
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5e90"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5e90"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = "function" === typeof Symbol && Symbol.for, $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$n ? Symbol.for("react.element") : 60103, $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$n ? Symbol.for("react.portal") : 60106, $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$n ? Symbol.for("react.fragment") : 60107, $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$n ? Symbol.for("react.strict_mode") : 60108, $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$n ? Symbol.for("react.profiler") : 60114, $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$n ? Symbol.for("react.provider") : 60109, $1c29a66706a62afd$var$w = $1c29a66706a62afd$var$n ? Symbol.for("react.context") : 60110, $1c29a66706a62afd$var$x = $1c29a66706a62afd$var$n ? Symbol.for("react.forward_ref") : 60112, $1c29a66706a62afd$var$y = $1c29a66706a62afd$var$n ? Symbol.for("react.suspense") : 60113, $1c29a66706a62afd$var$z = $1c29a66706a62afd$var$n ? Symbol.for("react.memo") : 60115, $1c29a66706a62afd$var$A = $1c29a66706a62afd$var$n ? Symbol.for("react.lazy") : 60116, $1c29a66706a62afd$var$B = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$E = {};
function $1c29a66706a62afd$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
$1c29a66706a62afd$var$F.prototype.isReactComponent = {};
$1c29a66706a62afd$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$G() {}
$1c29a66706a62afd$var$G.prototype = $1c29a66706a62afd$var$F.prototype;
function $1c29a66706a62afd$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
var $1c29a66706a62afd$var$I = $1c29a66706a62afd$var$H.prototype = new $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$I.constructor = $1c29a66706a62afd$var$H;
$8coUR($1c29a66706a62afd$var$I, $1c29a66706a62afd$var$F.prototype);
$1c29a66706a62afd$var$I.isPureReactComponent = !0;
var $1c29a66706a62afd$var$J = {
    current: null
}, $1c29a66706a62afd$var$K = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$1c29a66706a62afd$var$K.call(b, e) && !$1c29a66706a62afd$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $1c29a66706a62afd$var$J.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$p;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g, $1c29a66706a62afd$var$Q = [];
function $1c29a66706a62afd$var$R(a, b, c, e) {
    if ($1c29a66706a62afd$var$Q.length) {
        var d = $1c29a66706a62afd$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $1c29a66706a62afd$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $1c29a66706a62afd$var$Q.length && $1c29a66706a62afd$var$Q.push(a);
}
function $1c29a66706a62afd$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$p:
                case $1c29a66706a62afd$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $1c29a66706a62afd$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $1c29a66706a62afd$var$U(d, k);
        g += $1c29a66706a62afd$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $1c29a66706a62afd$var$B && a[$1c29a66706a62afd$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $1c29a66706a62afd$var$U(d, k++), g += $1c29a66706a62afd$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($1c29a66706a62afd$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $1c29a66706a62afd$var$V(a, b, c) {
    return null == a ? 0 : $1c29a66706a62afd$var$T(a, "", b, c);
}
function $1c29a66706a62afd$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape(a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $1c29a66706a62afd$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $1c29a66706a62afd$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($1c29a66706a62afd$var$O(a) && (a = $1c29a66706a62afd$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + c)), e.push(a));
}
function $1c29a66706a62afd$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($1c29a66706a62afd$var$P, "$&/") + "/");
    b = $1c29a66706a62afd$var$R(b, g, e, d);
    $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$aa, b);
    $1c29a66706a62afd$var$S(b);
}
var $1c29a66706a62afd$var$Y = {
    current: null
};
function $1c29a66706a62afd$var$Z() {
    var a = $1c29a66706a62afd$var$Y.current;
    if (null === a) throw Error($1c29a66706a62afd$var$C(321));
    return a;
}
var $1c29a66706a62afd$var$ba = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $1c29a66706a62afd$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $1c29a66706a62afd$var$R(null, null, b, c);
        $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$W, b);
        $1c29a66706a62afd$var$S(b);
    },
    count: function(a) {
        return $1c29a66706a62afd$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $1c29a66706a62afd$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error($1c29a66706a62afd$var$C(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$F;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$u;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$H;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$t;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$y;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$ba;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$C(267, a));
    var e = $8coUR({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $1c29a66706a62afd$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$1c29a66706a62afd$var$K.call(b, h) && !$1c29a66706a62afd$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$Z().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$Z().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$Z().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $fO90s.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$8coUR(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $8coUR(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $8coUR({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $8coUR({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $fO90s.unstable_runWithPriority, Jf = $fO90s.unstable_scheduleCallback, Kf = $fO90s.unstable_cancelCallback, Lf = $fO90s.unstable_requestPaint, Mf = $fO90s.unstable_now, Nf = $fO90s.unstable_getCurrentPriorityLevel, Of = $fO90s.unstable_ImmediatePriority, Pf = $fO90s.unstable_UserBlockingPriority, Qf = $fO90s.unstable_NormalPriority, Rf = $fO90s.unstable_LowPriority, Sf = $fO90s.unstable_IdlePriority, Tf = {}, Uf = $fO90s.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $8coUR({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $acw62.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $8coUR({}, f, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $8coUR({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($8coUR({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k, $bcb017604639e9d7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$p = null, $bcb017604639e9d7$var$q = null, $bcb017604639e9d7$var$t = function() {
        if (null !== $bcb017604639e9d7$var$p) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$p(!0, a);
            $bcb017604639e9d7$var$p = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$t, 0), b;
        }
    }, $bcb017604639e9d7$var$u = Date.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return Date.now() - $bcb017604639e9d7$var$u;
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$p ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$p = a, setTimeout($bcb017604639e9d7$var$t, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$q = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$q);
    };
    $bcb017604639e9d7$var$k = function() {
        return !1;
    };
    $bcb017604639e9d7$var$l = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$w = window.performance, $bcb017604639e9d7$var$x = window.Date, $bcb017604639e9d7$var$y = window.setTimeout, $bcb017604639e9d7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcb017604639e9d7$var$w && "function" === typeof $bcb017604639e9d7$var$w.now) $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$w.now();
    };
    else {
        var $bcb017604639e9d7$var$B = $bcb017604639e9d7$var$x.now();
        $bcb017604639e9d7$export$c4744153514ff05d = function() {
            return $bcb017604639e9d7$var$x.now() - $bcb017604639e9d7$var$B;
        };
    }
    var $bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null, $bcb017604639e9d7$var$E = -1, $bcb017604639e9d7$var$F = 5, $bcb017604639e9d7$var$G = 0;
    $bcb017604639e9d7$var$k = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$G;
    };
    $bcb017604639e9d7$var$l = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcb017604639e9d7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$H = new MessageChannel, $bcb017604639e9d7$var$I = $bcb017604639e9d7$var$H.port2;
    $bcb017604639e9d7$var$H.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$D) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$G = a + $bcb017604639e9d7$var$F;
            try {
                $bcb017604639e9d7$var$D(!0, a) ? $bcb017604639e9d7$var$I.postMessage(null) : ($bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$I.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$C = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$D = a;
        $bcb017604639e9d7$var$C || ($bcb017604639e9d7$var$C = !0, $bcb017604639e9d7$var$I.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$E = $bcb017604639e9d7$var$y(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$z($bcb017604639e9d7$var$E);
        $bcb017604639e9d7$var$E = -1;
    };
}
function $bcb017604639e9d7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$K(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$N = [], $bcb017604639e9d7$var$O = [], $bcb017604639e9d7$var$P = 1, $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = 3, $bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$T = !1, $bcb017604639e9d7$var$U = !1;
function $bcb017604639e9d7$var$V(a) {
    for(var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O);
        else if (b.startTime <= a) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, b);
        else break;
        b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
    }
}
function $bcb017604639e9d7$var$W(a) {
    $bcb017604639e9d7$var$U = !1;
    $bcb017604639e9d7$var$V(a);
    if (!$bcb017604639e9d7$var$T) {
        if (null !== $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N)) $bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X);
        else {
            var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$X(a, b) {
    $bcb017604639e9d7$var$T = !1;
    $bcb017604639e9d7$var$U && ($bcb017604639e9d7$var$U = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$S = !0;
    var c = $bcb017604639e9d7$var$R;
    try {
        $bcb017604639e9d7$var$V(b);
        for($bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N); null !== $bcb017604639e9d7$var$Q && (!($bcb017604639e9d7$var$Q.expirationTime > b) || a && !$bcb017604639e9d7$var$k());){
            var d = $bcb017604639e9d7$var$Q.callback;
            if (null !== d) {
                $bcb017604639e9d7$var$Q.callback = null;
                $bcb017604639e9d7$var$R = $bcb017604639e9d7$var$Q.priorityLevel;
                var e = d($bcb017604639e9d7$var$Q.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$Q.callback = e : $bcb017604639e9d7$var$Q === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
                $bcb017604639e9d7$var$V(b);
            } else $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
            $bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
        }
        if (null !== $bcb017604639e9d7$var$Q) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = c, $bcb017604639e9d7$var$S = !1;
    }
}
function $bcb017604639e9d7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcb017604639e9d7$var$Z = $bcb017604639e9d7$var$l;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$R;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$R;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$Z;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcb017604639e9d7$var$Y(a);
    } else c = $bcb017604639e9d7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcb017604639e9d7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$O, a), null === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && a === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O) && ($bcb017604639e9d7$var$U ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$U = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, e - d))) : (a.sortIndex = c, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, a), $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = function() {
    var a = $bcb017604639e9d7$export$c4744153514ff05d();
    $bcb017604639e9d7$var$V(a);
    var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
    return b !== $bcb017604639e9d7$var$Q && null !== $bcb017604639e9d7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcb017604639e9d7$var$Q.expirationTime || $bcb017604639e9d7$var$k();
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$R;
    return function() {
        var c = $bcb017604639e9d7$var$R;
        $bcb017604639e9d7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$R = c;
        }
    };
};

});




parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("lmFrL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isStyledComponent", () => $f8dbcd8598db1f0b$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "version", () => $f8dbcd8598db1f0b$export$83d89fbfd8236492);
$parcel$export(module.exports, "StyleSheetContext", () => $f8dbcd8598db1f0b$export$8c190ef828af4c86);
$parcel$export(module.exports, "StyleSheetConsumer", () => $f8dbcd8598db1f0b$export$91317688fc694efa);
$parcel$export(module.exports, "StyleSheetManager", () => $f8dbcd8598db1f0b$export$a473771da2f0ff7c);
$parcel$export(module.exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export(module.exports, "ThemeContext", () => $f8dbcd8598db1f0b$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeConsumer", () => $f8dbcd8598db1f0b$export$b631efc24e9d5e2f);
$parcel$export(module.exports, "ThemeProvider", () => $f8dbcd8598db1f0b$export$d8964aec282183a3);
$parcel$export(module.exports, "createGlobalStyle", () => $f8dbcd8598db1f0b$export$f0f03736edb61697);
$parcel$export(module.exports, "keyframes", () => $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ServerStyleSheet", () => $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "withTheme", () => $f8dbcd8598db1f0b$export$e8748c6a27b910dc);
$parcel$export(module.exports, "useTheme", () => $f8dbcd8598db1f0b$export$93d4e7f90805808f);
$parcel$export(module.exports, "__PRIVATE__", () => $f8dbcd8598db1f0b$export$5c87cfe6c475f500);
$parcel$export(module.exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");

var $acw62 = parcelRequire("acw62");

var $i5C3F = parcelRequire("i5C3F");

var $demXJ = parcelRequire("demXJ");

var $iDSBG = parcelRequire("iDSBG");

var $7dGEo = parcelRequire("7dGEo");

var $9ORqK = parcelRequire("9ORqK");
function $f8dbcd8598db1f0b$var$v() {
    return ($f8dbcd8598db1f0b$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4jPKB.typeOf)(t);
}, $f8dbcd8598db1f0b$var$w = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$b(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$_(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$A = "data-styled", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.1", $f8dbcd8598db1f0b$var$I = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $f8dbcd8598db1f0b$var$O = {}, $f8dbcd8598db1f0b$var$R = {};
function $f8dbcd8598db1f0b$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$k = new Map, $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$V = 1, $f8dbcd8598db1f0b$var$B = function(e) {
    if ($f8dbcd8598db1f0b$var$k.has(e)) return $f8dbcd8598db1f0b$var$k.get(e);
    for(; $f8dbcd8598db1f0b$var$x.has($f8dbcd8598db1f0b$var$V);)$f8dbcd8598db1f0b$var$V++;
    var t = $f8dbcd8598db1f0b$var$V++;
    return $f8dbcd8598db1f0b$var$k.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e), t;
}, $f8dbcd8598db1f0b$var$M = function(e) {
    return $f8dbcd8598db1f0b$var$x.get(e);
}, $f8dbcd8598db1f0b$var$z = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$V && ($f8dbcd8598db1f0b$var$V = t + 1), $f8dbcd8598db1f0b$var$k.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e);
}, $f8dbcd8598db1f0b$var$L = "style[" + $f8dbcd8598db1f0b$var$A + '][data-styled-version="5.3.1"]', $f8dbcd8598db1f0b$var$G = new RegExp("^" + $f8dbcd8598db1f0b$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$Y = function(e, t) {
    for(var n = (t.innerHTML || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$z(u, c), $f8dbcd8598db1f0b$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$A, "active"), r.setAttribute("data-styled-version", "5.3.1");
    var i = $f8dbcd8598db1f0b$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$J = $f8dbcd8598db1f0b$var$I, $f8dbcd8598db1f0b$var$X = {
    isServer: !$f8dbcd8598db1f0b$var$I,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$P
}, $f8dbcd8598db1f0b$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$v({}, $f8dbcd8598db1f0b$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$I && $f8dbcd8598db1f0b$var$J && ($f8dbcd8598db1f0b$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$L), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$A) && ($f8dbcd8598db1f0b$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$U(o) : r ? new $f8dbcd8598db1f0b$var$$(o) : new $f8dbcd8598db1f0b$var$W(o), new $f8dbcd8598db1f0b$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$M(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$K = /(a)(d)/gi, $f8dbcd8598db1f0b$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$Q(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$Q(t % 52) + n).replace($f8dbcd8598db1f0b$var$K, "$1-$2");
}
var $f8dbcd8598db1f0b$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$ne = function(e) {
    return $f8dbcd8598db1f0b$var$te(5381, e);
};
function $f8dbcd8598db1f0b$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$b(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$oe = $f8dbcd8598db1f0b$var$ne("5.3.1"), $f8dbcd8598db1f0b$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$re(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$oe, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$Ne(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$ie = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$E : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$w : c, l = new (0, $demXJ.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$j(15), $f8dbcd8598db1f0b$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$he = ($f8dbcd8598db1f0b$var$de.Consumer, new $f8dbcd8598db1f0b$var$Z), $f8dbcd8598db1f0b$var$pe = $f8dbcd8598db1f0b$var$ce();
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$var$me() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$de) || $f8dbcd8598db1f0b$var$pe;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$fe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$pe), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ge = /([A-Z])/, $f8dbcd8598db1f0b$var$Se = /([A-Z])/g, $f8dbcd8598db1f0b$var$we = /^ms-/, $f8dbcd8598db1f0b$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$be(e) {
    return $f8dbcd8598db1f0b$var$ge.test(e) ? e.replace($f8dbcd8598db1f0b$var$Se, $f8dbcd8598db1f0b$var$Ee).replace($f8dbcd8598db1f0b$var$we, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$_e(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$b(t[i]) ? s.push($f8dbcd8598db1f0b$var$be(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $iDSBG.default) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$b(e) || $f8dbcd8598db1f0b$var$S(e) ? $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g($f8dbcd8598db1f0b$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g(e, n)));
}
var $f8dbcd8598db1f0b$var$Ie = /invalid hook call/i, $f8dbcd8598db1f0b$var$Pe = new Set, $f8dbcd8598db1f0b$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Re = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$je = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$Te(e) {
    return e.replace($f8dbcd8598db1f0b$var$De, "-").replace($f8dbcd8598db1f0b$var$je, "");
}
var $f8dbcd8598db1f0b$var$ke = function(e) {
    return $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$ne(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$xe(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$Me(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$Ve(t) && $f8dbcd8598db1f0b$var$Ve(r) ? $f8dbcd8598db1f0b$var$ze(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$Ve(i)) for(var a in i)$f8dbcd8598db1f0b$var$Be(a) && $f8dbcd8598db1f0b$var$Me(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$j(14);
            if ($f8dbcd8598db1f0b$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$j(8) : t ? $f8dbcd8598db1f0b$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ye = {};
function $f8dbcd8598db1f0b$var$qe(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$xe(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$Te(e);
        $f8dbcd8598db1f0b$var$Ye[n] = ($f8dbcd8598db1f0b$var$Ye[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$ke("5.3.1" + n + $f8dbcd8598db1f0b$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $f8dbcd8598db1f0b$var$xe(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $f8dbcd8598db1f0b$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$E);
                var r = $f8dbcd8598db1f0b$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Re(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$fe(), s = $f8dbcd8598db1f0b$var$me(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $f8dbcd8598db1f0b$var$xe(_), A = g !== t ? $f8dbcd8598db1f0b$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $7dGEo.default), _) : !N || (0, $7dGEo.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $f8dbcd8598db1f0b$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $acw62.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$xe(e) ? e : $f8dbcd8598db1f0b$var$Te($f8dbcd8598db1f0b$var$_(e)));
        return $f8dbcd8598db1f0b$var$qe(e, $f8dbcd8598db1f0b$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$ze({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !(0, $4jPKB.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$j(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$He[e] = $f8dbcd8598db1f0b$var$He(e);
});
var $f8dbcd8598db1f0b$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$re(e), $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$ke(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$$e(i, a);
    function l(e) {
        var t = $f8dbcd8598db1f0b$var$fe(), n = $f8dbcd8598db1f0b$var$me(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), l = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$O, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$v({}, t, {
                theme: $f8dbcd8598db1f0b$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$ke(o);
    return new $f8dbcd8598db1f0b$var$ve(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$A + '="true"',
                'data-styled-version="5.3.1"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$j(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$A] = "", t["data-styled-version"] = "5.3.1", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$j(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$_(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Z,
    masterSheet: $f8dbcd8598db1f0b$var$he
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$He;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});


parcelRegister("i5C3F", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("demXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e650477d9d52e$export$2e2bcd8739ae039);
function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;

});

parcelRegister("iDSBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9263a4c6739b952$export$2e2bcd8739ae039);
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;

});

parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});


parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});


parcelRegister("9Y1h9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $741ab4f0e0afe920$var$inspect;

var $741ab4f0e0afe920$var$_nodejsCustomInspectSymbol = $741ab4f0e0afe920$var$_interopRequireDefault((parcelRequire("1ci0q")));
function $741ab4f0e0afe920$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $741ab4f0e0afe920$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $741ab4f0e0afe920$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $741ab4f0e0afe920$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $741ab4f0e0afe920$var$_typeof(obj);
}
var $741ab4f0e0afe920$var$MAX_ARRAY_LENGTH = 10;
var $741ab4f0e0afe920$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $741ab4f0e0afe920$var$inspect(value) {
    return $741ab4f0e0afe920$var$formatValue(value, []);
}
function $741ab4f0e0afe920$var$formatValue(value, seenValues) {
    switch($741ab4f0e0afe920$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $741ab4f0e0afe920$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $741ab4f0e0afe920$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $741ab4f0e0afe920$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $741ab4f0e0afe920$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $741ab4f0e0afe920$var$formatArray(value, seenValues);
    return $741ab4f0e0afe920$var$formatObject(value, seenValues);
}
function $741ab4f0e0afe920$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $741ab4f0e0afe920$var$MAX_RECURSIVE_DEPTH) return '[' + $741ab4f0e0afe920$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $741ab4f0e0afe920$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $741ab4f0e0afe920$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $741ab4f0e0afe920$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($741ab4f0e0afe920$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($741ab4f0e0afe920$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $741ab4f0e0afe920$var$getCustomFn(object) {
    var customInspectFn = object[String($741ab4f0e0afe920$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $741ab4f0e0afe920$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("1ci0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $0df4e1001807e952$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $0df4e1001807e952$var$_default = $0df4e1001807e952$var$nodejsCustomInspectSymbol;
module.exports.default = $0df4e1001807e952$var$_default;

});


parcelRegister("4YcFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39e696f79ffb1272$var$defineInspect;

var $39e696f79ffb1272$var$_invariant = $39e696f79ffb1272$var$_interopRequireDefault((parcelRequire("c258Y")));

var $39e696f79ffb1272$var$_nodejsCustomInspectSymbol = $39e696f79ffb1272$var$_interopRequireDefault((parcelRequire("1ci0q")));
function $39e696f79ffb1272$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $39e696f79ffb1272$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $39e696f79ffb1272$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($39e696f79ffb1272$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$39e696f79ffb1272$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("c258Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c29a961bdcd5365$var$invariant;
function $8c29a961bdcd5365$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});


parcelRegister("kwUjq", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("3gKaa")).default);

var $3gKaa = parcelRequire("3gKaa");

var $8JRy9 = parcelRequire("8JRy9");

var $7WQrb = parcelRequire("7WQrb");

var $4i0Ci = parcelRequire("4i0Ci");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8JRy9.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $7WQrb.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $3gKaa.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $3gKaa.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $4i0Ci.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $7WQrb.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $7WQrb.__assign)({}, context, next(context));
        else context = (0, $7WQrb.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $7WQrb.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $3gKaa.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $3gKaa.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $3gKaa.default).of() : rightLink.request(operation) || (0, $3gKaa.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $3gKaa.default).of() : rightLink.request(operation, forward) || (0, $3gKaa.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $3gKaa.default).of();
        }) || (0, $3gKaa.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $3gKaa.default).of();
        }) || (0, $3gKaa.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8JRy9.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $3gKaa.default).of();
}

});
parcelRegister("3gKaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2616acb700713866$export$2e2bcd8739ae039);

var $Fm3BX = parcelRequire("Fm3BX");
var $2616acb700713866$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($Fm3BX)));
var $2616acb700713866$export$2e2bcd8739ae039 = $2616acb700713866$export$77cea355fa80b5f4;

});
parcelRegister("Fm3BX", function(module, exports) {

module.exports = (parcelRequire("jmIat")).Observable;

});
parcelRegister("jmIat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e192553538094b4b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e192553538094b4b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e192553538094b4b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e192553538094b4b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e192553538094b4b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e192553538094b4b$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e192553538094b4b$var$hasSymbol = function(name) {
    return $e192553538094b4b$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e192553538094b4b$var$getSymbol = function(name) {
    return $e192553538094b4b$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e192553538094b4b$var$hasSymbols() && !$e192553538094b4b$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e192553538094b4b$var$SymbolIterator = $e192553538094b4b$var$getSymbol('iterator');
var $e192553538094b4b$var$SymbolObservable = $e192553538094b4b$var$getSymbol('observable');
var $e192553538094b4b$var$SymbolSpecies = $e192553538094b4b$var$getSymbol('species'); // === Abstract Operations ===
function $e192553538094b4b$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e192553538094b4b$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e192553538094b4b$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e192553538094b4b$var$Observable;
}
function $e192553538094b4b$var$isObservable(x) {
    return x instanceof $e192553538094b4b$var$Observable; // SPEC: Brand check
}
function $e192553538094b4b$var$hostReportError(e) {
    if ($e192553538094b4b$var$hostReportError.log) $e192553538094b4b$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e192553538094b4b$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e192553538094b4b$var$hostReportError(e);
        }
    });
}
function $e192553538094b4b$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e192553538094b4b$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e192553538094b4b$var$hostReportError(e);
    }
}
function $e192553538094b4b$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e192553538094b4b$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e192553538094b4b$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e192553538094b4b$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e192553538094b4b$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e192553538094b4b$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e192553538094b4b$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e192553538094b4b$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e192553538094b4b$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e192553538094b4b$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e192553538094b4b$var$enqueue(function() {
            return $e192553538094b4b$var$flushSubscription(subscription);
        });
        return;
    }
    $e192553538094b4b$var$notifySubscription(subscription, type, value);
}
var $e192553538094b4b$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e192553538094b4b$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e192553538094b4b$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e192553538094b4b$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e192553538094b4b$var$closeSubscription(this);
                    $e192553538094b4b$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e192553538094b4b$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e192553538094b4b$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e192553538094b4b$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e192553538094b4b$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e192553538094b4b$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e192553538094b4b$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e192553538094b4b$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e192553538094b4b$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e192553538094b4b$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e192553538094b4b$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e192553538094b4b$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e192553538094b4b$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e192553538094b4b$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e192553538094b4b$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e192553538094b4b$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e192553538094b4b$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e192553538094b4b$var$getMethod(x, $e192553538094b4b$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e192553538094b4b$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e192553538094b4b$var$hasSymbol('iterator')) {
                    method = $e192553538094b4b$var$getMethod(x, $e192553538094b4b$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e192553538094b4b$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e192553538094b4b$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e192553538094b4b$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e192553538094b4b$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e192553538094b4b$var$Observable;
if ($e192553538094b4b$var$hasSymbols()) Object.defineProperty($e192553538094b4b$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e192553538094b4b$var$SymbolObservable,
        hostReportError: $e192553538094b4b$var$hostReportError
    },
    configurable: true
});

});



parcelRegister("8JRy9", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $65cc10942cb5e2db$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $65cc10942cb5e2db$export$f5708dca728d7177);

var $7WQrb = parcelRequire("7WQrb");
var $65cc10942cb5e2db$var$genericMessage = "Invariant Violation";
var $65cc10942cb5e2db$var$_a = Object.setPrototypeOf, $65cc10942cb5e2db$var$setPrototypeOf = $65cc10942cb5e2db$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $65cc10942cb5e2db$var$_a;
var $65cc10942cb5e2db$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $65cc10942cb5e2db$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $65cc10942cb5e2db$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $65cc10942cb5e2db$var$genericMessage;
        $65cc10942cb5e2db$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $65cc10942cb5e2db$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $65cc10942cb5e2db$export$cea12affaee22fe8(message);
}
function $65cc10942cb5e2db$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $65cc10942cb5e2db$var$wrapConsoleMethod("warn");
    invariant.error = $65cc10942cb5e2db$var$wrapConsoleMethod("error");
})($65cc10942cb5e2db$export$f5708dca728d7177 || ($65cc10942cb5e2db$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $65cc10942cb5e2db$export$e54fe5b0f43758f7 = {
    env: {}
};
try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($65cc10942cb5e2db$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $65cc10942cb5e2db$var$invariant$1 = $65cc10942cb5e2db$export$f5708dca728d7177;
var $65cc10942cb5e2db$export$2e2bcd8739ae039 = $65cc10942cb5e2db$var$invariant$1;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $5c96a02c592fcff1$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("4i0Ci", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $31f95252ecb9b266$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $31f95252ecb9b266$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $31f95252ecb9b266$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $31f95252ecb9b266$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $31f95252ecb9b266$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $31f95252ecb9b266$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $31f95252ecb9b266$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $31f95252ecb9b266$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $31f95252ecb9b266$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $31f95252ecb9b266$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $31f95252ecb9b266$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $31f95252ecb9b266$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $31f95252ecb9b266$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $31f95252ecb9b266$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $31f95252ecb9b266$export$e6e34fd1f2686227);
$parcel$export(module.exports, "getOperationDefinition", () => $31f95252ecb9b266$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $31f95252ecb9b266$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $31f95252ecb9b266$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $31f95252ecb9b266$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $31f95252ecb9b266$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $31f95252ecb9b266$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $31f95252ecb9b266$export$84c19026e616569e);
$parcel$export(module.exports, "addTypenameToDocument", () => $31f95252ecb9b266$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $31f95252ecb9b266$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $31f95252ecb9b266$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $31f95252ecb9b266$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $31f95252ecb9b266$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $31f95252ecb9b266$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $31f95252ecb9b266$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $31f95252ecb9b266$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $31f95252ecb9b266$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $31f95252ecb9b266$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $31f95252ecb9b266$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $31f95252ecb9b266$export$160070228be94b08);

var $4XkMM = parcelRequire("4XkMM");

var $8JRy9 = parcelRequire("8JRy9");

var $7WQrb = parcelRequire("7WQrb");

var $1FoUm = parcelRequire("1FoUm");

var $f8ISh = parcelRequire("f8ISh");
function $31f95252ecb9b266$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $31f95252ecb9b266$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $31f95252ecb9b266$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $31f95252ecb9b266$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $31f95252ecb9b266$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $31f95252ecb9b266$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $31f95252ecb9b266$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $31f95252ecb9b266$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $31f95252ecb9b266$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $31f95252ecb9b266$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $31f95252ecb9b266$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $31f95252ecb9b266$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($31f95252ecb9b266$var$isIntValue(value) || $31f95252ecb9b266$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($31f95252ecb9b266$var$isBooleanValue(value) || $31f95252ecb9b266$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($31f95252ecb9b266$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $31f95252ecb9b266$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($31f95252ecb9b266$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($31f95252ecb9b266$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $31f95252ecb9b266$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($31f95252ecb9b266$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($31f95252ecb9b266$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8JRy9.InvariantError)(17);
}
function $31f95252ecb9b266$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $31f95252ecb9b266$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $31f95252ecb9b266$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $31f95252ecb9b266$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $31f95252ecb9b266$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $31f95252ecb9b266$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($1FoUm)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($31f95252ecb9b266$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $31f95252ecb9b266$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $31f95252ecb9b266$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $31f95252ecb9b266$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $31f95252ecb9b266$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $31f95252ecb9b266$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $31f95252ecb9b266$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $31f95252ecb9b266$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $7WQrb.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $31f95252ecb9b266$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $31f95252ecb9b266$var$defaultValueFromVariable(node) {
    throw new (0, $8JRy9.InvariantError)(18);
}
function $31f95252ecb9b266$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $31f95252ecb9b266$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $31f95252ecb9b266$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $31f95252ecb9b266$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $31f95252ecb9b266$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $31f95252ecb9b266$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $31f95252ecb9b266$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $31f95252ecb9b266$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8JRy9.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $31f95252ecb9b266$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $4XkMM.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $31f95252ecb9b266$export$2dafb573e282fe8d(names, doc) {
    return $31f95252ecb9b266$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $31f95252ecb9b266$export$8d1e9e5bbfa5d09a(document) {
    return document && $31f95252ecb9b266$export$2dafb573e282fe8d([
        'client'
    ], document) && $31f95252ecb9b266$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $31f95252ecb9b266$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $31f95252ecb9b266$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($31f95252ecb9b266$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8JRy9.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8JRy9.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8JRy9.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $31f95252ecb9b266$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8JRy9.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8JRy9.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, document), {
        definitions: (0, $7WQrb.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $31f95252ecb9b266$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $31f95252ecb9b266$export$a92e7a440b22bdf0(doc) {
    $31f95252ecb9b266$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8JRy9.invariant)(mutationDef, 1);
    return mutationDef;
}
function $31f95252ecb9b266$export$a7d0d8111d2386df(doc) {
    (0, $8JRy9.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8JRy9.InvariantError)(3);
        return definition;
    });
    (0, $8JRy9.invariant)(operations.length <= 1, 4);
    return doc;
}
function $31f95252ecb9b266$export$7a5b1fa979d2c158(doc) {
    $31f95252ecb9b266$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $31f95252ecb9b266$export$78a8e95d8d43ad7f(document) {
    var def = $31f95252ecb9b266$export$7a5b1fa979d2c158(document);
    (0, $8JRy9.invariant)(def, 5);
    return def;
}
function $31f95252ecb9b266$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $31f95252ecb9b266$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $31f95252ecb9b266$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $31f95252ecb9b266$export$7a5b1fa979d2c158(doc);
    (0, $8JRy9.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $31f95252ecb9b266$export$772111caef41b3f5(doc) {
    (0, $8JRy9.invariant)(doc.kind === 'Document', 7);
    (0, $8JRy9.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8JRy9.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $31f95252ecb9b266$export$f431198736b7f96d(queryDoc) {
    $31f95252ecb9b266$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8JRy9.InvariantError)(10);
}
function $31f95252ecb9b266$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $31f95252ecb9b266$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $31f95252ecb9b266$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $31f95252ecb9b266$export$e6e34fd1f2686227.apply(void 0, (0, $7WQrb.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $31f95252ecb9b266$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $31f95252ecb9b266$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $31f95252ecb9b266$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $31f95252ecb9b266$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $31f95252ecb9b266$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $31f95252ecb9b266$var$nullIfDocIsEmpty(doc) {
    return $31f95252ecb9b266$var$isEmpty($31f95252ecb9b266$export$7a5b1fa979d2c158(doc) || $31f95252ecb9b266$export$772111caef41b3f5(doc), $31f95252ecb9b266$export$193789b4c8246dd4($31f95252ecb9b266$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $31f95252ecb9b266$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $31f95252ecb9b266$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $31f95252ecb9b266$var$nullIfDocIsEmpty((0, $4XkMM.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($31f95252ecb9b266$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $31f95252ecb9b266$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($31f95252ecb9b266$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $31f95252ecb9b266$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $31f95252ecb9b266$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $31f95252ecb9b266$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $31f95252ecb9b266$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $31f95252ecb9b266$export$43b332f87950a467(doc) {
    return (0, $4XkMM.visit)($31f95252ecb9b266$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $31f95252ecb9b266$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($31f95252ecb9b266$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, node), {
                    selections: (0, $7WQrb.__spreadArrays)(selections, [
                        $31f95252ecb9b266$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $31f95252ecb9b266$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $31f95252ecb9b266$export$74985f3324559867(doc) {
    return $31f95252ecb9b266$export$e5ae0530da5fe96c([
        $31f95252ecb9b266$var$connectionRemoveConfig
    ], $31f95252ecb9b266$export$a7d0d8111d2386df(doc));
}
function $31f95252ecb9b266$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $31f95252ecb9b266$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $31f95252ecb9b266$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$31f95252ecb9b266$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($31f95252ecb9b266$var$getDirectiveMatcher(directives)) || nestedCheck && $31f95252ecb9b266$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $31f95252ecb9b266$export$deed3420cb5d2e1d(directives, doc) {
    $31f95252ecb9b266$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $31f95252ecb9b266$var$nullIfDocIsEmpty((0, $4XkMM.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $31f95252ecb9b266$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($31f95252ecb9b266$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $31f95252ecb9b266$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $31f95252ecb9b266$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $31f95252ecb9b266$var$getArgumentMatcher(config);
    return $31f95252ecb9b266$var$nullIfDocIsEmpty((0, $4XkMM.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $31f95252ecb9b266$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $31f95252ecb9b266$var$nullIfDocIsEmpty((0, $4XkMM.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $31f95252ecb9b266$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($31f95252ecb9b266$export$fb56ad75dd311c12(selection) || $31f95252ecb9b266$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $31f95252ecb9b266$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $31f95252ecb9b266$export$57c368c23873f32b(document) {
    var definition = $31f95252ecb9b266$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $4XkMM.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $31f95252ecb9b266$export$8eae69e876ee321e(document) {
    $31f95252ecb9b266$export$a7d0d8111d2386df(document);
    var modifiedDoc = $31f95252ecb9b266$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $4XkMM.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $31f95252ecb9b266$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $31f95252ecb9b266$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $31f95252ecb9b266$var$toString = Object.prototype.toString;
function $31f95252ecb9b266$export$629a2bd3f5a49ecc(value) {
    return $31f95252ecb9b266$var$cloneDeepHelper(value, new Map());
}
function $31f95252ecb9b266$var$cloneDeepHelper(val, seen) {
    switch($31f95252ecb9b266$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $31f95252ecb9b266$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $31f95252ecb9b266$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $31f95252ecb9b266$export$4bd44a2aa29d3d6e() {
    return 'development';
}
function $31f95252ecb9b266$export$f0cb0fda19c18b37(env) {
    return $31f95252ecb9b266$export$4bd44a2aa29d3d6e() === env;
}
function $31f95252ecb9b266$export$f15d00aa73aafac4() {
    return $31f95252ecb9b266$export$f0cb0fda19c18b37('production') === true;
}
function $31f95252ecb9b266$export$df77466336fe5355() {
    return $31f95252ecb9b266$export$f0cb0fda19c18b37('development') === true;
}
function $31f95252ecb9b266$export$410cbc2864fa25b5() {
    return $31f95252ecb9b266$export$f0cb0fda19c18b37('test') === true;
}
function $31f95252ecb9b266$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $31f95252ecb9b266$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $31f95252ecb9b266$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $31f95252ecb9b266$var$deepFreeze(o[prop]);
    });
    return o;
}
function $31f95252ecb9b266$export$7f9c177735b71f18(obj) {
    if ($31f95252ecb9b266$export$df77466336fe5355() || $31f95252ecb9b266$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $31f95252ecb9b266$var$deepFreeze(obj);
    }
    return obj;
}
var $31f95252ecb9b266$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $31f95252ecb9b266$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $31f95252ecb9b266$export$160070228be94b08(sources);
}
function $31f95252ecb9b266$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $31f95252ecb9b266$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $31f95252ecb9b266$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $31f95252ecb9b266$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $31f95252ecb9b266$var$mergeHelper(target, source, pastCopies) {
    if ($31f95252ecb9b266$var$isObject(source) && $31f95252ecb9b266$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $31f95252ecb9b266$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($31f95252ecb9b266$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $31f95252ecb9b266$var$mergeHelper($31f95252ecb9b266$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $31f95252ecb9b266$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $7WQrb.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $31f95252ecb9b266$var$haveWarned = Object.create({});
function $31f95252ecb9b266$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$31f95252ecb9b266$export$f15d00aa73aafac4() && !$31f95252ecb9b266$var$haveWarned[msg]) {
        if (!$31f95252ecb9b266$export$410cbc2864fa25b5()) $31f95252ecb9b266$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $31f95252ecb9b266$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("4XkMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $39bccbb8c2e84889$var$visit;
module.exports.visitInParallel = $39bccbb8c2e84889$var$visitInParallel;
module.exports.getVisitFn = $39bccbb8c2e84889$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $39bccbb8c2e84889$var$_inspect = $39bccbb8c2e84889$var$_interopRequireDefault((parcelRequire("9Y1h9")));

var $1XBDM = parcelRequire("1XBDM");
function $39bccbb8c2e84889$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $39bccbb8c2e84889$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $39bccbb8c2e84889$var$QueryDocumentKeys;
var $39bccbb8c2e84889$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $39bccbb8c2e84889$var$BREAK;
function $39bccbb8c2e84889$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $39bccbb8c2e84889$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $1XBDM.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $39bccbb8c2e84889$var$_inspect.default)(node), "."));
            var visitFn = $39bccbb8c2e84889$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $39bccbb8c2e84889$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $1XBDM.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $39bccbb8c2e84889$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $39bccbb8c2e84889$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $39bccbb8c2e84889$var$BREAK) skipping[i] = $39bccbb8c2e84889$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $39bccbb8c2e84889$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $39bccbb8c2e84889$var$BREAK) skipping[i] = $39bccbb8c2e84889$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $39bccbb8c2e84889$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("1XBDM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $16d87fca428ec50d$var$isNode;
module.exports.Token = module.exports.Location = void 0;

var $16d87fca428ec50d$var$_defineInspect = $16d87fca428ec50d$var$_interopRequireDefault((parcelRequire("4YcFh")));
function $16d87fca428ec50d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $16d87fca428ec50d$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Location = $16d87fca428ec50d$var$Location;
(0, $16d87fca428ec50d$var$_defineInspect.default)($16d87fca428ec50d$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $16d87fca428ec50d$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Token = $16d87fca428ec50d$var$Token;
(0, $16d87fca428ec50d$var$_defineInspect.default)($16d87fca428ec50d$var$Token);
/**
 * @internal
 */ function $16d87fca428ec50d$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});


parcelRegister("1FoUm", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("f8ISh", function(module, exports) {

$parcel$export(module.exports, "equal", () => $b05a6988bb07520f$export$411ce8e5a71e3069);
var $b05a6988bb07520f$var$_a = Object.prototype, $b05a6988bb07520f$var$toString = $b05a6988bb07520f$var$_a.toString, $b05a6988bb07520f$var$hasOwnProperty = $b05a6988bb07520f$var$_a.hasOwnProperty;
var $b05a6988bb07520f$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $b05a6988bb07520f$export$411ce8e5a71e3069(a, b) {
    try {
        return $b05a6988bb07520f$var$check(a, b);
    } finally{
        $b05a6988bb07520f$var$previousComparisons.clear();
    }
}
function $b05a6988bb07520f$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $b05a6988bb07520f$var$toString.call(a);
    var bTag = $b05a6988bb07520f$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($b05a6988bb07520f$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$b05a6988bb07520f$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$b05a6988bb07520f$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($b05a6988bb07520f$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$b05a6988bb07520f$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $b05a6988bb07520f$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $b05a6988bb07520f$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $b05a6988bb07520f$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $b05a6988bb07520f$export$2e2bcd8739ae039 = $b05a6988bb07520f$export$411ce8e5a71e3069;

});



parcelRegister("6Z7su", function(module, exports) {

$parcel$export(module.exports, "default", () => $515e39ad6749f3aa$export$2e2bcd8739ae039);
/* global window */ 
var $1qzDT = parcelRequire("1qzDT");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $1qzDT.default)(root);
var $515e39ad6749f3aa$export$2e2bcd8739ae039 = result;

});
parcelRegister("1qzDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3ddfbb4e508ab$export$2e2bcd8739ae039);
function $10a3ddfbb4e508ab$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i;
        for(i = 0; i < arr.length; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentProperties.length > 0) for(i = 0; i < momentProperties.length; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key;
                for(i = 0; i < arguments.length; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i;
            for(i = 0; i < prioritized.length; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        for(i = 0; i < token.length; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDates.length; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimes.length; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false;
        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < config._f.length; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < ordering.length; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.29.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("1ApNP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "get", () => $127d2b1ff371d8b2$export$3988ae62b71be9a3);
$parcel$export(module.exports, "responsive", () => $127d2b1ff371d8b2$export$9dc15d61278b91b8);
$parcel$export(module.exports, "css", () => $127d2b1ff371d8b2$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $127d2b1ff371d8b2$export$2e2bcd8739ae039);
function $127d2b1ff371d8b2$var$_extends() {
    $127d2b1ff371d8b2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $127d2b1ff371d8b2$var$_extends.apply(this, arguments);
}
var $127d2b1ff371d8b2$export$3988ae62b71be9a3 = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [
        key
    ];
    for(p = 0; p < key.length; p++)obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
};
var $127d2b1ff371d8b2$var$defaultBreakpoints = [
    40,
    52,
    64
].map(function(n) {
    return n + 'em';
});
var $127d2b1ff371d8b2$var$defaultTheme = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ],
    fontSizes: [
        12,
        14,
        16,
        20,
        24,
        32,
        48,
        64,
        72
    ]
};
var $127d2b1ff371d8b2$var$aliases = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
};
var $127d2b1ff371d8b2$var$multiples = {
    marginX: [
        'marginLeft',
        'marginRight'
    ],
    marginY: [
        'marginTop',
        'marginBottom'
    ],
    paddingX: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingY: [
        'paddingTop',
        'paddingBottom'
    ],
    size: [
        'width',
        'height'
    ]
};
var $127d2b1ff371d8b2$var$scales = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
};
var $127d2b1ff371d8b2$var$positiveOrNegative = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) return $127d2b1ff371d8b2$export$3988ae62b71be9a3(scale, value, value);
    var absolute = Math.abs(value);
    var n = $127d2b1ff371d8b2$export$3988ae62b71be9a3(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return n * -1;
};
var $127d2b1ff371d8b2$var$transforms = [
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'top',
    'bottom',
    'left',
    'right'
].reduce(function(acc, curr) {
    var _extends2;
    return $127d2b1ff371d8b2$var$_extends({}, acc, (_extends2 = {}, _extends2[curr] = $127d2b1ff371d8b2$var$positiveOrNegative, _extends2));
}, {});
var $127d2b1ff371d8b2$export$9dc15d61278b91b8 = function responsive(styles) {
    return function(theme) {
        var next = {};
        var breakpoints = $127d2b1ff371d8b2$export$3988ae62b71be9a3(theme, 'breakpoints', $127d2b1ff371d8b2$var$defaultBreakpoints);
        var mediaQueries = [
            null
        ].concat(breakpoints.map(function(n) {
            return "@media screen and (min-width: " + n + ")";
        }));
        for(var key in styles){
            var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
            if (value == null) continue;
            if (!Array.isArray(value)) {
                next[key] = value;
                continue;
            }
            for(var i = 0; i < value.slice(0, mediaQueries.length).length; i++){
                var media = mediaQueries[i];
                if (!media) {
                    next[key] = value[i];
                    continue;
                }
                next[media] = next[media] || {};
                if (value[i] == null) continue;
                next[media][key] = value[i];
            }
        }
        return next;
    };
};
var $127d2b1ff371d8b2$export$dbf350e5966cf602 = function css(args) {
    return function(props) {
        if (props === void 0) props = {};
        var theme = $127d2b1ff371d8b2$var$_extends({}, $127d2b1ff371d8b2$var$defaultTheme, {}, props.theme || props);
        var result = {};
        var obj = typeof args === 'function' ? args(theme) : args;
        var styles = $127d2b1ff371d8b2$export$9dc15d61278b91b8(obj)(theme);
        for(var key in styles){
            var x = styles[key];
            var val = typeof x === 'function' ? x(theme) : x;
            if (key === 'variant') {
                var variant = css($127d2b1ff371d8b2$export$3988ae62b71be9a3(theme, val))(theme);
                result = $127d2b1ff371d8b2$var$_extends({}, result, {}, variant);
                continue;
            }
            if (val && typeof val === 'object') {
                result[key] = css(val)(theme);
                continue;
            }
            var prop = $127d2b1ff371d8b2$export$3988ae62b71be9a3($127d2b1ff371d8b2$var$aliases, key, key);
            var scaleName = $127d2b1ff371d8b2$export$3988ae62b71be9a3($127d2b1ff371d8b2$var$scales, prop);
            var scale = $127d2b1ff371d8b2$export$3988ae62b71be9a3(theme, scaleName, $127d2b1ff371d8b2$export$3988ae62b71be9a3(theme, prop, {}));
            var transform = $127d2b1ff371d8b2$export$3988ae62b71be9a3($127d2b1ff371d8b2$var$transforms, prop, $127d2b1ff371d8b2$export$3988ae62b71be9a3);
            var value = transform(scale, val, val);
            if ($127d2b1ff371d8b2$var$multiples[prop]) {
                var dirs = $127d2b1ff371d8b2$var$multiples[prop];
                for(var i = 0; i < dirs.length; i++)result[dirs[i]] = value;
            } else result[prop] = value;
        }
        return result;
    };
};
var $127d2b1ff371d8b2$export$2e2bcd8739ae039 = $127d2b1ff371d8b2$export$dbf350e5966cf602;

});

parcelRegister("h7un0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "props", () => $c76aa5f633915b02$export$8128bb6492cf3de7);
$parcel$export(module.exports, "createShouldForwardProp", () => $c76aa5f633915b02$export$ffd9f84df231f79d);
$parcel$export(module.exports, "default", () => $c76aa5f633915b02$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");

var $7dGEo = parcelRequire("7dGEo");
parcelRequire("8br48");
var $xIyuN = parcelRequire("xIyuN");
var $i2Hg7 = parcelRequire("i2Hg7");
var $8Sr9x = parcelRequire("8Sr9x");
var $3VFVC = parcelRequire("3VFVC");
var $665Bp = parcelRequire("665Bp");
var $fNZHs = parcelRequire("fNZHs");
var $fIrdk = parcelRequire("fIrdk");
var $hHVze = parcelRequire("hHVze");
var $hw25X = parcelRequire("hw25X");
var $hdn6g = parcelRequire("hdn6g");
var $cMmwD = parcelRequire("cMmwD");
var $lWdYs = parcelRequire("lWdYs");
var $c76aa5f633915b02$var$all = (0, $665Bp.compose)((0, $cMmwD.space), (0, $lWdYs.typography), (0, $3VFVC.color), (0, $hHVze.layout), (0, $fNZHs.flexbox), (0, $i2Hg7.border), (0, $xIyuN.background), (0, $hw25X.position), (0, $fIrdk.grid), (0, $hdn6g.shadow), (0, $8Sr9x.buttonStyle), (0, $8Sr9x.textStyle), (0, $8Sr9x.colorStyle));
var $c76aa5f633915b02$export$8128bb6492cf3de7 = $c76aa5f633915b02$var$all.propNames;
var $c76aa5f633915b02$export$ffd9f84df231f79d = function createShouldForwardProp(props) {
    var regex = new RegExp("^(" + props.join('|') + ")$");
    return (0, $l7O8P.default)(function(prop) {
        return (0, $7dGEo.default)(prop) && !regex.test(prop);
    });
};
var $c76aa5f633915b02$export$2e2bcd8739ae039 = $c76aa5f633915b02$export$ffd9f84df231f79d($c76aa5f633915b02$export$8128bb6492cf3de7);

});
parcelRegister("8br48", function(module, exports) {

$parcel$export(module.exports, "compose", () => (parcelRequire("665Bp")).compose);
$parcel$export(module.exports, "space", () => (parcelRequire("cMmwD")).space);
$parcel$export(module.exports, "color", () => (parcelRequire("3VFVC")).color);
$parcel$export(module.exports, "layout", () => (parcelRequire("hHVze")).layout);
$parcel$export(module.exports, "typography", () => (parcelRequire("lWdYs")).typography);
$parcel$export(module.exports, "flexbox", () => (parcelRequire("fNZHs")).flexbox);
$parcel$export(module.exports, "border", () => (parcelRequire("i2Hg7")).border);
$parcel$export(module.exports, "background", () => (parcelRequire("xIyuN")).background);
$parcel$export(module.exports, "position", () => (parcelRequire("hw25X")).position);
$parcel$export(module.exports, "grid", () => (parcelRequire("fIrdk")).grid);
$parcel$export(module.exports, "shadow", () => (parcelRequire("hdn6g")).shadow);
$parcel$export(module.exports, "buttonStyle", () => (parcelRequire("8Sr9x")).buttonStyle);
$parcel$export(module.exports, "textStyle", () => (parcelRequire("8Sr9x")).textStyle);
$parcel$export(module.exports, "colorStyle", () => (parcelRequire("8Sr9x")).colorStyle);

var $665Bp = parcelRequire("665Bp");

var $hHVze = parcelRequire("hHVze");

var $3VFVC = parcelRequire("3VFVC");

var $lWdYs = parcelRequire("lWdYs");

var $fNZHs = parcelRequire("fNZHs");

var $fIrdk = parcelRequire("fIrdk");

var $i2Hg7 = parcelRequire("i2Hg7");

var $xIyuN = parcelRequire("xIyuN");

var $hw25X = parcelRequire("hw25X");

var $cMmwD = parcelRequire("cMmwD");

var $hdn6g = parcelRequire("hdn6g");

var $8Sr9x = parcelRequire("8Sr9x");
var $5f545877b392f6a5$export$7e3df82ee760448c = (0, $hHVze.default).width, $5f545877b392f6a5$export$ac607276a8fe9f0a = (0, $hHVze.default).height, $5f545877b392f6a5$export$ee148fbbe8357dd2 = (0, $hHVze.default).minWidth, $5f545877b392f6a5$export$a43cf604e12f3b17 = (0, $hHVze.default).minHeight, $5f545877b392f6a5$export$488fda99655ff65a = (0, $hHVze.default).maxWidth, $5f545877b392f6a5$export$dc0d8bd0b94f8570 = (0, $hHVze.default).maxHeight, $5f545877b392f6a5$export$346677f925de839c = (0, $hHVze.default).size, $5f545877b392f6a5$export$a1d56c5b4fd76391 = (0, $hHVze.default).verticalAlign, $5f545877b392f6a5$export$79693fdaa4661ff2 = (0, $hHVze.default).display, $5f545877b392f6a5$export$f6530fb6e67e00bd = (0, $hHVze.default).overflow, $5f545877b392f6a5$export$de9d7619c2ea0e73 = (0, $hHVze.default).overflowX, $5f545877b392f6a5$export$d4afb3a10cd6ba72 = (0, $hHVze.default).overflowY;
var $5f545877b392f6a5$export$c17a3be1057836e = (0, $3VFVC.default).opacity;
var $5f545877b392f6a5$export$85e3c3ca0c6fb93 = (0, $lWdYs.default).fontSize, $5f545877b392f6a5$export$a5975749f0374264 = (0, $lWdYs.default).fontFamily, $5f545877b392f6a5$export$bc0b29e67df3229e = (0, $lWdYs.default).fontWeight, $5f545877b392f6a5$export$c9b91427b594e14 = (0, $lWdYs.default).lineHeight, $5f545877b392f6a5$export$a87999391cd10ae9 = (0, $lWdYs.default).textAlign, $5f545877b392f6a5$export$a827189a08c5a3a3 = (0, $lWdYs.default).fontStyle, $5f545877b392f6a5$export$3eb52878e4502ad1 = (0, $lWdYs.default).letterSpacing;
var $5f545877b392f6a5$export$898d9006406726bd = (0, $fNZHs.default).alignItems, $5f545877b392f6a5$export$38c32c6918694134 = (0, $fNZHs.default).alignContent, $5f545877b392f6a5$export$55e6b7a7f0eaa3ff = (0, $fNZHs.default).justifyItems, $5f545877b392f6a5$export$8dea3061ba53bfd1 = (0, $fNZHs.default).justifyContent, $5f545877b392f6a5$export$9a4bcd01f5c204bc = (0, $fNZHs.default).flexWrap, $5f545877b392f6a5$export$84c3c16c9ed6c908 = (0, $fNZHs.default).flexDirection, $5f545877b392f6a5$export$97691fbb80847c19 = (0, $fNZHs.default).flex, $5f545877b392f6a5$export$36c65c169152373d = (0, $fNZHs.default).flexGrow, $5f545877b392f6a5$export$2670ac60b02109d2 = (0, $fNZHs.default).flexShrink, $5f545877b392f6a5$export$d2ad290394bbc49d = (0, $fNZHs.default).flexBasis, $5f545877b392f6a5$export$d012640ac9a6446f = (0, $fNZHs.default).justifySelf, $5f545877b392f6a5$export$4545dd3632cb520b = (0, $fNZHs.default).alignSelf, $5f545877b392f6a5$export$aaaeab0fac9a3ccb = (0, $fNZHs.default).order;
var $5f545877b392f6a5$export$62ffeaf1cd78b2a6 = (0, $fIrdk.default).gridGap, $5f545877b392f6a5$export$d6171c086ca0de0 = (0, $fIrdk.default).gridColumnGap, $5f545877b392f6a5$export$8bb113508eaa54d = (0, $fIrdk.default).gridRowGap, $5f545877b392f6a5$export$baf44164ca3a34e8 = (0, $fIrdk.default).gridColumn, $5f545877b392f6a5$export$8f7213a1cd01e832 = (0, $fIrdk.default).gridRow, $5f545877b392f6a5$export$b0e0abbc49ba668 = (0, $fIrdk.default).gridAutoFlow, $5f545877b392f6a5$export$bcd8b929d4b4142 = (0, $fIrdk.default).gridAutoColumns, $5f545877b392f6a5$export$e5039a674e14c828 = (0, $fIrdk.default).gridAutoRows, $5f545877b392f6a5$export$42bd9088661ffb03 = (0, $fIrdk.default).gridTemplateColumns, $5f545877b392f6a5$export$920682ae05b999bc = (0, $fIrdk.default).gridTemplateRows, $5f545877b392f6a5$export$1b88fbdd482fd33a = (0, $fIrdk.default).gridTemplateAreas, $5f545877b392f6a5$export$bdb486e40d52d26f = (0, $fIrdk.default).gridArea;
var $5f545877b392f6a5$export$12879c7697ed953d = (0, $i2Hg7.default).borderWidth, $5f545877b392f6a5$export$4d0a7f76ad443516 = (0, $i2Hg7.default).borderStyle, $5f545877b392f6a5$export$e7fb0694ba2404fc = (0, $i2Hg7.default).borderColor, $5f545877b392f6a5$export$f9a7b6bd24892946 = (0, $i2Hg7.default).borderTop, $5f545877b392f6a5$export$5abca33e6be905d2 = (0, $i2Hg7.default).borderRight, $5f545877b392f6a5$export$e2ce9f12a980a822 = (0, $i2Hg7.default).borderBottom, $5f545877b392f6a5$export$47658cca1a909427 = (0, $i2Hg7.default).borderLeft, $5f545877b392f6a5$export$7a57f79000377ca2 = (0, $i2Hg7.default).borderRadius;
var $5f545877b392f6a5$export$586b24dc092f3131 = (0, $xIyuN.default).backgroundImage, $5f545877b392f6a5$export$c83c85ca8504d339 = (0, $xIyuN.default).backgroundSize, $5f545877b392f6a5$export$71e32fa73aaf5bec = (0, $xIyuN.default).backgroundPosition, $5f545877b392f6a5$export$edfc7ca25b41e47d = (0, $xIyuN.default).backgroundRepeat;
var $5f545877b392f6a5$export$56446adcecbeec34 = (0, $hw25X.default).zIndex, $5f545877b392f6a5$export$1e95b668f3b82d = (0, $hw25X.default).top, $5f545877b392f6a5$export$79ffe56a765070d2 = (0, $hw25X.default).right, $5f545877b392f6a5$export$40e543e69a8b3fbb = (0, $hw25X.default).bottom, $5f545877b392f6a5$export$eabcd2c8791e7bf4 = (0, $hw25X.default).left;
var $5f545877b392f6a5$export$1d567c320f4763bc = function style(_ref) {
    var prop = _ref.prop, cssProperty = _ref.cssProperty, alias = _ref.alias, key = _ref.key, transformValue = _ref.transformValue, scale = _ref.scale, properties = _ref.properties;
    var config = {};
    config[prop] = (0, $665Bp.createStyleFunction)({
        properties: properties,
        property: cssProperty || prop,
        scale: key,
        defaultScale: scale,
        transform: transformValue
    });
    if (alias) config[alias] = config[prop];
    var parse = (0, $665Bp.createParser)(config);
    return parse;
};

});
parcelRegister("665Bp", function(module, exports) {

$parcel$export(module.exports, "get", () => $4707a6257e8a6078$export$3988ae62b71be9a3);
$parcel$export(module.exports, "createParser", () => $4707a6257e8a6078$export$88a1156fad04455f);
$parcel$export(module.exports, "createStyleFunction", () => $4707a6257e8a6078$export$bb06ddfd5d66e02e);
$parcel$export(module.exports, "system", () => $4707a6257e8a6078$export$505f1cb98cb78c0d);
$parcel$export(module.exports, "compose", () => $4707a6257e8a6078$export$f672e0b6f7222cd7);

var $8coUR = parcelRequire("8coUR");
var $4707a6257e8a6078$export$4950aa0f605343fb = function merge(a, b) {
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, a, b);
    for(var key in a){
        var _assign;
        if (!a[key] || typeof b[key] !== 'object') continue;
        (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(result, (_assign = {}, _assign[key] = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(a[key], b[key]), _assign));
    }
    return result;
}; // sort object-value responsive styles
var $4707a6257e8a6078$var$sort = function sort(obj) {
    var next = {};
    Object.keys(obj).sort(function(a, b) {
        return a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    }).forEach(function(key) {
        next[key] = obj[key];
    });
    return next;
};
var $4707a6257e8a6078$var$defaults = {
    breakpoints: [
        40,
        52,
        64
    ].map(function(n) {
        return n + 'em';
    })
};
var $4707a6257e8a6078$var$createMediaQuery = function createMediaQuery(n) {
    return "@media screen and (min-width: " + n + ")";
};
var $4707a6257e8a6078$var$getValue = function getValue(n, scale) {
    return $4707a6257e8a6078$export$3988ae62b71be9a3(scale, n, n);
};
var $4707a6257e8a6078$export$3988ae62b71be9a3 = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [
        key
    ];
    for(p = 0; p < key.length; p++)obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
};
var $4707a6257e8a6078$export$88a1156fad04455f = function createParser(config) {
    var cache = {};
    var parse = function parse(props) {
        var styles = {};
        var shouldSort = false;
        var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;
        for(var key in props){
            if (!config[key]) continue;
            var sx = config[key];
            var raw = props[key];
            var scale = $4707a6257e8a6078$export$3988ae62b71be9a3(props.theme, sx.scale, sx.defaults);
            if (typeof raw === 'object') {
                cache.breakpoints = !isCacheDisabled && cache.breakpoints || $4707a6257e8a6078$export$3988ae62b71be9a3(props.theme, 'breakpoints', $4707a6257e8a6078$var$defaults.breakpoints);
                if (Array.isArray(raw)) {
                    cache.media = !isCacheDisabled && cache.media || [
                        null
                    ].concat(cache.breakpoints.map($4707a6257e8a6078$var$createMediaQuery));
                    styles = $4707a6257e8a6078$export$4950aa0f605343fb(styles, $4707a6257e8a6078$var$parseResponsiveStyle(cache.media, sx, scale, raw, props));
                    continue;
                }
                if (raw !== null) {
                    styles = $4707a6257e8a6078$export$4950aa0f605343fb(styles, $4707a6257e8a6078$var$parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
                    shouldSort = true;
                }
                continue;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(styles, sx(raw, scale, props));
        } // sort object-based responsive styles
        if (shouldSort) styles = $4707a6257e8a6078$var$sort(styles);
        return styles;
    };
    parse.config = config;
    parse.propNames = Object.keys(config);
    parse.cache = cache;
    var keys = Object.keys(config).filter(function(k) {
        return k !== 'config';
    });
    if (keys.length > 1) keys.forEach(function(key) {
        var _createParser;
        parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
    return parse;
};
var $4707a6257e8a6078$var$parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
    var styles = {};
    raw.slice(0, mediaQueries.length).forEach(function(value, i) {
        var media = mediaQueries[i];
        var style = sx(value, scale, _props);
        if (!media) (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(styles, style);
        else {
            var _assign2;
            (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(styles, (_assign2 = {}, _assign2[media] = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, styles[media], style), _assign2));
        }
    });
    return styles;
};
var $4707a6257e8a6078$var$parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
    var styles = {};
    for(var key in raw){
        var breakpoint = breakpoints[key];
        var value = raw[key];
        var style = sx(value, scale, _props);
        if (!breakpoint) (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(styles, style);
        else {
            var _assign3;
            var media = $4707a6257e8a6078$var$createMediaQuery(breakpoint);
            (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(styles, (_assign3 = {}, _assign3[media] = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, styles[media], style), _assign3));
        }
    }
    return styles;
};
var $4707a6257e8a6078$export$bb06ddfd5d66e02e = function createStyleFunction(_ref) {
    var properties = _ref.properties, property = _ref.property, scale = _ref.scale, _ref$transform = _ref.transform, transform = _ref$transform === void 0 ? $4707a6257e8a6078$var$getValue : _ref$transform, defaultScale = _ref.defaultScale;
    properties = properties || [
        property
    ];
    var sx = function sx(value, scale, _props) {
        var result = {};
        var n = transform(value, scale, _props);
        if (n === null) return;
        properties.forEach(function(prop) {
            result[prop] = n;
        });
        return result;
    };
    sx.scale = scale;
    sx.defaults = defaultScale;
    return sx;
}; // new v5 API
var $4707a6257e8a6078$export$505f1cb98cb78c0d = function system(args) {
    if (args === void 0) args = {};
    var config = {};
    Object.keys(args).forEach(function(key) {
        var conf = args[key];
        if (conf === true) {
            // shortcut definition
            config[key] = $4707a6257e8a6078$export$bb06ddfd5d66e02e({
                property: key,
                scale: key
            });
            return;
        }
        if (typeof conf === 'function') {
            config[key] = conf;
            return;
        }
        config[key] = $4707a6257e8a6078$export$bb06ddfd5d66e02e(conf);
    });
    var parser = $4707a6257e8a6078$export$88a1156fad04455f(config);
    return parser;
};
var $4707a6257e8a6078$export$f672e0b6f7222cd7 = function compose() {
    var config = {};
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++)parsers[_key] = arguments[_key];
    parsers.forEach(function(parser) {
        if (!parser || !parser.config) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))(config, parser.config);
    });
    var parser = $4707a6257e8a6078$export$88a1156fad04455f(config);
    return parser;
};

});

parcelRegister("hHVze", function(module, exports) {

$parcel$export(module.exports, "layout", () => $ce431b7bb8b1d44b$export$b3219800bda33a1f);
$parcel$export(module.exports, "default", () => $ce431b7bb8b1d44b$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $ce431b7bb8b1d44b$var$isNumber = function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
};
var $ce431b7bb8b1d44b$var$getWidth = function getWidth(n, scale) {
    return (0, $665Bp.get)(scale, n, !$ce431b7bb8b1d44b$var$isNumber(n) || n > 1 ? n : n * 100 + '%');
};
var $ce431b7bb8b1d44b$var$config = {
    width: {
        property: 'width',
        scale: 'sizes',
        transform: $ce431b7bb8b1d44b$var$getWidth
    },
    height: {
        property: 'height',
        scale: 'sizes'
    },
    minWidth: {
        property: 'minWidth',
        scale: 'sizes'
    },
    minHeight: {
        property: 'minHeight',
        scale: 'sizes'
    },
    maxWidth: {
        property: 'maxWidth',
        scale: 'sizes'
    },
    maxHeight: {
        property: 'maxHeight',
        scale: 'sizes'
    },
    size: {
        properties: [
            'width',
            'height'
        ],
        scale: 'sizes'
    },
    overflow: true,
    overflowX: true,
    overflowY: true,
    display: true,
    verticalAlign: true
};
var $ce431b7bb8b1d44b$export$b3219800bda33a1f = (0, $665Bp.system)($ce431b7bb8b1d44b$var$config);
var $ce431b7bb8b1d44b$export$2e2bcd8739ae039 = $ce431b7bb8b1d44b$export$b3219800bda33a1f;

});

parcelRegister("3VFVC", function(module, exports) {

$parcel$export(module.exports, "color", () => $2dc73812890f6d04$export$35e9368ef982300f);
$parcel$export(module.exports, "default", () => $2dc73812890f6d04$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $2dc73812890f6d04$var$config = {
    color: {
        property: 'color',
        scale: 'colors'
    },
    backgroundColor: {
        property: 'backgroundColor',
        scale: 'colors'
    },
    opacity: true
};
$2dc73812890f6d04$var$config.bg = $2dc73812890f6d04$var$config.backgroundColor;
var $2dc73812890f6d04$export$35e9368ef982300f = (0, $665Bp.system)($2dc73812890f6d04$var$config);
var $2dc73812890f6d04$export$2e2bcd8739ae039 = $2dc73812890f6d04$export$35e9368ef982300f;

});

parcelRegister("lWdYs", function(module, exports) {

$parcel$export(module.exports, "typography", () => $ff89dabd0ce30928$export$d846a084e680d8e);
$parcel$export(module.exports, "default", () => $ff89dabd0ce30928$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $ff89dabd0ce30928$var$defaults = {
    fontSizes: [
        12,
        14,
        16,
        20,
        24,
        32,
        48,
        64,
        72
    ]
};
var $ff89dabd0ce30928$var$config = {
    fontFamily: {
        property: 'fontFamily',
        scale: 'fonts'
    },
    fontSize: {
        property: 'fontSize',
        scale: 'fontSizes',
        defaultScale: $ff89dabd0ce30928$var$defaults.fontSizes
    },
    fontWeight: {
        property: 'fontWeight',
        scale: 'fontWeights'
    },
    lineHeight: {
        property: 'lineHeight',
        scale: 'lineHeights'
    },
    letterSpacing: {
        property: 'letterSpacing',
        scale: 'letterSpacings'
    },
    textAlign: true,
    fontStyle: true
};
var $ff89dabd0ce30928$export$d846a084e680d8e = (0, $665Bp.system)($ff89dabd0ce30928$var$config);
var $ff89dabd0ce30928$export$2e2bcd8739ae039 = $ff89dabd0ce30928$export$d846a084e680d8e;

});

parcelRegister("fNZHs", function(module, exports) {

$parcel$export(module.exports, "flexbox", () => $b81b4af4153f8718$export$feec61708a55c80e);
$parcel$export(module.exports, "default", () => $b81b4af4153f8718$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $b81b4af4153f8718$var$config = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: true,
    // item
    flex: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: true,
    justifySelf: true,
    alignSelf: true,
    order: true
};
var $b81b4af4153f8718$export$feec61708a55c80e = (0, $665Bp.system)($b81b4af4153f8718$var$config);
var $b81b4af4153f8718$export$2e2bcd8739ae039 = $b81b4af4153f8718$export$feec61708a55c80e;

});

parcelRegister("fIrdk", function(module, exports) {

$parcel$export(module.exports, "grid", () => $b7101330714ea2d1$export$85fc379452d91af0);
$parcel$export(module.exports, "default", () => $b7101330714ea2d1$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $b7101330714ea2d1$var$defaults = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ]
};
var $b7101330714ea2d1$var$config = {
    gridGap: {
        property: 'gridGap',
        scale: 'space',
        defaultScale: $b7101330714ea2d1$var$defaults.space
    },
    gridColumnGap: {
        property: 'gridColumnGap',
        scale: 'space',
        defaultScale: $b7101330714ea2d1$var$defaults.space
    },
    gridRowGap: {
        property: 'gridRowGap',
        scale: 'space',
        defaultScale: $b7101330714ea2d1$var$defaults.space
    },
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridAutoRows: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
var $b7101330714ea2d1$export$85fc379452d91af0 = (0, $665Bp.system)($b7101330714ea2d1$var$config);
var $b7101330714ea2d1$export$2e2bcd8739ae039 = $b7101330714ea2d1$export$85fc379452d91af0;

});

parcelRegister("i2Hg7", function(module, exports) {

$parcel$export(module.exports, "border", () => $d229f839a144025b$export$1edee58a52776cd9);
$parcel$export(module.exports, "default", () => $d229f839a144025b$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $d229f839a144025b$var$config = {
    border: {
        property: 'border',
        scale: 'borders'
    },
    borderWidth: {
        property: 'borderWidth',
        scale: 'borderWidths'
    },
    borderStyle: {
        property: 'borderStyle',
        scale: 'borderStyles'
    },
    borderColor: {
        property: 'borderColor',
        scale: 'colors'
    },
    borderRadius: {
        property: 'borderRadius',
        scale: 'radii'
    },
    borderTop: {
        property: 'borderTop',
        scale: 'borders'
    },
    borderTopLeftRadius: {
        property: 'borderTopLeftRadius',
        scale: 'radii'
    },
    borderTopRightRadius: {
        property: 'borderTopRightRadius',
        scale: 'radii'
    },
    borderRight: {
        property: 'borderRight',
        scale: 'borders'
    },
    borderBottom: {
        property: 'borderBottom',
        scale: 'borders'
    },
    borderBottomLeftRadius: {
        property: 'borderBottomLeftRadius',
        scale: 'radii'
    },
    borderBottomRightRadius: {
        property: 'borderBottomRightRadius',
        scale: 'radii'
    },
    borderLeft: {
        property: 'borderLeft',
        scale: 'borders'
    },
    borderX: {
        properties: [
            'borderLeft',
            'borderRight'
        ],
        scale: 'borders'
    },
    borderY: {
        properties: [
            'borderTop',
            'borderBottom'
        ],
        scale: 'borders'
    }
};
$d229f839a144025b$var$config.borderTopWidth = {
    property: 'borderTopWidth',
    scale: 'borderWidths'
};
$d229f839a144025b$var$config.borderTopColor = {
    property: 'borderTopColor',
    scale: 'colors'
};
$d229f839a144025b$var$config.borderTopStyle = {
    property: 'borderTopStyle',
    scale: 'borderStyles'
};
$d229f839a144025b$var$config.borderTopLeftRadius = {
    property: 'borderTopLeftRadius',
    scale: 'radii'
};
$d229f839a144025b$var$config.borderTopRightRadius = {
    property: 'borderTopRightRadius',
    scale: 'radii'
};
$d229f839a144025b$var$config.borderBottomWidth = {
    property: 'borderBottomWidth',
    scale: 'borderWidths'
};
$d229f839a144025b$var$config.borderBottomColor = {
    property: 'borderBottomColor',
    scale: 'colors'
};
$d229f839a144025b$var$config.borderBottomStyle = {
    property: 'borderBottomStyle',
    scale: 'borderStyles'
};
$d229f839a144025b$var$config.borderBottomLeftRadius = {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
};
$d229f839a144025b$var$config.borderBottomRightRadius = {
    property: 'borderBottomRightRadius',
    scale: 'radii'
};
$d229f839a144025b$var$config.borderLeftWidth = {
    property: 'borderLeftWidth',
    scale: 'borderWidths'
};
$d229f839a144025b$var$config.borderLeftColor = {
    property: 'borderLeftColor',
    scale: 'colors'
};
$d229f839a144025b$var$config.borderLeftStyle = {
    property: 'borderLeftStyle',
    scale: 'borderStyles'
};
$d229f839a144025b$var$config.borderRightWidth = {
    property: 'borderRightWidth',
    scale: 'borderWidths'
};
$d229f839a144025b$var$config.borderRightColor = {
    property: 'borderRightColor',
    scale: 'colors'
};
$d229f839a144025b$var$config.borderRightStyle = {
    property: 'borderRightStyle',
    scale: 'borderStyles'
};
var $d229f839a144025b$export$1edee58a52776cd9 = (0, $665Bp.system)($d229f839a144025b$var$config);
var $d229f839a144025b$export$2e2bcd8739ae039 = $d229f839a144025b$export$1edee58a52776cd9;

});

parcelRegister("xIyuN", function(module, exports) {

$parcel$export(module.exports, "background", () => $0655a4f3df95abd7$export$8ce1fd94bee2f412);
$parcel$export(module.exports, "default", () => $0655a4f3df95abd7$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $0655a4f3df95abd7$var$config = {
    background: true,
    backgroundImage: true,
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true
};
$0655a4f3df95abd7$var$config.bgImage = $0655a4f3df95abd7$var$config.backgroundImage;
$0655a4f3df95abd7$var$config.bgSize = $0655a4f3df95abd7$var$config.backgroundSize;
$0655a4f3df95abd7$var$config.bgPosition = $0655a4f3df95abd7$var$config.backgroundPosition;
$0655a4f3df95abd7$var$config.bgRepeat = $0655a4f3df95abd7$var$config.backgroundRepeat;
var $0655a4f3df95abd7$export$8ce1fd94bee2f412 = (0, $665Bp.system)($0655a4f3df95abd7$var$config);
var $0655a4f3df95abd7$export$2e2bcd8739ae039 = $0655a4f3df95abd7$export$8ce1fd94bee2f412;

});

parcelRegister("hw25X", function(module, exports) {

$parcel$export(module.exports, "position", () => $cc070cd99afa2c35$export$5880b8b5730aff45);
$parcel$export(module.exports, "default", () => $cc070cd99afa2c35$export$2e2bcd8739ae039);

var $665Bp = parcelRequire("665Bp");
var $cc070cd99afa2c35$var$defaults = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ]
};
var $cc070cd99afa2c35$var$config = {
    position: true,
    zIndex: {
        property: 'zIndex',
        scale: 'zIndices'
    },
    top: {
        property: 'top',
        scale: 'space',
        defaultScale: $cc070cd99afa2c35$var$defaults.space
    },
    right: {
        property: 'right',
        scale: 'space',
        defaultScale: $cc070cd99afa2c35$var$defaults.space
    },
    bottom: {
        property: 'bottom',
        scale: 'space',
        defaultScale: $cc070cd99afa2c35$var$defaults.space
    },
    left: {
        property: 'left',
        scale: 'space',
        defaultScale: $cc070cd99afa2c35$var$defaults.space
    }
};
var $cc070cd99afa2c35$export$5880b8b5730aff45 = (0, $665Bp.system)($cc070cd99afa2c35$var$config);
var $cc070cd99afa2c35$export$2e2bcd8739ae039 = $cc070cd99afa2c35$export$5880b8b5730aff45;

});

parcelRegister("cMmwD", function(module, exports) {

$parcel$export(module.exports, "space", () => $94db70d107b9dc73$export$a941ed4b947d12f8);

var $665Bp = parcelRequire("665Bp");
var $94db70d107b9dc73$var$defaults = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ]
};
var $94db70d107b9dc73$var$isNumber = function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
};
var $94db70d107b9dc73$var$getMargin = function getMargin(n, scale) {
    if (!$94db70d107b9dc73$var$isNumber(n)) return (0, $665Bp.get)(scale, n, n);
    var isNegative = n < 0;
    var absolute = Math.abs(n);
    var value = (0, $665Bp.get)(scale, absolute, absolute);
    if (!$94db70d107b9dc73$var$isNumber(value)) return isNegative ? '-' + value : value;
    return value * (isNegative ? -1 : 1);
};
var $94db70d107b9dc73$var$configs = {};
$94db70d107b9dc73$var$configs.margin = {
    margin: {
        property: 'margin',
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginTop: {
        property: 'marginTop',
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginRight: {
        property: 'marginRight',
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginBottom: {
        property: 'marginBottom',
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginLeft: {
        property: 'marginLeft',
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginX: {
        properties: [
            'marginLeft',
            'marginRight'
        ],
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    marginY: {
        properties: [
            'marginTop',
            'marginBottom'
        ],
        scale: 'space',
        transform: $94db70d107b9dc73$var$getMargin,
        defaultScale: $94db70d107b9dc73$var$defaults.space
    }
};
$94db70d107b9dc73$var$configs.margin.m = $94db70d107b9dc73$var$configs.margin.margin;
$94db70d107b9dc73$var$configs.margin.mt = $94db70d107b9dc73$var$configs.margin.marginTop;
$94db70d107b9dc73$var$configs.margin.mr = $94db70d107b9dc73$var$configs.margin.marginRight;
$94db70d107b9dc73$var$configs.margin.mb = $94db70d107b9dc73$var$configs.margin.marginBottom;
$94db70d107b9dc73$var$configs.margin.ml = $94db70d107b9dc73$var$configs.margin.marginLeft;
$94db70d107b9dc73$var$configs.margin.mx = $94db70d107b9dc73$var$configs.margin.marginX;
$94db70d107b9dc73$var$configs.margin.my = $94db70d107b9dc73$var$configs.margin.marginY;
$94db70d107b9dc73$var$configs.padding = {
    padding: {
        property: 'padding',
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingTop: {
        property: 'paddingTop',
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingRight: {
        property: 'paddingRight',
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingBottom: {
        property: 'paddingBottom',
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingLeft: {
        property: 'paddingLeft',
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingX: {
        properties: [
            'paddingLeft',
            'paddingRight'
        ],
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    },
    paddingY: {
        properties: [
            'paddingTop',
            'paddingBottom'
        ],
        scale: 'space',
        defaultScale: $94db70d107b9dc73$var$defaults.space
    }
};
$94db70d107b9dc73$var$configs.padding.p = $94db70d107b9dc73$var$configs.padding.padding;
$94db70d107b9dc73$var$configs.padding.pt = $94db70d107b9dc73$var$configs.padding.paddingTop;
$94db70d107b9dc73$var$configs.padding.pr = $94db70d107b9dc73$var$configs.padding.paddingRight;
$94db70d107b9dc73$var$configs.padding.pb = $94db70d107b9dc73$var$configs.padding.paddingBottom;
$94db70d107b9dc73$var$configs.padding.pl = $94db70d107b9dc73$var$configs.padding.paddingLeft;
$94db70d107b9dc73$var$configs.padding.px = $94db70d107b9dc73$var$configs.padding.paddingX;
$94db70d107b9dc73$var$configs.padding.py = $94db70d107b9dc73$var$configs.padding.paddingY;
var $94db70d107b9dc73$export$7ede87f9b603dd3c = (0, $665Bp.system)($94db70d107b9dc73$var$configs.margin);
var $94db70d107b9dc73$export$6f98e8eaf0be1996 = (0, $665Bp.system)($94db70d107b9dc73$var$configs.padding);
var $94db70d107b9dc73$export$a941ed4b947d12f8 = (0, $665Bp.compose)($94db70d107b9dc73$export$7ede87f9b603dd3c, $94db70d107b9dc73$export$6f98e8eaf0be1996);
var $94db70d107b9dc73$export$2e2bcd8739ae039 = $94db70d107b9dc73$export$a941ed4b947d12f8;

});

parcelRegister("hdn6g", function(module, exports) {

$parcel$export(module.exports, "shadow", () => $c88591ba4147f02d$export$b8972b998723d602);

var $665Bp = parcelRequire("665Bp");
var $c88591ba4147f02d$export$b8972b998723d602 = (0, $665Bp.system)({
    boxShadow: {
        property: 'boxShadow',
        scale: 'shadows'
    },
    textShadow: {
        property: 'textShadow',
        scale: 'shadows'
    }
});
var $c88591ba4147f02d$export$2e2bcd8739ae039 = $c88591ba4147f02d$export$b8972b998723d602;

});

parcelRegister("8Sr9x", function(module, exports) {

$parcel$export(module.exports, "buttonStyle", () => $67686de24be1bfe2$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "textStyle", () => $67686de24be1bfe2$export$e156b0e4bc782edc);
$parcel$export(module.exports, "colorStyle", () => $67686de24be1bfe2$export$32b689c01689bf5b);

var $665Bp = parcelRequire("665Bp");

var $1ApNP = parcelRequire("1ApNP");
var $67686de24be1bfe2$export$8fdf71db98f19724 = function variant(_ref) {
    var _config;
    var scale = _ref.scale, _ref$prop = _ref.prop, prop = _ref$prop === void 0 ? 'variant' : _ref$prop, _ref$variants = _ref.variants, variants = _ref$variants === void 0 ? {} : _ref$variants, key = _ref.key;
    var sx;
    if (Object.keys(variants).length) sx = function sx(value, scale, props) {
        return (0, $1ApNP.default)((0, $665Bp.get)(scale, value, null))(props.theme);
    };
    else sx = function sx(value, scale) {
        return (0, $665Bp.get)(scale, value, null);
    };
    sx.scale = scale || key;
    sx.defaults = variants;
    var config = (_config = {}, _config[prop] = sx, _config);
    var parser = (0, $665Bp.createParser)(config);
    return parser;
};
var $67686de24be1bfe2$export$2e2bcd8739ae039 = $67686de24be1bfe2$export$8fdf71db98f19724;
var $67686de24be1bfe2$export$fd4d27a26b4854f3 = $67686de24be1bfe2$export$8fdf71db98f19724({
    key: 'buttons'
});
var $67686de24be1bfe2$export$e156b0e4bc782edc = $67686de24be1bfe2$export$8fdf71db98f19724({
    key: 'textStyles',
    prop: 'textStyle'
});
var $67686de24be1bfe2$export$32b689c01689bf5b = $67686de24be1bfe2$export$8fdf71db98f19724({
    key: 'colorStyles',
    prop: 'colors'
});

});



parcelRegister("2hXAd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1aab634117c61fa3$export$2e2bcd8739ae039);

var $1poQt = parcelRequire("1poQt");
var $1aab634117c61fa3$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $1aab634117c61fa3$var$newStyled = (0, $1poQt.default).bind();
$1aab634117c61fa3$var$tags.forEach(function(tagName) {
    $1aab634117c61fa3$var$newStyled[tagName] = $1aab634117c61fa3$var$newStyled(tagName);
});
var $1aab634117c61fa3$export$2e2bcd8739ae039 = $1aab634117c61fa3$var$newStyled;

});
parcelRegister("1poQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $106b65ffba5ad10b$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $7dGEo = parcelRequire("7dGEo");
parcelRequire("f5Egd");
var $eeQal = parcelRequire("eeQal");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");
var $106b65ffba5ad10b$var$testOmitPropsOnStringTag = (0, $7dGEo.default);
var $106b65ffba5ad10b$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme' && key !== 'innerRef';
};
var $106b65ffba5ad10b$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $106b65ffba5ad10b$var$testOmitPropsOnStringTag : $106b65ffba5ad10b$var$testOmitPropsOnComponent;
};
function $106b65ffba5ad10b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $106b65ffba5ad10b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $106b65ffba5ad10b$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $106b65ffba5ad10b$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $106b65ffba5ad10b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $106b65ffba5ad10b$var$createStyled = function createStyled(tag, options) {
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $106b65ffba5ad10b$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $eeQal.w)(function(props, context, ref) {
            return (0, $acw62.createElement)((0, $eeQal.T).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = '';
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === 'string') className = (0, $boAuA.getRegisteredStyles)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $cXgB3.serializeStyles)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $boAuA.insertStyles)(context, serialized, typeof finalTag === 'string');
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $106b65ffba5ad10b$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === 'as') continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                var ele = (0, $acw62.createElement)(finalTag, newProps);
                return ele;
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $106b65ffba5ad10b$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $106b65ffba5ad10b$export$2e2bcd8739ae039 = $106b65ffba5ad10b$var$createStyled;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $5DKOa(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $fKGZD(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $010f4e0e13c82e16$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $b77c8068776c2a21$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f5Egd", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eeQal")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eeQal")).w);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");
parcelRequire("czXz2");

var $eeQal = parcelRequire("eeQal");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");

var $gGJqS = parcelRequire("gGJqS");

var $6xSYO = parcelRequire("6xSYO");
var $afc68d865495bec5$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $eeQal.h).call(props, 'css')) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eeQal.E);
    createElementArgArray[1] = (0, $eeQal.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $afc68d865495bec5$var$warnedAboutCssPropForGlobal = false;
var $afc68d865495bec5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eeQal.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $acw62.createElement)((0, $eeQal.T).Consumer, null, function(theme) {
        var serialized = (0, $cXgB3.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $cXgB3.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $afc68d865495bec5$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $gGJqS.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $boAuA.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $acw62.Component));
var $afc68d865495bec5$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $6xSYO.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $afc68d865495bec5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $afc68d865495bec5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $boAuA.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $afc68d865495bec5$export$9b9c0f9d9f3552b8 = (0, $eeQal.w)(function(props, context) {
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $eeQal.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $cXgB3.serializeStyles)(args, context.registered);
            (0, $boAuA.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $afc68d865495bec5$var$merge(context.registered, css, $afc68d865495bec5$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        return ele;
    });
});

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $VFVve.default)(subClass, superClass);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("czXz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9286f517b9779ada$export$2e2bcd8739ae039);

var $gGJqS = parcelRequire("gGJqS");

var $demXJ = parcelRequire("demXJ");
parcelRequire("55EI3");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $9286f517b9779ada$var$delimiter = '/*|*/';
var $9286f517b9779ada$var$needle = $9286f517b9779ada$var$delimiter + '}';
function $9286f517b9779ada$var$toSheet(block) {
    if (block) $9286f517b9779ada$var$Sheet.current.insert(block + '}');
}
var $9286f517b9779ada$var$Sheet = {
    current: null
};
var $9286f517b9779ada$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $9286f517b9779ada$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $9286f517b9779ada$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $9286f517b9779ada$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $9286f517b9779ada$var$delimiter : '');
            }
        case -2:
            content.split($9286f517b9779ada$var$needle).forEach($9286f517b9779ada$var$toSheet);
    }
};
var $9286f517b9779ada$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $demXJ.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($9286f517b9779ada$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $9286f517b9779ada$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $gGJqS.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $9286f517b9779ada$export$2e2bcd8739ae039 = $9286f517b9779ada$var$createCache;

});
parcelRegister("gGJqS", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $c263cf8568d025ad$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $c263cf8568d025ad$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $c263cf8568d025ad$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $c263cf8568d025ad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $c263cf8568d025ad$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c263cf8568d025ad$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("55EI3", function(module, exports) {
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;

});


parcelRegister("eeQal", function(module, exports) {

$parcel$export(module.exports, "h", () => $a5dad68f10fc0daf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $a5dad68f10fc0daf$export$971d5caa766a69d7);
$parcel$export(module.exports, "w", () => $a5dad68f10fc0daf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $a5dad68f10fc0daf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $a5dad68f10fc0daf$export$a9c23c6ac3fc3eca);
parcelRequire("6r4zt");

var $acw62 = parcelRequire("acw62");

var $czXz2 = parcelRequire("czXz2");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");
var $a5dad68f10fc0daf$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $a5dad68f10fc0daf$var$EmotionCacheContext = /*#__PURE__*/ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $czXz2.default)() : null);
var $a5dad68f10fc0daf$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $acw62.createContext)({});
var $a5dad68f10fc0daf$export$e7094788287c5e9b = $a5dad68f10fc0daf$var$EmotionCacheContext.Provider;
var $a5dad68f10fc0daf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $acw62.createElement)($a5dad68f10fc0daf$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $a5dad68f10fc0daf$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $a5dad68f10fc0daf$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $a5dad68f10fc0daf$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $a5dad68f10fc0daf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($a5dad68f10fc0daf$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$a5dad68f10fc0daf$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $a5dad68f10fc0daf$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$a5dad68f10fc0daf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $boAuA.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cXgB3.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $boAuA.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($a5dad68f10fc0daf$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $a5dad68f10fc0daf$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $acw62.createElement)(type, newProps);
    return ele;
}; // eslint-disable-next-line no-undef
var $a5dad68f10fc0daf$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $a5dad68f10fc0daf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $acw62.createElement)($a5dad68f10fc0daf$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $a5dad68f10fc0daf$var$render(cache, props, theme, ref);
    });
    return $a5dad68f10fc0daf$var$render(cache, props, null, ref);
});

});
parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $aAhot(subClass, superClass);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("boAuA", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $84be3e3d8830d20e$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $84be3e3d8830d20e$export$6f077d94b33a01aa);
var $84be3e3d8830d20e$var$isBrowser = true;
function $84be3e3d8830d20e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $84be3e3d8830d20e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $84be3e3d8830d20e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cXgB3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $96e7de74f086414c$export$6321afa313b251b5);

var $gz7zU = parcelRequire("gz7zU");

var $iDSBG = parcelRequire("iDSBG");

var $l7O8P = parcelRequire("l7O8P");
var $96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $96e7de74f086414c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $96e7de74f086414c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $96e7de74f086414c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $96e7de74f086414c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $96e7de74f086414c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $96e7de74f086414c$var$processStyleName = (0, $l7O8P.default)(function(styleName) {
    return $96e7de74f086414c$var$isCustomProperty(styleName) ? styleName : styleName.replace($96e7de74f086414c$var$hyphenateRegex, '-$&').toLowerCase();
});
var $96e7de74f086414c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($96e7de74f086414c$var$animationRegex, function(match, p1, p2) {
                $96e7de74f086414c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $96e7de74f086414c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iDSBG.default)[key] !== 1 && !$96e7de74f086414c$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $96e7de74f086414c$var$contentValuePattern, $96e7de74f086414c$var$contentValues, $96e7de74f086414c$var$oldProcessStyleValue, $96e7de74f086414c$var$msPattern, $96e7de74f086414c$var$hyphenPattern, $96e7de74f086414c$var$hyphenatedCache;
var $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $96e7de74f086414c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $96e7de74f086414c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $96e7de74f086414c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $96e7de74f086414c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $96e7de74f086414c$var$cursor;
                var result = interpolation(mergedProps);
                $96e7de74f086414c$var$cursor = previousCursor;
                return $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($96e7de74f086414c$var$isProcessableValue(value)) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($96e7de74f086414c$var$isProcessableValue(value[_i])) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $96e7de74f086414c$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $96e7de74f086414c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $96e7de74f086414c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $96e7de74f086414c$var$cursor;
var $96e7de74f086414c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $96e7de74f086414c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $96e7de74f086414c$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $96e7de74f086414c$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $gz7zU.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $96e7de74f086414c$var$cursor
    };
};

});
parcelRegister("gz7zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f5cb12993018cc$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;

});



parcelRegister("6xSYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4078fc8d62d9b6$export$2e2bcd8739ae039);

var $cXgB3 = parcelRequire("cXgB3");
function $4c4078fc8d62d9b6$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cXgB3.serializeStyles)(args);
}
var $4c4078fc8d62d9b6$export$2e2bcd8739ae039 = $4c4078fc8d62d9b6$var$css;

});




parcelRegister("8g1PZ", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("2RJ2t", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => epsilon);
$parcel$export(module.exports, "epsilon2", () => epsilon2);
$parcel$export(module.exports, "beaches", () => beaches);
$parcel$export(module.exports, "cells", () => cells);
$parcel$export(module.exports, "circles", () => circles);
$parcel$export(module.exports, "edges", () => edges);
$parcel$export(module.exports, "default", () => Diagram);

var $b1XfE = parcelRequire("b1XfE");

var $j61Qm = parcelRequire("j61Qm");

var $7AZxF = parcelRequire("7AZxF");

var $gzJsf = parcelRequire("gzJsf");

var $bo307 = parcelRequire("bo307");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $bo307.default);
    circles = new (0, $bo307.default);
    while(true){
        circle = (0, $7AZxF.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $b1XfE.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $b1XfE.removeBeach)(circle.arc);
        else break;
    }
    (0, $j61Qm.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $gzJsf.clipEdges)(x0, y0, x1, y1);
        (0, $j61Qm.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $j61Qm.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("b1XfE", function(module, exports) {

$parcel$export(module.exports, "removeBeach", () => $807dbfd47a592bc5$export$25be321a9b2d3c3c);
$parcel$export(module.exports, "addBeach", () => $807dbfd47a592bc5$export$fec167a219592370);

var $bo307 = parcelRequire("bo307");

var $j61Qm = parcelRequire("j61Qm");

var $7AZxF = parcelRequire("7AZxF");

var $gzJsf = parcelRequire("gzJsf");

var $2RJ2t = parcelRequire("2RJ2t");
var $807dbfd47a592bc5$var$beachPool = [];
function $807dbfd47a592bc5$var$Beach() {
    (0, $bo307.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $807dbfd47a592bc5$var$createBeach(site) {
    var beach = $807dbfd47a592bc5$var$beachPool.pop() || new $807dbfd47a592bc5$var$Beach;
    beach.site = site;
    return beach;
}
function $807dbfd47a592bc5$var$detachBeach(beach) {
    (0, $7AZxF.detachCircle)(beach);
    (0, $2RJ2t.beaches).remove(beach);
    $807dbfd47a592bc5$var$beachPool.push(beach);
    (0, $bo307.RedBlackNode)(beach);
}
function $807dbfd47a592bc5$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $807dbfd47a592bc5$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $2RJ2t.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $2RJ2t.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $807dbfd47a592bc5$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $7AZxF.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $2RJ2t.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $2RJ2t.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $807dbfd47a592bc5$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $7AZxF.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $gzJsf.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $gzJsf.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $7AZxF.attachCircle)(lArc);
    (0, $7AZxF.attachCircle)(rArc);
}
function $807dbfd47a592bc5$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $2RJ2t.beaches)._;
    while(node){
        dxl = $807dbfd47a592bc5$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $2RJ2t.epsilon)) node = node.L;
        else {
            dxr = x - $807dbfd47a592bc5$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $2RJ2t.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $2RJ2t.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $2RJ2t.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $j61Qm.createCell)(site);
    var newArc = $807dbfd47a592bc5$var$createBeach(site);
    (0, $2RJ2t.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $7AZxF.detachCircle)(lArc);
        rArc = $807dbfd47a592bc5$var$createBeach(lArc.site);
        (0, $2RJ2t.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $gzJsf.createEdge)(lArc.site, newArc.site);
        (0, $7AZxF.attachCircle)(lArc);
        (0, $7AZxF.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $gzJsf.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $7AZxF.detachCircle)(lArc);
    (0, $7AZxF.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $gzJsf.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $gzJsf.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $gzJsf.createEdge)(site, rSite, null, vertex);
    (0, $7AZxF.attachCircle)(lArc);
    (0, $7AZxF.attachCircle)(rArc);
}
function $807dbfd47a592bc5$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $807dbfd47a592bc5$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $807dbfd47a592bc5$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("bo307", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", () => $84a4437e8ef0514b$export$5072552a5e64b90a);
$parcel$export(module.exports, "default", () => $84a4437e8ef0514b$export$2e2bcd8739ae039);
function $84a4437e8ef0514b$var$RedBlackTree() {
    this._ = null; // root node
}
function $84a4437e8ef0514b$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$84a4437e8ef0514b$var$RedBlackTree.prototype = {
    constructor: $84a4437e8ef0514b$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $84a4437e8ef0514b$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $84a4437e8ef0514b$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $84a4437e8ef0514b$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $84a4437e8ef0514b$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $84a4437e8ef0514b$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $84a4437e8ef0514b$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $84a4437e8ef0514b$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $84a4437e8ef0514b$export$2e2bcd8739ae039 = $84a4437e8ef0514b$var$RedBlackTree;

});

parcelRegister("j61Qm", function(module, exports) {

$parcel$export(module.exports, "createCell", () => $de7001ec5c970277$export$3cb21b6b1233300e);
$parcel$export(module.exports, "cellHalfedgeStart", () => $de7001ec5c970277$export$67c16aa967774be);
$parcel$export(module.exports, "sortCellHalfedges", () => $de7001ec5c970277$export$41888d88cbc31210);
$parcel$export(module.exports, "clipCells", () => $de7001ec5c970277$export$cdcebd68073bc3f);

var $gzJsf = parcelRequire("gzJsf");

var $2RJ2t = parcelRequire("2RJ2t");
function $de7001ec5c970277$export$3cb21b6b1233300e(site) {
    return (0, $2RJ2t.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $de7001ec5c970277$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $de7001ec5c970277$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $de7001ec5c970277$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $de7001ec5c970277$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $2RJ2t.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $2RJ2t.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $de7001ec5c970277$var$cellHalfedgeAngle(cell, (0, $2RJ2t.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $de7001ec5c970277$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $2RJ2t.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $2RJ2t.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $2RJ2t.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $de7001ec5c970277$export$bf8e581ba65a00a5(cell, (0, $2RJ2t.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $de7001ec5c970277$export$67c16aa967774be(cell, (0, $2RJ2t.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $2RJ2t.epsilon) || Math.abs(endY - startY) > (0, $2RJ2t.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $2RJ2t.epsilon) && y1 - endY > (0, $2RJ2t.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $2RJ2t.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $2RJ2t.epsilon) && x1 - endX > (0, $2RJ2t.epsilon) ? [
                    Math.abs(startY - y1) < (0, $2RJ2t.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $2RJ2t.epsilon) && endY - y0 > (0, $2RJ2t.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $2RJ2t.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $2RJ2t.epsilon) && endX - x0 > (0, $2RJ2t.epsilon) ? [
                    Math.abs(startY - y0) < (0, $2RJ2t.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $2RJ2t.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v01, v11)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v11, v10)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $2RJ2t.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $2RJ2t.cells)[iCell];
        }
    }
}

});
parcelRegister("gzJsf", function(module, exports) {

$parcel$export(module.exports, "createEdge", () => $c1132c8ae02cf463$export$bdd941b9b8806569);
$parcel$export(module.exports, "setEdgeEnd", () => $c1132c8ae02cf463$export$9e883caea829cb44);
$parcel$export(module.exports, "createBorderEdge", () => $c1132c8ae02cf463$export$681cc0bbec712be1);
$parcel$export(module.exports, "clipEdges", () => $c1132c8ae02cf463$export$db4502aa9c1617af);

var $2RJ2t = parcelRequire("2RJ2t");
function $c1132c8ae02cf463$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $2RJ2t.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $c1132c8ae02cf463$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $c1132c8ae02cf463$export$9e883caea829cb44(edge, right, left, v1);
    (0, $2RJ2t.cells)[left.index].halfedges.push(index);
    (0, $2RJ2t.cells)[right.index].halfedges.push(index);
    return edge;
}
function $c1132c8ae02cf463$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $c1132c8ae02cf463$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $c1132c8ae02cf463$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $c1132c8ae02cf463$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $c1132c8ae02cf463$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $2RJ2t.edges).length, edge;
    while(i--)if (!$c1132c8ae02cf463$var$connectEdge(edge = (0, $2RJ2t.edges)[i], x0, y0, x1, y1) || !$c1132c8ae02cf463$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $2RJ2t.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $2RJ2t.epsilon))) delete (0, $2RJ2t.edges)[i];
}

});


parcelRegister("7AZxF", function(module, exports) {

$parcel$export(module.exports, "firstCircle", () => $587ba22dbacb1cfa$export$2ca650a30b282a37);
$parcel$export(module.exports, "attachCircle", () => $587ba22dbacb1cfa$export$2a19333f6373b7a2);
$parcel$export(module.exports, "detachCircle", () => $587ba22dbacb1cfa$export$f0bd50ff687673c1);

var $bo307 = parcelRequire("bo307");

var $2RJ2t = parcelRequire("2RJ2t");
var $587ba22dbacb1cfa$var$circlePool = [];
var $587ba22dbacb1cfa$export$2ca650a30b282a37;
function $587ba22dbacb1cfa$var$Circle() {
    (0, $bo307.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $587ba22dbacb1cfa$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $2RJ2t.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $587ba22dbacb1cfa$var$circlePool.pop() || new $587ba22dbacb1cfa$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $2RJ2t.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $2RJ2t.circles).insert(before, circle);
    if (!before) $587ba22dbacb1cfa$export$2ca650a30b282a37 = circle;
}
function $587ba22dbacb1cfa$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $587ba22dbacb1cfa$export$2ca650a30b282a37 = circle.N;
        (0, $2RJ2t.circles).remove(circle);
        $587ba22dbacb1cfa$var$circlePool.push(circle);
        (0, $bo307.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});



parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("9BdaM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $4LmDH.default)(1, arguments);
    return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("cFZfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93a8d45f3f5c7cb9$export$2e2bcd8739ae039);

var $9BdaM = parcelRequire("9BdaM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    if (!(0, $9BdaM.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $gdr0J.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("gdr0J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("6IhJz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e349bc0dbb08c36$export$2e2bcd8739ae039);

var $cFZfS = parcelRequire("cFZfS");

var $15nwl = parcelRequire("15nwl");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $iDIba = parcelRequire("iDIba");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $4LmDH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $15nwl.default);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $esGEx.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $esGEx.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $gdr0J.default)(dirtyDate);
    if (!(0, $cFZfS.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9vfYB.default)(originalDate);
    var utcDate = (0, $8NlMJ.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $iDIba.default)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $ebrmh.isProtectedWeekYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $ebrmh.isProtectedDayOfYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    return input.match($4e349bc0dbb08c36$var$escapedStringRegExp)[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("15nwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca880ce53ce49f9$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $fW24Y = parcelRequire("fW24Y");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $fW24Y.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;

});
parcelRegister("2qFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e78b8ee7f66d8$export$2e2bcd8739ae039);
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;

});

parcelRegister("fW24Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99de2b03d4f39be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;

});
parcelRegister("uq3Ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b7040d79e43f9d$export$2e2bcd8739ae039);
function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("1uXR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $117705cf2af2348d$export$2e2bcd8739ae039);
var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;

});

parcelRegister("cPhtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9567ced935a3b497$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;

});
parcelRegister("kp3bq", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda89c8f88184c82$export$2e2bcd8739ae039);
function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2SJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $219397ebd8b56b11$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;

});
parcelRegister("gKbFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c309fdccb9ef673a$export$2e2bcd8739ae039);
function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7pOAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56621c36efca199b$export$2e2bcd8739ae039);
function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("8NlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6673cc5b62dfa592$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, -amount);
}

});
parcelRegister("esGEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874c42e2166676d$export$2e2bcd8739ae039);
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("8eaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd7da45fede2458$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var timestamp = (0, $gdr0J.default)(dirtyDate).getTime();
    var amount = (0, $esGEx.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("iDIba", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e238bf521c720$export$2e2bcd8739ae039);

var $cbpKX = parcelRequire("cbpKX");

var $iT1Z6 = parcelRequire("iT1Z6");

var $jsJZZ = parcelRequire("jsJZZ");

var $7sdBg = parcelRequire("7sdBg");

var $gTlfB = parcelRequire("gTlfB");

var $kB1VM = parcelRequire("kB1VM");

var $bGZx9 = parcelRequire("bGZx9");
var $d91e238bf521c720$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $cbpKX.default).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $kB1VM.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $bGZx9.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $bGZx9.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $7sdBg.default)(date); // Padding
        return (0, $bGZx9.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $bGZx9.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $cbpKX.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $bGZx9.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $gTlfB.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $bGZx9.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $jsJZZ.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $bGZx9.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $cbpKX.default).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $iT1Z6.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $bGZx9.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $bGZx9.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $bGZx9.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $bGZx9.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $cbpKX.default).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $cbpKX.default).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $cbpKX.default).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $cbpKX.default).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $cbpKX.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $bGZx9.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $bGZx9.default)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $bGZx9.default)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $bGZx9.default)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $bGZx9.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $bGZx9.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;

});
parcelRegister("cbpKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dea7dd01f0b97c2$export$2e2bcd8739ae039);

var $bGZx9 = parcelRequire("bGZx9");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bGZx9.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $bGZx9.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $bGZx9.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $bGZx9.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $bGZx9.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bGZx9.default)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;

});
parcelRegister("bGZx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $88335940ad51fc8f$export$2e2bcd8739ae039);
function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});


parcelRegister("iT1Z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfee7256f9ba04c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("jsJZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b4503c694c959a$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bY8nB = parcelRequire("bY8nB");

var $6KmMb = parcelRequire("6KmMb");

var $4LmDH = parcelRequire("4LmDH");
var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $bY8nB.default)(date).getTime() - (0, $6KmMb.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("bY8nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6bcc549b1c1b29$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6KmMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98b4d5a2488885$export$2e2bcd8739ae039);

var $7sdBg = parcelRequire("7sdBg");

var $bY8nB = parcelRequire("bY8nB");

var $4LmDH = parcelRequire("4LmDH");
function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $7sdBg.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $bY8nB.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7sdBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d5b29bd1df6af4$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bY8nB = parcelRequire("bY8nB");

var $4LmDH = parcelRequire("4LmDH");
function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $bY8nB.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $bY8nB.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gTlfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c2445bc457b574$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $1cqVL = parcelRequire("1cqVL");

var $7Pzkw = parcelRequire("7Pzkw");

var $4LmDH = parcelRequire("4LmDH");
var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $1cqVL.default)(date, options).getTime() - (0, $7Pzkw.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1cqVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfbcd4e04a34858$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7Pzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b38b39a484f4993$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $kB1VM = parcelRequire("kB1VM");

var $1cqVL = parcelRequire("1cqVL");

var $4LmDH = parcelRequire("4LmDH");
function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $esGEx.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $esGEx.default)(options.firstWeekContainsDate);
    var year = (0, $kB1VM.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $1cqVL.default)(firstWeek, dirtyOptions);
    return date;
}

});
parcelRegister("kB1VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe8c2ce4ac4bd36$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $1cqVL = parcelRequire("1cqVL");

var $4LmDH = parcelRequire("4LmDH");
function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $esGEx.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $esGEx.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1cqVL.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1cqVL.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});




parcelRegister("6MGGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f085685fa15e740$export$2e2bcd8739ae039);
function $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $4f085685fa15e740$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $4f085685fa15e740$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
}
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;

});

parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("ebrmh", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a5375092e28b891e$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a5375092e28b891e$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a5375092e28b891e$export$8073c1ae88f0e727);
var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("bTSG2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8a9f3e7be35784f5$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE = 60000;
function $8a9f3e7be35784f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("kehhj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eba2848fce1475e9$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR = 3600000;
function $eba2848fce1475e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("6OX6Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f754377033842c6$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("2MTnF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $207b05f27970aaba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $6OX6Q.default)(dirtyDate, days);
}

});

parcelRegister("eqWMS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a8211859f65764ad$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("kbDwl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb237db400049a40$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, amount * 12);
}

});

parcelRegister("8o58w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61b48c9d860cd899$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $bTSG2 = parcelRequire("bTSG2");

var $4LmDH = parcelRequire("4LmDH");
function $61b48c9d860cd899$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $bTSG2.default)(dirtyDate, -amount);
}

});

parcelRegister("58cSq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bc7b0320eecfefe$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $kehhj = parcelRequire("kehhj");

var $4LmDH = parcelRequire("4LmDH");
function $3bc7b0320eecfefe$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kehhj.default)(dirtyDate, -amount);
}

});

parcelRegister("4irF8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $320e4d083cefb0bc$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $320e4d083cefb0bc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $6OX6Q.default)(dirtyDate, -amount);
}

});

parcelRegister("lDduA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fbf7b4c4dab20b8b$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $2MTnF = parcelRequire("2MTnF");

var $4LmDH = parcelRequire("4LmDH");
function $fbf7b4c4dab20b8b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $2MTnF.default)(dirtyDate, -amount);
}

});

parcelRegister("lXe7Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ffba10b3e12d8879$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $ffba10b3e12d8879$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, -amount);
}

});

parcelRegister("4UG1B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $393cfda53f7a350f$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $kbDwl = parcelRequire("kbDwl");

var $4LmDH = parcelRequire("4LmDH");
function $393cfda53f7a350f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kbDwl.default)(dirtyDate, -amount);
}

});

parcelRegister("6fhf3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48c184a62f8d0eb5$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48c184a62f8d0eb5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("aABJG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b5a89b8f9188b81$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $7b5a89b8f9188b81$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("kjLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecaa46b9ba4a249b$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ecaa46b9ba4a249b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("34ylv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $23cc632e101f8877$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $23cc632e101f8877$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("eZOMj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aeae26b52a87faed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $aeae26b52a87faed$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("hbMru", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8390a6465ec9630$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $2HjQQ = parcelRequire("2HjQQ");

var $4LmDH = parcelRequire("4LmDH");
var $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK = 604800000;
function $c8390a6465ec9630$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $Ua0Sr.default)(date).getTime() - (0, $2HjQQ.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("Ua0Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8cff7ae633de9e$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $4LmDH = parcelRequire("4LmDH");
function $0a8cff7ae633de9e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $7yBDJ.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7yBDJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5808e7e2a5fbbc4c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("2HjQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6eff01db4e8676$export$2e2bcd8739ae039);

var $i0SQV = parcelRequire("i0SQV");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $1f6eff01db4e8676$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $i0SQV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $Ua0Sr.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("i0SQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d2c6aef0e5f696$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $d1d2c6aef0e5f696$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("4UeRq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3927eb6a31e1659f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3927eb6a31e1659f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("3LPyO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2bedc1b96ccf587f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2bedc1b96ccf587f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("knAHj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ed626c0821295496$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ed626c0821295496$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    return year;
}

});

parcelRegister("2SwgK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2189a7e545f8ece8$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2189a7e545f8ece8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("d0W11", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $979847221b6d59d4$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $979847221b6d59d4$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = (0, $esGEx.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("6mdUF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a0f96fdddaa35da$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4a0f96fdddaa35da$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = (0, $esGEx.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("gpyWg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf2a1543848c0a73$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bf2a1543848c0a73$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = (0, $esGEx.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("cZ2kT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $973cfe686ae8d1d7$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cPszP = parcelRequire("cPszP");

var $4LmDH = parcelRequire("4LmDH");
function $973cfe686ae8d1d7$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = (0, $esGEx.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $cPszP.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("cPszP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95706a37c0d7d1b0$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("fVhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b979d7c80aa6a726$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cZ2kT = parcelRequire("cZ2kT");

var $4LmDH = parcelRequire("4LmDH");
function $b979d7c80aa6a726$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = (0, $esGEx.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $cZ2kT.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("3lKFD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2707890d0f47c3ba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2707890d0f47c3ba$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = (0, $esGEx.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("8v9st", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $63088e2bf3abfc06$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $63088e2bf3abfc06$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("6atcA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $47da542d3f4cabcc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $47da542d3f4cabcc$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("lm2ga", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f8bd67cac91ee19b$export$2e2bcd8739ae039);

var $9vfYB = parcelRequire("9vfYB");

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $cJfMa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $cJfMa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("cJfMa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("1Whvr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1698c992e2cb67cc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("e4h6L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3deb5b5de15b12f$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $9vfYB = parcelRequire("9vfYB");

var $4LmDH = parcelRequire("4LmDH");
var $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK = 604800000;
function $a3deb5b5de15b12f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
    (0, $4LmDH.default)(2, arguments);
    var startOfWeekLeft = (0, $7yBDJ.default)(dirtyDateLeft, dirtyOptions);
    var startOfWeekRight = (0, $7yBDJ.default)(dirtyDateRight, dirtyOptions);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $9vfYB.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $9vfYB.default)(startOfWeekRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("jMhzE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e66021df2494c23e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("5E40x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41c3cc0836893904$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gVPZO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c53a4d8dd17910c2$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c53a4d8dd17910c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6eIgt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48a662f07bb27222$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var cleanDate = (0, $gdr0J.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6uyHy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ba07667a7282b10$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("75XN4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52a761315a8e3e9c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("gd5RE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bcd268c28ce3da9c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bcd268c28ce3da9c$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyLeftDate);
    var dateRight = (0, $gdr0J.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("hjw1k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c9ad0c9b51445ea3$export$2e2bcd8739ae039);

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfDay = (0, $cJfMa.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $cJfMa.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("b27pX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8085a298e92e1718$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("R4xmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09f87854553a6255$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("kggGd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec023d87d9d9e040$export$2e2bcd8739ae039);

var $gVPZO = parcelRequire("gVPZO");

var $4LmDH = parcelRequire("4LmDH");
function $ec023d87d9d9e040$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $gVPZO.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $gVPZO.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("baBa1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $821d7431eba4c146$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("4YTY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a082e1cb0a32433$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("gDwFN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c1c9a216d559c39d$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c1c9a216d559c39d$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $4LmDH.default)(2, arguments);
    var time = (0, $gdr0J.default)(dirtyDate).getTime();
    var startTime = (0, $gdr0J.default)(interval.start).getTime();
    var endTime = (0, $gdr0J.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("auRgN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a460707bf147158$export$2e2bcd8739ae039);

var $15nwl = parcelRequire("15nwl");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $6yoAC = parcelRequire("6yoAC");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $gznWl = parcelRequire("gznWl");

var $4LmDH = parcelRequire("4LmDH");
var $7a460707bf147158$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    (0, $4LmDH.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $15nwl.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $esGEx.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $esGEx.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $gdr0J.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        {
            priority: $7a460707bf147158$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $7a460707bf147158$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
        }
        return substring;
    }).join('').match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && (0, $ebrmh.isProtectedWeekYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && (0, $ebrmh.isProtectedDayOfYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = (0, $gznWl.default)[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === '*' && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $gdr0J.default)(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = (0, $8NlMJ.default)(date, (0, $9vfYB.default)(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            (0, $6yoAC.default)(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $7a460707bf147158$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("6yoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c58fe0eb0761e95$export$2e2bcd8739ae039);
function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}

});

parcelRegister("gznWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1027c3b7f83f29d$export$2e2bcd8739ae039);

var $kB1VM = parcelRequire("kB1VM");

var $hCHMu = parcelRequire("hCHMu");

var $ay6wS = parcelRequire("ay6wS");

var $jIUvX = parcelRequire("jIUvX");

var $aj6ZU = parcelRequire("aj6ZU");

var $bY8nB = parcelRequire("bY8nB");

var $1cqVL = parcelRequire("1cqVL");
var $c1027c3b7f83f29d$var$MILLISECONDS_IN_HOUR = 3600000;
var $c1027c3b7f83f29d$var$MILLISECONDS_IN_MINUTE = 60000;
var $c1027c3b7f83f29d$var$MILLISECONDS_IN_SECOND = 1000;
var $c1027c3b7f83f29d$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $c1027c3b7f83f29d$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $c1027c3b7f83f29d$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $c1027c3b7f83f29d$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $c1027c3b7f83f29d$var$MILLISECONDS_IN_HOUR + minutes * $c1027c3b7f83f29d$var$MILLISECONDS_IN_MINUTE + seconds * $c1027c3b7f83f29d$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string, valueCallback) {
    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $c1027c3b7f83f29d$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $c1027c3b7f83f29d$var$parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $c1027c3b7f83f29d$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $c1027c3b7f83f29d$var$parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $c1027c3b7f83f29d$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $c1027c3b7f83f29d$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $c1027c3b7f83f29d$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $c1027c3b7f83f29d$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $c1027c3b7f83f29d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $c1027c3b7f83f29d$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case 'G':
                case 'GG':
                case 'GGG':
                    return match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
                // A, B
                case 'GGGGG':
                    return match.era(string, {
                        width: 'narrow'
                    });
                // Anno Domini, Before Christ
                case 'GGGG':
                default:
                    return match.era(string, {
                        width: 'wide'
                    }) || match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'yy'
                };
            };
            switch(token){
                case 'y':
                    return $c1027c3b7f83f29d$var$parseNDigits(4, string, valueCallback);
                case 'yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $c1027c3b7f83f29d$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'YY'
                };
            };
            switch(token){
                case 'Y':
                    return $c1027c3b7f83f29d$var$parseNDigits(4, string, valueCallback);
                case 'Yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = (0, $kB1VM.default)(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $c1027c3b7f83f29d$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $1cqVL.default)(date, options);
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return (0, $1cqVL.default)(date, options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'R') return $c1027c3b7f83f29d$var$parseNDigitsSigned(4, string);
            return $c1027c3b7f83f29d$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return (0, $bY8nB.default)(firstWeekOfYear);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'u') return $c1027c3b7f83f29d$var$parseNDigitsSigned(4, string);
            return $c1027c3b7f83f29d$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'Q':
                case 'QQ':
                    // 01, 02, 03, 04
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'Qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'QQQ':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'QQQQQ':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'QQQQ':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'q':
                case 'qq':
                    // 01, 02, 03, 04
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'qqq':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'qqqqq':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'qqqq':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'M':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'MM':
                    return $c1027c3b7f83f29d$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Mo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'MMM':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // J, F, ..., D
                case 'MMMMM':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // January, February, ..., December
                case 'MMMM':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'L':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'LL':
                    return $c1027c3b7f83f29d$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Lo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'LLL':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // J, F, ..., D
                case 'LLLLL':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // January, February, ..., December
                case 'LLLL':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'w':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.week, string);
                case 'wo':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $1cqVL.default)((0, $aj6ZU.default)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'I':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.week, string);
                case 'Io':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $bY8nB.default)((0, $jIUvX.default)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'd':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.date, string);
                case 'do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $c1027c3b7f83f29d$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $c1027c3b7f83f29d$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $c1027c3b7f83f29d$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'D':
                case 'DD':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.dayOfYear, string);
                case 'Do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $c1027c3b7f83f29d$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case 'E':
                case 'EE':
                case 'EEE':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'EEEEE':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'EEEEEE':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'EEEE':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $hCHMu.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'e':
                case 'ee':
                    // 03
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'eo':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'eee':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'eeeee':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'eeeeee':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'eeee':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $hCHMu.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'c':
                case 'cc':
                    // 03
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'co':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'ccc':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // T
                case 'ccccc':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tu
                case 'cccccc':
                    return match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tuesday
                case 'cccc':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $hCHMu.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case 'i':
                case 'ii':
                    // 02
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 2nd
                case 'io':
                    return match.ordinalNumber(string, {
                        unit: 'day'
                    });
                // Tue
                case 'iii':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // T
                case 'iiiii':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tu
                case 'iiiiii':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tuesday
                case 'iiii':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = (0, $ay6wS.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'a':
                case 'aa':
                case 'aaa':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'b':
                case 'bb':
                case 'bbb':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'h':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour12h, string);
                case 'ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'H':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour23h, string);
                case 'Ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'K':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour11h, string);
                case 'Ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'k':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour24h, string);
                case 'ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'm':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.minute, string);
                case 'mo':
                    return match.ordinalNumber(string, {
                        unit: 'minute'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case 's':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.second, string);
                case 'so':
                    return match.ordinalNumber(string, {
                        unit: 'second'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'X':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalMinutes, string);
                case 'XX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basic, string);
                case 'XXXX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalSeconds, string);
                case 'XXXXX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'XXX':
                default:
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'x':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalMinutes, string);
                case 'xx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basic, string);
                case 'xxxx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalSeconds, string);
                case 'xxxxx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'xxx':
                default:
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    }
};
var $c1027c3b7f83f29d$export$2e2bcd8739ae039 = $c1027c3b7f83f29d$var$parsers;

});
parcelRegister("hCHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd47f247bdfd58ed$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, dirtyOptions) {
    (0, $4LmDH.default)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = (0, $esGEx.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("ay6wS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae224ed93d5e7cb$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4LmDH.default)(2, arguments);
    var day = (0, $esGEx.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("jIUvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5bdf6fda1ca18fd$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $jsJZZ = parcelRequire("jsJZZ");

var $4LmDH = parcelRequire("4LmDH");
function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var isoWeek = (0, $esGEx.default)(dirtyISOWeek);
    var diff = (0, $jsJZZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("aj6ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $78111b508c05f859$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $gTlfB = parcelRequire("gTlfB");

var $4LmDH = parcelRequire("4LmDH");
function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var week = (0, $esGEx.default)(dirtyWeek);
    var diff = (0, $gTlfB.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});



parcelRegister("dpjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c2d1611e11d9224$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
var $9c2d1611e11d9224$var$MILLISECONDS_IN_HOUR = 3600000;
var $9c2d1611e11d9224$var$MILLISECONDS_IN_MINUTE = 60000;
var $9c2d1611e11d9224$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $9c2d1611e11d9224$var$DEFAULT_ADDITIONAL_DIGITS : (0, $esGEx.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (isNaN(date) || !date) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time) || time === null) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) {
        dateStrings.date = null;
        timeString = array[0];
    } else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: null
    };
    var year = captures[1] && parseInt(captures[1]);
    var century = captures[2] && parseInt(captures[2]);
    return {
        year: century == null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return null;
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return null; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $9c2d1611e11d9224$var$MILLISECONDS_IN_HOUR + minutes * $9c2d1611e11d9224$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $9c2d1611e11d9224$var$MILLISECONDS_IN_HOUR + minutes * $9c2d1611e11d9224$var$MILLISECONDS_IN_MINUTE);
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("hL3CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $ced9a37f3aaca250$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $ced9a37f3aaca250$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $ced9a37f3aaca250$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ced9a37f3aaca250$var$_setPrototypeOf(subClass, superClass);
}
function $ced9a37f3aaca250$var$_setPrototypeOf(o, p) {
    $ced9a37f3aaca250$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ced9a37f3aaca250$var$_setPrototypeOf(o, p);
}
function $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ced9a37f3aaca250$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $ced9a37f3aaca250$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $ced9a37f3aaca250$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $ced9a37f3aaca250$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $ced9a37f3aaca250$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $ced9a37f3aaca250$var$uid = $ced9a37f3aaca250$var$autoInc();
var $ced9a37f3aaca250$var$passiveEventSupport;
var $ced9a37f3aaca250$var$handlersMap = {};
var $ced9a37f3aaca250$var$enabledInstances = {};
var $ced9a37f3aaca250$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $ced9a37f3aaca250$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $ced9a37f3aaca250$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = $ced9a37f3aaca250$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $ced9a37f3aaca250$var$passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $ced9a37f3aaca250$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $ced9a37f3aaca250$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $1u0KT.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $ced9a37f3aaca250$var$enabledInstances[_this._uid]) return;
                if (typeof $ced9a37f3aaca250$var$passiveEventSupport === 'undefined') $ced9a37f3aaca250$var$passiveEventSupport = $ced9a37f3aaca250$var$testPassiveEventSupport();
                $ced9a37f3aaca250$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $ced9a37f3aaca250$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $ced9a37f3aaca250$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($ced9a37f3aaca250$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $ced9a37f3aaca250$var$handlersMap[_this._uid], $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $ced9a37f3aaca250$var$enabledInstances[_this._uid];
                var fn = $ced9a37f3aaca250$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $ced9a37f3aaca250$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $ced9a37f3aaca250$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $acw62.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $acw62.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $ced9a37f3aaca250$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $ced9a37f3aaca250$export$2e2bcd8739ae039 = $ced9a37f3aaca250$var$onClickOutsideHOC;

});

parcelRegister("7tYfQ", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("3cbhK")).Popper);
$parcel$export(module.exports, "Manager", () => (parcelRequire("8j0J5")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("6KgD0")).Reference);
$parcel$export(module.exports, "usePopper", () => (parcelRequire("KNTYF")).usePopper);
// Public components

var $3cbhK = parcelRequire("3cbhK");

var $8j0J5 = parcelRequire("8j0J5");

var $6KgD0 = parcelRequire("6KgD0");

var $KNTYF = parcelRequire("KNTYF");
 // Public types

});
parcelRegister("3cbhK", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $253b3f1d15d57500$export$badac9ada3a0bdf9);

var $acw62 = parcelRequire("acw62");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");

var $KNTYF = parcelRequire("KNTYF");
var $253b3f1d15d57500$var$NOOP = function NOOP() {
    return void 0;
};
var $253b3f1d15d57500$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $253b3f1d15d57500$var$EMPTY_MODIFIERS = [];
function $253b3f1d15d57500$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $253b3f1d15d57500$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $8j0J5.ManagerReferenceNodeContext));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $buXxn.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $KNTYF.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $253b3f1d15d57500$var$NOOP,
            update: update || $253b3f1d15d57500$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $buXxn.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("8j0J5", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $60c0a9468407f91d$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $60c0a9468407f91d$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $60c0a9468407f91d$export$d0d38e7dec7a1a61);

var $acw62 = parcelRequire("acw62");
var $60c0a9468407f91d$export$3dbd3405086fec7b = $acw62.createContext();
var $60c0a9468407f91d$export$cbabb21c2529b130 = $acw62.createContext();
function $60c0a9468407f91d$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("buXxn", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $85f0adf197ea687e$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $85f0adf197ea687e$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $85f0adf197ea687e$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $85f0adf197ea687e$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $85f0adf197ea687e$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $85f0adf197ea687e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $85f0adf197ea687e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $85f0adf197ea687e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $85f0adf197ea687e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $85f0adf197ea687e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $85f0adf197ea687e$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("KNTYF", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $08cb017687258e89$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $buXxn = parcelRequire("buXxn");
var $08cb017687258e89$var$EMPTY_MODIFIERS = [];
var $08cb017687258e89$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $08cb017687258e89$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                setState({
                    styles: (0, $buXxn.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.styles[element] || {}
                        ];
                    })),
                    attributes: (0, $buXxn.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.attributes[element]
                        ];
                    }))
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");


var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");




var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");

var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = rect.width / element.offsetWidth || 1;
    var scaleY = rect.height / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
var $2ef6a598263dba8e$var$round = Math.round;
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $93iQ7.isHTMLElement)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = rect.width / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = rect.height / offsetHeight || 1;
    }
    return {
        width: $2ef6a598263dba8e$var$round(rect.width / scaleX),
        height: $2ef6a598263dba8e$var$round(rect.height / scaleY),
        top: $2ef6a598263dba8e$var$round(rect.top / scaleY),
        right: $2ef6a598263dba8e$var$round(rect.right / scaleX),
        bottom: $2ef6a598263dba8e$var$round(rect.bottom / scaleY),
        left: $2ef6a598263dba8e$var$round(rect.left / scaleX),
        x: $2ef6a598263dba8e$var$round(rect.left / scaleX),
        y: $2ef6a598263dba8e$var$round(rect.top / scaleY)
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)((0, $4J8n1.round)(x * dpr) / dpr) || 0,
        y: (0, $4J8n1.round)((0, $4J8n1.round)(y * dpr) / dpr) || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets;
    var _ref3 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets, _ref3$x = _ref3.x, x = _ref3$x === void 0 ? 0 : _ref3$x, _ref3$y = _ref3.y, y = _ref3$y === void 0 ? 0 : _ref3$y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom); // $FlowFixMe[prop-missing]
            y -= offsetParent[heightProp] - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right); // $FlowFixMe[prop-missing]
            x -= offsetParent[widthProp] - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref4) {
    var state = _ref4.state, options = _ref4.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});
parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});


parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element) {
    var rect = (0, $41Z5W.default)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element)) : (0, $93iQ7.isHTMLElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis || checkAltAxis) {
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = popperOffsets[mainAxis] + overflow[mainSide];
        var max = popperOffsets[mainAxis] - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.default)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
        var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
        if (checkMainAxis) {
            var preventedOffset = (0, $cOvrb.default)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
            var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
            var _offset = popperOffsets[altAxis];
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var _preventedOffset = (0, $cOvrb.default)(tether ? (0, $4J8n1.min)(_min, tetherMin) : _min, _offset, tether ? (0, $4J8n1.max)(_max, tetherMax) : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $95428a5e75015184$export$2e2bcd8739ae039);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$2e2bcd8739ae039(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");

var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.default)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("ai2Pb", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
var $77ddc6be16b1d7de$var$hasMap = typeof Map === 'function';
var $77ddc6be16b1d7de$var$hasSet = typeof Set === 'function';
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("6KgD0", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $4e93effa1fe7e7cd$export$e0be378c32fb70a7);

var $acw62 = parcelRequire("acw62");

var $kg9aN = parcelRequire("kg9aN");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");
function $4e93effa1fe7e7cd$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $8j0J5.ManagerReferenceNodeSetterContext));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $buXxn.setRef)(innerRef, node);
        (0, $buXxn.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    $acw62.useEffect(function() {
        return function() {
            return (0, $buXxn.setRef)(innerRef, null);
        };
    });
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $buXxn.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("kg9aN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $ebfc6adce9fdacf8$var$warning;

});



parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
'use strict';

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});

parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
'use strict';

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("30Ie1"));

});


parcelRegister("5iEZS", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $3dbe6f53ee61e43d$export$a7c73072b1a182ae, (v) => $3dbe6f53ee61e43d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3dbe6f53ee61e43d$export$9f27bc3417b4524d, (v) => $3dbe6f53ee61e43d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3dbe6f53ee61e43d$export$db77ccec0bb4ccac, (v) => $3dbe6f53ee61e43d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3dbe6f53ee61e43d$export$8392c0c9d3dcbd35, (v) => $3dbe6f53ee61e43d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3dbe6f53ee61e43d$export$ffb0004e005737fa, (v) => $3dbe6f53ee61e43d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3dbe6f53ee61e43d$export$b624eff549462981, (v) => $3dbe6f53ee61e43d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3dbe6f53ee61e43d$export$7897aa7841a5380c, (v) => $3dbe6f53ee61e43d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3dbe6f53ee61e43d$export$602eac185826482c, (v) => $3dbe6f53ee61e43d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3dbe6f53ee61e43d$export$e2c29f18771995cb, (v) => $3dbe6f53ee61e43d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3dbe6f53ee61e43d$export$5f8d39834fd61797, (v) => $3dbe6f53ee61e43d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3dbe6f53ee61e43d$export$74bf444e3cd11ea5, (v) => $3dbe6f53ee61e43d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $3dbe6f53ee61e43d$export$998bcd577473dd93, (v) => $3dbe6f53ee61e43d$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $3dbe6f53ee61e43d$export$92387174baf9b227, (v) => $3dbe6f53ee61e43d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $3dbe6f53ee61e43d$export$ec112efeb987d9c6, (v) => $3dbe6f53ee61e43d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3dbe6f53ee61e43d$export$b706b080d889d2c9, (v) => $3dbe6f53ee61e43d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3dbe6f53ee61e43d$export$5be5a87408f70ddc, (v) => $3dbe6f53ee61e43d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3dbe6f53ee61e43d$export$45a5e7f76e0caa8d, (v) => $3dbe6f53ee61e43d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3dbe6f53ee61e43d$export$455c2e768291efa6, (v) => $3dbe6f53ee61e43d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3dbe6f53ee61e43d$export$9522e17588c12572, (v) => $3dbe6f53ee61e43d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3dbe6f53ee61e43d$export$2110ac352bb060b9, (v) => $3dbe6f53ee61e43d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3dbe6f53ee61e43d$export$56885ab8b9c456ab, (v) => $3dbe6f53ee61e43d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3dbe6f53ee61e43d$export$d927fcb6adf8f9de, (v) => $3dbe6f53ee61e43d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3dbe6f53ee61e43d$export$b82d16f27459e05a, (v) => $3dbe6f53ee61e43d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3dbe6f53ee61e43d$export$522c17b4f5e123e8, (v) => $3dbe6f53ee61e43d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3dbe6f53ee61e43d$export$1aabd8a0274ecfd6, (v) => $3dbe6f53ee61e43d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $3dbe6f53ee61e43d$export$3d6c20d97e46b957, (v) => $3dbe6f53ee61e43d$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $3dbe6f53ee61e43d$export$9b621391a187a31a, (v) => $3dbe6f53ee61e43d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3dbe6f53ee61e43d$export$f5bbd400c2f4426f, (v) => $3dbe6f53ee61e43d$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3dbe6f53ee61e43d$export$a7c73072b1a182ae;
var $3dbe6f53ee61e43d$export$9f27bc3417b4524d;
var $3dbe6f53ee61e43d$export$db77ccec0bb4ccac;
var $3dbe6f53ee61e43d$export$8392c0c9d3dcbd35;
var $3dbe6f53ee61e43d$export$ffb0004e005737fa;
var $3dbe6f53ee61e43d$export$b624eff549462981;
var $3dbe6f53ee61e43d$export$7897aa7841a5380c;
var $3dbe6f53ee61e43d$export$602eac185826482c;
var $3dbe6f53ee61e43d$export$e2c29f18771995cb;
var $3dbe6f53ee61e43d$export$5f8d39834fd61797;
var $3dbe6f53ee61e43d$export$74bf444e3cd11ea5;
var $3dbe6f53ee61e43d$export$998bcd577473dd93;
var $3dbe6f53ee61e43d$export$92387174baf9b227;
var $3dbe6f53ee61e43d$export$ec112efeb987d9c6;
var $3dbe6f53ee61e43d$export$b706b080d889d2c9;
var $3dbe6f53ee61e43d$export$5be5a87408f70ddc;
var $3dbe6f53ee61e43d$export$45a5e7f76e0caa8d;
var $3dbe6f53ee61e43d$export$455c2e768291efa6;
var $3dbe6f53ee61e43d$export$9522e17588c12572;
var $3dbe6f53ee61e43d$export$2110ac352bb060b9;
var $3dbe6f53ee61e43d$export$56885ab8b9c456ab;
var $3dbe6f53ee61e43d$export$d927fcb6adf8f9de;
var $3dbe6f53ee61e43d$export$b82d16f27459e05a;
var $3dbe6f53ee61e43d$export$522c17b4f5e123e8;
var $3dbe6f53ee61e43d$export$1aabd8a0274ecfd6;
var $3dbe6f53ee61e43d$export$3d6c20d97e46b957;
var $3dbe6f53ee61e43d$export$9b621391a187a31a;
var $3dbe6f53ee61e43d$export$f5bbd400c2f4426f;
'use strict';
var $3dbe6f53ee61e43d$var$b = Symbol.for("react.element"), $3dbe6f53ee61e43d$var$c = Symbol.for("react.portal"), $3dbe6f53ee61e43d$var$d = Symbol.for("react.fragment"), $3dbe6f53ee61e43d$var$e = Symbol.for("react.strict_mode"), $3dbe6f53ee61e43d$var$f = Symbol.for("react.profiler"), $3dbe6f53ee61e43d$var$g = Symbol.for("react.provider"), $3dbe6f53ee61e43d$var$h = Symbol.for("react.context"), $3dbe6f53ee61e43d$var$k = Symbol.for("react.server_context"), $3dbe6f53ee61e43d$var$l = Symbol.for("react.forward_ref"), $3dbe6f53ee61e43d$var$m = Symbol.for("react.suspense"), $3dbe6f53ee61e43d$var$n = Symbol.for("react.suspense_list"), $3dbe6f53ee61e43d$var$p = Symbol.for("react.memo"), $3dbe6f53ee61e43d$var$q = Symbol.for("react.lazy"), $3dbe6f53ee61e43d$var$t = Symbol.for("react.offscreen"), $3dbe6f53ee61e43d$var$u;
$3dbe6f53ee61e43d$var$u = Symbol.for("react.module.reference");
function $3dbe6f53ee61e43d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $3dbe6f53ee61e43d$var$b:
                switch(a = a.type, a){
                    case $3dbe6f53ee61e43d$var$d:
                    case $3dbe6f53ee61e43d$var$f:
                    case $3dbe6f53ee61e43d$var$e:
                    case $3dbe6f53ee61e43d$var$m:
                    case $3dbe6f53ee61e43d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3dbe6f53ee61e43d$var$k:
                            case $3dbe6f53ee61e43d$var$h:
                            case $3dbe6f53ee61e43d$var$l:
                            case $3dbe6f53ee61e43d$var$q:
                            case $3dbe6f53ee61e43d$var$p:
                            case $3dbe6f53ee61e43d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $3dbe6f53ee61e43d$var$c:
                return r;
        }
    }
}
$3dbe6f53ee61e43d$export$a7c73072b1a182ae = $3dbe6f53ee61e43d$var$h;
$3dbe6f53ee61e43d$export$9f27bc3417b4524d = $3dbe6f53ee61e43d$var$g;
$3dbe6f53ee61e43d$export$db77ccec0bb4ccac = $3dbe6f53ee61e43d$var$b;
$3dbe6f53ee61e43d$export$8392c0c9d3dcbd35 = $3dbe6f53ee61e43d$var$l;
$3dbe6f53ee61e43d$export$ffb0004e005737fa = $3dbe6f53ee61e43d$var$d;
$3dbe6f53ee61e43d$export$b624eff549462981 = $3dbe6f53ee61e43d$var$q;
$3dbe6f53ee61e43d$export$7897aa7841a5380c = $3dbe6f53ee61e43d$var$p;
$3dbe6f53ee61e43d$export$602eac185826482c = $3dbe6f53ee61e43d$var$c;
$3dbe6f53ee61e43d$export$e2c29f18771995cb = $3dbe6f53ee61e43d$var$f;
$3dbe6f53ee61e43d$export$5f8d39834fd61797 = $3dbe6f53ee61e43d$var$e;
$3dbe6f53ee61e43d$export$74bf444e3cd11ea5 = $3dbe6f53ee61e43d$var$m;
$3dbe6f53ee61e43d$export$998bcd577473dd93 = $3dbe6f53ee61e43d$var$n;
$3dbe6f53ee61e43d$export$92387174baf9b227 = function() {
    return !1;
};
$3dbe6f53ee61e43d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3dbe6f53ee61e43d$export$b706b080d889d2c9 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$h;
};
$3dbe6f53ee61e43d$export$5be5a87408f70ddc = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$g;
};
$3dbe6f53ee61e43d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3dbe6f53ee61e43d$var$b;
};
$3dbe6f53ee61e43d$export$455c2e768291efa6 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$l;
};
$3dbe6f53ee61e43d$export$9522e17588c12572 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$d;
};
$3dbe6f53ee61e43d$export$2110ac352bb060b9 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$q;
};
$3dbe6f53ee61e43d$export$56885ab8b9c456ab = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$p;
};
$3dbe6f53ee61e43d$export$d927fcb6adf8f9de = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$c;
};
$3dbe6f53ee61e43d$export$b82d16f27459e05a = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$f;
};
$3dbe6f53ee61e43d$export$522c17b4f5e123e8 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$e;
};
$3dbe6f53ee61e43d$export$1aabd8a0274ecfd6 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$m;
};
$3dbe6f53ee61e43d$export$3d6c20d97e46b957 = function(a) {
    return $3dbe6f53ee61e43d$var$v(a) === $3dbe6f53ee61e43d$var$n;
};
$3dbe6f53ee61e43d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3dbe6f53ee61e43d$var$d || a === $3dbe6f53ee61e43d$var$f || a === $3dbe6f53ee61e43d$var$e || a === $3dbe6f53ee61e43d$var$m || a === $3dbe6f53ee61e43d$var$n || a === $3dbe6f53ee61e43d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $3dbe6f53ee61e43d$var$q || a.$$typeof === $3dbe6f53ee61e43d$var$p || a.$$typeof === $3dbe6f53ee61e43d$var$g || a.$$typeof === $3dbe6f53ee61e43d$var$h || a.$$typeof === $3dbe6f53ee61e43d$var$l || a.$$typeof === $3dbe6f53ee61e43d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$3dbe6f53ee61e43d$export$f5bbd400c2f4426f = $3dbe6f53ee61e43d$var$v;

});

parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);

var $acw62 = parcelRequire("acw62");

var $7yeFe = parcelRequire("7yeFe");

var $cCVp3 = parcelRequire("cCVp3");

var $3rtvu = parcelRequire("3rtvu");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9RYKL = parcelRequire("9RYKL");

var $9ORqK = parcelRequire("9ORqK");

var $chB0Q = parcelRequire("chB0Q");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, $acw62.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cCVp3.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cCVp3.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cCVp3.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $9RYKL.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false);
            return (0, $acw62.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
                var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($7yeFe)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false);
        !!(component && render) && (0, $9RYKL.default)(false);
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("7yeFe", function(module, exports) {
'use strict';
var $57f7155c0a7db2ad$var$isArray = Array.isArray;
var $57f7155c0a7db2ad$var$keyList = Object.keys;
var $57f7155c0a7db2ad$var$hasProp = Object.prototype.hasOwnProperty;
var $57f7155c0a7db2ad$var$hasElementType = typeof Element !== 'undefined';
function $57f7155c0a7db2ad$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $57f7155c0a7db2ad$var$isArray(a), arrB = $57f7155c0a7db2ad$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$57f7155c0a7db2ad$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $57f7155c0a7db2ad$var$keyList(a);
        length = keys.length;
        if (length !== $57f7155c0a7db2ad$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$57f7155c0a7db2ad$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($57f7155c0a7db2ad$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$57f7155c0a7db2ad$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $57f7155c0a7db2ad$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("cCVp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93158fb633685272$export$2e2bcd8739ae039);
var $93158fb633685272$var$isMergeableObject = function isMergeableObject(value) {
    return $93158fb633685272$var$isNonNullObject(value) && !$93158fb633685272$var$isSpecial(value);
};
function $93158fb633685272$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $93158fb633685272$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $93158fb633685272$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $93158fb633685272$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $93158fb633685272$var$REACT_ELEMENT_TYPE = $93158fb633685272$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $93158fb633685272$var$isReactElement(value) {
    return value.$$typeof === $93158fb633685272$var$REACT_ELEMENT_TYPE;
}
function $93158fb633685272$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $93158fb633685272$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $93158fb633685272$var$deepmerge($93158fb633685272$var$emptyTarget(value), value, options) : value;
}
function $93158fb633685272$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $93158fb633685272$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $93158fb633685272$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $93158fb633685272$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $93158fb633685272$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $93158fb633685272$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $93158fb633685272$var$mergeObject(target, source, options);
}
$93158fb633685272$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $93158fb633685272$var$deepmerge(prev, next, options);
    }, {});
};
var $93158fb633685272$var$deepmerge_1 = $93158fb633685272$var$deepmerge;
var $93158fb633685272$export$2e2bcd8739ae039 = $93158fb633685272$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = '[object Arguments]', $bc81bf84e8d65dab$var$arrayTag = '[object Array]', $bc81bf84e8d65dab$var$boolTag = '[object Boolean]', $bc81bf84e8d65dab$var$dateTag = '[object Date]', $bc81bf84e8d65dab$var$errorTag = '[object Error]', $bc81bf84e8d65dab$var$funcTag = '[object Function]', $bc81bf84e8d65dab$var$genTag = '[object GeneratorFunction]', $bc81bf84e8d65dab$var$mapTag = '[object Map]', $bc81bf84e8d65dab$var$numberTag = '[object Number]', $bc81bf84e8d65dab$var$objectTag = '[object Object]', $bc81bf84e8d65dab$var$regexpTag = '[object RegExp]', $bc81bf84e8d65dab$var$setTag = '[object Set]', $bc81bf84e8d65dab$var$stringTag = '[object String]', $bc81bf84e8d65dab$var$symbolTag = '[object Symbol]', $bc81bf84e8d65dab$var$weakMapTag = '[object WeakMap]';
var $bc81bf84e8d65dab$var$arrayBufferTag = '[object ArrayBuffer]', $bc81bf84e8d65dab$var$dataViewTag = '[object DataView]', $bc81bf84e8d65dab$var$float32Tag = '[object Float32Array]', $bc81bf84e8d65dab$var$float64Tag = '[object Float64Array]', $bc81bf84e8d65dab$var$int8Tag = '[object Int8Array]', $bc81bf84e8d65dab$var$int16Tag = '[object Int16Array]', $bc81bf84e8d65dab$var$int32Tag = '[object Int32Array]', $bc81bf84e8d65dab$var$uint8Tag = '[object Uint8Array]', $bc81bf84e8d65dab$var$uint8ClampedTag = '[object Uint8ClampedArray]', $bc81bf84e8d65dab$var$uint16Tag = '[object Uint16Array]', $bc81bf84e8d65dab$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype['delete'] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype['delete'] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), 'Map');
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp('^' + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = '[object AsyncFunction]', $397b12740d7995ef$var$funcTag = '[object Function]', $397b12740d7995ef$var$genTag = '[object GeneratorFunction]', $397b12740d7995ef$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)['__core-js_shared__'];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype['delete'] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $lSo3Y.default),
        'map': new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        'string': new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype['delete'] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, 'create');
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, 'callee') && !$44fca59879666c41$var$propertyIsEnumerable.call(value, 'callee');
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = '[object Arguments]', $a51ff94e4fd33486$var$arrayTag = '[object Array]', $a51ff94e4fd33486$var$boolTag = '[object Boolean]', $a51ff94e4fd33486$var$dateTag = '[object Date]', $a51ff94e4fd33486$var$errorTag = '[object Error]', $a51ff94e4fd33486$var$funcTag = '[object Function]', $a51ff94e4fd33486$var$mapTag = '[object Map]', $a51ff94e4fd33486$var$numberTag = '[object Number]', $a51ff94e4fd33486$var$objectTag = '[object Object]', $a51ff94e4fd33486$var$regexpTag = '[object RegExp]', $a51ff94e4fd33486$var$setTag = '[object Set]', $a51ff94e4fd33486$var$stringTag = '[object String]', $a51ff94e4fd33486$var$weakMapTag = '[object WeakMap]';
var $a51ff94e4fd33486$var$arrayBufferTag = '[object ArrayBuffer]', $a51ff94e4fd33486$var$dataViewTag = '[object DataView]', $a51ff94e4fd33486$var$float32Tag = '[object Float32Array]', $a51ff94e4fd33486$var$float64Tag = '[object Float64Array]', $a51ff94e4fd33486$var$int8Tag = '[object Int8Array]', $a51ff94e4fd33486$var$int16Tag = '[object Int16Array]', $a51ff94e4fd33486$var$int32Tag = '[object Int32Array]', $a51ff94e4fd33486$var$uint8Tag = '[object Uint8Array]', $a51ff94e4fd33486$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a51ff94e4fd33486$var$uint16Tag = '[object Uint16Array]', $a51ff94e4fd33486$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = '[object Map]', $34aa59a61c7ccccb$var$objectTag = '[object Object]', $34aa59a61c7ccccb$var$promiseTag = '[object Promise]', $34aa59a61c7ccccb$var$setTag = '[object Set]', $34aa59a61c7ccccb$var$weakMapTag = '[object WeakMap]';
var $34aa59a61c7ccccb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), 'DataView');
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), 'Promise');
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), 'Set');
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), 'WeakMap');
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7103088c29fc4f0b$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = '[object Boolean]', $d8c6c80dd3650253$var$dateTag = '[object Date]', $d8c6c80dd3650253$var$mapTag = '[object Map]', $d8c6c80dd3650253$var$numberTag = '[object Number]', $d8c6c80dd3650253$var$regexpTag = '[object RegExp]', $d8c6c80dd3650253$var$setTag = '[object Set]', $d8c6c80dd3650253$var$stringTag = '[object String]', $d8c6c80dd3650253$var$symbolTag = '[object Symbol]';
var $d8c6c80dd3650253$var$arrayBufferTag = '[object ArrayBuffer]', $d8c6c80dd3650253$var$dataViewTag = '[object DataView]', $d8c6c80dd3650253$var$float32Tag = '[object Float32Array]', $d8c6c80dd3650253$var$float64Tag = '[object Float64Array]', $d8c6c80dd3650253$var$int8Tag = '[object Int8Array]', $d8c6c80dd3650253$var$int16Tag = '[object Int16Array]', $d8c6c80dd3650253$var$int32Tag = '[object Int32Array]', $d8c6c80dd3650253$var$uint8Tag = '[object Uint8Array]', $d8c6c80dd3650253$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d8c6c80dd3650253$var$uint16Tag = '[object Uint16Array]', $d8c6c80dd3650253$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == 'string' || (0, $1WN0o.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? '-0' : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? '' : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + '';
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? '-0' : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});


parcelRegister("k4mSs", function(module, exports) {
'use strict';

var $c1WOw = parcelRequire("c1WOw");

var $lyUht = parcelRequire("lyUht");

var $a3ZNN = parcelRequire("a3ZNN");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $e9c5ed5b799343e5$var$clusterWorkerId = (parcelRequire("fdgZy")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $e9c5ed5b799343e5$var$seed(seedValue) {
    $c1WOw.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $e9c5ed5b799343e5$var$worker(workerId) {
    $e9c5ed5b799343e5$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $e9c5ed5b799343e5$var$characters(newCharacters) {
    if (newCharacters !== undefined) $c1WOw.characters(newCharacters);
    return $c1WOw.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $e9c5ed5b799343e5$var$generate() {
    return $lyUht($e9c5ed5b799343e5$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $e9c5ed5b799343e5$var$generate;
module.exports.generate = $e9c5ed5b799343e5$var$generate;
module.exports.seed = $e9c5ed5b799343e5$var$seed;
module.exports.worker = $e9c5ed5b799343e5$var$worker;
module.exports.characters = $e9c5ed5b799343e5$var$characters;
module.exports.isValid = $a3ZNN;

});
parcelRegister("c1WOw", function(module, exports) {
'use strict';

var $9QMEO = parcelRequire("9QMEO");
var $8c23333828cc3125$var$ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var $8c23333828cc3125$var$alphabet;
var $8c23333828cc3125$var$previousSeed;
var $8c23333828cc3125$var$shuffled;
function $8c23333828cc3125$var$reset() {
    $8c23333828cc3125$var$shuffled = false;
}
function $8c23333828cc3125$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($8c23333828cc3125$var$alphabet !== $8c23333828cc3125$var$ORIGINAL) {
            $8c23333828cc3125$var$alphabet = $8c23333828cc3125$var$ORIGINAL;
            $8c23333828cc3125$var$reset();
        }
        return;
    }
    if (_alphabet_ === $8c23333828cc3125$var$alphabet) return;
    if (_alphabet_.length !== $8c23333828cc3125$var$ORIGINAL.length) throw new Error('Custom alphabet for shortid must be ' + $8c23333828cc3125$var$ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    var unique = _alphabet_.split('').filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error('Custom alphabet for shortid must be ' + $8c23333828cc3125$var$ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    $8c23333828cc3125$var$alphabet = _alphabet_;
    $8c23333828cc3125$var$reset();
}
function $8c23333828cc3125$var$characters(_alphabet_) {
    $8c23333828cc3125$var$setCharacters(_alphabet_);
    return $8c23333828cc3125$var$alphabet;
}
function $8c23333828cc3125$var$setSeed(seed) {
    $9QMEO.seed(seed);
    if ($8c23333828cc3125$var$previousSeed !== seed) {
        $8c23333828cc3125$var$reset();
        $8c23333828cc3125$var$previousSeed = seed;
    }
}
function $8c23333828cc3125$var$shuffle() {
    if (!$8c23333828cc3125$var$alphabet) $8c23333828cc3125$var$setCharacters($8c23333828cc3125$var$ORIGINAL);
    var sourceArray = $8c23333828cc3125$var$alphabet.split('');
    var targetArray = [];
    var r = $9QMEO.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $9QMEO.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}
function $8c23333828cc3125$var$getShuffled() {
    if ($8c23333828cc3125$var$shuffled) return $8c23333828cc3125$var$shuffled;
    $8c23333828cc3125$var$shuffled = $8c23333828cc3125$var$shuffle();
    return $8c23333828cc3125$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $8c23333828cc3125$var$lookup(index) {
    var alphabetShuffled = $8c23333828cc3125$var$getShuffled();
    return alphabetShuffled[index];
}
function $8c23333828cc3125$var$get() {
    return $8c23333828cc3125$var$alphabet || $8c23333828cc3125$var$ORIGINAL;
}
module.exports = {
    get: $8c23333828cc3125$var$get,
    characters: $8c23333828cc3125$var$characters,
    seed: $8c23333828cc3125$var$setSeed,
    lookup: $8c23333828cc3125$var$lookup,
    shuffled: $8c23333828cc3125$var$getShuffled
};

});
parcelRegister("9QMEO", function(module, exports) {
'use strict';
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $72beb6ba744b7542$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $72beb6ba744b7542$var$getNextValue() {
    $72beb6ba744b7542$var$seed = ($72beb6ba744b7542$var$seed * 9301 + 49297) % 233280;
    return $72beb6ba744b7542$var$seed / 233280.0;
}
function $72beb6ba744b7542$var$setSeed(_seed_) {
    $72beb6ba744b7542$var$seed = _seed_;
}
module.exports = {
    nextValue: $72beb6ba744b7542$var$getNextValue,
    seed: $72beb6ba744b7542$var$setSeed
};

});


parcelRegister("lyUht", function(module, exports) {
'use strict';

var $ajyTY = parcelRequire("ajyTY");
parcelRequire("c1WOw");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $fb286e221af32807$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $fb286e221af32807$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $fb286e221af32807$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $fb286e221af32807$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $fb286e221af32807$var$build(clusterWorkerId) {
    var str = '';
    var seconds = Math.floor((Date.now() - $fb286e221af32807$var$REDUCE_TIME) * 0.001);
    if (seconds === $fb286e221af32807$var$previousSeconds) $fb286e221af32807$var$counter++;
    else {
        $fb286e221af32807$var$counter = 0;
        $fb286e221af32807$var$previousSeconds = seconds;
    }
    str = str + $ajyTY($fb286e221af32807$var$version);
    str = str + $ajyTY(clusterWorkerId);
    if ($fb286e221af32807$var$counter > 0) str = str + $ajyTY($fb286e221af32807$var$counter);
    str = str + $ajyTY(seconds);
    return str;
}
module.exports = $fb286e221af32807$var$build;

});
parcelRegister("ajyTY", function(module, exports) {
'use strict';

var $c1WOw = parcelRequire("c1WOw");

var $hjtYC = parcelRequire("hjtYC");

var $fkOdF = parcelRequire("fkOdF");
function $7826c07ea7f5db37$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = '';
    while(!done){
        str = str + $fkOdF($hjtYC, $c1WOw.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $7826c07ea7f5db37$var$generate;

});
parcelRegister("hjtYC", function(module, exports) {
'use strict';
var $c9ab76c51769857c$var$crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $c9ab76c51769857c$var$randomByte;
if (!$c9ab76c51769857c$var$crypto || !$c9ab76c51769857c$var$crypto.getRandomValues) $c9ab76c51769857c$var$randomByte = function(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $c9ab76c51769857c$var$randomByte = function(size) {
    return $c9ab76c51769857c$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $c9ab76c51769857c$var$randomByte;

});

parcelRegister("fkOdF", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = '';
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || '';
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("a3ZNN", function(module, exports) {
'use strict';

var $c1WOw = parcelRequire("c1WOw");
function $753a1fd6a37c913c$var$isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6) return false;
    var nonAlphabetic = new RegExp('[^' + $c1WOw.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') + ']');
    return !nonAlphabetic.test(id);
}
module.exports = $753a1fd6a37c913c$var$isShortId;

});

parcelRegister("fdgZy", function(module, exports) {
'use strict';
module.exports = 0;

});


parcelRegister("7we3r", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
'use strict';

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url
        }));
    };
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($gKvUL.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + '=' + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("7L4QX", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("lJY4v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, 'Accept');
            $kiL6T(headers, 'Content-Type');
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$gKvUL.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("at5cb", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        if (($gKvUL.isBlob(requestData) || $gKvUL.isFile(requestData)) && requestData.type) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = unescape(encodeURIComponent(config.auth.password)) || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
'use strict';

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
'use strict';

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRegister("8v8A7", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8JRzs", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push('path=' + path);
            if ($gKvUL.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
'use strict';

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lk5EI", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("4Tkeq", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
'use strict';

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRegister("3odmW", function(module, exports) {
/** @license React v16.14.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8coUR = parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$q(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$t = "function" === typeof Symbol && Symbol.for, $277dfbc9b64034b1$var$aa = $277dfbc9b64034b1$var$t ? Symbol.for("react.portal") : 60106, $277dfbc9b64034b1$var$u = $277dfbc9b64034b1$var$t ? Symbol.for("react.fragment") : 60107, $277dfbc9b64034b1$var$ba = $277dfbc9b64034b1$var$t ? Symbol.for("react.strict_mode") : 60108, $277dfbc9b64034b1$var$ca = $277dfbc9b64034b1$var$t ? Symbol.for("react.profiler") : 60114, $277dfbc9b64034b1$var$v = $277dfbc9b64034b1$var$t ? Symbol.for("react.provider") : 60109, $277dfbc9b64034b1$var$da = $277dfbc9b64034b1$var$t ? Symbol.for("react.context") : 60110, $277dfbc9b64034b1$var$ea = $277dfbc9b64034b1$var$t ? Symbol.for("react.concurrent_mode") : 60111, $277dfbc9b64034b1$var$fa = $277dfbc9b64034b1$var$t ? Symbol.for("react.forward_ref") : 60112, $277dfbc9b64034b1$var$B = $277dfbc9b64034b1$var$t ? Symbol.for("react.suspense") : 60113, $277dfbc9b64034b1$var$ha = $277dfbc9b64034b1$var$t ? Symbol.for("react.suspense_list") : 60120, $277dfbc9b64034b1$var$ia = $277dfbc9b64034b1$var$t ? Symbol.for("react.memo") : 60115, $277dfbc9b64034b1$var$ja = $277dfbc9b64034b1$var$t ? Symbol.for("react.lazy") : 60116, $277dfbc9b64034b1$var$ka = $277dfbc9b64034b1$var$t ? Symbol.for("react.block") : 60121, $277dfbc9b64034b1$var$la = $277dfbc9b64034b1$var$t ? Symbol.for("react.fundamental") : 60117, $277dfbc9b64034b1$var$ma = $277dfbc9b64034b1$var$t ? Symbol.for("react.scope") : 60119;
function $277dfbc9b64034b1$var$na(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(c) {
            0 === a._status && (c = c.default, a._status = 1, a._result = c);
        }, function(c) {
            0 === a._status && (a._status = 2, a._result = c);
        });
    }
}
function $277dfbc9b64034b1$var$C(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$u:
            return "Fragment";
        case $277dfbc9b64034b1$var$aa:
            return "Portal";
        case $277dfbc9b64034b1$var$ca:
            return "Profiler";
        case $277dfbc9b64034b1$var$ba:
            return "StrictMode";
        case $277dfbc9b64034b1$var$B:
            return "Suspense";
        case $277dfbc9b64034b1$var$ha:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$da:
            return "Context.Consumer";
        case $277dfbc9b64034b1$var$v:
            return "Context.Provider";
        case $277dfbc9b64034b1$var$fa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $277dfbc9b64034b1$var$ia:
            return $277dfbc9b64034b1$var$C(a.type);
        case $277dfbc9b64034b1$var$ka:
            return $277dfbc9b64034b1$var$C(a.render);
        case $277dfbc9b64034b1$var$ja:
            if (a = 1 === a._status ? a._result : null) return $277dfbc9b64034b1$var$C(a);
    }
    return null;
}
var $277dfbc9b64034b1$var$D = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$277dfbc9b64034b1$var$D.hasOwnProperty("ReactCurrentDispatcher") || ($277dfbc9b64034b1$var$D.ReactCurrentDispatcher = {
    current: null
});
$277dfbc9b64034b1$var$D.hasOwnProperty("ReactCurrentBatchConfig") || ($277dfbc9b64034b1$var$D.ReactCurrentBatchConfig = {
    suspense: null
});
var $277dfbc9b64034b1$var$oa = {};
function $277dfbc9b64034b1$var$E(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function $277dfbc9b64034b1$var$pa(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return $277dfbc9b64034b1$var$E(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = $277dfbc9b64034b1$var$oa;
    return b;
}
for(var $277dfbc9b64034b1$var$F = new Uint16Array(16), $277dfbc9b64034b1$var$H = 0; 15 > $277dfbc9b64034b1$var$H; $277dfbc9b64034b1$var$H++)$277dfbc9b64034b1$var$F[$277dfbc9b64034b1$var$H] = $277dfbc9b64034b1$var$H + 1;
$277dfbc9b64034b1$var$F[15] = 0;
var $277dfbc9b64034b1$var$qa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$ra = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$sa = {}, $277dfbc9b64034b1$var$ta = {};
function $277dfbc9b64034b1$var$ua(a) {
    if ($277dfbc9b64034b1$var$ra.call($277dfbc9b64034b1$var$ta, a)) return !0;
    if ($277dfbc9b64034b1$var$ra.call($277dfbc9b64034b1$var$sa, a)) return !1;
    if ($277dfbc9b64034b1$var$qa.test(a)) return $277dfbc9b64034b1$var$ta[a] = !0;
    $277dfbc9b64034b1$var$sa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$va(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $277dfbc9b64034b1$var$wa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $277dfbc9b64034b1$var$va(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $277dfbc9b64034b1$var$J(a, b, c, d, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = g;
}
var $277dfbc9b64034b1$var$K = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$K[b] = new $277dfbc9b64034b1$var$J(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 5, !1, a.toLowerCase(), null, !1);
});
var $277dfbc9b64034b1$var$L = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$M(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$L, $277dfbc9b64034b1$var$M);
    $277dfbc9b64034b1$var$K[b] = new $277dfbc9b64034b1$var$J(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$L, $277dfbc9b64034b1$var$M);
    $277dfbc9b64034b1$var$K[b] = new $277dfbc9b64034b1$var$J(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$L, $277dfbc9b64034b1$var$M);
    $277dfbc9b64034b1$var$K[b] = new $277dfbc9b64034b1$var$J(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 1, !1, a.toLowerCase(), null, !1);
});
$277dfbc9b64034b1$var$K.xlinkHref = new $277dfbc9b64034b1$var$J("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$K[a] = new $277dfbc9b64034b1$var$J(a, 1, !1, a.toLowerCase(), null, !0);
});
var $277dfbc9b64034b1$var$xa = /["'&<>]/;
function $277dfbc9b64034b1$var$N(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function $277dfbc9b64034b1$var$ya(a, b) {
    var c = $277dfbc9b64034b1$var$K.hasOwnProperty(a) ? $277dfbc9b64034b1$var$K[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || $277dfbc9b64034b1$var$wa(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + ($277dfbc9b64034b1$var$N(b) + '"');
    }
    return $277dfbc9b64034b1$var$ua(a) ? a + '="' + ($277dfbc9b64034b1$var$N(b) + '"') : "";
}
function $277dfbc9b64034b1$var$za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$Aa = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$za, $277dfbc9b64034b1$var$O = null, $277dfbc9b64034b1$var$P = null, $277dfbc9b64034b1$var$Q = null, $277dfbc9b64034b1$var$R = !1, $277dfbc9b64034b1$var$S = !1, $277dfbc9b64034b1$var$U = null, $277dfbc9b64034b1$var$V = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$O) throw Error($277dfbc9b64034b1$var$q(321));
    return $277dfbc9b64034b1$var$O;
}
function $277dfbc9b64034b1$var$Ba() {
    if (0 < $277dfbc9b64034b1$var$V) throw Error($277dfbc9b64034b1$var$q(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$Ca() {
    null === $277dfbc9b64034b1$var$Q ? null === $277dfbc9b64034b1$var$P ? ($277dfbc9b64034b1$var$R = !1, $277dfbc9b64034b1$var$P = $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Ba()) : ($277dfbc9b64034b1$var$R = !0, $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$P) : null === $277dfbc9b64034b1$var$Q.next ? ($277dfbc9b64034b1$var$R = !1, $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Q.next = $277dfbc9b64034b1$var$Ba()) : ($277dfbc9b64034b1$var$R = !0, $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Q.next);
    return $277dfbc9b64034b1$var$Q;
}
function $277dfbc9b64034b1$var$Da(a, b, c, d) {
    for(; $277dfbc9b64034b1$var$S;)$277dfbc9b64034b1$var$S = !1, $277dfbc9b64034b1$var$V += 1, $277dfbc9b64034b1$var$Q = null, c = a(b, d);
    $277dfbc9b64034b1$var$P = $277dfbc9b64034b1$var$O = null;
    $277dfbc9b64034b1$var$V = 0;
    $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$U = null;
    return c;
}
function $277dfbc9b64034b1$var$Ea(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$Fa(a, b, c) {
    $277dfbc9b64034b1$var$O = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Ca();
    if ($277dfbc9b64034b1$var$R) {
        var d = $277dfbc9b64034b1$var$Q.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$U && (c = $277dfbc9b64034b1$var$U.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$U.delete(d);
            d = $277dfbc9b64034b1$var$Q.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$Q.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$Q.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$Ea ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$Q.memoizedState = a;
    a = $277dfbc9b64034b1$var$Q.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$Ga.bind(null, $277dfbc9b64034b1$var$O, a);
    return [
        $277dfbc9b64034b1$var$Q.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$Ga(a, b, c) {
    if (!(25 > $277dfbc9b64034b1$var$V)) throw Error($277dfbc9b64034b1$var$q(301));
    if (a === $277dfbc9b64034b1$var$O) {
        if ($277dfbc9b64034b1$var$S = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$U && ($277dfbc9b64034b1$var$U = new Map), c = $277dfbc9b64034b1$var$U.get(b), void 0 === c) $277dfbc9b64034b1$var$U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$Ha() {}
var $277dfbc9b64034b1$var$X = 0, $277dfbc9b64034b1$var$Ia = {
    readContext: function(a) {
        var b = $277dfbc9b64034b1$var$X;
        $277dfbc9b64034b1$var$E(a, b);
        return a[b];
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        var b = $277dfbc9b64034b1$var$X;
        $277dfbc9b64034b1$var$E(a, b);
        return a[b];
    },
    useMemo: function(a, b) {
        $277dfbc9b64034b1$var$O = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Ca();
        b = void 0 === b ? null : b;
        if (null !== $277dfbc9b64034b1$var$Q) {
            var c = $277dfbc9b64034b1$var$Q.memoizedState;
            if (null !== c && null !== b) {
                a: {
                    var d = c[1];
                    if (null === d) d = !1;
                    else {
                        for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$Aa(b[f], d[f])) {
                            d = !1;
                            break a;
                        }
                        d = !0;
                    }
                }
                if (d) return c[0];
            }
        }
        a = a();
        $277dfbc9b64034b1$var$Q.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $277dfbc9b64034b1$var$Fa,
    useRef: function(a) {
        $277dfbc9b64034b1$var$O = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$Ca();
        var b = $277dfbc9b64034b1$var$Q.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$Q.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$Fa($277dfbc9b64034b1$var$Ea, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a) {
        return a;
    },
    useImperativeHandle: $277dfbc9b64034b1$var$Ha,
    useEffect: $277dfbc9b64034b1$var$Ha,
    useDebugValue: $277dfbc9b64034b1$var$Ha,
    useResponder: function(a, b) {
        return {
            props: b,
            responder: a
        };
    },
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    }
}, $277dfbc9b64034b1$var$Ja = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $277dfbc9b64034b1$var$Ka(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $277dfbc9b64034b1$var$La = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $277dfbc9b64034b1$var$Ma = $8coUR({
    menuitem: !0
}, $277dfbc9b64034b1$var$La), $277dfbc9b64034b1$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$Na = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$Y).forEach(function(a) {
    $277dfbc9b64034b1$var$Na.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$Y[b] = $277dfbc9b64034b1$var$Y[a];
    });
});
var $277dfbc9b64034b1$var$Oa = /([A-Z])/g, $277dfbc9b64034b1$var$Pa = /^ms-/, $277dfbc9b64034b1$var$Z = $acw62.Children.toArray, $277dfbc9b64034b1$var$Qa = $277dfbc9b64034b1$var$D.ReactCurrentDispatcher, $277dfbc9b64034b1$var$Ra = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $277dfbc9b64034b1$var$Sa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Ta = {}, $277dfbc9b64034b1$var$Ua = {};
function $277dfbc9b64034b1$var$Va(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Wa = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$Xa = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $277dfbc9b64034b1$var$Ya(a, b) {
    if (void 0 === a) throw Error($277dfbc9b64034b1$var$q(152, $277dfbc9b64034b1$var$C(b) || "Component"));
}
function $277dfbc9b64034b1$var$Za(a, b, c) {
    function d(d, g) {
        var e = g.prototype && g.prototype.isReactComponent, f = $277dfbc9b64034b1$var$pa(g, b, c, e), x = [], h = !1, m = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === x) return null;
            },
            enqueueReplaceState: function(a, c) {
                h = !0;
                x = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === x) return null;
                x.push(c);
            }
        };
        if (e) {
            if (e = new g(d.props, f, m), "function" === typeof g.getDerivedStateFromProps) {
                var w = g.getDerivedStateFromProps.call(null, d.props, e.state);
                null != w && (e.state = $8coUR({}, e.state, w));
            }
        } else if ($277dfbc9b64034b1$var$O = {}, e = g(d.props, f, m), e = $277dfbc9b64034b1$var$Da(g, d.props, e, f), null == e || null == e.render) {
            a = e;
            $277dfbc9b64034b1$var$Ya(a, g);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = m;
        m = e.state;
        void 0 === m && (e.state = m = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof g.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof g.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), x.length) {
                m = x;
                var r = h;
                x = null;
                h = !1;
                if (r && 1 === m.length) e.state = m[0];
                else {
                    w = r ? m[0] : e.state;
                    var y = !0;
                    for(r = r ? 1 : 0; r < m.length; r++){
                        var p = m[r];
                        p = "function" === typeof p ? p.call(e, w, d.props, f) : p;
                        null != p && (y ? (y = !1, w = $8coUR({}, w, p)) : $8coUR(w, p));
                    }
                    e.state = w;
                }
            } else x = null;
        }
        a = e.render();
        $277dfbc9b64034b1$var$Ya(a, g);
        if ("function" === typeof e.getChildContext && (d = g.childContextTypes, "object" === typeof d)) {
            var A = e.getChildContext();
            for(var T in A)if (!(T in d)) throw Error($277dfbc9b64034b1$var$q(108, $277dfbc9b64034b1$var$C(g) || "Unknown", T));
        }
        A && (b = $8coUR({}, b, A));
    }
    for(; $acw62.isValidElement(a);){
        var f = a, g = f.type;
        if ("function" !== typeof g) break;
        d(f, g);
    }
    return {
        child: a,
        context: b
    };
}
var $277dfbc9b64034b1$var$$a = function() {
    function a(a, b) {
        $acw62.isValidElement(a) ? a.type !== $277dfbc9b64034b1$var$u ? a = [
            a
        ] : (a = a.props.children, a = $acw62.isValidElement(a) ? [
            a
        ] : $277dfbc9b64034b1$var$Z(a)) : a = $277dfbc9b64034b1$var$Z(a);
        a = {
            type: null,
            domNamespace: $277dfbc9b64034b1$var$Ja.html,
            children: a,
            childIndex: 0,
            context: $277dfbc9b64034b1$var$oa,
            footer: ""
        };
        var c = $277dfbc9b64034b1$var$F[0];
        if (0 === c) {
            var g = $277dfbc9b64034b1$var$F;
            c = g.length;
            var d = 2 * c;
            if (!(65536 >= d)) throw Error($277dfbc9b64034b1$var$q(304));
            var h = new Uint16Array(d);
            h.set(g);
            $277dfbc9b64034b1$var$F = h;
            $277dfbc9b64034b1$var$F[0] = c + 1;
            for(g = c; g < d - 1; g++)$277dfbc9b64034b1$var$F[g] = g + 1;
            $277dfbc9b64034b1$var$F[d - 1] = 0;
        } else $277dfbc9b64034b1$var$F[0] = $277dfbc9b64034b1$var$F[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            $277dfbc9b64034b1$var$F[a] = $277dfbc9b64034b1$var$F[0];
            $277dfbc9b64034b1$var$F[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var c = ++this.contextIndex, b = a.type._context, g = this.threadID;
        $277dfbc9b64034b1$var$E(b, g);
        var x = b[g];
        this.contextStack[c] = b;
        this.contextValueStack[c] = x;
        b[g] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = $277dfbc9b64034b1$var$X;
        $277dfbc9b64034b1$var$X = this.threadID;
        var c = $277dfbc9b64034b1$var$Qa.current;
        $277dfbc9b64034b1$var$Qa.current = $277dfbc9b64034b1$var$Ia;
        try {
            for(var g = [
                ""
            ], x = !1; g[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var h = this.threadID;
                    $277dfbc9b64034b1$var$F[h] = $277dfbc9b64034b1$var$F[0];
                    $277dfbc9b64034b1$var$F[0] = h;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (x || e.childIndex >= e.children.length) {
                    var I = e.footer;
                    "" !== I && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === $277dfbc9b64034b1$var$v) this.popProvider(e.type);
                    else if (e.type === $277dfbc9b64034b1$var$B) {
                        this.suspenseDepth--;
                        var G = g.pop();
                        if (x) {
                            x = !1;
                            var n = e.fallbackFrame;
                            if (!n) throw Error($277dfbc9b64034b1$var$q(303));
                            this.stack.push(n);
                            g[this.suspenseDepth] += "\x3c!--$!--\x3e";
                            continue;
                        } else g[this.suspenseDepth] += G;
                    }
                    g[this.suspenseDepth] += I;
                } else {
                    var m = e.children[e.childIndex++], w = "";
                    try {
                        w += this.render(m, e.context, e.domNamespace);
                    } catch (r) {
                        if (null != r && "function" === typeof r.then) throw Error($277dfbc9b64034b1$var$q(294));
                        throw r;
                    } finally{}
                    g.length <= this.suspenseDepth && g.push("");
                    g[this.suspenseDepth] += w;
                }
            }
            return g[0];
        } finally{
            $277dfbc9b64034b1$var$Qa.current = c, $277dfbc9b64034b1$var$X = b;
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return $277dfbc9b64034b1$var$N(f);
            if (this.previousWasTextNode) return "\x3c!-- --\x3e" + $277dfbc9b64034b1$var$N(f);
            this.previousWasTextNode = !0;
            return $277dfbc9b64034b1$var$N(f);
        }
        b = $277dfbc9b64034b1$var$Za(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!$acw62.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === $277dfbc9b64034b1$var$aa) throw Error($277dfbc9b64034b1$var$q(257));
                throw Error($277dfbc9b64034b1$var$q(258, f.toString()));
            }
            a = $277dfbc9b64034b1$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case $277dfbc9b64034b1$var$ba:
            case $277dfbc9b64034b1$var$ea:
            case $277dfbc9b64034b1$var$ca:
            case $277dfbc9b64034b1$var$ha:
            case $277dfbc9b64034b1$var$u:
                return a = $277dfbc9b64034b1$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $277dfbc9b64034b1$var$B:
                throw Error($277dfbc9b64034b1$var$q(294));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$fa:
                $277dfbc9b64034b1$var$O = {};
                var d = c.render(a.props, a.ref);
                d = $277dfbc9b64034b1$var$Da(c.render, a.props, d, a.ref);
                d = $277dfbc9b64034b1$var$Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $277dfbc9b64034b1$var$ia:
                return a = [
                    $acw62.createElement(c.type, $8coUR({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $277dfbc9b64034b1$var$v:
                return c = $277dfbc9b64034b1$var$Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case $277dfbc9b64034b1$var$da:
                c = a.type;
                d = a.props;
                var h = this.threadID;
                $277dfbc9b64034b1$var$E(c, h);
                c = $277dfbc9b64034b1$var$Z(d.children(c[h]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $277dfbc9b64034b1$var$la:
                throw Error($277dfbc9b64034b1$var$q(338));
            case $277dfbc9b64034b1$var$ja:
                switch(c = a.type, $277dfbc9b64034b1$var$na(c), c._status){
                    case 1:
                        return a = [
                            $acw62.createElement(c._result, $8coUR({
                                ref: a.ref
                            }, a.props))
                        ], this.stack.push({
                            type: null,
                            domNamespace: f,
                            children: a,
                            childIndex: 0,
                            context: b,
                            footer: ""
                        }), "";
                    case 2:
                        throw c._result;
                    default:
                        throw Error($277dfbc9b64034b1$var$q(295));
                }
            case $277dfbc9b64034b1$var$ma:
                throw Error($277dfbc9b64034b1$var$q(343));
        }
        throw Error($277dfbc9b64034b1$var$q(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === $277dfbc9b64034b1$var$Ja.html && $277dfbc9b64034b1$var$Ka(c);
        if (!$277dfbc9b64034b1$var$Ta.hasOwnProperty(c)) {
            if (!$277dfbc9b64034b1$var$Sa.test(c)) throw Error($277dfbc9b64034b1$var$q(65, c));
            $277dfbc9b64034b1$var$Ta[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = $8coUR({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var h = d.value;
            if (null == h) {
                h = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != h) throw Error($277dfbc9b64034b1$var$q(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error($277dfbc9b64034b1$var$q(93));
                        e = e[0];
                    }
                    h = "" + e;
                }
                null == h && (h = "");
            }
            d = $8coUR({}, d, {
                value: void 0,
                children: "" + h
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = $8coUR({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var I = $277dfbc9b64034b1$var$Va(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : I;
                h = !1;
                if (Array.isArray(e)) {
                    for(var n = 0; n < e.length; n++)if ("" + e[n] === G) {
                        h = !0;
                        break;
                    }
                } else h = "" + e === G;
                d = $8coUR({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: h,
                    children: I
                });
            }
        }
        if (h = d) {
            if ($277dfbc9b64034b1$var$Ma[c] && (null != h.children || null != h.dangerouslySetInnerHTML)) throw Error($277dfbc9b64034b1$var$q(137, c, ""));
            if (null != h.dangerouslySetInnerHTML) {
                if (null != h.children) throw Error($277dfbc9b64034b1$var$q(60));
                if (!("object" === typeof h.dangerouslySetInnerHTML && "__html" in h.dangerouslySetInnerHTML)) throw Error($277dfbc9b64034b1$var$q(61));
            }
            if (null != h.style && "object" !== typeof h.style) throw Error($277dfbc9b64034b1$var$q(62, ""));
        }
        h = d;
        e = this.makeStaticMarkup;
        I = 1 === this.stack.length;
        G = "<" + a.type;
        for(z in h)if ($277dfbc9b64034b1$var$Wa.call(h, z)) {
            var m = h[z];
            if (null != m) {
                if ("style" === z) {
                    n = void 0;
                    var w = "", r = "";
                    for(n in m)if (m.hasOwnProperty(n)) {
                        var y = 0 === n.indexOf("--"), p = m[n];
                        if (null != p) {
                            if (y) var A = n;
                            else if (A = n, $277dfbc9b64034b1$var$Ua.hasOwnProperty(A)) A = $277dfbc9b64034b1$var$Ua[A];
                            else {
                                var T = A.replace($277dfbc9b64034b1$var$Oa, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$Pa, "-ms-");
                                A = $277dfbc9b64034b1$var$Ua[A] = T;
                            }
                            w += r + A + ":";
                            r = n;
                            y = null == p || "boolean" === typeof p || "" === p ? "" : y || "number" !== typeof p || 0 === p || $277dfbc9b64034b1$var$Y.hasOwnProperty(r) && $277dfbc9b64034b1$var$Y[r] ? ("" + p).trim() : p + "px";
                            w += y;
                            r = ";";
                        }
                    }
                    m = w || null;
                }
                n = null;
                b: if (y = c, p = h, -1 === y.indexOf("-")) y = "string" === typeof p.is;
                else switch(y){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        y = !1;
                        break b;
                    default:
                        y = !0;
                }
                y ? $277dfbc9b64034b1$var$Xa.hasOwnProperty(z) || (n = z, n = $277dfbc9b64034b1$var$ua(n) && null != m ? n + '="' + ($277dfbc9b64034b1$var$N(m) + '"') : "") : n = $277dfbc9b64034b1$var$ya(z, m);
                n && (G += " " + n);
            }
        }
        e || I && (G += ' data-reactroot=""');
        var z = G;
        h = "";
        $277dfbc9b64034b1$var$La.hasOwnProperty(c) ? z += "/>" : (z += ">", h = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = $277dfbc9b64034b1$var$N(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], $277dfbc9b64034b1$var$Ra.hasOwnProperty(c) && "\n" === e.charAt(0) && (z += "\n"), z += e) : d = $277dfbc9b64034b1$var$Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? $277dfbc9b64034b1$var$Ka(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: h
        });
        this.previousWasTextNode = !1;
        return z;
    };
    return a;
}(), $277dfbc9b64034b1$var$ab = {
    renderToString: function(a) {
        a = new $277dfbc9b64034b1$var$$a(a, !1);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToStaticMarkup: function(a) {
        a = new $277dfbc9b64034b1$var$$a(a, !0);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToNodeStream: function() {
        throw Error($277dfbc9b64034b1$var$q(207));
    },
    renderToStaticNodeStream: function() {
        throw Error($277dfbc9b64034b1$var$q(208));
    },
    version: "16.14.0"
};
module.exports = $277dfbc9b64034b1$var$ab.default || $277dfbc9b64034b1$var$ab;

});

parcelRegister("dmHdY", function(module, exports) {

$parcel$export(module.exports, "default", () => SchemaType);

var $8nd05 = parcelRequire("8nd05");

var $cHPF9 = parcelRequire("cHPF9");

var $8XLqy = parcelRequire("8XLqy");

var $ls0I6 = parcelRequire("ls0I6");

var $7WY4h = parcelRequire("7WY4h");

var $5nwN5 = parcelRequire("5nwN5");

var $aQNBY = parcelRequire("aQNBY");

var $6sdvp = parcelRequire("6sdvp");

var $lLrpe = parcelRequire("lLrpe");

var $2vNMA = parcelRequire("2vNMA");

var $aFRKX = parcelRequire("aFRKX");

var $58i62 = parcelRequire("58i62");

var $l6pyh = parcelRequire("l6pyh");

var $7Qa2h = parcelRequire("7Qa2h");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var RefSet = /*#__PURE__*/ function() {
    function RefSet() {
        this.list = new Set();
        this.refs = new Map();
    }
    var _proto = RefSet.prototype;
    _proto.describe = function describe() {
        var description = [];
        for(var _iterator = _createForOfIteratorHelperLoose(this.list), _step; !(_step = _iterator()).done;){
            var item = _step.value;
            description.push(item);
        }
        for(var _iterator2 = _createForOfIteratorHelperLoose(this.refs), _step2; !(_step2 = _iterator2()).done;){
            var _step2$value = _step2.value, ref = _step2$value[1];
            description.push(ref.describe());
        }
        return description;
    };
    _proto.toArray = function toArray() {
        return (0, $7WY4h.default)(this.list).concat((0, $7WY4h.default)(this.refs.values()));
    };
    _proto.add = function add(value) {
        (0, $l6pyh.default).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    };
    _proto.delete = function _delete(value) {
        (0, $l6pyh.default).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    };
    _proto.has = function has(value, resolve) {
        if (this.list.has(value)) return true;
        var item, values = this.refs.values();
        while(item = values.next(), !item.done){
            if (resolve(item.value) === value) return true;
        }
        return false;
    };
    _proto.clone = function clone() {
        var next = new RefSet();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    };
    _proto.merge = function merge(newItems, removeItems) {
        var next = this.clone();
        newItems.list.forEach(function(value) {
            return next.add(value);
        });
        newItems.refs.forEach(function(value) {
            return next.add(value);
        });
        removeItems.list.forEach(function(value) {
            return next.delete(value);
        });
        removeItems.refs.forEach(function(value) {
            return next.delete(value);
        });
        return next;
    };
    (0, $cHPF9.default)(RefSet, [
        {
            key: "size",
            get: function get() {
                return this.list.size + this.refs.size;
            }
        }
    ]);
    return RefSet;
}();
function SchemaType(options) {
    var _this = this;
    if (options === void 0) options = {};
    if (!(this instanceof SchemaType)) return new SchemaType();
    this._deps = [];
    this._conditions = [];
    this._options = {
        abortEarly: true,
        recursive: true
    };
    this._exclusive = Object.create(null);
    this._whitelist = new RefSet();
    this._blacklist = new RefSet();
    this.tests = [];
    this.transforms = [];
    this.withMutation(function() {
        _this.typeError((0, $5nwN5.mixed).notType);
    });
    if ((0, $8XLqy.default)(options, 'default')) this._defaultDefault = options.default;
    this.type = options.type || 'mixed'; // TODO: remove
    this._type = options.type || 'mixed';
}
var proto = SchemaType.prototype = {
    __isYupSchema__: true,
    constructor: SchemaType,
    clone: function clone() {
        var _this2 = this;
        if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        return (0, $ls0I6.default)(this, function(value) {
            if ((0, $2vNMA.default)(value) && value !== _this2) return value;
        });
    },
    label: function label(_label) {
        var next = this.clone();
        next._label = _label;
        return next;
    },
    meta: function meta(obj) {
        if (arguments.length === 0) return this._meta;
        var next = this.clone();
        next._meta = (0, $8nd05.default)(next._meta || {}, obj);
        return next;
    },
    withMutation: function withMutation(fn) {
        var before = this._mutate;
        this._mutate = true;
        var result = fn(this);
        this._mutate = before;
        return result;
    },
    concat: function concat(schema) {
        if (!schema || schema === this) return this;
        if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
        var next = (0, $lLrpe.default)(schema.clone(), this); // new undefined default is overridden by old non-undefined one, revert
        if ((0, $8XLqy.default)(schema, '_default')) next._default = schema._default;
        next.tests = this.tests;
        next._exclusive = this._exclusive; // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        next._whitelist = this._whitelist.merge(schema._whitelist, schema._blacklist);
        next._blacklist = this._blacklist.merge(schema._blacklist, schema._whitelist); // manually add the new tests to ensure
        // the deduping logic is consistent
        next.withMutation(function(next) {
            schema.tests.forEach(function(fn) {
                next.test(fn.OPTIONS);
            });
        });
        return next;
    },
    isType: function isType(v) {
        if (this._nullable && v === null) return true;
        return !this._typeCheck || this._typeCheck(v);
    },
    resolve: function resolve(options) {
        var schema = this;
        if (schema._conditions.length) {
            var conditions = schema._conditions;
            schema = schema.clone();
            schema._conditions = [];
            schema = conditions.reduce(function(schema, condition) {
                return condition.resolve(schema, options);
            }, schema);
            schema = schema.resolve(options);
        }
        return schema;
    },
    cast: function cast(value, options) {
        if (options === void 0) options = {};
        var resolvedSchema = this.resolve((0, $8nd05.default)({}, options, {
            value: value
        }));
        var result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            var formattedValue = (0, $58i62.default)(value);
            var formattedResult = (0, $58i62.default)(result);
            throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
        }
        return result;
    },
    _cast: function _cast(rawValue) {
        var _this3 = this;
        var value = rawValue === undefined ? rawValue : this.transforms.reduce(function(value, fn) {
            return fn.call(_this3, value, rawValue);
        }, rawValue);
        if (value === undefined && (0, $8XLqy.default)(this, '_default')) value = this.default();
        return value;
    },
    _validate: function _validate(_value, options) {
        var _this4 = this;
        if (options === void 0) options = {};
        var value = _value;
        var originalValue = options.originalValue != null ? options.originalValue : _value;
        var isStrict = this._option('strict', options);
        var endEarly = this._option('abortEarly', options);
        var sync = options.sync;
        var path = options.path;
        var label = this._label;
        if (!isStrict) value = this._cast(value, (0, $8nd05.default)({
            assert: false
        }, options));
         // value is cast, we can check if it meets type requirements
        var validationParams = {
            value: value,
            path: path,
            schema: this,
            options: options,
            label: label,
            originalValue: originalValue,
            sync: sync
        };
        if (options.from) validationParams.from = options.from;
        var initialTests = [];
        if (this._typeError) initialTests.push(this._typeError(validationParams));
        if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
        if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
        return (0, $6sdvp.default)({
            validations: initialTests,
            endEarly: endEarly,
            value: value,
            path: path,
            sync: sync
        }).then(function(value) {
            return (0, $6sdvp.default)({
                path: path,
                sync: sync,
                value: value,
                endEarly: endEarly,
                validations: _this4.tests.map(function(fn) {
                    return fn(validationParams);
                })
            });
        });
    },
    validate: function validate(value, options) {
        if (options === void 0) options = {};
        var schema = this.resolve((0, $8nd05.default)({}, options, {
            value: value
        }));
        return schema._validate(value, options);
    },
    validateSync: function validateSync(value, options) {
        if (options === void 0) options = {};
        var schema = this.resolve((0, $8nd05.default)({}, options, {
            value: value
        }));
        var result, err;
        schema._validate(value, (0, $8nd05.default)({}, options, {
            sync: true
        })).then(function(r) {
            return result = r;
        }).catch(function(e) {
            return err = e;
        });
        if (err) throw err;
        return result;
    },
    isValid: function isValid(value, options) {
        return this.validate(value, options).then(function() {
            return true;
        }).catch(function(err) {
            if (err.name === 'ValidationError') return false;
            throw err;
        });
    },
    isValidSync: function isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if (err.name === 'ValidationError') return false;
            throw err;
        }
    },
    getDefault: function getDefault(options) {
        if (options === void 0) options = {};
        var schema = this.resolve(options);
        return schema.default();
    },
    default: function _default(def) {
        if (arguments.length === 0) {
            var defaultValue = (0, $8XLqy.default)(this, '_default') ? this._default : this._defaultDefault;
            return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $ls0I6.default)(defaultValue);
        }
        var next = this.clone();
        next._default = def;
        return next;
    },
    strict: function strict(isStrict) {
        if (isStrict === void 0) isStrict = true;
        var next = this.clone();
        next._options.strict = isStrict;
        return next;
    },
    _isPresent: function _isPresent(value) {
        return value != null;
    },
    required: function required(message) {
        if (message === void 0) message = (0, $5nwN5.mixed).required;
        return this.test({
            message: message,
            name: 'required',
            exclusive: true,
            test: function test(value) {
                return this.schema._isPresent(value);
            }
        });
    },
    notRequired: function notRequired() {
        var next = this.clone();
        next.tests = next.tests.filter(function(test) {
            return test.OPTIONS.name !== 'required';
        });
        return next;
    },
    nullable: function nullable(isNullable) {
        if (isNullable === void 0) isNullable = true;
        var next = this.clone();
        next._nullable = isNullable;
        return next;
    },
    transform: function transform(fn) {
        var next = this.clone();
        next.transforms.push(fn);
        return next;
    },
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test: function test() {
        var opts;
        if (arguments.length === 1) {
            if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') opts = {
                test: arguments.length <= 0 ? undefined : arguments[0]
            };
            else opts = arguments.length <= 0 ? undefined : arguments[0];
        } else if (arguments.length === 2) opts = {
            name: arguments.length <= 0 ? undefined : arguments[0],
            test: arguments.length <= 1 ? undefined : arguments[1]
        };
        else opts = {
            name: arguments.length <= 0 ? undefined : arguments[0],
            message: arguments.length <= 1 ? undefined : arguments[1],
            test: arguments.length <= 2 ? undefined : arguments[2]
        };
        if (opts.message === undefined) opts.message = (0, $5nwN5.mixed).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        var next = this.clone();
        var validate = (0, $aFRKX.default)(opts);
        var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;
        if (opts.exclusive && !opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        next._exclusive[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter(function(fn) {
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    },
    when: function when(keys, options) {
        if (arguments.length === 1) {
            options = keys;
            keys = '.';
        }
        var next = this.clone(), deps = [].concat(keys).map(function(key) {
            return new (0, $l6pyh.default)(key);
        });
        deps.forEach(function(dep) {
            if (dep.isSibling) next._deps.push(dep.key);
        });
        next._conditions.push(new (0, $aQNBY.default)(deps, options));
        return next;
    },
    typeError: function typeError(message) {
        var next = this.clone();
        next._typeError = (0, $aFRKX.default)({
            message: message,
            name: 'typeError',
            test: function test(value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    },
    oneOf: function oneOf(enums, message) {
        if (message === void 0) message = (0, $5nwN5.mixed).oneOf;
        var next = this.clone();
        enums.forEach(function(val) {
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $aFRKX.default)({
            message: message,
            name: 'oneOf',
            test: function test(value) {
                if (value === undefined) return true;
                var valids = this.schema._whitelist;
                return valids.has(value, this.resolve) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', ')
                    }
                });
            }
        });
        return next;
    },
    notOneOf: function notOneOf(enums, message) {
        if (message === void 0) message = (0, $5nwN5.mixed).notOneOf;
        var next = this.clone();
        enums.forEach(function(val) {
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $aFRKX.default)({
            message: message,
            name: 'notOneOf',
            test: function test(value) {
                var invalids = this.schema._blacklist;
                if (invalids.has(value, this.resolve)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', ')
                    }
                });
                return true;
            }
        });
        return next;
    },
    strip: function strip(_strip) {
        if (_strip === void 0) _strip = true;
        var next = this.clone();
        next._strip = _strip;
        return next;
    },
    _option: function _option(key, overrides) {
        return (0, $8XLqy.default)(overrides, key) ? overrides[key] : this._options[key];
    },
    describe: function describe() {
        var next = this.clone();
        var description = {
            type: next._type,
            meta: next._meta,
            label: next._label,
            tests: next.tests.map(function(fn) {
                return {
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                };
            }).filter(function(n, idx, list) {
                return list.findIndex(function(c) {
                    return c.name === n.name;
                }) === idx;
            })
        };
        if (next._whitelist.size) description.oneOf = next._whitelist.describe();
        if (next._blacklist.size) description.notOneOf = next._blacklist.describe();
        return description;
    },
    defined: function defined(message) {
        if (message === void 0) message = (0, $5nwN5.mixed).defined;
        return this.nullable().test({
            message: message,
            name: 'defined',
            exclusive: true,
            test: function test(value) {
                return value !== undefined;
            }
        });
    }
};
var _loop = function _loop() {
    var method = _arr[_i];
    proto[method + "At"] = function(path, value, options) {
        if (options === void 0) options = {};
        var _getIn = (0, $7Qa2h.getIn)(this, path, value, options.context), parent = _getIn.parent, parentPath = _getIn.parentPath, schema = _getIn.schema;
        return schema[method](parent && parent[parentPath], (0, $8nd05.default)({}, options, {
            parent: parent,
            path: path
        }));
    };
};
for(var _i = 0, _arr = [
    'validate',
    'validateSync'
]; _i < _arr.length; _i++)_loop();
for(var _i2 = 0, _arr2 = [
    'equals',
    'is'
]; _i2 < _arr2.length; _i2++){
    var alias = _arr2[_i2];
    proto[alias] = proto.oneOf;
}
for(var _i3 = 0, _arr3 = [
    'not',
    'nope'
]; _i3 < _arr3.length; _i3++){
    var _alias = _arr3[_i3];
    proto[_alias] = proto.notOneOf;
}
proto.optional = proto.notRequired;

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $4ZreY.default)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $cXkjo.default)(arg, "string");
    return (0, $fSwVM.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $fSwVM.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $fSwVM.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRegister("8XLqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $68689f7f2aa159ec$export$2e2bcd8739ae039);

var $2lSdM = parcelRequire("2lSdM");

var $3AXYs = parcelRequire("3AXYs");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $68689f7f2aa159ec$var$has(object, path) {
    return object != null && (0, $3AXYs.default)(object, path, (0, $2lSdM.default));
}
var $68689f7f2aa159ec$export$2e2bcd8739ae039 = $68689f7f2aa159ec$var$has;

});
parcelRegister("2lSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b679a285568063c$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $1b679a285568063c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1b679a285568063c$var$hasOwnProperty = $1b679a285568063c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1b679a285568063c$var$baseHas(object, key) {
    return object != null && $1b679a285568063c$var$hasOwnProperty.call(object, key);
}
var $1b679a285568063c$export$2e2bcd8739ae039 = $1b679a285568063c$var$baseHas;

});

parcelRegister("3AXYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e34186fa753d89$export$2e2bcd8739ae039);

var $dUJCp = parcelRequire("dUJCp");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $cBYZY = parcelRequire("cBYZY");

var $idNmI = parcelRequire("idNmI");

var $ft2bY = parcelRequire("ft2bY");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $29e34186fa753d89$var$hasPath(object, path, hasFunc) {
    path = (0, $dUJCp.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $ft2bY.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $idNmI.default)(length) && (0, $cBYZY.default)(key, length) && ((0, $hf0C9.default)(object) || (0, $5VdmZ.default)(object));
}
var $29e34186fa753d89$export$2e2bcd8739ae039 = $29e34186fa753d89$var$hasPath;

});
parcelRegister("dUJCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a213e439f16f86c2$export$2e2bcd8739ae039);

var $hf0C9 = parcelRequire("hf0C9");

var $6f10l = parcelRequire("6f10l");

var $6D9Aa = parcelRequire("6D9Aa");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a213e439f16f86c2$var$castPath(value, object) {
    if ((0, $hf0C9.default)(value)) return value;
    return (0, $6f10l.default)(value, object) ? [
        value
    ] : (0, $6D9Aa.default)((0, $1fnxW.default)(value));
}
var $a213e439f16f86c2$export$2e2bcd8739ae039 = $a213e439f16f86c2$var$castPath;

});
parcelRegister("6f10l", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b4ec444ff09357$export$2e2bcd8739ae039);

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used to match property names within property paths. */ var $48b4ec444ff09357$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $48b4ec444ff09357$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $48b4ec444ff09357$var$isKey(value, object) {
    if ((0, $hf0C9.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $1WN0o.default)(value)) return true;
    return $48b4ec444ff09357$var$reIsPlainProp.test(value) || !$48b4ec444ff09357$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $48b4ec444ff09357$export$2e2bcd8739ae039 = $48b4ec444ff09357$var$isKey;

});




parcelRegister("ls0I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9dcc38a2a9e7ccd$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $f9dcc38a2a9e7ccd$var$CLONE_DEEP_FLAG = 1, $f9dcc38a2a9e7ccd$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $f9dcc38a2a9e7ccd$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return (0, $gbpSA.default)(value, $f9dcc38a2a9e7ccd$var$CLONE_DEEP_FLAG | $f9dcc38a2a9e7ccd$var$CLONE_SYMBOLS_FLAG, customizer);
}
var $f9dcc38a2a9e7ccd$export$2e2bcd8739ae039 = $f9dcc38a2a9e7ccd$var$cloneDeepWith;

});

parcelRegister("7WY4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9c8b6f5baf9369$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $jXStN = parcelRequire("jXStN");

var $4wkSQ = parcelRequire("4wkSQ");

var $lAOUf = parcelRequire("lAOUf");

var $7icKW = parcelRequire("7icKW");

var $gB7Nn = parcelRequire("gB7Nn");

var $7YTsx = parcelRequire("7YTsx");

var $827W0 = parcelRequire("827W0");

var $h5ULu = parcelRequire("h5ULu");

var $7pPNr = parcelRequire("7pPNr");
/** `Object#toString` result references. */ var $5c9c8b6f5baf9369$var$mapTag = '[object Map]', $5c9c8b6f5baf9369$var$setTag = '[object Set]';
/** Built-in value references. */ var $5c9c8b6f5baf9369$var$symIterator = (0, $kRxPv.default) ? (0, $kRxPv.default).iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $5c9c8b6f5baf9369$var$toArray(value) {
    if (!value) return [];
    if ((0, $lAOUf.default)(value)) return (0, $7icKW.default)(value) ? (0, $h5ULu.default)(value) : (0, $jXStN.default)(value);
    if ($5c9c8b6f5baf9369$var$symIterator && value[$5c9c8b6f5baf9369$var$symIterator]) return (0, $gB7Nn.default)(value[$5c9c8b6f5baf9369$var$symIterator]());
    var tag = (0, $4wkSQ.default)(value), func = tag == $5c9c8b6f5baf9369$var$mapTag ? (0, $7YTsx.default) : tag == $5c9c8b6f5baf9369$var$setTag ? (0, $827W0.default) : (0, $7pPNr.default);
    return func(value);
}
var $5c9c8b6f5baf9369$export$2e2bcd8739ae039 = $5c9c8b6f5baf9369$var$toArray;

});
parcelRegister("7icKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $54f41bee1f651fc5$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $hf0C9 = parcelRequire("hf0C9");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $54f41bee1f651fc5$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $54f41bee1f651fc5$var$isString(value) {
    return typeof value == 'string' || !(0, $hf0C9.default)(value) && (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $54f41bee1f651fc5$var$stringTag;
}
var $54f41bee1f651fc5$export$2e2bcd8739ae039 = $54f41bee1f651fc5$var$isString;

});

parcelRegister("gB7Nn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1562606e08e91bc$export$2e2bcd8739ae039);
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $c1562606e08e91bc$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
var $c1562606e08e91bc$export$2e2bcd8739ae039 = $c1562606e08e91bc$var$iteratorToArray;

});

parcelRegister("7YTsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf92809ef98e399$export$2e2bcd8739ae039);
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5cf92809ef98e399$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $5cf92809ef98e399$export$2e2bcd8739ae039 = $5cf92809ef98e399$var$mapToArray;

});

parcelRegister("827W0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d94aa434317cc8a$export$2e2bcd8739ae039);
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5d94aa434317cc8a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $5d94aa434317cc8a$export$2e2bcd8739ae039 = $5d94aa434317cc8a$var$setToArray;

});

parcelRegister("h5ULu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71eef9ea1732fba$export$2e2bcd8739ae039);

var $aEW27 = parcelRequire("aEW27");

var $6MCUi = parcelRequire("6MCUi");

var $llmuY = parcelRequire("llmuY");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c71eef9ea1732fba$var$stringToArray(string) {
    return (0, $6MCUi.default)(string) ? (0, $llmuY.default)(string) : (0, $aEW27.default)(string);
}
var $c71eef9ea1732fba$export$2e2bcd8739ae039 = $c71eef9ea1732fba$var$stringToArray;

});
parcelRegister("aEW27", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2aa7f8f772b324$export$2e2bcd8739ae039);
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7c2aa7f8f772b324$var$asciiToArray(string) {
    return string.split('');
}
var $7c2aa7f8f772b324$export$2e2bcd8739ae039 = $7c2aa7f8f772b324$var$asciiToArray;

});

parcelRegister("6MCUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0567e72dd9ce2b$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $4f0567e72dd9ce2b$var$rsAstralRange = '\\ud800-\\udfff', $4f0567e72dd9ce2b$var$rsComboMarksRange = '\\u0300-\\u036f', $4f0567e72dd9ce2b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $4f0567e72dd9ce2b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $4f0567e72dd9ce2b$var$rsComboRange = $4f0567e72dd9ce2b$var$rsComboMarksRange + $4f0567e72dd9ce2b$var$reComboHalfMarksRange + $4f0567e72dd9ce2b$var$rsComboSymbolsRange, $4f0567e72dd9ce2b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $4f0567e72dd9ce2b$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $4f0567e72dd9ce2b$var$reHasUnicode = RegExp('[' + $4f0567e72dd9ce2b$var$rsZWJ + $4f0567e72dd9ce2b$var$rsAstralRange + $4f0567e72dd9ce2b$var$rsComboRange + $4f0567e72dd9ce2b$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $4f0567e72dd9ce2b$var$hasUnicode(string) {
    return $4f0567e72dd9ce2b$var$reHasUnicode.test(string);
}
var $4f0567e72dd9ce2b$export$2e2bcd8739ae039 = $4f0567e72dd9ce2b$var$hasUnicode;

});

parcelRegister("llmuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89d02de0bef2564$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $f89d02de0bef2564$var$rsAstralRange = '\\ud800-\\udfff', $f89d02de0bef2564$var$rsComboMarksRange = '\\u0300-\\u036f', $f89d02de0bef2564$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $f89d02de0bef2564$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $f89d02de0bef2564$var$rsComboRange = $f89d02de0bef2564$var$rsComboMarksRange + $f89d02de0bef2564$var$reComboHalfMarksRange + $f89d02de0bef2564$var$rsComboSymbolsRange, $f89d02de0bef2564$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $f89d02de0bef2564$var$rsAstral = '[' + $f89d02de0bef2564$var$rsAstralRange + ']', $f89d02de0bef2564$var$rsCombo = '[' + $f89d02de0bef2564$var$rsComboRange + ']', $f89d02de0bef2564$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $f89d02de0bef2564$var$rsModifier = '(?:' + $f89d02de0bef2564$var$rsCombo + '|' + $f89d02de0bef2564$var$rsFitz + ')', $f89d02de0bef2564$var$rsNonAstral = '[^' + $f89d02de0bef2564$var$rsAstralRange + ']', $f89d02de0bef2564$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $f89d02de0bef2564$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $f89d02de0bef2564$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $f89d02de0bef2564$var$reOptMod = $f89d02de0bef2564$var$rsModifier + '?', $f89d02de0bef2564$var$rsOptVar = '[' + $f89d02de0bef2564$var$rsVarRange + ']?', $f89d02de0bef2564$var$rsOptJoin = '(?:' + $f89d02de0bef2564$var$rsZWJ + '(?:' + [
    $f89d02de0bef2564$var$rsNonAstral,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair
].join('|') + ')' + $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + ')*', $f89d02de0bef2564$var$rsSeq = $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + $f89d02de0bef2564$var$rsOptJoin, $f89d02de0bef2564$var$rsSymbol = '(?:' + [
    $f89d02de0bef2564$var$rsNonAstral + $f89d02de0bef2564$var$rsCombo + '?',
    $f89d02de0bef2564$var$rsCombo,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair,
    $f89d02de0bef2564$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $f89d02de0bef2564$var$reUnicode = RegExp($f89d02de0bef2564$var$rsFitz + '(?=' + $f89d02de0bef2564$var$rsFitz + ')|' + $f89d02de0bef2564$var$rsSymbol + $f89d02de0bef2564$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f89d02de0bef2564$var$unicodeToArray(string) {
    return string.match($f89d02de0bef2564$var$reUnicode) || [];
}
var $f89d02de0bef2564$export$2e2bcd8739ae039 = $f89d02de0bef2564$var$unicodeToArray;

});


parcelRegister("7pPNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $56630be738b3f9fd$export$2e2bcd8739ae039);

var $g74O3 = parcelRequire("g74O3");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $56630be738b3f9fd$var$values(object) {
    return object == null ? [] : (0, $g74O3.default)(object, (0, $8krEv.default)(object));
}
var $56630be738b3f9fd$export$2e2bcd8739ae039 = $56630be738b3f9fd$var$values;

});
parcelRegister("g74O3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb1073b008645d2$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $bbb1073b008645d2$var$baseValues(object, props) {
    return (0, $afgje.default)(props, function(key) {
        return object[key];
    });
}
var $bbb1073b008645d2$export$2e2bcd8739ae039 = $bbb1073b008645d2$var$baseValues;

});



parcelRegister("5nwN5", function(module, exports) {

$parcel$export(module.exports, "mixed", () => $3ea8894c2d1a8ff8$export$9b30b6294c1449a8);
$parcel$export(module.exports, "string", () => $3ea8894c2d1a8ff8$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $3ea8894c2d1a8ff8$export$98e628dec113755e);
$parcel$export(module.exports, "date", () => $3ea8894c2d1a8ff8$export$324d90190a8b822a);
$parcel$export(module.exports, "object", () => $3ea8894c2d1a8ff8$export$be5493f9613cbbe);
$parcel$export(module.exports, "array", () => $3ea8894c2d1a8ff8$export$2f23118c22fb2630);
$parcel$export(module.exports, "default", () => $3ea8894c2d1a8ff8$export$2e2bcd8739ae039);

var $58i62 = parcelRequire("58i62");
var $3ea8894c2d1a8ff8$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: function notType(_ref) {
        var path = _ref.path, type = _ref.type, value = _ref.value, originalValue = _ref.originalValue;
        var isCast = originalValue != null && originalValue !== value;
        var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, $58i62.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, $58i62.default)(originalValue, true) + "`)." : '.');
        if (value === null) msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
        return msg;
    },
    defined: '${path} must be defined'
};
var $3ea8894c2d1a8ff8$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
var $3ea8894c2d1a8ff8$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    notEqual: '${path} must be not equal to ${notEqual}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
var $3ea8894c2d1a8ff8$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
var $3ea8894c2d1a8ff8$export$4a21f16c33752377 = {};
var $3ea8894c2d1a8ff8$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
var $3ea8894c2d1a8ff8$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items'
};
var $3ea8894c2d1a8ff8$export$2e2bcd8739ae039 = {
    mixed: $3ea8894c2d1a8ff8$export$9b30b6294c1449a8,
    string: $3ea8894c2d1a8ff8$export$22b082955e083ec3,
    number: $3ea8894c2d1a8ff8$export$98e628dec113755e,
    date: $3ea8894c2d1a8ff8$export$324d90190a8b822a,
    object: $3ea8894c2d1a8ff8$export$be5493f9613cbbe,
    array: $3ea8894c2d1a8ff8$export$2f23118c22fb2630,
    boolean: $3ea8894c2d1a8ff8$export$4a21f16c33752377
};

});
parcelRegister("58i62", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bcbbcae986c2431$export$2e2bcd8739ae039);
var $3bcbbcae986c2431$var$toString = Object.prototype.toString;
var $3bcbbcae986c2431$var$errorToString = Error.prototype.toString;
var $3bcbbcae986c2431$var$regExpToString = RegExp.prototype.toString;
var $3bcbbcae986c2431$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function() {
    return '';
};
var $3bcbbcae986c2431$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $3bcbbcae986c2431$var$printNumber(val) {
    if (val != +val) return 'NaN';
    var isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $3bcbbcae986c2431$var$printSimpleValue(val, quoteStrings) {
    if (quoteStrings === void 0) quoteStrings = false;
    if (val == null || val === true || val === false) return '' + val;
    var typeOf = typeof val;
    if (typeOf === 'number') return $3bcbbcae986c2431$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $3bcbbcae986c2431$var$symbolToString.call(val).replace($3bcbbcae986c2431$var$SYMBOL_REGEXP, 'Symbol($1)');
    var tag = $3bcbbcae986c2431$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $3bcbbcae986c2431$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $3bcbbcae986c2431$var$regExpToString.call(val);
    return null;
}
function $3bcbbcae986c2431$export$2e2bcd8739ae039(value, quoteStrings) {
    var result = $3bcbbcae986c2431$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        var result = $3bcbbcae986c2431$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}

});


parcelRegister("aQNBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e653e8008789a27$export$2e2bcd8739ae039);

var $8XLqy = parcelRequire("8XLqy");

var $2vNMA = parcelRequire("2vNMA");
var $7e653e8008789a27$var$Condition = /*#__PURE__*/ function() {
    function Condition(refs, options) {
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, $8XLqy.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        var is = options.is, then = options.then, otherwise = options.otherwise;
        var check = typeof is === 'function' ? is : function() {
            for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
            return values.every(function(value) {
                return value === is;
            });
        };
        this.fn = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            var options = args.pop();
            var schema = args.pop();
            var branch = check.apply(void 0, args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    var _proto = Condition.prototype;
    _proto.resolve = function resolve(base, options) {
        var values = this.refs.map(function(ref) {
            return ref.getValue(options);
        });
        var schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $2vNMA.default)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    };
    return Condition;
}();
var $7e653e8008789a27$export$2e2bcd8739ae039 = $7e653e8008789a27$var$Condition;

});
parcelRegister("2vNMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d4517ced724be00$export$2e2bcd8739ae039);
var $1d4517ced724be00$export$2e2bcd8739ae039 = function(obj) {
    return obj && obj.__isYupSchema__;
};

});


parcelRegister("6sdvp", function(module, exports) {

$parcel$export(module.exports, "propagateErrors", () => $4b2fd587c44d25ba$export$771abf5661930bfd);
$parcel$export(module.exports, "default", () => $4b2fd587c44d25ba$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $k5kZD = parcelRequire("k5kZD");

var $i6D11 = parcelRequire("i6D11");
var $4b2fd587c44d25ba$var$promise = function promise(sync) {
    return sync ? (0, $k5kZD.SynchronousPromise) : Promise;
};
var $4b2fd587c44d25ba$var$unwrapError = function unwrapError(errors) {
    if (errors === void 0) errors = [];
    return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};
function $4b2fd587c44d25ba$var$scopeToValue(promises, value, sync) {
    //console.log('scopeToValue', promises, value)
    var p = $4b2fd587c44d25ba$var$promise(sync).all(promises); //console.log('scopeToValue B', p)
    var b = p.catch(function(err) {
        if (err.name === 'ValidationError') err.value = value;
        throw err;
    }); //console.log('scopeToValue c', b)
    var c = b.then(function() {
        return value;
    }); //console.log('scopeToValue d', c)
    return c;
}
function $4b2fd587c44d25ba$export$771abf5661930bfd(endEarly, errors) {
    return endEarly ? null : function(err) {
        errors.push(err);
        return err.value;
    };
}
function $4b2fd587c44d25ba$export$3910381886d0de18(promises, sync) {
    var Promise1 = $4b2fd587c44d25ba$var$promise(sync);
    return Promise1.all(promises.map(function(p) {
        return Promise1.resolve(p).then(function(value) {
            return {
                fulfilled: true,
                value: value
            };
        }, function(value) {
            return {
                fulfilled: false,
                value: value
            };
        });
    }));
}
function $4b2fd587c44d25ba$export$7166359b4d75c140(_ref) {
    var validations = _ref.validations, value = _ref.value, path = _ref.path, sync = _ref.sync, errors = _ref.errors, sort = _ref.sort;
    errors = $4b2fd587c44d25ba$var$unwrapError(errors);
    return $4b2fd587c44d25ba$export$3910381886d0de18(validations, sync).then(function(results) {
        var nestedErrors = results.filter(function(r) {
            return !r.fulfilled;
        }).reduce(function(arr, _ref2) {
            var error = _ref2.value;
            // we are only collecting validation errors
            if (!(0, $i6D11.default).isError(error)) throw error;
            return arr.concat(error);
        }, []);
        if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
        errors = nestedErrors.concat(errors);
        if (errors.length) throw new (0, $i6D11.default)(errors, value, path);
        return value;
    });
}
function $4b2fd587c44d25ba$export$2e2bcd8739ae039(_ref3) {
    var endEarly = _ref3.endEarly, options = (0, $1En50.default)(_ref3, [
        "endEarly"
    ]);
    if (endEarly) return $4b2fd587c44d25ba$var$scopeToValue(options.validations, options.value, options.sync);
    return $4b2fd587c44d25ba$export$7166359b4d75c140(options);
}

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("k5kZD", function(module, exports) {
/* jshint node: true */ "use strict";
function $e9f48f17d53a2cf5$var$makeArrayFrom(obj) {
    return Array.prototype.slice.apply(obj);
}
var $e9f48f17d53a2cf5$var$PENDING = "pending", $e9f48f17d53a2cf5$var$RESOLVED = "resolved", $e9f48f17d53a2cf5$var$REJECTED = "rejected";
function $e9f48f17d53a2cf5$var$SynchronousPromise(handler) {
    this.status = $e9f48f17d53a2cf5$var$PENDING;
    this._continuations = [];
    this._parent = null;
    this._paused = false;
    if (handler) handler.call(this, this._continueWith.bind(this), this._failWith.bind(this));
}
function $e9f48f17d53a2cf5$var$looksLikeAPromise(obj) {
    return obj && typeof obj.then === "function";
}
function $e9f48f17d53a2cf5$var$passThrough(value) {
    return value;
}
$e9f48f17d53a2cf5$var$SynchronousPromise.prototype = {
    then: function(nextFn, catchFn) {
        var next = $e9f48f17d53a2cf5$var$SynchronousPromise.unresolved()._setParent(this);
        if (this._isRejected()) {
            if (this._paused) {
                this._continuations.push({
                    promise: next,
                    nextFn: nextFn,
                    catchFn: catchFn
                });
                return next;
            }
            if (catchFn) try {
                var catchResult = catchFn(this._error);
                if ($e9f48f17d53a2cf5$var$looksLikeAPromise(catchResult)) {
                    this._chainPromiseData(catchResult, next);
                    return next;
                } else return $e9f48f17d53a2cf5$var$SynchronousPromise.resolve(catchResult)._setParent(this);
            } catch (e) {
                return $e9f48f17d53a2cf5$var$SynchronousPromise.reject(e)._setParent(this);
            }
            return $e9f48f17d53a2cf5$var$SynchronousPromise.reject(this._error)._setParent(this);
        }
        this._continuations.push({
            promise: next,
            nextFn: nextFn,
            catchFn: catchFn
        });
        this._runResolutions();
        return next;
    },
    catch: function(handler) {
        if (this._isResolved()) return $e9f48f17d53a2cf5$var$SynchronousPromise.resolve(this._data)._setParent(this);
        var next = $e9f48f17d53a2cf5$var$SynchronousPromise.unresolved()._setParent(this);
        this._continuations.push({
            promise: next,
            catchFn: handler
        });
        this._runRejections();
        return next;
    },
    finally: function(callback) {
        var ran = false;
        function runFinally(result, err) {
            if (!ran) {
                ran = true;
                if (!callback) callback = $e9f48f17d53a2cf5$var$passThrough;
                var callbackResult = callback(result);
                if ($e9f48f17d53a2cf5$var$looksLikeAPromise(callbackResult)) return callbackResult.then(function() {
                    if (err) throw err;
                    return result;
                });
                else return result;
            }
        }
        return this.then(function(result) {
            return runFinally(result);
        }).catch(function(err) {
            return runFinally(null, err);
        });
    },
    pause: function() {
        this._paused = true;
        return this;
    },
    resume: function() {
        var firstPaused = this._findFirstPaused();
        if (firstPaused) {
            firstPaused._paused = false;
            firstPaused._runResolutions();
            firstPaused._runRejections();
        }
        return this;
    },
    _findAncestry: function() {
        return this._continuations.reduce(function(acc, cur) {
            if (cur.promise) {
                var node = {
                    promise: cur.promise,
                    children: cur.promise._findAncestry()
                };
                acc.push(node);
            }
            return acc;
        }, []);
    },
    _setParent: function(parent) {
        if (this._parent) throw new Error("parent already set");
        this._parent = parent;
        return this;
    },
    _continueWith: function(data) {
        var firstPending = this._findFirstPending();
        if (firstPending) {
            firstPending._data = data;
            firstPending._setResolved();
        }
    },
    _findFirstPending: function() {
        return this._findFirstAncestor(function(test) {
            return test._isPending && test._isPending();
        });
    },
    _findFirstPaused: function() {
        return this._findFirstAncestor(function(test) {
            return test._paused;
        });
    },
    _findFirstAncestor: function(matching) {
        var test = this;
        var result;
        while(test){
            if (matching(test)) result = test;
            test = test._parent;
        }
        return result;
    },
    _failWith: function(error) {
        var firstRejected = this._findFirstPending();
        if (firstRejected) {
            firstRejected._error = error;
            firstRejected._setRejected();
        }
    },
    _takeContinuations: function() {
        return this._continuations.splice(0, this._continuations.length);
    },
    _runRejections: function() {
        if (this._paused || !this._isRejected()) return;
        var error = this._error, continuations = this._takeContinuations(), self = this;
        continuations.forEach(function(cont) {
            if (cont.catchFn) try {
                var catchResult = cont.catchFn(error);
                self._handleUserFunctionResult(catchResult, cont.promise);
            } catch (e) {
                cont.promise.reject(e);
            }
            else cont.promise.reject(error);
        });
    },
    _runResolutions: function() {
        if (this._paused || !this._isResolved() || this._isPending()) return;
        var continuations = this._takeContinuations();
        if ($e9f48f17d53a2cf5$var$looksLikeAPromise(this._data)) return this._handleWhenResolvedDataIsPromise(this._data);
        var data = this._data;
        var self = this;
        continuations.forEach(function(cont) {
            if (cont.nextFn) try {
                var result = cont.nextFn(data);
                self._handleUserFunctionResult(result, cont.promise);
            } catch (e) {
                self._handleResolutionError(e, cont);
            }
            else if (cont.promise) cont.promise.resolve(data);
        });
    },
    _handleResolutionError: function(e, continuation) {
        this._setRejected();
        if (continuation.catchFn) try {
            continuation.catchFn(e);
            return;
        } catch (e2) {
            e = e2;
        }
        if (continuation.promise) continuation.promise.reject(e);
    },
    _handleWhenResolvedDataIsPromise: function(data) {
        var self = this;
        return data.then(function(result) {
            self._data = result;
            self._runResolutions();
        }).catch(function(error) {
            self._error = error;
            self._setRejected();
            self._runRejections();
        });
    },
    _handleUserFunctionResult: function(data, nextSynchronousPromise) {
        if ($e9f48f17d53a2cf5$var$looksLikeAPromise(data)) this._chainPromiseData(data, nextSynchronousPromise);
        else nextSynchronousPromise.resolve(data);
    },
    _chainPromiseData: function(promiseData, nextSynchronousPromise) {
        promiseData.then(function(newData) {
            nextSynchronousPromise.resolve(newData);
        }).catch(function(newError) {
            nextSynchronousPromise.reject(newError);
        });
    },
    _setResolved: function() {
        this.status = $e9f48f17d53a2cf5$var$RESOLVED;
        if (!this._paused) this._runResolutions();
    },
    _setRejected: function() {
        this.status = $e9f48f17d53a2cf5$var$REJECTED;
        if (!this._paused) this._runRejections();
    },
    _isPending: function() {
        return this.status === $e9f48f17d53a2cf5$var$PENDING;
    },
    _isResolved: function() {
        return this.status === $e9f48f17d53a2cf5$var$RESOLVED;
    },
    _isRejected: function() {
        return this.status === $e9f48f17d53a2cf5$var$REJECTED;
    }
};
$e9f48f17d53a2cf5$var$SynchronousPromise.resolve = function(result) {
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve, reject) {
        if ($e9f48f17d53a2cf5$var$looksLikeAPromise(result)) result.then(function(newResult) {
            resolve(newResult);
        }).catch(function(error) {
            reject(error);
        });
        else resolve(result);
    });
};
$e9f48f17d53a2cf5$var$SynchronousPromise.reject = function(result) {
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve, reject) {
        reject(result);
    });
};
$e9f48f17d53a2cf5$var$SynchronousPromise.unresolved = function() {
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve, reject) {
        this.resolve = resolve;
        this.reject = reject;
    });
};
$e9f48f17d53a2cf5$var$SynchronousPromise.all = function() {
    var args = $e9f48f17d53a2cf5$var$makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return $e9f48f17d53a2cf5$var$SynchronousPromise.resolve([]);
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve, reject) {
        var allData = [], numResolved = 0, doResolve = function() {
            if (numResolved === args.length) resolve(allData);
        }, rejected = false, doReject = function(err) {
            if (rejected) return;
            rejected = true;
            reject(err);
        };
        args.forEach(function(arg, idx) {
            $e9f48f17d53a2cf5$var$SynchronousPromise.resolve(arg).then(function(thisResult) {
                allData[idx] = thisResult;
                numResolved += 1;
                doResolve();
            }).catch(function(err) {
                doReject(err);
            });
        });
    });
};
function $e9f48f17d53a2cf5$var$createAggregateErrorFrom(errors) {
    /* jshint ignore:start */ if (typeof window !== "undefined" && "AggregateError" in window) return new window.AggregateError(errors);
    /* jshint ignore:end */ return {
        errors: errors
    };
}
$e9f48f17d53a2cf5$var$SynchronousPromise.any = function() {
    var args = $e9f48f17d53a2cf5$var$makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return $e9f48f17d53a2cf5$var$SynchronousPromise.reject($e9f48f17d53a2cf5$var$createAggregateErrorFrom([]));
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve, reject) {
        var allErrors = [], numRejected = 0, doReject = function() {
            if (numRejected === args.length) reject($e9f48f17d53a2cf5$var$createAggregateErrorFrom(allErrors));
        }, resolved = false, doResolve = function(result) {
            if (resolved) return;
            resolved = true;
            resolve(result);
        };
        args.forEach(function(arg, idx) {
            $e9f48f17d53a2cf5$var$SynchronousPromise.resolve(arg).then(function(thisResult) {
                doResolve(thisResult);
            }).catch(function(err) {
                allErrors[idx] = err;
                numRejected += 1;
                doReject();
            });
        });
    });
};
$e9f48f17d53a2cf5$var$SynchronousPromise.allSettled = function() {
    var args = $e9f48f17d53a2cf5$var$makeArrayFrom(arguments);
    if (Array.isArray(args[0])) args = args[0];
    if (!args.length) return $e9f48f17d53a2cf5$var$SynchronousPromise.resolve([]);
    return new $e9f48f17d53a2cf5$var$SynchronousPromise(function(resolve) {
        var allData = [], numSettled = 0, doSettled = function() {
            numSettled += 1;
            if (numSettled === args.length) resolve(allData);
        };
        args.forEach(function(arg, idx) {
            $e9f48f17d53a2cf5$var$SynchronousPromise.resolve(arg).then(function(thisResult) {
                allData[idx] = {
                    status: "fulfilled",
                    value: thisResult
                };
                doSettled();
            }).catch(function(err) {
                allData[idx] = {
                    status: "rejected",
                    reason: err
                };
                doSettled();
            });
        });
    });
};
/* jshint ignore:start */ if (Promise === $e9f48f17d53a2cf5$var$SynchronousPromise) throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
var $e9f48f17d53a2cf5$var$RealPromise = Promise;
$e9f48f17d53a2cf5$var$SynchronousPromise.installGlobally = function(__awaiter) {
    if (Promise === $e9f48f17d53a2cf5$var$SynchronousPromise) return __awaiter;
    var result = $e9f48f17d53a2cf5$var$patchAwaiterIfRequired(__awaiter);
    Promise = $e9f48f17d53a2cf5$var$SynchronousPromise;
    return result;
};
$e9f48f17d53a2cf5$var$SynchronousPromise.uninstallGlobally = function() {
    if (Promise === $e9f48f17d53a2cf5$var$SynchronousPromise) Promise = $e9f48f17d53a2cf5$var$RealPromise;
};
function $e9f48f17d53a2cf5$var$patchAwaiterIfRequired(__awaiter) {
    if (typeof __awaiter === "undefined" || __awaiter.__patched) return __awaiter;
    var originalAwaiter = __awaiter;
    __awaiter = function() {
        var Promise1 = $e9f48f17d53a2cf5$var$RealPromise;
        originalAwaiter.apply(this, $e9f48f17d53a2cf5$var$makeArrayFrom(arguments));
    };
    __awaiter.__patched = true;
    return __awaiter;
}
/* jshint ignore:end */ module.exports = {
    SynchronousPromise: $e9f48f17d53a2cf5$var$SynchronousPromise
};

});

parcelRegister("i6D11", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e70d35996a7daf$export$2e2bcd8739ae039);

var $58i62 = parcelRequire("58i62");
var $d2e70d35996a7daf$var$strReg = /\$\{\s*(\w+)\s*\}/g;
var $d2e70d35996a7daf$var$replace = function replace(str) {
    return function(params) {
        return str.replace($d2e70d35996a7daf$var$strReg, function(_, key) {
            return (0, $58i62.default)(params[key]);
        });
    };
};
function $d2e70d35996a7daf$export$2e2bcd8739ae039(errors, value, field, type) {
    var _this = this;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    if (errors) [].concat(errors).forEach(function(err) {
        _this.errors = _this.errors.concat(err.errors || err);
        if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
    });
    this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, $d2e70d35996a7daf$export$2e2bcd8739ae039);
}
$d2e70d35996a7daf$export$2e2bcd8739ae039.prototype = Object.create(Error.prototype);
$d2e70d35996a7daf$export$2e2bcd8739ae039.prototype.constructor = $d2e70d35996a7daf$export$2e2bcd8739ae039;
$d2e70d35996a7daf$export$2e2bcd8739ae039.isError = function(err) {
    return err && err.name === 'ValidationError';
};
$d2e70d35996a7daf$export$2e2bcd8739ae039.formatError = function(message, params) {
    if (typeof message === 'string') message = $d2e70d35996a7daf$var$replace(message);
    var fn = function fn(params) {
        params.path = params.label || params.path || 'this';
        return typeof message === 'function' ? message(params) : message;
    };
    return arguments.length === 1 ? fn : fn(params);
};

});


parcelRegister("lLrpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd833efe29c4d28c$export$2e2bcd8739ae039);

var $8XLqy = parcelRequire("8XLqy");

var $2vNMA = parcelRequire("2vNMA");
var $fd833efe29c4d28c$var$isObject = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
function $fd833efe29c4d28c$export$2e2bcd8739ae039(target, source) {
    for(var key in source)if ((0, $8XLqy.default)(source, key)) {
        var sourceVal = source[key], targetVal = target[key];
        if (targetVal === undefined) target[key] = sourceVal;
        else if (targetVal === sourceVal) continue;
        else if ((0, $2vNMA.default)(targetVal)) {
            if ((0, $2vNMA.default)(sourceVal)) target[key] = sourceVal.concat(targetVal);
        } else if ($fd833efe29c4d28c$var$isObject(targetVal)) {
            if ($fd833efe29c4d28c$var$isObject(sourceVal)) target[key] = $fd833efe29c4d28c$export$2e2bcd8739ae039(targetVal, sourceVal);
        } else if (Array.isArray(targetVal)) {
            if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
        }
    }
    return target;
}

});

parcelRegister("aFRKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c576e9ad8044c54$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hnngZ = parcelRequire("hnngZ");

var $i6D11 = parcelRequire("i6D11");

var $l6pyh = parcelRequire("l6pyh");

var $k5kZD = parcelRequire("k5kZD");
var $7c576e9ad8044c54$var$formatError = (0, $i6D11.default).formatError;
var $7c576e9ad8044c54$var$thenable = function thenable(p) {
    return p && typeof p.then === 'function' && typeof p.catch === 'function';
};
function $7c576e9ad8044c54$var$runTest(testFn, ctx, value, sync) {
    var result = testFn.call(ctx, value);
    if (!sync) return Promise.resolve(result);
    if ($7c576e9ad8044c54$var$thenable(result)) throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
    return (0, $k5kZD.SynchronousPromise).resolve(result);
}
function $7c576e9ad8044c54$var$resolveParams(oldParams, newParams, resolve) {
    return (0, $hnngZ.default)((0, $8nd05.default)({}, oldParams, newParams), resolve);
}
function $7c576e9ad8044c54$export$404dbf22c24db6ba(_ref) {
    var value = _ref.value, label = _ref.label, resolve = _ref.resolve, originalValue = _ref.originalValue, opts = (0, $1En50.default)(_ref, [
        "value",
        "label",
        "resolve",
        "originalValue"
    ]);
    return function createError(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$path = _ref2.path, path = _ref2$path === void 0 ? opts.path : _ref2$path, _ref2$message = _ref2.message, message = _ref2$message === void 0 ? opts.message : _ref2$message, _ref2$type = _ref2.type, type = _ref2$type === void 0 ? opts.name : _ref2$type, params = _ref2.params;
        params = (0, $8nd05.default)({
            path: path,
            value: value,
            originalValue: originalValue,
            label: label
        }, $7c576e9ad8044c54$var$resolveParams(opts.params, params, resolve));
        return (0, $8nd05.default)(new (0, $i6D11.default)($7c576e9ad8044c54$var$formatError(message, params), value, path, type), {
            params: params
        });
    };
}
function $7c576e9ad8044c54$export$2e2bcd8739ae039(options) {
    var name = options.name, message = options.message, test = options.test, params = options.params;
    function validate(_ref3) {
        var value = _ref3.value, path = _ref3.path, label = _ref3.label, options = _ref3.options, originalValue = _ref3.originalValue, sync = _ref3.sync, rest = (0, $1En50.default)(_ref3, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        var parent = options.parent;
        var resolve = function resolve(item) {
            return (0, $l6pyh.default).isRef(item) ? item.getValue({
                value: value,
                parent: parent,
                context: options.context
            }) : item;
        };
        var createError = $7c576e9ad8044c54$export$404dbf22c24db6ba({
            message: message,
            path: path,
            value: value,
            originalValue: originalValue,
            params: params,
            label: label,
            resolve: resolve,
            name: name
        });
        var ctx = (0, $8nd05.default)({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options
        }, rest);
        return $7c576e9ad8044c54$var$runTest(test, ctx, value, sync).then(function(validOrError) {
            if ((0, $i6D11.default).isError(validOrError)) throw validOrError;
            else if (!validOrError) throw createError();
        });
    }
    validate.OPTIONS = options;
    return validate;
}

});
parcelRegister("hnngZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca66a3307a349412$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $by0Fh = parcelRequire("by0Fh");

var $dKmGr = parcelRequire("dKmGr");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $ca66a3307a349412$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = (0, $dKmGr.default)(iteratee, 3);
    (0, $by0Fh.default)(object, function(value, key, object) {
        (0, $dLTlW.default)(result, key, iteratee(value, key, object));
    });
    return result;
}
var $ca66a3307a349412$export$2e2bcd8739ae039 = $ca66a3307a349412$var$mapValues;

});
parcelRegister("by0Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $868362ae4d3d3a88$export$2e2bcd8739ae039);

var $RlazS = parcelRequire("RlazS");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $868362ae4d3d3a88$var$baseForOwn(object, iteratee) {
    return object && (0, $RlazS.default)(object, iteratee, (0, $8krEv.default));
}
var $868362ae4d3d3a88$export$2e2bcd8739ae039 = $868362ae4d3d3a88$var$baseForOwn;

});
parcelRegister("RlazS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a055f31ee6b9615$export$2e2bcd8739ae039);

var $XI7zJ = parcelRequire("XI7zJ");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0a055f31ee6b9615$var$baseFor = (0, $XI7zJ.default)();
var $0a055f31ee6b9615$export$2e2bcd8739ae039 = $0a055f31ee6b9615$var$baseFor;

});
parcelRegister("XI7zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b37bc59bcb3fc9f$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $0b37bc59bcb3fc9f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $0b37bc59bcb3fc9f$export$2e2bcd8739ae039 = $0b37bc59bcb3fc9f$var$createBaseFor;

});



parcelRegister("dKmGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0212ab78648add2$export$2e2bcd8739ae039);

var $3a0Ub = parcelRequire("3a0Ub");

var $dblNV = parcelRequire("dblNV");

var $jSR8v = parcelRequire("jSR8v");

var $hf0C9 = parcelRequire("hf0C9");

var $gFZ2v = parcelRequire("gFZ2v");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $a0212ab78648add2$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $jSR8v.default;
    if (typeof value == 'object') return (0, $hf0C9.default)(value) ? (0, $dblNV.default)(value[0], value[1]) : (0, $3a0Ub.default)(value);
    return (0, $gFZ2v.default)(value);
}
var $a0212ab78648add2$export$2e2bcd8739ae039 = $a0212ab78648add2$var$baseIteratee;

});
parcelRegister("3a0Ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d30208023909d0$export$2e2bcd8739ae039);

var $lgJAv = parcelRequire("lgJAv");

var $7H3kZ = parcelRequire("7H3kZ");

var $fgvE4 = parcelRequire("fgvE4");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $24d30208023909d0$var$baseMatches(source) {
    var matchData = (0, $7H3kZ.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $fgvE4.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $lgJAv.default)(object, source, matchData);
    };
}
var $24d30208023909d0$export$2e2bcd8739ae039 = $24d30208023909d0$var$baseMatches;

});
parcelRegister("lgJAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7be745fcdc67850$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $h2imA = parcelRequire("h2imA");
/** Used to compose bitmasks for value comparisons. */ var $f7be745fcdc67850$var$COMPARE_PARTIAL_FLAG = 1, $f7be745fcdc67850$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f7be745fcdc67850$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $9WjpT.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $h2imA.default)(srcValue, objValue, $f7be745fcdc67850$var$COMPARE_PARTIAL_FLAG | $f7be745fcdc67850$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $f7be745fcdc67850$export$2e2bcd8739ae039 = $f7be745fcdc67850$var$baseIsMatch;

});
parcelRegister("h2imA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c670de299407e555$export$2e2bcd8739ae039);

var $jneo7 = parcelRequire("jneo7");

var $f2iog = parcelRequire("f2iog");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $c670de299407e555$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $f2iog.default)(value) && !(0, $f2iog.default)(other)) return value !== value && other !== other;
    return (0, $jneo7.default)(value, other, bitmask, customizer, $c670de299407e555$var$baseIsEqual, stack);
}
var $c670de299407e555$export$2e2bcd8739ae039 = $c670de299407e555$var$baseIsEqual;

});
parcelRegister("jneo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ab537c68aa36d5$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $etcwV = parcelRequire("etcwV");

var $alETr = parcelRequire("alETr");

var $517wt = parcelRequire("517wt");

var $4wkSQ = parcelRequire("4wkSQ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cmTeE = parcelRequire("cmTeE");
/** Used to compose bitmasks for value comparisons. */ var $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e1ab537c68aa36d5$var$argsTag = '[object Arguments]', $e1ab537c68aa36d5$var$arrayTag = '[object Array]', $e1ab537c68aa36d5$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e1ab537c68aa36d5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e1ab537c68aa36d5$var$hasOwnProperty = $e1ab537c68aa36d5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e1ab537c68aa36d5$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $hf0C9.default)(object), othIsArr = (0, $hf0C9.default)(other), objTag = objIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $4wkSQ.default)(object), othTag = othIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $4wkSQ.default)(other);
    objTag = objTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : objTag;
    othTag = othTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : othTag;
    var objIsObj = objTag == $e1ab537c68aa36d5$var$objectTag, othIsObj = othTag == $e1ab537c68aa36d5$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $f3ZL4.default)(object)) {
        if (!(0, $f3ZL4.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $9WjpT.default));
        return objIsArr || (0, $cmTeE.default)(object) ? (0, $etcwV.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $alETr.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $9WjpT.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $9WjpT.default));
    return (0, $517wt.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $e1ab537c68aa36d5$export$2e2bcd8739ae039 = $e1ab537c68aa36d5$var$baseIsEqualDeep;

});
parcelRegister("etcwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a88d7e53afca3b5f$export$2e2bcd8739ae039);

var $dTR92 = parcelRequire("dTR92");

var $8v1iI = parcelRequire("8v1iI");

var $lEs8E = parcelRequire("lEs8E");
/** Used to compose bitmasks for value comparisons. */ var $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG = 1, $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a88d7e53afca3b5f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG ? new (0, $dTR92.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $8v1iI.default)(other, function(othValue, othIndex) {
                if (!(0, $lEs8E.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $a88d7e53afca3b5f$export$2e2bcd8739ae039 = $a88d7e53afca3b5f$var$equalArrays;

});
parcelRegister("dTR92", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e9a2ddf37e1e25$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");

var $j3oih = parcelRequire("j3oih");

var $ebCAc = parcelRequire("ebCAc");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a1e9a2ddf37e1e25$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $7n3PR.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a1e9a2ddf37e1e25$var$SetCache.prototype.add = $a1e9a2ddf37e1e25$var$SetCache.prototype.push = (0, $j3oih.default);
$a1e9a2ddf37e1e25$var$SetCache.prototype.has = (0, $ebCAc.default);
var $a1e9a2ddf37e1e25$export$2e2bcd8739ae039 = $a1e9a2ddf37e1e25$var$SetCache;

});
parcelRegister("j3oih", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf12460e0325b87$export$2e2bcd8739ae039);
/** Used to stand-in for `undefined` hash values. */ var $ddf12460e0325b87$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $ddf12460e0325b87$var$setCacheAdd(value) {
    this.__data__.set(value, $ddf12460e0325b87$var$HASH_UNDEFINED);
    return this;
}
var $ddf12460e0325b87$export$2e2bcd8739ae039 = $ddf12460e0325b87$var$setCacheAdd;

});

parcelRegister("ebCAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5400587c2b0dcec$export$2e2bcd8739ae039);
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $a5400587c2b0dcec$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $a5400587c2b0dcec$export$2e2bcd8739ae039 = $a5400587c2b0dcec$var$setCacheHas;

});


parcelRegister("8v1iI", function(module, exports) {

$parcel$export(module.exports, "default", () => $63023a486d78f8d1$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $63023a486d78f8d1$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $63023a486d78f8d1$export$2e2bcd8739ae039 = $63023a486d78f8d1$var$arraySome;

});

parcelRegister("lEs8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc33292595196d6a$export$2e2bcd8739ae039);
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc33292595196d6a$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $fc33292595196d6a$export$2e2bcd8739ae039 = $fc33292595196d6a$var$cacheHas;

});


parcelRegister("alETr", function(module, exports) {

$parcel$export(module.exports, "default", () => $788b9615ccc4ea9d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $dJVnF = parcelRequire("dJVnF");

var $lvgV1 = parcelRequire("lvgV1");

var $etcwV = parcelRequire("etcwV");

var $7YTsx = parcelRequire("7YTsx");

var $827W0 = parcelRequire("827W0");
/** Used to compose bitmasks for value comparisons. */ var $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG = 1, $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $788b9615ccc4ea9d$var$boolTag = '[object Boolean]', $788b9615ccc4ea9d$var$dateTag = '[object Date]', $788b9615ccc4ea9d$var$errorTag = '[object Error]', $788b9615ccc4ea9d$var$mapTag = '[object Map]', $788b9615ccc4ea9d$var$numberTag = '[object Number]', $788b9615ccc4ea9d$var$regexpTag = '[object RegExp]', $788b9615ccc4ea9d$var$setTag = '[object Set]', $788b9615ccc4ea9d$var$stringTag = '[object String]', $788b9615ccc4ea9d$var$symbolTag = '[object Symbol]';
var $788b9615ccc4ea9d$var$arrayBufferTag = '[object ArrayBuffer]', $788b9615ccc4ea9d$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $788b9615ccc4ea9d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $788b9615ccc4ea9d$var$symbolValueOf = $788b9615ccc4ea9d$var$symbolProto ? $788b9615ccc4ea9d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $788b9615ccc4ea9d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $788b9615ccc4ea9d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $788b9615ccc4ea9d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $dJVnF.default)(object), new (0, $dJVnF.default)(other))) return false;
            return true;
        case $788b9615ccc4ea9d$var$boolTag:
        case $788b9615ccc4ea9d$var$dateTag:
        case $788b9615ccc4ea9d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $lvgV1.default)(+object, +other);
        case $788b9615ccc4ea9d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $788b9615ccc4ea9d$var$regexpTag:
        case $788b9615ccc4ea9d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $788b9615ccc4ea9d$var$mapTag:
            var convert = (0, $7YTsx.default);
        case $788b9615ccc4ea9d$var$setTag:
            var isPartial = bitmask & $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $827W0.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $etcwV.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $788b9615ccc4ea9d$var$symbolTag:
            if ($788b9615ccc4ea9d$var$symbolValueOf) return $788b9615ccc4ea9d$var$symbolValueOf.call(object) == $788b9615ccc4ea9d$var$symbolValueOf.call(other);
    }
    return false;
}
var $788b9615ccc4ea9d$export$2e2bcd8739ae039 = $788b9615ccc4ea9d$var$equalByTag;

});

parcelRegister("517wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a72e1a244e07566$export$2e2bcd8739ae039);

var $oK0lo = parcelRequire("oK0lo");
/** Used to compose bitmasks for value comparisons. */ var $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3a72e1a244e07566$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3a72e1a244e07566$var$hasOwnProperty = $3a72e1a244e07566$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3a72e1a244e07566$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG, objProps = (0, $oK0lo.default)(object), objLength = objProps.length, othProps = (0, $oK0lo.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3a72e1a244e07566$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $3a72e1a244e07566$export$2e2bcd8739ae039 = $3a72e1a244e07566$var$equalObjects;

});




parcelRegister("7H3kZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $599f234e9e3f0f59$export$2e2bcd8739ae039);

var $jfIsX = parcelRequire("jfIsX");

var $8krEv = parcelRequire("8krEv");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $599f234e9e3f0f59$var$getMatchData(object) {
    var result = (0, $8krEv.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $jfIsX.default)(value)
        ];
    }
    return result;
}
var $599f234e9e3f0f59$export$2e2bcd8739ae039 = $599f234e9e3f0f59$var$getMatchData;

});
parcelRegister("jfIsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e041e90de407bce3$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e041e90de407bce3$var$isStrictComparable(value) {
    return value === value && !(0, $iYDsF.default)(value);
}
var $e041e90de407bce3$export$2e2bcd8739ae039 = $e041e90de407bce3$var$isStrictComparable;

});


parcelRegister("fgvE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d0e5b68de69e09$export$2e2bcd8739ae039);
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b1d0e5b68de69e09$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $b1d0e5b68de69e09$export$2e2bcd8739ae039 = $b1d0e5b68de69e09$var$matchesStrictComparable;

});


parcelRegister("dblNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $998d375609b22804$export$2e2bcd8739ae039);

var $h2imA = parcelRequire("h2imA");

var $kWunJ = parcelRequire("kWunJ");

var $cMLDw = parcelRequire("cMLDw");

var $6f10l = parcelRequire("6f10l");

var $jfIsX = parcelRequire("jfIsX");

var $fgvE4 = parcelRequire("fgvE4");

var $ft2bY = parcelRequire("ft2bY");
/** Used to compose bitmasks for value comparisons. */ var $998d375609b22804$var$COMPARE_PARTIAL_FLAG = 1, $998d375609b22804$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $998d375609b22804$var$baseMatchesProperty(path, srcValue) {
    if ((0, $6f10l.default)(path) && (0, $jfIsX.default)(srcValue)) return (0, $fgvE4.default)((0, $ft2bY.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $kWunJ.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $cMLDw.default)(object, path) : (0, $h2imA.default)(srcValue, objValue, $998d375609b22804$var$COMPARE_PARTIAL_FLAG | $998d375609b22804$var$COMPARE_UNORDERED_FLAG);
    };
}
var $998d375609b22804$export$2e2bcd8739ae039 = $998d375609b22804$var$baseMatchesProperty;

});
parcelRegister("kWunJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f0ca997cdf37f0$export$2e2bcd8739ae039);

var $foHRp = parcelRequire("foHRp");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $f3f0ca997cdf37f0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $foHRp.default)(object, path);
    return result === undefined ? defaultValue : result;
}
var $f3f0ca997cdf37f0$export$2e2bcd8739ae039 = $f3f0ca997cdf37f0$var$get;

});
parcelRegister("foHRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35b1eb26f74d6d6$export$2e2bcd8739ae039);

var $dUJCp = parcelRequire("dUJCp");

var $ft2bY = parcelRequire("ft2bY");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b35b1eb26f74d6d6$var$baseGet(object, path) {
    path = (0, $dUJCp.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $ft2bY.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $b35b1eb26f74d6d6$export$2e2bcd8739ae039 = $b35b1eb26f74d6d6$var$baseGet;

});


parcelRegister("cMLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94eeeb5c0678fbac$export$2e2bcd8739ae039);

var $kyik6 = parcelRequire("kyik6");

var $3AXYs = parcelRequire("3AXYs");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $94eeeb5c0678fbac$var$hasIn(object, path) {
    return object != null && (0, $3AXYs.default)(object, path, (0, $kyik6.default));
}
var $94eeeb5c0678fbac$export$2e2bcd8739ae039 = $94eeeb5c0678fbac$var$hasIn;

});
parcelRegister("kyik6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef65323979230da4$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ef65323979230da4$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $ef65323979230da4$export$2e2bcd8739ae039 = $ef65323979230da4$var$baseHasIn;

});



parcelRegister("jSR8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e79c473b2396ff2f$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e79c473b2396ff2f$var$identity(value) {
    return value;
}
var $e79c473b2396ff2f$export$2e2bcd8739ae039 = $e79c473b2396ff2f$var$identity;

});

parcelRegister("gFZ2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23fd2d05c98c812$export$2e2bcd8739ae039);

var $7cEkV = parcelRequire("7cEkV");

var $axdWU = parcelRequire("axdWU");

var $6f10l = parcelRequire("6f10l");

var $ft2bY = parcelRequire("ft2bY");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $c23fd2d05c98c812$var$property(path) {
    return (0, $6f10l.default)(path) ? (0, $7cEkV.default)((0, $ft2bY.default)(path)) : (0, $axdWU.default)(path);
}
var $c23fd2d05c98c812$export$2e2bcd8739ae039 = $c23fd2d05c98c812$var$property;

});
parcelRegister("7cEkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e8f161f80fe1f1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $53e8f161f80fe1f1$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $53e8f161f80fe1f1$export$2e2bcd8739ae039 = $53e8f161f80fe1f1$var$baseProperty;

});

parcelRegister("axdWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ab7ce7ad108fa99$export$2e2bcd8739ae039);

var $foHRp = parcelRequire("foHRp");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7ab7ce7ad108fa99$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $foHRp.default)(object, path);
    };
}
var $7ab7ce7ad108fa99$export$2e2bcd8739ae039 = $7ab7ce7ad108fa99$var$basePropertyDeep;

});




parcelRegister("l6pyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5cdfa956e941194$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $Sk64T = parcelRequire("Sk64T");
var $f5cdfa956e941194$var$prefixes = {
    context: '$',
    value: '.'
};
var $f5cdfa956e941194$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Reference(key, options) {
        if (options === void 0) options = {};
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $f5cdfa956e941194$var$prefixes.context;
        this.isValue = this.key[0] === $f5cdfa956e941194$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        var prefix = this.isContext ? $f5cdfa956e941194$var$prefixes.context : this.isValue ? $f5cdfa956e941194$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $Sk64T.getter)(this.path, true);
        this.map = options.map;
    }
    var _proto = Reference.prototype;
    _proto.getValue = function getValue(options) {
        var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    };
    _proto.cast = function cast(value, options) {
        return this.getValue((0, $8nd05.default)({}, options, {
            value: value
        }));
    };
    _proto.resolve = function resolve() {
        return this;
    };
    _proto.describe = function describe() {
        return {
            type: 'ref',
            key: this.key
        };
    };
    _proto.toString = function toString() {
        return "Ref(" + this.key + ")";
    };
    Reference.isRef = function isRef(value) {
        return value && value.__isYupRef;
    };
    return Reference;
}();
$f5cdfa956e941194$export$2e2bcd8739ae039.prototype.__isYupRef = true;

});
parcelRegister("Sk64T", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
module.exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX);
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}

});



parcelRegister("7Qa2h", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $5b552ca0a6c1ed5f$export$c52e5867d5879e24);

var $Sk64T = parcelRequire("Sk64T");
var $5b552ca0a6c1ed5f$var$trim = function trim(part) {
    return part.substr(0, part.length - 1).substr(1);
};
function $5b552ca0a6c1ed5f$export$c52e5867d5879e24(schema, path, value, context) {
    if (context === void 0) context = value;
    var parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $Sk64T.forEach)(path, function(_part, isBracket, isArray) {
        var part = isBracket ? $5b552ca0a6c1ed5f$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            var idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\")"));
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
var $5b552ca0a6c1ed5f$var$reach = function reach(obj, path, value, context) {
    return $5b552ca0a6c1ed5f$export$c52e5867d5879e24(obj, path, value, context).schema;
};
var $5b552ca0a6c1ed5f$export$2e2bcd8739ae039 = $5b552ca0a6c1ed5f$var$reach;

});


parcelRegister("gcL7X", function(module, exports) {

$parcel$export(module.exports, "default", () => StringSchema);

var $9H9Di = parcelRequire("9H9Di");

var $dmHdY = parcelRequire("dmHdY");

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
var rUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var isTrimmed = function isTrimmed(value) {
    return (0, $7mZW8.default)(value) || value === value.trim();
};
function StringSchema() {
    var _this = this;
    if (!(this instanceof StringSchema)) return new StringSchema();
    (0, $dmHdY.default).call(this, {
        type: 'string'
    });
    this.withMutation(function() {
        _this.transform(function(value) {
            if (this.isType(value)) return value;
            return value != null && value.toString ? value.toString() : value;
        });
    });
}
(0, $9H9Di.default)(StringSchema, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    },
    _isPresent: function _isPresent(value) {
        return (0, $dmHdY.default).prototype._isPresent.call(this, value) && value.length > 0;
    },
    length: function length(_length, message) {
        if (message === void 0) message = (0, $5nwN5.string).length;
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: _length
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value.length === this.resolve(_length);
            }
        });
    },
    min: function min(_min, message) {
        if (message === void 0) message = (0, $5nwN5.string).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: _min
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value.length >= this.resolve(_min);
            }
        });
    },
    max: function max(_max, message) {
        if (message === void 0) message = (0, $5nwN5.string).max;
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: _max
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value.length <= this.resolve(_max);
            }
        });
    },
    matches: function matches(regex, options) {
        var excludeEmptyString = false;
        var message;
        var name;
        if (options) {
            if (typeof options === 'object') {
                excludeEmptyString = options.excludeEmptyString;
                message = options.message;
                name = options.name;
            } else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $5nwN5.string).matches,
            params: {
                regex: regex
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1;
            }
        });
    },
    email: function email(message) {
        if (message === void 0) message = (0, $5nwN5.string).email;
        return this.matches(rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    },
    url: function url(message) {
        if (message === void 0) message = (0, $5nwN5.string).url;
        return this.matches(rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    },
    uuid: function uuid(message) {
        if (message === void 0) message = (0, $5nwN5.string).uuid;
        return this.matches(rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    },
    //-- transforms --
    ensure: function ensure() {
        return this.default('').transform(function(val) {
            return val === null ? '' : val;
        });
    },
    trim: function trim(message) {
        if (message === void 0) message = (0, $5nwN5.string).trim;
        return this.transform(function(val) {
            return val != null ? val.trim() : val;
        }).test({
            message: message,
            name: 'trim',
            test: isTrimmed
        });
    },
    lowercase: function lowercase(message) {
        if (message === void 0) message = (0, $5nwN5.string).lowercase;
        return this.transform(function(value) {
            return !(0, $7mZW8.default)(value) ? value.toLowerCase() : value;
        }).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value === value.toLowerCase();
            }
        });
    },
    uppercase: function uppercase(message) {
        if (message === void 0) message = (0, $5nwN5.string).uppercase;
        return this.transform(function(value) {
            return !(0, $7mZW8.default)(value) ? value.toUpperCase() : value;
        }).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value === value.toUpperCase();
            }
        });
    }
});

});
parcelRegister("9H9Di", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ef9a115cae4592$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $70ef9a115cae4592$export$2e2bcd8739ae039(ctor, superCtor, spec) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    (0, $8nd05.default)(ctor.prototype, spec);
}

});

parcelRegister("7mZW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $55daa1cd95624d91$export$2e2bcd8739ae039);
var $55daa1cd95624d91$export$2e2bcd8739ae039 = function(value) {
    return value == null;
};

});


parcelRegister("hDGtv", function(module, exports) {

var $gZblc = parcelRequire("gZblc");

var $8nd05 = parcelRequire("8nd05");

var $8XLqy = parcelRequire("8XLqy");

var $2oNFZ = parcelRequire("2oNFZ");

var $9m0Wz = parcelRequire("9m0Wz");

var $1bAZN = parcelRequire("1bAZN");

var $hnngZ = parcelRequire("hnngZ");

var $Sk64T = parcelRequire("Sk64T");

var $dmHdY = parcelRequire("dmHdY");

var $5nwN5 = parcelRequire("5nwN5");

var $eVHXo = parcelRequire("eVHXo");

var $fAFBj = parcelRequire("fAFBj");

var $9H9Di = parcelRequire("9H9Di");

var $5LO8C = parcelRequire("5LO8C");

var $6sdvp = parcelRequire("6sdvp");

var $k5kZD = parcelRequire("k5kZD");
function _templateObject3() {
    var data = (0, $gZblc.default)([
        "",
        "[\"",
        "\"]"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, $gZblc.default)([
        "",
        ".",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject() {
    var data = (0, $gZblc.default)([
        "",
        ".",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var isObject = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
var promise = function promise(sync) {
    return sync ? (0, $k5kZD.SynchronousPromise) : Promise;
};
function unknown(ctx, value) {
    var known = Object.keys(ctx.fields);
    return Object.keys(value).filter(function(key) {
        return known.indexOf(key) === -1;
    });
}
function ObjectSchema(spec) {
    var _this2 = this;
    if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);
    (0, $dmHdY.default).call(this, {
        type: 'object',
        default: function _default() {
            var _this = this;
            if (!this._nodes.length) return undefined;
            var dft = {};
            this._nodes.forEach(function(key) {
                dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
            });
            return dft;
        }
    });
    this.fields = Object.create(null);
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(function() {
        _this2.transform(function coerce(value) {
            if (typeof value === 'string') try {
                value = JSON.parse(value);
            } catch (err) {
                value = null;
            }
            if (this.isType(value)) return value;
            return null;
        });
        if (spec) _this2.shape(spec);
    });
}
(0, $9H9Di.default)(ObjectSchema, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(value) {
        return isObject(value) || typeof value === 'function';
    },
    _cast: function _cast(_value, options) {
        var _this3 = this;
        if (options === void 0) options = {};
        var value = (0, $dmHdY.default).prototype._cast.call(this, _value, options); //should ignore nulls here
        if (value === undefined) return this.default();
        if (!this._typeCheck(value)) return value;
        var fields = this.fields;
        var strip = this._option('stripUnknown', options) === true;
        var props = this._nodes.concat(Object.keys(value).filter(function(v) {
            return _this3._nodes.indexOf(v) === -1;
        }));
        var intermediateValue = {}; // is filled during the transform below
        var innerOptions = (0, $8nd05.default)({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        var isChanged = false;
        props.forEach(function(prop) {
            var field = fields[prop];
            var exists = (0, $8XLqy.default)(value, prop);
            if (field) {
                var fieldValue;
                var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence
                innerOptions.path = (0, $5LO8C.default)(_templateObject(), options.path, prop);
                innerOptions.value = value[prop];
                field = field.resolve(innerOptions);
                if (field._strip === true) {
                    isChanged = isChanged || prop in value;
                    return;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        });
        return isChanged ? intermediateValue : value;
    },
    _validate: function _validate(_value, opts) {
        var _this4 = this;
        if (opts === void 0) opts = {};
        var endEarly, recursive;
        var sync = opts.sync;
        var errors = [];
        var originalValue = opts.originalValue != null ? opts.originalValue : _value;
        var from = [
            {
                schema: this,
                value: originalValue
            }
        ].concat(opts.from || []);
        endEarly = this._option('abortEarly', opts);
        recursive = this._option('recursive', opts);
        opts = (0, $8nd05.default)({}, opts, {
            __validating: true,
            originalValue: originalValue,
            from: from
        });
        return (0, $dmHdY.default).prototype._validate.call(this, _value, opts).catch((0, $6sdvp.propagateErrors)(endEarly, errors)).then(function(value) {
            if (!recursive || !isObject(value)) {
                // only iterate though actual objects
                if (errors.length) throw errors[0];
                return value;
            }
            from = originalValue ? [].concat(from) : [
                {
                    schema: _this4,
                    value: originalValue || value
                }
            ].concat(opts.from || []);
            originalValue = originalValue || value;
            var validations = _this4._nodes.map(function(key) {
                var path = key.indexOf('.') === -1 ? (0, $5LO8C.default)(_templateObject2(), opts.path, key) : (0, $5LO8C.default)(_templateObject3(), opts.path, key);
                var field = _this4.fields[key];
                var innerOptions = (0, $8nd05.default)({}, opts, {
                    path: path,
                    from: from,
                    parent: value,
                    originalValue: originalValue[key]
                });
                if (field && field.validate) {
                    // inner fields are always strict:
                    // 1. this isn't strict so the casting will also have cast inner values
                    // 2. this is strict in which case the nested values weren't cast either
                    innerOptions.strict = true;
                    return field.validate(value[key], innerOptions);
                }
                return promise(sync).resolve(true);
            });
            return (0, $6sdvp.default)({
                sync: sync,
                validations: validations,
                value: value,
                errors: errors,
                endEarly: endEarly,
                path: opts.path,
                sort: (0, $fAFBj.default)(_this4.fields)
            });
        });
    },
    concat: function concat(schema) {
        var next = (0, $dmHdY.default).prototype.concat.call(this, schema);
        next._nodes = (0, $eVHXo.default)(next.fields, next._excludedEdges);
        return next;
    },
    shape: function shape(schema, excludes) {
        if (excludes === void 0) excludes = [];
        var next = this.clone();
        var fields = (0, $8nd05.default)(next.fields, schema);
        next.fields = fields;
        if (excludes.length) {
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            var keys = excludes.map(function(_ref) {
                var first = _ref[0], second = _ref[1];
                return first + "-" + second;
            });
            next._excludedEdges = next._excludedEdges.concat(keys);
        }
        next._nodes = (0, $eVHXo.default)(fields, next._excludedEdges);
        return next;
    },
    from: function from(_from, to, alias) {
        var fromGetter = (0, $Sk64T.getter)(_from, true);
        return this.transform(function(obj) {
            if (obj == null) return obj;
            var newObj = obj;
            if ((0, $8XLqy.default)(obj, _from)) {
                newObj = (0, $8nd05.default)({}, obj);
                if (!alias) delete newObj[_from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    },
    noUnknown: function noUnknown(noAllow, message) {
        if (noAllow === void 0) noAllow = true;
        if (message === void 0) message = (0, $5nwN5.object).noUnknown;
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        var next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test: function test(value) {
                if (value == null) return true;
                var unknownKeys = unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next._options.stripUnknown = noAllow;
        return next;
    },
    unknown: function unknown(allow, message) {
        if (allow === void 0) allow = true;
        if (message === void 0) message = (0, $5nwN5.object).noUnknown;
        return this.noUnknown(!allow, message);
    },
    transformKeys: function transformKeys(fn) {
        return this.transform(function(obj) {
            return obj && (0, $1bAZN.default)(obj, function(_, key) {
                return fn(key);
            });
        });
    },
    camelCase: function camelCase() {
        return this.transformKeys((0, $9m0Wz.default));
    },
    snakeCase: function snakeCase() {
        return this.transformKeys((0, $2oNFZ.default));
    },
    constantCase: function constantCase() {
        return this.transformKeys(function(key) {
            return (0, $2oNFZ.default)(key).toUpperCase();
        });
    },
    describe: function describe() {
        var base = (0, $dmHdY.default).prototype.describe.call(this);
        base.fields = (0, $hnngZ.default)(this.fields, function(value) {
            return value.describe();
        });
        return base;
    }
});

});
parcelRegister("gZblc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5db23e5823ab236$export$2e2bcd8739ae039);
function $c5db23e5823ab236$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}

});

parcelRegister("2oNFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf45b5b3bc94294$export$2e2bcd8739ae039);

var $fbN8B = parcelRequire("fbN8B");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $1bf45b5b3bc94294$var$snakeCase = (0, $fbN8B.default)(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
var $1bf45b5b3bc94294$export$2e2bcd8739ae039 = $1bf45b5b3bc94294$var$snakeCase;

});
parcelRegister("fbN8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0edffd6e8b73bc7$export$2e2bcd8739ae039);

var $jZsE4 = parcelRequire("jZsE4");

var $hqoVj = parcelRequire("hqoVj");

var $3eCGl = parcelRequire("3eCGl");
/** Used to compose unicode capture groups. */ var $b0edffd6e8b73bc7$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $b0edffd6e8b73bc7$var$reApos = RegExp($b0edffd6e8b73bc7$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $b0edffd6e8b73bc7$var$createCompounder(callback) {
    return function(string) {
        return (0, $jZsE4.default)((0, $3eCGl.default)((0, $hqoVj.default)(string).replace($b0edffd6e8b73bc7$var$reApos, '')), callback, '');
    };
}
var $b0edffd6e8b73bc7$export$2e2bcd8739ae039 = $b0edffd6e8b73bc7$var$createCompounder;

});
parcelRegister("jZsE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d9ef3488ca3193$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $e8d9ef3488ca3193$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $e8d9ef3488ca3193$export$2e2bcd8739ae039 = $e8d9ef3488ca3193$var$arrayReduce;

});

parcelRegister("hqoVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf8329f989df6e3$export$2e2bcd8739ae039);

var $3vvIk = parcelRequire("3vvIk");

var $1fnxW = parcelRequire("1fnxW");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $caf8329f989df6e3$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $caf8329f989df6e3$var$rsComboMarksRange = '\\u0300-\\u036f', $caf8329f989df6e3$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $caf8329f989df6e3$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $caf8329f989df6e3$var$rsComboRange = $caf8329f989df6e3$var$rsComboMarksRange + $caf8329f989df6e3$var$reComboHalfMarksRange + $caf8329f989df6e3$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $caf8329f989df6e3$var$rsCombo = '[' + $caf8329f989df6e3$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $caf8329f989df6e3$var$reComboMark = RegExp($caf8329f989df6e3$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $caf8329f989df6e3$var$deburr(string) {
    string = (0, $1fnxW.default)(string);
    return string && string.replace($caf8329f989df6e3$var$reLatin, (0, $3vvIk.default)).replace($caf8329f989df6e3$var$reComboMark, '');
}
var $caf8329f989df6e3$export$2e2bcd8739ae039 = $caf8329f989df6e3$var$deburr;

});
parcelRegister("3vvIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $28dcde10004623b8$export$2e2bcd8739ae039);

var $56Q2M = parcelRequire("56Q2M");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $28dcde10004623b8$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $28dcde10004623b8$var$deburrLetter = (0, $56Q2M.default)($28dcde10004623b8$var$deburredLetters);
var $28dcde10004623b8$export$2e2bcd8739ae039 = $28dcde10004623b8$var$deburrLetter;

});
parcelRegister("56Q2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b85e21977fb59c8$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $3b85e21977fb59c8$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var $3b85e21977fb59c8$export$2e2bcd8739ae039 = $3b85e21977fb59c8$var$basePropertyOf;

});



parcelRegister("3eCGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b0af50751d7f34$export$2e2bcd8739ae039);

var $eIUuP = parcelRequire("eIUuP");

var $hSzKI = parcelRequire("hSzKI");

var $1fnxW = parcelRequire("1fnxW");

var $fAl3h = parcelRequire("fAl3h");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $25b0af50751d7f34$var$words(string, pattern, guard) {
    string = (0, $1fnxW.default)(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return (0, $hSzKI.default)(string) ? (0, $fAl3h.default)(string) : (0, $eIUuP.default)(string);
    return string.match(pattern) || [];
}
var $25b0af50751d7f34$export$2e2bcd8739ae039 = $25b0af50751d7f34$var$words;

});
parcelRegister("eIUuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab80ffb88e878c05$export$2e2bcd8739ae039);
/** Used to match words composed of alphanumeric characters. */ var $ab80ffb88e878c05$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $ab80ffb88e878c05$var$asciiWords(string) {
    return string.match($ab80ffb88e878c05$var$reAsciiWord) || [];
}
var $ab80ffb88e878c05$export$2e2bcd8739ae039 = $ab80ffb88e878c05$var$asciiWords;

});

parcelRegister("hSzKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d043367ca578c4f9$export$2e2bcd8739ae039);
/** Used to detect strings that need a more robust regexp to match words. */ var $d043367ca578c4f9$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d043367ca578c4f9$var$hasUnicodeWord(string) {
    return $d043367ca578c4f9$var$reHasUnicodeWord.test(string);
}
var $d043367ca578c4f9$export$2e2bcd8739ae039 = $d043367ca578c4f9$var$hasUnicodeWord;

});

parcelRegister("fAl3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58a8c4a2218d852$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $b58a8c4a2218d852$var$rsAstralRange = '\\ud800-\\udfff', $b58a8c4a2218d852$var$rsComboMarksRange = '\\u0300-\\u036f', $b58a8c4a2218d852$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b58a8c4a2218d852$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b58a8c4a2218d852$var$rsComboRange = $b58a8c4a2218d852$var$rsComboMarksRange + $b58a8c4a2218d852$var$reComboHalfMarksRange + $b58a8c4a2218d852$var$rsComboSymbolsRange, $b58a8c4a2218d852$var$rsDingbatRange = '\\u2700-\\u27bf', $b58a8c4a2218d852$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $b58a8c4a2218d852$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $b58a8c4a2218d852$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $b58a8c4a2218d852$var$rsPunctuationRange = '\\u2000-\\u206f', $b58a8c4a2218d852$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $b58a8c4a2218d852$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $b58a8c4a2218d852$var$rsVarRange = '\\ufe0e\\ufe0f', $b58a8c4a2218d852$var$rsBreakRange = $b58a8c4a2218d852$var$rsMathOpRange + $b58a8c4a2218d852$var$rsNonCharRange + $b58a8c4a2218d852$var$rsPunctuationRange + $b58a8c4a2218d852$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $b58a8c4a2218d852$var$rsApos = "['\u2019]", $b58a8c4a2218d852$var$rsBreak = '[' + $b58a8c4a2218d852$var$rsBreakRange + ']', $b58a8c4a2218d852$var$rsCombo = '[' + $b58a8c4a2218d852$var$rsComboRange + ']', $b58a8c4a2218d852$var$rsDigits = '\\d+', $b58a8c4a2218d852$var$rsDingbat = '[' + $b58a8c4a2218d852$var$rsDingbatRange + ']', $b58a8c4a2218d852$var$rsLower = '[' + $b58a8c4a2218d852$var$rsLowerRange + ']', $b58a8c4a2218d852$var$rsMisc = '[^' + $b58a8c4a2218d852$var$rsAstralRange + $b58a8c4a2218d852$var$rsBreakRange + $b58a8c4a2218d852$var$rsDigits + $b58a8c4a2218d852$var$rsDingbatRange + $b58a8c4a2218d852$var$rsLowerRange + $b58a8c4a2218d852$var$rsUpperRange + ']', $b58a8c4a2218d852$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $b58a8c4a2218d852$var$rsModifier = '(?:' + $b58a8c4a2218d852$var$rsCombo + '|' + $b58a8c4a2218d852$var$rsFitz + ')', $b58a8c4a2218d852$var$rsNonAstral = '[^' + $b58a8c4a2218d852$var$rsAstralRange + ']', $b58a8c4a2218d852$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $b58a8c4a2218d852$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $b58a8c4a2218d852$var$rsUpper = '[' + $b58a8c4a2218d852$var$rsUpperRange + ']', $b58a8c4a2218d852$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $b58a8c4a2218d852$var$rsMiscLower = '(?:' + $b58a8c4a2218d852$var$rsLower + '|' + $b58a8c4a2218d852$var$rsMisc + ')', $b58a8c4a2218d852$var$rsMiscUpper = '(?:' + $b58a8c4a2218d852$var$rsUpper + '|' + $b58a8c4a2218d852$var$rsMisc + ')', $b58a8c4a2218d852$var$rsOptContrLower = '(?:' + $b58a8c4a2218d852$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $b58a8c4a2218d852$var$rsOptContrUpper = '(?:' + $b58a8c4a2218d852$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $b58a8c4a2218d852$var$reOptMod = $b58a8c4a2218d852$var$rsModifier + '?', $b58a8c4a2218d852$var$rsOptVar = '[' + $b58a8c4a2218d852$var$rsVarRange + ']?', $b58a8c4a2218d852$var$rsOptJoin = '(?:' + $b58a8c4a2218d852$var$rsZWJ + '(?:' + [
    $b58a8c4a2218d852$var$rsNonAstral,
    $b58a8c4a2218d852$var$rsRegional,
    $b58a8c4a2218d852$var$rsSurrPair
].join('|') + ')' + $b58a8c4a2218d852$var$rsOptVar + $b58a8c4a2218d852$var$reOptMod + ')*', $b58a8c4a2218d852$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $b58a8c4a2218d852$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $b58a8c4a2218d852$var$rsSeq = $b58a8c4a2218d852$var$rsOptVar + $b58a8c4a2218d852$var$reOptMod + $b58a8c4a2218d852$var$rsOptJoin, $b58a8c4a2218d852$var$rsEmoji = '(?:' + [
    $b58a8c4a2218d852$var$rsDingbat,
    $b58a8c4a2218d852$var$rsRegional,
    $b58a8c4a2218d852$var$rsSurrPair
].join('|') + ')' + $b58a8c4a2218d852$var$rsSeq;
/** Used to match complex or compound words. */ var $b58a8c4a2218d852$var$reUnicodeWord = RegExp([
    $b58a8c4a2218d852$var$rsUpper + '?' + $b58a8c4a2218d852$var$rsLower + '+' + $b58a8c4a2218d852$var$rsOptContrLower + '(?=' + [
        $b58a8c4a2218d852$var$rsBreak,
        $b58a8c4a2218d852$var$rsUpper,
        '$'
    ].join('|') + ')',
    $b58a8c4a2218d852$var$rsMiscUpper + '+' + $b58a8c4a2218d852$var$rsOptContrUpper + '(?=' + [
        $b58a8c4a2218d852$var$rsBreak,
        $b58a8c4a2218d852$var$rsUpper + $b58a8c4a2218d852$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $b58a8c4a2218d852$var$rsUpper + '?' + $b58a8c4a2218d852$var$rsMiscLower + '+' + $b58a8c4a2218d852$var$rsOptContrLower,
    $b58a8c4a2218d852$var$rsUpper + '+' + $b58a8c4a2218d852$var$rsOptContrUpper,
    $b58a8c4a2218d852$var$rsOrdUpper,
    $b58a8c4a2218d852$var$rsOrdLower,
    $b58a8c4a2218d852$var$rsDigits,
    $b58a8c4a2218d852$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $b58a8c4a2218d852$var$unicodeWords(string) {
    return string.match($b58a8c4a2218d852$var$reUnicodeWord) || [];
}
var $b58a8c4a2218d852$export$2e2bcd8739ae039 = $b58a8c4a2218d852$var$unicodeWords;

});




parcelRegister("9m0Wz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf6e68aee6d204a$export$2e2bcd8739ae039);

var $1mZSa = parcelRequire("1mZSa");

var $fbN8B = parcelRequire("fbN8B");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $6cf6e68aee6d204a$var$camelCase = (0, $fbN8B.default)(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? (0, $1mZSa.default)(word) : word);
});
var $6cf6e68aee6d204a$export$2e2bcd8739ae039 = $6cf6e68aee6d204a$var$camelCase;

});
parcelRegister("1mZSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff7d71e45d9103c$export$2e2bcd8739ae039);

var $1fnxW = parcelRequire("1fnxW");

var $hBmZL = parcelRequire("hBmZL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $0ff7d71e45d9103c$var$capitalize(string) {
    return (0, $hBmZL.default)((0, $1fnxW.default)(string).toLowerCase());
}
var $0ff7d71e45d9103c$export$2e2bcd8739ae039 = $0ff7d71e45d9103c$var$capitalize;

});
parcelRegister("hBmZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd07bab7cc5d99bb$export$2e2bcd8739ae039);

var $a30PF = parcelRequire("a30PF");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cd07bab7cc5d99bb$var$upperFirst = (0, $a30PF.default)('toUpperCase');
var $cd07bab7cc5d99bb$export$2e2bcd8739ae039 = $cd07bab7cc5d99bb$var$upperFirst;

});
parcelRegister("a30PF", function(module, exports) {

$parcel$export(module.exports, "default", () => $750ad476ec58e06d$export$2e2bcd8739ae039);

var $d5OJ9 = parcelRequire("d5OJ9");

var $6MCUi = parcelRequire("6MCUi");

var $h5ULu = parcelRequire("h5ULu");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $750ad476ec58e06d$var$createCaseFirst(methodName) {
    return function(string) {
        string = (0, $1fnxW.default)(string);
        var strSymbols = (0, $6MCUi.default)(string) ? (0, $h5ULu.default)(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? (0, $d5OJ9.default)(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
var $750ad476ec58e06d$export$2e2bcd8739ae039 = $750ad476ec58e06d$var$createCaseFirst;

});
parcelRegister("d5OJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9883175c52fe19da$export$2e2bcd8739ae039);

var $8vRoo = parcelRequire("8vRoo");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $9883175c52fe19da$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : (0, $8vRoo.default)(array, start, end);
}
var $9883175c52fe19da$export$2e2bcd8739ae039 = $9883175c52fe19da$var$castSlice;

});
parcelRegister("8vRoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $632aa29c87e61531$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $632aa29c87e61531$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $632aa29c87e61531$export$2e2bcd8739ae039 = $632aa29c87e61531$var$baseSlice;

});






parcelRegister("1bAZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dd3841c476534bd$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $by0Fh = parcelRequire("by0Fh");

var $dKmGr = parcelRequire("dKmGr");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0dd3841c476534bd$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = (0, $dKmGr.default)(iteratee, 3);
    (0, $by0Fh.default)(object, function(value, key, object) {
        (0, $dLTlW.default)(result, iteratee(value, key, object), value);
    });
    return result;
}
var $0dd3841c476534bd$export$2e2bcd8739ae039 = $0dd3841c476534bd$var$mapKeys;

});

parcelRegister("eVHXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade87c847c1ee6bb$export$2e2bcd8739ae039);

var $8XLqy = parcelRequire("8XLqy");

var $dYCFZ = parcelRequire("dYCFZ");

var $Sk64T = parcelRequire("Sk64T");

var $l6pyh = parcelRequire("l6pyh");

var $2vNMA = parcelRequire("2vNMA");
function $ade87c847c1ee6bb$export$2e2bcd8739ae039(fields, excludes) {
    if (excludes === void 0) excludes = [];
    var edges = [], nodes = [];
    function addNode(depPath, key) {
        var node = (0, $Sk64T.split)(depPath)[0];
        if (!~nodes.indexOf(node)) nodes.push(node);
        if (!~excludes.indexOf(key + "-" + node)) edges.push([
            key,
            node
        ]);
    }
    for(var key in fields)if ((0, $8XLqy.default)(fields, key)) {
        var value = fields[key];
        if (!~nodes.indexOf(key)) nodes.push(key);
        if ((0, $l6pyh.default).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $2vNMA.default)(value) && value._deps) value._deps.forEach(function(path) {
            return addNode(path, key);
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dYCFZ))).array(nodes, edges).reverse();
}

});
parcelRegister("dYCFZ", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
module.exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("fAFBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039);
function $b59a7ce2e5e0a1e4$var$findIndex(arr, err) {
    var idx = Infinity;
    arr.some(function(key, ii) {
        if (err.path.indexOf(key) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039(fields) {
    var keys = Object.keys(fields);
    return function(a, b) {
        return $b59a7ce2e5e0a1e4$var$findIndex(keys, a) - $b59a7ce2e5e0a1e4$var$findIndex(keys, b);
    };
}

});

parcelRegister("5LO8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $43383bec5af84fa6$export$2e2bcd8739ae039);
function $43383bec5af84fa6$export$2e2bcd8739ae039(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    var path = strings.reduce(function(str, next) {
        var value = values.shift();
        return str + (value == null ? '' : value) + next;
    });
    return path.replace(/^\./, '');
}

});


parcelRegister("jpuYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e218604b96487b25$export$2e2bcd8739ae039);

var $gZblc = parcelRequire("gZblc");

var $8nd05 = parcelRequire("8nd05");

var $9H9Di = parcelRequire("9H9Di");

var $7mZW8 = parcelRequire("7mZW8");

var $2vNMA = parcelRequire("2vNMA");

var $5LO8C = parcelRequire("5LO8C");

var $58i62 = parcelRequire("58i62");

var $dmHdY = parcelRequire("dmHdY");

var $5nwN5 = parcelRequire("5nwN5");

var $6sdvp = parcelRequire("6sdvp");
function _templateObject2() {
    var data = (0, $gZblc.default)([
        "",
        "[",
        "]"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject() {
    var data = (0, $gZblc.default)([
        "",
        "[",
        "]"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e218604b96487b25$export$2e2bcd8739ae039 = ArraySchema;
function ArraySchema(type) {
    var _this = this;
    if (!(this instanceof ArraySchema)) return new ArraySchema(type);
    (0, $dmHdY.default).call(this, {
        type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"
    this._subType = undefined;
    this.innerType = undefined;
    this.withMutation(function() {
        _this.transform(function(values) {
            if (typeof values === 'string') try {
                values = JSON.parse(values);
            } catch (err) {
                values = null;
            }
            return this.isType(values) ? values : null;
        });
        if (type) _this.of(type);
    });
}
(0, $9H9Di.default)(ArraySchema, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(v) {
        return Array.isArray(v);
    },
    _cast: function _cast(_value, _opts) {
        var _this2 = this;
        var value = (0, $dmHdY.default).prototype._cast.call(this, _value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        var isChanged = false;
        var castArray = value.map(function(v, idx) {
            var castElement = _this2.innerType.cast(v, (0, $8nd05.default)({}, _opts, {
                path: (0, $5LO8C.default)(_templateObject(), _opts.path, idx)
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    },
    _validate: function _validate(_value, options) {
        var _this3 = this;
        if (options === void 0) options = {};
        var errors = [];
        var sync = options.sync;
        var path = options.path;
        var innerType = this.innerType;
        var endEarly = this._option('abortEarly', options);
        var recursive = this._option('recursive', options);
        var originalValue = options.originalValue != null ? options.originalValue : _value;
        return (0, $dmHdY.default).prototype._validate.call(this, _value, options).catch((0, $6sdvp.propagateErrors)(endEarly, errors)).then(function(value) {
            if (!recursive || !innerType || !_this3._typeCheck(value)) {
                if (errors.length) throw errors[0];
                return value;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            var validations = new Array(value.length);
            for(var idx = 0; idx < value.length; idx++){
                var item = value[idx];
                var _path = (0, $5LO8C.default)(_templateObject2(), options.path, idx); // object._validate note for isStrict explanation
                var innerOptions = (0, $8nd05.default)({}, options, {
                    path: _path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                validations[idx] = innerType.validate ? innerType.validate(item, innerOptions) : true;
            }
            return (0, $6sdvp.default)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                validations: validations
            });
        });
    },
    _isPresent: function _isPresent(value) {
        return (0, $dmHdY.default).prototype._isPresent.call(this, value) && value.length > 0;
    },
    of: function of(schema) {
        var next = this.clone();
        if (schema !== false && !(0, $2vNMA.default)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. not: " + (0, $58i62.default)(schema));
        next._subType = schema;
        next.innerType = schema;
        return next;
    },
    min: function min(_min, message) {
        message = message || (0, $5nwN5.array).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: _min
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value.length >= this.resolve(_min);
            }
        });
    },
    max: function max(_max, message) {
        message = message || (0, $5nwN5.array).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: _max
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value.length <= this.resolve(_max);
            }
        });
    },
    ensure: function ensure() {
        var _this4 = this;
        return this.default(function() {
            return [];
        }).transform(function(val, original) {
            // We don't want to return `null` for nullable schema
            if (_this4._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    },
    compact: function compact(rejector) {
        var reject = !rejector ? function(v) {
            return !!v;
        } : function(v, i, a) {
            return !rejector(v, i, a);
        };
        return this.transform(function(values) {
            return values != null ? values.filter(reject) : values;
        });
    },
    describe: function describe() {
        var base = (0, $dmHdY.default).prototype.describe.call(this);
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
});

});

parcelRegister("bspzY", function(module, exports) {

$parcel$export(module.exports, "namespaces", () => $857626bf766d9720$export$41fc20bb625e8618);
$parcel$export(module.exports, "precision", () => $857626bf766d9720$export$b70eeb0e623ceb0d);
$parcel$export(module.exports, "escapingMap", () => $857626bf766d9720$export$c56f738b5b9e4176);
$parcel$export(module.exports, "ensureUnit", () => $857626bf766d9720$export$55ba73e7e2582947);
$parcel$export(module.exports, "quantity", () => $857626bf766d9720$export$82dd68b83a44b253);
$parcel$export(module.exports, "alphaNumerate", () => $857626bf766d9720$export$77ecec3d3dcfe360);
$parcel$export(module.exports, "EPSILON", () => $857626bf766d9720$export$fd293b15f47e270);
$parcel$export(module.exports, "orderOfMagnitude", () => $857626bf766d9720$export$7a05205744354670);
$parcel$export(module.exports, "projectLength", () => $857626bf766d9720$export$6bfe3e2dca3d4e73);
$parcel$export(module.exports, "roundWithPrecision", () => $857626bf766d9720$export$6eefa22f65535549);
$parcel$export(module.exports, "rho", () => $857626bf766d9720$export$bf155d91e9c570c8);
$parcel$export(module.exports, "polarToCartesian", () => $857626bf766d9720$export$5c9a959bb3fc7749);
$parcel$export(module.exports, "getBounds", () => $857626bf766d9720$export$becd1e645219fa23);
$parcel$export(module.exports, "extend", () => $857626bf766d9720$export$8b58be045bf06082);
$parcel$export(module.exports, "noop", () => $857626bf766d9720$export$8793edee2d425525);
$parcel$export(module.exports, "times", () => $857626bf766d9720$export$b5bc26e198ce73d0);
$parcel$export(module.exports, "sum", () => $857626bf766d9720$export$8a63f25cc62965f1);
$parcel$export(module.exports, "serialMap", () => $857626bf766d9720$export$e29b2cd13549b23b);
$parcel$export(module.exports, "safeHasProperty", () => $857626bf766d9720$export$7aae4c7f770e1d0b);
$parcel$export(module.exports, "isNumeric", () => $857626bf766d9720$export$e90fb89750dba83f);
$parcel$export(module.exports, "isFalseyButZero", () => $857626bf766d9720$export$d45b80bd88a96dcb);
$parcel$export(module.exports, "getNumberOrUndefined", () => $857626bf766d9720$export$7f5a9228ad5d5555);
$parcel$export(module.exports, "isArrayOfArrays", () => $857626bf766d9720$export$e3f2d7f0b529e664);
$parcel$export(module.exports, "each", () => $857626bf766d9720$export$79b2f7037acddd43);
$parcel$export(module.exports, "getMetaData", () => $857626bf766d9720$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "isDataHoleValue", () => $857626bf766d9720$export$454c92a38a755fd3);
$parcel$export(module.exports, "isArrayOfSeries", () => $857626bf766d9720$export$4984e4b4f3cd6fd5);
$parcel$export(module.exports, "isMultiValue", () => $857626bf766d9720$export$262b6745e2670594);
$parcel$export(module.exports, "getMultiValue", () => $857626bf766d9720$export$656dba5810c63062);
$parcel$export(module.exports, "getHighLow", () => $857626bf766d9720$export$3e3ab378c1942d40);
$parcel$export(module.exports, "normalizeData", () => $857626bf766d9720$export$3a0f8eb7361883bd);
$parcel$export(module.exports, "splitIntoSegments", () => $857626bf766d9720$export$cfb2ca1a0728c62d);
$parcel$export(module.exports, "serialize", () => $857626bf766d9720$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "deserialize", () => $857626bf766d9720$export$efcd34ab6248d3cd);
$parcel$export(module.exports, "SvgList", () => $857626bf766d9720$export$6a1629697f60641);
$parcel$export(module.exports, "Svg", () => $857626bf766d9720$export$e17b9c1182212c96);
$parcel$export(module.exports, "easings", () => $857626bf766d9720$export$15a0bf1b4bbacad8);
$parcel$export(module.exports, "createSvg", () => $857626bf766d9720$export$c54fe3b9ecaa84cf);
$parcel$export(module.exports, "normalizePadding", () => $857626bf766d9720$export$9a9bba3f57c45f3f);
$parcel$export(module.exports, "createChartRect", () => $857626bf766d9720$export$287763b5f38b12d6);
$parcel$export(module.exports, "createGrid", () => $857626bf766d9720$export$fce123c48a7b4eae);
$parcel$export(module.exports, "createGridBackground", () => $857626bf766d9720$export$46e1d35fe977edb4);
$parcel$export(module.exports, "createLabel", () => $857626bf766d9720$export$f2839682b8c07f35);
$parcel$export(module.exports, "optionsProvider", () => $857626bf766d9720$export$f12efb46802a3d21);
$parcel$export(module.exports, "SvgPath", () => $857626bf766d9720$export$1c313b81a43a728a);
$parcel$export(module.exports, "Interpolation", () => $857626bf766d9720$export$b0cc4f9860136880);
$parcel$export(module.exports, "EventEmitter", () => $857626bf766d9720$export$4fae95256245c8c0);
$parcel$export(module.exports, "BaseChart", () => $857626bf766d9720$export$ba89768bd61fb9ef);
$parcel$export(module.exports, "axisUnits", () => $857626bf766d9720$export$45dc71cecb436b28);
$parcel$export(module.exports, "Axis", () => $857626bf766d9720$export$d06866a9fb0606da);
$parcel$export(module.exports, "AutoScaleAxis", () => $857626bf766d9720$export$2c0288ac3969ab20);
$parcel$export(module.exports, "FixedScaleAxis", () => $857626bf766d9720$export$9869192afbf61008);
$parcel$export(module.exports, "StepAxis", () => $857626bf766d9720$export$1f3b9f5753043f0c);
$parcel$export(module.exports, "getSeriesOption", () => $857626bf766d9720$export$d5c951c1021f1820);
$parcel$export(module.exports, "LineChart", () => $857626bf766d9720$export$54d0e8420ac838ac);
$parcel$export(module.exports, "BarChart", () => $857626bf766d9720$export$94aefc399ef206a9);
$parcel$export(module.exports, "determineAnchorPosition", () => $857626bf766d9720$export$b4dd96cedf6bf355);
$parcel$export(module.exports, "PieChart", () => $857626bf766d9720$export$b99d3348f709c998);
/**
 * This object contains all namespaces used within Chartist.
 */ const $857626bf766d9720$export$41fc20bb625e8618 = {
    svg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/xmlns/",
    xhtml: "http://www.w3.org/1999/xhtml",
    xlink: "http://www.w3.org/1999/xlink",
    ct: "http://gionkunz.github.com/chartist-js/ct"
};
/**
 * Precision level used internally in Chartist for rounding. If you require more decimal places you can increase this number.
 */ const $857626bf766d9720$export$b70eeb0e623ceb0d = 8;
/**
 * A map with characters to escape for strings to be safely used as attribute values.
 */ const $857626bf766d9720$export$c56f738b5b9e4176 = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
};
/**
 * Converts a number to a string with a unit. If a string is passed then this will be returned unmodified.
 * @return Returns the passed number value with unit.
 */ function $857626bf766d9720$export$55ba73e7e2582947(value, unit) {
    if (typeof value === "number") return value + unit;
    return value;
}
/**
 * Converts a number or string to a quantity object.
 * @return Returns an object containing the value as number and the unit as string.
 */ function $857626bf766d9720$export$82dd68b83a44b253(input) {
    if (typeof input === "string") {
        const match = /^(\d+)\s*(.*)$/g.exec(input);
        return {
            value: match ? +match[1] : 0,
            unit: (match === null || match === void 0 ? void 0 : match[2]) || undefined
        };
    }
    return {
        value: Number(input)
    };
}
/**
 * Generates a-z from a number 0 to 26
 * @param n A number from 0 to 26 that will result in a letter a-z
 * @return A character from a-z based on the input number n
 */ function $857626bf766d9720$export$77ecec3d3dcfe360(n) {
    // Limit to a-z
    return String.fromCharCode(97 + n % 26);
}
const $857626bf766d9720$export$fd293b15f47e270 = 2.221e-16;
/**
 * Calculate the order of magnitude for the chart scale
 * @param value The value Range of the chart
 * @return The order of magnitude
 */ function $857626bf766d9720$export$7a05205744354670(value) {
    return Math.floor(Math.log(Math.abs(value)) / Math.LN10);
}
/**
 * Project a data length into screen coordinates (pixels)
 * @param axisLength The svg element for the chart
 * @param length Single data value from a series array
 * @param bounds All the values to set the bounds of the chart
 * @return The projected data length in pixels
 */ function $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, length, bounds) {
    return length / bounds.range * axisLength;
}
/**
 * This helper function can be used to round values with certain precision level after decimal. This is used to prevent rounding errors near float point precision limit.
 * @param value The value that should be rounded with precision
 * @param [digits] The number of digits after decimal used to do the rounding
 * @returns Rounded value
 */ function $857626bf766d9720$export$6eefa22f65535549(value, digits) {
    const precision$1 = Math.pow(10, digits || $857626bf766d9720$export$b70eeb0e623ceb0d);
    return Math.round(value * precision$1) / precision$1;
}
/**
 * Pollard Rho Algorithm to find smallest factor of an integer value. There are more efficient algorithms for factorization, but this one is quite efficient and not so complex.
 * @param num An integer number where the smallest factor should be searched for
 * @returns The smallest integer factor of the parameter num.
 */ function $857626bf766d9720$export$bf155d91e9c570c8(num) {
    if (num === 1) return num;
    function gcd(p, q) {
        if (p % q === 0) return q;
        else return gcd(q, p % q);
    }
    function f(x) {
        return x * x + 1;
    }
    let x1 = 2;
    let x2 = 2;
    let divisor;
    if (num % 2 === 0) return 2;
    do {
        x1 = f(x1) % num;
        x2 = f(f(x2)) % num;
        divisor = gcd(Math.abs(x1 - x2), num);
    }while (divisor === 1);
    return divisor;
}
/**
 * Calculate cartesian coordinates of polar coordinates
 * @param centerX X-axis coordinates of center point of circle segment
 * @param centerY X-axis coordinates of center point of circle segment
 * @param radius Radius of circle segment
 * @param angleInDegrees Angle of circle segment in degrees
 * @return Coordinates of point on circumference
 */ function $857626bf766d9720$export$5c9a959bb3fc7749(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
/**
 * Calculate and retrieve all the bounds for the chart and return them in one array
 * @param axisLength The length of the Axis used for
 * @param highLow An object containing a high and low property indicating the value range of the chart.
 * @param scaleMinSpace The minimum projected length a step should result in
 * @param onlyInteger
 * @return All the values to set the bounds of the chart
 */ function $857626bf766d9720$export$becd1e645219fa23(axisLength, highLow, scaleMinSpace) {
    let onlyInteger = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const bounds = {
        high: highLow.high,
        low: highLow.low,
        valueRange: 0,
        oom: 0,
        step: 0,
        min: 0,
        max: 0,
        range: 0,
        numberOfSteps: 0,
        values: []
    };
    bounds.valueRange = bounds.high - bounds.low;
    bounds.oom = $857626bf766d9720$export$7a05205744354670(bounds.valueRange);
    bounds.step = Math.pow(10, bounds.oom);
    bounds.min = Math.floor(bounds.low / bounds.step) * bounds.step;
    bounds.max = Math.ceil(bounds.high / bounds.step) * bounds.step;
    bounds.range = bounds.max - bounds.min;
    bounds.numberOfSteps = Math.round(bounds.range / bounds.step);
    // Optimize scale step by checking if subdivision is possible based on horizontalGridMinSpace
    // If we are already below the scaleMinSpace value we will scale up
    const length = $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, bounds.step, bounds);
    const scaleUp = length < scaleMinSpace;
    const smallestFactor = onlyInteger ? $857626bf766d9720$export$bf155d91e9c570c8(bounds.range) : 0;
    // First check if we should only use integer steps and if step 1 is still larger than scaleMinSpace so we can use 1
    if (onlyInteger && $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, 1, bounds) >= scaleMinSpace) bounds.step = 1;
    else if (onlyInteger && smallestFactor < bounds.step && $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, smallestFactor, bounds) >= scaleMinSpace) // If step 1 was too small, we can try the smallest factor of range
    // If the smallest factor is smaller than the current bounds.step and the projected length of smallest factor
    // is larger than the scaleMinSpace we should go for it.
    bounds.step = smallestFactor;
    else {
        // Trying to divide or multiply by 2 and find the best step value
        let optimizationCounter = 0;
        for(;;){
            if (scaleUp && $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, bounds.step, bounds) <= scaleMinSpace) bounds.step *= 2;
            else if (!scaleUp && $857626bf766d9720$export$6bfe3e2dca3d4e73(axisLength, bounds.step / 2, bounds) >= scaleMinSpace) {
                bounds.step /= 2;
                if (onlyInteger && bounds.step % 1 !== 0) {
                    bounds.step *= 2;
                    break;
                }
            } else break;
            if (optimizationCounter++ > 1000) throw new Error("Exceeded maximum number of iterations while optimizing scale step!");
        }
    }
    bounds.step = Math.max(bounds.step, $857626bf766d9720$export$fd293b15f47e270);
    function safeIncrement(value, increment) {
        // If increment is too small use *= (1+EPSILON) as a simple nextafter
        if (value === (value += increment)) value *= 1 + (increment > 0 ? $857626bf766d9720$export$fd293b15f47e270 : -$857626bf766d9720$export$fd293b15f47e270);
        return value;
    }
    // Narrow min and max based on new step
    let newMin = bounds.min;
    let newMax = bounds.max;
    while(newMin + bounds.step <= bounds.low)newMin = safeIncrement(newMin, bounds.step);
    while(newMax - bounds.step >= bounds.high)newMax = safeIncrement(newMax, -bounds.step);
    bounds.min = newMin;
    bounds.max = newMax;
    bounds.range = bounds.max - bounds.min;
    const values = [];
    for(let i = bounds.min; i <= bounds.max; i = safeIncrement(i, bounds.step)){
        const value = $857626bf766d9720$export$6eefa22f65535549(i);
        if (value !== values[values.length - 1]) values.push(value);
    }
    bounds.values = values;
    return bounds;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $857626bf766d9720$export$8b58be045bf06082() {
    let target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        for(const prop in source){
            const sourceProp = source[prop];
            if (typeof sourceProp === "object" && sourceProp !== null && !(sourceProp instanceof Array)) target[prop] = $857626bf766d9720$export$8b58be045bf06082(target[prop], sourceProp);
            else target[prop] = sourceProp;
        }
    }
    return target;
}
/**
 * Helps to simplify functional style code
 * @param n This exact value will be returned by the noop function
 * @return The same value that was provided to the n parameter
 */ const $857626bf766d9720$export$8793edee2d425525 = (n)=>n;
function $857626bf766d9720$export$b5bc26e198ce73d0(length, filler) {
    return Array.from({
        length: length
    }, filler ? (_, i)=>filler(i) : ()=>void 0);
}
/**
 * Sum helper to be used in reduce functions
 */ const $857626bf766d9720$export$8a63f25cc62965f1 = (previous, current)=>previous + (current ? current : 0);
/**
 * Map for multi dimensional arrays where their nested arrays will be mapped in serial. The output array will have the length of the largest nested array. The callback function is called with variable arguments where each argument is the nested array value (or undefined if there are no more values).
 *
 * For example:
 * @example
 * ```ts
 * const data = [[1, 2], [3], []];
 * serialMap(data, cb);
 *
 * // where cb will be called 2 times
 * // 1. call arguments: (1, 3, undefined)
 * // 2. call arguments: (2, undefined, undefined)
 * ```
 */ const $857626bf766d9720$export$e29b2cd13549b23b = (array, callback)=>$857626bf766d9720$export$b5bc26e198ce73d0(Math.max(...array.map((element)=>element.length)), (index)=>callback(...array.map((element)=>element[index])));
function $857626bf766d9720$export$7aae4c7f770e1d0b(target, property) {
    return target !== null && typeof target === "object" && Reflect.has(target, property);
}
function $857626bf766d9720$export$e90fb89750dba83f(value) {
    return value !== null && isFinite(value);
}
/**
 * Returns true on all falsey values except the numeric value 0.
 */ function $857626bf766d9720$export$d45b80bd88a96dcb(value) {
    return !value && value !== 0;
}
function $857626bf766d9720$export$7f5a9228ad5d5555(value) {
    return $857626bf766d9720$export$e90fb89750dba83f(value) ? Number(value) : undefined;
}
/**
 * Checks if value is array of arrays or not.
 */ function $857626bf766d9720$export$e3f2d7f0b529e664(data) {
    if (!Array.isArray(data)) return false;
    return data.every(Array.isArray);
}
/**
 * Loop over array.
 */ function $857626bf766d9720$export$79b2f7037acddd43(list, callback) {
    let reverse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    let index = 0;
    list[reverse ? "reduceRight" : "reduce"]((_, item, itemIndex)=>callback(item, index++, itemIndex), void 0);
}
/**
 * Get meta data of a specific value in a series.
 */ function $857626bf766d9720$export$929b5cc2a4ac0922(seriesData, index) {
    const value = Array.isArray(seriesData) ? seriesData[index] : $857626bf766d9720$export$7aae4c7f770e1d0b(seriesData, "data") ? seriesData.data[index] : null;
    return $857626bf766d9720$export$7aae4c7f770e1d0b(value, "meta") ? value.meta : undefined;
}
function $857626bf766d9720$export$454c92a38a755fd3(value) {
    return value === null || value === undefined || typeof value === "number" && isNaN(value);
}
/**
 * Checks if value is array of series objects.
 */ function $857626bf766d9720$export$4984e4b4f3cd6fd5(value) {
    return Array.isArray(value) && value.every((_)=>Array.isArray(_) || $857626bf766d9720$export$7aae4c7f770e1d0b(_, "data"));
}
/**
 * Checks if provided value object is multi value (contains x or y properties)
 */ function $857626bf766d9720$export$262b6745e2670594(value) {
    return typeof value === "object" && value !== null && (Reflect.has(value, "x") || Reflect.has(value, "y"));
}
/**
 * Gets a value from a dimension `value.x` or `value.y` while returning value directly if it's a valid numeric value. If the value is not numeric and it's falsey this function will return `defaultValue`.
 */ function $857626bf766d9720$export$656dba5810c63062(value) {
    let dimension = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y";
    if ($857626bf766d9720$export$262b6745e2670594(value) && $857626bf766d9720$export$7aae4c7f770e1d0b(value, dimension)) return $857626bf766d9720$export$7f5a9228ad5d5555(value[dimension]);
    else return $857626bf766d9720$export$7f5a9228ad5d5555(value);
}
/**
 * Get highest and lowest value of data array. This Array contains the data that will be visualized in the chart.
 * @param data The array that contains the data to be visualized in the chart
 * @param options The Object that contains the chart options
 * @param dimension Axis dimension 'x' or 'y' used to access the correct value and high / low configuration
 * @return An object that contains the highest and lowest value that will be visualized on the chart.
 */ function $857626bf766d9720$export$3e3ab378c1942d40(data, options, dimension) {
    // TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
    options = {
        ...options,
        ...dimension ? dimension === "x" ? options.axisX : options.axisY : {}
    };
    const highLow = {
        high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
        low: options.low === undefined ? Number.MAX_VALUE : +options.low
    };
    const findHigh = options.high === undefined;
    const findLow = options.low === undefined;
    // Function to recursively walk through arrays and find highest and lowest number
    function recursiveHighLow(sourceData) {
        if ($857626bf766d9720$export$454c92a38a755fd3(sourceData)) return;
        else if (Array.isArray(sourceData)) for(let i = 0; i < sourceData.length; i++)recursiveHighLow(sourceData[i]);
        else {
            const value = Number(dimension && $857626bf766d9720$export$7aae4c7f770e1d0b(sourceData, dimension) ? sourceData[dimension] : sourceData);
            if (findHigh && value > highLow.high) highLow.high = value;
            if (findLow && value < highLow.low) highLow.low = value;
        }
    }
    // Start to find highest and lowest number recursively
    if (findHigh || findLow) recursiveHighLow(data);
    // Overrides of high / low based on reference value, it will make sure that the invisible reference value is
    // used to generate the chart. This is useful when the chart always needs to contain the position of the
    // invisible reference value in the view i.e. for bipolar scales.
    if (options.referenceValue || options.referenceValue === 0) {
        highLow.high = Math.max(options.referenceValue, highLow.high);
        highLow.low = Math.min(options.referenceValue, highLow.low);
    }
    // If high and low are the same because of misconfiguration or flat data (only the same value) we need
    // to set the high or low to 0 depending on the polarity
    if (highLow.high <= highLow.low) {
        // If both values are 0 we set high to 1
        if (highLow.low === 0) highLow.high = 1;
        else if (highLow.low < 0) // If we have the same negative value for the bounds we set bounds.high to 0
        highLow.high = 0;
        else if (highLow.high > 0) // If we have the same positive value for the bounds we set bounds.low to 0
        highLow.low = 0;
        else {
            // If data array was empty, values are Number.MAX_VALUE and -Number.MAX_VALUE. Set bounds to prevent errors
            highLow.high = 1;
            highLow.low = 0;
        }
    }
    return highLow;
}
function $857626bf766d9720$export$3a0f8eb7361883bd(data) {
    let reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, multi = arguments.length > 2 ? arguments[2] : void 0, distributed = arguments.length > 3 ? arguments[3] : void 0;
    let labelCount;
    const normalized = {
        labels: (data.labels || []).slice(),
        series: $857626bf766d9720$var$normalizeSeries(data.series, multi, distributed)
    };
    const inputLabelCount = normalized.labels.length;
    // If all elements of the normalized data array are arrays we're dealing with
    // multi series data and we need to find the largest series if they are un-even
    if ($857626bf766d9720$export$e3f2d7f0b529e664(normalized.series)) {
        // Getting the series with the the most elements
        labelCount = Math.max(inputLabelCount, ...normalized.series.map((series)=>series.length));
        normalized.series.forEach((series)=>{
            series.push(...$857626bf766d9720$export$b5bc26e198ce73d0(Math.max(0, labelCount - series.length)));
        });
    } else // We're dealing with Pie data so we just take the normalized array length
    labelCount = normalized.series.length;
    // Padding the labels to labelCount with empty strings
    normalized.labels.push(...$857626bf766d9720$export$b5bc26e198ce73d0(Math.max(0, labelCount - inputLabelCount), ()=>""));
    if (reverse) $857626bf766d9720$var$reverseData(normalized);
    return normalized;
}
/**
 * Reverses the series, labels and series data arrays.
 */ function $857626bf766d9720$var$reverseData(data) {
    var ref;
    (ref = data.labels) === null || ref === void 0 || ref.reverse();
    data.series.reverse();
    for (const series of data.series){
        if ($857626bf766d9720$export$7aae4c7f770e1d0b(series, "data")) series.data.reverse();
        else if (Array.isArray(series)) series.reverse();
    }
}
function $857626bf766d9720$var$normalizeMulti(value, multi) {
    // We need to prepare multi value output (x and y data)
    let x;
    let y;
    // Single series value arrays are assumed to specify the Y-Axis value
    // For example: [1, 2] => [{x: undefined, y: 1}, {x: undefined, y: 2}]
    // If multi is a string then it's assumed that it specified which dimension should be filled as default
    if (typeof value !== "object") {
        const num = $857626bf766d9720$export$7f5a9228ad5d5555(value);
        if (multi === "x") x = num;
        else y = num;
    } else {
        if ($857626bf766d9720$export$7aae4c7f770e1d0b(value, "x")) x = $857626bf766d9720$export$7f5a9228ad5d5555(value.x);
        if ($857626bf766d9720$export$7aae4c7f770e1d0b(value, "y")) y = $857626bf766d9720$export$7f5a9228ad5d5555(value.y);
    }
    if (x === undefined && y === undefined) return undefined;
    return {
        x: x,
        y: y
    };
}
function $857626bf766d9720$var$normalizePrimitive(value, multi) {
    if ($857626bf766d9720$export$454c92a38a755fd3(value)) // We're dealing with a hole in the data and therefore need to return undefined
    // We're also returning undefined for multi value output
    return undefined;
    if (multi) return $857626bf766d9720$var$normalizeMulti(value, multi);
    return $857626bf766d9720$export$7f5a9228ad5d5555(value);
}
function $857626bf766d9720$var$normalizeSingleSeries(series, multi) {
    if (!Array.isArray(series)) // We are dealing with series object notation so we need to recurse on data property
    return $857626bf766d9720$var$normalizeSingleSeries(series.data, multi);
    return series.map((value)=>{
        if ($857626bf766d9720$export$7aae4c7f770e1d0b(value, "value")) // We are dealing with value object notation so we need to recurse on value property
        return $857626bf766d9720$var$normalizePrimitive(value.value, multi);
        return $857626bf766d9720$var$normalizePrimitive(value, multi);
    });
}
function $857626bf766d9720$var$normalizeSeries(series, multi, distributed) {
    if ($857626bf766d9720$export$4984e4b4f3cd6fd5(series)) return series.map((_)=>$857626bf766d9720$var$normalizeSingleSeries(_, multi));
    const normalizedSeries = $857626bf766d9720$var$normalizeSingleSeries(series, multi);
    if (distributed) return normalizedSeries.map((value)=>[
            value
        ]);
    return normalizedSeries;
}
/**
 * Splits a list of coordinates and associated values into segments. Each returned segment contains a pathCoordinates
 * valueData property describing the segment.
 *
 * With the default options, segments consist of contiguous sets of points that do not have an undefined value. Any
 * points with undefined values are discarded.
 *
 * **Options**
 * The following options are used to determine how segments are formed
 * ```javascript
 * var options = {
 *   // If fillHoles is true, undefined values are simply discarded without creating a new segment. Assuming other options are default, this returns single segment.
 *   fillHoles: false,
 *   // If increasingX is true, the coordinates in all segments have strictly increasing x-values.
 *   increasingX: false
 * };
 * ```
 *
 * @param pathCoordinates List of point coordinates to be split in the form [x1, y1, x2, y2 ... xn, yn]
 * @param valueData List of associated point values in the form [v1, v2 .. vn]
 * @param options Options set by user
 * @return List of segments, each containing a pathCoordinates and valueData property.
 */ function $857626bf766d9720$export$cfb2ca1a0728c62d(pathCoordinates, valueData, options) {
    const finalOptions = {
        increasingX: false,
        fillHoles: false,
        ...options
    };
    const segments = [];
    let hole = true;
    for(let i = 0; i < pathCoordinates.length; i += 2){
        // If this value is a "hole" we set the hole flag
        if ($857626bf766d9720$export$656dba5810c63062(valueData[i / 2].value) === undefined) // if(valueData[i / 2].value === undefined) {
        {
            if (!finalOptions.fillHoles) hole = true;
        } else {
            if (finalOptions.increasingX && i >= 2 && pathCoordinates[i] <= pathCoordinates[i - 2]) // X is not increasing, so we need to make sure we start a new segment
            hole = true;
            // If it's a valid value we need to check if we're coming out of a hole and create a new empty segment
            if (hole) {
                segments.push({
                    pathCoordinates: [],
                    valueData: []
                });
                // As we have a valid value now, we are not in a "hole" anymore
                hole = false;
            }
            // Add to the segment pathCoordinates and valueData
            segments[segments.length - 1].pathCoordinates.push(pathCoordinates[i], pathCoordinates[i + 1]);
            segments[segments.length - 1].valueData.push(valueData[i / 2]);
        }
    }
    return segments;
}
function $857626bf766d9720$export$dfdc1655ccc5b9cb(data) {
    let serialized = "";
    if (data === null || data === undefined) return data;
    else if (typeof data === "number") serialized = "" + data;
    else if (typeof data === "object") serialized = JSON.stringify({
        data: data
    });
    else serialized = String(data);
    return Object.keys($857626bf766d9720$export$c56f738b5b9e4176).reduce((result, key)=>result.replaceAll(key, $857626bf766d9720$export$c56f738b5b9e4176[key]), serialized);
}
function $857626bf766d9720$export$efcd34ab6248d3cd(data) {
    if (typeof data !== "string") return data;
    if (data === "NaN") return NaN;
    data = Object.keys($857626bf766d9720$export$c56f738b5b9e4176).reduce((result, key)=>result.replaceAll($857626bf766d9720$export$c56f738b5b9e4176[key], key), data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let parsedData = data;
    if (typeof data === "string") try {
        parsedData = JSON.parse(data);
        parsedData = parsedData.data !== undefined ? parsedData.data : parsedData;
    } catch (e) {
    /* Ingore */ }
    return parsedData;
}
/**
 * This helper class is to wrap multiple `Svg` elements into a list where you can call the `Svg` functions on all elements in the list with one call. This is helpful when you'd like to perform calls with `Svg` on multiple elements.
 * An instance of this class is also returned by `Svg.querySelectorAll`.
 */ class $857626bf766d9720$export$6a1629697f60641 {
    call(method, args) {
        this.svgElements.forEach((element)=>Reflect.apply(element[method], element, args));
        return this;
    }
    attr() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("attr", args);
    }
    elem() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("elem", args);
    }
    root() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("root", args);
    }
    getNode() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("getNode", args);
    }
    foreignObject() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("foreignObject", args);
    }
    text() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("text", args);
    }
    empty() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("empty", args);
    }
    remove() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("remove", args);
    }
    addClass() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("addClass", args);
    }
    removeClass() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("removeClass", args);
    }
    removeAllClasses() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("removeAllClasses", args);
    }
    animate() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.call("animate", args);
    }
    /**
   * @param nodeList An Array of SVG DOM nodes or a SVG DOM NodeList (as returned by document.querySelectorAll)
   */ constructor(nodeList){
        this.svgElements = [];
        for(let i = 0; i < nodeList.length; i++)this.svgElements.push(new $857626bf766d9720$export$e17b9c1182212c96(nodeList[i]));
    }
}
/**
 * This Object contains some standard easing cubic bezier curves.
 * Then can be used with their name in the `Svg.animate`.
 * You can also extend the list and use your own name in the `animate` function.
 * Click the show code button to see the available bezier functions.
 */ const $857626bf766d9720$export$15a0bf1b4bbacad8 = {
    easeInSine: [
        0.47,
        0,
        0.745,
        0.715
    ],
    easeOutSine: [
        0.39,
        0.575,
        0.565,
        1
    ],
    easeInOutSine: [
        0.445,
        0.05,
        0.55,
        0.95
    ],
    easeInQuad: [
        0.55,
        0.085,
        0.68,
        0.53
    ],
    easeOutQuad: [
        0.25,
        0.46,
        0.45,
        0.94
    ],
    easeInOutQuad: [
        0.455,
        0.03,
        0.515,
        0.955
    ],
    easeInCubic: [
        0.55,
        0.055,
        0.675,
        0.19
    ],
    easeOutCubic: [
        0.215,
        0.61,
        0.355,
        1
    ],
    easeInOutCubic: [
        0.645,
        0.045,
        0.355,
        1
    ],
    easeInQuart: [
        0.895,
        0.03,
        0.685,
        0.22
    ],
    easeOutQuart: [
        0.165,
        0.84,
        0.44,
        1
    ],
    easeInOutQuart: [
        0.77,
        0,
        0.175,
        1
    ],
    easeInQuint: [
        0.755,
        0.05,
        0.855,
        0.06
    ],
    easeOutQuint: [
        0.23,
        1,
        0.32,
        1
    ],
    easeInOutQuint: [
        0.86,
        0,
        0.07,
        1
    ],
    easeInExpo: [
        0.95,
        0.05,
        0.795,
        0.035
    ],
    easeOutExpo: [
        0.19,
        1,
        0.22,
        1
    ],
    easeInOutExpo: [
        1,
        0,
        0,
        1
    ],
    easeInCirc: [
        0.6,
        0.04,
        0.98,
        0.335
    ],
    easeOutCirc: [
        0.075,
        0.82,
        0.165,
        1
    ],
    easeInOutCirc: [
        0.785,
        0.135,
        0.15,
        0.86
    ],
    easeInBack: [
        0.6,
        -0.28,
        0.735,
        0.045
    ],
    easeOutBack: [
        0.175,
        0.885,
        0.32,
        1.275
    ],
    easeInOutBack: [
        0.68,
        -0.55,
        0.265,
        1.55
    ]
};
function $857626bf766d9720$var$createAnimation(element, attribute, animationDefinition) {
    let createGuided = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, eventEmitter = arguments.length > 4 ? arguments[4] : void 0;
    const { easing: easing, ...def } = animationDefinition;
    const attributeProperties = {};
    let animationEasing;
    let timeout;
    // Check if an easing is specified in the definition object and delete it from the object as it will not
    // be part of the animate element attributes.
    if (easing) // If already an easing Bézier curve array we take it or we lookup a easing array in the Easing object
    animationEasing = Array.isArray(easing) ? easing : $857626bf766d9720$export$15a0bf1b4bbacad8[easing];
    // If numeric dur or begin was provided we assume milli seconds
    def.begin = $857626bf766d9720$export$55ba73e7e2582947(def.begin, "ms");
    def.dur = $857626bf766d9720$export$55ba73e7e2582947(def.dur, "ms");
    if (animationEasing) {
        def.calcMode = "spline";
        def.keySplines = animationEasing.join(" ");
        def.keyTimes = "0;1";
    }
    // Adding "fill: freeze" if we are in guided mode and set initial attribute values
    if (createGuided) {
        def.fill = "freeze";
        // Animated property on our element should already be set to the animation from value in guided mode
        attributeProperties[attribute] = def.from;
        element.attr(attributeProperties);
        // In guided mode we also set begin to indefinite so we can trigger the start manually and put the begin
        // which needs to be in ms aside
        timeout = $857626bf766d9720$export$82dd68b83a44b253(def.begin || 0).value;
        def.begin = "indefinite";
    }
    const animate = element.elem("animate", {
        attributeName: attribute,
        ...def
    });
    if (createGuided) // If guided we take the value that was put aside in timeout and trigger the animation manually with a timeout
    setTimeout(()=>{
        // If beginElement fails we set the animated attribute to the end position and remove the animate element
        // This happens if the SMIL ElementTimeControl interface is not supported or any other problems occurred in
        // the browser. (Currently FF 34 does not support animate elements in foreignObjects)
        try {
            // @ts-expect-error Try legacy API.
            animate._node.beginElement();
        } catch (err) {
            // Set animated attribute to current animated value
            attributeProperties[attribute] = def.to;
            element.attr(attributeProperties);
            // Remove the animate element as it's no longer required
            animate.remove();
        }
    }, timeout);
    const animateNode = animate.getNode();
    if (eventEmitter) animateNode.addEventListener("beginEvent", ()=>eventEmitter.emit("animationBegin", {
            element: element,
            animate: animateNode,
            params: animationDefinition
        }));
    animateNode.addEventListener("endEvent", ()=>{
        if (eventEmitter) eventEmitter.emit("animationEnd", {
            element: element,
            animate: animateNode,
            params: animationDefinition
        });
        if (createGuided) {
            // Set animated attribute to current animated value
            attributeProperties[attribute] = def.to;
            element.attr(attributeProperties);
            // Remove the animate element as it's no longer required
            animate.remove();
        }
    });
}
/**
 * Svg creates a new SVG object wrapper with a starting element. You can use the wrapper to fluently create sub-elements and modify them.
 */ class $857626bf766d9720$export$e17b9c1182212c96 {
    attr(attributes, ns) {
        if (typeof attributes === "string") {
            if (ns) return this._node.getAttributeNS(ns, attributes);
            else return this._node.getAttribute(attributes);
        }
        Object.keys(attributes).forEach((key)=>{
            // If the attribute value is undefined we can skip this one
            if (attributes[key] === undefined) return;
            if (key.indexOf(":") !== -1) {
                const namespacedAttribute = key.split(":");
                this._node.setAttributeNS($857626bf766d9720$export$41fc20bb625e8618[namespacedAttribute[0]], key, String(attributes[key]));
            } else this._node.setAttribute(key, String(attributes[key]));
        });
        return this;
    }
    /**
   * Create a new SVG element whose wrapper object will be selected for further operations. This way you can also create nested groups easily.
   * @param name The name of the SVG element that should be created as child element of the currently selected element wrapper
   * @param attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param className This class or class list will be added to the SVG element
   * @param insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   * @return Returns a Svg wrapper object that can be used to modify the containing SVG data
   */ elem(name, attributes, className) {
        let insertFirst = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        return new $857626bf766d9720$export$e17b9c1182212c96(name, attributes, className, this, insertFirst);
    }
    /**
   * Returns the parent Chartist.SVG wrapper object
   * @return Returns a Svg wrapper around the parent node of the current node. If the parent node is not existing or it's not an SVG node then this function will return null.
   */ parent() {
        return this._node.parentNode instanceof SVGElement ? new $857626bf766d9720$export$e17b9c1182212c96(this._node.parentNode) : null;
    }
    /**
   * This method returns a Svg wrapper around the root SVG element of the current tree.
   * @return The root SVG element wrapped in a Svg element
   */ root() {
        let node = this._node;
        while(node.nodeName !== "svg"){
            if (node.parentElement) node = node.parentElement;
            else break;
        }
        return new $857626bf766d9720$export$e17b9c1182212c96(node);
    }
    /**
   * Find the first child SVG element of the current element that matches a CSS selector. The returned object is a Svg wrapper.
   * @param selector A CSS selector that is used to query for child SVG elements
   * @return The SVG wrapper for the element found or null if no element was found
   */ querySelector(selector) {
        const foundNode = this._node.querySelector(selector);
        return foundNode ? new $857626bf766d9720$export$e17b9c1182212c96(foundNode) : null;
    }
    /**
   * Find the all child SVG elements of the current element that match a CSS selector. The returned object is a Svg.List wrapper.
   * @param selector A CSS selector that is used to query for child SVG elements
   * @return The SVG wrapper list for the element found or null if no element was found
   */ querySelectorAll(selector) {
        const foundNodes = this._node.querySelectorAll(selector);
        return new $857626bf766d9720$export$6a1629697f60641(foundNodes);
    }
    /**
   * Returns the underlying SVG node for the current element.
   */ getNode() {
        return this._node;
    }
    /**
   * This method creates a foreignObject (see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject) that allows to embed HTML content into a SVG graphic. With the help of foreignObjects you can enable the usage of regular HTML elements inside of SVG where they are subject for SVG positioning and transformation but the Browser will use the HTML rendering capabilities for the containing DOM.
   * @param content The DOM Node, or HTML string that will be converted to a DOM Node, that is then placed into and wrapped by the foreignObject
   * @param attributes An object with properties that will be added as attributes to the foreignObject element that is created. Attributes with undefined values will not be added.
   * @param className This class or class list will be added to the SVG element
   * @param insertFirst Specifies if the foreignObject should be inserted as first child
   * @return New wrapper object that wraps the foreignObject element
   */ foreignObject(content, attributes, className) {
        let insertFirst = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        let contentNode;
        // If content is string then we convert it to DOM
        // TODO: Handle case where content is not a string nor a DOM Node
        if (typeof content === "string") {
            const container = document.createElement("div");
            container.innerHTML = content;
            contentNode = container.firstChild;
        } else contentNode = content;
        if (contentNode instanceof Element) // Adding namespace to content element
        contentNode.setAttribute("xmlns", $857626bf766d9720$export$41fc20bb625e8618.xmlns);
        // Creating the foreignObject without required extension attribute (as described here
        // http://www.w3.org/TR/SVG/extend.html#ForeignObjectElement)
        const fnObj = this.elem("foreignObject", attributes, className, insertFirst);
        // Add content to foreignObjectElement
        fnObj._node.appendChild(contentNode);
        return fnObj;
    }
    /**
   * This method adds a new text element to the current Svg wrapper.
   * @param t The text that should be added to the text element that is created
   * @return The same wrapper object that was used to add the newly created element
   */ text(t) {
        this._node.appendChild(document.createTextNode(t));
        return this;
    }
    /**
   * This method will clear all child nodes of the current wrapper object.
   * @return The same wrapper object that got emptied
   */ empty() {
        while(this._node.firstChild)this._node.removeChild(this._node.firstChild);
        return this;
    }
    /**
   * This method will cause the current wrapper to remove itself from its parent wrapper. Use this method if you'd like to get rid of an element in a given DOM structure.
   * @return The parent wrapper object of the element that got removed
   */ remove() {
        var ref;
        (ref = this._node.parentNode) === null || ref === void 0 || ref.removeChild(this._node);
        return this.parent();
    }
    /**
   * This method will replace the element with a new element that can be created outside of the current DOM.
   * @param newElement The new Svg object that will be used to replace the current wrapper object
   * @return The wrapper of the new element
   */ replace(newElement) {
        var ref;
        (ref = this._node.parentNode) === null || ref === void 0 || ref.replaceChild(newElement._node, this._node);
        return newElement;
    }
    /**
   * This method will append an element to the current element as a child.
   * @param element The Svg element that should be added as a child
   * @param insertFirst Specifies if the element should be inserted as first child
   * @return The wrapper of the appended object
   */ append(element) {
        let insertFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (insertFirst && this._node.firstChild) this._node.insertBefore(element._node, this._node.firstChild);
        else this._node.appendChild(element._node);
        return this;
    }
    /**
   * Returns an array of class names that are attached to the current wrapper element. This method can not be chained further.
   * @return A list of classes or an empty array if there are no classes on the current element
   */ classes() {
        const classNames = this._node.getAttribute("class");
        return classNames ? classNames.trim().split(/\s+/) : [];
    }
    /**
   * Adds one or a space separated list of classes to the current element and ensures the classes are only existing once.
   * @param names A white space separated list of class names
   * @return The wrapper of the current element
   */ addClass(names) {
        this._node.setAttribute("class", this.classes().concat(names.trim().split(/\s+/)).filter(function(elem, pos, self) {
            return self.indexOf(elem) === pos;
        }).join(" "));
        return this;
    }
    /**
   * Removes one or a space separated list of classes from the current element.
   * @param names A white space separated list of class names
   * @return The wrapper of the current element
   */ removeClass(names) {
        const removedClasses = names.trim().split(/\s+/);
        this._node.setAttribute("class", this.classes().filter((name)=>removedClasses.indexOf(name) === -1).join(" "));
        return this;
    }
    /**
   * Removes all classes from the current element.
   * @return The wrapper of the current element
   */ removeAllClasses() {
        this._node.setAttribute("class", "");
        return this;
    }
    /**
   * Get element height using `getBoundingClientRect`
   * @return The elements height in pixels
   */ height() {
        return this._node.getBoundingClientRect().height;
    }
    /**
   * Get element width using `getBoundingClientRect`
   * @return The elements width in pixels
   */ width() {
        return this._node.getBoundingClientRect().width;
    }
    /**
   * The animate function lets you animate the current element with SMIL animations. You can add animations for multiple attributes at the same time by using an animation definition object. This object should contain SMIL animation attributes. Please refer to http://www.w3.org/TR/SVG/animate.html for a detailed specification about the available animation attributes. Additionally an easing property can be passed in the animation definition object. This can be a string with a name of an easing function in `Svg.Easing` or an array with four numbers specifying a cubic Bézier curve.
   * **An animations object could look like this:**
   * ```javascript
   * element.animate({
   *   opacity: {
   *     dur: 1000,
   *     from: 0,
   *     to: 1
   *   },
   *   x1: {
   *     dur: '1000ms',
   *     from: 100,
   *     to: 200,
   *     easing: 'easeOutQuart'
   *   },
   *   y1: {
   *     dur: '2s',
   *     from: 0,
   *     to: 100
   *   }
   * });
   * ```
   * **Automatic unit conversion**
   * For the `dur` and the `begin` animate attribute you can also omit a unit by passing a number. The number will automatically be converted to milli seconds.
   * **Guided mode**
   * The default behavior of SMIL animations with offset using the `begin` attribute is that the attribute will keep it's original value until the animation starts. Mostly this behavior is not desired as you'd like to have your element attributes already initialized with the animation `from` value even before the animation starts. Also if you don't specify `fill="freeze"` on an animate element or if you delete the animation after it's done (which is done in guided mode) the attribute will switch back to the initial value. This behavior is also not desired when performing simple one-time animations. For one-time animations you'd want to trigger animations immediately instead of relative to the document begin time. That's why in guided mode Svg will also use the `begin` property to schedule a timeout and manually start the animation after the timeout. If you're using multiple SMIL definition objects for an attribute (in an array), guided mode will be disabled for this attribute, even if you explicitly enabled it.
   * If guided mode is enabled the following behavior is added:
   * - Before the animation starts (even when delayed with `begin`) the animated attribute will be set already to the `from` value of the animation
   * - `begin` is explicitly set to `indefinite` so it can be started manually without relying on document begin time (creation)
   * - The animate element will be forced to use `fill="freeze"`
   * - The animation will be triggered with `beginElement()` in a timeout where `begin` of the definition object is interpreted in milli seconds. If no `begin` was specified the timeout is triggered immediately.
   * - After the animation the element attribute value will be set to the `to` value of the animation
   * - The animate element is deleted from the DOM
   * @param animations An animations object where the property keys are the attributes you'd like to animate. The properties should be objects again that contain the SMIL animation attributes (usually begin, dur, from, and to). The property begin and dur is auto converted (see Automatic unit conversion). You can also schedule multiple animations for the same attribute by passing an Array of SMIL definition objects. Attributes that contain an array of SMIL definition objects will not be executed in guided mode.
   * @param guided Specify if guided mode should be activated for this animation (see Guided mode). If not otherwise specified, guided mode will be activated.
   * @param eventEmitter If specified, this event emitter will be notified when an animation starts or ends.
   * @return The current element where the animation was added
   */ animate(animations) {
        let guided = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, eventEmitter = arguments.length > 2 ? arguments[2] : void 0;
        Object.keys(animations).forEach((attribute)=>{
            const attributeAnimation = animations[attribute];
            // If current attribute is an array of definition objects we create an animate for each and disable guided mode
            if (Array.isArray(attributeAnimation)) attributeAnimation.forEach((animationDefinition)=>$857626bf766d9720$var$createAnimation(this, attribute, animationDefinition, false, eventEmitter));
            else $857626bf766d9720$var$createAnimation(this, attribute, attributeAnimation, guided, eventEmitter);
        });
        return this;
    }
    /**
   * @param name The name of the SVG element to create or an SVG dom element which should be wrapped into Svg
   * @param attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param className This class or class list will be added to the SVG element
   * @param parent The parent SVG wrapper object where this newly created wrapper and it's element will be attached to as child
   * @param insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   */ constructor(name, attributes, className, parent, insertFirst = false){
        // If Svg is getting called with an SVG element we just return the wrapper
        if (name instanceof Element) this._node = name;
        else {
            this._node = document.createElementNS($857626bf766d9720$export$41fc20bb625e8618.svg, name);
            // If this is an SVG element created then custom namespace
            if (name === "svg") this.attr({
                "xmlns:ct": $857626bf766d9720$export$41fc20bb625e8618.ct
            });
        }
        if (attributes) this.attr(attributes);
        if (className) this.addClass(className);
        if (parent) {
            if (insertFirst && parent._node.firstChild) parent._node.insertBefore(this._node, parent._node.firstChild);
            else parent._node.appendChild(this._node);
        }
    }
}
/**
   * @todo Only there for chartist <1 compatibility. Remove after deprecation warining.
   * @deprecated Use the animation module export `easings` directly.
   */ $857626bf766d9720$export$e17b9c1182212c96.Easing = $857626bf766d9720$export$15a0bf1b4bbacad8;
/**
 * Create or reinitialize the SVG element for the chart
 * @param container The containing DOM Node object that will be used to plant the SVG element
 * @param width Set the width of the SVG element. Default is 100%
 * @param height Set the height of the SVG element. Default is 100%
 * @param className Specify a class to be added to the SVG element
 * @return The created/reinitialized SVG element
 */ function $857626bf766d9720$export$c54fe3b9ecaa84cf(container) {
    let width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "100%", height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "100%", className = arguments.length > 3 ? arguments[3] : void 0;
    // Check if there is a previous SVG element in the container that contains the Chartist XML namespace and remove it
    // Since the DOM API does not support namespaces we need to manually search the returned list http://www.w3.org/TR/selectors-api/
    Array.from(container.querySelectorAll("svg")).filter((svg)=>svg.getAttributeNS($857626bf766d9720$export$41fc20bb625e8618.xmlns, "ct")).forEach((svg)=>container.removeChild(svg));
    // Create svg object with width and height or use 100% as default
    const svg1 = new $857626bf766d9720$export$e17b9c1182212c96("svg").attr({
        width: width,
        height: height
    }).attr({
        // TODO: Check better solution (browser support) and remove inline styles due to CSP
        style: "width: ".concat(width, "; height: ").concat(height, ";")
    });
    if (className) svg1.addClass(className);
    // Add the DOM node to our container
    container.appendChild(svg1.getNode());
    return svg1;
}
/**
 * Converts a number into a padding object.
 * @param padding
 * @param fallback This value is used to fill missing values if a incomplete padding object was passed
 * @returns Returns a padding object containing top, right, bottom, left properties filled with the padding number passed in as argument. If the argument is something else than a number (presumably already a correct padding object) then this argument is directly returned.
 */ function $857626bf766d9720$export$9a9bba3f57c45f3f(padding) {
    return typeof padding === "number" ? {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    } : padding === undefined ? {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    } : {
        top: typeof padding.top === "number" ? padding.top : 0,
        right: typeof padding.right === "number" ? padding.right : 0,
        bottom: typeof padding.bottom === "number" ? padding.bottom : 0,
        left: typeof padding.left === "number" ? padding.left : 0
    };
}
/**
 * Initialize chart drawing rectangle (area where chart is drawn) x1,y1 = bottom left / x2,y2 = top right
 * @param svg The svg element for the chart
 * @param options The Object that contains all the optional values for the chart
 * @return The chart rectangles coordinates inside the svg element plus the rectangles measurements
 */ function $857626bf766d9720$export$287763b5f38b12d6(svg, options) {
    var ref, ref1, ref2, ref3;
    const hasAxis = Boolean(options.axisX || options.axisY);
    const yAxisOffset = ((ref = options.axisY) === null || ref === void 0 ? void 0 : ref.offset) || 0;
    const xAxisOffset = ((ref1 = options.axisX) === null || ref1 === void 0 ? void 0 : ref1.offset) || 0;
    const yAxisPosition = (ref2 = options.axisY) === null || ref2 === void 0 ? void 0 : ref2.position;
    const xAxisPosition = (ref3 = options.axisX) === null || ref3 === void 0 ? void 0 : ref3.position;
    // If width or height results in invalid value (including 0) we fallback to the unitless settings or even 0
    let width = svg.width() || $857626bf766d9720$export$82dd68b83a44b253(options.width).value || 0;
    let height = svg.height() || $857626bf766d9720$export$82dd68b83a44b253(options.height).value || 0;
    const normalizedPadding = $857626bf766d9720$export$9a9bba3f57c45f3f(options.chartPadding);
    // If settings were to small to cope with offset (legacy) and padding, we'll adjust
    width = Math.max(width, yAxisOffset + normalizedPadding.left + normalizedPadding.right);
    height = Math.max(height, xAxisOffset + normalizedPadding.top + normalizedPadding.bottom);
    const chartRect = {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0,
        padding: normalizedPadding,
        width () {
            return this.x2 - this.x1;
        },
        height () {
            return this.y1 - this.y2;
        }
    };
    if (hasAxis) {
        if (xAxisPosition === "start") {
            chartRect.y2 = normalizedPadding.top + xAxisOffset;
            chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
        } else {
            chartRect.y2 = normalizedPadding.top;
            chartRect.y1 = Math.max(height - normalizedPadding.bottom - xAxisOffset, chartRect.y2 + 1);
        }
        if (yAxisPosition === "start") {
            chartRect.x1 = normalizedPadding.left + yAxisOffset;
            chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
        } else {
            chartRect.x1 = normalizedPadding.left;
            chartRect.x2 = Math.max(width - normalizedPadding.right - yAxisOffset, chartRect.x1 + 1);
        }
    } else {
        chartRect.x1 = normalizedPadding.left;
        chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
        chartRect.y2 = normalizedPadding.top;
        chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
    }
    return chartRect;
}
/**
 * Creates a grid line based on a projected value.
 */ function $857626bf766d9720$export$fce123c48a7b4eae(position, index, axis, offset, length, group, classes, eventEmitter) {
    const positionalData = {
        ["".concat(axis.units.pos, "1")]: position,
        ["".concat(axis.units.pos, "2")]: position,
        ["".concat(axis.counterUnits.pos, "1")]: offset,
        ["".concat(axis.counterUnits.pos, "2")]: offset + length
    };
    const gridElement = group.elem("line", positionalData, classes.join(" "));
    // Event for grid draw
    eventEmitter.emit("draw", {
        type: "grid",
        axis: axis,
        index: index,
        group: group,
        element: gridElement,
        ...positionalData
    });
}
/**
 * Creates a grid background rect and emits the draw event.
 */ function $857626bf766d9720$export$46e1d35fe977edb4(gridGroup, chartRect, className, eventEmitter) {
    const gridBackground = gridGroup.elem("rect", {
        x: chartRect.x1,
        y: chartRect.y2,
        width: chartRect.width(),
        height: chartRect.height()
    }, className, true);
    // Event for grid background draw
    eventEmitter.emit("draw", {
        type: "gridBackground",
        group: gridGroup,
        element: gridBackground
    });
}
/**
 * Creates a label based on a projected value and an axis.
 */ function $857626bf766d9720$export$f2839682b8c07f35(position, length, index, label, axis, axisOffset, labelOffset, group, classes, eventEmitter) {
    const positionalData = {
        [axis.units.pos]: position + labelOffset[axis.units.pos],
        [axis.counterUnits.pos]: labelOffset[axis.counterUnits.pos],
        [axis.units.len]: length,
        [axis.counterUnits.len]: Math.max(0, axisOffset - 10)
    };
    // We need to set width and height explicitly to px as span will not expand with width and height being
    // 100% in all browsers
    const stepLength = Math.round(positionalData[axis.units.len]);
    const stepCounterLength = Math.round(positionalData[axis.counterUnits.len]);
    const content = document.createElement("span");
    content.className = classes.join(" ");
    content.style[axis.units.len] = stepLength + "px";
    content.style[axis.counterUnits.len] = stepCounterLength + "px";
    content.textContent = String(label);
    const labelElement = group.foreignObject(content, {
        style: "overflow: visible;",
        ...positionalData
    });
    eventEmitter.emit("draw", {
        type: "label",
        axis: axis,
        index: index,
        group: group,
        element: labelElement,
        text: label,
        ...positionalData
    });
}
/**
 * Provides options handling functionality with callback for options changes triggered by responsive options and media query matches
 * @param options Options set by user
 * @param responsiveOptions Optional functions to add responsive behavior to chart
 * @param eventEmitter The event emitter that will be used to emit the options changed events
 * @return The consolidated options object from the defaults, base and matching responsive options
 */ function $857626bf766d9720$export$f12efb46802a3d21(options, responsiveOptions, eventEmitter) {
    let currentOptions;
    const mediaQueryListeners = [];
    function updateCurrentOptions(mediaEvent) {
        const previousOptions = currentOptions;
        currentOptions = $857626bf766d9720$export$8b58be045bf06082({}, options);
        if (responsiveOptions) responsiveOptions.forEach((responsiveOption)=>{
            const mql = window.matchMedia(responsiveOption[0]);
            if (mql.matches) currentOptions = $857626bf766d9720$export$8b58be045bf06082(currentOptions, responsiveOption[1]);
        });
        if (eventEmitter && mediaEvent) eventEmitter.emit("optionsChanged", {
            previousOptions: previousOptions,
            currentOptions: currentOptions
        });
    }
    function removeMediaQueryListeners() {
        mediaQueryListeners.forEach((mql)=>mql.removeEventListener("change", updateCurrentOptions));
    }
    if (!window.matchMedia) throw new Error("window.matchMedia not found! Make sure you're using a polyfill.");
    else if (responsiveOptions) responsiveOptions.forEach((responsiveOption)=>{
        const mql = window.matchMedia(responsiveOption[0]);
        mql.addEventListener("change", updateCurrentOptions);
        mediaQueryListeners.push(mql);
    });
    // Execute initially without an event argument so we get the correct options
    updateCurrentOptions();
    return {
        removeMediaQueryListeners: removeMediaQueryListeners,
        getCurrentOptions () {
            return currentOptions;
        }
    };
}
/**
 * Contains the descriptors of supported element types in a SVG path. Currently only move, line and curve are supported.
 */ const $857626bf766d9720$var$elementDescriptions = {
    m: [
        "x",
        "y"
    ],
    l: [
        "x",
        "y"
    ],
    c: [
        "x1",
        "y1",
        "x2",
        "y2",
        "x",
        "y"
    ],
    a: [
        "rx",
        "ry",
        "xAr",
        "lAf",
        "sf",
        "x",
        "y"
    ]
};
/**
 * Default options for newly created SVG path objects.
 */ const $857626bf766d9720$var$defaultOptions$3 = {
    // The accuracy in digit count after the decimal point. This will be used to round numbers in the SVG path. If this option is set to false then no rounding will be performed.
    accuracy: 3
};
function $857626bf766d9720$var$element(command, params, pathElements, pos, relative, data) {
    const pathElement = {
        command: relative ? command.toLowerCase() : command.toUpperCase(),
        ...params,
        ...data ? {
            data: data
        } : {}
    };
    pathElements.splice(pos, 0, pathElement);
}
function $857626bf766d9720$var$forEachParam(pathElements, cb) {
    pathElements.forEach((pathElement, pathElementIndex)=>{
        $857626bf766d9720$var$elementDescriptions[pathElement.command.toLowerCase()].forEach((paramName, paramIndex)=>{
            cb(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
        });
    });
}
class $857626bf766d9720$export$1c313b81a43a728a {
    /**
   * This static function on `SvgPath` is joining multiple paths together into one paths.
   * @param paths A list of paths to be joined together. The order is important.
   * @param close If the newly created path should be a closed path
   * @param options Path options for the newly created path.
   */ static join(paths) {
        let close = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 ? arguments[2] : void 0;
        const joinedPath = new $857626bf766d9720$export$1c313b81a43a728a(close, options);
        for(let i = 0; i < paths.length; i++){
            const path = paths[i];
            for(let j = 0; j < path.pathElements.length; j++)joinedPath.pathElements.push(path.pathElements[j]);
        }
        return joinedPath;
    }
    position(pos) {
        if (pos !== undefined) {
            this.pos = Math.max(0, Math.min(this.pathElements.length, pos));
            return this;
        } else return this.pos;
    }
    /**
   * Removes elements from the path starting at the current position.
   * @param count Number of path elements that should be removed from the current position.
   * @return The current path object for easy call chaining.
   */ remove(count) {
        this.pathElements.splice(this.pos, count);
        return this;
    }
    /**
   * Use this function to add a new move SVG path element.
   * @param x The x coordinate for the move element.
   * @param y The y coordinate for the move element.
   * @param relative If set to true the move element will be created with relative coordinates (lowercase letter)
   * @param data Any data that should be stored with the element object that will be accessible in pathElement
   * @return The current path object for easy call chaining.
   */ move(x, y) {
        let relative = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, data = arguments.length > 3 ? arguments[3] : void 0;
        $857626bf766d9720$var$element("M", {
            x: +x,
            y: +y
        }, this.pathElements, this.pos++, relative, data);
        return this;
    }
    /**
   * Use this function to add a new line SVG path element.
   * @param x The x coordinate for the line element.
   * @param y The y coordinate for the line element.
   * @param relative If set to true the line element will be created with relative coordinates (lowercase letter)
   * @param data Any data that should be stored with the element object that will be accessible in pathElement
   * @return The current path object for easy call chaining.
   */ line(x, y) {
        let relative = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, data = arguments.length > 3 ? arguments[3] : void 0;
        $857626bf766d9720$var$element("L", {
            x: +x,
            y: +y
        }, this.pathElements, this.pos++, relative, data);
        return this;
    }
    /**
   * Use this function to add a new curve SVG path element.
   * @param x1 The x coordinate for the first control point of the bezier curve.
   * @param y1 The y coordinate for the first control point of the bezier curve.
   * @param x2 The x coordinate for the second control point of the bezier curve.
   * @param y2 The y coordinate for the second control point of the bezier curve.
   * @param x The x coordinate for the target point of the curve element.
   * @param y The y coordinate for the target point of the curve element.
   * @param relative If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param data Any data that should be stored with the element object that will be accessible in pathElement
   * @return The current path object for easy call chaining.
   */ curve(x1, y1, x2, y2, x, y) {
        let relative = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, data = arguments.length > 7 ? arguments[7] : void 0;
        $857626bf766d9720$var$element("C", {
            x1: +x1,
            y1: +y1,
            x2: +x2,
            y2: +y2,
            x: +x,
            y: +y
        }, this.pathElements, this.pos++, relative, data);
        return this;
    }
    /**
   * Use this function to add a new non-bezier curve SVG path element.
   * @param rx The radius to be used for the x-axis of the arc.
   * @param ry The radius to be used for the y-axis of the arc.
   * @param xAr Defines the orientation of the arc
   * @param lAf Large arc flag
   * @param sf Sweep flag
   * @param x The x coordinate for the target point of the curve element.
   * @param y The y coordinate for the target point of the curve element.
   * @param relative If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param data Any data that should be stored with the element object that will be accessible in pathElement
   * @return The current path object for easy call chaining.
   */ arc(rx, ry, xAr, lAf, sf, x, y) {
        let relative = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false, data = arguments.length > 8 ? arguments[8] : void 0;
        $857626bf766d9720$var$element("A", {
            rx: rx,
            ry: ry,
            xAr: xAr,
            lAf: lAf,
            sf: sf,
            x: x,
            y: y
        }, this.pathElements, this.pos++, relative, data);
        return this;
    }
    /**
   * Parses an SVG path seen in the d attribute of path elements, and inserts the parsed elements into the existing path object at the current cursor position. Any closing path indicators (Z at the end of the path) will be ignored by the parser as this is provided by the close option in the options of the path object.
   * @param path Any SVG path that contains move (m), line (l) or curve (c) components.
   * @return The current path object for easy call chaining.
   */ parse(path) {
        // Parsing the SVG path string into an array of arrays [['M', '10', '10'], ['L', '100', '100']]
        const chunks = path.replace(/([A-Za-z])(-?[0-9])/g, "$1 $2").replace(/([0-9])([A-Za-z])/g, "$1 $2").split(/[\s,]+/).reduce((result, pathElement)=>{
            if (pathElement.match(/[A-Za-z]/)) result.push([]);
            result[result.length - 1].push(pathElement);
            return result;
        }, []);
        // If this is a closed path we remove the Z at the end because this is determined by the close option
        if (chunks[chunks.length - 1][0].toUpperCase() === "Z") chunks.pop();
        // Using svgPathElementDescriptions to map raw path arrays into objects that contain the command and the parameters
        // For example {command: 'M', x: '10', y: '10'}
        const elements = chunks.map((chunk)=>{
            const command = chunk.shift();
            const description = $857626bf766d9720$var$elementDescriptions[command.toLowerCase()];
            return {
                command: command,
                ...description.reduce((result, paramName, index)=>{
                    result[paramName] = +chunk[index];
                    return result;
                }, {})
            };
        });
        // Preparing a splice call with the elements array as var arg params and insert the parsed elements at the current position
        this.pathElements.splice(this.pos, 0, ...elements);
        // Increase the internal position by the element count
        this.pos += elements.length;
        return this;
    }
    /**
   * This function renders to current SVG path object into a final SVG string that can be used in the d attribute of SVG path elements. It uses the accuracy option to round big decimals. If the close parameter was set in the constructor of this path object then a path closing Z will be appended to the output string.
   */ stringify() {
        const accuracyMultiplier = Math.pow(10, this.options.accuracy);
        return this.pathElements.reduce((path, pathElement)=>{
            const params = $857626bf766d9720$var$elementDescriptions[pathElement.command.toLowerCase()].map((paramName)=>{
                const value = pathElement[paramName];
                return this.options.accuracy ? Math.round(value * accuracyMultiplier) / accuracyMultiplier : value;
            });
            return path + pathElement.command + params.join(",");
        }, "") + (this.close ? "Z" : "");
    }
    /**
   * Scales all elements in the current SVG path object. There is an individual parameter for each coordinate. Scaling will also be done for control points of curves, affecting the given coordinate.
   * @param x The number which will be used to scale the x, x1 and x2 of all path elements.
   * @param y The number which will be used to scale the y, y1 and y2 of all path elements.
   * @return The current path object for easy call chaining.
   */ scale(x, y) {
        $857626bf766d9720$var$forEachParam(this.pathElements, (pathElement, paramName)=>{
            pathElement[paramName] *= paramName[0] === "x" ? x : y;
        });
        return this;
    }
    /**
   * Translates all elements in the current SVG path object. The translation is relative and there is an individual parameter for each coordinate. Translation will also be done for control points of curves, affecting the given coordinate.
   * @param x The number which will be used to translate the x, x1 and x2 of all path elements.
   * @param y The number which will be used to translate the y, y1 and y2 of all path elements.
   * @return The current path object for easy call chaining.
   */ translate(x, y) {
        $857626bf766d9720$var$forEachParam(this.pathElements, (pathElement, paramName)=>{
            pathElement[paramName] += paramName[0] === "x" ? x : y;
        });
        return this;
    }
    /**
   * This function will run over all existing path elements and then loop over their attributes. The callback function will be called for every path element attribute that exists in the current path.
   * The method signature of the callback function looks like this:
   * ```javascript
   * function(pathElement, paramName, pathElementIndex, paramIndex, pathElements)
   * ```
   * If something else than undefined is returned by the callback function, this value will be used to replace the old value. This allows you to build custom transformations of path objects that can't be achieved using the basic transformation functions scale and translate.
   * @param transformFnc The callback function for the transformation. Check the signature in the function description.
   * @return The current path object for easy call chaining.
   */ transform(transformFnc) {
        $857626bf766d9720$var$forEachParam(this.pathElements, (pathElement, paramName, pathElementIndex, paramIndex, pathElements)=>{
            const transformed = transformFnc(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
            if (transformed || transformed === 0) pathElement[paramName] = transformed;
        });
        return this;
    }
    /**
   * This function clones a whole path object with all its properties. This is a deep clone and path element objects will also be cloned.
   * @param close Optional option to set the new cloned path to closed. If not specified or false, the original path close option will be used.
   */ clone() {
        let close = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        const clone = new $857626bf766d9720$export$1c313b81a43a728a(close || this.close);
        clone.pos = this.pos;
        clone.pathElements = this.pathElements.slice().map((pathElement)=>({
                ...pathElement
            }));
        clone.options = {
            ...this.options
        };
        return clone;
    }
    /**
   * Split a Svg.Path object by a specific command in the path chain. The path chain will be split and an array of newly created paths objects will be returned. This is useful if you'd like to split an SVG path by it's move commands, for example, in order to isolate chunks of drawings.
   * @param command The command you'd like to use to split the path
   */ splitByCommand(command) {
        const split = [
            new $857626bf766d9720$export$1c313b81a43a728a()
        ];
        this.pathElements.forEach((pathElement)=>{
            if (pathElement.command === command.toUpperCase() && split[split.length - 1].pathElements.length !== 0) split.push(new $857626bf766d9720$export$1c313b81a43a728a());
            split[split.length - 1].pathElements.push(pathElement);
        });
        return split;
    }
    /**
   * Used to construct a new path object.
   * @param close If set to true then this path will be closed when stringified (with a Z at the end)
   * @param options Options object that overrides the default objects. See default options for more details.
   */ constructor(close = false, options){
        this.close = close;
        this.pathElements = [];
        this.pos = 0;
        this.options = {
            ...$857626bf766d9720$var$defaultOptions$3,
            ...options
        };
    }
}
/**
 * This interpolation function does not smooth the path and the result is only containing lines and no curves.
 *
 * @example
 * ```ts
 * const chart = new LineChart('.ct-chart', {
 *   labels: [1, 2, 3, 4, 5],
 *   series: [[1, 2, 8, 1, 7]]
 * }, {
 *   lineSmooth: Interpolation.none({
 *     fillHoles: false
 *   })
 * });
 * ```
 */ function $857626bf766d9720$var$none(options) {
    const finalOptions = {
        fillHoles: false,
        ...options
    };
    return function noneInterpolation(pathCoordinates, valueData) {
        const path = new $857626bf766d9720$export$1c313b81a43a728a();
        let hole = true;
        for(let i = 0; i < pathCoordinates.length; i += 2){
            const currX = pathCoordinates[i];
            const currY = pathCoordinates[i + 1];
            const currData = valueData[i / 2];
            if ($857626bf766d9720$export$656dba5810c63062(currData.value) !== undefined) {
                if (hole) path.move(currX, currY, false, currData);
                else path.line(currX, currY, false, currData);
                hole = false;
            } else if (!finalOptions.fillHoles) hole = true;
        }
        return path;
    };
}
/**
 * Simple smoothing creates horizontal handles that are positioned with a fraction of the length between two data points. You can use the divisor option to specify the amount of smoothing.
 *
 * Simple smoothing can be used instead of `Chartist.Smoothing.cardinal` if you'd like to get rid of the artifacts it produces sometimes. Simple smoothing produces less flowing lines but is accurate by hitting the points and it also doesn't swing below or above the given data point.
 *
 * All smoothing functions within Chartist are factory functions that accept an options parameter. The simple interpolation function accepts one configuration parameter `divisor`, between 1 and ∞, which controls the smoothing characteristics.
 *
 * @example
 * ```ts
 * const chart = new LineChart('.ct-chart', {
 *   labels: [1, 2, 3, 4, 5],
 *   series: [[1, 2, 8, 1, 7]]
 * }, {
 *   lineSmooth: Interpolation.simple({
 *     divisor: 2,
 *     fillHoles: false
 *   })
 * });
 * ```
 *
 * @param options The options of the simple interpolation factory function.
 */ function $857626bf766d9720$var$simple(options) {
    const finalOptions = {
        divisor: 2,
        fillHoles: false,
        ...options
    };
    const d = 1 / Math.max(1, finalOptions.divisor);
    return function simpleInterpolation(pathCoordinates, valueData) {
        const path = new $857626bf766d9720$export$1c313b81a43a728a();
        let prevX = 0;
        let prevY = 0;
        let prevData;
        for(let i = 0; i < pathCoordinates.length; i += 2){
            const currX = pathCoordinates[i];
            const currY = pathCoordinates[i + 1];
            const length = (currX - prevX) * d;
            const currData = valueData[i / 2];
            if (currData.value !== undefined) {
                if (prevData === undefined) path.move(currX, currY, false, currData);
                else path.curve(prevX + length, prevY, currX - length, currY, currX, currY, false, currData);
                prevX = currX;
                prevY = currY;
                prevData = currData;
            } else if (!finalOptions.fillHoles) {
                prevX = prevY = 0;
                prevData = undefined;
            }
        }
        return path;
    };
}
/**
 * Step interpolation will cause the line chart to move in steps rather than diagonal or smoothed lines. This interpolation will create additional points that will also be drawn when the `showPoint` option is enabled.
 *
 * All smoothing functions within Chartist are factory functions that accept an options parameter. The step interpolation function accepts one configuration parameter `postpone`, that can be `true` or `false`. The default value is `true` and will cause the step to occur where the value actually changes. If a different behaviour is needed where the step is shifted to the left and happens before the actual value, this option can be set to `false`.
 *
 * @example
 * ```ts
 * const chart = new Chartist.Line('.ct-chart', {
 *   labels: [1, 2, 3, 4, 5],
 *   series: [[1, 2, 8, 1, 7]]
 * }, {
 *   lineSmooth: Interpolation.step({
 *     postpone: true,
 *     fillHoles: false
 *   })
 * });
 * ```
 */ function $857626bf766d9720$var$step(options) {
    const finalOptions = {
        postpone: true,
        fillHoles: false,
        ...options
    };
    return function stepInterpolation(pathCoordinates, valueData) {
        const path = new $857626bf766d9720$export$1c313b81a43a728a();
        let prevX = 0;
        let prevY = 0;
        let prevData;
        for(let i = 0; i < pathCoordinates.length; i += 2){
            const currX = pathCoordinates[i];
            const currY = pathCoordinates[i + 1];
            const currData = valueData[i / 2];
            // If the current point is also not a hole we can draw the step lines
            if (currData.value !== undefined) {
                if (prevData === undefined) path.move(currX, currY, false, currData);
                else {
                    if (finalOptions.postpone) // If postponed we should draw the step line with the value of the previous value
                    path.line(currX, prevY, false, prevData);
                    else // If not postponed we should draw the step line with the value of the current value
                    path.line(prevX, currY, false, currData);
                    // Line to the actual point (this should only be a Y-Axis movement
                    path.line(currX, currY, false, currData);
                }
                prevX = currX;
                prevY = currY;
                prevData = currData;
            } else if (!finalOptions.fillHoles) {
                prevX = prevY = 0;
                prevData = undefined;
            }
        }
        return path;
    };
}
/**
 * Cardinal / Catmull-Rome spline interpolation is the default smoothing function in Chartist. It produces nice results where the splines will always meet the points. It produces some artifacts though when data values are increased or decreased rapidly. The line may not follow a very accurate path and if the line should be accurate this smoothing function does not produce the best results.
 *
 * Cardinal splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
 *
 * All smoothing functions within Chartist are factory functions that accept an options parameter. The cardinal interpolation function accepts one configuration parameter `tension`, between 0 and 1, which controls the smoothing intensity.
 *
 * @example
 * ```ts
 * const chart = new LineChart('.ct-chart', {
 *   labels: [1, 2, 3, 4, 5],
 *   series: [[1, 2, 8, 1, 7]]
 * }, {
 *   lineSmooth: Interpolation.cardinal({
 *     tension: 1,
 *     fillHoles: false
 *   })
 * });
 * ```
 *
 * @param options The options of the cardinal factory function.
 */ function $857626bf766d9720$var$cardinal(options) {
    const finalOptions = {
        tension: 1,
        fillHoles: false,
        ...options
    };
    const t = Math.min(1, Math.max(0, finalOptions.tension));
    const c = 1 - t;
    return function cardinalInterpolation(pathCoordinates, valueData) {
        // First we try to split the coordinates into segments
        // This is necessary to treat "holes" in line charts
        const segments = $857626bf766d9720$export$cfb2ca1a0728c62d(pathCoordinates, valueData, {
            fillHoles: finalOptions.fillHoles
        });
        if (!segments.length) // If there were no segments return 'none' interpolation
        return $857626bf766d9720$var$none()([], []);
        else if (segments.length > 1) // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
        // For each segment we will recurse the cardinal function
        // Join the segment path data into a single path and return
        return $857626bf766d9720$export$1c313b81a43a728a.join(segments.map((segment)=>cardinalInterpolation(segment.pathCoordinates, segment.valueData)));
        else {
            // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
            // segment
            pathCoordinates = segments[0].pathCoordinates;
            valueData = segments[0].valueData;
            // If less than two points we need to fallback to no smoothing
            if (pathCoordinates.length <= 4) return $857626bf766d9720$var$none()(pathCoordinates, valueData);
            const path = new $857626bf766d9720$export$1c313b81a43a728a().move(pathCoordinates[0], pathCoordinates[1], false, valueData[0]);
            const z = false;
            for(let i = 0, iLen = pathCoordinates.length; iLen - 2 * Number(!z) > i; i += 2){
                const p = [
                    {
                        x: +pathCoordinates[i - 2],
                        y: +pathCoordinates[i - 1]
                    },
                    {
                        x: +pathCoordinates[i],
                        y: +pathCoordinates[i + 1]
                    },
                    {
                        x: +pathCoordinates[i + 2],
                        y: +pathCoordinates[i + 3]
                    },
                    {
                        x: +pathCoordinates[i + 4],
                        y: +pathCoordinates[i + 5]
                    }
                ];
                if (iLen - 4 === i) p[3] = p[2];
                else if (!i) p[0] = {
                    x: +pathCoordinates[i],
                    y: +pathCoordinates[i + 1]
                };
                path.curve(t * (-p[0].x + 6 * p[1].x + p[2].x) / 6 + c * p[2].x, t * (-p[0].y + 6 * p[1].y + p[2].y) / 6 + c * p[2].y, t * (p[1].x + 6 * p[2].x - p[3].x) / 6 + c * p[2].x, t * (p[1].y + 6 * p[2].y - p[3].y) / 6 + c * p[2].y, p[2].x, p[2].y, false, valueData[(i + 2) / 2]);
            }
            return path;
        }
    };
}
/**
 * Monotone Cubic spline interpolation produces a smooth curve which preserves monotonicity. Unlike cardinal splines, the curve will not extend beyond the range of y-values of the original data points.
 *
 * Monotone Cubic splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
 *
 * The x-values of subsequent points must be increasing to fit a Monotone Cubic spline. If this condition is not met for a pair of adjacent points, then there will be a break in the curve between those data points.
 *
 * All smoothing functions within Chartist are factory functions that accept an options parameter.
 *
 * @example
 * ```ts
 * const chart = new LineChart('.ct-chart', {
 *   labels: [1, 2, 3, 4, 5],
 *   series: [[1, 2, 8, 1, 7]]
 * }, {
 *   lineSmooth: Interpolation.monotoneCubic({
 *     fillHoles: false
 *   })
 * });
 * ```
 *
 * @param options The options of the monotoneCubic factory function.
 */ function $857626bf766d9720$var$monotoneCubic(options) {
    const finalOptions = {
        fillHoles: false,
        ...options
    };
    return function monotoneCubicInterpolation(pathCoordinates, valueData) {
        // First we try to split the coordinates into segments
        // This is necessary to treat "holes" in line charts
        const segments = $857626bf766d9720$export$cfb2ca1a0728c62d(pathCoordinates, valueData, {
            fillHoles: finalOptions.fillHoles,
            increasingX: true
        });
        if (!segments.length) // If there were no segments return 'Chartist.Interpolation.none'
        return $857626bf766d9720$var$none()([], []);
        else if (segments.length > 1) // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
        // For each segment we will recurse the monotoneCubic fn function
        // Join the segment path data into a single path and return
        return $857626bf766d9720$export$1c313b81a43a728a.join(segments.map((segment)=>monotoneCubicInterpolation(segment.pathCoordinates, segment.valueData)));
        else {
            // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
            // segment
            pathCoordinates = segments[0].pathCoordinates;
            valueData = segments[0].valueData;
            // If less than three points we need to fallback to no smoothing
            if (pathCoordinates.length <= 4) return $857626bf766d9720$var$none()(pathCoordinates, valueData);
            const xs = [];
            const ys = [];
            const n = pathCoordinates.length / 2;
            const ms = [];
            const ds = [];
            const dys = [];
            const dxs = [];
            // Populate x and y coordinates into separate arrays, for readability
            for(let i = 0; i < n; i++){
                xs[i] = pathCoordinates[i * 2];
                ys[i] = pathCoordinates[i * 2 + 1];
            }
            // Calculate deltas and derivative
            for(let i1 = 0; i1 < n - 1; i1++){
                dys[i1] = ys[i1 + 1] - ys[i1];
                dxs[i1] = xs[i1 + 1] - xs[i1];
                ds[i1] = dys[i1] / dxs[i1];
            }
            // Determine desired slope (m) at each point using Fritsch-Carlson method
            // See: http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
            ms[0] = ds[0];
            ms[n - 1] = ds[n - 2];
            for(let i2 = 1; i2 < n - 1; i2++)if (ds[i2] === 0 || ds[i2 - 1] === 0 || ds[i2 - 1] > 0 !== ds[i2] > 0) ms[i2] = 0;
            else {
                ms[i2] = 3 * (dxs[i2 - 1] + dxs[i2]) / ((2 * dxs[i2] + dxs[i2 - 1]) / ds[i2 - 1] + (dxs[i2] + 2 * dxs[i2 - 1]) / ds[i2]);
                if (!isFinite(ms[i2])) ms[i2] = 0;
            }
            // Now build a path from the slopes
            const path = new $857626bf766d9720$export$1c313b81a43a728a().move(xs[0], ys[0], false, valueData[0]);
            for(let i3 = 0; i3 < n - 1; i3++)path.curve(xs[i3] + dxs[i3] / 3, ys[i3] + ms[i3] * dxs[i3] / 3, xs[i3 + 1] - dxs[i3] / 3, ys[i3 + 1] - ms[i3 + 1] * dxs[i3] / 3, xs[i3 + 1], ys[i3 + 1], false, valueData[i3 + 1]);
            return path;
        }
    };
}
var $857626bf766d9720$export$b0cc4f9860136880 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $857626bf766d9720$var$none,
    simple: $857626bf766d9720$var$simple,
    step: $857626bf766d9720$var$step,
    cardinal: $857626bf766d9720$var$cardinal,
    monotoneCubic: $857626bf766d9720$var$monotoneCubic
});
class $857626bf766d9720$export$4fae95256245c8c0 {
    on(event, listener) {
        const { allListeners: allListeners, listeners: listeners } = this;
        if (event === "*") allListeners.add(listener);
        else {
            if (!listeners.has(event)) listeners.set(event, new Set());
            listeners.get(event).add(listener);
        }
    }
    off(event, listener) {
        const { allListeners: allListeners, listeners: listeners } = this;
        if (event === "*") {
            if (listener) allListeners.delete(listener);
            else allListeners.clear();
        } else if (listeners.has(event)) {
            const eventListeners = listeners.get(event);
            if (listener) eventListeners.delete(listener);
            else eventListeners.clear();
            if (!eventListeners.size) listeners.delete(event);
        }
    }
    /**
   * Use this function to emit an event. All handlers that are listening for this event will be triggered with the data parameter.
   * @param event The event name that should be triggered
   * @param data Arbitrary data that will be passed to the event handler callback functions
   */ emit(event, data) {
        const { allListeners: allListeners, listeners: listeners } = this;
        // Only do something if there are event handlers with this name existing
        if (listeners.has(event)) listeners.get(event).forEach((listener)=>listener(data));
        // Emit event to star event handlers
        allListeners.forEach((listener)=>listener(event, data));
    }
    constructor(){
        this.listeners = new Map();
        this.allListeners = new Set();
    }
}
const $857626bf766d9720$var$instances = new WeakMap();
class $857626bf766d9720$export$ba89768bd61fb9ef {
    // TODO: Currently we need to re-draw the chart on window resize. This is usually very bad and will affect performance.
    // This is done because we can't work with relative coordinates when drawing the chart because SVG Path does not
    // work with relative positions yet. We need to check if we can do a viewBox hack to switch to percentage.
    // See http://mozilla.6506.n7.nabble.com/Specyfing-paths-with-percentages-unit-td247474.html
    // Update: can be done using the above method tested here: http://codepen.io/gionkunz/pen/KDvLj
    // The problem is with the label offsets that can't be converted into percentage and affecting the chart container
    /**
   * Updates the chart which currently does a full reconstruction of the SVG DOM
   * @param data Optional data you'd like to set for the chart before it will update. If not specified the update method will use the data that is already configured with the chart.
   * @param options Optional options you'd like to add to the previous options for the chart before it will update. If not specified the update method will use the options that have been already configured with the chart.
   * @param override If set to true, the passed options will be used to extend the options that have been configured already. Otherwise the chart default options will be used as the base
   */ update(data, options) {
        let override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (data) {
            this.data = data || {};
            this.data.labels = this.data.labels || [];
            this.data.series = this.data.series || [];
            // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
            this.eventEmitter.emit("data", {
                type: "update",
                data: this.data
            });
        }
        if (options) {
            this.options = $857626bf766d9720$export$8b58be045bf06082({}, override ? this.options : this.defaultOptions, options);
            // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
            // Otherwise we re-create the optionsProvider at this point
            if (!this.initializeTimeoutId) {
                var ref;
                (ref = this.optionsProvider) === null || ref === void 0 || ref.removeMediaQueryListeners();
                this.optionsProvider = $857626bf766d9720$export$f12efb46802a3d21(this.options, this.responsiveOptions, this.eventEmitter);
            }
        }
        // Only re-created the chart if it has been initialized yet
        if (!this.initializeTimeoutId && this.optionsProvider) this.createChart(this.optionsProvider.getCurrentOptions());
        // Return a reference to the chart object to chain up calls
        return this;
    }
    /**
   * This method can be called on the API object of each chart and will un-register all event listeners that were added to other components. This currently includes a window.resize listener as well as media query listeners if any responsive options have been provided. Use this function if you need to destroy and recreate Chartist charts dynamically.
   */ detach() {
        // Only detach if initialization already occurred on this chart. If this chart still hasn't initialized (therefore
        // the initializationTimeoutId is still a valid timeout reference, we will clear the timeout
        if (!this.initializeTimeoutId) {
            var ref;
            window.removeEventListener("resize", this.resizeListener);
            (ref = this.optionsProvider) === null || ref === void 0 || ref.removeMediaQueryListeners();
        } else window.clearTimeout(this.initializeTimeoutId);
        $857626bf766d9720$var$instances.delete(this.container);
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        this.eventEmitter.on(event, listener);
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        this.eventEmitter.off(event, listener);
        return this;
    }
    initialize() {
        // Add window resize listener that re-creates the chart
        window.addEventListener("resize", this.resizeListener);
        // Obtain current options based on matching media queries (if responsive options are given)
        // This will also register a listener that is re-creating the chart based on media changes
        this.optionsProvider = $857626bf766d9720$export$f12efb46802a3d21(this.options, this.responsiveOptions, this.eventEmitter);
        // Register options change listener that will trigger a chart update
        this.eventEmitter.on("optionsChanged", ()=>this.update());
        // Before the first chart creation we need to register us with all plugins that are configured
        // Initialize all relevant plugins with our chart object and the plugin options specified in the config
        if (this.options.plugins) this.options.plugins.forEach((plugin)=>{
            if (Array.isArray(plugin)) plugin[0](this, plugin[1]);
            else plugin(this);
        });
        // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
        this.eventEmitter.emit("data", {
            type: "initial",
            data: this.data
        });
        // Create the first chart
        this.createChart(this.optionsProvider.getCurrentOptions());
        // As chart is initialized from the event loop now we can reset our timeout reference
        // This is important if the chart gets initialized on the same element twice
        this.initializeTimeoutId = null;
    }
    constructor(query, data, defaultOptions, options, responsiveOptions){
        this.data = data;
        this.defaultOptions = defaultOptions;
        this.options = options;
        this.responsiveOptions = responsiveOptions;
        this.eventEmitter = new $857626bf766d9720$export$4fae95256245c8c0();
        this.resizeListener = ()=>this.update();
        this.initializeTimeoutId = setTimeout(()=>this.initialize(), 0);
        const container = typeof query === "string" ? document.querySelector(query) : query;
        if (!container) throw new Error("Target element is not found");
        this.container = container;
        const prevInstance = $857626bf766d9720$var$instances.get(container);
        // If chartist was already initialized in this container we are detaching all event listeners first
        if (prevInstance) prevInstance.detach();
        $857626bf766d9720$var$instances.set(container, this);
    }
}
const $857626bf766d9720$export$45dc71cecb436b28 = {
    x: {
        pos: "x",
        len: "width",
        dir: "horizontal",
        rectStart: "x1",
        rectEnd: "x2",
        rectOffset: "y2"
    },
    y: {
        pos: "y",
        len: "height",
        dir: "vertical",
        rectStart: "y2",
        rectEnd: "y1",
        rectOffset: "x1"
    }
};
class $857626bf766d9720$export$d06866a9fb0606da {
    createGridAndLabels(gridGroup, labelGroup, chartOptions, eventEmitter) {
        const axisOptions = this.units.pos === "x" ? chartOptions.axisX : chartOptions.axisY;
        const projectedValues = this.ticks.map((tick, i)=>this.projectValue(tick, i));
        const labelValues = this.ticks.map(axisOptions.labelInterpolationFnc);
        projectedValues.forEach((projectedValue, index)=>{
            const labelValue = labelValues[index];
            const labelOffset = {
                x: 0,
                y: 0
            };
            // TODO: Find better solution for solving this problem
            // Calculate how much space we have available for the label
            let labelLength;
            if (projectedValues[index + 1]) // If we still have one label ahead, we can calculate the distance to the next tick / label
            labelLength = projectedValues[index + 1] - projectedValue;
            else // If we don't have a label ahead and we have only two labels in total, we just take the remaining distance to
            // on the whole axis length. We limit that to a minimum of 30 pixel, so that labels close to the border will
            // still be visible inside of the chart padding.
            labelLength = Math.max(this.axisLength - projectedValue, this.axisLength / this.ticks.length);
            // Skip grid lines and labels where interpolated label values are falsey (except for 0)
            if (labelValue !== "" && $857626bf766d9720$export$d45b80bd88a96dcb(labelValue)) return;
            // Transform to global coordinates using the chartRect
            // We also need to set the label offset for the createLabel function
            if (this.units.pos === "x") {
                projectedValue = this.chartRect.x1 + projectedValue;
                labelOffset.x = chartOptions.axisX.labelOffset.x;
                // If the labels should be positioned in start position (top side for vertical axis) we need to set a
                // different offset as for positioned with end (bottom)
                if (chartOptions.axisX.position === "start") labelOffset.y = this.chartRect.padding.top + chartOptions.axisX.labelOffset.y + 5;
                else labelOffset.y = this.chartRect.y1 + chartOptions.axisX.labelOffset.y + 5;
            } else {
                projectedValue = this.chartRect.y1 - projectedValue;
                labelOffset.y = chartOptions.axisY.labelOffset.y - labelLength;
                // If the labels should be positioned in start position (left side for horizontal axis) we need to set a
                // different offset as for positioned with end (right side)
                if (chartOptions.axisY.position === "start") labelOffset.x = this.chartRect.padding.left + chartOptions.axisY.labelOffset.x;
                else labelOffset.x = this.chartRect.x2 + chartOptions.axisY.labelOffset.x + 10;
            }
            if (axisOptions.showGrid) $857626bf766d9720$export$fce123c48a7b4eae(projectedValue, index, this, this.gridOffset, this.chartRect[this.counterUnits.len](), gridGroup, [
                chartOptions.classNames.grid,
                chartOptions.classNames[this.units.dir]
            ], eventEmitter);
            if (axisOptions.showLabel) $857626bf766d9720$export$f2839682b8c07f35(projectedValue, labelLength, index, labelValue, this, axisOptions.offset, labelOffset, labelGroup, [
                chartOptions.classNames.label,
                chartOptions.classNames[this.units.dir],
                axisOptions.position === "start" ? chartOptions.classNames[axisOptions.position] : chartOptions.classNames.end
            ], eventEmitter);
        });
    }
    constructor(units, chartRect, ticks){
        this.units = units;
        this.chartRect = chartRect;
        this.ticks = ticks;
        this.counterUnits = units === $857626bf766d9720$export$45dc71cecb436b28.x ? $857626bf766d9720$export$45dc71cecb436b28.y : $857626bf766d9720$export$45dc71cecb436b28.x;
        this.axisLength = chartRect[this.units.rectEnd] - chartRect[this.units.rectStart];
        this.gridOffset = chartRect[this.units.rectOffset];
    }
}
class $857626bf766d9720$export$2c0288ac3969ab20 extends $857626bf766d9720$export$d06866a9fb0606da {
    projectValue(value) {
        const finalValue = Number($857626bf766d9720$export$656dba5810c63062(value, this.units.pos));
        return this.axisLength * (finalValue - this.bounds.min) / this.bounds.range;
    }
    constructor(axisUnit, data, chartRect, options){
        // Usually we calculate highLow based on the data but this can be overriden by a highLow object in the options
        const highLow = options.highLow || $857626bf766d9720$export$3e3ab378c1942d40(data, options, axisUnit.pos);
        const bounds = $857626bf766d9720$export$becd1e645219fa23(chartRect[axisUnit.rectEnd] - chartRect[axisUnit.rectStart], highLow, options.scaleMinSpace || 20, options.onlyInteger);
        const range = {
            min: bounds.min,
            max: bounds.max
        };
        super(axisUnit, chartRect, bounds.values);
        this.bounds = bounds;
        this.range = range;
    }
}
class $857626bf766d9720$export$9869192afbf61008 extends $857626bf766d9720$export$d06866a9fb0606da {
    projectValue(value) {
        const finalValue = Number($857626bf766d9720$export$656dba5810c63062(value, this.units.pos));
        return this.axisLength * (finalValue - this.range.min) / (this.range.max - this.range.min);
    }
    constructor(axisUnit, data, chartRect, options){
        const highLow = options.highLow || $857626bf766d9720$export$3e3ab378c1942d40(data, options, axisUnit.pos);
        const divisor = options.divisor || 1;
        const ticks = (options.ticks || $857626bf766d9720$export$b5bc26e198ce73d0(divisor, (index)=>highLow.low + (highLow.high - highLow.low) / divisor * index)).sort((a, b)=>Number(a) - Number(b));
        const range = {
            min: highLow.low,
            max: highLow.high
        };
        super(axisUnit, chartRect, ticks);
        this.range = range;
    }
}
class $857626bf766d9720$export$1f3b9f5753043f0c extends $857626bf766d9720$export$d06866a9fb0606da {
    projectValue(_value, index) {
        return this.stepLength * index;
    }
    constructor(axisUnit, _data, chartRect, options){
        const ticks = options.ticks || [];
        super(axisUnit, chartRect, ticks);
        const calc = Math.max(1, ticks.length - (options.stretch ? 1 : 0));
        this.stepLength = this.axisLength / calc;
        this.stretch = Boolean(options.stretch);
    }
}
function $857626bf766d9720$export$d5c951c1021f1820(series, options, key) {
    var ref;
    if ($857626bf766d9720$export$7aae4c7f770e1d0b(series, "name") && series.name && ((ref = options.series) === null || ref === void 0 ? void 0 : ref[series.name])) {
        const seriesOptions = options === null || options === void 0 ? void 0 : options.series[series.name];
        const value = seriesOptions[key];
        const result = value === undefined ? options[key] : value;
        return result;
    } else return options[key];
}
/**
 * Default options in line charts. Expand the code view to see a detailed list of options with comments.
 */ const $857626bf766d9720$var$defaultOptions$2 = {
    // Options for X-Axis
    axisX: {
        // The offset of the labels to the chart area
        offset: 30,
        // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
        position: "end",
        // Allows you to correct label positioning on this axis by positive or negative x and y offset.
        labelOffset: {
            x: 0,
            y: 0
        },
        // If labels should be shown or not
        showLabel: true,
        // If the axis grid should be drawn or not
        showGrid: true,
        // Interpolation function that allows you to intercept the value from the axis label
        labelInterpolationFnc: $857626bf766d9720$export$8793edee2d425525,
        // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
        type: undefined
    },
    // Options for Y-Axis
    axisY: {
        // The offset of the labels to the chart area
        offset: 40,
        // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
        position: "start",
        // Allows you to correct label positioning on this axis by positive or negative x and y offset.
        labelOffset: {
            x: 0,
            y: 0
        },
        // If labels should be shown or not
        showLabel: true,
        // If the axis grid should be drawn or not
        showGrid: true,
        // Interpolation function that allows you to intercept the value from the axis label
        labelInterpolationFnc: $857626bf766d9720$export$8793edee2d425525,
        // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
        type: undefined,
        // This value specifies the minimum height in pixel of the scale steps
        scaleMinSpace: 20,
        // Use only integer values (whole numbers) for the scale steps
        onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // If the line should be drawn or not
    showLine: true,
    // If dots should be drawn or not
    showPoint: true,
    // If the line chart should draw an area
    showArea: false,
    // The base for the area chart that will be used to close the area shape (is normally 0)
    areaBase: 0,
    // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
    lineSmooth: true,
    // If the line chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
        top: 15,
        right: 15,
        bottom: 5,
        left: 10
    },
    // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
    fullWidth: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
        chart: "ct-chart-line",
        label: "ct-label",
        labelGroup: "ct-labels",
        series: "ct-series",
        line: "ct-line",
        point: "ct-point",
        area: "ct-area",
        grid: "ct-grid",
        gridGroup: "ct-grids",
        gridBackground: "ct-grid-background",
        vertical: "ct-vertical",
        horizontal: "ct-horizontal",
        start: "ct-start",
        end: "ct-end"
    }
};
class $857626bf766d9720$export$54d0e8420ac838ac extends $857626bf766d9720$export$ba89768bd61fb9ef {
    /**
   * Creates a new chart
   */ createChart(options) {
        const { data: data } = this;
        const normalizedData = $857626bf766d9720$export$3a0f8eb7361883bd(data, options.reverseData, true);
        // Create new svg object
        const svg = $857626bf766d9720$export$c54fe3b9ecaa84cf(this.container, options.width, options.height, options.classNames.chart);
        this.svg = svg;
        // Create groups for labels, grid and series
        const gridGroup = svg.elem("g").addClass(options.classNames.gridGroup);
        const seriesGroup = svg.elem("g");
        const labelGroup = svg.elem("g").addClass(options.classNames.labelGroup);
        const chartRect = $857626bf766d9720$export$287763b5f38b12d6(svg, options);
        let axisX;
        let axisY;
        if (options.axisX.type === undefined) axisX = new $857626bf766d9720$export$1f3b9f5753043f0c($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, {
            ...options.axisX,
            ticks: normalizedData.labels,
            stretch: options.fullWidth
        });
        else // eslint-disable-next-line new-cap
        axisX = new options.axisX.type($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, options.axisX);
        if (options.axisY.type === undefined) axisY = new $857626bf766d9720$export$2c0288ac3969ab20($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, {
            ...options.axisY,
            high: $857626bf766d9720$export$e90fb89750dba83f(options.high) ? options.high : options.axisY.high,
            low: $857626bf766d9720$export$e90fb89750dba83f(options.low) ? options.low : options.axisY.low
        });
        else // eslint-disable-next-line new-cap
        axisY = new options.axisY.type($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, options.axisY);
        axisX.createGridAndLabels(gridGroup, labelGroup, options, this.eventEmitter);
        axisY.createGridAndLabels(gridGroup, labelGroup, options, this.eventEmitter);
        if (options.showGridBackground) $857626bf766d9720$export$46e1d35fe977edb4(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
        // Draw the series
        $857626bf766d9720$export$79b2f7037acddd43(data.series, (series, seriesIndex)=>{
            const seriesElement = seriesGroup.elem("g");
            const seriesName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "name") && series.name;
            const seriesClassName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "className") && series.className;
            const seriesMeta = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "meta") ? series.meta : undefined;
            // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
            if (seriesName) seriesElement.attr({
                "ct:series-name": seriesName
            });
            if (seriesMeta) seriesElement.attr({
                "ct:meta": $857626bf766d9720$export$dfdc1655ccc5b9cb(seriesMeta)
            });
            // Use series class from series data or if not set generate one
            seriesElement.addClass([
                options.classNames.series,
                seriesClassName || "".concat(options.classNames.series, "-").concat($857626bf766d9720$export$77ecec3d3dcfe360(seriesIndex))
            ].join(" "));
            const pathCoordinates = [];
            const pathData = [];
            normalizedData.series[seriesIndex].forEach((value, valueIndex)=>{
                const p = {
                    x: chartRect.x1 + axisX.projectValue(value, valueIndex, normalizedData.series[seriesIndex]),
                    y: chartRect.y1 - axisY.projectValue(value, valueIndex, normalizedData.series[seriesIndex])
                };
                pathCoordinates.push(p.x, p.y);
                pathData.push({
                    value: value,
                    valueIndex: valueIndex,
                    meta: $857626bf766d9720$export$929b5cc2a4ac0922(series, valueIndex)
                });
            });
            const seriesOptions = {
                lineSmooth: $857626bf766d9720$export$d5c951c1021f1820(series, options, "lineSmooth"),
                showPoint: $857626bf766d9720$export$d5c951c1021f1820(series, options, "showPoint"),
                showLine: $857626bf766d9720$export$d5c951c1021f1820(series, options, "showLine"),
                showArea: $857626bf766d9720$export$d5c951c1021f1820(series, options, "showArea"),
                areaBase: $857626bf766d9720$export$d5c951c1021f1820(series, options, "areaBase")
            };
            let smoothing;
            if (typeof seriesOptions.lineSmooth === "function") smoothing = seriesOptions.lineSmooth;
            else smoothing = seriesOptions.lineSmooth ? $857626bf766d9720$var$monotoneCubic() : $857626bf766d9720$var$none();
            // Interpolating path where pathData will be used to annotate each path element so we can trace back the original
            // index, value and meta data
            const path = smoothing(pathCoordinates, pathData);
            // If we should show points we need to create them now to avoid secondary loop
            // Points are drawn from the pathElements returned by the interpolation function
            // Small offset for Firefox to render squares correctly
            if (seriesOptions.showPoint) path.pathElements.forEach((pathElement)=>{
                const { data: pathElementData } = pathElement;
                const point = seriesElement.elem("line", {
                    x1: pathElement.x,
                    y1: pathElement.y,
                    x2: pathElement.x + 0.01,
                    y2: pathElement.y
                }, options.classNames.point);
                if (pathElementData) {
                    let x;
                    let y;
                    if ($857626bf766d9720$export$7aae4c7f770e1d0b(pathElementData.value, "x")) x = pathElementData.value.x;
                    if ($857626bf766d9720$export$7aae4c7f770e1d0b(pathElementData.value, "y")) y = pathElementData.value.y;
                    point.attr({
                        "ct:value": [
                            x,
                            y
                        ].filter($857626bf766d9720$export$e90fb89750dba83f).join(","),
                        "ct:meta": $857626bf766d9720$export$dfdc1655ccc5b9cb(pathElementData.meta)
                    });
                }
                this.eventEmitter.emit("draw", {
                    type: "point",
                    value: pathElementData === null || pathElementData === void 0 ? void 0 : pathElementData.value,
                    index: (pathElementData === null || pathElementData === void 0 ? void 0 : pathElementData.valueIndex) || 0,
                    meta: pathElementData === null || pathElementData === void 0 ? void 0 : pathElementData.meta,
                    series: series,
                    seriesIndex: seriesIndex,
                    axisX: axisX,
                    axisY: axisY,
                    group: seriesElement,
                    element: point,
                    x: pathElement.x,
                    y: pathElement.y,
                    chartRect: chartRect
                });
            });
            if (seriesOptions.showLine) {
                const line = seriesElement.elem("path", {
                    d: path.stringify()
                }, options.classNames.line, true);
                this.eventEmitter.emit("draw", {
                    type: "line",
                    values: normalizedData.series[seriesIndex],
                    path: path.clone(),
                    chartRect: chartRect,
                    // TODO: Remove redundant
                    index: seriesIndex,
                    series: series,
                    seriesIndex: seriesIndex,
                    meta: seriesMeta,
                    axisX: axisX,
                    axisY: axisY,
                    group: seriesElement,
                    element: line
                });
            }
            // Area currently only works with axes that support a range!
            if (seriesOptions.showArea && axisY.range) {
                // If areaBase is outside the chart area (< min or > max) we need to set it respectively so that
                // the area is not drawn outside the chart area.
                const areaBase = Math.max(Math.min(seriesOptions.areaBase, axisY.range.max), axisY.range.min);
                // We project the areaBase value into screen coordinates
                const areaBaseProjected = chartRect.y1 - axisY.projectValue(areaBase);
                // In order to form the area we'll first split the path by move commands so we can chunk it up into segments
                path.splitByCommand("M") // We filter only "solid" segments that contain more than one point. Otherwise there's no need for an area
                .filter((pathSegment)=>pathSegment.pathElements.length > 1).map((solidPathSegments)=>{
                    // Receiving the filtered solid path segments we can now convert those segments into fill areas
                    const firstElement = solidPathSegments.pathElements[0];
                    const lastElement = solidPathSegments.pathElements[solidPathSegments.pathElements.length - 1];
                    // Cloning the solid path segment with closing option and removing the first move command from the clone
                    // We then insert a new move that should start at the area base and draw a straight line up or down
                    // at the end of the path we add an additional straight line to the projected area base value
                    // As the closing option is set our path will be automatically closed
                    return solidPathSegments.clone(true).position(0).remove(1).move(firstElement.x, areaBaseProjected).line(firstElement.x, firstElement.y).position(solidPathSegments.pathElements.length + 1).line(lastElement.x, areaBaseProjected);
                }).forEach((areaPath)=>{
                    // For each of our newly created area paths, we'll now create path elements by stringifying our path objects
                    // and adding the created DOM elements to the correct series group
                    const area = seriesElement.elem("path", {
                        d: areaPath.stringify()
                    }, options.classNames.area, true);
                    // Emit an event for each area that was drawn
                    this.eventEmitter.emit("draw", {
                        type: "area",
                        values: normalizedData.series[seriesIndex],
                        path: areaPath.clone(),
                        series: series,
                        seriesIndex: seriesIndex,
                        axisX: axisX,
                        axisY: axisY,
                        chartRect: chartRect,
                        // TODO: Remove redundant
                        index: seriesIndex,
                        group: seriesElement,
                        element: area,
                        meta: seriesMeta
                    });
                });
            }
        }, options.reverseData);
        this.eventEmitter.emit("created", {
            chartRect: chartRect,
            axisX: axisX,
            axisY: axisY,
            svg: svg,
            options: options
        });
    }
    /**
   * This method creates a new line chart.
   * @param query A selector query string or directly a DOM element
   * @param data The data object that needs to consist of a labels and a series array
   * @param options The options object with options that override the default options. Check the examples for a detailed list.
   * @param responsiveOptions Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return An object which exposes the API for the created chart
   *
   * @example
   * ```ts
   * // Create a simple line chart
   * const data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // As options we currently only set a static size of 300x200 px
   * const options = {
   *   width: '300px',
   *   height: '200px'
   * };
   *
   * // In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
   * new LineChart('.ct-chart', data, options);
   * ```
   *
   * @example
   * ```ts
   * // Use specific interpolation function with configuration from the Chartist.Interpolation module
   *
   * const chart = new LineChart('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [
   *     [1, 1, 8, 1, 7]
   *   ]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 0.2
   *   })
   * });
   * ```
   *
   * @example
   * ```ts
   * // Create a line chart with responsive options
   *
   * const data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In addition to the regular options we specify responsive option overrides that will override the default configutation based on the matching media queries.
   * const responsiveOptions = [
   *   ['screen and (min-width: 641px) and (max-width: 1024px)', {
   *     showPoint: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return Mon, Tue, Wed etc. on medium screens
   *         return value.slice(0, 3);
   *       }
   *     }
   *   }],
   *   ['screen and (max-width: 640px)', {
   *     showLine: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return M, T, W etc. on small screens
   *         return value[0];
   *       }
   *     }
   *   }]
   * ];
   *
   * new LineChart('.ct-chart', data, null, responsiveOptions);
   * ```
   */ constructor(query, data, options, responsiveOptions){
        super(query, data, $857626bf766d9720$var$defaultOptions$2, $857626bf766d9720$export$8b58be045bf06082({}, $857626bf766d9720$var$defaultOptions$2, options), responsiveOptions);
        this.data = data;
    }
}
function $857626bf766d9720$var$getSerialSums(series) {
    return $857626bf766d9720$export$e29b2cd13549b23b(series, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return Array.from(args).reduce((prev, curr)=>{
            return {
                x: prev.x + ($857626bf766d9720$export$7aae4c7f770e1d0b(curr, "x") ? curr.x : 0),
                y: prev.y + ($857626bf766d9720$export$7aae4c7f770e1d0b(curr, "y") ? curr.y : 0)
            };
        }, {
            x: 0,
            y: 0
        });
    });
}
/**
 * Default options in bar charts. Expand the code view to see a detailed list of options with comments.
 */ const $857626bf766d9720$var$defaultOptions$1 = {
    // Options for X-Axis
    axisX: {
        // The offset of the chart drawing area to the border of the container
        offset: 30,
        // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
        position: "end",
        // Allows you to correct label positioning on this axis by positive or negative x and y offset.
        labelOffset: {
            x: 0,
            y: 0
        },
        // If labels should be shown or not
        showLabel: true,
        // If the axis grid should be drawn or not
        showGrid: true,
        // Interpolation function that allows you to intercept the value from the axis label
        labelInterpolationFnc: $857626bf766d9720$export$8793edee2d425525,
        // This value specifies the minimum width in pixel of the scale steps
        scaleMinSpace: 30,
        // Use only integer values (whole numbers) for the scale steps
        onlyInteger: false
    },
    // Options for Y-Axis
    axisY: {
        // The offset of the chart drawing area to the border of the container
        offset: 40,
        // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
        position: "start",
        // Allows you to correct label positioning on this axis by positive or negative x and y offset.
        labelOffset: {
            x: 0,
            y: 0
        },
        // If labels should be shown or not
        showLabel: true,
        // If the axis grid should be drawn or not
        showGrid: true,
        // Interpolation function that allows you to intercept the value from the axis label
        labelInterpolationFnc: $857626bf766d9720$export$8793edee2d425525,
        // This value specifies the minimum height in pixel of the scale steps
        scaleMinSpace: 20,
        // Use only integer values (whole numbers) for the scale steps
        onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Unless low/high are explicitly set, bar chart will be centered at zero by default. Set referenceValue to null to auto scale.
    referenceValue: 0,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
        top: 15,
        right: 15,
        bottom: 5,
        left: 10
    },
    // Specify the distance in pixel of bars in a group
    seriesBarDistance: 15,
    // If set to true this property will cause the series bars to be stacked. Check the `stackMode` option for further stacking options.
    stackBars: false,
    // If set to true this property will force the stacked bars to draw from the zero line.
    // If set to 'accumulate' this property will form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
    // If set to 'accumulate-relative' positive and negative values will be handled separately.
    stackMode: "accumulate",
    // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
    horizontalBars: false,
    // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
    distributeSeries: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // If the bar chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
        chart: "ct-chart-bar",
        horizontalBars: "ct-horizontal-bars",
        label: "ct-label",
        labelGroup: "ct-labels",
        series: "ct-series",
        bar: "ct-bar",
        grid: "ct-grid",
        gridGroup: "ct-grids",
        gridBackground: "ct-grid-background",
        vertical: "ct-vertical",
        horizontal: "ct-horizontal",
        start: "ct-start",
        end: "ct-end"
    }
};
class $857626bf766d9720$export$94aefc399ef206a9 extends $857626bf766d9720$export$ba89768bd61fb9ef {
    /**
   * Creates a new chart
   */ createChart(options) {
        const { data: data } = this;
        const normalizedData = $857626bf766d9720$export$3a0f8eb7361883bd(data, options.reverseData, options.horizontalBars ? "x" : "y", true);
        // Create new svg element
        const svg = $857626bf766d9720$export$c54fe3b9ecaa84cf(this.container, options.width, options.height, options.classNames.chart + (options.horizontalBars ? " " + options.classNames.horizontalBars : ""));
        const highLow = options.stackBars && options.stackMode !== true && normalizedData.series.length ? $857626bf766d9720$export$3e3ab378c1942d40([
            $857626bf766d9720$var$getSerialSums(normalizedData.series)
        ], options, options.horizontalBars ? "x" : "y") : $857626bf766d9720$export$3e3ab378c1942d40(normalizedData.series, options, options.horizontalBars ? "x" : "y");
        this.svg = svg;
        // Drawing groups in correct order
        const gridGroup = svg.elem("g").addClass(options.classNames.gridGroup);
        const seriesGroup = svg.elem("g");
        const labelGroup = svg.elem("g").addClass(options.classNames.labelGroup);
        // Overrides of high / low from settings
        if (typeof options.high === "number") highLow.high = options.high;
        if (typeof options.low === "number") highLow.low = options.low;
        const chartRect = $857626bf766d9720$export$287763b5f38b12d6(svg, options);
        let valueAxis;
        const labelAxisTicks = options.distributeSeries && options.stackBars ? normalizedData.labels.slice(0, 1) : // as the bars are normalized
        normalizedData.labels;
        let labelAxis;
        let axisX;
        let axisY;
        // Set labelAxis and valueAxis based on the horizontalBars setting. This setting will flip the axes if necessary.
        if (options.horizontalBars) {
            if (options.axisX.type === undefined) valueAxis = axisX = new $857626bf766d9720$export$2c0288ac3969ab20($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, {
                ...options.axisX,
                highLow: highLow,
                referenceValue: 0
            });
            else // eslint-disable-next-line new-cap
            valueAxis = axisX = new options.axisX.type($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, {
                ...options.axisX,
                highLow: highLow,
                referenceValue: 0
            });
            if (options.axisY.type === undefined) labelAxis = axisY = new $857626bf766d9720$export$1f3b9f5753043f0c($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, {
                ticks: labelAxisTicks
            });
            else // eslint-disable-next-line new-cap
            labelAxis = axisY = new options.axisY.type($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, options.axisY);
        } else {
            if (options.axisX.type === undefined) labelAxis = axisX = new $857626bf766d9720$export$1f3b9f5753043f0c($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, {
                ticks: labelAxisTicks
            });
            else // eslint-disable-next-line new-cap
            labelAxis = axisX = new options.axisX.type($857626bf766d9720$export$45dc71cecb436b28.x, normalizedData.series, chartRect, options.axisX);
            if (options.axisY.type === undefined) valueAxis = axisY = new $857626bf766d9720$export$2c0288ac3969ab20($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, {
                ...options.axisY,
                highLow: highLow,
                referenceValue: 0
            });
            else // eslint-disable-next-line new-cap
            valueAxis = axisY = new options.axisY.type($857626bf766d9720$export$45dc71cecb436b28.y, normalizedData.series, chartRect, {
                ...options.axisY,
                highLow: highLow,
                referenceValue: 0
            });
        }
        // Projected 0 point
        const zeroPoint = options.horizontalBars ? chartRect.x1 + valueAxis.projectValue(0) : chartRect.y1 - valueAxis.projectValue(0);
        const isAccumulateStackMode = options.stackMode === "accumulate";
        const isAccumulateRelativeStackMode = options.stackMode === "accumulate-relative";
        // Used to track the screen coordinates of stacked bars
        const posStackedBarValues = [];
        const negStackedBarValues = [];
        let stackedBarValues = posStackedBarValues;
        labelAxis.createGridAndLabels(gridGroup, labelGroup, options, this.eventEmitter);
        valueAxis.createGridAndLabels(gridGroup, labelGroup, options, this.eventEmitter);
        if (options.showGridBackground) $857626bf766d9720$export$46e1d35fe977edb4(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
        // Draw the series
        $857626bf766d9720$export$79b2f7037acddd43(data.series, (series, seriesIndex)=>{
            // Calculating bi-polar value of index for seriesOffset. For i = 0..4 biPol will be -1.5, -0.5, 0.5, 1.5 etc.
            const biPol = seriesIndex - (data.series.length - 1) / 2;
            // Half of the period width between vertical grid lines used to position bars
            let periodHalfLength;
            // We need to set periodHalfLength based on some options combinations
            if (options.distributeSeries && !options.stackBars) // If distributed series are enabled but stacked bars aren't, we need to use the length of the normaizedData array
            // which is the series count and divide by 2
            periodHalfLength = labelAxis.axisLength / normalizedData.series.length / 2;
            else if (options.distributeSeries && options.stackBars) // If distributed series and stacked bars are enabled we'll only get one bar so we should just divide the axis
            // length by 2
            periodHalfLength = labelAxis.axisLength / 2;
            else // On regular bar charts we should just use the series length
            periodHalfLength = labelAxis.axisLength / normalizedData.series[seriesIndex].length / 2;
            // Adding the series group to the series element
            const seriesElement = seriesGroup.elem("g");
            const seriesName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "name") && series.name;
            const seriesClassName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "className") && series.className;
            const seriesMeta = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "meta") ? series.meta : undefined;
            // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
            if (seriesName) seriesElement.attr({
                "ct:series-name": seriesName
            });
            if (seriesMeta) seriesElement.attr({
                "ct:meta": $857626bf766d9720$export$dfdc1655ccc5b9cb(seriesMeta)
            });
            // Use series class from series data or if not set generate one
            seriesElement.addClass([
                options.classNames.series,
                seriesClassName || "".concat(options.classNames.series, "-").concat($857626bf766d9720$export$77ecec3d3dcfe360(seriesIndex))
            ].join(" "));
            normalizedData.series[seriesIndex].forEach((value, valueIndex)=>{
                const valueX = $857626bf766d9720$export$7aae4c7f770e1d0b(value, "x") && value.x;
                const valueY = $857626bf766d9720$export$7aae4c7f770e1d0b(value, "y") && value.y;
                let labelAxisValueIndex;
                // We need to set labelAxisValueIndex based on some options combinations
                if (options.distributeSeries && !options.stackBars) // If distributed series are enabled but stacked bars aren't, we can use the seriesIndex for later projection
                // on the step axis for label positioning
                labelAxisValueIndex = seriesIndex;
                else if (options.distributeSeries && options.stackBars) // If distributed series and stacked bars are enabled, we will only get one bar and therefore always use
                // 0 for projection on the label step axis
                labelAxisValueIndex = 0;
                else // On regular bar charts we just use the value index to project on the label step axis
                labelAxisValueIndex = valueIndex;
                let projected;
                // We need to transform coordinates differently based on the chart layout
                if (options.horizontalBars) projected = {
                    x: chartRect.x1 + valueAxis.projectValue(valueX || 0, valueIndex, normalizedData.series[seriesIndex]),
                    y: chartRect.y1 - labelAxis.projectValue(valueY || 0, labelAxisValueIndex, normalizedData.series[seriesIndex])
                };
                else projected = {
                    x: chartRect.x1 + labelAxis.projectValue(valueX || 0, labelAxisValueIndex, normalizedData.series[seriesIndex]),
                    y: chartRect.y1 - valueAxis.projectValue(valueY || 0, valueIndex, normalizedData.series[seriesIndex])
                };
                // If the label axis is a step based axis we will offset the bar into the middle of between two steps using
                // the periodHalfLength value. Also we do arrange the different series so that they align up to each other using
                // the seriesBarDistance. If we don't have a step axis, the bar positions can be chosen freely so we should not
                // add any automated positioning.
                if (labelAxis instanceof $857626bf766d9720$export$1f3b9f5753043f0c) {
                    // Offset to center bar between grid lines, but only if the step axis is not stretched
                    if (!labelAxis.stretch) projected[labelAxis.units.pos] += periodHalfLength * (options.horizontalBars ? -1 : 1);
                    // Using bi-polar offset for multiple series if no stacked bars or series distribution is used
                    projected[labelAxis.units.pos] += options.stackBars || options.distributeSeries ? 0 : biPol * options.seriesBarDistance * (options.horizontalBars ? -1 : 1);
                }
                // distinguish between positive and negative values in relative stack mode
                if (isAccumulateRelativeStackMode) stackedBarValues = valueY >= 0 || valueX >= 0 ? posStackedBarValues : negStackedBarValues;
                // Enter value in stacked bar values used to remember previous screen value for stacking up bars
                const previousStack = stackedBarValues[valueIndex] || zeroPoint;
                stackedBarValues[valueIndex] = previousStack - (zeroPoint - projected[labelAxis.counterUnits.pos]);
                // Skip if value is undefined
                if (value === undefined) return;
                const positions = {
                    ["".concat(labelAxis.units.pos, "1")]: projected[labelAxis.units.pos],
                    ["".concat(labelAxis.units.pos, "2")]: projected[labelAxis.units.pos]
                };
                if (options.stackBars && (isAccumulateStackMode || isAccumulateRelativeStackMode || !options.stackMode)) {
                    // Stack mode: accumulate (default)
                    // If bars are stacked we use the stackedBarValues reference and otherwise base all bars off the zero line
                    // We want backwards compatibility, so the expected fallback without the 'stackMode' option
                    // to be the original behaviour (accumulate)
                    positions["".concat(labelAxis.counterUnits.pos, "1")] = previousStack;
                    positions["".concat(labelAxis.counterUnits.pos, "2")] = stackedBarValues[valueIndex];
                } else {
                    // Draw from the zero line normally
                    // This is also the same code for Stack mode: overlap
                    positions["".concat(labelAxis.counterUnits.pos, "1")] = zeroPoint;
                    positions["".concat(labelAxis.counterUnits.pos, "2")] = projected[labelAxis.counterUnits.pos];
                }
                // Limit x and y so that they are within the chart rect
                positions.x1 = Math.min(Math.max(positions.x1, chartRect.x1), chartRect.x2);
                positions.x2 = Math.min(Math.max(positions.x2, chartRect.x1), chartRect.x2);
                positions.y1 = Math.min(Math.max(positions.y1, chartRect.y2), chartRect.y1);
                positions.y2 = Math.min(Math.max(positions.y2, chartRect.y2), chartRect.y1);
                const metaData = $857626bf766d9720$export$929b5cc2a4ac0922(series, valueIndex);
                // Create bar element
                const bar = seriesElement.elem("line", positions, options.classNames.bar).attr({
                    "ct:value": [
                        valueX,
                        valueY
                    ].filter($857626bf766d9720$export$e90fb89750dba83f).join(","),
                    "ct:meta": $857626bf766d9720$export$dfdc1655ccc5b9cb(metaData)
                });
                this.eventEmitter.emit("draw", {
                    type: "bar",
                    value: value,
                    index: valueIndex,
                    meta: metaData,
                    series: series,
                    seriesIndex: seriesIndex,
                    axisX: axisX,
                    axisY: axisY,
                    chartRect: chartRect,
                    group: seriesElement,
                    element: bar,
                    ...positions
                });
            });
        }, options.reverseData);
        this.eventEmitter.emit("created", {
            chartRect: chartRect,
            axisX: axisX,
            axisY: axisY,
            svg: svg,
            options: options
        });
    }
    /**
   * This method creates a new bar chart and returns API object that you can use for later changes.
   * @param query A selector query string or directly a DOM element
   * @param data The data object that needs to consist of a labels and a series array
   * @param options The options object with options that override the default options. Check the examples for a detailed list.
   * @param responsiveOptions Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return An object which exposes the API for the created chart
   *
   * @example
   * ```ts
   * // Create a simple bar chart
   * const data = {
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In the global name space Chartist we call the Bar function to initialize a bar chart. As a first parameter we pass in a selector where we would like to get our chart created and as a second parameter we pass our data object.
   * new BarChart('.ct-chart', data);
   * ```
   *
   * @example
   * ```ts
   * // This example creates a bipolar grouped bar chart where the boundaries are limitted to -10 and 10
   * new BarChart('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5, 6, 7],
   *   series: [
   *     [1, 3, 2, -5, -3, 1, -6],
   *     [-5, -2, -4, -1, 2, -3, 1]
   *   ]
   * }, {
   *   seriesBarDistance: 12,
   *   low: -10,
   *   high: 10
   * });
   * ```
   */ constructor(query, data, options, responsiveOptions){
        super(query, data, $857626bf766d9720$var$defaultOptions$1, $857626bf766d9720$export$8b58be045bf06082({}, $857626bf766d9720$var$defaultOptions$1, options), responsiveOptions);
        this.data = data;
    }
}
/**
 * Default options in line charts. Expand the code view to see a detailed list of options with comments.
 */ const $857626bf766d9720$var$defaultOptions = {
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: 5,
    // Override the class names that are used to generate the SVG structure of the chart
    classNames: {
        chartPie: "ct-chart-pie",
        chartDonut: "ct-chart-donut",
        series: "ct-series",
        slicePie: "ct-slice-pie",
        sliceDonut: "ct-slice-donut",
        label: "ct-label"
    },
    // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
    startAngle: 0,
    // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
    total: undefined,
    // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
    donut: false,
    // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
    // This option can be set as number or string to specify a relative width (i.e. 100 or '30%').
    donutWidth: 60,
    // If a label should be shown or not
    showLabel: true,
    // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
    labelOffset: 0,
    // This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
    labelPosition: "inside",
    // An interpolation function for the label value
    labelInterpolationFnc: $857626bf766d9720$export$8793edee2d425525,
    // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
    labelDirection: "neutral",
    // If true empty values will be ignored to avoid drawing unnecessary slices and labels
    ignoreEmptyValues: false
};
/**
 * Determines SVG anchor position based on direction and center parameter
 */ function $857626bf766d9720$export$b4dd96cedf6bf355(center, label, direction) {
    const toTheRight = label.x > center.x;
    if (toTheRight && direction === "explode" || !toTheRight && direction === "implode") return "start";
    else if (toTheRight && direction === "implode" || !toTheRight && direction === "explode") return "end";
    else return "middle";
}
class $857626bf766d9720$export$b99d3348f709c998 extends $857626bf766d9720$export$ba89768bd61fb9ef {
    /**
   * Creates the pie chart
   *
   * @param options
   */ createChart(options) {
        const { data: data } = this;
        const normalizedData = $857626bf766d9720$export$3a0f8eb7361883bd(data);
        const seriesGroups = [];
        let labelsGroup;
        let labelRadius;
        let startAngle = options.startAngle;
        // Create SVG.js draw
        const svg = $857626bf766d9720$export$c54fe3b9ecaa84cf(this.container, options.width, options.height, options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
        this.svg = svg;
        // Calculate charting rect
        const chartRect = $857626bf766d9720$export$287763b5f38b12d6(svg, options);
        // Get biggest circle radius possible within chartRect
        let radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
        // Calculate total of all series to get reference value or use total reference from optional options
        const totalDataSum = options.total || normalizedData.series.reduce($857626bf766d9720$export$8a63f25cc62965f1, 0);
        const donutWidth = $857626bf766d9720$export$82dd68b83a44b253(options.donutWidth);
        if (donutWidth.unit === "%") donutWidth.value *= radius / 100;
        // If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
        // Unfortunately this is not possible with the current SVG Spec
        // See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
        radius -= options.donut ? donutWidth.value / 2 : 0;
        // If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
        // if regular pie chart it's half of the radius
        if (options.labelPosition === "outside" || options.donut) labelRadius = radius;
        else if (options.labelPosition === "center") // If labelPosition is center we start with 0 and will later wait for the labelOffset
        labelRadius = 0;
        else // Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
        // slice
        labelRadius = radius / 2;
        // Add the offset to the labelRadius where a negative offset means closed to the center of the chart
        if (options.labelOffset) labelRadius += options.labelOffset;
        // Calculate end angle based on total sum and current data value and offset with padding
        const center = {
            x: chartRect.x1 + chartRect.width() / 2,
            y: chartRect.y2 + chartRect.height() / 2
        };
        // Check if there is only one non-zero value in the series array.
        const hasSingleValInSeries = data.series.filter((val)=>$857626bf766d9720$export$7aae4c7f770e1d0b(val, "value") ? val.value !== 0 : val !== 0).length === 1;
        // Creating the series groups
        data.series.forEach((_, index)=>seriesGroups[index] = svg.elem("g"));
        // if we need to show labels we create the label group now
        if (options.showLabel) labelsGroup = svg.elem("g");
        // Draw the series
        // initialize series groups
        data.series.forEach((series, index)=>{
            var ref, ref1;
            // If current value is zero and we are ignoring empty values then skip to next value
            if (normalizedData.series[index] === 0 && options.ignoreEmptyValues) return;
            const seriesName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "name") && series.name;
            const seriesClassName = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "className") && series.className;
            const seriesMeta = $857626bf766d9720$export$7aae4c7f770e1d0b(series, "meta") ? series.meta : undefined;
            // If the series is an object and contains a name or meta data we add a custom attribute
            if (seriesName) seriesGroups[index].attr({
                "ct:series-name": seriesName
            });
            // Use series class from series data or if not set generate one
            seriesGroups[index].addClass([
                (ref = options.classNames) === null || ref === void 0 ? void 0 : ref.series,
                seriesClassName || "".concat((ref1 = options.classNames) === null || ref1 === void 0 ? void 0 : ref1.series, "-").concat($857626bf766d9720$export$77ecec3d3dcfe360(index))
            ].join(" "));
            // If the whole dataset is 0 endAngle should be zero. Can't divide by 0.
            let endAngle = totalDataSum > 0 ? startAngle + normalizedData.series[index] / totalDataSum * 360 : 0;
            // Use slight offset so there are no transparent hairline issues
            const overlappigStartAngle = Math.max(0, startAngle - (index === 0 || hasSingleValInSeries ? 0 : 0.2));
            // If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
            // with Z and use 359.99 degrees
            if (endAngle - overlappigStartAngle >= 359.99) endAngle = overlappigStartAngle + 359.99;
            const start = $857626bf766d9720$export$5c9a959bb3fc7749(center.x, center.y, radius, overlappigStartAngle);
            const end = $857626bf766d9720$export$5c9a959bb3fc7749(center.x, center.y, radius, endAngle);
            // Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
            const path = new $857626bf766d9720$export$1c313b81a43a728a(!options.donut).move(end.x, end.y).arc(radius, radius, 0, Number(endAngle - startAngle > 180), 0, start.x, start.y);
            // If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
            if (!options.donut) path.line(center.x, center.y);
            // Create the SVG path
            // If this is a donut chart we add the donut class, otherwise just a regular slice
            const pathElement = seriesGroups[index].elem("path", {
                d: path.stringify()
            }, options.donut ? options.classNames.sliceDonut : options.classNames.slicePie);
            // Adding the pie series value to the path
            pathElement.attr({
                "ct:value": normalizedData.series[index],
                "ct:meta": $857626bf766d9720$export$dfdc1655ccc5b9cb(seriesMeta)
            });
            // If this is a donut, we add the stroke-width as style attribute
            if (options.donut) pathElement.attr({
                style: "stroke-width: " + donutWidth.value + "px"
            });
            // Fire off draw event
            this.eventEmitter.emit("draw", {
                type: "slice",
                value: normalizedData.series[index],
                totalDataSum: totalDataSum,
                index: index,
                meta: seriesMeta,
                series: series,
                group: seriesGroups[index],
                element: pathElement,
                path: path.clone(),
                center: center,
                radius: radius,
                startAngle: startAngle,
                endAngle: endAngle,
                chartRect: chartRect
            });
            // If we need to show labels we need to add the label for this slice now
            if (options.showLabel) {
                let labelPosition;
                if (data.series.length === 1) // If we have only 1 series, we can position the label in the center of the pie
                labelPosition = {
                    x: center.x,
                    y: center.y
                };
                else // Position at the labelRadius distance from center and between start and end angle
                labelPosition = $857626bf766d9720$export$5c9a959bb3fc7749(center.x, center.y, labelRadius, startAngle + (endAngle - startAngle) / 2);
                let rawValue;
                if (normalizedData.labels && !$857626bf766d9720$export$d45b80bd88a96dcb(normalizedData.labels[index])) rawValue = normalizedData.labels[index];
                else rawValue = normalizedData.series[index];
                const interpolatedValue = options.labelInterpolationFnc(rawValue, index);
                if (interpolatedValue || interpolatedValue === 0) {
                    const labelElement = labelsGroup.elem("text", {
                        dx: labelPosition.x,
                        dy: labelPosition.y,
                        "text-anchor": $857626bf766d9720$export$b4dd96cedf6bf355(center, labelPosition, options.labelDirection)
                    }, options.classNames.label).text(String(interpolatedValue));
                    // Fire off draw event
                    this.eventEmitter.emit("draw", {
                        type: "label",
                        index: index,
                        group: labelsGroup,
                        element: labelElement,
                        text: "" + interpolatedValue,
                        chartRect: chartRect,
                        series: series,
                        meta: seriesMeta,
                        ...labelPosition
                    });
                }
            }
            // Set next startAngle to current endAngle.
            // (except for last slice)
            startAngle = endAngle;
        });
        this.eventEmitter.emit("created", {
            chartRect: chartRect,
            svg: svg,
            options: options
        });
    }
    /**
   * This method creates a new pie chart and returns an object that can be used to redraw the chart.
   * @param query A selector query string or directly a DOM element
   * @param data The data object in the pie chart needs to have a series property with a one dimensional data array. The values will be normalized against each other and don't necessarily need to be in percentage. The series property can also be an array of value objects that contain a value property and a className property to override the CSS class name for the series group.
   * @param options The options object with options that override the default options. Check the examples for a detailed list.
   * @param responsiveOptions Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   *
   * @example
   * ```ts
   * // Simple pie chart example with four series
   * new PieChart('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * });
   * ```
   *
   * @example
   * ```ts
   * // Drawing a donut chart
   * new PieChart('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * }, {
   *   donut: true
   * });
   * ```
   *
   * @example
   * ```ts
   * // Using donut, startAngle and total to draw a gauge chart
   * new PieChart('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   donut: true,
   *   donutWidth: 20,
   *   startAngle: 270,
   *   total: 200
   * });
   * ```
   *
   * @example
   * ```ts
   * // Drawing a pie chart with padding and labels that are outside the pie
   * new PieChart('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   chartPadding: 30,
   *   labelOffset: 50,
   *   labelDirection: 'explode'
   * });
   * ```
   *
   * @example
   * ```ts
   * // Overriding the class names for individual series as well as a name and meta data.
   * // The name will be written as ct:series-name attribute and the meta data will be serialized and written
   * // to a ct:meta attribute.
   * new PieChart('.ct-chart', {
   *   series: [{
   *     value: 20,
   *     name: 'Series 1',
   *     className: 'my-custom-class-one',
   *     meta: 'Meta One'
   *   }, {
   *     value: 10,
   *     name: 'Series 2',
   *     className: 'my-custom-class-two',
   *     meta: 'Meta Two'
   *   }, {
   *     value: 70,
   *     name: 'Series 3',
   *     className: 'my-custom-class-three',
   *     meta: 'Meta Three'
   *   }]
   * });
   * ```
   */ constructor(query, data, options, responsiveOptions){
        super(query, data, $857626bf766d9720$var$defaultOptions, $857626bf766d9720$export$8b58be045bf06082({}, $857626bf766d9720$var$defaultOptions, options), responsiveOptions);
        this.data = data;
    }
}

});

parcelRegister("n3TJI", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $04552c275ef79ab8$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = false;
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xEF") {
                        let encoding;
                        if (str[0] === "\xFE" && str[1] === "\xFF") encoding = "utf-16be";
                        else if (str[0] === "\xFF" && str[1] === "\xFE") encoding = "utf-16le";
                        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    const password = src.password ?? null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: '3.11.174',
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                async function _fetchDocument(worker, source) {
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                        source.data.buffer
                    ] : null);
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    return workerId;
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $04552c275ef79ab8$require$Buffer !== "undefined" && val instanceof $04552c275ef79ab8$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        this._stats?.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            (intentState.renderTasks ||= new Set()).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        this.#pendingCleanup = true;
                        const success = this.#tryCleanup(false);
                        if (resetStats && success) this._stats &&= new _display_utils.StatTimer();
                        return success;
                    }
                    #tryCleanup(delayed = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks, operatorList } of this._intentStates.values()){
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency, cacheKey) {
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        this._stats?.timeEnd("Page Request");
                        intentState.displayReadyCapability?.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener of this.#listeners)listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        this.#listeners.add(listener);
                    }
                    removeEventListener(name, listener) {
                        this.#listeners.delete(listener);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            if (PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = this.#workerPorts?.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name, data = null) {
                        const cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, data);
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        loadingTask.onProgress?.({
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) this.#passwordCapability.reject(password);
                                    else this.#passwordCapability.resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    this.#passwordCapability.reject(ex);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            loadingTask.onProgress?.({
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = this.#pageCache.get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = this.#pageCache.get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = imageData.data?.length || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            if (this.destroyed) return;
                            loadingTask.onProgress?.({
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: this._fullReader?.filename ?? null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex, page);
                            return page;
                        });
                        this.#pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page of this.#pageCache.values()){
                            const cleanupSuccessful = page.cleanup();
                            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId) {
                        return this.#objs[objId] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = this.#ensureObj(objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = this.#objs[objId];
                        if (!obj?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = this.#objs[objId];
                        return obj?.capability.settled || false;
                    }
                    resolve(objId, data = null) {
                        const obj = this.#ensureObj(objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in this.#objs){
                            const { data } = this.#objs[objId];
                            data?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask){
                        this.#internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = this.#internalRenderTask;
                        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error = null, extraDelay = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = '3.11.174';
                exports.version = version;
                const build = 'ce8716743';
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                class AnnotationStorage {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key, defaultValue) {
                        const value = this.#storage.get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return this.#storage.get(key);
                    }
                    remove(key) {
                        this.#storage.delete(key);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of this.#storage.values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = this.#storage.get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            this.#storage.set(key, value);
                        }
                        if (modified) this.#setModified();
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return this.#storage.has(key);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of this.#storage){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap ||= !!serialized.bitmap;
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                class PrintAnnotationStorage extends AnnotationStorage {
                    #serializable;
                    constructor(parent){
                        super();
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        this.#serializable = {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        };
                    }
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class AnnotationEditor {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters){
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        AnnotationEditor._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ]));
                        if (options?.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value) {
                        this.#isDraggable = value;
                        this.div?.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target?.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    #translate([width, height], x, y) {
                        [x, y] = this.screenToPageTranslation(x, y);
                        this.x += x / width;
                        this.y += y / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        this.#translate(this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        this.#translate(this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const { _borderLineWidth } = AnnotationEditor;
                        const x = _borderLineWidth / parentWidth;
                        const y = _borderLineWidth / parentHeight;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x,
                                    y
                                ];
                            case 180:
                                return [
                                    x,
                                    y
                                ];
                            case 270:
                                return [
                                    x,
                                    -y
                                ];
                            default:
                                return [
                                    -x,
                                    -y
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x, y, angle) {
                        switch(angle){
                            case 90:
                                return [
                                    y,
                                    -x
                                ];
                            case 180:
                                return [
                                    -x,
                                    -y
                                ];
                            case 270:
                                return [
                                    -y,
                                    x
                                ];
                            default:
                                return [
                                    x,
                                    y
                                ];
                        }
                    }
                    screenToPageTranslation(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation) {
                        switch(rotation){
                            case 90:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth / pageHeight,
                                        pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth / pageHeight,
                                        -pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name of classes){
                            const div = document.createElement("div");
                            this.#resizersDiv.append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name, event) {
                        event.preventDefault();
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                        const savedDraggable = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const savedParentCursor = this.parent.div.style.cursor;
                        const savedCursor = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                        const pointerUpCallback = ()=>{
                            this._isDraggable = savedDraggable;
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                            this.parent.div.style.cursor = savedParentCursor;
                            this.div.style.cursor = savedCursor;
                            const newX = this.x;
                            const newY = this.y;
                            const newWidth = this.width;
                            const newHeight = this.height;
                            if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth;
                                    this.height = newHeight;
                                    this.x = newX;
                                    this.y = newY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth;
                                    this.height = savedHeight;
                                    this.x = savedX;
                                    this.y = savedY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    #resizerPointermove(name, event) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                        const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                        const round = (x)=>Math.round(x * 10000) / 10000;
                        const rotationMatrix = this.#getRotationMatrix(this.rotation);
                        const transf = (x, y)=>[
                                rotationMatrix[0] * x + rotationMatrix[2] * y,
                                rotationMatrix[1] * x + rotationMatrix[3] * y
                            ];
                        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf = (x, y)=>[
                                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                                invRotationMatrix[1] * x + invRotationMatrix[3] * y
                            ];
                        let getPoint;
                        let getOpposite;
                        let isDiagonal = false;
                        let isHorizontal = false;
                        switch(name){
                            case "topLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h
                                    ];
                                break;
                            case "topMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                break;
                            case "topRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                break;
                        }
                        const point = getPoint(savedWidth, savedHeight);
                        const oppositePoint = getOpposite(savedWidth, savedHeight);
                        let transfOppositePoint = transf(...oppositePoint);
                        const oppositeX = round(savedX + transfOppositePoint[0]);
                        const oppositeY = round(savedY + transfOppositePoint[1]);
                        let ratioX = 1;
                        let ratioY = 1;
                        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                        if (isDiagonal) {
                            const oldDiag = Math.hypot(savedWidth, savedHeight);
                            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                        const newWidth = round(savedWidth * ratioX);
                        const newHeight = round(savedHeight * ratioY);
                        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                        const newX = oppositeX - transfOppositePoint[0];
                        const newY = oppositeY - transfOppositePoint[1];
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText = this.#altTextButton = document.createElement("button");
                        altText.className = "altText";
                        const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                        altText.textContent = msg;
                        altText.setAttribute("aria-label", msg);
                        altText.tabIndex = "0";
                        altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                        altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                        altText.addEventListener("click", (event)=>{
                            event.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText.addEventListener("keydown", (event)=>{
                            if (event.target === altText && event.key === "Enter") {
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText);
                        if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                            const PERCENT = 40;
                            AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button = this.#altTextButton;
                        if (!button) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = this.#altTextTooltip;
                        if (!tooltip) {
                            this.#altTextTooltip = tooltip = document.createElement("span");
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP);
                            });
                            button.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip.parentNode) button.append(tooltip);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
                        this.#altText = altText;
                        this.#altTextDecorative = decorative;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event);
                    }
                    #setUpDragSession(event) {
                        if (!this._isDraggable) return;
                        const isSelected = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions, pointerMoveCallback;
                        if (isSelected) {
                            pointerMoveOptions = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback = (e)=>{
                                const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                                this._uiManager.dragSelectedEditors(tx, ty);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        }
                        const pointerUpCallback = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac } = _util.FeatureTest.platform;
                                if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value) {
                        this.#isEditing = value;
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        this.#keepAspectRatio = true;
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                class IdManager {
                    #id = 0;
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager {
                    #baseId = (0, _util.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    async #get(key, rawData) {
                        this.#cache ||= new Map();
                        let data = this.#cache.get(key);
                        if (data === null) return null;
                        if (data?.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = await fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = await response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = async ()=>{
                                        const url = data.svgUrl = fileReader.result;
                                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                    };
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                await imagePromise;
                            } else data.bitmap = await createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        this.#cache.set(key, data);
                        if (data) this.#cache.set(data.id, data);
                        return data;
                    }
                    async getFromFile(file) {
                        const { lastModified, name, size, type } = file;
                        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
                    }
                    async getFromUrl(url) {
                        return this.#get(url, url);
                    }
                    async getFromId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return null;
                        if (data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        if (data.file) return this.getFromFile(data.file);
                        return this.getFromUrl(data.url);
                    }
                    getSvgUrl(id) {
                        const data = this.#cache.get(id);
                        if (!data?.isSvg) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize = 128){
                        this.#maxSize = maxSize;
                    }
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if (this.#locked) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save);
                            return;
                        }
                        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
                            if (keepUndo) save.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save;
                            return;
                        }
                        const next = this.#position + 1;
                        if (next === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next;
                            if (next < this.#commands.length) this.#commands.splice(next);
                        }
                        this.#commands.push(save);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports.CommandManager = CommandManager;
                class KeyboardManager {
                    constructor(callbacks){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event) {
                        if (event.altKey) this.buffer.push("alt");
                        if (event.ctrlKey) this.buffer.push("ctrl");
                        if (event.metaKey) this.buffer.push("meta");
                        if (event.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event.key);
                        const str = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str;
                    }
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get(this.#serialize(event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                exports.ColorManager = ColorManager;
                class AnnotationEditorUIManager {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        this.#container = container;
                        this.#viewer = viewer;
                        this.#altTextManager = altTextManager;
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument.annotationStorage;
                        this.#filterFactory = pdfDocument.filterFactory;
                        this.#pageColors = pageColors;
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer of this.#allLayers.values())layer.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor) {
                        this.#altTextManager?.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        this.#currentPageIndex = pageNumber - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x, y) {
                        for (const layer of this.#allLayers.values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        this.#viewer.classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        this.#editorsToRescale.add(editor);
                    }
                    removeShouldRescale(editor) {
                        this.#editorsToRescale.delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
                            this.#lastActiveElement = [
                                editor,
                                activeElement
                            ];
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event) {
                        event.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of this.#selectedEditors){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)this.#addEditorToLayer(editor);
                                this.#selectEditors(newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    #dispatchUpdateStates(details) {
                        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
                        if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details)
                        });
                    }
                    #dispatchUpdateUI(details) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details
                        });
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types;
                        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex) {
                        return this.#allLayers.get(pageIndex);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer) {
                        this.#allLayers.set(layer.pageIndex, layer);
                        if (this.#isEnabled) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        this.#allLayers.delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if (this.#mode === mode) return;
                        this.#mode = mode;
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer of this.#allLayers.values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!this.#editorTypes) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
                        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if (this.#isWaiting === mustWait) return;
                        this.#isWaiting = mustWait;
                        for (const layer of this.#allLayers.values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer of this.#allLayers.values())layer.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer of this.#allLayers.values())layer.disable();
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return this.#allEditors.get(id);
                    }
                    addEditor(editor) {
                        this.#allEditors.set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        this.#allEditors.delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    #addEditorToLayer(editor) {
                        const layer = this.#allLayers.get(editor.pageIndex);
                        if (layer) layer.addOrRebuild(editor);
                        else this.addEditor(editor);
                    }
                    setActiveEditor(editor) {
                        if (this.#activeEditor === editor) return;
                        this.#activeEditor = editor;
                        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if (this.#selectedEditors.has(editor)) {
                            this.#selectedEditors.delete(editor);
                            editor.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return this.#selectedEditors.has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        this.#selectedEditors.delete(editor);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params) {
                        this.#commandManager.add(params);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor of this.#allEditors.values())return editor.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)this.#addEditorToLayer(editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors) {
                        this.#selectedEditors.clear();
                        for (const editor of editors){
                            if (editor.isEmpty()) continue;
                            this.#selectedEditors.add(editor);
                            editor.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor of this.#selectedEditors)editor.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of this.#selectedEditors)editor.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x;
                        this.#translation[1] += y;
                        const [totalX, totalY] = this.#translation;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT);
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if (this.#allEditors.has(editor.id)) {
                                const parent = this.#allLayers.get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!this.#draggingEditors) return;
                        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return this.#activeEditor === editor;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports.PixelsPerInch = PixelsPerInch;
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super();
                        this.#docId = docId;
                        this.#document = ownerDocument;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div = this.#document.createElement("div");
                            const { style } = div;
                            style.visibility = "hidden";
                            style.contain = "strict";
                            style.width = style.height = 0;
                            style.position = "absolute";
                            style.top = style.left = 0;
                            style.zIndex = -1;
                            const svg = this.#document.createElementNS(SVG_NS, "svg");
                            svg.setAttribute("width", 0);
                            svg.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                            div.append(svg);
                            svg.append(this.#_defs);
                            this.#document.body.append(div);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = this.#cache.get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = this.#cache.get(key);
                        if (value) {
                            this.#cache.set(maps, value);
                            return value;
                        }
                        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url = `url(#${id})`;
                        this.#cache.set(maps, url);
                        this.#cache.set(key, url);
                        const filter = this.#createFilter(id);
                        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        const key = `${fgColor}-${bgColor}`;
                        if (this.#hcmKey === key) return this.#hcmUrl;
                        this.#hcmKey = key;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmUrl;
                        const fgRGB = this.#getRGB(fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = this.#getRGB(bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        this.#defs.style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return this.#hcmUrl;
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                        }
                        const table = map.join(",");
                        const id = `g_${this.#docId}_hcm_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addTransferMapConversion(table, table, table, filter);
                        this.#addGrayConversion(filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        this.#hcmUrl = `url(#${id})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if (this.#hcmHighlightKey === key) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmHighlightUrl;
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map(this.#getRGB.bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map(this.#getRGB.bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        this.#defs.style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addGrayConversion(filter);
                        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        this.#hcmHighlightUrl = `url(#${id})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter) {
                        const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                        feColorMatrix.setAttribute("type", "matrix");
                        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter.append(feColorMatrix);
                    }
                    #createFilter(id) {
                        const filter = this.#document.createElementNS(SVG_NS, "filter");
                        filter.setAttribute("color-interpolation-filters", "sRGB");
                        filter.setAttribute("id", id);
                        this.#defs.append(filter);
                        return filter;
                    }
                    #appendFeFunc(feComponentTransfer, func, table) {
                        const feFunc = this.#document.createElementNS(SVG_NS, func);
                        feFunc.setAttribute("type", "discrete");
                        feFunc.setAttribute("tableValues", table);
                        feComponentTransfer.append(feFunc);
                    }
                    #addTransferMapConversion(rTable, gTable, bTable, filter) {
                        const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                        filter.append(feComponentTransfer);
                        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                    }
                    #getRGB(color) {
                        this.#defs.style.color = color;
                        return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                async function fetchData(url, asTypedArray = false) {
                    if (isValidFetchUrl(url, document.baseURI)) {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.statusText);
                        return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
                    }
                    return new Promise((resolve, reject)=>{
                        const request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        if (asTypedArray) request.responseType = "arraybuffer";
                        request.onreadystatechange = ()=>{
                            if (request.readyState !== XMLHttpRequest.DONE) return;
                            if (request.status === 200 || request.status === 0) {
                                let data;
                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                if (data) {
                                    resolve(data);
                                    return;
                                }
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    });
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch  {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    started = Object.create(null);
                    times = [];
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    async fetch({ name }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name) throw new Error("CMap name must be specified.");
                        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                        const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                        return this._fetchData(url, compressionType).catch((reason)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                        });
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    async fetch({ filename }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename) throw new Error("Font filename must be specified.");
                        const url = `${this.baseUrl}${filename}`;
                        return this._fetchData(url).catch((reason)=>{
                            throw new Error(`Unable to load font data at: ${url}`);
                        });
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                class FontLoader {
                    #systemFonts = new Set();
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info) {
                        if (!info || this.#systemFonts.has(info.loadedName)) return;
                        (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName, src, style } = info;
                            const fontFace = new FontFace(loadedName, src, style);
                            this.addNativeFontFace(fontFace);
                            try {
                                await fontFace.load();
                                this.#systemFonts.add(loadedName);
                            } catch  {
                                (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace);
                            }
                            return;
                        }
                        (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font) {
                        if (font.attached || font.missingFile && !font.systemFontInfo) return;
                        font.attached = true;
                        if (font.systemFontInfo) {
                            await this.loadSystemFont(font.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace = font.createNativeFontFace();
                            if (nativeFontFace) {
                                this.addNativeFontFace(nativeFontFace);
                                try {
                                    await nativeFontFace.loaded;
                                } catch (ex) {
                                    (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                    font.disableFontFace = true;
                                    throw ex;
                                }
                            }
                            return;
                        }
                        const rule = font.createFontFaceRule();
                        if (rule) {
                            this.insertRule(rule);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve)=>{
                                const request = this._queueLoadingCallback(resolve);
                                this._prepareFontLoadEvent(font, request);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts = !!this._document?.fonts;
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        this._inspectFont?.(this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("kjyEk"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("kjyEk"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                class CanvasGraphics {
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId !== "none") {
                                const savedFilter = this.ctx.filter;
                                this.ctx.filter = hcmFilterId;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter;
                            }
                        }
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths ||= [];
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        this.#restoreInitialState();
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                }
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                class Metadata {
                    #metadataMap;
                    #data;
                    constructor({ parsedData, rawData }){
                        this.#metadataMap = parsedData;
                        this.#data = rawData;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name) {
                        return this.#metadataMap.get(name) ?? null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)(this.#metadataMap);
                    }
                    has(name) {
                        return this.#metadataMap.has(name);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                class OptionalContentGroup {
                    #visible = true;
                    constructor(name, intent){
                        this.name = name;
                        this.intent = intent;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible;
                    }
                }
                class OptionalContentConfig {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data){
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this.#order = data.order;
                        for (const group of data.groups)this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)this.#groups.get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)this.#groups.get(off)._setVisible(INTERNAL, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array) {
                        const length = array.length;
                        if (length < 2) return true;
                        const operator = array[0];
                        for(let i = 1; i < length; i++){
                            const element = array[i];
                            let state;
                            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
                            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
                            else {
                                (0, _util.warn)(`Optional content group not found: ${element}`);
                                return true;
                            }
                            switch(operator){
                                case "And":
                                    if (!state) return false;
                                    break;
                                case "Or":
                                    if (state) return true;
                                    break;
                                case "Not":
                                    return !state;
                                default:
                                    return true;
                            }
                        }
                        return operator === "And";
                    }
                    isVisible(group) {
                        if (this.#groups.size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!this.#groups.has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return this.#groups.get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!this.#groups.has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id) {
                        return this.#groups.get(id) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
                        return this.#cachedGetHash = hash.hexdigest();
                    }
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if (initialData?.length > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt) {
                        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk = this._queuedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch  {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch  {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch  {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        pendingRequest.onProgress?.(evt);
                    }
                    onStateChange(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else pendingRequest.onError?.(xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                }
                class PDFNetworkStream {
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        this.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk = this._cachedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("kjyEk"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("kjyEk"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("kjyEk"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("kjyEk"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("kjyEk"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("kjyEk"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("kjyEk"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($hPtJY.versions.node) >= 8 ? literals : $04552c275ef79ab8$require$Buffer.from(literals);
                            const output = (parcelRequire("kjyEk")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node?.attributes?.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                class AnnotationEditorLayer {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        this.#uiManager = uiManager;
                        this.pageIndex = pageIndex;
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationLayer = annotationLayer;
                        this.viewport = viewport;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode) {
                        this.#uiManager.updateToolbar(mode);
                    }
                    updateMode(mode = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        this.#uiManager.setEditingState(isEditing);
                    }
                    addCommands(params) {
                        this.#uiManager.addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables = this.#annotationLayer.getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor.annotationElementId)?.show();
                            editor.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables = this.#annotationLayer.getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id) {
                        return this.#annotationLayer?.getEditableAnnotation(id) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = this.#uiManager.getActive();
                        if (currentActive === editor) return;
                        this.#uiManager.setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor) {
                        this.#editors.set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        this.#editors.delete(editor.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        this.#uiManager.removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        editor.parent?.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        this.#uiManager.addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params) {
                        switch(this.#uiManager.getMode()){
                            case _util.AnnotationEditorType.FREETEXT:
                                return new _freetext.FreeTextEditor(params);
                            case _util.AnnotationEditorType.INK:
                                return new _ink.InkEditor(params);
                            case _util.AnnotationEditorType.STAMP:
                                return new _stamp.StampEditor(params);
                        }
                        return null;
                    }
                    pasteEditor(mode, params) {
                        this.#uiManager.updateToolbar(mode);
                        this.#uiManager.updateMode(mode);
                        const { offsetX, offsetY } = this.#getCenterPoint();
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params
                        });
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        switch(data.annotationType ?? data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event, isCentered) {
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: event.offsetX,
                            y: event.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered
                        });
                        if (editor) this.add(editor);
                        return editor;
                    }
                    #getCenterPoint() {
                        const { x, y, width, height } = this.div.getBoundingClientRect();
                        const tlX = Math.max(0, x);
                        const tlY = Math.max(0, y);
                        const brX = Math.min(window.innerWidth, x + width);
                        const brY = Math.min(window.innerHeight, y + height);
                        const centerX = (tlX + brX) / 2 - x;
                        const centerY = (tlY + brY) / 2 - y;
                        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                            centerX,
                            centerY
                        ] : [
                            centerY,
                            centerX
                        ];
                        return {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor) {
                        this.#uiManager.setSelected(editor);
                    }
                    toggleSelected(editor) {
                        this.#uiManager.toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return this.#uiManager.isSelected(editor);
                    }
                    unselect(editor) {
                        this.#uiManager.unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event, false);
                    }
                    pointerdown(event) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor = this.#uiManager.getActive();
                        this.#allowClick = !editor || editor.isEmpty();
                    }
                    findNewParent(editor, x, y) {
                        const layer = this.#uiManager.findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of this.#uiManager.getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                class FreeTextEditor extends _editor.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params){
                        super({
                            ...params,
                            name: "freeTextEditor"
                        });
                        this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize) {
                        const setFontsize = (size)=>{
                            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                            this.translate(0, -(size - this.#fontSize) * this.parentScale);
                            this.#fontSize = size;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize(fontSize);
                            },
                            undo: ()=>{
                                setFontsize(savedFontsize);
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor;
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + this.#fontSize) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs = this.editorDiv.getElementsByTagName("div");
                        if (divs.length === 0) return this.editorDiv.innerText;
                        const buffer = [];
                        for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        return buffer.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        let rect;
                        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer, div } = this;
                            const savedDisplay = div.style.display;
                            div.style.display = "hidden";
                            currentLayer.div.append(this.div);
                            rect = div.getBoundingClientRect();
                            div.remove();
                            div.style.display = savedDisplay;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect.width / parentWidth;
                            this.height = rect.height / parentHeight;
                        } else {
                            this.width = rect.height / parentWidth;
                            this.height = rect.width / parentHeight;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = this.#content;
                        const newText = this.#content = this.#extractText().trimEnd();
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            this.#content = text;
                            if (!text) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>this.editorDiv?.setAttribute("aria-label", msg));
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = this.#initialData;
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line of this.#content.split("\n")){
                            const div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.#fontSize = data.fontSize;
                        editor.#color = _util.Util.makeHexColor(...data.color);
                        editor.#content = data.value;
                        editor.annotationElementId = data.id || null;
                        editor.#initialData = initialData;
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    #hasElementChanged(serialized) {
                        const { value, fontSize, color, rect, pageIndex } = this.#initialData;
                        return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                    }
                    #cheatInitialRect(delayed = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding, padding);
                    }
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                class AnnotationElement {
                    #hasBorder = false;
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!(titleObj?.str || contentsObj?.str || richText?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                this.#hasBorder = true;
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action?.(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if (this.#hasBorder) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                }
                class LinkAnnotationElement extends AnnotationElement {
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!options?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            this.#bindSetOCGState(link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeSetOCGState(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            otherClickAction?.();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
                            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                                focused: false
                            };
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues ?? textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues ?? textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                const defaultValue = this.data.defaultFieldValue ?? "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            elementData.userValue = event.detail.value ?? "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry?.();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        this.#container = container;
                        this.#titleObj = titleObj;
                        this.#contentsObj = contentsObj;
                        this.#richText = richText;
                        this.#parent = parent;
                        this.#color = color;
                        this.#rect = rect;
                        this.#parentRect = parentRect;
                        this.#elements = elements;
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        });
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", this.#boundToggle);
                            element.addEventListener("mouseenter", this.#boundShow);
                            element.addEventListener("mouseleave", this.#boundHide);
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = this.#parent;
                        const popup = this.#popup = document.createElement("div");
                        popup.className = "popup";
                        if (this.#color) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
                        popup.append(header);
                        if (this.#dateTimePromise) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            this.#dateTimePromise.then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = this.#contentsObj;
                        const richText = this.#richText;
                        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!this.#parentRect;
                        let rect = useParentRect ? this.#parentRect : this.#rect;
                        for (const element of this.#elements)if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = this.#container;
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        this.#container.append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    #keyDown(event) {
                        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                class LineAnnotationElement extends AnnotationElement {
                    #line = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = this.#line = this.svgFactory.createElement("svg:line");
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement extends AnnotationElement {
                    #square = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = this.#square = this.svgFactory.createElement("svg:rect");
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement extends AnnotationElement {
                    #circle = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement extends AnnotationElement {
                    #polyline = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement extends AnnotationElement {
                    #polylines = [];
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    #trigger = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger;
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationCanvasMap = annotationCanvasMap;
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils.NullL10n;
                    }
                    #appendElement(element, id) {
                        const contentElement = element.firstChild || element;
                        contentElement.id = `${_util.AnnotationPrefix}${id}`;
                        this.div.append(element);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                    }
                    async render(params) {
                        const { annotations } = params;
                        const layer = this.div;
                        (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                        const popupToElements = new Map();
                        const elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new _display_utils.DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data of annotations){
                            if (data.noHTML) continue;
                            const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                            if (!isPopupAnnotation) {
                                const { width, height } = getRectDims(data.rect);
                                if (width <= 0 || height <= 0) continue;
                            } else {
                                const elements = popupToElements.get(data.id);
                                if (!elements) continue;
                                elementParams.elements = elements;
                            }
                            elementParams.data = data;
                            const element = AnnotationElementFactory.create(elementParams);
                            if (!element.isRenderable) continue;
                            if (!isPopupAnnotation && data.popupRef) {
                                const elements = popupToElements.get(data.popupRef);
                                if (!elements) popupToElements.set(data.popupRef, [
                                    element
                                ]);
                                else elements.push(element);
                            }
                            if (element.annotationEditorType > 0) this.#editableAnnotations.set(element.data.id, element);
                            const rendered = element.render();
                            if (data.hidden) rendered.style.visibility = "hidden";
                            this.#appendElement(rendered, data.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer = this.div;
                        for (const [id, canvas] of this.#annotationCanvasMap){
                            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                            if (!element) continue;
                            const { firstChild } = element;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id) {
                        return this.#editableAnnotations.get(id);
                    }
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key, args = null, fallback = getL10nFallback(key, args)) {
                        return formatL10nValue(fallback, args);
                    },
                    async translate (element) {}
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                class InkEditor extends _editor.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params){
                        super({
                            ...params,
                            name: "inkEditor"
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness) {
                        const savedThickness = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity) {
                        opacity /= 100;
                        const savedOpacity = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation, parentDimensions: [width, height] } = this;
                        switch(parentRotation){
                            case 90:
                                return [
                                    0,
                                    height,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    width,
                                    height,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    width,
                                    0,
                                    height,
                                    width
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width,
                                    height
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                        ctx.lineWidth = thickness * parentScale / scaleFactor;
                        ctx.lineCap = "round";
                        ctx.lineJoin = "round";
                        ctx.miterLimit = 10;
                        ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                    }
                    #startDrawing(x, y) {
                        this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor._defaultThickness;
                            this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor._defaultOpacity;
                        }
                        this.currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x, y) {
                        const [lastX, lastY] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                        const currentPath = this.currentPath;
                        let path2D = this.#currentPath2D;
                        currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath.length <= 2) {
                            path2D.moveTo(...currentPath[0]);
                            path2D.lineTo(x, y);
                            return;
                        }
                        if (currentPath.length === 3) {
                            this.#currentPath2D = path2D = new Path2D();
                            path2D.moveTo(...currentPath[0]);
                        }
                        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint);
                    }
                    #stopDrawing(x, y) {
                        this.#requestFrameCallback = null;
                        x = Math.min(Math.max(x, 0), this.canvas.width);
                        y = Math.min(Math.max(y, 0), this.canvas.height);
                        this.#draw(x, y);
                        this.#endPath();
                        let bezier;
                        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
                        else {
                            const xy = [
                                x,
                                y
                            ];
                            bezier = [
                                [
                                    xy,
                                    xy.slice(),
                                    xy.slice(),
                                    xy
                                ]
                            ];
                        }
                        const path2D = this.#currentPath2D;
                        const currentPath = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd = ()=>{
                            this.allRawPaths.push(currentPath);
                            this.paths.push(bezier);
                            this.bezierPath2D.push(path2D);
                            this.rebuild();
                        };
                        const undo = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints = this.currentPath.slice(-3);
                        const x = lastPoints.map((xy)=>xy[0]);
                        const y = lastPoints.map((xy)=>xy[1]);
                        const xMin = Math.min(...x) - thickness;
                        const xMax = Math.max(...x) + thickness;
                        const yMin = Math.min(...y) - thickness;
                        const yMax = Math.max(...y) + thickness;
                        const { ctx } = this;
                        ctx.save();
                        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                        ctx.stroke(this.#currentPath2D);
                        ctx.restore();
                    }
                    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                        const prevX = (x0 + x1) / 2;
                        const prevY = (y0 + y1) / 2;
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                    }
                    #generateBezierPoints() {
                        const path = this.currentPath;
                        if (path.length <= 2) return [
                            [
                                path[0],
                                path[0],
                                path.at(-1),
                                path.at(-1)
                            ]
                        ];
                        const bezierPoints = [];
                        let i;
                        let [x0, y0] = path[0];
                        for(i = 1; i < path.length - 2; i++){
                            const [x1, y1] = path[i];
                            const [x2, y2] = path[i + 1];
                            const x3 = (x1 + x2) / 2;
                            const y3 = (y1 + y2) / 2;
                            const control1 = [
                                x0 + 2 * (x1 - x0) / 3,
                                y0 + 2 * (y1 - y0) / 3
                            ];
                            const control2 = [
                                x3 + 2 * (x1 - x3) / 3,
                                y3 + 2 * (y1 - y3) / 3
                            ];
                            bezierPoints.push([
                                [
                                    x0,
                                    y0
                                ],
                                control1,
                                control2,
                                [
                                    x3,
                                    y3
                                ]
                            ]);
                            [x0, y0] = [
                                x3,
                                y3
                            ];
                        }
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x2 + 2 * (x1 - x2) / 3,
                            y2 + 2 * (y1 - y2) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x2,
                                y2
                            ]
                        ]);
                        return bezierPoints;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas, ctx } = this;
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.#updateTransform();
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        this.#startDrawing(event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        this.#draw(event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        this.#endDrawing(event);
                    }
                    canvasPointerleave(event) {
                        this.#endDrawing(event);
                    }
                    #endDrawing(event) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event.offsetX, event.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>this.canvas?.setAttribute("aria-label", msg));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>this.div?.setAttribute("aria-label", msg));
                        const [x, y, w, h] = this.#getInitialBBox();
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth);
                        this.canvas.height = Math.ceil(this.height * parentHeight);
                        this.#updateTransform();
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
                        this.#realWidth = roundedWidth;
                        this.#realHeight = roundedHeight;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width, height);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width, height) {
                        const padding = this.#getPadding();
                        const scaleFactorW = (width - padding) / this.#baseWidth;
                        const scaleFactorH = (height - padding) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                    }
                    #updateTransform() {
                        const padding = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                    }
                    static #buildPath2D(bezier) {
                        const path2D = new Path2D();
                        for(let i = 0, ii = bezier.length; i < ii; i++){
                            const [first, control1, control2, second] = bezier[i];
                            if (i === 0) path2D.moveTo(...first);
                            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                        }
                        return path2D;
                    }
                    static #toPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] += blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] + blX;
                                    points[i + 1] = x + blY;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] += blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trX - points[i + 1];
                                    points[i + 1] = trY - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    static #fromPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] -= blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] - blY;
                                    points[i + 1] = x - blX;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] -= blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trY - points[i + 1];
                                    points[i + 1] = trX - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    #serializePaths(s, tx, ty, rect) {
                        const paths = [];
                        const padding = this.thickness / 2;
                        const shiftX = s * tx + padding;
                        const shiftY = s * ty + padding;
                        for (const bezier of this.paths){
                            const buffer = [];
                            const points = [];
                            for(let j = 0, jj = bezier.length; j < jj; j++){
                                const [first, control1, control2, second] = bezier[j];
                                const p10 = s * first[0] + shiftX;
                                const p11 = s * first[1] + shiftY;
                                const p20 = s * control1[0] + shiftX;
                                const p21 = s * control1[1] + shiftY;
                                const p30 = s * control2[0] + shiftX;
                                const p31 = s * control2[1] + shiftY;
                                const p40 = s * second[0] + shiftX;
                                const p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                                points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                            });
                        }
                        return paths;
                    }
                    #getBbox() {
                        let xMin = Infinity;
                        let xMax = -Infinity;
                        let yMin = Infinity;
                        let yMax = -Infinity;
                        for (const path of this.paths)for (const [first, control1, control2, second] of path){
                            const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                            xMin = Math.min(xMin, bbox[0]);
                            yMin = Math.min(yMin, bbox[1]);
                            xMax = Math.max(xMax, bbox[2]);
                            yMax = Math.max(yMax, bbox[3]);
                        }
                        return [
                            xMin,
                            yMin,
                            xMax,
                            yMax
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox = this.#getBbox();
                        const padding = this.#getPadding();
                        this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setAspectRatio(width, height);
                        const prevTranslationX = this.translationX;
                        const prevTranslationY = this.translationY;
                        this.translationX = -bbox[0];
                        this.translationY = -bbox[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width;
                        this.#realHeight = height;
                        this.setDims(width, height);
                        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        editor.#disableEditing = true;
                        editor.#realWidth = Math.round(width);
                        editor.#realHeight = Math.round(height);
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = this.#buildPath2D(path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = editor.#getBbox();
                        editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        editor.#setScaleFactor(width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                class StampEditor extends _editor.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params){
                        super({
                            ...params,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params.bitmapUrl;
                        this.#bitmapFile = params.bitmapFile;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    #getBitmapFetched(data, fromId = false) {
                        if (!data) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data.bitmap;
                        if (!fromId) {
                            this.#bitmapId = data.id;
                            this.#isSvg = data.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = StampEditor.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve)=>{
                            input.addEventListener("change", async ()=>{
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                                    this.#getBitmapFetched(data);
                                }
                                resolve();
                            });
                            input.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div } = this;
                        let { width, height } = this.#bitmap;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const MAX_RATIO = 0.75;
                        if (this.width) {
                            width = this.width * pageWidth;
                            height = this.height * pageHeight;
                        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                            width *= factor;
                            height *= factor;
                        }
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                        this._uiManager.enableWaiting(false);
                        const canvas = this.#canvas = document.createElement("canvas");
                        div.append(canvas);
                        div.hidden = false;
                        this.#drawBitmap(width, height);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setDims(width, height);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width, height);
                        }, TIME_TO_WAIT);
                    }
                    #scaleBitmap(width, height) {
                        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
                        let newWidth = bitmapWidth;
                        let newHeight = bitmapHeight;
                        let bitmap = this.#bitmap;
                        while(newWidth > 2 * width || newHeight > 2 * height){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                            const offscreen = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = offscreen.transferToImageBitmap();
                        }
                        return bitmap;
                    }
                    #drawBitmap(width, height) {
                        width = Math.ceil(width);
                        height = Math.ceil(height);
                        const canvas = this.#canvas;
                        if (!canvas || canvas.width === width && canvas.height === height) return;
                        canvas.width = width;
                        canvas.height = height;
                        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                        const ctx = canvas.getContext("2d");
                        ctx.filter = this._uiManager.hcmFilter;
                        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                    }
                    #serializeBitmap(toUrl) {
                        if (toUrl) {
                            if (this.#isSvg) {
                                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url) return url;
                            }
                            const canvas = document.createElement("canvas");
                            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0);
                            return canvas.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth, pageHeight] = this.pageDimensions;
                            const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen = new OffscreenCanvas(width, height);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                            return offscreen.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
                        else editor.#bitmapUrl = bitmapUrl;
                        editor.#isSvg = isSvg;
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = this.#serializeBitmap(true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        context.stamps ||= new Map();
                        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has(this.#bitmapId)) {
                            context.stamps.set(this.#bitmapId, {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData = context.stamps.get(this.#bitmapId);
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized;
                    }
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = '3.11.174';
            const pdfjsBuild = 'ce8716743';
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * auth0-js v9.16.4
 * Author: Auth0
 * Date: 2021-08-26
 * License: MIT
 */ 
var $hPtJY = parcelRequire("hPtJY");
var $51679e17ad633b30$var$commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $51679e17ad633b30$var$createCommonjsModule(fn, module) {
    return fn(module = {
        exports: {}
    }, module.exports), module.exports;
}
var $51679e17ad633b30$var$urlJoin = $51679e17ad633b30$var$createCommonjsModule(function(module) {
    var context, definition;
    context = $51679e17ad633b30$var$commonjsGlobal, definition = function() {
        function normalize(strArray) {
            var resultArray = [];
            if (0 === strArray.length) return "";
            if ("string" != typeof strArray[0]) throw new TypeError("Url must be a string. Received " + strArray[0]);
            if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
                var first = strArray.shift();
                strArray[0] = first + strArray[0];
            }
            strArray[0].match(/^file:\/\/\//) ? strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///") : strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
            for(var i = 0; i < strArray.length; i++){
                var component = strArray[i];
                if ("string" != typeof component) throw new TypeError("Url must be a string. Received " + component);
                "" !== component && (i > 0 && (component = component.replace(/^[\/]+/, "")), component = i < strArray.length - 1 ? component.replace(/[\/]+$/, "") : component.replace(/[\/]+$/, "/"), resultArray.push(component));
            }
            var str = resultArray.join("/"), parts = (str = str.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
            return str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        }
        return function() {
            return normalize("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
        };
    }, module.exports ? module.exports = definition() : context.urljoin = definition();
}), $51679e17ad633b30$var$origSymbol = $51679e17ad633b30$var$commonjsGlobal.Symbol, $51679e17ad633b30$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", $51679e17ad633b30$var$slice = Array.prototype.slice, $51679e17ad633b30$var$toStr = Object.prototype.toString, $51679e17ad633b30$var$functionBind = Function.prototype.bind || function(that) {
    var target = this;
    if ("function" != typeof target || "[object Function]" !== $51679e17ad633b30$var$toStr.call(target)) throw new TypeError($51679e17ad633b30$var$ERROR_MESSAGE + target);
    for(var bound, args = $51679e17ad633b30$var$slice.call(arguments, 1), binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($51679e17ad633b30$var$slice.call(arguments)));
            return Object(result) === result ? result : this;
        }
        return target.apply(that, args.concat($51679e17ad633b30$var$slice.call(arguments)));
    }, boundLength = Math.max(0, target.length - args.length), boundArgs = [], i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    if (bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder), target.prototype) {
        var Empty = function() {};
        Empty.prototype = target.prototype, bound.prototype = new Empty, Empty.prototype = null;
    }
    return bound;
}, $51679e17ad633b30$var$src = $51679e17ad633b30$var$functionBind.call(Function.call, Object.prototype.hasOwnProperty), $51679e17ad633b30$var$$SyntaxError = SyntaxError, $51679e17ad633b30$var$$Function = Function, $51679e17ad633b30$var$$TypeError = TypeError, $51679e17ad633b30$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $51679e17ad633b30$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
}, $51679e17ad633b30$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($51679e17ad633b30$var$$gOPD) try {
    $51679e17ad633b30$var$$gOPD({}, "");
} catch (e) {
    $51679e17ad633b30$var$$gOPD = null;
}
var $51679e17ad633b30$var$throwTypeError = function() {
    throw new $51679e17ad633b30$var$$TypeError;
}, $51679e17ad633b30$var$ThrowTypeError = $51679e17ad633b30$var$$gOPD ? function() {
    try {
        return $51679e17ad633b30$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            return $51679e17ad633b30$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $51679e17ad633b30$var$throwTypeError;
        }
    }
}() : $51679e17ad633b30$var$throwTypeError, $51679e17ad633b30$var$hasSymbols$1 = "function" == typeof $51679e17ad633b30$var$origSymbol && "function" == typeof Symbol && "symbol" == typeof $51679e17ad633b30$var$origSymbol("foo") && "symbol" == typeof Symbol("bar") && function() {
    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
    if ("symbol" == typeof Symbol.iterator) return !0;
    var obj = {}, sym = Symbol("test"), symObj = Object(sym);
    if ("string" == typeof sym) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(sym)) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(symObj)) return !1;
    for(sym in obj[sym] = 42, obj)return !1;
    if ("function" == typeof Object.keys && 0 !== Object.keys(obj).length) return !1;
    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(obj).length) return !1;
    var syms = Object.getOwnPropertySymbols(obj);
    if (1 !== syms.length || syms[0] !== sym) return !1;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return !1;
    if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (42 !== descriptor.value || !0 !== descriptor.enumerable) return !1;
    }
    return !0;
}(), $51679e17ad633b30$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}, $51679e17ad633b30$var$needsEval = {}, $51679e17ad633b30$var$TypedArray = "undefined" == typeof Uint8Array ? void 0 : $51679e17ad633b30$var$getProto(Uint8Array), $51679e17ad633b30$var$INTRINSICS = {
    "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
    "%ArrayIteratorPrototype%": $51679e17ad633b30$var$hasSymbols$1 ? $51679e17ad633b30$var$getProto([][Symbol.iterator]()) : void 0,
    "%AsyncFromSyncIteratorPrototype%": void 0,
    "%AsyncFunction%": $51679e17ad633b30$var$needsEval,
    "%AsyncGenerator%": $51679e17ad633b30$var$needsEval,
    "%AsyncGeneratorFunction%": $51679e17ad633b30$var$needsEval,
    "%AsyncIteratorPrototype%": $51679e17ad633b30$var$needsEval,
    "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
    "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
    "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
    "%Function%": $51679e17ad633b30$var$$Function,
    "%GeneratorFunction%": $51679e17ad633b30$var$needsEval,
    "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
    "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
    "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $51679e17ad633b30$var$hasSymbols$1 ? $51679e17ad633b30$var$getProto($51679e17ad633b30$var$getProto([][Symbol.iterator]())) : void 0,
    "%JSON%": "object" == typeof JSON ? JSON : void 0,
    "%Map%": "undefined" == typeof Map ? void 0 : Map,
    "%MapIteratorPrototype%": "undefined" != typeof Map && $51679e17ad633b30$var$hasSymbols$1 ? $51679e17ad633b30$var$getProto((new Map)[Symbol.iterator]()) : void 0,
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
    "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": "undefined" == typeof Set ? void 0 : Set,
    "%SetIteratorPrototype%": "undefined" != typeof Set && $51679e17ad633b30$var$hasSymbols$1 ? $51679e17ad633b30$var$getProto((new Set)[Symbol.iterator]()) : void 0,
    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $51679e17ad633b30$var$hasSymbols$1 ? $51679e17ad633b30$var$getProto(""[Symbol.iterator]()) : void 0,
    "%Symbol%": $51679e17ad633b30$var$hasSymbols$1 ? Symbol : void 0,
    "%SyntaxError%": $51679e17ad633b30$var$$SyntaxError,
    "%ThrowTypeError%": $51679e17ad633b30$var$ThrowTypeError,
    "%TypedArray%": $51679e17ad633b30$var$TypedArray,
    "%TypeError%": $51679e17ad633b30$var$$TypeError,
    "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
    "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
    "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
    "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
    "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
}, $51679e17ad633b30$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
}, $51679e17ad633b30$var$$concat = $51679e17ad633b30$var$functionBind.call(Function.call, Array.prototype.concat), $51679e17ad633b30$var$$spliceApply = $51679e17ad633b30$var$functionBind.call(Function.apply, Array.prototype.splice), $51679e17ad633b30$var$$replace = $51679e17ad633b30$var$functionBind.call(Function.call, String.prototype.replace), $51679e17ad633b30$var$$strSlice = $51679e17ad633b30$var$functionBind.call(Function.call, String.prototype.slice), $51679e17ad633b30$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, $51679e17ad633b30$var$reEscapeChar = /\\(\\)?/g, $51679e17ad633b30$var$stringToPath = function(string) {
    var first = $51679e17ad633b30$var$$strSlice(string, 0, 1), last = $51679e17ad633b30$var$$strSlice(string, -1);
    if ("%" === first && "%" !== last) throw new $51679e17ad633b30$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    if ("%" === last && "%" !== first) throw new $51679e17ad633b30$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    return $51679e17ad633b30$var$$replace(string, $51679e17ad633b30$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $51679e17ad633b30$var$$replace(subString, $51679e17ad633b30$var$reEscapeChar, "$1") : number || match;
    }), result;
}, $51679e17ad633b30$var$getBaseIntrinsic = function(name, allowMissing) {
    var alias, intrinsicName = name;
    if ($51679e17ad633b30$var$src($51679e17ad633b30$var$LEGACY_ALIASES, intrinsicName) && (intrinsicName = "%" + (alias = $51679e17ad633b30$var$LEGACY_ALIASES[intrinsicName])[0] + "%"), $51679e17ad633b30$var$src($51679e17ad633b30$var$INTRINSICS, intrinsicName)) {
        var value = $51679e17ad633b30$var$INTRINSICS[intrinsicName];
        if (value === $51679e17ad633b30$var$needsEval && (value = function doEval(name) {
            var value;
            if ("%AsyncFunction%" === name) value = $51679e17ad633b30$var$getEvalledConstructor("async function () {}");
            else if ("%GeneratorFunction%" === name) value = $51679e17ad633b30$var$getEvalledConstructor("function* () {}");
            else if ("%AsyncGeneratorFunction%" === name) value = $51679e17ad633b30$var$getEvalledConstructor("async function* () {}");
            else if ("%AsyncGenerator%" === name) {
                var fn = doEval("%AsyncGeneratorFunction%");
                fn && (value = fn.prototype);
            } else if ("%AsyncIteratorPrototype%" === name) {
                var gen = doEval("%AsyncGenerator%");
                gen && (value = $51679e17ad633b30$var$getProto(gen.prototype));
            }
            return $51679e17ad633b30$var$INTRINSICS[name] = value, value;
        }(intrinsicName)), void 0 === value && !allowMissing) throw new $51679e17ad633b30$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $51679e17ad633b30$var$$SyntaxError("intrinsic " + name + " does not exist!");
}, $51679e17ad633b30$var$getIntrinsic = function(name, allowMissing) {
    if ("string" != typeof name || 0 === name.length) throw new $51679e17ad633b30$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && "boolean" != typeof allowMissing) throw new $51679e17ad633b30$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $51679e17ad633b30$var$stringToPath(name), intrinsicBaseName = parts.length > 0 ? parts[0] : "", intrinsic = $51679e17ad633b30$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing), intrinsicRealName = intrinsic.name, value = intrinsic.value, skipFurtherCaching = !1, alias = intrinsic.alias;
    alias && (intrinsicBaseName = alias[0], $51679e17ad633b30$var$$spliceApply(parts, $51679e17ad633b30$var$$concat([
        0,
        1
    ], alias)));
    for(var i = 1, isOwn = !0; i < parts.length; i += 1){
        var part = parts[i], first = $51679e17ad633b30$var$$strSlice(part, 0, 1), last = $51679e17ad633b30$var$$strSlice(part, -1);
        if (('"' === first || "'" === first || "`" === first || '"' === last || "'" === last || "`" === last) && first !== last) throw new $51679e17ad633b30$var$$SyntaxError("property names with quotes must have matching quotes");
        if ("constructor" !== part && isOwn || (skipFurtherCaching = !0), $51679e17ad633b30$var$src($51679e17ad633b30$var$INTRINSICS, intrinsicRealName = "%" + (intrinsicBaseName += "." + part) + "%")) value = $51679e17ad633b30$var$INTRINSICS[intrinsicRealName];
        else if (null != value) {
            if (!(part in value)) {
                if (!allowMissing) throw new $51679e17ad633b30$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return;
            }
            if ($51679e17ad633b30$var$$gOPD && i + 1 >= parts.length) {
                var desc = $51679e17ad633b30$var$$gOPD(value, part);
                value = (isOwn = !!desc) && "get" in desc && !("originalValue" in desc.get) ? desc.get : value[part];
            } else isOwn = $51679e17ad633b30$var$src(value, part), value = value[part];
            isOwn && !skipFurtherCaching && ($51679e17ad633b30$var$INTRINSICS[intrinsicRealName] = value);
        }
    }
    return value;
}, $51679e17ad633b30$var$callBind = $51679e17ad633b30$var$createCommonjsModule(function(module) {
    var $apply = $51679e17ad633b30$var$getIntrinsic("%Function.prototype.apply%"), $call = $51679e17ad633b30$var$getIntrinsic("%Function.prototype.call%"), $reflectApply = $51679e17ad633b30$var$getIntrinsic("%Reflect.apply%", !0) || $51679e17ad633b30$var$functionBind.call($call, $apply), $gOPD = $51679e17ad633b30$var$getIntrinsic("%Object.getOwnPropertyDescriptor%", !0), $defineProperty = $51679e17ad633b30$var$getIntrinsic("%Object.defineProperty%", !0), $max = $51679e17ad633b30$var$getIntrinsic("%Math.max%");
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        $defineProperty = null;
    }
    module.exports = function(originalFunction) {
        var func = $reflectApply($51679e17ad633b30$var$functionBind, $call, arguments);
        if ($gOPD && $defineProperty) {
            var desc = $gOPD(func, "length");
            desc.configurable && $defineProperty(func, "length", {
                value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
            });
        }
        return func;
    };
    var applyBind = function() {
        return $reflectApply($51679e17ad633b30$var$functionBind, $apply, arguments);
    };
    $defineProperty ? $defineProperty(module.exports, "apply", {
        value: applyBind
    }) : module.exports.apply = applyBind;
}), $51679e17ad633b30$var$$indexOf = ($51679e17ad633b30$var$callBind.apply, $51679e17ad633b30$var$callBind($51679e17ad633b30$var$getIntrinsic("String.prototype.indexOf"))), $51679e17ad633b30$var$callBound = function(name, allowMissing) {
    var intrinsic = $51679e17ad633b30$var$getIntrinsic(name, !!allowMissing);
    return "function" == typeof intrinsic && $51679e17ad633b30$var$$indexOf(name, ".prototype.") > -1 ? $51679e17ad633b30$var$callBind(intrinsic) : intrinsic;
}, $51679e17ad633b30$var$require$$0 = function(n) {
    return n && n.default || n;
}(Object.freeze({
    __proto__: null,
    default: {}
})), $51679e17ad633b30$var$hasMap = "function" == typeof Map && Map.prototype, $51679e17ad633b30$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $51679e17ad633b30$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, $51679e17ad633b30$var$mapSize = $51679e17ad633b30$var$hasMap && $51679e17ad633b30$var$mapSizeDescriptor && "function" == typeof $51679e17ad633b30$var$mapSizeDescriptor.get ? $51679e17ad633b30$var$mapSizeDescriptor.get : null, $51679e17ad633b30$var$mapForEach = $51679e17ad633b30$var$hasMap && Map.prototype.forEach, $51679e17ad633b30$var$hasSet = "function" == typeof Set && Set.prototype, $51679e17ad633b30$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $51679e17ad633b30$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, $51679e17ad633b30$var$setSize = $51679e17ad633b30$var$hasSet && $51679e17ad633b30$var$setSizeDescriptor && "function" == typeof $51679e17ad633b30$var$setSizeDescriptor.get ? $51679e17ad633b30$var$setSizeDescriptor.get : null, $51679e17ad633b30$var$setForEach = $51679e17ad633b30$var$hasSet && Set.prototype.forEach, $51679e17ad633b30$var$weakMapHas = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, $51679e17ad633b30$var$weakSetHas = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, $51679e17ad633b30$var$weakRefDeref = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, $51679e17ad633b30$var$booleanValueOf = Boolean.prototype.valueOf, $51679e17ad633b30$var$objectToString = Object.prototype.toString, $51679e17ad633b30$var$functionToString = Function.prototype.toString, $51679e17ad633b30$var$match = String.prototype.match, $51679e17ad633b30$var$bigIntValueOf = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, $51679e17ad633b30$var$gOPS = Object.getOwnPropertySymbols, $51679e17ad633b30$var$symToString = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, $51679e17ad633b30$var$hasShammedSymbols = "function" == typeof Symbol && "object" == typeof Symbol.iterator, $51679e17ad633b30$var$isEnumerable = Object.prototype.propertyIsEnumerable, $51679e17ad633b30$var$gPO = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
    return O.__proto__;
} : null), $51679e17ad633b30$var$inspectCustom = $51679e17ad633b30$var$require$$0.custom, $51679e17ad633b30$var$inspectSymbol = $51679e17ad633b30$var$inspectCustom && $51679e17ad633b30$var$isSymbol($51679e17ad633b30$var$inspectCustom) ? $51679e17ad633b30$var$inspectCustom : null, $51679e17ad633b30$var$toStringTag = "function" == typeof Symbol && void 0 !== Symbol.toStringTag ? Symbol.toStringTag : null, $51679e17ad633b30$var$objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($51679e17ad633b30$var$has(opts, "quoteStyle") && "single" !== opts.quoteStyle && "double" !== opts.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($51679e17ad633b30$var$has(opts, "maxStringLength") && ("number" == typeof opts.maxStringLength ? opts.maxStringLength < 0 && opts.maxStringLength !== 1 / 0 : null !== opts.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = !$51679e17ad633b30$var$has(opts, "customInspect") || opts.customInspect;
    if ("boolean" != typeof customInspect && "symbol" !== customInspect) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($51679e17ad633b30$var$has(opts, "indent") && null !== opts.indent && "\t" !== opts.indent && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    if (void 0 === obj) return "undefined";
    if (null === obj) return "null";
    if ("boolean" == typeof obj) return obj ? "true" : "false";
    if ("string" == typeof obj) return function inspectString(str, opts) {
        if (str.length > opts.maxStringLength) {
            var remaining = str.length - opts.maxStringLength, trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
            return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
        }
        return $51679e17ad633b30$var$wrapQuotes(str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, $51679e17ad633b30$var$lowbyte), "single", opts);
    }(obj, opts);
    if ("number" == typeof obj) return 0 === obj ? 1 / 0 / obj > 0 ? "0" : "-0" : String(obj);
    if ("bigint" == typeof obj) return String(obj) + "n";
    var maxDepth = void 0 === opts.depth ? 5 : opts.depth;
    if (void 0 === depth && (depth = 0), depth >= maxDepth && maxDepth > 0 && "object" == typeof obj) return $51679e17ad633b30$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = function(opts, depth) {
        var baseIndent;
        if ("\t" === opts.indent) baseIndent = "\t";
        else {
            if (!("number" == typeof opts.indent && opts.indent > 0)) return null;
            baseIndent = Array(opts.indent + 1).join(" ");
        }
        return {
            base: baseIndent,
            prev: Array(depth + 1).join(baseIndent)
        };
    }(opts, depth);
    if (void 0 === seen) seen = [];
    else if ($51679e17ad633b30$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from && (seen = seen.slice()).push(from), noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            return $51679e17ad633b30$var$has(opts, "quoteStyle") && (newOpts.quoteStyle = opts.quoteStyle), inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if ("function" == typeof obj) {
        var name = function(f) {
            if (f.name) return f.name;
            var m = $51679e17ad633b30$var$match.call($51679e17ad633b30$var$functionToString.call(f), /^function\s*([\w$]+)/);
            if (m) return m[1];
            return null;
        }(obj), keys = $51679e17ad633b30$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + keys.join(", ") + " }" : "");
    }
    if ($51679e17ad633b30$var$isSymbol(obj)) {
        var symString = $51679e17ad633b30$var$hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : $51679e17ad633b30$var$symToString.call(obj);
        return "object" != typeof obj || $51679e17ad633b30$var$hasShammedSymbols ? symString : $51679e17ad633b30$var$markBoxed(symString);
    }
    if (function(x) {
        if (!x || "object" != typeof x) return !1;
        if ("undefined" != typeof HTMLElement && x instanceof HTMLElement) return !0;
        return "string" == typeof x.nodeName && "function" == typeof x.getAttribute;
    }(obj)) {
        for(var s = "<" + String(obj.nodeName).toLowerCase(), attrs = obj.attributes || [], i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $51679e17ad633b30$var$wrapQuotes($51679e17ad633b30$var$quote(attrs[i].value), "double", opts);
        return s += ">", obj.childNodes && obj.childNodes.length && (s += "..."), s += "</" + String(obj.nodeName).toLowerCase() + ">";
    }
    if ($51679e17ad633b30$var$isArray(obj)) {
        if (0 === obj.length) return "[]";
        var xs = $51679e17ad633b30$var$arrObjKeys(obj, inspect);
        return indent && !function(xs) {
            for(var i = 0; i < xs.length; i++)if ($51679e17ad633b30$var$indexOf(xs[i], "\n") >= 0) return !1;
            return !0;
        }(xs) ? "[" + $51679e17ad633b30$var$indentedJoin(xs, indent) + "]" : "[ " + xs.join(", ") + " ]";
    }
    if (function(obj) {
        return !("[object Error]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj)) {
        var parts = $51679e17ad633b30$var$arrObjKeys(obj, inspect);
        return 0 === parts.length ? "[" + String(obj) + "]" : "{ [" + String(obj) + "] " + parts.join(", ") + " }";
    }
    if ("object" == typeof obj && customInspect) {
        if ($51679e17ad633b30$var$inspectSymbol && "function" == typeof obj[$51679e17ad633b30$var$inspectSymbol]) return obj[$51679e17ad633b30$var$inspectSymbol]();
        if ("symbol" !== customInspect && "function" == typeof obj.inspect) return obj.inspect();
    }
    if (function(x) {
        if (!$51679e17ad633b30$var$mapSize || !x || "object" != typeof x) return !1;
        try {
            $51679e17ad633b30$var$mapSize.call(x);
            try {
                $51679e17ad633b30$var$setSize.call(x);
            } catch (s) {
                return !0;
            }
            return x instanceof Map;
        } catch (e) {}
        return !1;
    }(obj)) {
        var mapParts = [];
        return $51679e17ad633b30$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, !0) + " => " + inspect(value, obj));
        }), $51679e17ad633b30$var$collectionOf("Map", $51679e17ad633b30$var$mapSize.call(obj), mapParts, indent);
    }
    if (function(x) {
        if (!$51679e17ad633b30$var$setSize || !x || "object" != typeof x) return !1;
        try {
            $51679e17ad633b30$var$setSize.call(x);
            try {
                $51679e17ad633b30$var$mapSize.call(x);
            } catch (m) {
                return !0;
            }
            return x instanceof Set;
        } catch (e) {}
        return !1;
    }(obj)) {
        var setParts = [];
        return $51679e17ad633b30$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        }), $51679e17ad633b30$var$collectionOf("Set", $51679e17ad633b30$var$setSize.call(obj), setParts, indent);
    }
    if (function(x) {
        if (!$51679e17ad633b30$var$weakMapHas || !x || "object" != typeof x) return !1;
        try {
            $51679e17ad633b30$var$weakMapHas.call(x, $51679e17ad633b30$var$weakMapHas);
            try {
                $51679e17ad633b30$var$weakSetHas.call(x, $51679e17ad633b30$var$weakSetHas);
            } catch (s) {
                return !0;
            }
            return x instanceof WeakMap;
        } catch (e) {}
        return !1;
    }(obj)) return $51679e17ad633b30$var$weakCollectionOf("WeakMap");
    if (function(x) {
        if (!$51679e17ad633b30$var$weakSetHas || !x || "object" != typeof x) return !1;
        try {
            $51679e17ad633b30$var$weakSetHas.call(x, $51679e17ad633b30$var$weakSetHas);
            try {
                $51679e17ad633b30$var$weakMapHas.call(x, $51679e17ad633b30$var$weakMapHas);
            } catch (s) {
                return !0;
            }
            return x instanceof WeakSet;
        } catch (e) {}
        return !1;
    }(obj)) return $51679e17ad633b30$var$weakCollectionOf("WeakSet");
    if (function(x) {
        if (!$51679e17ad633b30$var$weakRefDeref || !x || "object" != typeof x) return !1;
        try {
            return $51679e17ad633b30$var$weakRefDeref.call(x), !0;
        } catch (e) {}
        return !1;
    }(obj)) return $51679e17ad633b30$var$weakCollectionOf("WeakRef");
    if (function(obj) {
        return !("[object Number]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj)) return $51679e17ad633b30$var$markBoxed(inspect(Number(obj)));
    if (function(obj) {
        if (!obj || "object" != typeof obj || !$51679e17ad633b30$var$bigIntValueOf) return !1;
        try {
            return $51679e17ad633b30$var$bigIntValueOf.call(obj), !0;
        } catch (e) {}
        return !1;
    }(obj)) return $51679e17ad633b30$var$markBoxed(inspect($51679e17ad633b30$var$bigIntValueOf.call(obj)));
    if (function(obj) {
        return !("[object Boolean]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj)) return $51679e17ad633b30$var$markBoxed($51679e17ad633b30$var$booleanValueOf.call(obj));
    if (function(obj) {
        return !("[object String]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj)) return $51679e17ad633b30$var$markBoxed(inspect(String(obj)));
    if (!function(obj) {
        return !("[object Date]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj) && !function(obj) {
        return !("[object RegExp]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
    }(obj)) {
        var ys = $51679e17ad633b30$var$arrObjKeys(obj, inspect), isPlainObject = $51679e17ad633b30$var$gPO ? $51679e17ad633b30$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object, protoTag = obj instanceof Object ? "" : "null prototype", stringTag = !isPlainObject && $51679e17ad633b30$var$toStringTag && Object(obj) === obj && $51679e17ad633b30$var$toStringTag in obj ? $51679e17ad633b30$var$toStr$1(obj).slice(8, -1) : protoTag ? "Object" : "", tag = (isPlainObject || "function" != typeof obj.constructor ? "" : obj.constructor.name ? obj.constructor.name + " " : "") + (stringTag || protoTag ? "[" + [].concat(stringTag || [], protoTag || []).join(": ") + "] " : "");
        return 0 === ys.length ? tag + "{}" : indent ? tag + "{" + $51679e17ad633b30$var$indentedJoin(ys, indent) + "}" : tag + "{ " + ys.join(", ") + " }";
    }
    return String(obj);
};
function $51679e17ad633b30$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = "double" === (opts.quoteStyle || defaultStyle) ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $51679e17ad633b30$var$quote(s) {
    return String(s).replace(/"/g, "&quot;");
}
function $51679e17ad633b30$var$isArray(obj) {
    return !("[object Array]" !== $51679e17ad633b30$var$toStr$1(obj) || $51679e17ad633b30$var$toStringTag && "object" == typeof obj && $51679e17ad633b30$var$toStringTag in obj);
}
function $51679e17ad633b30$var$isSymbol(obj) {
    if ($51679e17ad633b30$var$hasShammedSymbols) return obj && "object" == typeof obj && obj instanceof Symbol;
    if ("symbol" == typeof obj) return !0;
    if (!obj || "object" != typeof obj || !$51679e17ad633b30$var$symToString) return !1;
    try {
        return $51679e17ad633b30$var$symToString.call(obj), !0;
    } catch (e) {}
    return !1;
}
var $51679e17ad633b30$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $51679e17ad633b30$var$has(obj, key) {
    return $51679e17ad633b30$var$hasOwn.call(obj, key);
}
function $51679e17ad633b30$var$toStr$1(obj) {
    return $51679e17ad633b30$var$objectToString.call(obj);
}
function $51679e17ad633b30$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++)if (xs[i] === x) return i;
    return -1;
}
function $51679e17ad633b30$var$lowbyte(c) {
    var n = c.charCodeAt(0), x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    return x ? "\\" + x : "\\x" + (n < 16 ? "0" : "") + n.toString(16).toUpperCase();
}
function $51679e17ad633b30$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $51679e17ad633b30$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $51679e17ad633b30$var$collectionOf(type, size, entries, indent) {
    return type + " (" + size + ") {" + (indent ? $51679e17ad633b30$var$indentedJoin(entries, indent) : entries.join(", ")) + "}";
}
function $51679e17ad633b30$var$indentedJoin(xs, indent) {
    if (0 === xs.length) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
}
function $51679e17ad633b30$var$arrObjKeys(obj, inspect) {
    var isArr = $51679e17ad633b30$var$isArray(obj), xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $51679e17ad633b30$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var symMap, syms = "function" == typeof $51679e17ad633b30$var$gOPS ? $51679e17ad633b30$var$gOPS(obj) : [];
    if ($51679e17ad633b30$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj)$51679e17ad633b30$var$has(obj, key) && (isArr && String(Number(key)) === key && key < obj.length || $51679e17ad633b30$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol || (/[^\w$]/.test(key) ? xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj)) : xs.push(key + ": " + inspect(obj[key], obj))));
    if ("function" == typeof $51679e17ad633b30$var$gOPS) for(var j = 0; j < syms.length; j++)$51679e17ad633b30$var$isEnumerable.call(obj, syms[j]) && xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    return xs;
}
var $51679e17ad633b30$var$$TypeError$1 = $51679e17ad633b30$var$getIntrinsic("%TypeError%"), $51679e17ad633b30$var$$WeakMap = $51679e17ad633b30$var$getIntrinsic("%WeakMap%", !0), $51679e17ad633b30$var$$Map = $51679e17ad633b30$var$getIntrinsic("%Map%", !0), $51679e17ad633b30$var$$weakMapGet = $51679e17ad633b30$var$callBound("WeakMap.prototype.get", !0), $51679e17ad633b30$var$$weakMapSet = $51679e17ad633b30$var$callBound("WeakMap.prototype.set", !0), $51679e17ad633b30$var$$weakMapHas = $51679e17ad633b30$var$callBound("WeakMap.prototype.has", !0), $51679e17ad633b30$var$$mapGet = $51679e17ad633b30$var$callBound("Map.prototype.get", !0), $51679e17ad633b30$var$$mapSet = $51679e17ad633b30$var$callBound("Map.prototype.set", !0), $51679e17ad633b30$var$$mapHas = $51679e17ad633b30$var$callBound("Map.prototype.has", !0), $51679e17ad633b30$var$listGetNode = function(list, key) {
    for(var curr, prev = list; null !== (curr = prev.next); prev = curr)if (curr.key === key) return prev.next = curr.next, curr.next = list.next, list.next = curr, curr;
}, $51679e17ad633b30$var$sideChannel = function() {
    var $wm, $m, $o, channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $51679e17ad633b30$var$$TypeError$1("Side channel does not contain " + $51679e17ad633b30$var$objectInspect(key));
        },
        get: function(key) {
            if ($51679e17ad633b30$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
                if ($wm) return $51679e17ad633b30$var$$weakMapGet($wm, key);
            } else if ($51679e17ad633b30$var$$Map) {
                if ($m) return $51679e17ad633b30$var$$mapGet($m, key);
            } else if ($o) return function(objects, key) {
                var node = $51679e17ad633b30$var$listGetNode(objects, key);
                return node && node.value;
            }($o, key);
        },
        has: function(key) {
            if ($51679e17ad633b30$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
                if ($wm) return $51679e17ad633b30$var$$weakMapHas($wm, key);
            } else if ($51679e17ad633b30$var$$Map) {
                if ($m) return $51679e17ad633b30$var$$mapHas($m, key);
            } else if ($o) return function(objects, key) {
                return !!$51679e17ad633b30$var$listGetNode(objects, key);
            }($o, key);
            return !1;
        },
        set: function(key, value) {
            $51679e17ad633b30$var$$WeakMap && key && ("object" == typeof key || "function" == typeof key) ? ($wm || ($wm = new $51679e17ad633b30$var$$WeakMap), $51679e17ad633b30$var$$weakMapSet($wm, key, value)) : $51679e17ad633b30$var$$Map ? ($m || ($m = new $51679e17ad633b30$var$$Map), $51679e17ad633b30$var$$mapSet($m, key, value)) : ($o || ($o = {
                key: {},
                next: null
            }), function(objects, key, value) {
                var node = $51679e17ad633b30$var$listGetNode(objects, key);
                node ? node.value = value : objects.next = {
                    key: key,
                    next: objects.next,
                    value: value
                };
            }($o, key, value));
        }
    };
    return channel;
}, $51679e17ad633b30$var$replace = String.prototype.replace, $51679e17ad633b30$var$percentTwenties = /%20/g, $51679e17ad633b30$var$Format_RFC3986 = "RFC3986", $51679e17ad633b30$var$formats = {
    default: $51679e17ad633b30$var$Format_RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $51679e17ad633b30$var$replace.call(value, $51679e17ad633b30$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: "RFC1738",
    RFC3986: $51679e17ad633b30$var$Format_RFC3986
}, $51679e17ad633b30$var$has$1 = Object.prototype.hasOwnProperty, $51679e17ad633b30$var$isArray$1 = Array.isArray, $51679e17ad633b30$var$hexTable = function() {
    for(var array = [], i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}(), $51679e17ad633b30$var$arrayToObject = function(source, options) {
    for(var obj = options && options.plainObjects ? Object.create(null) : {}, i = 0; i < source.length; ++i)void 0 !== source[i] && (obj[i] = source[i]);
    return obj;
}, $51679e17ad633b30$var$utils = {
    arrayToObject: $51679e17ad633b30$var$arrayToObject,
    assign: function(target, source) {
        return Object.keys(source).reduce(function(acc, key) {
            return acc[key] = source[key], acc;
        }, target);
    },
    combine: function(a, b) {
        return [].concat(a, b);
    },
    compact: function(value) {
        for(var queue = [
            {
                obj: {
                    o: value
                },
                prop: "o"
            }
        ], refs = [], i = 0; i < queue.length; ++i)for(var item = queue[i], obj = item.obj[item.prop], keys = Object.keys(obj), j = 0; j < keys.length; ++j){
            var key = keys[j], val = obj[key];
            "object" == typeof val && null !== val && -1 === refs.indexOf(val) && (queue.push({
                obj: obj,
                prop: key
            }), refs.push(val));
        }
        return function(queue) {
            for(; queue.length > 1;){
                var item = queue.pop(), obj = item.obj[item.prop];
                if ($51679e17ad633b30$var$isArray$1(obj)) {
                    for(var compacted = [], j = 0; j < obj.length; ++j)void 0 !== obj[j] && compacted.push(obj[j]);
                    item.obj[item.prop] = compacted;
                }
            }
        }(queue), value;
    },
    decode: function(str, decoder, charset) {
        var strWithoutPlus = str.replace(/\+/g, " ");
        if ("iso-8859-1" === charset) return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
            return decodeURIComponent(strWithoutPlus);
        } catch (e) {
            return strWithoutPlus;
        }
    },
    encode: function(str, defaultEncoder, charset, kind, format) {
        if (0 === str.length) return str;
        var string = str;
        if ("symbol" == typeof str ? string = Symbol.prototype.toString.call(str) : "string" != typeof str && (string = String(str)), "iso-8859-1" === charset) return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
            return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
        });
        for(var out = "", i = 0; i < string.length; ++i){
            var c = string.charCodeAt(i);
            45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === $51679e17ad633b30$var$formats.RFC1738 && (40 === c || 41 === c) ? out += string.charAt(i) : c < 128 ? out += $51679e17ad633b30$var$hexTable[c] : c < 2048 ? out += $51679e17ad633b30$var$hexTable[192 | c >> 6] + $51679e17ad633b30$var$hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? out += $51679e17ad633b30$var$hexTable[224 | c >> 12] + $51679e17ad633b30$var$hexTable[128 | c >> 6 & 63] + $51679e17ad633b30$var$hexTable[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & string.charCodeAt(i)), out += $51679e17ad633b30$var$hexTable[240 | c >> 18] + $51679e17ad633b30$var$hexTable[128 | c >> 12 & 63] + $51679e17ad633b30$var$hexTable[128 | c >> 6 & 63] + $51679e17ad633b30$var$hexTable[128 | 63 & c]);
        }
        return out;
    },
    isBuffer: function(obj) {
        return !(!obj || "object" != typeof obj) && !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    },
    isRegExp: function(obj) {
        return "[object RegExp]" === Object.prototype.toString.call(obj);
    },
    maybeMap: function(val, fn) {
        if ($51679e17ad633b30$var$isArray$1(val)) {
            for(var mapped = [], i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
            return mapped;
        }
        return fn(val);
    },
    merge: function merge(target, source, options) {
        if (!source) return target;
        if ("object" != typeof source) {
            if ($51679e17ad633b30$var$isArray$1(target)) target.push(source);
            else {
                if (!target || "object" != typeof target) return [
                    target,
                    source
                ];
                (options && (options.plainObjects || options.allowPrototypes) || !$51679e17ad633b30$var$has$1.call(Object.prototype, source)) && (target[source] = !0);
            }
            return target;
        }
        if (!target || "object" != typeof target) return [
            target
        ].concat(source);
        var mergeTarget = target;
        return $51679e17ad633b30$var$isArray$1(target) && !$51679e17ad633b30$var$isArray$1(source) && (mergeTarget = $51679e17ad633b30$var$arrayToObject(target, options)), $51679e17ad633b30$var$isArray$1(target) && $51679e17ad633b30$var$isArray$1(source) ? (source.forEach(function(item, i) {
            if ($51679e17ad633b30$var$has$1.call(target, i)) {
                var targetItem = target[i];
                targetItem && "object" == typeof targetItem && item && "object" == typeof item ? target[i] = merge(targetItem, item, options) : target.push(item);
            } else target[i] = item;
        }), target) : Object.keys(source).reduce(function(acc, key) {
            var value = source[key];
            return $51679e17ad633b30$var$has$1.call(acc, key) ? acc[key] = merge(acc[key], value, options) : acc[key] = value, acc;
        }, mergeTarget);
    }
}, $51679e17ad633b30$var$has$2 = Object.prototype.hasOwnProperty, $51679e17ad633b30$var$arrayPrefixGenerators = {
    brackets: function(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function(prefix) {
        return prefix;
    }
}, $51679e17ad633b30$var$isArray$2 = Array.isArray, $51679e17ad633b30$var$push = Array.prototype.push, $51679e17ad633b30$var$pushToArray = function(arr, valueOrArray) {
    $51679e17ad633b30$var$push.apply(arr, $51679e17ad633b30$var$isArray$2(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
}, $51679e17ad633b30$var$toISO = Date.prototype.toISOString, $51679e17ad633b30$var$defaultFormat = $51679e17ad633b30$var$formats.default, $51679e17ad633b30$var$defaults = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: $51679e17ad633b30$var$utils.encode,
    encodeValuesOnly: !1,
    format: $51679e17ad633b30$var$defaultFormat,
    formatter: $51679e17ad633b30$var$formats.formatters[$51679e17ad633b30$var$defaultFormat],
    indices: !1,
    serializeDate: function(date) {
        return $51679e17ad633b30$var$toISO.call(date);
    },
    skipNulls: !1,
    strictNullHandling: !1
}, $51679e17ad633b30$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel$1) {
    var obj = object;
    if (sideChannel$1.has(object)) throw new RangeError("Cyclic object value");
    if ("function" == typeof filter ? obj = filter(prefix, obj) : obj instanceof Date ? obj = serializeDate(obj) : "comma" === generateArrayPrefix && $51679e17ad633b30$var$isArray$2(obj) && (obj = $51679e17ad633b30$var$utils.maybeMap(obj, function(value) {
        return value instanceof Date ? serializeDate(value) : value;
    })), null === obj) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $51679e17ad633b30$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (function(v) {
        return "string" == typeof v || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v;
    }(obj) || $51679e17ad633b30$var$utils.isBuffer(obj)) return encoder ? [
        formatter(encodeValuesOnly ? prefix : encoder(prefix, $51679e17ad633b30$var$defaults.encoder, charset, "key", format)) + "=" + formatter(encoder(obj, $51679e17ad633b30$var$defaults.encoder, charset, "value", format))
    ] : [
        formatter(prefix) + "=" + formatter(String(obj))
    ];
    var objKeys, values = [];
    if (void 0 === obj) return values;
    if ("comma" === generateArrayPrefix && $51679e17ad633b30$var$isArray$2(obj)) objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($51679e17ad633b30$var$isArray$2(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i], value = "object" == typeof key && void 0 !== key.value ? key.value : obj[key];
        if (!skipNulls || null !== value) {
            var keyPrefix = $51679e17ad633b30$var$isArray$2(obj) ? "function" == typeof generateArrayPrefix ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
            sideChannel$1.set(object, !0);
            var valueSideChannel = $51679e17ad633b30$var$sideChannel();
            $51679e17ad633b30$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
        }
    }
    return values;
}, $51679e17ad633b30$var$has$3 = Object.prototype.hasOwnProperty, $51679e17ad633b30$var$isArray$3 = Array.isArray, $51679e17ad633b30$var$defaults$1 = {
    allowDots: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: $51679e17ad633b30$var$utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
}, $51679e17ad633b30$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
}, $51679e17ad633b30$var$parseArrayValue = function(val, options) {
    return val && "string" == typeof val && options.comma && val.indexOf(",") > -1 ? val.split(",") : val;
}, $51679e17ad633b30$var$parseKeys = function(givenKey, val, options, valuesParsed) {
    if (givenKey) {
        var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey, child = /(\[[^[\]]*])/g, segment = options.depth > 0 && /(\[[^[\]]*])/.exec(key), parent = segment ? key.slice(0, segment.index) : key, keys = [];
        if (parent) {
            if (!options.plainObjects && $51679e17ad633b30$var$has$3.call(Object.prototype, parent) && !options.allowPrototypes) return;
            keys.push(parent);
        }
        for(var i = 0; options.depth > 0 && null !== (segment = child.exec(key)) && i < options.depth;){
            if (i += 1, !options.plainObjects && $51679e17ad633b30$var$has$3.call(Object.prototype, segment[1].slice(1, -1)) && !options.allowPrototypes) return;
            keys.push(segment[1]);
        }
        return segment && keys.push("[" + key.slice(segment.index) + "]"), function(chain, val, options, valuesParsed) {
            for(var leaf = valuesParsed ? val : $51679e17ad633b30$var$parseArrayValue(val, options), i = chain.length - 1; i >= 0; --i){
                var obj, root = chain[i];
                if ("[]" === root && options.parseArrays) obj = [].concat(leaf);
                else {
                    obj = options.plainObjects ? Object.create(null) : {};
                    var cleanRoot = "[" === root.charAt(0) && "]" === root.charAt(root.length - 1) ? root.slice(1, -1) : root, index = parseInt(cleanRoot, 10);
                    options.parseArrays || "" !== cleanRoot ? !isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit ? (obj = [])[index] = leaf : obj[cleanRoot] = leaf : obj = {
                        0: leaf
                    };
                }
                leaf = obj;
            }
            return leaf;
        }(keys, val, options, valuesParsed);
    }
}, $51679e17ad633b30$var$lib_parse = function(str, opts) {
    var options = function(opts) {
        if (!opts) return $51679e17ad633b30$var$defaults$1;
        if (null !== opts.decoder && void 0 !== opts.decoder && "function" != typeof opts.decoder) throw new TypeError("Decoder has to be a function.");
        if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var charset = void 0 === opts.charset ? $51679e17ad633b30$var$defaults$1.charset : opts.charset;
        return {
            allowDots: void 0 === opts.allowDots ? $51679e17ad633b30$var$defaults$1.allowDots : !!opts.allowDots,
            allowPrototypes: "boolean" == typeof opts.allowPrototypes ? opts.allowPrototypes : $51679e17ad633b30$var$defaults$1.allowPrototypes,
            allowSparse: "boolean" == typeof opts.allowSparse ? opts.allowSparse : $51679e17ad633b30$var$defaults$1.allowSparse,
            arrayLimit: "number" == typeof opts.arrayLimit ? opts.arrayLimit : $51679e17ad633b30$var$defaults$1.arrayLimit,
            charset: charset,
            charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : $51679e17ad633b30$var$defaults$1.charsetSentinel,
            comma: "boolean" == typeof opts.comma ? opts.comma : $51679e17ad633b30$var$defaults$1.comma,
            decoder: "function" == typeof opts.decoder ? opts.decoder : $51679e17ad633b30$var$defaults$1.decoder,
            delimiter: "string" == typeof opts.delimiter || $51679e17ad633b30$var$utils.isRegExp(opts.delimiter) ? opts.delimiter : $51679e17ad633b30$var$defaults$1.delimiter,
            depth: "number" == typeof opts.depth || !1 === opts.depth ? +opts.depth : $51679e17ad633b30$var$defaults$1.depth,
            ignoreQueryPrefix: !0 === opts.ignoreQueryPrefix,
            interpretNumericEntities: "boolean" == typeof opts.interpretNumericEntities ? opts.interpretNumericEntities : $51679e17ad633b30$var$defaults$1.interpretNumericEntities,
            parameterLimit: "number" == typeof opts.parameterLimit ? opts.parameterLimit : $51679e17ad633b30$var$defaults$1.parameterLimit,
            parseArrays: !1 !== opts.parseArrays,
            plainObjects: "boolean" == typeof opts.plainObjects ? opts.plainObjects : $51679e17ad633b30$var$defaults$1.plainObjects,
            strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : $51679e17ad633b30$var$defaults$1.strictNullHandling
        };
    }(opts);
    if ("" === str || null == str) return options.plainObjects ? Object.create(null) : {};
    for(var tempObj = "string" == typeof str ? function(str, options) {
        var i, obj = {}, cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str, limit = options.parameterLimit === 1 / 0 ? void 0 : options.parameterLimit, parts = cleanStr.split(options.delimiter, limit), skipIndex = -1, charset = options.charset;
        if (options.charsetSentinel) for(i = 0; i < parts.length; ++i)0 === parts[i].indexOf("utf8=") && ("utf8=%E2%9C%93" === parts[i] ? charset = "utf-8" : "utf8=%26%2310003%3B" === parts[i] && (charset = "iso-8859-1"), skipIndex = i, i = parts.length);
        for(i = 0; i < parts.length; ++i)if (i !== skipIndex) {
            var key, val, part = parts[i], bracketEqualsPos = part.indexOf("]="), pos = -1 === bracketEqualsPos ? part.indexOf("=") : bracketEqualsPos + 1;
            -1 === pos ? (key = options.decoder(part, $51679e17ad633b30$var$defaults$1.decoder, charset, "key"), val = options.strictNullHandling ? null : "") : (key = options.decoder(part.slice(0, pos), $51679e17ad633b30$var$defaults$1.decoder, charset, "key"), val = $51679e17ad633b30$var$utils.maybeMap($51679e17ad633b30$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $51679e17ad633b30$var$defaults$1.decoder, charset, "value");
            })), val && options.interpretNumericEntities && "iso-8859-1" === charset && (val = $51679e17ad633b30$var$interpretNumericEntities(val)), part.indexOf("[]=") > -1 && (val = $51679e17ad633b30$var$isArray$3(val) ? [
                val
            ] : val), $51679e17ad633b30$var$has$3.call(obj, key) ? obj[key] = $51679e17ad633b30$var$utils.combine(obj[key], val) : obj[key] = val;
        }
        return obj;
    }(str, options) : str, obj = options.plainObjects ? Object.create(null) : {}, keys = Object.keys(tempObj), i = 0; i < keys.length; ++i){
        var key = keys[i], newObj = $51679e17ad633b30$var$parseKeys(key, tempObj[key], options, "string" == typeof str);
        obj = $51679e17ad633b30$var$utils.merge(obj, newObj, options);
    }
    return !0 === options.allowSparse ? obj : $51679e17ad633b30$var$utils.compact(obj);
}, $51679e17ad633b30$var$lib_stringify = function(object, opts) {
    var objKeys, obj = object, options = function(opts) {
        if (!opts) return $51679e17ad633b30$var$defaults;
        if (null !== opts.encoder && void 0 !== opts.encoder && "function" != typeof opts.encoder) throw new TypeError("Encoder has to be a function.");
        var charset = opts.charset || $51679e17ad633b30$var$defaults.charset;
        if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var format = $51679e17ad633b30$var$formats.default;
        if (void 0 !== opts.format) {
            if (!$51679e17ad633b30$var$has$2.call($51679e17ad633b30$var$formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
            format = opts.format;
        }
        var formatter = $51679e17ad633b30$var$formats.formatters[format], filter = $51679e17ad633b30$var$defaults.filter;
        return ("function" == typeof opts.filter || $51679e17ad633b30$var$isArray$2(opts.filter)) && (filter = opts.filter), {
            addQueryPrefix: "boolean" == typeof opts.addQueryPrefix ? opts.addQueryPrefix : $51679e17ad633b30$var$defaults.addQueryPrefix,
            allowDots: void 0 === opts.allowDots ? $51679e17ad633b30$var$defaults.allowDots : !!opts.allowDots,
            charset: charset,
            charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : $51679e17ad633b30$var$defaults.charsetSentinel,
            delimiter: void 0 === opts.delimiter ? $51679e17ad633b30$var$defaults.delimiter : opts.delimiter,
            encode: "boolean" == typeof opts.encode ? opts.encode : $51679e17ad633b30$var$defaults.encode,
            encoder: "function" == typeof opts.encoder ? opts.encoder : $51679e17ad633b30$var$defaults.encoder,
            encodeValuesOnly: "boolean" == typeof opts.encodeValuesOnly ? opts.encodeValuesOnly : $51679e17ad633b30$var$defaults.encodeValuesOnly,
            filter: filter,
            format: format,
            formatter: formatter,
            serializeDate: "function" == typeof opts.serializeDate ? opts.serializeDate : $51679e17ad633b30$var$defaults.serializeDate,
            skipNulls: "boolean" == typeof opts.skipNulls ? opts.skipNulls : $51679e17ad633b30$var$defaults.skipNulls,
            sort: "function" == typeof opts.sort ? opts.sort : null,
            strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : $51679e17ad633b30$var$defaults.strictNullHandling
        };
    }(opts);
    "function" == typeof options.filter ? obj = (0, options.filter)("", obj) : $51679e17ad633b30$var$isArray$2(options.filter) && (objKeys = options.filter);
    var arrayFormat, keys = [];
    if ("object" != typeof obj || null === obj) return "";
    arrayFormat = opts && opts.arrayFormat in $51679e17ad633b30$var$arrayPrefixGenerators ? opts.arrayFormat : opts && "indices" in opts ? opts.indices ? "indices" : "repeat" : "indices";
    var generateArrayPrefix = $51679e17ad633b30$var$arrayPrefixGenerators[arrayFormat];
    objKeys || (objKeys = Object.keys(obj)), options.sort && objKeys.sort(options.sort);
    for(var sideChannel$1 = $51679e17ad633b30$var$sideChannel(), i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        options.skipNulls && null === obj[key] || $51679e17ad633b30$var$pushToArray(keys, $51679e17ad633b30$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel$1));
    }
    var joined = keys.join(options.delimiter), prefix = !0 === options.addQueryPrefix ? "?" : "";
    return options.charsetSentinel && ("iso-8859-1" === options.charset ? prefix += "utf8=%26%2310003%3B&" : prefix += "utf8=%E2%9C%93&"), joined.length > 0 ? prefix + joined : "";
}, $51679e17ad633b30$var$componentEmitter = $51679e17ad633b30$var$createCommonjsModule(function(module) {
    function Emitter(obj) {
        if (obj) return function(obj) {
            for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
            return obj;
        }(obj);
    }
    module.exports = Emitter, Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        return this._callbacks = this._callbacks || {}, (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn), this;
    }, Emitter.prototype.once = function(event, fn) {
        function on() {
            this.off(event, on), fn.apply(this, arguments);
        }
        return on.fn = fn, this.on(event, on), this;
    }, Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
        var cb, callbacks = this._callbacks["$" + event];
        if (!callbacks) return this;
        if (1 == arguments.length) return delete this._callbacks["$" + event], this;
        for(var i = 0; i < callbacks.length; i++)if ((cb = callbacks[i]) === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
        return 0 === callbacks.length && delete this._callbacks["$" + event], this;
    }, Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        for(var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event], i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
        if (callbacks) {
            i = 0;
            for(var len = (callbacks = callbacks.slice(0)).length; i < len; ++i)callbacks[i].apply(this, args);
        }
        return this;
    }, Emitter.prototype.listeners = function(event) {
        return this._callbacks = this._callbacks || {}, this._callbacks["$" + event] || [];
    }, Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
    };
}), $51679e17ad633b30$var$fastSafeStringify = $51679e17ad633b30$var$stringify$1;
$51679e17ad633b30$var$stringify$1.default = $51679e17ad633b30$var$stringify$1, $51679e17ad633b30$var$stringify$1.stable = $51679e17ad633b30$var$deterministicStringify, $51679e17ad633b30$var$stringify$1.stableStringify = $51679e17ad633b30$var$deterministicStringify;
var $51679e17ad633b30$var$arr = [], $51679e17ad633b30$var$replacerStack = [];
function $51679e17ad633b30$var$stringify$1(obj, replacer, spacer) {
    var res;
    for(!function decirc(val, k, stack, parent) {
        var i;
        if ("object" == typeof val && null !== val) {
            for(i = 0; i < stack.length; i++)if (stack[i] === val) {
                var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
                return void (void 0 !== propertyDescriptor.get ? propertyDescriptor.configurable ? (Object.defineProperty(parent, k, {
                    value: "[Circular]"
                }), $51679e17ad633b30$var$arr.push([
                    parent,
                    k,
                    val,
                    propertyDescriptor
                ])) : $51679e17ad633b30$var$replacerStack.push([
                    val,
                    k
                ]) : (parent[k] = "[Circular]", $51679e17ad633b30$var$arr.push([
                    parent,
                    k,
                    val
                ])));
            }
            if (stack.push(val), Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, stack, val);
            else {
                var keys = Object.keys(val);
                for(i = 0; i < keys.length; i++){
                    var key = keys[i];
                    decirc(val[key], key, stack, val);
                }
            }
            stack.pop();
        }
    }(obj, "", [], void 0), res = 0 === $51679e17ad633b30$var$replacerStack.length ? JSON.stringify(obj, replacer, spacer) : JSON.stringify(obj, $51679e17ad633b30$var$replaceGetterValues(replacer), spacer); 0 !== $51679e17ad633b30$var$arr.length;){
        var part = $51679e17ad633b30$var$arr.pop();
        4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
    }
    return res;
}
function $51679e17ad633b30$var$compareFunction(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $51679e17ad633b30$var$deterministicStringify(obj, replacer, spacer) {
    var res, tmp = function deterministicDecirc(val, k, stack, parent) {
        var i;
        if ("object" == typeof val && null !== val) {
            for(i = 0; i < stack.length; i++)if (stack[i] === val) {
                var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
                return void (void 0 !== propertyDescriptor.get ? propertyDescriptor.configurable ? (Object.defineProperty(parent, k, {
                    value: "[Circular]"
                }), $51679e17ad633b30$var$arr.push([
                    parent,
                    k,
                    val,
                    propertyDescriptor
                ])) : $51679e17ad633b30$var$replacerStack.push([
                    val,
                    k
                ]) : (parent[k] = "[Circular]", $51679e17ad633b30$var$arr.push([
                    parent,
                    k,
                    val
                ])));
            }
            if ("function" == typeof val.toJSON) return;
            if (stack.push(val), Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, stack, val);
            else {
                var tmp = {}, keys = Object.keys(val).sort($51679e17ad633b30$var$compareFunction);
                for(i = 0; i < keys.length; i++){
                    var key = keys[i];
                    deterministicDecirc(val[key], key, stack, val), tmp[key] = val[key];
                }
                if (void 0 === parent) return tmp;
                $51679e17ad633b30$var$arr.push([
                    parent,
                    k,
                    val
                ]), parent[k] = tmp;
            }
            stack.pop();
        }
    }(obj, "", [], void 0) || obj;
    for(res = 0 === $51679e17ad633b30$var$replacerStack.length ? JSON.stringify(tmp, replacer, spacer) : JSON.stringify(tmp, $51679e17ad633b30$var$replaceGetterValues(replacer), spacer); 0 !== $51679e17ad633b30$var$arr.length;){
        var part = $51679e17ad633b30$var$arr.pop();
        4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
    }
    return res;
}
function $51679e17ad633b30$var$replaceGetterValues(replacer) {
    return replacer = void 0 !== replacer ? replacer : function(k, v) {
        return v;
    }, function(key, val) {
        if ($51679e17ad633b30$var$replacerStack.length > 0) for(var i = 0; i < $51679e17ad633b30$var$replacerStack.length; i++){
            var part = $51679e17ad633b30$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = "[Circular]", $51679e17ad633b30$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}
function $51679e17ad633b30$var$_typeof(obj) {
    return ($51679e17ad633b30$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    })(obj);
}
var $51679e17ad633b30$var$isObject_1 = function(obj) {
    return null !== obj && "object" === $51679e17ad633b30$var$_typeof(obj);
};
function $51679e17ad633b30$var$_typeof$1(obj) {
    return ($51679e17ad633b30$var$_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    })(obj);
}
var $51679e17ad633b30$var$requestBase = $51679e17ad633b30$var$RequestBase;
function $51679e17ad633b30$var$RequestBase(obj) {
    if (obj) return function(obj) {
        for(var key in $51679e17ad633b30$var$RequestBase.prototype)Object.prototype.hasOwnProperty.call($51679e17ad633b30$var$RequestBase.prototype, key) && (obj[key] = $51679e17ad633b30$var$RequestBase.prototype[key]);
        return obj;
    }(obj);
}
$51679e17ad633b30$var$RequestBase.prototype.clearTimeout = function() {
    return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
}, $51679e17ad633b30$var$RequestBase.prototype.parse = function(fn) {
    return this._parser = fn, this;
}, $51679e17ad633b30$var$RequestBase.prototype.responseType = function(val) {
    return this._responseType = val, this;
}, $51679e17ad633b30$var$RequestBase.prototype.serialize = function(fn) {
    return this._serializer = fn, this;
}, $51679e17ad633b30$var$RequestBase.prototype.timeout = function(options) {
    if (!options || "object" !== $51679e17ad633b30$var$_typeof$1(options)) return this._timeout = options, this._responseTimeout = 0, this._uploadTimeout = 0, this;
    for(var option in options)if (Object.prototype.hasOwnProperty.call(options, option)) switch(option){
        case "deadline":
            this._timeout = options.deadline;
            break;
        case "response":
            this._responseTimeout = options.response;
            break;
        case "upload":
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn("Unknown timeout option", option);
    }
    return this;
}, $51679e17ad633b30$var$RequestBase.prototype.retry = function(count, fn) {
    return 0 !== arguments.length && !0 !== count || (count = 1), count <= 0 && (count = 0), this._maxRetries = count, this._retries = 0, this._retryCallback = fn, this;
};
var $51679e17ad633b30$var$ERROR_CODES = [
    "ECONNRESET",
    "ETIMEDOUT",
    "EADDRINFO",
    "ESOCKETTIMEDOUT"
];
$51679e17ad633b30$var$RequestBase.prototype._shouldRetry = function(err, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
    if (this._retryCallback) try {
        var override = this._retryCallback(err, res);
        if (!0 === override) return !0;
        if (!1 === override) return !1;
    } catch (err_) {
        console.error(err_);
    }
    if (res && res.status && res.status >= 500 && 501 !== res.status) return !0;
    if (err) {
        if (err.code && $51679e17ad633b30$var$ERROR_CODES.includes(err.code)) return !0;
        if (err.timeout && "ECONNABORTED" === err.code) return !0;
        if (err.crossDomain) return !0;
    }
    return !1;
}, $51679e17ad633b30$var$RequestBase.prototype._retry = function() {
    return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
}, $51679e17ad633b30$var$RequestBase.prototype.then = function(resolve, reject) {
    var _this = this;
    if (!this._fullfilledPromise) {
        var self1 = this;
        this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function(resolve, reject) {
            self1.on("abort", function() {
                if (!(_this._maxRetries && _this._maxRetries > _this._retries)) {
                    if (_this.timedout && _this.timedoutError) reject(_this.timedoutError);
                    else {
                        var err = new Error("Aborted");
                        err.code = "ABORTED", err.status = _this.status, err.method = _this.method, err.url = _this.url, reject(err);
                    }
                }
            }), self1.end(function(err, res) {
                err ? reject(err) : resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
}, $51679e17ad633b30$var$RequestBase.prototype.catch = function(cb) {
    return this.then(void 0, cb);
}, $51679e17ad633b30$var$RequestBase.prototype.use = function(fn) {
    return fn(this), this;
}, $51679e17ad633b30$var$RequestBase.prototype.ok = function(cb) {
    if ("function" != typeof cb) throw new Error("Callback required");
    return this._okCallback = cb, this;
}, $51679e17ad633b30$var$RequestBase.prototype._isResponseOK = function(res) {
    return !!res && (this._okCallback ? this._okCallback(res) : res.status >= 200 && res.status < 300);
}, $51679e17ad633b30$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
}, $51679e17ad633b30$var$RequestBase.prototype.getHeader = $51679e17ad633b30$var$RequestBase.prototype.get, $51679e17ad633b30$var$RequestBase.prototype.set = function(field, val) {
    if ($51679e17ad633b30$var$isObject_1(field)) {
        for(var key in field)Object.prototype.hasOwnProperty.call(field, key) && this.set(key, field[key]);
        return this;
    }
    return this._header[field.toLowerCase()] = val, this.header[field] = val, this;
}, $51679e17ad633b30$var$RequestBase.prototype.unset = function(field) {
    return delete this._header[field.toLowerCase()], delete this.header[field], this;
}, $51679e17ad633b30$var$RequestBase.prototype.field = function(name, val) {
    if (null == name) throw new Error(".field(name, val) name can not be empty");
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($51679e17ad633b30$var$isObject_1(name)) {
        for(var key in name)Object.prototype.hasOwnProperty.call(name, key) && this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(val)) {
        for(var i in val)Object.prototype.hasOwnProperty.call(val, i) && this.field(name, val[i]);
        return this;
    }
    if (null == val) throw new Error(".field(name, val) val can not be empty");
    return "boolean" == typeof val && (val = String(val)), this._getFormData().append(name, val), this;
}, $51679e17ad633b30$var$RequestBase.prototype.abort = function() {
    return this._aborted || (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort")), this;
}, $51679e17ad633b30$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case "basic":
            this.set("Authorization", "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
            break;
        case "auto":
            this.username = user, this.password = pass;
            break;
        case "bearer":
            this.set("Authorization", "Bearer ".concat(user));
    }
    return this;
}, $51679e17ad633b30$var$RequestBase.prototype.withCredentials = function(on) {
    return void 0 === on && (on = !0), this._withCredentials = on, this;
}, $51679e17ad633b30$var$RequestBase.prototype.redirects = function(n) {
    return this._maxRedirects = n, this;
}, $51679e17ad633b30$var$RequestBase.prototype.maxResponseSize = function(n) {
    if ("number" != typeof n) throw new TypeError("Invalid argument");
    return this._maxResponseSize = n, this;
}, $51679e17ad633b30$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
}, $51679e17ad633b30$var$RequestBase.prototype.send = function(data) {
    var isObj = $51679e17ad633b30$var$isObject_1(data), type = this._header["content-type"];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObj && !this._data) Array.isArray(data) ? this._data = [] : this._isHost(data) || (this._data = {});
    else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    if (isObj && $51679e17ad633b30$var$isObject_1(this._data)) for(var key in data)Object.prototype.hasOwnProperty.call(data, key) && (this._data[key] = data[key]);
    else "string" == typeof data ? (type || this.type("form"), type = this._header["content-type"], this._data = "application/x-www-form-urlencoded" === type ? this._data ? "".concat(this._data, "&").concat(data) : data : (this._data || "") + data) : this._data = data;
    return !isObj || this._isHost(data) || type || this.type("json"), this;
}, $51679e17ad633b30$var$RequestBase.prototype.sortQuery = function(sort) {
    return this._sort = void 0 === sort || sort, this;
}, $51679e17ad633b30$var$RequestBase.prototype._finalizeQueryString = function() {
    var query = this._query.join("&");
    if (query && (this.url += (this.url.includes("?") ? "&" : "?") + query), this._query.length = 0, this._sort) {
        var index = this.url.indexOf("?");
        if (index >= 0) {
            var queryArr = this.url.slice(index + 1).split("&");
            "function" == typeof this._sort ? queryArr.sort(this._sort) : queryArr.sort(), this.url = this.url.slice(0, index) + "?" + queryArr.join("&");
        }
    }
}, $51679e17ad633b30$var$RequestBase.prototype._appendQueryString = function() {
    console.warn("Unsupported");
}, $51679e17ad633b30$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (!this._aborted) {
        var err = new Error("".concat(reason + timeout, "ms exceeded"));
        err.timeout = timeout, err.code = "ECONNABORTED", err.errno = errno, this.timedout = !0, this.timedoutError = err, this.abort(), this.callback(err);
    }
}, $51679e17ad633b30$var$RequestBase.prototype._setTimeouts = function() {
    var self1 = this;
    this._timeout && !this._timer && (this._timer = setTimeout(function() {
        self1._timeoutError("Timeout of ", self1._timeout, "ETIME");
    }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function() {
        self1._timeoutError("Response timeout of ", self1._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout));
};
var $51679e17ad633b30$var$utils$1_type = function(str) {
    return str.split(/ *; */).shift();
}, $51679e17ad633b30$var$utils$1_params = function(str) {
    return str.split(/ *; */).reduce(function(obj, str) {
        var parts = str.split(/ *= */), key = parts.shift(), val = parts.shift();
        return key && val && (obj[key] = val), obj;
    }, {});
}, $51679e17ad633b30$var$utils$1_parseLinks = function(str) {
    return str.split(/ *, */).reduce(function(obj, str) {
        var parts = str.split(/ *; */), url = parts[0].slice(1, -1);
        return obj[parts[1].split(/ *= */)[1].slice(1, -1)] = url, obj;
    }, {});
}, $51679e17ad633b30$var$responseBase = $51679e17ad633b30$var$ResponseBase;
function $51679e17ad633b30$var$ResponseBase(obj) {
    if (obj) return function(obj) {
        for(var key in $51679e17ad633b30$var$ResponseBase.prototype)Object.prototype.hasOwnProperty.call($51679e17ad633b30$var$ResponseBase.prototype, key) && (obj[key] = $51679e17ad633b30$var$ResponseBase.prototype[key]);
        return obj;
    }(obj);
}
function $51679e17ad633b30$var$_toConsumableArray(arr) {
    return function(arr) {
        if (Array.isArray(arr)) return $51679e17ad633b30$var$_arrayLikeToArray(arr);
    }(arr) || function(iter) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
    }(arr) || function(o, minLen) {
        if (!o) return;
        if ("string" == typeof o) return $51679e17ad633b30$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        "Object" === n && o.constructor && (n = o.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(o);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51679e17ad633b30$var$_arrayLikeToArray(o, minLen);
    }(arr) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $51679e17ad633b30$var$_arrayLikeToArray(arr, len) {
    (null == len || len > arr.length) && (len = arr.length);
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $51679e17ad633b30$var$Agent() {
    this._defaults = [];
}
$51679e17ad633b30$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
}, $51679e17ad633b30$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    var ct = header["content-type"] || "";
    this.type = $51679e17ad633b30$var$utils$1_type(ct);
    var params = $51679e17ad633b30$var$utils$1_params(ct);
    for(var key in params)Object.prototype.hasOwnProperty.call(params, key) && (this[key] = params[key]);
    this.links = {};
    try {
        header.link && (this.links = $51679e17ad633b30$var$utils$1_parseLinks(header.link));
    } catch (_unused) {}
}, $51679e17ad633b30$var$ResponseBase.prototype._setStatusProperties = function(status) {
    var type = status / 100 | 0;
    this.statusCode = status, this.status = this.statusCode, this.statusType = type, this.info = 1 === type, this.ok = 2 === type, this.redirect = 3 === type, this.clientError = 4 === type, this.serverError = 5 === type, this.error = (4 === type || 5 === type) && this.toError(), this.created = 201 === status, this.accepted = 202 === status, this.noContent = 204 === status, this.badRequest = 400 === status, this.unauthorized = 401 === status, this.notAcceptable = 406 === status, this.forbidden = 403 === status, this.notFound = 404 === status, this.unprocessableEntity = 422 === status;
}, [
    "use",
    "on",
    "once",
    "set",
    "query",
    "type",
    "accept",
    "auth",
    "withCredentials",
    "sortQuery",
    "retry",
    "ok",
    "redirects",
    "timeout",
    "buffer",
    "serialize",
    "parse",
    "ca",
    "key",
    "pfx",
    "cert",
    "disableTLSCerts"
].forEach(function(fn) {
    $51679e17ad633b30$var$Agent.prototype[fn] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this._defaults.push({
            fn: fn,
            args: args
        }), this;
    };
}), $51679e17ad633b30$var$Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
        req[def.fn].apply(req, $51679e17ad633b30$var$_toConsumableArray(def.args));
    });
};
for(var $51679e17ad633b30$var$agentBase = $51679e17ad633b30$var$Agent, $51679e17ad633b30$var$client = $51679e17ad633b30$var$createCommonjsModule(function(module, exports) {
    function _typeof(obj) {
        return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        })(obj);
    }
    var root;
    function noop() {}
    "undefined" != typeof window ? root = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), root = void 0) : root = self, module.exports = function(method, url) {
        return "function" == typeof url ? new exports.Request("GET", method).end(url) : 1 === arguments.length ? new exports.Request("GET", method) : new exports.Request(method, url);
    };
    var request = exports = module.exports;
    exports.Request = Request, request.getXHR = function() {
        if (root.XMLHttpRequest && (!root.location || "file:" !== root.location.protocol || !root.ActiveXObject)) return new XMLHttpRequest;
        try {
            return new ActiveXObject("Microsoft.XMLHTTP");
        } catch (_unused) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP.6.0");
        } catch (_unused2) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP.3.0");
        } catch (_unused3) {}
        try {
            return new ActiveXObject("Msxml2.XMLHTTP");
        } catch (_unused4) {}
        throw new Error("Browser-only version of superagent could not find XHR");
    };
    var trim = "".trim ? function(s) {
        return s.trim();
    } : function(s) {
        return s.replace(/(^\s*|\s*$)/g, "");
    };
    function serialize(obj) {
        if (!$51679e17ad633b30$var$isObject_1(obj)) return obj;
        var pairs = [];
        for(var key in obj)Object.prototype.hasOwnProperty.call(obj, key) && pushEncodedKeyValuePair(pairs, key, obj[key]);
        return pairs.join("&");
    }
    function pushEncodedKeyValuePair(pairs, key, val) {
        if (void 0 !== val) {
            if (null !== val) {
                if (Array.isArray(val)) val.forEach(function(v) {
                    pushEncodedKeyValuePair(pairs, key, v);
                });
                else if ($51679e17ad633b30$var$isObject_1(val)) for(var subkey in val)Object.prototype.hasOwnProperty.call(val, subkey) && pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), val[subkey]);
                else pairs.push(encodeURI(key) + "=" + encodeURIComponent(val));
            } else pairs.push(encodeURI(key));
        }
    }
    function parseString(str) {
        for(var pair, pos, obj = {}, pairs = str.split("&"), i = 0, len = pairs.length; i < len; ++i)-1 === (pos = (pair = pairs[i]).indexOf("=")) ? obj[decodeURIComponent(pair)] = "" : obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
        return obj;
    }
    function isJSON(mime) {
        return /[/+]json($|[^-\w])/.test(mime);
    }
    function Response(req) {
        this.req = req, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
        var status = this.xhr.status;
        1223 === status && (status = 204), this._setStatusProperties(status), this.headers = function(str) {
            for(var index, line, field, val, lines = str.split(/\r?\n/), fields = {}, i = 0, len = lines.length; i < len; ++i)-1 !== (index = (line = lines[i]).indexOf(":")) && (field = line.slice(0, index).toLowerCase(), val = trim(line.slice(index + 1)), fields[field] = val);
            return fields;
        }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && req._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
    }
    function Request(method, url) {
        var self1 = this;
        this._query = this._query || [], this.method = method, this.url = url, this.header = {}, this._header = {}, this.on("end", function() {
            var new_err, err = null, res = null;
            try {
                res = new Response(self1);
            } catch (err_) {
                return (err = new Error("Parser is unable to parse the response")).parse = !0, err.original = err_, self1.xhr ? (err.rawResponse = void 0 === self1.xhr.responseType ? self1.xhr.responseText : self1.xhr.response, err.status = self1.xhr.status ? self1.xhr.status : null, err.statusCode = err.status) : (err.rawResponse = null, err.status = null), self1.callback(err);
            }
            self1.emit("response", res);
            try {
                self1._isResponseOK(res) || (new_err = new Error(res.statusText || res.text || "Unsuccessful HTTP response"));
            } catch (err_) {
                new_err = err_;
            }
            new_err ? (new_err.original = err, new_err.response = res, new_err.status = res.status, self1.callback(new_err, res)) : self1.callback(null, res);
        });
    }
    function del(url, data, fn) {
        var req = request("DELETE", url);
        return "function" == typeof data && (fn = data, data = null), data && req.send(data), fn && req.end(fn), req;
    }
    request.serializeObject = serialize, request.parseString = parseString, request.types = {
        html: "text/html",
        json: "application/json",
        xml: "text/xml",
        urlencoded: "application/x-www-form-urlencoded",
        form: "application/x-www-form-urlencoded",
        "form-data": "application/x-www-form-urlencoded"
    }, request.serialize = {
        "application/x-www-form-urlencoded": serialize,
        "application/json": $51679e17ad633b30$var$fastSafeStringify
    }, request.parse = {
        "application/x-www-form-urlencoded": parseString,
        "application/json": JSON.parse
    }, $51679e17ad633b30$var$responseBase(Response.prototype), Response.prototype._parseBody = function(str) {
        var parse = request.parse[this.type];
        return this.req._parser ? this.req._parser(this, str) : (!parse && isJSON(this.type) && (parse = request.parse["application/json"]), parse && str && (str.length > 0 || str instanceof Object) ? parse(str) : null);
    }, Response.prototype.toError = function() {
        var req = this.req, method = req.method, url = req.url, msg = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")"), err = new Error(msg);
        return err.status = this.status, err.method = method, err.url = url, err;
    }, request.Response = Response, $51679e17ad633b30$var$componentEmitter(Request.prototype), $51679e17ad633b30$var$requestBase(Request.prototype), Request.prototype.type = function(type) {
        return this.set("Content-Type", request.types[type] || type), this;
    }, Request.prototype.accept = function(type) {
        return this.set("Accept", request.types[type] || type), this;
    }, Request.prototype.auth = function(user, pass, options) {
        1 === arguments.length && (pass = ""), "object" === _typeof(pass) && null !== pass && (options = pass, pass = ""), options || (options = {
            type: "function" == typeof btoa ? "basic" : "auto"
        });
        var encoder = function(string) {
            if ("function" == typeof btoa) return btoa(string);
            throw new Error("Cannot use basic auth, btoa is not a function");
        };
        return this._auth(user, pass, options, encoder);
    }, Request.prototype.query = function(val) {
        return "string" != typeof val && (val = serialize(val)), val && this._query.push(val), this;
    }, Request.prototype.attach = function(field, file, options) {
        if (file) {
            if (this._data) throw new Error("superagent can't mix .send() and .attach()");
            this._getFormData().append(field, file, options || file.name);
        }
        return this;
    }, Request.prototype._getFormData = function() {
        return this._formData || (this._formData = new root.FormData), this._formData;
    }, Request.prototype.callback = function(err, res) {
        if (this._shouldRetry(err, res)) return this._retry();
        var fn = this._callback;
        this.clearTimeout(), err && (this._maxRetries && (err.retries = this._retries - 1), this.emit("error", err)), fn(err, res);
    }, Request.prototype.crossDomainError = function() {
        var err = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
        err.crossDomain = !0, err.status = this.status, err.method = this.method, err.url = this.url, this.callback(err);
    }, Request.prototype.agent = function() {
        return console.warn("This is not supported in browser version of superagent"), this;
    }, Request.prototype.ca = Request.prototype.agent, Request.prototype.buffer = Request.prototype.ca, Request.prototype.write = function() {
        throw new Error("Streaming is not supported in browser version of superagent");
    }, Request.prototype.pipe = Request.prototype.write, Request.prototype._isHost = function(obj) {
        return obj && "object" === _typeof(obj) && !Array.isArray(obj) && "[object Object]" !== Object.prototype.toString.call(obj);
    }, Request.prototype.end = function(fn) {
        this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = fn || noop, this._finalizeQueryString(), this._end();
    }, Request.prototype._setUploadTimeout = function() {
        var self1 = this;
        this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function() {
            self1._timeoutError("Upload timeout of ", self1._uploadTimeout, "ETIMEDOUT");
        }, this._uploadTimeout));
    }, Request.prototype._end = function() {
        if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
        var self1 = this;
        this.xhr = request.getXHR();
        var xhr = this.xhr, data = this._formData || this._data;
        this._setTimeouts(), xhr.onreadystatechange = function() {
            var readyState = xhr.readyState;
            if (readyState >= 2 && self1._responseTimeoutTimer && clearTimeout(self1._responseTimeoutTimer), 4 === readyState) {
                var status;
                try {
                    status = xhr.status;
                } catch (_unused5) {
                    status = 0;
                }
                if (!status) {
                    if (self1.timedout || self1._aborted) return;
                    return self1.crossDomainError();
                }
                self1.emit("end");
            }
        };
        var handleProgress = function(direction, e) {
            e.total > 0 && (e.percent = e.loaded / e.total * 100, 100 === e.percent && clearTimeout(self1._uploadTimeoutTimer)), e.direction = direction, self1.emit("progress", e);
        };
        if (this.hasListeners("progress")) try {
            xhr.addEventListener("progress", handleProgress.bind(null, "download")), xhr.upload && xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
        } catch (_unused6) {}
        xhr.upload && this._setUploadTimeout();
        try {
            this.username && this.password ? xhr.open(this.method, this.url, !0, this.username, this.password) : xhr.open(this.method, this.url, !0);
        } catch (err) {
            return this.callback(err);
        }
        if (this._withCredentials && (xhr.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof data && !this._isHost(data)) {
            var contentType = this._header["content-type"], _serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
            !_serialize && isJSON(contentType) && (_serialize = request.serialize["application/json"]), _serialize && (data = _serialize(data));
        }
        for(var field in this.header)null !== this.header[field] && Object.prototype.hasOwnProperty.call(this.header, field) && xhr.setRequestHeader(field, this.header[field]);
        this._responseType && (xhr.responseType = this._responseType), this.emit("request", this), xhr.send(void 0 === data ? null : data);
    }, request.agent = function() {
        return new $51679e17ad633b30$var$agentBase;
    }, [
        "GET",
        "POST",
        "OPTIONS",
        "PATCH",
        "PUT",
        "DELETE"
    ].forEach(function(method) {
        $51679e17ad633b30$var$agentBase.prototype[method.toLowerCase()] = function(url, fn) {
            var req = new request.Request(method, url);
            return this._setDefaults(req), fn && req.end(fn), req;
        };
    }), $51679e17ad633b30$var$agentBase.prototype.del = $51679e17ad633b30$var$agentBase.prototype.delete, request.get = function(url, data, fn) {
        var req = request("GET", url);
        return "function" == typeof data && (fn = data, data = null), data && req.query(data), fn && req.end(fn), req;
    }, request.head = function(url, data, fn) {
        var req = request("HEAD", url);
        return "function" == typeof data && (fn = data, data = null), data && req.query(data), fn && req.end(fn), req;
    }, request.options = function(url, data, fn) {
        var req = request("OPTIONS", url);
        return "function" == typeof data && (fn = data, data = null), data && req.send(data), fn && req.end(fn), req;
    }, request.del = del, request.delete = del, request.patch = function(url, data, fn) {
        var req = request("PATCH", url);
        return "function" == typeof data && (fn = data, data = null), data && req.send(data), fn && req.end(fn), req;
    }, request.post = function(url, data, fn) {
        var req = request("POST", url);
        return "function" == typeof data && (fn = data, data = null), data && req.send(data), fn && req.end(fn), req;
    }, request.put = function(url, data, fn) {
        var req = request("PUT", url);
        return "function" == typeof data && (fn = data, data = null), data && req.send(data), fn && req.end(fn), req;
    };
}), $51679e17ad633b30$var$byteLength_1 = ($51679e17ad633b30$var$client.Request, function(b64) {
    var lens = $51679e17ad633b30$var$getLens(b64), validLen = lens[0], placeHoldersLen = lens[1];
    return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
}), $51679e17ad633b30$var$toByteArray_1 = function(b64) {
    var tmp, i, lens = $51679e17ad633b30$var$getLens(b64), validLen = lens[0], placeHoldersLen = lens[1], arr = new $51679e17ad633b30$var$Arr(function(b64, validLen, placeHoldersLen) {
        return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
    }(0, validLen, placeHoldersLen)), curByte = 0, len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for(i = 0; i < len; i += 4)tmp = $51679e17ad633b30$var$revLookup[b64.charCodeAt(i)] << 18 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 3)], arr[curByte++] = tmp >> 16 & 255, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp;
    2 === placeHoldersLen && (tmp = $51679e17ad633b30$var$revLookup[b64.charCodeAt(i)] << 2 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 1)] >> 4, arr[curByte++] = 255 & tmp);
    1 === placeHoldersLen && (tmp = $51679e17ad633b30$var$revLookup[b64.charCodeAt(i)] << 10 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $51679e17ad633b30$var$revLookup[b64.charCodeAt(i + 2)] >> 2, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp);
    return arr;
}, $51679e17ad633b30$var$fromByteArray_1 = function(uint8) {
    for(var tmp, len = uint8.length, extraBytes = len % 3, parts = [], i = 0, len2 = len - extraBytes; i < len2; i += 16383)parts.push($51679e17ad633b30$var$encodeChunk(uint8, i, i + 16383 > len2 ? len2 : i + 16383));
    1 === extraBytes ? (tmp = uint8[len - 1], parts.push($51679e17ad633b30$var$lookup[tmp >> 2] + $51679e17ad633b30$var$lookup[tmp << 4 & 63] + "==")) : 2 === extraBytes && (tmp = (uint8[len - 2] << 8) + uint8[len - 1], parts.push($51679e17ad633b30$var$lookup[tmp >> 10] + $51679e17ad633b30$var$lookup[tmp >> 4 & 63] + $51679e17ad633b30$var$lookup[tmp << 2 & 63] + "="));
    return parts.join("");
}, $51679e17ad633b30$var$lookup = [], $51679e17ad633b30$var$revLookup = [], $51679e17ad633b30$var$Arr = "undefined" != typeof Uint8Array ? Uint8Array : Array, $51679e17ad633b30$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $51679e17ad633b30$var$i = 0, $51679e17ad633b30$var$len = $51679e17ad633b30$var$code.length; $51679e17ad633b30$var$i < $51679e17ad633b30$var$len; ++$51679e17ad633b30$var$i)$51679e17ad633b30$var$lookup[$51679e17ad633b30$var$i] = $51679e17ad633b30$var$code[$51679e17ad633b30$var$i], $51679e17ad633b30$var$revLookup[$51679e17ad633b30$var$code.charCodeAt($51679e17ad633b30$var$i)] = $51679e17ad633b30$var$i;
function $51679e17ad633b30$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var validLen = b64.indexOf("=");
    return -1 === validLen && (validLen = len), [
        validLen,
        validLen === len ? 0 : 4 - validLen % 4
    ];
}
function $51679e17ad633b30$var$encodeChunk(uint8, start, end) {
    for(var tmp, num, output = [], i = start; i < end; i += 3)tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (255 & uint8[i + 2]), output.push($51679e17ad633b30$var$lookup[(num = tmp) >> 18 & 63] + $51679e17ad633b30$var$lookup[num >> 12 & 63] + $51679e17ad633b30$var$lookup[num >> 6 & 63] + $51679e17ad633b30$var$lookup[63 & num]);
    return output.join("");
}
$51679e17ad633b30$var$revLookup["-".charCodeAt(0)] = 62, $51679e17ad633b30$var$revLookup["_".charCodeAt(0)] = 63;
var $51679e17ad633b30$var$base64Js = {
    byteLength: $51679e17ad633b30$var$byteLength_1,
    toByteArray: $51679e17ad633b30$var$toByteArray_1,
    fromByteArray: $51679e17ad633b30$var$fromByteArray_1
};
var $51679e17ad633b30$var$base64Url = {
    encode: function(str) {
        return $51679e17ad633b30$var$base64Js.fromByteArray(function(str) {
            for(var arr = new Array(str.length), a = 0; a < str.length; a++)arr[a] = str.charCodeAt(a);
            return arr;
        }(str)).replace(/\+/g, "-").replace(/\//g, "_");
    },
    decode: function(str) {
        return str = (function(str) {
            var mod = str.length % 4;
            return 0 === mod ? str : str + new Array(1 + (4 - mod)).join("=");
        })(str).replace(/-/g, "+").replace(/_/g, "/"), function(array) {
            for(var result = "", i = 0; i < array.length; i++)result += String.fromCharCode(array[i]);
            return result;
        }($51679e17ad633b30$var$base64Js.toByteArray(str));
    }
}, $51679e17ad633b30$export$83d89fbfd8236492 = {
    raw: "9.16.4"
}, $51679e17ad633b30$var$toString = Object.prototype.toString;
function $51679e17ad633b30$var$attribute(o, attr, type, text) {
    if (type = "array" === type ? "object" : type, o && typeof o[attr] !== type) throw new Error(text);
}
function $51679e17ad633b30$var$variable(o, type, text) {
    if (typeof o !== type) throw new Error(text);
}
function $51679e17ad633b30$var$value(o, values, text) {
    if (-1 === values.indexOf(o)) throw new Error(text);
}
var $51679e17ad633b30$var$assert = {
    check: function(o, config, attributes) {
        if (config.optional && !o || $51679e17ad633b30$var$variable(o, config.type, config.message), "object" === config.type && attributes) for(var keys = Object.keys(attributes), index = 0; index < keys.length; index++){
            var a = keys[index];
            attributes[a].optional && !o[a] || attributes[a].condition && !attributes[a].condition(o) || ($51679e17ad633b30$var$attribute(o, a, attributes[a].type, attributes[a].message), attributes[a].values && $51679e17ad633b30$var$value(o[a], attributes[a].values, attributes[a].value_message));
        }
    },
    attribute: $51679e17ad633b30$var$attribute,
    variable: $51679e17ad633b30$var$variable,
    value: $51679e17ad633b30$var$value,
    isArray: function(array) {
        return this.supportsIsArray() ? Array.isArray(array) : "[object Array]" === $51679e17ad633b30$var$toString.call(array);
    },
    supportsIsArray: function() {
        return null != Array.isArray;
    }
};
function $51679e17ad633b30$var$objectAssignPolyfill(target) {
    if (null == target) throw new TypeError("Cannot convert first argument to object");
    for(var to = Object(target), i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (null != nextSource) for(var keysArray = Object.keys(Object(nextSource)), nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex], desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            void 0 !== desc && desc.enumerable && (to[nextKey] = nextSource[nextKey]);
        }
    }
    return to;
}
var $51679e17ad633b30$var$objectAssign = {
    get: function() {
        return Object.assign ? Object.assign : $51679e17ad633b30$var$objectAssignPolyfill;
    },
    objectAssignPolyfill: $51679e17ad633b30$var$objectAssignPolyfill
};
function $51679e17ad633b30$var$pick(object, keys) {
    return keys.reduce(function(prev, key) {
        return object[key] && (prev[key] = object[key]), prev;
    }, {});
}
function $51679e17ad633b30$var$objectValues(obj) {
    var values = [];
    for(var key in obj)values.push(obj[key]);
    return values;
}
function $51679e17ad633b30$var$extend() {
    var params = $51679e17ad633b30$var$objectValues(arguments);
    return params.unshift({}), $51679e17ad633b30$var$objectAssign.get().apply(void 0, params);
}
function $51679e17ad633b30$var$getLocationFromUrl(href) {
    var match = href.match(/^(https?:|file:|chrome-extension:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
}
function $51679e17ad633b30$var$trim(options, key) {
    var trimmed = $51679e17ad633b30$var$extend(options);
    return options[key] && (trimmed[key] = options[key].trim()), trimmed;
}
var $51679e17ad633b30$var$objectHelper = {
    toSnakeCase: function toSnakeCase(object, exceptions) {
        return "object" != typeof object || $51679e17ad633b30$var$assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function(p, key) {
            return p[-1 === exceptions.indexOf(key) ? function(str) {
                for(var code, newKey = "", index = 0, wasPrevNumber = !0, wasPrevUppercase = !0; index < str.length;)code = str.charCodeAt(index), !wasPrevUppercase && code >= 65 && code <= 90 || !wasPrevNumber && code >= 48 && code <= 57 ? (newKey += "_", newKey += str[index].toLowerCase()) : newKey += str[index].toLowerCase(), wasPrevNumber = code >= 48 && code <= 57, wasPrevUppercase = code >= 65 && code <= 90, index++;
                return newKey;
            }(key) : key] = toSnakeCase(object[key]), p;
        }, {}));
    },
    toCamelCase: function toCamelCase(object, exceptions, options) {
        return "object" != typeof object || $51679e17ad633b30$var$assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], options = options || {}, Object.keys(object).reduce(function(p, key) {
            var parts, newKey = -1 === exceptions.indexOf(key) ? (parts = key.split("_")).reduce(function(p, c) {
                return p + c.charAt(0).toUpperCase() + c.slice(1);
            }, parts.shift()) : key;
            return p[newKey] = toCamelCase(object[newKey] || object[key], [], options), options.keepOriginal && (p[key] = toCamelCase(object[key], [], options)), p;
        }, {}));
    },
    blacklist: function(object, blacklistedKeys) {
        return Object.keys(object).reduce(function(p, key) {
            return -1 === blacklistedKeys.indexOf(key) && (p[key] = object[key]), p;
        }, {});
    },
    merge: function(object, keys) {
        return {
            base: keys ? $51679e17ad633b30$var$pick(object, keys) : object,
            with: function(object2, keys2) {
                return object2 = keys2 ? $51679e17ad633b30$var$pick(object2, keys2) : object2, $51679e17ad633b30$var$extend(this.base, object2);
            }
        };
    },
    pick: $51679e17ad633b30$var$pick,
    getKeysNotIn: function(obj, allowedKeys) {
        var notAllowed = [];
        for(var key in obj)-1 === allowedKeys.indexOf(key) && notAllowed.push(key);
        return notAllowed;
    },
    extend: $51679e17ad633b30$var$extend,
    getOriginFromUrl: function(url) {
        if (url) {
            var parsed = $51679e17ad633b30$var$getLocationFromUrl(url);
            if (!parsed) return null;
            var origin = parsed.protocol + "//" + parsed.hostname;
            return parsed.port && (origin += ":" + parsed.port), origin;
        }
    },
    getLocationFromUrl: $51679e17ad633b30$var$getLocationFromUrl,
    trimUserDetails: function(options) {
        return function(options, keys) {
            return keys.reduce($51679e17ad633b30$var$trim, options);
        }(options, [
            "username",
            "email",
            "phoneNumber"
        ]);
    },
    updatePropertyOn: function updatePropertyOn(obj, path, value) {
        "string" == typeof path && (path = path.split("."));
        var next = path[0];
        obj.hasOwnProperty(next) && (1 === path.length ? obj[next] = value : updatePropertyOn(obj[next], path.slice(1), value));
    }
};
function $51679e17ad633b30$var$RequestWrapper(req) {
    this.request = req, this.method = req.method, this.url = req.url, this.body = req._data, this.headers = req._header;
}
function $51679e17ad633b30$var$RequestObj(req) {
    this.request = req;
}
function $51679e17ad633b30$var$RequestBuilder(options) {
    this._sendTelemetry = !1 !== options._sendTelemetry || options._sendTelemetry, this._telemetryInfo = options._telemetryInfo || null, this._timesToRetryFailedRequests = options._timesToRetryFailedRequests, this.headers = options.headers || {}, this._universalLoginPage = options.universalLoginPage;
}
function $51679e17ad633b30$var$getWindow() {
    return window;
}
$51679e17ad633b30$var$RequestWrapper.prototype.abort = function() {
    this.request.abort();
}, $51679e17ad633b30$var$RequestWrapper.prototype.getMethod = function() {
    return this.method;
}, $51679e17ad633b30$var$RequestWrapper.prototype.getBody = function() {
    return this.body;
}, $51679e17ad633b30$var$RequestWrapper.prototype.getUrl = function() {
    return this.url;
}, $51679e17ad633b30$var$RequestWrapper.prototype.getHeaders = function() {
    return this.headers;
}, $51679e17ad633b30$var$RequestObj.prototype.set = function(key, value) {
    return this.request = this.request.set(key, value), this;
}, $51679e17ad633b30$var$RequestObj.prototype.send = function(body) {
    return this.request = this.request.send($51679e17ad633b30$var$objectHelper.trimUserDetails(body)), this;
}, $51679e17ad633b30$var$RequestObj.prototype.withCredentials = function() {
    return this.request = this.request.withCredentials(), this;
}, $51679e17ad633b30$var$RequestObj.prototype.end = function(cb) {
    return this.request.end(cb), new $51679e17ad633b30$var$RequestWrapper(this.request);
}, $51679e17ad633b30$var$RequestBuilder.prototype.setCommonConfiguration = function(ongoingRequest, options) {
    if (options = options || {}, this._timesToRetryFailedRequests > 0 && (ongoingRequest = ongoingRequest.retry(this._timesToRetryFailedRequests)), options.noHeaders) return ongoingRequest;
    var headers = this.headers;
    ongoingRequest = ongoingRequest.set("Content-Type", "application/json");
    for(var keys = Object.keys(this.headers), a = 0; a < keys.length; a++)ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
    return this._sendTelemetry && (ongoingRequest = ongoingRequest.set("Auth0-Client", this.getTelemetryData())), ongoingRequest;
}, $51679e17ad633b30$var$RequestBuilder.prototype.getTelemetryData = function() {
    var telemetryName = this._universalLoginPage ? "auth0.js-ulp" : "auth0.js", clientInfo = {
        name: telemetryName,
        version: $51679e17ad633b30$export$83d89fbfd8236492.raw
    };
    this._telemetryInfo && ((clientInfo = $51679e17ad633b30$var$objectHelper.extend({}, this._telemetryInfo)).env = $51679e17ad633b30$var$objectHelper.extend({}, this._telemetryInfo.env), clientInfo.env[telemetryName] = $51679e17ad633b30$export$83d89fbfd8236492.raw);
    var jsonClientInfo = JSON.stringify(clientInfo);
    return $51679e17ad633b30$var$base64Url.encode(jsonClientInfo);
}, $51679e17ad633b30$var$RequestBuilder.prototype.get = function(url, options) {
    return new $51679e17ad633b30$var$RequestObj(this.setCommonConfiguration($51679e17ad633b30$var$client.get(url), options));
}, $51679e17ad633b30$var$RequestBuilder.prototype.post = function(url, options) {
    return new $51679e17ad633b30$var$RequestObj(this.setCommonConfiguration($51679e17ad633b30$var$client.post(url), options));
}, $51679e17ad633b30$var$RequestBuilder.prototype.patch = function(url, options) {
    return new $51679e17ad633b30$var$RequestObj(this.setCommonConfiguration($51679e17ad633b30$var$client.patch(url), options));
};
var $51679e17ad633b30$var$windowHelper = {
    redirect: function(url) {
        $51679e17ad633b30$var$getWindow().location = url;
    },
    getDocument: function() {
        return $51679e17ad633b30$var$getWindow().document;
    },
    getWindow: $51679e17ad633b30$var$getWindow,
    getOrigin: function() {
        var location = $51679e17ad633b30$var$getWindow().location, origin = location.origin;
        return origin || (origin = $51679e17ad633b30$var$objectHelper.getOriginFromUrl(location.href)), origin;
    }
};
function $51679e17ad633b30$var$DummyStorage() {}
$51679e17ad633b30$var$DummyStorage.prototype.getItem = function() {
    return null;
}, $51679e17ad633b30$var$DummyStorage.prototype.removeItem = function() {}, $51679e17ad633b30$var$DummyStorage.prototype.setItem = function() {};
var $51679e17ad633b30$var$js_cookie = $51679e17ad633b30$var$createCommonjsModule(function(module, exports) {
    var factory;
    factory = function() {
        function extend() {
            for(var i = 0, result = {}; i < arguments.length; i++){
                var attributes = arguments[i];
                for(var key in attributes)result[key] = attributes[key];
            }
            return result;
        }
        function decode(s) {
            return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }
        return function init(converter) {
            function api() {}
            function set(key, value, attributes) {
                if ("undefined" != typeof document) {
                    "number" == typeof (attributes = extend({
                        path: "/"
                    }, api.defaults, attributes)).expires && (attributes.expires = new Date(1 * new Date + 864e5 * attributes.expires)), attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
                    try {
                        var result = JSON.stringify(value);
                        /^[\{\[]/.test(result) && (value = result);
                    } catch (e) {}
                    value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    var stringifiedAttributes = "";
                    for(var attributeName in attributes)attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, !0 !== attributes[attributeName] && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
                    return document.cookie = key + "=" + value + stringifiedAttributes;
                }
            }
            function get(key, json) {
                if ("undefined" != typeof document) {
                    for(var jar = {}, cookies = document.cookie ? document.cookie.split("; ") : [], i = 0; i < cookies.length; i++){
                        var parts = cookies[i].split("="), cookie = parts.slice(1).join("=");
                        json || '"' !== cookie.charAt(0) || (cookie = cookie.slice(1, -1));
                        try {
                            var name = decode(parts[0]);
                            if (cookie = (converter.read || converter)(cookie, name) || decode(cookie), json) try {
                                cookie = JSON.parse(cookie);
                            } catch (e) {}
                            if (jar[name] = cookie, key === name) break;
                        } catch (e) {}
                    }
                    return key ? jar[key] : jar;
                }
            }
            return api.set = set, api.get = function(key) {
                return get(key, !1);
            }, api.getJSON = function(key) {
                return get(key, !0);
            }, api.remove = function(key, attributes) {
                set(key, "", extend(attributes, {
                    expires: -1
                }));
            }, api.defaults = {}, api.withConverter = init, api;
        }(function() {});
    }, module.exports = factory();
});
function $51679e17ad633b30$var$CookieStorage() {}
function $51679e17ad633b30$var$Warn(options) {
    this.disableWarnings = options.disableWarnings;
}
function $51679e17ad633b30$var$StorageHandler(options) {
    if (this.warn = new $51679e17ad633b30$var$Warn({}), this.storage = new $51679e17ad633b30$var$CookieStorage, !0 === options.__tryLocalStorageFirst) try {
        var localStorage = $51679e17ad633b30$var$windowHelper.getWindow().localStorage;
        localStorage && (this.storage = localStorage);
    } catch (e) {
        this.warn.warning(e), this.warn.warning("Can't use localStorage. Using CookieStorage instead.");
    }
}
function $51679e17ad633b30$var$Storage(options) {
    this.handler = new $51679e17ad633b30$var$StorageHandler(options);
}
function $51679e17ad633b30$var$SSODataStorage(options) {
    this.storage = new $51679e17ad633b30$var$Storage(options);
}
function $51679e17ad633b30$var$buildResponse(error, description) {
    return {
        error: error,
        errorDescription: description
    };
}
$51679e17ad633b30$var$CookieStorage.prototype.getItem = function(key) {
    return $51679e17ad633b30$var$js_cookie.get(key);
}, $51679e17ad633b30$var$CookieStorage.prototype.removeItem = function(key) {
    $51679e17ad633b30$var$js_cookie.remove(key);
}, $51679e17ad633b30$var$CookieStorage.prototype.setItem = function(key, value, options) {
    var params = $51679e17ad633b30$var$objectHelper.extend({
        expires: 1
    }, options);
    "https:" === $51679e17ad633b30$var$windowHelper.getWindow().location.protocol && (params.secure = !0), $51679e17ad633b30$var$js_cookie.set(key, value, params);
}, $51679e17ad633b30$var$Warn.prototype.warning = function(message) {
    this.disableWarnings || console.warn(message);
}, $51679e17ad633b30$var$StorageHandler.prototype.failover = function() {
    this.storage instanceof $51679e17ad633b30$var$DummyStorage ? this.warn.warning("DummyStorage: ignore failover") : this.storage instanceof $51679e17ad633b30$var$CookieStorage ? (this.warn.warning("CookieStorage: failing over DummyStorage"), this.storage = new $51679e17ad633b30$var$DummyStorage) : (this.warn.warning("LocalStorage: failing over CookieStorage"), this.storage = new $51679e17ad633b30$var$CookieStorage);
}, $51679e17ad633b30$var$StorageHandler.prototype.getItem = function(key) {
    try {
        return this.storage.getItem(key);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.getItem(key);
    }
}, $51679e17ad633b30$var$StorageHandler.prototype.removeItem = function(key) {
    try {
        return this.storage.removeItem(key);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.removeItem(key);
    }
}, $51679e17ad633b30$var$StorageHandler.prototype.setItem = function(key, value, options) {
    try {
        return this.storage.setItem(key, value, options);
    } catch (e) {
        return this.warn.warning(e), this.failover(), this.setItem(key, value, options);
    }
}, $51679e17ad633b30$var$Storage.prototype.getItem = function(key) {
    var value = this.handler.getItem(key);
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}, $51679e17ad633b30$var$Storage.prototype.removeItem = function(key) {
    return this.handler.removeItem(key);
}, $51679e17ad633b30$var$Storage.prototype.setItem = function(key, value, options) {
    var json = JSON.stringify(value);
    return this.handler.setItem(key, json, options);
}, $51679e17ad633b30$var$SSODataStorage.prototype.set = function(connection, sub) {
    var ssodata = {
        lastUsedConnection: connection,
        lastUsedSub: sub
    };
    this.storage.setItem("auth0.ssodata", JSON.stringify(ssodata));
}, $51679e17ad633b30$var$SSODataStorage.prototype.get = function() {
    var ssodata = this.storage.getItem("auth0.ssodata");
    if (ssodata) return JSON.parse(ssodata);
};
var $51679e17ad633b30$var$error = {
    buildResponse: $51679e17ad633b30$var$buildResponse,
    invalidToken: function(description) {
        return $51679e17ad633b30$var$buildResponse("invalid_token", description);
    }
};
function $51679e17ad633b30$var$wrapCallback(cb, options) {
    return (options = options || {}).ignoreCasing = !!options.ignoreCasing && options.ignoreCasing, function(err, data) {
        var errObj;
        return err || data ? (!err && data.err && (err = data.err, data = null), !err && data.error && (err = data, data = null), err ? (errObj = {
            original: err
        }, $51679e17ad633b30$var$objectHelper.updatePropertyOn(errObj, "original.response.req._data.password", "*****"), err.response && err.response.statusCode && (errObj.statusCode = err.response.statusCode), err.response && err.response.statusText && (errObj.statusText = err.response.statusText), err.response && err.response.body && (err = err.response.body), err.err && (err = err.err), errObj.code = err.code || err.error || err.error_code || err.status || null, errObj.description = err.errorDescription || err.error_description || err.description || err.error || err.details || err.err || null, options.forceLegacyError && (errObj.error = errObj.code, errObj.error_description = errObj.description), err.error_codes && err.error_details && (errObj.errorDetails = {
            codes: err.error_codes,
            details: err.error_details
        }), err.name && (errObj.name = err.name), err.policy && (errObj.policy = err.policy), cb(errObj)) : !data.type || "text/html" !== data.type && "text/plain" !== data.type ? options.ignoreCasing ? cb(null, data.body || data) : cb(null, $51679e17ad633b30$var$objectHelper.toCamelCase(data.body || data, [], {
            keepOriginal: options.keepOriginalCasing
        })) : cb(null, data.text)) : cb($51679e17ad633b30$var$error.buildResponse("generic_error", "Something went wrong"));
    };
}
var $51679e17ad633b30$var$tokenParams = [
    "realm",
    "audience",
    "otp",
    "client_id",
    "client_secret",
    "redirect_uri",
    "scope",
    "code",
    "grant_type",
    "username",
    "password",
    "refresh_token",
    "assertion",
    "client_assertion",
    "client_assertion_type",
    "code_verifier"
], $51679e17ad633b30$var$authorizeParams = [
    "connection",
    "connection_scope",
    "auth0Client",
    "owp",
    "device",
    "realm",
    "organization",
    "invitation",
    "protocol",
    "_csrf",
    "_intstate",
    "login_ticket",
    "client_id",
    "response_type",
    "response_mode",
    "redirect_uri",
    "audience",
    "scope",
    "state",
    "nonce",
    "display",
    "prompt",
    "screen_hint",
    "max_age",
    "ui_locales",
    "claims_locales",
    "id_token_hint",
    "login_hint",
    "acr_values",
    "claims",
    "registration",
    "request",
    "request_uri",
    "code_challenge",
    "code_challenge_method",
    "access_type",
    "display"
];
var $51679e17ad633b30$var$parametersWhitelist = {
    oauthTokenParams: function(warn, params) {
        return $51679e17ad633b30$var$objectHelper.pick(params, $51679e17ad633b30$var$tokenParams);
    },
    oauthAuthorizeParams: function(warn, params) {
        var notAllowed = $51679e17ad633b30$var$objectHelper.getKeysNotIn(params, $51679e17ad633b30$var$authorizeParams);
        return notAllowed.length > 0 && warn.warning("Following parameters are not allowed on the `/authorize` endpoint: [" + notAllowed.join(",") + "]"), params;
    }
}, $51679e17ad633b30$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $51679e17ad633b30$var$e(t) {
    var e = {
        exports: {}
    };
    return t(e, e.exports), e.exports;
}
var $51679e17ad633b30$var$r = $51679e17ad633b30$var$e(function(e, r) {
    e.exports = function() {
        function e(t) {
            return "function" == typeof t;
        }
        var r = Array.isArray ? Array.isArray : function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }, i = 0, n = void 0, o = void 0, s = function(t, e) {
            l[i] = t, l[i + 1] = e, 2 === (i += 2) && (o ? o(d) : w());
        }, h = "undefined" != typeof window ? window : void 0, u = h || {}, a = u.MutationObserver || u.WebKitMutationObserver, f = "undefined" == typeof self && false, c = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
        function p() {
            var t = setTimeout;
            return function() {
                return t(d, 1);
            };
        }
        var l = new Array(1e3);
        function d() {
            for(var t = 0; t < i; t += 2)(0, l[t])(l[t + 1]), l[t] = void 0, l[t + 1] = void 0;
            i = 0;
        }
        var m, v, y, g, w = void 0;
        function T(t, e) {
            var r = this, i = new this.constructor(S);
            void 0 === i[_] && O(i);
            var n = r._state;
            if (n) {
                var o = arguments[n - 1];
                s(function() {
                    return R(n, i, o, r._result);
                });
            } else I(r, i, t, e);
            return i;
        }
        function b(t) {
            if (t && "object" == typeof t && t.constructor === this) return t;
            var e = new this(S);
            return B(e, t), e;
        }
        w = f ? function() {
            return $hPtJY.nextTick(d);
        } : a ? (v = 0, y = new a(d), g = document.createTextNode(""), y.observe(g, {
            characterData: !0
        }), function() {
            g.data = v = ++v % 2;
        }) : c ? ((m = new MessageChannel).port1.onmessage = d, function() {
            return m.port2.postMessage(0);
        }) : void 0 === h ? function() {
            try {
                var t = Function("return this")().require("vertx");
                return void 0 !== (n = t.runOnLoop || t.runOnContext) ? function() {
                    n(d);
                } : p();
            } catch (t) {
                return p();
            }
        }() : p();
        var _ = Math.random().toString(36).substring(2);
        function S() {}
        var A = void 0;
        function D(t, r, i) {
            r.constructor === t.constructor && i === T && r.constructor.resolve === b ? function(t, e) {
                1 === e._state ? E(t, e._result) : 2 === e._state ? k(t, e._result) : I(e, void 0, function(e) {
                    return B(t, e);
                }, function(e) {
                    return k(t, e);
                });
            }(t, r) : void 0 === i ? E(t, r) : e(i) ? function(t, e, r) {
                s(function(t) {
                    var i = !1, n = function(r, n, o, s) {
                        try {
                            r.call(n, function(r) {
                                i || (i = !0, e !== r ? B(t, r) : E(t, r));
                            }, function(e) {
                                i || (i = !0, k(t, e));
                            });
                        } catch (t) {
                            return t;
                        }
                    }(r, e);
                    !i && n && (i = !0, k(t, n));
                }, t);
            }(t, r, i) : E(t, r);
        }
        function B(t, e) {
            if (t === e) k(t, new TypeError("You cannot resolve a promise with itself"));
            else if (n = typeof (i = e), null === i || "object" !== n && "function" !== n) E(t, e);
            else {
                var r = void 0;
                try {
                    r = e.then;
                } catch (e) {
                    return void k(t, e);
                }
                D(t, e, r);
            }
            var i, n;
        }
        function x(t) {
            t._onerror && t._onerror(t._result), M(t);
        }
        function E(t, e) {
            t._state === A && (t._result = e, t._state = 1, 0 !== t._subscribers.length && s(M, t));
        }
        function k(t, e) {
            t._state === A && (t._state = 2, t._result = e, s(x, t));
        }
        function I(t, e, r, i) {
            var n = t._subscribers, o = n.length;
            t._onerror = null, n[o] = e, n[o + 1] = r, n[o + 2] = i, 0 === o && t._state && s(M, t);
        }
        function M(t) {
            var e = t._subscribers, r = t._state;
            if (0 !== e.length) {
                for(var i = void 0, n = void 0, o = t._result, s = 0; s < e.length; s += 3)n = e[s + r], (i = e[s]) ? R(r, i, n, o) : n(o);
                t._subscribers.length = 0;
            }
        }
        function R(t, r, i, n) {
            var o = e(i), s = void 0, h = void 0, u = !0;
            if (o) {
                try {
                    s = i(n);
                } catch (t) {
                    u = !1, h = t;
                }
                if (r === s) return void k(r, new TypeError("A promises callback cannot return that same promise."));
            } else s = n;
            r._state !== A || (o && u ? B(r, s) : !1 === u ? k(r, h) : 1 === t ? E(r, s) : 2 === t && k(r, s));
        }
        var C = 0;
        function O(t) {
            t[_] = C++, t._state = void 0, t._result = void 0, t._subscribers = [];
        }
        var j = function() {
            function t(t, e) {
                this._instanceConstructor = t, this.promise = new t(S), this.promise[_] || O(this.promise), r(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? E(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && E(this.promise, this._result))) : k(this.promise, new Error("Array Methods must be provided an Array"));
            }
            return t.prototype._enumerate = function(t) {
                for(var e = 0; this._state === A && e < t.length; e++)this._eachEntry(t[e], e);
            }, t.prototype._eachEntry = function(t, e) {
                var r = this._instanceConstructor, i = r.resolve;
                if (i === b) {
                    var n = void 0, o = void 0, s = !1;
                    try {
                        n = t.then;
                    } catch (t) {
                        s = !0, o = t;
                    }
                    if (n === T && t._state !== A) this._settledAt(t._state, e, t._result);
                    else if ("function" != typeof n) this._remaining--, this._result[e] = t;
                    else if (r === N) {
                        var h = new r(S);
                        s ? k(h, o) : D(h, t, n), this._willSettleAt(h, e);
                    } else this._willSettleAt(new r(function(e) {
                        return e(t);
                    }), e);
                } else this._willSettleAt(i(t), e);
            }, t.prototype._settledAt = function(t, e, r) {
                var i = this.promise;
                i._state === A && (this._remaining--, 2 === t ? k(i, r) : this._result[e] = r), 0 === this._remaining && E(i, this._result);
            }, t.prototype._willSettleAt = function(t, e) {
                var r = this;
                I(t, void 0, function(t) {
                    return r._settledAt(1, e, t);
                }, function(t) {
                    return r._settledAt(2, e, t);
                });
            }, t;
        }(), N = function() {
            function t(e) {
                this[_] = C++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function() {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof t ? function(t, e) {
                    try {
                        e(function(e) {
                            B(t, e);
                        }, function(e) {
                            k(t, e);
                        });
                    } catch (e) {
                        k(t, e);
                    }
                }(this, e) : function() {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
            }
            return t.prototype.catch = function(t) {
                return this.then(null, t);
            }, t.prototype.finally = function(t) {
                var r = this, i = r.constructor;
                return e(t) ? r.then(function(e) {
                    return i.resolve(t()).then(function() {
                        return e;
                    });
                }, function(e) {
                    return i.resolve(t()).then(function() {
                        throw e;
                    });
                }) : r.then(t, t);
            }, t;
        }();
        return N.prototype.then = T, N.all = function(t) {
            return new j(this, t).promise;
        }, N.race = function(t) {
            var e = this;
            return r(t) ? new e(function(r, i) {
                for(var n = t.length, o = 0; o < n; o++)e.resolve(t[o]).then(r, i);
            }) : new e(function(t, e) {
                return e(new TypeError("You must pass an array to race."));
            });
        }, N.resolve = b, N.reject = function(t) {
            var e = new this(S);
            return k(e, t), e;
        }, N._setScheduler = function(t) {
            o = t;
        }, N._setAsap = function(t) {
            s = t;
        }, N._asap = s, N.polyfill = function() {
            var e = void 0;
            if (void 0 !== $51679e17ad633b30$var$t) e = $51679e17ad633b30$var$t;
            else if ("undefined" != typeof self) e = self;
            else try {
                e = Function("return this")();
            } catch (t) {
                throw new Error("polyfill failed because global object is unavailable in this environment");
            }
            var r = e.Promise;
            if (r) {
                var i = null;
                try {
                    i = Object.prototype.toString.call(r.resolve());
                } catch (t) {}
                if ("[object Promise]" === i && !r.cast) return;
            }
            e.Promise = N;
        }, N.Promise = N, N;
    }();
}), $51679e17ad633b30$var$i$1 = {
    __proto__: null,
    default: {}
}, $51679e17ad633b30$var$n = $51679e17ad633b30$var$e(function(e, r) {
    var n;
    e.exports = n = n || function(e, r) {
        var n;
        if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== $51679e17ad633b30$var$t && $51679e17ad633b30$var$t.crypto && (n = $51679e17ad633b30$var$t.crypto), !n) try {
            n = $51679e17ad633b30$var$i$1;
        } catch (t) {}
        var o = function() {
            if (n) {
                if ("function" == typeof n.getRandomValues) try {
                    return n.getRandomValues(new Uint32Array(1))[0];
                } catch (t) {}
                if ("function" == typeof n.randomBytes) try {
                    return n.randomBytes(4).readInt32LE();
                } catch (t) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || function() {
            function t() {}
            return function(e) {
                var r;
                return t.prototype = e, r = new t, t.prototype = null, r;
            };
        }(), h = {}, u = h.lib = {}, a = u.Base = {
            extend: function(t) {
                var e = s(this);
                return t && e.mixIn(t), e.hasOwnProperty("init") && this.init !== e.init || (e.init = function() {
                    e.$super.init.apply(this, arguments);
                }), e.init.prototype = e, e.$super = this, e;
            },
            create: function() {
                var t = this.extend();
                return t.init.apply(t, arguments), t;
            },
            init: function() {},
            mixIn: function(t) {
                for(var e in t)t.hasOwnProperty(e) && (this[e] = t[e]);
                t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            clone: function() {
                return this.init.prototype.extend(this);
            }
        }, f = u.WordArray = a.extend({
            init: function(t, e) {
                t = this.words = t || [], this.sigBytes = null != e ? e : 4 * t.length;
            },
            toString: function(t) {
                return (t || p).stringify(this);
            },
            concat: function(t) {
                var e = this.words, r = t.words, i = this.sigBytes, n = t.sigBytes;
                if (this.clamp(), i % 4) for(var o = 0; o < n; o++)e[i + o >>> 2] |= (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 24 - (i + o) % 4 * 8;
                else for(var s = 0; s < n; s += 4)e[i + s >>> 2] = r[s >>> 2];
                return this.sigBytes += n, this;
            },
            clamp: function() {
                var t = this.words, r = this.sigBytes;
                t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = e.ceil(r / 4);
            },
            clone: function() {
                var t = a.clone.call(this);
                return t.words = this.words.slice(0), t;
            },
            random: function(t) {
                for(var e = [], r = 0; r < t; r += 4)e.push(o());
                return new f.init(e, t);
            }
        }), c = h.enc = {}, p = c.Hex = {
            stringify: function(t) {
                for(var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++){
                    var o = e[n >>> 2] >>> 24 - n % 4 * 8 & 255;
                    i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
                }
                return i.join("");
            },
            parse: function(t) {
                for(var e = t.length, r = [], i = 0; i < e; i += 2)r[i >>> 3] |= parseInt(t.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new f.init(r, e / 2);
            }
        }, l = c.Latin1 = {
            stringify: function(t) {
                for(var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++)i.push(String.fromCharCode(e[n >>> 2] >>> 24 - n % 4 * 8 & 255));
                return i.join("");
            },
            parse: function(t) {
                for(var e = t.length, r = [], i = 0; i < e; i++)r[i >>> 2] |= (255 & t.charCodeAt(i)) << 24 - i % 4 * 8;
                return new f.init(r, e);
            }
        }, d = c.Utf8 = {
            stringify: function(t) {
                try {
                    return decodeURIComponent(escape(l.stringify(t)));
                } catch (t) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            parse: function(t) {
                return l.parse(unescape(encodeURIComponent(t)));
            }
        }, m = u.BufferedBlockAlgorithm = a.extend({
            reset: function() {
                this._data = new f.init, this._nDataBytes = 0;
            },
            _append: function(t) {
                "string" == typeof t && (t = d.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
            },
            _process: function(t) {
                var r, i = this._data, n = i.words, o = i.sigBytes, s = this.blockSize, h = o / (4 * s), u = (h = t ? e.ceil(h) : e.max((0 | h) - this._minBufferSize, 0)) * s, a = e.min(4 * u, o);
                if (u) {
                    for(var c = 0; c < u; c += s)this._doProcessBlock(n, c);
                    r = n.splice(0, u), i.sigBytes -= a;
                }
                return new f.init(r, a);
            },
            clone: function() {
                var t = a.clone.call(this);
                return t._data = this._data.clone(), t;
            },
            _minBufferSize: 0
        });
        u.Hasher = m.extend({
            cfg: a.extend(),
            init: function(t) {
                this.cfg = this.cfg.extend(t), this.reset();
            },
            reset: function() {
                m.reset.call(this), this._doReset();
            },
            update: function(t) {
                return this._append(t), this._process(), this;
            },
            finalize: function(t) {
                return t && this._append(t), this._doFinalize();
            },
            blockSize: 16,
            _createHelper: function(t) {
                return function(e, r) {
                    return new t.init(r).finalize(e);
                };
            },
            _createHmacHelper: function(t) {
                return function(e, r) {
                    return new v.HMAC.init(t, r).finalize(e);
                };
            }
        });
        var v = h.algo = {};
        return h;
    }(Math);
}), $51679e17ad633b30$var$o = $51679e17ad633b30$var$e(function(t, e) {
    var r;
    t.exports = (r = $51679e17ad633b30$var$n, function(t) {
        var e = r, i = e.lib, n = i.WordArray, o = i.Hasher, s = e.algo, h = [], u = [];
        !function() {
            function e(e) {
                for(var r = t.sqrt(e), i = 2; i <= r; i++)if (!(e % i)) return !1;
                return !0;
            }
            function r(t) {
                return 4294967296 * (t - (0 | t)) | 0;
            }
            for(var i = 2, n = 0; n < 64;)e(i) && (n < 8 && (h[n] = r(t.pow(i, .5))), u[n] = r(t.pow(i, 1 / 3)), n++), i++;
        }();
        var a = [], f = s.SHA256 = o.extend({
            _doReset: function() {
                this._hash = new n.init(h.slice(0));
            },
            _doProcessBlock: function(t, e) {
                for(var r = this._hash.words, i = r[0], n = r[1], o = r[2], s = r[3], h = r[4], f = r[5], c = r[6], p = r[7], l = 0; l < 64; l++){
                    if (l < 16) a[l] = 0 | t[e + l];
                    else {
                        var d = a[l - 15], m = a[l - 2];
                        a[l] = ((d << 25 | d >>> 7) ^ (d << 14 | d >>> 18) ^ d >>> 3) + a[l - 7] + ((m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10) + a[l - 16];
                    }
                    var v = i & n ^ i & o ^ n & o, y = p + ((h << 26 | h >>> 6) ^ (h << 21 | h >>> 11) ^ (h << 7 | h >>> 25)) + (h & f ^ ~h & c) + u[l] + a[l];
                    p = c, c = f, f = h, h = s + y | 0, s = o, o = n, n = i, i = y + (((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + v) | 0;
                }
                r[0] = r[0] + i | 0, r[1] = r[1] + n | 0, r[2] = r[2] + o | 0, r[3] = r[3] + s | 0, r[4] = r[4] + h | 0, r[5] = r[5] + f | 0, r[6] = r[6] + c | 0, r[7] = r[7] + p | 0;
            },
            _doFinalize: function() {
                var e = this._data, r = e.words, i = 8 * this._nDataBytes, n = 8 * e.sigBytes;
                return r[n >>> 5] |= 128 << 24 - n % 32, r[14 + (n + 64 >>> 9 << 4)] = t.floor(i / 4294967296), r[15 + (n + 64 >>> 9 << 4)] = i, e.sigBytes = 4 * r.length, this._process(), this._hash;
            },
            clone: function() {
                var t = o.clone.call(this);
                return t._hash = this._hash.clone(), t;
            }
        });
        e.SHA256 = o._createHelper(f), e.HmacSHA256 = o._createHmacHelper(f);
    }(Math), r.SHA256);
}), $51679e17ad633b30$var$s = $51679e17ad633b30$var$e(function(t, e) {
    var r, i;
    t.exports = (i = (r = $51679e17ad633b30$var$n).lib.WordArray, r.enc.Base64 = {
        stringify: function(t) {
            var e = t.words, r = t.sigBytes, i = this._map;
            t.clamp();
            for(var n = [], o = 0; o < r; o += 3)for(var s = (e[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (e[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | e[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, h = 0; h < 4 && o + .75 * h < r; h++)n.push(i.charAt(s >>> 6 * (3 - h) & 63));
            var u = i.charAt(64);
            if (u) for(; n.length % 4;)n.push(u);
            return n.join("");
        },
        parse: function(t) {
            var e = t.length, r = this._map, n = this._reverseMap;
            if (!n) {
                n = this._reverseMap = [];
                for(var o = 0; o < r.length; o++)n[r.charCodeAt(o)] = o;
            }
            var s = r.charAt(64);
            if (s) {
                var h = t.indexOf(s);
                -1 !== h && (e = h);
            }
            return function(t, e, r) {
                for(var n = [], o = 0, s = 0; s < e; s++)if (s % 4) {
                    var h = r[t.charCodeAt(s - 1)] << s % 4 * 2, u = r[t.charCodeAt(s)] >>> 6 - s % 4 * 2;
                    n[o >>> 2] |= (h | u) << 24 - o % 4 * 8, o++;
                }
                return i.create(n, o);
            }(t, e, n);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, r.enc.Base64);
}), $51679e17ad633b30$var$h = $51679e17ad633b30$var$e(function(t, e) {
    t.exports = $51679e17ad633b30$var$n.enc.Hex;
}), $51679e17ad633b30$var$u = $51679e17ad633b30$var$e(function(e, r) {
    (function() {
        var t;
        function r(t, e, r) {
            null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : this.fromString(t, null == e && "string" != typeof t ? 256 : e));
        }
        function i() {
            return new r(null);
        }
        var n = "undefined" != typeof navigator;
        n && "Microsoft Internet Explorer" == navigator.appName ? (r.prototype.am = function(t, e, r, i, n, o) {
            for(var s = 32767 & e, h = e >> 15; --o >= 0;){
                var u = 32767 & this[t], a = this[t++] >> 15, f = h * u + a * s;
                n = ((u = s * u + ((32767 & f) << 15) + r[i] + (1073741823 & n)) >>> 30) + (f >>> 15) + h * a + (n >>> 30), r[i++] = 1073741823 & u;
            }
            return n;
        }, t = 30) : n && "Netscape" != navigator.appName ? (r.prototype.am = function(t, e, r, i, n, o) {
            for(; --o >= 0;){
                var s = e * this[t++] + r[i] + n;
                n = Math.floor(s / 67108864), r[i++] = 67108863 & s;
            }
            return n;
        }, t = 26) : (r.prototype.am = function(t, e, r, i, n, o) {
            for(var s = 16383 & e, h = e >> 14; --o >= 0;){
                var u = 16383 & this[t], a = this[t++] >> 14, f = h * u + a * s;
                n = ((u = s * u + ((16383 & f) << 14) + r[i] + n) >> 28) + (f >> 14) + h * a, r[i++] = 268435455 & u;
            }
            return n;
        }, t = 28), r.prototype.DB = t, r.prototype.DM = (1 << t) - 1, r.prototype.DV = 1 << t, r.prototype.FV = Math.pow(2, 52), r.prototype.F1 = 52 - t, r.prototype.F2 = 2 * t - 52;
        var o, s, h = new Array;
        for(o = "0".charCodeAt(0), s = 0; s <= 9; ++s)h[o++] = s;
        for(o = "a".charCodeAt(0), s = 10; s < 36; ++s)h[o++] = s;
        for(o = "A".charCodeAt(0), s = 10; s < 36; ++s)h[o++] = s;
        function u(t) {
            return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
        }
        function a(t, e) {
            var r = h[t.charCodeAt(e)];
            return null == r ? -1 : r;
        }
        function f(t) {
            var e = i();
            return e.fromInt(t), e;
        }
        function c(t) {
            var e, r = 1;
            return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
        }
        function p(t) {
            this.m = t;
        }
        function l(t) {
            this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
        }
        function d(t, e) {
            return t & e;
        }
        function m(t, e) {
            return t | e;
        }
        function v(t, e) {
            return t ^ e;
        }
        function y(t, e) {
            return t & ~e;
        }
        function g(t) {
            if (0 == t) return -1;
            var e = 0;
            return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
        }
        function w(t) {
            for(var e = 0; 0 != t;)t &= t - 1, ++e;
            return e;
        }
        function T() {}
        function b(t) {
            return t;
        }
        function _(t) {
            this.r2 = i(), this.q3 = i(), r.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
        }
        p.prototype.convert = function(t) {
            return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
        }, p.prototype.revert = function(t) {
            return t;
        }, p.prototype.reduce = function(t) {
            t.divRemTo(this.m, null, t);
        }, p.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, p.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        }, l.prototype.convert = function(t) {
            var e = i();
            return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(r.ZERO) > 0 && this.m.subTo(e, e), e;
        }, l.prototype.revert = function(t) {
            var e = i();
            return t.copyTo(e), this.reduce(e), e;
        }, l.prototype.reduce = function(t) {
            for(; t.t <= this.mt2;)t[t.t++] = 0;
            for(var e = 0; e < this.m.t; ++e){
                var r = 32767 & t[e], i = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
                for(t[r = e + this.m.t] += this.m.am(0, i, t, e, 0, this.m.t); t[r] >= t.DV;)t[r] -= t.DV, t[++r]++;
            }
            t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
        }, l.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, l.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        }, r.prototype.copyTo = function(t) {
            for(var e = this.t - 1; e >= 0; --e)t[e] = this[e];
            t.t = this.t, t.s = this.s;
        }, r.prototype.fromInt = function(t) {
            this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
        }, r.prototype.fromString = function(t, e) {
            var i;
            if (16 == e) i = 4;
            else if (8 == e) i = 3;
            else if (256 == e) i = 8;
            else if (2 == e) i = 1;
            else if (32 == e) i = 5;
            else {
                if (4 != e) return void this.fromRadix(t, e);
                i = 2;
            }
            this.t = 0, this.s = 0;
            for(var n = t.length, o = !1, s = 0; --n >= 0;){
                var h = 8 == i ? 255 & t[n] : a(t, n);
                h < 0 ? "-" == t.charAt(n) && (o = !0) : (o = !1, 0 == s ? this[this.t++] = h : s + i > this.DB ? (this[this.t - 1] |= (h & (1 << this.DB - s) - 1) << s, this[this.t++] = h >> this.DB - s) : this[this.t - 1] |= h << s, (s += i) >= this.DB && (s -= this.DB));
            }
            8 == i && 0 != (128 & t[0]) && (this.s = -1, s > 0 && (this[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), o && r.ZERO.subTo(this, this);
        }, r.prototype.clamp = function() {
            for(var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;)--this.t;
        }, r.prototype.dlShiftTo = function(t, e) {
            var r;
            for(r = this.t - 1; r >= 0; --r)e[r + t] = this[r];
            for(r = t - 1; r >= 0; --r)e[r] = 0;
            e.t = this.t + t, e.s = this.s;
        }, r.prototype.drShiftTo = function(t, e) {
            for(var r = t; r < this.t; ++r)e[r - t] = this[r];
            e.t = Math.max(this.t - t, 0), e.s = this.s;
        }, r.prototype.lShiftTo = function(t, e) {
            var r, i = t % this.DB, n = this.DB - i, o = (1 << n) - 1, s = Math.floor(t / this.DB), h = this.s << i & this.DM;
            for(r = this.t - 1; r >= 0; --r)e[r + s + 1] = this[r] >> n | h, h = (this[r] & o) << i;
            for(r = s - 1; r >= 0; --r)e[r] = 0;
            e[s] = h, e.t = this.t + s + 1, e.s = this.s, e.clamp();
        }, r.prototype.rShiftTo = function(t, e) {
            e.s = this.s;
            var r = Math.floor(t / this.DB);
            if (r >= this.t) e.t = 0;
            else {
                var i = t % this.DB, n = this.DB - i, o = (1 << i) - 1;
                e[0] = this[r] >> i;
                for(var s = r + 1; s < this.t; ++s)e[s - r - 1] |= (this[s] & o) << n, e[s - r] = this[s] >> i;
                i > 0 && (e[this.t - r - 1] |= (this.s & o) << n), e.t = this.t - r, e.clamp();
            }
        }, r.prototype.subTo = function(t, e) {
            for(var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;)i += this[r] - t[r], e[r++] = i & this.DM, i >>= this.DB;
            if (t.t < this.t) {
                for(i -= t.s; r < this.t;)i += this[r], e[r++] = i & this.DM, i >>= this.DB;
                i += this.s;
            } else {
                for(i += this.s; r < t.t;)i -= t[r], e[r++] = i & this.DM, i >>= this.DB;
                i -= t.s;
            }
            e.s = i < 0 ? -1 : 0, i < -1 ? e[r++] = this.DV + i : i > 0 && (e[r++] = i), e.t = r, e.clamp();
        }, r.prototype.multiplyTo = function(t, e) {
            var i = this.abs(), n = t.abs(), o = i.t;
            for(e.t = o + n.t; --o >= 0;)e[o] = 0;
            for(o = 0; o < n.t; ++o)e[o + i.t] = i.am(0, n[o], e, o, 0, i.t);
            e.s = 0, e.clamp(), this.s != t.s && r.ZERO.subTo(e, e);
        }, r.prototype.squareTo = function(t) {
            for(var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;)t[r] = 0;
            for(r = 0; r < e.t - 1; ++r){
                var i = e.am(r, e[r], t, 2 * r, 0, 1);
                (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, i, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
            }
            t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
        }, r.prototype.divRemTo = function(t, e, n) {
            var o = t.abs();
            if (!(o.t <= 0)) {
                var s = this.abs();
                if (s.t < o.t) return null != e && e.fromInt(0), void (null != n && this.copyTo(n));
                null == n && (n = i());
                var h = i(), u = this.s, a = t.s, f = this.DB - c(o[o.t - 1]);
                f > 0 ? (o.lShiftTo(f, h), s.lShiftTo(f, n)) : (o.copyTo(h), s.copyTo(n));
                var p = h.t, l = h[p - 1];
                if (0 != l) {
                    var d = l * (1 << this.F1) + (p > 1 ? h[p - 2] >> this.F2 : 0), m = this.FV / d, v = (1 << this.F1) / d, y = 1 << this.F2, g = n.t, w = g - p, T = null == e ? i() : e;
                    for(h.dlShiftTo(w, T), n.compareTo(T) >= 0 && (n[n.t++] = 1, n.subTo(T, n)), r.ONE.dlShiftTo(p, T), T.subTo(h, h); h.t < p;)h[h.t++] = 0;
                    for(; --w >= 0;){
                        var b = n[--g] == l ? this.DM : Math.floor(n[g] * m + (n[g - 1] + y) * v);
                        if ((n[g] += h.am(0, b, n, w, 0, p)) < b) for(h.dlShiftTo(w, T), n.subTo(T, n); n[g] < --b;)n.subTo(T, n);
                    }
                    null != e && (n.drShiftTo(p, e), u != a && r.ZERO.subTo(e, e)), n.t = p, n.clamp(), f > 0 && n.rShiftTo(f, n), u < 0 && r.ZERO.subTo(n, n);
                }
            }
        }, r.prototype.invDigit = function() {
            if (this.t < 1) return 0;
            var t = this[0];
            if (0 == (1 & t)) return 0;
            var e = 3 & t;
            return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
        }, r.prototype.isEven = function() {
            return 0 == (this.t > 0 ? 1 & this[0] : this.s);
        }, r.prototype.exp = function(t, e) {
            if (t > 4294967295 || t < 1) return r.ONE;
            var n = i(), o = i(), s = e.convert(this), h = c(t) - 1;
            for(s.copyTo(n); --h >= 0;)if (e.sqrTo(n, o), (t & 1 << h) > 0) e.mulTo(o, s, n);
            else {
                var u = n;
                n = o, o = u;
            }
            return e.revert(n);
        }, r.prototype.toString = function(t) {
            if (this.s < 0) return "-" + this.negate().toString(t);
            var e;
            if (16 == t) e = 4;
            else if (8 == t) e = 3;
            else if (2 == t) e = 1;
            else if (32 == t) e = 5;
            else {
                if (4 != t) return this.toRadix(t);
                e = 2;
            }
            var r, i = (1 << e) - 1, n = !1, o = "", s = this.t, h = this.DB - s * this.DB % e;
            if (s-- > 0) for(h < this.DB && (r = this[s] >> h) > 0 && (n = !0, o = u(r)); s >= 0;)h < e ? (r = (this[s] & (1 << h) - 1) << e - h, r |= this[--s] >> (h += this.DB - e)) : (r = this[s] >> (h -= e) & i, h <= 0 && (h += this.DB, --s)), r > 0 && (n = !0), n && (o += u(r));
            return n ? o : "0";
        }, r.prototype.negate = function() {
            var t = i();
            return r.ZERO.subTo(this, t), t;
        }, r.prototype.abs = function() {
            return this.s < 0 ? this.negate() : this;
        }, r.prototype.compareTo = function(t) {
            var e = this.s - t.s;
            if (0 != e) return e;
            var r = this.t;
            if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;
            for(; --r >= 0;)if (0 != (e = this[r] - t[r])) return e;
            return 0;
        }, r.prototype.bitLength = function() {
            return this.t <= 0 ? 0 : this.DB * (this.t - 1) + c(this[this.t - 1] ^ this.s & this.DM);
        }, r.prototype.mod = function(t) {
            var e = i();
            return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(r.ZERO) > 0 && t.subTo(e, e), e;
        }, r.prototype.modPowInt = function(t, e) {
            var r;
            return r = t < 256 || e.isEven() ? new p(e) : new l(e), this.exp(t, r);
        }, r.ZERO = f(0), r.ONE = f(1), T.prototype.convert = b, T.prototype.revert = b, T.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r);
        }, T.prototype.sqrTo = function(t, e) {
            t.squareTo(e);
        }, _.prototype.convert = function(t) {
            if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
            if (t.compareTo(this.m) < 0) return t;
            var e = i();
            return t.copyTo(e), this.reduce(e), e;
        }, _.prototype.revert = function(t) {
            return t;
        }, _.prototype.reduce = function(t) {
            for(t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;)t.dAddOffset(1, this.m.t + 1);
            for(t.subTo(this.r2, t); t.compareTo(this.m) >= 0;)t.subTo(this.m, t);
        }, _.prototype.mulTo = function(t, e, r) {
            t.multiplyTo(e, r), this.reduce(r);
        }, _.prototype.sqrTo = function(t, e) {
            t.squareTo(e), this.reduce(e);
        };
        var S, A, D, B = [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37,
            41,
            43,
            47,
            53,
            59,
            61,
            67,
            71,
            73,
            79,
            83,
            89,
            97,
            101,
            103,
            107,
            109,
            113,
            127,
            131,
            137,
            139,
            149,
            151,
            157,
            163,
            167,
            173,
            179,
            181,
            191,
            193,
            197,
            199,
            211,
            223,
            227,
            229,
            233,
            239,
            241,
            251,
            257,
            263,
            269,
            271,
            277,
            281,
            283,
            293,
            307,
            311,
            313,
            317,
            331,
            337,
            347,
            349,
            353,
            359,
            367,
            373,
            379,
            383,
            389,
            397,
            401,
            409,
            419,
            421,
            431,
            433,
            439,
            443,
            449,
            457,
            461,
            463,
            467,
            479,
            487,
            491,
            499,
            503,
            509,
            521,
            523,
            541,
            547,
            557,
            563,
            569,
            571,
            577,
            587,
            593,
            599,
            601,
            607,
            613,
            617,
            619,
            631,
            641,
            643,
            647,
            653,
            659,
            661,
            673,
            677,
            683,
            691,
            701,
            709,
            719,
            727,
            733,
            739,
            743,
            751,
            757,
            761,
            769,
            773,
            787,
            797,
            809,
            811,
            821,
            823,
            827,
            829,
            839,
            853,
            857,
            859,
            863,
            877,
            881,
            883,
            887,
            907,
            911,
            919,
            929,
            937,
            941,
            947,
            953,
            967,
            971,
            977,
            983,
            991,
            997
        ], x = 67108864 / B[B.length - 1];
        function E() {
            var t;
            t = (new Date).getTime(), A[D++] ^= 255 & t, A[D++] ^= t >> 8 & 255, A[D++] ^= t >> 16 & 255, A[D++] ^= t >> 24 & 255, D >= j && (D -= j);
        }
        if (r.prototype.chunkSize = function(t) {
            return Math.floor(Math.LN2 * this.DB / Math.log(t));
        }, r.prototype.toRadix = function(t) {
            if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
            var e = this.chunkSize(t), r = Math.pow(t, e), n = f(r), o = i(), s = i(), h = "";
            for(this.divRemTo(n, o, s); o.signum() > 0;)h = (r + s.intValue()).toString(t).substr(1) + h, o.divRemTo(n, o, s);
            return s.intValue().toString(t) + h;
        }, r.prototype.fromRadix = function(t, e) {
            this.fromInt(0), null == e && (e = 10);
            for(var i = this.chunkSize(e), n = Math.pow(e, i), o = !1, s = 0, h = 0, u = 0; u < t.length; ++u){
                var f = a(t, u);
                f < 0 ? "-" == t.charAt(u) && 0 == this.signum() && (o = !0) : (h = e * h + f, ++s >= i && (this.dMultiply(n), this.dAddOffset(h, 0), s = 0, h = 0));
            }
            s > 0 && (this.dMultiply(Math.pow(e, s)), this.dAddOffset(h, 0)), o && r.ZERO.subTo(this, this);
        }, r.prototype.fromNumber = function(t, e, i) {
            if ("number" == typeof e) {
                if (t < 2) this.fromInt(1);
                else for(this.fromNumber(t, i), this.testBit(t - 1) || this.bitwiseTo(r.ONE.shiftLeft(t - 1), m, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);)this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(r.ONE.shiftLeft(t - 1), this);
            } else {
                var n = new Array, o = 7 & t;
                n.length = 1 + (t >> 3), e.nextBytes(n), o > 0 ? n[0] &= (1 << o) - 1 : n[0] = 0, this.fromString(n, 256);
            }
        }, r.prototype.bitwiseTo = function(t, e, r) {
            var i, n, o = Math.min(t.t, this.t);
            for(i = 0; i < o; ++i)r[i] = e(this[i], t[i]);
            if (t.t < this.t) {
                for(n = t.s & this.DM, i = o; i < this.t; ++i)r[i] = e(this[i], n);
                r.t = this.t;
            } else {
                for(n = this.s & this.DM, i = o; i < t.t; ++i)r[i] = e(n, t[i]);
                r.t = t.t;
            }
            r.s = e(this.s, t.s), r.clamp();
        }, r.prototype.changeBit = function(t, e) {
            var i = r.ONE.shiftLeft(t);
            return this.bitwiseTo(i, e, i), i;
        }, r.prototype.addTo = function(t, e) {
            for(var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;)i += this[r] + t[r], e[r++] = i & this.DM, i >>= this.DB;
            if (t.t < this.t) {
                for(i += t.s; r < this.t;)i += this[r], e[r++] = i & this.DM, i >>= this.DB;
                i += this.s;
            } else {
                for(i += this.s; r < t.t;)i += t[r], e[r++] = i & this.DM, i >>= this.DB;
                i += t.s;
            }
            e.s = i < 0 ? -1 : 0, i > 0 ? e[r++] = i : i < -1 && (e[r++] = this.DV + i), e.t = r, e.clamp();
        }, r.prototype.dMultiply = function(t) {
            this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
        }, r.prototype.dAddOffset = function(t, e) {
            if (0 != t) {
                for(; this.t <= e;)this[this.t++] = 0;
                for(this[e] += t; this[e] >= this.DV;)this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
            }
        }, r.prototype.multiplyLowerTo = function(t, e, r) {
            var i, n = Math.min(this.t + t.t, e);
            for(r.s = 0, r.t = n; n > 0;)r[--n] = 0;
            for(i = r.t - this.t; n < i; ++n)r[n + this.t] = this.am(0, t[n], r, n, 0, this.t);
            for(i = Math.min(t.t, e); n < i; ++n)this.am(0, t[n], r, n, 0, e - n);
            r.clamp();
        }, r.prototype.multiplyUpperTo = function(t, e, r) {
            --e;
            var i = r.t = this.t + t.t - e;
            for(r.s = 0; --i >= 0;)r[i] = 0;
            for(i = Math.max(e - this.t, 0); i < t.t; ++i)r[this.t + i - e] = this.am(e - i, t[i], r, 0, 0, this.t + i - e);
            r.clamp(), r.drShiftTo(1, r);
        }, r.prototype.modInt = function(t) {
            if (t <= 0) return 0;
            var e = this.DV % t, r = this.s < 0 ? t - 1 : 0;
            if (this.t > 0) {
                if (0 == e) r = this[0] % t;
                else for(var i = this.t - 1; i >= 0; --i)r = (e * r + this[i]) % t;
            }
            return r;
        }, r.prototype.millerRabin = function(t) {
            var e = this.subtract(r.ONE), n = e.getLowestSetBit();
            if (n <= 0) return !1;
            var o = e.shiftRight(n);
            (t = t + 1 >> 1) > B.length && (t = B.length);
            for(var s = i(), h = 0; h < t; ++h){
                s.fromInt(B[Math.floor(Math.random() * B.length)]);
                var u = s.modPow(o, this);
                if (0 != u.compareTo(r.ONE) && 0 != u.compareTo(e)) {
                    for(var a = 1; a++ < n && 0 != u.compareTo(e);)if (0 == (u = u.modPowInt(2, this)).compareTo(r.ONE)) return !1;
                    if (0 != u.compareTo(e)) return !1;
                }
            }
            return !0;
        }, r.prototype.clone = function() {
            var t = i();
            return this.copyTo(t), t;
        }, r.prototype.intValue = function() {
            if (this.s < 0) {
                if (1 == this.t) return this[0] - this.DV;
                if (0 == this.t) return -1;
            } else {
                if (1 == this.t) return this[0];
                if (0 == this.t) return 0;
            }
            return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
        }, r.prototype.byteValue = function() {
            return 0 == this.t ? this.s : this[0] << 24 >> 24;
        }, r.prototype.shortValue = function() {
            return 0 == this.t ? this.s : this[0] << 16 >> 16;
        }, r.prototype.signum = function() {
            return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
        }, r.prototype.toByteArray = function() {
            var t = this.t, e = new Array;
            e[0] = this.s;
            var r, i = this.DB - t * this.DB % 8, n = 0;
            if (t-- > 0) for(i < this.DB && (r = this[t] >> i) != (this.s & this.DM) >> i && (e[n++] = r | this.s << this.DB - i); t >= 0;)i < 8 ? (r = (this[t] & (1 << i) - 1) << 8 - i, r |= this[--t] >> (i += this.DB - 8)) : (r = this[t] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == n && (128 & this.s) != (128 & r) && ++n, (n > 0 || r != this.s) && (e[n++] = r);
            return e;
        }, r.prototype.equals = function(t) {
            return 0 == this.compareTo(t);
        }, r.prototype.min = function(t) {
            return this.compareTo(t) < 0 ? this : t;
        }, r.prototype.max = function(t) {
            return this.compareTo(t) > 0 ? this : t;
        }, r.prototype.and = function(t) {
            var e = i();
            return this.bitwiseTo(t, d, e), e;
        }, r.prototype.or = function(t) {
            var e = i();
            return this.bitwiseTo(t, m, e), e;
        }, r.prototype.xor = function(t) {
            var e = i();
            return this.bitwiseTo(t, v, e), e;
        }, r.prototype.andNot = function(t) {
            var e = i();
            return this.bitwiseTo(t, y, e), e;
        }, r.prototype.not = function() {
            for(var t = i(), e = 0; e < this.t; ++e)t[e] = this.DM & ~this[e];
            return t.t = this.t, t.s = ~this.s, t;
        }, r.prototype.shiftLeft = function(t) {
            var e = i();
            return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
        }, r.prototype.shiftRight = function(t) {
            var e = i();
            return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
        }, r.prototype.getLowestSetBit = function() {
            for(var t = 0; t < this.t; ++t)if (0 != this[t]) return t * this.DB + g(this[t]);
            return this.s < 0 ? this.t * this.DB : -1;
        }, r.prototype.bitCount = function() {
            for(var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r)t += w(this[r] ^ e);
            return t;
        }, r.prototype.testBit = function(t) {
            var e = Math.floor(t / this.DB);
            return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
        }, r.prototype.setBit = function(t) {
            return this.changeBit(t, m);
        }, r.prototype.clearBit = function(t) {
            return this.changeBit(t, y);
        }, r.prototype.flipBit = function(t) {
            return this.changeBit(t, v);
        }, r.prototype.add = function(t) {
            var e = i();
            return this.addTo(t, e), e;
        }, r.prototype.subtract = function(t) {
            var e = i();
            return this.subTo(t, e), e;
        }, r.prototype.multiply = function(t) {
            var e = i();
            return this.multiplyTo(t, e), e;
        }, r.prototype.divide = function(t) {
            var e = i();
            return this.divRemTo(t, e, null), e;
        }, r.prototype.remainder = function(t) {
            var e = i();
            return this.divRemTo(t, null, e), e;
        }, r.prototype.divideAndRemainder = function(t) {
            var e = i(), r = i();
            return this.divRemTo(t, e, r), new Array(e, r);
        }, r.prototype.modPow = function(t, e) {
            var r, n, o = t.bitLength(), s = f(1);
            if (o <= 0) return s;
            r = o < 18 ? 1 : o < 48 ? 3 : o < 144 ? 4 : o < 768 ? 5 : 6, n = o < 8 ? new p(e) : e.isEven() ? new _(e) : new l(e);
            var h = new Array, u = 3, a = r - 1, d = (1 << r) - 1;
            if (h[1] = n.convert(this), r > 1) {
                var m = i();
                for(n.sqrTo(h[1], m); u <= d;)h[u] = i(), n.mulTo(m, h[u - 2], h[u]), u += 2;
            }
            var v, y, g = t.t - 1, w = !0, T = i();
            for(o = c(t[g]) - 1; g >= 0;){
                for(o >= a ? v = t[g] >> o - a & d : (v = (t[g] & (1 << o + 1) - 1) << a - o, g > 0 && (v |= t[g - 1] >> this.DB + o - a)), u = r; 0 == (1 & v);)v >>= 1, --u;
                if ((o -= u) < 0 && (o += this.DB, --g), w) h[v].copyTo(s), w = !1;
                else {
                    for(; u > 1;)n.sqrTo(s, T), n.sqrTo(T, s), u -= 2;
                    u > 0 ? n.sqrTo(s, T) : (y = s, s = T, T = y), n.mulTo(T, h[v], s);
                }
                for(; g >= 0 && 0 == (t[g] & 1 << o);)n.sqrTo(s, T), y = s, s = T, T = y, --o < 0 && (o = this.DB - 1, --g);
            }
            return n.revert(s);
        }, r.prototype.modInverse = function(t) {
            var e = t.isEven();
            if (this.isEven() && e || 0 == t.signum()) return r.ZERO;
            for(var i = t.clone(), n = this.clone(), o = f(1), s = f(0), h = f(0), u = f(1); 0 != i.signum();){
                for(; i.isEven();)i.rShiftTo(1, i), e ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(t, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(t, s), s.rShiftTo(1, s);
                for(; n.isEven();)n.rShiftTo(1, n), e ? (h.isEven() && u.isEven() || (h.addTo(this, h), u.subTo(t, u)), h.rShiftTo(1, h)) : u.isEven() || u.subTo(t, u), u.rShiftTo(1, u);
                i.compareTo(n) >= 0 ? (i.subTo(n, i), e && o.subTo(h, o), s.subTo(u, s)) : (n.subTo(i, n), e && h.subTo(o, h), u.subTo(s, u));
            }
            return 0 != n.compareTo(r.ONE) ? r.ZERO : u.compareTo(t) >= 0 ? u.subtract(t) : u.signum() < 0 ? (u.addTo(t, u), u.signum() < 0 ? u.add(t) : u) : u;
        }, r.prototype.pow = function(t) {
            return this.exp(t, new T);
        }, r.prototype.gcd = function(t) {
            var e = this.s < 0 ? this.negate() : this.clone(), r = t.s < 0 ? t.negate() : t.clone();
            if (e.compareTo(r) < 0) {
                var i = e;
                e = r, r = i;
            }
            var n = e.getLowestSetBit(), o = r.getLowestSetBit();
            if (o < 0) return e;
            for(n < o && (o = n), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;)(n = e.getLowestSetBit()) > 0 && e.rShiftTo(n, e), (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
            return o > 0 && r.lShiftTo(o, r), r;
        }, r.prototype.isProbablePrime = function(t) {
            var e, r = this.abs();
            if (1 == r.t && r[0] <= B[B.length - 1]) {
                for(e = 0; e < B.length; ++e)if (r[0] == B[e]) return !0;
                return !1;
            }
            if (r.isEven()) return !1;
            for(e = 1; e < B.length;){
                for(var i = B[e], n = e + 1; n < B.length && i < x;)i *= B[n++];
                for(i = r.modInt(i); e < n;)if (i % B[e++] == 0) return !1;
            }
            return r.millerRabin(t);
        }, r.prototype.square = function() {
            var t = i();
            return this.squareTo(t), t;
        }, r.prototype.Barrett = _, null == A) {
            var k;
            if (A = new Array, D = 0, "undefined" != typeof window && window.crypto) {
                if (window.crypto.getRandomValues) {
                    var I = new Uint8Array(32);
                    for(window.crypto.getRandomValues(I), k = 0; k < 32; ++k)A[D++] = I[k];
                } else if ("Netscape" == navigator.appName && navigator.appVersion < "5") {
                    var M = window.crypto.random(32);
                    for(k = 0; k < M.length; ++k)A[D++] = 255 & M.charCodeAt(k);
                }
            }
            for(; D < j;)k = Math.floor(65536 * Math.random()), A[D++] = k >>> 8, A[D++] = 255 & k;
            D = 0, E();
        }
        function R() {
            if (null == S) {
                for(E(), (S = new O).init(A), D = 0; D < A.length; ++D)A[D] = 0;
                D = 0;
            }
            return S.next();
        }
        function C() {}
        function O() {
            this.i = 0, this.j = 0, this.S = new Array;
        }
        C.prototype.nextBytes = function(t) {
            var e;
            for(e = 0; e < t.length; ++e)t[e] = R();
        }, O.prototype.init = function(t) {
            var e, r, i;
            for(e = 0; e < 256; ++e)this.S[e] = e;
            for(r = 0, e = 0; e < 256; ++e)i = this.S[e], this.S[e] = this.S[r = r + this.S[e] + t[e % t.length] & 255], this.S[r] = i;
            this.i = 0, this.j = 0;
        }, O.prototype.next = function() {
            var t;
            return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255];
        };
        var j = 256;
        e.exports = {
            default: r,
            BigInteger: r,
            SecureRandom: C
        };
    }).call($51679e17ad633b30$var$t);
}), $51679e17ad633b30$var$a = {
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    ripemd160: "3021300906052b2403020105000414"
}, $51679e17ad633b30$var$f = {
    sha256: $51679e17ad633b30$var$o
};
function $51679e17ad633b30$var$c(t, e) {
    if (this.n = null, this.e = 0, !(null != t && null != e && t.length > 0 && e.length > 0)) throw new Error("Invalid key data");
    this.n = new $51679e17ad633b30$var$u.BigInteger(t, 16), this.e = parseInt(e, 16);
}
$51679e17ad633b30$var$c.prototype.verify = function(t, e) {
    e = e.replace(/[^0-9a-f]|[\s\n]]/gi, "");
    var r = new $51679e17ad633b30$var$u.BigInteger(e, 16);
    if (r.bitLength() > this.n.bitLength()) throw new Error("Signature does not match with the key modulus.");
    var i = function(t) {
        for(var e in $51679e17ad633b30$var$a){
            var r = $51679e17ad633b30$var$a[e], i = r.length;
            if (t.substring(0, i) === r) return {
                alg: e,
                hash: t.substring(i)
            };
        }
        return [];
    }(r.modPowInt(this.e, this.n).toString(16).replace(/^1f+00/, ""));
    if (0 === i.length) return !1;
    if (!$51679e17ad633b30$var$f.hasOwnProperty(i.alg)) throw new Error("Hashing algorithm is not supported.");
    var n = $51679e17ad633b30$var$f[i.alg](t).toString();
    return i.hash === n;
};
for(var $51679e17ad633b30$var$p = [], $51679e17ad633b30$var$l = [], $51679e17ad633b30$var$d = "undefined" != typeof Uint8Array ? Uint8Array : Array, $51679e17ad633b30$var$m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $51679e17ad633b30$var$v = 0, $51679e17ad633b30$var$y = $51679e17ad633b30$var$m.length; $51679e17ad633b30$var$v < $51679e17ad633b30$var$y; ++$51679e17ad633b30$var$v)$51679e17ad633b30$var$p[$51679e17ad633b30$var$v] = $51679e17ad633b30$var$m[$51679e17ad633b30$var$v], $51679e17ad633b30$var$l[$51679e17ad633b30$var$m.charCodeAt($51679e17ad633b30$var$v)] = $51679e17ad633b30$var$v;
$51679e17ad633b30$var$l["-".charCodeAt(0)] = 62, $51679e17ad633b30$var$l["_".charCodeAt(0)] = 63;
var $51679e17ad633b30$var$g = function(t) {
    var e, r, i = function(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [
            r,
            r === e ? 0 : 4 - r % 4
        ];
    }(t), n = i[0], o = i[1], s = new $51679e17ad633b30$var$d(function(t, e, r) {
        return 3 * (e + r) / 4 - r;
    }(0, n, o)), h = 0, u = o > 0 ? n - 4 : n;
    for(r = 0; r < u; r += 4)e = $51679e17ad633b30$var$l[t.charCodeAt(r)] << 18 | $51679e17ad633b30$var$l[t.charCodeAt(r + 1)] << 12 | $51679e17ad633b30$var$l[t.charCodeAt(r + 2)] << 6 | $51679e17ad633b30$var$l[t.charCodeAt(r + 3)], s[h++] = e >> 16 & 255, s[h++] = e >> 8 & 255, s[h++] = 255 & e;
    return 2 === o && (e = $51679e17ad633b30$var$l[t.charCodeAt(r)] << 2 | $51679e17ad633b30$var$l[t.charCodeAt(r + 1)] >> 4, s[h++] = 255 & e), 1 === o && (e = $51679e17ad633b30$var$l[t.charCodeAt(r)] << 10 | $51679e17ad633b30$var$l[t.charCodeAt(r + 1)] << 4 | $51679e17ad633b30$var$l[t.charCodeAt(r + 2)] >> 2, s[h++] = e >> 8 & 255, s[h++] = 255 & e), s;
};
function $51679e17ad633b30$var$w(t) {
    var e = t.length % 4;
    return 0 === e ? t : t + new Array(4 - e + 1).join("=");
}
function $51679e17ad633b30$var$T(t) {
    return t = $51679e17ad633b30$var$w(t).replace(/\-/g, "+").replace(/_/g, "/"), decodeURIComponent((function(t) {
        for(var e = "", r = 0; r < t.length; r++)e += String.fromCharCode(t[r]);
        return e;
    })($51679e17ad633b30$var$g(t)).split("").map(function(t) {
        return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
}
function $51679e17ad633b30$var$b(t) {
    return function(t) {
        for(var e = "", r = 0; r < t.length; r++){
            var i = t[r].toString(16);
            e += 2 === i.length ? i : "0" + i;
        }
        return e;
    }($51679e17ad633b30$var$g($51679e17ad633b30$var$w(t)));
}
var $51679e17ad633b30$var$_ = $51679e17ad633b30$var$e(function(e) {
    var r, i;
    r = $51679e17ad633b30$var$t, i = function() {
        function t(t) {
            var e = [];
            if (0 === t.length) return "";
            if ("string" != typeof t[0]) throw new TypeError("Url must be a string. Received " + t[0]);
            if (t[0].match(/^[^/:]+:\/*$/) && t.length > 1) {
                var r = t.shift();
                t[0] = r + t[0];
            }
            t[0] = t[0].match(/^file:\/\/\//) ? t[0].replace(/^([^/:]+):\/*/, "$1:///") : t[0].replace(/^([^/:]+):\/*/, "$1://");
            for(var i = 0; i < t.length; i++){
                var n = t[i];
                if ("string" != typeof n) throw new TypeError("Url must be a string. Received " + n);
                "" !== n && (i > 0 && (n = n.replace(/^[\/]+/, "")), n = n.replace(/[\/]+$/, i < t.length - 1 ? "" : "/"), e.push(n));
            }
            var o = e.join("/"), s = (o = o.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
            return s.shift() + (s.length > 0 ? "?" : "") + s.join("&");
        }
        return function() {
            return t("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
        };
    }, e.exports ? e.exports = i() : r.urljoin = i();
});
function $51679e17ad633b30$var$S(t, e) {
    return e = e || {}, new Promise(function(r, i) {
        var n = new XMLHttpRequest, o = [], s = [], h = {}, u = function() {
            return {
                ok: 2 == (n.status / 100 | 0),
                statusText: n.statusText,
                status: n.status,
                url: n.responseURL,
                text: function() {
                    return Promise.resolve(n.responseText);
                },
                json: function() {
                    return Promise.resolve(n.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        n.response
                    ]));
                },
                clone: u,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return s;
                    },
                    get: function(t) {
                        return h[t.toLowerCase()];
                    },
                    has: function(t) {
                        return t.toLowerCase() in h;
                    }
                }
            };
        };
        for(var a in n.open(e.method || "get", t, !0), n.onload = function() {
            n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, r) {
                o.push(e = e.toLowerCase()), s.push([
                    e,
                    r
                ]), h[e] = h[e] ? h[e] + "," + r : r;
            }), r(u());
        }, n.onerror = i, n.withCredentials = "include" == e.credentials, e.headers)n.setRequestHeader(a, e.headers[a]);
        n.send(e.body || null);
    });
}
function $51679e17ad633b30$var$A(t) {
    if (t.ok) return t.json();
    var e = new Error(t.statusText);
    return e.response = t, Promise.reject(e);
}
function $51679e17ad633b30$var$D(t) {
    this.name = "ConfigurationError", this.message = t || "";
}
function $51679e17ad633b30$var$B(t) {
    this.name = "TokenValidationError", this.message = t || "";
}
$51679e17ad633b30$var$D.prototype = Error.prototype, $51679e17ad633b30$var$B.prototype = Error.prototype;
var $51679e17ad633b30$var$x = function() {
    function t() {}
    var e = t.prototype;
    return e.get = function() {
        return null;
    }, e.has = function() {
        return null;
    }, e.set = function() {
        return null;
    }, t;
}();
$51679e17ad633b30$var$r.polyfill();
var $51679e17ad633b30$var$E = function(t) {
    return "number" == typeof t;
}, $51679e17ad633b30$var$k = function() {
    return new Date;
};
function $51679e17ad633b30$var$I(t) {
    var e = t || {};
    if (this.jwksCache = e.jwksCache || new $51679e17ad633b30$var$x, this.expectedAlg = e.expectedAlg || "RS256", this.issuer = e.issuer, this.audience = e.audience, this.leeway = 0 === e.leeway ? 0 : e.leeway || 60, this.jwksURI = e.jwksURI, this.maxAge = e.maxAge, this.__clock = "function" == typeof e.__clock ? e.__clock : $51679e17ad633b30$var$k, this.leeway < 0 || this.leeway > 300) throw new $51679e17ad633b30$var$D("The leeway should be positive and lower than five minutes.");
    if ("RS256" !== this.expectedAlg) throw new $51679e17ad633b30$var$D('Signature algorithm of "' + this.expectedAlg + '" is not supported. Expected the ID token to be signed with "RS256".');
}
function $51679e17ad633b30$var$PluginHandler(webAuth, plugins) {
    this.plugins = plugins;
    for(var a = 0; a < this.plugins.length; a++){
        if (this.plugins[a].version !== $51679e17ad633b30$export$83d89fbfd8236492.raw) {
            var pluginName = "";
            throw this.plugins[a].constructor && this.plugins[a].constructor.name && (pluginName = this.plugins[a].constructor.name), new Error("Plugin " + pluginName + " version (" + this.plugins[a].version + ") is not compatible with the SDK version (" + $51679e17ad633b30$export$83d89fbfd8236492.raw + ")");
        }
        this.plugins[a].setWebAuth(webAuth);
    }
}
$51679e17ad633b30$var$I.prototype.verify = function(t, e, r) {
    if (!r && e && "function" == typeof e && (r = e, e = void 0), !t) return r(new $51679e17ad633b30$var$B("ID token is required but missing"), null);
    var i = this.decode(t);
    if (i instanceof Error) return r(new $51679e17ad633b30$var$B("ID token could not be decoded"), null);
    var n = i.encoded.header + "." + i.encoded.payload, o = $51679e17ad633b30$var$b(i.encoded.signature), s = i.header.alg, h = i.header.kid, u = i.payload.aud, a = i.payload.sub, f = i.payload.iss, c = i.payload.exp, p = i.payload.nbf, l = i.payload.iat, d = i.payload.azp, m = i.payload.auth_time, v = i.payload.nonce, y = this.__clock(), g = this;
    if (g.expectedAlg !== s) return r(new $51679e17ad633b30$var$B('Signature algorithm of "' + s + '" is not supported. Expected the ID token to be signed with "RS256".'), null);
    this.getRsaVerifier(f, h, function(t, s) {
        if (t) return r(t, null);
        if (!s.verify(n, o)) return r(new $51679e17ad633b30$var$B("Invalid ID token signature."), null);
        if (!f || "string" != typeof f) return r(new $51679e17ad633b30$var$B("Issuer (iss) claim must be a string present in the ID token"), null);
        if (g.issuer !== f) return r(new $51679e17ad633b30$var$B('Issuer (iss) claim mismatch in the ID token, expected "' + g.issuer + '", found "' + f + '"'), null);
        if (!a || "string" != typeof a) return r(new $51679e17ad633b30$var$B("Subject (sub) claim must be a string present in the ID token"), null);
        if (!u || "string" != typeof u && !Array.isArray(u)) return r(new $51679e17ad633b30$var$B("Audience (aud) claim must be a string or array of strings present in the ID token"), null);
        if (Array.isArray(u) && !u.includes(g.audience)) return r(new $51679e17ad633b30$var$B('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but was not one of "' + u.join(", ") + '"'), null);
        if ("string" == typeof u && g.audience !== u) return r(new $51679e17ad633b30$var$B('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but found "' + u + '"'), null);
        if (e) {
            if (!v || "string" != typeof v) return r(new $51679e17ad633b30$var$B("Nonce (nonce) claim must be a string present in the ID token"), null);
            if (v !== e) return r(new $51679e17ad633b30$var$B('Nonce (nonce) claim value mismatch in the ID token; expected "' + e + '", found "' + v + '"'), null);
        }
        if (Array.isArray(u) && u.length > 1) {
            if (!d || "string" != typeof d) return r(new $51679e17ad633b30$var$B("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values"), null);
            if (d !== g.audience) return r(new $51679e17ad633b30$var$B('Authorized Party (azp) claim mismatch in the ID token; expected "' + g.audience + '", found "' + d + '"'), null);
        }
        if (!c || !$51679e17ad633b30$var$E(c)) return r(new $51679e17ad633b30$var$B("Expiration Time (exp) claim must be a number present in the ID token"), null);
        if (!l || !$51679e17ad633b30$var$E(l)) return r(new $51679e17ad633b30$var$B("Issued At (iat) claim must be a number present in the ID token"), null);
        var h = c + g.leeway, w = new Date(0);
        if (w.setUTCSeconds(h), y > w) return r(new $51679e17ad633b30$var$B('Expiration Time (exp) claim error in the ID token; current time "' + y + '" is after expiration time "' + w + '"'), null);
        if (p && $51679e17ad633b30$var$E(p)) {
            var T = p - g.leeway, b = new Date(0);
            if (b.setUTCSeconds(T), y < b) return r(new $51679e17ad633b30$var$B('Not Before Time (nbf) claim error in the ID token; current time "' + y + '" is before the not before time "' + b + '"'), null);
        }
        if (g.maxAge) {
            if (!m || !$51679e17ad633b30$var$E(m)) return r(new $51679e17ad633b30$var$B("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified"), null);
            var _ = m + g.maxAge + g.leeway, S = new Date(0);
            if (S.setUTCSeconds(_), y > S) return r(new $51679e17ad633b30$var$B('Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time "' + y + '" is after last auth time at "' + S + '"'), null);
        }
        return r(null, i.payload);
    });
}, $51679e17ad633b30$var$I.prototype.getRsaVerifier = function(t, e, r) {
    var i = this, n = t + e;
    Promise.resolve(this.jwksCache.has(n)).then(function(r) {
        var o;
        return r ? i.jwksCache.get(n) : (o = {
            jwksURI: i.jwksURI,
            iss: t,
            kid: e
        }, ("undefined" == typeof fetch ? $51679e17ad633b30$var$S : fetch)(o.jwksURI || $51679e17ad633b30$var$_(o.iss, ".well-known", "jwks.json")).then($51679e17ad633b30$var$A).then(function(t) {
            var e, r, i, n = null;
            for(e = 0; e < t.keys.length && null === n; e++)(r = t.keys[e]).kid === o.kid && (n = r);
            if (!n) throw new Error('Could not find a public key for Key ID (kid) "' + o.kid + '"');
            return {
                modulus: $51679e17ad633b30$var$b((i = n).n),
                exp: $51679e17ad633b30$var$b(i.e)
            };
        }).catch(function(t) {
            throw t;
        }));
    }).then(function(t) {
        if (!t || !t.modulus || !t.exp) throw new Error("Empty keyInfo in response");
        return Promise.resolve(i.jwksCache.set(n, t)).then(function() {
            r && r(null, new $51679e17ad633b30$var$c(t.modulus, t.exp));
        });
    }).catch(function(t) {
        r && r(t);
    });
}, $51679e17ad633b30$var$I.prototype.decode = function(t) {
    var e, r, i = t.split(".");
    if (3 !== i.length) return new $51679e17ad633b30$var$B("Cannot decode a malformed JWT");
    try {
        e = JSON.parse($51679e17ad633b30$var$T(i[0])), r = JSON.parse($51679e17ad633b30$var$T(i[1]));
    } catch (t) {
        return new $51679e17ad633b30$var$B("Token header or payload is not valid JSON");
    }
    return {
        header: e,
        payload: r,
        encoded: {
            header: i[0],
            payload: i[1],
            signature: i[2]
        }
    };
}, $51679e17ad633b30$var$I.prototype.validateAccessToken = function(t, e, r, i) {
    if (this.expectedAlg !== e) return i(new $51679e17ad633b30$var$B('Signature algorithm of "' + e + '" is not supported. Expected "' + this.expectedAlg + '"'));
    var n, u = $51679e17ad633b30$var$o(t), a = $51679e17ad633b30$var$h.stringify(u), f = a.substring(0, a.length / 2), c = $51679e17ad633b30$var$h.parse(f), p = $51679e17ad633b30$var$s.stringify(c);
    return i((n = {
        "+": "-",
        "/": "_",
        "=": ""
    }, p.replace(/[+/=]/g, function(t) {
        return n[t];
    }) !== r ? new $51679e17ad633b30$var$B("Invalid access_token") : null));
}, $51679e17ad633b30$var$PluginHandler.prototype.get = function(extensibilityPoint) {
    for(var a = 0; a < this.plugins.length; a++)if (this.plugins[a].supports(extensibilityPoint)) return this.plugins[a].init();
    return null;
};
var $51679e17ad633b30$var$random = {
    randomString: function(length) {
        var bytes = new Uint8Array(length), result = [], charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~", cryptoObj = $51679e17ad633b30$var$windowHelper.getWindow().crypto || $51679e17ad633b30$var$windowHelper.getWindow().msCrypto;
        if (!cryptoObj) return null;
        for(var random = cryptoObj.getRandomValues(bytes), a = 0; a < random.length; a++)result.push(charset[random[a] % charset.length]);
        return result.join("");
    }
};
function $51679e17ad633b30$var$TransactionManager(options) {
    var transaction = options.transaction || {};
    this.namespace = transaction.namespace || "com.auth0.auth.", this.keyLength = transaction.keyLength || 32, this.storage = new $51679e17ad633b30$var$Storage(options), this.options = options;
}
function $51679e17ad633b30$var$IframeHandler(options) {
    if (this.url = options.url, this.callback = options.callback, this.timeout = options.timeout || 6e4, this.timeoutCallback = options.timeoutCallback || null, this.eventListenerType = options.eventListenerType || "message", this.iframe = null, this.timeoutHandle = null, this._destroyTimeout = null, this.transientMessageEventListener = null, this.proxyEventListener = null, this.eventValidator = options.eventValidator || {
        isValid: function() {
            return !0;
        }
    }, "function" != typeof this.callback) throw new Error("options.callback must be a function");
}
function $51679e17ad633b30$var$WebMessageHandler(webAuth) {
    this.webAuth = webAuth, this.warn = new $51679e17ad633b30$var$Warn(webAuth.baseOptions);
}
function $51679e17ad633b30$var$CrossOriginAuthentication(webAuth, options) {
    this.webAuth = webAuth, this.baseOptions = options, this.request = new $51679e17ad633b30$var$RequestBuilder(options), this.webMessageHandler = new $51679e17ad633b30$var$WebMessageHandler(webAuth), this.storage = new $51679e17ad633b30$var$Storage(options);
}
function $51679e17ad633b30$var$createKey(origin, coId) {
    return [
        "co/verifier",
        encodeURIComponent(origin),
        encodeURIComponent(coId)
    ].join("/");
}
function $51679e17ad633b30$var$Redirect(auth0, options) {
    this.webAuth = auth0, this.baseOptions = options, this.crossOriginAuthentication = new $51679e17ad633b30$var$CrossOriginAuthentication(auth0, this.baseOptions), this.warn = new $51679e17ad633b30$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
$51679e17ad633b30$var$TransactionManager.prototype.process = function(options) {
    if (!options.responseType) throw new Error("responseType is required");
    var lastUsedConnection = options.realm || options.connection, responseTypeIncludesIdToken = -1 !== options.responseType.indexOf("id_token"), transaction = this.generateTransaction(options.appState, options.state, options.nonce, lastUsedConnection, responseTypeIncludesIdToken, options.organization);
    return options.state || (options.state = transaction.state), responseTypeIncludesIdToken && !options.nonce && (options.nonce = transaction.nonce), options;
}, $51679e17ad633b30$var$TransactionManager.prototype.generateTransaction = function(appState, state, nonce, lastUsedConnection, generateNonce, organization) {
    if (state = state || $51679e17ad633b30$var$random.randomString(this.keyLength), nonce = nonce || (generateNonce ? $51679e17ad633b30$var$random.randomString(this.keyLength) : null), !($51679e17ad633b30$var$windowHelper.getWindow().location.host === this.options.domain)) {
        var transactionPayload = {
            nonce: nonce,
            appState: appState,
            state: state,
            lastUsedConnection: lastUsedConnection
        };
        organization && (transactionPayload.organization = organization), this.storage.setItem(this.namespace + state, transactionPayload, {
            expires: 1 / 48
        });
    }
    return {
        state: state,
        nonce: nonce
    };
}, $51679e17ad633b30$var$TransactionManager.prototype.getStoredTransaction = function(state) {
    var transactionData;
    return transactionData = this.storage.getItem(this.namespace + state), this.clearTransaction(state), transactionData;
}, $51679e17ad633b30$var$TransactionManager.prototype.clearTransaction = function(state) {
    this.storage.removeItem(this.namespace + state);
}, $51679e17ad633b30$var$IframeHandler.prototype.init = function() {
    var _this = this, _window = $51679e17ad633b30$var$windowHelper.getWindow();
    switch(this.iframe = _window.document.createElement("iframe"), this.iframe.style.display = "none", this.proxyEventListener = function(e) {
        _this.eventListener(e);
    }, this.eventListenerType){
        case "message":
            this.eventSourceObject = _window;
            break;
        case "load":
            this.eventSourceObject = this.iframe;
            break;
        default:
            throw new Error("Unsupported event listener type: " + this.eventListenerType);
    }
    this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, !1), _window.document.body.appendChild(this.iframe), this.iframe.src = this.url, this.timeoutHandle = setTimeout(function() {
        _this.timeoutHandler();
    }, this.timeout);
}, $51679e17ad633b30$var$IframeHandler.prototype.eventListener = function(event) {
    var eventData = {
        event: event,
        sourceObject: this.eventSourceObject
    };
    this.eventValidator.isValid(eventData) && (this.destroy(), this.callback(eventData));
}, $51679e17ad633b30$var$IframeHandler.prototype.timeoutHandler = function() {
    this.destroy(), this.timeoutCallback && this.timeoutCallback();
}, $51679e17ad633b30$var$IframeHandler.prototype.destroy = function() {
    var _this = this;
    clearTimeout(this.timeoutHandle), this._destroyTimeout = setTimeout(function() {
        _this.eventSourceObject.removeEventListener(_this.eventListenerType, _this.proxyEventListener, !1), _this.iframe.parentNode && _this.iframe.parentNode.removeChild(_this.iframe);
    }, 0);
}, $51679e17ad633b30$var$WebMessageHandler.prototype.run = function(options, cb) {
    var _this = this;
    options.responseMode = "web_message", options.prompt = "none";
    var currentOrigin = $51679e17ad633b30$var$windowHelper.getOrigin(), redirectUriOrigin = $51679e17ad633b30$var$objectHelper.getOriginFromUrl(options.redirectUri);
    if (redirectUriOrigin && currentOrigin !== redirectUriOrigin) return cb({
        error: "origin_mismatch",
        error_description: "The redirectUri's origin (" + redirectUriOrigin + ") should match the window's origin (" + currentOrigin + ")."
    });
    !function(authorizeUrl, options, callback) {
        new $51679e17ad633b30$var$IframeHandler({
            url: authorizeUrl,
            eventListenerType: "message",
            callback: function(eventData) {
                callback(null, eventData);
            },
            timeout: options.timeout,
            eventValidator: {
                isValid: function(eventData) {
                    return !(!eventData.event.data || "authorization_response" !== eventData.event.data.type || options.state !== eventData.event.data.response.state);
                }
            },
            timeoutCallback: function() {
                callback({
                    error: "timeout",
                    error_description: "Timeout during executing web_message communication",
                    state: options.state
                });
            }
        }).init();
    }(this.webAuth.client.buildAuthorizeUrl(options), options, function(err, eventData) {
        var error = err;
        if (!err && eventData.event.data.response.error && (error = eventData.event.data.response), !error) {
            var parsedHash = eventData.event.data.response;
            return _this.webAuth.validateAuthenticationResponse(options, parsedHash, cb);
        }
        return "consent_required" === error.error && "localhost" === $51679e17ad633b30$var$windowHelper.getWindow().location.hostname && _this.warn.warning("Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"), _this.webAuth.transactionManager.clearTransaction(error.state), cb($51679e17ad633b30$var$objectHelper.pick(error, [
            "error",
            "error_description"
        ]));
    });
}, $51679e17ad633b30$var$CrossOriginAuthentication.prototype.login = function(options, cb) {
    var _this = this, url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "/co/authenticate");
    options.username = options.username || options.email, delete options.email;
    var authenticateBody = {
        client_id: options.clientID || this.baseOptions.clientID,
        username: options.username
    };
    options.password && (authenticateBody.password = options.password), options.otp && (authenticateBody.otp = options.otp);
    var realm = options.realm || this.baseOptions.realm;
    if (realm) {
        var credentialType = options.credentialType || this.baseOptions.credentialType || "http://auth0.com/oauth/grant-type/password-realm";
        authenticateBody.realm = realm, authenticateBody.credential_type = credentialType;
    } else authenticateBody.credential_type = "password";
    this.request.post(url).withCredentials().send(authenticateBody).end(function(err, data) {
        if (err) {
            var errorObject = err.response && err.response.body || {
                error: "request_error",
                error_description: JSON.stringify(err)
            };
            return $51679e17ad633b30$var$wrapCallback(cb, {
                forceLegacyError: !0
            })(errorObject);
        }
        function doAuth() {
            var popupMode = !0 === options.popup;
            options = $51679e17ad633b30$var$objectHelper.blacklist(options, [
                "password",
                "credentialType",
                "otp",
                "popup",
                "onRedirecting"
            ]);
            var authorizeOptions = $51679e17ad633b30$var$objectHelper.merge(options).with({
                loginTicket: data.body.login_ticket
            }), key = $51679e17ad633b30$var$createKey(_this.baseOptions.rootUrl, data.body.co_id);
            _this.storage.setItem(key, data.body.co_verifier, {
                expires: 1 / 96
            }), popupMode ? _this.webMessageHandler.run(authorizeOptions, $51679e17ad633b30$var$wrapCallback(cb, {
                forceLegacyError: !0
            })) : _this.webAuth.authorize(authorizeOptions);
        }
        "function" == typeof options.onRedirecting ? options.onRedirecting(doAuth) : doAuth();
    });
}, $51679e17ad633b30$var$CrossOriginAuthentication.prototype.callback = function() {
    var targetOrigin = decodeURIComponent(function(name) {
        var parts = ("&" + $51679e17ad633b30$var$windowHelper.getWindow().location.hash.substring(1)).split("&" + name + "=");
        if (2 === parts.length) return parts.pop().split("&").shift();
    }("origin")), theWindow = $51679e17ad633b30$var$windowHelper.getWindow(), _this = this;
    theWindow.addEventListener("message", function(evt) {
        if ("co_verifier_request" === evt.data.type) {
            var key = $51679e17ad633b30$var$createKey(evt.origin, evt.data.request.id), verifier = function(storage, key) {
                try {
                    var verifier = storage.getItem(key);
                    return storage.removeItem(key), verifier || "";
                } catch (e) {
                    return "";
                }
            }(_this.storage, key);
            evt.source.postMessage({
                type: "co_verifier_response",
                response: {
                    verifier: verifier
                }
            }, evt.origin);
        }
    }), theWindow.parent.postMessage({
        type: "ready"
    }, targetOrigin);
}, $51679e17ad633b30$var$Redirect.prototype.loginWithCredentials = function(options, cb) {
    options.realm = options.realm || options.connection, delete options.connection, this.crossOriginAuthentication.login(options, cb);
}, $51679e17ad633b30$var$Redirect.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return this.webAuth.client.dbConnection.signup(options, function(err) {
        return err ? cb(err) : (options.realm = options.realm || options.connection, delete options.connection, _this.webAuth.login(options, cb));
    });
};
var $51679e17ad633b30$var$winchan = $51679e17ad633b30$var$createCommonjsModule(function(module) {
    var WinChan = function() {
        function addListener(w, event, cb) {
            w.attachEvent ? w.attachEvent("on" + event, cb) : w.addEventListener && w.addEventListener(event, cb, !1);
        }
        function removeListener(w, event, cb) {
            w.detachEvent ? w.detachEvent("on" + event, cb) : w.removeEventListener && w.removeEventListener(event, cb, !1);
        }
        function extractOrigin(url) {
            /^https?:\/\//.test(url) || (url = window.location.href);
            var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
            return m ? m[1] : url;
        }
        var isIE = function() {
            if ("undefined" == typeof navigator) return !1;
            var rv = -1, ua = navigator.userAgent;
            if ("Microsoft Internet Explorer" === navigator.appName) null != new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));
            else if (ua.indexOf("Trident") > -1) null !== new RegExp("rv:([0-9]{2,2}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));
            return rv >= 8;
        }();
        return "undefined" != typeof window && window.JSON && window.JSON.stringify && window.JSON.parse && window.postMessage ? {
            open: function(opts, cb) {
                if (!cb) throw "missing required callback argument";
                var err, iframe;
                opts.url || (err = "missing required 'url' parameter"), opts.relay_url || (err = "missing required 'relay_url' parameter"), err && setTimeout(function() {
                    cb(err);
                }, 0), opts.window_name || (opts.window_name = null), opts.window_features && !function() {
                    try {
                        var userAgent = navigator.userAgent;
                        return -1 != userAgent.indexOf("Fennec/") || -1 != userAgent.indexOf("Firefox/") && -1 != userAgent.indexOf("Android");
                    } catch (e) {}
                    return !1;
                }() || (opts.window_features = void 0);
                var messageTarget, origin = opts.origin || extractOrigin(opts.url);
                if (origin !== extractOrigin(opts.relay_url)) return setTimeout(function() {
                    cb("invalid arguments: origin of url and relay_url must match");
                }, 0);
                isIE && ((iframe = document.createElement("iframe")).setAttribute("src", opts.relay_url), iframe.style.display = "none", iframe.setAttribute("name", "__winchan_relay_frame"), document.body.appendChild(iframe), messageTarget = iframe.contentWindow);
                var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
                opts.popup && (w.location.href = opts.url), messageTarget || (messageTarget = w);
                var closeInterval = setInterval(function() {
                    w && w.closed && (cleanup(), cb && (cb("User closed the popup window"), cb = null));
                }, 500), req = JSON.stringify({
                    a: "request",
                    d: opts.params
                });
                function cleanup() {
                    if (iframe && document.body.removeChild(iframe), iframe = void 0, closeInterval && (closeInterval = clearInterval(closeInterval)), removeListener(window, "message", onMessage), removeListener(window, "unload", cleanup), w) try {
                        w.close();
                    } catch (securityViolation) {
                        messageTarget.postMessage("die", origin);
                    }
                    w = messageTarget = void 0;
                }
                function onMessage(e) {
                    if (e.origin === origin) {
                        try {
                            var d = JSON.parse(e.data);
                        } catch (err) {
                            if (cb) return cb(err);
                            throw err;
                        }
                        "ready" === d.a ? messageTarget.postMessage(req, origin) : "error" === d.a ? (cleanup(), cb && (cb(d.d), cb = null)) : "response" === d.a && (cleanup(), cb && (cb(null, d.d), cb = null));
                    }
                }
                return addListener(window, "unload", cleanup), addListener(window, "message", onMessage), {
                    originalPopup: w,
                    close: cleanup,
                    focus: function() {
                        if (w) try {
                            w.focus();
                        } catch (e) {}
                    }
                };
            },
            onOpen: function(cb) {
                var o = "*", msgTarget = isIE ? function() {
                    for(var frames = window.opener.frames, i = frames.length - 1; i >= 0; i--)try {
                        if (frames[i].location.protocol === window.location.protocol && frames[i].location.host === window.location.host && "__winchan_relay_frame" === frames[i].name) return frames[i];
                    } catch (e) {}
                }() : window.opener;
                if (!msgTarget) throw "can't find relay frame";
                function doPost(msg) {
                    msg = JSON.stringify(msg), isIE ? msgTarget.doPost(msg, o) : msgTarget.postMessage(msg, o);
                }
                function onDie(e) {
                    if ("die" === e.data) try {
                        window.close();
                    } catch (o_O) {}
                }
                addListener(isIE ? msgTarget : window, "message", function onMessage(e) {
                    var d;
                    try {
                        d = JSON.parse(e.data);
                    } catch (err) {}
                    d && "request" === d.a && (removeListener(window, "message", onMessage), o = e.origin, cb && setTimeout(function() {
                        cb(o, d.d, function(r) {
                            cb = void 0, doPost({
                                a: "response",
                                d: r
                            });
                        });
                    }, 0));
                }), addListener(isIE ? msgTarget : window, "message", onDie);
                try {
                    doPost({
                        a: "ready"
                    });
                } catch (e) {
                    addListener(msgTarget, "load", function(e) {
                        doPost({
                            a: "ready"
                        });
                    });
                }
                var onUnload = function() {
                    try {
                        removeListener(isIE ? msgTarget : window, "message", onDie);
                    } catch (ohWell) {}
                    cb && doPost({
                        a: "error",
                        d: "client closed window"
                    }), cb = void 0;
                    try {
                        window.close();
                    } catch (e) {}
                };
                return addListener(window, "unload", onUnload), {
                    detach: function() {
                        removeListener(window, "unload", onUnload);
                    }
                };
            }
        } : {
            open: function(url, winopts, arg, cb) {
                setTimeout(function() {
                    cb("unsupported browser");
                }, 0);
            },
            onOpen: function(cb) {
                setTimeout(function() {
                    cb("unsupported browser");
                }, 0);
            }
        };
    }();
    module.exports && (module.exports = WinChan);
});
var $51679e17ad633b30$var$urlHelper = {
    extractOrigin: function(url) {
        /^https?:\/\//.test(url) || (url = window.location.href);
        var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
        return m ? m[1] : url;
    }
};
function $51679e17ad633b30$var$PopupHandler() {
    this._current_popup = null;
}
function $51679e17ad633b30$var$Popup(webAuth, options) {
    this.baseOptions = options, this.baseOptions.popupOrigin = options.popupOrigin, this.client = webAuth.client, this.webAuth = webAuth, this.transactionManager = new $51679e17ad633b30$var$TransactionManager(this.baseOptions), this.crossOriginAuthentication = new $51679e17ad633b30$var$CrossOriginAuthentication(webAuth, this.baseOptions), this.warn = new $51679e17ad633b30$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
function $51679e17ad633b30$var$SilentAuthenticationHandler(options) {
    this.authenticationUrl = options.authenticationUrl, this.timeout = options.timeout || 6e4, this.handler = null, this.postMessageDataType = options.postMessageDataType || !1, this.postMessageOrigin = options.postMessageOrigin || $51679e17ad633b30$var$windowHelper.getWindow().location.origin || $51679e17ad633b30$var$windowHelper.getWindow().location.protocol + "//" + $51679e17ad633b30$var$windowHelper.getWindow().location.hostname + ($51679e17ad633b30$var$windowHelper.getWindow().location.port ? ":" + $51679e17ad633b30$var$windowHelper.getWindow().location.port : "");
}
function $51679e17ad633b30$var$UsernamePassword(options) {
    this.baseOptions = options, this.request = new $51679e17ad633b30$var$RequestBuilder(options), this.transactionManager = new $51679e17ad633b30$var$TransactionManager(this.baseOptions);
}
function $51679e17ad633b30$var$HostedPages(client, options) {
    this.baseOptions = options, this.client = client, this.baseOptions.universalLoginPage = !0, this.request = new $51679e17ad633b30$var$RequestBuilder(this.baseOptions), this.warn = new $51679e17ad633b30$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    });
}
$51679e17ad633b30$var$PopupHandler.prototype.calculatePosition = function(options) {
    var width = options.width || 500, height = options.height || 600, _window = $51679e17ad633b30$var$windowHelper.getWindow(), screenX = void 0 !== _window.screenX ? _window.screenX : _window.screenLeft, screenY = void 0 !== _window.screenY ? _window.screenY : _window.screenTop, outerWidth = void 0 !== _window.outerWidth ? _window.outerWidth : _window.document.body.clientWidth, outerHeight = void 0 !== _window.outerHeight ? _window.outerHeight : _window.document.body.clientHeight;
    return {
        width: width,
        height: height,
        left: options.left || screenX + (outerWidth - width) / 2,
        top: options.top || screenY + (outerHeight - height) / 2
    };
}, $51679e17ad633b30$var$PopupHandler.prototype.preload = function(options) {
    var _this = this, _window = $51679e17ad633b30$var$windowHelper.getWindow(), popupPosition = this.calculatePosition(options.popupOptions || {}), popupOptions = $51679e17ad633b30$var$objectHelper.merge(popupPosition).with(options.popupOptions), url = options.url || "about:blank", windowFeatures = $51679e17ad633b30$var$lib_stringify(popupOptions, {
        encode: !1,
        delimiter: ","
    });
    return this._current_popup && !this._current_popup.closed || (this._current_popup = _window.open(url, "auth0_signup_popup", windowFeatures), this._current_popup.kill = function() {
        this.close(), _this._current_popup = null;
    }), this._current_popup;
}, $51679e17ad633b30$var$PopupHandler.prototype.load = function(url, relayUrl, options, cb) {
    var _this = this, popupPosition = this.calculatePosition(options.popupOptions || {}), popupOptions = $51679e17ad633b30$var$objectHelper.merge(popupPosition).with(options.popupOptions), winchanOptions = $51679e17ad633b30$var$objectHelper.merge({
        url: url,
        relay_url: relayUrl,
        window_features: $51679e17ad633b30$var$lib_stringify(popupOptions, {
            delimiter: ",",
            encode: !1
        }),
        popup: this._current_popup
    }).with(options), popup = $51679e17ad633b30$var$winchan.open(winchanOptions, function(err, data) {
        if (!err || "SyntaxError" !== err.name) return _this._current_popup = null, cb(err, data);
    });
    return popup.focus(), popup;
}, $51679e17ad633b30$var$Popup.prototype.buildPopupHandler = function() {
    var pluginHandler = this.baseOptions.plugins.get("popup.getPopupHandler");
    return pluginHandler ? pluginHandler.getPopupHandler() : new $51679e17ad633b30$var$PopupHandler;
}, $51679e17ad633b30$var$Popup.prototype.preload = function(options) {
    options = options || {};
    var popup = this.buildPopupHandler();
    return popup.preload(options), popup;
}, $51679e17ad633b30$var$Popup.prototype.getPopupHandler = function(options, preload) {
    return options.popupHandler ? options.popupHandler : preload ? this.preload(options) : this.buildPopupHandler();
}, $51679e17ad633b30$var$Popup.prototype.callback = function(options) {
    var _this = this, theWindow = $51679e17ad633b30$var$windowHelper.getWindow(), originUrl = (options = options || {}).popupOrigin || this.baseOptions.popupOrigin || $51679e17ad633b30$var$windowHelper.getOrigin();
    theWindow.opener ? $51679e17ad633b30$var$winchan.onOpen(function(popupOrigin, r, cb) {
        if (popupOrigin !== originUrl) return cb({
            error: "origin_mismatch",
            error_description: "The popup's origin (" + popupOrigin + ") should match the `popupOrigin` parameter (" + originUrl + ")."
        });
        _this.webAuth.parseHash(options || {}, function(err, data) {
            return cb(err || data);
        });
    }) : theWindow.doPost = function(msg) {
        theWindow.parent && theWindow.parent.postMessage(msg, originUrl);
    };
}, $51679e17ad633b30$var$Popup.prototype.authorize = function(options, cb) {
    var url, relayUrl, popOpts = {}, pluginHandler = this.baseOptions.plugins.get("popup.authorize"), params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope",
        "domain",
        "audience",
        "tenant",
        "responseType",
        "redirectUri",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "organization",
        "invitation"
    ]).with($51679e17ad633b30$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]));
    return $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), relayUrl = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "relay.html"), options.owp ? params.owp = !0 : (popOpts.origin = $51679e17ad633b30$var$urlHelper.extractOrigin(params.redirectUri), relayUrl = params.redirectUri), options.popupOptions && (popOpts.popupOptions = $51679e17ad633b30$var$objectHelper.pick(options.popupOptions, [
        "width",
        "height",
        "top",
        "left"
    ])), pluginHandler && (params = pluginHandler.processParams(params)), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", delete params.domain, url = this.client.buildAuthorizeUrl(params), this.getPopupHandler(options).load(url, relayUrl, popOpts, $51679e17ad633b30$var$wrapCallback(cb, {
        keepOriginalCasing: !0
    }));
}, $51679e17ad633b30$var$Popup.prototype.loginWithCredentials = function(options, cb) {
    options.realm = options.realm || options.connection, options.popup = !0, options = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "redirectUri",
        "responseType",
        "state",
        "nonce"
    ]).with($51679e17ad633b30$var$objectHelper.blacklist(options, [
        "popupHandler",
        "connection"
    ])), options = this.transactionManager.process(options), this.crossOriginAuthentication.login(options, cb);
}, $51679e17ad633b30$var$Popup.prototype.passwordlessVerify = function(options, cb) {
    var _this = this;
    return this.client.passwordless.verify($51679e17ad633b30$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]), function(err) {
        if (err) return cb(err);
        options.username = options.phoneNumber || options.email, options.password = options.verificationCode, delete options.email, delete options.phoneNumber, delete options.verificationCode, delete options.type, _this.client.loginWithResourceOwner(options, cb);
    });
}, $51679e17ad633b30$var$Popup.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return this.client.dbConnection.signup(options, function(err) {
        if (err) return cb(err);
        _this.loginWithCredentials(options, cb);
    });
}, $51679e17ad633b30$var$SilentAuthenticationHandler.create = function(options) {
    return new $51679e17ad633b30$var$SilentAuthenticationHandler(options);
}, $51679e17ad633b30$var$SilentAuthenticationHandler.prototype.login = function(usePostMessage, callback) {
    this.handler = new $51679e17ad633b30$var$IframeHandler({
        auth0: this.auth0,
        url: this.authenticationUrl,
        eventListenerType: usePostMessage ? "message" : "load",
        callback: this.getCallbackHandler(callback, usePostMessage),
        timeout: this.timeout,
        eventValidator: this.getEventValidator(),
        timeoutCallback: function() {
            callback(null, "#error=timeout&error_description=Timeout+during+authentication+renew.");
        },
        usePostMessage: usePostMessage || !1
    }), this.handler.init();
}, $51679e17ad633b30$var$SilentAuthenticationHandler.prototype.getEventValidator = function() {
    var _this = this;
    return {
        isValid: function(eventData) {
            switch(eventData.event.type){
                case "message":
                    return eventData.event.origin === _this.postMessageOrigin && eventData.event.source === _this.handler.iframe.contentWindow && (!1 === _this.postMessageDataType || eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType);
                case "load":
                    if ("about:" === eventData.sourceObject.contentWindow.location.protocol) return !1;
                default:
                    return !0;
            }
        }
    };
}, $51679e17ad633b30$var$SilentAuthenticationHandler.prototype.getCallbackHandler = function(callback, usePostMessage) {
    return function(eventData) {
        var callbackValue;
        callbackValue = usePostMessage ? "object" == typeof eventData.event.data && eventData.event.data.hash ? eventData.event.data.hash : eventData.event.data : eventData.sourceObject.contentWindow.location.hash, callback(null, callbackValue);
    };
}, $51679e17ad633b30$var$UsernamePassword.prototype.login = function(options, cb) {
    var url, body;
    return url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "usernamepassword", "login"), options.username = options.username || options.email, options = $51679e17ad633b30$var$objectHelper.blacklist(options, [
        "email",
        "onRedirecting"
    ]), body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "tenant",
        "responseType",
        "responseMode",
        "scope",
        "audience"
    ]).with(options), body = this.transactionManager.process(body), body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$var$UsernamePassword.prototype.callback = function(formHtml) {
    var div, _document = $51679e17ad633b30$var$windowHelper.getDocument();
    (div = _document.createElement("div")).innerHTML = formHtml, _document.body.appendChild(div).children[0].submit();
}, $51679e17ad633b30$var$HostedPages.prototype.login = function(options, cb) {
    if ($51679e17ad633b30$var$windowHelper.getWindow().location.host !== this.baseOptions.domain) throw new Error("This method is meant to be used only inside the Universal Login Page.");
    var usernamePassword, params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "tenant",
        "responseType",
        "responseMode",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    return $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), (usernamePassword = new $51679e17ad633b30$var$UsernamePassword(this.baseOptions)).login(params, function(err, data) {
        if (err) return cb(err);
        function doAuth() {
            usernamePassword.callback(data);
        }
        if ("function" == typeof options.onRedirecting) return options.onRedirecting(function() {
            doAuth();
        });
        doAuth();
    });
}, $51679e17ad633b30$var$HostedPages.prototype.signupAndLogin = function(options, cb) {
    var _this = this;
    return _this.client.client.dbConnection.signup(options, function(err) {
        return err ? cb(err) : _this.login(options, cb);
    });
}, $51679e17ad633b30$var$HostedPages.prototype.getSSOData = function(withActiveDirectories, cb) {
    var url, params = "";
    return "function" == typeof withActiveDirectories && (cb = withActiveDirectories, withActiveDirectories = !1), $51679e17ad633b30$var$assert.check(withActiveDirectories, {
        type: "boolean",
        message: "withActiveDirectories parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), withActiveDirectories && (params = "?" + $51679e17ad633b30$var$lib_stringify({
        ldaps: 1,
        client_id: this.baseOptions.clientID
    })), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "user", "ssodata", params), this.request.get(url, {
        noHeaders: !0
    }).withCredentials().end($51679e17ad633b30$var$wrapCallback(cb));
};
var $51679e17ad633b30$var$noop = function() {}, $51679e17ad633b30$var$defaults$2 = {
    lang: "en",
    templates: {
        auth0: function(challenge) {
            var message = "code" === challenge.type ? "Enter the code shown above" : "Solve the formula shown above";
            return '<div class="captcha-challenge">\n  <img src="' + challenge.image + '" />\n  <button type="button" class="captcha-reload">\u21BA</button>\n</div>\n<input type="text" name="captcha"\n  class="form-control captcha-control"\n  placeholder="' + message + '" />';
        },
        recaptcha_v2: function() {
            return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
        },
        recaptcha_enterprise: function() {
            return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
        },
        error: function() {
            return '<div class="error" style="color: red;">Error getting the bot detection challenge. Please contact the system administrator.</div>';
        }
    }
};
function $51679e17ad633b30$var$globalForRecaptchaProvider(provider) {
    switch(provider){
        case "recaptcha_v2":
            return window.grecaptcha;
        case "recaptcha_enterprise":
            return window.grecaptcha.enterprise;
        default:
            throw new Error("Unknown captcha provider");
    }
}
function $51679e17ad633b30$var$injectRecaptchaScript(element, opts, callback) {
    var callbackName = "recaptchaCallback_" + Math.floor(1000001 * Math.random());
    window[callbackName] = function() {
        delete window[callbackName], callback();
    };
    var script = window.document.createElement("script");
    script.src = function(provider, lang, callback) {
        switch(provider){
            case "recaptcha_v2":
                return "https://www.recaptcha.net/recaptcha/api.js?hl=" + lang + "&onload=" + callback;
            case "recaptcha_enterprise":
                return "https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit&hl=" + lang + "&onload=" + callback;
            default:
                throw new Error("Unknown captcha provider");
        }
    }(opts.provider, opts.lang, callbackName), script.async = !0, window.document.body.appendChild(script);
}
var $51679e17ad633b30$var$captcha = {
    render: function(auth0Client, element, options, callback) {
        function load(done) {
            done = done || $51679e17ad633b30$var$noop, auth0Client.getChallenge(function(err, challenge) {
                return err ? (element.innerHTML = options.templates.error(err), done(err)) : challenge.required ? (element.style.display = "", "auth0" === challenge.provider ? function(element, options, challenge, load) {
                    element.innerHTML = options.templates[challenge.provider](challenge), element.querySelector(".captcha-reload").addEventListener("click", function(e) {
                        e.preventDefault(), load();
                    });
                }(element, options, challenge, load) : "recaptcha_v2" !== challenge.provider && "recaptcha_enterprise" !== challenge.provider || function(element, options, challenge) {
                    var widgetId = element.hasAttribute("data-wid") && element.getAttribute("data-wid");
                    function setValue(value) {
                        element.querySelector('input[name="captcha"]').value = value || "";
                    }
                    if (widgetId) return setValue(), void $51679e17ad633b30$var$globalForRecaptchaProvider(challenge.provider).reset(widgetId);
                    element.innerHTML = options.templates[challenge.provider](challenge);
                    var recaptchaDiv = element.querySelector(".recaptcha");
                    $51679e17ad633b30$var$injectRecaptchaScript(0, {
                        lang: options.lang,
                        provider: challenge.provider
                    }, function() {
                        var global1 = $51679e17ad633b30$var$globalForRecaptchaProvider(challenge.provider);
                        widgetId = global1.render(recaptchaDiv, {
                            callback: setValue,
                            "expired-callback": function() {
                                setValue();
                            },
                            "error-callback": function() {
                                setValue();
                            },
                            sitekey: challenge.siteKey
                        }), element.setAttribute("data-wid", widgetId);
                    });
                }(element, options, challenge), void done()) : (element.style.display = "none", void (element.innerHTML = ""));
            });
        }
        return options = $51679e17ad633b30$var$objectHelper.merge($51679e17ad633b30$var$defaults$2).with(options || {}), load(callback), {
            reload: load,
            getValue: function() {
                var captchaInput = element.querySelector('input[name="captcha"]');
                if (captchaInput) return captchaInput.value;
            }
        };
    }
};
function $51679e17ad633b30$var$defaultClock() {
    return new Date;
}
function $51679e17ad633b30$export$d1b7252873cb8575(options) {
    $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        responseType: {
            optional: !0,
            type: "string",
            message: "responseType is not valid"
        },
        responseMode: {
            optional: !0,
            type: "string",
            message: "responseMode is not valid"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri is not valid"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope is not valid"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience is not valid"
        },
        popupOrigin: {
            optional: !0,
            type: "string",
            message: "popupOrigin is not valid"
        },
        leeway: {
            optional: !0,
            type: "number",
            message: "leeway is not valid"
        },
        plugins: {
            optional: !0,
            type: "array",
            message: "plugins is not valid"
        },
        maxAge: {
            optional: !0,
            type: "number",
            message: "maxAge is not valid"
        },
        _disableDeprecationWarnings: {
            optional: !0,
            type: "boolean",
            message: "_disableDeprecationWarnings option is not valid"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        },
        _timesToRetryFailedRequests: {
            optional: !0,
            type: "number",
            message: "_timesToRetryFailedRequests option is not valid"
        }
    }), options.overrides && $51679e17ad633b30$var$assert.check(options.overrides, {
        type: "object",
        message: "overrides option is not valid"
    }, {
        __tenant: {
            optional: !0,
            type: "string",
            message: "__tenant option is required"
        },
        __token_issuer: {
            optional: !0,
            type: "string",
            message: "__token_issuer option is required"
        },
        __jwks_uri: {
            optional: !0,
            type: "string",
            message: "__jwks_uri is required"
        }
    }), this.baseOptions = options, this.baseOptions.plugins = new $51679e17ad633b30$var$PluginHandler(this, this.baseOptions.plugins || []), this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions._timesToRetryFailedRequests = options._timesToRetryFailedRequests ? parseInt(options._timesToRetryFailedRequests, 0) : 0, this.baseOptions.tenant = this.baseOptions.overrides && this.baseOptions.overrides.__tenant || this.baseOptions.domain.split(".")[0], this.baseOptions.token_issuer = this.baseOptions.overrides && this.baseOptions.overrides.__token_issuer || "https://" + this.baseOptions.domain + "/", this.baseOptions.jwksURI = this.baseOptions.overrides && this.baseOptions.overrides.__jwks_uri, this.transactionManager = new $51679e17ad633b30$var$TransactionManager(this.baseOptions), this.client = new $51679e17ad633b30$export$d9e3c9dc7eaad0c3(this.baseOptions), this.redirect = new $51679e17ad633b30$var$Redirect(this, this.baseOptions), this.popup = new $51679e17ad633b30$var$Popup(this, this.baseOptions), this.crossOriginAuthentication = new $51679e17ad633b30$var$CrossOriginAuthentication(this, this.baseOptions), this.webMessageHandler = new $51679e17ad633b30$var$WebMessageHandler(this), this._universalLogin = new $51679e17ad633b30$var$HostedPages(this, this.baseOptions), this.ssodataStorage = new $51679e17ad633b30$var$SSODataStorage(this.baseOptions);
}
function $51679e17ad633b30$var$PasswordlessAuthentication(request, options) {
    this.baseOptions = options, this.request = request;
}
function $51679e17ad633b30$var$DBConnection(request, options) {
    this.baseOptions = options, this.request = request;
}
function $51679e17ad633b30$export$d9e3c9dc7eaad0c3(auth0, options) {
    2 === arguments.length ? this.auth0 = auth0 : options = auth0, $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        responseType: {
            optional: !0,
            type: "string",
            message: "responseType is not valid"
        },
        responseMode: {
            optional: !0,
            type: "string",
            message: "responseMode is not valid"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri is not valid"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope is not valid"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience is not valid"
        },
        _disableDeprecationWarnings: {
            optional: !0,
            type: "boolean",
            message: "_disableDeprecationWarnings option is not valid"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        }
    }), this.baseOptions = options, this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions.rootUrl = this.baseOptions.domain && 0 === this.baseOptions.domain.toLowerCase().indexOf("http") ? this.baseOptions.domain : "https://" + this.baseOptions.domain, this.request = new $51679e17ad633b30$var$RequestBuilder(this.baseOptions), this.passwordless = new $51679e17ad633b30$var$PasswordlessAuthentication(this.request, this.baseOptions), this.dbConnection = new $51679e17ad633b30$var$DBConnection(this.request, this.baseOptions), this.warn = new $51679e17ad633b30$var$Warn({
        disableWarnings: !!options._disableDeprecationWarnings
    }), this.ssodataStorage = new $51679e17ad633b30$var$SSODataStorage(this.baseOptions);
}
function $51679e17ad633b30$export$cbb26d9fbbee6ab2(options) {
    $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        domain: {
            type: "string",
            message: "domain option is required"
        },
        token: {
            type: "string",
            message: "token option is required"
        },
        _sendTelemetry: {
            optional: !0,
            type: "boolean",
            message: "_sendTelemetry option is not valid"
        },
        _telemetryInfo: {
            optional: !0,
            type: "object",
            message: "_telemetryInfo option is not valid"
        }
    }), this.baseOptions = options, this.baseOptions.headers = {
        Authorization: "Bearer " + this.baseOptions.token
    }, this.request = new $51679e17ad633b30$var$RequestBuilder(this.baseOptions), this.baseOptions.rootUrl = $51679e17ad633b30$var$urlJoin("https://" + this.baseOptions.domain, "api", "v2");
}
$51679e17ad633b30$export$d1b7252873cb8575.prototype.parseHash = function(options, cb) {
    var parsedQs, err;
    cb || "function" != typeof options ? options = options || {} : (cb = options, options = {});
    var _window = $51679e17ad633b30$var$windowHelper.getWindow(), hashStr = void 0 === options.hash ? _window.location.hash : options.hash;
    if (hashStr = hashStr.replace(/^#?\/?/, ""), (parsedQs = $51679e17ad633b30$var$lib_parse(hashStr)).hasOwnProperty("error")) return err = $51679e17ad633b30$var$error.buildResponse(parsedQs.error, parsedQs.error_description), parsedQs.state && (err.state = parsedQs.state), cb(err);
    if (!parsedQs.hasOwnProperty("access_token") && !parsedQs.hasOwnProperty("id_token") && !parsedQs.hasOwnProperty("refresh_token")) return cb(null, null);
    var responseTypes = (this.baseOptions.responseType || options.responseType || "").split(" ");
    return responseTypes.length > 0 && -1 !== responseTypes.indexOf("token") && !parsedQs.hasOwnProperty("access_token") ? cb($51679e17ad633b30$var$error.buildResponse("invalid_hash", "response_type contains `token`, but the parsed hash does not contain an `access_token` property")) : responseTypes.length > 0 && -1 !== responseTypes.indexOf("id_token") && !parsedQs.hasOwnProperty("id_token") ? cb($51679e17ad633b30$var$error.buildResponse("invalid_hash", "response_type contains `id_token`, but the parsed hash does not contain an `id_token` property")) : this.validateAuthenticationResponse(options, parsedQs, cb);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.validateAuthenticationResponse = function(options, parsedHash, cb) {
    var _this = this;
    options.__enableIdPInitiatedLogin = options.__enableIdPInitiatedLogin || options.__enableImpersonation;
    var state = parsedHash.state, transaction = this.transactionManager.getStoredTransaction(state), transactionState = options.state || transaction && transaction.state || null, transactionStateMatchesState = transactionState === state;
    if (!(!state && !transactionState && options.__enableIdPInitiatedLogin) && !transactionStateMatchesState) return cb({
        error: "invalid_token",
        errorDescription: "`state` does not match."
    });
    var transactionNonce = options.nonce || transaction && transaction.nonce || null, transactionOrganization = transaction && transaction.organization, appState = options.state || transaction && transaction.appState || null, callback = function(err, payload) {
        if (err) return cb(err);
        var sub;
        transaction && transaction.lastUsedConnection && (payload && (sub = payload.sub), _this.ssodataStorage.set(transaction.lastUsedConnection, sub));
        return cb(null, function(qsParams, appState, token) {
            return {
                accessToken: qsParams.access_token || null,
                idToken: qsParams.id_token || null,
                idTokenPayload: token || null,
                appState: appState || null,
                refreshToken: qsParams.refresh_token || null,
                state: qsParams.state || null,
                expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
                tokenType: qsParams.token_type || null,
                scope: qsParams.scope || null
            };
        }(parsedHash, appState, payload));
    };
    return parsedHash.id_token ? this.validateToken(parsedHash.id_token, transactionNonce, function(validationError, payload) {
        if (!validationError) {
            if (transactionOrganization) {
                if (!payload.org_id) return callback($51679e17ad633b30$var$error.invalidToken("Organization Id (org_id) claim must be a string present in the ID token"));
                if (payload.org_id !== transactionOrganization) return callback($51679e17ad633b30$var$error.invalidToken('Organization Id (org_id) claim value mismatch in the ID token; expected "' + transactionOrganization + '", found "' + payload.org_id + '"'));
            }
            return parsedHash.access_token && payload.at_hash ? (new $51679e17ad633b30$var$I).validateAccessToken(parsedHash.access_token, "RS256", payload.at_hash, function(err) {
                return err ? callback($51679e17ad633b30$var$error.invalidToken(err.message)) : callback(null, payload);
            }) : callback(null, payload);
        }
        if ("invalid_token" !== validationError.error || validationError.errorDescription && validationError.errorDescription.indexOf("Nonce (nonce) claim value mismatch in the ID token") > -1) return callback(validationError);
        var decodedToken = (new $51679e17ad633b30$var$I).decode(parsedHash.id_token);
        if ("HS256" !== decodedToken.header.alg) return callback(validationError);
        if ((decodedToken.payload.nonce || null) !== transactionNonce) return callback({
            error: "invalid_token",
            errorDescription: 'Nonce (nonce) claim value mismatch in the ID token; expected "' + transactionNonce + '", found "' + decodedToken.payload.nonce + '"'
        });
        if (!parsedHash.access_token) return callback({
            error: "invalid_token",
            description: "The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can\u2019t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token"
        });
        return _this.client.userInfo(parsedHash.access_token, function(errUserInfo, profile) {
            return errUserInfo ? callback(errUserInfo) : callback(null, profile);
        });
    }) : callback(null, null);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.validateToken = function(token, nonce, cb) {
    new $51679e17ad633b30$var$I({
        issuer: this.baseOptions.token_issuer,
        jwksURI: this.baseOptions.jwksURI,
        audience: this.baseOptions.clientID,
        leeway: this.baseOptions.leeway || 60,
        maxAge: this.baseOptions.maxAge,
        __clock: this.baseOptions.__clock || $51679e17ad633b30$var$defaultClock
    }).verify(token, nonce, function(err, payload) {
        if (err) return cb($51679e17ad633b30$var$error.invalidToken(err.message));
        cb(null, payload);
    });
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.renewAuth = function(options, cb) {
    var usePostMessage = !!options.usePostMessage, postMessageDataType = options.postMessageDataType || !1, postMessageOrigin = options.postMessageOrigin || $51679e17ad633b30$var$windowHelper.getWindow().origin, timeout = options.timeout, _this = this, params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "redirectUri",
        "responseType",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    params.responseType = params.responseType || "token", params.responseMode = params.responseMode || "fragment", params = this.transactionManager.process(params), $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), params.prompt = "none", params = $51679e17ad633b30$var$objectHelper.blacklist(params, [
        "usePostMessage",
        "tenant",
        "postMessageDataType",
        "postMessageOrigin"
    ]), $51679e17ad633b30$var$SilentAuthenticationHandler.create({
        authenticationUrl: this.client.buildAuthorizeUrl(params),
        postMessageDataType: postMessageDataType,
        postMessageOrigin: postMessageOrigin,
        timeout: timeout
    }).login(usePostMessage, function(err, hash) {
        if ("object" == typeof hash) return cb(err, hash);
        _this.parseHash({
            hash: hash
        }, cb);
    });
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.checkSession = function(options, cb) {
    var params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options);
    return "code" === params.responseType ? cb({
        error: "error",
        error_description: "responseType can't be `code`"
    }) : (options.nonce || (params = this.transactionManager.process(params)), params.redirectUri ? ($51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), params = $51679e17ad633b30$var$objectHelper.blacklist(params, [
        "usePostMessage",
        "tenant",
        "postMessageDataType"
    ]), void this.webMessageHandler.run(params, $51679e17ad633b30$var$wrapCallback(cb, {
        forceLegacyError: !0,
        ignoreCasing: !0
    }))) : cb({
        error: "error",
        error_description: "redirectUri can't be empty"
    }));
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.changePassword = function(options, cb) {
    return this.client.dbConnection.changePassword(options, cb);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.passwordlessStart = function(options, cb) {
    var authParams = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce"
    ]).with(options.authParams);
    return options.authParams = this.transactionManager.process(authParams), this.client.passwordless.start(options, cb);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.signup = function(options, cb) {
    return this.client.dbConnection.signup(options, cb);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.authorize = function(options) {
    var params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "organization",
        "invitation"
    ]).with(options);
    $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", $51679e17ad633b30$var$windowHelper.redirect(this.client.buildAuthorizeUrl(params));
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.signupAndAuthorize = function(options, cb) {
    var _this = this;
    return this.client.dbConnection.signup($51679e17ad633b30$var$objectHelper.blacklist(options, [
        "popupHandler"
    ]), function(err) {
        if (err) return cb(err);
        options.realm = options.connection, options.username || (options.username = options.email), _this.client.login(options, cb);
    });
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.login = function(options, cb) {
    var params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting",
        "organization",
        "invitation"
    ]).with(options);
    params = this.transactionManager.process(params), $51679e17ad633b30$var$windowHelper.getWindow().location.host === this.baseOptions.domain ? (params.connection = params.realm, delete params.realm, this._universalLogin.login(params, cb)) : this.crossOriginAuthentication.login(params, cb);
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.passwordlessLogin = function(options, cb) {
    var params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting"
    ]).with(options);
    if (params = this.transactionManager.process(params), $51679e17ad633b30$var$windowHelper.getWindow().location.host === this.baseOptions.domain) this.passwordlessVerify(params, cb);
    else {
        var crossOriginOptions = $51679e17ad633b30$var$objectHelper.extend({
            credentialType: "http://auth0.com/oauth/grant-type/passwordless/otp",
            realm: params.connection,
            username: params.email || params.phoneNumber,
            otp: params.verificationCode
        }, $51679e17ad633b30$var$objectHelper.blacklist(params, [
            "connection",
            "email",
            "phoneNumber",
            "verificationCode"
        ]));
        this.crossOriginAuthentication.login(crossOriginOptions, cb);
    }
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.crossOriginAuthenticationCallback = function() {
    this.crossOriginVerification();
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.crossOriginVerification = function() {
    this.crossOriginAuthentication.callback();
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.logout = function(options) {
    $51679e17ad633b30$var$windowHelper.redirect(this.client.buildLogoutUrl(options));
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.passwordlessVerify = function(options, cb) {
    var _this = this, params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "nonce",
        "onRedirecting"
    ]).with(options);
    return $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        responseType: {
            type: "string",
            message: "responseType option is required"
        }
    }), params = this.transactionManager.process(params), this.client.passwordless.verify(params, function(err) {
        if (err) return cb(err);
        function doAuth() {
            $51679e17ad633b30$var$windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params));
        }
        if ("function" == typeof options.onRedirecting) return options.onRedirecting(function() {
            doAuth();
        });
        doAuth();
    });
}, $51679e17ad633b30$export$d1b7252873cb8575.prototype.renderCaptcha = function(element, options, callback) {
    return $51679e17ad633b30$var$captcha.render(this.client, element, options, callback);
}, $51679e17ad633b30$var$PasswordlessAuthentication.prototype.buildVerifyUrl = function(options) {
    var params, qString;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        verificationCode: {
            type: "string",
            message: "verificationCode option is required"
        },
        phoneNumber: {
            optional: !1,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return !o.email;
            }
        },
        email: {
            optional: !1,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return !o.phoneNumber;
            }
        }
    }), params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience",
        "_csrf",
        "state",
        "_intstate",
        "protocol",
        "nonce"
    ]).with(options), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = $51679e17ad633b30$var$objectHelper.toSnakeCase(params, [
        "auth0Client"
    ]), qString = $51679e17ad633b30$var$lib_stringify(params), $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "verify_redirect", "?" + qString);
}, $51679e17ad633b30$var$PasswordlessAuthentication.prototype.start = function(options, cb) {
    var url, body;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        send: {
            type: "string",
            message: "send option is required",
            values: [
                "link",
                "code"
            ],
            value_message: "send is not valid ([link, code])"
        },
        phoneNumber: {
            optional: !0,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return "code" === o.send || !o.email;
            }
        },
        email: {
            optional: !0,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return "link" === o.send || !o.phoneNumber;
            }
        },
        authParams: {
            optional: !0,
            type: "object",
            message: "authParams option is required"
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "start"), (body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "redirectUri",
        "scope"
    ]).with(options)).scope && (body.authParams = body.authParams || {}, body.authParams.scope = body.authParams.scope || body.scope), body.redirectUri && (body.authParams = body.authParams || {}, body.authParams.redirect_uri = body.authParams.redirectUri || body.redirectUri), body.responseType && (body.authParams = body.authParams || {}, body.authParams.response_type = body.authParams.responseType || body.responseType), delete body.redirectUri, delete body.responseType, delete body.scope, body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client",
        "authParams"
    ]), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$var$PasswordlessAuthentication.prototype.verify = function(options, cb) {
    var url, cleanOption;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        verificationCode: {
            type: "string",
            message: "verificationCode option is required"
        },
        phoneNumber: {
            optional: !1,
            type: "string",
            message: "phoneNumber option is required",
            condition: function(o) {
                return !o.email;
            }
        },
        email: {
            optional: !1,
            type: "string",
            message: "email option is required",
            condition: function(o) {
                return !o.phoneNumber;
            }
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), cleanOption = $51679e17ad633b30$var$objectHelper.pick(options, [
        "connection",
        "verificationCode",
        "phoneNumber",
        "email",
        "auth0Client",
        "clientID"
    ]), cleanOption = $51679e17ad633b30$var$objectHelper.toSnakeCase(cleanOption, [
        "auth0Client"
    ]), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "passwordless", "verify"), this.request.post(url).send(cleanOption).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$var$DBConnection.prototype.signup = function(options, cb) {
    var url, body, metadata;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        email: {
            type: "string",
            message: "email option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "dbconnections", "signup"), metadata = (body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "state"
    ]).with(options)).user_metadata || body.userMetadata, body = $51679e17ad633b30$var$objectHelper.blacklist(body, [
        "scope",
        "userMetadata",
        "user_metadata"
    ]), body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), metadata && (body.user_metadata = metadata), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$var$DBConnection.prototype.changePassword = function(options, cb) {
    var url, body;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        connection: {
            type: "string",
            message: "connection option is required"
        },
        email: {
            type: "string",
            message: "email option is required"
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "dbconnections", "change_password"), body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options, [
        "email",
        "connection"
    ]), body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.buildAuthorizeUrl = function(options) {
    var params, qString;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }), params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "responseType",
        "responseMode",
        "redirectUri",
        "scope",
        "audience"
    ]).with(options), $51679e17ad633b30$var$assert.check(params, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        redirectUri: {
            optional: !0,
            type: "string",
            message: "redirectUri option is required"
        },
        responseType: {
            type: "string",
            message: "responseType option is required"
        },
        nonce: {
            type: "string",
            message: "nonce option is required",
            condition: function(o) {
                return -1 === o.responseType.indexOf("code") && -1 !== o.responseType.indexOf("id_token");
            }
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params.connection_scope && $51679e17ad633b30$var$assert.isArray(params.connection_scope) && (params.connection_scope = params.connection_scope.join(",")), params = $51679e17ad633b30$var$objectHelper.blacklist(params, [
        "username",
        "popupOptions",
        "domain",
        "tenant",
        "timeout",
        "appState"
    ]), params = $51679e17ad633b30$var$objectHelper.toSnakeCase(params, [
        "auth0Client"
    ]), params = $51679e17ad633b30$var$parametersWhitelist.oauthAuthorizeParams(this.warn, params), qString = $51679e17ad633b30$var$lib_stringify(params), $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "authorize", "?" + qString);
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.buildLogoutUrl = function(options) {
    var params, qString;
    return $51679e17ad633b30$var$assert.check(options, {
        optional: !0,
        type: "object",
        message: "options parameter is not valid"
    }), params = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options || {}), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = $51679e17ad633b30$var$objectHelper.toSnakeCase(params, [
        "auth0Client",
        "returnTo"
    ]), qString = $51679e17ad633b30$var$lib_stringify($51679e17ad633b30$var$objectHelper.blacklist(params, [
        "federated"
    ])), options && void 0 !== options.federated && !1 !== options.federated && "false" !== options.federated && (qString += "&federated"), $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "v2", "logout", "?" + qString);
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.loginWithDefaultDirectory = function(options, cb) {
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), options.grantType = "password", this.oauthToken(options, cb);
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.login = function(options, cb) {
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        realm: {
            type: "string",
            message: "realm option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), options.grantType = "http://auth0.com/oauth/grant-type/password-realm", this.oauthToken(options, cb);
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.oauthToken = function(options, cb) {
    var url, body;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "oauth", "token"), body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope",
        "audience"
    ]).with(options), $51679e17ad633b30$var$assert.check(body, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        clientID: {
            type: "string",
            message: "clientID option is required"
        },
        grantType: {
            type: "string",
            message: "grantType option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        },
        audience: {
            optional: !0,
            type: "string",
            message: "audience option is required"
        }
    }), body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), body = $51679e17ad633b30$var$parametersWhitelist.oauthTokenParams(this.warn, body), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.loginWithResourceOwner = function(options, cb) {
    var url, body;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        username: {
            type: "string",
            message: "username option is required"
        },
        password: {
            type: "string",
            message: "password option is required"
        },
        connection: {
            type: "string",
            message: "connection option is required"
        },
        scope: {
            optional: !0,
            type: "string",
            message: "scope option is required"
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "oauth", "ro"), body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID",
        "scope"
    ]).with(options, [
        "username",
        "password",
        "scope",
        "connection",
        "device"
    ]), (body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ])).grant_type = body.grant_type || "password", this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.getSSOData = function(withActiveDirectories, cb) {
    if (this.auth0 || (this.auth0 = new $51679e17ad633b30$export$d1b7252873cb8575(this.baseOptions)), $51679e17ad633b30$var$windowHelper.getWindow().location.host === this.baseOptions.domain) return this.auth0._universalLogin.getSSOData(withActiveDirectories, cb);
    "function" == typeof withActiveDirectories && (cb = withActiveDirectories), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    });
    var clientId = this.baseOptions.clientID, ssodataInformation = this.ssodataStorage.get() || {};
    this.auth0.checkSession({
        responseType: "token id_token",
        scope: "openid profile email",
        connection: ssodataInformation.lastUsedConnection,
        timeout: 5e3
    }, function(err, result) {
        return err ? "login_required" === err.error ? cb(null, {
            sso: !1
        }) : ("consent_required" === err.error && (err.error_description = "Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`."), cb(err, {
            sso: !1
        })) : ssodataInformation.lastUsedSub && ssodataInformation.lastUsedSub !== result.idTokenPayload.sub ? cb(err, {
            sso: !1
        }) : cb(null, {
            lastUsedConnection: {
                name: ssodataInformation.lastUsedConnection
            },
            lastUsedUserID: result.idTokenPayload.sub,
            lastUsedUsername: result.idTokenPayload.email || result.idTokenPayload.name,
            lastUsedClientID: clientId,
            sessionClients: [
                clientId
            ],
            sso: !0
        });
    });
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.userInfo = function(accessToken, cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(accessToken, {
        type: "string",
        message: "accessToken parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "userinfo"), this.request.get(url).set("Authorization", "Bearer " + accessToken).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.getChallenge = function(cb) {
    if ($51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), !this.baseOptions.state) return cb();
    var url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "usernamepassword", "challenge");
    return this.request.post(url).send({
        state: this.baseOptions.state
    }).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.delegation = function(options, cb) {
    var url, body;
    return $51679e17ad633b30$var$assert.check(options, {
        type: "object",
        message: "options parameter is not valid"
    }, {
        grant_type: {
            type: "string",
            message: "grant_type option is required"
        }
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "delegation"), body = $51679e17ad633b30$var$objectHelper.merge(this.baseOptions, [
        "clientID"
    ]).with(options), body = $51679e17ad633b30$var$objectHelper.toSnakeCase(body, [
        "auth0Client"
    ]), this.request.post(url).send(body).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$export$d9e3c9dc7eaad0c3.prototype.getUserCountry = function(cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "user", "geoloc", "country"), this.request.get(url).end($51679e17ad633b30$var$wrapCallback(cb));
}, $51679e17ad633b30$export$cbb26d9fbbee6ab2.prototype.getUser = function(userId, cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.get(url).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $51679e17ad633b30$export$cbb26d9fbbee6ab2.prototype.patchUserMetadata = function(userId, userMetadata, cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(userMetadata, {
        type: "object",
        message: "userMetadata parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send({
        user_metadata: userMetadata
    }).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $51679e17ad633b30$export$cbb26d9fbbee6ab2.prototype.patchUserAttributes = function(userId, user, cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(user, {
        type: "object",
        message: "user parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send(user).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
}, $51679e17ad633b30$export$cbb26d9fbbee6ab2.prototype.linkUser = function(userId, secondaryUserToken, cb) {
    var url;
    return $51679e17ad633b30$var$assert.check(userId, {
        type: "string",
        message: "userId parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(secondaryUserToken, {
        type: "string",
        message: "secondaryUserToken parameter is not valid"
    }), $51679e17ad633b30$var$assert.check(cb, {
        type: "function",
        message: "cb parameter is not valid"
    }), url = $51679e17ad633b30$var$urlJoin(this.baseOptions.rootUrl, "users", userId, "identities"), this.request.post(url).send({
        link_with: secondaryUserToken
    }).end($51679e17ad633b30$var$wrapCallback(cb, {
        ignoreCasing: !0
    }));
};
var $51679e17ad633b30$var$index = {
    Authentication: $51679e17ad633b30$export$d9e3c9dc7eaad0c3,
    Management: $51679e17ad633b30$export$cbb26d9fbbee6ab2,
    WebAuth: $51679e17ad633b30$export$d1b7252873cb8575,
    version: $51679e17ad633b30$export$83d89fbfd8236492
};
var $51679e17ad633b30$export$2e2bcd8739ae039 = $51679e17ad633b30$var$index;


function $cecde547f6c9ac49$var$i() {
    return ($cecde547f6c9ac49$var$i = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
    }).apply(this, arguments);
}
var $cecde547f6c9ac49$var$s = function(e, t) {
    switch(t.type){
        case "login":
            var r = t.authResult, n = t.user, o = 1e3 * r.expiresIn + (new Date).getTime();
            return "undefined" != typeof localStorage && (localStorage.setItem("useAuth:expires_at", JSON.stringify(o)), localStorage.setItem("useAuth:user", JSON.stringify(n))), $cecde547f6c9ac49$var$i({}, e, {
                user: n,
                expiresAt: o,
                authResult: r
            });
        case "logout":
            return "undefined" != typeof localStorage && (localStorage.removeItem("useAuth:expires_at"), localStorage.removeItem("useAuth:user")), $cecde547f6c9ac49$var$i({}, e, {
                user: {},
                expiresAt: null,
                authResult: null
            });
        case "stopAuthenticating":
            return $cecde547f6c9ac49$var$i({}, e, {
                isAuthenticating: !1
            });
        case "startAuthenticating":
            return $cecde547f6c9ac49$var$i({}, e, {
                isAuthenticating: !0
            });
        case "error":
            return $cecde547f6c9ac49$var$i({}, e, {
                user: {},
                expiresAt: null,
                authResult: null,
                errorType: t.errorType,
                error: t.error
            });
        default:
            return e;
    }
};
"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
var $cecde547f6c9ac49$var$c = function(e) {
    var t = e.err, r = e.dispatch, n = e.auth0, o = e.authResult;
    try {
        return r({
            type: "stopAuthenticating"
        }), o && o.accessToken && o.idToken ? Promise.resolve(function(e, t) {
            try {
                var a = Promise.resolve(function(e) {
                    var t = e.dispatch, r = e.auth0, n = e.authResult;
                    try {
                        return Promise.resolve(new Promise(function(e, o) {
                            r.client.userInfo(n.accessToken || "", function(r, a) {
                                r ? (t({
                                    type: "error",
                                    errorType: "userInfo",
                                    error: r
                                }), o(r)) : (t({
                                    type: "login",
                                    authResult: n,
                                    user: a
                                }), e(a));
                            });
                        }));
                    } catch (e) {
                        return Promise.reject(e);
                    }
                }({
                    dispatch: r,
                    auth0: n,
                    authResult: o
                })).then(function() {
                    return !0;
                });
            } catch (e) {
                return !1;
            }
            return a && a.then ? a.then(void 0, function() {
                return !1;
            }) : a;
        }()) : t ? (console.error(t), r({
            type: "error",
            error: t,
            errorType: "authResult"
        }), Promise.resolve(!1)) : Promise.resolve(!1);
    } catch (e) {
        return Promise.reject(e);
    }
}, $cecde547f6c9ac49$export$1d39dc5b47e56ff0 = function() {
    var e = (0, $acw62.useContext)($cecde547f6c9ac49$var$p), r = e.state, n = e.dispatch, o = e.auth0, a = e.callback_domain, u = e.navigate, i = e.customPropertyNamespace, s = function() {
        return !!(r.expiresAt && (new Date).getTime() < r.expiresAt);
    };
    return {
        isAuthenticating: r.isAuthenticating,
        isAuthenticated: s,
        isAuthorized: function(e) {
            var t = Array.isArray(e) ? e : [
                e
            ], n = r.user[(i + "/user_metadata").replace(/\/+user_metadata/, "/user_metadata")];
            return !(!s() || !n) && t.some(function(e) {
                return n.roles.includes(e);
            });
        },
        user: r.user,
        userId: r.user ? r.user.sub : null,
        authResult: r.authResult,
        login: function() {
            o && o.authorize();
        },
        logout: function() {
            o && o.logout({
                returnTo: a
            }), n({
                type: "logout"
            }), u("/");
        },
        handleAuthentication: function(e) {
            var t = (void 0 === e ? {} : e).postLoginRoute, r = void 0 === t ? "/" : t;
            "undefined" != typeof window && (n({
                type: "startAuthenticating"
            }), o && o.parseHash(function(e, t) {
                try {
                    return Promise.resolve($cecde547f6c9ac49$var$c({
                        err: e,
                        authResult: t,
                        dispatch: n,
                        auth0: o
                    })).then(function() {
                        u(r);
                    });
                } catch (e) {
                    return Promise.reject(e);
                }
            }));
        }
    };
};
function $cecde547f6c9ac49$var$h() {
    var e = {};
    if ("undefined" != typeof localStorage) {
        var t = new Date(JSON.parse(localStorage.getItem("useAuth:expires_at") || "0"));
        t > new Date && (e = {
            user: JSON.parse(localStorage.getItem("useAuth:user") || "{}"),
            expiresAt: t
        });
    }
    return $cecde547f6c9ac49$var$i({}, {
        user: {},
        expiresAt: null,
        isAuthenticating: !1
    }, {}, e);
}
var $cecde547f6c9ac49$var$p = (0, $acw62.createContext)({
    state: $cecde547f6c9ac49$var$h(),
    dispatch: function() {},
    auth0: null,
    callback_domain: "http://localhost:8000",
    customPropertyNamespace: "http://localhost:8000",
    navigate: function(e) {}
}), $cecde547f6c9ac49$export$87091915187a1a85 = function(t) {
    var r = t.children, l = t.navigate, m = t.auth0_domain, d = t.customPropertyNamespace, f = "undefined" != typeof window ? window.location.protocol + "//" + window.location.host : "http://localhost:8000", y = new (0, $51679e17ad633b30$export$2e2bcd8739ae039).WebAuth($cecde547f6c9ac49$var$i({}, {
        domain: m,
        clientID: t.auth0_client_id,
        redirectUri: f + "/auth0_callback",
        audience: "https://" + (t.auth0_audience_domain || m) + "/api/v2/",
        responseType: "token id_token",
        scope: "openid profile email"
    }, {}, t.auth0_params)), g = (0, $acw62.useReducer)($cecde547f6c9ac49$var$s, $cecde547f6c9ac49$var$h()), v = g[0], A = g[1], S = (0, $acw62.useState)({
        state: v,
        dispatch: A,
        auth0: y,
        callback_domain: f,
        customPropertyNamespace: d,
        navigate: l
    }), b = S[0], _ = S[1];
    return (0, $acw62.useEffect)(function() {
        _(function(e) {
            return $cecde547f6c9ac49$var$i({}, e, {
                state: v
            });
        });
    }, [
        v
    ]), (0, $acw62.useEffect)(function() {
        A({
            type: "startAuthenticating"
        }), y.checkSession({}, function(e, t) {
            A({
                type: "stopAuthenticating"
            }), console.log(e), e ? A({
                type: "error",
                errorType: "checkSession",
                error: e
            }) : $cecde547f6c9ac49$var$c({
                dispatch: A,
                auth0: y,
                authResult: t
            });
        });
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cecde547f6c9ac49$var$p.Provider, {
        value: b
    }, r);
};



var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $3afa96475c004866$exports = {};
'use strict';
$3afa96475c004866$exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $3afa96475c004866$var$_react2 = $3afa96475c004866$var$_interopRequireDefault($acw62);
var $292d806c8898de24$exports = {};
'use strict';
$292d806c8898de24$exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $292d806c8898de24$var$_react2 = $292d806c8898de24$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $292d806c8898de24$var$_propTypes2 = $292d806c8898de24$var$_interopRequireDefault($c9Z8w);
var $92e06b8def6c7a49$exports = {};
// @flow
'use strict';
var $92e06b8def6c7a49$var$key = '__global_unique_id__';
$92e06b8def6c7a49$exports = function() {
    return $parcel$global[$92e06b8def6c7a49$var$key] = ($parcel$global[$92e06b8def6c7a49$var$key] || 0) + 1;
};


var $292d806c8898de24$var$_gud2 = $292d806c8898de24$var$_interopRequireDefault($92e06b8def6c7a49$exports);

var $kg9aN = parcelRequire("kg9aN");
var $292d806c8898de24$var$_warning2 = $292d806c8898de24$var$_interopRequireDefault($kg9aN);
function $292d806c8898de24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $292d806c8898de24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $292d806c8898de24$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $292d806c8898de24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $292d806c8898de24$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $292d806c8898de24$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $292d806c8898de24$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $292d806c8898de24$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, $292d806c8898de24$var$_gud2.default)() + '__';
    var Provider = function(_Component) {
        $292d806c8898de24$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $292d806c8898de24$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $292d806c8898de24$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $292d806c8898de24$var$createEventEmitter(_this.props.value), _temp), $292d806c8898de24$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if ($292d806c8898de24$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($acw62.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $292d806c8898de24$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $292d806c8898de24$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $292d806c8898de24$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $292d806c8898de24$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $292d806c8898de24$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $292d806c8898de24$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($acw62.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $292d806c8898de24$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
$292d806c8898de24$exports.default = $292d806c8898de24$var$createReactContext;
$292d806c8898de24$exports = $292d806c8898de24$exports['default'];


var $3afa96475c004866$var$_implementation2 = $3afa96475c004866$var$_interopRequireDefault($292d806c8898de24$exports);
function $3afa96475c004866$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3afa96475c004866$exports.default = $3afa96475c004866$var$_react2.default.createContext || $3afa96475c004866$var$_implementation2.default;
$3afa96475c004866$exports = $3afa96475c004866$exports['default'];


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}



////////////////////////////////////////////////////////////////////////////////
// startsWith(string, search) - Check if `string` starts with `search`
var $b59fe115cc21af2d$export$68326237475e9a7d = function startsWith(string, search) {
    return string.substr(0, search.length) === search;
};
////////////////////////////////////////////////////////////////////////////////
// pick(routes, uri)
//
// Ranks and picks the best route to match. Each segment gets the highest
// amount of points, then the type of segment gets an additional amount of
// points where
//
//     static > dynamic > splat > root
//
// This way we don't have to worry about the order of our routes, let the
// computers do it.
//
// A route looks like this
//
//     { path, default, value }
//
// And a returned match looks like:
//
//     { route, params, uri }
//
// I know, I should use TypeScript not comments for these types.
var $b59fe115cc21af2d$export$357523c63a2253b9 = function pick(routes, uri) {
    var match = void 0;
    var default_ = void 0;
    var _uri$split = uri.split("?"), uriPathname = _uri$split[0];
    var uriSegments = $b59fe115cc21af2d$var$segmentize(uriPathname);
    var isRootUri = uriSegments[0] === "";
    var ranked = $b59fe115cc21af2d$var$rankRoutes(routes);
    for(var i = 0, l = ranked.length; i < l; i++){
        var missed = false;
        var route = ranked[i].route;
        if (route.default) {
            default_ = {
                route: route,
                params: {},
                uri: uri
            };
            continue;
        }
        var routeSegments = $b59fe115cc21af2d$var$segmentize(route.path);
        var params = {};
        var max = Math.max(uriSegments.length, routeSegments.length);
        var index = 0;
        for(; index < max; index++){
            var routeSegment = routeSegments[index];
            var uriSegment = uriSegments[index];
            if ($b59fe115cc21af2d$var$isSplat(routeSegment)) {
                // Hit a splat, just grab the rest, and return a match
                // uri:   /files/documents/work
                // route: /files/*
                var param = routeSegment.slice(1) || "*";
                params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
                break;
            }
            if (uriSegment === undefined) {
                // URI is shorter than the route, no match
                // uri:   /users
                // route: /users/:userId
                missed = true;
                break;
            }
            var dynamicMatch = $b59fe115cc21af2d$var$paramRe.exec(routeSegment);
            if (dynamicMatch && !isRootUri) {
                var matchIsNotReserved = $b59fe115cc21af2d$var$reservedNames.indexOf(dynamicMatch[1]) === -1;
                !matchIsNotReserved && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
                var value = decodeURIComponent(uriSegment);
                params[dynamicMatch[1]] = value;
            } else if (routeSegment !== uriSegment) {
                // Current segments don't match, not dynamic, not splat, so no match
                // uri:   /users/123/settings
                // route: /users/:id/profile
                missed = true;
                break;
            }
        }
        if (!missed) {
            match = {
                route: route,
                params: params,
                uri: "/" + uriSegments.slice(0, index).join("/")
            };
            break;
        }
    }
    return match || default_ || null;
};
////////////////////////////////////////////////////////////////////////////////
// match(path, uri) - Matches just one path to a uri, also lol
var $b59fe115cc21af2d$export$4659b591c19bdf3d = function match(path, uri) {
    return $b59fe115cc21af2d$export$357523c63a2253b9([
        {
            path: path
        }
    ], uri);
};
////////////////////////////////////////////////////////////////////////////////
// resolve(to, basepath)
//
// Resolves URIs as though every path is a directory, no files.  Relative URIs
// in the browser can feel awkward because not only can you be "in a directory"
// you can be "at a file", too. For example
//
//     browserSpecResolve('foo', '/bar/') => /bar/foo
//     browserSpecResolve('foo', '/bar') => /foo
//
// But on the command line of a file system, it's not as complicated, you can't
// `cd` from a file, only directories.  This way, links have to know less about
// their current path. To go deeper you can do this:
//
//     <Link to="deeper"/>
//     // instead of
//     <Link to=`{${props.uri}/deeper}`/>
//
// Just like `cd`, if you want to go deeper from the command line, you do this:
//
//     cd deeper
//     # not
//     cd $(pwd)/deeper
//
// By treating every path as a directory, linking to relative paths should
// require less contextual information and (fingers crossed) be more intuitive.
var $b59fe115cc21af2d$export$f7ad0328861e2f03 = function resolve(to, base) {
    // /foo/bar, /baz/qux => /foo/bar
    if ($b59fe115cc21af2d$export$68326237475e9a7d(to, "/")) return to;
    var _to$split = to.split("?"), toPathname = _to$split[0], toQuery = _to$split[1];
    var _base$split = base.split("?"), basePathname = _base$split[0];
    var toSegments = $b59fe115cc21af2d$var$segmentize(toPathname);
    var baseSegments = $b59fe115cc21af2d$var$segmentize(basePathname);
    // ?a=b, /users?b=c => /users?a=b
    if (toSegments[0] === "") return $b59fe115cc21af2d$var$addQuery(basePathname, toQuery);
    // profile, /users/789 => /users/789/profile
    if (!$b59fe115cc21af2d$export$68326237475e9a7d(toSegments[0], ".")) {
        var pathname = baseSegments.concat(toSegments).join("/");
        return $b59fe115cc21af2d$var$addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
    }
    // ./         /users/123  =>  /users/123
    // ../        /users/123  =>  /users
    // ../..      /users/123  =>  /
    // ../../one  /a/b/c/d    =>  /a/b/one
    // .././one   /a/b/c/d    =>  /a/b/c/one
    var allSegments = baseSegments.concat(toSegments);
    var segments = [];
    for(var i = 0, l = allSegments.length; i < l; i++){
        var segment = allSegments[i];
        if (segment === "..") segments.pop();
        else if (segment !== ".") segments.push(segment);
    }
    return $b59fe115cc21af2d$var$addQuery("/" + segments.join("/"), toQuery);
};
////////////////////////////////////////////////////////////////////////////////
// insertParams(path, params)
var $b59fe115cc21af2d$export$2560bc9559623b9 = function insertParams(path, params) {
    var _path$split = path.split("?"), pathBase = _path$split[0], _path$split$ = _path$split[1], query = _path$split$ === undefined ? "" : _path$split$;
    var segments = $b59fe115cc21af2d$var$segmentize(pathBase);
    var constructedPath = "/" + segments.map(function(segment) {
        var match = $b59fe115cc21af2d$var$paramRe.exec(segment);
        return match ? params[match[1]] : segment;
    }).join("/");
    var _params$location = params.location;
    _params$location = _params$location === undefined ? {} : _params$location;
    var _params$location$sear = _params$location.search, search = _params$location$sear === undefined ? "" : _params$location$sear;
    var searchSplit = search.split("?")[1] || "";
    constructedPath = $b59fe115cc21af2d$var$addQuery(constructedPath, query, searchSplit);
    return constructedPath;
};
var $b59fe115cc21af2d$export$569b01c992e4a17e = function validateRedirect(from, to) {
    var filter = function filter(segment) {
        return $b59fe115cc21af2d$var$isDynamic(segment);
    };
    var fromString = $b59fe115cc21af2d$var$segmentize(from).filter(filter).sort().join("/");
    var toString = $b59fe115cc21af2d$var$segmentize(to).filter(filter).sort().join("/");
    return fromString === toString;
};
////////////////////////////////////////////////////////////////////////////////
// Junk
var $b59fe115cc21af2d$var$paramRe = /^:(.+)/;
var $b59fe115cc21af2d$var$SEGMENT_POINTS = 4;
var $b59fe115cc21af2d$var$STATIC_POINTS = 3;
var $b59fe115cc21af2d$var$DYNAMIC_POINTS = 2;
var $b59fe115cc21af2d$var$SPLAT_PENALTY = 1;
var $b59fe115cc21af2d$var$ROOT_POINTS = 1;
var $b59fe115cc21af2d$var$isRootSegment = function isRootSegment(segment) {
    return segment === "";
};
var $b59fe115cc21af2d$var$isDynamic = function isDynamic(segment) {
    return $b59fe115cc21af2d$var$paramRe.test(segment);
};
var $b59fe115cc21af2d$var$isSplat = function isSplat(segment) {
    return segment && segment[0] === "*";
};
var $b59fe115cc21af2d$var$rankRoute = function rankRoute(route, index) {
    var score = route.default ? 0 : $b59fe115cc21af2d$var$segmentize(route.path).reduce(function(score, segment) {
        score += $b59fe115cc21af2d$var$SEGMENT_POINTS;
        if ($b59fe115cc21af2d$var$isRootSegment(segment)) score += $b59fe115cc21af2d$var$ROOT_POINTS;
        else if ($b59fe115cc21af2d$var$isDynamic(segment)) score += $b59fe115cc21af2d$var$DYNAMIC_POINTS;
        else if ($b59fe115cc21af2d$var$isSplat(segment)) score -= $b59fe115cc21af2d$var$SEGMENT_POINTS + $b59fe115cc21af2d$var$SPLAT_PENALTY;
        else score += $b59fe115cc21af2d$var$STATIC_POINTS;
        return score;
    }, 0);
    return {
        route: route,
        score: score,
        index: index
    };
};
var $b59fe115cc21af2d$var$rankRoutes = function rankRoutes(routes) {
    return routes.map($b59fe115cc21af2d$var$rankRoute).sort(function(a, b) {
        return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
    });
};
var $b59fe115cc21af2d$var$segmentize = function segmentize(uri) {
    return uri// strip starting/ending slashes
    .replace(/(^\/+|\/+$)/g, "").split("/");
};
var $b59fe115cc21af2d$var$addQuery = function addQuery(pathname) {
    for(var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)query[_key - 1] = arguments[_key];
    query = query.filter(function(q) {
        return q && q.length > 0;
    });
    return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
};
var $b59fe115cc21af2d$var$reservedNames = [
    "uri",
    "path"
];
/**
 * Shallow compares two objects.
 * @param {Object} obj1 The first object to compare.
 * @param {Object} obj2 The second object to compare.
 */ var $b59fe115cc21af2d$export$90e866afbd6b9f1a = function shallowCompare(obj1, obj2) {
    var obj1Keys = Object.keys(obj1);
    return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function(key) {
        return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
    });
};


var $f125bbca2c654db8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f125bbca2c654db8$var$getLocation = function getLocation(source) {
    var _source$location = source.location, search = _source$location.search, hash = _source$location.hash, href = _source$location.href, origin = _source$location.origin, protocol = _source$location.protocol, host = _source$location.host, hostname = _source$location.hostname, port = _source$location.port;
    var pathname = source.location.pathname;
    if (!pathname && href && $f125bbca2c654db8$var$canUseDOM) {
        var url = new URL(href);
        pathname = url.pathname;
    }
    return {
        pathname: encodeURI(decodeURI(pathname)),
        search: search,
        hash: hash,
        href: href,
        origin: origin,
        protocol: protocol,
        host: host,
        hostname: hostname,
        port: port,
        state: source.history.state,
        key: source.history.state && source.history.state.key || "initial"
    };
};
var $f125bbca2c654db8$export$4178d7ac16e6cf7c = function createHistory(source, options) {
    var listeners = [];
    var location = $f125bbca2c654db8$var$getLocation(source);
    var transitioning = false;
    var resolveTransition = function resolveTransition() {};
    return {
        get location () {
            return location;
        },
        get transitioning () {
            return transitioning;
        },
        _onTransitionComplete: function _onTransitionComplete() {
            transitioning = false;
            resolveTransition();
        },
        listen: function listen(listener) {
            listeners.push(listener);
            var popstateListener = function popstateListener() {
                location = $f125bbca2c654db8$var$getLocation(source);
                listener({
                    location: location,
                    action: "POP"
                });
            };
            source.addEventListener("popstate", popstateListener);
            return function() {
                source.removeEventListener("popstate", popstateListener);
                listeners = listeners.filter(function(fn) {
                    return fn !== listener;
                });
            };
        },
        navigate: function navigate(to) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, state = _ref.state, _ref$replace = _ref.replace, replace = _ref$replace === undefined ? false : _ref$replace;
            if (typeof to === "number") source.history.go(to);
            else {
                state = $f125bbca2c654db8$var$_extends({}, state, {
                    key: Date.now() + ""
                });
                // try...catch iOS Safari limits to 100 pushState calls
                try {
                    if (transitioning || replace) source.history.replaceState(state, null, to);
                    else source.history.pushState(state, null, to);
                } catch (e) {
                    source.location[replace ? "replace" : "assign"](to);
                }
            }
            location = $f125bbca2c654db8$var$getLocation(source);
            transitioning = true;
            var transition = new Promise(function(res) {
                return resolveTransition = res;
            });
            listeners.forEach(function(listener) {
                return listener({
                    location: location,
                    action: "PUSH"
                });
            });
            return transition;
        }
    };
};
////////////////////////////////////////////////////////////////////////////////
// Stores history entries in memory for testing or other platforms like Native
var $f125bbca2c654db8$export$f8892d7c0e30dbc3 = function createMemorySource() {
    var initialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var searchIndex = initialPath.indexOf("?");
    var initialLocation = {
        pathname: searchIndex > -1 ? initialPath.substr(0, searchIndex) : initialPath,
        search: searchIndex > -1 ? initialPath.substr(searchIndex) : ""
    };
    var index = 0;
    var stack = [
        initialLocation
    ];
    var states = [
        null
    ];
    return {
        get location () {
            return stack[index];
        },
        addEventListener: function addEventListener(name, fn) {},
        removeEventListener: function removeEventListener(name, fn) {},
        history: {
            get entries () {
                return stack;
            },
            get index () {
                return index;
            },
            get state () {
                return states[index];
            },
            pushState: function pushState(state, _, uri) {
                var _uri$split = uri.split("?"), pathname = _uri$split[0], _uri$split$ = _uri$split[1], search = _uri$split$ === undefined ? "" : _uri$split$;
                index++;
                stack.push({
                    pathname: pathname,
                    search: search.length ? "?" + search : search
                });
                states.push(state);
            },
            replaceState: function replaceState(state, _, uri) {
                var _uri$split2 = uri.split("?"), pathname = _uri$split2[0], _uri$split2$ = _uri$split2[1], search = _uri$split2$ === undefined ? "" : _uri$split2$;
                stack[index] = {
                    pathname: pathname,
                    search: search
                };
                states[index] = state;
            },
            go: function go(to) {
                var newIndex = index + to;
                if (newIndex < 0 || newIndex > states.length - 1) return;
                index = newIndex;
            }
        }
    };
};
////////////////////////////////////////////////////////////////////////////////
// global history - uses window.history as the source if available, otherwise a
// memory history
var $f125bbca2c654db8$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $f125bbca2c654db8$var$getSource = function getSource() {
    return $f125bbca2c654db8$var$canUseDOM ? window : $f125bbca2c654db8$export$f8892d7c0e30dbc3();
};
var $f125bbca2c654db8$export$a2ad86361069f785 = $f125bbca2c654db8$export$4178d7ac16e6cf7c($f125bbca2c654db8$var$getSource());
var $f125bbca2c654db8$export$ff7962acd6052c28 = $f125bbca2c654db8$export$a2ad86361069f785.navigate;


var $66249767282b1118$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $66249767282b1118$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $66249767282b1118$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $66249767282b1118$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $66249767282b1118$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$var$createNamedContext = function createNamedContext(name, defaultValue) {
    var Ctx = (0, (/*@__PURE__*/$parcel$interopDefault($3afa96475c004866$exports)))(defaultValue);
    Ctx.displayName = name;
    return Ctx;
};
////////////////////////////////////////////////////////////////////////////////
// Location Context/Provider
var $66249767282b1118$var$LocationContext = $66249767282b1118$var$createNamedContext("Location");
// sets up a listener if there isn't one already so apps don't need to be
// wrapped in some top level provider
var $66249767282b1118$export$18a2be9195644f38 = function Location(_ref) {
    var children = _ref.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Consumer, null, function(context) {
        return context ? children(context) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$5af065edda80e75c, null, children);
    });
};
var $66249767282b1118$export$5af065edda80e75c = function(_React$Component) {
    $66249767282b1118$var$_inherits(LocationProvider, _React$Component);
    function LocationProvider() {
        var _temp, _this, _ret;
        $66249767282b1118$var$_classCallCheck(this, LocationProvider);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            context: _this.getContext(),
            refs: {
                unlisten: null
            }
        }, _temp), $66249767282b1118$var$_possibleConstructorReturn(_this, _ret);
    }
    LocationProvider.prototype.getContext = function getContext() {
        var _props$history = this.props.history, navigate = _props$history.navigate, location = _props$history.location;
        return {
            navigate: navigate,
            location: location
        };
    };
    LocationProvider.prototype.componentDidCatch = function componentDidCatch(error, info) {
        if ($66249767282b1118$export$4cb830d4f7e56898(error)) {
            var _navigate = this.props.history.navigate;
            _navigate(error.uri, {
                replace: true
            });
        } else throw error;
    };
    LocationProvider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevState.context.location !== this.state.context.location) this.props.history._onTransitionComplete();
    };
    LocationProvider.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        var refs = this.state.refs, history = this.props.history;
        history._onTransitionComplete();
        refs.unlisten = history.listen(function() {
            Promise.resolve().then(function() {
                // TODO: replace rAF with react deferred update API when it's ready https://github.com/facebook/react/issues/13306
                requestAnimationFrame(function() {
                    if (!_this2.unmounted) _this2.setState(function() {
                        return {
                            context: _this2.getContext()
                        };
                    });
                });
            });
        });
    };
    LocationProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        var refs = this.state.refs;
        this.unmounted = true;
        refs.unlisten();
    };
    LocationProvider.prototype.render = function render() {
        var context = this.state.context, children = this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Provider, {
            value: context
        }, typeof children === "function" ? children(context) : children || null);
    };
    return LocationProvider;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
////////////////////////////////////////////////////////////////////////////////
$66249767282b1118$export$5af065edda80e75c.defaultProps = {
    history: (0, $f125bbca2c654db8$export$a2ad86361069f785)
};
var $66249767282b1118$export$3f445d2f213f7c9 = function ServerLocation(_ref2) {
    var url = _ref2.url, children = _ref2.children;
    var searchIndex = url.indexOf("?");
    var searchExists = searchIndex > -1;
    var pathname = void 0;
    var search = "";
    var hash = "";
    if (searchExists) {
        pathname = url.substring(0, searchIndex);
        search = url.substring(searchIndex);
    } else pathname = url;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Provider, {
        value: {
            location: {
                pathname: pathname,
                search: search,
                hash: hash
            },
            navigate: function navigate() {
                throw new Error("You can't call navigate on the server.");
            }
        }
    }, children);
};
////////////////////////////////////////////////////////////////////////////////
// Sets baseuri and basepath for nested routers and links
var $66249767282b1118$var$BaseContext = $66249767282b1118$var$createNamedContext("Base", {
    baseuri: "/",
    basepath: "/"
});
////////////////////////////////////////////////////////////////////////////////
// The main event, welcome to the show everybody.
var $66249767282b1118$export$55185c17a0fcbe46 = function Router(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(baseContext) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(locationContext) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$RouterImpl, $66249767282b1118$var$_extends({}, baseContext, locationContext, props));
        });
    });
};
var $66249767282b1118$var$RouterImpl = function(_React$PureComponent) {
    $66249767282b1118$var$_inherits(RouterImpl, _React$PureComponent);
    function RouterImpl() {
        $66249767282b1118$var$_classCallCheck(this, RouterImpl);
        return $66249767282b1118$var$_possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }
    RouterImpl.prototype.render = function render() {
        var _props = this.props, location = _props.location, _navigate2 = _props.navigate, basepath = _props.basepath, primary = _props.primary, children = _props.children, baseuri = _props.baseuri, _props$component = _props.component, component = _props$component === undefined ? "div" : _props$component, domProps = $66249767282b1118$var$_objectWithoutProperties(_props, [
            "location",
            "navigate",
            "basepath",
            "primary",
            "children",
            "baseuri",
            "component"
        ]);
        var routes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).reduce(function(array, child) {
            var routes = $66249767282b1118$var$createRoute(basepath)(child);
            return array.concat(routes);
        }, []);
        var pathname = location.pathname;
        var match = (0, $b59fe115cc21af2d$export$357523c63a2253b9)(routes, pathname);
        if (match) {
            var params = match.params, uri = match.uri, route = match.route, element = match.route.value;
            // remove the /* from the end for child routes relative paths
            basepath = route.default ? basepath : route.path.replace(/\*$/, "");
            var props = $66249767282b1118$var$_extends({}, params, {
                uri: uri,
                location: location,
                navigate: function navigate(to, options) {
                    return _navigate2((0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, uri), options);
                }
            });
            var clone = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, props, element.props.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$55185c17a0fcbe46, {
                location: location,
                primary: primary
            }, element.props.children) : undefined);
            // using 'div' for < 16.3 support
            var FocusWrapper = primary ? $66249767282b1118$var$FocusHandler : component;
            // don't pass any props to 'div'
            var wrapperProps = primary ? $66249767282b1118$var$_extends({
                uri: uri,
                location: location,
                component: component
            }, domProps) : domProps;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Provider, {
                value: {
                    baseuri: uri,
                    basepath: basepath
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FocusWrapper, wrapperProps, clone));
        } else // Not sure if we want this, would require index routes at every level
        // warning(
        //   false,
        //   `<Router basepath="${basepath}">\n\nNothing matched:\n\t${
        //     location.pathname
        //   }\n\nPaths checked: \n\t${routes
        //     .map(route => route.path)
        //     .join(
        //       "\n\t"
        //     )}\n\nTo get rid of this warning, add a default NotFound component as child of Router:
        //   \n\tlet NotFound = () => <div>Not Found!</div>
        //   \n\t<Router>\n\t  <NotFound default/>\n\t  {/* ... */}\n\t</Router>`
        // );
        return null;
    };
    return RouterImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
$66249767282b1118$var$RouterImpl.defaultProps = {
    primary: true
};
var $66249767282b1118$var$FocusContext = $66249767282b1118$var$createNamedContext("Focus");
var $66249767282b1118$var$FocusHandler = function FocusHandler(_ref3) {
    var uri = _ref3.uri, location = _ref3.location, component = _ref3.component, domProps = $66249767282b1118$var$_objectWithoutProperties(_ref3, [
        "uri",
        "location",
        "component"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusContext.Consumer, null, function(requestFocus) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusHandlerImpl, $66249767282b1118$var$_extends({}, domProps, {
            component: component,
            requestFocus: requestFocus,
            uri: uri,
            location: location
        }));
    });
};
// don't focus on initial render
var $66249767282b1118$var$initialRender = true;
var $66249767282b1118$var$focusHandlerCount = 0;
var $66249767282b1118$var$FocusHandlerImpl = function(_React$Component2) {
    $66249767282b1118$var$_inherits(FocusHandlerImpl, _React$Component2);
    function FocusHandlerImpl() {
        var _temp2, _this4, _ret2;
        $66249767282b1118$var$_classCallCheck(this, FocusHandlerImpl);
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _ret2 = (_temp2 = (_this4 = $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args))), _this4), _this4.state = {}, _this4.requestFocus = function(node) {
            if (!_this4.state.shouldFocus && node) node.focus();
        }, _temp2), $66249767282b1118$var$_possibleConstructorReturn(_this4, _ret2);
    }
    FocusHandlerImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var initial = prevState.uri == null;
        if (initial) return $66249767282b1118$var$_extends({
            shouldFocus: true
        }, nextProps);
        else {
            var myURIChanged = nextProps.uri !== prevState.uri;
            var navigatedUpToMe = prevState.location.pathname !== nextProps.location.pathname && nextProps.location.pathname === nextProps.uri;
            return $66249767282b1118$var$_extends({
                shouldFocus: myURIChanged || navigatedUpToMe
            }, nextProps);
        }
    };
    FocusHandlerImpl.prototype.componentDidMount = function componentDidMount() {
        $66249767282b1118$var$focusHandlerCount++;
        this.focus();
    };
    FocusHandlerImpl.prototype.componentWillUnmount = function componentWillUnmount() {
        $66249767282b1118$var$focusHandlerCount--;
        if ($66249767282b1118$var$focusHandlerCount === 0) $66249767282b1118$var$initialRender = true;
    };
    FocusHandlerImpl.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.location !== this.props.location && this.state.shouldFocus) this.focus();
    };
    FocusHandlerImpl.prototype.focus = function focus() {
        var requestFocus = this.props.requestFocus;
        if (requestFocus) requestFocus(this.node);
        else {
            if ($66249767282b1118$var$initialRender) $66249767282b1118$var$initialRender = false;
            else if (this.node) // React polyfills [autofocus] and it fires earlier than cDM,
            // so we were stealing focus away, this line prevents that.
            {
                if (!this.node.contains(document.activeElement)) this.node.focus();
            }
        }
    };
    FocusHandlerImpl.prototype.render = function render() {
        var _this5 = this;
        var _props2 = this.props, children = _props2.children, style = _props2.style, requestFocus = _props2.requestFocus, _props2$component = _props2.component, Comp = _props2$component === undefined ? "div" : _props2$component, uri = _props2.uri, location = _props2.location, domProps = $66249767282b1118$var$_objectWithoutProperties(_props2, [
            "children",
            "style",
            "requestFocus",
            "component",
            "uri",
            "location"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, $66249767282b1118$var$_extends({
            style: $66249767282b1118$var$_extends({
                outline: "none"
            }, style),
            tabIndex: "-1",
            ref: function ref(n) {
                return _this5.node = n;
            }
        }, domProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusContext.Provider, {
            value: this.requestFocus
        }, this.props.children));
    };
    return FocusHandlerImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($66249767282b1118$var$FocusHandlerImpl);
var $66249767282b1118$var$k = function k() {};
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $66249767282b1118$var$forwardRef === "undefined") $66249767282b1118$var$forwardRef = function forwardRef(C) {
    return C;
};
var $66249767282b1118$export$a6c7ac8248d6e38a = $66249767282b1118$var$forwardRef(function(_ref4, ref) {
    var innerRef = _ref4.innerRef, props = $66249767282b1118$var$_objectWithoutProperties(_ref4, [
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref5) {
        var basepath = _ref5.basepath, baseuri = _ref5.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(_ref6) {
            var location = _ref6.location, navigate = _ref6.navigate;
            var to = props.to, state = props.state, replace = props.replace, _props$getProps = props.getProps, getProps = _props$getProps === undefined ? $66249767282b1118$var$k : _props$getProps, anchorProps = $66249767282b1118$var$_objectWithoutProperties(props, [
                "to",
                "state",
                "replace",
                "getProps"
            ]);
            var href = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
            var encodedHref = encodeURI(href);
            var isCurrent = location.pathname === encodedHref;
            var isPartiallyCurrent = (0, $b59fe115cc21af2d$export$68326237475e9a7d)(location.pathname, encodedHref);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", $66249767282b1118$var$_extends({
                ref: ref || innerRef,
                "aria-current": isCurrent ? "page" : undefined
            }, anchorProps, getProps({
                isCurrent: isCurrent,
                isPartiallyCurrent: isPartiallyCurrent,
                href: href,
                location: location
            }), {
                href: href,
                onClick: function onClick(event) {
                    if (anchorProps.onClick) anchorProps.onClick(event);
                    if ($66249767282b1118$var$shouldNavigate(event)) {
                        event.preventDefault();
                        var shouldReplace = replace;
                        if (typeof replace !== "boolean" && isCurrent) {
                            var _location$state = $66249767282b1118$var$_extends({}, location.state), key = _location$state.key, restState = $66249767282b1118$var$_objectWithoutProperties(_location$state, [
                                "key"
                            ]);
                            shouldReplace = (0, $b59fe115cc21af2d$export$90e866afbd6b9f1a)($66249767282b1118$var$_extends({}, state), restState);
                        }
                        navigate(href, {
                            state: state,
                            replace: shouldReplace
                        });
                    }
                }
            }));
        });
    });
});
$66249767282b1118$export$a6c7ac8248d6e38a.displayName = "Link";
////////////////////////////////////////////////////////////////////////////////
function $66249767282b1118$var$RedirectRequest(uri) {
    this.uri = uri;
}
var $66249767282b1118$export$4cb830d4f7e56898 = function isRedirect(o) {
    return o instanceof $66249767282b1118$var$RedirectRequest;
};
var $66249767282b1118$export$2d47ce6f15e624e5 = function redirectTo(to) {
    throw new $66249767282b1118$var$RedirectRequest(to);
};
var $66249767282b1118$var$RedirectImpl = function(_React$Component3) {
    $66249767282b1118$var$_inherits(RedirectImpl, _React$Component3);
    function RedirectImpl() {
        $66249767282b1118$var$_classCallCheck(this, RedirectImpl);
        return $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
    }
    // Support React < 16 with this hook
    RedirectImpl.prototype.componentDidMount = function componentDidMount() {
        var _props3 = this.props, navigate = _props3.navigate, to = _props3.to, from = _props3.from, _props3$replace = _props3.replace, replace = _props3$replace === undefined ? true : _props3$replace, state = _props3.state, noThrow = _props3.noThrow, baseuri = _props3.baseuri, props = $66249767282b1118$var$_objectWithoutProperties(_props3, [
            "navigate",
            "to",
            "from",
            "replace",
            "state",
            "noThrow",
            "baseuri"
        ]);
        Promise.resolve().then(function() {
            var resolvedTo = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
            navigate((0, $b59fe115cc21af2d$export$2560bc9559623b9)(resolvedTo, props), {
                replace: replace,
                state: state
            });
        });
    };
    RedirectImpl.prototype.render = function render() {
        var _props4 = this.props, navigate = _props4.navigate, to = _props4.to, from = _props4.from, replace = _props4.replace, state = _props4.state, noThrow = _props4.noThrow, baseuri = _props4.baseuri, props = $66249767282b1118$var$_objectWithoutProperties(_props4, [
            "navigate",
            "to",
            "from",
            "replace",
            "state",
            "noThrow",
            "baseuri"
        ]);
        var resolvedTo = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
        if (!noThrow) $66249767282b1118$export$2d47ce6f15e624e5((0, $b59fe115cc21af2d$export$2560bc9559623b9)(resolvedTo, props));
        return null;
    };
    return RedirectImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $66249767282b1118$export$2d8d895a0a0f636e = function Redirect(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref7) {
        var baseuri = _ref7.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(locationContext) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$RedirectImpl, $66249767282b1118$var$_extends({}, locationContext, {
                baseuri: baseuri
            }, props));
        });
    });
};
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$export$f421feb8fad20413 = function Match(_ref8) {
    var path = _ref8.path, children = _ref8.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref9) {
        var baseuri = _ref9.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(_ref10) {
            var navigate = _ref10.navigate, location = _ref10.location;
            var resolvedPath = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(path, baseuri);
            var result = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(resolvedPath, location.pathname);
            return children({
                navigate: navigate,
                location: location,
                match: result ? $66249767282b1118$var$_extends({}, result.params, {
                    uri: result.uri,
                    path: path
                }) : null
            });
        });
    });
};
////////////////////////////////////////////////////////////////////////////////
// Hooks
var $66249767282b1118$export$45d76561a5302f2b = function useLocation() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$LocationContext);
    if (!context) throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return context.location;
};
var $66249767282b1118$export$9770f232ac06a008 = function useNavigate() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$LocationContext);
    if (!context) throw new Error("useNavigate hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return context.navigate;
};
var $66249767282b1118$export$99eaa27ddbbb95ef = function useParams() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$BaseContext);
    if (!context) throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var location = $66249767282b1118$export$45d76561a5302f2b();
    var results = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(context.basepath, location.pathname);
    return results ? results.params : null;
};
var $66249767282b1118$export$6c330e8992e8a295 = function useMatch(path) {
    if (!path) throw new Error("useMatch(path: string) requires an argument of a string to match against");
    var context = (0, $acw62.useContext)($66249767282b1118$var$BaseContext);
    if (!context) throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var location = $66249767282b1118$export$45d76561a5302f2b();
    var resolvedPath = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(path, context.baseuri);
    var result = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(resolvedPath, location.pathname);
    return result ? $66249767282b1118$var$_extends({}, result.params, {
        uri: result.uri,
        path: path
    }) : null;
};
////////////////////////////////////////////////////////////////////////////////
// Junk
var $66249767282b1118$var$stripSlashes = function stripSlashes(str) {
    return str.replace(/(^\/+|\/+$)/g, "");
};
var $66249767282b1118$var$createRoute = function createRoute(basepath) {
    return function(element) {
        if (!element) return null;
        if (element.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment && element.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(element.props.children, createRoute(basepath));
        !(element.props.path || element.props.default || element.type === $66249767282b1118$export$2d8d895a0a0f636e) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        !!(element.type === $66249767282b1118$export$2d8d895a0a0f636e && (!element.props.from || !element.props.to)) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        !!(element.type === $66249767282b1118$export$2d8d895a0a0f636e && !(0, $b59fe115cc21af2d$export$569b01c992e4a17e)(element.props.from, element.props.to)) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        if (element.props.default) return {
            value: element,
            default: true
        };
        var elementPath = element.type === $66249767282b1118$export$2d8d895a0a0f636e ? element.props.from : element.props.path;
        var path = elementPath === "/" ? basepath : $66249767282b1118$var$stripSlashes(basepath) + "/" + $66249767282b1118$var$stripSlashes(elementPath);
        return {
            value: element,
            default: element.props.default,
            path: element.props.children ? $66249767282b1118$var$stripSlashes(path) + "/*" : path
        };
    };
};
var $66249767282b1118$var$shouldNavigate = function shouldNavigate(event) {
    return !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};


var $9d936a2aecb96285$export$2e2bcd8739ae039 = {
    AUTH0_DOMAIN: "leadernaplatform.eu.auth0.com",
    AUTH0_CLIENT_ID: "e8QfSXlsLISzTZ3htckL0J5doytNSqlt"
};




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $8JRy9 = parcelRequire("8JRy9");
var $dd3747b11ee1d6d4$var$apolloContext;
function $dd3747b11ee1d6d4$export$a47505d961ee3a1() {
    if (!$dd3747b11ee1d6d4$var$apolloContext) $dd3747b11ee1d6d4$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
    return $dd3747b11ee1d6d4$var$apolloContext;
}
function $dd3747b11ee1d6d4$export$c2ee824bcc89ca6a() {
    $dd3747b11ee1d6d4$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
}
var $dd3747b11ee1d6d4$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $dd3747b11ee1d6d4$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8JRy9.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $dd3747b11ee1d6d4$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $dd3747b11ee1d6d4$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8JRy9.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $dd3747b11ee1d6d4$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($dd3747b11ee1d6d4$export$d1d99cf900472499 || ($dd3747b11ee1d6d4$export$d1d99cf900472499 = {}));
var $dd3747b11ee1d6d4$var$cache = new Map();
function $dd3747b11ee1d6d4$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $dd3747b11ee1d6d4$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $dd3747b11ee1d6d4$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $dd3747b11ee1d6d4$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $dd3747b11ee1d6d4$export$8f49e4af10703ce3(document) {
    var cached = $dd3747b11ee1d6d4$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8JRy9.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8JRy9.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8JRy9.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $dd3747b11ee1d6d4$export$d1d99cf900472499.Query : $dd3747b11ee1d6d4$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $dd3747b11ee1d6d4$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8JRy9.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $dd3747b11ee1d6d4$var$cache.set(document, payload);
    return payload;
}



var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $15e6d94060e5d8b6$var$toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function $15e6d94060e5d8b6$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $15e6d94060e5d8b6$var$toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}



var $1u0KT = parcelRequire("1u0KT");
function $60f27fc97e29822a$var$_extends() {
    $60f27fc97e29822a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60f27fc97e29822a$var$_extends.apply(this, arguments);
}
function $60f27fc97e29822a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $60f27fc97e29822a$var$isNum(v) {
    return typeof v === 'number' && !isNaN(v);
}
function $60f27fc97e29822a$var$isBool(v) {
    return typeof v === 'boolean';
}
function $60f27fc97e29822a$var$isStr(v) {
    return typeof v === 'string';
}
function $60f27fc97e29822a$var$isFn(v) {
    return typeof v === 'function';
}
function $60f27fc97e29822a$var$parseClassName(v) {
    return $60f27fc97e29822a$var$isStr(v) || $60f27fc97e29822a$var$isFn(v) ? v : null;
}
function $60f27fc97e29822a$var$isToastIdValid(toastId) {
    return toastId === 0 || toastId;
}
function $60f27fc97e29822a$var$getAutoCloseDelay(toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || $60f27fc97e29822a$var$isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var $60f27fc97e29822a$var$canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $60f27fc97e29822a$var$canBeRendered(content) {
    return (0, $acw62.isValidElement)(content) || $60f27fc97e29822a$var$isStr(content) || $60f27fc97e29822a$var$isFn(content) || $60f27fc97e29822a$var$isNum(content);
}
var $60f27fc97e29822a$var$POSITION = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center'
};
var $60f27fc97e29822a$var$TYPE = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default',
    DARK: 'dark'
};
/**
 * Used to collapse toast after exit animation
 */ function $60f27fc97e29822a$export$184cca501f1aed7f(node, done, duration) {
    if (duration === void 0) duration = 300;
    var height = node.scrollHeight;
    var style = node.style;
    requestAnimationFrame(function() {
        style.minHeight = 'initial';
        style.height = height + 'px';
        style.transition = "all " + duration + "ms";
        requestAnimationFrame(function() {
            style.height = '0';
            style.padding = '0';
            style.margin = '0';
            setTimeout(done, duration);
        });
    });
}
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */ function $60f27fc97e29822a$export$3ff7dc44d332d222(_ref) {
    var enter = _ref.enter, exit = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
    return function ToastTransition(_ref2) {
        var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
        var enterClassName = appendPosition ? enter + "--" + position : enter;
        var exitClassName = appendPosition ? exit + "--" + position : exit;
        var baseClassName = (0, $acw62.useRef)();
        var animationStep = (0, $acw62.useRef)(0);
        (0, $acw62.useLayoutEffect)(function() {
            onEnter();
        }, []);
        (0, $acw62.useEffect)(function() {
            if (!isIn) preventExitTransition ? onExited() : onExit();
        }, [
            isIn
        ]);
        function onEnter() {
            var node = nodeRef.current;
            baseClassName.current = node.className;
            node.className += " " + enterClassName;
            node.addEventListener('animationend', onEntered);
        }
        function onEntered() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onEntered);
            if (animationStep.current === 0) node.className = baseClassName.current;
        }
        function onExit() {
            animationStep.current = 1;
            var node = nodeRef.current;
            node.className += " " + exitClassName;
            node.addEventListener('animationend', onExited);
        }
        function onExited() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onExited);
            collapse ? $60f27fc97e29822a$export$184cca501f1aed7f(node, done, collapseDuration) : done();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    };
}
var $60f27fc97e29822a$var$eventManager = {
    list: /*#__PURE__*/ new Map(),
    emitQueue: /*#__PURE__*/ new Map(),
    on: function on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function off(event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function(cb) {
                return cb !== callback;
            });
            this.list.set(event, cb);
            return this;
        }
        this.list["delete"](event);
        return this;
    },
    cancelEmit: function cancelEmit(event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(clearTimeout);
            this.emitQueue["delete"](event);
        }
        return this;
    },
    /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */ emit: function emit(event) {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.list.has(event) && this.list.get(event).forEach(function(callback) {
            var timer = setTimeout(function() {
                // @ts-ignore
                callback.apply(void 0, args);
            }, 0);
            _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
            _this.emitQueue.get(event).push(timer);
        });
    }
};
/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */ function $60f27fc97e29822a$var$useKeeper(arg, refresh) {
    if (refresh === void 0) refresh = false;
    var ref = (0, $acw62.useRef)(arg);
    (0, $acw62.useEffect)(function() {
        if (refresh) ref.current = arg;
    });
    return ref.current;
}
function $60f27fc97e29822a$var$reducer(state, action) {
    switch(action.type){
        case 0:
            return [].concat(state, [
                action.toastId
            ]).filter(function(id) {
                return id !== action.staleId;
            });
        case 1:
            return $60f27fc97e29822a$var$isToastIdValid(action.toastId) ? state.filter(function(id) {
                return id !== action.toastId;
            }) : [];
    }
}
function $60f27fc97e29822a$export$b262e13ca2dd2381(props) {
    var _useReducer = (0, $acw62.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = _useReducer[1];
    var _useReducer2 = (0, $acw62.useReducer)($60f27fc97e29822a$var$reducer, []), toast = _useReducer2[0], dispatch = _useReducer2[1];
    var containerRef = (0, $acw62.useRef)(null);
    var toastCount = $60f27fc97e29822a$var$useKeeper(0);
    var queue = $60f27fc97e29822a$var$useKeeper([]);
    var collection = $60f27fc97e29822a$var$useKeeper({});
    var instance = $60f27fc97e29822a$var$useKeeper({
        toastKey: 1,
        displayedToast: 0,
        props: props,
        containerId: null,
        isToastActive: isToastActive,
        getToast: function getToast(id) {
            return collection[id] || null;
        }
    });
    (0, $acw62.useEffect)(function() {
        instance.containerId = props.containerId;
        $60f27fc97e29822a$var$eventManager.cancelEmit(3).on(0, buildToast).on(1, function(toastId) {
            return containerRef.current && removeToast(toastId);
        }).on(5, clearWaitingQueue).emit(2, instance);
        return function() {
            return $60f27fc97e29822a$var$eventManager.emit(3, instance);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        instance.isToastActive = isToastActive;
        instance.displayedToast = toast.length;
        $60f27fc97e29822a$var$eventManager.emit(4, toast.length, props.containerId);
    }, [
        toast
    ]);
    (0, $acw62.useEffect)(function() {
        instance.props = props;
    });
    function isToastActive(id) {
        return toast.indexOf(id) !== -1;
    }
    function clearWaitingQueue(_ref) {
        var containerId = _ref.containerId;
        var limit = instance.props.limit;
        if (limit && (!containerId || instance.containerId === containerId)) {
            toastCount -= queue.length;
            queue = [];
        }
    }
    function removeToast(toastId) {
        dispatch({
            type: 1,
            toastId: toastId
        });
    }
    function dequeueToast() {
        var _queue$shift = queue.shift(), toastContent = _queue$shift.toastContent, toastProps = _queue$shift.toastProps, staleId = _queue$shift.staleId;
        appendToast(toastContent, toastProps, staleId);
    }
    /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */ function isNotValid(_ref2) {
        var containerId = _ref2.containerId, toastId = _ref2.toastId, updateId = _ref2.updateId;
        return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
    } // this function and all the function called inside needs to rely on ref(`useKeeper`)
    function buildToast(content, _ref3) {
        var delay = _ref3.delay, staleId = _ref3.staleId, options = $60f27fc97e29822a$var$_objectWithoutPropertiesLoose(_ref3, [
            "delay",
            "staleId"
        ]);
        if (!$60f27fc97e29822a$var$canBeRendered(content) || isNotValid(options)) return;
        var toastId = options.toastId, updateId = options.updateId;
        var props = instance.props;
        var closeToast = function closeToast() {
            return removeToast(toastId);
        };
        var isNotAnUpdate = options.updateId == null;
        if (isNotAnUpdate) toastCount++;
        var toastProps = {
            toastId: toastId,
            updateId: updateId,
            isIn: false,
            key: options.key || instance.toastKey++,
            type: options.type,
            closeToast: closeToast,
            closeButton: options.closeButton,
            rtl: props.rtl,
            position: options.position || props.position,
            transition: options.transition || props.transition,
            className: $60f27fc97e29822a$var$parseClassName(options.className || props.toastClassName),
            bodyClassName: $60f27fc97e29822a$var$parseClassName(options.bodyClassName || props.bodyClassName),
            style: options.style || props.toastStyle,
            bodyStyle: options.bodyStyle || props.bodyStyle,
            onClick: options.onClick || props.onClick,
            pauseOnHover: $60f27fc97e29822a$var$isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
            pauseOnFocusLoss: $60f27fc97e29822a$var$isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
            draggable: $60f27fc97e29822a$var$isBool(options.draggable) ? options.draggable : props.draggable,
            draggablePercent: $60f27fc97e29822a$var$isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
            draggableDirection: options.draggableDirection || props.draggableDirection,
            closeOnClick: $60f27fc97e29822a$var$isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
            progressClassName: $60f27fc97e29822a$var$parseClassName(options.progressClassName || props.progressClassName),
            progressStyle: options.progressStyle || props.progressStyle,
            autoClose: $60f27fc97e29822a$var$getAutoCloseDelay(options.autoClose, props.autoClose),
            hideProgressBar: $60f27fc97e29822a$var$isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
            progress: options.progress,
            role: $60f27fc97e29822a$var$isStr(options.role) ? options.role : props.role,
            deleteToast: function deleteToast() {
                removeFromCollection(toastId);
            }
        };
        if ($60f27fc97e29822a$var$isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
        if ($60f27fc97e29822a$var$isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging
        if (toastProps.draggableDirection === "y" && toastProps.draggablePercent === 80) toastProps.draggablePercent *= 1.5;
        var closeButton = props.closeButton;
        if (options.closeButton === false || $60f27fc97e29822a$var$canBeRendered(options.closeButton)) closeButton = options.closeButton;
        else if (options.closeButton === true) closeButton = $60f27fc97e29822a$var$canBeRendered(props.closeButton) ? props.closeButton : true;
        toastProps.closeButton = closeButton;
        var toastContent = content;
        if ((0, $acw62.isValidElement)(content) && !$60f27fc97e29822a$var$isStr(content.type)) toastContent = (0, $acw62.cloneElement)(content, {
            closeToast: closeToast,
            toastProps: toastProps
        });
        else if ($60f27fc97e29822a$var$isFn(content)) toastContent = content({
            closeToast: closeToast,
            toastProps: toastProps
        });
         // not handling limit + delay by design. Waiting for user feedback first
        if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) queue.push({
            toastContent: toastContent,
            toastProps: toastProps,
            staleId: staleId
        });
        else if ($60f27fc97e29822a$var$isNum(delay) && delay > 0) setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, delay);
        else appendToast(toastContent, toastProps, staleId);
    }
    function appendToast(content, toastProps, staleId) {
        var toastId = toastProps.toastId;
        if (staleId) delete collection[staleId];
        collection[toastId] = {
            content: content,
            props: toastProps
        };
        dispatch({
            type: 0,
            toastId: toastId,
            staleId: staleId
        });
    }
    function removeFromCollection(toastId) {
        delete collection[toastId];
        var queueLen = queue.length;
        toastCount = $60f27fc97e29822a$var$isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
        if (toastCount < 0) toastCount = 0;
        if (queueLen > 0) {
            var freeSlot = $60f27fc97e29822a$var$isToastIdValid(toastId) ? 1 : instance.props.limit;
            if (queueLen === 1 || freeSlot === 1) {
                instance.displayedToast++;
                dequeueToast();
            } else {
                var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
                instance.displayedToast = toDequeue;
                for(var i = 0; i < toDequeue; i++)dequeueToast();
            }
        } else forceUpdate();
    }
    function getToastToRender(cb) {
        var toastToRender = {};
        var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);
        for(var i = 0; i < toastList.length; i++){
            var _toast = collection[toastList[i]];
            var position = _toast.props.position;
            toastToRender[position] || (toastToRender[position] = []);
            toastToRender[position].push(_toast);
        }
        return Object.keys(toastToRender).map(function(p) {
            return cb(p, toastToRender[p]);
        });
    }
    return {
        getToastToRender: getToastToRender,
        collection: collection,
        containerRef: containerRef,
        isToastActive: isToastActive
    };
}
function $60f27fc97e29822a$var$getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function $60f27fc97e29822a$var$getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function $60f27fc97e29822a$export$a407b657d3044108(props) {
    var _useState = (0, $acw62.useState)(true), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState2 = (0, $acw62.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
    var toastRef = (0, $acw62.useRef)(null);
    var drag = $60f27fc97e29822a$var$useKeeper({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: true,
        canDrag: false,
        boundingRect: null
    });
    var syncProps = $60f27fc97e29822a$var$useKeeper(props, true);
    var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
    (0, $acw62.useEffect)(function() {
        if ($60f27fc97e29822a$var$isFn(props.onOpen)) props.onOpen((0, $acw62.isValidElement)(props.children) && props.children.props);
        return function() {
            if ($60f27fc97e29822a$var$isFn(syncProps.onClose)) syncProps.onClose((0, $acw62.isValidElement)(syncProps.children) && syncProps.children.props);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        props.draggable && bindDragEvents();
        return function() {
            props.draggable && unbindDragEvents();
        };
    }, [
        props.draggable
    ]);
    (0, $acw62.useEffect)(function() {
        props.pauseOnFocusLoss && bindFocusEvents();
        return function() {
            props.pauseOnFocusLoss && unbindFocusEvents();
        };
    }, [
        props.pauseOnFocusLoss
    ]);
    function onDragStart(e) {
        if (props.draggable) {
            var toast = toastRef.current;
            drag.canCloseOnClick = true;
            drag.canDrag = true;
            drag.boundingRect = toast.getBoundingClientRect();
            toast.style.transition = '';
            drag.x = $60f27fc97e29822a$var$getX(e.nativeEvent);
            drag.y = $60f27fc97e29822a$var$getY(e.nativeEvent);
            if (props.draggableDirection === "x") {
                drag.start = drag.x;
                drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
            } else {
                drag.start = drag.y;
                drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
            }
        }
    }
    function onDragTransitionEnd() {
        if (drag.boundingRect) {
            var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
            if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) pauseToast();
            else playToast();
        }
    }
    function playToast() {
        setIsRunning(true);
    }
    function pauseToast() {
        setIsRunning(false);
    }
    function bindFocusEvents() {
        if (!document.hasFocus()) pauseToast();
        window.addEventListener('focus', playToast);
        window.addEventListener('blur', pauseToast);
    }
    function unbindFocusEvents() {
        window.removeEventListener('focus', playToast);
        window.removeEventListener('blur', pauseToast);
    }
    function bindDragEvents() {
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragEnd);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragEnd);
    }
    function unbindDragEvents() {
        document.removeEventListener('mousemove', onDragMove);
        document.removeEventListener('mouseup', onDragEnd);
        document.removeEventListener('touchmove', onDragMove);
        document.removeEventListener('touchend', onDragEnd);
    }
    function onDragMove(e) {
        if (drag.canDrag) {
            e.preventDefault();
            var toast = toastRef.current;
            if (isRunning) pauseToast();
            drag.x = $60f27fc97e29822a$var$getX(e);
            drag.y = $60f27fc97e29822a$var$getY(e);
            if (props.draggableDirection === "x") drag.delta = drag.x - drag.start;
            else drag.delta = drag.y - drag.start;
             // prevent false positif during a toast click
            if (drag.start !== drag.x) drag.canCloseOnClick = false;
            toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
            toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
        }
    }
    function onDragEnd() {
        var toast = toastRef.current;
        if (drag.canDrag) {
            drag.canDrag = false;
            if (Math.abs(drag.delta) > drag.removalDistance) {
                setPreventExitTransition(true);
                props.closeToast();
                return;
            }
            toast.style.transition = 'transform 0.2s, opacity 0.2s';
            toast.style.transform = "translate" + props.draggableDirection + "(0)";
            toast.style.opacity = '1';
        }
    }
    var eventHandlers = {
        onMouseDown: onDragStart,
        onTouchStart: onDragStart,
        onMouseUp: onDragTransitionEnd,
        onTouchEnd: onDragTransitionEnd
    };
    if (autoClose && pauseOnHover) {
        eventHandlers.onMouseEnter = pauseToast;
        eventHandlers.onMouseLeave = playToast;
    } // prevent toast from closing when user drags the toast
    if (closeOnClick) eventHandlers.onClick = function(e) {
        onClick && onClick(e);
        drag.canCloseOnClick && closeToast();
    };
    return {
        playToast: playToast,
        pauseToast: pauseToast,
        isRunning: isRunning,
        preventExitTransition: preventExitTransition,
        toastRef: toastRef,
        eventHandlers: eventHandlers
    };
}
function $60f27fc97e29822a$var$CloseButton(_ref) {
    var closeToast = _ref.closeToast, type = _ref.type, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
    return (0, $acw62.createElement)("button", {
        className: "Toastify__close-button Toastify__close-button--" + type,
        type: "button",
        onClick: function onClick(e) {
            e.stopPropagation();
            closeToast(e);
        },
        "aria-label": ariaLabel
    }, (0, $acw62.createElement)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, $acw62.createElement)("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $60f27fc97e29822a$var$ProgressBar(_ref) {
    var _cx, _animationEvent;
    var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn;
    var style = $60f27fc97e29822a$var$_extends({}, userStyle, {
        animationDuration: delay + "ms",
        animationPlayState: isRunning ? 'running' : 'paused',
        opacity: hide ? 0 : 1
    });
    if (controlledProgress) style.transform = "scaleX(" + progress + ")";
    var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
    var classNames = $60f27fc97e29822a$var$isFn(className) ? className({
        rtl: rtl,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, className); // 🧐 controlledProgress is derived from progress
    // so if controlledProgress is set
    // it means that this is also the case for progress
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function() {
        isIn && closeToast();
    }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin
    return (0, $acw62.createElement)("div", Object.assign({
        role: "progressbar",
        "aria-hidden": hide ? 'true' : 'false',
        "aria-label": "notification timer",
        className: classNames,
        style: style
    }, animationEvent));
}
$60f27fc97e29822a$var$ProgressBar.defaultProps = {
    type: $60f27fc97e29822a$var$TYPE.DEFAULT,
    hide: false
};
var $60f27fc97e29822a$var$Toast = function Toast(props) {
    var _cx;
    var _useToast = $60f27fc97e29822a$export$a407b657d3044108(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
    var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn;
    var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast", "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
    var cssClasses = $60f27fc97e29822a$var$isFn(className) ? className({
        rtl: rtl,
        position: position,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, className);
    var isProgressControlled = !!progress;
    function renderCloseButton(closeButton) {
        if (!closeButton) return;
        var props = {
            closeToast: closeToast,
            type: type
        };
        if ($60f27fc97e29822a$var$isFn(closeButton)) return closeButton(props);
        if ((0, $acw62.isValidElement)(closeButton)) return (0, $acw62.cloneElement)(closeButton, props);
    }
    return (0, $acw62.createElement)(Transition, {
        isIn: isIn,
        done: deleteToast,
        position: position,
        preventExitTransition: preventExitTransition,
        nodeRef: toastRef
    }, (0, $acw62.createElement)("div", Object.assign({
        id: toastId,
        onClick: onClick,
        className: cssClasses
    }, eventHandlers, {
        style: style,
        ref: toastRef
    }), (0, $acw62.createElement)("div", Object.assign({}, isIn && {
        role: role
    }, {
        className: $60f27fc97e29822a$var$isFn(bodyClassName) ? bodyClassName({
            type: type
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-body", bodyClassName),
        style: bodyStyle
    }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0, $acw62.createElement)($60f27fc97e29822a$var$ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
        key: "pb-" + updateId
    } : {}, {
        rtl: rtl,
        delay: autoClose,
        isRunning: isRunning,
        isIn: isIn,
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: isProgressControlled,
        progress: progress
    }))));
};
var $60f27fc97e29822a$export$d20e79fdc3899e95 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__bounce-enter",
    exit: "Toastify--animate Toastify__bounce-exit",
    appendPosition: true
});
var $60f27fc97e29822a$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__slide-enter",
    exit: "Toastify--animate Toastify__slide-exit",
    appendPosition: true
});
var $60f27fc97e29822a$export$65cfd44a2050f99 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__zoom-enter",
    exit: "Toastify--animate Toastify__zoom-exit"
});
var $60f27fc97e29822a$export$4d2fae537bd90431 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__flip-enter",
    exit: "Toastify--animate Toastify__flip-exit"
});
var $60f27fc97e29822a$export$f2815235e76a62b9 = function ToastContainer(props) {
    var _useToastContainer = $60f27fc97e29822a$export$b262e13ca2dd2381(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
    function getClassName(position) {
        var _cx;
        var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
        return $60f27fc97e29822a$var$isFn(className) ? className({
            position: position,
            rtl: rtl,
            defaultClassName: defaultClassName
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, $60f27fc97e29822a$var$parseClassName(className));
    }
    return (0, $acw62.createElement)("div", {
        ref: containerRef,
        className: "Toastify",
        id: containerId
    }, getToastToRender(function(position, toastList) {
        var containerStyle = toastList.length === 0 ? $60f27fc97e29822a$var$_extends({}, style, {
            pointerEvents: 'none'
        }) : $60f27fc97e29822a$var$_extends({}, style);
        return (0, $acw62.createElement)("div", {
            className: getClassName(position),
            style: containerStyle,
            key: "container-" + position
        }, toastList.map(function(_ref) {
            var content = _ref.content, toastProps = _ref.props;
            return (0, $acw62.createElement)($60f27fc97e29822a$var$Toast, Object.assign({}, toastProps, {
                isIn: isToastActive(toastProps.toastId),
                key: "toast-" + toastProps.key,
                closeButton: toastProps.closeButton === true ? $60f27fc97e29822a$var$CloseButton : toastProps.closeButton
            }), content);
        }));
    }));
};
$60f27fc97e29822a$export$f2815235e76a62b9.defaultProps = {
    position: $60f27fc97e29822a$var$POSITION.TOP_RIGHT,
    transition: $60f27fc97e29822a$export$d20e79fdc3899e95,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: $60f27fc97e29822a$var$CloseButton,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    draggableDirection: "x",
    role: 'alert'
};
var $60f27fc97e29822a$var$containers = /*#__PURE__*/ new Map();
var $60f27fc97e29822a$var$latestInstance;
var $60f27fc97e29822a$var$containerDomNode;
var $60f27fc97e29822a$var$containerConfig;
var $60f27fc97e29822a$var$queue = [];
var $60f27fc97e29822a$var$lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */ function $60f27fc97e29822a$var$isAnyContainerMounted() {
    return $60f27fc97e29822a$var$containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */ function $60f27fc97e29822a$var$getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = $60f27fc97e29822a$var$containers.get(containerId || $60f27fc97e29822a$var$latestInstance);
    if (!container) return null;
    return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */ function $60f27fc97e29822a$var$generateToastId() {
    return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */ function $60f27fc97e29822a$var$getToastId(options) {
    if (options && ($60f27fc97e29822a$var$isStr(options.toastId) || $60f27fc97e29822a$var$isNum(options.toastId))) return options.toastId;
    return $60f27fc97e29822a$var$generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */ function $60f27fc97e29822a$var$dispatchToast(content, options) {
    if ($60f27fc97e29822a$var$isAnyContainerMounted()) $60f27fc97e29822a$var$eventManager.emit(0, content, options);
    else {
        $60f27fc97e29822a$var$queue.push({
            content: content,
            options: options
        });
        if ($60f27fc97e29822a$var$lazy && $60f27fc97e29822a$var$canUseDom) {
            $60f27fc97e29822a$var$lazy = false;
            $60f27fc97e29822a$var$containerDomNode = document.createElement('div');
            document.body.appendChild($60f27fc97e29822a$var$containerDomNode);
            (0, $1u0KT.render)((0, $acw62.createElement)($60f27fc97e29822a$export$f2815235e76a62b9, Object.assign({}, $60f27fc97e29822a$var$containerConfig)), $60f27fc97e29822a$var$containerDomNode);
        }
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */ function $60f27fc97e29822a$var$mergeOptions(type, options) {
    return $60f27fc97e29822a$var$_extends({}, options, {
        type: options && options.type || type,
        toastId: $60f27fc97e29822a$var$getToastId(options)
    });
}
var $60f27fc97e29822a$var$createToastByType = function createToastByType(type) {
    return function(content, options) {
        return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions(type, options));
    };
};
var $60f27fc97e29822a$export$b410431fab84fa58 = function toast(content, options) {
    return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions($60f27fc97e29822a$var$TYPE.DEFAULT, options));
};
$60f27fc97e29822a$export$b410431fab84fa58.success = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.SUCCESS);
$60f27fc97e29822a$export$b410431fab84fa58.info = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.INFO);
$60f27fc97e29822a$export$b410431fab84fa58.error = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.ERROR);
$60f27fc97e29822a$export$b410431fab84fa58.warning = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.WARNING);
$60f27fc97e29822a$export$b410431fab84fa58.dark = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.DARK);
$60f27fc97e29822a$export$b410431fab84fa58.warn = $60f27fc97e29822a$export$b410431fab84fa58.warning;
/**
 * Remove toast programmaticaly
 */ $60f27fc97e29822a$export$b410431fab84fa58.dismiss = function(id) {
    return $60f27fc97e29822a$var$eventManager.emit(1, id);
};
/**
 * Clear waiting queue when limit is used
 */ $60f27fc97e29822a$export$b410431fab84fa58.clearWaitingQueue = function(params) {
    if (params === void 0) params = {};
    return $60f27fc97e29822a$var$eventManager.emit(5, params);
};
/**
 * return true if one container is displaying the toast
 */ $60f27fc97e29822a$export$b410431fab84fa58.isActive = function(id) {
    var isToastActive = false;
    $60f27fc97e29822a$var$containers.forEach(function(container) {
        if (container.isToastActive && container.isToastActive(id)) isToastActive = true;
    });
    return isToastActive;
};
$60f27fc97e29822a$export$b410431fab84fa58.update = function(toastId, options) {
    if (options === void 0) options = {};
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function() {
        var toast = $60f27fc97e29822a$var$getToast(toastId, options);
        if (toast) {
            var oldOptions = toast.props, oldContent = toast.content;
            var nextOptions = $60f27fc97e29822a$var$_extends({}, oldOptions, options, {
                toastId: options.toastId || toastId,
                updateId: $60f27fc97e29822a$var$generateToastId()
            });
            if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
            var content = nextOptions.render || oldContent;
            delete nextOptions.render;
            $60f27fc97e29822a$var$dispatchToast(content, nextOptions);
        }
    }, 0);
};
/**
 * Used for controlled progress bar.
 */ $60f27fc97e29822a$export$b410431fab84fa58.done = function(id) {
    $60f27fc97e29822a$export$b410431fab84fa58.update(id, {
        progress: 1
    });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */ $60f27fc97e29822a$export$b410431fab84fa58.onChange = function(callback) {
    if ($60f27fc97e29822a$var$isFn(callback)) $60f27fc97e29822a$var$eventManager.on(4, callback);
    return function() {
        $60f27fc97e29822a$var$isFn(callback) && $60f27fc97e29822a$var$eventManager.off(4, callback);
    };
};
/**
 * Configure the ToastContainer when lazy mounted
 */ $60f27fc97e29822a$export$b410431fab84fa58.configure = function(config) {
    if (config === void 0) config = {};
    $60f27fc97e29822a$var$lazy = true;
    $60f27fc97e29822a$var$containerConfig = config;
};
$60f27fc97e29822a$export$b410431fab84fa58.POSITION = $60f27fc97e29822a$var$POSITION;
$60f27fc97e29822a$export$b410431fab84fa58.TYPE = $60f27fc97e29822a$var$TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */ $60f27fc97e29822a$var$eventManager.on(2, function(containerInstance) {
    $60f27fc97e29822a$var$latestInstance = containerInstance.containerId || containerInstance;
    $60f27fc97e29822a$var$containers.set($60f27fc97e29822a$var$latestInstance, containerInstance);
    $60f27fc97e29822a$var$queue.forEach(function(item) {
        $60f27fc97e29822a$var$eventManager.emit(0, item.content, item.options);
    });
    $60f27fc97e29822a$var$queue = [];
}).on(3, function(containerInstance) {
    $60f27fc97e29822a$var$containers["delete"](containerInstance.containerId || containerInstance);
    if ($60f27fc97e29822a$var$containers.size === 0) $60f27fc97e29822a$var$eventManager.off(0).off(1).off(5);
    if ($60f27fc97e29822a$var$canUseDom && $60f27fc97e29822a$var$containerDomNode) document.body.removeChild($60f27fc97e29822a$var$containerDomNode);
});



const $de08facaa603a546$export$cd891b82501bb412 = {
    WELCOME: "/",
    HEALTHCHECK: "/healthcheck",
    LOGIN: "/login",
    AUTH0_CALLBACK: "/auth0_callback",
    AFTER_LOGIN: "/afterlogin",
    WHAT_IS_LP: "/whatislp",
    INTRODUCTION: "/introduction",
    GRID_OF_PROJECTS: "/projects",
    LIST_OF_PROJECTS: "/projects/details",
    PROJECT: "/projects/:projectId",
    PROJECT_CONFIGURATOR: "/projects/:projectId/configurator",
    PROJECT_TIMELINE: "/projects/:projectId/timeline",
    PROJECT_TIMELINE_WILDCARD: "/projects/:projectId/timeline/*",
    PROJECT_TIMELINE_SAMPLE: "/projects/:projectId/timeline/samples/:sampleId",
    PROJECT_TIMELINE_SAMPLE_WORKFLOW: "/projects/:projectId/timeline/samples/:sampleId/workflows/:workflowId",
    PROJECT_TIMELINE_SAMPLE_SERVICE: "/projects/:projectId/timeline/samples/:sampleId/workflows/:workflowId/services/:serviceId",
    PROJECT_TIMELINE_SAMPLE_EVENT: "/projects/:projectId/timeline/samples/:sampleId/events/:eventId",
    PROJECT_LIST_OF_RESULTS: "/projects/:projectId/results",
    PROJECT_RESULT: "/projects/:projectId/results/:resultId",
    LIST_OF_SAMPLES: "/projects/:projectId/configurator/samples",
    SAMPLE: "/projects/:projectId/configurator/samples/:sampleId",
    SAMPLE_CONFIGURATOR: "/projects/:projectId/configurator/samples/:sampleId/configurator",
    SAMPLE_TIMELINE: "/projects/:projectId/configurator/samples/:sampleId/timeline",
    REPORTS: "/reports",
    REPORT: "/reports/:projectId/:sampleId",
    MANAGE_TEAMS: "/manage-team",
    MANAGE_TEAM: "/manage-team/:projectId",
    USER_TASKS: "/user-tasks/:userId",
    GROUP_TASKS: "/group-tasks/:groupId",
    MANAGE_GROUPS: "/manage-groups",
    MANAGE_GROUP_MEMBERS: "/manage-groups/:groupId",
    MANAGE_USERS: "/manage-users",
    DASHBOARD: "/dashboard",
    TASKS: "/tasks",
    TASKS_TABLE: "/tasks/:projectId",
    REGULATORY: "/regulatory",
    REGULATORY_ECTD_MAPPING: "/regulatory/ectd-mapping"
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");
const $a9484fd40cfd560e$export$2fd68ac541630219 = {
    newColors: {
        primary: {
            basic: "#3B79D1",
            hover: "#1F5FBC",
            darkestTint: "#204B88",
            darkTint: "#2A62B2",
            lightTint: "#EBF2FA",
            lightestTint: "#F5F8FD"
        },
        secondary: {
            basic: "#52B79F",
            hover: "#43A28B",
            darkestTint: "#347E6C",
            darkTint: "#43A28B",
            lightTint: "#EEF8F5",
            lightestTint: "#F6FBFA"
        },
        grayscale: {
            primaryGray: "#232F3C",
            secondaryGray: "#77808E",
            tertiaryGray: "#6E7D92",
            placeholder: "#ADB1BC",
            disabled: "#E7E7E7",
            bordersInside: "#DEDEDE",
            bordersOutside: "#D1D5D8",
            background: "#E8EAEE",
            hoverAreaOnDark: "rgba(255, 255, 255, 0.05)",
            white: "#FFFFFF"
        },
        extra: {
            tertiaryButtonBG: "#F9FAFC",
            successBasic: "#31A354",
            successArea: "#EDF8E9",
            errorState: "#DE2D26",
            errorHovered: "#CC1A1F",
            errorActive: "#AA1A1F",
            warningState: "#EAB838",
            selectedTaskOverlay: "rgba(59, 121, 209, 0.2)",
            selectedTaskBorder: "rgba(59, 121, 209, 0.75)",
            selectedBlock: "#D7E4F6"
        }
    },
    shadows: {
        dropShadows: {
            modal: "0px 4px 8px rgba(43, 115, 220, 0.3)",
            formCard: "0px 1px 0px #D1D5D8",
            expander: "0px 4px 8px rgba(43, 115, 220, 0.3)"
        },
        userInputs: {
            basicInside: "0px 1px 2px rgba(220, 222, 229, 0.3)",
            basicOutside: "0px 1px 2px rgba(218, 220, 226, 0.7)",
            activeState: "0px 1px 2px rgba(59, 121, 209, 0.2)",
            hoveredState: "0px 2px 4px rgba(220, 222, 229, 0.6)",
            errorState: "0px 1px 2px rgba(222, 45, 38, 0.2)"
        },
        sideDrawboard: {
            basicLeftOutisde: "-2px 1px 2px rgba(218, 220, 226, 0.7)"
        },
        icons: {
            expandIcon: "0 4px 8px 0 rgba(43, 115, 220, 0.3)"
        },
        dropdowns: {
            menu: "0 1px 8px rgba(0, 0, 0, 0.3)"
        }
    },
    colors: {
        gray05: "#E4E4E4",
        white: "#fff",
        whiteBg: "#fff",
        lightBg: "#E8EAEE",
        darkBg: "#232F3C",
        blackBg: "#18202e",
        lightText: "#9D9EA3",
        athensGray: "#f0f3f6",
        frenchGray: "#c5c6cb",
        inputError: "#DE1C22",
        inputDisabled: "#e4e4e4",
        selectHover: "#888",
        lightGreen: "#52b79f",
        greySecondary: "#6C727F",
        tertiaryGray: "#6E7D92"
    },
    lineHeights: [
        "12px",
        "14px",
        "16px",
        "20px",
        "24px"
    ],
    fontSizes: [
        "12px",
        "14px",
        "16px",
        "18px",
        "20px",
        "24px",
        "32px",
        "48px",
        "64px"
    ],
    space: [
        "0px",
        "4px",
        "8px",
        "16px",
        "32px",
        "64px",
        "128px",
        "256px"
    ],
    maxContentWidth: "1208px",
    radius: {
        default: "8px"
    },
    fonts: {
        body: "Overpass, sans-serif",
        heading: "inherit"
    },
    fontWeights: {
        body: "normal",
        heading: 800
    }
};


const $4a8ee0766077991c$export$8eea0721e4ba542 = ({ width: width, height: height, color: color, viewBoxWidth: viewBoxWidth, viewBoxHeight: viewBoxHeight, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${viewBoxWidth} ${viewBoxHeight}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M36.6869 19.235H33.2728V22.85H32V12.635C32 12.205 32.1398 11.85 32.4193 11.57C32.6988 11.29 33.0532 11.15 33.4824 11.15H36.6869C37.9048 11.15 38.9031 11.52 39.6817 12.26C40.4704 13 40.8647 13.97 40.8647 15.17C40.8647 16.37 40.4704 17.35 39.6817 18.11C38.9031 18.86 37.9048 19.235 36.6869 19.235ZM33.2728 12.875V18.035H36.6869C37.5354 18.035 38.2242 17.77 38.7533 17.24C39.2924 16.71 39.5619 16.02 39.5619 15.17C39.5619 14.34 39.2924 13.665 38.7533 13.145C38.2143 12.615 37.5255 12.35 36.6869 12.35H33.7669C33.6272 12.35 33.5074 12.4 33.4076 12.5C33.3177 12.6 33.2728 12.725 33.2728 12.875Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M50.6974 22.85H44.9623C44.4931 22.85 44.1188 22.71 43.8393 22.43C43.5697 22.15 43.435 21.78 43.435 21.32V11.15H44.7078V21.14C44.7078 21.49 44.8725 21.665 45.2019 21.665H50.6974V22.85Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M61.2465 22.85L59.779 19.1H54.2685L52.831 22.85H51.5133L55.751 12.08C55.8907 11.74 56.0554 11.49 56.2451 11.33C56.4348 11.16 56.6943 11.075 57.0238 11.075C57.3732 11.075 57.6477 11.16 57.8473 11.33C58.047 11.49 58.2167 11.74 58.3565 12.08L62.5941 22.85H61.2465ZM56.8141 12.5L54.7327 17.9H59.3148L57.2034 12.5C57.1535 12.39 57.0886 12.335 57.0088 12.335C56.9289 12.335 56.864 12.39 56.8141 12.5Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M71.8476 12.35H67.5949V22.85H66.3221V12.35H62.0545V11.15H71.8476V12.35Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M81.0077 17.975H75.1828V22.85H73.91V12.68C73.91 12.22 74.0498 11.85 74.3293 11.57C74.6088 11.29 74.9782 11.15 75.4374 11.15H81.3671V12.35H75.677C75.3475 12.35 75.1828 12.525 75.1828 12.875V16.775H81.0077V17.975Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M93.3616 21.32C92.2336 22.44 90.7861 23 89.0191 23C87.2522 23 85.8047 22.44 84.6766 21.32C83.5486 20.2 82.9846 18.76 82.9846 17C82.9846 15.25 83.5486 13.815 84.6766 12.695C85.8147 11.565 87.2622 11 89.0191 11C90.7761 11 92.2186 11.565 93.3467 12.695C94.4847 13.815 95.0537 15.25 95.0537 17C95.0537 18.76 94.4897 20.2 93.3616 21.32ZM89.0191 21.815C90.4167 21.815 91.5548 21.365 92.4332 20.465C93.3117 19.565 93.751 18.41 93.751 17C93.751 15.6 93.3117 14.45 92.4332 13.55C91.5548 12.65 90.4167 12.2 89.0191 12.2C87.6315 12.2 86.4935 12.65 85.605 13.55C84.7266 14.45 84.2873 15.6 84.2873 17C84.2873 18.41 84.7266 19.565 85.605 20.465C86.4935 21.365 87.6315 21.815 89.0191 21.815Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M105.663 22.85L102.518 18.5H99.2087V22.85H97.9359V12.68C97.9359 12.24 98.0756 11.875 98.3552 11.585C98.6447 11.295 99.014 11.15 99.4632 11.15H102.982C104.13 11.15 105.084 11.48 105.842 12.14C106.611 12.8 106.995 13.7 106.995 14.84C106.995 15.76 106.711 16.53 106.142 17.15C105.573 17.76 104.839 18.165 103.941 18.365L107.19 22.85H105.663ZM99.2087 12.875V17.33H102.982C103.761 17.33 104.405 17.105 104.914 16.655C105.433 16.205 105.692 15.6 105.692 14.84C105.692 14.06 105.433 13.45 104.914 13.01C104.405 12.57 103.761 12.35 102.982 12.35H99.7028C99.5531 12.35 99.4333 12.4 99.3435 12.5C99.2536 12.6 99.2087 12.725 99.2087 12.875Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M116.456 20.195C115.837 20.195 115.373 19.855 115.064 19.175L111.829 12.71C111.749 12.53 111.64 12.44 111.5 12.44C111.41 12.44 111.335 12.47 111.275 12.53C111.215 12.59 111.185 12.67 111.185 12.77V22.85H109.913V12.755C109.913 12.225 110.032 11.815 110.272 11.525C110.522 11.225 110.891 11.075 111.38 11.075C111.769 11.075 112.089 11.18 112.338 11.39C112.598 11.59 112.833 11.94 113.042 12.44L116.127 18.62C116.227 18.79 116.337 18.875 116.456 18.875C116.596 18.875 116.706 18.79 116.786 18.62L119.87 12.44C120.08 11.94 120.315 11.59 120.574 11.39C120.834 11.18 121.158 11.075 121.548 11.075C122.516 11.075 123 11.635 123 12.755V22.85H121.727V12.77C121.727 12.55 121.632 12.44 121.443 12.44C121.293 12.44 121.173 12.53 121.083 12.71L117.849 19.175C117.549 19.855 117.085 20.195 116.456 20.195Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.9716 6.09562V1C32.4382 1 32 1.44733 32 1.9919V6.99027H35.2483V6.09562H32.9716ZM58.396 1.00977C58.3864 1.50571 57.9959 1.90442 57.5101 1.90442H54.1665C54.176 1.40847 54.5666 1.00977 55.0524 1.00977H58.396ZM57.9387 3.54781C57.9387 4.01459 57.5863 4.40356 57.1481 4.44246H57.0623H54.7476C54.7761 4.33549 54.7952 4.2188 54.8047 4.11183V3.98541C54.8047 3.90762 54.8047 3.82982 54.7857 3.76175C54.7857 3.69181 54.7703 3.62972 54.7533 3.56137L54.7476 3.53809H57.9387V3.54781ZM57.6911 6.9904C58.1197 6.94177 58.4627 6.56252 58.4627 6.10547H54.9381C54.5094 6.15409 54.1665 6.53335 54.1665 6.9904H57.6911ZM37.4201 4.39384V6.09562H40.0302V6.99027H36.439V1.9919C36.439 1.44733 36.8867 1 37.4201 1H39.954V1.90438H37.4201V3.48946H39.8587V4.39384H37.4201ZM45.0504 2.50729L44.4598 1.02917L44.4502 1H44.2216C43.8311 1 43.4977 1.23339 43.3452 1.57374L43.3357 1.60292L43.2976 1.70016L41.1353 6.99027H42.1831L42.7165 5.61912H45.2409L45.7648 6.99027H46.8507L45.0504 2.50729ZM43.0023 4.79254L43.7263 2.84765L43.9644 2.20583L44.2597 2.98379L44.9361 4.79254H43.0023ZM74.6187 1.02917L75.2093 2.50729L77.0002 7H75.9142L75.3903 5.62885H72.866L72.3325 7H71.2847L73.447 1.70016L73.4851 1.60292L73.4947 1.57374C73.6566 1.23339 73.99 1 74.3806 1H74.6092L74.6187 1.02917ZM73.8852 2.84765L73.1613 4.79254H75.1045L74.4187 2.98379L74.1234 2.20583L73.8852 2.84765ZM49.861 6.09562H48.956V1.90438H49.9276C50.7088 1.9141 51.3279 2.21556 51.6804 2.76013C51.8995 2.51702 52.1853 2.33225 52.5091 2.24473C51.9662 1.42788 51.0041 1 49.8229 1H48.956C48.4226 1 47.9844 1.44733 47.9844 1.9919V6.99027H49.9086C51.2041 6.99027 52.0424 6.47488 52.5091 5.75527C52.1948 5.66775 51.909 5.48298 51.6899 5.23987C51.3375 5.81361 50.6992 6.09562 49.861 6.09562ZM63.8068 2.67261C63.8068 3.7034 63.1781 4.1799 62.3207 4.32577L63.9211 6.99028H62.9113L61.3586 4.38412H60.7585V7H59.7773V1.8752C59.7773 1.41815 60.1107 1.04862 60.5489 1H61.5968C62.7685 1 63.8068 1.33063 63.8068 2.67261ZM60.7585 1.88493V3.51864H61.5777C62.1874 3.51864 62.8256 3.3825 62.8256 2.70178C62.8256 1.97245 62.1874 1.88493 61.5777 1.88493H60.7585ZM69.2843 1.8752V1.97245V2.06969C69.2843 3.2269 69.2843 4.39384 69.2938 5.55105H69.2843C68.5127 4.35494 67.7411 3.15883 66.96 1.96272C66.8837 1.84197 66.8043 1.71965 66.7243 1.5964L66.7242 1.59626C66.6046 1.41187 66.4836 1.22538 66.3694 1.0389C66.3659 1.03528 66.3636 1.03032 66.3613 1.02502L66.3613 1.025C66.3572 1.01604 66.3528 1.0061 66.3408 1H66.1122C65.6454 1 65.2549 1.3987 65.2549 1.8752V6.99027H66.1979C66.1979 6.43598 66.1979 3.80065 66.1884 2.75041V2.41977H66.1979C66.2646 2.51702 66.3218 2.60454 66.3789 2.70178C66.6929 3.1859 67.0048 3.66782 67.316 4.14865L67.3162 4.14895C67.93 5.09746 68.541 6.04173 69.1605 6.99027H70.2178V1C69.7415 1 69.3319 1.37925 69.2843 1.8752ZM54.062 3.99539C54.062 3.85925 54.043 3.72311 53.9953 3.59669C53.9858 3.58696 53.9763 3.56751 53.9667 3.53834C53.7953 3.16881 53.4238 2.90625 52.9951 2.90625C52.938 2.90625 52.8808 2.90625 52.8332 2.91597C52.4331 2.98405 52.1092 3.27578 51.9854 3.65503C51.9473 3.762 51.9282 3.86897 51.9282 3.98567C51.9282 4.10236 51.9473 4.21905 51.9854 4.32602C52.1092 4.715 52.4331 4.99701 52.8237 5.05536C52.8808 5.07481 52.938 5.07481 52.9951 5.07481C53.4333 5.07481 53.7953 4.81225 53.9667 4.44272C54.0334 4.30657 54.062 4.16071 54.062 3.99539Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6321 24 24 18.6321 24 12C24 5.36791 18.6321 0 12 0C5.36791 0 0 5.36791 0 12C0 18.6321 5.36791 24 12 24ZM18.4767 5.13477C18.4572 6.28225 17.5431 7.17691 16.4151 7.17691H8.57715C8.5966 6.02942 9.5107 5.13477 10.6387 5.13477H18.4767ZM17.4068 10.9696C17.3873 12.0393 16.5899 12.9145 15.5397 13.0312H15.3258H9.91895L9.91895 13.0312L9.91895 13.0312C9.9773 12.7784 10.0356 12.5256 10.0551 12.2727V11.981C10.0551 11.806 10.0551 11.6309 10.0162 11.4559C10.0162 11.2808 9.97729 11.1058 9.9384 10.9502H17.4068V10.9696ZM16.8235 18.8459C17.8348 18.7487 18.6323 17.8735 18.6323 16.8232H10.3859C9.37455 16.9399 8.57715 17.7957 8.57715 18.8459H16.8235ZM8.18825 11.086C8.30494 11.3778 8.36329 11.6889 8.36329 12.0001C8.36329 12.3697 8.28549 12.7003 8.14935 13.0309C7.76037 13.8867 6.88517 14.4701 5.89327 14.4701C5.75713 14.4701 5.62099 14.4507 5.5043 14.4312C4.5902 14.2951 3.83169 13.6533 3.53995 12.7586C3.44271 12.5058 3.40381 12.253 3.40381 11.9807C3.40381 11.7084 3.44271 11.4556 3.53995 11.2222C3.83169 10.347 4.59019 9.6857 5.52374 9.53011C5.64044 9.49121 5.77658 9.49121 5.89327 9.49121C6.90462 9.49121 7.76037 10.0941 8.14935 10.9499C8.14935 11.0082 8.1688 11.0666 8.18825 11.086Z",
        fill: color
    }));
};
$4a8ee0766077991c$export$8eea0721e4ba542.defaultProps = {
    width: "124",
    height: "24",
    viewBoxHeight: "24",
    viewBoxWidth: "124",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $fe7277f9493cf0da$export$b42aec0a4a94c970 = (props)=>{
    const { size: size, color: color, width: width, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fe7277f9493cf0da$var$StyledSpinner, {
        viewBox: "0 0 50 50",
        size: size,
        color: color,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        className: "path",
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeWidth: width
    }));
};
$fe7277f9493cf0da$export$b42aec0a4a94c970.defaultProps = {
    size: 16,
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
    width: 2
};
const $fe7277f9493cf0da$var$StyledSpinner = (0, $lmFrL.default).svg`
  animation: rotate 1s linear infinite;
  width: ${({ size: size })=>size}px;
  height: ${({ size: size })=>size}px;

  & .path {
    stroke: ${({ color: color })=>color};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;


const $a6474a3dbf48270d$export$7f7cbe89f1eacd2 = (props)=>{
    const { className: className, opaque: opaque, containerSize: containerSize } = props;
    return /*#__PURE__*/ $acw62.createElement($a6474a3dbf48270d$var$Container, {
        className: className,
        "data-testid": "spinner",
        opaque: opaque,
        containerSize: containerSize
    }, /*#__PURE__*/ $acw62.createElement((0, $4a8ee0766077991c$export$8eea0721e4ba542), {
        color: "black"
    }), /*#__PURE__*/ $acw62.createElement((0, $fe7277f9493cf0da$export$b42aec0a4a94c970), {
        size: 180
    }));
};
const $a6474a3dbf48270d$var$Container = (0, $lmFrL.default).div`
  z-index: 100;
  position: ${({ containerSize: containerSize })=>containerSize ? "absolute" : "fixed"};
  left: 0;
  top: 0;
  width: ${({ containerSize: containerSize })=>containerSize ? "100%" : "100vw"};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: ${({ containerSize: containerSize })=>containerSize ? "100%" : "100vh"};
  background-color: rgba(
    255,
    255,
    255,
    ${({ opaque: opaque })=>opaque ? 0.6 : 0}
  );

  > svg:last-child {
    position: absolute;
  }
`;



var $7WQrb = parcelRequire("7WQrb");

var $4i0Ci = parcelRequire("4i0Ci");
var $f8ISh = parcelRequire("f8ISh");

var $kwUjq = parcelRequire("kwUjq");
var $3gKaa = parcelRequire("3gKaa");

var $6Z7su = parcelRequire("6Z7su");

var $8JRy9 = parcelRequire("8JRy9");

var $4XkMM = parcelRequire("4XkMM");
var $e00e7370e665423b$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($e00e7370e665423b$export$bd096ddbd246c79c || ($e00e7370e665423b$export$bd096ddbd246c79c = {}));
function $e00e7370e665423b$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $e00e7370e665423b$var$Observable = function(_super) {
    (0, $7WQrb.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6Z7su.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $3gKaa.default));
function $e00e7370e665423b$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $e00e7370e665423b$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $e00e7370e665423b$var$generateErrorMessage = function(err) {
    var message = '';
    if ($e00e7370e665423b$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $e00e7370e665423b$export$26a337512320b8c6 = function(_super) {
    (0, $7WQrb.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $e00e7370e665423b$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $e00e7370e665423b$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($e00e7370e665423b$export$160bafb6ac1e0641 || ($e00e7370e665423b$export$160bafb6ac1e0641 = {}));
var $e00e7370e665423b$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $e00e7370e665423b$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $e00e7370e665423b$export$6c1b56eac59c9584 = function(_super) {
    (0, $7WQrb.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $4i0Ci.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $e00e7370e665423b$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($e00e7370e665423b$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $e00e7370e665423b$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $e00e7370e665423b$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $e00e7370e665423b$export$bd096ddbd246c79c.loading : $e00e7370e665423b$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
            stale: false
        }));
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $f8ISh.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8JRy9.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $f8ISh.equal)(this.variables, variables)) this.variables = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.variables), variables);
        if (!(0, $f8ISh.equal)(this.options.variables, this.variables)) this.options.variables = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $e00e7370e665423b$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8JRy9.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $e00e7370e665423b$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $f8ISh.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $4i0Ci.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $e00e7370e665423b$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $4i0Ci.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $e00e7370e665423b$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $e00e7370e665423b$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $e00e7370e665423b$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $e00e7370e665423b$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $f8ISh.equal)(previousVariables, variables)) _this.refetch();
                        else $e00e7370e665423b$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $e00e7370e665423b$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($e00e7370e665423b$var$Observable);
function $e00e7370e665423b$var$defaultSubscriptionObserverErrorCallback(error) {}
function $e00e7370e665423b$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $e00e7370e665423b$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8JRy9.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $e00e7370e665423b$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $e00e7370e665423b$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8JRy9.invariant)(!previousQuery || previousQuery.document === query.document || (0, $f8ISh.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $e00e7370e665423b$export$bd096ddbd246c79c.loading) {
            if (!(0, $f8ISh.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.refetch;
        else networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $e00e7370e665423b$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $e00e7370e665423b$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $e00e7370e665423b$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $e00e7370e665423b$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $4i0Ci.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $4i0Ci.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $4i0Ci.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $4i0Ci.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8JRy9.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $7WQrb.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $4XkMM.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $4XkMM.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $4i0Ci.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $7WQrb.__generator)(this, function(_b) {
                mainDefinition = (0, $4i0Ci.getMainDefinition)(document);
                fragments = (0, $4i0Ci.getFragmentDefinitions)(document);
                fragmentMap = (0, $4i0Ci.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $e00e7370e665423b$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $7WQrb.__generator)(this, function(_a) {
                            if (!(0, $4i0Ci.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $4i0Ci.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $4i0Ci.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $4i0Ci.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8JRy9.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $4i0Ci.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $4i0Ci.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $4i0Ci.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $e00e7370e665423b$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $e00e7370e665423b$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $e00e7370e665423b$var$asyncMap(observable, mapFn) {
    return new $e00e7370e665423b$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $e00e7370e665423b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e00e7370e665423b$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $e00e7370e665423b$var$MutationStore();
        this.queryStore = new $e00e7370e665423b$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $4i0Ci.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $e00e7370e665423b$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8JRy9.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8JRy9.invariant)(mutation, 9);
                        (0, $8JRy9.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $e00e7370e665423b$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $4i0Ci.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $e00e7370e665423b$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $e00e7370e665423b$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($e00e7370e665423b$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $4i0Ci.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $4i0Ci.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $e00e7370e665423b$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $e00e7370e665423b$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($e00e7370e665423b$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $e00e7370e665423b$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $e00e7370e665423b$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $e00e7370e665423b$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $e00e7370e665423b$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $e00e7370e665423b$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $4i0Ci.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $4i0Ci.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $4i0Ci.getDefaultValues)((0, $4i0Ci.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8JRy9.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $7WQrb.__assign)({}, options);
        return new $e00e7370e665423b$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8JRy9.invariant)(options.query, 12);
        (0, $8JRy9.invariant)(options.query.kind === 'Document', 13);
        (0, $8JRy9.invariant)(!options.returnPartialData, 14);
        (0, $8JRy9.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8JRy9.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $4i0Ci.graphQLResultHasError)(result)) throw new $e00e7370e665423b$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $e00e7370e665423b$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8JRy9.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $4i0Ci.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $e00e7370e665423b$var$multiplex((0, $kwUjq.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $e00e7370e665423b$var$multiplex((0, $kwUjq.execute)(link, operation));
        } else {
            observable = $e00e7370e665423b$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $e00e7370e665423b$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $e00e7370e665423b$var$isNonEmptyArray(result.errors)) return reject(new $e00e7370e665423b$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $e00e7370e665423b$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $e00e7370e665423b$export$bd096ddbd246c79c.ready && query.networkStatus !== $e00e7370e665423b$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8JRy9.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $e00e7370e665423b$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $e00e7370e665423b$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $4i0Ci.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $4i0Ci.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $4i0Ci.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $4i0Ci.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $4i0Ci.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $4i0Ci.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $4i0Ci.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $e00e7370e665423b$var$version = "2.6.10";
var $e00e7370e665423b$var$hasSuggestedDevtools = false;
var $e00e7370e665423b$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $kwUjq.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8JRy9.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $e00e7370e665423b$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        $e00e7370e665423b$var$hasSuggestedDevtools;
        this.version = $e00e7370e665423b$var$version;
        this.localState = new $e00e7370e665423b$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $e00e7370e665423b$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.defaultOptions.query), options);
        (0, $8JRy9.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $kwUjq.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $e00e7370e665423b$export$2e2bcd8739ae039 = $e00e7370e665423b$export$13f5a5f0f1dbab88;



var $7WQrb = parcelRequire("7WQrb");

var $kwUjq = parcelRequire("kwUjq");
var $3gKaa = parcelRequire("3gKaa");
function $1b4fdaed0df28296$export$2f04de43fe27971a(setter) {
    return new (0, $kwUjq.ApolloLink)(function(operation, forward) {
        var request = (0, $7WQrb.__rest)(operation, []);
        return new (0, $3gKaa.default)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}



var $7WQrb = parcelRequire("7WQrb");

var $kwUjq = parcelRequire("kwUjq");
var $3gKaa = parcelRequire("3gKaa");

var $7WQrb = parcelRequire("7WQrb");
var $149a6acdaf4063ad$exports = {};
"use strict";
Object.defineProperty($149a6acdaf4063ad$exports, "__esModule", {
    value: true
});
$149a6acdaf4063ad$exports.print = $149a6acdaf4063ad$var$print;

var $4XkMM = parcelRequire("4XkMM");
var $42cd4d54e0c60478$exports = {};
"use strict";
Object.defineProperty($42cd4d54e0c60478$exports, "__esModule", {
    value: true
});
$42cd4d54e0c60478$exports.dedentBlockStringValue = $42cd4d54e0c60478$var$dedentBlockStringValue;
$42cd4d54e0c60478$exports.getBlockStringIndentation = $42cd4d54e0c60478$var$getBlockStringIndentation;
$42cd4d54e0c60478$exports.printBlockString = $42cd4d54e0c60478$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $42cd4d54e0c60478$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $42cd4d54e0c60478$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $42cd4d54e0c60478$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $42cd4d54e0c60478$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $42cd4d54e0c60478$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $42cd4d54e0c60478$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $42cd4d54e0c60478$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $149a6acdaf4063ad$var$print(ast) {
    return (0, $4XkMM.visit)(ast, {
        leave: $149a6acdaf4063ad$var$printDocASTReducer
    });
}
var $149a6acdaf4063ad$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $149a6acdaf4063ad$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $149a6acdaf4063ad$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(node.variableDefinitions, ', '), ')');
        var directives = $149a6acdaf4063ad$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $149a6acdaf4063ad$var$join([
            op,
            $149a6acdaf4063ad$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $149a6acdaf4063ad$var$wrap(' = ', defaultValue) + $149a6acdaf4063ad$var$wrap(' ', $149a6acdaf4063ad$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $149a6acdaf4063ad$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $149a6acdaf4063ad$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(args, ', '), ')');
        if (argsLine.length > $149a6acdaf4063ad$var$MAX_LINE_LENGTH) argsLine = prefix + $149a6acdaf4063ad$var$wrap('(\n', $149a6acdaf4063ad$var$indent($149a6acdaf4063ad$var$join(args, '\n')), '\n)');
        return $149a6acdaf4063ad$var$join([
            argsLine,
            $149a6acdaf4063ad$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $149a6acdaf4063ad$var$wrap(' ', $149a6acdaf4063ad$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $149a6acdaf4063ad$var$join([
            '...',
            $149a6acdaf4063ad$var$wrap('on ', typeCondition),
            $149a6acdaf4063ad$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($149a6acdaf4063ad$var$wrap('', $149a6acdaf4063ad$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $42cd4d54e0c60478$exports.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $149a6acdaf4063ad$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $149a6acdaf4063ad$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $149a6acdaf4063ad$var$join([
            'schema',
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $149a6acdaf4063ad$var$join([
            'scalar',
            name,
            $149a6acdaf4063ad$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $149a6acdaf4063ad$var$join([
            'type',
            name,
            $149a6acdaf4063ad$var$wrap('implements ', $149a6acdaf4063ad$var$join(interfaces, ' & ')),
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($149a6acdaf4063ad$var$hasMultilineItems(args) ? $149a6acdaf4063ad$var$wrap('(\n', $149a6acdaf4063ad$var$indent($149a6acdaf4063ad$var$join(args, '\n')), '\n)') : $149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(args, ', '), ')')) + ': ' + type + $149a6acdaf4063ad$var$wrap(' ', $149a6acdaf4063ad$var$join(directives, ' '));
    }),
    InputValueDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $149a6acdaf4063ad$var$join([
            name + ': ' + type,
            $149a6acdaf4063ad$var$wrap('= ', defaultValue),
            $149a6acdaf4063ad$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $149a6acdaf4063ad$var$join([
            'interface',
            name,
            $149a6acdaf4063ad$var$wrap('implements ', $149a6acdaf4063ad$var$join(interfaces, ' & ')),
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $149a6acdaf4063ad$var$join([
            'union',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $149a6acdaf4063ad$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $149a6acdaf4063ad$var$join([
            'enum',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $149a6acdaf4063ad$var$join([
            name,
            $149a6acdaf4063ad$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $149a6acdaf4063ad$var$join([
            'input',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $149a6acdaf4063ad$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($149a6acdaf4063ad$var$hasMultilineItems(args) ? $149a6acdaf4063ad$var$wrap('(\n', $149a6acdaf4063ad$var$indent($149a6acdaf4063ad$var$join(args, '\n')), '\n)') : $149a6acdaf4063ad$var$wrap('(', $149a6acdaf4063ad$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $149a6acdaf4063ad$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $149a6acdaf4063ad$var$join([
            'extend schema',
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $149a6acdaf4063ad$var$join([
            'extend scalar',
            name,
            $149a6acdaf4063ad$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $149a6acdaf4063ad$var$join([
            'extend type',
            name,
            $149a6acdaf4063ad$var$wrap('implements ', $149a6acdaf4063ad$var$join(interfaces, ' & ')),
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $149a6acdaf4063ad$var$join([
            'extend interface',
            name,
            $149a6acdaf4063ad$var$wrap('implements ', $149a6acdaf4063ad$var$join(interfaces, ' & ')),
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $149a6acdaf4063ad$var$join([
            'extend union',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $149a6acdaf4063ad$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $149a6acdaf4063ad$var$join([
            'extend enum',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $149a6acdaf4063ad$var$join([
            'extend input',
            name,
            $149a6acdaf4063ad$var$join(directives, ' '),
            $149a6acdaf4063ad$var$block(fields)
        ], ' ');
    }
};
function $149a6acdaf4063ad$var$addDescription(cb) {
    return function(node) {
        return $149a6acdaf4063ad$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $149a6acdaf4063ad$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $149a6acdaf4063ad$var$block(array) {
    return $149a6acdaf4063ad$var$wrap('{\n', $149a6acdaf4063ad$var$indent($149a6acdaf4063ad$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $149a6acdaf4063ad$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $149a6acdaf4063ad$var$indent(str) {
    return $149a6acdaf4063ad$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $149a6acdaf4063ad$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $149a6acdaf4063ad$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($149a6acdaf4063ad$var$isMultiline);
}



var $8JRy9 = parcelRequire("8JRy9");
var $ac962991e241437c$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $ac962991e241437c$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $ac962991e241437c$var$defaultOptions = {
    method: 'POST'
};
var $ac962991e241437c$export$dd86f00dc866e75d = {
    http: $ac962991e241437c$var$defaultHttpOptions,
    headers: $ac962991e241437c$var$defaultHeaders,
    options: $ac962991e241437c$var$defaultOptions
};
var $ac962991e241437c$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $ac962991e241437c$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $ac962991e241437c$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $ac962991e241437c$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $ac962991e241437c$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8JRy9.InvariantError)(1);
    }
};
var $ac962991e241437c$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $ac962991e241437c$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $7WQrb.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $7WQrb.__assign)({}, options, config.options, {
            headers: (0, $7WQrb.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $7WQrb.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $149a6acdaf4063ad$exports.print)(query);
    return {
        options: options,
        body: body
    };
};
var $ac962991e241437c$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8JRy9.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $ac962991e241437c$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};


var $871552d252f00c05$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0, $7WQrb.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries"
    ]);
    (0, $ac962991e241437c$export$8423f0cd3773115e)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $kwUjq.ApolloLink)(function(operation) {
        var chosenURI = (0, $ac962991e241437c$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $7WQrb.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $ac962991e241437c$export$a00ebfd5f1eebfb1)(operation, (0, $ac962991e241437c$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $ac962991e241437c$export$f5853cd1fc39aea6)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $871552d252f00c05$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $kwUjq.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $ac962991e241437c$export$5f8e80ac52052e28)(body, 'Payload');
        } catch (parseError) {
            return (0, $kwUjq.fromError)(parseError);
        }
        return new (0, $3gKaa.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $ac962991e241437c$export$d4051215bea0639f)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError') return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $871552d252f00c05$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $ac962991e241437c$export$5f8e80ac52052e28)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $ac962991e241437c$export$5f8e80ac52052e28)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $871552d252f00c05$export$f4bbf1aec241cc1 = function(_super) {
    (0, $7WQrb.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $871552d252f00c05$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $kwUjq.ApolloLink));



var $7WQrb = parcelRequire("7WQrb");

var $kwUjq = parcelRequire("kwUjq");
var $3gKaa = parcelRequire("3gKaa");
function $0e83b821d37cd44d$export$2288787135a8f66e(errorHandler) {
    return new (0, $kwUjq.ApolloLink)(function(operation, forward) {
        return new (0, $3gKaa.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $0e83b821d37cd44d$export$d2c8415987899609 = function(_super) {
    (0, $7WQrb.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $0e83b821d37cd44d$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $kwUjq.ApolloLink));



var $7WQrb = parcelRequire("7WQrb");

var $4i0Ci = parcelRequire("4i0Ci");
function $853f5de2adba6c71$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $853f5de2adba6c71$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $853f5de2adba6c71$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $853f5de2adba6c71$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $853f5de2adba6c71$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $853f5de2adba6c71$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $853f5de2adba6c71$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $853f5de2adba6c71$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $853f5de2adba6c71$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $4i0Ci.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $4i0Ci.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $853f5de2adba6c71$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $853f5de2adba6c71$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $853f5de2adba6c71$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $853f5de2adba6c71$export$94affb487e701bf2;
$853f5de2adba6c71$export$94affb487e701bf2 || ($853f5de2adba6c71$export$94affb487e701bf2 = {});



var $4i0Ci = parcelRequire("4i0Ci");
var $f8ISh = parcelRequire("f8ISh");
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $08ca5f0adf3741ba$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $08ca5f0adf3741ba$var$MISSING_VALUE = {};
var $08ca5f0adf3741ba$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $08ca5f0adf3741ba$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $08ca5f0adf3741ba$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $08ca5f0adf3741ba$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $08ca5f0adf3741ba$var$MISSING_VALUE) break;
                if (context_1 !== $08ca5f0adf3741ba$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $08ca5f0adf3741ba$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($08ca5f0adf3741ba$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $08ca5f0adf3741ba$var$currentContext.slots[this.id] = $08ca5f0adf3741ba$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $08ca5f0adf3741ba$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $08ca5f0adf3741ba$var$currentContext;
            $08ca5f0adf3741ba$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $08ca5f0adf3741ba$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $08ca5f0adf3741ba$var$currentContext;
            return function() {
                var saved = $08ca5f0adf3741ba$var$currentContext;
                try {
                    $08ca5f0adf3741ba$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $08ca5f0adf3741ba$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($08ca5f0adf3741ba$var$currentContext) {
                var saved = $08ca5f0adf3741ba$var$currentContext;
                try {
                    $08ca5f0adf3741ba$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $08ca5f0adf3741ba$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $08ca5f0adf3741ba$var$globalKey = "@wry/context:Slot";
var $08ca5f0adf3741ba$var$host = Array;
var $08ca5f0adf3741ba$export$8c6ed5c666ac1360 = $08ca5f0adf3741ba$var$host[$08ca5f0adf3741ba$var$globalKey] || function() {
    var Slot = $08ca5f0adf3741ba$var$makeSlotClass();
    try {
        Object.defineProperty($08ca5f0adf3741ba$var$host, $08ca5f0adf3741ba$var$globalKey, {
            value: $08ca5f0adf3741ba$var$host[$08ca5f0adf3741ba$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $08ca5f0adf3741ba$export$2385a24977818dd0 = $08ca5f0adf3741ba$export$8c6ed5c666ac1360.bind, $08ca5f0adf3741ba$export$9fa6f2e300a97f8 = $08ca5f0adf3741ba$export$8c6ed5c666ac1360.noContext;
function $08ca5f0adf3741ba$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($08ca5f0adf3741ba$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $08ca5f0adf3741ba$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $08ca5f0adf3741ba$export$2385a24977818dd0(gen.next);
        var boundThrow = $08ca5f0adf3741ba$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($08ca5f0adf3741ba$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $08ca5f0adf3741ba$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $08ca5f0adf3741ba$var$wrappedFibers = [];
function $08ca5f0adf3741ba$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($08ca5f0adf3741ba$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $08ca5f0adf3741ba$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $08ca5f0adf3741ba$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $81f6335fad49709b$var$defaultDispose() {}
var $81f6335fad49709b$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $81f6335fad49709b$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $81f6335fad49709b$var$parentEntrySlot = new (0, $08ca5f0adf3741ba$export$8c6ed5c666ac1360)();
var $81f6335fad49709b$var$reusableEmptyArray = [];
var $81f6335fad49709b$var$emptySetPool = [];
var $81f6335fad49709b$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $81f6335fad49709b$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $81f6335fad49709b$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $81f6335fad49709b$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $81f6335fad49709b$var$valueCopy(value) {
    return value.slice(0);
}
var $81f6335fad49709b$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $81f6335fad49709b$var$assert(!this.recomputing, "already recomputing");
        if (!$81f6335fad49709b$var$rememberParent(this) && $81f6335fad49709b$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $81f6335fad49709b$var$mightBeDirty(this) ? $81f6335fad49709b$var$reallyRecompute(this) : $81f6335fad49709b$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $81f6335fad49709b$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $81f6335fad49709b$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $81f6335fad49709b$var$forgetChildren(this).forEach($81f6335fad49709b$var$maybeReportOrphan);
        $81f6335fad49709b$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $81f6335fad49709b$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $81f6335fad49709b$var$rememberParent(child) {
    var parent = $81f6335fad49709b$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($81f6335fad49709b$var$mightBeDirty(child)) $81f6335fad49709b$var$reportDirtyChild(parent, child);
        else $81f6335fad49709b$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $81f6335fad49709b$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $81f6335fad49709b$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $81f6335fad49709b$var$parentEntrySlot.withValue(entry, $81f6335fad49709b$var$recomputeNewValue, [
        entry
    ]);
    if ($81f6335fad49709b$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $81f6335fad49709b$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($81f6335fad49709b$var$maybeReportOrphan);
    return $81f6335fad49709b$var$valueGet(entry.value);
}
function $81f6335fad49709b$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $81f6335fad49709b$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $81f6335fad49709b$var$setClean(entry) {
    entry.dirty = false;
    if ($81f6335fad49709b$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $81f6335fad49709b$var$reportClean(entry);
}
function $81f6335fad49709b$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $81f6335fad49709b$var$reportDirtyChild(parent, child);
    });
}
function $81f6335fad49709b$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $81f6335fad49709b$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $81f6335fad49709b$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $81f6335fad49709b$var$assert(parent.childValues.has(child));
    $81f6335fad49709b$var$assert($81f6335fad49709b$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $81f6335fad49709b$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $81f6335fad49709b$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $81f6335fad49709b$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $81f6335fad49709b$var$assert(parent.childValues.has(child));
    $81f6335fad49709b$var$assert(!$81f6335fad49709b$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $81f6335fad49709b$var$valueCopy(child.value));
    else if (!$81f6335fad49709b$var$valueIs(childValue, child.value)) parent.setDirty();
    $81f6335fad49709b$var$removeDirtyChild(parent, child);
    if ($81f6335fad49709b$var$mightBeDirty(parent)) return;
    $81f6335fad49709b$var$reportClean(parent);
}
function $81f6335fad49709b$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($81f6335fad49709b$var$emptySetPool.length < $81f6335fad49709b$var$POOL_TARGET_SIZE) $81f6335fad49709b$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $81f6335fad49709b$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $81f6335fad49709b$var$forgetChildren(parent) {
    var children = $81f6335fad49709b$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $81f6335fad49709b$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $81f6335fad49709b$var$assert(parent.dirtyChildren === null);
    return children;
}
function $81f6335fad49709b$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $81f6335fad49709b$var$removeDirtyChild(parent, child);
}
function $81f6335fad49709b$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $81f6335fad49709b$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $81f6335fad49709b$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $81f6335fad49709b$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $81f6335fad49709b$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $81f6335fad49709b$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $81f6335fad49709b$var$keyTrie = new $81f6335fad49709b$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $81f6335fad49709b$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $81f6335fad49709b$var$keyTrie.lookupArray(args);
}
var $81f6335fad49709b$var$caches = new Set();
function $81f6335fad49709b$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $81f6335fad49709b$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $81f6335fad49709b$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$81f6335fad49709b$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $81f6335fad49709b$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $81f6335fad49709b$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$81f6335fad49709b$var$parentEntrySlot.hasValue()) {
            $81f6335fad49709b$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $81f6335fad49709b$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}



var $8JRy9 = parcelRequire("8JRy9");
var $e092502b32d580ba$var$haveWarned = false;
function $e092502b32d580ba$var$shouldWarn() {
    var answer = !$e092502b32d580ba$var$haveWarned;
    if (!(0, $4i0Ci.isTest)()) $e092502b32d580ba$var$haveWarned = true;
    return answer;
}
var $e092502b32d580ba$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $e092502b32d580ba$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $e092502b32d580ba$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $e092502b32d580ba$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8JRy9.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8JRy9.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $e092502b32d580ba$var$hasOwn = Object.prototype.hasOwnProperty;
var $e092502b32d580ba$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $81f6335fad49709b$export$4997ffc0176396a6)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($e092502b32d580ba$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$e092502b32d580ba$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $e092502b32d580ba$var$defaultNormalizedCacheFactory(seed) {
    return new $e092502b32d580ba$var$DepTrackingCache(seed);
}
var $e092502b32d580ba$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $81f6335fad49709b$export$6bd8d8299be3ac82)((0, $4i0Ci.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $81f6335fad49709b$export$4997ffc0176396a6)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $e092502b32d580ba$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $81f6335fad49709b$export$4997ffc0176396a6)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $e092502b32d580ba$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $81f6335fad49709b$export$4997ffc0176396a6)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $e092502b32d580ba$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $4i0Ci.getQueryDefinition)(query);
        variables = (0, $4i0Ci.assign)({}, (0, $4i0Ci.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8JRy9.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $f8ISh.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $e092502b32d580ba$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $4i0Ci.getMainDefinition)(query);
        var fragments = (0, $4i0Ci.getFragmentDefinitions)(query);
        var fragmentMap = (0, $4i0Ci.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $4i0Ci.shouldInclude)(selection, variables)) return;
            if ((0, $4i0Ci.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $4i0Ci.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $4i0Ci.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8JRy9.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $4i0Ci.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $4i0Ci.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $4i0Ci.resultKeyNameFromField)(field),
            directives: (0, $4i0Ci.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $e092502b32d580ba$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $e092502b32d580ba$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $e092502b32d580ba$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $e092502b32d580ba$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $4i0Ci.isIdValue)(value)) throw new (0, $8JRy9.InvariantError)(10);
}
function $e092502b32d580ba$var$defaultFragmentMatcher() {
    return true;
}
function $e092502b32d580ba$export$7a4899fe13f33235(idValue) {
    (0, $8JRy9.invariant)((0, $4i0Ci.isIdValue)(idValue), 11);
}
function $e092502b32d580ba$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $4i0Ci.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $4i0Ci.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $4i0Ci.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $e092502b32d580ba$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $e092502b32d580ba$export$7e2b40d1002de152(seed) {
    return new $e092502b32d580ba$export$ee7258b8691956a3(seed);
}
var $e092502b32d580ba$export$de4e6870dc6ac801 = function(_super) {
    (0, $7WQrb.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $e092502b32d580ba$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $e092502b32d580ba$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $e092502b32d580ba$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $e092502b32d580ba$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $e092502b32d580ba$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $4i0Ci.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $4i0Ci.assign)({}, (0, $4i0Ci.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $4i0Ci.createFragmentMap)((0, $4i0Ci.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $e092502b32d580ba$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $4i0Ci.shouldInclude)(selection, variables)) return;
            if ((0, $4i0Ci.isField)(selection)) {
                var resultFieldKey = (0, $4i0Ci.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $4i0Ci.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8JRy9.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $4i0Ci.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $e092502b32d580ba$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $4i0Ci.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $4i0Ci.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$e092502b32d580ba$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8JRy9.invariant)(!semanticId || !$e092502b32d580ba$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$e092502b32d580ba$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $4i0Ci.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $4i0Ci.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8JRy9.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8JRy9.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $e092502b32d580ba$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $f8ISh.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$e092502b32d580ba$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $4i0Ci.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $e092502b32d580ba$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $e092502b32d580ba$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $4i0Ci.isIdValue)(value) && $e092502b32d580ba$var$isGeneratedId(value.id) && (0, $4i0Ci.isIdValue)(realValue) && !(0, $f8ISh.equal)(value, realValue) && $e092502b32d580ba$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, generated), real);
    if ((0, $f8ISh.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $e092502b32d580ba$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $e092502b32d580ba$var$defaultConfig = {
    fragmentMatcher: new $e092502b32d580ba$export$5d3fcf53267091de(),
    dataIdFromObject: $e092502b32d580ba$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $e092502b32d580ba$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $e092502b32d580ba$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $e092502b32d580ba$var$OptimisticCacheLayer = function(_super) {
    (0, $7WQrb.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $e092502b32d580ba$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($e092502b32d580ba$export$ee7258b8691956a3);
var $e092502b32d580ba$export$467265324939f47f = function(_super) {
    (0, $7WQrb.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $81f6335fad49709b$export$6bd8d8299be3ac82)((0, $4i0Ci.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, $e092502b32d580ba$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $e092502b32d580ba$var$DepTrackingCache() : new $e092502b32d580ba$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $e092502b32d580ba$export$eb8361c5d132fb8f();
        _this.storeReader = new $e092502b32d580ba$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $81f6335fad49709b$export$4997ffc0176396a6)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $e092502b32d580ba$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8JRy9.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $e092502b32d580ba$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $e092502b32d580ba$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $4i0Ci.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $853f5de2adba6c71$export$5fc74f25506aa9c));



const $8515f8e36503e661$var$result = {
    __schema: {
        types: [
            {
                kind: "UNION",
                name: "BaseAnswer",
                possibleTypes: [
                    {
                        name: "TextAnswer"
                    },
                    {
                        name: "NumericAnswer"
                    },
                    {
                        name: "MultiAnswer"
                    }
                ]
            },
            {
                kind: "INTERFACE",
                name: "BaseService",
                possibleTypes: [
                    {
                        name: "Service"
                    },
                    {
                        name: "ServiceForCustomer"
                    }
                ]
            },
            {
                kind: "INTERFACE",
                name: "BaseWorkflow",
                possibleTypes: [
                    {
                        name: "Workflow"
                    },
                    {
                        name: "WorkflowForCustomer"
                    }
                ]
            }
        ]
    }
};
var $8515f8e36503e661$export$2e2bcd8739ae039 = $8515f8e36503e661$var$result;



var $kwUjq = parcelRequire("kwUjq");
var $3gKaa = parcelRequire("3gKaa");
/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 


class $b4ad9151f76efc6b$export$2e2bcd8739ae039 extends (0, $kwUjq.ApolloLink) {
    constructor(timeout){
        super();
        this.timeout = timeout;
    }
    request(operation, forward) {
        const { operation: operationType } = operation.query.definitions.find((definition)=>definition.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION);
        if (operationType === "subscription") // timeout should not apply to subscriptions
        return forward(operation);
        // timeout value can be specified through the `context` object in useQuery/useMutation
        // value is in milliseconds and defaults to 30,000ms
        const requestTimeout = operation.getContext().timeout || this.timeout;
        if (operationType === "mutation") return new (0, $3gKaa.default)((subscriber)=>{
            let timeoutId;
            const forwardSubscription = forward(operation).subscribe({
                next: (data)=>{
                    subscriber.next(data);
                },
                complete: ()=>{
                    window.clearTimeout(timeoutId);
                    subscriber.complete();
                },
                error: (err)=>{
                    window.clearTimeout(timeoutId);
                    subscriber.error(err);
                }
            });
            timeoutId = window.setTimeout(()=>{
                forwardSubscription.unsubscribe();
                subscriber.error(new Error("Timeout"));
            }, requestTimeout);
            return ()=>{
                window.clearTimeout(timeoutId);
                forwardSubscription.unsubscribe();
            };
        });
        return forward(operation);
    }
}


const $edf0c7cc3f8c5588$var$QUERY_TIMEOUT = 15000;
const $edf0c7cc3f8c5588$var$fragmentMatcher = new (0, $e092502b32d580ba$export$3b71c6b829c99d21)({
    introspectionQueryResultData: $8515f8e36503e661$export$2e2bcd8739ae039
});
// this returns undefined for the cache leaf id which makes the Apollo use the full leaf path as the id, the cache id is longer, but it fixes our problems with duplicated ids on questions
function $edf0c7cc3f8c5588$var$dataIdFromObject() {
    return undefined;
}
const $edf0c7cc3f8c5588$var$cache = new (0, $e092502b32d580ba$export$467265324939f47f)({
    fragmentMatcher: $edf0c7cc3f8c5588$var$fragmentMatcher,
    dataIdFromObject: $edf0c7cc3f8c5588$var$dataIdFromObject
});
const $edf0c7cc3f8c5588$var$timeoutLink = new (0, $b4ad9151f76efc6b$export$2e2bcd8739ae039)($edf0c7cc3f8c5588$var$QUERY_TIMEOUT);
const $edf0c7cc3f8c5588$var$httpLink = new (0, $871552d252f00c05$export$f4bbf1aec241cc1)({
    uri: `${"https://dev.leadernaplatform.com"}/graphql`,
    credentials: "include"
});
const $edf0c7cc3f8c5588$var$linkChain = $edf0c7cc3f8c5588$var$timeoutLink.concat($edf0c7cc3f8c5588$var$httpLink);
const $edf0c7cc3f8c5588$var$authLink = (token)=>(0, $1b4fdaed0df28296$export$2f04de43fe27971a)((_, { headers: headers })=>{
        return {
            headers: {
                ...headers,
                authorization: token ? `Bearer ${token}` : ""
            }
        };
    });
const $edf0c7cc3f8c5588$var$errorLink = (0, $0e83b821d37cd44d$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors, networkError: networkError })=>{
    if (graphQLErrors) graphQLErrors.map(({ message: message, locations: locations, path: path })=>{
        if (!message.includes("jwt")) (0, $60f27fc97e29822a$export$b410431fab84fa58).error(message, {
            autoClose: 20000
        });
        return console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });
    if (networkError) {
        (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You've been logged out due to inactivity. Please refresh the page and / or try again in a few seconds.", {
            autoClose: 20000
        });
        console.log(`[Network error]: ${networkError}`);
    }
});
const $edf0c7cc3f8c5588$var$linkChainWithErrorHandling = $edf0c7cc3f8c5588$var$errorLink.concat($edf0c7cc3f8c5588$var$linkChain);
function $edf0c7cc3f8c5588$export$1e6cfeaf8b88bd01(token) {
    return new (0, $e00e7370e665423b$export$13f5a5f0f1dbab88)({
        link: $edf0c7cc3f8c5588$var$authLink(token).concat($edf0c7cc3f8c5588$var$linkChainWithErrorHandling),
        cache: $edf0c7cc3f8c5588$var$cache
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

function $d6c7161d63500fca$var$ServerError() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$ErrorBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$Logo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a8ee0766077991c$export$8eea0721e4ba542), {
        color: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$ContentBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$Title, null, "An error occurred"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6c7161d63500fca$var$Message, null, "We're sorry, but there was a problem connecting to the server. Please refresh the page again or try again later."))));
}
var $d6c7161d63500fca$export$2e2bcd8739ae039 = $d6c7161d63500fca$var$ServerError;
const $d6c7161d63500fca$var$Container = (0, $lmFrL.default).div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`;
const $d6c7161d63500fca$var$ErrorBox = (0, $lmFrL.default).div`
  width: 400px;
  border: 1px solid #d1d5d8;
  box-shadow: 0px 1px 0px #d1d5d8;
  border-radius: 8px;
`;
const $d6c7161d63500fca$var$Logo = (0, $lmFrL.default).div`
  background-color: #232f3c;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  border-radius: 8px 8px 0 0;
`;
const $d6c7161d63500fca$var$ContentBox = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 32px 72px;

  & > * {
    margin: 0;
  }
`;
const $d6c7161d63500fca$var$Title = (0, $lmFrL.default).p`
  letter-spacing: -0.02em;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 6px;
`;
const $d6c7161d63500fca$var$Message = (0, $lmFrL.default).p`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #77808e;
`;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $55c405f863cae9d4$var$extendStatics = function(d, b) {
    $55c405f863cae9d4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $55c405f863cae9d4$var$extendStatics(d, b);
};
function $55c405f863cae9d4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $55c405f863cae9d4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $55c405f863cae9d4$export$18ce0697a983be9b = function() {
    $55c405f863cae9d4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55c405f863cae9d4$export$18ce0697a983be9b.apply(this, arguments);
};
function $55c405f863cae9d4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $55c405f863cae9d4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $55c405f863cae9d4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $55c405f863cae9d4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $55c405f863cae9d4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $55c405f863cae9d4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $55c405f863cae9d4$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $55c405f863cae9d4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $55c405f863cae9d4$export$45d3717a4c69092e(o, m, p);
}
function $55c405f863cae9d4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $55c405f863cae9d4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $55c405f863cae9d4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($55c405f863cae9d4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $55c405f863cae9d4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $55c405f863cae9d4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $55c405f863cae9d4$export$10c90e4f7922046c(v) {
    return this instanceof $55c405f863cae9d4$export$10c90e4f7922046c ? (this.v = v, this) : new $55c405f863cae9d4$export$10c90e4f7922046c(v);
}
function $55c405f863cae9d4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $55c405f863cae9d4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $55c405f863cae9d4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $55c405f863cae9d4$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $55c405f863cae9d4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $55c405f863cae9d4$export$19a8beecd37a4c45 === "function" ? $55c405f863cae9d4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $55c405f863cae9d4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $55c405f863cae9d4$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $55c405f863cae9d4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $55c405f863cae9d4$export$45d3717a4c69092e(result, mod, k);
    }
    $55c405f863cae9d4$var$__setModuleDefault(result, mod);
    return result;
}
function $55c405f863cae9d4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $55c405f863cae9d4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $55c405f863cae9d4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


function $f419306d4be7fb23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f419306d4be7fb23$var$_typeof(obj);
}
function $f419306d4be7fb23$export$2e2bcd8739ae039(value) {
    return $f419306d4be7fb23$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $38898675a98013dc$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $a45c53fbf464b798$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $a45c53fbf464b798$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $a45c53fbf464b798$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $a45c53fbf464b798$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $a45c53fbf464b798$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $a45c53fbf464b798$var$leftPad(len, str) {
    return $a45c53fbf464b798$var$whitespace(len - str.length) + str;
}


function $52f13d37c0305dc6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52f13d37c0305dc6$var$_typeof(obj);
}
function $52f13d37c0305dc6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52f13d37c0305dc6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52f13d37c0305dc6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52f13d37c0305dc6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52f13d37c0305dc6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52f13d37c0305dc6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52f13d37c0305dc6$var$_setPrototypeOf(subClass, superClass);
}
function $52f13d37c0305dc6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52f13d37c0305dc6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52f13d37c0305dc6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52f13d37c0305dc6$var$_possibleConstructorReturn(this, result);
    };
}
function $52f13d37c0305dc6$var$_possibleConstructorReturn(self, call) {
    if (call && ($52f13d37c0305dc6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $52f13d37c0305dc6$var$_assertThisInitialized(self);
}
function $52f13d37c0305dc6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52f13d37c0305dc6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $52f13d37c0305dc6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$52f13d37c0305dc6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $52f13d37c0305dc6$var$_construct(Class, arguments, $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $52f13d37c0305dc6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $52f13d37c0305dc6$var$_wrapNativeSuper(Class);
}
function $52f13d37c0305dc6$var$_construct(Parent, args, Class) {
    if ($52f13d37c0305dc6$var$_isNativeReflectConstruct()) $52f13d37c0305dc6$var$_construct = Reflect.construct;
    else $52f13d37c0305dc6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $52f13d37c0305dc6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $52f13d37c0305dc6$var$_construct.apply(null, arguments);
}
function $52f13d37c0305dc6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52f13d37c0305dc6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $52f13d37c0305dc6$var$_setPrototypeOf(o, p) {
    $52f13d37c0305dc6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52f13d37c0305dc6$var$_setPrototypeOf(o, p);
}
function $52f13d37c0305dc6$var$_getPrototypeOf(o) {
    $52f13d37c0305dc6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52f13d37c0305dc6$var$_getPrototypeOf(o);
}
var $52f13d37c0305dc6$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $52f13d37c0305dc6$var$_inherits(GraphQLError, _Error);
    var _super = $52f13d37c0305dc6$var$_createSuper(GraphQLError);
    /**
   * A message describing the Error for debugging purposes.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   *
   * Note: should be treated as readonly, despite invariant usage.
   */ /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _locations2, _source2, _positions2, _extensions2;
        var _this;
        $52f13d37c0305dc6$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message); // Compute list of blame nodes.
        var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
            nodes
        ] : undefined; // Compute locations in the source for the given nodes/positions.
        var _source = source;
        if (!_source && _nodes) {
            var _nodes$0$loc;
            _source = (_nodes$0$loc = _nodes[0].loc) === null || _nodes$0$loc === void 0 ? void 0 : _nodes$0$loc.source;
        }
        var _positions = positions;
        if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
            if (node.loc) list.push(node.loc.start);
            return list;
        }, []);
        if (_positions && _positions.length === 0) _positions = undefined;
        var _locations;
        if (positions && source) _locations = positions.map(function(pos) {
            return (0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(source, pos);
        });
        else if (_nodes) _locations = _nodes.reduce(function(list, node) {
            if (node.loc) list.push((0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(node.loc.source, node.loc.start));
            return list;
        }, []);
        var _extensions = extensions;
        if (_extensions == null && originalError != null) {
            var originalExtensions = originalError.extensions;
            if ((0, $f419306d4be7fb23$export$2e2bcd8739ae039)(originalExtensions)) _extensions = originalExtensions;
        }
        Object.defineProperties($52f13d37c0305dc6$var$_assertThisInitialized(_this), {
            name: {
                value: 'GraphQLError'
            },
            message: {
                value: message,
                // By being enumerable, JSON.stringify will include `message` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: true,
                writable: true
            },
            locations: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_locations2 = _locations) !== null && _locations2 !== void 0 ? _locations2 : undefined,
                // By being enumerable, JSON.stringify will include `locations` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _locations != null
            },
            path: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: path !== null && path !== void 0 ? path : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: path != null
            },
            nodes: {
                value: _nodes !== null && _nodes !== void 0 ? _nodes : undefined
            },
            source: {
                value: (_source2 = _source) !== null && _source2 !== void 0 ? _source2 : undefined
            },
            positions: {
                value: (_positions2 = _positions) !== null && _positions2 !== void 0 ? _positions2 : undefined
            },
            originalError: {
                value: originalError
            },
            extensions: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_extensions2 = _extensions) !== null && _extensions2 !== void 0 ? _extensions2 : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _extensions != null
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $52f13d37c0305dc6$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($52f13d37c0305dc6$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $52f13d37c0305dc6$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $52f13d37c0305dc6$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $38898675a98013dc$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $52f13d37c0305dc6$var$_wrapNativeSuper(Error));
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += '\n\n' + (0, $a45c53fbf464b798$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += '\n\n' + (0, $a45c53fbf464b798$export$867940333fd9f869)(error.source, location);
    }
    return output;
}


function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $52f13d37c0305dc6$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}



function $0989dd6156f69013$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $d7a3e222a9fb30c4$export$2e2bcd8739ae039 = $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol;


function $79a8edb1a7f74fed$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $0989dd6156f69013$export$2e2bcd8739ae039)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $d7a3e222a9fb30c4$export$2e2bcd8739ae039) classObject.prototype[0, $d7a3e222a9fb30c4$export$2e2bcd8739ae039] = fn;
}


var $11b06753ce50693f$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $79a8edb1a7f74fed$export$2e2bcd8739ae039)($11b06753ce50693f$export$18a2be9195644f38);
var $11b06753ce50693f$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $79a8edb1a7f74fed$export$2e2bcd8739ae039)($11b06753ce50693f$export$50792b0e93539fde);
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 




function $9541a54af6a37409$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9541a54af6a37409$var$_typeof(obj);
}
var $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
var $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$2e2bcd8739ae039(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch($9541a54af6a37409$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $9541a54af6a37409$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $9541a54af6a37409$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[' + $9541a54af6a37409$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $9541a54af6a37409$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $9541a54af6a37409$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $d7a3e222a9fb30c4$export$2e2bcd8739ae039))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $9541a54af6a37409$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


function $8beb5260c793fc92$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}



function $c44107310810d751$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c44107310810d751$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c44107310810d751$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c44107310810d751$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$c44107310810d751$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $1ff584847d3a412c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1ff584847d3a412c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1ff584847d3a412c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1ff584847d3a412c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1ff584847d3a412c$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $8beb5260c793fc92$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $9541a54af6a37409$export$2e2bcd8739ae039)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $8beb5260c793fc92$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $8beb5260c793fc92$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $1ff584847d3a412c$var$_createClass(Source, [
        {
            key: (0, $38898675a98013dc$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $c44107310810d751$export$2e2bcd8739ae039)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 





/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a51b3e37e1f6e888$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $a51b3e37e1f6e888$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $a51b3e37e1f6e888$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $a51b3e37e1f6e888$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $a51b3e37e1f6e888$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $a51b3e37e1f6e888$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $971bc50063303b32$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $971bc50063303b32$var$readToken(this, token);
        }while (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R;
}
function $971bc50063303b32$var$printCharCode(code) {
    return isNaN(code) ? (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $971bc50063303b32$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $971bc50063303b32$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $971bc50063303b32$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $971bc50063303b32$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $971bc50063303b32$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, pos, $971bc50063303b32$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $971bc50063303b32$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($971bc50063303b32$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($971bc50063303b32$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $971bc50063303b32$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $971bc50063303b32$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    } else {
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $971bc50063303b32$var$isNameStart(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)(isFloat ? (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT : (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $971bc50063303b32$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $971bc50063303b32$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $971bc50063303b32$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $971bc50063303b32$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $a51b3e37e1f6e888$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $971bc50063303b32$var$uniCharCode(a, b, c, d) {
    return $971bc50063303b32$var$char2hex(a) << 12 | $971bc50063303b32$var$char2hex(b) << 8 | $971bc50063303b32$var$char2hex(c) << 4 | $971bc50063303b32$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $971bc50063303b32$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $971bc50063303b32$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $971bc50063303b32$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return type;
}
var $0013c7ab45cf197d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $1ff584847d3a412c$export$75135ee9ed6e435b)(source) ? source : new (0, $1ff584847d3a412c$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $971bc50063303b32$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING:
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST,
            values: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING) || this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP) || this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $289bf729a82494c6$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $11b06753ce50693f$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($0013c7ab45cf197d$var$getTokenKindDesc(kind), ", found ").concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    var value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $971bc50063303b32$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $4f5dcc0184f23a66$var$docCache = new Map();
var $4f5dcc0184f23a66$var$fragmentSourceMap = new Map();
var $4f5dcc0184f23a66$var$printFragmentWarnings = true;
var $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
function $4f5dcc0184f23a66$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $4f5dcc0184f23a66$var$cacheKeyFromLoc(loc) {
    return $4f5dcc0184f23a66$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $4f5dcc0184f23a66$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $4f5dcc0184f23a66$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $4f5dcc0184f23a66$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($4f5dcc0184f23a66$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $4f5dcc0184f23a66$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $55c405f863cae9d4$export$18ce0697a983be9b)((0, $55c405f863cae9d4$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $4f5dcc0184f23a66$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $4f5dcc0184f23a66$var$parseDocument(source) {
    var cacheKey = $4f5dcc0184f23a66$var$normalize(source);
    if (!$4f5dcc0184f23a66$var$docCache.has(cacheKey)) {
        var parsed = (0, $0013c7ab45cf197d$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $4f5dcc0184f23a66$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $4f5dcc0184f23a66$var$docCache.set(cacheKey, $4f5dcc0184f23a66$var$stripLoc($4f5dcc0184f23a66$var$processFragments(parsed)));
    }
    return $4f5dcc0184f23a66$var$docCache.get(cacheKey);
}
function $4f5dcc0184f23a66$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $4f5dcc0184f23a66$var$parseDocument(result);
}
function $4f5dcc0184f23a66$export$657554ef4dc7ac2d() {
    $4f5dcc0184f23a66$var$docCache.clear();
    $4f5dcc0184f23a66$var$fragmentSourceMap.clear();
}
function $4f5dcc0184f23a66$export$e4294e638636c6ab() {
    $4f5dcc0184f23a66$var$printFragmentWarnings = false;
}
function $4f5dcc0184f23a66$export$78cf889af350c840() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = true;
}
function $4f5dcc0184f23a66$export$5290df9bbbd3cfa() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
}
var $4f5dcc0184f23a66$var$extras = {
    gql: $4f5dcc0184f23a66$export$72e4926bf8358653,
    resetCaches: $4f5dcc0184f23a66$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $4f5dcc0184f23a66$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $4f5dcc0184f23a66$var$extras.gql, gql_1.resetCaches = $4f5dcc0184f23a66$var$extras.resetCaches, gql_1.disableFragmentWarnings = $4f5dcc0184f23a66$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.disableExperimentalFragmentVariables;
})($4f5dcc0184f23a66$export$72e4926bf8358653 || ($4f5dcc0184f23a66$export$72e4926bf8358653 = {}));
$4f5dcc0184f23a66$export$72e4926bf8358653["default"] = $4f5dcc0184f23a66$export$72e4926bf8358653;
var $4f5dcc0184f23a66$export$2e2bcd8739ae039 = $4f5dcc0184f23a66$export$72e4926bf8358653;



var $acw62 = parcelRequire("acw62");


var $7WQrb = parcelRequire("7WQrb");


var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");


var $f8ISh = parcelRequire("f8ISh");

var $8JRy9 = parcelRequire("8JRy9");
var $568346eb0b168c1b$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $f8ISh.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8JRy9.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $dd3747b11ee1d6d4$export$8f49e4af10703ce3)(document);
        var requiredOperationName = (0, $dd3747b11ee1d6d4$export$5db520940cf00715)(type);
        var usedOperationName = (0, $dd3747b11ee1d6d4$export$5db520940cf00715)(operation.type);
        (0, $8JRy9.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $568346eb0b168c1b$var$QueryData = function(_super) {
    (0, $7WQrb.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e00e7370e665423b$export$bd096ddbd246c79c).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $7WQrb.__assign)({
            loading: true,
            networkStatus: (0, $e00e7370e665423b$export$bd096ddbd246c79c).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $dd3747b11ee1d6d4$export$d1d99cf900472499).Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        var _a, _b;
        if (this.ssrInitiated()) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $7WQrb.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 || _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $f8ISh.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $f8ISh.equal)(previousResult.data, data)) return;
                _this.onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $f8ISh.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e00e7370e665423b$export$26a337512320b8c6)({
                graphQLErrors: errors
            });
            result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e00e7370e665423b$export$bd096ddbd246c79c).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $f8ISh.equal)(this.previousOptions.query, query) && (0, $f8ISh.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($568346eb0b168c1b$var$OperationData);
function $568346eb0b168c1b$var$useDeepMemo(memoFn, key) {
    var ref = (0, $acw62.useRef)();
    if (!ref.current || !(0, $f8ISh.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $568346eb0b168c1b$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $acw62.useContext)((0, $dd3747b11ee1d6d4$export$a47505d961ee3a1)());
    var _a = (0, $acw62.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $acw62.useRef)();
    var queryData = queryDataRef.current || new $568346eb0b168c1b$var$QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $568346eb0b168c1b$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $acw62.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}
function $568346eb0b168c1b$export$dd0a697e1782aedd(query, options) {
    return $568346eb0b168c1b$var$useBaseQuery(query, options, false);
}
function $568346eb0b168c1b$export$fd83eea6ecd2d8fa(query, options) {
    return $568346eb0b168c1b$var$useBaseQuery(query, options, true);
}
var $568346eb0b168c1b$var$MutationData = function(_super) {
    (0, $7WQrb.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $dd3747b11ee1d6d4$export$d1d99cf900472499).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $dd3747b11ee1d6d4$export$d1d99cf900472499).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $7WQrb.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $7WQrb.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e00e7370e665423b$export$26a337512320b8c6)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $f8ISh.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($568346eb0b168c1b$var$OperationData);
function $568346eb0b168c1b$export$609860bf8b0084c(mutation, options) {
    var context = (0, $acw62.useContext)((0, $dd3747b11ee1d6d4$export$a47505d961ee3a1)());
    var _a = (0, $acw62.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $acw62.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $568346eb0b168c1b$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $acw62.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $568346eb0b168c1b$var$SubscriptionData = function(_super) {
    (0, $7WQrb.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $f8ISh.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($568346eb0b168c1b$var$OperationData);
function $568346eb0b168c1b$export$368b4214baeb914c(subscription, options) {
    var context = (0, $acw62.useContext)((0, $dd3747b11ee1d6d4$export$a47505d961ee3a1)());
    var updatedOptions = options ? (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $acw62.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $acw62.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $568346eb0b168c1b$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $acw62.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $acw62.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $568346eb0b168c1b$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $dd3747b11ee1d6d4$export$a47505d961ee3a1)()).client;
    (0, $8JRy9.invariant)(client, 1);
    return client;
}
function $568346eb0b168c1b$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $568346eb0b168c1b$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $568346eb0b168c1b$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();



var $c9Z8w = parcelRequire("c9Z8w");
function $8f108aa291352b5e$export$62297b13309008b2(props) {
    var children = props.children, query = props.query, options = (0, $7WQrb.__rest)(props, [
        "children",
        "query"
    ]);
    var result = (0, $568346eb0b168c1b$export$dd0a697e1782aedd)(query, options);
    return children && result ? children(result) : null;
}
(function(Query) {
    Query.propTypes = {
        client: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        notifyOnNetworkStatusChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        pollInterval: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        query: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        partialRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        returnPartialData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    };
})($8f108aa291352b5e$export$62297b13309008b2 || ($8f108aa291352b5e$export$62297b13309008b2 = {}));
function $8f108aa291352b5e$export$17b8b19c814bcf56(props) {
    var _a = (0, $568346eb0b168c1b$export$609860bf8b0084c)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function(Mutation) {
    Mutation.propTypes = {
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        optimisticResponse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        refetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        awaitRefetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        update: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    };
})($8f108aa291352b5e$export$17b8b19c814bcf56 || ($8f108aa291352b5e$export$17b8b19c814bcf56 = {}));
function $8f108aa291352b5e$export$f55210826850c514(props) {
    var result = (0, $568346eb0b168c1b$export$368b4214baeb914c)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function(Subscription) {
    Subscription.propTypes = {
        subscription: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onSubscriptionData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onSubscriptionComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        shouldResubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])
    };
})($8f108aa291352b5e$export$f55210826850c514 || ($8f108aa291352b5e$export$f55210826850c514 = {}));



var $7608a8bbcbbad14c$export$44e2388b3736c907 = /*#__PURE__*/ function(AnswerType) {
    AnswerType["TextField"] = "TextField";
    AnswerType["Number"] = "Number";
    AnswerType["OneOfMany"] = "OneOfMany";
    AnswerType["TextArea"] = "TextArea";
    AnswerType["ManyOfMany"] = "ManyOfMany";
    AnswerType["File"] = "File";
    AnswerType["Date"] = "Date";
    AnswerType["DateTime"] = "DateTime";
    AnswerType["Currency"] = "Currency";
    AnswerType["Links"] = "Links";
    return AnswerType;
}({});
var $7608a8bbcbbad14c$export$b733e092f9f44b2c = /*#__PURE__*/ function(Currency) {
    Currency["Pln"] = "PLN";
    Currency["Eur"] = "EUR";
    Currency["Usd"] = "USD";
    Currency["Cny"] = "CNY";
    return Currency;
}({});
var $7608a8bbcbbad14c$export$1d8b9ae22d404866 = /*#__PURE__*/ function(Unit) {
    Unit["Mg"] = "mg";
    Unit["G"] = "g";
    Unit["Kg"] = "kg";
    return Unit;
}({});
var $7608a8bbcbbad14c$export$3f6d0f4ada384a91 = /*#__PURE__*/ function(EntityStatus) {
    EntityStatus["Finished"] = "Finished";
    EntityStatus["Ongoing"] = "Ongoing";
    EntityStatus["Approved"] = "Approved";
    EntityStatus["Pending"] = "Pending";
    EntityStatus["Cancelled"] = "Cancelled";
    return EntityStatus;
}({});
var $7608a8bbcbbad14c$export$300334f671c43555 = /*#__PURE__*/ function(Priority) {
    Priority["Low"] = "Low";
    Priority["Medium"] = "Medium";
    Priority["High"] = "High";
    return Priority;
}({});
var $7608a8bbcbbad14c$export$c24e27d0b3bde617 = /*#__PURE__*/ function(EventPriority) {
    EventPriority["Critical"] = "Critical";
    EventPriority["Urgent"] = "Urgent";
    EventPriority["Informational"] = "Informational";
    EventPriority["Warning"] = "Warning";
    return EventPriority;
}({});
var $7608a8bbcbbad14c$export$b780d51770a4d990 = /*#__PURE__*/ function(DeleteStatus) {
    DeleteStatus["Ok"] = "OK";
    DeleteStatus["Failed"] = "FAILED";
    return DeleteStatus;
}({});
var $7608a8bbcbbad14c$export$ff1b23e7fbed6ad5 = /*#__PURE__*/ function(NotificationStatus) {
    NotificationStatus["Sent"] = "Sent";
    NotificationStatus["Waiting"] = "Waiting";
    NotificationStatus["Failed"] = "Failed";
    return NotificationStatus;
}({});
var $7608a8bbcbbad14c$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["AssignedToSubtask"] = "AssignedToSubtask";
    NotificationType["UnassignedFromSubtask"] = "UnassignedFromSubtask";
    NotificationType["AssignedToProject"] = "AssignedToProject";
    NotificationType["UnassignedFromProject"] = "UnassignedFromProject";
    NotificationType["SubtaskIsAboutToBegin"] = "SubtaskIsAboutToBegin";
    NotificationType["SubtaskWillEndIn2weeks"] = "SubtaskWillEndIn2weeks";
    NotificationType["SubtaskWillEndIn1week"] = "SubtaskWillEndIn1week";
    return NotificationType;
}({});
var $7608a8bbcbbad14c$export$a7843e9fd6d3ef6b = /*#__PURE__*/ function(QuestionLevel) {
    QuestionLevel["Offer"] = "Offer";
    QuestionLevel["PreProject"] = "PreProject";
    QuestionLevel["Report"] = "Report";
    QuestionLevel["Project"] = "Project";
    QuestionLevel["Sample"] = "Sample";
    QuestionLevel["Admin"] = "Admin";
    QuestionLevel["ProjectManager"] = "ProjectManager";
    QuestionLevel["Scientist"] = "Scientist";
    QuestionLevel["CustomQuestion"] = "CustomQuestion";
    return QuestionLevel;
}({});
const $7608a8bbcbbad14c$export$cc8a8c8251f89cab = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    fragment MultiAnswer on MultiAnswer {
  multiBody: body
  answerType
}
    `;
const $7608a8bbcbbad14c$export$f58e84ab3f5c4b2 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    fragment TextAnswer on TextAnswer {
  textBody: body
  answerType
}
    `;
const $7608a8bbcbbad14c$export$a50f76e1c8b9b720 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    fragment NumericAnswer on NumericAnswer {
  numericBody: body
  answerType
}
    `;
const $7608a8bbcbbad14c$export$222618f4133c10f1 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query MyQuery {
  healthcheck
}
    `;
const $7608a8bbcbbad14c$export$b9612956e5ad2f70 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$222618f4133c10f1,
        ...props
    });
function $7608a8bbcbbad14c$export$838bf6e9a3b62aa6(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$222618f4133c10f1, baseOptions);
}
function $7608a8bbcbbad14c$export$adfadff53b4aae4f(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$222618f4133c10f1, baseOptions);
}
const $7608a8bbcbbad14c$export$fd7ece79ff57bc75 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateEventFromSample($projectSampleEventInput: ProjectSampleEventInput!, $eventUpdatables: EventUpdatables!) {
  UpdateEventFromSample(
    projectSampleEventInput: $projectSampleEventInput
    eventUpdatables: $eventUpdatables
  ) {
    id
    priority
    name
    description
    startDate
    endDate
    baseLineSize
    baseLine
    assignee
    collaborators {
      userIds
      groupIds
    }
    milestone
  }
}
    `;
const $7608a8bbcbbad14c$export$2c8311cd12f4d5e0 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$fd7ece79ff57bc75,
        ...props
    });
function $7608a8bbcbbad14c$export$8af6b8f568ed5160(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$fd7ece79ff57bc75, baseOptions);
}
const $7608a8bbcbbad14c$export$c05ec66c469e210b = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation DeleteUploadedFile($fileName: String!) {
  DeleteUploadedFile(fileName: $fileName) {
    deleteStatus
    fileName
  }
}
    `;
const $7608a8bbcbbad14c$export$a7f8600515be8667 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$c05ec66c469e210b,
        ...props
    });
function $7608a8bbcbbad14c$export$7ca0061c8c838e7b(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$c05ec66c469e210b, baseOptions);
}
const $7608a8bbcbbad14c$export$f77a59b9bbcb234f = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddGroup($name: String!) {
  AddGroup(name: $name) {
    id
    members
    name
  }
}
    `;
const $7608a8bbcbbad14c$export$37476d445448c249 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$f77a59b9bbcb234f,
        ...props
    });
function $7608a8bbcbbad14c$export$f23694eacea18d28(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$f77a59b9bbcb234f, baseOptions);
}
const $7608a8bbcbbad14c$export$b5a04d0098562e43 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddUsersToGroup($groupId: ID!, $usersIds: [ID!]!) {
  AddUsersToGroup(groupId: $groupId, usersIds: $usersIds) {
    id
    members
    name
  }
}
    `;
const $7608a8bbcbbad14c$export$ed8f3d12ca591bf5 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$b5a04d0098562e43,
        ...props
    });
function $7608a8bbcbbad14c$export$28537ac6612cfa4d(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$b5a04d0098562e43, baseOptions);
}
const $7608a8bbcbbad14c$export$98d8c252aafb4005 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation EditGroupName($groupId: ID!, $name: String!) {
  EditGroupName(groupId: $groupId, name: $name) {
    id
    members
    name
  }
}
    `;
const $7608a8bbcbbad14c$export$c191dcc5a093767e = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$98d8c252aafb4005,
        ...props
    });
function $7608a8bbcbbad14c$export$5503f1fae3915a76(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$98d8c252aafb4005, baseOptions);
}
const $7608a8bbcbbad14c$export$42a9965c63b62a73 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveGroup($groupId: ID!) {
  RemoveGroup(groupId: $groupId) {
    id
    members
    name
  }
}
    `;
const $7608a8bbcbbad14c$export$73b3beb6fdca1cda = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$42a9965c63b62a73,
        ...props
    });
function $7608a8bbcbbad14c$export$77e9bf9ca24c589f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$42a9965c63b62a73, baseOptions);
}
const $7608a8bbcbbad14c$export$9dfbafd4005dbf17 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveUserFromGroup($groupId: ID!, $userId: ID!) {
  RemoveUserFromGroup(groupId: $groupId, userId: $userId) {
    id
    members
    name
  }
}
    `;
const $7608a8bbcbbad14c$export$50784b6eddde1cb3 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$9dfbafd4005dbf17,
        ...props
    });
function $7608a8bbcbbad14c$export$b38500b13d54dd7a(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$9dfbafd4005dbf17, baseOptions);
}
const $7608a8bbcbbad14c$export$df3e777809a6859d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation NewProject {
  AddProject {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        services {
          id
          name
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          description
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      status
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$d78a0925c412ed8d = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$df3e777809a6859d,
        ...props
    });
function $7608a8bbcbbad14c$export$df57bd44e287f57c(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$df3e777809a6859d, baseOptions);
}
const $7608a8bbcbbad14c$export$d6ffb31882b77c51 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddSampleToProject($projectSampleInput: ProjectInput!) {
  AddSampleToProject(projectSampleInput: $projectSampleInput) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        order
        durationLocked
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      description
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        durationLocked
        price {
          currency
          price {
            value
          }
        }
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$fbebc65414e2ab7c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$d6ffb31882b77c51,
        ...props
    });
function $7608a8bbcbbad14c$export$c360d2acd2d92a13(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$d6ffb31882b77c51, baseOptions);
}
const $7608a8bbcbbad14c$export$c0c892e5b7cd31dc = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectWithMultiAnswer($projectQuestionInput: ProjectQuestionInput!, $answer: [String!]!) {
  AnswerProjectMultiQuestion(
    projectQuestionInput: $projectQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$ba98990ae4fd518b = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$c0c892e5b7cd31dc,
        ...props
    });
function $7608a8bbcbbad14c$export$401940162089bc0d(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$c0c892e5b7cd31dc, baseOptions);
}
const $7608a8bbcbbad14c$export$25f22ed3cb7641e8 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectWithNumericAnswer($projectQuestionInput: ProjectQuestionInput!, $answer: Float!) {
  AnswerProjectNumericQuestion(
    projectQuestionInput: $projectQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$ea4070173b3201e4 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$25f22ed3cb7641e8,
        ...props
    });
function $7608a8bbcbbad14c$export$83a028bb5e49d35f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$25f22ed3cb7641e8, baseOptions);
}
const $7608a8bbcbbad14c$export$ddeffc42c6ad39ef = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectWithTextAnswer($projectQuestionInput: ProjectQuestionInput!, $answer: String!) {
  AnswerProjectQuestion(
    projectQuestionInput: $projectQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$c2add1874689efc4 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$ddeffc42c6ad39ef,
        ...props
    });
function $7608a8bbcbbad14c$export$dc60d89c2de20f5c(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$ddeffc42c6ad39ef, baseOptions);
}
const $7608a8bbcbbad14c$export$8c49a8d774c63c2 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectSampleWithMultiAnswer($projectSampleQuestionInput: ProjectSampleQuestionInput!, $answer: [String!]!) {
  AnswerProjectSampleMultiQuestion(
    projectSampleQuestionInput: $projectSampleQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$36b1f5b875c4be8 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$8c49a8d774c63c2,
        ...props
    });
function $7608a8bbcbbad14c$export$3a30da8008cfc73a(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$8c49a8d774c63c2, baseOptions);
}
const $7608a8bbcbbad14c$export$a3dc001218f3558f = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectSampleWithNumericAnswer($projectSampleQuestionInput: ProjectSampleQuestionInput!, $answer: Float!) {
  AnswerProjectSampleNumericQuestion(
    projectSampleQuestionInput: $projectSampleQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$b28eb6bc3a61465b = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$a3dc001218f3558f,
        ...props
    });
function $7608a8bbcbbad14c$export$46ebc9426755df51(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$a3dc001218f3558f, baseOptions);
}
const $7608a8bbcbbad14c$export$346e35ccd70f21f7 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ProjectSampleWithTextAnswer($projectSampleQuestionInput: ProjectSampleQuestionInput!, $answer: String!) {
  AnswerProjectSampleQuestion(
    projectSampleQuestionInput: $projectSampleQuestionInput
    answer: $answer
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$9ec60d223831fde4 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$346e35ccd70f21f7,
        ...props
    });
function $7608a8bbcbbad14c$export$23628b905dc411dd(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$346e35ccd70f21f7, baseOptions);
}
const $7608a8bbcbbad14c$export$988c1658aa022efb = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AssignUsersToProject($projectId: ID!, $usersAuth0Ids: [String!]!) {
  AssignUsersToProject(projectId: $projectId, usersAuth0Ids: $usersAuth0Ids)
}
    `;
const $7608a8bbcbbad14c$export$2e885c4c6acd19ec = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$988c1658aa022efb,
        ...props
    });
function $7608a8bbcbbad14c$export$6a41775256872c83(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$988c1658aa022efb, baseOptions);
}
const $7608a8bbcbbad14c$export$9dffb599e51e9966 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation DuplicateProject($projectId: ID!) {
  DuplicateProject(projectId: $projectId) {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        services {
          id
          name
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          description
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      status
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
    visibleTimelineElements {
      samples {
        id
        workflows {
          id
          services
        }
        events
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$fe479ff93c3f62ed = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$9dffb599e51e9966,
        ...props
    });
function $7608a8bbcbbad14c$export$2d089989dadb2fd(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$9dffb599e51e9966, baseOptions);
}
const $7608a8bbcbbad14c$export$1d63d5cf0e10d949 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation MakeTimelineElementVisible($timelineElementVisibleInput: TimelineElementVisibleInput!) {
  MakeTimelineElementVisible(
    timelineElementVisibleInput: $timelineElementVisibleInput
  ) {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        services {
          id
          name
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          description
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      status
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
    visibleTimelineElements {
      samples {
        id
        workflows {
          id
          services
        }
        events
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$ffa2ec54ce7c78a7 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$1d63d5cf0e10d949,
        ...props
    });
function $7608a8bbcbbad14c$export$9392965d6afe019f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$1d63d5cf0e10d949, baseOptions);
}
const $7608a8bbcbbad14c$export$ce660f263c66c98d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveProject($projectId: ID!) {
  RemoveProject(projectId: $projectId)
}
    `;
const $7608a8bbcbbad14c$export$8b8618228e0040e3 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$ce660f263c66c98d,
        ...props
    });
function $7608a8bbcbbad14c$export$f734a850ac345d11(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$ce660f263c66c98d, baseOptions);
}
const $7608a8bbcbbad14c$export$986ea3691f57ffb5 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveUserFromProject($projectId: ID!, $userAuth0Id: String!) {
  RemoveUserFromProject(projectId: $projectId, userAuth0Id: $userAuth0Id)
}
    `;
const $7608a8bbcbbad14c$export$f9579c430eab8f8d = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$986ea3691f57ffb5,
        ...props
    });
function $7608a8bbcbbad14c$export$837df83f09477a72(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$986ea3691f57ffb5, baseOptions);
}
const $7608a8bbcbbad14c$export$d132394f9925faa2 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation SetProjectSampleWorkflowServiceTimeline($projectSampleWorkflowServiceInput: ProjectSampleWorkflowServiceInput!, $timeline: TimelineInput!) {
  SetProjectSampleWorkflowServiceTimeline(
    projectSampleWorkflowServiceInput: $projectSampleWorkflowServiceInput
    timeline: $timeline
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$d27bcbac1be15161 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$d132394f9925faa2,
        ...props
    });
function $7608a8bbcbbad14c$export$41acb43eb097e87f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$d132394f9925faa2, baseOptions);
}
const $7608a8bbcbbad14c$export$7d14388b01e978e8 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddEventToSample($projectSampleInput: ProjectSampleInput!, $eventId: ID!, $startDate: String!, $baseline: Int) {
  AddEventToSample(
    projectSampleInput: $projectSampleInput
    eventId: $eventId
    startDate: $startDate
    baseline: $baseline
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        price {
          currency
          price {
            value
          }
        }
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$790fd4451d3b0e3d = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$7d14388b01e978e8,
        ...props
    });
function $7608a8bbcbbad14c$export$1d952a1636443323(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$7d14388b01e978e8, baseOptions);
}
const $7608a8bbcbbad14c$export$cdfbfa94a764a928 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddQuestionGroupToSample($projectSampleInput: ProjectSampleInput!) {
  AddQuestionGroupToSample(projectSampleInput: $projectSampleInput) {
    id
    name
    questionSets {
      id
      apiLink
      renderer
      questions {
        id
        question
        description
        choices
        order
        questionLevel
        isObligatory
        answer {
          ... on MultiAnswer {
            multiBody: body
            answerType
          }
          ... on TextAnswer {
            textBody: body
            answerType
          }
          ... on NumericAnswer {
            numericBody: body
            answerType
          }
        }
        visibility
        visibilityPreconditions {
          isSatisfied
          questionId
          expectedAnswer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
        placeholder
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$4415d3f5c38a49d6 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$cdfbfa94a764a928,
        ...props
    });
function $7608a8bbcbbad14c$export$1896c00aac109ec8(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$cdfbfa94a764a928, baseOptions);
}
const $7608a8bbcbbad14c$export$a9a41665f9bdb9bc = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddQuestionToSample($projectSampleInput: ProjectSampleInput!, $questionGroupId: ID!, $questionSetId: ID, $questionId: ID!, $order: Int) {
  AddQuestionToSample(
    projectSampleInput: $projectSampleInput
    questionGroupId: $questionGroupId
    questionSetId: $questionSetId
    questionId: $questionId
    order: $order
  ) {
    id
    name
    enabledWorkflows {
      name
      id
      assignee
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    selectedQuestionGroups {
      id
      questionSets {
        id
        apiLink
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$b6258aad95bd445b = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$a9a41665f9bdb9bc,
        ...props
    });
function $7608a8bbcbbad14c$export$e44f75598bd188e3(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$a9a41665f9bdb9bc, baseOptions);
}
const $7608a8bbcbbad14c$export$181167075248841f = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddQuestionsToSample($projectSampleInput: ProjectSampleInput!, $questionGroupId: ID!, $questionSetId: ID, $questionIds: [ID!]!) {
  AddQuestionsToSample(
    projectSampleInput: $projectSampleInput
    questionGroupId: $questionGroupId
    questionSetId: $questionSetId
    questionIds: $questionIds
  ) {
    id
    name
    selectedQuestionGroups {
      id
      questionSets {
        id
        apiLink
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$b842776309d70379 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$181167075248841f,
        ...props
    });
function $7608a8bbcbbad14c$export$c8ee4814b6bc495a(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$181167075248841f, baseOptions);
}
const $7608a8bbcbbad14c$export$87eaa36e6bb57cdf = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddWorkflowToSample($projectSampleInput: ProjectSampleInput!, $workflowId: ID!, $startDate: String!, $serviceBaseline: Int) {
  AddWorkflowToSample(
    projectSampleInput: $projectSampleInput
    workflowId: $workflowId
    startDate: $startDate
    serviceBaseline: $serviceBaseline
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      description
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        price {
          currency
          price {
            value
          }
        }
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$19ee8c3111da09b3 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$87eaa36e6bb57cdf,
        ...props
    });
function $7608a8bbcbbad14c$export$96dfdf14e11e0dc6(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$87eaa36e6bb57cdf, baseOptions);
}
const $7608a8bbcbbad14c$export$d3e40a551bf1cab8 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation CopyTaskToChosenSample($projectSampleWorkflowInput: ProjectSampleWorkflowInput!, $destinationSampleId: ID!) {
  CopyTaskToChosenSample(
    projectSampleWorkflowInput: $projectSampleWorkflowInput
    destinationSampleId: $destinationSampleId
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$d310e698e0d900ba = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$d3e40a551bf1cab8,
        ...props
    });
function $7608a8bbcbbad14c$export$54d39c9b6d539ca7(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$d3e40a551bf1cab8, baseOptions);
}
const $7608a8bbcbbad14c$export$d610b5383de7f914 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation DuplicateSampleInProject($projectId: ID!, $sampleId: ID!) {
  DuplicateSampleInProject(projectId: $projectId, sampleId: $sampleId) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$6fcdbc187136a9a9 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$d610b5383de7f914,
        ...props
    });
function $7608a8bbcbbad14c$export$ba6ad065c90d2caf(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$d610b5383de7f914, baseOptions);
}
const $7608a8bbcbbad14c$export$6f81c8edc07607d3 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation EnableWorkflowInProjectSample($projectSampleWorkflowEnableInput: ProjectSampleWorkflowInput!) {
  EnableWorkflowInProjectSample(
    projectSampleWorkflowEnableInput: $projectSampleWorkflowEnableInput
  ) {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          assignee
          priority
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      selectedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          assignee
          priority
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        assignee
        collaborators {
          userIds
          groupIds
        }
        services {
          id
          name
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          description
          serviceType
          durationLocked
          priority
          collaborators {
            userIds
            groupIds
          }
          order
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      status
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$73edc2f966a6bd6 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$6f81c8edc07607d3,
        ...props
    });
function $7608a8bbcbbad14c$export$94b9fcb438d38b2d(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$6f81c8edc07607d3, baseOptions);
}
const $7608a8bbcbbad14c$export$bdd842316d97d02e = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveEventFromSample($projectSampleInput: ProjectSampleInput!, $eventId: ID!) {
  RemoveEventFromSample(
    projectSampleInput: $projectSampleInput
    eventId: $eventId
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$9910096bfa71e27 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$bdd842316d97d02e,
        ...props
    });
function $7608a8bbcbbad14c$export$860462a0577d7243(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$bdd842316d97d02e, baseOptions);
}
const $7608a8bbcbbad14c$export$1d726fff0561a96d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveQuestionGroupFromSample($projectSampleInput: ProjectSampleInput!, $questionGroupId: ID!) {
  RemoveQuestionGroupFromSample(
    projectSampleInput: $projectSampleInput
    questionGroupId: $questionGroupId
  ) {
    id
    name
    enabledWorkflows {
      name
      id
      assignee
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    selectedQuestionGroups {
      id
      questionSets {
        id
        apiLink
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$1df7415c0baf11d6 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$1d726fff0561a96d,
        ...props
    });
function $7608a8bbcbbad14c$export$c99471ae92b86a10(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$1d726fff0561a96d, baseOptions);
}
const $7608a8bbcbbad14c$export$a15bba746f5e542c = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveQuestionsFromSample($projectSampleInput: ProjectSampleInput!, $questionGroupId: ID!, $questionSetId: ID!, $questionIds: [ID!]) {
  RemoveQuestionsFromSample(
    projectSampleInput: $projectSampleInput
    questionGroupId: $questionGroupId
    questionSetId: $questionSetId
    questionIds: $questionIds
  ) {
    id
    name
    enabledWorkflows {
      name
      id
      assignee
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    selectedQuestionGroups {
      id
      questionSets {
        id
        apiLink
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$a6b912220ca8251c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$a15bba746f5e542c,
        ...props
    });
function $7608a8bbcbbad14c$export$87c29bb3ef00bd1f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$a15bba746f5e542c, baseOptions);
}
const $7608a8bbcbbad14c$export$7b14d7c1b7021593 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveSampleFromProject($projectSampleInput: ProjectSampleInput!) {
  RemoveSampleFromProject(projectSampleInput: $projectSampleInput) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$d06abf2dbc2634a1 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$7b14d7c1b7021593,
        ...props
    });
function $7608a8bbcbbad14c$export$fb5b0faacb9a4f3f(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$7b14d7c1b7021593, baseOptions);
}
const $7608a8bbcbbad14c$export$696d40de60ebfabf = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveWorkflowFromSample($projectSampleInput: ProjectSampleInput!, $workflowInput: WorkflowInput!) {
  RemoveWorkflowFromSample(
    projectSampleInput: $projectSampleInput
    workflowInput: $workflowInput
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$53976018b286c8ab = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$696d40de60ebfabf,
        ...props
    });
function $7608a8bbcbbad14c$export$abfe606629e42547(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$696d40de60ebfabf, baseOptions);
}
const $7608a8bbcbbad14c$export$6c8d2849ea7561ed = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation SelectWorkflowInProjectSample($projectSampleWorkflowSelectInput: ProjectSampleWorkflowInput!) {
  SelectWorkflowInProjectSample(
    projectSampleWorkflowSelectInput: $projectSampleWorkflowSelectInput
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$9a001d79b7be13f4 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$6c8d2849ea7561ed,
        ...props
    });
function $7608a8bbcbbad14c$export$e1f6df16af32d0fc(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$6c8d2849ea7561ed, baseOptions);
}
const $7608a8bbcbbad14c$export$3fd729ea9f18558e = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UnselectWorkflowInProjectSample($projectSampleWorkflowSelectInput: ProjectSampleWorkflowInput!) {
  UnselectWorkflowInProjectSample(
    projectSampleWorkflowSelectInput: $projectSampleWorkflowSelectInput
  ) {
    id
  }
}
    `;
const $7608a8bbcbbad14c$export$837ca4128dacd1bb = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$3fd729ea9f18558e,
        ...props
    });
function $7608a8bbcbbad14c$export$7e20857809eeff1e(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$3fd729ea9f18558e, baseOptions);
}
const $7608a8bbcbbad14c$export$7291bec6a49cf782 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateQuestionGroupFromSample($projectSampleInput: ProjectSampleInput!, $questionGroupUpdatables: UpdateQuestionGroupInput!) {
  UpdateQuestionGroupFromSample(
    projectSampleInput: $projectSampleInput
    questionGroupUpdatables: $questionGroupUpdatables
  ) {
    id
    name
    questionSets {
      id
      apiLink
      renderer
      questions {
        id
        question
        description
        choices
        order
        questionLevel
        isObligatory
        answer {
          ... on MultiAnswer {
            multiBody: body
            answerType
          }
          ... on TextAnswer {
            textBody: body
            answerType
          }
          ... on NumericAnswer {
            numericBody: body
            answerType
          }
        }
        visibility
        visibilityPreconditions {
          isSatisfied
          questionId
          expectedAnswer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
        placeholder
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$a47854d9bad9cafc = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$7291bec6a49cf782,
        ...props
    });
function $7608a8bbcbbad14c$export$92e597b1419ac8a5(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$7291bec6a49cf782, baseOptions);
}
const $7608a8bbcbbad14c$export$5d68d5a50520f6d8 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateQuestionInQuestionGroupFromSample($projectSampleInput: ProjectSampleInput!, $questionInput: QuestionInput!, $questionUpdatables: UpdateQuestionInput!) {
  UpdateQuestionInQuestionGroupFromSample(
    projectSampleInput: $projectSampleInput
    questionInput: $questionInput
    questionUpdatables: $questionUpdatables
  ) {
    id
    question
    description
    choices
    order
    questionLevel
    isObligatory
    answer {
      ... on MultiAnswer {
        multiBody: body
        answerType
      }
      ... on TextAnswer {
        textBody: body
        answerType
      }
      ... on NumericAnswer {
        numericBody: body
        answerType
      }
    }
    visibility
    visibilityPreconditions {
      isSatisfied
      questionId
      expectedAnswer {
        ... on MultiAnswer {
          multiBody: body
          answerType
        }
        ... on TextAnswer {
          textBody: body
          answerType
        }
        ... on NumericAnswer {
          numericBody: body
          answerType
        }
      }
    }
    placeholder
  }
}
    `;
const $7608a8bbcbbad14c$export$b9a37d4978f4d22b = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$5d68d5a50520f6d8,
        ...props
    });
function $7608a8bbcbbad14c$export$2135cdf0f1a972ba(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$5d68d5a50520f6d8, baseOptions);
}
const $7608a8bbcbbad14c$export$43b0580296d12256 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateSampleTimelineLine($projectId: ID!, $sampleId: ID!, $line: Int!, $name: String!) {
  UpdateSampleTimelineLine(
    projectId: $projectId
    sampleId: $sampleId
    line: $line
    name: $name
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      description
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        price {
          currency
          price {
            value
          }
        }
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$d898d5b1bdd06938 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$43b0580296d12256,
        ...props
    });
function $7608a8bbcbbad14c$export$7d4276896448a227(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$43b0580296d12256, baseOptions);
}
const $7608a8bbcbbad14c$export$9b86e78bd2a4be05 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateUserSamplesAssignmentInProject($updateUserSamplesAssignmentInProjectInput: UpdateUserSamplesAssignmentInProjectInput!) {
  UpdateUserSamplesAssignmentInProject(
    updateUserSamplesAssignmentInProjectInput: $updateUserSamplesAssignmentInProjectInput
  ) {
    id
    assignedUsers {
      id
      role
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$b99624277186b2de = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$9b86e78bd2a4be05,
        ...props
    });
function $7608a8bbcbbad14c$export$23193118be2a0f4e(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$9b86e78bd2a4be05, baseOptions);
}
const $7608a8bbcbbad14c$export$58f19aaa255807a6 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation AddServiceToWorkflow($projectSampleInput: ProjectSampleInput!, $workflowInput: WorkflowInput!, $serviceId: ID!, $startDate: String!, $baseline: Int) {
  AddServiceToWorkflow(
    projectSampleInput: $projectSampleInput
    workflowInput: $workflowInput
    serviceId: $serviceId
    startDate: $startDate
    baseline: $baseline
  ) {
    name
    id
    assignee
    price {
      currency
      price {
        value
      }
    }
    collaborators {
      userIds
      groupIds
    }
    description
    offerPrice {
      currency
      maxPrice {
        value
      }
      minPrice {
        value
      }
    }
    services {
      id
      name
      startDate
      endDate
      baseLine
      baseLineSize
      status
      description
      serviceType
      durationLocked
      order
      vendor {
        id
        name
      }
      price {
        currency
        price {
          value
        }
      }
      scientists {
        id
        name
        preferences {
          preferredCurrency
        }
        organization
        schedule {
          id
        }
      }
      report {
        selectedQuestionGroups {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
      }
      assignee
      priority
      collaborators {
        userIds
        groupIds
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$45654c476a984348 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$58f19aaa255807a6,
        ...props
    });
function $7608a8bbcbbad14c$export$2a667d95ba1e4243(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$58f19aaa255807a6, baseOptions);
}
const $7608a8bbcbbad14c$export$5ee32164627a1812 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveServiceFromWorkflow($projectSampleInput: ProjectSampleInput!, $workflowInput: WorkflowInput!, $serviceId: ID!) {
  RemoveServiceFromWorkflow(
    projectSampleInput: $projectSampleInput
    workflowInput: $workflowInput
    serviceId: $serviceId
  ) {
    name
    id
    offerPrice {
      currency
      maxPrice {
        value
      }
      minPrice {
        value
      }
    }
    services {
      id
      name
      startDate
      endDate
      baseLine
      baseLineSize
      status
      description
      serviceType
      durationLocked
      order
      assignee
      priority
      collaborators {
        userIds
        groupIds
      }
      vendor {
        id
        name
      }
      price {
        currency
        price {
          value
        }
      }
      scientists {
        id
        name
        preferences {
          preferredCurrency
        }
        organization
        schedule {
          id
        }
      }
      report {
        selectedQuestionGroups {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
      }
    }
    assignee
    description
    price {
      currency
      price {
        value
      }
    }
    collaborators {
      userIds
      groupIds
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$11a3f39dd6a05d4c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$5ee32164627a1812,
        ...props
    });
function $7608a8bbcbbad14c$export$8e73b281d471a42c(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$5ee32164627a1812, baseOptions);
}
const $7608a8bbcbbad14c$export$721b93b960456a16 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateServiceFromWorkflow($projectSampleInput: ProjectSampleInput!, $workflowInput: WorkflowInput!, $serviceUpdatables: ServiceInput!) {
  UpdateServiceFromWorkflow(
    projectSampleInput: $projectSampleInput
    workflowInput: $workflowInput
    serviceUpdatables: $serviceUpdatables
  ) {
    id
    name
    price {
      price {
        value
      }
      currency
    }
    description
    startDate
    endDate
    baseLineSize
    baseLine
    status
    serviceType
    durationLocked
    order
    hiddenOnTheList
    offerPrice {
      minPrice {
        value
      }
      maxPrice {
        value
      }
      currency
    }
    assignee
    priority
    collaborators {
      userIds
      groupIds
    }
    scientists {
      id
      name
      preferences {
        preferredCurrency
      }
      organization
      schedule {
        id
      }
    }
    vendor {
      id
      name
    }
    report {
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$447a97f099e77155 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$721b93b960456a16,
        ...props
    });
function $7608a8bbcbbad14c$export$981396349d3957c6(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$721b93b960456a16, baseOptions);
}
const $7608a8bbcbbad14c$export$14a4aacbf5cbc9bc = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation ChangePassword($newPassword: String!) {
  ChangePassword(newPassword: $newPassword)
}
    `;
const $7608a8bbcbbad14c$export$124d4751878bbb25 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$14a4aacbf5cbc9bc,
        ...props
    });
function $7608a8bbcbbad14c$export$4742f5cd36d944ba(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$14a4aacbf5cbc9bc, baseOptions);
}
const $7608a8bbcbbad14c$export$e84b92950b0db776 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation EditUserName($auth0UserId: ID!, $name: String!) {
  EditUserName(auth0UserId: $auth0UserId, name: $name) {
    id
    name
    avatar
    email
    organization
    role {
      id
      name
      description
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$eba79067c245d0c1 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$e84b92950b0db776,
        ...props
    });
function $7608a8bbcbbad14c$export$e345caa1b41e7c31(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$e84b92950b0db776, baseOptions);
}
const $7608a8bbcbbad14c$export$b4588b2d2c1a0026 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation EditUserRole($auth0UserId: ID!, $auth0RoleId: ID!) {
  EditUserRole(auth0UserId: $auth0UserId, auth0RoleId: $auth0RoleId) {
    id
    name
    description
  }
}
    `;
const $7608a8bbcbbad14c$export$e759c40f688779fc = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$b4588b2d2c1a0026,
        ...props
    });
function $7608a8bbcbbad14c$export$a873320c9f4661dd(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$b4588b2d2c1a0026, baseOptions);
}
const $7608a8bbcbbad14c$export$f38f767f74547a55 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation DuplicateWorkflowInSample($projectSampleWorkflowInput: ProjectSampleWorkflowInput!) {
  DuplicateWorkflowInSample(
    projectSampleWorkflowInput: $projectSampleWorkflowInput
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$9bec23045a534abb = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$f38f767f74547a55,
        ...props
    });
function $7608a8bbcbbad14c$export$1d93abf243f57e46(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$f38f767f74547a55, baseOptions);
}
const $7608a8bbcbbad14c$export$57ce217937a1f0f0 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation MoveAllWorkflowsInSampleMutation($projectSampleInput: ProjectSampleInput!, $newStartDate: String!) {
  MoveAllWorkflowsInSample(
    projectSampleInput: $projectSampleInput
    newStartDate: $newStartDate
  ) {
    name
    id
    assignee
    collaborators {
      userIds
      groupIds
    }
    offerPrice {
      currency
      maxPrice {
        value
      }
      minPrice {
        value
      }
    }
    price {
      currency
      price {
        value
      }
    }
    services {
      id
      name
      assignee
      priority
      collaborators {
        userIds
        groupIds
      }
      scientists {
        id
        name
        preferences {
          preferredCurrency
        }
        organization
        schedule {
          id
        }
      }
      startDate
      endDate
      baseLine
      baseLineSize
      status
      description
      serviceType
      durationLocked
      order
      vendor {
        id
        name
      }
      report {
        selectedQuestionGroups {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$653a9b2c2076cb2c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$57ce217937a1f0f0,
        ...props
    });
function $7608a8bbcbbad14c$export$be31b74f37fbe58(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$57ce217937a1f0f0, baseOptions);
}
const $7608a8bbcbbad14c$export$4d0abd917bbb5f1f = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation MoveServiceToChosenWorkflow($projectSampleWorkflowServiceInput: ProjectSampleWorkflowServiceInput!, $destinationWorkflowId: ID!) {
  MoveServiceToChosenWorkflow(
    projectSampleWorkflowServiceInput: $projectSampleWorkflowServiceInput
    destinationWorkflowId: $destinationWorkflowId
  ) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      collaborators {
        userIds
        groupIds
      }
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        collaborators {
          userIds
          groupIds
        }
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$47b6521cf08d79ab = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$4d0abd917bbb5f1f,
        ...props
    });
function $7608a8bbcbbad14c$export$2986f8b991ad98cd(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$4d0abd917bbb5f1f, baseOptions);
}
const $7608a8bbcbbad14c$export$baf3217526a12429 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation RemoveWorkflowTemplate($templateId: ID!) {
  RemoveWorkflowTemplate(templateId: $templateId)
}
    `;
const $7608a8bbcbbad14c$export$7b45934485a6b66 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$baf3217526a12429,
        ...props
    });
function $7608a8bbcbbad14c$export$2d2c9bcecc1a7ed8(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$baf3217526a12429, baseOptions);
}
const $7608a8bbcbbad14c$export$cc651dd4cdaa785 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation SaveWorkflowTemplate($projectSampleWorkflowInput: ProjectSampleWorkflowInput!, $organization: String!, $templateName: String!) {
  SaveWorkflowTemplate(
    projectSampleWorkflowInput: $projectSampleWorkflowInput
    organization: $organization
    templateName: $templateName
  ) {
    id
    name
    offerPrice {
      currency
      maxPrice {
        value
      }
      minPrice {
        value
      }
    }
    services {
      id
      name
      startDate
      endDate
      baseLine
      baseLineSize
      status
      description
      serviceType
      durationLocked
      order
      vendors {
        id
        name
      }
      report {
        selectedQuestionGroups {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
      }
      assignee
      priority
      vendors {
        id
        name
      }
      offerPrice {
        minPrice {
          value
        }
        maxPrice {
          value
        }
        currency
      }
    }
    questionGroupsToAddToSample {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    organization
    description
  }
}
    `;
const $7608a8bbcbbad14c$export$8674f4b0182d1d7c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$cc651dd4cdaa785,
        ...props
    });
function $7608a8bbcbbad14c$export$3dc5b673b15f2ff7(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$cc651dd4cdaa785, baseOptions);
}
const $7608a8bbcbbad14c$export$51b521b6b873e973 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    mutation UpdateWorkflowFromSample($projectSampleInput: ProjectSampleInput!, $workflowUpdatables: UpdateWorkflowInput!) {
  UpdateWorkflowFromSample(
    projectSampleInput: $projectSampleInput
    workflowUpdatables: $workflowUpdatables
  ) {
    name
    id
    assignee
    description
    offerPrice {
      currency
      maxPrice {
        value
      }
      minPrice {
        value
      }
    }
    price {
      currency
      price {
        value
      }
    }
    services {
      id
      name
      assignee
      priority
      price {
        currency
        price {
          value
        }
      }
      scientists {
        id
        name
        preferences {
          preferredCurrency
        }
        organization
        schedule {
          id
        }
      }
      startDate
      endDate
      baseLine
      baseLineSize
      status
      description
      serviceType
      durationLocked
      collaborators {
        userIds
        groupIds
      }
      order
      vendor {
        id
        name
      }
      report {
        selectedQuestionGroups {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    collaborators {
      groupIds
      userIds
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$1d88c03c7363126e = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$17b8b19c814bcf56, {
        mutation: $7608a8bbcbbad14c$export$51b521b6b873e973,
        ...props
    });
function $7608a8bbcbbad14c$export$9cb58138bf28f995(baseOptions) {
    return $568346eb0b168c1b$export$609860bf8b0084c($7608a8bbcbbad14c$export$51b521b6b873e973, baseOptions);
}
const $7608a8bbcbbad14c$export$3b42dffdb0477a6f = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query DownloadLink($fileName: String!, $originFileName: String!) {
  DownloadLink(fileName: $fileName, originFileName: $originFileName)
}
    `;
const $7608a8bbcbbad14c$export$29e643f016adc3ae = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$3b42dffdb0477a6f,
        ...props
    });
function $7608a8bbcbbad14c$export$41ad4f58dc0a8345(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$3b42dffdb0477a6f, baseOptions);
}
function $7608a8bbcbbad14c$export$98b6850a2dbc6198(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$3b42dffdb0477a6f, baseOptions);
}
const $7608a8bbcbbad14c$export$947d2938638e142d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query UploadLinks($fileInput: [UploadLinksInput!]!) {
  UploadLinks(fileInput: $fileInput) {
    fileId
    link
  }
}
    `;
const $7608a8bbcbbad14c$export$a145a97de00f8ade = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$947d2938638e142d,
        ...props
    });
function $7608a8bbcbbad14c$export$e1f4dfc2ee68266a(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$947d2938638e142d, baseOptions);
}
function $7608a8bbcbbad14c$export$c4336539623eb02d(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$947d2938638e142d, baseOptions);
}
const $7608a8bbcbbad14c$export$45949515a9e7498d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query Group($groupId: ID!) {
  Group(id: $groupId) {
    id
    name
    members {
      id
      name
      email
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$450247cd99a94b80 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$45949515a9e7498d,
        ...props
    });
function $7608a8bbcbbad14c$export$2316695f7398010a(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$45949515a9e7498d, baseOptions);
}
function $7608a8bbcbbad14c$export$2921b5399ae144fb(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$45949515a9e7498d, baseOptions);
}
const $7608a8bbcbbad14c$export$14173820abb9e7bc = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query Groups {
  Groups {
    id
    name
    members
    organization
  }
}
    `;
const $7608a8bbcbbad14c$export$856c39472e190337 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$14173820abb9e7bc,
        ...props
    });
function $7608a8bbcbbad14c$export$989566a73930cfbe(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$14173820abb9e7bc, baseOptions);
}
function $7608a8bbcbbad14c$export$86d134de398048bd(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$14173820abb9e7bc, baseOptions);
}
const $7608a8bbcbbad14c$export$dc001c6cf609680d = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query ServicesAssignedToGroupForTimeline($groupId: ID!) {
  ServicesAssignedToGroupForTimeline(groupId: $groupId) {
    id
    name
    events {
      id
      priority
      endDate
      startDate
      baseLine
      baseLineSize
      name
      description
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$3ce23c63e997ce73 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$dc001c6cf609680d,
        ...props
    });
function $7608a8bbcbbad14c$export$880ca56a001ec25(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$dc001c6cf609680d, baseOptions);
}
function $7608a8bbcbbad14c$export$721d1374227dbb93(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$dc001c6cf609680d, baseOptions);
}
const $7608a8bbcbbad14c$export$da25fac6b1252285 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query ProjectUsers($projectId: ID!) {
  ProjectUsers(id: $projectId) {
    id
    name
    avatar
    email
    group
    role
  }
}
    `;
const $7608a8bbcbbad14c$export$a040078e55a32f85 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$da25fac6b1252285,
        ...props
    });
function $7608a8bbcbbad14c$export$9822af98a3fbbf81(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$da25fac6b1252285, baseOptions);
}
function $7608a8bbcbbad14c$export$71f88a7ac7b38890(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$da25fac6b1252285, baseOptions);
}
const $7608a8bbcbbad14c$export$56959a2c3ec29cce = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query ProjectWithAllSamples($id: ID!) {
  ProjectWithAllSamples(id: $id) {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      selectedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        assignee
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        description
        services {
          id
          name
          assignee
          priority
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          price {
            price {
              value
            }
            currency
          }
          description
          serviceType
          durationLocked
          order
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
          collaborators {
            userIds
            groupIds
          }
        }
        collaborators {
          userIds
          groupIds
        }
      }
      status
      assignedUsers {
        id
        role
      }
      timelineLines {
        line
        name
      }
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$96549f9216a4410 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$56959a2c3ec29cce,
        ...props
    });
function $7608a8bbcbbad14c$export$cd78c08812e76862(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$56959a2c3ec29cce, baseOptions);
}
function $7608a8bbcbbad14c$export$fcadb19d5d3973c8(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$56959a2c3ec29cce, baseOptions);
}
const $7608a8bbcbbad14c$export$4424ae79d720e357 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query Services {
  Services {
    id
    name
    description
    startDate
    endDate
    baseLineSize
    baseLine
    status
    serviceType
    durationLocked
    order
    hiddenOnTheList
    offerPrice {
      minPrice {
        value
      }
      maxPrice {
        value
      }
      currency
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$7d999fd7250e20aa = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$4424ae79d720e357,
        ...props
    });
function $7608a8bbcbbad14c$export$a870673e4b33fcfb(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$4424ae79d720e357, baseOptions);
}
function $7608a8bbcbbad14c$export$fe6e6d108950bc0e(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$4424ae79d720e357, baseOptions);
}
const $7608a8bbcbbad14c$export$5dac92edaa5e1fb0 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query UserProjects {
  Projects {
    id
    name
    lastActivity
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          assignee
          priority
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      selectedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          assignee
          priority
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        assignee
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        services {
          id
          name
          assignee
          priority
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          description
          serviceType
          durationLocked
          collaborators {
            userIds
            groupIds
          }
          order
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
          collaborators {
            groupIds
            userIds
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      status
      assignedUsers {
        id
        role
      }
      timelineLines {
        line
        name
      }
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$485cac1916717e24 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$5dac92edaa5e1fb0,
        ...props
    });
function $7608a8bbcbbad14c$export$5fb71c15210980be(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$5dac92edaa5e1fb0, baseOptions);
}
function $7608a8bbcbbad14c$export$e26071933979964f(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$5dac92edaa5e1fb0, baseOptions);
}
const $7608a8bbcbbad14c$export$4da6a04ca1ab1039 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query UserPlainProjects {
  Projects {
    id
    name
    selectedQuestionGroups {
      questionSets {
        questions {
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    samples {
      id
      name
      assignedUsers {
        id
        role
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$3cbbb1fa3ab9f0aa = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$4da6a04ca1ab1039,
        ...props
    });
function $7608a8bbcbbad14c$export$51199fd5d18fce87(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$4da6a04ca1ab1039, baseOptions);
}
function $7608a8bbcbbad14c$export$448b0dbe5bdb5e1b(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$4da6a04ca1ab1039, baseOptions);
}
const $7608a8bbcbbad14c$export$cd946050302ba91a = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query UserPlainProjectsWithSamples {
  Projects {
    id
    name
    lastActivity
    currentService {
      serviceName
      sampleName
      weekRemaining
    }
    samples {
      id
      name
      status
      enabledWorkflows {
        services {
          id
          status
        }
      }
      selectedQuestionGroups {
        questionSets {
          questions {
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      assignedUsers {
        id
        role
      }
    }
    selectedQuestionGroups {
      questionSets {
        questions {
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    users {
      id
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$ac1052db9146964c = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$cd946050302ba91a,
        ...props
    });
function $7608a8bbcbbad14c$export$a040723abd7b5c86(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$cd946050302ba91a, baseOptions);
}
function $7608a8bbcbbad14c$export$e84bca59318ba91b(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$cd946050302ba91a, baseOptions);
}
const $7608a8bbcbbad14c$export$7b040ae9d4c82b96 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query UserProject($id: ID!) {
  Project(id: $id) {
    id
    name
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
          questionLevel
          isObligatory
          visibility
          placeholder
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
    }
    samples {
      id
      name
      events {
        id
        priority
        name
        description
        startDate
        endDate
        baseLineSize
        baseLine
        assignee
        collaborators {
          userIds
          groupIds
        }
        milestone
      }
      selectedQuestionGroups {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      suggestedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      selectedWorkflows {
        name
        id
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        questionGroupsToAddToSample {
          id
          name
          questionSets {
            id
            renderer
            questions {
              id
              question
              description
              choices
              order
              questionLevel
              isObligatory
              visibility
              visibilityPreconditions {
                isSatisfied
                questionId
                expectedAnswer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
              placeholder
              answer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
          }
        }
        services {
          id
          startDate
          endDate
          vendors {
            id
            name
          }
          baseLine
          baseLineSize
          status
          description
          name
          serviceType
          durationLocked
          order
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
        }
      }
      enabledWorkflows {
        name
        id
        assignee
        offerPrice {
          currency
          maxPrice {
            value
          }
          minPrice {
            value
          }
        }
        price {
          currency
          price {
            value
          }
        }
        description
        services {
          id
          name
          assignee
          priority
          scientists {
            id
            name
            preferences {
              preferredCurrency
            }
            organization
            schedule {
              id
            }
          }
          startDate
          endDate
          baseLine
          baseLineSize
          status
          price {
            price {
              value
            }
            currency
          }
          description
          serviceType
          durationLocked
          order
          vendor {
            id
            name
          }
          report {
            selectedQuestionGroups {
              id
              name
              questionSets {
                id
                renderer
                questions {
                  id
                  question
                  description
                  choices
                  order
                  questionLevel
                  isObligatory
                  visibility
                  visibilityPreconditions {
                    isSatisfied
                    questionId
                    expectedAnswer {
                      ... on MultiAnswer {
                        multiBody: body
                        answerType
                      }
                      ... on TextAnswer {
                        textBody: body
                        answerType
                      }
                      ... on NumericAnswer {
                        numericBody: body
                        answerType
                      }
                    }
                  }
                  placeholder
                  answer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
              }
            }
          }
          collaborators {
            userIds
            groupIds
          }
        }
        collaborators {
          userIds
          groupIds
        }
      }
      status
      assignedUsers {
        id
        role
      }
      timelineLines {
        line
        name
      }
    }
    users {
      schedule {
        id
      }
      id
      name
      organization
      preferences {
        preferredCurrency
      }
    }
    visibleTimelineElements {
      samples {
        id
        workflows {
          id
          services
        }
        events
      }
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$2778cce8da48a37e = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$7b040ae9d4c82b96,
        ...props
    });
function $7608a8bbcbbad14c$export$f47ded2d66c9a18a(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$7b040ae9d4c82b96, baseOptions);
}
function $7608a8bbcbbad14c$export$3df3ac09c6567ae4(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$7b040ae9d4c82b96, baseOptions);
}
const $7608a8bbcbbad14c$export$ef0b6321654e6bb3 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query Workflow {
  Workflows {
    id
    name
    services {
      id
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      status
      serviceType
      durationLocked
      order
      offerPrice {
        minPrice {
          value
        }
        maxPrice {
          value
        }
        currency
      }
    }
    offerPrice {
      minPrice {
        value
      }
      maxPrice {
        value
      }
      currency
    }
    questionGroupsToAddToSample {
      id
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$3f619b249196f1f0 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$ef0b6321654e6bb3,
        ...props
    });
function $7608a8bbcbbad14c$export$eae5fe4c87d08ef7(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$ef0b6321654e6bb3, baseOptions);
}
function $7608a8bbcbbad14c$export$d9fee7238923f7d0(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$ef0b6321654e6bb3, baseOptions);
}
const $7608a8bbcbbad14c$export$9684c3b3f24e04f1 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query GetAuth0Roles {
  GetAuth0Roles {
    id
    name
    description
  }
}
    `;
const $7608a8bbcbbad14c$export$a389e06e37984386 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$9684c3b3f24e04f1,
        ...props
    });
function $7608a8bbcbbad14c$export$b1b197b2cf928d0d(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$9684c3b3f24e04f1, baseOptions);
}
function $7608a8bbcbbad14c$export$b0d41c2128bf9082(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$9684c3b3f24e04f1, baseOptions);
}
const $7608a8bbcbbad14c$export$fb02ec9bb49fb8b2 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query ListUsers {
  ListUsers {
    id
    email
    name
    avatar
    organization
    role {
      id
      name
      description
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$e077b4f9dc7613c9 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$fb02ec9bb49fb8b2,
        ...props
    });
function $7608a8bbcbbad14c$export$7ccb685555ff35d8(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$fb02ec9bb49fb8b2, baseOptions);
}
function $7608a8bbcbbad14c$export$33f5da1e210d2b19(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$fb02ec9bb49fb8b2, baseOptions);
}
const $7608a8bbcbbad14c$export$8d41cd137eb00d4 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query SearchUsers($searchText: String!) {
  SearchUsers(searchText: $searchText) {
    id
    email
    name
    avatar
    organization
    role {
      id
      name
      description
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$e5b8d0ad9a57c399 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$8d41cd137eb00d4,
        ...props
    });
function $7608a8bbcbbad14c$export$de444598f6e99ad3(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$8d41cd137eb00d4, baseOptions);
}
function $7608a8bbcbbad14c$export$5dd5b53b34bfd5ee(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$8d41cd137eb00d4, baseOptions);
}
const $7608a8bbcbbad14c$export$cae0a44410eb9f52 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query ServicesAssignedToUserForTimeline($userId: ID!) {
  ServicesAssignedToUserForTimeline(userId: $userId) {
    id
    name
    events {
      id
      priority
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      assignee
      collaborators {
        userIds
        groupIds
      }
      milestone
    }
    selectedQuestionGroups {
      id
      name
      questionSets {
        id
        renderer
        questions {
          id
          question
          description
          choices
          order
          questionLevel
          isObligatory
          visibility
          visibilityPreconditions {
            isSatisfied
            questionId
            expectedAnswer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
          placeholder
          answer {
            ... on MultiAnswer {
              multiBody: body
              answerType
            }
            ... on TextAnswer {
              textBody: body
              answerType
            }
            ... on NumericAnswer {
              numericBody: body
              answerType
            }
          }
        }
      }
    }
    suggestedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    selectedWorkflows {
      name
      id
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      questionGroupsToAddToSample {
        id
        name
        questionSets {
          id
          renderer
          questions {
            id
            question
            description
            choices
            order
            questionLevel
            isObligatory
            visibility
            visibilityPreconditions {
              isSatisfied
              questionId
              expectedAnswer {
                ... on MultiAnswer {
                  multiBody: body
                  answerType
                }
                ... on TextAnswer {
                  textBody: body
                  answerType
                }
                ... on NumericAnswer {
                  numericBody: body
                  answerType
                }
              }
            }
            placeholder
            answer {
              ... on MultiAnswer {
                multiBody: body
                answerType
              }
              ... on TextAnswer {
                textBody: body
                answerType
              }
              ... on NumericAnswer {
                numericBody: body
                answerType
              }
            }
          }
        }
      }
      services {
        id
        startDate
        endDate
        vendors {
          id
          name
        }
        baseLine
        baseLineSize
        status
        description
        name
        serviceType
        durationLocked
        order
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
      }
    }
    enabledWorkflows {
      name
      id
      assignee
      offerPrice {
        currency
        maxPrice {
          value
        }
        minPrice {
          value
        }
      }
      price {
        currency
        price {
          value
        }
      }
      services {
        id
        name
        assignee
        priority
        scientists {
          id
          name
          preferences {
            preferredCurrency
          }
          organization
          schedule {
            id
          }
        }
        startDate
        endDate
        baseLine
        baseLineSize
        status
        description
        serviceType
        durationLocked
        order
        vendor {
          id
          name
        }
        report {
          selectedQuestionGroups {
            id
            name
            questionSets {
              id
              renderer
              questions {
                id
                question
                description
                choices
                order
                questionLevel
                isObligatory
                visibility
                visibilityPreconditions {
                  isSatisfied
                  questionId
                  expectedAnswer {
                    ... on MultiAnswer {
                      multiBody: body
                      answerType
                    }
                    ... on TextAnswer {
                      textBody: body
                      answerType
                    }
                    ... on NumericAnswer {
                      numericBody: body
                      answerType
                    }
                  }
                }
                placeholder
                answer {
                  ... on MultiAnswer {
                    multiBody: body
                    answerType
                  }
                  ... on TextAnswer {
                    textBody: body
                    answerType
                  }
                  ... on NumericAnswer {
                    numericBody: body
                    answerType
                  }
                }
              }
            }
          }
        }
        collaborators {
          groupIds
          userIds
        }
      }
      collaborators {
        groupIds
        userIds
      }
    }
    status
    assignedUsers {
      id
      role
    }
    timelineLines {
      line
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$76ee5192194a9729 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$cae0a44410eb9f52,
        ...props
    });
function $7608a8bbcbbad14c$export$9afe1cfbd00e459(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$cae0a44410eb9f52, baseOptions);
}
function $7608a8bbcbbad14c$export$cf54f360a8254e3a(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$cae0a44410eb9f52, baseOptions);
}
const $7608a8bbcbbad14c$export$95cf04aeba3a0624 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
    query WorkflowsByOrganization($organization: String!) {
  WorkflowsByOrganization(organization: $organization) {
    id
    name
    services {
      id
      name
      description
      startDate
      endDate
      baseLineSize
      baseLine
      status
      serviceType
      durationLocked
      order
      offerPrice {
        minPrice {
          value
        }
        maxPrice {
          value
        }
        currency
      }
    }
    offerPrice {
      minPrice {
        value
      }
      maxPrice {
        value
      }
      currency
    }
    questionGroupsToAddToSample {
      id
      name
    }
  }
}
    `;
const $7608a8bbcbbad14c$export$a3e2ee848db7f991 = (props)=>/*#__PURE__*/ $acw62.createElement($8f108aa291352b5e$export$62297b13309008b2, {
        query: $7608a8bbcbbad14c$export$95cf04aeba3a0624,
        ...props
    });
function $7608a8bbcbbad14c$export$4bba2baf4a53c749(baseOptions) {
    return $568346eb0b168c1b$export$dd0a697e1782aedd($7608a8bbcbbad14c$export$95cf04aeba3a0624, baseOptions);
}
function $7608a8bbcbbad14c$export$bd7b166f74159305(baseOptions) {
    return $568346eb0b168c1b$export$fd83eea6ecd2d8fa($7608a8bbcbbad14c$export$95cf04aeba3a0624, baseOptions);
}



var $471f4ec605b8e2c9$export$d1cfdc29cbc61821 = /*#__PURE__*/ function(ROLES) {
    ROLES["ADMINISTRATOR"] = "Administrator";
    ROLES["ORGANIZATION_ADMINISTRATOR"] = "OrganizationAdministrator";
    ROLES["PROJECT_MANAGER"] = "ProjectManager";
    ROLES["SPECIALIST"] = "Specialist";
    ROLES["REGULATORY"] = "Regulatory";
    ROLES["READONLY"] = "ReadOnly";
    return ROLES;
}({});


const $f96e1a178b2fcf1d$export$23191e4434a9e834 = (props)=>{
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const userRoles = user?.["https://leaderneplatform.com/roles"] || [];
    const hasFullAccessRole = userRoles.some((role)=>[
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ].includes(role));
    const shouldRedirectToRegulatory = !hasFullAccessRole && userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).REGULATORY);
    const queryResult = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)({
        variables: {},
        skip: shouldRedirectToRegulatory
    });
    const [newProjectMutationCalled, setNewProjectMutationCalled] = (0, $acw62.useState)(false);
    const [newProjectMutation, newProjectMutationResult] = (0, $7608a8bbcbbad14c$export$df57bd44e287f57c)();
    (0, $acw62.useEffect)(()=>{
        if (shouldRedirectToRegulatory) {
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY);
            return;
        }
        if (queryResult.data && queryResult.data.Projects.length === 0) {
            if (!(newProjectMutationResult.called || newProjectMutationCalled)) {
                const options = {
                    variables: {},
                    refetchQueries: [
                        {
                            query: (0, $7608a8bbcbbad14c$export$cd946050302ba91a),
                            variables: {}
                        }
                    ],
                    awaitRefetchQueries: true
                };
                setNewProjectMutationCalled(true);
                newProjectMutation(options);
            }
        }
    });
    if (shouldRedirectToRegulatory) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = queryResult.data.Projects || [];
    if (newProjectMutationResult.called || newProjectMutationCalled) {
        if (newProjectMutationResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Mutation Error: ", newProjectMutationResult.error);
        if (newProjectMutationResult.loading || !newProjectMutationResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    }
    // if (projects.length === 1) {
    //   if (projectHasOngoingSamples(projects[0])) {
    //     navigate(`/projects/${projects[0].id}`);
    //   } else {
    //     navigate(`/projects/${projects[0].id}/configurator`);
    //   }
    // }
    if (projects.length > 0) (0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
};



var $acw62 = parcelRequire("acw62");

const $96fcde7450cfd307$export$21a94553ffa41578 = (props)=>{
    const { isAuthenticated: isAuthenticated, login: login, logout: logout } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    return isAuthenticated() ? /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: logout
    }, "Logout") : /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: login
    }, "Login");
};



var $acw62 = parcelRequire("acw62");
const $8c84af5eefc2b2e4$export$26e5d19dbab98e56 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "AfterLogin works!");
};



var $acw62 = parcelRequire("acw62");
const $958581b144b6f867$export$ac07ca9bf4c6512c = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "What is LP?");
};



var $acw62 = parcelRequire("acw62");
const $ff811c5df4acb19e$export$cc4d8724d022ebe5 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "Introduction works!");
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $781e22e9ef9a0015$exports = {};
"use strict";
Object.defineProperty($781e22e9ef9a0015$exports, "__esModule", {
    value: true
});
Object.defineProperty($781e22e9ef9a0015$exports, "Box", {
    enumerable: true,
    get: function get() {
        return $9daa5a3f093ec6ae$exports.Box;
    }
});
Object.defineProperty($781e22e9ef9a0015$exports, "Flex", {
    enumerable: true,
    get: function get() {
        return $9daa5a3f093ec6ae$exports.Flex;
    }
});
$781e22e9ef9a0015$exports.Card = $781e22e9ef9a0015$exports.Image = $781e22e9ef9a0015$exports.Button = $781e22e9ef9a0015$exports.Link = $781e22e9ef9a0015$exports.Heading = $781e22e9ef9a0015$exports.Text = void 0;

var $781e22e9ef9a0015$var$_react = $781e22e9ef9a0015$var$_interopRequireWildcard((parcelRequire("acw62")));
var $9daa5a3f093ec6ae$exports = {};
"use strict";
Object.defineProperty($9daa5a3f093ec6ae$exports, "__esModule", {
    value: true
});
$9daa5a3f093ec6ae$exports.Flex = $9daa5a3f093ec6ae$exports.Box = void 0;

var $9daa5a3f093ec6ae$var$_react = $9daa5a3f093ec6ae$var$_interopRequireDefault((parcelRequire("acw62")));

var $9daa5a3f093ec6ae$var$_styledComponents = $9daa5a3f093ec6ae$var$_interopRequireDefault((parcelRequire("lmFrL")));
parcelRequire("8br48");
var $3VFVC = parcelRequire("3VFVC");
var $665Bp = parcelRequire("665Bp");
var $fNZHs = parcelRequire("fNZHs");
var $hHVze = parcelRequire("hHVze");
var $cMmwD = parcelRequire("cMmwD");
var $lWdYs = parcelRequire("lWdYs");

var $9daa5a3f093ec6ae$var$_css = $9daa5a3f093ec6ae$var$_interopRequireWildcard((parcelRequire("1ApNP")));

var $9daa5a3f093ec6ae$var$_shouldForwardProp = $9daa5a3f093ec6ae$var$_interopRequireDefault((parcelRequire("h7un0")));
function $9daa5a3f093ec6ae$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $9daa5a3f093ec6ae$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $9daa5a3f093ec6ae$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    var cache = $9daa5a3f093ec6ae$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    if (obj != null) {
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9daa5a3f093ec6ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $9daa5a3f093ec6ae$var$sx = function sx(props) {
    return (0, $9daa5a3f093ec6ae$var$_css["default"])(props.sx)(props.theme);
};
var $9daa5a3f093ec6ae$var$base = function base(props) {
    return (0, $9daa5a3f093ec6ae$var$_css["default"])(props.__css)(props.theme);
};
var $9daa5a3f093ec6ae$var$variant = function variant(_ref) {
    var theme = _ref.theme, variant = _ref.variant, _ref$tx = _ref.tx, tx = _ref$tx === void 0 ? 'variants' : _ref$tx;
    return (0, $9daa5a3f093ec6ae$var$_css["default"])((0, $9daa5a3f093ec6ae$var$_css.get)(theme, tx + '.' + variant, (0, $9daa5a3f093ec6ae$var$_css.get)(theme, variant)))(theme);
};
var $9daa5a3f093ec6ae$var$Box = (0, $9daa5a3f093ec6ae$var$_styledComponents["default"])('div', {
    shouldForwardProp: $9daa5a3f093ec6ae$var$_shouldForwardProp["default"]
})({
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
}, $9daa5a3f093ec6ae$var$base, $9daa5a3f093ec6ae$var$variant, $9daa5a3f093ec6ae$var$sx, function(props) {
    return props.css;
}, (0, $665Bp.compose)($cMmwD.space, $hHVze.layout, $lWdYs.typography, $3VFVC.color, $fNZHs.flexbox));
$9daa5a3f093ec6ae$exports.Box = $9daa5a3f093ec6ae$var$Box;
var $9daa5a3f093ec6ae$var$Flex = (0, $9daa5a3f093ec6ae$var$_styledComponents["default"])($9daa5a3f093ec6ae$var$Box)({
    display: 'flex'
});
$9daa5a3f093ec6ae$exports.Flex = $9daa5a3f093ec6ae$var$Flex;


function $781e22e9ef9a0015$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $781e22e9ef9a0015$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $781e22e9ef9a0015$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    var cache = $781e22e9ef9a0015$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    if (obj != null) {
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $781e22e9ef9a0015$var$_extends() {
    $781e22e9ef9a0015$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $781e22e9ef9a0015$var$_extends.apply(this, arguments);
}
var $781e22e9ef9a0015$var$Text = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        tx: "text"
    }, props));
});
$781e22e9ef9a0015$exports.Text = $781e22e9ef9a0015$var$Text;
var $781e22e9ef9a0015$var$Heading = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        as: "h2",
        tx: "text",
        variant: "heading"
    }, props, {
        __css: {
            fontSize: 4,
            fontFamily: 'heading',
            fontWeight: 'heading',
            lineHeight: 'heading'
        }
    }));
});
$781e22e9ef9a0015$exports.Heading = $781e22e9ef9a0015$var$Heading;
var $781e22e9ef9a0015$var$Link = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        as: "a",
        variant: "link"
    }, props));
});
$781e22e9ef9a0015$exports.Link = $781e22e9ef9a0015$var$Link;
var $781e22e9ef9a0015$var$Button = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        as: "button",
        tx: "buttons",
        variant: "primary"
    }, props, {
        __css: {
            appearance: 'none',
            display: 'inline-block',
            textAlign: 'center',
            lineHeight: 'inherit',
            textDecoration: 'none',
            fontSize: 'inherit',
            px: 3,
            py: 2,
            color: 'white',
            bg: 'primary',
            border: 0,
            borderRadius: 4
        }
    }));
});
$781e22e9ef9a0015$exports.Button = $781e22e9ef9a0015$var$Button;
var $781e22e9ef9a0015$var$Image = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        as: "img"
    }, props, {
        __css: {
            maxWidth: '100%',
            height: 'auto'
        }
    }));
});
$781e22e9ef9a0015$exports.Image = $781e22e9ef9a0015$var$Image;
var $781e22e9ef9a0015$var$Card = (0, $781e22e9ef9a0015$var$_react.forwardRef)(function(props, ref) {
    return $781e22e9ef9a0015$var$_react["default"].createElement($9daa5a3f093ec6ae$exports.Box, $781e22e9ef9a0015$var$_extends({
        ref: ref,
        variant: "card"
    }, props));
});
$781e22e9ef9a0015$exports.Card = $781e22e9ef9a0015$var$Card;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $lmFrL = parcelRequire("lmFrL");

const $0ae05e0bf2c3dc8f$export$844f199b4427ce36 = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  margin: auto;
  padding: ${(p)=>p.theme.space[3]};
  width: 100%;
  max-width: ${(p)=>p.theme.maxContentWidth};
`;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $5bf921a129ee049a$exports = {};
"use strict";
Object.defineProperty($5bf921a129ee049a$exports, "__esModule", {
    value: true
});
$5bf921a129ee049a$exports.Flex = $5bf921a129ee049a$exports.Box = void 0;

var $5bf921a129ee049a$var$_react = $5bf921a129ee049a$var$_interopRequireDefault((parcelRequire("acw62")));

var $5bf921a129ee049a$var$_styled = $5bf921a129ee049a$var$_interopRequireDefault((parcelRequire("2hXAd")));
parcelRequire("8br48");
var $3VFVC = parcelRequire("3VFVC");
var $665Bp = parcelRequire("665Bp");
var $fNZHs = parcelRequire("fNZHs");
var $hHVze = parcelRequire("hHVze");
var $cMmwD = parcelRequire("cMmwD");
var $lWdYs = parcelRequire("lWdYs");

var $5bf921a129ee049a$var$_css = $5bf921a129ee049a$var$_interopRequireWildcard((parcelRequire("1ApNP")));

var $5bf921a129ee049a$var$_shouldForwardProp = $5bf921a129ee049a$var$_interopRequireDefault((parcelRequire("h7un0")));
function $5bf921a129ee049a$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $5bf921a129ee049a$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $5bf921a129ee049a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    var cache = $5bf921a129ee049a$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    if (obj != null) {
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5bf921a129ee049a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $5bf921a129ee049a$var$sx = function sx(props) {
    return (0, $5bf921a129ee049a$var$_css["default"])(props.sx)(props.theme);
};
var $5bf921a129ee049a$var$base = function base(props) {
    return (0, $5bf921a129ee049a$var$_css["default"])(props.__css)(props.theme);
};
var $5bf921a129ee049a$var$variant = function variant(_ref) {
    var theme = _ref.theme, variant = _ref.variant, _ref$tx = _ref.tx, tx = _ref$tx === void 0 ? 'variants' : _ref$tx;
    return (0, $5bf921a129ee049a$var$_css["default"])((0, $5bf921a129ee049a$var$_css.get)(theme, tx + '.' + variant, (0, $5bf921a129ee049a$var$_css.get)(theme, variant)))(theme);
};
var $5bf921a129ee049a$var$Box = (0, $5bf921a129ee049a$var$_styled["default"])('div', {
    shouldForwardProp: $5bf921a129ee049a$var$_shouldForwardProp["default"]
})({
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
}, $5bf921a129ee049a$var$base, $5bf921a129ee049a$var$variant, $5bf921a129ee049a$var$sx, function(props) {
    return props.css;
}, (0, $665Bp.compose)($cMmwD.space, $hHVze.layout, $lWdYs.typography, $3VFVC.color, $fNZHs.flexbox));
$5bf921a129ee049a$exports.Box = $5bf921a129ee049a$var$Box;
var $5bf921a129ee049a$var$Flex = (0, $5bf921a129ee049a$var$_styled["default"])($5bf921a129ee049a$var$Box)({
    display: 'flex'
});
$5bf921a129ee049a$exports.Flex = $5bf921a129ee049a$var$Flex;


function $23d69906b9d4392a$var$_extends() {
    $23d69906b9d4392a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23d69906b9d4392a$var$_extends.apply(this, arguments);
}
var $23d69906b9d4392a$export$5f1af8db9871e1d6 = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        tx: "text"
    }, props));
});
var $23d69906b9d4392a$export$a8a3e93435678ff9 = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        as: "h2",
        tx: "text",
        variant: "heading"
    }, props, {
        __css: {
            fontSize: 4,
            fontFamily: 'heading',
            fontWeight: 'heading',
            lineHeight: 'heading'
        }
    }));
});
var $23d69906b9d4392a$export$a6c7ac8248d6e38a = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        as: "a",
        variant: "link"
    }, props));
});
var $23d69906b9d4392a$export$353f5b6fc5456de1 = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        as: "button",
        tx: "buttons",
        variant: "primary"
    }, props, {
        __css: {
            appearance: 'none',
            display: 'inline-block',
            textAlign: 'center',
            lineHeight: 'inherit',
            textDecoration: 'none',
            fontSize: 'inherit',
            px: 3,
            py: 2,
            color: 'white',
            bg: 'primary',
            border: 0,
            borderRadius: 4
        }
    }));
});
var $23d69906b9d4392a$export$3e431a229df88919 = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        as: "img"
    }, props, {
        __css: {
            maxWidth: '100%',
            height: 'auto'
        }
    }));
});
var $23d69906b9d4392a$export$60332b2344f7fe41 = (0, $acw62.forwardRef)(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bf921a129ee049a$exports.Box), $23d69906b9d4392a$var$_extends({
        ref: ref,
        variant: "card"
    }, props));
});



var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $e17e79530b3afee5$export$b837bd7eac09a33e = (props)=>{
    const { width: width, height: height, color: color, x: x, y: y } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 6 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        x: x,
        y: y
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.75192 4.83205C5.34566 4.43623 5.34566 3.56377 4.75192 3.16795L1.5547 1.03647C0.890145 0.59343 -3.02928e-07 1.06982 -2.68016e-07 1.86852L-8.16755e-08 6.13148C-4.67634e-08 6.93018 0.890145 7.40657 1.5547 6.96353L4.75192 4.83205Z",
        fill: color
    }));
};
$e17e79530b3afee5$export$b837bd7eac09a33e.defaultProps = {
    width: "6",
    height: "8",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background
};



// https://stackoverflow.com/a/55387306
const $1090c52da2338f2e$var$insertSeparatorsAtEveryOddIndex = (arr)=>// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    [].concat(...arr.map((n)=>[
            n,
            /*#__PURE__*/ $acw62.createElement($1090c52da2338f2e$var$ArrowContainer, {
                key: `arrow_${Math.random()}`
            }, /*#__PURE__*/ $acw62.createElement((0, $e17e79530b3afee5$export$b837bd7eac09a33e), {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText
            }))
        ])).slice(0, -1);
const $1090c52da2338f2e$var$reducer = (accumulator, currentValue)=>{
    return `${accumulator}/${currentValue}`;
};
// const camelcaseToSpaces = (s: string) => s.replace(/([A-Z])/g, " $1");
const $1090c52da2338f2e$var$prepareLinksFromCrumbs = (crumbs)=>crumbs.map((c, index, array)=>/*#__PURE__*/ $acw62.createElement((0, $66249767282b1118$export$a6c7ac8248d6e38a), {
            key: c + index,
            to: `/${array.slice(0, index + 1).reduce($1090c52da2338f2e$var$reducer)}`
        }, c));
const $1090c52da2338f2e$export$2dc68d50d56fbbd = ()=>{
    const location = (0, $66249767282b1118$export$45d76561a5302f2b)();
    const crumbs = location.pathname.split("/").filter((s)=>s !== "");
    const links = $1090c52da2338f2e$var$prepareLinksFromCrumbs(crumbs);
    const linksWithSeparators = $1090c52da2338f2e$var$insertSeparatorsAtEveryOddIndex(links);
    return /*#__PURE__*/ $acw62.createElement($1090c52da2338f2e$var$BreadcrumbsStyled, {
        "data-testid": "breadcrumbs"
    }, linksWithSeparators);
};
const $1090c52da2338f2e$var$BreadcrumbsStyled = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  font-size: ${(p)=>p.theme.fontSizes[0]};

  a {
    color: ${(p)=>p.theme.colors.lightText};
    text-decoration: none;
  }
`;
const $1090c52da2338f2e$var$ArrowContainer = (0, $lmFrL.default).span`
  padding: 0 9px;
`;



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");



var $acw62 = parcelRequire("acw62");

const $c5e5d92098072fea$export$2235404cc2cfe93c = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.00031 20C4.29606 20 3.82505 19.2979 4.06009 18.6586L4.10589 18.5528L5.2613 16.242C5.6987 15.3672 5.94738 14.4115 5.99274 13.4369L6.00031 13.1115V10C6.00031 7.02694 8.1627 4.55893 11.0005 4.08293L11.0003 3C11.0003 2.44772 11.448 2 12.0003 2C12.5526 2 13.0003 2.44772 13.0003 3L13.0011 4.08309C15.7596 4.54627 17.8797 6.89172 17.9953 9.75347L18.0003 10V13.1115C18.0003 14.0895 18.2053 15.0555 18.6005 15.9474L18.7393 16.242L19.8947 18.5528C20.2097 19.1827 19.7923 19.918 19.1154 19.9936L19.0003 20H14.0003C14.0003 21.1046 13.1049 22 12.0003 22C10.8957 22 10.0003 21.1046 10.0003 20H5.00031ZM12.0003 6C9.85812 6 8.10923 7.68397 8.00521 9.80036L8.00031 10V13.1115C8.00031 14.3922 7.72697 15.6569 7.20012 16.8213L7.05016 17.1364L6.61835 18H17.3823L16.9505 17.1364C16.3777 15.9908 16.0566 14.7374 16.0071 13.4603L16.0003 13.1115V10C16.0003 7.79086 14.2095 6 12.0003 6Z",
        fill: color
    }));
};
$c5e5d92098072fea$export$2235404cc2cfe93c.defaultProps = {
    width: 24,
    height: 24,
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background
};



var $acw62 = parcelRequire("acw62");

const $dac2a40df8fd5b62$export$58a334b597cee6d6 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM12 6C14.2091 6 16 7.79086 16 10C16 11.7948 14.8179 13.3135 13.1898 13.8201L13 13.874V14C13 14.5523 12.5523 15 12 15C11.4872 15 11.0645 14.614 11.0067 14.1166L11 14V13C11 12.4872 11.386 12.0645 11.8834 12.0067L12.1493 11.9945C13.1841 11.9182 14 11.0544 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 7.79086 9.79086 6 12 6Z",
        fill: color
    }));
};
$dac2a40df8fd5b62$export$58a334b597cee6d6.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $d305ae7318d3bd61$export$2c9e30524eeaa42e = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: width,
        height: height,
        viewBox: "0 0 490.3 490.3",
        xmlSpace: "preserve"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        fill: color
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0,121.05v248.2c0,34.2,27.9,62.1,62.1,62.1h200.6c34.2,0,62.1-27.9,62.1-62.1v-40.2c0-6.8-5.5-12.3-12.3-12.3    s-12.3,5.5-12.3,12.3v40.2c0,20.7-16.9,37.6-37.6,37.6H62.1c-20.7,0-37.6-16.9-37.6-37.6v-248.2c0-20.7,16.9-37.6,37.6-37.6h200.6    c20.7,0,37.6,16.9,37.6,37.6v40.2c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3v-40.2c0-34.2-27.9-62.1-62.1-62.1H62.1    C27.9,58.95,0,86.75,0,121.05z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M385.4,337.65c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l83.9-83.9c4.8-4.8,4.8-12.5,0-17.3l-83.9-83.9    c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l63,63H218.6c-6.8,0-12.3,5.5-12.3,12.3c0,6.8,5.5,12.3,12.3,12.3h229.8l-63,63    C380.6,325.15,380.6,332.95,385.4,337.65z"
    })));
};
$d305ae7318d3bd61$export$2c9e30524eeaa42e.defaultProps = {
    width: "20",
    height: "20",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};


/* eslint-disable react/default-props-match-prop-types */ 
var $acw62 = parcelRequire("acw62");
const $e0ac02571a3ef321$export$277089a45d8e9a3b = (props)=>{
    const { color: color, width: width, height: height, id: id, x: x, y: y, style: style, onClick: onClick, ownScale: ownScale = 1 } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: +width * ownScale,
        height: +height * ownScale,
        fill: "none",
        viewBox: `0 0 ${width} ${height}`,
        id: id,
        x: x,
        y: y,
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "2",
        cy: "2",
        r: 2,
        fill: color,
        transform: "rotate(90 2 2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10",
        cy: "2",
        r: 2,
        fill: color,
        transform: "rotate(90 10 2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "18",
        cy: "2",
        r: 2,
        fill: color,
        transform: "rotate(90 18 2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "transparent"
    }));
};
$e0ac02571a3ef321$export$277089a45d8e9a3b.defaultProps = {
    onwScale: 1,
    width: "20",
    height: "4",
    color: "#6E7D92"
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $1a2ca5846e673565$export$6c0524ba53950d9f = (props)=>{
    const { user: user, className: className } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1a2ca5846e673565$var$StyledAvatar, {
        className: className,
        src: user && user.picture
    });
};
const $1a2ca5846e673565$var$StyledAvatar = (0, $lmFrL.default).div`
  width: ${({ theme: theme })=>theme.space[4]};
  min-width: ${({ theme: theme })=>theme.space[4]};
  height: ${({ theme: theme })=>theme.space[4]};
  background-color: #4979cb;
  border-radius: 50%;
  background-image: url(${({ src: src })=>src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;



var $acw62 = parcelRequire("acw62");
function $ab7e5a8bc378b63a$var$useOnClickOutside(ref, handler) {
    (0, $acw62.useEffect)(()=>{
        const listener = (event)=>{
            const el = ref?.current;
            if (!el || el.contains(event.target)) return;
            handler(event);
        };
        document.addEventListener(`mousedown`, listener);
        document.addEventListener(`touchstart`, listener);
        return ()=>{
            document.removeEventListener(`mousedown`, listener);
            document.removeEventListener(`touchstart`, listener);
        };
    }, [
        ref,
        handler
    ]);
}
var $ab7e5a8bc378b63a$export$2e2bcd8739ae039 = $ab7e5a8bc378b63a$var$useOnClickOutside;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $26e621062d296af4$export$d3d950cd69e1ac66 = /*#__PURE__*/ function(ButtonType) {
    ButtonType[ButtonType["Primary"] = 0] = "Primary";
    ButtonType[ButtonType["Secondary"] = 1] = "Secondary";
    ButtonType[ButtonType["Tertiary"] = 2] = "Tertiary";
    ButtonType[ButtonType["Quaternary"] = 3] = "Quaternary";
    return ButtonType;
}({});



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $1u0KT = parcelRequire("1u0KT");

const $3139a814db547547$var$modalRoot = document.getElementById("modals");
const $3139a814db547547$export$2b77a92f1a5ad772 = (props)=>{
    const { id: id, children: children, footerContent: footerContent, title: title, className: className, dialogClassName: dialogClassName, onClose: onClose, isLoading: isLoading } = props;
    const background = (0, $acw62.useRef)(null);
    const [fadeType, setFadeType] = (0, $acw62.useState)("in");
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setFadeType("out");
        };
    }, []);
    const result = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, isLoading && /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        className: "spinner",
        opaque: true
    }), /*#__PURE__*/ $acw62.createElement($3139a814db547547$var$ModalStyled, {
        id: id,
        className: `fade-${fadeType} ${className}`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `modal-dialog ${dialogClassName}`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "modal-header"
    }, /*#__PURE__*/ $acw62.createElement("h4", {
        className: "modal-title"
    }, title)), /*#__PURE__*/ $acw62.createElement("div", {
        className: "modal-content-footer"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "modal-content-wrapper"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "modal-content"
    }, children)), /*#__PURE__*/ $acw62.createElement("div", {
        className: "modal-footer"
    }, footerContent))), /*#__PURE__*/ $acw62.createElement("div", {
        "aria-hidden": "true",
        className: "background",
        ref: background,
        onClick: onClose
    })));
    if ($3139a814db547547$var$modalRoot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(result, $3139a814db547547$var$modalRoot);
    return result;
};
const $3139a814db547547$var$ModalStyled = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity linear 0.3s;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  &.fade-in {
    opacity: 1;
    transition: opacity linear 0.3s;
  }

  &.fade-out {
    opacity: 0;
    transition: opacity linear 0.3s;
  }

  .background {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 900;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    outline: 0;
  }

  .spinner {
    z-index: 1001;
  }

  .modal-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background-color: ${(props)=>props.theme.newColors.grayscale.background};
    border-radius: 10px;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);

    .modal-header {
      padding: 0 1rem;
      height: 3.5rem;
      display: flex;
      background-color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
      border-radius: 0.5rem 0.5rem 0 0;
      align-items: center;

      .modal-title {
        color: ${(props)=>props.theme.newColors.grayscale.white};
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: 800;
        margin: 0 0 0 0;
      }
    }

    .modal-content-wrapper {
      padding: 1.5rem 5rem;
      display: flex;
      justify-content: center;
      max-height: 80vh;
    }

    .modal-content {
      min-width: 488px;
      padding: 0.75rem;
    }

    .modal-footer {
      padding: 1rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid
        ${(props)=>props.theme.newColors.grayscale.bordersInside};
      border-radius: 0 0 8px 8px;
    }
  }
`;


// @flow

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $lmFrL = parcelRequire("lmFrL");

const $1e7d80170752ca45$export$41c1085b355ecc97 = (0, $lmFrL.css)`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 0;

  svg path {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  }

  svg {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  }

  &:hover {
    background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.hover};
  }

  &:active {
    background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.darkestTint};
  }

  ${({ theme: theme, disabled: disabled })=>disabled && (0, $lmFrL.css)`
      background: ${theme.newColors.grayscale.disabled};
      cursor: default;
      color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};

      &:hover {
        background: ${theme.newColors.grayscale.disabled};
      }

      svg path {
        fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};
      }

      svg {
        fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};
      }
    `}
`;



var $lmFrL = parcelRequire("lmFrL");

const $041da08ae502de50$export$130dd2cd4186e923 = (0, $lmFrL.css)`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};

  svg path {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic};
  }

  div svg {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic};
  }

  &:hover {
    border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};
    color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.darkTint};

    &:active {
      border-style: inset;
    }

    svg path {
      fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.darkTint};
    }

    svg {
      fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.darkTint};
    }
  }

  ${({ theme: theme, disabled: disabled })=>disabled && (0, $lmFrL.css)`
      background: ${theme.newColors.extra.tertiaryButtonBG};
      cursor: default;
      color: ${theme.newColors.grayscale.disabled};
      border: 1px solid ${theme.newColors.grayscale.disabled};

      &:hover {
        color: ${theme.newColors.grayscale.disabled};
        border: 1px solid ${theme.newColors.grayscale.disabled};

        &:active {
          border-style: outset;
        }

        svg path {
          fill: ${theme.newColors.grayscale.disabled};
        }

        svg {
          fill: ${theme.newColors.grayscale.disabled};
        }
      }

      svg path {
        fill: ${theme.newColors.grayscale.disabled};
      }

      svg {
        fill: ${theme.newColors.grayscale.disabled};
      }
    `}
`;



var $lmFrL = parcelRequire("lmFrL");

const $6ffdc4b957b94b25$export$d55a97eb35aa8498 = (0, $lmFrL.css)`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.tertiaryButtonBG};
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};

  svg path {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray};
  }

  svg {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray};
  }

  &:hover {
    border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};

    &:active {
      border-style: inset;
    }
  }

  ${({ theme: theme, disabled: disabled })=>disabled && (0, $lmFrL.css)`
      background: ${theme.newColors.extra.tertiaryButtonBG};
      cursor: default;
      color: ${theme.newColors.grayscale.disabled};
      border: 1px solid ${theme.newColors.grayscale.disabled};

      &:hover {
        color: ${theme.newColors.grayscale.disabled};
        border: 1px solid ${theme.newColors.grayscale.disabled};

        &:active {
          border-style: outset;
        }

        svg path {
          fill: ${theme.newColors.grayscale.disabled};
        }

        svg {
          fill: ${theme.newColors.grayscale.disabled};
        }
      }

      svg path {
        fill: ${theme.newColors.grayscale.disabled};
      }

      svg {
        fill: ${theme.newColors.grayscale.disabled};
      }
    `}
`;



var $lmFrL = parcelRequire("lmFrL");

const $4f34c4e999475811$export$17f4b00c4e972b69 = (0, $lmFrL.css)`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorState};
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorState};

  svg path {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  }

  svg {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  }

  &:hover {
    background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorHovered};
    border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorHovered};

    &:active {
      background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorActive};
      border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorActive};
    }
  }

  ${({ theme: theme, disabled: disabled })=>disabled && (0, $lmFrL.css)`
      background: ${theme.newColors.extra.tertiaryButtonBG};
      cursor: default;
      color: ${theme.newColors.grayscale.disabled};
      border: 1px solid ${theme.newColors.grayscale.disabled};

      &:hover {
        background: ${theme.newColors.extra.tertiaryButtonBG};
        color: ${theme.newColors.grayscale.disabled};
        border: 1px solid ${theme.newColors.grayscale.disabled};

        &:active {
          background: ${theme.newColors.extra.tertiaryButtonBG};
          color: ${theme.newColors.grayscale.disabled};
          border: 1px solid ${theme.newColors.grayscale.disabled};
        }

        svg path {
          fill: ${theme.newColors.grayscale.disabled};
        }

        svg {
          fill: ${theme.newColors.grayscale.disabled};
        }
      }

      svg path {
        fill: ${theme.newColors.grayscale.disabled};
      }

      svg {
        fill: ${theme.newColors.grayscale.disabled};
      }
    `}
`;


const $d16295188a465402$var$StyledButton = (0, $lmFrL.default).button`
  display: flex;
  flex-direction: row;
  padding: 6px 16px;
  cursor: pointer;
  justify-content: center;
  align-items: center;

  ${({ theme: theme, buttonType: buttonType })=>{
    switch(buttonType){
        default:
        case (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary:
            return 0, $1e7d80170752ca45$export$41c1085b355ecc97;
        case (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary:
            return 0, $041da08ae502de50$export$130dd2cd4186e923;
        case (0, $26e621062d296af4$export$d3d950cd69e1ac66).Tertiary:
            return 0, $6ffdc4b957b94b25$export$d55a97eb35aa8498;
        case (0, $26e621062d296af4$export$d3d950cd69e1ac66).Quaternary:
            return 0, $4f34c4e999475811$export$17f4b00c4e972b69;
    }
}};

  border-radius: 4px;

  &:focus {
    outline: none;
  }

  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
`;
const $d16295188a465402$var$ButtonIcon = (0, $lmFrL.default).div`
  top: 5px;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $d16295188a465402$export$353f5b6fc5456de1 = (props)=>{
    const { icon: icon, label: label, type: type, disabled: disabled, className: className } = props;
    const onClick = disabled ? ()=>{} : (event)=>{
        // TODO fix any
        event.stopPropagation();
        if (props.onClick) props.onClick(event);
    };
    return /*#__PURE__*/ $acw62.createElement($d16295188a465402$var$StyledButton, {
        "data-testid": "button",
        type: "button",
        onClick: onClick,
        buttonType: type,
        disabled: disabled,
        className: className
    }, icon && /*#__PURE__*/ $acw62.createElement($d16295188a465402$var$ButtonIcon, {
        "data-testid": "button-icon"
    }, icon), /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": "button-label"
    }, label));
};
$d16295188a465402$export$353f5b6fc5456de1.defaultProps = {
    type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary
};




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $lmFrL = parcelRequire("lmFrL");
const $77508f0e0a787542$export$e1f706e5673fef9e = (0, $lmFrL.default).input`
  padding: 12px 16px;
  width: 100%;
  min-width: 0;

  border: 1px solid ${(props)=>props.theme.newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.basicInside};

  font-size: ${(props)=>props.theme.fontSizes[2]};
  font-style: normal;
  font-weight: normal;
  line-height: ${(props)=>props.theme.lineHeights[4]};
  color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  letter-spacing: -0.01em;

  :hover {
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.placeholder};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.hoveredState};
    outline: none;
  }

  :focus {
    border: 1px solid ${(props)=>props.theme.newColors.primary.basic};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.activeState};
    outline: none;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  :-ms-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  ${(props)=>props.error && (0, $lmFrL.css)`
      border: 1px solid ${({ theme: theme })=>theme.newColors.extra.errorState};
      box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.errorState};
    `}

  ${(props)=>props.disabled && (0, $lmFrL.css)`
      border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.placeholder};
      background: ${({ theme: theme })=>theme.newColors.grayscale.disabled};
      box-shadow: none;
    `}
    
    ${(props)=>{
    if (props.svgIcon) return `
        background-image: url("data:image/svg+xml,${props.svgIcon}");
        background-repeat: no-repeat;
        background-position-y: center;
        background-position-x: 18px;
        padding-left: 44px;
        `;
    return "";
}}
`;


const $e23cddd5b45db21f$var$Input = (0, $lmFrL.default)((0, $77508f0e0a787542$export$e1f706e5673fef9e))``;
const $e23cddd5b45db21f$export$10e6f4f66014ee2d = (props)=>{
    const { placeholder: placeholder, disabled: disabled, error: error, type: type, svgIcon: svgIcon, value: value, onChange: onChange, onBlur: onBlur, onKeyDown: onKeyDown, testId: testId, staticForm: staticForm, onlyForRead: onlyForRead } = props;
    const withStaticInput = (children)=>/*#__PURE__*/ $acw62.createElement($e23cddd5b45db21f$var$InputContainer, null, /*#__PURE__*/ $acw62.createElement($e23cddd5b45db21f$var$StaticInput, null), children);
    const renderInputComponent = ()=>/*#__PURE__*/ $acw62.createElement($e23cddd5b45db21f$var$Input, {
            type: type || "text",
            placeholder: placeholder,
            disabled: disabled,
            error: error,
            svgIcon: svgIcon,
            value: value,
            onChange: onChange,
            onKeyDown: onKeyDown,
            onBlur: onBlur,
            "data-testid": testId,
            readOnly: onlyForRead || false
        });
    return staticForm ? withStaticInput(renderInputComponent()) : renderInputComponent();
};
const $e23cddd5b45db21f$var$InputContainer = (0, $lmFrL.default).div`
  position: relative;
  width: 100%;
  display: flex;
`;
const $e23cddd5b45db21f$var$StaticInput = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: default;
`;


const $ad57214f7866145e$export$a5da2e560921fb7f = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const [newPassword1FieldValue, setNewPassword1FieldValue] = (0, $acw62.useState)("");
    const [newPassword2FieldValue, setNewPassword2FieldValue] = (0, $acw62.useState)("");
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [changePassword] = (0, $7608a8bbcbbad14c$export$4742f5cd36d944ba)();
    const onChange1 = (event)=>{
        setNewPassword1FieldValue(event.target.value);
    };
    const onChange2 = (event)=>{
        setNewPassword2FieldValue(event.target.value);
    };
    const onAcceptModal = ()=>{
        if (newPassword1FieldValue !== newPassword2FieldValue) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("New passwords do not match");
            return;
        }
        setIsLoading(true);
        changePassword({
            variables: {
                newPassword: newPassword1FieldValue
            },
            awaitRefetchQueries: true
        }).then(()=>{
            setIsLoading(false);
            onClose();
        }).catch((e)=>{
            setIsLoading(false);
        });
    };
    const ModalButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad57214f7866145e$var$AcceptButton, {
            disabled: isLoading,
            label: "Change password",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad57214f7866145e$var$StyledModal, {
        id: "changePasswordModal",
        title: "Change password",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        type: "password",
        placeholder: "New password",
        value: newPassword1FieldValue,
        onChange: onChange1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        type: "password",
        placeholder: "Confirm new password",
        value: newPassword2FieldValue,
        onChange: onChange2
    })));
};
const $ad57214f7866145e$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $ad57214f7866145e$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;


const $9e4810506b6e896c$export$e213cebad6250b4a = ()=>{
    const dropdownButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dropdownMenuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [changePasswordModalOpened, setChangePasswordModalOpened] = (0, $acw62.useState)(false);
    (0, $ab7e5a8bc378b63a$export$2e2bcd8739ae039)(dropdownMenuRef, (event)=>{
        if (!dropdownButtonRef.current.contains(event.target)) setMenuOpen(false);
    });
    const { // TODO not sure how to handle that types
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    user: { name: name, clientID: clientID, picture: picture } = {
        name: "",
        clientID: "#0000",
        picture: ""
    }, isAuthenticated: isAuthenticated, logout: logout } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const openChangePasswordModal = ()=>{
        setChangePasswordModalOpened(true);
    };
    const getUsernameComponent = ()=>{
        if (isAuthenticated()) {
            const splittedName = name.split("@");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$UserName, null, splittedName[0]), "@", splittedName[1]);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$StyledActionBar, null, isAuthenticated() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a2ca5846e673565$export$6c0524ba53950d9f), {
        user: {
            picture: picture
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $781e22e9ef9a0015$exports.Flex), {
        flexDirection: "column",
        pr: "16px",
        pl: "8px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$UsernameContainer, null, getUsernameComponent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$ClientId, null, "CID ", clientID))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$IconsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5e5d92098072fea$export$2235404cc2cfe93c), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dac2a40df8fd5b62$export$58a334b597cee6d6), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$DotsIconContainer, {
        ref: dropdownButtonRef,
        onClick: ()=>setMenuOpen(!menuOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0ac02571a3ef321$export$277089a45d8e9a3b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$Menu, {
        ref: dropdownMenuRef,
        isMenuOpen: menuOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$MenuLiItem, {
        onClick: logout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d305ae7318d3bd61$export$2c9e30524eeaa42e), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Logout")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$MenuLiItem, {
        onClick: openChangePasswordModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e4810506b6e896c$var$IconContainer, null, "\uD83D\uDD11"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Change password"))))), changePasswordModalOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad57214f7866145e$export$a5da2e560921fb7f), {
        isOpen: changePasswordModalOpened,
        onClose: ()=>setChangePasswordModalOpened(false)
    }));
};
const $9e4810506b6e896c$var$StyledActionBar = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  justify-content: flex-end;
  min-width: 250px;
`;
const $9e4810506b6e896c$var$UsernameContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  display: flex;
`;
const $9e4810506b6e896c$var$UserName = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Text))`
  white-space: none;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $9e4810506b6e896c$var$ClientId = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Text))`
  color: ${(p)=>p.theme.colors.lightText};
  font-size: ${(p)=>p.theme.fontSizes[0]};
`;
const $9e4810506b6e896c$var$IconsWrapper = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  padding: 0 1rem;
  display: flex;
  gap: 1rem;
  border-right: 1px solid
    ${({ theme: theme })=>theme.newColors.grayscale.bordersInside};
  border-left: 1px solid
    ${({ theme: theme })=>theme.newColors.grayscale.bordersInside};
  flex: 0 0 auto;
`;
const $9e4810506b6e896c$var$ActionsContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-right: 0.5rem !important;
`;
const $9e4810506b6e896c$var$IconContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  min-height: 24px;
  min-width: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const $9e4810506b6e896c$var$DotsIconContainer = (0, $lmFrL.default)($9e4810506b6e896c$var$IconContainer)`
  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover circle {
    fill: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
    transition: fill linear 0.2s;
  }

  & > svg:active circle {
    fill: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
    transition: fill linear 0.2s;
  }
`;
const $9e4810506b6e896c$var$Menu = (0, $lmFrL.default).nav`
  background: ${({ theme: theme })=>theme.newColors.grayscale.white};
  border-radius: 0.5rem;
  position: absolute;
  top: 46px;
  right: 0;
  width: 240px;
  box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.basicInside};
  border: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  z-index: 10;

  & ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  & li {
    padding: 0.8rem;
    display: flex;
    align-items: center;
    line-height: 1rem;
    gap: 6px;
    cursor: pointer;
    transition: 200ms;
  }

  & li > p {
    margin: 0;
    padding-top: 2px;
    line-height: 22px;
    white-space: nowrap;
  }

  & li:hover {
    background-color: ${({ theme: theme })=>theme.newColors.primary.lightTint};
    transition: 200ms;
  }

  & li:active {
    background-color: ${({ theme: theme })=>theme.newColors.primary.lightestTint};
    transition: 200ms;
  }

  & li:first-of-type:hover {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  & li:last-of-type:hover {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  ${({ isMenuOpen: isMenuOpen })=>isMenuOpen && (0, $lmFrL.css)`
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    `}
`;
const $9e4810506b6e896c$var$MenuLiItem = (0, $lmFrL.default).li`
  display: flex;
  align-items: center;
`;



var $lmFrL = parcelRequire("lmFrL");

var $b53943ce0d0e00e3$export$2e2bcd8739ae039 = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Heading))`
  font-size: ${(p)=>p.theme.fontSizes[5]};
`;


const $193714fcc8f30367$export$8b251419efc915eb = ({ pageTitle: pageTitle })=>{
    return /*#__PURE__*/ $acw62.createElement($193714fcc8f30367$var$StyledHeader, null, /*#__PURE__*/ $acw62.createElement($193714fcc8f30367$var$Content, null, /*#__PURE__*/ $acw62.createElement((0, $781e22e9ef9a0015$exports.Box), null, /*#__PURE__*/ $acw62.createElement((0, $1090c52da2338f2e$export$2dc68d50d56fbbd), null), /*#__PURE__*/ $acw62.createElement((0, $b53943ce0d0e00e3$export$2e2bcd8739ae039), null, pageTitle)), /*#__PURE__*/ $acw62.createElement((0, $9e4810506b6e896c$export$e213cebad6250b4a), null)));
};
const $193714fcc8f30367$var$StyledHeader = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
  min-height: 96px;
`;
const $193714fcc8f30367$var$Content = (0, $lmFrL.default)((0, $0ae05e0bf2c3dc8f$export$844f199b4427ce36))`
  display: flex;
  justify-content: space-between;
  margin-top: ${(p)=>p.theme.space[4]};
  padding-top: 0;
  padding-bottom: 0;

  @media screen and (max-width: 650px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 1.5rem;
  }
`;




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



/* eslint-disable react/jsx-wrap-multilines */ 
var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

const $ca1f34f7886ab6de$export$3cf71fded898499e = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: "2",
        height: "24",
        rx: "1",
        fill: color
    }));
};
$ca1f34f7886ab6de$export$3cf71fded898499e.defaultProps = {
    width: "2",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
};


const $6de631329bccb57b$var$Container = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Flex))`
  width: ${({ isSideBarOpen: isSideBarOpen })=>isSideBarOpen ? "184px" : "72px"};
  height: 40px;
  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled: disabled })=>disabled ? 0.5 : 1};

  &:hover {
    background: ${({ disabled: disabled })=>disabled ? "transparent" : "rgba(255, 255, 255, 0.05)"};
  }
`;
const $6de631329bccb57b$var$ContentContainer = (0, $lmFrL.default).div`
  display: flex;
  margin-left: ${({ isActive: isActive })=>isActive ? "24px" : "26px"};
  justify-content: center;
  align-items: center;

  font-weight: ${({ isActive: isActive })=>isActive ? "800" : "normal"};
  font-size: 16px;
  line-height: 24px;
  color: ${({ isActive: isActive, disabled: disabled })=>{
    if (isActive) return "#FFFFFF";
    if (disabled) return "#4A5568";
    return "#6E7D92";
}};
`;
const $6de631329bccb57b$var$IconContainer = (0, $lmFrL.default).div`
  display: flex;
  margin: 0 18px 0 0;

  // & > svg:hover,
  // & > svg > path:hover {
  //   fill: ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
  // }
`;
const $6de631329bccb57b$var$NameContainer = (0, $lmFrL.default).div``;
const $6de631329bccb57b$var$Indicator = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
const $6de631329bccb57b$export$cb10f9a9aa43f8bc = (props)=>{
    const { icon: icon, name: name, isActive: isActive, onClick: onClick, isSideBarOpen: isSideBarOpen, disabled: disabled } = props;
    const effectiveIsActive = isActive && !disabled;
    const handleClick = ()=>{
        if (!disabled && onClick) onClick();
    };
    return /*#__PURE__*/ $acw62.createElement($6de631329bccb57b$var$Container, {
        onClick: handleClick,
        isSideBarOpen: isSideBarOpen,
        disabled: disabled
    }, effectiveIsActive && /*#__PURE__*/ $acw62.createElement($6de631329bccb57b$var$Indicator, null, /*#__PURE__*/ $acw62.createElement((0, $ca1f34f7886ab6de$export$3cf71fded898499e), null)), /*#__PURE__*/ $acw62.createElement($6de631329bccb57b$var$ContentContainer, {
        isActive: effectiveIsActive,
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement($6de631329bccb57b$var$IconContainer, null, icon), isSideBarOpen && /*#__PURE__*/ $acw62.createElement($6de631329bccb57b$var$NameContainer, null, name)));
};



var $acw62 = parcelRequire("acw62");

const $26fe7c40940b2a65$export$5ed3e1bb3b04fc02 = (props)=>{
    const { width: width, height: height, isActive: isActive } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 18V18C3.34315 18 2 16.6569 2 15V5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V5",
        stroke: isActive ? "white" : "#6E7D92",
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 10C7 8.34315 8.34315 7 10 7H20C21.6569 7 23 8.34315 23 10V20C23 21.6569 21.6569 23 20 23H10C8.34315 23 7 21.6569 7 20V10Z",
        fill: isActive ? "white" : "#6E7D92"
    }));
};
$26fe7c40940b2a65$export$5ed3e1bb3b04fc02.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $3250d42fbce16cfa$export$d075c269628f45f8 = (props)=>{
    const { width: width, height: height, color: color, isActive: isActive } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19Z",
        stroke: isActive ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white : color,
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 6C12.5523 6 13 6.44772 13 7V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V7C11 6.44772 11.4477 6 12 6ZM8 14C8.55228 14 9 14.4477 9 15V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V15C7 14.4477 7.44772 14 8 14ZM17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11V17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17V11Z",
        fill: isActive ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white : color
    }));
};
$3250d42fbce16cfa$export$d075c269628f45f8.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $524aa20843ad8739$export$e04e17a44f37debc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    get selectedEntity () {
        throw new Error("ActionContext not defined");
    },
    setSelectedEntity () {
        throw new Error("ActionContext not defined");
    },
    saveCurrentSelectedEntityAndSet () {
        throw new Error("ActionContext not defined");
    },
    returnToPreviousSelectedEntity () {
        throw new Error("ActionContext not defined");
    },
    get selectedWorkflowIndex () {
        throw new Error("ActionContext not defined");
    },
    setSelectedWorkflowIndex () {
        throw new Error("ActionContext not defined");
    },
    get openedSampleGroup () {
        throw new Error("ActionContext not defined");
    },
    setOpenedSampleGroup () {
        throw new Error("ActionContext not defined");
    },
    get elementOnDragAction () {
        throw new Error("ActionContext not defined");
    },
    setElementOnDragAction () {
        throw new Error("ActionContext not defined");
    },
    get droppedElementCoordinates () {
        throw new Error("ActionContext not defined");
    },
    setDroppedElementCoordinates () {
        throw new Error("ActionContext not defined");
    }
});
const $524aa20843ad8739$export$ede2be63923d531e = ({ children: children, defaultSelectedEntity: defaultSelectedEntity })=>{
    const [selectedEntity, setSelectedEntity] = (0, $acw62.useState)(defaultSelectedEntity);
    const [selectedWorkflowIndex, setSelectedWorkflowIndex] = (0, $acw62.useState)(0);
    const [openedSampleGroup, setOpenedSampleGroup] = (0, $acw62.useState)(0);
    const [elementOnDragAction, setElementOnDragAction] = (0, $acw62.useState)(null);
    const [droppedElementCoordinates, setDroppedElementCoordinates] = (0, $acw62.useState)({
        date: new Date(),
        baseline: 0
    });
    const saveCurrentSelectedEntityAndSet = (newEntity)=>{
        if (newEntity) setSelectedEntity((currentEntity)=>({
                selectedElementType: newEntity.selectedElementType,
                selectedElementPath: newEntity.selectedElementPath,
                previousSelectedEntity: currentEntity
            }));
        else setSelectedEntity(undefined);
    };
    const returnToPreviousSelectedEntity = (alternativeEntity)=>{
        const entity = selectedEntity && selectedEntity.previousSelectedEntity ? selectedEntity.previousSelectedEntity : alternativeEntity;
        if (entity) {
            const e = {
                selectedElementType: entity.selectedElementType,
                selectedElementPath: entity.selectedElementPath
            };
            setSelectedEntity(e);
            return e;
        }
        setSelectedEntity(undefined);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($524aa20843ad8739$export$e04e17a44f37debc.Provider, {
        value: {
            selectedEntity: selectedEntity,
            setSelectedEntity: setSelectedEntity,
            saveCurrentSelectedEntityAndSet: saveCurrentSelectedEntityAndSet,
            returnToPreviousSelectedEntity: returnToPreviousSelectedEntity,
            selectedWorkflowIndex: selectedWorkflowIndex,
            setSelectedWorkflowIndex: setSelectedWorkflowIndex,
            openedSampleGroup: openedSampleGroup,
            setOpenedSampleGroup: setOpenedSampleGroup,
            elementOnDragAction: elementOnDragAction,
            setElementOnDragAction: setElementOnDragAction,
            droppedElementCoordinates: droppedElementCoordinates,
            setDroppedElementCoordinates: setDroppedElementCoordinates
        }
    }, children);
};


const $17ab349cbe2df1af$export$e94ddc405c82c3a0 = ()=>{
    const context = (0, $acw62.useContext)((0, $524aa20843ad8739$export$e04e17a44f37debc));
    if (context === undefined) throw new Error("ActionContext not defined");
    return context;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $752f8ea6cb0f30bd$export$79fbc94f0714b676 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    get sideBarOpen () {
        throw new Error("SideBarsContext not defined");
    },
    setSideBarOpen (open) {
        throw new Error("SideBarsContext not defined");
    },
    get sideDrawboardOpen () {
        throw new Error("SideBarsContext not defined");
    },
    setSideDrawboardOpen (open) {
        throw new Error("SideBarsContext not defined");
    },
    get navBarOpen () {
        throw new Error("SideBarsContext not defined");
    },
    setNavBarOpen (open) {
        throw new Error("SideBarsContext not defined");
    }
});
const $752f8ea6cb0f30bd$export$3a193063917ea516 = ({ children: children, isSideBarOpen: isSideBarOpen, isSideDrawboardOpen: isSideDrawboardOpen, isNavBarOpen: isNavBarOpen })=>{
    const [sideBarOpen, setSideBarOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isSideBarOpen !== undefined ? isSideBarOpen : true);
    const [sideDrawboardOpen, setSideDrawboardOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isSideDrawboardOpen !== undefined ? isSideDrawboardOpen : false);
    const [navBarOpen, setNavBarOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isNavBarOpen !== undefined ? isNavBarOpen : true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($752f8ea6cb0f30bd$export$79fbc94f0714b676.Provider, {
        value: {
            sideBarOpen: sideBarOpen,
            setSideBarOpen: setSideBarOpen,
            sideDrawboardOpen: sideDrawboardOpen,
            setSideDrawboardOpen: setSideDrawboardOpen,
            navBarOpen: navBarOpen,
            setNavBarOpen: setNavBarOpen
        }
    }, children);
};


const $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa = ()=>{
    const context = $acw62.useContext((0, $752f8ea6cb0f30bd$export$79fbc94f0714b676));
    if (context === undefined) throw new Error("SideBarsContext not defined");
    return context;
};



var $acw62 = parcelRequire("acw62");

const $88431eef5cffd1f4$export$555bc9f86a2ce7af = (props)=>{
    const { width: width, height: height, isActive: isActive } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fill: isActive ? "white" : "#6E7D92",
        d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
    }));
};
$88431eef5cffd1f4$export$555bc9f86a2ce7af.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $e8e3ec3e2bb73bce$export$c3fd4b380d7a1c05 = (permission, roles = [], role)=>{
    let userRoles = [];
    if (role) userRoles = [
        role
    ];
    else {
        const data = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
        userRoles = data.user["https://leaderneplatform.com/roles"] || roles;
    }
    if (userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR) || userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR)) return true;
    const permissionsMap = {
        editField: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        editForm: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        deleteForm: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        duplicateTask: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        moveSubtask: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        deleteTasks: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        addNewSection: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        addNewProject: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        editServiceInformations: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
        ],
        manageUsers: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        addNewPath: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        goToProjectData: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
        ],
        addItemsToTimeline: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
        ],
        accessReports: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
        ],
        makeElementVisible: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        copyTaskToOtherPath: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        saveAsTemplate: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        seeBudget: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        seeTeam: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
        ],
        moveAllServicesToNewStartDate: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        projectDuplication: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ],
        useRegulatory: [
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).REGULATORY
        ]
    };
    const allowedRoles = permissionsMap[permission] || [];
    return allowedRoles.some((allowedRole)=>userRoles.includes(allowedRole));
};


const $43f95f7f55a6f076$export$2224d6567246fcb6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    useUserPermissions () {
        throw new Error("UserRolesContext not defined");
    }
});
const $43f95f7f55a6f076$export$925437b8addebb63 = ({ children: children, roles: roles })=>{
    const useUserPermissions = (permission, role)=>(0, $e8e3ec3e2bb73bce$export$c3fd4b380d7a1c05)(permission, roles, role);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($43f95f7f55a6f076$export$2224d6567246fcb6.Provider, {
        value: {
            useUserPermissions: useUserPermissions
        }
    }, children);
};


const $81af44909bdca59e$export$ba88e5bb9748875d = ()=>{
    const context = $acw62.useContext((0, $43f95f7f55a6f076$export$2224d6567246fcb6));
    if (context === undefined) throw new Error("UserRolesContext not defined");
    return context;
};



var $acw62 = parcelRequire("acw62");

const $bdd1f3df1301f13b$export$73aa151491d31e4f = (props)=>{
    const { width: width, height: height, color: color, isActive: isActive } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.35078 18L3.6247 21.7809C2.96993 22.3047 2 21.8385 2 21V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V15C22 16.6569 20.6569 18 19 18H8.35078ZM4 18.9194L7.37531 16.2191C7.55262 16.0773 7.77293 16 8 16H19C19.5523 16 20 15.5523 20 15V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V18.9194Z",
        fill: isActive ? "white" : color
    }));
};
$bdd1f3df1301f13b$export$73aa151491d31e4f.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $19859f7dc69153e6$export$560b0277c649ed6b = (props)=>{
    const { color: color, width: width, height: height, isActive: isActive } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: isActive ? "white" : color,
        d: "M19.105 21H4.895a1.78 1.78 0 01-1.339-.587A1.983 1.983 0 013 19V5c0-.55.185-1.021.556-1.413A1.78 1.78 0 014.895 3h14.21c.521 0 .968.196 1.339.587.37.392.556.863.556 1.413v14c0 .55-.185 1.021-.556 1.413a1.78 1.78 0 01-1.339.587zM4.895 8h14.21V5H4.895v3zm2.842 2H4.895v9h2.842v-9zm8.526 0v9h2.842v-9h-2.842zm-1.895 0H9.632v9h4.736v-9z"
    }));
};
$19859f7dc69153e6$export$560b0277c649ed6b.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray
};



var $acw62 = parcelRequire("acw62");

const $13f85ea00a6416c9$export$bb4d7813766e20d3 = (props)=>{
    const { width: width, height: height, isActive: isActive } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6ZM6 3C6.27614 3 6.5 3.22386 6.5 3.5C6.5 3.77614 6.27614 4 6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3ZM6.5 9V5H5.5V9H6.5Z",
        fill: isActive ? "white" : "#6E7D92"
    }));
};
$13f85ea00a6416c9$export$bb4d7813766e20d3.defaultProps = {
    width: "25",
    height: "25",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};


const $b37f6ac6325e6678$export$678648d9310d92a1 = (props)=>{
    const { isSideBarOpen: isSideBarOpen } = props;
    const location = (0, $66249767282b1118$export$45d76561a5302f2b)();
    const { setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const isActiveLink = (route)=>location.pathname.startsWith(route);
    const navigateToPage = (path)=>{
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(path);
        setSelectedEntity(undefined);
        setSideDrawboardOpen(false);
    };
    const manageUsersIsEnabled = useUserPermissions("manageUsers");
    const reportsAreEnabled = useUserPermissions("accessReports");
    const regulatoryIsEnabled = useUserPermissions("useRegulatory");
    const readonlyIsEnabled = useUserPermissions("readonly");
    return /*#__PURE__*/ $acw62.createElement($b37f6ac6325e6678$var$Container, null, /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Projects",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $26fe7c40940b2a65$export$5ed3e1bb3b04fc02), {
            isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS),
        isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS),
        disabled: !readonlyIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Reports",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $3250d42fbce16cfa$export$d075c269628f45f8), {
            isActive: reportsAreEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).REPORTS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).REPORTS),
        isActive: reportsAreEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).REPORTS),
        disabled: !reportsAreEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Regulatory",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $13f85ea00a6416c9$export$bb4d7813766e20d3), {
            isActive: regulatoryIsEnabled && location.pathname === (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY),
        isActive: regulatoryIsEnabled && location.pathname === (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY,
        disabled: !regulatoryIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "eCTD mapping",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $13f85ea00a6416c9$export$bb4d7813766e20d3), {
            isActive: regulatoryIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING),
        isActive: regulatoryIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING),
        disabled: !regulatoryIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Project Users",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $88431eef5cffd1f4$export$555bc9f86a2ce7af), {
            isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_TEAMS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_TEAMS),
        isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_TEAMS),
        disabled: !manageUsersIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Groups",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $88431eef5cffd1f4$export$555bc9f86a2ce7af), {
            isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_GROUPS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_GROUPS),
        isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_GROUPS),
        disabled: !manageUsersIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Users",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $88431eef5cffd1f4$export$555bc9f86a2ce7af), {
            isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_USERS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_USERS),
        isActive: manageUsersIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_USERS),
        disabled: !manageUsersIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Dashboard",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $bdd1f3df1301f13b$export$73aa151491d31e4f), {
            isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).DASHBOARD)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).DASHBOARD),
        isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).DASHBOARD),
        disabled: !readonlyIsEnabled
    }), /*#__PURE__*/ $acw62.createElement((0, $6de631329bccb57b$export$cb10f9a9aa43f8bc), {
        name: "Tasks",
        isSideBarOpen: isSideBarOpen,
        icon: /*#__PURE__*/ $acw62.createElement((0, $19859f7dc69153e6$export$560b0277c649ed6b), {
            isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).TASKS)
        }),
        onClick: ()=>navigateToPage((0, $de08facaa603a546$export$cd891b82501bb412).TASKS),
        isActive: readonlyIsEnabled && isActiveLink((0, $de08facaa603a546$export$cd891b82501bb412).TASKS),
        disabled: !readonlyIsEnabled
    }));
};
const $b37f6ac6325e6678$var$Container = (0, $lmFrL.default).div`
  & > div {
    margin-bottom: 8px;
  }
`;



var $acw62 = parcelRequire("acw62");

const $8ad5d98d28e20636$export$d3dc052aee88bdfc = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("filter", {
        id: "filter0_d",
        width: "40",
        height: "40",
        x: "-8",
        y: "-4",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.168627 0 0 0 0 0.45098 0 0 0 0 0.862745 0 0 0 0.3 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "currentLayer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        filter: "url(#filter0_d)",
        opacity: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        r: "12",
        fill: color,
        opacity: "1",
        transform: "matrix(-1 0 0 1 12 12)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#fff",
        strokeWidth: "2",
        d: "M10.074 16.036L14 11.963 9.926 8.038",
        className: "selected"
    })));
};
$8ad5d98d28e20636$export$d3dc052aee88bdfc.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

const $d819d56e4eee36d1$export$a84e507fd943d8f9 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: `0 0 ${width} ${height}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        filter: "url(#filter0_d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        r: "12",
        fill: color,
        transform: "matrix(-1 0 0 1 12 12)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#fff",
        strokeWidth: "2",
        d: "M14 8l-4 4 4 4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("filter", {
        id: "filter0_d",
        width: "40",
        height: "40",
        x: "-8",
        y: "-4",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.168627 0 0 0 0 0.45098 0 0 0 0 0.862745 0 0 0 0.3 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
    }))));
};
$d819d56e4eee36d1$export$a84e507fd943d8f9.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

const $187a1d35685f2479$export$51ce686201b12f73 = ({ width: width, height: height, color: color, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6321 24 24 18.6321 24 12C24 5.36791 18.6321 0 12 0C5.36791 0 0 5.36791 0 12C0 18.6321 5.36791 24 12 24ZM18.4767 5.13477C18.4572 6.28225 17.5431 7.17691 16.4151 7.17691H8.57715C8.5966 6.02942 9.5107 5.13477 10.6387 5.13477H18.4767ZM17.4068 10.9696C17.3873 12.0393 16.5899 12.9145 15.5397 13.0312H15.3258H9.91895L9.91895 13.0312C9.97729 12.7784 10.0356 12.5256 10.0551 12.2727V11.981C10.0551 11.8059 10.0551 11.6309 10.0162 11.4559C10.0162 11.2808 9.97729 11.1058 9.9384 10.9502H17.4068V10.9696ZM16.8235 18.8459C17.8348 18.7487 18.6323 17.8735 18.6323 16.8232H10.3859C9.37455 16.9399 8.57715 17.7957 8.57715 18.8459H16.8235ZM8.18825 11.086C8.30494 11.3778 8.36329 11.6889 8.36329 12.0001C8.36329 12.3697 8.28549 12.7003 8.14935 13.0309C7.76037 13.8867 6.88517 14.4701 5.89327 14.4701C5.75713 14.4701 5.62099 14.4507 5.5043 14.4312C4.5902 14.2951 3.83169 13.6533 3.53995 12.7586C3.44271 12.5058 3.40381 12.253 3.40381 11.9807C3.40381 11.7084 3.44271 11.4556 3.53995 11.2222C3.83169 10.347 4.59019 9.6857 5.52374 9.53011C5.64044 9.49121 5.77658 9.49121 5.89327 9.49121C6.90462 9.49121 7.76037 10.0941 8.14935 10.9499C8.14935 11.0082 8.1688 11.0666 8.18825 11.086Z",
        fill: color
    }));
};
$187a1d35685f2479$export$51ce686201b12f73.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};




const $893bf6ab15cfafd6$export$614264b7ca4804e6 = ()=>{
    const { sideBarOpen: sideBarOpen, setSideBarOpen: setSideBarOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const navigateToProjects = ()=>(0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/`);
    return /*#__PURE__*/ $acw62.createElement($893bf6ab15cfafd6$var$Container, {
        open: sideBarOpen
    }, /*#__PURE__*/ $acw62.createElement($893bf6ab15cfafd6$var$LogoContainer, null, sideBarOpen ? /*#__PURE__*/ $acw62.createElement((0, $4a8ee0766077991c$export$8eea0721e4ba542), {
        onClick: navigateToProjects
    }) : /*#__PURE__*/ $acw62.createElement((0, $187a1d35685f2479$export$51ce686201b12f73), {
        onClick: navigateToProjects
    })), /*#__PURE__*/ $acw62.createElement($893bf6ab15cfafd6$var$MenuContainer, null, /*#__PURE__*/ $acw62.createElement((0, $b37f6ac6325e6678$export$678648d9310d92a1), {
        isSideBarOpen: sideBarOpen
    })), /*#__PURE__*/ $acw62.createElement($893bf6ab15cfafd6$var$IconContainer, {
        onClick: ()=>setSideBarOpen(!sideBarOpen),
        open: sideBarOpen
    }, sideBarOpen ? /*#__PURE__*/ $acw62.createElement((0, $d819d56e4eee36d1$export$a84e507fd943d8f9), null) : /*#__PURE__*/ $acw62.createElement((0, $8ad5d98d28e20636$export$d3dc052aee88bdfc), null)));
};
const $893bf6ab15cfafd6$var$Container = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: ${({ open: open })=>open ? "184px" : "72px"};
  min-width: ${({ open: open })=>open ? "184px" : "72px"};
  background-color: ${(p)=>p.theme.newColors.grayscale.primaryGray};
  flex-direction: column;
`;
const $893bf6ab15cfafd6$var$LogoContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  height: 120px;
  width: 100%;
  padding: 24px;
  text-align: center;

  svg {
    cursor: pointer;
  }
`;
const $893bf6ab15cfafd6$var$MenuContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  padding: 14px 0;
  width: 100%;
  color: ${({ theme: theme })=>theme.newColors.grayscale.white};
`;
const $893bf6ab15cfafd6$var$IconContainer = (0, $lmFrL.default).div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  top: 7.5rem;
  left: ${({ open: open })=>open ? "184px" : "72px"};
  position: absolute;
  margin-left: -0.8rem;
  border-radius: 50%;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.icons.expandIcon};
  z-index: 1;

  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover circle {
    fill: ${({ theme: theme })=>theme.newColors.primary.hover};
    transition: fill linear 0.2s;
  }

  & > svg:active circle {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.darkestTint};
    transition: fill linear 0.2s;
  }
`;


const $9a13939e608956ea$export$c14a569fae7175e4 = ({ children: children, pageTitle: pageTitle = "Welcome", tabs: tabs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9a13939e608956ea$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $893bf6ab15cfafd6$export$614264b7ca4804e6), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9a13939e608956ea$var$Main, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $193714fcc8f30367$export$8b251419efc915eb), {
        pageTitle: pageTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9a13939e608956ea$var$NavWrapper, null, tabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9a13939e608956ea$var$NavigationTabs, null, tabs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9a13939e608956ea$var$Content, {
        id: "children"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0ae05e0bf2c3dc8f$export$844f199b4427ce36), null, children))));
const $9a13939e608956ea$var$Wrapper = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  min-height: 100vh;
`;
const $9a13939e608956ea$var$NavWrapper = (0, $lmFrL.default).div`
  min-height: 36px;
  width: 100%;
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $9a13939e608956ea$var$NavigationTabs = (0, $lmFrL.default).div`
  margin: 0 auto;
  width: 100%;
  max-width: ${(p)=>p.theme.maxContentWidth};
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $9a13939e608956ea$var$Main = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: 100%;
  flex-direction: column;
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;
const $9a13939e608956ea$var$Content = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
  padding-top: ${(p)=>p.theme.space[4]};
`;



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $ffbf813e52b3912b$export$e1b1697635938ab5 = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 2.5H7.5V7.5H2.5V2.5ZM0.5 0.5H2.5H7.5H9.5V2.5V7.5V9.5H7.5H2.5H0.5V7.5V2.5V0.5ZM2.5 14.5H7.5V19.5H2.5V14.5ZM0.5 12.5H2.5H7.5H9.5V14.5V19.5V21.5H7.5H2.5H0.5V19.5V14.5V12.5ZM19.5 14.5H14.5V19.5H19.5V14.5ZM14.5 12.5H12.5V14.5V19.5V21.5H14.5H19.5H21.5V19.5V14.5V12.5H19.5H14.5ZM14.5 2.5H19.5V7.5H14.5V2.5ZM12.5 0.5H14.5H19.5H21.5V2.5V7.5V9.5H19.5H14.5H12.5V7.5V2.5V0.5Z",
        fill: color
    }));
};
$ffbf813e52b3912b$export$e1b1697635938ab5.defaultProps = {
    width: "22",
    height: "22",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $111173b23fd5caa5$export$edd56132b15efcf6 = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.875 13C17.4963 13 18 13.5596 18 14.25C18 14.9403 17.4963 15.5 16.875 15.5H1.125C0.50368 15.5 0 14.9403 0 14.25C0 13.5596 0.50368 13 1.125 13H16.875ZM16.875 6.74999C17.4963 6.74999 18 7.30964 18 7.99999C18 8.69035 17.4963 9.24999 16.875 9.24999H1.125C0.50368 9.24999 0 8.69035 0 7.99999C0 7.30964 0.50368 6.74999 1.125 6.74999H16.875ZM16.875 0.5C17.4963 0.5 18 1.05964 18 1.75C18 2.44036 17.4963 3 16.875 3H1.125C0.50368 3 0 2.44036 0 1.75C0 1.05964 0.50368 0.5 1.125 0.5H16.875Z",
        fill: color
    }));
};
$111173b23fd5caa5$export$edd56132b15efcf6.defaultProps = {
    width: "18",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText
};




const $d241d256ce3eb5d1$export$4fb75e6b75cdeeea = (props)=>{
    const { projectsNumber: projectsNumber, selectedView: selectedView } = props;
    // const svgString = encodeURIComponent(renderToStaticMarkup(<SearchIcon />));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$Header, null, "Projects (", projectsNumber, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$ViewModeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$LinkContainer, {
        onClick: ()=>(0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffbf813e52b3912b$export$e1b1697635938ab5), {
        color: selectedView === "grid" ? "#4979CB" : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$VerticalLine, {
        margin: 11
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d241d256ce3eb5d1$var$LinkContainer, {
        onClick: ()=>(0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).LIST_OF_PROJECTS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $111173b23fd5caa5$export$edd56132b15efcf6), {
        color: selectedView === "list" ? "#4979CB" : undefined
    })))));
};
$d241d256ce3eb5d1$export$4fb75e6b75cdeeea.defaultProps = {
    projectsNumber: 0
};
const $d241d256ce3eb5d1$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;
const $d241d256ce3eb5d1$var$Header = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
`;
const $d241d256ce3eb5d1$var$ActionsContainer = (0, $lmFrL.default).div`
  display: flex;

  input {
    border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
    width: 329px;
  }
`;
//
// const SortContainer = styled.div`
//   background: ${styledTheme.newColors.grayscale.white};
//   border: 1px solid ${styledTheme.newColors.grayscale.bordersOutside};
//   box-sizing: border-box;
//   border-radius: 4px;
//   padding: 14px;
//   display: flex;
//   align-items: center;
//   margin-right: 8px;
//
//   font-family: Overpass;
//   font-style: normal;
//   font-weight: 800;
//   font-size: 16px;
//   line-height: 24px;
//   text-transform: uppercase;
//   color: ${styledTheme.newColors.grayscale.primaryGray};
//
//   svg {
//     margin-top: -2px;
//     margin-right: 12px;
//   }
// `;
//
// const FilterContainer = styled.div`
//   background: ${styledTheme.newColors.grayscale.white};
//   border: 1px solid ${styledTheme.newColors.grayscale.bordersOutside};
//   box-sizing: border-box;
//   border-radius: 4px;
//   padding: 14px;
//   display: flex;
//   align-items: center;
//
//   font-family: Overpass;
//   font-style: normal;
//   font-weight: bold;
//   font-size: 16px;
//   line-height: 24px;
//   text-transform: uppercase;
//   color: #141419;
//
//   svg {
//     margin-top: -2px;
//     margin-right: 11px;
//   }
// `;
const $d241d256ce3eb5d1$var$ViewModeContainer = (0, $lmFrL.default).div`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px 14px 12px 14px;
  display: flex;
  align-items: center;
`;
const $d241d256ce3eb5d1$var$LinkContainer = (0, $lmFrL.default).span`
  cursor: pointer;
`;
const $d241d256ce3eb5d1$var$VerticalLine = (0, $lmFrL.default).div`
  font-size: 1px;
  width: 1px;
  height: 24px;
  background-color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  margin-left: ${({ margin: margin })=>margin}px;
  margin-right: ${({ margin: margin })=>margin}px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");
const $a839008f694b84b4$export$e36ab27f09d0f862 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 5.00037H13",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.1429 2.60013H1.85714C1.384 2.60013 1 2.95854 1 3.40015V12.2004C1 12.6421 1.384 13.0005 1.85714 13.0005H12.1429C12.616 13.0005 13 12.6421 13 12.2004V3.40015C13 2.95854 12.616 2.60013 12.1429 2.60013Z",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.57123 1V2.60005",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.4283 1V2.60005",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 1V2.60005",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "square"
    }));
};
$a839008f694b84b4$export$e36ab27f09d0f862.defaultProps = {
    width: "14",
    height: "14",
    color: "#6E7D92"
};




var $acw62 = parcelRequire("acw62");

const $0a739990c1675c9d$export$2ad141e9e3d81b82 = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.5 8.75V6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967L5.96967 0.71967C6.26256 0.426777 6.73744 0.426777 7.03033 0.71967L9.28033 2.96967C9.57322 3.26256 9.57322 3.73744 9.28033 4.03033L4.03033 9.28033C3.88968 9.42098 3.69891 9.5 3.5 9.5H1.25C0.835786 9.5 0.5 9.16421 0.5 8.75ZM6.5 2.3107L2 6.8107V8.00004H3.18934L7.68934 3.50004L6.5 2.3107Z",
        fill: color
    }));
};
$0a739990c1675c9d$export$2ad141e9e3d81b82.defaultProps = {
    width: "10",
    height: "10",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};


const $101f8b71a8c9f73f$export$a27b844eb741593c = (props)=>{
    const { name: name, lastActivity: lastActivity, projectId: projectId } = props;
    const handleEditIcon = (event)=>{
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`projects/${projectId}/configurator`);
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$NameContainer, null, name, name !== "Add a new project" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$EditIconContainer, {
        onClick: handleEditIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a739990c1675c9d$export$2ad141e9e3d81b82), {
        width: 14,
        height: 12,
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
    })) : null), lastActivity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$TimeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a839008f694b84b4$export$e36ab27f09d0f862), null), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$LastActivityTitle, null, "LAST ACTIVITY:"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($101f8b71a8c9f73f$var$LastActivityValue, null, lastActivity)) : null);
};
const $101f8b71a8c9f73f$var$EditIconContainer = (0, $lmFrL.default).div`
  display: inline-block;
  margin: 0 10px;
`;
const $101f8b71a8c9f73f$var$Container = (0, $lmFrL.default).div``;
const $101f8b71a8c9f73f$var$NameContainer = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #141419;
  margin-bottom: 4px;
`;
const $101f8b71a8c9f73f$var$TimeContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;

  svg {secondaryGray
    margin-top: -2px;
  }
`;
const $101f8b71a8c9f73f$var$LastActivityTitle = (0, $lmFrL.default).span`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
  padding-left: 6px;
`;
const $101f8b71a8c9f73f$var$LastActivityValue = (0, $lmFrL.default).span`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-decoration-line: underline;
  letter-spacing: -0.01em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  padding-left: 4px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $e6abd5a05d076ad5$export$5b6c8e359d4618aa = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color, secondColor: secondColor, onClick: onClick, className: className, id: id } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        id: id,
        x: x,
        y: y,
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("g", {
        clipPath: "url(#clipChain)"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.1549 8.00876C10.1581 6.91776 9.56731 5.90475 8.52609 5.20043C8.84365 4.93466 9.11217 4.63212 9.31692 4.30583C9.63476 3.79941 9.80274 3.23262 9.80274 2.66675H9.17843C9.17843 2.92176 9.1365 3.17227 9.05609 3.41384H6.90253C6.82212 3.17229 6.78019 2.92176 6.78019 2.66675H6.15588C6.15588 3.23262 6.32386 3.79941 6.64169 4.30583C6.84645 4.6321 7.11496 4.93464 7.43255 5.20043C6.39135 5.90475 5.8005 6.91774 5.80372 8.00876C5.80693 9.09433 6.39707 10.1 7.43215 10.8C7.11823 11.0628 6.85236 11.3614 6.64854 11.6835C6.32625 12.1928 6.1559 12.7634 6.1559 13.3334H6.78021C6.78021 13.0862 6.81964 12.8433 6.89512 12.6088H9.06356C9.13904 12.8433 9.17847 13.0862 9.17847 13.3334H9.80278C9.80278 12.7634 9.63243 12.1928 9.31014 11.6835C9.10632 11.3614 8.84045 11.0628 8.52653 10.8C9.56157 10.1 10.1517 9.09433 10.1549 8.00876ZM6.44932 8.31224H9.50929C9.47725 8.55022 9.40895 8.7824 9.30654 9.00487H6.6521C6.54969 8.7824 6.48137 8.55022 6.44932 8.31224ZM9.50934 7.68793H6.44928C6.48135 7.45004 6.54952 7.21782 6.65202 6.9953H9.3066C9.40909 7.21782 9.47727 7.45004 9.50934 7.68793ZM8.74859 4.03815C8.55323 4.33172 8.29455 4.60215 7.97932 4.83874C7.66408 4.60215 7.40541 4.33174 7.21004 4.03815H8.74859ZM7.94361 5.61349L7.97932 5.59168L8.01505 5.61351C8.37153 5.83127 8.67147 6.08757 8.90819 6.37099H7.05043C7.28715 6.08755 7.58711 5.83125 7.94361 5.61349ZM7.19479 11.9845C7.39186 11.6821 7.65572 11.4038 7.97932 11.1611C8.30292 11.4038 8.56677 11.6821 8.76385 11.9845H7.19479ZM7.99426 10.3995C7.98922 10.4025 7.98433 10.4057 7.97932 10.4088C7.9743 10.4057 7.96941 10.4025 7.96436 10.3995C7.59861 10.179 7.29127 9.91829 7.04989 9.6292H8.90873C8.66735 9.91827 8.36 10.179 7.99426 10.3995Z",
        fill: secondColor
    })), /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: "clipChain"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: "10.6667",
        height: "10.6667",
        fill: color,
        transform: "translate(2.66663 2.66675)"
    }))));
};
$e6abd5a05d076ad5$export$5b6c8e359d4618aa.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
    secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background
};



const $f7af627254c90ada$export$a522ceaa9e4a21ee = (props)=>{
    const { name: name, sampleName: sampleName, remaining: remaining } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7af627254c90ada$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7af627254c90ada$var$ChainIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
        color: "#141419",
        secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
        width: "16px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7af627254c90ada$var$NameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7af627254c90ada$var$Name, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7af627254c90ada$var$Info, null, sampleName, " \u2022 ", remaining)));
};
const $f7af627254c90ada$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding-left: 5px;
`;
const $f7af627254c90ada$var$NameContainer = (0, $lmFrL.default).div`
  margin-left: 8px;
`;
const $f7af627254c90ada$var$ChainIconContainer = (0, $lmFrL.default).div`
  padding: 0;
  font-size: 1px;
  transform: scale(1.4);
`;
const $f7af627254c90ada$var$Name = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};
`;
const $f7af627254c90ada$var$Info = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
`;



var $acw62 = parcelRequire("acw62");

const $3dd9f433765cfde8$export$e2391d0682fa90d6 = ({ width: width, height: height, color: color, secondColor: secondColor, thirdColor: thirdColor })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 4C0 1.79086 1.79086 0 4 0H40C42.2091 0 44 1.79086 44 4V40C44 42.2091 42.2091 44 40 44H4C1.79086 44 0 42.2091 0 40V4Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1104 36.6669V31.778L30.3628 18.5255C31.1439 17.7445 32.4102 17.7445 33.1912 18.5255L36.0801 21.4144C36.4552 21.7895 36.6659 22.2982 36.6659 22.8286V34.6669C36.6659 35.7715 35.7705 36.6669 34.6659 36.6669H17.1104Z",
        fill: secondColor
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.2219 17.1113C14.9218 17.1113 17.1108 14.9223 17.1108 12.2224C17.1108 9.5225 14.9218 7.3335 12.2219 7.3335C9.52201 7.3335 7.33301 9.5225 7.33301 12.2224C7.33301 14.9223 9.52201 17.1113 12.2219 17.1113ZM9.04011 34.9597C8.41015 35.5897 8.85632 36.6668 9.74722 36.6668H26.8886L18.525 28.3033C17.7439 27.5222 16.4776 27.5222 15.6966 28.3033L9.04011 34.9597Z",
        fill: thirdColor
    }));
};
$3dd9f433765cfde8$export$e2391d0682fa90d6.defaultProps = {
    width: "44",
    height: "44",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText,
    secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.gray05,
    thirdColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



const $0088b6913e751ef0$export$b3ae466e79cecc68 = (props)=>{
    const { projectName: projectName, projectLastActivity: projectLastActivity, currentService: currentService, onClick: onClick, projectId: projectId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0088b6913e751ef0$var$Container, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3dd9f433765cfde8$export$e2391d0682fa90d6), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $101f8b71a8c9f73f$export$a27b844eb741593c), {
        name: projectName,
        lastActivity: projectLastActivity,
        projectId: projectId
    }), currentService && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0088b6913e751ef0$var$ServiceStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7af627254c90ada$export$a522ceaa9e4a21ee), {
        name: currentService.serviceName,
        sampleName: currentService.sampleName,
        remaining: `${currentService.weekRemaining}w remaining`
    })));
};
$0088b6913e751ef0$export$b3ae466e79cecc68.defaultProps = {
    onClick: ()=>{}
};
const $0088b6913e751ef0$var$Container = (0, $lmFrL.default).div`
  width: 276px;
  padding: 24px;
  cursor: pointer;

  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.dropShadows.formCard};
  border-radius: 8px;

  > svg {
    margin-bottom: 16px;
  }
`;
const $0088b6913e751ef0$var$ServiceStatusContainer = (0, $lmFrL.default).div`
  margin-top: 20px;
  padding: 12px;
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 4px;
`;






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $a99dedb3f5818329$export$259db00ced016071 = (props)=>{
    const { onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a99dedb3f5818329$var$Container, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a99dedb3f5818329$var$PlusContainer, null, "+"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $101f8b71a8c9f73f$export$a27b844eb741593c), {
        name: "Add a new project"
    }));
};
$a99dedb3f5818329$export$259db00ced016071.defaultProps = {
    onClick: ()=>{}
};
const $a99dedb3f5818329$var$Container = (0, $lmFrL.default).div`
  width: 276px;
  padding: 24px;
  cursor: pointer;

  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.dropShadows.formCard};
  border-radius: 8px;
  text-align: center;
`;
const $a99dedb3f5818329$var$PlusContainer = (0, $lmFrL.default).span`
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray};
  font-size: 80pt;
`; // const ServiceStatusContainer = styled.div`
 //   margin-top: 20px;
 //   padding: 12px;
 //   border: 1px solid ${styledTheme.newColors.grayscale.bordersInside};
 //   box-sizing: border-box;
 //   border-radius: 4px;
 // `;


var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, 'create');
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, 'Map');
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8d50e526a9e9b7fa$exports,
        'map': new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        'string': new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype['delete'] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


const $30737cddea16cf18$export$2cd058184eb75757 = (project)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(project, "selectedQuestionGroups[0].questionSets[0].questions[0].answer.textBody", project.name);
};





const $41f1419b296329a4$export$ca6fbb51b35e375c = (_props)=>{
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const userRoles = user?.["https://leaderneplatform.com/roles"] || [];
    const hasFullAccessRole = userRoles.some((role)=>[
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR,
            (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
        ].includes(role));
    const shouldRedirectToRegulatory = !hasFullAccessRole && userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).REGULATORY);
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (shouldRedirectToRegulatory) (0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY);
    }, [
        shouldRedirectToRegulatory
    ]);
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)({
        skip: shouldRedirectToRegulatory
    });
    const newProjectMutation = (0, $7608a8bbcbbad14c$export$df57bd44e287f57c)()[0];
    if (shouldRedirectToRegulatory) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = data.Projects || [];
    const projectsNumber = projects.length;
    const createNewProject = async ()=>{
        setShowSpinner(true);
        newProjectMutation({
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$cd946050302ba91a),
                    variables: {}
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setShowSpinner(false);
        }).catch(()=>{
            setShowSpinner(false);
        });
    };
    const addNewProjectIsEnabled = useUserPermissions("addNewProject");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "All projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d241d256ce3eb5d1$export$4fb75e6b75cdeeea), {
        projectsNumber: projectsNumber,
        selectedView: "grid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41f1419b296329a4$var$ProjectsContainer, {
        id: "projects-container"
    }, projects.map((project)=>{
        const onClickLink = `/projects/${project.id}/timeline/samples/${project.samples[0].id}`;
        const projectLastActivityDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(project.lastActivity ? parseInt(project.lastActivity, 10) : undefined).format("Do MMMM YYYY");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0088b6913e751ef0$export$b3ae466e79cecc68), {
            key: project.id,
            projectId: project.id,
            projectLastActivity: projectLastActivityDateString,
            projectName: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            currentService: project.currentService,
            onClick: ()=>(0, $f125bbca2c654db8$export$ff7962acd6052c28)(onClickLink)
        });
    }), addNewProjectIsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a99dedb3f5818329$export$259db00ced016071), {
        onClick: createNewProject
    }) : null)));
};
const $41f1419b296329a4$var$ProjectsContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $92307008e8584b85$exports = {};
'use strict';
Object.defineProperty($92307008e8584b85$exports, "__esModule", {
    value: true
});
var $92307008e8584b85$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $92307008e8584b85$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $92307008e8584b85$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $92307008e8584b85$var$_react2 = $92307008e8584b85$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $92307008e8584b85$var$_propTypes2 = $92307008e8584b85$var$_interopRequireDefault($c9Z8w);

var $8g1PZ = parcelRequire("8g1PZ");
var $92307008e8584b85$var$_classnames2 = $92307008e8584b85$var$_interopRequireDefault($8g1PZ);
function $92307008e8584b85$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $92307008e8584b85$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $92307008e8584b85$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92307008e8584b85$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $92307008e8584b85$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $92307008e8584b85$var$ANIMATION_STATE_CLASSES = {
    animating: 'rah-animating',
    animatingUp: 'rah-animating--up',
    animatingDown: 'rah-animating--down',
    animatingToHeightZero: 'rah-animating--to-height-zero',
    animatingToHeightAuto: 'rah-animating--to-height-auto',
    animatingToHeightSpecific: 'rah-animating--to-height-specific',
    static: 'rah-static',
    staticHeightZero: 'rah-static--height-zero',
    staticHeightAuto: 'rah-static--height-auto',
    staticHeightSpecific: 'rah-static--height-specific'
};
var $92307008e8584b85$var$PROPS_TO_OMIT = [
    'animateOpacity',
    'animationStateClasses',
    'applyInlineTransitions',
    'children',
    'contentClassName',
    'delay',
    'duration',
    'easing',
    'height',
    'onAnimationEnd',
    'onAnimationStart'
];
function $92307008e8584b85$var$omit(obj) {
    for(var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keys[_key - 1] = arguments[_key];
    if (!keys.length) return obj;
    var res = {};
    var objectKeys = Object.keys(obj);
    for(var i = 0; i < objectKeys.length; i++){
        var key = objectKeys[i];
        if (keys.indexOf(key) === -1) res[key] = obj[key];
    }
    return res;
}
// Start animation helper using nested requestAnimationFrames
function $92307008e8584b85$var$startAnimationHelper(callback) {
    var requestAnimationFrameIDs = [];
    requestAnimationFrameIDs[0] = requestAnimationFrame(function() {
        requestAnimationFrameIDs[1] = requestAnimationFrame(function() {
            callback();
        });
    });
    return requestAnimationFrameIDs;
}
function $92307008e8584b85$var$cancelAnimationFrames(requestAnimationFrameIDs) {
    requestAnimationFrameIDs.forEach(function(id) {
        return cancelAnimationFrame(id);
    });
}
function $92307008e8584b85$var$isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $92307008e8584b85$var$isPercentage(height) {
    // Percentage height
    return typeof height === 'string' && height.search('%') === height.length - 1 && $92307008e8584b85$var$isNumber(height.substr(0, height.length - 1));
}
function $92307008e8584b85$var$runCallback(callback, params) {
    if (callback && typeof callback === 'function') callback(params);
}
var $92307008e8584b85$var$AnimateHeight = function(_React$Component) {
    $92307008e8584b85$var$_inherits(AnimateHeight, _React$Component);
    function AnimateHeight(props) {
        $92307008e8584b85$var$_classCallCheck(this, AnimateHeight);
        var _this = $92307008e8584b85$var$_possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));
        _this.animationFrameIDs = [];
        var height = 'auto';
        var overflow = 'visible';
        if ($92307008e8584b85$var$isNumber(props.height)) {
            // If value is string "0" make sure we convert it to number 0
            height = props.height < 0 || props.height === '0' ? 0 : props.height;
            overflow = 'hidden';
        } else if ($92307008e8584b85$var$isPercentage(props.height)) {
            // If value is string "0%" make sure we convert it to number 0
            height = props.height === '0%' ? 0 : props.height;
            overflow = 'hidden';
        }
        _this.animationStateClasses = $92307008e8584b85$var$_extends({}, $92307008e8584b85$var$ANIMATION_STATE_CLASSES, props.animationStateClasses);
        var animationStateClasses = _this.getStaticStateClasses(height);
        _this.state = {
            animationStateClasses: animationStateClasses,
            height: height,
            overflow: overflow,
            shouldUseTransitions: false
        };
        return _this;
    }
    $92307008e8584b85$var$_createClass(AnimateHeight, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var height = this.state.height;
                // Hide content if height is 0 (to prevent tabbing into it)
                // Check for contentElement is added cause this would fail in tests (react-test-renderer)
                // Read more here: https://github.com/Stanko/react-animate-height/issues/17
                if (this.contentElement && this.contentElement.style) this.hideContent(height);
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props = this.props, delay = _props.delay, duration = _props.duration, height = _props.height, onAnimationEnd = _props.onAnimationEnd, onAnimationStart = _props.onAnimationStart;
                // Check if 'height' prop has changed
                if (this.contentElement && height !== prevProps.height) {
                    var _cx;
                    // Remove display: none from the content div
                    // if it was hidden to prevent tabbing into it
                    this.showContent(prevState.height);
                    // Cache content height
                    this.contentElement.style.overflow = 'hidden';
                    var contentHeight = this.contentElement.offsetHeight;
                    this.contentElement.style.overflow = '';
                    // set total animation time
                    var totalDuration = duration + delay;
                    var newHeight = null;
                    var timeoutState = {
                        height: null,
                        overflow: 'hidden'
                    };
                    var isCurrentHeightAuto = prevState.height === 'auto';
                    if ($92307008e8584b85$var$isNumber(height)) {
                        // If value is string "0" make sure we convert it to number 0
                        newHeight = height < 0 || height === '0' ? 0 : height;
                        timeoutState.height = newHeight;
                    } else if ($92307008e8584b85$var$isPercentage(height)) {
                        // If value is string "0%" make sure we convert it to number 0
                        newHeight = height === '0%' ? 0 : height;
                        timeoutState.height = newHeight;
                    } else {
                        // If not, animate to content height
                        // and then reset to auto
                        newHeight = contentHeight; // TODO solve contentHeight = 0
                        timeoutState.height = 'auto';
                        timeoutState.overflow = null;
                    }
                    if (isCurrentHeightAuto) {
                        // This is the height to be animated to
                        timeoutState.height = newHeight;
                        // If previous height was 'auto'
                        // set starting height explicitly to be able to use transition
                        newHeight = contentHeight;
                    }
                    // Animation classes
                    var animationStateClasses = (0, $92307008e8584b85$var$_classnames2.default)((_cx = {}, $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animating, true), $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), $92307008e8584b85$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));
                    // Animation classes to be put after animation is complete
                    var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);
                    // Set starting height and animating classes
                    // We are safe to call set state as it will not trigger infinite loop
                    // because of the "height !== prevProps.height" check
                    this.setState({
                        animationStateClasses: animationStateClasses,
                        height: newHeight,
                        overflow: 'hidden',
                        // When animating from 'auto' we first need to set fixed height
                        // that change should be animated
                        shouldUseTransitions: !isCurrentHeightAuto
                    });
                    // Clear timeouts
                    clearTimeout(this.timeoutID);
                    clearTimeout(this.animationClassesTimeoutID);
                    if (isCurrentHeightAuto) {
                        // When animating from 'auto' we use a short timeout to start animation
                        // after setting fixed height above
                        timeoutState.shouldUseTransitions = true;
                        $92307008e8584b85$var$cancelAnimationFrames(this.animationFrameIDs);
                        this.animationFrameIDs = $92307008e8584b85$var$startAnimationHelper(function() {
                            _this2.setState(timeoutState);
                            // ANIMATION STARTS, run a callback if it exists
                            $92307008e8584b85$var$runCallback(onAnimationStart, {
                                newHeight: timeoutState.height
                            });
                        });
                        // Set static classes and remove transitions when animation ends
                        this.animationClassesTimeoutID = setTimeout(function() {
                            _this2.setState({
                                animationStateClasses: timeoutAnimationStateClasses,
                                shouldUseTransitions: false
                            });
                            // ANIMATION ENDS
                            // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(timeoutState.height);
                            // Run a callback if it exists
                            $92307008e8584b85$var$runCallback(onAnimationEnd, {
                                newHeight: timeoutState.height
                            });
                        }, totalDuration);
                    } else {
                        // ANIMATION STARTS, run a callback if it exists
                        $92307008e8584b85$var$runCallback(onAnimationStart, {
                            newHeight: newHeight
                        });
                        // Set end height, classes and remove transitions when animation is complete
                        this.timeoutID = setTimeout(function() {
                            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
                            timeoutState.shouldUseTransitions = false;
                            _this2.setState(timeoutState);
                            // ANIMATION ENDS
                            // If height is auto, don't hide the content
                            // (case when element is empty, therefore height is 0)
                            if (height !== 'auto') // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(newHeight); // TODO solve newHeight = 0
                            // Run a callback if it exists
                            $92307008e8584b85$var$runCallback(onAnimationEnd, {
                                newHeight: newHeight
                            });
                        }, totalDuration);
                    }
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                $92307008e8584b85$var$cancelAnimationFrames(this.animationFrameIDs);
                clearTimeout(this.timeoutID);
                clearTimeout(this.animationClassesTimeoutID);
                this.timeoutID = null;
                this.animationClassesTimeoutID = null;
                this.animationStateClasses = null;
            }
        },
        {
            key: 'showContent',
            value: function showContent(height) {
                if (height === 0) this.contentElement.style.display = '';
            }
        },
        {
            key: 'hideContent',
            value: function hideContent(newHeight) {
                if (newHeight === 0) this.contentElement.style.display = 'none';
            }
        },
        {
            key: 'getStaticStateClasses',
            value: function getStaticStateClasses(height) {
                var _cx2;
                return (0, $92307008e8584b85$var$_classnames2.default)((_cx2 = {}, $92307008e8584b85$var$_defineProperty(_cx2, this.animationStateClasses.static, true), $92307008e8584b85$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), $92307008e8584b85$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), $92307008e8584b85$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _cx3, _this3 = this;
                var _props2 = this.props, animateOpacity = _props2.animateOpacity, applyInlineTransitions = _props2.applyInlineTransitions, children = _props2.children, className = _props2.className, contentClassName = _props2.contentClassName, delay = _props2.delay, duration = _props2.duration, easing = _props2.easing, id = _props2.id, style = _props2.style;
                var _state = this.state, height = _state.height, overflow = _state.overflow, animationStateClasses = _state.animationStateClasses, shouldUseTransitions = _state.shouldUseTransitions;
                var componentStyle = $92307008e8584b85$var$_extends({}, style, {
                    height: height,
                    overflow: overflow || style.overflow
                });
                if (shouldUseTransitions && applyInlineTransitions) {
                    componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
                    // Include transition passed through styles
                    if (style.transition) componentStyle.transition = style.transition + ', ' + componentStyle.transition;
                    // Add webkit vendor prefix still used by opera, blackberry...
                    componentStyle.WebkitTransition = componentStyle.transition;
                }
                var contentStyle = {};
                if (animateOpacity) {
                    contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
                    // Add webkit vendor prefix still used by opera, blackberry...
                    contentStyle.WebkitTransition = contentStyle.transition;
                    if (height === 0) contentStyle.opacity = 0;
                }
                var componentClasses = (0, $92307008e8584b85$var$_classnames2.default)((_cx3 = {}, $92307008e8584b85$var$_defineProperty(_cx3, animationStateClasses, true), $92307008e8584b85$var$_defineProperty(_cx3, className, className), _cx3));
                // Check if user passed aria-hidden prop
                var hasAriaHiddenProp = typeof this.props['aria-hidden'] !== 'undefined';
                var ariaHidden = hasAriaHiddenProp ? this.props['aria-hidden'] : height === 0;
                return $92307008e8584b85$var$_react2.default.createElement('div', $92307008e8584b85$var$_extends({}, $92307008e8584b85$var$omit.apply(undefined, [
                    this.props
                ].concat($92307008e8584b85$var$PROPS_TO_OMIT)), {
                    'aria-hidden': ariaHidden,
                    className: componentClasses,
                    id: id,
                    style: componentStyle
                }), $92307008e8584b85$var$_react2.default.createElement('div', {
                    className: contentClassName,
                    style: contentStyle,
                    ref: function ref(el) {
                        return _this3.contentElement = el;
                    }
                }, children));
            }
        }
    ]);
    return AnimateHeight;
}($92307008e8584b85$var$_react2.default.Component);
var $92307008e8584b85$var$heightPropType = function heightPropType(props, propName, componentName) {
    var value = props[propName];
    if (typeof value === 'number' && value >= 0 || $92307008e8584b85$var$isPercentage(value) || value === 'auto') return null;
    return new TypeError('value "' + value + '" of type "' + (typeof value === 'undefined' ? 'undefined' : $92307008e8584b85$var$_typeof(value)) + '" is invalid type for ' + propName + ' in ' + componentName + '. ' + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
};
$92307008e8584b85$var$AnimateHeight.propTypes = {
    'aria-hidden': $92307008e8584b85$var$_propTypes2.default.bool,
    animateOpacity: $92307008e8584b85$var$_propTypes2.default.bool,
    animationStateClasses: $92307008e8584b85$var$_propTypes2.default.object,
    applyInlineTransitions: $92307008e8584b85$var$_propTypes2.default.bool,
    children: $92307008e8584b85$var$_propTypes2.default.any.isRequired,
    className: $92307008e8584b85$var$_propTypes2.default.string,
    contentClassName: $92307008e8584b85$var$_propTypes2.default.string,
    delay: $92307008e8584b85$var$_propTypes2.default.number,
    duration: $92307008e8584b85$var$_propTypes2.default.number,
    easing: $92307008e8584b85$var$_propTypes2.default.string,
    height: $92307008e8584b85$var$heightPropType,
    id: $92307008e8584b85$var$_propTypes2.default.string,
    onAnimationEnd: $92307008e8584b85$var$_propTypes2.default.func,
    onAnimationStart: $92307008e8584b85$var$_propTypes2.default.func,
    style: $92307008e8584b85$var$_propTypes2.default.object
};
$92307008e8584b85$var$AnimateHeight.defaultProps = {
    animateOpacity: false,
    animationStateClasses: $92307008e8584b85$var$ANIMATION_STATE_CLASSES,
    applyInlineTransitions: true,
    duration: 250,
    delay: 0,
    easing: 'ease',
    style: {}
};
$92307008e8584b85$exports.default = $92307008e8584b85$var$AnimateHeight;



var $acw62 = parcelRequire("acw62");

const $02e5d8dbcf160953$export$4857d3f3f5f8319b = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.16795 4.75192C3.56377 5.34566 4.43623 5.34566 4.83205 4.75192L6.96353 1.5547C7.40657 0.890145 6.93018 0 6.13148 0H1.86852C1.06982 0 0.59343 0.890145 1.03647 1.5547L3.16795 4.75192Z",
        fill: color
    }));
};
$02e5d8dbcf160953$export$4857d3f3f5f8319b.defaultProps = {
    width: "8",
    height: "6",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
};






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $73222a5d2c49b8c5$export$100cbaa565ba6879 = (props)=>{
    const { percent: percent, lineWidth: lineWidth, containerWidth: containerWidth, radius: radius, color: color } = props;
    const position = radius + lineWidth / 2;
    const containerSize = radius * 2 + lineWidth;
    const circumference = radius * 2 * Math.PI;
    const percentOffset = circumference - percent / 100 * circumference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73222a5d2c49b8c5$var$Container, {
        containerWidth: containerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73222a5d2c49b8c5$var$SvgContainer, {
        containerSize: containerSize,
        circumference: circumference,
        percentOffset: percentOffset,
        color: color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        strokeWidth: `${lineWidth}px`,
        fill: "transparent",
        r: `${radius}px`,
        cx: `${position}px`,
        cy: `${position}px`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        strokeWidth: `${lineWidth}px`,
        fill: "transparent",
        r: `${radius}px`,
        cx: `${position}px`,
        cy: `${position}px`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73222a5d2c49b8c5$var$PercentContainer, null, percent, "%"));
};
$73222a5d2c49b8c5$export$100cbaa565ba6879.defaultProps = {
    percent: 0,
    lineWidth: 3,
    containerWidth: 62,
    radius: 10,
    color: "#141418"
};
const $73222a5d2c49b8c5$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  width: ${({ containerWidth: containerWidth })=>containerWidth}px;
  min-width: ${({ containerWidth: containerWidth })=>containerWidth}px;
  justify-content: space-between;
`;
const $73222a5d2c49b8c5$var$SvgContainer = (0, $lmFrL.default).svg`
  width: ${(props)=>props.containerSize ? `${props.containerSize}px` : "unset"};
  height: ${(props)=>props.containerSize ? `${props.containerSize}px` : "unset"};

  circle:nth-child(1) {
    stroke: #eef1f5;
  }

  circle:nth-child(2) {
    stroke-dasharray: ${(props)=>`${props.circumference} ${props.circumference}`};
    stroke-dashoffset: ${(props)=>props.percentOffset};

    // axis compensation
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    stroke: ${({ color: color })=>color};
  }
`;
const $73222a5d2c49b8c5$var$PercentContainer = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};
`;



const $ceece09e37e97a76$export$52979a15abfe7e29 = (props)=>{
    const { name: name, percent: percent, icon: icon } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ceece09e37e97a76$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ceece09e37e97a76$var$NameContainer, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $73222a5d2c49b8c5$export$100cbaa565ba6879), {
        percent: percent
    }), icon !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ceece09e37e97a76$var$IconContainer, null, icon) : null);
};
const $ceece09e37e97a76$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
`;
const $ceece09e37e97a76$var$NameContainer = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 8px;
  border-right: 1px solid #dedede;
  margin-right: 10px;
  flex-grow: 1;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};
`;
const $ceece09e37e97a76$var$IconContainer = (0, $lmFrL.default).div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;



var $acw62 = parcelRequire("acw62");
const $5f2d89667ebbd7e2$export$51df23767fd20473 = (props)=>{
    const { color: color } = props;
    // eslint-disable-next-line radix
    const width = typeof props.width === "number" ? props.width : parseInt(props.width, 10);
    const height = 5 * width;
    const r = width / 2;
    const circleParams = [];
    const generateCircleParams = ()=>{
        let cy = r;
        for(let i = 1; i <= 3; i += 1){
            circleParams.push(cy);
            cy += width * 2;
        }
    };
    generateCircleParams();
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        fill: color,
        r: r,
        cx: r,
        cy: circleParams[0]
    }), /*#__PURE__*/ $acw62.createElement("circle", {
        fill: color,
        r: r,
        cx: r,
        cy: circleParams[1]
    }), /*#__PURE__*/ $acw62.createElement("circle", {
        fill: color,
        r: r,
        cx: r,
        cy: circleParams[2]
    }));
};
$5f2d89667ebbd7e2$export$51df23767fd20473.defaultProps = {
    width: "4",
    height: "0",
    color: "#9D9EA3"
};



const $4a481c221d5871b5$export$f07a8d48ec1fa3cd = (props)=>{
    const { id: id, name: name, percent: percent, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4a481c221d5871b5$var$Container, {
        onClick: ()=>onClick(id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceece09e37e97a76$export$52979a15abfe7e29), {
        name: name,
        percent: percent,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f2d89667ebbd7e2$export$51df23767fd20473), {
            color: "#9D9EA3"
        })
    }));
};
$4a481c221d5871b5$export$f07a8d48ec1fa3cd.defaultProps = {
    active: false
};
const $4a481c221d5871b5$var$Container = (0, $lmFrL.default).div`
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
`;




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
// @ts-nocheck

var $acw62 = parcelRequire("acw62");
var $d454d87dd25ca21e$export$a8ff84c12d48cfa6 = "d3";
var $d454d87dd25ca21e$export$83d89fbfd8236492 = "5.16.0";
var $d454d87dd25ca21e$export$6d59db4903f20f7d = "Data-Driven Documents";
var $d454d87dd25ca21e$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $d454d87dd25ca21e$export$4cec2234a9c7ce6d = "https://d3js.org";
var $d454d87dd25ca21e$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $d454d87dd25ca21e$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $d454d87dd25ca21e$export$f22da7240b7add18 = "dist/d3.node.js";
var $d454d87dd25ca21e$export$101358e655b23e68 = "dist/d3.min.js";
var $d454d87dd25ca21e$export$a2877c4988dda7ec = "dist/d3.min.js";
var $d454d87dd25ca21e$export$130be424786e852f = "index.js";
var $d454d87dd25ca21e$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $d454d87dd25ca21e$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $d454d87dd25ca21e$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $d454d87dd25ca21e$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "2",
    "rollup": "1",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "rollup-plugin-terser": "5",
    "tape": "4"
};
var $d454d87dd25ca21e$export$b74ff737e0e298b5 = {
    "d3-array": "1",
    "d3-axis": "1",
    "d3-brush": "1",
    "d3-chord": "1",
    "d3-collection": "1",
    "d3-color": "1",
    "d3-contour": "1",
    "d3-dispatch": "1",
    "d3-drag": "1",
    "d3-dsv": "1",
    "d3-ease": "1",
    "d3-fetch": "1",
    "d3-force": "1",
    "d3-format": "1",
    "d3-geo": "1",
    "d3-hierarchy": "1",
    "d3-interpolate": "1",
    "d3-path": "1",
    "d3-polygon": "1",
    "d3-quadtree": "1",
    "d3-random": "1",
    "d3-scale": "2",
    "d3-scale-chromatic": "1",
    "d3-selection": "1",
    "d3-shape": "1",
    "d3-time": "1",
    "d3-time-format": "2",
    "d3-timer": "1",
    "d3-transition": "1",
    "d3-voronoi": "1",
    "d3-zoom": "1"
};


function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $0ae9019609d046a1$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $0ae9019609d046a1$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $0ae9019609d046a1$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $63cbeabc75241824$export$2e2bcd8739ae039)(f(d), x);
    };
}


var $a6e17c0ec55d7735$var$ascendingBisect = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $63cbeabc75241824$export$2e2bcd8739ae039));
var $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
var $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;




function $a9640ed34ca3d852$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $a9640ed34ca3d852$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $a9640ed34ca3d852$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}


function $674b813fb857ae76$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $a9640ed34ca3d852$export$a04cb3fe8b81dd);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}


function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}


function $4eefdd235be3059b$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}


function $317408b795339b26$export$2e2bcd8739ae039(array, f) {
    var v = (0, $4eefdd235be3059b$export$2e2bcd8739ae039)(array, f);
    return v ? Math.sqrt(v) : v;
}


function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $38806e4e35e056bb$var$array = Array.prototype;
var $38806e4e35e056bb$export$58adb3bec8346d0f = $38806e4e35e056bb$var$array.slice;
var $38806e4e35e056bb$export$871de8747c9eaa88 = $38806e4e35e056bb$var$array.map;



function $a193f63211edda81$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $d9caf9fd1659d791$export$2e2bcd8739ae039(x) {
    return x;
}


function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


var $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1);
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $7c028b8201e48c5a$var$e10) step1 *= 10;
    else if (error >= $7c028b8201e48c5a$var$e5) step1 *= 5;
    else if (error >= $7c028b8201e48c5a$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $6d386446084ca1a9$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}


function $988bb1338864c108$export$2e2bcd8739ae039() {
    var value = (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), domain = (0, $24461355656d8852$export$2e2bcd8739ae039), threshold = (0, $6d386446084ca1a9$export$2e2bcd8739ae039);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(x0, x1, tz);
            tz = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $a193f63211edda81$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $a193f63211edda81$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $a193f63211edda81$export$2e2bcd8739ae039)((0, $38806e4e35e056bb$export$58adb3bec8346d0f).call(_)) : (0, $a193f63211edda81$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}






function $231c9024a6754413$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $591ad978f2ce6133$export$2e2bcd8739ae039);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $1ae435d6739098c4$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $38806e4e35e056bb$export$871de8747c9eaa88).call(values, (0, $591ad978f2ce6133$export$2e2bcd8739ae039)).sort((0, $63cbeabc75241824$export$2e2bcd8739ae039));
    return Math.ceil((max - min) / (2 * ((0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.75) - (0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}



function $e5c6de1a6d3b2294$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $317408b795339b26$export$2e2bcd8739ae039)(values) * Math.pow(values.length, -1 / 3)));
}



function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}



function $be26fde1f1f97ef0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}





function $5713cbb46e42efc2$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $231c9024a6754413$export$2e2bcd8739ae039)(numbers.sort((0, $63cbeabc75241824$export$2e2bcd8739ae039)), 0.5);
}


function $54ced0ad7294c1a8$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}


function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}



function $752ccd95a674b233$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}





function $69f952dec6daacf1$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $63cbeabc75241824$export$2e2bcd8739ae039);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}


function $0a6b5bfe2fca1ade$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}


function $daf42a1f07322cf6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}




function $e58cab29de1f7712$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(matrix, $e58cab29de1f7712$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $e58cab29de1f7712$var$length(d) {
    return d.length;
}




function $7d941308464d4714$export$2e2bcd8739ae039() {
    return (0, $e58cab29de1f7712$export$2e2bcd8739ae039)(arguments);
}




var $12a19819930050d0$export$58adb3bec8346d0f = Array.prototype.slice;


function $575c8f74500ed33b$export$2e2bcd8739ae039(x) {
    return x;
}


var $834b38f205523964$var$top = 1, $834b38f205523964$var$right = 2, $834b38f205523964$var$bottom = 3, $834b38f205523964$var$left = 4, $834b38f205523964$var$epsilon = 1e-6;
function $834b38f205523964$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $834b38f205523964$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $834b38f205523964$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $834b38f205523964$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $834b38f205523964$var$entering() {
    return !this.__axis;
}
function $834b38f205523964$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$left ? -1 : 1, x = orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? "x" : "y", transform = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$bottom ? $834b38f205523964$var$translateX : $834b38f205523964$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $575c8f74500ed33b$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $834b38f205523964$var$center : $834b38f205523964$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $834b38f205523964$var$top ? "0em" : orient === $834b38f205523964$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $834b38f205523964$var$left || orient == $834b38f205523964$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($834b38f205523964$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $834b38f205523964$var$right ? "start" : orient === $834b38f205523964$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $12a19819930050d0$export$58adb3bec8346d0f).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $12a19819930050d0$export$58adb3bec8346d0f).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $12a19819930050d0$export$58adb3bec8346d0f).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $834b38f205523964$export$59b8cfab074bdeb1(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$top, scale);
}
function $834b38f205523964$export$b0d2e24dc4f898f0(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$right, scale);
}
function $834b38f205523964$export$e5cb22533a15e72e(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$bottom, scale);
}
function $834b38f205523964$export$2749afb169a520d2(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$left, scale);
}




var $7c4cf709d1826294$var$noop = {
    value: function() {}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}



function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}


function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


var $cf943aeeeea8dffb$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $cf943aeeeea8dffb$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $cf943aeeeea8dffb$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name;
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


var $dd1fb49221ad966f$var$filterEvents = {};
var $dd1fb49221ad966f$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $dd1fb49221ad966f$var$element = document.documentElement;
    if (!("onmouseenter" in $dd1fb49221ad966f$var$element)) $dd1fb49221ad966f$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $dd1fb49221ad966f$var$filterContextListener(listener, index, group) {
    listener = $dd1fb49221ad966f$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $dd1fb49221ad966f$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $dd1fb49221ad966f$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $dd1fb49221ad966f$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $dd1fb49221ad966f$export$6cd530ed55e06764 = event0;
        }
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, capture) {
    var wrap = $dd1fb49221ad966f$var$filterEvents.hasOwnProperty(typename.type) ? $dd1fb49221ad966f$var$filterContextListener : $dd1fb49221ad966f$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $dd1fb49221ad966f$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $dd1fb49221ad966f$export$6cd530ed55e06764;
    event1.sourceEvent = $dd1fb49221ad966f$export$6cd530ed55e06764;
    $dd1fb49221ad966f$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $dd1fb49221ad966f$export$6cd530ed55e06764 = event0;
    }
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}



function $914edae09cbfb4c0$export$2e2561858db9bf47() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).preventDefault();
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


function $78a660cd70c52f6f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}



function $c447ae86a8320d39$export$2e2bcd8739ae039() {
    var current = (0, $dd1fb49221ad966f$export$6cd530ed55e06764), source;
    while(source = current.sourceEvent)current = source;
    return current;
}


function $341b26f2670eba15$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}


function $dbcffd59364661d7$export$2e2bcd8739ae039(node) {
    var event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $341b26f2670eba15$export$2e2bcd8739ae039)(node, event);
}



function $42a581473eb076b1$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $341b26f2670eba15$export$2e2bcd8739ae039)(node, touch);
    }
    return null;
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}




var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$cssNode, $4a001faa54972590$var$cssRoot, $4a001faa54972590$var$cssView, $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$cssNode) $4a001faa54972590$var$cssNode = document.createElement("DIV"), $4a001faa54972590$var$cssRoot = document.documentElement, $4a001faa54972590$var$cssView = document.defaultView;
    $4a001faa54972590$var$cssNode.style.transform = value;
    value = $4a001faa54972590$var$cssView.getComputedStyle($4a001faa54972590$var$cssRoot.appendChild($4a001faa54972590$var$cssNode), null).getPropertyValue("transform");
    $4a001faa54972590$var$cssRoot.removeChild($4a001faa54972590$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039)
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $b5b43281074f9351$var$defaultTiming.time = (0, $e782289d8bd71451$export$461939dd4422153)(), $b5b43281074f9351$var$defaultTiming;
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);





var $a3ea65c9b2342fdf$var$root = [
    null
];
function $a3ea65c9b2342fdf$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $150ba4634a330696$export$584530fe98d14a84) && schedule.name === name) return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)([
                [
                    node
                ]
            ], $a3ea65c9b2342fdf$var$root, name, +i);
        }
    }
    return null;
}





function $4fc3d848825eb4c8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $de0b5bec424cf247$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}



function $48e2d3ac3b9a75ee$export$2e2561858db9bf47() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).preventDefault();
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}


var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
function $5c8970f4694d4107$var$toucher(identifier) {
    return function(target) {
        return (0, $42a581473eb076b1$export$2e2bcd8739ae039)(target, (0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches, identifier);
    };
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter() {
    return !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).ctrlKey && !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8385105b4986daed$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $dd1fb49221ad966f$export$4c724631b4750aef)(new (0, $de0b5bec424cf247$export$2e2bcd8739ae039)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if (touchending && !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).target.__data__.type, mode = (keys && (0, $dd1fb49221ad966f$export$6cd530ed55e06764).metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && (0, $dd1fb49221ad966f$export$6cd530ed55e06764).altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && (0, $dd1fb49221ad966f$export$6cd530ed55e06764).shiftKey, lockX, lockY, pointer = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches ? $5c8970f4694d4107$var$toucher((0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches[0].identifier) : (0, $dbcffd59364661d7$export$2e2bcd8739ae039), point0 = pointer(that), point = point0, emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : point0[0],
                    n0 = dim === $5c8970f4694d4107$var$X ? N : point0[1]
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : w0,
                    s0 = dim === $5c8970f4694d4107$var$X ? S : n0
                ]
            ];
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $905558291b0c219c$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view);
        }
        (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)();
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)();
            if ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches) {
                if ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $905558291b0c219c$export$833237748009e1e1)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $dd1fb49221ad966f$export$6cd530ed55e06764).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)();
        }
        function keyupped() {
            switch((0, $dd1fb49221ad966f$export$6cd530ed55e06764).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)();
        }
    }
    function touchmoved() {
        emitter(this, arguments).moved();
    }
    function touchended() {
        emitter(this, arguments).ended();
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}





var $e4f9e8af03305b19$export$50d414a77b60d802 = Math.cos;
var $e4f9e8af03305b19$export$5de3937cb4b592ed = Math.sin;
var $e4f9e8af03305b19$export$18c7bea995a110f = Math.PI;
var $e4f9e8af03305b19$export$e51408a300e8929a = $e4f9e8af03305b19$export$18c7bea995a110f / 2;
var $e4f9e8af03305b19$export$a4b4b4d4d776fe92 = $e4f9e8af03305b19$export$18c7bea995a110f * 2;
var $e4f9e8af03305b19$export$8960430cfd85939f = Math.max;


function $47b4debc53fe20f4$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $47b4debc53fe20f4$export$2e2bcd8739ae039() {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = [], groupIndex = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
        // Compute the sum.
        k = 0, i = -1;
        while(++i < n){
            x = 0, j = -1;
            while(++j < n)x += matrix[i][j];
            groupSums.push(x);
            subgroupIndex.push((0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n));
            k += x;
        }
        // Sort groups…
        if (sortGroups) groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
        });
        // Sort subgroups…
        if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
        });
        // Convert the sum to scaling factor for [0, 2pi].
        // TODO Allow start and end angle to be specified?
        // TODO Allow padding to be specified as percentage?
        k = (0, $e4f9e8af03305b19$export$8960430cfd85939f)(0, (0, $e4f9e8af03305b19$export$a4b4b4d4d776fe92) - padAngle * n) / k;
        dx = k ? padAngle : (0, $e4f9e8af03305b19$export$a4b4b4d4d776fe92) / n;
        // Compute the start and end angle for each group and subgroup.
        // Note: Opera has a bug reordering object literal properties!
        x = 0, i = -1;
        while(++i < n){
            x0 = x, j = -1;
            while(++j < n){
                var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                subgroups[dj * n + di] = {
                    index: di,
                    subindex: dj,
                    startAngle: a0,
                    endAngle: a1,
                    value: v
                };
            }
            groups[di] = {
                index: di,
                startAngle: x0,
                endAngle: x,
                value: groupSums[di]
            };
            x += dx;
        }
        // Generate chords for each (non-empty) subgroup-subgroup link.
        i = -1;
        while(++i < n){
            j = i - 1;
            while(++j < n){
                var source = subgroups[j * n + i], target = subgroups[i * n + j];
                if (source.value || target.value) chords.push(source.value < target.value ? {
                    source: target,
                    target: source
                } : {
                    source: source,
                    target: target
                });
            }
        }
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $e4f9e8af03305b19$export$8960430cfd85939f)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $47b4debc53fe20f4$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}


var $2ce5bb679b5f7ae5$export$58adb3bec8346d0f = Array.prototype.slice;


function $f3e37bc5e2106614$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



var $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $c9f66a4d1c06b373$var$path() {
    return new $c9f66a4d1c06b373$var$Path;
}
$c9f66a4d1c06b373$var$Path.prototype = $c9f66a4d1c06b373$var$path.prototype = {
    constructor: $c9f66a4d1c06b373$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $c9f66a4d1c06b373$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $c9f66a4d1c06b373$export$2e2bcd8739ae039 = $c9f66a4d1c06b373$var$path;


function $c94985b24ca476f5$var$defaultSource(d) {
    return d.source;
}
function $c94985b24ca476f5$var$defaultTarget(d) {
    return d.target;
}
function $c94985b24ca476f5$var$defaultRadius(d) {
    return d.radius;
}
function $c94985b24ca476f5$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $c94985b24ca476f5$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $c94985b24ca476f5$export$2e2bcd8739ae039() {
    var source = $c94985b24ca476f5$var$defaultSource, target = $c94985b24ca476f5$var$defaultTarget, radius = $c94985b24ca476f5$var$defaultRadius, startAngle = $c94985b24ca476f5$var$defaultStartAngle, endAngle = $c94985b24ca476f5$var$defaultEndAngle, context = null;
    function ribbon() {
        var buffer, argv = (0, $2ce5bb679b5f7ae5$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $e4f9e8af03305b19$export$e51408a300e8929a), sa1 = endAngle.apply(this, argv) - (0, $e4f9e8af03305b19$export$e51408a300e8929a), sx0 = sr * (0, $e4f9e8af03305b19$export$50d414a77b60d802)(sa0), sy0 = sr * (0, $e4f9e8af03305b19$export$5de3937cb4b592ed)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $e4f9e8af03305b19$export$e51408a300e8929a), ta1 = endAngle.apply(this, argv) - (0, $e4f9e8af03305b19$export$e51408a300e8929a);
        if (!context) context = buffer = (0, $c9f66a4d1c06b373$export$2e2bcd8739ae039)();
        context.moveTo(sx0, sy0);
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            context.quadraticCurveTo(0, 0, tr * (0, $e4f9e8af03305b19$export$50d414a77b60d802)(ta0), tr * (0, $e4f9e8af03305b19$export$5de3937cb4b592ed)(ta0));
            context.arc(0, 0, tr, ta0, ta1);
        }
        context.quadraticCurveTo(0, 0, sx0, sy0);
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    ribbon.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $f3e37bc5e2106614$export$2e2bcd8739ae039)(+_), ribbon) : radius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $f3e37bc5e2106614$export$2e2bcd8739ae039)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $f3e37bc5e2106614$export$2e2bcd8739ae039)(+_), ribbon) : endAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}




var $38063efcb0b229b0$export$82e9f45cca5ba907 = "$";
function $38063efcb0b229b0$var$Map() {}
$38063efcb0b229b0$var$Map.prototype = $38063efcb0b229b0$var$map.prototype = {
    constructor: $38063efcb0b229b0$var$Map,
    has: function(key) {
        return $38063efcb0b229b0$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $38063efcb0b229b0$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $38063efcb0b229b0$var$map(object, f) {
    var map = new $38063efcb0b229b0$var$Map;
    // Copy constructor.
    if (object instanceof $38063efcb0b229b0$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $38063efcb0b229b0$export$2e2bcd8739ae039 = $38063efcb0b229b0$var$map;


function $84aeb4920efec81c$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createObject, $84aeb4920efec81c$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $84aeb4920efec81c$var$createObject() {
    return {};
}
function $84aeb4920efec81c$var$setObject(object, key, value) {
    object[key] = value;
}
function $84aeb4920efec81c$var$createMap() {
    return (0, $38063efcb0b229b0$export$2e2bcd8739ae039)();
}
function $84aeb4920efec81c$var$setMap(map, key, value) {
    map.set(key, value);
}



function $cf3c72678de97179$var$Set() {}
var $cf3c72678de97179$var$proto = (0, $38063efcb0b229b0$export$2e2bcd8739ae039).prototype;
$cf3c72678de97179$var$Set.prototype = $cf3c72678de97179$var$set.prototype = {
    constructor: $cf3c72678de97179$var$Set,
    has: $cf3c72678de97179$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $38063efcb0b229b0$export$82e9f45cca5ba907) + value] = value;
        return this;
    },
    remove: $cf3c72678de97179$var$proto.remove,
    clear: $cf3c72678de97179$var$proto.clear,
    values: $cf3c72678de97179$var$proto.keys,
    size: $cf3c72678de97179$var$proto.size,
    empty: $cf3c72678de97179$var$proto.empty,
    each: $cf3c72678de97179$var$proto.each
};
function $cf3c72678de97179$var$set(object, f) {
    var set = new $cf3c72678de97179$var$Set;
    // Copy constructor.
    if (object instanceof $cf3c72678de97179$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $cf3c72678de97179$export$2e2bcd8739ae039 = $cf3c72678de97179$var$set;



function $b1df778a51d6d6fd$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}


function $7138699956e0deee$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}


function $09fb892cb60fcd6e$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}






var $6e529a4d7c5318cb$var$array = Array.prototype;
var $6e529a4d7c5318cb$export$58adb3bec8346d0f = $6e529a4d7c5318cb$var$array.slice;


function $8cf317e8294c08d4$export$2e2bcd8739ae039(a, b) {
    return a - b;
}


function $3e63541b38411916$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}


function $2c54087e0cd22b13$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $dab7974168a117cc$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $dab7974168a117cc$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $dab7974168a117cc$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($dab7974168a117cc$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $dab7974168a117cc$var$segmentContains(a, b, c) {
    var i;
    return $dab7974168a117cc$var$collinear(a, b, c) && $dab7974168a117cc$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $dab7974168a117cc$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $dab7974168a117cc$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}


function $a2ef71a294399755$export$2e2bcd8739ae039() {}


var $bedfe0973872bedd$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $bedfe0973872bedd$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $6d386446084ca1a9$export$2e2bcd8739ae039), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var domain = (0, $24461355656d8852$export$2e2bcd8739ae039)(values), start = domain[0], stop = domain[1];
            tz = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, tz);
            tz = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
        } else tz = tz.slice().sort((0, $8cf317e8294c08d4$export$2e2bcd8739ae039));
        return tz.map(function(value) {
            return contour(values, value);
        });
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $3e63541b38411916$export$2e2bcd8739ae039)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $dab7974168a117cc$export$2e2bcd8739ae039)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $bedfe0973872bedd$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $bedfe0973872bedd$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $bedfe0973872bedd$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $bedfe0973872bedd$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $bedfe0973872bedd$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $bedfe0973872bedd$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $bedfe0973872bedd$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)((0, $6e529a4d7c5318cb$export$58adb3bec8346d0f).call(_)) : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $a2ef71a294399755$export$2e2bcd8739ae039), contours) : smooth === smoothLinear;
    };
    return contours;
}




// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function $52e275d1063750f6$export$d6b6c69cb5897b44(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function $52e275d1063750f6$export$96ba1179f8344c4b(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}




function $ad0d499b029c9e60$var$defaultX(d) {
    return d[0];
}
function $ad0d499b029c9e60$var$defaultY(d) {
    return d[1];
}
function $ad0d499b029c9e60$var$defaultWeight() {
    return 1;
}
function $ad0d499b029c9e60$export$2e2bcd8739ae039() {
    var x = $ad0d499b029c9e60$var$defaultX, y = $ad0d499b029c9e60$var$defaultY, weight = $ad0d499b029c9e60$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(20);
    function density(data) {
        var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        data.forEach(function(d, i, data) {
            var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
        });
        // TODO Optimize.
        (0, $52e275d1063750f6$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $52e275d1063750f6$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $52e275d1063750f6$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $52e275d1063750f6$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $52e275d1063750f6$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $52e275d1063750f6$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        var tz = threshold(values0);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var stop = (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(values0);
            tz = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(0, stop, tz);
            tz = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(0, Math.floor(stop / tz) * tz, tz);
            tz.shift();
        }
        return (0, $bedfe0973872bedd$export$2e2bcd8739ae039)().thresholds(tz).size([
            n,
            m
        ])(values0).map(transform);
    }
    function transform(geometry) {
        geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)((0, $6e529a4d7c5318cb$export$58adb3bec8346d0f).call(_)) : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
    };
    return density;
}









function $620ab3a49fccb4fc$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $45813ed5c6fd1799$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$45813ed5c6fd1799$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $0b4a1789c016a21b$var$defaultFilter() {
    return !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).ctrlKey && !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).button;
}
function $0b4a1789c016a21b$var$defaultContainer() {
    return this.parentNode;
}
function $0b4a1789c016a21b$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $dd1fb49221ad966f$export$6cd530ed55e06764).x,
        y: (0, $dd1fb49221ad966f$export$6cd530ed55e06764).y
    } : d;
}
function $0b4a1789c016a21b$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $0b4a1789c016a21b$export$2e2bcd8739ae039() {
    var filter = $0b4a1789c016a21b$var$defaultFilter, container = $0b4a1789c016a21b$var$defaultContainer, subject = $0b4a1789c016a21b$var$defaultSubject, touchable = $0b4a1789c016a21b$var$defaultTouchable, gestures = {}, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $dbcffd59364661d7$export$2e2bcd8739ae039), this, arguments);
        if (!gesture) return;
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $905558291b0c219c$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view);
        (0, $914edae09cbfb4c0$export$2e2561858db9bf47)();
        mousemoving = false;
        mousedownx = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientX;
        mousedowny = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)();
        if (!mousemoving) {
            var dx = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientX - mousedownx, dy = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view).on("mousemove.drag mouseup.drag", null);
        (0, $905558291b0c219c$export$833237748009e1e1)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view, mousemoving);
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $42a581473eb076b1$export$2e2bcd8739ae039), this, arguments)) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $dd1fb49221ad966f$export$4c724631b4750aef)(new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $dd1fb49221ad966f$export$6cd530ed55e06764).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $dd1fb49221ad966f$export$4c724631b4750aef)(new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





function $32b22de0132cc595$export$2e2bcd8739ae039(x, y) {
    var nodes;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}


function $b10509a5c523ef79$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $2dea4bbaea189065$export$2e2bcd8739ae039() {
    return (Math.random() - 0.5) * 1e-6;
}


function $be1b12895c7da8cf$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $be1b12895c7da8cf$var$add(this.cover(x, y), x, y, d);
}
function $be1b12895c7da8cf$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $be1b12895c7da8cf$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$be1b12895c7da8cf$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $6063f984171c8523$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $cfd8a0ee53f875c5$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $feddd81cb3a1a5cd$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $75f49fd5af8d23e7$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $b7a6a4e6ea4402cb$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $9ea7286cd6ff459a$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9ea7286cd6ff459a$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $0d9e2b498bba95b5$export$2e2bcd8739ae039() {
    return this._root;
}


function $f92329c600392ac7$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $15a5c85e382805ba$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $9a4dcb6a46603c0e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $e002de94352e4f40$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $e002de94352e4f40$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $6a00482922687876$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $6a00482922687876$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $977cc0295d3f184c$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $977cc0295d3f184c$var$Quadtree(x == null ? (0, $e002de94352e4f40$export$e6fafc98131d2a44) : x, y == null ? (0, $6a00482922687876$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $977cc0295d3f184c$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $977cc0295d3f184c$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $977cc0295d3f184c$var$treeProto = $977cc0295d3f184c$export$2e2bcd8739ae039.prototype = $977cc0295d3f184c$var$Quadtree.prototype;
$977cc0295d3f184c$var$treeProto.copy = function() {
    var copy = new $977cc0295d3f184c$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $977cc0295d3f184c$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $977cc0295d3f184c$var$leaf_copy(child);
        }
    }
    return copy;
};
$977cc0295d3f184c$var$treeProto.add = (0, $be1b12895c7da8cf$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.addAll = (0, $be1b12895c7da8cf$export$32ed0561867ec8a1);
$977cc0295d3f184c$var$treeProto.cover = (0, $6063f984171c8523$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.data = (0, $cfd8a0ee53f875c5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.extent = (0, $feddd81cb3a1a5cd$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.find = (0, $b7a6a4e6ea4402cb$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.remove = (0, $9ea7286cd6ff459a$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.removeAll = (0, $9ea7286cd6ff459a$export$1cfc7aad5cb1833b);
$977cc0295d3f184c$var$treeProto.root = (0, $0d9e2b498bba95b5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.size = (0, $f92329c600392ac7$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visit = (0, $15a5c85e382805ba$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visitAfter = (0, $9a4dcb6a46603c0e$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.x = (0, $e002de94352e4f40$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.y = (0, $6a00482922687876$export$2e2bcd8739ae039);


function $bdd28c4fe1fd882d$var$x(d) {
    return d.x + d.vx;
}
function $bdd28c4fe1fd882d$var$y(d) {
    return d.y + d.vy;
}
function $bdd28c4fe1fd882d$export$2e2bcd8739ae039(radius) {
    var nodes, radii, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, $bdd28c4fe1fd882d$var$x, $bdd28c4fe1fd882d$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += x * x;
                        if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}





function $4275f440a0eccb35$var$index(d) {
    return d.index;
}
function $4275f440a0eccb35$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}
function $4275f440a0eccb35$export$2e2bcd8739ae039(links) {
    var id = $4275f440a0eccb35$var$index, strength = defaultStrength, strengths, distance = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $2dea4bbaea189065$export$2e2bcd8739ae039)();
            y = target.y + target.vy - source.y - source.vy || (0, $2dea4bbaea189065$export$2e2bcd8739ae039)();
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)(nodes, id), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $4275f440a0eccb35$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $4275f440a0eccb35$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}








function $f7ecda670cf68ae1$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $f7ecda670cf68ae1$export$4a5767248b18ef41(d) {
    return d.y;
}
var $f7ecda670cf68ae1$var$initialRadius = 10, $f7ecda670cf68ae1$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $f7ecda670cf68ae1$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)(), stepper = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(step), event = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("tick", "end");
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.each(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $f7ecda670cf68ae1$var$initialRadius * Math.sqrt(i), angle = i * $f7ecda670cf68ae1$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $6b6e9bc7f2e1a0ee$export$2e2bcd8739ae039() {
    var nodes, node, alpha, strength = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, (0, $f7ecda670cf68ae1$export$d141bba7fdc215a3), (0, $f7ecda670cf68ae1$export$4a5767248b18ef41)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += x * x;
                if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += x * x;
            if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}



function $6f671e8f12d94cfe$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}




function $0269baf63e02b6fc$export$2e2bcd8739ae039(x) {
    var strength = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}



function $a8abf7da4ed52888$export$2e2bcd8739ae039(y) {
    var strength = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}











function $47e50bac224ef074$export$2e2bcd8739ae039() {
    return Math.random();
}


var $6f2138f117e664d5$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));



var $84a8341e7a81af75$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));




var $b55220c14c05b678$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, $84a8341e7a81af75$export$2e2bcd8739ae039).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));




var $239f1e07ebca197f$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));


var $ec31e64bd24fe1c3$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, $239f1e07ebca197f$export$2e2bcd8739ae039).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));




var $82c98442936778b2$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $47e50bac224ef074$export$2e2bcd8739ae039));





function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.interpolator(domain);
            break;
        default:
            this.interpolator(interpolator).domain(domain);
            break;
    }
    return this;
}



var $01f09594bbab007c$var$array = Array.prototype;
var $01f09594bbab007c$export$871de8747c9eaa88 = $01f09594bbab007c$var$array.map;
var $01f09594bbab007c$export$58adb3bec8346d0f = $01f09594bbab007c$var$array.slice;



var $38404d762c7ac827$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}





function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}



function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $acd329741cbdf381$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(domain) {
    var a = domain[0], b = domain[domain.length - 1], t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $01f09594bbab007c$export$871de8747c9eaa88).call(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), clamp === $afe237385175446a$export$f0954fd7d5368655 || (clamp = $afe237385175446a$var$clamper(domain)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), interpolate = (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? $afe237385175446a$var$clamper(domain) : $afe237385175446a$export$f0954fd7d5368655, scale) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039(transform, untransform) {
    return $afe237385175446a$export$6b468dcfb64c653c()(transform, untransform);
}




function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $458fe095863893c0$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $458fe095863893c0$export$2e2bcd8739ae039),
    "s": (0, $fe491ef31c379765$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}


var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $f4c0f29ad920aaa1$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $95e9c493347f9308$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $dd689cef4c920567$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $fe491ef31c379765$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $e8b109bb95cf9845$export$2e2bcd8739ae039)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}


function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1589426e0436f502$export$2e2bcd8739ae039)(max) - (0, $1589426e0436f502$export$2e2bcd8739ae039)(step)) + 1;
}


function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $162912dc121d0934$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $54a757fa53542946$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $d27f2d3c2137f747$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $f4e256a3cb9c44da$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
}


function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b0a07d06c8b316c1$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655));
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}



function $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $01f09594bbab007c$export$871de8747c9eaa88).call(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? (0, $01f09594bbab007c$export$871de8747c9eaa88).call(domain, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}





function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $5bf2f979a0299157$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    var scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    var scale = $5bf2f979a0299157$export$860836db074028f0((0, $afe237385175446a$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $cb758ed0dff37844$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $cb758ed0dff37844$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $cb758ed0dff37844$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($cb758ed0dff37844$var$transformSymlog(c), $cb758ed0dff37844$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($cb758ed0dff37844$var$transformSymlog(c = +_), $cb758ed0dff37844$var$transformSymexp(c)) : c;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $cb758ed0dff37844$export$2e2bcd8739ae039() {
    var scale = $cb758ed0dff37844$export$4602684e614eba38((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $cb758ed0dff37844$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}





function $96238d247b54f1ee$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $231c9024a6754413$export$2e2bcd8739ae039)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $63cbeabc75241824$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $96238d247b54f1ee$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $a6fd4026648153e5$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x <= x ? range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a6fd4026648153e5$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply((0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale), arguments);
}





function $8058838348a44fed$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x <= x ? range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $01f09594bbab007c$export$58adb3bec8346d0f).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8058838348a44fed$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}



var $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $f26fc9b6912de968$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


var $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1e3;
var $a28c7a35eadfe1f6$export$683905d551c33fa9 = 6e4;
var $a28c7a35eadfe1f6$export$4157bf0c8e241659 = 36e5;
var $a28c7a35eadfe1f6$export$353686095f4fbf45 = 864e5;
var $a28c7a35eadfe1f6$export$c241eb88520d5016 = 6048e5;


var $51fe2e20810fcb40$var$day = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, function(date) {
    return date.getDate() - 1;
});
var $51fe2e20810fcb40$export$2e2bcd8739ae039 = $51fe2e20810fcb40$var$day;
var $51fe2e20810fcb40$export$3cf5dda4201cc0f2 = $51fe2e20810fcb40$var$day.range;



var $9472e71f07850dab$var$hour = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc) - date.getMinutes() * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $9472e71f07850dab$export$2e2bcd8739ae039 = $9472e71f07850dab$var$hour;
var $9472e71f07850dab$export$8d468796d69cdad1 = $9472e71f07850dab$var$hour.range;


var $79ec6c01997bf022$var$millisecond = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$var$millisecond;
    return (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $79ec6c01997bf022$export$2e2bcd8739ae039 = $79ec6c01997bf022$var$millisecond;
var $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$var$millisecond.range;



var $292297f992a3b17e$var$minute = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $292297f992a3b17e$export$2e2bcd8739ae039 = $292297f992a3b17e$var$minute;
var $292297f992a3b17e$export$666252b437cce0c7 = $292297f992a3b17e$var$minute.range;


var $031c190f93ea3efa$var$month = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $031c190f93ea3efa$export$2e2bcd8739ae039 = $031c190f93ea3efa$var$month;
var $031c190f93ea3efa$export$16352d1b10c5eb38 = $031c190f93ea3efa$var$month.range;



var $490d5c36270b8fcb$var$second = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $490d5c36270b8fcb$export$2e2bcd8739ae039 = $490d5c36270b8fcb$var$second;
var $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$var$second.range;



function $7f6029921eecd017$var$weekday(i) {
    return (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
var $7f6029921eecd017$export$fb3ee18ed410cc21 = $7f6029921eecd017$var$weekday(0);
var $7f6029921eecd017$export$6416afaab03bc9b8 = $7f6029921eecd017$var$weekday(1);
var $7f6029921eecd017$export$cb8f040f5d17ac7b = $7f6029921eecd017$var$weekday(2);
var $7f6029921eecd017$export$347581849975dfc8 = $7f6029921eecd017$var$weekday(3);
var $7f6029921eecd017$export$2f2b56683a3e5629 = $7f6029921eecd017$var$weekday(4);
var $7f6029921eecd017$export$59b8c2ccd931d806 = $7f6029921eecd017$var$weekday(5);
var $7f6029921eecd017$export$478ceadebff4d377 = $7f6029921eecd017$var$weekday(6);
var $7f6029921eecd017$export$e8daabaa40641211 = $7f6029921eecd017$export$fb3ee18ed410cc21.range;
var $7f6029921eecd017$export$74e5b559c235c00e = $7f6029921eecd017$export$6416afaab03bc9b8.range;
var $7f6029921eecd017$export$e7d6aa4fb107bc56 = $7f6029921eecd017$export$cb8f040f5d17ac7b.range;
var $7f6029921eecd017$export$fcd5880b20bb06a8 = $7f6029921eecd017$export$347581849975dfc8.range;
var $7f6029921eecd017$export$682716b7bbe33641 = $7f6029921eecd017$export$2f2b56683a3e5629.range;
var $7f6029921eecd017$export$482924968ca86084 = $7f6029921eecd017$export$59b8c2ccd931d806.range;
var $7f6029921eecd017$export$7d755172c9cda9d2 = $7f6029921eecd017$export$478ceadebff4d377.range;


var $dd6e0f506bfbbd03$var$year = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $dd6e0f506bfbbd03$export$2e2bcd8739ae039 = $dd6e0f506bfbbd03$var$year;
var $dd6e0f506bfbbd03$export$6fda41c7fb23acf9 = $dd6e0f506bfbbd03$var$year.range;




var $1e9cc8da96008c84$var$utcDay = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $1e9cc8da96008c84$export$2e2bcd8739ae039 = $1e9cc8da96008c84$var$utcDay;
var $1e9cc8da96008c84$export$d277e198508549a1 = $1e9cc8da96008c84$var$utcDay.range;



function $7055c522f3e8f599$var$utcWeekday(i) {
    return (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
var $7055c522f3e8f599$export$4898b06303a92011 = $7055c522f3e8f599$var$utcWeekday(0);
var $7055c522f3e8f599$export$9cfc53b9cfafd080 = $7055c522f3e8f599$var$utcWeekday(1);
var $7055c522f3e8f599$export$2a6d545f77eceb15 = $7055c522f3e8f599$var$utcWeekday(2);
var $7055c522f3e8f599$export$a5c25d8ed64433c4 = $7055c522f3e8f599$var$utcWeekday(3);
var $7055c522f3e8f599$export$1db08111baec2f53 = $7055c522f3e8f599$var$utcWeekday(4);
var $7055c522f3e8f599$export$29265e34dd5921f7 = $7055c522f3e8f599$var$utcWeekday(5);
var $7055c522f3e8f599$export$85b74dad05049604 = $7055c522f3e8f599$var$utcWeekday(6);
var $7055c522f3e8f599$export$6f3e1c2b0f7d7880 = $7055c522f3e8f599$export$4898b06303a92011.range;
var $7055c522f3e8f599$export$1d2d8b858bb366f9 = $7055c522f3e8f599$export$9cfc53b9cfafd080.range;
var $7055c522f3e8f599$export$1d5f6785fc7f30f8 = $7055c522f3e8f599$export$2a6d545f77eceb15.range;
var $7055c522f3e8f599$export$7a75faf0e37ef4af = $7055c522f3e8f599$export$a5c25d8ed64433c4.range;
var $7055c522f3e8f599$export$417eb959611b2f2f = $7055c522f3e8f599$export$1db08111baec2f53.range;
var $7055c522f3e8f599$export$59d308db7af08c64 = $7055c522f3e8f599$export$29265e34dd5921f7.range;
var $7055c522f3e8f599$export$a124108a0a7f34c8 = $7055c522f3e8f599$export$85b74dad05049604.range;


var $997354f20ca19d0d$var$utcYear = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$997354f20ca19d0d$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $997354f20ca19d0d$export$2e2bcd8739ae039 = $997354f20ca19d0d$var$utcYear;
var $997354f20ca19d0d$export$3e24d311e17f5802 = $997354f20ca19d0d$var$utcYear.range;


function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7055c522f3e8f599$export$9cfc53b9cfafd080).ceil(week) : (0, $7055c522f3e8f599$export$9cfc53b9cfafd080)(week);
                    week = (0, $1e9cc8da96008c84$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$6416afaab03bc9b8).ceil(week) : (0, $7f6029921eecd017$export$6416afaab03bc9b8)(week);
                    week = (0, $51fe2e20810fcb40$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$2e2bcd8739ae039).count((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$fb3ee18ed410cc21).count((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$2f2b56683a3e5629)(d) : (0, $7f6029921eecd017$export$2f2b56683a3e5629).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$2f2b56683a3e5629).count((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039)(d), d) + ((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$6416afaab03bc9b8).count((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$2f2b56683a3e5629)(d) : (0, $7f6029921eecd017$export$2f2b56683a3e5629).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $1e9cc8da96008c84$export$2e2bcd8739ae039).count((0, $997354f20ca19d0d$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7055c522f3e8f599$export$4898b06303a92011).count((0, $997354f20ca19d0d$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7055c522f3e8f599$export$1db08111baec2f53)(d) : (0, $7055c522f3e8f599$export$1db08111baec2f53).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $7055c522f3e8f599$export$1db08111baec2f53).count((0, $997354f20ca19d0d$export$2e2bcd8739ae039)(d), d) + ((0, $997354f20ca19d0d$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7055c522f3e8f599$export$9cfc53b9cfafd080).count((0, $997354f20ca19d0d$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7055c522f3e8f599$export$1db08111baec2f53)(d) : (0, $7055c522f3e8f599$export$1db08111baec2f53).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $463505b9d968caf4$export$2e2bcd8739ae039)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}






var $304372357472b2a4$var$durationSecond = 1000, $304372357472b2a4$var$durationMinute = $304372357472b2a4$var$durationSecond * 60, $304372357472b2a4$var$durationHour = $304372357472b2a4$var$durationMinute * 60, $304372357472b2a4$var$durationDay = $304372357472b2a4$var$durationHour * 24, $304372357472b2a4$var$durationWeek = $304372357472b2a4$var$durationDay * 7, $304372357472b2a4$var$durationMonth = $304372357472b2a4$var$durationDay * 30, $304372357472b2a4$var$durationYear = $304372357472b2a4$var$durationDay * 365;
function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            5,
            5 * $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            15,
            15 * $304372357472b2a4$var$durationSecond
        ],
        [
            second,
            30,
            30 * $304372357472b2a4$var$durationSecond
        ],
        [
            minute,
            1,
            $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $304372357472b2a4$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $304372357472b2a4$var$durationMinute
        ],
        [
            hour,
            1,
            $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            3,
            3 * $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            6,
            6 * $304372357472b2a4$var$durationHour
        ],
        [
            hour,
            12,
            12 * $304372357472b2a4$var$durationHour
        ],
        [
            day,
            1,
            $304372357472b2a4$var$durationDay
        ],
        [
            day,
            2,
            2 * $304372357472b2a4$var$durationDay
        ],
        [
            week,
            1,
            $304372357472b2a4$var$durationWeek
        ],
        [
            month,
            1,
            $304372357472b2a4$var$durationMonth
        ],
        [
            month,
            3,
            3 * $304372357472b2a4$var$durationMonth
        ],
        [
            year,
            1,
            $304372357472b2a4$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start / $304372357472b2a4$var$durationYear, stop / $304372357472b2a4$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $01f09594bbab007c$export$871de8747c9eaa88).call(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $304372357472b2a4$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $dd6e0f506bfbbd03$export$2e2bcd8739ae039), (0, $031c190f93ea3efa$export$2e2bcd8739ae039), (0, $7f6029921eecd017$export$fb3ee18ed410cc21), (0, $51fe2e20810fcb40$export$2e2bcd8739ae039), (0, $9472e71f07850dab$export$2e2bcd8739ae039), (0, $292297f992a3b17e$export$2e2bcd8739ae039), (0, $490d5c36270b8fcb$export$2e2bcd8739ae039), (0, $79ec6c01997bf022$export$2e2bcd8739ae039), (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






var $2305685918ef6fca$var$utcHour = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $2305685918ef6fca$export$2e2bcd8739ae039 = $2305685918ef6fca$var$utcHour;
var $2305685918ef6fca$export$6e7a76cd5f50b719 = $2305685918ef6fca$var$utcHour.range;



var $6790bec6cda46448$var$utcMinute = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $6790bec6cda46448$export$2e2bcd8739ae039 = $6790bec6cda46448$var$utcMinute;
var $6790bec6cda46448$export$cedd563624e8ee50 = $6790bec6cda46448$var$utcMinute.range;


var $8f8815fab2435516$var$utcMonth = (0, $f26fc9b6912de968$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $8f8815fab2435516$export$2e2bcd8739ae039 = $8f8815fab2435516$var$utcMonth;
var $8f8815fab2435516$export$49159f585997498 = $8f8815fab2435516$var$utcMonth.range;



function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply((0, $304372357472b2a4$export$56bbcdb8aca31149)((0, $997354f20ca19d0d$export$2e2bcd8739ae039), (0, $8f8815fab2435516$export$2e2bcd8739ae039), (0, $7055c522f3e8f599$export$4898b06303a92011), (0, $1e9cc8da96008c84$export$2e2bcd8739ae039), (0, $2305685918ef6fca$export$2e2bcd8739ae039), (0, $6790bec6cda46448$export$2e2bcd8739ae039), (0, $490d5c36270b8fcb$export$2e2bcd8739ae039), (0, $79ec6c01997bf022$export$2e2bcd8739ae039), (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}








function $f9c43af42f8b19e4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $f9c43af42f8b19e4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $f9c43af42f8b19e4$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($f9c43af42f8b19e4$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$6843e08bf2ff981f() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($f9c43af42f8b19e4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$9d4af4de62c81941() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$de9f78581b4f2405() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$413d935127ed466e() {
    return $f9c43af42f8b19e4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $52fcf35202383c14$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $afe237385175446a$export$f0954fd7d5368655);
    function scale(x) {
        if (!isNaN(x = +x)) return interpolator(((0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $63cbeabc75241824$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $52fcf35202383c14$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}









function $19e76371916c670d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, t0, t1, t2, k10, k21, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
        return scale;
    };
}
function $19e76371916c670d$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($19e76371916c670d$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$5f0266a9159c47fb() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($19e76371916c670d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$50b3da713cf557c6() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$d6cedcc63bf26e7e() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$33ddefb5c4ab9e9c() {
    return $19e76371916c670d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}







function $e5dfdc386da08eff$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        selector == null ? [] : selector
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}







function $ff3d4f19a48078e6$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $08f9f2c3250a99f0$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $08f9f2c3250a99f0$export$4a5767248b18ef41(d) {
    return d[1];
}



var $2RJ2t = parcelRequire("2RJ2t");
function $50e37159451a6d0c$export$2e2bcd8739ae039() {
    var x = (0, $08f9f2c3250a99f0$export$d141bba7fdc215a3), y = (0, $08f9f2c3250a99f0$export$4a5767248b18ef41), extent = null;
    function voronoi(data) {
        return new (0, $2RJ2t.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $2RJ2t.epsilon)) * (0, $2RJ2t.epsilon),
                Math.round(y(d, i, data) / (0, $2RJ2t.epsilon)) * (0, $2RJ2t.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $ff3d4f19a48078e6$export$2e2bcd8739ae039)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $ff3d4f19a48078e6$export$2e2bcd8739ae039)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}






var $e4199827a75856fd$var$rho = Math.SQRT2, $e4199827a75856fd$var$rho2 = 2, $e4199827a75856fd$var$rho4 = 4, $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $e4199827a75856fd$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $e4199827a75856fd$var$epsilon2) {
        S = Math.log(w1 / w0) / $e4199827a75856fd$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($e4199827a75856fd$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $e4199827a75856fd$var$rho4 * d2) / (2 * w0 * $e4199827a75856fd$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $e4199827a75856fd$var$rho4 * d2) / (2 * w1 * $e4199827a75856fd$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $e4199827a75856fd$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / ($e4199827a75856fd$var$rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh($e4199827a75856fd$var$rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $e4199827a75856fd$var$cosh($e4199827a75856fd$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}




function $4aeb7326706b2467$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $7a8a51016481311d$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}



function $b2e4663bd9fbfcc1$export$2e2561858db9bf47() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039() {
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).preventDefault();
    (0, $dd1fb49221ad966f$export$6cd530ed55e06764).stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
function $91e02783b8b1c24a$var$defaultFilter() {
    return !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).ctrlKey && !(0, $dd1fb49221ad966f$export$6cd530ed55e06764).button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta() {
    return -(0, $dd1fb49221ad966f$export$6cd530ed55e06764).deltaY * ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).deltaMode === 1 ? 0.05 : (0, $dd1fb49221ad966f$export$6cd530ed55e06764).deltaMode ? 1 : 0.002);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p);
    };
    zoom.scaleTo = function(selection, k, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p);
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $dd1fb49221ad966f$export$4c724631b4750aef)(new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $dbcffd59364661d7$export$2e2bcd8739ae039)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments, true), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $dbcffd59364661d7$export$2e2bcd8739ae039)(this), x0 = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientX, y0 = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved() {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)();
            if (!g.moved) {
                var dx = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientX - x0, dy = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $dbcffd59364661d7$export$2e2bcd8739ae039)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)((0, $dd1fb49221ad966f$export$6cd530ed55e06764).view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $dbcffd59364661d7$export$2e2bcd8739ae039)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $dd1fb49221ad966f$export$6cd530ed55e06764).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)();
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).touches, n = touches.length, g = gesture(this, arguments, (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches.length === n), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $42a581473eb076b1$export$2e2bcd8739ae039)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        g.taps = 0;
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $42a581473eb076b1$export$2e2bcd8739ae039)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $dd1fb49221ad966f$export$6cd530ed55e06764).changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}








var $1cb7998639d45551$exports = {};
var $b1d5985487d54dea$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;


var $035bd928078475ee$exports = {};

var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $0488fde9aa355453$exports(value) || $7d0c6fd0eb26be0e$exports(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
$035bd928078475ee$exports = $035bd928078475ee$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $035bd928078475ee$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $cc77dbb7c08db6a8$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b1d5985487d54dea$exports = $b1d5985487d54dea$var$baseFlatten;


var $2f2d1bf022ac3e3d$exports = {};

var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, 'DataView');
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, 'Promise');
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, 'Set');
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, 'WeakMap');
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == 'object') return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $0488fde9aa355453$exports(collection) ? $d26d80da1ba3948c$exports : $b613e194c1b157de$exports;
    return func(collection, $5aba4f6d9f8304a3$exports(iteratee, 3));
}
$2f2d1bf022ac3e3d$exports = $2f2d1bf022ac3e3d$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $1cb7998639d45551$var$flatMap(collection, iteratee) {
    return $b1d5985487d54dea$exports($2f2d1bf022ac3e3d$exports(collection, iteratee), 1);
}
$1cb7998639d45551$exports = $1cb7998639d45551$var$flatMap;



var $acw62 = parcelRequire("acw62");
function $60dc7cc32b6e1f88$var$getDimensionObject(node) {
    var rect = node.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: "x" in rect ? rect.x : rect.top,
        left: "y" in rect ? rect.y : rect.left,
        x: "x" in rect ? rect.x : rect.left,
        y: "y" in rect ? rect.y : rect.top,
        right: rect.right,
        bottom: rect.bottom
    };
}
function $60dc7cc32b6e1f88$var$useDimensions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$liveMeasure = _ref.liveMeasure, liveMeasure = _ref$liveMeasure === undefined ? true : _ref$liveMeasure;
    var _useState = (0, $acw62.useState)({}), dimensions = _useState[0], setDimensions = _useState[1];
    var _useState2 = (0, $acw62.useState)(null), node = _useState2[0], setNode = _useState2[1];
    var ref = (0, $acw62.useCallback)(function(node) {
        setNode(node);
    }, []);
    (0, $acw62.useLayoutEffect)(function() {
        if (node) {
            var measure = function measure() {
                return window.requestAnimationFrame(function() {
                    return setDimensions($60dc7cc32b6e1f88$var$getDimensionObject(node));
                });
            };
            measure();
            if (liveMeasure) {
                window.addEventListener("resize", measure);
                window.addEventListener("scroll", measure);
                return function() {
                    window.removeEventListener("resize", measure);
                    window.removeEventListener("scroll", measure);
                };
            }
        }
    }, [
        node
    ]);
    return [
        ref,
        dimensions,
        node
    ];
}
var $60dc7cc32b6e1f88$export$2e2bcd8739ae039 //# sourceMappingURL=index.js.map
 = $60dc7cc32b6e1f88$var$useDimensions;



var $lmFrL = parcelRequire("lmFrL");



var $45fvw = parcelRequire("45fvw");


var $45fvw = parcelRequire("45fvw");
const $a66eb252e0fd4b58$export$8b7222fa92892b49 = {
    DEFAULT: "DEFAULT",
    HIGHER: "HIGHER"
};
const $a66eb252e0fd4b58$export$b71e687216915f11 = 40;
const $a66eb252e0fd4b58$export$410ebd54025ac67c = 5;
const $a66eb252e0fd4b58$export$769390b9ad120c2d = 1.7;
const $a66eb252e0fd4b58$export$e357d9dab1f6dd73 = 1;
const $a66eb252e0fd4b58$export$305eb744eb40f4ef = 113;
const $a66eb252e0fd4b58$var$oneWeek = 604800000;
const $a66eb252e0fd4b58$var$threeMonths = 7879680000;
const $a66eb252e0fd4b58$var$oneYear = 31518720000;
const $a66eb252e0fd4b58$export$38bedd7e3ec11e7a = (x)=>$834b38f205523964$export$e5cb22533a15e72e(x).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("%b")).ticks($031c190f93ea3efa$export$2e2bcd8739ae039.every(1)).tickSize(20);
const $a66eb252e0fd4b58$export$b1ffadcc6dff5329 = (monthsAxis)=>{
    monthsAxis.select(".domain").remove();
    monthsAxis.selectAll("text").attr("y", 6).attr("x", 8);
};
const $a66eb252e0fd4b58$export$24ff02d6d80a759c = (x)=>$834b38f205523964$export$59b8cfab074bdeb1(x).ticks($031c190f93ea3efa$export$2e2bcd8739ae039.every(3)).tickSize($a66eb252e0fd4b58$export$305eb744eb40f4ef).tickFormat((formatAttrib)=>{
        const momentObj = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(formatAttrib.getTime());
        return `Q${momentObj.quarter()} ${momentObj.format("YYYY")} `;
    });
const $a66eb252e0fd4b58$export$359112c5b5d36ed9 = (quarterAxis)=>{
    quarterAxis.select(".domain").remove();
    quarterAxis.selectAll("text").attr("y", -46).attr("x", 8);
};
const $a66eb252e0fd4b58$export$4a1b7570b49e9119 = (x)=>{
    const xDomain = x.domain();
    const xDomainLength = xDomain[0] && xDomain[1] && xDomain[1].valueOf() - xDomain[0].valueOf();
    if (xDomainLength > $a66eb252e0fd4b58$var$oneYear) return $834b38f205523964$export$e5cb22533a15e72e(x).ticks($dd6e0f506bfbbd03$export$2e2bcd8739ae039.every(1)).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("")).tickSize(0);
    return $834b38f205523964$export$e5cb22533a15e72e(x).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("W%V")).ticks($7f6029921eecd017$export$6416afaab03bc9b8.every(1)).tickSize(10);
};
const $a66eb252e0fd4b58$export$9ee892d8c45d4bbd = (x, firstGhostEventStartDate)=>{
    const xDomain = x.domain();
    const xDomainLength = xDomain[0] && xDomain[1] && xDomain[1].valueOf() - xDomain[0].valueOf();
    if (xDomainLength > $a66eb252e0fd4b58$var$oneYear) return $834b38f205523964$export$e5cb22533a15e72e(x).ticks($dd6e0f506bfbbd03$export$2e2bcd8739ae039.every(1)).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("")).tickSize(0);
    return $834b38f205523964$export$e5cb22533a15e72e(x).ticks($7f6029921eecd017$export$6416afaab03bc9b8.every(1)).tickFormat((thisDate)=>{
        const startDiff = thisDate.valueOf() - firstGhostEventStartDate;
        const weeks = Math.round(startDiff / $a66eb252e0fd4b58$var$oneWeek);
        return `${weeks}PW`;
    }).tickSize(10);
};
const $a66eb252e0fd4b58$export$fb6939bf153c51df = (weekAxis)=>{
    weekAxis.select(".domain").remove();
    weekAxis.selectAll("text").attr("y", 2).attr("x", 8);
};
const $a66eb252e0fd4b58$export$c9de31ea9c0906a = (x)=>{
    const xDomain = x.domain();
    const xDomainLength = xDomain[0] && xDomain[1] && xDomain[1].valueOf() - xDomain[0].valueOf();
    if (xDomainLength > $a66eb252e0fd4b58$var$threeMonths) return $834b38f205523964$export$e5cb22533a15e72e(x).ticks($dd6e0f506bfbbd03$export$2e2bcd8739ae039.every(1)).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("")).tickSize(0);
    return $834b38f205523964$export$e5cb22533a15e72e(x).tickFormat($0a9ce0165786feda$export$94f4d87fad5dcf9a("%e %a")).ticks($51fe2e20810fcb40$export$2e2bcd8739ae039.every(1)).tickSize(10);
};
const $a66eb252e0fd4b58$export$b1ead7427989bd7f = (dayAxis)=>{
    dayAxis.select(".domain").remove();
    dayAxis.selectAll("text").attr("y", 2).attr("x", 4);
};
const $a66eb252e0fd4b58$export$a6a9f78e87f19008 = (x)=>$834b38f205523964$export$59b8cfab074bdeb1(x).ticks($dd6e0f506bfbbd03$export$2e2bcd8739ae039.every(1)).tickSize($a66eb252e0fd4b58$export$305eb744eb40f4ef).tickFormat((formatAttrib)=>{
        const momentObj = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(formatAttrib.getTime());
        return `${momentObj.format("YYYY")}`;
    });
const $a66eb252e0fd4b58$export$56ef164c7e0d119b = (yearAxis)=>{
    yearAxis.select(".domain").remove();
    yearAxis.selectAll("text").attr("y", -46).attr("x", 8);
};
const $a66eb252e0fd4b58$export$ae562900860eaf36 = (transformZoom)=>{
    let zoomedInLevel = 1;
    if (transformZoom > 2) zoomedInLevel = 2;
    if (transformZoom > 5) zoomedInLevel = 4;
    if (transformZoom > 10) zoomedInLevel = 6;
    if (transformZoom > 20) zoomedInLevel = 10;
    if (transformZoom > 40) zoomedInLevel = 18;
    return zoomedInLevel;
};
const $a66eb252e0fd4b58$export$dbf01c52ad4aabb3 = (transformZoom)=>{
    return 0.5 / $a66eb252e0fd4b58$export$ae562900860eaf36(transformZoom);
};
const $a66eb252e0fd4b58$export$f9045ef5b76f55d6 = (transformZoom)=>{
    const height = 100;
    return (height + 8) * $a66eb252e0fd4b58$export$dbf01c52ad4aabb3(transformZoom);
};
const $a66eb252e0fd4b58$export$201583b01982110e = (width)=>{
    return width < 10;
};
const $a66eb252e0fd4b58$export$3e06f8d5fdc1813a = (ownScale, width)=>{
    const widthOfOtherUIElements = ($a66eb252e0fd4b58$export$201583b01982110e(width) ? -9 : 37) * ownScale;
    const availableWidth = width - widthOfOtherUIElements;
    return availableWidth;
};
const $a66eb252e0fd4b58$export$5cd2a5f4f0b1055 = (size, zoom)=>{
    return size * $a66eb252e0fd4b58$export$dbf01c52ad4aabb3(zoom) * 2;
};
const $a66eb252e0fd4b58$export$a2131950bc31a4d5 = (zoom)=>{
    return $a66eb252e0fd4b58$export$dbf01c52ad4aabb3(zoom) * 2;
};
const $a66eb252e0fd4b58$export$6ff78ae41f052774 = (zoom)=>{
    return $a66eb252e0fd4b58$export$dbf01c52ad4aabb3(zoom) * 4;
};
const $a66eb252e0fd4b58$export$2312b3c5fb51a00b = (zoom)=>{
    return $a66eb252e0fd4b58$export$dbf01c52ad4aabb3(zoom) * 8;
};



var $acw62 = parcelRequire("acw62");


const $ae0c2b5cefbd2eef$export$fd2f0df8d6b00873 = ({ x: x, y: y = (0, $a66eb252e0fd4b58$export$305eb744eb40f4ef), height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        id: "today"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: x,
        x2: x,
        y1: y,
        y2: height,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.frenchGray,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ae0c2b5cefbd2eef$var$Triangle, {
        x: x,
        y: y
    }));
const $ae0c2b5cefbd2eef$var$Triangle = ({ x: x, y: y })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        x: x - 6,
        y: y
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5.34535 5.43305C5.72112 5.75848 6.27888 5.75848 6.65465 5.43305L10.9006 1.75593C11.6005 1.14979 11.1719 0 10.246 0H1.75402C0.828135 0 0.399465 1.14979 1.09937 1.75593L5.34535 5.43305Z",
        fill: "#141419"
    }));



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $dc6fb3e45bbe78f3$var$msToWeeks = (ms)=>Math.ceil(ms / 604800000);
const $dc6fb3e45bbe78f3$export$be536556dc41984e = (workflow)=>{
    const dates = (0, (/*@__PURE__*/$parcel$interopDefault($1cb7998639d45551$exports)))(workflow.services || [], (s)=>[
            parseInt(s.startDate, 10),
            parseInt(s.endDate, 10)
        ]);
    return {
        startDate: $02ed355deaa9e190$export$2e2bcd8739ae039(dates) || 0,
        endDate: $5a964dca3df4eea7$export$2e2bcd8739ae039(dates) || 0
    };
};
const $dc6fb3e45bbe78f3$export$bbd619c0628de8ee = (workflow)=>{
    const range = $dc6fb3e45bbe78f3$export$be536556dc41984e(workflow);
    return range.endDate - range.startDate;
};
const $dc6fb3e45bbe78f3$export$a11918783cae9a97 = (workflow)=>$dc6fb3e45bbe78f3$var$msToWeeks($dc6fb3e45bbe78f3$export$bbd619c0628de8ee(workflow));
const $dc6fb3e45bbe78f3$export$cc4c3d8a5d21b33a = (startDate, endDate)=>`${Math.ceil((parseInt(endDate, 10) - parseInt(startDate, 10)) / 604800000)}w`;
const $dc6fb3e45bbe78f3$export$9082d34138010bda = (color, opacity)=>{
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
};



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");
const $456b87a164f2e791$var$reformatText = (element, string, width)=>{
    if (!element) return;
    const self = $cf81072cf307ee25$export$2e2bcd8739ae039(element);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    let textLength = self.text(string).node().getComputedTextLength();
    if (textLength > width && textLength > 0) {
        let text = string;
        for(let i = 0; text.length > 0 && textLength > width && textLength > 0 && i < 100; i += 1){
            text = text.slice(0, -1);
            self.text(`${text}...`);
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            textLength = self.node().getComputedTextLength();
        }
    }
};
const $456b87a164f2e791$export$87310464d9e20549 = ({ text: text = "", maxWidth: maxWidth = 100, dependenciesArray: dependenciesArray = [], scale: scale = 1, x: x = 0, y: y = 0, fontSize: fontSize = 16, fill: fill = "black", className: className, id: id })=>{
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (ref && ref.current) $456b87a164f2e791$var$reformatText(ref.current, text, maxWidth);
    }, [
        maxWidth,
        scale
    ]);
    return /*#__PURE__*/ $acw62.createElement($456b87a164f2e791$var$Text, {
        ref: ref,
        x: x,
        y: y,
        fontSize: fontSize,
        fill: fill,
        className: className,
        id: id
    }, text);
};
const $456b87a164f2e791$var$Text = (0, $lmFrL.default).text`
  opacity: 0;
  animation: 1s appear forwards;
  animation-delay: 0.4s;

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;


const $0b39e740869c6d21$var$blockHeight = 24;
const $0b39e740869c6d21$var$padding = 4;
var $0b39e740869c6d21$var$Variant = /*#__PURE__*/ function(Variant) {
    Variant["CURRENT"] = "CURRENT";
    Variant["FUTURE"] = "FUTURE";
    Variant["PAST"] = "PAST";
    return Variant;
}($0b39e740869c6d21$var$Variant || {});
const $0b39e740869c6d21$var$getBlockType = (service)=>{
    if (parseFloat(service.startDate) - 864000000 >= new Date().valueOf()) return "FUTURE";
    if (parseFloat(service.endDate) < new Date().valueOf()) return "PAST";
    return "CURRENT";
};
const $0b39e740869c6d21$var$getBlockColor = (variant)=>{
    switch(variant){
        case "FUTURE":
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white;
        case "PAST":
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background;
        case "CURRENT":
        default:
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic;
    }
};
const $0b39e740869c6d21$var$getTextColor = (variant)=>{
    switch(variant){
        case "CURRENT":
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white;
        case "FUTURE":
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText;
        case "PAST":
        default:
            return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray;
    }
};
const $0b39e740869c6d21$export$e00e3183602ac489 = ({ currentTransform: currentTransform, ...service })=>{
    const { width: width, endDate: endDate, startDate: startDate, x: x, y: y } = service;
    const blockType = $0b39e740869c6d21$var$getBlockType(service);
    const textColor = $0b39e740869c6d21$var$getTextColor(blockType);
    return /*#__PURE__*/ $acw62.createElement($0b39e740869c6d21$var$G, null, /*#__PURE__*/ $acw62.createElement("text", {
        className: "tooltip",
        x: x + 5,
        y: y - 10
    }, service.name), /*#__PURE__*/ $acw62.createElement("rect", {
        height: $0b39e740869c6d21$var$blockHeight,
        width: width,
        x: x,
        y: y,
        rx: 8,
        fill: $0b39e740869c6d21$var$getBlockColor(blockType),
        ...blockType === "FUTURE" ? {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.athensGray,
            strokeWidth: "1.5",
            strokeDasharray: "8, 10"
        } : null
    }), /*#__PURE__*/ $acw62.createElement((0, $456b87a164f2e791$export$87310464d9e20549), {
        fill: textColor,
        fontSize: 10,
        x: x + $0b39e740869c6d21$var$padding,
        y: y + $0b39e740869c6d21$var$blockHeight / 2 + $0b39e740869c6d21$var$padding,
        text: service.name,
        maxWidth: Math.max(width - 2 * $0b39e740869c6d21$var$padding - 13, 20)
    }), /*#__PURE__*/ $acw62.createElement("text", {
        fill: textColor,
        fontSize: 10,
        x: x + width - $0b39e740869c6d21$var$padding,
        y: y + $0b39e740869c6d21$var$blockHeight / 2 + $0b39e740869c6d21$var$padding,
        textAnchor: "end",
        fontWeight: "bold"
    }, (0, $dc6fb3e45bbe78f3$export$cc4c3d8a5d21b33a)(startDate, endDate)));
};
const $0b39e740869c6d21$var$G = (0, $lmFrL.default).g`
  .tooltip {
    visibility: hidden;
  }
  :hover .tooltip {
    visibility: visible;
  }
`;
$0b39e740869c6d21$export$e00e3183602ac489.defaultProps = {
    ownScale: 1,
    width: 220,
    height: 100,
    x: 100,
    y: 100
};


const $5cacad1b97470f4d$var$svgId = "timeline-svg";
const $5cacad1b97470f4d$var$timelinePadding = 2592000000; // 30days
const $5cacad1b97470f4d$var$rowHeight = 75;
let $5cacad1b97470f4d$var$dates = null;
let $5cacad1b97470f4d$var$canvasStartDate = 0;
let $5cacad1b97470f4d$var$canvasEndDate = 0;
let $5cacad1b97470f4d$var$worldEndDate = 20000101;
const $5cacad1b97470f4d$export$636de808b66fbd8e = (props)=>{
    const { samples: samples, axisHeight: axisHeight } = props;
    const worldHeight = parseInt(props.height || window.innerHeight, 10);
    const workflows = (0, (/*@__PURE__*/$parcel$interopDefault($1cb7998639d45551$exports)))(samples, (sample)=>(0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(sample, "enabledWorkflows", []));
    let services = [];
    workflows.forEach((workflow)=>{
        services = services.concat(workflow.services);
    });
    services.sort((serviceA, serviceB)=>{
        const serviceALength = serviceA.endDate - serviceA.startDate;
        const serviceBLength = serviceB.endDate - serviceB.startDate;
        return serviceALength - serviceBLength;
    });
    if (!$5cacad1b97470f4d$var$dates) {
        // run this calculation only once
        $5cacad1b97470f4d$var$dates = (0, (/*@__PURE__*/$parcel$interopDefault($1cb7998639d45551$exports)))(services, (s)=>[
                parseFloat(s.startDate),
                parseFloat(s.endDate)
            ]);
        $5cacad1b97470f4d$var$canvasStartDate = $02ed355deaa9e190$export$2e2bcd8739ae039($5cacad1b97470f4d$var$dates) - $5cacad1b97470f4d$var$timelinePadding;
        $5cacad1b97470f4d$var$canvasEndDate = $5cacad1b97470f4d$var$canvasStartDate + 7 * $5cacad1b97470f4d$var$timelinePadding;
        $5cacad1b97470f4d$var$worldEndDate = $5a964dca3df4eea7$export$2e2bcd8739ae039($5cacad1b97470f4d$var$dates) + $5cacad1b97470f4d$var$timelinePadding;
    }
    const [ref, { width: width, height: height }] = (0, $60dc7cc32b6e1f88$export$2e2bcd8739ae039)();
    const wrapperSVGRef = $acw62.useRef(null);
    const axisWrapperGroupRef = $acw62.useRef(null);
    const timelineElementsGroupRef = $acw62.useRef(null);
    const todayGroupRef = $acw62.useRef(null);
    const axisDomain = [
        new Date($5cacad1b97470f4d$var$canvasStartDate),
        new Date($5cacad1b97470f4d$var$canvasEndDate)
    ];
    const axisWidth = width;
    const x = $304372357472b2a4$export$2e2bcd8739ae039().domain(axisDomain).range([
        0,
        axisWidth
    ]);
    const [currentTransform, setCurrentTransform] = (0, $acw62.useState)($a3c1094a2e8782d7$export$f0954fd7d5368655.translate(0, 0).scale(1));
    const baselineHeight = worldHeight / 2 / 4;
    const draw = ()=>{
        const axisWrapperElement = $cf81072cf307ee25$export$2e2bcd8739ae039(axisWrapperGroupRef.current);
        const todayLine = $cf81072cf307ee25$export$2e2bcd8739ae039(todayGroupRef.current);
        axisWrapperElement.selectAll("*").remove();
        const timelineElementsGroup = $cf81072cf307ee25$export$2e2bcd8739ae039(timelineElementsGroupRef.current).attr("cursor", "grab");
        // axis background
        axisWrapperElement.append("rect").attr("x", 0).attr("y", 0).attr("width", axisWidth).attr("height", axisHeight).style("fill", "#ffffff");
        const mAxis = (0, $a66eb252e0fd4b58$export$38bedd7e3ec11e7a)(x);
        const monthsAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-month-axis").attr("transform", "translate(0,45)").call(mAxis);
        (0, $a66eb252e0fd4b58$export$b1ffadcc6dff5329)(monthsAxisHandler);
        const qAxis = (0, $a66eb252e0fd4b58$export$24ff02d6d80a759c)(x);
        const quarterAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-quarter-axis").attr("transform", `translate(0,${axisHeight})`).call(qAxis);
        (0, $a66eb252e0fd4b58$export$359112c5b5d36ed9)(quarterAxisHandler);
        const zoomed = (transformToSet)=>{
            let transform = transformToSet;
            if ($dd1fb49221ad966f$export$6cd530ed55e06764 && $dd1fb49221ad966f$export$6cd530ed55e06764.transform) transform = $dd1fb49221ad966f$export$6cd530ed55e06764.transform;
            transform.k = 1;
            transform.y = 0;
            timelineElementsGroup.attr("transform", transform);
            const updatedX = transform.rescaleX(x);
            const updatedMAxis = (0, $a66eb252e0fd4b58$export$38bedd7e3ec11e7a)(updatedX);
            const updatedMonthsAxisHandler = monthsAxisHandler.call(updatedMAxis);
            (0, $a66eb252e0fd4b58$export$b1ffadcc6dff5329)(updatedMonthsAxisHandler);
            const updatedQAxis = (0, $a66eb252e0fd4b58$export$24ff02d6d80a759c)(updatedX);
            const updatedQuarterAxisHandler = quarterAxisHandler.call(updatedQAxis);
            (0, $a66eb252e0fd4b58$export$359112c5b5d36ed9)(updatedQuarterAxisHandler);
            todayLine.attr("transform", transform);
            setCurrentTransform(transform);
        };
        // eslint-disable-next-line consistent-return
        const zoom = $91e02783b8b1c24a$export$2e2bcd8739ae039().on("zoom", zoomed);
        const todayLineXPosition = x(new Date().valueOf()) * currentTransform.k + currentTransform.x;
        $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call(zoom.translateTo, todayLineXPosition, 0);
        $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call(zoom);
    };
    const drawLines = ()=>{
        const lines = [];
        const monthStart = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($5cacad1b97470f4d$var$canvasStartDate).startOf("month");
        const monthStartTimestamp = monthStart.valueOf();
        const lastWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($5cacad1b97470f4d$var$worldEndDate).endOf("month");
        const numberOfMonths = lastWeek.diff(monthStart, "month");
        const numberOfMonthsToDraw = numberOfMonths + 1;
        for(let week = 0; week < numberOfMonthsToDraw; week += 1){
            const xPos = x((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(monthStartTimestamp).add(week, "month").valueOf()) + 0.5;
            lines.push(/*#__PURE__*/ $acw62.createElement("line", {
                x1: xPos,
                x2: xPos,
                y1: axisHeight,
                y2: 2000,
                stroke: "#c0c0c0",
                strokeWidth: "0.5"
            }));
        }
        return lines;
    };
    $acw62.useEffect(()=>{
        draw();
    }, [
        axisWidth,
        height,
        width
    ]);
    return /*#__PURE__*/ $acw62.createElement($5cacad1b97470f4d$var$TimelineContainer, {
        ref: ref,
        width: props.width,
        height: props.height
    }, axisWidth && /*#__PURE__*/ $acw62.createElement($5cacad1b97470f4d$var$StyledSVG, {
        id: $5cacad1b97470f4d$var$svgId,
        ref: wrapperSVGRef
    }, /*#__PURE__*/ $acw62.createElement("line", {
        x1: 0,
        x2: x($5cacad1b97470f4d$var$canvasEndDate),
        y1: axisHeight,
        y2: axisHeight,
        stroke: "#c0c0c0",
        strokeWidth: "1"
    }), /*#__PURE__*/ $acw62.createElement((0, $ae0c2b5cefbd2eef$export$fd2f0df8d6b00873), {
        x: x(new Date().valueOf()) * currentTransform.k + currentTransform.x,
        y: axisHeight,
        height: height
    }), /*#__PURE__*/ $acw62.createElement("g", {
        id: "timeline",
        width: width,
        height: height,
        ref: timelineElementsGroupRef
    }, drawLines(), samples.map((sample, sampleIndex)=>{
        const sampleWorkflows = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(sample, "enabledWorkflows", []);
        let sampleServices = [];
        sampleWorkflows.forEach((workflow)=>{
            sampleServices = sampleServices.concat(workflow.services);
        });
        return sampleServices.map((service)=>{
            return /*#__PURE__*/ $acw62.createElement((0, $0b39e740869c6d21$export$e00e3183602ac489), {
                baselineHeight: baselineHeight,
                ...service,
                y: axisHeight + sampleIndex * $5cacad1b97470f4d$var$rowHeight + 40,
                x: x(service.startDate),
                width: x(service.endDate) - x(service.startDate),
                currentTransform: currentTransform,
                key: service.id
            });
        });
    })), /*#__PURE__*/ $acw62.createElement("g", {
        id: "axis",
        width: width,
        height: height,
        ref: axisWrapperGroupRef
    })));
};
$5cacad1b97470f4d$export$636de808b66fbd8e.defaultProps = {
    axisHeight: 68
};
const $5cacad1b97470f4d$var$TimelineContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  width: ${({ width: width })=>width || "100vw"};
  height: ${({ height: height })=>height || "100vh"};
`;
const $5cacad1b97470f4d$var$StyledSVG = (0, $lmFrL.default).svg`
  width: calc(100%);
  height: calc(100%);
  max-width: 100%;
  max-height: 100%;
  background-color: white;
`;




const $62add3022bb9940f$export$8de5df859f5ec9aa = (props)=>{
    const { projectId: projectId } = props;
    const { loading: loading, error: error, data: data } = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: projectId
        }
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62add3022bb9940f$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe7277f9493cf0da$export$b42aec0a4a94c970), {
        size: 150
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5cacad1b97470f4d$export$636de808b66fbd8e), {
        samples: data.Project.samples,
        width: "100%",
        height: "100%"
    });
};
const $62add3022bb9940f$var$SpinnerContainer = (0, $lmFrL.default).div`
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;


const $7ada376125d62762$export$1f6ea786a1aef0ab = (props)=>{
    const { projectId: projectId, projectName: projectName, projectLastActivity: projectLastActivity, samples: samples, isOpen: isOpen, onClick: onClick } = props;
    const isDataContent = samples && samples.length || false;
    const [shouldRenderTimeline, setShouldRenderTimeline] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [contentHeight, setContentHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isOpen ? -1 : 0);
    const toggleContent = ()=>{
        if (isDataContent) setContentHeight(contentHeight === 0 ? -1 : 0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$Card, {
        onClick: onClick || toggleContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$IconContainer, {
        expanded: contentHeight === -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02e5d8dbcf160953$export$4857d3f3f5f8319b), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $101f8b71a8c9f73f$export$a27b844eb741593c), {
        name: projectName,
        lastActivity: projectLastActivity
    }), isDataContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$ServiceStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7af627254c90ada$export$a522ceaa9e4a21ee), {
        name: "Protein production optimization",
        sampleName: samples[0].name,
        remaining: "2w remaining"
    })) : null), isDataContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($92307008e8584b85$exports))), {
        duration: 500,
        height: contentHeight === -1 ? "auto" : contentHeight,
        onAnimationEnd: ()=>setShouldRenderTimeline(!shouldRenderTimeline)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$SamplesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$LabelContainer, null, "PATHS"), samples.filter((sample)=>sample.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing).map((sample)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a481c221d5871b5$export$f07a8d48ec1fa3cd), {
            key: sample.id,
            id: sample.id,
            name: sample.name,
            percent: sample.percent,
            status: sample.status
        })), samples.filter((sample)=>sample.status !== (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing).map((sample)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a481c221d5871b5$export$f07a8d48ec1fa3cd), {
            key: sample.id,
            id: sample.id,
            name: sample.name,
            percent: sample.percent,
            status: sample.status
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ada376125d62762$var$TimelineContainer, null, shouldRenderTimeline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $62add3022bb9940f$export$8de5df859f5ec9aa), {
        projectId: projectId
    }) : null))) : null);
};
$7ada376125d62762$export$1f6ea786a1aef0ab.defaultProps = {
    isOpen: false,
    onClick: undefined
};
const $7ada376125d62762$var$Container = (0, $lmFrL.default).div``;
const $7ada376125d62762$var$Card = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 24px;

  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.dropShadows.formCard};
  border-radius: 4px;
  cursor: pointer;
`;
const $7ada376125d62762$var$IconContainer = (0, $lmFrL.default).div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  svg {
    ${({ expanded: expanded })=>expanded ? "transform: rotate(-90deg); margin-left: 2px;" : "transform: rotate(0deg); margin-top: 1px;"}
  }
`;
const $7ada376125d62762$var$ServiceStatusContainer = (0, $lmFrL.default).div`
  margin-left: auto;
  width: 260px;
  padding: 12px;
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 4px;
`;
const $7ada376125d62762$var$ContentContainer = (0, $lmFrL.default).div`
  display: flex;
  margin: 16px 0;
`;
const $7ada376125d62762$var$SamplesContainer = (0, $lmFrL.default).div`
  width: 376px;
  margin-right: 24px;
  padding-top: 64px;

  > div {
    margin-top: 8px;
  }

  > div:first-child {
    margin-top: 0;
  }
`;
const $7ada376125d62762$var$LabelContainer = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray};
`;
const $7ada376125d62762$var$TimelineContainer = (0, $lmFrL.default).div`
  background-color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  flex-grow: 1;
`;






const $3bbf7b1e5596dfc1$export$95b0eef4b9606f6e = (sample)=>{
    const services = [];
    sample.enabledWorkflows.forEach((workflow)=>{
        services.push(...workflow.services);
    });
    const numberOfServices = services.length || 1;
    const finishedServices = services.filter((service)=>service.status === "Finished");
    const numberOfFinishedServices = finishedServices.length;
    return numberOfFinishedServices / numberOfServices;
};
const $3bbf7b1e5596dfc1$export$57b3d59defb99e59 = (fraction)=>Math.ceil(fraction * 100);




const $3574c953af361bd9$export$ce8e6cb7a6a45690 = (sample)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(sample, "selectedQuestionGroups[0].questionSets[0].questions[0].answer.textBody", sample.name);
};


const $86c61f6c97c0a9f7$export$99bffacbdbcb5195 = (props)=>{
    const queryResult = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)({
        variables: {}
    });
    // useEffect(() => {
    //   const projects = (queryResult.data && queryResult.data.Projects) || [];
    //   if (projects.length && !projectsHaveOngoingSamples(projects)) {
    //     navigate(`/projects/${projects[0].id}/configurator`);
    //   }
    // }, [JSON.stringify(queryResult.data)]);
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = queryResult.data.Projects || [];
    const projectsNumber = projects.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "All projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d241d256ce3eb5d1$export$4fb75e6b75cdeeea), {
        projectsNumber: projectsNumber,
        selectedView: "list"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($86c61f6c97c0a9f7$var$ProjectsContainer, null, projects.map((project)=>{
        const samples = project.samples.map((sample)=>({
                ...sample,
                name: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample),
                percent: (0, $3bbf7b1e5596dfc1$export$57b3d59defb99e59)((0, $3bbf7b1e5596dfc1$export$95b0eef4b9606f6e)(sample))
            }));
        // const projectOnClick = !projectHasOngoingSamples(project)
        //   ? (): void => {
        //       navigate(`/projects/${project.id}/configurator`);
        //     }
        //   : undefined;
        const projectOnClick = undefined;
        const projectLastActivityDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(project.lastActivity ? parseInt(project.lastActivity, 10) : undefined).format("Do MMMM YYYY");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ada376125d62762$export$1f6ea786a1aef0ab), {
            key: project.id,
            samples: samples,
            projectLastActivity: projectLastActivityDateString,
            projectId: project.id,
            projectName: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            onClick: projectOnClick
        });
    })));
};
const $86c61f6c97c0a9f7$var$ProjectsContainer = (0, $lmFrL.default).div`
  > div {
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-bottom: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  }

  > div:last-child {
    border-bottom: 0;
  }
`;



var $acw62 = parcelRequire("acw62");

var $d9f195cb3938646c$exports = {};

var $6d38303b9c8735ba$exports = {};

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;


var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;




/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $1043210e43b88f26$export$b131c49b26d3f427 = (props)=>{
    const { width: width, height: height, color: color, editing: editing } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, editing ? /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3.5",
        stroke: color
    }) : /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "4",
        fill: color
    }));
};
$1043210e43b88f26$export$b131c49b26d3f427.defaultProps = {
    width: "8",
    height: "8",
    editing: false,
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
};


var $2d7ecd00adce73e7$export$e35c1996c6f482ad = /*#__PURE__*/ function(StatusType) {
    StatusType[StatusType["Editing"] = 0] = "Editing";
    StatusType[StatusType["Done"] = 1] = "Done";
    StatusType[StatusType["Warning"] = 2] = "Warning";
    StatusType[StatusType["Error"] = 3] = "Error";
    return StatusType;
}({});
const $2d7ecd00adce73e7$export$c742923ea4ac4c1c = (type)=>{
    switch(type){
        case 0:
        default:
            return /*#__PURE__*/ $acw62.createElement((0, $1043210e43b88f26$export$b131c49b26d3f427), {
                editing: true
            });
        case 1:
            return /*#__PURE__*/ $acw62.createElement((0, $1043210e43b88f26$export$b131c49b26d3f427), null);
        case 3:
            return /*#__PURE__*/ $acw62.createElement((0, $1043210e43b88f26$export$b131c49b26d3f427), {
                color: "#DE2D26"
            });
        case 2:
            return /*#__PURE__*/ $acw62.createElement((0, $1043210e43b88f26$export$b131c49b26d3f427), {
                color: "#EAB838"
            });
    }
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");





var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
var $0602938f4da0bcb6$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $0602938f4da0bcb6$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $0602938f4da0bcb6$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $0602938f4da0bcb6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$0602938f4da0bcb6$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($0602938f4da0bcb6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0602938f4da0bcb6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $52dee30992af07b2$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $7e98d1a8eb8f05d8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $27316482380efac7$var$isBrowser = typeof document !== 'undefined';
var $27316482380efac7$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $27316482380efac7$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $27316482380efac7$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $27316482380efac7$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($27316482380efac7$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $27316482380efac7$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $27316482380efac7$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$27316482380efac7$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $27316482380efac7$var$fixedElements.set(element, true);
    var points = [];
    var rules = $27316482380efac7$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $27316482380efac7$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $27316482380efac7$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $27316482380efac7$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $27316482380efac7$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $27316482380efac7$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $27316482380efac7$var$getServerStylisCache = $27316482380efac7$var$isBrowser ? undefined : (0, $52dee30992af07b2$export$2e2bcd8739ae039)(function() {
    return (0, $7e98d1a8eb8f05d8$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $27316482380efac7$var$defaultStylisPlugins = [
    $27316482380efac7$var$prefixer
];
var $27316482380efac7$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($27316482380efac7$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $27316482380efac7$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($27316482380efac7$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $27316482380efac7$var$compat,
        $27316482380efac7$var$removeLabel
    ];
    if (!$27316482380efac7$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $27316482380efac7$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $0602938f4da0bcb6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};



var $8nd05 = parcelRequire("8nd05");


var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};


var $3eb4a1cfca695181$var$isBrowser = typeof document !== 'undefined';
function $3eb4a1cfca695181$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $3eb4a1cfca695181$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $3eb4a1cfca695181$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $3eb4a1cfca695181$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $3eb4a1cfca695181$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$3eb4a1cfca695181$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$3eb4a1cfca695181$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a7434f6fdfbe0a68$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $83d8ffc844fd6556$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $47ea2f8033c6cc11$var$isDevelopment = false;
var $47ea2f8033c6cc11$var$hyphenateRegex = /[A-Z]|^ms/g;
var $47ea2f8033c6cc11$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $47ea2f8033c6cc11$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $47ea2f8033c6cc11$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $47ea2f8033c6cc11$var$processStyleName = /* #__PURE__ */ (0, $7e98d1a8eb8f05d8$export$2e2bcd8739ae039)(function(styleName) {
    return $47ea2f8033c6cc11$var$isCustomProperty(styleName) ? styleName : styleName.replace($47ea2f8033c6cc11$var$hyphenateRegex, '-$&').toLowerCase();
});
var $47ea2f8033c6cc11$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($47ea2f8033c6cc11$var$animationRegex, function(match, p1, p2) {
                $47ea2f8033c6cc11$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $47ea2f8033c6cc11$var$cursor
                };
                return p1;
            });
    }
    if ((0, $83d8ffc844fd6556$export$2e2bcd8739ae039)[key] !== 1 && !$47ea2f8033c6cc11$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $47ea2f8033c6cc11$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $47ea2f8033c6cc11$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $47ea2f8033c6cc11$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $47ea2f8033c6cc11$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $47ea2f8033c6cc11$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $47ea2f8033c6cc11$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $47ea2f8033c6cc11$var$cursor;
                var result = interpolation(mergedProps);
                $47ea2f8033c6cc11$var$cursor = previousCursor;
                return $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $47ea2f8033c6cc11$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($47ea2f8033c6cc11$var$isProcessableValue(asString)) string += $47ea2f8033c6cc11$var$processStyleName(key) + ":" + $47ea2f8033c6cc11$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $47ea2f8033c6cc11$var$isDevelopment) throw new Error($47ea2f8033c6cc11$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($47ea2f8033c6cc11$var$isProcessableValue(value[_i])) string += $47ea2f8033c6cc11$var$processStyleName(key) + ":" + $47ea2f8033c6cc11$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $47ea2f8033c6cc11$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $47ea2f8033c6cc11$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $47ea2f8033c6cc11$var$cursor;
function $47ea2f8033c6cc11$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $47ea2f8033c6cc11$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $47ea2f8033c6cc11$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $47ea2f8033c6cc11$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $47ea2f8033c6cc11$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $a7434f6fdfbe0a68$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $47ea2f8033c6cc11$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;


var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $27316482380efac7$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $27316482380efac7$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $52dee30992af07b2$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $52dee30992af07b2$export$2e2bcd8739ae039)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $794b155aeb6b00fd$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3eb4a1cfca695181$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $3eb4a1cfca695181$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $3eb4a1cfca695181$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $47ea2f8033c6cc11$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;




parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $acad92301ef10c3f$export$dda1d9f60106f0e9).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $acad92301ef10c3f$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $acad92301ef10c3f$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $acad92301ef10c3f$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $47ea2f8033c6cc11$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $acad92301ef10c3f$export$971d5caa766a69d7)));
    if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3eb4a1cfca695181$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $47ea2f8033c6cc11$export$6321afa313b251b5)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3eb4a1cfca695181$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $3eb4a1cfca695181$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $acad92301ef10c3f$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $acad92301ef10c3f$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $47ea2f8033c6cc11$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3eb4a1cfca695181$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $acad92301ef10c3f$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $acad92301ef10c3f$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});


function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $1En50.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $fSwVM = parcelRequire("fSwVM");
var $5dda1db15c8c646c$exports = {};
'use strict';
Object.defineProperty($5dda1db15c8c646c$exports, "__esModule", {
    value: true
});
var $5dda1db15c8c646c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5dda1db15c8c646c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $5dda1db15c8c646c$var$_react2 = $5dda1db15c8c646c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $5dda1db15c8c646c$var$_propTypes2 = $5dda1db15c8c646c$var$_interopRequireDefault($c9Z8w);
function $5dda1db15c8c646c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dda1db15c8c646c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5dda1db15c8c646c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dda1db15c8c646c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5dda1db15c8c646c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5dda1db15c8c646c$var$sizerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    visibility: 'hidden',
    height: 0,
    overflow: 'scroll',
    whiteSpace: 'pre'
};
var $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST = [
    'extraWidth',
    'injectStyles',
    'inputClassName',
    'inputRef',
    'inputStyle',
    'minWidth',
    'onAutosize',
    'placeholderIsMinWidth'
];
var $5dda1db15c8c646c$var$cleanInputProps = function cleanInputProps(inputProps) {
    $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $5dda1db15c8c646c$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $5dda1db15c8c646c$var$isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $5dda1db15c8c646c$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $5dda1db15c8c646c$var$isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};
var $5dda1db15c8c646c$var$AutosizeInput = function(_Component) {
    $5dda1db15c8c646c$var$_inherits(AutosizeInput, _Component);
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, null, [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $5dda1db15c8c646c$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $5dda1db15c8c646c$var$_classCallCheck(this, AutosizeInput);
        var _this = $5dda1db15c8c646c$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === 'function') _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $5dda1db15c8c646c$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === 'function') this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: 'copyInputStyles',
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $5dda1db15c8c646c$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $5dda1db15c8c646c$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: 'updateInputWidth',
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: 'blur',
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: 'select',
            value: function select() {
                this.input.select();
            }
        },
        {
            key: 'renderStyles',
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $5dda1db15c8c646c$var$isIE && injectStyles ? $5dda1db15c8c646c$var$_react2.default.createElement('style', {
                    dangerouslySetInnerHTML: {
                        __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
                    }
                }) : null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ''
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $5dda1db15c8c646c$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
                var inputStyle = $5dda1db15c8c646c$var$_extends({
                    boxSizing: 'content-box',
                    width: this.state.inputWidth + 'px'
                }, this.props.inputStyle);
                var inputProps = $5dda1db15c8c646c$var$_objectWithoutProperties(this.props, []);
                $5dda1db15c8c646c$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $5dda1db15c8c646c$var$_react2.default.createElement('div', {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $5dda1db15c8c646c$var$_react2.default.createElement('input', $5dda1db15c8c646c$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $5dda1db15c8c646c$var$_react2.default.createElement('div', {
                    ref: this.sizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $5dda1db15c8c646c$var$_react2.default.createElement('div', {
                    ref: this.placeHolderSizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($acw62.Component);
$5dda1db15c8c646c$var$AutosizeInput.propTypes = {
    className: $5dda1db15c8c646c$var$_propTypes2.default.string,
    defaultValue: $5dda1db15c8c646c$var$_propTypes2.default.any,
    extraWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    id: $5dda1db15c8c646c$var$_propTypes2.default.string,
    injectStyles: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    inputClassName: $5dda1db15c8c646c$var$_propTypes2.default.string,
    inputRef: $5dda1db15c8c646c$var$_propTypes2.default.func,
    inputStyle: $5dda1db15c8c646c$var$_propTypes2.default.object,
    minWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    onAutosize: $5dda1db15c8c646c$var$_propTypes2.default.func,
    onChange: $5dda1db15c8c646c$var$_propTypes2.default.func,
    placeholder: $5dda1db15c8c646c$var$_propTypes2.default.string,
    placeholderIsMinWidth: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    style: $5dda1db15c8c646c$var$_propTypes2.default.object,
    value: $5dda1db15c8c646c$var$_propTypes2.default.any // field value
};
$5dda1db15c8c646c$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
$5dda1db15c8c646c$exports.default = $5dda1db15c8c646c$var$AutosizeInput;


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $cHPF9 = parcelRequire("cHPF9");

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $VFVve.default)(subClass, superClass);
}



var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $4ZreY.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $07378f5e4d664a8b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $07378f5e4d664a8b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07378f5e4d664a8b$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07378f5e4d664a8b$var$ownKeys(Object(source), true).forEach(function(key) {
            $07378f5e4d664a8b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07378f5e4d664a8b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $07378f5e4d664a8b$var$_getPrototypeOf(o) {
    $07378f5e4d664a8b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $07378f5e4d664a8b$var$_getPrototypeOf(o);
}
function $07378f5e4d664a8b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $07378f5e4d664a8b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $07378f5e4d664a8b$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $07378f5e4d664a8b$var$_assertThisInitialized(self);
}
function $07378f5e4d664a8b$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = $07378f5e4d664a8b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $07378f5e4d664a8b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $07378f5e4d664a8b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $07378f5e4d664a8b$var$_possibleConstructorReturn(this, result);
    };
}
// ==============================
// NO OP
// ==============================
var $07378f5e4d664a8b$export$2329c99376c9d0a4 = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $07378f5e4d664a8b$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $07378f5e4d664a8b$export$ef35774e6d314e91(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($07378f5e4d664a8b$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
} // ==============================
// Clean Value
// ==============================
var $07378f5e4d664a8b$export$a9c23c6ac3fc3eca = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Clean Common Props
// ==============================
var $07378f5e4d664a8b$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, [
        "className",
        "clearValue",
        "cx",
        "getStyles",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue",
        "theme"
    ]);
    return $07378f5e4d664a8b$export$407448d2b89b1813({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================
function $07378f5e4d664a8b$export$7f8ddf7c7c20b3cd(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $07378f5e4d664a8b$export$96f57966bedc81b4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $07378f5e4d664a8b$var$getScrollTop(el) {
    if ($07378f5e4d664a8b$export$96f57966bedc81b4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $07378f5e4d664a8b$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($07378f5e4d664a8b$export$96f57966bedc81b4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $07378f5e4d664a8b$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === 'fixed') return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $07378f5e4d664a8b$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $07378f5e4d664a8b$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $07378f5e4d664a8b$export$2329c99376c9d0a4;
    var start = $07378f5e4d664a8b$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $07378f5e4d664a8b$var$easeOutCubic(currentTime, start, change, duration);
        $07378f5e4d664a8b$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $07378f5e4d664a8b$export$d66501df72047452(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $07378f5e4d664a8b$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $07378f5e4d664a8b$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $07378f5e4d664a8b$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $07378f5e4d664a8b$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $07378f5e4d664a8b$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $07378f5e4d664a8b$var$passiveOptionAccessed = false;
var $07378f5e4d664a8b$var$options = {
    get passive () {
        return $07378f5e4d664a8b$var$passiveOptionAccessed = true;
    }
}; // check for SSR
var $07378f5e4d664a8b$var$w = typeof window !== 'undefined' ? window : {};
if ($07378f5e4d664a8b$var$w.addEventListener && $07378f5e4d664a8b$var$w.removeEventListener) {
    $07378f5e4d664a8b$var$w.addEventListener('p', $07378f5e4d664a8b$export$2329c99376c9d0a4, $07378f5e4d664a8b$var$options);
    $07378f5e4d664a8b$var$w.removeEventListener('p', $07378f5e4d664a8b$export$2329c99376c9d0a4, false);
}
var $07378f5e4d664a8b$export$2408f22a0fab9ae5 = $07378f5e4d664a8b$var$passiveOptionAccessed;
function $07378f5e4d664a8b$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $07378f5e4d664a8b$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $07378f5e4d664a8b$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === 'bottom') {
                if (shouldScroll) $07378f5e4d664a8b$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $07378f5e4d664a8b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $07378f5e4d664a8b$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $07378f5e4d664a8b$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $07378f5e4d664a8b$export$7ccc53e8f1e7dfc5 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: 'menu'
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, $07378f5e4d664a8b$var$alignToControl(placement), '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "backgroundColor", colors.neutral0), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "borderRadius", borderRadius), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "marginBottom", spacing.menuGutter), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "marginTop", spacing.menuGutter), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "position", 'absolute'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "width", '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, "zIndex", 1), _ref3;
};
var $07378f5e4d664a8b$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $07378f5e4d664a8b$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(MenuPlacer, _Component);
    var _super = $07378f5e4d664a8b$export$71511d61b312f219(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === 'fixed';
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $07378f5e4d664a8b$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $07378f5e4d664a8b$var$coercePlacement(menuPlacement);
            return $07378f5e4d664a8b$export$407448d2b89b1813($07378f5e4d664a8b$export$407448d2b89b1813({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $cHPF9.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $acw62.Component));
$07378f5e4d664a8b$export$3a1a48c8f6ef640e.contextType = $07378f5e4d664a8b$var$PortalPlacementContext;
var $07378f5e4d664a8b$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('menu', props),
        className: cx({
            menu: true
        }, className),
        ref: innerRef
    }, innerProps), children);
};
// Menu List
// ==============================
var $07378f5e4d664a8b$export$ae1af26003f05816 = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: 'auto',
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    };
};
var $07378f5e4d664a8b$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('menuList', props),
        className: cx({
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $07378f5e4d664a8b$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: 'center'
    };
};
var $07378f5e4d664a8b$export$3b14a55fb2447963 = $07378f5e4d664a8b$var$noticeCSS;
var $07378f5e4d664a8b$export$953cecd6e717a553 = $07378f5e4d664a8b$var$noticeCSS;
var $07378f5e4d664a8b$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('noOptionsMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--no-options': true
        }, className)
    }, innerProps), children);
};
$07378f5e4d664a8b$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $07378f5e4d664a8b$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('loadingMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--loading': true
        }, className)
    }, innerProps), children);
};
$07378f5e4d664a8b$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================
var $07378f5e4d664a8b$export$ffb5f4729a158638 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $07378f5e4d664a8b$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(MenuPortal, _Component2);
    var _super2 = $07378f5e4d664a8b$export$71511d61b312f219(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $07378f5e4d664a8b$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $cHPF9.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === 'fixed'; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $07378f5e4d664a8b$var$coercePlacement(menuPlacement);
                var rect = $07378f5e4d664a8b$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
                    css: getStyles('menuPortal', state),
                    className: cx({
                        'menu-portal': true
                    }, className)
                }, innerProps), children);
                return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $acw62.Component));
var $07378f5e4d664a8b$export$4368d992c4eafac0 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : null,
        pointerEvents: isDisabled ? 'none' : null,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $07378f5e4d664a8b$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('container', props),
        className: cx({
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $07378f5e4d664a8b$export$4a5767248b18ef41 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    };
};
var $07378f5e4d664a8b$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('valueContainer', props),
        className: cx({
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        }, className)
    }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================
var $07378f5e4d664a8b$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $07378f5e4d664a8b$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('indicatorsContainer', props),
        className: cx({
            indicators: true
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$var$_templateObject;
function $07378f5e4d664a8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $07378f5e4d664a8b$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $07378f5e4d664a8b$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, [
        "size"
    ]);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $07378f5e4d664a8b$var$_ref2
    }, props));
};
var $07378f5e4d664a8b$var$CrossIcon = function CrossIcon(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $07378f5e4d664a8b$var$DownChevron = function DownChevron(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $07378f5e4d664a8b$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: 'indicatorContainer',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $07378f5e4d664a8b$export$2d1720544b23b823 = $07378f5e4d664a8b$var$baseCSS;
var $07378f5e4d664a8b$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('dropdownIndicator', props),
        className: cx({
            indicator: true,
            'dropdown-indicator': true
        }, className)
    }, innerProps), children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$DownChevron, null));
};
var $07378f5e4d664a8b$export$8b22cf2602fb60ce = $07378f5e4d664a8b$var$baseCSS;
var $07378f5e4d664a8b$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('clearIndicator', props),
        className: cx({
            indicator: true,
            'clear-indicator': true
        }, className)
    }, innerProps), children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $07378f5e4d664a8b$export$35e795649ee09318 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $07378f5e4d664a8b$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", (0, $8nd05.default)({}, innerProps, {
        css: getStyles('indicatorSeparator', props),
        className: cx({
            'indicator-separator': true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $07378f5e4d664a8b$var$loadingDotAnimations = (0, $e0f035ab0866fe47$export$d25ddfdf17c3ad3e)($07378f5e4d664a8b$var$_templateObject || ($07378f5e4d664a8b$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $07378f5e4d664a8b$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: 'loadingIndicator',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    };
};
var $07378f5e4d664a8b$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $e0f035ab0866fe47$export$dbf350e5966cf602)({
            animation: "".concat($07378f5e4d664a8b$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : null,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $07378f5e4d664a8b$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('loadingIndicator', props),
        className: cx({
            indicator: true,
            'loading-indicator': true
        }, className)
    }, innerProps), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$07378f5e4d664a8b$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $07378f5e4d664a8b$export$f1e1789686576879 = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: 'control',
        alignItems: 'center',
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $07378f5e4d664a8b$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        ref: innerRef,
        css: getStyles('control', props),
        className: cx({
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $07378f5e4d664a8b$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('group', props),
        className: cx({
            group: true
        }, className)
    }, innerProps), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", null, children));
};
var $07378f5e4d664a8b$export$dda1d9f60106f0e9 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: 'group',
        color: '#999',
        cursor: 'default',
        display: 'block',
        fontSize: '75%',
        fontWeight: '500',
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    };
};
var $07378f5e4d664a8b$var$GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles, cx = props.cx, className = props.className;
    var _cleanCommonProps = $07378f5e4d664a8b$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, [
        "data"
    ]);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('groupHeading', props),
        className: cx({
            'group-heading': true
        }, className)
    }, innerProps));
};
var $07378f5e4d664a8b$export$342063e11d6c3cad = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? 'hidden' : 'visible',
        color: colors.neutral80
    };
};
var $07378f5e4d664a8b$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: 'input',
        background: 0,
        border: 0,
        fontSize: 'inherit',
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: 'inherit'
    };
};
var $07378f5e4d664a8b$var$Input = function Input(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles;
    var _cleanCommonProps = $07378f5e4d664a8b$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, [
        "innerRef",
        "isDisabled",
        "isHidden"
    ]);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", {
        css: getStyles('input', props)
    }, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($5dda1db15c8c646c$exports))), (0, $8nd05.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $07378f5e4d664a8b$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $07378f5e4d664a8b$export$9e5f44173e64f162 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: 'multiValue',
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: 'flex',
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $07378f5e4d664a8b$export$43caf9889c228507 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        overflow: 'hidden',
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? 'ellipsis' : null,
        whiteSpace: 'nowrap'
    };
};
var $07378f5e4d664a8b$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: 'center',
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: 'flex',
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $07378f5e4d664a8b$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $07378f5e4d664a8b$var$MultiValueContainer = $07378f5e4d664a8b$var$MultiValueGeneric;
var $07378f5e4d664a8b$var$MultiValueLabel = $07378f5e4d664a8b$var$MultiValueGeneric;
function $07378f5e4d664a8b$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", innerProps, children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($07378f5e4d664a8b$var$CrossIcon, {
        size: 14
    }));
}
var $07378f5e4d664a8b$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, $e0f035ab0866fe47$export$9b9c0f9d9f3552b8), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Container, {
            data: data,
            innerProps: $07378f5e4d664a8b$export$407448d2b89b1813({
                className: emotionCx(css(getStyles('multiValue', props)), cx({
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }, className))
            }, innerProps),
            selectProps: selectProps
        }, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
                    'multi-value__label': true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Remove, {
            data: data,
            innerProps: $07378f5e4d664a8b$export$407448d2b89b1813({
                className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
                    'multi-value__remove': true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$07378f5e4d664a8b$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $07378f5e4d664a8b$export$90a7f3efeed30595 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'option',
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $07378f5e4d664a8b$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('option', props),
        className: cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$efccba1c4a2ef57b = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'placeholder',
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $07378f5e4d664a8b$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('placeholder', props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$d141bba7fdc215a3 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'singleValue',
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $07378f5e4d664a8b$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $8nd05.default)({
        css: getStyles('singleValue', props),
        className: cx({
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }, className)
    }, innerProps), children);
};
var $07378f5e4d664a8b$export$db3b6bfb95261072 = {
    ClearIndicator: $07378f5e4d664a8b$var$ClearIndicator,
    Control: $07378f5e4d664a8b$var$Control,
    DropdownIndicator: $07378f5e4d664a8b$var$DropdownIndicator,
    DownChevron: $07378f5e4d664a8b$var$DownChevron,
    CrossIcon: $07378f5e4d664a8b$var$CrossIcon,
    Group: $07378f5e4d664a8b$var$Group,
    GroupHeading: $07378f5e4d664a8b$var$GroupHeading,
    IndicatorsContainer: $07378f5e4d664a8b$var$IndicatorsContainer,
    IndicatorSeparator: $07378f5e4d664a8b$var$IndicatorSeparator,
    Input: $07378f5e4d664a8b$var$Input,
    LoadingIndicator: $07378f5e4d664a8b$var$LoadingIndicator,
    Menu: $07378f5e4d664a8b$var$Menu,
    MenuList: $07378f5e4d664a8b$var$MenuList,
    MenuPortal: $07378f5e4d664a8b$var$MenuPortal,
    LoadingMessage: $07378f5e4d664a8b$var$LoadingMessage,
    NoOptionsMessage: $07378f5e4d664a8b$var$NoOptionsMessage,
    MultiValue: $07378f5e4d664a8b$var$MultiValue,
    MultiValueContainer: $07378f5e4d664a8b$var$MultiValueContainer,
    MultiValueLabel: $07378f5e4d664a8b$var$MultiValueLabel,
    MultiValueRemove: $07378f5e4d664a8b$var$MultiValueRemove,
    Option: $07378f5e4d664a8b$var$Option,
    Placeholder: $07378f5e4d664a8b$var$Placeholder,
    SelectContainer: $07378f5e4d664a8b$var$SelectContainer,
    SingleValue: $07378f5e4d664a8b$var$SingleValue,
    ValueContainer: $07378f5e4d664a8b$var$ValueContainer
};
var $07378f5e4d664a8b$export$e7094788287c5e9b = function defaultComponents(props) {
    return $07378f5e4d664a8b$export$407448d2b89b1813($07378f5e4d664a8b$export$407448d2b89b1813({}, $07378f5e4d664a8b$export$db3b6bfb95261072), props.components);
};




var $cHPF9 = parcelRequire("cHPF9");

function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");

var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;



function $0c1496466ef568ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0c1496466ef568ed$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $0c1496466ef568ed$var$A11yText = function A11yText(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", (0, $8nd05.default)({
        css: $0c1496466ef568ed$var$_ref
    }, props));
};
var $0c1496466ef568ed$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, _props$focused = props.focused, focused = _props$focused === void 0 ? {} : _props$focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $0c1496466ef568ed$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, $0c1496466ef568ed$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]); // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, removedValue = ariaSelection.removedValue, value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            var selected = removedValue || option || asOption(value);
            var onChangeProps = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
                isDisabled: selected && isOptionDisabled(selected),
                label: selected ? getOptionLabel(selected) : ''
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        isOptionDisabled,
        getOptionLabel,
        messages
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused),
                isSelected: isSelected,
                options: options,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        options,
        selectValue
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($0c1496466ef568ed$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext)));
};
var $0c1496466ef568ed$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0c1496466ef568ed$var$anyDiacritic = new RegExp('[' + $0c1496466ef568ed$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $0c1496466ef568ed$var$diacriticToBase = {};
for(var $0c1496466ef568ed$var$i = 0; $0c1496466ef568ed$var$i < $0c1496466ef568ed$var$diacritics.length; $0c1496466ef568ed$var$i++){
    var $0c1496466ef568ed$var$diacritic = $0c1496466ef568ed$var$diacritics[$0c1496466ef568ed$var$i];
    for(var $0c1496466ef568ed$var$j = 0; $0c1496466ef568ed$var$j < $0c1496466ef568ed$var$diacritic.letters.length; $0c1496466ef568ed$var$j++)$0c1496466ef568ed$var$diacriticToBase[$0c1496466ef568ed$var$diacritic.letters[$0c1496466ef568ed$var$j]] = $0c1496466ef568ed$var$diacritic.base;
}
var $0c1496466ef568ed$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($0c1496466ef568ed$var$anyDiacritic, function(match) {
        return $0c1496466ef568ed$var$diacriticToBase[match];
    });
};
var $0c1496466ef568ed$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($0c1496466ef568ed$var$stripDiacritics);
var $0c1496466ef568ed$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $0c1496466ef568ed$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $0c1496466ef568ed$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $0c1496466ef568ed$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $0c1496466ef568ed$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $0c1496466ef568ed$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $0c1496466ef568ed$var$memoizedStripDiacriticsForInput(input);
            candidate = $0c1496466ef568ed$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $0c1496466ef568ed$var$DummyInput(_ref) {
    _ref.in;
    _ref.out;
    _ref.onExited;
    _ref.appear;
    _ref.enter;
    _ref.exit;
    var innerRef = _ref.innerRef;
    _ref.emotion;
    var props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("input", (0, $8nd05.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $e0f035ab0866fe47$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: 'inherit',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(0)'
        }, "", "")
    }));
}
var $0c1496466ef568ed$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $0c1496466ef568ed$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        // Reference should never be `null` at this point, but flow complains otherwise
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        } // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        } // cancel scroll
        if (shouldCancelScroll) $0c1496466ef568ed$var$cancelScroll(event);
    }, []);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $07378f5e4d664a8b$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false; // all the if statements are to appease Flow 😢
        if (typeof el.addEventListener === 'function') el.addEventListener('wheel', onWheel, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchstart', onTouchStart, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return; // all the if statements are to appease Flow 😢
        if (typeof el.removeEventListener === 'function') el.removeEventListener('wheel', onWheel, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchstart', onTouchStart, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $0c1496466ef568ed$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $0c1496466ef568ed$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $0c1496466ef568ed$var$preventTouchMove(e) {
    e.preventDefault();
}
function $0c1496466ef568ed$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $0c1496466ef568ed$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $0c1496466ef568ed$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $0c1496466ef568ed$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $0c1496466ef568ed$var$activeScrollLocks = 0;
var $0c1496466ef568ed$var$listenerOptions = {
    capture: false,
    passive: false
};
function $0c1496466ef568ed$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$0c1496466ef568ed$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $0c1496466ef568ed$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
         // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $0c1496466ef568ed$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($0c1496466ef568ed$var$LOCK_STYLES).forEach(function(key) {
                var val = $0c1496466ef568ed$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        } // account for touch devices
        if (target && $0c1496466ef568ed$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $0c1496466ef568ed$var$preventTouchMove, $0c1496466ef568ed$var$listenerOptions); // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $0c1496466ef568ed$var$preventInertiaScroll, $0c1496466ef568ed$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $0c1496466ef568ed$var$allowTouchMove, $0c1496466ef568ed$var$listenerOptions);
            }
        } // increment active scroll locks
        $0c1496466ef568ed$var$activeScrollLocks += 1;
    }, []);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$0c1496466ef568ed$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks
        $0c1496466ef568ed$var$activeScrollLocks = Math.max($0c1496466ef568ed$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
        if (accountForScrollbars && $0c1496466ef568ed$var$activeScrollLocks < 1) $0c1496466ef568ed$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
         // remove touch listeners
        if (target && $0c1496466ef568ed$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $0c1496466ef568ed$var$preventTouchMove, $0c1496466ef568ed$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $0c1496466ef568ed$var$preventInertiaScroll, $0c1496466ef568ed$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $0c1496466ef568ed$var$allowTouchMove, $0c1496466ef568ed$var$listenerOptions);
            }
        }
    }, []);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $0c1496466ef568ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0c1496466ef568ed$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $0c1496466ef568ed$var$_ref2 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $0c1496466ef568ed$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $0c1496466ef568ed$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $0c1496466ef568ed$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, lockEnabled && (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", {
        onClick: $0c1496466ef568ed$var$blurSelectInput,
        css: $0c1496466ef568ed$var$_ref2
    }), children(targetRef));
}
var $0c1496466ef568ed$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $0c1496466ef568ed$export$407448d2b89b1813 = function getOptionLabel(option) {
    return option.label;
};
var $0c1496466ef568ed$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $0c1496466ef568ed$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $0c1496466ef568ed$var$defaultStyles = {
    clearIndicator: (0, $07378f5e4d664a8b$export$8b22cf2602fb60ce),
    container: (0, $07378f5e4d664a8b$export$4368d992c4eafac0),
    control: (0, $07378f5e4d664a8b$export$f1e1789686576879),
    dropdownIndicator: (0, $07378f5e4d664a8b$export$2d1720544b23b823),
    group: (0, $07378f5e4d664a8b$export$39b482c5e57630a8),
    groupHeading: (0, $07378f5e4d664a8b$export$dda1d9f60106f0e9),
    indicatorsContainer: (0, $07378f5e4d664a8b$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $07378f5e4d664a8b$export$35e795649ee09318),
    input: (0, $07378f5e4d664a8b$export$342063e11d6c3cad),
    loadingIndicator: (0, $07378f5e4d664a8b$export$882b5998b3b9117c),
    loadingMessage: (0, $07378f5e4d664a8b$export$953cecd6e717a553),
    menu: (0, $07378f5e4d664a8b$export$7ccc53e8f1e7dfc5),
    menuList: (0, $07378f5e4d664a8b$export$ae1af26003f05816),
    menuPortal: (0, $07378f5e4d664a8b$export$ffb5f4729a158638),
    multiValue: (0, $07378f5e4d664a8b$export$9e5f44173e64f162),
    multiValueLabel: (0, $07378f5e4d664a8b$export$43caf9889c228507),
    multiValueRemove: (0, $07378f5e4d664a8b$export$625550452a3fa3ec),
    noOptionsMessage: (0, $07378f5e4d664a8b$export$3b14a55fb2447963),
    option: (0, $07378f5e4d664a8b$export$90a7f3efeed30595),
    placeholder: (0, $07378f5e4d664a8b$export$efccba1c4a2ef57b),
    singleValue: (0, $07378f5e4d664a8b$export$d141bba7fdc215a3),
    valueContainer: (0, $07378f5e4d664a8b$export$4a5767248b18ef41)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $0c1496466ef568ed$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $0c1496466ef568ed$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $0c1496466ef568ed$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $0c1496466ef568ed$var$baseUnit = 4; // The minimum height of the control
var $0c1496466ef568ed$var$controlHeight = 38; // The amount of space between the control and menu */
var $0c1496466ef568ed$var$menuGutter = $0c1496466ef568ed$var$baseUnit * 2;
var $0c1496466ef568ed$var$spacing = {
    baseUnit: $0c1496466ef568ed$var$baseUnit,
    controlHeight: $0c1496466ef568ed$var$controlHeight,
    menuGutter: $0c1496466ef568ed$var$menuGutter
};
var $0c1496466ef568ed$export$4368d992c4eafac0 = {
    borderRadius: $0c1496466ef568ed$var$borderRadius,
    colors: $0c1496466ef568ed$var$colors,
    spacing: $0c1496466ef568ed$var$spacing
};
var $0c1496466ef568ed$export$8b22cf2602fb60ce = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $07378f5e4d664a8b$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $07378f5e4d664a8b$export$df995fae86a55f06)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $0c1496466ef568ed$export$db3b6bfb95261072(),
    formatGroupLabel: $0c1496466ef568ed$var$formatGroupLabel,
    getOptionLabel: $0c1496466ef568ed$export$407448d2b89b1813,
    getOptionValue: $0c1496466ef568ed$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $0c1496466ef568ed$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $07378f5e4d664a8b$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
};
function $0c1496466ef568ed$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $0c1496466ef568ed$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $0c1496466ef568ed$var$_isOptionSelected(props, option, selectValue);
    var label = $0c1496466ef568ed$var$getOptionLabel$1(props, option);
    var value = $0c1496466ef568ed$var$getOptionValue$1(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0c1496466ef568ed$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if (groupOrOption.options) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $0c1496466ef568ed$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $0c1496466ef568ed$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $0c1496466ef568ed$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0c1496466ef568ed$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }) // Flow limitation (see https://github.com/facebook/flow/issues/1414)
    .filter(function(categorizedOption) {
        return !!categorizedOption;
    });
}
function $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0c1496466ef568ed$var$buildFocusableOptions(props, selectValue) {
    return $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions($0c1496466ef568ed$var$buildCategorizedOptions(props, selectValue));
}
function $0c1496466ef568ed$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$0c1496466ef568ed$var$shouldHideSelectedOptions(props) || !isSelected) && $0c1496466ef568ed$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0c1496466ef568ed$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0c1496466ef568ed$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $0c1496466ef568ed$var$getOptionLabel$1 = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $0c1496466ef568ed$var$getOptionValue$1 = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $0c1496466ef568ed$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $0c1496466ef568ed$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $0c1496466ef568ed$var$getOptionValue$1(props, option);
    return selectValue.some(function(i) {
        return $0c1496466ef568ed$var$getOptionValue$1(props, i) === candidate;
    });
}
function $0c1496466ef568ed$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $0c1496466ef568ed$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $0c1496466ef568ed$var$instanceId = 1;
var $0c1496466ef568ed$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange('', {
                action: 'set-value'
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                }), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ]), 'select-option', newValue);
                else _this.setValue(newValue, 'select-option');
            } else {
                _this.ariaOnChange(newValue, {
                    action: 'select-option',
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange(_this.props.isMulti ? [] : null, {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $07378f5e4d664a8b$export$ef35774e6d314e91).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $0c1496466ef568ed$var$getOptionLabel$1(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $0c1496466ef568ed$var$getOptionValue$1(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var base = $0c1496466ef568ed$var$defaultStyles[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $07378f5e4d664a8b$export$e7094788287c5e9b)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $0c1496466ef568ed$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $0c1496466ef568ed$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $07378f5e4d664a8b$export$407448d2b89b1813)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $07378f5e4d664a8b$export$96f57966bedc81b4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change'
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur'
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $0c1496466ef568ed$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close'
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$0c1496466ef568ed$var$instanceId);
        _this.state.selectValue = (0, $07378f5e4d664a8b$export$a9c23c6ac3fc3eca)(_props.value);
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $07378f5e4d664a8b$export$d66501df72047452)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            } // ==============================
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close'
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $0c1496466ef568ed$export$4368d992c4eafac0;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($0c1496466ef568ed$export$4368d992c4eafac0);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, $0c1496466ef568ed$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $0c1496466ef568ed$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $0c1496466ef568ed$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $0c1496466ef568ed$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            value: // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    'aria-autocomplete': 'list',
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby']
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $07378f5e4d664a8b$export$2329c99376c9d0a4),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this3.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this3.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this3.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this3.formatOptionLabel(opt, 'value'));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $07378f5e4d664a8b$export$3a1a48c8f6ef640e), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, focusedOption = _this$state5.focusedOption, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0c1496466ef568ed$var$LiveRegion, (0, $8nd05.default)({}, commonProps, {
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue;
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var selectValue = (0, $07378f5e4d664a8b$export$a9c23c6ac3fc3eca)(value);
                    var focusableOptions = menuIsOpen ? $0c1496466ef568ed$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $0c1496466ef568ed$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $0c1496466ef568ed$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                } // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                return (0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)((0, $07378f5e4d664a8b$export$407448d2b89b1813)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$0c1496466ef568ed$export$25ce5a424b770e84.defaultProps = $0c1496466ef568ed$export$8b22cf2602fb60ce;



var $8nd05 = parcelRequire("8nd05");



var $cHPF9 = parcelRequire("cHPF9");



var $acw62 = parcelRequire("acw62");
var $b1870d752d02e690$var$defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $b1870d752d02e690$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(StateManager, _Component);
        var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(StateManager);
        function StateManager() {
            var _this;
            (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp('onChange', value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp('onInputChange', value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp('onMenuOpen');
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp('onMenuClose');
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $cHPF9.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === 'function') {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props;
                    _this$props2.defaultInputValue;
                    _this$props2.defaultMenuIsOpen;
                    _this$props2.defaultValue;
                    var props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp('inputValue'),
                        menuIsOpen: this.getProp('menuIsOpen'),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp('value')
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $acw62.Component)), _class.defaultProps = $b1870d752d02e690$var$defaultProps, _temp;
};




var $cHPF9 = parcelRequire("cHPF9");



var $acw62 = parcelRequire("acw62");

var $8b94d205f8f1aa61$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $8b94d205f8f1aa61$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $8b94d205f8f1aa61$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $8b94d205f8f1aa61$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$8b94d205f8f1aa61$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8b94d205f8f1aa61$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $8b94d205f8f1aa61$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();



var $ca897dd0330b7fa6$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $d886c076522d83e9$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $6dd49fb9a56801a5$var$isBrowser = typeof document !== 'undefined';
var $6dd49fb9a56801a5$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $6dd49fb9a56801a5$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6dd49fb9a56801a5$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $6dd49fb9a56801a5$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($6dd49fb9a56801a5$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6dd49fb9a56801a5$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6dd49fb9a56801a5$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6dd49fb9a56801a5$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6dd49fb9a56801a5$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6dd49fb9a56801a5$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6dd49fb9a56801a5$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $6dd49fb9a56801a5$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $6dd49fb9a56801a5$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $6dd49fb9a56801a5$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $6dd49fb9a56801a5$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $6dd49fb9a56801a5$var$getServerStylisCache = $6dd49fb9a56801a5$var$isBrowser ? undefined : (0, $ca897dd0330b7fa6$export$2e2bcd8739ae039)(function() {
    return (0, $d886c076522d83e9$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $6dd49fb9a56801a5$var$defaultStylisPlugins = [
    $6dd49fb9a56801a5$var$prefixer
];
var $6dd49fb9a56801a5$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($6dd49fb9a56801a5$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $6dd49fb9a56801a5$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($6dd49fb9a56801a5$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $6dd49fb9a56801a5$var$compat,
        $6dd49fb9a56801a5$var$removeLabel
    ];
    if (!$6dd49fb9a56801a5$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $6dd49fb9a56801a5$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $8b94d205f8f1aa61$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;


parcelRequire("41YNz");

parcelRequire("g5Zhu");
parcelRequire("1u0KT");
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NonceProvider, _Component);
    var _super = (0, $07378f5e4d664a8b$export$71511d61b312f219)(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce, key) {
            return (0, $6dd49fb9a56801a5$export$2e2bcd8739ae039)({
                nonce: nonce,
                key: key
            });
        };
        _this.createEmotionCache = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(_this.createEmotionCache);
        return _this;
    }
    (0, $cHPF9.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acad92301ef10c3f$export$e7094788287c5e9b), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $acw62.Component));
var $7532f3e29d96fa2a$var$index = (0, $b1870d752d02e690$export$953cecd6e717a553)((0, $0c1496466ef568ed$export$25ce5a424b770e84));
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$index;


const $4a0e8c93008ccfbd$export$dcee1aa94a106d27 = (0, $lmFrL.default)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039))`
  .Select__control {
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    border: 1px solid #dedede;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 5px 0 5px 16px;
    font-size: ${(props)=>props.theme.fontSizes[2]};
    line-height: ${(props)=>props.theme.lineHeights[4]};
    color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  }

  .Select__value-container {
    padding: 0;
  }

  .Select__dropdown-indicator svg {
    width: 16px;
    height: 16px;
  }

  .Select__dropdown-indicator svg path {
    d: path(
      "M7.16779 12.0849C7.56361 12.6787 8.43607 12.6787 8.83189 12.0849L12.2967 6.88771C12.7397 6.22315 12.2633 5.33301 11.4647 5.33301H4.53502C3.73633 5.33301 3.25993 6.22315 3.70297 6.88771L7.16779 12.0849Z"
    );
    fill: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  }

  .Select__control--is-disabled .Select__dropdown-indicator svg path {
    fill: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__control::-ms-expand {
    display: none;
    outline: none;
  }

  .Select__control--is-focused {
    outline: none;
    box-shadow: none;
  }

  .Select__control:hover {
    border: 1px solid
      ${(props)=>props.theme.newColors.grayscale.placeholder};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.hoveredState};
  }

  .Select__control--menu-is-open {
    border: 1px solid ${(props)=>props.theme.newColors.primary.basic};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.activeState};
    outline: none;
  }

  .Select__control--is-disabled {
    border-radius: 4px;
    border: 1px solid
      ${({ theme: theme })=>theme.newColors.grayscale.placeholder};
    background: ${({ theme: theme })=>theme.newColors.grayscale.disabled};
    box-shadow: none;
  }

  .Select__option {
    background: ${(props)=>props.theme.newColors.grayscale.white};
    font-size: ${(props)=>props.theme.fontSizes[2]};
    line-height: ${(props)=>props.theme.lineHeights[4]};
    font-weight: normal;
    cursor: pointer;
    padding: 12px 16px;
  }

  .Select__option--is-selected {
    background: ${(props)=>props.theme.newColors.primary.lightTint};
    color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  }

  .Select__menu {
    margin-top: 0;
    margin-bottom: 0;
  }

  .Select__menu-list {
    padding: 0;
    border: 1px solid
      ${(props)=>props.theme.newColors.grayscale.bordersInside};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.hoveredState};
    box-sizing: border-box;
    border-radius: 5px;
  }

  .Select__option:hover {
    background: ${(props)=>props.theme.newColors.primary.lightestTint};
  }

  .Select__option:active {
    background: ${(props)=>props.theme.newColors.primary.lightTint};
  }

  .Select__control:focus {
    outline: none;
  }

  .Select__control::placeholder,
  .Select__control::-webkit-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  .Select__control:-ms-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  ${(props)=>props.error && (0, $lmFrL.css)`
      .Select__control {
        border: 1px solid
          ${({ theme: theme })=>theme.newColors.extra.errorState};
        box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.errorState};
      }
    `}
`;



const $ce830298ea9125dd$var$getBackgroundColor = (state)=>{
    if (state.isFocused && state.isSelected) return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint;
    if (state.isSelected) return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightTint;
    if (state.isFocused) return (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint;
    return "white";
};
const $ce830298ea9125dd$var$getStyles = ()=>{
    return {
        control: (provided)=>({
                ...provided,
                padding: "0 0 0 3px;",
                fontSize: "11px",
                lineHeight: "16px"
            }),
        option: (provided, state)=>({
                ...provided,
                padding: "8px 8px 8px 6px",
                fontSize: "11px",
                lineHeight: "16px",
                background: $ce830298ea9125dd$var$getBackgroundColor(state),
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
            }),
        indicator: (provided)=>({
                ...provided,
                padding: "2px"
            }),
        menu: (provided)=>({
                ...provided,
                marginTop: 0,
                marginBottom: 0
            }),
        menuList: (provided)=>({
                ...provided,
                padding: 0
            })
    };
};
const $ce830298ea9125dd$export$931cbfb6bfb85fc = (props)=>{
    const { error: error, isSearchable: isSearchable, menuPortalTarget: menuPortalTarget } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a0e8c93008ccfbd$export$dcee1aa94a106d27), {
        menuPortalTarget: menuPortalTarget,
        classNamePrefix: "Select",
        menuPlacement: "auto",
        error: error,
        isSearchable: isSearchable || false,
        styles: menuPortalTarget ? $ce830298ea9125dd$var$getStyles() : undefined,
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $2cbb1ba96c3a6949$export$f2ca6fc699ca1fb4 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color, testId: testId } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 7L5 10L12 2",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "square"
    }));
};
$2cbb1ba96c3a6949$export$f2ca6fc699ca1fb4.defaultProps = {
    width: "14",
    height: "12",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};




var $fd090f2967b171e4$export$a4e0276d1f6541ed = /*#__PURE__*/ function(LabelTagTypes) {
    LabelTagTypes[LabelTagTypes["DEFAULT"] = 0] = "DEFAULT";
    LabelTagTypes[LabelTagTypes["SUCCESS"] = 1] = "SUCCESS";
    LabelTagTypes[LabelTagTypes["INVERTED"] = 2] = "INVERTED";
    LabelTagTypes[LabelTagTypes["SAVING"] = 3] = "SAVING";
    LabelTagTypes[LabelTagTypes["SAVED"] = 4] = "SAVED";
    LabelTagTypes[LabelTagTypes["FAILED"] = 5] = "FAILED";
    return LabelTagTypes;
}({});
const $fd090f2967b171e4$var$getColors = (type)=>{
    switch(type){
        case 1:
        case 3:
            return {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
                backgroundColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint
            };
        case 4:
            return {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.hover,
                backgroundColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.lightTint
            };
        case 2:
            return {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background,
                backgroundColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
            };
        case 5:
            return {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background,
                backgroundColor: "#de2d26"
            };
        default:
            return {
                color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray,
                backgroundColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.background
            };
    }
};
const $fd090f2967b171e4$export$688d8a2f2c9a1ec6 = (required, fieldValue, value)=>{
    if (typeof fieldValue === "number") // eslint-disable-next-line no-param-reassign
    value = parseFloat(value);
    if (fieldValue && fieldValue !== value || !fieldValue && value) return {
        type: 3,
        name: "SAVING..."
    };
    if (fieldValue && fieldValue === value) return {
        type: 4,
        name: "SAVED"
    };
    if (!fieldValue && required) return {
        type: 0,
        name: "REQUIRED"
    };
    return undefined;
};
const $fd090f2967b171e4$export$9dacaafb9baa8abc = (props)=>{
    const { name: name, type: type, selected: selected } = props;
    const { color: color, backgroundColor: backgroundColor } = $fd090f2967b171e4$var$getColors(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd090f2967b171e4$var$Container, {
        color: color,
        backgroundColor: backgroundColor,
        selected: selected
    }, type === 1 || type === 4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2cbb1ba96c3a6949$export$f2ca6fc699ca1fb4), {
        color: color,
        testId: "labelTagTickIcon"
    })) : null, type === 3 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe7277f9493cf0da$export$b42aec0a4a94c970), {
        size: 9,
        width: 8,
        testId: "labelTagSpinner"
    }) : null, name);
};
$fd090f2967b171e4$export$9dacaafb9baa8abc.defaultProps = {
    type: 0,
    selected: false
};
const $fd090f2967b171e4$var$Container = (0, $lmFrL.default).div`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  text-transform: uppercase;
  ${({ selected: selected })=>selected ? "word-spacing: 8px;" : ""}
  color: ${({ color: color })=>color};
  background-color: ${({ backgroundColor: backgroundColor })=>backgroundColor};
  border-radius: 100px;

  display: inline-flex;
  align-items: center;
  padding: 4px 12px;

  svg {
    margin-right: 10px;
  }

  span > svg {
    transform: scale(0.8);
  }
`;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $c6b18e1e224332a0$export$f713256e8ad1586 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.99935 2.6665C12.4972 2.6665 15.3327 5.50203 15.3327 8.99984C15.3327 12.4976 12.4972 15.3332 8.99935 15.3332C5.50154 15.3332 2.66602 12.4976 2.66602 8.99984C2.66602 5.50203 5.50154 2.6665 8.99935 2.6665ZM8.99935 0.666504C13.6017 0.666504 17.3327 4.39746 17.3327 8.99984C17.3327 13.6022 13.6017 17.3332 8.99935 17.3332C4.39698 17.3332 0.666016 13.6022 0.666016 8.99984C0.666016 4.39746 4.39698 0.666504 8.99935 0.666504ZM8.37808 10.3217C8.42115 10.3683 8.47748 10.3917 8.54706 10.3917H9.4914C9.55435 10.3917 9.60737 10.3699 9.65044 10.3263C9.69683 10.2828 9.72002 10.2283 9.72002 10.163V9.55626C9.72002 9.41936 9.76476 9.30423 9.85422 9.21089C9.9238 9.13933 10.005 9.07088 10.0978 9.00554C10.1905 8.9402 10.3247 8.85153 10.5003 8.73952L10.6097 8.66951C10.7555 8.58239 10.898 8.46572 11.0371 8.31948C11.3453 7.9959 11.4993 7.57741 11.4993 7.06404C11.4993 6.74356 11.4331 6.44642 11.3005 6.17262C11.1713 5.89882 10.9891 5.6608 10.7538 5.45856C10.5219 5.25943 10.2518 5.10542 9.94368 4.99652C9.63553 4.88762 9.31247 4.83317 8.9745 4.83317C8.64647 4.83317 8.33169 4.88762 8.03016 4.99652C7.73195 5.10542 7.46853 5.25787 7.23991 5.45389C7.00796 5.65613 6.82572 5.89415 6.69319 6.16796C6.56396 6.44176 6.49935 6.73734 6.49935 7.0547V7.20871C6.49935 7.26161 6.51592 7.30672 6.54905 7.34406C6.5855 7.3814 6.64183 7.40007 6.71804 7.40007H7.67728C7.74355 7.40007 7.79822 7.3814 7.8413 7.34406C7.88437 7.30672 7.90591 7.25694 7.90591 7.19471V7.0547C7.90591 6.92402 7.93242 6.7949 7.98543 6.66733C8.04176 6.53977 8.11963 6.42776 8.21903 6.3313C8.31843 6.23174 8.43275 6.15395 8.56197 6.09795C8.6912 6.04194 8.82871 6.01394 8.9745 6.01394C9.12029 6.01394 9.26111 6.04194 9.39696 6.09795C9.53613 6.15084 9.65707 6.22552 9.75979 6.32197C9.8625 6.41842 9.94203 6.52732 9.99835 6.64866C10.058 6.77001 10.0878 6.89446 10.0878 7.02203C10.0878 7.26472 9.99504 7.48874 9.80949 7.69409C9.73659 7.77499 9.65873 7.84655 9.57589 7.90878C9.49305 7.96789 9.3688 8.0519 9.20313 8.1608C9.05071 8.26659 8.92977 8.35371 8.8403 8.42216C8.75084 8.49061 8.66966 8.56528 8.59676 8.64618C8.41121 8.86397 8.31843 9.10666 8.31843 9.37424V10.163C8.31843 10.2221 8.33832 10.275 8.37808 10.3217ZM8.70611 12.2725C8.80551 12.3129 8.90989 12.3332 9.01923 12.3332C9.1352 12.3332 9.24289 12.3129 9.34229 12.2725C9.44169 12.2352 9.52784 12.1823 9.60074 12.1138C9.67032 12.0454 9.72499 11.966 9.76476 11.8758C9.80452 11.7856 9.8244 11.6891 9.8244 11.5864C9.8244 11.4838 9.80452 11.3858 9.76476 11.2924C9.72499 11.1991 9.67032 11.1182 9.60074 11.0497C9.52784 10.9813 9.44169 10.9284 9.34229 10.891C9.24289 10.8506 9.1352 10.8304 9.01923 10.8304C8.90989 10.8304 8.80551 10.8506 8.70611 10.891C8.61002 10.9284 8.52718 10.9813 8.4576 11.0497C8.3847 11.1182 8.32672 11.1991 8.28364 11.2924C8.24057 11.3858 8.21903 11.4838 8.21903 11.5864C8.21903 11.686 8.24057 11.7825 8.28364 11.8758C8.32672 11.966 8.3847 12.0454 8.4576 12.1138C8.52718 12.1823 8.61002 12.2352 8.70611 12.2725Z",
        fill: color
    }));
};
$c6b18e1e224332a0$export$f713256e8ad1586.defaultProps = {
    width: "20",
    height: "20",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $568f4ee4022ba00e$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $78d1b6b90091f3cc$var$byteToHex = [];
for(var $78d1b6b90091f3cc$var$i = 0; $78d1b6b90091f3cc$var$i < 256; ++$78d1b6b90091f3cc$var$i)$78d1b6b90091f3cc$var$byteToHex[$78d1b6b90091f3cc$var$i] = ($78d1b6b90091f3cc$var$i + 0x100).toString(16).substr(1);
function $78d1b6b90091f3cc$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $78d1b6b90091f3cc$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
var $78d1b6b90091f3cc$export$2e2bcd8739ae039 = $78d1b6b90091f3cc$var$bytesToUuid;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $78d1b6b90091f3cc$export$2e2bcd8739ae039)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


function $dc8851251b4817c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc8851251b4817c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dc8851251b4817c5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc8851251b4817c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc8851251b4817c5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dc8851251b4817c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc8851251b4817c5$var$_extends() {
    $dc8851251b4817c5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc8851251b4817c5$var$_extends.apply(this, arguments);
}
function $dc8851251b4817c5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc8851251b4817c5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc8851251b4817c5$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc8851251b4817c5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc8851251b4817c5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc8851251b4817c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dc8851251b4817c5$var$_setPrototypeOf(subClass, superClass);
}
function $dc8851251b4817c5$var$_getPrototypeOf(o) {
    $dc8851251b4817c5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc8851251b4817c5$var$_getPrototypeOf(o);
}
function $dc8851251b4817c5$var$_setPrototypeOf(o, p) {
    $dc8851251b4817c5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc8851251b4817c5$var$_setPrototypeOf(o, p);
}
function $dc8851251b4817c5$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $dc8851251b4817c5$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $dc8851251b4817c5$var$_assertThisInitialized(self1);
}
var $dc8851251b4817c5$var$CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
/**
 * Static methods for react-tooltip
 */ var $dc8851251b4817c5$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $dc8851251b4817c5$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $dc8851251b4817c5$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $dc8851251b4817c5$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        $dc8851251b4817c5$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $dc8851251b4817c5$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute('currentItem', 'false');
    else targetArray[i].setAttribute('currentItem', 'true');
};
var $dc8851251b4817c5$var$customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $dc8851251b4817c5$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $dc8851251b4817c5$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function(event) {
            ele.removeEventListener(event, $dc8851251b4817c5$var$customListeners.get(ele, event));
            var customListener = $dc8851251b4817c5$var$checkStatus.bind(_this, dataEventOff);
            $dc8851251b4817c5$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(' ').forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, $dc8851251b4817c5$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $dc8851251b4817c5$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $dc8851251b4817c5$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
/**
 * Util method to get effect
 */ var $dc8851251b4817c5$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === 'function') proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $dc8851251b4817c5$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute('data-tip') || null;
    var forId = e.target.getAttribute('data-for') || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = $dc8851251b4817c5$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $dc8851251b4817c5$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $dc8851251b4817c5$var$getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function $dc8851251b4817c5$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $dc8851251b4817c5$var$getBody();
        var customEvents = $dc8851251b4817c5$var$findCustomEvents(targetArray, 'data-event');
        var customEventsOff = $dc8851251b4817c5$var$findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $dc8851251b4817c5$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $dc8851251b4817c5$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $dc8851251b4817c5$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            $dc8851251b4817c5$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $dc8851251b4817c5$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $dc8851251b4817c5$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $dc8851251b4817c5$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $dc8851251b4817c5$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $dc8851251b4817c5$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $dc8851251b4817c5$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $dc8851251b4817c5$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $dc8851251b4817c5$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $dc8851251b4817c5$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $dc8851251b4817c5$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $dc8851251b4817c5$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    }; //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    }; // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        'top',
        'bottom',
        'left',
        'right'
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $dc8851251b4817c5$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
}; // Get current mouse offset
var $dc8851251b4817c5$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $dc8851251b4817c5$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $dc8851251b4817c5$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}; // Consider additional offset into position calculation
var $dc8851251b4817c5$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === 'top') extraOffsetY -= parseInt(offset[key], 10);
        else if (key === 'bottom') extraOffsetY += parseInt(offset[key], 10);
        else if (key === 'left') extraOffsetX -= parseInt(offset[key], 10);
        else if (key === 'right') extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
}; // Get the offset of the parent elements
var $dc8851251b4817c5$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $dc8851251b4817c5$var$getTipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
     // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $dc8851251b4817c5$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $dc8851251b4817c5$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $dc8851251b4817c5$var$generateUUID() {
    return 't' + (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
}
var $dc8851251b4817c5$var$baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
/**
 * Default pop-up style values (text color, background color).
 */ var $dc8851251b4817c5$var$defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function $dc8851251b4817c5$var$getDefaultPopupColors(type) {
    return $dc8851251b4817c5$var$defaultColors[type] ? $dc8851251b4817c5$var$_objectSpread2({}, $dc8851251b4817c5$var$defaultColors[type]) : undefined;
}
/**
 * Generates the specific tooltip style for use on render.
 */ function $dc8851251b4817c5$var$generateTooltipStyle(uuid, customColors, type, hasBorder) {
    return $dc8851251b4817c5$var$generateStyle(uuid, $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $dc8851251b4817c5$var$generateStyle(uuid, colors) {
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}
function $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $dc8851251b4817c5$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === 'light' ? 'black' : 'white';
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $dc8851251b4817c5$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $dc8851251b4817c5$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $dc8851251b4817c5$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $dc8851251b4817c5$var$global_1 = // eslint-disable-next-line es/no-global-this -- safe
$dc8851251b4817c5$var$check(typeof globalThis == 'object' && globalThis) || $dc8851251b4817c5$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$dc8851251b4817c5$var$check(typeof self == 'object' && self) || $dc8851251b4817c5$var$check(typeof $dc8851251b4817c5$var$commonjsGlobal == 'object' && $dc8851251b4817c5$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();
var $dc8851251b4817c5$var$fails = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
// Detect IE8's incomplete defineProperty implementation
var $dc8851251b4817c5$var$descriptors = !$dc8851251b4817c5$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $dc8851251b4817c5$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $dc8851251b4817c5$var$NASHORN_BUG = $dc8851251b4817c5$var$getOwnPropertyDescriptor && !$dc8851251b4817c5$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $dc8851251b4817c5$var$f = $dc8851251b4817c5$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $dc8851251b4817c5$var$$propertyIsEnumerable;
var $dc8851251b4817c5$var$objectPropertyIsEnumerable = {
    f: $dc8851251b4817c5$var$f
};
var $dc8851251b4817c5$var$createPropertyDescriptor = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $dc8851251b4817c5$var$toString = {}.toString;
var $dc8851251b4817c5$var$classofRaw = function(it) {
    return $dc8851251b4817c5$var$toString.call(it).slice(8, -1);
};
var $dc8851251b4817c5$var$split = ''.split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $dc8851251b4817c5$var$indexedObject = $dc8851251b4817c5$var$fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $dc8851251b4817c5$var$classofRaw(it) == 'String' ? $dc8851251b4817c5$var$split.call(it, '') : Object(it);
} : Object;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $dc8851251b4817c5$var$requireObjectCoercible = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $dc8851251b4817c5$var$toIndexedObject = function(it) {
    return $dc8851251b4817c5$var$indexedObject($dc8851251b4817c5$var$requireObjectCoercible(it));
};
var $dc8851251b4817c5$var$isObject = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var $dc8851251b4817c5$var$toPrimitive = function(input, PREFERRED_STRING) {
    if (!$dc8851251b4817c5$var$isObject(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == 'function' && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $dc8851251b4817c5$var$toObject = function(argument) {
    return Object($dc8851251b4817c5$var$requireObjectCoercible(argument));
};
var $dc8851251b4817c5$var$hasOwnProperty = {}.hasOwnProperty;
var $dc8851251b4817c5$var$has = function hasOwn(it, key) {
    return $dc8851251b4817c5$var$hasOwnProperty.call($dc8851251b4817c5$var$toObject(it), key);
};
var $dc8851251b4817c5$var$document$1 = $dc8851251b4817c5$var$global_1.document;
// typeof document.createElement is 'object' in old IE
var $dc8851251b4817c5$var$EXISTS = $dc8851251b4817c5$var$isObject($dc8851251b4817c5$var$document$1) && $dc8851251b4817c5$var$isObject($dc8851251b4817c5$var$document$1.createElement);
var $dc8851251b4817c5$var$documentCreateElement = function(it) {
    return $dc8851251b4817c5$var$EXISTS ? $dc8851251b4817c5$var$document$1.createElement(it) : {};
};
// Thank's IE8 for his funny defineProperty
var $dc8851251b4817c5$var$ie8DomDefine = !$dc8851251b4817c5$var$descriptors && !$dc8851251b4817c5$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($dc8851251b4817c5$var$documentCreateElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $dc8851251b4817c5$var$f$1 = $dc8851251b4817c5$var$descriptors ? $dc8851251b4817c5$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $dc8851251b4817c5$var$toIndexedObject(O);
    P = $dc8851251b4817c5$var$toPrimitive(P, true);
    if ($dc8851251b4817c5$var$ie8DomDefine) try {
        return $dc8851251b4817c5$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($dc8851251b4817c5$var$has(O, P)) return $dc8851251b4817c5$var$createPropertyDescriptor(!$dc8851251b4817c5$var$objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor = {
    f: $dc8851251b4817c5$var$f$1
};
var $dc8851251b4817c5$var$anObject = function(it) {
    if (!$dc8851251b4817c5$var$isObject(it)) throw TypeError(String(it) + ' is not an object');
    return it;
};
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $dc8851251b4817c5$var$$defineProperty = Object.defineProperty;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $dc8851251b4817c5$var$f$2 = $dc8851251b4817c5$var$descriptors ? $dc8851251b4817c5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $dc8851251b4817c5$var$anObject(O);
    P = $dc8851251b4817c5$var$toPrimitive(P, true);
    $dc8851251b4817c5$var$anObject(Attributes);
    if ($dc8851251b4817c5$var$ie8DomDefine) try {
        return $dc8851251b4817c5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $dc8851251b4817c5$var$objectDefineProperty = {
    f: $dc8851251b4817c5$var$f$2
};
var $dc8851251b4817c5$var$createNonEnumerableProperty = $dc8851251b4817c5$var$descriptors ? function(object, key, value) {
    return $dc8851251b4817c5$var$objectDefineProperty.f(object, key, $dc8851251b4817c5$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $dc8851251b4817c5$var$setGlobal = function(key, value) {
    try {
        $dc8851251b4817c5$var$createNonEnumerableProperty($dc8851251b4817c5$var$global_1, key, value);
    } catch (error) {
        $dc8851251b4817c5$var$global_1[key] = value;
    }
    return value;
};
var $dc8851251b4817c5$var$SHARED = '__core-js_shared__';
var $dc8851251b4817c5$var$store = $dc8851251b4817c5$var$global_1[$dc8851251b4817c5$var$SHARED] || $dc8851251b4817c5$var$setGlobal($dc8851251b4817c5$var$SHARED, {});
var $dc8851251b4817c5$var$sharedStore = $dc8851251b4817c5$var$store;
var $dc8851251b4817c5$var$functionToString = Function.toString;
// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $dc8851251b4817c5$var$sharedStore.inspectSource != 'function') $dc8851251b4817c5$var$sharedStore.inspectSource = function(it) {
    return $dc8851251b4817c5$var$functionToString.call(it);
};
var $dc8851251b4817c5$var$inspectSource = $dc8851251b4817c5$var$sharedStore.inspectSource;
var $dc8851251b4817c5$var$WeakMap = $dc8851251b4817c5$var$global_1.WeakMap;
var $dc8851251b4817c5$var$nativeWeakMap = typeof $dc8851251b4817c5$var$WeakMap === 'function' && /native code/.test($dc8851251b4817c5$var$inspectSource($dc8851251b4817c5$var$WeakMap));
var $dc8851251b4817c5$var$shared = $dc8851251b4817c5$var$createCommonjsModule(function(module) {
    (module.exports = function(key, value) {
        return $dc8851251b4817c5$var$sharedStore[key] || ($dc8851251b4817c5$var$sharedStore[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: '3.12.1',
        mode: 'global',
        copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
    });
});
var $dc8851251b4817c5$var$id = 0;
var $dc8851251b4817c5$var$postfix = Math.random();
var $dc8851251b4817c5$var$uid = function(key) {
    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++$dc8851251b4817c5$var$id + $dc8851251b4817c5$var$postfix).toString(36);
};
var $dc8851251b4817c5$var$keys = $dc8851251b4817c5$var$shared('keys');
var $dc8851251b4817c5$var$sharedKey = function(key) {
    return $dc8851251b4817c5$var$keys[key] || ($dc8851251b4817c5$var$keys[key] = $dc8851251b4817c5$var$uid(key));
};
var $dc8851251b4817c5$var$hiddenKeys = {};
var $dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $dc8851251b4817c5$var$WeakMap$1 = $dc8851251b4817c5$var$global_1.WeakMap;
var $dc8851251b4817c5$var$set, $dc8851251b4817c5$var$get, $dc8851251b4817c5$var$has$1;
var $dc8851251b4817c5$var$enforce = function(it) {
    return $dc8851251b4817c5$var$has$1(it) ? $dc8851251b4817c5$var$get(it) : $dc8851251b4817c5$var$set(it, {});
};
var $dc8851251b4817c5$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$dc8851251b4817c5$var$isObject(it) || (state = $dc8851251b4817c5$var$get(it)).type !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($dc8851251b4817c5$var$nativeWeakMap || $dc8851251b4817c5$var$sharedStore.state) {
    var $dc8851251b4817c5$var$store$1 = $dc8851251b4817c5$var$sharedStore.state || ($dc8851251b4817c5$var$sharedStore.state = new $dc8851251b4817c5$var$WeakMap$1());
    var $dc8851251b4817c5$var$wmget = $dc8851251b4817c5$var$store$1.get;
    var $dc8851251b4817c5$var$wmhas = $dc8851251b4817c5$var$store$1.has;
    var $dc8851251b4817c5$var$wmset = $dc8851251b4817c5$var$store$1.set;
    $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$wmhas.call($dc8851251b4817c5$var$store$1, it)) throw new TypeError($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$wmset.call($dc8851251b4817c5$var$store$1, it, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$wmget.call($dc8851251b4817c5$var$store$1, it) || {};
    };
    $dc8851251b4817c5$var$has$1 = function(it) {
        return $dc8851251b4817c5$var$wmhas.call($dc8851251b4817c5$var$store$1, it);
    };
} else {
    var $dc8851251b4817c5$var$STATE = $dc8851251b4817c5$var$sharedKey('state');
    $dc8851251b4817c5$var$hiddenKeys[$dc8851251b4817c5$var$STATE] = true;
    $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE)) throw new TypeError($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$createNonEnumerableProperty(it, $dc8851251b4817c5$var$STATE, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE) ? it[$dc8851251b4817c5$var$STATE] : {};
    };
    $dc8851251b4817c5$var$has$1 = function(it) {
        return $dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE);
    };
}
var $dc8851251b4817c5$var$internalState = {
    set: $dc8851251b4817c5$var$set,
    get: $dc8851251b4817c5$var$get,
    has: $dc8851251b4817c5$var$has$1,
    enforce: $dc8851251b4817c5$var$enforce,
    getterFor: $dc8851251b4817c5$var$getterFor
};
var $dc8851251b4817c5$var$redefine = $dc8851251b4817c5$var$createCommonjsModule(function(module) {
    var getInternalState = $dc8851251b4817c5$var$internalState.get;
    var enforceInternalState = $dc8851251b4817c5$var$internalState.enforce;
    var TEMPLATE = String(String).split('String');
    (module.exports = function(O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var state;
        if (typeof value == 'function') {
            if (typeof key == 'string' && !$dc8851251b4817c5$var$has(value, 'name')) $dc8851251b4817c5$var$createNonEnumerableProperty(value, 'name', key);
            state = enforceInternalState(value);
            if (!state.source) state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
        }
        if (O === $dc8851251b4817c5$var$global_1) {
            if (simple) O[key] = value;
            else $dc8851251b4817c5$var$setGlobal(key, value);
            return;
        } else if (!unsafe) delete O[key];
        else if (!noTargetGet && O[key]) simple = true;
        if (simple) O[key] = value;
        else $dc8851251b4817c5$var$createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, 'toString', function toString() {
        return typeof this == 'function' && getInternalState(this).source || $dc8851251b4817c5$var$inspectSource(this);
    });
});
var $dc8851251b4817c5$var$path = $dc8851251b4817c5$var$global_1;
var $dc8851251b4817c5$var$aFunction = function(variable) {
    return typeof variable == 'function' ? variable : undefined;
};
var $dc8851251b4817c5$var$getBuiltIn = function(namespace, method) {
    return arguments.length < 2 ? $dc8851251b4817c5$var$aFunction($dc8851251b4817c5$var$path[namespace]) || $dc8851251b4817c5$var$aFunction($dc8851251b4817c5$var$global_1[namespace]) : $dc8851251b4817c5$var$path[namespace] && $dc8851251b4817c5$var$path[namespace][method] || $dc8851251b4817c5$var$global_1[namespace] && $dc8851251b4817c5$var$global_1[namespace][method];
};
var $dc8851251b4817c5$var$ceil = Math.ceil;
var $dc8851251b4817c5$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var $dc8851251b4817c5$var$toInteger = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $dc8851251b4817c5$var$floor : $dc8851251b4817c5$var$ceil)(argument);
};
var $dc8851251b4817c5$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $dc8851251b4817c5$var$toLength = function(argument) {
    return argument > 0 ? $dc8851251b4817c5$var$min($dc8851251b4817c5$var$toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $dc8851251b4817c5$var$max = Math.max;
var $dc8851251b4817c5$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $dc8851251b4817c5$var$toAbsoluteIndex = function(index, length) {
    var integer = $dc8851251b4817c5$var$toInteger(index);
    return integer < 0 ? $dc8851251b4817c5$var$max(integer + length, 0) : $dc8851251b4817c5$var$min$1(integer, length);
};
// `Array.prototype.{ indexOf, includes }` methods implementation
var $dc8851251b4817c5$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $dc8851251b4817c5$var$toIndexedObject($this);
        var length = $dc8851251b4817c5$var$toLength(O.length);
        var index = $dc8851251b4817c5$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $dc8851251b4817c5$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $dc8851251b4817c5$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $dc8851251b4817c5$var$createMethod(false)
};
var $dc8851251b4817c5$var$indexOf = $dc8851251b4817c5$var$arrayIncludes.indexOf;
var $dc8851251b4817c5$var$objectKeysInternal = function(object, names) {
    var O = $dc8851251b4817c5$var$toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$dc8851251b4817c5$var$has($dc8851251b4817c5$var$hiddenKeys, key) && $dc8851251b4817c5$var$has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dc8851251b4817c5$var$has(O, key = names[i++])) ~$dc8851251b4817c5$var$indexOf(result, key) || result.push(key);
    return result;
};
// IE8- don't enum bug keys
var $dc8851251b4817c5$var$enumBugKeys = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $dc8851251b4817c5$var$hiddenKeys$1 = $dc8851251b4817c5$var$enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $dc8851251b4817c5$var$f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dc8851251b4817c5$var$objectKeysInternal(O, $dc8851251b4817c5$var$hiddenKeys$1);
};
var $dc8851251b4817c5$var$objectGetOwnPropertyNames = {
    f: $dc8851251b4817c5$var$f$3
};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $dc8851251b4817c5$var$f$4 = Object.getOwnPropertySymbols;
var $dc8851251b4817c5$var$objectGetOwnPropertySymbols = {
    f: $dc8851251b4817c5$var$f$4
};
// all object keys, includes non-enumerable and symbols
var $dc8851251b4817c5$var$ownKeys$1 = $dc8851251b4817c5$var$getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $dc8851251b4817c5$var$objectGetOwnPropertyNames.f($dc8851251b4817c5$var$anObject(it));
    var getOwnPropertySymbols = $dc8851251b4817c5$var$objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};
var $dc8851251b4817c5$var$copyConstructorProperties = function(target, source) {
    var keys = $dc8851251b4817c5$var$ownKeys$1(source);
    var defineProperty = $dc8851251b4817c5$var$objectDefineProperty.f;
    var getOwnPropertyDescriptor = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$dc8851251b4817c5$var$has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $dc8851251b4817c5$var$replacement = /#|\.prototype\./;
var $dc8851251b4817c5$var$isForced = function(feature, detection) {
    var value = $dc8851251b4817c5$var$data[$dc8851251b4817c5$var$normalize(feature)];
    return value == $dc8851251b4817c5$var$POLYFILL ? true : value == $dc8851251b4817c5$var$NATIVE ? false : typeof detection == 'function' ? $dc8851251b4817c5$var$fails(detection) : !!detection;
};
var $dc8851251b4817c5$var$normalize = $dc8851251b4817c5$var$isForced.normalize = function(string) {
    return String(string).replace($dc8851251b4817c5$var$replacement, '.').toLowerCase();
};
var $dc8851251b4817c5$var$data = $dc8851251b4817c5$var$isForced.data = {};
var $dc8851251b4817c5$var$NATIVE = $dc8851251b4817c5$var$isForced.NATIVE = 'N';
var $dc8851251b4817c5$var$POLYFILL = $dc8851251b4817c5$var$isForced.POLYFILL = 'P';
var $dc8851251b4817c5$var$isForced_1 = $dc8851251b4817c5$var$isForced;
var $dc8851251b4817c5$var$getOwnPropertyDescriptor$1 = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ var $dc8851251b4817c5$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $dc8851251b4817c5$var$global_1;
    else if (STATIC) target = $dc8851251b4817c5$var$global_1[TARGET] || $dc8851251b4817c5$var$setGlobal(TARGET, {});
    else target = ($dc8851251b4817c5$var$global_1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $dc8851251b4817c5$var$isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $dc8851251b4817c5$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $dc8851251b4817c5$var$createNonEnumerableProperty(sourceProperty, 'sham', true);
        // extend global
        $dc8851251b4817c5$var$redefine(target, key, sourceProperty, options);
    }
};
var $dc8851251b4817c5$var$aFunction$1 = function(it) {
    if (typeof it != 'function') throw TypeError(String(it) + ' is not a function');
    return it;
};
// optional / simple context binding
var $dc8851251b4817c5$var$functionBindContext = function(fn, that, length) {
    $dc8851251b4817c5$var$aFunction$1(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $dc8851251b4817c5$var$isArray = Array.isArray || function isArray(arg) {
    return $dc8851251b4817c5$var$classofRaw(arg) == 'Array';
};
var $dc8851251b4817c5$var$engineUserAgent = $dc8851251b4817c5$var$getBuiltIn('navigator', 'userAgent') || '';
var $dc8851251b4817c5$var$process = $dc8851251b4817c5$var$global_1.process;
var $dc8851251b4817c5$var$versions = $dc8851251b4817c5$var$process && $dc8851251b4817c5$var$process.versions;
var $dc8851251b4817c5$var$v8 = $dc8851251b4817c5$var$versions && $dc8851251b4817c5$var$versions.v8;
var $dc8851251b4817c5$var$match, $dc8851251b4817c5$var$version;
if ($dc8851251b4817c5$var$v8) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$v8.split('.');
    $dc8851251b4817c5$var$version = $dc8851251b4817c5$var$match[0] < 4 ? 1 : $dc8851251b4817c5$var$match[0] + $dc8851251b4817c5$var$match[1];
} else if ($dc8851251b4817c5$var$engineUserAgent) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$engineUserAgent.match(/Edge\/(\d+)/);
    if (!$dc8851251b4817c5$var$match || $dc8851251b4817c5$var$match[1] >= 74) {
        $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$engineUserAgent.match(/Chrome\/(\d+)/);
        if ($dc8851251b4817c5$var$match) $dc8851251b4817c5$var$version = $dc8851251b4817c5$var$match[1];
    }
}
var $dc8851251b4817c5$var$engineV8Version = $dc8851251b4817c5$var$version && +$dc8851251b4817c5$var$version;
/* eslint-disable es/no-symbol -- required for testing */ // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $dc8851251b4817c5$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$dc8851251b4817c5$var$fails(function() {
    return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $dc8851251b4817c5$var$engineV8Version && $dc8851251b4817c5$var$engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $dc8851251b4817c5$var$useSymbolAsUid = $dc8851251b4817c5$var$nativeSymbol && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $dc8851251b4817c5$var$WellKnownSymbolsStore = $dc8851251b4817c5$var$shared('wks');
var $dc8851251b4817c5$var$Symbol$1 = $dc8851251b4817c5$var$global_1.Symbol;
var $dc8851251b4817c5$var$createWellKnownSymbol = $dc8851251b4817c5$var$useSymbolAsUid ? $dc8851251b4817c5$var$Symbol$1 : $dc8851251b4817c5$var$Symbol$1 && $dc8851251b4817c5$var$Symbol$1.withoutSetter || $dc8851251b4817c5$var$uid;
var $dc8851251b4817c5$var$wellKnownSymbol = function(name) {
    if (!$dc8851251b4817c5$var$has($dc8851251b4817c5$var$WellKnownSymbolsStore, name) || !($dc8851251b4817c5$var$nativeSymbol || typeof $dc8851251b4817c5$var$WellKnownSymbolsStore[name] == 'string')) {
        if ($dc8851251b4817c5$var$nativeSymbol && $dc8851251b4817c5$var$has($dc8851251b4817c5$var$Symbol$1, name)) $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$Symbol$1[name];
        else $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$createWellKnownSymbol('Symbol.' + name);
    }
    return $dc8851251b4817c5$var$WellKnownSymbolsStore[name];
};
var $dc8851251b4817c5$var$SPECIES = $dc8851251b4817c5$var$wellKnownSymbol('species');
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $dc8851251b4817c5$var$arraySpeciesCreate = function(originalArray, length) {
    var C;
    if ($dc8851251b4817c5$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $dc8851251b4817c5$var$isArray(C.prototype))) C = undefined;
        else if ($dc8851251b4817c5$var$isObject(C)) {
            C = C[$dc8851251b4817c5$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};
var $dc8851251b4817c5$var$push = [].push;
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var $dc8851251b4817c5$var$createMethod$1 = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_OUT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $dc8851251b4817c5$var$toObject($this);
        var self1 = $dc8851251b4817c5$var$indexedObject(O);
        var boundFunction = $dc8851251b4817c5$var$functionBindContext(callbackfn, that, 3);
        var length = $dc8851251b4817c5$var$toLength(self1.length);
        var index = 0;
        var create = specificCreate || $dc8851251b4817c5$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $dc8851251b4817c5$var$push.call(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $dc8851251b4817c5$var$push.call(target, value); // filterOut
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $dc8851251b4817c5$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $dc8851251b4817c5$var$createMethod$1(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $dc8851251b4817c5$var$createMethod$1(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $dc8851251b4817c5$var$createMethod$1(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $dc8851251b4817c5$var$createMethod$1(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $dc8851251b4817c5$var$createMethod$1(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $dc8851251b4817c5$var$createMethod$1(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $dc8851251b4817c5$var$createMethod$1(6),
    // `Array.prototype.filterOut` method
    // https://github.com/tc39/proposal-array-filtering
    filterOut: $dc8851251b4817c5$var$createMethod$1(7)
};
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $dc8851251b4817c5$var$objectKeys = Object.keys || function keys(O) {
    return $dc8851251b4817c5$var$objectKeysInternal(O, $dc8851251b4817c5$var$enumBugKeys);
};
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $dc8851251b4817c5$var$objectDefineProperties = $dc8851251b4817c5$var$descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    $dc8851251b4817c5$var$anObject(O);
    var keys = $dc8851251b4817c5$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$dc8851251b4817c5$var$objectDefineProperty.f(O, key = keys[index++], Properties[key]);
    return O;
};
var $dc8851251b4817c5$var$html = $dc8851251b4817c5$var$getBuiltIn('document', 'documentElement');
var $dc8851251b4817c5$var$GT = '>';
var $dc8851251b4817c5$var$LT = '<';
var $dc8851251b4817c5$var$PROTOTYPE = 'prototype';
var $dc8851251b4817c5$var$SCRIPT = 'script';
var $dc8851251b4817c5$var$IE_PROTO = $dc8851251b4817c5$var$sharedKey('IE_PROTO');
var $dc8851251b4817c5$var$EmptyConstructor = function() {};
var $dc8851251b4817c5$var$scriptTag = function(content) {
    return $dc8851251b4817c5$var$LT + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT + content + $dc8851251b4817c5$var$LT + '/' + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($dc8851251b4817c5$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $dc8851251b4817c5$var$documentCreateElement('iframe');
    var JS = 'java' + $dc8851251b4817c5$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $dc8851251b4817c5$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($dc8851251b4817c5$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $dc8851251b4817c5$var$activeXDocument;
var $dc8851251b4817c5$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $dc8851251b4817c5$var$activeXDocument = document.domain && new ActiveXObject('htmlfile');
    } catch (error) {}
    $dc8851251b4817c5$var$NullProtoObject = $dc8851251b4817c5$var$activeXDocument ? $dc8851251b4817c5$var$NullProtoObjectViaActiveX($dc8851251b4817c5$var$activeXDocument) : $dc8851251b4817c5$var$NullProtoObjectViaIFrame();
    var length = $dc8851251b4817c5$var$enumBugKeys.length;
    while(length--)delete $dc8851251b4817c5$var$NullProtoObject[$dc8851251b4817c5$var$PROTOTYPE][$dc8851251b4817c5$var$enumBugKeys[length]];
    return $dc8851251b4817c5$var$NullProtoObject();
};
$dc8851251b4817c5$var$hiddenKeys[$dc8851251b4817c5$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var $dc8851251b4817c5$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = $dc8851251b4817c5$var$anObject(O);
        result = new $dc8851251b4817c5$var$EmptyConstructor();
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$dc8851251b4817c5$var$IE_PROTO] = O;
    } else result = $dc8851251b4817c5$var$NullProtoObject();
    return Properties === undefined ? result : $dc8851251b4817c5$var$objectDefineProperties(result, Properties);
};
var $dc8851251b4817c5$var$UNSCOPABLES = $dc8851251b4817c5$var$wellKnownSymbol('unscopables');
var $dc8851251b4817c5$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES] == undefined) $dc8851251b4817c5$var$objectDefineProperty.f($dc8851251b4817c5$var$ArrayPrototype, $dc8851251b4817c5$var$UNSCOPABLES, {
    configurable: true,
    value: $dc8851251b4817c5$var$objectCreate(null)
});
// add a key to Array.prototype[@@unscopables]
var $dc8851251b4817c5$var$addToUnscopables = function(key) {
    $dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES][key] = true;
};
var $dc8851251b4817c5$var$$find = $dc8851251b4817c5$var$arrayIteration.find;
var $dc8851251b4817c5$var$FIND = 'find';
var $dc8851251b4817c5$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($dc8851251b4817c5$var$FIND in []) Array(1)[$dc8851251b4817c5$var$FIND](function() {
    $dc8851251b4817c5$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$dc8851251b4817c5$var$_export({
    target: 'Array',
    proto: true,
    forced: $dc8851251b4817c5$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $dc8851251b4817c5$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$dc8851251b4817c5$var$addToUnscopables($dc8851251b4817c5$var$FIND);
var $dc8851251b4817c5$var$_class, $dc8851251b4817c5$var$_class2, $dc8851251b4817c5$var$_temp;
var $dc8851251b4817c5$var$ReactTooltip = $dc8851251b4817c5$var$staticMethods($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$windowListener($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$customEvent($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$isCapture($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$getEffect($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$bodyMode($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$trackRemoval($dc8851251b4817c5$var$_class = ($dc8851251b4817c5$var$_temp = $dc8851251b4817c5$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $dc8851251b4817c5$var$_inherits(ReactTooltip, _React$Component);
    $dc8851251b4817c5$var$_createClass(ReactTooltip, null, [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
                };
            }
        }
    ]);
    function ReactTooltip(props) {
        var _this;
        $dc8851251b4817c5$var$_classCallCheck(this, ReactTooltip);
        _this = $dc8851251b4817c5$var$_possibleConstructorReturn(this, $dc8851251b4817c5$var$_getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            uuid: props.uuid || $dc8851251b4817c5$var$generateUUID(),
            place: props.place || 'top',
            // Direction of tooltip
            desiredPlace: props.place || 'top',
            type: 'dark',
            // Color theme of tooltip
            effect: 'float',
            // float or fixed
            show: false,
            border: false,
            customColors: {},
            offset: {},
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $dc8851251b4817c5$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $dc8851251b4817c5$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case 'Document':
                    case 'HTMLDocument':
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case 'ShadowRoot':
                    default:
                        domRoot = parentNode;
                        break;
                } // Prevent styles duplication.
                if (!domRoot.querySelector('style[data-react-tooltip]')) {
                    var style = document.createElement('style');
                    style.textContent = $dc8851251b4817c5$var$baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = '[data-tip]:not([data-for])';
                else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
                } // Scan document for shadow DOM elements
                $dc8851251b4817c5$var$nodeListToArray(document.getElementsByTagName('*')).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($dc8851251b4817c5$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($dc8851251b4817c5$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute('currentItem') === null) target.setAttribute('currentItem', 'false');
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                    target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
                    if (effect === 'float') target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                    target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
                });
                 // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                } // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children; // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $dc8851251b4817c5$var$getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                } // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                 // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute('aria-describedby', this.state.uuid);
                 // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = $dc8851251b4817c5$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self1.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self1.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self1.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self1.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self1.props.arrowColor || null
                        },
                        effect: effect,
                        offset: offset,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self1.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self1.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self1.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self1.props.border) || false,
                        extraClass: target.getAttribute('data-class') || self1.props["class"] || self1.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $dc8851251b4817c5$var$getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                }; // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                 // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                } // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute('aria-describedby');
                var resetState = function resetState() {
                    var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            } // Calculation the position
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $dc8851251b4817c5$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                 // Set tooltip position
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = $dc8851251b4817c5$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
                var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = "".concat(content, "\n<style aria-hidden=\"true\">").concat(style, "</style>");
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $dc8851251b4817c5$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $dc8851251b4817c5$var$_objectSpread2({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "supportedWrappers", [
    'div',
    'span'
]), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "displayName", 'ReactTooltip'), $dc8851251b4817c5$var$_temp)) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class;
var $dc8851251b4817c5$export$2e2bcd8739ae039 = $dc8851251b4817c5$var$ReactTooltip;


var $ba6adedcdb459bac$exports = {};

/** Used to generate unique IDs. */ var $ba6adedcdb459bac$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $ba6adedcdb459bac$var$uniqueId(prefix) {
    var id = ++$ba6adedcdb459bac$var$idCounter;
    return $f5d9385a9cc7e413$exports(prefix) + id;
}
$ba6adedcdb459bac$exports = $ba6adedcdb459bac$var$uniqueId;


const $213b3ea45c5c64eb$export$28c660c63b792dea = (props)=>{
    const { children: children, text: text, place: place } = props;
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($ba6adedcdb459bac$exports)))();
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($213b3ea45c5c64eb$var$Icon, {
        "data-tip": true,
        "data-for": id,
        "data-event": "click focus"
    }, children), /*#__PURE__*/ $acw62.createElement($213b3ea45c5c64eb$var$TooltipStyled, {
        id: id,
        globalEventOff: "click",
        place: place,
        effect: "solid"
    }, /*#__PURE__*/ $acw62.createElement($213b3ea45c5c64eb$var$TipText, null, text)));
};
const $213b3ea45c5c64eb$var$TipText = (0, $lmFrL.default).div`
  width: 200px;
`;
const $213b3ea45c5c64eb$var$Icon = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${({ theme: theme })=>theme.space[2]};
  cursor: pointer;
`;
const $213b3ea45c5c64eb$var$TooltipStyled = (0, $lmFrL.default)((0, $dc8851251b4817c5$export$2e2bcd8739ae039))`
  color: #232f3c !important;
  background-color: ${({ theme: theme })=>theme.newColors.grayscale.white} !important;
  border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.bordersInside} !important;
  box-sizing: border-box !important;
  box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.hoveredState} !important;
  border-radius: 4px !important;
  padding: 4px 8px !important;

  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 16px !important;

  letter-spacing: -0.01em !important;

  &.place-top {
    &:before {
      bottom: -10px !important;
      border-top: 10px solid transparent !important;
      border-top-color: ${({ theme: theme })=>theme.newColors.grayscale.bordersInside} !important;
    }

    &:after {
      bottom: -9px !important;
      border-top: 9px solid transparent !important;
      border-top-color: ${({ theme: theme })=>theme.newColors.grayscale.white} !important;
    }
  }

  &.place-bottom {
    &:before {
      top: -20px !important;
      border: 10px solid transparent !important;
      border-bottom-color: ${({ theme: theme })=>theme.newColors.grayscale.bordersInside} !important;
    }

    &:after {
      top: -18px !important;
      left: 49.5% !important;
      border: 9px solid transparent !important;
      border-bottom-color: ${({ theme: theme })=>theme.newColors.grayscale.white} !important;
    }
  }

  &.place-right {
    &:before {
      left: -10px !important;
      border-right: 10px solid transparent !important;
      border-right-color: ${({ theme: theme })=>theme.newColors.grayscale.bordersInside} !important;
    }

    &:after {
      left: -8px !important;
      border-right: 9px solid transparent !important;
      border-right-color: ${({ theme: theme })=>theme.newColors.grayscale.white} !important;
    }
  }

  &.place-left {
    &:before {
      right: -10px !important;
      border-left: 10px solid transparent !important;
      border-left-color: ${({ theme: theme })=>theme.newColors.grayscale.bordersInside} !important;
    }

    &:after {
      right: -8px !important;
      border-left: 9px solid transparent !important;
      border-left-color: ${({ theme: theme })=>theme.newColors.grayscale.white} !important;
    }
  }
`;


const $c1023ac6167399f5$export$1be7516c0280bee8 = (props)=>{
    const { text: text, place: place } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $213b3ea45c5c64eb$export$28c660c63b792dea), {
        text: text,
        place: place
    }, /*#__PURE__*/ $acw62.createElement((0, $c6b18e1e224332a0$export$f713256e8ad1586), null));
};


const $d1cfb23e53b30236$var$Container = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;
const $d1cfb23e53b30236$var$LabelContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Flex))`
  font-size: ${({ theme: theme })=>theme.fontSizes[3]};
  line-height: ${({ theme: theme })=>theme.lineHeights[4]};
  color: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
  font-weight: bold;
  letter-spacing: -0.02em;
`;
const $d1cfb23e53b30236$var$Description = (0, $lmFrL.default).div`
  font-size: ${({ theme: theme })=>theme.fontSizes[1]};
  line-height: ${({ theme: theme })=>theme.lineHeights[3]};
  color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
  margin-top: ${({ theme: theme })=>theme.space[1]};
`;
const $d1cfb23e53b30236$var$TopContainer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
`;
const $d1cfb23e53b30236$var$Edit = (0, $lmFrL.default).span`
  color: ${({ theme: theme })=>theme.newColors.secondary.basic};
  font-size: 15px;
  line-height: 26px;
  padding: 0 0.5rem;
  cursor: pointer;

  :hover {
    color: #4e9786;
  }
`;
const $d1cfb23e53b30236$export$b04be29aa201d4f5 = (props)=>{
    const { children: children, label: label, help: help, htmlFor: htmlFor, status: status, edit: edit, onEditClick: onEditClick, disabled: disabled } = props;
    return /*#__PURE__*/ $acw62.createElement($d1cfb23e53b30236$var$Container, null, /*#__PURE__*/ $acw62.createElement($d1cfb23e53b30236$var$TopContainer, null, /*#__PURE__*/ $acw62.createElement($d1cfb23e53b30236$var$LabelContainer, {
        className: props.className
    }, /*#__PURE__*/ $acw62.createElement("label", {
        htmlFor: htmlFor
    }, label, " "), help && help !== "" && /*#__PURE__*/ $acw62.createElement((0, $c1023ac6167399f5$export$1be7516c0280bee8), {
        text: help,
        place: "right"
    }), edit && /*#__PURE__*/ $acw62.createElement($d1cfb23e53b30236$var$Edit, {
        onClick: onEditClick
    }, "EDIT")), status && !disabled ? /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $fd090f2967b171e4$export$9dacaafb9baa8abc), {
        name: status.name,
        type: status.type
    })) : null), /*#__PURE__*/ $acw62.createElement($d1cfb23e53b30236$var$Description, null, children));
};




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



var $d30aef34372d015b$export$ee47ee6cb4ebe8fd = /*#__PURE__*/ function(SelectedElementType) {
    SelectedElementType["SERVICE"] = "service";
    SelectedElementType["WORKFLOW"] = "workflow";
    SelectedElementType["QUESTION"] = "question";
    SelectedElementType["ONE_OF_MANY"] = "oneOfMany";
    SelectedElementType["EVENT"] = "event";
    SelectedElementType["QUESTION_GROUP"] = "questionGroup";
    return SelectedElementType;
}({});



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

const $2dc197c95390b379$export$9759fbee3638143b = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color, testId: testId } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 7L5 10L12 2",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "square"
    }));
};
$2dc197c95390b379$export$9759fbee3638143b.defaultProps = {
    width: "14",
    height: "12",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



const $b18a70253dacc3de$export$2a77c5ae3792996e = [
    {
        id: 0,
        color: "#232f3c"
    },
    {
        id: 1,
        color: "#3b79d1"
    },
    {
        id: 2,
        color: "#186a58"
    },
    {
        id: 3,
        color: "#853b49"
    },
    {
        id: 4,
        color: "#997c15"
    },
    {
        id: 5,
        color: "#52b79b"
    },
    {
        id: 6,
        color: "#e8bd25"
    },
    {
        id: 7,
        color: "#c1475f"
    }
];
const $b18a70253dacc3de$var$Color = (props)=>{
    const { id: id, color: color, setSelected: setSelected, selected: selected, disabled: disabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b18a70253dacc3de$var$ColorRing, {
        color: color,
        onClick: ()=>{
            if (!disabled) setSelected(id);
        },
        selected: selected,
        disabled: disabled
    }, selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2dc197c95390b379$export$9759fbee3638143b), {
        height: 16,
        width: 16
    }));
};
const $b18a70253dacc3de$export$eff3ebfaf2eadb01 = (props)=>{
    const { selectedWorkflowIndex: selectedWorkflowIndex, setSelectedWorkflowIndex: setSelectedWorkflowIndex } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b18a70253dacc3de$var$Header, null, "Select Task / Phase"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b18a70253dacc3de$var$ColorsContainer, null, $b18a70253dacc3de$export$2a77c5ae3792996e.map((mappedColor, colorIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b18a70253dacc3de$var$Color, {
            key: mappedColor.id,
            id: mappedColor.id,
            color: mappedColor.color,
            setSelected: setSelectedWorkflowIndex,
            selected: mappedColor.id === selectedWorkflowIndex,
            disabled: colorIndex + 1 > props.numberOfExistingWorkflows
        }))));
};
const $b18a70253dacc3de$var$Header = (0, $lmFrL.default).div`
  margin-top: 21px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
`;
const $b18a70253dacc3de$var$ColorsContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  margin: 1rem 0 !important;
  font-weight: bold;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
const $b18a70253dacc3de$var$ColorRing = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  background-color: ${({ color: color })=>color};
  height: 30px;
  width: calc(100% / 4 - 6px);
  box-shadow: 0 4px 8px 0 rgba(141, 211, 199, 0.3);
  border: solid 1px #dedede;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: ${({ disabled: disabled })=>disabled ? "default" : "pointer"};

  ${({ selected: selected })=>selected && (0, $lmFrL.css)`
      border: 3px solid #3267cf;
    `}

  & > svg {
    margin-top: 4px;
  }
`;



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");


var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");

const $9eb29ab2880b8781$export$1ae95d1a7411cb7b = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 9v10H8V9h8zm-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z",
        fill: color
    }));
};
$9eb29ab2880b8781$export$1ae95d1a7411cb7b.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorState
};



var $acw62 = parcelRequire("acw62");

const $8ec9903342680886$export$51b6cd98f8778f0d = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8v-2z",
        fill: color
    }));
};
$8ec9903342680886$export$51b6cd98f8778f0d.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

const $68d47805524f5874$export$10862138e9169702 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
        fill: color
    }));
};
$68d47805524f5874$export$10862138e9169702.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

const $d6a40bdd11492229$export$3e0409b11e4da6d2 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: color,
        d: "M16.5 17l-1.41-1.41L17.67 13H8v-2h9.67l-2.58-2.59L16.5 7l5 5-5 5z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: color,
        d: "M5 3h11c1.1 0 2 .9 2 2H5v14h13c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
    }));
};
$d6a40bdd11492229$export$3e0409b11e4da6d2.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};







const $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d = (mutationName, cache, mutationResult, projectId, sampleId)=>{
    const incomingData = mutationResult?.data?.[mutationName];
    const existingData = cache.readQuery({
        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
        variables: {
            id: projectId
        }
    })?.["Project"];
    if (existingData && incomingData) {
        const sampleIndex = existingData.samples.findIndex((s)=>s.id === sampleId);
        const samples = [
            ...existingData.samples
        ];
        if (sampleIndex >= 0) {
            samples[sampleIndex] = {
                ...samples[sampleIndex],
                ...incomingData
            };
            cache.writeQuery({
                variables: {
                    id: projectId
                },
                query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                data: {
                    Project: {
                        ...existingData,
                        samples: samples
                    }
                }
            });
            return true;
        }
    }
    return false;
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $4016d912c7091cca$export$1f33f980da756c46 = (props)=>{
    const { isOpen: isOpen, closeModal: closeModal, acceptModal: acceptModal, message: message, title: title, yesButtonText: yesButtonText = "ACCEPT", isLoading: isLoading } = props;
    const ModalButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4016d912c7091cca$var$AcceptButton, {
            label: yesButtonText,
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: acceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: closeModal
        }));
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4016d912c7091cca$var$StyledModal, {
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        id: "ConfirmationModal",
        title: title,
        onClose: closeModal,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, message));
};
const $4016d912c7091cca$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $4016d912c7091cca$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  &
    > .modal-dialog
    > .modal-content-footer
    > .modal-content-wrapper
    > .modal-content {
    min-width: 0;
    padding: 0;
  }
`;





var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");









const $309ab67c8b4d6de6$export$f8a0408ff830a5a9 = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const [selectedTask, setSelectedTask] = (0, $acw62.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [moveServiceToChosenWorkflow] = (0, $7608a8bbcbbad14c$export$2986f8b991ad98cd)();
    if (!(selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const userProjectQueryResult = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: selectedEntity.selectedElementPath.projectId
        }
    });
    if (userProjectQueryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", userProjectQueryResult.error);
    if (userProjectQueryResult.loading || !userProjectQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const chosenTask = (option)=>{
        setSelectedTask(option);
    };
    const onAcceptModal = ()=>{
        if (!selectedTask) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, workflowId: workflowId, service: { id: id } } = selectedEntity.selectedElementPath;
        moveServiceToChosenWorkflow({
            variables: {
                projectSampleWorkflowServiceInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    workflowId: workflowId,
                    serviceId: id
                },
                destinationWorkflowId: selectedTask.value
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
            setIsLoading(false);
            onClose();
        }).catch((e)=>{
            setIsLoading(false);
        });
    };
    const ModalButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($309ab67c8b4d6de6$var$AcceptButton, {
            disabled: isLoading,
            label: "Move Subtask",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    };
    const getOptions = ()=>{
        const foundSample = userProjectQueryResult.data?.Project.samples.find((sample)=>sample.id === selectedEntity.selectedElementPath.sampleId);
        const { workflowId: workflowId } = selectedEntity.selectedElementPath;
        const availableOptions = foundSample?.enabledWorkflows.filter((workflow)=>workflow.id !== workflowId).map((workflow)=>({
                value: workflow.id,
                label: `${workflow.name}`
            })) || [];
        availableOptions.push({
            value: "CreateNewTask",
            label: "Create a new Task for this Subtask"
        });
        return availableOptions;
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($309ab67c8b4d6de6$var$StyledModal, {
        id: "moveSubtaskToOtherTask",
        title: "Move Subtask to other Task",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($309ab67c8b4d6de6$var$StyledDropdown, {
        closeMenuOnSelect: true,
        value: selectedTask,
        options: getOptions(),
        onChange: chosenTask,
        placeholder: "Select destination Task"
    }));
};
const $309ab67c8b4d6de6$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $309ab67c8b4d6de6$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $309ab67c8b4d6de6$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 100%;
  .Select__option:last-child {
    border-top: 1px solid #dedede;
  }

  .Select__option:only-child {
    border-top: transparent;
  }
`;



var $acw62 = parcelRequire("acw62");

const $bb5408929c185189$export$7111563bfe31e497 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fill: color,
        d: "M12 16c1.25 0 2.313-.437 3.188-1.312S16.5 12.75 16.5 11.5c0-1.25-.437-2.313-1.312-3.188S13.25 7 12 7c-1.25 0-2.313.437-3.188 1.312S7.5 10.25 7.5 11.5c0 1.25.437 2.313 1.312 3.188S10.75 16 12 16zm0-1.8c-.75 0-1.387-.263-1.912-.788A2.601 2.601 0 019.3 11.5c0-.75.263-1.388.788-1.913A2.603 2.603 0 0112 8.8c.75 0 1.388.262 1.913.787.525.525.787 1.163.787 1.913s-.262 1.387-.787 1.912A2.605 2.605 0 0112 14.2zm0 4.8c-2.317 0-4.433-.612-6.35-1.837-1.917-1.225-3.367-2.88-4.35-4.963a.813.813 0 01-.1-.313 2.919 2.919 0 010-.775.811.811 0 01.1-.312c.983-2.083 2.433-3.737 4.35-4.962C7.567 4.613 9.683 4 12 4c2.317 0 4.433.613 6.35 1.838 1.917 1.225 3.367 2.879 4.35 4.962.05.083.083.187.1.312a2.936 2.936 0 010 .775.813.813 0 01-.1.313c-.983 2.083-2.433 3.738-4.35 4.963C16.433 18.388 14.317 19 12 19zm0-2a9.545 9.545 0 005.188-1.488A9.77 9.77 0 0020.8 11.5a9.777 9.777 0 00-3.612-4.013A9.55 9.55 0 0012 6a9.55 9.55 0 00-5.188 1.487A9.777 9.777 0 003.2 11.5a9.77 9.77 0 003.612 4.012A9.545 9.545 0 0012 17z"
    }));
};
$bb5408929c185189$export$7111563bfe31e497.defaultProps = {
    width: "24",
    height: "24",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");










const $d3e79295a1bee167$export$db09748cd23470a9 = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const [selectedPath, setSelectedPath] = (0, $acw62.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [copyTaskToChosenSample] = (0, $7608a8bbcbbad14c$export$54d39c9b6d539ca7)();
    if (!(selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const userProjectQueryResult = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: selectedEntity.selectedElementPath.projectId
        }
    });
    if (userProjectQueryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", userProjectQueryResult.error);
    if (userProjectQueryResult.loading || !userProjectQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const onAcceptModal = ()=>{
        if (!selectedPath) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, workflowId: workflowId } = selectedEntity.selectedElementPath;
        copyTaskToChosenSample({
            variables: {
                projectSampleWorkflowInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    workflowId: workflowId
                },
                destinationSampleId: selectedPath.value
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
            setIsLoading(false);
            onClose();
        }).catch(()=>{
            setIsLoading(false);
        });
    };
    const ModalButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3e79295a1bee167$var$AcceptButton, {
            disabled: isLoading,
            label: "Move Task",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    const getOptions = ()=>{
        const { sampleId: sampleId } = selectedEntity.selectedElementPath;
        const availableOptions = userProjectQueryResult.data?.Project.samples.filter((sample)=>sample.id !== sampleId).map((sample)=>({
                value: sample.id,
                label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)
            })) || [];
        availableOptions.push({
            value: "CreateNewSample",
            label: "Create a new Path for this Task"
        });
        return availableOptions;
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3e79295a1bee167$var$StyledModal, {
        id: "copyTaskToOtherPathModal",
        title: "Copy Task to other Path",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3e79295a1bee167$var$StyledDropdown, {
        closeMenuOnSelect: true,
        value: selectedPath,
        options: getOptions(),
        onChange: (option)=>setSelectedPath(option),
        placeholder: "Select destination Path"
    }));
};
const $d3e79295a1bee167$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $d3e79295a1bee167$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $d3e79295a1bee167$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 100%;
  .Select__option:last-child {
    border-top: 1px solid #dedede;
  }

  .Select__option:only-child {
    border-top: transparent;
  }
`;


const $8e533dbe14bc68d5$var$isUnknownObject = (x)=>{
    return x != null && typeof x === "object";
};
const $8e533dbe14bc68d5$export$d51625d75caede58 = (object)=>{
    if ($8e533dbe14bc68d5$var$isUnknownObject(object)) return "service" in object;
    return false;
};
const $8e533dbe14bc68d5$export$e2a35ec91c774fdd = (object)=>{
    if ($8e533dbe14bc68d5$var$isUnknownObject(object)) return "event" in object;
    return false;
};
const $8e533dbe14bc68d5$export$975149a1b2911df8 = (object)=>{
    if ($8e533dbe14bc68d5$var$isUnknownObject(object)) return "workflow" in object;
    return false;
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");







var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $45fvw = parcelRequire("45fvw");

var $3c339a8eee4a5286$exports = {};






























































!function(e, t) {
    t($3c339a8eee4a5286$exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("8g1PZ")), (parcelRequire("9BdaM")), (parcelRequire("cFZfS")), (parcelRequire("6IhJz")), (parcelRequire("bTSG2")), (parcelRequire("kehhj")), (parcelRequire("6OX6Q")), (parcelRequire("2MTnF")), (parcelRequire("eqWMS")), (parcelRequire("kbDwl")), (parcelRequire("8o58w")), (parcelRequire("58cSq")), (parcelRequire("4irF8")), (parcelRequire("lDduA")), (parcelRequire("lXe7Q")), (parcelRequire("4UG1B")), (parcelRequire("6fhf3")), (parcelRequire("aABJG")), (parcelRequire("kjLiX")), (parcelRequire("34ylv")), (parcelRequire("eZOMj")), (parcelRequire("hbMru")), (parcelRequire("4UeRq")), (parcelRequire("3LPyO")), (parcelRequire("knAHj")), (parcelRequire("2SwgK")), (parcelRequire("d0W11")), (parcelRequire("6mdUF")), (parcelRequire("gpyWg")), (parcelRequire("cZ2kT")), (parcelRequire("fVhCa")), (parcelRequire("3lKFD")), (parcelRequire("8v9st")), (parcelRequire("6atcA")), (parcelRequire("lm2ga")), (parcelRequire("1Whvr")), (parcelRequire("e4h6L")), (parcelRequire("jMhzE")), (parcelRequire("cJfMa")), (parcelRequire("7yBDJ")), (parcelRequire("5E40x")), (parcelRequire("gVPZO")), (parcelRequire("6eIgt")), (parcelRequire("6uyHy")), (parcelRequire("75XN4")), (parcelRequire("l2vHo")), (parcelRequire("gd5RE")), (parcelRequire("hjw1k")), (parcelRequire("b27pX")), (parcelRequire("R4xmB")), (parcelRequire("kggGd")), (parcelRequire("baBa1")), (parcelRequire("4YTY5")), (parcelRequire("gDwFN")), (parcelRequire("gdr0J")), (parcelRequire("auRgN")), (parcelRequire("dpjX2")), (parcelRequire("hL3CS")), (parcelRequire("1u0KT")), (parcelRequire("7tYfQ")));
}($3c339a8eee4a5286$exports, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, C, S, _, M, P, E, N, O, Y, x, T, I, L, F, R, q, A, W, K, B, j, H, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Ce = le(D), Se = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(C), Oe = le(S), Ye = le(_), xe = le(M), Te = le(P), Ie = le(E), Le = le(N), Fe = le(O), Re = le(Y), qe = le(x), Ae = le(T), We = le(I), Ke = le(L), Be = le(F), je = le(R), He = le(q), Qe = le(W), Ve = le(K), Ue = le(B), $e = le(j), ze = le(H), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function Ct(e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? bt(e) : t;
    }
    function St(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return Ct(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/), n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, Ot = 12, Yt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function xt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return It(t) ? t : null;
    }
    function Tt(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var r = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = It(r, n) && e === he.default(r, t, {
                awareOfUnicodeTokens: !0
            })), It(r, n) && i && (o = r);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = It(o) && e === he.default(o, t, {
            awareOfUnicodeTokens: !0
        }) : It(o) || (t = t.match(Yt).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), It(o) || (o = new Date(e))), It(o) && i ? o : null);
    }
    function It(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && at.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Ft(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Rt(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Re.default(Fe.default(Le.default(e, i), o), a);
    }
    function qt(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return Oe.default(e, r ? {
            locale: r
        } : null);
    }
    function At(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Kt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Bt(e) {
        return $e.default(e);
    }
    function jt(e) {
        return Ge.default(e);
    }
    function Ht(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : $parcel$global).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : $parcel$global;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(qe.default(xt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(qe.default(xt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(Ae.default(xt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && !o.some(function(t) {
            return $t(e, t);
        }) || s && !s(xt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates;
        return r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(xt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Te.default(e), o = Ye.default(e), s = Te.default(t), i = Ye.default(t), p = Te.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(xt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Te.default(e), o = xe.default(e), s = Te.default(t), i = xe.default(t), p = Te.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && je.default(e, r) < 0 || a && je.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = xt(), s = Re.default(Fe.default(o, Me.default(e)), Pe.default(e)), i = Re.default(Fe.default(o, Me.default(r)), Pe.default(r)), p = Re.default(Fe.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && He.default(r, n) > 0 || a && a.every(function(e) {
            return He.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && He.default(n, r) > 0 || a && a.every(function(e) {
            return He.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return je.default(e, t) >= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return je.default(e, t) <= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ot, r = Math.ceil(Te.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Cr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Te.default(r) <= s), a && i && (i = Te.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Sr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                var e = a.props.year, t = a.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t)
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = a.props.minDate ? Te.default(a.props.minDate) : null, n = a.props.maxDate ? Te.default(a.props.maxDate) : null;
                return n && a.state.yearsList.find(function(e) {
                    return e === n;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: a.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && a.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: a.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(a), "onChange", function(e) {
                a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), Dt(bt(a), "shiftYears", function(e) {
                var t = a.state.yearsList.map(function(t) {
                    return t + e;
                });
                a.setState({
                    yearsList: t
                });
            }), Dt(bt(a), "incrementYears", function() {
                return a.shiftYears(1);
            }), Dt(bt(a), "decrementYears", function() {
                return a.shiftYears(-1);
            });
            var n = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = n || (o ? 10 : 5);
            return a.state = {
                yearsList: Cr(a.props.year, s, a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), _r = lt.default(Sr), Mr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Te.default(e.props.minDate) : 1900, r = e.props.maxDate ? Te.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.props.month === r ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r)
                    }, e.props.month === r ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function Or(e, t) {
        for(var r = [], a = Bt(e), n = Bt(t); !at.default(a, n);)r.push(xt(a)), a = we.default(a, 1);
        return r;
    }
    var Yr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Ie.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t)
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: Or(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), xr = lt.default(Yr), Tr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Bt(e.props.minDate), r = Bt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Ie.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Ie.default(Bt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(xr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = xt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Ir = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.startDate, p = r.endDate, l = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !l || e.isDisabled()) && (n && p && (nt.default(l, p) || zt(l, p)) ? Gt(a, l, p) : (o && i && (at.default(l, i) || zt(l, i)) || !(!s || !i || p || !at.default(l, i) && !zt(l, i))) && Gt(a, i, l));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isOutsideMonth", function() {
                return void 0 !== e.props.month && e.props.month !== Ye.default(e.props.day);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + At(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSameDay(e.props.selected),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isSameDay(xt()),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isOutsideMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                if (e.isOutsideMonth()) {
                    if (e.props.monthShowsDuplicateDaysEnd && Ne.default(e.props.day) < 10) return null;
                    if (e.props.monthShowsDuplicateDaysStart && Ne.default(e.props.day) > 20) return null;
                }
                return e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "button",
                    "aria-disabled": e.isDisabled()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : qt(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Kt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Ir, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        includeDates: e.props.includeDates,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(qe.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(Ae.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Kt(Bt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Fr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Ye.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    includeDates: e.props.includeDates,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Bt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Ce.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(Ht(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(qe.default(a, t), e.props),
                    "react-datepicker__month--selected": Ye.default(a) === t && Te.default(a) === Te.default(s),
                    "react-datepicker__month-text--keyboard-selected": Ye.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = Ye.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.ariaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = qe.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(Ae.default(a, t), e.props),
                    "react-datepicker__quarter--selected": xe.default(a) === t && Te.default(a) === Te.default(s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "button",
                            "aria-label": e.getAriaLabel(t)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, r) {
                    return de.default.createElement("div", {
                        key: r,
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM"))
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), qr = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.props.selected && r === Pe.default(t) && a === Me.default(t) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(xt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || xt(), p = Pe.default(i), l = Me.default(i), d = Re.default(Fe.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0"
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(qr, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var Ar = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = jt(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, jt(a.props.selected)) && $t(t, jt(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(jt(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Se.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Te.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": e === Te.default(xt())
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Te.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Kr(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Br = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], jr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Br.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = xt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: qe.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(qe.default(r, Ye.default(e)), Te.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Kt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? Ot : a, o = br(jt(Se.default(e, n)), n).endPeriod, s = r && Te.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthAriaLabel, i = void 0 === s ? "Previous Month" : s, p = o.previousYearAriaLabel, l = void 0 === p ? "Previous Year" : p;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? l : i
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? Ot : a, o = br(ge.default(e, n), n).startPeriod, s = r && Te.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthAriaLabel, i = void 0 === s ? "Next Month" : s, p = o.nextYearAriaLabel, l = void 0 === p ? "Next Year" : p;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? l : i
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Te.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Ye.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Tr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(xt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Te.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Ce.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Rr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(Ar, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(qr, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = It(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Kr;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: Ot
                    };
                }
            }
        ]), r;
    }(de.default.Component), Hr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = document.getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), document.body.appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = St(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId;
                    if (!n) {
                        var f = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: f,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(Hr, {
                        portalId: u
                    }, e));
                    var h = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: h
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(jr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = St(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : xt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = Tt(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Rt(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Rt(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = xt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = xt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Ce.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Se.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Ye.default(r), s = Ye.default(n), i = Te.default(r), p = Te.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Ft(e, r), n = t ? Ft(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Ft(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Ye.default(r) !== Ye.default(a) || Te.default(r) !== Te.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(Hr, {
                            portalId: this.props.portalId
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: Ot,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Kr, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : $parcel$global;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : $parcel$global).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



var $acw62 = parcelRequire("acw62");

const $165a42873c6cf021$export$f1075f53fba499b3 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "15.5",
        stroke: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M10 14h12m-.857-2.4H10.857c-.473 0-.857.359-.857.8v8.8c0 .442.384.8.857.8h10.286c.473 0 .857-.358.857-.8v-8.8c0-.441-.384-.8-.857-.8z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: color,
        strokeLinecap: "square",
        strokeMiterlimit: "10",
        d: "M12.571 10v1.6m6.858-1.6v1.6M16 10v1.6"
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        width: "100%",
        height: "100%",
        fill: "transparent",
        id: "calendar-icon"
    }));
};
$165a42873c6cf021$export$f1075f53fba499b3.defaultProps = {
    width: "32",
    height: "32",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside
};


const $db52be5984f608c1$export$5109c6dd95d8fb00 = (props)=>{
    const { date: date, setDate: setDate, editMode: editMode, showIcon: showIcon, selectedDatePickerId: selectedDatePickerId, setSelectedDatePickerId: setSelectedDatePickerId, datePickerId: datePickerId, isOpen: isOpen = false, className: className } = props;
    const selected = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).toDate();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($db52be5984f608c1$var$Container, {
        editMode: editMode,
        className: className
    }, showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($db52be5984f608c1$var$IconContainer, {
        onClick: ()=>{
            if (selectedDatePickerId && selectedDatePickerId !== datePickerId) return setSelectedDatePickerId(datePickerId);
            return setSelectedDatePickerId(selectedDatePickerId ? null : datePickerId);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $165a42873c6cf021$export$f1075f53fba499b3), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($db52be5984f608c1$var$StyledDatePicker, {
        id: "date-picker",
        selected: selected,
        onChange: (newDate)=>{
            if (setDate) {
                setDate(newDate);
                setSelectedDatePickerId(null);
            }
        },
        peekNextMonth: true,
        showMonthDropdown: true,
        showYearDropdown: true,
        dateFormat: "d MMMM yyyy",
        dropdownMode: "select",
        disabled: !editMode,
        editMode: editMode,
        onInputClick: ()=>{
            if (selectedDatePickerId && selectedDatePickerId !== datePickerId) return setSelectedDatePickerId(datePickerId);
            return setSelectedDatePickerId(selectedDatePickerId ? null : datePickerId);
        },
        onClickOutside: (ev)=>{
            const target = ev.target;
            if (target.id === "calendar-icon" || target.id === "date-picker") return null;
            return setSelectedDatePickerId(null);
        },
        shouldCloseOnSelect: true,
        open: datePickerId === selectedDatePickerId || isOpen,
        onKeyDown: (ev)=>ev.preventDefault()
    }));
};
const $db52be5984f608c1$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;

  .react-datepicker__header {
    background-color: white;
  }

  .react-datepicker__month-select,
  .react-datepicker__year-select {
    background-color: white;
    border: 1px solid #adb1bc;
    box-shadow: 0px 2px 4px rgba(220, 222, 229, 0.6);
    border-radius: 4px;
    padding: 5px;
    margin: 10px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: inherit;
    color: inherit;

    &:hover {
      background-color: #f0f0f0;
    }
  }

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`;
const $db52be5984f608c1$var$StyledDatePicker = (0, $lmFrL.default)((/*@__PURE__*/$parcel$interopDefault($3c339a8eee4a5286$exports)))`
  margin-left: 13px;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  background-color: white;
  color: black;
  cursor: auto;
  caret-color: transparent;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  &:focus {
    outline: none;
  }

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `}
`;
const $db52be5984f608c1$var$IconContainer = (0, $lmFrL.default).div`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;


const $24bc540d66893e15$export$2ad826a25ca9f46e = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const [newStartDate, setNewStartDate] = (0, $acw62.useState)(new Date());
    const [selectedDatePickerId, setSelectedDatePickerId] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [moveServicesToNewStartDate] = (0, $7608a8bbcbbad14c$export$be31b74f37fbe58)();
    if (!selectedEntity || !selectedEntity.selectedElementPath) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const onAcceptModal = ()=>{
        if (!newStartDate) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId } = selectedEntity.selectedElementPath;
        const newStartDateWithCorrectHours = new Date(newStartDate.setHours(0, 0, 0, 0));
        moveServicesToNewStartDate({
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                newStartDate: newStartDateWithCorrectHours.getTime().toString()
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
            setIsLoading(false);
            onClose();
        }).catch((e)=>{
            setIsLoading(false);
        });
    };
    const ModalButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24bc540d66893e15$var$AcceptButton, {
            disabled: isLoading,
            label: "Move All Tasks and Services",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24bc540d66893e15$var$StyledModal, {
        id: "moveAllServicesToNewStartDate",
        title: "Move All Services To New Start Date",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24bc540d66893e15$var$StyledLineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: newStartDate,
        setDate: setNewStartDate,
        editMode: true,
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 10
    })));
};
const $24bc540d66893e15$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }

  .modal-content-wrapper {
    background: white;
  }
`;
const $24bc540d66893e15$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $24bc540d66893e15$var$StyledLineContainer = (0, $lmFrL.default).div`
  width: 180px;
`; // const StyledDropdown = styled(Dropdown)`
 //   width: 100%;
 //
 //   .Select__option:last-child {
 //     border-top: 1px solid #dedede;
 //   }
 //
 //   .Select__option:only-child {
 //     border-top: transparent;
 //   }
 // `;



var $acw62 = parcelRequire("acw62");

const $8aeeca65aa4d76f9$export$b38ed03f19f841e2 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: color,
        d: "M3.25 1.5A1.75 1.75 0 001.5 3.25v15.5A1.75 1.75 0 003 20.482V13.25A2.25 2.25 0 015.25 11h11.5A2.25 2.25 0 0119 13.25v7.232a1.75 1.75 0 001.5-1.732V5.786c0-.465-.184-.91-.513-1.238l-2.535-2.535a1.749 1.749 0 00-1.238-.513H16v4.25A2.25 2.25 0 0113.75 8h-6.5A2.25 2.25 0 015 5.75V1.5H3.25zm3.25 0v4.25c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75V1.5h-8zm11 19v-7.25a.75.75 0 00-.75-.75H5.25a.75.75 0 00-.75.75v7.25h13zM0 3.25A3.25 3.25 0 013.25 0h12.965a3.25 3.25 0 012.298.952l2.535 2.535c.61.61.952 1.437.952 2.299V18.75A3.25 3.25 0 0118.75 22H3.25A3.25 3.25 0 010 18.75V3.25z"
    }));
};
$8aeeca65aa4d76f9$export$b38ed03f19f841e2.defaultProps = {
    width: "22",
    height: "22",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");









const $505f6b7bd7e9db49$export$9e11d46da0387635 = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [fieldValue, setFieldValue] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (selectedEntity && (0, $8e533dbe14bc68d5$export$975149a1b2911df8)(selectedEntity.selectedElementPath)) {
            const { workflow: workflow } = selectedEntity.selectedElementPath;
            setFieldValue(workflow.name);
        }
    }, [
        selectedEntity
    ]);
    const onChange = (event)=>{
        setFieldValue(event.target.value);
    };
    const [saveWorkflowTemplate] = (0, $7608a8bbcbbad14c$export$3dc5b673b15f2ff7)();
    if (!isOpen || !(selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const onAcceptModal = ()=>{
        if (!fieldValue) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, workflowId: workflowId } = selectedEntity.selectedElementPath;
        saveWorkflowTemplate({
            variables: {
                projectSampleWorkflowInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    workflowId: workflowId
                },
                organization: user["https://leaderneplatform.com/organization"],
                templateName: fieldValue
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$95cf04aeba3a0624),
                    variables: {
                        organization: user["https://leaderneplatform.com/organization"]
                    }
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setIsLoading(false);
            onClose();
        }).catch((e)=>{
            setIsLoading(false);
        });
    };
    const ModalButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($505f6b7bd7e9db49$var$AcceptButton, {
            disabled: isLoading,
            label: "Save Template",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($505f6b7bd7e9db49$var$StyledModal, {
        id: "saveAsTemplateModal",
        title: "Save as a Template",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        value: fieldValue,
        onChange: onChange
    }));
};
const $505f6b7bd7e9db49$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $505f6b7bd7e9db49$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;


const $8d5c67818b2014d7$export$97b2572d967d561a = (props)=>{
    const { closeMenu: closeMenu, mainQuestionGroupId: mainQuestionGroupId, userRoleInSample: userRoleInSample } = props;
    const [isConfirmationModalForRemoveOpen, setIsConfirmationModalForRemoveOpen] = (0, $acw62.useState)(false);
    const [isConfirmationModalForRemoveSampleOpen, setIsConfirmationModalForRemoveSampleOpen] = (0, $acw62.useState)(false);
    const [isConfirmationModalForDuplicateOpen, setIsConfirmationModalForDuplicateOpen] = (0, $acw62.useState)(false);
    const [isMoveSubtaskToTaskModalOpen, setIsMoveSubtaskToTaskModalOpen] = (0, $acw62.useState)(false);
    const [isConfirmationModalForMakeElementVisible, setIsConfirmationModalForMakeElementVisible] = (0, $acw62.useState)(false);
    const [isCopyTaskToOtherPathModalOpen, setIsCopyTaskToOtherPathModalOpen] = (0, $acw62.useState)(false);
    const [isSaveAsTemplateModalOpen, setIsSaveAsTemplateModalOpen] = (0, $acw62.useState)(false);
    const [isMoveAllServicesToNewStartDateModalVisible, setIsMoveAllServicesToNewStartDateModalVisible] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const [removeServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$8e73b281d471a42c)();
    const [removeWorkflowFromSample] = (0, $7608a8bbcbbad14c$export$abfe606629e42547)();
    const [removeEventFromSample] = (0, $7608a8bbcbbad14c$export$860462a0577d7243)();
    const [duplicateWorkflowInSampleMutation] = (0, $7608a8bbcbbad14c$export$1d93abf243f57e46)();
    const [removeQuestionGroupFromSampleMutation] = (0, $7608a8bbcbbad14c$export$c99471ae92b86a10)();
    const [makeTimelineElementVisibleMutation] = (0, $7608a8bbcbbad14c$export$9392965d6afe019f)();
    let deleteIsEnabled = useUserPermissions("deleteTasks", userRoleInSample);
    let moveSubtaskIsEnabled = useUserPermissions("moveSubtask", userRoleInSample);
    let duplicateIsEnabled = useUserPermissions("duplicateTask", userRoleInSample);
    let copyTaskToOtherPathIsEnabled = useUserPermissions("copyTaskToOtherPath", userRoleInSample);
    let saveAsTemplateIsEnabled = useUserPermissions("saveAsTemplate", userRoleInSample);
    let makeElementVisible = useUserPermissions("makeElementVisible", userRoleInSample);
    let moveAllServicesToNewStartDateIsEnabled = useUserPermissions("moveAllServicesToNewStartDate", userRoleInSample);
    const [removeSampleFromProjectMutation] = (0, $7608a8bbcbbad14c$export$fb5b0faacb9a4f3f)();
    const removeSampleFromProject = async ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["RemoveSampleFromProject"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator/samples/${incomingData[0].id}/configurator`);
                    cache.writeQuery({
                        variables: {
                            id: projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: incomingData
                            }
                        }
                    });
                    setIsLoading(false);
                }
            }
        };
        await removeSampleFromProjectMutation(options);
    };
    const removeQuestionGroupFromSample = ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        const { projectId: projectId, sampleId: sampleId, serviceId: serviceId, workflowId: workflowId, questionGroupId: questionGroupId, fromReport: fromReport } = selectedEntity.selectedElementPath;
        setSelectedEntity(undefined);
        setSideDrawboardOpen(false);
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    fromReport: fromReport,
                    workflowId: workflowId,
                    serviceId: serviceId
                },
                questionGroupId: questionGroupId
            },
            update (cache, mutationResult) {
                (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("RemoveQuestionGroupFromSample", cache, mutationResult, projectId, sampleId);
            }
        };
        removeQuestionGroupFromSampleMutation(options);
    };
    if ((0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).USER_TASKS) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).GROUP_TASKS) || selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.originPathId !== selectedEntity.selectedElementPath.sampleId || selectedEntity && (0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.originPathId !== selectedEntity.selectedElementPath.sampleId) {
        deleteIsEnabled = false;
        duplicateIsEnabled = false;
        copyTaskToOtherPathIsEnabled = false;
        saveAsTemplateIsEnabled = false;
        moveSubtaskIsEnabled = false;
        makeElementVisible = false;
        moveAllServicesToNewStartDateIsEnabled = false;
    }
    const deleteServiceFromWorkflow = ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, service: service, workflowId: workflowId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: workflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceId: service.id
            },
            update (cache, { data: data }) {
                const incomingData = data?.["RemoveServiceFromWorkflow"];
                const existingQueryResult = (0, $f1q41.cloneDeep)(cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"]);
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = samples.find((s)=>s.id === sampleId);
                    if (foundSample) {
                        const workflowIndex = foundSample.enabledWorkflows.findIndex((ew)=>ew.id === workflowId);
                        if (workflowIndex !== -1) {
                            foundSample.enabledWorkflows[workflowIndex] = incomingData;
                            const sampleIndex = samples.findIndex((s)=>s.id === sampleId);
                            samples[sampleIndex] = {
                                ...foundSample
                            };
                            existingQueryResult.samples = [
                                ...samples
                            ];
                            cache.writeQuery({
                                variables: {
                                    id: projectId
                                },
                                query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                data: {
                                    Project: {
                                        ...existingQueryResult
                                    }
                                }
                            });
                        }
                    }
                    setSelectedEntity(undefined);
                    setSideDrawboardOpen(false);
                    setIsLoading(false);
                    setIsConfirmationModalForRemoveOpen(false);
                }
            }
        };
        removeServiceFromWorkflow(options).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalForRemoveOpen(false);
        });
    };
    const deleteWorkflowFromSample = ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, workflowId: workflowId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: workflowId,
                    workflowDesignation: "enabledWorkflows"
                }
            },
            update (cache, mutationResult) {
                const sampleUpdated = (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("RemoveWorkflowFromSample", cache, mutationResult, projectId, sampleId);
                if (sampleUpdated) {
                    setSelectedEntity(undefined);
                    setSideDrawboardOpen(false);
                    setIsLoading(false);
                    setIsConfirmationModalForRemoveOpen(false);
                }
            }
        };
        removeWorkflowFromSample(options).catch((e)=>{
            setIsLoading(false);
        });
    };
    const deleteEventFromWorkflow = ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, event: event } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                eventId: event.id
            },
            update (cache, mutationResult) {
                const sampleUpdated = (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("RemoveEventFromSample", cache, mutationResult, projectId, sampleId);
                if (sampleUpdated) {
                    setSelectedEntity(undefined);
                    setSideDrawboardOpen(false);
                    setIsLoading(false);
                    setIsConfirmationModalForRemoveOpen(false);
                }
            }
        };
        removeEventFromSample(options).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalForRemoveOpen(false);
        });
    };
    const onDeleteClick = ()=>{
        if (!selectedEntity || !deleteIsEnabled) return;
        if (selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW) {
            deleteWorkflowFromSample();
            return;
        }
        if (selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE) {
            deleteServiceFromWorkflow();
            return;
        }
        if (selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) deleteEventFromWorkflow();
    };
    const handleCopyUrl = ()=>{
        const pageUrl = window.location.href;
        try {
            navigator.clipboard.writeText(pageUrl).then(()=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).info("Copied link to the clipboard");
            }, ()=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error("Couldn't copy the link to the clipboard, check your browser settings");
            });
        } catch (error) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("Couldn't copy the link to the clipboard, check your browser settings");
        }
        closeMenu();
    };
    const handleDuplicatePath = ()=>{
        if (!selectedEntity || !duplicateIsEnabled) return;
        setIsLoading(true);
        const { projectId: projectId, sampleId: sampleId, workflowId: workflowId } = selectedEntity.selectedElementPath;
        duplicateWorkflowInSampleMutation({
            variables: {
                projectSampleWorkflowInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    workflowId: workflowId
                }
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                }
            ]
        }).then(()=>{
            setIsLoading(false);
            setIsConfirmationModalForDuplicateOpen(false);
        }).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalForDuplicateOpen(false);
        });
    };
    const handleMakeElementVisible = ()=>{
        if (!selectedEntity || !makeElementVisible) return;
        let timelineElementVisibleInput;
        if ((0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath)) {
            const { projectId: projectId, sampleId: sampleId, workflowId: workflowId, service: { id: serviceId }, visibleOnAllPaths: visibleOnAllPaths } = selectedEntity.selectedElementPath;
            timelineElementVisibleInput = {
                projectId: projectId,
                sampleId: sampleId,
                workflowId: workflowId,
                serviceId: serviceId,
                removeVisibility: visibleOnAllPaths
            };
        }
        if ((0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath)) {
            const { projectId: projectId, sampleId: sampleId, event: { id: eventId }, visibleOnAllPaths: visibleOnAllPaths } = selectedEntity.selectedElementPath;
            timelineElementVisibleInput = {
                projectId: projectId,
                sampleId: sampleId,
                eventId: eventId,
                removeVisibility: visibleOnAllPaths
            };
        }
        if (!timelineElementVisibleInput) return;
        setIsLoading(true);
        makeTimelineElementVisibleMutation({
            variables: {
                timelineElementVisibleInput: timelineElementVisibleInput
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: timelineElementVisibleInput.projectId
                    }
                }
            ]
        }).then(()=>{
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
            setIsConfirmationModalForMakeElementVisible(false);
            setIsLoading(false);
        }).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalForMakeElementVisible(false);
        });
    };
    const conditionallyShowSectionDelete = ()=>{
        if (!selectedEntity || !deleteIsEnabled || !mainQuestionGroupId) return false;
        const { questionGroupId: questionGroupId } = selectedEntity.selectedElementPath;
        if (selectedEntity.selectedElementType !== (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP || questionGroupId === mainQuestionGroupId) return false;
        return true;
    };
    const visibleText = selectedEntity && selectedEntity.selectedElementPath.visibleOnAllPaths ? "unvisible" : "visible";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$List, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: handleCopyUrl,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ec9903342680886$export$51b6cd98f8778f0d), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Copy URL")), moveSubtaskIsEnabled && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsMoveSubtaskToTaskModalOpen(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6a40bdd11492229$export$3e0409b11e4da6d2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Move to other Task")), makeElementVisible && (selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsConfirmationModalForMakeElementVisible(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb5408929c185189$export$7111563bfe31e497), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, `Make it ${visibleText} on all Paths`)), moveAllServicesToNewStartDateIsEnabled && (selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsMoveAllServicesToNewStartDateModalVisible(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb5408929c185189$export$7111563bfe31e497), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Move all services to a new start date")), duplicateIsEnabled && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsConfirmationModalForDuplicateOpen(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68d47805524f5874$export$10862138e9169702), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Duplicate")), copyTaskToOtherPathIsEnabled && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsCopyTaskToOtherPathModalOpen(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68d47805524f5874$export$10862138e9169702), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Copy Task to other Path")), saveAsTemplateIsEnabled && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        onClick: ()=>{
            closeMenu();
            setIsSaveAsTemplateModalOpen(true);
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8aeeca65aa4d76f9$export$b38ed03f19f841e2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Save as a Template")), deleteIsEnabled && (selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteLi, {
        onClick: ()=>{
            closeMenu();
            setIsConfirmationModalForRemoveOpen(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Delete")), conditionallyShowSectionDelete() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteLi, {
        onClick: ()=>{
            closeMenu();
            setIsConfirmationModalForRemoveOpen(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Delete Form Section")), deleteIsEnabled && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteLi, {
        onClick: ()=>{
            closeMenu();
            setIsConfirmationModalForRemoveSampleOpen(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeleteIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8d5c67818b2014d7$var$DeletePathText, null, "Delete the whole Path"))), isConfirmationModalForRemoveOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveOpen,
        message: "Are you sure you want to remove this task?",
        title: "Confirmation",
        yesButtonText: "Remove task",
        closeModal: ()=>setIsConfirmationModalForRemoveOpen(false),
        acceptModal: onDeleteClick,
        isLoading: isLoading
    }), isConfirmationModalForRemoveOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveOpen,
        message: "Are you sure you want to remove this subtask?",
        title: "Confirmation",
        yesButtonText: "Remove subtask",
        closeModal: ()=>setIsConfirmationModalForRemoveOpen(false),
        acceptModal: onDeleteClick,
        isLoading: isLoading
    }), isConfirmationModalForRemoveOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveOpen,
        message: "Are you sure you want to remove this event?",
        title: "Confirmation",
        yesButtonText: "Remove event",
        closeModal: ()=>setIsConfirmationModalForRemoveOpen(false),
        acceptModal: onDeleteClick,
        isLoading: isLoading
    }), isConfirmationModalForDuplicateOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForDuplicateOpen,
        message: "Are you sure you want to duplicate this task?",
        title: "Confirmation",
        yesButtonText: "Duplicate task",
        closeModal: ()=>setIsConfirmationModalForDuplicateOpen(false),
        acceptModal: handleDuplicatePath,
        isLoading: isLoading
    }), isConfirmationModalForMakeElementVisible && (selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForMakeElementVisible,
        message: `Are you sure you want to make it ${visibleText} on all paths?`,
        title: "Confirmation",
        yesButtonText: `Make it ${visibleText}`,
        closeModal: ()=>setIsConfirmationModalForMakeElementVisible(false),
        acceptModal: handleMakeElementVisible,
        isLoading: isLoading
    }), isMoveSubtaskToTaskModalOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $309ab67c8b4d6de6$export$f8a0408ff830a5a9), {
        isOpen: isMoveSubtaskToTaskModalOpen,
        onClose: ()=>setIsMoveSubtaskToTaskModalOpen(false)
    }), isCopyTaskToOtherPathModalOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3e79295a1bee167$export$db09748cd23470a9), {
        isOpen: isCopyTaskToOtherPathModalOpen,
        onClose: ()=>setIsCopyTaskToOtherPathModalOpen(false)
    }), isSaveAsTemplateModalOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $505f6b7bd7e9db49$export$9e11d46da0387635), {
        isOpen: isSaveAsTemplateModalOpen,
        onClose: ()=>setIsSaveAsTemplateModalOpen(false)
    }), isMoveAllServicesToNewStartDateModalVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24bc540d66893e15$export$2ad826a25ca9f46e), {
        isOpen: isMoveAllServicesToNewStartDateModalVisible,
        onClose: ()=>setIsMoveAllServicesToNewStartDateModalVisible(false)
    }), isConfirmationModalForRemoveOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveOpen,
        message: "Do you want to delete this section?",
        title: "Confirmation",
        closeModal: ()=>setIsConfirmationModalForRemoveOpen(false),
        acceptModal: ()=>removeQuestionGroupFromSample(),
        isLoading: isLoading
    }), isConfirmationModalForRemoveSampleOpen && selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveSampleOpen,
        message: "Do you want to delete this path?",
        title: "Confirmation",
        yesButtonText: "DELETE PATH",
        closeModal: ()=>setIsConfirmationModalForRemoveSampleOpen(false),
        acceptModal: ()=>removeSampleFromProject(),
        isLoading: isLoading
    }));
};
const $8d5c67818b2014d7$var$IconContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.25rem !important;
`;
const $8d5c67818b2014d7$var$DeleteIconContainer = (0, $lmFrL.default)($8d5c67818b2014d7$var$IconContainer)`
  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover > path {
    fill: ${({ theme: theme })=>theme.newColors.extra.errorHovered};
    transition: fill linear 0.2s;
  }

  & > svg:active > path {
    fill: ${({ theme: theme })=>theme.newColors.extra.errorActive};
    transition: fill linear 0.2s;
  }
`;
const $8d5c67818b2014d7$var$DeleteLi = (0, $lmFrL.default).li`
  display: flex;
  justify-content: start;
  padding: 0.8rem;
  cursor: pointer;

  &:hover {
    background: ${({ theme: theme })=>theme.newColors.primary.lightTint};
  }

  &:active {
    background-color: ${({ theme: theme })=>theme.newColors.primary.lightestTint};
  }
`;
const $8d5c67818b2014d7$var$List = (0, $lmFrL.default).ul`
  list-style: none;
  padding: 0;
  margin: 0;

  & li {
    padding: 0.8rem;
    display: flex;
    align-items: center;
    line-height: 1rem;
    gap: 6px;
    cursor: pointer;
    transition: 200ms;
  }

  & li > p {
    margin: 0;
    padding-top: 2px;
    line-height: 22px;
    white-space: nowrap;
  }

  & li:first-of-type:hover {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  & li:last-of-type:hover {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  & li:hover {
    background-color: ${({ theme: theme })=>theme.newColors.primary.lightTint};
    transition: 200ms;
  }

  & li:active {
    background-color: ${({ theme: theme })=>theme.newColors.primary.lightestTint};
    transition: 200ms;
  }
`;
const $8d5c67818b2014d7$var$DeletePathText = (0, $lmFrL.default).p`
  color: #f40505;
`;


const $064a049026fadc98$export$41744e2e60971504 = ({ isMenuOpen: isMenuOpen, mainQuestionGroupId: mainQuestionGroupId, userRoleInSample: userRoleInSample })=>{
    const dropdownMenuRef = (0, $acw62.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dropdownButtonRef = (0, $acw62.useRef)(null);
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(isMenuOpen);
    (0, $ab7e5a8bc378b63a$export$2e2bcd8739ae039)(dropdownMenuRef, (event)=>{
        if (!dropdownButtonRef.current.contains(event.target)) setMenuOpen(false);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($064a049026fadc98$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($064a049026fadc98$var$DotsIconContainer, {
        ref: dropdownButtonRef,
        onClick: ()=>setMenuOpen(!menuOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0ac02571a3ef321$export$277089a45d8e9a3b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($064a049026fadc98$var$Menu, {
        ref: dropdownMenuRef,
        isMenuOpen: menuOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d5c67818b2014d7$export$97b2572d967d561a), {
        closeMenu: ()=>setMenuOpen(false),
        mainQuestionGroupId: mainQuestionGroupId,
        userRoleInSample: userRoleInSample
    }))));
};
const $064a049026fadc98$var$DotsIconContainer = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.25rem !important;

  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover circle {
    fill: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
    transition: fill linear 0.2s;
  }

  & > svg:active circle {
    fill: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
    transition: fill linear 0.2s;
  }
`;
const $064a049026fadc98$var$Container = (0, $lmFrL.default)((0, $5bf921a129ee049a$exports.Box))`
  position: relative;
`;
const $064a049026fadc98$var$Menu = (0, $lmFrL.default).nav`
  background: ${({ theme: theme })=>theme.newColors.grayscale.white};
  border-radius: 0.5rem;
  position: absolute;
  top: 2rem;
  right: 0;
  min-width: 240px;
  box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.basicInside};
  border: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  z-index: 10;

  ${({ isMenuOpen: isMenuOpen })=>isMenuOpen && (0, $lmFrL.css)`
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    `}
`;



const $91f376d2ad47e03d$export$f521b166687784ce = (props)=>{
    const { numberOfExistingWorkflows: numberOfExistingWorkflows, mainQuestionGroupId: mainQuestionGroupId, userRoleInSample: userRoleInSample } = props;
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const budgetIsVisible = useUserPermissions("seeBudget", userRoleInSample);
    if (!selectedEntity && numberOfExistingWorkflows && numberOfExistingWorkflows > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b18a70253dacc3de$export$eff3ebfaf2eadb01), {
        numberOfExistingWorkflows: numberOfExistingWorkflows
    });
    if (!selectedEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const calculateUsedBudgetInThisWorkflow = ()=>{
        const currentWorkflow = selectedEntity.selectedElementPath.workflow;
        const budgetSumInCurrencies = {};
        currentWorkflow.services.forEach((service)=>{
            const priceData = service.price;
            if (priceData) {
                if (!budgetSumInCurrencies[priceData.currency]) budgetSumInCurrencies[priceData.currency] = 0;
                budgetSumInCurrencies[priceData.currency] += parseFloat(priceData.price.value);
            }
        });
        return budgetSumInCurrencies;
    };
    const calculateRemainingBudget = (budgetData)=>{
        const remainingBudgetInCurrencies = {};
        const currentWorkflow = selectedEntity.selectedElementPath.workflow;
        const budgetCurrency = currentWorkflow.price?.currency;
        const budgetValue = currentWorkflow.price?.price.value;
        if (budgetCurrency && budgetValue) remainingBudgetInCurrencies[budgetCurrency] = parseFloat(budgetValue);
        Object.keys(budgetData).forEach((currency)=>{
            if (!remainingBudgetInCurrencies[currency]) remainingBudgetInCurrencies[currency] = 0;
            remainingBudgetInCurrencies[currency] -= budgetData[currency];
        });
        return remainingBudgetInCurrencies;
    };
    const formatBudgetDataToString = (budgetSumInCurrencies)=>{
        const outputArray = [];
        Object.keys(budgetSumInCurrencies).forEach((currency)=>{
            const sumOfBudgets = budgetSumInCurrencies[currency];
            outputArray.push(`${sumOfBudgets}${currency}`);
        });
        return outputArray.join(", ");
    };
    let budgetData = {};
    let remainingBudget = {};
    let itemName = "";
    let headerContent = "";
    let headerAreaContent = null;
    switch(selectedEntity.selectedElementType){
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP:
            itemName = selectedEntity.selectedElementPath.questionGroupName;
            headerContent = "You edit";
            break;
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION:
            itemName = selectedEntity.selectedElementPath.questionName;
            headerContent = "You edit";
            break;
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY:
            itemName = selectedEntity.selectedElementPath.questionName;
            headerContent = "Answers of";
            break;
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE:
            itemName = selectedEntity.selectedElementPath.workflowName;
            headerContent = "Part of";
            break;
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW:
            if (budgetIsVisible) {
                budgetData = calculateUsedBudgetInThisWorkflow();
                remainingBudget = calculateRemainingBudget(budgetData);
                headerAreaContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Header, null, "BUDGET USED BY SUBTASKS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Content, null, formatBudgetDataToString(budgetData)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Header, null, "BUDGET REMAINING"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Content, null, formatBudgetDataToString(remainingBudget)));
            }
            break;
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT:
            itemName = selectedEntity.selectedElementPath.event.name;
            headerContent = "You edit";
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Container, null, headerAreaContent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Header, null, headerContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$Content, null, itemName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91f376d2ad47e03d$var$IconsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $064a049026fadc98$export$41744e2e60971504), {
        isMenuOpen: false,
        mainQuestionGroupId: mainQuestionGroupId,
        userRoleInSample: userRoleInSample
    })));
};
const $91f376d2ad47e03d$var$Container = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  margin-top: 21px;
  font-weight: bold;
`;
const $91f376d2ad47e03d$var$Header = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  font-size: 14px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
`;
const $91f376d2ad47e03d$var$Content = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  font-size: 12px;
  text-transform: uppercase;
`;
const $91f376d2ad47e03d$var$IconsContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  position: absolute;
  bottom: 1rem;
  right: 2rem;
`;



const $6ec0d34cc6282180$export$7cc2e931cb5d855 = (props)=>{
    const { dropdownData: dropdownData, selectedDropdownDataId: selectedDropdownDataId, onDataClick: onDataClick, userRoleInSample: userRoleInSample } = props;
    const [dropdownValue, setDropdownValue] = (0, $acw62.useState)({
        label: "",
        value: ""
    });
    const [mainQuestionGroupId, setMainQuestionGroupId] = (0, $acw62.useState)("");
    const { sideDrawboardOpen: sideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    (0, $acw62.useEffect)(()=>{
        if (!dropdownData || !selectedDropdownDataId || !onDataClick) return;
        const selectedSample = dropdownData.find((data)=>data.id === selectedDropdownDataId);
        if (selectedSample) {
            setDropdownValue({
                label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(selectedSample),
                value: selectedSample.id
            });
            if (selectedSample.selectedQuestionGroups.length > 0) setMainQuestionGroupId(selectedSample.selectedQuestionGroups[0].id);
        }
    }, [
        selectedDropdownDataId
    ]);
    const samplesDropdown = dropdownData?.map((dataItem)=>({
            value: dataItem.id,
            label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(dataItem)
        }));
    const handleDropdownChange = (selectedValue)=>{
        const { value: value } = selectedValue;
        if (value) onDataClick(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6ec0d34cc6282180$var$Container, {
        open: sideDrawboardOpen
    }, sideDrawboardOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, dropdownData && selectedDropdownDataId && onDataClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
        options: samplesDropdown,
        onChange: handleDropdownChange,
        value: dropdownValue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $91f376d2ad47e03d$export$f521b166687784ce), {
        numberOfExistingWorkflows: props.numberOfExistingWorkflows,
        mainQuestionGroupId: mainQuestionGroupId,
        userRoleInSample: userRoleInSample
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6ec0d34cc6282180$var$StyledLabel, {
        label: dropdownValue.label
    }));
};
const $6ec0d34cc6282180$var$Container = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  padding: ${({ open: open })=>open ? "1.5rem 2rem 1rem 2rem" : "0"};
  min-height: 181px;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
  position: relative;

  ${({ open: open })=>!open && (0, $lmFrL.css)`
      display: flex;
      align-items: center;
      & > div {
        margin-bottom: 0;
      }
    `}
`;
const $6ec0d34cc6282180$var$StyledLabel = (0, $lmFrL.default)((0, $d1cfb23e53b30236$export$b04be29aa201d4f5))`
  writing-mode: vertical-rl;
  transform: scale(-1);
  width: 18px;

  & label {
    height: 149px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
`;


const $9b46390a7c7d7753$export$7280240986cdf65a = (props)=>{
    const { className: className, children: children, dropdownData: dropdownData, selectedDropdownDataId: selectedDropdownDataId, onDataClick: onDataClick, fixedViewMode: fixedViewMode = true, userRoleInSample: userRoleInSample } = props;
    const { sideDrawboardOpen: sideDrawboardOpen, setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b46390a7c7d7753$var$Container, {
        open: sideDrawboardOpen,
        fixedViewMode: fixedViewMode,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ec0d34cc6282180$export$7cc2e931cb5d855), {
        dropdownData: dropdownData,
        onDataClick: onDataClick,
        selectedDropdownDataId: selectedDropdownDataId,
        numberOfExistingWorkflows: props.numberOfExistingWorkflows,
        userRoleInSample: userRoleInSample
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b46390a7c7d7753$var$ContentContainer, null, sideDrawboardOpen ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b46390a7c7d7753$var$ExpandIconContainer, {
        onClick: ()=>setSideDrawboardOpen(!sideDrawboardOpen)
    }, sideDrawboardOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ad5d98d28e20636$export$d3dc052aee88bdfc), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d819d56e4eee36d1$export$a84e507fd943d8f9), null)));
};
const $9b46390a7c7d7753$var$Container = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: ${({ open: open })=>open ? "337px" : "72px"};
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
  flex-direction: column;
  border-left: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
  position: ${(props)=>props.fixedViewMode ? "fixed" : "sticky"};
  top: 0;
  right: 0;
  height: 100vh;
  box-shadow: ${(props)=>props.theme.shadows.sideDrawboard.basicLeftOutisde};
`;
const $9b46390a7c7d7753$var$ContentContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
`;
const $9b46390a7c7d7753$var$ExpandIconContainer = (0, $lmFrL.default).div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 2rem;
  position: absolute;
  margin-left: -1rem;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.icons.expandIcon};

  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover circle {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.hover};
    transition: fill linear 0.2s;
  }

  & > svg:active circle {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.darkestTint};
    transition: fill linear 0.2s;
  }
`;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $34138cd79f9cdb64$export$55a73bc3d4b275e4 = (props)=>{
    const { title: title, value: value, editable: editable = true, onChange: onChange, onBlur: onBlur, className: className } = props;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($34138cd79f9cdb64$var$Container, {
        className: className
    }, /*#__PURE__*/ $acw62.createElement($34138cd79f9cdb64$var$Title, null, title), /*#__PURE__*/ $acw62.createElement($34138cd79f9cdb64$var$ValueContainer, {
        contentEditable: editable,
        suppressContentEditableWarning: true,
        editMode: editable,
        onChange: onChange,
        onBlur: onBlur
    }, value)));
};
const $34138cd79f9cdb64$var$Container = (0, $lmFrL.default).div`
  margin: 0 1rem;
  padding: 1rem 0;
`;
const $34138cd79f9cdb64$var$Title = (0, $lmFrL.default).div`
  margin-bottom: 0.5rem;
  color: ${(props)=>props.theme.newColors.primary.basic};
  font-size: 0.8rem;
`;
const $34138cd79f9cdb64$var$ValueContainer = (0, $lmFrL.default).div`
  border: solid 1px ${(props)=>props.theme.newColors.grayscale.bordersInside};
  border-radius: 4px;
  padding: 9px;
  line-height: 1rem;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      min-width: calc(100% - 106px);

      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `}
`;






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $d2e03a45ef627067$var$Container = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 16px;
  display: flex;
  padding: 3px;
`;
const $d2e03a45ef627067$var$Icon = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
`;
const $d2e03a45ef627067$var$Message = (0, $lmFrL.default).div`
  color: ${(props)=>props.color};
`;
const $d2e03a45ef627067$export$c92c6401b52a9298 = (props)=>{
    const { message: message, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement($d2e03a45ef627067$var$Container, null, /*#__PURE__*/ $acw62.createElement($d2e03a45ef627067$var$Icon, null, /*#__PURE__*/ $acw62.createElement((0, $13f85ea00a6416c9$export$bb4d7813766e20d3), {
        width: "12",
        height: "12",
        color: color
    })), /*#__PURE__*/ $acw62.createElement($d2e03a45ef627067$var$Message, {
        color: color
    }, message));
};



var $acw62 = parcelRequire("acw62");
const $42463a34abab2d04$export$9b5dff8e8139613e = ({ className: className })=>/*#__PURE__*/ $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
        fill: "#3B79D1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 13L10 16L17 8",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "square"
    }));


const $e226f22baf630209$var$Root = (0, $lmFrL.default).div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: relative;

  &::before {
    content: "";
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.tertiaryGray};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    border-radius: 4px;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
    }
  }

  ${(props)=>props.checked && (0, $lmFrL.css)`
      &::before {
        background: ${({ theme: theme })=>theme.newColors.primary.basic};
        border: none;
      }
    `}
  
  &:hover {
    &::before {
      background: ${({ theme: theme })=>theme.newColors.grayscale.background};
      border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
    }
  }
`;
const $e226f22baf630209$var$LabelText = (0, $lmFrL.default).label`
  margin-left: 41px;
  font-size: ${(props)=>props.theme.fontSizes[2]};
  line-height: ${(props)=>props.theme.lineHeights[4]};
  white-space: nowrap;
  cursor: pointer;
  color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  user-select: none;

  letter-spacing: -0.01em;

  ${({ disabled: disabled, theme: theme })=>disabled && (0, $lmFrL.css)`
      color: ${theme.newColors.grayscale.placeholder};
    `}
`;
const $e226f22baf630209$var$Container = (0, $lmFrL.default).div`
  height: 48px;
  padding: 12px 16px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  background: ${({ checked: checked, theme: theme })=>checked ? theme.newColors.primary.lightestTint : theme.newColors.grayscale.white};

  box-shadow: ${({ checked: checked, theme: theme })=>checked ? theme.shadows.userInputs.activeState : theme.shadows.userInputs.basicInside};
  border: 1px solid
    ${({ checked: checked, theme: theme })=>checked ? theme.newColors.primary.basic : theme.newColors.grayscale.bordersInside};

  ${({ disabled: disabled, checked: checked, theme: theme })=>disabled ? (0, $lmFrL.css)`
          background: #e7e7e7;
          color: #adb1bc;
          border: 1px solid #adb1bc;
        ` : (0, $lmFrL.css)`
          &:hover {
            border-color: ${!checked && theme.newColors.grayscale.placeholder};
            box-shadow: ${theme.shadows.userInputs.hoveredState};

            & > ${$e226f22baf630209$var$Root} {
              &::before {
                background: ${theme.newColors.grayscale.background};
                border: 1px solid ${theme.newColors.grayscale.tertiaryGray};
              }
            }
          }
        `}
`;
const $e226f22baf630209$var$Fill = (0, $lmFrL.default).div`
  opacity: 0;
  width: 0;
  height: 0;
  border-radius: 100%;
  position: absolute;
  pointer-events: none;
  z-index: 1;
`;
const $e226f22baf630209$var$Input = (0, $lmFrL.default).input`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ checked: checked })=>checked ? (0, $lmFrL.css)`
          & ~ ${$e226f22baf630209$var$Fill} {
            opacity: 1;
          }
        ` : ``}
`;
const $e226f22baf630209$var$TipContainer = (0, $lmFrL.default).div`
  margin-top: 8px;
`;
const $e226f22baf630209$var$MainContainer = (0, $lmFrL.default).div``;
const $e226f22baf630209$export$48513f6b9f8ce62d = (props)=>{
    const [checked, setChecked] = (0, $acw62.useState)(props.checked);
    const { value: value, labelText: labelText, name: name, tip: tip, disabled: disabled } = props;
    (0, $acw62.useEffect)(()=>{
        setChecked(props.checked);
    }, [
        props.checked
    ]);
    const onChange = disabled ? ()=>{} : ()=>{
        setChecked(!checked);
        props.onChange({
            value: value,
            checked: !checked,
            name: labelText
        });
    };
    return /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$MainContainer, null, /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$Container, {
        checked: checked,
        onClick: onChange,
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$Root, {
        checked: checked
    }, /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$Input, {
        id: value,
        type: "checkbox",
        onChange: onChange,
        name: name,
        value: value,
        checked: checked,
        "aria-checked": checked
    }), /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$Fill, null, /*#__PURE__*/ $acw62.createElement((0, $42463a34abab2d04$export$9b5dff8e8139613e), null)), /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$LabelText, {
        onClick: onChange,
        disabled: disabled
    }, labelText))), tip && tip !== "" && /*#__PURE__*/ $acw62.createElement($e226f22baf630209$var$TipContainer, null, /*#__PURE__*/ $acw62.createElement((0, $d2e03a45ef627067$export$c92c6401b52a9298), {
        message: tip,
        color: "black"
    })));
};


const $4ef5e8aede5b8ad7$export$93613990e3f30616 = ()=>{
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity || selectedEntity.selectedElementType !== (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    const [title, setTitle] = $acw62.useState(selectedEntity.selectedElementPath.questionName);
    const [description, setDescription] = $acw62.useState(selectedEntity.selectedElementPath.questionDescription);
    const [checked, setChecked] = $acw62.useState(selectedEntity.selectedElementPath.questionIsObligatory);
    $acw62.useEffect(()=>{
        setTitle(selectedEntity.selectedElementPath.questionName);
        setDescription(selectedEntity.selectedElementPath.questionDescription);
        setChecked(selectedEntity.selectedElementPath.questionIsObligatory);
    }, [
        selectedEntity
    ]);
    const [updateQuestionInQuestionGroupFromSample] = (0, $7608a8bbcbbad14c$export$2135cdf0f1a972ba)();
    const useQuestionMutation = (destination, value)=>{
        const { projectId: projectId, sampleId: sampleId, questionId: questionId, questionSetId: questionSetId, questionGroupId: questionGroupId, fromReport: fromReport, workflowId: workflowId, serviceId: serviceId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                questionInput: {
                    questionId: questionId,
                    questionSetId: questionSetId,
                    questionGroupId: questionGroupId,
                    fromReport: fromReport,
                    workflowId: workflowId,
                    serviceId: serviceId
                },
                questionUpdatables: {
                    id: questionId,
                    [destination]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateQuestionInQuestionGroupFromSample"];
                const existingQueryResult = (0, $f1q41.cloneDeep)(cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"]);
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = samples.find((s)=>s.id === sampleId);
                    if (foundSample) {
                        let selectedQuestionGroups;
                        if (fromReport && workflowId && serviceId) selectedQuestionGroups = foundSample.enabledWorkflows.find((wf)=>wf.id === workflowId)?.services.find((s)=>s.id === serviceId)?.report?.selectedQuestionGroups;
                        else selectedQuestionGroups = foundSample.selectedQuestionGroups;
                        if (selectedQuestionGroups) {
                            const questionGroupIndex = selectedQuestionGroups.findIndex((qg)=>qg.id === questionGroupId);
                            if (questionGroupIndex !== -1) {
                                const questionSetIndex = selectedQuestionGroups[questionGroupIndex].questionSets.findIndex((qs)=>qs.id === questionSetId);
                                if (questionSetIndex !== -1) {
                                    const questionIndex = selectedQuestionGroups[questionGroupIndex].questionSets[questionSetIndex].questions.findIndex((q)=>q.id === questionId);
                                    if (questionIndex !== -1) {
                                        selectedQuestionGroups[questionGroupIndex].questionSets[questionSetIndex].questions[questionIndex] = incomingData;
                                        const sampleIndex = samples.findIndex((s)=>s.id === sampleId);
                                        samples[sampleIndex] = {
                                            ...foundSample
                                        };
                                        existingQueryResult.samples = [
                                            ...samples
                                        ];
                                        cache.writeQuery({
                                            variables: {
                                                id: projectId
                                            },
                                            query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                            data: {
                                                Project: {
                                                    ...existingQueryResult
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
        updateQuestionInQuestionGroupFromSample(options);
    };
    const handleOnTitleChange = (e)=>{
        setTitle(e.target.textContent || "");
    };
    const handleOnTitleBlur = (e)=>{
        if (!e.target.textContent) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You must enter a field name.");
            return;
        }
        if (e.target.textContent === title) return;
        useQuestionMutation("question", e.target.textContent);
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                questionName: e.target.textContent
            }
        });
    };
    const handleOnDescriptionChange = (e)=>{
        setDescription(e.target.textContent || "");
    };
    const handleOnDescriptionBlur = (e)=>{
        if (e.target.textContent === description) return;
        useQuestionMutation("description", e.target.textContent || "");
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                questionDescription: e.target.textContent || ""
            }
        });
    };
    const handleOnRequiredChange = (e)=>{
        const booleanValue = e.checked === true;
        setChecked(booleanValue);
        useQuestionMutation("isObligatory", booleanValue);
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                questionIsObligatory: booleanValue
            }
        });
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $34138cd79f9cdb64$export$55a73bc3d4b275e4), {
        title: "Title:",
        value: title,
        onChange: handleOnTitleChange,
        onBlur: handleOnTitleBlur
    }), /*#__PURE__*/ $acw62.createElement((0, $34138cd79f9cdb64$export$55a73bc3d4b275e4), {
        title: "Description:",
        value: description,
        onChange: handleOnDescriptionChange,
        onBlur: handleOnDescriptionBlur
    }), /*#__PURE__*/ $acw62.createElement((0, $e226f22baf630209$export$48513f6b9f8ce62d), {
        value: "Required",
        checked: checked,
        onChange: handleOnRequiredChange,
        labelText: "Required",
        name: "options"
    }));
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

function $983350b7b3960a26$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $983350b7b3960a26$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $983350b7b3960a26$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("6VZtt"));



var $1u0KT = parcelRequire("1u0KT");


var $1u0KT = parcelRequire("1u0KT");
// Default to a dummy "batch" implementation that just runs the callback
function $cf080a8910d18aed$var$defaultNoopBatch(callback) {
    callback();
}
let $cf080a8910d18aed$var$batch = $cf080a8910d18aed$var$defaultNoopBatch; // Allow injecting another batching function later
const $cf080a8910d18aed$export$4b9874722d0da7bc = (newBatch)=>$cf080a8910d18aed$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $cf080a8910d18aed$export$fc47d4c0ba3bd2c6 = ()=>$cf080a8910d18aed$var$batch;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $e8505e67f6dd14ea$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $e8505e67f6dd14ea$export$2e2bcd8739ae039 = $e8505e67f6dd14ea$export$cc80c08dc91f1c00;


function $c880d57f8c47009a$export$c1275ca9a6fd3ec5() {
    const contextValue = (0, $acw62.useContext)((0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00));
    return contextValue;
}



const $f0ceea941b7dd061$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $2a3acbb4cad78826$var$useSyncExternalStoreWithSelector = (0, $f0ceea941b7dd061$export$20656a4825650bd0);
const $2a3acbb4cad78826$export$e2e6e3f3f3b782e3 = (fn)=>{
    $2a3acbb4cad78826$var$useSyncExternalStoreWithSelector = fn;
};
const $2a3acbb4cad78826$var$refEquality = (a, b)=>a === b;
function $2a3acbb4cad78826$export$2b53f90d2bd1cbfb(context = (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00) ? (0, $c880d57f8c47009a$export$c1275ca9a6fd3ec5) : ()=>(0, $acw62.useContext)(context);
    return function useSelector(selector, equalityFn = $2a3acbb4cad78826$var$refEquality) {
        const { store: store, subscription: subscription, getServerState: getServerState } = useReduxContext();
        const selectedState = $2a3acbb4cad78826$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $2a3acbb4cad78826$export$2105062e25df4afe = /*#__PURE__*/ $2a3acbb4cad78826$export$2b53f90d2bd1cbfb();



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
var $f295447d0f5fb45a$exports = {};
'use strict';

$f295447d0f5fb45a$exports = (parcelRequire("5iEZS"));



var $1En50 = parcelRequire("1En50");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1abce40d3dc4e46c$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $14e51739290174f6$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $1abce40d3dc4e46c$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $14e51739290174f6$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $14e51739290174f6$var$verify(mapStateToProps, 'mapStateToProps');
    $14e51739290174f6$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $14e51739290174f6$var$verify(mergeProps, 'mergeProps');
}


const $e76849ceef979e2a$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e76849ceef979e2a$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e76849ceef979e2a$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $1En50.default)(_ref, $e76849ceef979e2a$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e76849ceef979e2a$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $5e583867e2f217e8$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $945775474b0ff5ac$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $64f24de3dd0d73be$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $945775474b0ff5ac$export$2e2bcd8739ae039)(value)) (0, $1abce40d3dc4e46c$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $f70db0793775d021$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $f70db0793775d021$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $f70db0793775d021$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f70db0793775d021$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f70db0793775d021$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $804dd51f6de769e5$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $c181d4ebdd1964e4$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $f70db0793775d021$export$710f7c60f68acd3e)((dispatch)=>(0, $5e583867e2f217e8$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $f70db0793775d021$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $f70db0793775d021$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $804dd51f6de769e5$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $ddcd5dccb12a6480$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $f70db0793775d021$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $f70db0793775d021$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $804dd51f6de769e5$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}



var $8nd05 = parcelRequire("8nd05");


function $b2f1e54a980c2942$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $b2f1e54a980c2942$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $b2f1e54a980c2942$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$b2f1e54a980c2942$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $b2f1e54a980c2942$export$5b105939c84b5234(mergeProps) : (0, $804dd51f6de769e5$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $ca8148ec12768bbe$var$createListenerCollection() {
    const batch = (0, $cf080a8910d18aed$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $ca8148ec12768bbe$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $ca8148ec12768bbe$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $ca8148ec12768bbe$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $ca8148ec12768bbe$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $ca8148ec12768bbe$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $acw62 = parcelRequire("acw62");
const $8f419e08aecb0795$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $8f419e08aecb0795$export$700979bc83e7db82 = $8f419e08aecb0795$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $cfdaddca61ecedf2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $cfdaddca61ecedf2$export$2e2bcd8739ae039(objA, objB) {
    if ($cfdaddca61ecedf2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$cfdaddca61ecedf2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $42eb6aad476e9cd0$var$_excluded = [
    "reactReduxForwardedRef"
];
let $42eb6aad476e9cd0$var$useSyncExternalStore = (0, $f0ceea941b7dd061$export$20656a4825650bd0);
const $42eb6aad476e9cd0$export$36d45daa6a4925b8 = (fn)=>{
    $42eb6aad476e9cd0$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $42eb6aad476e9cd0$var$EMPTY_ARRAY = [
    null,
    0
];
const $42eb6aad476e9cd0$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $42eb6aad476e9cd0$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $42eb6aad476e9cd0$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8f419e08aecb0795$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $42eb6aad476e9cd0$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $42eb6aad476e9cd0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $42eb6aad476e9cd0$var$initStateUpdates = ()=>$42eb6aad476e9cd0$var$EMPTY_ARRAY;
function $42eb6aad476e9cd0$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $42eb6aad476e9cd0$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $42eb6aad476e9cd0$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $42eb6aad476e9cd0$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $cfdaddca61ecedf2$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $cfdaddca61ecedf2$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $cfdaddca61ecedf2$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $ddcd5dccb12a6480$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $c181d4ebdd1964e4$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $b2f1e54a980c2942$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $acw62.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $1En50.default)(props, $42eb6aad476e9cd0$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $acw62.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $f295447d0f5fb45a$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $acw62.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $e76849ceef979e2a$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $acw62.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $42eb6aad476e9cd0$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $ca8148ec12768bbe$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $acw62.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $acw62.useRef)();
            const lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $acw62.useRef)();
            const renderIsScheduled = (0, $acw62.useRef)(false);
            const isProcessingDispatch = (0, $acw62.useRef)(false);
            const isMounted = (0, $acw62.useRef)(false);
            const latestSubscriptionCallbackError = (0, $acw62.useRef)();
            (0, $8f419e08aecb0795$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $acw62.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $acw62.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $42eb6aad476e9cd0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $42eb6aad476e9cd0$var$useIsomorphicLayoutEffectWithArgs($42eb6aad476e9cd0$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $42eb6aad476e9cd0$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $8f419e08aecb0795$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $acw62.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $acw62.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $42eb6aad476e9cd0$export$2e2bcd8739ae039 = $42eb6aad476e9cd0$var$connect;



var $acw62 = parcelRequire("acw62");



function $e7b35c603673dee1$var$Provider({ store: store, context: context, children: children, serverState: serverState }) {
    const contextValue = (0, $acw62.useMemo)(()=>{
        const subscription = (0, $ca8148ec12768bbe$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, $acw62.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $8f419e08aecb0795$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $e7b35c603673dee1$export$2e2bcd8739ae039 = $e7b35c603673dee1$var$Provider;






var $acw62 = parcelRequire("acw62");


function $7a3e869eac64a5fd$export$671dba69185d0304(context = (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00) ? (0, $c880d57f8c47009a$export$c1275ca9a6fd3ec5) : ()=>(0, $acw62.useContext)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $7a3e869eac64a5fd$export$6ccbb43953eebf8 = /*#__PURE__*/ $7a3e869eac64a5fd$export$671dba69185d0304();


function $b95723b00aff28c4$export$bc9b55530897c558(context = (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $e8505e67f6dd14ea$export$cc80c08dc91f1c00) ? (0, $7a3e869eac64a5fd$export$6ccbb43953eebf8) : (0, $7a3e869eac64a5fd$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $b95723b00aff28c4$export$8ad76b76a4c905f8 = /*#__PURE__*/ $b95723b00aff28c4$export$bc9b55530897c558();









(0, $2a3acbb4cad78826$export$e2e6e3f3f3b782e3)((0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector));
(0, $42eb6aad476e9cd0$export$36d45daa6a4925b8)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $cf080a8910d18aed$export$4b9874722d0da7bc)((0, $1u0KT.unstable_batchedUpdates));



var $acw62 = parcelRequire("acw62");
function $d29f5b3d0d51225a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $d29f5b3d0d51225a$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $d29f5b3d0d51225a$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $d29f5b3d0d51225a$export$33752cf3ee811995(callback, inputs) {
    return $d29f5b3d0d51225a$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $d29f5b3d0d51225a$export$1538c33de8887b59 = $d29f5b3d0d51225a$export$b6feb8998cd9b342;
var $d29f5b3d0d51225a$export$35808ee640e87ca7 = $d29f5b3d0d51225a$export$33752cf3ee811995;


var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$var$invariant(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    throw new Error($85f606e562c81b96$var$prefix + ": " + (message || ''));
}
var $85f606e562c81b96$export$2e2bcd8739ae039 = $85f606e562c81b96$var$invariant;


var $0f2a76a440eafaaa$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $0f2a76a440eafaaa$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $0f2a76a440eafaaa$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $0f2a76a440eafaaa$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $0f2a76a440eafaaa$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $0f2a76a440eafaaa$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$padding;
    var marginBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $0f2a76a440eafaaa$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $0f2a76a440eafaaa$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return result;
};
var $0f2a76a440eafaaa$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $0f2a76a440eafaaa$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $0f2a76a440eafaaa$var$shift(borderBox, change);
    return $0f2a76a440eafaaa$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $0f2a76a440eafaaa$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $0f2a76a440eafaaa$var$getWindowScroll();
    return $0f2a76a440eafaaa$export$cc800923e997bb8(original, scroll);
};
var $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $0f2a76a440eafaaa$var$parse(styles.marginTop),
        right: $0f2a76a440eafaaa$var$parse(styles.marginRight),
        bottom: $0f2a76a440eafaaa$var$parse(styles.marginBottom),
        left: $0f2a76a440eafaaa$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $0f2a76a440eafaaa$var$parse(styles.paddingTop),
        right: $0f2a76a440eafaaa$var$parse(styles.paddingRight),
        bottom: $0f2a76a440eafaaa$var$parse(styles.paddingBottom),
        left: $0f2a76a440eafaaa$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $0f2a76a440eafaaa$var$parse(styles.borderTopWidth),
        right: $0f2a76a440eafaaa$var$parse(styles.borderRightWidth),
        bottom: $0f2a76a440eafaaa$var$parse(styles.borderBottomWidth),
        left: $0f2a76a440eafaaa$var$parse(styles.borderLeftWidth)
    };
    return $0f2a76a440eafaaa$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $0f2a76a440eafaaa$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $8b216712f075a158$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $8b216712f075a158$var$isEqual(first, second) {
    if (first === second) return true;
    if ($8b216712f075a158$var$safeIsNaN(first) && $8b216712f075a158$var$safeIsNaN(second)) return true;
    return false;
}
function $8b216712f075a158$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$8b216712f075a158$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $8b216712f075a158$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $8b216712f075a158$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


var $8f52a5054f09a665$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8f52a5054f09a665$export$2e2bcd8739ae039 = $8f52a5054f09a665$var$rafSchd;



var $8nd05 = parcelRequire("8nd05");
const $a63adcedbbdafe19$var$isProduction$1 = true;
const $a63adcedbbdafe19$var$spacesAndTabs = /[ \t]{2,}/g;
const $a63adcedbbdafe19$var$lineStartWithSpaces = /^[ \t]*/gm;
const $a63adcedbbdafe19$var$clean$2 = (value)=>value.replace($a63adcedbbdafe19$var$spacesAndTabs, ' ').replace($a63adcedbbdafe19$var$lineStartWithSpaces, '').trim();
const $a63adcedbbdafe19$var$getDevMessage = (message)=>$a63adcedbbdafe19$var$clean$2(`
  %c@hello-pangea/dnd

  %c${$a63adcedbbdafe19$var$clean$2(message)}

  %c\u{1F477}\u{200D} This is a development only message. It will be removed in production builds.
`);
const $a63adcedbbdafe19$var$getFormattedMessage = (message)=>[
        $a63adcedbbdafe19$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
const $a63adcedbbdafe19$var$isDisabledFlag = '__@hello-pangea/dnd-disable-dev-warnings';
function $a63adcedbbdafe19$var$log(type, message) {
    if ($a63adcedbbdafe19$var$isProduction$1) return;
    if (typeof window !== 'undefined' && window[$a63adcedbbdafe19$var$isDisabledFlag]) return;
    console[type](...$a63adcedbbdafe19$var$getFormattedMessage(message));
}
const $a63adcedbbdafe19$var$warning = $a63adcedbbdafe19$var$log.bind(null, 'warn');
const $a63adcedbbdafe19$var$error = $a63adcedbbdafe19$var$log.bind(null, 'error');
function $a63adcedbbdafe19$var$noop$2() {}
function $a63adcedbbdafe19$var$getOptions(shared, fromBinding) {
    return {
        ...shared,
        ...fromBinding
    };
}
function $a63adcedbbdafe19$var$bindEvents(el, bindings, sharedOptions) {
    const unbindings = bindings.map((binding)=>{
        const options = $a63adcedbbdafe19$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach((unbind)=>{
            unbind();
        });
    };
}
const $a63adcedbbdafe19$var$isProduction = true;
const $a63adcedbbdafe19$var$prefix$1 = 'Invariant failed';
class $a63adcedbbdafe19$var$RbdInvariant extends Error {
}
$a63adcedbbdafe19$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $a63adcedbbdafe19$var$invariant(condition, message) {
    if (condition) return;
    if ($a63adcedbbdafe19$var$isProduction) throw new $a63adcedbbdafe19$var$RbdInvariant($a63adcedbbdafe19$var$prefix$1);
    else throw new $a63adcedbbdafe19$var$RbdInvariant(`${$a63adcedbbdafe19$var$prefix$1}: ${message || ''}`);
}
class $a63adcedbbdafe19$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super(...arguments);
        this.callbacks = null;
        this.unbind = $a63adcedbbdafe19$var$noop$2;
        this.onWindowError = (event)=>{
            const callbacks = this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            const err = event.error;
            if (err instanceof $a63adcedbbdafe19$var$RbdInvariant) event.preventDefault();
        };
        this.getCallbacks = ()=>{
            if (!this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return this.callbacks;
        };
        this.setCallbacks = (callbacks)=>{
            this.callbacks = callbacks;
        };
    }
    componentDidMount() {
        this.unbind = $a63adcedbbdafe19$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    }
    componentDidCatch(err) {
        if (err instanceof $a63adcedbbdafe19$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    }
    componentWillUnmount() {
        this.unbind();
    }
    render() {
        return this.props.children(this.setCallbacks);
    }
}
const $a63adcedbbdafe19$var$dragHandleUsageInstructions = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`;
const $a63adcedbbdafe19$var$position = (index)=>index + 1;
const $a63adcedbbdafe19$var$onDragStart = (start)=>`
  You have lifted an item in position ${$a63adcedbbdafe19$var$position(start.source.index)}
`;
const $a63adcedbbdafe19$var$withLocation = (source, destination)=>{
    const isInHomeList = source.droppableId === destination.droppableId;
    const startPosition = $a63adcedbbdafe19$var$position(source.index);
    const endPosition = $a63adcedbbdafe19$var$position(destination.index);
    if (isInHomeList) return `
      You have moved the item from position ${startPosition}
      to position ${endPosition}
    `;
    return `
    You have moved the item from position ${startPosition}
    in list ${source.droppableId}
    to list ${destination.droppableId}
    in position ${endPosition}
  `;
};
const $a63adcedbbdafe19$var$withCombine = (id, source, combine)=>{
    const inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return `
      The item ${id}
      has been combined with ${combine.draggableId}`;
    return `
      The item ${id}
      in list ${source.droppableId}
      has been combined with ${combine.draggableId}
      in list ${combine.droppableId}
    `;
};
const $a63adcedbbdafe19$var$onDragUpdate = (update)=>{
    const location = update.destination;
    if (location) return $a63adcedbbdafe19$var$withLocation(update.source, location);
    const combine = update.combine;
    if (combine) return $a63adcedbbdafe19$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
const $a63adcedbbdafe19$var$returnedToStart = (source)=>`
  The item has returned to its starting position
  of ${$a63adcedbbdafe19$var$position(source.index)}
`;
const $a63adcedbbdafe19$var$onDragEnd = (result)=>{
    if (result.reason === 'CANCEL') return `
      Movement cancelled.
      ${$a63adcedbbdafe19$var$returnedToStart(result.source)}
    `;
    const location = result.destination;
    const combine = result.combine;
    if (location) return `
      You have dropped the item.
      ${$a63adcedbbdafe19$var$withLocation(result.source, location)}
    `;
    if (combine) return `
      You have dropped the item.
      ${$a63adcedbbdafe19$var$withCombine(result.draggableId, result.source, combine)}
    `;
    return `
    The item has been dropped while not over a drop area.
    ${$a63adcedbbdafe19$var$returnedToStart(result.source)}
  `;
};
const $a63adcedbbdafe19$var$preset = {
    dragHandleUsageInstructions: $a63adcedbbdafe19$var$dragHandleUsageInstructions,
    onDragStart: $a63adcedbbdafe19$var$onDragStart,
    onDragUpdate: $a63adcedbbdafe19$var$onDragUpdate,
    onDragEnd: $a63adcedbbdafe19$var$onDragEnd
};
var $a63adcedbbdafe19$var$preset$1 = $a63adcedbbdafe19$var$preset;
const $a63adcedbbdafe19$var$origin = {
    x: 0,
    y: 0
};
const $a63adcedbbdafe19$var$add = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $a63adcedbbdafe19$var$subtract = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
const $a63adcedbbdafe19$var$isEqual$1 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $a63adcedbbdafe19$var$negate = (point)=>({
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    });
const $a63adcedbbdafe19$var$patch = function(line, value, otherValue) {
    if (otherValue === void 0) otherValue = 0;
    if (line === 'x') return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
const $a63adcedbbdafe19$var$distance = (point1, point2)=>Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
const $a63adcedbbdafe19$var$closest$1 = (target, points)=>Math.min(...points.map((point)=>$a63adcedbbdafe19$var$distance(target, point)));
const $a63adcedbbdafe19$var$apply = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
var $a63adcedbbdafe19$var$executeClip = (frame, subject)=>{
    const result = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
const $a63adcedbbdafe19$var$offsetByPosition = (spacing, point)=>({
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    });
const $a63adcedbbdafe19$var$getCorners = (spacing)=>[
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
const $a63adcedbbdafe19$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $a63adcedbbdafe19$var$scroll$1 = (target, frame)=>{
    if (!frame) return target;
    return $a63adcedbbdafe19$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
const $a63adcedbbdafe19$var$increase = (target, axis, withPlaceholder)=>{
    if (withPlaceholder && withPlaceholder.increasedBy) return {
        ...target,
        [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line]
    };
    return target;
};
const $a63adcedbbdafe19$var$clip = (target, frame)=>{
    if (frame && frame.shouldClipSubject) return $a63adcedbbdafe19$var$executeClip(frame.pageMarginBox, target);
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)(target);
};
var $a63adcedbbdafe19$var$getSubject = (_ref)=>{
    let { page: page, withPlaceholder: withPlaceholder, axis: axis, frame: frame } = _ref;
    const scrolled = $a63adcedbbdafe19$var$scroll$1(page.marginBox, frame);
    const increased = $a63adcedbbdafe19$var$increase(scrolled, axis, withPlaceholder);
    const clipped = $a63adcedbbdafe19$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $a63adcedbbdafe19$var$scrollDroppable = (droppable, newScroll)=>{
    !droppable.frame && $a63adcedbbdafe19$var$invariant(false);
    const scrollable = droppable.frame;
    const scrollDiff = $a63adcedbbdafe19$var$subtract(newScroll, scrollable.scroll.initial);
    const scrollDisplacement = $a63adcedbbdafe19$var$negate(scrollDiff);
    const frame = {
        ...scrollable,
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    };
    const subject = $a63adcedbbdafe19$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    const result = {
        ...droppable,
        frame: frame,
        subject: subject
    };
    return result;
};
const $a63adcedbbdafe19$var$toDroppableMap = (0, $8b216712f075a158$export$2e2bcd8739ae039)((droppables)=>droppables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $a63adcedbbdafe19$var$toDraggableMap = (0, $8b216712f075a158$export$2e2bcd8739ae039)((draggables)=>draggables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $a63adcedbbdafe19$var$toDroppableList = (0, $8b216712f075a158$export$2e2bcd8739ae039)((droppables)=>Object.values(droppables));
const $a63adcedbbdafe19$var$toDraggableList = (0, $8b216712f075a158$export$2e2bcd8739ae039)((draggables)=>Object.values(draggables));
var $a63adcedbbdafe19$var$getDraggablesInsideDroppable = (0, $8b216712f075a158$export$2e2bcd8739ae039)((droppableId, draggables)=>{
    const result = $a63adcedbbdafe19$var$toDraggableList(draggables).filter((draggable)=>droppableId === draggable.descriptor.droppableId).sort((a, b)=>a.descriptor.index - b.descriptor.index);
    return result;
});
function $a63adcedbbdafe19$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $a63adcedbbdafe19$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $a63adcedbbdafe19$var$removeDraggableFromList = (0, $8b216712f075a158$export$2e2bcd8739ae039)((remove, list)=>list.filter((item)=>item.descriptor.id !== remove.descriptor.id));
var $a63adcedbbdafe19$var$moveToNextCombine = (_ref)=>{
    let { isMovingForward: isMovingForward, draggable: draggable, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact } = _ref;
    if (!destination.isCombineEnabled) return null;
    const location = $a63adcedbbdafe19$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        const at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return {
            ...previousImpact,
            at: at
        };
    }
    const all = previousImpact.displaced.all;
    const closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    const withoutDraggable = $a63adcedbbdafe19$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        const last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    const indexOfClosest = withoutDraggable.findIndex((d)=>d.descriptor.id === closestId);
    !(indexOfClosest !== -1) && $a63adcedbbdafe19$var$invariant(false);
    const proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    const before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $a63adcedbbdafe19$var$isHomeOf = (draggable, destination)=>draggable.descriptor.droppableId === destination.descriptor.id;
const $a63adcedbbdafe19$var$noDisplacedBy = {
    point: $a63adcedbbdafe19$var$origin,
    value: 0
};
const $a63adcedbbdafe19$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
const $a63adcedbbdafe19$var$noImpact = {
    displaced: $a63adcedbbdafe19$var$emptyGroups,
    displacedBy: $a63adcedbbdafe19$var$noDisplacedBy,
    at: null
};
var $a63adcedbbdafe19$var$noImpact$1 = $a63adcedbbdafe19$var$noImpact;
var $a63adcedbbdafe19$var$isWithin = (lowerBound, upperBound)=>(value)=>lowerBound <= value && value <= upperBound;
var $a63adcedbbdafe19$var$isPartiallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $a63adcedbbdafe19$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $a63adcedbbdafe19$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        const isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        const isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        const isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        const isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        const isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        const isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        const isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $a63adcedbbdafe19$var$isTotallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $a63adcedbbdafe19$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $a63adcedbbdafe19$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
const $a63adcedbbdafe19$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
const $a63adcedbbdafe19$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $a63adcedbbdafe19$var$isTotallyVisibleThroughFrameOnAxis = (axis)=>(frame)=>{
        const isWithinVertical = $a63adcedbbdafe19$var$isWithin(frame.top, frame.bottom);
        const isWithinHorizontal = $a63adcedbbdafe19$var$isWithin(frame.left, frame.right);
        return (subject)=>{
            if (axis === $a63adcedbbdafe19$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
const $a63adcedbbdafe19$var$getDroppableDisplaced = (target, destination)=>{
    const displacement = destination.frame ? destination.frame.scroll.diff.displacement : $a63adcedbbdafe19$var$origin;
    return $a63adcedbbdafe19$var$offsetByPosition(target, displacement);
};
const $a63adcedbbdafe19$var$isVisibleInDroppable = (target, destination, isVisibleThroughFrameFn)=>{
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
const $a63adcedbbdafe19$var$isVisibleInViewport = (target, viewport, isVisibleThroughFrameFn)=>isVisibleThroughFrameFn(viewport)(target);
const $a63adcedbbdafe19$var$isVisible$1 = (_ref)=>{
    let { target: toBeDisplaced, destination: destination, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, isVisibleThroughFrameFn: isVisibleThroughFrameFn } = _ref;
    const displacedTarget = withDroppableDisplacement ? $a63adcedbbdafe19$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $a63adcedbbdafe19$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $a63adcedbbdafe19$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
const $a63adcedbbdafe19$var$isPartiallyVisible = (args)=>$a63adcedbbdafe19$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $a63adcedbbdafe19$var$isPartiallyVisibleThroughFrame
    });
const $a63adcedbbdafe19$var$isTotallyVisible = (args)=>$a63adcedbbdafe19$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $a63adcedbbdafe19$var$isTotallyVisibleThroughFrame
    });
const $a63adcedbbdafe19$var$isTotallyVisibleOnAxis = (args)=>$a63adcedbbdafe19$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $a63adcedbbdafe19$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    });
const $a63adcedbbdafe19$var$getShouldAnimate = (id, last, forceShouldAnimate)=>{
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    const { invisible: invisible, visible: visible } = last;
    if (invisible[id]) return false;
    const previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $a63adcedbbdafe19$var$getTarget(draggable, displacedBy) {
    const marginBox = draggable.page.marginBox;
    const expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)((0, $0f2a76a440eafaaa$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $a63adcedbbdafe19$var$getDisplacementGroups(_ref) {
    let { afterDragging: afterDragging, destination: destination, displacedBy: displacedBy, viewport: viewport, forceShouldAnimate: forceShouldAnimate, last: last } = _ref;
    return afterDragging.reduce(function process(groups, draggable) {
        const target = $a63adcedbbdafe19$var$getTarget(draggable, displacedBy);
        const id = draggable.descriptor.id;
        groups.all.push(id);
        const isVisible = $a63adcedbbdafe19$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        const shouldAnimate = $a63adcedbbdafe19$var$getShouldAnimate(id, last, forceShouldAnimate);
        const displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $a63adcedbbdafe19$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    const indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $a63adcedbbdafe19$var$goAtEnd(_ref) {
    let { insideDestination: insideDestination, inHomeList: inHomeList, displacedBy: displacedBy, destination: destination } = _ref;
    const newIndex = $a63adcedbbdafe19$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $a63adcedbbdafe19$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $a63adcedbbdafe19$var$calculateReorderImpact(_ref2) {
    let { draggable: draggable, insideDestination: insideDestination, destination: destination, viewport: viewport, displacedBy: displacedBy, last: last, index: index, forceShouldAnimate: forceShouldAnimate } = _ref2;
    const inHomeList = $a63adcedbbdafe19$var$isHomeOf(draggable, destination);
    if (index == null) return $a63adcedbbdafe19$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const match = insideDestination.find((item)=>item.descriptor.index === index);
    if (!match) return $a63adcedbbdafe19$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const withoutDragging = $a63adcedbbdafe19$var$removeDraggableFromList(draggable, insideDestination);
    const sliceFrom = insideDestination.indexOf(match);
    const impacted = withoutDragging.slice(sliceFrom);
    const displaced = $a63adcedbbdafe19$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $a63adcedbbdafe19$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $a63adcedbbdafe19$var$fromCombine = (_ref)=>{
    let { isMovingForward: isMovingForward, destination: destination, draggables: draggables, combine: combine, afterCritical: afterCritical } = _ref;
    if (!destination.isCombineEnabled) return null;
    const combineId = combine.draggableId;
    const combineWith = draggables[combineId];
    const combineWithIndex = combineWith.descriptor.index;
    const didCombineWithStartAfterCritical = $a63adcedbbdafe19$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $a63adcedbbdafe19$var$fromReorder = (_ref)=>{
    let { isMovingForward: isMovingForward, isInHomeList: isInHomeList, insideDestination: insideDestination, location: location } = _ref;
    if (!insideDestination.length) return null;
    const currentIndex = location.index;
    const proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    const firstIndex = insideDestination[0].descriptor.index;
    const lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    const upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $a63adcedbbdafe19$var$moveToNextIndex = (_ref)=>{
    let { isMovingForward: isMovingForward, isInHomeList: isInHomeList, draggable: draggable, draggables: draggables, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical } = _ref;
    const wasAt = previousImpact.at;
    !wasAt && $a63adcedbbdafe19$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        const newIndex = $a63adcedbbdafe19$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (newIndex == null) return null;
        return $a63adcedbbdafe19$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    const newIndex = $a63adcedbbdafe19$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $a63adcedbbdafe19$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $a63adcedbbdafe19$var$getCombinedItemDisplacement = (_ref)=>{
    let { displaced: displaced, afterCritical: afterCritical, combineWith: combineWith, displacedBy: displacedBy } = _ref;
    const isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($a63adcedbbdafe19$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $a63adcedbbdafe19$var$origin : $a63adcedbbdafe19$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $a63adcedbbdafe19$var$origin;
};
var $a63adcedbbdafe19$var$whenCombining = (_ref)=>{
    let { afterCritical: afterCritical, impact: impact, draggables: draggables } = _ref;
    const combine = $a63adcedbbdafe19$var$tryGetCombine(impact);
    !combine && $a63adcedbbdafe19$var$invariant(false);
    const combineWith = combine.draggableId;
    const center = draggables[combineWith].page.borderBox.center;
    const displaceBy = $a63adcedbbdafe19$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $a63adcedbbdafe19$var$add(center, displaceBy);
};
const $a63adcedbbdafe19$var$distanceFromStartToBorderBoxCenter = (axis, box)=>box.margin[axis.start] + box.borderBox[axis.size] / 2;
const $a63adcedbbdafe19$var$distanceFromEndToBorderBoxCenter = (axis, box)=>box.margin[axis.end] + box.borderBox[axis.size] / 2;
const $a63adcedbbdafe19$var$getCrossAxisBorderBoxCenter = (axis, target, isMoving)=>target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
const $a63adcedbbdafe19$var$goAfter = (_ref)=>{
    let { axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving } = _ref;
    return $a63adcedbbdafe19$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $a63adcedbbdafe19$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a63adcedbbdafe19$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
const $a63adcedbbdafe19$var$goBefore = (_ref2)=>{
    let { axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving } = _ref2;
    return $a63adcedbbdafe19$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $a63adcedbbdafe19$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $a63adcedbbdafe19$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
const $a63adcedbbdafe19$var$goIntoStart = (_ref3)=>{
    let { axis: axis, moveInto: moveInto, isMoving: isMoving } = _ref3;
    return $a63adcedbbdafe19$var$patch(axis.line, moveInto.contentBox[axis.start] + $a63adcedbbdafe19$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a63adcedbbdafe19$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $a63adcedbbdafe19$var$whenReordering = (_ref)=>{
    let { impact: impact, draggable: draggable, draggables: draggables, droppable: droppable, afterCritical: afterCritical } = _ref;
    const insideDestination = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const draggablePage = draggable.page;
    const axis = droppable.axis;
    if (!insideDestination.length) return $a63adcedbbdafe19$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    const { displaced: displaced, displacedBy: displacedBy } = impact;
    const closestAfter = displaced.all[0];
    if (closestAfter) {
        const closest = draggables[closestAfter];
        if ($a63adcedbbdafe19$var$didStartAfterCritical(closestAfter, afterCritical)) return $a63adcedbbdafe19$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        const withDisplacement = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $a63adcedbbdafe19$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    const last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($a63adcedbbdafe19$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        const page = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(last.page, $a63adcedbbdafe19$var$negate(afterCritical.displacedBy.point));
        return $a63adcedbbdafe19$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $a63adcedbbdafe19$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $a63adcedbbdafe19$var$withDroppableDisplacement = (droppable, point)=>{
    const frame = droppable.frame;
    if (!frame) return point;
    return $a63adcedbbdafe19$var$add(point, frame.scroll.diff.displacement);
};
const $a63adcedbbdafe19$var$getResultWithoutDroppableDisplacement = (_ref)=>{
    let { impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, afterCritical: afterCritical } = _ref;
    const original = draggable.page.borderBox.center;
    const at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $a63adcedbbdafe19$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a63adcedbbdafe19$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $a63adcedbbdafe19$var$getPageBorderBoxCenterFromImpact = (args)=>{
    const withoutDisplacement = $a63adcedbbdafe19$var$getResultWithoutDroppableDisplacement(args);
    const droppable = args.droppable;
    const withDisplacement = droppable ? $a63adcedbbdafe19$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $a63adcedbbdafe19$var$scrollViewport = (viewport, newScroll)=>{
    const diff = $a63adcedbbdafe19$var$subtract(newScroll, viewport.scroll.initial);
    const displacement = $a63adcedbbdafe19$var$negate(diff);
    const frame = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    const updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $a63adcedbbdafe19$var$getDraggables$1(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
function $a63adcedbbdafe19$var$tryGetVisible(id, groups) {
    for(let i = 0; i < groups.length; i++){
        const displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $a63adcedbbdafe19$var$speculativelyIncrease = (_ref)=>{
    let { impact: impact, viewport: viewport, destination: destination, draggables: draggables, maxScrollChange: maxScrollChange } = _ref;
    const scrolledViewport = $a63adcedbbdafe19$var$scrollViewport(viewport, $a63adcedbbdafe19$var$add(viewport.scroll.current, maxScrollChange));
    const scrolledDroppable = destination.frame ? $a63adcedbbdafe19$var$scrollDroppable(destination, $a63adcedbbdafe19$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    const last = impact.displaced;
    const withViewportScroll = $a63adcedbbdafe19$var$getDisplacementGroups({
        afterDragging: $a63adcedbbdafe19$var$getDraggables$1(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const withDroppableScroll = $a63adcedbbdafe19$var$getDisplacementGroups({
        afterDragging: $a63adcedbbdafe19$var$getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const invisible = {};
    const visible = {};
    const groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach((id)=>{
        const displacement = $a63adcedbbdafe19$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    const newImpact = {
        ...impact,
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    };
    return newImpact;
};
var $a63adcedbbdafe19$var$withViewportDisplacement = (viewport, point)=>$a63adcedbbdafe19$var$add(viewport.scroll.diff.displacement, point);
var $a63adcedbbdafe19$var$getClientFromPageBorderBoxCenter = (_ref)=>{
    let { pageBorderBoxCenter: pageBorderBoxCenter, draggable: draggable, viewport: viewport } = _ref;
    const withoutPageScrollChange = $a63adcedbbdafe19$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    const offset = $a63adcedbbdafe19$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $a63adcedbbdafe19$var$add(draggable.client.borderBox.center, offset);
};
var $a63adcedbbdafe19$var$isTotallyVisibleInNewLocation = (_ref)=>{
    let { draggable: draggable, destination: destination, newPageBorderBoxCenter: newPageBorderBoxCenter, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, onlyOnMainAxis: onlyOnMainAxis = false } = _ref;
    const changeNeeded = $a63adcedbbdafe19$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    const shifted = $a63adcedbbdafe19$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    const args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $a63adcedbbdafe19$var$isTotallyVisibleOnAxis(args) : $a63adcedbbdafe19$var$isTotallyVisible(args);
};
var $a63adcedbbdafe19$var$moveToNextPlace = (_ref)=>{
    let { isMovingForward: isMovingForward, draggable: draggable, destination: destination, draggables: draggables, previousImpact: previousImpact, viewport: viewport, previousPageBorderBoxCenter: previousPageBorderBoxCenter, previousClientSelection: previousClientSelection, afterCritical: afterCritical } = _ref;
    if (!destination.isEnabled) return null;
    const insideDestination = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const isInHomeList = $a63adcedbbdafe19$var$isHomeOf(draggable, destination);
    const impact = $a63adcedbbdafe19$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $a63adcedbbdafe19$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $a63adcedbbdafe19$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const isVisibleInNewLocation = $a63adcedbbdafe19$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        const clientSelection = $a63adcedbbdafe19$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    const distance = $a63adcedbbdafe19$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    const cautious = $a63adcedbbdafe19$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
const $a63adcedbbdafe19$var$getKnownActive = (droppable)=>{
    const rect = droppable.subject.active;
    !rect && $a63adcedbbdafe19$var$invariant(false);
    return rect;
};
var $a63adcedbbdafe19$var$getBestCrossAxisDroppable = (_ref)=>{
    let { isMovingForward: isMovingForward, pageBorderBoxCenter: pageBorderBoxCenter, source: source, droppables: droppables, viewport: viewport } = _ref;
    const active = source.subject.active;
    if (!active) return null;
    const axis = source.axis;
    const isBetweenSourceClipped = $a63adcedbbdafe19$var$isWithin(active[axis.start], active[axis.end]);
    const candidates = $a63adcedbbdafe19$var$toDroppableList(droppables).filter((droppable)=>droppable !== source).filter((droppable)=>droppable.isEnabled).filter((droppable)=>Boolean(droppable.subject.active)).filter((droppable)=>$a63adcedbbdafe19$var$isPartiallyVisibleThroughFrame(viewport.frame)($a63adcedbbdafe19$var$getKnownActive(droppable))).filter((droppable)=>{
        const activeOfTarget = $a63adcedbbdafe19$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter((droppable)=>{
        const activeOfTarget = $a63adcedbbdafe19$var$getKnownActive(droppable);
        const isBetweenDestinationClipped = $a63adcedbbdafe19$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort((a, b)=>{
        const first = $a63adcedbbdafe19$var$getKnownActive(a)[axis.crossAxisStart];
        const second = $a63adcedbbdafe19$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter((droppable, index, array)=>$a63adcedbbdafe19$var$getKnownActive(droppable)[axis.crossAxisStart] === $a63adcedbbdafe19$var$getKnownActive(array[0])[axis.crossAxisStart]);
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const contains = candidates.filter((droppable)=>{
        const isWithinDroppable = $a63adcedbbdafe19$var$isWithin($a63adcedbbdafe19$var$getKnownActive(droppable)[axis.start], $a63adcedbbdafe19$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort((a, b)=>$a63adcedbbdafe19$var$getKnownActive(a)[axis.start] - $a63adcedbbdafe19$var$getKnownActive(b)[axis.start])[0];
    return candidates.sort((a, b)=>{
        const first = $a63adcedbbdafe19$var$closest$1(pageBorderBoxCenter, $a63adcedbbdafe19$var$getCorners($a63adcedbbdafe19$var$getKnownActive(a)));
        const second = $a63adcedbbdafe19$var$closest$1(pageBorderBoxCenter, $a63adcedbbdafe19$var$getCorners($a63adcedbbdafe19$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $a63adcedbbdafe19$var$getKnownActive(a)[axis.start] - $a63adcedbbdafe19$var$getKnownActive(b)[axis.start];
    })[0];
};
const $a63adcedbbdafe19$var$getCurrentPageBorderBoxCenter = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox.center;
    return $a63adcedbbdafe19$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a63adcedbbdafe19$var$subtract(original, afterCritical.displacedBy.point) : original;
};
const $a63adcedbbdafe19$var$getCurrentPageBorderBox = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox;
    return $a63adcedbbdafe19$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a63adcedbbdafe19$var$offsetByPosition(original, $a63adcedbbdafe19$var$negate(afterCritical.displacedBy.point)) : original;
};
var $a63adcedbbdafe19$var$getClosestDraggable = (_ref)=>{
    let { pageBorderBoxCenter: pageBorderBoxCenter, viewport: viewport, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical } = _ref;
    const sorted = insideDestination.filter((draggable)=>$a63adcedbbdafe19$var$isTotallyVisible({
            target: $a63adcedbbdafe19$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        })).sort((a, b)=>{
        const distanceToA = $a63adcedbbdafe19$var$distance(pageBorderBoxCenter, $a63adcedbbdafe19$var$withDroppableDisplacement(destination, $a63adcedbbdafe19$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        const distanceToB = $a63adcedbbdafe19$var$distance(pageBorderBoxCenter, $a63adcedbbdafe19$var$withDroppableDisplacement(destination, $a63adcedbbdafe19$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $a63adcedbbdafe19$var$getDisplacedBy = (0, $8b216712f075a158$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    const displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $a63adcedbbdafe19$var$patch(axis.line, displacement)
    };
});
const $a63adcedbbdafe19$var$getRequiredGrowthForPlaceholder = (droppable, placeholderSize, draggables)=>{
    const axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $a63adcedbbdafe19$var$patch(axis.line, placeholderSize[axis.line]);
    const availableSpace = droppable.subject.page.contentBox[axis.size];
    const insideDroppable = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const spaceUsed = insideDroppable.reduce((sum, dimension)=>sum + dimension.client.marginBox[axis.size], 0);
    const requiredSpace = spaceUsed + placeholderSize[axis.line];
    const needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $a63adcedbbdafe19$var$patch(axis.line, needsToGrowBy);
};
const $a63adcedbbdafe19$var$withMaxScroll = (frame, max)=>({
        ...frame,
        scroll: {
            ...frame.scroll,
            max: max
        }
    });
const $a63adcedbbdafe19$var$addPlaceholder = (droppable, draggable, draggables)=>{
    const frame = droppable.frame;
    !!$a63adcedbbdafe19$var$isHomeOf(draggable, droppable) && $a63adcedbbdafe19$var$invariant(false);
    !!droppable.subject.withPlaceholder && $a63adcedbbdafe19$var$invariant(false);
    const placeholderSize = $a63adcedbbdafe19$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    const requiredGrowth = $a63adcedbbdafe19$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    const added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        const subject = $a63adcedbbdafe19$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const maxScroll = requiredGrowth ? $a63adcedbbdafe19$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    const newFrame = $a63adcedbbdafe19$var$withMaxScroll(frame, maxScroll);
    const subject = $a63adcedbbdafe19$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
const $a63adcedbbdafe19$var$removePlaceholder = (droppable)=>{
    const added = droppable.subject.withPlaceholder;
    !added && $a63adcedbbdafe19$var$invariant(false);
    const frame = droppable.frame;
    if (!frame) {
        const subject = $a63adcedbbdafe19$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $a63adcedbbdafe19$var$invariant(false);
    const newFrame = $a63adcedbbdafe19$var$withMaxScroll(frame, oldMaxScroll);
    const subject = $a63adcedbbdafe19$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
var $a63adcedbbdafe19$var$moveToNewDroppable = (_ref)=>{
    let { previousPageBorderBoxCenter: previousPageBorderBoxCenter, moveRelativeTo: moveRelativeTo, insideDestination: insideDestination, draggable: draggable, draggables: draggables, destination: destination, viewport: viewport, afterCritical: afterCritical } = _ref;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        const proposed = {
            displaced: $a63adcedbbdafe19$var$emptyGroups,
            displacedBy: $a63adcedbbdafe19$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        const proposedPageBorderBoxCenter = $a63adcedbbdafe19$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        const withPlaceholder = $a63adcedbbdafe19$var$isHomeOf(draggable, destination) ? destination : $a63adcedbbdafe19$var$addPlaceholder(destination, draggable, draggables);
        const isVisibleInNewLocation = $a63adcedbbdafe19$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    const isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    const proposedIndex = (()=>{
        const relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    })();
    const displacedBy = $a63adcedbbdafe19$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $a63adcedbbdafe19$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $a63adcedbbdafe19$var$emptyGroups,
        index: proposedIndex
    });
};
var $a63adcedbbdafe19$var$moveCrossAxis = (_ref)=>{
    let { isMovingForward: isMovingForward, previousPageBorderBoxCenter: previousPageBorderBoxCenter, draggable: draggable, isOver: isOver, draggables: draggables, droppables: droppables, viewport: viewport, afterCritical: afterCritical } = _ref;
    const destination = $a63adcedbbdafe19$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    const insideDestination = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const moveRelativeTo = $a63adcedbbdafe19$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    const impact = $a63adcedbbdafe19$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $a63adcedbbdafe19$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const clientSelection = $a63adcedbbdafe19$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $a63adcedbbdafe19$var$whatIsDraggedOver = (impact)=>{
    const at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
const $a63adcedbbdafe19$var$getDroppableOver$1 = (impact, droppables)=>{
    const id = $a63adcedbbdafe19$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $a63adcedbbdafe19$var$moveInDirection = (_ref)=>{
    let { state: state, type: type } = _ref;
    const isActuallyOver = $a63adcedbbdafe19$var$getDroppableOver$1(state.impact, state.dimensions.droppables);
    const isMainAxisMovementAllowed = Boolean(isActuallyOver);
    const home = state.dimensions.droppables[state.critical.droppable.id];
    const isOver = isActuallyOver || home;
    const direction = isOver.axis.direction;
    const isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    const isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    const { draggables: draggables, droppables: droppables } = state.dimensions;
    return isMovingOnMainAxis ? $a63adcedbbdafe19$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $a63adcedbbdafe19$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $a63adcedbbdafe19$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $a63adcedbbdafe19$var$isPositionInFrame(frame) {
    const isWithinVertical = $a63adcedbbdafe19$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $a63adcedbbdafe19$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $a63adcedbbdafe19$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $a63adcedbbdafe19$var$getFurthestAway(_ref) {
    let { pageBorderBox: pageBorderBox, draggable: draggable, candidates: candidates } = _ref;
    const startCenter = draggable.page.borderBox.center;
    const sorted = candidates.map((candidate)=>{
        const axis = candidate.axis;
        const target = $a63adcedbbdafe19$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $a63adcedbbdafe19$var$distance(startCenter, target)
        };
    }).sort((a, b)=>b.distance - a.distance);
    return sorted[0] ? sorted[0].id : null;
}
function $a63adcedbbdafe19$var$getDroppableOver(_ref2) {
    let { pageBorderBox: pageBorderBox, draggable: draggable, droppables: droppables } = _ref2;
    const candidates = $a63adcedbbdafe19$var$toDroppableList(droppables).filter((item)=>{
        if (!item.isEnabled) return false;
        const active = item.subject.active;
        if (!active) return false;
        if (!$a63adcedbbdafe19$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($a63adcedbbdafe19$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        const axis = item.axis;
        const childCenter = active.center[axis.crossAxisLine];
        const crossAxisStart = pageBorderBox[axis.crossAxisStart];
        const crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        const isContained = $a63adcedbbdafe19$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        const isStartContained = isContained(crossAxisStart);
        const isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $a63adcedbbdafe19$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
const $a63adcedbbdafe19$var$offsetRectByPosition = (rect, point)=>(0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)($a63adcedbbdafe19$var$offsetByPosition(rect, point));
var $a63adcedbbdafe19$var$withDroppableScroll = (droppable, area)=>{
    const frame = droppable.frame;
    if (!frame) return area;
    return $a63adcedbbdafe19$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $a63adcedbbdafe19$var$getIsDisplaced(_ref) {
    let { displaced: displaced, id: id } = _ref;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $a63adcedbbdafe19$var$atIndex(_ref) {
    let { draggable: draggable, closest: closest, inHomeList: inHomeList } = _ref;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $a63adcedbbdafe19$var$getReorderImpact = (_ref2)=>{
    let { pageBorderBoxWithDroppableScroll: targetRect, draggable: draggable, destination: destination, insideDestination: insideDestination, last: last, viewport: viewport, afterCritical: afterCritical } = _ref2;
    const axis = destination.axis;
    const displacedBy = $a63adcedbbdafe19$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $a63adcedbbdafe19$var$removeDraggableFromList(draggable, insideDestination);
    const closest = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childCenter = child.page.borderBox.center[axis.line];
        const didStartAfterCritical$1 = $a63adcedbbdafe19$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $a63adcedbbdafe19$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    const newIndex = $a63adcedbbdafe19$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $a63adcedbbdafe19$var$isHomeOf(draggable, destination)
    });
    return $a63adcedbbdafe19$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
const $a63adcedbbdafe19$var$combineThresholdDivisor = 4;
var $a63adcedbbdafe19$var$getCombineImpact = (_ref)=>{
    let { draggable: draggable, pageBorderBoxWithDroppableScroll: targetRect, previousImpact: previousImpact, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical } = _ref;
    if (!destination.isCombineEnabled) return null;
    const axis = destination.axis;
    const displacedBy = $a63adcedbbdafe19$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $a63adcedbbdafe19$var$removeDraggableFromList(draggable, insideDestination);
    const combineWith = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childRect = child.page.borderBox;
        const childSize = childRect[axis.size];
        const threshold = childSize / $a63adcedbbdafe19$var$combineThresholdDivisor;
        const didStartAfterCritical$1 = $a63adcedbbdafe19$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $a63adcedbbdafe19$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    const impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $a63adcedbbdafe19$var$getDragImpact = (_ref)=>{
    let { pageOffset: pageOffset, draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical } = _ref;
    const pageBorderBox = $a63adcedbbdafe19$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    const destinationId = $a63adcedbbdafe19$var$getDroppableOver({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $a63adcedbbdafe19$var$noImpact$1;
    const destination = droppables[destinationId];
    const insideDestination = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const pageBorderBoxWithDroppableScroll = $a63adcedbbdafe19$var$withDroppableScroll(destination, pageBorderBox);
    return $a63adcedbbdafe19$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $a63adcedbbdafe19$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $a63adcedbbdafe19$var$patchDroppableMap = (droppables, updated)=>({
        ...droppables,
        [updated.descriptor.id]: updated
    });
const $a63adcedbbdafe19$var$clearUnusedPlaceholder = (_ref)=>{
    let { previousImpact: previousImpact, impact: impact, droppables: droppables } = _ref;
    const last = $a63adcedbbdafe19$var$whatIsDraggedOver(previousImpact);
    const now = $a63adcedbbdafe19$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    const lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    const updated = $a63adcedbbdafe19$var$removePlaceholder(lastDroppable);
    return $a63adcedbbdafe19$var$patchDroppableMap(droppables, updated);
};
var $a63adcedbbdafe19$var$recomputePlaceholders = (_ref2)=>{
    let { draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, impact: impact } = _ref2;
    const cleaned = $a63adcedbbdafe19$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    const isOver = $a63adcedbbdafe19$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    const droppable = droppables[isOver];
    if ($a63adcedbbdafe19$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    const patched = $a63adcedbbdafe19$var$addPlaceholder(droppable, draggable, draggables);
    return $a63adcedbbdafe19$var$patchDroppableMap(cleaned, patched);
};
var $a63adcedbbdafe19$var$update = (_ref)=>{
    let { state: state, clientSelection: forcedClientSelection, dimensions: forcedDimensions, viewport: forcedViewport, impact: forcedImpact, scrollJumpRequest: scrollJumpRequest } = _ref;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const clientSelection = forcedClientSelection || state.current.client.selection;
    const offset = $a63adcedbbdafe19$var$subtract(clientSelection, state.initial.client.selection);
    const client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $a63adcedbbdafe19$var$add(state.initial.client.borderBoxCenter, offset)
    };
    const page = {
        selection: $a63adcedbbdafe19$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $a63adcedbbdafe19$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $a63adcedbbdafe19$var$add(client.offset, viewport.scroll.diff.value)
    };
    const current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return {
        ...state,
        dimensions: dimensions,
        viewport: viewport,
        current: current
    };
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const newImpact = forcedImpact || $a63adcedbbdafe19$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    const withUpdatedPlaceholders = $a63adcedbbdafe19$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    const result = {
        ...state,
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    };
    return result;
};
function $a63adcedbbdafe19$var$getDraggables(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
var $a63adcedbbdafe19$var$recompute = (_ref)=>{
    let { impact: impact, viewport: viewport, draggables: draggables, destination: destination, forceShouldAnimate: forceShouldAnimate } = _ref;
    const last = impact.displaced;
    const afterDragging = $a63adcedbbdafe19$var$getDraggables(last.all, draggables);
    const displaced = $a63adcedbbdafe19$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return {
        ...impact,
        displaced: displaced
    };
};
var $a63adcedbbdafe19$var$getClientBorderBoxCenter = (_ref)=>{
    let { impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, viewport: viewport, afterCritical: afterCritical } = _ref;
    const pageBorderBoxCenter = $a63adcedbbdafe19$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a63adcedbbdafe19$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $a63adcedbbdafe19$var$refreshSnap = (_ref)=>{
    let { state: state, dimensions: forcedDimensions, viewport: forcedViewport } = _ref;
    !(state.movementMode === 'SNAP') && $a63adcedbbdafe19$var$invariant(false);
    const needsVisibilityCheck = state.impact;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const { draggables: draggables, droppables: droppables } = dimensions;
    const draggable = draggables[state.critical.draggable.id];
    const isOver = $a63adcedbbdafe19$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $a63adcedbbdafe19$var$invariant(false);
    const destination = droppables[isOver];
    const impact = $a63adcedbbdafe19$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    const clientSelection = $a63adcedbbdafe19$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $a63adcedbbdafe19$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $a63adcedbbdafe19$var$getHomeLocation = (descriptor)=>({
        index: descriptor.index,
        droppableId: descriptor.droppableId
    });
var $a63adcedbbdafe19$var$getLiftEffect = (_ref)=>{
    let { draggable: draggable, home: home, draggables: draggables, viewport: viewport } = _ref;
    const displacedBy = $a63adcedbbdafe19$var$getDisplacedBy(home.axis, draggable.displaceBy);
    const insideHome = $a63adcedbbdafe19$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    const rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $a63adcedbbdafe19$var$invariant(false);
    const afterDragging = insideHome.slice(rawIndex + 1);
    const effected = afterDragging.reduce((previous, item)=>{
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    const afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    const displaced = $a63adcedbbdafe19$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    const impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $a63adcedbbdafe19$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $a63adcedbbdafe19$var$patchDimensionMap = (dimensions, updated)=>({
        draggables: dimensions.draggables,
        droppables: $a63adcedbbdafe19$var$patchDroppableMap(dimensions.droppables, updated)
    });
const $a63adcedbbdafe19$var$start = (key)=>{};
const $a63adcedbbdafe19$var$finish = (key)=>{};
var $a63adcedbbdafe19$var$offsetDraggable = (_ref)=>{
    let { draggable: draggable, offset: offset$1, initialWindowScroll: initialWindowScroll } = _ref;
    const client = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(draggable.client, offset$1);
    const page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    const moved = {
        ...draggable,
        placeholder: {
            ...draggable.placeholder,
            client: client
        },
        client: client,
        page: page
    };
    return moved;
};
var $a63adcedbbdafe19$var$getFrame = (droppable)=>{
    const frame = droppable.frame;
    !frame && $a63adcedbbdafe19$var$invariant(false);
    return frame;
};
var $a63adcedbbdafe19$var$adjustAdditionsForScrollChanges = (_ref)=>{
    let { additions: additions, updatedDroppables: updatedDroppables, viewport: viewport } = _ref;
    const windowScrollChange = viewport.scroll.diff.value;
    return additions.map((draggable)=>{
        const droppableId = draggable.descriptor.droppableId;
        const modified = updatedDroppables[droppableId];
        const frame = $a63adcedbbdafe19$var$getFrame(modified);
        const droppableScrollChange = frame.scroll.diff.value;
        const totalChange = $a63adcedbbdafe19$var$add(windowScrollChange, droppableScrollChange);
        const moved = $a63adcedbbdafe19$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
const $a63adcedbbdafe19$var$timingsKey = 'Processing dynamic changes';
var $a63adcedbbdafe19$var$publishWhileDraggingInVirtual = (_ref)=>{
    let { state: state, published: published } = _ref;
    $a63adcedbbdafe19$var$start($a63adcedbbdafe19$var$timingsKey);
    const withScrollChange = published.modified.map((update)=>{
        const existing = state.dimensions.droppables[update.droppableId];
        const scrolled = $a63adcedbbdafe19$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    const droppables = {
        ...state.dimensions.droppables,
        ...$a63adcedbbdafe19$var$toDroppableMap(withScrollChange)
    };
    const updatedAdditions = $a63adcedbbdafe19$var$toDraggableMap($a63adcedbbdafe19$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    const draggables = {
        ...state.dimensions.draggables,
        ...updatedAdditions
    };
    published.removals.forEach((id)=>{
        delete draggables[id];
    });
    const dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    const wasOverId = $a63adcedbbdafe19$var$whatIsDraggedOver(state.impact);
    const wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const home = dimensions.droppables[state.critical.droppable.id];
    const { impact: onLiftImpact, afterCritical: afterCritical } = $a63adcedbbdafe19$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    });
    const previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    const impact = $a63adcedbbdafe19$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $a63adcedbbdafe19$var$finish($a63adcedbbdafe19$var$timingsKey);
    const draggingState = {
        ...state,
        phase: 'DRAGGING',
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    };
    if (state.phase === 'COLLECTING') return draggingState;
    const dropPending = {
        ...draggingState,
        phase: 'DROP_PENDING',
        reason: state.reason,
        isWaiting: false
    };
    return dropPending;
};
const $a63adcedbbdafe19$var$isSnapping = (state)=>state.movementMode === 'SNAP';
const $a63adcedbbdafe19$var$postDroppableChange = (state, updated, isEnabledChanging)=>{
    const dimensions = $a63adcedbbdafe19$var$patchDimensionMap(state.dimensions, updated);
    if (!$a63adcedbbdafe19$var$isSnapping(state) || isEnabledChanging) return $a63adcedbbdafe19$var$update({
        state: state,
        dimensions: dimensions
    });
    return $a63adcedbbdafe19$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $a63adcedbbdafe19$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return {
        ...state,
        scrollJumpRequest: null
    };
    return state;
}
const $a63adcedbbdafe19$var$idle$2 = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $a63adcedbbdafe19$var$reducer = function(state, action) {
    if (state === void 0) state = $a63adcedbbdafe19$var$idle$2;
    if (action.type === 'FLUSH') return {
        ...$a63adcedbbdafe19$var$idle$2,
        shouldFlush: true
    };
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
        const { critical: critical, clientSelection: clientSelection, viewport: viewport, dimensions: dimensions, movementMode: movementMode } = action.payload;
        const draggable = dimensions.draggables[critical.draggable.id];
        const home = dimensions.droppables[critical.droppable.id];
        const client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $a63adcedbbdafe19$var$origin
        };
        const initial = {
            client: client,
            page: {
                selection: $a63adcedbbdafe19$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $a63adcedbbdafe19$var$add(client.selection, viewport.scroll.initial),
                offset: $a63adcedbbdafe19$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        const isWindowScrollAllowed = $a63adcedbbdafe19$var$toDroppableList(dimensions.droppables).every((item)=>!item.isFixedOnPage);
        const { impact: impact, afterCritical: afterCritical } = $a63adcedbbdafe19$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        });
        const result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $a63adcedbbdafe19$var$invariant(false);
        const result = {
            ...state,
            phase: 'COLLECTING'
        };
        return result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $a63adcedbbdafe19$var$invariant(false);
        return $a63adcedbbdafe19$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a63adcedbbdafe19$var$isMovementAllowed(state) && $a63adcedbbdafe19$var$invariant(false);
        const { client: clientSelection } = action.payload;
        if ($a63adcedbbdafe19$var$isEqual$1(clientSelection, state.current.client.selection)) return state;
        return $a63adcedbbdafe19$var$update({
            state: state,
            clientSelection: clientSelection,
            impact: $a63adcedbbdafe19$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $a63adcedbbdafe19$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $a63adcedbbdafe19$var$removeScrollJumpRequest(state);
        !$a63adcedbbdafe19$var$isMovementAllowed(state) && $a63adcedbbdafe19$var$invariant(false);
        const { id: id, newScroll: newScroll } = action.payload;
        const target = state.dimensions.droppables[id];
        if (!target) return state;
        const scrolled = $a63adcedbbdafe19$var$scrollDroppable(target, newScroll);
        return $a63adcedbbdafe19$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a63adcedbbdafe19$var$isMovementAllowed(state) && $a63adcedbbdafe19$var$invariant(false);
        const { id: id, isEnabled: isEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $a63adcedbbdafe19$var$invariant(false);
        !(target.isEnabled !== isEnabled) && $a63adcedbbdafe19$var$invariant(false);
        const updated = {
            ...target,
            isEnabled: isEnabled
        };
        return $a63adcedbbdafe19$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a63adcedbbdafe19$var$isMovementAllowed(state) && $a63adcedbbdafe19$var$invariant(false);
        const { id: id, isCombineEnabled: isCombineEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $a63adcedbbdafe19$var$invariant(false);
        !(target.isCombineEnabled !== isCombineEnabled) && $a63adcedbbdafe19$var$invariant(false);
        const updated = {
            ...target,
            isCombineEnabled: isCombineEnabled
        };
        return $a63adcedbbdafe19$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$a63adcedbbdafe19$var$isMovementAllowed(state) && $a63adcedbbdafe19$var$invariant(false);
        !state.isWindowScrollAllowed && $a63adcedbbdafe19$var$invariant(false);
        const newScroll = action.payload.newScroll;
        if ($a63adcedbbdafe19$var$isEqual$1(state.viewport.scroll.current, newScroll)) return $a63adcedbbdafe19$var$removeScrollJumpRequest(state);
        const viewport = $a63adcedbbdafe19$var$scrollViewport(state.viewport, newScroll);
        if ($a63adcedbbdafe19$var$isSnapping(state)) return $a63adcedbbdafe19$var$refreshSnap({
            state: state,
            viewport: viewport
        });
        return $a63adcedbbdafe19$var$update({
            state: state,
            viewport: viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$a63adcedbbdafe19$var$isMovementAllowed(state)) return state;
        const maxScroll = action.payload.maxScroll;
        if ($a63adcedbbdafe19$var$isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        const withMaxScroll = {
            ...state.viewport,
            scroll: {
                ...state.viewport.scroll,
                max: maxScroll
            }
        };
        return {
            ...state,
            viewport: withMaxScroll
        };
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $a63adcedbbdafe19$var$invariant(false);
        const result = $a63adcedbbdafe19$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!result) return state;
        return $a63adcedbbdafe19$var$update({
            state: state,
            impact: result.impact,
            clientSelection: result.clientSelection,
            scrollJumpRequest: result.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        const reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $a63adcedbbdafe19$var$invariant(false);
        const newState = {
            ...state,
            phase: 'DROP_PENDING',
            isWaiting: true,
            reason: reason
        };
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        const { completed: completed, dropDuration: dropDuration, newHomeClientOffset: newHomeClientOffset } = action.payload;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $a63adcedbbdafe19$var$invariant(false);
        const result = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result;
    }
    if (action.type === 'DROP_COMPLETE') {
        const { completed: completed } = action.payload;
        return {
            phase: 'IDLE',
            completed: completed,
            shouldFlush: false
        };
    }
    return state;
};
const $a63adcedbbdafe19$var$beforeInitialCapture = (args)=>({
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    });
const $a63adcedbbdafe19$var$lift$1 = (args)=>({
        type: 'LIFT',
        payload: args
    });
const $a63adcedbbdafe19$var$initialPublish = (args)=>({
        type: 'INITIAL_PUBLISH',
        payload: args
    });
const $a63adcedbbdafe19$var$publishWhileDragging = (args)=>({
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    });
const $a63adcedbbdafe19$var$collectionStarting = ()=>({
        type: 'COLLECTION_STARTING',
        payload: null
    });
const $a63adcedbbdafe19$var$updateDroppableScroll = (args)=>({
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    });
const $a63adcedbbdafe19$var$updateDroppableIsEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    });
const $a63adcedbbdafe19$var$updateDroppableIsCombineEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    });
const $a63adcedbbdafe19$var$move = (args)=>({
        type: 'MOVE',
        payload: args
    });
const $a63adcedbbdafe19$var$moveByWindowScroll = (args)=>({
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    });
const $a63adcedbbdafe19$var$updateViewportMaxScroll = (args)=>({
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    });
const $a63adcedbbdafe19$var$moveUp = ()=>({
        type: 'MOVE_UP',
        payload: null
    });
const $a63adcedbbdafe19$var$moveDown = ()=>({
        type: 'MOVE_DOWN',
        payload: null
    });
const $a63adcedbbdafe19$var$moveRight = ()=>({
        type: 'MOVE_RIGHT',
        payload: null
    });
const $a63adcedbbdafe19$var$moveLeft = ()=>({
        type: 'MOVE_LEFT',
        payload: null
    });
const $a63adcedbbdafe19$var$flush = ()=>({
        type: 'FLUSH',
        payload: null
    });
const $a63adcedbbdafe19$var$animateDrop = (args)=>({
        type: 'DROP_ANIMATE',
        payload: args
    });
const $a63adcedbbdafe19$var$completeDrop = (args)=>({
        type: 'DROP_COMPLETE',
        payload: args
    });
const $a63adcedbbdafe19$var$drop$1 = (args)=>({
        type: 'DROP',
        payload: args
    });
const $a63adcedbbdafe19$var$dropPending = (args)=>({
        type: 'DROP_PENDING',
        payload: args
    });
const $a63adcedbbdafe19$var$dropAnimationFinished = ()=>({
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    });
function $a63adcedbbdafe19$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    const indexes = insideDestination.map((d)=>d.descriptor.index);
    const errors = {};
    for(let i = 1; i < indexes.length; i++){
        const current = indexes[i];
        const previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    const formatted = indexes.map((index)=>{
        const hasError = Boolean(errors[index]);
        return hasError ? `[\u{1F525}${index}]` : `${index}`;
    }).join(', ');
}
function $a63adcedbbdafe19$var$validateDimensions(critical, dimensions) {}
var $a63adcedbbdafe19$var$lift = (marshal)=>(_ref)=>{
        let { getState: getState, dispatch: dispatch } = _ref;
        return (next)=>(action)=>{
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                const { id: id, clientSelection: clientSelection, movementMode: movementMode } = action.payload;
                const initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($a63adcedbbdafe19$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
                dispatch($a63adcedbbdafe19$var$flush());
                dispatch($a63adcedbbdafe19$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                const scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                const request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                const { critical: critical, dimensions: dimensions, viewport: viewport } = marshal.startPublishing(request);
                $a63adcedbbdafe19$var$validateDimensions(critical, dimensions);
                dispatch($a63adcedbbdafe19$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
    };
var $a63adcedbbdafe19$var$style = (marshal)=>()=>(next)=>(action)=>{
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
const $a63adcedbbdafe19$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
const $a63adcedbbdafe19$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
const $a63adcedbbdafe19$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
const $a63adcedbbdafe19$var$outOfTheWayTiming = `${$a63adcedbbdafe19$var$timings.outOfTheWay}s ${$a63adcedbbdafe19$var$curves.outOfTheWay}`;
const $a63adcedbbdafe19$var$transitions = {
    fluid: `opacity ${$a63adcedbbdafe19$var$outOfTheWayTiming}`,
    snap: `transform ${$a63adcedbbdafe19$var$outOfTheWayTiming}, opacity ${$a63adcedbbdafe19$var$outOfTheWayTiming}`,
    drop: (duration)=>{
        const timing = `${duration}s ${$a63adcedbbdafe19$var$curves.drop}`;
        return `transform ${timing}, opacity ${timing}`;
    },
    outOfTheWay: `transform ${$a63adcedbbdafe19$var$outOfTheWayTiming}`,
    placeholder: `height ${$a63adcedbbdafe19$var$outOfTheWayTiming}, width ${$a63adcedbbdafe19$var$outOfTheWayTiming}, margin ${$a63adcedbbdafe19$var$outOfTheWayTiming}`
};
const $a63adcedbbdafe19$var$moveTo = (offset)=>$a63adcedbbdafe19$var$isEqual$1(offset, $a63adcedbbdafe19$var$origin) ? undefined : `translate(${offset.x}px, ${offset.y}px)`;
const $a63adcedbbdafe19$var$transforms = {
    moveTo: $a63adcedbbdafe19$var$moveTo,
    drop: (offset, isCombining)=>{
        const translate = $a63adcedbbdafe19$var$moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return `${translate} scale(${$a63adcedbbdafe19$var$combine.scale.drop})`;
    }
};
const { minDropTime: $a63adcedbbdafe19$var$minDropTime, maxDropTime: $a63adcedbbdafe19$var$maxDropTime } = $a63adcedbbdafe19$var$timings;
const $a63adcedbbdafe19$var$dropTimeRange = $a63adcedbbdafe19$var$maxDropTime - $a63adcedbbdafe19$var$minDropTime;
const $a63adcedbbdafe19$var$maxDropTimeAtDistance = 1500;
const $a63adcedbbdafe19$var$cancelDropModifier = 0.6;
var $a63adcedbbdafe19$var$getDropDuration = (_ref)=>{
    let { current: current, destination: destination, reason: reason } = _ref;
    const distance$1 = $a63adcedbbdafe19$var$distance(current, destination);
    if (distance$1 <= 0) return $a63adcedbbdafe19$var$minDropTime;
    if (distance$1 >= $a63adcedbbdafe19$var$maxDropTimeAtDistance) return $a63adcedbbdafe19$var$maxDropTime;
    const percentage = distance$1 / $a63adcedbbdafe19$var$maxDropTimeAtDistance;
    const duration = $a63adcedbbdafe19$var$minDropTime + $a63adcedbbdafe19$var$dropTimeRange * percentage;
    const withDuration = reason === 'CANCEL' ? duration * $a63adcedbbdafe19$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $a63adcedbbdafe19$var$getNewHomeClientOffset = (_ref)=>{
    let { impact: impact, draggable: draggable, dimensions: dimensions, viewport: viewport, afterCritical: afterCritical } = _ref;
    const { draggables: draggables, droppables: droppables } = dimensions;
    const droppableId = $a63adcedbbdafe19$var$whatIsDraggedOver(impact);
    const destination = droppableId ? droppables[droppableId] : null;
    const home = droppables[draggable.descriptor.droppableId];
    const newClientCenter = $a63adcedbbdafe19$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    const offset = $a63adcedbbdafe19$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $a63adcedbbdafe19$var$getDropImpact = (_ref)=>{
    let { draggables: draggables, reason: reason, lastImpact: lastImpact, home: home, viewport: viewport, onLiftImpact: onLiftImpact } = _ref;
    if (!lastImpact.at || reason !== 'DROP') {
        const recomputedHomeImpact = $a63adcedbbdafe19$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    const withoutMovement = {
        ...lastImpact,
        displaced: $a63adcedbbdafe19$var$emptyGroups
    };
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
const $a63adcedbbdafe19$var$dropMiddleware = (_ref)=>{
    let { getState: getState, dispatch: dispatch } = _ref;
    return (next)=>(action)=>{
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            const state = getState();
            const reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($a63adcedbbdafe19$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            const isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $a63adcedbbdafe19$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $a63adcedbbdafe19$var$invariant(false);
            const critical = state.critical;
            const dimensions = state.dimensions;
            const draggable = dimensions.draggables[state.critical.draggable.id];
            const { impact: impact, didDropInsideDroppable: didDropInsideDroppable } = $a63adcedbbdafe19$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            });
            const destination = didDropInsideDroppable ? $a63adcedbbdafe19$var$tryGetDestination(impact) : null;
            const combine = didDropInsideDroppable ? $a63adcedbbdafe19$var$tryGetCombine(impact) : null;
            const source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            const result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            const newHomeClientOffset = $a63adcedbbdafe19$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            const completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            const isAnimationRequired = !$a63adcedbbdafe19$var$isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($a63adcedbbdafe19$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            const dropDuration = $a63adcedbbdafe19$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            const args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($a63adcedbbdafe19$var$animateDrop(args));
        };
};
var $a63adcedbbdafe19$var$drop = $a63adcedbbdafe19$var$dropMiddleware;
var $a63adcedbbdafe19$var$getWindowScroll = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });
function $a63adcedbbdafe19$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: (event)=>{
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $a63adcedbbdafe19$var$getScrollListener(_ref) {
    let { onWindowScroll: onWindowScroll } = _ref;
    function updateScroll() {
        onWindowScroll($a63adcedbbdafe19$var$getWindowScroll());
    }
    const scheduled = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(updateScroll);
    const binding = $a63adcedbbdafe19$var$getWindowScrollBinding(scheduled);
    let unbind = $a63adcedbbdafe19$var$noop$2;
    function isActive() {
        return unbind !== $a63adcedbbdafe19$var$noop$2;
    }
    function start() {
        !!isActive() && $a63adcedbbdafe19$var$invariant(false);
        unbind = $a63adcedbbdafe19$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $a63adcedbbdafe19$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $a63adcedbbdafe19$var$noop$2;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
const $a63adcedbbdafe19$var$shouldEnd = (action)=>action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
const $a63adcedbbdafe19$var$scrollListener = (store)=>{
    const listener = $a63adcedbbdafe19$var$getScrollListener({
        onWindowScroll: (newScroll)=>{
            store.dispatch($a63adcedbbdafe19$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return (next)=>(action)=>{
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $a63adcedbbdafe19$var$shouldEnd(action)) listener.stop();
            next(action);
        };
};
var $a63adcedbbdafe19$var$scrollListener$1 = $a63adcedbbdafe19$var$scrollListener;
var $a63adcedbbdafe19$var$getExpiringAnnounce = (announce)=>{
    let wasCalled = false;
    let isExpired = false;
    const timeoutId = setTimeout(()=>{
        isExpired = true;
    });
    const result = (message)=>{
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = ()=>wasCalled;
    return result;
};
var $a63adcedbbdafe19$var$getAsyncMarshal = ()=>{
    const entries = [];
    const execute = (timerId)=>{
        const index = entries.findIndex((item)=>item.timerId === timerId);
        !(index !== -1) && $a63adcedbbdafe19$var$invariant(false);
        const [entry] = entries.splice(index, 1);
        entry.callback();
    };
    const add = (fn)=>{
        const timerId = setTimeout(()=>execute(timerId));
        const entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    const flush = ()=>{
        if (!entries.length) return;
        const shallow = [
            ...entries
        ];
        entries.length = 0;
        shallow.forEach((entry)=>{
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
const $a63adcedbbdafe19$var$areLocationsEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
const $a63adcedbbdafe19$var$isCombineEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
const $a63adcedbbdafe19$var$isCriticalEqual = (first, second)=>{
    if (first === second) return true;
    const isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    const isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
const $a63adcedbbdafe19$var$withTimings = (key, fn)=>{
    $a63adcedbbdafe19$var$start();
    fn();
    $a63adcedbbdafe19$var$finish();
};
const $a63adcedbbdafe19$var$getDragStart = (critical, mode)=>({
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    });
function $a63adcedbbdafe19$var$execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    const willExpire = $a63adcedbbdafe19$var$getExpiringAnnounce(announce);
    const provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var $a63adcedbbdafe19$var$getPublisher = (getResponders, announce)=>{
    const asyncMarshal = $a63adcedbbdafe19$var$getAsyncMarshal();
    let dragging = null;
    const beforeCapture = (draggableId, mode)=>{
        !!dragging && $a63adcedbbdafe19$var$invariant(false);
        $a63adcedbbdafe19$var$withTimings('onBeforeCapture', ()=>{
            const fn = getResponders().onBeforeCapture;
            if (fn) {
                const before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    const beforeStart = (critical, mode)=>{
        !!dragging && $a63adcedbbdafe19$var$invariant(false);
        $a63adcedbbdafe19$var$withTimings('onBeforeDragStart', ()=>{
            const fn = getResponders().onBeforeDragStart;
            if (fn) fn($a63adcedbbdafe19$var$getDragStart(critical, mode));
        });
    };
    const start = (critical, mode)=>{
        !!dragging && $a63adcedbbdafe19$var$invariant(false);
        const data = $a63adcedbbdafe19$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(()=>{
            $a63adcedbbdafe19$var$withTimings('onDragStart', ()=>$a63adcedbbdafe19$var$execute(getResponders().onDragStart, data, announce, $a63adcedbbdafe19$var$preset$1.onDragStart));
        });
    };
    const update = (critical, impact)=>{
        const location = $a63adcedbbdafe19$var$tryGetDestination(impact);
        const combine = $a63adcedbbdafe19$var$tryGetCombine(impact);
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        const hasCriticalChanged = !$a63adcedbbdafe19$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        const hasLocationChanged = !$a63adcedbbdafe19$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        const hasGroupingChanged = !$a63adcedbbdafe19$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        const data = {
            ...$a63adcedbbdafe19$var$getDragStart(critical, dragging.mode),
            combine: combine,
            destination: location
        };
        asyncMarshal.add(()=>{
            $a63adcedbbdafe19$var$withTimings('onDragUpdate', ()=>$a63adcedbbdafe19$var$execute(getResponders().onDragUpdate, data, announce, $a63adcedbbdafe19$var$preset$1.onDragUpdate));
        });
    };
    const flush = ()=>{
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        asyncMarshal.flush();
    };
    const drop = (result)=>{
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        dragging = null;
        $a63adcedbbdafe19$var$withTimings('onDragEnd', ()=>$a63adcedbbdafe19$var$execute(getResponders().onDragEnd, result, announce, $a63adcedbbdafe19$var$preset$1.onDragEnd));
    };
    const abort = ()=>{
        if (!dragging) return;
        const result = {
            ...$a63adcedbbdafe19$var$getDragStart(dragging.lastCritical, dragging.mode),
            combine: null,
            destination: null,
            reason: 'CANCEL'
        };
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $a63adcedbbdafe19$var$responders = (getResponders, announce)=>{
    const publisher = $a63adcedbbdafe19$var$getPublisher(getResponders, announce);
    return (store)=>(next)=>(action)=>{
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    const critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    const result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                const state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
};
const $a63adcedbbdafe19$var$dropAnimationFinishMiddleware = (store)=>(next)=>(action)=>{
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            const state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $a63adcedbbdafe19$var$invariant(false);
            store.dispatch($a63adcedbbdafe19$var$completeDrop({
                completed: state.completed
            }));
        };
var $a63adcedbbdafe19$var$dropAnimationFinish = $a63adcedbbdafe19$var$dropAnimationFinishMiddleware;
const $a63adcedbbdafe19$var$dropAnimationFlushOnScrollMiddleware = (store)=>{
    let unbind = null;
    let frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return (next)=>(action)=>{
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            const binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    const state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($a63adcedbbdafe19$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                unbind = $a63adcedbbdafe19$var$bindEvents(window, [
                    binding
                ]);
            });
        };
};
var $a63adcedbbdafe19$var$dropAnimationFlushOnScroll = $a63adcedbbdafe19$var$dropAnimationFlushOnScrollMiddleware;
var $a63adcedbbdafe19$var$dimensionMarshalStopper = (marshal)=>()=>(next)=>(action)=>{
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
var $a63adcedbbdafe19$var$focus = (marshal)=>{
    let isWatching = false;
    return ()=>(next)=>(action)=>{
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    const result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
};
const $a63adcedbbdafe19$var$shouldStop = (action)=>action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
var $a63adcedbbdafe19$var$autoScroll = (autoScroller)=>(store)=>(next)=>(action)=>{
                if ($a63adcedbbdafe19$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    const state = store.getState();
                    !(state.phase === 'DRAGGING') && $a63adcedbbdafe19$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
const $a63adcedbbdafe19$var$pendingDrop = (store)=>(next)=>(action)=>{
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            const postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($a63adcedbbdafe19$var$drop$1({
                reason: postActionState.reason
            }));
        };
var $a63adcedbbdafe19$var$pendingDrop$1 = $a63adcedbbdafe19$var$pendingDrop;
const $a63adcedbbdafe19$var$composeEnhancers = (0, $ad4393542232627c$export$f672e0b6f7222cd7);
var $a63adcedbbdafe19$var$createStore = (_ref)=>{
    let { dimensionMarshal: dimensionMarshal, focusMarshal: focusMarshal, styleMarshal: styleMarshal, getResponders: getResponders, announce: announce, autoScroller: autoScroller } = _ref;
    return (0, $ad4393542232627c$export$f51a9068ac82ea43)($a63adcedbbdafe19$var$reducer, $a63adcedbbdafe19$var$composeEnhancers((0, $ad4393542232627c$export$9ff26e0402cc7b7)($a63adcedbbdafe19$var$style(styleMarshal), $a63adcedbbdafe19$var$dimensionMarshalStopper(dimensionMarshal), $a63adcedbbdafe19$var$lift(dimensionMarshal), $a63adcedbbdafe19$var$drop, $a63adcedbbdafe19$var$dropAnimationFinish, $a63adcedbbdafe19$var$dropAnimationFlushOnScroll, $a63adcedbbdafe19$var$pendingDrop$1, $a63adcedbbdafe19$var$autoScroll(autoScroller), $a63adcedbbdafe19$var$scrollListener$1, $a63adcedbbdafe19$var$focus(focusMarshal), $a63adcedbbdafe19$var$responders(getResponders, announce))));
};
const $a63adcedbbdafe19$var$clean$1 = ()=>({
        additions: {},
        removals: {},
        modified: {}
    });
function $a63adcedbbdafe19$var$createPublisher(_ref) {
    let { registry: registry, callbacks: callbacks } = _ref;
    let staging = $a63adcedbbdafe19$var$clean$1();
    let frameId = null;
    const collect = ()=>{
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            $a63adcedbbdafe19$var$start();
            const { additions: additions, removals: removals, modified: modified } = staging;
            const added = Object.keys(additions).map((id)=>registry.draggable.getById(id).getDimension($a63adcedbbdafe19$var$origin)).sort((a, b)=>a.descriptor.index - b.descriptor.index);
            const updated = Object.keys(modified).map((id)=>{
                const entry = registry.droppable.getById(id);
                const scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            const result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $a63adcedbbdafe19$var$clean$1();
            $a63adcedbbdafe19$var$finish();
            callbacks.publish(result);
        });
    };
    const add = (entry)=>{
        const id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    const remove = (entry)=>{
        const descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    const stop = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $a63adcedbbdafe19$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $a63adcedbbdafe19$var$getMaxScroll = (_ref)=>{
    let { scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width } = _ref;
    const maxScroll = $a63adcedbbdafe19$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $a63adcedbbdafe19$var$getDocumentElement = ()=>{
    const doc = document.documentElement;
    !doc && $a63adcedbbdafe19$var$invariant(false);
    return doc;
};
var $a63adcedbbdafe19$var$getMaxWindowScroll = ()=>{
    const doc = $a63adcedbbdafe19$var$getDocumentElement();
    const maxScroll = $a63adcedbbdafe19$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $a63adcedbbdafe19$var$getViewport = ()=>{
    const scroll = $a63adcedbbdafe19$var$getWindowScroll();
    const maxScroll = $a63adcedbbdafe19$var$getMaxWindowScroll();
    const top = scroll.y;
    const left = scroll.x;
    const doc = $a63adcedbbdafe19$var$getDocumentElement();
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    const right = left + width;
    const bottom = top + height;
    const frame = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $a63adcedbbdafe19$var$origin,
                displacement: $a63adcedbbdafe19$var$origin
            }
        }
    };
    return viewport;
};
var $a63adcedbbdafe19$var$getInitialPublish = (_ref)=>{
    let { critical: critical, scrollOptions: scrollOptions, registry: registry } = _ref;
    $a63adcedbbdafe19$var$start();
    const viewport = $a63adcedbbdafe19$var$getViewport();
    const windowScroll = viewport.scroll.current;
    const home = critical.droppable;
    const droppables = registry.droppable.getAllByType(home.type).map((entry)=>entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions));
    const draggables = registry.draggable.getAllByType(critical.draggable.type).map((entry)=>entry.getDimension(windowScroll));
    const dimensions = {
        draggables: $a63adcedbbdafe19$var$toDraggableMap(draggables),
        droppables: $a63adcedbbdafe19$var$toDroppableMap(droppables)
    };
    $a63adcedbbdafe19$var$finish();
    const result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $a63adcedbbdafe19$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    const home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $a63adcedbbdafe19$var$createDimensionMarshal = (registry, callbacks)=>{
    let collection = null;
    const publisher = $a63adcedbbdafe19$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    const updateDroppableIsEnabled = (id, isEnabled)=>{
        !registry.droppable.exists(id) && $a63adcedbbdafe19$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    const updateDroppableIsCombineEnabled = (id, isCombineEnabled)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $a63adcedbbdafe19$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    const updateDroppableScroll = (id, newScroll)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $a63adcedbbdafe19$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    const scrollDroppable = (id, change)=>{
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    const stopPublishing = ()=>{
        if (!collection) return;
        publisher.stop();
        const home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach((entry)=>entry.callbacks.dragStopped());
        collection.unsubscribe();
        collection = null;
    };
    const subscriber = (event)=>{
        !collection && $a63adcedbbdafe19$var$invariant(false);
        const dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($a63adcedbbdafe19$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($a63adcedbbdafe19$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    const startPublishing = (request)=>{
        !!collection && $a63adcedbbdafe19$var$invariant(false);
        const entry = registry.draggable.getById(request.draggableId);
        const home = registry.droppable.getById(entry.descriptor.droppableId);
        const critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        const unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $a63adcedbbdafe19$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    const marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $a63adcedbbdafe19$var$canStartDrag = (state, id)=>{
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $a63adcedbbdafe19$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $a63adcedbbdafe19$var$getScrollableDroppables = (0, $8b216712f075a158$export$2e2bcd8739ae039)((droppables)=>$a63adcedbbdafe19$var$toDroppableList(droppables).filter((droppable)=>{
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    }));
const $a63adcedbbdafe19$var$getScrollableDroppableOver = (target, droppables)=>{
    const maybe = $a63adcedbbdafe19$var$getScrollableDroppables(droppables).find((droppable)=>{
        !droppable.frame && $a63adcedbbdafe19$var$invariant(false);
        return $a63adcedbbdafe19$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var $a63adcedbbdafe19$var$getBestScrollableDroppable = (_ref)=>{
    let { center: center, destination: destination, droppables: droppables } = _ref;
    if (destination) {
        const dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    const dimension = $a63adcedbbdafe19$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
const $a63adcedbbdafe19$var$defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: (percentage)=>percentage ** 2,
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var $a63adcedbbdafe19$var$getDistanceThresholds = function(container, axis, getAutoScrollerOptions) {
    if (getAutoScrollerOptions === void 0) getAutoScrollerOptions = ()=>$a63adcedbbdafe19$var$defaultAutoScrollerOptions;
    const autoScrollerOptions = getAutoScrollerOptions();
    const startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    const maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $a63adcedbbdafe19$var$getPercentage = (_ref)=>{
    let { startOfRange: startOfRange, endOfRange: endOfRange, current: current } = _ref;
    const range = endOfRange - startOfRange;
    if (range === 0) return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};
var $a63adcedbbdafe19$var$minScroll = 1;
var $a63adcedbbdafe19$var$getValueFromDistance = function(distanceToEdge, thresholds, getAutoScrollerOptions) {
    if (getAutoScrollerOptions === void 0) getAutoScrollerOptions = ()=>$a63adcedbbdafe19$var$defaultAutoScrollerOptions;
    const autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $a63adcedbbdafe19$var$minScroll;
    const percentageFromMaxScrollValueAt = $a63adcedbbdafe19$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $a63adcedbbdafe19$var$dampenValueByTime = (proposedScroll, dragStartTime, getAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    const stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    const startOfRange = dragStartTime;
    const endOfRange = stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return $a63adcedbbdafe19$var$minScroll;
    const betweenAccelerateAtAndStopAtPercentage = $a63adcedbbdafe19$var$getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $a63adcedbbdafe19$var$getValue = (_ref)=>{
    let { distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const scroll = $a63adcedbbdafe19$var$getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($a63adcedbbdafe19$var$dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), $a63adcedbbdafe19$var$minScroll);
};
var $a63adcedbbdafe19$var$getScrollOnAxis = (_ref)=>{
    let { container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const thresholds = $a63adcedbbdafe19$var$getDistanceThresholds(container, axis, getAutoScrollerOptions);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $a63adcedbbdafe19$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return -1 * $a63adcedbbdafe19$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
};
var $a63adcedbbdafe19$var$adjustForSizeLimits = (_ref)=>{
    let { container: container, subject: subject, proposedScroll: proposedScroll } = _ref;
    const isTooBigVertically = subject.height > container.height;
    const isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
const $a63adcedbbdafe19$var$clean = $a63adcedbbdafe19$var$apply((value)=>value === 0 ? 0 : value);
var $a63adcedbbdafe19$var$getScroll$1 = (_ref)=>{
    let { dragStartTime: dragStartTime, container: container, subject: subject, center: center, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    const y = $a63adcedbbdafe19$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a63adcedbbdafe19$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const x = $a63adcedbbdafe19$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a63adcedbbdafe19$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const required = $a63adcedbbdafe19$var$clean({
        x: x,
        y: y
    });
    if ($a63adcedbbdafe19$var$isEqual$1(required, $a63adcedbbdafe19$var$origin)) return null;
    const limited = $a63adcedbbdafe19$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $a63adcedbbdafe19$var$isEqual$1(limited, $a63adcedbbdafe19$var$origin) ? null : limited;
};
const $a63adcedbbdafe19$var$smallestSigned = $a63adcedbbdafe19$var$apply((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $a63adcedbbdafe19$var$getOverlap = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return (_ref)=>{
        let { current: current, max: max, change: change } = _ref;
        const targetScroll = $a63adcedbbdafe19$var$add(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($a63adcedbbdafe19$var$isEqual$1(overlap, $a63adcedbbdafe19$var$origin)) return null;
        return overlap;
    };
})();
const $a63adcedbbdafe19$var$canPartiallyScroll = (_ref2)=>{
    let { max: rawMax, current: current, change: change } = _ref2;
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    const smallestChange = $a63adcedbbdafe19$var$smallestSigned(change);
    const overlap = $a63adcedbbdafe19$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $a63adcedbbdafe19$var$canScrollWindow = (viewport, change)=>$a63adcedbbdafe19$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $a63adcedbbdafe19$var$getWindowOverlap = (viewport, change)=>{
    if (!$a63adcedbbdafe19$var$canScrollWindow(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $a63adcedbbdafe19$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
const $a63adcedbbdafe19$var$canScrollDroppable = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return false;
    return $a63adcedbbdafe19$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
const $a63adcedbbdafe19$var$getDroppableOverlap = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return null;
    if (!$a63adcedbbdafe19$var$canScrollDroppable(droppable, change)) return null;
    return $a63adcedbbdafe19$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $a63adcedbbdafe19$var$getWindowScrollChange = (_ref)=>{
    let { viewport: viewport, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const scroll = $a63adcedbbdafe19$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $a63adcedbbdafe19$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $a63adcedbbdafe19$var$getDroppableScrollChange = (_ref)=>{
    let { droppable: droppable, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const frame = droppable.frame;
    if (!frame) return null;
    const scroll = $a63adcedbbdafe19$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $a63adcedbbdafe19$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $a63adcedbbdafe19$var$scroll = (_ref)=>{
    let { state: state, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const center = state.current.page.borderBoxCenter;
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        const viewport = state.viewport;
        const change = $a63adcedbbdafe19$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    const droppable = $a63adcedbbdafe19$var$getBestScrollableDroppable({
        center: center,
        destination: $a63adcedbbdafe19$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    const change = $a63adcedbbdafe19$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $a63adcedbbdafe19$var$createFluidScroller = (_ref)=>{
    let { scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions = ()=>$a63adcedbbdafe19$var$defaultAutoScrollerOptions } = _ref;
    const scheduleWindowScroll = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(scrollWindow);
    const scheduleDroppableScroll = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(scrollDroppable);
    let dragging = null;
    const tryScroll = (state)=>{
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        const { shouldUseTimeDampening: shouldUseTimeDampening, dragStartTime: dragStartTime } = dragging;
        $a63adcedbbdafe19$var$scroll({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
    };
    const start$1 = (state)=>{
        $a63adcedbbdafe19$var$start();
        !!dragging && $a63adcedbbdafe19$var$invariant(false);
        const dragStartTime = Date.now();
        let wasScrollNeeded = false;
        const fakeScrollCallback = ()=>{
            wasScrollNeeded = true;
        };
        $a63adcedbbdafe19$var$scroll({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $a63adcedbbdafe19$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    const stop = ()=>{
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $a63adcedbbdafe19$var$createJumpScroller = (_ref)=>{
    let { move: move, scrollDroppable: scrollDroppable, scrollWindow: scrollWindow } = _ref;
    const moveByOffset = (state, offset)=>{
        const client = $a63adcedbbdafe19$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    const scrollDroppableAsMuchAsItCan = (droppable, change)=>{
        if (!$a63adcedbbdafe19$var$canScrollDroppable(droppable, change)) return change;
        const overlap = $a63adcedbbdafe19$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        const whatTheDroppableCanScroll = $a63adcedbbdafe19$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        const remainder = $a63adcedbbdafe19$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    const scrollWindowAsMuchAsItCan = (isWindowScrollAllowed, viewport, change)=>{
        if (!isWindowScrollAllowed) return change;
        if (!$a63adcedbbdafe19$var$canScrollWindow(viewport, change)) return change;
        const overlap = $a63adcedbbdafe19$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        const whatTheWindowCanScroll = $a63adcedbbdafe19$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        const remainder = $a63adcedbbdafe19$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    const jumpScroller = (state)=>{
        const request = state.scrollJumpRequest;
        if (!request) return;
        const destination = $a63adcedbbdafe19$var$whatIsDraggedOver(state.impact);
        !destination && $a63adcedbbdafe19$var$invariant(false);
        const droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        const viewport = state.viewport;
        const windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $a63adcedbbdafe19$var$createAutoScroller = (_ref)=>{
    let { scrollDroppable: scrollDroppable, scrollWindow: scrollWindow, move: move, getAutoScrollerOptions: getAutoScrollerOptions } = _ref;
    const fluidScroller = $a63adcedbbdafe19$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const jumpScroll = $a63adcedbbdafe19$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    const scroll = (state)=>{
        const autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    const scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
const $a63adcedbbdafe19$var$prefix = 'data-rfd';
const $a63adcedbbdafe19$var$dragHandle = (()=>{
    const base = `${$a63adcedbbdafe19$var$prefix}-drag-handle`;
    return {
        base: base,
        draggableId: `${base}-draggable-id`,
        contextId: `${base}-context-id`
    };
})();
const $a63adcedbbdafe19$var$draggable = (()=>{
    const base = `${$a63adcedbbdafe19$var$prefix}-draggable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $a63adcedbbdafe19$var$droppable = (()=>{
    const base = `${$a63adcedbbdafe19$var$prefix}-droppable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $a63adcedbbdafe19$var$scrollContainer = {
    contextId: `${$a63adcedbbdafe19$var$prefix}-scroll-container-context-id`
};
const $a63adcedbbdafe19$var$makeGetSelector = (context)=>(attribute)=>`[${attribute}="${context}"]`;
const $a63adcedbbdafe19$var$getStyles = (rules, property)=>rules.map((rule)=>{
        const value = rule.styles[property];
        if (!value) return '';
        return `${rule.selector} { ${value} }`;
    }).join(' ');
const $a63adcedbbdafe19$var$noPointerEvents = 'pointer-events: none;';
var $a63adcedbbdafe19$var$getStyles$1 = (contextId)=>{
    const getSelector = $a63adcedbbdafe19$var$makeGetSelector(contextId);
    const dragHandle$1 = (()=>{
        const grabCursor = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
        return {
            selector: getSelector($a63adcedbbdafe19$var$dragHandle.contextId),
            styles: {
                always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
                resting: grabCursor,
                dragging: $a63adcedbbdafe19$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    })();
    const draggable$1 = (()=>{
        const transition = `
      transition: ${$a63adcedbbdafe19$var$transitions.outOfTheWay};
    `;
        return {
            selector: getSelector($a63adcedbbdafe19$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    })();
    const droppable$1 = {
        selector: getSelector($a63adcedbbdafe19$var$droppable.contextId),
        styles: {
            always: `overflow-anchor: none;`
        }
    };
    const body = {
        selector: 'body',
        styles: {
            dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
        }
    };
    const rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $a63adcedbbdafe19$var$getStyles(rules, 'always'),
        resting: $a63adcedbbdafe19$var$getStyles(rules, 'resting'),
        dragging: $a63adcedbbdafe19$var$getStyles(rules, 'dragging'),
        dropAnimating: $a63adcedbbdafe19$var$getStyles(rules, 'dropAnimating'),
        userCancel: $a63adcedbbdafe19$var$getStyles(rules, 'userCancel')
    };
};
const $a63adcedbbdafe19$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $a63adcedbbdafe19$var$useLayoutEffect = $a63adcedbbdafe19$var$useIsomorphicLayoutEffect;
const $a63adcedbbdafe19$var$getHead = ()=>{
    const head = document.querySelector('head');
    !head && $a63adcedbbdafe19$var$invariant(false);
    return head;
};
const $a63adcedbbdafe19$var$createStyleEl = (nonce)=>{
    const el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $a63adcedbbdafe19$var$useStyleMarshal(contextId, nonce) {
    const styles = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>$a63adcedbbdafe19$var$getStyles$1(contextId), [
        contextId
    ]);
    const alwaysRef = (0, $acw62.useRef)(null);
    const dynamicRef = (0, $acw62.useRef)(null);
    const setDynamicStyle = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((0, $8b216712f075a158$export$2e2bcd8739ae039)((proposed)=>{
        const el = dynamicRef.current;
        !el && $a63adcedbbdafe19$var$invariant(false);
        el.textContent = proposed;
    }), []);
    const setAlwaysStyle = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((proposed)=>{
        const el = alwaysRef.current;
        !el && $a63adcedbbdafe19$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        !(!alwaysRef.current && !dynamicRef.current) && $a63adcedbbdafe19$var$invariant(false);
        const always = $a63adcedbbdafe19$var$createStyleEl(nonce);
        const dynamic = $a63adcedbbdafe19$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(`${$a63adcedbbdafe19$var$prefix}-always`, contextId);
        dynamic.setAttribute(`${$a63adcedbbdafe19$var$prefix}-dynamic`, contextId);
        $a63adcedbbdafe19$var$getHead().appendChild(always);
        $a63adcedbbdafe19$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return ()=>{
            const remove = (ref)=>{
                const current = ref.current;
                !current && $a63adcedbbdafe19$var$invariant(false);
                $a63adcedbbdafe19$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    const dragging = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>setDynamicStyle(styles.dragging), [
        setDynamicStyle,
        styles.dragging
    ]);
    const dropping = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((reason)=>{
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    const resting = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    const marshal = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            dragging: dragging,
            dropping: dropping,
            resting: resting
        }), [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function $a63adcedbbdafe19$var$querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var $a63adcedbbdafe19$var$getWindowFromEl = (el)=>{
    var _el$ownerDocument;
    return (el == null ? void 0 : (_el$ownerDocument = el.ownerDocument) == null ? void 0 : _el$ownerDocument.defaultView) || window;
};
function $a63adcedbbdafe19$var$isHtmlElement(el) {
    return el instanceof $a63adcedbbdafe19$var$getWindowFromEl(el).HTMLElement;
}
function $a63adcedbbdafe19$var$findDragHandle(contextId, draggableId) {
    const selector = `[${$a63adcedbbdafe19$var$dragHandle.contextId}="${contextId}"]`;
    const possible = $a63adcedbbdafe19$var$querySelectorAll(document, selector);
    if (!possible.length) return null;
    const handle = possible.find((el)=>{
        return el.getAttribute($a63adcedbbdafe19$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$a63adcedbbdafe19$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a63adcedbbdafe19$var$useFocusMarshal(contextId) {
    const entriesRef = (0, $acw62.useRef)({});
    const recordRef = (0, $acw62.useRef)(null);
    const restoreFocusFrameRef = (0, $acw62.useRef)(null);
    const isMountedRef = (0, $acw62.useRef)(false);
    const register = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function register(id, focus) {
        const entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            const entries = entriesRef.current;
            const current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    const tryGiveFocus = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        const handle = $a63adcedbbdafe19$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    const tryShiftRecord = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    const tryRestoreFocusRecorded = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(()=>{
            restoreFocusFrameRef.current = null;
            const record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    const tryRecordFocus = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        const focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($a63adcedbbdafe19$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            const frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    const marshal = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        }), [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $a63adcedbbdafe19$var$createRegistry() {
    const entries = {
        draggables: {},
        droppables: {}
    };
    const subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            const index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach((cb)=>cb(event));
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        const entry = findDraggableById(id);
        !entry && $a63adcedbbdafe19$var$invariant(false);
        return entry;
    }
    const draggableAPI = {
        register: (entry)=>{
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: (entry, last)=>{
            const current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const draggableId = entry.descriptor.id;
            const current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: (id)=>Boolean(findDraggableById(id)),
        getAllByType: (type)=>Object.values(entries.draggables).filter((entry)=>entry.descriptor.type === type)
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        const entry = findDroppableById(id);
        !entry && $a63adcedbbdafe19$var$invariant(false);
        return entry;
    }
    const droppableAPI = {
        register: (entry)=>{
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: (id)=>Boolean(findDroppableById(id)),
        getAllByType: (type)=>Object.values(entries.droppables).filter((entry)=>entry.descriptor.type === type)
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $a63adcedbbdafe19$var$useRegistry() {
    const registry = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)($a63adcedbbdafe19$var$createRegistry, []);
    (0, $acw62.useEffect)(()=>{
        return function unmount() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('16') || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('17')) requestAnimationFrame(registry.clean);
            else registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var $a63adcedbbdafe19$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $a63adcedbbdafe19$var$getBodyElement = ()=>{
    const body = document.body;
    !body && $a63adcedbbdafe19$var$invariant(false);
    return body;
};
const $a63adcedbbdafe19$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $a63adcedbbdafe19$var$visuallyHidden$1 = $a63adcedbbdafe19$var$visuallyHidden;
const $a63adcedbbdafe19$var$getId = (contextId)=>`rfd-announcement-${contextId}`;
function $a63adcedbbdafe19$var$useAnnouncer(contextId) {
    const id = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>$a63adcedbbdafe19$var$getId(contextId), [
        contextId
    ]);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function setup() {
        const el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        (0, $8nd05.default)(el.style, $a63adcedbbdafe19$var$visuallyHidden$1);
        $a63adcedbbdafe19$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                const body = $a63adcedbbdafe19$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    const announce = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((message)=>{
        const el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
let $a63adcedbbdafe19$var$count$1 = 0;
const $a63adcedbbdafe19$var$defaults = {
    separator: '::'
};
function $a63adcedbbdafe19$var$resetDeprecatedUniqueId() {
    $a63adcedbbdafe19$var$count$1 = 0;
}
function $a63adcedbbdafe19$var$useDeprecatedUniqueId(prefix, options) {
    if (options === void 0) options = $a63adcedbbdafe19$var$defaults;
    return (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>`${prefix}${options.separator}${$a63adcedbbdafe19$var$count$1++}`, [
        options.separator,
        prefix
    ]);
}
function $a63adcedbbdafe19$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $a63adcedbbdafe19$var$defaults;
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    return (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>`${prefix}${options.separator}${id}`, [
        options.separator,
        prefix,
        id
    ]);
}
var $a63adcedbbdafe19$var$useUniqueId$1 = 'useId' in (0, (/*@__PURE__*/$parcel$interopDefault($acw62))) ? $a63adcedbbdafe19$var$useUniqueId : $a63adcedbbdafe19$var$useDeprecatedUniqueId;
function $a63adcedbbdafe19$var$getElementId(_ref) {
    let { contextId: contextId, uniqueId: uniqueId } = _ref;
    return `rfd-hidden-text-${contextId}-${uniqueId}`;
}
function $a63adcedbbdafe19$var$useHiddenTextElement(_ref2) {
    let { contextId: contextId, text: text } = _ref2;
    const uniqueId = $a63adcedbbdafe19$var$useUniqueId$1('hidden-text', {
        separator: '-'
    });
    const id = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>$a63adcedbbdafe19$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        }), [
        uniqueId,
        contextId
    ]);
    (0, $acw62.useEffect)(function mount() {
        const el = document.createElement('div');
        el.id = id;
        el.textContent = text;
        el.style.display = 'none';
        $a63adcedbbdafe19$var$getBodyElement().appendChild(el);
        return function unmount() {
            const body = $a63adcedbbdafe19$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $a63adcedbbdafe19$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $a63adcedbbdafe19$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
const $a63adcedbbdafe19$var$semver = /(\d+)\.(\d+)\.(\d+)/;
const $a63adcedbbdafe19$var$getVersion = (value)=>{
    const result = $a63adcedbbdafe19$var$semver.exec(value);
    !(result != null) && $a63adcedbbdafe19$var$invariant(false);
    const major = Number(result[1]);
    const minor = Number(result[2]);
    const patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
const $a63adcedbbdafe19$var$isSatisfied = (expected, actual)=>{
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $a63adcedbbdafe19$var$checkReactVersion = (peerDepValue, actualValue)=>{
    const peerDep = $a63adcedbbdafe19$var$getVersion(peerDepValue);
    const actual = $a63adcedbbdafe19$var$getVersion(actualValue);
    if ($a63adcedbbdafe19$var$isSatisfied(peerDep, actual)) return;
};
const $a63adcedbbdafe19$var$suffix = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var $a63adcedbbdafe19$var$checkDoctype = (doc)=>{
    const doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $a63adcedbbdafe19$var$useDev(useHook) {}
function $a63adcedbbdafe19$var$useDevSetupWarning(fn, inputs) {
    $a63adcedbbdafe19$var$useDev(()=>{
        (0, $acw62.useEffect)(()=>{
            try {
                fn();
            } catch (e) {
                $a63adcedbbdafe19$var$error(`
          A setup problem was encountered.

          > ${e.message}
        `);
            }
        }, inputs);
    });
}
function $a63adcedbbdafe19$var$useStartupValidation() {
    $a63adcedbbdafe19$var$useDevSetupWarning(()=>{
        $a63adcedbbdafe19$var$checkReactVersion($a63adcedbbdafe19$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version);
        $a63adcedbbdafe19$var$checkDoctype(document);
    }, []);
}
function $a63adcedbbdafe19$var$usePrevious(current) {
    const ref = (0, $acw62.useRef)(current);
    (0, $acw62.useEffect)(()=>{
        ref.current = current;
    });
    return ref;
}
function $a63adcedbbdafe19$var$create() {
    let lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $a63adcedbbdafe19$var$invariant(false);
        const newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $a63adcedbbdafe19$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
function $a63adcedbbdafe19$var$isDragging(state) {
    if (state.phase === 'IDLE' || state.phase === 'DROP_ANIMATING') return false;
    return state.isDragging;
}
const $a63adcedbbdafe19$var$tab = 9;
const $a63adcedbbdafe19$var$enter = 13;
const $a63adcedbbdafe19$var$escape = 27;
const $a63adcedbbdafe19$var$space = 32;
const $a63adcedbbdafe19$var$pageUp = 33;
const $a63adcedbbdafe19$var$pageDown = 34;
const $a63adcedbbdafe19$var$end = 35;
const $a63adcedbbdafe19$var$home = 36;
const $a63adcedbbdafe19$var$arrowLeft = 37;
const $a63adcedbbdafe19$var$arrowUp = 38;
const $a63adcedbbdafe19$var$arrowRight = 39;
const $a63adcedbbdafe19$var$arrowDown = 40;
const $a63adcedbbdafe19$var$preventedKeys = {
    [$a63adcedbbdafe19$var$enter]: true,
    [$a63adcedbbdafe19$var$tab]: true
};
var $a63adcedbbdafe19$var$preventStandardKeyEvents = (event)=>{
    if ($a63adcedbbdafe19$var$preventedKeys[event.keyCode]) event.preventDefault();
};
const $a63adcedbbdafe19$var$supportedEventName = (()=>{
    const base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        `ms${base}`,
        `webkit${base}`,
        `moz${base}`,
        `o${base}`
    ];
    const supported = candidates.find((eventName)=>`on${eventName}` in document);
    return supported || base;
})();
var $a63adcedbbdafe19$var$supportedPageVisibilityEventName = $a63adcedbbdafe19$var$supportedEventName;
const $a63adcedbbdafe19$var$primaryButton = 0;
const $a63adcedbbdafe19$var$sloppyClickThreshold = 5;
function $a63adcedbbdafe19$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $a63adcedbbdafe19$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $a63adcedbbdafe19$var$sloppyClickThreshold;
}
const $a63adcedbbdafe19$var$idle$1 = {
    type: 'IDLE'
};
function $a63adcedbbdafe19$var$getCaptureBindings(_ref) {
    let { cancel: cancel, completed: completed, getPhase: getPhase, setPhase: setPhase } = _ref;
    return [
        {
            eventName: 'mousemove',
            fn: (event)=>{
                const { button: button, clientX: clientX, clientY: clientY } = event;
                if (button !== $a63adcedbbdafe19$var$primaryButton) return;
                const point = {
                    x: clientX,
                    y: clientY
                };
                const phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $a63adcedbbdafe19$var$invariant(false);
                const pending = phase.point;
                if (!$a63adcedbbdafe19$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                const actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: (event)=>{
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $a63adcedbbdafe19$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: ()=>{
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a63adcedbbdafe19$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $a63adcedbbdafe19$export$2f59cd992b42195a(api) {
    const phaseRef = (0, $acw62.useRef)($a63adcedbbdafe19$var$idle$1);
    const unbindEventsRef = (0, $acw62.useRef)($a63adcedbbdafe19$var$noop$2);
    const startCaptureBinding = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $a63adcedbbdafe19$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                const point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const preventForcePressBinding = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            eventName: 'webkitmouseforcewillbegin',
            fn: (event)=>{
                if (event.defaultPrevented) return;
                const id = api.findClosestDraggableId(event);
                if (!id) return;
                const options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function listenForCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a63adcedbbdafe19$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    const stop = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $a63adcedbbdafe19$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    const cancel = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const bindings = $a63adcedbbdafe19$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: ()=>phaseRef.current,
            setPhase: (phase)=>{
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $a63adcedbbdafe19$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    const startPendingDrag = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function $a63adcedbbdafe19$var$noop$1() {}
const $a63adcedbbdafe19$var$scrollJumpKeys = {
    [$a63adcedbbdafe19$var$pageDown]: true,
    [$a63adcedbbdafe19$var$pageUp]: true,
    [$a63adcedbbdafe19$var$home]: true,
    [$a63adcedbbdafe19$var$end]: true
};
function $a63adcedbbdafe19$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (event.keyCode === $a63adcedbbdafe19$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($a63adcedbbdafe19$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $a63adcedbbdafe19$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $a63adcedbbdafe19$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $a63adcedbbdafe19$export$42b74264faad0714(api) {
    const unbindEventsRef = (0, $acw62.useRef)($a63adcedbbdafe19$var$noop$1);
    const startCaptureBinding = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $a63adcedbbdafe19$var$space) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                let isCapturing = true;
                const actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $a63adcedbbdafe19$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $a63adcedbbdafe19$var$bindEvents(window, $a63adcedbbdafe19$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryStartCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a63adcedbbdafe19$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
const $a63adcedbbdafe19$var$idle = {
    type: 'IDLE'
};
const $a63adcedbbdafe19$var$timeForLongPress = 120;
const $a63adcedbbdafe19$var$forcePressThreshold = 0.15;
function $a63adcedbbdafe19$var$getWindowBindings(_ref) {
    let { cancel: cancel, getPhase: getPhase } = _ref;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: (event)=>{
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $a63adcedbbdafe19$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $a63adcedbbdafe19$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $a63adcedbbdafe19$var$getHandleBindings(_ref2) {
    let { cancel: cancel, completed: completed, getPhase: getPhase } = _ref2;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                const { clientX: clientX, clientY: clientY } = event.touches[0];
                const point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
                const touch = event.touches[0];
                if (!touch) return;
                const isForcePress = touch.force >= $a63adcedbbdafe19$var$forcePressThreshold;
                if (!isForcePress) return;
                const shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a63adcedbbdafe19$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $a63adcedbbdafe19$export$ac235fd3a7bcf7b4(api) {
    const phaseRef = (0, $acw62.useRef)($a63adcedbbdafe19$var$idle);
    const unbindEventsRef = (0, $acw62.useRef)($a63adcedbbdafe19$var$noop$2);
    const getPhase = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    const setPhase = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    const startCaptureBinding = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                const touch = event.touches[0];
                const { clientX: clientX, clientY: clientY } = touch;
                const point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function listenForCapture() {
        const options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $a63adcedbbdafe19$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    const stop = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($a63adcedbbdafe19$var$idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    const cancel = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        const unbindTarget = $a63adcedbbdafe19$var$bindEvents(window, $a63adcedbbdafe19$var$getHandleBindings(args), options);
        const unbindWindow = $a63adcedbbdafe19$var$bindEvents(window, $a63adcedbbdafe19$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    const startDragging = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function startDragging() {
        const phase = getPhase();
        !(phase.type === 'PENDING') && $a63adcedbbdafe19$var$invariant(false);
        const actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    const startPendingDrag = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $a63adcedbbdafe19$var$invariant(false);
        const longPressTimerId = setTimeout(startDragging, $a63adcedbbdafe19$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            const phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($a63adcedbbdafe19$var$idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(function webkitHack() {
        const unbind = $a63adcedbbdafe19$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: ()=>{},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $a63adcedbbdafe19$var$useValidateSensorHooks(sensorHooks) {
    $a63adcedbbdafe19$var$useDev(()=>{
        const previousRef = $a63adcedbbdafe19$var$usePrevious(sensorHooks);
        $a63adcedbbdafe19$var$useDevSetupWarning(()=>{
            !(previousRef.current.length === sensorHooks.length) && $a63adcedbbdafe19$var$invariant(false);
        });
    });
}
const $a63adcedbbdafe19$var$interactiveTagNames = [
    'input',
    'button',
    'textarea',
    'select',
    'option',
    'optgroup',
    'video',
    'audio'
];
function $a63adcedbbdafe19$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    const hasAnInteractiveTag = $a63adcedbbdafe19$var$interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    const attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $a63adcedbbdafe19$var$isAnInteractiveElement(parent, current.parentElement);
}
function $a63adcedbbdafe19$var$isEventInInteractiveElement(draggable, event) {
    const target = event.target;
    if (!$a63adcedbbdafe19$var$isHtmlElement(target)) return false;
    return $a63adcedbbdafe19$var$isAnInteractiveElement(draggable, target);
}
var $a63adcedbbdafe19$var$getBorderBoxCenterPosition = (el)=>(0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
function $a63adcedbbdafe19$var$isElement(el) {
    return el instanceof $a63adcedbbdafe19$var$getWindowFromEl(el).Element;
}
const $a63adcedbbdafe19$var$supportedMatchesName = (()=>{
    const base = 'matches';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    const value = candidates.find((name)=>name in Element.prototype);
    return value || base;
})();
function $a63adcedbbdafe19$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$a63adcedbbdafe19$var$supportedMatchesName](selector)) return el;
    return $a63adcedbbdafe19$var$closestPonyfill(el.parentElement, selector);
}
function $a63adcedbbdafe19$var$closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return $a63adcedbbdafe19$var$closestPonyfill(el, selector);
}
function $a63adcedbbdafe19$var$getSelector(contextId) {
    return `[${$a63adcedbbdafe19$var$dragHandle.contextId}="${contextId}"]`;
}
function $a63adcedbbdafe19$var$findClosestDragHandleFromEvent(contextId, event) {
    const target = event.target;
    if (!$a63adcedbbdafe19$var$isElement(target)) return null;
    const selector = $a63adcedbbdafe19$var$getSelector(contextId);
    const handle = $a63adcedbbdafe19$var$closest(target, selector);
    if (!handle) return null;
    if (!$a63adcedbbdafe19$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a63adcedbbdafe19$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    const handle = $a63adcedbbdafe19$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($a63adcedbbdafe19$var$dragHandle.draggableId);
}
function $a63adcedbbdafe19$var$findDraggable(contextId, draggableId) {
    const selector = `[${$a63adcedbbdafe19$var$draggable.contextId}="${contextId}"]`;
    const possible = $a63adcedbbdafe19$var$querySelectorAll(document, selector);
    const draggable$1 = possible.find((el)=>{
        return el.getAttribute($a63adcedbbdafe19$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$a63adcedbbdafe19$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $a63adcedbbdafe19$var$preventDefault(event) {
    event.preventDefault();
}
function $a63adcedbbdafe19$var$isActive(_ref) {
    let { expected: expected, phase: phase, isLockActive: isLockActive, shouldWarn: shouldWarn } = _ref;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $a63adcedbbdafe19$var$canStart(_ref2) {
    let { lockAPI: lockAPI, store: store, registry: registry, draggableId: draggableId } = _ref2;
    if (lockAPI.isClaimed()) return false;
    const entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$a63adcedbbdafe19$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $a63adcedbbdafe19$var$tryStart(_ref3) {
    let { lockAPI: lockAPI, contextId: contextId, store: store, registry: registry, draggableId: draggableId, forceSensorStop: forceSensorStop, sourceEvent: sourceEvent } = _ref3;
    const shouldStart = $a63adcedbbdafe19$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    const entry = registry.draggable.getById(draggableId);
    const el = $a63adcedbbdafe19$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $a63adcedbbdafe19$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    const lock = lockAPI.claim(forceSensorStop || $a63adcedbbdafe19$var$noop$2);
    let phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($a63adcedbbdafe19$var$isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    const tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            $a63adcedbbdafe19$var$invariant(false);
        }
        store.dispatch($a63adcedbbdafe19$var$lift$1(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                const unbind = $a63adcedbbdafe19$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $a63adcedbbdafe19$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($a63adcedbbdafe19$var$drop$1({
                reason: reason
            }));
        }
        return {
            isActive: ()=>$a63adcedbbdafe19$var$isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                }),
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: (options)=>finish('DROP', options),
            cancel: (options)=>finish('CANCEL', options),
            ...args.actions
        };
    }
    function fluidLift(clientSelection) {
        const move$1 = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)((client)=>{
            tryDispatchWhenDragging(()=>$a63adcedbbdafe19$var$move({
                    client: client
                }));
        });
        const api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: ()=>move$1.cancel(),
            actions: {
                move: move$1
            }
        });
        return {
            ...api,
            move: move$1
        };
    }
    function snapLift() {
        const actions = {
            moveUp: ()=>tryDispatchWhenDragging($a63adcedbbdafe19$var$moveUp),
            moveRight: ()=>tryDispatchWhenDragging($a63adcedbbdafe19$var$moveRight),
            moveDown: ()=>tryDispatchWhenDragging($a63adcedbbdafe19$var$moveDown),
            moveLeft: ()=>tryDispatchWhenDragging($a63adcedbbdafe19$var$moveLeft)
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $a63adcedbbdafe19$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $a63adcedbbdafe19$var$noop$2,
            actions: actions
        });
    }
    function abortPreDrag() {
        const shouldRelease = $a63adcedbbdafe19$var$isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    const preDrag = {
        isActive: ()=>$a63adcedbbdafe19$var$isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            }),
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
const $a63adcedbbdafe19$var$defaultSensors = [
    $a63adcedbbdafe19$export$2f59cd992b42195a,
    $a63adcedbbdafe19$export$42b74264faad0714,
    $a63adcedbbdafe19$export$ac235fd3a7bcf7b4
];
function $a63adcedbbdafe19$var$useSensorMarshal(_ref4) {
    let { contextId: contextId, store: store, registry: registry, customSensors: customSensors, enableDefaultSensors: enableDefaultSensors } = _ref4;
    const useSensors = [
        ...enableDefaultSensors ? $a63adcedbbdafe19$var$defaultSensors : [],
        ...customSensors || []
    ];
    const lockAPI = (0, $acw62.useState)(()=>$a63adcedbbdafe19$var$create())[0];
    const tryAbandonLock = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if ($a63adcedbbdafe19$var$isDragging(previous) && !$a63adcedbbdafe19$var$isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(function listenToStore() {
        let previous = store.getState();
        const unsubscribe = store.subscribe(()=>{
            const current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    const canGetLock = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((draggableId)=>{
        return $a63adcedbbdafe19$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    const tryGetLock = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((draggableId, forceStop, options)=>$a63adcedbbdafe19$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        }), [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    const findClosestDraggableId = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((event)=>$a63adcedbbdafe19$var$tryGetClosestDraggableIdFromEvent(contextId, event), [
        contextId
    ]);
    const findOptionsForDraggable = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((id)=>{
        const entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    const tryReleaseLock = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== 'IDLE') store.dispatch($a63adcedbbdafe19$var$flush());
    }, [
        lockAPI,
        store
    ]);
    const isLockClaimed = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>lockAPI.isClaimed(), [
        lockAPI
    ]);
    const api = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        }), [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $a63adcedbbdafe19$var$useValidateSensorHooks(useSensors);
    for(let i = 0; i < useSensors.length; i++)useSensors[i](api);
}
const $a63adcedbbdafe19$var$createResponders = (props)=>({
        onBeforeCapture: (t)=>{
            const onBeforeCapureCallback = ()=>{
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('16') || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('17')) onBeforeCapureCallback();
            else (0, $1u0KT.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    });
const $a63adcedbbdafe19$var$createAutoScrollerOptions = (props)=>({
        ...$a63adcedbbdafe19$var$defaultAutoScrollerOptions,
        ...props.autoScrollerOptions,
        durationDampening: {
            ...$a63adcedbbdafe19$var$defaultAutoScrollerOptions.durationDampening,
            ...props.autoScrollerOptions
        }
    });
function $a63adcedbbdafe19$var$getStore(lazyRef) {
    !lazyRef.current && $a63adcedbbdafe19$var$invariant(false);
    return lazyRef.current;
}
function $a63adcedbbdafe19$var$App(props) {
    const { contextId: contextId, setCallbacks: setCallbacks, sensors: sensors, nonce: nonce, dragHandleUsageInstructions: dragHandleUsageInstructions } = props;
    const lazyStoreRef = (0, $acw62.useRef)(null);
    $a63adcedbbdafe19$var$useStartupValidation();
    const lastPropsRef = $a63adcedbbdafe19$var$usePrevious(props);
    const getResponders = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        return $a63adcedbbdafe19$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const getAutoScrollerOptions = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        return $a63adcedbbdafe19$var$createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const announce = $a63adcedbbdafe19$var$useAnnouncer(contextId);
    const dragHandleUsageInstructionsId = $a63adcedbbdafe19$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    const styleMarshal = $a63adcedbbdafe19$var$useStyleMarshal(contextId, nonce);
    const lazyDispatch = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((action)=>{
        $a63adcedbbdafe19$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    const marshalCallbacks = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>(0, $ad4393542232627c$export$aea084d96e84da92)({
            publishWhileDragging: $a63adcedbbdafe19$var$publishWhileDragging,
            updateDroppableScroll: $a63adcedbbdafe19$var$updateDroppableScroll,
            updateDroppableIsEnabled: $a63adcedbbdafe19$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $a63adcedbbdafe19$var$updateDroppableIsCombineEnabled,
            collectionStarting: $a63adcedbbdafe19$var$collectionStarting
        }, lazyDispatch), [
        lazyDispatch
    ]);
    const registry = $a63adcedbbdafe19$var$useRegistry();
    const dimensionMarshal = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>{
        return $a63adcedbbdafe19$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    const autoScroller = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>$a63adcedbbdafe19$var$createAutoScroller({
            scrollWindow: $a63adcedbbdafe19$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions: getAutoScrollerOptions,
            ...(0, $ad4393542232627c$export$aea084d96e84da92)({
                move: $a63adcedbbdafe19$var$move
            }, lazyDispatch)
        }), [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    const focusMarshal = $a63adcedbbdafe19$var$useFocusMarshal(contextId);
    const store = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>$a63adcedbbdafe19$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        }), [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    const tryResetStore = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const current = $a63adcedbbdafe19$var$getStore(lazyStoreRef);
        const state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($a63adcedbbdafe19$var$flush());
    }, []);
    const isDragging = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const state = $a63adcedbbdafe19$var$getStore(lazyStoreRef).getState();
        if (state.phase === 'DROP_ANIMATING') return true;
        if (state.phase === 'IDLE') return false;
        return state.isDragging;
    }, []);
    const appCallbacks = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            isDragging: isDragging,
            tryAbort: tryResetStore
        }), [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    const getCanLift = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((id)=>$a63adcedbbdafe19$var$canStartDrag($a63adcedbbdafe19$var$getStore(lazyStoreRef).getState(), id), []);
    const getIsMovementAllowed = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>$a63adcedbbdafe19$var$isMovementAllowed($a63adcedbbdafe19$var$getStore(lazyStoreRef).getState()), []);
    const appContext = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        }), [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $a63adcedbbdafe19$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $acw62.useEffect)(()=>{
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e7b35c603673dee1$export$2e2bcd8739ae039), {
        context: $a63adcedbbdafe19$var$StoreContext,
        store: store
    }, props.children));
}
let $a63adcedbbdafe19$var$count = 0;
function $a63adcedbbdafe19$var$resetDeprecatedUniqueContextId() {
    $a63adcedbbdafe19$var$count = 0;
}
function $a63adcedbbdafe19$var$useDeprecatedUniqueContextId() {
    return (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>`${$a63adcedbbdafe19$var$count++}`, []);
}
function $a63adcedbbdafe19$var$useUniqueContextId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
}
var $a63adcedbbdafe19$var$useUniqueContextId$1 = 'useId' in (0, (/*@__PURE__*/$parcel$interopDefault($acw62))) ? $a63adcedbbdafe19$var$useUniqueContextId : $a63adcedbbdafe19$var$useDeprecatedUniqueContextId;
function $a63adcedbbdafe19$export$2bfe52350fc0150d() {
    if ('useId' in (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))) return;
    $a63adcedbbdafe19$var$resetDeprecatedUniqueContextId();
    $a63adcedbbdafe19$var$resetDeprecatedUniqueId();
}
function $a63adcedbbdafe19$export$237bd83162c14364(props) {
    const contextId = $a63adcedbbdafe19$var$useUniqueContextId$1();
    const dragHandleUsageInstructions = props.dragHandleUsageInstructions || $a63adcedbbdafe19$var$preset$1.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$ErrorBoundary, null, (setCallbacks)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children));
}
const $a63adcedbbdafe19$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
const $a63adcedbbdafe19$var$getDraggingTransition = (shouldAnimateDragMovement, dropping)=>{
    if (dropping) return $a63adcedbbdafe19$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $a63adcedbbdafe19$var$transitions.snap;
    return $a63adcedbbdafe19$var$transitions.fluid;
};
const $a63adcedbbdafe19$var$getDraggingOpacity = (isCombining, isDropAnimating)=>{
    if (!isCombining) return undefined;
    return isDropAnimating ? $a63adcedbbdafe19$var$combine.opacity.drop : $a63adcedbbdafe19$var$combine.opacity.combining;
};
const $a63adcedbbdafe19$var$getShouldDraggingAnimate = (dragging)=>{
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $a63adcedbbdafe19$var$getDraggingStyle(dragging) {
    const dimension = dragging.dimension;
    const box = dimension.client;
    const { offset: offset, combineWith: combineWith, dropping: dropping } = dragging;
    const isCombining = Boolean(combineWith);
    const shouldAnimate = $a63adcedbbdafe19$var$getShouldDraggingAnimate(dragging);
    const isDropAnimating = Boolean(dropping);
    const transform = isDropAnimating ? $a63adcedbbdafe19$var$transforms.drop(offset, isCombining) : $a63adcedbbdafe19$var$transforms.moveTo(offset);
    const style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $a63adcedbbdafe19$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $a63adcedbbdafe19$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $a63adcedbbdafe19$var$zIndexOptions.dropAnimating : $a63adcedbbdafe19$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $a63adcedbbdafe19$var$getSecondaryStyle(secondary) {
    return {
        transform: $a63adcedbbdafe19$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : 'none'
    };
}
function $a63adcedbbdafe19$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $a63adcedbbdafe19$var$getDraggingStyle(mapped) : $a63adcedbbdafe19$var$getSecondaryStyle(mapped);
}
function $a63adcedbbdafe19$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $a63adcedbbdafe19$var$origin;
    const computedStyles = window.getComputedStyle(el);
    const borderBox = el.getBoundingClientRect();
    const client = (0, $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    const page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, windowScroll);
    const placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    const displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    const dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $a63adcedbbdafe19$var$useDraggablePublisher(args) {
    const uniqueId = $a63adcedbbdafe19$var$useUniqueId$1('draggable');
    const { descriptor: descriptor, registry: registry, getDraggableRef: getDraggableRef, canDragInteractiveElements: canDragInteractiveElements, shouldRespectForcePress: shouldRespectForcePress, isEnabled: isEnabled } = args;
    const options = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        }), [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    const getDimension = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((windowScroll)=>{
        const el = getDraggableRef();
        !el && $a63adcedbbdafe19$var$invariant(false);
        return $a63adcedbbdafe19$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    const entry = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        }), [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    const publishedRef = (0, $acw62.useRef)(entry);
    const isFirstPublishRef = (0, $acw62.useRef)(true);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        registry.draggable.register(publishedRef.current);
        return ()=>registry.draggable.unregister(publishedRef.current);
    }, [
        registry.draggable
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        const last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var $a63adcedbbdafe19$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $a63adcedbbdafe19$var$checkIsValidInnerRef(el) {
    !(el && $a63adcedbbdafe19$var$isHtmlElement(el)) && $a63adcedbbdafe19$var$invariant(false);
}
function $a63adcedbbdafe19$var$useValidation$1(props, contextId, getRef) {
    $a63adcedbbdafe19$var$useDevSetupWarning(()=>{
        function prefix(id) {
            return `Draggable[id: ${id}]: `;
        }
        const id = props.draggableId;
        !id && $a63adcedbbdafe19$var$invariant(false);
        !(typeof id === 'string') && $a63adcedbbdafe19$var$invariant(false);
        !Number.isInteger(props.index) && $a63adcedbbdafe19$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $a63adcedbbdafe19$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$a63adcedbbdafe19$var$findDragHandle(contextId, id) && $a63adcedbbdafe19$var$invariant(false);
    });
}
function $a63adcedbbdafe19$var$useClonePropValidation(isClone) {
    $a63adcedbbdafe19$var$useDev(()=>{
        const initialRef = (0, $acw62.useRef)(isClone);
        $a63adcedbbdafe19$var$useDevSetupWarning(()=>{
            !(isClone === initialRef.current) && $a63adcedbbdafe19$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $a63adcedbbdafe19$var$useRequiredContext(Context) {
    const result = (0, $acw62.useContext)(Context);
    !result && $a63adcedbbdafe19$var$invariant(false);
    return result;
}
function $a63adcedbbdafe19$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
const $a63adcedbbdafe19$var$Draggable = (props)=>{
    const ref = (0, $acw62.useRef)(null);
    const setRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function(el) {
        if (el === void 0) el = null;
        ref.current = el;
    }, []);
    const getRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>ref.current, []);
    const { contextId: contextId, dragHandleUsageInstructionsId: dragHandleUsageInstructionsId, registry: registry } = $a63adcedbbdafe19$var$useRequiredContext($a63adcedbbdafe19$var$AppContext);
    const { type: type, droppableId: droppableId } = $a63adcedbbdafe19$var$useRequiredContext($a63adcedbbdafe19$var$DroppableContext);
    const descriptor = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        }), [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    const { children: children, draggableId: draggableId, isEnabled: isEnabled, shouldRespectForcePress: shouldRespectForcePress, canDragInteractiveElements: canDragInteractiveElements, isClone: isClone, mapped: mapped, dropAnimationFinished: dropAnimationFinishedAction } = props;
    $a63adcedbbdafe19$var$useValidation$1(props, contextId, getRef);
    $a63adcedbbdafe19$var$useClonePropValidation(isClone);
    if (!isClone) {
        const forPublisher = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            }), [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $a63adcedbbdafe19$var$useDraggablePublisher(forPublisher);
    }
    const dragHandleProps = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>isEnabled ? {
            tabIndex: 0,
            role: 'button',
            'aria-describedby': dragHandleUsageInstructionsId,
            'data-rfd-drag-handle-draggable-id': draggableId,
            'data-rfd-drag-handle-context-id': contextId,
            draggable: false,
            onDragStart: $a63adcedbbdafe19$var$preventHtml5Dnd
        } : null, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    const onMoveEnd = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((event)=>{
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('16') || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.startsWith('17')) dropAnimationFinishedAction();
        else (0, $1u0KT.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    const provided = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>{
        const style = $a63adcedbbdafe19$var$getStyle$1(mapped);
        const onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : undefined;
        const result = {
            innerRef: setRef,
            draggableProps: {
                'data-rfd-draggable-context-id': contextId,
                'data-rfd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    const rubric = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }), [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var $a63adcedbbdafe19$var$Draggable$1 = $a63adcedbbdafe19$var$Draggable;
var $a63adcedbbdafe19$var$isStrictEqual = (a, b)=>a === b;
var $a63adcedbbdafe19$var$whatIsDraggedOverFromResult = (result)=>{
    const { combine: combine, destination: destination } = result;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
const $a63adcedbbdafe19$var$getCombineWithFromResult = (result)=>{
    return result.combine ? result.combine.draggableId : null;
};
const $a63adcedbbdafe19$var$getCombineWithFromImpact = (impact)=>{
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $a63adcedbbdafe19$var$getDraggableSelector() {
    const memoizedOffset = (0, $8b216712f075a158$export$2e2bcd8739ae039)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $8b216712f075a158$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        if (draggingOver === void 0) draggingOver = null;
        if (combineWith === void 0) combineWith = null;
        if (dropping === void 0) dropping = null;
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    const getMemoizedProps = (0, $8b216712f075a158$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        if (draggingOver === void 0) draggingOver = null;
        if (combineWith === void 0) combineWith = null;
        if (forceShouldAnimate === void 0) forceShouldAnimate = null;
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    const selector = (state, ownProps)=>{
        if ($a63adcedbbdafe19$var$isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            const offset = state.current.client.offset;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const draggingOver = $a63adcedbbdafe19$var$whatIsDraggedOver(state.impact);
            const combineWith = $a63adcedbbdafe19$var$getCombineWithFromImpact(state.impact);
            const forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            const isClone = ownProps.isClone;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const result = completed.result;
            const mode = result.mode;
            const draggingOver = $a63adcedbbdafe19$var$whatIsDraggedOverFromResult(result);
            const combineWith = $a63adcedbbdafe19$var$getCombineWithFromResult(result);
            const duration = state.dropDuration;
            const dropping = {
                duration: duration,
                curve: $a63adcedbbdafe19$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith ? $a63adcedbbdafe19$var$combine.opacity.drop : null,
                scale: combineWith ? $a63adcedbbdafe19$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: dimension,
                    dropping: dropping,
                    draggingOver: draggingOver,
                    combineWith: combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $a63adcedbbdafe19$var$getSecondarySnapshot(combineTargetFor) {
    if (combineTargetFor === void 0) combineTargetFor = null;
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
const $a63adcedbbdafe19$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $a63adcedbbdafe19$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $a63adcedbbdafe19$var$getSecondarySnapshot(null)
    }
};
function $a63adcedbbdafe19$var$getSecondarySelector() {
    const memoizedOffset = (0, $8b216712f075a158$export$2e2bcd8739ae039)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $8b216712f075a158$export$2e2bcd8739ae039)($a63adcedbbdafe19$var$getSecondarySnapshot);
    const getMemoizedProps = (0, $8b216712f075a158$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    const getFallback = (combineTargetFor)=>{
        return combineTargetFor ? getMemoizedProps($a63adcedbbdafe19$var$origin, combineTargetFor, true) : null;
    };
    const getProps = (ownId, draggingId, impact, afterCritical)=>{
        const visualDisplacement = impact.displaced.visible[ownId];
        const isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        const combine = $a63adcedbbdafe19$var$tryGetCombine(impact);
        const combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            const change = $a63adcedbbdafe19$var$negate(afterCritical.displacedBy.point);
            const offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        const displaceBy = impact.displacedBy.point;
        const offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    const selector = (state, ownProps)=>{
        if ($a63adcedbbdafe19$var$isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
const $a63adcedbbdafe19$var$makeMapStateToProps$1 = ()=>{
    const draggingSelector = $a63adcedbbdafe19$var$getDraggableSelector();
    const secondarySelector = $a63adcedbbdafe19$var$getSecondarySelector();
    const selector = (state, ownProps)=>draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $a63adcedbbdafe19$var$atRest;
    return selector;
};
const $a63adcedbbdafe19$var$mapDispatchToProps$1 = {
    dropAnimationFinished: $a63adcedbbdafe19$var$dropAnimationFinished
};
const $a63adcedbbdafe19$var$ConnectedDraggable = (0, $42eb6aad476e9cd0$export$2e2bcd8739ae039)($a63adcedbbdafe19$var$makeMapStateToProps$1, $a63adcedbbdafe19$var$mapDispatchToProps$1, null, {
    context: $a63adcedbbdafe19$var$StoreContext,
    areStatePropsEqual: $a63adcedbbdafe19$var$isStrictEqual
})($a63adcedbbdafe19$var$Draggable$1);
var $a63adcedbbdafe19$var$ConnectedDraggable$1 = $a63adcedbbdafe19$var$ConnectedDraggable;
function $a63adcedbbdafe19$var$PrivateDraggable(props) {
    const droppableContext = $a63adcedbbdafe19$var$useRequiredContext($a63adcedbbdafe19$var$DroppableContext);
    const isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$ConnectedDraggable$1, props);
}
function $a63adcedbbdafe19$export$f2a139e5d18b9882(props) {
    const isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    const canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    const shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$PrivateDraggable, (0, $8nd05.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
const $a63adcedbbdafe19$var$isEqual = (base)=>(value)=>base === value;
const $a63adcedbbdafe19$var$isScroll = $a63adcedbbdafe19$var$isEqual('scroll');
const $a63adcedbbdafe19$var$isAuto = $a63adcedbbdafe19$var$isEqual('auto');
const $a63adcedbbdafe19$var$isVisible = $a63adcedbbdafe19$var$isEqual('visible');
const $a63adcedbbdafe19$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $a63adcedbbdafe19$var$isBoth = (overflow, fn)=>fn(overflow.overflowX) && fn(overflow.overflowY);
const $a63adcedbbdafe19$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $a63adcedbbdafe19$var$isEither(overflow, $a63adcedbbdafe19$var$isScroll) || $a63adcedbbdafe19$var$isEither(overflow, $a63adcedbbdafe19$var$isAuto);
};
const $a63adcedbbdafe19$var$isBodyScrollable = ()=>{
    return false;
};
const $a63adcedbbdafe19$var$getClosestScrollable = (el)=>{
    if (el == null) return null;
    if (el === document.body) return $a63adcedbbdafe19$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$a63adcedbbdafe19$var$isElementScrollable(el)) return $a63adcedbbdafe19$var$getClosestScrollable(el.parentElement);
    return el;
};
var $a63adcedbbdafe19$var$getClosestScrollable$1 = $a63adcedbbdafe19$var$getClosestScrollable;
var $a63adcedbbdafe19$var$checkForNestedScrollContainers = (scrollable)=>{
    if (!scrollable) return;
    const anotherScrollParent = $a63adcedbbdafe19$var$getClosestScrollable$1(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $a63adcedbbdafe19$var$getScroll = (el)=>({
        x: el.scrollLeft,
        y: el.scrollTop
    });
const $a63adcedbbdafe19$var$getIsFixed = (el)=>{
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return $a63adcedbbdafe19$var$getIsFixed(el.parentElement);
};
var $a63adcedbbdafe19$var$getEnv = (start)=>{
    const closestScrollable = $a63adcedbbdafe19$var$getClosestScrollable$1(start);
    const isFixedOnPage = $a63adcedbbdafe19$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $a63adcedbbdafe19$var$getDroppableDimension = (_ref)=>{
    let { descriptor: descriptor, isEnabled: isEnabled, isCombineEnabled: isCombineEnabled, isFixedOnPage: isFixedOnPage, direction: direction, client: client, page: page, closest: closest } = _ref;
    const frame = (()=>{
        if (!closest) return null;
        const { scrollSize: scrollSize, client: frameClient } = closest;
        const maxScroll = $a63adcedbbdafe19$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $a63adcedbbdafe19$var$origin,
                    displacement: $a63adcedbbdafe19$var$origin
                }
            }
        };
    })();
    const axis = direction === 'vertical' ? $a63adcedbbdafe19$var$vertical : $a63adcedbbdafe19$var$horizontal;
    const subject = $a63adcedbbdafe19$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    const dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
const $a63adcedbbdafe19$var$getClient = (targetRef, closestScrollable)=>{
    const base = (0, $0f2a76a440eafaaa$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    const top = base.paddingBox.top - closestScrollable.scrollTop;
    const left = base.paddingBox.left - closestScrollable.scrollLeft;
    const bottom = top + closestScrollable.scrollHeight;
    const right = left + closestScrollable.scrollWidth;
    const paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    const borderBox = (0, $0f2a76a440eafaaa$export$9f77e0932fb78f72)(paddingBox, base.border);
    const client = (0, $0f2a76a440eafaaa$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $a63adcedbbdafe19$var$getDimension = (_ref)=>{
    let { ref: ref, descriptor: descriptor, env: env, windowScroll: windowScroll, direction: direction, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, shouldClipSubject: shouldClipSubject } = _ref;
    const closestScrollable = env.closestScrollable;
    const client = $a63adcedbbdafe19$var$getClient(ref, closestScrollable);
    const page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, windowScroll);
    const closest = (()=>{
        if (!closestScrollable) return null;
        const frameClient = (0, $0f2a76a440eafaaa$export$34928e660d2a8702)(closestScrollable);
        const scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $a63adcedbbdafe19$var$getScroll(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    })();
    const dimension = $a63adcedbbdafe19$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
const $a63adcedbbdafe19$var$immediate = {
    passive: false
};
const $a63adcedbbdafe19$var$delayed = {
    passive: true
};
var $a63adcedbbdafe19$var$getListenerOptions = (options)=>options.shouldPublishImmediately ? $a63adcedbbdafe19$var$immediate : $a63adcedbbdafe19$var$delayed;
const $a63adcedbbdafe19$var$getClosestScrollableFromDrag = (dragging)=>dragging && dragging.env.closestScrollable || null;
function $a63adcedbbdafe19$var$useDroppablePublisher(args) {
    const whileDraggingRef = (0, $acw62.useRef)(null);
    const appContext = $a63adcedbbdafe19$var$useRequiredContext($a63adcedbbdafe19$var$AppContext);
    const uniqueId = $a63adcedbbdafe19$var$useUniqueId$1('droppable');
    const { registry: registry, marshal: marshal } = appContext;
    const previousRef = $a63adcedbbdafe19$var$usePrevious(args);
    const descriptor = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        }), [
        args.droppableId,
        args.mode,
        args.type
    ]);
    const publishedDescriptorRef = (0, $acw62.useRef)(descriptor);
    const memoizedUpdateScroll = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>(0, $8b216712f075a158$export$2e2bcd8739ae039)((x, y)=>{
            !whileDraggingRef.current && $a63adcedbbdafe19$var$invariant(false);
            const scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        }), [
        descriptor.id,
        marshal
    ]);
    const getClosestScroll = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $a63adcedbbdafe19$var$origin;
        return $a63adcedbbdafe19$var$getScroll(dragging.env.closestScrollable);
    }, []);
    const updateScroll = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    const scheduleScrollUpdate = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>(0, $8f52a5054f09a665$export$2e2bcd8739ae039)(updateScroll), [
        updateScroll
    ]);
    const onClosestScroll = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $a63adcedbbdafe19$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a63adcedbbdafe19$var$invariant(false);
        const options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    const getDimensionAndWatchScroll = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((windowScroll, options)=>{
        !!whileDraggingRef.current && $a63adcedbbdafe19$var$invariant(false);
        const previous = previousRef.current;
        const ref = previous.getDroppableRef();
        !ref && $a63adcedbbdafe19$var$invariant(false);
        const env = $a63adcedbbdafe19$var$getEnv(ref);
        const dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        const dimension = $a63adcedbbdafe19$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        const scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($a63adcedbbdafe19$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $a63adcedbbdafe19$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    const getScrollWhileDragging = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $a63adcedbbdafe19$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a63adcedbbdafe19$var$invariant(false);
        return $a63adcedbbdafe19$var$getScroll(closest);
    }, []);
    const dragStopped = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        const dragging = whileDraggingRef.current;
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        const closest = $a63adcedbbdafe19$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($a63adcedbbdafe19$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $a63adcedbbdafe19$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    const scroll = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((change)=>{
        const dragging = whileDraggingRef.current;
        !dragging && $a63adcedbbdafe19$var$invariant(false);
        const closest = $a63adcedbbdafe19$var$getClosestScrollableFromDrag(dragging);
        !closest && $a63adcedbbdafe19$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    const callbacks = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>{
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    const entry = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        }), [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return ()=>{
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $a63adcedbbdafe19$var$useLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $a63adcedbbdafe19$var$noop() {}
const $a63adcedbbdafe19$var$empty = {
    width: 0,
    height: 0,
    margin: $a63adcedbbdafe19$var$noSpacing
};
const $a63adcedbbdafe19$var$getSize = (_ref)=>{
    let { isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate } = _ref;
    if (isAnimatingOpenOnMount) return $a63adcedbbdafe19$var$empty;
    if (animate === 'close') return $a63adcedbbdafe19$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
const $a63adcedbbdafe19$var$getStyle = (_ref2)=>{
    let { isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate } = _ref2;
    const size = $a63adcedbbdafe19$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $a63adcedbbdafe19$var$transitions.placeholder : null
    };
};
const $a63adcedbbdafe19$var$Placeholder = (props)=>{
    const animateOpenTimerRef = (0, $acw62.useRef)(null);
    const tryClearAnimateOpenTimer = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    const { animate: animate, onTransitionEnd: onTransitionEnd, onClose: onClose, contextId: contextId } = props;
    const [isAnimatingOpenOnMount, setIsAnimatingOpenOnMount] = (0, $acw62.useState)(props.animate === 'open');
    (0, $acw62.useEffect)(()=>{
        if (!isAnimatingOpenOnMount) return $a63adcedbbdafe19$var$noop;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $a63adcedbbdafe19$var$noop;
        }
        if (animateOpenTimerRef.current) return $a63adcedbbdafe19$var$noop;
        animateOpenTimerRef.current = setTimeout(()=>{
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    const onSizeChangeEnd = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)((event)=>{
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    const style = $a63adcedbbdafe19$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rfd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var $a63adcedbbdafe19$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($a63adcedbbdafe19$var$Placeholder);
function $a63adcedbbdafe19$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $a63adcedbbdafe19$var$runChecks(args, checks) {
    checks.forEach((check)=>check(args));
}
const $a63adcedbbdafe19$var$shared = [
    function required(_ref) {
        let { props: props } = _ref;
        !props.droppableId && $a63adcedbbdafe19$var$invariant(false);
        !(typeof props.droppableId === 'string') && $a63adcedbbdafe19$var$invariant(false);
    },
    function boolean(_ref2) {
        let { props: props } = _ref2;
        !$a63adcedbbdafe19$var$isBoolean(props.isDropDisabled) && $a63adcedbbdafe19$var$invariant(false);
        !$a63adcedbbdafe19$var$isBoolean(props.isCombineEnabled) && $a63adcedbbdafe19$var$invariant(false);
        !$a63adcedbbdafe19$var$isBoolean(props.ignoreContainerClipping) && $a63adcedbbdafe19$var$invariant(false);
    },
    function ref(_ref3) {
        let { getDroppableRef: getDroppableRef } = _ref3;
        $a63adcedbbdafe19$var$checkIsValidInnerRef(getDroppableRef());
    }
];
const $a63adcedbbdafe19$var$standard = [
    function placeholder(_ref4) {
        let { props: props, getPlaceholderRef: getPlaceholderRef } = _ref4;
        if (!props.placeholder) return;
        const ref = getPlaceholderRef();
        if (ref) return;
    }
];
const $a63adcedbbdafe19$var$virtual = [
    function hasClone(_ref5) {
        let { props: props } = _ref5;
        !props.renderClone && $a63adcedbbdafe19$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        let { getPlaceholderRef: getPlaceholderRef } = _ref6;
        !!getPlaceholderRef() && $a63adcedbbdafe19$var$invariant(false);
    }
];
function $a63adcedbbdafe19$var$useValidation(args) {
    $a63adcedbbdafe19$var$useDevSetupWarning(()=>{
        $a63adcedbbdafe19$var$runChecks(args, $a63adcedbbdafe19$var$shared);
        if (args.props.mode === 'standard') $a63adcedbbdafe19$var$runChecks(args, $a63adcedbbdafe19$var$standard);
        if (args.props.mode === 'virtual') $a63adcedbbdafe19$var$runChecks(args, $a63adcedbbdafe19$var$virtual);
    });
}
class $a63adcedbbdafe19$var$AnimateInOut extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    constructor(){
        super(...arguments);
        this.state = {
            isVisible: Boolean(this.props.on),
            data: this.props.on,
            animate: this.props.shouldAnimate && this.props.on ? 'open' : 'none'
        };
        this.onClose = ()=>{
            if (this.state.animate !== 'close') return;
            this.setState({
                isVisible: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    }
    render() {
        if (!this.state.isVisible) return null;
        const provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    }
}
const $a63adcedbbdafe19$var$Droppable = (props)=>{
    const appContext = (0, $acw62.useContext)($a63adcedbbdafe19$var$AppContext);
    !appContext && $a63adcedbbdafe19$var$invariant(false);
    const { contextId: contextId, isMovementAllowed: isMovementAllowed } = appContext;
    const droppableRef = (0, $acw62.useRef)(null);
    const placeholderRef = (0, $acw62.useRef)(null);
    const { children: children, droppableId: droppableId, type: type, mode: mode, direction: direction, ignoreContainerClipping: ignoreContainerClipping, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, snapshot: snapshot, useClone: useClone, updateViewportMaxScroll: updateViewportMaxScroll, getContainerForClone: getContainerForClone } = props;
    const getDroppableRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>droppableRef.current, []);
    const setDroppableRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function(value) {
        if (value === void 0) value = null;
        droppableRef.current = value;
    }, []);
    const getPlaceholderRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>placeholderRef.current, []);
    const setPlaceholderRef = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(function(value) {
        if (value === void 0) value = null;
        placeholderRef.current = value;
    }, []);
    $a63adcedbbdafe19$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    const onPlaceholderTransitionEnd = (0, $d29f5b3d0d51225a$export$35808ee640e87ca7)(()=>{
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $a63adcedbbdafe19$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $a63adcedbbdafe19$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    const placeholder = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, (_ref)=>{
            let { onClose: onClose, data: data, animate: animate } = _ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            });
        }), [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    const provided = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rfd-droppable-id': droppableId,
                'data-rfd-droppable-context-id': contextId
            }
        }), [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    const isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    const droppableContext = (0, $d29f5b3d0d51225a$export$1538c33de8887b59)(()=>({
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        }), [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        const { dragging: dragging, render: render } = useClone;
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, (draggableProvided, draggableSnapshot)=>render(draggableProvided, draggableSnapshot, dragging));
        return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a63adcedbbdafe19$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
var $a63adcedbbdafe19$var$Droppable$1 = $a63adcedbbdafe19$var$Droppable;
const $a63adcedbbdafe19$var$isMatchingType = (type, critical)=>type === critical.droppable.type;
const $a63adcedbbdafe19$var$getDraggable = (critical, dimensions)=>dimensions.draggables[critical.draggable.id];
const $a63adcedbbdafe19$var$makeMapStateToProps = ()=>{
    const idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    const idleWithoutAnimation = {
        ...idleWithAnimation,
        shouldAnimatePlaceholder: false
    };
    const getDraggableRubric = (0, $8b216712f075a158$export$2e2bcd8739ae039)((descriptor)=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }));
    const getMapProps = (0, $8b216712f075a158$export$2e2bcd8739ae039)((id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone)=>{
        const draggableId = dragging.descriptor.id;
        const isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            const useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            const snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        const snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    const selector = (state, ownProps)=>{
        const id = ownProps.droppableId;
        const type = ownProps.type;
        const isEnabled = !ownProps.isDropDisabled;
        const renderClone = ownProps.renderClone;
        if ($a63adcedbbdafe19$var$isDragging(state)) {
            const critical = state.critical;
            if (!$a63adcedbbdafe19$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            const dragging = $a63adcedbbdafe19$var$getDraggable(critical, state.dimensions);
            const isDraggingOver = $a63adcedbbdafe19$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (!$a63adcedbbdafe19$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const dragging = $a63adcedbbdafe19$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $a63adcedbbdafe19$var$whatIsDraggedOverFromResult(completed.result) === id, $a63adcedbbdafe19$var$whatIsDraggedOver(completed.impact) === id, dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            const completed = state.completed;
            if (!$a63adcedbbdafe19$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const wasOver = $a63adcedbbdafe19$var$whatIsDraggedOver(completed.impact) === id;
            const wasCombining = Boolean(completed.impact.at && completed.impact.at.type === 'COMBINE');
            const isHome = completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
const $a63adcedbbdafe19$var$mapDispatchToProps = {
    updateViewportMaxScroll: $a63adcedbbdafe19$var$updateViewportMaxScroll
};
function $a63adcedbbdafe19$var$getBody() {
    !document.body && $a63adcedbbdafe19$var$invariant(false);
    return document.body;
}
const $a63adcedbbdafe19$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $a63adcedbbdafe19$var$getBody
};
const $a63adcedbbdafe19$var$ConnectedDroppable = (0, $42eb6aad476e9cd0$export$2e2bcd8739ae039)($a63adcedbbdafe19$var$makeMapStateToProps, $a63adcedbbdafe19$var$mapDispatchToProps, null, {
    context: $a63adcedbbdafe19$var$StoreContext,
    areStatePropsEqual: $a63adcedbbdafe19$var$isStrictEqual
})($a63adcedbbdafe19$var$Droppable$1);
$a63adcedbbdafe19$var$ConnectedDroppable.defaultProps = $a63adcedbbdafe19$var$defaultProps;
var $a63adcedbbdafe19$export$423ec2075359570a = $a63adcedbbdafe19$var$ConnectedDroppable;




var $acw62 = parcelRequire("acw62");

const $8248918e189a913b$export$67396e133708350c = (props)=>{
    const { spaceBetweenCircles: spaceBetweenCircles, color: color, strokeColor: strokeColor, strokeWidth: strokeWidth, diameterOfACircle: diameterOfACircle } = props;
    const iconWidth = diameterOfACircle * 2 + spaceBetweenCircles;
    const iconHeight = diameterOfACircle * 3 + spaceBetweenCircles * 2;
    const circleRadius = diameterOfACircle / 2 - strokeWidth / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        fill: "none",
        viewBox: `0 0 ${iconWidth} ${iconHeight}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: diameterOfACircle / 2,
        cy: diameterOfACircle / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: iconWidth - diameterOfACircle / 2,
        cy: diameterOfACircle / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: diameterOfACircle / 2,
        cy: iconHeight / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: iconWidth - diameterOfACircle / 2,
        cy: iconHeight / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: diameterOfACircle / 2,
        cy: iconHeight - diameterOfACircle / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: iconWidth - diameterOfACircle / 2,
        cy: iconHeight - diameterOfACircle / 2,
        r: circleRadius,
        fill: color,
        stroke: strokeColor,
        strokeWidth: strokeWidth
    }));
};
$8248918e189a913b$export$67396e133708350c.defaultProps = {
    spaceBetweenCircles: 2,
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
    strokeColor: "#fff",
    strokeWidth: 0.2,
    diameterOfACircle: 5
};
var $8248918e189a913b$export$2e2bcd8739ae039 = $8248918e189a913b$export$67396e133708350c;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $9f035b2006f43014$export$56caa13a0392587b = (props)=>{
    const { children: children, copy: copy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9f035b2006f43014$var$FormElementContainer, {
        copy: copy || false
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9f035b2006f43014$var$DragIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null)));
};
const $9f035b2006f43014$var$FormElementContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  width: 100%;

  ${(copy)=>copy && (0, $lmFrL.css)`
      opacity: 0.5;

      ~ div {
        transform: none !important;
      }

      ~ [data-rbd-placeholder-context-id] {
        display: none !important;
      }
    `}
`;
const $9f035b2006f43014$var$DragIconContainer = (0, $lmFrL.default).div`
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
`;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $63af748d0fde9ea7$var$extendStatics = function(d, b) {
    $63af748d0fde9ea7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $63af748d0fde9ea7$var$extendStatics(d, b);
};
function $63af748d0fde9ea7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $63af748d0fde9ea7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $63af748d0fde9ea7$export$18ce0697a983be9b = function() {
    $63af748d0fde9ea7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63af748d0fde9ea7$export$18ce0697a983be9b.apply(this, arguments);
};
function $63af748d0fde9ea7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $63af748d0fde9ea7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $63af748d0fde9ea7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $63af748d0fde9ea7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $63af748d0fde9ea7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $63af748d0fde9ea7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $63af748d0fde9ea7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $63af748d0fde9ea7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $63af748d0fde9ea7$export$45d3717a4c69092e(o, m, p);
}
function $63af748d0fde9ea7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $63af748d0fde9ea7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $63af748d0fde9ea7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($63af748d0fde9ea7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $63af748d0fde9ea7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $63af748d0fde9ea7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $63af748d0fde9ea7$export$10c90e4f7922046c(v) {
    return this instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? (this.v = v, this) : new $63af748d0fde9ea7$export$10c90e4f7922046c(v);
}
function $63af748d0fde9ea7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $63af748d0fde9ea7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $63af748d0fde9ea7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $63af748d0fde9ea7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $63af748d0fde9ea7$export$19a8beecd37a4c45 === "function" ? $63af748d0fde9ea7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $63af748d0fde9ea7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $63af748d0fde9ea7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $63af748d0fde9ea7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $63af748d0fde9ea7$export$45d3717a4c69092e(result, mod, k);
    }
    $63af748d0fde9ea7$var$__setModuleDefault(result, mod);
    return result;
}
function $63af748d0fde9ea7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $63af748d0fde9ea7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $63af748d0fde9ea7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    [
        'avi',
        'video/avi'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $63af748d0fde9ea7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $63af748d0fde9ea7$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$isDragEvt(evt) && evt.dataTransfer ? $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    var files = $7ac450b547cb7da9$var$isInput(evt.target) ? evt.target.files ? $7ac450b547cb7da9$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
function $7ac450b547cb7da9$var$isInput(value) {
    return value !== null;
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $63af748d0fde9ea7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $63af748d0fde9ea7$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $63af748d0fde9ea7$export$afc72e2116322959)(acc, Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $63af748d0fde9ea7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $63af748d0fde9ea7$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $63af748d0fde9ea7$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $63af748d0fde9ea7$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $63af748d0fde9ea7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $63af748d0fde9ea7$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $aaac53b849ab07d4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $aaac53b849ab07d4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = 'file-invalid-type';
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = 'file-too-large';
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = 'file-too-small';
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = 'too-many-files';
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
}; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === 'application/x-moz-file' || (0, $000a86df99a95c54$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === 'function') return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== 'undefined') return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === 'Files' || type === 'application/x-moz-file';
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf('Edge/') !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}


var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a24044586ed82795$var$ownKeys(Object(source), true).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function 
   * @param {File} file
   * @returns {FileError|FileError[]}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$options = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), options), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling, validator = _defaultProps$options.validator;
    var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: 'openDialog'
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: 'closeDialog'
                    });
                    if (typeof onFileDialogCancel === 'function') onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener('focus', onWindowFocus, false);
        return function() {
            window.removeEventListener('focus', onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: 'focus'
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: 'blur'
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener('dragover', (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener('drop', onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener('dragover', (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener('drop', onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: 'setDraggedFiles'
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = 'copy';
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: 'setDraggedFiles',
            draggedFiles: []
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var fileRejections = [];
            files.forEach(function(file) {
                var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, accept), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
                var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
                var customErrors = validator ? validator(file) : null;
                if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
                else {
                    var errors = [
                        acceptError,
                        sizeError
                    ];
                    if (customErrors) errors = errors.concat(customErrors);
                    fileRejections.push({
                        file: file,
                        errors: errors.filter(function(e) {
                            return e;
                        })
                    });
                }
            });
            if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
                // Reject everything and empty accepted files
                acceptedFiles.forEach(function(file) {
                    fileRejections.push({
                        file: file,
                        errors: [
                            (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                        ]
                    });
                });
                acceptedFiles.splice(0);
            }
            dispatch({
                acceptedFiles: acceptedFiles,
                fileRejections: fileRejections,
                type: 'setFiles'
            });
            if (onDrop) onDrop(acceptedFiles, fileRejections, event);
            if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: 'reset'
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        maxFiles,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling,
        validator
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: 'file',
                style: {
                    display: 'none'
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                autoComplete: 'off',
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple,
        maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case 'focus':
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case 'blur':
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case 'openDialog':
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: true
            });
        case 'closeDialog':
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case 'setDraggedFiles':
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case 'setFiles':
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case 'reset':
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $lmFrL = parcelRequire("lmFrL");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $38ac1a7b92ec1912$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = $acw62.useRef(value);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};



var $acw62 = parcelRequire("acw62");
var $7662f217721ef745$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    ref.current = value;
};
var $7662f217721ef745$var$useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, $acw62.useRef)();
    return (0, $acw62.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $7662f217721ef745$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $7662f217721ef745$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};
var $7662f217721ef745$export$2e2bcd8739ae039 = $7662f217721ef745$var$useComposedRef;


var $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE = {
    'min-height': '0',
    'max-height': 'none',
    height: '0',
    visibility: 'hidden',
    overflow: 'hidden',
    position: 'absolute',
    'z-index': '-1000',
    top: '0',
    right: '0'
};
var $8d208011843bf7ea$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE[key], 'important');
    });
};
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259
var $8d208011843bf7ea$var$hiddenTextarea = null;
var $8d208011843bf7ea$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
     // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $8d208011843bf7ea$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$8d208011843bf7ea$var$hiddenTextarea) {
        $8d208011843bf7ea$var$hiddenTextarea = document.createElement('textarea');
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute('tabindex', '-1');
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        $8d208011843bf7ea$var$forceHiddenStyles($8d208011843bf7ea$var$hiddenTextarea);
    }
    if ($8d208011843bf7ea$var$hiddenTextarea.parentNode === null) document.body.appendChild($8d208011843bf7ea$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $8d208011843bf7ea$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $8d208011843bf7ea$var$forceHiddenStyles($8d208011843bf7ea$var$hiddenTextarea);
    $8d208011843bf7ea$var$hiddenTextarea.value = value;
    var height = $8d208011843bf7ea$var$getHeight($8d208011843bf7ea$var$hiddenTextarea, sizingData); // measure height of a textarea with a single row
    $8d208011843bf7ea$var$hiddenTextarea.value = 'x';
    var rowHeight = $8d208011843bf7ea$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $8d208011843bf7ea$var$noop = function noop() {};
var $8d208011843bf7ea$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $8d208011843bf7ea$var$SIZING_STYLE = [
    'borderBottomWidth',
    'borderLeftWidth',
    'borderRightWidth',
    'borderTopWidth',
    'boxSizing',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'tabSize',
    'textIndent',
    'textRendering',
    'textTransform',
    'width',
    'wordBreak'
];
var $8d208011843bf7ea$var$isIE = !!document.documentElement.currentStyle;
var $8d208011843bf7ea$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $8d208011843bf7ea$var$pick($8d208011843bf7ea$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === '') return null;
     // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($8d208011843bf7ea$var$isIE && boxSizing === 'border-box') sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $8d208011843bf7ea$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    var latestListener = (0, $38ac1a7b92ec1912$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useLayoutEffect)(function() {
        var handler = function handler(event) {
            latestListener.current(event);
        };
        window.addEventListener('resize', handler);
        return function() {
            window.removeEventListener('resize', handler);
        };
    }, []);
};
var $8d208011843bf7ea$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onHeightChange, props = (0, $1En50.default)(_ref, [
        "cacheMeasurements",
        "maxRows",
        "minRows",
        "onChange",
        "onHeightChange"
    ]);
    var isControlled = props.value !== undefined;
    var libRef = (0, $acw62.useRef)(null);
    var ref = (0, $7662f217721ef745$export$2e2bcd8739ae039)(libRef, userRef);
    var heightRef = (0, $acw62.useRef)(0);
    var measurementsCacheRef = (0, $acw62.useRef)();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $8d208011843bf7ea$var$getSizingData(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $8d208011843bf7ea$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty('height', height + "px", 'important');
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    (0, $acw62.useLayoutEffect)(resizeTextarea);
    $8d208011843bf7ea$var$useWindowResizeListener(resizeTextarea);
    return /*#__PURE__*/ (0, $acw62.createElement)("textarea", (0, $8nd05.default)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $8d208011843bf7ea$var$index = /* #__PURE__ */ (0, $acw62.forwardRef)($8d208011843bf7ea$var$TextareaAutosize);
var $8d208011843bf7ea$export$2e2bcd8739ae039 = $8d208011843bf7ea$var$index;


const $449c75cb605e6723$export$b4047155ef57fca6 = (0, $lmFrL.default)((0, $8d208011843bf7ea$export$2e2bcd8739ae039))`
  width: 100%;
  min-height: 95px;
  font-size: ${(props)=>props.theme.fontSizes[2]};
  line-height: ${(props)=>props.theme.lineHeights[4]};
  resize: none;
  padding: 12px 16px;
  border: 1px solid ${(props)=>props.theme.newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 4px;

  :hover {
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.placeholder};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.hoveredState};
    outline: none;
  }

  :focus {
    border: 1px solid ${(props)=>props.theme.newColors.primary.basic};
    box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.activeState};
    outline: none;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }
  :-ms-input-placeholder {
    color: ${(props)=>props.theme.newColors.grayscale.placeholder};
  }

  ${(props)=>props.disabled && (0, $lmFrL.css)`
      border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.placeholder};
      background: ${({ theme: theme })=>theme.newColors.grayscale.disabled};
      box-shadow: none;
    `}

  ${(props)=>props.error && (0, $lmFrL.css)`
      border: 1px solid ${({ theme: theme })=>theme.newColors.extra.errorState};
      box-shadow: ${({ theme: theme })=>theme.shadows.userInputs.errorState};
    `}
`;


const $c7e0eaaa31601803$export$f5c9f3c2c4054eec = (props)=>{
    const { placeholder: placeholder, isDisabled: isDisabled, error: error, onChange: onChange, value: value, staticForm: staticForm, onlyForRead: onlyForRead, rows: rows } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c7e0eaaa31601803$var$InputContainer, null, staticForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c7e0eaaa31601803$var$StaticInput, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $449c75cb605e6723$export$b4047155ef57fca6), {
        placeholder: placeholder,
        disabled: isDisabled,
        error: error,
        onChange: onChange,
        value: value,
        maxRows: rows || 24,
        readOnly: onlyForRead || false
    }));
};
const $c7e0eaaa31601803$var$InputContainer = (0, $lmFrL.default).div`
  position: relative;
  width: 100%;
  display: flex;
`;
const $c7e0eaaa31601803$var$StaticInput = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: default;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $b7fb67a5d8f37b3a$export$ff379678d9de45e8 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 6C11.5128 6 11.9355 6.38604 11.9933 6.88338L12 7V9C12 10.5977 10.7511 11.9037 9.17627 11.9949L9 12H3C1.40232 12 0.0963391 10.7511 0.00509269 9.17627L0 9V7C0 6.44772 0.447715 6 1 6C1.51284 6 1.93551 6.38604 1.99327 6.88338L2 7V9C2 9.51284 2.38604 9.93551 2.88338 9.99327L3 10H9C9.51284 10 9.93551 9.61396 9.99327 9.11662L10 9V7C10 6.44772 10.4477 6 11 6ZM5.85153 0.0110178L5.90997 0.00399798L6 0L6.07524 0.00278786L6.20073 0.0202401L6.31214 0.0497381L6.42322 0.0936734L6.52071 0.145995L6.62545 0.219689L6.70711 0.292893L8.70711 2.29289C9.09763 2.68342 9.09763 3.31658 8.70711 3.70711C8.31658 4.09763 7.68342 4.09763 7.29289 3.70711L7 3.415V7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7V3.414L4.70711 3.70711C4.31658 4.09763 3.68342 4.09763 3.29289 3.70711C2.90237 3.31658 2.90237 2.68342 3.29289 2.29289L5.29289 0.292893C5.32829 0.257499 5.36567 0.225313 5.40469 0.196335L5.51594 0.124671L5.62866 0.0712255L5.73401 0.0358451L5.85153 0.0110178Z",
        fill: color
    }));
};
$b7fb67a5d8f37b3a$export$ff379678d9de45e8.defaultProps = {
    width: "12",
    height: "12",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};




const $e464d85de0bbd46d$var$DivWithDropZone = (0, $lmFrL.default).div`
  border: 1px dashed
    ${(props)=>props.dragActive ? props.theme.newColors.secondary.darkTint : props.theme.newColors.secondary.basic};
  box-sizing: border-box;
  background: ${(props)=>props.dragActive ? props.theme.newColors.secondary.lightTint : props.theme.newColors.secondary.lightestTint};
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: ${(props)=>props.theme.fontSizes[0]};
  line-height: ${(props)=>props.theme.fontSizes[2]};
  text-align: center;
  padding: 16px;
  position: relative;
  opacity: ${(props)=>props.disabled ? 0.5 : 1};
  cursor: ${(props)=>props.disabled ? "not-allowed" : "pointer"};

  ${({ horizontally: horizontally })=>horizontally && (0, $lmFrL.css)`
      display: flex;
      padding-left: 0.5rem;
      width: 100%;
      position: relative;
    `}
`;
const $e464d85de0bbd46d$var$SelectFileButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin: auto;

  &[disabled] {
    cursor: not-allowed;
  }
`;
const $e464d85de0bbd46d$var$DivForText = (0, $lmFrL.default).div`
  margin-top: 8px;
  letter-spacing: -0.01em;
  color: ${(props)=>props.theme.newColors.grayscale.primaryGray};

  ${({ horizontally: horizontally })=>horizontally && (0, $lmFrL.css)`
      padding-left: 8px;
    `}
`;
const $e464d85de0bbd46d$var$StaticInput = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
  top: 0;
  left: 0;
  z-index: 1;
`;
const $e464d85de0bbd46d$export$6c8108ad15125580 = (props)=>{
    const { rootProps: rootProps, inputProps: inputProps, open: open, horizontally: horizontally, staticForm: staticForm, disabled: disabled } = props;
    const { isDragAccept: isDragAccept } = rootProps;
    const handleOpen = disabled ? ()=>{} : open;
    const rootPropsToUse = disabled ? {
        ...rootProps,
        onClick: ()=>{}
    } : rootProps;
    return /*#__PURE__*/ $acw62.createElement($e464d85de0bbd46d$var$DivWithDropZone, {
        dragActive: isDragAccept,
        horizontally: horizontally,
        disabled: disabled,
        ...rootPropsToUse
    }, /*#__PURE__*/ $acw62.createElement($e464d85de0bbd46d$var$SelectFileButton, {
        type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
        label: "Select files",
        icon: /*#__PURE__*/ $acw62.createElement((0, $b7fb67a5d8f37b3a$export$ff379678d9de45e8), null),
        onClick: handleOpen,
        disabled: disabled
    }), /*#__PURE__*/ $acw62.createElement("input", inputProps), /*#__PURE__*/ $acw62.createElement($e464d85de0bbd46d$var$DivForText, {
        horizontally: horizontally
    }, "or drop files here"), (staticForm || disabled) && /*#__PURE__*/ $acw62.createElement($e464d85de0bbd46d$var$StaticInput, null));
};
$e464d85de0bbd46d$export$6c8108ad15125580.defaultProps = {
    horizontally: false
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $0fc800146dc7eed0$var$Root = (0, $lmFrL.default).div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: absolute;

  &::before {
    content: "";
    border-radius: 100%;
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.tertiaryGray};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
    }
  }

  ${(props)=>props.checked && (0, $lmFrL.css)`
      &::before {
        background: ${({ theme: theme })=>theme.newColors.primary.basic};
        border: none;
      }
    `}

  &:hover {
    &::before {
      background: ${({ theme: theme })=>theme.newColors.grayscale.background};
      border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
    }
  }
`;
const $0fc800146dc7eed0$var$Fill = (0, $lmFrL.default).div`
  background: ${(props)=>props.theme.newColors.grayscale.white};
  width: 0;
  height: 0;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.2s ease-in, height 0.2s ease-in;
  pointer-events: none;
  z-index: 1;

  &::before {
    content: "";
    opacity: 0;
    width: 12px;
    position: absolute;
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.primaryGray}
    border-radius: 100%;
  }
`;
const $0fc800146dc7eed0$var$Container = (0, $lmFrL.default).div`
  position: relative;
  height: 48px;
  padding: 12px 16px;
  background: ${({ checked: checked, theme: theme })=>checked ? theme.newColors.primary.lightestTint : theme.newColors.grayscale.white};

  box-shadow: ${({ checked: checked, theme: theme })=>checked ? theme.shadows.userInputs.activeState : theme.shadows.userInputs.basicInside};
  border-radius: 4px;
  border: 1px solid
    ${({ checked: checked, theme: theme })=>checked ? theme.newColors.primary.basic : theme.newColors.grayscale.bordersInside};
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    border-color: ${({ checked: checked, theme: theme })=>!checked && theme.newColors.grayscale.placeholder};

    box-shadow: ${({ checked: checked, theme: theme })=>!checked && theme.shadows.userInputs.hoveredState};

    & > ${$0fc800146dc7eed0$var$Root} {
      &::before {
        background: ${({ theme: theme })=>theme.newColors.grayscale.background};
        border: 1px solid
          ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
      }
    }

    ${$0fc800146dc7eed0$var$Fill} {
      background: ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
      width: 8px;
      height: 8px;
      transition: width 0.2s ease-out, height 0.2s ease-out;
      z-index: 0;

      &::before {
        opacity: 1;
        transition: opacity 1s ease;
      }
    }
  }
`;
const $0fc800146dc7eed0$var$Input = (0, $lmFrL.default).input`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:checked {
    & ~ ${$0fc800146dc7eed0$var$Fill} {
      width: 8px;
      height: 8px;
      transition: width 0.2s ease-out, height 0.2s ease-out;
      z-index: 0;

      &::before {
        opacity: 1;
        transition: opacity 1s ease;
      }
    }
  }
`;
const $0fc800146dc7eed0$var$LabelText = (0, $lmFrL.default).label`
  margin-left: 41px;
  font-size: ${(props)=>props.theme.fontSizes[2]};
  line-height: ${(props)=>props.theme.lineHeights[4]};
  white-space: nowrap;
  cursor: pointer;
  color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
  user-select: none;

  letter-spacing: -0.01em;

  ${({ disabled: disabled, theme: theme })=>disabled && (0, $lmFrL.css)`
      color: ${theme.newColors.grayscale.placeholder};
    `}
`;
const $0fc800146dc7eed0$var$TipContainer = (0, $lmFrL.default).div`
  margin-top: 8px;
`;
const $0fc800146dc7eed0$var$MainContainer = (0, $lmFrL.default).div`
  flex: 1;
`;
const $0fc800146dc7eed0$export$f4422ae58352e179 = (props)=>{
    const { onChange: onChange, value: value, labelText: labelText, checked: checked, name: name, tip: tip } = props;
    return /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$MainContainer, null, /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$Container, {
        checked: checked,
        onClick: onChange
    }, /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$Root, {
        checked: checked
    }, /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$Input, {
        id: value,
        type: "radio",
        onChange: onChange,
        name: name,
        value: value,
        checked: checked,
        "aria-checked": checked
    }), /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$Fill, null)), /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$LabelText, {
        htmlFor: value
    }, labelText)), tip && tip !== "" && /*#__PURE__*/ $acw62.createElement($0fc800146dc7eed0$var$TipContainer, null, /*#__PURE__*/ $acw62.createElement((0, $d2e03a45ef627067$export$c92c6401b52a9298), {
        message: tip,
        color: "black"
    })));
};


const $d19f8a0606798fa7$var$Container = (0, $lmFrL.default).div`
  flex: 1;
  display: flex;
  max-width: 625px;

  & > div:not(:last-child) {
    margin-right: 16px;
  }
`;
const $d19f8a0606798fa7$export$a98f0dcb43a68a25 = (props)=>{
    const { name: name, selectedValue: selectedValue, onClickRadioButton: onClickRadioButton, options: options } = props;
    return /*#__PURE__*/ $acw62.createElement($d19f8a0606798fa7$var$Container, null, options.map((option)=>{
        return /*#__PURE__*/ $acw62.createElement((0, $0fc800146dc7eed0$export$f4422ae58352e179), {
            key: option.value,
            labelText: option.labelText,
            value: option.value,
            tip: option.tip,
            checked: selectedValue === option.value,
            onChange: ()=>onClickRadioButton(option.value),
            name: name,
            disabled: option.disabled
        });
    }));
};



const $08268787b704fc5c$export$61220de1105bad54 = ()=>{
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept, open: open } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        noClick: true,
        noKeyboard: true
    });
    return [
        {
            id: "TextField",
            label: "Text Field",
            createComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
                    placeholder: "Text Field...",
                    staticForm: true,
                    onChange: ()=>{}
                })
        },
        {
            id: "TextArea",
            label: "Long Text Field",
            createComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c7e0eaaa31601803$export$f5c9f3c2c4054eec), {
                    placeholder: "Long Text Field...",
                    value: "",
                    staticForm: true,
                    onChange: ()=>{}
                })
        },
        {
            id: "File",
            label: "Drop Zone",
            createComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e464d85de0bbd46d$export$6c8108ad15125580), {
                    rootProps: getRootProps({
                        isDragAccept: isDragAccept
                    }),
                    inputProps: getInputProps(),
                    open: open,
                    horizontally: true,
                    staticForm: true
                })
        },
        {
            id: "Number",
            label: "Number Field",
            createComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
                    placeholder: "0",
                    type: "Number",
                    staticForm: true,
                    onChange: ()=>{}
                })
        },
        {
            id: "OneOfMany",
            label: "One of many",
            editMode: true,
            createComponent: (question)=>{
                if (question && question.choices) {
                    if (question.choices.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", null, "Answers not specified! Go to the edit mode on the right");
                    if (question.choices.length > 2) {
                        const options = question.choices.map((choice)=>({
                                value: choice,
                                label: choice
                            }));
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                flexGrow: 1
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
                            options: options
                        }));
                    }
                    const options = question.choices.map((choice)=>({
                            value: choice,
                            labelText: choice
                        }));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d19f8a0606798fa7$export$a98f0dcb43a68a25), {
                        selectedValue: "",
                        onClickRadioButton: ()=>{},
                        options: options
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d19f8a0606798fa7$export$a98f0dcb43a68a25), {
                    selectedValue: "",
                    onClickRadioButton: ()=>{},
                    options: [
                        {
                            value: "One of many",
                            labelText: "One of many"
                        }
                    ]
                });
            }
        },
        {
            id: "Links",
            label: "External links",
            createComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
                    placeholder: "Links field...",
                    staticForm: true,
                    onChange: ()=>{}
                })
        }
    ];
};


const $3c9e0dbc85b3117a$var$getDraggingQuestionClone = (formQuestions)=>(provided, _snapshot, rubric)=>{
        const formQuestion = formQuestions[rubric.source.index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$DraggableFormElementContainer, {
            ...provided.draggableProps,
            ref: provided.innerRef,
            style: provided.draggableProps.style,
            key: formQuestion.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$FormElementContainer, {
            clone: true
        }, formQuestion.createComponent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$DragIconContainer, provided.dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null))));
    };
const $3c9e0dbc85b3117a$export$f25fb485e76e4528 = ()=>{
    const formQuestions = (0, $08268787b704fc5c$export$61220de1105bad54)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$Title, null, "Add new question:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        renderClone: $3c9e0dbc85b3117a$var$getDraggingQuestionClone(formQuestions),
        droppableId: "FormQuestions",
        isDropDisabled: true
    }, (droppableProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$FormContainer, {
            ref: droppableProvided.innerRef
        }, formQuestions.map((item, index)=>{
            const renderClone = item.id === snapshot.draggingFromThisWith;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: item.id
            }, renderClone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9f035b2006f43014$export$56caa13a0392587b), {
                key: item.id
            }, item.createComponent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$f2a139e5d18b9882), {
                draggableId: item.id,
                index: index,
                key: item.id
            }, (draggableProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$DraggableFormElementContainer, {
                    ref: draggableProvided.innerRef,
                    ...draggableProvided.draggableProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$FormElementContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$FormComponentContainer, null, item.createComponent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c9e0dbc85b3117a$var$DragIconContainer, draggableProvided.dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null))))));
        }), droppableProvided.placeholder)));
};
const $3c9e0dbc85b3117a$var$Title = (0, $lmFrL.default).div`
  margin: 0 1rem;
  color: ${(props)=>props.theme.newColors.primary.basic};
  font-size: 0.8rem;
`;
const $3c9e0dbc85b3117a$var$FormContainer = (0, $lmFrL.default).div`
  padding: 0 1rem;
`;
const $3c9e0dbc85b3117a$var$DraggableFormElementContainer = (0, $lmFrL.default).div``;
const $3c9e0dbc85b3117a$var$FormElementContainer = (0, $lmFrL.default).div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  border-bottom: ${(props)=>props.clone ? "none" : `1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside}`};
`;
const $3c9e0dbc85b3117a$var$FormComponentContainer = (0, $lmFrL.default).div`
  max-width: 100%;
  flex-grow: 1;
`;
const $3c9e0dbc85b3117a$var$DragIconContainer = (0, $lmFrL.default).div`
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
`;





const $d0471eeaee1ef6e7$export$59334a79843bd6ac = ()=>{
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity || selectedEntity.selectedElementType !== (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    const [questionGroupName, setQuestionGroupName] = $acw62.useState(selectedEntity.selectedElementPath.questionGroupName);
    const [updateQuestionGroupFromSample] = (0, $7608a8bbcbbad14c$export$92e597b1419ac8a5)();
    const handleNameChange = (e)=>{
        setQuestionGroupName(e.target.textContent || "");
    };
    const handleNameOnBlur = (e)=>{
        if (!e.target.textContent) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You must enter a group name.");
            return;
        }
        if (e.target.textContent === questionGroupName) return;
        const { projectId: projectId, sampleId: sampleId, questionGroupId: questionGroupId, fromReport: fromReport, workflowId: workflowId, serviceId: serviceId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    fromReport: fromReport,
                    workflowId: workflowId,
                    serviceId: serviceId
                },
                questionGroupUpdatables: {
                    id: questionGroupId,
                    name: e.target.textContent
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateQuestionGroupFromSample"];
                const existingQueryResult = (0, $f1q41.cloneDeep)(cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"]);
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = samples.find((s)=>s.id === sampleId);
                    if (foundSample) {
                        let questionGroups;
                        if (fromReport && workflowId && serviceId) questionGroups = foundSample.enabledWorkflows.find((wf)=>wf.id === workflowId)?.services.find((s)=>s.id === serviceId)?.report?.selectedQuestionGroups;
                        else questionGroups = foundSample.selectedQuestionGroups;
                        if (questionGroups) {
                            const questionGroupIndex = questionGroups.findIndex((qg)=>qg.id === questionGroupId);
                            if (questionGroupIndex !== -1) {
                                questionGroups[questionGroupIndex] = incomingData;
                                const sampleIndex = samples.findIndex((s)=>s.id === sampleId);
                                samples[sampleIndex] = {
                                    ...foundSample
                                };
                                existingQueryResult.samples = samples;
                                cache.writeQuery({
                                    variables: {
                                        id: projectId
                                    },
                                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                    data: {
                                        Project: {
                                            ...existingQueryResult
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            }
        };
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                questionGroupName: e.target.textContent
            }
        });
        updateQuestionGroupFromSample(options);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($d0471eeaee1ef6e7$var$StyledTextFieldAutoHight, {
        title: "Change section title:",
        value: questionGroupName || "",
        onChange: handleNameChange,
        onBlur: handleNameOnBlur
    }), /*#__PURE__*/ $acw62.createElement((0, $3c9e0dbc85b3117a$export$f25fb485e76e4528), null));
};
const $d0471eeaee1ef6e7$var$StyledTextFieldAutoHight = (0, $lmFrL.default)((0, $34138cd79f9cdb64$export$55a73bc3d4b275e4))`
  & > div {
    margin-bottom: 16px;
  }
`;



var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");



/* eslint-disable react/no-array-index-key */ 
var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $e0c315f98e3d49f4$export$ba80d8b8f784dce2 = (props)=>{
    const { id: id, value: value, onChange: onChange, onBlur: onBlur, onDelete: onDelete, testId: testId } = props;
    const onBlurEvent = (input)=>{
        if (input.target.value.length > 0) onBlur(input.target.value);
        else onDelete(id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0c315f98e3d49f4$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: `Answer number ${id + 1}`,
        value: value,
        onChange: (input)=>onChange(input.target.value),
        onBlur: onBlurEvent,
        testId: `${testId}_input`
    }), value.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0c315f98e3d49f4$var$Button, {
        onClick: ()=>onDelete(id),
        style: {
            cursor: "pointer"
        },
        "data-testid": `${testId}_deleteButton`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null)) : null);
};
const $e0c315f98e3d49f4$var$Container = (0, $lmFrL.default).div`
  display: flex;
`;
const $e0c315f98e3d49f4$var$Button = (0, $lmFrL.default).div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.userInputs.basicInside};
  border-radius: 4px;
  margin-left: 16px;
`;




var $acw62 = parcelRequire("acw62");

const $af15d86567b97244$export$f21ab0717a89c77f = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 1.5C5.58579 1.5 5.25 1.83579 5.25 2.25V5.25H2.25C1.83579 5.25 1.5 5.58579 1.5 6C1.5 6.41421 1.83579 6.75 2.25 6.75H5.25V9.75C5.25 10.1642 5.58579 10.5 6 10.5C6.41421 10.5 6.75 10.1642 6.75 9.75V6.75H9.75C10.1642 6.75 10.5 6.41421 10.5 6C10.5 5.58579 10.1642 5.25 9.75 5.25H6.75V2.25C6.75 1.83579 6.41421 1.5 6 1.5Z",
        fill: color
    }));
};
$af15d86567b97244$export$f21ab0717a89c77f.defaultProps = {
    width: "12",
    height: "12",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};


const $6e0dab73a4fa814f$export$e5b90ba70e8f1c5d = (props)=>{
    const { title: title, onUpdateFinishCallback: onUpdateFinishCallback, answerValues: answerValues } = props;
    const [answers, setAnswers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(answerValues);
    const updateAnswerList = (list)=>{
        if (onUpdateFinishCallback) onUpdateFinishCallback(list);
    };
    const updateAnswer = (id, value)=>{
        const answersArray = [
            ...answers
        ];
        answersArray[id] = value;
        setAnswers(answersArray);
    };
    const deleteAnswer = (id)=>{
        const answersArray = [
            ...answers
        ];
        answersArray.splice(id, 1);
        setAnswers(answersArray);
        updateAnswerList(answersArray);
    };
    const addAnswer = ()=>{
        const answersArray = [
            ...answers
        ];
        answersArray.push("");
        setAnswers(answersArray);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e0dab73a4fa814f$var$Container, null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e0dab73a4fa814f$var$Title, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e0dab73a4fa814f$var$AnswerListElementContainer, null, answers.map((answer, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0c315f98e3d49f4$export$ba80d8b8f784dce2), {
            key: `answerList${index}`,
            testId: "answerListElement",
            id: index,
            value: answer,
            onChange: (answerValue)=>updateAnswer(index, answerValue),
            onBlur: ()=>updateAnswerList(answers),
            onDelete: (answerId)=>deleteAnswer(answerId)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e0dab73a4fa814f$var$AddAnswerContainer, {
        onClick: addAnswer,
        "data-testid": "answerList_addButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af15d86567b97244$export$f21ab0717a89c77f), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }), "ADD ANSWER"));
};
$6e0dab73a4fa814f$export$e5b90ba70e8f1c5d.defaultProps = {
    onUpdateFinishCallback: ()=>{},
    answerValues: []
};
const $6e0dab73a4fa814f$var$Container = (0, $lmFrL.default).div`
  margin: 16px;
`;
const $6e0dab73a4fa814f$var$Title = (0, $lmFrL.default).div`
  margin-bottom: 0.5rem;
  color: ${(props)=>props.theme.newColors.primary.basic};
  font-size: 0.8rem;
`;
const $6e0dab73a4fa814f$var$AnswerListElementContainer = (0, $lmFrL.default).div`
  > div {
    margin-bottom: 8px;
  }
`;
const $6e0dab73a4fa814f$var$AddAnswerContainer = (0, $lmFrL.default).div`
  margin-top: 15px;
  margin-left: 10px;
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 180px;

  svg {
    margin-right: 10px;
    transform: scale(1.5);
  }
`;


const $f17f2888f1e79d54$export$fd7ca5615f137815 = ()=>{
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity || selectedEntity.selectedElementType !== (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    const [answers, setAnswers] = $acw62.useState(selectedEntity.selectedElementPath.questionChoices);
    const [updateQuestionInQuestionGroupFromSample] = (0, $7608a8bbcbbad14c$export$2135cdf0f1a972ba)();
    const useQuestionMutation = (destination, value)=>{
        const { projectId: projectId, sampleId: sampleId, questionId: questionId, questionSetId: questionSetId, questionGroupId: questionGroupId, fromReport: fromReport, workflowId: workflowId, serviceId: serviceId } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                questionInput: {
                    questionId: questionId,
                    questionSetId: questionSetId,
                    questionGroupId: questionGroupId,
                    fromReport: fromReport,
                    workflowId: workflowId,
                    serviceId: serviceId
                },
                questionUpdatables: {
                    id: questionId,
                    [destination]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateQuestionInQuestionGroupFromSample"];
                const existingQueryResult = (0, $f1q41.cloneDeep)(cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"]);
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = samples.find((s)=>s.id === sampleId);
                    if (foundSample) {
                        const questionGroupIndex = foundSample.selectedQuestionGroups.findIndex((qg)=>qg.id === questionGroupId);
                        if (questionGroupIndex !== -1) {
                            const questionSetIndex = foundSample.selectedQuestionGroups[questionGroupIndex].questionSets.findIndex((qs)=>qs.id === questionSetId);
                            if (questionSetIndex !== -1) {
                                const questionIndex = foundSample.selectedQuestionGroups[questionGroupIndex].questionSets[questionSetIndex].questions.findIndex((q)=>q.id === questionId);
                                if (questionIndex !== -1) {
                                    foundSample.selectedQuestionGroups[questionGroupIndex].questionSets[questionSetIndex].questions[questionIndex] = incomingData;
                                    const sampleIndex = samples.findIndex((s)=>s.id === sampleId);
                                    samples[sampleIndex] = {
                                        ...foundSample
                                    };
                                    existingQueryResult.samples = [
                                        ...samples
                                    ];
                                    cache.writeQuery({
                                        variables: {
                                            id: projectId
                                        },
                                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                        data: {
                                            Project: {
                                                ...existingQueryResult
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            }
        };
        updateQuestionInQuestionGroupFromSample(options);
    };
    const handleOnAnswersChange = (values)=>{
        setAnswers(values);
        useQuestionMutation("choices", values);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $6e0dab73a4fa814f$export$e5b90ba70e8f1c5d), {
        title: "Answers: ",
        answerValues: answers,
        onUpdateFinishCallback: handleOnAnswersChange
    }));
};


const $2cb268602699e484$export$543ec51f2d9ac69a = ()=>{
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    switch(selectedEntity?.selectedElementType){
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION:
            return /*#__PURE__*/ $acw62.createElement((0, $4ef5e8aede5b8ad7$export$93613990e3f30616), null);
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY:
            return /*#__PURE__*/ $acw62.createElement((0, $f17f2888f1e79d54$export$fd7ca5615f137815), null);
        case (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP:
            return /*#__PURE__*/ $acw62.createElement((0, $d0471eeaee1ef6e7$export$59334a79843bd6ac), null);
        default:
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    }
};


const $c3ddc2046751dfe0$export$c7af6722a1a50f6c = ({ children: children, pageTitle: pageTitle = "Welcome", tabs: tabs, dropdownData: dropdownData, selectedDropdownDataId: selectedDropdownDataId, onDataClick: onDataClick, fixedSideDrawboard: fixedSideDrawboard = true })=>{
    const { sideBarOpen: sideBarOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    return /*#__PURE__*/ $acw62.createElement($c3ddc2046751dfe0$var$Wrapper, null, /*#__PURE__*/ $acw62.createElement((0, $893bf6ab15cfafd6$export$614264b7ca4804e6), null), /*#__PURE__*/ $acw62.createElement($c3ddc2046751dfe0$var$Main, {
        isSideBarOpen: sideBarOpen
    }, /*#__PURE__*/ $acw62.createElement((0, $193714fcc8f30367$export$8b251419efc915eb), {
        pageTitle: pageTitle
    }), /*#__PURE__*/ $acw62.createElement($c3ddc2046751dfe0$var$NavWrapper, null, tabs && /*#__PURE__*/ $acw62.createElement($c3ddc2046751dfe0$var$NavigationTabs, null, tabs)), /*#__PURE__*/ $acw62.createElement($c3ddc2046751dfe0$var$Content, null, /*#__PURE__*/ $acw62.createElement((0, $0ae05e0bf2c3dc8f$export$844f199b4427ce36), null, children))), /*#__PURE__*/ $acw62.createElement((0, $9b46390a7c7d7753$export$7280240986cdf65a), {
        dropdownData: dropdownData,
        selectedDropdownDataId: selectedDropdownDataId,
        onDataClick: onDataClick,
        numberOfExistingWorkflows: 0,
        fixedViewMode: fixedSideDrawboard
    }, /*#__PURE__*/ $acw62.createElement((0, $2cb268602699e484$export$543ec51f2d9ac69a), null)));
};
const $c3ddc2046751dfe0$var$Wrapper = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  min-height: 100vh;
`;
const $c3ddc2046751dfe0$var$NavWrapper = (0, $lmFrL.default).div`
  min-height: 36px;
  width: 100%;
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $c3ddc2046751dfe0$var$NavigationTabs = (0, $lmFrL.default).div`
  margin: 0 auto;
  width: 100%;
  max-width: ${(p)=>p.theme.maxContentWidth};
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $c3ddc2046751dfe0$var$Main = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: ${({ isSideBarOpen: isSideBarOpen })=>isSideBarOpen ? "calc(100% - 184px - 72px);" : "calc(100% - 72px - 72px);"};
  flex-direction: column;
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;
const $c3ddc2046751dfe0$var$Content = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $394e973b6ab0086c$export$3e41faf802a29e71 = (props)=>{
    const { isActive: isActive, label: label, onClick: onClick, status: status } = props;
    return /*#__PURE__*/ $acw62.createElement($394e973b6ab0086c$var$Container, {
        onClick: onClick,
        isActive: isActive
    }, /*#__PURE__*/ $acw62.createElement($394e973b6ab0086c$var$Content, null, /*#__PURE__*/ $acw62.createElement($394e973b6ab0086c$var$Statuses, null, status !== undefined ? (0, $2d7ecd00adce73e7$export$c742923ea4ac4c1c)(status) : ""), /*#__PURE__*/ $acw62.createElement($394e973b6ab0086c$var$Label, null, label)));
};
$394e973b6ab0086c$export$3e41faf802a29e71.defaultProps = {
    label: "Project data",
    isActive: false,
    status: undefined
};
const $394e973b6ab0086c$var$Container = (0, $lmFrL.default).div`
  width: auto;
  display: inline-block;
  height: 36px;
  background: ${(props)=>props.isActive ? props.theme.newColors.grayscale.background : "none"};
  border-radius: 4px 4px 0 0;
  font-weight: ${(props)=>props.isActive ? "800" : "normal"};
  cursor: pointer;

  :hover {
    background: ${({ theme: theme })=>theme.newColors.grayscale.background};
    border-radius: 4px 4px 0px 0px;
  }
`;
const $394e973b6ab0086c$var$Content = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
`;
const $394e973b6ab0086c$var$Statuses = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 8px;
  }
`;
const $394e973b6ab0086c$var$Label = (0, $lmFrL.default).div`
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  color: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
  white-space: nowrap;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $9b6aca80bc34b520$var$SVGWrapper = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -1px;
`;
const $9b6aca80bc34b520$export$54a4dff1172315ec = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($9b6aca80bc34b520$var$SVGWrapper, null, /*#__PURE__*/ $acw62.createElement("svg", {
        width: "1",
        height: "20",
        viewBox: "0 0 1 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: "1",
        height: "20",
        fill: "#e8eaee"
    })));
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $6557f22f27937ff5$export$1702a4aba12fb1da = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($6557f22f27937ff5$var$Container, {
        onClick: props.onClick
    }, /*#__PURE__*/ $acw62.createElement($6557f22f27937ff5$var$AddIcon, null), " ", /*#__PURE__*/ $acw62.createElement($6557f22f27937ff5$var$Label, null, "Add new path"));
};
const $6557f22f27937ff5$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  user-select: none;

  :hover {
    font-weight: 800;
  }
`;
const $6557f22f27937ff5$var$Label = (0, $lmFrL.default).div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme: theme })=>theme.newColors.primary.basic};
  margin-left: 8px;
  min-width: 110px;
`;
const $6557f22f27937ff5$var$AddIcon = ()=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8888 6.6665H11.111V11.1108H6.6665V12.8886H11.111V17.3332H12.8888V12.8886H17.3332V11.1108H12.8888V6.6665Z",
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }));
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

const $d945cd3a6a8a9c23$export$54b0956b7b71071d = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 10 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m8.97211,17.91681c-0.25402,0 -0.50804,-0.09732 -0.70153,-0.29097l-7.93807,-7.94472c-0.38802,-0.3883 -0.38802,-1.01593 0,-1.40422l7.93807,-7.94468c0.38797,-0.3883 1.01508,-0.3883 1.40305,0c0.38797,0.3883 0.38797,1.01593 0,1.40422l-7.23655,7.24257l7.23655,7.24261c0.38797,0.3883 0.38797,1.01593 0,1.40422c-0.19349,0.19365 -0.44751,0.29097 -0.70153,0.29097l0.00001,0z",
        fill: color
    }));
};
$d945cd3a6a8a9c23$export$54b0956b7b71071d.defaultProps = {
    width: "10",
    height: "18",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightGreen
};




var $acw62 = parcelRequire("acw62");

const $dcffcd0a998792f2$export$10ff764a0e9ffbb8 = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 10 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.99975 17.9998C1.25575 17.9998 1.51175 17.9018 1.70675 17.7068L9.70675 9.70676C10.0978 9.31576 10.0978 8.68376 9.70675 8.29276L1.70675 0.292762C1.31575 -0.0982383 0.68375 -0.0982383 0.29275 0.292762C-0.0982494 0.683762 -0.0982494 1.31576 0.29275 1.70676L7.58575 8.99976L0.29275 16.2928C-0.0982494 16.6838 -0.0982494 17.3158 0.29275 17.7068C0.48775 17.9018 0.743751 17.9998 0.99975 17.9998Z",
        fill: color
    }));
};
$dcffcd0a998792f2$export$10ff764a0e9ffbb8.defaultProps = {
    width: "10",
    height: "18",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
};


let $dde185f9092af2d2$var$interval;
const $dde185f9092af2d2$export$2d7b9c7ef4a07c5 = (element, direction, speed, step)=>{
    const elem = element;
    $dde185f9092af2d2$var$interval = window.setInterval(()=>{
        if (direction === "left") elem.scrollLeft -= step;
        else elem.scrollLeft += step;
    }, speed);
};
const $dde185f9092af2d2$export$45af555e0d0f2cef = ()=>{
    if ($dde185f9092af2d2$var$interval) window.clearInterval($dde185f9092af2d2$var$interval);
};


const $9ae14ced62adca0f$export$9778a85352188e27 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { children: children, tabs: tabs } = props;
    const scrollableRef = ref;
    const isScrollVisible = ()=>{
        return scrollableRef && scrollableRef.current && scrollableRef.current.scrollWidth - scrollableRef.current.clientWidth > 1;
    };
    const [scrollVisible, setScrollVisible] = (0, $acw62.useState)(isScrollVisible());
    (0, $acw62.useEffect)(()=>{
        const visible = isScrollVisible();
        setScrollVisible(visible);
    }, [
        tabs
    ]);
    (0, $acw62.useEffect)(()=>{
        const debounceHandleResize = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(()=>{
            setScrollVisible(isScrollVisible());
        }, 700);
        window.addEventListener("resize", debounceHandleResize);
        return ()=>window.removeEventListener("resize", debounceHandleResize);
    });
    const onMouseDown = (direction)=>{
        if (scrollableRef && scrollableRef.current) (0, $dde185f9092af2d2$export$2d7b9c7ef4a07c5)(scrollableRef.current, direction, 50, 25);
    };
    const onMouseUp = ()=>{
        (0, $dde185f9092af2d2$export$45af555e0d0f2cef)();
    };
    return /*#__PURE__*/ $acw62.createElement($9ae14ced62adca0f$var$Scrollable, {
        ref: scrollableRef
    }, scrollVisible && /*#__PURE__*/ $acw62.createElement($9ae14ced62adca0f$var$ScrollLeftBtn, {
        onMouseDown: ()=>onMouseDown("left"),
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ $acw62.createElement((0, $d945cd3a6a8a9c23$export$54b0956b7b71071d), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
    })), children, scrollVisible && /*#__PURE__*/ $acw62.createElement($9ae14ced62adca0f$var$ScrollRightBtn, {
        onMouseDown: ()=>onMouseDown("right"),
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ $acw62.createElement((0, $dcffcd0a998792f2$export$10ff764a0e9ffbb8), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
    })));
});
const $9ae14ced62adca0f$var$ScrollButton = (0, $lmFrL.default).div`
  position: sticky;
  justify-content: center;
  align-items: center;
  height: 36px;
  display: flex;
  z-index: 10;
  cursor: pointer;
  min-width: 20px;
  border-radius: 4px 4px 0 0;
  background-color: ${({ theme: theme })=>theme.newColors.grayscale.background};

  :hover {
    opacity: 100%;
    background-color: ${({ theme: theme })=>theme.newColors.grayscale.placeholder};
  }
`;
const $9ae14ced62adca0f$var$ScrollLeftBtn = (0, $lmFrL.default)($9ae14ced62adca0f$var$ScrollButton)`
  left: 0;
`;
const $9ae14ced62adca0f$var$ScrollRightBtn = (0, $lmFrL.default)($9ae14ced62adca0f$var$ScrollButton)`
  right: -1px;
`;
const $9ae14ced62adca0f$var$Scrollable = (0, $lmFrL.default).div`
  position: relative;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
`;



var $acw62 = parcelRequire("acw62");
const $d23d5a953e17e309$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};


const $37c3cbd3d47c5d4a$var$Container = (0, $lmFrL.default).div`
  display: flex;
  padding: 0 ${(p)=>p.theme.space[3]};
`;
const $37c3cbd3d47c5d4a$export$b2539bed5023c21c = (props)=>{
    const { tabs: tabs, onTabClick: onTabClick, activeTab: activeTab, onNewTabClick: onNewTabClick, hideNewButton: hideNewButton } = props;
    const activeTabRef = (0, $acw62.useRef)(null);
    const scrollableRef = (0, $acw62.useRef)(null);
    const prevTabsCount = (0, $d23d5a953e17e309$export$5cae361ad82dce8b)(tabs.length);
    (0, $acw62.useEffect)(()=>{
        if (activeTabRef.current && scrollableRef && scrollableRef.current) {
            activeTabRef.current.scrollIntoView({
                block: "end",
                behavior: "auto"
            });
            scrollableRef.current.scrollLeft += 50;
        }
    }, [
        activeTab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prevTabsCount && prevTabsCount !== tabs.length && scrollableRef && scrollableRef.current) scrollableRef.current.scrollLeft = scrollableRef.current.scrollWidth;
    }, [
        tabs
    ]);
    return /*#__PURE__*/ $acw62.createElement($37c3cbd3d47c5d4a$var$Container, null, /*#__PURE__*/ $acw62.createElement((0, $9ae14ced62adca0f$export$9778a85352188e27), {
        ref: scrollableRef,
        tabs: tabs
    }, tabs.map(({ id: id, label: label, status: status }, index)=>{
        const lastOne = index === tabs.length - 1;
        const isActive = activeTab === id;
        return /*#__PURE__*/ $acw62.createElement($37c3cbd3d47c5d4a$var$TabContainer, {
            ref: isActive ? activeTabRef : null,
            key: label + id
        }, /*#__PURE__*/ $acw62.createElement((0, $394e973b6ab0086c$export$3e41faf802a29e71), {
            onClick: ()=>onTabClick(id),
            label: label,
            isActive: isActive,
            lastOne: lastOne,
            status: status
        }), !isActive && /*#__PURE__*/ $acw62.createElement((0, $9b6aca80bc34b520$export$54a4dff1172315ec), null));
    })), !hideNewButton && /*#__PURE__*/ $acw62.createElement((0, $6557f22f27937ff5$export$1702a4aba12fb1da), {
        onClick: onNewTabClick
    }));
};
const $37c3cbd3d47c5d4a$var$TabContainer = (0, $lmFrL.default).div`
  display: flex;
`;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");
const $e6703e6014d8edb3$export$51e90905745eccda = ({ title: title, stepNumber: stepNumber = 1, children: children, wrapped: wrapped = false, stepIcon: stepIcon, buttons: buttons, propertyValue: propertyValue, wrapCardsCallback: wrapCardsCallback, fullWidth: fullWidth })=>/*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$StyledContentSection, {
        wrapped: wrapped,
        fullWidth: fullWidth,
        onClick: wrapCardsCallback
    }, /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$StyledHeading, {
        wrapped: wrapped
    }, /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$Step, {
        wrapped: wrapped
    }, stepIcon || stepNumber), /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$Title, {
        wrapped: wrapped
    }, title), !wrapped && buttons && /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$ButtonsContainer, null, buttons), wrapped && propertyValue !== undefined && /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$PropertyValueContainer, null, propertyValue)), !wrapped && /*#__PURE__*/ $acw62.createElement($e6703e6014d8edb3$var$StyledChildren, null, children));
const $e6703e6014d8edb3$var$PropertyValueContainer = (0, $lmFrL.default).div`
  color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  letter-spacing: -0.01em;
`;
const $e6703e6014d8edb3$var$ButtonsContainer = (0, $lmFrL.default).div`
  display: flex;

  button {
    margin-left: 24px;
  }
`;
const $e6703e6014d8edb3$var$StyledContentSection = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  border-radius: ${({ theme: theme })=>theme.radius.default};
  background-color: ${({ theme: theme })=>theme.newColors.grayscale.white};
  margin: 10px 0 44px 0;
  box-shadow: ${({ theme: theme })=>theme.shadows.dropShadows.formCard};
  border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.bordersInside};
  ${({ fullWidth: fullWidth })=>fullWidth && (0, $lmFrL.css)`
      width: 100%;
    `};

  &:not(:last-of-type) {
    :after {
      position: relative;
      bottom: -${({ theme: theme })=>theme.space[4]};
      left: ${({ theme: theme })=>theme.space[3]};
      height: 10px;
      width: 10px;
      content: url("data:image/svg+xml,%3Csvg width='4' height='20' viewBox='0 0 4 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='18' r='2' fill='%23C5C6CB'/%3E%3Ccircle cx='2' cy='10' r='2' fill='%23C5C6CB'/%3E%3Ccircle cx='2' cy='2' r='2' fill='%23C5C6CB'/%3E%3C/svg%3E");
    }
  }

  &:not(:last-of-type) {
    & > div:last-of-type {
      ${({ wrapped: wrapped })=>wrapped && (0, $lmFrL.css)`
          margin-bottom: -20px;
        `};
    }
  }
`;
const $e6703e6014d8edb3$var$StyledHeading = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  height: 56px;
  background: ${({ theme: theme, wrapped: wrapped })=>wrapped ? theme.newColors.grayscale.white : theme.newColors.grayscale.primaryGray};
  border-radius: ${({ theme: theme, wrapped: wrapped })=>wrapped ? `${theme.radius.default}` : `${theme.radius.default} ${theme.radius.default} 0 0`};
  align-items: center;
  padding: ${({ theme: theme })=>theme.space[3]};
  justify-content: space-between;
`;
const $e6703e6014d8edb3$var$Step = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  padding-top: 2px;
  margin-right: ${({ theme: theme })=>theme.space[3]};
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ theme: theme })=>theme.newColors.grayscale.white};
  width: 24px;
  height: 24px;
  border: ${({ theme: theme, wrapped: wrapped })=>wrapped ? `2px solid ${theme.newColors.grayscale.bordersInside}` : "none"};

  font-size: 14px;
  line-height: 24px;
`;
const $e6703e6014d8edb3$var$Title = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Heading))`
  margin-top: 3px;
  font-size: ${({ theme: theme })=>theme.fontSizes[2]};
  line-height: 24px;
  color: ${({ theme: theme })=>theme.newColors.grayscale.white};
  color: ${({ theme: theme, wrapped: wrapped })=>wrapped ? theme.newColors.grayscale.primaryGray : theme.newColors.grayscale.white};
  flex-grow: 1;
`;
const $e6703e6014d8edb3$var$StyledChildren = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  padding: 27px 36px 27px 56px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");
// @flow

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");
const $5b157c2ebdc5985a$export$1ff3c3f08ae963c0 = (0, $lmFrL.default).hr`
  border: 1px solid #f0f3f6;
  margin: 32px 0;
`;


const $80a057cdff0d2afb$export$2d00230e1e6f7fbc = (props)=>{
    const { label: label, description: description, children: children, status: status, onFormEdit: onFormEdit, editVisible: editVisible = false, disabled: disabled } = props;
    return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        htmlFor: label,
        label: label,
        status: status,
        edit: editVisible,
        onEditClick: onFormEdit,
        disabled: disabled
    }, description), children, /*#__PURE__*/ $acw62.createElement((0, $5b157c2ebdc5985a$export$1ff3c3f08ae963c0), null));
};




var $acw62 = parcelRequire("acw62");

const $2f9a2915679c4fce$export$2c827532b2816694 = (fieldStatus, setFieldStatus, delay = 20000)=>{
    const savedFieldStatus = $acw62.useRef(fieldStatus);
    $acw62.useEffect(()=>{
        savedFieldStatus.current = fieldStatus;
    }, [
        fieldStatus
    ]);
    $acw62.useEffect(()=>{
        const timer = setTimeout(()=>{
            if (savedFieldStatus.current?.type === 3) setFieldStatus({
                type: (0, $fd090f2967b171e4$export$a4e0276d1f6541ed).FAILED,
                name: "FAILED"
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        savedFieldStatus.current
    ]);
};


const $df875e3cd5dd5201$export$d55b50a564d0b931 = ({ field: field, // form: { touched, errors, setFieldValue },
...props })=>{
    const { options: options, label: label, answerQuestionCallback: answerQuestionCallback, metadata: metadata, required: required, fieldStatus: fieldStatusCallback, disabled: disabled, isSearchable: isSearchable } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue));
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    (0, $acw62.useEffect)(()=>{
        setFieldValue(field.value);
    }, [
        field.value
    ]);
    (0, $acw62.useEffect)(()=>{
        const currentStatus = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue);
        setFieldStatus(currentStatus);
        fieldStatusCallback(currentStatus);
    }, [
        fieldValue,
        field.value
    ]);
    const onChange = (option)=>{
        setFieldValue(option.value);
        answerQuestionCallback(metadata, option.value);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        status: fieldStatus
    }, /*#__PURE__*/ $acw62.createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
        ...field,
        ...props,
        options: options,
        value: options ? options.find((option)=>option.value === field.value) : "",
        onChange: onChange,
        isDisabled: disabled,
        isSearchable: isSearchable
    }));
};


const $f7ce80ed4a205928$export$229ced5e3e429d2a = (props)=>{
    const autoCompleteProps = {
        ...props,
        isSearchable: true
    };
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $df875e3cd5dd5201$export$d55b50a564d0b931),
        ...autoCompleteProps
    });
};



var $acw62 = parcelRequire("acw62");




const $fbd112d8cb085986$export$2c73285ae9390cec = (props)=>{
    const { placeholder: placeholder, field: field, label: label, description: description, answerQuestionCallback: answerQuestionCallback, metadata: metadata, type: type, required: required, fieldStatus: fieldStatusCallback, disabled: disabled } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue));
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    // useEffect(() => {
    //   setFieldValue(field.value);
    // }, [field.value]);
    (0, $acw62.useEffect)(()=>{
        const currentStatus = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue);
        setFieldStatus(currentStatus);
        fieldStatusCallback(currentStatus);
    }, [
        fieldValue,
        field.value
    ]);
    // console.log("PINGWING: 33 valueSaved", field.value === fieldValue); // TODO: signal this state, SAVING for false, SAVED for true
    const onChange = (event)=>{
        setFieldValue(event.target.value);
        answerQuestionCallback(metadata, event.target.value);
    };
    const handleOnKeyDown = (event)=>{
        if (fieldValue === "") setFieldStatus({
            type: (0, $fd090f2967b171e4$export$a4e0276d1f6541ed).FAILED,
            name: "FAILED"
        });
        const sameSignExp = new RegExp(/^[.,]*$/);
        if ((sameSignExp.test(fieldValue) || fieldValue === "") && sameSignExp.test(event.key)) {
            setFieldStatus({
                type: (0, $fd090f2967b171e4$export$a4e0276d1f6541ed).FAILED,
                name: "FAILED"
            });
            return event.preventDefault();
        }
        const inputNumberExp = new RegExp(/(^\d*,?\d*\.?\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight|F5)/);
        return !event.key.match(inputNumberExp) && event.preventDefault();
    };
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description,
        status: fieldStatus,
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: placeholder === null ? undefined : placeholder,
        type: type,
        ...field,
        value: fieldValue,
        onChange: onChange,
        onKeyDown: type === "number" ? (event)=>handleOnKeyDown(event) : undefined,
        disabled: disabled
    }));
};


const $5e6f2bcea9cbc06f$export$1da64124c9426c44 = (props)=>{
    if (props.options && props.options.length > 0) return (0, $f7ce80ed4a205928$export$229ced5e3e429d2a)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $fbd112d8cb085986$export$2c73285ae9390cec),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");


var $acw62 = parcelRequire("acw62");




const $2f7c9b665a686114$export$a314277471067e8a = ({ field: field, ...props })=>{
    const { options: options, label: label, answerQuestionCallback: answerQuestionCallback, metadata: metadata, required: required, disabled: disabled, fieldStatus: fieldStatusCallback } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue));
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    (0, $acw62.useEffect)(()=>{
        setFieldValue(field.value);
    }, [
        field.value
    ]);
    (0, $acw62.useEffect)(()=>{
        const currentStatus = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue);
        setFieldStatus(currentStatus);
        fieldStatusCallback(currentStatus);
    }, [
        fieldValue,
        field.value
    ]);
    const onClickRadioButton = (value)=>{
        setFieldValue(value);
        answerQuestionCallback(metadata, value);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        status: fieldStatus
    }, /*#__PURE__*/ $acw62.createElement((0, $d19f8a0606798fa7$export$a98f0dcb43a68a25), {
        ...field,
        ...props,
        options: options.map((option)=>({
                labelText: option.label,
                value: option.value,
                disabled: disabled
            })),
        selectedValue: options ? options.find((option)=>option.value === field.value)?.value : "",
        onClickRadioButton: onClickRadioButton
    }));
};


const $0194baca8cb4c35c$export$58636e7da020966a = (props)=>{
    if (!props.options) throw new Error("Corrupted question");
    if (props.options.length > 2) return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $df875e3cd5dd5201$export$d55b50a564d0b931),
        ...props
    });
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $2f7c9b665a686114$export$a314277471067e8a),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");




const $f3a445272696109c$export$301bf6213f61d17f = (props)=>{
    const { placeholder: placeholder, field: field, label: label, description: description, answerQuestionCallback: answerQuestionCallback, metadata: metadata, required: required, fieldStatus: fieldStatusCallback, disabled: disabled } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue));
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    // useEffect(() => {
    //   setFieldValue(field.value);
    // }, [field.value]);
    (0, $acw62.useEffect)(()=>{
        const currentStatus = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue);
        setFieldStatus(currentStatus);
        fieldStatusCallback(currentStatus);
    }, [
        fieldValue,
        field.value
    ]);
    // console.log("PINGWING: 33 valueSaved", field.value === fieldValue); // TODO: signal this state, SAVING for false, SAVED for true
    const onChange = (event)=>{
        setFieldValue(event.target.value);
        answerQuestionCallback(metadata, event.target.value);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description,
        status: fieldStatus
    }, /*#__PURE__*/ $acw62.createElement((0, $c7e0eaaa31601803$export$f5c9f3c2c4054eec), {
        placeholder: placeholder,
        ...field,
        value: fieldValue,
        onChange: onChange,
        isDisabled: disabled
    }));
};


const $0507586b407e8c78$export$ea51f321caa02dd4 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $f3a445272696109c$export$301bf6213f61d17f),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $5e72379fd34263c8$exports = {};
'use strict';

$5e72379fd34263c8$exports = (parcelRequire("k4mSs"));


var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $baa553d77c4811c0$export$aa86822bccdac75d = (bytes, decimals = 2)=>{
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};



var $acw62 = parcelRequire("acw62");

const $db86e8297ab3e9e8$export$e1f2a1a82f61fe88 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.41413 5.00001L9.70713 1.70701C10.0981 1.31601 10.0981 0.684006 9.70713 0.293006C9.31613 -0.0979941 8.68413 -0.0979941 8.29313 0.293006L5.00013 3.58601L1.70713 0.293006C1.31613 -0.0979941 0.684128 -0.0979941 0.293128 0.293006C-0.0978721 0.684006 -0.0978721 1.31601 0.293128 1.70701L3.58613 5.00001L0.293128 8.29301C-0.0978721 8.68401 -0.0978721 9.31601 0.293128 9.70701C0.488128 9.90201 0.744128 10 1.00013 10C1.25613 10 1.51213 9.90201 1.70713 9.70701L5.00013 6.41401L8.29313 9.70701C8.48813 9.90201 8.74413 10 9.00013 10C9.25613 10 9.51213 9.90201 9.70713 9.70701C10.0981 9.31601 10.0981 8.68401 9.70713 8.29301L6.41413 5.00001Z",
        fill: color
    }));
};
$db86e8297ab3e9e8$export$e1f2a1a82f61fe88.defaultProps = {
    width: "10",
    height: "10",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};
var $db86e8297ab3e9e8$export$2e2bcd8739ae039 = $db86e8297ab3e9e8$export$e1f2a1a82f61fe88;





const $5bc2b5d75698284c$var$FileContainer = (0, $lmFrL.default).div`
  width: 312px;
  height: 32px;
  border-radius: 8px 8px 8px 0px;

  background: ${(props)=>props.isLoading ? props.theme.newColors.primary.lightestTint : props.theme.newColors.grayscale.primaryGray};

  .progressBar {
    display: ${(props)=>props.isLoading ? "block;" : "none;"};
  }
`;
const $5bc2b5d75698284c$var$ProgressBar = (0, $lmFrL.default).div`
  height: 2px;
  width: ${(props)=>props.percent}%;
  border-radius: 4px;
  background: ${(props)=>props.theme.newColors.primary.basic};
`;
const $5bc2b5d75698284c$var$Label = (0, $lmFrL.default).div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  cursor: ${({ isLoading: isLoading })=>isLoading ? "default" : "pointer"};
`;
const $5bc2b5d75698284c$var$LabelContainer = (0, $lmFrL.default).div`
  display: flex;
  padding: 8px 12px;
`;
const $5bc2b5d75698284c$var$FileName = (0, $lmFrL.default).div`
  font-size: ${(props)=>props.theme.fontSizes[0]};
  line-height: ${(props)=>props.theme.lineHeights[2]};

  letter-spacing: -0.01em;

  color: ${(props)=>props.isLoading ? props.theme.newColors.grayscale.primaryGray : props.theme.newColors.grayscale.white};

  order: 0;
  align-self: center;
  margin-right: 5px;

  max-width: 175px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $5bc2b5d75698284c$var$FileSize = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01em;

  color: ${(props)=>props.isLoading ? props.theme.newColors.grayscale.secondaryGray : props.theme.newColors.grayscale.placeholder};

  order: 1;
  align-self: center;
`;
const $5bc2b5d75698284c$var$CloseButton = (0, $lmFrL.default).button`
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  width: 16px;
  height: 16px;
  padding: 0;
  cursor: pointer;
`;
const $5bc2b5d75698284c$export$5053f49f46dd8ad = (props)=>{
    const { name: name, size: size, percent: percent = 100, onGetFileClick: onGetFileClick, onDeleteFileClick: onDeleteFileClick } = props;
    const isLoading = percent !== 100;
    const [openConfirmationModal, setOpenConfirmationModal] = $acw62.useState(false);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$FileContainer, {
        isLoading: isLoading
    }, /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$LabelContainer, null, /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$Label, {
        onClick: !isLoading ? onGetFileClick : ()=>{},
        isLoading: isLoading
    }, /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$FileName, {
        isLoading: isLoading
    }, name), /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$FileSize, {
        isLoading: isLoading
    }, "(", (0, $baa553d77c4811c0$export$aa86822bccdac75d)(size), ")")), /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$CloseButton, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (!isLoading) setOpenConfirmationModal(true);
        }
    }, isLoading ? /*#__PURE__*/ $acw62.createElement((0, $db86e8297ab3e9e8$export$e1f2a1a82f61fe88), {
        width: "10",
        height: "16",
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
    }) : /*#__PURE__*/ $acw62.createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), {
        width: "16",
        height: "16",
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
    }))), /*#__PURE__*/ $acw62.createElement($5bc2b5d75698284c$var$ProgressBar, {
        className: "progressBar",
        percent: percent
    })), /*#__PURE__*/ $acw62.createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        title: "Warning",
        message: "Do you want to delete this file?",
        isOpen: openConfirmationModal,
        closeModal: ()=>setOpenConfirmationModal(false),
        acceptModal: ()=>onDeleteFileClick()
    }));
};
$5bc2b5d75698284c$export$5053f49f46dd8ad.defaultProps = {
    onGetFileClick: ()=>{},
    onDeleteFileClick: ()=>{}
};



const $d8fa700afad7bc18$var$FilesContainer = (0, $lmFrL.default).div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;

  > div {
    margin: 0 5px 5px 0;
  }
`;
const $d8fa700afad7bc18$export$9330ab61a7e5c11b = (props)=>{
    const { files: files, onDeleteFile: onDeleteFile } = props;
    if (files.length === 0) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    const navigate = (0, $66249767282b1118$export$9770f232ac06a008)();
    const [getDownloadLink, { data: downloadLinkQueryData }] = (0, $7608a8bbcbbad14c$export$98b6850a2dbc6198)();
    const [deleteUploadedFile, { data: deleteUploadedFileMutationData }] = (0, $7608a8bbcbbad14c$export$7ca0061c8c838e7b)();
    $acw62.useEffect(()=>{
        if (downloadLinkQueryData && downloadLinkQueryData.DownloadLink) navigate(downloadLinkQueryData.DownloadLink);
    }, [
        JSON.stringify(downloadLinkQueryData)
    ]);
    $acw62.useEffect(()=>{
        const deleteUploadedFileResult = deleteUploadedFileMutationData?.DeleteUploadedFile;
        if (deleteUploadedFileResult) {
            if (deleteUploadedFileResult.deleteStatus === (0, $7608a8bbcbbad14c$export$b780d51770a4d990).Ok) onDeleteFile(deleteUploadedFileResult.fileName);
        }
    }, [
        JSON.stringify(deleteUploadedFileMutationData)
    ]);
    return /*#__PURE__*/ $acw62.createElement($d8fa700afad7bc18$var$FilesContainer, null, files.map((file)=>/*#__PURE__*/ $acw62.createElement((0, $5bc2b5d75698284c$export$5053f49f46dd8ad), {
            key: file.s3FileName,
            name: file.fileName,
            size: file.fileSize,
            percent: file.percent !== undefined ? file.percent : 100,
            onGetFileClick: ()=>getDownloadLink({
                    variables: {
                        fileName: file.s3FileName,
                        originFileName: file.fileName
                    }
                }),
            onDeleteFileClick: ()=>{
                deleteUploadedFile({
                    variables: {
                        fileName: file.s3FileName
                    }
                });
            }
        })));
};
$d8fa700afad7bc18$export$9330ab61a7e5c11b.defaultProps = {
    onDeleteFile: ()=>{}
};




const $a8854d78951f5b1d$var$generateFileName = (fileName)=>{
    const extension = fileName.replace(/.*\./, "");
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($5e72379fd34263c8$exports))).generate()}.${extension}`;
};
const $a8854d78951f5b1d$var$parseFilesToQuery = (files)=>files.filter((file)=>file.percent === 0).map((file)=>({
            fileId: file.id,
            fileName: file.generatedFileName,
            fileType: file.fileItem.type
        }));
const $a8854d78951f5b1d$var$parseFilesToComponent = (files, filesToUpload)=>{
    const parsedFilesName = [];
    const parsedFiles = files.map((file)=>{
        parsedFilesName.push(file.s3FileName);
        return {
            ...file,
            percent: 100
        };
    });
    const parsedFilesToUpload = filesToUpload.map((fileToUpload)=>({
            fileName: fileToUpload.fileItem.name,
            s3FileName: fileToUpload.generatedFileName,
            fileSize: fileToUpload.fileItem.size,
            percent: fileToUpload.percent
        })).filter((fileToUpload)=>!parsedFilesName.includes(fileToUpload.s3FileName));
    return [].concat(parsedFiles, parsedFilesToUpload);
};
const $a8854d78951f5b1d$var$parseFieldValue = (fieldValue)=>{
    if (fieldValue?.length) return JSON.parse(fieldValue);
    return [];
};
const $a8854d78951f5b1d$export$1a5cb5295a7d2749 = (props)=>{
    const { onChange: onChange, field: field, horizontally: horizontally, disabled: disabled } = props;
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept, open: open, acceptedFiles: acceptedFiles } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        noClick: true,
        noKeyboard: true
    });
    const [files, setFiles] = (0, $acw62.useState)($a8854d78951f5b1d$var$parseFieldValue(field.value));
    const [filesToUpload, setFilesToUpload] = (0, $acw62.useState)([]);
    const [finishedFilesQueue, setFinishedFilesQueue] = (0, $acw62.useState)([]);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [getUploadLinksQuery, { data: uploadLinksQueryData }] = (0, $7608a8bbcbbad14c$export$c4336539623eb02d)();
    (0, $acw62.useEffect)(()=>{
        setFiles($a8854d78951f5b1d$var$parseFieldValue(field.value));
        setSaving(false);
    }, [
        field.value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!saving) {
            const fileToProceed = finishedFilesQueue.shift();
            if (fileToProceed) {
                setSaving(true);
                setFinishedFilesQueue(finishedFilesQueue);
                onChange(JSON.stringify([
                    ...files,
                    fileToProceed
                ]));
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (uploadLinksQueryData && uploadLinksQueryData.UploadLinks && uploadLinksQueryData.UploadLinks.length) uploadLinksQueryData.UploadLinks.forEach((uploadLink)=>{
            const fileItem = filesToUpload.find((file)=>file.id === uploadLink.fileId);
            if (fileItem) {
                const axiosConfig = {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": fileItem.fileItem.type
                    },
                    onUploadProgress: (progressEvent)=>{
                        const percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        const filesToUploadArray = [
                            ...filesToUpload
                        ];
                        const fileIndex = filesToUploadArray.findIndex((arrayElement)=>arrayElement.id === uploadLink.fileId);
                        if (fileIndex >= 0) {
                            filesToUploadArray[fileIndex].percent = percentCompleted;
                            setFilesToUpload(filesToUploadArray);
                        }
                    }
                };
                const finishedFile = {
                    fileName: fileItem.fileItem.name,
                    s3FileName: fileItem.generatedFileName,
                    fileSize: fileItem.fileItem.size
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put(uploadLink.link, fileItem.fileItem, axiosConfig).then(()=>{
                    const updatedFinishedFilesQueue = [
                        ...finishedFilesQueue
                    ];
                    updatedFinishedFilesQueue.push(finishedFile);
                    setFinishedFilesQueue(updatedFinishedFilesQueue);
                }).catch((err)=>{
                    console.log(`[ERROR] uploading file ${fileItem.fileItem.name}`, err);
                }).then(()=>{
                    const updatedFilesToUpload = filesToUpload.filter((fileToUpload)=>fileToUpload.generatedFileName !== fileItem.generatedFileName);
                    setFilesToUpload(updatedFilesToUpload);
                    setFiles([
                        ...files,
                        finishedFile
                    ]);
                });
            }
        });
    }, [
        JSON.stringify(uploadLinksQueryData)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (acceptedFiles && acceptedFiles.length) {
            const filesToUploadArray = [
                ...filesToUpload
            ];
            acceptedFiles.forEach((acceptedFile)=>{
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($5e72379fd34263c8$exports))).generate();
                const generatedFileName = $a8854d78951f5b1d$var$generateFileName(acceptedFile.name);
                filesToUploadArray.push({
                    fileItem: acceptedFile,
                    id: id,
                    generatedFileName: generatedFileName,
                    percent: 0
                });
            });
            setFilesToUpload(filesToUploadArray);
            getUploadLinksQuery({
                variables: {
                    fileInput: $a8854d78951f5b1d$var$parseFilesToQuery(filesToUploadArray)
                }
            });
        }
    }, [
        acceptedFiles.length
    ]);
    const deleteFile = (fileName)=>{
        const filesArray = files.filter((file)=>file.s3FileName !== fileName);
        onChange(JSON.stringify(filesArray));
        setFilesToUpload(filesToUpload.filter((file)=>file.generatedFileName !== fileName));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8fa700afad7bc18$export$9330ab61a7e5c11b), {
        files: $a8854d78951f5b1d$var$parseFilesToComponent(files, filesToUpload),
        onDeleteFile: deleteFile
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e464d85de0bbd46d$export$6c8108ad15125580), {
        rootProps: getRootProps({
            isDragAccept: isDragAccept
        }),
        inputProps: getInputProps(),
        open: open,
        horizontally: horizontally,
        disabled: disabled
    }));
};
$a8854d78951f5b1d$export$1a5cb5295a7d2749.defaultProps = {
    horizontally: false
};


const $ca1b1fa10d6d8e75$export$ad2d04c8e5b15ad7 = (props)=>{
    const { field: field, label: label, description: description, answerQuestionCallback: answerQuestionCallback, metadata: metadata, disabled: disabled } = props;
    const onChange = (uploadedFilesData)=>answerQuestionCallback(metadata, uploadedFilesData);
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description
    }, /*#__PURE__*/ $acw62.createElement((0, $a8854d78951f5b1d$export$1a5cb5295a7d2749), {
        field: field,
        onChange: onChange,
        disabled: disabled
    }));
};


const $7a855258136ccaac$export$8bded3446c85dfe6 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $ca1b1fa10d6d8e75$export$ad2d04c8e5b15ad7),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

/* eslint-disable react/no-array-index-key */ 
var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");
var $f46ed4009cb9c1cd$exports = {};
'use strict';

$f46ed4009cb9c1cd$exports = (parcelRequire("3odmW"));



var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

const $651a3f4c44f43348$export$6dcd14de5b20d369 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99998 1.6001C11.5346 1.6001 14.4 4.46547 14.4 8.0001C14.4 11.5347 11.5346 14.4001 7.99998 14.4001C4.46535 14.4001 1.59998 11.5347 1.59998 8.0001C1.59998 4.46547 4.46535 1.6001 7.99998 1.6001ZM9.57374 8.80113H6.42626C6.50053 9.92413 6.72897 10.9423 7.06843 11.7061C7.40331 12.4596 7.76115 12.8001 8 12.8001C8.23884 12.8001 8.59668 12.4596 8.93156 11.7061C9.27102 10.9423 9.49947 9.92413 9.57374 8.80113ZM4.82481 8.80127L3.2664 8.80043C3.50438 10.2183 4.36392 11.4253 5.55525 12.1317C5.1654 11.2083 4.9035 10.0617 4.82481 8.80127ZM12.7336 8.80043L11.1752 8.80126C11.0965 10.0617 10.8345 11.2082 10.4443 12.1308C11.636 11.4252 12.4956 10.2182 12.7336 8.80043ZM5.55565 3.86937L5.52901 3.88412C4.35123 4.5927 3.50251 5.7925 3.26635 7.20003L4.82475 7.19974C4.90339 5.93902 5.16537 4.7922 5.55565 3.86937ZM7.99998 3.2001L7.95067 3.20466C7.71353 3.24734 7.38097 3.59088 7.06842 4.29411C6.72888 5.05809 6.5004 6.07655 6.42619 7.19987H9.57378C9.49956 6.07655 9.27109 5.05809 8.93155 4.29411C8.59667 3.54064 8.23883 3.2001 7.99998 3.2001ZM10.4447 3.86845L10.4474 3.87666C10.836 4.79827 11.0968 5.94241 11.1753 7.19985L12.7337 7.20055C12.496 5.78237 11.6363 4.57502 10.4447 3.86845Z",
        fill: color
    }));
};
$651a3f4c44f43348$export$6dcd14de5b20d369.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};




var $acw62 = parcelRequire("acw62");

const $a3a4dc08b7338d07$export$adbe208aaacdedf9 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.75 0.125H0.75V1.125V14.25V15.25H1.75H14.25H15.25V14.25V10.5H13.25V13.25H2.75V2.125H5.5V0.125H1.75ZM14.25 0.125H8.625V2.125H11.8358L6.66789 7.29289L8.08211 8.70711L13.25 3.53921V6.75H15.25V1.125V0.125H14.25Z",
        fill: color
    }));
};
$a3a4dc08b7338d07$export$adbe208aaacdedf9.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



const $2a718db137cf5435$var$svgString = encodeURIComponent((0, $f46ed4009cb9c1cd$exports.renderToStaticMarkup)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $651a3f4c44f43348$export$6dcd14de5b20d369), null)));
function $2a718db137cf5435$var$isValidUrl(string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return !!url.protocol;
}
const $2a718db137cf5435$export$7072fe5fbc0a2edb = (props)=>{
    const { id: id, value: value, onChange: onChange, onDelete: onDelete, testId: testId, disabled: disabled } = props;
    let valueAsUrl = value.trim();
    if (!$2a718db137cf5435$var$isValidUrl(valueAsUrl)) valueAsUrl = `https://${valueAsUrl}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2a718db137cf5435$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: "https://www.example.com",
        svgIcon: $2a718db137cf5435$var$svgString,
        value: value,
        onChange: (input)=>onChange(input.target.value),
        testId: `${testId}_input`,
        disabled: disabled
    }), valueAsUrl.length && !disabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: valueAsUrl,
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2a718db137cf5435$var$Button, {
        "data-testid": `${testId}_previewButton`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a3a4dc08b7338d07$export$adbe208aaacdedf9), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2a718db137cf5435$var$Button, {
        onClick: ()=>onDelete(id),
        style: {
            cursor: "pointer"
        },
        "data-testid": `${testId}_deleteButton`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null))) : null);
};
const $2a718db137cf5435$var$Container = (0, $lmFrL.default).div`
  display: flex;
`;
const $2a718db137cf5435$var$Button = (0, $lmFrL.default).div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.userInputs.basicInside};
  border-radius: 4px;
  margin-left: 16px;
`;




const $e180965ada60d3b1$var$parseValue = (linksValue)=>{
    if (linksValue && linksValue.length) return JSON.parse(linksValue);
    return [
        ""
    ];
};
const $e180965ada60d3b1$export$7c6fdaf98295312b = (props)=>{
    const { onUpdateCallback: onUpdateCallback, linksValue: linksValue, disabled: disabled } = props;
    const [links, setLinks] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($e180965ada60d3b1$var$parseValue(linksValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const linksToUpdate = JSON.stringify(links);
        if (linksToUpdate !== linksValue) onUpdateCallback(linksToUpdate);
    }, [
        JSON.stringify(links)
    ]);
    const updateLink = (id, value)=>{
        const linksArray = [
            ...links
        ];
        linksArray[id] = value;
        setLinks(linksArray);
    };
    const deleteLink = (id)=>{
        const linksArray = [
            ...links
        ];
        linksArray.splice(id, 1);
        if (linksArray.length === 0) linksArray.push("");
        setLinks(linksArray);
    };
    const addLink = ()=>{
        const linksArray = [
            ...links
        ];
        linksArray.push("");
        setLinks(linksArray);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e180965ada60d3b1$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e180965ada60d3b1$var$ExternalLinksElementContainer, null, links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a718db137cf5435$export$7072fe5fbc0a2edb), {
            key: `externalLink${index}`,
            testId: "externalLinksElement",
            id: index,
            value: link,
            onChange: (linkValue)=>updateLink(index, linkValue),
            onDelete: (linkId)=>deleteLink(linkId),
            disabled: disabled
        }))), !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e180965ada60d3b1$var$AddLinkContainer, {
        onClick: addLink,
        "data-testid": "externalLinks_addButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af15d86567b97244$export$f21ab0717a89c77f), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }), "ADD ANOTHER LINK"));
};
$e180965ada60d3b1$export$7c6fdaf98295312b.defaultProps = {
    onUpdateCallback: ()=>{},
    linksValue: ""
};
const $e180965ada60d3b1$var$Container = (0, $lmFrL.default).div``;
const $e180965ada60d3b1$var$ExternalLinksElementContainer = (0, $lmFrL.default).div`
  > div {
    margin-bottom: 8px;
  }
`;
const $e180965ada60d3b1$var$AddLinkContainer = (0, $lmFrL.default).div`
  margin-top: 4px;
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 180px;

  svg {
    margin-right: 10px;
    transform: scale(1.5);
  }
`;




const $81a8bb5941459a44$export$c89d4b0890a242f4 = (props)=>{
    const { field: field, label: label, description: description, answerQuestionCallback: answerQuestionCallback, metadata: metadata, required: required, fieldStatus: fieldStatusCallback, disabled: disabled } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, field.value, fieldValue));
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    // useEffect(() => {
    //   setFieldValue(field.value);
    // }, [field.value]);
    (0, $acw62.useEffect)(()=>{
        const currentStatus = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(required, // field.value === '[""]' ? undefined : field.value,
        field.value, fieldValue);
        setFieldStatus(currentStatus);
        fieldStatusCallback(currentStatus);
    }, [
        fieldValue,
        field.value
    ]);
    const onChange = (links)=>{
        setFieldValue(links);
        answerQuestionCallback(metadata, links);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description,
        status: fieldStatus,
        editVisible: !disabled,
        disabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e180965ada60d3b1$export$7c6fdaf98295312b), {
        onUpdateCallback: onChange,
        linksValue: fieldValue,
        disabled: disabled
    }));
};


const $a93f29f0033f7505$export$6a8e268bd4b87d1d = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $81a8bb5941459a44$export$c89d4b0890a242f4),
        ...props
    });
};


const $7cbc563b836a4de0$export$465c18d0577ffcf1 = (elementName, elementSchema, fieldStatus = ()=>{}, readonly = false)=>{
    const props = {
        name: elementName,
        label: elementSchema.label,
        options: elementSchema.options,
        description: elementSchema.description,
        placeholder: elementSchema.placeholder,
        required: elementSchema.required,
        visibility: elementSchema.visibility,
        answerQuestionCallback: elementSchema.answerQuestionCallback,
        metadata: elementSchema.metadata,
        fieldStatus: fieldStatus,
        disabled: elementSchema.disabled || readonly
    };
    if (!props.visibility) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    switch(elementSchema.type){
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextField:
            return (0, $5e6f2bcea9cbc06f$export$1da64124c9426c44)({
                ...props,
                type: "text"
            });
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextArea:
            return (0, $0507586b407e8c78$export$ea51f321caa02dd4)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).OneOfMany:
            return (0, $0194baca8cb4c35c$export$58636e7da020966a)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).File:
            return (0, $7a855258136ccaac$export$8bded3446c85dfe6)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Links:
            return (0, $a93f29f0033f7505$export$6a8e268bd4b87d1d)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
            return (0, $5e6f2bcea9cbc06f$export$1da64124c9426c44)({
                ...props,
                type: "number"
            });
        default:
            return /*#__PURE__*/ $acw62.createElement("div", null, "There is no renderer for type: ", elementSchema.type);
    }
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $lmFrL = parcelRequire("lmFrL");
const $f62c1a640a047274$var$Container = (0, $lmFrL.default).div`
  & div:last-child > hr {
    display: none;
  }
`;
const $f62c1a640a047274$export$a7fed597f4b8afd8 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Formik), rest, /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Form), {
        className: "needs-validation"
    }, /*#__PURE__*/ $acw62.createElement($f62c1a640a047274$var$Container, null, children)));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7YFi7 = parcelRequire("7YFi7");






const $8693072a6b8cb456$var$TextContainer = (props)=>{
    const { field: field, answerQuestionCallback: answerQuestionCallback, metadata: metadata, updateStatus: updateStatus, disabled: disabled } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    (0, $acw62.useEffect)(()=>{
        updateStatus((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(false, `${field.value}`, `${fieldValue}`));
    }, [
        fieldValue,
        field.value
    ]);
    const onChange = (event)=>{
        setFieldValue(event.target.value);
        answerQuestionCallback(metadata, parseFloat(event.target.value));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: "",
        type: "number",
        value: fieldValue,
        onChange: onChange,
        disabled: disabled
    });
};
$8693072a6b8cb456$var$TextContainer.defaultProps = {
    updateStatus: ()=>{}
};
const $8693072a6b8cb456$var$DropdownContainer = (props)=>{
    const { field: field, options: options, answerQuestionCallback: answerQuestionCallback, metadata: metadata, updateStatus: updateStatus, disabled: disabled } = props;
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(field.value);
    (0, $acw62.useEffect)(()=>{
        updateStatus((0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(false, field.value, fieldValue));
    }, [
        fieldValue,
        field.value
    ]);
    const onChange = (option)=>{
        setFieldValue(option.value);
        answerQuestionCallback(metadata, option.value);
    };
    if (options.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8693072a6b8cb456$var$StyledDropdown, {
        options: options,
        placeholder: "",
        value: options.find((option)=>option.value === field.value) || "",
        onChange: onChange,
        components: {
            IndicatorSeparator: null
        },
        isDisabled: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8693072a6b8cb456$var$OneValueContainer, null, options[0].label);
};
const $8693072a6b8cb456$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  min-width: 92px;
`;
$8693072a6b8cb456$var$DropdownContainer.defaultProps = {
    updateStatus: ()=>{}
};
const $8693072a6b8cb456$var$getContainerProps = (elementName, elementSchema)=>({
        name: elementName,
        label: elementSchema.label,
        options: elementSchema.options,
        description: elementSchema.description,
        placeholder: elementSchema.placeholder,
        answerQuestionCallback: elementSchema.answerQuestionCallback,
        metadata: elementSchema.metadata,
        required: elementSchema.required,
        disabled: elementSchema.disabled
    });
const $8693072a6b8cb456$export$be62da8a6332d81e = (props)=>{
    const { parentId: parentId, isRequired: isRequired, filledRequiredItemsIds: filledRequiredItemsIds, updateStatus: updateStatusToParent } = props;
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)();
    const textElementId = props.formSchemaItems.findIndex((formSchemaItem)=>formSchemaItem?.type === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextField || formSchemaItem?.type === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number);
    const dropdownElementId = props.formSchemaItems.findIndex((formSchemaItem)=>formSchemaItem?.type === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).OneOfMany);
    const updateStatus = (status)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        updateStatusToParent(status);
        setFieldStatus(status);
    };
    const textElementProps = $8693072a6b8cb456$var$getContainerProps(`${textElementId}`, props.formSchemaItems[textElementId]);
    textElementProps.updateStatus = updateStatus;
    const dropdownElementProps = $8693072a6b8cb456$var$getContainerProps(`${dropdownElementId}`, props.formSchemaItems[dropdownElementId]);
    dropdownElementProps.updateStatus = updateStatus;
    const statusValue = filledRequiredItemsIds.includes(parentId) ? "filled" : undefined;
    let status;
    if (fieldStatus?.type === (0, $fd090f2967b171e4$export$a4e0276d1f6541ed).SAVING) status = fieldStatus;
    else status = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(isRequired, statusValue, statusValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: textElementProps.label,
        description: textElementProps.description || "",
        status: isRequired ? status : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8693072a6b8cb456$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7YFi7.Field), {
        component: $8693072a6b8cb456$var$TextContainer,
        ...textElementProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7YFi7.Field), {
        component: $8693072a6b8cb456$var$DropdownContainer,
        ...dropdownElementProps
    })));
};
$8693072a6b8cb456$export$be62da8a6332d81e.defaultProps = {
    updateStatus: ()=>{},
    readonly: false
};
const $8693072a6b8cb456$var$Container = (0, $lmFrL.default).div`
  display: flex;

  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  border-radius: 4px;
  padding-left: 4px;

  >input: first-child {
    border: 0;
    border-right: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
    border-radius: 0;
  }

  > div:last-child {
    width: 110px;
  }

  .Select__control,
  .Select__control:focus {
    border: 0;
    box-shadow: none;
    height: 50px;
  }
`;
const $8693072a6b8cb456$var$OneValueContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");





var $acw62 = parcelRequire("acw62");

const $d990224433cba588$export$7aa88867d61720c1 = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.31449 7.94749L3.20964 6.05235C3.4713 5.79068 3.89554 5.79068 4.15721 6.05235C4.40018 6.29532 4.41754 6.67848 4.20927 6.94148L4.15721 6.99992L2.26206 8.89506C1.47707 9.68005 1.47707 10.9528 2.26206 11.7378C3.01902 12.4947 4.2295 12.5218 5.01885 11.8189L5.10478 11.7378L6.99992 9.84263C7.26158 9.58097 7.68582 9.58097 7.94749 9.84263C8.19046 10.0856 8.20782 10.4688 7.99956 10.7318L7.94749 10.7902L6.05235 12.6853C4.74403 13.9937 2.62282 13.9937 1.31449 12.6853C0.0406009 11.4115 0.00707746 9.36689 1.21392 8.05244L1.31449 7.94749ZM7.94752 1.31449C9.25584 0.00617141 11.3771 0.00617141 12.6854 1.31449C13.9937 2.62282 13.9937 4.74403 12.6854 6.05235L10.7902 7.94749C10.5286 8.20915 10.1043 8.20915 9.84266 7.94749C9.581 7.68582 9.581 7.26158 9.84266 6.99992L11.7378 5.10478C12.5228 4.31978 12.5228 3.04706 11.7378 2.26206C10.9528 1.47707 9.68008 1.47707 8.89509 2.26206L6.99995 4.15721C6.73828 4.41887 6.31404 4.41887 6.05238 4.15721C5.79071 3.89554 5.79071 3.4713 6.05238 3.20964L7.94752 1.31449ZM7.94753 5.10478C8.20919 4.84311 8.63344 4.84311 8.8951 5.10478C9.15676 5.36644 9.15676 5.79068 8.8951 6.05235L6.05239 8.89506C5.79072 9.15672 5.36648 9.15672 5.10482 8.89506C4.84315 8.6334 4.84315 8.20915 5.10482 7.94749L7.94753 5.10478Z",
        fill: color
    }));
};
$d990224433cba588$export$7aa88867d61720c1.defaultProps = {
    width: "14",
    height: "14",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText
};




const $e517e1744618c2fb$var$chunkArrayInGroups = (arr, size)=>{
    const myArray = [];
    for(let i = 0; i < arr.length; i += size)myArray.push(arr.slice(i, i + size));
    return myArray;
};
const $e517e1744618c2fb$var$getFormSchemaElements = (formSchema, indexArray)=>{
    const resultArray = [];
    indexArray.forEach((indexArrayElement)=>{
        resultArray[indexArrayElement] = formSchema[indexArrayElement];
    });
    return resultArray;
};
const $e517e1744618c2fb$export$fe684f8343edf07 = (props)=>{
    const { parentId: parentId, formSchemaItems: formSchemaItems, isRequired: isRequired, filledRequiredItemsIds: filledRequiredItemsIds } = props;
    const [fieldStatus, setFieldStatus] = (0, $acw62.useState)();
    (0, $2f9a2915679c4fce$export$2c827532b2816694)(fieldStatus, setFieldStatus);
    const updateStatus = (status)=>{
        setFieldStatus(status);
    };
    const formSchemaItemsKeys = Object.keys(formSchemaItems);
    const mainElementsIndex = formSchemaItemsKeys.slice(0, 2);
    const proteinElementsIndex = $e517e1744618c2fb$var$chunkArrayInGroups(formSchemaItemsKeys.slice(2), 2);
    const proteinElementsIndexLength = proteinElementsIndex.length - 1;
    const firstElementIndex = mainElementsIndex[0];
    const firstElement = formSchemaItems[firstElementIndex];
    const statusValue = filledRequiredItemsIds.includes(parentId) ? "filled" : undefined;
    let status;
    if (fieldStatus?.type === (0, $fd090f2967b171e4$export$a4e0276d1f6541ed).SAVING) status = fieldStatus;
    else status = (0, $fd090f2967b171e4$export$688d8a2f2c9a1ec6)(isRequired, statusValue, statusValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: firstElement.label,
        description: firstElement.description || "",
        status: isRequired ? status : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e517e1744618c2fb$var$NoLabelContainer, null, mainElementsIndex.map((mainElementIndex)=>(0, $7cbc563b836a4de0$export$465c18d0577ffcf1)(`${mainElementIndex}`, formSchemaItems[mainElementIndex], updateStatus))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e517e1744618c2fb$var$LineContainer, {
        width: 32,
        margin: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "or")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e517e1744618c2fb$var$ProteinsContainer, null, proteinElementsIndex.map((proteinElementIndex, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8693072a6b8cb456$export$be62da8a6332d81e), {
            parentId: "0",
            isRequired: false,
            formSchemaItems: $e517e1744618c2fb$var$getFormSchemaElements(formSchemaItems, proteinElementIndex),
            filledRequiredItemsIds: [],
            updateStatus: updateStatus
        }), index < proteinElementsIndexLength ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e517e1744618c2fb$var$LineContainer, {
            width: 4,
            margin: 5,
            style: {
                marginBottom: "18px"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d990224433cba588$export$7aa88867d61720c1), null))) : null))));
};
const $e517e1744618c2fb$var$NoLabelContainer = (0, $lmFrL.default).div`
  > div {
    > div:first-child {
      display: none;
    }

    > hr {
      display: none;
    }
  }
`;
const $e517e1744618c2fb$var$ProteinsContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: flex-end;

  margin-top: 20px;
  > div {
    margin-right: 16px;
    margin-left: 16px;

    > hr {
      display: none;
    }
  }

  > div:first-child {
    margin-left: 0;
  }

  > div:last-child {
    margin-right: 0;
  }
`;
const $e517e1744618c2fb$var$LineContainer = (0, $lmFrL.default).div`
  margin-top: 20px;
  margin-left: ${({ width: width, margin: margin })=>width + margin}px;
  margin-right: ${({ width: width, margin: margin })=>width + margin}px;

  font-family: Bio Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText};

  span {
    display: inline-block;
    position: relative;
  }
  span:before,
  span:after {
    content: "";
    position: absolute;
    height: 8px;
    border-bottom: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText};
    top: 0;
    width: ${({ width: width })=>width}px;
  }
  span:before {
    right: 100%;
    margin-right: ${({ margin: margin })=>margin}px;
  }
  span:after {
    left: 100%;
    margin-left: ${({ margin: margin })=>margin}px;
  }
`;


const $aa0eddcb3b21a458$export$204d23ef3d1ec54b = (elementKey, elementData, isRequired, filledRequiredItemsIds, readonly)=>{
    switch(elementData.renderer){
        case "QuestionWithUnit":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8693072a6b8cb456$export$be62da8a6332d81e), {
                parentId: elementKey,
                isRequired: isRequired,
                formSchemaItems: elementData.formSchemaItems,
                filledRequiredItemsIds: filledRequiredItemsIds,
                readonly: readonly
            });
        case "ProteinSequence":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e517e1744618c2fb$export$fe684f8343edf07), {
                parentId: elementKey,
                formSchemaItems: elementData.formSchemaItems,
                isRequired: isRequired,
                filledRequiredItemsIds: filledRequiredItemsIds
            });
        case "AnotherRenderer":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Another Renderer content");
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "There is no renderer for: ", elementData.renderer);
    }
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $8caa11269a5f0cd9$export$8403ae9113208a5d = (props)=>{
    const { requiredItems: requiredItems, filledItems: filledItems } = props;
    const percent = Math.round(filledItems / (requiredItems || 1) * 100);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8caa11269a5f0cd9$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $73222a5d2c49b8c5$export$100cbaa565ba6879), {
        percent: percent,
        lineWidth: 2,
        radius: 25,
        containerWidth: null,
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8caa11269a5f0cd9$var$PercentContainer, null, percent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8caa11269a5f0cd9$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, filledItems), " out of ", requiredItems));
};
$8caa11269a5f0cd9$export$8403ae9113208a5d.defaultProps = {
    requiredItems: 0,
    filledItems: 0
};
const $8caa11269a5f0cd9$var$Container = (0, $lmFrL.default).div`
  margin-left: 20px;
  position: sticky;
  top: 10px;
  max-width: 176px;
  min-width: 100px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 140px;
  padding: 24px 0;

  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
  box-sizing: border-box;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.userInputs.basicInside};
  border-radius: 4px;

  > div:first-child > div {
    display: none;
  }
`;
const $8caa11269a5f0cd9$var$PercentContainer = (0, $lmFrL.default).div`
  position: absolute;
  top: 34px;
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.08em;
  width: 50px;
  height: 50px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};

  div {
    font-size: 12px;
    line-height: 12px;
    color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
  }
`;
const $8caa11269a5f0cd9$var$LabelContainer = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
  margin-top: 16px;

  span {
    font-weight: 800;
    color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};
  }
`;


const $6ceea703abcd95ae$export$e8cd5397656f35ba = (formSchema)=>{
    const requiredItems = [];
    Object.keys(formSchema).forEach((id)=>{
        const formSchemaRendererItem = formSchema[id];
        const formSchemaItem = formSchema[id];
        if (formSchemaRendererItem.renderer && formSchemaRendererItem.formSchemaItems.some((formSchemaItemElement)=>formSchemaItemElement.required)) requiredItems.push({
            renderer: true,
            id: id
        });
        if (!formSchemaRendererItem.renderer && formSchemaItem.required && formSchemaItem.visibility) requiredItems.push({
            renderer: false,
            id: id
        });
    });
    return requiredItems;
};
const $6ceea703abcd95ae$export$596872b699efc9f4 = (requiredItems, formData, formSchema)=>{
    const filledRequiredItemsIds = [];
    requiredItems.forEach((requiredItemsItem)=>{
        if (requiredItemsItem.renderer) {
            const renderedFormSchemaItems = // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            formSchema[requiredItemsItem.id].formSchemaItems;
            const rendererRequiredItems = $6ceea703abcd95ae$export$e8cd5397656f35ba(renderedFormSchemaItems);
            const filledRendererItemsIds = $6ceea703abcd95ae$export$596872b699efc9f4(rendererRequiredItems, formData);
            if (rendererRequiredItems.length === filledRendererItemsIds.length) filledRequiredItemsIds.push(requiredItemsItem.id);
        }
        if (!requiredItemsItem.renderer && formData[requiredItemsItem.id]) filledRequiredItemsIds.push(requiredItemsItem.id);
    });
    return filledRequiredItemsIds;
};


const $88a5466183037fd5$export$7052cd336a5c2ae3 = (props)=>{
    const { formData: formData, formSchema: formSchema, validationSchema: validationSchema, onSubmit: onSubmit, readonly: readonly } = props;
    const requiredItems = (0, $6ceea703abcd95ae$export$e8cd5397656f35ba)(formSchema);
    const filledRequiredItems = (0, $6ceea703abcd95ae$export$596872b699efc9f4)(requiredItems, formData, formSchema);
    return /*#__PURE__*/ $acw62.createElement((0, $f62c1a640a047274$export$a7fed597f4b8afd8), {
        enableReinitialize: true,
        initialValues: formData,
        validationSchema: validationSchema,
        onSubmit: onSubmit
    }, /*#__PURE__*/ $acw62.createElement($88a5466183037fd5$var$Container, null, /*#__PURE__*/ $acw62.createElement($88a5466183037fd5$var$FormContainer, null, Object.keys(formSchema).map((key)=>{
        const formSchemaElement = formSchema[key];
        const isRequired = requiredItems.some((requiredItem)=>requiredItem.id === key);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: key
        }, formSchemaElement.renderer ? (0, $aa0eddcb3b21a458$export$204d23ef3d1ec54b)(key, formSchema[key], isRequired, filledRequiredItems, readonly) : (0, $7cbc563b836a4de0$export$465c18d0577ffcf1)(key, formSchema[key], ()=>{}, readonly));
    })), (0, $6ceea703abcd95ae$export$e8cd5397656f35ba).length && !readonly ? /*#__PURE__*/ $acw62.createElement($88a5466183037fd5$var$WidgetContainer, null, /*#__PURE__*/ $acw62.createElement((0, $8caa11269a5f0cd9$export$8403ae9113208a5d), {
        requiredItems: requiredItems.length,
        filledItems: filledRequiredItems.length
    })) : null));
};
const $88a5466183037fd5$var$Container = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
`;
const $88a5466183037fd5$var$WidgetContainer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: flex-end;
  width: 200px;
`;
const $88a5466183037fd5$var$FormContainer = (0, $lmFrL.default).div`
  flex-grow: 1;
  min-width: 500px;
`;


const $0b9e68e503e790ca$export$a768b233790fc927 = (questionGroup, questionLevelInput, answerQuestionCallback, readonly)=>{
    const formSchema = {};
    const getFormSchemaForQuestion = (question, questionSetId, disabled)=>{
        const formSchemaElement = {
            type: question.answer.answerType,
            label: question.question,
            description: question.description,
            placeholder: question.placeholder,
            required: question.isObligatory,
            visibility: question.visibility,
            disabled: disabled,
            metadata: {
                questionLevelInput: questionLevelInput,
                answerType: question.answer.answerType,
                questionInput: {
                    questionGroupId: questionGroup.id,
                    questionSetId: questionSetId,
                    questionId: question.id
                }
            },
            answerQuestionCallback: answerQuestionCallback
        };
        if (question.choices) formSchemaElement.options = question.choices.map((choice)=>({
                label: choice,
                value: choice
            }));
        return formSchemaElement;
    };
    questionGroup.questionSets.forEach((questionSet)=>{
        if (questionSet.renderer) {
            const formSchemaItems = [];
            questionSet.questions.forEach((question)=>{
                formSchemaItems[question.id] = getFormSchemaForQuestion(question, questionSet.id, readonly);
            });
            formSchema[questionSet.id] = {
                renderer: questionSet.renderer,
                formSchemaItems: formSchemaItems
            };
        } else questionSet.questions.forEach((question)=>{
            formSchema[question.id] = getFormSchemaForQuestion(question, questionSet.id, readonly);
        });
    });
    return formSchema;
};




var $dmHdY = parcelRequire("dmHdY");

var $9H9Di = parcelRequire("9H9Di");

var $dmHdY = parcelRequire("dmHdY");
var $0237b22d97657ad7$export$2e2bcd8739ae039 = $0237b22d97657ad7$var$BooleanSchema;
function $0237b22d97657ad7$var$BooleanSchema() {
    var _this = this;
    if (!(this instanceof $0237b22d97657ad7$var$BooleanSchema)) return new $0237b22d97657ad7$var$BooleanSchema();
    (0, $dmHdY.default).call(this, {
        type: 'boolean'
    });
    this.withMutation(function() {
        _this.transform(function(value) {
            if (!this.isType(value)) {
                if (/^(true|1)$/i.test(value)) return true;
                if (/^(false|0)$/i.test(value)) return false;
            }
            return value;
        });
    });
}
(0, $9H9Di.default)($0237b22d97657ad7$var$BooleanSchema, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
});



var $gcL7X = parcelRequire("gcL7X");

var $9H9Di = parcelRequire("9H9Di");

var $dmHdY = parcelRequire("dmHdY");

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");
var $425f4614c2bd74f2$var$isNaN = function isNaN(value) {
    return value != +value;
};
function $425f4614c2bd74f2$export$2e2bcd8739ae039() {
    var _this = this;
    if (!(this instanceof $425f4614c2bd74f2$export$2e2bcd8739ae039)) return new $425f4614c2bd74f2$export$2e2bcd8739ae039();
    (0, $dmHdY.default).call(this, {
        type: 'number'
    });
    this.withMutation(function() {
        _this.transform(function(value) {
            var parsed = value;
            if (typeof parsed === 'string') {
                parsed = parsed.replace(/\s/g, '');
                if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                parsed = +parsed;
            }
            if (this.isType(parsed)) return parsed;
            return parseFloat(parsed);
        });
    });
}
(0, $9H9Di.default)($425f4614c2bd74f2$export$2e2bcd8739ae039, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$425f4614c2bd74f2$var$isNaN(value);
    },
    min: function min(_min, message) {
        if (message === void 0) message = (0, $5nwN5.number).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: _min
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value >= this.resolve(_min);
            }
        });
    },
    max: function max(_max, message) {
        if (message === void 0) message = (0, $5nwN5.number).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: _max
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value <= this.resolve(_max);
            }
        });
    },
    lessThan: function lessThan(less, message) {
        if (message === void 0) message = (0, $5nwN5.number).lessThan;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value < this.resolve(less);
            }
        });
    },
    moreThan: function moreThan(more, message) {
        if (message === void 0) message = (0, $5nwN5.number).moreThan;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value > this.resolve(more);
            }
        });
    },
    positive: function positive(msg) {
        if (msg === void 0) msg = (0, $5nwN5.number).positive;
        return this.moreThan(0, msg);
    },
    negative: function negative(msg) {
        if (msg === void 0) msg = (0, $5nwN5.number).negative;
        return this.lessThan(0, msg);
    },
    integer: function integer(message) {
        if (message === void 0) message = (0, $5nwN5.number).integer;
        return this.test({
            name: 'integer',
            message: message,
            test: function test(val) {
                return (0, $7mZW8.default)(val) || Number.isInteger(val);
            }
        });
    },
    truncate: function truncate() {
        return this.transform(function(value) {
            return !(0, $7mZW8.default)(value) ? value | 0 : value;
        });
    },
    round: function round(method) {
        var avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform(function(value) {
            return !(0, $7mZW8.default)(value) ? Math[method](value) : value;
        });
    }
});



var $dmHdY = parcelRequire("dmHdY");

var $9H9Di = parcelRequire("9H9Di");
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7b96554ad88dbbc3$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7b96554ad88dbbc3$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7b96554ad88dbbc3$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0;
         // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}



var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");

var $l6pyh = parcelRequire("l6pyh");
var $647598aeb0c659d9$var$invalidDate = new Date('');
var $647598aeb0c659d9$var$isDate = function isDate(obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
};
var $647598aeb0c659d9$export$2e2bcd8739ae039 = $647598aeb0c659d9$var$DateSchema;
function $647598aeb0c659d9$var$DateSchema() {
    var _this = this;
    if (!(this instanceof $647598aeb0c659d9$var$DateSchema)) return new $647598aeb0c659d9$var$DateSchema();
    (0, $dmHdY.default).call(this, {
        type: 'date'
    });
    this.withMutation(function() {
        _this.transform(function(value) {
            if (this.isType(value)) return value;
            value = (0, $7b96554ad88dbbc3$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
            return !isNaN(value) ? new Date(value) : $647598aeb0c659d9$var$invalidDate;
        });
    });
}
(0, $9H9Di.default)($647598aeb0c659d9$var$DateSchema, (0, $dmHdY.default), {
    _typeCheck: function _typeCheck(v) {
        return $647598aeb0c659d9$var$isDate(v) && !isNaN(v.getTime());
    },
    min: function min(_min, message) {
        if (message === void 0) message = (0, $5nwN5.date).min;
        var limit = _min;
        if (!(0, $l6pyh.default).isRef(limit)) {
            limit = this.cast(_min);
            if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
        }
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: _min
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value >= this.resolve(limit);
            }
        });
    },
    max: function max(_max, message) {
        if (message === void 0) message = (0, $5nwN5.date).max;
        var limit = _max;
        if (!(0, $l6pyh.default).isRef(limit)) {
            limit = this.cast(_max);
            if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
        }
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: _max
            },
            test: function test(value) {
                return (0, $7mZW8.default)(value) || value <= this.resolve(limit);
            }
        });
    }
});



var $hDGtv = parcelRequire("hDGtv");

var $jpuYg = parcelRequire("jpuYg");

var $l6pyh = parcelRequire("l6pyh");

var $2vNMA = parcelRequire("2vNMA");
var $5a78aa552a6b7bb3$var$Lazy = /*#__PURE__*/ function() {
    function Lazy(mapFn) {
        this._resolve = function(value, options) {
            var schema = mapFn(value, options);
            if (!(0, $2vNMA.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
    }
    var _proto = Lazy.prototype;
    _proto.resolve = function resolve(options) {
        return this._resolve(options.value, options);
    };
    _proto.cast = function cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    };
    _proto.validate = function validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    };
    _proto.validateSync = function validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    };
    _proto.validateAt = function validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    };
    _proto.validateSyncAt = function validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    };
    return Lazy;
}();
$5a78aa552a6b7bb3$var$Lazy.prototype.__isYupSchema__ = true;
var $5a78aa552a6b7bb3$export$2e2bcd8739ae039 = $5a78aa552a6b7bb3$var$Lazy;



var $i6D11 = parcelRequire("i6D11");

var $7Qa2h = parcelRequire("7Qa2h");

var $2vNMA = parcelRequire("2vNMA");

var $5nwN5 = parcelRequire("5nwN5");
function $eabff3e78de076bd$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach(function(type) {
        Object.keys(custom[type]).forEach(function(method) {
            (0, $5nwN5.default)[type][method] = custom[type][method];
        });
    });
}


var $920660c8aca77688$export$4a21f16c33752377 = (0, $0237b22d97657ad7$export$2e2bcd8739ae039);
var $920660c8aca77688$export$eff4d24c3ff7876e = function ref(key, options) {
    return new (0, $l6pyh.default)(key, options);
};
var $920660c8aca77688$export$488013bae63b21da = function lazy(fn) {
    return new (0, $5a78aa552a6b7bb3$export$2e2bcd8739ae039)(fn);
};
function $920660c8aca77688$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $2vNMA.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


var $jpuYg = parcelRequire("jpuYg");
var $gcL7X = parcelRequire("gcL7X");

function $40e65b17a1bb5f5a$var$getValidationSchemaForQuestion(question) {
    const choices = question.choices ? question.choices : [];
    let result;
    switch(question.answer.answerType){
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextField:
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextArea:
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Date:
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Currency:
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).File:
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Links:
            result = $gcL7X.default();
            break;
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
            result = $425f4614c2bd74f2$export$2e2bcd8739ae039();
            break;
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).OneOfMany:
            result = $gcL7X.default().oneOf(choices.map((choice)=>choice));
            break;
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
            result = $jpuYg.default();
            break;
        default:
            throw new Error("Unsupported answer type");
    }
    if (question.isObligatory) result = result.required(`${question.question} is required`);
    return result;
}
const $40e65b17a1bb5f5a$export$d4f1a1c1230e2076 = (questionGroup)=>{
    const validationSchema = {};
    questionGroup.questionSets.forEach((questionSet)=>{
        questionSet.questions.forEach((question)=>{
            if (question.visibility) validationSchema[question.id] = $40e65b17a1bb5f5a$var$getValidationSchemaForQuestion(question);
        });
    });
    return validationSchema;
};



const $dd31949bb8cc9c37$export$6af2357d4499ad4e = (questionGroup)=>{
    const formData = {};
    questionGroup.questionSets.forEach((questionSet)=>{
        questionSet.questions.forEach((question)=>{
            if (question.visibility) {
                const { answer: answer } = question;
                switch(answer.answerType){
                    case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
                        formData[question.id] = answer.numericBody || undefined;
                        break;
                    case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
                        formData[question.id] = answer.multiBody || undefined;
                        break;
                    default:
                        formData[question.id] = answer.textBody || undefined;
                        break;
                }
            }
        });
    });
    return formData;
};









const $f801bca6edd7fbeb$export$53faf303b8a97647 = (props)=>{
    const { questionGroup: questionGroup, title: title, stepNumber: stepNumber, wrapped: wrapped, questionLevelInput: questionLevelInput, answerQuestionCallback: answerQuestionCallback, wrapCardsCallback: wrapCardsCallback, goToNextGroupCallback: goToNextGroupCallback, goTo1stSampleCallback: goTo1stSampleCallback, deleteProjectCallback: deleteProjectCallback, projectId: projectId, sampleId: sampleId, isReport: isReport, workflowId: workflowId, serviceId: serviceId, handleOnPrepareForPrinting: handleOnPrepareForPrinting, userRoleInSample: userRoleInSample } = props;
    const numberOfQuestions = questionGroup.questionSets.reduce((accumulator, currentValue)=>accumulator + currentValue.questions.length, 0);
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = (0, $acw62.useState)(false);
    const [openDuplicateConfirmationModal, setOpenDuplicateConfirmationModal] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [duplicateSampleInProjectMutation] = (0, $7608a8bbcbbad14c$export$ba6ad065c90d2caf)();
    const [duplicateProjectMutation] = (0, $7608a8bbcbbad14c$export$2d089989dadb2fd)();
    const handleEditQuestionGroup = ()=>{
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP,
            selectedElementPath: {
                questionGroupId: questionGroup.id,
                questionGroupName: questionGroup.name,
                projectId: projectId,
                sampleId: sampleId,
                fromReport: isReport,
                workflowId: workflowId,
                serviceId: serviceId
            }
        });
        setSideDrawboardOpen(true);
    };
    const handlePrintingQuestionGroup = ()=>{
        if (handleOnPrepareForPrinting) handleOnPrepareForPrinting(questionGroup.id);
    };
    const handleDuplicateSample = ()=>{
        setIsLoading(true);
        duplicateSampleInProjectMutation({
            variables: {
                projectId: projectId,
                sampleId: sampleId
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                },
                {
                    query: (0, $7608a8bbcbbad14c$export$56959a2c3ec29cce),
                    variables: {
                        id: projectId
                    }
                }
            ]
        }).then(()=>{
            setIsLoading(false);
            setOpenDuplicateConfirmationModal(false);
        }).catch(()=>{
            setIsLoading(false);
            setOpenDuplicateConfirmationModal(false);
        });
    };
    const handleDuplicateProject = ()=>{
        setIsLoading(true);
        duplicateProjectMutation({
            variables: {
                projectId: projectId
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$cd946050302ba91a)
                }
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setIsLoading(false);
            setOpenDuplicateConfirmationModal(false);
        }).catch(()=>{
            setIsLoading(false);
            setOpenDuplicateConfirmationModal(false);
        });
    };
    const editIsEnabled = useUserPermissions("editForm", userRoleInSample);
    const deleteIsEnabled = useUserPermissions("deleteForm", userRoleInSample);
    const duplicationIsEnabled = useUserPermissions("projectDuplication", userRoleInSample);
    const getSectionButtons = ()=>{
        const buttonArray = [];
        const isProjectConfigurator = title === "General project description";
        const isSampleConfigurator = title === "General path description";
        if (goToNextGroupCallback) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Go to next section",
            onClick: goToNextGroupCallback
        }));
        if (goTo1stSampleCallback) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Go to 1st sample",
            onClick: goTo1stSampleCallback
        }));
        if (duplicationIsEnabled && (isProjectConfigurator || isSampleConfigurator)) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Duplicate",
            onClick: ()=>setOpenDuplicateConfirmationModal(true)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
            isOpen: openDuplicateConfirmationModal,
            message: `Are you sure you want to duplicate this ${isProjectConfigurator ? "project" : "path"}?`,
            yesButtonText: "DUPLICATE",
            title: "Confirmation",
            closeModal: ()=>setOpenDuplicateConfirmationModal(false),
            acceptModal: isProjectConfigurator ? handleDuplicateProject : handleDuplicateSample,
            isLoading: isLoading
        })));
        if (isProjectConfigurator && deleteProjectCallback && deleteIsEnabled) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Delete Project",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Quaternary,
            onClick: ()=>setOpenDeleteConfirmationModal(true)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
            isOpen: openDeleteConfirmationModal,
            message: "Are you sure you want to delete this project?",
            yesButtonText: "DELETE PROJECT",
            title: "Confirmation",
            closeModal: ()=>setOpenDeleteConfirmationModal(false),
            acceptModal: deleteProjectCallback
        }));
        if (!isProjectConfigurator && editIsEnabled) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Edit",
            onClick: handleEditQuestionGroup
        }));
        if (!isProjectConfigurator && handleOnPrepareForPrinting) buttonArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Prepare printout",
            onClick: handlePrintingQuestionGroup
        }));
        return buttonArray;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: title,
        stepNumber: stepNumber,
        wrapped: wrapped,
        wrapCardsCallback: wrapCardsCallback,
        buttons: getSectionButtons()
    }, numberOfQuestions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $88a5466183037fd5$export$7052cd336a5c2ae3), {
        formData: (0, $dd31949bb8cc9c37$export$6af2357d4499ad4e)(questionGroup),
        validationSchema: (0, $40e65b17a1bb5f5a$export$d4f1a1c1230e2076)(questionGroup),
        formSchema: (0, $0b9e68e503e790ca$export$a768b233790fc927)(questionGroup, questionLevelInput, answerQuestionCallback),
        onSubmit: (values)=>console.log(values),
        key: questionGroup.id,
        readonly: !editIsEnabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: questionGroup.id
    }, "Empty Question Group - Edit to add new form elements"));
};




const $e07216757a3bd51c$var$maxNumberOfCharactersInTitle = 30;
const $e07216757a3bd51c$export$915e191deda31e58 = (text)=>{
    if (text) return text.length > $e07216757a3bd51c$var$maxNumberOfCharactersInTitle ? `...${text.substr(text.length - $e07216757a3bd51c$var$maxNumberOfCharactersInTitle)}` : text;
    return "";
};



var $f1q41 = parcelRequire("f1q41");
const $590f4d6a0c375d80$export$6b98ed09a1b36987 = (variables, query, path, mutationName, cache, data, parentPath)=>{
    const incomingData = data?.[mutationName];
    const existingQueryResult = (0, $f1q41.cloneDeep)(cache.readQuery({
        query: query,
        variables: variables
    })?.[path]);
    if (parentPath) existingQueryResult[parentPath].push(incomingData);
    if (existingQueryResult && incomingData) cache.writeQuery({
        variables: variables,
        query: query,
        data: {
            [path]: parentPath ? existingQueryResult : incomingData
        }
    });
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $lmFrL = parcelRequire("lmFrL");
var $d1de8120d343301d$export$2e2bcd8739ae039 = (0, $lmFrL.default)((0, $66249767282b1118$export$a6c7ac8248d6e38a))`
  text-decoration: none;
`;


const $1e26fa3e7edc863b$export$aede49260422b749 = ({ path: path = "", label: label = "" })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1e26fa3e7edc863b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1e26fa3e7edc863b$var$StyledforLink, {
        to: path
    }, label, " \u2192"));
const $1e26fa3e7edc863b$var$Container = (0, $lmFrL.default).div`
  width: 100%;
  text-align: right;
`;
const $1e26fa3e7edc863b$var$StyledforLink = (0, $lmFrL.default)((0, $d1de8120d343301d$export$2e2bcd8739ae039))`
  width: 100%;
  font-size: 14px;
  padding-right: 16px;
  color: ${({ theme: theme })=>theme.newColors.primary.basic};
  transition: 0.1s transform linear;
  &:visited {
    color: ${({ theme: theme })=>theme.newColors.primary.basic};
  }

  &:hover {
    color: ${({ theme: theme })=>theme.newColors.primary.hover};
  }
`;



const $2fd20af61ab7006c$var$projectDataTab = {
    id: "1",
    label: "Project Data",
    status: (0, $2d7ecd00adce73e7$export$e35c1996c6f482ad).Editing
};
const $2fd20af61ab7006c$var$parseProjectSamples = (samples)=>samples.map((sample)=>({
            id: sample.id,
            label: (0, $e07216757a3bd51c$export$915e191deda31e58)((0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)),
            status: (0, $2d7ecd00adce73e7$export$e35c1996c6f482ad).Editing
        }));
const $2fd20af61ab7006c$export$4c9873d4255a2b02 = (props)=>{
    const { project: project, projects: projects, answerProjectQuestion: answerProjectQuestion } = props;
    const [selectedProjectId, setSelectedProjectId] = (0, $acw62.useState)(project.id);
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const [removeProject] = (0, $7608a8bbcbbad14c$export$f734a850ac345d11)();
    const removeProjectAction = async ()=>{
        const variables = {
            projectId: selectedProjectId
        };
        const options = {
            variables: variables,
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$cd946050302ba91a),
                    variables: {}
                }
            ],
            awaitRefetchQueries: true
        };
        await removeProject(options);
    };
    const getTabs = (projectId, samples = [])=>{
        const parsedProjectSamples = $2fd20af61ab7006c$var$parseProjectSamples(samples);
        const tabs = [
            $2fd20af61ab7006c$var$projectDataTab,
            ...parsedProjectSamples
        ];
        const [addSampleToProjectMutation] = (0, $7608a8bbcbbad14c$export$c360d2acd2d92a13)();
        const newTabClick = async ()=>{
            setShowSpinner(true);
            const variables = {
                projectSampleInput: {
                    projectId: projectId
                }
            };
            const options = {
                variables: variables,
                refetchQueries: [
                    {
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        variables: {
                            id: projectId
                        }
                    },
                    {
                        query: (0, $7608a8bbcbbad14c$export$56959a2c3ec29cce),
                        variables: {
                            id: projectId
                        }
                    }
                ],
                awaitRefetchQueries: true,
                update (cache, { data: data }) {
                    (0, $590f4d6a0c375d80$export$6b98ed09a1b36987)({
                        id: projectId
                    }, (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96), "Project", "AddSampleToProject", cache, data, "samples");
                }
            };
            await addSampleToProjectMutation(options);
            setShowSpinner(false);
        };
        const selectTab = (sampleId)=>{
            if (sampleId === "1") // go to Project data tab
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator`);
            else (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator/samples/${sampleId}/configurator`);
        };
        return /*#__PURE__*/ $acw62.createElement((0, $37c3cbd3d47c5d4a$export$b2539bed5023c21c), {
            tabs: tabs,
            onTabClick: selectTab,
            activeTab: "1",
            onNewTabClick: newTabClick
        });
    };
    const questionLevelInput = {
        projectId: project.id
    };
    const projectName = (0, $30737cddea16cf18$export$2cd058184eb75757)(project);
    const handleProjectClick = (projectId)=>{
        setSelectedProjectId(projectId);
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator/`);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSpinner ? /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ $acw62.createElement((0, $c3ddc2046751dfe0$export$c7af6722a1a50f6c), {
        pageTitle: projectName,
        tabs: getTabs(project.id, project.samples),
        dropdownData: projects,
        selectedDropdownDataId: selectedProjectId,
        onDataClick: (projectId)=>handleProjectClick(projectId)
    }, /*#__PURE__*/ $acw62.createElement((0, $1e26fa3e7edc863b$export$aede49260422b749), {
        path: `/projects/${project.id}/timeline/samples/${project.samples[0].id}`,
        label: "Go to the timeline"
    }), project.selectedQuestionGroups.map((questionGroup, index)=>/*#__PURE__*/ $acw62.createElement((0, $f801bca6edd7fbeb$export$53faf303b8a97647), {
            title: questionGroup.name,
            key: questionGroup.id,
            stepNumber: index + 1,
            questionLevelInput: questionLevelInput,
            questionGroup: questionGroup,
            wrapped: !!index,
            answerQuestionCallback: answerProjectQuestion,
            wrapCardsCallback: ()=>{},
            goTo1stSampleCallback: ()=>{
                if (project.samples.length > 0) (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${project.id}/configurator/samples/${project.samples[0].id}`);
            },
            deleteProjectCallback: async ()=>{
                await removeProjectAction();
                await (0, $f125bbca2c654db8$export$ff7962acd6052c28)("/projects");
            },
            projectId: project.id,
            sampleId: project.samples[0].id
        }))));
};


const $53645720d811f12d$var$runQuestionAnswerMutationAfterMs = 1000;
let $53645720d811f12d$var$lastMetadata = null;
const $53645720d811f12d$export$4c9873d4255a2b02 = (props)=>{
    const urlQueryParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const queryResult = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: urlQueryParams.projectId
        }
    });
    const queryProjectsResult = (0, $7608a8bbcbbad14c$export$51199fd5d18fce87)({
        variables: {}
    });
    const projectWithMultiAnswer = (0, $7608a8bbcbbad14c$export$401940162089bc0d)()[0];
    const projectWithNumericAnswer = (0, $7608a8bbcbbad14c$export$83a028bb5e49d35f)()[0];
    const projectWithTextAnswer = (0, $7608a8bbcbbad14c$export$dc60d89c2de20f5c)()[0];
    const getMutationBasedOnAnswerType = (answerType)=>{
        switch(answerType){
            case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
                return projectWithNumericAnswer;
            case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
                return projectWithMultiAnswer;
            default:
                return projectWithTextAnswer;
        }
    };
    const answerProjectQuestion = (metadata, answer)=>{
        const options = {
            variables: {
                answer: answer,
                projectQuestionInput: {
                    questionInput: metadata.questionInput,
                    projectId: metadata.questionLevelInput.projectId
                }
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: metadata.questionLevelInput.projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        };
        if (metadata?.questionInput?.questionId === "TEMP_PROJECT_Q_ID_name") options.refetchQueries.push({
            query: (0, $7608a8bbcbbad14c$export$cd946050302ba91a),
            variables: {
                id: ""
            }
        });
        const mutation = getMutationBasedOnAnswerType(metadata.answerType);
        if (metadata.answerType === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number) options.variables.answer = parseFloat(options.variables.answer) || 0;
        const mutationPromise = mutation(options);
        mutationPromise.catch((e)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e.toString());
        });
    };
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", queryResult.error);
    if (queryProjectsResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", queryProjectsResult.error);
    if (queryResult.loading || !queryResult.data || !queryResult.data.Project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    if (queryProjectsResult.loading || !queryProjectsResult.data || !queryProjectsResult.data.Projects) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const answerProjectQuestionDebouncedInternal = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(answerProjectQuestion, $53645720d811f12d$var$runQuestionAnswerMutationAfterMs, {
        leading: false,
        trailing: true
    });
    const answerProjectQuestionDebounced = (metadata, answear)=>{
        if ($53645720d811f12d$var$lastMetadata !== JSON.stringify(metadata)) {
            $53645720d811f12d$var$lastMetadata = JSON.stringify(metadata);
            answerProjectQuestionDebouncedInternal.flush();
        }
        answerProjectQuestionDebouncedInternal(metadata, answear);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fd20af61ab7006c$export$4c9873d4255a2b02), {
        project: queryResult.data.Project,
        projects: queryProjectsResult.data.Projects,
        answerProjectQuestion: answerProjectQuestionDebounced,
        ...props
    });
};


/* eslint-disable react/prop-types */ 
var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $a5a6cf231caf7103$export$6630c27b3745aeba = ()=>{
    return /*#__PURE__*/ $acw62.createElement($a5a6cf231caf7103$var$Header, null, /*#__PURE__*/ $acw62.createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        label: "Design a research workflow for a sample by selecting individual services and choose the optimal Leaderna's package"
    }, /*#__PURE__*/ $acw62.createElement($a5a6cf231caf7103$var$Description, null, "If you need any additional help, you can reach out to our team. We will be more than happy to suggest our service packages to match the exact needs for your research. To ease up selection process, platform automatically recommends service packages that suits project & sample specification based on your preferences.")));
};
const $a5a6cf231caf7103$var$Header = (0, $lmFrL.default).div`
  &:after {
    content: " ";
    width: 67%;
    border-top: 1px solid #dedede;
    margin-top: 32px;
    margin-bottom: 32px;
    display: block;
  }
`;
const $a5a6cf231caf7103$var$Description = (0, $lmFrL.default).div`
  width: 60%;
`;


const $bb6435b9b5475ea1$var$getSelectedServicesCount = (services)=>{
    return services.filter((service)=>service.selected).length;
};
const $bb6435b9b5475ea1$export$bef6099e958fdd10 = (arrayToSort)=>{
    const array = [
        ...arrayToSort
    ];
    const sortedArray = array.sort((w1, w2)=>{
        const w1ServicesCount = $bb6435b9b5475ea1$var$getSelectedServicesCount(w1.services);
        const w2ServicesCount = $bb6435b9b5475ea1$var$getSelectedServicesCount(w2.services);
        if (w1ServicesCount < w2ServicesCount) return 1;
        if (w1ServicesCount > w2ServicesCount) return -1;
        return 0;
    }).sort((w1, w2)=>{
        const w1ServicesCount = $bb6435b9b5475ea1$var$getSelectedServicesCount(w1.services);
        const w2ServicesCount = $bb6435b9b5475ea1$var$getSelectedServicesCount(w2.services);
        if (w1ServicesCount < w2ServicesCount || w1.services.length > w2.services.length) return 1;
        if (w1ServicesCount > w2ServicesCount || w1.services.length < w2.services.length) return -1;
        return 0;
    });
    return sortedArray;
};


const $f3b9651ac67e6e6d$export$2255fad869368d36 = (workflows, selectedServices)=>{
    const recommendedArray = [];
    const suggestedArray = [];
    const othersArray = [];
    if (selectedServices && selectedServices.length !== 0) workflows?.forEach((workflow)=>{
        const workflowCommon = {
            id: workflow.id,
            name: workflow.name,
            services: []
        };
        let isRecommended = false;
        let isSuggested = false;
        const matchingServices = [];
        workflow.services.forEach((service)=>{
            let serviceCommon = {
                id: service.id,
                name: service.name,
                tip: service.description
            };
            if (selectedServices.includes(service.name)) {
                isSuggested = true;
                isRecommended = true;
                serviceCommon = {
                    ...serviceCommon,
                    selected: true
                };
                if (!matchingServices.includes(service.name)) matchingServices.push(service.name);
            }
            workflowCommon.services.push({
                ...serviceCommon
            });
        });
        if (isRecommended && selectedServices.length === matchingServices.length) recommendedArray.push({
            ...workflowCommon
        });
        else if (isSuggested) suggestedArray.push({
            ...workflowCommon
        });
        else othersArray.push({
            ...workflowCommon
        });
    });
    return {
        recommended: (0, $bb6435b9b5475ea1$export$bef6099e958fdd10)(recommendedArray),
        suggested: (0, $bb6435b9b5475ea1$export$bef6099e958fdd10)(suggestedArray),
        others: (0, $bb6435b9b5475ea1$export$bef6099e958fdd10)(othersArray)
    };
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $3d78480098346730$export$5c6c48580631eddb = /*#__PURE__*/ function(ServiceCardTag) {
    ServiceCardTag["Recommended"] = "Recommended";
    ServiceCardTag["Suggested"] = "Suggested";
    ServiceCardTag["Added"] = "Added";
    return ServiceCardTag;
}({});



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
// @flow

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $b28213cfae84dc19$export$681147733b538e56 = (props)=>{
    const { title: title, description: description, selectedCount: selectedCount } = props;
    return /*#__PURE__*/ $acw62.createElement($b28213cfae84dc19$var$Container, null, /*#__PURE__*/ $acw62.createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        label: title
    }, description), /*#__PURE__*/ $acw62.createElement($b28213cfae84dc19$var$LabelTagStyled, null, /*#__PURE__*/ $acw62.createElement((0, $fd090f2967b171e4$export$9dacaafb9baa8abc), {
        name: `${selectedCount} Selected`
    })));
};
const $b28213cfae84dc19$var$Container = (0, $lmFrL.default).div`
  position: relative;
`;
const $b28213cfae84dc19$var$LabelTagStyled = (0, $lmFrL.default).div`
  position: absolute;
  top: 0;
  right: 0;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

const $45d53b86e591d2a6$export$25435839742ff495 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0.151171 0.151171C0.352732 -0.0503902 0.679526 -0.0503902 0.881087 0.151171L8.25806 7.52815V0.516129C8.25806 0.231079 8.48914 7.69092e-09 8.77419 7.69092e-09C9.05924 7.69092e-09 9.29032 0.231079 9.29032 0.516129V8.77369C9.29032 8.78194 9.29013 8.79071 9.28973 8.79895C9.28692 8.85787 9.27406 8.9164 9.25116 8.97176C9.22597 9.03263 9.18864 9.08967 9.13915 9.13915C9.08967 9.18864 9.03263 9.22597 8.97176 9.25116C8.9118 9.27602 8.84614 9.28991 8.77729 9.29031L8.77419 9.29032H0.516129C0.231079 9.29032 7.69092e-09 9.05924 7.69092e-09 8.77419C7.69092e-09 8.48914 0.231079 8.25806 0.516129 8.25806H7.52815L0.151171 0.881087C-0.0503902 0.679526 -0.0503902 0.352732 0.151171 0.151171Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M23.2258 9.29032L23.2227 9.29031C23.1539 9.28991 23.0882 9.27602 23.0282 9.25116C22.9674 9.22597 22.9103 9.18864 22.8608 9.13915C22.8114 9.08967 22.774 9.03263 22.7488 8.97176C22.7259 8.9164 22.7131 8.85787 22.7103 8.79895C22.7099 8.79071 22.7097 8.78245 22.7097 8.77419V0.516129C22.7097 0.231079 22.9408 7.69092e-09 23.2258 7.69092e-09C23.5109 7.69092e-09 23.7419 0.231079 23.7419 0.516129V7.52815L31.1189 0.151171C31.3205 -0.0503902 31.6473 -0.0503902 31.8488 0.151171C32.0504 0.352732 32.0504 0.679526 31.8488 0.881087L24.4719 8.25806H31.4839C31.7689 8.25806 32 8.48914 32 8.77419C32 9.05924 31.7689 9.29032 31.4839 9.29032H23.2258Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0.151171 31.1189L7.52815 23.7419H0.516129C0.231079 23.7419 7.69092e-09 23.5109 7.69092e-09 23.2258C7.69092e-09 22.9408 0.231079 22.7097 0.516129 22.7097H8.77419C8.84418 22.7097 8.9109 22.7236 8.97176 22.7488C9.03263 22.774 9.08967 22.8114 9.13915 22.8608C9.18864 22.9103 9.22597 22.9674 9.25116 23.0282C9.27406 23.0836 9.28692 23.1421 9.28973 23.201C9.29013 23.2093 9.29032 23.2176 9.29032 23.2258V31.4839C9.29032 31.7689 9.05924 32 8.77419 32C8.48914 32 8.25806 31.7689 8.25806 31.4839V24.4719L0.881087 31.8488C0.679526 32.0504 0.352732 32.0504 0.151171 31.8488C-0.0503902 31.6473 -0.0503902 31.3205 0.151171 31.1189Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M31.8488 31.1189L24.4719 23.7419H31.4839C31.7689 23.7419 32 23.5109 32 23.2258C32 22.9408 31.7689 22.7097 31.4839 22.7097H23.2258C23.2176 22.7097 23.2093 22.7099 23.201 22.7103C23.1421 22.7131 23.0836 22.7259 23.0282 22.7488C22.9674 22.774 22.9103 22.8114 22.8608 22.8608C22.8114 22.9103 22.774 22.9674 22.7488 23.0282C22.7236 23.0891 22.7097 23.1558 22.7097 23.2258V31.4839C22.7097 31.7689 22.9408 32 23.2258 32C23.5109 32 23.7419 31.7689 23.7419 31.4839V24.4719L31.1189 31.8488C31.3205 32.0504 31.6473 32.0504 31.8488 31.8488C32.0504 31.6473 32.0504 31.3205 31.8488 31.1189Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 10.3226C12.8644 10.3226 10.3226 12.8644 10.3226 16C10.3226 19.1356 12.8644 21.6774 16 21.6774C19.1356 21.6774 21.6774 19.1356 21.6774 16C21.6774 12.8644 19.1356 10.3226 16 10.3226ZM11.3548 16C11.3548 13.4345 13.4345 11.3548 16 11.3548C18.5655 11.3548 20.6452 13.4345 20.6452 16C20.6452 18.5655 18.5655 20.6452 16 20.6452C13.4345 20.6452 11.3548 18.5655 11.3548 16Z",
        fill: color
    }));
};
$45d53b86e591d2a6$export$25435839742ff495.defaultProps = {
    width: "32",
    height: "32",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
};


const $c650cf9edadbcb0e$export$7e28701e4994d106 = (props)=>{
    const { title: title, description: description } = props;
    return /*#__PURE__*/ $acw62.createElement($c650cf9edadbcb0e$var$Container, null, /*#__PURE__*/ $acw62.createElement($c650cf9edadbcb0e$var$Icon, null, /*#__PURE__*/ $acw62.createElement((0, $45d53b86e591d2a6$export$25435839742ff495), null)), /*#__PURE__*/ $acw62.createElement($c650cf9edadbcb0e$var$TextContainer, null, /*#__PURE__*/ $acw62.createElement($c650cf9edadbcb0e$var$Title, null, title), /*#__PURE__*/ $acw62.createElement($c650cf9edadbcb0e$var$Description, null, description)));
};
const $c650cf9edadbcb0e$var$Container = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: row;
`;
const $c650cf9edadbcb0e$var$Icon = (0, $lmFrL.default).div`
  margin-right: 12px;
`;
const $c650cf9edadbcb0e$var$TextContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
`;
const $c650cf9edadbcb0e$var$Title = (0, $lmFrL.default).div`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.01em;

  width: 100%;

  color: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
`;
const $c650cf9edadbcb0e$var$Description = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;

  color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $3b8b46a489cc0321$export$8d9163a4b3454cd5 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($3b8b46a489cc0321$var$Container, null, /*#__PURE__*/ $acw62.createElement($3b8b46a489cc0321$var$Text, null, props.text), /*#__PURE__*/ $acw62.createElement($3b8b46a489cc0321$var$SeparatorContainer, null, /*#__PURE__*/ $acw62.createElement($3b8b46a489cc0321$var$Separator, null)));
};
const $3b8b46a489cc0321$var$Container = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $3b8b46a489cc0321$var$Text = (0, $lmFrL.default).div`
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  margin-right: 8px;

  color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
`;
const $3b8b46a489cc0321$var$SeparatorContainer = (0, $lmFrL.default).div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $3b8b46a489cc0321$var$Separator = (0, $lmFrL.default).hr`
  width: 100%;
  height: 0;

  border-top: 1px solid
    ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




const $b0b92243bbf3da66$export$a8e502cdcb65dd46 = (props)=>{
    const { name: name, selected: selected, disabled: disabled, tip: tip } = props;
    return /*#__PURE__*/ $acw62.createElement($b0b92243bbf3da66$var$ServiceContainer, {
        selected: selected,
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement($b0b92243bbf3da66$var$ServicePillContent, null, /*#__PURE__*/ $acw62.createElement($b0b92243bbf3da66$var$ServiceIcon, null, /*#__PURE__*/ $acw62.createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
        width: "20",
        height: "20",
        color: disabled ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.disabled : (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray,
        secondColor: disabled ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder : (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
    })), /*#__PURE__*/ $acw62.createElement($b0b92243bbf3da66$var$ServiceName, null, name), tip && /*#__PURE__*/ $acw62.createElement($b0b92243bbf3da66$var$ServiceTip, null, /*#__PURE__*/ $acw62.createElement((0, $213b3ea45c5c64eb$export$28c660c63b792dea), {
        text: tip,
        place: "right"
    }, /*#__PURE__*/ $acw62.createElement((0, $13f85ea00a6416c9$export$bb4d7813766e20d3), {
        color: disabled ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder : (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray,
        width: "16",
        height: "16"
    })))));
};
const $b0b92243bbf3da66$var$ServiceContainer = (0, $lmFrL.default).div`
  padding: 6px 8px;
  background: ${({ theme: theme, selected: selected })=>selected ? theme.newColors.grayscale.background : theme.newColors.grayscale.white};
  border-radius: 4px;

  ${({ disabled: disabled, theme: theme })=>disabled && (0, $lmFrL.css)`
      background: ${theme.newColors.grayscale.white};

      div {
        color: ${theme.newColors.grayscale.placeholder};
      }
    `}
`;
const $b0b92243bbf3da66$var$ServicePillContent = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  height: 20px;
  margin: 0 -4px;

  & > div {
    margin: 0 4px;
  }
`;
const $b0b92243bbf3da66$var$ServiceIcon = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $b0b92243bbf3da66$var$ServiceName = (0, $lmFrL.default).div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  width: 100%;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
`;
const $b0b92243bbf3da66$var$ServiceTip = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;



// @flow

var $acw62 = parcelRequire("acw62");

const $3b9bf177ba8611a6$export$a6b7c34d56975de0 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.88878 2.6665H7.111V7.11092H2.6665V8.8887H7.111V13.3332H8.88878V8.8887H13.3332V7.11092H8.88878V2.6665Z",
        fill: color
    }));
};
$3b9bf177ba8611a6$export$a6b7c34d56975de0.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



var $acw62 = parcelRequire("acw62");

const $b4e3c31e4b687f6d$export$6382847193091a26 = (props)=>{
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 7H14V9H2V7Z",
        fill: color
    }));
};
$b4e3c31e4b687f6d$export$6382847193091a26.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



const $14710affd9bdeae9$export$1e569385ec4f50ff = (props)=>{
    const { id: id, title: title, services: services, selected: selected, onClick: onClick, metaData: metaData, disabled: disabled } = props;
    const count = services.length;
    const onButtonClicked = ()=>{
        onClick(metaData);
    };
    return /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$Container, null, /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$Content, null, /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$Header, null, /*#__PURE__*/ $acw62.createElement((0, $c650cf9edadbcb0e$export$7e28701e4994d106), {
        title: title,
        description: `${count} Services`
    })), /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$IncludedServices, null, /*#__PURE__*/ $acw62.createElement((0, $3b8b46a489cc0321$export$8d9163a4b3454cd5), {
        text: "What's included"
    }), /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$ServicesList, null, services.map((service)=>/*#__PURE__*/ $acw62.createElement((0, $b0b92243bbf3da66$export$a8e502cdcb65dd46), {
            key: id + service.id,
            name: service.name,
            tip: service.tip,
            disabled: service.disabled,
            selected: service.selected
        }))))), /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$Footer, null, /*#__PURE__*/ $acw62.createElement($14710affd9bdeae9$var$StyledButton, {
        label: selected ? "Remove" : "Add",
        type: selected ? (0, $26e621062d296af4$export$d3d950cd69e1ac66).Tertiary : (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
        icon: selected ? /*#__PURE__*/ $acw62.createElement((0, $b4e3c31e4b687f6d$export$6382847193091a26), null) : /*#__PURE__*/ $acw62.createElement((0, $3b9bf177ba8611a6$export$a6b7c34d56975de0), null),
        onClick: onButtonClicked,
        disabled: disabled
    })));
};
const $14710affd9bdeae9$var$StyledButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  width: 100%;
`;
const $14710affd9bdeae9$var$Container = (0, $lmFrL.default).div`
  background: ${({ theme: theme })=>theme.newColors.grayscale.white};

  border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.bordersInside};
  box-sizing: border-box;
  border-radius: 4px;

  width: 290px;
  height: fit-content;
`;
const $14710affd9bdeae9$var$Content = (0, $lmFrL.default).div`
  padding: 24px 22.5px 16px 22.5px;
`;
const $14710affd9bdeae9$var$Header = (0, $lmFrL.default).div`
  margin-bottom: 24px;
`;
const $14710affd9bdeae9$var$IncludedServices = (0, $lmFrL.default).div`
  padding: 0 2px;
`;
const $14710affd9bdeae9$var$ServicesList = (0, $lmFrL.default).div`
  margin-top: 16px;

  & > div:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const $14710affd9bdeae9$var$Footer = (0, $lmFrL.default).div`
  padding: 12px 23px;

  background: ${({ theme: theme })=>theme.newColors.grayscale.background};
  border-radius: 0px 0px 3px 3px;
`;


const $d7bfb388214fc79e$var$getWithTag = (card, selected, tag)=>{
    const realTag = selected ? (0, $3d78480098346730$export$5c6c48580631eddb).Added : tag;
    if (!realTag) return card;
    return /*#__PURE__*/ $acw62.createElement($d7bfb388214fc79e$var$Container, {
        tag: realTag
    }, /*#__PURE__*/ $acw62.createElement($d7bfb388214fc79e$var$Header, null, realTag), card);
};
const $d7bfb388214fc79e$export$47e19cb482b7c646 = ({ tag: tag, ...props })=>{
    const [selected, setSelected] = (0, $acw62.useState)(props.selected || false);
    const onClick = (metaData)=>{
        if (props.onAction) {
            setSelected(!selected);
            props.onAction(metaData, selected);
        }
    };
    return $d7bfb388214fc79e$var$getWithTag(/*#__PURE__*/ $acw62.createElement((0, $14710affd9bdeae9$export$1e569385ec4f50ff), {
        ...props,
        selected: selected,
        onClick: onClick
    }), selected, tag);
};
const $d7bfb388214fc79e$var$Header = (0, $lmFrL.default).div`
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;

  color: ${(props)=>props.theme.newColors.grayscale.white};
  align-self: center;
  padding: 4px;
`;
const $d7bfb388214fc79e$var$Container = (0, $lmFrL.default).div`
  ${(props)=>{
    switch(props.tag){
        case (0, $3d78480098346730$export$5c6c48580631eddb).Recommended:
            return (0, $lmFrL.css)`
          background: ${props.theme.newColors.grayscale.primaryGray};
          border-radius: 4px;
          height: fit-content;
          & > div:not(:first-child) {
            border: 1px solid ${props.theme.newColors.grayscale.primaryGray};
          }
        `;
        case (0, $3d78480098346730$export$5c6c48580631eddb).Suggested:
            return (0, $lmFrL.css)`
          background: ${props.theme.newColors.grayscale.secondaryGray};
          border-radius: 4px;
          height: fit-content;
          & > div:not(:first-child) {
            border: 1px solid ${props.theme.newColors.grayscale.secondaryGray};
          }
        `;
        case (0, $3d78480098346730$export$5c6c48580631eddb).Added:
            return (0, $lmFrL.css)`
          background: ${props.theme.newColors.primary.basic};
          border-radius: 4px;
          height: fit-content;
          & > div:not(:first-child) {
            border: 1px solid ${props.theme.newColors.primary.basic};
          }
        `;
        default:
            return ``;
    }
}}
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $f52f906ca2d88b40$export$e6e3be48196e70af = (props)=>{
    const children = [
        ...props.children
    ];
    const firstColumn = children.slice(0, Math.round(children.length / 2));
    const secondColumn = children.slice(Math.round(children.length / 2), children.length);
    return /*#__PURE__*/ $acw62.createElement($f52f906ca2d88b40$var$Container, null, /*#__PURE__*/ $acw62.createElement($f52f906ca2d88b40$var$Column, null, firstColumn), /*#__PURE__*/ $acw62.createElement($f52f906ca2d88b40$var$Column, null, secondColumn));
};
const $f52f906ca2d88b40$var$Container = (0, $lmFrL.default).div`
  display: flex;
  margin-left: -16px;
  width: auto;
  flex-wrap: wrap;
`;
const $f52f906ca2d88b40$var$Column = (0, $lmFrL.default).div`
  padding-left: 16px;
  background-clip: padding-box;

  & > div {
    margin-bottom: 17px;
  }
`;


const $56d5d326ec571c76$export$ffdfade4e5529fbf = (props)=>{
    const { workflows: workflows, tag: tag, title: title, description: description, projectId: projectId, sampleId: sampleId, onAction: onAction, selectedWorkflowsIds: selectedWorkflowsIds, removeDisabled: removeDisabled } = props;
    const checkSelection = (workflowId)=>{
        return selectedWorkflowsIds && selectedWorkflowsIds.includes(workflowId);
    };
    const getSelectedCounts = ()=>{
        return selectedWorkflowsIds && selectedWorkflowsIds.filter((workflowId)=>workflows.map((workflow)=>workflow.id).includes(workflowId)).length || 0;
    };
    const onClick = (metadata, unselect)=>{
        onAction(metadata, unselect);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $b28213cfae84dc19$export$681147733b538e56), {
        title: title,
        description: description,
        selectedCount: getSelectedCounts() || 0
    }), /*#__PURE__*/ $acw62.createElement($56d5d326ec571c76$var$ServicePacks, null, /*#__PURE__*/ $acw62.createElement((0, $f52f906ca2d88b40$export$e6e3be48196e70af), null, workflows.map((workflow)=>workflow && /*#__PURE__*/ $acw62.createElement((0, $d7bfb388214fc79e$export$47e19cb482b7c646), {
            key: workflow.id,
            id: workflow.id,
            title: workflow.name,
            services: workflow.services,
            onAction: onClick,
            metaData: {
                projectId: projectId,
                sampleId: sampleId,
                workflowId: workflow.id
            },
            tag: tag,
            selected: checkSelection(workflow.id),
            disabled: removeDisabled
        })))));
};
const $56d5d326ec571c76$var$ServicePacks = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $1a63ebed5cb0ee52$export$bba2dac6148063a6 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($1a63ebed5cb0ee52$var$Container, {
        className: props.className
    }, /*#__PURE__*/ $acw62.createElement($1a63ebed5cb0ee52$var$Content, null, /*#__PURE__*/ $acw62.createElement($1a63ebed5cb0ee52$var$ImageContainer, null, /*#__PURE__*/ $acw62.createElement((0, $3dd9f433765cfde8$export$e2391d0682fa90d6), {
        width: 48,
        height: 48,
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
        secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.gray05,
        thirdColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText
    })), /*#__PURE__*/ $acw62.createElement($1a63ebed5cb0ee52$var$StyledLabel, {
        label: "List of service packages will appear here."
    }, "Once you will select at least one desired service from the list, packages will appear below. The more services you select, the closer platform suggestions will be.")));
};
const $1a63ebed5cb0ee52$var$StyledLabel = (0, $lmFrL.default)((0, $d1cfb23e53b30236$export$b04be29aa201d4f5))`
  margin: auto !important;
`;
const $1a63ebed5cb0ee52$var$Container = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $1a63ebed5cb0ee52$var$Content = (0, $lmFrL.default).div`
  width: 381px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const $1a63ebed5cb0ee52$var$ImageContainer = (0, $lmFrL.default).div`
  background: ${({ theme: theme })=>theme.colors.gray05};
  width: 96px;
  height: 96px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;


const $e76be33a36d52d7e$export$d04c69929fc6b8f = (props)=>{
    const { recommendedWorkflows: recommendedWorkflows, suggestedWorkflows: suggestedWorkflows, othersWorkflows: othersWorkflows } = props.workflows;
    const { selectedWorkflows: selectedWorkflows, removeDisabled: removeDisabled, selectedWorkflowsIds: selectedWorkflowsIds } = props;
    const servicePacksProps = {
        projectId: props.projectId,
        sampleId: props.sampleId
    };
    const isRecommendedEmpty = recommendedWorkflows.length === 0;
    const isSuggestedEmpty = suggestedWorkflows.length === 0;
    const isOthersEmpty = othersWorkflows.length === 0;
    if (isRecommendedEmpty && isSuggestedEmpty && isOthersEmpty || removeDisabled) {
        if (selectedWorkflows && selectedWorkflows.length > 0) return /*#__PURE__*/ $acw62.createElement($e76be33a36d52d7e$var$Container, {
            className: props.className
        }, /*#__PURE__*/ $acw62.createElement((0, $56d5d326ec571c76$export$ffdfade4e5529fbf), {
            ...servicePacksProps,
            workflows: selectedWorkflows,
            title: "Selected service packages",
            description: "Below you can find list of selected service packages which were selected before.",
            onAction: props.onAction,
            selectedWorkflowsIds: selectedWorkflowsIds,
            removeDisabled: removeDisabled
        }));
        return /*#__PURE__*/ $acw62.createElement((0, $1a63ebed5cb0ee52$export$bba2dac6148063a6), {
            className: props.className
        });
    }
    return /*#__PURE__*/ $acw62.createElement($e76be33a36d52d7e$var$Container, {
        className: props.className
    }, !isRecommendedEmpty && /*#__PURE__*/ $acw62.createElement((0, $56d5d326ec571c76$export$ffdfade4e5529fbf), {
        ...servicePacksProps,
        workflows: recommendedWorkflows,
        tag: (0, $3d78480098346730$export$5c6c48580631eddb).Recommended,
        title: "Recommended service packages",
        description: "Below you can find list of service packages recommended for your sample, based on your \u2028choices.",
        selectedWorkflowsIds: selectedWorkflowsIds,
        onAction: props.onAction,
        removeDisabled: false
    }), !isSuggestedEmpty && /*#__PURE__*/ $acw62.createElement((0, $56d5d326ec571c76$export$ffdfade4e5529fbf), {
        ...servicePacksProps,
        workflows: suggestedWorkflows,
        tag: (0, $3d78480098346730$export$5c6c48580631eddb).Suggested,
        title: "Suggested service packages",
        description: "Below you can find the list of service packages that we offer in Leaderna Platform. Adding those packages will create a list of questions that will allow us to offer you a price and time estimates.",
        selectedWorkflowsIds: selectedWorkflowsIds,
        onAction: props.onAction,
        removeDisabled: false
    }), !isOthersEmpty && /*#__PURE__*/ $acw62.createElement((0, $56d5d326ec571c76$export$ffdfade4e5529fbf), {
        ...servicePacksProps,
        workflows: othersWorkflows,
        title: "Other service packages",
        description: "Below you can find all of the other service packages offered by Leaderna.",
        selectedWorkflowsIds: selectedWorkflowsIds,
        onAction: props.onAction,
        removeDisabled: false
    }));
};
const $e76be33a36d52d7e$var$Container = (0, $lmFrL.default).div`
  margin-left: 16px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $bf1ca04c20d814f3$export$a1dc0adca9646c07 = (props)=>{
    const { children: children, title: title, count: count, wrapped: wrapped, wrapGroupCallback: wrapGroupCallback } = props;
    const groupMarker = wrapped ? "\u25BE" : "\u25B8";
    return /*#__PURE__*/ $acw62.createElement($bf1ca04c20d814f3$var$ServiceGroupContainer, null, /*#__PURE__*/ $acw62.createElement($bf1ca04c20d814f3$var$Title, {
        onClick: wrapGroupCallback
    }, groupMarker, " ", title, " \u2022 ", count), !wrapped ? /*#__PURE__*/ $acw62.createElement($bf1ca04c20d814f3$var$Elements, null, children) : null);
};
const $bf1ca04c20d814f3$var$Title = (0, $lmFrL.default).div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  cursor: pointer;
  font-weight: bold;

  color: ${({ theme: theme })=>theme.newColors.grayscale.primaryGray};
`;
const $bf1ca04c20d814f3$var$Elements = (0, $lmFrL.default).div`
  & > div {
    margin: 6px 0;
  }
`;
const $bf1ca04c20d814f3$var$ServiceGroupContainer = (0, $lmFrL.default).div`
  margin-bottom: 12px;
`;



const $d3243cd8830e0ec5$export$c447b0cdbd1cd184 = (props)=>{
    const { services: services, onServiceChecked: onServiceChecked, selectedServices: selectedServices } = props;
    const servicesGroups = [];
    const servicesGroupsNames = [];
    services.forEach((service)=>{
        if (!servicesGroupsNames.includes(service.serviceType)) {
            servicesGroupsNames.push(service.serviceType);
            servicesGroups.push({
                serviceGroupName: service.serviceType,
                services: []
            });
        }
    });
    services.forEach((service)=>{
        const groupIndex = servicesGroups.findIndex((group)=>group.serviceGroupName === service.serviceType);
        servicesGroups[groupIndex].services.push(service);
    });
    const initialWrappedGroupsState = servicesGroups.map((data, index)=>index !== 0); // first question group visible
    const [wrappedGroups, setWrappedGroups] = (0, $acw62.useState)(initialWrappedGroupsState);
    const wrapGroup = (questionGroupIndex)=>{
        const initialGroupState = wrappedGroups[questionGroupIndex];
        const groupsWrappedState = servicesGroups.map(()=>true);
        groupsWrappedState[questionGroupIndex] = !initialGroupState;
        setWrappedGroups(groupsWrappedState);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: props.className
    }, /*#__PURE__*/ $acw62.createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        label: "Pick services for you sample and design your sample workflow",
        help: "Platform will recommend service packages based upon your choices."
    }), /*#__PURE__*/ $acw62.createElement($d3243cd8830e0ec5$var$List, null, /*#__PURE__*/ $acw62.createElement($d3243cd8830e0ec5$var$Groups, null, servicesGroups.map((servicesGroup, index)=>/*#__PURE__*/ $acw62.createElement((0, $bf1ca04c20d814f3$export$a1dc0adca9646c07), {
            title: servicesGroup.serviceGroupName,
            count: servicesGroup.services ? servicesGroup.services.length : 0,
            key: servicesGroup.serviceGroupName,
            wrapped: wrappedGroups[index],
            wrapGroupCallback: ()=>{
                wrapGroup(index);
            }
        }, servicesGroup.services?.map((service)=>service && !service.hiddenOnTheList && /*#__PURE__*/ $acw62.createElement((0, $e226f22baf630209$export$48513f6b9f8ce62d), {
                key: service.id,
                labelText: service.name,
                value: service.id,
                tip: service.description,
                checked: selectedServices.includes(service.name),
                onChange: onServiceChecked
            }))))), /*#__PURE__*/ $acw62.createElement($d3243cd8830e0ec5$var$VerticalSeparator, null)));
};
const $d3243cd8830e0ec5$var$VerticalSeparator = (0, $lmFrL.default).hr`
  border: none;
  border-left: 1px solid #dedede;
  width: 1px;
  margin: 0 24px 15px 24px;
`;
const $d3243cd8830e0ec5$var$Groups = (0, $lmFrL.default).div`
  flex-grow: 1;
`;
const $d3243cd8830e0ec5$var$List = (0, $lmFrL.default).div`
  display: flex;
`;



const $70ea48a4c83a09ec$export$4756ac74c07f9b13 = (workflows, selectedWorkflowsIds)=>workflows.filter((workflow)=>selectedWorkflowsIds?.includes(workflow.id)).map((workflow)=>{
        return {
            id: workflow.id,
            name: workflow.name,
            services: workflow.services.map((service)=>{
                return {
                    id: service.id,
                    name: service.name,
                    tip: service.description
                };
            })
        };
    });


var $61265cbd5811e578$exports = {};
var $451cd6fc5b077ebe$exports = {};

var $a541279ebb64f2c9$exports = {};
var $565b5ed18efa4b9c$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;


var $c66d4063f81f4687$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
$c66d4063f81f4687$exports = $c66d4063f81f4687$var$baseIsNaN;


var $a1f1a90cd7caaefa$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a1f1a90cd7caaefa$exports = $a1f1a90cd7caaefa$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a1f1a90cd7caaefa$exports(array, value, fromIndex) : $a9e76203bd7c412f$exports(array, $c66d4063f81f4687$exports, fromIndex);
}
$565b5ed18efa4b9c$exports = $565b5ed18efa4b9c$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $565b5ed18efa4b9c$exports(array, value, 0) > -1;
}
$a541279ebb64f2c9$exports = $a541279ebb64f2c9$var$arrayIncludes;


var $ad409cc63f3cbe79$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$ad409cc63f3cbe79$exports = $ad409cc63f3cbe79$var$arrayIncludesWith;



var $3fa8e773494800f5$exports = {};

var $6c554e32feae9faa$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
$6c554e32feae9faa$exports = $6c554e32feae9faa$var$noop;



/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($05f44e958da968eb$exports && 1 / $11f509f8f53d8c36$exports(new $05f44e958da968eb$exports([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $6c554e32feae9faa$exports : function(values) {
    return new $05f44e958da968eb$exports(values);
};
$3fa8e773494800f5$exports = $3fa8e773494800f5$var$createSet;



/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $a541279ebb64f2c9$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $ad409cc63f3cbe79$exports;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3fa8e773494800f5$exports(array);
        if (set) return $11f509f8f53d8c36$exports(set);
        isCommon = false;
        includes = $1b44096ad4b9e2d5$exports;
        seen = new $a29ccdc0f60e279e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$451cd6fc5b077ebe$exports = $451cd6fc5b077ebe$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $61265cbd5811e578$var$uniq(array) {
    return array && array.length ? $451cd6fc5b077ebe$exports(array) : [];
}
$61265cbd5811e578$exports = $61265cbd5811e578$var$uniq;



const $e8b22a6a79a95ba8$export$d9eaec88f6ad5e14 = (workflows, selectedWorkflowsIds)=>{
    const workflowsArray = (0, $70ea48a4c83a09ec$export$4756ac74c07f9b13)(workflows, selectedWorkflowsIds);
    const servicesIds = [];
    workflowsArray.forEach((wrk)=>wrk.services.forEach((service)=>servicesIds.push(service.name)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($61265cbd5811e578$exports)))(servicesIds);
};


const $5c20795a5ab0718b$export$cd37dc451dc8443 = (props)=>{
    const { services: services, workflows: workflows, serviceCardButtonAction: serviceCardButtonAction, projectId: projectId, sampleId: sampleId, selectedWorkflowsIds: selectedWorkflowsIds, removeDisabled: removeDisabled } = props;
    const [selectedServices, setSelectedServices] = (0, $acw62.useState)(null);
    const [recommendedWorkflows, setRecommendedWorkflows] = (0, $acw62.useState)([]);
    const [suggestedWorkflows, setSuggestedWorkflows] = (0, $acw62.useState)([]);
    const [othersWorkflows, setOthersWorkflows] = (0, $acw62.useState)([]);
    const [selectedWorkflows, setSelectedWorkflows] = (0, $acw62.useState)((0, $70ea48a4c83a09ec$export$4756ac74c07f9b13)(workflows, selectedWorkflowsIds));
    (0, $acw62.useEffect)(()=>{
        const { recommended: recommended, suggested: suggested, others: others } = (0, $f3b9651ac67e6e6d$export$2255fad869368d36)(workflows, selectedServices);
        setRecommendedWorkflows(recommended);
        setSuggestedWorkflows(suggested);
        setOthersWorkflows(others);
        setSelectedWorkflows((0, $70ea48a4c83a09ec$export$4756ac74c07f9b13)(workflows, selectedWorkflowsIds));
    }, [
        selectedServices
    ]);
    (0, $acw62.useEffect)(()=>{
        setSelectedServices([
            ...(0, $e8b22a6a79a95ba8$export$d9eaec88f6ad5e14)(workflows, selectedWorkflowsIds)
        ]);
    }, []);
    const addSelectedService = (value)=>{
        if (selectedServices) setSelectedServices([
            ...selectedServices,
            value
        ]);
    };
    const removeSelectedService = (value)=>{
        if (selectedServices) {
            const array = [
                ...selectedServices
            ];
            const index = array.indexOf(value);
            if (index !== -1) {
                array.splice(index, 1);
                setSelectedServices(array);
            }
        }
    };
    const onServiceChecked = (e)=>{
        return e.checked ? addSelectedService(e.name) : removeSelectedService(e.name);
    };
    return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $a5a6cf231caf7103$export$6630c27b3745aeba), null), /*#__PURE__*/ $acw62.createElement($5c20795a5ab0718b$var$Content, null, !removeDisabled && (selectedServices ? /*#__PURE__*/ $acw62.createElement($5c20795a5ab0718b$var$StyledServices, {
        services: services,
        selectedServices: selectedServices,
        onServiceChecked: onServiceChecked
    }) : /*#__PURE__*/ $acw62.createElement($5c20795a5ab0718b$var$StyledLoader, null)), /*#__PURE__*/ $acw62.createElement($5c20795a5ab0718b$var$StyledServicePacks, {
        projectId: projectId,
        sampleId: sampleId,
        workflows: {
            recommendedWorkflows: recommendedWorkflows,
            suggestedWorkflows: suggestedWorkflows,
            othersWorkflows: othersWorkflows
        },
        selectedWorkflows: selectedWorkflows,
        onAction: serviceCardButtonAction,
        removeDisabled: removeDisabled,
        selectedWorkflowsIds: selectedWorkflowsIds
    })));
};
const $5c20795a5ab0718b$var$StyledLoader = (0, $lmFrL.default)((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2))`
  width: 476px;
`;
const $5c20795a5ab0718b$var$StyledServices = (0, $lmFrL.default)((0, $d3243cd8830e0ec5$export$c447b0cdbd1cd184))`
  width: 476px;
`;
const $5c20795a5ab0718b$var$StyledServicePacks = (0, $lmFrL.default)((0, $e76be33a36d52d7e$export$d04c69929fc6b8f))`
  width: 620px;
`;
const $5c20795a5ab0718b$var$Content = (0, $lmFrL.default).div`
  display: flex;
`;



const $b5c88c807253826c$export$16e5151cb4c38864 = (props)=>{
    const [showSpinner, setShowSpinner] = $acw62.useState(false);
    const selectWorkflowInProjectSampleMutation = (0, $7608a8bbcbbad14c$export$e1f6df16af32d0fc)()[0];
    const unselectWorkflowInProjectSampleMutation = (0, $7608a8bbcbbad14c$export$7e20857809eeff1e)()[0];
    const getMutationForWorkflow = (unSelect)=>{
        if (unSelect) return unselectWorkflowInProjectSampleMutation;
        return selectWorkflowInProjectSampleMutation;
    };
    const workflowAction = async (metadata, unselect)=>{
        setShowSpinner(true);
        const options = {
            variables: {
                projectSampleWorkflowSelectInput: metadata
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: metadata.projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        };
        const mutation = getMutationForWorkflow(unselect);
        await mutation(options);
        props.workflowAction(metadata.workflowId, unselect);
        setShowSpinner(false);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSpinner ? /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ $acw62.createElement((0, $5c20795a5ab0718b$export$cd37dc451dc8443), {
        ...props,
        serviceCardButtonAction: workflowAction
    }));
};




const $de4fa3f953c8e349$export$c61885ea1ad3465d = ({ enableWorkflowsForProjectSample: enableWorkflowsForProjectSample, ...props })=>{
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const [selectedWorkflowsIds, setSelectedWorkflowsIds] = (0, $acw62.useState)(props.selectedWorkflowsIds || []);
    const selectWorkflow = (id)=>{
        setSelectedWorkflowsIds([
            ...selectedWorkflowsIds,
            id
        ]);
    };
    const removeWorkflow = (id)=>{
        const array = [
            ...selectedWorkflowsIds
        ];
        const index = array.indexOf(id);
        if (index !== -1) {
            array.splice(index, 1);
            setSelectedWorkflowsIds(array);
        }
    };
    const workflowAction = (id, unselect)=>{
        if (unselect) removeWorkflow(id);
        else selectWorkflow(id);
    };
    const enableWorkflowsForProjectSampleAndGoToNextCard = async ()=>{
        setShowSpinner(true);
        if (enableWorkflowsForProjectSample) await enableWorkflowsForProjectSample(selectedWorkflowsIds);
        if (props.goToNextGroupCallback) props.goToNextGroupCallback();
        setShowSpinner(false);
    };
    const getServiceConfiguratorSectionButtons = ()=>{
        const buttonAction = props.servicePackagesAlreadyAdded ? props.goToNextGroupCallback : enableWorkflowsForProjectSampleAndGoToNextCard;
        const buttonArray = [];
        if (props.goToNextGroupCallback) buttonArray.push(/*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Go to next section",
            onClick: props.goToNextGroupCallback
        }));
        buttonArray.push(/*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Configure your service packages",
            onClick: buttonAction,
            disabled: selectedWorkflowsIds.length === 0
        }));
        return buttonArray;
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSpinner ? /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ $acw62.createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        ...props,
        buttons: getServiceConfiguratorSectionButtons()
    }, /*#__PURE__*/ $acw62.createElement((0, $b5c88c807253826c$export$16e5151cb4c38864), {
        workflowAction: workflowAction,
        selectedWorkflowsIds: selectedWorkflowsIds,
        ...props
    })));
};






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $b4af7334d0fcef01$export$60fb4f810efc7de0 = ({ goToNextGroupCallback: goToNextGroupCallback, questionGroup: questionGroup, ...props })=>{
    const getSectionButtons = ()=>{
        if (goToNextGroupCallback) return [
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Go to next section",
                onClick: goToNextGroupCallback
            })
        ];
        return [];
    };
    const packageDescription = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(questionGroup, "questionSets[0].questions[0].answer.textBody", "In preparation");
    const formatPackageDescription = (text)=>{
        return text.split("\n").filter((paragraph)=>!!paragraph) // remove empty paragraphs
        .map((paragraph)=>/*#__PURE__*/ $acw62.createElement($b4af7334d0fcef01$var$StyledParagraph, {
                key: `${paragraph.substring(0, 8)}_${Math.random()}`
            }, paragraph));
    };
    return /*#__PURE__*/ $acw62.createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        ...props,
        buttons: getSectionButtons()
    }, /*#__PURE__*/ $acw62.createElement($b4af7334d0fcef01$var$TextContainer, null, formatPackageDescription(packageDescription)));
};
const $b4af7334d0fcef01$var$TextContainer = (0, $lmFrL.default).div`
  margin-right: 22px;
`;
const $b4af7334d0fcef01$var$StyledParagraph = (0, $lmFrL.default).p`
  text-align: justify;
  text-justify: inter-word;
  line-height: 1.5;
`;




var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");
const $254b2a5d9af30712$export$abcf0acb680d5c4f = ({ children: children, centered: centered })=>/*#__PURE__*/ $acw62.createElement($254b2a5d9af30712$var$StyledContentSimpleSection, null, /*#__PURE__*/ $acw62.createElement($254b2a5d9af30712$var$StyledChildren, {
        centered: centered
    }, children));
const $254b2a5d9af30712$var$StyledContentSimpleSection = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  border-radius: ${({ theme: theme })=>theme.radius.default};
  background-color: ${({ theme: theme })=>theme.newColors.grayscale.white};
  margin-bottom: 44px;
  box-shadow: ${({ theme: theme })=>theme.shadows.dropShadows.formCard};
  border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.bordersInside};

  &:not(:last-of-type) {
    :after {
      position: relative;
      bottom: -${({ theme: theme })=>theme.space[4]};
      left: ${({ theme: theme })=>theme.space[3]};
      height: 10px;
      width: 10px;
      content: url("data:image/svg+xml,%3Csvg width='4' height='20' viewBox='0 0 4 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='18' r='2' fill='%23C5C6CB'/%3E%3Ccircle cx='2' cy='10' r='2' fill='%23C5C6CB'/%3E%3Ccircle cx='2' cy='2' r='2' fill='%23C5C6CB'/%3E%3C/svg%3E");
    }
  }
`;
const $254b2a5d9af30712$var$StyledChildren = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  padding: 10px 27px;
  display: flex;

  ${({ centered: centered })=>centered && (0, $lmFrL.css)`
      justify-content: center;
    `}
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");














const $6b010ab846055fec$export$7ff8a395dfe1fcb1 = (props)=>{
    const { title: title, stepNumber: stepNumber, wrapped: wrapped, wrapCardsCallback: wrapCardsCallback, goToNextGroupCallback: goToNextGroupCallback, goTo1stSampleCallback: goTo1stSampleCallback, questionGroup: questionGroup, projectId: projectId, sampleId: sampleId, isReport: isReport = false, workflowId: workflowId, serviceId: serviceId } = props;
    const { saveCurrentSelectedEntityAndSet: saveCurrentSelectedEntityAndSet, setSelectedEntity: setSelectedEntity, selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const formQuestionsArray = (0, $08268787b704fc5c$export$61220de1105bad54)();
    function getCurrentNumberOfQuestions() {
        const questions = questionGroup.questionSets;
        return questions.reduce((accumulator, currentValue)=>accumulator + currentValue.questions.length, 0);
    }
    const [numberOfQuestions, setNumberOfQuestions] = $acw62.useState(getCurrentNumberOfQuestions());
    $acw62.useEffect(()=>{
        setNumberOfQuestions(getCurrentNumberOfQuestions());
    }, [
        questionGroup
    ]);
    const [removeQuestionsFromSampleMutation] = (0, $7608a8bbcbbad14c$export$87c29bb3ef00bd1f)();
    const handleFinishEditing = ()=>{
        setSelectedEntity(undefined);
        setSideDrawboardOpen(false);
    };
    const getSectionButtons = ()=>{
        if (goToNextGroupCallback) return [
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Finish Editing",
                onClick: handleFinishEditing
            }),
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Go to next section",
                onClick: goToNextGroupCallback
            })
        ];
        if (goTo1stSampleCallback) return [
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Go to 1st sample",
                onClick: goTo1stSampleCallback
            })
        ];
        return [
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Finish Editing",
                onClick: handleFinishEditing
            })
        ];
    };
    const deleteSelectedQuestion = (questionSet, questionItem)=>{
        if (selectedEntity) {
            const { questionGroupId: questionGroupId } = selectedEntity.selectedElementPath;
            const options = {
                variables: {
                    projectSampleInput: {
                        projectId: projectId,
                        sampleId: sampleId,
                        fromReport: isReport,
                        workflowId: workflowId,
                        serviceId: serviceId
                    },
                    questionGroupId: questionGroupId,
                    questionSetId: questionSet.id,
                    questionIds: [
                        questionItem.id
                    ]
                },
                update (cache, mutationResult) {
                    (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("RemoveQuestionsFromSample", cache, mutationResult, projectId, sampleId);
                }
            };
            removeQuestionsFromSampleMutation(options);
        }
    };
    const getFormQuestion = (id, questionObject)=>{
        const formElement = formQuestionsArray.find((question)=>question.id === id);
        if (formElement) return formElement.createComponent(questionObject);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    };
    const componentEditModeAvailable = (answerType)=>{
        const formElement = formQuestionsArray.find((question)=>question.id === answerType);
        return formElement?.editMode;
    };
    const handleOnQuestionEdit = (questionSet, question)=>{
        setSideDrawboardOpen(true);
        saveCurrentSelectedEntityAndSet({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION,
            selectedElementPath: {
                projectId: projectId,
                sampleId: sampleId,
                questionGroupId: questionGroup.id,
                questionId: question.id,
                questionSetId: questionSet.id,
                questionName: question.question,
                questionDescription: question.description || "",
                questionIsObligatory: question.isObligatory,
                fromReport: isReport,
                workflowId: workflowId,
                serviceId: serviceId
            }
        });
    };
    const handleOnComponentEdit = (questionSet, question)=>{
        // eslint-disable-next-line default-case
        switch(question.answer.answerType){
            case "OneOfMany":
                setSideDrawboardOpen(true);
                saveCurrentSelectedEntityAndSet({
                    selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY,
                    selectedElementPath: {
                        projectId: projectId,
                        sampleId: sampleId,
                        questionGroupId: questionGroup.id,
                        questionId: question.id,
                        questionSetId: questionSet.id,
                        questionName: question.question,
                        questionChoices: question.choices || []
                    }
                });
                break;
        }
    };
    const droppableFormId = `FORM_ID_$$_${workflowId}_$$_${serviceId}`;
    return /*#__PURE__*/ $acw62.createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: title,
        stepNumber: stepNumber,
        wrapped: wrapped,
        wrapCardsCallback: wrapCardsCallback,
        buttons: getSectionButtons()
    }, /*#__PURE__*/ $acw62.createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        droppableId: droppableFormId
    }, (droppableProvided, snapshot)=>numberOfQuestions > 0 ? /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$FormContainer, {
            ref: droppableProvided.innerRef
        }, questionGroup.questionSets.map((questionSetItem, questionSetIdx)=>/*#__PURE__*/ $acw62.createElement((0, $a63adcedbbdafe19$export$f2a139e5d18b9882), {
                key: questionSetItem.id,
                draggableId: questionSetItem.id,
                index: questionSetIdx,
                isDragDisabled: true
            }, (draggableProvided)=>{
                if (questionSetItem.questions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
                    key: questionSetItem.id,
                    ref: draggableProvided.innerRef
                });
                return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, questionSetItem.questions.map((questionItem, questionIdx)=>/*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$FormElementContainer, {
                        ref: draggableProvided.innerRef,
                        ...draggableProvided.draggableProps,
                        style: questionItem.question === "Path name" ? undefined : draggableProvided.draggableProps.style,
                        key: questionItem.id
                    }, /*#__PURE__*/ $acw62.createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
                        label: questionItem.question,
                        onEditClick: ()=>handleOnQuestionEdit(questionSetItem, questionItem),
                        edit: true
                    }, questionItem.description), /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$FormElement, null, getFormQuestion(questionItem.answer.answerType, questionItem), componentEditModeAvailable(questionItem.answer.answerType) && /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$IconContainer, {
                        onClick: ()=>handleOnComponentEdit(questionSetItem, questionItem)
                    }, /*#__PURE__*/ $acw62.createElement((0, $0a739990c1675c9d$export$2ad141e9e3d81b82), {
                        width: 18,
                        height: 18,
                        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
                    })), /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$IconContainer, {
                        onClick: ()=>deleteSelectedQuestion(questionSetItem, questionItem)
                    }, /*#__PURE__*/ $acw62.createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null))), !(questionGroup.questionSets.length - 1 === questionSetIdx && questionSetItem.questions.length - 1 === questionIdx) && /*#__PURE__*/ $acw62.createElement((0, $5b157c2ebdc5985a$export$1ff3c3f08ae963c0), null))));
            })), droppableProvided.placeholder) : /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$NewDropZoneContainer, null, /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$NewDropZone, {
            ref: droppableProvided.innerRef,
            isDraggingOver: snapshot.isDraggingOver
        }, /*#__PURE__*/ $acw62.createElement($6b010ab846055fec$var$NewDropZoneCenterDiv, {
            isDraggingOver: snapshot.isDraggingOver
        }, "DROP HERE")), droppableProvided.placeholder)));
};
const $6b010ab846055fec$var$FormElementContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
`;
const $6b010ab846055fec$var$FormElement = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const $6b010ab846055fec$var$IconContainer = (0, $lmFrL.default).div`
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
`;
const $6b010ab846055fec$var$FormContainer = (0, $lmFrL.default).div`
  margin-bottom: 1rem;
`;
const $6b010ab846055fec$var$NewDropZoneContainer = (0, $lmFrL.default).div`
  & > [data-rbd-placeholder-context-id] {
    display: none !important;
    height: 0;
  }
`;
const $6b010ab846055fec$var$NewDropZone = (0, $lmFrL.default).div`
  border: 1px
    ${(props)=>props.isDraggingOver ? `solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray}` : `dashed ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic}`};

  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(82, 183, 159, 0.1);
`;
const $6b010ab846055fec$var$NewDropZoneCenterDiv = (0, $lmFrL.default).div`
  color: ${(props)=>props.isDraggingOver ? `${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray}` : `${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic}`};
  padding: 6px 16px;
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  border-radius: 4px;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
`;



var $acw62 = parcelRequire("acw62");
var $06d61c41acc2a072$exports = {};


!function(e, t) {
    $06d61c41acc2a072$exports = t((parcelRequire("acw62")), (parcelRequire("1u0KT")));
}("undefined" != typeof self ? self : $06d61c41acc2a072$exports, function(e, t) {
    return function() {
        "use strict";
        var n = {
            655: function(e, t, n) {
                n.r(t), n.d(t, {
                    __extends: function() {
                        return o;
                    },
                    __assign: function() {
                        return i;
                    },
                    __rest: function() {
                        return a;
                    },
                    __decorate: function() {
                        return l;
                    },
                    __param: function() {
                        return c;
                    },
                    __metadata: function() {
                        return u;
                    },
                    __awaiter: function() {
                        return s;
                    },
                    __generator: function() {
                        return f;
                    },
                    __createBinding: function() {
                        return d;
                    },
                    __exportStar: function() {
                        return p;
                    },
                    __values: function() {
                        return h;
                    },
                    __read: function() {
                        return y;
                    },
                    __spread: function() {
                        return b;
                    },
                    __spreadArrays: function() {
                        return g;
                    },
                    __spreadArray: function() {
                        return m;
                    },
                    __await: function() {
                        return v;
                    },
                    __asyncGenerator: function() {
                        return w;
                    },
                    __asyncDelegator: function() {
                        return _;
                    },
                    __asyncValues: function() {
                        return P;
                    },
                    __makeTemplateObject: function() {
                        return O;
                    },
                    __importStar: function() {
                        return x;
                    },
                    __importDefault: function() {
                        return E;
                    },
                    __classPrivateFieldGet: function() {
                        return T;
                    },
                    __classPrivateFieldSet: function() {
                        return j;
                    },
                    __classPrivateFieldIn: function() {
                        return A;
                    }
                });
                var r = function(e, t) {
                    return r = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }, r(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var n = {};
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(r = Object.getOwnPropertySymbols(e); o < r.length; o++)t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                    }
                    return n;
                }
                function l(e, t, n, r) {
                    var o, i = arguments.length, a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);
                    else for(var l = e.length - 1; l >= 0; l--)(o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
                    return i > 3 && a && Object.defineProperty(t, n, a), a;
                }
                function c(e, t) {
                    return function(n, r) {
                        t(n, r, e);
                    };
                }
                function u(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function s(e, t, n, r) {
                    return new (n || (n = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                c(r.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function l(e) {
                            try {
                                c(r.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, l);
                        }
                        c((r = r.apply(e, t || [])).next());
                    });
                }
                function f(e, t) {
                    var n, r, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(l) {
                        return function(c) {
                            return function(l) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, l[0] && (a = 0)), a;)try {
                                    if (n = 1, r && (o = 2 & l[0] ? r.return : l[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, l[1])).done) return o;
                                    switch(r = 0, o && (l = [
                                        2 & l[0],
                                        o.value
                                    ]), l[0]){
                                        case 0:
                                        case 1:
                                            o = l;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: l[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, r = l[1], l = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            l = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== l[0] && 2 !== l[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === l[0] && (!o || l[1] > o[0] && l[1] < o[3])) {
                                                a.label = l[1];
                                                break;
                                            }
                                            if (6 === l[0] && a.label < o[1]) {
                                                a.label = o[1], o = l;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(l);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    l = t.call(e, a);
                                } catch (e) {
                                    l = [
                                        6,
                                        e
                                    ], r = 0;
                                } finally{
                                    n = o = 0;
                                }
                                if (5 & l[0]) throw l[1];
                                return {
                                    value: l[0] ? l[1] : void 0,
                                    done: !0
                                };
                            }([
                                l,
                                c
                            ]);
                        };
                    }
                }
                var d = Object.create ? function(e, t, n, r) {
                    void 0 === r && (r = n);
                    var o = Object.getOwnPropertyDescriptor(t, n);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, r, o);
                } : function(e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                };
                function p(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || d(t, e, n);
                }
                function h(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && r >= e.length && (e = void 0), {
                                value: e && e[r++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function y(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var r, o, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(r = i.next()).done;)a.push(r.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (n = i.return) && n.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function b() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(y(arguments[t]));
                    return e;
                }
                function g() {
                    for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
                    var r = Array(e), o = 0;
                    for(t = 0; t < n; t++)for(var i = arguments[t], a = 0, l = i.length; a < l; a++, o++)r[o] = i[a];
                    return r;
                }
                function m(e, t, n) {
                    if (n || 2 === arguments.length) for(var r, o = 0, i = t.length; o < i; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
                    return e.concat(r || Array.prototype.slice.call(t));
                }
                function v(e) {
                    return this instanceof v ? (this.v = e, this) : new v(e);
                }
                function w(e, t, n) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var r, o = n.apply(e, t || []), i = [];
                    return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function() {
                        return this;
                    }, r;
                    function a(e) {
                        o[e] && (r[e] = function(t) {
                            return new Promise(function(n, r) {
                                i.push([
                                    e,
                                    t,
                                    n,
                                    r
                                ]) > 1 || l(e, t);
                            });
                        });
                    }
                    function l(e, t) {
                        try {
                            (n = o[e](t)).value instanceof v ? Promise.resolve(n.value.v).then(c, u) : s(i[0][2], n);
                        } catch (e) {
                            s(i[0][3], e);
                        }
                        var n;
                    }
                    function c(e) {
                        l("next", e);
                    }
                    function u(e) {
                        l("throw", e);
                    }
                    function s(e, t) {
                        e(t), i.shift(), i.length && l(i[0][0], i[0][1]);
                    }
                }
                function _(e) {
                    var t, n;
                    return t = {}, r("next"), r("throw", function(e) {
                        throw e;
                    }), r("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function r(r, o) {
                        t[r] = e[r] ? function(t) {
                            return (n = !n) ? {
                                value: v(e[r](t)),
                                done: "return" === r
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function P(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, n = e[Symbol.asyncIterator];
                    return n ? n.call(e) : (e = h(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function r(n) {
                        t[n] = e[n] && function(t) {
                            return new Promise(function(r, o) {
                                !function(e, t, n, r) {
                                    Promise.resolve(r).then(function(t) {
                                        e({
                                            value: t,
                                            done: n
                                        });
                                    }, t);
                                }(r, o, (t = e[n](t)).done, t.value);
                            });
                        };
                    }
                }
                function O(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var S = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function x(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && d(t, e, n);
                    return S(t, e), t;
                }
                function E(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function T(e, t, n, r) {
                    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
                }
                function j(e, t, n, r, o) {
                    if ("m" === r) throw new TypeError("Private method is not writable");
                    if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
                }
                function A(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
            },
            156: function(t) {
                t.exports = e;
            },
            111: function(e) {
                e.exports = t;
            }
        }, r = {};
        function o(e) {
            var t = r[e];
            if (void 0 !== t) return t.exports;
            var i = r[e] = {
                exports: {}
            };
            return n[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var n in t)o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(655), n = o(156), r = o(111), a = Object.prototype.hasOwnProperty.call(n, "createContext"), l = Object.prototype.hasOwnProperty.call(n, "useMemo") && Object.prototype.hasOwnProperty.call(n, "useCallback"), c = a ? n.createContext({}) : null;
            e.PrintContextConsumer = c ? c.Consumer : function() {
                return null;
            };
            var u = {
                copyStyles: !0,
                pageStyle: "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",
                removeAfterPrint: !1,
                suppressErrors: !1
            }, s = function(e) {
                function o() {
                    var n = null !== e && e.apply(this, arguments) || this;
                    return n.startPrint = function(e) {
                        var t = n.props, r = t.onAfterPrint, o = t.onPrintError, i = t.print, a = t.documentTitle;
                        setTimeout(function() {
                            var t, l;
                            if (e.contentWindow) {
                                if (e.contentWindow.focus(), i) i(e).then(n.handleRemoveIframe).catch(function(e) {
                                    o ? o("print", e) : n.logMessages([
                                        "An error was thrown by the specified `print` function"
                                    ]);
                                });
                                else if (e.contentWindow.print) {
                                    var c = null !== (l = null === (t = e.contentDocument) || void 0 === t ? void 0 : t.title) && void 0 !== l ? l : "", u = e.ownerDocument.title;
                                    a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = c));
                                } else n.logMessages([
                                    "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                ]);
                                r && r(), n.handleRemoveIframe();
                            } else n.logMessages([
                                "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                            ]);
                        }, 500);
                    }, n.triggerPrint = function(e) {
                        var t = n.props, r = t.onBeforePrint, o = t.onPrintError;
                        if (r) {
                            var i = r();
                            i && "function" == typeof i.then ? i.then(function() {
                                n.startPrint(e);
                            }).catch(function(e) {
                                o && o("onBeforePrint", e);
                            }) : n.startPrint(e);
                        } else n.startPrint(e);
                    }, n.handleClick = function() {
                        var e = n.props, t = e.onBeforeGetContent, r = e.onPrintError;
                        if (t) {
                            var o = t();
                            o && "function" == typeof o.then ? o.then(n.handlePrint).catch(function(e) {
                                r && r("onBeforeGetContent", e);
                            }) : n.handlePrint();
                        } else n.handlePrint();
                    }, n.handlePrint = function() {
                        var e = n.props, o = e.bodyClass, i = e.content, a = e.copyStyles, l = e.fonts, c = e.pageStyle, u = e.nonce, s = i();
                        if (void 0 !== s) {
                            if (null !== s) {
                                var f = document.createElement("iframe");
                                f.width = "".concat(document.documentElement.clientWidth, "px"), f.height = "".concat(document.documentElement.clientHeight, "px"), f.style.position = "absolute", f.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), f.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), f.id = "printWindow", f.srcdoc = "<!DOCTYPE html>";
                                var d = (0, r.findDOMNode)(s);
                                if (d) {
                                    var p = d.cloneNode(!0), h = p instanceof Text, y = document.querySelectorAll("link[rel='stylesheet']"), b = h ? [] : p.querySelectorAll("img"), g = h ? [] : p.querySelectorAll("video");
                                    n.linkTotal = y.length + b.length + g.length, n.linksLoaded = [], n.linksErrored = [], n.fontsLoaded = [], n.fontsErrored = [];
                                    var m = function(e, t) {
                                        t ? n.linksLoaded.push(e) : (n.logMessages([
                                            '"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:',
                                            e
                                        ]), n.linksErrored.push(e)), n.linksLoaded.length + n.linksErrored.length + n.fontsLoaded.length + n.fontsErrored.length === n.linkTotal && n.triggerPrint(f);
                                    };
                                    f.onload = function() {
                                        var e, r, i, s;
                                        f.onload = null;
                                        var y = f.contentDocument || (null === (r = f.contentWindow) || void 0 === r ? void 0 : r.document);
                                        if (y) {
                                            y.body.appendChild(p), l && ((null === (i = f.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (s = f.contentWindow) || void 0 === s ? void 0 : s.FontFace) ? l.forEach(function(e) {
                                                var t = new FontFace(e.family, e.source);
                                                f.contentDocument.fonts.add(t), t.loaded.then(function(e) {
                                                    n.fontsLoaded.push(e);
                                                }).catch(function(e) {
                                                    n.fontsErrored.push(t), n.logMessages([
                                                        '"react-to-print" was unable to load a font. "react-to-print" will continue attempting to print the page. The font that failed to load is:',
                                                        t,
                                                        "The error from loading the font is:",
                                                        e
                                                    ]);
                                                });
                                            }) : n.logMessages([
                                                '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API'
                                            ]));
                                            var v = "function" == typeof c ? c() : c;
                                            if ("string" != typeof v) n.logMessages([
                                                '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof v, '". Styles from `pageStyle` will not be applied.')
                                            ]);
                                            else {
                                                var w = y.createElement("style");
                                                u && (w.setAttribute("nonce", u), y.head.setAttribute("nonce", u)), w.appendChild(y.createTextNode(v)), y.head.appendChild(w);
                                            }
                                            if (o && (e = y.body.classList).add.apply(e, (0, t.__spreadArray)([], (0, t.__read)(o.split(" ")), !1)), !h) {
                                                for(var _ = h ? [] : d.querySelectorAll("canvas"), P = y.querySelectorAll("canvas"), O = 0; O < _.length; ++O){
                                                    var S = _[O], x = P[O].getContext("2d");
                                                    x && x.drawImage(S, 0, 0);
                                                }
                                                for(O = 0; O < b.length; O++){
                                                    var E = b[O], T = E.getAttribute("src");
                                                    T ? ((A = new Image).onload = m.bind(null, E, !0), A.onerror = m.bind(null, E, !1), A.src = T) : (n.logMessages([
                                                        '"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:',
                                                        E
                                                    ], "warning"), m(E, !1));
                                                }
                                                for(O = 0; O < g.length; O++){
                                                    var j = g[O];
                                                    j.preload = "auto";
                                                    var A, k = j.getAttribute("poster");
                                                    k ? ((A = new Image).onload = m.bind(null, j, !0), A.onerror = m.bind(null, j, !1), A.src = k) : j.readyState >= 2 ? m(j, !0) : (j.onloadeddata = m.bind(null, j, !0), j.onerror = m.bind(null, j, !1), j.onstalled = m.bind(null, j, !1));
                                                }
                                                var C = "input", M = d.querySelectorAll(C), R = y.querySelectorAll(C);
                                                for(O = 0; O < M.length; O++)R[O].value = M[O].value;
                                                var I = "input[type=checkbox],input[type=radio]", q = d.querySelectorAll(I), D = y.querySelectorAll(I);
                                                for(O = 0; O < q.length; O++)D[O].checked = q[O].checked;
                                                var W = "select", L = d.querySelectorAll(W), F = y.querySelectorAll(W);
                                                for(O = 0; O < L.length; O++)F[O].value = L[O].value;
                                            }
                                            if (a) for(var N = document.querySelectorAll("style, link[rel='stylesheet']"), B = (O = 0, N.length); O < B; ++O){
                                                var G = N[O];
                                                if ("style" === G.tagName.toLowerCase()) {
                                                    var H = y.createElement(G.tagName), Y = G.sheet;
                                                    if (Y) {
                                                        var z = "";
                                                        try {
                                                            for(var V = Y.cssRules.length, U = 0; U < V; ++U)"string" == typeof Y.cssRules[U].cssText && (z += "".concat(Y.cssRules[U].cssText, "\r\n"));
                                                        } catch (e) {
                                                            n.logMessages([
                                                                "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                G
                                                            ], "warning");
                                                        }
                                                        H.setAttribute("id", "react-to-print-".concat(O)), u && H.setAttribute("nonce", u), H.appendChild(y.createTextNode(z)), y.head.appendChild(H);
                                                    }
                                                } else if (G.getAttribute("href")) {
                                                    if (G.hasAttribute("disabled")) n.logMessages([
                                                        "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                        G
                                                    ], "warning"), m(G, !0);
                                                    else {
                                                        H = y.createElement(G.tagName), U = 0;
                                                        for(var J = G.attributes.length; U < J; ++U){
                                                            var K = G.attributes[U];
                                                            K && H.setAttribute(K.nodeName, K.nodeValue || "");
                                                        }
                                                        H.onload = m.bind(null, H, !0), H.onerror = m.bind(null, H, !1), u && H.setAttribute("nonce", u), y.head.appendChild(H);
                                                    }
                                                } else n.logMessages([
                                                    "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                    G
                                                ], "warning"), m(G, !0);
                                            }
                                        }
                                        0 !== n.linkTotal && a || n.triggerPrint(f);
                                    }, n.handleRemoveIframe(!0), document.body.appendChild(f);
                                } else n.logMessages([
                                    '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                ]);
                            } else n.logMessages([
                                'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                            ]);
                        } else n.logMessages([
                            "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                        ]);
                    }, n.handleRemoveIframe = function(e) {
                        var t = n.props.removeAfterPrint;
                        if (e || t) {
                            var r = document.getElementById("printWindow");
                            r && document.body.removeChild(r);
                        }
                    }, n.logMessages = function(e, t) {
                        void 0 === t && (t = "error"), n.props.suppressErrors || ("error" === t ? console.error(e) : "warning" === t ? console.warn(e) : "debug" === t && console.debug(e));
                    }, n;
                }
                return (0, t.__extends)(o, e), o.prototype.render = function() {
                    var e = this.props, t = e.children, r = e.trigger;
                    if (r) return n.cloneElement(r(), {
                        onClick: this.handleClick
                    });
                    if (!c) return this.logMessages([
                        '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                    ]), null;
                    var o = {
                        handlePrint: this.handleClick
                    };
                    return n.createElement(c.Provider, {
                        value: o
                    }, t);
                }, o.defaultProps = u, o;
            }(n.Component);
            e.default = s, e.useReactToPrint = function(e) {
                if (!l) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                    throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                };
                var r = n.useMemo(function() {
                    return new s((0, t.__assign)((0, t.__assign)({}, u), e));
                }, [
                    e
                ]);
                return n.useCallback(function() {
                    return r.handleClick();
                }, [
                    r
                ]);
            };
        }(), i;
    }();
});



var $lmFrL = parcelRequire("lmFrL");







var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
function $a3aa406e66440265$var$CheckboxElement({ id: id, handleCheckboxClick: handleCheckboxClick, position: position }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a3aa406e66440265$var$CheckboxWrapper, {
        onChange: ()=>handleCheckboxClick(position)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a3aa406e66440265$var$CheckboxInput, {
        type: "checkbox",
        name: id,
        id: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a3aa406e66440265$var$CheckboxLabel, {
        htmlFor: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "box",
        d: "M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        className: "check",
        points: "25.5,53.5 39.5,67.5 72.5,34.5 "
    }))));
}
var $a3aa406e66440265$export$2e2bcd8739ae039 = $a3aa406e66440265$var$CheckboxElement;
const $a3aa406e66440265$var$CheckboxWrapper = (0, $lmFrL.default).div`
  border-radius: 0.3em;
  width: 35px;
  height: 35px;
  box-shadow: 7px 7px 5px rgba(0, 0, 0, 0.04),
    -7px -7px 5px rgba(255, 255, 255, 0.8);
  border: 2px solid rgb(235, 235, 235);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $a3aa406e66440265$var$CheckboxLabel = (0, $lmFrL.default).label`
  cursor: pointer;
  font-size: 0.8em;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    stroke: rgb(0, 124, 226);
    stroke-width: 5;
    fill: white;

    .box {
      stroke-dasharray: 320;
      stroke-dashoffset: 0;
      fill: white;
      transition: stroke-dashoffset 0.3s linear;
    }
    .check {
      stroke-dasharray: 70;
      stroke-dashoffset: 70;
      fill: none;
      transition: stroke-dashoffset 0.3s linear;
    }
  }

  span {
    padding-top: 0.3em;
    margin-left: 0.3em;
  }
`;
const $a3aa406e66440265$var$CheckboxInput = (0, $lmFrL.default).input`
  display: none;
  pointer-events: none;

  &:checked + label {
    .box {
      stroke-dashoffset: 320;
    }
    .check {
      stroke-dashoffset: 0;
    }
  }
`;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");


var $acw62 = parcelRequire("acw62");


const $0555f2091375111a$export$2c73285ae9390cec = (props)=>{
    const { placeholder: placeholder, field: field, label: label, description: description, type: type } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description
    }, /*#__PURE__*/ $acw62.createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: placeholder === null ? undefined : placeholder,
        type: type,
        ...field,
        value: field.value,
        onlyForRead: true
    }));
};


const $c91e3ae4f27bb06e$export$1da64124c9426c44 = (props)=>{
    if (props.options && props.options.length > 0) return (0, $f7ce80ed4a205928$export$229ced5e3e429d2a)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $0555f2091375111a$export$2c73285ae9390cec),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");


const $ffcf1d15412c60d3$export$d55b50a564d0b931 = ({ field: field, ...props })=>{
    const { options: options, label: label, isSearchable: isSearchable } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label
    }, /*#__PURE__*/ $acw62.createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
        ...field,
        ...props,
        options: options,
        value: options ? options.find((option)=>option.value === field.value) : "",
        isDisabled: true,
        isSearchable: isSearchable
    }));
};



var $acw62 = parcelRequire("acw62");


const $916c1697f7ab4086$export$a314277471067e8a = ({ field: field, ...props })=>{
    const { options: options, label: label } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label
    }, /*#__PURE__*/ $acw62.createElement((0, $d19f8a0606798fa7$export$a98f0dcb43a68a25), {
        ...field,
        ...props,
        options: options.map((option)=>({
                labelText: option.label,
                value: option.value,
                disabled: true
            })),
        selectedValue: options ? options.find((option)=>option.value === field.value)?.value : "",
        onClickRadioButton: ()=>null
    }));
};


const $094c80b4e73e4856$export$58636e7da020966a = (props)=>{
    if (!props.options) throw new Error("Corrupted question");
    if (props.options.length > 2) return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $ffcf1d15412c60d3$export$d55b50a564d0b931),
        ...props
    });
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $916c1697f7ab4086$export$a314277471067e8a),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");


const $f044b2f349cdab6d$export$301bf6213f61d17f = (props)=>{
    const { placeholder: placeholder, field: field, label: label, description: description } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description
    }, /*#__PURE__*/ $acw62.createElement((0, $c7e0eaaa31601803$export$f5c9f3c2c4054eec), {
        placeholder: placeholder,
        ...field,
        value: field.value,
        // isDisabled={true}
        onlyForRead: true,
        rows: field.value && field.value.length > 0 ? field.value.split("\n").length : null
    }));
};


const $5ad740ced29d0b38$export$ea51f321caa02dd4 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $f044b2f349cdab6d$export$301bf6213f61d17f),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $b3b91b8a6c564470$var$FileContainer = (0, $lmFrL.default).div`
  width: 312px;
  height: 32px;
  border-radius: 8px 8px 8px 0px;

  background: ${(props)=>props.isLoading ? props.theme.newColors.primary.lightestTint : props.theme.newColors.grayscale.primaryGray};

  .progressBar {
    display: ${(props)=>props.isLoading ? "block;" : "none;"};
  }
`;
const $b3b91b8a6c564470$var$Label = (0, $lmFrL.default).div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  cursor: ${({ isLoading: isLoading })=>isLoading ? "default" : "pointer"};
`;
const $b3b91b8a6c564470$var$LabelContainer = (0, $lmFrL.default).div`
  display: flex;
  padding: 8px 12px;
`;
const $b3b91b8a6c564470$var$FileName = (0, $lmFrL.default).div`
  font-size: ${(props)=>props.theme.fontSizes[0]};
  line-height: ${(props)=>props.theme.lineHeights[2]};

  letter-spacing: -0.01em;

  color: ${(props)=>props.isLoading ? props.theme.newColors.grayscale.primaryGray : props.theme.newColors.grayscale.white};

  order: 0;
  align-self: center;
  margin-right: 5px;

  max-width: 175px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $b3b91b8a6c564470$var$FileSize = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01em;

  color: ${(props)=>props.isLoading ? props.theme.newColors.grayscale.secondaryGray : props.theme.newColors.grayscale.placeholder};

  order: 1;
  align-self: center;
`;
const $b3b91b8a6c564470$export$5053f49f46dd8ad = (props)=>{
    const { name: name, size: size, percent: percent = 100 } = props;
    const isLoading = percent !== 100;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($b3b91b8a6c564470$var$FileContainer, {
        isLoading: isLoading
    }, /*#__PURE__*/ $acw62.createElement($b3b91b8a6c564470$var$LabelContainer, null, /*#__PURE__*/ $acw62.createElement($b3b91b8a6c564470$var$Label, {
        isLoading: isLoading
    }, /*#__PURE__*/ $acw62.createElement($b3b91b8a6c564470$var$FileName, {
        isLoading: isLoading
    }, name), /*#__PURE__*/ $acw62.createElement($b3b91b8a6c564470$var$FileSize, {
        isLoading: isLoading
    }, "(", (0, $baa553d77c4811c0$export$aa86822bccdac75d)(size), ")")))));
};


const $c362b94095ccc64a$var$FilesContainer = (0, $lmFrL.default).div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;

  > div {
    margin: 0 5px 5px 0;
  }
`;
const $c362b94095ccc64a$export$9330ab61a7e5c11b = (props)=>{
    const { files: files } = props;
    if (files.length === 0) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    return /*#__PURE__*/ $acw62.createElement($c362b94095ccc64a$var$FilesContainer, null, files.map((file)=>/*#__PURE__*/ $acw62.createElement((0, $b3b91b8a6c564470$export$5053f49f46dd8ad), {
            key: file.s3FileName,
            name: file.fileName,
            size: file.fileSize,
            percent: file.percent !== undefined ? file.percent : 100
        })));
};


const $aec60e92764b97ae$var$parseFilesToComponent = (files, filesToUpload)=>{
    const parsedFilesName = [];
    const parsedFiles = files.map((file)=>{
        parsedFilesName.push(file.s3FileName);
        return {
            ...file,
            percent: 100
        };
    });
    const parsedFilesToUpload = filesToUpload.map((fileToUpload)=>({
            fileName: fileToUpload.fileItem.name,
            s3FileName: fileToUpload.generatedFileName,
            fileSize: fileToUpload.fileItem.size,
            percent: fileToUpload.percent
        })).filter((fileToUpload)=>!parsedFilesName.includes(fileToUpload.s3FileName));
    return [].concat(parsedFiles, parsedFilesToUpload);
};
const $aec60e92764b97ae$var$parseFieldValue = (fieldValue)=>{
    if (fieldValue?.length) return JSON.parse(fieldValue);
    return [];
};
const $aec60e92764b97ae$export$ad2d04c8e5b15ad7 = (props)=>{
    const { field: field, label: label, description: description } = props;
    const files = $aec60e92764b97ae$var$parseFieldValue(field.value);
    const filesToUpload = [];
    return /*#__PURE__*/ $acw62.createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "container"
    }, files.length > 0 ? /*#__PURE__*/ $acw62.createElement((0, $c362b94095ccc64a$export$9330ab61a7e5c11b), {
        files: $aec60e92764b97ae$var$parseFilesToComponent(files, filesToUpload)
    }) : /*#__PURE__*/ $acw62.createElement($aec60e92764b97ae$var$NoFilesNotification, null, "No files have been uploaded.")));
};
const $aec60e92764b97ae$var$NoFilesNotification = (0, $lmFrL.default).p`
  color: #a9a9a9;
`;


const $3d6ac619cd0d7ec0$export$8bded3446c85dfe6 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $aec60e92764b97ae$export$ad2d04c8e5b15ad7),
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

/* eslint-disable react/no-array-index-key */ 
var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");


const $177a1b6002878743$var$svgString = encodeURIComponent((0, $f46ed4009cb9c1cd$exports.renderToStaticMarkup)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $651a3f4c44f43348$export$6dcd14de5b20d369), null)));
const $177a1b6002878743$export$7072fe5fbc0a2edb = (props)=>{
    const { value: value, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($177a1b6002878743$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        placeholder: "https://www.example.com",
        svgIcon: $177a1b6002878743$var$svgString,
        value: value,
        testId: `${testId}_input`,
        onlyForRead: true
    }));
};
const $177a1b6002878743$var$Container = (0, $lmFrL.default).div`
  display: flex;
`;


const $7788e4e47f556033$var$parseValue = (linksValue)=>{
    if (linksValue && linksValue.length) return JSON.parse(linksValue);
    return [
        ""
    ];
};
const $7788e4e47f556033$export$7c6fdaf98295312b = (props)=>{
    const { linksValue: linksValue } = props;
    const links = $7788e4e47f556033$var$parseValue(linksValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7788e4e47f556033$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7788e4e47f556033$var$ExternalLinksElementContainer, null, links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $177a1b6002878743$export$7072fe5fbc0a2edb), {
            key: `externalLink${index}`,
            testId: "externalLinksElement",
            id: index,
            value: link
        }))));
};
$7788e4e47f556033$export$7c6fdaf98295312b.defaultProps = {
    linksValue: ""
};
const $7788e4e47f556033$var$Container = (0, $lmFrL.default).div``;
const $7788e4e47f556033$var$ExternalLinksElementContainer = (0, $lmFrL.default).div`
  > div {
    margin-bottom: 8px;
  }
`;


const $53bd697ba384750d$export$c89d4b0890a242f4 = (props)=>{
    const { field: field, label: label, description: description } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80a057cdff0d2afb$export$2d00230e1e6f7fbc), {
        label: label,
        description: description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7788e4e47f556033$export$7c6fdaf98295312b), {
        linksValue: field.value
    }));
};


const $25ae0f736b57e208$export$6a8e268bd4b87d1d = (props)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $7YFi7.Field), {
        component: (0, $53bd697ba384750d$export$c89d4b0890a242f4),
        ...props
    });
};


const $abb7ff0bbb7f830e$export$ddf0a5a90174f65e = (elementName, elementSchema, fieldStatus = ()=>{})=>{
    const props = {
        name: elementName,
        label: elementSchema.label,
        options: elementSchema.options,
        description: elementSchema.description,
        placeholder: elementSchema.placeholder,
        required: elementSchema.required,
        visibility: elementSchema.visibility,
        answerQuestionCallback: elementSchema.answerQuestionCallback,
        metadata: elementSchema.metadata,
        fieldStatus: fieldStatus,
        disabled: elementSchema.disabled
    };
    if (!props.visibility) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null);
    switch(elementSchema.type){
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextField:
            return (0, $c91e3ae4f27bb06e$export$1da64124c9426c44)({
                ...props,
                type: "text"
            });
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).TextArea:
            return (0, $5ad740ced29d0b38$export$ea51f321caa02dd4)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).OneOfMany:
            return (0, $094c80b4e73e4856$export$58636e7da020966a)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).File:
            return (0, $3d6ac619cd0d7ec0$export$8bded3446c85dfe6)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Links:
            return (0, $25ae0f736b57e208$export$6a8e268bd4b87d1d)(props);
        case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
            return (0, $c91e3ae4f27bb06e$export$1da64124c9426c44)({
                ...props,
                type: "number"
            });
        default:
            return /*#__PURE__*/ $acw62.createElement("div", null, "There is no renderer for type: ", elementSchema.type);
    }
};


const $dfd2b7a4135e8d17$export$235fb95ee0ade20c = (props)=>{
    const { title: title, stepNumber: stepNumber, wrapped: wrapped, wrapCardsCallback: wrapCardsCallback, questionGroup: questionGroup, handleOnPrepareForPrinting: handleOnPrepareForPrinting, questionLevelInput: questionLevelInput, answerQuestionCallback: answerQuestionCallback } = props;
    const { setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const [checkedQuestionGroup, setCheckedQuestionGroup] = $acw62.useState(()=>{
        const questions = questionGroup.questionSets;
        const numberOfQuestions = questions.reduce((accumulator, currentValue)=>accumulator + currentValue.questions.length, 0);
        return new Array(numberOfQuestions).fill(false);
    });
    const formSchema = (0, $0b9e68e503e790ca$export$a768b233790fc927)(questionGroup, questionLevelInput, answerQuestionCallback);
    const getCurrentSchema = (key)=>{
        const newSchema = formSchema[key];
        newSchema.disabled = true;
        return newSchema;
    };
    const componentRef = $acw62.useRef(null);
    const handleFinishPrintingMode = ()=>{
        setSelectedEntity(undefined);
        if (handleOnPrepareForPrinting) handleOnPrepareForPrinting("");
    };
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>componentRef.current
    });
    const handleCheckboxClick = (position)=>{
        const updatedCheckedQuestionGroup = checkedQuestionGroup.map((item, index)=>index === position ? !item : item);
        setCheckedQuestionGroup(updatedCheckedQuestionGroup);
    };
    const isUserSelectAtLeastOneField = (fieldsState)=>{
        return fieldsState.some((fieldState)=>fieldState === true);
    };
    const showPrintintError = ()=>{
        return (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You need to select field you want to print.");
    };
    const getSectionButtons = ()=>{
        return [
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Back to overview",
                onClick: handleFinishPrintingMode
            }),
            /*#__PURE__*/ $acw62.createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
                label: "Print",
                onClick: isUserSelectAtLeastOneField(checkedQuestionGroup) ? handlePrint : showPrintintError
            })
        ];
    };
    return /*#__PURE__*/ $acw62.createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: title,
        stepNumber: stepNumber,
        wrapped: wrapped,
        wrapCardsCallback: wrapCardsCallback,
        buttons: getSectionButtons()
    }, /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$ComponentToPrint, {
        ref: componentRef
    }, checkedQuestionGroup.length > 0 ? /*#__PURE__*/ $acw62.createElement((0, $f62c1a640a047274$export$a7fed597f4b8afd8), {
        enableReinitialize: true,
        initialValues: (0, $dd31949bb8cc9c37$export$6af2357d4499ad4e)(questionGroup),
        validationSchema: (0, $40e65b17a1bb5f5a$export$d4f1a1c1230e2076)(questionGroup),
        onSubmit: (values)=>console.log(values)
    }, /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$Container, null, /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$FormContainer, null, Object.keys(formSchema).map((key, id)=>{
        return /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$FormElementContainer, {
            key: key,
            isSelected: checkedQuestionGroup[id]
        }, (0, $abb7ff0bbb7f830e$export$ddf0a5a90174f65e)(key, getCurrentSchema(key)), /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$IconContainer, null, " ", /*#__PURE__*/ $acw62.createElement((0, $a3aa406e66440265$export$2e2bcd8739ae039), {
            id: `${id}`,
            handleCheckboxClick: handleCheckboxClick,
            position: id
        })));
    })), /*#__PURE__*/ $acw62.createElement($dfd2b7a4135e8d17$var$ToPrintNotification, null, "Select data to print:"))) : /*#__PURE__*/ $acw62.createElement("div", {
        key: questionGroup.id
    }, "Empty Question Group - Edit to add new form elements")));
};
const $dfd2b7a4135e8d17$var$ComponentToPrint = (0, $lmFrL.default).div`
  textarea {
    overflow: hidden;
  }

  @media print {
    display: block;

    @page {
      margin: 80px 40px;
    }
  }
`;
const $dfd2b7a4135e8d17$var$FormElementContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;

  & div:first-child {
    flex: 1;
  }

  @media print {
    display: ${(props)=>props.isSelected ? "flex" : "none"};
    margin-bottom: 40px;
    page-break-inside: avoid;

    hr {
      display: none;
    }
  }
`;
const $dfd2b7a4135e8d17$var$IconContainer = (0, $lmFrL.default).div`
  margin-left: 30px;

  @media print {
    display: none;
  }
`;
const $dfd2b7a4135e8d17$var$Container = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  position: relative;
`;
const $dfd2b7a4135e8d17$var$ToPrintNotification = (0, $lmFrL.default).p`
  position: absolute;
  top: 0;
  right: 0;
  color: #232f3c;
  font-size: 16px;
  font-weight: bold;

  @media print {
    display: none;
  }
`;
const $dfd2b7a4135e8d17$var$FormContainer = (0, $lmFrL.default).div`
  flex-grow: 1;
  min-width: 500px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");











const $ee39733285fed7b5$export$3a64ff9464252ed4 = ({ children: children, pageTitle: pageTitle = "Welcome", tabs: tabs, dropdownData: dropdownData, selectedDropdownDataId: selectedDropdownDataId, onDataClick: onDataClick, projectId: projectId, sample: sample, fromReport: fromReport, fixedSideDrawboard: fixedSideDrawboard = true })=>{
    const [addQuestionToSampleMutation] = (0, $7608a8bbcbbad14c$export$e44f75598bd188e3)();
    const { sideBarOpen: sideBarOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const questionGroupId = selectedEntity && selectedEntity.selectedElementPath.questionGroupId;
    const onDragEnd = $acw62.useCallback(async (result)=>{
        const { source: source, destination: destination, draggableId: draggableId } = result;
        if (!destination) return;
        const encodedId = destination.droppableId;
        const partsOfEncodedString = encodedId.split("_$$_");
        const workflowIdFromId = partsOfEncodedString[1];
        const serviceIdFromId = partsOfEncodedString[2];
        switch(source.droppableId){
            case destination.droppableId:
                console.log("Reorder event");
                break;
            case "FormQuestions":
                {
                    const options = {
                        variables: {
                            projectSampleInput: {
                                projectId: projectId,
                                sampleId: selectedDropdownDataId,
                                fromReport: fromReport,
                                workflowId: workflowIdFromId,
                                serviceId: serviceIdFromId
                            },
                            questionGroupId: questionGroupId,
                            questionId: draggableId,
                            order: destination.index
                        },
                        update (cache, mutationResult) {
                            (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("AddQuestionToSample", cache, mutationResult, projectId || "", selectedDropdownDataId);
                        }
                    };
                    addQuestionToSampleMutation(options);
                    break;
                }
            default:
                console.log("ReactDnD error");
                break;
        }
    }, [
        questionGroupId,
        sample
    ]);
    return /*#__PURE__*/ $acw62.createElement($ee39733285fed7b5$var$Wrapper, null, /*#__PURE__*/ $acw62.createElement((0, $893bf6ab15cfafd6$export$614264b7ca4804e6), null), /*#__PURE__*/ $acw62.createElement((0, $a63adcedbbdafe19$export$237bd83162c14364), {
        onDragEnd: onDragEnd
    }, /*#__PURE__*/ $acw62.createElement($ee39733285fed7b5$var$Main, {
        isSideBarOpen: sideBarOpen
    }, /*#__PURE__*/ $acw62.createElement((0, $193714fcc8f30367$export$8b251419efc915eb), {
        pageTitle: pageTitle
    }), /*#__PURE__*/ $acw62.createElement($ee39733285fed7b5$var$NavWrapper, null, tabs && /*#__PURE__*/ $acw62.createElement($ee39733285fed7b5$var$NavigationTabs, null, tabs)), /*#__PURE__*/ $acw62.createElement($ee39733285fed7b5$var$Content, null, /*#__PURE__*/ $acw62.createElement((0, $0ae05e0bf2c3dc8f$export$844f199b4427ce36), null, children))), /*#__PURE__*/ $acw62.createElement((0, $9b46390a7c7d7753$export$7280240986cdf65a), {
        dropdownData: dropdownData,
        selectedDropdownDataId: selectedDropdownDataId,
        onDataClick: onDataClick,
        numberOfExistingWorkflows: 0,
        fixedViewMode: fixedSideDrawboard
    }, /*#__PURE__*/ $acw62.createElement((0, $2cb268602699e484$export$543ec51f2d9ac69a), null))));
};
const $ee39733285fed7b5$var$Wrapper = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  min-height: 100vh;
`;
const $ee39733285fed7b5$var$NavWrapper = (0, $lmFrL.default).div`
  min-height: 36px;
  width: 100%;
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $ee39733285fed7b5$var$NavigationTabs = (0, $lmFrL.default).div`
  margin: 0 auto;
  width: 100%;
  max-width: ${(p)=>p.theme.maxContentWidth};
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $ee39733285fed7b5$var$Main = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: ${({ isSideBarOpen: isSideBarOpen })=>isSideBarOpen ? "calc(100% - 184px - 72px);" : "calc(100% - 72px - 72px);"};
  flex-direction: column;
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;
const $ee39733285fed7b5$var$Content = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $41b64a22815559b1$export$f112b55f7596c776 = ({ addNewQuestionGroup: addNewQuestionGroup })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41b64a22815559b1$var$AddNewSectionContainer, {
        onClick: addNewQuestionGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41b64a22815559b1$var$AddIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3b9bf177ba8611a6$export$a6b7c34d56975de0), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41b64a22815559b1$var$AddNewSectionText, null, "Add a new section"));
};
const $41b64a22815559b1$var$AddNewSectionContainer = (0, $lmFrL.default).div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px;
`;
const $41b64a22815559b1$var$AddNewSectionText = (0, $lmFrL.default).div`
  margin-left: 8px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic};
  font-size: 14px;
`;
const $41b64a22815559b1$var$AddIconContainer = (0, $lmFrL.default).div`
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;








const $868c602c0bd46ebb$var$SAMPLE_CONFIGURATOR_QUESTION_GROUP_NAME = "Service Packages";
const $868c602c0bd46ebb$var$PACKAGE_DESCRIPTION_QUESTION_GROUP_NAME = "Package Description";
const $868c602c0bd46ebb$var$NEW_QUESTION_GROUP_NAME = "New Question Group";
const $868c602c0bd46ebb$var$projectDataTab = {
    id: "1",
    label: "Project Data",
    status: (0, $2d7ecd00adce73e7$export$e35c1996c6f482ad).Editing
};
const $868c602c0bd46ebb$var$runQuestionAnswerMutationAfterMs = 1000;
let $868c602c0bd46ebb$var$lastMetadata = null;
const $868c602c0bd46ebb$var$parseProjectSamples = (samples)=>samples.map((sample)=>({
            id: sample.id,
            label: (0, $e07216757a3bd51c$export$915e191deda31e58)((0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)),
            status: (0, $2d7ecd00adce73e7$export$e35c1996c6f482ad).Editing
        }));
const $868c602c0bd46ebb$var$getReportSelectedQuestionGroups = (sample)=>{
    const questionGroups = [];
    for(let i = 0; i < sample.enabledWorkflows.length; i += 1){
        const workflow = sample.enabledWorkflows[i];
        const services = workflow.services.filter((service)=>service && service.report && service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Approved);
        if (services.length > 0) services.forEach((service)=>{
            const { report: report } = service;
            if (report && report.selectedQuestionGroups && report.selectedQuestionGroups.length > 0) report.selectedQuestionGroups.forEach((questionGroup)=>questionGroups.push({
                    serviceName: service.name,
                    serviceId: service.id,
                    workflowId: workflow.id,
                    questionGroup: {
                        ...questionGroup
                    }
                }));
        });
    }
    return questionGroups;
};
const $868c602c0bd46ebb$export$23ac95e499a8bbe = (props)=>{
    const { project: project, sample: sample, answerProjectSampleQuestion: answerProjectSampleQuestion, enableWorkflowsForProjectSample: enableWorkflowsForProjectSample, services: services, workflows: workflows } = props;
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const userRoleInSample = sample?.assignedUsers?.find((assignedUser)=>assignedUser?.id === user.sub)?.role;
    const [addQuestionGroupToSampleMutation] = (0, $7608a8bbcbbad14c$export$1896c00aac109ec8)();
    const projectSampleWithMultiAnswer = (0, $7608a8bbcbbad14c$export$3a30da8008cfc73a)()[0];
    const projectSampleWithNumericAnswer = (0, $7608a8bbcbbad14c$export$46ebc9426755df51)()[0];
    const projectSampleWithTextAnswer = (0, $7608a8bbcbbad14c$export$23628b905dc411dd)()[0];
    const [preparedForPrintingQuestionGroupId, setPreparedForPrintingQuestionGroupId] = (0, $acw62.useState)("");
    const handleOnPrepareForPrinting = (questionGroupId)=>{
        setPreparedForPrintingQuestionGroupId(questionGroupId);
    };
    const [isReportEdited, setIsReportEdited] = (0, $acw62.useState)(false);
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity, openedSampleGroup: openedSampleGroup, setOpenedSampleGroup: setOpenedSampleGroup } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const questionGroupId = selectedEntity && selectedEntity.selectedElementPath.questionGroupId;
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const addNewSectionIsEnabled = useUserPermissions("addNewSection", userRoleInSample);
    const urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    (0, $acw62.useEffect)(()=>{
        if (!sample.selectedQuestionGroups[openedSampleGroup]) setOpenedSampleGroup(0);
    }, [
        urlParams.sampleId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (preparedForPrintingQuestionGroupId) setPreparedForPrintingQuestionGroupId("");
    }, [
        openedSampleGroup
    ]);
    const getTabs = (projectId, samples = [], selectedSampleId = "1")=>{
        const parsedProjectSamples = $868c602c0bd46ebb$var$parseProjectSamples(samples);
        const tabs = [
            $868c602c0bd46ebb$var$projectDataTab,
            ...parsedProjectSamples
        ];
        const [addSampleToProjectMutation] = (0, $7608a8bbcbbad14c$export$c360d2acd2d92a13)();
        const newTabClick = async ()=>{
            setShowSpinner(true);
            const options = {
                variables: {
                    projectSampleInput: {
                        projectId: projectId
                    }
                },
                refetchQueries: [
                    {
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        variables: {
                            id: projectId
                        }
                    },
                    {
                        query: (0, $7608a8bbcbbad14c$export$56959a2c3ec29cce),
                        variables: {
                            id: projectId
                        }
                    }
                ],
                awaitRefetchQueries: true,
                update (cache, { data: data }) {
                    (0, $590f4d6a0c375d80$export$6b98ed09a1b36987)({
                        id: projectId
                    }, (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96), "Project", "AddSampleToProject", cache, data, "samples");
                }
            };
            await addSampleToProjectMutation(options);
            setShowSpinner(false);
        };
        const selectTab = (sampleId)=>{
            if (selectedSampleId !== sampleId) {
                setSelectedEntity(undefined);
                setSideDrawboardOpen(false);
            }
            if (sampleId === "1") // go to Project data tab
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator`);
            else (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/configurator/samples/${sampleId}/configurator`);
        };
        return /*#__PURE__*/ $acw62.createElement((0, $37c3cbd3d47c5d4a$export$b2539bed5023c21c), {
            tabs: tabs,
            onTabClick: selectTab,
            activeTab: selectedSampleId,
            onNewTabClick: newTabClick
        });
    };
    const questionLevelInput = {
        projectId: project.id,
        sampleId: sample.id
    };
    const questionGroups = $868c602c0bd46ebb$var$getReportSelectedQuestionGroups(sample);
    const wrapCards = (questionGroupIndex)=>{
        if (questionGroupIndex !== openedSampleGroup) {
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
        }
        if (questionGroupIndex > sample.selectedQuestionGroups.length + questionGroups.length) setOpenedSampleGroup(0);
        else setOpenedSampleGroup(questionGroupIndex);
    };
    const handleSampleClick = (sampleId)=>{
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${project.id}/configurator/samples/${sampleId}/configurator`);
    };
    const projectName = (0, $30737cddea16cf18$export$2cd058184eb75757)(project);
    const sampleName = (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample);
    const pageTitle = `${projectName} > ${(0, $e07216757a3bd51c$export$915e191deda31e58)(sampleName)}`;
    const getReportSelectedQuestionGroupElement = (questionGroup, index)=>{
        /* eslint-disable */ const projectId = project.id;
        const sampleId = sample.id;
        if ((selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY) && questionGroup.questionGroup.id === questionGroupId) {
            /* eslint-enable */ if (!isReportEdited) setIsReportEdited(true);
            return /*#__PURE__*/ $acw62.createElement((0, $6b010ab846055fec$export$7ff8a395dfe1fcb1), {
                key: questionGroup.questionGroup.id,
                title: `${questionGroup.serviceName}: ${questionGroup.questionGroup.name}`,
                questionGroup: questionGroup.questionGroup,
                projectId: projectId,
                sampleId: sampleId,
                isReport: true,
                stepNumber: sample.selectedQuestionGroups.length + index + 1,
                wrapped: openedSampleGroup !== sample.selectedQuestionGroups.length + index,
                wrapCardsCallback: ()=>{
                    wrapCards(sample.selectedQuestionGroups.length + index);
                },
                workflowId: questionGroup.workflowId,
                serviceId: questionGroup.serviceId,
                goToNextGroupCallback: questionGroups.length > 1 && questionGroups.length > index + 1 ? ()=>{
                    if (questionGroups.length > index) wrapCards(sample.selectedQuestionGroups.length + index + 1);
                } : undefined
            });
        }
        if (!questionGroupId && isReportEdited) setIsReportEdited(false);
        const getMutationBasedOnAnswerType = (answerType)=>{
            switch(answerType){
                case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
                    return projectSampleWithNumericAnswer;
                case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
                    return projectSampleWithMultiAnswer;
                default:
                    return projectSampleWithTextAnswer;
            }
        };
        const reportAnswerProjectSampleQuestion = (metadata, answer)=>{
            if (!metadata.questionLevelInput.sampleId) throw new Error("Metadata is missing sampleId");
            const options = {
                variables: {
                    answer: answer,
                    projectSampleQuestionInput: {
                        questionInput: {
                            ...metadata.questionInput,
                            fromReport: true,
                            workflowId: questionGroup.workflowId,
                            serviceId: questionGroup.serviceId
                        },
                        projectSampleInput: {
                            projectId: metadata.questionLevelInput.projectId,
                            sampleId: metadata.questionLevelInput.sampleId
                        }
                    }
                },
                refetchQueries: [
                    {
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        variables: {
                            id: projectId
                        }
                    }
                ],
                awaitRefetchQueries: true
            };
            const mutation = getMutationBasedOnAnswerType(metadata.answerType);
            if (metadata.answerType === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number) options.variables.answer = parseFloat(options.variables.answer) || 0;
            const mutationPromise = mutation(options);
            mutationPromise.catch((e)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e.toString());
            });
        };
        const answerProjectSampleQuestionDebouncedInternal = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(reportAnswerProjectSampleQuestion, $868c602c0bd46ebb$var$runQuestionAnswerMutationAfterMs, {
            leading: false,
            trailing: true
        });
        const answerProjectSampleQuestionDebounced = (metadata, answear)=>{
            if ($868c602c0bd46ebb$var$lastMetadata !== JSON.stringify(metadata)) {
                $868c602c0bd46ebb$var$lastMetadata = JSON.stringify(metadata);
                answerProjectSampleQuestionDebouncedInternal.flush();
            }
            answerProjectSampleQuestionDebouncedInternal(metadata, answear);
        };
        if (questionGroup.questionGroup.id === preparedForPrintingQuestionGroupId) /* eslint-enable */ return /*#__PURE__*/ $acw62.createElement((0, $dfd2b7a4135e8d17$export$235fb95ee0ade20c), {
            title: `${questionGroup.serviceName}: ${questionGroup.questionGroup.name}`,
            answerQuestionCallback: answerProjectSampleQuestionDebounced,
            questionLevelInput: {
                projectId: projectId,
                sampleId: sampleId
            },
            key: questionGroup.questionGroup.id,
            stepNumber: sample.selectedQuestionGroups.length + index + 1,
            questionGroup: questionGroup.questionGroup,
            wrapped: openedSampleGroup !== sample.selectedQuestionGroups.length + index,
            wrapCardsCallback: ()=>{
                wrapCards(sample.selectedQuestionGroups.length + index);
            },
            handleOnPrepareForPrinting: handleOnPrepareForPrinting
        });
        return /*#__PURE__*/ $acw62.createElement((0, $f801bca6edd7fbeb$export$53faf303b8a97647), {
            key: questionGroup.questionGroup.id,
            title: `${questionGroup.serviceName}: ${questionGroup.questionGroup.name}`,
            stepNumber: sample.selectedQuestionGroups.length + index + 1,
            wrapped: openedSampleGroup !== sample.selectedQuestionGroups.length + index,
            questionLevelInput: {
                projectId: projectId,
                sampleId: sampleId
            },
            questionGroup: questionGroup.questionGroup,
            answerQuestionCallback: answerProjectSampleQuestionDebounced,
            wrapCardsCallback: ()=>{
                wrapCards(sample.selectedQuestionGroups.length + index);
            },
            goToNextGroupCallback: questionGroups.length > 1 && questionGroups.length > index + 1 ? ()=>{
                if (questionGroups.length > index) wrapCards(sample.selectedQuestionGroups.length + index + 1);
            } : undefined,
            projectId: projectId,
            sampleId: sampleId,
            workflowId: questionGroup.workflowId,
            serviceId: questionGroup.serviceId,
            isReport: true,
            handleOnPrepareForPrinting: handleOnPrepareForPrinting,
            userRoleInSample: userRoleInSample
        });
    };
    const addNewQuestionGroup = async ()=>{
        setShowSpinner(true);
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: project.id,
                    sampleId: sample.id
                },
                name: $868c602c0bd46ebb$var$NEW_QUESTION_GROUP_NAME
            },
            update (cache, { data: data }) {
                const incomingData = data?.["AddQuestionGroupToSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: project.id
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const editedSample = existingQueryResult.samples.find((s)=>s.id === sample.id);
                    editedSample.selectedQuestionGroups.push(incomingData);
                    cache.writeQuery({
                        variables: {
                            id: project.id
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: existingQueryResult.samples
                            }
                        }
                    });
                    wrapCards(editedSample.selectedQuestionGroups.length - 1);
                }
            }
        };
        await addQuestionGroupToSampleMutation(options);
        setShowSpinner(false);
    };
    const getSelectedQuestionGroupElement = (questionGroup, index)=>{
        if (questionGroup.name === $868c602c0bd46ebb$var$SAMPLE_CONFIGURATOR_QUESTION_GROUP_NAME) // if (!addNewSectionIsEnabled) return <></>;
        return /*#__PURE__*/ $acw62.createElement((0, $de4fa3f953c8e349$export$c61885ea1ad3465d), {
            key: questionGroup.id,
            title: questionGroup.name,
            stepNumber: index + 1,
            wrapped: openedSampleGroup !== index,
            wrapCardsCallback: ()=>{
                wrapCards(index);
            },
            projectId: project.id,
            sampleId: sample.id,
            workflows: workflows,
            services: services,
            selectedWorkflowsIds: sample.selectedWorkflows.map((workflow)=>workflow.id),
            enableWorkflowsForProjectSample: enableWorkflowsForProjectSample,
            servicePackagesAlreadyAdded: sample.enabledWorkflows.length > 1,
            goToNextGroupCallback: sample.selectedQuestionGroups.length + questionGroups.length > 1 && sample.selectedQuestionGroups.length + questionGroups.length > index + 1 ? ()=>{
                if (sample.selectedQuestionGroups.length + questionGroups.length > index) wrapCards(index + 1);
            } : undefined,
            removeDisabled: sample.enabledWorkflows.length > 1
        });
        if (questionGroup.name === $868c602c0bd46ebb$var$PACKAGE_DESCRIPTION_QUESTION_GROUP_NAME) return /*#__PURE__*/ $acw62.createElement((0, $b4af7334d0fcef01$export$60fb4f810efc7de0), {
            key: questionGroup.id,
            title: questionGroup.name,
            stepNumber: index + 1,
            wrapped: openedSampleGroup !== index,
            wrapCardsCallback: ()=>{
                wrapCards(index);
            },
            questionGroup: questionGroup,
            goToNextGroupCallback: sample.selectedQuestionGroups.length + questionGroups.length > 1 && sample.selectedQuestionGroups.length + questionGroups.length > index + 1 ? ()=>{
                if (sample.selectedQuestionGroups.length + questionGroups.length > index) wrapCards(index + 1);
            } : undefined
        });
        if (questionGroup.id === preparedForPrintingQuestionGroupId) /* eslint-enable */ return /*#__PURE__*/ $acw62.createElement((0, $dfd2b7a4135e8d17$export$235fb95ee0ade20c), {
            title: questionGroup.name,
            answerQuestionCallback: answerProjectSampleQuestion,
            questionLevelInput: questionLevelInput,
            key: questionGroup.id,
            stepNumber: index + 1,
            questionGroup: questionGroup,
            wrapped: openedSampleGroup !== index,
            wrapCardsCallback: ()=>{
                wrapCards(index);
            },
            handleOnPrepareForPrinting: handleOnPrepareForPrinting
        });
        /* eslint-disable */ if ((selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY) && questionGroup.id === questionGroupId) /* eslint-enable */ return /*#__PURE__*/ $acw62.createElement((0, $6b010ab846055fec$export$7ff8a395dfe1fcb1), {
            title: questionGroup.name,
            key: questionGroup.id,
            stepNumber: index + 1,
            questionGroup: questionGroup,
            wrapped: openedSampleGroup !== index,
            wrapCardsCallback: ()=>{
                wrapCards(index);
            },
            goToNextGroupCallback: sample.selectedQuestionGroups.length + questionGroups.length > 1 && sample.selectedQuestionGroups.length + questionGroups.length > index + 1 ? ()=>{
                if (sample.selectedQuestionGroups.length + questionGroups.length > index) wrapCards(index + 1);
            } : undefined,
            projectId: project.id,
            sampleId: sample.id
        });
        return /*#__PURE__*/ $acw62.createElement((0, $f801bca6edd7fbeb$export$53faf303b8a97647), {
            title: questionGroup.name,
            questionLevelInput: questionLevelInput,
            key: questionGroup.id,
            stepNumber: index + 1,
            questionGroup: questionGroup,
            wrapped: openedSampleGroup !== index,
            answerQuestionCallback: answerProjectSampleQuestion,
            wrapCardsCallback: ()=>{
                wrapCards(index);
            },
            goToNextGroupCallback: sample.selectedQuestionGroups.length + questionGroups.length > 1 && sample.selectedQuestionGroups.length + questionGroups.length > index + 1 ? ()=>{
                if (sample.selectedQuestionGroups.length + questionGroups.length > index) wrapCards(index + 1);
            } : undefined,
            projectId: project.id,
            sampleId: sample.id,
            handleOnPrepareForPrinting: handleOnPrepareForPrinting,
            userRoleInSample: userRoleInSample
        });
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSpinner ? /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ $acw62.createElement((0, $ee39733285fed7b5$export$3a64ff9464252ed4), {
        pageTitle: pageTitle,
        tabs: getTabs(project.id, project.samples, urlParams.sampleId || "1"),
        dropdownData: project.samples,
        selectedDropdownDataId: sample.id,
        onDataClick: (sampleId)=>handleSampleClick(sampleId),
        projectId: project.id,
        selectedQuestionGroups: sample.selectedQuestionGroups,
        sample: sample,
        fixedSideDrawboard: false,
        fromReport: isReportEdited
    }, /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $1e26fa3e7edc863b$export$aede49260422b749), {
        path: `/projects/${urlParams.projectId}/timeline/samples/${urlParams.sampleId || "1"}`,
        label: "Go to the timeline"
    }), sample.selectedQuestionGroups.map((questionGroup, index)=>{
        return getSelectedQuestionGroupElement(questionGroup, index);
    }), questionGroups.length > 0 ? questionGroups.map((qg, index)=>getReportSelectedQuestionGroupElement(qg, index)) : null, addNewSectionIsEnabled ? /*#__PURE__*/ $acw62.createElement((0, $254b2a5d9af30712$export$abcf0acb680d5c4f), {
        centered: true
    }, /*#__PURE__*/ $acw62.createElement((0, $41b64a22815559b1$export$f112b55f7596c776), {
        addNewQuestionGroup: addNewQuestionGroup
    })) : null)));
};


const $85f61ab778fb9bcf$var$runQuestionAnswerMutationAfterMs = 1000;
let $85f61ab778fb9bcf$var$lastMetadata = null;
const $85f61ab778fb9bcf$export$23ac95e499a8bbe = (props)=>{
    const urlQueryParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const queryResult = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: urlQueryParams.projectId
        }
    });
    const servicesQueryResult = (0, $7608a8bbcbbad14c$export$a870673e4b33fcfb)();
    const projectSampleWithMultiAnswer = (0, $7608a8bbcbbad14c$export$3a30da8008cfc73a)()[0];
    const projectSampleWithNumericAnswer = (0, $7608a8bbcbbad14c$export$46ebc9426755df51)()[0];
    const projectSampleWithTextAnswer = (0, $7608a8bbcbbad14c$export$23628b905dc411dd)()[0];
    const enableWorkflowInProjectSampleMutation = (0, $7608a8bbcbbad14c$export$94b9fcb438d38b2d)()[0];
    const getMutationBasedOnAnswerType = (answerType)=>{
        switch(answerType){
            case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
                return projectSampleWithNumericAnswer;
            case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
                return projectSampleWithMultiAnswer;
            default:
                return projectSampleWithTextAnswer;
        }
    };
    const answerProjectSampleQuestion = (metadata, answer)=>{
        if (!metadata.questionLevelInput.sampleId) throw new Error("Metadata is missing sampleId");
        const options = {
            variables: {
                answer: answer,
                projectSampleQuestionInput: {
                    questionInput: metadata.questionInput,
                    projectSampleInput: {
                        projectId: metadata.questionLevelInput.projectId,
                        sampleId: metadata.questionLevelInput.sampleId
                    }
                }
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: urlQueryParams.projectId
                    }
                }
            ],
            awaitRefetchQueries: true
        };
        if (metadata.questionInput.questionId === "name") options.refetchQueries.push({
            query: (0, $7608a8bbcbbad14c$export$56959a2c3ec29cce),
            variables: {
                id: metadata.questionLevelInput.projectId
            }
        });
        const mutation = getMutationBasedOnAnswerType(metadata.answerType);
        if (metadata.answerType === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number) options.variables.answer = parseFloat(options.variables.answer) || 0;
        const mutationPromise = mutation(options);
        mutationPromise.catch((e)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e.toString());
        });
    };
    if (queryResult.error || servicesQueryResult.error) {
        const error = queryResult.error || servicesQueryResult.error;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    }
    if (queryResult.loading || !queryResult.data || servicesQueryResult.loading || !servicesQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const project = queryResult.data.Project;
    const services = servicesQueryResult.data.Services.sort((service1, service2)=>service1.order - service2.order) || [];
    if (!project.samples.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: no samples were defined in the project");
    const selectedSample = project.samples.find((sample)=>sample.id === urlQueryParams.sampleId);
    if (!selectedSample) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Sample not found");
    const workflows = selectedSample.suggestedWorkflows.length > 0 ? selectedSample.suggestedWorkflows : selectedSample.selectedWorkflows || [];
    const answerProjectSampleQuestionDebouncedInternal = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(answerProjectSampleQuestion, $85f61ab778fb9bcf$var$runQuestionAnswerMutationAfterMs, {
        leading: false,
        trailing: true
    });
    const answerProjectSampleQuestionDebounced = (metadata, answear)=>{
        if ($85f61ab778fb9bcf$var$lastMetadata !== JSON.stringify(metadata)) {
            $85f61ab778fb9bcf$var$lastMetadata = JSON.stringify(metadata);
            answerProjectSampleQuestionDebouncedInternal.flush();
        }
        answerProjectSampleQuestionDebouncedInternal(metadata, answear);
    };
    const getEnableWorkflowsOptions = (workflowId)=>{
        return {
            variables: {
                projectSampleWorkflowEnableInput: {
                    projectId: project.id,
                    sampleId: selectedSample.id,
                    workflowId: workflowId
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["EnableWorkflowInProjectSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: project.id
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) cache.writeQuery({
                    variables: {
                        id: project.id
                    },
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    data: {
                        Project: incomingData
                    }
                });
            }
        };
    };
    const enableWorkflows = async (selectedWorkflowsIds)=>{
        // eslint-disable-next-line no-restricted-syntax
        for (const workflowId of selectedWorkflowsIds){
            const options = getEnableWorkflowsOptions(workflowId);
            const mutationPromise = enableWorkflowInProjectSampleMutation(options);
            mutationPromise.catch((e)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e.toString());
            });
            // eslint-disable-next-line no-await-in-loop
            await mutationPromise;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $868c602c0bd46ebb$export$23ac95e499a8bbe), {
        sample: selectedSample,
        project: project,
        answerProjectSampleQuestion: answerProjectSampleQuestionDebounced,
        enableWorkflowsForProjectSample: enableWorkflows,
        services: services,
        workflows: workflows,
        ...props
    });
};



var $acw62 = parcelRequire("acw62");
const $633b54f18e47cb87$export$7b09e4e56e72adf7 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "Project timeline -\xa0", props.projectId);
};



var $acw62 = parcelRequire("acw62");
const $b2064c4fcddce0c2$export$1938c2a558dbd08 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "List of Results for project - ", props.projectId);
};



var $acw62 = parcelRequire("acw62");
const $ad026400ddaec87e$export$8fdcabde73f49165 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "Result ", props.resultId, " - for project - ", props.projectId);
};



var $acw62 = parcelRequire("acw62");
const $b259a7a43a8a0e37$export$123d2caab55bdec5 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, "List of Samples for project -", props.projectId);
};



var $acw62 = parcelRequire("acw62");


const $16007f7ec99c5da6$export$d4483811a7219199 = (props)=>{
    const { handleAuthentication: handleAuthentication } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    $acw62.useEffect(()=>{
        let postLoginRoute = "/";
        try {
            postLoginRoute = localStorage.getItem("gQ4QutxXcziDP3e2") || "/";
        } catch (err) {
        // do nothing
        }
        try {
            localStorage.setItem("gQ4QutxXcziDP3e2", "");
        } catch (err) {
        // do nothing
        }
        handleAuthentication({
            postLoginRoute: postLoginRoute
        });
    }, []);
    return /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
};
var $16007f7ec99c5da6$export$2e2bcd8739ae039 = $16007f7ec99c5da6$export$d4483811a7219199;


/* eslint-disable react/prop-types */ 
var $acw62 = parcelRequire("acw62");


const $35b3f2cd735e2b62$export$f41e788976ac3d85 = (0, $4f5dcc0184f23a66$export$2e2bcd8739ae039)`
  query MyQuery {
    healthcheck
  }
`;
var $35b3f2cd735e2b62$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f108aa291352b5e$export$62297b13309008b2), {
        query: $35b3f2cd735e2b62$export$f41e788976ac3d85
    }, (query)=>{
        const { loading: loading, data: data } = query;
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, "loading");
        if (data && data.healthcheck) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, data && data.healthcheck);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, ":(");
    });



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $b711d7114a492d30$export$fd49a2600ae22a01 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b711d7114a492d30$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $893bf6ab15cfafd6$export$614264b7ca4804e6), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b711d7114a492d30$var$ChildrenContainer, null, children));
};
const $b711d7114a492d30$var$Container = (0, $lmFrL.default).div`
  height: 100vh;
  display: flex;
`;
const $b711d7114a492d30$var$ChildrenContainer = (0, $lmFrL.default).div`
  flex-grow: 1;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $ab6826c47328cd8c$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dcffcd0a998792f2$export$10ff764a0e9ffbb8), {
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
    width: "9"
});
const $ab6826c47328cd8c$export$15c6004013f7aaec = (props)=>{
    const { id: id, name: name, percent: percent, active: active, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ab6826c47328cd8c$var$Container, {
        active: active,
        onClick: ()=>onClick(id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceece09e37e97a76$export$52979a15abfe7e29), {
        name: name,
        percent: percent,
        icon: $ab6826c47328cd8c$var$icon
    }));
};
$ab6826c47328cd8c$export$15c6004013f7aaec.defaultProps = {
    active: false
};
const $ab6826c47328cd8c$var$Container = (0, $lmFrL.default).div`
  ${(props)=>{
    if (props.active) return `
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.lightestTint};
  border: 2px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  > div > div:first-child {
    font-weight: 800;
  }
          `;
    return `
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 2px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
      `;
}}
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
`;

















const $4b4277e0518a98ad$export$ef8da11641c635de = (props)=>{
    const { projectsList: projectsList, samples: samples, selectedSample: selectedSample, onSampleClick: onSampleClick } = props;
    const { navBarOpen: navBarOpen, setNavBarOpen: setNavBarOpen, setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const addNewPathIsEnabled = useUserPermissions("addNewPath");
    const goToProjectDataIsEnabled = useUserPermissions("goToProjectData");
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const [addSampleToProjectMutation] = (0, $7608a8bbcbbad14c$export$c360d2acd2d92a13)();
    const projectsDropdown = projectsList.map((projectItem)=>({
            value: projectItem.id,
            label: projectItem.name
        }));
    let urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    if (!urlParams) urlParams = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_EVENT) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_SERVICE) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_WORKFLOW) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE);
    let dropdownDefaultValue;
    const selectedProject = projectsList.find((project)=>project.id === urlParams.projectId);
    if (selectedProject) dropdownDefaultValue = {
        value: selectedProject.id,
        label: selectedProject.name
    };
    const handleDropdownChange = async (selectedValue)=>{
        const { value: value } = selectedValue;
        if (value) {
            if (value !== selectedProject?.id) {
                setSelectedEntity(undefined);
                setSideDrawboardOpen(false);
            }
            const selProj = projectsList.find((project)=>project.id === value);
            if (selProj) await (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${value}/timeline/samples/${selProj.samples[0].id}`);
        }
    };
    const newSampleClick = async ()=>{
        if (!addNewPathIsEnabled) return;
        setShowSpinner(true);
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: urlParams.projectId
                }
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: urlParams.projectId
                    }
                },
                {
                    query: (0, $7608a8bbcbbad14c$export$56959a2c3ec29cce),
                    variables: {
                        id: urlParams.projectId
                    }
                }
            ],
            awaitRefetchQueries: true,
            update (cache, { data: data }) {
                (0, $590f4d6a0c375d80$export$6b98ed09a1b36987)({
                    id: urlParams.projectId
                }, (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96), "Project", "AddSampleToProject", cache, data, "samples");
            }
        };
        await addSampleToProjectMutation(options);
        setShowSpinner(false);
    };
    const configuratorOnClick = async ()=>{
        if (!goToProjectDataIsEnabled) return;
        setSideDrawboardOpen(false);
        await (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${urlParams.projectId}/configurator/samples/${selectedSample}/configurator`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$Container, {
        open: navBarOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$TopContainer, {
        open: navBarOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$ProjectContainer, {
        open: navBarOpen
    }, navBarOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1090c52da2338f2e$export$2dc68d50d56fbbd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
        options: projectsDropdown,
        defaultValue: dropdownDefaultValue,
        onChange: handleDropdownChange
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$StyledLabel, {
        label: dropdownDefaultValue?.label || ""
    })), navBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$SectionHeader, null, "PROJECT PATHS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$SamplesContainer, null, samples.filter((sample)=>sample.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing).map((sample)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab6826c47328cd8c$export$15c6004013f7aaec), {
            key: sample.id,
            id: sample.id,
            percent: sample.percent,
            name: sample.name,
            active: sample.id === selectedSample,
            onClick: (sampleId)=>onSampleClick(sampleId),
            status: sample.status
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$SamplesContainer, null, samples.filter((sample)=>sample.status !== (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing).map((sample)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab6826c47328cd8c$export$15c6004013f7aaec), {
            key: sample.id,
            id: sample.id,
            percent: sample.percent,
            name: sample.name,
            active: sample.id === selectedSample,
            onClick: (sampleId)=>onSampleClick(sampleId),
            status: sample.status
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$BottomContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$BottomButton, {
        onClick: newSampleClick,
        disabled: !addNewPathIsEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af15d86567b97244$export$f21ab0717a89c77f), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
    })), navBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$ButtonText, null, "Add a new path")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$StyledLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$BottomButton, {
        onClick: configuratorOnClick,
        disabled: !goToProjectDataIsEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a739990c1675c9d$export$2ad141e9e3d81b82), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic
    })), navBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$ButtonText, null, "Go to the project data"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b4277e0518a98ad$var$ExpandIconContainer, {
        onClick: ()=>setNavBarOpen(!navBarOpen),
        open: navBarOpen
    }, navBarOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d819d56e4eee36d1$export$a84e507fd943d8f9), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ad5d98d28e20636$export$d3dc052aee88bdfc), null))));
};
const $4b4277e0518a98ad$var$Container = (0, $lmFrL.default).div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  border-right: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
  position: relative;
  // width: 337px;
  width: ${({ open: open })=>open ? "337px" : "72px"};
  flex-shrink: 0;
`;
const $4b4277e0518a98ad$var$TopContainer = (0, $lmFrL.default).div`
  background-color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  padding: 0 24px;
  //margin-bottom: 32px;
  overflow-y: auto;
  height: 100%
    ${({ open: open })=>!open && (0, $lmFrL.css)`
        display: flex;
        align-items: center;
        & > div {
          margin-bottom: 0;
          width: 1.5rem;
        }
      `};
`;
const $4b4277e0518a98ad$var$ProjectContainer = (0, $lmFrL.default).div`
  margin-bottom: 16px;
  padding-top: 32px;
  padding-bottom: 16px;

  ${({ open: open })=>open && (0, $lmFrL.css)`
      border-bottom: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
    `}

  > div:first-child {
    margin-bottom: 8px;
  }
`;
const $4b4277e0518a98ad$var$StyledLabel = (0, $lmFrL.default)((0, $d1cfb23e53b30236$export$b04be29aa201d4f5))`
  writing-mode: vertical-rl;
  transform: scale(-1);
  width: 18px;

  & label {
    height: 149px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
`;
const $4b4277e0518a98ad$var$SectionHeader = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText};
  margin-bottom: 8px;
  margin-top: 24px;
`;
const $4b4277e0518a98ad$var$SamplesContainer = (0, $lmFrL.default).div`
  > div {
    margin-bottom: 8px;
  }
`;
const $4b4277e0518a98ad$var$BottomContainer = (0, $lmFrL.default).div`
  border-top: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
`;
const $4b4277e0518a98ad$var$BottomButton = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1.5rem 0 1.5rem 1.5rem;

  ${({ disabled: disabled })=>disabled && (0, $lmFrL.css)`
      cursor: not-allowed;

      div {
        color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};
      }

      path {
        fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.placeholder};
      }
    `}
`;
const $4b4277e0518a98ad$var$IconContainer = (0, $lmFrL.default).div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $4b4277e0518a98ad$var$ButtonText = (0, $lmFrL.default).div`
  flex-grow: 1;
  display: flex;
  margin-left: 8px;
  font-family: Overpass;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.secondary.basic};
`;
const $4b4277e0518a98ad$var$StyledLine = (0, $lmFrL.default).div`
  border-bottom: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside};
`;
const $4b4277e0518a98ad$var$ExpandIconContainer = (0, $lmFrL.default).div`
  cursor: pointer;
  top: 6.2rem;
  left: ${({ open: open })=>open ? "320px" : "54px"};
  position: absolute;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).shadows.icons.expandIcon};
  z-index: 1;

  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover circle {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.hover};
    transition: fill linear 0.2s;
  }

  & > svg:active circle {
    fill: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.darkestTint};
    transition: fill linear 0.2s;
  }
`;


// @ts-nocheck

var $acw62 = parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");
var $012ab268fa9077b1$exports = {};
"use strict";
var $012ab268fa9077b1$var$__assign = $012ab268fa9077b1$exports && $012ab268fa9077b1$exports.__assign || function() {
    $012ab268fa9077b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $012ab268fa9077b1$var$__assign.apply(this, arguments);
};
Object.defineProperty($012ab268fa9077b1$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $5c7908f42ed9bb37$export$402e76927ebf6a24 = [];


var $08f51855f5aa1c67$export$63c81bd924f89474 = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $16b09d5982f07c6f$export$8ca35300535e324d = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $a94d1125331cd631$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $a94d1125331cd631$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $a94d1125331cd631$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $a94d1125331cd631$var$msg;
    }
    window.dispatchEvent(event);
};



var $eb9a41c17c565fb1$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($eb9a41c17c565fb1$export$416d111b83cd1483 || ($eb9a41c17c565fb1$export$416d111b83cd1483 = {}));


var $4aa2fd75c74ae252$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $9347cb8a23412ffc$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $8243f40f6e04f737$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $8243f40f6e04f737$export$ee695c13482bb5dd = function(target) {
    if ($8243f40f6e04f737$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $8243f40f6e04f737$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $8243f40f6e04f737$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $5970d6d9ee6c5784$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $f202245796aa2855$var$cache = new WeakMap();
var $f202245796aa2855$var$scrollRegexp = /auto|scroll/;
var $f202245796aa2855$var$verticalRegexp = /^tb|vertical/;
var $f202245796aa2855$var$IE = /msie|trident/i.test((0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator && (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator.userAgent);
var $f202245796aa2855$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $f202245796aa2855$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $f202245796aa2855$var$zeroBoxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $f202245796aa2855$var$size(),
    borderBoxSize: $f202245796aa2855$var$size(),
    contentBoxSize: $f202245796aa2855$var$size(),
    contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $f202245796aa2855$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($f202245796aa2855$var$cache.has(target) && !forceRecalculation) return $f202245796aa2855$var$cache.get(target);
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(target)) {
        $f202245796aa2855$var$cache.set(target, $f202245796aa2855$var$zeroBoxes);
        return $f202245796aa2855$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$f202245796aa2855$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $f202245796aa2855$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $f202245796aa2855$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $f202245796aa2855$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $f202245796aa2855$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $f202245796aa2855$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $f202245796aa2855$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $f202245796aa2855$var$cache.set(target, boxes);
    return boxes;
};
var $f202245796aa2855$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $f202245796aa2855$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $01e136febfef5919$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $f202245796aa2855$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $3f0a2fbc64f46fd3$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $01e136febfef5919$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $f202245796aa2855$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $638acb999774387d$export$9c17b8913a2a3572 = function(depth) {
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $ecda2146b87bdeae$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    while((0, $08f51855f5aa1c67$export$63c81bd924f89474)()){
        depth = (0, $3f0a2fbc64f46fd3$export$9cac928141e5443b)();
        (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $16b09d5982f07c6f$export$8ca35300535e324d)()) (0, $a94d1125331cd631$export$888cb69481582149)();
    return depth > 0;
};



var $4a6a87bff7ef9ac1$var$trigger;
var $4a6a87bff7ef9ac1$var$callbacks = [];
var $4a6a87bff7ef9ac1$var$notify = function() {
    return $4a6a87bff7ef9ac1$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $4a6a87bff7ef9ac1$export$4c995d4933c4abb = function(callback) {
    if (!$4a6a87bff7ef9ac1$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $4a6a87bff7ef9ac1$var$notify();
        }).observe(el_1, config);
        $4a6a87bff7ef9ac1$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $4a6a87bff7ef9ac1$var$callbacks.push(callback);
    $4a6a87bff7ef9ac1$var$trigger();
};


var $b7d7256b374777b1$export$5755c7b572e34c6 = function(cb) {
    (0, $4a6a87bff7ef9ac1$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $068e7d416abba7c5$var$watching = 0;
var $068e7d416abba7c5$var$isWatching = function() {
    return !!$068e7d416abba7c5$var$watching;
};
var $068e7d416abba7c5$var$CATCH_PERIOD = 250;
var $068e7d416abba7c5$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $068e7d416abba7c5$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $068e7d416abba7c5$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $068e7d416abba7c5$var$scheduled = false;
var $068e7d416abba7c5$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $068e7d416abba7c5$var$CATCH_PERIOD;
        if ($068e7d416abba7c5$var$scheduled) return;
        $068e7d416abba7c5$var$scheduled = true;
        var until = $068e7d416abba7c5$var$time(timeout);
        (0, $b7d7256b374777b1$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $ecda2146b87bdeae$export$e54fe5b0f43758f7)();
            } finally{
                $068e7d416abba7c5$var$scheduled = false;
                timeout = until - $068e7d416abba7c5$var$time();
                if (!$068e7d416abba7c5$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $068e7d416abba7c5$var$observerConfig);
        };
        document.body ? cb() : (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $068e7d416abba7c5$export$d30788f2c20241cd = new $068e7d416abba7c5$var$Scheduler();
var $068e7d416abba7c5$export$1f18a74d42722835 = function(n) {
    !$068e7d416abba7c5$var$watching && n > 0 && $068e7d416abba7c5$export$d30788f2c20241cd.start();
    $068e7d416abba7c5$var$watching += n;
    !$068e7d416abba7c5$var$watching && $068e7d416abba7c5$export$d30788f2c20241cd.stop();
};





var $4b08a70ac8b1df2b$var$skipNotifyOnElement = function(target) {
    return !(0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && !(0, $8243f40f6e04f737$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $4b08a70ac8b1df2b$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $eb9a41c17c565fb1$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $f202245796aa2855$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($4b08a70ac8b1df2b$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $53daa9aad498b184$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $d48ceca8c6d96018$var$observerMap = new WeakMap();
var $d48ceca8c6d96018$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $d48ceca8c6d96018$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $53daa9aad498b184$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $d48ceca8c6d96018$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $4b08a70ac8b1df2b$export$fea412043713122)(target, options && options.box));
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(1);
            (0, $068e7d416abba7c5$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var index = $d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).splice((0, $5c7908f42ed9bb37$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $ba00521e8d0ae023$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






/* function calculateDimensions(initialDimensions: InitialDimensions): CalculatedDimensions
 * - Helper functions for calculating CalculatedDimensions with given IntialDimensions
 *@params-
 *	initialDimensions: InitialDimensions
 *
 * */ var $012ab268fa9077b1$var$calculateDimensions = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 300 : _b, _c = _a.height, height = _c === void 0 ? 300 : _c, _d = _a.marginLeft, marginLeft = _d === void 0 ? 0.1 : _d, _e = _a.marginRight, marginRight = _e === void 0 ? 0.1 : _e, _f = _a.marginTop, marginTop = _f === void 0 ? 0.1 : _f, _g = _a.marginBottom, marginBottom = _g === void 0 ? 0.1 : _g;
    // If each margin is fraction number(less than 1) used it as fraction of width or height 
    // then, caculate value with given width or height
    // otherwise, used it as static value. 
    var newMarginTop = marginTop < 1 ? Math.floor(height * marginTop) : marginTop;
    var newMarginBottom = marginBottom < 1 ? Math.floor(height * marginBottom) : marginBottom;
    var newMarginLeft = marginLeft < 1 ? Math.floor(width * marginLeft) : marginLeft;
    var newMarginRight = marginRight < 1 ? Math.floor(width * marginRight) : marginRight;
    // calculate each 'bounded'Properties
    var verticalMargins = newMarginTop + newMarginBottom;
    // if height is less equal than verticalMargins no margin on vertical axis.
    var boundedHeight = verticalMargins >= height ? height : Math.max(height - verticalMargins, 0);
    // if width is less equal than horizontalMargins no margin on horizontal axis.
    var horizontalMargins = newMarginRight + newMarginLeft;
    var boundedWidth = horizontalMargins >= width ? width : Math.max(width - horizontalMargins, 0);
    return {
        width: width,
        height: height,
        marginLeft: newMarginLeft,
        marginRight: newMarginRight,
        marginTop: newMarginTop,
        marginBottom: newMarginBottom,
        boundedWidth: boundedWidth,
        boundedHeight: boundedHeight
    };
};
var $012ab268fa9077b1$var$useDimensions = function(initialDimensions, resizeObserver) {
    if (resizeObserver === void 0) resizeObserver = $ba00521e8d0ae023$export$9caf76241ca21a11;
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState($012ab268fa9077b1$var$__assign($012ab268fa9077b1$var$__assign({}, $012ab268fa9077b1$var$calculateDimensions(initialDimensions)), {
        isDomAttached: false
    })), dimensions = _a[0], setDimensions = _a[1];
    $acw62.useEffect(function() {
        var element = ref.current;
        // if DOM is rendered 
        if (element) {
            if (!dimensions.isDomAttached) {
                var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
                setDimensions($012ab268fa9077b1$var$__assign($012ab268fa9077b1$var$__assign({}, $012ab268fa9077b1$var$calculateDimensions($012ab268fa9077b1$var$__assign($012ab268fa9077b1$var$__assign({}, initialDimensions), {
                    width: Number(width.toFixed(3)),
                    height: Number(height.toFixed(3))
                }))), {
                    isDomAttached: true
                }));
                // resize observer
                var observer_1 = new resizeObserver(function(entries) {
                    // if there is entries
                    if (entries.length > 0) {
                        // first element of entries is only needed
                        var entry = entries[0];
                        // check current width and height
                        var width_1 = dimensions.width, height_1 = dimensions.height;
                        // check resized width and height
                        var newWidth = Number(entry.contentRect.width.toFixed(3));
                        var newHeight = Number(entry.contentRect.height.toFixed(3));
                        // if at least one of width and height is changed
                        if (width_1 !== newWidth || height_1 !== newHeight) // set newly calculatedDimension with new width or height.
                        setDimensions($012ab268fa9077b1$var$__assign($012ab268fa9077b1$var$__assign({}, $012ab268fa9077b1$var$calculateDimensions($012ab268fa9077b1$var$__assign($012ab268fa9077b1$var$__assign({}, initialDimensions), {
                            width: newWidth,
                            height: newHeight
                        }))), {
                            isDomAttached: true
                        }));
                    }
                });
                // start to observer referenced element;
                observer_1.observe(element);
                return function() {
                    return observer_1.unobserve(element);
                };
            }
        }
    }, [
        ref
    ]);
    /* return values
     * @ref: Callback Ref
     * @dimensions: ResizedDimensions
     * */ return {
        ref: ref,
        dimensions: dimensions
    };
};
$012ab268fa9077b1$exports.default = $012ab268fa9077b1$var$useDimensions;



var $lmFrL = parcelRequire("lmFrL");




var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



var $acw62 = parcelRequire("acw62");

function $981d51073377eec5$export$1da33c890ea56e9f(props) {
    const tooNarrow = props.ownScale ? props.width / props.ownScale < 250 : false;
    const widthIfIsTooNarrow = tooNarrow ? 120 : props.width;
    const widthIfShowDetails = props.showDetails ? widthIfIsTooNarrow : props.width;
    return props.type === "TOP" ? /*#__PURE__*/ $acw62.createElement("path", {
        className: props.className,
        id: props.id,
        d: `M${props.x},${props.y + props.height} h${props.width} v-${props.height - props.radius} q${0},-${props.radius} -${props.radius},-${props.radius}  h-${props.width - props.radius} q-${props.radius},0 ${-props.radius},${props.radius} v${props.height - props.radius} z`,
        fill: props.fill
    }) : /*#__PURE__*/ $acw62.createElement("path", {
        className: props.className,
        id: props.id,
        d: `M${props.x},${props.y + props.height} h${widthIfShowDetails} v${props.height} q${0},${props.radius} -${props.radius},${props.radius}  h-${widthIfShowDetails - props.radius} q-${props.radius},0 ${-props.radius},${-props.radius} v-${props.height} z`,
        fill: props.fill
    });
}
$981d51073377eec5$export$1da33c890ea56e9f.defaultProps = {
    x: 100,
    y: 100,
    height: 100,
    width: 100,
    radius: 100,
    fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
};




var $acw62 = parcelRequire("acw62");

function $a054f1e3bd3c76f8$export$bf149c3b6eeafcc(props) {
    const totalArrowHeight = props.height * 0.6;
    return props.type === "LEFT" ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        className: "leftDragElement",
        style: {
            cursor: "col-resize"
        },
        d: `
      M${props.x},${props.y + props.height}
      
      h${props.width}
      
      v-${props.height}
     
      h-${props.width}
      
      q-${props.radius},0 ${-props.radius},${props.radius}
      
      v${props.height - props.radius * 2}
      
      q0,${props.radius} ${props.radius},${props.radius}
      
      z`,
        fill: props.fill
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "leftDragElement",
        style: {
            cursor: "col-resize"
        },
        d: `
      M${props.x + props.width * 0.5},${props.y + (props.height - totalArrowHeight) / 2}
      
      l-${props.width * 0.83},${totalArrowHeight / 2}
      
      l${props.width * 0.83},${totalArrowHeight / 2}
      
      `,
        stroke: "white",
        strokeWidth: props.width / 6,
        fillOpacity: 0
    })) : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        className: "rightDragElement",
        style: {
            cursor: "col-resize"
        },
        d: `
      M${props.x - props.radius},${props.y + props.height}
      
      h${props.width}
      
      q${props.radius},0 ${props.radius},${-props.radius}
      
      v-${props.height - props.radius * 2}
      
      q0,${-props.radius} ${-props.radius},${-props.radius}
      
      h-${props.width}
      
      v${props.height - props.radius * 2}

      z`,
        fill: props.fill
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "rightDragElement",
        style: {
            cursor: "col-resize"
        },
        d: `
      M${props.x - props.radius + props.width * 0.5},${props.y + (props.height - totalArrowHeight) / 2}
      
      l${props.width * 0.83},${totalArrowHeight / 2}
      
      l-${props.width * 0.83},${totalArrowHeight / 2}
      
      `,
        stroke: "white",
        strokeWidth: props.width / 6,
        fillOpacity: 0
    }));
}
$a054f1e3bd3c76f8$export$bf149c3b6eeafcc.defaultProps = {
    x: 100,
    y: 100,
    height: 100,
    width: 100,
    radius: 100,
    fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
};



const $936ee5739574b592$var$Block = ({ name: name, x: x, y: y, width: width, height: height, length: length, children: children, ownScale: ownScale = 1, showTitleOnHover: showTitleOnHover = false, showDetails: showDetails = false, onBlockClick: onBlockClick, selected: selected = false, blockId: blockId, disableDnD: disableDnD = false, blockColor: blockColor = (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray, isWorkflow: isWorkflow = false, serviceIsDelayed: serviceIsDelayed = false, todayX: todayX = 0, hideTooltip: hideTooltip = false })=>{
    const topHeight = 40;
    const bottomHeight = height ? height - (showDetails ? 100 : topHeight) : 200;
    const radius = parseInt((0, $a9484fd40cfd560e$export$2fd68ac541630219).radius.default, 10);
    const radiusInScale = radius * ownScale;
    const xWithRadius = x + radiusInScale;
    const widthWithRadius = Math.max(width - radiusInScale, 0.1);
    const selectedArrowWitdth = 12 * ownScale;
    const totalBlockHeight = showDetails ? (height + 8) * ownScale + 15 + 30 * ownScale : (height + 8) * ownScale;
    const blockIsVeryThin = (0, $a66eb252e0fd4b58$export$201583b01982110e)(widthWithRadius);
    const delayedColor = (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.errorState;
    const delayedBlockX = xWithRadius + widthWithRadius;
    const delayedWidth = todayX - delayedBlockX;
    const delayedString = serviceIsDelayed ? " DELAYED" : "";
    const shortenedBlockName = name && name.length > 15 ? `${name.slice(0, 15).trim()}\u{2026}` : name;
    return /*#__PURE__*/ $acw62.createElement($936ee5739574b592$var$G, {
        onClick: onBlockClick,
        disableDnd: disableDnD
    }, showTitleOnHover && !blockIsVeryThin ? /*#__PURE__*/ $acw62.createElement($936ee5739574b592$var$Tooltip, {
        className: "tooltip",
        x: x + 10 * ownScale,
        y: y - 15 * ownScale,
        ownScale: ownScale
    }, name + delayedString) : null, !hideTooltip && blockIsVeryThin ? /*#__PURE__*/ $acw62.createElement($936ee5739574b592$var$TooltipAngled, {
        x: x + 10 * ownScale,
        y: y - 5 * ownScale,
        ownScale: ownScale,
        transform: `rotate(-40 ${x + 10 * ownScale} ${y - 5 * ownScale})`
    }, shortenedBlockName) : null, serviceIsDelayed ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $981d51073377eec5$export$1da33c890ea56e9f), {
        className: "BlockHeader",
        id: blockId,
        type: "TOP",
        x: xWithRadius + widthWithRadius,
        y: y,
        height: topHeight * ownScale,
        width: delayedWidth,
        radius: radiusInScale,
        fill: delayedColor
    }), /*#__PURE__*/ $acw62.createElement((0, $981d51073377eec5$export$1da33c890ea56e9f), {
        type: "BOTTOM",
        x: xWithRadius + widthWithRadius,
        y: showDetails ? y - bottomHeight + topHeight * ownScale : y - bottomHeight * ownScale + topHeight * ownScale,
        height: showDetails ? bottomHeight : bottomHeight * ownScale,
        width: delayedWidth,
        radius: radiusInScale,
        fill: delayedColor,
        ownScale: ownScale,
        showDetails: showDetails
    })) : null, /*#__PURE__*/ $acw62.createElement((0, $981d51073377eec5$export$1da33c890ea56e9f), {
        className: "BlockHeader",
        id: blockId,
        type: "TOP",
        x: xWithRadius,
        y: y,
        height: topHeight * ownScale,
        width: widthWithRadius,
        radius: radiusInScale,
        fill: blockColor
    }), /*#__PURE__*/ $acw62.createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
        secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray,
        height: (16 * ownScale).toString(),
        width: (16 * ownScale).toString(),
        x: xWithRadius + (blockIsVeryThin ? -6 : 1) * ownScale,
        y: y + (blockIsVeryThin ? 2 : 12) * ownScale
    }), /*#__PURE__*/ $acw62.createElement((0, $981d51073377eec5$export$1da33c890ea56e9f), {
        type: "BOTTOM",
        x: xWithRadius,
        y: showDetails ? y - bottomHeight + topHeight * ownScale : y - bottomHeight * ownScale + topHeight * ownScale,
        height: showDetails ? bottomHeight : bottomHeight * ownScale,
        width: widthWithRadius,
        radius: radiusInScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
        ownScale: ownScale,
        showDetails: showDetails
    }), /*#__PURE__*/ $acw62.createElement((0, $456b87a164f2e791$export$87310464d9e20549), {
        className: "BlockHeader",
        id: blockId,
        text: name,
        maxWidth: (0, $a66eb252e0fd4b58$export$3e06f8d5fdc1813a)(ownScale, widthWithRadius),
        x: xWithRadius + (blockIsVeryThin ? -6 : 22) * ownScale,
        y: y + (blockIsVeryThin ? 34 : 25.5) * ownScale,
        fontSize: 16 * ownScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
    }), /*#__PURE__*/ $acw62.createElement("text", {
        textAnchor: "end",
        x: xWithRadius + widthWithRadius - (blockIsVeryThin ? 2 : 0) * ownScale,
        y: y + (blockIsVeryThin ? 16 : 25.5) * ownScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
        fontSize: 16 * ownScale,
        fontWeight: "bold"
    }, length), /*#__PURE__*/ $acw62.createElement("g", {
        transform: `translate(${x}, ${y + topHeight * ownScale + 10 * ownScale})`
    }, children), // PINGWING svg version of z-index zIndex
    selected && /*#__PURE__*/ $acw62.createElement("use", {
        xlinkHref: blockId
    }), selected && isWorkflow ? /*#__PURE__*/ $acw62.createElement((0, $981d51073377eec5$export$1da33c890ea56e9f), {
        type: "BOTTOM",
        x: xWithRadius,
        y: showDetails ? y - bottomHeight + topHeight * ownScale : y - bottomHeight * ownScale + topHeight * ownScale,
        height: showDetails ? bottomHeight : bottomHeight * ownScale,
        width: widthWithRadius,
        radius: radiusInScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.selectedTaskOverlay
    }) : null, selected && !disableDnD && !isWorkflow ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $a054f1e3bd3c76f8$export$bf149c3b6eeafcc), {
        type: "LEFT",
        x: xWithRadius,
        y: y,
        height: totalBlockHeight,
        width: selectedArrowWitdth,
        radius: radiusInScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.selectedTaskBorder
    }), /*#__PURE__*/ $acw62.createElement((0, $a054f1e3bd3c76f8$export$bf149c3b6eeafcc), {
        type: "RIGHT",
        x: xWithRadius + widthWithRadius - selectedArrowWitdth,
        y: y,
        height: totalBlockHeight,
        width: selectedArrowWitdth,
        radius: radiusInScale,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.selectedTaskBorder
    })) : null);
};
const $936ee5739574b592$var$G = (0, $lmFrL.default).g`
  :hover .tooltip {
    visibility: visible;
  }

  ${({ disableDnd: disableDnd })=>disableDnd && (0, $lmFrL.css)`
      cursor: pointer;
    `}
`;
const $936ee5739574b592$var$Tooltip = (0, $lmFrL.default).text`
  visibility: hidden;
  font-size: ${({ ownScale: ownScale = 1 })=>ownScale * 20}px;
`;
const $936ee5739574b592$var$TooltipAngled = (0, $lmFrL.default).text`
  font-size: ${({ ownScale: ownScale = 1 })=>ownScale * 20}px;
`;
var $936ee5739574b592$export$2e2bcd8739ae039 = $936ee5739574b592$var$Block;
$936ee5739574b592$var$Block.defaultProps = {
    width: 220,
    height: 110,
    x: 100,
    y: 100,
    ownScale: 1,
    headerHeight: 40,
    showTitleOnHover: false
};




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $528694881e20e6a6$export$396501e06429cbe = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.75 2C12.9926 2 14 3.00736 14 4.25V11.75C14 12.9926 12.9926 14 11.75 14H4.25C3.00736 14 2 12.9926 2 11.75V4.25C2 3.00736 3.00736 2 4.25 2H11.75ZM8 4C7.48716 4 7.06449 4.38604 7.00673 4.88338L7 5V11C7 11.5523 7.44772 12 8 12C8.51284 12 8.93551 11.614 8.99327 11.1166L9 11V5C9 4.44772 8.55228 4 8 4ZM11 6C10.4872 6 10.0645 6.38604 10.0067 6.88338L10 7V11C10 11.5523 10.4477 12 11 12C11.5128 12 11.9355 11.614 11.9933 11.1166L12 11V7C12 6.44772 11.5523 6 11 6ZM5 8C4.48716 8 4.06449 8.38604 4.00673 8.88338L4 9V11C4 11.5523 4.44772 12 5 12C5.51284 12 5.93551 11.614 5.99327 11.1166L6 11V9C6 8.44772 5.55228 8 5 8Z",
        fill: color
    }));
};
$528694881e20e6a6$export$396501e06429cbe.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $faa66b2d2069bb13$export$5fda1783bb83f57b = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10 11.3333C10.7364 11.3333 11.3333 10.7364 11.3333 10C11.3333 9.26362 10.7364 8.66667 10 8.66667C9.26362 8.66667 8.66667 9.26362 8.66667 10C8.66667 10.7364 9.26362 11.3333 10 11.3333Z",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H4ZM3.33333 12V4.66667H12.6667V12C12.6667 12.3682 12.3682 12.6667 12 12.6667H4C3.63181 12.6667 3.33333 12.3682 3.33333 12Z",
        fill: color
    }));
};
$faa66b2d2069bb13$export$5fda1783bb83f57b.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $acw62 = parcelRequire("acw62");

const $1a3f0bdd81cba476$export$e0af6f64dcdf9a06 = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.79995 1.6001C9.01212 1.6001 9.21561 1.68438 9.36564 1.83441L12.5656 5.03441C12.7157 5.18444 12.8 5.38792 12.8 5.6001V12.0001C12.8 13.3256 11.7254 14.4001 10.4 14.4001H5.59995C4.27447 14.4001 3.19995 13.3256 3.19995 12.0001V4.0001C3.19995 2.67461 4.27447 1.6001 5.59995 1.6001H8.79995ZM7.99915 3.2001H5.59995C5.15812 3.2001 4.79995 3.55827 4.79995 4.0001V12.0001C4.79995 12.4419 5.15812 12.8001 5.59995 12.8001H10.4C10.8418 12.8001 11.2 12.4419 11.2 12.0001V6.4001H8.79995C8.38968 6.4001 8.05155 6.09127 8.00533 5.69339L7.99995 5.6001L7.99915 3.2001Z",
        fill: color
    }));
};
$1a3f0bdd81cba476$export$e0af6f64dcdf9a06.defaultProps = {
    width: "16",
    height: "16",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.tertiaryGray
};



var $9ff3217c59de6720$export$ac8b2c861d136194 = /*#__PURE__*/ function(DETAIL_GROUPS) {
    DETAIL_GROUPS["REPORTS"] = "Reports";
    DETAIL_GROUPS["MEMOS"] = "Memos";
    DETAIL_GROUPS["DATES"] = "Dates";
    DETAIL_GROUPS["RESOURCES"] = "Resources";
    return DETAIL_GROUPS;
}({});
const $9ff3217c59de6720$var$defaultDetailHeaderHeight = 20;
function $9ff3217c59de6720$export$ca17560b2e80f4b5(detailGroups, height = $9ff3217c59de6720$var$defaultDetailHeaderHeight) {
    const totalHeadersHeight = detailGroups.length * height;
    return totalHeadersHeight + detailGroups.reduce((a, b)=>a + b.items.length, 1) * height;
}
function $9ff3217c59de6720$export$ce2180377d848345(d, detailGroups = [], height) {
    const index = detailGroups.findIndex((dd)=>dd.name === d.name);
    return $9ff3217c59de6720$export$ca17560b2e80f4b5(detailGroups.slice(0, index), height);
}
const $9ff3217c59de6720$export$56e2352e63353d99 = (props)=>{
    const boxIsNarrow = props.width / props.ownScale < 60;
    const boxIsTooNarrowForLine = props.width / props.ownScale < 90;
    const detailsText = boxIsNarrow ? "Det" : "Details";
    return /*#__PURE__*/ $acw62.createElement("g", {
        // onClick={(): void => props.setShowDetails(!props.showDetails)}
        pointerEvents: "bounding-box"
    }, /*#__PURE__*/ $acw62.createElement((0, $e17e79530b3afee5$export$b837bd7eac09a33e), {
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        width: 6 * props.ownScale,
        height: 15 * props.ownScale,
        x: 9 * props.ownScale,
        y: 2.5 * props.ownScale
    }), /*#__PURE__*/ $acw62.createElement("text", {
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        x: 16 * props.ownScale,
        y: 15 * props.ownScale,
        fontSize: 14 * props.ownScale,
        style: {
            cursor: "pointer"
        }
    }, detailsText), boxIsTooNarrowForLine ? null : /*#__PURE__*/ $acw62.createElement("line", {
        x1: 65 * props.ownScale,
        x2: props.width - 4,
        y1: 11 * props.ownScale,
        y2: 11 * props.ownScale,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.athensGray,
            strokeWidth: 1 / props.zoomedInLevel
        }
    }));
};
const $9ff3217c59de6720$export$7681fee114e2a07e = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $faa66b2d2069bb13$export$5fda1783bb83f57b), {
        y: props.y,
        x: props.width - 80 * props.ownScale - 2,
        height: 16 * props.ownScale,
        width: 16 * props.ownScale
    }), /*#__PURE__*/ $acw62.createElement((0, $528694881e20e6a6$export$396501e06429cbe), {
        y: props.y,
        x: props.width - 60 * props.ownScale - 2,
        height: 16 * props.ownScale,
        width: 16 * props.ownScale
    }), /*#__PURE__*/ $acw62.createElement((0, $1a3f0bdd81cba476$export$e0af6f64dcdf9a06), {
        y: props.y,
        x: props.width - 40 * props.ownScale - 2,
        height: 16 * props.ownScale,
        width: 16 * props.ownScale
    }), /*#__PURE__*/ $acw62.createElement((0, $651a3f4c44f43348$export$6dcd14de5b20d369), {
        y: props.y,
        x: props.width - 20 * props.ownScale - 2,
        height: 16 * props.ownScale,
        width: 16 * props.ownScale
    }));
};
function $9ff3217c59de6720$export$a64edcd3037852c6(detailGroup, scale = 1, zoomedInLevel = 1) {
    switch(detailGroup.name){
        case "Dates":
            return /*#__PURE__*/ $acw62.createElement("svg", {
                width: 16 * scale,
                height: 16 * scale,
                y: zoomedInLevel ? -8 : -5,
                x: zoomedInLevel ? 10 : 5,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ $acw62.createElement("path", {
                d: "M2 6.00024H14",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M13.1429 3.6001H2.85714C2.384 3.6001 2 3.95851 2 4.40012V13.2004C2 13.642 2.384 14.0004 2.85714 14.0004H13.1429C13.616 14.0004 14 13.642 14 13.2004V4.40012C14 3.95851 13.616 3.6001 13.1429 3.6001Z",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M4.57129 2V3.60005",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M11.4282 2V3.60005",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M8 2V3.60005",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }));
        case "Resources":
            return /*#__PURE__*/ $acw62.createElement("svg", {
                width: 16 * scale,
                height: 16 * scale,
                y: zoomedInLevel ? -8 : -5,
                x: zoomedInLevel ? 10 : 5,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ $acw62.createElement("path", {
                d: "M8.00014 14C9.4203 14 10.5716 11.3137 10.5716 8C10.5716 4.68629 9.4203 2 8.00014 2C6.57998 2 5.42871 4.68629 5.42871 8C5.42871 11.3137 6.57998 14 8.00014 14Z",
                stroke: "#3B79D1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M2 8H14",
                stroke: "#3B79D1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
                stroke: "#3B79D1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }));
        case "Reports":
            return /*#__PURE__*/ $acw62.createElement("svg", {
                width: 16 * scale,
                height: 16 * scale,
                y: zoomedInLevel ? -8 : -5,
                x: zoomedInLevel ? 10 : 5,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ $acw62.createElement("rect", {
                x: "4.5",
                y: "8",
                width: "1",
                height: "4",
                fill: "#3B79D1"
            }), /*#__PURE__*/ $acw62.createElement("rect", {
                x: "6.5",
                y: "4",
                width: "1",
                height: "8",
                fill: "#3B79D1"
            }), /*#__PURE__*/ $acw62.createElement("rect", {
                x: "8.5",
                y: "6",
                width: "1",
                height: "6",
                fill: "#3B79D1"
            }), /*#__PURE__*/ $acw62.createElement("rect", {
                x: "10.5",
                y: "10",
                width: "1",
                height: "2",
                fill: "#3B79D1"
            }), /*#__PURE__*/ $acw62.createElement("rect", {
                x: "2",
                y: "2",
                width: "12",
                height: "12",
                stroke: "#3B79D1"
            }));
        case "Memos":
        default:
            return /*#__PURE__*/ $acw62.createElement("svg", {
                width: 16 * scale,
                height: 16 * scale,
                y: zoomedInLevel ? -8 : -5,
                x: zoomedInLevel ? 10 : 5,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ $acw62.createElement("path", {
                d: "M4.39941 4.39868H9.99942",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M4.39941 6.79956H9.99942",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M4.39941 9.19946H9.99942",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ $acw62.createElement("path", {
                d: "M12.4 10V2H2V12.4C2 13.284 2.716 14 3.6 14M3.6 14C4.484 14 5.2 13.284 5.2 12.4V11.6H14V12C14 13.1048 13.1048 14 12 14H3.6Z",
                stroke: "#3B79D1",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }));
    }
}
const $9ff3217c59de6720$export$3e8048d3cf2ba3fd = (props)=>{
    const tooNarrow = props.width / props.ownScale < 250;
    const widthIfIsTooNarrow = tooNarrow ? 120 : props.width;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        width: widthIfIsTooNarrow,
        y: 10 * props.ownScale + 5,
        x: -2,
        height: props.height
    }, props.detailGroups.map((detailGroup)=>{
        return /*#__PURE__*/ $acw62.createElement("g", {
            transform: `translate(0, ${$9ff3217c59de6720$export$ce2180377d848345(detailGroup, props.detailGroups, props.detailHeaderHeight) - (props.zoomedInLevel ? 0 : 5)})`
        }, /*#__PURE__*/ $acw62.createElement("rect", {
            fill: "#F5F8FD",
            width: "100%",
            height: props.detailHeaderHeight,
            x: props.zoomedInLevel ? 1.5 : 0,
            y: -10
        }), $9ff3217c59de6720$export$a64edcd3037852c6(detailGroup, props.zoomedInLevel ? 0.4 : 0.6, props.zoomedInLevel), /*#__PURE__*/ $acw62.createElement("text", {
            fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            fontSize: 14 * props.ownScale,
            y: props.zoomedInLevel ? -3 : 2,
            x: 20
        }, detailGroup.name), detailGroup.items.map((item, i)=>{
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, i > 0 ? /*#__PURE__*/ $acw62.createElement("line", {
                x1: 8,
                y1: (i + 1) * props.detailHeaderHeight - 10,
                x2: props.width - 8,
                y2: (i + 1) * props.detailHeaderHeight - 10,
                style: {
                    stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.athensGray,
                    strokeWidth: props.zoomedInLevel ? 0.5 : 1
                }
            }) : null, /*#__PURE__*/ $acw62.createElement("text", {
                fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray,
                fontSize: 14 * props.ownScale,
                y: (i + 1) * props.detailHeaderHeight + (props.zoomedInLevel ? -3 : 2),
                x: 10,
                onClick: item.link ? ()=>{
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(item.link);
                } : undefined,
                style: item.link ? {
                    cursor: "pointer"
                } : undefined
            }, item.name), item.value && /*#__PURE__*/ $acw62.createElement("text", {
                fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText,
                fontSize: 14 * props.ownScale,
                y: (i + 1) * props.detailHeaderHeight + (props.zoomedInLevel ? -3 : 2),
                x: "95%",
                textAnchor: "end"
            }, item.value));
        }));
    }));
};








const $45477df3f05bcd9c$export$3aad99d61846824e = (status)=>{
    return status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Approved || status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing || status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Finished;
};


const $94f1a4c82da92a9a$export$ff6d4fbdc5509464 = ({ currentTransform: currentTransform, projectId: projectId, sampleId: sampleId, workflowName: workflowName, workflowId: workflowId, color: color, disableDnD: disableDnD, visibleOnAllPaths: visibleOnAllPaths, originPathId: originPathId, todayX: todayX, ...service })=>{
    const matchProjectPath = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_WILDCARD);
    let reports = [
        {
            name: "Not yet available"
        }
    ];
    if (service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Finished) reports = [
        {
            name: "Go to reports",
            link: `/reports/${projectId}/${sampleId}`
        }
    ];
    // todo get from props
    const detailGroups = [
        {
            name: (0, $9ff3217c59de6720$export$ac8b2c861d136194).DATES,
            items: [
                {
                    name: "Start date",
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(parseInt(service.startDate, 10))).format("L")
                },
                {
                    name: "End date",
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(parseInt(service.endDate, 10))).format("L")
                }
            ]
        },
        {
            name: (0, $9ff3217c59de6720$export$ac8b2c861d136194).REPORTS,
            items: reports
        },
        {
            name: (0, $9ff3217c59de6720$export$ac8b2c861d136194).MEMOS,
            items: []
        },
        {
            name: (0, $9ff3217c59de6720$export$ac8b2c861d136194).RESOURCES,
            items: []
        }
    ];
    const zoomedInLevel = (0, $a66eb252e0fd4b58$export$ae562900860eaf36)(currentTransform.k);
    const detailHeaderHeight = 20 / zoomedInLevel;
    const filteredDetailGroupsWithHeights = detailGroups.filter((g)=>g?.items && g.items.length > 0).map((g)=>({
            ...g,
            height: (0, $9ff3217c59de6720$export$ca17560b2e80f4b5)([
                g
            ], detailHeaderHeight)
        }));
    const detailGroupsHeight = (0, $9ff3217c59de6720$export$ca17560b2e80f4b5)(filteredDetailGroupsWithHeights, detailHeaderHeight);
    const selectedElementPath = {
        projectId: projectId,
        sampleId: sampleId,
        workflowName: workflowName,
        workflowId: workflowId,
        service: service,
        originPathId: originPathId,
        visibleOnAllPaths: visibleOnAllPaths
    };
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { setSelectedEntity: setSelectedEntity, selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const [serviceIsSelected, setServiceIsSelected] = (0, $acw62.useState)(false);
    const handleOnBlockClick = ()=>{
        setSideDrawboardOpen(true);
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE,
            selectedElementPath: selectedElementPath
        });
        if (matchProjectPath && !workflowId) {
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/timeline/samples/${sampleId}`);
            return;
        }
        if (matchProjectPath) (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/timeline/samples/${sampleId}/workflows/${workflowId}/services/${service.id}`);
    };
    (0, $acw62.useEffect)(()=>{
        const isSelected = selectedEntity ? selectedEntity?.selectedElementPath.service?.id === selectedElementPath.service?.id : false;
        setServiceIsSelected(isSelected);
    }, [
        selectedEntity
    ]);
    const [showDetails, setShowDetails] = (0, $acw62.useState)(!!service.showDetails);
    const ownScale = (0, $a66eb252e0fd4b58$export$dbf01c52ad4aabb3)(currentTransform.k);
    const { width: width, endDate: endDate, startDate: startDate } = service;
    const minWidth = 2 * ownScale;
    const widthWithDetailsOpened = showDetails && width < minWidth ? minWidth : width;
    const headerHeight = 40 * ownScale;
    const lengthInMs = parseInt(endDate, 10) - parseInt(startDate, 10);
    const lengthInWeeks = lengthInMs / 604800000;
    const lengthInDays = lengthInMs / 86400000;
    const lockIcon = (0, $45477df3f05bcd9c$export$3aad99d61846824e)(service.status) ? "\uD83D\uDD12" : "";
    const lengthString = lockIcon + (lengthInWeeks > 2 ? `${Math.ceil(lengthInWeeks)}w` : `${Math.ceil(lengthInDays)}d`);
    const nowTimestamp = Date.now();
    const serviceIsDelayed = service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing && parseInt(service.endDate, 10) < nowTimestamp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $936ee5739574b592$export$2e2bcd8739ae039), {
        blockId: service.id,
        headerHeight: headerHeight,
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        length: lengthString,
        ...service,
        width: widthWithDetailsOpened,
        height: service.height + (showDetails ? detailGroupsHeight : 0),
        ownScale: ownScale,
        showTitleOnHover: true,
        showDetails: showDetails,
        onBlockClick: handleOnBlockClick,
        selected: serviceIsSelected,
        blockColor: color,
        disableDnD: disableDnD,
        serviceIsDelayed: serviceIsDelayed,
        todayX: todayX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ff3217c59de6720$export$56e2352e63353d99), {
        setShowDetails: setShowDetails,
        showDetails: showDetails,
        ownScale: ownScale,
        width: widthWithDetailsOpened,
        zoomedInLevel: zoomedInLevel
    }));
};
$94f1a4c82da92a9a$export$ff6d4fbdc5509464.defaultProps = {
    ownScale: 1,
    width: 220,
    height: 100,
    x: 100,
    y: 100
};




var $acw62 = parcelRequire("acw62");








const $cbaacee6e33703b9$export$dcb94e49d873db03 = ({ projectId: projectId, sampleId: sampleId, ...workflow })=>{
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { setSelectedEntity: setSelectedEntity, selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const [serviceIsSelected, setServiceIsSelected] = (0, $acw62.useState)(false);
    const matchProjectPath = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_WILDCARD);
    const headerHeight = 40;
    const selectedElementPath = {
        projectId: projectId,
        sampleId: sampleId,
        workflowName: workflow.name,
        workflowId: workflow.id,
        workflow: workflow
    };
    const handleOnBlockClick = async ()=>{
        setSideDrawboardOpen(true);
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW,
            selectedElementPath: selectedElementPath
        });
        if (matchProjectPath) await (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/timeline/samples/${sampleId}/workflows/${workflow.id}`);
    };
    (0, $acw62.useEffect)(()=>{
        const isSelected = selectedEntity ? JSON.stringify(selectedEntity.selectedElementPath) === JSON.stringify(selectedElementPath) : false;
        setServiceIsSelected(isSelected);
    }, [
        selectedEntity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $936ee5739574b592$export$2e2bcd8739ae039), {
        headerHeight: headerHeight,
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        length: `${(0, $dc6fb3e45bbe78f3$export$a11918783cae9a97)(workflow)}w`,
        ...workflow,
        height: workflow.services.length * 20 + 150,
        blockColor: workflow.blockColor,
        onBlockClick: handleOnBlockClick,
        selected: serviceIsSelected,
        disableDnD: workflow.disableDnD,
        isWorkflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.lightText,
        x: 0,
        y: 9
    }, "SUBTASKS"), workflow.services.map((service, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            y: i * 20 + 30,
            key: service.id
        }, service.name)));
};
$cbaacee6e33703b9$export$dcb94e49d873db03.defaultProps = {
    width: 220,
    height: 100
};





var $acw62 = parcelRequire("acw62");
// ========
// MINIMAP prep
// minimap inspired by https://observablehq.com/@rabelais/d3-js-zoom-minimap
// ========

const $f12409ee1bd2f4d3$export$4fa6d59685552a7c = (x, y, k)=>{
    const coord2d = `translate(${x}, ${y})`;
    if (!k) return coord2d;
    return `${coord2d} scale(${k})`;
};
const $f12409ee1bd2f4d3$export$946dd6c81ac75a9f = (x, y, k)=>[
        "transform",
        $f12409ee1bd2f4d3$export$4fa6d59685552a7c(x, y, k)
    ];
const $f12409ee1bd2f4d3$export$2784e4af23e06893 = (zoomScale, config)=>// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    $db1dd3c66a0cbf94$export$2e2bcd8739ae039([
        0,
        config._width
    ], [
        0,
        config._width * zoomScale
    ]);
const $f12409ee1bd2f4d3$export$cb4680fd6c11928e = (zoomScale, config)=>// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    $db1dd3c66a0cbf94$export$2e2bcd8739ae039([
        0,
        config._height
    ], [
        0,
        config._height * zoomScale
    ]);




var $acw62 = parcelRequire("acw62");

const $1703658fd39cf5e7$export$fa17e9a974485717 = ({ width: width, height: height, color: color, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0H2.5V2.5H0V0ZM0 6.25H2.5V8.75H0V6.25ZM2.5 12.5H0V15H2.5V12.5ZM6.25 12.5H8.75V15H6.25V12.5ZM15 12.5H12.5V15H15V12.5ZM6.25 6.25H8.75V8.75H6.25V6.25ZM15 6.25H12.5V8.75H15V6.25ZM6.25 0H8.75V2.5H6.25V0ZM15 0H12.5V2.5H15V0Z",
        fill: "#3B79D1"
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "transparent"
    }));
};
$1703658fd39cf5e7$export$fa17e9a974485717.defaultProps = {
    width: "20",
    height: "20",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



var $acw62 = parcelRequire("acw62");

const $817dc56dd7c8b3b4$export$7fd917bb0f156712 = ({ width: width, height: height, color: color, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.625 8.75L17.5 1.875M17.5 1.875V7.5M17.5 1.875H11.875",
        stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 7V2H6",
        stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M18 13V18H14",
        stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.75 10.625L1.875 17.5M1.875 17.5V11.875M1.875 17.5H7.5",
        stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
        strokeWidth: "2"
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "transparent"
    }));
};
$817dc56dd7c8b3b4$export$7fd917bb0f156712.defaultProps = {
    width: "20",
    height: "20",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



var $acw62 = parcelRequire("acw62");

const $59a85c8addafa543$export$cb808a3c41736d8e = ({ width: width, height: height, color: color, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.5 8.75H17.5V11.25H2.5V8.75Z",
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "transparent"
    }));
};
$59a85c8addafa543$export$cb808a3c41736d8e.defaultProps = {
    width: "20",
    height: "20",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};



var $acw62 = parcelRequire("acw62");

const $a45abe70ee3ad71d$export$e7edafc470c5b67d = ({ width: width, height: height, color: color, ...props })=>{
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.1113 0.333252H5.88908V5.88875H0.333496V8.11098H5.88908V13.6666H8.1113V8.11098H13.6668V5.88875H8.1113V0.333252Z",
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "transparent"
    }));
};
$a45abe70ee3ad71d$export$e7edafc470c5b67d.defaultProps = {
    width: "14",
    height: "14"
};



const $68679112dabf4530$var$Minimap = (props)=>{
    const { config: config } = props;
    const { setSideBarOpen: setSideBarOpen, setSideDrawboardOpen: setSideDrawboardOpen, setNavBarOpen: setNavBarOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const setFullscreen = ()=>{
        setSideBarOpen(false);
        setSideDrawboardOpen(false);
        setNavBarOpen(false);
    };
    return /*#__PURE__*/ $acw62.createElement("g", {
        id: "minimap"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        id: "minimapBg",
        x: props.axisWidth - config.viewWidth - 3 * config.margin,
        y: config._height - config.viewHeight - 3 * config.margin - config.controlsHeight,
        width: config.viewWidth + 2 * config.margin,
        height: config.viewHeight + 2 * config.margin + config.controlsHeight,
        rx: 8,
        ry: 8,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
    }), /*#__PURE__*/ $acw62.createElement("svg", {
        ref: props.forwardedRef,
        id: "minimapSVG",
        x: props.axisWidth - config.viewWidth - 2 * config.margin,
        y: config._height - config.viewHeight - 2 * config.margin - config.controlsHeight,
        width: (0, $f12409ee1bd2f4d3$export$2784e4af23e06893)(config.minimapScale, config)(config._width),
        height: (0, $f12409ee1bd2f4d3$export$cb4680fd6c11928e)(config.minimapScale, config)(config._height),
        viewBox: [
            0,
            0,
            config._width,
            config._height
        ].join(" "),
        preserveAspectRatio: "xMidYMid meet"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        id: "selection-boundary",
        width: config._width,
        height: config._height,
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white,
        stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray,
        strokeWidth: "1px",
        style: {
            zIndex: 20
        }
    }), props.services.map((service)=>/*#__PURE__*/ $acw62.createElement("rect", {
            key: service.id,
            y: props.baselineY - props.baselineHeight * service.baseLine,
            x: props.x(service.startDate),
            width: Math.max(props.x(service.endDate) - props.x(service.startDate), 20),
            height: 10,
            opacity: 0.3,
            rx: 10
        }))), /*#__PURE__*/ $acw62.createElement("line", {
        y1: config._height - config.controlsHeight - config.margin,
        y2: config._height - config.controlsHeight - config.margin,
        x1: props.axisWidth - config.viewWidth - 3 * config.margin,
        x2: props.axisWidth - config.margin,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside,
            strokeWidth: 1
        }
    }), /*#__PURE__*/ $acw62.createElement((0, $1703658fd39cf5e7$export$fa17e9a974485717), {
        x: props.axisWidth - config.viewWidth - 2 * config.margin,
        y: config._height - 2 * config.margin - 12,
        onClick: props.resetView,
        style: {
            cursor: "pointer",
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            pointerEvents: "bounding-box"
        }
    }), /*#__PURE__*/ $acw62.createElement("line", {
        x1: props.axisWidth - config.viewWidth - 2 * config.margin + 25,
        y1: config._height - 2 * config.margin - 14,
        x2: props.axisWidth - config.viewWidth - 2 * config.margin + 25,
        y2: config._height - 2 * config.margin + 5,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersInside,
            strokeWidth: 1
        }
    }), /*#__PURE__*/ $acw62.createElement((0, $817dc56dd7c8b3b4$export$7fd917bb0f156712), {
        x: props.axisWidth - config.viewWidth - 2 * config.margin + 35,
        y: config._height - 2 * config.margin - 14,
        onClick: setFullscreen,
        style: {
            cursor: "pointer",
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            pointerEvents: "bounding-box"
        }
    }), /*#__PURE__*/ $acw62.createElement((0, $59a85c8addafa543$export$cb808a3c41736d8e), {
        onClick: ()=>props.increaseTransform(-0.25),
        x: props.axisWidth - 5 * config.margin - 38,
        y: config._height - 2 * config.margin - 14,
        style: {
            padding: 10,
            cursor: "pointer",
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            pointerEvents: "bounding-box"
        }
    }), /*#__PURE__*/ $acw62.createElement((0, $a45abe70ee3ad71d$export$e7edafc470c5b67d), {
        onClick: ()=>props.increaseTransform(0.25),
        x: props.axisWidth - 5 * config.margin - 10,
        y: config._height - 2 * config.margin - 3 - 8,
        style: {
            padding: 10,
            cursor: "pointer",
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            pointerEvents: "bounding-box"
        }
    }), /*#__PURE__*/ $acw62.createElement("text", {
        x: props.axisWidth - 3 * config.margin,
        y: config._height - 2 * config.margin - 3,
        dominantBaseline: "middle",
        textAnchor: "middle",
        fontFamily: "Overpass",
        fontWeight: "800",
        fontSize: 14
    }, `${Math.round(props.currentTransform.k * 100)}%`));
};
var $68679112dabf4530$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement($68679112dabf4530$var$Minimap, {
        forwardedRef: ref,
        ...props
    }));




var $acw62 = parcelRequire("acw62");


const $a6f31bcb30602320$export$c3fa0ba61f9aa58a = ({ x: x, y: y = (0, $a66eb252e0fd4b58$export$305eb744eb40f4ef), height: height })=>/*#__PURE__*/ $acw62.createElement("g", {
        id: "eline"
    }, /*#__PURE__*/ $acw62.createElement("line", {
        x1: x,
        x2: x,
        y1: y,
        y2: height,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).colors.frenchGray,
            strokeWidth: 2,
            strokeDasharray: 5
        }
    }), /*#__PURE__*/ $acw62.createElement($a6f31bcb30602320$var$Triangle, {
        x: x,
        y: y
    }));
const $a6f31bcb30602320$var$Triangle = ({ x: x, y: y })=>/*#__PURE__*/ $acw62.createElement("svg", {
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        x: x - 6,
        y: y
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.34535 5.43305C5.72112 5.75848 6.27888 5.75848 6.65465 5.43305L10.9006 1.75593C11.6005 1.14979 11.1719 0 10.246 0H1.75402C0.828135 0 0.399465 1.14979 1.09937 1.75593L5.34535 5.43305Z",
        fill: "#141419"
    }));



var $acw62 = parcelRequire("acw62");


const $c90fe9ddbb64f23e$export$c5319153a9ea6c5 = ({ x: x, y: y = (0, $a66eb252e0fd4b58$export$305eb744eb40f4ef), height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        id: "dropLine",
        key: "dropLine"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: x,
        y: y
    }, "Hello There!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: x,
        x2: x,
        y1: y,
        y2: height,
        style: {
            stroke: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90fe9ddbb64f23e$var$Triangle, {
        x: x,
        y: y
    }));
const $c90fe9ddbb64f23e$var$Triangle = ({ x: x, y: y })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        x: x - 6,
        y: y
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5.34535 5.43305C5.72112 5.75848 6.27888 5.75848 6.65465 5.43305L10.9006 1.75593C11.6005 1.14979 11.1719 0 10.246 0H1.75402C0.828135 0 0.399465 1.14979 1.09937 1.75593L5.34535 5.43305Z",
        fill: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
    }));



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $17988a9d596bcc6e$export$b8cabaaa78031cf8 = (props)=>{
    const { x: x = 0, y: y = 0, color: color, onClick: onClick, className: className, id: id, zoom: zoom } = props;
    return /*#__PURE__*/ $acw62.createElement($17988a9d596bcc6e$var$SvgWrapper, {
        id: id,
        x: x,
        y: y,
        className: className,
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        viewBox: `0 0 ${(0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom)} ${(0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom)}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        rx: (0, $a66eb252e0fd4b58$export$2312b3c5fb51a00b)(zoom),
        fill: "transparent"
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: (0, $a66eb252e0fd4b58$export$6ff78ae41f052774)(zoom),
        y: (0, $a66eb252e0fd4b58$export$6ff78ae41f052774)(zoom),
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(16, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(16, zoom),
        rx: (0, $a66eb252e0fd4b58$export$2312b3c5fb51a00b)(zoom),
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("g", {
        clipPath: "url(#clip0_727_2)",
        style: {
            transform: `scale(${(0, $a66eb252e0fd4b58$export$a2131950bc31a4d5)(zoom)})`
        }
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 10C5 7.23857 7.23857 5 10 5C12.7614 5 15 7.23857 15 10C15 12.7614 12.7614 15 10 15C7.23857 15 5 12.7614 5 10Z",
        fill: "#fff"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.3464 10.0055C11.3484 9.32363 10.9792 8.6905 10.3284 8.2503C10.5269 8.08419 10.6947 7.8951 10.8227 7.69117C11.0214 7.37466 11.1263 7.02042 11.1263 6.66675H10.7362C10.7362 6.82613 10.7099 6.9827 10.6597 7.13368H9.31372C9.26346 6.98271 9.23726 6.82613 9.23726 6.66675H8.84706C8.84706 7.02042 8.95205 7.37466 9.15069 7.69117C9.27867 7.89509 9.44649 8.08418 9.64498 8.2503C8.99423 8.6905 8.62495 9.32362 8.62696 10.0055C8.62897 10.684 8.99781 11.3125 9.64473 11.75C9.44853 11.9143 9.28236 12.1009 9.15497 12.3022C8.95354 12.6205 8.84707 12.9772 8.84707 13.3334H9.23727C9.23727 13.1789 9.26191 13.0271 9.30909 12.8805H10.6644C10.7115 13.0271 10.7362 13.1789 10.7362 13.3334H11.1264C11.1264 12.9772 11.0199 12.6205 10.8185 12.3022C10.6911 12.1009 10.5249 11.9143 10.3287 11.75C10.9756 11.3125 11.3444 10.684 11.3464 10.0055ZM9.03046 10.1952H10.9429C10.9229 10.3439 10.8802 10.489 10.8162 10.6281H9.1572C9.09319 10.489 9.05049 10.3439 9.03046 10.1952ZM10.943 9.80499H9.03044C9.05048 9.6563 9.09309 9.51117 9.15715 9.37209H10.8163C10.8803 9.51117 10.9229 9.6563 10.943 9.80499ZM10.4675 7.52387C10.3454 7.70735 10.1837 7.87637 9.98671 8.02424C9.78969 7.87637 9.62802 7.70737 9.50591 7.52387H10.4675ZM9.96439 8.50846L9.98671 8.49483L10.009 8.50847C10.2318 8.64457 10.4193 8.80476 10.5673 8.9819H9.40615C9.5541 8.80475 9.74158 8.64456 9.96439 8.50846ZM9.49638 12.4903C9.61955 12.3013 9.78446 12.1274 9.98671 11.9757C10.189 12.1274 10.3539 12.3013 10.477 12.4903H9.49638ZM9.99605 11.4997C9.9929 11.5016 9.98984 11.5036 9.98671 11.5055C9.98357 11.5036 9.98052 11.5016 9.97736 11.4997C9.74877 11.3619 9.55668 11.199 9.40582 11.0183H10.5676C10.4167 11.1989 10.2246 11.3619 9.99605 11.4997Z",
        fill: color
    })), /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: "clip0_727_2"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: 10,
        height: 10,
        fill: "white",
        transform: "translate(5 5)"
    }))));
};
const $17988a9d596bcc6e$var$SvgWrapper = (0, $lmFrL.default).svg`
  cursor: pointer;
`;



var $acw62 = parcelRequire("acw62");

function $baa8e8bad15b7b23$var$SelectedEventIcon(props) {
    const { x: x = 0, y: y = 0, color: color, secondColor: secondColor, onClick: onClick, className: className, id: id, zoom: zoom } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        id: id,
        x: x,
        y: y,
        className: className,
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        viewBox: `0 0 ${(0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom)} ${(0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom)}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, zoom),
        rx: (0, $a66eb252e0fd4b58$export$2312b3c5fb51a00b)(zoom),
        fill: secondColor
    }), /*#__PURE__*/ $acw62.createElement("rect", {
        x: (0, $a66eb252e0fd4b58$export$6ff78ae41f052774)(zoom),
        y: (0, $a66eb252e0fd4b58$export$6ff78ae41f052774)(zoom),
        width: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(16, zoom),
        height: (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(16, zoom),
        rx: (0, $a66eb252e0fd4b58$export$2312b3c5fb51a00b)(zoom),
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("g", {
        clipPath: "url(#clip0_727_9)",
        style: {
            transform: `scale(${(0, $a66eb252e0fd4b58$export$a2131950bc31a4d5)(zoom)})`
        }
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 10C5 7.23857 7.23857 5 10 5C12.7614 5 15 7.23857 15 10C15 12.7614 12.7614 15 10 15C7.23857 15 5 12.7614 5 10Z",
        fill: secondColor
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.3464 10.0055C11.3484 9.32363 10.9792 8.6905 10.3284 8.2503C10.5269 8.08419 10.6947 7.8951 10.8227 7.69117C11.0214 7.37466 11.1263 7.02042 11.1263 6.66675H10.7362C10.7362 6.82613 10.7099 6.9827 10.6597 7.13368H9.31372C9.26346 6.98271 9.23726 6.82613 9.23726 6.66675H8.84706C8.84706 7.02042 8.95205 7.37466 9.15069 7.69117C9.27867 7.89509 9.44649 8.08418 9.64498 8.2503C8.99423 8.6905 8.62495 9.32362 8.62696 10.0055C8.62897 10.684 8.99781 11.3125 9.64473 11.75C9.44853 11.9143 9.28236 12.1009 9.15497 12.3022C8.95354 12.6205 8.84707 12.9772 8.84707 13.3334H9.23727C9.23727 13.1789 9.26191 13.0271 9.30909 12.8805H10.6644C10.7115 13.0271 10.7362 13.1789 10.7362 13.3334H11.1264C11.1264 12.9772 11.0199 12.6205 10.8185 12.3022C10.6911 12.1009 10.5249 11.9143 10.3287 11.75C10.9756 11.3125 11.3444 10.684 11.3464 10.0055ZM9.03046 10.1952H10.9429C10.9229 10.3439 10.8802 10.489 10.8162 10.6281H9.1572C9.09319 10.489 9.05049 10.3439 9.03046 10.1952ZM10.943 9.80499H9.03044C9.05048 9.6563 9.09309 9.51117 9.15715 9.37209H10.8163C10.8803 9.51117 10.9229 9.6563 10.943 9.80499ZM10.4675 7.52387C10.3454 7.70735 10.1837 7.87637 9.98671 8.02424C9.78969 7.87637 9.62802 7.70737 9.50591 7.52387H10.4675ZM9.96439 8.50846L9.98671 8.49483L10.009 8.50847C10.2318 8.64457 10.4193 8.80476 10.5673 8.9819H9.40615C9.5541 8.80475 9.74158 8.64456 9.96439 8.50846ZM9.49638 12.4903C9.61955 12.3013 9.78446 12.1274 9.98671 11.9757C10.189 12.1274 10.3539 12.3013 10.477 12.4903H9.49638ZM9.99605 11.4997C9.9929 11.5016 9.98984 11.5036 9.98671 11.5055C9.98357 11.5036 9.98052 11.5016 9.97736 11.4997C9.74877 11.3619 9.55668 11.199 9.40582 11.0183H10.5676C10.4167 11.1989 10.2246 11.3619 9.99605 11.4997Z",
        fill: color
    })), /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: "clip0_727_9"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        width: 10,
        height: 10,
        fill: "white",
        transform: "translate(5 5)"
    }))));
}
var $baa8e8bad15b7b23$export$2e2bcd8739ae039 = $baa8e8bad15b7b23$var$SelectedEventIcon;



var $acw62 = parcelRequire("acw62");
const $84fd979863cecccd$export$fb9f56d10d46869f = ({ text: text = "", maxChars: maxChars = 29, scale: scale = 1, maxLines: maxLines })=>{
    const tokens = text.split(" ");
    const lines = [
        []
    ];
    tokens.forEach((t)=>{
        const lastLine = lines[lines.length - 1];
        const lastLineLength = lastLine.join(" ").length;
        if (lastLineLength > maxChars) lines.push([
            t
        ]);
        else lastLine.push(t);
    });
    let linesFormatted = lines.map((line)=>line.join(" "));
    if (maxLines && linesFormatted.length > maxLines) {
        linesFormatted = linesFormatted.slice(0, maxLines);
        linesFormatted[linesFormatted.length - 1] = `${linesFormatted[linesFormatted.length - 1]}\u{2026}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linesFormatted.map((fragment, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: fragment,
            y: i * 25 * scale + 10 * scale,
            fontSize: 13 * scale
        }, fragment)));
};







const $d3598a50f749fb55$export$8d048a4093f4779e = ({ x: x, y: y, currentTransform: currentTransform, projectId: projectId, sampleId: sampleId, disableDnD: disableDnD, visibleOnAllPaths: visibleOnAllPaths, originPathId: originPathId, color: color = (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray, ...event })=>{
    const ownScale = (0, $a66eb252e0fd4b58$export$dbf01c52ad4aabb3)(currentTransform.k);
    const matchProjectPath = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_WILDCARD);
    const selectedElementPath = {
        projectId: projectId,
        sampleId: sampleId,
        event: event,
        originPathId: originPathId,
        visibleOnAllPaths: visibleOnAllPaths
    };
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { setSelectedEntity: setSelectedEntity, selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const [eventIsSelected, setEventIsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleOnEventClick = ()=>{
        setSideDrawboardOpen(true);
        setSelectedEntity({
            selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT,
            selectedElementPath: selectedElementPath
        });
        if (matchProjectPath) (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${projectId}/timeline/samples/${sampleId}/events/${event.id}`);
    };
    (0, $acw62.useEffect)(()=>{
        const isSelected = selectedEntity ? selectedEntity?.selectedElementPath.event?.id === selectedElementPath.event?.id : false;
        setEventIsSelected(isSelected);
    }, [
        selectedEntity
    ]);
    const eventName = event.name && event.name.length > 15 ? `${event.name.slice(0, 15).trim()}\u{2026}` : event.name;
    const width = 20;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3598a50f749fb55$var$EventWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3598a50f749fb55$var$TooltipAngled, {
        x: x + 15 * ownScale,
        y: y,
        ownScale: ownScale,
        transform: `rotate(-40 ${x + 10 * ownScale} ${y - 5 * ownScale})`
    }, eventName), eventIsSelected && !disableDnD ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $baa8e8bad15b7b23$export$2e2bcd8739ae039), {
        color: color,
        secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.extra.selectedBlock,
        x: x,
        y: y,
        width: width,
        height: 20,
        onClick: handleOnEventClick,
        className: "EventDragElement",
        id: event.id,
        zoom: currentTransform.k
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17988a9d596bcc6e$export$b8cabaaa78031cf8), {
        color: color,
        x: x,
        y: y,
        width: width,
        height: 20,
        onClick: handleOnEventClick,
        className: "EventDragElement",
        id: event.id,
        zoom: currentTransform.k
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $936ee5739574b592$export$2e2bcd8739ae039), {
        name: event.name,
        x: x + 15 * ownScale,
        y: y - 120 * ownScale,
        ownScale: ownScale,
        width: 220 * ownScale,
        disableDnD: disableDnD,
        hideTooltip: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84fd979863cecccd$export$fb9f56d10d46869f), {
        text: event.description,
        maxChars: 29,
        scale: ownScale,
        maxLines: 3
    }))));
};
const $d3598a50f749fb55$var$EventWrapper = (0, $lmFrL.default).g`
  .tooltip {
    visibility: hidden;
  }

  :hover {
    .tooltip {
      visibility: visible;
    }
  }
`;
$d3598a50f749fb55$export$8d048a4093f4779e.defaultProps = {
    ownScale: 1,
    width: 220,
    height: 100
};
const $d3598a50f749fb55$var$TooltipAngled = (0, $lmFrL.default).text`
  font-size: ${({ ownScale: ownScale = 1 })=>ownScale * 20}px;
`;







const $cc4416d5e1582097$export$cf5b13249fe61a4d = (servicesArray, changedServiceArray)=>{
    return servicesArray.map((service)=>{
        const matchingService = changedServiceArray.find((s)=>s.id === service.id);
        if (matchingService) return {
            ...service,
            ...matchingService
        };
        return service;
    }).sort((a, b)=>a.startDate > b.startDate ? 1 : -1);
};








var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $5777cc8d6c10ab5b$export$10e6f4f66014ee2d = (props)=>{
    const { text: text, onClick: onClick, ownScale: ownScale = 1, readonly: readonly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("foreignObject", {
        width: ownScale * 20,
        height: ownScale * 100
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5777cc8d6c10ab5b$var$Text, {
        readonly: readonly,
        spellCheck: false,
        onClick: onClick,
        ownScale: ownScale
    }, text));
};
const $5777cc8d6c10ab5b$var$Text = (0, $lmFrL.default).div`
  border: none;
  border-radius: ${({ ownScale: ownScale = 1 })=>ownScale * 4}px;
  font-size: ${({ ownScale: ownScale = 1 })=>ownScale * 13}px;
  width: ${({ ownScale: ownScale = 1 })=>ownScale * 20}px;
  height: ${({ ownScale: ownScale = 1 })=>ownScale * 100}px;
  writing-mode: vertical-rl;
  transform: scale(-1);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ readonly: readonly = false })=>readonly ? "default" : "pointer"};
  transition: 200ms;

  &:hover {
    font-weight: bold;
    transition: 200ms;
  }
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");






const $3cb9a5671ba52d6c$export$b6f541c8c0d9ae7d = (props)=>{
    const { isOpen: isOpen, onClose: onClose, projectId: projectId, sampleId: sampleId, pathLineNameToChange: pathLineNameToChange } = props;
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(pathLineNameToChange.name);
    const onChange = (event)=>{
        setFieldValue(event.target.value);
    };
    const [updateSampleTimelineLine] = (0, $7608a8bbcbbad14c$export$7d4276896448a227)();
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const onAcceptModal = ()=>{
        if (fieldValue === pathLineNameToChange.name) {
            onClose();
            return;
        }
        setIsLoading(true);
        const options = {
            variables: {
                projectId: projectId,
                sampleId: sampleId,
                line: pathLineNameToChange.baseline,
                name: fieldValue.trim()
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateSampleTimelineLine"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesCopy = [
                        ...existingQueryResult.samples
                    ];
                    const sampleToUpdate = samplesCopy.find((sampleCopy)=>sampleCopy.id === sampleId);
                    if (sampleToUpdate) {
                        const updatedSamples = samplesCopy.map((sampleCopy)=>sampleCopy.id === sampleId ? incomingData : sampleCopy);
                        cache.writeQuery({
                            variables: {
                                id: projectId
                            },
                            query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                            data: {
                                Project: {
                                    ...existingQueryResult,
                                    samples: updatedSamples
                                }
                            }
                        });
                    }
                }
            }
        };
        updateSampleTimelineLine(options).then(()=>{
            setIsLoading(false);
            onClose();
        }).catch((error)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error);
        });
    };
    const ModalButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3cb9a5671ba52d6c$var$AcceptButton, {
            disabled: isLoading,
            label: "Save Path Line Name",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3cb9a5671ba52d6c$var$StyledModal, {
        id: "changePathLineNameModal",
        title: "Change Path Line Name",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e23cddd5b45db21f$export$10e6f4f66014ee2d), {
        value: fieldValue,
        onChange: onChange,
        placeholder: "Enter Path Line Name"
    }));
};
const $3cb9a5671ba52d6c$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $3cb9a5671ba52d6c$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;


const $ff8a3318298de872$var$zoomThreshold = 0.9;
const $ff8a3318298de872$var$svgId = "timeline-svg";
const $ff8a3318298de872$var$year = 31536000000; // 1 year
let $ff8a3318298de872$var$dates = null;
let $ff8a3318298de872$var$sampleId = null;
let $ff8a3318298de872$var$canvasStartDate = 0;
let $ff8a3318298de872$var$canvasEndDate = 0;
function $ff8a3318298de872$var$getColorFromIndex(index) {
    const colorIndex = index % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
    const color = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[colorIndex];
    return color.color;
}
const $ff8a3318298de872$export$e6a97ba2cae5bb94 = (props)=>{
    const { sample: sample, projectId: projectId, hideAddIcon: hideAddIcon = false, disableDnD: disableDnD = false } = props;
    const zoomedFunction = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity, elementOnDragAction: elementOnDragAction, setDroppedElementCoordinates: setDroppedElementCoordinates } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const workflows = (0, $f1q41.get)(sample, "enabledWorkflows", []);
    let services = [];
    workflows.forEach((workflow, workflowIndex)=>{
        const servicesToAdd = workflow.services.map((service)=>{
            const serviceExtended = {
                ...service
            };
            serviceExtended.workflowId = workflow.id;
            serviceExtended.workflowName = workflow.name;
            serviceExtended.colorIndex = workflowIndex % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
            serviceExtended.color = $ff8a3318298de872$var$getColorFromIndex(workflowIndex);
            return serviceExtended;
        });
        services = services.concat(servicesToAdd);
    });
    services.sort((serviceA, serviceB)=>{
        const serviceALength = serviceA.endDate - serviceA.startDate;
        const serviceBLength = serviceB.endDate - serviceB.startDate;
        return serviceALength - serviceBLength;
    });
    services.reverse();
    const events = (0, $f1q41.get)(sample, "events", []);
    if (!$ff8a3318298de872$var$dates || sample && $ff8a3318298de872$var$sampleId !== sample.id) {
        // run this calculation only once or after changing the sample
        $ff8a3318298de872$var$dates = (0, $f1q41.flatMap)(services, (s)=>[
                parseFloat(s.startDate),
                parseFloat(s.endDate)
            ]);
        const eventsDates = (0, $f1q41.flatMap)(events, (e)=>[
                parseFloat(e.startDate),
                parseFloat(e.endDate)
            ]);
        $ff8a3318298de872$var$dates = $ff8a3318298de872$var$dates.concat(eventsDates);
        const canvasMin = $02ed355deaa9e190$export$2e2bcd8739ae039($ff8a3318298de872$var$dates);
        const canvasMax = $5a964dca3df4eea7$export$2e2bcd8739ae039($ff8a3318298de872$var$dates);
        const canvasDiff = canvasMax - canvasMin;
        $ff8a3318298de872$var$canvasStartDate = canvasMin - canvasDiff * 0.1;
        $ff8a3318298de872$var$canvasEndDate = canvasMax + canvasDiff * 0.1;
        $ff8a3318298de872$var$sampleId = sample.id;
    }
    const { ref: ref, dimensions: { width: width, height: height } } = (0, (/*@__PURE__*/$parcel$interopDefault($012ab268fa9077b1$exports)))({});
    const wrapperSVGRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const axisWrapperGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const timelineElementsGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const todayGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const svgMinimapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { setSideDrawboardOpen: setSideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const [axisWidth, setAxisWidth] = (0, $acw62.useState)(width);
    const [pathLineNameToChange, setPathLineNameToChange] = (0, $acw62.useState)(null);
    const [isChangePathLineNameModalOpen, setIsChangePathLineNameModalOpen] = (0, $acw62.useState)(false);
    const [dropPlace, setDropPlace] = (0, $acw62.useState)(null);
    const [selectedElementD3Data, setSelectedElementD3Data] = (0, $acw62.useState)({
        isDragged: false,
        mousePosition: null,
        mouseYDragStartPos: null,
        previousBaseline: null
    });
    (0, $acw62.useEffect)(()=>{
        if (width !== undefined) setAxisWidth(width + 300);
    }, [
        width
    ]);
    function showBaselines() {
        $e5dfdc386da08eff$export$2e2bcd8739ae039(".baselines").style("visibility", "visible");
    }
    function hideBaselines() {
        $e5dfdc386da08eff$export$2e2bcd8739ae039(".baselines").style("visibility", "hidden");
    }
    function changeBaselineStroke() {
        $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("stroke", "#c0c0c0");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function clearBaselines(baselinesToClear) {
        baselinesToClear.each(changeBaselineStroke);
    }
    const baselines = $e5dfdc386da08eff$export$2e2bcd8739ae039(".baselines");
    (0, $acw62.useEffect)(()=>{
        if (elementOnDragAction) {
            showBaselines();
            return;
        }
        hideBaselines();
        setDropPlace(null);
        clearBaselines(baselines);
    }, [
        elementOnDragAction
    ]);
    const matchWorkflowPath = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_WORKFLOW);
    const [zoomLevel, setTimelineZoomLevel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(matchWorkflowPath ? (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).HIGHER : (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT);
    const axisDomain = [
        new Date($ff8a3318298de872$var$canvasStartDate),
        new Date($ff8a3318298de872$var$canvasEndDate)
    ];
    const x = $304372357472b2a4$export$2e2bcd8739ae039().domain(axisDomain).range([
        0,
        axisWidth
    ]);
    const [currentTransform, setCurrentTransform] = (0, $acw62.useState)($a3c1094a2e8782d7$export$f0954fd7d5368655.translate(0, 0).scale(1));
    const baselineY = window.innerHeight / 2;
    const baselineHeightBaseValue = 150;
    const baselineHeight = baselineHeightBaseValue * (0, $a66eb252e0fd4b58$export$dbf01c52ad4aabb3)(currentTransform.k);
    const workflowsBaselineHeight = 200;
    //= =============================================================
    // MINIMAP prep
    // minimap inspired by https://observablehq.com/@rabelais/d3-js-zoom-minimap
    //= =============================================================
    const _config = {
        margin: 20,
        // TODO this should be devised based on the project extent and its visible width on the screen
        _width: width,
        _height: height,
        viewWidth: 240,
        controlsHeight: 50
    };
    const config = {
        ..._config,
        clippedWidth: _config._width - _config.margin * 2,
        clippedHeight: _config._height - _config.margin * 2,
        minimapScale: _config.viewWidth / _config._width,
        viewHeight: Math.min(500, Math.max(100, _config._height * (_config.viewWidth / _config._width)))
    };
    const minimapScaleX = (zoomScale)=>// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        $db1dd3c66a0cbf94$export$2e2bcd8739ae039([
            0,
            config._width
        ], [
            0,
            config._width * zoomScale
        ]);
    const minimapScaleY = (zoomScale)=>// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        $db1dd3c66a0cbf94$export$2e2bcd8739ae039([
            0,
            config._height
        ], [
            0,
            config._height * zoomScale
        ]);
    //= =============================================================
    let firstGhostEventStartDate;
    if (props.ghostTimelineElements && props.ghostTimelineElements.ghostEvents && props.ghostTimelineElements.ghostEvents.length > 0) props.ghostTimelineElements.ghostEvents.forEach((pathEvents)=>{
        pathEvents.events.forEach((pathEvent)=>{
            const startDateInt = parseInt(pathEvent.startDate, 10);
            if (!firstGhostEventStartDate) firstGhostEventStartDate = startDateInt;
            if (startDateInt < firstGhostEventStartDate) firstGhostEventStartDate = startDateInt;
        });
    });
    const draw = ()=>{
        const axisWrapperElement = $cf81072cf307ee25$export$2e2bcd8739ae039(axisWrapperGroupRef.current);
        const todayLine = $cf81072cf307ee25$export$2e2bcd8739ae039(todayGroupRef.current);
        axisWrapperElement.selectAll("*").remove();
        const timelineElementsGroup = $cf81072cf307ee25$export$2e2bcd8739ae039(timelineElementsGroupRef.current);
        // .attr("cursor", "grab");
        // axis background
        axisWrapperElement.append("rect").attr("x", 0).attr("y", 0).attr("width", axisWidth).attr("height", (0, $a66eb252e0fd4b58$export$305eb744eb40f4ef)).style("fill", "#ffffff");
        const mAxis = (0, $a66eb252e0fd4b58$export$38bedd7e3ec11e7a)(x);
        const monthsAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-month-axis").attr("transform", "translate(0,75)").call(mAxis);
        (0, $a66eb252e0fd4b58$export$b1ffadcc6dff5329)(monthsAxisHandler);
        const wAxis = (0, $a66eb252e0fd4b58$export$4a1b7570b49e9119)(x);
        const weekAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-week-axis").attr("transform", "translate(0,94)").call(wAxis);
        (0, $a66eb252e0fd4b58$export$fb6939bf153c51df)(weekAxisHandler);
        const dAxis = (0, $a66eb252e0fd4b58$export$c9de31ea9c0906a)(x);
        const dayAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-day-axis").attr("transform", "translate(0,103)").call(dAxis);
        (0, $a66eb252e0fd4b58$export$b1ead7427989bd7f)(dayAxisHandler);
        const qAxis = (0, $a66eb252e0fd4b58$export$24ff02d6d80a759c)(x);
        const quarterAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-quarter-axis").attr("transform", `translate(0,${(0, $a66eb252e0fd4b58$export$305eb744eb40f4ef)})`).call(qAxis);
        (0, $a66eb252e0fd4b58$export$359112c5b5d36ed9)(quarterAxisHandler);
        const yAxis = (0, $a66eb252e0fd4b58$export$a6a9f78e87f19008)(x);
        const yearAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-year-axis").attr("transform", `translate(0,${(0, $a66eb252e0fd4b58$export$305eb744eb40f4ef)})`).call(yAxis);
        (0, $a66eb252e0fd4b58$export$56ef164c7e0d119b)(yearAxisHandler);
        let projectStartWeekAxisHandler;
        if (firstGhostEventStartDate) {
            const projectStartWeekAxis = (0, $a66eb252e0fd4b58$export$9ee892d8c45d4bbd)(x, firstGhostEventStartDate);
            projectStartWeekAxisHandler = axisWrapperElement.append("g").attr("class", "timeline-week-axis").attr("transform", "translate(0,115)").call(projectStartWeekAxis);
            (0, $a66eb252e0fd4b58$export$fb6939bf153c51df)(projectStartWeekAxisHandler);
        }
        const updateXAxis = (transform)=>{
            const updatedX = transform.rescaleX(x);
            const updatedMAxis = (0, $a66eb252e0fd4b58$export$38bedd7e3ec11e7a)(updatedX);
            const updatedMonthsAxisHandler = monthsAxisHandler.call(updatedMAxis);
            (0, $a66eb252e0fd4b58$export$b1ffadcc6dff5329)(updatedMonthsAxisHandler);
            const updatedQAxis = (0, $a66eb252e0fd4b58$export$24ff02d6d80a759c)(updatedX);
            const updatedQuarterAxisHandler = quarterAxisHandler.call(updatedQAxis);
            (0, $a66eb252e0fd4b58$export$359112c5b5d36ed9)(updatedQuarterAxisHandler);
            const updatedYAxis = (0, $a66eb252e0fd4b58$export$a6a9f78e87f19008)(updatedX);
            const updatedYearAxisHandler = yearAxisHandler.call(updatedYAxis);
            (0, $a66eb252e0fd4b58$export$56ef164c7e0d119b)(updatedYearAxisHandler);
            const updatedWAxis = (0, $a66eb252e0fd4b58$export$4a1b7570b49e9119)(updatedX);
            weekAxisHandler.call(updatedWAxis);
            (0, $a66eb252e0fd4b58$export$fb6939bf153c51df)(weekAxisHandler);
            const updatedDAxis = (0, $a66eb252e0fd4b58$export$c9de31ea9c0906a)(updatedX);
            dayAxisHandler.call(updatedDAxis);
            (0, $a66eb252e0fd4b58$export$b1ead7427989bd7f)(dayAxisHandler);
            if (firstGhostEventStartDate) {
                const updatedProjectStartWAxis = (0, $a66eb252e0fd4b58$export$9ee892d8c45d4bbd)(updatedX, firstGhostEventStartDate);
                projectStartWeekAxisHandler.call(updatedProjectStartWAxis);
                (0, $a66eb252e0fd4b58$export$fb6939bf153c51df)(projectStartWeekAxisHandler);
            }
        };
        const timelineWidth = $ff8a3318298de872$var$canvasEndDate - $ff8a3318298de872$var$canvasStartDate;
        const scaleNominator = 100000000 * width / timelineWidth;
        const setDayAxisVisibility = (transform)=>{
            const scale = scaleNominator * transform.k;
            if (scale < (0, $a66eb252e0fd4b58$export$b71e687216915f11) && !dayAxisHandler.classed("timeline-day-axis-hide")) dayAxisHandler.classed("timeline-day-axis-hide", true);
            if (scale >= (0, $a66eb252e0fd4b58$export$b71e687216915f11) && dayAxisHandler.classed("timeline-day-axis-hide")) dayAxisHandler.classed("timeline-day-axis-hide", false);
        };
        const setWeekAxisVisibility = (transform)=>{
            const scale = scaleNominator * transform.k;
            if (scale < (0, $a66eb252e0fd4b58$export$410ebd54025ac67c) && !weekAxisHandler.classed("timeline-week-axis-hide")) {
                weekAxisHandler.classed("timeline-week-axis-hide", true);
                if (firstGhostEventStartDate) projectStartWeekAxisHandler.classed("timeline-week-axis-hide", true);
            }
            if (scale >= (0, $a66eb252e0fd4b58$export$410ebd54025ac67c) && weekAxisHandler.classed("timeline-week-axis-hide")) {
                weekAxisHandler.classed("timeline-week-axis-hide", false);
                if (firstGhostEventStartDate) projectStartWeekAxisHandler.classed("timeline-week-axis-hide", false);
            }
        };
        const setMonthAxisVisibility = (transform)=>{
            const scale = scaleNominator * transform.k;
            if (scale < (0, $a66eb252e0fd4b58$export$769390b9ad120c2d) && !monthsAxisHandler.classed("timeline-month-axis-hide")) monthsAxisHandler.classed("timeline-month-axis-hide", true);
            if (scale >= (0, $a66eb252e0fd4b58$export$769390b9ad120c2d) && monthsAxisHandler.classed("timeline-month-axis-hide")) monthsAxisHandler.classed("timeline-month-axis-hide", false);
        };
        const switchQuarterAxisToYearAxis = (transform)=>{
            const scale = scaleNominator * transform.k;
            if (scale < (0, $a66eb252e0fd4b58$export$e357d9dab1f6dd73)) {
                if (!quarterAxisHandler.classed("timeline-quarter-axis-hide")) quarterAxisHandler.classed("timeline-quarter-axis-hide", true);
                if (yearAxisHandler.classed("timeline-year-axis-hide")) yearAxisHandler.classed("timeline-year-axis-hide", false);
            }
            if (scale >= (0, $a66eb252e0fd4b58$export$e357d9dab1f6dd73)) {
                if (quarterAxisHandler.classed("timeline-quarter-axis-hide")) quarterAxisHandler.classed("timeline-quarter-axis-hide", false);
                if (!yearAxisHandler.classed("timeline-year-axis-hide")) yearAxisHandler.classed("timeline-year-axis-hide", true);
            }
        };
        const zoomed = (transform)=>{
            timelineElementsGroup.attr("transform", transform);
            setDayAxisVisibility(transform);
            setWeekAxisVisibility(transform);
            setMonthAxisVisibility(transform);
            switchQuarterAxisToYearAxis(transform);
            updateXAxis(transform);
            todayLine.attr("transform", transform);
            setCurrentTransform(transform);
        };
        let transformData;
        const updateMinimap = (transform)=>{
            const scaleX = minimapScaleX(transform.k);
            const scaleY = minimapScaleY(transform.k);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            brush.move(gBrush, [
                [
                    scaleX.invert(-transform.x),
                    scaleY.invert(-transform.y)
                ],
                [
                    scaleX.invert(-transform.x + config._width),
                    scaleY.invert(-transform.y + config._height)
                ]
            ]);
        };
        // eslint-disable-next-line consistent-return
        function onZoom(transform) {
            if (transform.k < $ff8a3318298de872$var$zoomThreshold) setTimelineZoomLevel((0, $a66eb252e0fd4b58$export$8b7222fa92892b49).HIGHER);
            else setTimelineZoomLevel((0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT);
            updateMinimap(transform);
            zoomed(transform);
        }
        const onZoomThrottled = (0, $f1q41.throttle)(onZoom, 100, {
            leading: true,
            trailing: true
        });
        function getMaxWorldHeightMargin(transformK) {
            return window.innerHeight * transformK - config.viewHeight;
        }
        function checkIfUserViewIsOutside(transformK, transformY, maxHeight) {
            const isOutside = transformK >= $ff8a3318298de872$var$zoomThreshold && transformY < -maxHeight;
            return isOutside;
        }
        function onZoomThrottledCall() {
            const oldK = transformData && transformData.k;
            transformData = $dd1fb49221ad966f$export$6cd530ed55e06764.transform;
            const maxWorldHeightMargin = getMaxWorldHeightMargin(transformData.k);
            const isUserViewOutside = checkIfUserViewIsOutside(transformData.k, transformData.y, maxWorldHeightMargin);
            if (isUserViewOutside) transformData.y = -maxWorldHeightMargin;
            setCurrentTransform(transformData);
            if (oldK !== transformData.k) onZoomThrottled(transformData);
            else onZoom(transformData);
            return null;
        }
        const worldWidth = x($ff8a3318298de872$var$canvasEndDate);
        let worldHeight = window.innerHeight;
        if (zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).HIGHER) {
            const lastIndexOfWorkflowsArray = workflows.length - 1;
            const positionOfLastWorkflow = lastIndexOfWorkflowsArray * workflowsBaselineHeight;
            worldHeight = positionOfLastWorkflow;
        }
        const translatedExtent = [
            [
                x((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($ff8a3318298de872$var$canvasStartDate)),
                0
            ],
            [
                worldWidth,
                worldHeight
            ]
        ];
        const zoom = $91e02783b8b1c24a$export$2e2bcd8739ae039().scaleExtent([
            0.65,
            50
        ]) // smaller front, larger latter
        .translateExtent(translatedExtent).extent([
            [
                0,
                0
            ],
            [
                config.viewWidth,
                config.viewHeight
            ]
        ]) // viewport extent
        .on("zoom", onZoomThrottledCall).filter(()=>{
            // return true/false in filter means that action can (or not) be triggered on zoom event
            const isDoubleClick = $dd1fb49221ad966f$export$6cd530ed55e06764.type === "dblclick";
            if (!isDoubleClick) return true;
            const targetElement = $dd1fb49221ad966f$export$6cd530ed55e06764.target;
            const isClickedOnTimeline = targetElement.parentNode.id === "timeline" || targetElement.id === "timeline-svg" || targetElement.parentNode.id === "today";
            if (isClickedOnTimeline) return true;
            return false;
        });
        // eslint-disable-next-line consistent-return
        function onBrush() {
            // prevent zoom invoked event
            // if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") {
            //   return null;
            // }
            if (Array.isArray($dd1fb49221ad966f$export$6cd530ed55e06764.selection)) {
                const [[brushX, brushY]] = $dd1fb49221ad966f$export$6cd530ed55e06764.selection;
                const zoomScale = $a3c1094a2e8782d7$export$2e2bcd8739ae039(axisWrapperElement.node()).k;
                const scaleX = minimapScaleX(zoomScale);
                const scaleY = minimapScaleY(zoomScale);
                const newTransform = $a3c1094a2e8782d7$export$f0954fd7d5368655.translate(-scaleX(brushX), -scaleY(brushY)).scale(zoomScale);
                const isItEndOfMovingMinimap = $dd1fb49221ad966f$export$6cd530ed55e06764.sourceEvent && $dd1fb49221ad966f$export$6cd530ed55e06764.type === "end" && $dd1fb49221ad966f$export$6cd530ed55e06764.sourceEvent.type === "mouseup";
                const maxWorldHeightMargin = getMaxWorldHeightMargin(newTransform.k);
                const isUserViewOutside = checkIfUserViewIsOutside(newTransform.k, newTransform.y, maxWorldHeightMargin);
                if (isUserViewOutside) transformData.y = -maxWorldHeightMargin;
                if (isItEndOfMovingMinimap) $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call(zoom.transform, newTransform);
                setCurrentTransform(newTransform);
                zoomed(newTransform);
            }
        }
        const svgMinimap = $cf81072cf307ee25$export$2e2bcd8739ae039(svgMinimapRef.current);
        svgMinimap.select("#gBrush").remove();
        const gBrush = svgMinimap.append("g").attr("id", "gBrush");
        const brush = $5c8970f4694d4107$export$2e2bcd8739ae039().extent([
            [
                0,
                0
            ],
            [
                config._width,
                config._height
            ]
        ]).on("brush end", onBrush);
        $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call(zoom);
        gBrush.call(brush);
        updateMinimap(currentTransform);
        updateXAxis(currentTransform);
        zoomedFunction.current = onZoom;
    };
    const drawLines = ()=>{
        const lines = [];
        const firstWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($ff8a3318298de872$var$canvasStartDate).startOf("isoWeek");
        const firstWeekTimestamp = firstWeek.valueOf();
        const lastWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($ff8a3318298de872$var$canvasEndDate).endOf("isoWeek");
        const numberOfWeeks = lastWeek.diff(firstWeek, "week");
        const numberOfWeeksToDraw = numberOfWeeks + 100;
        const aWeek = 604800000;
        const x1 = -x(firstWeekTimestamp) + 0.1;
        lines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            id: "wL",
            key: `line-${0}`,
            x1: x(firstWeekTimestamp),
            x2: x(firstWeekTimestamp),
            y1: 0,
            y2: 2000,
            stroke: "#c0c0c0",
            strokeWidth: "1",
            strokeDasharray: "1, 12"
        }));
        for(let week = 1; week < numberOfWeeksToDraw; week += 1)lines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("use", {
            key: `line-${week}`,
            href: "#wL",
            x: x1 + x(firstWeekTimestamp + aWeek * week)
        }));
        return lines;
    };
    function getYValueForBaseline(baseline) {
        const halfBlockHeight = (0, $a66eb252e0fd4b58$export$f9045ef5b76f55d6)(currentTransform.k) / 2;
        return baselineY + halfBlockHeight - baselineHeight * baseline;
    }
    const drawBaselineLines = ()=>{
        const lines = [];
        const firstWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($ff8a3318298de872$var$canvasStartDate).startOf("week");
        const firstWeekTimestamp = firstWeek.valueOf();
        const lastWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($ff8a3318298de872$var$canvasEndDate).endOf("week");
        const lastWeekTimestamp = lastWeek.valueOf() + $ff8a3318298de872$var$year;
        const numberOfBaselinesToDraw = 50;
        const strokeWidth = currentTransform.k < 5 ? "2" : "0.5";
        for(let baseline = -20; baseline < numberOfBaselinesToDraw; baseline += 1)lines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            className: "baselines",
            "data-baseline": baseline,
            style: {
                visibility: "hidden",
                cursor: "row-resize"
            },
            id: "baselineL",
            key: `baseline${baseline}`,
            x1: x(firstWeekTimestamp),
            x2: x(lastWeekTimestamp),
            y1: getYValueForBaseline(baseline),
            y2: getYValueForBaseline(baseline),
            stroke: "#c0c0c0",
            strokeWidth: strokeWidth
        }));
        return lines;
    };
    const drawChangeLineNamingDots = (readonly = false)=>{
        const dots = [];
        const numberOfDotsToDraw = 100;
        const ownScale = (0, $a66eb252e0fd4b58$export$dbf01c52ad4aabb3)(currentTransform.k) * 2;
        const xPosition = -currentTransform.x / currentTransform.k + 20 * ownScale;
        const totalHeight = 108 * ownScale;
        const theMiddleOfLine = totalHeight / 4 - (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, currentTransform.k) / 2;
        for(let baseline = -100; baseline < numberOfDotsToDraw; baseline += 1){
            const foundTimelineLine = sample.timelineLines?.find((timelineLine)=>timelineLine.line === baseline);
            const yPosition = baselineY - baseline * baselineHeight + theMiddleOfLine;
            if (foundTimelineLine) dots.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
                key: baseline,
                x: xPosition,
                y: yPosition - ownScale * 40,
                style: {
                    cursor: "pointer"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5777cc8d6c10ab5b$export$10e6f4f66014ee2d), {
                text: foundTimelineLine.name,
                onClick: ()=>{
                    if (readonly) return;
                    setPathLineNameToChange({
                        baseline: baseline,
                        name: foundTimelineLine.name
                    });
                    setIsChangePathLineNameModalOpen(true);
                },
                ownScale: ownScale,
                readonly: readonly
            })));
            else if (!readonly) dots.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0ac02571a3ef321$export$277089a45d8e9a3b), {
                onClick: ()=>{
                    setPathLineNameToChange({
                        baseline: baseline,
                        name: ""
                    });
                    setIsChangePathLineNameModalOpen(true);
                },
                style: {
                    cursor: "pointer"
                },
                key: baseline,
                x: xPosition,
                y: yPosition + ownScale * 8,
                width: 22,
                height: 6,
                ownScale: ownScale
            }));
        }
        return dots;
    };
    const handleOnAddIconCLick = ()=>{
        setSelectedEntity(undefined);
        setSideDrawboardOpen(true);
    };
    const [updateServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$981396349d3957c6)();
    const userRoleInSample = sample?.users?.find((u)=>u?.id === user.sub)?.role;
    const editServiceInformationsIsEnabled = useUserPermissions("editServiceInformations", userRoleInSample);
    const addItemsToTimelineIsEnabled = useUserPermissions("addItemsToTimeline", userRoleInSample);
    const disableDnDToUse = !editServiceInformationsIsEnabled || !addItemsToTimelineIsEnabled || disableDnD;
    const hideAddIconToUse = !editServiceInformationsIsEnabled || !addItemsToTimelineIsEnabled || hideAddIcon;
    async function updateService(serviceUpdatables) {
        if (!editServiceInformationsIsEnabled) return;
        const { projectId: selectedProjectId, sampleId: selectedSampleId, workflowId: selectedWorkflowId, service: { id: selectedServiceId }, service: service } = selectedEntity.selectedElementPath;
        if (serviceUpdatables.endDate && !serviceUpdatables.startDate) {
            const startDate = parseInt(service.startDate, 10);
            const newEndDate = parseInt(serviceUpdatables.endDate, 10);
            if (newEndDate < startDate) {
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You cannot set the end date earlier than the start date");
                return;
            }
        }
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: selectedProjectId,
                    sampleId: selectedSampleId
                },
                workflowInput: {
                    workflowId: selectedWorkflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceUpdatables: {
                    id: selectedServiceId,
                    ...serviceUpdatables
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateServiceFromWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === $ff8a3318298de872$var$sampleId);
                    const updatedEnabledWorkflows = sampleHere.enabledWorkflows.map((workflow)=>({
                            ...workflow,
                            services: (0, $cc4416d5e1582097$export$cf5b13249fe61a4d)(workflow.services, incomingData)
                        }));
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === $ff8a3318298de872$var$sampleId) return {
                            ...sampleLoop,
                            enabledWorkflows: updatedEnabledWorkflows
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                }
            }
        };
        const selectedEntityNewObj = {
            ...selectedEntity,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                service: {
                    ...selectedEntity.selectedElementPath.service,
                    ...serviceUpdatables
                }
            }
        };
        setSelectedEntity(selectedEntityNewObj);
        await updateServiceFromWorkflow(options);
    }
    const [updateEventFromSample] = (0, $7608a8bbcbbad14c$export$8af6b8f568ed5160)();
    async function updateEvent(eventUpdatables) {
        const { projectId: selectedProjectId, sampleId: selectedSampleId, event: { id: selectedEventId } } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleEventInput: {
                    projectId: selectedProjectId,
                    sampleId: selectedSampleId,
                    eventId: selectedEventId
                },
                eventUpdatables: {
                    ...eventUpdatables
                }
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateEventFromSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: selectedProjectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === selectedSampleId);
                    const updatedEvents = sampleHere?.events.map((event)=>{
                        if (event.id === selectedEventId) return incomingData;
                        return event;
                    });
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === selectedSampleId) return {
                            ...sampleLoop,
                            events: updatedEvents
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: selectedProjectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                }
            }
        };
        const selectedEntityNewObj = {
            ...selectedEntity,
            ...eventUpdatables
        };
        setSelectedEntity(selectedEntityNewObj);
        await updateEventFromSample(options);
    }
    function getBaselineFromYPos(yPos) {
        let closestDistance = 10000000000;
        let selectedBaseline = null;
        for(let baseline = -20; baseline < 20; baseline += 1){
            const currentBaselineY = getYValueForBaseline(baseline);
            const distanceFromThisBaseline = Math.abs(currentBaselineY - yPos);
            if (distanceFromThisBaseline < closestDistance) {
                closestDistance = distanceFromThisBaseline;
                selectedBaseline = baseline;
            }
        }
        return selectedBaseline;
    }
    const wrapperSvg = $cf81072cf307ee25$export$2e2bcd8739ae039(timelineElementsGroupRef.current);
    function wrapperSvgMouseMove() {
        if (!elementOnDragAction) return;
        const xDate = x.invert($dbcffd59364661d7$export$2e2bcd8739ae039(this)[0]);
        const closestBaseline = getBaselineFromYPos($dbcffd59364661d7$export$2e2bcd8739ae039(this)[1]);
        // eslint-disable-next-line func-names
        baselines.each(function() {
            const baseline = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("stroke", "#c0c0c0");
            const baselineDataId = baseline.attr("data-baseline");
            if (baselineDataId === closestBaseline.toString()) baseline.attr("stroke", "#3B79D1");
        });
        setDropPlace({
            date: xDate,
            baseline: closestBaseline,
            yPosition: $dbcffd59364661d7$export$2e2bcd8739ae039(this)[1] * currentTransform.k + currentTransform.y
        });
        setDroppedElementCoordinates({
            date: xDate,
            baseline: closestBaseline
        });
    }
    function wrapperSvgMouseLeave() {
        if (!elementOnDragAction) return;
        if (dropPlace) {
            setDropPlace(null);
            clearBaselines(baselines);
        }
    }
    wrapperSvg.on("mousemove", wrapperSvgMouseMove);
    wrapperSvg.on("mouseleave", wrapperSvgMouseLeave);
    let dragStartDateValue = null;
    let blockStartDateBeforeDragging = null;
    let blockEndDateBeforeDragging = null;
    function blockDragStart() {
        const blockId = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("id");
        const blockClassName = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("class");
        const serviceBlockDragged = selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath);
        const wrongBlockDragged = selectedEntity && serviceBlockDragged && blockId !== selectedEntity.selectedElementPath.service.id && blockClassName !== "leftDragElement" && blockClassName !== "rightDragElement";
        const isNotGhostBlock = selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.sampleId === selectedEntity.selectedElementPath.originPathId;
        const canMove = selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending;
        if (selectedEntity && serviceBlockDragged && !wrongBlockDragged && isNotGhostBlock && canMove) {
            showBaselines();
            $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "row-resize");
            const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
            const draggedToDate2 = x.invert(mousePosition);
            dragStartDateValue = draggedToDate2.valueOf();
            blockStartDateBeforeDragging = parseInt(selectedEntity.selectedElementPath.service.startDate, 10);
            blockEndDateBeforeDragging = parseInt(selectedEntity.selectedElementPath.service.endDate, 10);
            const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
            const closestBaseline = getBaselineFromYPos(mouseYpos);
            setSelectedElementD3Data((prev)=>{
                const newData = {
                    ...prev
                };
                newData.isDragged = true;
                newData.mousePosition = mouseYpos;
                newData.mouseYDragStartPos = mouseYpos;
                newData.previousBaseline = closestBaseline;
                return newData;
            });
        }
    }
    function eventDragStart() {
        const eventId = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("id");
        const eventBlockDragged = selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT;
        const wrongBlockDragged = selectedEntity && eventBlockDragged && eventId !== selectedEntity.selectedElementPath.event.id;
        const isNotGhostBlock = selectedEntity && (0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.sampleId === selectedEntity.selectedElementPath.originPathId;
        if (selectedEntity && eventBlockDragged && !wrongBlockDragged && isNotGhostBlock) {
            showBaselines();
            $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "row-resize");
            const mousePosition = $dd1fb49221ad966f$export$6cd530ed55e06764.x;
            const draggedToDate2 = x.invert(mousePosition);
            dragStartDateValue = draggedToDate2.valueOf();
            blockStartDateBeforeDragging = parseInt(selectedEntity.selectedElementPath.event.startDate, 10);
            blockEndDateBeforeDragging = parseInt(selectedEntity.selectedElementPath.event.endDate, 10);
            const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
            const closestBaseline = getBaselineFromYPos(mouseYpos);
            setSelectedElementD3Data((prev)=>{
                const newData = {
                    ...prev
                };
                newData.isDragged = true;
                newData.mousePosition = mouseYpos;
                newData.mouseYDragStartPos = mouseYpos;
                newData.previousBaseline = closestBaseline;
                return newData;
            });
        }
    }
    function dateDragStart() {
        $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "col-resize");
    }
    function dragMoveEndDate() {
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf().toString();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        selectedEntityNewObj.selectedElementPath.service.endDate = newDate;
        setSelectedEntity(selectedEntityNewObj);
    }
    function dragMoveStartDate() {
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf().toString();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        selectedEntityNewObj.selectedElementPath.service.startDate = newDate;
        setSelectedEntity(selectedEntityNewObj);
    }
    function dragMoveStartAndEndDate() {
        if (!selectedEntity || !blockStartDateBeforeDragging || !blockEndDateBeforeDragging || !dragStartDateValue) return;
        const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
        setSelectedElementD3Data((prev)=>{
            const newData = {
                ...prev
            };
            newData.mousePosition = mouseYpos;
            return newData;
        });
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        const dragDelta = newDate - dragStartDateValue;
        selectedEntityNewObj.selectedElementPath.service.startDate = (blockStartDateBeforeDragging + dragDelta).toString();
        selectedEntityNewObj.selectedElementPath.service.endDate = (blockEndDateBeforeDragging + dragDelta).toString();
        setSelectedEntity(selectedEntityNewObj);
    // TODO make the whole block being dragged https://stackoverflow.com/questions/16294214/making-a-svg-text-draggable-using-d3-js
    // const blockDragElement = d3.selectAll(".BlockHeader");
    // transX += d3.event.dx;
    // transY += d3.event.dy;
    // blockDragElement.attr("transform", `translate(${transX}, ${transY})`);
    }
    function dragMoveStartAndEndDateEvent() {
        if (!selectedEntity || !blockStartDateBeforeDragging || !blockEndDateBeforeDragging || !dragStartDateValue) return;
        const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
        setSelectedElementD3Data((prev)=>{
            const newData = {
                ...prev
            };
            newData.mousePosition = mouseYpos;
            return newData;
        });
        const mousePosition = $dd1fb49221ad966f$export$6cd530ed55e06764.x;
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        const dragDelta = newDate - dragStartDateValue;
        selectedEntityNewObj.selectedElementPath.event.startDate = (blockStartDateBeforeDragging + dragDelta).toString();
        selectedEntityNewObj.selectedElementPath.event.endDate = (blockEndDateBeforeDragging + dragDelta).toString();
        setSelectedEntity(selectedEntityNewObj);
    }
    function dragEndLeft() {
        $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "default");
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf().toString();
        updateService({
            startDate: newDate
        });
    }
    function dragEndRight() {
        $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "default");
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf().toString();
        updateService({
            endDate: newDate
        });
    }
    function dragEndBlock() {
        const isNotGhostBlock = selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.sampleId === selectedEntity.selectedElementPath.originPathId;
        const canMove = selectedEntity && (0, $8e533dbe14bc68d5$export$d51625d75caede58)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending;
        if (!isNotGhostBlock || !canMove) return;
        hideBaselines();
        $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "default");
        const blockId = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("id");
        const blockClassName = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("class");
        const serviceBlockDragged = selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE;
        const wrongBlockDragged = selectedEntity && serviceBlockDragged && blockId !== selectedEntity.selectedElementPath.service.id && blockClassName !== "leftDragElement" && blockClassName !== "rightDragElement";
        // d3.mouse(this)[1] and d3.event.y have both the same value here
        const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
        if (!selectedEntity || wrongBlockDragged || !serviceBlockDragged) return;
        setSelectedElementD3Data((prev)=>{
            const newData = {
                ...prev
            };
            newData.isDragged = false;
            newData.mouseYDragStartPos = null;
            newData.mousePosition = null;
            newData.previousBaseline = null;
            return newData;
        });
        const mousePosition = $dbcffd59364661d7$export$2e2bcd8739ae039(this)[0];
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        const dragDelta = newDate - dragStartDateValue;
        const newStartDate = (blockStartDateBeforeDragging + dragDelta).toString();
        const newEndDate = (blockEndDateBeforeDragging + dragDelta).toString();
        const closestBaseline = getBaselineFromYPos(mouseYpos);
        selectedEntityNewObj.selectedElementPath.service.startDate = newStartDate;
        selectedEntityNewObj.selectedElementPath.service.endDate = newEndDate;
        selectedEntityNewObj.selectedElementPath.service.baseLine = closestBaseline;
        setSelectedEntity(selectedEntityNewObj);
        updateService({
            baseLine: closestBaseline,
            startDate: newStartDate,
            endDate: newEndDate
        });
    }
    function dragEndEvent() {
        const isNotGhostBlock = selectedEntity && (0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath) && selectedEntity.selectedElementPath.sampleId === selectedEntity.selectedElementPath.originPathId;
        if (!isNotGhostBlock) return;
        hideBaselines();
        $cf81072cf307ee25$export$2e2bcd8739ae039("body").style("cursor", "default");
        const eventId = $cf81072cf307ee25$export$2e2bcd8739ae039(this).attr("id");
        setSelectedElementD3Data((prev)=>{
            const newData = {
                ...prev
            };
            newData.isDragged = false;
            newData.mouseYDragStartPos = null;
            newData.mousePosition = null;
            newData.previousBaseline = null;
            return newData;
        });
        const eventBlockDragged = selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT;
        const wrongBlockDragged = selectedEntity && eventBlockDragged && eventId !== selectedEntity.selectedElementPath.event.id;
        // d3.mouse(this)[1] and d3.event.y have both the same value here
        const mouseYpos = $dd1fb49221ad966f$export$6cd530ed55e06764.y;
        if (!selectedEntity || wrongBlockDragged || !eventBlockDragged) return;
        const mousePosition = $dd1fb49221ad966f$export$6cd530ed55e06764.x;
        const draggedToDate2 = x.invert(mousePosition);
        const newDate = draggedToDate2.valueOf();
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        const dragDelta = newDate - dragStartDateValue;
        const newStartDate = (blockStartDateBeforeDragging + dragDelta).toString();
        const newEndDate = (blockEndDateBeforeDragging + dragDelta).toString();
        selectedEntityNewObj.selectedElementPath.event.startDate = newStartDate;
        selectedEntityNewObj.selectedElementPath.event.endDate = newEndDate;
        setSelectedEntity(selectedEntityNewObj);
        const closestBaseline = getBaselineFromYPos(mouseYpos);
        updateEvent({
            startDate: newStartDate,
            endDate: newEndDate,
            baseLine: closestBaseline
        });
    }
    if (!disableDnDToUse) {
        const leftDragHandler = $0b4a1789c016a21b$export$2e2bcd8739ae039().on("start", dateDragStart).on("drag", dragMoveStartDate).on("end", dragEndLeft);
        const rightDragHandler = $0b4a1789c016a21b$export$2e2bcd8739ae039().on("start", dateDragStart).on("drag", dragMoveEndDate).on("end", dragEndRight);
        const blockDragHandler = $0b4a1789c016a21b$export$2e2bcd8739ae039().on("start", blockDragStart).on("drag", dragMoveStartAndEndDate).on("end", dragEndBlock);
        const eventDragHandler = $0b4a1789c016a21b$export$2e2bcd8739ae039().on("start", eventDragStart).on("drag", dragMoveStartAndEndDateEvent).on("end", dragEndEvent);
        const leftDragElement = $e5dfdc386da08eff$export$2e2bcd8739ae039(".leftDragElement");
        const rightDragElement = $e5dfdc386da08eff$export$2e2bcd8739ae039(".rightDragElement");
        const blockDragElement = $e5dfdc386da08eff$export$2e2bcd8739ae039(".BlockHeader");
        const eventDragElement = $e5dfdc386da08eff$export$2e2bcd8739ae039(".EventDragElement");
        const selectedEntityNewObj = {
            ...selectedEntity
        };
        eventDragHandler(eventDragElement);
        const isServiceSelected = selectedEntity && selectedEntity.selectedElementType === "service";
        if (isServiceSelected) {
            blockDragHandler(blockDragElement);
            if (selectedEntityNewObj.selectedElementPath.service.durationLocked) {
                blockDragHandler(leftDragElement);
                blockDragHandler(rightDragElement);
            } else {
                leftDragHandler(leftDragElement);
                rightDragHandler(rightDragElement);
            }
        }
    }
    const todayLineX = x(Date.now()) * currentTransform.k + currentTransform.x;
    const todayX = x(Date.now());
    const dropLineX = dropPlace ? x(dropPlace.date) : null;
    (0, $acw62.useEffect)(()=>{
        draw();
    }, [
        axisWidth,
        height,
        width,
        sample.id,
        zoomLevel
    ]);
    const getEventBlock = (event, ghostEvents)=>{
        const isSelected = selectedEntity && selectedEntity.selectedElementType === "event" && selectedEntity.selectedElementPath.event.id === event.id;
        const ownScale = (0, $a66eb252e0fd4b58$export$dbf01c52ad4aabb3)(currentTransform.k);
        const selectedEventPositionY = baselineY - event.baseLine * baselineHeight + (selectedElementD3Data.mousePosition - selectedElementD3Data.mouseYDragStartPos);
        const unselectedEventPositionY = baselineY - event.baseLine * baselineHeight;
        const eventPositionY = isSelected && selectedElementD3Data.isDragged ? selectedEventPositionY : unselectedEventPositionY;
        const totalHeight = 108 * ownScale;
        const theMiddleOfLine = totalHeight / 2 - (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, currentTransform.k) / 2;
        const eventPositionX = isSelected ? x(selectedEntity.selectedElementPath.event.startDate) : x(event.startDate);
        const eventWidth = Math.max(x(event.endDate) - x(event.startDate), 10);
        let newColor = (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray;
        let newEventName = event.name;
        let originPathId = sample.id;
        let eventDisableDndToUse = disableDnDToUse;
        if (ghostEvents) {
            newColor = (0, $dc6fb3e45bbe78f3$export$9082d34138010bda)((0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray, 0.5);
            newEventName = `${ghostEvents.sampleName} - ${event.name}`;
            originPathId = ghostEvents.sampleId;
            eventDisableDndToUse = true;
        }
        const isVisibleOnAllPaths = props.ghostTimelineElements?.ghostEvents.some((ghostEvent)=>ghostEvent.sampleId === sample.id && ghostEvent.events.some((ghEvent)=>ghEvent.id === event.id)) || false;
        const updatedEvent = {
            ...event,
            name: newEventName
        };
        const theMiddleOfXLine = (0, $a66eb252e0fd4b58$export$5cd2a5f4f0b1055)(20, currentTransform.k) / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3598a50f749fb55$export$8d048a4093f4779e), {
            ...updatedEvent,
            y: eventPositionY + theMiddleOfLine,
            x: eventPositionX - theMiddleOfXLine,
            width: eventWidth,
            currentTransform: currentTransform,
            key: updatedEvent.id,
            projectId: projectId,
            sampleId: sample.id,
            disableDnD: eventDisableDndToUse,
            color: newColor,
            visibleOnAllPaths: isVisibleOnAllPaths,
            originPathId: originPathId
        });
    };
    const getServiceBlock = (service, ghostServices)=>{
        const isSelected = selectedEntity && selectedEntity.selectedElementType === "service" && selectedEntity.selectedElementPath.service.id === service.id;
        const selectedServicePositionY = baselineY - baselineHeight * service.baseLine + (selectedElementD3Data.mousePosition - selectedElementD3Data.mouseYDragStartPos);
        const unselectedServicePositionY = baselineY - baselineHeight * service.baseLine;
        const servicePositionY = isSelected && selectedElementD3Data.isDragged ? selectedServicePositionY : unselectedServicePositionY;
        const servicePositionX = isSelected ? x(selectedEntity.selectedElementPath.service.startDate) : x(service.startDate);
        const serviceWidth = isSelected ? Math.max(x(selectedEntity.selectedElementPath.service.endDate) - x(selectedEntity.selectedElementPath.service.startDate), 1) : Math.max(x(service.endDate) - x(service.startDate), 1);
        let newColor = service.color;
        let newWorkflowName = service.workflowName;
        let originPathId = sample.id;
        let serviceDisableDndToUse = disableDnDToUse;
        if (ghostServices) {
            newColor = (0, $dc6fb3e45bbe78f3$export$9082d34138010bda)($ff8a3318298de872$var$getColorFromIndex(ghostServices.workflowIndex), 0.5);
            newWorkflowName = `${ghostServices.sampleName} - ${ghostServices.workflowName}`;
            originPathId = ghostServices.sampleId;
            serviceDisableDndToUse = true;
        }
        if (service.status !== (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending) serviceDisableDndToUse = true;
        const isVisibleOnAllPaths = props.ghostTimelineElements?.ghostServices.some((ghostService)=>ghostService.sampleId === sample.id && ghostService.services.some((vs)=>vs.id === service.id)) || false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94f1a4c82da92a9a$export$ff6d4fbdc5509464), {
            baselineHeight: baselineHeight,
            projectId: projectId,
            sampleId: sample.id,
            ...service,
            y: servicePositionY,
            x: servicePositionX,
            width: serviceWidth,
            currentTransform: currentTransform,
            key: service.id,
            workflowName: newWorkflowName,
            workflowId: service.workflowId,
            color: newColor,
            disableDnD: serviceDisableDndToUse,
            visibleOnAllPaths: isVisibleOnAllPaths,
            originPathId: originPathId,
            todayX: todayX
        });
    };
    const getEventLine = (event)=>{
        const isSelected = selectedEntity && selectedEntity.selectedElementType === "event" && selectedEntity.selectedElementPath.event.id === event.id;
        const eventPositionX = isSelected ? x(selectedEntity.selectedElementPath.event.startDate) : x(event.startDate);
        if (!event.milestone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6f31bcb30602320$export$c3fa0ba61f9aa58a), {
            x: eventPositionX * currentTransform.k + currentTransform.x,
            height: height,
            key: event.id
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ff8a3318298de872$var$TimelineContainer, {
        ref: ref,
        width: props.width,
        height: props.height,
        className: props.className
    }, axisWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ff8a3318298de872$var$StyledSVG, {
        id: $ff8a3318298de872$var$svgId,
        ref: wrapperSVGRef,
        style: {
            backgroundColor: "#e8eaee"
        }
    }, events.filter((event)=>event.milestone).map((event)=>getEventLine(event)), props.ghostTimelineElements?.ghostEvents.filter((ghostEvent)=>ghostEvent.sampleId !== sample.id).filter((ghostEvent)=>ghostEvent.events.filter((ghEvent)=>ghEvent.milestone)).map((ghostEvent)=>ghostEvent.events.map((ghEvent)=>getEventLine(ghEvent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae0c2b5cefbd2eef$export$fd2f0df8d6b00873), {
        x: todayLineX,
        height: height
    }), elementOnDragAction && dropPlace && dropLineX && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: dropLineX * currentTransform.k + currentTransform.x + 20,
        y: dropPlace.yPosition - (elementOnDragAction.type === "event" ? 40 : 20)
    }, dropPlace.date.toISOString().split("T")[0]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90fe9ddbb64f23e$export$c5319153a9ea6c5), {
        x: dropLineX * currentTransform.k + currentTransform.x,
        height: height
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        id: "timeline",
        width: width,
        height: height,
        ref: timelineElementsGroupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: width * 100,
        height: height,
        fillOpacity: "0"
    }), drawLines(), drawBaselineLines(), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT && props.ghostTimelineElements?.ghostServices.filter((ghostService)=>ghostService.sampleId !== sample.id).map((ghostService)=>ghostService.services.map((ghService)=>getServiceBlock(ghService, ghostService))), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT && services.map((service)=>getServiceBlock(service)), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT && props.ghostTimelineElements?.ghostEvents.filter((ghostEvent)=>ghostEvent.sampleId !== sample.id).map((ghostEvent)=>ghostEvent.events.map((ghEvent)=>getEventBlock(ghEvent, ghostEvent))), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT && events.map((event)=>getEventBlock(event)), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).HIGHER && workflows.map((workflow, workflowIndex)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbaacee6e33703b9$export$dcb94e49d873db03), {
            ...workflow,
            projectId: projectId,
            sampleId: sample.id,
            y: baselineY + workflowIndex * workflowsBaselineHeight,
            x: x((0, $dc6fb3e45bbe78f3$export$be536556dc41984e)(workflow).startDate),
            width: Math.max(x((0, $dc6fb3e45bbe78f3$export$be536556dc41984e)(workflow).endDate) - x((0, $dc6fb3e45bbe78f3$export$be536556dc41984e)(workflow).startDate), 20),
            currentTransform: currentTransform,
            key: workflow.id,
            blockColor: $ff8a3318298de872$var$getColorFromIndex(workflowIndex),
            disableDnD: disableDnDToUse
        });
    }), zoomLevel === (0, $a66eb252e0fd4b58$export$8b7222fa92892b49).DEFAULT && drawChangeLineNamingDots(disableDnDToUse)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        id: "axis",
        width: axisWidth,
        height: height,
        ref: axisWrapperGroupRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68679112dabf4530$export$2e2bcd8739ae039), {
        services: services,
        axisWidth: axisWidth - 300,
        config: config,
        x: x,
        baselineY: baselineY,
        baselineHeight: baselineHeight,
        forwardedRef: svgMinimapRef,
        increaseTransform: (delta)=>{
            const center = [
                config._width / 2,
                config._height / 2
            ];
            const newX = (currentTransform.x - center[0]) * (1 + delta) + center[0];
            const newY = (currentTransform.y - center[1]) * (1 + delta) + center[1];
            const newTransform = $a3c1094a2e8782d7$export$f0954fd7d5368655.translate(newX, newY).scale(currentTransform.k + currentTransform.k * delta);
            $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call($91e02783b8b1c24a$export$2e2bcd8739ae039().transform, newTransform);
            zoomedFunction.current(newTransform);
        },
        resetView: ()=>{
            const newTransform = $a3c1094a2e8782d7$export$f0954fd7d5368655.translate(0, 0).scale(1);
            $cf81072cf307ee25$export$2e2bcd8739ae039(wrapperSVGRef.current).call($91e02783b8b1c24a$export$2e2bcd8739ae039().transform, newTransform);
            zoomedFunction.current(newTransform);
        },
        currentTransform: currentTransform
    })), !hideAddIconToUse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ff8a3318298de872$var$AddIconContainer, {
        onClick: handleOnAddIconCLick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3b9bf177ba8611a6$export$a6b7c34d56975de0), {
        height: 24,
        width: 24
    })), isChangePathLineNameModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cb9a5671ba52d6c$export$b6f541c8c0d9ae7d), {
        isOpen: isChangePathLineNameModalOpen,
        pathLineNameToChange: pathLineNameToChange,
        onClose: ()=>{
            setIsChangePathLineNameModalOpen(false);
            setPathLineNameToChange(null);
        },
        projectId: projectId,
        sampleId: sample.id
    }));
};
const $ff8a3318298de872$var$TimelineContainer = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Box))`
  width: ${({ width: width })=>width || "100vw"};
  height: ${({ height: height })=>height || "100vh"};
  position: relative;
  overflow: hidden;
`;
const $ff8a3318298de872$var$StyledSVG = (0, $lmFrL.default).svg`
  width: calc(100%);
  height: calc(100%);
  max-width: 100%;
  max-height: 100%;
  shape-rendering: crispEdges;
`;
const $ff8a3318298de872$var$AddIconContainer = (0, $lmFrL.default).div`
  width: 48px;
  height: 48px;
  background-color: ${({ theme: theme })=>theme.newColors.primary.basic};
  position: absolute;
  bottom: 1.5rem;
  left: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: ${({ theme: theme })=>theme.shadows.icons.expandIcon};
  transition: background-color linear 0.2s;

  :hover {
    background-color: ${({ theme: theme })=>theme.newColors.primary.hover};
    transition: background-color linear 0.2s;
  }

  :focus,
  :active {
    background-color: ${({ theme: theme })=>theme.newColors.primary.darkestTint};
    transition: background-color linear 0.2s;
  }
`;







var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

var $lmFrL = parcelRequire("lmFrL");






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $02448428349d6ff4$var$SingleValue = (props)=>{
    const { data: { label: label, avatar: avatar, smallMenuItems: smallMenuItems } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$SingleValueContainer, {
        smallMenuItems: smallMenuItems,
        title: label
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeAvatar, {
        src: avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeSingleValue, {
        avatarExists: !!avatar,
        smallMenuItems: smallMenuItems
    }, label));
};
const $02448428349d6ff4$var$Option = (props)=>{
    const { data: { label: label, value: value, avatar: avatar, smallMenuItems: smallMenuItems }, setValue: setValue, isSelected: isSelected, disabled: disabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$OptionContainer, {
        isSelected: isSelected,
        onClick: ()=>{
            if (!disabled) setValue(value);
        },
        title: label,
        smallMenuItems: smallMenuItems
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeAvatar, {
        src: avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeValue, {
        avatarExists: !!avatar,
        smallMenuItems: smallMenuItems
    }, label));
};
const $02448428349d6ff4$export$bf32bf315ebc4261 = (props)=>{
    const { loading: loading, users: users, onChange: onChange, editMode: editMode, selectedValue: selectedValue, hardcodedUser: hardcodedUser, disabled: disabled, className: className, smallMenuItems: smallMenuItems = false, menuPortalTarget: menuPortalTarget } = props;
    if (!hardcodedUser && (loading || !users)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe7277f9493cf0da$export$b42aec0a4a94c970), null));
    const renderContent = ()=>{
        const defaultValue = {
            value: "",
            label: "Unassigned",
            avatar: "",
            smallMenuItems: smallMenuItems
        };
        const usersOptions = !hardcodedUser ? users.map((usr)=>{
            if (!usr) return undefined;
            return {
                value: usr.id,
                label: usr.name,
                avatar: usr.avatar,
                smallMenuItems: smallMenuItems
            };
        }).filter((usr)=>usr !== undefined) : [];
        let options = [
            defaultValue,
            ...usersOptions
        ];
        if (hardcodedUser) {
            const newUser = {
                value: hardcodedUser.id,
                avatar: hardcodedUser.avatar,
                label: hardcodedUser.name,
                smallMenuItems: smallMenuItems
            };
            options = [
                ...options,
                newUser
            ];
        }
        if (!editMode) {
            const user = options.find((option)=>option.value === selectedValue);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, user?.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeAvatar, {
                title: user?.label || "",
                src: user?.avatar
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$AssigneeValue, {
                title: user?.label || "",
                smallMenuItems: smallMenuItems,
                avatarExists: !!user?.avatar
            }, user?.label));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$StyledDropdown, {
            defaultValue: options[0],
            options: options,
            components: {
                Option: $02448428349d6ff4$var$Option,
                SingleValue: $02448428349d6ff4$var$SingleValue
            },
            value: options.find((option)=>option.value === selectedValue) || options[0],
            onChange: onChange,
            disabled: disabled,
            menuPortalTarget: menuPortalTarget
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02448428349d6ff4$var$Container, {
        className: className,
        editMode: editMode
    }, renderContent());
};
const $02448428349d6ff4$var$OptionContainer = (0, $lmFrL.default).div`
  display: flex;
  padding: 5px;
  min-height: 2rem;
  align-items: center;

  ${({ smallMenuItems: smallMenuItems })=>smallMenuItems && (0, $lmFrL.css)`
      font-size: 11px !important;
    `};

  ${({ isSelected: isSelected })=>isSelected && (0, $lmFrL.css)`
      background: ${(props)=>props.theme.newColors.primary.lightTint};
      color: ${(props)=>props.theme.newColors.grayscale.primaryGray};
    `};

  &:hover {
    background: ${(props)=>props.theme.newColors.primary.lightestTint};
  }

  &:active {
    background: ${(props)=>props.theme.newColors.primary.lightTint};
  }
`;
const $02448428349d6ff4$var$SingleValueContainer = (0, $lmFrL.default).div`
  display: flex;
  min-height: 15px;
  align-items: center;
  font-size: 12px;

  ${({ smallMenuItems: smallMenuItems })=>smallMenuItems && (0, $lmFrL.css)`
      font-size: 11px;
      margin-left: 2px;
      padding: 0;
    `};
`;
const $02448428349d6ff4$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 200px;
`;
const $02448428349d6ff4$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  position: absolute;
  margin-left: 100px;
  height: 2rem;
  width: calc(100% - 100px);

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`;
const $02448428349d6ff4$var$AssigneeValue = (0, $lmFrL.default).div`
  margin-left: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;

  ${({ smallMenuItems: smallMenuItems })=>smallMenuItems && (0, $lmFrL.css)`
      font-size: 11px;
      margin-left: 5px;
      padding: 0;
    `};

  ${({ smallMenuItems: smallMenuItems, avatarExists: avatarExists })=>smallMenuItems && !avatarExists && (0, $lmFrL.css)`
      margin-left: 0;
    `};
`;
const $02448428349d6ff4$var$AssigneeSingleValue = (0, $lmFrL.default)($02448428349d6ff4$var$AssigneeValue)`
  max-width: 75px;
  cursor: default;
`;
const $02448428349d6ff4$var$AssigneeAvatar = (0, $lmFrL.default).img`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
`;




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $3f28f33e26d81bd8$export$d6005e0ba713cdb8 = "0.00";
const $3f28f33e26d81bd8$var$currencies = Object.keys((0, $7608a8bbcbbad14c$export$b733e092f9f44b2c)).map((key)=>(0, $7608a8bbcbbad14c$export$b733e092f9f44b2c)[key]);
const $3f28f33e26d81bd8$export$a0ace416ddcaca7 = (props)=>{
    const { editMode: editMode = true, value: value, onChange: onChange, onBlur: onBlur, maxWidth: maxWidth, small: small } = props;
    let currentValues = {
        price: value?.price || "",
        currency: value?.currency || $3f28f33e26d81bd8$var$currencies[0] || ""
    };
    const sendOnChangeEvent = (field, newValue)=>{
        currentValues = {
            ...currentValues,
            [field]: newValue
        };
        if (onChange) onChange(currentValues);
    };
    const sendOnBlurEvent = ()=>{
        if (onBlur) onBlur(currentValues);
    };
    const getSize = ()=>{
        if (maxWidth !== undefined && maxWidth >= 0) return maxWidth > 3 ? maxWidth + 4 : 8;
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f28f33e26d81bd8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f28f33e26d81bd8$var$StyledInput, {
        type: "number",
        placeholder: $3f28f33e26d81bd8$export$d6005e0ba713cdb8,
        value: currentValues.price,
        onChange: (e)=>sendOnChangeEvent("price", e.target.value),
        onBlur: sendOnBlurEvent,
        disabled: !editMode,
        size: getSize(),
        small: small
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f28f33e26d81bd8$var$StyledSelect, {
        value: currentValues.currency,
        disabled: !editMode,
        onChange: (e)=>{
            sendOnChangeEvent("currency", e.target.value);
            sendOnBlurEvent();
        },
        small: small
    }, $3f28f33e26d81bd8$var$currencies.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: c
        }, c))));
};
const $3f28f33e26d81bd8$var$Container = (0, $lmFrL.default).div`
  display: flex;
  margin: 4px 0;
`;
const $3f28f33e26d81bd8$var$StyledInput = (0, $lmFrL.default).input`
  width: calc(100% - 70px);
  border-radius: 6px 0 0 6px;
  border-color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};
  border-width: 1px;
  border-right: none;
  text-align: right;

  ${({ size: size })=>size && (0, $lmFrL.css)`
      width: ${size}ch;
    `}

  ${({ small: small })=>small && (0, $lmFrL.css)`
      font-size: 11px;
    `}
`;
const $3f28f33e26d81bd8$var$StyledSelect = (0, $lmFrL.default).select`
  border-radius: 0 6px 6px 0;
  border-color: ${({ theme: theme })=>theme.newColors.grayscale.secondaryGray};

  ${({ small: small })=>small && (0, $lmFrL.css)`
      font-size: 11px;
    `}

  ${({ small: small })=>!small && (0, $lmFrL.css)`
      width: 70px;
    `}
`;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $9474cb8f7f29eaae$export$e1cf0ae0c31c73e7 = (props)=>{
    const { editMode: editMode, selectedOption: selectedOption, dropdownOptions: dropdownOptions, handleColorType: handleColorType, onChange: onChange, className: className } = props;
    const formatOptionLabel = (option)=>{
        const { label: label, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9474cb8f7f29eaae$var$Container, {
            colorValue: value || "",
            handleColorType: handleColorType
        }, label);
    };
    if (!editMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9474cb8f7f29eaae$var$Container, {
        colorValue: selectedOption.value,
        handleColorType: handleColorType
    }, selectedOption.label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9474cb8f7f29eaae$var$StyledDropdown, {
        options: dropdownOptions,
        formatOptionLabel: formatOptionLabel,
        value: selectedOption,
        onChange: onChange,
        className: className
    });
};
const $9474cb8f7f29eaae$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 100%;

  .Select__value-container {
    overflow: unset;
  }
`;
const $9474cb8f7f29eaae$var$Container = (0, $lmFrL.default).div`
  padding: ${({ colorValue: colorValue })=>colorValue !== "None" ? "4px 12px" : "4px 0"};
  border-radius: 29px;
  ${({ colorValue: colorValue, handleColorType: handleColorType })=>handleColorType(colorValue)};
  color: ${({ colorValue: colorValue })=>colorValue !== "None" ? "#ffffff" : "#000000"};
  font-size: 12px;
  vertical-align: middle;
  line-height: 1rem;
  text-transform: uppercase;
  font-weight: 800;
  width: fit-content;
  display: flex;
  justify-content: center;
`;


const $1d76682ddfd98d7d$var$dropdownOptions = [
    {
        value: "None",
        label: "None"
    },
    {
        value: (0, $7608a8bbcbbad14c$export$300334f671c43555).High,
        label: "High"
    },
    {
        value: (0, $7608a8bbcbbad14c$export$300334f671c43555).Medium,
        label: "Medium"
    },
    {
        value: (0, $7608a8bbcbbad14c$export$300334f671c43555).Low,
        label: "Low"
    }
];
const $1d76682ddfd98d7d$export$b95fc38821f8220f = (props)=>{
    const { readOnly: readOnly = false, priority: priority, onPriorityChange: onPriorityChange, className: className } = props;
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($1d76682ddfd98d7d$var$dropdownOptions[0]);
    const onChange = (option)=>{
        const newPriority = option.value === "None" ? null : option.value;
        onPriorityChange(newPriority || null);
    // return (newPriority as Priority) || null;
    };
    const handleColorType = (colorValue)=>{
        switch(colorValue){
            case (0, $7608a8bbcbbad14c$export$300334f671c43555).High:
                return "background-color: #3b79d1;";
            case (0, $7608a8bbcbbad14c$export$300334f671c43555).Medium:
                return "background-color: #91a9e3;";
            case (0, $7608a8bbcbbad14c$export$300334f671c43555).Low:
                return "background-color: #d4dbf4;";
            default:
                return "";
        }
    };
    (0, $acw62.useEffect)(()=>{
        const option = $1d76682ddfd98d7d$var$dropdownOptions.find((dropdownOption)=>dropdownOption.value === priority) || $1d76682ddfd98d7d$var$dropdownOptions[0];
        setSelectedOption(option);
    }, [
        priority
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9474cb8f7f29eaae$export$e1cf0ae0c31c73e7), {
        dropdownOptions: $1d76682ddfd98d7d$var$dropdownOptions,
        editMode: !readOnly,
        selectedOption: selectedOption,
        handleColorType: handleColorType,
        onChange: onChange,
        className: className
    });
};





var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $1220835957bca3ce$export$aac6c35e680b9e09 = (props)=>{
    const { id: id, onClick: onClick, checked: checked, readonly: readonly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1220835957bca3ce$var$Container, {
        onClick: ()=>{
            if (readonly) return;
            onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1220835957bca3ce$var$Input, {
        onChange: ()=>{},
        checked: checked,
        type: "checkbox",
        name: `checkbox-${id}`,
        id: `checkbox-${id}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1220835957bca3ce$var$Label, {
        htmlFor: `checkbox${id}`,
        readonly: readonly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "box",
        d: "M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        className: "check",
        points: "25.5,53.5 39.5,67.5 72.5,34.5 "
    }))));
};
const $1220835957bca3ce$var$Container = (0, $lmFrL.default).div`
  border-radius: 0.3em;
  width: 25px;
  height: 25px;
  box-shadow: 7px 7px 5px rgba(0, 0, 0, 0.04),
    -7px -7px 5px rgba(255, 255, 255, 0.8);
  border: 1px solid rgb(235, 235, 235);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $1220835957bca3ce$var$Label = (0, $lmFrL.default).label`
  font-size: 0.8em;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    stroke: rgb(0, 124, 226);
    stroke-width: 5;
    fill: white;
    padding-right: 0.1px;
    padding-bottom: 0.1px;

    .box {
      stroke-dasharray: 320;
      stroke-dashoffset: 0;
      fill: white;
      transition: stroke-dashoffset 0.3s linear;
    }
    .check {
      stroke-dasharray: 70;
      stroke-dashoffset: 70;
      fill: none;
      transition: stroke-dashoffset 0.3s linear;
    }
  }

  span {
    padding-top: 0.3em;
    margin-left: 0.3em;
  }

  ${({ readonly: readonly })=>!readonly && (0, $lmFrL.css)`
      cursor: pointer;
    `}
`;
const $1220835957bca3ce$var$Input = (0, $lmFrL.default).input`
  display: none;
  pointer-events: none;

  &:checked + label {
    .box {
      stroke-dashoffset: 320;
    }
    .check {
      stroke-dashoffset: 0;
    }
  }
`;


const $108d4e455ecc7d6a$export$ae8c6b85205d7bc6 = (props)=>{
    const { editMode: editMode, hardcodedUser: hardcodedUser } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const { projectId: projectId, sampleId: sampleId, workflowId: workflowId, service: { id: id } } = selectedEntity?.selectedElementPath;
    const { loading: usersLoading, data: usersData } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        },
        fetchPolicy: "cache-first",
        skip: projectId === "tasksAssignedView"
    });
    const [isDescriptionFieldFocused, setIsDescriptionFieldFocused] = (0, $acw62.useState)(false);
    const [isNameFieldFocused, setIsNameFieldFocused] = (0, $acw62.useState)(false);
    const [updateServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$981396349d3957c6)();
    const [serviceName, setServiceName] = (0, $acw62.useState)("");
    const [serviceStartDate, setServiceStartDate] = (0, $acw62.useState)();
    const [serviceDueDate, setServiceDueDate] = (0, $acw62.useState)();
    const [budget, setBudget] = (0, $acw62.useState)();
    const [serviceDescription, setServiceDescription] = (0, $acw62.useState)("");
    const [totalDays, setTotalDays] = (0, $acw62.useState)(null);
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const budgetIsVisible = useUserPermissions("seeBudget");
    const [selectedDatePickerId, setSelectedDatePickerId] = (0, $acw62.useState)(null);
    const [serviceAssignee, setServiceAssignee] = (0, $acw62.useState)(hardcodedUser?.id || null);
    const [servicePriority, setServicePriority] = (0, $acw62.useState)(null);
    const [editModeCalendar, setEditModeCalendar] = (0, $acw62.useState)(editMode);
    const [lockedDuration, setLockedDuration] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const { service: service } = selectedEntity.selectedElementPath;
        let preferredCurrency = (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        try {
            preferredCurrency = localStorage.getItem("preferredCurrency") || (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        } catch (err) {
        // do nothing
        }
        setBudget({
            price: service.price?.price.value || "",
            currency: service.price?.currency || preferredCurrency
        });
        setServiceDescription(service.description);
        setServiceName(service.name);
        setServiceStartDate(new Date(+service.startDate));
        setServiceDueDate(new Date(+service.endDate));
        setServicePriority(service.priority || null);
        setEditModeCalendar(editMode ? service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending : false);
        setLockedDuration(service.durationLocked || false);
        if (!hardcodedUser) setServiceAssignee(service.assignee || "Unassigned");
    }, [
        selectedEntity
    ]);
    (0, $acw62.useEffect)(()=>{
        if (serviceStartDate && serviceDueDate) {
            const calculatedTotalDays = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(serviceDueDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(serviceStartDate), "days") + 1;
            setTotalDays(calculatedTotalDays);
        }
    }, [
        serviceStartDate,
        serviceDueDate,
        selectedEntity
    ]);
    const updateService = (target, value, lockedDate)=>{
        if (!editMode || !(0, $8e533dbe14bc68d5$export$d51625d75caede58)) return;
        if (target === "endDate" && serviceStartDate) {
            if (typeof value === "string" && parseInt(value, 10) < serviceStartDate.getTime()) return;
        }
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: workflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceUpdatables: {
                    id: id,
                    ...lockedDate ? {
                        startDate: lockedDate[0],
                        endDate: lockedDate[1]
                    } : {
                        [target]: value
                    }
                }
            },
            update (cache, { data: data }) {
                // TODO: for Apollo Client v3
                // if (target === "assignee") {
                //
                // cache.evict({
                //   query: ServicesAssignedToUserForTimelineDocument,
                //   variables: { userId: value },
                // });
                // cache.gc()
                // }
                const incomingData = data?.["UpdateServiceFromWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === sampleId);
                    const updatedEnabledWorkflows = sampleHere?.enabledWorkflows.map((workflow)=>({
                            ...workflow,
                            services: (0, $cc4416d5e1582097$export$cf5b13249fe61a4d)(workflow.services, incomingData)
                        }));
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === sampleId) return {
                            ...sampleLoop,
                            enabledWorkflows: updatedEnabledWorkflows
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                }
            }
        };
        if (target === "assignee") options.refetchQueries = [
            "ServicesAssignedToUserForTimeline"
        ];
        const newSelectedEntity = {
            ...selectedEntity,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                service: {
                    ...selectedEntity.selectedElementPath.service,
                    ...lockedDate ? {
                        startDate: lockedDate[0],
                        endDate: lockedDate[1]
                    } : {
                        [target]: value
                    }
                }
            }
        };
        setSelectedEntity(newSelectedEntity);
        updateServiceFromWorkflow(options);
    };
    const setServiceDueDateWithCheck = (newDate)=>{
        if (serviceStartDate && newDate < serviceStartDate && !lockedDuration) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You cannot set the end date earlier than the start date");
            return;
        }
        const copyOfNewDate = newDate;
        const dueDateWithCorrectHours = new Date(copyOfNewDate.setHours(23, 59, 59, 59));
        if (lockedDuration && serviceDueDate && serviceStartDate) {
            const dateDifference = newDate.valueOf() - serviceDueDate.valueOf();
            const newStartValueDate = serviceStartDate.valueOf() + dateDifference;
            const newStartDate = new Date(+newStartValueDate);
            const newStartDateWithCorrectHours = new Date(newStartDate.setHours(0, 0, 0, 0));
            updateService("lockDate", null, [
                newStartDateWithCorrectHours.getTime().toString(),
                dueDateWithCorrectHours.getTime().toString()
            ]);
        } else updateService("endDate", dueDateWithCorrectHours.getTime().toString());
    };
    const handleServiceStartDateChange = (newDate)=>{
        if (serviceDueDate && newDate > serviceDueDate && !lockedDuration) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You cannot set the start date later than the end date");
            return;
        }
        const copyOfNewDate = newDate;
        const startDateWithCorrectHours = new Date(copyOfNewDate.setHours(0, 0, 0, 0));
        if (lockedDuration && serviceDueDate && serviceStartDate) {
            const dateDifference = newDate.valueOf() - serviceStartDate.valueOf();
            const newDueValueDate = serviceDueDate.valueOf() + dateDifference;
            const newDueDate = new Date(+newDueValueDate);
            const newDueDateWithCorrectHours = new Date(newDueDate.setHours(23, 59, 59, 59));
            updateService("lockDate", null, [
                startDateWithCorrectHours.getTime().toString(),
                newDueDateWithCorrectHours.getTime().toString()
            ]);
        } else updateService("startDate", startDateWithCorrectHours.getTime().toString());
    };
    const handleAssigneeChange = (value)=>{
        setServiceAssignee(value);
        updateService("assignee", value);
    };
    const handleNameChange = (e)=>{
        const text = e.target.value;
        setServiceName(text);
    };
    const handleNameOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateService("name", trimmedText);
        setIsNameFieldFocused(false);
    };
    const handleBudgetChange = (p)=>{
        setBudget(p);
    };
    const handlePriorityChange = (priority)=>{
        setServicePriority(priority);
        updateService("priority", priority);
    };
    const handleBudgetOnBlur = (p)=>{
        try {
            localStorage.setItem("preferredCurrency", p.currency);
        } catch (err) {
        // do nothing
        }
        updateService("price", {
            price: {
                value: p.price
            },
            currency: p.currency
        });
    };
    const handleDescriptionChange = (e)=>{
        const text = e.target.value;
        setServiceDescription(text);
    };
    const handleDescriptionOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateService("description", trimmedText);
        setIsDescriptionFieldFocused(false);
    };
    const handleCheckboxClick = ()=>{
        updateService("durationLocked", !lockedDuration);
        setLockedDuration((prev)=>!prev);
    };
    const handleTextWithPencil = (flag, text, readonly)=>{
        if (readonly) return text;
        let preparedText = text;
        if (flag) preparedText = text;
        else if (text.length > 0) preparedText += " \u270E";
        else preparedText = text;
        return preparedText;
    };
    const descriptionText = handleTextWithPencil(isDescriptionFieldFocused, serviceDescription, !editMode);
    const preparedServiceName = handleTextWithPencil(isNameFieldFocused, serviceName, !editMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$EditableNameArea, {
        onChange: handleNameChange,
        onBlur: handleNameOnBlur,
        disabled: !editMode,
        onKeyDown: (event)=>{
            if (event.key === "Enter") event.preventDefault();
        },
        value: preparedServiceName,
        onFocus: ()=>setIsNameFieldFocused(true),
        placeholder: `Enter a name...${editMode ? " \u270E" : ""}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Assignee"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02448428349d6ff4$export$bf32bf315ebc4261), {
        users: usersData?.ProjectUsers,
        loading: !hardcodedUser && usersLoading,
        editMode: editMode,
        selectedValue: serviceAssignee,
        onChange: handleAssigneeChange,
        hardcodedUser: hardcodedUser,
        disabled: !editMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Start Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationValue, {
        editMode: editModeCalendar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: serviceStartDate,
        setDate: handleServiceStartDateChange,
        editMode: editModeCalendar,
        update: updateService,
        destinationUpdate: "startDate",
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 1
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Due Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationValue, {
        editMode: editModeCalendar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: serviceDueDate,
        setDate: setServiceDueDateWithCheck,
        editMode: editModeCalendar,
        update: updateService,
        destinationUpdate: "endDate",
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 2
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Duration"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationValue, {
        editMode: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, totalDays, " ", totalDays && totalDays > 1 ? "Days" : "Day"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Lock Duration"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1220835957bca3ce$export$aac6c35e680b9e09), {
        id: id,
        onClick: handleCheckboxClick,
        checked: lockedDuration,
        readonly: !editMode
    })))), budgetIsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Budget"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f28f33e26d81bd8$export$a0ace416ddcaca7), {
        editMode: editMode,
        value: budget,
        onChange: handleBudgetChange,
        onBlur: handleBudgetOnBlur
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationLabel, null, "Priority"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationDropdown, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1d76682ddfd98d7d$export$b95fc38821f8220f), {
        onPriorityChange: handlePriorityChange,
        priority: servicePriority,
        readOnly: !editMode
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$ServiceDescriptionInformationLabel, null, "Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($108d4e455ecc7d6a$var$EditableDescriptionArea, {
        onChange: handleDescriptionChange,
        onBlur: handleDescriptionOnBlur,
        disabled: !editMode,
        value: descriptionText,
        onFocus: ()=>setIsDescriptionFieldFocused(true),
        placeholder: `Enter a description...${editMode ? " \u270E" : ""}`
    })));
};
const $108d4e455ecc7d6a$var$Container = (0, $lmFrL.default).div`
  padding: 18px 24px;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
`;
const $108d4e455ecc7d6a$var$EditableArea = (0, $lmFrL.default)((0, $8d208011843bf7ea$export$2e2bcd8739ae039))`
  resize: none;
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 6px 3px 6px 3px;
  position: relative;
  width: 100%;

  ${({ disabled: disabled })=>!disabled && (0, $lmFrL.css)`
      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `};

  &:empty::before {
    content: attr(data-placeholder-description);
    color: #ccc;
    font-weight: 400;
  }

  &:empty:focus::before {
    content: "";
  }
`;
const $108d4e455ecc7d6a$var$EditableNameArea = (0, $lmFrL.default)($108d4e455ecc7d6a$var$EditableArea)`
  min-height: 20px;
  line-height: 20px;
  font-size: 17px;
`;
const $108d4e455ecc7d6a$var$EditableDescriptionArea = (0, $lmFrL.default)($108d4e455ecc7d6a$var$EditableArea)`
  min-height: 18px;
  line-height: 18px;
  font-size: 14px;
`;
const $108d4e455ecc7d6a$var$IconContainer = (0, $lmFrL.default).div`
  margin-left: 30px;
`;
const $108d4e455ecc7d6a$var$ServiceInformation = (0, $lmFrL.default).div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  position: relative;
  text-transform: uppercase;
  margin-bottom: 5px;
  column-gap: 23px;
`;
const $108d4e455ecc7d6a$var$ServiceInformationAdditionalMargin = (0, $lmFrL.default)($108d4e455ecc7d6a$var$ServiceInformation)`
  width: 100%;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      margin: 14px 0;
    `};
`;
const $108d4e455ecc7d6a$var$ServiceInformationLabel = (0, $lmFrL.default).div`
  color: ${(props)=>props.theme.newColors.primary.basic};
  padding: 3px 6px;
  height: 2rem;
  display: flex;
  align-items: center;
`;
const $108d4e455ecc7d6a$var$ServiceDescriptionInformationLabel = (0, $lmFrL.default)($108d4e455ecc7d6a$var$ServiceInformationLabel)`
  padding: 4px 6px;
  height: fit-content;
`;
const $108d4e455ecc7d6a$var$ServiceInformationValue = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  position: absolute;
  margin-left: 100px;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`;
const $108d4e455ecc7d6a$var$ServiceInformationDropdown = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  position: absolute;
  margin-left: 100px;
  height: 2rem;
  width: calc(100% - 100px);
`;





var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");



var $acw62 = parcelRequire("acw62");



function $00e7e73723903303$export$9ab0cb19df2ead5a(Component) {
    return (hocProps)=>{
        const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
        const selectedElementPath = selectedEntity?.selectedElementPath;
        const { data: usersData, loading: usersLoading } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
            skip: !selectedElementPath?.projectId || selectedElementPath?.projectId === "tasksAssignedView",
            variables: {
                projectId: selectedElementPath.projectId
            },
            fetchPolicy: "cache-first"
        });
        const { data: groupsData, loading: groupsLoading } = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)({
            fetchPolicy: "cache-first"
        });
        if (groupsLoading || usersLoading || !selectedEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
            opaque: true
        });
        const allGroupOptions = groupsData?.Groups.map((group)=>({
                label: `Group: ${group.name}`,
                value: {
                    id: group.id,
                    name: group.name,
                    type: "group",
                    details: group
                }
            }));
        const allUserOptions = usersData?.ProjectUsers.map((user)=>({
                label: user?.name,
                value: {
                    id: user?.id,
                    name: user?.name,
                    type: "user",
                    details: user
                }
            }));
        const allCollaboratorsOptions = [
            ...allGroupOptions ?? [],
            ...allUserOptions ?? []
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ...hocProps,
            allCollaboratorsOptions: allCollaboratorsOptions
        });
    };
}



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $eb7850b9935bc6b9$export$7e3f53ca473d7a6 = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;
const $eb7850b9935bc6b9$export$ac4a61ef83dbb77b = (0, $lmFrL.default).div`
  font-size: 14px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  display: flex;
  cursor: pointer;
  ${({ spread: spread })=>spread && (0, $lmFrL.css)`
      justify-content: space-between;
    `}

  ${({ editMode: editMode })=>!editMode && (0, $lmFrL.css)`
      cursor: auto;
    `}
`;
const $eb7850b9935bc6b9$export$e18ead8d97f2e857 = (0, $lmFrL.default).div`
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  font-size: 24px;
  margin: auto 5px;
  font-weight: bold;
`;
const $eb7850b9935bc6b9$export$fe5b299089007e42 = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  justify-self: flex-start;
  width: 100%;
`;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
function $9ed1e667c7c1b34e$export$18c8c98c69035f17(props) {
    const getGroupInitials = (g)=>{
        const initial = g.name;
        if (initial.includes(" ")) return initial.split(" ").map((text)=>text[0]).join("").slice(0, 3).toUpperCase();
        return initial.slice(0, 3).toUpperCase();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9ed1e667c7c1b34e$var$AvatarContainer, null, props.collaboratorOption.value.type === "user" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9ed1e667c7c1b34e$var$UserAvatar, {
        src: props.collaboratorOption.value.details.avatar,
        title: props.collaboratorOption.label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9ed1e667c7c1b34e$var$GroupAvatar, {
        title: props.collaboratorOption.label
    }, getGroupInitials(props.collaboratorOption.value)));
}
const $9ed1e667c7c1b34e$var$AvatarContainer = (0, $lmFrL.default).div`
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $9ed1e667c7c1b34e$var$UserAvatar = (0, $lmFrL.default).img`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
`;
const $9ed1e667c7c1b34e$var$GroupAvatar = (0, $lmFrL.default).div`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  background-color: ${(props)=>props.theme.newColors.grayscale.secondaryGray};
  color: white;
  font-weight: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;


const $7cc11c9e56040479$export$9696f3ac75b04826 = (selectedCollaborators)=>{
    return selectedCollaborators && selectedCollaborators.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, selectedCollaborators.sort((a)=>a.value.type === "group" ? -1 : 1).map((collaboratorOption)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ed1e667c7c1b34e$export$18c8c98c69035f17), {
            key: collaboratorOption.value.id,
            collaboratorOption: collaboratorOption
        });
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};


function $a80cb50005a17779$export$e7dc8da8ec7ee068({ currentCollaborators: currentCollaborators, allCollaboratorsOptions: allCollaboratorsOptions, updateServiceFromWorkflow: updateServiceFromWorkflow, serviceId: serviceId, editMode: editMode = true }) {
    const [hideCollaborators, setHideCollaborators] = (0, $acw62.useState)(true);
    const [selectedCollaborators, setCollaborators] = (0, $acw62.useState)(currentCollaborators || []);
    (0, $acw62.useEffect)(()=>{
        setCollaborators(currentCollaborators);
    }, [
        serviceId
    ]);
    const unselectedOptions = allCollaboratorsOptions.filter((a)=>!selectedCollaborators.find((s)=>s.value.id === a.value.id));
    const onSelectBlur = ()=>{
        if (!hideCollaborators) setHideCollaborators(true);
        return updateServiceFromWorkflow(selectedCollaborators);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$ac4a61ef83dbb77b), {
        spread: !hideCollaborators,
        editMode: editMode,
        onClick: ()=>{
            if (editMode) setHideCollaborators(false);
        }
    }, hideCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$7e3f53ca473d7a6), null, (0, $7cc11c9e56040479$export$9696f3ac75b04826)(selectedCollaborators), editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$e18ead8d97f2e857), null, "+")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$fe5b299089007e42), {
        autoFocus: true,
        onBlur: onSelectBlur,
        options: unselectedOptions,
        isMulti: true,
        onChange: (e)=>{
            setCollaborators(e ?? []);
        },
        value: selectedCollaborators
    }));
}




function $3286bb2a5af9d167$var$EditSubtaskCollaboratorsWrapperPure({ allCollaboratorsOptions: allCollaboratorsOptions, parentEnabledWorkflow: parentEnabledWorkflow, editMode: editMode = true }) {
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const selectedElementPath = selectedEntity?.selectedElementPath;
    const [updateServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$981396349d3957c6)({
        refetchQueries: [
            "UserProject"
        ]
    });
    const currentWorkflowCollaborators = parentEnabledWorkflow?.collaborators;
    const currentServiceCollaborators = selectedElementPath.service.collaborators;
    const editServiceInformationsIsEnabled = useUserPermissions("editServiceInformations");
    const callUpdateServiceFromWorkflow = (collaboratorOptions)=>{
        if (!editServiceInformationsIsEnabled) return;
        const updatedCollaborators = {
            groupIds: collaboratorOptions.filter((x)=>x.value.type === "group").map((x)=>x.value.id),
            userIds: collaboratorOptions.filter((x)=>x && x.value.type === "user").map((x)=>x.value.id)
        };
        if (!(0, $f1q41.isEqual)(updatedCollaborators, currentServiceCollaborators)) updateServiceFromWorkflow({
            variables: {
                projectSampleInput: {
                    projectId: selectedElementPath.projectId,
                    sampleId: selectedElementPath.sampleId
                },
                workflowInput: {
                    workflowId: selectedElementPath.workflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceUpdatables: {
                    id: selectedElementPath.service.id,
                    collaborators: updatedCollaborators
                }
            },
            refetchQueries: [
                "ServicesAssignedToGroupForTimeline"
            ],
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateServiceFromWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: selectedElementPath.projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === selectedElementPath.sampleId);
                    const updatedEnabledWorkflows = sampleHere?.enabledWorkflows.map((workflow)=>({
                            ...workflow,
                            services: (0, $cc4416d5e1582097$export$cf5b13249fe61a4d)(workflow.services, incomingData)
                        }));
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === selectedElementPath.sampleId) return {
                            ...sampleLoop,
                            enabledWorkflows: updatedEnabledWorkflows
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: selectedElementPath.projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                }
            }
        });
    };
    const getCurrentCollaborators = (serviceCollaborators, workflowCollaborators)=>{
        let entityToUse;
        if (serviceCollaborators && (serviceCollaborators.userIds.length || serviceCollaborators.groupIds.length)) entityToUse = serviceCollaborators;
        else entityToUse = workflowCollaborators || {
            userIds: [],
            groupIds: []
        };
        return [
            ...entityToUse?.groupIds || [],
            ...entityToUse?.userIds || []
        ].map((eId)=>allCollaboratorsOptions?.find((cg)=>cg.value.id === eId)).filter(Boolean);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a80cb50005a17779$export$e7dc8da8ec7ee068), {
        updateServiceFromWorkflow: callUpdateServiceFromWorkflow,
        allCollaboratorsOptions: allCollaboratorsOptions,
        currentCollaborators: getCurrentCollaborators(currentServiceCollaborators, currentWorkflowCollaborators),
        serviceId: selectedElementPath.service.id,
        editMode: editMode
    });
}
const $3286bb2a5af9d167$export$75ad54955268411e = (0, $00e7e73723903303$export$9ab0cb19df2ead5a)($3286bb2a5af9d167$var$EditSubtaskCollaboratorsWrapperPure);







var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $be57be1003c3e394$var$dropdownOptions = [
    {
        label: "Finished",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Finished
    },
    {
        label: "Ongoing",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing
    },
    {
        label: "Approved",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Approved
    },
    {
        label: "Pending",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending
    },
    {
        label: "Cancelled",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Cancelled
    }
];
const $be57be1003c3e394$export$d8d76cebceb779d8 = (props)=>{
    const { readonly: readonly = false, status: status, onStatusChange: onStatusChange, className: className, menuPortalTarget: menuPortalTarget } = props;
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)($be57be1003c3e394$var$dropdownOptions[3]);
    const onChange = (option)=>{
        onStatusChange(option.value);
    };
    (0, $acw62.useEffect)(()=>{
        const option = $be57be1003c3e394$var$dropdownOptions.find((dropdownOption)=>dropdownOption.value === status) || $be57be1003c3e394$var$dropdownOptions[3];
        setSelectedOption(option);
    }, [
        status
    ]);
    if (readonly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, selectedOption.label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($be57be1003c3e394$var$StyledDropdown, {
        options: $be57be1003c3e394$var$dropdownOptions,
        value: selectedOption,
        onChange: onChange,
        className: className,
        menuPortalTarget: menuPortalTarget
    });
};
const $be57be1003c3e394$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 200px;
`;


const $5bfdf1fd4865de13$export$ebe32a73fdce612e = (props)=>{
    const { parentEnabledWorkflow: parentEnabledWorkflow, hardcodedUser: hardcodedUser, userRoleInSample: userRoleInSample } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const [updateServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$981396349d3957c6)();
    if (!selectedEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const [serviceStatus, setServiceStatus] = (0, $acw62.useState)(null);
    let editMode = useUserPermissions("editServiceInformations", userRoleInSample);
    if ((0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).USER_TASKS) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).GROUP_TASKS)) editMode = false;
    const { projectId: projectId, sampleId: sampleId, workflowId: workflowId, service: { id: id }, originPathId: originPathId } = selectedEntity.selectedElementPath;
    if (sampleId !== originPathId) editMode = false;
    const updateService = (target, value)=>{
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: workflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceUpdatables: {
                    id: id,
                    [target]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateServiceFromWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === sampleId);
                    const updatedEnabledWorkflows = sampleHere?.enabledWorkflows.map((workflow)=>({
                            ...workflow,
                            services: (0, $cc4416d5e1582097$export$cf5b13249fe61a4d)(workflow.services, incomingData)
                        }));
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === sampleId) return {
                            ...sampleLoop,
                            enabledWorkflows: updatedEnabledWorkflows
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                }
            }
        };
        updateServiceFromWorkflow(options);
    };
    const handleStatusChange = (status)=>{
        setServiceStatus(status);
        updateService("status", status);
        const newSelectedEntity = {
            ...selectedEntity
        };
        newSelectedEntity.selectedElementPath.service.status = status;
        setSelectedEntity(newSelectedEntity);
    };
    (0, $acw62.useEffect)(()=>{
        const { service: service } = selectedEntity.selectedElementPath;
        setServiceStatus(service.status);
    }, [
        selectedEntity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, selectedEntity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5bfdf1fd4865de13$var$MarkCompleteContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $be57be1003c3e394$export$d8d76cebceb779d8), {
        onStatusChange: handleStatusChange,
        status: serviceStatus,
        readonly: !editMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $108d4e455ecc7d6a$export$ae8c6b85205d7bc6), {
        editMode: editMode,
        hardcodedUser: hardcodedUser
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5bfdf1fd4865de13$var$CollaboratorsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5bfdf1fd4865de13$var$CollaboratorsHeader, null, "Collaborators and Groups"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3286bb2a5af9d167$export$75ad54955268411e), {
        parentEnabledWorkflow: parentEnabledWorkflow,
        editMode: editMode
    }))));
};
const $5bfdf1fd4865de13$var$CollaboratorsContainer = (0, $lmFrL.default).div`
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  height: 100px;
`;
const $5bfdf1fd4865de13$var$CollaboratorsHeader = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-size: 14px;
  line-height: 16px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-self: flex-start;
`;
const $5bfdf1fd4865de13$var$MarkCompleteContainer = (0, $lmFrL.default).div`
  padding: 18px 24px;
  width: 100%;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
`;





var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");









const $b8e8ee27cdf4766b$export$27816a11377a93f4 = (props)=>{
    const { blockName: blockName, blockColor: blockColor = "#3b79d1", className: className, dragHandleVisible: dragHandleVisible, dragHandleProps: dragHandleProps, copy: copy = false, showDeleteIcon: showDeleteIcon = false, duration: duration = 16, onDeleteIconClick: onDeleteIconClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Container, {
        copy: copy,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Header, {
        color: blockColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$HeaderLeftPart, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$ChainIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
        width: 16,
        height: 16,
        secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$BlockName, null, blockName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$HeaderRightPart, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Time, null, duration, "w"), showDeleteIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$DeleteIconContainer, {
        onClick: onDeleteIconClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9eb29ab2880b8781$export$1ae95d1a7411cb7b), null)), dragHandleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$HeaderIconContainer, dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$ShowDetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$ChevronRightIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e17e79530b3afee5$export$b837bd7eac09a33e), {
        color: "#3b79d1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$LabelContainer, null, "SHOW DETAILS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Line, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$IconsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $faa66b2d2069bb13$export$5fda1783bb83f57b), {
        color: "#e6e6e6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $528694881e20e6a6$export$396501e06429cbe), {
        color: "#e6e6e6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Value, null, "0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a3f0bdd81cba476$export$e0af6f64dcdf9a06), {
        color: "#e6e6e6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Value, null, "0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $651a3f4c44f43348$export$6dcd14de5b20d369), {
        color: "#e6e6e6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8e8ee27cdf4766b$var$Value, null, "0"))));
};
const $b8e8ee27cdf4766b$var$Container = (0, $lmFrL.default).div`
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(220, 222, 229, 0.3);
  border: solid 1px #dedede;
  background-color: #ffffff;
  opacity: 1;

  ${(copy)=>copy && (0, $lmFrL.css)`
      ~ div {
        transform: none !important;
      }

      ~ [data-rbd-placeholder-context-id] {
        display: none !important;
      }
    `};
`;
const $b8e8ee27cdf4766b$var$Header = (0, $lmFrL.default).div`
  background-color: ${({ color: color })=>color};
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const $b8e8ee27cdf4766b$var$HeaderLeftPart = (0, $lmFrL.default).div`
  display: flex;
`;
const $b8e8ee27cdf4766b$var$ChainIconContainer = (0, $lmFrL.default).div`
  padding: 12px;
  height: 16px;
  width: 16px;
`;
const $b8e8ee27cdf4766b$var$HeaderRightPart = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
`;
const $b8e8ee27cdf4766b$var$BlockName = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
`;
const $b8e8ee27cdf4766b$var$Time = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
  margin-right: 4px;
`;
const $b8e8ee27cdf4766b$var$HeaderIconContainer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  margin-right: 8px;
  cursor: pointer;
`;
const $b8e8ee27cdf4766b$var$DeleteIconContainer = (0, $lmFrL.default)($b8e8ee27cdf4766b$var$HeaderIconContainer)`
  margin-right: 0;

  & > svg circle {
    transition: fill linear 0.2s;
  }

  & > svg:hover > path {
    fill: ${({ theme: theme })=>theme.newColors.extra.errorHovered};
    transition: fill linear 0.2s;
  }

  & > svg:active > path {
    fill: ${({ theme: theme })=>theme.newColors.extra.errorActive};
    transition: fill linear 0.2s;
  }
`;
const $b8e8ee27cdf4766b$var$Content = (0, $lmFrL.default).div`
  padding: 12px;
`;
const $b8e8ee27cdf4766b$var$ShowDetailsContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
`;
const $b8e8ee27cdf4766b$var$ChevronRightIconContainer = (0, $lmFrL.default).div`
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $b8e8ee27cdf4766b$var$LabelContainer = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 10px;
  margin-left: 8px;
  color: #3b79d1;
`;
const $b8e8ee27cdf4766b$var$Line = (0, $lmFrL.default).div`
  height: 1px;
  background-color: #dedede;
  margin-left: 8px;
  width: calc(100% - 100px);
`;
const $b8e8ee27cdf4766b$var$IconsContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-top: 12px;
`;
const $b8e8ee27cdf4766b$var$IconContainer = (0, $lmFrL.default).div`
  width: 16px;
  height: 16px;
  padding: 0 2px;
`;
const $b8e8ee27cdf4766b$var$Value = (0, $lmFrL.default).div`
  font-size: 12px;
  line-height: 12px;
  color: #adb1bc;
  padding: 0 2px;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $24248744301e9893$export$9149ee2b9de1b275 = (props)=>{
    const { icon: icon, className: className, dragHandleVisible: dragHandleVisible, dragHandleProps: dragHandleProps, copy: copy = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24248744301e9893$var$Container, {
        copy: copy,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24248744301e9893$var$IconContainer, null, icon), dragHandleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24248744301e9893$var$DragIconContainer, dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null)));
};
const $24248744301e9893$var$Container = (0, $lmFrL.default).div`
  display: flex;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(220, 222, 229, 0.3);
  border: solid 1px #dedede;
  background-color: #ffffff;
  opacity: 1;
  width: fit-content;

  ${(copy)=>copy && (0, $lmFrL.css)`
      ~ div {
        transform: none !important;
      }

      ~ [data-rbd-placeholder-context-id] {
        display: none !important;
      }
    `};
`;
const $24248744301e9893$var$IconContainer = (0, $lmFrL.default).div`
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $24248744301e9893$var$DragIconContainer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  cursor: pointer;
`;






var $acw62 = parcelRequire("acw62");

const $9493a56e0ab435f6$export$da42ff36f288ccd = (props)=>{
    const { width: width, height: height, x: x = 0, y: y = 0, color: color, secondColor: secondColor } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        cx: "11",
        cy: "11",
        r: "11",
        fill: color
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: secondColor,
        d: "M10.333 8.333h1.334V11h2v1.333h-3.334v-4z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fill: secondColor,
        fillRule: "evenodd",
        d: "M5 11a6 6 0 1112 0 6 6 0 01-12 0zm1.333 0a4.668 4.668 0 119.335.001A4.668 4.668 0 016.333 11z",
        clipRule: "evenodd"
    }));
};
$9493a56e0ab435f6$export$da42ff36f288ccd.defaultProps = {
    width: 24,
    height: 24,
    color: "#00715A",
    secondColor: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white
};






const $dd61cc724b29c96b$var$getDefinedBlocks = (numberOfExistingWorkflows)=>{
    const { selectedWorkflowIndex: selectedWorkflowIndex } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const newSubtaskColor = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[selectedWorkflowIndex];
    const newTaskColorIndex = numberOfExistingWorkflows % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
    const newTaskColor = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[newTaskColorIndex];
    return [
        {
            id: "NewWorkflowBlock",
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$StyledStaticBlock, {
                blockName: "New task",
                blockColor: newTaskColor.color,
                dragHandleVisible: true
            })
        },
        {
            id: "NewServiceBlock",
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$StyledStaticBlock, {
                blockName: "New subtask",
                blockColor: newSubtaskColor.color,
                dragHandleVisible: true
            })
        }
    ];
};
const $dd61cc724b29c96b$var$getDefinedEvents = ()=>{
    return [
        {
            id: "NewEventBlock_Meeting",
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24248744301e9893$export$9149ee2b9de1b275), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9493a56e0ab435f6$export$da42ff36f288ccd), null),
                dragHandleVisible: true
            })
        },
        {
            id: "NewEventBlock",
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24248744301e9893$export$9149ee2b9de1b275), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
                    color: "#00715A"
                }),
                dragHandleVisible: true
            })
        }
    ];
};
const $dd61cc724b29c96b$var$getDefinedWorkflowsTemplates = (workflows, numberOfExistingWorkflows, onDeleteClick)=>{
    const newTaskColorIndex = numberOfExistingWorkflows % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
    const newTaskColor = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[newTaskColorIndex];
    return workflows.map((workflow)=>{
        const startDates = workflow.services.map((service)=>+service.startDate);
        const dueDates = workflow.services.map((service)=>+service.endDate);
        const duration = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Math.max(...dueDates)).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Math.min(...startDates)), "week");
        return {
            id: workflow.id,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$StyledStaticBlock, {
                blockName: workflow.name,
                blockColor: newTaskColor.color,
                dragHandleVisible: true,
                duration: duration,
                showDeleteIcon: true,
                onDeleteIconClick: ()=>{
                    if (onDeleteClick) onDeleteClick(workflow.id);
                }
            })
        };
    });
};
const $dd61cc724b29c96b$var$getDraggableElementStyle = (snapshot, style)=>{
    if (!snapshot.isDropAnimating || snapshot.draggingOver !== "TIMELINE") return style;
    return {
        ...style,
        transitionDuration: `0.001s`,
        opacity: 0
    };
};
const $dd61cc724b29c96b$var$getDraggingBlockClone = (numberOfExistingWorkflows)=>(provided, snapshot, rubric)=>{
        const definedBlocks = $dd61cc724b29c96b$var$getDefinedBlocks(numberOfExistingWorkflows);
        const definedBlock = definedBlocks[rubric.source.index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...provided.draggableProps,
            ref: provided.innerRef,
            style: $dd61cc724b29c96b$var$getDraggableElementStyle(snapshot, provided.draggableProps.style),
            key: definedBlock.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(definedBlock.element, {
            dragHandleProps: provided.dragHandleProps
        }));
    };
const $dd61cc724b29c96b$var$getDraggingEventClone = ()=>(provided, snapshot, rubric)=>{
        const definedEvents = $dd61cc724b29c96b$var$getDefinedEvents();
        const definedEvent = definedEvents[rubric.source.index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...provided.draggableProps,
            ref: provided.innerRef,
            style: $dd61cc724b29c96b$var$getDraggableElementStyle(snapshot, provided.draggableProps.style),
            key: definedEvent.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(definedEvent.element, {
            dragHandleProps: provided.dragHandleProps
        }));
    };
const $dd61cc724b29c96b$var$getDraggingTemplateBlockClone = (workflows, numberOfExistingWorkflows)=>(provided, snapshot, rubric)=>{
        const definedBlocks = $dd61cc724b29c96b$var$getDefinedWorkflowsTemplates(workflows, numberOfExistingWorkflows);
        const definedBlock = definedBlocks[rubric.source.index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...provided.draggableProps,
            ref: provided.innerRef,
            style: $dd61cc724b29c96b$var$getDraggableElementStyle(snapshot, provided.draggableProps.style),
            key: definedBlock.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(definedBlock.element, {
            dragHandleProps: provided.dragHandleProps
        }));
    };
const $dd61cc724b29c96b$export$578907c09372c8 = (props)=>{
    const { numberOfExistingWorkflows: numberOfExistingWorkflows, organization: organization } = props;
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [templateIdToDelete, setTemplateIdToDelete] = (0, $acw62.useState)();
    const [removeWorkflowTemplateMutation] = (0, $7608a8bbcbbad14c$export$2d2c9bcecc1a7ed8)();
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $7608a8bbcbbad14c$export$4bba2baf4a53c749)({
        variables: {
            organization: user["https://leaderneplatform.com/organization"] || organization
        }
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    });
    const removeWorkflowTemplate = ()=>{
        if (!templateIdToDelete) return;
        setIsLoading(true);
        removeWorkflowTemplateMutation({
            variables: {
                templateId: templateIdToDelete
            }
        }).then(()=>{
            refetch();
            setTemplateIdToDelete(undefined);
            setIsLoading(false);
            setIsModalOpen(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    };
    const onDeleteClick = (id)=>{
        setTemplateIdToDelete(id);
        setIsModalOpen(true);
    };
    const definedBlocks = $dd61cc724b29c96b$var$getDefinedBlocks(numberOfExistingWorkflows);
    const definedEvents = $dd61cc724b29c96b$var$getDefinedEvents();
    const definedWorkflowsTemplates = $dd61cc724b29c96b$var$getDefinedWorkflowsTemplates(data.WorkflowsByOrganization, numberOfExistingWorkflows, onDeleteClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$Header, null, "add new block"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        renderClone: $dd61cc724b29c96b$var$getDraggingBlockClone(numberOfExistingWorkflows),
        droppableId: "BlockAdder",
        isDropDisabled: true
    }, (droppableProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$BlocksContainer, {
            ref: droppableProvided.innerRef
        }, definedBlocks.map((item, index)=>{
            const renderClone = item.id === snapshot.draggingFromThisWith;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: item.id
            }, renderClone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                copy: renderClone,
                key: item.id
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$f2a139e5d18b9882), {
                draggableId: item.id,
                index: index,
                key: item.id
            }, (draggableProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    ref: draggableProvided.innerRef,
                    ...draggableProvided.draggableProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                    dragHandleProps: draggableProvided.dragHandleProps
                }))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: "none"
            }
        }, droppableProvided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        renderClone: $dd61cc724b29c96b$var$getDraggingEventClone(),
        droppableId: "EventsAdder",
        isDropDisabled: true,
        direction: "horizontal"
    }, (droppableProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$EventsContainer, {
            ref: droppableProvided.innerRef
        }, definedEvents.map((item, index)=>{
            const renderClone = item.id === snapshot.draggingFromThisWith;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: item.id
            }, renderClone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                copy: renderClone,
                key: item.id
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$f2a139e5d18b9882), {
                draggableId: item.id,
                index: index,
                key: item.id
            }, (draggableProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    ref: draggableProvided.innerRef,
                    ...draggableProvided.draggableProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                    dragHandleProps: draggableProvided.dragHandleProps
                }))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: "none"
            }
        }, droppableProvided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$Header, null, "add from a template"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        renderClone: $dd61cc724b29c96b$var$getDraggingTemplateBlockClone(data.WorkflowsByOrganization, numberOfExistingWorkflows),
        droppableId: "WorkflowTemplatesAdder",
        isDropDisabled: true
    }, (droppableProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd61cc724b29c96b$var$BlocksContainer, {
            ref: droppableProvided.innerRef
        }, definedWorkflowsTemplates.map((item, index)=>{
            const renderClone = item.id === snapshot.draggingFromThisWith;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: item.id
            }, renderClone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                copy: renderClone,
                key: item.id
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$f2a139e5d18b9882), {
                draggableId: item.id,
                index: index,
                key: item.id
            }, (draggableProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    ref: draggableProvided.innerRef,
                    ...draggableProvided.draggableProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.element, {
                    dragHandleProps: draggableProvided.dragHandleProps
                }))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: "none"
            }
        }, droppableProvided.placeholder))), isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isModalOpen,
        message: "Do you want to remove this task template?",
        title: "Confirmation",
        closeModal: ()=>setIsModalOpen(false),
        acceptModal: removeWorkflowTemplate,
        isLoading: isLoading
    }));
};
const $dd61cc724b29c96b$var$Container = (0, $lmFrL.default).div`
  padding: 21px 32px;
`;
const $dd61cc724b29c96b$var$Header = (0, $lmFrL.default).div`
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
`;
const $dd61cc724b29c96b$var$BlocksContainer = (0, $lmFrL.default).div``;
const $dd61cc724b29c96b$var$StyledStaticBlock = (0, $lmFrL.default)((0, $b8e8ee27cdf4766b$export$27816a11377a93f4))`
  margin-top: 1rem;
`;
const $dd61cc724b29c96b$var$EventsContainer = (0, $lmFrL.default).div`
  margin: 2rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
`;




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");







const $58d0d9d1e064a340$export$9736bd4e3445c71 = (props)=>{
    const { editMode: editMode, hardcodedUser: hardcodedUser } = props;
    const { selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const { loading: usersLoading, data: usersData } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: selectedEntity.selectedElementPath.projectId
        },
        fetchPolicy: "cache-first"
    });
    const [isDescriptionFieldFocused, setIsDescriptionFieldFocused] = (0, $acw62.useState)(false);
    const [isNameFieldFocused, setIsNameFieldFocused] = (0, $acw62.useState)(false);
    const [updateWorkflowFromSample] = (0, $7608a8bbcbbad14c$export$9cb58138bf28f995)();
    const [workflowName, setWorkflowName] = (0, $acw62.useState)("");
    const [workflowStartDate, setWorkflowStartDate] = (0, $acw62.useState)();
    const [workflowDueDate, setWorkflowDueDate] = (0, $acw62.useState)();
    const [budget, setBudget] = (0, $acw62.useState)();
    const [workflowDescription, setWorkflowDescription] = (0, $acw62.useState)("");
    const [selectedDatePickerId, setSelectedDatePickerId] = (0, $acw62.useState)(null);
    const [workflowAssignee, setWorkflowAssignee] = (0, $acw62.useState)(hardcodedUser?.id || null);
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const budgetIsVisible = useUserPermissions("seeBudget");
    (0, $acw62.useEffect)(()=>{
        const { workflow: workflow } = selectedEntity.selectedElementPath;
        let preferredCurrency = (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        try {
            preferredCurrency = localStorage.getItem("preferredCurrency") || (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        } catch (err) {
        // do nothing
        }
        setBudget({
            price: workflow.price?.price.value || "",
            currency: workflow.price?.currency || preferredCurrency
        });
        setWorkflowDescription(workflow.description || "");
        setWorkflowName(workflow.name);
        const startDates = workflow.services.map((service)=>+service.startDate);
        const dueDates = workflow.services.map((service)=>+service.endDate);
        setWorkflowStartDate(new Date(Math.min(...startDates)));
        setWorkflowDueDate(new Date(Math.max(...dueDates)));
        if (!hardcodedUser) setWorkflowAssignee(workflow.assignee || "Unassigned");
    }, [
        selectedEntity
    ]);
    const { projectId: projectId, sampleId: sampleId, workflowId: workflowId } = selectedEntity?.selectedElementPath;
    const updateWorkflow = async (target, value)=>{
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowUpdatables: {
                    id: workflowId,
                    [target]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateWorkflowFromSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const sample = samples.find((s)=>s.id === sampleId);
                    if (sample) {
                        const workflowIndex = sample.enabledWorkflows.findIndex((w)=>w.id === workflowId);
                        if (workflowIndex !== -1) {
                            sample.enabledWorkflows[workflowIndex] = incomingData;
                            const sampleIndex = samples.findIndex((s)=>s.id === sampleId);
                            samples[sampleIndex] = {
                                ...sample
                            };
                            cache.writeQuery({
                                variables: {
                                    id: projectId
                                },
                                query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                data: {
                                    Project: {
                                        ...existingQueryResult,
                                        samples: samples
                                    }
                                }
                            });
                        }
                    }
                }
            }
        };
        const newSelectedEntity = {
            ...selectedEntity,
            selectedElementPath: {
                ...selectedEntity.selectedElementPath,
                workflow: {
                    ...selectedEntity.selectedElementPath.workflow,
                    [target]: value
                }
            }
        };
        setSelectedEntity(newSelectedEntity);
        return updateWorkflowFromSample(options);
    };
    const handleNameChange = (e)=>{
        const text = e.target.value;
        setWorkflowName(text);
    };
    const handleAssigneeChange = async (value)=>{
        setWorkflowAssignee(value);
        return updateWorkflow("assignee", value);
    };
    const handleStartDateChange = async (value)=>{
        setWorkflowStartDate(value);
        return updateWorkflow("startDate", value.getTime().toString());
    };
    const handleEndDateChange = async (value)=>{
        setWorkflowDueDate(value);
        return updateWorkflow("endDate", value.getTime().toString());
    };
    const handleNameOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateWorkflow("name", trimmedText);
        setIsNameFieldFocused(false);
    };
    const handleBudgetChange = (p)=>{
        setBudget(p);
    };
    const handleBudgetOnBlur = (p)=>{
        try {
            localStorage.setItem("preferredCurrency", p.currency);
        } catch (err) {
        // do nothing
        }
        updateWorkflow("price", {
            price: {
                value: p.price
            },
            currency: p.currency
        });
    };
    const handleDescriptionChange = (e)=>{
        const text = e.target.value;
        setWorkflowDescription(text);
    };
    const handleDescriptionOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateWorkflow("description", trimmedText);
        setIsDescriptionFieldFocused(false);
    };
    const handleTextWithPencil = (flag, text, readonly)=>{
        if (readonly) return text;
        let preparedText = text;
        if (flag) preparedText = text;
        else if (text.length > 0) preparedText += " \u270E";
        else preparedText = text;
        return preparedText;
    };
    const descriptionText = handleTextWithPencil(isDescriptionFieldFocused, workflowDescription, !editMode);
    const preparedWorkflowName = handleTextWithPencil(isNameFieldFocused, workflowName, !editMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$EditableNameArea, {
        onChange: handleNameChange,
        onBlur: handleNameOnBlur,
        disabled: !editMode,
        onKeyDown: (event)=>{
            if (event.key === "Enter") event.preventDefault();
        },
        value: preparedWorkflowName,
        onFocus: ()=>setIsNameFieldFocused(true),
        placeholder: `Enter a name...${editMode ? " \u270E" : ""}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationLabel, null, "Assignee"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02448428349d6ff4$export$bf32bf315ebc4261), {
        users: usersData?.ProjectUsers,
        loading: usersLoading,
        editMode: editMode,
        selectedValue: workflowAssignee,
        onChange: handleAssigneeChange,
        hardcodedUser: hardcodedUser
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationLabel, null, "Start Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: workflowStartDate,
        setDate: handleStartDateChange,
        editMode: editMode,
        update: updateWorkflow,
        destinationUpdate: "startDate",
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 1
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationLabel, null, "Due Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: workflowDueDate,
        setDate: handleEndDateChange,
        editMode: editMode,
        update: updateWorkflow,
        destinationUpdate: "endDate",
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 2
    }))), budgetIsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationLabel, null, "Budget"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f28f33e26d81bd8$export$a0ace416ddcaca7), {
        editMode: editMode,
        value: budget,
        onChange: handleBudgetChange,
        onBlur: handleBudgetOnBlur
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$ServiceDescriptionInformationLabel, null, "Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58d0d9d1e064a340$var$EditableDescriptionArea, {
        onChange: handleDescriptionChange,
        onBlur: handleDescriptionOnBlur,
        disabled: !editMode,
        value: descriptionText,
        onFocus: ()=>setIsDescriptionFieldFocused(true),
        placeholder: `Enter a description...${editMode ? " \u270E" : ""}`
    })));
};
const $58d0d9d1e064a340$var$Container = (0, $lmFrL.default).div`
  padding: 18px 24px;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
`;
const $58d0d9d1e064a340$var$EditableArea = (0, $lmFrL.default)((0, $8d208011843bf7ea$export$2e2bcd8739ae039))`
  resize: none;
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 6px 3px 6px 3px;
  position: relative;
  width: 100%;

  ${({ disabled: disabled })=>!disabled && (0, $lmFrL.css)`
      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `};

  &:empty::before {
    content: attr(data-placeholder-description);
    color: #ccc;
    font-weight: 400;
  }

  &:empty:focus::before {
    content: "";
  }
`;
const $58d0d9d1e064a340$var$EditableNameArea = (0, $lmFrL.default)($58d0d9d1e064a340$var$EditableArea)`
  min-height: 20px;
  line-height: 20px;
  font-size: 17px;
`;
const $58d0d9d1e064a340$var$EditableDescriptionArea = (0, $lmFrL.default)($58d0d9d1e064a340$var$EditableArea)`
  min-height: 18px;
  line-height: 18px;
  font-size: 14px;
`;
const $58d0d9d1e064a340$var$ServiceInformation = (0, $lmFrL.default).div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  position: relative;
  text-transform: uppercase;
  margin-bottom: 5px;
  column-gap: 23px;
  align-items: center;
`;
const $58d0d9d1e064a340$var$ServiceInformationAdditionalMargin = (0, $lmFrL.default)($58d0d9d1e064a340$var$ServiceInformation)`
  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      margin: 14px 0;
    `};
`;
const $58d0d9d1e064a340$var$ServiceInformationLabel = (0, $lmFrL.default).div`
  color: ${(props)=>props.theme.newColors.primary.basic};
  padding: 3px 6px;
  height: 2rem;
  display: flex;
  align-items: center;
`;
const $58d0d9d1e064a340$var$ServiceDescriptionInformationLabel = (0, $lmFrL.default)($58d0d9d1e064a340$var$ServiceInformationLabel)`
  padding: 4px 6px;
  height: fit-content;
`;
const $58d0d9d1e064a340$var$ServiceInformationValue = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  position: absolute;
  margin-left: 100px;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`; // const ServiceInformationDropdown = styled.div`
 //   display: flex;
 //   align-items: center;
 //   padding: 3px 0;
 //   position: absolute;
 //   margin-left: 100px;
 //   height: 2rem;
 //   width: calc(100% - 100px);
 // `;




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $48733520fe14d760$export$2cceaa698b7ab0be = ({ allCollaborators: allCollaborators, currentCollaborators: currentCollaborators, updateWorkflow: updateWorkflow, workflowId: workflowId, editMode: editMode = true })=>{
    const [hideCollaborators, setHideCollaborators] = (0, $acw62.useState)(true);
    const [selectedCollaborators, setCollaborators] = (0, $acw62.useState)(currentCollaborators || []);
    (0, $acw62.useEffect)(()=>{
        setCollaborators(currentCollaborators);
    }, [
        workflowId
    ]);
    const unselectedOptions = allCollaborators.filter((a)=>!selectedCollaborators.find((s)=>s.value.id === a.value.id));
    const onSelectBlur = ()=>{
        if (!hideCollaborators) setHideCollaborators(true);
        return updateWorkflow(selectedCollaborators);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$ac4a61ef83dbb77b), {
        spread: !hideCollaborators,
        onClick: ()=>{
            if (editMode) setHideCollaborators(false);
        },
        editMode: editMode
    }, hideCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$7e3f53ca473d7a6), null, (0, $7cc11c9e56040479$export$9696f3ac75b04826)(selectedCollaborators), editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$e18ead8d97f2e857), null, "+")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb7850b9935bc6b9$export$fe5b299089007e42), {
        autoFocus: true,
        onBlur: onSelectBlur,
        options: unselectedOptions,
        isMulti: true,
        onChange: (e)=>{
            setCollaborators(e ?? []);
        },
        value: selectedCollaborators
    }));
};



function $40191194a72a9a97$var$EditTaskCollaboratorsWrapperPure({ allCollaboratorsOptions: allCollaboratorsOptions, editMode: editMode = true }) {
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const selectedElementPath = selectedEntity?.selectedElementPath;
    const workflowForCustomer = selectedElementPath.workflow;
    const [updateWorkflow] = (0, $7608a8bbcbbad14c$export$9cb58138bf28f995)({
        refetchQueries: [
            "UserProject"
        ]
    });
    const { collaborators: currentCollaborators } = workflowForCustomer;
    const callUpdateWorkflow = (collaboratorOptions)=>{
        const updatedCollaborators = {
            groupIds: collaboratorOptions.filter((x)=>x.value.type === "group").map((x)=>x.value.id),
            userIds: collaboratorOptions.filter((x)=>x && x.value.type === "user").map((x)=>x.value.id)
        };
        if (!(0, $f1q41.isEqual)(updatedCollaborators, currentCollaborators)) return updateWorkflow({
            variables: {
                projectSampleInput: {
                    projectId: selectedElementPath.projectId,
                    sampleId: selectedElementPath.sampleId
                },
                workflowUpdatables: {
                    id: workflowForCustomer.id,
                    collaborators: updatedCollaborators
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateWorkflowFromSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: selectedElementPath.projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const sample = samples.find((s)=>s.id === selectedElementPath.sampleId);
                    if (sample) {
                        const workflowIndex = sample.enabledWorkflows.findIndex((w)=>w.id === workflowForCustomer.id);
                        if (workflowIndex !== -1) {
                            sample.enabledWorkflows[workflowIndex] = incomingData;
                            const sampleIndex = samples.findIndex((s)=>s.id === selectedElementPath.sampleId);
                            samples[sampleIndex] = {
                                ...sample
                            };
                            cache.writeQuery({
                                variables: {
                                    id: selectedElementPath.projectId
                                },
                                query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                                data: {
                                    Project: {
                                        ...existingQueryResult,
                                        samples: samples
                                    }
                                }
                            });
                        }
                    }
                }
            }
        });
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48733520fe14d760$export$2cceaa698b7ab0be), {
        allCollaborators: allCollaboratorsOptions,
        currentCollaborators: [
            ...currentCollaborators?.groupIds || [],
            ...currentCollaborators?.userIds || []
        ].map((eId)=>allCollaboratorsOptions?.find((cg)=>cg.value.id === eId)).filter(Boolean),
        updateWorkflow: callUpdateWorkflow,
        workflowId: selectedElementPath.workflowId,
        editMode: editMode
    });
}
const $40191194a72a9a97$export$508e07282f0ffd08 = (0, $00e7e73723903303$export$9ab0cb19df2ead5a)($40191194a72a9a97$var$EditTaskCollaboratorsWrapperPure);




const $f7ee36a6b693e63b$export$793bea54b89939f3 = (props)=>{
    const { hardcodedUser: hardcodedUser, userRoleInSample: userRoleInSample } = props;
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    let editMode = useUserPermissions("editServiceInformations", userRoleInSample);
    if ((0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).USER_TASKS) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).GROUP_TASKS)) editMode = false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7ee36a6b693e63b$var$MarkCompleteContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "\u2714 MARK COMPLETE",
        type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $58d0d9d1e064a340$export$9736bd4e3445c71), {
        editMode: editMode,
        hardcodedUser: hardcodedUser
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7ee36a6b693e63b$var$CollaboratorsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f7ee36a6b693e63b$var$CollaboratorsHeader, null, "Collaborators and Groups"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40191194a72a9a97$export$508e07282f0ffd08), {
        editMode: editMode
    })));
};
const $f7ee36a6b693e63b$var$CollaboratorsContainer = (0, $lmFrL.default).div`
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  height: 100px;
`;
const $f7ee36a6b693e63b$var$CollaboratorsHeader = (0, $lmFrL.default).div`
  font-family: Overpass;
  font-size: 14px;
  line-height: 16px;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-self: flex-start;
`;
const $f7ee36a6b693e63b$var$MarkCompleteContainer = (0, $lmFrL.default).div`
  padding: 18px 24px;
  width: 100%;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
`;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");







const $7258e425c91ec8e4$export$7c86639a21ed3750 = (props)=>{
    const { editMode: editMode = true } = props;
    const { setSelectedEntity: setSelectedEntity, selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity || !(0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const [isDescriptionFieldFocused, setIsDescriptionFieldFocused] = (0, $acw62.useState)(false);
    const [isNameFieldFocused, setIsNameFieldFocused] = (0, $acw62.useState)(false);
    const [updateEventFromSample] = (0, $7608a8bbcbbad14c$export$8af6b8f568ed5160)();
    const [eventDescription, setEventDescription] = (0, $acw62.useState)("");
    const [eventName, setEventName] = (0, $acw62.useState)("");
    const [eventDate, setEventDate] = (0, $acw62.useState)();
    const [eventMilestoneChecked, setEventMilestoneChecked] = (0, $acw62.useState)(false);
    const [selectedDatePickerId, setSelectedDatePickerId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const { event: event } = selectedEntity.selectedElementPath;
        setEventDescription(event.description);
        setEventName(event.name);
        setEventDate(new Date(+event.startDate));
        setEventMilestoneChecked(event.milestone || false);
    }, [
        selectedEntity
    ]);
    const updateEvent = (target, value)=>{
        if (!(0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath)) return;
        const { projectId: projectId, sampleId: sampleId, event: { id: id } } = selectedEntity.selectedElementPath;
        const options = {
            variables: {
                projectSampleEventInput: {
                    projectId: projectId,
                    sampleId: sampleId,
                    eventId: id
                },
                eventUpdatables: {
                    [target]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateEventFromSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleHere = samplesHere.find((s)=>s.id === sampleId);
                    const updatedEvents = sampleHere?.events.map((event)=>{
                        if (event.id === id) return incomingData;
                        return event;
                    });
                    const newSamples = samplesHere.map((sampleLoop)=>{
                        if (sampleLoop.id === sampleId) return {
                            ...sampleLoop,
                            events: updatedEvents
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        variables: {
                            id: projectId
                        },
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: newSamples
                            }
                        }
                    });
                    setSelectedEntity({
                        selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT,
                        selectedElementPath: {
                            projectId: projectId,
                            sampleId: sampleId,
                            originPathId: sampleId,
                            event: incomingData
                        }
                    });
                }
            }
        };
        updateEventFromSample(options);
    };
    const handleNameChange = (e)=>{
        const text = e.target.value;
        setEventName(text);
    };
    const handleEventDateChange = (newDate)=>{
        newDate.setHours(12);
        newDate.setMinutes(0);
        updateEvent("startDate", newDate.getTime().toString());
    };
    const handleNameOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateEvent("name", trimmedText);
        setIsNameFieldFocused(false);
    };
    const handleDescriptionChange = (e)=>{
        const text = e.target.value;
        setEventDescription(text);
    };
    const handleDescriptionOnBlur = (e)=>{
        const text = e.target.value;
        const trimmedText = text.trim();
        updateEvent("description", trimmedText);
        setIsDescriptionFieldFocused(false);
    };
    const handleOnCheckboxClick = ()=>{
        updateEvent("milestone", !eventMilestoneChecked);
        setEventMilestoneChecked((prev)=>!prev);
    };
    const handleTextWithPencil = (flag, text)=>{
        let preparedText = text;
        if (flag) preparedText = text;
        else if (text.length > 0) preparedText += " \u270E";
        else preparedText = text;
        return preparedText;
    };
    const descriptionText = handleTextWithPencil(isDescriptionFieldFocused, eventDescription);
    const preparedEventName = handleTextWithPencil(isNameFieldFocused, eventName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EditableNameArea, {
        onChange: handleNameChange,
        onBlur: handleNameOnBlur,
        disabled: !editMode,
        onKeyDown: (event)=>{
            if (event.key === "Enter") event.preventDefault();
        },
        value: preparedEventName,
        onFocus: ()=>setIsNameFieldFocused(true),
        placeholder: "Enter a name... \u270E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformationLabel, null, "Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformationValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db52be5984f608c1$export$5109c6dd95d8fb00), {
        date: eventDate,
        setDate: handleEventDateChange,
        editMode: editMode,
        update: updateEvent,
        destinationUpdate: "startDate",
        showIcon: true,
        selectedDatePickerId: selectedDatePickerId,
        setSelectedDatePickerId: setSelectedDatePickerId,
        datePickerId: 1
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformationAdditionalMargin, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventDescriptionInformationLabel, null, "Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EditableDescriptionArea, {
        onChange: handleDescriptionChange,
        onBlur: handleDescriptionOnBlur,
        disabled: !editMode,
        value: descriptionText,
        onFocus: ()=>setIsDescriptionFieldFocused(true),
        placeholder: "Enter a description... \u270E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventInformationLabel, null, "Show milestone line"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$EventMilestoneValue, {
        editMode: editMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7258e425c91ec8e4$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1220835957bca3ce$export$aac6c35e680b9e09), {
        id: selectedEntity.selectedElementPath.event.id,
        onClick: handleOnCheckboxClick,
        checked: eventMilestoneChecked,
        readonly: !editMode
    })))));
};
const $7258e425c91ec8e4$var$Container = (0, $lmFrL.default).div`
  padding: 18px 24px;
  border-bottom: 1px solid
    ${(props)=>props.theme.newColors.grayscale.bordersInside};
`;
const $7258e425c91ec8e4$var$IconContainer = (0, $lmFrL.default).div`
  margin-left: 30px;
`;
const $7258e425c91ec8e4$var$EditableArea = (0, $lmFrL.default)((0, $8d208011843bf7ea$export$2e2bcd8739ae039))`
  resize: none;
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 6px 3px 6px 3px;
  position: relative;
  width: 100%;

  &:hover,
  &:active,
  &:focus-visible {
    border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
    outline: 0px solid transparent;
  }

  &:empty::before {
    content: attr(data-placeholder-description);
    color: #ccc;
    font-weight: 400;
  }

  &:empty:focus::before {
    content: "";
  }
`;
const $7258e425c91ec8e4$var$EditableNameArea = (0, $lmFrL.default)($7258e425c91ec8e4$var$EditableArea)`
  min-height: 20px;
  line-height: 20px;
  font-size: 17px;
`;
const $7258e425c91ec8e4$var$EditableDescriptionArea = (0, $lmFrL.default)($7258e425c91ec8e4$var$EditableArea)`
  min-height: 18px;
  line-height: 18px;
  font-size: 14px;
`;
const $7258e425c91ec8e4$var$EventInformation = (0, $lmFrL.default).div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  position: relative;
  text-transform: uppercase;
  margin-bottom: 5px;
  column-gap: 23px;
  align-items: center;
`;
const $7258e425c91ec8e4$var$EventInformationAdditionalMargin = (0, $lmFrL.default)($7258e425c91ec8e4$var$EventInformation)`
  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      margin: 14px 0;
    `};
`;
const $7258e425c91ec8e4$var$EventInformationLabel = (0, $lmFrL.default).div`
  color: ${(props)=>props.theme.newColors.primary.basic};
  padding: 3px 6px;
  height: 2rem;
  display: flex;
  align-items: center;
`;
const $7258e425c91ec8e4$var$EventDescriptionInformationLabel = (0, $lmFrL.default)($7258e425c91ec8e4$var$EventInformationLabel)`
  padding: 4px 6px;
  height: fit-content;
`;
const $7258e425c91ec8e4$var$EventInformationValue = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  position: absolute;
  margin-left: 100px;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`;
const $7258e425c91ec8e4$var$EventMilestoneValue = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 130px;

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      cursor: pointer;
    `};
`;




const $e5a56ccfcb050dcb$export$591c482854a3b3 = (props)=>{
    const { editMode: editMode = true } = props;
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    if (!selectedEntity || !(0, $8e533dbe14bc68d5$export$e2a35ec91c774fdd)(selectedEntity.selectedElementPath)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const { sampleId: sampleId, originPathId: originPathId } = selectedEntity.selectedElementPath;
    let edit = editMode;
    if (sampleId !== originPathId) edit = false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7258e425c91ec8e4$export$7c86639a21ed3750), {
        editMode: edit
    });
};







const $ef92f9c2c2fa6654$export$3d59973ce1647f7d = (projects)=>projects.map((project)=>{
        const { id: id, samples: samples } = project;
        return {
            id: id,
            name: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            samples: samples
        };
    });
const $ef92f9c2c2fa6654$export$a3b1f88604fc80ab = (project)=>{
    if (!project) return [];
    return project.samples.map((sample)=>{
        const { id: id, status: status } = sample;
        const percent = (0, $3bbf7b1e5596dfc1$export$57b3d59defb99e59)((0, $3bbf7b1e5596dfc1$export$95b0eef4b9606f6e)(sample));
        return {
            id: id,
            name: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample),
            percent: percent,
            status: status
        };
    });
};
const $ef92f9c2c2fa6654$export$51b38849529091dd = (project)=>{
    if (!project.visibleTimelineElements?.samples) return undefined;
    const ghostTimelineElements = {
        ghostServices: [],
        ghostEvents: []
    };
    project.visibleTimelineElements.samples.forEach((visibleSample)=>{
        const projectSample = project.samples.find((sample)=>sample.id === visibleSample?.id);
        if (!projectSample) return;
        visibleSample?.workflows?.forEach((visibleWorkflow)=>{
            const sampleWorkflowIndex = projectSample.enabledWorkflows.findIndex((enabledWorkflow)=>enabledWorkflow.id === visibleWorkflow?.id);
            if (sampleWorkflowIndex === -1) return;
            const newGhostTimelineServices = {
                sampleId: projectSample.id,
                sampleName: projectSample.name,
                workflowId: projectSample.enabledWorkflows[sampleWorkflowIndex].id,
                workflowIndex: sampleWorkflowIndex,
                workflowName: projectSample.enabledWorkflows[sampleWorkflowIndex].name,
                services: []
            };
            visibleWorkflow?.services?.forEach((visibleService)=>{
                const workflowService = projectSample.enabledWorkflows[sampleWorkflowIndex].services.find((service)=>service.id === visibleService);
                if (!workflowService) return;
                newGhostTimelineServices.services.push(workflowService);
            });
            ghostTimelineElements.ghostServices.push(newGhostTimelineServices);
        });
        if (visibleSample?.events) {
            const newGhostTimelineEvents = {
                sampleId: projectSample.id,
                sampleName: projectSample.name,
                events: []
            };
            visibleSample.events?.forEach((visibleEvent)=>{
                const eventToAdd = projectSample.events.find((event)=>event.id === visibleEvent);
                if (!eventToAdd) return;
                newGhostTimelineEvents.events.push(eventToAdd);
            });
            ghostTimelineElements.ghostEvents.push(newGhostTimelineEvents);
        }
    });
    return ghostTimelineElements;
};



const $fdecb748df15842d$export$882f8cd6537a0f14 = (_props)=>{
    let urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    if (!urlParams) urlParams = (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_EVENT) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_SERVICE) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE_WORKFLOW) || (0, $66249767282b1118$export$6c330e8992e8a295)((0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_SAMPLE);
    const { selectedWorkflowIndex: selectedWorkflowIndex, selectedEntity: selectedEntity, setSelectedEntity: setSelectedEntity, droppedElementCoordinates: droppedElementCoordinates, setDroppedElementCoordinates: setDroppedElementCoordinates, setElementOnDragAction: setElementOnDragAction } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { setSideDrawboardOpen: setSideDrawboardOpen, sideDrawboardOpen: sideDrawboardOpen, navBarOpen: navBarOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const { error: userPlainProjectsError, loading: userPlainProjectsLoading, data: userPlainProjectsData } = (0, $7608a8bbcbbad14c$export$51199fd5d18fce87)();
    const { error: userProjectError, loading: userProjectLoading, data: userProjectData } = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: urlParams.projectId
        }
    });
    const [addServiceToWorkflow] = (0, $7608a8bbcbbad14c$export$2a667d95ba1e4243)();
    const [addWorkflowToSample] = (0, $7608a8bbcbbad14c$export$96dfdf14e11e0dc6)();
    const [addEventToSample] = (0, $7608a8bbcbbad14c$export$1d952a1636443323)();
    const [selectedSampleId, setSelectedSampleId] = (0, $acw62.useState)("");
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let projectName = "";
        if (!userProjectLoading && userProjectData) {
            const project = userProjectData.Project;
            projectName = `${(0, $30737cddea16cf18$export$2cd058184eb75757)(project)} `;
        }
        document.title = `${projectName}Leaderna Platform`;
    }, [
        urlParams.projectId
    ]);
    if (userProjectError || userPlainProjectsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", userProjectError || userPlainProjectsError);
    if (userPlainProjectsLoading || !userPlainProjectsData || userProjectLoading || !userProjectData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projectsList = (0, $ef92f9c2c2fa6654$export$3d59973ce1647f7d)(userPlainProjectsData.Projects);
    const project = userProjectData.Project;
    const samples = (0, $ef92f9c2c2fa6654$export$a3b1f88604fc80ab)(project);
    if (!project) {
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    }
    // this redirects to the configurator when project has none ongoing services
    // if (project && !projectHasOngoingSamples(project)) {
    //   navigate(`/projects/${project.id}/configurator`);
    //   return <Spinner />;
    // }
    // const selectFirstSampleWithTimeline = (): void => {
    //   const sampleWithTimeline = project.samples.find(
    //     (sample: Sample) => sample.status === "Ongoing"
    //   );
    //   if (sampleWithTimeline) {
    //     setSelectedSampleId(sampleWithTimeline.id);
    //   }
    // };
    const ghostTimelineElements = (0, $ef92f9c2c2fa6654$export$51b38849529091dd)(project);
    const getSelectedSample = (sampleId)=>{
        return project.samples.find((sample)=>sample.id === sampleId);
    };
    const selectFirstSample = ()=>{
        if (urlParams.sampleId === "1") {
            const firstSampleId = project.samples[0].id;
            setSelectedSampleId(firstSampleId);
        }
        const sampleToSelect = getSelectedSample(urlParams.sampleId);
        if (!sampleToSelect) return;
        setSelectedSampleId(sampleToSelect.id);
        if (urlParams.eventId) {
            const event = sampleToSelect.events.find((e)=>e.id === urlParams.eventId);
            if (!event) return;
            const visibleOnAllPaths = ghostTimelineElements?.ghostEvents.some((ghostEvent)=>ghostEvent.sampleId === urlParams.sampleId && ghostEvent.events.some((ghEvent)=>ghEvent.id === event.id)) || false;
            const selectedElementPath = {
                projectId: urlParams.projectId,
                sampleId: urlParams.sampleId,
                event: event,
                originPathId: urlParams.sampleId,
                visibleOnAllPaths: visibleOnAllPaths
            };
            setSelectedEntity({
                selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT,
                selectedElementPath: selectedElementPath
            });
            setSideDrawboardOpen(true);
            return;
        }
        if (urlParams.workflowId) {
            const workflow = sampleToSelect.enabledWorkflows.find((w)=>w.id === urlParams.workflowId);
            if (!workflow) return;
            if (urlParams.serviceId) {
                const service = workflow.services.find((s)=>s.id === urlParams.serviceId);
                if (service) {
                    const visibleOnAllPaths = ghostTimelineElements?.ghostServices.some((ghostService)=>ghostService.sampleId === urlParams.sampleId && ghostService.services.some((ghService)=>ghService.id === service.id)) || false;
                    const selectedElementPath = {
                        projectId: urlParams.projectId,
                        sampleId: urlParams.sampleId,
                        workflowName: workflow.name,
                        workflowId: urlParams.workflowId,
                        service: service,
                        originPathId: urlParams.sampleId,
                        visibleOnAllPaths: visibleOnAllPaths
                    };
                    setSelectedEntity({
                        selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE,
                        selectedElementPath: selectedElementPath
                    });
                    setSideDrawboardOpen(true);
                    return;
                }
            }
            const selectedElementPath = {
                projectId: urlParams.projectId,
                sampleId: urlParams.sampleId,
                workflowName: workflow.name,
                workflowId: workflow.id,
                workflow: workflow
            };
            setSelectedEntity({
                selectedElementType: (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW,
                selectedElementPath: selectedElementPath
            });
            setSideDrawboardOpen(true);
        }
    };
    if (selectedSampleId === "") selectFirstSample();
    const sample = getSelectedSample(selectedSampleId);
    if (!sample) selectFirstSample();
    const handleChangeSample = (sampleId)=>{
        const selectedSample = getSelectedSample(sampleId);
        if (selectedSampleId !== sampleId) {
            setSelectedEntity(undefined);
            setSideDrawboardOpen(false);
        }
        if (selectedSample) {
            setSelectedSampleId(sampleId);
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/projects/${urlParams.projectId}/timeline/samples/${sampleId}`);
        }
    };
    const addService = (newServiceId, startDate, baseline)=>{
        const currentWorkflowId = sample && sample.enabledWorkflows[selectedWorkflowIndex] && sample.enabledWorkflows[selectedWorkflowIndex].id;
        if (!currentWorkflowId) return;
        setIsLoading(true);
        addServiceToWorkflow({
            variables: {
                projectSampleInput: {
                    projectId: project.id,
                    sampleId: selectedSampleId
                },
                workflowInput: {
                    workflowId: currentWorkflowId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceId: newServiceId,
                startDate: startDate,
                baseline: baseline
            },
            update (cache, { data: data }) {
                const incomingData = data?.["AddServiceToWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: project.id
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samplesHere = [
                        ...existingQueryResult.samples
                    ];
                    const sampleData = samplesHere.find((s)=>s.id === selectedSampleId);
                    if (sampleData) {
                        const workflowIndex = sampleData.enabledWorkflows.findIndex((w)=>w.id === currentWorkflowId);
                        if (workflowIndex !== -1) sampleData.enabledWorkflows[workflowIndex] = incomingData;
                        cache.writeQuery({
                            variables: {
                                id: project.id
                            },
                            query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                            data: {
                                Project: {
                                    ...existingQueryResult,
                                    samples: samplesHere
                                }
                            }
                        });
                    }
                }
            }
        }).then(()=>{
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    };
    const addWorkflow = (newWorkflowId, startDate, serviceBaseline)=>{
        setIsLoading(true);
        addWorkflowToSample({
            variables: {
                projectSampleInput: {
                    projectId: project.id,
                    sampleId: selectedSampleId
                },
                workflowId: newWorkflowId,
                startDate: startDate,
                serviceBaseline: serviceBaseline
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: project.id
                    }
                }
            ],
            update (cache, mutationResult) {
                (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("AddWorkflowToSample", cache, mutationResult, project.id, selectedSampleId);
            }
        }).then(()=>{
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    };
    const addEvent = (newEventId, startDate, baseline)=>{
        setIsLoading(true);
        addEventToSample({
            variables: {
                projectSampleInput: {
                    projectId: project.id,
                    sampleId: selectedSampleId
                },
                eventId: newEventId,
                startDate: startDate,
                baseline: baseline
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: project.id
                    }
                }
            ],
            update (cache, mutationResult) {
                (0, $7caf56f3d9ede2cb$export$3f3ffa4457eefa1d)("AddWorkflowToSample", cache, mutationResult, project.id, selectedSampleId);
            }
        }).then(()=>{
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    };
    const onDragEnd = (result)=>{
        setElementOnDragAction(null);
        if (result.destination?.droppableId !== "TIMELINE") return;
        const newElementId = result.draggableId;
        const startDate = droppedElementCoordinates.date.getTime().toString();
        const { baseline: baseline } = droppedElementCoordinates;
        const source = result.source.droppableId;
        if (newElementId === "NewServiceBlock") addService(newElementId, startDate, baseline);
        else if (newElementId === "NewWorkflowBlock") addWorkflow(newElementId, startDate, baseline);
        else if (newElementId.includes("EventBlock")) addEvent(newElementId, startDate, baseline);
        if (source === "WorkflowTemplatesAdder") addWorkflow(newElementId, startDate, baseline);
        setDroppedElementCoordinates({
            date: new Date(),
            baseline: 0
        });
    };
    const onDragStart = (dragStart)=>{
        let type = "";
        switch(dragStart.draggableId){
            case "NewServiceBlock":
                type = "service";
                break;
            case "NewWorkflowBlock":
                type = "workflow";
                break;
            case "NewEventBlock":
            case "NewEventBlock_Meeting":
                type = "event";
                break;
            default:
                break;
        }
        setElementOnDragAction({
            type: type
        });
    };
    const numberOfExistingWorkflows = sample ? sample.enabledWorkflows.length : 1;
    const userRoleInSample = sample?.assignedUsers?.find((assignedUser)=>assignedUser?.id === user.sub)?.role;
    const addItemsIsEnabled = useUserPermissions("addItemsToTimeline", userRoleInSample);
    let sideDrawboardContent = null;
    if (addItemsIsEnabled) sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd61cc724b29c96b$export$578907c09372c8), {
        numberOfExistingWorkflows: numberOfExistingWorkflows
    });
    if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE) {
        const parentEnabledWorkflow = project.samples?.find((s)=>selectedSampleId === s.id)?.enabledWorkflows.find((w)=>w.id === selectedEntity.selectedElementPath.workflowId);
        sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bfdf1fd4865de13$export$ebe32a73fdce612e), {
            parentEnabledWorkflow: parentEnabledWorkflow,
            userRoleInSample: userRoleInSample
        });
    } else if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW) sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7ee36a6b693e63b$export$793bea54b89939f3), {
        userRoleInSample: userRoleInSample
    });
    else if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).EVENT) sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5a56ccfcb050dcb$export$591c482854a3b3), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b711d7114a492d30$export$fd49a2600ae22a01), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fdecb748df15842d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b4277e0518a98ad$export$ef8da11641c635de), {
        projectsList: projectsList,
        samples: samples,
        selectedSample: selectedSampleId,
        onSampleClick: (sampleId)=>handleChangeSample(sampleId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$237bd83162c14364), {
        onDragStart: onDragStart,
        onDragEnd: onDragEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a63adcedbbdafe19$export$423ec2075359570a), {
        droppableId: "TIMELINE"
    }, (droppableProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fdecb748df15842d$var$DroppableContent, {
            ref: droppableProvided.innerRef,
            width: `calc(100% - ${sideDrawboardOpen ? "337px" : "72px"} - ${navBarOpen ? "337px" : "72px"})`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff8a3318298de872$export$e6a97ba2cae5bb94), {
            width: "100%",
            sample: sample,
            projectId: project.id,
            ghostTimelineElements: ghostTimelineElements,
            disableDnD: !addItemsIsEnabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                // backgroundColor: "black",
                width: 1000
            }
        }, droppableProvided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b46390a7c7d7753$export$7280240986cdf65a), {
        dropdownData: project.samples,
        selectedDropdownDataId: selectedSampleId,
        onDataClick: (sampleId)=>handleChangeSample(sampleId),
        numberOfExistingWorkflows: numberOfExistingWorkflows,
        userRoleInSample: userRoleInSample
    }, sideDrawboardContent))));
};
const $fdecb748df15842d$var$Container = (0, $lmFrL.default).div`
  display: flex;
  height: 100%;
`;
const $fdecb748df15842d$var$DroppableContent = (0, $lmFrL.default).div`
  width: ${(props)=>props.width};
  height: 100%;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $45fvw = parcelRequire("45fvw");






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $46874718c32701e4$export$2146da21c23d5853 = (props)=>{
    const { projectsNumber: projectsNumber } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46874718c32701e4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46874718c32701e4$var$Header, null, "Projects (", projectsNumber, ")"));
};
$46874718c32701e4$export$2146da21c23d5853.defaultProps = {
    projectsNumber: 0
};
const $46874718c32701e4$var$Container = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;
const $46874718c32701e4$var$Header = (0, $lmFrL.default).div`
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.secondaryGray};
`;



const $da725c5c72257b1b$export$883262dc952d8f59 = (_props)=>{
    const queryResult = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)({
        variables: {}
    });
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = queryResult.data.Projects || [];
    const projectsLength = projects.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "All reports"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46874718c32701e4$export$2146da21c23d5853), {
        projectsNumber: projectsLength
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($da725c5c72257b1b$var$ProjectsContainer, null, projects.map((project)=>{
        const projectLastActivityDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(project.lastActivity ? parseInt(project.lastActivity, 10) : undefined).format("Do MMMM YYYY");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0088b6913e751ef0$export$b3ae466e79cecc68), {
            key: project.id,
            projectLastActivity: projectLastActivityDateString,
            projectName: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            currentService: project.currentService,
            onClick: ()=>{
                (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/reports/${project.id}/${project.samples[0].id}`);
            }
        });
    })));
};
const $da725c5c72257b1b$var$ProjectsContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $1d7d458669c8b075$export$b33f1c0dcea919cf = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($1d7d458669c8b075$var$Container, {
        className: props.className
    }, /*#__PURE__*/ $acw62.createElement($1d7d458669c8b075$var$Content, null, /*#__PURE__*/ $acw62.createElement($1d7d458669c8b075$var$ImageContainer, null, /*#__PURE__*/ $acw62.createElement((0, $528694881e20e6a6$export$396501e06429cbe), {
        width: 48,
        height: 48,
        color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray
    })), /*#__PURE__*/ $acw62.createElement($1d7d458669c8b075$var$StyledLabel, {
        label: "NO REPORTS YET"
    }, "Here you\u2019ll see reports for finished services. They will contain a general status description and a file with the full result of the service.")));
};
const $1d7d458669c8b075$var$StyledLabel = (0, $lmFrL.default)((0, $d1cfb23e53b30236$export$b04be29aa201d4f5))``;
const $1d7d458669c8b075$var$Container = (0, $lmFrL.default).div`
  display: flex;
`;
const $1d7d458669c8b075$var$Content = (0, $lmFrL.default).div`
  width: 381px;
  display: flex;
  flex-direction: column;
`;
const $1d7d458669c8b075$var$ImageContainer = (0, $lmFrL.default).div`
  background: ${({ theme: theme })=>theme.colors.gray05};
  width: 96px;
  height: 96px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;







const $51325696c2fe73ac$var$runQuestionAnswerMutationAfterMs = 1000;
let $51325696c2fe73ac$var$lastMetadata = null;
const $51325696c2fe73ac$var$parseProjectSamples = (samples)=>samples.filter((sample)=>sample.enabledWorkflows && sample.enabledWorkflows.length > 0).map((sample)=>({
            id: sample.id,
            label: (0, $e07216757a3bd51c$export$915e191deda31e58)((0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)),
            status: (0, $2d7ecd00adce73e7$export$e35c1996c6f482ad).Done
        }));
const $51325696c2fe73ac$var$getTabs = (projectId, samples = [], selectedSampleId = "1")=>{
    const parsedProjectSamples = $51325696c2fe73ac$var$parseProjectSamples(samples);
    const tabs = [
        ...parsedProjectSamples
    ];
    const selectTab = (sampleId)=>{
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/reports/${projectId}/${sampleId}`);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $37c3cbd3d47c5d4a$export$b2539bed5023c21c), {
        tabs: tabs,
        onTabClick: selectTab,
        activeTab: selectedSampleId,
        onNewTabClick: ()=>{},
        hideNewButton: true
    });
};
const $51325696c2fe73ac$var$getReportSelectedQuestionGroups = (sample)=>{
    const questionGroups = [];
    for(let i = 0; i < sample.enabledWorkflows.length; i += 1){
        const workflow = sample.enabledWorkflows[i];
        const services = workflow.services.filter((service)=>service && service.report && service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Finished);
        if (services.length > 0) services.forEach((service)=>{
            const { report: report } = service;
            if (report && report.selectedQuestionGroups && report.selectedQuestionGroups.length > 0) report.selectedQuestionGroups.forEach((questionGroup)=>questionGroups.push({
                    serviceName: service.name,
                    serviceId: service.id,
                    workflowId: workflow.id,
                    questionGroup: {
                        ...questionGroup
                    }
                }));
        });
    }
    return questionGroups;
};
const $51325696c2fe73ac$export$98c2ac6bfa108d31 = (props)=>{
    const { sample: sample, samples: samples } = props;
    const { projectId: projectId, sampleId: sampleId } = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const userRoleInSample = sample?.assignedUsers?.find((assignedUser)=>assignedUser?.id === user.sub)?.role;
    const projectSampleWithMultiAnswer = (0, $7608a8bbcbbad14c$export$3a30da8008cfc73a)()[0];
    const projectSampleWithNumericAnswer = (0, $7608a8bbcbbad14c$export$46ebc9426755df51)()[0];
    const projectSampleWithTextAnswer = (0, $7608a8bbcbbad14c$export$23628b905dc411dd)()[0];
    const questionGroupId = selectedEntity && selectedEntity.selectedElementPath.questionGroupId;
    const sampleName = (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample);
    const questionGroups = $51325696c2fe73ac$var$getReportSelectedQuestionGroups(sample);
    const getSelectedQuestionGroupElement = (questionGroup, index)=>{
        /* eslint-disable */ if ((selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION_GROUP || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).QUESTION || selectedEntity?.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).ONE_OF_MANY) && questionGroup.questionGroup.id === questionGroupId) /* eslint-enable */ return /*#__PURE__*/ $acw62.createElement((0, $6b010ab846055fec$export$7ff8a395dfe1fcb1), {
            key: questionGroup.questionGroup.id,
            title: `${questionGroup.serviceName}: ${questionGroup.questionGroup.name}`,
            stepNumber: index + 1,
            wrapped: false,
            questionGroup: questionGroup.questionGroup,
            wrapCardsCallback: ()=>{},
            projectId: projectId,
            sampleId: sampleId,
            isReport: true,
            workflowId: questionGroup.workflowId,
            serviceId: questionGroup.serviceId
        });
        const getMutationBasedOnAnswerType = (answerType)=>{
            switch(answerType){
                case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number:
                    return projectSampleWithNumericAnswer;
                case (0, $7608a8bbcbbad14c$export$44e2388b3736c907).ManyOfMany:
                    return projectSampleWithMultiAnswer;
                default:
                    return projectSampleWithTextAnswer;
            }
        };
        const answerProjectSampleQuestion = (metadata, answer)=>{
            if (!metadata.questionLevelInput.sampleId) throw new Error("Metadata is missing sampleId");
            const options = {
                variables: {
                    answer: answer,
                    projectSampleQuestionInput: {
                        questionInput: {
                            ...metadata.questionInput,
                            fromReport: true,
                            workflowId: questionGroup.workflowId,
                            serviceId: questionGroup.serviceId
                        },
                        projectSampleInput: {
                            projectId: metadata.questionLevelInput.projectId,
                            sampleId: metadata.questionLevelInput.sampleId
                        }
                    }
                },
                refetchQueries: [
                    {
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        variables: {
                            id: projectId
                        }
                    }
                ],
                awaitRefetchQueries: true
            };
            const mutation = getMutationBasedOnAnswerType(metadata.answerType);
            if (metadata.answerType === (0, $7608a8bbcbbad14c$export$44e2388b3736c907).Number) options.variables.answer = parseFloat(options.variables.answer) || 0;
            const mutationPromise = mutation(options);
            mutationPromise.catch((e)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e.toString());
            });
        };
        const answerProjectSampleQuestionDebouncedInternal = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(answerProjectSampleQuestion, $51325696c2fe73ac$var$runQuestionAnswerMutationAfterMs, {
            leading: false,
            trailing: true
        });
        const answerProjectSampleQuestionDebounced = (metadata, answear)=>{
            if ($51325696c2fe73ac$var$lastMetadata !== JSON.stringify(metadata)) {
                $51325696c2fe73ac$var$lastMetadata = JSON.stringify(metadata);
                answerProjectSampleQuestionDebouncedInternal.flush();
            }
            answerProjectSampleQuestionDebouncedInternal(metadata, answear);
        };
        return /*#__PURE__*/ $acw62.createElement((0, $f801bca6edd7fbeb$export$53faf303b8a97647), {
            key: questionGroup.questionGroup.id,
            title: `${questionGroup.serviceName}: ${questionGroup.questionGroup.name}`,
            stepNumber: index + 1,
            wrapped: false,
            questionLevelInput: {
                projectId: projectId,
                sampleId: sampleId
            },
            questionGroup: questionGroup.questionGroup,
            answerQuestionCallback: answerProjectSampleQuestionDebounced,
            wrapCardsCallback: ()=>{},
            projectId: projectId,
            sampleId: sampleId,
            isReport: true,
            workflowId: questionGroup.workflowId,
            serviceId: questionGroup.serviceId,
            userRoleInSample: userRoleInSample
        });
    };
    const handleSampleClick = (id)=>{
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/reports/${projectId}/${id}`);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $ee39733285fed7b5$export$3a64ff9464252ed4), {
        pageTitle: sampleName,
        tabs: $51325696c2fe73ac$var$getTabs(projectId, samples, sampleId || "1"),
        dropdownData: samples,
        selectedDropdownDataId: sample.id,
        onDataClick: (id)=>handleSampleClick(id),
        projectId: projectId,
        selectedQuestionGroups: sample.selectedQuestionGroups,
        sample: sample,
        fromReport: questionGroups.length > 0,
        fixedSideDrawboard: false
    }, questionGroups.length > 0 ? questionGroups.map((qg, index)=>getSelectedQuestionGroupElement(qg, index)) : /*#__PURE__*/ $acw62.createElement((0, $1d7d458669c8b075$export$b33f1c0dcea919cf), null));
};


const $6b451827d670740b$export$8f769340aed2ad81 = (props)=>{
    const urlQueryParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const queryResult = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: urlQueryParams.projectId
        }
    });
    if (queryResult.error) return /*#__PURE__*/ $acw62.createElement("p", null, "Query Error: ", queryResult.error);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const project = queryResult.data.Project;
    if (!project.samples.length) return /*#__PURE__*/ $acw62.createElement("p", null, "Query Error: no samples were defined in the project");
    const selectedSample = project.samples.find((sample)=>sample.id === urlQueryParams.sampleId);
    if (!selectedSample) return /*#__PURE__*/ $acw62.createElement("div", null, "Sample not found");
    return /*#__PURE__*/ $acw62.createElement((0, $51325696c2fe73ac$export$98c2ac6bfa108d31), {
        sample: selectedSample,
        samples: project.samples,
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");









var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");





const $8b3fdf9efe73528c$export$ba5b4d9fcd6df2f0 = (props)=>{
    const { isOpen: isOpen, onAccept: onAccept, onClose: onClose } = props;
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)([]);
    const { data: data, loading: loading } = (0, $7608a8bbcbbad14c$export$de444598f6e99ad3)({
        fetchPolicy: "cache-first",
        variables: {
            searchText: searchText
        }
    });
    const closeModal = ()=>{
        setSearchText("");
        onClose();
    };
    const invite = ()=>{
        setSearchText("");
        setIsLoading(true);
        onAccept(selected);
    };
    const ModalButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8b3fdf9efe73528c$var$AcceptButton, {
            disabled: isLoading,
            label: "Add Users",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: invite
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: closeModal
        }));
    };
    const onMenuClose = ()=>{
        setSearchText("");
    };
    const onChange = (options)=>{
        setSelected(options);
    };
    const onInputChange = (value)=>{
        if (value.length >= 3) setTimeout(()=>{
            setSearchText(value);
        }, 1000);
    };
    const getOptions = ()=>{
        return data && data.SearchUsers ? data.SearchUsers.map((el)=>({
                value: el.id,
                label: `${el.name} - ${el.email}`
            })) : [];
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3139a814db547547$export$2b77a92f1a5ad772), {
        id: "addTeamMember",
        title: "Add users to this Project",
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        dialogClassName: "customModalDialog",
        onClose: closeModal,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8b3fdf9efe73528c$var$StyledDropdown, {
        closeMenuOnSelect: false,
        isMulti: true,
        isLoading: loading,
        isSearchable: true,
        value: selected,
        options: getOptions(),
        noOptionsMessage: ()=>"Search by name or email, type at least 3 letters",
        placeholder: "Search by name or email, type at least 3 letters",
        onInputChange: onInputChange,
        onChange: onChange,
        onMenuClose: onMenuClose
    }));
};
const $8b3fdf9efe73528c$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $8b3fdf9efe73528c$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 100%;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $2fa05356ae0b1c49$export$370f1ee40d2f6224 = (0, $lmFrL.default).div`
  overflow-x: ${(props)=>props.scrollable ? "auto" : "inherit"};
`;
const $2fa05356ae0b1c49$export$f2c3aea42b2a048f = (0, $lmFrL.default).table`
  width: 100%;
  border-collapse: collapse;
  font-family: Overpass, serif;
  line-height: 1.33;
  letter-spacing: normal;
`;
const $2fa05356ae0b1c49$export$f850895b287ef28e = (0, $lmFrL.default).thead``;
const $2fa05356ae0b1c49$export$9e1517a3035b3e5c = (0, $lmFrL.default).th`
  font-weight: bold;
  text-align: left;
  padding: 5px 0;
  font-size: 14px;
`;
const $2fa05356ae0b1c49$export$81861c3875c01088 = (0, $lmFrL.default).tr`
  border-bottom: 2px ${(props)=>props.theme.newColors.grayscale.primaryGray}
    solid;
`;
const $2fa05356ae0b1c49$export$76ccd210b9029917 = (0, $lmFrL.default).tbody``;
const $2fa05356ae0b1c49$export$b05581f4e764e162 = (0, $lmFrL.default).tr`
  &:hover {
    background-color: ${(props)=>props.theme.newColors.grayscale.background};
  }
`;
const $2fa05356ae0b1c49$export$1e4baea7053fc0e3 = (0, $lmFrL.default).td`
  &:first-child {
    max-width: ${({ isEditable: isEditable })=>isEditable && "40px"};
  }
  &:nth-child(2) {
    max-width: ${({ isEditable: isEditable })=>isEditable && "70px"};
  }

  padding: 8px 3px 5px;
  font-size: 12px;
`;
const $2fa05356ae0b1c49$export$4dfa824a445e350c = (0, $lmFrL.default).div`
  display: flex;
  gap: 1rem;
`;
const $2fa05356ae0b1c49$export$534d24ee1d3c6abf = (0, $lmFrL.default).span`
  display: inline-block;
  cursor: pointer;
  font-weight: bold;
  padding: 5px;
  color: ${(props)=>props.theme.newColors.primary.basic};

  &:hover {
    color: ${(props)=>props.theme.newColors.primary.hover};
  }
`;
const $2fa05356ae0b1c49$export$b6f8733eca75f512 = (0, $lmFrL.default)($2fa05356ae0b1c49$export$534d24ee1d3c6abf)`
  color: ${({ theme: theme })=>theme.newColors.extra.errorState};

  &:hover {
    color: ${({ theme: theme })=>theme.newColors.extra.errorHovered};
  }
`;


const $4f313ca9eed73129$export$54ec01a60f47d33d = (props)=>{
    const { children: children, columns: columns, scrollable: scrollable = true, isEditable: isEditable } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$370f1ee40d2f6224), {
        scrollable: scrollable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$f2c3aea42b2a048f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$f850895b287ef28e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$81861c3875c01088), null, columns.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$9e1517a3035b3e5c), {
            key: c
        }, c)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$76ccd210b9029917), null, children.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$b05581f4e764e162), {
            key: `row_${Math.random()}`
        }, row.map((cell)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$1e4baea7053fc0e3), {
                key: `cell_${Math.random()}`,
                isEditable: isEditable
            }, cell)))))));
};







var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");








var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $2e8ca34cd8eee2f9$export$6741b6855392643a = (props)=>{
    const { disabled: disabled, checked: checked, onChange: onChange, className: className } = props;
    const [isChecked, setIsChecked] = (0, $acw62.useState)(checked);
    (0, $acw62.useEffect)(()=>{
        setIsChecked(checked);
    }, [
        checked
    ]);
    const onCheckboxChange = disabled ? ()=>{} : ()=>{
        setIsChecked(!isChecked);
        if (onChange) onChange();
    };
    return /*#__PURE__*/ $acw62.createElement($2e8ca34cd8eee2f9$var$Root, {
        checked: isChecked,
        disabled: disabled,
        className: className
    }, /*#__PURE__*/ $acw62.createElement($2e8ca34cd8eee2f9$var$Input, {
        type: "checkbox",
        onChange: onCheckboxChange,
        checked: isChecked,
        "aria-checked": isChecked,
        disabled: disabled
    }), /*#__PURE__*/ $acw62.createElement($2e8ca34cd8eee2f9$var$Fill, {
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement((0, $42463a34abab2d04$export$9b5dff8e8139613e), null)));
};
const $2e8ca34cd8eee2f9$var$Root = (0, $lmFrL.default).div`
  cursor: pointer;
  min-width: 24px;
  height: 24px;
  position: relative;

  &::before {
    content: "";
    border: 1px solid ${(props)=>props.theme.newColors.grayscale.tertiaryGray};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    border-radius: 4px;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
  }

  ${(props)=>props.disabled && (0, $lmFrL.css)`
      cursor: default;
    `}

  ${(props)=>props.checked && (0, $lmFrL.css)`
      &::before {
        background: ${({ theme: theme })=>theme.newColors.primary.basic};
        border: none;
      }
    `}

  &:hover {
    &::before {
      background: ${({ theme: theme })=>theme.newColors.grayscale.background};
      border: 1px solid ${({ theme: theme })=>theme.newColors.grayscale.tertiaryGray};
    }
  }
`;
const $2e8ca34cd8eee2f9$var$Fill = (0, $lmFrL.default).div`
  opacity: 0;
  width: 0;
  height: 0;
  border-radius: 100%;
  position: absolute;
  pointer-events: none;
  z-index: 1;

  ${(props)=>props.disabled && (0, $lmFrL.css)`
      & > svg > path {
        fill: #b6b8ba;
      }
    `}
`;
const $2e8ca34cd8eee2f9$var$Input = (0, $lmFrL.default).input`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;

  &:focus {
    outline: none;
  }

  ${({ checked: checked })=>checked ? (0, $lmFrL.css)`
          & ~ ${$2e8ca34cd8eee2f9$var$Fill} {
            opacity: 1;
          }
        ` : ``}
`;




const $3a0f5e44c015da7e$var$dropdownOptions = [
    {
        value: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR,
        label: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR
    },
    {
        value: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR,
        label: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR
    },
    {
        value: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
        label: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER
    },
    {
        value: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).READONLY,
        label: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).READONLY
    },
    {
        value: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST,
        label: (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST
    }
];
const $3a0f5e44c015da7e$export$c2e68c538d45a4df = (props)=>{
    const { assignedSamples: assignedSamples, onCheckboxChange: onCheckboxChange, onDropdownChange: onDropdownChange, user: user, canUserModifyOverview: canUserModifyOverview } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$Title, null, "Samples"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$SamplesContainer, null, assignedSamples.map((assignedSample, index)=>{
        const dropdownOption = $3a0f5e44c015da7e$var$dropdownOptions.find((dO)=>dO.value === assignedSample.role);
        const userOptionRoleIndex = $3a0f5e44c015da7e$var$dropdownOptions.findIndex((dO)=>dO.value === user.role);
        const filteredDropdownOptions = $3a0f5e44c015da7e$var$dropdownOptions.filter((_, i)=>i >= userOptionRoleIndex);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$Row, {
            key: assignedSample.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$SubContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2e8ca34cd8eee2f9$export$6741b6855392643a), {
            checked: assignedSample.assigned,
            onChange: ()=>onCheckboxChange(assignedSample.id, !assignedSample.assigned),
            disabled: index === 0 && !canUserModifyOverview
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$SampleName, null, assignedSample.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a0f5e44c015da7e$var$StyledDropdown, {
            options: filteredDropdownOptions,
            value: assignedSample.assigned ? dropdownOption : undefined,
            placeholder: "",
            onChange: (option)=>{
                onDropdownChange(assignedSample.id, option.value);
            },
            isDisabled: index === 0 && !canUserModifyOverview || !assignedSample.assigned
        }));
    })));
};
const $3a0f5e44c015da7e$var$Container = (0, $lmFrL.default).div``;
const $3a0f5e44c015da7e$var$Title = (0, $lmFrL.default).div`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;
const $3a0f5e44c015da7e$var$SamplesContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const $3a0f5e44c015da7e$var$Row = (0, $lmFrL.default).div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;
const $3a0f5e44c015da7e$var$SubContainer = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const $3a0f5e44c015da7e$var$SampleName = (0, $lmFrL.default).div`
  margin-top: 1px;
`;
const $3a0f5e44c015da7e$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  min-width: 260px;
`;



const $6a0b62294ea09dcb$export$e75be3c606a9ff1a = (project, userId, userRole)=>{
    const filteredByUserExistenceInSamples = project.samples.filter((sample)=>sample.assignedUsers?.find((user)=>user?.id === userId));
    return project.samples.map((sample)=>{
        const { id: id } = sample;
        const name = (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample);
        if (!filteredByUserExistenceInSamples.length) return {
            id: id,
            name: name,
            assigned: true,
            userId: userId,
            role: userRole
        };
        if (!sample?.assignedUsers?.length) return {
            id: id,
            name: name,
            assigned: false,
            userId: userId,
            role: userRole
        };
        const foundUser = sample.assignedUsers.find((assignedUser)=>assignedUser?.id === userId);
        return {
            id: id,
            name: name,
            assigned: !!foundUser,
            userId: userId,
            role: foundUser?.role || userRole
        };
    });
};



const $6af6853a9ae7530e$export$2f12885fd8f8cc40 = (props)=>{
    const { projectId: projectId, isOpen: isOpen, onClose: onClose, user: user } = props;
    const { user: authUser } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const [assignedSamples, setAssignedSamples] = (0, $acw62.useState)([]);
    const [canUserModifyOverview, setCanUserModifyOverview] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const { error: error, loading: loading, data: data, refetch: refetch } = (0, $7608a8bbcbbad14c$export$cd78c08812e76862)({
        variables: {
            id: projectId
        }
    });
    const [updateUserSamplesAssignmentInProjectMutation] = (0, $7608a8bbcbbad14c$export$23193118be2a0f4e)();
    (0, $acw62.useEffect)(()=>{
        if (data?.ProjectWithAllSamples) setAssignedSamples((0, $6a0b62294ea09dcb$export$e75be3c606a9ff1a)(data.ProjectWithAllSamples, user.id, user.role));
    }, [
        data
    ]);
    (0, $acw62.useEffect)(()=>{
        if (data?.ProjectWithAllSamples) {
            const userRoles = authUser["https://leaderneplatform.com/roles"];
            if (userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR) || userRoles.includes((0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR)) {
                setCanUserModifyOverview(true);
                return;
            }
            const test = (0, $6a0b62294ea09dcb$export$e75be3c606a9ff1a)(data.ProjectWithAllSamples, authUser.sub || "", userRoles[0]);
            if (test.length > 0 && (!test[0].assigned || test[0].role === (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).READONLY || test[0].role === (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST)) {
                setCanUserModifyOverview(false);
                return;
            }
            setCanUserModifyOverview(true);
        }
    }, [
        data,
        user.id
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    });
    const onCheckboxChange = (sampleId, assigned)=>{
        setAssignedSamples((prevAssignedSamples)=>prevAssignedSamples.map((prevAssignedSample)=>{
                if (prevAssignedSample.id === sampleId) return {
                    ...prevAssignedSample,
                    assigned: assigned
                };
                return prevAssignedSample;
            }));
    };
    const onDropdownChange = (sampleId, role)=>{
        setAssignedSamples((prevAssignedSamples)=>prevAssignedSamples.map((prevAssignedSample)=>{
                if (prevAssignedSample.id === sampleId) return {
                    ...prevAssignedSample,
                    role: role
                };
                return prevAssignedSample;
            }));
    };
    const onAcceptClick = ()=>{
        const sampleAssignments = assignedSamples.filter((assignedSample)=>assignedSample.assigned).map((filteredAssignedSample)=>{
            return {
                sampleId: filteredAssignedSample.id,
                role: filteredAssignedSample.role
            };
        });
        if (!sampleAssignments.length) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("User must be assigned to at least one sample");
            return;
        }
        setIsLoading(true);
        updateUserSamplesAssignmentInProjectMutation({
            variables: {
                updateUserSamplesAssignmentInProjectInput: {
                    projectId: projectId,
                    sampleAssignments: sampleAssignments,
                    userId: user.id
                }
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                }
            ]
        }).then(()=>{
            refetch().then(()=>{
                setIsLoading(false);
                onClose();
            }).catch((e)=>{
                setIsLoading(false);
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e);
            });
        }).catch((e)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(e);
        });
    };
    const ModalButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6af6853a9ae7530e$var$AcceptButton, {
            label: "Save",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3139a814db547547$export$2b77a92f1a5ad772), {
        id: "assignPathsToUser",
        title: `Assign paths to user: ${user.name}`,
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a0f5e44c015da7e$export$c2e68c538d45a4df), {
        assignedSamples: assignedSamples,
        onCheckboxChange: onCheckboxChange,
        onDropdownChange: onDropdownChange,
        user: user,
        canUserModifyOverview: canUserModifyOverview
    }));
};
const $6af6853a9ae7530e$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;


const $beeee90727a86437$export$eaacc8c92c2783a7 = (_props)=>{
    const [isConfirmationModalRemoveUserOpen, setIsConfirmationModalRemoveUserOpen] = (0, $acw62.useState)(false);
    const [isInviteTeamMemberFormOpen, setIsInviteTeamMemberFormOpen] = (0, $acw62.useState)(false);
    const [isPathAccessManagementModal, setIsPathAccessManagementModal] = (0, $acw62.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $acw62.useState)({
        id: "",
        name: "",
        role: ""
    });
    const [currentSearchTerm, setCurrentSearchTerm] = (0, $acw62.useState)("");
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [assignUsersToProjectMutation] = (0, $7608a8bbcbbad14c$export$6a41775256872c83)();
    const [removeUserFromProjectMutation] = (0, $7608a8bbcbbad14c$export$837df83f09477a72)();
    const urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { error: error, loading: loading, data: data, refetch: refetch } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: urlParams.projectId
        }
    });
    const projectsQuery = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)();
    if (error || projectsQuery.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (loading || !data || projectsQuery.loading || !projectsQuery.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projectUsers = data?.ProjectUsers || [];
    const project = projectsQuery.data.Projects.find((projectData)=>projectData.id === urlParams.projectId);
    const searchUsers = ()=>{
        const lowerCasedSearchTerm = currentSearchTerm.toLowerCase();
        return projectUsers.filter((user)=>user?.name.toLowerCase().includes(lowerCasedSearchTerm) || user?.email.toLowerCase().includes(lowerCasedSearchTerm));
    };
    const onInviteNewMember = (selectedUsers)=>{
        const usersAuth0Ids = selectedUsers.map((usr)=>usr.value);
        assignUsersToProjectMutation({
            variables: {
                projectId: urlParams.projectId,
                usersAuth0Ids: usersAuth0Ids
            }
        }).then(()=>{
            setIsInviteTeamMemberFormOpen(false);
            refetch();
        });
    };
    const removeUserFromProjectCallback = (userIdToRemove)=>{
        setIsLoading(true);
        removeUserFromProjectMutation({
            variables: {
                projectId: urlParams.projectId,
                userAuth0Id: userIdToRemove
            }
        }).then(()=>{
            refetch().then(()=>{
                setIsLoading(false);
                setIsConfirmationModalRemoveUserOpen(false);
            }).catch((e)=>{
                setIsLoading(false);
                setIsConfirmationModalRemoveUserOpen(false);
            });
        }).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalRemoveUserOpen(false);
        });
    };
    const getUserRow = (user)=>{
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a2ca5846e673565$export$6c0524ba53950d9f), {
                user: {
                    picture: user.avatar
                }
            }),
            user.name,
            user.email,
            user.group,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$534d24ee1d3c6abf), {
                onClick: ()=>{
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/user-tasks/${user.id}`);
                }
            }, "SHOW ASSIGNED TASKS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$534d24ee1d3c6abf), {
                onClick: ()=>{
                    setSelectedUser({
                        id: user.id,
                        name: user.name,
                        role: user.role
                    });
                    setIsPathAccessManagementModal(true);
                }
            }, "ASSIGN PATHS")),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$b6f8733eca75f512), {
                onClick: ()=>{
                    setSelectedUser({
                        id: user.id,
                        name: user.name,
                        role: user.role
                    });
                    setIsConfirmationModalRemoveUserOpen(true);
                }
            }, "REMOVE")
        ];
    };
    const projectName = (0, $30737cddea16cf18$export$2cd058184eb75757)(project);
    const pageTitle = projectName ? `Project Users for ${projectName}` : "Project Users";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: pageTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($beeee90727a86437$var$ManageTeamContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: "Users with access to the project",
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($beeee90727a86437$var$StyledHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Team members (", projectUsers.length, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($beeee90727a86437$var$StyledButton, {
        label: "ADD USERS TO THIS PROJECT",
        onClick: ()=>{
            setIsInviteTeamMemberFormOpen(true);
        }
    }), isInviteTeamMemberFormOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8b3fdf9efe73528c$export$ba5b4d9fcd6df2f0), {
        isOpen: isInviteTeamMemberFormOpen,
        onAccept: onInviteNewMember,
        onClose: ()=>setIsInviteTeamMemberFormOpen(false)
    }), isConfirmationModalRemoveUserOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalRemoveUserOpen,
        message: `Are you sure you want to remove ${selectedUser.name} from this project?`,
        title: "Confirmation",
        yesButtonText: "Remove this user",
        closeModal: ()=>setIsConfirmationModalRemoveUserOpen(false),
        acceptModal: ()=>{
            removeUserFromProjectCallback(selectedUser.id);
        },
        isLoading: isLoading
    }), isPathAccessManagementModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6af6853a9ae7530e$export$2f12885fd8f8cc40), {
        projectId: urlParams.projectId,
        isOpen: isPathAccessManagementModal,
        user: selectedUser,
        onClose: ()=>{
            setIsPathAccessManagementModal(false);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($beeee90727a86437$var$StyledDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($beeee90727a86437$var$StyledSearchBar, {
        key: "user-searchbar",
        value: currentSearchTerm,
        placeholder: "Search by name or email",
        onChange: (e)=>setCurrentSearchTerm(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f313ca9eed73129$export$54ec01a60f47d33d), {
        columns: [
            "",
            "User",
            "E-mail",
            "Group",
            "Actions",
            "Remove user"
        ]
    }, searchUsers().map((user)=>getUserRow(user))))));
};
const $beeee90727a86437$var$StyledSearchBar = (0, $lmFrL.default)((0, $77508f0e0a787542$export$e1f706e5673fef9e))`
  width: 205px;
  height: 48px;
  box-shadow: 0 1px 2px 0 rgba(220, 222, 229, 0.3);
  background-color: #ffffff;
`;
const $beeee90727a86437$var$StyledHeader = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  flex-grow: 0;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.36px;
  text-align: left;
  color: #232f3c;
`;
const $beeee90727a86437$var$StyledDiv = (0, $lmFrL.default).div`
  display: flex;
  margin-bottom: 20px;
`;
const $beeee90727a86437$var$StyledButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  width: 250px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #3b79d1;
`;
const $beeee90727a86437$var$ManageTeamContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $45fvw = parcelRequire("45fvw");







const $64a8c7fab4187453$export$2e52b39ca0c7f0bb = (_props)=>{
    const queryResult = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)();
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = queryResult.data.Projects || [];
    const projectsLength = projects.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Project Users"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46874718c32701e4$export$2146da21c23d5853), {
        projectsNumber: projectsLength
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a8c7fab4187453$var$ManageTeamsContainer, null, projects.map((project)=>{
        const projectLastActivityDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(project.lastActivity ? parseInt(project.lastActivity, 10) : undefined).format("Do MMMM YYYY");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0088b6913e751ef0$export$b3ae466e79cecc68), {
            key: project.id,
            projectLastActivity: projectLastActivityDateString,
            projectName: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            currentService: project.currentService,
            onClick: ()=>{
                (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/manage-team/${project.id}/`);
            }
        });
    })));
};
const $64a8c7fab4187453$var$ManageTeamsContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");











const $75bea24b7ba94747$export$7b8ace970730ea90 = (_props)=>{
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    const queryResult = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)();
    const [addGroup, addGroupMutationResult] = (0, $7608a8bbcbbad14c$export$f23694eacea18d28)({
        refetchQueries: [
            "Groups"
        ]
    });
    const [removeGroup] = (0, $7608a8bbcbbad14c$export$77e9bf9ca24c589f)();
    const [editGroupName] = (0, $7608a8bbcbbad14c$export$5503f1fae3915a76)();
    const [newGroupName, setNewGroupName] = (0, $acw62.useState)("");
    const [selectedGroup, setSelectedGroup] = (0, $acw62.useState)();
    const [isConfirmationModalForRemoveGroupOpen, setIsConfirmationModalForRemoveGroupOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", queryResult.error);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const groupsData = queryResult.data.Groups;
    const removeGroupCallback = (groupId)=>{
        setLoading(true);
        removeGroup({
            variables: {
                groupId: groupId
            },
            refetchQueries: [
                "Groups"
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setLoading(false);
            setIsConfirmationModalForRemoveGroupOpen(false);
        }).catch((e)=>{
            setLoading(false);
            setIsConfirmationModalForRemoveGroupOpen(false);
        });
    };
    const editGroupNameCallback = (groupId, name)=>{
        editGroupName({
            variables: {
                groupId: groupId,
                name: name
            },
            refetchQueries: [
                "Groups"
            ],
            awaitRefetchQueries: true
        });
    };
    const handleOnBlur = (e, groupId)=>{
        editGroupNameCallback(groupId, e.target.innerText);
    };
    const getGroupRow = (group)=>{
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$NameDescriptionTextAreaContainer, {
                contentEditable: true,
                suppressContentEditableWarning: true,
                editMode: true,
                onBlur: (e)=>handleOnBlur(e, group.id),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") event.preventDefault();
                },
                "data-placeholder-name": "Enter a name..."
            }, group.name),
            group.members.length,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$534d24ee1d3c6abf), {
                onClick: ()=>{
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/manage-groups/${group.id}`);
                }
            }, "SHOW MEMBERS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$534d24ee1d3c6abf), {
                onClick: ()=>{
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/group-tasks/${group.id}`);
                }
            }, "SHOW ASSIGNED TASKS")),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$b6f8733eca75f512), {
                onClick: ()=>{
                    setSelectedGroup(group);
                    setIsConfirmationModalForRemoveGroupOpen(true);
                }
            }, "REMOVE")
        ];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Manage Teams and Equipment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$ManageGroupsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: "Manage Groups",
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$StyledHeader, null, "Teams and equipment groups (", groupsData.length, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$StyledDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$StyledInput, {
        key: "add-group",
        value: newGroupName,
        placeholder: "Name of the new group",
        onChange: (e)=>setNewGroupName(e.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($75bea24b7ba94747$var$StyledButton, {
        disabled: !newGroupName.length || addGroupMutationResult.loading,
        label: "ADD",
        type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
        onClick: ()=>{
            addGroup({
                variables: {
                    name: newGroupName
                }
            }).then(()=>setNewGroupName(""));
        }
    })), isConfirmationModalForRemoveGroupOpen && selectedGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveGroupOpen,
        message: `Are you sure you want to remove this group? (${selectedGroup.name})`,
        title: "Confirmation",
        yesButtonText: "Remove this group",
        closeModal: ()=>setIsConfirmationModalForRemoveGroupOpen(false),
        acceptModal: ()=>{
            removeGroupCallback(selectedGroup.id);
        },
        isLoading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f313ca9eed73129$export$54ec01a60f47d33d), {
        columns: [
            "Groups",
            "Members",
            "Actions",
            "Remove group"
        ],
        isEditable: true
    }, groupsData.map((group)=>getGroupRow(group))))));
};
const $75bea24b7ba94747$var$StyledButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  width: 78px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin: 42px 205px 2px 24px;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #3b79d1;
`;
const $75bea24b7ba94747$var$StyledDiv = (0, $lmFrL.default).div`
  display: flex;
  margin-bottom: 20px;
`;
const $75bea24b7ba94747$var$StyledInput = (0, $lmFrL.default)((0, $77508f0e0a787542$export$e1f706e5673fef9e))`
  width: 205px;
  max-height: 48px;
  margin: 40px 12px 0 0;
  padding: 0 16px;
  box-shadow: 0 1px 2px 0 rgba(220, 222, 229, 0.3);
  background-color: #ffffff;
  font-size: 15px;
  line-height: 15px;
`;
const $75bea24b7ba94747$var$StyledHeader = (0, $lmFrL.default).div`
  width: 400px;
  height: 24px;
  flex-grow: 0;
  font-family: Overpass, serif;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.36px;
  text-align: left;
  color: #232f3c;
`;
const $75bea24b7ba94747$var$ManageGroupsContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
const $75bea24b7ba94747$var$NameDescriptionTextAreaContainer = (0, $lmFrL.default).div`
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 3px 18px 3px 3px;
  overflow-wrap: break-word;
  text-transform: none;
  white-space: pre-wrap;

  &:empty::before {
    content: attr(data-placeholder-name);
    color: #ccc;
    font-weight: 400;
  }

  &:empty:focus::before {
    content: "";
  }

  &::after {
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M0.5 8.75V6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967L5.96967 0.71967C6.26256 0.426777 6.73744 0.426777 7.03033 0.71967L9.28033 2.96967C9.57322 3.26256 9.57322 3.73744 9.28033 4.03033L4.03033 9.28033C3.88968 9.42098 3.69891 9.5 3.5 9.5H1.25C0.835786 9.5 0.5 9.16421 0.5 8.75ZM6.5 2.3107L2 6.8107V8.00004H3.18934L7.68934 3.50004L6.5 2.3107Z' fill='gray' /%3E%3C/svg%3E");
    margin-left: 8px;
    width: 10px;
    height: 10px;
    position: absolute;
    cursor: text;
    display: inline;
    white-space: nowrap;
  }

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      min-width: calc(100% - 25px);
      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `}
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $f1q41 = parcelRequire("f1q41");




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



const $43663afd1f3d6b81$export$bd92744a3d7f1c24 = ({ children: children, pageTitle: pageTitle = "Welcome", tabs: tabs })=>/*#__PURE__*/ $acw62.createElement($43663afd1f3d6b81$var$Wrapper, null, /*#__PURE__*/ $acw62.createElement((0, $893bf6ab15cfafd6$export$614264b7ca4804e6), null), /*#__PURE__*/ $acw62.createElement($43663afd1f3d6b81$var$Main, null, /*#__PURE__*/ $acw62.createElement((0, $193714fcc8f30367$export$8b251419efc915eb), {
        pageTitle: pageTitle
    }), /*#__PURE__*/ $acw62.createElement($43663afd1f3d6b81$var$NavWrapper, null, tabs && /*#__PURE__*/ $acw62.createElement($43663afd1f3d6b81$var$NavigationTabs, null, tabs)), /*#__PURE__*/ $acw62.createElement($43663afd1f3d6b81$var$ChildrenContainer, null, children)));
const $43663afd1f3d6b81$var$Wrapper = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  min-height: 100vh;
`;
const $43663afd1f3d6b81$var$NavWrapper = (0, $lmFrL.default).div`
  min-height: 36px;
  width: 100%;
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $43663afd1f3d6b81$var$NavigationTabs = (0, $lmFrL.default).div`
  margin: 0 auto;
  width: 100%;
  max-width: ${(p)=>p.theme.maxContentWidth};
  background-color: ${(p)=>p.theme.newColors.grayscale.white};
`;
const $43663afd1f3d6b81$var$Main = (0, $lmFrL.default)((0, $781e22e9ef9a0015$exports.Flex))`
  width: 100%;
  flex-direction: column;
  background-color: ${(p)=>p.theme.newColors.grayscale.background};
`;
const $43663afd1f3d6b81$var$ChildrenContainer = (0, $lmFrL.default).div`
  flex-grow: 1;
`;









const $a378f934e49c61cf$export$8be927c321cf81c8 = (// eslint-disable-next-line @typescript-eslint/no-unused-vars
_props)=>{
    const urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { sideDrawboardOpen: sideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$9afe1cfbd00e459)({
        variables: {
            userId: urlParams.userId
        }
    });
    const { error: allUsersError, loading: allUsersLoading, data: allUsersData } = (0, $7608a8bbcbbad14c$export$7ccb685555ff35d8)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (allUsersError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", allUsersError);
    if (loading || !data || allUsersLoading || !allUsersData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const allUsers = allUsersData.ListUsers || [];
    const userAssigned = (0, $f1q41.cloneDeep)(allUsers.find((user)=>user?.id === urlParams.userId));
    const sample = data.ServicesAssignedToUserForTimeline;
    if (!sample) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    let sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE) {
        const parentEnabledWorkflow = sample.enabledWorkflows.find((w)=>w.id === selectedEntity.selectedElementPath.workflowId);
        sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bfdf1fd4865de13$export$ebe32a73fdce612e), {
            parentEnabledWorkflow: parentEnabledWorkflow,
            editMode: false,
            hardcodedUser: userAssigned
        });
    } else if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW) sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7ee36a6b693e63b$export$793bea54b89939f3), {
        editMode: false,
        hardcodedUser: userAssigned
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $43663afd1f3d6b81$export$bd92744a3d7f1c24), {
        pageTitle: `Tasks assigned to ${userAssigned?.name}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a378f934e49c61cf$var$ManageTeamUserContainer, null, sample.enabledWorkflows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a378f934e49c61cf$var$StyledTimeline, {
        sample: sample,
        projectId: "tasksAssignedView",
        hideAddIcon: true,
        height: "calc(100vh - 96px - 36px - 9px)",
        width: `calc(100% - ${sideDrawboardOpen ? "337px" : "72px"})`,
        disableDnD: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a378f934e49c61cf$var$UserIsNotAssigned, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        label: "Selected user is currently not assigned to any task"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a378f934e49c61cf$var$StyledSideDrawboard, null, sideDrawboardContent)));
};
const $a378f934e49c61cf$var$ManageTeamUserContainer = (0, $lmFrL.default).div`
  display: flex;
`;
const $a378f934e49c61cf$var$StyledTimeline = (0, $lmFrL.default)((0, $ff8a3318298de872$export$e6a97ba2cae5bb94))`
  border-top: 2px solid #dedede;
`;
const $a378f934e49c61cf$var$UserIsNotAssigned = (0, $lmFrL.default).div`
  padding: 2rem;
`;
const $a378f934e49c61cf$var$StyledSideDrawboard = (0, $lmFrL.default)((0, $9b46390a7c7d7753$export$7280240986cdf65a))`
  border-top: 2px solid #dedede;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");











const $19391a46fe0246aa$export$c3db4313253f3d7e = (_props)=>{
    const [currentSearchTerm, setCurrentSearchTerm] = (0, $acw62.useState)("");
    const [isInviteGroupMemberFormOpen, setIsInviteGroupMemberFormOpen] = (0, $acw62.useState)(false);
    const urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$2316695f7398010a)({
        variables: {
            groupId: urlParams.groupId
        }
    });
    const [addUsersToGroup] = (0, $7608a8bbcbbad14c$export$28537ac6612cfa4d)();
    const [removeUserFromGroup] = (0, $7608a8bbcbbad14c$export$b38500b13d54dd7a)();
    const [selectedMember, setSelectedMember] = (0, $acw62.useState)();
    const [isConfirmationModalForRemoveMemberOpen, setIsConfirmationModalForRemoveMemberOpen] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const onAddUserToGroup = (selectedUsers)=>{
        const usersIds = selectedUsers.map((usr)=>usr.value);
        setIsInviteGroupMemberFormOpen(false);
        addUsersToGroup({
            variables: {
                groupId: urlParams.groupId,
                usersIds: usersIds
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$45949515a9e7498d),
                    variables: {
                        groupId: urlParams.groupId
                    }
                },
                "Groups"
            ],
            awaitRefetchQueries: true
        });
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const searchMembers = ()=>{
        const lowerCasedSearchTerm = currentSearchTerm.toLowerCase();
        return data.Group.members.filter((user)=>user?.name.toLowerCase().includes(lowerCasedSearchTerm) || user?.email?.toLowerCase().includes(lowerCasedSearchTerm));
    };
    const getMembersRow = (member, index)=>{
        return [
            index + 1,
            member.name,
            member.email,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$b6f8733eca75f512), {
                onClick: ()=>{
                    setSelectedMember(member);
                    setIsConfirmationModalForRemoveMemberOpen(true);
                }
            }, "REMOVE")
        ];
    };
    const removeMemberFromGroupCallback = (userId)=>{
        setIsLoading(true);
        removeUserFromGroup({
            variables: {
                groupId: urlParams.groupId,
                userId: userId
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$45949515a9e7498d),
                    variables: {
                        groupId: urlParams.groupId
                    }
                },
                "Groups"
            ],
            awaitRefetchQueries: true
        }).then(()=>{
            setIsLoading(false);
            setIsConfirmationModalForRemoveMemberOpen(false);
        }).catch((e)=>{
            setIsLoading(false);
            setIsConfirmationModalForRemoveMemberOpen(false);
        });
    };
    const groupName = data.Group.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Manage members"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$ManageTeamContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: `Manage group members for group ${groupName}`,
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$StyledHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Group members (", data.Group.members.length, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$StyledButton, {
        label: "ADD USERS TO THIS GROUP",
        onClick: ()=>{
            setIsInviteGroupMemberFormOpen(true);
        }
    }), isInviteGroupMemberFormOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8b3fdf9efe73528c$export$ba5b4d9fcd6df2f0), {
        isOpen: isInviteGroupMemberFormOpen,
        onAccept: onAddUserToGroup,
        onClose: ()=>setIsInviteGroupMemberFormOpen(false)
    }), isConfirmationModalForRemoveMemberOpen && selectedMember && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isConfirmationModalForRemoveMemberOpen,
        message: `Are you sure you want to remove ${selectedMember.name} from this group?`,
        title: "Confirmation",
        yesButtonText: "Remove this member",
        closeModal: ()=>setIsConfirmationModalForRemoveMemberOpen(false),
        acceptModal: ()=>{
            removeMemberFromGroupCallback(selectedMember.id);
        },
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$StyledDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$StyledSearchBar, {
        key: "user-searchbar",
        value: currentSearchTerm,
        placeholder: "Search by name or email",
        onChange: (e)=>setCurrentSearchTerm(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f313ca9eed73129$export$54ec01a60f47d33d), {
        columns: [
            "No.",
            "Name",
            "E-mail",
            "Remove user"
        ]
    }, searchMembers().map((m, idx)=>getMembersRow(m, idx))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$MarginTop, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($19391a46fe0246aa$var$StyledButton, {
        label: "Go back to groups list",
        onClick: ()=>{
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/manage-groups`);
        }
    })))));
};
const $19391a46fe0246aa$var$StyledSearchBar = (0, $lmFrL.default)((0, $77508f0e0a787542$export$e1f706e5673fef9e))`
  width: 205px;
  height: 48px;
  box-shadow: 0 1px 2px 0 rgba(220, 222, 229, 0.3);
  background-color: #ffffff;
`;
const $19391a46fe0246aa$var$StyledHeader = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  flex-grow: 0;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.36px;
  text-align: left;
  color: #232f3c;
`;
const $19391a46fe0246aa$var$StyledDiv = (0, $lmFrL.default).div`
  display: flex;
  margin-bottom: 20px;
`;
const $19391a46fe0246aa$var$MarginTop = (0, $lmFrL.default).div`
  margin-top: 20px;
`;
const $19391a46fe0246aa$var$ManageTeamContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
const $19391a46fe0246aa$var$StyledButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  width: 250px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #3b79d1;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");









var $acw62 = parcelRequire("acw62");
const $901a6d4132c341a7$export$d2c72b688139a728 = (props)=>{
    const { color: color, width: width, height: height } = props;
    return /*#__PURE__*/ $acw62.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: `0 0 ${width} ${height}`
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: color,
        d: "M0.5 8.75V6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967L5.96967 0.71967C6.26256 0.426777 6.73744 0.426777 7.03033 0.71967L9.28033 2.96967C9.57322 3.26256 9.57322 3.73744 9.28033 4.03033L4.03033 9.28033C3.88968 9.42098 3.69891 9.5 3.5 9.5H1.25C0.835786 9.5 0.5 9.16421 0.5 8.75ZM6.5 2.3107L2 6.8107V8.00004H3.18934L7.68934 3.50004L6.5 2.3107Z"
    }));
};
$901a6d4132c341a7$export$d2c72b688139a728.defaultProps = {
    width: "10",
    height: "10",
    color: "#6E7D92"
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");






const $20506dc64ebe4dd3$export$62be8347329e419b = (props)=>{
    const { isOpen: isOpen, onClose: onClose, user: user } = props;
    const [selectedRole, setSelectedRole] = (0, $acw62.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    if (!user) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const { error: error, loading: loading, data: rolesData } = (0, $7608a8bbcbbad14c$export$b1b197b2cf928d0d)();
    const [editUserRoleMutation] = (0, $7608a8bbcbbad14c$export$a873320c9f4661dd)();
    const onAcceptClick = ()=>{
        if (!selectedRole || !user.id || selectedRole.value === user.roleId) {
            onClose();
            return;
        }
        setIsLoading(true);
        editUserRoleMutation({
            variables: {
                auth0UserId: user.id,
                auth0RoleId: selectedRole.value
            },
            refetchQueries: [
                {
                    query: (0, $7608a8bbcbbad14c$export$fb02ec9bb49fb8b2)
                }
            ]
        }).then(()=>{
            setIsLoading(false);
            onClose();
        }).catch((e)=>{
            setIsLoading(false);
            onClose();
        });
    };
    const ModalButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($20506dc64ebe4dd3$var$AcceptButton, {
            disabled: isLoading,
            label: "Assign role",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Primary,
            onClick: onAcceptClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
            disabled: isLoading,
            label: "Cancel",
            type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
            onClick: onClose
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (rolesData?.GetAuth0Roles) {
            const roleToSet = rolesData.GetAuth0Roles.find((role)=>role.id === user.roleId);
            if (!roleToSet) return;
            setSelectedRole({
                label: roleToSet.name,
                value: roleToSet.id
            });
        }
    }, [
        rolesData
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading || !rolesData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    });
    const getOptions = ()=>{
        return rolesData.GetAuth0Roles.map((role)=>({
                value: role.id,
                label: role.name
            }));
    };
    if (!isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($20506dc64ebe4dd3$var$StyledModal, {
        id: "assignRoleModal",
        title: `Assign role to user: ${user.name}`,
        footerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalButtons, null),
        onClose: onClose,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($20506dc64ebe4dd3$var$StyledDropdown, {
        closeMenuOnSelect: true,
        value: selectedRole,
        options: getOptions(),
        onChange: (option)=>setSelectedRole(option),
        placeholder: "Select role"
    }));
};
const $20506dc64ebe4dd3$var$StyledModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  .customModalDialog {
    max-width: 55%;
  }
`;
const $20506dc64ebe4dd3$var$AcceptButton = (0, $lmFrL.default)((0, $d16295188a465402$export$353f5b6fc5456de1))`
  margin-right: 10px;
`;
const $20506dc64ebe4dd3$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  width: 100%;
`;


const $e6556986845d7d1c$export$3caac47e16448199 = (_props)=>{
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    const queryResult = (0, $7608a8bbcbbad14c$export$7ccb685555ff35d8)();
    const [editUserName] = (0, $7608a8bbcbbad14c$export$e345caa1b41e7c31)();
    const { data: groupsQueryResult } = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)();
    const { data: projectstQueryResult } = (0, $7608a8bbcbbad14c$export$5fb71c15210980be)();
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", queryResult.error);
    if (queryResult.loading || !queryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const usersData = queryResult.data && queryResult.data.ListUsers || [];
    const editUserNameCallback = (auth0UserId, name)=>{
        const projectWithUser = projectstQueryResult?.Projects.filter((project)=>project.users.find((user)=>user.id === auth0UserId));
        const groupsWithUser = groupsQueryResult?.Groups?.filter((group)=>group.members.find((member)=>member === auth0UserId));
        const queriesGroupMembers = groupsWithUser && groupsWithUser.length > 0 ? groupsWithUser.map((group)=>({
                query: (0, $7608a8bbcbbad14c$export$45949515a9e7498d),
                variables: {
                    groupId: group.id
                }
            })) : [];
        const queriesProjectUsers = projectWithUser && projectWithUser.length > 0 ? projectWithUser.map((project)=>({
                query: (0, $7608a8bbcbbad14c$export$da25fac6b1252285),
                variables: {
                    projectId: project.id
                }
            })) : [];
        editUserName({
            variables: {
                auth0UserId: auth0UserId,
                name: name
            },
            refetchQueries: [
                "ListUsers",
                ...queriesGroupMembers,
                ...queriesProjectUsers
            ],
            awaitRefetchQueries: true
        });
    };
    const getUserRow = (user)=>{
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a2ca5846e673565$export$6c0524ba53950d9f), {
                user: {
                    picture: user.avatar
                }
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e6556986845d7d1c$var$NameDescriptionTextAreaContainer, {
                contentEditable: true,
                suppressContentEditableWarning: true,
                editMode: true,
                spellCheck: false,
                onBlur: (e)=>editUserNameCallback(user.id, e.target.innerText),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") event.preventDefault();
                },
                "data-placeholder-name": "Enter a username..."
            }, user.name),
            user.email,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e6556986845d7d1c$var$RoleContainer, {
                onClick: ()=>{
                    setSelectedUser({
                        id: user.id,
                        name: user.name,
                        roleId: user.role?.id
                    });
                    setIsModalOpen(true);
                }
            }, user.role?.name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $901a6d4132c341a7$export$d2c72b688139a728), null)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$4dfa824a445e350c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fa05356ae0b1c49$export$534d24ee1d3c6abf), {
                onClick: ()=>{
                    (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/user-tasks/${user.id}`);
                }
            }, "SHOW ASSIGNED TASKS"))
        ];
    };
    if (!usersData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Manage Users"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e6556986845d7d1c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: "All Users",
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e6556986845d7d1c$var$StyledHeader, null, "Number of users: ", usersData.length), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f313ca9eed73129$export$54ec01a60f47d33d), {
        columns: [
            "",
            "User",
            "E-mail",
            "Role",
            "Actions"
        ],
        isEditable: true
    }, usersData.map((user)=>getUserRow(user)))))), isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $20506dc64ebe4dd3$export$62be8347329e419b), {
        isOpen: isModalOpen,
        onClose: ()=>setIsModalOpen(false),
        user: selectedUser
    }));
};
const $e6556986845d7d1c$var$StyledHeader = (0, $lmFrL.default).div`
  width: 400px;
  height: 24px;
  flex-grow: 0;
  font-family: Overpass, serif;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.36px;
  text-align: left;
  color: #232f3c;
`;
const $e6556986845d7d1c$var$Container = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
const $e6556986845d7d1c$var$RoleContainer = (0, $lmFrL.default).div`
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
`;
const $e6556986845d7d1c$var$NameDescriptionTextAreaContainer = (0, $lmFrL.default).div`
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 3px 18px 3px 3px;
  overflow-wrap: break-word;
  text-transform: none;
  white-space: pre-wrap;

  &:empty::before {
    content: attr(data-placeholder-name);
    color: #ccc;
    font-weight: 400;
  }
  &:empty:focus::before {
    content: "";
  }

  &::after {
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M0.5 8.75V6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967L5.96967 0.71967C6.26256 0.426777 6.73744 0.426777 7.03033 0.71967L9.28033 2.96967C9.57322 3.26256 9.57322 3.73744 9.28033 4.03033L4.03033 9.28033C3.88968 9.42098 3.69891 9.5 3.5 9.5H1.25C0.835786 9.5 0.5 9.16421 0.5 8.75ZM6.5 2.3107L2 6.8107V8.00004H3.18934L7.68934 3.50004L6.5 2.3107Z' fill='gray' /%3E%3C/svg%3E");
    margin-left: 8px;
    width: 10px;
    height: 10px;
    position: absolute;
    cursor: text;
    display: inline;
    white-space: nowrap;
  }

  ${({ editMode: editMode })=>editMode && (0, $lmFrL.css)`
      min-width: calc(100% - 25px);
      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `}
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $f1q41 = parcelRequire("f1q41");











const $9cb4ff7362db7acf$export$d35e4a97650ed24e = (// eslint-disable-next-line @typescript-eslint/no-unused-vars
_props)=>{
    const urlParams = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { selectedEntity: selectedEntity } = (0, $17ab349cbe2df1af$export$e94ddc405c82c3a0)();
    const { sideDrawboardOpen: sideDrawboardOpen } = (0, $f0b5ad5d8d9b08dd$export$79d854cbcf464eaa)();
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$880ca56a001ec25)({
        variables: {
            groupId: urlParams.groupId
        }
    });
    const { error: allUsersError, loading: allUsersLoading, data: allUsersData } = (0, $7608a8bbcbbad14c$export$7ccb685555ff35d8)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (allUsersError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", allUsersError);
    if (loading || !data || allUsersLoading || !allUsersData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const allUsers = allUsersData.ListUsers || [];
    let userAssigned = {
        id: "unassigned",
        name: "Unassigned",
        avatar: ""
    };
    const sample = data.ServicesAssignedToGroupForTimeline;
    if (!sample) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    let sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).SERVICE) {
        const assignee = selectedEntity.selectedElementPath.service?.assignee;
        if (assignee) {
            const foundUser = (0, $f1q41.cloneDeep)(allUsers.find((user)=>user?.id === assignee));
            if (foundUser) userAssigned = foundUser;
        }
        const parentEnabledWorkflow = sample.enabledWorkflows.find((w)=>w.id === selectedEntity.selectedElementPath.workflowId);
        sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bfdf1fd4865de13$export$ebe32a73fdce612e), {
            parentEnabledWorkflow: parentEnabledWorkflow,
            editMode: false,
            hardcodedUser: userAssigned
        });
    } else if (selectedEntity && selectedEntity.selectedElementType === (0, $d30aef34372d015b$export$ee47ee6cb4ebe8fd).WORKFLOW) sideDrawboardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7ee36a6b693e63b$export$793bea54b89939f3), {
        editMode: false,
        hardcodedUser: userAssigned
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $43663afd1f3d6b81$export$bd92744a3d7f1c24), {
        pageTitle: "Tasks assigned to this group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9cb4ff7362db7acf$var$ManageTeamUserContainer, null, sample.enabledWorkflows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9cb4ff7362db7acf$var$StyledTimeline, {
        sample: sample,
        projectId: "tasksAssignedView",
        hideAddIcon: true,
        height: "calc(100vh - 96px - 36px - 9px)",
        width: `calc(100% - ${sideDrawboardOpen ? "337px" : "72px"})`,
        disableDnD: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9cb4ff7362db7acf$var$UserIsNotAssigned, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1cfb23e53b30236$export$b04be29aa201d4f5), {
        label: "Selected group is currently not contributing to any task"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9cb4ff7362db7acf$var$StyledSideDrawboard, null, sideDrawboardContent)));
};
const $9cb4ff7362db7acf$var$ManageTeamUserContainer = (0, $lmFrL.default).div`
  display: flex;
`;
const $9cb4ff7362db7acf$var$StyledTimeline = (0, $lmFrL.default)((0, $ff8a3318298de872$export$e6a97ba2cae5bb94))`
  border-top: 2px solid #dedede;
`;
const $9cb4ff7362db7acf$var$UserIsNotAssigned = (0, $lmFrL.default).div`
  padding: 2rem;
`;
const $9cb4ff7362db7acf$var$StyledSideDrawboard = (0, $lmFrL.default)((0, $9b46390a7c7d7753$export$7280240986cdf65a))`
  border-top: 2px solid #dedede;
`;



var $acw62 = parcelRequire("acw62");




const $d57ed483ff218c08$var$accessPathMap = new Map([
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ADMINISTRATOR,
        [
            "*"
        ]
    ],
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).ORGANIZATION_ADMINISTRATOR,
        [
            "*"
        ]
    ],
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).PROJECT_MANAGER,
        [
            "*"
        ]
    ],
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).SPECIALIST,
        [
            (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_CONFIGURATOR,
            (0, $de08facaa603a546$export$cd891b82501bb412).SAMPLE_CONFIGURATOR,
            (0, $de08facaa603a546$export$cd891b82501bb412).REPORTS,
            (0, $de08facaa603a546$export$cd891b82501bb412).REPORT
        ]
    ],
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).REGULATORY,
        [
            (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY,
            (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING
        ]
    ],
    [
        (0, $471f4ec605b8e2c9$export$d1cfdc29cbc61821).READONLY,
        []
    ]
]);
const $d57ed483ff218c08$export$f01b3d7c7bbe3997 = (props)=>{
    const { route: Component, path: path } = props;
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const userRoles = user["https://leaderneplatform.com/roles"] || [];
    const availablePaths = userRoles.map((role)=>$d57ed483ff218c08$var$accessPathMap.get(role) || []).reduce((accPaths, paths)=>[
            ...new Set([
                ...accPaths,
                ...paths
            ])
        ], []);
    const accessToPath = availablePaths?.includes("*") || availablePaths?.includes(path);
    if (accessToPath) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
        path: path
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f96e1a178b2fcf1d$export$23191e4434a9e834), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).WELCOME,
        default: true
    });
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $d280eed38b07656f$export$f6a08e5e4e44ec47 = (props)=>{
    const { projectId: projectId } = props;
    const [users, setUsers] = (0, $acw62.useState)([]);
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (!data?.ProjectUsers) return;
        const usersToSet = data.ProjectUsers.map((user)=>{
            return {
                id: user?.id || "",
                name: user?.name || user?.email || "",
                email: user?.email || "",
                role: user?.role || "",
                avatar: user?.avatar || ""
            };
        });
        setUsers(usersToSet);
    }, [
        data
    ]);
    return {
        users: users,
        error: error,
        loading: loading || !data
    };
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $57e3f04af4700914$export$9f2731c1db586d53 = (props)=>{
    const { title: title, headerComponent: headerComponent, className: className } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57e3f04af4700914$var$Header, {
        className: className
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57e3f04af4700914$var$Title, null, title), headerComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57e3f04af4700914$var$Title, null, headerComponent), !title && !headerComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57e3f04af4700914$var$DragIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8248918e189a913b$export$67396e133708350c), null)));
};
const $57e3f04af4700914$var$Header = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border: 1px solid #dedede;
  padding: 16px 24px 12px 24px;
  height: 55px;
  max-height: 55px;
  box-sizing: border-box;
  background-color: white;
  width: 568px;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;
const $57e3f04af4700914$var$Title = (0, $lmFrL.default).div`
  font-weight: bold;
`;
const $57e3f04af4700914$var$DragIconContainer = (0, $lmFrL.default).div`
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;

  &:hover > svg > circle {
    transition: 200ms;
    fill: #1856c0;
  }
`;


const $2218edc180268acc$export$b9b108b497733374 = (props)=>{
    const { title: title, children: children, loading: loading, headerComponent: headerComponent } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2218edc180268acc$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2218edc180268acc$var$StyledBlockHeader, {
        title: title,
        headerComponent: headerComponent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2218edc180268acc$var$ChildrenContainer, null, children), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2218edc180268acc$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        containerSize: true,
        opaque: true
    })));
};
const $2218edc180268acc$var$StyledBlockHeader = (0, $lmFrL.default)((0, $57e3f04af4700914$export$9f2731c1db586d53))`
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
const $2218edc180268acc$var$Container = (0, $lmFrL.default).div`
  width: 570px;
  height: 339px;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px #d1d5d8;
  border-radius: 8px;
  position: relative;
  border: 1px solid #dedede;
`;
const $2218edc180268acc$var$ChildrenContainer = (0, $lmFrL.default).div`
  padding: 12px 20px;
  height: 234px;
  overflow: auto;
`;
const $2218edc180268acc$var$SpinnerContainer = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");
const $0455d43c70d0c029$export$790a148a5546e843 = (props)=>{
    const { color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: `0 0 ${width} ${height}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M10.195 13.385H2.644A1.652 1.652 0 011 11.73V1.655C1 .742 1.738 0 2.644 0h15.684a1.65 1.65 0 011.644 1.655v9.348a7.033 7.033 0 013.31 5.96A7.046 7.046 0 0116.245 24c-3.88 0-7.038-3.157-7.038-7.038 0-1.306.365-2.527.988-3.577zm6.05 9.115a5.544 5.544 0 005.537-5.538 5.544 5.544 0 00-5.537-5.538 5.544 5.544 0 00-5.538 5.538 5.544 5.544 0 005.538 5.538zm-4.86-10.615a7.008 7.008 0 014.86-1.96c.779 0 1.526.132 2.227.366V3.244l-7.986 6.19L2.5 3.244v8.486c0 .084.066.155.144.155h8.74zM18.274 1.5H2.698l7.788 6.036L18.274 1.5zm-2.806 14.632l-1.798 1.804-1.198-1.149 3.836-3.846 3.834 3.846-1.197 1.15-1.799-1.805v4.353h-1.678v-4.353z",
        clipRule: "evenodd"
    }));
};
$0455d43c70d0c029$export$790a148a5546e843.defaultProps = {
    width: "24",
    height: "24",
    color: "#4979CB"
};



const $543426d7f2d8bad4$export$74fe99b603ac7125 = (props)=>{
    const { users: users } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$Table, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, users.map((user)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$Row, {
            key: user.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$UserCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$SendMessageContainer, {
            "aria-hidden": true,
            onClick: ()=>{
                window.location.href = `mailto:${user.email}`;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0455d43c70d0c029$export$790a148a5546e843), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$StyledAvatar, {
            user: {
                picture: user.avatar
            }
        }), user.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$RoleCell, null, user.role), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($543426d7f2d8bad4$var$SeeTasksCell, {
            onClick: ()=>{
                (0, $f125bbca2c654db8$export$ff7962acd6052c28)(`/user-tasks/${user.id}`);
            }
        }, "See tasks \u279C"));
    })));
};
const $543426d7f2d8bad4$var$Table = (0, $lmFrL.default).table`
  width: 100%;
  border-collapse: collapse;

  tr:last-child {
    td {
      padding-bottom: 0;
    }
  }
`;
const $543426d7f2d8bad4$var$Row = (0, $lmFrL.default).tr`
  gap: 12px;
  font-size: 12px;

  td {
    padding-bottom: 16px;
  }
`;
const $543426d7f2d8bad4$var$UserCell = (0, $lmFrL.default).td`
  white-space: nowrap;
  width: 1%;

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
const $543426d7f2d8bad4$var$StyledAvatar = (0, $lmFrL.default)((0, $1a2ca5846e673565$export$6c0524ba53950d9f))`
  margin-right: 12px;
`;
const $543426d7f2d8bad4$var$SendMessageContainer = (0, $lmFrL.default).div`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #dedede;
  padding-right: 4px;
  cursor: pointer;

  &:hover > svg > path {
    transition: 200ms;
    fill: #1856c0;
  }
`;
const $543426d7f2d8bad4$var$RoleCell = (0, $lmFrL.default).td`
  text-align: center;
  line-height: 32px;
`;
const $543426d7f2d8bad4$var$SeeTasksCell = (0, $lmFrL.default).td`
  cursor: pointer;
  color: #4979cb;
  padding-bottom: 6px;
  padding-right: 4px;
  text-decoration: underline;
  text-underline-offset: 6px;
  white-space: nowrap;
  width: 1%;

  &:hover {
    transition: 200ms;
    color: #1856c0;
  }
`;


const $c23c5ea6c96b3754$export$20a19277110e1a71 = (props)=>{
    const { projectId: projectId } = props;
    const { error: error, loading: loading, users: users } = (0, $d280eed38b07656f$export$f6a08e5e4e44ec47)({
        projectId: projectId
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2218edc180268acc$export$b9b108b497733374), {
        title: "Team",
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $543426d7f2d8bad4$export$74fe99b603ac7125), {
        users: users
    }));
};






var $acw62 = parcelRequire("acw62");


const $943534f4fbe55ce2$export$bc2f3c415e4383ee = ()=>{
    const [selectedProject, setSelectedProject] = (0, $acw62.useState)({
        label: "",
        value: ""
    });
    const [projects, setProjects] = (0, $acw62.useState)([]);
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$51199fd5d18fce87)();
    (0, $acw62.useEffect)(()=>{
        if (!data?.Projects) return;
        const projectsToSet = data.Projects.map((project)=>({
                value: project.id,
                label: (0, $30737cddea16cf18$export$2cd058184eb75757)(project)
            }));
        setProjects(projectsToSet);
        setSelectedProject(projectsToSet[0]);
    }, [
        data
    ]);
    return {
        selectedProject: selectedProject,
        setSelectedProject: setSelectedProject,
        projects: projects,
        error: error,
        loading: loading || !data || projects.length === 0
    };
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");


const $c868d9146d506459$export$2822d76efe8c447e = (props)=>{
    const { projectId: projectId } = props;
    const [selectedSample, setSelectedSample] = (0, $acw62.useState)({
        label: "",
        value: ""
    });
    const [samples, setSamples] = (0, $acw62.useState)([]);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [groups, setGroups] = (0, $acw62.useState)([]);
    const [workflows, setWorkflows] = (0, $acw62.useState)([]);
    const { error: errorProject, loading: loadingProject, data: dataProject } = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: projectId
        }
    });
    const { error: errorUsers, loading: loadingUsers, data: dataUsers } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        }
    });
    const { error: errorGroups, loading: loadingGroups, data: dataGroups } = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)();
    (0, $acw62.useEffect)(()=>{
        if (!dataProject?.Project) return;
        setSamples(dataProject.Project.samples);
        if (dataProject.Project.samples.length > 0) setSelectedSample({
            label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(dataProject.Project.samples[0]),
            value: dataProject.Project.samples[0].id
        });
    }, [
        dataProject
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dataUsers?.ProjectUsers) return;
        const usersToSet = dataUsers.ProjectUsers.map((user)=>{
            return {
                id: user?.id || "",
                name: user?.name || user?.email || "",
                email: user?.email || "",
                role: user?.role || "",
                avatar: user?.avatar || ""
            };
        });
        setUsers(usersToSet);
    }, [
        dataUsers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dataGroups?.Groups) return;
        setGroups(dataGroups.Groups);
    }, [
        dataGroups
    ]);
    (0, $acw62.useEffect)(()=>{
        const foundSample = samples.find((sample)=>sample.id === selectedSample.value);
        if (!foundSample) return;
        setWorkflows(foundSample.enabledWorkflows);
    }, [
        selectedSample
    ]);
    return {
        selectedSample: selectedSample,
        setSelectedSample: setSelectedSample,
        samples: samples,
        users: users,
        groups: groups,
        workflows: workflows,
        error: errorProject || errorUsers || errorGroups,
        loading: loadingProject || !dataProject || loadingUsers || !dataUsers || loadingGroups || !dataGroups
    };
};






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $e387141087877de7$export$47130d0982a49524 = (props)=>{
    const { tasks: tasks } = props;
    const getGroupInitials = (groupName)=>groupName.split(" ").map((text)=>text[0]).join("").slice(0, 2).toUpperCase();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$Table, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, tasks.map((task)=>task.subtasks.map((subtask)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$Row, {
                key: subtask.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
                color: task.color
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, task.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$TaskNowContainer, null, subtask.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$UsersContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, subtask.assignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$StyledAvatar, {
                user: {
                    picture: subtask.assignee
                }
            }), subtask.collaborators && subtask.collaborators.map((collaborator, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e387141087877de7$var$GroupAvatar, {
                    style: {
                        zIndex: 99 - index
                    }
                }, getGroupInitials(collaborator.name))))))))));
};
const $e387141087877de7$var$Table = (0, $lmFrL.default).table`
  width: 100%;
  border-collapse: collapse;
`;
const $e387141087877de7$var$Row = (0, $lmFrL.default).tr`
  font-size: 12px;
  height: 55px;
`;
const $e387141087877de7$var$TaskNowContainer = (0, $lmFrL.default).td`
  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 10px;
      color: #9d9ea3;
    }
  }
`;
const $e387141087877de7$var$UsersContainer = (0, $lmFrL.default).td`
  white-space: nowrap;
  width: 1%;

  & > div {
    display: flex;
    margin-right: 10px;
  }
`;
const $e387141087877de7$var$StyledAvatar = (0, $lmFrL.default)((0, $1a2ca5846e673565$export$6c0524ba53950d9f))`
  margin-right: -10px;
  border: 1px solid white;
  z-index: 100;
`;
const $e387141087877de7$var$IconContainer = (0, $lmFrL.default).td`
  width: 1px;
  white-space: nowrap;
  padding: 0 12px 0 8px;

  svg {
    margin-top: 4px;
    margin-right: 4px;
    height: 16px;
    width: 16px;
  }
`;
const $e387141087877de7$var$GroupAvatar = (0, $lmFrL.default).div`
  width: ${({ theme: theme })=>theme.space[4]};
  min-width: ${({ theme: theme })=>theme.space[4]};
  height: ${({ theme: theme })=>theme.space[4]};
  border-radius: 50%;
  background-color: ${(props)=>props.theme.newColors.grayscale.secondaryGray};
  color: white;
  font-weight: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin-right: -10px;
  border: 1px solid white;
`;


const $7ec28d678e86e892$var$tabsData = [
    {
        id: 0,
        title: "New tasks"
    },
    {
        id: 1,
        title: "On going"
    },
    {
        id: 2,
        title: "Near ending"
    },
    {
        id: 3,
        title: "Completed"
    }
];
const $7ec28d678e86e892$export$b2539bed5023c21c = (props)=>{
    const { workflows: workflows, users: users, groups: groups } = props;
    const [tab, setTab] = (0, $acw62.useState)(0);
    const getColorFromIndex = (index)=>{
        const colorIndex = index % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
        const color = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[colorIndex];
        return color.color;
    };
    const parseTasks = (tasksToParse)=>{
        return tasksToParse.map((workflow)=>{
            const workflowIndex = workflows.findIndex((enabledWorkflow)=>workflow.id === enabledWorkflow.id);
            const subtasks = workflow.services.map((service)=>{
                const collaborators = [];
                service.collaborators?.groupIds.forEach((groupId)=>{
                    const foundGroup = groups.find((group)=>group.id === groupId);
                    if (foundGroup) collaborators.push({
                        id: foundGroup.id,
                        name: foundGroup.name,
                        picture: ""
                    });
                });
                service.collaborators?.userIds.forEach((userId)=>{
                    const foundUser = users.find((user)=>user.id === userId);
                    if (foundUser) collaborators.push({
                        id: foundUser.id,
                        name: foundUser.name,
                        picture: foundUser.avatar
                    });
                });
                return {
                    id: service.id,
                    name: service.name,
                    assignee: service.assignee ? users.find((user)=>user.id === service.assignee)?.avatar : undefined,
                    collaborators: collaborators
                };
            });
            return {
                id: workflow.id,
                color: getColorFromIndex(workflowIndex),
                name: workflow.name,
                subtasks: subtasks
            };
        });
    };
    const getNewTasks = ()=>{
        const tasks = workflows.map((workflow)=>{
            const filteredServices = workflow.services.filter((service)=>service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending);
            return {
                ...workflow,
                services: filteredServices
            };
        }).filter((workflow)=>workflow.services.length > 0);
        return parseTasks(tasks);
    };
    const getOngoingTasks = ()=>{
        const tasks = workflows.map((workflow)=>{
            const filteredServices = workflow.services.filter((service)=>service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing);
            return {
                ...workflow,
                services: filteredServices
            };
        }).filter((workflow)=>workflow.services.length > 0);
        return parseTasks(tasks);
    };
    const getNearEndingTasks = ()=>{
        const tasks = workflows.map((workflow)=>{
            const filteredServices = workflow.services.filter((service)=>{
                const msToEnd = parseInt(service.endDate, 10) - new Date().getTime();
                const twoWeeksInMs = 1209600000;
                return msToEnd < twoWeeksInMs && msToEnd >= 0;
            });
            return {
                ...workflow,
                services: filteredServices
            };
        }).filter((workflow)=>workflow.services.length > 0);
        return parseTasks(tasks);
    };
    const getCompletedTasks = ()=>{
        const tasks = workflows.map((workflow)=>{
            const filteredServices = workflow.services.filter((service)=>{
                const msToEnd = parseInt(service.endDate, 10) - new Date().getTime();
                return msToEnd < 0 || service.status === (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing;
            });
            return {
                ...workflow,
                services: filteredServices
            };
        }).filter((workflow)=>workflow.services.length > 0);
        return parseTasks(tasks);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$TabsContainer, null, $7ec28d678e86e892$var$tabsData.map((tabData, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Tab, {
            "aria-hidden": true,
            onClick: ()=>setTab(tabData.id),
            active: tab === index
        }, tabData.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$ContentContainer, {
        firstTab: tab === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Content, {
        key: 0,
        active: tab === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e387141087877de7$export$47130d0982a49524), {
        tasks: getNewTasks()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Content, {
        key: 1,
        active: tab === 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e387141087877de7$export$47130d0982a49524), {
        tasks: getOngoingTasks()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Content, {
        key: 2,
        active: tab === 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e387141087877de7$export$47130d0982a49524), {
        tasks: getNearEndingTasks()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ec28d678e86e892$var$Content, {
        key: 3,
        active: tab === 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e387141087877de7$export$47130d0982a49524), {
        tasks: getCompletedTasks()
    }))));
};
const $7ec28d678e86e892$var$Container = (0, $lmFrL.default).div`
  height: inherit;
  box-shadow: 0px 1px 0px #d1d5d8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 568px;
`;
const $7ec28d678e86e892$var$TabsContainer = (0, $lmFrL.default).ul`
  display: flex;
  cursor: pointer;
  margin: 0;
  padding: 0;
`;
const $7ec28d678e86e892$var$Tab = (0, $lmFrL.default).li`
  font-size: 14px;
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  border-radius: 8px;

  ${({ active: active })=>active && (0, $lmFrL.css)`
      background: white;
      border-radius: 8px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border: 1px solid #dedede;
      border-bottom: 1px solid white;
    `}
`;
const $7ec28d678e86e892$var$ContentContainer = (0, $lmFrL.default).div`
  background-color: white;
  border-radius: 8px;
  border-top-left-radius: ${({ firstTab: firstTab })=>firstTab ? 0 : "8px"};
  border: 1px solid #dedede;
  border-top: 0;
  max-height: 235px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
`;
const $7ec28d678e86e892$var$Content = (0, $lmFrL.default).div`
  display: none;
  padding: 4px 16px 20px 16px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;

  ${({ active: active })=>active && (0, $lmFrL.css)`
      display: flex;
      border-radius: 8px;
    `}
`;



const $e9162ab31050de2a$export$3cba8e686888d8a = (props)=>{
    const { projectId: projectId } = props;
    const { error: error, loading: loading, samples: samples, setSelectedSample: setSelectedSample, users: users, groups: groups, selectedSample: selectedSample, workflows: workflows } = (0, $c868d9146d506459$export$2822d76efe8c447e)({
        projectId: projectId
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    const handleDropdownChange = async (selectedValue)=>{
        setSelectedSample(selectedValue);
    };
    const samplesDropdown = samples.map((sample)=>({
            value: sample.id,
            label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)
        }));
    const getDropdown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9162ab31050de2a$var$StyledDropdown, {
            options: samplesDropdown,
            onChange: handleDropdownChange,
            value: selectedSample
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9162ab31050de2a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9162ab31050de2a$var$StyledBlockHeader, {
        headerComponent: getDropdown()
    }), samples.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ec28d678e86e892$export$b2539bed5023c21c), {
        workflows: workflows,
        users: users,
        groups: groups
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9162ab31050de2a$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        containerSize: true,
        opaque: true
    })));
};
const $e9162ab31050de2a$var$StyledBlockHeader = (0, $lmFrL.default)((0, $57e3f04af4700914$export$9f2731c1db586d53))`
  padding: 16px 24px 12px 6px;
  box-shadow: 0px 1px 0px #d1d5d8;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const $e9162ab31050de2a$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  min-width: 260px;
  margin-bottom: 4px;
`;
const $e9162ab31050de2a$var$Container = (0, $lmFrL.default).div`
  height: 338px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
`;
const $e9162ab31050de2a$var$SpinnerContainer = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




const $35eac9dcf3bb7a07$export$82357078a8fd4381 = (props)=>{
    const { projectId: projectId } = props;
    const { error: error, loading: loading, samples: samples, users: users, groups: groups } = (0, $c868d9146d506459$export$2822d76efe8c447e)({
        projectId: projectId
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    const workflows = samples.map((sample)=>sample.enabledWorkflows).reduce((accWorkflows, ws)=>[
            ...new Set([
                ...accWorkflows,
                ...ws
            ])
        ], []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($35eac9dcf3bb7a07$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($35eac9dcf3bb7a07$var$StyledBlockHeader, {
        title: "Subtasks per project"
    }), samples.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ec28d678e86e892$export$b2539bed5023c21c), {
        workflows: workflows,
        users: users,
        groups: groups
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($35eac9dcf3bb7a07$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        containerSize: true,
        opaque: true
    })));
};
const $35eac9dcf3bb7a07$var$StyledBlockHeader = (0, $lmFrL.default)((0, $57e3f04af4700914$export$9f2731c1db586d53))`
  box-shadow: 0px 1px 0px #d1d5d8;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid #dedede;
`;
const $35eac9dcf3bb7a07$var$Container = (0, $lmFrL.default).div`
  height: 338px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
`;
const $35eac9dcf3bb7a07$var$SpinnerContainer = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $bfbfe85495db98b1$export$fa9980c25a106850 = (props)=>{
    const { projectId: projectId } = props;
    const [{ samples: samples, projectQuestions: projectQuestions }, setData] = (0, $acw62.useState)({
        samples: [],
        projectQuestions: []
    });
    const { error: error, loading: loading, data: dataProject } = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: projectId
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (!dataProject?.Project) return;
        const samplesToUse = dataProject.Project.samples.map((sample)=>{
            const sampleName = (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample);
            return {
                ...sample,
                name: sampleName
            };
        });
        const budgetProjectQuestions = [];
        dataProject.Project.selectedQuestionGroups.forEach((questionGroup)=>{
            questionGroup.questionSets.forEach((questionSet)=>{
                questionSet.questions.forEach((question)=>{
                    if (question.id.includes("Budget")) budgetProjectQuestions.push(question);
                });
            });
        });
        setData({
            samples: samplesToUse,
            projectQuestions: budgetProjectQuestions
        });
    }, [
        dataProject
    ]);
    return {
        samples: samples,
        projectQuestions: projectQuestions,
        error: error,
        loading: loading || !samples
    };
};




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $bspzY = parcelRequire("bspzY");
var $95c003f3dca95aba$exports = {};

(function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "chartist"
    ], function(a0) {
        return root['Chartist.plugins.tooltip'] = factory(a0);
    });
    else if ($95c003f3dca95aba$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $95c003f3dca95aba$exports = factory((parcelRequire("bspzY")));
    else root['Chartist.plugins.tooltip'] = factory(root["Chartist"]);
})($95c003f3dca95aba$exports, function(Chartist) {
    /**
 * Chartist.js plugin to display a data label on top of the points in a line chart.
 *
 */ /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        var defaultOptions = {
            currency: undefined,
            currencyFormatCallback: undefined,
            tooltipOffset: {
                x: 0,
                y: -20
            },
            anchorToPoint: false,
            appendToBody: true,
            class: undefined,
            pointClass: 'ct-point'
        };
        Chartist.plugins = Chartist.plugins || {};
        Chartist.plugins.tooltip = function(options) {
            options = Chartist.extend({}, defaultOptions, options);
            return function tooltip(chart) {
                // Warning: If you are using npm link or yarn link, these instanceof checks will fail and you won't any tooltips
                var tooltipSelector = options.pointClass;
                if (chart instanceof Chartist.BarChart) tooltipSelector = 'ct-bar';
                else if (chart instanceof Chartist.PieChart) {
                    // Added support for donut graph
                    if (chart.options.donut) // Added support for the solid donut graph
                    tooltipSelector = chart.options.donutSolid ? 'ct-slice-donut-solid' : 'ct-slice-donut';
                    else tooltipSelector = 'ct-slice-pie';
                }
                var $chart = chart.container;
                var $toolTipIsShown = false;
                var $tooltipOffsetParent = offsetParent($chart);
                var $toolTip;
                if (!options.appendToBody) // searching for existing tooltip in the chart, because appendToBody is disabled
                $toolTip = $chart.querySelector('.chartist-tooltip');
                else // searching for existing tooltip in the body, because appendToBody is enabled
                $toolTip = document1.querySelector('.chartist-tooltip');
                if (!$toolTip) {
                    $toolTip = document1.createElement('div');
                    $toolTip.className = !options.class ? 'chartist-tooltip' : 'chartist-tooltip ' + options.class;
                    if (!options.appendToBody) $chart.appendChild($toolTip);
                    else document1.body.appendChild($toolTip);
                }
                var height = $toolTip.offsetHeight;
                var width = $toolTip.offsetWidth;
                hide($toolTip);
                function on(event, selector, callback) {
                    $chart.addEventListener(event, function(e) {
                        if (!selector || hasClass(e.target, selector)) callback(e);
                    });
                }
                on('mouseover', tooltipSelector, function(event) {
                    var $point = event.target;
                    var tooltipText = '';
                    var isPieChart = chart instanceof Chartist.PieChart ? $point : $point.parentNode;
                    var seriesName = isPieChart ? $point.parentNode.getAttribute('ct:meta') || $point.parentNode.getAttribute('ct:series-name') : '';
                    var meta = $point.getAttribute('ct:meta') || seriesName || '';
                    var hasMeta = !!meta;
                    var value = $point.getAttribute('ct:value');
                    if (options.transformTooltipTextFnc && typeof options.transformTooltipTextFnc === 'function') value = options.transformTooltipTextFnc(value);
                    if (options.tooltipFnc && typeof options.tooltipFnc === 'function') tooltipText = options.tooltipFnc(meta, value);
                    else {
                        if (options.metaIsHTML) {
                            var txt = document1.createElement('textarea');
                            txt.innerHTML = meta;
                            meta = txt.value;
                        }
                        meta = '<span class="chartist-tooltip-meta">' + meta + '</span>';
                        if (hasMeta) tooltipText += meta + '<br>';
                        else // For Pie Charts also take the labels into account
                        // Could add support for more charts here as well!
                        if (chart instanceof Chartist.PieChart) {
                            var label = next($point, 'ct-label');
                            if (label) tooltipText += text(label) + '<br>';
                        }
                        if (value) {
                            if (options.currency) {
                                if (options.currencyFormatCallback != undefined) value = options.currencyFormatCallback(value, options);
                                else value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
                            }
                            value = '<span class="chartist-tooltip-value">' + value + '</span>';
                            tooltipText += value;
                        }
                    }
                    if (tooltipText) {
                        $toolTip.innerHTML = tooltipText;
                        // Calculate new width and height, as toolTip width/height may have changed with innerHTML change
                        height = $toolTip.offsetHeight;
                        width = $toolTip.offsetWidth;
                        if (options.appendToBody !== true) $tooltipOffsetParent = offsetParent($chart);
                        if ($toolTip.style.display !== 'absolute') $toolTip.style.display = 'absolute';
                        setPosition(event);
                        show($toolTip);
                        // Remember height and width to avoid wrong position in IE
                        height = $toolTip.offsetHeight;
                        width = $toolTip.offsetWidth;
                    }
                });
                on('mouseout', tooltipSelector, function() {
                    hide($toolTip);
                });
                on('mousemove', null, function(event) {
                    if (options.anchorToPoint === false && $toolTipIsShown) setPosition(event);
                });
                function setPosition(event) {
                    height = height || $toolTip.offsetHeight;
                    width = width || $toolTip.offsetWidth;
                    var offsetX = -width / 2 + options.tooltipOffset.x;
                    var offsetY = -height + options.tooltipOffset.y;
                    var anchor = options.anchorToPoint === true && event.target.x2 && event.target.y2;
                    if (options.appendToBody === true) {
                        if (anchor) {
                            var box = $chart.getBoundingClientRect();
                            var left = event.target.x2.baseVal.value + box.left + window1.pageXOffset;
                            var top = event.target.y2.baseVal.value + box.top + window1.pageYOffset;
                            $toolTip.style.left = left + offsetX + 'px';
                            $toolTip.style.top = top + offsetY + 'px';
                        } else {
                            $toolTip.style.left = event.pageX + offsetX + 'px';
                            $toolTip.style.top = event.pageY + offsetY + 'px';
                        }
                    } else {
                        var offsetBox = $tooltipOffsetParent.getBoundingClientRect();
                        var allOffsetLeft = -offsetBox.left - window1.pageXOffset + offsetX;
                        var allOffsetTop = -offsetBox.top - window1.pageYOffset + offsetY;
                        if (anchor) {
                            var box = $chart.getBoundingClientRect();
                            var left = event.target.x2.baseVal.value + box.left + window1.pageXOffset;
                            var top = event.target.y2.baseVal.value + box.top + window1.pageYOffset;
                            $toolTip.style.left = left + allOffsetLeft + 'px';
                            $toolTip.style.top = top + allOffsetTop + 'px';
                        } else {
                            $toolTip.style.left = event.pageX + allOffsetLeft + 'px';
                            $toolTip.style.top = event.pageY + allOffsetTop + 'px';
                        }
                    }
                }
                /**
       * Shows the tooltip element, if not shown
       * @param element
       */ function show(element) {
                    $toolTipIsShown = true;
                    if (!hasClass(element, 'tooltip-show')) element.className = element.className + ' tooltip-show';
                }
                /**
       * Hides the tooltip element
       * @param element
       */ function hide(element) {
                    $toolTipIsShown = false;
                    var regex = new RegExp("tooltip-show\\s*", 'gi');
                    element.className = element.className.replace(regex, '').trim();
                }
            };
        };
        /**
   * Returns whether a element has a css class called className
   * @param element
   * @param className
   * @return {boolean}
   */ function hasClass(element, className) {
            return (' ' + element.getAttribute('class') + ' ').indexOf(' ' + className + ' ') > -1;
        }
        function next(element, className) {
            do element = element.nextSibling;
            while (element && !hasClass(element, className));
            return element;
        }
        /**
   *
   * @param element
   * @return {string | string}
   */ function text(element) {
            return element.innerText || element.textContent;
        }
        /**
   * Returns the first positioned parent of the element
   * @return HTMLElement
   */ function offsetParent(elem) {
            if (offsetParent in elem) {
                // Using the native property if possible
                var parent = elem.offsetParent;
                if (!parent) parent = document1.body.parentElement;
                return parent;
            }
            var parent = elem.parentNode;
            if (!parent) return document1.body.parentElement;
            if (window1.getComputedStyle(parent).position !== 'static') return parent;
            else if (parent.tagName === 'BODY') return parent.parentElement;
            else return offsetParent(parent);
        }
    })(window, document, Chartist);
    return Chartist.plugins.tooltip;
});






const $d27dc3254ec987e4$export$e7a1baa2fae31f0f = (str)=>parseInt(str, 10);



function $4f9e48187bc1b90b$var$transpose(matrix) {
    const rows = matrix.length;
    const colsLen = matrix.map((col)=>col.length);
    const cols = Math.max(...colsLen);
    const grid = [];
    for(let j = 0; j < cols; j += 1)grid[j] = Array(rows);
    for(let i = 0; i < rows; i += 1)for(let j = 0; j < cols; j += 1)grid[j][i] = matrix[i][j];
    return grid;
}
function $4f9e48187bc1b90b$var$addToCategory(graphData, category, priceValue) {
    const alreadyDefinedCategories = graphData.map((field)=>field.meta);
    if (!alreadyDefinedCategories.includes(category)) graphData.push({
        meta: category,
        value: 0
    });
    const categoryToAddTo = graphData.find((field)=>field.meta === category);
    if (categoryToAddTo) categoryToAddTo.value += parseFloat(priceValue);
}
const $4f9e48187bc1b90b$export$9b45b27c3e20aa7c = (props)=>{
    const { samples: samples, currency: currency, projectQuestions: projectQuestions } = props;
    const [label, setLabel] = (0, $acw62.useState)("");
    const options = {
        stackBars: true,
        horizontalBars: true,
        axisX: {
            labelInterpolationFnc: (value, index)=>index % 2 === 0 ? value : null
        },
        axisY: {
            offset: 60
        },
        chartPadding: {
            top: 0,
            bottom: 0
        },
        plugins: [
            (0, (/*@__PURE__*/$parcel$interopDefault($95c003f3dca95aba$exports)))({
                currency: currency
            })
        ]
    };
    (0, $acw62.useEffect)(()=>{
        const budgetForAllProject = [
            {
                meta: "Budget for all project",
                value: 0
            }
        ];
        const budgetForAllWorkflows = [
            0
        ];
        const budgetForAllServices = [
            0
        ];
        const budgetsForAllWorkflows = [];
        const budgetsForAllServices = [];
        const usedBudget = [];
        // const yearsSumsInWorkflows: FieldWithDesc[] = [];
        const yearsSumsInServices = [];
        const sumsOfSimilarServices = [];
        const sumsOfSimilarServicesInYears = [];
        if (projectQuestions.length > 0) projectQuestions.forEach((question)=>{
            if (question.id.includes(currency)) {
                const numericAnswer = question.answer;
                const value = numericAnswer.numericBody ? numericAnswer.numericBody : 0;
                budgetForAllProject[0].value = value;
            }
        });
        let sampleToUse = samples.length > 0 && samples[0];
        samples.forEach((sample)=>{
            const sampleName = (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample);
            const sampleNameLowercase = sampleName.toLowerCase();
            if (sampleNameLowercase.includes("budget") || sampleNameLowercase.includes("bud\u017Cet")) sampleToUse = sample;
        });
        let showSumsOfSimilar = false;
        if (sampleToUse) sampleToUse.enabledWorkflows.forEach((workflow)=>{
            JSON.stringify(workflow);
            if (workflow.price?.price?.value && workflow.price?.currency === currency) {
                budgetForAllWorkflows[0] += parseFloat(workflow.price.price.value);
                budgetsForAllWorkflows.push({
                    meta: workflow.name,
                    value: parseFloat(workflow.price.price.value)
                });
            }
            workflow.services.forEach((service)=>{
                const serviceMapped = service;
                if (serviceMapped.price?.price?.value && serviceMapped.price?.currency === currency) {
                    if (!/^\d+$/.test(service.name)) showSumsOfSimilar = true;
                    budgetForAllServices[0] += parseFloat(serviceMapped.price.price.value);
                    budgetsForAllServices.push({
                        meta: `${workflow.name}: ${service.name}`,
                        value: parseFloat(serviceMapped.price.price.value)
                    });
                    const serviceStartYear = new Date((0, $d27dc3254ec987e4$export$e7a1baa2fae31f0f)(serviceMapped.startDate)).getFullYear().toString();
                    $4f9e48187bc1b90b$var$addToCategory(yearsSumsInServices, serviceStartYear, serviceMapped.price.price.value);
                    $4f9e48187bc1b90b$var$addToCategory(sumsOfSimilarServices, serviceMapped.name, serviceMapped.price.price.value);
                    $4f9e48187bc1b90b$var$addToCategory(sumsOfSimilarServicesInYears, `${serviceMapped.name} in year ${serviceStartYear}`, serviceMapped.price.price.value);
                    if ((0, $45477df3f05bcd9c$export$3aad99d61846824e)(serviceMapped.status) && serviceMapped.price?.currency === currency) usedBudget.push({
                        meta: `${workflow.name}: ${service.name}`,
                        value: parseFloat(serviceMapped.price.price.value)
                    });
                }
            });
        });
        const labels = [
            "Used",
            "In Years"
        ];
        if (showSumsOfSimilar) labels.push("Sums by year");
        if (showSumsOfSimilar) labels.push("Sums of similar");
        labels.push("Subtasks");
        labels.push("Tasks");
        const sourceData = [
            usedBudget,
            yearsSumsInServices
        ];
        if (showSumsOfSimilar) sourceData.push(sumsOfSimilarServicesInYears);
        if (showSumsOfSimilar) sourceData.push(sumsOfSimilarServices);
        sourceData.push(budgetsForAllServices);
        sourceData.push(budgetsForAllWorkflows);
        if (budgetForAllProject[0].value !== 0) {
            sourceData.push(budgetForAllProject);
            labels.push("Project");
        }
        const series = $4f9e48187bc1b90b$var$transpose(sourceData);
        const data = {
            labels: labels,
            series: series
        };
        const thereIsNoDataHere = budgetForAllWorkflows[0] === 0 && budgetForAllServices[0] === 0 && budgetForAllProject[0].value === 0;
        if (!thereIsNoDataHere) {
            setLabel("");
            // eslint-disable-next-line no-new
            new (0, $bspzY.BarChart)(`.chart${currency}`, data, options);
        } else setLabel("There is no budget data in this currency.");
    }, [
        samples
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4f9e48187bc1b90b$var$Chart, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4f9e48187bc1b90b$var$ChartContainer, {
        isVisible: label.length === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `chart${currency}`,
        style: {
            height: "234px"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4f9e48187bc1b90b$var$Label, null, label));
};
const $4f9e48187bc1b90b$var$Chart = (0, $lmFrL.default).div`
  .ct-bar {
    /* The width of your bars */
    stroke-width: 20px;
  }
`;
const $4f9e48187bc1b90b$var$ChartContainer = (0, $lmFrL.default).div`
  ${({ isVisible: isVisible })=>isVisible ? "" : "display: none;"}
`;
const $4f9e48187bc1b90b$var$Label = (0, $lmFrL.default).div`
  font-size: smaller;
`;


const $66f23685a6783b54$export$9a9e82507f41a742 = (props)=>{
    const { projectId: projectId, currency: currency } = props;
    const { error: error, loading: loading, samples: samples, projectQuestions: projectQuestions } = (0, $bfbfe85495db98b1$export$fa9980c25a106850)({
        projectId: projectId
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2218edc180268acc$export$b9b108b497733374), {
        title: `Budget in ${currency}`,
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f9e48187bc1b90b$export$9b45b27c3e20aa7c), {
        samples: samples,
        projectQuestions: projectQuestions,
        currency: currency
    }));
};




const $f2286f61233a3c57$export$fe82a520fc33e5f4 = (_props)=>{
    const { error: error, loading: loading, projects: projects, selectedProject: selectedProject, setSelectedProject: setSelectedProject } = (0, $943534f4fbe55ce2$export$bc2f3c415e4383ee)();
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const budgetIsVisible = useUserPermissions("seeBudget");
    const teamIsVisible = useUserPermissions("seeTeam");
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const handleDropdownChange = async (selectedValue)=>{
        setSelectedProject(selectedValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Dashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f2286f61233a3c57$var$DropdownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f2286f61233a3c57$var$StyledDropdown, {
        options: projects,
        defaultValue: selectedProject,
        onChange: handleDropdownChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f2286f61233a3c57$var$BlocksContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9162ab31050de2a$export$3cba8e686888d8a), {
        projectId: selectedProject.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35eac9dcf3bb7a07$export$82357078a8fd4381), {
        projectId: selectedProject.value
    }), teamIsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c23c5ea6c96b3754$export$20a19277110e1a71), {
        projectId: selectedProject.value
    }) : null, budgetIsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66f23685a6783b54$export$9a9e82507f41a742), {
        projectId: selectedProject.value,
        currency: (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Pln
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66f23685a6783b54$export$9a9e82507f41a742), {
        projectId: selectedProject.value,
        currency: (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66f23685a6783b54$export$9a9e82507f41a742), {
        projectId: selectedProject.value,
        currency: (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Usd
    })) : null));
};
const $f2286f61233a3c57$var$DropdownContainer = (0, $lmFrL.default).div`
  margin-bottom: 16px;
`;
const $f2286f61233a3c57$var$BlocksContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 36px;
  row-gap: 40px;
`;
const $f2286f61233a3c57$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  padding: 0;
  max-width: 294px;
`;



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");

var $45fvw = parcelRequire("45fvw");





var $acw62 = parcelRequire("acw62");


const $379834141212cc85$export$5dd1db33bd4289c2 = (props)=>{
    const { projectId: projectId } = props;
    const [selectedSample, setSelectedSample] = (0, $acw62.useState)({
        label: "",
        value: ""
    });
    const [samples, setSamples] = (0, $acw62.useState)([]);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [groups, setGroups] = (0, $acw62.useState)([]);
    const [workflows, setWorkflows] = (0, $acw62.useState)([]);
    const { error: errorProject, loading: loadingProject, data: dataProject } = (0, $7608a8bbcbbad14c$export$f47ded2d66c9a18a)({
        variables: {
            id: projectId
        }
    });
    const { error: errorUsers, loading: loadingUsers, data: dataUsers } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        }
    });
    const { error: errorGroups, loading: loadingGroups, data: dataGroups } = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)();
    (0, $acw62.useEffect)(()=>{
        if (!dataProject?.Project) return;
        setSamples(dataProject.Project.samples);
        if (dataProject.Project.samples.length > 0 && !selectedSample.value) setSelectedSample({
            label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(dataProject.Project.samples[0]),
            value: dataProject.Project.samples[0].id
        });
        if (dataProject.Project.samples.length > 0 && selectedSample.value) {
            const foundSample = dataProject.Project.samples.find((sample)=>sample.id === selectedSample.value);
            if (!foundSample) return;
            setWorkflows([
                ...foundSample.enabledWorkflows
            ]);
        }
    }, [
        dataProject
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dataUsers?.ProjectUsers) return;
        const usersToSet = dataUsers.ProjectUsers.map((user)=>{
            return {
                id: user?.id || "",
                name: user?.name || user?.email || "",
                email: user?.email || "",
                role: user?.role || "",
                avatar: user?.avatar || ""
            };
        });
        setUsers(usersToSet);
    }, [
        dataUsers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dataGroups?.Groups) return;
        setGroups(dataGroups.Groups);
    }, [
        dataGroups
    ]);
    (0, $acw62.useEffect)(()=>{
        const foundSample = samples.find((sample)=>sample.id === selectedSample.value);
        if (!foundSample) return;
        setWorkflows(foundSample.enabledWorkflows);
    }, [
        selectedSample
    ]);
    return {
        selectedSample: selectedSample,
        setSelectedSample: setSelectedSample,
        samples: samples,
        users: users,
        groups: groups,
        workflows: workflows,
        error: errorProject || errorUsers || errorGroups,
        loading: loadingProject || !dataProject || loadingUsers || !dataUsers || loadingGroups || !dataGroups
    };
};



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");




var $acw62 = parcelRequire("acw62");



const $4c1c637c4ba7023c$export$8fde5d322d162af4 = (props)=>{
    const { projectId: projectId, sampleId: sampleId, reloadTasks: reloadTasks } = props;
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const { loading: usersLoading, data: usersData, error: usersError } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        },
        fetchPolicy: "cache-first"
    });
    const [updateWorkflowFromSample] = (0, $7608a8bbcbbad14c$export$9cb58138bf28f995)();
    const [updateServiceFromWorkflow] = (0, $7608a8bbcbbad14c$export$981396349d3957c6)();
    const [addServiceToWorkflow] = (0, $7608a8bbcbbad14c$export$2a667d95ba1e4243)();
    (0, $acw62.useEffect)(()=>{
        if (!usersData?.ProjectUsers) return;
        setUsers(usersData.ProjectUsers);
    }, [
        usersData
    ]);
    const updateTask = (taskId, target, value)=>{
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowUpdatables: {
                    id: taskId,
                    [target]: value
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateWorkflowFromSample"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const samples = [
                        ...existingQueryResult.samples
                    ];
                    const sample = samples.find((s)=>s.id === sampleId);
                    if (sample) {
                        const newSamples = samples.map((sampleLoop)=>{
                            if (sampleLoop.id === sampleId) {
                                const newWorkflows = sampleLoop.enabledWorkflows.map((workflowLoop)=>{
                                    if (workflowLoop.id === taskId) return incomingData;
                                    return workflowLoop;
                                });
                                return {
                                    ...sampleLoop,
                                    enabledWorkflows: newWorkflows
                                };
                            }
                            return sampleLoop;
                        });
                        cache.writeQuery({
                            variables: {
                                id: projectId
                            },
                            query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                            data: {
                                Project: {
                                    ...existingQueryResult,
                                    samples: newSamples
                                }
                            }
                        });
                    }
                }
            }
        };
        updateWorkflowFromSample(options).catch((error)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error);
            if (reloadTasks) reloadTasks();
        });
    };
    const updateSubtask = (taskId, subtaskId, target, value, lockedDate)=>{
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: taskId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceUpdatables: {
                    id: subtaskId,
                    ...lockedDate ? {
                        startDate: lockedDate[0],
                        endDate: lockedDate[1]
                    } : {
                        [target]: value
                    }
                }
            },
            update (cache, { data: data }) {
                const incomingData = data?.["UpdateServiceFromWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const existingSamples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = existingSamples.find((s)=>s.id === sampleId);
                    const updatedEnabledWorkflows = foundSample?.enabledWorkflows.map((workflow)=>({
                            ...workflow,
                            services: (0, $cc4416d5e1582097$export$cf5b13249fe61a4d)(workflow.services, incomingData)
                        }));
                    const samplesToSave = existingSamples?.map((sampleLoop)=>{
                        if (sampleLoop.id === sampleId) return {
                            ...sampleLoop,
                            enabledWorkflows: updatedEnabledWorkflows
                        };
                        return sampleLoop;
                    });
                    cache.writeQuery({
                        query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                        variables: {
                            id: projectId
                        },
                        data: {
                            Project: {
                                ...existingQueryResult,
                                samples: samplesToSave
                            }
                        }
                    });
                }
            }
        };
        if (target === "assignee") options.refetchQueries = [
            "ServicesAssignedToUserForTimeline"
        ];
        updateServiceFromWorkflow(options).catch((error)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error);
            if (reloadTasks) reloadTasks();
        });
    };
    const addSubtask = (taskId)=>{
        setShowSpinner(true);
        const options = {
            variables: {
                projectSampleInput: {
                    projectId: projectId,
                    sampleId: sampleId
                },
                workflowInput: {
                    workflowId: taskId,
                    workflowDesignation: "enabledWorkflows"
                },
                serviceId: "NewServiceBlock",
                startDate: Date.now().toString()
            },
            update (cache, { data: data }) {
                const incomingData = data?.["AddServiceToWorkflow"];
                const existingQueryResult = cache.readQuery({
                    query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                    variables: {
                        id: projectId
                    }
                })?.["Project"];
                if (existingQueryResult && incomingData) {
                    const existingSamples = [
                        ...existingQueryResult.samples
                    ];
                    const foundSample = existingSamples.find((s)=>s.id === sampleId);
                    if (foundSample) {
                        const mappedWorkflows = foundSample.enabledWorkflows.map((workflow)=>{
                            if (workflow.id === taskId) return incomingData;
                            return workflow;
                        });
                        const samplesToSave = existingSamples?.map((existingSample)=>{
                            if (existingSample.id === sampleId) return {
                                ...existingSample,
                                enabledWorkflows: mappedWorkflows
                            };
                            return existingSample;
                        });
                        cache.writeQuery({
                            query: (0, $7608a8bbcbbad14c$export$7b040ae9d4c82b96),
                            variables: {
                                id: projectId
                            },
                            data: {
                                Project: {
                                    ...existingQueryResult,
                                    samples: samplesToSave
                                }
                            }
                        });
                    }
                }
                setShowSpinner(false);
            }
        };
        addServiceToWorkflow(options).catch((error)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error);
            if (reloadTasks) reloadTasks();
        });
    };
    return {
        updateTask: updateTask,
        updateSubtask: updateSubtask,
        addSubtask: addSubtask,
        users: users,
        error: usersError,
        loading: usersLoading || !usersData,
        showSpinner: showSpinner
    };
};






var $acw62 = parcelRequire("acw62");

const $aea4e0b5fa4afc54$export$68af20de9302002c = (props)=>{
    const { width: width, height: height, color: color, className: className } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: `0 0 ${width} ${height}`,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: color,
        d: "M0 3.5L19 3.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "17.5",
        cy: "3.5",
        r: "3.5",
        fill: color
    }));
};
$aea4e0b5fa4afc54$export$68af20de9302002c.defaultProps = {
    width: "21",
    height: "7",
    color: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
};



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");





const $7d273cd19d2100d4$export$8913b16345c43cb5 = (props)=>{
    const { projectId: projectId, collaborators: collaborators, readonly: readonly, onChange: onChange, className: className, menuPortalTarget: menuPortalTarget } = props;
    const [hideCollaborators, setHideCollaborators] = (0, $acw62.useState)(true);
    const [selectedCollaborators, setCollaborators] = (0, $acw62.useState)([]);
    const [allCollaboratorsOptions, setAllCollaboratorsOptions] = (0, $acw62.useState)([]);
    const { data: usersData, loading: usersLoading } = (0, $7608a8bbcbbad14c$export$9822af98a3fbbf81)({
        variables: {
            projectId: projectId
        },
        fetchPolicy: "cache-first"
    });
    const { data: groupsData, loading: groupsLoading } = (0, $7608a8bbcbbad14c$export$989566a73930cfbe)({
        fetchPolicy: "cache-first"
    });
    (0, $acw62.useEffect)(()=>{
        setCollaborators([
            ...collaborators?.groupIds || [],
            ...collaborators?.userIds || []
        ].map((eId)=>allCollaboratorsOptions?.find((cg)=>cg.value.id === eId)).filter(Boolean));
    }, [
        collaborators,
        allCollaboratorsOptions
    ]);
    (0, $acw62.useEffect)(()=>{
        const allGroupOptions = groupsData?.Groups.map((group)=>({
                label: `Group: ${group.name}`,
                value: {
                    id: group.id,
                    name: group.name,
                    type: "group",
                    details: group
                }
            }));
        const allUserOptions = usersData?.ProjectUsers.map((user)=>({
                label: user?.name,
                value: {
                    id: user?.id,
                    name: user?.name,
                    type: "user",
                    details: user
                }
            }));
        setAllCollaboratorsOptions([
            ...allGroupOptions ?? [],
            ...allUserOptions ?? []
        ]);
    }, [
        usersData,
        groupsData
    ]);
    if (groupsLoading || usersLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const unselectedOptions = allCollaboratorsOptions.filter((x)=>{
        if (!selectedCollaborators) return true;
        return !selectedCollaborators.includes(x);
    });
    const onSelectBlur = ()=>{
        if (!hideCollaborators) setHideCollaborators(true);
        onChange(selectedCollaborators);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d273cd19d2100d4$var$Container, {
        spread: !hideCollaborators,
        onClick: ()=>{
            if (!readonly) setHideCollaborators(false);
        },
        editMode: !readonly,
        className: className
    }, hideCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d273cd19d2100d4$var$SelectionContainer, null, (0, $7cc11c9e56040479$export$9696f3ac75b04826)(selectedCollaborators), !readonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d273cd19d2100d4$var$PlusContainer, null, "+")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d273cd19d2100d4$var$StyledDropdown, {
        autoFocus: true,
        onBlur: onSelectBlur,
        options: unselectedOptions,
        isMulti: true,
        onChange: setCollaborators,
        value: selectedCollaborators,
        menuPortalTarget: menuPortalTarget
    }));
};
const $7d273cd19d2100d4$var$Container = (0, $lmFrL.default).div`
  flex-direction: row;
  align-items: center;
  display: flex;
  cursor: pointer;

  ${({ spread: spread })=>spread && (0, $lmFrL.css)`
      justify-content: space-between;
    `}

  ${({ editMode: editMode })=>!editMode && (0, $lmFrL.css)`
      cursor: auto;
    `}
`;
const $7d273cd19d2100d4$var$SelectionContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;
const $7d273cd19d2100d4$var$PlusContainer = (0, $lmFrL.default).div`
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  padding-top: 4px;
`;
const $7d273cd19d2100d4$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  justify-self: flex-start;
  width: 100%;
`;




const $ad7d42e336cb5e10$var$getTableHeadRow = (budgetIsVisible)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$HeadRow, {
        key: "head-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Assignee"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Start Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Due Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Duration"), budgetIsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Budget") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col"
    }, "Collaborators"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$TimelineTh, {
        scope: "col"
    }, "Timeline"));
};
const $ad7d42e336cb5e10$export$47130d0982a49524 = (props)=>{
    const { projectId: projectId, sampleId: sampleId, tasks: tasks, setTasks: setTasks, showSubtasks: showSubtasks = true, readonly: readonly = false, reloadTasks: reloadTasks } = props;
    const { updateTask: updateTask, updateSubtask: updateSubtask, addSubtask: addSubtask, users: users, loading: loading, showSpinner: showSpinner } = (0, $4c1c637c4ba7023c$export$8fde5d322d162af4)({
        projectId: projectId,
        sampleId: sampleId,
        reloadTasks: reloadTasks
    });
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const budgetIsVisible = useUserPermissions("seeBudget");
    const [selectedDatePickerId, setSelectedDatePickerId] = (0, $acw62.useState)(null);
    const updateState = (taskId, updatables, subtaskId)=>{
        if (subtaskId) {
            setTasks((prevTasks)=>{
                const newTasks = [
                    ...prevTasks
                ];
                const taskIndex = newTasks.findIndex((task)=>task.id === taskId);
                const subtaskIndex = newTasks[taskIndex].subtasks.findIndex((subtask)=>subtask.id === subtaskId);
                updatables.forEach(({ key: key, value: value })=>{
                    newTasks[taskIndex].subtasks[subtaskIndex][key] = value;
                });
                return newTasks;
            });
            return;
        }
        setTasks((prevTasks)=>{
            const newTasks = [
                ...prevTasks
            ];
            const taskIndex = newTasks.findIndex((task)=>task.id === taskId);
            updatables.forEach(({ key: key, value: value })=>{
                newTasks[taskIndex][key] = value;
            });
            return newTasks;
        });
    };
    const handleNameChange = (taskId, name, subtaskId)=>{
        if (subtaskId) {
            updateState(taskId, [
                {
                    key: "name",
                    value: name
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "name", name);
            return;
        }
        updateState(taskId, [
            {
                key: "name",
                value: name
            }
        ]);
        updateTask(taskId, "name", name);
    };
    const handleSubtaskStatusChange = (taskId, subtaskId, status)=>{
        updateState(taskId, [
            {
                key: "status",
                value: status
            }
        ], subtaskId);
        updateSubtask(taskId, subtaskId, "status", status);
    };
    const handleSubtaskStartDateChange = (taskId, subtaskId, startDate, oldStartDate, endDate, lockedDuration)=>{
        if (startDate > endDate && !lockedDuration) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You cannot set the start date later than the end date");
            return;
        }
        const copyOfNewDate = startDate;
        const startDateWithCorrectHours = new Date(copyOfNewDate.setHours(0, 0, 0, 0));
        if (lockedDuration) {
            const dateDifference = startDate.valueOf() - oldStartDate.valueOf();
            const newEndValueDate = endDate.valueOf() + dateDifference;
            const newEndDate = new Date(+newEndValueDate);
            const newEndDateWithCorrectHours = new Date(newEndDate.setHours(23, 59, 59, 59));
            updateState(taskId, [
                {
                    key: "startDate",
                    value: startDateWithCorrectHours
                },
                {
                    key: "endDate",
                    value: newEndDateWithCorrectHours
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "lockDate", null, [
                startDateWithCorrectHours.getTime().toString(),
                newEndDateWithCorrectHours.getTime().toString()
            ]);
        } else {
            updateState(taskId, [
                {
                    key: "startDate",
                    value: startDateWithCorrectHours
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "startDate", startDateWithCorrectHours.getTime().toString());
        }
    };
    const handleSubtaskEndDateChange = (taskId, subtaskId, endDate, oldEndDate, startDate, lockedDuration)=>{
        if (endDate < startDate && !lockedDuration) {
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error("You cannot set the end date earlier than the start date");
            return;
        }
        const copyOfNewDate = endDate;
        const endDateWithCorrectHours = new Date(copyOfNewDate.setHours(23, 59, 59, 59));
        if (lockedDuration) {
            const dateDifference = endDate.valueOf() - oldEndDate.valueOf();
            const newStartValueDate = startDate.valueOf() + dateDifference;
            const newStartDate = new Date(+newStartValueDate);
            const newStartDateWithCorrectHours = new Date(newStartDate.setHours(0, 0, 0, 0));
            updateState(taskId, [
                {
                    key: "startDate",
                    value: newStartDateWithCorrectHours
                },
                {
                    key: "endDate",
                    value: endDateWithCorrectHours
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "lockDate", null, [
                newStartDateWithCorrectHours.getTime().toString(),
                endDateWithCorrectHours.getTime().toString()
            ]);
        } else {
            updateState(taskId, [
                {
                    key: "endDate",
                    value: endDateWithCorrectHours
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "endDate", endDateWithCorrectHours.getTime().toString());
        }
    };
    const handleAssigneeChange = (taskId, assignee, subtaskId)=>{
        if (subtaskId) {
            updateState(taskId, [
                {
                    key: "assignee",
                    value: assignee
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "assignee", assignee);
            return;
        }
        updateState(taskId, [
            {
                key: "assignee",
                value: assignee
            }
        ]);
        updateTask(taskId, "assignee", assignee);
    };
    const handleNavigateTo = (taskId, subtaskId)=>{
        let url = `/projects/${projectId}/timeline/samples/${sampleId}/workflows/${taskId}`;
        if (subtaskId) url = `${url}/services/${subtaskId}`;
        (0, $f125bbca2c654db8$export$ff7962acd6052c28)(url);
    };
    const handleCollaboratorsChange = (taskId, collaborators, subtaskId)=>{
        const updatedCollaborators = {
            groupIds: collaborators ? collaborators.filter((x)=>x.value.type === "group").map((x)=>x.value.id) : [],
            userIds: collaborators ? collaborators.filter((x)=>x && x.value.type === "user").map((x)=>x.value.id) : []
        };
        if (subtaskId) {
            updateState(taskId, [
                {
                    key: "collaborators",
                    value: updatedCollaborators
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "collaborators", updatedCollaborators);
            return;
        }
        updateState(taskId, [
            {
                key: "collaborators",
                value: updatedCollaborators
            }
        ]);
        updateTask(taskId, "collaborators", updatedCollaborators);
    };
    const handleBudgetChange = (taskId, price, subtaskId)=>{
        if (subtaskId) {
            updateState(taskId, [
                {
                    key: "budget",
                    value: price
                }
            ], subtaskId);
            return;
        }
        updateState(taskId, [
            {
                key: "budget",
                value: price
            }
        ]);
    };
    const handleBudgetBlur = (taskId, price, subtaskId)=>{
        try {
            localStorage.setItem("preferredCurrency", price.currency);
        } catch (err) {
        // do nothing
        }
        const priceToSet = {
            price: {
                value: price.price
            },
            currency: price.currency
        };
        if (subtaskId) {
            updateState(taskId, [
                {
                    key: "budget",
                    value: price
                }
            ], subtaskId);
            updateSubtask(taskId, subtaskId, "price", priceToSet);
            return;
        }
        updateState(taskId, [
            {
                key: "budget",
                value: price
            }
        ]);
        updateTask(taskId, "price", priceToSet);
    };
    const handleAddSubtask = (taskId)=>{
        addSubtask(taskId);
    };
    const menuPortalTarget = document.querySelector("#children");
    const budgets = [];
    tasks.forEach((task)=>{
        if (task.budget.price) budgets.push(parseFloat(task.budget.price));
        task.subtasks.forEach((subtask)=>{
            if (subtask.budget.price) budgets.push(parseFloat(subtask.budget.price));
        });
    });
    const maxBudgetWidth = budgets.length > 0 ? Math.max(...budgets).toString().length : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Table, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, $ad7d42e336cb5e10$var$getTableHeadRow(budgetIsVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, tasks.map((task)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Row, {
            key: task.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$IconContainer, {
            color: task.color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6abd5a05d076ad5$export$5b6c8e359d4618aa), {
            color: task.color
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Text, {
            contentEditable: !readonly,
            suppressContentEditableWarning: !readonly,
            readonly: readonly,
            spellCheck: false,
            onBlur: (event)=>handleNameChange(task.id, event.target.innerText),
            onKeyDown: (event)=>{
                if (event.key === "Enter") event.preventDefault();
            }
        }, task.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledUsersSelector, {
            users: users,
            loading: loading,
            editMode: !readonly,
            selectedValue: task.assignee?.id,
            onChange: (assignee)=>handleAssigneeChange(task.id, assignee),
            disabled: readonly,
            smallMenuItems: true,
            readonly: readonly,
            menuPortalTarget: menuPortalTarget
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledDatePicker, {
            date: task.startDate,
            editMode: false,
            selectedDatePickerId: selectedDatePickerId,
            setSelectedDatePickerId: setSelectedDatePickerId,
            datePickerId: `start-date-${task.id}`,
            readonly: readonly
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledDatePicker, {
            date: task.endDate,
            editMode: false,
            selectedDatePickerId: selectedDatePickerId,
            setSelectedDatePickerId: setSelectedDatePickerId,
            datePickerId: `end-date-${task.id}`,
            readonly: readonly
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, task.duration), budgetIsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$PriceContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f28f33e26d81bd8$export$a0ace416ddcaca7), {
            editMode: !readonly,
            value: task.budget,
            onChange: (price)=>handleBudgetChange(task.id, price),
            onBlur: (price)=>handleBudgetBlur(task.id, price),
            maxWidth: maxBudgetWidth,
            small: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledCollaboratorsDropdown, {
            projectId: projectId,
            readonly: readonly,
            collaborators: task.collaborators,
            onChange: (collaborators)=>handleCollaboratorsChange(task.id, collaborators),
            menuPortalTarget: menuPortalTarget
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$LinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            onClick: ()=>handleNavigateTo(task.id)
        }, "Show \u279C"))), showSubtasks && task.subtasks.map((subtask, subtaskIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Row, {
                key: subtask.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$DotContainer, {
                color: task.color,
                lastSubtask: task.subtasks.length - 1 === subtaskIndex
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aea4e0b5fa4afc54$export$68af20de9302002c), {
                color: task.color
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Text, {
                contentEditable: !readonly,
                suppressContentEditableWarning: !readonly,
                readonly: readonly,
                spellCheck: false,
                onBlur: (e)=>handleNameChange(task.id, e.target.innerText.trim(), subtask.id),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") event.preventDefault();
                }
            }, subtask.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledStatusDropdown, {
                onStatusChange: (status)=>handleSubtaskStatusChange(task.id, subtask.id, status),
                status: subtask.status,
                readonly: readonly,
                menuPortalTarget: menuPortalTarget
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledUsersSelector, {
                users: users,
                loading: loading,
                editMode: !readonly,
                selectedValue: subtask.assignee?.id || "",
                onChange: (value)=>handleAssigneeChange(task.id, value, subtask.id),
                disabled: readonly,
                readonly: readonly,
                smallMenuItems: true,
                menuPortalTarget: menuPortalTarget
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledDatePicker, {
                date: subtask.startDate,
                setDate: (date)=>handleSubtaskStartDateChange(task.id, subtask.id, date, subtask.startDate, subtask.endDate, subtask.durationLocked),
                editMode: !readonly,
                selectedDatePickerId: selectedDatePickerId,
                setSelectedDatePickerId: setSelectedDatePickerId,
                datePickerId: `start-date-${subtask.id}`,
                readonly: readonly
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledDatePicker, {
                date: subtask.endDate,
                setDate: (date)=>handleSubtaskEndDateChange(task.id, subtask.id, date, subtask.endDate, subtask.startDate, subtask.durationLocked),
                editMode: !readonly,
                selectedDatePickerId: selectedDatePickerId,
                setSelectedDatePickerId: setSelectedDatePickerId,
                datePickerId: `end-date-${subtask.id}`,
                readonly: readonly
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, subtask.duration), budgetIsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$PriceContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f28f33e26d81bd8$export$a0ace416ddcaca7), {
                editMode: !readonly,
                value: subtask.budget,
                onChange: (price)=>handleBudgetChange(task.id, price, subtask.id),
                onBlur: (price)=>handleBudgetBlur(task.id, price, subtask.id),
                maxWidth: maxBudgetWidth,
                small: true
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$StyledCollaboratorsDropdown, {
                projectId: projectId,
                readonly: readonly,
                collaborators: subtask.collaborators,
                onChange: (collaborators)=>handleCollaboratorsChange(task.id, collaborators, subtask.id),
                menuPortalTarget: menuPortalTarget
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$LinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                onClick: ()=>handleNavigateTo(task.id, subtask.id)
            }, "Show \u279C")))), !readonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7d42e336cb5e10$var$ClickableTd, {
            "aria-hidden": true,
            colSpan: 2,
            onClick: ()=>{
                handleAddSubtask(task.id);
            }
        }, "+ Add subtask")))))), showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        opaque: true
    }) : null);
};
const $ad7d42e336cb5e10$var$Container = (0, $lmFrL.default).div`
  overflow: auto;
  width: 100%;
`;
const $ad7d42e336cb5e10$var$ClickableTd = (0, $lmFrL.default).td`
  cursor: pointer;
`;
const $ad7d42e336cb5e10$var$Table = (0, $lmFrL.default).table`
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  height: 1px;
`;
const $ad7d42e336cb5e10$var$HeadRow = (0, $lmFrL.default).tr`
  font-size: 12px;
  height: 55px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  th {
    text-align: left;
    padding-left: 6px;
    padding-right: 6px;
  }

  th:first-child {
    padding-left: 12px;
  }

  th:last-child {
    padding-right: 12px;
  }
`;
const $ad7d42e336cb5e10$var$TimelineTh = (0, $lmFrL.default).th`
  padding-left: 12px;
`;
const $ad7d42e336cb5e10$var$Row = (0, $lmFrL.default).tr`
  height: 100%;
  border-bottom: 0.1px solid #f3efef;

  td {
    padding: 6px;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  td:first-child {
    padding-left: 12px;
  }

  td:last-child {
    padding-right: 12px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f5f5f5;

    #date-picker {
      background-color: #f5f5f5;
    }
  }
`;
const $ad7d42e336cb5e10$var$DotContainer = (0, $lmFrL.default).td`
  padding-top: 0;
  padding-bottom: 0;
  height: inherit;

  & > div {
    margin-left: 8px;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    height: inherit;

    &:after {
      content: "";
      position: absolute;
      height: calc(100% + 14px);
      top: -7px;
      left: -0.5px;
      border-left: 1px solid
        ${(props)=>props.color ? props.color : "black"};

      ${({ lastSubtask: lastSubtask })=>lastSubtask && (0, $lmFrL.css)`
          top: -7px;
          height: calc(50% + 7px);
        `}
    }
  }
`;
const $ad7d42e336cb5e10$var$Text = (0, $lmFrL.default).div`
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 3px 3px 3px 0;
  overflow-wrap: break-word;
  text-transform: none;
  white-space: pre-wrap;
  position: relative;

  ${({ readonly: readonly })=>!readonly && (0, $lmFrL.css)`
      padding: 3px 18px 3px 3px;

      &:empty::before {
        content: attr(data-placeholder-name);
        color: #ccc;
        font-weight: 400;
      }
      &:empty:focus::before {
        content: "";
      }

      &::after {
        content: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M0.5 8.75V6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967L5.96967 0.71967C6.26256 0.426777 6.73744 0.426777 7.03033 0.71967L9.28033 2.96967C9.57322 3.26256 9.57322 3.73744 9.28033 4.03033L4.03033 9.28033C3.88968 9.42098 3.69891 9.5 3.5 9.5H1.25C0.835786 9.5 0.5 9.16421 0.5 8.75ZM6.5 2.3107L2 6.8107V8.00004H3.18934L7.68934 3.50004L6.5 2.3107Z' fill='gray' /%3E%3C/svg%3E");
        margin-left: 8px;
        width: 10px;
        height: 10px;
        position: absolute;
        cursor: text;
        display: inline;
        white-space: nowrap;
      }

      min-width: calc(100% - 25px);
      &:hover,
      &:active,
      &:focus-visible {
        border: solid 1px
          ${(props)=>props.theme.newColors.primary.basic};
        outline: 0px solid transparent;
      }
    `}
`;
const $ad7d42e336cb5e10$var$StyledCollaboratorsDropdown = (0, $lmFrL.default)((0, $7d273cd19d2100d4$export$8913b16345c43cb5))`
  max-width: 180px;

  & > div > div:not([class^="Select__control"]) {
    &:not(:last-child) {
      border: 1px solid white;
      border-radius: 50%;
      margin-right: 0;
    }
  }

  .Select__control {
    padding: 0 0 0 3px;
    font-size: 11px;
    line-height: 16px;
  }

  .Select__indicator {
    padding: 2px;
  }
  .Select__value-container .Select__option {
    padding: 6px;
    font-size: 11px;
    line-height: 16px;
  }

  .Select__option {
    font-size: 11px;
    font-weight: normal;
    line-height: 16px;
    padding: 6px;
  }

  .Select__single-value {
    font-size: 11px;
    font-weight: normal;
    line-height: 16px;
  }
`;
const $ad7d42e336cb5e10$var$StyledStatusDropdown = (0, $lmFrL.default)((0, $be57be1003c3e394$export$d8d76cebceb779d8))`
  width: 85px;

  .Select__control {
    padding: 0 0 0 3px;
    font-size: 11px;
    line-height: 16px;
  }

  .Select__indicator {
    padding: 2px;
  }

  .Select__option {
    padding: 8px 8px 8px 6px;
    font-size: 11px;
    line-height: 16px;
  }
`;
const $ad7d42e336cb5e10$var$IconContainer = (0, $lmFrL.default).td`
  width: 1px;
  white-space: nowrap;
  padding: 0 12px 0 24px;
  position: relative;

  svg {
    margin-top: 4px;
    margin-right: 4px;
    height: 16px;
    width: 16px;
  }

  &:after {
    content: "";
    position: absolute;
    height: 40%;
    top: 61%;
    left: 19.5px;
    border-left: 1px solid
      ${(props)=>props.color ? props.color : "black"};
  }
`;
const $ad7d42e336cb5e10$var$LinkContainer = (0, $lmFrL.default).td`
  span {
    transition: 300ms;
    cursor: pointer;
    color: #3b79d1;
  }

  span:hover {
    transition: 300ms;
    font-weight: bold;
    color: #1f5fbc;
  }
`;
const $ad7d42e336cb5e10$var$DatePickerContainer = (0, $lmFrL.default).td`
  width: 1px;
  white-space: nowrap;
`;
const $ad7d42e336cb5e10$var$StyledDatePicker = (0, $lmFrL.default)((0, $db52be5984f608c1$export$5109c6dd95d8fb00))`
  #date-picker {
    margin: 0;
    font-weight: 300;
    font-size: 11px;
    width: 120px;
    text-transform: capitalize;
  }

  #date-picker:hover {
    ${({ readonly: readonly })=>!readonly && (0, $lmFrL.css)`
        font-weight: bold;
        transition: 200ms;
      `}
  }
`;
const $ad7d42e336cb5e10$var$PriceContainer = (0, $lmFrL.default).td`
  width: 1px;
  white-space: nowrap;
`;
const $ad7d42e336cb5e10$var$StyledUsersSelector = (0, $lmFrL.default)((0, $02448428349d6ff4$export$bf32bf315ebc4261))`
  margin: 0;
  display: block;
  padding: 0;
  height: auto;
  width: max-content;
  min-width: 140px;
  position: initial;

  ${({ readonly: readonly })=>readonly && (0, $lmFrL.css)`
      display: flex;

      & > div {
        max-width: 100px;
      }
    `}

  & > div {
    width: auto;
  }

  .Select__control {
    padding: 0 0 0 4px;
    font-size: 11px;
    line-height: 16px;
  }

  .Select__indicator {
    padding: 2px;
  }

  .Select__option {
    padding: 8px 8px 8px 6px;
    font-size: 11px;
    line-height: 16px;
  }

  .Select__value-container > div > div {
    font-size: 11px;
    margin-left: 5px;
    width: auto;
  }

  .Select__menu-list > div > div {
    margin-left: 5px;
    width: auto;
  }
`;






const $e8c9061cb8c578d7$var$statuses = [
    {
        label: "Finished",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Finished
    },
    {
        label: "Ongoing",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Ongoing
    },
    {
        label: "Approved",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Approved
    },
    {
        label: "Pending",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Pending
    },
    {
        label: "Cancelled",
        value: (0, $7608a8bbcbbad14c$export$3f6d0f4ada384a91).Cancelled
    }
];
const $e8c9061cb8c578d7$export$a95ea6b55a8407e0 = (_props)=>{
    const { projectId: projectId } = (0, $66249767282b1118$export$99eaa27ddbbb95ef)();
    const { useUserPermissions: useUserPermissions } = (0, $81af44909bdca59e$export$ba88e5bb9748875d)();
    const { user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const { error: error, loading: loading, samples: samples, setSelectedSample: setSelectedSample, users: users, selectedSample: selectedSample, workflows: workflows } = (0, $379834141212cc85$export$5dd1db33bd4289c2)({
        projectId: projectId
    });
    const [tasks, setTasks] = (0, $acw62.useState)([]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Query Error: ", error);
    const handleDropdownChange = async (selectedValue)=>{
        setSelectedSample(selectedValue);
    };
    const samplesDropdown = samples.map((sample)=>({
            value: sample.id,
            label: (0, $3574c953af361bd9$export$ce8e6cb7a6a45690)(sample)
        }));
    const getColorFromIndex = (index)=>{
        const colorIndex = index % (0, $b18a70253dacc3de$export$2a77c5ae3792996e).length;
        const color = (0, $b18a70253dacc3de$export$2a77c5ae3792996e)[colorIndex];
        return color.color;
    };
    const getTasks = (workflowsToChange)=>{
        let preferredCurrency = (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        try {
            preferredCurrency = localStorage.getItem("preferredCurrency") || (0, $7608a8bbcbbad14c$export$b733e092f9f44b2c).Eur;
        } catch (err) {
        // do nothing
        }
        return workflowsToChange.map((workflow)=>{
            const workflowIndex = workflowsToChange.findIndex((enabledWorkflow)=>workflow.id === enabledWorkflow.id);
            const subtasks = workflow.services.map((service)=>{
                const subtaskStartDate = new Date(+service.startDate).setHours(0, 0, 0, 0);
                const subtaskEndDate = new Date(+service.endDate).setHours(23, 59, 59, 59);
                const durationDays = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(subtaskEndDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(subtaskStartDate), "days") + 1;
                const duration = `${durationDays} ${durationDays && durationDays > 1 ? "Days" : "Day"}`;
                const foundAssignee = users.find((u)=>u.id === service.assignee);
                const assignee = foundAssignee ? {
                    id: foundAssignee.id,
                    name: foundAssignee.name,
                    picture: foundAssignee.avatar
                } : undefined;
                const budget = {
                    price: service.price?.price.value || "",
                    currency: service.price?.currency || preferredCurrency
                };
                return {
                    id: service.id,
                    name: service.name,
                    status: $e8c9061cb8c578d7$var$statuses.find((status)=>status.value === service.status)?.value || $e8c9061cb8c578d7$var$statuses[3].value,
                    startDate: new Date(subtaskStartDate),
                    endDate: new Date(subtaskEndDate),
                    duration: duration,
                    durationLocked: service.durationLocked || false,
                    budget: budget,
                    assignee: assignee,
                    collaborators: service.collaborators || undefined
                };
            });
            const startDates = workflow.services.map((service)=>+service.startDate);
            const endDates = workflow.services.map((service)=>+service.endDate);
            const workflowStartDate = new Date(Math.min(...startDates)).setHours(0, 0, 0, 0);
            const workflowEndDate = new Date(Math.max(...endDates)).setHours(23, 59, 59, 59);
            const durationDays = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(workflowEndDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(workflowStartDate), "days") + 1;
            const duration = `${durationDays} ${durationDays && durationDays > 1 ? "Days" : "Day"}`;
            const foundAssignee = users.find((u)=>u.id === workflow.assignee);
            const assignee = foundAssignee ? {
                id: foundAssignee.id,
                name: foundAssignee.name,
                picture: foundAssignee.avatar
            } : undefined;
            const budget = {
                price: workflow.price?.price.value || "",
                currency: workflow.price?.currency || preferredCurrency
            };
            return {
                id: workflow.id,
                color: getColorFromIndex(workflowIndex),
                name: workflow.name,
                assignee: assignee,
                startDate: new Date(workflowStartDate),
                endDate: new Date(workflowEndDate),
                duration: duration,
                budget: budget,
                subtasks: subtasks,
                collaborators: workflow.collaborators || undefined
            };
        });
    };
    const reloadTasks = ()=>{
        setTasks(getTasks(workflows));
    };
    (0, $acw62.useEffect)(()=>{
        setTasks(getTasks(workflows));
    }, [
        workflows
    ]);
    const userRoleInSample = samples?.find((s)=>s.id === selectedSample.value)?.assignedUsers?.find((assignedUser)=>assignedUser?.id === user.sub)?.role;
    const editServiceAvailable = useUserPermissions("editServiceInformations", userRoleInSample);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Project Tasks Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e8c9061cb8c578d7$var$DropdownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e8c9061cb8c578d7$var$StyledDropdown, {
        options: samplesDropdown,
        onChange: handleDropdownChange,
        value: selectedSample,
        menuPortalTarget: null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e8c9061cb8c578d7$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad7d42e336cb5e10$export$47130d0982a49524), {
        projectId: projectId,
        sampleId: selectedSample.value,
        tasks: tasks,
        setTasks: setTasks,
        reloadTasks: reloadTasks,
        readonly: !editServiceAvailable
    })), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e8c9061cb8c578d7$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), {
        containerSize: true,
        opaque: true
    })));
};
const $e8c9061cb8c578d7$var$DropdownContainer = (0, $lmFrL.default).div`
  margin-bottom: 16px;
`;
const $e8c9061cb8c578d7$var$TableContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 36px;
  row-gap: 40px;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px #d1d5d8;
  border-radius: 8px;
  border: 1px solid #dedede;
`;
const $e8c9061cb8c578d7$var$StyledDropdown = (0, $lmFrL.default)((0, $ce830298ea9125dd$export$931cbfb6bfb85fc))`
  padding: 0;
  max-width: 294px;
`;
const $e8c9061cb8c578d7$var$SpinnerContainer = (0, $lmFrL.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $45fvw = parcelRequire("45fvw");







const $8374305fee1a9a36$export$974318e8ccdf0391 = (_props)=>{
    const { error: error, loading: loading, data: data } = (0, $7608a8bbcbbad14c$export$a040723abd7b5c86)();
    (0, $acw62.useEffect)(()=>{
        document.title = "Leaderna Platform";
    }, []);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6c7161d63500fca$export$2e2bcd8739ae039), null);
    if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
    const projects = data.Projects || [];
    const projectsNumber = projects.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "All projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d241d256ce3eb5d1$export$4fb75e6b75cdeeea), {
        projectsNumber: projectsNumber,
        selectedView: "grid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8374305fee1a9a36$var$ProjectsContainer, {
        id: "projects-container"
    }, projects.map((project)=>{
        const onClickLink = `tasks/${project.id}`;
        const projectLastActivityDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(project.lastActivity ? parseInt(project.lastActivity, 10) : undefined).format("Do MMMM YYYY");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0088b6913e751ef0$export$b3ae466e79cecc68), {
            key: project.id,
            projectId: project.id,
            projectLastActivity: projectLastActivityDateString,
            projectName: (0, $30737cddea16cf18$export$2cd058184eb75757)(project),
            currentService: project.currentService,
            onClick: ()=>(0, $f125bbca2c654db8$export$ff7962acd6052c28)(onClickLink)
        });
    })));
};
const $8374305fee1a9a36$var$ProjectsContainer = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;



var $acw62 = parcelRequire("acw62");



var $lmFrL = parcelRequire("lmFrL");

var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.3.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.0/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.3.0';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});




/* eslint-disable @typescript-eslint/camelcase */ const $81b98fb9de868a7b$export$91a1e2a10aca6e86 = '3.2.P\n \nDRUG PRODUCT (\nN\nAME, DOSAGE FORM)\n3.2.P.1\n \nDescription and Composition of the Drug Product (name, dosage form)\nA\n \ndescription\n \nof\n \nthe\n \ndrug\n \nproduct\n \nand\n \nits\n \ncomposition\n \nshould\n \nbe\n \nprovided.\n \nThe\ninformation provided should include, for example:\n\u2022\n \nDescription\n2\n \nof the dosage form;\n\u2022\n \nComposition, i.e., list of all components of the dosage form, and their amount on a\nper-unit basis (including overages, if any) the function of the components, and a\nreference\n \nto\n \ntheir\n \nquality\n \nstandards\n \n(e.g.,\n \ncompendial\n \nmonographs\n \nor\nmanufacturer\u2019s specifications):\n\u2022\n \nDescription of accompanying reconstitution diluent(s); and\n\u2022\n \nType of container and closure used for the dosage form and accompanying\nreconstitution diluent, if applicable.\nReference CPMP-ICH\n \nGuidelines: \u201CSpecifications \u2013 Test Procedures and Acceptance\nCriteria for New Drug Substances and New Drug Products \u2013 Chemical Substances\u201D,\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts\u201D\n3.2.P.2\n \nPharmaceutical Development (name, dosage form)\nThe Pharmaceutical Development section should contain information on the development\nstudies conducted to establish that the dosage form, the formulation, manufacturing\nprocess, container closure system, microbiological attributes and usage instructions are\nappropriate for the purpose specified in the application. The studies described here are\ndistinguished\n \nfrom\n \nroutine\n \ncontrol\n \ntests\n \nconducted\n \naccording\n \nto\n \nspecifications.\nAdditionally,\n \nthis\n \nsection\n \nshould\n \nidentify and describe the formulation and process\nattributes\n \n(critical\n \nparameters)\n \nthat\n \ncan\n \ninfluence\n \nbatch\n \nreproducibility,\n \nproduct\nperformance and drug product quality. Supportive data and results from specific studies or\npublished literature can be included within or attached to the Pharmaceutical Development\nsection. Additional supportive data can be referenced to the relevant nonclinical or clinical\nsections of the application.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n\u201COn\n \ndevelopment\n \npharmaceutics\u201D,\n \n\u201CAnnex\n \nto\nDevelopment Pharmaceutics \u2013 Decision Trees for Selection of Sterilisation methods\u201D\n\u201CDevelopment Pharmaceutics for Biotechnological and Biological Products - Annex to NfG\non Development Pharmaceutics\u201D\nReference CPMP Guideline:\n \n\u201Con investigation of bioavailability and bioequivalence\u201D\n3.2.P.2.1\n \nComponents of the Drug Product (name, dosage form)\n3.2.P.2.1.1\n \nDrug Substance (name, dosage form)\nThe compatibility of the drug substance with excipients listed in 3.2.P.1 should be\ndiscussed.\n \nAdditionally,\n \nkey\n \nphysicochemical\n \ncharacteristics\n \n(e.g.,\n \nwater\n \ncontent,\n2\n \nFor a drug product supplied with reconstitution diluent(s), the information on the diluent(s) should be provided\nin a separate part \u201CP\u201D, as appropriate\n\nsolubility, particle size distribution, polymorphic or solid state form) of the drug substance\nthat can influence the performance of the drug product should be discussed.\nFor combination products, the compatibility of drug substances with each other should be\ndiscussed.\n3.2.P.2.1.2\n \nExcipients (name, dosage form)\nThe choice of excipients listed in 3.2.P.1, their concentration, their characteristics that can\ninfluence the drug product performance should be discussed relative to their respective\nfunctions.\nReference CPMP Guideline: "Excipients in the Dossier for application for marketing\nauthorisation of a medicinal product"\n3.2.P.2.2\n \nDrug Product (name, dosage form)\n3.2.P.2.2.1\n \nFormulation Development (name, dosage form)\nA brief summary describing the development of the drug product should be provided,\ntaking into consideration the proposed route of administration and usage. The differences\nbetween clinical formulations and the formulation (i.e. composition) described in 3.2.P.1\nshould be discussed.\n \nResults from comparative in vitro studies (e.g., dissolution) or\ncomparative in vivo studies (e.g., bioequivalence) should be discussed when appropriate.\n3.2.P.2.2.2\n \nOverages (name, dosage form)\nAny overages in the formulation(s) described in 3.2.P.1 should be justified.\n3.2.P.2.2.3\n \nPhysicochemical and Biological Properties (name, dosage form)\nParameters relevant to the performance of the drug product, such as pH, ionic strength,\ndissolution,\n \nredispersion,\n \nreconstitution,\n \nparticle\n \nsize\n \ndistribution,\n \naggregation,\npolymorphism,\n \nrheological\n \nproperties,\n \nbiological\n \nactivity\n \nor\n \npotency,\n \nand/or\nimmunological activity, should be addressed.\n3.2.P.2.3\n \nManufacturing Process Development (name, dosage form)\nThe selection and optimisation of the manufacturing process described in 3.2.P.3.3, in\nparticular its critical aspects, should be explained.\n \nWhere relevant, the method of\nsterilisation should be explained and justified.\nDifferences\n \nbetween\n \nthe\n \nmanufacturing\n \nprocess(es)\n \nused\n \nto\n \nproduce\n \npivotal\n \nclinical\nbatches and the process described in 3.2.P.3.3 that can influence the performance of the\nproduct should be discussed.\nReference CPMP-ICH Guideline: \u201CComparability of medicinal products containing\nbiotechnology-derived proteins as active drug substance\u201D\n\n3.2.P.2.4\n \nContainer Closure System (name, dosage form)\nThe suitability of the container closure system (described in 3.2.P.7) used for the storage,\ntransportation (shipping) and use of the drug product should be discussed. This discussion\nshould consider, e.g., choice of materials, protection from moisture and light, compatibility\nof the materials of construction with the dosage form (including sorption to container and\nleaching) safety of materials of construction, and performance (such as reproducibility of\nthe dose delivery from the device when presented as part of the drug product).\n3.2.P.2.5\n \nMicrobiological Attributes (name, dosage form)\nWhere appropriate, the microbiological attributes of the dosage form should be discussed,\nincluding, for example, the rationale for not performing microbial limits testing for non-\nsterile products and the selection and effectiveness of preservative systems in products\ncontaining antimicrobial preservatives.\n \nFor sterile products, the integrity of the container\nclosure system to prevent microbial contamination should be addressed.\nReference CPMP Guideline: "Guideline on the use of antioxidants and preservatives in\nmedicinal products"\n3.2.P.2.6\n \nCompatibility (name, dosage form)\nThe compatibility of the drug product with reconstitution diluent(s) or dosage devices\n(e.g., precipitation of drug substance in solution, sorption on injection vessels, stability)\nshould be addressed to provide appropriate and supportive information for the labeling.\n3.2.P.3\n \nManufacture (name, dosage form)\n3.2.P.3.1\n \nManufacturer(s) (name, dosage form)\nThe name, address, and responsibility of each manufacturer, including contractors, and\neach proposed production site or facility involved in manufacturing and testing should be\nprovided.\nReference CPMP Guideline: "On Manufacture of the finished dosage form"\n3.2.P.3.2\n \nBatch Formula (name, dosage form)\nA batch formula should be provided that includes a list of all components of the dosage\nform to be used in the manufacturing process, their amounts on a per batch basis, including\noverages, and a reference to their quality standards.\nReference CPMP Guideline: " On Manufacture of the finished dosage form"\n3.2.P.3.3\n \nDescription of\n \nManufacturing\n \nProcess\n \nand\n \nProcess\n \nControls\n \n(name,\ndosage form)\n\nA flow diagram should be presented giving the steps of the process and showing where\nmaterials enter the process. The critical steps and points at which process controls,\nintermediate tests or final product controls are conducted should be identified.\nA narrative description of the manufacturing process, including packaging, that represents\nthe sequence of steps undertaken and the scale of production should also be provided.\nNovel processes or technologies and packaging operations that directly affect product\nquality should be described with a greater level of detail. Equipment should, at least, be\nidentified by type (e.g., tumble blender, in-line homogeniser) and working capacity, where\nrelevant.\nSteps in the process should have the appropriate process parameters identified, such as\ntime, temperature, or pH. Associated numeric values can be presented as an expected\nrange. Numeric ranges for critical steps should be justified in Section 3.2.P.3.4. In certain\ncases, environmental conditions (e.g., low humidity for an effervescent product) should be\nstated.\nProposals for the reprocessing of materials should be justified. Any data to support this\njustification should be either referenced or filed in this section (3.2.P.3.3).\nAdditionally for Biotech see 3.2.A.1 for facilities, if appropriate.\nReference CPMP Guideline: " On Manufacture of the finished dosage form"\n3.2.P.3.4\n \nControls of Critical Steps and Intermediates (name, dosage form)\nCritical Steps:\n \nTests and acceptance criteria should be provided (with justification,\nincluding experimental data) performed at the critical steps identified in 3.2.P.3.3 of the\nmanufacturing process, to ensure that the process is controlled.\nIntermediates:\n \nInformation on the quality and control of intermediates isolated during the\nprocess should be provided.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Validation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\nterminology", "Validation of analytical procedures: methodology", "Specifications - Test\nProcedures and Acceptance Criteria for New Drug Substances and New Drug Products -\nChemical\n \nSubstances",\n \n"Specifications:\n \nTest\n \nProcedures\n \nand\n \nAcceptance\n \nCriteria\n \nfor\nBiotechnological/ Biological Products"\nReference CPMP Guideline: " On Manufacture of the finished dosage form"\n3.2.P.3.5\n \nProcess Validation and/or Evaluation (name, dosage form)\nDescription, documentation, and results of the validation and/or evaluation studies should\nbe provided for critical steps or critical assays used in the manufacturing process (e.g.,\nvalidation of the sterilisation process or aseptic processing or filling).\n \nViral safety\nevaluation should be provided in 3.2.A.2, if necessary.\nReference CPMP-ICH Guideline: "Specifications: Test Procedures and Acceptance Criteria\nfor Biotechnological/ Biological Products"\nReference CPMP Guidelines: " On Manufacture of the finished dosage form", \u201CProcess\nValidation\u201D, \u201CParametric Release\u201D\n\n3.2.P.4\n \nControl of Excipients (name, dosage form)\nReference CPMP Guidelines: "Excipients in the Dossier for application for marketing\nauthorisation\n \nof\n \na\n \nmedicinal\n \nproduct",\n \n"Guideline\n \non\n \nthe\n \nuse\n \nof\n \nantioxidants\n \nand\npreservatives in medicinal products"\n3.2.P.4.1\n \nSpecifications (name, dosage form)\nThe specifications for excipients should be provided.\nReference CPMP-ICH\n \nGuidelines: \u201CSpecifications \u2013 Test Procedures and Acceptance\nCriteria for New Drug Substances and New Drug Products \u2013 Chemical Substances\u201D,\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts\u201D\n3.2.P.4.2\n \nAnalytical Procedures (name, dosage form)\nThe analytical procedures used for testing the excipients should be provided, where\nappropriate.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Validation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\nterminology",\n \n\u201CSpecifications:\n \nTest\n \nProcedures\n \nand\n \nAcceptance\n \nCriteria\n \nfor\nBiotechnological/ Biological Products\u201D\n3.2.P.4.3\n \nValidation of Analytical Procedures (name, dosage form)\nAnalytical\n \nvalidation\n \ninformation,\n \nincluding\n \nexperimental\n \ndata,\n \nfor\n \nthe\n \nanalytical\nprocedures used for testing the excipients should be provided, where appropriate.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Validation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\nterminology", "Validation of analytical procedures: methodology",\n \n\u201CSpecifications: Test\nProcedures and Acceptance Criteria for Biotechnological/ Biological Products\u201D\n3.2.P.4.4\n \nJustification of Specifications (name, dosage form)\nJustification\n \nfor\n \nthe\n \nproposed\n \nexcipient\n \nspecifications\n \nshould\n \nbe\n \nprovided,\n \nwhere\nappropriate.\nReference CPMP-ICH Guidelines:\n \n"Impurities: residual solvents", \u201CSpecifications: Test\nProcedures and Acceptance Criteria for Biotechnological/ Biological Products\u201D\n3.2.P.4.5\n \nExcipients of Human or Animal Origin (name, dosage form)\nFor excipients of human or animal origin, information should be provided regarding\nadventitious agents (e.g., sources, specifications; description of the testing performed; viral\nsafety data). (Details in 3.2.A.2).\nReference CPMP-ICH Guidelines:\n \n"Viral Safety Evaluation of Biotechnology Products\nDerived From Cell Lines of Human or Animal Origin", "Derivation and Characterisation of\nCell\n \nSubstrates\n \nUsed\n \nfor\n \nProduction\n \nof\n \nBiotechnological/\n \nBiological\n \nProducts",\n\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts\u201D\nReference\n \nCPMP/CVMP\n \nGuideline:\n \n\u201CNote\n \nfor\n \nGuidance\n \non\n \nMinimising\n \nthe\n \nRisk\n \nof\nTransmitting\n \nAnimal\n \nSpongiform\n \nEncephalopathy\n \nAgents\n \nvia\n \nHuman\n \nand\n \nVeterinary\nMedicinal Products\u201D\n3.2.P.4.6\n \nN\novel Excipients (name, dosage form)\nFor\n \nexcipient(s)\n \nused\n \nfor\n \nthe\n \nfirst\n \ntime\n \nin\n \na\n \ndrug\n \nproduct\n \nor\n \nby\n \na\n \nnew\n \nroute\n \nof\nadministration, full details of manufacture, characterisation, and controls, with cross\nreferences to supporting safety data (nonclinical and/or clinical) should be provided\naccording to the drug substance format. (Details in 3.2.A.3).\nReference CPMP Guideline: "On development pharmaceutics"\n3.2.P.5\n \nControl of Drug Product (name, dosage form)\nReference CPMP Guideline: "Specifications and Control Tests on the finished product"\n3.2.P.5.1\n \nSpecification(s) (name, dosage form)\nThe specification(s) for the drug product should be provided.\nReference CPMP-ICH Guidelines: "Impurities in new drug products", \u201CSpecifications \u2013\nTest Procedures and Acceptance Criteria for New Drug Substances and New Drug Products\n\u2013 Chemical Substances\u201D, \u201CSpecifications: Test Procedures and Acceptance Criteria for\nBiotechnological/ Biological Products\u201D\n3.2.P.5.2\n \nAnalytical Procedures (name, dosage form)\nThe analytical procedures used for testing the drug product should be provided.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Validation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\nterminology",\n \n\u201CSpecifications:\n \nTest\n \nProcedures\n \nand\n \nAcceptance\n \nCriteria\n \nfor\nBiotechnological/ Biological Products\u201D\n3.2.P.5.3\n \nValidation of Analytical Procedures (name, dosage form)\nAnalytical\n \nvalidation\n \ninformation,\n \nincluding\n \nexperimental\n \ndata,\n \nfor\n \nthe\n \nanalytical\nprocedures used for testing the drug product, should be provided.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Validation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\nterminology", "Validation of analytical procedures: methodology",\n \n\u201CSpecifications: Test\nProcedures and Acceptance Criteria for Biotechnological/ Biological Products\u201D\n3.2.P.5.4\n \nBatch Analyses (name, dosage form)\nA description of batches and results of batch analyses should be provided.\nReference CPMP-ICH Guidelines:\n \n"Impurities in new drug products", " Impurities: residual\nsolvents", \u201CSpecifications \u2013 Test Procedures and Acceptance Criteria for New Drug Substances\n\nand\n \nNew\n \nDrug\n \nProducts\n \n\u2013\n \nChemical\n \nSubstances\u201D,\n \n\u201CSpecifications:\n \nTest\n \nProcedures\n \nand\nAcceptance Criteria for Biotechnological/ Biological Products\u201D\n3.2.P.5.5\n \nCharacterisation of Impurities (name, dosage form)\nInformation on the characterisation of impurities should be provided, if not previously\nprovided in "3.2.S.3.2 Impurities".\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Impurities\n \nin\n \nnew\n \ndrug\n \nproducts",\n \n"Quality\n \nof\nBiotechnological Products: Stability Testing of Biotechnological/ Biological Products",\n\u201CSpecifications \u2013 Test Procedures and Acceptance Criteria for New Drug Substances and\nNew\n \nDrug\n \nProducts\n \n\u2013\n \nChemical\n \nSubstances\u201D,\n \n\u201CSpecifications:\n \nTest\n \nProcedures\n \nand\nAcceptance Criteria for Biotechnological/ Biological Products"\n3.2.P.5.6\n \nJustification of Specification(s) (name, dosage form)\nJustification for the proposed drug product specification(s) should be provided.\nReference\n \nCPMP-ICH\n \nGuidelines:\n \n"Impurities\n \nin\n \nnew\n \ndrug\n \nproducts",\n \n"Quality\n \nof\nBiotechnological Products: Stability Testing of Biotechnological/ Biological Products",\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts"\n3.2.P.6\n \nReference Standards or Materials (name, dosage form)\nInformation on the reference standards or reference materials used for testing of the drug\nproduct should be provided, if not previously provided in "3.2.S.5 Reference Standards or\nMaterials".\nReference CPMP-ICH Guidelines: "Quality of Biotechnological Products: Stability Testing\nof Biotechnological/ Biological Products", \u201CSpecifications: Test Procedures and Acceptance\nCriteria for Biotechnological/ Biological Products"\n3.2.P.7\n \nContainer Closure System (name, dosage form)\nA description of the container closure systems should be provided, including the identity\nof materials of construction of each primary packaging component and its specification.\nThe specifications should include description and identification (and critical dimensions,\nwith drawings where appropriate). Non-compendial methods (with validation) should be\nincluded where appropriate.\nFor non-functional secondary packaging components (e.g., those that neither provide\nadditional protection nor serve to deliver the product), only a brief description should be\nprovided. For functional secondary packaging components, additional information should\nbe provided.\nSuitability information should be located in 3.2.P.2.\nReference CPMP Guideline: "Plastic Primary Packaging Materials".\n\n3.2.P.8\n \nStability (name, dosage form)\nReference CPMP Guideline: "On reduced stability testing - bracketing and matrixing"\n3.2.P.8.1\n \nStability Summary and Conclusion (name, dosage form)\nThe types of studies conducted, protocols used, and the results of the studies should be\nsummarized. The summary should include, for example, conclusions with respect to\nstorage conditions and shelf-life, and, if applicable, in-use storage conditions and shelf-\nlife.\nReference CPMP-ICH Guidelines: \u201CStability testing guidelines: stability testing of new drug\nsubstances and products\u201D, \u201CStability testing: photostability testing of new drug substances\nand products\u201D, "Impurities in new drug products", \u201CQuality of Biotechnological Products:\nStability\n \nTesting\n \nof\n \nBiotechnological/\n \nBiological\n \nProducts",\n \n"Specifications\n \n-\n \nTest\nProcedures and Acceptance Criteria for New Drug Substances and New Drug Products -\nChemical Substances"\nReference CPMP Guidelines: "on stability testing of existing active substances and related\nfinished products ", "On maximum shelf-life for sterile products for human use after first\nopening\n \nor\n \nfollowing\n \nreconstitution",\n \n"On\n \nthe\n \ndeclaration\n \nof\n \nstorage\n \nconditions\n \nfor\nmedicinal products in the products particulars and for active substances", \u201CIn-Use stability\ntesting of human medicinal products\u201D\n3.2.P.8.2\n \nPost-approval\n \nStability\n \nProtocol\n \nand\n \nStability\n \nCommitment\n \n(name,\ndosage form)\nThe post-approval stability protocol and stability commitment should be provided.\nReference CPMP-ICH Guidelines: \u201CStability testing guidelines: stability testing of new drug\nsubstances and products\u201D, \u201CQuality of Biotechnological Products: Stability Testing of\nBiotechnological/ Biological Products",\nReference CPMP Guideline: "\n \non stability testing of existing active substances and related\nfinished products "\n3.2.P.8.3\n \nStability Data (name, dosage form)\nResults of the stability studies should be presented in an appropriate format (e.g. tabular,\ngraphical, narrative).\n \nInformation on the analytical procedures used to generate the data\nand validation of these procedures should be included.\nInformation on characterisation of impurities is located in 3.2.P.5.5.\nReference CPMP-ICH Guidelines: \u201CStability testing guidelines: stability testing of new drug\nsubstances and products\u201D, \u201CStability testing: photostability testing of new drug substances\nand\n \nproducts\u201D,\n \n\u201CValidation\n \nof\n \nanalytical\n \nmethods:\n \ndefinitions\n \nand\n \nterminology\u201D,\n\u201CValidation\n \nof\n \nanalytical\n \nprocedures:\n \nmethodology\u201D,\n \n\u201CQuality\n \nof\n \nBiotechnological\nProducts: Stability Testing of Biotechnological/ Biological Products"\nReference CPMP Guidelines: "\n \non stability testing of existing active substances and related\nfinished products ", \u201CIn-Use stability testing of human medicinal products\u201D\n\n \n3.2.A\n \nAPPE\nN\nDICES\n3.2.A.1\n \nFacilities and Equipment (name, manufacturer)\nBiotech:\nA\n \ndiagram\n \nshould\n \nbe\n \nprovided\n \nillustrating\n \nthe\n \nmanufacturing\n \nflow\n \nincluding\nmovement of raw materials, personnel, waste, and intermediate(s) in and out of the\nmanufacturing areas.\n \nInformation should be presented with respect to adjacent\nareas or rooms that may be of concern for maintaining integrity of the product.\nInformation\n \non\n \nall\n \ndevelopmental\n \nor\n \napproved\n \nproducts\n \nmanufactured\n \nor\nmanipulated in the same areas as the applicant\'s product should be included.\nA summary description of product-contact equipment, and its use (dedicated or\nmulti-use) should be provided. Information on preparation, cleaning, sterilisation,\nand\n \nstorage\n \nof\n \nspecified\n \nequipment\n \nand\n \nmaterials\n \nshould\n \nbe\n \nincluded,\n \nas\nappropriate.\nInformation should be included on procedures (e.g., cleaning and production\nscheduling) and design features of the facility (e.g., area classifications) to prevent\ncontamination or cross-contamination of areas and equipment, where operations for\nthe preparation of cell banks and product manufacturing are performed.\n3.2.A.2\n \nAdventitious\n \nAgents\n \nSafety\n \nEvaluation\n \n(name,\n \ndosage\n \nform,\nmanufacturer)\nInformation assessing the risk with respect to potential contamination with adventitious\nagents should be provided in this section.\nFor non-viral adventitious agents:\nDetailed information should be provided on the avoidance and control of non-viral\nadventitious\n \nagents\n \n(e.g.,\n \ntransmissible\n \nspongiform\n \nencephalopathy\n \nagents,\n \nbacteria,\nmycoplasma, fungi).\n \nThis information can include, for example, certification and/or\ntesting\n \nof\n \nraw\n \nmaterials\n \nand\n \nexcipients,\n \nand\n \ncontrol\n \nof\n \nthe\n \nproduction\n \nprocess,\n \nas\nappropriate for the material, process and agent.\nReference CPMP-ICH Guidelines: "Derivation and Characterisation of Cell Substrates\nUsed\n \nfor\n \nProduction\n \nof\n \nBiotechnological/\n \nBiological\n \nProducts",\n \n\u201CSpecifications:\n \nTest\nProcedures and Acceptance Criteria for Biotechnological/ Biological Products"\nReference CPMP Guideline: "Minimizing the Risk of Transmitting animal Spongiform\nEncephalopathy Agents via Medicinal Products"\nFor viral adventitious agents:\nDetailed information from viral safety evaluation studies should be provided in this\nsection. Viral evaluation studies should demonstrate that the materials used in production\nare considered safe, and that the approaches used to test, evaluate, and eliminate the\npotential risks during manufacturing are suitable.\nReference CPMP-ICH Guidelines: "Viral Safety Evaluation of Biotechnology Products\nDerived From Cell Lines of Human or Animal Origin", "Derivation and Characterisation of\n\nCell\n \nSubstrates\n \nUsed\n \nfor\n \nProduction\n \nof\n \nBiotechnological/\n \nBiological\n \nProducts",\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts"\nReference\n \nCPMP\n \nGuideline:\n \n"\n \nvirus\n \nvalidation\n \nstudies:\n \nthe\n \ndesign,\n \ncontribution\n \nand\ninterpretation of studies validating the inactivation and removal of viruses\u201D\nMaterials of Biological Origin\nInformation essential to evaluate the virological safety of materials of animal or\nhuman origin (e.g. biological fluids, tissue, organ, cell lines) should be provided.\n(See related information in 3.2.S.2.3, and 3.2.P.4.5). For cell lines, information on\nthe selection, testing, and safety assessment for potential viral contamination of the\ncells and viral qualification of cell banks should also be provided. (See related\ninformation in 3.2.S.2.3).\nTesting at appropriate stages of production\nThe selection of virological tests that are conducted during manufacturing (e.g., cell\nsubstrate, unprocessed bulk or post viral clearance testing) should be justified. The\ntype of test, sensitivity and specificity of the test, if applicable, and frequency of\ntesting should be included.\n \nTest results to confirm, at an appropriate stage of\nmanufacture, that the product is free from viral contamination should be provided.\n(See related information in 3.2.S.2.4 and 3.2.P.3.4 ).\nViral Testing of Unprocessed Bulk\nIn accordance with Q5A and Q6B, results for viral testing of unprocessed bulk\nshould be included.\nViral Clearance Studies\nIn accordance with Q5A, the rationale and action plan for assessing viral clearance\nand the results and evaluation of the viral clearance studies should be provided.\nData can include those that demonstrate the validity of the scaled-down model\ncompared to the commercial scale process; the adequacy of viral inactivation or\nremoval procedures for manufacturing equipment and materials; and manufacturing\nsteps that are capable of removing or inactivating viruses. (See related information\nin 3.2.S.2.5 and 3.2.P.3.5).\nReference CPMP-ICH Guidelines: "Viral Safety Evaluation of Biotechnology Products\nDerived From Cell Lines of Human or Animal Origin", "Derivation and Characterisation of\nCell\n \nSubstrates\n \nUsed\n \nfor\n \nProduction\n \nof\n \nBiotechnological/\n \nBiological\n \nProducts",\n\u201CSpecifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological\nProducts\u201D\nReference CPMP Guideline: \u201CVirus Validation Studies: The Design, Contribution and\nInterpretation of Studies Validating the Inactivation and Removal of Viruses\u201D\n3.2.A.3\n \nExcipients\n\nModule 3.2.R\nRegional Information\nFor EU\nAny additional drug substance/active substance and/or drug product information\nspecific\n \nto\n \neach\n \nregion\n \nshould\n \nbe\n \nprovided\n \nin\n \nsection\n \nR\n \nof\n \nthe\n \napplication.\nApplicants should consult the appropriate regional guidelines and/or regulatory\nauthorities for additional guidance.\n\u2022\n \nProcess Validation Scheme for the Drug Product\nReference CPMP-ICH Guideline\n:\n \nNote for Guidance on Process Validation\n(CPMP/QWP/848/96, EMEA/CVMP/598/99)\n\u2022\n \nMedical Device\n\u2022\n \nCertificate(s) of Suitability\n\u2022\n \nMedicinal\n \nproducts\n \ncontaining\n \nor\n \nusing\n \nin\n \nthe\nmanufacturing process materials of animal and/or human\norigin\nCompliance with the Annex I to Dir. 2001/83/EC, Part I, Module 2, paragraph\n3.2 (9)\n\u201C\n(9)\n \nSpecific measures concerning the prevention of the transmission of animal\nspongiform encephalopathies (materials from ruminant origin): at each step of the\nmanufacturing process, the applicant must demonstrate the compliance of the\nmaterials used with the Note for Guidance on Minimising the Risk of Transmitting\nAnimal Spongiform Encephalopathy Agents via Medicinal Products and its updates,\npublished by the Commission in the Official Journal of the European Union.\nDemonstration of compliance with the said Note for Guidance can be done by\nsubmitting either, preferably a certificate of suitability to the relevant monograph of\nthe European Pharmacopoeia that has been granted by the European Directorate\nfor the Quality of Medicines or by the supply of scientific data to substantiate this\ncompliance.\u201D\n\nIn the case that scientific data to substantiate this compliance is included in the\nQuality Part of the dossier, then this data should be reviewed in the Quality Overall\nSummary (Module 2.3).\nFor all applications, the table A on \u2018\nMaterials of animal origin\n \ncovered by the Note\nfor Guidance on minimising the risk of transmitting animal spongiform\nencephalopathy agents via medicinal products\u2019\n \nshould be completed .\nTSE Certificates of Suitability (if available) are to be attached.\nFor materials of animal origin other than those covered by the\n \nNote for Guidance on\nminimising the risk of transmitting animal spongiform encephalopathy agents via\nmedicinal products\n, applicants are requested to complete the table B on \u2018\nOther\nmaterials of animal origin\n\u2019.\nIf an application relates to a medicinal product, which contains or uses in the\nmanufacture materials of human origin, applicants are request to complete the table\nC on albumin and other human tissue derived products.\n\nTable A : Materials of animal origin covered by the Note for Guidance on\nminimising the risk of transmitting animal spongiform encephalopathy\nagents via medicinal products\ni\nMedicinal product:\n \n(Invented name/I\nNN\n)\nApplicant:\nDate of completion of table:\nN\name of material\nN\name and address of manufacturer\nii\nSpecies and tissue from which material is\na derivative\nCountry of origin of the source animals for\nthe material cited\nDo you have a TSE-Certificate of\nSuitability\niii\n \nfor the material of animal\norigin? If yes, please put number and date\nof certificate and attach a copy.\nAs active substances\nAs excipient\nAs reagent/ culture medium\ncomponent used in routine\nmanufacture\nAs reagent/ culture medium\ncomponent used in\nestablishment of new master\ncell banks\n \niv\nAs reagent/ culture medium\ncomponent used in\nestablishment of working\ncell banks\nStarting material used in\nmanufacture of active\nsubstances\nUse\nof\nmaterial\nStarting material used in\nmanufacture of excipient\nOther, give details\ni\n \nNote For Guidance on minimising the risk of transmitting animal spongiform encephalopathy agents via\nmedicinal products, Jan 2004 (EMEA/410/01 rev2) or any future revision.\nii\n \nThe manufacturer and not the supplier/broker of the material of animal origin should be mentioned. For the\nsame material from different manufacturers, use a separate column for each manufacturer.\niii\n \nFrom 1 January 2000, manufacturers of materials of animal origin can submit a dossier to the European\nPharmacopoeia to obtain a Certificate of Suitability in accordance with the monograph : \u2018Products at risk of\ntransmitting animal spongiform encephalopathies\u2019.\niv\n \nMaterials of ruminant origin used in the establishment of\n \nexisting\n \nmaster cell banks should be included in\nTable B.\n\nTable B : Other materials of animal origin\n \ni\nMedicinal product:\n \n(Invented name/I\nNN\n)\nApplicant:\nDate of completion of table:\nN\name of material\nN\name and address of manufacturer\nSpecies and tissue from which material is\na derivative\nCountry of origin of the source animals for\nthe material cited\nAs active substances\nAs reagent/ culture medium\ncomponent used in routine\nmanufacture\nAs reagent/ culture medium\ncomponent used in\nestablishment of master cell\nbanks\n \nii\nAs reagent/ culture medium\ncomponent used in\nestablishment of working\ncell banks\nStarting material used in\nmanufacture of active\nsubstances\nAs excipient\nUse\nof\nmaterial\nStarting material used in\nmanufacture of excipient\nOther, give details\ni\n \nMaterials not covered by the Note For Guidance on minimising the risk of transmitting animal spongiform\nencephalopathy agents via medicinal products, Jan 2004 (EMEA/410/01 rev2) or any future revision\nii Materials of ruminant origin used in the establishment of existing master cell banks should also be\nincluded in this Table.';
const $81b98fb9de868a7b$export$8e5a7a72a7f58157 = "Page 25\nModule 3.2.R\nRegional Information\nFor EU\nAny additional drug substance/active substance and/or drug product information\nspecific\n \nto\n \neach\n \nregion\n \nshould\n \nbe\n \nprovided\n \nin\n \nsection\n \nR\n \nof\n \nthe\n \napplication.\nApplicants should consult the appropriate regional guidelines and/or regulatory\nauthorities for additional guidance.\n\u2022\n \nProcess Validation Scheme for the Drug Product\nReference CPMP-ICH Guideline\n:\n \nNote for Guidance on Process Validation\n(CPMP/QWP/848/96, EMEA/CVMP/598/99)\n\u2022\n \nMedical Device\n\u2022\n \nCertificate(s) of Suitability\n\u2022\n \nMedicinal\n \nproducts\n \ncontaining\n \nor\n \nusing\n \nin\n \nthe\nmanufacturing process materials of animal and/or human\norigin\nCompliance with the Annex I to Dir. 2001/83/EC, Part I, Module 2, paragraph\n3.2 (9)\n\u201C\n(9)\n \nSpecific measures concerning the prevention of the transmission of animal\nspongiform encephalopathies (materials from ruminant origin): at each step of the\nmanufacturing process, the applicant must demonstrate the compliance of the\nmaterials used with the Note for Guidance on Minimising the Risk of Transmitting\nAnimal Spongiform Encephalopathy Agents via Medicinal Products and its updates,\npublished by the Commission in the Official Journal of the European Union.\nDemonstration of compliance with the said Note for Guidance can be done by\nsubmitting either, preferably a certificate of suitability to the relevant monograph of\nthe European Pharmacopoeia that has been granted by the European Directorate\nfor the Quality of Medicines or by the supply of scientific data to substantiate this\ncompliance.\u201D\n\nIn the case that scientific data to substantiate this compliance is included in the\nQuality Part of the dossier, then this data should be reviewed in the Quality Overall\nSummary (Module 2.3).\nFor all applications, the table A on \u2018\nMaterials of animal origin\n \ncovered by the Note\nfor Guidance on minimising the risk of transmitting animal spongiform\nencephalopathy agents via medicinal products\u2019\n \nshould be completed .\nTSE Certificates of Suitability (if available) are to be attached.\nFor materials of animal origin other than those covered by the\n \nNote for Guidance on\nminimising the risk of transmitting animal spongiform encephalopathy agents via\nmedicinal products\n, applicants are requested to complete the table B on \u2018\nOther\nmaterials of animal origin\n\u2019.\nIf an application relates to a medicinal product, which contains or uses in the\nmanufacture materials of human origin, applicants are request to complete the table\nC on albumin and other human tissue derived products.\n\nTable A : Materials of animal origin covered by the Note for Guidance on\nminimising the risk of transmitting animal spongiform encephalopathy\nagents via medicinal products\ni\nMedicinal product:\n \n(Invented name/I\nNN\n)\nApplicant:\nDate of completion of table:\nN\name of material\nN\name and address of manufacturer\nii\nSpecies and tissue from which material is\na derivative\nCountry of origin of the source animals for\nthe material cited\nDo you have a TSE-Certificate of\nSuitability\niii\n \nfor the material of animal\norigin? If yes, please put number and date\nof certificate and attach a copy.\nAs active substances\nAs excipient\nAs reagent/ culture medium\ncomponent used in routine\nmanufacture\nAs reagent/ culture medium\ncomponent used in\nestablishment of new master\ncell banks\n \niv\nAs reagent/ culture medium\ncomponent used in\nestablishment of working\ncell banks\nStarting material used in\nmanufacture of active\nsubstances\nUse\nof\nmaterial\nStarting material used in\nmanufacture of excipient\nOther, give details\ni\n \nNote For Guidance on minimising the risk of transmitting animal spongiform encephalopathy agents via\nmedicinal products, Jan 2004 (EMEA/410/01 rev2) or any future revision.\nii\n \nThe manufacturer and not the supplier/broker of the material of animal origin should be mentioned. For the\nsame material from different manufacturers, use a separate column for each manufacturer.\niii\n \nFrom 1 January 2000, manufacturers of materials of animal origin can submit a dossier to the European\nPharmacopoeia to obtain a Certificate of Suitability in accordance with the monograph : \u2018Products at risk of\ntransmitting animal spongiform encephalopathies\u2019.\niv\n \nMaterials of ruminant origin used in the establishment of\n \nexisting\n \nmaster cell banks should be included in\nTable B.\n\nTable B : Other materials of animal origin\n \ni\nMedicinal product:\n \n(Invented name/I\nNN\n)\nApplicant:\nDate of completion of table:\nN\name of material\nN\name and address of manufacturer\nSpecies and tissue from which material is\na derivative\nCountry of origin of the source animals for\nthe material cited\nAs active substances\nAs reagent/ culture medium\ncomponent used in routine\nmanufacture\nAs reagent/ culture medium\ncomponent used in\nestablishment of master cell\nbanks\n \nii\nAs reagent/ culture medium\ncomponent used in\nestablishment of working\ncell banks\nStarting material used in\nmanufacture of active\nsubstances\nAs excipient\nUse\nof\nmaterial\nStarting material used in\nmanufacture of excipient\nOther, give details\ni\n \nMaterials not covered by the Note For Guidance on minimising the risk of transmitting animal spongiform\nencephalopathy agents via medicinal products, Jan 2004 (EMEA/410/01 rev2) or any future revision\nii Materials of ruminant origin used in the establishment of existing master cell banks should also be\nincluded in this Table.\n\nTable C : Albumin and other human tissue derived materials.\nMedicinal product:\n \n(\n \nInvented name/I\nNN\n)\nApplicant:\nDate of completion of table:\nN\name of Material\nSupplier\nTissue from which material is a derivative\nCountry (-ies) where donation took place\nDoes the material have a Marketing\nAuthorisation?\nIf yes, specify Member State(s) and MA\nnumber(s)\nAs active substances\nAs excipient\nAs reagent / culture medium\ncomponent\nUse\nof\nMaterial:\nOther, please specify";
const $81b98fb9de868a7b$export$48eb55df22ff8474 = `3.2
Body of Data
3.2.S DRUG SUBSTANCE1 (NAME, MANUFACTURER)
Reference CPMP Guidelines:
\u{201C}On summary of requirements for active substances in part II of the dossier\u{201D},including the
Certification of Suitability of monographs of the European Pharmacopoeia.(see also NTA,
Vol. 2B \u{2013} introduction).
\u{201C}Active Substance Master File procedure\u{201D}
3.2.S.1
General Information (name, manufacturer)
3.2.S.1.1
Nomenclature (name, manufacturer)
Information on the nomenclature of the drug substance should be provided. For example:
\u{2022} Recommended International Nonproprietary Name (INN);
\u{2022} Compendial name (e.g. European Pharmacopoeia) if relevant;
\u{2022} Chemical name(s);
\u{2022} Company or laboratory code;
\u{2022} Other non-proprietary name(s), e.g., national name, United States Adopted Name
(USAN), Japanese Accepted Name (JAN); British Approved Name (BAN), and
\u{2022} Chemical Abstracts Service (CAS) registry number.
Reference CPMP-Guidelines: \u{201C}Chemistry of New Active Substance\u{201D} and \u{201C}Chemistry of the
Active Substance\u{201D}
3.2.S.1.2
Structure (name, manufacturer)
NCE:
The structural formula, including relative and absolute stereochemistry, the
molecular formula, and the relative molecular mass should be provided.
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and
\u{201C}Chemistry of the Active Substance\u{201D}
Biotech:
The schematic amino acid sequence indicating glycosylation sites or other posttranslational modifications and relative molecular mass should be provided, as
appropriate.
Reference CPMP Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of
the Active Substance\u{201D}
3.2.S.1.3
General Properties (name, manufacturer)
A list should be provided of physicochemical and other relevant properties of the drug
substance, including biological activity for Biotech.
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of Active
Substance\u{201D}
1
For a drug product containing more than one drug substance, the information requested for part \u{201C}S\u{201D} should be
provided in its entirety for each drug substance
Page 6
Reference CPMP-ICH Guidelines: \u{201C}Specifications \u{2013} Test Procedures and Acceptance Criteria for
New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D} and \u{201C}Specifications \u{2013} Test
Procedures and Acceptance criteria for Biotechnological, Biological products\u{201D}
3.2.S.2
Manufacture (name, manufacturer)
3.2.S.2.1
Manufacturer(s) (name, manufacturer)
The name, address, and responsibility of each manufacturer, including contractors, and
each proposed production site or facility involved in manufacturing and testing should be
provided.
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of the
Active Substance\u{201D}
3.2.S.2.2
Description of Manufacturing Process and Process Controls (name,
manufacturer)
The description of the drug substance manufacturing process represents the applicant\u{2019}s
commitment for the manufacture of the drug substance. Information should be provided to
adequately describe the manufacturing process and process controls. For example:
NCE:
A flow diagram of the synthetic process(es) should be provided that includes
molecular formulae, weights, yield ranges, chemical structures of starting
materials, intermediates, reagents and drug substance reflecting stereochemistry,
and identifies operating conditions and solvents.
A sequential procedural narrative of the manufacturing process should be
submitted. The narrative should include, for example, quantities of raw materials,
solvents, catalysts and reagents reflecting the representative batch scale for
commercial manufacture, identification of critical steps, process controls,
equipment and operating conditions (e.g., temperature, pressure, pH, time).
Alternate processes should be explained and described with the same level of detail
as the primary process. Reprocessing steps should be identified and justified. Any
data to support this justification should be either referenced or filed in 3.2.S.2.5.
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of
the Active Substance\u{201D}
Biotech:
Information should be provided on the manufacturing process, which typically
starts with a vial(s) of the cell bank, and includes cell culture, harvest(s),
purification and modification reactions, filling, storage and shipping conditions.
Batch(es) and scale definition
An explanation of the batch numbering system, including information regarding
any pooling of harvests or intermediates and batch size or scale should be provided.
Cell culture and harvest
Page 7
A flow diagram should be provided that illustrates the manufacturing route from
the original inoculum (e.g. cells contained in one or more vials(s) of the Working
Cell Bank up to the last harvesting operation. The diagram should include all steps
(i.e., unit operations) and intermediates. Relevant information for each stage, such
as population doubling levels, cell concentration, volumes, pH, cultivation times,
holding times, and temperature, should be included. Critical steps and critical
intermediates for which specifications are established (as mentioned in 3.2.S.2.4)
should be identified.
A description of each process step in the flow diagram should be provided.
Information should be included on, for example, scale; culture media and other
additives (details provided in 3.2.S.2.3); major equipment (details provided in
3.2.A.1); and process controls, including in-process tests and operational
parameters, process steps, equipment and intermediates with acceptance criteria
(details provided in 3.2.S.2.4). Information on procedures used to transfer material
between steps, equipment, areas, and buildings, as appropriate, and shipping and
storage conditions should be provided. (Details on shipping and storage provided
in 3.2.S.2.4.)
Purification and modification reactions
A flow diagram should be provided that illustrates the purification steps (i.e., unit
operations) from the crude harvest(s) up to the step preceding filling of the drug
substance. All steps and intermediates and relevant information for each stage
(e.g., volumes, pH, critical processing time, holding times, temperatures and
elution profiles and selection of fraction, storage of intermediate, if applicable)
should be included. Critical steps for which specifications are established as
mentioned in 3.2.S.2.4 should be identified.
A description of each process step (as identified in the flow diagram) should be
provided. The description should include information on, for example, scale,
buffers and other reagents (details provided in 3.2.S.2.3, major equipment (details
provided in 3.2.A.1), and materials. For materials such as membranes and
chromatography resins, information for conditions of use and reuse also should be
provided. (Equipment details in 3.2.A.1; validation studies for the reuse and
regeneration of columns and membranes in 3.2.S.2.5.) The description should
include process controls (including in-process tests and operational parameters)
with acceptance criteria for process steps, equipment and intermediates. (Details in
3.2.S.2.4.).
Reprocessing procedures with criteria for reprocessing of any intermediate or the
drug substance should be described. (Details should be given in 3.2.S.2.5.).
Information on procedures used to transfer material between steps, equipment,
areas, and buildings, as appropriate, and shipping and storage conditions should be
provided (details on shipping and storage provided in 3.2.S.2.4.).
Filling, storage and transportation (shipping)
A description of the filling procedure for the drug substance, process controls
(including in-process tests and operational parameters), and acceptance criteria
should be provided. (Details in 3.2.S.2.4.) The container closure system(s) used
Page 8
for storage of the drug substance (details in 3.2.S.6.) and storage and shipping
conditions for the drug substance should be described.
Reference CPMP-ICH Guidelines: \u{201C}Viral Safety Evaluation of Biotechnology Products
Derived From Cell Lines of Human or Animal Origin\u{201D}, \u{201C}Quality of Biotechnological
Products: Analysis of the Expression Construct in Cells Used for Production of r-DNA
Derived Protein Products\u{201D}, \u{201C}Specifications: Test Procedures and Acceptance Criteria for
Biotechnological/ Biological Products\u{201D}.

3.2.S.2.3
Control of Materials (name, manufacturer)
Materials used in the manufacture of the drug substance (e.g., raw materials, starting
materials, solvents, reagents, catalysts) should be listed identifying where each material is
used in the process. Information on the quality and control of these materials should be
provided. Information demonstrating that materials (including biologically-sourced
materials, e.g., media components, monoclonal antibodies, enzymes) meet standards
appropriate for their intended use (including the clearance or control of adventitious
agents) should be provided, as appropriate. For biologically-sourced materials, this can
include information regarding the source, manufacture, and characterisation. (Details in
3.2.A.2 for both NCE and Biotech)
Reference CPMP Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of
the Active Substance\u{201D}
Reference CPMP-ICH Guidelines: \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D},
\u{201C}Specifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological
Products\u{201D}, \u{201C}Use of bovine serum in the manufacture of human biological medicinal
products\u{201D}.
Biotech:
Control of Source and Starting Materials of Biological Origin
Summaries of viral safety information for biologically-sourced materials should be
provided. (Details in 3.2.A.2.)
Source, history, and generation of the cell substrate
Information on the source of the cell substrate and analysis of the expression
construct used to genetically modify cells and incorporated in the initial cell clone
used to develop the Master Cell Bank should be provided as described in CPMPICH Guidelines Q5B and Q5D.
Cell banking system, characterisation, and testing
Information on the cell banking system, quality control activities, and cell line
stability during production and storage (including procedures used to generate the
Master and Working Cell Bank(s)) should be provided as described in CPMP-ICH
Guidelines Q5B and Q5D.
Reference CPMP-ICH Guidelines: \u{201C}Viral Safety Evaluation of Biotechnology Products
Derived From Cell Lines of Human or Animal Origin\u{201D}, \u{201C} Quality of Biotechnological
Products: Analysis of the Expression Construct in Cells Used for Production of r-DNA
Page 9
Derived Protein Products\u{201D}, \u{201C}Quality of Biotechnological Products: Stability Testing of
Biotechnological/ Biological Products\u{201D}, \u{201C}Derivation and Characterisation of Cell
Substrates Used for Production of Biotechnological/ Biological Products\u{201D}
3.2.S.2.4
Controls of Critical Steps and Intermediates (name, manufacturer)
Critical Steps: Tests and acceptance criteria (with justification including experimental
data) performed at critical steps identified in 3.2.S.2.2 of the manufacturing process to
ensure that the process is controlled should be provided.
Intermediates: Information on the quality and control of intermediates isolated during the
process should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D},
\u{201C}Specifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological
Products\u{201D}
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of
the Active Substance\u{201D}
Additionally for Biotech: Stability data supporting storage conditions should be provided.
Reference CPMP-ICH Guideline: \u{201C}Quality of Biotechnological Products: Stability Testing
of Biotechnological/ Biological Products\u{201D}
3.2.S.2.5
Process Validation and/or Evaluation (name, manufacturer)
Process validation and/or evaluation studies for aseptic processing and sterilisation should
be included.
Biotech:
Sufficient information should be provided on validation and evaluation studies to
demonstrate that the manufacturing process (including reprocessing steps) is
suitable for its intended purpose and to substantiate selection of critical process
controls (operational parameters and in-process tests) and their limits for critical
manufacturing steps (e.g., cell culture, harvesting, purification, and modification).
The plan for conducting the study should be described and the results, analysis and
conclusions from the executed study(ies) should be provided. The analytical
procedures and corresponding validation should be cross-referenced (e.g.,
3.2.S.2.4, 3.2.S.4.3) or provided as part of justifying the selection of critical process
controls and acceptance criteria.
For manufacturing steps intended to remove or inactivate viral contaminants, the
information from evaluation studies should be provided in 3.2.A.2.
3.2.S.2.6
Manufacturing Process Development (name, manufacturer)
NCE:
A description and discussion should be provided of the significant changes made to
the manufacturing process and/or manufacturing site of the drug substance used in
producing nonclinical, clinical, scale-up, pilot, and, if available, production scale
batches.
Reference should be made to the drug substance data provided in section 3.2.S.4.4.
Reference CPMP-ICH Guideline: \u{201C}Impurities testing guideline: impurities in new drug
substances
Biotech:
The developmental history of the manufacturing process, as described in 3.2.S.2.2,
should be provided. The description of change(s) made to the manufacture of drug
substance batches used in support of the marketing application (e.g., nonclinical or
clinical studies) should include, for example, changes to the process or to critical
equipment. The reason for the change should be explained. Relevant information
on drug substance batches manufactured during development, such as the batch
number, manufacturing scale, and use (e.g., stability, nonclinical, reference
material) in relation to the change, should be provided.
The significance of the change should be assessed by evaluating its potential to
impact the quality of the drug substance (and/or intermediate, if appropriate). For
manufacturing changes that are considered significant, data from comparative
analytical testing on relevant drug substance batches should be provided to
determine the impact on quality of the drug substance (see Q6B for additional
guidance). A discussion of the data, including a justification for selection of the
tests and assessment of results, should be included.
Testing used to assess the impact of manufacturing changes on the drug
substance(s) and the corresponding drug product(s) can also include nonclinical
and clinical studies. Cross-reference to the location of these studies in other
modules of the submission should be included.
Reference should be made to the drug substance data provided in section 3.2.S.4.4.
Reference CPMP-ICH Guidelines: \u{201C}Specifications: Test Procedures and Acceptance
Criteria for Biotechnological/ Biological Products\u{201D}, \u{201C}Comparability of medicinal products
containing biotechnology-derived proteins as active drug substance\u{201D}
3.2.S.3
Characterisation (name, manufacturer)
3.2.S.3.1
Elucidation of
manufacturer)
Structure
and
other
Characteristics
(name,
NCE:
Confirmation of structure based on e.g., synthetic route and spectral analyses
should be provided. Information such as the potential for isomerism, the
identification of stereochemistry, or the potential for forming polymorphs should
also be included.
Reference CPMP-ICH Guideline: \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} and \u{201C}Chemistry of
the Active Substance\u{201D}
Biotech:
For desired product and product-related substances, details should be provided on
primary, secondary and higher-order structure, post-translational forms (e.g.,
glycoforms), biological activity, purity, and immunochemical properties, when
relevant.
Reference CPMP-ICH Guideline: \u{201C}Specifications: Test Procedures and Acceptance Criteria
for Biotechnological/ Biological Products\u{201D}
3.2.S.3.2
Impurities (name, manufacturer)
Information on impurities should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Impurities testing guideline: impurities in new drug
substances\u{201D}, \u{201C}Impurities: residual solvents\u{201D}, \u{201C}Quality of Biotechnological Products:
Stability Testing of Biotechnological/ Biological Products\u{201D}, \u{201C}Specifications \u{2013} Test
Procedures and Acceptance Criteria for New Drug Substances and New Drug Products \u{2013}
Chemical Substances\u{201D}, \u{201C}Specifications: Test Procedures and Acceptance Criteria for
Biotechnological/ Biological Products\u{201D}
Reference CPMP-Guidelines: \u{201C}Control of Impurities of Pharmacopoeial Substances\u{201D}
3.2.S.4
Control of Drug Substance (name, manufacturer)
3.2.S.4.1
Specification (name, manufacturer)
The specification for the drug substance should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D},
\u{201C}Specifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological
Products\u{201D}
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D}, \u{201C}Chemistry of the
Active Substance\u{201D}and \u{201C}Control of Impurities of Pharmacopoeial Substances\u{201D}
3.2.S.4.2
Analytical Procedures (name, manufacturer)
The analytical procedures used for testing the drug substance should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Validation of analytical methods: definitions and
terminology\u{201D}, \u{201C}Specifications: Test Procedures and Acceptance Criteria for
Biotechnological/ Biological Products\u{201D}
Reference CPMP-Guidelines: \u{201C}Control of Impurities of Pharmacopoeial Substances\u{201D}
3.2.S.4.3
Validation of Analytical Procedures (name, manufacturer)
Analytical validation information, including experimental data for the analytical
procedures used for testing the drug substance, should be provided.

Reference CPMP-ICH Guidelines: \u{201C}Validation of analytical methods: definitions and
terminology\u{201D}, \u{201C}Validation of analytical procedures: methodology\u{201D}, \u{201C}Specifications: Test
Procedures and Acceptance Criteria for Biotechnological/ Biological Products\u{201D}
\u{201C}Tests on Samples of Biological Origin\u{201D}
3.2.S.4.4
Batch Analyses (name, manufacturer)
Description of batches and results of batch analyses should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Impurities testing guideline: impurities in new drug
substances\u{201D}, \u{201C}Impurities: residual solvents\u{201D}, \u{201C}Specifications \u{2013} Test Procedures and
Acceptance Criteria for New drug substances and New Drug Products \u{2013} Chemical
Substances\u{201D}, \u{201C}Specifications: Test Procedures and Acceptance Criteria for
Biotechnological/ Biological Products\u{201D}
3.2.S.4.5
Justification of Specification (name, manufacturer)
Justification for the drug substance specification should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Impurities testing guideline: impurities in new drug
substances\u{201D}, \u{201C}Impurities: residual solvents\u{201D}, \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D},
\u{201C}Specifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological
Products\u{201D}
Reference CPMP-Guidelines: \u{201C}Control of Impurities of Pharmacopoeial Substances\u{201D}
3.2.S.5
Reference Standards or Materials (name, manufacturer)
Information on the reference standards or reference materials used for testing of the drug
substance should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Specifications \u{2013} Test Procedures and Acceptance
Criteria for New Drug Substances and New Drug Products \u{2013} Chemical Substances\u{201D},
\u{201C}Specifications: Test Procedures and Acceptance Criteria for Biotechnological/ Biological
Products\u{201D}
3.2.S.6
Container Closure System (name, manufacturer)
A description of the container closure system(s) should be provided, including the identity
of materials of construction of each primary packaging component, and their
specifications. The specifications should include description and identification (and critical
dimensions with drawings, where appropriate). Non-compendial methods (with validation)
should be included, where appropriate.
For non-functional secondary packaging components (e.g., those that do not provide
additional protection), only a brief description should be provided. For functional
secondary packaging components, additional information should be provided.
The suitability should be discussed with respect to, for example, choice of materials,
protection from moisture and light, compatibility of the materials of construction with the
drug substance, including sorption to container and leaching, and/or safety of materials of
construction.
3.2.S.7
Stability (name, manufacturer)
3.2.S.7.1
Stability Summary and Conclusions (name, manufacturer)
The types of studies conducted, protocols used, and the results of the studies should be
summarized. The summary should include results, for example, from forced degradation
studies and stress conditions, as well as conclusions with respect to storage conditions and
retest date or shelf-life, as appropriate.
Reference CPMP-ICH Guidelines: \u{201C}Stability testing guidelines: stability testing of new drug
substances and products\u{201D}, \u{201C}Stability testing: photostability testing of new drug substances
and products\u{201D}, \u{201D}, \u{201C}Evaluation of stability data\u{201D}, \u{201C}On stability testing for a type II variation
to a marketing authorisation\u{201D}, \u{201C}Quality of Biotechnological Products: Stability Testing of
Biotechnological/ Biological Products,\u{201D}
Reference CPMP-Guidelines: \u{201C}Chemistry of the New Active Substance\u{201D} \u{201C}Chemistry of the
Active Substance\u{201D}, "On the declaration of storage conditions for medicinal products in the
products particulars and for active substances", \u{201C}on stability testing of existing active
substances and related finished products\u{201D}
3.2.S.7.2
Post-approval Stability Protocol and Stability Commitment (name,
manufacturer)
The post-approval stability protocol and stability commitment should be provided.
Reference CPMP-ICH Guidelines: \u{201C}Stability testing guidelines: stability testing of new drug
substances and products\u{201D}, , \u{201C}On stability testing for a type II variation to a marketing
authorisation\u{201D}, \u{201C}Evaluation of stability data\u{201D}, \u{201C}Quality of Biotechnological Products:
Stability Testing of Biotechnological/ Biological Products
Reference CPMP-Guideline: \u{201C}on stability testing of existing active substances and related
finished products\u{201D}
3.2.S.7.3
Stability Data (name, manufacturer)
Results of the stability studies (e.g., forced degradation studies and stress conditions)
should be presented in an appropriate format such as tabular, graphical, or narrative.
Information on the analytical procedures used to generate the data and validation of these
procedures should be included.
Reference CPMP-ICH Guidelines: \u{201C}Stability testing guidelines: stability testing of new drug
substances and products\u{201D}, \u{201C}Stability testing: photostability testing of new drug substances
and products\u{201D}, \u{201C}Validation of analytical methods: definitions and terminology\u{201D},
\u{201C}Validation of analytical procedures: methodology\u{201D}, \u{201C}On stability testing for a type II
variation to a marketing authorisation\u{201D}, \u{201C}Evaluation of stability data\u{201D}, \u{201C}Quality of
Biotechnological Products: Stability Testing of Biotechnological / Biological Products\u{201D}
Reference CPMP-Guideline: \u{201C}on stability testing of existing active substances and related
finished products\u{201D}`;
const $81b98fb9de868a7b$export$9c58314550ba2c12 = `MODULE 1.3 SUMMARY OF PRODUCT CHARACTERISTICS
Article 8(3)(j) of Directive 2001/83/EC and Article 6(1) of Regulation (EC) 726/2004 require that, in
order to obtain a marketing authorisation, a Summary of Product Characteristics (SmPC) in
accordance with Article 11 of Directive 2001/83/EC must be included in the application1 . In
accordance with Directive 2001/83/EC, when the marketing authorisation is issued, the Marketing
Authorisation Holder shall be informed, by the competent authorities of the Member States concerned,
of the SmPC as approved by it. For decisions concerning centralised marketing authorisations,
according to Article 10 of Regulation (EC) No 726/2004, the final Commission decision with the
SmPC is addressed and notified to the Marketing Authorisation Holder. Thus, the SmPC forms an
intrinsic and integral part of the marketing authorisation.
The SmPC sets out the agreed position of the medicinal product as distilled during the course of the
assessment process. As such the content cannot be changed except with the approval of the originating
competent authority.
The SmPC is the basis of information for healthcare professionals on how to use the medicinal product
safely and effectively. The Package Leaflet (PL) shall be drawn up in accordance with the SmPC. The
Guideline on excipients in the label and package leaflet of medicinal products for human use is also
applicable to the SmPC.
It is not in the remit of the SmPC to give general advice on the treatment of particular medical
conditions. On the other hand specific aspects of the treatment related to use of the medicinal product
or its effects should be mentioned. Similarly, general advice on administration procedures should not
be included but any advice specific to the concerned medicinal product should be included.
This guideline provides advice on the principles of presenting information in the SmPC. Applicants
should maintain the integrity of each section of the document by only including information in each
section which is relevant to the section heading. However, some issues may need to be addressed in
more than one section of the SmPC and in such situations the individual statements may cross-refer to
other sections when these contain relevant additional information.
This guideline should be read in conjunction with any other specific guidance document related to the
SmPC (e.g. on benzodiazepines, antibiotics, vaccines, pegylated proteins, or plasma-derived medicinal
products).
Separate SmPCs are required for each pharmaceutical form and strength by the European Commission
and certain Member States. Limited references to other strengths or pharmaceutical forms of the same
medicinal product may be necessary in a SmPC if the dosage regimen is based on the use of several
strengths or pharmaceutical forms. For the purposes of giving information to prescribers, the SmPCs
of different pharmaceutical forms and strengths may be combined for appropriate products within the
same range.
This guidance shall apply as from 1 May 2010. However, submissions may also be done on the basis
of this guidance prior to that date.
1 Module 1.3 consists of the SmPC.

SUMMARY OF PRODUCT CHARACTERISTICS: Principles of presenting information
- The SmPC should be worded in clear and concise language.
- Each section of the SmPC should first deal with those issues that apply to the core population for
whom the medicine is indicated followed - when necessary \u{2013} by specific information for any relevant
special population (e.g. children or elderly).
- Public Assessment Reports provide detailed information on medicinal products and are available on
the website of the European Medicines Agency, of Heads of medicines Agencies or other National
Competent Authorities. A link to the relevant website should be included in SmPCs when a public
assessment report is available.
- Consistent medical terminology should be used throughout the SmPC. For example, the use of
MedDRA as described in the annex for section 4.8 should be applied though the SmPC, in particular
for sections 4.3 and 4.4 and 4.8.
- The SmPC provides information on a particular medicinal product; therefore it should not include
reference to other medicinal products (e.g. through statement such as \u{201C}Like other medicines of the
same class \u{2026}\u{201D}) except when it is a class warning recommended by a competent authority.
- The principles set-out in this guideline are applicable to all medicinal products. The application of
those principles for a particular medicinal product will depend on the scientific knowledge on the
medicinal product, the legal basis of a marketing authorisation and public health needs. Deviation
from this guideline should therefore be justified in the relevant Overview or Summary in the
marketing authorisation application.
- Practical advice on how to draw up the SmPC is provided to the applicant in the form of templates
developed by the Quality Review of Documents (QRD) group, for centralised, decentralised and
mutual recognition procedures.
1 NAME OF THE MEDICINAL PRODUCT
The (invented) name should be followed by both the strength and the pharmaceutical form. However,
when otherwise referring to the medicinal product throughout the SmPC text, the strength and the
pharmaceutical form do not have to be mentioned in the name. The International Non-proprietary
Name (INN) or the usual common name of the active substance should be used when referring to
properties of the active substance(s) rather than those of the product.
The use of pronouns (e.g. \u{201C}it\u{201D}) is encouraged whenever possible.
Strength
The strength should be the relevant quantity for identification and use of the product and should be
consistent with the quantity stated in the quantitative composition and in the posology. Different
strengths of the same medicinal product should be stated in the same way, e.g. 250 mg, 500 mg, 750
mg. The use of decimal points should be avoided where these can be easily removed (e.g. 250
microgram, not 0.25 mg). However, where a range of medicinal products of the same pharmaceutical
form includes strengths of more than one unit (e.g. 250 microgram, 1 mg and 6 mg), it may be more
appropriate in certain cases to state the strengths in the same unit for the purpose of comparability (e.g.
0.25 mg, 1 mg and 6 mg). For safety reasons, micrograms and millions (e.g. for units) should always
be spelled out in full rather than be abbreviated.
Pharmaceutical form
The pharmaceutical form of a medicinal product should be described by a single full Standard Term of
the European Pharmacopoeia using the plural form if appropriate (e.g. tablets) (see section 3). If an
appropriate standard term does not exist, a new term may be constructed from a combination of
standard terms in accordance with the document \u{201C}Standard Terms, Introduction and Guidance to use\u{201D}.

Should this not be possible, the competent authority should be asked to request a new Standard Term
from the European Department for the Quality of Medicines (EDQM) of the Council of Europe. No
reference should be made to the route of administration or container unless these elements are part of
the standard term or where there is a particular safety reason for their inclusion or where there are
identical products, which may be distinguished only by reference to the route of administration or to
the container.
For the expression of the name and strength of (traditional) herbal medicinal products the declaration
should be in accordance with existing quality guidelines on herbal medicinal products.
2 QUALITATIVE AND QUANTITATIVE COMPOSITION
Full details of the qualitative and quantitative composition in terms of the active substance(s) and
excipients, knowledge of which are essential for proper administration of the medicinal product,
should be provided in section 2 and as appropriate in section 4.3 or 4.4. For example, excipients listed
in the Annex to the \u{201C}Guideline on the excipients in the label and package leaflet of medicinal product
for human use\u{201D} should be stated here under a separate subheading qualitatively, and, quantitatively.
The following standard statement should be included at the end of the section, i.e. \u{2018}for full list of
excipients, see section 6.1\u{2019}.
If a diluent is part of the medicinal product, information should be included in the relevant sections
(usually sections 3, 6.1, 6.5 and 6.6).
Qualitative declaration
The active substance should be declared by its recommended INN, accompanied by its salt or hydrate
form if relevant, or the European Pharmacopoeial name if that name represents an established name in
Europe. If no INN exists, the European Pharmacopoeia name should be used or if the substance is not
in the pharmacopoeia, the usual common name should be used. In the absence of a common name, the
exact scientific designation should be given. Substances not having an exact scientific designation
should be described by a statement on how and from what they were prepared. References to the
pharmacopoeial quality should not be included.
Where the medicinal product is a (traditional) herbal medicinal product, the qualitative declaration
should be in accordance with the existing quality guidelines on herbal medicinal products.
When the medicinal product is a radiopharmaceutical kit, the qualitative declaration should clearly
indicate that the radioisotope is not part of the kit.
Quantitative declaration
The quantity of the active substance should be expressed per dosage unit (for metered dose inhalation
products, per delivered dose and/or per metered dose), per unit volume, or per unit of weight and
should be related to the declaration of strength in section 1.
Quantity should be expressed in internationally recognised standard term which could be
complemented with another term if more meaningful to healthcare professionals.
Salts and hydrates
Where the active substance is present in the form of a salt or hydrate, the quantitative composition
should be expressed in terms of the mass (or biological activity in International (or other) units where
appropriate) of the active moiety (base, acid or anhydrous material), e.g. \u{2018}60 mg toremifene (as
citrate)\u{2019} or toremifene citrate equivalent to 60 mg toremifene\u{2019}.
Where a salt is formed in situ during the preparation of the finished product (i.e. formed during the
mixture of a solvent and powder), the quantity of the active moiety should be stated, with a reference
to the in situ formation of the salt.
In the case of established active substances in medicinal products where the strength has traditionally
been expressed in the form of a salt or hydrate, the quantitative composition may be declared in terms

of the salt or hydrate, e.g. \u{2018}60 mg diltiazem hydrochloride\u{2019}. This may also apply when the salt is
formed in situ.
Esters and pro-drugs
If the active substance is an ester or pro-drug, the quantitative composition should be stated in terms of
the quantity of the ester or pro-drug. When the active moiety is an active substance of an already
approved medicinal product, the quantitative composition should also be stated in terms of the
quantity of this active moiety (e.g. 75 mg of fosphenytoin is equivalent to 50 mg of phenytoin).
Oral powders for solution or suspension
The quantity of active substance should be stated per unit dose if the product is a single-dose
preparation or otherwise per unit dose volume after reconstitution; a reference to the molar
concentration may also be appropriate in some cases.
Parenterals excluding powders for reconstitution
For single-dose parenterals, where the total contents of the container are given in a single dose (\u{2018}total
use\u{2019}), the quantity of active substance(s) should be stated per presentation (e.g. 20 mg etc.) not
including any overages or overfill. The quantity per ml and the total labelled volume should also be
given.
For single-dose parenterals, where the amount to be given is calculated on the basis of the patient\u{2019}s
weight or body surface or other variable (\u{2018}partial use\u{2019}), the quantity of active substance(s) should be
stated per ml. The quantity per total labelled volume should also be given. Overages or overfills
should not be included.
For multi-dose and large volume parenterals, the quantity of active substance(s) should be stated per
ml, per 100 ml, per 1000 ml, etc. as appropriate, except for multidose vaccines containing \u{2018}n\u{2019} doses of
the same dose. In this case, the strength should be expressed per dose volume. Overages or overfills
should not be included.
Where appropriate, e.g. for X-ray contrast media, and parenterals containing inorganic salts, the
quantity of active substance(s) should also be indicated in millimoles. For X-ray contrast media with
iodine-containing actives substances, the quantity of iodine per ml should be stated in addition to the
quantity of the active substance.
Powders for reconstitution prior to parenteral administration
When the product is a powder to be reconstituted prior to administration, the total quantity of active
substance in the container should be stated not including overages or overfills, as well as the quantity
per ml when reconstituted, unless there are several means of reconstituting, or different quantities
used, which result in different final concentrations.
Concentrates
The quantity should be stated as the content per ml in the concentrate and as the total content of the
active substance. The content per ml when diluted as recommended should also be included unless the
concentrate is to be diluted to within a range of different final concentrations.
Transdermal patches
The following quantitative details should be given: the content of active substance(s) per patch, the
mean dose delivered per unit time, and the area of the releasing surface, e.g. \u{2018}Each patch contains 750
micrograms of estradiol in a patch size of 10 cm2 , releasing a nominal 25 micrograms of estradiol per
24 hours'.
Multidose solid or semi-solid products
Quantity of active substance should be stated, where possible, per unit dose, otherwise per gram, per
100 g or percentage, as appropriate.

Biological medicinal products
Expression of strength.
The quantity of biological medicinal products should be expressed in terms of mass units, units of
biological activity, or International Units as appropriate for the particular product, and reflecting
European Pharmacopoeia usage where relevant. For pegylated proteins, the CHMP Guideline on the
Description of Composition of Pegylated (Conjugated) Proteins in the SmPC should be referred to.
The biological origin of the active substance.
The origin of the active substance should be defined briefly. Thus, the nature of any cellular system(s)
used for production and, if relevant, the use of recombinant DNA technology should be specified. The
entry should take the form: \u{201C}produced in XXX cells <by recombinant DNA technology>\u{201D}. The
following are examples of the application of this principle:
\u{201C}produced in human diploid (MRC-5) cells\u{201D},
\u{201C}produced in Escherichia coli cells by recombinant DNA technology\u{201D},
\u{201C}produced in chick-embryo cells\u{201D},
\u{201C}produced from the plasma of human donors\u{201D},
\u{201C}produced from human urine\u{201D},
\u{201C}produced from <animal>blood\u{201D},
\u{201C}produced from porcine pancreatic tissue\u{201D},
\u{201C}produced from porcine intestinal mucosa\u{201D}.
Special provisions for normal immunoglobulins.
In the case of normal immunoglobulins, the IgG subclass distribution should be stated in terms of
percent of total IgG present. The upper limit of the IgA content should follow.
Special provisions for vaccines.
In the case of vaccines, the content of active substance per dose unit (e.g. per 0.5 ml) should be stated.
Adjuvants, if present, should be stated qualitatively and quantitatively.
Residues that are of special relevance (e.g. ovalbumin in egg derived vaccines) should be specified.
Additional specific guidance is available in CHMP guidelines on biotechnological medicinal products,
e.g. the CHMP Guideline on the Pharmaceutical Aspects of the Product Information for Human
Vaccines.
Herbal medicinal products
The quantitative declaration should be in accordance with the existing quality guidelines on herbal
medicinal products.
3 PHARMACEUTICAL FORM
The pharmaceutical form should be described by a full standard term of the European Pharmacopoeia
(see section 1) using the singular form. The term used in this section should be the same as the term
used in section 1. However, where a short standard term of the European Pharmacopoeia is used on
small immediate packaging material, the short term should be added in brackets in this section.
A visual description of the appearance of the product (colour, markings, etc.) should be given, in a
separate paragraph to the standard term, including information on the actual size of a solid oral
formulation, e.g.
\u{2018}Tablet

White, circular flat bevelled-edge tablets of 5 mm marked \u{2018}100\u{2019} on one side\u{2019}
In case of tablets designed with a score line, information should be given on whether or not
reproducible dividing of the tablets has been shown. e.g. \u{2018}the scoreline is only to facilitate breaking for
ease of swallowing and not to divide into equal doses\u{2019}, \u{2018}the tablet can be divided into equal halves\u{2019}.
Information on pH and osmolarity should be provided, as appropriate.
In case of products to be reconstituted before use, the appearance before reconstitution should be
stated in this section. Appearance of the product after reconstitution should be stated in sections 4.2
and 6.6.
4. CLINICAL PARTICULARS
4.1 Therapeutic indications
The indication(s) should be stated clearly and concisely and should define the target disease or
condition distinguishing between treatment (symptomatic, curative or modifying the evolution or
progression of the disease), prevention (primary or secondary) and diagnostic indication. When
appropriate it should define the target population especially when restrictions to the patient
populations apply.
Study endpoints should not normally be included, unless such mention is specified as being
appropriate for the indication in CHMP Guidelines. The objective of a prevention indication may be
mentioned in general terms only. This should also be done for the target population.
Where results from subsequent studies provide further definition or information on an authorised
indication, such information, provided it does not itself constitute a new indication, may be considered
for inclusion in section 5.1.
Mandatory conditions of product usage not covered more appropriately in other parts of the SmPC
may also be included when relevant, e.g. concomitant dietary measures, lifestyle changes, or other
therapy.
It should be stated in which age groups the product is indicated, specifying the age limits, e.g. \u{2018}X is
indicated in <adults><neonates><infants><children> <adolescents> <aged x to y <years, months>>.
If the product\u{2019}s indication depends on a particular genotype or the expression of a gene or a particular
phenotype, this should be stated in the indication.
4.2 Posology and method of administration
In case of restricted medical prescription, this section should be started by specifying the conditions.
In case of specific safety need, any recommended restriction to a particular setting should also be
stated (e.g. \u{201C}restricted to hospital use only\u{201D} or \u{201C}appropriate resuscitation equipment should be
available\u{201D}).
Posology
The dosage should be clearly specified for each method/route of administration and for each
indication, as appropriate.
Where appropriate, a reference to official recommendations should be made (e.g. for primary
vaccination and antibiotics as well as for booster dose).
Dose recommendations (e.g. mg, mg/kg, mg/m2 ) should be specified per dose interval for each
category where appropriate (specify age/weight/body surface area of subsets of the population as
appropriate). Frequency of dosing should be expressed using time units (e.g. once or twice daily or
every 6 hour) and, to avoid confusion, abbreviations e.g. OD or BID should not be used.
Where appropriate, the following points should be addressed:

\u{2022} the maximum recommended single, daily and/or total dose,
\u{2022} the need for dose titration,
\u{2022} the normal duration of use and any restrictions on duration and, if relevant, the need for tapering
off, or advice on discontinuation,
\u{2022} advice on action to be taken if one or more dose(s) is (are) missed, or e.g. in case of vomiting
(the advice should be as specific as possible, taking into consideration the recommended
frequency of dosing and relevant pharmacokinetic data)
\u{2022} advice on preventive measures to avoid certain adverse drug reactions (e.g. administration of
antiemetics) with cross-reference to section 4.4,
\u{2022} the intake of the product in relation to drink and food intake, together with a cross-reference to
section 4.5 in case of specific interaction e.g. with alcohol, grapefruit or milk,
\u{2022} advice regarding repeat use, with any information on intervals to be observed between courses
of treatment, as appropriate,
\u{2022} interactions requiring specific dose adjustments with cross-reference to other appropriate
sections of the SmPC (e.g. 4.4, 4.5, 4.8, 5.1, 5.2), and
\u{2022} it may also be relevant to recommend not to prematurely discontinue a treatment in case of
specific non-serious adverse reaction(s) that are frequent but transient or manageable with dose-
titration.
Where relevant to the particular product, the following should appear \u{2018}The potency of this medicinal
product is expressed in <invented name> units. These units are not interchangeable with the units used
to express the potency of other <active substance name> preparations\u{2019}.
Special populations
Dosage adjustments or other posology related information in specific patient groups should be stated
where necessary, in well-defined sub-sections ordered by importance, e.g. regarding:
\u{2022} elderly population; it should be made clear whether or not any dosage adjustment is necessary in
any subsets of the elderly population, with cross-reference to other sections providing
information in elderly, e.g. 4.4, 4.5, 4.8 or 5.2.
\u{2022} renal impairment; the dose recommendation should relate as precisely as possible to the cut-off
values for biochemical markers of renal impairment in clinical studies and to the results of these
studies;
\u{2022} hepatic impairment, specified according to the patients included in studies, for instance
\u{2018}alcohol-related cirrhosis\u{2019} and the definitions used in the studies, for instance Child-Pugh
score/grade of the patients;
\u{2022} patients with a particular genotype; with cross-reference to other relevant sections for further
detail as appropriate;
\u{2022} other relevant special population (e.g. patients with other concomitant disease or overweight
patients).
Advice relevant for dosage adjustment e.g. from monitoring of clinical symptoms and signs, and/or
laboratory investigations, including blood concentrations of the medicinal product should be
mentioned when appropriate with cross-reference to other sections where appropriate.
Paediatric population
The specific sub-section \u{2018}paediatric population\u{2019} should always be included and the information given
should cover all subsets of the paediatric population, using a combination of the possible situations
presented below as appropriate.

If the product is indicated in the paediatric population, posology recommendations should be given for
each of the relevant subsets. The age limits should reflect the benefit-risk assessment of the available
documentation for each subset.
If the posology is the same in adults and children, then a statement to this effect is sufficient; the
posology does not need to be repeated.
Dose recommendations (e.g. mg, mg/kg, mg/m2) should be specified per dose interval for the
paediatric subsets where the product is indicated. Different subsets may require different dosing
information. If necessary, recommendations in preterm newborns should be presented taking into
account the more appropriate age e.g. gestational age or the post-menstrual age.
Depending on the subset, the clinical data and available formulations, the dose will be expressed
according to weight or body surface area, e.g. \u{201C}children aged 2-4 years, 1 mg/kg bodyweight twice a
day\u{201D}.
When appropriate, information on timing of intake of the product should consider children\u{2019}s daily life,
e.g. school or sleep.
Where a product is indicated in children and no adequate paediatric formulation can be developed,
detailed instructions on how to obtain an extemporaneous preparation shall be included in section 6.6
with a cross-reference in section 4.2.
Doses and method of administration in the various subsets may be presented in a tabulated format.
If there is no indication for the product in some or all subsets of the paediatric population, no
posology recommendation can be made, but available information should be summarised using the
following standard statements (one or combination of several as appropriate):
\u{2022} The <safety> <and> <efficacy> of X in children aged x to y <months, years> <or any other
relevant subsets e.g. weight, pubertal age, gender> <has><have> not <yet> been established.
One of the following statements should be added:
\u{2013} <No data are available>.
or
\u{2013} <Currently available data are described in section <4.8><5.1><5.2> but no
recommendation on a posology can be made >
\u{2022} X should not be used in children aged x to y <years, months><or any other relevant subsets e.g.
weight, pubertal age, gender> because of <safety> <efficacy> concern(s) <concern(s) to be stated
with cross-reference to sections detailing data (e.g. 4.8 or 5.1) >.
\u{2022} There is no relevant use of X in <the paediatric population><in children aged x to y><years,
months>><or any other relevant subsets e.g. weight, pubertal age, gender> in the indication(s)
<specify indication(s)>.
\u{2022} X is contraindicated in children aged x to y <years, months> <or any other relevant subsets e.g.
weight, pubertal age, gender> <in the indication \u{2026}> (cross-reference to section 4.3).
If there are more appropriate strength(s) and/or pharmaceutical form(s) for administration in some or
all subsets of the paediatric population (e.g. oral solution for infants), these can be mentioned in
section 4.2 of the SmPC of the less appropriate one(s).
E.g.: Other pharmaceutical forms/strengths may be more appropriate for administration to
this population.
Method of administration
Any special precautions related to the manipulation or administration of the product (e.g. cytotoxic
products) by healthcare professionals (including pregnant healthcare professionals), the patient or
carers should be mentioned here under a specific sub-heading (<Precaution to be taken before
manipulating or administering the product>), with a cross-reference to section 6.6 (or 12).
The route of administration and concise relevant instruction for correct administration and use should
be given here. Information on instructions for preparation or reconstitution should be placed in section

6.6 \u{2018}Special precautions for disposal of a used medicinal product and other handling of the product\u{2019}
(or in section 12 if appropriate) and cross-referenced here.
When supportive data are available, information on alternative method(s) to facilitate administration
or acceptability should be given as explicitly as possible (e.g. possibility of crushing tablet, cutting
tablet or transdermal patch, pulverising tablet, opening capsules, mixing with food, dissolution in
drinks \u{2013} specifying if a proportion of the dose can be given) particularly for administration via feeding
tubes.
Any specific recommendation for use related to the pharmaceutical form should be explained, e.g.:
- \u{201C}the coated tablet should not be chewed because of <bad taste>,
- \u{201C}the enteric-coated tablet should not be crushed because coating prevents <pH sensitive
degradation><irritant effects> on the gut\u{201D},
- \u{201C}the coated tablet should not be broken because the coating is intended to ensure a prolonged release
(see 5.2)\u{201D}.
For parenteral formulations, information on the rate or speed of injection or infusion should be
provided.
For parenteral formulations - in children, especially newborns in whom quite often fluids have to be
restricted - it would be useful to have information on maximal concentration that can be safely
administered (e.g. "no more than X mg of Y/ml of solution").
4.3 Contraindications
Situations where the medicinal product must not be given for safety reasons, i.e. contraindications, are
the subject of this section. Such circumstances could include a particular clinical diagnosis,
concomitant diseases, demographic factors (e.g. gender, age) or predispositions (e.g. metabolic or
immunological factors, a particular genotype and prior adverse reactions to the medicine or class of
medicines). The situations should be unambiguously, comprehensively and clearly outlined.
Other medicines or classes of medicine, which must not be used concomitantly or consecutively
should be stated, based on either data or strong theoretical reasons. If applicable a cross-reference to
section 4.5 should be made.
In general, patient populations not studied in the clinical trial programme should be mentioned in
section 4.4 and not in this section unless a safety issue can be predicted (e.g. use of renally eliminated
substances with narrow therapeutic margin in renal failure patients). If, however, patients have been
excluded from studies due to a contraindication on grounds of safety, they should be mentioned in this
section. If applicable a cross-reference to section 4.4 should be made.
Only if pregnancy or breastfeeding is contraindicated, should it be mentioned here. In section 4.6, a
cross-reference should be made and further background information provided.
Hypersensitivity to the active substance or to any of the excipients or residues from the manufacturing
process should be included, as well as any contraindication arising from the presence of certain
excipients (see Guideline on excipients in the label and package leaflet of medicinal products for
Human Use).
For herbal medicinal products, hypersensitivity extended to other plants of the same family or to other
parts of the same plant should be labelled as a contraindication, where applicable.
Lack of data alone should not lead to a contraindication. Where for safety reasons, the product should
be contraindicated in a specific population, e.g. paediatric or a subset of the paediatric population, it
should appear in this section with a cross-reference to the section giving detailed information on the
safety issue. A contraindication in the paediatric population should be listed without a sub-heading.
4.4 Special warnings and precautions for use
The order of warnings and precautions should in principle be determined by the importance of the
safety information provided.

The exact content of this section will be different for each product and the therapeutic conditions it is
intended to treat. It is however suggested that the following items should be included where relevant to
the specific product.
Information on a specific risk should be given in section 4.4 only when the risk leads to a precaution
for use or when healthcare professionals have to be warned of this risk. Patient groups in which use of
the medicinal product is contraindicated should be mentioned in section 4.3 only and not to be
repeated here.
The following should be described:
\u{2022} The conditions, in which the use of the medicinal product could be acceptable, provided that
special conditions for use are fulfilled. In particular, specific risk minimisation measures
requested as part of a Risk Management Plan to ensure safe and effective use should be
described in this section. (For example; \u{201C}Liver function should be monitored before initiation of
treatment and monthly thereafter\u{201D}, \u{201C}Patients should be advised to immediately report any
symptoms of depression and/or suicidal ideation\u{201D}, \u{201C}Women of childbearing potential should use
contraception\u{201D}, \u{2026})
\u{2022} Special patient groups that are at increased risk or are the only groups at risk of experiencing
product or product class-related adverse reactions (usually serious or common), e.g. elderly,
children, patients with renal or hepatic impairment (including the degree of impairment, e.g.
mild, moderate or severe), patients having an anaesthesic or patients with cardiac failure
(including in this case the NYHA Classification for example). Cross-reference to section 4.8 on
the differential effects in terms of frequency and severity of the specified adverse reaction
should be provided.
\u{2022} Serious adverse reactions to which healthcare professionals need to be alerted, the situations in
which these may occur and the action that may be required, e.g. emergency resuscitation.
\u{2022} If there are particular risks associated with starting the medicinal product (e.g. first dose effects)
or stopping it (e.g. rebound, withdrawal effects), these should be mentioned in this section,
together with the action required for prevention.
\u{2022} Any measures which can be taken to identify patients at risk and prevent the occurrence, or
detect early the onset or worsening of noxious conditions. If there is a need for awareness of
symptoms or signs representing early warning of a serious adverse reaction, a statement should
be included.
\u{2022} Any need for specific clinical or laboratory monitoring should be stated. Recommendation for
monitoring should address why, when and how the monitoring should be conducted in clinical
practice. If dose reduction or other posology is recommended in such circumstances or
conditions, this should be included in section 4.2 and cross-referenced here.
\u{2022} Any warnings necessary for excipients or residues from the manufacturing process.
\u{2022} For herbal preparations containing alcohol, information about the ethanol content in the
medicinal product should be included in accordance with the Guideline on excipients in the
label and package leaflet of medicinal products for human use.
\u{2022} Any warnings necessary with respect to transmissible agents (e.g. Warning of Transmissible
Agents in SmPCs and Package Leaflets for Plasma-Derived Medicinal Products
(CPMP/BPWG/BWP/561/03).
\u{2022} Subjects or patients with a specific genotype or phenotype might either not respond to the
treatment or be at risk of a pronounced pharmacodynamic effect or adverse reaction. These may
arise because of non-functioning enzyme alleles, alternative metabolic pathways (governed by
specific alleles), or transporter deficiencies. Such situations should be clearly described if
known.
\u{2022} Any particular risk associated with an incorrect route of administration (e.g. necrosis risk with
extravasation of intravenous formulation, or neurological consequences of intravenous use
instead of intramuscular use), should be presented, with advice on management if possible.

In exceptional cases, especially important safety information may be included in bold type within a
box.
Any adverse reactions described in this section or known to result from conditions mentioned here
should also be included in section 4.8.
Specific interference with laboratory tests should be mentioned when appropriate, e.g. Coombs test
and Beta-lactams. They should be clearly identified with a subheading, e.g. \u{201C}Interference with
serological testing\u{201D}.
In general, descriptions of warnings and precautions regarding pregnancy and breast-feeding, ability to
drive and use machines, and other aspects of interactions should be dealt with in sections 4.6, 4.7 and
4.5, respectively. However in specific cases of major clinical importance it might be more appropriate
to describe specific precautionary measures in this section, e.g. contraception measures, or when
concomitant use of another medicine is not recommended, and with cross reference to section 4.5, 4.6,
or 4.7.
Paediatric population
When the product is indicated in one or more subsets of the paediatric population and there are
warnings and precautions for use that are specific to the paediatric population or any subset of the
paediatric population, they should be identified under this subheading. Any necessary warning or
precaution in relation to long-term safety (e.g. on growth, neuro-behavioural development or sexual
maturation) or specific monitoring (e.g. growth) in the paediatric population should be described.
When long-term safety data are necessary but not yet available, it should be stated in this section.
Warnings should be included in case of possible significant or long-lasting impact on children\u{2019}s daily
activities, such as learning ability or physical activities, or in case of impact on appetite or sleep
pattern.
If measures are requested that are specific to the paediatric population for which the product is
indicated (e.g. as part of a Risk Management Plan), these measures should be described in this section.
4.5 Interaction with other medicinal products and other forms of interaction
This section should provide information on the potential for clinically relevant interactions based on
the pharmacodynamic properties and in vivo pharmacokinetic studies of the medicinal product, with a
particular emphasis on the interactions, which result in a recommendation regarding the use of this
medicinal product. This includes in vivo interaction results which are important for extrapolating an
effect on a marker (\u{2018}probe\u{2019}) substance to other medicinal products having the same pharmacokinetic
property as the marker.
Interactions affecting the use of this medicinal product should be given first, followed by those
interactions resulting in clinically relevant changes on the use of others.
Interactions referred to in other sections of the SmPC should be described here and cross-referenced
from other sections.
The order of presentation should be contraindicated combinations, those where concomitant use is not
recommended, followed by others.
The following information should be given for each clinically relevant interaction:
a. Recommendations: these might be
\u{2022} contraindications of concomitant use (cross-refer to section 4.3),
\u{2022} concomitant use not recommended (cross-refer to section 4.4), and
\u{2022} precautions including dose adjustment (cross-refer to sections 4.2 or 4.4, as appropriate),
mentioning specific situations where these may be required.
b. Any clinical manifestations and effects on plasma levels and AUC of parent compounds or
active metabolites and/or on laboratory parameters.

c. Mechanism, if known. For example, interaction due to inhibition or induction of cytochrome
P450 should be presented as such in this section, with a cross-reference to 5.2 where in vitro
results on inhibition or induction potential should be summarised.
Interactions not studied in vivo but predicted from in vitro studies or deducible from other situations or
studies should be described if they result in a change in the use of the medicinal product, cross-
referring to sections 4.2 or 4.4.
This section should mention the duration of interaction when a medicinal product with clinically
important interaction (e.g., enzyme inhibitor or inducer) is discontinued. Adjustment of dosing may be
required as a result. The implication for the need for a washout period when using medicines
consecutively should also be mentioned.
Information on other relevant interactions such as with herbal medicinal products, food, alcohol,
smoking, or pharmacologically active substances not used for medical purpose, should also be given.
With regard to pharmacodynamic effects where there is a possibility of a clinically relevant
potentiation or a harmful additive effect, this should be stated.
In vivo results demonstrating an absence of interaction should only be mentioned here if this is of
major importance to the prescriber (e.g. in therapeutic area where potentially problematic interactions
have been identified such as with anti-retroviral medicines).
If no interaction studies have been performed, this should be clearly stated.
Additional information on special populations
If there are patient groups in which the impact of an interaction is more severe, or the magnitude of an
interaction is expected to be larger e.g., patients with decreased renal function (in case the parallel
pathway is renal excretion), paediatric patients, elderly etc, this information should be given here.
If interactions with other medicinal products depend on polymorphisms of metabolising enzymes or
certain genotypes, this should be stated.
Paediatric population
Information specific to a subset of the paediatric population should be given here if there is an
indication for the particular age group.
The resulting exposure and clinical consequences of a pharmacokinetic interaction can differ between
adults and children, or between older and younger children. Therefore;
\u{2022} Any identified treatment recommendations should be given in relation to concomitant use in the
paediatric subset(s) (e.g. dose adjustment, extra-monitoring of clinical effect marker/adverse
reactions, therapeutic drug monitoring),
\u{2022} If the interaction studies have been performed in adults, the statement \u{2018}Interaction studies have
only been performed in adults\u{2019} should be included.
\u{2022} If the extent of an interaction is known to be similar in a paediatric age group to that in adults,
this should be stated.
\u{2022} If this is not known, this should also be stated.
The same applies to pharmacodynamic drug interactions.
In cases of food interaction leading to a recommendation on co-administration with a meal or specific
food, it should be specified whether this is relevant for paediatric use (especially newborns and
infants) whose diet is different (100 % milk in newborns).
Overall, section 4.5 should be presented in the simplest possible way to highlight the interactions
resulting in a practical recommendation regarding the use of the medicinal product. Presentation in a
tabulated format may help where interactions are numerous and various, such as with anti-viral
products.
4.6 Fertility, pregnancy and lactation

General principles
Efforts should be made by the Marketing Authorisation Applicant or Holder to provide the reasons for
the recommendations for use in pregnant or lactating women and in women of childbearing potential.
This information is important for the healthcare professionals informing the patient.
In the overall assessment, all available knowledge should be taken into account, including clinical
studies and post-marketing surveillance, pharmacological activity, results from non-clinical studies,
and knowledge about compounds within the same class.
Efforts should be made to update the recommendations for use during pregnancy and lactation on the
basis of increasing human experience in exposed pregnancies which eventually supersede the animal
data.
In case of contraindication, this should be included in section 4.3.
The following should be mentioned:
Women of childbearing potential / Contraception in males and females
Recommendations on the use of the medicinal product in women of childbearing potential should be
given when appropriate including the need for pregnancy test or contraceptive measures. Where an
effective contraception is required for patients or partners of patients during treatment or for a defined
period before starting or after ending treatment, the rationale should be included in this section. If
contraceptive measures are recommended, there should also be a cross-reference to section 4.5 (and
possibly 4.4) in case of interaction with oral contraceptives.
Pregnancy
In general, clinical and non-clinical data should be followed by recommendations.
With respect to non-clinical data,
\u{2022} only conclusions of the reproductive toxicity studies should be included in this section. Further
details should be provided in section 5.3.
With respect to clinical data,
\u{2022} the section should include comprehensive information on relevant adverse events reported in the
embryo, the fetus, neonates and pregnant women, when appropriate. The frequency of such
events (for example the frequency of birth defects) should be specified when available.
\u{2022} the section should specify the extent of the human experience if no adverse events have been
reported in pregnancy.
With respect to the recommendations:
a) Recommendations on the use of the medicinal product during the different periods of gestation,
including the reason(s) for these recommendations, should be given.
b) Recommendations for the management of exposure during pregnancy when appropriate (including
relevant specific monitoring such as fetal ultrasound, specific biological or clinical surveillance of
the fetus or the neonate) should be given.
Cross-references can be included in sections 4.3, 4.4 and 4.8, as appropriate.
Examples of wording for this section are annexed to the CHMP/SWP guideline on reproduction and
lactation.
Breastfeeding
If available, clinical data should be mentioned (exposed breastfed infants) as the conclusions of kinetic
studies (plasma concentrations in breastfed infants, transfer of the active substance and/or its
metabolite(s) into human milk\u{2026}). Information on adverse reactions in nursing neonates should be
included if available.

Conclusions from non-clinical studies on the transfer of the active substance and/or its metabolite(s)
into milk should be given only if no human data are available.
Recommendations should be given to stop or continue breastfeeding and/or to stop or continue the
treatment in cases where treatment or breastfeeding discontinuation is recommended, and the reason
should be provided.
Examples of wordings for this section are annexed to the CHMP/SWP guideline on reproduction and
lactation.
Fertility
The main information on the possible effects of the medicinal product on male and female fertility
should be included in section 4.6.
This section should include:
a) Clinical data if available.
b) Relevant conclusions from nonclinical toxicity studies, if available. Further details should be
included in section 5.3.
c) Recommendations for the use of the medicinal product when pregnancy is planned but fertility
might be affected by treatment.
Cross-references could be included in section 4.3, if appropriate.
If there are no fertility data at all, then this should be clearly stated.
4.7 Effects on ability to drive and use machines
On the basis of the pharmacodynamic and pharmacokinetic profile, reported adverse reactions and/or
specific studies in a relevant target population addressing the performance related to driving and road
safety or using machines, specify whether the medicinal product has a) no or negligible influence b)
minor influence, c) moderate influence or d) major influence on these abilities. Other important factors
that affect the ability to drive and use machines should be considered if known, e.g. duration of the
impairing effect and the development of tolerance or adverse reactions with continued use.
For situations c and d, special warnings/precautions for use should be mentioned here (and also in
section 4.4 for situation d).
4.8 Undesirable effects
This section should include all adverse reactions from clinical trials, post-authorisation safety studies
and spontaneous reporting for which, after thorough assessment, a causal relationship between the
medicinal product and the adverse event is at least a reasonable possibility, based for example, on their
comparative incidence in clinical trials, or on findings from epidemiological studies and/or on an
evaluation of causality from individual case reports. Adverse events, without at least a suspected
causal relationship, should not be listed in the SmPC.
The content of this section should be justified in the Clinical Overview of the marketing authorisation
application based upon a best-evidence assessment of all observed adverse events and all facts relevant
to the assessment of causality, severity and frequency. This section should be regularly reviewed and,
if necessary, updated with the aim to ensure appropriate information to health care professionals on the
safety profile of the product. In addition, the whole section could be revised at the renewal of the
marketing authorisation, where the safety profile of most products is likely to be well established, and
thereafter at each of the three-yearly PSUR.
It is important that the whole section is worded in concise and specific language and does not include
information such as claims regarding the absence of specific adverse reactions, comparative frequency
statements other than as described below, or statements of general good tolerability such as \u{201C}well
tolerated\u{201D}, \u{201C}adverse reactions are normally rare\u{201D}, etc. Statements on lack of proof of causal association
should not be included.

In order to provide clear and readily accessible information, section 4.8 should be structured according
to the following recommendations:
a. Summary of the safety profile
b. Tabulated summary of adverse reactions
c. Description of selected adverse reactions
d. <Paediatric population>
e. <Other special population(s)>
a. Summary of the safety profile
The summary of the safety profile should provide information about the most serious and/or most
frequently occurring adverse reactions.
If known, it may be helpful to indicate the timing when adverse reactions occur. For example, in order
to prevent early discontinuation of a treatment, it may be important to inform about non-serious
adverse reactions that are frequent in the beginning of the treatment but may disappear with its
continuation. Another example would be to inform about adverse reaction associated with long-term
use. Frequencies of cited adverse reactions should be stated as accurately as possible. This summary of
the safety profile should be consistent with the important identified risks mentioned in the Safety
Specification of the Risk Management Plan. The information should be consistent with the Table of
Adverse Reactions (see section b). Cross-reference should be made to section 4.4 if relevant risk
minimisation measures have been proposed in that section.
An example of an acceptable statement is given below:
\u{2018}At the beginning of the treatment, epigastric pain, nausea, diarrhoea, headache or vertigo
may occur; these reactions usually disappear within a few days even if treatment is
continued. The most commonly reported adverse reactions during treatment are dizziness
and headache, both occurring in approximately 6% of patients. Serious acute liver injury
and agranulocytosis may occur rarely (less than 1 case per 1,000 patients)\u{2019}
b. Tabulated list of adverse reactions
A single table (or structured listing) should list all adverse reactions with their respective frequency
category. In some cases for common or very common reactions, and when it is necessary for the
clarity of the information, frequency figures may be presented in the table.
Separate tables are acceptable in exceptional cases where the adverse reaction profiles markedly differ
depending on the use of the product. For example, it might be the case for a product used for different
indications (e.g. an oncology and a non-oncology indication) or at different posologies.
The table should be introduced with a short paragraph stating the source of the safety database (e.g.
from clinical trials, post-authorisation safety studies or spontaneous reporting).
The table should be presented according to the MedDRA system organ classification. The system
organ class (SOC) should be presented in the order shown in the annex. Adverse reactions descriptions
should be based on the most suitable representation within the MedDRA terminology. This will
usually be at the Preferred Term (PT) Level, although there may be instances where the use of Lowest
Term Level or exceptionally group terms, such as High Level Terms may be appropriate. As a general
rule, any adverse reactions should be assigned to the most relevant SOC related to the target organ.
For example, PT \u{2018}Liver function test abnormal\u{2019} should be assigned to the SOC \u{2018}Hepatobiliary
disorders\u{2019} rather than to the SOC \u{2018}Investigations\u{2019}. Within each system organ class, the adverse
reactions should be ranked under headings of frequency, most frequent reactions first. Within each
frequency grouping, adverse reactions should be presented in the order of decreasing seriousness. The
names used to describe each of the frequency groupings should follow standard terms established in
each official language using the following convention: Very common (\u{2265}1/10); common (\u{2265}1/100 to
<1/10); uncommon (\u{2265}1/1,000 to <1/100); rare (\u{2265}1/10,000 to <1/1,000); very rare (<1/10,000).
In exceptional cases, if a frequency cannot be estimated from the available data, an additional category
frequency \u{2018}not known\u{2019} may be used. In case the expression \u{201C}Frequency not known\u{201D} is used, the
following text should be added in the list of terms explaining the frequency categories: \u{201C}not known

(cannot be estimated from the available data)\u{201D}. The expressions isolated/single cases/reports should
not be used.
Where additional details about an adverse reaction are described in section c), the reaction concerned
should be highlighted, for example with an asterisk, and, \u{201C}see section c)\u{201D} should be included as a
footnote.
Guidance on how to estimate the frequency of an adverse reaction is provided at the end of this
chapter of the guideline.
c. Description of selected adverse reactions
This section should include information characterising specific adverse reaction which may be useful
to prevent, assess or manage the occurrence of an adverse reaction in clinical practice.
This section should include information characterising individual serious and/or frequently occurring
adverse reactions, or those where there have been reports of particularly severe cases. The information
should provide frequency and may describe for example reversibility, time of onset, severity, duration,
mechanism of the reaction (if of clinical relevance), dose relationship, relationship with duration of
exposure or risk factors. Measures to be taken to avoid specific adverse reactions or actions to be taken
if specific reactions occur should be mentioned under section 4.4 and cross-referenced here.
Information on the occurrence of withdrawal reactions may be mentioned here with cross-reference to
section 4.2 in case of need for tapering off or advice on discontinuation of the product.
Mention should be made here of any differences between different dosage forms in respect of adverse
reactions.
In the case of combination products, information should be included in this sub-section pointing out
which particular adverse reactions are usually attributable to which active substance of the
combination, where known.
Any adverse reactions resulting directly from an interaction should be mentioned here and cross-
referenced to section 4.5.
This section should also inform on adverse reactions with very low frequency or with delayed onset of
symptoms which may not have been observed in relation to the product, but which are considered to
be related to the same therapeutic, chemical or pharmacological class. The fact that this is a class
attribution should be mentioned.
Any adverse reaction specific to excipients or residues from the manufacturing process should be
included.
d. <Paediatric population>
A paediatric sub-section should always be included (unless irrelevant).
The extent and age characteristics of the safety database in children should be described (e.g. from
clinical trials or pharmacovigilance data). Uncertainties due to limited experience should be stated.
If the observed safety profile is similar in children and adults this could be stated: e.g. \u{201C}Frequency,
type and severity of adverse reactions in children are <expected> to be the same as in adults\u{201D}.
Similarly, it is appropriate to state whether the safety profiles in the different paediatric subsets are
similar or not.
Any clinically relevant differences (i.e. in nature, frequency, seriousness or reversibility of adverse
reactions) between the safety profiles in adult and paediatric populations, or in any relevant age
groups, should be described and presented by age group. If there is a need for specific monitoring, this
should be highlighted by cross-referencing to section 4.4. For clinically relevant differences, a separate
table listing such adverse reactions by frequency can be added and presented by relevant age groups if
appropriate. If some paediatric adverse reactions are considered common (\u{2265}1/100 to <1/10) or very
common (\u{2265}1/10), the frequencies should be provided in parentheses. In case of major difference with
the safety profile in adults, a summary of the safety profile in children could be presented to facilitate
the presentation of the information. Available information, from any source scientifically validated, on

long-term safety in children (e.g. on growth, mental development and sexual maturation) should also
be summarised, whether positive or negative, with cross-reference to section 5.1 if appropriate. Any
risk factors such as duration of treatment or period at risk should be specified.
If relevant, symptoms of neonatal withdrawal should be listed in a separate paragraph with cross
reference with 4.6.
e. <Other special populations>
This section may include information on any clinically relevant differences (i.e. in nature, frequency,
seriousness or reversibility of adverse reactions, or need for monitoring) specifically observed in other
special populations such as elderly, patients with renal impairment, patients with hepatic impairment,
patients with other diseases or a specific genotype. Cross-reference to other sections such as 4.3, 4.4 or
4.5 may be added as appropriate.
Adverse reactions may also be related to genetically determined product metabolism. Subjects or
patients deficient in the specific enzyme may experience a different rate or severity of adverse
reactions. This should be mentioned and where relevant correlated with data from clinical trials.
Further guidance on the estimation of frequency of adverse reactions
The estimation of the frequency of an adverse reaction depends on the data source (i.e. clinical trial,
post-authorisation safety study or spontaneous reporting), the quality of data collection and causality
evaluation. If the choice of the frequency category is based on different sources, the category
representing the highest frequency should be chosen unless a more specific method has been applied
and thus resulted in an estimate of clearly higher validity, e.g. a pooled analysis across suitable studies.
Sources of data should use population exposed to the doses and treatment duration as recommended in
the SmPC.
Reactions that are reported under different terms but represent the same phenomenon (e.g., sedation,
somnolence, drowsiness) should ordinarily be grouped together as a single adverse reaction to avoid
diluting or obscuring the true effect. Similarly, reactions that represent a syndrome complex should
ordinarily be grouped together under an appropriate heading to avoid obscuring the full range of
respective symptoms.
Adverse reactions from clinical trials
Safety data from several studies should be pooled to increase the precision of adverse reaction rates as
appropriate without introducing bias (e.g. major difference in population characteristics or exposure to
the product).
The frequency of adverse reactions should be derived from pooled placebo-controlled studies if these
data are available and the databases are sufficiently large to be informative. If these data are
unavailable or not sufficiently informative, active-controlled data or possibly single-arm or add-on
trials databases could be used to estimate frequencies.
Frequency should represent crude incidence rates (and not differences or relative risks calculated
against placebo or other comparator).
When a common, very common or serious adverse reaction (e.g. suicide) also occurs in the placebo
group with a relevant frequency, both incidence rates can be stated to put the risk into perspective (e.g.
in subsection c).
Adverse reactions from safety studies
The choice of the frequency category to which any adverse reaction will be assigned is based on the
point estimate of the crude incidence rate derived from a study designed in such a way that specific
adverse events occurring in patients within a defined observation period would have been detected and
reasonably attributed to the medicinal product. In this situation, it is possible to calculate a point
estimate of the crude incidence rate using standard statistical methods. In cases where the original
information is expressed as an incidence density (denominator expressed as person-time), an
appropriate transformation into an incidence proportion should be performed for choosing the
frequency category. Normally, incidence proportions for the most representative exposure period (e.g.

1 week, 3 months, 1 year) should be used to derive the frequency category. However, this may not be
appropriate if the hazard function increases over time; in this case, the adverse reaction and its
frequency pattern, when clinically relevant, should be properly described in section c).
The frequency category to be chosen for each adverse reaction should not be based on differences
calculated against a comparator. However, when data are derived from a study with a non-exposed
group and the rate difference attributed to the medicinal product is smaller than the baseline or
background incidence rate, and if the adverse reaction is considered important, the background
incidence may be provided (e.g. in section c).
Adverse reactions from spontaneous reporting
The number of spontaneous reports should not be stated because the number can quickly become
outdated. Frequencies based on reporting rates from a spontaneous reporting system should not be
used to assign frequency category. In case of an unexpected adverse reaction detected from
spontaneous reporting, each adequately designed study where this adverse reaction could have been
detected should be reviewed to choose a frequency category. If the adverse reaction has never been
observed in clinical trials, then the upper limit of the 95% confidence interval is not higher than 3/X,
with X representing the total sample size summed up across all relevant clinical trials and studies (e.g.
those with a follow-up long enough to detect the adverse reaction). For example, if a particular
adverse reaction has not been observed among 3600 subjects exposed to the product in clinical trials
and studies, then the upper limit of the 95% confidence interval for the point estimate is 1/1200 or less
and the frequency category should be "rare", based on worst value of the point estimate. The rationale
for the frequency category for that particular reaction could be explained in sub-section c).
4.9 Overdose
Describe acute symptoms and signs and potential sequelae of different dose levels of the medicinal
product based on all available information including accidental intake, mistakes and suicide attempts
by patients.
Taking into account all relevant evidence, describe management of overdose in man, e.g. in relation to
monitoring or use of specific agonists/antagonists, antidotes or methods to increase elimination of the
medicinal product such as dialysis. However, there should not be any dosage recommendation of other
medicinal products (e.g. antidotes) as it could create conflict with the SmPCs of those other products.
If applicable, counteractive measures based on genetic factors should be described.
Additional information on special populations
Information specifically observed in special populations such as elderly, patients with renal
impairment, patients with hepatic impairment, other concomitant diseases etc.
Paediatric population
If there are specific paediatric considerations, there should be a sub-section entitled \u{2018}paediatric
population\u{2019}.
Special mention should be made of those medicinal products/strength of formulation for which
ingestion of only one dose unit by children can cause fatal poisoning.
5. PHARMACOLOGICAL PROPERTIES
Sections 5.1 \u{2013} 5.3 should normally mention information, which is relevant to the prescriber and to
other health-care professionals, taking into account the approved therapeutic indication(s) and the
potential adverse drug reactions. Statements should be brief and precise.
The sections should be updated regularly when new information becomes available, especially in
relation to the paediatric population.

5.1 Pharmacodynamic properties
Describe:
\u{2022} Pharmacotherapeutic group and ATC code:
Inclusion of the therapeutic subgroup (2nd level of WHO classification) with the 3rd
(pharmacological subgroup) or 4th (chemical subgroup) level is recommended.
If an ATC code is not yet available, this should be mentioned as \u{2018}not yet assigned\u{2019}.
In case of medicinal product authorised as similar biological medicinal product, the following
statement will be included:
<< (Invented) Name> is a biosimilar medicinal product. Detailed information is available on the
European Medicines Agency website; www.emea.europa.eu>
\u{2022} Mechanism of action (if known)
\u{2022} Pharmacodynamic effects.
\u{2022} Clinical efficacy and safety
It may be appropriate to provide limited information, relevant to the prescriber, such as the main
results (statistically compelling and clinically relevant) regarding pre-specified end points or clinical
outcomes in the major trials, and giving the main characteristics of the patient population. Such
information on clinical trials should be concise, clear, relevant and balanced, and should summarise
evidence from relevant studies supporting the indication. The magnitude of effects should be described
using absolute figures. (Relative risks or odd ratio should not be presented without absolute figures).
In the exceptional cases when clinically relevant information from subgroup or post-hoc analyses is
presented, it should be identified as such in a balanced manner reflecting the limited robustness of
both positive and negative secondary observations.
Any relevant pharmacogenetic information from clinical studies may be mentioned here. This should
include any data showing a difference in benefit or risk depending on a particular genotype or
phenotype.
Paediatric population
The results of all pharmacodynamic (clinically relevant) or efficacy studies conducted in children
should be presented under this sub-heading.
Information should be updated when new relevant information becomes available.
Results should be presented by age or relevant subsets.
When there are data available, but there is no authorised paediatric indication, data should be
presented and a cross-reference should always be made to section 4.2and, as appropriate to 4.3.
In presenting results of studies, particular attention should be given to include the relevant safety data.
For exploratory studies, the results of the main endpoints should be given with the main characteristics
of the population studied and the doses used.
When they are available, information and results of confirmatory studies should usually supersede and
replace those of exploratory studies. For confirmatory studies, the objectives, the study duration, the
doses used (and the formulation used if different from the marketed one), the main characteristics of
the patient population studied (including age and numbers of patient), and the main results regarding
pre-specified endpoints should be provided, whether positive or negative. If data are considered
inconclusive, this should be stated.
The objective and the main results or the conclusion of any specific clinical safety study should also
be given.
[If the EMEA has waived or deferred a paediatric development, the information should be given as
follows:]
-For waivers applying to all subsets:

\u{201C}The European Medicines Agency has waived the obligation to submit the results of studies with
<name of the product> in all subsets of the paediatric population in <condition as per PIP decision,
in the granted indication>. See 4.2 for information on paediatric use.\u{201D}
- For deferrals applying to at least one subset:
\u{201C}The European Medicines Agency has deferred the obligation to submit the results of studies with
<name of the product> in one or more subsets of the paediatric population in <condition, as per PIP
decision in the granted indication>. See 4.2 for information on paediatric use.
[For products approved under \u{2018}conditional approval\u{2019} in the centralised procedure, include the
following statement:]
<This medicinal product has been authorised under a so-called \u{2018}conditional approval\u{2019} scheme. This
means that further evidence on this medicinal product is awaited. The European Medicines Agency
(EMEA) will review new information on the product every year and this SmPC will be updated as
necessary.>
[For products approved under \u{2018}exceptional circumstances\u{2019}, include the following statement:]
<This medicinal product has been authorised under \u{2018}Exceptional Circumstances\u{2019}. This means that
<due to the rarity of the disease> <for scientific reasons> <for ethical reasons> it has not been possible
to obtain complete information on this medicinal product. The {name of Agency} will review any new
information which may become available every year and this SmPC will be updated as necessary.>
5.2 Pharmacokinetic properties
Pharmacokinetic properties of the active substance(s) relevant for the advised dose, strength and the
pharmaceutical formulation marketed should be given in this section. If these are not available, results
obtained with other administration routes, other pharmaceutical forms or doses can be given as
alternative.
Basic primary pharmacokinetic parameters, for instance bioavailability, clearance and half-life, should
be given as mean values with a measure of variability.
Pharmacokinetics items, which could be included in this section when relevant, are given below.
a. General introduction, information about whether the medicinal product is a pro-drug or whether
there are active metabolites, chirality, solubility, information on the population in which general
pharmacokinetic data were obtained, etc.
b. General characteristics of the active substance(s) after administration of the medicinal product
formulation to be marketed.
\u{2022} Absorption: complete or incomplete absorption; absolute and/or relative bioavailability;
first pass effect; Tmax; the influence of food; in case of locally applied medicinal product
the systemic bioavailability; involvement of transport proteins. If available, information
on the site of absorption in the gastro-intestinal tract should be stated (as it may be
important for administration by enteral feeding tubes).
\u{2022} Distribution: plasma protein binding; apparent volume of distribution per kilogram body
weight (l/kg); tissue and/or plasma concentrations; pronounced multi-compartment
behaviour; involvement of transport proteins.
\u{2022} Biotransformation: degree of metabolism; which metabolites; activity of metabolites
and contribution to effect and toxicity; enzymes involved in metabolism; site of
metabolism; results from in vitro interaction studies that indicate whether the new
compound can induce/inhibit metabolic enzymes.
\u{2022} Elimination: elimination half-lives, total clearance; inter and/or intra-subject variability
in total clearance; excretion routes of the unchanged substance and the metabolites
including the relative portion of the hepatic and renal eliminated fraction, involvement of
transport proteins.

\u{2022} Linearity/non-linearity: linearity/non-linearity of the pharmacokinetics of the active
substance with respect to dose and/or time; if the pharmacokinetics are nonlinear with
respect to dose and/or time, the underlying reason for the non-linearity should be
presented.
Additional relevant information should be included here.
c. Characteristics in specific groups of subjects or patients
\u{2022} Variations with respect to factors such as age, weight, gender, smoking status,
polymorphic metabolism and concomitant pathological situations such as renal failure,
hepatic disease, including degree of impairment. If the influence on pharmacokinetics is
considered to be clinically relevant, it should be described here in quantitative terms
(cross-reference to section 4.2 when applicable).
d. Pharmacokinetic/pharmacodynamic relationship(s)
\u{2022} Relationship between dose/concentration/pharmacokinetic parameter and effect (either
true endpoint, validated surrogate endpoint or side effect).
\u{2022} The population studied should be described.
Paediatric population
Results of pharmacokinetic studies in the different paediatric age groups should be summarised, with a
comparison to adults if available. If appropriate, the dose producing similar product exposure as in
adults could be given. The pharmaceutical form(s) used for pharmacokinetic studies in children should
be stated. Uncertainties due to limited experience should be stated.
5.3 Preclinical safety data
Information should be given on any findings in the non-clinical testing which could be of relevance for
the prescriber, in recognising the safety profile of the medicinal product used for the authorised
indication(s), and which is not already included in other relevant sections of the SmPC.
If the results of the non-clinical studies do not add to the information needed by the prescriber, then
the results (either positive or negative) need not be repeated in the SmPC.
The findings of the non-clinical testing should be described in brief with qualitative statements as
outlined in the following example:
\u{2022} Non-clinical data reveal no special hazard for humans based on conventional studies of safety
pharmacology, repeated dose toxicity, genotoxicity, carcinogenic potential and toxicity to
reproduction and development.
\u{2022} Effects in non-clinical studies were observed only at exposures considered sufficiently in excess
of the maximum human exposure indicating little relevance to clinical use.
\u{2022} Adverse reactions not observed in clinical studies, but seen in animals at exposure levels similar
to clinical exposure levels and with possible relevance to clinical use were as follows.
Findings of non-clinical studies relevant for use in the paediatric population, including juvenile
animals and peri- or post- natal studies, should be presented with a discussion of their clinical
relevance, under a sub-heading if necessary.
<Environmental Risk Assessment (ERA)>
Where relevant, conclusions on the environmental risk assessment of the product should be included,
with reference to section 6.6.

6 PHARMACEUTICAL PARTICULARS
6.1 List of excipients
A list should be given of the excipients, expressed qualitatively only. All excipients, which are present
in the product, should be included, even those present in small amounts, such as printing inks. Further
details on the excipients to be declared may be found in the section on definitions and examples in the
Guideline on the Excipients in the Label and Package Leaflet of Medicinal Products for Human Use.
For transdermal patches, all ingredients of the patch (including the adhesive, release liner and backing
film) should be mentioned.
The active substance itself, residues of substances used during manufacture of the finished product
(for example, solvents, head-space gases or antibiotics in vaccine manufacture), lubricants for pre-
filled syringes and constituents of capsule shells for inhalation powders not intended to be taken
should not be included.
However, certain residues such as residues of antibiotic or other antimicrobial agents used in
production that are known allergens with a potential for inducing undesirable effects should be
mentioned in section 4.3 or 4.4 as appropriate.
Excipients should be referred to by their recommended INN if existing, accompanied by the salt or
hydrate form if relevant or by their European Pharmacopoeia name. If an excipient has neither an INN
nor European Pharmacopoeia name, it should be described by its usual common name. References to
the pharmacopoeial quality should not be included. E numbers should be given along with the
common name of the excipient where they exist and when necessary for proper use, e.g. when the
excipient is listed in the Guideline on the excipients in the label and package leaflet of medicinal
products for human use (as having recognised action or effect).
The ingredients in excipient mixtures should be listed individually. In cases where the full
composition of a flavour or fragrance is not known to the applicant or is too complex, it may be
declared in general terms (e.g. \u{2018}orange flavour\u{2019}, \u{2018}citrus perfume\u{2019}). However, any of the components,
which are known to have a recognised action or effect, should be included.
Ingredients that may or may not be added for the pH adjustment should be followed by the parenthesis
\u{2018}(for pH-adjustment)\u{2019}
Invented names or general descriptive names such as \u{2018}printing ink\u{2019} should not be used in place of the
common name of an ingredient or of a mixture of ingredients but may be used in conjunction with the
name(s) of the ingredient(s), so long as it is clear which ingredients are described by the name.
Chemically modified excipients should be declared in such a way as to avoid confusion with the
unmodified excipients, e.g. \u{2018}pregelatinised starch\u{2019}.
In the case of a product containing a covert marker for the purpose of tracking, tracing and
authentication, a general term such as \u{201C}authentication factor\u{201D} should be included in the list of
excipients instead of the name of the excipient, unless the excipient is one that is known to have a
recognised action or effect.
For clarity, it is recommended that each excipient be listed on a separate line. It can be useful to list
excipients according to the different parts of the product, e.g. tablet core/coat, capsule contents/shells,
etc. For products that are presented in more than one container or in dual-chamber containers, the
excipients should be listed per container or per chamber.
Abbreviations for excipients should not be used. However, where justified for space considerations,
abbreviations for excipient names may appear on the labelling, on condition that these abbreviations
are designated in section 6.1.
6.2 Incompatibilities
Information on physical and chemical incompatibilities of the medicinal product with other products
with which it is likely to be mixed or co-administered should be stated. This is particularly important
for medicinal products to be reconstituted and/or diluted before parenteral administration. Significant

interaction problems, e.g. sorption of products or product components to syringes, large volume
parenteral containers, tubing, in-line filters, administration sets, etc. should be stated.
Statements concerning compatibility of the product with other medicinal products or devices should
not be included in this section but in section 6.6. Statements concerning pharmacological and
chemical/physical incompatibilities with food should be included in section 4.5. If appropriate, the
standard statement, \u{2018}Not applicable\u{2019}, should be included.
For certain pharmaceutical forms, e.g. parenterals, either of the following standard statements should
be included as appropriate:
\u{2022} \u{2018}In the absence of compatibility studies, this medicinal product must not be mixed with other
medicinal products.\u{2019}
\u{2022} \u{2018}This medicinal product must not be mixed with other medicinal products except those
mentioned in section 6.6.\u{2019}
6.3 Shelf life
The shelf life should be given for the medicinal product as packaged for sale and, if appropriate, after
dilution or reconstitution or after first opening.
A clear statement of the shelf life should be given, in an appropriate unit of time.
For statements to be included regarding in-use shelf lives of sterile products, consult the Note for
Guidance on maximum shelf life for sterile products for human use after first opening or following
reconstitution. An in-use shelf life may need to be stated for other medicinal products if development
studies have found it to be necessary.
Additionally, if different concentrations need to be prepared, e.g. for use in children, the
physicochemical stability throughout the entire concentration range should be stated; e.g. \u{201C}The
stability has been demonstrated between x mg/ml and y mg/ml for t hours/days at 25 \xbaC and 2-8 \xbaC\u{201D}.
In case of a paediatric indication, if no age appropriate formulation is available for children but an
extemporaneous formulation could be prepared from an existing formulation, relevant
physicochemical data on storage and stability should be included here with a cross-reference in
sections 6.4 and 6.6."
In case of specific temporary storage conditions need to be provided to healthcare professionals or
patients, e.g. for the purpose of ambulatory use (e.g. shelf-life 24 months at 2-8\xb0C of which 3 months
could be below 25\xb0C), specific additional guidance should be provided as appropriate. Such
information should always be based on stability data. In particular, the recommended temperature
range and maximum duration of temporary storage should be specified. This guidance may also
include the action to be taken after the product has been stored under the temporary storage conditions
(e.g. discard immediately).
Statements such as \u{201C}These data are not recommendations for storage\u{201D} should not be used.
No reference should be made to the container unless there are different shelf lives for different
containers. Storage conditions should not be included, except for the storage conditions after opening
(see the corresponding guideline). Statements such as \u{2018}Do not use after the expiry date\u{2019} should not be
included.
When a device is supplied together with a medicinal product, the in-use shelf-life of the device should
be given where applicable.
6.4 Special precautions for storage
Storage warnings should use one or more of the standard statements from the Note for Guidance on
declaration of storage conditions in the product information of medicinal products. When such a
standard statement is used, an explanation specifying whether the product is sensitive to light and/or
moisture should be added.

For storage of sterile products that have been opened, diluted or reconstituted, a cross-reference should
be made to section 6.3.
Note that if a specific storage warning is required, the warning should be consistent between the
SmPC, label and PL.
A warning to keep the product out of the reach and sight of children should not be included in the
SmPC.
6.5 Nature and contents of container
Reference should be made to the immediate container using the European Pharmacopoeia standard
term; the material of construction of the immediate container should be stated (\u{2018}glass vials\u{2019},
\u{2018}PVC/Aluminium blisters\u{2019}, \u{2018}HDPE bottles\u{2019}); and any other component of the product should be listed,
e.g. needles, swabs, measuring spoons, syringes inhaler devices, desiccant. The graduation on
measuring devices should be explained. The container of any solvent provided with the medicinal
product should also be described. Excessive detail, e.g., concerning the colour of the stopper, the
nature of the heat-seal lacquer, should usually not be included. For parenteral preparations, when
enclosure colour is used to differentiate between the presentations of a product, this should be stated
here.
If appropriate, it should be indicated if the container closure is child-resistant.
Examples on the text in this section:
\u{2018}<Volume> ml suspension in a pre-filled syringe (glass) with plunger stopper (chlorobutyl
rubber) with or without needle in pack sizes of 5 or 10.\u{2019}
\u{2018}HDPE bottle with a child-resistant closure and a silica gel desiccant. Pack-sizes of 30, 60 or
90 film-coated tablets.\u{2019}
All pack sizes should be listed. Pack sizes mentioned should include the number of units, number of
doses (for e.g. multi-dose vaccines, inhalers, etc.), total weight or volume of the immediate container,
as appropriate, and the number of containers present in any outer carton. If appropriate, a standard
statement, \u{2018}Not all pack sizes may be marketed\u{2019}, should be included, in order to alert health
professionals to the fact that not all listed pack sizes may be available for prescribing or dispensing.
Multiple unit packs for distribution purposes only do not constitute new pack sizes for marketing of
the product and should therefore not be included in this section.
6.6 Special precautions for disposal of a used medicinal product or waste materials derived
from such medicinal product and other handling of the product 2
Instructions for disposal should be included here, if appropriate for the product.
Where special precautions for the handling and disposal of certain products such as cytotoxics and
some biological products or waste material derived from it are advised, e.g. in the case of products
containing live organisms, these should be stated in this section, as should, where relevant, the
disposal of items which come into contact with the product, such as nappies, or spoons used to
administer oral vaccines. If relevant, a cross-reference to conclusions on the environmental risk
assessment described in section 5.3 can be included.
If applicable, e.g. for cytotoxics, the following standard statement should be included, \u{2018}Any unused
product or waste material should be disposed of in accordance with local requirements.\u{2019}
If there are no special use or handling instructions for the pharmacist or other healthcare professionals,
the standard statement, \u{2018}No special requirements.\u{2019} should be included.
2 This section is reflected in the QRD template in the section 6.6 \u{2018}Special precautions for disposal < and other handling >\u{2019}

Any directions necessary for the accurate preparation of certain products such as cytotoxics and some
biological products and/or necessary for the protection of persons including parents or carers preparing
or handling the product should be stated.
In section 4.2, instructions on handling of the product by the doctor, other health personnel, or patient
should be included, as well as general information concerning the administration of the product
(whether administered by the patient or the health personnel). If instructions for use/handling are
needed where the medicinal product has to be prepared before use, e.g. where it must be suspended or
diluted, this information has to be given here.
For clarity, a cross-reference in section 4.2 to the relevant information in section 6.6 could be
included, e.g. \u{2018}For instructions on dilution of the product before administration, see section 6.6.\u{2019}
It is recommend that only information necessary for the pharmacist or other health personnel to
prepare the product for administration to the patient should be included here.
Information on the preparation (e.g. the suspension of a powder for injection, or preparing a dilution)
of the medicinal should be included in section 6.6, regardless of who prepares the product (e.g.
pharmacist, doctor, other health personnel, patient, parents or carers). In the case of products for
reconstitution, the appearance of the product after reconstitution should be stated.
Statements concerning compatibility of the product with other medicinal products or devices can be
given here provided the data have been provided in the dossier.
In the exceptional cases where a product is indicated in children and where no adequate paediatric
formulation can be developed (based on duly justified scientific grounds), information on
extemporaneous formulation should appear under a sub-heading \u{201C}Use in the paediatric population\u{201D}
and should cross-refer to the section 4.2. Detailed instructions for the preparation of the
extemporaneous formulation from the appropriate \u{201C}adult\u{201D} or other \u{201C}older children\u{201D} dosage form and
additional information on extemporaneous formulations for use in younger children shall be provided
and, where appropriate, the maximum storage time during which such preparation will conform to its
specifications. When necessary, the required packaging material and storage conditions should be
stated here.
Any specific warnings for the handling of the product should be in section 4.4.
Information on risks due to occupational exposure should be included in this section, with reference to
section 4.4 or 4.8 if there is information in that section.
7 MARKETING AUTHORISATION HOLDER
Name and permanent address or registered place of business of the Marketing Authorisation Holder.
Telephone, fax numbers or e-mail addresses may be included (not websites or emails linking to
websites).
8 MARKETING AUTHORISATION NUMBER(S)
Item to be completed by the competent authority or by the Marketing Authorisation Holder once the
Marketing Authorisation has been granted. For medicinal products for which the European
Commission is the Competent Authority, the number to be included in this section is the number in the
Community Register.
9 DATE OF FIRST AUTHORISATION/RENEWAL OF THE AUTHORISATION
Item to be completed by the competent authority or by the Marketing Authorisation Holder once the
Marketing Authorisation has been granted or renewed. Both the date of first authorisation and, if the
authorisation has been renewed, the date of the (last) renewal should be stated in the format given in
the following example:

Date of first authorisation: 3 April 1985
Date of latest renewal: 3 April 2000
10 DATE OF REVISION OF THE TEXT
Leave blank in case of a first Marketing Authorisation.
For medicinal products for which the European Commission is the Competent Authority: date of
approval of latest variation or transfer, e.g. the latest Commission Decision amending the SmPC,
implementation date of the Urgent Safety Restriction or date of (EMEA) notification amending the
annexes to the Marketing Authorisation.
For products for which Member States are the Competent Authorities: date of approval of latest
variation or implementation date of the Urgent Safety Restriction resulting in a revision of the SmPC.
Item to be completed by the competent authority or by the Marketing Authorisation Holder at time of
printing the SmPC.
11 DOSIMETRY (IF APPLICABLE)
Full details of internal radiation dosimetry should be included in this section for radiopharmaceuticals.
For all other products, this section should be excluded.
12 INSTRUCTIONS FOR PREPARATION OF RADIOPHARMACEUTICALS (IF
APPLICABLE)
For radiopharmaceuticals, additional detailed instructions for extemporaneous preparation and quality
control of such preparation and, where appropriate, maximum storage time during which any
intermediate preparation such as an eluate or the ready-to-use pharmaceutical will conform to its
specifications.
Special instructions relating to the disposal of containers and unused contents should also be included.

ANNEX
THE MEDICAL DICTIONARY FOR REGULATORY ACTIVITIES TERMINOLOGY
(MedDRA)
All ADRs should be grouped according to the following order based on the MedDRA system organ
classes (SOC). As a general rule, MedDRA terms should be classified according to the most relevant
SOC related to the target organ.
A pragmatic approach to the location of terms should be taken in order to make the identification of
adverse reactions simpler and clinically appropriate for the reader. For example, it may be helpful on
some occasions \u{2013} solely in the context of the SmPC - to use secondary SOC locations of some
MedDRA Preferred Terms (PT), or sometimes to use locations that do not strictly accord with the
MedDRA architecture. For example, if the PT \u{2018}Liver function test abnormal\u{2019}, \u{2018}Hepatitis\u{2019} and \u{2018}Hepatic
encephalopathy\u{2019} are to be included in an SmPC, it would be acceptable to include them all under the
SOC \u{2018}Hepatobiliary disorders\u{2019} instead of distributing the reactions among the SOCs \u{2018}Hepatobiliary
disorders\u{2019}, \u{2018}Nervous system disorders\u{2019} and \u{2018}Investigations\u{2019} as dictated by their primary location in
MedDRA.
SOC LIST
\u{2022} Infections and infestations
\u{2022} Neoplasms benign, malignant and unspecified (including cysts and polyps)
\u{2022} Blood and lymphatic system disorders
\u{2022} Immune system disorders
\u{2022} Endocrine disorders
\u{2022} Metabolism and nutrition disorders
\u{2022} Psychiatric disorders
\u{2022} Nervous system disorders
\u{2022} Eye disorders
\u{2022} Ear and labyrinth disorders
\u{2022} Cardiac disorders
\u{2022} Vascular disorders
\u{2022} Respiratory, thoracic and mediastinal disorders
\u{2022} Gastrointestinal disorders
\u{2022} Hepatobiliary disorders
\u{2022} Skin and subcutaneous tissue disorders
\u{2022} Musculoskeletal and connective tissue disorders
\u{2022} Renal and urinary disorders
\u{2022} Pregnancy, puerperium and perinatal conditions
\u{2022} Reproductive system and breast disorders
\u{2022} Congenital, familial and genetic disorders
\u{2022} General disorders and administration site conditions
\u{2022} Investigations
\u{2022} Injury, poisoning and procedural complications
\u{2022} Surgical and medical procedures
\u{2022} Social circumstances
Adverse reaction descriptions should be based on the most suitable representation within the MedDRA
terminology. This will usually be at the PT level, although there may be instances where the use of
Lowest Level Terms (LLT) or group terms, such as high-level terms (HLT) may be appropriate. It is
acceptable to adapt the names of the MedDRA group terms if this makes their meaning more
transparent to the reader of the SmPC; e.g. the use of the suffixes NEC and NOS are not appropriate
for inclusion in the SmPC. The adverse reaction term should be expressed in natural word order, e.g.
\u{2018}Interstitial pneumonia\u{2019} in preference to \u{2018}Pneumonia interstitial\u{2019}. It may be appropriate to modify
MedDRA terms in other ways in the interests of comprehensibility. The most widely recognised term

for a particular condition should be used, e.g. the use of \u{2018}Churg Strauss syndrome\u{2019} might be more
appropriate than the use of \u{2018}Allergic granulomatous angiitis\u{2019}.
Within each MedDRA SOC, adverse reactions should be classified according to their frequency of
occurrence. Prior to estimating frequency of occurrence of adverse events from systematic studies
(clinical trials or other sources), appropriate levels of the MedDRA hierarchy should be used in order
to group together clinically related conditions in a meaningful way. For example, if \u{2018}postural
dizziness\u{2019}, \u{2018}exertional dizziness\u{2019} and \u{2018}unspecified dizziness\u{2019} were each reported by 2% of patients,
this might reasonably be represented in the SmPC as \u{2018}Dizziness\u{2019} occurring in 6% of patients
(assuming that only one report of dizziness applied to each patient). It may also be appropriate to use
ad hoc groupings of terms, or to adapt MedDRA group terms if the established MedDRA group terms
are not completely suitable, e.g. reports of adverse reactions represented as \u{2018}Diarrhoea\u{2019}, \u{2018}Diarrhoea
aggravated\u{2019}, \u{2018}Loose stools\u{2019}, \u{2018}Stools watery\u{2019}, \u{2018}Intestinal hypermotility\u{2019} or other might all reasonably be
represented as the single term \u{2018}Diarrhoea\u{2019} in the interest of making the SmPC relevant and
comprehensible to patients. The total number of those cases should be used to estimate the frequency
of diarrhoea.`;
const $81b98fb9de868a7b$export$6edfdea2dd4b547f = `The summary of the pharmacovigilance system master file shall contain the following information:
(a) the pharmacovigilance system master file reference number;
(b) the pharmacovigilance system master file location;
(c) name, contact details and place of operation of the qualified person responsible for pharmacovigilance;
(d) the signed statement referred to in Article 22(2)(b), point (i);
(e) the type of record management system used for adverse events reports including the name of the database, if applicable.`;
const $81b98fb9de868a7b$export$baa027a998e5fdd4 = "25\nB. PACKAGE LEAFLET\n[NOTE: the following items must appear in the package leaflet as required by Title V of Directive\n2001/83/EC. In the case of advanced therapy medicines, these items are listed in Annex IV of\nRegulation (EC) 1394/2007.\nThe package leaflet must be readable for the patient; please refer to the \u201CGuideline on the Readability\nof the Labelling and Package Leaflet of Medicinal Products for Human Use\u201D as published on the\nwebsite of the European Commission in the Notice to Applicants, Volume 2C:\nhttps://health.ec.europa.eu/document/download/d8612682-ad17-40e3-8130-\n23395ec80380_en?filename=2009_01_12_readability_guideline_final_en.pdf. The package leaflet\nshould be written in a language understandable by the patient and should reflect the terminology the\npatient is likely to be familiar with.\nThroughout the text \u201CX\u201D stands for the (invented) name of the medicine.\nHeadings and standard statements given in the template must be used whenever they are applicable. If\nthe applicant needs to deviate from these headings/statements to accommodate medicine-specific\nrequirements (e.g. for medicines administered by healthcare professionals, \u201Ctake\u201D/\u201Duse\u201D could be\nreplaced by \u201Care given\u201D or \u201Care administered\u201D), alternative or additional headings/statements will be\nconsidered on a case-by-case basis.\nWhen requested, applicants should justify the use of alternative headings (e.g. by reference to user\ntesting results). For certain medicines not all items may be relevant, in this case the corresponding\nheading should not be included.\nThe purpose of the templates is to ensure that all the information required by Directive 2001/83/EC is\nincluded in the text versions of all packaging components in the order specified (where order is a\nrequirement of the legal provisions).\nDesign and layout are key elements for the readability of the final printed material. Having used the\ntemplates provided, MAHs will still need to format the resulting texts into the relevant full colour\nmock-ups for all packaging components. This template ensures a certain degree of consistency across\ncentrally authorised medicines, however the formatting should not be transferred to the printed\nmaterial (especially the font and text size).\nGuidance notes in orange cross-refer to the section/information of the SmPC which is to be reflected\nin that particular section of the package leaflet.\n\n26\nApplicants shall ensure that, on request from patients' organisations, the package leaflet is made\navailable in formats appropriate for the blind and partially sighted. MAHs are, therefore, encouraged\nto include a statement at the end of the package leaflet to inform about the availability of such\nalternative formats.]\n\n27\nPackage leaflet: Information for the <patient> <user>\n[Heading to be printed]\n{(Invented) name strength pharmaceutical form}\n{active substance(s)}\n[The (invented) name of the medicine (referred to as \u201Cthis medicine\u201D throughout the package leaflet,\nwherever practical) followed by the strength and pharmaceutical form (i.e. as it appears in section 1 of\nthe SmPC) should be stated here in bold. This should be followed by the active substance(s) (as stated\non the label section 1), which may be written on the line below. In the remainder of the document the\n(invented) name should appear without bold or underline and should not be used excessively\nthroughout the text.]\n[For medicinal products subject to additional monitoring ONLY:\nThe black symbol and the statements should only appear here. The black symbol shall be a black\ninverted equilateral triangle: the symbol shall be proportional to the font size of the subsequent\nstandardised text and in any case each side of the triangle shall have a minimum length of 5 mm. For\nthe purpose of preparing the product information annexes please use the black triangle as presented in\nthis template (see below).]\n< This medicine is subject to additional monitoring. This will allow quick identification of new\nsafety information. You can help by reporting any side effects you may get. See the end of section 4\nfor how to report side effects. >\n[For medicines available only on prescription:]\n<Read all of this leaflet carefully before you start <taking> <using> this medicine because it\ncontains important information for you.\n- Keep this leaflet. You may need to read it again.\n- If you have any further questions, ask your <doctor> <,> <or> <pharmacist> <or nurse>.\n<- This medicine has been prescribed for you only. Do not pass it on to others. It may harm them,\neven if their signs of illness are the same as yours.> [Do not include this statement in case of\nhospital use.]\n- If you get any side effects, talk to your <doctor> <,> <or> <pharmacist> <or nurse>. This\nincludes any possible side effects not listed in this leaflet. See section 4.>\n[For medicines available without a prescription:]\n<Read all of this leaflet carefully before you start <taking> <using> this medicine because it\ncontains important information for you.\nAlways <take> <use> this medicine exactly as described in this leaflet or as your <doctor> <,> <or>\n<pharmacist> <or nurse> <has> <have> told you.\n- Keep this leaflet. You may need to read it again.\n- Ask your pharmacist if you need more information or advice.\n- If you get any side effects, talk to your <doctor> <,> <or> <pharmacist> <or nurse>. This\nincludes any possible side effects not listed in this leaflet. See section 4.\n- You must talk to a doctor if you do not feel better or if you feel worse <after {number of}\ndays>.>\nWhat is in this leaflet\n[User testing to date has indicated that most patients value a content listing in the package leaflet. In\norder for this to be most useful it needs to be prominently displayed where it appears. The content\nlisting would normally reflect the six main sections of the leaflet, where a flat leaflet is prepared.\nHowever, if a booklet format is used, or the flat leaflet contains many subsections, a more detailed\ncontent listing may be used (page numbers or column numbers, which enable readers to quickly find\nthe information they are seeking, can only be included in the mock-up).]\n1. What X is and what it is used for\n2. What you need to know before you <take> <use> X\n\n28\n3. How to <take> <use> X\n4. Possible side effects\n5. How to store X\n6. Contents of the pack and other information\n1. What X is and what it is used for\n[(Invented) name, active substance(s) and pharmacotherapeutic group]\n[You should first of all include the (invented) name of the medicinal product and the active\nsubstance(s) included in it, if necessary, as per section 1 and 2 of the SmPC, e.g. \u201CX contains the\nactive substance Y\u201D. The pharmacotherapeutic group and/or type of activity, as per section 5.1 of the\nSmPC should also be stated, e.g. \u201Cstatins (used to lower cholesterol)\u201D.]\n[Therapeutic indications]\n[The therapeutic indications in line with section 4.1 of the SmPC should be stated here. It should be\nstated in which age group the medicine is indicated, specifying the age limits, e.g. \u201CX is used to treat\n{specify indication} in <adults> <new-born babies> <babies> <children> <adolescents> <aged {x to\ny}> <years> <months>\u201D.]\n[If appropriate, specify that:\n- if the medicine is an advanced therapy medicine which contains cells or tissues, a description of\nthose cells or tissues and of their specific origin, including the species of animal in cases of\nnon-human origin, should be provided in line with section 2.1 of the SmPC.\n- if the medicine is an advanced therapy medicine which contains medical devices or active\nimplantable medical devices, a description of those devices and their specific origin should be\nprovided in line with section 2.2 of the SmPC.]\n[Information on the benefits of using this medicine]\n[On a case-by-case basis, information on the benefits of the treatment could be included in this section,\nas long as it is compatible with the SmPC, useful for the patient, and to the exclusion of any element\nof a promotional nature (in accordance with art 62 of Directive 2001/83/EC). This could be included\nunder a separate sub-heading, e.g. entitled \u201CHow X works\u201D.\nThe information should be depicted in a clear and condensed way. For example, information could\nrelate to:\n- signs and symptoms of the target disease, in particular for non-prescription medicines, but also for\nmedicines to be taken \u201Con-demand\u201D (e.g. treatment of migraine);\n- the benefit(s) of taking the medicine could be summarised (e.g. \u201Cthis medicine reduces pain\nassociated with arthritis\u201D, \u201Cthis medicine has been shown to reduce blood sugar, which helps to\nprevent complications from your diabetes\u201D). This would be particularly important to encourage\nadherence to the treatment, e.g. for long-term and prevention treatment. Benefit may be described in\nterms of prevention of disease complications (e.g. anti-diabetic), if established. The timing of the\neffect may also be described if useful. In any case, information must be compatible with the SmPC, in\nparticular section 5.1;\n- information on the amount of time the medicine usually takes to work may be presented if relevant\nfor the patient (painkiller, antidepressant, etc).\n<You must talk to a doctor if you do not feel better or if you feel worse <after {number of} days>.>.]\n2. What you need to know before you <take> <use> X\n[This section should include information which patients/users should be aware of before they start\ntaking the medicine and while using it. This section of the package leaflet is the one which in user\ntesting patients have most difficulty with due to its overall size. Inclusion of additional sub-headings\n(e.g. for information to particular category of users) with a clear hierarchy is therefore critical in\nhelping patients to navigate this information.]\n\n29\n[Contraindications]\nDo not <take> <use> X\n[All contraindications mentioned in section 4.3 of the SmPC should be included here in the same order\nas presented in the SmPC. Other precautions and special warnings should be presented in the next\nsection.\nCare must be taken to ensure that complex details are not omitted. It is not acceptable to state only the\ncommon or major contraindications. Belief that a patient cannot understand a contraindication is not a\nreason for omitting it.]\n- <if you are allergic to {active substance(s)} or any of the other ingredients of this medicine\n(listed in section 6).> [include reference to residues, if applicable.]\n[Appropriate precautions for use; special warnings]\nWarnings and precautions\nTalk to your doctor <or> <pharmacist> <or nurse> before <taking> <using> X [in case of long\nbulleted list, book-ends (i.e. whereby the statement recommending the action to talk to your doctor or\npharmacist is repeated after each warning or precaution) are recommended.]\n[All warnings and precautions for use included in section 4.4 of the SmPC should be provided here (as\nin the SmPC, the order should be in principle determined by the importance of safety information\nprovided) and it should also be made clear for each warning or precaution for use, what action the\npatient should take to minimise the potential risk.\nDetailed information on warnings and precautions relating to side effects that could occur while a\npatient is taking the medicine should be presented in section 4 (e.g. symptoms), with an appropriate\ncross-reference in section 2.]\n[Warnings relating to interactions, fertility, pregnancy and breast-feeding, the ability to drive and use\nmachines, or excipients should be presented in the relevant subsequent subsections, unless they are of\nmajor safety importance (contraindication) in which case they should also be highlighted in the\nsubsection \u201CDo not take/use X\u201D, above.]\n[An additional sub-heading could be included for information on additional monitoring tests that the\npatient will be required to undergo during treatment.]\nChildren <and adolescents>\n[When the medicine is indicated in children, the warnings and precautions which are specific to this\npopulation (and identified as such in section 4.4 of the SmPC) should be included under this\nsub-heading. Where relevant, parents/carers should also be alerted in this section of potential\nchildren/teenager specific warnings included under \u201Cdriving and using machines\u201D.]\n[If there is no indication in some or all subsets of the paediatric population, information should reflect\nthe paediatric subsection of section 4.2 of the SmPC, e.g. \u201CDo not give this medicine to children\nbetween the ages of x and y <years> <months> because <of the risk of [\u2026]> <it does not work> <the\npotential benefits are not greater than the risks>, <it is unlikely to be safe>\u201D.]\n[Interactions with other medicines]\nOther medicines and X\n<Tell your <doctor> <or> <pharmacist> if you are <taking> <using>, have recently <taken> <used>\nor might <take> <use> any other medicines.>\n[Describe the effects of other medicines on the medicine in question and vice versa as per section 4.5\nof the SmPC. Refer to other medicines by their pharmacotherapeutic group/type of activity and by\ntheir INN(s) (including the lay terms first and the INNs in brackets unless the interaction is only with\none active in a class, e.g. \u201Cpravastatin (medicine used to lower cholesterol)\u201D), where possible.]\n[In some cases, where it may be helpful to the patient, you should describe in brief terms the\nconsequence of the interaction. One possibility could be to distinguish the medicine which must not be\n\n30\nused with the medicine, e.g.: \u201CDo not take X with Y (a medicine used for Z) as this may result in the\n<loss of its effect><side effect>\u201D, those for which the combination should be avoided and those for\nwhich the combination would require some precaution (e.g. dose adjustment; in such a case please\ncross-refer to section 3 of this leaflet). For example, if hormonal oral contraceptives are likely to\nbecome ineffective as a result of an interaction, patients should also be advised to use additional forms\nof contraceptives (e.g. barrier contraceptives).]\n[Interactions with herbal or alternative therapies should be addressed if mentioned in section 4.5 of the\nSmPC.]\n[Interactions with food and drink]\nX with <food> <and> <,> <drink> <and> <alcohol>\n[Interactions not related to medicines should be mentioned here if reference is made in section 4.5 of\nthe SmPC. For example, patients should not consume milk in combination with tetracyclines and no\nalcohol should be consumed during treatment with benzodiazepines. This section should not be used\nto tell patients whether or not their medicine should be taken before, during or after meals as this\nshould only be addressed in section 3 (below), but a cross-reference to section 3 can be included.]\n[Use by pregnant or breast-feeding women, information on fertility]\nPregnancy <and> <,> breast-feeding <and fertility>\n[Where the information is significantly different, pregnancy, breast-feeding and fertility information\ncan be presented under separate sub-headings.]\n[Include conclusion summary of the information given in section 4.6 of the SmPC, in addition to the\nfollowing optional statement:]\n<If you are pregnant or breast-feeding, think you may be pregnant or are planning to have a baby, ask\nyour <doctor> <or> <pharmacist> for advice before taking this medicine.>\n[Please note that if the medicine is contraindicated in pregnancy and/or breast-feeding the same\ninformation should be presented in both subsections (\u201CDo not take/use X\u201D & \u201CPregnancy,\nbreast-feeding and fertility\u201D) of the leaflet and should include information on teratogenicity where this\nis known.]\n[Effects on the ability to drive or to use machines]\nDriving and using machines\n[Where there is cautionary advice in section 4.7 of the SmPC this should be translated into meaningful\ncolloquial language for the patient.\nMAHs should bear in mind that medicines taken by children may need specific advice. For example,\nregarding road safety, children who may not be old enough to drive may nevertheless cycle.\nThe advice should include an explanation as to why the patient is advised not to drive or undertake\nthese tasks, and whether or not they should discuss this with their doctor if they wish to do so.]\n[Excipients warnings]\n<X contains {name the excipient(s)}>\n[If appropriate, warnings of those excipients knowledge of which is important for the safe and\neffective use of the medicine and included in the guideline on \u201CExcipients in the Label and Package\nLeaflet of Medicinal Products for Human Use\u201D (The rules governing medicinal products in the\nEuropean Union, Volume 3B), as per section 4.4 of the SmPC, should be mentioned here. This\nsubsection should be omitted when the medicine does not contain any excipients of known effect. In\ncase the information relates to another section of the package leaflet (e.g. alcohol), a cross reference to\nthis section should be made; it will be necessary to refer back to the excipients warning from those\nsections relating to the effects (e.g. ability to drive, pregnancy and breast-feeding, paediatric\ninformation).]\n3. How to <take> <use> X\n\n31\n[In simple cases, the following 3 items can be combined as one paragraph.]\n[ Dose (SmPC section 4.2)]\n[For medicines available on prescription only:]\n<Always <take> <use> this medicine exactly as your doctor <or pharmacist> has told you. Check with\nyour <doctor> <or> <pharmacist> if you are not sure.>\n<The recommended dose is ...>\n[For medicines available without prescription:]\n<Always <take> <use> this medicine exactly as described in this leaflet or as your <doctor> <,> <or>\n<pharmacist> <or nurse> <has> <have> told you. Check with your <doctor> <or> <,> <pharmacist>\n<or nurse> if you are not sure.>\n<The recommended dose is ...>\n[When available, information on maximum single, daily and/or total dose should also be included.\nAdditional sub-headings may be included where the posology varies for different indications or for\ndifferent populations (e.g. elderly, hepatic impairment, renal impairment). Include the recommended\ndose and specify, if necessary, the appropriate time(s) at which the medicine may or must be\nadministered.]\n<Use in children <and adolescents>>\n[When the medicine is indicated in different age groups with a different dose, method of\nadministration, frequency of administration or duration of treatment, specific instructions for use for\neach age group should be clearly identified.\nIf there are more appropriate strength(s) and/or pharmaceutical form(s) for administration in some or\nall subsets of the paediatric population (e.g. oral solution for infants), these should be mentioned, e.g.\n\u201COther form(s) of this medicine may be more suitable for children; ask your doctor or pharmacist.\u201D.]\n[Route(s) and/or method of administration (SmPC section 4.2)]\n[Route(s) of administration according to \u201CStandard Terms\u201D published by the Council of Europe and an\nadditional patient-friendly explanation may be given if necessary.\nMethod of administration: directions for a proper use of the medicine, e.g. \u201CDo not swallow\u201D, \u2018Do not\nchew\u201D, \u201CShake well before use\u201D (user testing experience has shown it is useful to state the reasons for\nthe inclusion of such a statement, e.g. \u201CDo not break or crush the tablet(s). If you do, there is a danger\nyou could overdose because this medicine will be absorbed into your body too quickly\u201D).\nWhen applicable, there should be descriptions (if useful with illustrations) of opening techniques for\nchild-resistant containers and other containers to be opened in an unusual way.\nWhere relevant, guidance should always be included to clarify if the medicine must be taken with\nfood, during/before meals, or clearly state if food/meals have no influence, etc.]\n<The score line is only there to help you break the tablet if you have difficulty swallowing it whole.>\n<The tablet can be divided into equal doses.>\n<The score line is not intended for breaking the tablet.>\n[Duration of treatment (SmPC section 4.2)]\n[If appropriate, especially for medicines available without prescription, precise statements should be\nincluded on:\n\u2022 the usual duration of the therapy;\n\u2022 the maximum duration of the therapy;\n\u2022 the intervals with no treatment;\n\u2022 the cases in which the duration of treatment should be limited.]\n[For some medicines it may be necessary to include some additional information in this section\nalthough this need not be covered in all cases. The following headings can be used as a guide:]\n<If you <take> <use> more X than you should>\n\n32\n[Describe how to recognise symptoms if someone has taken an overdose and what to do as per SmPC\nsection 4.9.]\n<If you forget to <take> <use> X>\n[Make clear to patients what they should do after irregular use of a medicine, e.g.: if information is\navailable, try to include information on the maximum interval the missed dose can be caught up as per\nSmPC section 4.2.]\n<Do not take a double dose to make up for a forgotten <tablet> <dose> <\u2026>.>\n<If you stop <taking> <using> X>\n[Indicate withdrawal effects and how to minimise them as per SmPC section(s) 4.2 and/or 4.4.\nA statement on the potential consequences of stopping the treatment before finishing the course of\ntreatment and the need for a prior discussion with the treating physician, pharmacist or nurse should be\nincluded as appropriate.]\n[Close this section with:]\n<If you have any further questions on the use of this medicine, ask your <doctor> <,> <or>\n<pharmacist> <or nurse>.>\n4. Possible side effects\n[Description of side effects]\n[Begin this section with]\nLike all medicines, this medicine can cause side effects, although not everybody gets them.\n[The section should generally be divided into two sections bearing in mind that there should be\nsufficient patient-friendly description of the overt clinical signs and symptoms to enable the patient to\nrecognise all side effects which may occur as set out in section 4.8 of the SmPC:\n1) the most serious side effects need to be listed prominently first with clear instructions to the\npatients on what action to take (e.g. to stop taking the medicine and/or seek urgent medical\nadvice. The use of the words \u201Cstraight away\u201D or \u201Cimmediately\u201D may be helpful in this context).\n2) then a list of all other side effects, listed by frequency and starting with the most frequent\n(without repeating the most serious included above).\nWithin each section mentioned above, side effects should be arranged by frequency. The following\nfrequency convention is recommended:\nVery common: may affect more than 1 in 10 people\nCommon: may affect up to 1 in 10 people\nUncommon: may affect up to 1 in 100 people\nRare: may affect up to 1 in 1,000 people\nVery rare: may affect up to 1 in 10,000 people\nNot known: frequency cannot be estimated from the available data\nThis frequency convention should not appear before the list of side effects as this takes up space and\nhas shown in user testing to be misleading to patients.\nIn any case, when expressing the likelihood of side effects, it is important to include verbal terms and\nnumerical data, as far as possible. Bear in mind that user testing has shown that double sided\nexpressions such as \u201Caffects more than 1 in 100 but less than 1 in 10\u201D are not well understood and\nshould not be used.\nSystem organ class listings should not be used. However, patient-friendly terms for parts of the body\nmay be used as headings where the frequency is not known (e.g. for older medicines) in order to break\nup an otherwise long list, e.g. skin, stomach and gut, etc.]\n<Additional side effects in children <and adolescents >>\n[If appropriate (and in line with information stated in section 4.8 of the SmPC), a subsection should\nhighlight any clinically relevant differences in terms of side effects in any relevant subset of the\npaediatric population compared to another or to the adult population.]\n\n33\n[For ALL medicinal products:\nThe following sub-heading should appear at the end of section 4:]\nReporting of side effects\nIf you get any side effects, talk to your <doctor> <or> <,> <pharmacist> <or nurse>. This includes any\npossible side effects not listed in this leaflet. You can also report side effects directly via the national\nreporting system listed in Appendix V.* By reporting side effects you can help provide more\ninformation on the safety of this medicine.\n[*For the printed materials: No reference to Appendix V should be included in the printed materials.\nThe above grey-shaded terms will only appear in the published version of the approved product\ninformation annexes on the European Medicines Agency website. The actual details of the national\nreporting system (as listed in Appendix V) of the concerned Member State(s) shall be displayed on the\nprinted version.\nThe examples below are not exhaustive; the design and layout chosen for the package leaflet should\ndrive the display of the details. Linguistic adjustments may also be necessary depending on the\ngrammatical rules of the languages used.\n\u2022 In case the details of the national reporting system are short, e.g. website only, you may wish to\nintegrate the details within the text as per the example below:\n\u201CIf you get any side effects, talk to your <doctor> <or> <,> <pharmacist> <or nurse>. This includes\nany possible side effects not listed in this leaflet. You can also report side effects directly via\nwww.xxx.xx.xx. By reporting side effects, you can help provide more information on the safety of this\nmedicine.\u201D\n\u2022 In case the details of the national reporting system are long, e.g. website + alternative reporting\ndetails and/or leaflet addressed to more than one Member States, you may wish to follow the\nexample below:\n\u201CIf you get any side effects, talk to your <doctor> <or> <,> <pharmacist> <or nurse>. This includes\nany possible side effects not listed in this leaflet. You can also report side effects directly (see details\nbelow). By reporting side effects, you can help provide more information on the safety of this\nmedicine.\nIreland\n{Name}\n<{Address}\nIRL - {Town} {Code for Dublin}>\nTel: + {Telephone number}\n<website>\n<{e-mail}>\nMalta\n{Isem}\n<{Indirizz}\nMT-0000 {Belt/Ra\u0127al}>\nTel: + {Numru tat-telefon}\n<website>\n<{e-mail}> ]\n5. How to store X\nKeep this medicine out of the sight and reach of children.\n[Expiry date]\n[Where a specific abbreviation for expiry date is used on the labelling, it should be mentioned here.]\nDo not use this medicine after the expiry date which is stated on the <label> <carton> <bottle> <...>\n<after {abbreviation used for expiry date}.> <The expiry date refers to the last day of that month.>\n\n34\n[Storage conditions]\n[Information should be in accordance with section 6.4 of the SmPC; for storage condition statements,\nsee Appendix III.]\n[Where applicable, shelf life after reconstitution, dilution or after first opening the container]\n[Information should be in accordance with section 6.3 of the SmPC; please also refer to \u201CNote for\nGuidance on Maximum Shelf Life for Sterile Products for Human Use after First Opening or\nFollowing Reconstitution\u201D (CPMP/QWP/159/96/corr).]\n[Where appropriate, warnings against certain visible signs of deterioration]\n<Do not use this medicine if you notice {description of the visible signs of deterioration}.>\n<Do not throw away any medicines via wastewater <or household waste>. Ask your pharmacist how\nto throw away medicines you no longer use. These measures will help protect the environment.>\n6. Contents of the pack and other information\n[Full statement of the active substance(s) and excipient(s)]\nWhat X contains\n[The active substance(s) (expressed qualitatively and quantitatively) and the other ingredients\n(expressed qualitatively) should be identified using their names as given in sections 2 and 6.1 of the\nSmPC and in the language of the text.]\n- The active substance(s) is (are)\u2026 [e.g. \u201CEach <tablet> <capsule> contains x <gram>\n<milligram>\u2026{active substance}\u201D.]\n- The other <ingredient(s)> <(excipient(s))> is (are)... [A cross-reference to section 2 \u201CX contains\n{name the excipients}\u201D should be included when applicable.]\n[Pharmaceutical form, nature and contents of container in weight, volume or units of dose]\nWhat X looks like and contents of the pack\n[The pharmaceutical form should be stated according to the full \u201CStandard Terms\u201D published by the\nCouncil of Europe and an additional patient-friendly explanation may be given if necessary. Where the\nCouncil of Europe patient-friendly term is used on small immediate packaging materials, the patient\nfriendly-term should be added in brackets.\nIt is recommended to include a physical description, e.g. shape, colour, texture, imprint, etc as per\nsection 3 of the SmPC.]\n[All pack sizes for this pharmaceutical form and strength should be detailed here as per section 6.5 of\nthe SmPC, including a reference to any ancillary items included in the pack such as needles, swabs,\netc. For multipacks, clearly indicate the pack content, e.g. \u201CX is available in packs containing Y, Z or\nW tablets and in multipacks comprising N cartons, each containing M tablets\u201D.\nIf appropriate indicate that not all pack sizes may be marketed. A cross-reference to other\npharmaceutical forms and strengths may be included.]\n[Name and address of the MAH and of the manufacturer responsible for batch release, if different]\nMarketing Authorisation Holder and Manufacturer\n{Name and address}\n<{tel}>\n<{fax}>\n<{e-mail}>\n[State the name and address of the MAH as per section 7 of the SmPC and identify as such, e.g.\n\u201CMarketing Authorisation Holder: ABC Ltd, etc.\u201D (Full address: name of the country to be stated in\nthe language of the text. Telephone, fax numbers or e-mail addresses may be included (no websites, no\ne-mails linking to websites).]\n\n35\n[State the name and address of the manufacturer responsible for batch release and identify as such, e.g.\n\u201CManufacturer: DEF Ltd, etc.\u201D (Full address: name of the country to be stated in the language of the\ntext. Telephone or fax numbers, e-mail addresses or websites are not allowed).]\n[If MAH and manufacturer are the same, the general heading \u201CMarketing Authorisation Holder and\nManufacturer\u201D can be used.]\n[In cases where more than 1 manufacturer responsible for batch release is designated, all should be\nlisted here (with or without grey-shading, depending on the option chosen for the printed package\nleaflet). However, the printed package leaflet of the medicinal product must clearly identify the\nmanufacturer responsible for the release of the concerned batch or mention only the specific\nmanufacturer responsible for the release of that batch.]\n[List of local representatives, where applicable.\n- Listing of local representatives is not a requirement, but if included in the product information\nannexes, the full list for all Member States must be stated. However, a representative may be\ndesignated for more than one country and may also be the MAH where no other local\nrepresentative is indicated. In cases where the same representative is designated for more than\none country, the representative\u2019s details may be listed only once below the names of the\ncountries concerned.\n- In the printed package leaflet, only the concerned local representative can be mentioned\nprovided the whole list has been included in the product information annexes.\n- Where a local representative is located outside the country concerned and where an address is\ngiven, the country name must be included in the address of the local representative and must be\ngiven in the language(s) of the country(ies) for which the local representative is designated.\n- ISO country codes* may be used to replace the full name of the country heading. ISO codes\ntogether with the respective names of EU/EEA countries can be found at the following web site:\nhttp://publications.europa.eu/code/en/en-370100.htm\n- In order to save space in the printed package leaflet, local representatives may be presented\nsequentially rather than in a tabulated format. In case of multi-lingual leaflets, the list of local\nrepresentatives can be printed only once at the end of the printed leaflet.\n- The local representative may be indicated by name, telephone number and electronic e-mail\naddress (optional) only. Postal address may be added space permitting. Website addresses or\ne-mails linking to websites are not allowed.\n- If a representative is outside the relevant country, indicate the name of the country.\n- For Belgium (Brussels) and Finland (Swedish speaking Finland) addresses may appear in two\nlanguages, respectively Dutch/French and Finnish/Swedish.\n- For Greece and Cyprus, the address must appear in Greek.\nTelephone numbers: international dialling code followed by the area code and telephone number, e.g.\nEuropean Medicines Agency Tel: + 31 (0)88 781 6000.]\n*[except for the United Kingdom, for which UK is recommended (instead of the ISO code GB).]\n<For any information about this medicine, please contact the local representative of the Marketing\nAuthorisation Holder:\nBelgi\xeb/Belgique/Belgien\n{Nom/Naam/Name}\n<{Adresse/Adres/Anschrift }\nB-0000 {Localit\xe9/Stad/Stadt}>\nT\xe9l/Tel: + {N\xb0 de t\xe9l\xe9phone/Telefoonnummer/\nTelefonnummer}\n<{e-mail}>\nLietuva\n{pavadinimas}\n<{adresas}\nLT {pa\u0161to indeksas} {miestas}>\nTel: + {telefono numeris}\n<{e-mail}>\n\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F\n{\u0418\u043C\u0435}\n<{\u0410\u0434\u0440\u0435\u0441}\nLuxembourg/Luxemburg\n{Nom}\n<{Adresse}\n\n36\n{\u0413\u0440\u0430\u0434} {\u041F\u043E\u0449\u0435\u043D\u0441\u043A\u0438 \u043A\u043E\u0434}>\nTe\u043B.: + {\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440}\n<{e-mail}>\nL-0000 {Localit\xe9/Stadt}>\nT\xe9l/Tel: + {N\xb0 de t\xe9l\xe9phone/Telefonnummer}\n<{e-mail}>\n\u010Cesk\xe1 republika\n{N\xe1zev}\n<{Adresa}\nCZ {m\u011Bsto}>\nTel: +{telefonn\xed \u010D\xedslo}\n<{e-mail}>\nMagyarorsz\xe1g\n{N\xe9v}\n<{C\xedm}\nH-0000 {V\xe1ros}>\nTel.: + {Telefonsz\xe1m}\n<{e-mail}>\nDanmark\n{Navn}\n<{Adresse}\nDK-0000 {by}>\nTlf.: + {Telefonnummer}\n<{e-mail}>\nMalta\n{Isem}\n<{Indirizz}\nMT-0000 {Belt/Ra\u0127al}>\nTel: + {Numru tat-telefon}\n<{e-mail}>\nDeutschland\n{Name}\n<{Anschrift}\nD-00000 {Stadt}>\nTel: + {Telefonnummer}\n<{e-mail}>\nNederland\n{Naam}\n<{Adres}\nNL-0000 XX {stad}>\nTel: + {Telefoonnummer}\n<{e-mail}>\nEesti\n{Nimi}\n<{Aadress}\nEE - {Postiindeks} {Linn}>\nTel: + {Telefoninumber}\n<{e-mail}>\nNorge\n{Navn}\n<{Adresse}\nN-0000 {poststed}>\nTlf: + {Telefonnummer}\n<{e-mail}>\n\u0395\u03BB\u03BB\u03AC\u03B4\u03B1\n{\u038C\u03BD\u03BF\u03BC\u03B1}\n<{\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7}\nGR-000 00 {\u03C0\u03CC\u03BB\u03B7}>\n\u03A4\u03B7\u03BB: + {\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5}\n<{e-mail}>\n\xd6sterreich\n{Name}\n<{Anschrift}\nA-0000 {Stadt}>\nTel: + {Telefonnummer}\n<{e-mail}>\nEspa\xf1a\n{Nombre}\n<{Direcci\xf3n}\nE-00000 {Ciudad}>\nTel: + {Tel\xe9fono}\n<{e-mail}>\nPolska\n{Nazwa/ Nazwisko:}\n<{Adres:}\nPL \u2013 00 000{Miasto:}>\nTel.: + {Numer telefonu:}\n<{e-mail}>\nFrance\n{Nom}\n<{Adresse}\nF-00000 {Localit\xe9}>\nT\xe9l: + {Num\xe9ro de t\xe9l\xe9phone}\n<{e-mail}>\nPortugal\n{Nome}\n<{Morada}\nP-0000\u2212000 {Cidade}>\nTel: + {N\xfamero de telefone}\n<{e-mail}>\nHrvatska\n{Ime}\n<{Adresa}\n{Po\u0161tanski broj} {grad}>\nRom\xe2nia\n{Nume}\n<{Adres\u0103}\n{Ora\u015F} {Cod po\u015Ftal} \u2013 RO>\n\n37\nTel: + {Telefonski broj}\n<{e-mail}>\nIreland\n{Name}\n<{Address}\nIRL - {Town} {Code for Dublin}>\nTel: + {Telephone number}\n<{e-mail}>\nTel: + {Num\u0103r de telefon}\n<{e-mail}>\nSlovenija\n{Ime}\n<{Naslov}\nSI-0000 {Mesto}>\nTel: + {telefonska \u0161tevilka}\n<{e-mail}>\n\xcdsland\n{Nafn}\n<{Heimilisfang}\nIS-000 {Borg/B\xe6r}>\nS\xedmi: + {S\xedman\xfamer}\n<{Netfang }>\nSlovensk\xe1 republika\n{N\xe1zov}\n<{Adresa}\nSK-000 00 {Mesto}>\nTel: + {Telef\xf3nne \u010D\xedslo}\n<{e-mail}>\nItalia\n{Nome}\n<{Indirizzo}\nI-00000 {Localit\xe0}>\nTel: + {Numero di telefono}\n<{e-mail}>\nSuomi/Finland\n{Nimi/Namn}\n<{Osoite/Adress}\nFIN-00000 {Postitoimipaikka/Stad}>\nPuh/Tel: + {Puhelinnumero/Telefonnummer}\n<{e-mail}>\n\u039A\u03CD\u03C0\u03C1\u03BF\u03C2\n{\u038C\u03BD\u03BF\u03BC\u03B1}\n<{\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7}\nCY-000 00 {\u03C0\u03CC\u03BB\u03B7}>\n\u03A4\u03B7\u03BB: + {\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5}\n<{e-mail}>\nSverige\n{Namn}\n<{Adress}\nS-000 00 {Stad}>\nTel: + {Telefonnummer}\n<{e-mail}>\nLatvija\n{Nosaukums}\n<{Adrese}\n{Pils\u0113ta}, LV{pasta indekss }>\nTel: + {telefona numurs}\n<{e-mail}>\nThis leaflet was last revised in <{MM/YYYY}><{month YYYY}>.\n[Date of granting of the marketing authorisation/approval of latest variation or transfer (as per section\n9 or 10 of the SmPC), e.g. the latest Commission Decision or the latest favourable CHMP opinion, as\napplicable, implementation date of the Urgent Safety Restriction or date of European Medicines\nAgency letter/notification. Item to be completed by the MAH at time of printing. If the regulatory\nprocedure does not affect the leaflet, this date does not need to be changed.]\n[For medicines approved under \u201Cconditional approval\u201D, include the following statement:]\n<This medicine has been given \u2018conditional approval\u2019.\nThis means that there is more evidence to come about this medicine.\nThe European Medicines Agency will review new information on this medicine at least every year and\nthis leaflet will be updated as necessary.>\n[For medicines approved under \u201Cexceptional circumstances\u201D, include the following statement:]\n<This medicine has been authorised under \u2018exceptional circumstances\u2019.\nThis means that <because of the rarity of this disease> <for scientific reasons> <for ethical reasons> it\nhas been impossible to get complete information on this medicine.\n\n38\nThe European Medicines Agency will review any new information on this medicine every year and\nthis leaflet will be updated as necessary.>\n[For generic medicines, if the reference medicinal product was approved under \u201Cexceptional\ncircumstances\u201D, include the following statement:]\n<X contains the same active substance and works in the same way as a \u2018reference medicine\u2019 already\nauthorised in the EU. The reference medicine for X has been authorised under \u2018exceptional\ncircumstances\u2019. This means that <because of the rarity of this disease><due to scientific reasons>\n<due to ethical reasons> it has been impossible to get complete information on the reference medicine.\nThe European Medicines Agency will review any new information on the reference medicine every\nyear and any updates for the reference medicine will also be included as appropriate in the information\nfor X, such as this leaflet.>\n<Other sources of information>\n[This section should include references to other sources of information which will be useful for the\npatient. Such sources of information must be compatible with the SmPC and non-promotional:\n- Details of how patients can access the information in alternative formats such as Braille, audio,\ncd-rom or large print. Normally, this should appear in a large font to ensure visually impaired patients\nare aware of the service.\n- Reference to the European Medicines Agency website:\nDetailed information on this medicine is available on the European Medicines Agency web site:\nhttps://www.ema.europa.eu<, and on the website of {name of Member State Agency (link)}>.*\n<There are also links to other websites about rare diseases and treatments.> [the last part of the\nstatement is applicable to orphan medicines only.]\n[*This statement is optional, and it is only to be displayed on the final printed materials. It will not\nbe included in the product information annexes as applicants may choose to include it for one or more\nMember States but not for all of them.]\n[For medicines having been granted an exemption of having English only package leaflet according to\nArt 63 of Directive 2001/83/EC, the following statement translated in all EU/EEA languages should be\nincluded here:\n<This leaflet is available in all EU/EEA languages on the European Medicines Agency website.>\nthis information should appear prominently in the printed material.]\n<------------------------------------------------------------------------------------------------------------------------>\n[For parenteral products, other medicines which are mainly used in hospitals or in the exceptional cases\nof extemporaneous preparations (where a medicine is indicated in children and where no adequate\npaediatric formulation can be developed (based on duly justified scientific grounds)), practical\ninformation relevant for healthcare professionals, such as on preparation and/or handling,\nincompatibilities, posology of the medicine, overdose or monitoring measures and laboratory\ninvestigations can be included in this section, WHERE RELEVANT, and a cross-reference to section 3\nshould be included. In such a case, start the section with:\n<The following information is intended for healthcare professionals only:>]\n[If other additional scientific information is to be included in the package for the healthcare\nprofessional, this can be achieved by either:\n\u2022 providing the complete SmPC as a separate document in the medicine pack, or\n\u2022 adding the complete SmPC as a tear-off section at the end of the printed package leaflet,\nso that the information for the patient (i.e. the package leaflet) and the information for the healthcare\nprofessional (i.e. the SmPC) are clearly differentiated.\nThe intention to include the complete SmPC and the way in which this will be achieved must be\njustified by the applicant and indicated at the end of Annex IIIB without actually repeating the\ncomplete latest SmPC text.\n\n39\nApplicants should carefully consider whether including such scientific information in the pack is\nappropriate, taking into account the nature of the medicine. The product information must be presented\nin an identical way in all EU/EEA languages.]";
const $81b98fb9de868a7b$export$4611ade21167fdc2 = `Module 2.2\nIntroduction\nThe general introduction to the medicinal product should include its pharmacological class,\nmode of action and the proposed clinical use. In general the introduction should not exceed one\npage.`;
const $81b98fb9de868a7b$export$35dd9876801626d0 = `Module 2.3
Quality Overall Summary
The Quality Overall Summary (QOS) is a summary that follows the scope and the outline of the
Body of Data in Module 3. The QOS should not include information, data or justification that
was not already included in Module 3 or in other parts of the CTD.
The QOS should include sufficient information from each section to provide the Quality
reviewer with an overview of Module 3. The QOS should also emphasise critical key parameters
of the product and provide, for instance, justification in cases where guidelines were not
followed. The QOS should include a discussion of key issues that integrates information from
sections in the Quality Module and supporting information from other Modules (e.g.
qualification of impurities via toxicological studies discussed under the CTD-S module),
including cross-referencing to volume and page number in other Modules.
This QOS normally should not exceed 40 pages of text, excluding tables and figures. For biotech
products and products manufactured using more complex processes, the document could be
longer but normally should not exceed 80 pages of text (excluding tables and figures).
The italicised text below indicates where tables, figures, or other items can be imported directly
from Module 3.
INTRODUCTION
The introduction should include proprietary name, non-proprietary name, European
Pharmacopoeia name or common name of the drug substance, company name, dosage form(s),
strength(s), route of administration according to the current version of the Standard Terms of the
European Pharmacopoeia and proposed indication(s)
2.3.S DRUG SUBSTANCE (NAME, MANUFACTURER)
2.3.S.1 General Information (name, manufacturer)
Information from 3.2.S.1 should be included.
2.3.S.2 Manufacture (name, manufacturer)
Information from 3.2.S.2 should be included:
\u{2022} Information on the manufacturer;
\u{2022} A brief description of the manufacturing process (including, for example, reference to
starting materials, critical steps, and reprocessing) and the controls that are intended to
result in the routine and consistent production of material(s) of appropriate quality;
\u{2022} A flow diagram, as provided in 3.2.S.2.2;
\u{2022} A description of the Source and Starting Material and raw materials of biological origin
used in the manufacture of the drug substance, as described in 3.2.S.2.3;
\u{2022} A discussion of the selection and justification of critical manufacturing steps, process
controls, and acceptance criteria. Highlight critical process intermediates, as described in
3.2.S.2.4;
\u{2022} A description of process validation and/or evaluation, as described in 3.2.S.2.5.
\u{2022} A brief summary of major manufacturing changes made throughout development and
conclusions from the assessment used to evaluate product consistency, as described in
3.2.S.2.6. The QOS should also cross-refer to the non-clinical and clinical studies that
used batches affected by these manufacturing changes, as provided in the CTD-S and
CTD-E modules of the dossier.
2.3.S.3 Characterisation (name, manufacturer)
For NCE:
A summary of the interpretation of evidence of structure and isomerism, as described in
3.2.S.3.1, should be included.
When a drug substance is chiral, it should be specified whether specific stereoisomers or a
mixture of stereoisomers have been used in the nonclinical and clinical studies, and
information should be given as to the stereoisomer of the drug substance that is to be used in
the final product intended for marketing.
For Biotech:
A description of the desired product and product-related substances and a summary of
general properties, characteristic features and characterisation data (for example, primary
and higher order structure and biological activity), as described in 3.2.S.3.1, should be
included.
For NCE and Biotech:
The QOS should summarise the data on potential and actual impurities arising from the
synthesis, manufacture and/or degradation, and should summarise the basis for setting the
acceptance criteria for individual and total impurities. The QOS should also summarise the
impurity levels in batches of the drug substance used in the non-clinical studies, in the
clinical trials, and in typical batches manufactured by the proposed commercial process. The
QOS should state how the proposed impurity limits are qualified.
A tabulated summary of the data provided in 3.2.S.3.2, with graphical representation, where
appropriate should be included.
2.3.S.4 Control of Drug Substance (name, manufacturer)
A brief summary of the justification of the specification(s), the analytical procedures, and
validation should be included.
Specification from 3.2.S.4.1 should be provided.
A tabulated summary of the batch analyses from 3.2.S.4.4, with graphical representation where
appropriate, should be provided.
2.3.S.5 Reference Standards or Materials (name, manufacturer)
Information from 3.2.S.5 (tabulated presentation, where appropriate) should be included.
2.3.S.6 Container Closure System (name, manufacturer)
A brief description and discussion of the information, from 3.2.S.6 should be included.
2.3.S.7 Stability (name, manufacturer)
This section should include a summary of the studies undertaken (conditions, batches, analytical
procedures) and a brief discussion of the results and conclusions, the proposed storage
conditions, retest date or shelf-life, where relevant, as described in 3.2.S.7.1.
The post-approval stability protocol, as described in 3.2.S.7.2, should be included.
A tabulated summary of the stability results from 3.2.S.7.3, with graphical representation where
appropriate, should be provided.
2.3.P DRUG PRODUCT (NAME, DOSAGE FORM)
2.3.P.1 Description and Composition of the Drug Product (name, dosage form)
Information from 3.2.P.1 should be provided.
Composition from 3.2.P.1 should be provided.
2.3.P.2 Pharmaceutical Development (name, dosage form)
A discussion of the information and data from 3.2.P.2 should be presented.
A tabulated summary of the composition of the formulations used in clinical trials and a
presentation of dissolution profiles should be provided, where relevant.
2.3.P.3 Manufacture (name, dosage form)
Information from 3.2.P.3 should include:
\u{2022} Information on the manufacturer.
\u{2022} A brief description of the manufacturing process and the controls that are intended to
result in the routine and consistent production of product of appropriate quality.
\u{2022} A flow diagram, as provided under 3.2.P.3.3.
\u{2022} A brief description of the process validation and/or evaluation, as described in 3.2.P.3.5.
2.3.P.4 Control of Excipients (name, dosage form)
A brief summary on the quality of excipients, as described in 3.2.P.4, should be included.
2.3.P.5 Control of Drug Product (name, dosage form)
A brief summary of the justification of the specification(s), a summary of the analytical
procedures and validation, and characterisation of impurities should be provided.
Specification(s) from 3.2.P.5.1 should be provided.
A tabulated summary of the batch analyses provided under 3.2.P.5.4, with graphical
representation where appropriate should be included.
2.3.P.6 Reference Standards or Materials (name, dosage form)
Information from 3.2.P.6 (tabulated presentation, where appropriate) should be included.
2.3.P.7 Container Closure System (name, dosage form)
A brief description and discussion of the information in 3.2.P.7 should be included.
2.3.P.8 Stability (name, dosage form)
A summary of the studies undertaken (conditions, batches, analytical procedures) and a brief
discussion of the results and conclusions of the stability studies and analysis of data should be
included. Conclusions with respect to storage conditions and shelf-life and, if applicable, in-use
storage conditions and shelf-life should be given.
A tabulated summary of the stability results from 3.2.P.8.3, with graphical representation where
appropriate, should be included.
The post-approval stability protocol, as described in 3.2.P.8.2, should be provided.
2.3.A APPENDICES
2.3.A.1 Facilities and Equipment (name, manufacturer)
Biotech:
A summary of facility information described under 3.2.A.1 should be included.
2.3.A.2 Adventitious Agents Safety Evaluation (name, dosage form, manufacturer)
A discussion on measures implemented to control endogenous and adventitious agents in
production should be included.
A tabulated summary of the reduction factors for viral clearance from 3.2.A.2, should be
provided.
2.3.A.3 Excipients
2.3.R REGIONAL INFORMATION
A brief description of the information specific for the region, as provided under \u{201C}3.2.R\u{201D} should
be included, where appropriate.`;
const $81b98fb9de868a7b$export$bfcc4869675020e7 = `Module 2.4
Nonclinical Overview
NONCLINICAL OVERVIEW
The Nonclinical Overview should provide an integrated overall analysis of the information in the
Common Technical Document. In general, the Nonclinical Overview should not exceed about
30 pages.
General Aspects
The Nonclinical Overview should present an integrated and critical assessment of the
pharmacologic, pharmacokinetic, and toxicologic evaluation of the pharmaceutical. Where
relevant guidelines on the conduct of studies exist, these should be taken into consideration, and
any deviation from these guidelines should be discussed and justified. The nonclinical testing
strategy should be discussed and justified. There should be comment on the GLP status of the
studies submitted. Any association between nonclinical findings and the quality characteristics
of the human pharmaceutical, the results of clinical trials, or effects seen with related products
should be indicated, as appropriate.
Except for biotechnology-derived products, an assessment of the impurities and degradants
present in the drug substance and product should be included along with what is known of their
potential pharmacologic and toxicologic effects. This assessment should form part of the
justification for proposed impurity limits in the drug substance and product, and be appropriately
cross-referenced to the quality documentation. The implications of any differences in the
chirality, chemical form, and impurity profile between the compound used in the nonclinical
studies and the product to be marketed should be discussed. For biotechnology-derived
products, comparability of material used in nonclinical studies, clinical studies, and proposed for
marketing should be assessed. If a drug product includes a novel excipient, an assessment of the
information regarding its safety should be provided.
Relevant scientific literature and the properties of related products should be taken into account.
If detailed references to published scientific literature are to be used in place of studies
conducted by the applicant, this should be supported by an appropriate justification that reviews
the design of the studies and any deviations from available guidelines. In addition, the
availability of information on the quality of batches of drug substance used in these referenced
studies should be discussed.
The Nonclinical Overview should contain appropriate reference citations to the Tabulated
Summaries, in the following format: (Table X.X, Study/Report Number).
Content and Structural Format
The Nonclinical Overview should be presented in the following sequence:
Overview of the nonclinical testing strategy
Pharmacology
Pharmacokinetics
Toxicology
Integrated overview and conclusions
List of literature references
Studies conducted to establish the pharmacodynamic effects, the mode of action, and potential
side effects should be evaluated and consideration should be given to the significance of any
issues that arise.
The assessment of the pharmacokinetic, toxicokinetic, and metabolism data should address the
relevance of the analytical methods used, the pharmacokinetic models, and the derived
parameters. It might be appropriate to cross-refer to more detailed consideration of certain
issues within the pharmacology or toxicology studies (e.g. impact of the disease states, changes
in physiology, anti-product antibodies, cross-species consideration of toxicokinetic data).
Inconsistencies in the data should be discussed. Inter-species comparisons of metabolism and
systemic exposure comparisons in animals and humans (AUC, Cmax, and other appropriate
parameters) should be discussed and the limitations and utility of the nonclinical studies for
prediction of potential adverse effects in humans highlighted.
The onset, severity, and duration of the toxic effects, their dose-dependency and degree of
reversibility (or irreversibility), and species- or gender-related differences should be evaluated
and important features discussed, particularly with regard to:
\u{2022} pharmacodynamics
\u{2022} toxic signs
\u{2022} causes of death
\u{2022} pathologic findings
\u{2022} genotoxic activity - the chemical structure of the compound, its mode of action, and its
relationship to known genotoxic compounds
\u{2022} carcinogenic potential in the context of the chemical structure of the compound, its
relationship to known carcinogens, its genotoxic potential, and the exposure data
\u{2022} the carcinogenic risk to humans - if epidemiologic data are available, they should be
taken into account
\u{2022} fertility, embryofetal development, pre-and post-natal toxicity
\u{2022} studies in juvenile animals
\u{2022} the consequences of use before and during pregnancy, during lactation, and during
pediatric development
\u{2022} local tolerance
\u{2022} other toxicity studies/ studies to clarify special problems
The evaluation of toxicology studies should be arranged in a logical order so that all relevant
data elucidating a certain effect / phenomenon are brought together. Extrapolation of the data
from animals to humans should be considered in relation to:
\u{2022} animal species used
\u{2022} numbers of animals used
\u{2022} routes of administration employed
\u{2022} dosages used
\u{2022} duration of treatment or of the study
\u{2022} systemic exposures in the toxicology species at no observed adverse effect levels and at
toxic doses, in relation to the exposures in humans at the maximum recommended human
dose. Tables or figures summarising this information are recommended.
\u{2022} the effect of the drug substance observed in nonclinical studies in relation to that expected
or observed in humans
If alternatives to whole-animal experiments are employed, their scientific validity should be
discussed.
The Integrated Overview and Conclusions should clearly define the characteristics of the human
pharmaceutical as demonstrated by the nonclinical studies and arrive at logical, well-argued
conclusions supporting the safety of the product for the intended clinical use. Taking the
pharmacology, pharmacokinetics, and toxicology results into account, the implications of the
nonclinical findings for the safe human use of the pharmaceutical should be discussed (i.e., as
applicable to labeling).
`;
const $81b98fb9de868a7b$export$5279f1f2897ad22f = `Module 2.5
Clinical Overview
Preamble
The Clinical Overview is intended to provide a critical analysis of the clinical data in the
Common Technical Document. The Clinical Overview will necessarily refer to application data
provided in the comprehensive Clinical Summary, the individual clinical study reports (ICH E3),
and other relevant reports; but it should primarily present the conclusions and implications of
those data, and should not recapitulate them. Specifically, the Clinical Summary should provide
a detailed factual summarisation of the clinical information in the CTD, and the Clinical
Overview should provide a succinct discussion and interpretation of these findings together with
any other relevant information (e.g., pertinent animal data or product quality issues that may
have clinical implications).
The Clinical Overview is primarily intended for use by regulatory agencies in the review of the
clinical section of a marketing application. It should also be a useful reference to the overall
clinical findings for regulatory agency staff involved in the review of other sections of the
marketing application. The Clinical Overview should present the strengths and limitations of the
development program and study results, analyse the benefits and risks of the medicinal product
in its intended use, and describe how the study results support critical parts of the prescribing
information.
In order to achieve these objectives the Clinical Overview should:
\u{2022} describe and explain the overall approach to the clinical development of a medicinal
product, including critical study design decisions;
\u{2022} assess the quality of the design and performance of the studies, and include a statement
regarding GCP compliance;
\u{2022} provide a brief overview of the clinical findings, including important limitations (e.g.,
lack of comparisons with an especially relevant active comparator, or absence of
information on some patient populations, ; pertinent endpoints, or on use in combination
therapy).
\u{2022} provide an evaluation of benefits and risks based upon the conclusions of the relevant
clinical studies, including interpretation of how the efficacy and safety findings support
the proposed dose and target indication and an evaluation of how prescribing information
and other approaches will optimise benefits and manage risks;
\u{2022} address particular efficacy or safety issues encountered in development, and how they
have been evaluated and resolved;
\u{2022} explore unresolved issues, explain why they should not be considered as barriers to
approval, and describe plans to resolve them;
\u{2022} explain the basis for important or unusual aspects of the prescribing information.
The Clinical Overview should generally be a relatively short document (about 30 pages). The
length, however, will depend on the complexity of the application. The use of graphs and concise
tables in the body of the text is encouraged for brevity and to facilitate understanding. It is not
intended that material presented fully elsewhere be repeated in the Clinical Overview; cross-
referencing to more detailed presentations provided in the Clinical Summary or in Module 5 is
encouraged.
Table of Contents
2.5.1 Product Development Rationale
2.5.2 Overview of Biopharmaceutics
2.5.3 Overview of Clinical Pharmacology
2.5.4 Overview of Efficacy
2.5.5 Overview of Safety
2.5.6 Benefits and Risks Conclusions
2.5.7 Literature References
Detailed Discussion of Content of the Clinical Overview Sections
2.5.1 Product Development Rationale
The discussion of the rationale for the development of the medicinal product should:
\u{2022} identify the pharmacological class of the medicinal product.
\u{2022} describe the particular clinical/pathophysiological condition that the medicinal product is
intended to treat, prevent, or diagnose (the targeted indication).
\u{2022} briefly summarise the scientific background that supported the investigation of the
medicinal product for the indication(s) that was (were) studied.
\u{2022} briefly describe the clinical development programme of the medicinal product, including
ongoing and planned clinical studies and the basis for the decision to submit the
application at this point in the programme. Briefly describe plans for the use of foreign
clinical data (ICH E5).
\u{2022} note and explain concordance or lack of concordance with current standard research
approaches regarding the design, conduct and analysis of the studies. Pertinent published
literature should be referenced. Regulatory guidance and advice (at least from the
region(s) where the Clinical Overview is being submitted) should be identified, with
discussion of how that advice was implemented. Formal advice documents (e.g., official
meeting minutes, official guidance, letters from regulatory authorities) should be
referenced, with copies included in the references section of Module 5.
2.5.2 Overview of Biopharmaceutics
The purpose of this section is to present a critical analysis of any important issues related to
bioavailability that might affect efficacy and/or safety of the to-be-marketed formulation(s) (e.g.,
dosage form/strength proportionality, differences between the to-be-marketed formulation and
the formulation(s) used in clinical trials, and influence of food on exposure).
2.5.3 Overview of Clinical Pharmacology
The purpose of this section is to present a critical analysis of the pharmacokinetic (PK),
pharmacodynamic (PD), and related in vitro data in the CTD. The analysis should consider all
relevant data and explain why and how the data support the conclusions drawn. It should
emphasise unusual results and known or potential problems, or note the lack thereof. This section
should address:
\u{2022} pharmacokinetics, e.g., comparative PK in healthy subjects, patients, and special
populations; PK related to intrinsic factors (e.g., age, sex, race, renal and hepatic
impairment) and to extrinsic factors (e.g., smoking, concomitant drugs, diet); rate and
extent of absorption; distribution, including binding with plasma proteins; specific
metabolic pathways, including effects of possible genetic polymorphism and the
formation of active and inactive metabolites; excretion; time-dependent changes in
pharmacokinetics; stereochemistry issues; clinically relevant PK interactions with other
medicinal products or other substances.
\u{2022} pharmacodynamics, e.g., information on mechanism of action, such as receptor binding;
onset and/or offset of action; relationship of favorable and unfavorable pharmacodynamic
effects to dose or plasma concentration (i.e., PK/PD relationships); PD support for the
proposed dose and dosing interval; clinically relevant PD interactions with other
medicinal products or substances; and possible genetic differences in response.
\u{2022} interpretation of the results and implications of immunogenicity studies, clinical
microbiology studies, or other drug class specific PD studies summarised in section
2.7.2.4 of the Clinical Summary.
2.5.4 Overview of Efficacy
The purpose of this section is to present a critical analysis of the clinical data pertinent to the
efficacy of the medicinal product in the intended population. The analysis should consider all
relevant data, whether positive or negative, and should explain why and how the data support the
proposed indication and prescribing information. Those studies deemed relevant for evaluation
of efficacy should be identified, and reasons that any apparently adequate and well-controlled
studies are not considered relevant should be provided. Prematurely terminated studies should be
noted and their impact considered.
The following issues should generally be considered:
\u{2022} relevant features of the patient populations, including demographic features, disease
stage, any other potentially important covariates, any important patient populations
excluded from critical studies, and participation of children and elderly (ICH E11 and
E7). Differences between the studied population(s) and the population that would be
expected to receive the medicinal product after marketing should be discussed.
\u{2022} implications of the study design(s), including selection of patients, duration of studies and
choice of endpoints and control group(s). Particular attention should be given to
endpoints for which there is limited experience. Use of surrogate endpoints should be
justified. Validation of any scales used should be discussed.
\u{2022} for non-inferiority trials used to demonstrate efficacy, the evidence supporting a
determination that the trial had assay sensitivity and justifying the choice of non-
inferiority margin (ICH E10).
\u{2022} statistical methods and any issues that could affect the interpretation of the study results
(e.g., important modifications to the study design, including endpoint assessments and
planned analyses, as they were specified in the original protocol; support for any
unplanned analyses; procedures for handling missing data; and corrections for multiple
endpoints).
\u{2022} similarities and differences in results among studies, or in different patient sub-groups
within studies, and their effect upon the interpretation of the efficacy data.
\u{2022} observed relationships between efficacy, dose, and dosage regimen for each indication, in
both the overall population and in the different patient subgroups (ICH E4).
\u{2022} support for the applicability to the new region of data generated in another region, where
appropriate (ICH E5).
\u{2022} for products intended for long-term use, efficacy findings pertinent to the maintenance of
long-term efficacy and the establishment of long-term dosage. Development of tolerance
should be considered.
\u{2022} data suggesting that treatment results can be improved through plasma concentration
monitoring, if any, and documentation for an optimal plasma concentration range.
\u{2022} the clinical relevance of the magnitude of the observed effects.
\u{2022} if surrogate endpoints are relied upon, the nature and magnitude of expected clinical
benefit and the basis for these expectations.
\u{2022} efficacy in special populations. If efficacy is claimed with inadequate clinical data in the
population, support should be provided for extrapolating efficacy from effects in the
general population.
2.5.5 Overview of Safety
The purpose of this section is to provide a concise critical analysis of the safety data, noting how
results support and justify proposed prescribing information. A critical analysis of safety should
consider:
\u{2022} adverse effects characteristic of the pharmacological class. Approaches taken to monitor
for similar effects should be described.
\u{2022} special approaches to monitoring for particular adverse events (e.g., ophthalmic, QT
interval prolongation).
\u{2022} relevant animal toxicology and product quality information. Findings that affect or could
affect the evaluation of safety in clinical use should be considered.
\u{2022} the nature of the patient population and the extent of exposure, both for test drug and
control treatments. Limitations of the safety database, e.g., related to inclusion/exclusion
criteria and study subject demographics, should be considered, and the implications of
such limitations with respect to predicting the safety of the product in the marketplace
should be explicitly discussed.
\u{2022} common and non-serious adverse events, with reference to the tabular presentations of
events with the test drug and with control agents in the Clinical Summary. The discussion
should be brief, focusing on events of relatively high frequency, those with an incidence
higher than placebo, and those that are known to occur in active controls or other
members of the therapeutic class. Events that are substantially more or less common or
problematic (considering the duration and degree of the observed events) with the test
drug than with active controls are of particular interest.
\u{2022} serious adverse events (relevant tabulations should be cross-referenced from the Clinical
Summary). This section should discuss the absolute number and frequency of serious
adverse events, including deaths, and other significant adverse events (e.g., events leading
to discontinuation or dose modification), and should discuss the results obtained for test
drug versus control treatments. Any conclusions regarding causal relationship (or lack of
this) to the product should be provided. Laboratory findings reflecting actual or possible
serious medical effects should be considered.
\u{2022} similarities and differences in results among studies, and their effect upon the
interpretation of the safety data.
\u{2022} any differences in rates of adverse events in population subgroups, such as those defined
by demographic factors, weight, concomitant illness, concomitant therapy, or
polymorphic metabolism.
\u{2022} relation of adverse events to dose, dose regimen, and treatment duration.
\u{2022} long-term safety (E1a).
\u{2022} methods to prevent, mitigate, or manage adverse events.
\u{2022} reactions due to overdose; the potential for dependence, rebound phenomena and abuse,
or lack of data on these issues.
\u{2022} world-wide marketing experience. The following should be briefly discussed:
- the extent of the world-wide experience,
- any new or different safety issues identified,
- any regulatory actions related to safety.
\u{2022} support for the applicability to the new region of data generated in another region, where
appropriate (ICH E5).
2.5.6 Benefits and Risks Conclusions
The purpose of this section is to integrate all of the conclusions reached in the previous sections
about the biopharmaceutics, clinical pharmacology, efficacy and safety of the medicinal product
and to provide an overall appraisal of the benefits and risks of its use in clinical practice. Also,
implications of any deviations from regulatory advice or guidelines and any important limitations
of the available data should be discussed here. This assessment should address critical aspects of
the proposed Prescribing Information. This section should also consider the risks and benefits of
the medicinal product as they compare to available alternative treatments or to no treatment in
illnesses where no treatment may be a medically acceptable option; and should clarify the
expected place of the medicinal product in the armamentarium of treatments for the proposed
indication. If there are risks to individuals other than those who will receive the drug, these risks
should be discussed (e.g., risks of emergence of drug-resistant bacterial strains with widespread
use of an antibiotic for minor illnesses). The analyses provided in previous sections should not be
reiterated here. This section often can be quite abbreviated when no special concerns have arisen
and the drug is a member of a familiar pharmacological class.
This analysis of benefits and risks is generally expected to be very brief but it should identify the
most important conclusions and issues concerning each of the following points:
\u{2022} the efficacy of the medicinal product for each proposed indication.
\u{2022} significant safety findings and any measures that may enhance safety.
\u{2022} dose-response and dose-toxicity relationships; optimal dose ranges and dosage regimens.
\u{2022} efficacy and safety in sub-populations, e.g., those defined by age, sex, ethnicity, organ
function, disease severity, and genetic polymorphisms.
\u{2022} data in children in different age groups, if applicable, and any plans for a development
programme in children.
\u{2022} any risks to the patient of known and potential interactions, including food-drug and
drug-drug interactions, and recommendations for product use.
\u{2022} any potential effect of the medicinal product that might affect ability to drive or operate
heavy machinery.
Examples of issues and concerns that could warrant a more detailed discussion of benefits and
risks might include:
\u{2022} the drug is for treatment of a non-fatal disease but has known or potential serious toxicity,
such as a strong signal of carcinogenicity, teratogenicity, pro-arrhythmic potential (effect
on QT interval), or suggestion of hepatotoxicity.
\u{2022} the proposed use is based on a surrogate endpoint and there is a well-documented
important toxicity.
\u{2022} safe and/or effective use of the drug requires potentially difficult selection or
management approaches that require special physician expertise or patient training.
2.5.7 Literature References
A list of references used, stated in accordance with the current edition of the Uniform
Requirements for Manuscripts Submitted to Biomedical Journals, International Committee of
Medical Journal Editors (ICMJE) 1 or the system used in \u{201C}Chemical Abstracts\u{201D}, should be
provided. Copies of all references cited in the Clinical Overview should be provided in Section
5.4 of Module 5.
1 The first edition of the Uniform Requirements for Manuscripts Submitted to Biomedical Journals was conceived
by the Vancouver Group and was published in 1979.
`;
const $81b98fb9de868a7b$export$fae0affe3eccb7a7 = `Module 2.6
Nonclinical Summary
NONCLINICAL WRITTEN AND TABULATED SUMMARIES
Guidance on Nonclinical Written Summaries
Introduction
This guidance is intended to assist authors in the preparation of nonclinical pharmacology,
pharmacokinetics, and toxicology written summaries in an acceptable format. This guidance is
not intended to indicate what studies are required. It merely indicates an appropriate format for
the nonclinical data that have been acquired.
The sequence and content of the Nonclinical Written Summary sections are described below. It
should be emphasised that no guideline can cover all eventualities, and common sense and a
clear focus on the needs of the regulatory authority assessor are the best guides to constructing an
acceptable document. Therefore, applicants can modify the format if needed to provide the best
possible presentation of the information, in order to facilitate the understanding and evaluation of
the results.
Whenever appropriate, age- and gender-related effects should be discussed. Relevant findings
with stereoisomers and/or metabolites should be included, as appropriate. Consistent use of units
throughout the Summaries will facilitate their review. A table for converting units might also be
useful.
In the Discussion and Conclusion sections, information should be integrated across studies and
across species, and exposure in the test animals should be related to exposure in humans given
the maximum intended doses.
General Presentation Issues
Order of Presentation of Information Within Sections
When available, in vitro studies should precede in vivo studies. Where multiple studies of the
same type need to be summarised within the Pharmacokinetics and Toxicology sections, studies
should be ordered by species, by route, and then by duration (shortest duration first).
Species should be ordered as follows:
\u{2022} Mouse
\u{2022} Rat
\u{2022} Hamster
\u{2022} Other rodent
\u{2022} Rabbit
\u{2022} Dog
\u{2022} Non-human primate
\u{2022} Other non-rodent mammal
\u{2022} Non-mammals
Routes of administration should be ordered as follows:
\u{2022} The intended route for human use
\u{2022} Oral
\u{2022} Intravenous
\u{2022} Intramuscular
\u{2022} Intraperitoneal
\u{2022} Subcutaneous
\u{2022} Inhalation
\u{2022} Topical
\u{2022} Other
Use of Tables and Figures
Although the Nonclinical Written Summaries are envisaged to be composed mainly of text, some
information contained within them might be more effectively and/or concisely communicated
through the use of appropriate tables or figures. Examples of formats that might be included in
the Written Summaries are shown in Appendix A.
To allow authors flexibility in defining the optimal structure for the Written Summaries, tables
and figures should preferably be included within the text. Alternatively, they could be grouped
together at the end of each of the Nonclinical Written Summaries.
Throughout the text, reference citations to the Tabulated Summaries should be included, in the
following format: (Table X.X, Study/Report Number).
Length of Nonclinical Written Summaries
Although there is no formal limit to the length of the Nonclinical Written Summaries, it is
recommended that the total length of the three Nonclinical Written Summaries in general not
exceed 100-150 pages.
Sequence of Written Summaries and Tabulated Summaries
The following order is recommended:
\u{2022} Introduction
\u{2022} Written Summary of Pharmacology
\u{2022} Tabulated Summary of Pharmacology
\u{2022} Written Summary of Pharmacokinetics
\u{2022} Tabulated Summary of Pharmacokinetcs
\u{2022} Written Summary of Toxicology
\u{2022} Tabulated Summary of Toxicology
Guidance on Nonclinical Tabulated Summaries
It is recommended that summary tables for the nonclinical information in the Common Technical
Document be provided in the format outlined in this guidance. Applicants can modify the format
if needed to provide the best possible presentation of the information and to facilitate the
understanding and evaluation of the results.
This guidance is not intended to indicate what studies are requested, but solely to advise how to
tabulate study results if a study is performed. Applicants might need to add some items to or
delete some items from the cited format where appropriate. One tabular format can contain
results from several studies. Alternatively, it may be appropriate to cite the data resulting from
one study in several tabular formats.
The recommended formats for the tables in the Nonclinical Tabulated Summaries are provided in
Appendices B and C, which follow. Appendix B contains templates for use in preparation of the
tables. The templates are annotated (in italics) to provide guidance on their preparation. (The
italicized information should be deleted when the tables are prepared.) Appendix C provides
examples of the summary tables. The purpose of the examples is to provide additional guidance
on the suggested content and format of the Tabulated Summaries. However, it is the
responsibility of the applicant to decide on the best possible presentation of the data for each
product. Authors should keep in mind that, in some regions, a review of the Tabulated
Summaries (in conjunction with the Written Summaries) represents the primary review of the
nonclinical information. Presentation of the data in the formats provided as templates and
examples should ensure that a sufficient level of detail is available to the reviewer and should
provide concise overviews of related information.
When a juvenile-animal study has been conducted, it should be tabulated using the template
appropriate for the type of study.
The order of presentation given for the Nonclinical Written Summaries should be followed for
the preparation of the tables for the Nonclinical Tabulated Summaries.
CONTENT OF NONCLINICAL WRITTEN AND TABULATED SUMMARIES
2.6.1 INTRODUCTION
The aim of this section should be to introduce the reviewer to the pharmaceutical and to its
proposed clinical use. The following key elements should be covered:
\u{2022} Brief information concerning the pharmaceutical\u{2019}s structure (preferably, a structure
diagram should be provided) and pharmacologic properties;
\u{2022} Information concerning the pharmaceutical\u{2019}s proposed clinical indication, dose, and
duration of use.
2.6.2 PHARMACOLOGY WRITTEN SUMMARY
Within the Pharmacology Written Summary, the data should be presented in the following
sequence:
\u{2022} Brief summary
\u{2022} Primary pharmacodynamics
\u{2022} Secondary pharmacodynamics
\u{2022} Safety pharmacology
\u{2022} Pharmacodynamic drug interactions
\u{2022} Discussion and conclusions
\u{2022} Tables and figures (either here or included in text)
2.6.2.1 Brief Summary
The principal findings from the pharmacology studies should be briefly summarized in
approximately 2 to 3 pages. This section should begin with a brief description of the content of
the pharmacologic data package, pointing out any notable aspects such as the inclusion/exclusion
of particular data (e.g., lack of an animal model).
2.6.2.2 Primary Pharmacodynamics
Studies on primary pharmacodynamics* should be summarised and evaluated. Where possible,
it would be helpful to relate the pharmacology of the drug to available data (in terms of
selectivity, safety, potency, etc.) on other drugs in the class.
2.6.2.3 Secondary Pharmacodynamics
Studies on secondary pharmacodynamics* should be summarised by organ system, where
appropriate, and* evaluated in this section.
2.6.2.4 Safety Pharmacology
Safety pharmacology studies* should be summarised and evaluated in this section. In some
cases, secondary pharmacodynamic studies can contribute to the safety evaluation when they
predict or assess potential adverse effect(s) in humans. In such cases, these secondary
pharmacodynamic studies should be considered along with safety pharmacology studies.
2.6.2.5 Pharmacodynamic Drug Interactions
If they have been performed, pharmacodynamic drug interaction studies should be briefly
summarised in this section.
* See ICH Guideline S7, Safety Pharmacology Studies for Human Pharmaceuticals, Note 2. p. 8, for definitions.
2.6.2.6 Discussion and Conclusions
This section provides an opportunity to discuss the pharmacologic evaluation and to consider the
significance of any issues that arise.
2.6.2.7 Tables and Figures
Text tables and figures can be included at appropriate points throughout the summary within the
text. Alternatively, tables and figures can be included at the end of the summary.
2.6.3 PHARMACOLOGY TABULATED SUMMARY (SEE APPENDIX B)
2.6.4 PHARMACOKINETICS WRITTEN SUMMARY
The sequence of the Pharmacokinetics Written Summary should be as follows:
\u{2022} Brief Summary
\u{2022} Methods of Analysis
\u{2022} Absorption
\u{2022} Distribution
\u{2022} Metabolism
\u{2022} Excretion
\u{2022} Pharmacokinetic Drug Interactions
\u{2022} Other Pharmacokinetic Studies
\u{2022} Discussion and Conclusions
\u{2022} Tables and Figures (either here or included in text)
2.6.4.1 Brief Summary
The principal findings from the pharmacokinetics studies should be briefly summarized in
approximately 2 to 3 pages. This section should begin with a description of the scope of the
pharmacokinetic evaluation, emphasising, for example, whether the species and strains examined
were those used in the pharmacology and toxicology evaluations, and whether the formulations
used were similar or identical.
2.6.4.2 Methods of Analysis
This section should contain a brief summary of the methods of analysis for biological samples,
including the detection and quantification limits of an analytical procedure. If possible,
validation data for the analytical method and stability of biological samples should be discussed
in this section. The potential impact of different methods of analysis on the interpretation of the
results should be discussed in the following relevant sections.
2.6.4.3 Absorption
The following data should be summarised in this section:
\u{2022} Absorption (extent and rate of absorption, in vivo and in situ studies)
\u{2022} Kinetic parameters, bioequivalence and/or bioavailability (serum/plasma/blood PK
studies)
2.6.4.4 Distribution
The following data should be summarised in this section:
\u{2022} Tissue distribution studies
\u{2022} Protein binding and distribution in blood cells
\u{2022} Placental transfer studies
2.6.4.5 Metabolism (interspecies comparison)
The following data should be summarised in this section:
\u{2022} Chemical structures and quantities of metabolites in biological samples
\u{2022} Possible metabolic pathways
\u{2022} Pre-systemic metabolism (GI/hepatic first-pass effects)
\u{2022} In vitro metabolism including P450 studies
\u{2022} Enzyme induction and inhibition
2.6.4.6 Excretion
The following data should be summarised in this section:
\u{2022} Routes and extent of excretion
\u{2022} Excretion in milk
2.6.4.7 Pharmacokinetic Drug Interactions
If they have been performed, nonclinical pharmacokinetic drug-interaction studies (in vitro
and/or in vivo) should be briefly summarised in this section.
2.6.4.8 Other Pharmacokinetic Studies
If studies have been performed in nonclinical models of disease (e.g., renally impaired animals),
they should be summarised in this section.
2.6.4.9 Discussion and Conclusions
This section provides an opportunity to discuss the pharmacokinetic evaluation and to consider
the significance of any issues that arise.
2.6.4.10 Tables and Figures
Text tables and figures can be included at appropriate points throughout the summary within the
text. Alternatively, there is the option of including tables and figures at the end of the summary.
2.6.5 PHARMACOKINETICS TABULATED SUMMARY (SEE APPENDIX B)
2.6.6 TOXICOLOGY WRITTEN SUMMARY
The sequence of the Toxicology Written Summary should be as follows:
\u{2022} Brief Summary
\u{2022} Single-Dose Toxicity
\u{2022} Repeat-Dose Toxicity
\u{2022} Genotoxicity
\u{2022} Carcinogenicity
\u{2022} Reproductive and Developmental Toxicity
\u{2022} Studies in Juvenile Animals
\u{2022} Local Tolerance
\u{2022} Other Toxicity Studies
\u{2022} Discussion and Conclusions
\u{2022} Tables and Figures (either here or included in text)
2.6.6.1 Brief Summary
The principal findings from the toxicology studies should be briefly summarized in a few pages
(generally not more than 6). In this section, the extent of the toxicologic evaluation can be
indicated by the use of a table listing the principal toxicologic studies (results should not be
presented in this table), for example:
TOXICOLOGY PROGRAMME
Study type and
duration
Route of
administration
Species Compound administered*
Single-dose toxicity
Single-dose toxicity
Repeat-dose toxicity
1 month
6 months
9 months,
etc.
po and iv
po and iv
po
po
po
Rat and mouse
Rat and mouse
Rat and dog
Rat
Dog
Parent drug
Metabolite X
Parent drug
\u{201C} \u{201C}
\u{201C} \u{201C}
* This column required only if metabolite(s) are investigated.
The scope of the toxicologic evaluation should be described in relation to the proposed clinical
use. A comment on the GLP status of the studies should be included.
2.6.6.2 Single-Dose Toxicity
The single-dose data should be very briefly summarised, in order by species, by route. In some
instances, it may be helpful to provide the data in the form of a table.
2.6.6.3 Repeat-Dose Toxicity (including supportive toxicokinetics evaluation)
Studies should be summarised in order by species, by route, and by duration, giving brief details
of the methodology and highlighting important findings (e.g., nature and severity of target organ
toxicity, dose (exposure)/response relationships, no observed adverse effect levels, etc.). Non-
pivotal studies can be summarized in less detail (pivotal studies are the definitive GLP studies
specified by ICH Guideline M3).
2.6.6.4 Genotoxicity
Studies should be briefly summarised in the following order:
\u{2022} in vitro non-mammalian cell system
\u{2022} in vitro mammalian cell system
\u{2022} in vivo mammalian system (including supportive toxicokinetics evaluation)
\u{2022} other systems
2.6.6.5 Carcinogenicity (including supportive toxicokinetics evaluations)
A brief rationale should explain why the studies were chosen and the basis for high-dose
selection. Individual studies should be summarised in the following order:
\u{2022} Long-term studies (in order by species; including range-finding studies that cannot
appropriately be included under repeat-dose toxicity or pharmacokinetics)
\u{2022} Short- or medium-term studies (including range-finding studies that cannot appropriately
be included under repeat-dose toxicity or pharmacokinetics)
\u{2022} Other studies
2.6.6.6 Reproductive and Developmental Toxicity (including range-finding studies
and supportive toxicokinetics evaluations)
Studies should be summarised in the following order, giving brief details of the methodology and
highlighting important findings:
\u{2022} Fertility and early embryonic development
\u{2022} Embryo-fetal development
\u{2022} Prenatal and postnatal development, including maternal function
\u{2022} Studies in which the offspring (juvenile animals) are dosed and/or further evaluated, if
such studies have been conducted.
If modified study designs are used, the sub-headings should be modified accordingly.
2.6.6.7 Local Tolerance
If local tolerance studies have been performed, they should be summarised in order by species,
by route, and by duration, giving brief details of the methodology and highlighting important
findings.
2.6.6.8 Other Toxicity Studies (if available)
If other studies have been performed, they should be summarised. When appropriate, the
rationale for conducting the studies should be provided.
\u{2022} Antigenicity
\u{2022} Immunotoxicity
\u{2022} Mechanistic studies (if not reported elsewhere)
\u{2022} Dependence
\u{2022} Studies on metabolites
\u{2022} Studies on impurities
\u{2022} Other studies
2.6.6.9 Discussion and Conclusions
This section should provide an opportunity to discuss the toxicologic evaluation and the
significance of any issues that arise. Tables or figures summarizing this information are
recommended.
2.6.6.10 Tables and Figures
Text tables and figures can be included at appropriate points throughout the summary within the
text. Alternatively, tables and figures can be included at the end of the summary.
2.6.7 TOXICOLOGY TABULATED SUMMARY (SEE APPENDIX B)`;
const $81b98fb9de868a7b$export$63b727d6e7a38867 = [
    {
        text: $81b98fb9de868a7b$export$4611ade21167fdc2,
        ectdTitle: "qos",
        ectdKey: "m2-2-introduction",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 2.2, edition July 2003"
    },
    {
        text: $81b98fb9de868a7b$export$35dd9876801626d0,
        ectdTitle: "qos",
        ectdKey: "m2-3-quality-overall-summary",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 2.3, edition July 2003"
    },
    {
        text: $81b98fb9de868a7b$export$bfcc4869675020e7,
        ectdTitle: "nonclinical-overview",
        ectdKey: "m2-4-nonclinical-overview",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 2.4, edition July 2003"
    },
    {
        text: $81b98fb9de868a7b$export$5279f1f2897ad22f,
        ectdTitle: "clinical-overview",
        ectdKey: "m2-5-clinical-overview",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 2.5, edition July 2003"
    },
    {
        text: $81b98fb9de868a7b$export$fae0affe3eccb7a7,
        ectdTitle: "clinical-summary",
        ectdKey: "m2-6-clinical-summary",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 2.6, edition July 2003"
    },
    {
        text: $81b98fb9de868a7b$export$91a1e2a10aca6e86,
        ectdTitle: "Module 3.2.P",
        ectdKey: "m3-2-p",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 3.2.P, edition July 2004"
    },
    {
        text: $81b98fb9de868a7b$export$8e5a7a72a7f58157,
        ectdTitle: "Module 3.2.R",
        ectdKey: "m3-2-r",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 3.2.R, edition July 2004"
    },
    {
        text: $81b98fb9de868a7b$export$48eb55df22ff8474,
        ectdTitle: "Module 3.2.S",
        ectdKey: "m3-2-s",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en#volume-2b---presentation-and-content-of-the-dossier",
        sourceName: "Volume 2B - Presentation and content of the dossier, Notice to Applicants - Medicinal products for human use, Section on Module 3.2.S, edition July 2004"
    },
    {
        text: $81b98fb9de868a7b$export$9c58314550ba2c12,
        ectdTitle: "common-spc",
        ectdKey: "pi-doc",
        sourceUrl: "https://health.ec.europa.eu/medicinal-products/eudralex/eudralex-volume-2_en",
        sourceName: "Guideline on Summary of Product Characteristics - SmPC (September 2009)"
    },
    {
        text: $81b98fb9de868a7b$export$baa027a998e5fdd4,
        ectdTitle: "common-pl",
        ectdKey: "pi-doc",
        sourceUrl: "https://www.ema.europa.eu/en/human-regulatory-overview/marketing-authorisation/product-information-requirements/product-information-qrd-templates-human#compliance-with-qrd-template-version-104-12646",
        sourceName: "QRD product-information annotated template (English) version 10.4, Section B. PACKAGE LEAFLET"
    },
    {
        text: $81b98fb9de868a7b$export$6edfdea2dd4b547f,
        ectdTitle: "phvigsystem",
        ectdKey: "m1-8-1-pharmacovigilance-system",
        sourceUrl: "https://eur-lex.europa.eu/eli/reg_impl/2021/1281",
        sourceName: "Article 23 of COMMISSION IMPLEMENTING REGULATION (EU) 2021/1281 of 2 August 2021 laying down rules for the application of Regulation (EU) 2019/6 of the European Parliament and of the Council as regards good pharmacovigilance practice and on the format, content and summary of the pharmacovigilance system master file for veterinary medicinal products"
    }
];








// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}



var $n3TJI = parcelRequire("n3TJI");
var $028c0e1c138f1b37$exports = {};
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ !function webpackUniversalModuleDefinition(e1, t) {
    $028c0e1c138f1b37$exports = e1.pdfjsWorker = t();
}(globalThis, ()=>(()=>{
        "use strict";
        var e1 = [
            ,
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.WorkerTask = t.WorkerMessageHandler = void 0;
                var r = a(2), n = a(3), i = a(4), s = a(6), o = a(10), c = a(68), l = a(73), h = a(104), u = a(105), d = a(72);
                class WorkerTask {
                    constructor(e1){
                        this.name = e1;
                        this.terminated = !1;
                        this._capability = new r.PromiseCapability;
                    }
                    get finished() {
                        return this._capability.promise;
                    }
                    finish() {
                        this._capability.resolve();
                    }
                    terminate() {
                        this.terminated = !0;
                    }
                    ensureNotTerminated() {
                        if (this.terminated) throw new Error("Worker task was terminated");
                    }
                }
                t.WorkerTask = WorkerTask;
                class WorkerMessageHandler {
                    static setup(e1, t) {
                        let a = !1;
                        e1.on("test", function(t) {
                            if (!a) {
                                a = !0;
                                e1.send("test", t instanceof Uint8Array);
                            }
                        });
                        e1.on("configure", function(e1) {
                            (0, r.setVerbosityLevel)(e1.verbosity);
                        });
                        e1.on("GetDocRequest", function(e1) {
                            return WorkerMessageHandler.createDocumentHandler(e1, t);
                        });
                    }
                    static createDocumentHandler(e1, t) {
                        let a, f = !1, g = null;
                        const p = new Set, m = (0, r.getVerbosityLevel)(), { docId: b, apiVersion: y } = e1, w = "3.11.174";
                        if (y !== w) throw new Error(`The API version "${y}" does not match the Worker version "${w}".`);
                        const S = [];
                        for(const e1 in [])S.push(e1);
                        if (S.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + S.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                        const x = b + "_worker";
                        let C = new h.MessageHandler(x, b, t);
                        function ensureNotTerminated() {
                            if (f) throw new Error("Worker was terminated");
                        }
                        function startWorkerTask(e1) {
                            p.add(e1);
                        }
                        function finishWorkerTask(e1) {
                            e1.finish();
                            p.delete(e1);
                        }
                        async function loadDocument(e1) {
                            await a.ensureDoc("checkHeader");
                            await a.ensureDoc("parseStartXRef");
                            await a.ensureDoc("parse", [
                                e1
                            ]);
                            await a.ensureDoc("checkFirstPage", [
                                e1
                            ]);
                            await a.ensureDoc("checkLastPage", [
                                e1
                            ]);
                            const t = await a.ensureDoc("isPureXfa");
                            if (t) {
                                const e1 = new WorkerTask("loadXfaFonts");
                                startWorkerTask(e1);
                                await Promise.all([
                                    a.loadXfaFonts(C, e1).catch((e1)=>{}).then(()=>finishWorkerTask(e1)),
                                    a.loadXfaImages()
                                ]);
                            }
                            const [r, n] = await Promise.all([
                                a.ensureDoc("numPages"),
                                a.ensureDoc("fingerprints")
                            ]);
                            return {
                                numPages: r,
                                fingerprints: n,
                                htmlForXfa: t ? await a.ensureDoc("htmlForXfa") : null
                            };
                        }
                        function getPdfManager({ data: e1, password: t, disableAutoFetch: a, rangeChunkSize: i, length: o, docBaseUrl: c, enableXfa: l, evaluatorOptions: h }) {
                            const d = {
                                source: null,
                                disableAutoFetch: a,
                                docBaseUrl: c,
                                docId: b,
                                enableXfa: l,
                                evaluatorOptions: h,
                                handler: C,
                                length: o,
                                password: t,
                                rangeChunkSize: i
                            }, f = new r.PromiseCapability;
                            let p;
                            if (e1) {
                                try {
                                    d.source = e1;
                                    p = new s.LocalPdfManager(d);
                                    f.resolve(p);
                                } catch (e1) {
                                    f.reject(e1);
                                }
                                return f.promise;
                            }
                            let m, y = [];
                            try {
                                m = new u.PDFWorkerStream(C);
                            } catch (e1) {
                                f.reject(e1);
                                return f.promise;
                            }
                            const w = m.getFullReader();
                            w.headersReady.then(function() {
                                if (w.isRangeSupported) {
                                    d.source = m;
                                    d.length = w.contentLength;
                                    d.disableAutoFetch ||= w.isStreamingSupported;
                                    p = new s.NetworkPdfManager(d);
                                    for (const e1 of y)p.sendProgressiveData(e1);
                                    y = [];
                                    f.resolve(p);
                                    g = null;
                                }
                            }).catch(function(e1) {
                                f.reject(e1);
                                g = null;
                            });
                            let S = 0;
                            new Promise(function(e1, t) {
                                const readChunk = function({ value: e1, done: a }) {
                                    try {
                                        ensureNotTerminated();
                                        if (a) {
                                            p || function() {
                                                const e1 = (0, n.arrayBuffersToBytes)(y);
                                                o && e1.length !== o && (0, r.warn)("reported HTTP length is different from actual");
                                                try {
                                                    d.source = e1;
                                                    p = new s.LocalPdfManager(d);
                                                    f.resolve(p);
                                                } catch (e1) {
                                                    f.reject(e1);
                                                }
                                                y = [];
                                            }();
                                            g = null;
                                            return;
                                        }
                                        S += e1.byteLength;
                                        w.isStreamingSupported || C.send("DocProgress", {
                                            loaded: S,
                                            total: Math.max(S, w.contentLength || 0)
                                        });
                                        p ? p.sendProgressiveData(e1) : y.push(e1);
                                        w.read().then(readChunk, t);
                                    } catch (e1) {
                                        t(e1);
                                    }
                                };
                                w.read().then(readChunk, t);
                            }).catch(function(e1) {
                                f.reject(e1);
                                g = null;
                            });
                            g = function(e1) {
                                m.cancelAllRequests(e1);
                            };
                            return f.promise;
                        }
                        C.on("GetPage", function(e1) {
                            return a.getPage(e1.pageIndex).then(function(e1) {
                                return Promise.all([
                                    a.ensure(e1, "rotate"),
                                    a.ensure(e1, "ref"),
                                    a.ensure(e1, "userUnit"),
                                    a.ensure(e1, "view")
                                ]).then(function([e1, t, a, r]) {
                                    return {
                                        rotate: e1,
                                        ref: t,
                                        userUnit: a,
                                        view: r
                                    };
                                });
                            });
                        });
                        C.on("GetPageIndex", function(e1) {
                            const t = i.Ref.get(e1.num, e1.gen);
                            return a.ensureCatalog("getPageIndex", [
                                t
                            ]);
                        });
                        C.on("GetDestinations", function(e1) {
                            return a.ensureCatalog("destinations");
                        });
                        C.on("GetDestination", function(e1) {
                            return a.ensureCatalog("getDestination", [
                                e1.id
                            ]);
                        });
                        C.on("GetPageLabels", function(e1) {
                            return a.ensureCatalog("pageLabels");
                        });
                        C.on("GetPageLayout", function(e1) {
                            return a.ensureCatalog("pageLayout");
                        });
                        C.on("GetPageMode", function(e1) {
                            return a.ensureCatalog("pageMode");
                        });
                        C.on("GetViewerPreferences", function(e1) {
                            return a.ensureCatalog("viewerPreferences");
                        });
                        C.on("GetOpenAction", function(e1) {
                            return a.ensureCatalog("openAction");
                        });
                        C.on("GetAttachments", function(e1) {
                            return a.ensureCatalog("attachments");
                        });
                        C.on("GetDocJSActions", function(e1) {
                            return a.ensureCatalog("jsActions");
                        });
                        C.on("GetPageJSActions", function({ pageIndex: e1 }) {
                            return a.getPage(e1).then(function(e1) {
                                return a.ensure(e1, "jsActions");
                            });
                        });
                        C.on("GetOutline", function(e1) {
                            return a.ensureCatalog("documentOutline");
                        });
                        C.on("GetOptionalContentConfig", function(e1) {
                            return a.ensureCatalog("optionalContentConfig");
                        });
                        C.on("GetPermissions", function(e1) {
                            return a.ensureCatalog("permissions");
                        });
                        C.on("GetMetadata", function(e1) {
                            return Promise.all([
                                a.ensureDoc("documentInfo"),
                                a.ensureCatalog("metadata")
                            ]);
                        });
                        C.on("GetMarkInfo", function(e1) {
                            return a.ensureCatalog("markInfo");
                        });
                        C.on("GetData", function(e1) {
                            return a.requestLoadedStream().then(function(e1) {
                                return e1.bytes;
                            });
                        });
                        C.on("GetAnnotations", function({ pageIndex: e1, intent: t }) {
                            return a.getPage(e1).then(function(a) {
                                const r = new WorkerTask(`GetAnnotations: page ${e1}`);
                                startWorkerTask(r);
                                return a.getAnnotationsData(C, r, t).then((e1)=>{
                                    finishWorkerTask(r);
                                    return e1;
                                }, (e1)=>{
                                    finishWorkerTask(r);
                                    throw e1;
                                });
                            });
                        });
                        C.on("GetFieldObjects", function(e1) {
                            return a.ensureDoc("fieldObjects");
                        });
                        C.on("HasJSActions", function(e1) {
                            return a.ensureDoc("hasJSActions");
                        });
                        C.on("GetCalculationOrderIds", function(e1) {
                            return a.ensureDoc("calculationOrderIds");
                        });
                        C.on("SaveDocument", async function({ isPureXfa: e1, numPages: t, annotationStorage: s, filename: c }) {
                            const h = [
                                a.requestLoadedStream(),
                                a.ensureCatalog("acroForm"),
                                a.ensureCatalog("acroFormRef"),
                                a.ensureDoc("startXRef"),
                                a.ensureDoc("xref"),
                                a.ensureDoc("linearization"),
                                a.ensureCatalog("structTreeRoot")
                            ], u = [], f = e1 ? null : (0, n.getNewAnnotationsMap)(s), [g, p, m, b, y, w, S] = await Promise.all(h), x = y.trailer.getRaw("Root") || null;
                            let k;
                            if (f) {
                                S ? await S.canUpdateStructTree({
                                    pdfManager: a,
                                    newAnnotationsByPage: f
                                }) && (k = S) : await d.StructTreeRoot.canCreateStructureTree({
                                    catalogRef: x,
                                    pdfManager: a,
                                    newAnnotationsByPage: f
                                }) && (k = null);
                                const e1 = o.AnnotationFactory.generateImages(s.values(), y, a.evaluatorOptions.isOffscreenCanvasSupported), t = void 0 === k ? u : [];
                                for (const [r, n] of f)t.push(a.getPage(r).then((t)=>{
                                    const a = new WorkerTask(`Save (editor): page ${r}`);
                                    return t.saveNewAnnotations(C, a, n, e1).finally(function() {
                                        finishWorkerTask(a);
                                    });
                                }));
                                null === k ? u.push(Promise.all(t).then(async (e1)=>{
                                    await d.StructTreeRoot.createStructureTree({
                                        newAnnotationsByPage: f,
                                        xref: y,
                                        catalogRef: x,
                                        pdfManager: a,
                                        newRefs: e1
                                    });
                                    return e1;
                                })) : k && u.push(Promise.all(t).then(async (e1)=>{
                                    await k.updateStructureTree({
                                        newAnnotationsByPage: f,
                                        pdfManager: a,
                                        newRefs: e1
                                    });
                                    return e1;
                                }));
                            }
                            if (e1) u.push(a.serializeXfaData(s));
                            else for(let e1 = 0; e1 < t; e1++)u.push(a.getPage(e1).then(function(t) {
                                const a = new WorkerTask(`Save: page ${e1}`);
                                return t.save(C, a, s).finally(function() {
                                    finishWorkerTask(a);
                                });
                            }));
                            const v = await Promise.all(u);
                            let F = [], O = null;
                            if (e1) {
                                O = v[0];
                                if (!O) return g.bytes;
                            } else {
                                F = v.flat(2);
                                if (0 === F.length) return g.bytes;
                            }
                            const T = m && p instanceof i.Dict && F.some((e1)=>e1.needAppearances), M = p instanceof i.Dict && p.get("XFA") || null;
                            let D = null, E = !1;
                            if (Array.isArray(M)) {
                                for(let e1 = 0, t = M.length; e1 < t; e1 += 2)if ("datasets" === M[e1]) {
                                    D = M[e1 + 1];
                                    E = !0;
                                }
                                null === D && (D = y.getNewTemporaryRef());
                            } else M && (0, r.warn)("Unsupported XFA type.");
                            let N = Object.create(null);
                            if (y.trailer) {
                                const e1 = Object.create(null), t = y.trailer.get("Info") || null;
                                t instanceof i.Dict && t.forEach((t, a)=>{
                                    "string" == typeof a && (e1[t] = (0, r.stringToPDFString)(a));
                                });
                                N = {
                                    rootRef: x,
                                    encryptRef: y.trailer.getRaw("Encrypt") || null,
                                    newRef: y.getNewTemporaryRef(),
                                    infoRef: y.trailer.getRaw("Info") || null,
                                    info: e1,
                                    fileIds: y.trailer.get("ID") || null,
                                    startXRef: w ? b : y.lastXRefStreamPos ?? b,
                                    filename: c
                                };
                            }
                            return (0, l.incrementalUpdate)({
                                originalData: g.bytes,
                                xrefInfo: N,
                                newRefs: F,
                                xref: y,
                                hasXfa: !!M,
                                xfaDatasetsRef: D,
                                hasXfaDatasetsEntry: E,
                                needAppearances: T,
                                acroFormRef: m,
                                acroForm: p,
                                xfaData: O
                            }).finally(()=>{
                                y.resetNewTemporaryRef();
                            });
                        });
                        C.on("GetOperatorList", function(e1, t) {
                            const n = e1.pageIndex;
                            a.getPage(n).then(function(a) {
                                const i = new WorkerTask(`GetOperatorList: page ${n}`);
                                startWorkerTask(i);
                                const s = m >= r.VerbosityLevel.INFOS ? Date.now() : 0;
                                a.getOperatorList({
                                    handler: C,
                                    sink: t,
                                    task: i,
                                    intent: e1.intent,
                                    cacheKey: e1.cacheKey,
                                    annotationStorage: e1.annotationStorage
                                }).then(function(e1) {
                                    finishWorkerTask(i);
                                    s && (0, r.info)(`page=${n + 1} - getOperatorList: time=${Date.now() - s}ms, len=${e1.length}`);
                                    t.close();
                                }, function(e1) {
                                    finishWorkerTask(i);
                                    i.terminated || t.error(e1);
                                });
                            });
                        });
                        C.on("GetTextContent", function(e1, t) {
                            const { pageIndex: n, includeMarkedContent: i, disableNormalization: s } = e1;
                            a.getPage(n).then(function(e1) {
                                const a = new WorkerTask("GetTextContent: page " + n);
                                startWorkerTask(a);
                                const o = m >= r.VerbosityLevel.INFOS ? Date.now() : 0;
                                e1.extractTextContent({
                                    handler: C,
                                    task: a,
                                    sink: t,
                                    includeMarkedContent: i,
                                    disableNormalization: s
                                }).then(function() {
                                    finishWorkerTask(a);
                                    o && (0, r.info)(`page=${n + 1} - getTextContent: time=` + (Date.now() - o) + "ms");
                                    t.close();
                                }, function(e1) {
                                    finishWorkerTask(a);
                                    a.terminated || t.error(e1);
                                });
                            });
                        });
                        C.on("GetStructTree", function(e1) {
                            return a.getPage(e1.pageIndex).then(function(e1) {
                                return a.ensure(e1, "getStructTree");
                            });
                        });
                        C.on("FontFallback", function(e1) {
                            return a.fontFallback(e1.id, C);
                        });
                        C.on("Cleanup", function(e1) {
                            return a.cleanup(!0);
                        });
                        C.on("Terminate", function(e1) {
                            f = !0;
                            const t = [];
                            if (a) {
                                a.terminate(new r.AbortException("Worker was terminated."));
                                const e1 = a.cleanup();
                                t.push(e1);
                                a = null;
                            } else (0, c.clearGlobalCaches)();
                            g && g(new r.AbortException("Worker was terminated."));
                            for (const e1 of p){
                                t.push(e1.finished);
                                e1.terminate();
                            }
                            return Promise.all(t).then(function() {
                                C.destroy();
                                C = null;
                            });
                        });
                        C.on("Ready", function(t) {
                            !function setupDoc(e1) {
                                function onSuccess(e1) {
                                    ensureNotTerminated();
                                    C.send("GetDoc", {
                                        pdfInfo: e1
                                    });
                                }
                                function onFailure(e1) {
                                    ensureNotTerminated();
                                    if (e1 instanceof r.PasswordException) {
                                        const t = new WorkerTask(`PasswordException: response ${e1.code}`);
                                        startWorkerTask(t);
                                        C.sendWithPromise("PasswordRequest", e1).then(function({ password: e1 }) {
                                            finishWorkerTask(t);
                                            a.updatePassword(e1);
                                            pdfManagerReady();
                                        }).catch(function() {
                                            finishWorkerTask(t);
                                            C.send("DocException", e1);
                                        });
                                    } else e1 instanceof r.InvalidPDFException || e1 instanceof r.MissingPDFException || e1 instanceof r.UnexpectedResponseException || e1 instanceof r.UnknownErrorException ? C.send("DocException", e1) : C.send("DocException", new r.UnknownErrorException(e1.message, e1.toString()));
                                }
                                function pdfManagerReady() {
                                    ensureNotTerminated();
                                    loadDocument(!1).then(onSuccess, function(e1) {
                                        ensureNotTerminated();
                                        e1 instanceof n.XRefParseException ? a.requestLoadedStream().then(function() {
                                            ensureNotTerminated();
                                            loadDocument(!0).then(onSuccess, onFailure);
                                        }) : onFailure(e1);
                                    });
                                }
                                ensureNotTerminated();
                                getPdfManager(e1).then(function(e1) {
                                    if (f) {
                                        e1.terminate(new r.AbortException("Worker was terminated."));
                                        throw new Error("Worker was terminated");
                                    }
                                    a = e1;
                                    a.requestLoadedStream(!0).then((e1)=>{
                                        C.send("DataLoaded", {
                                            length: e1.bytes.byteLength
                                        });
                                    });
                                }).then(pdfManagerReady, onFailure);
                            }(e1);
                            e1 = null;
                        });
                        return x;
                    }
                    static initializeFromPort(e1) {
                        const t = new h.MessageHandler("worker", "main", e1);
                        WorkerMessageHandler.setup(t, e1);
                        t.send("ready", null);
                    }
                }
                t.WorkerMessageHandler = WorkerMessageHandler;
                "undefined" == typeof window && !r.isNodeJS && "undefined" != typeof self && function isMessagePort(e1) {
                    return "function" == typeof e1.postMessage && "onmessage" in e1;
                }(self) && WorkerMessageHandler.initializeFromPort(self);
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.VerbosityLevel = t.Util = t.UnknownErrorException = t.UnexpectedResponseException = t.TextRenderingMode = t.RenderingIntentFlag = t.PromiseCapability = t.PermissionFlag = t.PasswordResponses = t.PasswordException = t.PageActionEventType = t.OPS = t.MissingPDFException = t.MAX_IMAGE_SIZE_TO_CACHE = t.LINE_FACTOR = t.LINE_DESCENT_FACTOR = t.InvalidPDFException = t.ImageKind = t.IDENTITY_MATRIX = t.FormatError = t.FeatureTest = t.FONT_IDENTITY_MATRIX = t.DocumentActionEventType = t.CMapCompressionType = t.BaseException = t.BASELINE_FACTOR = t.AnnotationType = t.AnnotationReplyType = t.AnnotationPrefix = t.AnnotationMode = t.AnnotationFlag = t.AnnotationFieldFlag = t.AnnotationEditorType = t.AnnotationEditorPrefix = t.AnnotationEditorParamsType = t.AnnotationBorderStyleType = t.AnnotationActionEventType = t.AbortException = void 0;
                t.assert = function assert(e1, t) {
                    e1 || unreachable(t);
                };
                t.bytesToString = bytesToString;
                t.createValidAbsoluteUrl = function createValidAbsoluteUrl(e1, t = null, a = null) {
                    if (!e1) return null;
                    try {
                        if (a && "string" == typeof e1) {
                            if (a.addDefaultProtocol && e1.startsWith("www.")) {
                                const t = e1.match(/\./g);
                                t?.length >= 2 && (e1 = `http://${e1}`);
                            }
                            if (a.tryConvertEncoding) try {
                                e1 = stringToUTF8String(e1);
                            } catch  {}
                        }
                        const r = t ? new URL(e1, t) : new URL(e1);
                        if (function _isValidProtocol(e1) {
                            switch(e1?.protocol){
                                case "http:":
                                case "https:":
                                case "ftp:":
                                case "mailto:":
                                case "tel:":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }(r)) return r;
                    } catch  {}
                    return null;
                };
                t.getModificationDate = function getModificationDate(e1 = new Date) {
                    return [
                        e1.getUTCFullYear().toString(),
                        (e1.getUTCMonth() + 1).toString().padStart(2, "0"),
                        e1.getUTCDate().toString().padStart(2, "0"),
                        e1.getUTCHours().toString().padStart(2, "0"),
                        e1.getUTCMinutes().toString().padStart(2, "0"),
                        e1.getUTCSeconds().toString().padStart(2, "0")
                    ].join("");
                };
                t.getUuid = function getUuid() {
                    if ("undefined" != typeof crypto && "function" == typeof crypto?.randomUUID) return crypto.randomUUID();
                    const e1 = new Uint8Array(32);
                    if ("undefined" != typeof crypto && "function" == typeof crypto?.getRandomValues) crypto.getRandomValues(e1);
                    else for(let t = 0; t < 32; t++)e1[t] = Math.floor(255 * Math.random());
                    return bytesToString(e1);
                };
                t.getVerbosityLevel = function getVerbosityLevel() {
                    return n;
                };
                t.info = function info(e1) {
                    n >= r.INFOS && console.log(`Info: ${e1}`);
                };
                t.isArrayBuffer = function isArrayBuffer(e1) {
                    return "object" == typeof e1 && void 0 !== e1?.byteLength;
                };
                t.isArrayEqual = function isArrayEqual(e1, t) {
                    if (e1.length !== t.length) return !1;
                    for(let a = 0, r = e1.length; a < r; a++)if (e1[a] !== t[a]) return !1;
                    return !0;
                };
                t.isNodeJS = void 0;
                t.normalizeUnicode = function normalizeUnicode(e1) {
                    if (!c) {
                        c = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        l = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return e1.replaceAll(c, (e1, t, a)=>t ? t.normalize("NFKC") : l.get(a));
                };
                t.objectFromMap = function objectFromMap(e1) {
                    const t = Object.create(null);
                    for (const [a, r] of e1)t[a] = r;
                    return t;
                };
                t.objectSize = function objectSize(e1) {
                    return Object.keys(e1).length;
                };
                t.setVerbosityLevel = function setVerbosityLevel(e1) {
                    Number.isInteger(e1) && (n = e1);
                };
                t.shadow = shadow;
                t.string32 = function string32(e1) {
                    return String.fromCharCode(e1 >> 24 & 255, e1 >> 16 & 255, e1 >> 8 & 255, 255 & e1);
                };
                t.stringToBytes = stringToBytes;
                t.stringToPDFString = function stringToPDFString(e1) {
                    if (e1[0] >= "\xef") {
                        let t;
                        "\xfe" === e1[0] && "\xff" === e1[1] ? t = "utf-16be" : "\xff" === e1[0] && "\xfe" === e1[1] ? t = "utf-16le" : "\xef" === e1[0] && "\xbb" === e1[1] && "\xbf" === e1[2] && (t = "utf-8");
                        if (t) try {
                            const a = new TextDecoder(t, {
                                fatal: !0
                            }), r = stringToBytes(e1);
                            return a.decode(r);
                        } catch (e1) {
                            warn(`stringToPDFString: "${e1}".`);
                        }
                    }
                    const t = [];
                    for(let a = 0, r = e1.length; a < r; a++){
                        const r = o[e1.charCodeAt(a)];
                        t.push(r ? String.fromCharCode(r) : e1.charAt(a));
                    }
                    return t.join("");
                };
                t.stringToUTF8String = stringToUTF8String;
                t.unreachable = unreachable;
                t.utf8StringToString = function utf8StringToString(e1) {
                    return unescape(encodeURIComponent(e1));
                };
                t.warn = warn;
                const a = false;
                t.isNodeJS = a;
                t.IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                t.FONT_IDENTITY_MATRIX = [
                    .001,
                    0,
                    0,
                    .001,
                    0,
                    0
                ];
                t.MAX_IMAGE_SIZE_TO_CACHE = 1e7;
                t.LINE_FACTOR = 1.35;
                t.LINE_DESCENT_FACTOR = .35;
                t.BASELINE_FACTOR = .25925925925925924;
                t.RenderingIntentFlag = {
                    ANY: 1,
                    DISPLAY: 2,
                    PRINT: 4,
                    SAVE: 8,
                    ANNOTATIONS_FORMS: 16,
                    ANNOTATIONS_STORAGE: 32,
                    ANNOTATIONS_DISABLE: 64,
                    OPLIST: 256
                };
                t.AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                t.AnnotationEditorPrefix = "pdfjs_internal_editor_";
                t.AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                t.AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                t.PermissionFlag = {
                    PRINT: 4,
                    MODIFY_CONTENTS: 8,
                    COPY: 16,
                    MODIFY_ANNOTATIONS: 32,
                    FILL_INTERACTIVE_FORMS: 256,
                    COPY_FOR_ACCESSIBILITY: 512,
                    ASSEMBLE: 1024,
                    PRINT_HIGH_QUALITY: 2048
                };
                t.TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                t.ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                t.AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                t.AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                t.AnnotationFlag = {
                    INVISIBLE: 1,
                    HIDDEN: 2,
                    PRINT: 4,
                    NOZOOM: 8,
                    NOROTATE: 16,
                    NOVIEW: 32,
                    READONLY: 64,
                    LOCKED: 128,
                    TOGGLENOVIEW: 256,
                    LOCKEDCONTENTS: 512
                };
                t.AnnotationFieldFlag = {
                    READONLY: 1,
                    REQUIRED: 2,
                    NOEXPORT: 4,
                    MULTILINE: 4096,
                    PASSWORD: 8192,
                    NOTOGGLETOOFF: 16384,
                    RADIO: 32768,
                    PUSHBUTTON: 65536,
                    COMBO: 131072,
                    EDIT: 262144,
                    SORT: 524288,
                    FILESELECT: 1048576,
                    MULTISELECT: 2097152,
                    DONOTSPELLCHECK: 4194304,
                    DONOTSCROLL: 8388608,
                    COMB: 16777216,
                    RICHTEXT: 33554432,
                    RADIOSINUNISON: 33554432,
                    COMMITONSELCHANGE: 67108864
                };
                t.AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                t.AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                t.DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                t.PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                const r = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                t.VerbosityLevel = r;
                t.CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                t.OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                t.PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                let n = r.WARNINGS;
                function warn(e1) {
                    n >= r.WARNINGS && console.log(`Warning: ${e1}`);
                }
                function unreachable(e1) {
                    throw new Error(e1);
                }
                function shadow(e1, t, a, r = !1) {
                    Object.defineProperty(e1, t, {
                        value: a,
                        enumerable: !r,
                        configurable: !0,
                        writable: !1
                    });
                    return a;
                }
                const i = function BaseExceptionClosure() {
                    function BaseException(e1, t) {
                        this.constructor === BaseException && unreachable("Cannot initialize BaseException.");
                        this.message = e1;
                        this.name = t;
                    }
                    BaseException.prototype = new Error;
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                t.BaseException = i;
                t.PasswordException = class PasswordException extends i {
                    constructor(e1, t){
                        super(e1, "PasswordException");
                        this.code = t;
                    }
                };
                t.UnknownErrorException = class UnknownErrorException extends i {
                    constructor(e1, t){
                        super(e1, "UnknownErrorException");
                        this.details = t;
                    }
                };
                t.InvalidPDFException = class InvalidPDFException extends i {
                    constructor(e1){
                        super(e1, "InvalidPDFException");
                    }
                };
                t.MissingPDFException = class MissingPDFException extends i {
                    constructor(e1){
                        super(e1, "MissingPDFException");
                    }
                };
                t.UnexpectedResponseException = class UnexpectedResponseException extends i {
                    constructor(e1, t){
                        super(e1, "UnexpectedResponseException");
                        this.status = t;
                    }
                };
                t.FormatError = class FormatError extends i {
                    constructor(e1){
                        super(e1, "FormatError");
                    }
                };
                t.AbortException = class AbortException extends i {
                    constructor(e1){
                        super(e1, "AbortException");
                    }
                };
                function bytesToString(e1) {
                    "object" == typeof e1 && void 0 !== e1?.length || unreachable("Invalid argument for bytesToString");
                    const t = e1.length, a = 8192;
                    if (t < a) return String.fromCharCode.apply(null, e1);
                    const r = [];
                    for(let n = 0; n < t; n += a){
                        const i = Math.min(n + a, t), s = e1.subarray(n, i);
                        r.push(String.fromCharCode.apply(null, s));
                    }
                    return r.join("");
                }
                function stringToBytes(e1) {
                    "string" != typeof e1 && unreachable("Invalid argument for stringToBytes");
                    const t = e1.length, a = new Uint8Array(t);
                    for(let r = 0; r < t; ++r)a[r] = 255 & e1.charCodeAt(r);
                    return a;
                }
                t.FeatureTest = class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", function isLittleEndian() {
                            const e1 = new Uint8Array(4);
                            e1[0] = 1;
                            return 1 === new Uint32Array(e1.buffer, 0, 1)[0];
                        }());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", function isEvalSupported() {
                            try {
                                new Function("");
                                return !0;
                            } catch  {
                                return !1;
                            }
                        }());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", "undefined" != typeof OffscreenCanvas);
                    }
                    static get platform() {
                        return "undefined" == typeof navigator ? shadow(this, "platform", {
                            isWin: !1,
                            isMac: !1
                        }) : shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                };
                const s = [
                    ...Array(256).keys()
                ].map((e1)=>e1.toString(16).padStart(2, "0"));
                t.Util = class Util {
                    static makeHexColor(e1, t, a) {
                        return `#${s[e1]}${s[t]}${s[a]}`;
                    }
                    static scaleMinMax(e1, t) {
                        let a;
                        if (e1[0]) {
                            if (e1[0] < 0) {
                                a = t[0];
                                t[0] = t[1];
                                t[1] = a;
                            }
                            t[0] *= e1[0];
                            t[1] *= e1[0];
                            if (e1[3] < 0) {
                                a = t[2];
                                t[2] = t[3];
                                t[3] = a;
                            }
                            t[2] *= e1[3];
                            t[3] *= e1[3];
                        } else {
                            a = t[0];
                            t[0] = t[2];
                            t[2] = a;
                            a = t[1];
                            t[1] = t[3];
                            t[3] = a;
                            if (e1[1] < 0) {
                                a = t[2];
                                t[2] = t[3];
                                t[3] = a;
                            }
                            t[2] *= e1[1];
                            t[3] *= e1[1];
                            if (e1[2] < 0) {
                                a = t[0];
                                t[0] = t[1];
                                t[1] = a;
                            }
                            t[0] *= e1[2];
                            t[1] *= e1[2];
                        }
                        t[0] += e1[4];
                        t[1] += e1[4];
                        t[2] += e1[5];
                        t[3] += e1[5];
                    }
                    static transform(e1, t) {
                        return [
                            e1[0] * t[0] + e1[2] * t[1],
                            e1[1] * t[0] + e1[3] * t[1],
                            e1[0] * t[2] + e1[2] * t[3],
                            e1[1] * t[2] + e1[3] * t[3],
                            e1[0] * t[4] + e1[2] * t[5] + e1[4],
                            e1[1] * t[4] + e1[3] * t[5] + e1[5]
                        ];
                    }
                    static applyTransform(e1, t) {
                        return [
                            e1[0] * t[0] + e1[1] * t[2] + t[4],
                            e1[0] * t[1] + e1[1] * t[3] + t[5]
                        ];
                    }
                    static applyInverseTransform(e1, t) {
                        const a = t[0] * t[3] - t[1] * t[2];
                        return [
                            (e1[0] * t[3] - e1[1] * t[2] + t[2] * t[5] - t[4] * t[3]) / a,
                            (-e1[0] * t[1] + e1[1] * t[0] + t[4] * t[1] - t[5] * t[0]) / a
                        ];
                    }
                    static getAxialAlignedBoundingBox(e1, t) {
                        const a = this.applyTransform(e1, t), r = this.applyTransform(e1.slice(2, 4), t), n = this.applyTransform([
                            e1[0],
                            e1[3]
                        ], t), i = this.applyTransform([
                            e1[2],
                            e1[1]
                        ], t);
                        return [
                            Math.min(a[0], r[0], n[0], i[0]),
                            Math.min(a[1], r[1], n[1], i[1]),
                            Math.max(a[0], r[0], n[0], i[0]),
                            Math.max(a[1], r[1], n[1], i[1])
                        ];
                    }
                    static inverseTransform(e1) {
                        const t = e1[0] * e1[3] - e1[1] * e1[2];
                        return [
                            e1[3] / t,
                            -e1[1] / t,
                            -e1[2] / t,
                            e1[0] / t,
                            (e1[2] * e1[5] - e1[4] * e1[3]) / t,
                            (e1[4] * e1[1] - e1[5] * e1[0]) / t
                        ];
                    }
                    static singularValueDecompose2dScale(e1) {
                        const t = [
                            e1[0],
                            e1[2],
                            e1[1],
                            e1[3]
                        ], a = e1[0] * t[0] + e1[1] * t[2], r = e1[0] * t[1] + e1[1] * t[3], n = e1[2] * t[0] + e1[3] * t[2], i = e1[2] * t[1] + e1[3] * t[3], s = (a + i) / 2, o = Math.sqrt((a + i) ** 2 - 4 * (a * i - n * r)) / 2, c = s + o || 1, l = s - o || 1;
                        return [
                            Math.sqrt(c),
                            Math.sqrt(l)
                        ];
                    }
                    static normalizeRect(e1) {
                        const t = e1.slice(0);
                        if (e1[0] > e1[2]) {
                            t[0] = e1[2];
                            t[2] = e1[0];
                        }
                        if (e1[1] > e1[3]) {
                            t[1] = e1[3];
                            t[3] = e1[1];
                        }
                        return t;
                    }
                    static intersect(e1, t) {
                        const a = Math.max(Math.min(e1[0], e1[2]), Math.min(t[0], t[2])), r = Math.min(Math.max(e1[0], e1[2]), Math.max(t[0], t[2]));
                        if (a > r) return null;
                        const n = Math.max(Math.min(e1[1], e1[3]), Math.min(t[1], t[3])), i = Math.min(Math.max(e1[1], e1[3]), Math.max(t[1], t[3]));
                        return n > i ? null : [
                            a,
                            n,
                            r,
                            i
                        ];
                    }
                    static bezierBoundingBox(e1, t, a, r, n, i, s, o) {
                        const c = [], l = [
                            [],
                            []
                        ];
                        let h, u, d, f, g, p, m, b;
                        for(let l = 0; l < 2; ++l){
                            if (0 === l) {
                                u = 6 * e1 - 12 * a + 6 * n;
                                h = -3 * e1 + 9 * a - 9 * n + 3 * s;
                                d = 3 * a - 3 * e1;
                            } else {
                                u = 6 * t - 12 * r + 6 * i;
                                h = -3 * t + 9 * r - 9 * i + 3 * o;
                                d = 3 * r - 3 * t;
                            }
                            if (Math.abs(h) < 1e-12) {
                                if (Math.abs(u) < 1e-12) continue;
                                f = -d / u;
                                0 < f && f < 1 && c.push(f);
                            } else {
                                m = u * u - 4 * d * h;
                                b = Math.sqrt(m);
                                if (!(m < 0)) {
                                    g = (-u + b) / (2 * h);
                                    0 < g && g < 1 && c.push(g);
                                    p = (-u - b) / (2 * h);
                                    0 < p && p < 1 && c.push(p);
                                }
                            }
                        }
                        let y, w = c.length;
                        const S = w;
                        for(; w--;){
                            f = c[w];
                            y = 1 - f;
                            l[0][w] = y * y * y * e1 + 3 * y * y * f * a + 3 * y * f * f * n + f * f * f * s;
                            l[1][w] = y * y * y * t + 3 * y * y * f * r + 3 * y * f * f * i + f * f * f * o;
                        }
                        l[0][S] = e1;
                        l[1][S] = t;
                        l[0][S + 1] = s;
                        l[1][S + 1] = o;
                        l[0].length = l[1].length = S + 2;
                        return [
                            Math.min(...l[0]),
                            Math.min(...l[1]),
                            Math.max(...l[0]),
                            Math.max(...l[1])
                        ];
                    }
                };
                const o = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    728,
                    711,
                    710,
                    729,
                    733,
                    731,
                    730,
                    732,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8226,
                    8224,
                    8225,
                    8230,
                    8212,
                    8211,
                    402,
                    8260,
                    8249,
                    8250,
                    8722,
                    8240,
                    8222,
                    8220,
                    8221,
                    8216,
                    8217,
                    8218,
                    8482,
                    64257,
                    64258,
                    321,
                    338,
                    352,
                    376,
                    381,
                    305,
                    322,
                    339,
                    353,
                    382,
                    0,
                    8364
                ];
                function stringToUTF8String(e1) {
                    return decodeURIComponent(escape(e1));
                }
                t.PromiseCapability = class PromiseCapability {
                    #e = !1;
                    constructor(){
                        this.promise = new Promise((e1, t)=>{
                            this.resolve = (t)=>{
                                this.#e = !0;
                                e1(t);
                            };
                            this.reject = (e1)=>{
                                this.#e = !0;
                                t(e1);
                            };
                        });
                    }
                    get settled() {
                        return this.#e;
                    }
                };
                let c = null, l = null;
                t.AnnotationPrefix = "pdfjs_internal_id_";
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XRefParseException = t.XRefEntryException = t.ParserEOFException = t.PDF_VERSION_REGEXP = t.MissingDataException = void 0;
                t.arrayBuffersToBytes = function arrayBuffersToBytes(e1) {
                    const t = e1.length;
                    if (0 === t) return new Uint8Array(0);
                    if (1 === t) return new Uint8Array(e1[0]);
                    let a = 0;
                    for(let r = 0; r < t; r++)a += e1[r].byteLength;
                    const r = new Uint8Array(a);
                    let n = 0;
                    for(let a = 0; a < t; a++){
                        const t = new Uint8Array(e1[a]);
                        r.set(t, n);
                        n += t.byteLength;
                    }
                    return r;
                };
                t.collectActions = function collectActions(e1, t, a) {
                    const i = Object.create(null), s = getInheritableProperty({
                        dict: t,
                        key: "AA",
                        stopWhenFound: !1
                    });
                    if (s) for(let t = s.length - 1; t >= 0; t--){
                        const r = s[t];
                        if (r instanceof n.Dict) for (const t of r.getKeys()){
                            const s = a[t];
                            if (!s) continue;
                            const o = [];
                            _collectJS(r.getRaw(t), e1, o, new n.RefSet);
                            o.length > 0 && (i[s] = o);
                        }
                    }
                    if (t.has("A")) {
                        const a = [];
                        _collectJS(t.get("A"), e1, a, new n.RefSet);
                        a.length > 0 && (i.Action = a);
                    }
                    return (0, r.objectSize)(i) > 0 ? i : null;
                };
                t.encodeToXmlString = function encodeToXmlString(e1) {
                    const t = [];
                    let a = 0;
                    for(let r = 0, n = e1.length; r < n; r++){
                        const n = e1.codePointAt(r);
                        if (32 <= n && n <= 126) {
                            const i = o[n];
                            if (i) {
                                a < r && t.push(e1.substring(a, r));
                                t.push(i);
                                a = r + 1;
                            }
                        } else {
                            a < r && t.push(e1.substring(a, r));
                            t.push(`&#x${n.toString(16).toUpperCase()};`);
                            n > 55295 && (n < 57344 || n > 65533) && r++;
                            a = r + 1;
                        }
                    }
                    if (0 === t.length) return e1;
                    a < e1.length && t.push(e1.substring(a, e1.length));
                    return t.join("");
                };
                t.escapePDFName = function escapePDFName(e1) {
                    const t = [];
                    let a = 0;
                    for(let r = 0, n = e1.length; r < n; r++){
                        const n = e1.charCodeAt(r);
                        if (n < 33 || n > 126 || 35 === n || 40 === n || 41 === n || 60 === n || 62 === n || 91 === n || 93 === n || 123 === n || 125 === n || 47 === n || 37 === n) {
                            a < r && t.push(e1.substring(a, r));
                            t.push(`#${n.toString(16)}`);
                            a = r + 1;
                        }
                    }
                    if (0 === t.length) return e1;
                    a < e1.length && t.push(e1.substring(a, e1.length));
                    return t.join("");
                };
                t.escapeString = function escapeString(e1) {
                    return e1.replaceAll(/([()\\\n\r])/g, (e1)=>"\n" === e1 ? "\\n" : "\r" === e1 ? "\\r" : `\\${e1}`);
                };
                t.getInheritableProperty = getInheritableProperty;
                t.getLookupTableFactory = function getLookupTableFactory(e1) {
                    let t;
                    return function() {
                        if (e1) {
                            t = Object.create(null);
                            e1(t);
                            e1 = null;
                        }
                        return t;
                    };
                };
                t.getNewAnnotationsMap = function getNewAnnotationsMap(e1) {
                    if (!e1) return null;
                    const t = new Map;
                    for (const [a, n] of e1){
                        if (!a.startsWith(r.AnnotationEditorPrefix)) continue;
                        let e1 = t.get(n.pageIndex);
                        if (!e1) {
                            e1 = [];
                            t.set(n.pageIndex, e1);
                        }
                        e1.push(n);
                    }
                    return t.size > 0 ? t : null;
                };
                t.getRotationMatrix = function getRotationMatrix(e1, t, a) {
                    switch(e1){
                        case 90:
                            return [
                                0,
                                1,
                                -1,
                                0,
                                t,
                                0
                            ];
                        case 180:
                            return [
                                -1,
                                0,
                                0,
                                -1,
                                t,
                                a
                            ];
                        case 270:
                            return [
                                0,
                                -1,
                                1,
                                0,
                                0,
                                a
                            ];
                        default:
                            throw new Error("Invalid rotation");
                    }
                };
                t.isAscii = function isAscii(e1) {
                    return /^[\x00-\x7F]*$/.test(e1);
                };
                t.isWhiteSpace = function isWhiteSpace(e1) {
                    return 32 === e1 || 9 === e1 || 13 === e1 || 10 === e1;
                };
                t.log2 = function log2(e1) {
                    if (e1 <= 0) return 0;
                    return Math.ceil(Math.log2(e1));
                };
                t.numberToString = function numberToString(e1) {
                    if (Number.isInteger(e1)) return e1.toString();
                    const t = Math.round(100 * e1);
                    if (t % 100 == 0) return (t / 100).toString();
                    if (t % 10 == 0) return e1.toFixed(1);
                    return e1.toFixed(2);
                };
                t.parseXFAPath = function parseXFAPath(e1) {
                    const t = /(.+)\[(\d+)\]$/;
                    return e1.split(".").map((e1)=>{
                        const a = e1.match(t);
                        return a ? {
                            name: a[1],
                            pos: parseInt(a[2], 10)
                        } : {
                            name: e1,
                            pos: 0
                        };
                    });
                };
                t.readInt8 = function readInt8(e1, t) {
                    return e1[t] << 24 >> 24;
                };
                t.readUint16 = function readUint16(e1, t) {
                    return e1[t] << 8 | e1[t + 1];
                };
                t.readUint32 = function readUint32(e1, t) {
                    return (e1[t] << 24 | e1[t + 1] << 16 | e1[t + 2] << 8 | e1[t + 3]) >>> 0;
                };
                t.recoverJsURL = function recoverJsURL(e1) {
                    const t = new RegExp("^\\s*(" + [
                        "app.launchURL",
                        "window.open",
                        "xfa.host.gotoURL"
                    ].join("|").replaceAll(".", "\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i").exec(e1);
                    if (t?.[2]) {
                        const e1 = t[2];
                        let a = !1;
                        "true" === t[3] && "app.launchURL" === t[1] && (a = !0);
                        return {
                            url: e1,
                            newWindow: a
                        };
                    }
                    return null;
                };
                t.stringToUTF16HexString = function stringToUTF16HexString(e1) {
                    const t = [];
                    for(let a = 0, r = e1.length; a < r; a++){
                        const r = e1.charCodeAt(a);
                        t.push((r >> 8 & 255).toString(16).padStart(2, "0"), (255 & r).toString(16).padStart(2, "0"));
                    }
                    return t.join("");
                };
                t.stringToUTF16String = function stringToUTF16String(e1, t = !1) {
                    const a = [];
                    t && a.push("\xfe\xff");
                    for(let t = 0, r = e1.length; t < r; t++){
                        const r = e1.charCodeAt(t);
                        a.push(String.fromCharCode(r >> 8 & 255), String.fromCharCode(255 & r));
                    }
                    return a.join("");
                };
                t.toRomanNumerals = function toRomanNumerals(e1, t = !1) {
                    (0, r.assert)(Number.isInteger(e1) && e1 > 0, "The number should be a positive integer.");
                    const a = [];
                    let n;
                    for(; e1 >= 1e3;){
                        e1 -= 1e3;
                        a.push("M");
                    }
                    n = e1 / 100 | 0;
                    e1 %= 100;
                    a.push(s[n]);
                    n = e1 / 10 | 0;
                    e1 %= 10;
                    a.push(s[10 + n]);
                    a.push(s[20 + e1]);
                    const i = a.join("");
                    return t ? i.toLowerCase() : i;
                };
                t.validateCSSFont = function validateCSSFont(e1) {
                    const t = new Set([
                        "100",
                        "200",
                        "300",
                        "400",
                        "500",
                        "600",
                        "700",
                        "800",
                        "900",
                        "1000",
                        "normal",
                        "bold",
                        "bolder",
                        "lighter"
                    ]), { fontFamily: a, fontWeight: r, italicAngle: n } = e1;
                    if (!validateFontName(a, !0)) return !1;
                    const i = r ? r.toString() : "";
                    e1.fontWeight = t.has(i) ? i : "400";
                    const s = parseFloat(n);
                    e1.italicAngle = isNaN(s) || s < -90 || s > 90 ? "14" : n.toString();
                    return !0;
                };
                t.validateFontName = validateFontName;
                var r = a(2), n = a(4), i = a(5);
                t.PDF_VERSION_REGEXP = /^[1-9]\.\d$/;
                class MissingDataException extends r.BaseException {
                    constructor(e1, t){
                        super(`Missing data [${e1}, ${t})`, "MissingDataException");
                        this.begin = e1;
                        this.end = t;
                    }
                }
                t.MissingDataException = MissingDataException;
                class ParserEOFException extends r.BaseException {
                    constructor(e1){
                        super(e1, "ParserEOFException");
                    }
                }
                t.ParserEOFException = ParserEOFException;
                class XRefEntryException extends r.BaseException {
                    constructor(e1){
                        super(e1, "XRefEntryException");
                    }
                }
                t.XRefEntryException = XRefEntryException;
                class XRefParseException extends r.BaseException {
                    constructor(e1){
                        super(e1, "XRefParseException");
                    }
                }
                t.XRefParseException = XRefParseException;
                function getInheritableProperty({ dict: e1, key: t, getArray: a = !1, stopWhenFound: r = !0 }) {
                    let i;
                    const s = new n.RefSet;
                    for(; e1 instanceof n.Dict && (!e1.objId || !s.has(e1.objId));){
                        e1.objId && s.put(e1.objId);
                        const n = a ? e1.getArray(t) : e1.get(t);
                        if (void 0 !== n) {
                            if (r) return n;
                            (i ||= []).push(n);
                        }
                        e1 = e1.get("Parent");
                    }
                    return i;
                }
                const s = [
                    "",
                    "C",
                    "CC",
                    "CCC",
                    "CD",
                    "D",
                    "DC",
                    "DCC",
                    "DCCC",
                    "CM",
                    "",
                    "X",
                    "XX",
                    "XXX",
                    "XL",
                    "L",
                    "LX",
                    "LXX",
                    "LXXX",
                    "XC",
                    "",
                    "I",
                    "II",
                    "III",
                    "IV",
                    "V",
                    "VI",
                    "VII",
                    "VIII",
                    "IX"
                ];
                function _collectJS(e1, t, a, s) {
                    if (!e1) return;
                    let o = null;
                    if (e1 instanceof n.Ref) {
                        if (s.has(e1)) return;
                        o = e1;
                        s.put(o);
                        e1 = t.fetch(e1);
                    }
                    if (Array.isArray(e1)) for (const r of e1)_collectJS(r, t, a, s);
                    else if (e1 instanceof n.Dict) {
                        if ((0, n.isName)(e1.get("S"), "JavaScript")) {
                            const t = e1.get("JS");
                            let n;
                            t instanceof i.BaseStream ? n = t.getString() : "string" == typeof t && (n = t);
                            n &&= (0, r.stringToPDFString)(n).replaceAll("\0", "");
                            n && a.push(n);
                        }
                        _collectJS(e1.getRaw("Next"), t, a, s);
                    }
                    o && s.remove(o);
                }
                const o = {
                    60: "&lt;",
                    62: "&gt;",
                    38: "&amp;",
                    34: "&quot;",
                    39: "&apos;"
                };
                function validateFontName(e1, t = !1) {
                    const a = /^("|').*("|')$/.exec(e1);
                    if (a && a[1] === a[2]) {
                        if (new RegExp(`[^\\\\]${a[1]}`).test(e1.slice(1, -1))) {
                            t && (0, r.warn)(`FontFamily contains unescaped ${a[1]}: ${e1}.`);
                            return !1;
                        }
                    } else for (const a of e1.split(/[ \t]+/))if (/^(\d|(-(\d|-)))/.test(a) || !/^[\w-\\]+$/.test(a)) {
                        t && (0, r.warn)(`FontFamily contains invalid <custom-ident>: ${e1}.`);
                        return !1;
                    }
                    return !0;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.RefSetCache = t.RefSet = t.Ref = t.Name = t.EOF = t.Dict = t.Cmd = t.CIRCULAR_REF = void 0;
                t.clearPrimitiveCaches = function clearPrimitiveCaches() {
                    s = Object.create(null);
                    o = Object.create(null);
                    c = Object.create(null);
                };
                t.isCmd = function isCmd(e1, t) {
                    return e1 instanceof Cmd && (void 0 === t || e1.cmd === t);
                };
                t.isDict = function isDict(e1, t) {
                    return e1 instanceof Dict && (void 0 === t || isName(e1.get("Type"), t));
                };
                t.isName = isName;
                t.isRefsEqual = function isRefsEqual(e1, t) {
                    return e1.num === t.num && e1.gen === t.gen;
                };
                var r = a(2);
                const n = Symbol("CIRCULAR_REF");
                t.CIRCULAR_REF = n;
                const i = Symbol("EOF");
                t.EOF = i;
                let s = Object.create(null), o = Object.create(null), c = Object.create(null);
                class Name {
                    constructor(e1){
                        this.name = e1;
                    }
                    static get(e1) {
                        return o[e1] ||= new Name(e1);
                    }
                }
                t.Name = Name;
                class Cmd {
                    constructor(e1){
                        this.cmd = e1;
                    }
                    static get(e1) {
                        return s[e1] ||= new Cmd(e1);
                    }
                }
                t.Cmd = Cmd;
                const l = function nonSerializableClosure() {
                    return l;
                };
                class Dict {
                    constructor(e1 = null){
                        this._map = Object.create(null);
                        this.xref = e1;
                        this.objId = null;
                        this.suppressEncryption = !1;
                        this.__nonSerializable__ = l;
                    }
                    assignXref(e1) {
                        this.xref = e1;
                    }
                    get size() {
                        return Object.keys(this._map).length;
                    }
                    get(e1, t, a) {
                        let r = this._map[e1];
                        if (void 0 === r && void 0 !== t) {
                            r = this._map[t];
                            void 0 === r && void 0 !== a && (r = this._map[a]);
                        }
                        return r instanceof Ref && this.xref ? this.xref.fetch(r, this.suppressEncryption) : r;
                    }
                    async getAsync(e1, t, a) {
                        let r = this._map[e1];
                        if (void 0 === r && void 0 !== t) {
                            r = this._map[t];
                            void 0 === r && void 0 !== a && (r = this._map[a]);
                        }
                        return r instanceof Ref && this.xref ? this.xref.fetchAsync(r, this.suppressEncryption) : r;
                    }
                    getArray(e1, t, a) {
                        let r = this._map[e1];
                        if (void 0 === r && void 0 !== t) {
                            r = this._map[t];
                            void 0 === r && void 0 !== a && (r = this._map[a]);
                        }
                        r instanceof Ref && this.xref && (r = this.xref.fetch(r, this.suppressEncryption));
                        if (Array.isArray(r)) {
                            r = r.slice();
                            for(let e1 = 0, t = r.length; e1 < t; e1++)r[e1] instanceof Ref && this.xref && (r[e1] = this.xref.fetch(r[e1], this.suppressEncryption));
                        }
                        return r;
                    }
                    getRaw(e1) {
                        return this._map[e1];
                    }
                    getKeys() {
                        return Object.keys(this._map);
                    }
                    getRawValues() {
                        return Object.values(this._map);
                    }
                    set(e1, t) {
                        this._map[e1] = t;
                    }
                    has(e1) {
                        return void 0 !== this._map[e1];
                    }
                    forEach(e1) {
                        for(const t in this._map)e1(t, this.get(t));
                    }
                    static get empty() {
                        const e1 = new Dict(null);
                        e1.set = (e1, t)=>{
                            (0, r.unreachable)("Should not call `set` on the empty dictionary.");
                        };
                        return (0, r.shadow)(this, "empty", e1);
                    }
                    static merge({ xref: e1, dictArray: t, mergeSubDicts: a = !1 }) {
                        const r = new Dict(e1), n = new Map;
                        for (const e1 of t)if (e1 instanceof Dict) for (const [t, r] of Object.entries(e1._map)){
                            let e1 = n.get(t);
                            if (void 0 === e1) {
                                e1 = [];
                                n.set(t, e1);
                            } else if (!(a && r instanceof Dict)) continue;
                            e1.push(r);
                        }
                        for (const [t, a] of n){
                            if (1 === a.length || !(a[0] instanceof Dict)) {
                                r._map[t] = a[0];
                                continue;
                            }
                            const n = new Dict(e1);
                            for (const e1 of a)for (const [t, a] of Object.entries(e1._map))void 0 === n._map[t] && (n._map[t] = a);
                            n.size > 0 && (r._map[t] = n);
                        }
                        n.clear();
                        return r.size > 0 ? r : Dict.empty;
                    }
                    clone() {
                        const e1 = new Dict(this.xref);
                        for (const t of this.getKeys())e1.set(t, this.getRaw(t));
                        return e1;
                    }
                }
                t.Dict = Dict;
                class Ref {
                    constructor(e1, t){
                        this.num = e1;
                        this.gen = t;
                    }
                    toString() {
                        return 0 === this.gen ? `${this.num}R` : `${this.num}R${this.gen}`;
                    }
                    static fromString(e1) {
                        const t = c[e1];
                        if (t) return t;
                        const a = /^(\d+)R(\d*)$/.exec(e1);
                        return a && "0" !== a[1] ? c[e1] = new Ref(parseInt(a[1]), a[2] ? parseInt(a[2]) : 0) : null;
                    }
                    static get(e1, t) {
                        const a = 0 === t ? `${e1}R` : `${e1}R${t}`;
                        return c[a] ||= new Ref(e1, t);
                    }
                }
                t.Ref = Ref;
                class RefSet {
                    constructor(e1 = null){
                        this._set = new Set(e1?._set);
                    }
                    has(e1) {
                        return this._set.has(e1.toString());
                    }
                    put(e1) {
                        this._set.add(e1.toString());
                    }
                    remove(e1) {
                        this._set.delete(e1.toString());
                    }
                    [Symbol.iterator]() {
                        return this._set.values();
                    }
                    clear() {
                        this._set.clear();
                    }
                }
                t.RefSet = RefSet;
                class RefSetCache {
                    constructor(){
                        this._map = new Map;
                    }
                    get size() {
                        return this._map.size;
                    }
                    get(e1) {
                        return this._map.get(e1.toString());
                    }
                    has(e1) {
                        return this._map.has(e1.toString());
                    }
                    put(e1, t) {
                        this._map.set(e1.toString(), t);
                    }
                    putAlias(e1, t) {
                        this._map.set(e1.toString(), this.get(t));
                    }
                    [Symbol.iterator]() {
                        return this._map.values();
                    }
                    clear() {
                        this._map.clear();
                    }
                }
                t.RefSetCache = RefSetCache;
                function isName(e1, t) {
                    return e1 instanceof Name && (void 0 === t || e1.name === t);
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.BaseStream = void 0;
                var r = a(2);
                class BaseStream {
                    constructor(){
                        this.constructor === BaseStream && (0, r.unreachable)("Cannot initialize BaseStream.");
                    }
                    get length() {
                        (0, r.unreachable)("Abstract getter `length` accessed");
                    }
                    get isEmpty() {
                        (0, r.unreachable)("Abstract getter `isEmpty` accessed");
                    }
                    get isDataLoaded() {
                        return (0, r.shadow)(this, "isDataLoaded", !0);
                    }
                    getByte() {
                        (0, r.unreachable)("Abstract method `getByte` called");
                    }
                    getBytes(e1) {
                        (0, r.unreachable)("Abstract method `getBytes` called");
                    }
                    peekByte() {
                        const e1 = this.getByte();
                        -1 !== e1 && this.pos--;
                        return e1;
                    }
                    peekBytes(e1) {
                        const t = this.getBytes(e1);
                        this.pos -= t.length;
                        return t;
                    }
                    getUint16() {
                        const e1 = this.getByte(), t = this.getByte();
                        return -1 === e1 || -1 === t ? -1 : (e1 << 8) + t;
                    }
                    getInt32() {
                        return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
                    }
                    getByteRange(e1, t) {
                        (0, r.unreachable)("Abstract method `getByteRange` called");
                    }
                    getString(e1) {
                        return (0, r.bytesToString)(this.getBytes(e1));
                    }
                    skip(e1) {
                        this.pos += e1 || 1;
                    }
                    reset() {
                        (0, r.unreachable)("Abstract method `reset` called");
                    }
                    moveStart() {
                        (0, r.unreachable)("Abstract method `moveStart` called");
                    }
                    makeSubStream(e1, t, a = null) {
                        (0, r.unreachable)("Abstract method `makeSubStream` called");
                    }
                    getBaseStreams() {
                        return null;
                    }
                }
                t.BaseStream = BaseStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.NetworkPdfManager = t.LocalPdfManager = void 0;
                var r = a(2), n = a(7), i = a(3), s = a(9), o = a(8);
                class BasePdfManager {
                    constructor(e1){
                        this.constructor === BasePdfManager && (0, r.unreachable)("Cannot initialize BasePdfManager.");
                        this._docBaseUrl = function parseDocBaseUrl(e1) {
                            if (e1) {
                                const t = (0, r.createValidAbsoluteUrl)(e1);
                                if (t) return t.href;
                                (0, r.warn)(`Invalid absolute docBaseUrl: "${e1}".`);
                            }
                            return null;
                        }(e1.docBaseUrl);
                        this._docId = e1.docId;
                        this._password = e1.password;
                        this.enableXfa = e1.enableXfa;
                        e1.evaluatorOptions.isOffscreenCanvasSupported &&= r.FeatureTest.isOffscreenCanvasSupported;
                        this.evaluatorOptions = e1.evaluatorOptions;
                    }
                    get docId() {
                        return this._docId;
                    }
                    get password() {
                        return this._password;
                    }
                    get docBaseUrl() {
                        return this._docBaseUrl;
                    }
                    get catalog() {
                        return this.pdfDocument.catalog;
                    }
                    ensureDoc(e1, t) {
                        return this.ensure(this.pdfDocument, e1, t);
                    }
                    ensureXRef(e1, t) {
                        return this.ensure(this.pdfDocument.xref, e1, t);
                    }
                    ensureCatalog(e1, t) {
                        return this.ensure(this.pdfDocument.catalog, e1, t);
                    }
                    getPage(e1) {
                        return this.pdfDocument.getPage(e1);
                    }
                    fontFallback(e1, t) {
                        return this.pdfDocument.fontFallback(e1, t);
                    }
                    loadXfaFonts(e1, t) {
                        return this.pdfDocument.loadXfaFonts(e1, t);
                    }
                    loadXfaImages() {
                        return this.pdfDocument.loadXfaImages();
                    }
                    serializeXfaData(e1) {
                        return this.pdfDocument.serializeXfaData(e1);
                    }
                    cleanup(e1 = !1) {
                        return this.pdfDocument.cleanup(e1);
                    }
                    async ensure(e1, t, a) {
                        (0, r.unreachable)("Abstract method `ensure` called");
                    }
                    requestRange(e1, t) {
                        (0, r.unreachable)("Abstract method `requestRange` called");
                    }
                    requestLoadedStream(e1 = !1) {
                        (0, r.unreachable)("Abstract method `requestLoadedStream` called");
                    }
                    sendProgressiveData(e1) {
                        (0, r.unreachable)("Abstract method `sendProgressiveData` called");
                    }
                    updatePassword(e1) {
                        this._password = e1;
                    }
                    terminate(e1) {
                        (0, r.unreachable)("Abstract method `terminate` called");
                    }
                }
                t.LocalPdfManager = class LocalPdfManager extends BasePdfManager {
                    constructor(e1){
                        super(e1);
                        const t = new o.Stream(e1.source);
                        this.pdfDocument = new s.PDFDocument(this, t);
                        this._loadedStreamPromise = Promise.resolve(t);
                    }
                    async ensure(e1, t, a) {
                        const r = e1[t];
                        return "function" == typeof r ? r.apply(e1, a) : r;
                    }
                    requestRange(e1, t) {
                        return Promise.resolve();
                    }
                    requestLoadedStream(e1 = !1) {
                        return this._loadedStreamPromise;
                    }
                    terminate(e1) {}
                };
                t.NetworkPdfManager = class NetworkPdfManager extends BasePdfManager {
                    constructor(e1){
                        super(e1);
                        this.streamManager = new n.ChunkedStreamManager(e1.source, {
                            msgHandler: e1.handler,
                            length: e1.length,
                            disableAutoFetch: e1.disableAutoFetch,
                            rangeChunkSize: e1.rangeChunkSize
                        });
                        this.pdfDocument = new s.PDFDocument(this, this.streamManager.getStream());
                    }
                    async ensure(e1, t, a) {
                        try {
                            const r = e1[t];
                            return "function" == typeof r ? r.apply(e1, a) : r;
                        } catch (r) {
                            if (!(r instanceof i.MissingDataException)) throw r;
                            await this.requestRange(r.begin, r.end);
                            return this.ensure(e1, t, a);
                        }
                    }
                    requestRange(e1, t) {
                        return this.streamManager.requestRange(e1, t);
                    }
                    requestLoadedStream(e1 = !1) {
                        return this.streamManager.requestAllChunks(e1);
                    }
                    sendProgressiveData(e1) {
                        this.streamManager.onReceiveData({
                            chunk: e1
                        });
                    }
                    terminate(e1) {
                        this.streamManager.abort(e1);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ChunkedStreamManager = t.ChunkedStream = void 0;
                var r = a(3), n = a(2), i = a(8);
                class ChunkedStream extends i.Stream {
                    constructor(e1, t, a){
                        super(new Uint8Array(e1), 0, e1, null);
                        this.chunkSize = t;
                        this._loadedChunks = new Set;
                        this.numChunks = Math.ceil(e1 / t);
                        this.manager = a;
                        this.progressiveDataLength = 0;
                        this.lastSuccessfulEnsureByteChunk = -1;
                    }
                    getMissingChunks() {
                        const e1 = [];
                        for(let t = 0, a = this.numChunks; t < a; ++t)this._loadedChunks.has(t) || e1.push(t);
                        return e1;
                    }
                    get numChunksLoaded() {
                        return this._loadedChunks.size;
                    }
                    get isDataLoaded() {
                        return this.numChunksLoaded === this.numChunks;
                    }
                    onReceiveData(e1, t) {
                        const a = this.chunkSize;
                        if (e1 % a != 0) throw new Error(`Bad begin offset: ${e1}`);
                        const r = e1 + t.byteLength;
                        if (r % a != 0 && r !== this.bytes.length) throw new Error(`Bad end offset: ${r}`);
                        this.bytes.set(new Uint8Array(t), e1);
                        const n = Math.floor(e1 / a), i = Math.floor((r - 1) / a) + 1;
                        for(let e1 = n; e1 < i; ++e1)this._loadedChunks.add(e1);
                    }
                    onReceiveProgressiveData(e1) {
                        let t = this.progressiveDataLength;
                        const a = Math.floor(t / this.chunkSize);
                        this.bytes.set(new Uint8Array(e1), t);
                        t += e1.byteLength;
                        this.progressiveDataLength = t;
                        const r = t >= this.end ? this.numChunks : Math.floor(t / this.chunkSize);
                        for(let e1 = a; e1 < r; ++e1)this._loadedChunks.add(e1);
                    }
                    ensureByte(e1) {
                        if (e1 < this.progressiveDataLength) return;
                        const t = Math.floor(e1 / this.chunkSize);
                        if (!(t > this.numChunks) && t !== this.lastSuccessfulEnsureByteChunk) {
                            if (!this._loadedChunks.has(t)) throw new r.MissingDataException(e1, e1 + 1);
                            this.lastSuccessfulEnsureByteChunk = t;
                        }
                    }
                    ensureRange(e1, t) {
                        if (e1 >= t) return;
                        if (t <= this.progressiveDataLength) return;
                        const a = Math.floor(e1 / this.chunkSize);
                        if (a > this.numChunks) return;
                        const n = Math.min(Math.floor((t - 1) / this.chunkSize) + 1, this.numChunks);
                        for(let i = a; i < n; ++i)if (!this._loadedChunks.has(i)) throw new r.MissingDataException(e1, t);
                    }
                    nextEmptyChunk(e1) {
                        const t = this.numChunks;
                        for(let a = 0; a < t; ++a){
                            const r = (e1 + a) % t;
                            if (!this._loadedChunks.has(r)) return r;
                        }
                        return null;
                    }
                    hasChunk(e1) {
                        return this._loadedChunks.has(e1);
                    }
                    getByte() {
                        const e1 = this.pos;
                        if (e1 >= this.end) return -1;
                        e1 >= this.progressiveDataLength && this.ensureByte(e1);
                        return this.bytes[this.pos++];
                    }
                    getBytes(e1) {
                        const t = this.bytes, a = this.pos, r = this.end;
                        if (!e1) {
                            r > this.progressiveDataLength && this.ensureRange(a, r);
                            return t.subarray(a, r);
                        }
                        let n = a + e1;
                        n > r && (n = r);
                        n > this.progressiveDataLength && this.ensureRange(a, n);
                        this.pos = n;
                        return t.subarray(a, n);
                    }
                    getByteRange(e1, t) {
                        e1 < 0 && (e1 = 0);
                        t > this.end && (t = this.end);
                        t > this.progressiveDataLength && this.ensureRange(e1, t);
                        return this.bytes.subarray(e1, t);
                    }
                    makeSubStream(e1, t, a = null) {
                        t ? e1 + t > this.progressiveDataLength && this.ensureRange(e1, e1 + t) : e1 >= this.progressiveDataLength && this.ensureByte(e1);
                        function ChunkedStreamSubstream() {}
                        ChunkedStreamSubstream.prototype = Object.create(this);
                        ChunkedStreamSubstream.prototype.getMissingChunks = function() {
                            const e1 = this.chunkSize, t = Math.floor(this.start / e1), a = Math.floor((this.end - 1) / e1) + 1, r = [];
                            for(let e1 = t; e1 < a; ++e1)this._loadedChunks.has(e1) || r.push(e1);
                            return r;
                        };
                        Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
                            get () {
                                return this.numChunksLoaded === this.numChunks || 0 === this.getMissingChunks().length;
                            },
                            configurable: !0
                        });
                        const r = new ChunkedStreamSubstream;
                        r.pos = r.start = e1;
                        r.end = e1 + t || this.end;
                        r.dict = a;
                        return r;
                    }
                    getBaseStreams() {
                        return [
                            this
                        ];
                    }
                }
                t.ChunkedStream = ChunkedStream;
                t.ChunkedStreamManager = class ChunkedStreamManager {
                    constructor(e1, t){
                        this.length = t.length;
                        this.chunkSize = t.rangeChunkSize;
                        this.stream = new ChunkedStream(this.length, this.chunkSize, this);
                        this.pdfNetworkStream = e1;
                        this.disableAutoFetch = t.disableAutoFetch;
                        this.msgHandler = t.msgHandler;
                        this.currRequestId = 0;
                        this._chunksNeededByRequest = new Map;
                        this._requestsByChunk = new Map;
                        this._promisesByRequest = new Map;
                        this.progressiveDataLength = 0;
                        this.aborted = !1;
                        this._loadedStreamCapability = new n.PromiseCapability;
                    }
                    sendRequest(e1, t) {
                        const a = this.pdfNetworkStream.getRangeReader(e1, t);
                        a.isStreamingSupported || (a.onProgress = this.onProgress.bind(this));
                        let n = [], i = 0;
                        return new Promise((e1, t)=>{
                            const readChunk = ({ value: s, done: o })=>{
                                try {
                                    if (o) {
                                        const t = (0, r.arrayBuffersToBytes)(n);
                                        n = null;
                                        e1(t);
                                        return;
                                    }
                                    i += s.byteLength;
                                    a.isStreamingSupported && this.onProgress({
                                        loaded: i
                                    });
                                    n.push(s);
                                    a.read().then(readChunk, t);
                                } catch (e1) {
                                    t(e1);
                                }
                            };
                            a.read().then(readChunk, t);
                        }).then((t)=>{
                            this.aborted || this.onReceiveData({
                                chunk: t,
                                begin: e1
                            });
                        });
                    }
                    requestAllChunks(e1 = !1) {
                        if (!e1) {
                            const e1 = this.stream.getMissingChunks();
                            this._requestChunks(e1);
                        }
                        return this._loadedStreamCapability.promise;
                    }
                    _requestChunks(e1) {
                        const t = this.currRequestId++, a = new Set;
                        this._chunksNeededByRequest.set(t, a);
                        for (const t of e1)this.stream.hasChunk(t) || a.add(t);
                        if (0 === a.size) return Promise.resolve();
                        const r = new n.PromiseCapability;
                        this._promisesByRequest.set(t, r);
                        const i = [];
                        for (const e1 of a){
                            let a = this._requestsByChunk.get(e1);
                            if (!a) {
                                a = [];
                                this._requestsByChunk.set(e1, a);
                                i.push(e1);
                            }
                            a.push(t);
                        }
                        if (i.length > 0) {
                            const e1 = this.groupChunks(i);
                            for (const t of e1){
                                const e1 = t.beginChunk * this.chunkSize, a = Math.min(t.endChunk * this.chunkSize, this.length);
                                this.sendRequest(e1, a).catch(r.reject);
                            }
                        }
                        return r.promise.catch((e1)=>{
                            if (!this.aborted) throw e1;
                        });
                    }
                    getStream() {
                        return this.stream;
                    }
                    requestRange(e1, t) {
                        t = Math.min(t, this.length);
                        const a = this.getBeginChunk(e1), r = this.getEndChunk(t), n = [];
                        for(let e1 = a; e1 < r; ++e1)n.push(e1);
                        return this._requestChunks(n);
                    }
                    requestRanges(e1 = []) {
                        const t = [];
                        for (const a of e1){
                            const e1 = this.getBeginChunk(a.begin), r = this.getEndChunk(a.end);
                            for(let a = e1; a < r; ++a)t.includes(a) || t.push(a);
                        }
                        t.sort(function(e1, t) {
                            return e1 - t;
                        });
                        return this._requestChunks(t);
                    }
                    groupChunks(e1) {
                        const t = [];
                        let a = -1, r = -1;
                        for(let n = 0, i = e1.length; n < i; ++n){
                            const i = e1[n];
                            a < 0 && (a = i);
                            if (r >= 0 && r + 1 !== i) {
                                t.push({
                                    beginChunk: a,
                                    endChunk: r + 1
                                });
                                a = i;
                            }
                            n + 1 === e1.length && t.push({
                                beginChunk: a,
                                endChunk: i + 1
                            });
                            r = i;
                        }
                        return t;
                    }
                    onProgress(e1) {
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize + e1.loaded,
                            total: this.length
                        });
                    }
                    onReceiveData(e1) {
                        const t = e1.chunk, a = void 0 === e1.begin, r = a ? this.progressiveDataLength : e1.begin, n = r + t.byteLength, i = Math.floor(r / this.chunkSize), s = n < this.length ? Math.floor(n / this.chunkSize) : Math.ceil(n / this.chunkSize);
                        if (a) {
                            this.stream.onReceiveProgressiveData(t);
                            this.progressiveDataLength = n;
                        } else this.stream.onReceiveData(r, t);
                        this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
                        const o = [];
                        for(let e1 = i; e1 < s; ++e1){
                            const t = this._requestsByChunk.get(e1);
                            if (t) {
                                this._requestsByChunk.delete(e1);
                                for (const a of t){
                                    const t = this._chunksNeededByRequest.get(a);
                                    t.has(e1) && t.delete(e1);
                                    t.size > 0 || o.push(a);
                                }
                            }
                        }
                        if (!this.disableAutoFetch && 0 === this._requestsByChunk.size) {
                            let e1;
                            if (1 === this.stream.numChunksLoaded) {
                                const t = this.stream.numChunks - 1;
                                this.stream.hasChunk(t) || (e1 = t);
                            } else e1 = this.stream.nextEmptyChunk(s);
                            Number.isInteger(e1) && this._requestChunks([
                                e1
                            ]);
                        }
                        for (const e1 of o){
                            const t = this._promisesByRequest.get(e1);
                            this._promisesByRequest.delete(e1);
                            t.resolve();
                        }
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize,
                            total: this.length
                        });
                    }
                    onError(e1) {
                        this._loadedStreamCapability.reject(e1);
                    }
                    getBeginChunk(e1) {
                        return Math.floor(e1 / this.chunkSize);
                    }
                    getEndChunk(e1) {
                        return Math.floor((e1 - 1) / this.chunkSize) + 1;
                    }
                    abort(e1) {
                        this.aborted = !0;
                        this.pdfNetworkStream?.cancelAllRequests(e1);
                        for (const t of this._promisesByRequest.values())t.reject(e1);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.StringStream = t.Stream = t.NullStream = void 0;
                var r = a(5), n = a(2);
                class Stream extends r.BaseStream {
                    constructor(e1, t, a, r){
                        super();
                        this.bytes = e1 instanceof Uint8Array ? e1 : new Uint8Array(e1);
                        this.start = t || 0;
                        this.pos = this.start;
                        this.end = t + a || this.bytes.length;
                        this.dict = r;
                    }
                    get length() {
                        return this.end - this.start;
                    }
                    get isEmpty() {
                        return 0 === this.length;
                    }
                    getByte() {
                        return this.pos >= this.end ? -1 : this.bytes[this.pos++];
                    }
                    getBytes(e1) {
                        const t = this.bytes, a = this.pos, r = this.end;
                        if (!e1) return t.subarray(a, r);
                        let n = a + e1;
                        n > r && (n = r);
                        this.pos = n;
                        return t.subarray(a, n);
                    }
                    getByteRange(e1, t) {
                        e1 < 0 && (e1 = 0);
                        t > this.end && (t = this.end);
                        return this.bytes.subarray(e1, t);
                    }
                    reset() {
                        this.pos = this.start;
                    }
                    moveStart() {
                        this.start = this.pos;
                    }
                    makeSubStream(e1, t, a = null) {
                        return new Stream(this.bytes.buffer, e1, t, a);
                    }
                }
                t.Stream = Stream;
                t.StringStream = class StringStream extends Stream {
                    constructor(e1){
                        super((0, n.stringToBytes)(e1));
                    }
                };
                t.NullStream = class NullStream extends Stream {
                    constructor(){
                        super(new Uint8Array(0));
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Page = t.PDFDocument = void 0;
                var r = a(2), n = a(10), i = a(3), s = a(4), o = a(51), c = a(5), l = a(74), h = a(66), u = a(68), d = a(102), f = a(16), g = a(8), p = a(76), m = a(64), b = a(13), y = a(18), w = a(72), S = a(73), x = a(77), C = a(103);
                const k = [
                    0,
                    0,
                    612,
                    792
                ];
                class Page {
                    constructor({ pdfManager: e1, xref: t, pageIndex: a, pageDict: r, ref: n, globalIdFactory: i, fontCache: s, builtInCMapCache: o, standardFontDataCache: c, globalImageCache: l, systemFontCache: h, nonBlendModesSet: u, xfaFactory: d }){
                        this.pdfManager = e1;
                        this.pageIndex = a;
                        this.pageDict = r;
                        this.xref = t;
                        this.ref = n;
                        this.fontCache = s;
                        this.builtInCMapCache = o;
                        this.standardFontDataCache = c;
                        this.globalImageCache = l;
                        this.systemFontCache = h;
                        this.nonBlendModesSet = u;
                        this.evaluatorOptions = e1.evaluatorOptions;
                        this.resourcesPromise = null;
                        this.xfaFactory = d;
                        const f = {
                            obj: 0
                        };
                        this._localIdFactory = class extends i {
                            static createObjId() {
                                return `p${a}_${++f.obj}`;
                            }
                            static getPageObjId() {
                                return `p${n.toString()}`;
                            }
                        };
                    }
                    _getInheritableProperty(e1, t = !1) {
                        const a = (0, i.getInheritableProperty)({
                            dict: this.pageDict,
                            key: e1,
                            getArray: t,
                            stopWhenFound: !1
                        });
                        return Array.isArray(a) ? 1 !== a.length && a[0] instanceof s.Dict ? s.Dict.merge({
                            xref: this.xref,
                            dictArray: a
                        }) : a[0] : a;
                    }
                    get content() {
                        return this.pageDict.getArray("Contents");
                    }
                    get resources() {
                        const e1 = this._getInheritableProperty("Resources");
                        return (0, r.shadow)(this, "resources", e1 instanceof s.Dict ? e1 : s.Dict.empty);
                    }
                    _getBoundingBox(e1) {
                        if (this.xfaData) return this.xfaData.bbox;
                        let t = this._getInheritableProperty(e1, !0);
                        if (Array.isArray(t) && 4 === t.length) {
                            t = r.Util.normalizeRect(t);
                            if (t[2] - t[0] > 0 && t[3] - t[1] > 0) return t;
                            (0, r.warn)(`Empty, or invalid, /${e1} entry.`);
                        }
                        return null;
                    }
                    get mediaBox() {
                        return (0, r.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || k);
                    }
                    get cropBox() {
                        return (0, r.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
                    }
                    get userUnit() {
                        let e1 = this.pageDict.get("UserUnit");
                        ("number" != typeof e1 || e1 <= 0) && (e1 = 1);
                        return (0, r.shadow)(this, "userUnit", e1);
                    }
                    get view() {
                        const { cropBox: e1, mediaBox: t } = this;
                        if (e1 !== t && !(0, r.isArrayEqual)(e1, t)) {
                            const a = r.Util.intersect(e1, t);
                            if (a && a[2] - a[0] > 0 && a[3] - a[1] > 0) return (0, r.shadow)(this, "view", a);
                            (0, r.warn)("Empty /CropBox and /MediaBox intersection.");
                        }
                        return (0, r.shadow)(this, "view", t);
                    }
                    get rotate() {
                        let e1 = this._getInheritableProperty("Rotate") || 0;
                        e1 % 90 != 0 ? e1 = 0 : e1 >= 360 ? e1 %= 360 : e1 < 0 && (e1 = (e1 % 360 + 360) % 360);
                        return (0, r.shadow)(this, "rotate", e1);
                    }
                    _onSubStreamError(e1, t) {
                        if (!this.evaluatorOptions.ignoreErrors) throw e1;
                        (0, r.warn)(`getContentStream - ignoring sub-stream (${t}): "${e1}".`);
                    }
                    getContentStream() {
                        return this.pdfManager.ensure(this, "content").then((e1)=>e1 instanceof c.BaseStream ? e1 : Array.isArray(e1) ? new y.StreamsSequenceStream(e1, this._onSubStreamError.bind(this)) : new g.NullStream);
                    }
                    get xfaData() {
                        return (0, r.shadow)(this, "xfaData", this.xfaFactory ? {
                            bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                        } : null);
                    }
                    #t(e1, t, a) {
                        for (const n of e1)if (n.id) {
                            const e1 = s.Ref.fromString(n.id);
                            if (!e1) {
                                (0, r.warn)(`A non-linked annotation cannot be modified: ${n.id}`);
                                continue;
                            }
                            if (n.deleted) {
                                t.put(e1);
                                continue;
                            }
                            a?.put(e1);
                            n.ref = e1;
                            delete n.id;
                        }
                    }
                    async saveNewAnnotations(e1, t, a, r) {
                        if (this.xfaFactory) throw new Error("XFA: Cannot save new annotations.");
                        const i = new b.PartialEvaluator({
                            xref: this.xref,
                            handler: e1,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        }), o = new s.RefSet, c = new s.RefSet;
                        this.#t(a, o, c);
                        const l = this.pageDict, h = this.annotations.filter((e1)=>!(e1 instanceof s.Ref && o.has(e1))), u = await n.AnnotationFactory.saveNewAnnotations(i, t, a, r);
                        for (const { ref: e1 } of u.annotations)e1 instanceof s.Ref && !c.has(e1) && h.push(e1);
                        const d = l.get("Annots");
                        l.set("Annots", h);
                        const f = [];
                        await (0, S.writeObject)(this.ref, l, f, this.xref);
                        d && l.set("Annots", d);
                        const g = u.dependencies;
                        g.push({
                            ref: this.ref,
                            data: f.join("")
                        }, ...u.annotations);
                        return g;
                    }
                    save(e1, t, a) {
                        const n = new b.PartialEvaluator({
                            xref: this.xref,
                            handler: e1,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        return this._parsedAnnotations.then(function(e1) {
                            const i = [];
                            for (const s of e1)s.mustBePrinted(a) && i.push(s.save(n, t, a).catch(function(e1) {
                                (0, r.warn)(`save - ignoring annotation data during "${t.name}" task: "${e1}".`);
                                return null;
                            }));
                            return Promise.all(i).then(function(e1) {
                                return e1.filter((e1)=>!!e1);
                            });
                        });
                    }
                    loadResources(e1) {
                        this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources"));
                        return this.resourcesPromise.then(()=>new p.ObjectLoader(this.resources, e1, this.xref).load());
                    }
                    getOperatorList({ handler: e1, sink: t, task: a, intent: o, cacheKey: c, annotationStorage: l = null }) {
                        const h = this.getContentStream(), u = this.loadResources([
                            "ColorSpace",
                            "ExtGState",
                            "Font",
                            "Pattern",
                            "Properties",
                            "Shading",
                            "XObject"
                        ]), d = new b.PartialEvaluator({
                            xref: this.xref,
                            handler: e1,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        }), f = this.xfaFactory ? null : (0, i.getNewAnnotationsMap)(l);
                        let g = null, p = Promise.resolve(null);
                        if (f) {
                            const e1 = f.get(this.pageIndex);
                            if (e1) {
                                const t = this.pdfManager.ensureDoc("annotationGlobals");
                                let i;
                                const o = new Set;
                                for (const { bitmapId: t, bitmap: a } of e1)!t || a || o.has(t) || o.add(t);
                                const { isOffscreenCanvasSupported: c } = this.evaluatorOptions;
                                if (o.size > 0) {
                                    const t = e1.slice();
                                    for (const [e1, a] of l)e1.startsWith(r.AnnotationEditorPrefix) && a.bitmap && o.has(a.bitmapId) && t.push(a);
                                    i = n.AnnotationFactory.generateImages(t, this.xref, c);
                                } else i = n.AnnotationFactory.generateImages(e1, this.xref, c);
                                g = new s.RefSet;
                                this.#t(e1, g, null);
                                p = t.then((t)=>t ? n.AnnotationFactory.printNewAnnotations(t, d, a, e1, i) : null);
                            }
                        }
                        const y = Promise.all([
                            h,
                            u
                        ]).then(([r])=>{
                            const n = new m.OperatorList(o, t);
                            e1.send("StartRenderPage", {
                                transparency: d.hasBlendModes(this.resources, this.nonBlendModesSet),
                                pageIndex: this.pageIndex,
                                cacheKey: c
                            });
                            return d.getOperatorList({
                                stream: r,
                                task: a,
                                resources: this.resources,
                                operatorList: n
                            }).then(function() {
                                return n;
                            });
                        });
                        return Promise.all([
                            y,
                            this._parsedAnnotations,
                            p
                        ]).then(function([e1, t, n]) {
                            if (n) {
                                t = t.filter((e1)=>!(e1.ref && g.has(e1.ref)));
                                for(let e1 = 0, a = n.length; e1 < a; e1++){
                                    const r = n[e1];
                                    if (r.refToReplace) {
                                        const i = t.findIndex((e1)=>e1.ref && (0, s.isRefsEqual)(e1.ref, r.refToReplace));
                                        if (i >= 0) {
                                            t.splice(i, 1, r);
                                            n.splice(e1--, 1);
                                            a--;
                                        }
                                    }
                                }
                                t = t.concat(n);
                            }
                            if (0 === t.length || o & r.RenderingIntentFlag.ANNOTATIONS_DISABLE) {
                                e1.flush(!0);
                                return {
                                    length: e1.totalLength
                                };
                            }
                            const i = !!(o & r.RenderingIntentFlag.ANNOTATIONS_FORMS), c = !!(o & r.RenderingIntentFlag.ANY), h = !!(o & r.RenderingIntentFlag.DISPLAY), u = !!(o & r.RenderingIntentFlag.PRINT), f = [];
                            for (const e1 of t)(c || h && e1.mustBeViewed(l, i) || u && e1.mustBePrinted(l)) && f.push(e1.getOperatorList(d, a, o, i, l).catch(function(e1) {
                                (0, r.warn)(`getOperatorList - ignoring annotation data during "${a.name}" task: "${e1}".`);
                                return {
                                    opList: null,
                                    separateForm: !1,
                                    separateCanvas: !1
                                };
                            }));
                            return Promise.all(f).then(function(t) {
                                let a = !1, r = !1;
                                for (const { opList: n, separateForm: i, separateCanvas: s } of t){
                                    e1.addOpList(n);
                                    a ||= i;
                                    r ||= s;
                                }
                                e1.flush(!0, {
                                    form: a,
                                    canvas: r
                                });
                                return {
                                    length: e1.totalLength
                                };
                            });
                        });
                    }
                    extractTextContent({ handler: e1, task: t, includeMarkedContent: a, disableNormalization: r, sink: n }) {
                        const i = this.getContentStream(), s = this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ]);
                        return Promise.all([
                            i,
                            s
                        ]).then(([i])=>new b.PartialEvaluator({
                                xref: this.xref,
                                handler: e1,
                                pageIndex: this.pageIndex,
                                idFactory: this._localIdFactory,
                                fontCache: this.fontCache,
                                builtInCMapCache: this.builtInCMapCache,
                                standardFontDataCache: this.standardFontDataCache,
                                globalImageCache: this.globalImageCache,
                                systemFontCache: this.systemFontCache,
                                options: this.evaluatorOptions
                            }).getTextContent({
                                stream: i,
                                task: t,
                                resources: this.resources,
                                includeMarkedContent: a,
                                disableNormalization: r,
                                sink: n,
                                viewBox: this.view
                            }));
                    }
                    async getStructTree() {
                        const e1 = await this.pdfManager.ensureCatalog("structTreeRoot");
                        if (!e1) return null;
                        await this._parsedAnnotations;
                        return (await this.pdfManager.ensure(this, "_parseStructTree", [
                            e1
                        ])).serializable;
                    }
                    _parseStructTree(e1) {
                        const t = new w.StructTreePage(e1, this.pageDict);
                        t.parse(this.ref);
                        return t;
                    }
                    async getAnnotationsData(e1, t, a) {
                        const n = await this._parsedAnnotations;
                        if (0 === n.length) return n;
                        const i = [], s = [];
                        let o;
                        const c = !!(a & r.RenderingIntentFlag.ANY), l = !!(a & r.RenderingIntentFlag.DISPLAY), h = !!(a & r.RenderingIntentFlag.PRINT);
                        for (const a of n){
                            const n = c || l && a.viewable;
                            (n || h && a.printable) && i.push(a.data);
                            if (a.hasTextContent && n) {
                                o ||= new b.PartialEvaluator({
                                    xref: this.xref,
                                    handler: e1,
                                    pageIndex: this.pageIndex,
                                    idFactory: this._localIdFactory,
                                    fontCache: this.fontCache,
                                    builtInCMapCache: this.builtInCMapCache,
                                    standardFontDataCache: this.standardFontDataCache,
                                    globalImageCache: this.globalImageCache,
                                    systemFontCache: this.systemFontCache,
                                    options: this.evaluatorOptions
                                });
                                s.push(a.extractTextContent(o, t, [
                                    -1 / 0,
                                    -1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]).catch(function(e1) {
                                    (0, r.warn)(`getAnnotationsData - ignoring textContent during "${t.name}" task: "${e1}".`);
                                }));
                            }
                        }
                        await Promise.all(s);
                        return i;
                    }
                    get annotations() {
                        const e1 = this._getInheritableProperty("Annots");
                        return (0, r.shadow)(this, "annotations", Array.isArray(e1) ? e1 : []);
                    }
                    get _parsedAnnotations() {
                        const e1 = this.pdfManager.ensure(this, "annotations").then(async (e1)=>{
                            if (0 === e1.length) return e1;
                            const t = await this.pdfManager.ensureDoc("annotationGlobals");
                            if (!t) return [];
                            const a = [];
                            for (const i of e1)a.push(n.AnnotationFactory.create(this.xref, i, t, this._localIdFactory, !1, this.ref).catch(function(e1) {
                                (0, r.warn)(`_parsedAnnotations: "${e1}".`);
                                return null;
                            }));
                            const i = [];
                            let s;
                            for (const e1 of (await Promise.all(a)))e1 && (e1 instanceof n.PopupAnnotation ? (s ||= []).push(e1) : i.push(e1));
                            s && i.push(...s);
                            return i;
                        });
                        return (0, r.shadow)(this, "_parsedAnnotations", e1);
                    }
                    get jsActions() {
                        const e1 = (0, i.collectActions)(this.xref, this.pageDict, r.PageActionEventType);
                        return (0, r.shadow)(this, "jsActions", e1);
                    }
                }
                t.Page = Page;
                const v = new Uint8Array([
                    37,
                    80,
                    68,
                    70,
                    45
                ]), F = new Uint8Array([
                    115,
                    116,
                    97,
                    114,
                    116,
                    120,
                    114,
                    101,
                    102
                ]), O = new Uint8Array([
                    101,
                    110,
                    100,
                    111,
                    98,
                    106
                ]);
                function find(e1, t, a = 1024, r = !1) {
                    const n = t.length, i = e1.peekBytes(a), s = i.length - n;
                    if (s <= 0) return !1;
                    if (r) {
                        const a = n - 1;
                        let r = i.length - 1;
                        for(; r >= a;){
                            let s = 0;
                            for(; s < n && i[r - s] === t[a - s];)s++;
                            if (s >= n) {
                                e1.pos += r - a;
                                return !0;
                            }
                            r--;
                        }
                    } else {
                        let a = 0;
                        for(; a <= s;){
                            let r = 0;
                            for(; r < n && i[a + r] === t[r];)r++;
                            if (r >= n) {
                                e1.pos += a;
                                return !0;
                            }
                            a++;
                        }
                    }
                    return !1;
                }
                t.PDFDocument = class PDFDocument {
                    constructor(e1, t){
                        if (t.length <= 0) throw new r.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                        this.pdfManager = e1;
                        this.stream = t;
                        this.xref = new C.XRef(t, e1);
                        this._pagePromises = new Map;
                        this._version = null;
                        const a = {
                            font: 0
                        };
                        this._globalIdFactory = class {
                            static getDocId() {
                                return `g_${e1.docId}`;
                            }
                            static createFontId() {
                                return "f" + ++a.font;
                            }
                            static createObjId() {
                                (0, r.unreachable)("Abstract method `createObjId` called.");
                            }
                            static getPageObjId() {
                                (0, r.unreachable)("Abstract method `getPageObjId` called.");
                            }
                        };
                    }
                    parse(e1) {
                        this.xref.parse(e1);
                        this.catalog = new h.Catalog(this.pdfManager, this.xref);
                    }
                    get linearization() {
                        let e1 = null;
                        try {
                            e1 = f.Linearization.create(this.stream);
                        } catch (e1) {
                            if (e1 instanceof i.MissingDataException) throw e1;
                            (0, r.info)(e1);
                        }
                        return (0, r.shadow)(this, "linearization", e1);
                    }
                    get startXRef() {
                        const e1 = this.stream;
                        let t = 0;
                        if (this.linearization) {
                            e1.reset();
                            find(e1, O) && (t = e1.pos + 6 - e1.start);
                        } else {
                            const a = 1024, r = F.length;
                            let n = !1, s = e1.end;
                            for(; !n && s > 0;){
                                s -= a - r;
                                s < 0 && (s = 0);
                                e1.pos = s;
                                n = find(e1, F, a, !0);
                            }
                            if (n) {
                                e1.skip(9);
                                let a;
                                do a = e1.getByte();
                                while ((0, i.isWhiteSpace)(a));
                                let r = "";
                                for(; a >= 32 && a <= 57;){
                                    r += String.fromCharCode(a);
                                    a = e1.getByte();
                                }
                                t = parseInt(r, 10);
                                isNaN(t) && (t = 0);
                            }
                        }
                        return (0, r.shadow)(this, "startXRef", t);
                    }
                    checkHeader() {
                        const e1 = this.stream;
                        e1.reset();
                        if (!find(e1, v)) return;
                        e1.moveStart();
                        e1.skip(v.length);
                        let t, a = "";
                        for(; (t = e1.getByte()) > 32 && a.length < 7;)a += String.fromCharCode(t);
                        i.PDF_VERSION_REGEXP.test(a) ? this._version = a : (0, r.warn)(`Invalid PDF header version: ${a}`);
                    }
                    parseStartXRef() {
                        this.xref.setStartXRef(this.startXRef);
                    }
                    get numPages() {
                        let e1 = 0;
                        e1 = this.catalog.hasActualNumPages ? this.catalog.numPages : this.xfaFactory ? this.xfaFactory.getNumPages() : this.linearization ? this.linearization.numPages : this.catalog.numPages;
                        return (0, r.shadow)(this, "numPages", e1);
                    }
                    _hasOnlyDocumentSignatures(e1, t = 0) {
                        return !!Array.isArray(e1) && e1.every((e1)=>{
                            if (!((e1 = this.xref.fetchIfRef(e1)) instanceof s.Dict)) return !1;
                            if (e1.has("Kids")) {
                                if (++t > 10) {
                                    (0, r.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached");
                                    return !1;
                                }
                                return this._hasOnlyDocumentSignatures(e1.get("Kids"), t);
                            }
                            const a = (0, s.isName)(e1.get("FT"), "Sig"), n = e1.get("Rect"), i = Array.isArray(n) && n.every((e1)=>0 === e1);
                            return a && i;
                        });
                    }
                    get _xfaStreams() {
                        const e1 = this.catalog.acroForm;
                        if (!e1) return null;
                        const t = e1.get("XFA"), a = {
                            "xdp:xdp": "",
                            template: "",
                            datasets: "",
                            config: "",
                            connectionSet: "",
                            localeSet: "",
                            stylesheet: "",
                            "/xdp:xdp": ""
                        };
                        if (t instanceof c.BaseStream && !t.isEmpty) {
                            a["xdp:xdp"] = t;
                            return a;
                        }
                        if (!Array.isArray(t) || 0 === t.length) return null;
                        for(let e1 = 0, r = t.length; e1 < r; e1 += 2){
                            let n;
                            n = 0 === e1 ? "xdp:xdp" : e1 === r - 2 ? "/xdp:xdp" : t[e1];
                            if (!a.hasOwnProperty(n)) continue;
                            const i = this.xref.fetchIfRef(t[e1 + 1]);
                            i instanceof c.BaseStream && !i.isEmpty && (a[n] = i);
                        }
                        return a;
                    }
                    get xfaDatasets() {
                        const e1 = this._xfaStreams;
                        if (!e1) return (0, r.shadow)(this, "xfaDatasets", null);
                        for (const t of [
                            "datasets",
                            "xdp:xdp"
                        ]){
                            const a = e1[t];
                            if (a) try {
                                const e1 = {
                                    [t]: (0, r.stringToUTF8String)(a.getString())
                                };
                                return (0, r.shadow)(this, "xfaDatasets", new d.DatasetReader(e1));
                            } catch  {
                                (0, r.warn)("XFA - Invalid utf-8 string.");
                                break;
                            }
                        }
                        return (0, r.shadow)(this, "xfaDatasets", null);
                    }
                    get xfaData() {
                        const e1 = this._xfaStreams;
                        if (!e1) return null;
                        const t = Object.create(null);
                        for (const [a, n] of Object.entries(e1))if (n) try {
                            t[a] = (0, r.stringToUTF8String)(n.getString());
                        } catch  {
                            (0, r.warn)("XFA - Invalid utf-8 string.");
                            return null;
                        }
                        return t;
                    }
                    get xfaFactory() {
                        let e1;
                        this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && (e1 = this.xfaData);
                        return (0, r.shadow)(this, "xfaFactory", e1 ? new x.XFAFactory(e1) : null);
                    }
                    get isPureXfa() {
                        return !!this.xfaFactory && this.xfaFactory.isValid();
                    }
                    get htmlForXfa() {
                        return this.xfaFactory ? this.xfaFactory.getPages() : null;
                    }
                    async loadXfaImages() {
                        const e1 = await this.pdfManager.ensureCatalog("xfaImages");
                        if (!e1) return;
                        const t = e1.getKeys(), a = new p.ObjectLoader(e1, t, this.xref);
                        await a.load();
                        const r = new Map;
                        for (const a of t){
                            const t = e1.get(a);
                            t instanceof c.BaseStream && r.set(a, t.getBytes());
                        }
                        this.xfaFactory.setImages(r);
                    }
                    async loadXfaFonts(e1, t) {
                        const a = await this.pdfManager.ensureCatalog("acroForm");
                        if (!a) return;
                        const n = await a.getAsync("DR");
                        if (!(n instanceof s.Dict)) return;
                        const c = new p.ObjectLoader(n, [
                            "Font"
                        ], this.xref);
                        await c.load();
                        const l = n.get("Font");
                        if (!(l instanceof s.Dict)) return;
                        const h = Object.assign(Object.create(null), this.pdfManager.evaluatorOptions);
                        h.useSystemFonts = !1;
                        const u = new b.PartialEvaluator({
                            xref: this.xref,
                            handler: e1,
                            pageIndex: -1,
                            idFactory: this._globalIdFactory,
                            fontCache: this.catalog.fontCache,
                            builtInCMapCache: this.catalog.builtInCMapCache,
                            standardFontDataCache: this.catalog.standardFontDataCache,
                            options: h
                        }), d = new m.OperatorList, f = [], g = {
                            get font () {
                                return f.at(-1);
                            },
                            set font (e){
                                f.push(e);
                            },
                            clone () {
                                return this;
                            }
                        }, y = new Map;
                        l.forEach((e1, t)=>{
                            y.set(e1, t);
                        });
                        const w = [];
                        for (const [e1, a] of y){
                            const o = a.get("FontDescriptor");
                            if (!(o instanceof s.Dict)) continue;
                            let c = o.get("FontFamily");
                            c = c.replaceAll(/[ ]+(\d)/g, "$1");
                            const l = {
                                fontFamily: c,
                                fontWeight: o.get("FontWeight"),
                                italicAngle: -o.get("ItalicAngle")
                            };
                            (0, i.validateCSSFont)(l) && w.push(u.handleSetFont(n, [
                                s.Name.get(e1),
                                1
                            ], null, d, t, g, null, l).catch(function(e1) {
                                (0, r.warn)(`loadXfaFonts: "${e1}".`);
                                return null;
                            }));
                        }
                        await Promise.all(w);
                        const S = this.xfaFactory.setFonts(f);
                        if (!S) return;
                        h.ignoreErrors = !0;
                        w.length = 0;
                        f.length = 0;
                        const x = new Set;
                        for (const e1 of S)(0, o.getXfaFontName)(`${e1}-Regular`) || x.add(e1);
                        x.size && S.push("PdfJS-Fallback");
                        for (const e1 of S)if (!x.has(e1)) for (const a of [
                            {
                                name: "Regular",
                                fontWeight: 400,
                                italicAngle: 0
                            },
                            {
                                name: "Bold",
                                fontWeight: 700,
                                italicAngle: 0
                            },
                            {
                                name: "Italic",
                                fontWeight: 400,
                                italicAngle: 12
                            },
                            {
                                name: "BoldItalic",
                                fontWeight: 700,
                                italicAngle: 12
                            }
                        ]){
                            const i = `${e1}-${a.name}`, c = (0, o.getXfaFontDict)(i);
                            w.push(u.handleSetFont(n, [
                                s.Name.get(i),
                                1
                            ], null, d, t, g, c, {
                                fontFamily: e1,
                                fontWeight: a.fontWeight,
                                italicAngle: a.italicAngle
                            }).catch(function(e1) {
                                (0, r.warn)(`loadXfaFonts: "${e1}".`);
                                return null;
                            }));
                        }
                        await Promise.all(w);
                        this.xfaFactory.appendFonts(f, x);
                    }
                    async serializeXfaData(e1) {
                        return this.xfaFactory ? this.xfaFactory.serializeData(e1) : null;
                    }
                    get version() {
                        return this.catalog.version || this._version;
                    }
                    get formInfo() {
                        const e1 = {
                            hasFields: !1,
                            hasAcroForm: !1,
                            hasXfa: !1,
                            hasSignatures: !1
                        }, t = this.catalog.acroForm;
                        if (!t) return (0, r.shadow)(this, "formInfo", e1);
                        try {
                            const a = t.get("Fields"), r = Array.isArray(a) && a.length > 0;
                            e1.hasFields = r;
                            const n = t.get("XFA");
                            e1.hasXfa = Array.isArray(n) && n.length > 0 || n instanceof c.BaseStream && !n.isEmpty;
                            const i = !!(1 & t.get("SigFlags")), s = i && this._hasOnlyDocumentSignatures(a);
                            e1.hasAcroForm = r && !s;
                            e1.hasSignatures = i;
                        } catch (e1) {
                            if (e1 instanceof i.MissingDataException) throw e1;
                            (0, r.warn)(`Cannot fetch form information: "${e1}".`);
                        }
                        return (0, r.shadow)(this, "formInfo", e1);
                    }
                    get documentInfo() {
                        const e1 = {
                            PDFFormatVersion: this.version,
                            Language: this.catalog.lang,
                            EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                            IsLinearized: !!this.linearization,
                            IsAcroFormPresent: this.formInfo.hasAcroForm,
                            IsXFAPresent: this.formInfo.hasXfa,
                            IsCollectionPresent: !!this.catalog.collection,
                            IsSignaturesPresent: this.formInfo.hasSignatures
                        };
                        let t;
                        try {
                            t = this.xref.trailer.get("Info");
                        } catch (e1) {
                            if (e1 instanceof i.MissingDataException) throw e1;
                            (0, r.info)("The document information dictionary is invalid.");
                        }
                        if (!(t instanceof s.Dict)) return (0, r.shadow)(this, "documentInfo", e1);
                        for (const a of t.getKeys()){
                            const n = t.get(a);
                            switch(a){
                                case "Title":
                                case "Author":
                                case "Subject":
                                case "Keywords":
                                case "Creator":
                                case "Producer":
                                case "CreationDate":
                                case "ModDate":
                                    if ("string" == typeof n) {
                                        e1[a] = (0, r.stringToPDFString)(n);
                                        continue;
                                    }
                                    break;
                                case "Trapped":
                                    if (n instanceof s.Name) {
                                        e1[a] = n;
                                        continue;
                                    }
                                    break;
                                default:
                                    let t1;
                                    switch(typeof n){
                                        case "string":
                                            t1 = (0, r.stringToPDFString)(n);
                                            break;
                                        case "number":
                                        case "boolean":
                                            t1 = n;
                                            break;
                                        default:
                                            n instanceof s.Name && (t1 = n);
                                    }
                                    if (void 0 === t1) {
                                        (0, r.warn)(`Bad value, for custom key "${a}", in Info: ${n}.`);
                                        continue;
                                    }
                                    e1.Custom || (e1.Custom = Object.create(null));
                                    e1.Custom[a] = t1;
                                    continue;
                            }
                            (0, r.warn)(`Bad value, for key "${a}", in Info: ${n}.`);
                        }
                        return (0, r.shadow)(this, "documentInfo", e1);
                    }
                    get fingerprints() {
                        function validate(e1) {
                            return "string" == typeof e1 && e1.length > 0 && "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0" !== e1;
                        }
                        function hexString(e1) {
                            const t = [];
                            for (const a of e1){
                                const e1 = a.toString(16);
                                t.push(e1.padStart(2, "0"));
                            }
                            return t.join("");
                        }
                        const e1 = this.xref.trailer.get("ID");
                        let t, a;
                        if (Array.isArray(e1) && validate(e1[0])) {
                            t = (0, r.stringToBytes)(e1[0]);
                            e1[1] !== e1[0] && validate(e1[1]) && (a = (0, r.stringToBytes)(e1[1]));
                        } else t = (0, l.calculateMD5)(this.stream.getByteRange(0, 1024), 0, 1024);
                        return (0, r.shadow)(this, "fingerprints", [
                            hexString(t),
                            a ? hexString(a) : null
                        ]);
                    }
                    async _getLinearizationPage(e1) {
                        const { catalog: t, linearization: a, xref: n } = this, i = s.Ref.get(a.objectNumberFirst, 0);
                        try {
                            const e1 = await n.fetchAsync(i);
                            if (e1 instanceof s.Dict) {
                                let a = e1.getRaw("Type");
                                a instanceof s.Ref && (a = await n.fetchAsync(a));
                                if ((0, s.isName)(a, "Page") || !e1.has("Type") && !e1.has("Kids")) {
                                    t.pageKidsCountCache.has(i) || t.pageKidsCountCache.put(i, 1);
                                    t.pageIndexCache.has(i) || t.pageIndexCache.put(i, 0);
                                    return [
                                        e1,
                                        i
                                    ];
                                }
                            }
                            throw new r.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                        } catch (a) {
                            (0, r.warn)(`_getLinearizationPage: "${a.message}".`);
                            return t.getPageDict(e1);
                        }
                    }
                    getPage(e1) {
                        const t = this._pagePromises.get(e1);
                        if (t) return t;
                        const { catalog: a, linearization: r, xfaFactory: n } = this;
                        let i;
                        i = n ? Promise.resolve([
                            s.Dict.empty,
                            null
                        ]) : r?.pageFirst === e1 ? this._getLinearizationPage(e1) : a.getPageDict(e1);
                        i = i.then(([t, r])=>new Page({
                                pdfManager: this.pdfManager,
                                xref: this.xref,
                                pageIndex: e1,
                                pageDict: t,
                                ref: r,
                                globalIdFactory: this._globalIdFactory,
                                fontCache: a.fontCache,
                                builtInCMapCache: a.builtInCMapCache,
                                standardFontDataCache: a.standardFontDataCache,
                                globalImageCache: a.globalImageCache,
                                systemFontCache: a.systemFontCache,
                                nonBlendModesSet: a.nonBlendModesSet,
                                xfaFactory: n
                            }));
                        this._pagePromises.set(e1, i);
                        return i;
                    }
                    async checkFirstPage(e1 = !1) {
                        if (!e1) try {
                            await this.getPage(0);
                        } catch (e1) {
                            if (e1 instanceof i.XRefEntryException) {
                                this._pagePromises.delete(0);
                                await this.cleanup();
                                throw new i.XRefParseException;
                            }
                        }
                    }
                    async checkLastPage(e1 = !1) {
                        const { catalog: t, pdfManager: a } = this;
                        t.setActualNumPages();
                        let n;
                        try {
                            await Promise.all([
                                a.ensureDoc("xfaFactory"),
                                a.ensureDoc("linearization"),
                                a.ensureCatalog("numPages")
                            ]);
                            if (this.xfaFactory) return;
                            n = this.linearization ? this.linearization.numPages : t.numPages;
                            if (!Number.isInteger(n)) throw new r.FormatError("Page count is not an integer.");
                            if (n <= 1) return;
                            await this.getPage(n - 1);
                        } catch (s) {
                            this._pagePromises.delete(n - 1);
                            await this.cleanup();
                            if (s instanceof i.XRefEntryException && !e1) throw new i.XRefParseException;
                            (0, r.warn)(`checkLastPage - invalid /Pages tree /Count: ${n}.`);
                            let o;
                            try {
                                o = await t.getAllPageDicts(e1);
                            } catch (a) {
                                if (a instanceof i.XRefEntryException && !e1) throw new i.XRefParseException;
                                t.setActualNumPages(1);
                                return;
                            }
                            for (const [e1, [r, n]] of o){
                                let i;
                                if (r instanceof Error) {
                                    i = Promise.reject(r);
                                    i.catch(()=>{});
                                } else i = Promise.resolve(new Page({
                                    pdfManager: a,
                                    xref: this.xref,
                                    pageIndex: e1,
                                    pageDict: r,
                                    ref: n,
                                    globalIdFactory: this._globalIdFactory,
                                    fontCache: t.fontCache,
                                    builtInCMapCache: t.builtInCMapCache,
                                    standardFontDataCache: t.standardFontDataCache,
                                    globalImageCache: t.globalImageCache,
                                    systemFontCache: t.systemFontCache,
                                    nonBlendModesSet: t.nonBlendModesSet,
                                    xfaFactory: null
                                }));
                                this._pagePromises.set(e1, i);
                            }
                            t.setActualNumPages(o.size);
                        }
                    }
                    fontFallback(e1, t) {
                        return this.catalog.fontFallback(e1, t);
                    }
                    async cleanup(e1 = !1) {
                        return this.catalog ? this.catalog.cleanup(e1) : (0, u.clearGlobalCaches)();
                    }
                    #a(e1, t, a, i) {
                        const s = this.xref.fetchIfRef(t);
                        if (s.has("T")) {
                            const t = (0, r.stringToPDFString)(s.get("T"));
                            e1 = "" === e1 ? t : `${e1}.${t}`;
                        }
                        a.has(e1) || a.set(e1, []);
                        a.get(e1).push(n.AnnotationFactory.create(this.xref, t, i, this._localIdFactory, !0, null).then((e1)=>e1?.getFieldObject()).catch(function(e1) {
                            (0, r.warn)(`#collectFieldObjects: "${e1}".`);
                            return null;
                        }));
                        if (s.has("Kids")) for (const t of s.get("Kids"))this.#a(e1, t, a, i);
                    }
                    get fieldObjects() {
                        if (!this.formInfo.hasFields) return (0, r.shadow)(this, "fieldObjects", Promise.resolve(null));
                        const e1 = this.pdfManager.ensureDoc("annotationGlobals").then(async (e1)=>{
                            if (!e1) return null;
                            const t = Object.create(null), a = new Map;
                            for (const t of this.catalog.acroForm.get("Fields"))this.#a("", t, a, e1);
                            const r = [];
                            for (const [e1, n] of a)r.push(Promise.all(n).then((a)=>{
                                (a = a.filter((e1)=>!!e1)).length > 0 && (t[e1] = a);
                            }));
                            await Promise.all(r);
                            return t;
                        });
                        return (0, r.shadow)(this, "fieldObjects", e1);
                    }
                    get hasJSActions() {
                        const e1 = this.pdfManager.ensureDoc("_parseHasJSActions");
                        return (0, r.shadow)(this, "hasJSActions", e1);
                    }
                    async _parseHasJSActions() {
                        const [e1, t] = await Promise.all([
                            this.pdfManager.ensureCatalog("jsActions"),
                            this.pdfManager.ensureDoc("fieldObjects")
                        ]);
                        return !!e1 || !!t && Object.values(t).some((e1)=>e1.some((e1)=>null !== e1.actions));
                    }
                    get calculationOrderIds() {
                        const e1 = this.catalog.acroForm;
                        if (!e1?.has("CO")) return (0, r.shadow)(this, "calculationOrderIds", null);
                        const t = e1.get("CO");
                        if (!Array.isArray(t) || 0 === t.length) return (0, r.shadow)(this, "calculationOrderIds", null);
                        const a = [];
                        for (const e1 of t)e1 instanceof s.Ref && a.push(e1.toString());
                        return 0 === a.length ? (0, r.shadow)(this, "calculationOrderIds", null) : (0, r.shadow)(this, "calculationOrderIds", a);
                    }
                    get annotationGlobals() {
                        return (0, r.shadow)(this, "annotationGlobals", n.AnnotationFactory.createGlobals(this.pdfManager));
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PopupAnnotation = t.MarkupAnnotation = t.AnnotationFactory = t.AnnotationBorderStyle = t.Annotation = void 0;
                t.getQuadPoints = getQuadPoints;
                var r = a(2), n = a(3), i = a(11), s = a(4), o = a(8), c = a(5), l = a(60), h = a(66), u = a(12), d = a(69), f = a(26), g = a(76), p = a(64), m = a(73), b = a(77);
                t.AnnotationFactory = class AnnotationFactory {
                    static createGlobals(e1) {
                        return Promise.all([
                            e1.ensureCatalog("acroForm"),
                            e1.ensureDoc("xfaDatasets"),
                            e1.ensureCatalog("structTreeRoot"),
                            e1.ensureCatalog("baseUrl"),
                            e1.ensureCatalog("attachments")
                        ]).then(([t, a, r, n, i])=>({
                                pdfManager: e1,
                                acroForm: t instanceof s.Dict ? t : s.Dict.empty,
                                xfaDatasets: a,
                                structTreeRoot: r,
                                baseUrl: n,
                                attachments: i
                            }), (e1)=>{
                            (0, r.warn)(`createGlobals: "${e1}".`);
                            return null;
                        });
                    }
                    static async create(e1, t, a, r, n, i) {
                        const s = n ? await this._getPageIndex(e1, t, a.pdfManager) : null;
                        return a.pdfManager.ensure(this, "_create", [
                            e1,
                            t,
                            a,
                            r,
                            n,
                            s,
                            i
                        ]);
                    }
                    static _create(e1, t, a, i, o = !1, c = null, l = null) {
                        const h = e1.fetchIfRef(t);
                        if (!(h instanceof s.Dict)) return;
                        const { acroForm: u, pdfManager: d } = a, f = t instanceof s.Ref ? t.toString() : `annot_${i.createObjId()}`;
                        let g = h.get("Subtype");
                        g = g instanceof s.Name ? g.name : null;
                        const p = {
                            xref: e1,
                            ref: t,
                            dict: h,
                            subtype: g,
                            id: f,
                            annotationGlobals: a,
                            collectFields: o,
                            needAppearances: !o && !0 === u.get("NeedAppearances"),
                            pageIndex: c,
                            evaluatorOptions: d.evaluatorOptions,
                            pageRef: l
                        };
                        switch(g){
                            case "Link":
                                return new LinkAnnotation(p);
                            case "Text":
                                return new TextAnnotation(p);
                            case "Widget":
                                let e2 = (0, n.getInheritableProperty)({
                                    dict: h,
                                    key: "FT"
                                });
                                e2 = e2 instanceof s.Name ? e2.name : null;
                                switch(e2){
                                    case "Tx":
                                        return new TextWidgetAnnotation(p);
                                    case "Btn":
                                        return new ButtonWidgetAnnotation(p);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotation(p);
                                    case "Sig":
                                        return new SignatureWidgetAnnotation(p);
                                }
                                (0, r.warn)(`Unimplemented widget field type "${e2}", falling back to base field type.`);
                                return new WidgetAnnotation(p);
                            case "Popup":
                                return new PopupAnnotation(p);
                            case "FreeText":
                                return new FreeTextAnnotation(p);
                            case "Line":
                                return new LineAnnotation(p);
                            case "Square":
                                return new SquareAnnotation(p);
                            case "Circle":
                                return new CircleAnnotation(p);
                            case "PolyLine":
                                return new PolylineAnnotation(p);
                            case "Polygon":
                                return new PolygonAnnotation(p);
                            case "Caret":
                                return new CaretAnnotation(p);
                            case "Ink":
                                return new InkAnnotation(p);
                            case "Highlight":
                                return new HighlightAnnotation(p);
                            case "Underline":
                                return new UnderlineAnnotation(p);
                            case "Squiggly":
                                return new SquigglyAnnotation(p);
                            case "StrikeOut":
                                return new StrikeOutAnnotation(p);
                            case "Stamp":
                                return new StampAnnotation(p);
                            case "FileAttachment":
                                return new FileAttachmentAnnotation(p);
                            default:
                                o || (g ? (0, r.warn)(`Unimplemented annotation type "${g}", falling back to base annotation.`) : (0, r.warn)("Annotation is missing the required /Subtype."));
                                return new Annotation(p);
                        }
                    }
                    static async _getPageIndex(e1, t, a) {
                        try {
                            const n = await e1.fetchIfRefAsync(t);
                            if (!(n instanceof s.Dict)) return -1;
                            const i = n.getRaw("P");
                            if (i instanceof s.Ref) try {
                                return await a.ensureCatalog("getPageIndex", [
                                    i
                                ]);
                            } catch (e1) {
                                (0, r.info)(`_getPageIndex -- not a valid page reference: "${e1}".`);
                            }
                            if (n.has("Kids")) return -1;
                            const o = await a.ensureDoc("numPages");
                            for(let e1 = 0; e1 < o; e1++){
                                const r = await a.getPage(e1), n = await a.ensure(r, "annotations");
                                for (const a of n)if (a instanceof s.Ref && (0, s.isRefsEqual)(a, t)) return e1;
                            }
                        } catch (e1) {
                            (0, r.warn)(`_getPageIndex: "${e1}".`);
                        }
                        return -1;
                    }
                    static generateImages(e1, t, a) {
                        if (!a) {
                            (0, r.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images.");
                            return null;
                        }
                        let n;
                        for (const { bitmapId: a, bitmap: r } of e1)if (r) {
                            n ||= new Map;
                            n.set(a, StampAnnotation.createImage(r, t));
                        }
                        return n;
                    }
                    static async saveNewAnnotations(e1, t, a, n) {
                        const i = e1.xref;
                        let o;
                        const c = [], l = [], { isOffscreenCanvasSupported: h } = e1.options;
                        for (const u of a)if (!u.deleted) switch(u.annotationType){
                            case r.AnnotationEditorType.FREETEXT:
                                if (!o) {
                                    const e1 = new s.Dict(i);
                                    e1.set("BaseFont", s.Name.get("Helvetica"));
                                    e1.set("Type", s.Name.get("Font"));
                                    e1.set("Subtype", s.Name.get("Type1"));
                                    e1.set("Encoding", s.Name.get("WinAnsiEncoding"));
                                    const t = [];
                                    o = i.getNewTemporaryRef();
                                    await (0, m.writeObject)(o, e1, t, i);
                                    c.push({
                                        ref: o,
                                        data: t.join("")
                                    });
                                }
                                l.push(FreeTextAnnotation.createNewAnnotation(i, u, c, {
                                    evaluator: e1,
                                    task: t,
                                    baseFontRef: o
                                }));
                                break;
                            case r.AnnotationEditorType.INK:
                                l.push(InkAnnotation.createNewAnnotation(i, u, c));
                                break;
                            case r.AnnotationEditorType.STAMP:
                                if (!h) break;
                                const a = await n.get(u.bitmapId);
                                if (a.imageStream) {
                                    const { imageStream: e1, smaskStream: t } = a, r = [];
                                    if (t) {
                                        const a = i.getNewTemporaryRef();
                                        await (0, m.writeObject)(a, t, r, i);
                                        c.push({
                                            ref: a,
                                            data: r.join("")
                                        });
                                        e1.dict.set("SMask", a);
                                        r.length = 0;
                                    }
                                    const n = a.imageRef = i.getNewTemporaryRef();
                                    await (0, m.writeObject)(n, e1, r, i);
                                    c.push({
                                        ref: n,
                                        data: r.join("")
                                    });
                                    a.imageStream = a.smaskStream = null;
                                }
                                l.push(StampAnnotation.createNewAnnotation(i, u, c, {
                                    image: a
                                }));
                        }
                        return {
                            annotations: await Promise.all(l),
                            dependencies: c
                        };
                    }
                    static async printNewAnnotations(e1, t, a, n, i) {
                        if (!n) return null;
                        const { options: s, xref: o } = t, c = [];
                        for (const l of n)if (!l.deleted) switch(l.annotationType){
                            case r.AnnotationEditorType.FREETEXT:
                                c.push(FreeTextAnnotation.createNewPrintAnnotation(e1, o, l, {
                                    evaluator: t,
                                    task: a,
                                    evaluatorOptions: s
                                }));
                                break;
                            case r.AnnotationEditorType.INK:
                                c.push(InkAnnotation.createNewPrintAnnotation(e1, o, l, {
                                    evaluatorOptions: s
                                }));
                                break;
                            case r.AnnotationEditorType.STAMP:
                                if (!s.isOffscreenCanvasSupported) break;
                                const n = await i.get(l.bitmapId);
                                if (n.imageStream) {
                                    const { imageStream: e1, smaskStream: t } = n;
                                    t && e1.dict.set("SMask", t);
                                    n.imageRef = new f.JpegStream(e1, e1.length);
                                    n.imageStream = n.smaskStream = null;
                                }
                                c.push(StampAnnotation.createNewPrintAnnotation(e1, o, l, {
                                    image: n,
                                    evaluatorOptions: s
                                }));
                        }
                        return Promise.all(c);
                    }
                };
                function getRgbColor(e1, t = new Uint8ClampedArray(3)) {
                    if (!Array.isArray(e1)) return t;
                    const a = t || new Uint8ClampedArray(3);
                    switch(e1.length){
                        case 0:
                            return null;
                        case 1:
                            u.ColorSpace.singletons.gray.getRgbItem(e1, 0, a, 0);
                            return a;
                        case 3:
                            u.ColorSpace.singletons.rgb.getRgbItem(e1, 0, a, 0);
                            return a;
                        case 4:
                            u.ColorSpace.singletons.cmyk.getRgbItem(e1, 0, a, 0);
                            return a;
                        default:
                            return t;
                    }
                }
                function getPdfColorArray(e1) {
                    return Array.from(e1, (e1)=>e1 / 255);
                }
                function getQuadPoints(e1, t) {
                    const a = e1.getArray("QuadPoints");
                    if (!Array.isArray(a) || 0 === a.length || a.length % 8 > 0) return null;
                    const r = [];
                    for(let e1 = 0, n = a.length / 8; e1 < n; e1++){
                        let n = 1 / 0, i = -1 / 0, s = 1 / 0, o = -1 / 0;
                        for(let t = 8 * e1, r = 8 * e1 + 8; t < r; t += 2){
                            const e1 = a[t], r = a[t + 1];
                            n = Math.min(e1, n);
                            i = Math.max(e1, i);
                            s = Math.min(r, s);
                            o = Math.max(r, o);
                        }
                        if (null !== t && (n < t[0] || i > t[2] || s < t[1] || o > t[3])) return null;
                        r.push([
                            {
                                x: n,
                                y: o
                            },
                            {
                                x: i,
                                y: o
                            },
                            {
                                x: n,
                                y: s
                            },
                            {
                                x: i,
                                y: s
                            }
                        ]);
                    }
                    return r;
                }
                function getTransformMatrix(e1, t, a) {
                    const [n, i, s, o] = r.Util.getAxialAlignedBoundingBox(t, a);
                    if (n === s || i === o) return [
                        1,
                        0,
                        0,
                        1,
                        e1[0],
                        e1[1]
                    ];
                    const c = (e1[2] - e1[0]) / (s - n), l = (e1[3] - e1[1]) / (o - i);
                    return [
                        c,
                        0,
                        0,
                        l,
                        e1[0] - n * c,
                        e1[1] - i * l
                    ];
                }
                class Annotation {
                    constructor(e1){
                        const { dict: t, xref: a, annotationGlobals: i } = e1;
                        this.setTitle(t.get("T"));
                        this.setContents(t.get("Contents"));
                        this.setModificationDate(t.get("M"));
                        this.setFlags(t.get("F"));
                        this.setRectangle(t.getArray("Rect"));
                        this.setColor(t.getArray("C"));
                        this.setBorderStyle(t);
                        this.setAppearance(t);
                        this.setOptionalContent(t);
                        const o = t.get("MK");
                        this.setBorderAndBackgroundColors(o);
                        this.setRotation(o, t);
                        this.ref = e1.ref instanceof s.Ref ? e1.ref : null;
                        this._streams = [];
                        this.appearance && this._streams.push(this.appearance);
                        const c = !!(this.flags & r.AnnotationFlag.LOCKED), l = !!(this.flags & r.AnnotationFlag.LOCKEDCONTENTS);
                        if (i.structTreeRoot) {
                            let a = t.get("StructParent");
                            a = Number.isInteger(a) && a >= 0 ? a : -1;
                            i.structTreeRoot.addAnnotationIdToPage(e1.pageRef, a);
                        }
                        this.data = {
                            annotationFlags: this.flags,
                            borderStyle: this.borderStyle,
                            color: this.color,
                            backgroundColor: this.backgroundColor,
                            borderColor: this.borderColor,
                            rotation: this.rotation,
                            contentsObj: this._contents,
                            hasAppearance: !!this.appearance,
                            id: e1.id,
                            modificationDate: this.modificationDate,
                            rect: this.rectangle,
                            subtype: e1.subtype,
                            hasOwnCanvas: !1,
                            noRotate: !!(this.flags & r.AnnotationFlag.NOROTATE),
                            noHTML: c && l
                        };
                        if (e1.collectFields) {
                            const i = t.get("Kids");
                            if (Array.isArray(i)) {
                                const e1 = [];
                                for (const t of i)t instanceof s.Ref && e1.push(t.toString());
                                0 !== e1.length && (this.data.kidIds = e1);
                            }
                            this.data.actions = (0, n.collectActions)(a, t, r.AnnotationActionEventType);
                            this.data.fieldName = this._constructFieldName(t);
                            this.data.pageIndex = e1.pageIndex;
                        }
                        this._isOffscreenCanvasSupported = e1.evaluatorOptions.isOffscreenCanvasSupported;
                        this._fallbackFontDict = null;
                        this._needAppearances = !1;
                    }
                    _hasFlag(e1, t) {
                        return !!(e1 & t);
                    }
                    _isViewable(e1) {
                        return !this._hasFlag(e1, r.AnnotationFlag.INVISIBLE) && !this._hasFlag(e1, r.AnnotationFlag.NOVIEW);
                    }
                    _isPrintable(e1) {
                        return this._hasFlag(e1, r.AnnotationFlag.PRINT) && !this._hasFlag(e1, r.AnnotationFlag.HIDDEN) && !this._hasFlag(e1, r.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(e1, t) {
                        const a = e1?.get(this.data.id)?.noView;
                        return void 0 !== a ? !a : this.viewable && !this._hasFlag(this.flags, r.AnnotationFlag.HIDDEN);
                    }
                    mustBePrinted(e1) {
                        const t = e1?.get(this.data.id)?.noPrint;
                        return void 0 !== t ? !t : this.printable;
                    }
                    get viewable() {
                        return null !== this.data.quadPoints && (0 === this.flags || this._isViewable(this.flags));
                    }
                    get printable() {
                        return null !== this.data.quadPoints && 0 !== this.flags && this._isPrintable(this.flags);
                    }
                    _parseStringHelper(e1) {
                        const t = "string" == typeof e1 ? (0, r.stringToPDFString)(e1) : "";
                        return {
                            str: t,
                            dir: t && "rtl" === (0, l.bidi)(t).dir ? "rtl" : "ltr"
                        };
                    }
                    setDefaultAppearance(e1) {
                        const { dict: t, annotationGlobals: a } = e1, r = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "DA"
                        }) || a.acroForm.get("DA");
                        this._defaultAppearance = "string" == typeof r ? r : "";
                        this.data.defaultAppearanceData = (0, i.parseDefaultAppearance)(this._defaultAppearance);
                    }
                    setTitle(e1) {
                        this._title = this._parseStringHelper(e1);
                    }
                    setContents(e1) {
                        this._contents = this._parseStringHelper(e1);
                    }
                    setModificationDate(e1) {
                        this.modificationDate = "string" == typeof e1 ? e1 : null;
                    }
                    setFlags(e1) {
                        this.flags = Number.isInteger(e1) && e1 > 0 ? e1 : 0;
                    }
                    hasFlag(e1) {
                        return this._hasFlag(this.flags, e1);
                    }
                    setRectangle(e1) {
                        this.rectangle = Array.isArray(e1) && 4 === e1.length ? r.Util.normalizeRect(e1) : [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    setColor(e1) {
                        this.color = getRgbColor(e1);
                    }
                    setLineEndings(e1) {
                        this.lineEndings = [
                            "None",
                            "None"
                        ];
                        if (Array.isArray(e1) && 2 === e1.length) for(let t = 0; t < 2; t++){
                            const a = e1[t];
                            if (a instanceof s.Name) switch(a.name){
                                case "None":
                                    continue;
                                case "Square":
                                case "Circle":
                                case "Diamond":
                                case "OpenArrow":
                                case "ClosedArrow":
                                case "Butt":
                                case "ROpenArrow":
                                case "RClosedArrow":
                                case "Slash":
                                    this.lineEndings[t] = a.name;
                                    continue;
                            }
                            (0, r.warn)(`Ignoring invalid lineEnding: ${a}`);
                        }
                    }
                    setRotation(e1, t) {
                        this.rotation = 0;
                        let a = e1 instanceof s.Dict ? e1.get("R") || 0 : t.get("Rotate") || 0;
                        if (Number.isInteger(a) && 0 !== a) {
                            a %= 360;
                            a < 0 && (a += 360);
                            a % 90 == 0 && (this.rotation = a);
                        }
                    }
                    setBorderAndBackgroundColors(e1) {
                        if (e1 instanceof s.Dict) {
                            this.borderColor = getRgbColor(e1.getArray("BC"), null);
                            this.backgroundColor = getRgbColor(e1.getArray("BG"), null);
                        } else this.borderColor = this.backgroundColor = null;
                    }
                    setBorderStyle(e1) {
                        this.borderStyle = new AnnotationBorderStyle;
                        if (e1 instanceof s.Dict) {
                            if (e1.has("BS")) {
                                const t = e1.get("BS"), a = t.get("Type");
                                if (!a || (0, s.isName)(a, "Border")) {
                                    this.borderStyle.setWidth(t.get("W"), this.rectangle);
                                    this.borderStyle.setStyle(t.get("S"));
                                    this.borderStyle.setDashArray(t.getArray("D"));
                                }
                            } else if (e1.has("Border")) {
                                const t = e1.getArray("Border");
                                if (Array.isArray(t) && t.length >= 3) {
                                    this.borderStyle.setHorizontalCornerRadius(t[0]);
                                    this.borderStyle.setVerticalCornerRadius(t[1]);
                                    this.borderStyle.setWidth(t[2], this.rectangle);
                                    4 === t.length && this.borderStyle.setDashArray(t[3], !0);
                                }
                            } else this.borderStyle.setWidth(0);
                        }
                    }
                    setAppearance(e1) {
                        this.appearance = null;
                        const t = e1.get("AP");
                        if (!(t instanceof s.Dict)) return;
                        const a = t.get("N");
                        if (a instanceof c.BaseStream) {
                            this.appearance = a;
                            return;
                        }
                        if (!(a instanceof s.Dict)) return;
                        const r = e1.get("AS");
                        if (!(r instanceof s.Name && a.has(r.name))) return;
                        const n = a.get(r.name);
                        n instanceof c.BaseStream && (this.appearance = n);
                    }
                    setOptionalContent(e1) {
                        this.oc = null;
                        const t = e1.get("OC");
                        t instanceof s.Name ? (0, r.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : t instanceof s.Dict && (this.oc = t);
                    }
                    loadResources(e1, t) {
                        return t.dict.getAsync("Resources").then((t)=>{
                            if (!t) return;
                            return new g.ObjectLoader(t, e1, t.xref).load().then(function() {
                                return t;
                            });
                        });
                    }
                    async getOperatorList(e1, t, a, n, i) {
                        const c = this.data;
                        let l = this.appearance;
                        const h = !!(this.data.hasOwnCanvas && a & r.RenderingIntentFlag.DISPLAY);
                        if (!l) {
                            if (!h) return {
                                opList: new p.OperatorList,
                                separateForm: !1,
                                separateCanvas: !1
                            };
                            l = new o.StringStream("");
                            l.dict = new s.Dict;
                        }
                        const u = l.dict, d = await this.loadResources([
                            "ExtGState",
                            "ColorSpace",
                            "Pattern",
                            "Shading",
                            "XObject",
                            "Font"
                        ], l), f = u.getArray("BBox") || [
                            0,
                            0,
                            1,
                            1
                        ], g = u.getArray("Matrix") || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ], m = getTransformMatrix(c.rect, f, g), b = new p.OperatorList;
                        let y;
                        this.oc && (y = await e1.parseMarkedContentProps(this.oc, null));
                        void 0 !== y && b.addOp(r.OPS.beginMarkedContentProps, [
                            "OC",
                            y
                        ]);
                        b.addOp(r.OPS.beginAnnotation, [
                            c.id,
                            c.rect,
                            m,
                            g,
                            h
                        ]);
                        await e1.getOperatorList({
                            stream: l,
                            task: t,
                            resources: d,
                            operatorList: b,
                            fallbackFontDict: this._fallbackFontDict
                        });
                        b.addOp(r.OPS.endAnnotation, []);
                        void 0 !== y && b.addOp(r.OPS.endMarkedContent, []);
                        this.reset();
                        return {
                            opList: b,
                            separateForm: !1,
                            separateCanvas: h
                        };
                    }
                    async save(e1, t, a) {
                        return null;
                    }
                    get hasTextContent() {
                        return !1;
                    }
                    async extractTextContent(e1, t, a) {
                        if (!this.appearance) return;
                        const n = await this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ], this.appearance), i = [], s = [];
                        let o = null;
                        const c = {
                            desiredSize: Math.Infinity,
                            ready: !0,
                            enqueue (e1, t) {
                                for (const t of e1.items)if (void 0 !== t.str) {
                                    o ||= t.transform.slice(-2);
                                    s.push(t.str);
                                    if (t.hasEOL) {
                                        i.push(s.join(""));
                                        s.length = 0;
                                    }
                                }
                            }
                        };
                        await e1.getTextContent({
                            stream: this.appearance,
                            task: t,
                            resources: n,
                            includeMarkedContent: !0,
                            sink: c,
                            viewBox: a
                        });
                        this.reset();
                        s.length && i.push(s.join(""));
                        if (i.length > 1 || i[0]) {
                            const e1 = this.appearance.dict, t = e1.getArray("BBox") || [
                                0,
                                0,
                                1,
                                1
                            ], a = e1.getArray("Matrix") || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ], n = this.data.rect, s = getTransformMatrix(n, t, a);
                            s[4] -= n[0];
                            s[5] -= n[1];
                            o = r.Util.applyTransform(o, s);
                            o = r.Util.applyTransform(o, a);
                            this.data.textPosition = o;
                            this.data.textContent = i;
                        }
                    }
                    getFieldObject() {
                        return this.data.kidIds ? {
                            id: this.data.id,
                            actions: this.data.actions,
                            name: this.data.fieldName,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            type: "",
                            kidIds: this.data.kidIds,
                            page: this.data.pageIndex,
                            rotation: this.rotation
                        } : null;
                    }
                    reset() {
                        for (const e1 of this._streams)e1.reset();
                    }
                    _constructFieldName(e1) {
                        if (!e1.has("T") && !e1.has("Parent")) {
                            (0, r.warn)("Unknown field name, falling back to empty field name.");
                            return "";
                        }
                        if (!e1.has("Parent")) return (0, r.stringToPDFString)(e1.get("T"));
                        const t = [];
                        e1.has("T") && t.unshift((0, r.stringToPDFString)(e1.get("T")));
                        let a = e1;
                        const n = new s.RefSet;
                        e1.objId && n.put(e1.objId);
                        for(; a.has("Parent");){
                            a = a.get("Parent");
                            if (!(a instanceof s.Dict) || a.objId && n.has(a.objId)) break;
                            a.objId && n.put(a.objId);
                            a.has("T") && t.unshift((0, r.stringToPDFString)(a.get("T")));
                        }
                        return t.join(".");
                    }
                }
                t.Annotation = Annotation;
                class AnnotationBorderStyle {
                    constructor(){
                        this.width = 1;
                        this.style = r.AnnotationBorderStyleType.SOLID;
                        this.dashArray = [
                            3
                        ];
                        this.horizontalCornerRadius = 0;
                        this.verticalCornerRadius = 0;
                    }
                    setWidth(e1, t = [
                        0,
                        0,
                        0,
                        0
                    ]) {
                        if (e1 instanceof s.Name) this.width = 0;
                        else if ("number" == typeof e1) {
                            if (e1 > 0) {
                                const a = (t[2] - t[0]) / 2, n = (t[3] - t[1]) / 2;
                                if (a > 0 && n > 0 && (e1 > a || e1 > n)) {
                                    (0, r.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${e1}`);
                                    e1 = 1;
                                }
                            }
                            this.width = e1;
                        }
                    }
                    setStyle(e1) {
                        if (e1 instanceof s.Name) switch(e1.name){
                            case "S":
                                this.style = r.AnnotationBorderStyleType.SOLID;
                                break;
                            case "D":
                                this.style = r.AnnotationBorderStyleType.DASHED;
                                break;
                            case "B":
                                this.style = r.AnnotationBorderStyleType.BEVELED;
                                break;
                            case "I":
                                this.style = r.AnnotationBorderStyleType.INSET;
                                break;
                            case "U":
                                this.style = r.AnnotationBorderStyleType.UNDERLINE;
                        }
                    }
                    setDashArray(e1, t = !1) {
                        if (Array.isArray(e1) && e1.length > 0) {
                            let a = !0, r = !0;
                            for (const t of e1){
                                if (!(+t >= 0)) {
                                    a = !1;
                                    break;
                                }
                                t > 0 && (r = !1);
                            }
                            if (a && !r) {
                                this.dashArray = e1;
                                t && this.setStyle(s.Name.get("D"));
                            } else this.width = 0;
                        } else e1 && (this.width = 0);
                    }
                    setHorizontalCornerRadius(e1) {
                        Number.isInteger(e1) && (this.horizontalCornerRadius = e1);
                    }
                    setVerticalCornerRadius(e1) {
                        Number.isInteger(e1) && (this.verticalCornerRadius = e1);
                    }
                }
                t.AnnotationBorderStyle = AnnotationBorderStyle;
                class MarkupAnnotation extends Annotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t } = e1;
                        if (t.has("IRT")) {
                            const e1 = t.getRaw("IRT");
                            this.data.inReplyTo = e1 instanceof s.Ref ? e1.toString() : null;
                            const a = t.get("RT");
                            this.data.replyType = a instanceof s.Name ? a.name : r.AnnotationReplyType.REPLY;
                        }
                        let a = null;
                        if (this.data.replyType === r.AnnotationReplyType.GROUP) {
                            const e1 = t.get("IRT");
                            this.setTitle(e1.get("T"));
                            this.data.titleObj = this._title;
                            this.setContents(e1.get("Contents"));
                            this.data.contentsObj = this._contents;
                            if (e1.has("CreationDate")) {
                                this.setCreationDate(e1.get("CreationDate"));
                                this.data.creationDate = this.creationDate;
                            } else this.data.creationDate = null;
                            if (e1.has("M")) {
                                this.setModificationDate(e1.get("M"));
                                this.data.modificationDate = this.modificationDate;
                            } else this.data.modificationDate = null;
                            a = e1.getRaw("Popup");
                            if (e1.has("C")) {
                                this.setColor(e1.getArray("C"));
                                this.data.color = this.color;
                            } else this.data.color = null;
                        } else {
                            this.data.titleObj = this._title;
                            this.setCreationDate(t.get("CreationDate"));
                            this.data.creationDate = this.creationDate;
                            a = t.getRaw("Popup");
                            t.has("C") || (this.data.color = null);
                        }
                        this.data.popupRef = a instanceof s.Ref ? a.toString() : null;
                        t.has("RC") && (this.data.richText = b.XFAFactory.getRichTextAsHtml(t.get("RC")));
                    }
                    setCreationDate(e1) {
                        this.creationDate = "string" == typeof e1 ? e1 : null;
                    }
                    _setDefaultAppearance({ xref: e1, extra: t, strokeColor: a, fillColor: r, blendMode: n, strokeAlpha: i, fillAlpha: c, pointsCallback: l }) {
                        let h = Number.MAX_VALUE, u = Number.MAX_VALUE, d = Number.MIN_VALUE, f = Number.MIN_VALUE;
                        const g = [
                            "q"
                        ];
                        t && g.push(t);
                        a && g.push(`${a[0]} ${a[1]} ${a[2]} RG`);
                        r && g.push(`${r[0]} ${r[1]} ${r[2]} rg`);
                        let p = this.data.quadPoints;
                        p || (p = [
                            [
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[1]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[1]
                                }
                            ]
                        ]);
                        for (const e1 of p){
                            const [t, a, r, n] = l(g, e1);
                            h = Math.min(h, t);
                            d = Math.max(d, a);
                            u = Math.min(u, r);
                            f = Math.max(f, n);
                        }
                        g.push("Q");
                        const m = new s.Dict(e1), b = new s.Dict(e1);
                        b.set("Subtype", s.Name.get("Form"));
                        const y = new o.StringStream(g.join(" "));
                        y.dict = b;
                        m.set("Fm0", y);
                        const w = new s.Dict(e1);
                        n && w.set("BM", s.Name.get(n));
                        "number" == typeof i && w.set("CA", i);
                        "number" == typeof c && w.set("ca", c);
                        const S = new s.Dict(e1);
                        S.set("GS0", w);
                        const x = new s.Dict(e1);
                        x.set("ExtGState", S);
                        x.set("XObject", m);
                        const C = new s.Dict(e1);
                        C.set("Resources", x);
                        const k = this.data.rect = [
                            h,
                            u,
                            d,
                            f
                        ];
                        C.set("BBox", k);
                        this.appearance = new o.StringStream("/GS0 gs /Fm0 Do");
                        this.appearance.dict = C;
                        this._streams.push(this.appearance, y);
                    }
                    static async createNewAnnotation(e1, t, a, r) {
                        const n = t.ref ||= e1.getNewTemporaryRef(), i = await this.createNewAppearanceStream(t, e1, r), s = [];
                        let o;
                        if (i) {
                            const r = e1.getNewTemporaryRef();
                            o = this.createNewDict(t, e1, {
                                apRef: r
                            });
                            await (0, m.writeObject)(r, i, s, e1);
                            a.push({
                                ref: r,
                                data: s.join("")
                            });
                        } else o = this.createNewDict(t, e1, {});
                        Number.isInteger(t.parentTreeId) && o.set("StructParent", t.parentTreeId);
                        s.length = 0;
                        await (0, m.writeObject)(n, o, s, e1);
                        return {
                            ref: n,
                            data: s.join("")
                        };
                    }
                    static async createNewPrintAnnotation(e1, t, a, r) {
                        const n = await this.createNewAppearanceStream(a, t, r), i = this.createNewDict(a, t, {
                            ap: n
                        }), s = new this.prototype.constructor({
                            dict: i,
                            xref: t,
                            annotationGlobals: e1,
                            evaluatorOptions: r.evaluatorOptions
                        });
                        a.ref && (s.ref = s.refToReplace = a.ref);
                        return s;
                    }
                }
                t.MarkupAnnotation = MarkupAnnotation;
                class WidgetAnnotation extends Annotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a, annotationGlobals: i } = e1, o = this.data;
                        this._needAppearances = e1.needAppearances;
                        o.annotationType = r.AnnotationType.WIDGET;
                        void 0 === o.fieldName && (o.fieldName = this._constructFieldName(t));
                        void 0 === o.actions && (o.actions = (0, n.collectActions)(a, t, r.AnnotationActionEventType));
                        let c = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "V",
                            getArray: !0
                        });
                        o.fieldValue = this._decodeFormValue(c);
                        const l = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "DV",
                            getArray: !0
                        });
                        o.defaultFieldValue = this._decodeFormValue(l);
                        if (void 0 === c && i.xfaDatasets) {
                            const e1 = this._title.str;
                            if (e1) {
                                this._hasValueFromXFA = !0;
                                o.fieldValue = c = i.xfaDatasets.getValue(e1);
                            }
                        }
                        void 0 === c && null !== o.defaultFieldValue && (o.fieldValue = o.defaultFieldValue);
                        o.alternativeText = (0, r.stringToPDFString)(t.get("TU") || "");
                        this.setDefaultAppearance(e1);
                        o.hasAppearance ||= this._needAppearances && void 0 !== o.fieldValue && null !== o.fieldValue;
                        const h = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "FT"
                        });
                        o.fieldType = h instanceof s.Name ? h.name : null;
                        const u = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "DR"
                        }), d = i.acroForm.get("DR"), f = this.appearance?.dict.get("Resources");
                        this._fieldResources = {
                            localResources: u,
                            acroFormResources: d,
                            appearanceResources: f,
                            mergedResources: s.Dict.merge({
                                xref: a,
                                dictArray: [
                                    u,
                                    f,
                                    d
                                ],
                                mergeSubDicts: !0
                            })
                        };
                        o.fieldFlags = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "Ff"
                        });
                        (!Number.isInteger(o.fieldFlags) || o.fieldFlags < 0) && (o.fieldFlags = 0);
                        o.readOnly = this.hasFieldFlag(r.AnnotationFieldFlag.READONLY);
                        o.required = this.hasFieldFlag(r.AnnotationFieldFlag.REQUIRED);
                        o.hidden = this._hasFlag(o.annotationFlags, r.AnnotationFlag.HIDDEN) || this._hasFlag(o.annotationFlags, r.AnnotationFlag.NOVIEW);
                    }
                    _decodeFormValue(e1) {
                        return Array.isArray(e1) ? e1.filter((e1)=>"string" == typeof e1).map((e1)=>(0, r.stringToPDFString)(e1)) : e1 instanceof s.Name ? (0, r.stringToPDFString)(e1.name) : "string" == typeof e1 ? (0, r.stringToPDFString)(e1) : null;
                    }
                    hasFieldFlag(e1) {
                        return !!(this.data.fieldFlags & e1);
                    }
                    _isViewable(e1) {
                        return !this._hasFlag(e1, r.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(e1, t) {
                        return t ? this.viewable : super.mustBeViewed(e1, t) && !this._hasFlag(this.flags, r.AnnotationFlag.NOVIEW);
                    }
                    getRotationMatrix(e1) {
                        let t = e1?.get(this.data.id)?.rotation;
                        void 0 === t && (t = this.rotation);
                        if (0 === t) return r.IDENTITY_MATRIX;
                        const a = this.data.rect[2] - this.data.rect[0], i = this.data.rect[3] - this.data.rect[1];
                        return (0, n.getRotationMatrix)(t, a, i);
                    }
                    getBorderAndBackgroundAppearances(e1) {
                        let t = e1?.get(this.data.id)?.rotation;
                        void 0 === t && (t = this.rotation);
                        if (!this.backgroundColor && !this.borderColor) return "";
                        const a = this.data.rect[2] - this.data.rect[0], r = this.data.rect[3] - this.data.rect[1], n = 0 === t || 180 === t ? `0 0 ${a} ${r} re` : `0 0 ${r} ${a} re`;
                        let s = "";
                        this.backgroundColor && (s = `${(0, i.getPdfColor)(this.backgroundColor, !0)} ${n} f `);
                        if (this.borderColor) s += `${this.borderStyle.width || 1} w ${(0, i.getPdfColor)(this.borderColor, !1)} ${n} S `;
                        return s;
                    }
                    async getOperatorList(e1, t, a, n, i) {
                        if (n && !(this instanceof SignatureWidgetAnnotation) && !this.data.noHTML && !this.data.hasOwnCanvas) return {
                            opList: new p.OperatorList,
                            separateForm: !0,
                            separateCanvas: !1
                        };
                        if (!this._hasText) return super.getOperatorList(e1, t, a, n, i);
                        const s = await this._getAppearance(e1, t, a, i);
                        if (this.appearance && null === s) return super.getOperatorList(e1, t, a, n, i);
                        const c = new p.OperatorList;
                        if (!this._defaultAppearance || null === s) return {
                            opList: c,
                            separateForm: !1,
                            separateCanvas: !1
                        };
                        const l = !!(this.data.hasOwnCanvas && a & r.RenderingIntentFlag.DISPLAY), h = [
                            0,
                            0,
                            this.data.rect[2] - this.data.rect[0],
                            this.data.rect[3] - this.data.rect[1]
                        ], u = getTransformMatrix(this.data.rect, h, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]);
                        let d;
                        this.oc && (d = await e1.parseMarkedContentProps(this.oc, null));
                        void 0 !== d && c.addOp(r.OPS.beginMarkedContentProps, [
                            "OC",
                            d
                        ]);
                        c.addOp(r.OPS.beginAnnotation, [
                            this.data.id,
                            this.data.rect,
                            u,
                            this.getRotationMatrix(i),
                            l
                        ]);
                        const f = new o.StringStream(s);
                        await e1.getOperatorList({
                            stream: f,
                            task: t,
                            resources: this._fieldResources.mergedResources,
                            operatorList: c
                        });
                        c.addOp(r.OPS.endAnnotation, []);
                        void 0 !== d && c.addOp(r.OPS.endMarkedContent, []);
                        return {
                            opList: c,
                            separateForm: !1,
                            separateCanvas: l
                        };
                    }
                    _getMKDict(e1) {
                        const t = new s.Dict(null);
                        e1 && t.set("R", e1);
                        this.borderColor && t.set("BC", getPdfColorArray(this.borderColor));
                        this.backgroundColor && t.set("BG", getPdfColorArray(this.backgroundColor));
                        return t.size > 0 ? t : null;
                    }
                    amendSavedDict(e1, t) {}
                    async save(e1, t, a) {
                        const i = a?.get(this.data.id);
                        let c = i?.value, l = i?.rotation;
                        if (c === this.data.fieldValue || void 0 === c) {
                            if (!this._hasValueFromXFA && void 0 === l) return null;
                            c ||= this.data.fieldValue;
                        }
                        if (void 0 === l && !this._hasValueFromXFA && Array.isArray(c) && Array.isArray(this.data.fieldValue) && c.length === this.data.fieldValue.length && c.every((e1, t)=>e1 === this.data.fieldValue[t])) return null;
                        void 0 === l && (l = this.rotation);
                        let h = null;
                        if (!this._needAppearances) {
                            h = await this._getAppearance(e1, t, r.RenderingIntentFlag.SAVE, a);
                            if (null === h) return null;
                        }
                        let u = !1;
                        if (h?.needAppearances) {
                            u = !0;
                            h = null;
                        }
                        const { xref: d } = e1, f = d.fetchIfRef(this.ref);
                        if (!(f instanceof s.Dict)) return null;
                        const g = new s.Dict(d);
                        for (const e1 of f.getKeys())"AP" !== e1 && g.set(e1, f.getRaw(e1));
                        const p = {
                            path: this.data.fieldName,
                            value: c
                        }, encoder = (e1)=>(0, n.isAscii)(e1) ? e1 : (0, n.stringToUTF16String)(e1, !0);
                        g.set("V", Array.isArray(c) ? c.map(encoder) : encoder(c));
                        this.amendSavedDict(a, g);
                        const b = this._getMKDict(l);
                        b && g.set("MK", b);
                        const y = [], w = [
                            {
                                ref: this.ref,
                                data: "",
                                xfa: p,
                                needAppearances: u
                            }
                        ];
                        if (null !== h) {
                            const e1 = d.getNewTemporaryRef(), t = new s.Dict(d);
                            g.set("AP", t);
                            t.set("N", e1);
                            const n = this._getSaveFieldResources(d), i = new o.StringStream(h), c = i.dict = new s.Dict(d);
                            c.set("Subtype", s.Name.get("Form"));
                            c.set("Resources", n);
                            c.set("BBox", [
                                0,
                                0,
                                this.data.rect[2] - this.data.rect[0],
                                this.data.rect[3] - this.data.rect[1]
                            ]);
                            const l = this.getRotationMatrix(a);
                            l !== r.IDENTITY_MATRIX && c.set("Matrix", l);
                            await (0, m.writeObject)(e1, i, y, d);
                            w.push({
                                ref: e1,
                                data: y.join(""),
                                xfa: null,
                                needAppearances: !1
                            });
                            y.length = 0;
                        }
                        g.set("M", `D:${(0, r.getModificationDate)()}`);
                        await (0, m.writeObject)(this.ref, g, y, d);
                        w[0].data = y.join("");
                        return w;
                    }
                    async _getAppearance(e1, t, a, s) {
                        if (this.hasFieldFlag(r.AnnotationFieldFlag.PASSWORD)) return null;
                        const o = s?.get(this.data.id);
                        let c, l;
                        if (o) {
                            c = o.formattedValue || o.value;
                            l = o.rotation;
                        }
                        if (void 0 === l && void 0 === c && !this._needAppearances && (!this._hasValueFromXFA || this.appearance)) return null;
                        const h = this.getBorderAndBackgroundAppearances(s);
                        if (void 0 === c) {
                            c = this.data.fieldValue;
                            if (!c) return `/Tx BMC q ${h}Q EMC`;
                        }
                        Array.isArray(c) && 1 === c.length && (c = c[0]);
                        (0, r.assert)("string" == typeof c, "Expected `value` to be a string.");
                        c = c.trim();
                        if (this.data.combo) {
                            const e1 = this.data.options.find(({ exportValue: e1 })=>c === e1);
                            c = e1?.displayValue || c;
                        }
                        if ("" === c) return `/Tx BMC q ${h}Q EMC`;
                        void 0 === l && (l = this.rotation);
                        let u, d = -1;
                        if (this.data.multiLine) {
                            u = c.split(/\r\n?|\n/).map((e1)=>e1.normalize("NFC"));
                            d = u.length;
                        } else u = [
                            c.replace(/\r\n?|\n/, "").normalize("NFC")
                        ];
                        let f = this.data.rect[3] - this.data.rect[1], g = this.data.rect[2] - this.data.rect[0];
                        90 !== l && 270 !== l || ([g, f] = [
                            f,
                            g
                        ]);
                        this._defaultAppearance || (this.data.defaultAppearanceData = (0, i.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
                        let p, m, b, y = await WidgetAnnotation._getFontData(e1, t, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        const w = [];
                        let S = !1;
                        for (const e1 of u){
                            const t = y.encodeString(e1);
                            t.length > 1 && (S = !0);
                            w.push(t.join(""));
                        }
                        if (S && a & r.RenderingIntentFlag.SAVE) return {
                            needAppearances: !0
                        };
                        if (S && this._isOffscreenCanvasSupported) {
                            const a = this.data.comb ? "monospace" : "sans-serif", r = new i.FakeUnicodeFont(e1.xref, a), s = r.createFontResources(u.join("")), o = s.getRaw("Font");
                            if (this._fieldResources.mergedResources.has("Font")) {
                                const e1 = this._fieldResources.mergedResources.get("Font");
                                for (const t of o.getKeys())e1.set(t, o.getRaw(t));
                            } else this._fieldResources.mergedResources.set("Font", o);
                            const l = r.fontName.name;
                            y = await WidgetAnnotation._getFontData(e1, t, {
                                fontName: l,
                                fontSize: 0
                            }, s);
                            for(let e1 = 0, t = w.length; e1 < t; e1++)w[e1] = (0, n.stringToUTF16String)(u[e1]);
                            const h = Object.assign(Object.create(null), this.data.defaultAppearanceData);
                            this.data.defaultAppearanceData.fontSize = 0;
                            this.data.defaultAppearanceData.fontName = l;
                            [p, m, b] = this._computeFontSize(f - 2, g - 4, c, y, d);
                            this.data.defaultAppearanceData = h;
                        } else {
                            this._isOffscreenCanvasSupported || (0, r.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");
                            [p, m, b] = this._computeFontSize(f - 2, g - 4, c, y, d);
                        }
                        let x = y.descent;
                        x = isNaN(x) ? r.BASELINE_FACTOR * b : Math.max(r.BASELINE_FACTOR * b, Math.abs(x) * m);
                        const C = Math.min(Math.floor((f - m) / 2), 1), k = this.data.textAlignment;
                        if (this.data.multiLine) return this._getMultilineAppearance(p, w, y, m, g, f, k, 2, C, x, b, s);
                        if (this.data.comb) return this._getCombAppearance(p, y, w[0], m, g, f, 2, C, x, b, s);
                        const v = C + x;
                        if (0 === k || k > 2) return `/Tx BMC q ${h}BT ` + p + ` 1 0 0 1 ${(0, n.numberToString)(2)} ${(0, n.numberToString)(v)} Tm (${(0, n.escapeString)(w[0])}) Tj ET Q EMC`;
                        return `/Tx BMC q ${h}BT ` + p + ` 1 0 0 1 0 0 Tm ${this._renderText(w[0], y, m, g, k, {
                            shift: 0
                        }, 2, v)} ET Q EMC`;
                    }
                    static async _getFontData(e1, t, a, r) {
                        const n = new p.OperatorList, i = {
                            font: null,
                            clone () {
                                return this;
                            }
                        }, { fontName: o, fontSize: c } = a;
                        await e1.handleSetFont(r, [
                            o && s.Name.get(o),
                            c
                        ], null, n, t, i, null);
                        return i.font;
                    }
                    _getTextWidth(e1, t) {
                        return t.charsToGlyphs(e1).reduce((e1, t)=>e1 + t.width, 0) / 1e3;
                    }
                    _computeFontSize(e1, t, a, n, s) {
                        let { fontSize: o } = this.data.defaultAppearanceData, c = (o || 12) * r.LINE_FACTOR, l = Math.round(e1 / c);
                        if (!o) {
                            const roundWithTwoDigits = (e1)=>Math.floor(100 * e1) / 100;
                            if (-1 === s) {
                                const i = this._getTextWidth(a, n);
                                o = roundWithTwoDigits(Math.min(e1 / r.LINE_FACTOR, i > t ? t / i : 1 / 0));
                                l = 1;
                            } else {
                                const i = a.split(/\r\n?|\n/), h = [];
                                for (const e1 of i){
                                    const t = n.encodeString(e1).join(""), a = n.charsToGlyphs(t), r = n.getCharPositions(t);
                                    h.push({
                                        line: t,
                                        glyphs: a,
                                        positions: r
                                    });
                                }
                                const isTooBig = (a)=>{
                                    let r = 0;
                                    for (const i of h){
                                        r += this._splitLine(null, n, a, t, i).length * a;
                                        if (r > e1) return !0;
                                    }
                                    return !1;
                                };
                                l = Math.max(l, s);
                                for(;;){
                                    c = e1 / l;
                                    o = roundWithTwoDigits(c / r.LINE_FACTOR);
                                    if (!isTooBig(o)) break;
                                    l++;
                                }
                            }
                            const { fontName: h, fontColor: u } = this.data.defaultAppearanceData;
                            this._defaultAppearance = (0, i.createDefaultAppearance)({
                                fontSize: o,
                                fontName: h,
                                fontColor: u
                            });
                        }
                        return [
                            this._defaultAppearance,
                            o,
                            e1 / l
                        ];
                    }
                    _renderText(e1, t, a, r, i, s, o, c) {
                        let l;
                        if (1 === i) l = (r - this._getTextWidth(e1, t) * a) / 2;
                        else if (2 === i) l = r - this._getTextWidth(e1, t) * a - o;
                        else l = o;
                        const h = (0, n.numberToString)(l - s.shift);
                        s.shift = l;
                        return `${h} ${c = (0, n.numberToString)(c)} Td (${(0, n.escapeString)(e1)}) Tj`;
                    }
                    _getSaveFieldResources(e1) {
                        const { localResources: t, appearanceResources: a, acroFormResources: r } = this._fieldResources, n = this.data.defaultAppearanceData?.fontName;
                        if (!n) return t || s.Dict.empty;
                        for (const e1 of [
                            t,
                            a
                        ])if (e1 instanceof s.Dict) {
                            const t = e1.get("Font");
                            if (t instanceof s.Dict && t.has(n)) return e1;
                        }
                        if (r instanceof s.Dict) {
                            const a = r.get("Font");
                            if (a instanceof s.Dict && a.has(n)) {
                                const r = new s.Dict(e1);
                                r.set(n, a.getRaw(n));
                                const i = new s.Dict(e1);
                                i.set("Font", r);
                                return s.Dict.merge({
                                    xref: e1,
                                    dictArray: [
                                        i,
                                        t
                                    ],
                                    mergeSubDicts: !0
                                });
                            }
                        }
                        return t || s.Dict.empty;
                    }
                    getFieldObject() {
                        return null;
                    }
                }
                class TextWidgetAnnotation extends WidgetAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML;
                        this._hasText = !0;
                        const t = e1.dict;
                        "string" != typeof this.data.fieldValue && (this.data.fieldValue = "");
                        let a = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "Q"
                        });
                        (!Number.isInteger(a) || a < 0 || a > 2) && (a = null);
                        this.data.textAlignment = a;
                        let i = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "MaxLen"
                        });
                        (!Number.isInteger(i) || i < 0) && (i = 0);
                        this.data.maxLen = i;
                        this.data.multiLine = this.hasFieldFlag(r.AnnotationFieldFlag.MULTILINE);
                        this.data.comb = this.hasFieldFlag(r.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(r.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(r.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(r.AnnotationFieldFlag.FILESELECT) && 0 !== this.data.maxLen;
                        this.data.doNotScroll = this.hasFieldFlag(r.AnnotationFieldFlag.DONOTSCROLL);
                    }
                    get hasTextContent() {
                        return !!this.appearance && !this._needAppearances;
                    }
                    _getCombAppearance(e1, t, a, r, i, s, o, c, l, h, u) {
                        const d = i / this.data.maxLen, f = this.getBorderAndBackgroundAppearances(u), g = [], p = t.getCharPositions(a);
                        for (const [e1, t] of p)g.push(`(${(0, n.escapeString)(a.substring(e1, t))}) Tj`);
                        const m = g.join(` ${(0, n.numberToString)(d)} 0 Td `);
                        return `/Tx BMC q ${f}BT ` + e1 + ` 1 0 0 1 ${(0, n.numberToString)(o)} ${(0, n.numberToString)(c + l)} Tm ${m} ET Q EMC`;
                    }
                    _getMultilineAppearance(e1, t, a, r, i, s, o, c, l, h, u, d) {
                        const f = [], g = i - 2 * c, p = {
                            shift: 0
                        };
                        for(let e1 = 0, n = t.length; e1 < n; e1++){
                            const n = t[e1], s = this._splitLine(n, a, r, g);
                            for(let t = 0, n = s.length; t < n; t++){
                                const n = s[t], d = 0 === e1 && 0 === t ? -l - (u - h) : -u;
                                f.push(this._renderText(n, a, r, i, o, p, c, d));
                            }
                        }
                        const m = this.getBorderAndBackgroundAppearances(d), b = f.join("\n");
                        return `/Tx BMC q ${m}BT ` + e1 + ` 1 0 0 1 0 ${(0, n.numberToString)(s)} Tm ${b} ET Q EMC`;
                    }
                    _splitLine(e1, t, a, r, n = {}) {
                        e1 = n.line || e1;
                        const i = n.glyphs || t.charsToGlyphs(e1);
                        if (i.length <= 1) return [
                            e1
                        ];
                        const s = n.positions || t.getCharPositions(e1), o = a / 1e3, c = [];
                        let l = -1, h = -1, u = -1, d = 0, f = 0;
                        for(let t = 0, a = i.length; t < a; t++){
                            const [a, n] = s[t], g = i[t], p = g.width * o;
                            if (" " === g.unicode) {
                                if (f + p > r) {
                                    c.push(e1.substring(d, a));
                                    d = a;
                                    f = p;
                                    l = -1;
                                    u = -1;
                                } else {
                                    f += p;
                                    l = a;
                                    h = n;
                                    u = t;
                                }
                            } else if (f + p > r) {
                                if (-1 !== l) {
                                    c.push(e1.substring(d, h));
                                    d = h;
                                    t = u + 1;
                                    l = -1;
                                    f = 0;
                                } else {
                                    c.push(e1.substring(d, a));
                                    d = a;
                                    f = p;
                                }
                            } else f += p;
                        }
                        d < e1.length && c.push(e1.substring(d, e1.length));
                        return c;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue,
                            defaultValue: this.data.defaultFieldValue || "",
                            multiline: this.data.multiLine,
                            password: this.hasFieldFlag(r.AnnotationFieldFlag.PASSWORD),
                            charLimit: this.data.maxLen,
                            comb: this.data.comb,
                            editable: !this.data.readOnly,
                            hidden: this.data.hidden,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: "text"
                        };
                    }
                }
                class ButtonWidgetAnnotation extends WidgetAnnotation {
                    constructor(e1){
                        super(e1);
                        this.checkedAppearance = null;
                        this.uncheckedAppearance = null;
                        this.data.checkBox = !this.hasFieldFlag(r.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(r.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.radioButton = this.hasFieldFlag(r.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(r.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.pushButton = this.hasFieldFlag(r.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.isTooltipOnly = !1;
                        if (this.data.checkBox) this._processCheckBox(e1);
                        else if (this.data.radioButton) this._processRadioButton(e1);
                        else if (this.data.pushButton) {
                            this.data.hasOwnCanvas = !0;
                            this._processPushButton(e1);
                        } else (0, r.warn)("Invalid field flags for button widget annotation");
                    }
                    async getOperatorList(e1, t, a, n, i) {
                        if (this.data.pushButton) return super.getOperatorList(e1, t, a, !1, i);
                        let s = null, o = null;
                        if (i) {
                            const e1 = i.get(this.data.id);
                            s = e1 ? e1.value : null;
                            o = e1 ? e1.rotation : null;
                        }
                        if (null === s && this.appearance) return super.getOperatorList(e1, t, a, n, i);
                        null == s && (s = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
                        const c = s ? this.checkedAppearance : this.uncheckedAppearance;
                        if (c) {
                            const s = this.appearance, l = c.dict.getArray("Matrix") || r.IDENTITY_MATRIX;
                            o && c.dict.set("Matrix", this.getRotationMatrix(i));
                            this.appearance = c;
                            const h = super.getOperatorList(e1, t, a, n, i);
                            this.appearance = s;
                            c.dict.set("Matrix", l);
                            return h;
                        }
                        return {
                            opList: new p.OperatorList,
                            separateForm: !1,
                            separateCanvas: !1
                        };
                    }
                    async save(e1, t, a) {
                        return this.data.checkBox ? this._saveCheckbox(e1, t, a) : this.data.radioButton ? this._saveRadioButton(e1, t, a) : null;
                    }
                    async _saveCheckbox(e1, t, a) {
                        if (!a) return null;
                        const n = a.get(this.data.id);
                        let i = n?.rotation, o = n?.value;
                        if (void 0 === i) {
                            if (void 0 === o) return null;
                            if (this.data.fieldValue === this.data.exportValue === o) return null;
                        }
                        const c = e1.xref.fetchIfRef(this.ref);
                        if (!(c instanceof s.Dict)) return null;
                        void 0 === i && (i = this.rotation);
                        void 0 === o && (o = this.data.fieldValue === this.data.exportValue);
                        const l = {
                            path: this.data.fieldName,
                            value: o ? this.data.exportValue : ""
                        }, h = s.Name.get(o ? this.data.exportValue : "Off");
                        c.set("V", h);
                        c.set("AS", h);
                        c.set("M", `D:${(0, r.getModificationDate)()}`);
                        const u = this._getMKDict(i);
                        u && c.set("MK", u);
                        const d = [];
                        await (0, m.writeObject)(this.ref, c, d, e1.xref);
                        return [
                            {
                                ref: this.ref,
                                data: d.join(""),
                                xfa: l
                            }
                        ];
                    }
                    async _saveRadioButton(e1, t, a) {
                        if (!a) return null;
                        const n = a.get(this.data.id);
                        let i = n?.rotation, o = n?.value;
                        if (void 0 === i) {
                            if (void 0 === o) return null;
                            if (this.data.fieldValue === this.data.buttonValue === o) return null;
                        }
                        const c = e1.xref.fetchIfRef(this.ref);
                        if (!(c instanceof s.Dict)) return null;
                        void 0 === o && (o = this.data.fieldValue === this.data.buttonValue);
                        void 0 === i && (i = this.rotation);
                        const l = {
                            path: this.data.fieldName,
                            value: o ? this.data.buttonValue : ""
                        }, h = s.Name.get(o ? this.data.buttonValue : "Off"), u = [];
                        let d = null;
                        if (o) {
                            if (this.parent instanceof s.Ref) {
                                const t = e1.xref.fetch(this.parent);
                                t.set("V", h);
                                await (0, m.writeObject)(this.parent, t, u, e1.xref);
                                d = u.join("");
                                u.length = 0;
                            } else this.parent instanceof s.Dict && this.parent.set("V", h);
                        }
                        c.set("AS", h);
                        c.set("M", `D:${(0, r.getModificationDate)()}`);
                        const f = this._getMKDict(i);
                        f && c.set("MK", f);
                        await (0, m.writeObject)(this.ref, c, u, e1.xref);
                        const g = [
                            {
                                ref: this.ref,
                                data: u.join(""),
                                xfa: l
                            }
                        ];
                        d && g.push({
                            ref: this.parent,
                            data: d,
                            xfa: null
                        });
                        return g;
                    }
                    _getDefaultCheckedAppearance(e1, t) {
                        const a = this.data.rect[2] - this.data.rect[0], i = this.data.rect[3] - this.data.rect[1], c = [
                            0,
                            0,
                            a,
                            i
                        ], l = .8 * Math.min(a, i);
                        let h, u;
                        if ("check" === t) {
                            h = {
                                width: .755 * l,
                                height: .705 * l
                            };
                            u = "3";
                        } else if ("disc" === t) {
                            h = {
                                width: .791 * l,
                                height: .705 * l
                            };
                            u = "l";
                        } else (0, r.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${t}`);
                        const d = `q BT /PdfJsZaDb ${l} Tf 0 g ${(0, n.numberToString)((a - h.width) / 2)} ${(0, n.numberToString)((i - h.height) / 2)} Td (${u}) Tj ET Q`, f = new s.Dict(e1.xref);
                        f.set("FormType", 1);
                        f.set("Subtype", s.Name.get("Form"));
                        f.set("Type", s.Name.get("XObject"));
                        f.set("BBox", c);
                        f.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]);
                        f.set("Length", d.length);
                        const g = new s.Dict(e1.xref), p = new s.Dict(e1.xref);
                        p.set("PdfJsZaDb", this.fallbackFontDict);
                        g.set("Font", p);
                        f.set("Resources", g);
                        this.checkedAppearance = new o.StringStream(d);
                        this.checkedAppearance.dict = f;
                        this._streams.push(this.checkedAppearance);
                    }
                    _processCheckBox(e1) {
                        const t = e1.dict.get("AP");
                        if (!(t instanceof s.Dict)) return;
                        const a = t.get("N");
                        if (!(a instanceof s.Dict)) return;
                        const r = this._decodeFormValue(e1.dict.get("AS"));
                        "string" == typeof r && (this.data.fieldValue = r);
                        const n = null !== this.data.fieldValue && "Off" !== this.data.fieldValue ? this.data.fieldValue : "Yes", i = a.getKeys();
                        if (0 === i.length) i.push("Off", n);
                        else if (1 === i.length) "Off" === i[0] ? i.push(n) : i.unshift("Off");
                        else if (i.includes(n)) {
                            i.length = 0;
                            i.push("Off", n);
                        } else {
                            const e1 = i.find((e1)=>"Off" !== e1);
                            i.length = 0;
                            i.push("Off", e1);
                        }
                        i.includes(this.data.fieldValue) || (this.data.fieldValue = "Off");
                        this.data.exportValue = i[1];
                        const o = a.get(this.data.exportValue);
                        this.checkedAppearance = o instanceof c.BaseStream ? o : null;
                        const l = a.get("Off");
                        this.uncheckedAppearance = l instanceof c.BaseStream ? l : null;
                        this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(e1, "check");
                        this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        null === this.data.defaultFieldValue && (this.data.defaultFieldValue = "Off");
                    }
                    _processRadioButton(e1) {
                        this.data.fieldValue = this.data.buttonValue = null;
                        const t = e1.dict.get("Parent");
                        if (t instanceof s.Dict) {
                            this.parent = e1.dict.getRaw("Parent");
                            const a = t.get("V");
                            a instanceof s.Name && (this.data.fieldValue = this._decodeFormValue(a));
                        }
                        const a = e1.dict.get("AP");
                        if (!(a instanceof s.Dict)) return;
                        const r = a.get("N");
                        if (!(r instanceof s.Dict)) return;
                        for (const e1 of r.getKeys())if ("Off" !== e1) {
                            this.data.buttonValue = this._decodeFormValue(e1);
                            break;
                        }
                        const n = r.get(this.data.buttonValue);
                        this.checkedAppearance = n instanceof c.BaseStream ? n : null;
                        const i = r.get("Off");
                        this.uncheckedAppearance = i instanceof c.BaseStream ? i : null;
                        this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(e1, "disc");
                        this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        null === this.data.defaultFieldValue && (this.data.defaultFieldValue = "Off");
                    }
                    _processPushButton(e1) {
                        const { dict: t, annotationGlobals: a } = e1;
                        if (t.has("A") || t.has("AA") || this.data.alternativeText) {
                            this.data.isTooltipOnly = !t.has("A") && !t.has("AA");
                            h.Catalog.parseDestDictionary({
                                destDict: t,
                                resultObj: this.data,
                                docBaseUrl: a.baseUrl,
                                docAttachments: a.attachments
                            });
                        } else (0, r.warn)("Push buttons without action dictionaries are not supported");
                    }
                    getFieldObject() {
                        let e1, t = "button";
                        if (this.data.checkBox) {
                            t = "checkbox";
                            e1 = this.data.exportValue;
                        } else if (this.data.radioButton) {
                            t = "radiobutton";
                            e1 = this.data.buttonValue;
                        }
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue || "Off",
                            defaultValue: this.data.defaultFieldValue,
                            exportValues: e1,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: t
                        };
                    }
                    get fallbackFontDict() {
                        const e1 = new s.Dict;
                        e1.set("BaseFont", s.Name.get("ZapfDingbats"));
                        e1.set("Type", s.Name.get("FallbackType"));
                        e1.set("Subtype", s.Name.get("FallbackType"));
                        e1.set("Encoding", s.Name.get("ZapfDingbatsEncoding"));
                        return (0, r.shadow)(this, "fallbackFontDict", e1);
                    }
                }
                class ChoiceWidgetAnnotation extends WidgetAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.indices = t.getArray("I");
                        this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0;
                        this.data.options = [];
                        const i = (0, n.getInheritableProperty)({
                            dict: t,
                            key: "Opt"
                        });
                        if (Array.isArray(i)) for(let e1 = 0, t = i.length; e1 < t; e1++){
                            const t = a.fetchIfRef(i[e1]), r = Array.isArray(t);
                            this.data.options[e1] = {
                                exportValue: this._decodeFormValue(r ? a.fetchIfRef(t[0]) : t),
                                displayValue: this._decodeFormValue(r ? a.fetchIfRef(t[1]) : t)
                            };
                        }
                        if (this.hasIndices) {
                            this.data.fieldValue = [];
                            const e1 = this.data.options.length;
                            for (const t of this.indices)Number.isInteger(t) && t >= 0 && t < e1 && this.data.fieldValue.push(this.data.options[t].exportValue);
                        } else "string" == typeof this.data.fieldValue ? this.data.fieldValue = [
                            this.data.fieldValue
                        ] : this.data.fieldValue || (this.data.fieldValue = []);
                        this.data.combo = this.hasFieldFlag(r.AnnotationFieldFlag.COMBO);
                        this.data.multiSelect = this.hasFieldFlag(r.AnnotationFieldFlag.MULTISELECT);
                        this._hasText = !0;
                    }
                    getFieldObject() {
                        const e1 = this.data.combo ? "combobox" : "listbox", t = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                        return {
                            id: this.data.id,
                            value: t,
                            defaultValue: this.data.defaultFieldValue,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            numItems: this.data.fieldValue.length,
                            multipleSelection: this.data.multiSelect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            items: this.data.options,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: e1
                        };
                    }
                    amendSavedDict(e1, t) {
                        if (!this.hasIndices) return;
                        let a = e1?.get(this.data.id)?.value;
                        Array.isArray(a) || (a = [
                            a
                        ]);
                        const r = [], { options: n } = this.data;
                        for(let e1 = 0, t = 0, i = n.length; e1 < i; e1++)if (n[e1].exportValue === a[t]) {
                            r.push(e1);
                            t += 1;
                        }
                        t.set("I", r);
                    }
                    async _getAppearance(e1, t, a, n) {
                        if (this.data.combo) return super._getAppearance(e1, t, a, n);
                        let s, o;
                        const c = n?.get(this.data.id);
                        if (c) {
                            o = c.rotation;
                            s = c.value;
                        }
                        if (void 0 === o && void 0 === s && !this._needAppearances) return null;
                        void 0 === s ? s = this.data.fieldValue : Array.isArray(s) || (s = [
                            s
                        ]);
                        let l = this.data.rect[3] - this.data.rect[1], h = this.data.rect[2] - this.data.rect[0];
                        90 !== o && 270 !== o || ([h, l] = [
                            l,
                            h
                        ]);
                        const u = this.data.options.length, d = [];
                        for(let e1 = 0; e1 < u; e1++){
                            const { exportValue: t } = this.data.options[e1];
                            s.includes(t) && d.push(e1);
                        }
                        this._defaultAppearance || (this.data.defaultAppearanceData = (0, i.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
                        const f = await WidgetAnnotation._getFontData(e1, t, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        let g, { fontSize: p } = this.data.defaultAppearanceData;
                        if (p) g = this._defaultAppearance;
                        else {
                            const e1 = (l - 1) / u;
                            let t, a = -1;
                            for (const { displayValue: e1 } of this.data.options){
                                const r = this._getTextWidth(e1, f);
                                if (r > a) {
                                    a = r;
                                    t = e1;
                                }
                            }
                            [g, p] = this._computeFontSize(e1, h - 4, t, f, -1);
                        }
                        const m = p * r.LINE_FACTOR, b = (m - p) / 2, y = Math.floor(l / m);
                        let w = 0;
                        if (d.length > 0) {
                            const e1 = Math.min(...d), t = Math.max(...d);
                            w = Math.max(0, t - y + 1);
                            w > e1 && (w = e1);
                        }
                        const S = Math.min(w + y + 1, u), x = [
                            "/Tx BMC q",
                            `1 1 ${h} ${l} re W n`
                        ];
                        if (d.length) {
                            x.push("0.600006 0.756866 0.854904 rg");
                            for (const e1 of d)w <= e1 && e1 < S && x.push(`1 ${l - (e1 - w + 1) * m} ${h} ${m} re f`);
                        }
                        x.push("BT", g, `1 0 0 1 0 ${l} Tm`);
                        const C = {
                            shift: 0
                        };
                        for(let e1 = w; e1 < S; e1++){
                            const { displayValue: t } = this.data.options[e1], a = e1 === w ? b : 0;
                            x.push(this._renderText(t, f, p, h, 0, C, 2, -m + a));
                        }
                        x.push("ET Q EMC");
                        return x.join("\n");
                    }
                }
                class SignatureWidgetAnnotation extends WidgetAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.fieldValue = null;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: null,
                            page: this.data.pageIndex,
                            type: "signature"
                        };
                    }
                }
                class TextAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.noRotate = !0;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: t } = e1;
                        this.data.annotationType = r.AnnotationType.TEXT;
                        if (this.data.hasAppearance) this.data.name = "NoIcon";
                        else {
                            this.data.rect[1] = this.data.rect[3] - 22;
                            this.data.rect[2] = this.data.rect[0] + 22;
                            this.data.name = t.has("Name") ? t.get("Name").name : "Note";
                        }
                        if (t.has("State")) {
                            this.data.state = t.get("State") || null;
                            this.data.stateModel = t.get("StateModel") || null;
                        } else {
                            this.data.state = null;
                            this.data.stateModel = null;
                        }
                    }
                }
                class LinkAnnotation extends Annotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, annotationGlobals: a } = e1;
                        this.data.annotationType = r.AnnotationType.LINK;
                        const n = getQuadPoints(t, this.rectangle);
                        n && (this.data.quadPoints = n);
                        this.data.borderColor ||= this.data.color;
                        h.Catalog.parseDestDictionary({
                            destDict: t,
                            resultObj: this.data,
                            docBaseUrl: a.baseUrl,
                            docAttachments: a.attachments
                        });
                    }
                }
                class PopupAnnotation extends Annotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t } = e1;
                        this.data.annotationType = r.AnnotationType.POPUP;
                        this.data.rect[0] !== this.data.rect[2] && this.data.rect[1] !== this.data.rect[3] || (this.data.rect = null);
                        let a = t.get("Parent");
                        if (!a) {
                            (0, r.warn)("Popup annotation has a missing or invalid parent annotation.");
                            return;
                        }
                        const n = a.getArray("Rect");
                        this.data.parentRect = Array.isArray(n) && 4 === n.length ? r.Util.normalizeRect(n) : null;
                        const i = a.get("RT");
                        (0, s.isName)(i, r.AnnotationReplyType.GROUP) && (a = a.get("IRT"));
                        if (a.has("M")) {
                            this.setModificationDate(a.get("M"));
                            this.data.modificationDate = this.modificationDate;
                        } else this.data.modificationDate = null;
                        if (a.has("C")) {
                            this.setColor(a.getArray("C"));
                            this.data.color = this.color;
                        } else this.data.color = null;
                        if (!this.viewable) {
                            const e1 = a.get("F");
                            this._isViewable(e1) && this.setFlags(e1);
                        }
                        this.setTitle(a.get("T"));
                        this.data.titleObj = this._title;
                        this.setContents(a.get("Contents"));
                        this.data.contentsObj = this._contents;
                        a.has("RC") && (this.data.richText = b.XFAFactory.getRichTextAsHtml(a.get("RC")));
                        this.data.open = !!t.get("Open");
                    }
                }
                t.PopupAnnotation = PopupAnnotation;
                class FreeTextAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.hasOwnCanvas = !0;
                        const { evaluatorOptions: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.FREETEXT;
                        this.setDefaultAppearance(e1);
                        if (this.appearance) {
                            const { fontColor: e1, fontSize: r } = (0, i.parseAppearanceStream)(this.appearance, t, a);
                            this.data.defaultAppearanceData.fontColor = e1;
                            this.data.defaultAppearanceData.fontSize = r || 10;
                        } else if (this._isOffscreenCanvasSupported) {
                            const t = e1.dict.get("CA"), r = new i.FakeUnicodeFont(a, "sans-serif");
                            this.data.defaultAppearanceData.fontSize ||= 10;
                            const { fontColor: n, fontSize: s } = this.data.defaultAppearanceData;
                            this.appearance = r.createAppearance(this._contents.str, this.rectangle, this.rotation, s, n, t);
                            this._streams.push(this.appearance, i.FakeUnicodeFont.toUnicodeStream);
                        } else (0, r.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
                    }
                    get hasTextContent() {
                        return !!this.appearance;
                    }
                    static createNewDict(e1, t, { apRef: a, ap: o }) {
                        const { color: c, fontSize: l, rect: h, rotation: u, user: d, value: f } = e1, g = new s.Dict(t);
                        g.set("Type", s.Name.get("Annot"));
                        g.set("Subtype", s.Name.get("FreeText"));
                        g.set("CreationDate", `D:${(0, r.getModificationDate)()}`);
                        g.set("Rect", h);
                        const p = `/Helv ${l} Tf ${(0, i.getPdfColor)(c, !0)}`;
                        g.set("DA", p);
                        g.set("Contents", (0, n.isAscii)(f) ? f : (0, n.stringToUTF16String)(f, !0));
                        g.set("F", 4);
                        g.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        g.set("Rotate", u);
                        d && g.set("T", (0, n.isAscii)(d) ? d : (0, n.stringToUTF16String)(d, !0));
                        if (a || o) {
                            const e1 = new s.Dict(t);
                            g.set("AP", e1);
                            a ? e1.set("N", a) : e1.set("N", o);
                        }
                        return g;
                    }
                    static async createNewAppearanceStream(e1, t, a) {
                        const { baseFontRef: c, evaluator: l, task: h } = a, { color: u, fontSize: d, rect: f, rotation: g, value: p } = e1, m = new s.Dict(t), b = new s.Dict(t);
                        if (c) b.set("Helv", c);
                        else {
                            const e1 = new s.Dict(t);
                            e1.set("BaseFont", s.Name.get("Helvetica"));
                            e1.set("Type", s.Name.get("Font"));
                            e1.set("Subtype", s.Name.get("Type1"));
                            e1.set("Encoding", s.Name.get("WinAnsiEncoding"));
                            b.set("Helv", e1);
                        }
                        m.set("Font", b);
                        const y = await WidgetAnnotation._getFontData(l, h, {
                            fontName: "Helv",
                            fontSize: d
                        }, m), [w, S, x, C] = f;
                        let k = x - w, v = C - S;
                        g % 180 != 0 && ([k, v] = [
                            v,
                            k
                        ]);
                        const F = p.split("\n"), O = d / 1e3;
                        let T = -1 / 0;
                        const M = [];
                        for (let e1 of F){
                            const t = y.encodeString(e1);
                            if (t.length > 1) return null;
                            e1 = t.join("");
                            M.push(e1);
                            let a = 0;
                            const r = y.charsToGlyphs(e1);
                            for (const e1 of r)a += e1.width * O;
                            T = Math.max(T, a);
                        }
                        let D = 1;
                        T > k && (D = k / T);
                        let E = 1;
                        const N = r.LINE_FACTOR * d, R = (r.LINE_FACTOR - r.LINE_DESCENT_FACTOR) * d, L = N * F.length;
                        L > v && (E = v / L);
                        const $ = d * Math.min(D, E);
                        let _, j, U;
                        switch(g){
                            case 0:
                                U = [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                                j = [
                                    f[0],
                                    f[1],
                                    k,
                                    v
                                ];
                                _ = [
                                    f[0],
                                    f[3] - R
                                ];
                                break;
                            case 90:
                                U = [
                                    0,
                                    1,
                                    -1,
                                    0
                                ];
                                j = [
                                    f[1],
                                    -f[2],
                                    k,
                                    v
                                ];
                                _ = [
                                    f[1],
                                    -f[0] - R
                                ];
                                break;
                            case 180:
                                U = [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                                j = [
                                    -f[2],
                                    -f[3],
                                    k,
                                    v
                                ];
                                _ = [
                                    -f[2],
                                    -f[1] - R
                                ];
                                break;
                            case 270:
                                U = [
                                    0,
                                    -1,
                                    1,
                                    0
                                ];
                                j = [
                                    -f[3],
                                    f[0],
                                    k,
                                    v
                                ];
                                _ = [
                                    -f[3],
                                    f[2] - R
                                ];
                        }
                        const X = [
                            "q",
                            `${U.join(" ")} 0 0 cm`,
                            `${j.join(" ")} re W n`,
                            "BT",
                            `${(0, i.getPdfColor)(u, !0)}`,
                            `0 Tc /Helv ${(0, n.numberToString)($)} Tf`
                        ];
                        X.push(`${_.join(" ")} Td (${(0, n.escapeString)(M[0])}) Tj`);
                        const H = (0, n.numberToString)(N);
                        for(let e1 = 1, t = M.length; e1 < t; e1++){
                            const t = M[e1];
                            X.push(`0 -${H} Td (${(0, n.escapeString)(t)}) Tj`);
                        }
                        X.push("ET", "Q");
                        const q = X.join("\n"), z = new s.Dict(t);
                        z.set("FormType", 1);
                        z.set("Subtype", s.Name.get("Form"));
                        z.set("Type", s.Name.get("XObject"));
                        z.set("BBox", f);
                        z.set("Resources", m);
                        z.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            -f[0],
                            -f[1]
                        ]);
                        const W = new o.StringStream(q);
                        W.dict = z;
                        return W;
                    }
                }
                class LineAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.LINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const n = t.getArray("L");
                        this.data.lineCoordinates = r.Util.normalizeRect(n);
                        this.setLineEndings(t.getArray("LE"));
                        this.data.lineEndings = this.lineEndings;
                        if (!this.appearance) {
                            const e1 = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ], i = t.get("CA"), s = getRgbColor(t.getArray("IC"), null), o = s ? getPdfColorArray(s) : null, c = o ? i : null, l = this.borderStyle.width || 1, h = 2 * l, u = [
                                this.data.lineCoordinates[0] - h,
                                this.data.lineCoordinates[1] - h,
                                this.data.lineCoordinates[2] + h,
                                this.data.lineCoordinates[3] + h
                            ];
                            r.Util.intersect(this.rectangle, u) || (this.rectangle = u);
                            this._setDefaultAppearance({
                                xref: a,
                                extra: `${l} w`,
                                strokeColor: e1,
                                fillColor: o,
                                strokeAlpha: i,
                                fillAlpha: c,
                                pointsCallback: (e1, t)=>{
                                    e1.push(`${n[0]} ${n[1]} m`, `${n[2]} ${n[3]} l`, "S");
                                    return [
                                        t[0].x - l,
                                        t[1].x + l,
                                        t[3].y - l,
                                        t[1].y + l
                                    ];
                                }
                            });
                        }
                    }
                }
                class SquareAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.SQUARE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        if (!this.appearance) {
                            const e1 = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ], r = t.get("CA"), n = getRgbColor(t.getArray("IC"), null), i = n ? getPdfColorArray(n) : null, s = i ? r : null;
                            if (0 === this.borderStyle.width && !i) return;
                            this._setDefaultAppearance({
                                xref: a,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: e1,
                                fillColor: i,
                                strokeAlpha: r,
                                fillAlpha: s,
                                pointsCallback: (e1, t)=>{
                                    const a = t[2].x + this.borderStyle.width / 2, r = t[2].y + this.borderStyle.width / 2, n = t[3].x - t[2].x - this.borderStyle.width, s = t[1].y - t[3].y - this.borderStyle.width;
                                    e1.push(`${a} ${r} ${n} ${s} re`);
                                    i ? e1.push("B") : e1.push("S");
                                    return [
                                        t[0].x,
                                        t[1].x,
                                        t[3].y,
                                        t[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class CircleAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.CIRCLE;
                        if (!this.appearance) {
                            const e1 = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ], r = t.get("CA"), n = getRgbColor(t.getArray("IC"), null), i = n ? getPdfColorArray(n) : null, s = i ? r : null;
                            if (0 === this.borderStyle.width && !i) return;
                            const o = 4 / 3 * Math.tan(Math.PI / 8);
                            this._setDefaultAppearance({
                                xref: a,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: e1,
                                fillColor: i,
                                strokeAlpha: r,
                                fillAlpha: s,
                                pointsCallback: (e1, t)=>{
                                    const a = t[0].x + this.borderStyle.width / 2, r = t[0].y - this.borderStyle.width / 2, n = t[3].x - this.borderStyle.width / 2, s = t[3].y + this.borderStyle.width / 2, c = a + (n - a) / 2, l = r + (s - r) / 2, h = (n - a) / 2 * o, u = (s - r) / 2 * o;
                                    e1.push(`${c} ${s} m`, `${c + h} ${s} ${n} ${l + u} ${n} ${l} c`, `${n} ${l - u} ${c + h} ${r} ${c} ${r} c`, `${c - h} ${r} ${a} ${l - u} ${a} ${l} c`, `${a} ${l + u} ${c - h} ${s} ${c} ${s} c`, "h");
                                    i ? e1.push("B") : e1.push("S");
                                    return [
                                        t[0].x,
                                        t[1].x,
                                        t[3].y,
                                        t[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolylineAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.POLYLINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.vertices = [];
                        if (!(this instanceof PolygonAnnotation)) {
                            this.setLineEndings(t.getArray("LE"));
                            this.data.lineEndings = this.lineEndings;
                        }
                        const n = t.getArray("Vertices");
                        if (Array.isArray(n)) {
                            for(let e1 = 0, t = n.length; e1 < t; e1 += 2)this.data.vertices.push({
                                x: n[e1],
                                y: n[e1 + 1]
                            });
                            if (!this.appearance) {
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ], n = t.get("CA"), i = this.borderStyle.width || 1, s = 2 * i, o = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ];
                                for (const e1 of this.data.vertices){
                                    o[0] = Math.min(o[0], e1.x - s);
                                    o[1] = Math.min(o[1], e1.y - s);
                                    o[2] = Math.max(o[2], e1.x + s);
                                    o[3] = Math.max(o[3], e1.y + s);
                                }
                                r.Util.intersect(this.rectangle, o) || (this.rectangle = o);
                                this._setDefaultAppearance({
                                    xref: a,
                                    extra: `${i} w`,
                                    strokeColor: e1,
                                    strokeAlpha: n,
                                    pointsCallback: (e1, t)=>{
                                        const a = this.data.vertices;
                                        for(let t = 0, r = a.length; t < r; t++)e1.push(`${a[t].x} ${a[t].y} ${0 === t ? "m" : "l"}`);
                                        e1.push("S");
                                        return [
                                            t[0].x,
                                            t[1].x,
                                            t[3].y,
                                            t[1].y
                                        ];
                                    }
                                });
                            }
                        }
                    }
                }
                class PolygonAnnotation extends PolylineAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.annotationType = r.AnnotationType.POLYGON;
                    }
                }
                class CaretAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.annotationType = r.AnnotationType.CARET;
                    }
                }
                class InkAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.INK;
                        this.data.inkLists = [];
                        const n = t.getArray("InkList");
                        if (Array.isArray(n)) {
                            for(let e1 = 0, t = n.length; e1 < t; ++e1){
                                this.data.inkLists.push([]);
                                for(let t = 0, r = n[e1].length; t < r; t += 2)this.data.inkLists[e1].push({
                                    x: a.fetchIfRef(n[e1][t]),
                                    y: a.fetchIfRef(n[e1][t + 1])
                                });
                            }
                            if (!this.appearance) {
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ], n = t.get("CA"), i = this.borderStyle.width || 1, s = 2 * i, o = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ];
                                for (const e1 of this.data.inkLists)for (const t of e1){
                                    o[0] = Math.min(o[0], t.x - s);
                                    o[1] = Math.min(o[1], t.y - s);
                                    o[2] = Math.max(o[2], t.x + s);
                                    o[3] = Math.max(o[3], t.y + s);
                                }
                                r.Util.intersect(this.rectangle, o) || (this.rectangle = o);
                                this._setDefaultAppearance({
                                    xref: a,
                                    extra: `${i} w`,
                                    strokeColor: e1,
                                    strokeAlpha: n,
                                    pointsCallback: (e1, t)=>{
                                        for (const t of this.data.inkLists){
                                            for(let a = 0, r = t.length; a < r; a++)e1.push(`${t[a].x} ${t[a].y} ${0 === a ? "m" : "l"}`);
                                            e1.push("S");
                                        }
                                        return [
                                            t[0].x,
                                            t[1].x,
                                            t[3].y,
                                            t[1].y
                                        ];
                                    }
                                });
                            }
                        }
                    }
                    static createNewDict(e1, t, { apRef: a, ap: n }) {
                        const { color: i, opacity: o, paths: c, rect: l, rotation: h, thickness: u } = e1, d = new s.Dict(t);
                        d.set("Type", s.Name.get("Annot"));
                        d.set("Subtype", s.Name.get("Ink"));
                        d.set("CreationDate", `D:${(0, r.getModificationDate)()}`);
                        d.set("Rect", l);
                        d.set("InkList", c.map((e1)=>e1.points));
                        d.set("F", 4);
                        d.set("Rotate", h);
                        const f = new s.Dict(t);
                        d.set("BS", f);
                        f.set("W", u);
                        d.set("C", Array.from(i, (e1)=>e1 / 255));
                        d.set("CA", o);
                        const g = new s.Dict(t);
                        d.set("AP", g);
                        a ? g.set("N", a) : g.set("N", n);
                        return d;
                    }
                    static async createNewAppearanceStream(e1, t, a) {
                        const { color: r, rect: c, paths: l, thickness: h, opacity: u } = e1, d = [
                            `${h} w 1 J 1 j`,
                            `${(0, i.getPdfColor)(r, !1)}`
                        ];
                        1 !== u && d.push("/R0 gs");
                        const f = [];
                        for (const { bezier: e1 } of l){
                            f.length = 0;
                            f.push(`${(0, n.numberToString)(e1[0])} ${(0, n.numberToString)(e1[1])} m`);
                            for(let t = 2, a = e1.length; t < a; t += 6){
                                const a = e1.slice(t, t + 6).map(n.numberToString).join(" ");
                                f.push(`${a} c`);
                            }
                            f.push("S");
                            d.push(f.join("\n"));
                        }
                        const g = d.join("\n"), p = new s.Dict(t);
                        p.set("FormType", 1);
                        p.set("Subtype", s.Name.get("Form"));
                        p.set("Type", s.Name.get("XObject"));
                        p.set("BBox", c);
                        p.set("Length", g.length);
                        if (1 !== u) {
                            const e1 = new s.Dict(t), a = new s.Dict(t), r = new s.Dict(t);
                            r.set("CA", u);
                            r.set("Type", s.Name.get("ExtGState"));
                            a.set("R0", r);
                            e1.set("ExtGState", a);
                            p.set("Resources", e1);
                        }
                        const m = new o.StringStream(g);
                        m.dict = p;
                        return m;
                    }
                }
                class HighlightAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.HIGHLIGHT;
                        if (this.data.quadPoints = getQuadPoints(t, null)) {
                            const e1 = this.appearance?.dict.get("Resources");
                            if (!this.appearance || !e1?.has("ExtGState")) {
                                this.appearance && (0, r.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    1,
                                    1,
                                    0
                                ], n = t.get("CA");
                                this._setDefaultAppearance({
                                    xref: a,
                                    fillColor: e1,
                                    blendMode: "Multiply",
                                    fillAlpha: n,
                                    pointsCallback: (e1, t)=>{
                                        e1.push(`${t[0].x} ${t[0].y} m`, `${t[1].x} ${t[1].y} l`, `${t[3].x} ${t[3].y} l`, `${t[2].x} ${t[2].y} l`, "f");
                                        return [
                                            t[0].x,
                                            t[1].x,
                                            t[3].y,
                                            t[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class UnderlineAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.UNDERLINE;
                        if (this.data.quadPoints = getQuadPoints(t, null)) {
                            if (!this.appearance) {
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ], r = t.get("CA");
                                this._setDefaultAppearance({
                                    xref: a,
                                    extra: "[] 0 d 0.571 w",
                                    strokeColor: e1,
                                    strokeAlpha: r,
                                    pointsCallback: (e1, t)=>{
                                        e1.push(`${t[2].x} ${t[2].y + 1.3} m`, `${t[3].x} ${t[3].y + 1.3} l`, "S");
                                        return [
                                            t[0].x,
                                            t[1].x,
                                            t[3].y,
                                            t[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class SquigglyAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.SQUIGGLY;
                        if (this.data.quadPoints = getQuadPoints(t, null)) {
                            if (!this.appearance) {
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ], r = t.get("CA");
                                this._setDefaultAppearance({
                                    xref: a,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: e1,
                                    strokeAlpha: r,
                                    pointsCallback: (e1, t)=>{
                                        const a = (t[0].y - t[2].y) / 6;
                                        let r = a, n = t[2].x;
                                        const i = t[2].y, s = t[3].x;
                                        e1.push(`${n} ${i + r} m`);
                                        do {
                                            n += 2;
                                            r = 0 === r ? a : 0;
                                            e1.push(`${n} ${i + r} l`);
                                        }while (n < s);
                                        e1.push("S");
                                        return [
                                            t[2].x,
                                            s,
                                            i - 2 * a,
                                            i + 2 * a
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StrikeOutAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1;
                        this.data.annotationType = r.AnnotationType.STRIKEOUT;
                        if (this.data.quadPoints = getQuadPoints(t, null)) {
                            if (!this.appearance) {
                                const e1 = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ], r = t.get("CA");
                                this._setDefaultAppearance({
                                    xref: a,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: e1,
                                    strokeAlpha: r,
                                    pointsCallback: (e1, t)=>{
                                        e1.push((t[0].x + t[2].x) / 2 + " " + (t[0].y + t[2].y) / 2 + " m", (t[1].x + t[3].x) / 2 + " " + (t[1].y + t[3].y) / 2 + " l", "S");
                                        return [
                                            t[0].x,
                                            t[1].x,
                                            t[3].y,
                                            t[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StampAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        this.data.annotationType = r.AnnotationType.STAMP;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    static async createImage(e1, t) {
                        const { width: a, height: n } = e1, i = new OffscreenCanvas(a, n), c = i.getContext("2d", {
                            alpha: !0
                        });
                        c.drawImage(e1, 0, 0);
                        const l = c.getImageData(0, 0, a, n).data, h = new Uint32Array(l.buffer), u = h.some(r.FeatureTest.isLittleEndian ? (e1)=>e1 >>> 24 != 255 : (e1)=>255 != (255 & e1));
                        if (u) {
                            c.fillStyle = "white";
                            c.fillRect(0, 0, a, n);
                            c.drawImage(e1, 0, 0);
                        }
                        const d = i.convertToBlob({
                            type: "image/jpeg",
                            quality: 1
                        }).then((e1)=>e1.arrayBuffer()), f = s.Name.get("XObject"), g = s.Name.get("Image"), p = new s.Dict(t);
                        p.set("Type", f);
                        p.set("Subtype", g);
                        p.set("BitsPerComponent", 8);
                        p.set("ColorSpace", s.Name.get("DeviceRGB"));
                        p.set("Filter", s.Name.get("DCTDecode"));
                        p.set("BBox", [
                            0,
                            0,
                            a,
                            n
                        ]);
                        p.set("Width", a);
                        p.set("Height", n);
                        let m = null;
                        if (u) {
                            const e1 = new Uint8Array(h.length);
                            if (r.FeatureTest.isLittleEndian) for(let t = 0, a = h.length; t < a; t++)e1[t] = h[t] >>> 24;
                            else for(let t = 0, a = h.length; t < a; t++)e1[t] = 255 & h[t];
                            const i = new s.Dict(t);
                            i.set("Type", f);
                            i.set("Subtype", g);
                            i.set("BitsPerComponent", 8);
                            i.set("ColorSpace", s.Name.get("DeviceGray"));
                            i.set("Width", a);
                            i.set("Height", n);
                            m = new o.Stream(e1, 0, 0, i);
                        }
                        return {
                            imageStream: new o.Stream(await d, 0, 0, p),
                            smaskStream: m,
                            width: a,
                            height: n
                        };
                    }
                    static createNewDict(e1, t, { apRef: a, ap: i }) {
                        const { rect: o, rotation: c, user: l } = e1, h = new s.Dict(t);
                        h.set("Type", s.Name.get("Annot"));
                        h.set("Subtype", s.Name.get("Stamp"));
                        h.set("CreationDate", `D:${(0, r.getModificationDate)()}`);
                        h.set("Rect", o);
                        h.set("F", 4);
                        h.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        h.set("Rotate", c);
                        l && h.set("T", (0, n.isAscii)(l) ? l : (0, n.stringToUTF16String)(l, !0));
                        if (a || i) {
                            const e1 = new s.Dict(t);
                            h.set("AP", e1);
                            a ? e1.set("N", a) : e1.set("N", i);
                        }
                        return h;
                    }
                    static async createNewAppearanceStream(e1, t, a) {
                        const { rotation: r } = e1, { imageRef: i, width: c, height: l } = a.image, h = new s.Dict(t), u = new s.Dict(t);
                        h.set("XObject", u);
                        u.set("Im0", i);
                        const d = `q ${c} 0 0 ${l} 0 0 cm /Im0 Do Q`, f = new s.Dict(t);
                        f.set("FormType", 1);
                        f.set("Subtype", s.Name.get("Form"));
                        f.set("Type", s.Name.get("XObject"));
                        f.set("BBox", [
                            0,
                            0,
                            c,
                            l
                        ]);
                        f.set("Resources", h);
                        if (r) {
                            const e1 = (0, n.getRotationMatrix)(r, c, l);
                            f.set("Matrix", e1);
                        }
                        const g = new o.StringStream(d);
                        g.dict = f;
                        return g;
                    }
                }
                class FileAttachmentAnnotation extends MarkupAnnotation {
                    constructor(e1){
                        super(e1);
                        const { dict: t, xref: a } = e1, n = new d.FileSpec(t.get("FS"), a);
                        this.data.annotationType = r.AnnotationType.FILEATTACHMENT;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.file = n.serializable;
                        const i = t.get("Name");
                        this.data.name = i instanceof s.Name ? (0, r.stringToPDFString)(i.name) : "PushPin";
                        const o = t.get("ca");
                        this.data.fillAlpha = "number" == typeof o && o >= 0 && o <= 1 ? o : null;
                    }
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.FakeUnicodeFont = void 0;
                t.createDefaultAppearance = function createDefaultAppearance({ fontSize: e1, fontName: t, fontColor: a }) {
                    return `/${(0, n.escapePDFName)(t)} ${e1} Tf ${getPdfColor(a, !0)}`;
                };
                t.getPdfColor = getPdfColor;
                t.parseAppearanceStream = function parseAppearanceStream(e1, t, a) {
                    return new AppearanceStreamEvaluator(e1, t, a).parse();
                };
                t.parseDefaultAppearance = function parseDefaultAppearance(e1) {
                    return new DefaultAppearanceEvaluator(e1).parse();
                };
                var r = a(4), n = a(3), i = a(2), s = a(12), o = a(13), c = a(59), l = a(57), h = a(8);
                class DefaultAppearanceEvaluator extends o.EvaluatorPreprocessor {
                    constructor(e1){
                        super(new h.StringStream(e1));
                    }
                    parse() {
                        const e1 = {
                            fn: 0,
                            args: []
                        }, t = {
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3)
                        };
                        try {
                            for(;;){
                                e1.args.length = 0;
                                if (!this.read(e1)) break;
                                if (0 !== this.savedStatesDepth) continue;
                                const { fn: a, args: n } = e1;
                                switch(0 | a){
                                    case i.OPS.setFont:
                                        const [e2, a1] = n;
                                        e2 instanceof r.Name && (t.fontName = e2.name);
                                        "number" == typeof a1 && a1 > 0 && (t.fontSize = a1);
                                        break;
                                    case i.OPS.setFillRGBColor:
                                        s.ColorSpace.singletons.rgb.getRgbItem(n, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.setFillGray:
                                        s.ColorSpace.singletons.gray.getRgbItem(n, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.setFillCMYKColor:
                                        s.ColorSpace.singletons.cmyk.getRgbItem(n, 0, t.fontColor, 0);
                                }
                            }
                        } catch (e1) {
                            (0, i.warn)(`parseDefaultAppearance - ignoring errors: "${e1}".`);
                        }
                        return t;
                    }
                }
                class AppearanceStreamEvaluator extends o.EvaluatorPreprocessor {
                    constructor(e1, t, a){
                        super(e1);
                        this.stream = e1;
                        this.evaluatorOptions = t;
                        this.xref = a;
                        this.resources = e1.dict?.get("Resources");
                    }
                    parse() {
                        const e1 = {
                            fn: 0,
                            args: []
                        };
                        let t = {
                            scaleFactor: 1,
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3),
                            fillColorSpace: s.ColorSpace.singletons.gray
                        }, a = !1;
                        const n = [];
                        try {
                            for(;;){
                                e1.args.length = 0;
                                if (a || !this.read(e1)) break;
                                const { fn: o, args: c } = e1;
                                switch(0 | o){
                                    case i.OPS.save:
                                        n.push({
                                            scaleFactor: t.scaleFactor,
                                            fontSize: t.fontSize,
                                            fontName: t.fontName,
                                            fontColor: t.fontColor.slice(),
                                            fillColorSpace: t.fillColorSpace
                                        });
                                        break;
                                    case i.OPS.restore:
                                        t = n.pop() || t;
                                        break;
                                    case i.OPS.setTextMatrix:
                                        t.scaleFactor *= Math.hypot(c[0], c[1]);
                                        break;
                                    case i.OPS.setFont:
                                        const [e2, o1] = c;
                                        e2 instanceof r.Name && (t.fontName = e2.name);
                                        "number" == typeof o1 && o1 > 0 && (t.fontSize = o1 * t.scaleFactor);
                                        break;
                                    case i.OPS.setFillColorSpace:
                                        t.fillColorSpace = s.ColorSpace.parse({
                                            cs: c[0],
                                            xref: this.xref,
                                            resources: this.resources,
                                            pdfFunctionFactory: this._pdfFunctionFactory,
                                            localColorSpaceCache: this._localColorSpaceCache
                                        });
                                        break;
                                    case i.OPS.setFillColor:
                                        t.fillColorSpace.getRgbItem(c, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.setFillRGBColor:
                                        s.ColorSpace.singletons.rgb.getRgbItem(c, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.setFillGray:
                                        s.ColorSpace.singletons.gray.getRgbItem(c, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.setFillCMYKColor:
                                        s.ColorSpace.singletons.cmyk.getRgbItem(c, 0, t.fontColor, 0);
                                        break;
                                    case i.OPS.showText:
                                    case i.OPS.showSpacedText:
                                    case i.OPS.nextLineShowText:
                                    case i.OPS.nextLineSetSpacingShowText:
                                        a = !0;
                                }
                            }
                        } catch (e1) {
                            (0, i.warn)(`parseAppearanceStream - ignoring errors: "${e1}".`);
                        }
                        this.stream.reset();
                        delete t.scaleFactor;
                        delete t.fillColorSpace;
                        return t;
                    }
                    get _localColorSpaceCache() {
                        return (0, i.shadow)(this, "_localColorSpaceCache", new c.LocalColorSpaceCache);
                    }
                    get _pdfFunctionFactory() {
                        const e1 = new l.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.evaluatorOptions.isEvalSupported
                        });
                        return (0, i.shadow)(this, "_pdfFunctionFactory", e1);
                    }
                }
                function getPdfColor(e1, t) {
                    if (e1[0] === e1[1] && e1[1] === e1[2]) {
                        const a = e1[0] / 255;
                        return `${(0, n.numberToString)(a)} ${t ? "g" : "G"}`;
                    }
                    return Array.from(e1, (e1)=>(0, n.numberToString)(e1 / 255)).join(" ") + " " + (t ? "rg" : "RG");
                }
                class FakeUnicodeFont {
                    constructor(e1, t){
                        this.xref = e1;
                        this.widths = null;
                        this.firstChar = 1 / 0;
                        this.lastChar = -1 / 0;
                        this.fontFamily = t;
                        const a = new OffscreenCanvas(1, 1);
                        this.ctxMeasure = a.getContext("2d");
                        FakeUnicodeFont._fontNameId || (FakeUnicodeFont._fontNameId = 1);
                        this.fontName = r.Name.get(`InvalidPDFjsFont_${t}_${FakeUnicodeFont._fontNameId++}`);
                    }
                    get toUnicodeRef() {
                        if (!FakeUnicodeFont._toUnicodeRef) {
                            const e1 = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo\n<< /Registry (Adobe)\n/Ordering (UCS) /Supplement 0 >> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000> <FFFF>\nendcodespacerange\n1 beginbfrange\n<0000> <FFFF> <0000>\nendbfrange\nendcmap CMapName currentdict /CMap defineresource pop end end", t = FakeUnicodeFont.toUnicodeStream = new h.StringStream(e1), a = new r.Dict(this.xref);
                            t.dict = a;
                            a.set("Length", e1.length);
                            FakeUnicodeFont._toUnicodeRef = this.xref.getNewPersistentRef(t);
                        }
                        return FakeUnicodeFont._toUnicodeRef;
                    }
                    get fontDescriptorRef() {
                        if (!FakeUnicodeFont._fontDescriptorRef) {
                            const e1 = new r.Dict(this.xref);
                            e1.set("Type", r.Name.get("FontDescriptor"));
                            e1.set("FontName", this.fontName);
                            e1.set("FontFamily", "MyriadPro Regular");
                            e1.set("FontBBox", [
                                0,
                                0,
                                0,
                                0
                            ]);
                            e1.set("FontStretch", r.Name.get("Normal"));
                            e1.set("FontWeight", 400);
                            e1.set("ItalicAngle", 0);
                            FakeUnicodeFont._fontDescriptorRef = this.xref.getNewPersistentRef(e1);
                        }
                        return FakeUnicodeFont._fontDescriptorRef;
                    }
                    get descendantFontRef() {
                        const e1 = new r.Dict(this.xref);
                        e1.set("BaseFont", this.fontName);
                        e1.set("Type", r.Name.get("Font"));
                        e1.set("Subtype", r.Name.get("CIDFontType0"));
                        e1.set("CIDToGIDMap", r.Name.get("Identity"));
                        e1.set("FirstChar", this.firstChar);
                        e1.set("LastChar", this.lastChar);
                        e1.set("FontDescriptor", this.fontDescriptorRef);
                        e1.set("DW", 1e3);
                        const t = [], a = [
                            ...this.widths.entries()
                        ].sort();
                        let n = null, i = null;
                        for (const [e1, r] of a)if (n) {
                            if (e1 === n + i.length) i.push(r);
                            else {
                                t.push(n, i);
                                n = e1;
                                i = [
                                    r
                                ];
                            }
                        } else {
                            n = e1;
                            i = [
                                r
                            ];
                        }
                        n && t.push(n, i);
                        e1.set("W", t);
                        const s = new r.Dict(this.xref);
                        s.set("Ordering", "Identity");
                        s.set("Registry", "Adobe");
                        s.set("Supplement", 0);
                        e1.set("CIDSystemInfo", s);
                        return this.xref.getNewPersistentRef(e1);
                    }
                    get baseFontRef() {
                        const e1 = new r.Dict(this.xref);
                        e1.set("BaseFont", this.fontName);
                        e1.set("Type", r.Name.get("Font"));
                        e1.set("Subtype", r.Name.get("Type0"));
                        e1.set("Encoding", r.Name.get("Identity-H"));
                        e1.set("DescendantFonts", [
                            this.descendantFontRef
                        ]);
                        e1.set("ToUnicode", this.toUnicodeRef);
                        return this.xref.getNewPersistentRef(e1);
                    }
                    get resources() {
                        const e1 = new r.Dict(this.xref), t = new r.Dict(this.xref);
                        t.set(this.fontName.name, this.baseFontRef);
                        e1.set("Font", t);
                        return e1;
                    }
                    _createContext() {
                        this.widths = new Map;
                        this.ctxMeasure.font = `1000px ${this.fontFamily}`;
                        return this.ctxMeasure;
                    }
                    createFontResources(e1) {
                        const t = this._createContext();
                        for (const a of e1.split(/\r\n?|\n/))for (const e1 of a.split("")){
                            const a = e1.charCodeAt(0);
                            if (this.widths.has(a)) continue;
                            const r = t.measureText(e1), n = Math.ceil(r.width);
                            this.widths.set(a, n);
                            this.firstChar = Math.min(a, this.firstChar);
                            this.lastChar = Math.max(a, this.lastChar);
                        }
                        return this.resources;
                    }
                    createAppearance(e1, t, a, s, o, c) {
                        const l = this._createContext(), u = [];
                        let d = -1 / 0;
                        for (const t of e1.split(/\r\n?|\n/)){
                            u.push(t);
                            const e1 = l.measureText(t).width;
                            d = Math.max(d, e1);
                            for (const e1 of t.split("")){
                                const t = e1.charCodeAt(0);
                                let a = this.widths.get(t);
                                if (void 0 === a) {
                                    const r = l.measureText(e1);
                                    a = Math.ceil(r.width);
                                    this.widths.set(t, a);
                                    this.firstChar = Math.min(t, this.firstChar);
                                    this.lastChar = Math.max(t, this.lastChar);
                                }
                            }
                        }
                        d *= s / 1e3;
                        const [f, g, p, m] = t;
                        let b = p - f, y = m - g;
                        a % 180 != 0 && ([b, y] = [
                            y,
                            b
                        ]);
                        let w = 1;
                        d > b && (w = b / d);
                        let S = 1;
                        const x = i.LINE_FACTOR * s, C = i.LINE_DESCENT_FACTOR * s, k = x * u.length;
                        k > y && (S = y / k);
                        const v = s * Math.min(w, S), F = [
                            "q",
                            `0 0 ${(0, n.numberToString)(b)} ${(0, n.numberToString)(y)} re W n`,
                            "BT",
                            `1 0 0 1 0 ${(0, n.numberToString)(y + C)} Tm 0 Tc ${getPdfColor(o, !0)}`,
                            `/${this.fontName.name} ${(0, n.numberToString)(v)} Tf`
                        ], { resources: O } = this;
                        if (1 !== (c = "number" == typeof c && c >= 0 && c <= 1 ? c : 1)) {
                            F.push("/R0 gs");
                            const e1 = new r.Dict(this.xref), t = new r.Dict(this.xref);
                            t.set("ca", c);
                            t.set("CA", c);
                            t.set("Type", r.Name.get("ExtGState"));
                            e1.set("R0", t);
                            O.set("ExtGState", e1);
                        }
                        const T = (0, n.numberToString)(x);
                        for (const e1 of u)F.push(`0 -${T} Td <${(0, n.stringToUTF16HexString)(e1)}> Tj`);
                        F.push("ET", "Q");
                        const M = F.join("\n"), D = new r.Dict(this.xref);
                        D.set("Subtype", r.Name.get("Form"));
                        D.set("Type", r.Name.get("XObject"));
                        D.set("BBox", [
                            0,
                            0,
                            b,
                            y
                        ]);
                        D.set("Length", M.length);
                        D.set("Resources", O);
                        if (a) {
                            const e1 = (0, n.getRotationMatrix)(a, b, y);
                            D.set("Matrix", e1);
                        }
                        const E = new h.StringStream(M);
                        E.dict = D;
                        return E;
                    }
                }
                t.FakeUnicodeFont = FakeUnicodeFont;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ColorSpace = void 0;
                var r = a(2), n = a(4), i = a(5), s = a(3);
                class ColorSpace {
                    constructor(e1, t){
                        this.constructor === ColorSpace && (0, r.unreachable)("Cannot initialize ColorSpace.");
                        this.name = e1;
                        this.numComps = t;
                    }
                    getRgb(e1, t) {
                        const a = new Uint8ClampedArray(3);
                        this.getRgbItem(e1, t, a, 0);
                        return a;
                    }
                    getRgbItem(e1, t, a, n) {
                        (0, r.unreachable)("Should not call ColorSpace.getRgbItem");
                    }
                    getRgbBuffer(e1, t, a, n, i, s, o) {
                        (0, r.unreachable)("Should not call ColorSpace.getRgbBuffer");
                    }
                    getOutputLength(e1, t) {
                        (0, r.unreachable)("Should not call ColorSpace.getOutputLength");
                    }
                    isPassthrough(e1) {
                        return !1;
                    }
                    isDefaultDecode(e1, t) {
                        return ColorSpace.isDefaultDecode(e1, this.numComps);
                    }
                    fillRgb(e1, t, a, r, n, i, s, o, c) {
                        const l = t * a;
                        let h = null;
                        const u = 1 << s, d = a !== n || t !== r;
                        if (this.isPassthrough(s)) h = o;
                        else if (1 === this.numComps && l > u && "DeviceGray" !== this.name && "DeviceRGB" !== this.name) {
                            const t = s <= 8 ? new Uint8Array(u) : new Uint16Array(u);
                            for(let e1 = 0; e1 < u; e1++)t[e1] = e1;
                            const a = new Uint8ClampedArray(3 * u);
                            this.getRgbBuffer(t, 0, u, a, 0, s, 0);
                            if (d) {
                                h = new Uint8Array(3 * l);
                                let e1 = 0;
                                for(let t = 0; t < l; ++t){
                                    const r = 3 * o[t];
                                    h[e1++] = a[r];
                                    h[e1++] = a[r + 1];
                                    h[e1++] = a[r + 2];
                                }
                            } else {
                                let t = 0;
                                for(let r = 0; r < l; ++r){
                                    const n = 3 * o[r];
                                    e1[t++] = a[n];
                                    e1[t++] = a[n + 1];
                                    e1[t++] = a[n + 2];
                                    t += c;
                                }
                            }
                        } else if (d) {
                            h = new Uint8ClampedArray(3 * l);
                            this.getRgbBuffer(o, 0, l, h, 0, s, 0);
                        } else this.getRgbBuffer(o, 0, r * i, e1, 0, s, c);
                        if (h) {
                            if (d) !function resizeRgbImage(e1, t, a, r, n, i, s) {
                                s = 1 !== s ? 0 : s;
                                const o = a / n, c = r / i;
                                let l, h = 0;
                                const u = new Uint16Array(n), d = 3 * a;
                                for(let e1 = 0; e1 < n; e1++)u[e1] = 3 * Math.floor(e1 * o);
                                for(let a = 0; a < i; a++){
                                    const r = Math.floor(a * c) * d;
                                    for(let a = 0; a < n; a++){
                                        l = r + u[a];
                                        t[h++] = e1[l++];
                                        t[h++] = e1[l++];
                                        t[h++] = e1[l++];
                                        h += s;
                                    }
                                }
                            }(h, e1, t, a, r, n, c);
                            else {
                                let t = 0, a = 0;
                                for(let n = 0, s = r * i; n < s; n++){
                                    e1[t++] = h[a++];
                                    e1[t++] = h[a++];
                                    e1[t++] = h[a++];
                                    t += c;
                                }
                            }
                        }
                    }
                    get usesZeroToOneRange() {
                        return (0, r.shadow)(this, "usesZeroToOneRange", !0);
                    }
                    static _cache(e1, t, a, r) {
                        if (!a) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                        if (!r) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                        let i, s;
                        if (e1 instanceof n.Ref) {
                            s = e1;
                            e1 = t.fetch(e1);
                        }
                        e1 instanceof n.Name && (i = e1.name);
                        (i || s) && a.set(i, s, r);
                    }
                    static getCached(e1, t, a) {
                        if (!a) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                        if (e1 instanceof n.Ref) {
                            const r = a.getByRef(e1);
                            if (r) return r;
                            try {
                                e1 = t.fetch(e1);
                            } catch (e1) {
                                if (e1 instanceof s.MissingDataException) throw e1;
                            }
                        }
                        if (e1 instanceof n.Name) {
                            const t = a.getByName(e1.name);
                            if (t) return t;
                        }
                        return null;
                    }
                    static async parseAsync({ cs: e1, xref: t, resources: a = null, pdfFunctionFactory: r, localColorSpaceCache: n }) {
                        const i = this._parse(e1, t, a, r);
                        this._cache(e1, t, n, i);
                        return i;
                    }
                    static parse({ cs: e1, xref: t, resources: a = null, pdfFunctionFactory: r, localColorSpaceCache: n }) {
                        const i = this.getCached(e1, t, n);
                        if (i) return i;
                        const s = this._parse(e1, t, a, r);
                        this._cache(e1, t, n, s);
                        return s;
                    }
                    static _parse(e1, t, a = null, i) {
                        if ((e1 = t.fetchIfRef(e1)) instanceof n.Name) switch(e1.name){
                            case "G":
                            case "DeviceGray":
                                return this.singletons.gray;
                            case "RGB":
                            case "DeviceRGB":
                                return this.singletons.rgb;
                            case "CMYK":
                            case "DeviceCMYK":
                                return this.singletons.cmyk;
                            case "Pattern":
                                return new PatternCS(null);
                            default:
                                if (a instanceof n.Dict) {
                                    const r = a.get("ColorSpace");
                                    if (r instanceof n.Dict) {
                                        const s = r.get(e1.name);
                                        if (s) {
                                            if (s instanceof n.Name) return this._parse(s, t, a, i);
                                            e1 = s;
                                            break;
                                        }
                                    }
                                }
                                throw new r.FormatError(`Unrecognized ColorSpace: ${e1.name}`);
                        }
                        if (Array.isArray(e1)) {
                            const n = t.fetchIfRef(e1[0]).name;
                            let s, o, c, l, h, u;
                            switch(n){
                                case "G":
                                case "DeviceGray":
                                    return this.singletons.gray;
                                case "RGB":
                                case "DeviceRGB":
                                    return this.singletons.rgb;
                                case "CMYK":
                                case "DeviceCMYK":
                                    return this.singletons.cmyk;
                                case "CalGray":
                                    s = t.fetchIfRef(e1[1]);
                                    l = s.getArray("WhitePoint");
                                    h = s.getArray("BlackPoint");
                                    u = s.get("Gamma");
                                    return new CalGrayCS(l, h, u);
                                case "CalRGB":
                                    s = t.fetchIfRef(e1[1]);
                                    l = s.getArray("WhitePoint");
                                    h = s.getArray("BlackPoint");
                                    u = s.getArray("Gamma");
                                    const d = s.getArray("Matrix");
                                    return new CalRGBCS(l, h, u, d);
                                case "ICCBased":
                                    const f = t.fetchIfRef(e1[1]).dict;
                                    o = f.get("N");
                                    const g = f.get("Alternate");
                                    if (g) {
                                        const e1 = this._parse(g, t, a, i);
                                        if (e1.numComps === o) return e1;
                                        (0, r.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                                    }
                                    if (1 === o) return this.singletons.gray;
                                    if (3 === o) return this.singletons.rgb;
                                    if (4 === o) return this.singletons.cmyk;
                                    break;
                                case "Pattern":
                                    c = e1[1] || null;
                                    c && (c = this._parse(c, t, a, i));
                                    return new PatternCS(c);
                                case "I":
                                case "Indexed":
                                    c = this._parse(e1[1], t, a, i);
                                    const p = t.fetchIfRef(e1[2]) + 1, m = t.fetchIfRef(e1[3]);
                                    return new IndexedCS(c, p, m);
                                case "Separation":
                                case "DeviceN":
                                    const b = t.fetchIfRef(e1[1]);
                                    o = Array.isArray(b) ? b.length : 1;
                                    c = this._parse(e1[2], t, a, i);
                                    const y = i.create(e1[3]);
                                    return new AlternateCS(o, c, y);
                                case "Lab":
                                    s = t.fetchIfRef(e1[1]);
                                    l = s.getArray("WhitePoint");
                                    h = s.getArray("BlackPoint");
                                    const w = s.getArray("Range");
                                    return new LabCS(l, h, w);
                                default:
                                    throw new r.FormatError(`Unimplemented ColorSpace object: ${n}`);
                            }
                        }
                        throw new r.FormatError(`Unrecognized ColorSpace object: ${e1}`);
                    }
                    static isDefaultDecode(e1, t) {
                        if (!Array.isArray(e1)) return !0;
                        if (2 * t !== e1.length) {
                            (0, r.warn)("The decode map is not the correct length");
                            return !0;
                        }
                        for(let t = 0, a = e1.length; t < a; t += 2)if (0 !== e1[t] || 1 !== e1[t + 1]) return !1;
                        return !0;
                    }
                    static get singletons() {
                        return (0, r.shadow)(this, "singletons", {
                            get gray () {
                                return (0, r.shadow)(this, "gray", new DeviceGrayCS);
                            },
                            get rgb () {
                                return (0, r.shadow)(this, "rgb", new DeviceRgbCS);
                            },
                            get cmyk () {
                                return (0, r.shadow)(this, "cmyk", new DeviceCmykCS);
                            }
                        });
                    }
                }
                t.ColorSpace = ColorSpace;
                class AlternateCS extends ColorSpace {
                    constructor(e1, t, a){
                        super("Alternate", e1);
                        this.base = t;
                        this.tintFn = a;
                        this.tmpBuf = new Float32Array(t.numComps);
                    }
                    getRgbItem(e1, t, a, r) {
                        const n = this.tmpBuf;
                        this.tintFn(e1, t, n, 0);
                        this.base.getRgbItem(n, 0, a, r);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = this.tintFn, c = this.base, l = 1 / ((1 << i) - 1), h = c.numComps, u = c.usesZeroToOneRange, d = (c.isPassthrough(8) || !u) && 0 === s;
                        let f = d ? n : 0;
                        const g = d ? r : new Uint8ClampedArray(h * a), p = this.numComps, m = new Float32Array(p), b = new Float32Array(h);
                        let y, w;
                        for(y = 0; y < a; y++){
                            for(w = 0; w < p; w++)m[w] = e1[t++] * l;
                            o(m, 0, b, 0);
                            if (u) for(w = 0; w < h; w++)g[f++] = 255 * b[w];
                            else {
                                c.getRgbItem(b, 0, g, f);
                                f += h;
                            }
                        }
                        d || c.getRgbBuffer(g, 0, a, r, n, 8, s);
                    }
                    getOutputLength(e1, t) {
                        return this.base.getOutputLength(e1 * this.base.numComps / this.numComps, t);
                    }
                }
                class PatternCS extends ColorSpace {
                    constructor(e1){
                        super("Pattern", null);
                        this.base = e1;
                    }
                    isDefaultDecode(e1, t) {
                        (0, r.unreachable)("Should not call PatternCS.isDefaultDecode");
                    }
                }
                class IndexedCS extends ColorSpace {
                    constructor(e1, t, a){
                        super("Indexed", 1);
                        this.base = e1;
                        this.highVal = t;
                        const n = e1.numComps * t;
                        this.lookup = new Uint8Array(n);
                        if (a instanceof i.BaseStream) {
                            const e1 = a.getBytes(n);
                            this.lookup.set(e1);
                        } else {
                            if ("string" != typeof a) throw new r.FormatError(`IndexedCS - unrecognized lookup table: ${a}`);
                            for(let e1 = 0; e1 < n; ++e1)this.lookup[e1] = 255 & a.charCodeAt(e1);
                        }
                    }
                    getRgbItem(e1, t, a, r) {
                        const n = this.base.numComps, i = e1[t] * n;
                        this.base.getRgbBuffer(this.lookup, i, 1, a, r, 8, 0);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = this.base, c = o.numComps, l = o.getOutputLength(c, s), h = this.lookup;
                        for(let i = 0; i < a; ++i){
                            const a = e1[t++] * c;
                            o.getRgbBuffer(h, a, 1, r, n, 8, s);
                            n += l;
                        }
                    }
                    getOutputLength(e1, t) {
                        return this.base.getOutputLength(e1 * this.base.numComps, t);
                    }
                    isDefaultDecode(e1, t) {
                        if (!Array.isArray(e1)) return !0;
                        if (2 !== e1.length) {
                            (0, r.warn)("Decode map length is not correct");
                            return !0;
                        }
                        if (!Number.isInteger(t) || t < 1) {
                            (0, r.warn)("Bits per component is not correct");
                            return !0;
                        }
                        return 0 === e1[0] && e1[1] === (1 << t) - 1;
                    }
                }
                class DeviceGrayCS extends ColorSpace {
                    constructor(){
                        super("DeviceGray", 1);
                    }
                    getRgbItem(e1, t, a, r) {
                        const n = 255 * e1[t];
                        a[r] = a[r + 1] = a[r + 2] = n;
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = 255 / ((1 << i) - 1);
                        let c = t, l = n;
                        for(let t = 0; t < a; ++t){
                            const t = o * e1[c++];
                            r[l++] = t;
                            r[l++] = t;
                            r[l++] = t;
                            l += s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 * (3 + t);
                    }
                }
                class DeviceRgbCS extends ColorSpace {
                    constructor(){
                        super("DeviceRGB", 3);
                    }
                    getRgbItem(e1, t, a, r) {
                        a[r] = 255 * e1[t];
                        a[r + 1] = 255 * e1[t + 1];
                        a[r + 2] = 255 * e1[t + 2];
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        if (8 === i && 0 === s) {
                            r.set(e1.subarray(t, t + 3 * a), n);
                            return;
                        }
                        const o = 255 / ((1 << i) - 1);
                        let c = t, l = n;
                        for(let t = 0; t < a; ++t){
                            r[l++] = o * e1[c++];
                            r[l++] = o * e1[c++];
                            r[l++] = o * e1[c++];
                            l += s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 * (3 + t) / 3 | 0;
                    }
                    isPassthrough(e1) {
                        return 8 === e1;
                    }
                }
                class DeviceCmykCS extends ColorSpace {
                    constructor(){
                        super("DeviceCMYK", 4);
                    }
                    #r(e1, t, a, r, n) {
                        const i = e1[t] * a, s = e1[t + 1] * a, o = e1[t + 2] * a, c = e1[t + 3] * a;
                        r[n] = 255 + i * (-4.387332384609988 * i + 54.48615194189176 * s + 18.82290502165302 * o + 212.25662451639585 * c - 285.2331026137004) + s * (1.7149763477362134 * s - 5.6096736904047315 * o + -17.873870861415444 * c - 5.497006427196366) + o * (-2.5217340131683033 * o - 21.248923337353073 * c + 17.5119270841813) + c * (-21.86122147463605 * c - 189.48180835922747);
                        r[n + 1] = 255 + i * (8.841041422036149 * i + 60.118027045597366 * s + 6.871425592049007 * o + 31.159100130055922 * c - 79.2970844816548) + s * (-15.310361306967817 * s + 17.575251261109482 * o + 131.35250912493976 * c - 190.9453302588951) + o * (4.444339102852739 * o + 9.8632861493405 * c - 24.86741582555878) + c * (-20.737325471181034 * c - 187.80453709719578);
                        r[n + 2] = 255 + i * (.8842522430003296 * i + 8.078677503112928 * s + 30.89978309703729 * o - .23883238689178934 * c - 14.183576799673286) + s * (10.49593273432072 * s + 63.02378494754052 * o + 50.606957656360734 * c - 112.23884253719248) + o * (.03296041114873217 * o + 115.60384449646641 * c - 193.58209356861505) + c * (-22.33816807309886 * c - 180.12613974708367);
                    }
                    getRgbItem(e1, t, a, r) {
                        this.#r(e1, t, 1, a, r);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = 1 / ((1 << i) - 1);
                        for(let i = 0; i < a; i++){
                            this.#r(e1, t, o, r, n);
                            t += 4;
                            n += 3 + s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 / 4 * (3 + t) | 0;
                    }
                }
                class CalGrayCS extends ColorSpace {
                    constructor(e1, t, a){
                        super("CalGray", 1);
                        if (!e1) throw new r.FormatError("WhitePoint missing - required for color space CalGray");
                        [this.XW, this.YW, this.ZW] = e1;
                        [this.XB, this.YB, this.ZB] = t || [
                            0,
                            0,
                            0
                        ];
                        this.G = a || 1;
                        if (this.XW < 0 || this.ZW < 0 || 1 !== this.YW) throw new r.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, r.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`);
                            this.XB = this.YB = this.ZB = 0;
                        }
                        0 === this.XB && 0 === this.YB && 0 === this.ZB || (0, r.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`);
                        if (this.G < 1) {
                            (0, r.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`);
                            this.G = 1;
                        }
                    }
                    #r(e1, t, a, r, n) {
                        const i = (e1[t] * n) ** this.G, s = this.YW * i, o = Math.max(295.8 * s ** .3333333333333333 - 40.8, 0);
                        a[r] = o;
                        a[r + 1] = o;
                        a[r + 2] = o;
                    }
                    getRgbItem(e1, t, a, r) {
                        this.#r(e1, t, a, r, 1);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = 1 / ((1 << i) - 1);
                        for(let i = 0; i < a; ++i){
                            this.#r(e1, t, r, n, o);
                            t += 1;
                            n += 3 + s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 * (3 + t);
                    }
                }
                class CalRGBCS extends ColorSpace {
                    static #n = new Float32Array([
                        .8951,
                        .2664,
                        -0.1614,
                        -0.7502,
                        1.7135,
                        .0367,
                        .0389,
                        -0.0685,
                        1.0296
                    ]);
                    static #i = new Float32Array([
                        .9869929,
                        -0.1470543,
                        .1599627,
                        .4323053,
                        .5183603,
                        .0492912,
                        -0.0085287,
                        .0400428,
                        .9684867
                    ]);
                    static #s = new Float32Array([
                        3.2404542,
                        -1.5371385,
                        -0.4985314,
                        -0.969266,
                        1.8760108,
                        .041556,
                        .0556434,
                        -0.2040259,
                        1.0572252
                    ]);
                    static #o = new Float32Array([
                        1,
                        1,
                        1
                    ]);
                    static #c = new Float32Array(3);
                    static #l = new Float32Array(3);
                    static #h = new Float32Array(3);
                    static #u = (24 / 116) ** 3 / 8;
                    constructor(e1, t, a, n){
                        super("CalRGB", 3);
                        if (!e1) throw new r.FormatError("WhitePoint missing - required for color space CalRGB");
                        const [i, s, o] = this.whitePoint = e1, [c, l, h] = this.blackPoint = t || new Float32Array(3);
                        [this.GR, this.GG, this.GB] = a || new Float32Array([
                            1,
                            1,
                            1
                        ]);
                        [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = n || new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]);
                        if (i < 0 || o < 0 || 1 !== s) throw new r.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (c < 0 || l < 0 || h < 0) {
                            (0, r.info)(`Invalid BlackPoint for ${this.name} [${c}, ${l}, ${h}], falling back to default.`);
                            this.blackPoint = new Float32Array(3);
                        }
                        if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
                            (0, r.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`);
                            this.GR = this.GG = this.GB = 1;
                        }
                    }
                    #d(e1, t, a) {
                        a[0] = e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2];
                        a[1] = e1[3] * t[0] + e1[4] * t[1] + e1[5] * t[2];
                        a[2] = e1[6] * t[0] + e1[7] * t[1] + e1[8] * t[2];
                    }
                    #f(e1, t, a) {
                        a[0] = 1 * t[0] / e1[0];
                        a[1] = 1 * t[1] / e1[1];
                        a[2] = 1 * t[2] / e1[2];
                    }
                    #g(e1, t, a) {
                        a[0] = .95047 * t[0] / e1[0];
                        a[1] = 1 * t[1] / e1[1];
                        a[2] = 1.08883 * t[2] / e1[2];
                    }
                    #p(e1) {
                        return e1 <= .0031308 ? this.#m(0, 1, 12.92 * e1) : e1 >= .99554525 ? 1 : this.#m(0, 1, 1.055 * e1 ** (1 / 2.4) - .055);
                    }
                    #m(e1, t, a) {
                        return Math.max(e1, Math.min(t, a));
                    }
                    #b(e1) {
                        return e1 < 0 ? -this.#b(-e1) : e1 > 8 ? ((e1 + 16) / 116) ** 3 : e1 * CalRGBCS.#u;
                    }
                    #y(e1, t, a) {
                        if (0 === e1[0] && 0 === e1[1] && 0 === e1[2]) {
                            a[0] = t[0];
                            a[1] = t[1];
                            a[2] = t[2];
                            return;
                        }
                        const r = this.#b(0), n = (1 - r) / (1 - this.#b(e1[0])), i = 1 - n, s = (1 - r) / (1 - this.#b(e1[1])), o = 1 - s, c = (1 - r) / (1 - this.#b(e1[2])), l = 1 - c;
                        a[0] = t[0] * n + i;
                        a[1] = t[1] * s + o;
                        a[2] = t[2] * c + l;
                    }
                    #w(e1, t, a) {
                        if (1 === e1[0] && 1 === e1[2]) {
                            a[0] = t[0];
                            a[1] = t[1];
                            a[2] = t[2];
                            return;
                        }
                        const r = a;
                        this.#d(CalRGBCS.#n, t, r);
                        const n = CalRGBCS.#c;
                        this.#f(e1, r, n);
                        this.#d(CalRGBCS.#i, n, a);
                    }
                    #S(e1, t, a) {
                        const r = a;
                        this.#d(CalRGBCS.#n, t, r);
                        const n = CalRGBCS.#c;
                        this.#g(e1, r, n);
                        this.#d(CalRGBCS.#i, n, a);
                    }
                    #r(e1, t, a, r, n) {
                        const i = this.#m(0, 1, e1[t] * n), s = this.#m(0, 1, e1[t + 1] * n), o = this.#m(0, 1, e1[t + 2] * n), c = 1 === i ? 1 : i ** this.GR, l = 1 === s ? 1 : s ** this.GG, h = 1 === o ? 1 : o ** this.GB, u = this.MXA * c + this.MXB * l + this.MXC * h, d = this.MYA * c + this.MYB * l + this.MYC * h, f = this.MZA * c + this.MZB * l + this.MZC * h, g = CalRGBCS.#l;
                        g[0] = u;
                        g[1] = d;
                        g[2] = f;
                        const p = CalRGBCS.#h;
                        this.#w(this.whitePoint, g, p);
                        const m = CalRGBCS.#l;
                        this.#y(this.blackPoint, p, m);
                        const b = CalRGBCS.#h;
                        this.#S(CalRGBCS.#o, m, b);
                        const y = CalRGBCS.#l;
                        this.#d(CalRGBCS.#s, b, y);
                        a[r] = 255 * this.#p(y[0]);
                        a[r + 1] = 255 * this.#p(y[1]);
                        a[r + 2] = 255 * this.#p(y[2]);
                    }
                    getRgbItem(e1, t, a, r) {
                        this.#r(e1, t, a, r, 1);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = 1 / ((1 << i) - 1);
                        for(let i = 0; i < a; ++i){
                            this.#r(e1, t, r, n, o);
                            t += 3;
                            n += 3 + s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 * (3 + t) / 3 | 0;
                    }
                }
                class LabCS extends ColorSpace {
                    constructor(e1, t, a){
                        super("Lab", 3);
                        if (!e1) throw new r.FormatError("WhitePoint missing - required for color space Lab");
                        [this.XW, this.YW, this.ZW] = e1;
                        [this.amin, this.amax, this.bmin, this.bmax] = a || [
                            -100,
                            100,
                            -100,
                            100
                        ];
                        [this.XB, this.YB, this.ZB] = t || [
                            0,
                            0,
                            0
                        ];
                        if (this.XW < 0 || this.ZW < 0 || 1 !== this.YW) throw new r.FormatError("Invalid WhitePoint components, no fallback available");
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, r.info)("Invalid BlackPoint, falling back to default");
                            this.XB = this.YB = this.ZB = 0;
                        }
                        if (this.amin > this.amax || this.bmin > this.bmax) {
                            (0, r.info)("Invalid Range, falling back to defaults");
                            this.amin = -100;
                            this.amax = 100;
                            this.bmin = -100;
                            this.bmax = 100;
                        }
                    }
                    #x(e1) {
                        return e1 >= 6 / 29 ? e1 ** 3 : 108 / 841 * (e1 - 4 / 29);
                    }
                    #A(e1, t, a, r) {
                        return a + e1 * (r - a) / t;
                    }
                    #r(e1, t, a, r, n) {
                        let i = e1[t], s = e1[t + 1], o = e1[t + 2];
                        if (!1 !== a) {
                            i = this.#A(i, a, 0, 100);
                            s = this.#A(s, a, this.amin, this.amax);
                            o = this.#A(o, a, this.bmin, this.bmax);
                        }
                        s > this.amax ? s = this.amax : s < this.amin && (s = this.amin);
                        o > this.bmax ? o = this.bmax : o < this.bmin && (o = this.bmin);
                        const c = (i + 16) / 116, l = c + s / 500, h = c - o / 200, u = this.XW * this.#x(l), d = this.YW * this.#x(c), f = this.ZW * this.#x(h);
                        let g, p, m;
                        if (this.ZW < 1) {
                            g = 3.1339 * u + -1.617 * d + -0.4906 * f;
                            p = -0.9785 * u + 1.916 * d + .0333 * f;
                            m = .072 * u + -0.229 * d + 1.4057 * f;
                        } else {
                            g = 3.2406 * u + -1.5372 * d + -0.4986 * f;
                            p = -0.9689 * u + 1.8758 * d + .0415 * f;
                            m = .0557 * u + -0.204 * d + 1.057 * f;
                        }
                        r[n] = 255 * Math.sqrt(g);
                        r[n + 1] = 255 * Math.sqrt(p);
                        r[n + 2] = 255 * Math.sqrt(m);
                    }
                    getRgbItem(e1, t, a, r) {
                        this.#r(e1, t, !1, a, r);
                    }
                    getRgbBuffer(e1, t, a, r, n, i, s) {
                        const o = (1 << i) - 1;
                        for(let i = 0; i < a; i++){
                            this.#r(e1, t, o, r, n);
                            t += 3;
                            n += 3 + s;
                        }
                    }
                    getOutputLength(e1, t) {
                        return e1 * (3 + t) / 3 | 0;
                    }
                    isDefaultDecode(e1, t) {
                        return !0;
                    }
                    get usesZeroToOneRange() {
                        return (0, r.shadow)(this, "usesZeroToOneRange", !1);
                    }
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PartialEvaluator = t.EvaluatorPreprocessor = void 0;
                var r = a(2), n = a(14), i = a(4), s = a(34), o = a(37), c = a(41), l = a(50), h = a(51), u = a(42), d = a(57), f = a(16), g = a(59), p = a(8), m = a(5), b = a(60), y = a(12), w = a(18), S = a(38), x = a(61), C = a(39), k = a(45), v = a(40), F = a(62), O = a(63), T = a(64), M = a(65);
                const D = Object.freeze({
                    maxImageSize: -1,
                    disableFontFace: !1,
                    ignoreErrors: !1,
                    isEvalSupported: !0,
                    isOffscreenCanvasSupported: !1,
                    canvasMaxAreaInBytes: -1,
                    fontExtraProperties: !1,
                    useSystemFonts: !0,
                    cMapUrl: null,
                    standardFontDataUrl: null
                }), E = 1, N = 2, R = Promise.resolve();
                function normalizeBlendMode(e1, t = !1) {
                    if (Array.isArray(e1)) {
                        for (const t of e1){
                            const e1 = normalizeBlendMode(t, !0);
                            if (e1) return e1;
                        }
                        (0, r.warn)(`Unsupported blend mode Array: ${e1}`);
                        return "source-over";
                    }
                    if (!(e1 instanceof i.Name)) return t ? null : "source-over";
                    switch(e1.name){
                        case "Normal":
                        case "Compatible":
                            return "source-over";
                        case "Multiply":
                            return "multiply";
                        case "Screen":
                            return "screen";
                        case "Overlay":
                            return "overlay";
                        case "Darken":
                            return "darken";
                        case "Lighten":
                            return "lighten";
                        case "ColorDodge":
                            return "color-dodge";
                        case "ColorBurn":
                            return "color-burn";
                        case "HardLight":
                            return "hard-light";
                        case "SoftLight":
                            return "soft-light";
                        case "Difference":
                            return "difference";
                        case "Exclusion":
                            return "exclusion";
                        case "Hue":
                            return "hue";
                        case "Saturation":
                            return "saturation";
                        case "Color":
                            return "color";
                        case "Luminosity":
                            return "luminosity";
                    }
                    if (t) return null;
                    (0, r.warn)(`Unsupported blend mode: ${e1.name}`);
                    return "source-over";
                }
                function incrementCachedImageMaskCount(e1) {
                    e1.fn === r.OPS.paintImageMaskXObject && e1.args[0]?.count > 0 && e1.args[0].count++;
                }
                class TimeSlotManager {
                    static TIME_SLOT_DURATION_MS = 20;
                    static CHECK_TIME_EVERY = 100;
                    constructor(){
                        this.reset();
                    }
                    check() {
                        if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) return !1;
                        this.checked = 0;
                        return this.endTime <= Date.now();
                    }
                    reset() {
                        this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
                        this.checked = 0;
                    }
                }
                class PartialEvaluator {
                    constructor({ xref: e1, handler: t, pageIndex: a, idFactory: r, fontCache: n, builtInCMapCache: i, standardFontDataCache: s, globalImageCache: o, systemFontCache: c, options: l = null }){
                        this.xref = e1;
                        this.handler = t;
                        this.pageIndex = a;
                        this.idFactory = r;
                        this.fontCache = n;
                        this.builtInCMapCache = i;
                        this.standardFontDataCache = s;
                        this.globalImageCache = o;
                        this.systemFontCache = c;
                        this.options = l || D;
                        this.parsingType3Font = !1;
                        this._regionalImageCache = new g.RegionalImageCache;
                        this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
                        F.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
                    }
                    get _pdfFunctionFactory() {
                        const e1 = new d.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.options.isEvalSupported
                        });
                        return (0, r.shadow)(this, "_pdfFunctionFactory", e1);
                    }
                    clone(e1 = null) {
                        const t = Object.create(this);
                        t.options = Object.assign(Object.create(null), this.options, e1);
                        return t;
                    }
                    hasBlendModes(e1, t) {
                        if (!(e1 instanceof i.Dict)) return !1;
                        if (e1.objId && t.has(e1.objId)) return !1;
                        const a = new i.RefSet(t);
                        e1.objId && a.put(e1.objId);
                        const n = [
                            e1
                        ], s = this.xref;
                        for(; n.length;){
                            const e1 = n.shift(), t = e1.get("ExtGState");
                            if (t instanceof i.Dict) for (let e1 of t.getRawValues()){
                                if (e1 instanceof i.Ref) {
                                    if (a.has(e1)) continue;
                                    try {
                                        e1 = s.fetch(e1);
                                    } catch (t) {
                                        a.put(e1);
                                        (0, r.info)(`hasBlendModes - ignoring ExtGState: "${t}".`);
                                        continue;
                                    }
                                }
                                if (!(e1 instanceof i.Dict)) continue;
                                e1.objId && a.put(e1.objId);
                                const t = e1.get("BM");
                                if (t instanceof i.Name) {
                                    if ("Normal" !== t.name) return !0;
                                } else if (void 0 !== t && Array.isArray(t)) {
                                    for (const e1 of t)if (e1 instanceof i.Name && "Normal" !== e1.name) return !0;
                                }
                            }
                            const o = e1.get("XObject");
                            if (o instanceof i.Dict) for (let e1 of o.getRawValues()){
                                if (e1 instanceof i.Ref) {
                                    if (a.has(e1)) continue;
                                    try {
                                        e1 = s.fetch(e1);
                                    } catch (t) {
                                        a.put(e1);
                                        (0, r.info)(`hasBlendModes - ignoring XObject: "${t}".`);
                                        continue;
                                    }
                                }
                                if (!(e1 instanceof m.BaseStream)) continue;
                                e1.dict.objId && a.put(e1.dict.objId);
                                const t = e1.dict.get("Resources");
                                if (t instanceof i.Dict && (!t.objId || !a.has(t.objId))) {
                                    n.push(t);
                                    t.objId && a.put(t.objId);
                                }
                            }
                        }
                        for (const e1 of a)t.put(e1);
                        return !1;
                    }
                    async fetchBuiltInCMap(e1) {
                        const t = this.builtInCMapCache.get(e1);
                        if (t) return t;
                        let a;
                        if (null !== this.options.cMapUrl) {
                            const t = `${this.options.cMapUrl}${e1}.bcmap`, n = await fetch(t);
                            if (!n.ok) throw new Error(`fetchBuiltInCMap: failed to fetch file "${t}" with "${n.statusText}".`);
                            a = {
                                cMapData: new Uint8Array(await n.arrayBuffer()),
                                compressionType: r.CMapCompressionType.BINARY
                            };
                        } else a = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                            name: e1
                        });
                        a.compressionType !== r.CMapCompressionType.NONE && this.builtInCMapCache.set(e1, a);
                        return a;
                    }
                    async fetchStandardFontData(e1) {
                        const t = this.standardFontDataCache.get(e1);
                        if (t) return new p.Stream(t);
                        if (this.options.useSystemFonts && "Symbol" !== e1 && "ZapfDingbats" !== e1) return null;
                        const a = (0, c.getFontNameToFileMap)()[e1];
                        let n;
                        if (null !== this.options.standardFontDataUrl) {
                            const e1 = `${this.options.standardFontDataUrl}${a}`, t = await fetch(e1);
                            t.ok ? n = await t.arrayBuffer() : (0, r.warn)(`fetchStandardFontData: failed to fetch file "${e1}" with "${t.statusText}".`);
                        } else try {
                            n = await this.handler.sendWithPromise("FetchStandardFontData", {
                                filename: a
                            });
                        } catch (e1) {
                            (0, r.warn)(`fetchStandardFontData: failed to fetch file "${a}" with "${e1}".`);
                        }
                        if (!n) return null;
                        this.standardFontDataCache.set(e1, n);
                        return new p.Stream(n);
                    }
                    async buildFormXObject(e1, t, a, n, s, o, c) {
                        const l = t.dict, h = l.getArray("Matrix");
                        let u, d, f = l.getArray("BBox");
                        f = Array.isArray(f) && 4 === f.length ? r.Util.normalizeRect(f) : null;
                        l.has("OC") && (u = await this.parseMarkedContentProps(l.get("OC"), e1));
                        void 0 !== u && n.addOp(r.OPS.beginMarkedContentProps, [
                            "OC",
                            u
                        ]);
                        const g = l.get("Group");
                        if (g) {
                            d = {
                                matrix: h,
                                bbox: f,
                                smask: a,
                                isolated: !1,
                                knockout: !1
                            };
                            const t = g.get("S");
                            let s = null;
                            if ((0, i.isName)(t, "Transparency")) {
                                d.isolated = g.get("I") || !1;
                                d.knockout = g.get("K") || !1;
                                if (g.has("CS")) {
                                    const t = g.getRaw("CS"), a = y.ColorSpace.getCached(t, this.xref, c);
                                    s = a || await this.parseColorSpace({
                                        cs: t,
                                        resources: e1,
                                        localColorSpaceCache: c
                                    });
                                }
                            }
                            if (a?.backdrop) {
                                s ||= y.ColorSpace.singletons.rgb;
                                a.backdrop = s.getRgb(a.backdrop, 0);
                            }
                            n.addOp(r.OPS.beginGroup, [
                                d
                            ]);
                        }
                        const p = g ? [
                            h,
                            null
                        ] : [
                            h,
                            f
                        ];
                        n.addOp(r.OPS.paintFormXObjectBegin, p);
                        return this.getOperatorList({
                            stream: t,
                            task: s,
                            resources: l.get("Resources") || e1,
                            operatorList: n,
                            initialState: o
                        }).then(function() {
                            n.addOp(r.OPS.paintFormXObjectEnd, []);
                            g && n.addOp(r.OPS.endGroup, [
                                d
                            ]);
                            void 0 !== u && n.addOp(r.OPS.endMarkedContent, []);
                        });
                    }
                    _sendImgData(e1, t, a = !1) {
                        const r = t ? [
                            t.bitmap || t.data.buffer
                        ] : null;
                        return this.parsingType3Font || a ? this.handler.send("commonobj", [
                            e1,
                            "Image",
                            t
                        ], r) : this.handler.send("obj", [
                            e1,
                            this.pageIndex,
                            "Image",
                            t
                        ], r);
                    }
                    async buildPaintImageXObject({ resources: e1, image: t, isInline: a = !1, operatorList: n, cacheKey: i, localImageCache: s, localColorSpaceCache: o }) {
                        const c = t.dict, l = c.objId, h = c.get("W", "Width"), u = c.get("H", "Height");
                        if (!h || "number" != typeof h || !u || "number" != typeof u) {
                            (0, r.warn)("Image dimensions are missing, or not numbers.");
                            return;
                        }
                        const d = this.options.maxImageSize;
                        if (-1 !== d && h * u > d) {
                            const e1 = "Image exceeded maximum allowed size and was removed.";
                            if (this.options.ignoreErrors) {
                                (0, r.warn)(e1);
                                return;
                            }
                            throw new Error(e1);
                        }
                        let f;
                        c.has("OC") && (f = await this.parseMarkedContentProps(c.get("OC"), e1));
                        let g, p;
                        if (c.get("IM", "ImageMask") || !1) {
                            const e1 = c.get("I", "Interpolate"), a = h + 7 >> 3, o = t.getBytes(a * u), d = c.getArray("D", "Decode");
                            if (this.parsingType3Font) {
                                g = M.PDFImage.createRawMask({
                                    imgArray: o,
                                    width: h,
                                    height: u,
                                    imageIsFromDecodeStream: t instanceof w.DecodeStream,
                                    inverseDecode: d?.[0] > 0,
                                    interpolate: e1
                                });
                                g.cached = !!i;
                                p = [
                                    g
                                ];
                                n.addImageOps(r.OPS.paintImageMaskXObject, p, f);
                                if (i) {
                                    const e1 = {
                                        fn: r.OPS.paintImageMaskXObject,
                                        args: p,
                                        optionalContent: f
                                    };
                                    s.set(i, l, e1);
                                    l && this._regionalImageCache.set(null, l, e1);
                                }
                                return;
                            }
                            g = await M.PDFImage.createMask({
                                imgArray: o,
                                width: h,
                                height: u,
                                imageIsFromDecodeStream: t instanceof w.DecodeStream,
                                inverseDecode: d?.[0] > 0,
                                interpolate: e1,
                                isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                            });
                            if (g.isSingleOpaquePixel) {
                                n.addImageOps(r.OPS.paintSolidColorImageMask, [], f);
                                if (i) {
                                    const e1 = {
                                        fn: r.OPS.paintSolidColorImageMask,
                                        args: [],
                                        optionalContent: f
                                    };
                                    s.set(i, l, e1);
                                    l && this._regionalImageCache.set(null, l, e1);
                                }
                                return;
                            }
                            const m = `mask_${this.idFactory.createObjId()}`;
                            n.addDependency(m);
                            this._sendImgData(m, g);
                            p = [
                                {
                                    data: m,
                                    width: g.width,
                                    height: g.height,
                                    interpolate: g.interpolate,
                                    count: 1
                                }
                            ];
                            n.addImageOps(r.OPS.paintImageMaskXObject, p, f);
                            if (i) {
                                const e1 = {
                                    fn: r.OPS.paintImageMaskXObject,
                                    args: p,
                                    optionalContent: f
                                };
                                s.set(i, l, e1);
                                l && this._regionalImageCache.set(null, l, e1);
                            }
                            return;
                        }
                        if (a && !c.has("SMask") && !c.has("Mask") && h + u < 200) {
                            const i = new M.PDFImage({
                                xref: this.xref,
                                res: e1,
                                image: t,
                                isInline: a,
                                pdfFunctionFactory: this._pdfFunctionFactory,
                                localColorSpaceCache: o
                            });
                            g = await i.createImageData(!0, !1);
                            n.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported;
                            n.addImageOps(r.OPS.paintInlineImageXObject, [
                                g
                            ], f);
                            return;
                        }
                        let m = `img_${this.idFactory.createObjId()}`, b = !1;
                        if (this.parsingType3Font) m = `${this.idFactory.getDocId()}_type3_${m}`;
                        else if (l) {
                            b = this.globalImageCache.shouldCache(l, this.pageIndex);
                            b && (m = `${this.idFactory.getDocId()}_${m}`);
                        }
                        n.addDependency(m);
                        p = [
                            m,
                            h,
                            u
                        ];
                        M.PDFImage.buildImage({
                            xref: this.xref,
                            res: e1,
                            image: t,
                            isInline: a,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: o
                        }).then(async (e1)=>{
                            g = await e1.createImageData(!1, this.options.isOffscreenCanvasSupported);
                            if (i && l && b) {
                                const e1 = g.bitmap ? g.width * g.height * 4 : g.data.length;
                                this.globalImageCache.addByteSize(l, e1);
                            }
                            return this._sendImgData(m, g, b);
                        }).catch((e1)=>{
                            (0, r.warn)(`Unable to decode image "${m}": "${e1}".`);
                            return this._sendImgData(m, null, b);
                        });
                        n.addImageOps(r.OPS.paintImageXObject, p, f);
                        if (i) {
                            const e1 = {
                                fn: r.OPS.paintImageXObject,
                                args: p,
                                optionalContent: f
                            };
                            s.set(i, l, e1);
                            if (l) {
                                this._regionalImageCache.set(null, l, e1);
                                if (b) {
                                    (0, r.assert)(!a, "Cannot cache an inline image globally.");
                                    this.globalImageCache.setData(l, {
                                        objId: m,
                                        fn: r.OPS.paintImageXObject,
                                        args: p,
                                        optionalContent: f,
                                        byteSize: 0
                                    });
                                }
                            }
                        }
                    }
                    handleSMask(e1, t, a, r, n, i) {
                        const s = e1.get("G"), o = {
                            subtype: e1.get("S").name,
                            backdrop: e1.get("BC")
                        }, c = e1.get("TR");
                        if ((0, d.isPDFFunction)(c)) {
                            const e1 = this._pdfFunctionFactory.create(c), t = new Uint8Array(256), a = new Float32Array(1);
                            for(let r = 0; r < 256; r++){
                                a[0] = r / 255;
                                e1(a, 0, a, 0);
                                t[r] = 255 * a[0] | 0;
                            }
                            o.transferMap = t;
                        }
                        return this.buildFormXObject(t, s, o, a, r, n.state.clone(), i);
                    }
                    handleTransferFunction(e1) {
                        let t;
                        if (Array.isArray(e1)) t = e1;
                        else {
                            if (!(0, d.isPDFFunction)(e1)) return null;
                            t = [
                                e1
                            ];
                        }
                        const a = [];
                        let r = 0, n = 0;
                        for (const e1 of t){
                            const t = this.xref.fetchIfRef(e1);
                            r++;
                            if ((0, i.isName)(t, "Identity")) {
                                a.push(null);
                                continue;
                            }
                            if (!(0, d.isPDFFunction)(t)) return null;
                            const s = this._pdfFunctionFactory.create(t), o = new Uint8Array(256), c = new Float32Array(1);
                            for(let e1 = 0; e1 < 256; e1++){
                                c[0] = e1 / 255;
                                s(c, 0, c, 0);
                                o[e1] = 255 * c[0] | 0;
                            }
                            a.push(o);
                            n++;
                        }
                        return 1 !== r && 4 !== r || 0 === n ? null : a;
                    }
                    handleTilingType(e1, t, a, n, s, o, c, h) {
                        const u = new T.OperatorList, d = i.Dict.merge({
                            xref: this.xref,
                            dictArray: [
                                s.get("Resources"),
                                a
                            ]
                        });
                        return this.getOperatorList({
                            stream: n,
                            task: c,
                            resources: d,
                            operatorList: u
                        }).then(function() {
                            const a = u.getIR(), r = (0, l.getTilingPatternIR)(a, s, t);
                            o.addDependencies(u.dependencies);
                            o.addOp(e1, r);
                            s.objId && h.set(null, s.objId, {
                                operatorListIR: a,
                                dict: s
                            });
                        }).catch((e1)=>{
                            if (!(e1 instanceof r.AbortException)) {
                                if (!this.options.ignoreErrors) throw e1;
                                (0, r.warn)(`handleTilingType - ignoring pattern: "${e1}".`);
                            }
                        });
                    }
                    handleSetFont(e1, t, a, r, n, o, c = null, l = null) {
                        const h = t?.[0] instanceof i.Name ? t[0].name : null;
                        return this.loadFont(h, a, e1, c, l).then((t)=>t.font.isType3Font ? t.loadType3Data(this, e1, n).then(function() {
                                r.addDependencies(t.type3Dependencies);
                                return t;
                            }).catch((e1)=>new TranslatedFont({
                                    loadedName: "g_font_error",
                                    font: new s.ErrorFont(`Type3 font load error: ${e1}`),
                                    dict: t.font,
                                    evaluatorOptions: this.options
                                })) : t).then((e1)=>{
                            o.font = e1.font;
                            e1.send(this.handler);
                            return e1.loadedName;
                        });
                    }
                    handleText(e1, t) {
                        const a = t.font, n = a.charsToGlyphs(e1);
                        if (a.data) (!!(t.textRenderingMode & r.TextRenderingMode.ADD_TO_PATH_FLAG) || "Pattern" === t.fillColorSpace.name || a.disableFontFace || this.options.disableFontFace) && PartialEvaluator.buildFontPaths(a, n, this.handler, this.options);
                        return n;
                    }
                    ensureStateFont(e1) {
                        if (e1.font) return;
                        const t = new r.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                        if (!this.options.ignoreErrors) throw t;
                        (0, r.warn)(`ensureStateFont: "${t}".`);
                    }
                    async setGState({ resources: e1, gState: t, operatorList: a, cacheKey: n, task: s, stateManager: o, localGStateCache: c, localColorSpaceCache: l }) {
                        const h = t.objId;
                        let u = !0;
                        const d = [];
                        let f = Promise.resolve();
                        for (const n of t.getKeys()){
                            const c = t.get(n);
                            switch(n){
                                case "Type":
                                    break;
                                case "LW":
                                case "LC":
                                case "LJ":
                                case "ML":
                                case "D":
                                case "RI":
                                case "FL":
                                case "CA":
                                case "ca":
                                    d.push([
                                        n,
                                        c
                                    ]);
                                    break;
                                case "Font":
                                    u = !1;
                                    f = f.then(()=>this.handleSetFont(e1, null, c[0], a, s, o.state).then(function(e1) {
                                            a.addDependency(e1);
                                            d.push([
                                                n,
                                                [
                                                    e1,
                                                    c[1]
                                                ]
                                            ]);
                                        }));
                                    break;
                                case "BM":
                                    d.push([
                                        n,
                                        normalizeBlendMode(c)
                                    ]);
                                    break;
                                case "SMask":
                                    if ((0, i.isName)(c, "None")) {
                                        d.push([
                                            n,
                                            !1
                                        ]);
                                        break;
                                    }
                                    if (c instanceof i.Dict) {
                                        u = !1;
                                        f = f.then(()=>this.handleSMask(c, e1, a, s, o, l));
                                        d.push([
                                            n,
                                            !0
                                        ]);
                                    } else (0, r.warn)("Unsupported SMask type");
                                    break;
                                case "TR":
                                    const t1 = this.handleTransferFunction(c);
                                    d.push([
                                        n,
                                        t1
                                    ]);
                                    break;
                                case "OP":
                                case "op":
                                case "OPM":
                                case "BG":
                                case "BG2":
                                case "UCR":
                                case "UCR2":
                                case "TR2":
                                case "HT":
                                case "SM":
                                case "SA":
                                case "AIS":
                                case "TK":
                                    (0, r.info)("graphic state operator " + n);
                                    break;
                                default:
                                    (0, r.info)("Unknown graphic state operator " + n);
                            }
                        }
                        return f.then(function() {
                            d.length > 0 && a.addOp(r.OPS.setGState, [
                                d
                            ]);
                            u && c.set(n, h, d);
                        });
                    }
                    loadFont(e1, t, a, n = null, o = null) {
                        const errorFont = async ()=>new TranslatedFont({
                                loadedName: "g_font_error",
                                font: new s.ErrorFont(`Font "${e1}" is not available.`),
                                dict: t,
                                evaluatorOptions: this.options
                            });
                        let c;
                        if (t) t instanceof i.Ref && (c = t);
                        else {
                            const t = a.get("Font");
                            t && (c = t.getRaw(e1));
                        }
                        if (c) {
                            if (this.parsingType3Font && this.type3FontRefs.has(c)) return errorFont();
                            if (this.fontCache.has(c)) return this.fontCache.get(c);
                            t = this.xref.fetchIfRef(c);
                        }
                        if (!(t instanceof i.Dict)) {
                            if (!this.options.ignoreErrors && !this.parsingType3Font) {
                                (0, r.warn)(`Font "${e1}" is not available.`);
                                return errorFont();
                            }
                            (0, r.warn)(`Font "${e1}" is not available -- attempting to fallback to a default font.`);
                            t = n || PartialEvaluator.fallbackFontDict;
                        }
                        if (t.cacheKey && this.fontCache.has(t.cacheKey)) return this.fontCache.get(t.cacheKey);
                        const l = new r.PromiseCapability;
                        let h;
                        try {
                            h = this.preEvaluateFont(t);
                            h.cssFontInfo = o;
                        } catch (e1) {
                            (0, r.warn)(`loadFont - preEvaluateFont failed: "${e1}".`);
                            return errorFont();
                        }
                        const { descriptor: u, hash: d } = h, f = c instanceof i.Ref;
                        let g;
                        if (d && u instanceof i.Dict) {
                            const e1 = u.fontAliases ||= Object.create(null);
                            if (e1[d]) {
                                const t = e1[d].aliasRef;
                                if (f && t && this.fontCache.has(t)) {
                                    this.fontCache.putAlias(c, t);
                                    return this.fontCache.get(c);
                                }
                            } else e1[d] = {
                                fontID: this.idFactory.createFontId()
                            };
                            f && (e1[d].aliasRef = c);
                            g = e1[d].fontID;
                        } else g = this.idFactory.createFontId();
                        (0, r.assert)(g?.startsWith("f"), 'The "fontID" must be (correctly) defined.');
                        if (f) this.fontCache.put(c, l.promise);
                        else {
                            t.cacheKey = `cacheKey_${g}`;
                            this.fontCache.put(t.cacheKey, l.promise);
                        }
                        t.loadedName = `${this.idFactory.getDocId()}_${g}`;
                        this.translateFont(h).then((e1)=>{
                            l.resolve(new TranslatedFont({
                                loadedName: t.loadedName,
                                font: e1,
                                dict: t,
                                evaluatorOptions: this.options
                            }));
                        }).catch((e1)=>{
                            (0, r.warn)(`loadFont - translateFont failed: "${e1}".`);
                            l.resolve(new TranslatedFont({
                                loadedName: t.loadedName,
                                font: new s.ErrorFont(e1 instanceof Error ? e1.message : e1),
                                dict: t,
                                evaluatorOptions: this.options
                            }));
                        });
                        return l.promise;
                    }
                    buildPath(e1, t, a, n = !1) {
                        const i = e1.length - 1;
                        a || (a = []);
                        if (i < 0 || e1.fnArray[i] !== r.OPS.constructPath) {
                            if (n) {
                                (0, r.warn)(`Encountered path operator "${t}" inside of a text object.`);
                                e1.addOp(r.OPS.save, null);
                            }
                            let i;
                            switch(t){
                                case r.OPS.rectangle:
                                    const e2 = a[0] + a[2], t1 = a[1] + a[3];
                                    i = [
                                        Math.min(a[0], e2),
                                        Math.max(a[0], e2),
                                        Math.min(a[1], t1),
                                        Math.max(a[1], t1)
                                    ];
                                    break;
                                case r.OPS.moveTo:
                                case r.OPS.lineTo:
                                    i = [
                                        a[0],
                                        a[0],
                                        a[1],
                                        a[1]
                                    ];
                                    break;
                                default:
                                    i = [
                                        1 / 0,
                                        -1 / 0,
                                        1 / 0,
                                        -1 / 0
                                    ];
                            }
                            e1.addOp(r.OPS.constructPath, [
                                [
                                    t
                                ],
                                a,
                                i
                            ]);
                            n && e1.addOp(r.OPS.restore, null);
                        } else {
                            const n = e1.argsArray[i];
                            n[0].push(t);
                            n[1].push(...a);
                            const s = n[2];
                            switch(t){
                                case r.OPS.rectangle:
                                    const e2 = a[0] + a[2], t1 = a[1] + a[3];
                                    s[0] = Math.min(s[0], a[0], e2);
                                    s[1] = Math.max(s[1], a[0], e2);
                                    s[2] = Math.min(s[2], a[1], t1);
                                    s[3] = Math.max(s[3], a[1], t1);
                                    break;
                                case r.OPS.moveTo:
                                case r.OPS.lineTo:
                                    s[0] = Math.min(s[0], a[0]);
                                    s[1] = Math.max(s[1], a[0]);
                                    s[2] = Math.min(s[2], a[1]);
                                    s[3] = Math.max(s[3], a[1]);
                            }
                        }
                    }
                    parseColorSpace({ cs: e1, resources: t, localColorSpaceCache: a }) {
                        return y.ColorSpace.parseAsync({
                            cs: e1,
                            xref: this.xref,
                            resources: t,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: a
                        }).catch((e1)=>{
                            if (e1 instanceof r.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, r.warn)(`parseColorSpace - ignoring ColorSpace: "${e1}".`);
                                return null;
                            }
                            throw e1;
                        });
                    }
                    parseShading({ shading: e1, resources: t, localColorSpaceCache: a, localShadingPatternCache: r }) {
                        let n = r.get(e1);
                        if (!n) {
                            const i = l.Pattern.parseShading(e1, this.xref, t, this._pdfFunctionFactory, a).getIR();
                            n = `pattern_${this.idFactory.createObjId()}`;
                            this.parsingType3Font && (n = `${this.idFactory.getDocId()}_type3_${n}`);
                            r.set(e1, n);
                            this.parsingType3Font ? this.handler.send("commonobj", [
                                n,
                                "Pattern",
                                i
                            ]) : this.handler.send("obj", [
                                n,
                                this.pageIndex,
                                "Pattern",
                                i
                            ]);
                        }
                        return n;
                    }
                    handleColorN(e1, t, a, n, s, o, c, h, u, d) {
                        const f = a.pop();
                        if (f instanceof i.Name) {
                            const g = s.getRaw(f.name), p = g instanceof i.Ref && u.getByRef(g);
                            if (p) try {
                                const r = n.base ? n.base.getRgb(a, 0) : null, i = (0, l.getTilingPatternIR)(p.operatorListIR, p.dict, r);
                                e1.addOp(t, i);
                                return;
                            } catch  {}
                            const b = this.xref.fetchIfRef(g);
                            if (b) {
                                const i = b instanceof m.BaseStream ? b.dict : b, s = i.get("PatternType");
                                if (s === E) {
                                    const r = n.base ? n.base.getRgb(a, 0) : null;
                                    return this.handleTilingType(t, r, o, b, i, e1, c, u);
                                }
                                if (s === N) {
                                    const a = i.get("Shading"), r = i.getArray("Matrix"), n = this.parseShading({
                                        shading: a,
                                        resources: o,
                                        localColorSpaceCache: h,
                                        localShadingPatternCache: d
                                    });
                                    e1.addOp(t, [
                                        "Shading",
                                        n,
                                        r
                                    ]);
                                    return;
                                }
                                throw new r.FormatError(`Unknown PatternType: ${s}`);
                            }
                        }
                        throw new r.FormatError(`Unknown PatternName: ${f}`);
                    }
                    _parseVisibilityExpression(e1, t, a) {
                        if (++t > 10) {
                            (0, r.warn)("Visibility expression is too deeply nested");
                            return;
                        }
                        const n = e1.length, s = this.xref.fetchIfRef(e1[0]);
                        if (!(n < 2) && s instanceof i.Name) {
                            switch(s.name){
                                case "And":
                                case "Or":
                                case "Not":
                                    a.push(s.name);
                                    break;
                                default:
                                    (0, r.warn)(`Invalid operator ${s.name} in visibility expression`);
                                    return;
                            }
                            for(let r = 1; r < n; r++){
                                const n = e1[r], s = this.xref.fetchIfRef(n);
                                if (Array.isArray(s)) {
                                    const e1 = [];
                                    a.push(e1);
                                    this._parseVisibilityExpression(s, t, e1);
                                } else n instanceof i.Ref && a.push(n.toString());
                            }
                        } else (0, r.warn)("Invalid visibility expression");
                    }
                    async parseMarkedContentProps(e1, t) {
                        let a;
                        if (e1 instanceof i.Name) a = t.get("Properties").get(e1.name);
                        else {
                            if (!(e1 instanceof i.Dict)) throw new r.FormatError("Optional content properties malformed.");
                            a = e1;
                        }
                        const n = a.get("Type")?.name;
                        if ("OCG" === n) return {
                            type: n,
                            id: a.objId
                        };
                        if ("OCMD" === n) {
                            const e1 = a.get("VE");
                            if (Array.isArray(e1)) {
                                const t = [];
                                this._parseVisibilityExpression(e1, 0, t);
                                if (t.length > 0) return {
                                    type: "OCMD",
                                    expression: t
                                };
                            }
                            const t = a.get("OCGs");
                            if (Array.isArray(t) || t instanceof i.Dict) {
                                const e1 = [];
                                if (Array.isArray(t)) for (const a of t)e1.push(a.toString());
                                else e1.push(t.objId);
                                return {
                                    type: n,
                                    ids: e1,
                                    policy: a.get("P") instanceof i.Name ? a.get("P").name : null,
                                    expression: null
                                };
                            }
                            if (t instanceof i.Ref) return {
                                type: n,
                                id: t.toString()
                            };
                        }
                        return null;
                    }
                    getOperatorList({ stream: e1, task: t, resources: a, operatorList: n, initialState: s = null, fallbackFontDict: o = null }) {
                        a ||= i.Dict.empty;
                        s ||= new EvalState;
                        if (!n) throw new Error('getOperatorList: missing "operatorList" parameter');
                        const c = this, l = this.xref;
                        let h = !1;
                        const u = new g.LocalImageCache, d = new g.LocalColorSpaceCache, f = new g.LocalGStateCache, p = new g.LocalTilingPatternCache, b = new Map, w = a.get("XObject") || i.Dict.empty, S = a.get("Pattern") || i.Dict.empty, x = new StateManager(s), C = new EvaluatorPreprocessor(e1, l, x), k = new TimeSlotManager;
                        function closePendingRestoreOPS(e1) {
                            for(let e1 = 0, t = C.savedStatesDepth; e1 < t; e1++)n.addOp(r.OPS.restore, []);
                        }
                        return new Promise(function promiseBody(e1, s) {
                            const next = function(t) {
                                Promise.all([
                                    t,
                                    n.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(e1, s);
                                    } catch (e1) {
                                        s(e1);
                                    }
                                }, s);
                            };
                            t.ensureNotTerminated();
                            k.reset();
                            const g = {};
                            let v, F, O, T, M, D;
                            for(; !(v = k.check());){
                                g.args = null;
                                if (!C.read(g)) break;
                                let e1 = g.args, s = g.fn;
                                switch(0 | s){
                                    case r.OPS.paintXObject:
                                        D = e1[0] instanceof i.Name;
                                        M = e1[0].name;
                                        if (D) {
                                            const t = u.getByName(M);
                                            if (t) {
                                                n.addImageOps(t.fn, t.args, t.optionalContent);
                                                incrementCachedImageMaskCount(t);
                                                e1 = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(e1, s) {
                                            if (!D) throw new r.FormatError("XObject must be referred to by name.");
                                            let o = w.getRaw(M);
                                            if (o instanceof i.Ref) {
                                                const t = u.getByRef(o) || c._regionalImageCache.getByRef(o);
                                                if (t) {
                                                    n.addImageOps(t.fn, t.args, t.optionalContent);
                                                    incrementCachedImageMaskCount(t);
                                                    e1();
                                                    return;
                                                }
                                                const a = c.globalImageCache.getData(o, c.pageIndex);
                                                if (a) {
                                                    n.addDependency(a.objId);
                                                    n.addImageOps(a.fn, a.args, a.optionalContent);
                                                    e1();
                                                    return;
                                                }
                                                o = l.fetch(o);
                                            }
                                            if (!(o instanceof m.BaseStream)) throw new r.FormatError("XObject should be a stream");
                                            const h = o.dict.get("Subtype");
                                            if (!(h instanceof i.Name)) throw new r.FormatError("XObject should have a Name subtype");
                                            if ("Form" !== h.name) {
                                                if ("Image" !== h.name) {
                                                    if ("PS" !== h.name) throw new r.FormatError(`Unhandled XObject subtype ${h.name}`);
                                                    (0, r.info)("Ignored XObject subtype PS");
                                                    e1();
                                                } else c.buildPaintImageXObject({
                                                    resources: a,
                                                    image: o,
                                                    operatorList: n,
                                                    cacheKey: M,
                                                    localImageCache: u,
                                                    localColorSpaceCache: d
                                                }).then(e1, s);
                                            } else {
                                                x.save();
                                                c.buildFormXObject(a, o, null, n, t, x.state.clone(), d).then(function() {
                                                    x.restore();
                                                    e1();
                                                }, s);
                                            }
                                        }).catch(function(e1) {
                                            if (!(e1 instanceof r.AbortException)) {
                                                if (!c.options.ignoreErrors) throw e1;
                                                (0, r.warn)(`getOperatorList - ignoring XObject: "${e1}".`);
                                            }
                                        }));
                                        return;
                                    case r.OPS.setFont:
                                        var E = e1[1];
                                        next(c.handleSetFont(a, e1, null, n, t, x.state, o).then(function(e1) {
                                            n.addDependency(e1);
                                            n.addOp(r.OPS.setFont, [
                                                e1,
                                                E
                                            ]);
                                        }));
                                        return;
                                    case r.OPS.beginText:
                                        h = !0;
                                        break;
                                    case r.OPS.endText:
                                        h = !1;
                                        break;
                                    case r.OPS.endInlineImage:
                                        var N = e1[0].cacheKey;
                                        if (N) {
                                            const t = u.getByName(N);
                                            if (t) {
                                                n.addImageOps(t.fn, t.args, t.optionalContent);
                                                incrementCachedImageMaskCount(t);
                                                e1 = null;
                                                continue;
                                            }
                                        }
                                        next(c.buildPaintImageXObject({
                                            resources: a,
                                            image: e1[0],
                                            isInline: !0,
                                            operatorList: n,
                                            cacheKey: N,
                                            localImageCache: u,
                                            localColorSpaceCache: d
                                        }));
                                        return;
                                    case r.OPS.showText:
                                        if (!x.state.font) {
                                            c.ensureStateFont(x.state);
                                            continue;
                                        }
                                        e1[0] = c.handleText(e1[0], x.state);
                                        break;
                                    case r.OPS.showSpacedText:
                                        if (!x.state.font) {
                                            c.ensureStateFont(x.state);
                                            continue;
                                        }
                                        var L = [], $ = x.state;
                                        for (const t of e1[0])"string" == typeof t ? L.push(...c.handleText(t, $)) : "number" == typeof t && L.push(t);
                                        e1[0] = L;
                                        s = r.OPS.showText;
                                        break;
                                    case r.OPS.nextLineShowText:
                                        if (!x.state.font) {
                                            c.ensureStateFont(x.state);
                                            continue;
                                        }
                                        n.addOp(r.OPS.nextLine);
                                        e1[0] = c.handleText(e1[0], x.state);
                                        s = r.OPS.showText;
                                        break;
                                    case r.OPS.nextLineSetSpacingShowText:
                                        if (!x.state.font) {
                                            c.ensureStateFont(x.state);
                                            continue;
                                        }
                                        n.addOp(r.OPS.nextLine);
                                        n.addOp(r.OPS.setWordSpacing, [
                                            e1.shift()
                                        ]);
                                        n.addOp(r.OPS.setCharSpacing, [
                                            e1.shift()
                                        ]);
                                        e1[0] = c.handleText(e1[0], x.state);
                                        s = r.OPS.showText;
                                        break;
                                    case r.OPS.setTextRenderingMode:
                                        x.state.textRenderingMode = e1[0];
                                        break;
                                    case r.OPS.setFillColorSpace:
                                        {
                                            const t = y.ColorSpace.getCached(e1[0], l, d);
                                            if (t) {
                                                x.state.fillColorSpace = t;
                                                continue;
                                            }
                                            next(c.parseColorSpace({
                                                cs: e1[0],
                                                resources: a,
                                                localColorSpaceCache: d
                                            }).then(function(e1) {
                                                e1 && (x.state.fillColorSpace = e1);
                                            }));
                                            return;
                                        }
                                    case r.OPS.setStrokeColorSpace:
                                        {
                                            const t = y.ColorSpace.getCached(e1[0], l, d);
                                            if (t) {
                                                x.state.strokeColorSpace = t;
                                                continue;
                                            }
                                            next(c.parseColorSpace({
                                                cs: e1[0],
                                                resources: a,
                                                localColorSpaceCache: d
                                            }).then(function(e1) {
                                                e1 && (x.state.strokeColorSpace = e1);
                                            }));
                                            return;
                                        }
                                    case r.OPS.setFillColor:
                                        T = x.state.fillColorSpace;
                                        e1 = T.getRgb(e1, 0);
                                        s = r.OPS.setFillRGBColor;
                                        break;
                                    case r.OPS.setStrokeColor:
                                        T = x.state.strokeColorSpace;
                                        e1 = T.getRgb(e1, 0);
                                        s = r.OPS.setStrokeRGBColor;
                                        break;
                                    case r.OPS.setFillGray:
                                        x.state.fillColorSpace = y.ColorSpace.singletons.gray;
                                        e1 = y.ColorSpace.singletons.gray.getRgb(e1, 0);
                                        s = r.OPS.setFillRGBColor;
                                        break;
                                    case r.OPS.setStrokeGray:
                                        x.state.strokeColorSpace = y.ColorSpace.singletons.gray;
                                        e1 = y.ColorSpace.singletons.gray.getRgb(e1, 0);
                                        s = r.OPS.setStrokeRGBColor;
                                        break;
                                    case r.OPS.setFillCMYKColor:
                                        x.state.fillColorSpace = y.ColorSpace.singletons.cmyk;
                                        e1 = y.ColorSpace.singletons.cmyk.getRgb(e1, 0);
                                        s = r.OPS.setFillRGBColor;
                                        break;
                                    case r.OPS.setStrokeCMYKColor:
                                        x.state.strokeColorSpace = y.ColorSpace.singletons.cmyk;
                                        e1 = y.ColorSpace.singletons.cmyk.getRgb(e1, 0);
                                        s = r.OPS.setStrokeRGBColor;
                                        break;
                                    case r.OPS.setFillRGBColor:
                                        x.state.fillColorSpace = y.ColorSpace.singletons.rgb;
                                        e1 = y.ColorSpace.singletons.rgb.getRgb(e1, 0);
                                        break;
                                    case r.OPS.setStrokeRGBColor:
                                        x.state.strokeColorSpace = y.ColorSpace.singletons.rgb;
                                        e1 = y.ColorSpace.singletons.rgb.getRgb(e1, 0);
                                        break;
                                    case r.OPS.setFillColorN:
                                        T = x.state.fillColorSpace;
                                        if ("Pattern" === T.name) {
                                            next(c.handleColorN(n, r.OPS.setFillColorN, e1, T, S, a, t, d, p, b));
                                            return;
                                        }
                                        e1 = T.getRgb(e1, 0);
                                        s = r.OPS.setFillRGBColor;
                                        break;
                                    case r.OPS.setStrokeColorN:
                                        T = x.state.strokeColorSpace;
                                        if ("Pattern" === T.name) {
                                            next(c.handleColorN(n, r.OPS.setStrokeColorN, e1, T, S, a, t, d, p, b));
                                            return;
                                        }
                                        e1 = T.getRgb(e1, 0);
                                        s = r.OPS.setStrokeRGBColor;
                                        break;
                                    case r.OPS.shadingFill:
                                        var _ = a.get("Shading");
                                        if (!_) throw new r.FormatError("No shading resource found");
                                        var j = _.get(e1[0].name);
                                        if (!j) throw new r.FormatError("No shading object found");
                                        e1 = [
                                            c.parseShading({
                                                shading: j,
                                                resources: a,
                                                localColorSpaceCache: d,
                                                localShadingPatternCache: b
                                            })
                                        ];
                                        s = r.OPS.shadingFill;
                                        break;
                                    case r.OPS.setGState:
                                        D = e1[0] instanceof i.Name;
                                        M = e1[0].name;
                                        if (D) {
                                            const t = f.getByName(M);
                                            if (t) {
                                                t.length > 0 && n.addOp(r.OPS.setGState, [
                                                    t
                                                ]);
                                                e1 = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(e1, s) {
                                            if (!D) throw new r.FormatError("GState must be referred to by name.");
                                            const o = a.get("ExtGState");
                                            if (!(o instanceof i.Dict)) throw new r.FormatError("ExtGState should be a dictionary.");
                                            const l = o.get(M);
                                            if (!(l instanceof i.Dict)) throw new r.FormatError("GState should be a dictionary.");
                                            c.setGState({
                                                resources: a,
                                                gState: l,
                                                operatorList: n,
                                                cacheKey: M,
                                                task: t,
                                                stateManager: x,
                                                localGStateCache: f,
                                                localColorSpaceCache: d
                                            }).then(e1, s);
                                        }).catch(function(e1) {
                                            if (!(e1 instanceof r.AbortException)) {
                                                if (!c.options.ignoreErrors) throw e1;
                                                (0, r.warn)(`getOperatorList - ignoring ExtGState: "${e1}".`);
                                            }
                                        }));
                                        return;
                                    case r.OPS.moveTo:
                                    case r.OPS.lineTo:
                                    case r.OPS.curveTo:
                                    case r.OPS.curveTo2:
                                    case r.OPS.curveTo3:
                                    case r.OPS.closePath:
                                    case r.OPS.rectangle:
                                        c.buildPath(n, s, e1, h);
                                        continue;
                                    case r.OPS.markPoint:
                                    case r.OPS.markPointProps:
                                    case r.OPS.beginCompat:
                                    case r.OPS.endCompat:
                                        continue;
                                    case r.OPS.beginMarkedContentProps:
                                        if (!(e1[0] instanceof i.Name)) {
                                            (0, r.warn)(`Expected name for beginMarkedContentProps arg0=${e1[0]}`);
                                            continue;
                                        }
                                        if ("OC" === e1[0].name) {
                                            next(c.parseMarkedContentProps(e1[1], a).then((e1)=>{
                                                n.addOp(r.OPS.beginMarkedContentProps, [
                                                    "OC",
                                                    e1
                                                ]);
                                            }).catch((e1)=>{
                                                if (!(e1 instanceof r.AbortException)) {
                                                    if (!c.options.ignoreErrors) throw e1;
                                                    (0, r.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${e1}".`);
                                                }
                                            }));
                                            return;
                                        }
                                        e1 = [
                                            e1[0].name,
                                            e1[1] instanceof i.Dict ? e1[1].get("MCID") : null
                                        ];
                                        break;
                                    case r.OPS.beginMarkedContent:
                                    case r.OPS.endMarkedContent:
                                    default:
                                        if (null !== e1) {
                                            for(F = 0, O = e1.length; F < O && !(e1[F] instanceof i.Dict); F++);
                                            if (F < O) {
                                                (0, r.warn)("getOperatorList - ignoring operator: " + s);
                                                continue;
                                            }
                                        }
                                }
                                n.addOp(s, e1);
                            }
                            if (v) next(R);
                            else {
                                closePendingRestoreOPS();
                                e1();
                            }
                        }).catch((e1)=>{
                            if (!(e1 instanceof r.AbortException)) {
                                if (!this.options.ignoreErrors) throw e1;
                                (0, r.warn)(`getOperatorList - ignoring errors during "${t.name}" task: "${e1}".`);
                                closePendingRestoreOPS();
                            }
                        });
                    }
                    getTextContent({ stream: e1, task: t, resources: a, stateManager: n = null, includeMarkedContent: s = !1, sink: o, seenStyles: c = new Set, viewBox: l, markedContentData: h = null, disableNormalization: u = !1 }) {
                        a ||= i.Dict.empty;
                        n ||= new StateManager(new TextState);
                        s && (h ||= {
                            level: 0
                        });
                        const d = {
                            items: [],
                            styles: Object.create(null)
                        }, f = {
                            initialized: !1,
                            str: [],
                            totalWidth: 0,
                            totalHeight: 0,
                            width: 0,
                            height: 0,
                            vertical: !1,
                            prevTransform: null,
                            textAdvanceScale: 0,
                            spaceInFlowMin: 0,
                            spaceInFlowMax: 0,
                            trackingSpaceMin: 1 / 0,
                            negativeSpaceMax: -1 / 0,
                            notASpace: -1 / 0,
                            transform: null,
                            fontName: null,
                            hasEOL: !1
                        }, p = [
                            " ",
                            " "
                        ];
                        let y = 0;
                        function saveLastChar(e1) {
                            const t = (y + 1) % 2, a = " " !== p[y] && " " === p[t];
                            p[y] = e1;
                            y = t;
                            return a;
                        }
                        function shouldAddWhitepsace() {
                            return " " !== p[y] && " " === p[(y + 1) % 2];
                        }
                        function resetLastChars() {
                            p[0] = p[1] = " ";
                            y = 0;
                        }
                        const w = this, S = this.xref, x = [];
                        let C = null;
                        const k = new g.LocalImageCache, v = new g.LocalGStateCache, F = new EvaluatorPreprocessor(e1, S, n);
                        let O;
                        function pushWhitespace({ width: e1 = 0, height: t = 0, transform: a = f.prevTransform, fontName: r = f.fontName }) {
                            d.items.push({
                                str: " ",
                                dir: "ltr",
                                width: e1,
                                height: t,
                                transform: a,
                                fontName: r,
                                hasEOL: !1
                            });
                        }
                        function getCurrentTextTransform() {
                            const e1 = O.font, t = [
                                O.fontSize * O.textHScale,
                                0,
                                0,
                                O.fontSize,
                                0,
                                O.textRise
                            ];
                            if (e1.isType3Font && (O.fontSize <= 1 || e1.isCharBBox) && !(0, r.isArrayEqual)(O.fontMatrix, r.FONT_IDENTITY_MATRIX)) {
                                const a = e1.bbox[3] - e1.bbox[1];
                                a > 0 && (t[3] *= a * O.fontMatrix[3]);
                            }
                            return r.Util.transform(O.ctm, r.Util.transform(O.textMatrix, t));
                        }
                        function ensureTextContentItem() {
                            if (f.initialized) return f;
                            const { font: e1, loadedName: t } = O;
                            if (!c.has(t)) {
                                c.add(t);
                                d.styles[t] = {
                                    fontFamily: e1.fallbackName,
                                    ascent: e1.ascent,
                                    descent: e1.descent,
                                    vertical: e1.vertical
                                };
                            }
                            f.fontName = t;
                            const a = f.transform = getCurrentTextTransform();
                            if (e1.vertical) {
                                f.width = f.totalWidth = Math.hypot(a[0], a[1]);
                                f.height = f.totalHeight = 0;
                                f.vertical = !0;
                            } else {
                                f.width = f.totalWidth = 0;
                                f.height = f.totalHeight = Math.hypot(a[2], a[3]);
                                f.vertical = !1;
                            }
                            const r = Math.hypot(O.textLineMatrix[0], O.textLineMatrix[1]), n = Math.hypot(O.ctm[0], O.ctm[1]);
                            f.textAdvanceScale = n * r;
                            const { fontSize: i } = O;
                            f.trackingSpaceMin = .102 * i;
                            f.notASpace = .03 * i;
                            f.negativeSpaceMax = -0.2 * i;
                            f.spaceInFlowMin = .102 * i;
                            f.spaceInFlowMax = .6 * i;
                            f.hasEOL = !1;
                            f.initialized = !0;
                            return f;
                        }
                        function updateAdvanceScale() {
                            if (!f.initialized) return;
                            const e1 = Math.hypot(O.textLineMatrix[0], O.textLineMatrix[1]), t = Math.hypot(O.ctm[0], O.ctm[1]) * e1;
                            if (t !== f.textAdvanceScale) {
                                if (f.vertical) {
                                    f.totalHeight += f.height * f.textAdvanceScale;
                                    f.height = 0;
                                } else {
                                    f.totalWidth += f.width * f.textAdvanceScale;
                                    f.width = 0;
                                }
                                f.textAdvanceScale = t;
                            }
                        }
                        function handleSetFont(e1, n) {
                            return w.loadFont(e1, n, a).then(function(e1) {
                                return e1.font.isType3Font ? e1.loadType3Data(w, a, t).catch(function() {}).then(function() {
                                    return e1;
                                }) : e1;
                            }).then(function(e1) {
                                O.loadedName = e1.loadedName;
                                O.font = e1.font;
                                O.fontMatrix = e1.font.fontMatrix || r.FONT_IDENTITY_MATRIX;
                            });
                        }
                        function applyInverseRotation(e1, t, a) {
                            const r = Math.hypot(a[0], a[1]);
                            return [
                                (a[0] * e1 + a[1] * t) / r,
                                (a[2] * e1 + a[3] * t) / r
                            ];
                        }
                        function compareWithLastPosition(e1) {
                            const t = getCurrentTextTransform();
                            let a = t[4], r = t[5];
                            if (O.font?.vertical) {
                                if (a < l[0] || a > l[2] || r + e1 < l[1] || r > l[3]) return !1;
                            } else if (a + e1 < l[0] || a > l[2] || r < l[1] || r > l[3]) return !1;
                            if (!O.font || !f.prevTransform) return !0;
                            let n = f.prevTransform[4], i = f.prevTransform[5];
                            if (n === a && i === r) return !0;
                            let s = -1;
                            t[0] && 0 === t[1] && 0 === t[2] ? s = t[0] > 0 ? 0 : 180 : t[1] && 0 === t[0] && 0 === t[3] && (s = t[1] > 0 ? 90 : 270);
                            switch(s){
                                case 0:
                                    break;
                                case 90:
                                    [a, r] = [
                                        r,
                                        a
                                    ];
                                    [n, i] = [
                                        i,
                                        n
                                    ];
                                    break;
                                case 180:
                                    [a, r, n, i] = [
                                        -a,
                                        -r,
                                        -n,
                                        -i
                                    ];
                                    break;
                                case 270:
                                    [a, r] = [
                                        -r,
                                        -a
                                    ];
                                    [n, i] = [
                                        -i,
                                        -n
                                    ];
                                    break;
                                default:
                                    [a, r] = applyInverseRotation(a, r, t);
                                    [n, i] = applyInverseRotation(n, i, f.prevTransform);
                            }
                            if (O.font.vertical) {
                                const e1 = (i - r) / f.textAdvanceScale, t = a - n, s = Math.sign(f.height);
                                if (e1 < s * f.negativeSpaceMax) {
                                    if (Math.abs(t) > .5 * f.width) {
                                        appendEOL();
                                        return !0;
                                    }
                                    resetLastChars();
                                    flushTextContentItem();
                                    return !0;
                                }
                                if (Math.abs(t) > f.width) {
                                    appendEOL();
                                    return !0;
                                }
                                e1 <= s * f.notASpace && resetLastChars();
                                if (e1 <= s * f.trackingSpaceMin) {
                                    if (shouldAddWhitepsace()) {
                                        resetLastChars();
                                        flushTextContentItem();
                                        pushWhitespace({
                                            height: Math.abs(e1)
                                        });
                                    } else f.height += e1;
                                } else if (!addFakeSpaces(e1, f.prevTransform, s)) {
                                    if (0 === f.str.length) {
                                        resetLastChars();
                                        pushWhitespace({
                                            height: Math.abs(e1)
                                        });
                                    } else f.height += e1;
                                }
                                Math.abs(t) > .25 * f.width && flushTextContentItem();
                                return !0;
                            }
                            const o = (a - n) / f.textAdvanceScale, c = r - i, h = Math.sign(f.width);
                            if (o < h * f.negativeSpaceMax) {
                                if (Math.abs(c) > .5 * f.height) {
                                    appendEOL();
                                    return !0;
                                }
                                resetLastChars();
                                flushTextContentItem();
                                return !0;
                            }
                            if (Math.abs(c) > f.height) {
                                appendEOL();
                                return !0;
                            }
                            o <= h * f.notASpace && resetLastChars();
                            if (o <= h * f.trackingSpaceMin) {
                                if (shouldAddWhitepsace()) {
                                    resetLastChars();
                                    flushTextContentItem();
                                    pushWhitespace({
                                        width: Math.abs(o)
                                    });
                                } else f.width += o;
                            } else if (!addFakeSpaces(o, f.prevTransform, h)) {
                                if (0 === f.str.length) {
                                    resetLastChars();
                                    pushWhitespace({
                                        width: Math.abs(o)
                                    });
                                } else f.width += o;
                            }
                            Math.abs(c) > .25 * f.height && flushTextContentItem();
                            return !0;
                        }
                        function buildTextContentItem({ chars: e1, extraSpacing: t }) {
                            const a = O.font;
                            if (!e1) {
                                const e1 = O.charSpacing + t;
                                e1 && (a.vertical ? O.translateTextMatrix(0, -e1) : O.translateTextMatrix(e1 * O.textHScale, 0));
                                return;
                            }
                            const r = a.charsToGlyphs(e1), n = O.fontMatrix[0] * O.fontSize;
                            for(let e1 = 0, i = r.length; e1 < i; e1++){
                                const s = r[e1], { category: o } = s;
                                if (o.isInvisibleFormatMark) continue;
                                let c = O.charSpacing + (e1 + 1 === i ? t : 0), l = s.width;
                                a.vertical && (l = s.vmetric ? s.vmetric[0] : -l);
                                let h = l * n;
                                if (o.isWhitespace) {
                                    if (a.vertical) {
                                        c += -h + O.wordSpacing;
                                        O.translateTextMatrix(0, -c);
                                    } else {
                                        c += h + O.wordSpacing;
                                        O.translateTextMatrix(c * O.textHScale, 0);
                                    }
                                    saveLastChar(" ");
                                    continue;
                                }
                                if (!o.isZeroWidthDiacritic && !compareWithLastPosition(h)) {
                                    a.vertical ? O.translateTextMatrix(0, h) : O.translateTextMatrix(h * O.textHScale, 0);
                                    continue;
                                }
                                const u = ensureTextContentItem();
                                o.isZeroWidthDiacritic && (h = 0);
                                if (a.vertical) {
                                    O.translateTextMatrix(0, h);
                                    h = Math.abs(h);
                                    u.height += h;
                                } else {
                                    h *= O.textHScale;
                                    O.translateTextMatrix(h, 0);
                                    u.width += h;
                                }
                                h && (u.prevTransform = getCurrentTextTransform());
                                const d = s.unicode;
                                saveLastChar(d) && u.str.push(" ");
                                u.str.push(d);
                                c && (a.vertical ? O.translateTextMatrix(0, -c) : O.translateTextMatrix(c * O.textHScale, 0));
                            }
                        }
                        function appendEOL() {
                            resetLastChars();
                            if (f.initialized) {
                                f.hasEOL = !0;
                                flushTextContentItem();
                            } else d.items.push({
                                str: "",
                                dir: "ltr",
                                width: 0,
                                height: 0,
                                transform: getCurrentTextTransform(),
                                fontName: O.loadedName,
                                hasEOL: !0
                            });
                        }
                        function addFakeSpaces(e1, t, a) {
                            if (a * f.spaceInFlowMin <= e1 && e1 <= a * f.spaceInFlowMax) {
                                if (f.initialized) {
                                    resetLastChars();
                                    f.str.push(" ");
                                }
                                return !1;
                            }
                            const r = f.fontName;
                            let n = 0;
                            if (f.vertical) {
                                n = e1;
                                e1 = 0;
                            }
                            flushTextContentItem();
                            resetLastChars();
                            pushWhitespace({
                                width: Math.abs(e1),
                                height: Math.abs(n),
                                transform: t || getCurrentTextTransform(),
                                fontName: r
                            });
                            return !0;
                        }
                        function flushTextContentItem() {
                            if (f.initialized && f.str) {
                                f.vertical ? f.totalHeight += f.height * f.textAdvanceScale : f.totalWidth += f.width * f.textAdvanceScale;
                                d.items.push(function runBidiTransform(e1) {
                                    let t = e1.str.join("");
                                    u || (t = (0, r.normalizeUnicode)(t));
                                    const a = (0, b.bidi)(t, -1, e1.vertical);
                                    return {
                                        str: a.str,
                                        dir: a.dir,
                                        width: Math.abs(e1.totalWidth),
                                        height: Math.abs(e1.totalHeight),
                                        transform: e1.transform,
                                        fontName: e1.fontName,
                                        hasEOL: e1.hasEOL
                                    };
                                }(f));
                                f.initialized = !1;
                                f.str.length = 0;
                            }
                        }
                        function enqueueChunk(e1 = !1) {
                            const t = d.items.length;
                            if (0 !== t && !(e1 && t < 10)) {
                                o.enqueue(d, t);
                                d.items = [];
                                d.styles = Object.create(null);
                            }
                        }
                        const T = new TimeSlotManager;
                        return new Promise(function promiseBody(e1, f) {
                            const next = function(t) {
                                enqueueChunk(!0);
                                Promise.all([
                                    t,
                                    o.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(e1, f);
                                    } catch (e1) {
                                        f(e1);
                                    }
                                }, f);
                            };
                            t.ensureNotTerminated();
                            T.reset();
                            const g = {};
                            let p, b = [];
                            for(; !(p = T.check());){
                                b.length = 0;
                                g.args = b;
                                if (!F.read(g)) break;
                                const e1 = O;
                                O = n.state;
                                const f = g.fn;
                                b = g.args;
                                switch(0 | f){
                                    case r.OPS.setFont:
                                        var y = b[0].name, M = b[1];
                                        if (O.font && y === O.fontName && M === O.fontSize) break;
                                        flushTextContentItem();
                                        O.fontName = y;
                                        O.fontSize = M;
                                        next(handleSetFont(y, null));
                                        return;
                                    case r.OPS.setTextRise:
                                        O.textRise = b[0];
                                        break;
                                    case r.OPS.setHScale:
                                        O.textHScale = b[0] / 100;
                                        break;
                                    case r.OPS.setLeading:
                                        O.leading = b[0];
                                        break;
                                    case r.OPS.moveText:
                                        O.translateTextLineMatrix(b[0], b[1]);
                                        O.textMatrix = O.textLineMatrix.slice();
                                        break;
                                    case r.OPS.setLeadingMoveText:
                                        O.leading = -b[1];
                                        O.translateTextLineMatrix(b[0], b[1]);
                                        O.textMatrix = O.textLineMatrix.slice();
                                        break;
                                    case r.OPS.nextLine:
                                        O.carriageReturn();
                                        break;
                                    case r.OPS.setTextMatrix:
                                        O.setTextMatrix(b[0], b[1], b[2], b[3], b[4], b[5]);
                                        O.setTextLineMatrix(b[0], b[1], b[2], b[3], b[4], b[5]);
                                        updateAdvanceScale();
                                        break;
                                    case r.OPS.setCharSpacing:
                                        O.charSpacing = b[0];
                                        break;
                                    case r.OPS.setWordSpacing:
                                        O.wordSpacing = b[0];
                                        break;
                                    case r.OPS.beginText:
                                        O.textMatrix = r.IDENTITY_MATRIX.slice();
                                        O.textLineMatrix = r.IDENTITY_MATRIX.slice();
                                        break;
                                    case r.OPS.showSpacedText:
                                        if (!n.state.font) {
                                            w.ensureStateFont(n.state);
                                            continue;
                                        }
                                        const f1 = (O.font.vertical ? 1 : -1) * O.fontSize / 1e3, g1 = b[0];
                                        for(let e1 = 0, t = g1.length; e1 < t; e1++){
                                            const t = g1[e1];
                                            if ("string" == typeof t) x.push(t);
                                            else if ("number" == typeof t && 0 !== t) {
                                                const e1 = x.join("");
                                                x.length = 0;
                                                buildTextContentItem({
                                                    chars: e1,
                                                    extraSpacing: t * f1
                                                });
                                            }
                                        }
                                        if (x.length > 0) {
                                            const e1 = x.join("");
                                            x.length = 0;
                                            buildTextContentItem({
                                                chars: e1,
                                                extraSpacing: 0
                                            });
                                        }
                                        break;
                                    case r.OPS.showText:
                                        if (!n.state.font) {
                                            w.ensureStateFont(n.state);
                                            continue;
                                        }
                                        buildTextContentItem({
                                            chars: b[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case r.OPS.nextLineShowText:
                                        if (!n.state.font) {
                                            w.ensureStateFont(n.state);
                                            continue;
                                        }
                                        O.carriageReturn();
                                        buildTextContentItem({
                                            chars: b[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case r.OPS.nextLineSetSpacingShowText:
                                        if (!n.state.font) {
                                            w.ensureStateFont(n.state);
                                            continue;
                                        }
                                        O.wordSpacing = b[0];
                                        O.charSpacing = b[1];
                                        O.carriageReturn();
                                        buildTextContentItem({
                                            chars: b[2],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case r.OPS.paintXObject:
                                        flushTextContentItem();
                                        C || (C = a.get("XObject") || i.Dict.empty);
                                        var D = b[0] instanceof i.Name, E = b[0].name;
                                        if (D && k.getByName(E)) break;
                                        next(new Promise(function(e1, d) {
                                            if (!D) throw new r.FormatError("XObject must be referred to by name.");
                                            let f = C.getRaw(E);
                                            if (f instanceof i.Ref) {
                                                if (k.getByRef(f)) {
                                                    e1();
                                                    return;
                                                }
                                                if (w.globalImageCache.getData(f, w.pageIndex)) {
                                                    e1();
                                                    return;
                                                }
                                                f = S.fetch(f);
                                            }
                                            if (!(f instanceof m.BaseStream)) throw new r.FormatError("XObject should be a stream");
                                            const g = f.dict.get("Subtype");
                                            if (!(g instanceof i.Name)) throw new r.FormatError("XObject should have a Name subtype");
                                            if ("Form" !== g.name) {
                                                k.set(E, f.dict.objId, !0);
                                                e1();
                                                return;
                                            }
                                            const p = n.state.clone(), b = new StateManager(p), y = f.dict.getArray("Matrix");
                                            Array.isArray(y) && 6 === y.length && b.transform(y);
                                            enqueueChunk();
                                            const x = {
                                                enqueueInvoked: !1,
                                                enqueue (e1, t) {
                                                    this.enqueueInvoked = !0;
                                                    o.enqueue(e1, t);
                                                },
                                                get desiredSize () {
                                                    return o.desiredSize;
                                                },
                                                get ready () {
                                                    return o.ready;
                                                }
                                            };
                                            w.getTextContent({
                                                stream: f,
                                                task: t,
                                                resources: f.dict.get("Resources") || a,
                                                stateManager: b,
                                                includeMarkedContent: s,
                                                sink: x,
                                                seenStyles: c,
                                                viewBox: l,
                                                markedContentData: h,
                                                disableNormalization: u
                                            }).then(function() {
                                                x.enqueueInvoked || k.set(E, f.dict.objId, !0);
                                                e1();
                                            }, d);
                                        }).catch(function(e1) {
                                            if (!(e1 instanceof r.AbortException)) {
                                                if (!w.options.ignoreErrors) throw e1;
                                                (0, r.warn)(`getTextContent - ignoring XObject: "${e1}".`);
                                            }
                                        }));
                                        return;
                                    case r.OPS.setGState:
                                        D = b[0] instanceof i.Name;
                                        E = b[0].name;
                                        if (D && v.getByName(E)) break;
                                        next(new Promise(function(e1, t) {
                                            if (!D) throw new r.FormatError("GState must be referred to by name.");
                                            const n = a.get("ExtGState");
                                            if (!(n instanceof i.Dict)) throw new r.FormatError("ExtGState should be a dictionary.");
                                            const s = n.get(E);
                                            if (!(s instanceof i.Dict)) throw new r.FormatError("GState should be a dictionary.");
                                            const o = s.get("Font");
                                            if (o) {
                                                flushTextContentItem();
                                                O.fontName = null;
                                                O.fontSize = o[1];
                                                handleSetFont(null, o[0]).then(e1, t);
                                            } else {
                                                v.set(E, s.objId, !0);
                                                e1();
                                            }
                                        }).catch(function(e1) {
                                            if (!(e1 instanceof r.AbortException)) {
                                                if (!w.options.ignoreErrors) throw e1;
                                                (0, r.warn)(`getTextContent - ignoring ExtGState: "${e1}".`);
                                            }
                                        }));
                                        return;
                                    case r.OPS.beginMarkedContent:
                                        flushTextContentItem();
                                        if (s) {
                                            h.level++;
                                            d.items.push({
                                                type: "beginMarkedContent",
                                                tag: b[0] instanceof i.Name ? b[0].name : null
                                            });
                                        }
                                        break;
                                    case r.OPS.beginMarkedContentProps:
                                        flushTextContentItem();
                                        if (s) {
                                            h.level++;
                                            let e1 = null;
                                            b[1] instanceof i.Dict && (e1 = b[1].get("MCID"));
                                            d.items.push({
                                                type: "beginMarkedContentProps",
                                                id: Number.isInteger(e1) ? `${w.idFactory.getPageObjId()}_mc${e1}` : null,
                                                tag: b[0] instanceof i.Name ? b[0].name : null
                                            });
                                        }
                                        break;
                                    case r.OPS.endMarkedContent:
                                        flushTextContentItem();
                                        if (s) {
                                            if (0 === h.level) break;
                                            h.level--;
                                            d.items.push({
                                                type: "endMarkedContent"
                                            });
                                        }
                                        break;
                                    case r.OPS.restore:
                                        !e1 || e1.font === O.font && e1.fontSize === O.fontSize && e1.fontName === O.fontName || flushTextContentItem();
                                }
                                if (d.items.length >= o.desiredSize) {
                                    p = !0;
                                    break;
                                }
                            }
                            if (p) next(R);
                            else {
                                flushTextContentItem();
                                enqueueChunk();
                                e1();
                            }
                        }).catch((e1)=>{
                            if (!(e1 instanceof r.AbortException)) {
                                if (!this.options.ignoreErrors) throw e1;
                                (0, r.warn)(`getTextContent - ignoring errors during "${t.name}" task: "${e1}".`);
                                flushTextContentItem();
                                enqueueChunk();
                            }
                        });
                    }
                    extractDataStructures(e1, t, a) {
                        const n = this.xref;
                        let s;
                        const l = this.readToUnicode(a.toUnicode || e1.get("ToUnicode") || t.get("ToUnicode"));
                        if (a.composite) {
                            const t = e1.get("CIDSystemInfo");
                            t instanceof i.Dict && (a.cidSystemInfo = {
                                registry: (0, r.stringToPDFString)(t.get("Registry")),
                                ordering: (0, r.stringToPDFString)(t.get("Ordering")),
                                supplement: t.get("Supplement")
                            });
                            try {
                                const t = e1.get("CIDToGIDMap");
                                t instanceof m.BaseStream && (s = t.getBytes());
                            } catch (e1) {
                                if (!this.options.ignoreErrors) throw e1;
                                (0, r.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${e1}".`);
                            }
                        }
                        const h = [];
                        let u, d = null;
                        if (e1.has("Encoding")) {
                            u = e1.get("Encoding");
                            if (u instanceof i.Dict) {
                                d = u.get("BaseEncoding");
                                d = d instanceof i.Name ? d.name : null;
                                if (u.has("Differences")) {
                                    const e1 = u.get("Differences");
                                    let t = 0;
                                    for (const a of e1){
                                        const e1 = n.fetchIfRef(a);
                                        if ("number" == typeof e1) t = e1;
                                        else {
                                            if (!(e1 instanceof i.Name)) throw new r.FormatError(`Invalid entry in 'Differences' array: ${e1}`);
                                            h[t++] = e1.name;
                                        }
                                    }
                                }
                            } else if (u instanceof i.Name) d = u.name;
                            else {
                                const e1 = "Encoding is not a Name nor a Dict";
                                if (!this.options.ignoreErrors) throw new r.FormatError(e1);
                                (0, r.warn)(e1);
                            }
                            "MacRomanEncoding" !== d && "MacExpertEncoding" !== d && "WinAnsiEncoding" !== d && (d = null);
                        }
                        const f = !a.file || a.isInternalFont, g = (0, c.getSymbolsFonts)()[a.name];
                        d && f && g && (d = null);
                        if (d) a.defaultEncoding = (0, o.getEncoding)(d);
                        else {
                            const e1 = !!(a.flags & S.FontFlags.Symbolic), t = !!(a.flags & S.FontFlags.Nonsymbolic);
                            u = o.StandardEncoding;
                            "TrueType" !== a.type || t || (u = o.WinAnsiEncoding);
                            if (e1 || g) {
                                u = o.MacRomanEncoding;
                                f && (/Symbol/i.test(a.name) ? u = o.SymbolSetEncoding : /Dingbats/i.test(a.name) ? u = o.ZapfDingbatsEncoding : /Wingdings/i.test(a.name) && (u = o.WinAnsiEncoding));
                            }
                            a.defaultEncoding = u;
                        }
                        a.differences = h;
                        a.baseEncodingName = d;
                        a.hasEncoding = !!d || h.length > 0;
                        a.dict = e1;
                        return l.then((e1)=>{
                            a.toUnicode = e1;
                            return this.buildToUnicode(a);
                        }).then((e1)=>{
                            a.toUnicode = e1;
                            s && (a.cidToGidMap = this.readCidToGidMap(s, e1));
                            return a;
                        });
                    }
                    _simpleFontToUnicode(e1, t = !1) {
                        (0, r.assert)(!e1.composite, "Must be a simple font.");
                        const a = [], n = e1.defaultEncoding.slice(), i = e1.baseEncodingName, s = e1.differences;
                        for(const e1 in s){
                            const t = s[e1];
                            ".notdef" !== t && (n[e1] = t);
                        }
                        const c = (0, C.getGlyphsUnicode)();
                        for(const r in n){
                            let s = n[r];
                            if ("" === s) continue;
                            let l = c[s];
                            if (void 0 !== l) {
                                a[r] = String.fromCharCode(l);
                                continue;
                            }
                            let h = 0;
                            switch(s[0]){
                                case "G":
                                    3 === s.length && (h = parseInt(s.substring(1), 16));
                                    break;
                                case "g":
                                    5 === s.length && (h = parseInt(s.substring(1), 16));
                                    break;
                                case "C":
                                case "c":
                                    if (s.length >= 3 && s.length <= 4) {
                                        const a = s.substring(1);
                                        if (t) {
                                            h = parseInt(a, 16);
                                            break;
                                        }
                                        h = +a;
                                        if (Number.isNaN(h) && Number.isInteger(parseInt(a, 16))) return this._simpleFontToUnicode(e1, !0);
                                    }
                                    break;
                                case "u":
                                    l = (0, v.getUnicodeForGlyph)(s, c);
                                    -1 !== l && (h = l);
                                    break;
                                default:
                                    switch(s){
                                        case "f_h":
                                        case "f_t":
                                        case "T_h":
                                            a[r] = s.replaceAll("_", "");
                                            continue;
                                    }
                            }
                            if (h > 0 && h <= 1114111 && Number.isInteger(h)) {
                                if (i && h === +r) {
                                    const e1 = (0, o.getEncoding)(i);
                                    if (e1 && (s = e1[r])) {
                                        a[r] = String.fromCharCode(c[s]);
                                        continue;
                                    }
                                }
                                a[r] = String.fromCodePoint(h);
                            }
                        }
                        return a;
                    }
                    async buildToUnicode(e1) {
                        e1.hasIncludedToUnicodeMap = e1.toUnicode?.length > 0;
                        if (e1.hasIncludedToUnicodeMap) {
                            !e1.composite && e1.hasEncoding && (e1.fallbackToUnicode = this._simpleFontToUnicode(e1));
                            return e1.toUnicode;
                        }
                        if (!e1.composite) return new u.ToUnicodeMap(this._simpleFontToUnicode(e1));
                        if (e1.composite && (e1.cMap.builtInCMap && !(e1.cMap instanceof n.IdentityCMap) || "Adobe" === e1.cidSystemInfo.registry && ("GB1" === e1.cidSystemInfo.ordering || "CNS1" === e1.cidSystemInfo.ordering || "Japan1" === e1.cidSystemInfo.ordering || "Korea1" === e1.cidSystemInfo.ordering))) {
                            const { registry: t, ordering: a } = e1.cidSystemInfo, s = i.Name.get(`${t}-${a}-UCS2`), o = await n.CMapFactory.create({
                                encoding: s,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            }), c = [], l = [];
                            e1.cMap.forEach(function(e1, t) {
                                if (t > 65535) throw new r.FormatError("Max size of CID is 65,535");
                                const a = o.lookup(t);
                                if (a) {
                                    l.length = 0;
                                    for(let e1 = 0, t = a.length; e1 < t; e1 += 2)l.push((a.charCodeAt(e1) << 8) + a.charCodeAt(e1 + 1));
                                    c[e1] = String.fromCharCode(...l);
                                }
                            });
                            return new u.ToUnicodeMap(c);
                        }
                        return new u.IdentityToUnicodeMap(e1.firstChar, e1.lastChar);
                    }
                    readToUnicode(e1) {
                        return e1 ? e1 instanceof i.Name ? n.CMapFactory.create({
                            encoding: e1,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(e1) {
                            return e1 instanceof n.IdentityCMap ? new u.IdentityToUnicodeMap(0, 65535) : new u.ToUnicodeMap(e1.getMap());
                        }) : e1 instanceof m.BaseStream ? n.CMapFactory.create({
                            encoding: e1,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(e1) {
                            if (e1 instanceof n.IdentityCMap) return new u.IdentityToUnicodeMap(0, 65535);
                            const t = new Array(e1.length);
                            e1.forEach(function(e1, a) {
                                if ("number" == typeof a) {
                                    t[e1] = String.fromCodePoint(a);
                                    return;
                                }
                                const r = [];
                                for(let e1 = 0; e1 < a.length; e1 += 2){
                                    const t = a.charCodeAt(e1) << 8 | a.charCodeAt(e1 + 1);
                                    if (55296 != (63488 & t)) {
                                        r.push(t);
                                        continue;
                                    }
                                    e1 += 2;
                                    const n = a.charCodeAt(e1) << 8 | a.charCodeAt(e1 + 1);
                                    r.push(((1023 & t) << 10) + (1023 & n) + 65536);
                                }
                                t[e1] = String.fromCodePoint(...r);
                            });
                            return new u.ToUnicodeMap(t);
                        }, (e1)=>{
                            if (e1 instanceof r.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, r.warn)(`readToUnicode - ignoring ToUnicode data: "${e1}".`);
                                return null;
                            }
                            throw e1;
                        }) : Promise.resolve(null) : Promise.resolve(null);
                    }
                    readCidToGidMap(e1, t) {
                        const a = [];
                        for(let r = 0, n = e1.length; r < n; r++){
                            const n = e1[r++] << 8 | e1[r], i = r >> 1;
                            (0 !== n || t.has(i)) && (a[i] = n);
                        }
                        return a;
                    }
                    extractWidths(e1, t, a) {
                        const r = this.xref;
                        let n = [], s = 0;
                        const o = [];
                        let c, l, h, u, d, f, g, p;
                        if (a.composite) {
                            s = e1.has("DW") ? e1.get("DW") : 1e3;
                            p = e1.get("W");
                            if (p) for(l = 0, h = p.length; l < h; l++){
                                f = r.fetchIfRef(p[l++]);
                                g = r.fetchIfRef(p[l]);
                                if (Array.isArray(g)) for(u = 0, d = g.length; u < d; u++)n[f++] = r.fetchIfRef(g[u]);
                                else {
                                    const e1 = r.fetchIfRef(p[++l]);
                                    for(u = f; u <= g; u++)n[u] = e1;
                                }
                            }
                            if (a.vertical) {
                                let t = e1.getArray("DW2") || [
                                    880,
                                    -1000
                                ];
                                c = [
                                    t[1],
                                    .5 * s,
                                    t[0]
                                ];
                                t = e1.get("W2");
                                if (t) for(l = 0, h = t.length; l < h; l++){
                                    f = r.fetchIfRef(t[l++]);
                                    g = r.fetchIfRef(t[l]);
                                    if (Array.isArray(g)) for(u = 0, d = g.length; u < d; u++)o[f++] = [
                                        r.fetchIfRef(g[u++]),
                                        r.fetchIfRef(g[u++]),
                                        r.fetchIfRef(g[u])
                                    ];
                                    else {
                                        const e1 = [
                                            r.fetchIfRef(t[++l]),
                                            r.fetchIfRef(t[++l]),
                                            r.fetchIfRef(t[++l])
                                        ];
                                        for(u = f; u <= g; u++)o[u] = e1;
                                    }
                                }
                            }
                        } else {
                            const o = a.firstChar;
                            p = e1.get("Widths");
                            if (p) {
                                u = o;
                                for(l = 0, h = p.length; l < h; l++)n[u++] = r.fetchIfRef(p[l]);
                                s = parseFloat(t.get("MissingWidth")) || 0;
                            } else {
                                const t = e1.get("BaseFont");
                                if (t instanceof i.Name) {
                                    const e1 = this.getBaseFontMetrics(t.name);
                                    n = this.buildCharCodeToWidth(e1.widths, a);
                                    s = e1.defaultWidth;
                                }
                            }
                        }
                        let m = !0, b = s;
                        for(const e1 in n){
                            const t = n[e1];
                            if (t) {
                                if (b) {
                                    if (b !== t) {
                                        m = !1;
                                        break;
                                    }
                                } else b = t;
                            }
                        }
                        m ? a.flags |= S.FontFlags.FixedPitch : a.flags &= ~S.FontFlags.FixedPitch;
                        a.defaultWidth = s;
                        a.widths = n;
                        a.defaultVMetrics = c;
                        a.vmetrics = o;
                    }
                    isSerifFont(e1) {
                        const t = e1.split("-")[0];
                        return t in (0, c.getSerifFonts)() || /serif/gi.test(t);
                    }
                    getBaseFontMetrics(e1) {
                        let t = 0, a = Object.create(null), r = !1;
                        let n = (0, c.getStdFontMap)()[e1] || e1;
                        const i = (0, k.getMetrics)();
                        n in i || (n = this.isSerifFont(e1) ? "Times-Roman" : "Helvetica");
                        const s = i[n];
                        if ("number" == typeof s) {
                            t = s;
                            r = !0;
                        } else a = s();
                        return {
                            defaultWidth: t,
                            monospace: r,
                            widths: a
                        };
                    }
                    buildCharCodeToWidth(e1, t) {
                        const a = Object.create(null), r = t.differences, n = t.defaultEncoding;
                        for(let t = 0; t < 256; t++)t in r && e1[r[t]] ? a[t] = e1[r[t]] : t in n && e1[n[t]] && (a[t] = e1[n[t]]);
                        return a;
                    }
                    preEvaluateFont(e1) {
                        const t = e1;
                        let a = e1.get("Subtype");
                        if (!(a instanceof i.Name)) throw new r.FormatError("invalid font Subtype");
                        let n, s, o = !1;
                        if ("Type0" === a.name) {
                            const t = e1.get("DescendantFonts");
                            if (!t) throw new r.FormatError("Descendant fonts are not specified");
                            if (!((e1 = Array.isArray(t) ? this.xref.fetchIfRef(t[0]) : t) instanceof i.Dict)) throw new r.FormatError("Descendant font is not a dictionary.");
                            a = e1.get("Subtype");
                            if (!(a instanceof i.Name)) throw new r.FormatError("invalid font Subtype");
                            o = !0;
                        }
                        const c = e1.get("FirstChar") || 0, l = e1.get("LastChar") || (o ? 65535 : 255), h = e1.get("FontDescriptor");
                        if (h) {
                            n = new O.MurmurHash3_64;
                            const a = t.getRaw("Encoding");
                            if (a instanceof i.Name) n.update(a.name);
                            else if (a instanceof i.Ref) n.update(a.toString());
                            else if (a instanceof i.Dict) {
                                for (const e1 of a.getRawValues())if (e1 instanceof i.Name) n.update(e1.name);
                                else if (e1 instanceof i.Ref) n.update(e1.toString());
                                else if (Array.isArray(e1)) {
                                    const t = e1.length, a = new Array(t);
                                    for(let r = 0; r < t; r++){
                                        const t = e1[r];
                                        t instanceof i.Name ? a[r] = t.name : ("number" == typeof t || t instanceof i.Ref) && (a[r] = t.toString());
                                    }
                                    n.update(a.join());
                                }
                            }
                            n.update(`${c}-${l}`);
                            s = e1.get("ToUnicode") || t.get("ToUnicode");
                            if (s instanceof m.BaseStream) {
                                const e1 = s.str || s, t = e1.buffer ? new Uint8Array(e1.buffer.buffer, 0, e1.bufferLength) : new Uint8Array(e1.bytes.buffer, e1.start, e1.end - e1.start);
                                n.update(t);
                            } else s instanceof i.Name && n.update(s.name);
                            const r = e1.get("Widths") || t.get("Widths");
                            if (Array.isArray(r)) {
                                const e1 = [];
                                for (const t of r)("number" == typeof t || t instanceof i.Ref) && e1.push(t.toString());
                                n.update(e1.join());
                            }
                            if (o) {
                                n.update("compositeFont");
                                const a = e1.get("W") || t.get("W");
                                if (Array.isArray(a)) {
                                    const e1 = [];
                                    for (const t of a)if ("number" == typeof t || t instanceof i.Ref) e1.push(t.toString());
                                    else if (Array.isArray(t)) {
                                        const a = [];
                                        for (const e1 of t)("number" == typeof e1 || e1 instanceof i.Ref) && a.push(e1.toString());
                                        e1.push(`[${a.join()}]`);
                                    }
                                    n.update(e1.join());
                                }
                                const r = e1.getRaw("CIDToGIDMap") || t.getRaw("CIDToGIDMap");
                                r instanceof i.Name ? n.update(r.name) : r instanceof i.Ref ? n.update(r.toString()) : r instanceof m.BaseStream && n.update(r.peekBytes());
                            }
                        }
                        return {
                            descriptor: h,
                            dict: e1,
                            baseDict: t,
                            composite: o,
                            type: a.name,
                            firstChar: c,
                            lastChar: l,
                            toUnicode: s,
                            hash: n ? n.hexdigest() : ""
                        };
                    }
                    async translateFont({ descriptor: e1, dict: t, baseDict: a, composite: o, type: l, firstChar: u, lastChar: d, toUnicode: f, cssFontInfo: g }) {
                        const m = "Type3" === l;
                        let b;
                        if (!e1) {
                            if (!m) {
                                let e1 = t.get("BaseFont");
                                if (!(e1 instanceof i.Name)) throw new r.FormatError("Base font is not specified");
                                e1 = e1.name.replaceAll(/[,_]/g, "-");
                                const n = this.getBaseFontMetrics(e1), o = e1.split("-")[0], h = (this.isSerifFont(o) ? S.FontFlags.Serif : 0) | (n.monospace ? S.FontFlags.FixedPitch : 0) | ((0, c.getSymbolsFonts)()[o] ? S.FontFlags.Symbolic : S.FontFlags.Nonsymbolic);
                                b = {
                                    type: l,
                                    name: e1,
                                    loadedName: a.loadedName,
                                    systemFontInfo: null,
                                    widths: n.widths,
                                    defaultWidth: n.defaultWidth,
                                    isSimulatedFlags: !0,
                                    flags: h,
                                    firstChar: u,
                                    lastChar: d,
                                    toUnicode: f,
                                    xHeight: 0,
                                    capHeight: 0,
                                    italicAngle: 0,
                                    isType3Font: m
                                };
                                const g = t.get("Widths"), p = (0, c.getStandardFontName)(e1);
                                let y = null;
                                if (p) {
                                    y = await this.fetchStandardFontData(p);
                                    b.isInternalFont = !!y;
                                }
                                !b.isInternalFont && this.options.useSystemFonts && (b.systemFontInfo = (0, x.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, e1, p));
                                return this.extractDataStructures(t, t, b).then((t)=>{
                                    if (g) {
                                        const e1 = [];
                                        let a = u;
                                        for (const t of g)e1[a++] = this.xref.fetchIfRef(t);
                                        t.widths = e1;
                                    } else t.widths = this.buildCharCodeToWidth(n.widths, t);
                                    return new s.Font(e1, y, t);
                                });
                            }
                            (e1 = new i.Dict(null)).set("FontName", i.Name.get(l));
                            e1.set("FontBBox", t.getArray("FontBBox") || [
                                0,
                                0,
                                0,
                                0
                            ]);
                        }
                        let y = e1.get("FontName"), w = t.get("BaseFont");
                        "string" == typeof y && (y = i.Name.get(y));
                        "string" == typeof w && (w = i.Name.get(w));
                        const C = y?.name, k = w?.name;
                        if (!m && C !== k) {
                            (0, r.info)(`The FontDescriptor's FontName is "${C}" but should be the same as the Font's BaseFont "${k}".`);
                            C && k && (k.startsWith(C) || !(0, c.isKnownFontName)(C) && (0, c.isKnownFontName)(k)) && (y = null);
                        }
                        y ||= w;
                        if (!(y instanceof i.Name)) throw new r.FormatError("invalid font name");
                        let v, F, O, T, M;
                        try {
                            v = e1.get("FontFile", "FontFile2", "FontFile3");
                        } catch (e1) {
                            if (!this.options.ignoreErrors) throw e1;
                            (0, r.warn)(`translateFont - fetching "${y.name}" font file: "${e1}".`);
                            v = new p.NullStream;
                        }
                        let D = !1, E = null, N = null;
                        if (v) {
                            if (v.dict) {
                                const e1 = v.dict.get("Subtype");
                                e1 instanceof i.Name && (F = e1.name);
                                O = v.dict.get("Length1");
                                T = v.dict.get("Length2");
                                M = v.dict.get("Length3");
                            }
                        } else if (g) {
                            const e1 = (0, h.getXfaFontName)(y.name);
                            if (e1) {
                                g.fontFamily = `${g.fontFamily}-PdfJS-XFA`;
                                g.metrics = e1.metrics || null;
                                E = e1.factors || null;
                                v = await this.fetchStandardFontData(e1.name);
                                D = !!v;
                                a = t = (0, h.getXfaFontDict)(y.name);
                                o = !0;
                            }
                        } else if (!m) {
                            const e1 = (0, c.getStandardFontName)(y.name);
                            if (e1) {
                                v = await this.fetchStandardFontData(e1);
                                D = !!v;
                            }
                            !D && this.options.useSystemFonts && (N = (0, x.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, y.name, e1));
                        }
                        b = {
                            type: l,
                            name: y.name,
                            subtype: F,
                            file: v,
                            length1: O,
                            length2: T,
                            length3: M,
                            isInternalFont: D,
                            loadedName: a.loadedName,
                            composite: o,
                            fixedPitch: !1,
                            fontMatrix: t.getArray("FontMatrix") || r.FONT_IDENTITY_MATRIX,
                            firstChar: u,
                            lastChar: d,
                            toUnicode: f,
                            bbox: e1.getArray("FontBBox") || t.getArray("FontBBox"),
                            ascent: e1.get("Ascent"),
                            descent: e1.get("Descent"),
                            xHeight: e1.get("XHeight") || 0,
                            capHeight: e1.get("CapHeight") || 0,
                            flags: e1.get("Flags"),
                            italicAngle: e1.get("ItalicAngle") || 0,
                            isType3Font: m,
                            cssFontInfo: g,
                            scaleFactors: E,
                            systemFontInfo: N
                        };
                        if (o) {
                            const e1 = a.get("Encoding");
                            e1 instanceof i.Name && (b.cidEncoding = e1.name);
                            const t = await n.CMapFactory.create({
                                encoding: e1,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            b.cMap = t;
                            b.vertical = b.cMap.vertical;
                        }
                        return this.extractDataStructures(t, a, b).then((a)=>{
                            this.extractWidths(t, e1, a);
                            return new s.Font(y.name, v, a);
                        });
                    }
                    static buildFontPaths(e1, t, a, n) {
                        function buildPath(t) {
                            const i = `${e1.loadedName}_path_${t}`;
                            try {
                                if (e1.renderer.hasBuiltPath(t)) return;
                                a.send("commonobj", [
                                    i,
                                    "FontPath",
                                    e1.renderer.getPathJs(t)
                                ]);
                            } catch (e1) {
                                if (n.ignoreErrors) {
                                    (0, r.warn)(`buildFontPaths - ignoring ${i} glyph: "${e1}".`);
                                    return;
                                }
                                throw e1;
                            }
                        }
                        for (const e1 of t){
                            buildPath(e1.fontChar);
                            const t = e1.accent;
                            t?.fontChar && buildPath(t.fontChar);
                        }
                    }
                    static get fallbackFontDict() {
                        const e1 = new i.Dict;
                        e1.set("BaseFont", i.Name.get("Helvetica"));
                        e1.set("Type", i.Name.get("FallbackType"));
                        e1.set("Subtype", i.Name.get("FallbackType"));
                        e1.set("Encoding", i.Name.get("WinAnsiEncoding"));
                        return (0, r.shadow)(this, "fallbackFontDict", e1);
                    }
                }
                t.PartialEvaluator = PartialEvaluator;
                class TranslatedFont {
                    constructor({ loadedName: e1, font: t, dict: a, evaluatorOptions: r }){
                        this.loadedName = e1;
                        this.font = t;
                        this.dict = a;
                        this._evaluatorOptions = r || D;
                        this.type3Loaded = null;
                        this.type3Dependencies = t.isType3Font ? new Set : null;
                        this.sent = !1;
                    }
                    send(e1) {
                        if (!this.sent) {
                            this.sent = !0;
                            e1.send("commonobj", [
                                this.loadedName,
                                "Font",
                                this.font.exportData(this._evaluatorOptions.fontExtraProperties)
                            ]);
                        }
                    }
                    fallback(e1) {
                        if (this.font.data) {
                            this.font.disableFontFace = !0;
                            PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, e1, this._evaluatorOptions);
                        }
                    }
                    loadType3Data(e1, t, a) {
                        if (this.type3Loaded) return this.type3Loaded;
                        if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
                        const n = e1.clone({
                            ignoreErrors: !1
                        });
                        n.parsingType3Font = !0;
                        const s = new i.RefSet(e1.type3FontRefs);
                        this.dict.objId && !s.has(this.dict.objId) && s.put(this.dict.objId);
                        n.type3FontRefs = s;
                        const o = this.font, c = this.type3Dependencies;
                        let l = Promise.resolve();
                        const h = this.dict.get("CharProcs"), u = this.dict.get("Resources") || t, d = Object.create(null), f = r.Util.normalizeRect(o.bbox || [
                            0,
                            0,
                            0,
                            0
                        ]), g = f[2] - f[0], p = f[3] - f[1], m = Math.hypot(g, p);
                        for (const e1 of h.getKeys())l = l.then(()=>{
                            const t = h.get(e1), i = new T.OperatorList;
                            return n.getOperatorList({
                                stream: t,
                                task: a,
                                resources: u,
                                operatorList: i
                            }).then(()=>{
                                i.fnArray[0] === r.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(i, m);
                                d[e1] = i.getIR();
                                for (const e1 of i.dependencies)c.add(e1);
                            }).catch(function(t) {
                                (0, r.warn)(`Type3 font resource "${e1}" is not available.`);
                                const a = new T.OperatorList;
                                d[e1] = a.getIR();
                            });
                        });
                        this.type3Loaded = l.then(()=>{
                            o.charProcOperatorList = d;
                            if (this._bbox) {
                                o.isCharBBox = !0;
                                o.bbox = this._bbox;
                            }
                        });
                        return this.type3Loaded;
                    }
                    _removeType3ColorOperators(e1, t = NaN) {
                        const a = r.Util.normalizeRect(e1.argsArray[0].slice(2)), n = a[2] - a[0], i = a[3] - a[1], s = Math.hypot(n, i);
                        if (0 === n || 0 === i) {
                            e1.fnArray.splice(0, 1);
                            e1.argsArray.splice(0, 1);
                        } else if (0 === t || Math.round(s / t) >= 10) {
                            this._bbox || (this._bbox = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ]);
                            this._bbox[0] = Math.min(this._bbox[0], a[0]);
                            this._bbox[1] = Math.min(this._bbox[1], a[1]);
                            this._bbox[2] = Math.max(this._bbox[2], a[2]);
                            this._bbox[3] = Math.max(this._bbox[3], a[3]);
                        }
                        let o = 0, c = e1.length;
                        for(; o < c;){
                            switch(e1.fnArray[o]){
                                case r.OPS.setCharWidthAndBounds:
                                    break;
                                case r.OPS.setStrokeColorSpace:
                                case r.OPS.setFillColorSpace:
                                case r.OPS.setStrokeColor:
                                case r.OPS.setStrokeColorN:
                                case r.OPS.setFillColor:
                                case r.OPS.setFillColorN:
                                case r.OPS.setStrokeGray:
                                case r.OPS.setFillGray:
                                case r.OPS.setStrokeRGBColor:
                                case r.OPS.setFillRGBColor:
                                case r.OPS.setStrokeCMYKColor:
                                case r.OPS.setFillCMYKColor:
                                case r.OPS.shadingFill:
                                case r.OPS.setRenderingIntent:
                                    e1.fnArray.splice(o, 1);
                                    e1.argsArray.splice(o, 1);
                                    c--;
                                    continue;
                                case r.OPS.setGState:
                                    const [t] = e1.argsArray[o];
                                    let a = 0, n = t.length;
                                    for(; a < n;){
                                        const [e1] = t[a];
                                        switch(e1){
                                            case "TR":
                                            case "TR2":
                                            case "HT":
                                            case "BG":
                                            case "BG2":
                                            case "UCR":
                                            case "UCR2":
                                                t.splice(a, 1);
                                                n--;
                                                continue;
                                        }
                                        a++;
                                    }
                            }
                            o++;
                        }
                    }
                }
                class StateManager {
                    constructor(e1 = new EvalState){
                        this.state = e1;
                        this.stateStack = [];
                    }
                    save() {
                        const e1 = this.state;
                        this.stateStack.push(this.state);
                        this.state = e1.clone();
                    }
                    restore() {
                        const e1 = this.stateStack.pop();
                        e1 && (this.state = e1);
                    }
                    transform(e1) {
                        this.state.ctm = r.Util.transform(this.state.ctm, e1);
                    }
                }
                class TextState {
                    constructor(){
                        this.ctm = new Float32Array(r.IDENTITY_MATRIX);
                        this.fontName = null;
                        this.fontSize = 0;
                        this.loadedName = null;
                        this.font = null;
                        this.fontMatrix = r.FONT_IDENTITY_MATRIX;
                        this.textMatrix = r.IDENTITY_MATRIX.slice();
                        this.textLineMatrix = r.IDENTITY_MATRIX.slice();
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.leading = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                    }
                    setTextMatrix(e1, t, a, r, n, i) {
                        const s = this.textMatrix;
                        s[0] = e1;
                        s[1] = t;
                        s[2] = a;
                        s[3] = r;
                        s[4] = n;
                        s[5] = i;
                    }
                    setTextLineMatrix(e1, t, a, r, n, i) {
                        const s = this.textLineMatrix;
                        s[0] = e1;
                        s[1] = t;
                        s[2] = a;
                        s[3] = r;
                        s[4] = n;
                        s[5] = i;
                    }
                    translateTextMatrix(e1, t) {
                        const a = this.textMatrix;
                        a[4] = a[0] * e1 + a[2] * t + a[4];
                        a[5] = a[1] * e1 + a[3] * t + a[5];
                    }
                    translateTextLineMatrix(e1, t) {
                        const a = this.textLineMatrix;
                        a[4] = a[0] * e1 + a[2] * t + a[4];
                        a[5] = a[1] * e1 + a[3] * t + a[5];
                    }
                    carriageReturn() {
                        this.translateTextLineMatrix(0, -this.leading);
                        this.textMatrix = this.textLineMatrix.slice();
                    }
                    clone() {
                        const e1 = Object.create(this);
                        e1.textMatrix = this.textMatrix.slice();
                        e1.textLineMatrix = this.textLineMatrix.slice();
                        e1.fontMatrix = this.fontMatrix.slice();
                        return e1;
                    }
                }
                class EvalState {
                    constructor(){
                        this.ctm = new Float32Array(r.IDENTITY_MATRIX);
                        this.font = null;
                        this.textRenderingMode = r.TextRenderingMode.FILL;
                        this.fillColorSpace = y.ColorSpace.singletons.gray;
                        this.strokeColorSpace = y.ColorSpace.singletons.gray;
                    }
                    clone() {
                        return Object.create(this);
                    }
                }
                class EvaluatorPreprocessor {
                    static get opMap() {
                        return (0, r.shadow)(this, "opMap", {
                            w: {
                                id: r.OPS.setLineWidth,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            J: {
                                id: r.OPS.setLineCap,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            j: {
                                id: r.OPS.setLineJoin,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            M: {
                                id: r.OPS.setMiterLimit,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            d: {
                                id: r.OPS.setDash,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            ri: {
                                id: r.OPS.setRenderingIntent,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            i: {
                                id: r.OPS.setFlatness,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            gs: {
                                id: r.OPS.setGState,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            q: {
                                id: r.OPS.save,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            Q: {
                                id: r.OPS.restore,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            cm: {
                                id: r.OPS.transform,
                                numArgs: 6,
                                variableArgs: !1
                            },
                            m: {
                                id: r.OPS.moveTo,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            l: {
                                id: r.OPS.lineTo,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            c: {
                                id: r.OPS.curveTo,
                                numArgs: 6,
                                variableArgs: !1
                            },
                            v: {
                                id: r.OPS.curveTo2,
                                numArgs: 4,
                                variableArgs: !1
                            },
                            y: {
                                id: r.OPS.curveTo3,
                                numArgs: 4,
                                variableArgs: !1
                            },
                            h: {
                                id: r.OPS.closePath,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            re: {
                                id: r.OPS.rectangle,
                                numArgs: 4,
                                variableArgs: !1
                            },
                            S: {
                                id: r.OPS.stroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            s: {
                                id: r.OPS.closeStroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            f: {
                                id: r.OPS.fill,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            F: {
                                id: r.OPS.fill,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            "f*": {
                                id: r.OPS.eoFill,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            B: {
                                id: r.OPS.fillStroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            "B*": {
                                id: r.OPS.eoFillStroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            b: {
                                id: r.OPS.closeFillStroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            "b*": {
                                id: r.OPS.closeEOFillStroke,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            n: {
                                id: r.OPS.endPath,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            W: {
                                id: r.OPS.clip,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            "W*": {
                                id: r.OPS.eoClip,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            BT: {
                                id: r.OPS.beginText,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            ET: {
                                id: r.OPS.endText,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            Tc: {
                                id: r.OPS.setCharSpacing,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Tw: {
                                id: r.OPS.setWordSpacing,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Tz: {
                                id: r.OPS.setHScale,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            TL: {
                                id: r.OPS.setLeading,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Tf: {
                                id: r.OPS.setFont,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            Tr: {
                                id: r.OPS.setTextRenderingMode,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Ts: {
                                id: r.OPS.setTextRise,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Td: {
                                id: r.OPS.moveText,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            TD: {
                                id: r.OPS.setLeadingMoveText,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            Tm: {
                                id: r.OPS.setTextMatrix,
                                numArgs: 6,
                                variableArgs: !1
                            },
                            "T*": {
                                id: r.OPS.nextLine,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            Tj: {
                                id: r.OPS.showText,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            TJ: {
                                id: r.OPS.showSpacedText,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            "'": {
                                id: r.OPS.nextLineShowText,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            '"': {
                                id: r.OPS.nextLineSetSpacingShowText,
                                numArgs: 3,
                                variableArgs: !1
                            },
                            d0: {
                                id: r.OPS.setCharWidth,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            d1: {
                                id: r.OPS.setCharWidthAndBounds,
                                numArgs: 6,
                                variableArgs: !1
                            },
                            CS: {
                                id: r.OPS.setStrokeColorSpace,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            cs: {
                                id: r.OPS.setFillColorSpace,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            SC: {
                                id: r.OPS.setStrokeColor,
                                numArgs: 4,
                                variableArgs: !0
                            },
                            SCN: {
                                id: r.OPS.setStrokeColorN,
                                numArgs: 33,
                                variableArgs: !0
                            },
                            sc: {
                                id: r.OPS.setFillColor,
                                numArgs: 4,
                                variableArgs: !0
                            },
                            scn: {
                                id: r.OPS.setFillColorN,
                                numArgs: 33,
                                variableArgs: !0
                            },
                            G: {
                                id: r.OPS.setStrokeGray,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            g: {
                                id: r.OPS.setFillGray,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            RG: {
                                id: r.OPS.setStrokeRGBColor,
                                numArgs: 3,
                                variableArgs: !1
                            },
                            rg: {
                                id: r.OPS.setFillRGBColor,
                                numArgs: 3,
                                variableArgs: !1
                            },
                            K: {
                                id: r.OPS.setStrokeCMYKColor,
                                numArgs: 4,
                                variableArgs: !1
                            },
                            k: {
                                id: r.OPS.setFillCMYKColor,
                                numArgs: 4,
                                variableArgs: !1
                            },
                            sh: {
                                id: r.OPS.shadingFill,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            BI: {
                                id: r.OPS.beginInlineImage,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            ID: {
                                id: r.OPS.beginImageData,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            EI: {
                                id: r.OPS.endInlineImage,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            Do: {
                                id: r.OPS.paintXObject,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            MP: {
                                id: r.OPS.markPoint,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            DP: {
                                id: r.OPS.markPointProps,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            BMC: {
                                id: r.OPS.beginMarkedContent,
                                numArgs: 1,
                                variableArgs: !1
                            },
                            BDC: {
                                id: r.OPS.beginMarkedContentProps,
                                numArgs: 2,
                                variableArgs: !1
                            },
                            EMC: {
                                id: r.OPS.endMarkedContent,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            BX: {
                                id: r.OPS.beginCompat,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            EX: {
                                id: r.OPS.endCompat,
                                numArgs: 0,
                                variableArgs: !1
                            },
                            BM: null,
                            BD: null,
                            true: null,
                            fa: null,
                            fal: null,
                            fals: null,
                            false: null,
                            nu: null,
                            nul: null,
                            null: null
                        });
                    }
                    static MAX_INVALID_PATH_OPS = 10;
                    constructor(e1, t, a = new StateManager){
                        this.parser = new f.Parser({
                            lexer: new f.Lexer(e1, EvaluatorPreprocessor.opMap),
                            xref: t
                        });
                        this.stateManager = a;
                        this.nonProcessedArgs = [];
                        this._isPathOp = !1;
                        this._numInvalidPathOPS = 0;
                    }
                    get savedStatesDepth() {
                        return this.stateManager.stateStack.length;
                    }
                    read(e1) {
                        let t = e1.args;
                        for(;;){
                            const a = this.parser.getObj();
                            if (a instanceof i.Cmd) {
                                const n = a.cmd, i = EvaluatorPreprocessor.opMap[n];
                                if (!i) {
                                    (0, r.warn)(`Unknown command "${n}".`);
                                    continue;
                                }
                                const s = i.id, o = i.numArgs;
                                let c = null !== t ? t.length : 0;
                                this._isPathOp || (this._numInvalidPathOPS = 0);
                                this._isPathOp = s >= r.OPS.moveTo && s <= r.OPS.endPath;
                                if (i.variableArgs) c > o && (0, r.info)(`Command ${n}: expected [0, ${o}] args, but received ${c} args.`);
                                else {
                                    if (c !== o) {
                                        const e1 = this.nonProcessedArgs;
                                        for(; c > o;){
                                            e1.push(t.shift());
                                            c--;
                                        }
                                        for(; c < o && 0 !== e1.length;){
                                            null === t && (t = []);
                                            t.unshift(e1.pop());
                                            c++;
                                        }
                                    }
                                    if (c < o) {
                                        const e1 = `command ${n}: expected ${o} args, but received ${c} args.`;
                                        if (this._isPathOp && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) throw new r.FormatError(`Invalid ${e1}`);
                                        (0, r.warn)(`Skipping ${e1}`);
                                        null !== t && (t.length = 0);
                                        continue;
                                    }
                                }
                                this.preprocessCommand(s, t);
                                e1.fn = s;
                                e1.args = t;
                                return !0;
                            }
                            if (a === i.EOF) return !1;
                            if (null !== a) {
                                null === t && (t = []);
                                t.push(a);
                                if (t.length > 33) throw new r.FormatError("Too many arguments");
                            }
                        }
                    }
                    preprocessCommand(e1, t) {
                        switch(0 | e1){
                            case r.OPS.save:
                                this.stateManager.save();
                                break;
                            case r.OPS.restore:
                                this.stateManager.restore();
                                break;
                            case r.OPS.transform:
                                this.stateManager.transform(t);
                        }
                    }
                }
                t.EvaluatorPreprocessor = EvaluatorPreprocessor;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.IdentityCMap = t.CMapFactory = t.CMap = void 0;
                var r = a(2), n = a(4), i = a(5), s = a(15), o = a(16), c = a(3), l = a(8);
                const h = [
                    "Adobe-GB1-UCS2",
                    "Adobe-CNS1-UCS2",
                    "Adobe-Japan1-UCS2",
                    "Adobe-Korea1-UCS2",
                    "78-EUC-H",
                    "78-EUC-V",
                    "78-H",
                    "78-RKSJ-H",
                    "78-RKSJ-V",
                    "78-V",
                    "78ms-RKSJ-H",
                    "78ms-RKSJ-V",
                    "83pv-RKSJ-H",
                    "90ms-RKSJ-H",
                    "90ms-RKSJ-V",
                    "90msp-RKSJ-H",
                    "90msp-RKSJ-V",
                    "90pv-RKSJ-H",
                    "90pv-RKSJ-V",
                    "Add-H",
                    "Add-RKSJ-H",
                    "Add-RKSJ-V",
                    "Add-V",
                    "Adobe-CNS1-0",
                    "Adobe-CNS1-1",
                    "Adobe-CNS1-2",
                    "Adobe-CNS1-3",
                    "Adobe-CNS1-4",
                    "Adobe-CNS1-5",
                    "Adobe-CNS1-6",
                    "Adobe-GB1-0",
                    "Adobe-GB1-1",
                    "Adobe-GB1-2",
                    "Adobe-GB1-3",
                    "Adobe-GB1-4",
                    "Adobe-GB1-5",
                    "Adobe-Japan1-0",
                    "Adobe-Japan1-1",
                    "Adobe-Japan1-2",
                    "Adobe-Japan1-3",
                    "Adobe-Japan1-4",
                    "Adobe-Japan1-5",
                    "Adobe-Japan1-6",
                    "Adobe-Korea1-0",
                    "Adobe-Korea1-1",
                    "Adobe-Korea1-2",
                    "B5-H",
                    "B5-V",
                    "B5pc-H",
                    "B5pc-V",
                    "CNS-EUC-H",
                    "CNS-EUC-V",
                    "CNS1-H",
                    "CNS1-V",
                    "CNS2-H",
                    "CNS2-V",
                    "ETHK-B5-H",
                    "ETHK-B5-V",
                    "ETen-B5-H",
                    "ETen-B5-V",
                    "ETenms-B5-H",
                    "ETenms-B5-V",
                    "EUC-H",
                    "EUC-V",
                    "Ext-H",
                    "Ext-RKSJ-H",
                    "Ext-RKSJ-V",
                    "Ext-V",
                    "GB-EUC-H",
                    "GB-EUC-V",
                    "GB-H",
                    "GB-V",
                    "GBK-EUC-H",
                    "GBK-EUC-V",
                    "GBK2K-H",
                    "GBK2K-V",
                    "GBKp-EUC-H",
                    "GBKp-EUC-V",
                    "GBT-EUC-H",
                    "GBT-EUC-V",
                    "GBT-H",
                    "GBT-V",
                    "GBTpc-EUC-H",
                    "GBTpc-EUC-V",
                    "GBpc-EUC-H",
                    "GBpc-EUC-V",
                    "H",
                    "HKdla-B5-H",
                    "HKdla-B5-V",
                    "HKdlb-B5-H",
                    "HKdlb-B5-V",
                    "HKgccs-B5-H",
                    "HKgccs-B5-V",
                    "HKm314-B5-H",
                    "HKm314-B5-V",
                    "HKm471-B5-H",
                    "HKm471-B5-V",
                    "HKscs-B5-H",
                    "HKscs-B5-V",
                    "Hankaku",
                    "Hiragana",
                    "KSC-EUC-H",
                    "KSC-EUC-V",
                    "KSC-H",
                    "KSC-Johab-H",
                    "KSC-Johab-V",
                    "KSC-V",
                    "KSCms-UHC-H",
                    "KSCms-UHC-HW-H",
                    "KSCms-UHC-HW-V",
                    "KSCms-UHC-V",
                    "KSCpc-EUC-H",
                    "KSCpc-EUC-V",
                    "Katakana",
                    "NWP-H",
                    "NWP-V",
                    "RKSJ-H",
                    "RKSJ-V",
                    "Roman",
                    "UniCNS-UCS2-H",
                    "UniCNS-UCS2-V",
                    "UniCNS-UTF16-H",
                    "UniCNS-UTF16-V",
                    "UniCNS-UTF32-H",
                    "UniCNS-UTF32-V",
                    "UniCNS-UTF8-H",
                    "UniCNS-UTF8-V",
                    "UniGB-UCS2-H",
                    "UniGB-UCS2-V",
                    "UniGB-UTF16-H",
                    "UniGB-UTF16-V",
                    "UniGB-UTF32-H",
                    "UniGB-UTF32-V",
                    "UniGB-UTF8-H",
                    "UniGB-UTF8-V",
                    "UniJIS-UCS2-H",
                    "UniJIS-UCS2-HW-H",
                    "UniJIS-UCS2-HW-V",
                    "UniJIS-UCS2-V",
                    "UniJIS-UTF16-H",
                    "UniJIS-UTF16-V",
                    "UniJIS-UTF32-H",
                    "UniJIS-UTF32-V",
                    "UniJIS-UTF8-H",
                    "UniJIS-UTF8-V",
                    "UniJIS2004-UTF16-H",
                    "UniJIS2004-UTF16-V",
                    "UniJIS2004-UTF32-H",
                    "UniJIS2004-UTF32-V",
                    "UniJIS2004-UTF8-H",
                    "UniJIS2004-UTF8-V",
                    "UniJISPro-UCS2-HW-V",
                    "UniJISPro-UCS2-V",
                    "UniJISPro-UTF8-V",
                    "UniJISX0213-UTF32-H",
                    "UniJISX0213-UTF32-V",
                    "UniJISX02132004-UTF32-H",
                    "UniJISX02132004-UTF32-V",
                    "UniKS-UCS2-H",
                    "UniKS-UCS2-V",
                    "UniKS-UTF16-H",
                    "UniKS-UTF16-V",
                    "UniKS-UTF32-H",
                    "UniKS-UTF32-V",
                    "UniKS-UTF8-H",
                    "UniKS-UTF8-V",
                    "V",
                    "WP-Symbol"
                ], u = 2 ** 24 - 1;
                class CMap {
                    constructor(e1 = !1){
                        this.codespaceRanges = [
                            [],
                            [],
                            [],
                            []
                        ];
                        this.numCodespaceRanges = 0;
                        this._map = [];
                        this.name = "";
                        this.vertical = !1;
                        this.useCMap = null;
                        this.builtInCMap = e1;
                    }
                    addCodespaceRange(e1, t, a) {
                        this.codespaceRanges[e1 - 1].push(t, a);
                        this.numCodespaceRanges++;
                    }
                    mapCidRange(e1, t, a) {
                        if (t - e1 > u) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                        for(; e1 <= t;)this._map[e1++] = a++;
                    }
                    mapBfRange(e1, t, a) {
                        if (t - e1 > u) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                        const r = a.length - 1;
                        for(; e1 <= t;){
                            this._map[e1++] = a;
                            const t = a.charCodeAt(r) + 1;
                            t > 255 ? a = a.substring(0, r - 1) + String.fromCharCode(a.charCodeAt(r - 1) + 1) + "\0" : a = a.substring(0, r) + String.fromCharCode(t);
                        }
                    }
                    mapBfRangeToArray(e1, t, a) {
                        if (t - e1 > u) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                        const r = a.length;
                        let n = 0;
                        for(; e1 <= t && n < r;){
                            this._map[e1] = a[n++];
                            ++e1;
                        }
                    }
                    mapOne(e1, t) {
                        this._map[e1] = t;
                    }
                    lookup(e1) {
                        return this._map[e1];
                    }
                    contains(e1) {
                        return void 0 !== this._map[e1];
                    }
                    forEach(e1) {
                        const t = this._map, a = t.length;
                        if (a <= 65536) for(let r = 0; r < a; r++)void 0 !== t[r] && e1(r, t[r]);
                        else for(const a in t)e1(a, t[a]);
                    }
                    charCodeOf(e1) {
                        const t = this._map;
                        if (t.length <= 65536) return t.indexOf(e1);
                        for(const a in t)if (t[a] === e1) return 0 | a;
                        return -1;
                    }
                    getMap() {
                        return this._map;
                    }
                    readCharCode(e1, t, a) {
                        let r = 0;
                        const n = this.codespaceRanges;
                        for(let i = 0, s = n.length; i < s; i++){
                            r = (r << 8 | e1.charCodeAt(t + i)) >>> 0;
                            const s = n[i];
                            for(let e1 = 0, t = s.length; e1 < t;){
                                const t = s[e1++], n = s[e1++];
                                if (r >= t && r <= n) {
                                    a.charcode = r;
                                    a.length = i + 1;
                                    return;
                                }
                            }
                        }
                        a.charcode = 0;
                        a.length = 1;
                    }
                    getCharCodeLength(e1) {
                        const t = this.codespaceRanges;
                        for(let a = 0, r = t.length; a < r; a++){
                            const r = t[a];
                            for(let t = 0, n = r.length; t < n;){
                                const n = r[t++], i = r[t++];
                                if (e1 >= n && e1 <= i) return a + 1;
                            }
                        }
                        return 1;
                    }
                    get length() {
                        return this._map.length;
                    }
                    get isIdentityCMap() {
                        if ("Identity-H" !== this.name && "Identity-V" !== this.name) return !1;
                        if (65536 !== this._map.length) return !1;
                        for(let e1 = 0; e1 < 65536; e1++)if (this._map[e1] !== e1) return !1;
                        return !0;
                    }
                }
                t.CMap = CMap;
                class IdentityCMap extends CMap {
                    constructor(e1, t){
                        super();
                        this.vertical = e1;
                        this.addCodespaceRange(t, 0, 65535);
                    }
                    mapCidRange(e1, t, a) {
                        (0, r.unreachable)("should not call mapCidRange");
                    }
                    mapBfRange(e1, t, a) {
                        (0, r.unreachable)("should not call mapBfRange");
                    }
                    mapBfRangeToArray(e1, t, a) {
                        (0, r.unreachable)("should not call mapBfRangeToArray");
                    }
                    mapOne(e1, t) {
                        (0, r.unreachable)("should not call mapCidOne");
                    }
                    lookup(e1) {
                        return Number.isInteger(e1) && e1 <= 65535 ? e1 : void 0;
                    }
                    contains(e1) {
                        return Number.isInteger(e1) && e1 <= 65535;
                    }
                    forEach(e1) {
                        for(let t = 0; t <= 65535; t++)e1(t, t);
                    }
                    charCodeOf(e1) {
                        return Number.isInteger(e1) && e1 <= 65535 ? e1 : -1;
                    }
                    getMap() {
                        const e1 = new Array(65536);
                        for(let t = 0; t <= 65535; t++)e1[t] = t;
                        return e1;
                    }
                    get length() {
                        return 65536;
                    }
                    get isIdentityCMap() {
                        (0, r.unreachable)("should not access .isIdentityCMap");
                    }
                }
                t.IdentityCMap = IdentityCMap;
                function strToInt(e1) {
                    let t = 0;
                    for(let a = 0; a < e1.length; a++)t = t << 8 | e1.charCodeAt(a);
                    return t >>> 0;
                }
                function expectString(e1) {
                    if ("string" != typeof e1) throw new r.FormatError("Malformed CMap: expected string.");
                }
                function expectInt(e1) {
                    if (!Number.isInteger(e1)) throw new r.FormatError("Malformed CMap: expected int.");
                }
                function parseBfChar(e1, t) {
                    for(;;){
                        let a = t.getObj();
                        if (a === n.EOF) break;
                        if ((0, n.isCmd)(a, "endbfchar")) return;
                        expectString(a);
                        const r = strToInt(a);
                        a = t.getObj();
                        expectString(a);
                        const i = a;
                        e1.mapOne(r, i);
                    }
                }
                function parseBfRange(e1, t) {
                    for(;;){
                        let a = t.getObj();
                        if (a === n.EOF) break;
                        if ((0, n.isCmd)(a, "endbfrange")) return;
                        expectString(a);
                        const r = strToInt(a);
                        a = t.getObj();
                        expectString(a);
                        const i = strToInt(a);
                        a = t.getObj();
                        if (Number.isInteger(a) || "string" == typeof a) {
                            const t = Number.isInteger(a) ? String.fromCharCode(a) : a;
                            e1.mapBfRange(r, i, t);
                        } else {
                            if (!(0, n.isCmd)(a, "[")) break;
                            {
                                a = t.getObj();
                                const s = [];
                                for(; !(0, n.isCmd)(a, "]") && a !== n.EOF;){
                                    s.push(a);
                                    a = t.getObj();
                                }
                                e1.mapBfRangeToArray(r, i, s);
                            }
                        }
                    }
                    throw new r.FormatError("Invalid bf range.");
                }
                function parseCidChar(e1, t) {
                    for(;;){
                        let a = t.getObj();
                        if (a === n.EOF) break;
                        if ((0, n.isCmd)(a, "endcidchar")) return;
                        expectString(a);
                        const r = strToInt(a);
                        a = t.getObj();
                        expectInt(a);
                        const i = a;
                        e1.mapOne(r, i);
                    }
                }
                function parseCidRange(e1, t) {
                    for(;;){
                        let a = t.getObj();
                        if (a === n.EOF) break;
                        if ((0, n.isCmd)(a, "endcidrange")) return;
                        expectString(a);
                        const r = strToInt(a);
                        a = t.getObj();
                        expectString(a);
                        const i = strToInt(a);
                        a = t.getObj();
                        expectInt(a);
                        const s = a;
                        e1.mapCidRange(r, i, s);
                    }
                }
                function parseCodespaceRange(e1, t) {
                    for(;;){
                        let a = t.getObj();
                        if (a === n.EOF) break;
                        if ((0, n.isCmd)(a, "endcodespacerange")) return;
                        if ("string" != typeof a) break;
                        const r = strToInt(a);
                        a = t.getObj();
                        if ("string" != typeof a) break;
                        const i = strToInt(a);
                        e1.addCodespaceRange(a.length, r, i);
                    }
                    throw new r.FormatError("Invalid codespace range.");
                }
                function parseWMode(e1, t) {
                    const a = t.getObj();
                    Number.isInteger(a) && (e1.vertical = !!a);
                }
                function parseCMapName(e1, t) {
                    const a = t.getObj();
                    a instanceof n.Name && (e1.name = a.name);
                }
                async function parseCMap(e1, t, a, i) {
                    let s, o;
                    e: for(;;)try {
                        const a = t.getObj();
                        if (a === n.EOF) break;
                        if (a instanceof n.Name) {
                            "WMode" === a.name ? parseWMode(e1, t) : "CMapName" === a.name && parseCMapName(e1, t);
                            s = a;
                        } else if (a instanceof n.Cmd) switch(a.cmd){
                            case "endcmap":
                                break e;
                            case "usecmap":
                                s instanceof n.Name && (o = s.name);
                                break;
                            case "begincodespacerange":
                                parseCodespaceRange(e1, t);
                                break;
                            case "beginbfchar":
                                parseBfChar(e1, t);
                                break;
                            case "begincidchar":
                                parseCidChar(e1, t);
                                break;
                            case "beginbfrange":
                                parseBfRange(e1, t);
                                break;
                            case "begincidrange":
                                parseCidRange(e1, t);
                        }
                    } catch (e1) {
                        if (e1 instanceof c.MissingDataException) throw e1;
                        (0, r.warn)("Invalid cMap data: " + e1);
                        continue;
                    }
                    !i && o && (i = o);
                    return i ? extendCMap(e1, a, i) : e1;
                }
                async function extendCMap(e1, t, a) {
                    e1.useCMap = await createBuiltInCMap(a, t);
                    if (0 === e1.numCodespaceRanges) {
                        const t = e1.useCMap.codespaceRanges;
                        for(let a = 0; a < t.length; a++)e1.codespaceRanges[a] = t[a].slice();
                        e1.numCodespaceRanges = e1.useCMap.numCodespaceRanges;
                    }
                    e1.useCMap.forEach(function(t, a) {
                        e1.contains(t) || e1.mapOne(t, e1.useCMap.lookup(t));
                    });
                    return e1;
                }
                async function createBuiltInCMap(e1, t) {
                    if ("Identity-H" === e1) return new IdentityCMap(!1, 2);
                    if ("Identity-V" === e1) return new IdentityCMap(!0, 2);
                    if (!h.includes(e1)) throw new Error("Unknown CMap name: " + e1);
                    if (!t) throw new Error("Built-in CMap parameters are not provided.");
                    const { cMapData: a, compressionType: n } = await t(e1), i = new CMap(!0);
                    if (n === r.CMapCompressionType.BINARY) return (new s.BinaryCMapReader).process(a, i, (e1)=>extendCMap(i, t, e1));
                    if (n === r.CMapCompressionType.NONE) {
                        const e1 = new o.Lexer(new l.Stream(a));
                        return parseCMap(i, e1, t, null);
                    }
                    throw new Error(`Invalid CMap "compressionType" value: ${n}`);
                }
                t.CMapFactory = class CMapFactory {
                    static async create({ encoding: e1, fetchBuiltInCMap: t, useCMap: a }) {
                        if (e1 instanceof n.Name) return createBuiltInCMap(e1.name, t);
                        if (e1 instanceof i.BaseStream) {
                            const r = await parseCMap(new CMap, new o.Lexer(e1), t, a);
                            return r.isIdentityCMap ? createBuiltInCMap(r.name, t) : r;
                        }
                        throw new Error("Encoding required.");
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.BinaryCMapReader = void 0;
                var r = a(2);
                function hexToInt(e1, t) {
                    let a = 0;
                    for(let r = 0; r <= t; r++)a = a << 8 | e1[r];
                    return a >>> 0;
                }
                function hexToStr(e1, t) {
                    return 1 === t ? String.fromCharCode(e1[0], e1[1]) : 3 === t ? String.fromCharCode(e1[0], e1[1], e1[2], e1[3]) : String.fromCharCode(...e1.subarray(0, t + 1));
                }
                function addHex(e1, t, a) {
                    let r = 0;
                    for(let n = a; n >= 0; n--){
                        r += e1[n] + t[n];
                        e1[n] = 255 & r;
                        r >>= 8;
                    }
                }
                function incHex(e1, t) {
                    let a = 1;
                    for(let r = t; r >= 0 && a > 0; r--){
                        a += e1[r];
                        e1[r] = 255 & a;
                        a >>= 8;
                    }
                }
                const n = 16;
                class BinaryCMapStream {
                    constructor(e1){
                        this.buffer = e1;
                        this.pos = 0;
                        this.end = e1.length;
                        this.tmpBuf = new Uint8Array(19);
                    }
                    readByte() {
                        return this.pos >= this.end ? -1 : this.buffer[this.pos++];
                    }
                    readNumber() {
                        let e1, t = 0;
                        do {
                            const a = this.readByte();
                            if (a < 0) throw new r.FormatError("unexpected EOF in bcmap");
                            e1 = !(128 & a);
                            t = t << 7 | 127 & a;
                        }while (!e1);
                        return t;
                    }
                    readSigned() {
                        const e1 = this.readNumber();
                        return 1 & e1 ? ~(e1 >>> 1) : e1 >>> 1;
                    }
                    readHex(e1, t) {
                        e1.set(this.buffer.subarray(this.pos, this.pos + t + 1));
                        this.pos += t + 1;
                    }
                    readHexNumber(e1, t) {
                        let a;
                        const n = this.tmpBuf;
                        let i = 0;
                        do {
                            const e1 = this.readByte();
                            if (e1 < 0) throw new r.FormatError("unexpected EOF in bcmap");
                            a = !(128 & e1);
                            n[i++] = 127 & e1;
                        }while (!a);
                        let s = t, o = 0, c = 0;
                        for(; s >= 0;){
                            for(; c < 8 && n.length > 0;){
                                o |= n[--i] << c;
                                c += 7;
                            }
                            e1[s] = 255 & o;
                            s--;
                            o >>= 8;
                            c -= 8;
                        }
                    }
                    readHexSigned(e1, t) {
                        this.readHexNumber(e1, t);
                        const a = 1 & e1[t] ? 255 : 0;
                        let r = 0;
                        for(let n = 0; n <= t; n++){
                            r = (1 & r) << 8 | e1[n];
                            e1[n] = r >> 1 ^ a;
                        }
                    }
                    readString() {
                        const e1 = this.readNumber(), t = new Array(e1);
                        for(let a = 0; a < e1; a++)t[a] = this.readNumber();
                        return String.fromCharCode(...t);
                    }
                }
                t.BinaryCMapReader = class BinaryCMapReader {
                    async process(e1, t, a) {
                        const r = new BinaryCMapStream(e1), i = r.readByte();
                        t.vertical = !!(1 & i);
                        let s = null;
                        const o = new Uint8Array(n), c = new Uint8Array(n), l = new Uint8Array(n), h = new Uint8Array(n), u = new Uint8Array(n);
                        let d, f;
                        for(; (f = r.readByte()) >= 0;){
                            const e1 = f >> 5;
                            if (7 === e1) {
                                switch(31 & f){
                                    case 0:
                                        r.readString();
                                        break;
                                    case 1:
                                        s = r.readString();
                                }
                                continue;
                            }
                            const a = !!(16 & f), i = 15 & f;
                            if (i + 1 > n) throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                            const g = 1, p = r.readNumber();
                            switch(e1){
                                case 0:
                                    r.readHex(o, i);
                                    r.readHexNumber(c, i);
                                    addHex(c, o, i);
                                    t.addCodespaceRange(i + 1, hexToInt(o, i), hexToInt(c, i));
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(c, i);
                                        r.readHexNumber(o, i);
                                        addHex(o, c, i);
                                        r.readHexNumber(c, i);
                                        addHex(c, o, i);
                                        t.addCodespaceRange(i + 1, hexToInt(o, i), hexToInt(c, i));
                                    }
                                    break;
                                case 1:
                                    r.readHex(o, i);
                                    r.readHexNumber(c, i);
                                    addHex(c, o, i);
                                    r.readNumber();
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(c, i);
                                        r.readHexNumber(o, i);
                                        addHex(o, c, i);
                                        r.readHexNumber(c, i);
                                        addHex(c, o, i);
                                        r.readNumber();
                                    }
                                    break;
                                case 2:
                                    r.readHex(l, i);
                                    d = r.readNumber();
                                    t.mapOne(hexToInt(l, i), d);
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(l, i);
                                        if (!a) {
                                            r.readHexNumber(u, i);
                                            addHex(l, u, i);
                                        }
                                        d = r.readSigned() + (d + 1);
                                        t.mapOne(hexToInt(l, i), d);
                                    }
                                    break;
                                case 3:
                                    r.readHex(o, i);
                                    r.readHexNumber(c, i);
                                    addHex(c, o, i);
                                    d = r.readNumber();
                                    t.mapCidRange(hexToInt(o, i), hexToInt(c, i), d);
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(c, i);
                                        if (a) o.set(c);
                                        else {
                                            r.readHexNumber(o, i);
                                            addHex(o, c, i);
                                        }
                                        r.readHexNumber(c, i);
                                        addHex(c, o, i);
                                        d = r.readNumber();
                                        t.mapCidRange(hexToInt(o, i), hexToInt(c, i), d);
                                    }
                                    break;
                                case 4:
                                    r.readHex(l, g);
                                    r.readHex(h, i);
                                    t.mapOne(hexToInt(l, g), hexToStr(h, i));
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(l, g);
                                        if (!a) {
                                            r.readHexNumber(u, g);
                                            addHex(l, u, g);
                                        }
                                        incHex(h, i);
                                        r.readHexSigned(u, i);
                                        addHex(h, u, i);
                                        t.mapOne(hexToInt(l, g), hexToStr(h, i));
                                    }
                                    break;
                                case 5:
                                    r.readHex(o, g);
                                    r.readHexNumber(c, g);
                                    addHex(c, o, g);
                                    r.readHex(h, i);
                                    t.mapBfRange(hexToInt(o, g), hexToInt(c, g), hexToStr(h, i));
                                    for(let e1 = 1; e1 < p; e1++){
                                        incHex(c, g);
                                        if (a) o.set(c);
                                        else {
                                            r.readHexNumber(o, g);
                                            addHex(o, c, g);
                                        }
                                        r.readHexNumber(c, g);
                                        addHex(c, o, g);
                                        r.readHex(h, i);
                                        t.mapBfRange(hexToInt(o, g), hexToInt(c, g), hexToStr(h, i));
                                    }
                                    break;
                                default:
                                    throw new Error(`BinaryCMapReader.process - unknown type: ${e1}`);
                            }
                        }
                        return s ? a(s) : t;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Parser = t.Linearization = t.Lexer = void 0;
                var r = a(2), n = a(4), i = a(3), s = a(8), o = a(17), c = a(19), l = a(20), h = a(22), u = a(23), d = a(26), f = a(29), g = a(31), p = a(32), m = a(33);
                class Parser {
                    constructor({ lexer: e1, xref: t, allowStreams: a = !1, recoveryMode: r = !1 }){
                        this.lexer = e1;
                        this.xref = t;
                        this.allowStreams = a;
                        this.recoveryMode = r;
                        this.imageCache = Object.create(null);
                        this._imageId = 0;
                        this.refill();
                    }
                    refill() {
                        this.buf1 = this.lexer.getObj();
                        this.buf2 = this.lexer.getObj();
                    }
                    shift() {
                        if (this.buf2 instanceof n.Cmd && "ID" === this.buf2.cmd) {
                            this.buf1 = this.buf2;
                            this.buf2 = null;
                        } else {
                            this.buf1 = this.buf2;
                            this.buf2 = this.lexer.getObj();
                        }
                    }
                    tryShift() {
                        try {
                            this.shift();
                            return !0;
                        } catch (e1) {
                            if (e1 instanceof i.MissingDataException) throw e1;
                            return !1;
                        }
                    }
                    getObj(e1 = null) {
                        const t = this.buf1;
                        this.shift();
                        if (t instanceof n.Cmd) switch(t.cmd){
                            case "BI":
                                return this.makeInlineImage(e1);
                            case "[":
                                const a = [];
                                for(; !(0, n.isCmd)(this.buf1, "]") && this.buf1 !== n.EOF;)a.push(this.getObj(e1));
                                if (this.buf1 === n.EOF) {
                                    if (this.recoveryMode) return a;
                                    throw new i.ParserEOFException("End of file inside array.");
                                }
                                this.shift();
                                return a;
                            case "<<":
                                const s = new n.Dict(this.xref);
                                for(; !(0, n.isCmd)(this.buf1, ">>") && this.buf1 !== n.EOF;){
                                    if (!(this.buf1 instanceof n.Name)) {
                                        (0, r.info)("Malformed dictionary: key must be a name object");
                                        this.shift();
                                        continue;
                                    }
                                    const t = this.buf1.name;
                                    this.shift();
                                    if (this.buf1 === n.EOF) break;
                                    s.set(t, this.getObj(e1));
                                }
                                if (this.buf1 === n.EOF) {
                                    if (this.recoveryMode) return s;
                                    throw new i.ParserEOFException("End of file inside dictionary.");
                                }
                                if ((0, n.isCmd)(this.buf2, "stream")) return this.allowStreams ? this.makeStream(s, e1) : s;
                                this.shift();
                                return s;
                            default:
                                return t;
                        }
                        if (Number.isInteger(t)) {
                            if (Number.isInteger(this.buf1) && (0, n.isCmd)(this.buf2, "R")) {
                                const e1 = n.Ref.get(t, this.buf1);
                                this.shift();
                                this.shift();
                                return e1;
                            }
                            return t;
                        }
                        return "string" == typeof t && e1 ? e1.decryptString(t) : t;
                    }
                    findDefaultInlineStreamEnd(e1) {
                        const { knownCommands: t } = this.lexer, a = e1.pos;
                        let o, c, l = 0;
                        for(; -1 !== (o = e1.getByte());)if (0 === l) l = 69 === o ? 1 : 0;
                        else if (1 === l) l = 73 === o ? 2 : 0;
                        else if (32 === o || 10 === o || 13 === o) {
                            c = e1.pos;
                            const a = e1.peekBytes(15), i = a.length;
                            if (0 === i) break;
                            for(let e1 = 0; e1 < i; e1++){
                                o = a[e1];
                                if ((0 !== o || 0 === a[e1 + 1]) && 10 !== o && 13 !== o && (o < 32 || o > 127)) {
                                    l = 0;
                                    break;
                                }
                            }
                            if (2 !== l) continue;
                            if (!t) {
                                (0, r.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                                continue;
                            }
                            const h = new Lexer(new s.Stream(a.slice()), t);
                            h._hexStringWarn = ()=>{};
                            let u = 0;
                            for(;;){
                                const e1 = h.getObj();
                                if (e1 === n.EOF) {
                                    l = 0;
                                    break;
                                }
                                if (e1 instanceof n.Cmd) {
                                    const a = t[e1.cmd];
                                    if (!a) {
                                        l = 0;
                                        break;
                                    }
                                    if (a.variableArgs ? u <= a.numArgs : u === a.numArgs) break;
                                    u = 0;
                                } else u++;
                            }
                            if (2 === l) break;
                        } else l = 0;
                        if (-1 === o) {
                            (0, r.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
                            if (c) {
                                (0, r.warn)('... trying to recover by using the last "EI" occurrence.');
                                e1.skip(-(e1.pos - c));
                            }
                        }
                        let h = 4;
                        e1.skip(-h);
                        o = e1.peekByte();
                        e1.skip(h);
                        (0, i.isWhiteSpace)(o) || h--;
                        return e1.pos - h - a;
                    }
                    findDCTDecodeInlineStreamEnd(e1) {
                        const t = e1.pos;
                        let a, n, i = !1;
                        for(; -1 !== (a = e1.getByte());)if (255 === a) {
                            switch(e1.getByte()){
                                case 0:
                                    break;
                                case 255:
                                    e1.skip(-1);
                                    break;
                                case 217:
                                    i = !0;
                                    break;
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 197:
                                case 198:
                                case 199:
                                case 201:
                                case 202:
                                case 203:
                                case 205:
                                case 206:
                                case 207:
                                case 196:
                                case 204:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 254:
                                    n = e1.getUint16();
                                    n > 2 ? e1.skip(n - 2) : e1.skip(-2);
                            }
                            if (i) break;
                        }
                        const s = e1.pos - t;
                        if (-1 === a) {
                            (0, r.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
                            e1.skip(-s);
                            return this.findDefaultInlineStreamEnd(e1);
                        }
                        this.inlineStreamSkipEI(e1);
                        return s;
                    }
                    findASCII85DecodeInlineStreamEnd(e1) {
                        const t = e1.pos;
                        let a;
                        for(; -1 !== (a = e1.getByte());)if (126 === a) {
                            const t = e1.pos;
                            a = e1.peekByte();
                            for(; (0, i.isWhiteSpace)(a);){
                                e1.skip();
                                a = e1.peekByte();
                            }
                            if (62 === a) {
                                e1.skip();
                                break;
                            }
                            if (e1.pos > t) {
                                const t = e1.peekBytes(2);
                                if (69 === t[0] && 73 === t[1]) break;
                            }
                        }
                        const n = e1.pos - t;
                        if (-1 === a) {
                            (0, r.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
                            e1.skip(-n);
                            return this.findDefaultInlineStreamEnd(e1);
                        }
                        this.inlineStreamSkipEI(e1);
                        return n;
                    }
                    findASCIIHexDecodeInlineStreamEnd(e1) {
                        const t = e1.pos;
                        let a;
                        for(; -1 !== (a = e1.getByte()) && 62 !== a;);
                        const n = e1.pos - t;
                        if (-1 === a) {
                            (0, r.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
                            e1.skip(-n);
                            return this.findDefaultInlineStreamEnd(e1);
                        }
                        this.inlineStreamSkipEI(e1);
                        return n;
                    }
                    inlineStreamSkipEI(e1) {
                        let t, a = 0;
                        for(; -1 !== (t = e1.getByte());)if (0 === a) a = 69 === t ? 1 : 0;
                        else if (1 === a) a = 73 === t ? 2 : 0;
                        else if (2 === a) break;
                    }
                    makeInlineImage(e1) {
                        const t = this.lexer, a = t.stream, i = Object.create(null);
                        let s;
                        for(; !(0, n.isCmd)(this.buf1, "ID") && this.buf1 !== n.EOF;){
                            if (!(this.buf1 instanceof n.Name)) throw new r.FormatError("Dictionary key must be a name object");
                            const t = this.buf1.name;
                            this.shift();
                            if (this.buf1 === n.EOF) break;
                            i[t] = this.getObj(e1);
                        }
                        -1 !== t.beginInlineImagePos && (s = a.pos - t.beginInlineImagePos);
                        const o = this.xref.fetchIfRef(i.F || i.Filter);
                        let c;
                        if (o instanceof n.Name) c = o.name;
                        else if (Array.isArray(o)) {
                            const e1 = this.xref.fetchIfRef(o[0]);
                            e1 instanceof n.Name && (c = e1.name);
                        }
                        const l = a.pos;
                        let h, u;
                        switch(c){
                            case "DCT":
                            case "DCTDecode":
                                h = this.findDCTDecodeInlineStreamEnd(a);
                                break;
                            case "A85":
                            case "ASCII85Decode":
                                h = this.findASCII85DecodeInlineStreamEnd(a);
                                break;
                            case "AHx":
                            case "ASCIIHexDecode":
                                h = this.findASCIIHexDecodeInlineStreamEnd(a);
                                break;
                            default:
                                h = this.findDefaultInlineStreamEnd(a);
                        }
                        if (h < 1e3 && s > 0) {
                            const e1 = a.pos;
                            a.pos = t.beginInlineImagePos;
                            u = function getInlineImageCacheKey(e1) {
                                const t = [], a = e1.length;
                                let r = 0;
                                for(; r < a - 1;)t.push(e1[r++] << 8 | e1[r++]);
                                r < a && t.push(e1[r]);
                                return a + "_" + String.fromCharCode.apply(null, t);
                            }(a.getBytes(s + h));
                            a.pos = e1;
                            const r = this.imageCache[u];
                            if (void 0 !== r) {
                                this.buf2 = n.Cmd.get("EI");
                                this.shift();
                                r.reset();
                                return r;
                            }
                        }
                        const d = new n.Dict(this.xref);
                        for(const e1 in i)d.set(e1, i[e1]);
                        let f = a.makeSubStream(l, h, d);
                        e1 && (f = e1.createStream(f, h));
                        f = this.filter(f, d, h);
                        f.dict = d;
                        if (void 0 !== u) {
                            f.cacheKey = "inline_img_" + ++this._imageId;
                            this.imageCache[u] = f;
                        }
                        this.buf2 = n.Cmd.get("EI");
                        this.shift();
                        return f;
                    }
                    _findStreamLength(e1, t) {
                        const { stream: a } = this.lexer;
                        a.pos = e1;
                        const r = t.length;
                        for(; a.pos < a.end;){
                            const n = a.peekBytes(2048), i = n.length - r;
                            if (i <= 0) break;
                            let s = 0;
                            for(; s < i;){
                                let i = 0;
                                for(; i < r && n[s + i] === t[i];)i++;
                                if (i >= r) {
                                    a.pos += s;
                                    return a.pos - e1;
                                }
                                s++;
                            }
                            a.pos += i;
                        }
                        return -1;
                    }
                    makeStream(e1, t) {
                        const a = this.lexer;
                        let s = a.stream;
                        a.skipToNextLine();
                        const o = s.pos - 1;
                        let c = e1.get("Length");
                        if (!Number.isInteger(c)) {
                            (0, r.info)(`Bad length "${c && c.toString()}" in stream.`);
                            c = 0;
                        }
                        s.pos = o + c;
                        a.nextChar();
                        if (this.tryShift() && (0, n.isCmd)(this.buf2, "endstream")) this.shift();
                        else {
                            const e1 = new Uint8Array([
                                101,
                                110,
                                100,
                                115,
                                116,
                                114,
                                101,
                                97,
                                109
                            ]);
                            let t = this._findStreamLength(o, e1);
                            if (t < 0) {
                                const a = 1;
                                for(let n = 1; n <= a; n++){
                                    const a = e1.length - n, c = e1.slice(0, a), l = this._findStreamLength(o, c);
                                    if (l >= 0) {
                                        const e1 = s.peekBytes(a + 1)[a];
                                        if (!(0, i.isWhiteSpace)(e1)) break;
                                        (0, r.info)(`Found "${(0, r.bytesToString)(c)}" when searching for endstream command.`);
                                        t = l;
                                        break;
                                    }
                                }
                                if (t < 0) throw new r.FormatError("Missing endstream command.");
                            }
                            c = t;
                            a.nextChar();
                            this.shift();
                            this.shift();
                        }
                        this.shift();
                        s = s.makeSubStream(o, c, e1);
                        t && (s = t.createStream(s, c));
                        s = this.filter(s, e1, c);
                        s.dict = e1;
                        return s;
                    }
                    filter(e1, t, a) {
                        let i = t.get("F", "Filter"), s = t.get("DP", "DecodeParms");
                        if (i instanceof n.Name) {
                            Array.isArray(s) && (0, r.warn)("/DecodeParms should not be an Array, when /Filter is a Name.");
                            return this.makeFilter(e1, i.name, a, s);
                        }
                        let o = a;
                        if (Array.isArray(i)) {
                            const t = i, a = s;
                            for(let c = 0, l = t.length; c < l; ++c){
                                i = this.xref.fetchIfRef(t[c]);
                                if (!(i instanceof n.Name)) throw new r.FormatError(`Bad filter name "${i}"`);
                                s = null;
                                Array.isArray(a) && c in a && (s = this.xref.fetchIfRef(a[c]));
                                e1 = this.makeFilter(e1, i.name, o, s);
                                o = null;
                            }
                        }
                        return e1;
                    }
                    makeFilter(e1, t, a, n) {
                        if (0 === a) {
                            (0, r.warn)(`Empty "${t}" stream.`);
                            return new s.NullStream;
                        }
                        try {
                            switch(t){
                                case "Fl":
                                case "FlateDecode":
                                    return n ? new p.PredictorStream(new h.FlateStream(e1, a), a, n) : new h.FlateStream(e1, a);
                                case "LZW":
                                case "LZWDecode":
                                    let t1 = 1;
                                    if (n) {
                                        n.has("EarlyChange") && (t1 = n.get("EarlyChange"));
                                        return new p.PredictorStream(new g.LZWStream(e1, a, t1), a, n);
                                    }
                                    return new g.LZWStream(e1, a, t1);
                                case "DCT":
                                case "DCTDecode":
                                    return new d.JpegStream(e1, a, n);
                                case "JPX":
                                case "JPXDecode":
                                    return new f.JpxStream(e1, a, n);
                                case "A85":
                                case "ASCII85Decode":
                                    return new o.Ascii85Stream(e1, a);
                                case "AHx":
                                case "ASCIIHexDecode":
                                    return new c.AsciiHexStream(e1, a);
                                case "CCF":
                                case "CCITTFaxDecode":
                                    return new l.CCITTFaxStream(e1, a, n);
                                case "RL":
                                case "RunLengthDecode":
                                    return new m.RunLengthStream(e1, a);
                                case "JBIG2Decode":
                                    return new u.Jbig2Stream(e1, a, n);
                            }
                            (0, r.warn)(`Filter "${t}" is not supported.`);
                            return e1;
                        } catch (e1) {
                            if (e1 instanceof i.MissingDataException) throw e1;
                            (0, r.warn)(`Invalid stream: "${e1}"`);
                            return new s.NullStream;
                        }
                    }
                }
                t.Parser = Parser;
                const b = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                function toHexDigit(e1) {
                    return e1 >= 48 && e1 <= 57 ? 15 & e1 : e1 >= 65 && e1 <= 70 || e1 >= 97 && e1 <= 102 ? 9 + (15 & e1) : -1;
                }
                class Lexer {
                    constructor(e1, t = null){
                        this.stream = e1;
                        this.nextChar();
                        this.strBuf = [];
                        this.knownCommands = t;
                        this._hexStringNumWarn = 0;
                        this.beginInlineImagePos = -1;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    peekChar() {
                        return this.stream.peekByte();
                    }
                    getNumber() {
                        let e1 = this.currentChar, t = !1, a = 0, n = 1;
                        if (45 === e1) {
                            n = -1;
                            e1 = this.nextChar();
                            45 === e1 && (e1 = this.nextChar());
                        } else 43 === e1 && (e1 = this.nextChar());
                        if (10 === e1 || 13 === e1) do e1 = this.nextChar();
                        while (10 === e1 || 13 === e1);
                        if (46 === e1) {
                            a = 10;
                            e1 = this.nextChar();
                        }
                        if (e1 < 48 || e1 > 57) {
                            const t = `Invalid number: ${String.fromCharCode(e1)} (charCode ${e1})`;
                            if ((0, i.isWhiteSpace)(e1) || -1 === e1) {
                                (0, r.info)(`Lexer.getNumber - "${t}".`);
                                return 0;
                            }
                            throw new r.FormatError(t);
                        }
                        let s = e1 - 48, o = 0, c = 1;
                        for(; (e1 = this.nextChar()) >= 0;)if (e1 >= 48 && e1 <= 57) {
                            const r = e1 - 48;
                            if (t) o = 10 * o + r;
                            else {
                                0 !== a && (a *= 10);
                                s = 10 * s + r;
                            }
                        } else if (46 === e1) {
                            if (0 !== a) break;
                            a = 1;
                        } else if (45 === e1) (0, r.warn)("Badly formatted number: minus sign in the middle");
                        else {
                            if (69 !== e1 && 101 !== e1) break;
                            e1 = this.peekChar();
                            if (43 === e1 || 45 === e1) {
                                c = 45 === e1 ? -1 : 1;
                                this.nextChar();
                            } else if (e1 < 48 || e1 > 57) break;
                            t = !0;
                        }
                        0 !== a && (s /= a);
                        t && (s *= 10 ** (c * o));
                        return n * s;
                    }
                    getString() {
                        let e1 = 1, t = !1;
                        const a = this.strBuf;
                        a.length = 0;
                        let n = this.nextChar();
                        for(;;){
                            let i = !1;
                            switch(0 | n){
                                case -1:
                                    (0, r.warn)("Unterminated string");
                                    t = !0;
                                    break;
                                case 40:
                                    ++e1;
                                    a.push("(");
                                    break;
                                case 41:
                                    if (0 == --e1) {
                                        this.nextChar();
                                        t = !0;
                                    } else a.push(")");
                                    break;
                                case 92:
                                    n = this.nextChar();
                                    switch(n){
                                        case -1:
                                            (0, r.warn)("Unterminated string");
                                            t = !0;
                                            break;
                                        case 110:
                                            a.push("\n");
                                            break;
                                        case 114:
                                            a.push("\r");
                                            break;
                                        case 116:
                                            a.push("\t");
                                            break;
                                        case 98:
                                            a.push("\b");
                                            break;
                                        case 102:
                                            a.push("\f");
                                            break;
                                        case 92:
                                        case 40:
                                        case 41:
                                            a.push(String.fromCharCode(n));
                                            break;
                                        case 48:
                                        case 49:
                                        case 50:
                                        case 51:
                                        case 52:
                                        case 53:
                                        case 54:
                                        case 55:
                                            let e2 = 15 & n;
                                            n = this.nextChar();
                                            i = !0;
                                            if (n >= 48 && n <= 55) {
                                                e2 = (e2 << 3) + (15 & n);
                                                n = this.nextChar();
                                                if (n >= 48 && n <= 55) {
                                                    i = !1;
                                                    e2 = (e2 << 3) + (15 & n);
                                                }
                                            }
                                            a.push(String.fromCharCode(e2));
                                            break;
                                        case 13:
                                            10 === this.peekChar() && this.nextChar();
                                            break;
                                        case 10:
                                            break;
                                        default:
                                            a.push(String.fromCharCode(n));
                                    }
                                    break;
                                default:
                                    a.push(String.fromCharCode(n));
                            }
                            if (t) break;
                            i || (n = this.nextChar());
                        }
                        return a.join("");
                    }
                    getName() {
                        let e1, t;
                        const a = this.strBuf;
                        a.length = 0;
                        for(; (e1 = this.nextChar()) >= 0 && !b[e1];)if (35 === e1) {
                            e1 = this.nextChar();
                            if (b[e1]) {
                                (0, r.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
                                a.push("#");
                                break;
                            }
                            const n = toHexDigit(e1);
                            if (-1 !== n) {
                                t = e1;
                                e1 = this.nextChar();
                                const i = toHexDigit(e1);
                                if (-1 === i) {
                                    (0, r.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(e1)}) in hexadecimal number.`);
                                    a.push("#", String.fromCharCode(t));
                                    if (b[e1]) break;
                                    a.push(String.fromCharCode(e1));
                                    continue;
                                }
                                a.push(String.fromCharCode(n << 4 | i));
                            } else a.push("#", String.fromCharCode(e1));
                        } else a.push(String.fromCharCode(e1));
                        a.length > 127 && (0, r.warn)(`Name token is longer than allowed by the spec: ${a.length}`);
                        return n.Name.get(a.join(""));
                    }
                    _hexStringWarn(e1) {
                        5 != this._hexStringNumWarn++ ? this._hexStringNumWarn > 5 || (0, r.warn)(`getHexString - ignoring invalid character: ${e1}`) : (0, r.warn)("getHexString - ignoring additional invalid characters.");
                    }
                    getHexString() {
                        const e1 = this.strBuf;
                        e1.length = 0;
                        let t, a, n = this.currentChar, i = !0;
                        this._hexStringNumWarn = 0;
                        for(;;){
                            if (n < 0) {
                                (0, r.warn)("Unterminated hex string");
                                break;
                            }
                            if (62 === n) {
                                this.nextChar();
                                break;
                            }
                            if (1 !== b[n]) {
                                if (i) {
                                    t = toHexDigit(n);
                                    if (-1 === t) {
                                        this._hexStringWarn(n);
                                        n = this.nextChar();
                                        continue;
                                    }
                                } else {
                                    a = toHexDigit(n);
                                    if (-1 === a) {
                                        this._hexStringWarn(n);
                                        n = this.nextChar();
                                        continue;
                                    }
                                    e1.push(String.fromCharCode(t << 4 | a));
                                }
                                i = !i;
                                n = this.nextChar();
                            } else n = this.nextChar();
                        }
                        return e1.join("");
                    }
                    getObj() {
                        let e1 = !1, t = this.currentChar;
                        for(;;){
                            if (t < 0) return n.EOF;
                            if (e1) 10 !== t && 13 !== t || (e1 = !1);
                            else if (37 === t) e1 = !0;
                            else if (1 !== b[t]) break;
                            t = this.nextChar();
                        }
                        switch(0 | t){
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 43:
                            case 45:
                            case 46:
                                return this.getNumber();
                            case 40:
                                return this.getString();
                            case 47:
                                return this.getName();
                            case 91:
                                this.nextChar();
                                return n.Cmd.get("[");
                            case 93:
                                this.nextChar();
                                return n.Cmd.get("]");
                            case 60:
                                t = this.nextChar();
                                if (60 === t) {
                                    this.nextChar();
                                    return n.Cmd.get("<<");
                                }
                                return this.getHexString();
                            case 62:
                                t = this.nextChar();
                                if (62 === t) {
                                    this.nextChar();
                                    return n.Cmd.get(">>");
                                }
                                return n.Cmd.get(">");
                            case 123:
                                this.nextChar();
                                return n.Cmd.get("{");
                            case 125:
                                this.nextChar();
                                return n.Cmd.get("}");
                            case 41:
                                this.nextChar();
                                throw new r.FormatError(`Illegal character: ${t}`);
                        }
                        let a = String.fromCharCode(t);
                        if (t < 32 || t > 127) {
                            const e1 = this.peekChar();
                            if (e1 >= 32 && e1 <= 127) {
                                this.nextChar();
                                return n.Cmd.get(a);
                            }
                        }
                        const i = this.knownCommands;
                        let s = void 0 !== i?.[a];
                        for(; (t = this.nextChar()) >= 0 && !b[t];){
                            const e1 = a + String.fromCharCode(t);
                            if (s && void 0 === i[e1]) break;
                            if (128 === a.length) throw new r.FormatError(`Command token too long: ${a.length}`);
                            a = e1;
                            s = void 0 !== i?.[a];
                        }
                        if ("true" === a) return !0;
                        if ("false" === a) return !1;
                        if ("null" === a) return null;
                        "BI" === a && (this.beginInlineImagePos = this.stream.pos);
                        return n.Cmd.get(a);
                    }
                    skipToNextLine() {
                        let e1 = this.currentChar;
                        for(; e1 >= 0;){
                            if (13 === e1) {
                                e1 = this.nextChar();
                                10 === e1 && this.nextChar();
                                break;
                            }
                            if (10 === e1) {
                                this.nextChar();
                                break;
                            }
                            e1 = this.nextChar();
                        }
                    }
                }
                t.Lexer = Lexer;
                t.Linearization = class Linearization {
                    static create(e1) {
                        function getInt(e1, t, a = !1) {
                            const r = e1.get(t);
                            if (Number.isInteger(r) && (a ? r >= 0 : r > 0)) return r;
                            throw new Error(`The "${t}" parameter in the linearization dictionary is invalid.`);
                        }
                        const t = new Parser({
                            lexer: new Lexer(e1),
                            xref: null
                        }), a = t.getObj(), r = t.getObj(), i = t.getObj(), s = t.getObj();
                        let o, c;
                        if (!(Number.isInteger(a) && Number.isInteger(r) && (0, n.isCmd)(i, "obj") && s instanceof n.Dict && "number" == typeof (o = s.get("Linearized")) && o > 0)) return null;
                        if ((c = getInt(s, "L")) !== e1.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                        return {
                            length: c,
                            hints: function getHints(e1) {
                                const t = e1.get("H");
                                let a;
                                if (Array.isArray(t) && (2 === (a = t.length) || 4 === a)) {
                                    for(let e1 = 0; e1 < a; e1++){
                                        const a = t[e1];
                                        if (!(Number.isInteger(a) && a > 0)) throw new Error(`Hint (${e1}) in the linearization dictionary is invalid.`);
                                    }
                                    return t;
                                }
                                throw new Error("Hint array in the linearization dictionary is invalid.");
                            }(s),
                            objectNumberFirst: getInt(s, "O"),
                            endFirst: getInt(s, "E"),
                            numPages: getInt(s, "N"),
                            mainXRefEntriesOffset: getInt(s, "T"),
                            pageFirst: s.has("P") ? getInt(s, "P", !0) : 0
                        };
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Ascii85Stream = void 0;
                var r = a(18), n = a(3);
                class Ascii85Stream extends r.DecodeStream {
                    constructor(e1, t){
                        t && (t *= .8);
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        this.input = new Uint8Array(5);
                    }
                    readBlock() {
                        const e1 = this.str;
                        let t = e1.getByte();
                        for(; (0, n.isWhiteSpace)(t);)t = e1.getByte();
                        if (-1 === t || 126 === t) {
                            this.eof = !0;
                            return;
                        }
                        const a = this.bufferLength;
                        let r, i;
                        if (122 === t) {
                            r = this.ensureBuffer(a + 4);
                            for(i = 0; i < 4; ++i)r[a + i] = 0;
                            this.bufferLength += 4;
                        } else {
                            const s = this.input;
                            s[0] = t;
                            for(i = 1; i < 5; ++i){
                                t = e1.getByte();
                                for(; (0, n.isWhiteSpace)(t);)t = e1.getByte();
                                s[i] = t;
                                if (-1 === t || 126 === t) break;
                            }
                            r = this.ensureBuffer(a + i - 1);
                            this.bufferLength += i - 1;
                            if (i < 5) {
                                for(; i < 5; ++i)s[i] = 117;
                                this.eof = !0;
                            }
                            let o = 0;
                            for(i = 0; i < 5; ++i)o = 85 * o + (s[i] - 33);
                            for(i = 3; i >= 0; --i){
                                r[a + i] = 255 & o;
                                o >>= 8;
                            }
                        }
                    }
                }
                t.Ascii85Stream = Ascii85Stream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.StreamsSequenceStream = t.DecodeStream = void 0;
                var r = a(5), n = a(8);
                const i = new Uint8Array(0);
                class DecodeStream extends r.BaseStream {
                    constructor(e1){
                        super();
                        this._rawMinBufferLength = e1 || 0;
                        this.pos = 0;
                        this.bufferLength = 0;
                        this.eof = !1;
                        this.buffer = i;
                        this.minBufferLength = 512;
                        if (e1) for(; this.minBufferLength < e1;)this.minBufferLength *= 2;
                    }
                    get isEmpty() {
                        for(; !this.eof && 0 === this.bufferLength;)this.readBlock();
                        return 0 === this.bufferLength;
                    }
                    ensureBuffer(e1) {
                        const t = this.buffer;
                        if (e1 <= t.byteLength) return t;
                        let a = this.minBufferLength;
                        for(; a < e1;)a *= 2;
                        const r = new Uint8Array(a);
                        r.set(t);
                        return this.buffer = r;
                    }
                    getByte() {
                        const e1 = this.pos;
                        for(; this.bufferLength <= e1;){
                            if (this.eof) return -1;
                            this.readBlock();
                        }
                        return this.buffer[this.pos++];
                    }
                    getBytes(e1) {
                        const t = this.pos;
                        let a;
                        if (e1) {
                            this.ensureBuffer(t + e1);
                            a = t + e1;
                            for(; !this.eof && this.bufferLength < a;)this.readBlock();
                            const r = this.bufferLength;
                            a > r && (a = r);
                        } else {
                            for(; !this.eof;)this.readBlock();
                            a = this.bufferLength;
                        }
                        this.pos = a;
                        return this.buffer.subarray(t, a);
                    }
                    reset() {
                        this.pos = 0;
                    }
                    makeSubStream(e1, t, a = null) {
                        if (void 0 === t) for(; !this.eof;)this.readBlock();
                        else {
                            const a = e1 + t;
                            for(; this.bufferLength <= a && !this.eof;)this.readBlock();
                        }
                        return new n.Stream(this.buffer, e1, t, a);
                    }
                    getBaseStreams() {
                        return this.str ? this.str.getBaseStreams() : null;
                    }
                }
                t.DecodeStream = DecodeStream;
                t.StreamsSequenceStream = class StreamsSequenceStream extends DecodeStream {
                    constructor(e1, t = null){
                        let a = 0;
                        for (const t of e1)a += t instanceof DecodeStream ? t._rawMinBufferLength : t.length;
                        super(a);
                        this.streams = e1;
                        this._onError = t;
                    }
                    readBlock() {
                        const e1 = this.streams;
                        if (0 === e1.length) {
                            this.eof = !0;
                            return;
                        }
                        const t = e1.shift();
                        let a;
                        try {
                            a = t.getBytes();
                        } catch (e1) {
                            if (this._onError) {
                                this._onError(e1, t.dict?.objId);
                                return;
                            }
                            throw e1;
                        }
                        const r = this.bufferLength, n = r + a.length;
                        this.ensureBuffer(n).set(a, r);
                        this.bufferLength = n;
                    }
                    getBaseStreams() {
                        const e1 = [];
                        for (const t of this.streams){
                            const a = t.getBaseStreams();
                            a && e1.push(...a);
                        }
                        return e1.length > 0 ? e1 : null;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.AsciiHexStream = void 0;
                var r = a(18);
                class AsciiHexStream extends r.DecodeStream {
                    constructor(e1, t){
                        t && (t *= .5);
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        this.firstDigit = -1;
                    }
                    readBlock() {
                        const e1 = this.str.getBytes(8e3);
                        if (!e1.length) {
                            this.eof = !0;
                            return;
                        }
                        const t = e1.length + 1 >> 1, a = this.ensureBuffer(this.bufferLength + t);
                        let r = this.bufferLength, n = this.firstDigit;
                        for (const t of e1){
                            let e1;
                            if (t >= 48 && t <= 57) e1 = 15 & t;
                            else {
                                if (!(t >= 65 && t <= 70 || t >= 97 && t <= 102)) {
                                    if (62 === t) {
                                        this.eof = !0;
                                        break;
                                    }
                                    continue;
                                }
                                e1 = 9 + (15 & t);
                            }
                            if (n < 0) n = e1;
                            else {
                                a[r++] = n << 4 | e1;
                                n = -1;
                            }
                        }
                        if (n >= 0 && this.eof) {
                            a[r++] = n << 4;
                            n = -1;
                        }
                        this.firstDigit = n;
                        this.bufferLength = r;
                    }
                }
                t.AsciiHexStream = AsciiHexStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.CCITTFaxStream = void 0;
                var r = a(21), n = a(18), i = a(4);
                class CCITTFaxStream extends n.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        a instanceof i.Dict || (a = i.Dict.empty);
                        const n = {
                            next: ()=>e1.getByte()
                        };
                        this.ccittFaxDecoder = new r.CCITTFaxDecoder(n, {
                            K: a.get("K"),
                            EndOfLine: a.get("EndOfLine"),
                            EncodedByteAlign: a.get("EncodedByteAlign"),
                            Columns: a.get("Columns"),
                            Rows: a.get("Rows"),
                            EndOfBlock: a.get("EndOfBlock"),
                            BlackIs1: a.get("BlackIs1")
                        });
                    }
                    readBlock() {
                        for(; !this.eof;){
                            const e1 = this.ccittFaxDecoder.readNextChar();
                            if (-1 === e1) {
                                this.eof = !0;
                                return;
                            }
                            this.ensureBuffer(this.bufferLength + 1);
                            this.buffer[this.bufferLength++] = e1;
                        }
                    }
                }
                t.CCITTFaxStream = CCITTFaxStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.CCITTFaxDecoder = void 0;
                var r = a(2);
                const n = -1, i = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        7,
                        8
                    ],
                    [
                        7,
                        7
                    ],
                    [
                        6,
                        6
                    ],
                    [
                        6,
                        6
                    ],
                    [
                        6,
                        5
                    ],
                    [
                        6,
                        5
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        3,
                        3
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        1,
                        2
                    ]
                ], s = [
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        -2
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ]
                ], o = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        9,
                        1472
                    ],
                    [
                        9,
                        1536
                    ],
                    [
                        9,
                        1600
                    ],
                    [
                        9,
                        1728
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        9,
                        704
                    ],
                    [
                        9,
                        768
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        9,
                        832
                    ],
                    [
                        9,
                        896
                    ],
                    [
                        9,
                        960
                    ],
                    [
                        9,
                        1024
                    ],
                    [
                        9,
                        1088
                    ],
                    [
                        9,
                        1152
                    ],
                    [
                        9,
                        1216
                    ],
                    [
                        9,
                        1280
                    ],
                    [
                        9,
                        1344
                    ],
                    [
                        9,
                        1408
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ]
                ], c = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        -2
                    ],
                    [
                        12,
                        -2
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        13,
                        640
                    ],
                    [
                        13,
                        704
                    ],
                    [
                        13,
                        768
                    ],
                    [
                        13,
                        832
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        13,
                        1280
                    ],
                    [
                        13,
                        1344
                    ],
                    [
                        13,
                        1408
                    ],
                    [
                        13,
                        1472
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        13,
                        1536
                    ],
                    [
                        13,
                        1600
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        13,
                        1664
                    ],
                    [
                        13,
                        1728
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        13,
                        512
                    ],
                    [
                        13,
                        576
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        13,
                        896
                    ],
                    [
                        13,
                        960
                    ],
                    [
                        13,
                        1024
                    ],
                    [
                        13,
                        1088
                    ],
                    [
                        13,
                        1152
                    ],
                    [
                        13,
                        1216
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ]
                ], l = [
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        12,
                        50
                    ],
                    [
                        12,
                        51
                    ],
                    [
                        12,
                        44
                    ],
                    [
                        12,
                        45
                    ],
                    [
                        12,
                        46
                    ],
                    [
                        12,
                        47
                    ],
                    [
                        12,
                        57
                    ],
                    [
                        12,
                        58
                    ],
                    [
                        12,
                        61
                    ],
                    [
                        12,
                        256
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        12,
                        48
                    ],
                    [
                        12,
                        49
                    ],
                    [
                        12,
                        62
                    ],
                    [
                        12,
                        63
                    ],
                    [
                        12,
                        30
                    ],
                    [
                        12,
                        31
                    ],
                    [
                        12,
                        32
                    ],
                    [
                        12,
                        33
                    ],
                    [
                        12,
                        40
                    ],
                    [
                        12,
                        41
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        12,
                        128
                    ],
                    [
                        12,
                        192
                    ],
                    [
                        12,
                        26
                    ],
                    [
                        12,
                        27
                    ],
                    [
                        12,
                        28
                    ],
                    [
                        12,
                        29
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        12,
                        34
                    ],
                    [
                        12,
                        35
                    ],
                    [
                        12,
                        36
                    ],
                    [
                        12,
                        37
                    ],
                    [
                        12,
                        38
                    ],
                    [
                        12,
                        39
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        12,
                        42
                    ],
                    [
                        12,
                        43
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ]
                ], h = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        6,
                        9
                    ],
                    [
                        6,
                        8
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ]
                ];
                t.CCITTFaxDecoder = class CCITTFaxDecoder {
                    constructor(e1, t = {}){
                        if (!e1 || "function" != typeof e1.next) throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                        this.source = e1;
                        this.eof = !1;
                        this.encoding = t.K || 0;
                        this.eoline = t.EndOfLine || !1;
                        this.byteAlign = t.EncodedByteAlign || !1;
                        this.columns = t.Columns || 1728;
                        this.rows = t.Rows || 0;
                        this.eoblock = t.EndOfBlock ?? !0;
                        this.black = t.BlackIs1 || !1;
                        this.codingLine = new Uint32Array(this.columns + 1);
                        this.refLine = new Uint32Array(this.columns + 2);
                        this.codingLine[0] = this.columns;
                        this.codingPos = 0;
                        this.row = 0;
                        this.nextLine2D = this.encoding < 0;
                        this.inputBits = 0;
                        this.inputBuf = 0;
                        this.outputBits = 0;
                        this.rowsDone = !1;
                        let a;
                        for(; 0 === (a = this._lookBits(12));)this._eatBits(1);
                        1 === a && this._eatBits(12);
                        if (this.encoding > 0) {
                            this.nextLine2D = !this._lookBits(1);
                            this._eatBits(1);
                        }
                    }
                    readNextChar() {
                        if (this.eof) return -1;
                        const e1 = this.refLine, t = this.codingLine, a = this.columns;
                        let i, s, o, c, l;
                        if (0 === this.outputBits) {
                            this.rowsDone && (this.eof = !0);
                            if (this.eof) return -1;
                            this.err = !1;
                            let o, l, h;
                            if (this.nextLine2D) {
                                for(c = 0; t[c] < a; ++c)e1[c] = t[c];
                                e1[c++] = a;
                                e1[c] = a;
                                t[0] = 0;
                                this.codingPos = 0;
                                i = 0;
                                s = 0;
                                for(; t[this.codingPos] < a;){
                                    o = this._getTwoDimCode();
                                    switch(o){
                                        case 0:
                                            this._addPixels(e1[i + 1], s);
                                            e1[i + 1] < a && (i += 2);
                                            break;
                                        case 1:
                                            o = l = 0;
                                            if (s) {
                                                do o += h = this._getBlackCode();
                                                while (h >= 64);
                                                do l += h = this._getWhiteCode();
                                                while (h >= 64);
                                            } else {
                                                do o += h = this._getWhiteCode();
                                                while (h >= 64);
                                                do l += h = this._getBlackCode();
                                                while (h >= 64);
                                            }
                                            this._addPixels(t[this.codingPos] + o, s);
                                            t[this.codingPos] < a && this._addPixels(t[this.codingPos] + l, 1 ^ s);
                                            for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            break;
                                        case 7:
                                            this._addPixels(e1[i] + 3, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 5:
                                            this._addPixels(e1[i] + 2, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 3:
                                            this._addPixels(e1[i] + 1, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 2:
                                            this._addPixels(e1[i], s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 8:
                                            this._addPixelsNeg(e1[i] - 3, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                i > 0 ? --i : ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 6:
                                            this._addPixelsNeg(e1[i] - 2, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                i > 0 ? --i : ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case 4:
                                            this._addPixelsNeg(e1[i] - 1, s);
                                            s ^= 1;
                                            if (t[this.codingPos] < a) {
                                                i > 0 ? --i : ++i;
                                                for(; e1[i] <= t[this.codingPos] && e1[i] < a;)i += 2;
                                            }
                                            break;
                                        case n:
                                            this._addPixels(a, 0);
                                            this.eof = !0;
                                            break;
                                        default:
                                            (0, r.info)("bad 2d code");
                                            this._addPixels(a, 0);
                                            this.err = !0;
                                    }
                                }
                            } else {
                                t[0] = 0;
                                this.codingPos = 0;
                                s = 0;
                                for(; t[this.codingPos] < a;){
                                    o = 0;
                                    if (s) do o += h = this._getBlackCode();
                                    while (h >= 64);
                                    else do o += h = this._getWhiteCode();
                                    while (h >= 64);
                                    this._addPixels(t[this.codingPos] + o, s);
                                    s ^= 1;
                                }
                            }
                            let u = !1;
                            this.byteAlign && (this.inputBits &= -8);
                            if (this.eoblock || this.row !== this.rows - 1) {
                                o = this._lookBits(12);
                                if (this.eoline) for(; o !== n && 1 !== o;){
                                    this._eatBits(1);
                                    o = this._lookBits(12);
                                }
                                else for(; 0 === o;){
                                    this._eatBits(1);
                                    o = this._lookBits(12);
                                }
                                if (1 === o) {
                                    this._eatBits(12);
                                    u = !0;
                                } else o === n && (this.eof = !0);
                            } else this.rowsDone = !0;
                            if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                                this.nextLine2D = !this._lookBits(1);
                                this._eatBits(1);
                            }
                            if (this.eoblock && u && this.byteAlign) {
                                o = this._lookBits(12);
                                if (1 === o) {
                                    this._eatBits(12);
                                    if (this.encoding > 0) {
                                        this._lookBits(1);
                                        this._eatBits(1);
                                    }
                                    if (this.encoding >= 0) for(c = 0; c < 4; ++c){
                                        o = this._lookBits(12);
                                        1 !== o && (0, r.info)("bad rtc code: " + o);
                                        this._eatBits(12);
                                        if (this.encoding > 0) {
                                            this._lookBits(1);
                                            this._eatBits(1);
                                        }
                                    }
                                    this.eof = !0;
                                }
                            } else if (this.err && this.eoline) {
                                for(;;){
                                    o = this._lookBits(13);
                                    if (o === n) {
                                        this.eof = !0;
                                        return -1;
                                    }
                                    if (o >> 1 == 1) break;
                                    this._eatBits(1);
                                }
                                this._eatBits(12);
                                if (this.encoding > 0) {
                                    this._eatBits(1);
                                    this.nextLine2D = !(1 & o);
                                }
                            }
                            this.outputBits = t[0] > 0 ? t[this.codingPos = 0] : t[this.codingPos = 1];
                            this.row++;
                        }
                        if (this.outputBits >= 8) {
                            l = 1 & this.codingPos ? 0 : 255;
                            this.outputBits -= 8;
                            if (0 === this.outputBits && t[this.codingPos] < a) {
                                this.codingPos++;
                                this.outputBits = t[this.codingPos] - t[this.codingPos - 1];
                            }
                        } else {
                            o = 8;
                            l = 0;
                            do {
                                if ("number" != typeof this.outputBits) throw new r.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                                if (this.outputBits > o) {
                                    l <<= o;
                                    1 & this.codingPos || (l |= 255 >> 8 - o);
                                    this.outputBits -= o;
                                    o = 0;
                                } else {
                                    l <<= this.outputBits;
                                    1 & this.codingPos || (l |= 255 >> 8 - this.outputBits);
                                    o -= this.outputBits;
                                    this.outputBits = 0;
                                    if (t[this.codingPos] < a) {
                                        this.codingPos++;
                                        this.outputBits = t[this.codingPos] - t[this.codingPos - 1];
                                    } else if (o > 0) {
                                        l <<= o;
                                        o = 0;
                                    }
                                }
                            }while (o);
                        }
                        this.black && (l ^= 255);
                        return l;
                    }
                    _addPixels(e1, t) {
                        const a = this.codingLine;
                        let n = this.codingPos;
                        if (e1 > a[n]) {
                            if (e1 > this.columns) {
                                (0, r.info)("row is wrong length");
                                this.err = !0;
                                e1 = this.columns;
                            }
                            1 & n ^ t && ++n;
                            a[n] = e1;
                        }
                        this.codingPos = n;
                    }
                    _addPixelsNeg(e1, t) {
                        const a = this.codingLine;
                        let n = this.codingPos;
                        if (e1 > a[n]) {
                            if (e1 > this.columns) {
                                (0, r.info)("row is wrong length");
                                this.err = !0;
                                e1 = this.columns;
                            }
                            1 & n ^ t && ++n;
                            a[n] = e1;
                        } else if (e1 < a[n]) {
                            if (e1 < 0) {
                                (0, r.info)("invalid code");
                                this.err = !0;
                                e1 = 0;
                            }
                            for(; n > 0 && e1 < a[n - 1];)--n;
                            a[n] = e1;
                        }
                        this.codingPos = n;
                    }
                    _findTableCode(e1, t, a, r) {
                        const i = r || 0;
                        for(let r = e1; r <= t; ++r){
                            let e1 = this._lookBits(r);
                            if (e1 === n) return [
                                !0,
                                1,
                                !1
                            ];
                            r < t && (e1 <<= t - r);
                            if (!i || e1 >= i) {
                                const t = a[e1 - i];
                                if (t[0] === r) {
                                    this._eatBits(r);
                                    return [
                                        !0,
                                        t[1],
                                        !0
                                    ];
                                }
                            }
                        }
                        return [
                            !1,
                            0,
                            !1
                        ];
                    }
                    _getTwoDimCode() {
                        let e1, t = 0;
                        if (this.eoblock) {
                            t = this._lookBits(7);
                            e1 = i[t];
                            if (e1?.[0] > 0) {
                                this._eatBits(e1[0]);
                                return e1[1];
                            }
                        } else {
                            const e1 = this._findTableCode(1, 7, i);
                            if (e1[0] && e1[2]) return e1[1];
                        }
                        (0, r.info)("Bad two dim code");
                        return n;
                    }
                    _getWhiteCode() {
                        let e1, t = 0;
                        if (this.eoblock) {
                            t = this._lookBits(12);
                            if (t === n) return 1;
                            e1 = t >> 5 == 0 ? s[t] : o[t >> 3];
                            if (e1[0] > 0) {
                                this._eatBits(e1[0]);
                                return e1[1];
                            }
                        } else {
                            let e1 = this._findTableCode(1, 9, o);
                            if (e1[0]) return e1[1];
                            e1 = this._findTableCode(11, 12, s);
                            if (e1[0]) return e1[1];
                        }
                        (0, r.info)("bad white code");
                        this._eatBits(1);
                        return 1;
                    }
                    _getBlackCode() {
                        let e1, t;
                        if (this.eoblock) {
                            e1 = this._lookBits(13);
                            if (e1 === n) return 1;
                            t = e1 >> 7 == 0 ? c[e1] : e1 >> 9 == 0 && e1 >> 7 != 0 ? l[(e1 >> 1) - 64] : h[e1 >> 7];
                            if (t[0] > 0) {
                                this._eatBits(t[0]);
                                return t[1];
                            }
                        } else {
                            let e1 = this._findTableCode(2, 6, h);
                            if (e1[0]) return e1[1];
                            e1 = this._findTableCode(7, 12, l, 64);
                            if (e1[0]) return e1[1];
                            e1 = this._findTableCode(10, 13, c);
                            if (e1[0]) return e1[1];
                        }
                        (0, r.info)("bad black code");
                        this._eatBits(1);
                        return 1;
                    }
                    _lookBits(e1) {
                        let t;
                        for(; this.inputBits < e1;){
                            if (-1 === (t = this.source.next())) return 0 === this.inputBits ? n : this.inputBuf << e1 - this.inputBits & 65535 >> 16 - e1;
                            this.inputBuf = this.inputBuf << 8 | t;
                            this.inputBits += 8;
                        }
                        return this.inputBuf >> this.inputBits - e1 & 65535 >> 16 - e1;
                    }
                    _eatBits(e1) {
                        (this.inputBits -= e1) < 0 && (this.inputBits = 0);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.FlateStream = void 0;
                var r = a(18), n = a(2);
                const i = new Int32Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]), s = new Int32Array([
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    65547,
                    65549,
                    65551,
                    65553,
                    131091,
                    131095,
                    131099,
                    131103,
                    196643,
                    196651,
                    196659,
                    196667,
                    262211,
                    262227,
                    262243,
                    262259,
                    327811,
                    327843,
                    327875,
                    327907,
                    258,
                    258,
                    258
                ]), o = new Int32Array([
                    1,
                    2,
                    3,
                    4,
                    65541,
                    65543,
                    131081,
                    131085,
                    196625,
                    196633,
                    262177,
                    262193,
                    327745,
                    327777,
                    393345,
                    393409,
                    459009,
                    459137,
                    524801,
                    525057,
                    590849,
                    591361,
                    657409,
                    658433,
                    724993,
                    727041,
                    794625,
                    798721,
                    868353,
                    876545
                ]), c = [
                    new Int32Array([
                        459008,
                        524368,
                        524304,
                        524568,
                        459024,
                        524400,
                        524336,
                        590016,
                        459016,
                        524384,
                        524320,
                        589984,
                        524288,
                        524416,
                        524352,
                        590048,
                        459012,
                        524376,
                        524312,
                        589968,
                        459028,
                        524408,
                        524344,
                        590032,
                        459020,
                        524392,
                        524328,
                        59e4,
                        524296,
                        524424,
                        524360,
                        590064,
                        459010,
                        524372,
                        524308,
                        524572,
                        459026,
                        524404,
                        524340,
                        590024,
                        459018,
                        524388,
                        524324,
                        589992,
                        524292,
                        524420,
                        524356,
                        590056,
                        459014,
                        524380,
                        524316,
                        589976,
                        459030,
                        524412,
                        524348,
                        590040,
                        459022,
                        524396,
                        524332,
                        590008,
                        524300,
                        524428,
                        524364,
                        590072,
                        459009,
                        524370,
                        524306,
                        524570,
                        459025,
                        524402,
                        524338,
                        590020,
                        459017,
                        524386,
                        524322,
                        589988,
                        524290,
                        524418,
                        524354,
                        590052,
                        459013,
                        524378,
                        524314,
                        589972,
                        459029,
                        524410,
                        524346,
                        590036,
                        459021,
                        524394,
                        524330,
                        590004,
                        524298,
                        524426,
                        524362,
                        590068,
                        459011,
                        524374,
                        524310,
                        524574,
                        459027,
                        524406,
                        524342,
                        590028,
                        459019,
                        524390,
                        524326,
                        589996,
                        524294,
                        524422,
                        524358,
                        590060,
                        459015,
                        524382,
                        524318,
                        589980,
                        459031,
                        524414,
                        524350,
                        590044,
                        459023,
                        524398,
                        524334,
                        590012,
                        524302,
                        524430,
                        524366,
                        590076,
                        459008,
                        524369,
                        524305,
                        524569,
                        459024,
                        524401,
                        524337,
                        590018,
                        459016,
                        524385,
                        524321,
                        589986,
                        524289,
                        524417,
                        524353,
                        590050,
                        459012,
                        524377,
                        524313,
                        589970,
                        459028,
                        524409,
                        524345,
                        590034,
                        459020,
                        524393,
                        524329,
                        590002,
                        524297,
                        524425,
                        524361,
                        590066,
                        459010,
                        524373,
                        524309,
                        524573,
                        459026,
                        524405,
                        524341,
                        590026,
                        459018,
                        524389,
                        524325,
                        589994,
                        524293,
                        524421,
                        524357,
                        590058,
                        459014,
                        524381,
                        524317,
                        589978,
                        459030,
                        524413,
                        524349,
                        590042,
                        459022,
                        524397,
                        524333,
                        590010,
                        524301,
                        524429,
                        524365,
                        590074,
                        459009,
                        524371,
                        524307,
                        524571,
                        459025,
                        524403,
                        524339,
                        590022,
                        459017,
                        524387,
                        524323,
                        589990,
                        524291,
                        524419,
                        524355,
                        590054,
                        459013,
                        524379,
                        524315,
                        589974,
                        459029,
                        524411,
                        524347,
                        590038,
                        459021,
                        524395,
                        524331,
                        590006,
                        524299,
                        524427,
                        524363,
                        590070,
                        459011,
                        524375,
                        524311,
                        524575,
                        459027,
                        524407,
                        524343,
                        590030,
                        459019,
                        524391,
                        524327,
                        589998,
                        524295,
                        524423,
                        524359,
                        590062,
                        459015,
                        524383,
                        524319,
                        589982,
                        459031,
                        524415,
                        524351,
                        590046,
                        459023,
                        524399,
                        524335,
                        590014,
                        524303,
                        524431,
                        524367,
                        590078,
                        459008,
                        524368,
                        524304,
                        524568,
                        459024,
                        524400,
                        524336,
                        590017,
                        459016,
                        524384,
                        524320,
                        589985,
                        524288,
                        524416,
                        524352,
                        590049,
                        459012,
                        524376,
                        524312,
                        589969,
                        459028,
                        524408,
                        524344,
                        590033,
                        459020,
                        524392,
                        524328,
                        590001,
                        524296,
                        524424,
                        524360,
                        590065,
                        459010,
                        524372,
                        524308,
                        524572,
                        459026,
                        524404,
                        524340,
                        590025,
                        459018,
                        524388,
                        524324,
                        589993,
                        524292,
                        524420,
                        524356,
                        590057,
                        459014,
                        524380,
                        524316,
                        589977,
                        459030,
                        524412,
                        524348,
                        590041,
                        459022,
                        524396,
                        524332,
                        590009,
                        524300,
                        524428,
                        524364,
                        590073,
                        459009,
                        524370,
                        524306,
                        524570,
                        459025,
                        524402,
                        524338,
                        590021,
                        459017,
                        524386,
                        524322,
                        589989,
                        524290,
                        524418,
                        524354,
                        590053,
                        459013,
                        524378,
                        524314,
                        589973,
                        459029,
                        524410,
                        524346,
                        590037,
                        459021,
                        524394,
                        524330,
                        590005,
                        524298,
                        524426,
                        524362,
                        590069,
                        459011,
                        524374,
                        524310,
                        524574,
                        459027,
                        524406,
                        524342,
                        590029,
                        459019,
                        524390,
                        524326,
                        589997,
                        524294,
                        524422,
                        524358,
                        590061,
                        459015,
                        524382,
                        524318,
                        589981,
                        459031,
                        524414,
                        524350,
                        590045,
                        459023,
                        524398,
                        524334,
                        590013,
                        524302,
                        524430,
                        524366,
                        590077,
                        459008,
                        524369,
                        524305,
                        524569,
                        459024,
                        524401,
                        524337,
                        590019,
                        459016,
                        524385,
                        524321,
                        589987,
                        524289,
                        524417,
                        524353,
                        590051,
                        459012,
                        524377,
                        524313,
                        589971,
                        459028,
                        524409,
                        524345,
                        590035,
                        459020,
                        524393,
                        524329,
                        590003,
                        524297,
                        524425,
                        524361,
                        590067,
                        459010,
                        524373,
                        524309,
                        524573,
                        459026,
                        524405,
                        524341,
                        590027,
                        459018,
                        524389,
                        524325,
                        589995,
                        524293,
                        524421,
                        524357,
                        590059,
                        459014,
                        524381,
                        524317,
                        589979,
                        459030,
                        524413,
                        524349,
                        590043,
                        459022,
                        524397,
                        524333,
                        590011,
                        524301,
                        524429,
                        524365,
                        590075,
                        459009,
                        524371,
                        524307,
                        524571,
                        459025,
                        524403,
                        524339,
                        590023,
                        459017,
                        524387,
                        524323,
                        589991,
                        524291,
                        524419,
                        524355,
                        590055,
                        459013,
                        524379,
                        524315,
                        589975,
                        459029,
                        524411,
                        524347,
                        590039,
                        459021,
                        524395,
                        524331,
                        590007,
                        524299,
                        524427,
                        524363,
                        590071,
                        459011,
                        524375,
                        524311,
                        524575,
                        459027,
                        524407,
                        524343,
                        590031,
                        459019,
                        524391,
                        524327,
                        589999,
                        524295,
                        524423,
                        524359,
                        590063,
                        459015,
                        524383,
                        524319,
                        589983,
                        459031,
                        524415,
                        524351,
                        590047,
                        459023,
                        524399,
                        524335,
                        590015,
                        524303,
                        524431,
                        524367,
                        590079
                    ]),
                    9
                ], l = [
                    new Int32Array([
                        327680,
                        327696,
                        327688,
                        327704,
                        327684,
                        327700,
                        327692,
                        327708,
                        327682,
                        327698,
                        327690,
                        327706,
                        327686,
                        327702,
                        327694,
                        0,
                        327681,
                        327697,
                        327689,
                        327705,
                        327685,
                        327701,
                        327693,
                        327709,
                        327683,
                        327699,
                        327691,
                        327707,
                        327687,
                        327703,
                        327695,
                        0
                    ]),
                    5
                ];
                class FlateStream extends r.DecodeStream {
                    constructor(e1, t){
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        const a = e1.getByte(), r = e1.getByte();
                        if (-1 === a || -1 === r) throw new n.FormatError(`Invalid header in flate stream: ${a}, ${r}`);
                        if (8 != (15 & a)) throw new n.FormatError(`Unknown compression method in flate stream: ${a}, ${r}`);
                        if (((a << 8) + r) % 31 != 0) throw new n.FormatError(`Bad FCHECK in flate stream: ${a}, ${r}`);
                        if (32 & r) throw new n.FormatError(`FDICT bit set in flate stream: ${a}, ${r}`);
                        this.codeSize = 0;
                        this.codeBuf = 0;
                    }
                    getBits(e1) {
                        const t = this.str;
                        let a, r = this.codeSize, i = this.codeBuf;
                        for(; r < e1;){
                            if (-1 === (a = t.getByte())) throw new n.FormatError("Bad encoding in flate stream");
                            i |= a << r;
                            r += 8;
                        }
                        a = i & (1 << e1) - 1;
                        this.codeBuf = i >> e1;
                        this.codeSize = r -= e1;
                        return a;
                    }
                    getCode(e1) {
                        const t = this.str, a = e1[0], r = e1[1];
                        let i, s = this.codeSize, o = this.codeBuf;
                        for(; s < r && -1 !== (i = t.getByte());){
                            o |= i << s;
                            s += 8;
                        }
                        const c = a[o & (1 << r) - 1], l = c >> 16, h = 65535 & c;
                        if (l < 1 || s < l) throw new n.FormatError("Bad encoding in flate stream");
                        this.codeBuf = o >> l;
                        this.codeSize = s - l;
                        return h;
                    }
                    generateHuffmanTable(e1) {
                        const t = e1.length;
                        let a, r = 0;
                        for(a = 0; a < t; ++a)e1[a] > r && (r = e1[a]);
                        const n = 1 << r, i = new Int32Array(n);
                        for(let s = 1, o = 0, c = 2; s <= r; ++s, o <<= 1, c <<= 1)for(let r = 0; r < t; ++r)if (e1[r] === s) {
                            let e1 = 0, t = o;
                            for(a = 0; a < s; ++a){
                                e1 = e1 << 1 | 1 & t;
                                t >>= 1;
                            }
                            for(a = e1; a < n; a += c)i[a] = s << 16 | r;
                            ++o;
                        }
                        return [
                            i,
                            r
                        ];
                    }
                    readBlock() {
                        let e1, t;
                        const a = this.str;
                        let r, h, u = this.getBits(3);
                        1 & u && (this.eof = !0);
                        u >>= 1;
                        if (0 === u) {
                            let t;
                            if (-1 === (t = a.getByte())) throw new n.FormatError("Bad block header in flate stream");
                            let r = t;
                            if (-1 === (t = a.getByte())) throw new n.FormatError("Bad block header in flate stream");
                            r |= t << 8;
                            if (-1 === (t = a.getByte())) throw new n.FormatError("Bad block header in flate stream");
                            let i = t;
                            if (-1 === (t = a.getByte())) throw new n.FormatError("Bad block header in flate stream");
                            i |= t << 8;
                            if (i !== (65535 & ~r) && (0 !== r || 0 !== i)) throw new n.FormatError("Bad uncompressed block length in flate stream");
                            this.codeBuf = 0;
                            this.codeSize = 0;
                            const s = this.bufferLength, o = s + r;
                            e1 = this.ensureBuffer(o);
                            this.bufferLength = o;
                            if (0 === r) -1 === a.peekByte() && (this.eof = !0);
                            else {
                                const t = a.getBytes(r);
                                e1.set(t, s);
                                t.length < r && (this.eof = !0);
                            }
                            return;
                        }
                        if (1 === u) {
                            r = c;
                            h = l;
                        } else {
                            if (2 !== u) throw new n.FormatError("Unknown block type in flate stream");
                            {
                                const e1 = this.getBits(5) + 257, a = this.getBits(5) + 1, n = this.getBits(4) + 4, s = new Uint8Array(i.length);
                                let o;
                                for(o = 0; o < n; ++o)s[i[o]] = this.getBits(3);
                                const c = this.generateHuffmanTable(s);
                                t = 0;
                                o = 0;
                                const l = e1 + a, u = new Uint8Array(l);
                                let d, f, g;
                                for(; o < l;){
                                    const e1 = this.getCode(c);
                                    if (16 === e1) {
                                        d = 2;
                                        f = 3;
                                        g = t;
                                    } else if (17 === e1) {
                                        d = 3;
                                        f = 3;
                                        g = t = 0;
                                    } else {
                                        if (18 !== e1) {
                                            u[o++] = t = e1;
                                            continue;
                                        }
                                        d = 7;
                                        f = 11;
                                        g = t = 0;
                                    }
                                    let a = this.getBits(d) + f;
                                    for(; a-- > 0;)u[o++] = g;
                                }
                                r = this.generateHuffmanTable(u.subarray(0, e1));
                                h = this.generateHuffmanTable(u.subarray(e1, l));
                            }
                        }
                        e1 = this.buffer;
                        let d = e1 ? e1.length : 0, f = this.bufferLength;
                        for(;;){
                            let a = this.getCode(r);
                            if (a < 256) {
                                if (f + 1 >= d) {
                                    e1 = this.ensureBuffer(f + 1);
                                    d = e1.length;
                                }
                                e1[f++] = a;
                                continue;
                            }
                            if (256 === a) {
                                this.bufferLength = f;
                                return;
                            }
                            a -= 257;
                            a = s[a];
                            let n = a >> 16;
                            n > 0 && (n = this.getBits(n));
                            t = (65535 & a) + n;
                            a = this.getCode(h);
                            a = o[a];
                            n = a >> 16;
                            n > 0 && (n = this.getBits(n));
                            const i = (65535 & a) + n;
                            if (f + t >= d) {
                                e1 = this.ensureBuffer(f + t);
                                d = e1.length;
                            }
                            for(let a = 0; a < t; ++a, ++f)e1[f] = e1[f - i];
                        }
                    }
                }
                t.FlateStream = FlateStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Jbig2Stream = void 0;
                var r = a(5), n = a(18), i = a(4), s = a(24), o = a(2);
                class Jbig2Stream extends n.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        this.stream = e1;
                        this.dict = e1.dict;
                        this.maybeLength = t;
                        this.params = a;
                    }
                    get bytes() {
                        return (0, o.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(e1) {}
                    readBlock() {
                        if (this.eof) return;
                        const e1 = new s.Jbig2Image, t = [];
                        if (this.params instanceof i.Dict) {
                            const e1 = this.params.get("JBIG2Globals");
                            if (e1 instanceof r.BaseStream) {
                                const a = e1.getBytes();
                                t.push({
                                    data: a,
                                    start: 0,
                                    end: a.length
                                });
                            }
                        }
                        t.push({
                            data: this.bytes,
                            start: 0,
                            end: this.bytes.length
                        });
                        const a = e1.parseChunks(t), n = a.length;
                        for(let e1 = 0; e1 < n; e1++)a[e1] ^= 255;
                        this.buffer = a;
                        this.bufferLength = n;
                        this.eof = !0;
                    }
                }
                t.Jbig2Stream = Jbig2Stream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Jbig2Image = void 0;
                var r = a(2), n = a(3), i = a(25), s = a(21);
                class Jbig2Error extends r.BaseException {
                    constructor(e1){
                        super(`JBIG2 error: ${e1}`, "Jbig2Error");
                    }
                }
                class ContextCache {
                    getContexts(e1) {
                        return e1 in this ? this[e1] : this[e1] = new Int8Array(65536);
                    }
                }
                class DecodingContext {
                    constructor(e1, t, a){
                        this.data = e1;
                        this.start = t;
                        this.end = a;
                    }
                    get decoder() {
                        const e1 = new i.ArithmeticDecoder(this.data, this.start, this.end);
                        return (0, r.shadow)(this, "decoder", e1);
                    }
                    get contextCache() {
                        const e1 = new ContextCache;
                        return (0, r.shadow)(this, "contextCache", e1);
                    }
                }
                const o = 2 ** 31 - 1, c = -(2 ** 31);
                function decodeInteger(e1, t, a) {
                    const r = e1.getContexts(t);
                    let n = 1;
                    function readBits(e1) {
                        let t = 0;
                        for(let i = 0; i < e1; i++){
                            const e1 = a.readBit(r, n);
                            n = n < 256 ? n << 1 | e1 : 511 & (n << 1 | e1) | 256;
                            t = t << 1 | e1;
                        }
                        return t >>> 0;
                    }
                    const i = readBits(1), s = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
                    let l;
                    0 === i ? l = s : s > 0 && (l = -s);
                    return l >= c && l <= o ? l : null;
                }
                function decodeIAID(e1, t, a) {
                    const r = e1.getContexts("IAID");
                    let n = 1;
                    for(let e1 = 0; e1 < a; e1++)n = n << 1 | t.readBit(r, n);
                    return a < 31 ? n & (1 << a) - 1 : 2147483647 & n;
                }
                const l = [
                    "SymbolDictionary",
                    null,
                    null,
                    null,
                    "IntermediateTextRegion",
                    null,
                    "ImmediateTextRegion",
                    "ImmediateLosslessTextRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "PatternDictionary",
                    null,
                    null,
                    null,
                    "IntermediateHalftoneRegion",
                    null,
                    "ImmediateHalftoneRegion",
                    "ImmediateLosslessHalftoneRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "IntermediateGenericRegion",
                    null,
                    "ImmediateGenericRegion",
                    "ImmediateLosslessGenericRegion",
                    "IntermediateGenericRefinementRegion",
                    null,
                    "ImmediateGenericRefinementRegion",
                    "ImmediateLosslessGenericRefinementRegion",
                    null,
                    null,
                    null,
                    null,
                    "PageInformation",
                    "EndOfPage",
                    "EndOfStripe",
                    "EndOfFile",
                    "Profiles",
                    "Tables",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "Extension"
                ], h = [
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: 2,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -3,
                            y: -1
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ]
                ], u = [
                    {
                        coding: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: -1,
                                y: 1
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    },
                    {
                        coding: [
                            {
                                x: -1,
                                y: -1
                            },
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    }
                ], d = [
                    39717,
                    1941,
                    229,
                    405
                ], f = [
                    32,
                    8
                ];
                function decodeBitmap(e1, t, a, r, n, i, s, o) {
                    if (e1) return decodeMMRBitmap(new Reader(o.data, o.start, o.end), t, a, !1);
                    if (0 === r && !i && !n && 4 === s.length && 3 === s[0].x && -1 === s[0].y && -3 === s[1].x && -1 === s[1].y && 2 === s[2].x && -2 === s[2].y && -2 === s[3].x && -2 === s[3].y) return function decodeBitmapTemplate0(e1, t, a) {
                        const r = a.decoder, n = a.contextCache.getContexts("GB"), i = [];
                        let s, o, c, l, h, u, d;
                        for(o = 0; o < t; o++){
                            h = i[o] = new Uint8Array(e1);
                            u = o < 1 ? h : i[o - 1];
                            d = o < 2 ? h : i[o - 2];
                            s = d[0] << 13 | d[1] << 12 | d[2] << 11 | u[0] << 7 | u[1] << 6 | u[2] << 5 | u[3] << 4;
                            for(c = 0; c < e1; c++){
                                h[c] = l = r.readBit(n, s);
                                s = (31735 & s) << 1 | (c + 3 < e1 ? d[c + 3] << 11 : 0) | (c + 4 < e1 ? u[c + 4] << 4 : 0) | l;
                            }
                        }
                        return i;
                    }(t, a, o);
                    const c = !!i, l = h[r].concat(s);
                    l.sort(function(e1, t) {
                        return e1.y - t.y || e1.x - t.x;
                    });
                    const u = l.length, f = new Int8Array(u), g = new Int8Array(u), p = [];
                    let m, b, y = 0, w = 0, S = 0, x = 0;
                    for(b = 0; b < u; b++){
                        f[b] = l[b].x;
                        g[b] = l[b].y;
                        w = Math.min(w, l[b].x);
                        S = Math.max(S, l[b].x);
                        x = Math.min(x, l[b].y);
                        b < u - 1 && l[b].y === l[b + 1].y && l[b].x === l[b + 1].x - 1 ? y |= 1 << u - 1 - b : p.push(b);
                    }
                    const C = p.length, k = new Int8Array(C), v = new Int8Array(C), F = new Uint16Array(C);
                    for(m = 0; m < C; m++){
                        b = p[m];
                        k[m] = l[b].x;
                        v[m] = l[b].y;
                        F[m] = 1 << u - 1 - b;
                    }
                    const O = -w, T = -x, M = t - S, D = d[r];
                    let E = new Uint8Array(t);
                    const N = [], R = o.decoder, L = o.contextCache.getContexts("GB");
                    let $, _, j, U, X, H = 0, q = 0;
                    for(let e1 = 0; e1 < a; e1++){
                        if (n) {
                            H ^= R.readBit(L, D);
                            if (H) {
                                N.push(E);
                                continue;
                            }
                        }
                        E = new Uint8Array(E);
                        N.push(E);
                        for($ = 0; $ < t; $++){
                            if (c && i[e1][$]) {
                                E[$] = 0;
                                continue;
                            }
                            if ($ >= O && $ < M && e1 >= T) {
                                q = q << 1 & y;
                                for(b = 0; b < C; b++){
                                    _ = e1 + v[b];
                                    j = $ + k[b];
                                    U = N[_][j];
                                    if (U) {
                                        U = F[b];
                                        q |= U;
                                    }
                                }
                            } else {
                                q = 0;
                                X = u - 1;
                                for(b = 0; b < u; b++, X--){
                                    j = $ + f[b];
                                    if (j >= 0 && j < t) {
                                        _ = e1 + g[b];
                                        if (_ >= 0) {
                                            U = N[_][j];
                                            U && (q |= U << X);
                                        }
                                    }
                                }
                            }
                            const a = R.readBit(L, q);
                            E[$] = a;
                        }
                    }
                    return N;
                }
                function decodeRefinement(e1, t, a, r, n, i, s, o, c) {
                    let l = u[a].coding;
                    0 === a && (l = l.concat([
                        o[0]
                    ]));
                    const h = l.length, d = new Int32Array(h), g = new Int32Array(h);
                    let p;
                    for(p = 0; p < h; p++){
                        d[p] = l[p].x;
                        g[p] = l[p].y;
                    }
                    let m = u[a].reference;
                    0 === a && (m = m.concat([
                        o[1]
                    ]));
                    const b = m.length, y = new Int32Array(b), w = new Int32Array(b);
                    for(p = 0; p < b; p++){
                        y[p] = m[p].x;
                        w[p] = m[p].y;
                    }
                    const S = r[0].length, x = r.length, C = f[a], k = [], v = c.decoder, F = c.contextCache.getContexts("GR");
                    let O = 0;
                    for(let a = 0; a < t; a++){
                        if (s) {
                            O ^= v.readBit(F, C);
                            if (O) throw new Jbig2Error("prediction is not supported");
                        }
                        const t = new Uint8Array(e1);
                        k.push(t);
                        for(let s = 0; s < e1; s++){
                            let o, c, l = 0;
                            for(p = 0; p < h; p++){
                                o = a + g[p];
                                c = s + d[p];
                                o < 0 || c < 0 || c >= e1 ? l <<= 1 : l = l << 1 | k[o][c];
                            }
                            for(p = 0; p < b; p++){
                                o = a + w[p] - i;
                                c = s + y[p] - n;
                                o < 0 || o >= x || c < 0 || c >= S ? l <<= 1 : l = l << 1 | r[o][c];
                            }
                            const u = v.readBit(F, l);
                            t[s] = u;
                        }
                    }
                    return k;
                }
                function decodeTextRegion(e1, t, a, r, n, i, s, o, c, l, h, u, d, f, g, p, m, b, y) {
                    if (e1 && t) throw new Jbig2Error("refinement with Huffman is not supported");
                    const w = [];
                    let S, x;
                    for(S = 0; S < r; S++){
                        x = new Uint8Array(a);
                        if (n) for(let e1 = 0; e1 < a; e1++)x[e1] = n;
                        w.push(x);
                    }
                    const C = m.decoder, k = m.contextCache;
                    let v = e1 ? -f.tableDeltaT.decode(y) : -decodeInteger(k, "IADT", C), F = 0;
                    S = 0;
                    for(; S < i;){
                        v += e1 ? f.tableDeltaT.decode(y) : decodeInteger(k, "IADT", C);
                        F += e1 ? f.tableFirstS.decode(y) : decodeInteger(k, "IAFS", C);
                        let r = F;
                        for(;;){
                            let n = 0;
                            s > 1 && (n = e1 ? y.readBits(b) : decodeInteger(k, "IAIT", C));
                            const i = s * v + n, F = e1 ? f.symbolIDTable.decode(y) : decodeIAID(k, C, c), O = t && (e1 ? y.readBit() : decodeInteger(k, "IARI", C));
                            let T = o[F], M = T[0].length, D = T.length;
                            if (O) {
                                const e1 = decodeInteger(k, "IARDW", C), t = decodeInteger(k, "IARDH", C);
                                M += e1;
                                D += t;
                                T = decodeRefinement(M, D, g, T, (e1 >> 1) + decodeInteger(k, "IARDX", C), (t >> 1) + decodeInteger(k, "IARDY", C), !1, p, m);
                            }
                            const E = i - (1 & u ? 0 : D - 1), N = r - (2 & u ? M - 1 : 0);
                            let R, L, $;
                            if (l) {
                                for(R = 0; R < D; R++){
                                    x = w[N + R];
                                    if (!x) continue;
                                    $ = T[R];
                                    const e1 = Math.min(a - E, M);
                                    switch(d){
                                        case 0:
                                            for(L = 0; L < e1; L++)x[E + L] |= $[L];
                                            break;
                                        case 2:
                                            for(L = 0; L < e1; L++)x[E + L] ^= $[L];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${d} is not supported`);
                                    }
                                }
                                r += D - 1;
                            } else {
                                for(L = 0; L < D; L++){
                                    x = w[E + L];
                                    if (x) {
                                        $ = T[L];
                                        switch(d){
                                            case 0:
                                                for(R = 0; R < M; R++)x[N + R] |= $[R];
                                                break;
                                            case 2:
                                                for(R = 0; R < M; R++)x[N + R] ^= $[R];
                                                break;
                                            default:
                                                throw new Jbig2Error(`operator ${d} is not supported`);
                                        }
                                    }
                                }
                                r += M - 1;
                            }
                            S++;
                            const _ = e1 ? f.tableDeltaS.decode(y) : decodeInteger(k, "IADS", C);
                            if (null === _) break;
                            r += _ + h;
                        }
                    }
                    return w;
                }
                function readSegmentHeader(e1, t) {
                    const a = {};
                    a.number = (0, n.readUint32)(e1, t);
                    const r = e1[t + 4], i = 63 & r;
                    if (!l[i]) throw new Jbig2Error("invalid segment type: " + i);
                    a.type = i;
                    a.typeName = l[i];
                    a.deferredNonRetain = !!(128 & r);
                    const s = !!(64 & r), o = e1[t + 5];
                    let c = o >> 5 & 7;
                    const h = [
                        31 & o
                    ];
                    let u = t + 6;
                    if (7 === o) {
                        c = 536870911 & (0, n.readUint32)(e1, u - 1);
                        u += 3;
                        let t = c + 7 >> 3;
                        h[0] = e1[u++];
                        for(; --t > 0;)h.push(e1[u++]);
                    } else if (5 === o || 6 === o) throw new Jbig2Error("invalid referred-to flags");
                    a.retainBits = h;
                    let d = 4;
                    a.number <= 256 ? d = 1 : a.number <= 65536 && (d = 2);
                    const f = [];
                    let p, m;
                    for(p = 0; p < c; p++){
                        let t;
                        t = 1 === d ? e1[u] : 2 === d ? (0, n.readUint16)(e1, u) : (0, n.readUint32)(e1, u);
                        f.push(t);
                        u += d;
                    }
                    a.referredTo = f;
                    if (s) {
                        a.pageAssociation = (0, n.readUint32)(e1, u);
                        u += 4;
                    } else a.pageAssociation = e1[u++];
                    a.length = (0, n.readUint32)(e1, u);
                    u += 4;
                    if (4294967295 === a.length) {
                        if (38 !== i) throw new Jbig2Error("invalid unknown segment length");
                        {
                            const t = readRegionSegmentInformation(e1, u), r = !!(1 & e1[u + g]), n = 6, i = new Uint8Array(n);
                            if (!r) {
                                i[0] = 255;
                                i[1] = 172;
                            }
                            i[2] = t.height >>> 24 & 255;
                            i[3] = t.height >> 16 & 255;
                            i[4] = t.height >> 8 & 255;
                            i[5] = 255 & t.height;
                            for(p = u, m = e1.length; p < m; p++){
                                let t = 0;
                                for(; t < n && i[t] === e1[p + t];)t++;
                                if (t === n) {
                                    a.length = p + n;
                                    break;
                                }
                            }
                            if (4294967295 === a.length) throw new Jbig2Error("segment end was not found");
                        }
                    }
                    a.headerEnd = u;
                    return a;
                }
                function readSegments(e1, t, a, r) {
                    const n = [];
                    let i = a;
                    for(; i < r;){
                        const a = readSegmentHeader(t, i);
                        i = a.headerEnd;
                        const r = {
                            header: a,
                            data: t
                        };
                        if (!e1.randomAccess) {
                            r.start = i;
                            i += a.length;
                            r.end = i;
                        }
                        n.push(r);
                        if (51 === a.type) break;
                    }
                    if (e1.randomAccess) for(let e1 = 0, t = n.length; e1 < t; e1++){
                        n[e1].start = i;
                        i += n[e1].header.length;
                        n[e1].end = i;
                    }
                    return n;
                }
                function readRegionSegmentInformation(e1, t) {
                    return {
                        width: (0, n.readUint32)(e1, t),
                        height: (0, n.readUint32)(e1, t + 4),
                        x: (0, n.readUint32)(e1, t + 8),
                        y: (0, n.readUint32)(e1, t + 12),
                        combinationOperator: 7 & e1[t + 16]
                    };
                }
                const g = 17;
                function processSegment(e1, t) {
                    const a = e1.header, r = e1.data, i = e1.end;
                    let s, o, c, l, h = e1.start;
                    switch(a.type){
                        case 0:
                            const e2 = {}, t1 = (0, n.readUint16)(r, h);
                            e2.huffman = !!(1 & t1);
                            e2.refinement = !!(2 & t1);
                            e2.huffmanDHSelector = t1 >> 2 & 3;
                            e2.huffmanDWSelector = t1 >> 4 & 3;
                            e2.bitmapSizeSelector = t1 >> 6 & 1;
                            e2.aggregationInstancesSelector = t1 >> 7 & 1;
                            e2.bitmapCodingContextUsed = !!(256 & t1);
                            e2.bitmapCodingContextRetained = !!(512 & t1);
                            e2.template = t1 >> 10 & 3;
                            e2.refinementTemplate = t1 >> 12 & 1;
                            h += 2;
                            if (!e2.huffman) {
                                l = 0 === e2.template ? 4 : 1;
                                o = [];
                                for(c = 0; c < l; c++){
                                    o.push({
                                        x: (0, n.readInt8)(r, h),
                                        y: (0, n.readInt8)(r, h + 1)
                                    });
                                    h += 2;
                                }
                                e2.at = o;
                            }
                            if (e2.refinement && !e2.refinementTemplate) {
                                o = [];
                                for(c = 0; c < 2; c++){
                                    o.push({
                                        x: (0, n.readInt8)(r, h),
                                        y: (0, n.readInt8)(r, h + 1)
                                    });
                                    h += 2;
                                }
                                e2.refinementAt = o;
                            }
                            e2.numberOfExportedSymbols = (0, n.readUint32)(r, h);
                            h += 4;
                            e2.numberOfNewSymbols = (0, n.readUint32)(r, h);
                            h += 4;
                            s = [
                                e2,
                                a.number,
                                a.referredTo,
                                r,
                                h,
                                i
                            ];
                            break;
                        case 6:
                        case 7:
                            const u = {};
                            u.info = readRegionSegmentInformation(r, h);
                            h += g;
                            const d = (0, n.readUint16)(r, h);
                            h += 2;
                            u.huffman = !!(1 & d);
                            u.refinement = !!(2 & d);
                            u.logStripSize = d >> 2 & 3;
                            u.stripSize = 1 << u.logStripSize;
                            u.referenceCorner = d >> 4 & 3;
                            u.transposed = !!(64 & d);
                            u.combinationOperator = d >> 7 & 3;
                            u.defaultPixelValue = d >> 9 & 1;
                            u.dsOffset = d << 17 >> 27;
                            u.refinementTemplate = d >> 15 & 1;
                            if (u.huffman) {
                                const e1 = (0, n.readUint16)(r, h);
                                h += 2;
                                u.huffmanFS = 3 & e1;
                                u.huffmanDS = e1 >> 2 & 3;
                                u.huffmanDT = e1 >> 4 & 3;
                                u.huffmanRefinementDW = e1 >> 6 & 3;
                                u.huffmanRefinementDH = e1 >> 8 & 3;
                                u.huffmanRefinementDX = e1 >> 10 & 3;
                                u.huffmanRefinementDY = e1 >> 12 & 3;
                                u.huffmanRefinementSizeSelector = !!(16384 & e1);
                            }
                            if (u.refinement && !u.refinementTemplate) {
                                o = [];
                                for(c = 0; c < 2; c++){
                                    o.push({
                                        x: (0, n.readInt8)(r, h),
                                        y: (0, n.readInt8)(r, h + 1)
                                    });
                                    h += 2;
                                }
                                u.refinementAt = o;
                            }
                            u.numberOfSymbolInstances = (0, n.readUint32)(r, h);
                            h += 4;
                            s = [
                                u,
                                a.referredTo,
                                r,
                                h,
                                i
                            ];
                            break;
                        case 16:
                            const f = {}, p = r[h++];
                            f.mmr = !!(1 & p);
                            f.template = p >> 1 & 3;
                            f.patternWidth = r[h++];
                            f.patternHeight = r[h++];
                            f.maxPatternIndex = (0, n.readUint32)(r, h);
                            h += 4;
                            s = [
                                f,
                                a.number,
                                r,
                                h,
                                i
                            ];
                            break;
                        case 22:
                        case 23:
                            const m = {};
                            m.info = readRegionSegmentInformation(r, h);
                            h += g;
                            const b = r[h++];
                            m.mmr = !!(1 & b);
                            m.template = b >> 1 & 3;
                            m.enableSkip = !!(8 & b);
                            m.combinationOperator = b >> 4 & 7;
                            m.defaultPixelValue = b >> 7 & 1;
                            m.gridWidth = (0, n.readUint32)(r, h);
                            h += 4;
                            m.gridHeight = (0, n.readUint32)(r, h);
                            h += 4;
                            m.gridOffsetX = 4294967295 & (0, n.readUint32)(r, h);
                            h += 4;
                            m.gridOffsetY = 4294967295 & (0, n.readUint32)(r, h);
                            h += 4;
                            m.gridVectorX = (0, n.readUint16)(r, h);
                            h += 2;
                            m.gridVectorY = (0, n.readUint16)(r, h);
                            h += 2;
                            s = [
                                m,
                                a.referredTo,
                                r,
                                h,
                                i
                            ];
                            break;
                        case 38:
                        case 39:
                            const y = {};
                            y.info = readRegionSegmentInformation(r, h);
                            h += g;
                            const w = r[h++];
                            y.mmr = !!(1 & w);
                            y.template = w >> 1 & 3;
                            y.prediction = !!(8 & w);
                            if (!y.mmr) {
                                l = 0 === y.template ? 4 : 1;
                                o = [];
                                for(c = 0; c < l; c++){
                                    o.push({
                                        x: (0, n.readInt8)(r, h),
                                        y: (0, n.readInt8)(r, h + 1)
                                    });
                                    h += 2;
                                }
                                y.at = o;
                            }
                            s = [
                                y,
                                r,
                                h,
                                i
                            ];
                            break;
                        case 48:
                            const S = {
                                width: (0, n.readUint32)(r, h),
                                height: (0, n.readUint32)(r, h + 4),
                                resolutionX: (0, n.readUint32)(r, h + 8),
                                resolutionY: (0, n.readUint32)(r, h + 12)
                            };
                            4294967295 === S.height && delete S.height;
                            const x = r[h + 16];
                            (0, n.readUint16)(r, h + 17);
                            S.lossless = !!(1 & x);
                            S.refinement = !!(2 & x);
                            S.defaultPixelValue = x >> 2 & 1;
                            S.combinationOperator = x >> 3 & 3;
                            S.requiresBuffer = !!(32 & x);
                            S.combinationOperatorOverride = !!(64 & x);
                            s = [
                                S
                            ];
                            break;
                        case 49:
                        case 50:
                        case 51:
                        case 62:
                            break;
                        case 53:
                            s = [
                                a.number,
                                r,
                                h,
                                i
                            ];
                            break;
                        default:
                            throw new Jbig2Error(`segment type ${a.typeName}(${a.type}) is not implemented`);
                    }
                    const u1 = "on" + a.typeName;
                    u1 in t && t[u1].apply(t, s);
                }
                function processSegments(e1, t) {
                    for(let a = 0, r = e1.length; a < r; a++)processSegment(e1[a], t);
                }
                class SimpleSegmentVisitor {
                    onPageInformation(e1) {
                        this.currentPageInfo = e1;
                        const t = e1.width + 7 >> 3, a = new Uint8ClampedArray(t * e1.height);
                        e1.defaultPixelValue && a.fill(255);
                        this.buffer = a;
                    }
                    drawBitmap(e1, t) {
                        const a = this.currentPageInfo, r = e1.width, n = e1.height, i = a.width + 7 >> 3, s = a.combinationOperatorOverride ? e1.combinationOperator : a.combinationOperator, o = this.buffer, c = 128 >> (7 & e1.x);
                        let l, h, u, d, f = e1.y * i + (e1.x >> 3);
                        switch(s){
                            case 0:
                                for(l = 0; l < n; l++){
                                    u = c;
                                    d = f;
                                    for(h = 0; h < r; h++){
                                        t[l][h] && (o[d] |= u);
                                        u >>= 1;
                                        if (!u) {
                                            u = 128;
                                            d++;
                                        }
                                    }
                                    f += i;
                                }
                                break;
                            case 2:
                                for(l = 0; l < n; l++){
                                    u = c;
                                    d = f;
                                    for(h = 0; h < r; h++){
                                        t[l][h] && (o[d] ^= u);
                                        u >>= 1;
                                        if (!u) {
                                            u = 128;
                                            d++;
                                        }
                                    }
                                    f += i;
                                }
                                break;
                            default:
                                throw new Jbig2Error(`operator ${s} is not supported`);
                        }
                    }
                    onImmediateGenericRegion(e1, t, a, r) {
                        const n = e1.info, i = new DecodingContext(t, a, r), s = decodeBitmap(e1.mmr, n.width, n.height, e1.template, e1.prediction, null, e1.at, i);
                        this.drawBitmap(n, s);
                    }
                    onImmediateLosslessGenericRegion() {
                        this.onImmediateGenericRegion(...arguments);
                    }
                    onSymbolDictionary(e1, t, a, r, i, s) {
                        let o, c;
                        if (e1.huffman) {
                            o = function getSymbolDictionaryHuffmanTables(e1, t, a) {
                                let r, n, i, s, o = 0;
                                switch(e1.huffmanDHSelector){
                                    case 0:
                                    case 1:
                                        r = getStandardTable(e1.huffmanDHSelector + 4);
                                        break;
                                    case 3:
                                        r = getCustomHuffmanTable(o, t, a);
                                        o++;
                                        break;
                                    default:
                                        throw new Jbig2Error("invalid Huffman DH selector");
                                }
                                switch(e1.huffmanDWSelector){
                                    case 0:
                                    case 1:
                                        n = getStandardTable(e1.huffmanDWSelector + 2);
                                        break;
                                    case 3:
                                        n = getCustomHuffmanTable(o, t, a);
                                        o++;
                                        break;
                                    default:
                                        throw new Jbig2Error("invalid Huffman DW selector");
                                }
                                if (e1.bitmapSizeSelector) {
                                    i = getCustomHuffmanTable(o, t, a);
                                    o++;
                                } else i = getStandardTable(1);
                                s = e1.aggregationInstancesSelector ? getCustomHuffmanTable(o, t, a) : getStandardTable(1);
                                return {
                                    tableDeltaHeight: r,
                                    tableDeltaWidth: n,
                                    tableBitmapSize: i,
                                    tableAggregateInstances: s
                                };
                            }(e1, a, this.customTables);
                            c = new Reader(r, i, s);
                        }
                        let l = this.symbols;
                        l || (this.symbols = l = {});
                        const h = [];
                        for (const e1 of a){
                            const t = l[e1];
                            t && h.push(...t);
                        }
                        const u = new DecodingContext(r, i, s);
                        l[t] = function decodeSymbolDictionary(e1, t, a, r, i, s, o, c, l, h, u, d) {
                            if (e1 && t) throw new Jbig2Error("symbol refinement with Huffman is not supported");
                            const f = [];
                            let g = 0, p = (0, n.log2)(a.length + r);
                            const m = u.decoder, b = u.contextCache;
                            let y, w;
                            if (e1) {
                                y = getStandardTable(1);
                                w = [];
                                p = Math.max(p, 1);
                            }
                            for(; f.length < r;){
                                g += e1 ? s.tableDeltaHeight.decode(d) : decodeInteger(b, "IADH", m);
                                let r = 0, n = 0;
                                const i = e1 ? w.length : 0;
                                for(;;){
                                    const i = e1 ? s.tableDeltaWidth.decode(d) : decodeInteger(b, "IADW", m);
                                    if (null === i) break;
                                    r += i;
                                    n += r;
                                    let y;
                                    if (t) {
                                        const n = decodeInteger(b, "IAAI", m);
                                        if (n > 1) y = decodeTextRegion(e1, t, r, g, 0, n, 1, a.concat(f), p, 0, 0, 1, 0, s, l, h, u, 0, d);
                                        else {
                                            const e1 = decodeIAID(b, m, p), t = decodeInteger(b, "IARDX", m), n = decodeInteger(b, "IARDY", m);
                                            y = decodeRefinement(r, g, l, e1 < a.length ? a[e1] : f[e1 - a.length], t, n, !1, h, u);
                                        }
                                        f.push(y);
                                    } else if (e1) w.push(r);
                                    else {
                                        y = decodeBitmap(!1, r, g, o, !1, null, c, u);
                                        f.push(y);
                                    }
                                }
                                if (e1 && !t) {
                                    const e1 = s.tableBitmapSize.decode(d);
                                    d.byteAlign();
                                    let t;
                                    if (0 === e1) t = readUncompressedBitmap(d, n, g);
                                    else {
                                        const a = d.end, r = d.position + e1;
                                        d.end = r;
                                        t = decodeMMRBitmap(d, n, g, !1);
                                        d.end = a;
                                        d.position = r;
                                    }
                                    const a = w.length;
                                    if (i === a - 1) f.push(t);
                                    else {
                                        let e1, r, n, s, o, c = 0;
                                        for(e1 = i; e1 < a; e1++){
                                            s = w[e1];
                                            n = c + s;
                                            o = [];
                                            for(r = 0; r < g; r++)o.push(t[r].subarray(c, n));
                                            f.push(o);
                                            c = n;
                                        }
                                    }
                                }
                            }
                            const S = [], x = [];
                            let C, k, v = !1;
                            const F = a.length + r;
                            for(; x.length < F;){
                                let t = e1 ? y.decode(d) : decodeInteger(b, "IAEX", m);
                                for(; t--;)x.push(v);
                                v = !v;
                            }
                            for(C = 0, k = a.length; C < k; C++)x[C] && S.push(a[C]);
                            for(let e1 = 0; e1 < r; C++, e1++)x[C] && S.push(f[e1]);
                            return S;
                        }(e1.huffman, e1.refinement, h, e1.numberOfNewSymbols, e1.numberOfExportedSymbols, o, e1.template, e1.at, e1.refinementTemplate, e1.refinementAt, u, c);
                    }
                    onImmediateTextRegion(e1, t, a, r, i) {
                        const s = e1.info;
                        let o, c;
                        const l = this.symbols, h = [];
                        for (const e1 of t){
                            const t = l[e1];
                            t && h.push(...t);
                        }
                        const u = (0, n.log2)(h.length);
                        if (e1.huffman) {
                            c = new Reader(a, r, i);
                            o = function getTextRegionHuffmanTables(e1, t, a, r, n) {
                                const i = [];
                                for(let e1 = 0; e1 <= 34; e1++){
                                    const t = n.readBits(4);
                                    i.push(new HuffmanLine([
                                        e1,
                                        t,
                                        0,
                                        0
                                    ]));
                                }
                                const s = new HuffmanTable(i, !1);
                                i.length = 0;
                                for(let e1 = 0; e1 < r;){
                                    const t = s.decode(n);
                                    if (t >= 32) {
                                        let a, r, s;
                                        switch(t){
                                            case 32:
                                                if (0 === e1) throw new Jbig2Error("no previous value in symbol ID table");
                                                r = n.readBits(2) + 3;
                                                a = i[e1 - 1].prefixLength;
                                                break;
                                            case 33:
                                                r = n.readBits(3) + 3;
                                                a = 0;
                                                break;
                                            case 34:
                                                r = n.readBits(7) + 11;
                                                a = 0;
                                                break;
                                            default:
                                                throw new Jbig2Error("invalid code length in symbol ID table");
                                        }
                                        for(s = 0; s < r; s++){
                                            i.push(new HuffmanLine([
                                                e1,
                                                a,
                                                0,
                                                0
                                            ]));
                                            e1++;
                                        }
                                    } else {
                                        i.push(new HuffmanLine([
                                            e1,
                                            t,
                                            0,
                                            0
                                        ]));
                                        e1++;
                                    }
                                }
                                n.byteAlign();
                                const o = new HuffmanTable(i, !1);
                                let c, l, h, u = 0;
                                switch(e1.huffmanFS){
                                    case 0:
                                    case 1:
                                        c = getStandardTable(e1.huffmanFS + 6);
                                        break;
                                    case 3:
                                        c = getCustomHuffmanTable(u, t, a);
                                        u++;
                                        break;
                                    default:
                                        throw new Jbig2Error("invalid Huffman FS selector");
                                }
                                switch(e1.huffmanDS){
                                    case 0:
                                    case 1:
                                    case 2:
                                        l = getStandardTable(e1.huffmanDS + 8);
                                        break;
                                    case 3:
                                        l = getCustomHuffmanTable(u, t, a);
                                        u++;
                                        break;
                                    default:
                                        throw new Jbig2Error("invalid Huffman DS selector");
                                }
                                switch(e1.huffmanDT){
                                    case 0:
                                    case 1:
                                    case 2:
                                        h = getStandardTable(e1.huffmanDT + 11);
                                        break;
                                    case 3:
                                        h = getCustomHuffmanTable(u, t, a);
                                        u++;
                                        break;
                                    default:
                                        throw new Jbig2Error("invalid Huffman DT selector");
                                }
                                if (e1.refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                                return {
                                    symbolIDTable: o,
                                    tableFirstS: c,
                                    tableDeltaS: l,
                                    tableDeltaT: h
                                };
                            }(e1, t, this.customTables, h.length, c);
                        }
                        const d = new DecodingContext(a, r, i), f = decodeTextRegion(e1.huffman, e1.refinement, s.width, s.height, e1.defaultPixelValue, e1.numberOfSymbolInstances, e1.stripSize, h, u, e1.transposed, e1.dsOffset, e1.referenceCorner, e1.combinationOperator, o, e1.refinementTemplate, e1.refinementAt, d, e1.logStripSize, c);
                        this.drawBitmap(s, f);
                    }
                    onImmediateLosslessTextRegion() {
                        this.onImmediateTextRegion(...arguments);
                    }
                    onPatternDictionary(e1, t, a, r, n) {
                        let i = this.patterns;
                        i || (this.patterns = i = {});
                        const s = new DecodingContext(a, r, n);
                        i[t] = function decodePatternDictionary(e1, t, a, r, n, i) {
                            const s = [];
                            if (!e1) {
                                s.push({
                                    x: -t,
                                    y: 0
                                });
                                0 === n && s.push({
                                    x: -3,
                                    y: -1
                                }, {
                                    x: 2,
                                    y: -2
                                }, {
                                    x: -2,
                                    y: -2
                                });
                            }
                            const o = decodeBitmap(e1, (r + 1) * t, a, n, !1, null, s, i), c = [];
                            for(let e1 = 0; e1 <= r; e1++){
                                const r = [], n = t * e1, i = n + t;
                                for(let e1 = 0; e1 < a; e1++)r.push(o[e1].subarray(n, i));
                                c.push(r);
                            }
                            return c;
                        }(e1.mmr, e1.patternWidth, e1.patternHeight, e1.maxPatternIndex, e1.template, s);
                    }
                    onImmediateHalftoneRegion(e1, t, a, r, i) {
                        const s = this.patterns[t[0]], o = e1.info, c = new DecodingContext(a, r, i), l = function decodeHalftoneRegion(e1, t, a, r, i, s, o, c, l, h, u, d, f, g, p) {
                            if (o) throw new Jbig2Error("skip is not supported");
                            if (0 !== c) throw new Jbig2Error(`operator "${c}" is not supported in halftone region`);
                            const m = [];
                            let b, y, w;
                            for(b = 0; b < i; b++){
                                w = new Uint8Array(r);
                                if (s) for(y = 0; y < r; y++)w[y] = s;
                                m.push(w);
                            }
                            const S = t.length, x = t[0], C = x[0].length, k = x.length, v = (0, n.log2)(S), F = [];
                            if (!e1) {
                                F.push({
                                    x: a <= 1 ? 3 : 2,
                                    y: -1
                                });
                                0 === a && F.push({
                                    x: -3,
                                    y: -1
                                }, {
                                    x: 2,
                                    y: -2
                                }, {
                                    x: -2,
                                    y: -2
                                });
                            }
                            const O = [];
                            let T, M, D, E, N, R, L, $, _, j, U;
                            e1 && (T = new Reader(p.data, p.start, p.end));
                            for(b = v - 1; b >= 0; b--){
                                M = e1 ? decodeMMRBitmap(T, l, h, !0) : decodeBitmap(!1, l, h, a, !1, null, F, p);
                                O[b] = M;
                            }
                            for(D = 0; D < h; D++)for(E = 0; E < l; E++){
                                N = 0;
                                R = 0;
                                for(y = v - 1; y >= 0; y--){
                                    N ^= O[y][D][E];
                                    R |= N << y;
                                }
                                L = t[R];
                                $ = u + D * g + E * f >> 8;
                                _ = d + D * f - E * g >> 8;
                                if ($ >= 0 && $ + C <= r && _ >= 0 && _ + k <= i) for(b = 0; b < k; b++){
                                    U = m[_ + b];
                                    j = L[b];
                                    for(y = 0; y < C; y++)U[$ + y] |= j[y];
                                }
                                else {
                                    let e1, t;
                                    for(b = 0; b < k; b++){
                                        t = _ + b;
                                        if (!(t < 0 || t >= i)) {
                                            U = m[t];
                                            j = L[b];
                                            for(y = 0; y < C; y++){
                                                e1 = $ + y;
                                                e1 >= 0 && e1 < r && (U[e1] |= j[y]);
                                            }
                                        }
                                    }
                                }
                            }
                            return m;
                        }(e1.mmr, s, e1.template, o.width, o.height, e1.defaultPixelValue, e1.enableSkip, e1.combinationOperator, e1.gridWidth, e1.gridHeight, e1.gridOffsetX, e1.gridOffsetY, e1.gridVectorX, e1.gridVectorY, c);
                        this.drawBitmap(o, l);
                    }
                    onImmediateLosslessHalftoneRegion() {
                        this.onImmediateHalftoneRegion(...arguments);
                    }
                    onTables(e1, t, a, r) {
                        let i = this.customTables;
                        i || (this.customTables = i = {});
                        i[e1] = function decodeTablesSegment(e1, t, a) {
                            const r = e1[t], i = 4294967295 & (0, n.readUint32)(e1, t + 1), s = 4294967295 & (0, n.readUint32)(e1, t + 5), o = new Reader(e1, t + 9, a), c = 1 + (r >> 1 & 7), l = 1 + (r >> 4 & 7), h = [];
                            let u, d, f = i;
                            do {
                                u = o.readBits(c);
                                d = o.readBits(l);
                                h.push(new HuffmanLine([
                                    f,
                                    u,
                                    d,
                                    0
                                ]));
                                f += 1 << d;
                            }while (f < s);
                            u = o.readBits(c);
                            h.push(new HuffmanLine([
                                i - 1,
                                u,
                                32,
                                0,
                                "lower"
                            ]));
                            u = o.readBits(c);
                            h.push(new HuffmanLine([
                                s,
                                u,
                                32,
                                0
                            ]));
                            if (1 & r) {
                                u = o.readBits(c);
                                h.push(new HuffmanLine([
                                    u,
                                    0
                                ]));
                            }
                            return new HuffmanTable(h, !1);
                        }(t, a, r);
                    }
                }
                class HuffmanLine {
                    constructor(e1){
                        if (2 === e1.length) {
                            this.isOOB = !0;
                            this.rangeLow = 0;
                            this.prefixLength = e1[0];
                            this.rangeLength = 0;
                            this.prefixCode = e1[1];
                            this.isLowerRange = !1;
                        } else {
                            this.isOOB = !1;
                            this.rangeLow = e1[0];
                            this.prefixLength = e1[1];
                            this.rangeLength = e1[2];
                            this.prefixCode = e1[3];
                            this.isLowerRange = "lower" === e1[4];
                        }
                    }
                }
                class HuffmanTreeNode {
                    constructor(e1){
                        this.children = [];
                        if (e1) {
                            this.isLeaf = !0;
                            this.rangeLength = e1.rangeLength;
                            this.rangeLow = e1.rangeLow;
                            this.isLowerRange = e1.isLowerRange;
                            this.isOOB = e1.isOOB;
                        } else this.isLeaf = !1;
                    }
                    buildTree(e1, t) {
                        const a = e1.prefixCode >> t & 1;
                        if (t <= 0) this.children[a] = new HuffmanTreeNode(e1);
                        else {
                            let r = this.children[a];
                            r || (this.children[a] = r = new HuffmanTreeNode(null));
                            r.buildTree(e1, t - 1);
                        }
                    }
                    decodeNode(e1) {
                        if (this.isLeaf) {
                            if (this.isOOB) return null;
                            const t = e1.readBits(this.rangeLength);
                            return this.rangeLow + (this.isLowerRange ? -t : t);
                        }
                        const t = this.children[e1.readBit()];
                        if (!t) throw new Jbig2Error("invalid Huffman data");
                        return t.decodeNode(e1);
                    }
                }
                class HuffmanTable {
                    constructor(e1, t){
                        t || this.assignPrefixCodes(e1);
                        this.rootNode = new HuffmanTreeNode(null);
                        for(let t = 0, a = e1.length; t < a; t++){
                            const a = e1[t];
                            a.prefixLength > 0 && this.rootNode.buildTree(a, a.prefixLength - 1);
                        }
                    }
                    decode(e1) {
                        return this.rootNode.decodeNode(e1);
                    }
                    assignPrefixCodes(e1) {
                        const t = e1.length;
                        let a = 0;
                        for(let r = 0; r < t; r++)a = Math.max(a, e1[r].prefixLength);
                        const r = new Uint32Array(a + 1);
                        for(let a = 0; a < t; a++)r[e1[a].prefixLength]++;
                        let n, i, s, o = 1, c = 0;
                        r[0] = 0;
                        for(; o <= a;){
                            c = c + r[o - 1] << 1;
                            n = c;
                            i = 0;
                            for(; i < t;){
                                s = e1[i];
                                if (s.prefixLength === o) {
                                    s.prefixCode = n;
                                    n++;
                                }
                                i++;
                            }
                            o++;
                        }
                    }
                }
                const p = {};
                function getStandardTable(e1) {
                    let t, a = p[e1];
                    if (a) return a;
                    switch(e1){
                        case 1:
                            t = [
                                [
                                    0,
                                    1,
                                    4,
                                    0
                                ],
                                [
                                    16,
                                    2,
                                    8,
                                    2
                                ],
                                [
                                    272,
                                    3,
                                    16,
                                    6
                                ],
                                [
                                    65808,
                                    3,
                                    32,
                                    7
                                ]
                            ];
                            break;
                        case 2:
                            t = [
                                [
                                    0,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    14
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    30
                                ],
                                [
                                    75,
                                    6,
                                    32,
                                    62
                                ],
                                [
                                    6,
                                    63
                                ]
                            ];
                            break;
                        case 3:
                            t = [
                                [
                                    -256,
                                    8,
                                    8,
                                    254
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    14
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    30
                                ],
                                [
                                    -257,
                                    8,
                                    32,
                                    255,
                                    "lower"
                                ],
                                [
                                    75,
                                    7,
                                    32,
                                    126
                                ],
                                [
                                    6,
                                    62
                                ]
                            ];
                            break;
                        case 4:
                            t = [
                                [
                                    1,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    14
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    30
                                ],
                                [
                                    76,
                                    5,
                                    32,
                                    31
                                ]
                            ];
                            break;
                        case 5:
                            t = [
                                [
                                    -255,
                                    7,
                                    8,
                                    126
                                ],
                                [
                                    1,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    14
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    30
                                ],
                                [
                                    -256,
                                    7,
                                    32,
                                    127,
                                    "lower"
                                ],
                                [
                                    76,
                                    6,
                                    32,
                                    62
                                ]
                            ];
                            break;
                        case 6:
                            t = [
                                [
                                    -2048,
                                    5,
                                    10,
                                    28
                                ],
                                [
                                    -1024,
                                    4,
                                    9,
                                    8
                                ],
                                [
                                    -512,
                                    4,
                                    8,
                                    9
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    10
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    29
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    30
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    11
                                ],
                                [
                                    0,
                                    2,
                                    7,
                                    0
                                ],
                                [
                                    128,
                                    3,
                                    7,
                                    2
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    3
                                ],
                                [
                                    512,
                                    4,
                                    9,
                                    12
                                ],
                                [
                                    1024,
                                    4,
                                    10,
                                    13
                                ],
                                [
                                    -2049,
                                    6,
                                    32,
                                    62,
                                    "lower"
                                ],
                                [
                                    2048,
                                    6,
                                    32,
                                    63
                                ]
                            ];
                            break;
                        case 7:
                            t = [
                                [
                                    -1024,
                                    4,
                                    9,
                                    8
                                ],
                                [
                                    -512,
                                    3,
                                    8,
                                    0
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    9
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    26
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    27
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    10
                                ],
                                [
                                    0,
                                    4,
                                    5,
                                    11
                                ],
                                [
                                    32,
                                    5,
                                    5,
                                    28
                                ],
                                [
                                    64,
                                    5,
                                    6,
                                    29
                                ],
                                [
                                    128,
                                    4,
                                    7,
                                    12
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    1
                                ],
                                [
                                    512,
                                    3,
                                    9,
                                    2
                                ],
                                [
                                    1024,
                                    3,
                                    10,
                                    3
                                ],
                                [
                                    -1025,
                                    5,
                                    32,
                                    30,
                                    "lower"
                                ],
                                [
                                    2048,
                                    5,
                                    32,
                                    31
                                ]
                            ];
                            break;
                        case 8:
                            t = [
                                [
                                    -15,
                                    8,
                                    3,
                                    252
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    508
                                ],
                                [
                                    -5,
                                    8,
                                    1,
                                    253
                                ],
                                [
                                    -3,
                                    9,
                                    0,
                                    509
                                ],
                                [
                                    -2,
                                    7,
                                    0,
                                    124
                                ],
                                [
                                    -1,
                                    4,
                                    0,
                                    10
                                ],
                                [
                                    0,
                                    2,
                                    1,
                                    0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    26
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    58
                                ],
                                [
                                    4,
                                    3,
                                    4,
                                    4
                                ],
                                [
                                    20,
                                    6,
                                    1,
                                    59
                                ],
                                [
                                    22,
                                    4,
                                    4,
                                    11
                                ],
                                [
                                    38,
                                    4,
                                    5,
                                    12
                                ],
                                [
                                    70,
                                    5,
                                    6,
                                    27
                                ],
                                [
                                    134,
                                    5,
                                    7,
                                    28
                                ],
                                [
                                    262,
                                    6,
                                    7,
                                    60
                                ],
                                [
                                    390,
                                    7,
                                    8,
                                    125
                                ],
                                [
                                    646,
                                    6,
                                    10,
                                    61
                                ],
                                [
                                    -16,
                                    9,
                                    32,
                                    510,
                                    "lower"
                                ],
                                [
                                    1670,
                                    9,
                                    32,
                                    511
                                ],
                                [
                                    2,
                                    1
                                ]
                            ];
                            break;
                        case 9:
                            t = [
                                [
                                    -31,
                                    8,
                                    4,
                                    252
                                ],
                                [
                                    -15,
                                    9,
                                    2,
                                    508
                                ],
                                [
                                    -11,
                                    8,
                                    2,
                                    253
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    509
                                ],
                                [
                                    -5,
                                    7,
                                    1,
                                    124
                                ],
                                [
                                    -3,
                                    4,
                                    1,
                                    10
                                ],
                                [
                                    -1,
                                    3,
                                    1,
                                    2
                                ],
                                [
                                    1,
                                    3,
                                    1,
                                    3
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    26
                                ],
                                [
                                    5,
                                    6,
                                    1,
                                    58
                                ],
                                [
                                    7,
                                    3,
                                    5,
                                    4
                                ],
                                [
                                    39,
                                    6,
                                    2,
                                    59
                                ],
                                [
                                    43,
                                    4,
                                    5,
                                    11
                                ],
                                [
                                    75,
                                    4,
                                    6,
                                    12
                                ],
                                [
                                    139,
                                    5,
                                    7,
                                    27
                                ],
                                [
                                    267,
                                    5,
                                    8,
                                    28
                                ],
                                [
                                    523,
                                    6,
                                    8,
                                    60
                                ],
                                [
                                    779,
                                    7,
                                    9,
                                    125
                                ],
                                [
                                    1291,
                                    6,
                                    11,
                                    61
                                ],
                                [
                                    -32,
                                    9,
                                    32,
                                    510,
                                    "lower"
                                ],
                                [
                                    3339,
                                    9,
                                    32,
                                    511
                                ],
                                [
                                    2,
                                    0
                                ]
                            ];
                            break;
                        case 10:
                            t = [
                                [
                                    -21,
                                    7,
                                    4,
                                    122
                                ],
                                [
                                    -5,
                                    8,
                                    0,
                                    252
                                ],
                                [
                                    -4,
                                    7,
                                    0,
                                    123
                                ],
                                [
                                    -3,
                                    5,
                                    0,
                                    24
                                ],
                                [
                                    -2,
                                    2,
                                    2,
                                    0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    25
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    54
                                ],
                                [
                                    4,
                                    7,
                                    0,
                                    124
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    253
                                ],
                                [
                                    6,
                                    2,
                                    6,
                                    1
                                ],
                                [
                                    70,
                                    5,
                                    5,
                                    26
                                ],
                                [
                                    102,
                                    6,
                                    5,
                                    55
                                ],
                                [
                                    134,
                                    6,
                                    6,
                                    56
                                ],
                                [
                                    198,
                                    6,
                                    7,
                                    57
                                ],
                                [
                                    326,
                                    6,
                                    8,
                                    58
                                ],
                                [
                                    582,
                                    6,
                                    9,
                                    59
                                ],
                                [
                                    1094,
                                    6,
                                    10,
                                    60
                                ],
                                [
                                    2118,
                                    7,
                                    11,
                                    125
                                ],
                                [
                                    -22,
                                    8,
                                    32,
                                    254,
                                    "lower"
                                ],
                                [
                                    4166,
                                    8,
                                    32,
                                    255
                                ],
                                [
                                    2,
                                    2
                                ]
                            ];
                            break;
                        case 11:
                            t = [
                                [
                                    1,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    2,
                                    2,
                                    1,
                                    2
                                ],
                                [
                                    4,
                                    4,
                                    0,
                                    12
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    13
                                ],
                                [
                                    7,
                                    5,
                                    1,
                                    28
                                ],
                                [
                                    9,
                                    5,
                                    2,
                                    29
                                ],
                                [
                                    13,
                                    6,
                                    2,
                                    60
                                ],
                                [
                                    17,
                                    7,
                                    2,
                                    122
                                ],
                                [
                                    21,
                                    7,
                                    3,
                                    123
                                ],
                                [
                                    29,
                                    7,
                                    4,
                                    124
                                ],
                                [
                                    45,
                                    7,
                                    5,
                                    125
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    126
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    127
                                ]
                            ];
                            break;
                        case 12:
                            t = [
                                [
                                    1,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    2
                                ],
                                [
                                    3,
                                    3,
                                    1,
                                    6
                                ],
                                [
                                    5,
                                    5,
                                    0,
                                    28
                                ],
                                [
                                    6,
                                    5,
                                    1,
                                    29
                                ],
                                [
                                    8,
                                    6,
                                    1,
                                    60
                                ],
                                [
                                    10,
                                    7,
                                    0,
                                    122
                                ],
                                [
                                    11,
                                    7,
                                    1,
                                    123
                                ],
                                [
                                    13,
                                    7,
                                    2,
                                    124
                                ],
                                [
                                    17,
                                    7,
                                    3,
                                    125
                                ],
                                [
                                    25,
                                    7,
                                    4,
                                    126
                                ],
                                [
                                    41,
                                    8,
                                    5,
                                    254
                                ],
                                [
                                    73,
                                    8,
                                    32,
                                    255
                                ]
                            ];
                            break;
                        case 13:
                            t = [
                                [
                                    1,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    4
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    12
                                ],
                                [
                                    4,
                                    5,
                                    0,
                                    28
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    13
                                ],
                                [
                                    7,
                                    3,
                                    3,
                                    5
                                ],
                                [
                                    15,
                                    6,
                                    1,
                                    58
                                ],
                                [
                                    17,
                                    6,
                                    2,
                                    59
                                ],
                                [
                                    21,
                                    6,
                                    3,
                                    60
                                ],
                                [
                                    29,
                                    6,
                                    4,
                                    61
                                ],
                                [
                                    45,
                                    6,
                                    5,
                                    62
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    126
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    127
                                ]
                            ];
                            break;
                        case 14:
                            t = [
                                [
                                    -2,
                                    3,
                                    0,
                                    4
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    5
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    6
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    7
                                ]
                            ];
                            break;
                        case 15:
                            t = [
                                [
                                    -24,
                                    7,
                                    4,
                                    124
                                ],
                                [
                                    -8,
                                    6,
                                    2,
                                    60
                                ],
                                [
                                    -4,
                                    5,
                                    1,
                                    28
                                ],
                                [
                                    -2,
                                    4,
                                    0,
                                    12
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    4
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    5
                                ],
                                [
                                    2,
                                    4,
                                    0,
                                    13
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    29
                                ],
                                [
                                    5,
                                    6,
                                    2,
                                    61
                                ],
                                [
                                    9,
                                    7,
                                    4,
                                    125
                                ],
                                [
                                    -25,
                                    7,
                                    32,
                                    126,
                                    "lower"
                                ],
                                [
                                    25,
                                    7,
                                    32,
                                    127
                                ]
                            ];
                            break;
                        default:
                            throw new Jbig2Error(`standard table B.${e1} does not exist`);
                    }
                    for(let e1 = 0, a = t.length; e1 < a; e1++)t[e1] = new HuffmanLine(t[e1]);
                    a = new HuffmanTable(t, !0);
                    p[e1] = a;
                    return a;
                }
                class Reader {
                    constructor(e1, t, a){
                        this.data = e1;
                        this.start = t;
                        this.end = a;
                        this.position = t;
                        this.shift = -1;
                        this.currentByte = 0;
                    }
                    readBit() {
                        if (this.shift < 0) {
                            if (this.position >= this.end) throw new Jbig2Error("end of data while reading bit");
                            this.currentByte = this.data[this.position++];
                            this.shift = 7;
                        }
                        const e1 = this.currentByte >> this.shift & 1;
                        this.shift--;
                        return e1;
                    }
                    readBits(e1) {
                        let t, a = 0;
                        for(t = e1 - 1; t >= 0; t--)a |= this.readBit() << t;
                        return a;
                    }
                    byteAlign() {
                        this.shift = -1;
                    }
                    next() {
                        return this.position >= this.end ? -1 : this.data[this.position++];
                    }
                }
                function getCustomHuffmanTable(e1, t, a) {
                    let r = 0;
                    for(let n = 0, i = t.length; n < i; n++){
                        const i = a[t[n]];
                        if (i) {
                            if (e1 === r) return i;
                            r++;
                        }
                    }
                    throw new Jbig2Error("can't find custom Huffman table");
                }
                function readUncompressedBitmap(e1, t, a) {
                    const r = [];
                    for(let n = 0; n < a; n++){
                        const a = new Uint8Array(t);
                        r.push(a);
                        for(let r = 0; r < t; r++)a[r] = e1.readBit();
                        e1.byteAlign();
                    }
                    return r;
                }
                function decodeMMRBitmap(e1, t, a, r) {
                    const n = {
                        K: -1,
                        Columns: t,
                        Rows: a,
                        BlackIs1: !0,
                        EndOfBlock: r
                    }, i = new s.CCITTFaxDecoder(e1, n), o = [];
                    let c, l = !1;
                    for(let e1 = 0; e1 < a; e1++){
                        const e1 = new Uint8Array(t);
                        o.push(e1);
                        let a = -1;
                        for(let r = 0; r < t; r++){
                            if (a < 0) {
                                c = i.readNextChar();
                                if (-1 === c) {
                                    c = 0;
                                    l = !0;
                                }
                                a = 7;
                            }
                            e1[r] = c >> a & 1;
                            a--;
                        }
                    }
                    if (r && !l) {
                        const e1 = 5;
                        for(let t = 0; t < e1 && -1 !== i.readNextChar(); t++);
                    }
                    return o;
                }
                t.Jbig2Image = class Jbig2Image {
                    parseChunks(e1) {
                        return function parseJbig2Chunks(e1) {
                            const t = new SimpleSegmentVisitor;
                            for(let a = 0, r = e1.length; a < r; a++){
                                const r = e1[a];
                                processSegments(readSegments({}, r.data, r.start, r.end), t);
                            }
                            return t.buffer;
                        }(e1);
                    }
                    parse(e1) {
                        throw new Error("Not implemented: Jbig2Image.parse");
                    }
                };
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ArithmeticDecoder = void 0;
                const a = [
                    {
                        qe: 22017,
                        nmps: 1,
                        nlps: 1,
                        switchFlag: 1
                    },
                    {
                        qe: 13313,
                        nmps: 2,
                        nlps: 6,
                        switchFlag: 0
                    },
                    {
                        qe: 6145,
                        nmps: 3,
                        nlps: 9,
                        switchFlag: 0
                    },
                    {
                        qe: 2753,
                        nmps: 4,
                        nlps: 12,
                        switchFlag: 0
                    },
                    {
                        qe: 1313,
                        nmps: 5,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 545,
                        nmps: 38,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 22017,
                        nmps: 7,
                        nlps: 6,
                        switchFlag: 1
                    },
                    {
                        qe: 21505,
                        nmps: 8,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 18433,
                        nmps: 9,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 14337,
                        nmps: 10,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 12289,
                        nmps: 11,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 9217,
                        nmps: 12,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 7169,
                        nmps: 13,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 5633,
                        nmps: 29,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 22017,
                        nmps: 15,
                        nlps: 14,
                        switchFlag: 1
                    },
                    {
                        qe: 21505,
                        nmps: 16,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 20737,
                        nmps: 17,
                        nlps: 15,
                        switchFlag: 0
                    },
                    {
                        qe: 18433,
                        nmps: 18,
                        nlps: 16,
                        switchFlag: 0
                    },
                    {
                        qe: 14337,
                        nmps: 19,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 13313,
                        nmps: 20,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 12289,
                        nmps: 21,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 10241,
                        nmps: 22,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 9217,
                        nmps: 23,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 8705,
                        nmps: 24,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 7169,
                        nmps: 25,
                        nlps: 22,
                        switchFlag: 0
                    },
                    {
                        qe: 6145,
                        nmps: 26,
                        nlps: 23,
                        switchFlag: 0
                    },
                    {
                        qe: 5633,
                        nmps: 27,
                        nlps: 24,
                        switchFlag: 0
                    },
                    {
                        qe: 5121,
                        nmps: 28,
                        nlps: 25,
                        switchFlag: 0
                    },
                    {
                        qe: 4609,
                        nmps: 29,
                        nlps: 26,
                        switchFlag: 0
                    },
                    {
                        qe: 4353,
                        nmps: 30,
                        nlps: 27,
                        switchFlag: 0
                    },
                    {
                        qe: 2753,
                        nmps: 31,
                        nlps: 28,
                        switchFlag: 0
                    },
                    {
                        qe: 2497,
                        nmps: 32,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 2209,
                        nmps: 33,
                        nlps: 30,
                        switchFlag: 0
                    },
                    {
                        qe: 1313,
                        nmps: 34,
                        nlps: 31,
                        switchFlag: 0
                    },
                    {
                        qe: 1089,
                        nmps: 35,
                        nlps: 32,
                        switchFlag: 0
                    },
                    {
                        qe: 673,
                        nmps: 36,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 545,
                        nmps: 37,
                        nlps: 34,
                        switchFlag: 0
                    },
                    {
                        qe: 321,
                        nmps: 38,
                        nlps: 35,
                        switchFlag: 0
                    },
                    {
                        qe: 273,
                        nmps: 39,
                        nlps: 36,
                        switchFlag: 0
                    },
                    {
                        qe: 133,
                        nmps: 40,
                        nlps: 37,
                        switchFlag: 0
                    },
                    {
                        qe: 73,
                        nmps: 41,
                        nlps: 38,
                        switchFlag: 0
                    },
                    {
                        qe: 37,
                        nmps: 42,
                        nlps: 39,
                        switchFlag: 0
                    },
                    {
                        qe: 21,
                        nmps: 43,
                        nlps: 40,
                        switchFlag: 0
                    },
                    {
                        qe: 9,
                        nmps: 44,
                        nlps: 41,
                        switchFlag: 0
                    },
                    {
                        qe: 5,
                        nmps: 45,
                        nlps: 42,
                        switchFlag: 0
                    },
                    {
                        qe: 1,
                        nmps: 45,
                        nlps: 43,
                        switchFlag: 0
                    },
                    {
                        qe: 22017,
                        nmps: 46,
                        nlps: 46,
                        switchFlag: 0
                    }
                ];
                t.ArithmeticDecoder = class ArithmeticDecoder {
                    constructor(e1, t, a){
                        this.data = e1;
                        this.bp = t;
                        this.dataEnd = a;
                        this.chigh = e1[t];
                        this.clow = 0;
                        this.byteIn();
                        this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127;
                        this.clow = this.clow << 7 & 65535;
                        this.ct -= 7;
                        this.a = 32768;
                    }
                    byteIn() {
                        const e1 = this.data;
                        let t = this.bp;
                        if (255 === e1[t]) {
                            if (e1[t + 1] > 143) {
                                this.clow += 65280;
                                this.ct = 8;
                            } else {
                                t++;
                                this.clow += e1[t] << 9;
                                this.ct = 7;
                                this.bp = t;
                            }
                        } else {
                            t++;
                            this.clow += t < this.dataEnd ? e1[t] << 8 : 65280;
                            this.ct = 8;
                            this.bp = t;
                        }
                        if (this.clow > 65535) {
                            this.chigh += this.clow >> 16;
                            this.clow &= 65535;
                        }
                    }
                    readBit(e1, t) {
                        let r = e1[t] >> 1, n = 1 & e1[t];
                        const i = a[r], s = i.qe;
                        let o, c = this.a - s;
                        if (this.chigh < s) {
                            if (c < s) {
                                c = s;
                                o = n;
                                r = i.nmps;
                            } else {
                                c = s;
                                o = 1 ^ n;
                                1 === i.switchFlag && (n = o);
                                r = i.nlps;
                            }
                        } else {
                            this.chigh -= s;
                            if (0 != (32768 & c)) {
                                this.a = c;
                                return n;
                            }
                            if (c < s) {
                                o = 1 ^ n;
                                1 === i.switchFlag && (n = o);
                                r = i.nlps;
                            } else {
                                o = n;
                                r = i.nmps;
                            }
                        }
                        do {
                            0 === this.ct && this.byteIn();
                            c <<= 1;
                            this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1;
                            this.clow = this.clow << 1 & 65535;
                            this.ct--;
                        }while (0 == (32768 & c));
                        this.a = c;
                        e1[t] = r << 1 | n;
                        return o;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.JpegStream = void 0;
                var r = a(18), n = a(4), i = a(27), s = a(2);
                class JpegStream extends r.DecodeStream {
                    constructor(e1, t, a){
                        let r;
                        for(; -1 !== (r = e1.getByte());)if (255 === r) {
                            e1.skip(-1);
                            break;
                        }
                        super(t);
                        this.stream = e1;
                        this.dict = e1.dict;
                        this.maybeLength = t;
                        this.params = a;
                    }
                    get bytes() {
                        return (0, s.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(e1) {}
                    readBlock() {
                        if (this.eof) return;
                        const e1 = {
                            decodeTransform: void 0,
                            colorTransform: void 0
                        }, t = this.dict.getArray("D", "Decode");
                        if ((this.forceRGBA || this.forceRGB) && Array.isArray(t)) {
                            const a = this.dict.get("BPC", "BitsPerComponent") || 8, r = t.length, n = new Int32Array(r);
                            let i = !1;
                            const s = (1 << a) - 1;
                            for(let e1 = 0; e1 < r; e1 += 2){
                                n[e1] = 256 * (t[e1 + 1] - t[e1]) | 0;
                                n[e1 + 1] = t[e1] * s | 0;
                                256 === n[e1] && 0 === n[e1 + 1] || (i = !0);
                            }
                            i && (e1.decodeTransform = n);
                        }
                        if (this.params instanceof n.Dict) {
                            const t = this.params.get("ColorTransform");
                            Number.isInteger(t) && (e1.colorTransform = t);
                        }
                        const a = new i.JpegImage(e1);
                        a.parse(this.bytes);
                        const r = a.getData({
                            width: this.drawWidth,
                            height: this.drawHeight,
                            forceRGBA: this.forceRGBA,
                            forceRGB: this.forceRGB,
                            isSourcePDF: !0
                        });
                        this.buffer = r;
                        this.bufferLength = r.length;
                        this.eof = !0;
                    }
                }
                t.JpegStream = JpegStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.JpegImage = void 0;
                var r = a(2), n = a(28), i = a(3);
                class JpegError extends r.BaseException {
                    constructor(e1){
                        super(`JPEG error: ${e1}`, "JpegError");
                    }
                }
                class DNLMarkerError extends r.BaseException {
                    constructor(e1, t){
                        super(e1, "DNLMarkerError");
                        this.scanLines = t;
                    }
                }
                class EOIMarkerError extends r.BaseException {
                    constructor(e1){
                        super(e1, "EOIMarkerError");
                    }
                }
                const s = new Uint8Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63
                ]), o = 4017, c = 799, l = 3406, h = 2276, u = 1567, d = 3784, f = 5793, g = 2896;
                function buildHuffmanTable(e1, t) {
                    let a, r, n = 0, i = 16;
                    for(; i > 0 && !e1[i - 1];)i--;
                    const s = [
                        {
                            children: [],
                            index: 0
                        }
                    ];
                    let o, c = s[0];
                    for(a = 0; a < i; a++){
                        for(r = 0; r < e1[a]; r++){
                            c = s.pop();
                            c.children[c.index] = t[n];
                            for(; c.index > 0;)c = s.pop();
                            c.index++;
                            s.push(c);
                            for(; s.length <= a;){
                                s.push(o = {
                                    children: [],
                                    index: 0
                                });
                                c.children[c.index] = o.children;
                                c = o;
                            }
                            n++;
                        }
                        if (a + 1 < i) {
                            s.push(o = {
                                children: [],
                                index: 0
                            });
                            c.children[c.index] = o.children;
                            c = o;
                        }
                    }
                    return s[0].children;
                }
                function getBlockBufferOffset(e1, t, a) {
                    return 64 * ((e1.blocksPerLine + 1) * t + a);
                }
                function decodeScan(e1, t, a, n, o, c, l, h, u, d = !1) {
                    const f = a.mcusPerLine, g = a.progressive, p = t;
                    let m = 0, b = 0;
                    function readBit() {
                        if (b > 0) {
                            b--;
                            return m >> b & 1;
                        }
                        m = e1[t++];
                        if (255 === m) {
                            const r = e1[t++];
                            if (r) {
                                if (220 === r && d) {
                                    t += 2;
                                    const r = (0, i.readUint16)(e1, t);
                                    t += 2;
                                    if (r > 0 && r !== a.scanLines) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", r);
                                } else if (217 === r) {
                                    if (d) {
                                        const e1 = x * (8 === a.precision ? 8 : 0);
                                        if (e1 > 0 && Math.round(a.scanLines / e1) >= 5) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", e1);
                                    }
                                    throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                                }
                                throw new JpegError(`unexpected marker ${(m << 8 | r).toString(16)}`);
                            }
                        }
                        b = 7;
                        return m >>> 7;
                    }
                    function decodeHuffman(e1) {
                        let t = e1;
                        for(;;){
                            t = t[readBit()];
                            switch(typeof t){
                                case "number":
                                    return t;
                                case "object":
                                    continue;
                            }
                            throw new JpegError("invalid huffman sequence");
                        }
                    }
                    function receive(e1) {
                        let t = 0;
                        for(; e1 > 0;){
                            t = t << 1 | readBit();
                            e1--;
                        }
                        return t;
                    }
                    function receiveAndExtend(e1) {
                        if (1 === e1) return 1 === readBit() ? 1 : -1;
                        const t = receive(e1);
                        return t >= 1 << e1 - 1 ? t : t + (-1 << e1) + 1;
                    }
                    let y = 0;
                    let w, S = 0;
                    let x = 0;
                    function decodeMcu(e1, t, a, r, n) {
                        const i = a % f;
                        x = (a / f | 0) * e1.v + r;
                        const s = i * e1.h + n;
                        t(e1, getBlockBufferOffset(e1, x, s));
                    }
                    function decodeBlock(e1, t, a) {
                        x = a / e1.blocksPerLine | 0;
                        const r = a % e1.blocksPerLine;
                        t(e1, getBlockBufferOffset(e1, x, r));
                    }
                    const C = n.length;
                    let k, v, F, O, T, M;
                    M = g ? 0 === c ? 0 === h ? function decodeDCFirst(e1, t) {
                        const a = decodeHuffman(e1.huffmanTableDC), r = 0 === a ? 0 : receiveAndExtend(a) << u;
                        e1.blockData[t] = e1.pred += r;
                    } : function decodeDCSuccessive(e1, t) {
                        e1.blockData[t] |= readBit() << u;
                    } : 0 === h ? function decodeACFirst(e1, t) {
                        if (y > 0) {
                            y--;
                            return;
                        }
                        let a = c;
                        const r = l;
                        for(; a <= r;){
                            const r = decodeHuffman(e1.huffmanTableAC), n = 15 & r, i = r >> 4;
                            if (0 === n) {
                                if (i < 15) {
                                    y = receive(i) + (1 << i) - 1;
                                    break;
                                }
                                a += 16;
                                continue;
                            }
                            a += i;
                            const o = s[a];
                            e1.blockData[t + o] = receiveAndExtend(n) * (1 << u);
                            a++;
                        }
                    } : function decodeACSuccessive(e1, t) {
                        let a = c;
                        const r = l;
                        let n, i, o = 0;
                        for(; a <= r;){
                            const r = t + s[a], c = e1.blockData[r] < 0 ? -1 : 1;
                            switch(S){
                                case 0:
                                    i = decodeHuffman(e1.huffmanTableAC);
                                    n = 15 & i;
                                    o = i >> 4;
                                    if (0 === n) {
                                        if (o < 15) {
                                            y = receive(o) + (1 << o);
                                            S = 4;
                                        } else {
                                            o = 16;
                                            S = 1;
                                        }
                                    } else {
                                        if (1 !== n) throw new JpegError("invalid ACn encoding");
                                        w = receiveAndExtend(n);
                                        S = o ? 2 : 3;
                                    }
                                    continue;
                                case 1:
                                case 2:
                                    if (e1.blockData[r]) e1.blockData[r] += c * (readBit() << u);
                                    else {
                                        o--;
                                        0 === o && (S = 2 === S ? 3 : 0);
                                    }
                                    break;
                                case 3:
                                    if (e1.blockData[r]) e1.blockData[r] += c * (readBit() << u);
                                    else {
                                        e1.blockData[r] = w << u;
                                        S = 0;
                                    }
                                    break;
                                case 4:
                                    e1.blockData[r] && (e1.blockData[r] += c * (readBit() << u));
                            }
                            a++;
                        }
                        if (4 === S) {
                            y--;
                            0 === y && (S = 0);
                        }
                    } : function decodeBaseline(e1, t) {
                        const a = decodeHuffman(e1.huffmanTableDC), r = 0 === a ? 0 : receiveAndExtend(a);
                        e1.blockData[t] = e1.pred += r;
                        let n = 1;
                        for(; n < 64;){
                            const a = decodeHuffman(e1.huffmanTableAC), r = 15 & a, i = a >> 4;
                            if (0 === r) {
                                if (i < 15) break;
                                n += 16;
                                continue;
                            }
                            n += i;
                            const o = s[n];
                            e1.blockData[t + o] = receiveAndExtend(r);
                            n++;
                        }
                    };
                    let D, E = 0;
                    const N = 1 === C ? n[0].blocksPerLine * n[0].blocksPerColumn : f * a.mcusPerColumn;
                    let R, L;
                    for(; E <= N;){
                        const a = o ? Math.min(N - E, o) : N;
                        if (a > 0) {
                            for(v = 0; v < C; v++)n[v].pred = 0;
                            y = 0;
                            if (1 === C) {
                                k = n[0];
                                for(T = 0; T < a; T++){
                                    decodeBlock(k, M, E);
                                    E++;
                                }
                            } else for(T = 0; T < a; T++){
                                for(v = 0; v < C; v++){
                                    k = n[v];
                                    R = k.h;
                                    L = k.v;
                                    for(F = 0; F < L; F++)for(O = 0; O < R; O++)decodeMcu(k, M, E, F, O);
                                }
                                E++;
                            }
                        }
                        b = 0;
                        D = findNextFileMarker(e1, t);
                        if (!D) break;
                        if (D.invalid) {
                            const e1 = a > 0 ? "unexpected" : "excessive";
                            (0, r.warn)(`decodeScan - ${e1} MCU data, current marker is: ${D.invalid}`);
                            t = D.offset;
                        }
                        if (!(D.marker >= 65488 && D.marker <= 65495)) break;
                        t += 2;
                    }
                    return t - p;
                }
                function quantizeAndInverse(e1, t, a) {
                    const r = e1.quantizationTable, n = e1.blockData;
                    let i, s, p, m, b, y, w, S, x, C, k, v, F, O, T, M, D;
                    if (!r) throw new JpegError("missing required Quantization Table.");
                    for(let e1 = 0; e1 < 64; e1 += 8){
                        x = n[t + e1];
                        C = n[t + e1 + 1];
                        k = n[t + e1 + 2];
                        v = n[t + e1 + 3];
                        F = n[t + e1 + 4];
                        O = n[t + e1 + 5];
                        T = n[t + e1 + 6];
                        M = n[t + e1 + 7];
                        x *= r[e1];
                        if (0 != (C | k | v | F | O | T | M)) {
                            C *= r[e1 + 1];
                            k *= r[e1 + 2];
                            v *= r[e1 + 3];
                            F *= r[e1 + 4];
                            O *= r[e1 + 5];
                            T *= r[e1 + 6];
                            M *= r[e1 + 7];
                            i = f * x + 128 >> 8;
                            s = f * F + 128 >> 8;
                            p = k;
                            m = T;
                            b = g * (C - M) + 128 >> 8;
                            S = g * (C + M) + 128 >> 8;
                            y = v << 4;
                            w = O << 4;
                            i = i + s + 1 >> 1;
                            s = i - s;
                            D = p * d + m * u + 128 >> 8;
                            p = p * u - m * d + 128 >> 8;
                            m = D;
                            b = b + w + 1 >> 1;
                            w = b - w;
                            S = S + y + 1 >> 1;
                            y = S - y;
                            i = i + m + 1 >> 1;
                            m = i - m;
                            s = s + p + 1 >> 1;
                            p = s - p;
                            D = b * h + S * l + 2048 >> 12;
                            b = b * l - S * h + 2048 >> 12;
                            S = D;
                            D = y * c + w * o + 2048 >> 12;
                            y = y * o - w * c + 2048 >> 12;
                            w = D;
                            a[e1] = i + S;
                            a[e1 + 7] = i - S;
                            a[e1 + 1] = s + w;
                            a[e1 + 6] = s - w;
                            a[e1 + 2] = p + y;
                            a[e1 + 5] = p - y;
                            a[e1 + 3] = m + b;
                            a[e1 + 4] = m - b;
                        } else {
                            D = f * x + 512 >> 10;
                            a[e1] = D;
                            a[e1 + 1] = D;
                            a[e1 + 2] = D;
                            a[e1 + 3] = D;
                            a[e1 + 4] = D;
                            a[e1 + 5] = D;
                            a[e1 + 6] = D;
                            a[e1 + 7] = D;
                        }
                    }
                    for(let e1 = 0; e1 < 8; ++e1){
                        x = a[e1];
                        C = a[e1 + 8];
                        k = a[e1 + 16];
                        v = a[e1 + 24];
                        F = a[e1 + 32];
                        O = a[e1 + 40];
                        T = a[e1 + 48];
                        M = a[e1 + 56];
                        if (0 != (C | k | v | F | O | T | M)) {
                            i = f * x + 2048 >> 12;
                            s = f * F + 2048 >> 12;
                            p = k;
                            m = T;
                            b = g * (C - M) + 2048 >> 12;
                            S = g * (C + M) + 2048 >> 12;
                            y = v;
                            w = O;
                            i = 4112 + (i + s + 1 >> 1);
                            s = i - s;
                            D = p * d + m * u + 2048 >> 12;
                            p = p * u - m * d + 2048 >> 12;
                            m = D;
                            b = b + w + 1 >> 1;
                            w = b - w;
                            S = S + y + 1 >> 1;
                            y = S - y;
                            i = i + m + 1 >> 1;
                            m = i - m;
                            s = s + p + 1 >> 1;
                            p = s - p;
                            D = b * h + S * l + 2048 >> 12;
                            b = b * l - S * h + 2048 >> 12;
                            S = D;
                            D = y * c + w * o + 2048 >> 12;
                            y = y * o - w * c + 2048 >> 12;
                            w = D;
                            x = i + S;
                            M = i - S;
                            C = s + w;
                            T = s - w;
                            k = p + y;
                            O = p - y;
                            v = m + b;
                            F = m - b;
                            x < 16 ? x = 0 : x >= 4080 ? x = 255 : x >>= 4;
                            C < 16 ? C = 0 : C >= 4080 ? C = 255 : C >>= 4;
                            k < 16 ? k = 0 : k >= 4080 ? k = 255 : k >>= 4;
                            v < 16 ? v = 0 : v >= 4080 ? v = 255 : v >>= 4;
                            F < 16 ? F = 0 : F >= 4080 ? F = 255 : F >>= 4;
                            O < 16 ? O = 0 : O >= 4080 ? O = 255 : O >>= 4;
                            T < 16 ? T = 0 : T >= 4080 ? T = 255 : T >>= 4;
                            M < 16 ? M = 0 : M >= 4080 ? M = 255 : M >>= 4;
                            n[t + e1] = x;
                            n[t + e1 + 8] = C;
                            n[t + e1 + 16] = k;
                            n[t + e1 + 24] = v;
                            n[t + e1 + 32] = F;
                            n[t + e1 + 40] = O;
                            n[t + e1 + 48] = T;
                            n[t + e1 + 56] = M;
                        } else {
                            D = f * x + 8192 >> 14;
                            D = D < -2040 ? 0 : D >= 2024 ? 255 : D + 2056 >> 4;
                            n[t + e1] = D;
                            n[t + e1 + 8] = D;
                            n[t + e1 + 16] = D;
                            n[t + e1 + 24] = D;
                            n[t + e1 + 32] = D;
                            n[t + e1 + 40] = D;
                            n[t + e1 + 48] = D;
                            n[t + e1 + 56] = D;
                        }
                    }
                }
                function buildComponentData(e1, t) {
                    const a = t.blocksPerLine, r = t.blocksPerColumn, n = new Int16Array(64);
                    for(let e1 = 0; e1 < r; e1++)for(let r = 0; r < a; r++)quantizeAndInverse(t, getBlockBufferOffset(t, e1, r), n);
                    return t.blockData;
                }
                function findNextFileMarker(e1, t, a = t) {
                    const r = e1.length - 1;
                    let n = a < t ? a : t;
                    if (t >= r) return null;
                    const s = (0, i.readUint16)(e1, t);
                    if (s >= 65472 && s <= 65534) return {
                        invalid: null,
                        marker: s,
                        offset: t
                    };
                    let o = (0, i.readUint16)(e1, n);
                    for(; !(o >= 65472 && o <= 65534);){
                        if (++n >= r) return null;
                        o = (0, i.readUint16)(e1, n);
                    }
                    return {
                        invalid: s.toString(16),
                        marker: o,
                        offset: n
                    };
                }
                t.JpegImage = class JpegImage {
                    constructor({ decodeTransform: e1 = null, colorTransform: t = -1 } = {}){
                        this._decodeTransform = e1;
                        this._colorTransform = t;
                    }
                    parse(e1, { dnlScanLines: t = null } = {}) {
                        function readDataBlock() {
                            const t = (0, i.readUint16)(e1, o);
                            o += 2;
                            let a = o + t - 2;
                            const n = findNextFileMarker(e1, a, o);
                            if (n?.invalid) {
                                (0, r.warn)("readDataBlock - incorrect length, current marker is: " + n.invalid);
                                a = n.offset;
                            }
                            const s = e1.subarray(o, a);
                            o += s.length;
                            return s;
                        }
                        function prepareComponents(e1) {
                            const t = Math.ceil(e1.samplesPerLine / 8 / e1.maxH), a = Math.ceil(e1.scanLines / 8 / e1.maxV);
                            for (const r of e1.components){
                                const n = Math.ceil(Math.ceil(e1.samplesPerLine / 8) * r.h / e1.maxH), i = Math.ceil(Math.ceil(e1.scanLines / 8) * r.v / e1.maxV), s = t * r.h, o = 64 * (a * r.v) * (s + 1);
                                r.blockData = new Int16Array(o);
                                r.blocksPerLine = n;
                                r.blocksPerColumn = i;
                            }
                            e1.mcusPerLine = t;
                            e1.mcusPerColumn = a;
                        }
                        let a, n, o = 0, c = null, l = null, h = 0;
                        const u = [], d = [], f = [];
                        let g = (0, i.readUint16)(e1, o);
                        o += 2;
                        if (65496 !== g) throw new JpegError("SOI not found");
                        g = (0, i.readUint16)(e1, o);
                        o += 2;
                        e: for(; 65497 !== g;){
                            let p, m, b;
                            switch(g){
                                case 65504:
                                case 65505:
                                case 65506:
                                case 65507:
                                case 65508:
                                case 65509:
                                case 65510:
                                case 65511:
                                case 65512:
                                case 65513:
                                case 65514:
                                case 65515:
                                case 65516:
                                case 65517:
                                case 65518:
                                case 65519:
                                case 65534:
                                    const y = readDataBlock();
                                    65504 === g && 74 === y[0] && 70 === y[1] && 73 === y[2] && 70 === y[3] && 0 === y[4] && (c = {
                                        version: {
                                            major: y[5],
                                            minor: y[6]
                                        },
                                        densityUnits: y[7],
                                        xDensity: y[8] << 8 | y[9],
                                        yDensity: y[10] << 8 | y[11],
                                        thumbWidth: y[12],
                                        thumbHeight: y[13],
                                        thumbData: y.subarray(14, 14 + 3 * y[12] * y[13])
                                    });
                                    65518 === g && 65 === y[0] && 100 === y[1] && 111 === y[2] && 98 === y[3] && 101 === y[4] && (l = {
                                        version: y[5] << 8 | y[6],
                                        flags0: y[7] << 8 | y[8],
                                        flags1: y[9] << 8 | y[10],
                                        transformCode: y[11]
                                    });
                                    break;
                                case 65499:
                                    const w = (0, i.readUint16)(e1, o);
                                    o += 2;
                                    const S = w + o - 2;
                                    let x;
                                    for(; o < S;){
                                        const t = e1[o++], a = new Uint16Array(64);
                                        if (t >> 4 == 0) for(m = 0; m < 64; m++){
                                            x = s[m];
                                            a[x] = e1[o++];
                                        }
                                        else {
                                            if (t >> 4 != 1) throw new JpegError("DQT - invalid table spec");
                                            for(m = 0; m < 64; m++){
                                                x = s[m];
                                                a[x] = (0, i.readUint16)(e1, o);
                                                o += 2;
                                            }
                                        }
                                        u[15 & t] = a;
                                    }
                                    break;
                                case 65472:
                                case 65473:
                                case 65474:
                                    if (a) throw new JpegError("Only single frame JPEGs supported");
                                    o += 2;
                                    a = {};
                                    a.extended = 65473 === g;
                                    a.progressive = 65474 === g;
                                    a.precision = e1[o++];
                                    const C = (0, i.readUint16)(e1, o);
                                    o += 2;
                                    a.scanLines = t || C;
                                    a.samplesPerLine = (0, i.readUint16)(e1, o);
                                    o += 2;
                                    a.components = [];
                                    a.componentIds = {};
                                    const k = e1[o++];
                                    let v = 0, F = 0;
                                    for(p = 0; p < k; p++){
                                        const t = e1[o], r = e1[o + 1] >> 4, n = 15 & e1[o + 1];
                                        v < r && (v = r);
                                        F < n && (F = n);
                                        const i = e1[o + 2];
                                        b = a.components.push({
                                            h: r,
                                            v: n,
                                            quantizationId: i,
                                            quantizationTable: null
                                        });
                                        a.componentIds[t] = b - 1;
                                        o += 3;
                                    }
                                    a.maxH = v;
                                    a.maxV = F;
                                    prepareComponents(a);
                                    break;
                                case 65476:
                                    const O = (0, i.readUint16)(e1, o);
                                    o += 2;
                                    for(p = 2; p < O;){
                                        const t = e1[o++], a = new Uint8Array(16);
                                        let r = 0;
                                        for(m = 0; m < 16; m++, o++)r += a[m] = e1[o];
                                        const n = new Uint8Array(r);
                                        for(m = 0; m < r; m++, o++)n[m] = e1[o];
                                        p += 17 + r;
                                        (t >> 4 == 0 ? f : d)[15 & t] = buildHuffmanTable(a, n);
                                    }
                                    break;
                                case 65501:
                                    o += 2;
                                    n = (0, i.readUint16)(e1, o);
                                    o += 2;
                                    break;
                                case 65498:
                                    const T = 1 == ++h && !t;
                                    o += 2;
                                    const M = e1[o++], D = [];
                                    for(p = 0; p < M; p++){
                                        const t = e1[o++], r = a.componentIds[t], n = a.components[r];
                                        n.index = t;
                                        const i = e1[o++];
                                        n.huffmanTableDC = f[i >> 4];
                                        n.huffmanTableAC = d[15 & i];
                                        D.push(n);
                                    }
                                    const E = e1[o++], N = e1[o++], R = e1[o++];
                                    try {
                                        const t = decodeScan(e1, o, a, D, n, E, N, R >> 4, 15 & R, T);
                                        o += t;
                                    } catch (t) {
                                        if (t instanceof DNLMarkerError) {
                                            (0, r.warn)(`${t.message} -- attempting to re-parse the JPEG image.`);
                                            return this.parse(e1, {
                                                dnlScanLines: t.scanLines
                                            });
                                        }
                                        if (t instanceof EOIMarkerError) {
                                            (0, r.warn)(`${t.message} -- ignoring the rest of the image data.`);
                                            break e;
                                        }
                                        throw t;
                                    }
                                    break;
                                case 65500:
                                    o += 4;
                                    break;
                                case 65535:
                                    255 !== e1[o] && o--;
                                    break;
                                default:
                                    const L = findNextFileMarker(e1, o - 2, o - 3);
                                    if (L?.invalid) {
                                        (0, r.warn)("JpegImage.parse - unexpected data, current marker is: " + L.invalid);
                                        o = L.offset;
                                        break;
                                    }
                                    if (!L || o >= e1.length - 1) {
                                        (0, r.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                                        break e;
                                    }
                                    throw new JpegError("JpegImage.parse - unknown marker: " + g.toString(16));
                            }
                            g = (0, i.readUint16)(e1, o);
                            o += 2;
                        }
                        this.width = a.samplesPerLine;
                        this.height = a.scanLines;
                        this.jfif = c;
                        this.adobe = l;
                        this.components = [];
                        for (const e1 of a.components){
                            const t = u[e1.quantizationId];
                            t && (e1.quantizationTable = t);
                            this.components.push({
                                index: e1.index,
                                output: buildComponentData(0, e1),
                                scaleX: e1.h / a.maxH,
                                scaleY: e1.v / a.maxV,
                                blocksPerLine: e1.blocksPerLine,
                                blocksPerColumn: e1.blocksPerColumn
                            });
                        }
                        this.numComponents = this.components.length;
                    }
                    _getLinearizedBlockData(e1, t, a = !1) {
                        const r = this.width / e1, n = this.height / t;
                        let i, s, o, c, l, h, u, d, f, g, p, m = 0;
                        const b = this.components.length, y = e1 * t * b, w = new Uint8ClampedArray(y), S = new Uint32Array(e1), x = 4294967288;
                        let C;
                        for(u = 0; u < b; u++){
                            i = this.components[u];
                            s = i.scaleX * r;
                            o = i.scaleY * n;
                            m = u;
                            p = i.output;
                            c = i.blocksPerLine + 1 << 3;
                            if (s !== C) {
                                for(l = 0; l < e1; l++){
                                    d = 0 | l * s;
                                    S[l] = (d & x) << 3 | 7 & d;
                                }
                                C = s;
                            }
                            for(h = 0; h < t; h++){
                                d = 0 | h * o;
                                g = c * (d & x) | (7 & d) << 3;
                                for(l = 0; l < e1; l++){
                                    w[m] = p[g + S[l]];
                                    m += b;
                                }
                            }
                        }
                        let k = this._decodeTransform;
                        a || 4 !== b || k || (k = new Int32Array([
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255
                        ]));
                        if (k) for(u = 0; u < y;)for(d = 0, f = 0; d < b; d++, u++, f += 2)w[u] = (w[u] * k[f] >> 8) + k[f + 1];
                        return w;
                    }
                    get _isColorConversionNeeded() {
                        return this.adobe ? !!this.adobe.transformCode : 3 === this.numComponents ? 0 !== this._colorTransform && (82 !== this.components[0].index || 71 !== this.components[1].index || 66 !== this.components[2].index) : 1 === this._colorTransform;
                    }
                    _convertYccToRgb(e1) {
                        let t, a, r;
                        for(let n = 0, i = e1.length; n < i; n += 3){
                            t = e1[n];
                            a = e1[n + 1];
                            r = e1[n + 2];
                            e1[n] = t - 179.456 + 1.402 * r;
                            e1[n + 1] = t + 135.459 - .344 * a - .714 * r;
                            e1[n + 2] = t - 226.816 + 1.772 * a;
                        }
                        return e1;
                    }
                    _convertYccToRgba(e1, t) {
                        for(let a = 0, r = 0, n = e1.length; a < n; a += 3, r += 4){
                            const n = e1[a], i = e1[a + 1], s = e1[a + 2];
                            t[r] = n - 179.456 + 1.402 * s;
                            t[r + 1] = n + 135.459 - .344 * i - .714 * s;
                            t[r + 2] = n - 226.816 + 1.772 * i;
                            t[r + 3] = 255;
                        }
                        return t;
                    }
                    _convertYcckToRgb(e1) {
                        let t, a, r, n, i = 0;
                        for(let s = 0, o = e1.length; s < o; s += 4){
                            t = e1[s];
                            a = e1[s + 1];
                            r = e1[s + 2];
                            n = e1[s + 3];
                            e1[i++] = a * (-0.0000660635669420364 * a + .000437130475926232 * r - 54080610064599e-18 * t + .00048449797120281 * n - .154362151871126) - 122.67195406894 + r * (-0.000957964378445773 * r + .000817076911346625 * t - .00477271405408747 * n + 1.53380253221734) + t * (.000961250184130688 * t - .00266257332283933 * n + .48357088451265) + n * (-0.000336197177618394 * n + .484791561490776);
                            e1[i++] = 107.268039397724 + a * (219927104525741e-19 * a - .000640992018297945 * r + .000659397001245577 * t + .000426105652938837 * n - .176491792462875) + r * (-0.000778269941513683 * r + .00130872261408275 * t + .000770482631801132 * n - .151051492775562) + t * (.00126935368114843 * t - .00265090189010898 * n + .25802910206845) + n * (-0.000318913117588328 * n - .213742400323665);
                            e1[i++] = a * (-0.000570115196973677 * a - 263409051004589e-19 * r + .0020741088115012 * t - .00288260236853442 * n + .814272968359295) - 20.810012546947 + r * (-0.0000153496057440975 * r - .000132689043961446 * t + .000560833691242812 * n - .195152027534049) + t * (.00174418132927582 * t - .00255243321439347 * n + .116935020465145) + n * (-0.000343531996510555 * n + .24165260232407);
                        }
                        return e1.subarray(0, i);
                    }
                    _convertYcckToRgba(e1) {
                        for(let t = 0, a = e1.length; t < a; t += 4){
                            const a = e1[t], r = e1[t + 1], n = e1[t + 2], i = e1[t + 3];
                            e1[t] = r * (-0.0000660635669420364 * r + .000437130475926232 * n - 54080610064599e-18 * a + .00048449797120281 * i - .154362151871126) - 122.67195406894 + n * (-0.000957964378445773 * n + .000817076911346625 * a - .00477271405408747 * i + 1.53380253221734) + a * (.000961250184130688 * a - .00266257332283933 * i + .48357088451265) + i * (-0.000336197177618394 * i + .484791561490776);
                            e1[t + 1] = 107.268039397724 + r * (219927104525741e-19 * r - .000640992018297945 * n + .000659397001245577 * a + .000426105652938837 * i - .176491792462875) + n * (-0.000778269941513683 * n + .00130872261408275 * a + .000770482631801132 * i - .151051492775562) + a * (.00126935368114843 * a - .00265090189010898 * i + .25802910206845) + i * (-0.000318913117588328 * i - .213742400323665);
                            e1[t + 2] = r * (-0.000570115196973677 * r - 263409051004589e-19 * n + .0020741088115012 * a - .00288260236853442 * i + .814272968359295) - 20.810012546947 + n * (-0.0000153496057440975 * n - .000132689043961446 * a + .000560833691242812 * i - .195152027534049) + a * (.00174418132927582 * a - .00255243321439347 * i + .116935020465145) + i * (-0.000343531996510555 * i + .24165260232407);
                            e1[t + 3] = 255;
                        }
                        return e1;
                    }
                    _convertYcckToCmyk(e1) {
                        let t, a, r;
                        for(let n = 0, i = e1.length; n < i; n += 4){
                            t = e1[n];
                            a = e1[n + 1];
                            r = e1[n + 2];
                            e1[n] = 434.456 - t - 1.402 * r;
                            e1[n + 1] = 119.541 - t + .344 * a + .714 * r;
                            e1[n + 2] = 481.816 - t - 1.772 * a;
                        }
                        return e1;
                    }
                    _convertCmykToRgb(e1) {
                        let t, a, r, n, i = 0;
                        for(let s = 0, o = e1.length; s < o; s += 4){
                            t = e1[s];
                            a = e1[s + 1];
                            r = e1[s + 2];
                            n = e1[s + 3];
                            e1[i++] = 255 + t * (-0.00006747147073602441 * t + .0008379262121013727 * a + .0002894718188643294 * r + .003264231057537806 * n - 1.1185611867203937) + a * (26374107616089405e-21 * a - 8626949158638572e-20 * r - .0002748769067499491 * n - .02155688794978967) + r * (-0.00003878099212869363 * r - .0003267808279485286 * n + .0686742238595345) - n * (.0003361971776183937 * n + .7430659151342254);
                            e1[i++] = 255 + t * (.00013596372813588848 * t + .000924537132573585 * a + .00010567359618683593 * r + .0004791864687436512 * n - .3109689587515875) + a * (-0.00023545346108370344 * a + .0002702845253534714 * r + .0020200308977307156 * n - .7488052167015494) + r * (6834815998235662e-20 * r + .00015168452363460973 * n - .09751927774728933) - n * (.0003189131175883281 * n + .7364883807733168);
                            e1[i++] = 255 + t * (13598650411385307e-21 * t + .00012423956175490851 * a + .0004751985097583589 * r - 36729317476630422e-22 * n - .05562186980264034) + a * (.00016141380598724676 * a + .0009692239130725186 * r + .0007782692450036253 * n - .44015232367526463) + r * (5.068882914068769e-7 * r + .0017778369011375071 * n - .7591454649749609) - n * (.0003435319965105553 * n + .7063770186160144);
                        }
                        return e1.subarray(0, i);
                    }
                    _convertCmykToRgba(e1) {
                        for(let t = 0, a = e1.length; t < a; t += 4){
                            const a = e1[t], r = e1[t + 1], n = e1[t + 2], i = e1[t + 3];
                            e1[t] = 255 + a * (-0.00006747147073602441 * a + .0008379262121013727 * r + .0002894718188643294 * n + .003264231057537806 * i - 1.1185611867203937) + r * (26374107616089405e-21 * r - 8626949158638572e-20 * n - .0002748769067499491 * i - .02155688794978967) + n * (-0.00003878099212869363 * n - .0003267808279485286 * i + .0686742238595345) - i * (.0003361971776183937 * i + .7430659151342254);
                            e1[t + 1] = 255 + a * (.00013596372813588848 * a + .000924537132573585 * r + .00010567359618683593 * n + .0004791864687436512 * i - .3109689587515875) + r * (-0.00023545346108370344 * r + .0002702845253534714 * n + .0020200308977307156 * i - .7488052167015494) + n * (6834815998235662e-20 * n + .00015168452363460973 * i - .09751927774728933) - i * (.0003189131175883281 * i + .7364883807733168);
                            e1[t + 2] = 255 + a * (13598650411385307e-21 * a + .00012423956175490851 * r + .0004751985097583589 * n - 36729317476630422e-22 * i - .05562186980264034) + r * (.00016141380598724676 * r + .0009692239130725186 * n + .0007782692450036253 * i - .44015232367526463) + n * (5.068882914068769e-7 * n + .0017778369011375071 * i - .7591454649749609) - i * (.0003435319965105553 * i + .7063770186160144);
                            e1[t + 3] = 255;
                        }
                        return e1;
                    }
                    getData({ width: e1, height: t, forceRGBA: a = !1, forceRGB: r = !1, isSourcePDF: i = !1 }) {
                        if (this.numComponents > 4) throw new JpegError("Unsupported color mode");
                        const s = this._getLinearizedBlockData(e1, t, i);
                        if (1 === this.numComponents && (a || r)) {
                            const e1 = s.length * (a ? 4 : 3), t = new Uint8ClampedArray(e1);
                            let r = 0;
                            if (a) (0, n.grayToRGBA)(s, new Uint32Array(t.buffer));
                            else for (const e1 of s){
                                t[r++] = e1;
                                t[r++] = e1;
                                t[r++] = e1;
                            }
                            return t;
                        }
                        if (3 === this.numComponents && this._isColorConversionNeeded) {
                            if (a) {
                                const e1 = new Uint8ClampedArray(s.length / 3 * 4);
                                return this._convertYccToRgba(s, e1);
                            }
                            return this._convertYccToRgb(s);
                        }
                        if (4 === this.numComponents) {
                            if (this._isColorConversionNeeded) return a ? this._convertYcckToRgba(s) : r ? this._convertYcckToRgb(s) : this._convertYcckToCmyk(s);
                            if (a) return this._convertCmykToRgba(s);
                            if (r) return this._convertCmykToRgb(s);
                        }
                        return s;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                t.convertToRGBA = function convertToRGBA(e1) {
                    switch(e1.kind){
                        case r.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(e1);
                        case r.ImageKind.RGB_24BPP:
                            return function convertRGBToRGBA({ src: e1, srcPos: t = 0, dest: a, destPos: n = 0, width: i, height: s }) {
                                let o = 0;
                                const c = e1.length >> 2, l = new Uint32Array(e1.buffer, t, c);
                                if (r.FeatureTest.isLittleEndian) {
                                    for(; o < c - 2; o += 3, n += 4){
                                        const e1 = l[o], t = l[o + 1], r = l[o + 2];
                                        a[n] = 4278190080 | e1;
                                        a[n + 1] = e1 >>> 24 | t << 8 | 4278190080;
                                        a[n + 2] = t >>> 16 | r << 16 | 4278190080;
                                        a[n + 3] = r >>> 8 | 4278190080;
                                    }
                                    for(let t = 4 * o, r = e1.length; t < r; t += 3)a[n++] = e1[t] | e1[t + 1] << 8 | e1[t + 2] << 16 | 4278190080;
                                } else {
                                    for(; o < c - 2; o += 3, n += 4){
                                        const e1 = l[o], t = l[o + 1], r = l[o + 2];
                                        a[n] = 255 | e1;
                                        a[n + 1] = e1 << 24 | t >>> 8 | 255;
                                        a[n + 2] = t << 16 | r >>> 16 | 255;
                                        a[n + 3] = r << 8 | 255;
                                    }
                                    for(let t = 4 * o, r = e1.length; t < r; t += 3)a[n++] = e1[t] << 24 | e1[t + 1] << 16 | e1[t + 2] << 8 | 255;
                                }
                                return {
                                    srcPos: t,
                                    destPos: n
                                };
                            }(e1);
                    }
                    return null;
                };
                t.grayToRGBA = function grayToRGBA(e1, t) {
                    if (r.FeatureTest.isLittleEndian) for(let a = 0, r = e1.length; a < r; a++)t[a] = 65793 * e1[a] | 4278190080;
                    else for(let a = 0, r = e1.length; a < r; a++)t[a] = 16843008 * e1[a] | 255;
                };
                var r = a(2);
                function convertBlackAndWhiteToRGBA({ src: e1, srcPos: t = 0, dest: a, width: n, height: i, nonBlackColor: s = 4294967295, inverseDecode: o = !1 }) {
                    const c = r.FeatureTest.isLittleEndian ? 4278190080 : 255, [l, h] = o ? [
                        s,
                        c
                    ] : [
                        c,
                        s
                    ], u = n >> 3, d = 7 & n, f = e1.length;
                    a = new Uint32Array(a.buffer);
                    let g = 0;
                    for(let r = 0; r < i; r++){
                        for(const r = t + u; t < r; t++){
                            const r = t < f ? e1[t] : 255;
                            a[g++] = 128 & r ? h : l;
                            a[g++] = 64 & r ? h : l;
                            a[g++] = 32 & r ? h : l;
                            a[g++] = 16 & r ? h : l;
                            a[g++] = 8 & r ? h : l;
                            a[g++] = 4 & r ? h : l;
                            a[g++] = 2 & r ? h : l;
                            a[g++] = 1 & r ? h : l;
                        }
                        if (0 === d) continue;
                        const r = t < f ? e1[t++] : 255;
                        for(let e1 = 0; e1 < d; e1++)a[g++] = r & 1 << 7 - e1 ? h : l;
                    }
                    return {
                        srcPos: t,
                        destPos: g
                    };
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.JpxStream = void 0;
                var r = a(18), n = a(30), i = a(2);
                class JpxStream extends r.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        this.stream = e1;
                        this.dict = e1.dict;
                        this.maybeLength = t;
                        this.params = a;
                    }
                    get bytes() {
                        return (0, i.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(e1) {}
                    readBlock() {
                        if (this.eof) return;
                        const e1 = new n.JpxImage;
                        e1.parse(this.bytes);
                        const t = e1.width, a = e1.height, r = e1.componentsCount, i = e1.tiles.length;
                        if (1 === i) this.buffer = e1.tiles[0].items;
                        else {
                            const n = new Uint8ClampedArray(t * a * r);
                            for(let a = 0; a < i; a++){
                                const i = e1.tiles[a], s = i.width, o = i.height, c = i.left, l = i.top, h = i.items;
                                let u = 0, d = (t * l + c) * r;
                                const f = t * r, g = s * r;
                                for(let e1 = 0; e1 < o; e1++){
                                    const e1 = h.subarray(u, u + g);
                                    n.set(e1, d);
                                    u += g;
                                    d += f;
                                }
                            }
                            this.buffer = n;
                        }
                        this.bufferLength = this.buffer.length;
                        this.eof = !0;
                    }
                }
                t.JpxStream = JpxStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.JpxImage = void 0;
                var r = a(2), n = a(3), i = a(25);
                class JpxError extends r.BaseException {
                    constructor(e1){
                        super(`JPX error: ${e1}`, "JpxError");
                    }
                }
                const s = {
                    LL: 0,
                    LH: 1,
                    HL: 1,
                    HH: 2
                };
                t.JpxImage = class JpxImage {
                    constructor(){
                        this.failOnCorruptedImage = !1;
                    }
                    parse(e1) {
                        if (65359 === (0, n.readUint16)(e1, 0)) {
                            this.parseCodestream(e1, 0, e1.length);
                            return;
                        }
                        const t = e1.length;
                        let a = 0;
                        for(; a < t;){
                            let i = 8, s = (0, n.readUint32)(e1, a);
                            const o = (0, n.readUint32)(e1, a + 4);
                            a += i;
                            if (1 === s) {
                                s = 4294967296 * (0, n.readUint32)(e1, a) + (0, n.readUint32)(e1, a + 4);
                                a += 8;
                                i += 8;
                            }
                            0 === s && (s = t - a + i);
                            if (s < i) throw new JpxError("Invalid box field size");
                            const c = s - i;
                            let l = !0;
                            switch(o){
                                case 1785737832:
                                    l = !1;
                                    break;
                                case 1668246642:
                                    const t1 = e1[a];
                                    if (1 === t1) {
                                        const t = (0, n.readUint32)(e1, a + 3);
                                        switch(t){
                                            case 16:
                                            case 17:
                                            case 18:
                                                break;
                                            default:
                                                (0, r.warn)("Unknown colorspace " + t);
                                        }
                                    } else 2 === t1 && (0, r.info)("ICC profile not supported");
                                    break;
                                case 1785737827:
                                    this.parseCodestream(e1, a, a + c);
                                    break;
                                case 1783636e3:
                                    218793738 !== (0, n.readUint32)(e1, a) && (0, r.warn)("Invalid JP2 signature");
                                    break;
                                case 1783634458:
                                case 1718909296:
                                case 1920099697:
                                case 1919251232:
                                case 1768449138:
                                    break;
                                default:
                                    const i1 = String.fromCharCode(o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o);
                                    (0, r.warn)(`Unsupported header type ${o} (${i1}).`);
                            }
                            l && (a += c);
                        }
                    }
                    parseImageProperties(e1) {
                        let t = e1.getByte();
                        for(; t >= 0;){
                            const a = t;
                            t = e1.getByte();
                            if (65361 === (a << 8 | t)) {
                                e1.skip(4);
                                const t = e1.getInt32() >>> 0, a = e1.getInt32() >>> 0, r = e1.getInt32() >>> 0, n = e1.getInt32() >>> 0;
                                e1.skip(16);
                                const i = e1.getUint16();
                                this.width = t - r;
                                this.height = a - n;
                                this.componentsCount = i;
                                this.bitsPerComponent = 8;
                                return;
                            }
                        }
                        throw new JpxError("No size marker found in JPX stream");
                    }
                    parseCodestream(e1, t, a) {
                        const i = {};
                        let s = !1;
                        try {
                            let o = t;
                            for(; o + 1 < a;){
                                const t = (0, n.readUint16)(e1, o);
                                o += 2;
                                let a, c, l, h, u, d, f = 0;
                                switch(t){
                                    case 65359:
                                        i.mainHeader = !0;
                                        break;
                                    case 65497:
                                        break;
                                    case 65361:
                                        f = (0, n.readUint16)(e1, o);
                                        const g = {};
                                        g.Xsiz = (0, n.readUint32)(e1, o + 4);
                                        g.Ysiz = (0, n.readUint32)(e1, o + 8);
                                        g.XOsiz = (0, n.readUint32)(e1, o + 12);
                                        g.YOsiz = (0, n.readUint32)(e1, o + 16);
                                        g.XTsiz = (0, n.readUint32)(e1, o + 20);
                                        g.YTsiz = (0, n.readUint32)(e1, o + 24);
                                        g.XTOsiz = (0, n.readUint32)(e1, o + 28);
                                        g.YTOsiz = (0, n.readUint32)(e1, o + 32);
                                        const p = (0, n.readUint16)(e1, o + 36);
                                        g.Csiz = p;
                                        const m = [];
                                        a = o + 38;
                                        for(let t = 0; t < p; t++){
                                            const t = {
                                                precision: 1 + (127 & e1[a]),
                                                isSigned: !!(128 & e1[a]),
                                                XRsiz: e1[a + 1],
                                                YRsiz: e1[a + 2]
                                            };
                                            a += 3;
                                            calculateComponentDimensions(t, g);
                                            m.push(t);
                                        }
                                        i.SIZ = g;
                                        i.components = m;
                                        calculateTileGrids(i, m);
                                        i.QCC = [];
                                        i.COC = [];
                                        break;
                                    case 65372:
                                        f = (0, n.readUint16)(e1, o);
                                        const b = {};
                                        a = o + 2;
                                        c = e1[a++];
                                        switch(31 & c){
                                            case 0:
                                                h = 8;
                                                u = !0;
                                                break;
                                            case 1:
                                                h = 16;
                                                u = !1;
                                                break;
                                            case 2:
                                                h = 16;
                                                u = !0;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + c);
                                        }
                                        b.noQuantization = 8 === h;
                                        b.scalarExpounded = u;
                                        b.guardBits = c >> 5;
                                        l = [];
                                        for(; a < f + o;){
                                            const t = {};
                                            if (8 === h) {
                                                t.epsilon = e1[a++] >> 3;
                                                t.mu = 0;
                                            } else {
                                                t.epsilon = e1[a] >> 3;
                                                t.mu = (7 & e1[a]) << 8 | e1[a + 1];
                                                a += 2;
                                            }
                                            l.push(t);
                                        }
                                        b.SPqcds = l;
                                        if (i.mainHeader) i.QCD = b;
                                        else {
                                            i.currentTile.QCD = b;
                                            i.currentTile.QCC = [];
                                        }
                                        break;
                                    case 65373:
                                        f = (0, n.readUint16)(e1, o);
                                        const y = {};
                                        a = o + 2;
                                        let w;
                                        if (i.SIZ.Csiz < 257) w = e1[a++];
                                        else {
                                            w = (0, n.readUint16)(e1, a);
                                            a += 2;
                                        }
                                        c = e1[a++];
                                        switch(31 & c){
                                            case 0:
                                                h = 8;
                                                u = !0;
                                                break;
                                            case 1:
                                                h = 16;
                                                u = !1;
                                                break;
                                            case 2:
                                                h = 16;
                                                u = !0;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + c);
                                        }
                                        y.noQuantization = 8 === h;
                                        y.scalarExpounded = u;
                                        y.guardBits = c >> 5;
                                        l = [];
                                        for(; a < f + o;){
                                            const t = {};
                                            if (8 === h) {
                                                t.epsilon = e1[a++] >> 3;
                                                t.mu = 0;
                                            } else {
                                                t.epsilon = e1[a] >> 3;
                                                t.mu = (7 & e1[a]) << 8 | e1[a + 1];
                                                a += 2;
                                            }
                                            l.push(t);
                                        }
                                        y.SPqcds = l;
                                        i.mainHeader ? i.QCC[w] = y : i.currentTile.QCC[w] = y;
                                        break;
                                    case 65362:
                                        f = (0, n.readUint16)(e1, o);
                                        const S = {};
                                        a = o + 2;
                                        const x = e1[a++];
                                        S.entropyCoderWithCustomPrecincts = !!(1 & x);
                                        S.sopMarkerUsed = !!(2 & x);
                                        S.ephMarkerUsed = !!(4 & x);
                                        S.progressionOrder = e1[a++];
                                        S.layersCount = (0, n.readUint16)(e1, a);
                                        a += 2;
                                        S.multipleComponentTransform = e1[a++];
                                        S.decompositionLevelsCount = e1[a++];
                                        S.xcb = 2 + (15 & e1[a++]);
                                        S.ycb = 2 + (15 & e1[a++]);
                                        const C = e1[a++];
                                        S.selectiveArithmeticCodingBypass = !!(1 & C);
                                        S.resetContextProbabilities = !!(2 & C);
                                        S.terminationOnEachCodingPass = !!(4 & C);
                                        S.verticallyStripe = !!(8 & C);
                                        S.predictableTermination = !!(16 & C);
                                        S.segmentationSymbolUsed = !!(32 & C);
                                        S.reversibleTransformation = e1[a++];
                                        if (S.entropyCoderWithCustomPrecincts) {
                                            const t = [];
                                            for(; a < f + o;){
                                                const r = e1[a++];
                                                t.push({
                                                    PPx: 15 & r,
                                                    PPy: r >> 4
                                                });
                                            }
                                            S.precinctsSizes = t;
                                        }
                                        const k = [];
                                        S.selectiveArithmeticCodingBypass && k.push("selectiveArithmeticCodingBypass");
                                        S.terminationOnEachCodingPass && k.push("terminationOnEachCodingPass");
                                        S.verticallyStripe && k.push("verticallyStripe");
                                        S.predictableTermination && k.push("predictableTermination");
                                        if (k.length > 0) {
                                            s = !0;
                                            (0, r.warn)(`JPX: Unsupported COD options (${k.join(", ")}).`);
                                        }
                                        if (i.mainHeader) i.COD = S;
                                        else {
                                            i.currentTile.COD = S;
                                            i.currentTile.COC = [];
                                        }
                                        break;
                                    case 65424:
                                        f = (0, n.readUint16)(e1, o);
                                        d = {};
                                        d.index = (0, n.readUint16)(e1, o + 2);
                                        d.length = (0, n.readUint32)(e1, o + 4);
                                        d.dataEnd = d.length + o - 2;
                                        d.partIndex = e1[o + 8];
                                        d.partsCount = e1[o + 9];
                                        i.mainHeader = !1;
                                        if (0 === d.partIndex) {
                                            d.COD = i.COD;
                                            d.COC = i.COC.slice(0);
                                            d.QCD = i.QCD;
                                            d.QCC = i.QCC.slice(0);
                                        }
                                        i.currentTile = d;
                                        break;
                                    case 65427:
                                        d = i.currentTile;
                                        if (0 === d.partIndex) {
                                            initializeTile(i, d.index);
                                            buildPackets(i);
                                        }
                                        f = d.dataEnd - o;
                                        parseTilePackets(i, e1, o, f);
                                        break;
                                    case 65363:
                                        (0, r.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                                    case 65365:
                                    case 65367:
                                    case 65368:
                                    case 65380:
                                        f = (0, n.readUint16)(e1, o);
                                        break;
                                    default:
                                        throw new Error("Unknown codestream code: " + t.toString(16));
                                }
                                o += f;
                            }
                        } catch (e1) {
                            if (s || this.failOnCorruptedImage) throw new JpxError(e1.message);
                            (0, r.warn)(`JPX: Trying to recover from: "${e1.message}".`);
                        }
                        this.tiles = function transformComponents(e1) {
                            const t = e1.SIZ, a = e1.components, r = t.Csiz, n = [];
                            for(let t = 0, i = e1.tiles.length; t < i; t++){
                                const i = e1.tiles[t], s = [];
                                for(let t = 0; t < r; t++)s[t] = transformTile(e1, i, t);
                                const o = s[0], c = new Uint8ClampedArray(o.items.length * r), l = {
                                    left: o.left,
                                    top: o.top,
                                    width: o.width,
                                    height: o.height,
                                    items: c
                                };
                                let h, u, d, f, g, p, m, b = 0;
                                if (i.codingStyleDefaultParameters.multipleComponentTransform) {
                                    const e1 = 4 === r, t = s[0].items, n = s[1].items, o = s[2].items, l = e1 ? s[3].items : null;
                                    h = a[0].precision - 8;
                                    u = .5 + (128 << h);
                                    const y = i.components[0], w = r - 3;
                                    f = t.length;
                                    if (y.codingStyleParameters.reversibleTransformation) for(d = 0; d < f; d++, b += w){
                                        g = t[d] + u;
                                        p = n[d];
                                        m = o[d];
                                        const e1 = g - (m + p >> 2);
                                        c[b++] = e1 + m >> h;
                                        c[b++] = e1 >> h;
                                        c[b++] = e1 + p >> h;
                                    }
                                    else for(d = 0; d < f; d++, b += w){
                                        g = t[d] + u;
                                        p = n[d];
                                        m = o[d];
                                        c[b++] = g + 1.402 * m >> h;
                                        c[b++] = g - .34413 * p - .71414 * m >> h;
                                        c[b++] = g + 1.772 * p >> h;
                                    }
                                    if (e1) for(d = 0, b = 3; d < f; d++, b += 4)c[b] = l[d] + u >> h;
                                } else for(let e1 = 0; e1 < r; e1++){
                                    const t = s[e1].items;
                                    h = a[e1].precision - 8;
                                    u = .5 + (128 << h);
                                    for(b = e1, d = 0, f = t.length; d < f; d++){
                                        c[b] = t[d] + u >> h;
                                        b += r;
                                    }
                                }
                                n.push(l);
                            }
                            return n;
                        }(i);
                        this.width = i.SIZ.Xsiz - i.SIZ.XOsiz;
                        this.height = i.SIZ.Ysiz - i.SIZ.YOsiz;
                        this.componentsCount = i.SIZ.Csiz;
                    }
                };
                function calculateComponentDimensions(e1, t) {
                    e1.x0 = Math.ceil(t.XOsiz / e1.XRsiz);
                    e1.x1 = Math.ceil(t.Xsiz / e1.XRsiz);
                    e1.y0 = Math.ceil(t.YOsiz / e1.YRsiz);
                    e1.y1 = Math.ceil(t.Ysiz / e1.YRsiz);
                    e1.width = e1.x1 - e1.x0;
                    e1.height = e1.y1 - e1.y0;
                }
                function calculateTileGrids(e1, t) {
                    const a = e1.SIZ, r = [];
                    let n;
                    const i = Math.ceil((a.Xsiz - a.XTOsiz) / a.XTsiz), s = Math.ceil((a.Ysiz - a.YTOsiz) / a.YTsiz);
                    for(let e1 = 0; e1 < s; e1++)for(let t = 0; t < i; t++){
                        n = {};
                        n.tx0 = Math.max(a.XTOsiz + t * a.XTsiz, a.XOsiz);
                        n.ty0 = Math.max(a.YTOsiz + e1 * a.YTsiz, a.YOsiz);
                        n.tx1 = Math.min(a.XTOsiz + (t + 1) * a.XTsiz, a.Xsiz);
                        n.ty1 = Math.min(a.YTOsiz + (e1 + 1) * a.YTsiz, a.Ysiz);
                        n.width = n.tx1 - n.tx0;
                        n.height = n.ty1 - n.ty0;
                        n.components = [];
                        r.push(n);
                    }
                    e1.tiles = r;
                    for(let e1 = 0, i = a.Csiz; e1 < i; e1++){
                        const a = t[e1];
                        for(let t = 0, i = r.length; t < i; t++){
                            const i = {};
                            n = r[t];
                            i.tcx0 = Math.ceil(n.tx0 / a.XRsiz);
                            i.tcy0 = Math.ceil(n.ty0 / a.YRsiz);
                            i.tcx1 = Math.ceil(n.tx1 / a.XRsiz);
                            i.tcy1 = Math.ceil(n.ty1 / a.YRsiz);
                            i.width = i.tcx1 - i.tcx0;
                            i.height = i.tcy1 - i.tcy0;
                            n.components[e1] = i;
                        }
                    }
                }
                function getBlocksDimensions(e1, t, a) {
                    const r = t.codingStyleParameters, n = {};
                    if (r.entropyCoderWithCustomPrecincts) {
                        n.PPx = r.precinctsSizes[a].PPx;
                        n.PPy = r.precinctsSizes[a].PPy;
                    } else {
                        n.PPx = 15;
                        n.PPy = 15;
                    }
                    n.xcb_ = a > 0 ? Math.min(r.xcb, n.PPx - 1) : Math.min(r.xcb, n.PPx);
                    n.ycb_ = a > 0 ? Math.min(r.ycb, n.PPy - 1) : Math.min(r.ycb, n.PPy);
                    return n;
                }
                function buildPrecincts(e1, t, a) {
                    const r = 1 << a.PPx, n = 1 << a.PPy, i = 0 === t.resLevel, s = 1 << a.PPx + (i ? 0 : -1), o = 1 << a.PPy + (i ? 0 : -1), c = t.trx1 > t.trx0 ? Math.ceil(t.trx1 / r) - Math.floor(t.trx0 / r) : 0, l = t.try1 > t.try0 ? Math.ceil(t.try1 / n) - Math.floor(t.try0 / n) : 0, h = c * l;
                    t.precinctParameters = {
                        precinctWidth: r,
                        precinctHeight: n,
                        numprecinctswide: c,
                        numprecinctshigh: l,
                        numprecincts: h,
                        precinctWidthInSubband: s,
                        precinctHeightInSubband: o
                    };
                }
                function buildCodeblocks(e1, t, a) {
                    const r = a.xcb_, n = a.ycb_, i = 1 << r, s = 1 << n, o = t.tbx0 >> r, c = t.tby0 >> n, l = t.tbx1 + i - 1 >> r, h = t.tby1 + s - 1 >> n, u = t.resolution.precinctParameters, d = [], f = [];
                    let g, p, m, b;
                    for(p = c; p < h; p++)for(g = o; g < l; g++){
                        m = {
                            cbx: g,
                            cby: p,
                            tbx0: i * g,
                            tby0: s * p,
                            tbx1: i * (g + 1),
                            tby1: s * (p + 1)
                        };
                        m.tbx0_ = Math.max(t.tbx0, m.tbx0);
                        m.tby0_ = Math.max(t.tby0, m.tby0);
                        m.tbx1_ = Math.min(t.tbx1, m.tbx1);
                        m.tby1_ = Math.min(t.tby1, m.tby1);
                        b = Math.floor((m.tbx0_ - t.tbx0) / u.precinctWidthInSubband) + Math.floor((m.tby0_ - t.tby0) / u.precinctHeightInSubband) * u.numprecinctswide;
                        m.precinctNumber = b;
                        m.subbandType = t.type;
                        m.Lblock = 3;
                        if (m.tbx1_ <= m.tbx0_ || m.tby1_ <= m.tby0_) continue;
                        d.push(m);
                        let e1 = f[b];
                        if (void 0 !== e1) {
                            g < e1.cbxMin ? e1.cbxMin = g : g > e1.cbxMax && (e1.cbxMax = g);
                            p < e1.cbyMin ? e1.cbxMin = p : p > e1.cbyMax && (e1.cbyMax = p);
                        } else f[b] = e1 = {
                            cbxMin: g,
                            cbyMin: p,
                            cbxMax: g,
                            cbyMax: p
                        };
                        m.precinct = e1;
                    }
                    t.codeblockParameters = {
                        codeblockWidth: r,
                        codeblockHeight: n,
                        numcodeblockwide: l - o + 1,
                        numcodeblockhigh: h - c + 1
                    };
                    t.codeblocks = d;
                    t.precincts = f;
                }
                function createPacket(e1, t, a) {
                    const r = [], n = e1.subbands;
                    for(let e1 = 0, a = n.length; e1 < a; e1++){
                        const a = n[e1].codeblocks;
                        for(let e1 = 0, n = a.length; e1 < n; e1++){
                            const n = a[e1];
                            n.precinctNumber === t && r.push(n);
                        }
                    }
                    return {
                        layerNumber: a,
                        codeblocks: r
                    };
                }
                function LayerResolutionComponentPositionIterator(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = r.codingStyleDefaultParameters.layersCount, i = t.Csiz;
                    let s = 0;
                    for(let e1 = 0; e1 < i; e1++)s = Math.max(s, r.components[e1].codingStyleParameters.decompositionLevelsCount);
                    let o = 0, c = 0, l = 0, h = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; o < n; o++){
                            for(; c <= s; c++){
                                for(; l < i; l++){
                                    const e1 = r.components[l];
                                    if (c > e1.codingStyleParameters.decompositionLevelsCount) continue;
                                    const t = e1.resolutions[c], a = t.precinctParameters.numprecincts;
                                    for(; h < a;){
                                        const e1 = createPacket(t, h, o);
                                        h++;
                                        return e1;
                                    }
                                    h = 0;
                                }
                                l = 0;
                            }
                            c = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionLayerComponentPositionIterator(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = r.codingStyleDefaultParameters.layersCount, i = t.Csiz;
                    let s = 0;
                    for(let e1 = 0; e1 < i; e1++)s = Math.max(s, r.components[e1].codingStyleParameters.decompositionLevelsCount);
                    let o = 0, c = 0, l = 0, h = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; o <= s; o++){
                            for(; c < n; c++){
                                for(; l < i; l++){
                                    const e1 = r.components[l];
                                    if (o > e1.codingStyleParameters.decompositionLevelsCount) continue;
                                    const t = e1.resolutions[o], a = t.precinctParameters.numprecincts;
                                    for(; h < a;){
                                        const e1 = createPacket(t, h, c);
                                        h++;
                                        return e1;
                                    }
                                    h = 0;
                                }
                                l = 0;
                            }
                            c = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionPositionComponentLayerIterator(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = r.codingStyleDefaultParameters.layersCount, i = t.Csiz;
                    let s, o, c, l, h = 0;
                    for(c = 0; c < i; c++){
                        const e1 = r.components[c];
                        h = Math.max(h, e1.codingStyleParameters.decompositionLevelsCount);
                    }
                    const u = new Int32Array(h + 1);
                    for(o = 0; o <= h; ++o){
                        let e1 = 0;
                        for(c = 0; c < i; ++c){
                            const t = r.components[c].resolutions;
                            o < t.length && (e1 = Math.max(e1, t[o].precinctParameters.numprecincts));
                        }
                        u[o] = e1;
                    }
                    s = 0;
                    o = 0;
                    c = 0;
                    l = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; o <= h; o++){
                            for(; l < u[o]; l++){
                                for(; c < i; c++){
                                    const e1 = r.components[c];
                                    if (o > e1.codingStyleParameters.decompositionLevelsCount) continue;
                                    const t = e1.resolutions[o], a = t.precinctParameters.numprecincts;
                                    if (!(l >= a)) {
                                        for(; s < n;){
                                            const e1 = createPacket(t, l, s);
                                            s++;
                                            return e1;
                                        }
                                        s = 0;
                                    }
                                }
                                c = 0;
                            }
                            l = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function PositionComponentResolutionLayerIterator(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = r.codingStyleDefaultParameters.layersCount, i = t.Csiz, s = getPrecinctSizesInImageScale(r), o = s;
                    let c = 0, l = 0, h = 0, u = 0, d = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; d < o.maxNumHigh; d++){
                            for(; u < o.maxNumWide; u++){
                                for(; h < i; h++){
                                    const e1 = r.components[h], t = e1.codingStyleParameters.decompositionLevelsCount;
                                    for(; l <= t; l++){
                                        const t = e1.resolutions[l], a = s.components[h].resolutions[l], r = getPrecinctIndexIfExist(u, d, a, o, t);
                                        if (null !== r) {
                                            for(; c < n;){
                                                const e1 = createPacket(t, r, c);
                                                c++;
                                                return e1;
                                            }
                                            c = 0;
                                        }
                                    }
                                    l = 0;
                                }
                                h = 0;
                            }
                            u = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ComponentPositionResolutionLayerIterator(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = r.codingStyleDefaultParameters.layersCount, i = t.Csiz, s = getPrecinctSizesInImageScale(r);
                    let o = 0, c = 0, l = 0, h = 0, u = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; l < i; ++l){
                            const e1 = r.components[l], t = s.components[l], a = e1.codingStyleParameters.decompositionLevelsCount;
                            for(; u < t.maxNumHigh; u++){
                                for(; h < t.maxNumWide; h++){
                                    for(; c <= a; c++){
                                        const a = e1.resolutions[c], r = t.resolutions[c], i = getPrecinctIndexIfExist(h, u, r, t, a);
                                        if (null !== i) {
                                            for(; o < n;){
                                                const e1 = createPacket(a, i, o);
                                                o++;
                                                return e1;
                                            }
                                            o = 0;
                                        }
                                    }
                                    c = 0;
                                }
                                h = 0;
                            }
                            u = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function getPrecinctIndexIfExist(e1, t, a, r, n) {
                    const i = e1 * r.minWidth, s = t * r.minHeight;
                    if (i % a.width != 0 || s % a.height != 0) return null;
                    const o = s / a.width * n.precinctParameters.numprecinctswide;
                    return i / a.height + o;
                }
                function getPrecinctSizesInImageScale(e1) {
                    const t = e1.components.length;
                    let a = Number.MAX_VALUE, r = Number.MAX_VALUE, n = 0, i = 0;
                    const s = new Array(t);
                    for(let o = 0; o < t; o++){
                        const t = e1.components[o], c = t.codingStyleParameters.decompositionLevelsCount, l = new Array(c + 1);
                        let h = Number.MAX_VALUE, u = Number.MAX_VALUE, d = 0, f = 0, g = 1;
                        for(let e1 = c; e1 >= 0; --e1){
                            const a = t.resolutions[e1], r = g * a.precinctParameters.precinctWidth, n = g * a.precinctParameters.precinctHeight;
                            h = Math.min(h, r);
                            u = Math.min(u, n);
                            d = Math.max(d, a.precinctParameters.numprecinctswide);
                            f = Math.max(f, a.precinctParameters.numprecinctshigh);
                            l[e1] = {
                                width: r,
                                height: n
                            };
                            g <<= 1;
                        }
                        a = Math.min(a, h);
                        r = Math.min(r, u);
                        n = Math.max(n, d);
                        i = Math.max(i, f);
                        s[o] = {
                            resolutions: l,
                            minWidth: h,
                            minHeight: u,
                            maxNumWide: d,
                            maxNumHigh: f
                        };
                    }
                    return {
                        components: s,
                        minWidth: a,
                        minHeight: r,
                        maxNumWide: n,
                        maxNumHigh: i
                    };
                }
                function buildPackets(e1) {
                    const t = e1.SIZ, a = e1.currentTile.index, r = e1.tiles[a], n = t.Csiz;
                    for(let e1 = 0; e1 < n; e1++){
                        const t = r.components[e1], a = t.codingStyleParameters.decompositionLevelsCount, n = [], i = [];
                        for(let e1 = 0; e1 <= a; e1++){
                            const r = getBlocksDimensions(0, t, e1), s = {}, o = 1 << a - e1;
                            s.trx0 = Math.ceil(t.tcx0 / o);
                            s.try0 = Math.ceil(t.tcy0 / o);
                            s.trx1 = Math.ceil(t.tcx1 / o);
                            s.try1 = Math.ceil(t.tcy1 / o);
                            s.resLevel = e1;
                            buildPrecincts(0, s, r);
                            n.push(s);
                            let c;
                            if (0 === e1) {
                                c = {};
                                c.type = "LL";
                                c.tbx0 = Math.ceil(t.tcx0 / o);
                                c.tby0 = Math.ceil(t.tcy0 / o);
                                c.tbx1 = Math.ceil(t.tcx1 / o);
                                c.tby1 = Math.ceil(t.tcy1 / o);
                                c.resolution = s;
                                buildCodeblocks(0, c, r);
                                i.push(c);
                                s.subbands = [
                                    c
                                ];
                            } else {
                                const n = 1 << a - e1 + 1, o = [];
                                c = {};
                                c.type = "HL";
                                c.tbx0 = Math.ceil(t.tcx0 / n - .5);
                                c.tby0 = Math.ceil(t.tcy0 / n);
                                c.tbx1 = Math.ceil(t.tcx1 / n - .5);
                                c.tby1 = Math.ceil(t.tcy1 / n);
                                c.resolution = s;
                                buildCodeblocks(0, c, r);
                                i.push(c);
                                o.push(c);
                                c = {};
                                c.type = "LH";
                                c.tbx0 = Math.ceil(t.tcx0 / n);
                                c.tby0 = Math.ceil(t.tcy0 / n - .5);
                                c.tbx1 = Math.ceil(t.tcx1 / n);
                                c.tby1 = Math.ceil(t.tcy1 / n - .5);
                                c.resolution = s;
                                buildCodeblocks(0, c, r);
                                i.push(c);
                                o.push(c);
                                c = {};
                                c.type = "HH";
                                c.tbx0 = Math.ceil(t.tcx0 / n - .5);
                                c.tby0 = Math.ceil(t.tcy0 / n - .5);
                                c.tbx1 = Math.ceil(t.tcx1 / n - .5);
                                c.tby1 = Math.ceil(t.tcy1 / n - .5);
                                c.resolution = s;
                                buildCodeblocks(0, c, r);
                                i.push(c);
                                o.push(c);
                                s.subbands = o;
                            }
                        }
                        t.resolutions = n;
                        t.subbands = i;
                    }
                    const i = r.codingStyleDefaultParameters.progressionOrder;
                    switch(i){
                        case 0:
                            r.packetsIterator = new LayerResolutionComponentPositionIterator(e1);
                            break;
                        case 1:
                            r.packetsIterator = new ResolutionLayerComponentPositionIterator(e1);
                            break;
                        case 2:
                            r.packetsIterator = new ResolutionPositionComponentLayerIterator(e1);
                            break;
                        case 3:
                            r.packetsIterator = new PositionComponentResolutionLayerIterator(e1);
                            break;
                        case 4:
                            r.packetsIterator = new ComponentPositionResolutionLayerIterator(e1);
                            break;
                        default:
                            throw new JpxError(`Unsupported progression order ${i}`);
                    }
                }
                function parseTilePackets(e1, t, a, r) {
                    let i, s = 0, o = 0, c = !1;
                    function readBits(e1) {
                        for(; o < e1;){
                            const e1 = t[a + s];
                            s++;
                            if (c) {
                                i = i << 7 | e1;
                                o += 7;
                                c = !1;
                            } else {
                                i = i << 8 | e1;
                                o += 8;
                            }
                            255 === e1 && (c = !0);
                        }
                        o -= e1;
                        return i >>> o & (1 << e1) - 1;
                    }
                    function skipMarkerIfEqual(e1) {
                        if (255 === t[a + s - 1] && t[a + s] === e1) {
                            skipBytes(1);
                            return !0;
                        }
                        if (255 === t[a + s] && t[a + s + 1] === e1) {
                            skipBytes(2);
                            return !0;
                        }
                        return !1;
                    }
                    function skipBytes(e1) {
                        s += e1;
                    }
                    function alignToByte() {
                        o = 0;
                        if (c) {
                            s++;
                            c = !1;
                        }
                    }
                    function readCodingpasses() {
                        if (0 === readBits(1)) return 1;
                        if (0 === readBits(1)) return 2;
                        let e1 = readBits(2);
                        if (e1 < 3) return e1 + 3;
                        e1 = readBits(5);
                        if (e1 < 31) return e1 + 6;
                        e1 = readBits(7);
                        return e1 + 37;
                    }
                    const l = e1.currentTile.index, h = e1.tiles[l], u = e1.COD.sopMarkerUsed, d = e1.COD.ephMarkerUsed, f = h.packetsIterator;
                    for(; s < r;){
                        alignToByte();
                        u && skipMarkerIfEqual(145) && skipBytes(4);
                        const e1 = f.nextPacket();
                        if (!readBits(1)) continue;
                        const r = e1.layerNumber, i = [];
                        let o;
                        for(let t = 0, a = e1.codeblocks.length; t < a; t++){
                            o = e1.codeblocks[t];
                            let a = o.precinct;
                            const s = o.cbx - a.cbxMin, c = o.cby - a.cbyMin;
                            let l, h, u = !1, d = !1;
                            if (void 0 !== o.included) u = !!readBits(1);
                            else {
                                a = o.precinct;
                                let e1;
                                if (void 0 !== a.inclusionTree) e1 = a.inclusionTree;
                                else {
                                    const t = a.cbxMax - a.cbxMin + 1, n = a.cbyMax - a.cbyMin + 1;
                                    e1 = new InclusionTree(t, n, r);
                                    h = new TagTree(t, n);
                                    a.inclusionTree = e1;
                                    a.zeroBitPlanesTree = h;
                                    for(let e1 = 0; e1 < r; e1++)if (0 !== readBits(1)) throw new JpxError("Invalid tag tree");
                                }
                                if (e1.reset(s, c, r)) for(;;){
                                    if (!readBits(1)) {
                                        e1.incrementValue(r);
                                        break;
                                    }
                                    l = !e1.nextLevel();
                                    if (l) {
                                        o.included = !0;
                                        u = d = !0;
                                        break;
                                    }
                                }
                            }
                            if (!u) continue;
                            if (d) {
                                h = a.zeroBitPlanesTree;
                                h.reset(s, c);
                                for(;;)if (readBits(1)) {
                                    l = !h.nextLevel();
                                    if (l) break;
                                } else h.incrementValue();
                                o.zeroBitPlanes = h.value;
                            }
                            const f = readCodingpasses();
                            for(; readBits(1);)o.Lblock++;
                            const g = (0, n.log2)(f), p = readBits((f < 1 << g ? g - 1 : g) + o.Lblock);
                            i.push({
                                codeblock: o,
                                codingpasses: f,
                                dataLength: p
                            });
                        }
                        alignToByte();
                        d && skipMarkerIfEqual(146);
                        for(; i.length > 0;){
                            const e1 = i.shift();
                            o = e1.codeblock;
                            void 0 === o.data && (o.data = []);
                            o.data.push({
                                data: t,
                                start: a + s,
                                end: a + s + e1.dataLength,
                                codingpasses: e1.codingpasses
                            });
                            s += e1.dataLength;
                        }
                    }
                    return s;
                }
                function copyCoefficients(e1, t, a, r, n, s, o, c, l) {
                    const h = r.tbx0, u = r.tby0, d = r.tbx1 - r.tbx0, f = r.codeblocks, g = "H" === r.type.charAt(0) ? 1 : 0, p = "H" === r.type.charAt(1) ? t : 0;
                    for(let a = 0, m = f.length; a < m; ++a){
                        const m = f[a], b = m.tbx1_ - m.tbx0_, y = m.tby1_ - m.tby0_;
                        if (0 === b || 0 === y) continue;
                        if (void 0 === m.data) continue;
                        const w = new BitModel(b, y, m.subbandType, m.zeroBitPlanes, s);
                        let S = 2;
                        const x = m.data;
                        let C, k, v, F = 0, O = 0;
                        for(C = 0, k = x.length; C < k; C++){
                            v = x[C];
                            F += v.end - v.start;
                            O += v.codingpasses;
                        }
                        const T = new Uint8Array(F);
                        let M = 0;
                        for(C = 0, k = x.length; C < k; C++){
                            v = x[C];
                            const e1 = v.data.subarray(v.start, v.end);
                            T.set(e1, M);
                            M += e1.length;
                        }
                        const D = new i.ArithmeticDecoder(T, 0, F);
                        w.setDecoder(D);
                        for(C = 0; C < O; C++){
                            switch(S){
                                case 0:
                                    w.runSignificancePropagationPass();
                                    break;
                                case 1:
                                    w.runMagnitudeRefinementPass();
                                    break;
                                case 2:
                                    w.runCleanupPass();
                                    c && w.checkSegmentationSymbol();
                            }
                            l && w.reset();
                            S = (S + 1) % 3;
                        }
                        let E = m.tbx0_ - h + (m.tby0_ - u) * d;
                        const N = w.coefficentsSign, R = w.coefficentsMagnitude, L = w.bitsDecoded, $ = o ? 0 : .5;
                        let _, j, U;
                        M = 0;
                        const X = "LL" !== r.type;
                        for(C = 0; C < y; C++){
                            const a = 2 * (E / d | 0) * (t - d) + g + p;
                            for(_ = 0; _ < b; _++){
                                j = R[M];
                                if (0 !== j) {
                                    j = (j + $) * n;
                                    0 !== N[M] && (j = -j);
                                    U = L[M];
                                    e1[X ? a + (E << 1) : E] = o && U >= s ? j : j * (1 << s - U);
                                }
                                E++;
                                M++;
                            }
                            E += d - b;
                        }
                    }
                }
                function transformTile(e1, t, a) {
                    const r = t.components[a], n = r.codingStyleParameters, i = r.quantizationParameters, o = n.decompositionLevelsCount, c = i.SPqcds, l = i.scalarExpounded, h = i.guardBits, u = n.segmentationSymbolUsed, d = n.resetContextProbabilities, f = e1.components[a].precision, g = n.reversibleTransformation, p = g ? new ReversibleTransform : new IrreversibleTransform, m = [];
                    let b = 0;
                    for(let e1 = 0; e1 <= o; e1++){
                        const t = r.resolutions[e1], a = t.trx1 - t.trx0, n = t.try1 - t.try0, i = new Float32Array(a * n);
                        for(let r = 0, n = t.subbands.length; r < n; r++){
                            let n, o;
                            if (l) {
                                n = c[b].mu;
                                o = c[b].epsilon;
                                b++;
                            } else {
                                n = c[0].mu;
                                o = c[0].epsilon + (e1 > 0 ? 1 - e1 : 0);
                            }
                            const p = t.subbands[r], m = s[p.type];
                            copyCoefficients(i, a, 0, p, g ? 1 : 2 ** (f + m - o) * (1 + n / 2048), h + o - 1, g, u, d);
                        }
                        m.push({
                            width: a,
                            height: n,
                            items: i
                        });
                    }
                    const y = p.calculate(m, r.tcx0, r.tcy0);
                    return {
                        left: r.tcx0,
                        top: r.tcy0,
                        width: y.width,
                        height: y.height,
                        items: y.items
                    };
                }
                function initializeTile(e1, t) {
                    const a = e1.SIZ.Csiz, r = e1.tiles[t];
                    for(let t = 0; t < a; t++){
                        const a = r.components[t], n = void 0 !== e1.currentTile.QCC[t] ? e1.currentTile.QCC[t] : e1.currentTile.QCD;
                        a.quantizationParameters = n;
                        const i = void 0 !== e1.currentTile.COC[t] ? e1.currentTile.COC[t] : e1.currentTile.COD;
                        a.codingStyleParameters = i;
                    }
                    r.codingStyleDefaultParameters = e1.currentTile.COD;
                }
                class TagTree {
                    constructor(e1, t){
                        const a = (0, n.log2)(Math.max(e1, t)) + 1;
                        this.levels = [];
                        for(let r = 0; r < a; r++){
                            const a = {
                                width: e1,
                                height: t,
                                items: []
                            };
                            this.levels.push(a);
                            e1 = Math.ceil(e1 / 2);
                            t = Math.ceil(t / 2);
                        }
                    }
                    reset(e1, t) {
                        let a, r = 0, n = 0;
                        for(; r < this.levels.length;){
                            a = this.levels[r];
                            const i = e1 + t * a.width;
                            if (void 0 !== a.items[i]) {
                                n = a.items[i];
                                break;
                            }
                            a.index = i;
                            e1 >>= 1;
                            t >>= 1;
                            r++;
                        }
                        r--;
                        a = this.levels[r];
                        a.items[a.index] = n;
                        this.currentLevel = r;
                        delete this.value;
                    }
                    incrementValue() {
                        const e1 = this.levels[this.currentLevel];
                        e1.items[e1.index]++;
                    }
                    nextLevel() {
                        let e1 = this.currentLevel, t = this.levels[e1];
                        const a = t.items[t.index];
                        e1--;
                        if (e1 < 0) {
                            this.value = a;
                            return !1;
                        }
                        this.currentLevel = e1;
                        t = this.levels[e1];
                        t.items[t.index] = a;
                        return !0;
                    }
                }
                class InclusionTree {
                    constructor(e1, t, a){
                        const r = (0, n.log2)(Math.max(e1, t)) + 1;
                        this.levels = [];
                        for(let n = 0; n < r; n++){
                            const r = new Uint8Array(e1 * t);
                            for(let e1 = 0, t = r.length; e1 < t; e1++)r[e1] = a;
                            const n = {
                                width: e1,
                                height: t,
                                items: r
                            };
                            this.levels.push(n);
                            e1 = Math.ceil(e1 / 2);
                            t = Math.ceil(t / 2);
                        }
                    }
                    reset(e1, t, a) {
                        let r = 0;
                        for(; r < this.levels.length;){
                            const n = this.levels[r], i = e1 + t * n.width;
                            n.index = i;
                            const s = n.items[i];
                            if (255 === s) break;
                            if (s > a) {
                                this.currentLevel = r;
                                this.propagateValues();
                                return !1;
                            }
                            e1 >>= 1;
                            t >>= 1;
                            r++;
                        }
                        this.currentLevel = r - 1;
                        return !0;
                    }
                    incrementValue(e1) {
                        const t = this.levels[this.currentLevel];
                        t.items[t.index] = e1 + 1;
                        this.propagateValues();
                    }
                    propagateValues() {
                        let e1 = this.currentLevel, t = this.levels[e1];
                        const a = t.items[t.index];
                        for(; --e1 >= 0;){
                            t = this.levels[e1];
                            t.items[t.index] = a;
                        }
                    }
                    nextLevel() {
                        let e1 = this.currentLevel, t = this.levels[e1];
                        const a = t.items[t.index];
                        t.items[t.index] = 255;
                        e1--;
                        if (e1 < 0) return !1;
                        this.currentLevel = e1;
                        t = this.levels[e1];
                        t.items[t.index] = a;
                        return !0;
                    }
                }
                class BitModel {
                    static UNIFORM_CONTEXT = 17;
                    static RUNLENGTH_CONTEXT = 18;
                    static LLAndLHContextsLabel = new Uint8Array([
                        0,
                        5,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8
                    ]);
                    static HLContextLabel = new Uint8Array([
                        0,
                        3,
                        4,
                        0,
                        5,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8
                    ]);
                    static HHContextLabel = new Uint8Array([
                        0,
                        1,
                        2,
                        0,
                        1,
                        2,
                        2,
                        0,
                        2,
                        2,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        4,
                        5,
                        0,
                        4,
                        5,
                        5,
                        0,
                        5,
                        5,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        6,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8
                    ]);
                    constructor(e1, t, a, r, n){
                        this.width = e1;
                        this.height = t;
                        let i;
                        i = "HH" === a ? BitModel.HHContextLabel : "HL" === a ? BitModel.HLContextLabel : BitModel.LLAndLHContextsLabel;
                        this.contextLabelTable = i;
                        const s = e1 * t;
                        this.neighborsSignificance = new Uint8Array(s);
                        this.coefficentsSign = new Uint8Array(s);
                        let o;
                        o = n > 14 ? new Uint32Array(s) : n > 6 ? new Uint16Array(s) : new Uint8Array(s);
                        this.coefficentsMagnitude = o;
                        this.processingFlags = new Uint8Array(s);
                        const c = new Uint8Array(s);
                        if (0 !== r) for(let e1 = 0; e1 < s; e1++)c[e1] = r;
                        this.bitsDecoded = c;
                        this.reset();
                    }
                    setDecoder(e1) {
                        this.decoder = e1;
                    }
                    reset() {
                        this.contexts = new Int8Array(19);
                        this.contexts[0] = 8;
                        this.contexts[BitModel.UNIFORM_CONTEXT] = 92;
                        this.contexts[BitModel.RUNLENGTH_CONTEXT] = 6;
                    }
                    setNeighborsSignificance(e1, t, a) {
                        const r = this.neighborsSignificance, n = this.width, i = this.height, s = t > 0, o = t + 1 < n;
                        let c;
                        if (e1 > 0) {
                            c = a - n;
                            s && (r[c - 1] += 16);
                            o && (r[c + 1] += 16);
                            r[c] += 4;
                        }
                        if (e1 + 1 < i) {
                            c = a + n;
                            s && (r[c - 1] += 16);
                            o && (r[c + 1] += 16);
                            r[c] += 4;
                        }
                        s && (r[a - 1] += 1);
                        o && (r[a + 1] += 1);
                        r[a] |= 128;
                    }
                    runSignificancePropagationPass() {
                        const e1 = this.decoder, t = this.width, a = this.height, r = this.coefficentsMagnitude, n = this.coefficentsSign, i = this.neighborsSignificance, s = this.processingFlags, o = this.contexts, c = this.contextLabelTable, l = this.bitsDecoded;
                        for(let h = 0; h < a; h += 4)for(let u = 0; u < t; u++){
                            let d = h * t + u;
                            for(let f = 0; f < 4; f++, d += t){
                                const t = h + f;
                                if (t >= a) break;
                                s[d] &= -2;
                                if (r[d] || !i[d]) continue;
                                const g = c[i[d]];
                                if (e1.readBit(o, g)) {
                                    const e1 = this.decodeSignBit(t, u, d);
                                    n[d] = e1;
                                    r[d] = 1;
                                    this.setNeighborsSignificance(t, u, d);
                                    s[d] |= 2;
                                }
                                l[d]++;
                                s[d] |= 1;
                            }
                        }
                    }
                    decodeSignBit(e1, t, a) {
                        const r = this.width, n = this.height, i = this.coefficentsMagnitude, s = this.coefficentsSign;
                        let o, c, l, h, u, d;
                        h = t > 0 && 0 !== i[a - 1];
                        if (t + 1 < r && 0 !== i[a + 1]) {
                            l = s[a + 1];
                            if (h) {
                                c = s[a - 1];
                                o = 1 - l - c;
                            } else o = 1 - l - l;
                        } else if (h) {
                            c = s[a - 1];
                            o = 1 - c - c;
                        } else o = 0;
                        const f = 3 * o;
                        h = e1 > 0 && 0 !== i[a - r];
                        if (e1 + 1 < n && 0 !== i[a + r]) {
                            l = s[a + r];
                            if (h) {
                                c = s[a - r];
                                o = 1 - l - c + f;
                            } else o = 1 - l - l + f;
                        } else if (h) {
                            c = s[a - r];
                            o = 1 - c - c + f;
                        } else o = f;
                        if (o >= 0) {
                            u = 9 + o;
                            d = this.decoder.readBit(this.contexts, u);
                        } else {
                            u = 9 - o;
                            d = 1 ^ this.decoder.readBit(this.contexts, u);
                        }
                        return d;
                    }
                    runMagnitudeRefinementPass() {
                        const e1 = this.decoder, t = this.width, a = this.height, r = this.coefficentsMagnitude, n = this.neighborsSignificance, i = this.contexts, s = this.bitsDecoded, o = this.processingFlags, c = t * a, l = 4 * t;
                        for(let a, h = 0; h < c; h = a){
                            a = Math.min(c, h + l);
                            for(let c = 0; c < t; c++)for(let l = h + c; l < a; l += t){
                                if (!r[l] || 0 != (1 & o[l])) continue;
                                let t = 16;
                                if (0 != (2 & o[l])) {
                                    o[l] ^= 2;
                                    t = 0 === (127 & n[l]) ? 15 : 14;
                                }
                                const a = e1.readBit(i, t);
                                r[l] = r[l] << 1 | a;
                                s[l]++;
                                o[l] |= 1;
                            }
                        }
                    }
                    runCleanupPass() {
                        const e1 = this.decoder, t = this.width, a = this.height, r = this.neighborsSignificance, n = this.coefficentsMagnitude, i = this.coefficentsSign, s = this.contexts, o = this.contextLabelTable, c = this.bitsDecoded, l = this.processingFlags, h = t, u = 2 * t, d = 3 * t;
                        let f;
                        for(let g = 0; g < a; g = f){
                            f = Math.min(g + 4, a);
                            const p = g * t, m = g + 3 < a;
                            for(let a = 0; a < t; a++){
                                const b = p + a;
                                let y, w = 0, S = b, x = g;
                                if (m && 0 === l[b] && 0 === l[b + h] && 0 === l[b + u] && 0 === l[b + d] && 0 === r[b] && 0 === r[b + h] && 0 === r[b + u] && 0 === r[b + d]) {
                                    if (!e1.readBit(s, BitModel.RUNLENGTH_CONTEXT)) {
                                        c[b]++;
                                        c[b + h]++;
                                        c[b + u]++;
                                        c[b + d]++;
                                        continue;
                                    }
                                    w = e1.readBit(s, BitModel.UNIFORM_CONTEXT) << 1 | e1.readBit(s, BitModel.UNIFORM_CONTEXT);
                                    if (0 !== w) {
                                        x = g + w;
                                        S += w * t;
                                    }
                                    y = this.decodeSignBit(x, a, S);
                                    i[S] = y;
                                    n[S] = 1;
                                    this.setNeighborsSignificance(x, a, S);
                                    l[S] |= 2;
                                    S = b;
                                    for(let e1 = g; e1 <= x; e1++, S += t)c[S]++;
                                    w++;
                                }
                                for(x = g + w; x < f; x++, S += t){
                                    if (n[S] || 0 != (1 & l[S])) continue;
                                    const t = o[r[S]];
                                    if (1 === e1.readBit(s, t)) {
                                        y = this.decodeSignBit(x, a, S);
                                        i[S] = y;
                                        n[S] = 1;
                                        this.setNeighborsSignificance(x, a, S);
                                        l[S] |= 2;
                                    }
                                    c[S]++;
                                }
                            }
                        }
                    }
                    checkSegmentationSymbol() {
                        const e1 = this.decoder, t = this.contexts;
                        if (10 !== (e1.readBit(t, BitModel.UNIFORM_CONTEXT) << 3 | e1.readBit(t, BitModel.UNIFORM_CONTEXT) << 2 | e1.readBit(t, BitModel.UNIFORM_CONTEXT) << 1 | e1.readBit(t, BitModel.UNIFORM_CONTEXT))) throw new JpxError("Invalid segmentation symbol");
                    }
                }
                class Transform {
                    constructor(){
                        this.constructor === Transform && (0, r.unreachable)("Cannot initialize Transform.");
                    }
                    calculate(e1, t, a) {
                        let r = e1[0];
                        for(let n = 1, i = e1.length; n < i; n++)r = this.iterate(r, e1[n], t, a);
                        return r;
                    }
                    extend(e1, t, a) {
                        let r = t - 1, n = t + 1, i = t + a - 2, s = t + a;
                        e1[r--] = e1[n++];
                        e1[s++] = e1[i--];
                        e1[r--] = e1[n++];
                        e1[s++] = e1[i--];
                        e1[r--] = e1[n++];
                        e1[s++] = e1[i--];
                        e1[r] = e1[n];
                        e1[s] = e1[i];
                    }
                    filter(e1, t, a) {
                        (0, r.unreachable)("Abstract method `filter` called");
                    }
                    iterate(e1, t, a, r) {
                        const n = e1.width, i = e1.height;
                        let s = e1.items;
                        const o = t.width, c = t.height, l = t.items;
                        let h, u, d, f, g, p;
                        for(d = 0, h = 0; h < i; h++){
                            f = 2 * h * o;
                            for(u = 0; u < n; u++, d++, f += 2)l[f] = s[d];
                        }
                        s = e1.items = null;
                        const m = new Float32Array(o + 8);
                        if (1 === o) {
                            if (0 != (1 & a)) for(p = 0, d = 0; p < c; p++, d += o)l[d] *= .5;
                        } else for(p = 0, d = 0; p < c; p++, d += o){
                            m.set(l.subarray(d, d + o), 4);
                            this.extend(m, 4, o);
                            this.filter(m, 4, o);
                            l.set(m.subarray(4, 4 + o), d);
                        }
                        let b = 16;
                        const y = [];
                        for(h = 0; h < b; h++)y.push(new Float32Array(c + 8));
                        let w, S = 0;
                        e1 = 4 + c;
                        if (1 === c) {
                            if (0 != (1 & r)) for(g = 0; g < o; g++)l[g] *= .5;
                        } else for(g = 0; g < o; g++){
                            if (0 === S) {
                                b = Math.min(o - g, b);
                                for(d = g, f = 4; f < e1; d += o, f++)for(w = 0; w < b; w++)y[w][f] = l[d + w];
                                S = b;
                            }
                            S--;
                            const t = y[S];
                            this.extend(t, 4, c);
                            this.filter(t, 4, c);
                            if (0 === S) {
                                d = g - b + 1;
                                for(f = 4; f < e1; d += o, f++)for(w = 0; w < b; w++)l[d + w] = y[w][f];
                            }
                        }
                        return {
                            width: o,
                            height: c,
                            items: l
                        };
                    }
                }
                class IrreversibleTransform extends Transform {
                    filter(e1, t, a) {
                        const r = a >> 1;
                        let n, i, s, o;
                        const c = -1.586134342059924, l = -0.052980118572961, h = .882911075530934, u = .443506852043971, d = 1.230174104914001;
                        n = (t |= 0) - 3;
                        for(i = r + 4; i--; n += 2)e1[n] *= .8128930661159609;
                        n = t - 2;
                        s = u * e1[n - 1];
                        for(i = r + 3; i--; n += 2){
                            o = u * e1[n + 1];
                            e1[n] = d * e1[n] - s - o;
                            if (!i--) break;
                            n += 2;
                            s = u * e1[n + 1];
                            e1[n] = d * e1[n] - s - o;
                        }
                        n = t - 1;
                        s = h * e1[n - 1];
                        for(i = r + 2; i--; n += 2){
                            o = h * e1[n + 1];
                            e1[n] -= s + o;
                            if (!i--) break;
                            n += 2;
                            s = h * e1[n + 1];
                            e1[n] -= s + o;
                        }
                        n = t;
                        s = l * e1[n - 1];
                        for(i = r + 1; i--; n += 2){
                            o = l * e1[n + 1];
                            e1[n] -= s + o;
                            if (!i--) break;
                            n += 2;
                            s = l * e1[n + 1];
                            e1[n] -= s + o;
                        }
                        if (0 !== r) {
                            n = t + 1;
                            s = c * e1[n - 1];
                            for(i = r; i--; n += 2){
                                o = c * e1[n + 1];
                                e1[n] -= s + o;
                                if (!i--) break;
                                n += 2;
                                s = c * e1[n + 1];
                                e1[n] -= s + o;
                            }
                        }
                    }
                }
                class ReversibleTransform extends Transform {
                    filter(e1, t, a) {
                        const r = a >> 1;
                        let n, i;
                        for(n = t |= 0, i = r + 1; i--; n += 2)e1[n] -= e1[n - 1] + e1[n + 1] + 2 >> 2;
                        for(n = t + 1, i = r; i--; n += 2)e1[n] += e1[n - 1] + e1[n + 1] >> 1;
                    }
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.LZWStream = void 0;
                var r = a(18);
                class LZWStream extends r.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        this.cachedData = 0;
                        this.bitsCached = 0;
                        const r = 4096, n = {
                            earlyChange: a,
                            codeLength: 9,
                            nextCode: 258,
                            dictionaryValues: new Uint8Array(r),
                            dictionaryLengths: new Uint16Array(r),
                            dictionaryPrevCodes: new Uint16Array(r),
                            currentSequence: new Uint8Array(r),
                            currentSequenceLength: 0
                        };
                        for(let e1 = 0; e1 < 256; ++e1){
                            n.dictionaryValues[e1] = e1;
                            n.dictionaryLengths[e1] = 1;
                        }
                        this.lzwState = n;
                    }
                    readBits(e1) {
                        let t = this.bitsCached, a = this.cachedData;
                        for(; t < e1;){
                            const e1 = this.str.getByte();
                            if (-1 === e1) {
                                this.eof = !0;
                                return null;
                            }
                            a = a << 8 | e1;
                            t += 8;
                        }
                        this.bitsCached = t -= e1;
                        this.cachedData = a;
                        this.lastCode = null;
                        return a >>> t & (1 << e1) - 1;
                    }
                    readBlock() {
                        let e1, t, a, r = 1024;
                        const n = this.lzwState;
                        if (!n) return;
                        const i = n.earlyChange;
                        let s = n.nextCode;
                        const o = n.dictionaryValues, c = n.dictionaryLengths, l = n.dictionaryPrevCodes;
                        let h = n.codeLength, u = n.prevCode;
                        const d = n.currentSequence;
                        let f = n.currentSequenceLength, g = 0, p = this.bufferLength, m = this.ensureBuffer(this.bufferLength + r);
                        for(e1 = 0; e1 < 512; e1++){
                            const e1 = this.readBits(h), n = f > 0;
                            if (e1 < 256) {
                                d[0] = e1;
                                f = 1;
                            } else {
                                if (!(e1 >= 258)) {
                                    if (256 === e1) {
                                        h = 9;
                                        s = 258;
                                        f = 0;
                                        continue;
                                    }
                                    this.eof = !0;
                                    delete this.lzwState;
                                    break;
                                }
                                if (e1 < s) {
                                    f = c[e1];
                                    for(t = f - 1, a = e1; t >= 0; t--){
                                        d[t] = o[a];
                                        a = l[a];
                                    }
                                } else d[f++] = d[0];
                            }
                            if (n) {
                                l[s] = u;
                                c[s] = c[u] + 1;
                                o[s] = d[0];
                                s++;
                                h = s + i & s + i - 1 ? h : 0 | Math.min(Math.log(s + i) / .6931471805599453 + 1, 12);
                            }
                            u = e1;
                            g += f;
                            if (r < g) {
                                do r += 512;
                                while (r < g);
                                m = this.ensureBuffer(this.bufferLength + r);
                            }
                            for(t = 0; t < f; t++)m[p++] = d[t];
                        }
                        n.nextCode = s;
                        n.codeLength = h;
                        n.prevCode = u;
                        n.currentSequenceLength = f;
                        this.bufferLength = p;
                    }
                }
                t.LZWStream = LZWStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PredictorStream = void 0;
                var r = a(18), n = a(4), i = a(2);
                class PredictorStream extends r.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        if (!(a instanceof n.Dict)) return e1;
                        const r = this.predictor = a.get("Predictor") || 1;
                        if (r <= 1) return e1;
                        if (2 !== r && (r < 10 || r > 15)) throw new i.FormatError(`Unsupported predictor: ${r}`);
                        this.readBlock = 2 === r ? this.readBlockTiff : this.readBlockPng;
                        this.str = e1;
                        this.dict = e1.dict;
                        const s = this.colors = a.get("Colors") || 1, o = this.bits = a.get("BPC", "BitsPerComponent") || 8, c = this.columns = a.get("Columns") || 1;
                        this.pixBytes = s * o + 7 >> 3;
                        this.rowBytes = c * s * o + 7 >> 3;
                        return this;
                    }
                    readBlockTiff() {
                        const e1 = this.rowBytes, t = this.bufferLength, a = this.ensureBuffer(t + e1), r = this.bits, n = this.colors, i = this.str.getBytes(e1);
                        this.eof = !i.length;
                        if (this.eof) return;
                        let s, o = 0, c = 0, l = 0, h = 0, u = t;
                        if (1 === r && 1 === n) for(s = 0; s < e1; ++s){
                            let e1 = i[s] ^ o;
                            e1 ^= e1 >> 1;
                            e1 ^= e1 >> 2;
                            e1 ^= e1 >> 4;
                            o = (1 & e1) << 7;
                            a[u++] = e1;
                        }
                        else if (8 === r) {
                            for(s = 0; s < n; ++s)a[u++] = i[s];
                            for(; s < e1; ++s){
                                a[u] = a[u - n] + i[s];
                                u++;
                            }
                        } else if (16 === r) {
                            const t = 2 * n;
                            for(s = 0; s < t; ++s)a[u++] = i[s];
                            for(; s < e1; s += 2){
                                const e1 = ((255 & i[s]) << 8) + (255 & i[s + 1]) + ((255 & a[u - t]) << 8) + (255 & a[u - t + 1]);
                                a[u++] = e1 >> 8 & 255;
                                a[u++] = 255 & e1;
                            }
                        } else {
                            const e1 = new Uint8Array(n + 1), u = (1 << r) - 1;
                            let d = 0, f = t;
                            const g = this.columns;
                            for(s = 0; s < g; ++s)for(let t = 0; t < n; ++t){
                                if (l < r) {
                                    o = o << 8 | 255 & i[d++];
                                    l += 8;
                                }
                                e1[t] = e1[t] + (o >> l - r) & u;
                                l -= r;
                                c = c << r | e1[t];
                                h += r;
                                if (h >= 8) {
                                    a[f++] = c >> h - 8 & 255;
                                    h -= 8;
                                }
                            }
                            h > 0 && (a[f++] = (c << 8 - h) + (o & (1 << 8 - h) - 1));
                        }
                        this.bufferLength += e1;
                    }
                    readBlockPng() {
                        const e1 = this.rowBytes, t = this.pixBytes, a = this.str.getByte(), r = this.str.getBytes(e1);
                        this.eof = !r.length;
                        if (this.eof) return;
                        const n = this.bufferLength, s = this.ensureBuffer(n + e1);
                        let o = s.subarray(n - e1, n);
                        0 === o.length && (o = new Uint8Array(e1));
                        let c, l, h, u = n;
                        switch(a){
                            case 0:
                                for(c = 0; c < e1; ++c)s[u++] = r[c];
                                break;
                            case 1:
                                for(c = 0; c < t; ++c)s[u++] = r[c];
                                for(; c < e1; ++c){
                                    s[u] = s[u - t] + r[c] & 255;
                                    u++;
                                }
                                break;
                            case 2:
                                for(c = 0; c < e1; ++c)s[u++] = o[c] + r[c] & 255;
                                break;
                            case 3:
                                for(c = 0; c < t; ++c)s[u++] = (o[c] >> 1) + r[c];
                                for(; c < e1; ++c){
                                    s[u] = (o[c] + s[u - t] >> 1) + r[c] & 255;
                                    u++;
                                }
                                break;
                            case 4:
                                for(c = 0; c < t; ++c){
                                    l = o[c];
                                    h = r[c];
                                    s[u++] = l + h;
                                }
                                for(; c < e1; ++c){
                                    l = o[c];
                                    const e1 = o[c - t], a = s[u - t], n = a + l - e1;
                                    let i = n - a;
                                    i < 0 && (i = -i);
                                    let d = n - l;
                                    d < 0 && (d = -d);
                                    let f = n - e1;
                                    f < 0 && (f = -f);
                                    h = r[c];
                                    s[u++] = i <= d && i <= f ? a + h : d <= f ? l + h : e1 + h;
                                }
                                break;
                            default:
                                throw new i.FormatError(`Unsupported predictor: ${a}`);
                        }
                        this.bufferLength += e1;
                    }
                }
                t.PredictorStream = PredictorStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.RunLengthStream = void 0;
                var r = a(18);
                class RunLengthStream extends r.DecodeStream {
                    constructor(e1, t){
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                    }
                    readBlock() {
                        const e1 = this.str.getBytes(2);
                        if (!e1 || e1.length < 2 || 128 === e1[0]) {
                            this.eof = !0;
                            return;
                        }
                        let t, a = this.bufferLength, r = e1[0];
                        if (r < 128) {
                            t = this.ensureBuffer(a + r + 1);
                            t[a++] = e1[1];
                            if (r > 0) {
                                const e1 = this.str.getBytes(r);
                                t.set(e1, a);
                                a += r;
                            }
                        } else {
                            r = 257 - r;
                            const n = e1[1];
                            t = this.ensureBuffer(a + r + 1);
                            for(let e1 = 0; e1 < r; e1++)t[a++] = n;
                        }
                        this.bufferLength = a;
                    }
                }
                t.RunLengthStream = RunLengthStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Font = t.ErrorFont = void 0;
                var r = a(2), n = a(35), i = a(38), s = a(40), o = a(39), c = a(37), l = a(41), h = a(42), u = a(43), d = a(44), f = a(45), g = a(46), p = a(14), m = a(47), b = a(3), y = a(8), w = a(48);
                const S = [
                    [
                        57344,
                        63743
                    ],
                    [
                        1048576,
                        1114109
                    ]
                ], x = 1e3, C = [
                    "ascent",
                    "bbox",
                    "black",
                    "bold",
                    "charProcOperatorList",
                    "composite",
                    "cssFontInfo",
                    "data",
                    "defaultVMetrics",
                    "defaultWidth",
                    "descent",
                    "fallbackName",
                    "fontMatrix",
                    "isInvalidPDFjsFont",
                    "isType3Font",
                    "italic",
                    "loadedName",
                    "mimetype",
                    "missingFile",
                    "name",
                    "remeasure",
                    "subtype",
                    "systemFontInfo",
                    "type",
                    "vertical"
                ], k = [
                    "cMap",
                    "defaultEncoding",
                    "differences",
                    "isMonospace",
                    "isSerifFont",
                    "isSymbolicFont",
                    "seacMap",
                    "toFontChar",
                    "toUnicode",
                    "vmetrics",
                    "widths"
                ];
                function adjustWidths(e1) {
                    if (!e1.fontMatrix) return;
                    if (e1.fontMatrix[0] === r.FONT_IDENTITY_MATRIX[0]) return;
                    const t = .001 / e1.fontMatrix[0], a = e1.widths;
                    for(const e1 in a)a[e1] *= t;
                    e1.defaultWidth *= t;
                }
                function amendFallbackToUnicode(e1) {
                    if (!e1.fallbackToUnicode) return;
                    if (e1.toUnicode instanceof h.IdentityToUnicodeMap) return;
                    const t = [];
                    for(const a in e1.fallbackToUnicode)e1.toUnicode.has(a) || (t[a] = e1.fallbackToUnicode[a]);
                    t.length > 0 && e1.toUnicode.amend(t);
                }
                class Glyph {
                    constructor(e1, t, a, r, n, i, s, o, c){
                        this.originalCharCode = e1;
                        this.fontChar = t;
                        this.unicode = a;
                        this.accent = r;
                        this.width = n;
                        this.vmetric = i;
                        this.operatorListId = s;
                        this.isSpace = o;
                        this.isInFont = c;
                    }
                    get category() {
                        return (0, r.shadow)(this, "category", (0, s.getCharUnicodeCategory)(this.unicode), !0);
                    }
                }
                function int16(e1, t) {
                    return (e1 << 8) + t;
                }
                function writeSignedInt16(e1, t, a) {
                    e1[t + 1] = a;
                    e1[t] = a >>> 8;
                }
                function signedInt16(e1, t) {
                    const a = (e1 << 8) + t;
                    return 32768 & a ? a - 65536 : a;
                }
                function string16(e1) {
                    return String.fromCharCode(e1 >> 8 & 255, 255 & e1);
                }
                function safeString16(e1) {
                    e1 > 32767 ? e1 = 32767 : e1 < -32768 && (e1 = -32768);
                    return String.fromCharCode(e1 >> 8 & 255, 255 & e1);
                }
                function isTrueTypeCollectionFile(e1) {
                    const t = e1.peekBytes(4);
                    return "ttcf" === (0, r.bytesToString)(t);
                }
                function getFontFileType(e1, { type: t, subtype: a, composite: n }) {
                    let i, s;
                    if (function isTrueTypeFile(e1) {
                        const t = e1.peekBytes(4);
                        return 65536 === (0, b.readUint32)(t, 0) || "true" === (0, r.bytesToString)(t);
                    }(e1) || isTrueTypeCollectionFile(e1)) i = n ? "CIDFontType2" : "TrueType";
                    else if (function isOpenTypeFile(e1) {
                        const t = e1.peekBytes(4);
                        return "OTTO" === (0, r.bytesToString)(t);
                    }(e1)) i = n ? "CIDFontType2" : "OpenType";
                    else if (function isType1File(e1) {
                        const t = e1.peekBytes(2);
                        return 37 === t[0] && 33 === t[1] || 128 === t[0] && 1 === t[1];
                    }(e1)) i = n ? "CIDFontType0" : "MMType1" === t ? "MMType1" : "Type1";
                    else if (function isCFFFile(e1) {
                        const t = e1.peekBytes(4);
                        return t[0] >= 1 && t[3] >= 1 && t[3] <= 4;
                    }(e1)) {
                        if (n) {
                            i = "CIDFontType0";
                            s = "CIDFontType0C";
                        } else {
                            i = "MMType1" === t ? "MMType1" : "Type1";
                            s = "Type1C";
                        }
                    } else {
                        (0, r.warn)("getFontFileType: Unable to detect correct font file Type/Subtype.");
                        i = t;
                        s = a;
                    }
                    return [
                        i,
                        s
                    ];
                }
                function applyStandardFontGlyphMap(e1, t) {
                    for(const a in t)e1[+a] = t[a];
                }
                function buildToFontChar(e1, t, a) {
                    const r = [];
                    let n;
                    for(let a = 0, i = e1.length; a < i; a++){
                        n = (0, s.getUnicodeForGlyph)(e1[a], t);
                        -1 !== n && (r[a] = n);
                    }
                    for(const e1 in a){
                        n = (0, s.getUnicodeForGlyph)(a[e1], t);
                        -1 !== n && (r[+e1] = n);
                    }
                    return r;
                }
                function isMacNameRecord(e1) {
                    return 1 === e1.platform && 0 === e1.encoding && 0 === e1.language;
                }
                function isWinNameRecord(e1) {
                    return 3 === e1.platform && 1 === e1.encoding && 1033 === e1.language;
                }
                function convertCidString(e1, t, a = !1) {
                    switch(t.length){
                        case 1:
                            return t.charCodeAt(0);
                        case 2:
                            return t.charCodeAt(0) << 8 | t.charCodeAt(1);
                    }
                    const n = `Unsupported CID string (charCode ${e1}): "${t}".`;
                    if (a) throw new r.FormatError(n);
                    (0, r.warn)(n);
                    return t;
                }
                function adjustMapping(e1, t, a, n) {
                    const i = Object.create(null), s = new Map, o = [], c = new Set;
                    let l = 0;
                    let h = S[l][0], u = S[l][1];
                    for(let f in e1){
                        f |= 0;
                        let g = e1[f];
                        if (!t(g)) continue;
                        if (h > u) {
                            l++;
                            if (l >= S.length) {
                                (0, r.warn)("Ran out of space in font private use area.");
                                break;
                            }
                            h = S[l][0];
                            u = S[l][1];
                        }
                        const p = h++;
                        0 === g && (g = a);
                        let m = n.get(f);
                        "string" == typeof m && (m = m.codePointAt(0));
                        if (m && !(d = m, S[0][0] <= d && d <= S[0][1] || S[1][0] <= d && d <= S[1][1]) && !c.has(g)) {
                            s.set(m, g);
                            c.add(g);
                        }
                        i[p] = g;
                        o[f] = p;
                    }
                    var d;
                    return {
                        toFontChar: o,
                        charCodeToGlyphId: i,
                        toUnicodeExtraMap: s,
                        nextAvailableFontCharCode: h
                    };
                }
                function createCmapTable(e1, t, a) {
                    const n = function getRanges(e1, t, a) {
                        const r = [];
                        for(const t in e1)e1[t] >= a || r.push({
                            fontCharCode: 0 | t,
                            glyphId: e1[t]
                        });
                        if (t) for (const [e1, n] of t)n >= a || r.push({
                            fontCharCode: e1,
                            glyphId: n
                        });
                        0 === r.length && r.push({
                            fontCharCode: 0,
                            glyphId: 0
                        });
                        r.sort(function fontGetRangesSort(e1, t) {
                            return e1.fontCharCode - t.fontCharCode;
                        });
                        const n = [], i = r.length;
                        for(let e1 = 0; e1 < i;){
                            const t = r[e1].fontCharCode, a = [
                                r[e1].glyphId
                            ];
                            ++e1;
                            let s = t;
                            for(; e1 < i && s + 1 === r[e1].fontCharCode;){
                                a.push(r[e1].glyphId);
                                ++s;
                                ++e1;
                                if (65535 === s) break;
                            }
                            n.push([
                                t,
                                s,
                                a
                            ]);
                        }
                        return n;
                    }(e1, t, a), i = n.at(-1)[1] > 65535 ? 2 : 1;
                    let s, o, c, l, h = "\0\0" + string16(i) + "\0\0" + (0, r.string32)(4 + 8 * i);
                    for(s = n.length - 1; s >= 0 && !(n[s][0] <= 65535); --s);
                    const u = s + 1;
                    n[s][0] < 65535 && 65535 === n[s][1] && (n[s][1] = 65534);
                    const d = n[s][1] < 65535 ? 1 : 0, f = u + d, g = m.OpenTypeFileBuilder.getSearchParams(f, 2);
                    let p, b, y, w, S = "", x = "", C = "", k = "", v = "", F = 0;
                    for(s = 0, o = u; s < o; s++){
                        p = n[s];
                        b = p[0];
                        y = p[1];
                        S += string16(b);
                        x += string16(y);
                        w = p[2];
                        let e1 = !0;
                        for(c = 1, l = w.length; c < l; ++c)if (w[c] !== w[c - 1] + 1) {
                            e1 = !1;
                            break;
                        }
                        if (e1) {
                            C += string16(w[0] - b & 65535);
                            k += string16(0);
                        } else {
                            const e1 = 2 * (f - s) + 2 * F;
                            F += y - b + 1;
                            C += string16(0);
                            k += string16(e1);
                            for(c = 0, l = w.length; c < l; ++c)v += string16(w[c]);
                        }
                    }
                    if (d > 0) {
                        x += "\xff\xff";
                        S += "\xff\xff";
                        C += "\0";
                        k += "\0\0";
                    }
                    const O = "\0\0" + string16(2 * f) + string16(g.range) + string16(g.entry) + string16(g.rangeShift) + x + "\0\0" + S + C + k + v;
                    let T = "", M = "";
                    if (i > 1) {
                        h += "\0\0\n" + (0, r.string32)(4 + 8 * i + 4 + O.length);
                        T = "";
                        for(s = 0, o = n.length; s < o; s++){
                            p = n[s];
                            b = p[0];
                            w = p[2];
                            let e1 = w[0];
                            for(c = 1, l = w.length; c < l; ++c)if (w[c] !== w[c - 1] + 1) {
                                y = p[0] + c - 1;
                                T += (0, r.string32)(b) + (0, r.string32)(y) + (0, r.string32)(e1);
                                b = y + 1;
                                e1 = w[c];
                            }
                            T += (0, r.string32)(b) + (0, r.string32)(p[1]) + (0, r.string32)(e1);
                        }
                        M = "\0\f\0\0" + (0, r.string32)(T.length + 16) + "\0\0\0\0" + (0, r.string32)(T.length / 12);
                    }
                    return h + "\0" + string16(O.length + 4) + O + M + T;
                }
                function createOS2Table(e1, t, a) {
                    a ||= {
                        unitsPerEm: 0,
                        yMax: 0,
                        yMin: 0,
                        ascent: 0,
                        descent: 0
                    };
                    let n = 0, i = 0, o = 0, c = 0, l = null, h = 0, u = -1;
                    if (t) {
                        for(let e1 in t){
                            e1 |= 0;
                            (l > e1 || !l) && (l = e1);
                            h < e1 && (h = e1);
                            u = (0, s.getUnicodeRangeFor)(e1, u);
                            if (u < 32) n |= 1 << u;
                            else if (u < 64) i |= 1 << u - 32;
                            else if (u < 96) o |= 1 << u - 64;
                            else {
                                if (!(u < 123)) throw new r.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                                c |= 1 << u - 96;
                            }
                        }
                        h > 65535 && (h = 65535);
                    } else {
                        l = 0;
                        h = 255;
                    }
                    const d = e1.bbox || [
                        0,
                        0,
                        0,
                        0
                    ], f = a.unitsPerEm || 1 / (e1.fontMatrix || r.FONT_IDENTITY_MATRIX)[0], g = e1.ascentScaled ? 1 : f / x, p = a.ascent || Math.round(g * (e1.ascent || d[3]));
                    let m = a.descent || Math.round(g * (e1.descent || d[1]));
                    m > 0 && e1.descent > 0 && d[1] < 0 && (m = -m);
                    const b = a.yMax || p, y = -a.yMin || -m;
                    return "\0\x03\x02$\x01\xf4\0\x05\0\0\x02\x8a\x02\xbb\0\0\0\x8c\x02\x8a\x02\xbb\0\0\x01\xdf\x001\x01\x02\0\0\0\0\x06" + String.fromCharCode(e1.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, r.string32)(n) + (0, r.string32)(i) + (0, r.string32)(o) + (0, r.string32)(c) + "*21*" + string16(e1.italicAngle ? 1 : 0) + string16(l || e1.firstChar) + string16(h || e1.lastChar) + string16(p) + string16(m) + "\0d" + string16(b) + string16(y) + "\0\0\0\0\0\0\0\0" + string16(e1.xHeight) + string16(e1.capHeight) + string16(0) + string16(l || e1.firstChar) + "\0";
                }
                function createPostTable(e1) {
                    const t = Math.floor(65536 * e1.italicAngle);
                    return "\0\0\0" + (0, r.string32)(t) + "\0\0\0\0" + (0, r.string32)(e1.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
                }
                function createPostscriptName(e1) {
                    return e1.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
                }
                function createNameTable(e1, t) {
                    t || (t = [
                        [],
                        []
                    ]);
                    const a = [
                        t[0][0] || "Original licence",
                        t[0][1] || e1,
                        t[0][2] || "Unknown",
                        t[0][3] || "uniqueID",
                        t[0][4] || e1,
                        t[0][5] || "Version 0.11",
                        t[0][6] || createPostscriptName(e1),
                        t[0][7] || "Unknown",
                        t[0][8] || "Unknown",
                        t[0][9] || "Unknown"
                    ], r = [];
                    let n, i, s, o, c;
                    for(n = 0, i = a.length; n < i; n++){
                        c = t[1][n] || a[n];
                        const e1 = [];
                        for(s = 0, o = c.length; s < o; s++)e1.push(string16(c.charCodeAt(s)));
                        r.push(e1.join(""));
                    }
                    const l = [
                        a,
                        r
                    ], h = [
                        "\0",
                        "\0"
                    ], u = [
                        "\0\0",
                        "\0"
                    ], d = [
                        "\0\0",
                        "\t"
                    ], f = a.length * h.length;
                    let g = "\0\0" + string16(f) + string16(12 * f + 6), p = 0;
                    for(n = 0, i = h.length; n < i; n++){
                        const e1 = l[n];
                        for(s = 0, o = e1.length; s < o; s++){
                            c = e1[s];
                            g += h[n] + u[n] + d[n] + string16(s) + string16(c.length) + string16(p);
                            p += c.length;
                        }
                    }
                    g += a.join("") + r.join("");
                    return g;
                }
                t.Font = class Font {
                    constructor(e1, t, a){
                        this.name = e1;
                        this.psName = null;
                        this.mimetype = null;
                        this.disableFontFace = !1;
                        this.loadedName = a.loadedName;
                        this.isType3Font = a.isType3Font;
                        this.missingFile = !1;
                        this.cssFontInfo = a.cssFontInfo;
                        this._charsCache = Object.create(null);
                        this._glyphCache = Object.create(null);
                        let n = !!(a.flags & i.FontFlags.Serif);
                        if (!n && !a.isSimulatedFlags) {
                            const t = e1.replaceAll(/[,_]/g, "-").split("-")[0], a = (0, l.getSerifFonts)();
                            for (const e1 of t.split("+"))if (a[e1]) {
                                n = !0;
                                break;
                            }
                        }
                        this.isSerifFont = n;
                        this.isSymbolicFont = !!(a.flags & i.FontFlags.Symbolic);
                        this.isMonospace = !!(a.flags & i.FontFlags.FixedPitch);
                        let { type: s, subtype: o } = a;
                        this.type = s;
                        this.subtype = o;
                        this.systemFontInfo = a.systemFontInfo;
                        const c = e1.match(/^InvalidPDFjsFont_(.*)_\d+$/);
                        this.isInvalidPDFjsFont = !!c;
                        this.isInvalidPDFjsFont ? this.fallbackName = c[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif";
                        if (this.systemFontInfo?.guessFallback) {
                            this.systemFontInfo.guessFallback = !1;
                            this.systemFontInfo.css += `,${this.fallbackName}`;
                        }
                        this.differences = a.differences;
                        this.widths = a.widths;
                        this.defaultWidth = a.defaultWidth;
                        this.composite = a.composite;
                        this.cMap = a.cMap;
                        this.capHeight = a.capHeight / x;
                        this.ascent = a.ascent / x;
                        this.descent = a.descent / x;
                        this.lineHeight = this.ascent - this.descent;
                        this.fontMatrix = a.fontMatrix;
                        this.bbox = a.bbox;
                        this.defaultEncoding = a.defaultEncoding;
                        this.toUnicode = a.toUnicode;
                        this.toFontChar = [];
                        if ("Type3" === a.type) {
                            for(let e1 = 0; e1 < 256; e1++)this.toFontChar[e1] = this.differences[e1] || a.defaultEncoding[e1];
                            return;
                        }
                        this.cidEncoding = a.cidEncoding || "";
                        this.vertical = !!a.vertical;
                        if (this.vertical) {
                            this.vmetrics = a.vmetrics;
                            this.defaultVMetrics = a.defaultVMetrics;
                        }
                        if (!t || t.isEmpty) {
                            t && (0, r.warn)('Font file is empty in "' + e1 + '" (' + this.loadedName + ")");
                            this.fallbackToSystemFont(a);
                            return;
                        }
                        [s, o] = getFontFileType(t, a);
                        s === this.type && o === this.subtype || (0, r.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${s}/${o}.`);
                        let h;
                        try {
                            switch(s){
                                case "MMType1":
                                    (0, r.info)("MMType1 font (" + e1 + "), falling back to Type1.");
                                case "Type1":
                                case "CIDFontType0":
                                    this.mimetype = "font/opentype";
                                    const n = "Type1C" === o || "CIDFontType0C" === o ? new u.CFFFont(t, a) : new w.Type1Font(e1, t, a);
                                    adjustWidths(a);
                                    h = this.convert(e1, n, a);
                                    break;
                                case "OpenType":
                                case "TrueType":
                                case "CIDFontType2":
                                    this.mimetype = "font/opentype";
                                    h = this.checkAndRepair(e1, t, a);
                                    if (this.isOpenType) {
                                        adjustWidths(a);
                                        s = "OpenType";
                                    }
                                    break;
                                default:
                                    throw new r.FormatError(`Font ${s} is not supported`);
                            }
                        } catch (e1) {
                            (0, r.warn)(e1);
                            this.fallbackToSystemFont(a);
                            return;
                        }
                        amendFallbackToUnicode(a);
                        this.data = h;
                        this.type = s;
                        this.subtype = o;
                        this.fontMatrix = a.fontMatrix;
                        this.widths = a.widths;
                        this.defaultWidth = a.defaultWidth;
                        this.toUnicode = a.toUnicode;
                        this.seacMap = a.seacMap;
                    }
                    get renderer() {
                        const e1 = d.FontRendererFactory.create(this, i.SEAC_ANALYSIS_ENABLED);
                        return (0, r.shadow)(this, "renderer", e1);
                    }
                    exportData(e1 = !1) {
                        const t = e1 ? [
                            ...C,
                            ...k
                        ] : C, a = Object.create(null);
                        let r, n;
                        for (r of t){
                            n = this[r];
                            void 0 !== n && (a[r] = n);
                        }
                        return a;
                    }
                    fallbackToSystemFont(e1) {
                        this.missingFile = !0;
                        const { name: t, type: a } = this;
                        let r = (0, i.normalizeFontName)(t);
                        const n = (0, l.getStdFontMap)(), u = (0, l.getNonStdFontMap)(), d = !!n[r], g = !(!u[r] || !n[u[r]]);
                        r = n[r] || u[r] || r;
                        const p = (0, f.getFontBasicMetrics)()[r];
                        if (p) {
                            isNaN(this.ascent) && (this.ascent = p.ascent / x);
                            isNaN(this.descent) && (this.descent = p.descent / x);
                            isNaN(this.capHeight) && (this.capHeight = p.capHeight / x);
                        }
                        this.bold = /bold/gi.test(r);
                        this.italic = /oblique|italic/gi.test(r);
                        this.black = /Black/g.test(t);
                        const m = /Narrow/g.test(t);
                        this.remeasure = (!d || m) && Object.keys(this.widths).length > 0;
                        if ((d || g) && "CIDFontType2" === a && this.cidEncoding.startsWith("Identity-")) {
                            const a = e1.cidToGidMap, r = [];
                            applyStandardFontGlyphMap(r, (0, l.getGlyphMapForStandardFonts)());
                            /Arial-?Black/i.test(t) ? applyStandardFontGlyphMap(r, (0, l.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(t) && applyStandardFontGlyphMap(r, (0, l.getSupplementalGlyphMapForCalibri)());
                            if (a) {
                                for(const e1 in r){
                                    const t = r[e1];
                                    void 0 !== a[t] && (r[+e1] = a[t]);
                                }
                                a.length !== this.toUnicode.length && e1.hasIncludedToUnicodeMap && this.toUnicode instanceof h.IdentityToUnicodeMap && this.toUnicode.forEach(function(e1, t) {
                                    const n = r[e1];
                                    void 0 === a[n] && (r[+e1] = t);
                                });
                            }
                            this.toUnicode instanceof h.IdentityToUnicodeMap || this.toUnicode.forEach(function(e1, t) {
                                r[+e1] = t;
                            });
                            this.toFontChar = r;
                            this.toUnicode = new h.ToUnicodeMap(r);
                        } else if (/Symbol/i.test(r)) this.toFontChar = buildToFontChar(c.SymbolSetEncoding, (0, o.getGlyphsUnicode)(), this.differences);
                        else if (/Dingbats/i.test(r)) this.toFontChar = buildToFontChar(c.ZapfDingbatsEncoding, (0, o.getDingbatsGlyphsUnicode)(), this.differences);
                        else if (d) {
                            const e1 = buildToFontChar(this.defaultEncoding, (0, o.getGlyphsUnicode)(), this.differences);
                            "CIDFontType2" !== a || this.cidEncoding.startsWith("Identity-") || this.toUnicode instanceof h.IdentityToUnicodeMap || this.toUnicode.forEach(function(t, a) {
                                e1[+t] = a;
                            });
                            this.toFontChar = e1;
                        } else {
                            const e1 = (0, o.getGlyphsUnicode)(), a = [];
                            this.toUnicode.forEach((t, r)=>{
                                if (!this.composite) {
                                    const a = this.differences[t] || this.defaultEncoding[t], n = (0, s.getUnicodeForGlyph)(a, e1);
                                    -1 !== n && (r = n);
                                }
                                a[+t] = r;
                            });
                            this.composite && this.toUnicode instanceof h.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(t) && applyStandardFontGlyphMap(a, (0, l.getGlyphMapForStandardFonts)());
                            this.toFontChar = a;
                        }
                        amendFallbackToUnicode(e1);
                        this.loadedName = r.split("-")[0];
                    }
                    checkAndRepair(e1, t, a) {
                        const s = [
                            "OS/2",
                            "cmap",
                            "head",
                            "hhea",
                            "hmtx",
                            "maxp",
                            "name",
                            "post",
                            "loca",
                            "glyf",
                            "fpgm",
                            "prep",
                            "cvt ",
                            "CFF "
                        ];
                        function readTables(e1, t) {
                            const a = Object.create(null);
                            a["OS/2"] = null;
                            a.cmap = null;
                            a.head = null;
                            a.hhea = null;
                            a.hmtx = null;
                            a.maxp = null;
                            a.name = null;
                            a.post = null;
                            for(let r = 0; r < t; r++){
                                const t = readTableEntry(e1);
                                s.includes(t.tag) && 0 !== t.length && (a[t.tag] = t);
                            }
                            return a;
                        }
                        function readTableEntry(e1) {
                            const t = e1.getString(4), a = e1.getInt32() >>> 0, r = e1.getInt32() >>> 0, n = e1.getInt32() >>> 0, i = e1.pos;
                            e1.pos = e1.start || 0;
                            e1.skip(r);
                            const s = e1.getBytes(n);
                            e1.pos = i;
                            if ("head" === t) {
                                s[8] = s[9] = s[10] = s[11] = 0;
                                s[17] |= 32;
                            }
                            return {
                                tag: t,
                                checksum: a,
                                length: n,
                                offset: r,
                                data: s
                            };
                        }
                        function readOpenTypeHeader(e1) {
                            return {
                                version: e1.getString(4),
                                numTables: e1.getUint16(),
                                searchRange: e1.getUint16(),
                                entrySelector: e1.getUint16(),
                                rangeShift: e1.getUint16()
                            };
                        }
                        function sanitizeGlyph(e1, t, a, r, n, i) {
                            const s = {
                                length: 0,
                                sizeOfInstructions: 0
                            };
                            if (t < 0 || t >= e1.length || a > e1.length || a - t <= 12) return s;
                            const o = e1.subarray(t, a), c = signedInt16(o[2], o[3]), l = signedInt16(o[4], o[5]), h = signedInt16(o[6], o[7]), u = signedInt16(o[8], o[9]);
                            if (c > h) {
                                writeSignedInt16(o, 2, h);
                                writeSignedInt16(o, 6, c);
                            }
                            if (l > u) {
                                writeSignedInt16(o, 4, u);
                                writeSignedInt16(o, 8, l);
                            }
                            const d = signedInt16(o[0], o[1]);
                            if (d < 0) {
                                if (d < -1) return s;
                                r.set(o, n);
                                s.length = o.length;
                                return s;
                            }
                            let f, g = 10, p = 0;
                            for(f = 0; f < d; f++){
                                p = (o[g] << 8 | o[g + 1]) + 1;
                                g += 2;
                            }
                            const m = g, b = o[g] << 8 | o[g + 1];
                            s.sizeOfInstructions = b;
                            g += 2 + b;
                            const y = g;
                            let w = 0;
                            for(f = 0; f < p; f++){
                                const e1 = o[g++];
                                192 & e1 && (o[g - 1] = 63 & e1);
                                let t = 2;
                                2 & e1 ? t = 1 : 16 & e1 && (t = 0);
                                let a = 2;
                                4 & e1 ? a = 1 : 32 & e1 && (a = 0);
                                const r = t + a;
                                w += r;
                                if (8 & e1) {
                                    const e1 = o[g++];
                                    0 === e1 && (o[g - 1] ^= 8);
                                    f += e1;
                                    w += e1 * r;
                                }
                            }
                            if (0 === w) return s;
                            let S = g + w;
                            if (S > o.length) return s;
                            if (!i && b > 0) {
                                r.set(o.subarray(0, m), n);
                                r.set([
                                    0,
                                    0
                                ], n + m);
                                r.set(o.subarray(y, S), n + m + 2);
                                S -= b;
                                o.length - S > 3 && (S = S + 3 & -4);
                                s.length = S;
                                return s;
                            }
                            if (o.length - S > 3) {
                                S = S + 3 & -4;
                                r.set(o.subarray(0, S), n);
                                s.length = S;
                                return s;
                            }
                            r.set(o, n);
                            s.length = o.length;
                            return s;
                        }
                        function readNameTable(e1) {
                            const a = (t.start || 0) + e1.offset;
                            t.pos = a;
                            const r = [
                                [],
                                []
                            ], n = [], i = e1.length, s = a + i;
                            if (0 !== t.getUint16() || i < 6) return [
                                r,
                                n
                            ];
                            const o = t.getUint16(), c = t.getUint16();
                            let l, h;
                            for(l = 0; l < o && t.pos + 12 <= s; l++){
                                const e1 = {
                                    platform: t.getUint16(),
                                    encoding: t.getUint16(),
                                    language: t.getUint16(),
                                    name: t.getUint16(),
                                    length: t.getUint16(),
                                    offset: t.getUint16()
                                };
                                (isMacNameRecord(e1) || isWinNameRecord(e1)) && n.push(e1);
                            }
                            for(l = 0, h = n.length; l < h; l++){
                                const e1 = n[l];
                                if (e1.length <= 0) continue;
                                const i = a + c + e1.offset;
                                if (i + e1.length > s) continue;
                                t.pos = i;
                                const o = e1.name;
                                if (e1.encoding) {
                                    let a = "";
                                    for(let r = 0, n = e1.length; r < n; r += 2)a += String.fromCharCode(t.getUint16());
                                    r[1][o] = a;
                                } else r[0][o] = t.getString(e1.length);
                            }
                            return [
                                r,
                                n
                            ];
                        }
                        const l = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -2,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            -5,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            1,
                            -1,
                            -999,
                            0,
                            1,
                            0,
                            -1,
                            -2,
                            0,
                            -1,
                            -2,
                            -1,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            0,
                            -999,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -2,
                            -999,
                            -2,
                            -2,
                            -999,
                            0,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            0,
                            -2,
                            0,
                            0,
                            0,
                            -2,
                            -1,
                            -1,
                            1,
                            1,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -999,
                            -999,
                            -999,
                            -999,
                            -999,
                            -1,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -999,
                            -2,
                            -2,
                            0,
                            0,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -2
                        ];
                        function sanitizeTTProgram(e1, t) {
                            let a, n, i, s, o, c = e1.data, h = 0, u = 0, d = 0;
                            const f = [], g = [], p = [];
                            let m = t.tooComplexToFollowFunctions, b = !1, y = 0, w = 0;
                            for(let e1 = c.length; h < e1;){
                                const e1 = c[h++];
                                if (64 === e1) {
                                    n = c[h++];
                                    if (b || w) h += n;
                                    else for(a = 0; a < n; a++)f.push(c[h++]);
                                } else if (65 === e1) {
                                    n = c[h++];
                                    if (b || w) h += 2 * n;
                                    else for(a = 0; a < n; a++){
                                        i = c[h++];
                                        f.push(i << 8 | c[h++]);
                                    }
                                } else if (176 == (248 & e1)) {
                                    n = e1 - 176 + 1;
                                    if (b || w) h += n;
                                    else for(a = 0; a < n; a++)f.push(c[h++]);
                                } else if (184 == (248 & e1)) {
                                    n = e1 - 184 + 1;
                                    if (b || w) h += 2 * n;
                                    else for(a = 0; a < n; a++){
                                        i = c[h++];
                                        f.push(i << 8 | c[h++]);
                                    }
                                } else if (43 !== e1 || m) {
                                    if (44 !== e1 || m) {
                                        if (45 === e1) {
                                            if (b) {
                                                b = !1;
                                                u = h;
                                            } else {
                                                o = g.pop();
                                                if (!o) {
                                                    (0, r.warn)("TT: ENDF bad stack");
                                                    t.hintsValid = !1;
                                                    return;
                                                }
                                                s = p.pop();
                                                c = o.data;
                                                h = o.i;
                                                t.functionsStackDeltas[s] = f.length - o.stackTop;
                                            }
                                        } else if (137 === e1) {
                                            if (b || w) {
                                                (0, r.warn)("TT: nested IDEFs not allowed");
                                                m = !0;
                                            }
                                            b = !0;
                                            d = h;
                                        } else if (88 === e1) ++y;
                                        else if (27 === e1) w = y;
                                        else if (89 === e1) {
                                            w === y && (w = 0);
                                            --y;
                                        } else if (28 === e1 && !b && !w) {
                                            const e1 = f.at(-1);
                                            e1 > 0 && (h += e1 - 1);
                                        }
                                    } else {
                                        if (b || w) {
                                            (0, r.warn)("TT: nested FDEFs not allowed");
                                            m = !0;
                                        }
                                        b = !0;
                                        d = h;
                                        s = f.pop();
                                        t.functionsDefined[s] = {
                                            data: c,
                                            i: h
                                        };
                                    }
                                } else if (!b && !w) {
                                    s = f.at(-1);
                                    if (isNaN(s)) (0, r.info)("TT: CALL empty stack (or invalid entry).");
                                    else {
                                        t.functionsUsed[s] = !0;
                                        if (s in t.functionsStackDeltas) {
                                            const e1 = f.length + t.functionsStackDeltas[s];
                                            if (e1 < 0) {
                                                (0, r.warn)("TT: CALL invalid functions stack delta.");
                                                t.hintsValid = !1;
                                                return;
                                            }
                                            f.length = e1;
                                        } else if (s in t.functionsDefined && !p.includes(s)) {
                                            g.push({
                                                data: c,
                                                i: h,
                                                stackTop: f.length - 1
                                            });
                                            p.push(s);
                                            o = t.functionsDefined[s];
                                            if (!o) {
                                                (0, r.warn)("TT: CALL non-existent function");
                                                t.hintsValid = !1;
                                                return;
                                            }
                                            c = o.data;
                                            h = o.i;
                                        }
                                    }
                                }
                                if (!b && !w) {
                                    let t = 0;
                                    e1 <= 142 ? t = l[e1] : e1 >= 192 && e1 <= 223 ? t = -1 : e1 >= 224 && (t = -2);
                                    if (e1 >= 113 && e1 <= 117) {
                                        n = f.pop();
                                        isNaN(n) || (t = 2 * -n);
                                    }
                                    for(; t < 0 && f.length > 0;){
                                        f.pop();
                                        t++;
                                    }
                                    for(; t > 0;){
                                        f.push(NaN);
                                        t--;
                                    }
                                }
                            }
                            t.tooComplexToFollowFunctions = m;
                            const S = [
                                c
                            ];
                            h > c.length && S.push(new Uint8Array(h - c.length));
                            if (d > u) {
                                (0, r.warn)("TT: complementing a missing function tail");
                                S.push(new Uint8Array([
                                    34,
                                    45
                                ]));
                            }
                            !function foldTTTable(e1, t) {
                                if (t.length > 1) {
                                    let a, r, n = 0;
                                    for(a = 0, r = t.length; a < r; a++)n += t[a].length;
                                    n = n + 3 & -4;
                                    const i = new Uint8Array(n);
                                    let s = 0;
                                    for(a = 0, r = t.length; a < r; a++){
                                        i.set(t[a], s);
                                        s += t[a].length;
                                    }
                                    e1.data = i;
                                    e1.length = n;
                                }
                            }(e1, S);
                        }
                        let d, f, b, w;
                        if (isTrueTypeCollectionFile(t = new y.Stream(new Uint8Array(t.getBytes())))) {
                            const e1 = function readTrueTypeCollectionData(e1, t) {
                                const { numFonts: a, offsetTable: n } = function readTrueTypeCollectionHeader(e1) {
                                    const t = e1.getString(4);
                                    (0, r.assert)("ttcf" === t, "Must be a TrueType Collection font.");
                                    const a = e1.getUint16(), n = e1.getUint16(), i = e1.getInt32() >>> 0, s = [];
                                    for(let t = 0; t < i; t++)s.push(e1.getInt32() >>> 0);
                                    const o = {
                                        ttcTag: t,
                                        majorVersion: a,
                                        minorVersion: n,
                                        numFonts: i,
                                        offsetTable: s
                                    };
                                    switch(a){
                                        case 1:
                                            return o;
                                        case 2:
                                            o.dsigTag = e1.getInt32() >>> 0;
                                            o.dsigLength = e1.getInt32() >>> 0;
                                            o.dsigOffset = e1.getInt32() >>> 0;
                                            return o;
                                    }
                                    throw new r.FormatError(`Invalid TrueType Collection majorVersion: ${a}.`);
                                }(e1), i = t.split("+");
                                let s;
                                for(let o = 0; o < a; o++){
                                    e1.pos = (e1.start || 0) + n[o];
                                    const a = readOpenTypeHeader(e1), c = readTables(e1, a.numTables);
                                    if (!c.name) throw new r.FormatError('TrueType Collection font must contain a "name" table.');
                                    const [l] = readNameTable(c.name);
                                    for(let e1 = 0, r = l.length; e1 < r; e1++)for(let r = 0, n = l[e1].length; r < n; r++){
                                        const n = l[e1][r]?.replaceAll(/\s/g, "");
                                        if (n) {
                                            if (n === t) return {
                                                header: a,
                                                tables: c
                                            };
                                            if (!(i.length < 2)) for (const e1 of i)n === e1 && (s = {
                                                name: e1,
                                                header: a,
                                                tables: c
                                            });
                                        }
                                    }
                                }
                                if (s) {
                                    (0, r.warn)(`TrueType Collection does not contain "${t}" font, falling back to "${s.name}" font instead.`);
                                    return {
                                        header: s.header,
                                        tables: s.tables
                                    };
                                }
                                throw new r.FormatError(`TrueType Collection does not contain "${t}" font.`);
                            }(t, this.name);
                            d = e1.header;
                            f = e1.tables;
                        } else {
                            d = readOpenTypeHeader(t);
                            f = readTables(t, d.numTables);
                        }
                        const S = !f["CFF "];
                        if (S) {
                            if (!f.loca) throw new r.FormatError('Required "loca" table is not found');
                            if (!f.glyf) {
                                (0, r.warn)('Required "glyf" table is not found -- trying to recover.');
                                f.glyf = {
                                    tag: "glyf",
                                    data: new Uint8Array(0)
                                };
                            }
                            this.isOpenType = !1;
                        } else {
                            const t = a.composite && (a.cidToGidMap?.length > 0 || !(a.cMap instanceof p.IdentityCMap));
                            if ("OTTO" === d.version && !t || !f.head || !f.hhea || !f.maxp || !f.post) {
                                w = new y.Stream(f["CFF "].data);
                                b = new u.CFFFont(w, a);
                                adjustWidths(a);
                                return this.convert(e1, b, a);
                            }
                            delete f.glyf;
                            delete f.loca;
                            delete f.fpgm;
                            delete f.prep;
                            delete f["cvt "];
                            this.isOpenType = !0;
                        }
                        if (!f.maxp) throw new r.FormatError('Required "maxp" table is not found');
                        t.pos = (t.start || 0) + f.maxp.offset;
                        const x = t.getInt32(), C = t.getUint16();
                        if (a.scaleFactors?.length === C && S) {
                            const { scaleFactors: e1 } = a, t = int16(f.head.data[50], f.head.data[51]), r = new g.GlyfTable({
                                glyfTable: f.glyf.data,
                                isGlyphLocationsLong: t,
                                locaTable: f.loca.data,
                                numGlyphs: C
                            });
                            r.scale(e1);
                            const { glyf: n, loca: i, isLocationLong: s } = r.write();
                            f.glyf.data = n;
                            f.loca.data = i;
                            if (s !== !!t) {
                                f.head.data[50] = 0;
                                f.head.data[51] = s ? 1 : 0;
                            }
                            const o = f.hmtx.data;
                            for(let t = 0; t < C; t++){
                                const a = 4 * t, r = Math.round(e1[t] * int16(o[a], o[a + 1]));
                                o[a] = r >> 8 & 255;
                                o[a + 1] = 255 & r;
                                writeSignedInt16(o, a + 2, Math.round(e1[t] * signedInt16(o[a + 2], o[a + 3])));
                            }
                        }
                        let k = C + 1, v = !0;
                        if (k > 65535) {
                            v = !1;
                            k = C;
                            (0, r.warn)("Not enough space in glyfs to duplicate first glyph.");
                        }
                        let F = 0, O = 0;
                        if (x >= 65536 && f.maxp.length >= 22) {
                            t.pos += 8;
                            if (t.getUint16() > 2) {
                                f.maxp.data[14] = 0;
                                f.maxp.data[15] = 2;
                            }
                            t.pos += 4;
                            F = t.getUint16();
                            t.pos += 4;
                            O = t.getUint16();
                        }
                        f.maxp.data[4] = k >> 8;
                        f.maxp.data[5] = 255 & k;
                        const T = function sanitizeTTPrograms(e1, t, a, n) {
                            const i = {
                                functionsDefined: [],
                                functionsUsed: [],
                                functionsStackDeltas: [],
                                tooComplexToFollowFunctions: !1,
                                hintsValid: !0
                            };
                            e1 && sanitizeTTProgram(e1, i);
                            t && sanitizeTTProgram(t, i);
                            e1 && function checkInvalidFunctions(e1, t) {
                                if (!e1.tooComplexToFollowFunctions) {
                                    if (e1.functionsDefined.length > t) {
                                        (0, r.warn)("TT: more functions defined than expected");
                                        e1.hintsValid = !1;
                                    } else for(let a = 0, n = e1.functionsUsed.length; a < n; a++){
                                        if (a > t) {
                                            (0, r.warn)("TT: invalid function id: " + a);
                                            e1.hintsValid = !1;
                                            return;
                                        }
                                        if (e1.functionsUsed[a] && !e1.functionsDefined[a]) {
                                            (0, r.warn)("TT: undefined function: " + a);
                                            e1.hintsValid = !1;
                                            return;
                                        }
                                    }
                                }
                            }(i, n);
                            if (a && 1 & a.length) {
                                const e1 = new Uint8Array(a.length + 1);
                                e1.set(a.data);
                                a.data = e1;
                            }
                            return i.hintsValid;
                        }(f.fpgm, f.prep, f["cvt "], F);
                        if (!T) {
                            delete f.fpgm;
                            delete f.prep;
                            delete f["cvt "];
                        }
                        !function sanitizeMetrics(e1, t, a, n, i, s) {
                            if (!t) {
                                a && (a.data = null);
                                return;
                            }
                            e1.pos = (e1.start || 0) + t.offset;
                            e1.pos += 4;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            e1.pos += 2;
                            const o = e1.getUint16();
                            e1.pos += 8;
                            e1.pos += 2;
                            let c = e1.getUint16();
                            if (0 !== o) {
                                if (!(2 & int16(n.data[44], n.data[45]))) {
                                    t.data[22] = 0;
                                    t.data[23] = 0;
                                }
                            }
                            if (c > i) {
                                (0, r.info)(`The numOfMetrics (${c}) should not be greater than the numGlyphs (${i}).`);
                                c = i;
                                t.data[34] = (65280 & c) >> 8;
                                t.data[35] = 255 & c;
                            }
                            const l = i - c - (a.length - 4 * c >> 1);
                            if (l > 0) {
                                const e1 = new Uint8Array(a.length + 2 * l);
                                e1.set(a.data);
                                if (s) {
                                    e1[a.length] = a.data[2];
                                    e1[a.length + 1] = a.data[3];
                                }
                                a.data = e1;
                            }
                        }(t, f.hhea, f.hmtx, f.head, k, v);
                        if (!f.head) throw new r.FormatError('Required "head" table is not found');
                        !function sanitizeHead(e1, t, a) {
                            const n = e1.data, i = function int32(e1, t, a, r) {
                                return (e1 << 24) + (t << 16) + (a << 8) + r;
                            }(n[0], n[1], n[2], n[3]);
                            if (i >> 16 != 1) {
                                (0, r.info)("Attempting to fix invalid version in head table: " + i);
                                n[0] = 0;
                                n[1] = 1;
                                n[2] = 0;
                                n[3] = 0;
                            }
                            const s = int16(n[50], n[51]);
                            if (s < 0 || s > 1) {
                                (0, r.info)("Attempting to fix invalid indexToLocFormat in head table: " + s);
                                const e1 = t + 1;
                                if (a === e1 << 1) {
                                    n[50] = 0;
                                    n[51] = 0;
                                } else {
                                    if (a !== e1 << 2) throw new r.FormatError("Could not fix indexToLocFormat: " + s);
                                    n[50] = 0;
                                    n[51] = 1;
                                }
                            }
                        }(f.head, C, S ? f.loca.length : 0);
                        let M = Object.create(null);
                        if (S) {
                            const e1 = int16(f.head.data[50], f.head.data[51]), t = function sanitizeGlyphLocations(e1, t, a, r, n, i, s) {
                                let o, c, l;
                                if (r) {
                                    o = 4;
                                    c = function fontItemDecodeLong(e1, t) {
                                        return e1[t] << 24 | e1[t + 1] << 16 | e1[t + 2] << 8 | e1[t + 3];
                                    };
                                    l = function fontItemEncodeLong(e1, t, a) {
                                        e1[t] = a >>> 24 & 255;
                                        e1[t + 1] = a >> 16 & 255;
                                        e1[t + 2] = a >> 8 & 255;
                                        e1[t + 3] = 255 & a;
                                    };
                                } else {
                                    o = 2;
                                    c = function fontItemDecode(e1, t) {
                                        return e1[t] << 9 | e1[t + 1] << 1;
                                    };
                                    l = function fontItemEncode(e1, t, a) {
                                        e1[t] = a >> 9 & 255;
                                        e1[t + 1] = a >> 1 & 255;
                                    };
                                }
                                const h = i ? a + 1 : a, u = o * (1 + h), d = new Uint8Array(u);
                                d.set(e1.data.subarray(0, u));
                                e1.data = d;
                                const f = t.data, g = f.length, p = new Uint8Array(g);
                                let m, b;
                                const y = [];
                                for(m = 0, b = 0; m < a + 1; m++, b += o){
                                    let e1 = c(d, b);
                                    e1 > g && (e1 = g);
                                    y.push({
                                        index: m,
                                        offset: e1,
                                        endOffset: 0
                                    });
                                }
                                y.sort((e1, t)=>e1.offset - t.offset);
                                for(m = 0; m < a; m++)y[m].endOffset = y[m + 1].offset;
                                y.sort((e1, t)=>e1.index - t.index);
                                for(m = 0; m < a; m++){
                                    const { offset: e1, endOffset: t } = y[m];
                                    if (0 !== e1 || 0 !== t) break;
                                    const a = y[m + 1].offset;
                                    if (0 !== a) {
                                        y[m].endOffset = a;
                                        break;
                                    }
                                }
                                const w = Object.create(null);
                                let S = 0;
                                l(d, 0, S);
                                for(m = 0, b = o; m < a; m++, b += o){
                                    const e1 = sanitizeGlyph(f, y[m].offset, y[m].endOffset, p, S, n), t = e1.length;
                                    0 === t && (w[m] = !0);
                                    e1.sizeOfInstructions > s && (s = e1.sizeOfInstructions);
                                    S += t;
                                    l(d, b, S);
                                }
                                if (0 === S) {
                                    const e1 = new Uint8Array([
                                        0,
                                        1,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        49,
                                        0
                                    ]);
                                    for(m = 0, b = o; m < h; m++, b += o)l(d, b, e1.length);
                                    t.data = e1;
                                } else if (i) {
                                    const a = c(d, o);
                                    if (p.length > a + S) t.data = p.subarray(0, a + S);
                                    else {
                                        t.data = new Uint8Array(a + S);
                                        t.data.set(p.subarray(0, S));
                                    }
                                    t.data.set(p.subarray(0, a), S);
                                    l(e1.data, d.length - o, S + a);
                                } else t.data = p.subarray(0, S);
                                return {
                                    missingGlyphs: w,
                                    maxSizeOfInstructions: s
                                };
                            }(f.loca, f.glyf, C, e1, T, v, O);
                            M = t.missingGlyphs;
                            if (x >= 65536 && f.maxp.length >= 22) {
                                f.maxp.data[26] = t.maxSizeOfInstructions >> 8;
                                f.maxp.data[27] = 255 & t.maxSizeOfInstructions;
                            }
                        }
                        if (!f.hhea) throw new r.FormatError('Required "hhea" table is not found');
                        if (0 === f.hhea.data[10] && 0 === f.hhea.data[11]) {
                            f.hhea.data[10] = 255;
                            f.hhea.data[11] = 255;
                        }
                        const D = {
                            unitsPerEm: int16(f.head.data[18], f.head.data[19]),
                            yMax: signedInt16(f.head.data[42], f.head.data[43]),
                            yMin: signedInt16(f.head.data[38], f.head.data[39]),
                            ascent: signedInt16(f.hhea.data[4], f.hhea.data[5]),
                            descent: signedInt16(f.hhea.data[6], f.hhea.data[7]),
                            lineGap: signedInt16(f.hhea.data[8], f.hhea.data[9])
                        };
                        this.ascent = D.ascent / D.unitsPerEm;
                        this.descent = D.descent / D.unitsPerEm;
                        this.lineGap = D.lineGap / D.unitsPerEm;
                        if (this.cssFontInfo?.lineHeight) {
                            this.lineHeight = this.cssFontInfo.metrics.lineHeight;
                            this.lineGap = this.cssFontInfo.metrics.lineGap;
                        } else this.lineHeight = this.ascent - this.descent + this.lineGap;
                        f.post && function readPostScriptTable(e1, a, n) {
                            const s = (t.start || 0) + e1.offset;
                            t.pos = s;
                            const o = s + e1.length, c = t.getInt32();
                            t.skip(28);
                            let l, h, u = !0;
                            switch(c){
                                case 65536:
                                    l = i.MacStandardGlyphOrdering;
                                    break;
                                case 131072:
                                    const e2 = t.getUint16();
                                    if (e2 !== n) {
                                        u = !1;
                                        break;
                                    }
                                    const s1 = [];
                                    for(h = 0; h < e2; ++h){
                                        const e1 = t.getUint16();
                                        if (e1 >= 32768) {
                                            u = !1;
                                            break;
                                        }
                                        s1.push(e1);
                                    }
                                    if (!u) break;
                                    const d = [], f = [];
                                    for(; t.pos < o;){
                                        const e1 = t.getByte();
                                        f.length = e1;
                                        for(h = 0; h < e1; ++h)f[h] = String.fromCharCode(t.getByte());
                                        d.push(f.join(""));
                                    }
                                    l = [];
                                    for(h = 0; h < e2; ++h){
                                        const e1 = s1[h];
                                        e1 < 258 ? l.push(i.MacStandardGlyphOrdering[e1]) : l.push(d[e1 - 258]);
                                    }
                                    break;
                                case 196608:
                                    break;
                                default:
                                    (0, r.warn)("Unknown/unsupported post table version " + c);
                                    u = !1;
                                    a.defaultEncoding && (l = a.defaultEncoding);
                            }
                            a.glyphNames = l;
                            return u;
                        }(f.post, a, C);
                        f.post = {
                            tag: "post",
                            data: createPostTable(a)
                        };
                        const E = [];
                        function hasGlyph(e1) {
                            return !M[e1];
                        }
                        if (a.composite) {
                            const e1 = a.cidToGidMap || [], t = 0 === e1.length;
                            a.cMap.forEach(function(a, n) {
                                "string" == typeof n && (n = convertCidString(a, n, !0));
                                if (n > 65535) throw new r.FormatError("Max size of CID is 65,535");
                                let i = -1;
                                t ? i = n : void 0 !== e1[n] && (i = e1[n]);
                                i >= 0 && i < C && hasGlyph(i) && (E[a] = i);
                            });
                        } else {
                            const e1 = function readCmapTable(e1, t, a, n) {
                                if (!e1) {
                                    (0, r.warn)("No cmap table available.");
                                    return {
                                        platformId: -1,
                                        encodingId: -1,
                                        mappings: [],
                                        hasShortCmap: !1
                                    };
                                }
                                let i, s = (t.start || 0) + e1.offset;
                                t.pos = s;
                                t.skip(2);
                                const o = t.getUint16();
                                let c, l = !1;
                                for(let e1 = 0; e1 < o; e1++){
                                    const r = t.getUint16(), i = t.getUint16(), s = t.getInt32() >>> 0;
                                    let h = !1;
                                    if (c?.platformId !== r || c?.encodingId !== i) {
                                        if (0 !== r || 0 !== i && 1 !== i && 3 !== i) {
                                            if (1 === r && 0 === i) h = !0;
                                            else if (3 !== r || 1 !== i || !n && c) {
                                                if (a && 3 === r && 0 === i) {
                                                    h = !0;
                                                    let a = !0;
                                                    if (e1 < o - 1) {
                                                        const e1 = t.peekBytes(2);
                                                        int16(e1[0], e1[1]) < r && (a = !1);
                                                    }
                                                    a && (l = !0);
                                                }
                                            } else {
                                                h = !0;
                                                a || (l = !0);
                                            }
                                        } else h = !0;
                                        h && (c = {
                                            platformId: r,
                                            encodingId: i,
                                            offset: s
                                        });
                                        if (l) break;
                                    }
                                }
                                c && (t.pos = s + c.offset);
                                if (!c || -1 === t.peekByte()) {
                                    (0, r.warn)("Could not find a preferred cmap table.");
                                    return {
                                        platformId: -1,
                                        encodingId: -1,
                                        mappings: [],
                                        hasShortCmap: !1
                                    };
                                }
                                const h = t.getUint16();
                                let u = !1;
                                const d = [];
                                let f, g;
                                if (0 === h) {
                                    t.skip(4);
                                    for(f = 0; f < 256; f++){
                                        const e1 = t.getByte();
                                        e1 && d.push({
                                            charCode: f,
                                            glyphId: e1
                                        });
                                    }
                                    u = !0;
                                } else if (2 === h) {
                                    t.skip(4);
                                    const e1 = [];
                                    let a = 0;
                                    for(let r = 0; r < 256; r++){
                                        const r = t.getUint16() >> 3;
                                        e1.push(r);
                                        a = Math.max(r, a);
                                    }
                                    const r = [];
                                    for(let e1 = 0; e1 <= a; e1++)r.push({
                                        firstCode: t.getUint16(),
                                        entryCount: t.getUint16(),
                                        idDelta: signedInt16(t.getByte(), t.getByte()),
                                        idRangePos: t.pos + t.getUint16()
                                    });
                                    for(let a = 0; a < 256; a++)if (0 === e1[a]) {
                                        t.pos = r[0].idRangePos + 2 * a;
                                        g = t.getUint16();
                                        d.push({
                                            charCode: a,
                                            glyphId: g
                                        });
                                    } else {
                                        const n = r[e1[a]];
                                        for(f = 0; f < n.entryCount; f++){
                                            const e1 = (a << 8) + f + n.firstCode;
                                            t.pos = n.idRangePos + 2 * f;
                                            g = t.getUint16();
                                            0 !== g && (g = (g + n.idDelta) % 65536);
                                            d.push({
                                                charCode: e1,
                                                glyphId: g
                                            });
                                        }
                                    }
                                } else if (4 === h) {
                                    t.skip(4);
                                    const e1 = t.getUint16() >> 1;
                                    t.skip(6);
                                    const a = [];
                                    let r;
                                    for(r = 0; r < e1; r++)a.push({
                                        end: t.getUint16()
                                    });
                                    t.skip(2);
                                    for(r = 0; r < e1; r++)a[r].start = t.getUint16();
                                    for(r = 0; r < e1; r++)a[r].delta = t.getUint16();
                                    let n, o = 0;
                                    for(r = 0; r < e1; r++){
                                        i = a[r];
                                        const s = t.getUint16();
                                        if (s) {
                                            n = (s >> 1) - (e1 - r);
                                            i.offsetIndex = n;
                                            o = Math.max(o, n + i.end - i.start + 1);
                                        } else i.offsetIndex = -1;
                                    }
                                    const c = [];
                                    for(f = 0; f < o; f++)c.push(t.getUint16());
                                    for(r = 0; r < e1; r++){
                                        i = a[r];
                                        s = i.start;
                                        const e1 = i.end, t = i.delta;
                                        n = i.offsetIndex;
                                        for(f = s; f <= e1; f++)if (65535 !== f) {
                                            g = n < 0 ? f : c[n + f - s];
                                            g = g + t & 65535;
                                            d.push({
                                                charCode: f,
                                                glyphId: g
                                            });
                                        }
                                    }
                                } else if (6 === h) {
                                    t.skip(4);
                                    const e1 = t.getUint16(), a = t.getUint16();
                                    for(f = 0; f < a; f++){
                                        g = t.getUint16();
                                        const a = e1 + f;
                                        d.push({
                                            charCode: a,
                                            glyphId: g
                                        });
                                    }
                                } else {
                                    if (12 !== h) {
                                        (0, r.warn)("cmap table has unsupported format: " + h);
                                        return {
                                            platformId: -1,
                                            encodingId: -1,
                                            mappings: [],
                                            hasShortCmap: !1
                                        };
                                    }
                                    {
                                        t.skip(10);
                                        const e1 = t.getInt32() >>> 0;
                                        for(f = 0; f < e1; f++){
                                            const e1 = t.getInt32() >>> 0, a = t.getInt32() >>> 0;
                                            let r = t.getInt32() >>> 0;
                                            for(let t = e1; t <= a; t++)d.push({
                                                charCode: t,
                                                glyphId: r++
                                            });
                                        }
                                    }
                                }
                                d.sort(function(e1, t) {
                                    return e1.charCode - t.charCode;
                                });
                                for(let e1 = 1; e1 < d.length; e1++)if (d[e1 - 1].charCode === d[e1].charCode) {
                                    d.splice(e1, 1);
                                    e1--;
                                }
                                return {
                                    platformId: c.platformId,
                                    encodingId: c.encodingId,
                                    mappings: d,
                                    hasShortCmap: u
                                };
                            }(f.cmap, t, this.isSymbolicFont, a.hasEncoding), n = e1.platformId, s = e1.encodingId, l = e1.mappings;
                            let u = [], d = !1;
                            !a.hasEncoding || "MacRomanEncoding" !== a.baseEncodingName && "WinAnsiEncoding" !== a.baseEncodingName || (u = (0, c.getEncoding)(a.baseEncodingName));
                            if (a.hasEncoding && !this.isSymbolicFont && (3 === n && 1 === s || 1 === n && 0 === s)) {
                                const e1 = (0, o.getGlyphsUnicode)();
                                for(let t = 0; t < 256; t++){
                                    let r;
                                    r = void 0 !== this.differences[t] ? this.differences[t] : u.length && "" !== u[t] ? u[t] : c.StandardEncoding[t];
                                    if (!r) continue;
                                    const o = (0, i.recoverGlyphName)(r, e1);
                                    let d;
                                    3 === n && 1 === s ? d = e1[o] : 1 === n && 0 === s && (d = c.MacRomanEncoding.indexOf(o));
                                    if (void 0 === d) {
                                        if (!a.glyphNames && a.hasIncludedToUnicodeMap && !(this.toUnicode instanceof h.IdentityToUnicodeMap)) {
                                            const e1 = this.toUnicode.get(t);
                                            e1 && (d = e1.codePointAt(0));
                                        }
                                        if (void 0 === d) continue;
                                    }
                                    for (const e1 of l)if (e1.charCode === d) {
                                        E[t] = e1.glyphId;
                                        break;
                                    }
                                }
                            } else if (0 === n) {
                                for (const e1 of l)E[e1.charCode] = e1.glyphId;
                                d = !0;
                            } else for (const e1 of l){
                                let t = e1.charCode;
                                3 === n && t >= 61440 && t <= 61695 && (t &= 255);
                                E[t] = e1.glyphId;
                            }
                            if (a.glyphNames && (u.length || this.differences.length)) for(let e1 = 0; e1 < 256; ++e1){
                                if (!d && void 0 !== E[e1]) continue;
                                const t = this.differences[e1] || u[e1];
                                if (!t) continue;
                                const r = a.glyphNames.indexOf(t);
                                r > 0 && hasGlyph(r) && (E[e1] = r);
                            }
                        }
                        0 === E.length && (E[0] = 0);
                        let N = k - 1;
                        v || (N = 0);
                        if (!a.cssFontInfo) {
                            const e1 = adjustMapping(E, hasGlyph, N, this.toUnicode);
                            this.toFontChar = e1.toFontChar;
                            f.cmap = {
                                tag: "cmap",
                                data: createCmapTable(e1.charCodeToGlyphId, e1.toUnicodeExtraMap, k)
                            };
                            f["OS/2"] && function validateOS2Table(e1, t) {
                                t.pos = (t.start || 0) + e1.offset;
                                const a = t.getUint16();
                                t.skip(60);
                                const r = t.getUint16();
                                if (a < 4 && 768 & r) return !1;
                                if (t.getUint16() > t.getUint16()) return !1;
                                t.skip(6);
                                if (0 === t.getUint16()) return !1;
                                e1.data[8] = e1.data[9] = 0;
                                return !0;
                            }(f["OS/2"], t) || (f["OS/2"] = {
                                tag: "OS/2",
                                data: createOS2Table(a, e1.charCodeToGlyphId, D)
                            });
                        }
                        if (!S) try {
                            w = new y.Stream(f["CFF "].data);
                            b = new n.CFFParser(w, a, i.SEAC_ANALYSIS_ENABLED).parse();
                            b.duplicateFirstGlyph();
                            const e1 = new n.CFFCompiler(b);
                            f["CFF "].data = e1.compile();
                        } catch  {
                            (0, r.warn)("Failed to compile font " + a.loadedName);
                        }
                        if (f.name) {
                            const [t, r] = readNameTable(f.name);
                            f.name.data = createNameTable(e1, t);
                            this.psName = t[0][6] || null;
                            a.composite || function adjustTrueTypeToUnicode(e1, t, a) {
                                if (e1.isInternalFont) return;
                                if (e1.hasIncludedToUnicodeMap) return;
                                if (e1.hasEncoding) return;
                                if (e1.toUnicode instanceof h.IdentityToUnicodeMap) return;
                                if (!t) return;
                                if (0 === a.length) return;
                                if (e1.defaultEncoding === c.WinAnsiEncoding) return;
                                for (const e1 of a)if (!isWinNameRecord(e1)) return;
                                const r = c.WinAnsiEncoding, n = [], i = (0, o.getGlyphsUnicode)();
                                for(const e1 in r){
                                    const t = r[e1];
                                    if ("" === t) continue;
                                    const a = i[t];
                                    void 0 !== a && (n[e1] = String.fromCharCode(a));
                                }
                                n.length > 0 && e1.toUnicode.amend(n);
                            }(a, this.isSymbolicFont, r);
                        } else f.name = {
                            tag: "name",
                            data: createNameTable(this.name)
                        };
                        const R = new m.OpenTypeFileBuilder(d.version);
                        for(const e1 in f)R.addTable(e1, f[e1].data);
                        return R.toArray();
                    }
                    convert(e1, t, a) {
                        a.fixedPitch = !1;
                        a.builtInEncoding && function adjustType1ToUnicode(e1, t) {
                            if (e1.isInternalFont) return;
                            if (e1.hasIncludedToUnicodeMap) return;
                            if (t === e1.defaultEncoding) return;
                            if (e1.toUnicode instanceof h.IdentityToUnicodeMap) return;
                            const a = [], r = (0, o.getGlyphsUnicode)();
                            for(const n in t){
                                if (e1.hasEncoding && (e1.baseEncodingName || void 0 !== e1.differences[n])) continue;
                                const i = t[n], o = (0, s.getUnicodeForGlyph)(i, r);
                                -1 !== o && (a[n] = String.fromCharCode(o));
                            }
                            a.length > 0 && e1.toUnicode.amend(a);
                        }(a, a.builtInEncoding);
                        let n = 1;
                        t instanceof u.CFFFont && (n = t.numGlyphs - 1);
                        const l = t.getGlyphMapping(a);
                        let d = null, f = l, g = null;
                        if (!a.cssFontInfo) {
                            d = adjustMapping(l, t.hasGlyphId.bind(t), n, this.toUnicode);
                            this.toFontChar = d.toFontChar;
                            f = d.charCodeToGlyphId;
                            g = d.toUnicodeExtraMap;
                        }
                        const p = t.numGlyphs;
                        function getCharCodes(e1, t) {
                            let a = null;
                            for(const r in e1)t === e1[r] && (a ||= []).push(0 | r);
                            return a;
                        }
                        function createCharCode(e1, t) {
                            for(const a in e1)if (t === e1[a]) return 0 | a;
                            d.charCodeToGlyphId[d.nextAvailableFontCharCode] = t;
                            return d.nextAvailableFontCharCode++;
                        }
                        const b = t.seacs;
                        if (d && i.SEAC_ANALYSIS_ENABLED && b?.length) {
                            const e1 = a.fontMatrix || r.FONT_IDENTITY_MATRIX, n = t.getCharset(), i = Object.create(null);
                            for(let t in b){
                                t |= 0;
                                const a = b[t], r = c.StandardEncoding[a[2]], s = c.StandardEncoding[a[3]], o = n.indexOf(r), h = n.indexOf(s);
                                if (o < 0 || h < 0) continue;
                                const u = {
                                    x: a[0] * e1[0] + a[1] * e1[2] + e1[4],
                                    y: a[0] * e1[1] + a[1] * e1[3] + e1[5]
                                }, f = getCharCodes(l, t);
                                if (f) for (const e1 of f){
                                    const t = d.charCodeToGlyphId, a = createCharCode(t, o), r = createCharCode(t, h);
                                    i[e1] = {
                                        baseFontCharCode: a,
                                        accentFontCharCode: r,
                                        accentOffset: u
                                    };
                                }
                            }
                            a.seacMap = i;
                        }
                        const y = 1 / (a.fontMatrix || r.FONT_IDENTITY_MATRIX)[0], w = new m.OpenTypeFileBuilder("OTTO");
                        w.addTable("CFF ", t.data);
                        w.addTable("OS/2", createOS2Table(a, f));
                        w.addTable("cmap", createCmapTable(f, g, p));
                        w.addTable("head", "\0\x01\0\0\0\0\x10\0\0\0\0\0_\x0f<\xf5\0\0" + safeString16(y) + "\0\0\0\0\x9e\v~'\0\0\0\0\x9e\v~'\0\0" + safeString16(a.descent) + "\x0f\xff" + safeString16(a.ascent) + string16(a.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0");
                        w.addTable("hhea", "\0\0\0" + safeString16(a.ascent) + safeString16(a.descent) + "\0\0\xff\xff\0\0\0\0\0\0" + safeString16(a.capHeight) + safeString16(Math.tan(a.italicAngle) * a.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + string16(p));
                        w.addTable("hmtx", function fontFieldsHmtx() {
                            const e1 = t.charstrings, a = t.cff ? t.cff.widths : null;
                            let r = "\0\0\0\0";
                            for(let t = 1, n = p; t < n; t++){
                                let n = 0;
                                if (e1) {
                                    const a = e1[t - 1];
                                    n = "width" in a ? a.width : 0;
                                } else a && (n = Math.ceil(a[t] || 0));
                                r += string16(n) + string16(0);
                            }
                            return r;
                        }());
                        w.addTable("maxp", "\0\0P\0" + string16(p));
                        w.addTable("name", createNameTable(e1));
                        w.addTable("post", createPostTable(a));
                        return w.toArray();
                    }
                    get spaceWidth() {
                        const e1 = [
                            "space",
                            "minus",
                            "one",
                            "i",
                            "I"
                        ];
                        let t;
                        for (const a of e1){
                            if (a in this.widths) {
                                t = this.widths[a];
                                break;
                            }
                            const e1 = (0, o.getGlyphsUnicode)()[a];
                            let r = 0;
                            if (this.composite && this.cMap.contains(e1)) {
                                r = this.cMap.lookup(e1);
                                "string" == typeof r && (r = convertCidString(e1, r));
                            }
                            !r && this.toUnicode && (r = this.toUnicode.charCodeOf(e1));
                            r <= 0 && (r = e1);
                            t = this.widths[r];
                            if (t) break;
                        }
                        return (0, r.shadow)(this, "spaceWidth", t || this.defaultWidth);
                    }
                    _charToGlyph(e1, t = !1) {
                        let a, n, i, o = this._glyphCache[e1];
                        if (o?.isSpace === t) return o;
                        let c = e1;
                        if (this.cMap?.contains(e1)) {
                            c = this.cMap.lookup(e1);
                            "string" == typeof c && (c = convertCidString(e1, c));
                        }
                        n = this.widths[c];
                        "number" != typeof n && (n = this.defaultWidth);
                        const l = this.vmetrics?.[c];
                        let h = this.toUnicode.get(e1) || e1;
                        "number" == typeof h && (h = String.fromCharCode(h));
                        let u = void 0 !== this.toFontChar[e1];
                        a = this.toFontChar[e1] || e1;
                        if (this.missingFile) {
                            const t = this.differences[e1] || this.defaultEncoding[e1];
                            ".notdef" !== t && "" !== t || "Type1" !== this.type || (a = 32);
                            a = (0, s.mapSpecialUnicodeValues)(a);
                        }
                        this.isType3Font && (i = a);
                        let d = null;
                        if (this.seacMap?.[e1]) {
                            u = !0;
                            const t = this.seacMap[e1];
                            a = t.baseFontCharCode;
                            d = {
                                fontChar: String.fromCodePoint(t.accentFontCharCode),
                                offset: t.accentOffset
                            };
                        }
                        let f = "";
                        "number" == typeof a && (a <= 1114111 ? f = String.fromCodePoint(a) : (0, r.warn)(`charToGlyph - invalid fontCharCode: ${a}`));
                        o = new Glyph(e1, f, h, d, n, l, i, t, u);
                        return this._glyphCache[e1] = o;
                    }
                    charsToGlyphs(e1) {
                        let t = this._charsCache[e1];
                        if (t) return t;
                        t = [];
                        if (this.cMap) {
                            const a = Object.create(null), r = e1.length;
                            let n = 0;
                            for(; n < r;){
                                this.cMap.readCharCode(e1, n, a);
                                const { charcode: r, length: i } = a;
                                n += i;
                                const s = this._charToGlyph(r, 1 === i && 32 === e1.charCodeAt(n - 1));
                                t.push(s);
                            }
                        } else for(let a = 0, r = e1.length; a < r; ++a){
                            const r = e1.charCodeAt(a), n = this._charToGlyph(r, 32 === r);
                            t.push(n);
                        }
                        return this._charsCache[e1] = t;
                    }
                    getCharPositions(e1) {
                        const t = [];
                        if (this.cMap) {
                            const a = Object.create(null);
                            let r = 0;
                            for(; r < e1.length;){
                                this.cMap.readCharCode(e1, r, a);
                                const n = a.length;
                                t.push([
                                    r,
                                    r + n
                                ]);
                                r += n;
                            }
                        } else for(let a = 0, r = e1.length; a < r; ++a)t.push([
                            a,
                            a + 1
                        ]);
                        return t;
                    }
                    get glyphCacheValues() {
                        return Object.values(this._glyphCache);
                    }
                    encodeString(e1) {
                        const t = [], a = [], hasCurrentBufErrors = ()=>t.length % 2 == 1, r = this.toUnicode instanceof h.IdentityToUnicodeMap ? (e1)=>this.toUnicode.charCodeOf(e1) : (e1)=>this.toUnicode.charCodeOf(String.fromCodePoint(e1));
                        for(let n = 0, i = e1.length; n < i; n++){
                            const i = e1.codePointAt(n);
                            i > 55295 && (i < 57344 || i > 65533) && n++;
                            if (this.toUnicode) {
                                const e1 = r(i);
                                if (-1 !== e1) {
                                    if (hasCurrentBufErrors()) {
                                        t.push(a.join(""));
                                        a.length = 0;
                                    }
                                    for(let t = (this.cMap ? this.cMap.getCharCodeLength(e1) : 1) - 1; t >= 0; t--)a.push(String.fromCharCode(e1 >> 8 * t & 255));
                                    continue;
                                }
                            }
                            if (!hasCurrentBufErrors()) {
                                t.push(a.join(""));
                                a.length = 0;
                            }
                            a.push(String.fromCodePoint(i));
                        }
                        t.push(a.join(""));
                        return t;
                    }
                };
                t.ErrorFont = class ErrorFont {
                    constructor(e1){
                        this.error = e1;
                        this.loadedName = "g_font_error";
                        this.missingFile = !0;
                    }
                    charsToGlyphs() {
                        return [];
                    }
                    encodeString(e1) {
                        return [
                            e1
                        ];
                    }
                    exportData(e1 = !1) {
                        return {
                            error: this.error
                        };
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.CFFTopDict = t.CFFStrings = t.CFFStandardStrings = t.CFFPrivateDict = t.CFFParser = t.CFFIndex = t.CFFHeader = t.CFFFDSelect = t.CFFCompiler = t.CFFCharset = t.CFF = void 0;
                var r = a(2), n = a(36), i = a(37);
                const s = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                t.CFFStandardStrings = s;
                const o = 391, c = [
                    null,
                    {
                        id: "hstem",
                        min: 2,
                        stackClearing: !0,
                        stem: !0
                    },
                    null,
                    {
                        id: "vstem",
                        min: 2,
                        stackClearing: !0,
                        stem: !0
                    },
                    {
                        id: "vmoveto",
                        min: 1,
                        stackClearing: !0
                    },
                    {
                        id: "rlineto",
                        min: 2,
                        resetStack: !0
                    },
                    {
                        id: "hlineto",
                        min: 1,
                        resetStack: !0
                    },
                    {
                        id: "vlineto",
                        min: 1,
                        resetStack: !0
                    },
                    {
                        id: "rrcurveto",
                        min: 6,
                        resetStack: !0
                    },
                    null,
                    {
                        id: "callsubr",
                        min: 1,
                        undefStack: !0
                    },
                    {
                        id: "return",
                        min: 0,
                        undefStack: !0
                    },
                    null,
                    null,
                    {
                        id: "endchar",
                        min: 0,
                        stackClearing: !0
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hstemhm",
                        min: 2,
                        stackClearing: !0,
                        stem: !0
                    },
                    {
                        id: "hintmask",
                        min: 0,
                        stackClearing: !0
                    },
                    {
                        id: "cntrmask",
                        min: 0,
                        stackClearing: !0
                    },
                    {
                        id: "rmoveto",
                        min: 2,
                        stackClearing: !0
                    },
                    {
                        id: "hmoveto",
                        min: 1,
                        stackClearing: !0
                    },
                    {
                        id: "vstemhm",
                        min: 2,
                        stackClearing: !0,
                        stem: !0
                    },
                    {
                        id: "rcurveline",
                        min: 8,
                        resetStack: !0
                    },
                    {
                        id: "rlinecurve",
                        min: 8,
                        resetStack: !0
                    },
                    {
                        id: "vvcurveto",
                        min: 4,
                        resetStack: !0
                    },
                    {
                        id: "hhcurveto",
                        min: 4,
                        resetStack: !0
                    },
                    null,
                    {
                        id: "callgsubr",
                        min: 1,
                        undefStack: !0
                    },
                    {
                        id: "vhcurveto",
                        min: 4,
                        resetStack: !0
                    },
                    {
                        id: "hvcurveto",
                        min: 4,
                        resetStack: !0
                    }
                ], l = [
                    null,
                    null,
                    null,
                    {
                        id: "and",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "or",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "not",
                        min: 1,
                        stackDelta: 0
                    },
                    null,
                    null,
                    null,
                    {
                        id: "abs",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "add",
                        min: 2,
                        stackDelta: -1,
                        stackFn (e1, t) {
                            e1[t - 2] = e1[t - 2] + e1[t - 1];
                        }
                    },
                    {
                        id: "sub",
                        min: 2,
                        stackDelta: -1,
                        stackFn (e1, t) {
                            e1[t - 2] = e1[t - 2] - e1[t - 1];
                        }
                    },
                    {
                        id: "div",
                        min: 2,
                        stackDelta: -1,
                        stackFn (e1, t) {
                            e1[t - 2] = e1[t - 2] / e1[t - 1];
                        }
                    },
                    null,
                    {
                        id: "neg",
                        min: 1,
                        stackDelta: 0,
                        stackFn (e1, t) {
                            e1[t - 1] = -e1[t - 1];
                        }
                    },
                    {
                        id: "eq",
                        min: 2,
                        stackDelta: -1
                    },
                    null,
                    null,
                    {
                        id: "drop",
                        min: 1,
                        stackDelta: -1
                    },
                    null,
                    {
                        id: "put",
                        min: 2,
                        stackDelta: -2
                    },
                    {
                        id: "get",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "ifelse",
                        min: 4,
                        stackDelta: -3
                    },
                    {
                        id: "random",
                        min: 0,
                        stackDelta: 1
                    },
                    {
                        id: "mul",
                        min: 2,
                        stackDelta: -1,
                        stackFn (e1, t) {
                            e1[t - 2] = e1[t - 2] * e1[t - 1];
                        }
                    },
                    null,
                    {
                        id: "sqrt",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "dup",
                        min: 1,
                        stackDelta: 1
                    },
                    {
                        id: "exch",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "index",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "roll",
                        min: 3,
                        stackDelta: -2
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hflex",
                        min: 7,
                        resetStack: !0
                    },
                    {
                        id: "flex",
                        min: 13,
                        resetStack: !0
                    },
                    {
                        id: "hflex1",
                        min: 9,
                        resetStack: !0
                    },
                    {
                        id: "flex1",
                        min: 11,
                        resetStack: !0
                    }
                ];
                t.CFFParser = class CFFParser {
                    constructor(e1, t, a){
                        this.bytes = e1.getBytes();
                        this.properties = t;
                        this.seacAnalysisEnabled = !!a;
                    }
                    parse() {
                        const e1 = this.properties, t = new CFF;
                        this.cff = t;
                        const a = this.parseHeader(), r = this.parseIndex(a.endPos), n = this.parseIndex(r.endPos), i = this.parseIndex(n.endPos), s = this.parseIndex(i.endPos), o = this.parseDict(n.obj.get(0)), c = this.createDict(CFFTopDict, o, t.strings);
                        t.header = a.obj;
                        t.names = this.parseNameIndex(r.obj);
                        t.strings = this.parseStringIndex(i.obj);
                        t.topDict = c;
                        t.globalSubrIndex = s.obj;
                        this.parsePrivateDict(t.topDict);
                        t.isCIDFont = c.hasName("ROS");
                        const l = c.getByName("CharStrings"), h = this.parseIndex(l).obj, u = c.getByName("FontMatrix");
                        u && (e1.fontMatrix = u);
                        const d = c.getByName("FontBBox");
                        if (d) {
                            e1.ascent = Math.max(d[3], d[1]);
                            e1.descent = Math.min(d[1], d[3]);
                            e1.ascentScaled = !0;
                        }
                        let f, g;
                        if (t.isCIDFont) {
                            const e1 = this.parseIndex(c.getByName("FDArray")).obj;
                            for(let a = 0, r = e1.count; a < r; ++a){
                                const r = e1.get(a), n = this.createDict(CFFTopDict, this.parseDict(r), t.strings);
                                this.parsePrivateDict(n);
                                t.fdArray.push(n);
                            }
                            g = null;
                            f = this.parseCharsets(c.getByName("charset"), h.count, t.strings, !0);
                            t.fdSelect = this.parseFDSelect(c.getByName("FDSelect"), h.count);
                        } else {
                            f = this.parseCharsets(c.getByName("charset"), h.count, t.strings, !1);
                            g = this.parseEncoding(c.getByName("Encoding"), e1, t.strings, f.charset);
                        }
                        t.charset = f;
                        t.encoding = g;
                        const p = this.parseCharStrings({
                            charStrings: h,
                            localSubrIndex: c.privateDict.subrsIndex,
                            globalSubrIndex: s.obj,
                            fdSelect: t.fdSelect,
                            fdArray: t.fdArray,
                            privateDict: c.privateDict
                        });
                        t.charStrings = p.charStrings;
                        t.seacs = p.seacs;
                        t.widths = p.widths;
                        return t;
                    }
                    parseHeader() {
                        let e1 = this.bytes;
                        const t = e1.length;
                        let a = 0;
                        for(; a < t && 1 !== e1[a];)++a;
                        if (a >= t) throw new r.FormatError("Invalid CFF header");
                        if (0 !== a) {
                            (0, r.info)("cff data is shifted");
                            e1 = e1.subarray(a);
                            this.bytes = e1;
                        }
                        const n = e1[0], i = e1[1], s = e1[2], o = e1[3];
                        return {
                            obj: new CFFHeader(n, i, s, o),
                            endPos: s
                        };
                    }
                    parseDict(e1) {
                        let t = 0;
                        function parseOperand() {
                            let a = e1[t++];
                            if (30 === a) return function parseFloatOperand() {
                                let a = "";
                                const r = 15, n = [
                                    "0",
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                    "8",
                                    "9",
                                    ".",
                                    "E",
                                    "E-",
                                    null,
                                    "-"
                                ], i = e1.length;
                                for(; t < i;){
                                    const i = e1[t++], s = i >> 4, o = 15 & i;
                                    if (s === r) break;
                                    a += n[s];
                                    if (o === r) break;
                                    a += n[o];
                                }
                                return parseFloat(a);
                            }();
                            if (28 === a) {
                                a = e1[t++];
                                a = (a << 24 | e1[t++] << 16) >> 16;
                                return a;
                            }
                            if (29 === a) {
                                a = e1[t++];
                                a = a << 8 | e1[t++];
                                a = a << 8 | e1[t++];
                                a = a << 8 | e1[t++];
                                return a;
                            }
                            if (a >= 32 && a <= 246) return a - 139;
                            if (a >= 247 && a <= 250) return 256 * (a - 247) + e1[t++] + 108;
                            if (a >= 251 && a <= 254) return -256 * (a - 251) - e1[t++] - 108;
                            (0, r.warn)('CFFParser_parseDict: "' + a + '" is a reserved command.');
                            return NaN;
                        }
                        let a = [];
                        const n = [];
                        t = 0;
                        const i = e1.length;
                        for(; t < i;){
                            let r = e1[t];
                            if (r <= 21) {
                                12 === r && (r = r << 8 | e1[++t]);
                                n.push([
                                    r,
                                    a
                                ]);
                                a = [];
                                ++t;
                            } else a.push(parseOperand());
                        }
                        return n;
                    }
                    parseIndex(e1) {
                        const t = new CFFIndex, a = this.bytes, r = a[e1++] << 8 | a[e1++], n = [];
                        let i, s, o = e1;
                        if (0 !== r) {
                            const t = a[e1++], c = e1 + (r + 1) * t - 1;
                            for(i = 0, s = r + 1; i < s; ++i){
                                let r = 0;
                                for(let n = 0; n < t; ++n){
                                    r <<= 8;
                                    r += a[e1++];
                                }
                                n.push(c + r);
                            }
                            o = n[r];
                        }
                        for(i = 0, s = n.length - 1; i < s; ++i){
                            const e1 = n[i], r = n[i + 1];
                            t.add(a.subarray(e1, r));
                        }
                        return {
                            obj: t,
                            endPos: o
                        };
                    }
                    parseNameIndex(e1) {
                        const t = [];
                        for(let a = 0, n = e1.count; a < n; ++a){
                            const n = e1.get(a);
                            t.push((0, r.bytesToString)(n));
                        }
                        return t;
                    }
                    parseStringIndex(e1) {
                        const t = new CFFStrings;
                        for(let a = 0, n = e1.count; a < n; ++a){
                            const n = e1.get(a);
                            t.add((0, r.bytesToString)(n));
                        }
                        return t;
                    }
                    createDict(e1, t, a) {
                        const r = new e1(a);
                        for (const [e1, a] of t)r.setByKey(e1, a);
                        return r;
                    }
                    parseCharString(e1, t, a, n) {
                        if (!t || e1.callDepth > 10) return !1;
                        let i = e1.stackSize;
                        const s = e1.stack;
                        let o = t.length;
                        for(let h = 0; h < o;){
                            const u = t[h++];
                            let d = null;
                            if (12 === u) {
                                const e1 = t[h++];
                                if (0 === e1) {
                                    t[h - 2] = 139;
                                    t[h - 1] = 22;
                                    i = 0;
                                } else d = l[e1];
                            } else if (28 === u) {
                                s[i] = (t[h] << 24 | t[h + 1] << 16) >> 16;
                                h += 2;
                                i++;
                            } else if (14 === u) {
                                if (i >= 4) {
                                    i -= 4;
                                    if (this.seacAnalysisEnabled) {
                                        e1.seac = s.slice(i, i + 4);
                                        return !1;
                                    }
                                }
                                d = c[u];
                            } else if (u >= 32 && u <= 246) {
                                s[i] = u - 139;
                                i++;
                            } else if (u >= 247 && u <= 254) {
                                s[i] = u < 251 ? (u - 247 << 8) + t[h] + 108 : -(u - 251 << 8) - t[h] - 108;
                                h++;
                                i++;
                            } else if (255 === u) {
                                s[i] = (t[h] << 24 | t[h + 1] << 16 | t[h + 2] << 8 | t[h + 3]) / 65536;
                                h += 4;
                                i++;
                            } else if (19 === u || 20 === u) {
                                e1.hints += i >> 1;
                                if (0 === e1.hints) {
                                    t.copyWithin(h - 1, h, -1);
                                    h -= 1;
                                    o -= 1;
                                    continue;
                                }
                                h += e1.hints + 7 >> 3;
                                i %= 2;
                                d = c[u];
                            } else {
                                if (10 === u || 29 === u) {
                                    const t = 10 === u ? a : n;
                                    if (!t) {
                                        d = c[u];
                                        (0, r.warn)("Missing subrsIndex for " + d.id);
                                        return !1;
                                    }
                                    let o = 32768;
                                    t.count < 1240 ? o = 107 : t.count < 33900 && (o = 1131);
                                    const l = s[--i] + o;
                                    if (l < 0 || l >= t.count || isNaN(l)) {
                                        d = c[u];
                                        (0, r.warn)("Out of bounds subrIndex for " + d.id);
                                        return !1;
                                    }
                                    e1.stackSize = i;
                                    e1.callDepth++;
                                    if (!this.parseCharString(e1, t.get(l), a, n)) return !1;
                                    e1.callDepth--;
                                    i = e1.stackSize;
                                    continue;
                                }
                                if (11 === u) {
                                    e1.stackSize = i;
                                    return !0;
                                }
                                if (0 === u && h === t.length) {
                                    t[h - 1] = 14;
                                    d = c[14];
                                } else {
                                    if (9 === u) {
                                        t.copyWithin(h - 1, h, -1);
                                        h -= 1;
                                        o -= 1;
                                        continue;
                                    }
                                    d = c[u];
                                }
                            }
                            if (d) {
                                if (d.stem) {
                                    e1.hints += i >> 1;
                                    if (3 === u || 23 === u) e1.hasVStems = !0;
                                    else if (e1.hasVStems && (1 === u || 18 === u)) {
                                        (0, r.warn)("CFF stem hints are in wrong order");
                                        t[h - 1] = 1 === u ? 3 : 23;
                                    }
                                }
                                if ("min" in d && !e1.undefStack && i < d.min) {
                                    (0, r.warn)("Not enough parameters for " + d.id + "; actual: " + i + ", expected: " + d.min);
                                    if (0 === i) {
                                        t[h - 1] = 14;
                                        return !0;
                                    }
                                    return !1;
                                }
                                if (e1.firstStackClearing && d.stackClearing) {
                                    e1.firstStackClearing = !1;
                                    i -= d.min;
                                    i >= 2 && d.stem ? i %= 2 : i > 1 && (0, r.warn)("Found too many parameters for stack-clearing command");
                                    i > 0 && (e1.width = s[i - 1]);
                                }
                                if ("stackDelta" in d) {
                                    "stackFn" in d && d.stackFn(s, i);
                                    i += d.stackDelta;
                                } else if (d.stackClearing) i = 0;
                                else if (d.resetStack) {
                                    i = 0;
                                    e1.undefStack = !1;
                                } else if (d.undefStack) {
                                    i = 0;
                                    e1.undefStack = !0;
                                    e1.firstStackClearing = !1;
                                }
                            }
                        }
                        o < t.length && t.fill(14, o);
                        e1.stackSize = i;
                        return !0;
                    }
                    parseCharStrings({ charStrings: e1, localSubrIndex: t, globalSubrIndex: a, fdSelect: n, fdArray: i, privateDict: s }) {
                        const o = [], c = [], l = e1.count;
                        for(let h = 0; h < l; h++){
                            const l = e1.get(h), u = {
                                callDepth: 0,
                                stackSize: 0,
                                stack: [],
                                undefStack: !0,
                                hints: 0,
                                firstStackClearing: !0,
                                seac: null,
                                width: null,
                                hasVStems: !1
                            };
                            let d = !0, f = null, g = s;
                            if (n && i.length) {
                                const e1 = n.getFDIndex(h);
                                if (-1 === e1) {
                                    (0, r.warn)("Glyph index is not in fd select.");
                                    d = !1;
                                }
                                if (e1 >= i.length) {
                                    (0, r.warn)("Invalid fd index for glyph index.");
                                    d = !1;
                                }
                                if (d) {
                                    g = i[e1].privateDict;
                                    f = g.subrsIndex;
                                }
                            } else t && (f = t);
                            d && (d = this.parseCharString(u, l, f, a));
                            if (null !== u.width) {
                                const e1 = g.getByName("nominalWidthX");
                                c[h] = e1 + u.width;
                            } else {
                                const e1 = g.getByName("defaultWidthX");
                                c[h] = e1;
                            }
                            null !== u.seac && (o[h] = u.seac);
                            d || e1.set(h, new Uint8Array([
                                14
                            ]));
                        }
                        return {
                            charStrings: e1,
                            seacs: o,
                            widths: c
                        };
                    }
                    emptyPrivateDictionary(e1) {
                        const t = this.createDict(CFFPrivateDict, [], e1.strings);
                        e1.setByKey(18, [
                            0,
                            0
                        ]);
                        e1.privateDict = t;
                    }
                    parsePrivateDict(e1) {
                        if (!e1.hasName("Private")) {
                            this.emptyPrivateDictionary(e1);
                            return;
                        }
                        const t = e1.getByName("Private");
                        if (!Array.isArray(t) || 2 !== t.length) {
                            e1.removeByName("Private");
                            return;
                        }
                        const a = t[0], r = t[1];
                        if (0 === a || r >= this.bytes.length) {
                            this.emptyPrivateDictionary(e1);
                            return;
                        }
                        const n = r + a, i = this.bytes.subarray(r, n), s = this.parseDict(i), o = this.createDict(CFFPrivateDict, s, e1.strings);
                        e1.privateDict = o;
                        0 === o.getByName("ExpansionFactor") && o.setByName("ExpansionFactor", .06);
                        if (!o.getByName("Subrs")) return;
                        const c = o.getByName("Subrs"), l = r + c;
                        if (0 === c || l >= this.bytes.length) {
                            this.emptyPrivateDictionary(e1);
                            return;
                        }
                        const h = this.parseIndex(l);
                        o.subrsIndex = h.obj;
                    }
                    parseCharsets(e1, t, a, i) {
                        if (0 === e1) return new CFFCharset(!0, d.ISO_ADOBE, n.ISOAdobeCharset);
                        if (1 === e1) return new CFFCharset(!0, d.EXPERT, n.ExpertCharset);
                        if (2 === e1) return new CFFCharset(!0, d.EXPERT_SUBSET, n.ExpertSubsetCharset);
                        const s = this.bytes, o = e1, c = s[e1++], l = [
                            i ? 0 : ".notdef"
                        ];
                        let h, u, f;
                        t -= 1;
                        switch(c){
                            case 0:
                                for(f = 0; f < t; f++){
                                    h = s[e1++] << 8 | s[e1++];
                                    l.push(i ? h : a.get(h));
                                }
                                break;
                            case 1:
                                for(; l.length <= t;){
                                    h = s[e1++] << 8 | s[e1++];
                                    u = s[e1++];
                                    for(f = 0; f <= u; f++)l.push(i ? h++ : a.get(h++));
                                }
                                break;
                            case 2:
                                for(; l.length <= t;){
                                    h = s[e1++] << 8 | s[e1++];
                                    u = s[e1++] << 8 | s[e1++];
                                    for(f = 0; f <= u; f++)l.push(i ? h++ : a.get(h++));
                                }
                                break;
                            default:
                                throw new r.FormatError("Unknown charset format");
                        }
                        const g = e1, p = s.subarray(o, g);
                        return new CFFCharset(!1, c, l, p);
                    }
                    parseEncoding(e1, t, a, n) {
                        const s = Object.create(null), o = this.bytes;
                        let c, l, h, u = !1, d = null;
                        if (0 === e1 || 1 === e1) {
                            u = !0;
                            c = e1;
                            const t = e1 ? i.ExpertEncoding : i.StandardEncoding;
                            for(l = 0, h = n.length; l < h; l++){
                                const e1 = t.indexOf(n[l]);
                                -1 !== e1 && (s[e1] = l);
                            }
                        } else {
                            const t = e1;
                            c = o[e1++];
                            switch(127 & c){
                                case 0:
                                    const t1 = o[e1++];
                                    for(l = 1; l <= t1; l++)s[o[e1++]] = l;
                                    break;
                                case 1:
                                    const a1 = o[e1++];
                                    let n1 = 1;
                                    for(l = 0; l < a1; l++){
                                        const t = o[e1++], a = o[e1++];
                                        for(let e1 = t; e1 <= t + a; e1++)s[e1] = n1++;
                                    }
                                    break;
                                default:
                                    throw new r.FormatError(`Unknown encoding format: ${c} in CFF`);
                            }
                            const i = e1;
                            if (128 & c) {
                                o[t] &= 127;
                                !function readSupplement() {
                                    const t = o[e1++];
                                    for(l = 0; l < t; l++){
                                        const t = o[e1++], r = (o[e1++] << 8) + (255 & o[e1++]);
                                        s[t] = n.indexOf(a.get(r));
                                    }
                                }();
                            }
                            d = o.subarray(t, i);
                        }
                        c &= 127;
                        return new CFFEncoding(u, c, s, d);
                    }
                    parseFDSelect(e1, t) {
                        const a = this.bytes, n = a[e1++], i = [];
                        let s;
                        switch(n){
                            case 0:
                                for(s = 0; s < t; ++s){
                                    const t = a[e1++];
                                    i.push(t);
                                }
                                break;
                            case 3:
                                const o = a[e1++] << 8 | a[e1++];
                                for(s = 0; s < o; ++s){
                                    let t = a[e1++] << 8 | a[e1++];
                                    if (0 === s && 0 !== t) {
                                        (0, r.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
                                        t = 0;
                                    }
                                    const n = a[e1++], o = a[e1] << 8 | a[e1 + 1];
                                    for(let e1 = t; e1 < o; ++e1)i.push(n);
                                }
                                e1 += 2;
                                break;
                            default:
                                throw new r.FormatError(`parseFDSelect: Unknown format "${n}".`);
                        }
                        if (i.length !== t) throw new r.FormatError("parseFDSelect: Invalid font data.");
                        return new CFFFDSelect(n, i);
                    }
                };
                class CFF {
                    constructor(){
                        this.header = null;
                        this.names = [];
                        this.topDict = null;
                        this.strings = new CFFStrings;
                        this.globalSubrIndex = null;
                        this.encoding = null;
                        this.charset = null;
                        this.charStrings = null;
                        this.fdArray = [];
                        this.fdSelect = null;
                        this.isCIDFont = !1;
                    }
                    duplicateFirstGlyph() {
                        if (this.charStrings.count >= 65535) {
                            (0, r.warn)("Not enough space in charstrings to duplicate first glyph.");
                            return;
                        }
                        const e1 = this.charStrings.get(0);
                        this.charStrings.add(e1);
                        this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
                    }
                    hasGlyphId(e1) {
                        if (e1 < 0 || e1 >= this.charStrings.count) return !1;
                        return this.charStrings.get(e1).length > 0;
                    }
                }
                t.CFF = CFF;
                class CFFHeader {
                    constructor(e1, t, a, r){
                        this.major = e1;
                        this.minor = t;
                        this.hdrSize = a;
                        this.offSize = r;
                    }
                }
                t.CFFHeader = CFFHeader;
                class CFFStrings {
                    constructor(){
                        this.strings = [];
                    }
                    get(e1) {
                        return e1 >= 0 && e1 <= 390 ? s[e1] : e1 - o <= this.strings.length ? this.strings[e1 - o] : s[0];
                    }
                    getSID(e1) {
                        let t = s.indexOf(e1);
                        if (-1 !== t) return t;
                        t = this.strings.indexOf(e1);
                        return -1 !== t ? t + o : -1;
                    }
                    add(e1) {
                        this.strings.push(e1);
                    }
                    get count() {
                        return this.strings.length;
                    }
                }
                t.CFFStrings = CFFStrings;
                class CFFIndex {
                    constructor(){
                        this.objects = [];
                        this.length = 0;
                    }
                    add(e1) {
                        this.length += e1.length;
                        this.objects.push(e1);
                    }
                    set(e1, t) {
                        this.length += t.length - this.objects[e1].length;
                        this.objects[e1] = t;
                    }
                    get(e1) {
                        return this.objects[e1];
                    }
                    get count() {
                        return this.objects.length;
                    }
                }
                t.CFFIndex = CFFIndex;
                class CFFDict {
                    constructor(e1, t){
                        this.keyToNameMap = e1.keyToNameMap;
                        this.nameToKeyMap = e1.nameToKeyMap;
                        this.defaults = e1.defaults;
                        this.types = e1.types;
                        this.opcodes = e1.opcodes;
                        this.order = e1.order;
                        this.strings = t;
                        this.values = Object.create(null);
                    }
                    setByKey(e1, t) {
                        if (!(e1 in this.keyToNameMap)) return !1;
                        if (0 === t.length) return !0;
                        for (const a of t)if (isNaN(a)) {
                            (0, r.warn)(`Invalid CFFDict value: "${t}" for key "${e1}".`);
                            return !0;
                        }
                        const a = this.types[e1];
                        "num" !== a && "sid" !== a && "offset" !== a || (t = t[0]);
                        this.values[e1] = t;
                        return !0;
                    }
                    setByName(e1, t) {
                        if (!(e1 in this.nameToKeyMap)) throw new r.FormatError(`Invalid dictionary name "${e1}"`);
                        this.values[this.nameToKeyMap[e1]] = t;
                    }
                    hasName(e1) {
                        return this.nameToKeyMap[e1] in this.values;
                    }
                    getByName(e1) {
                        if (!(e1 in this.nameToKeyMap)) throw new r.FormatError(`Invalid dictionary name ${e1}"`);
                        const t = this.nameToKeyMap[e1];
                        return t in this.values ? this.values[t] : this.defaults[t];
                    }
                    removeByName(e1) {
                        delete this.values[this.nameToKeyMap[e1]];
                    }
                    static createTables(e1) {
                        const t = {
                            keyToNameMap: {},
                            nameToKeyMap: {},
                            defaults: {},
                            types: {},
                            opcodes: {},
                            order: []
                        };
                        for (const a of e1){
                            const e1 = Array.isArray(a[0]) ? (a[0][0] << 8) + a[0][1] : a[0];
                            t.keyToNameMap[e1] = a[1];
                            t.nameToKeyMap[a[1]] = e1;
                            t.types[e1] = a[2];
                            t.defaults[e1] = a[3];
                            t.opcodes[e1] = Array.isArray(a[0]) ? a[0] : [
                                a[0]
                            ];
                            t.order.push(e1);
                        }
                        return t;
                    }
                }
                const h = [
                    [
                        [
                            12,
                            30
                        ],
                        "ROS",
                        [
                            "sid",
                            "sid",
                            "num"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            20
                        ],
                        "SyntheticBase",
                        "num",
                        null
                    ],
                    [
                        0,
                        "version",
                        "sid",
                        null
                    ],
                    [
                        1,
                        "Notice",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            0
                        ],
                        "Copyright",
                        "sid",
                        null
                    ],
                    [
                        2,
                        "FullName",
                        "sid",
                        null
                    ],
                    [
                        3,
                        "FamilyName",
                        "sid",
                        null
                    ],
                    [
                        4,
                        "Weight",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            1
                        ],
                        "isFixedPitch",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            2
                        ],
                        "ItalicAngle",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            3
                        ],
                        "UnderlinePosition",
                        "num",
                        -100
                    ],
                    [
                        [
                            12,
                            4
                        ],
                        "UnderlineThickness",
                        "num",
                        50
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        "PaintType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            6
                        ],
                        "CharstringType",
                        "num",
                        2
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        [
                            "num",
                            "num",
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            .001,
                            0,
                            0,
                            .001,
                            0,
                            0
                        ]
                    ],
                    [
                        13,
                        "UniqueID",
                        "num",
                        null
                    ],
                    [
                        5,
                        "FontBBox",
                        [
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            8
                        ],
                        "StrokeWidth",
                        "num",
                        0
                    ],
                    [
                        14,
                        "XUID",
                        "array",
                        null
                    ],
                    [
                        15,
                        "charset",
                        "offset",
                        0
                    ],
                    [
                        16,
                        "Encoding",
                        "offset",
                        0
                    ],
                    [
                        17,
                        "CharStrings",
                        "offset",
                        0
                    ],
                    [
                        18,
                        "Private",
                        [
                            "offset",
                            "offset"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            21
                        ],
                        "PostScript",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            22
                        ],
                        "BaseFontName",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            23
                        ],
                        "BaseFontBlend",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            31
                        ],
                        "CIDFontVersion",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            32
                        ],
                        "CIDFontRevision",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            33
                        ],
                        "CIDFontType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            34
                        ],
                        "CIDCount",
                        "num",
                        8720
                    ],
                    [
                        [
                            12,
                            35
                        ],
                        "UIDBase",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        "FDSelect",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        "FDArray",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        "FontName",
                        "sid",
                        null
                    ]
                ];
                class CFFTopDict extends CFFDict {
                    static get tables() {
                        return (0, r.shadow)(this, "tables", this.createTables(h));
                    }
                    constructor(e1){
                        super(CFFTopDict.tables, e1);
                        this.privateDict = null;
                    }
                }
                t.CFFTopDict = CFFTopDict;
                const u = [
                    [
                        6,
                        "BlueValues",
                        "delta",
                        null
                    ],
                    [
                        7,
                        "OtherBlues",
                        "delta",
                        null
                    ],
                    [
                        8,
                        "FamilyBlues",
                        "delta",
                        null
                    ],
                    [
                        9,
                        "FamilyOtherBlues",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            9
                        ],
                        "BlueScale",
                        "num",
                        .039625
                    ],
                    [
                        [
                            12,
                            10
                        ],
                        "BlueShift",
                        "num",
                        7
                    ],
                    [
                        [
                            12,
                            11
                        ],
                        "BlueFuzz",
                        "num",
                        1
                    ],
                    [
                        10,
                        "StdHW",
                        "num",
                        null
                    ],
                    [
                        11,
                        "StdVW",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            12
                        ],
                        "StemSnapH",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            13
                        ],
                        "StemSnapV",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            14
                        ],
                        "ForceBold",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            17
                        ],
                        "LanguageGroup",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            18
                        ],
                        "ExpansionFactor",
                        "num",
                        .06
                    ],
                    [
                        [
                            12,
                            19
                        ],
                        "initialRandomSeed",
                        "num",
                        0
                    ],
                    [
                        20,
                        "defaultWidthX",
                        "num",
                        0
                    ],
                    [
                        21,
                        "nominalWidthX",
                        "num",
                        0
                    ],
                    [
                        19,
                        "Subrs",
                        "offset",
                        null
                    ]
                ];
                class CFFPrivateDict extends CFFDict {
                    static get tables() {
                        return (0, r.shadow)(this, "tables", this.createTables(u));
                    }
                    constructor(e1){
                        super(CFFPrivateDict.tables, e1);
                        this.subrsIndex = null;
                    }
                }
                t.CFFPrivateDict = CFFPrivateDict;
                const d = {
                    ISO_ADOBE: 0,
                    EXPERT: 1,
                    EXPERT_SUBSET: 2
                };
                class CFFCharset {
                    constructor(e1, t, a, r){
                        this.predefined = e1;
                        this.format = t;
                        this.charset = a;
                        this.raw = r;
                    }
                }
                t.CFFCharset = CFFCharset;
                class CFFEncoding {
                    constructor(e1, t, a, r){
                        this.predefined = e1;
                        this.format = t;
                        this.encoding = a;
                        this.raw = r;
                    }
                }
                class CFFFDSelect {
                    constructor(e1, t){
                        this.format = e1;
                        this.fdSelect = t;
                    }
                    getFDIndex(e1) {
                        return e1 < 0 || e1 >= this.fdSelect.length ? -1 : this.fdSelect[e1];
                    }
                }
                t.CFFFDSelect = CFFFDSelect;
                class CFFOffsetTracker {
                    constructor(){
                        this.offsets = Object.create(null);
                    }
                    isTracking(e1) {
                        return e1 in this.offsets;
                    }
                    track(e1, t) {
                        if (e1 in this.offsets) throw new r.FormatError(`Already tracking location of ${e1}`);
                        this.offsets[e1] = t;
                    }
                    offset(e1) {
                        for(const t in this.offsets)this.offsets[t] += e1;
                    }
                    setEntryLocation(e1, t, a) {
                        if (!(e1 in this.offsets)) throw new r.FormatError(`Not tracking location of ${e1}`);
                        const n = a.data, i = this.offsets[e1];
                        for(let e1 = 0, a = t.length; e1 < a; ++e1){
                            const a = 5 * e1 + i, s = a + 1, o = a + 2, c = a + 3, l = a + 4;
                            if (29 !== n[a] || 0 !== n[s] || 0 !== n[o] || 0 !== n[c] || 0 !== n[l]) throw new r.FormatError("writing to an offset that is not empty");
                            const h = t[e1];
                            n[a] = 29;
                            n[s] = h >> 24 & 255;
                            n[o] = h >> 16 & 255;
                            n[c] = h >> 8 & 255;
                            n[l] = 255 & h;
                        }
                    }
                }
                class CFFCompiler {
                    constructor(e1){
                        this.cff = e1;
                    }
                    compile() {
                        const e1 = this.cff, t = {
                            data: [],
                            length: 0,
                            add (e1) {
                                try {
                                    this.data.push(...e1);
                                } catch  {
                                    this.data = this.data.concat(e1);
                                }
                                this.length = this.data.length;
                            }
                        }, a = this.compileHeader(e1.header);
                        t.add(a);
                        const n = this.compileNameIndex(e1.names);
                        t.add(n);
                        if (e1.isCIDFont && e1.topDict.hasName("FontMatrix")) {
                            const t = e1.topDict.getByName("FontMatrix");
                            e1.topDict.removeByName("FontMatrix");
                            for (const a of e1.fdArray){
                                let e1 = t.slice(0);
                                a.hasName("FontMatrix") && (e1 = r.Util.transform(e1, a.getByName("FontMatrix")));
                                a.setByName("FontMatrix", e1);
                            }
                        }
                        const i = e1.topDict.getByName("XUID");
                        i?.length > 16 && e1.topDict.removeByName("XUID");
                        e1.topDict.setByName("charset", 0);
                        let s = this.compileTopDicts([
                            e1.topDict
                        ], t.length, e1.isCIDFont);
                        t.add(s.output);
                        const o = s.trackers[0], c = this.compileStringIndex(e1.strings.strings);
                        t.add(c);
                        const l = this.compileIndex(e1.globalSubrIndex);
                        t.add(l);
                        if (e1.encoding && e1.topDict.hasName("Encoding")) {
                            if (e1.encoding.predefined) o.setEntryLocation("Encoding", [
                                e1.encoding.format
                            ], t);
                            else {
                                const a = this.compileEncoding(e1.encoding);
                                o.setEntryLocation("Encoding", [
                                    t.length
                                ], t);
                                t.add(a);
                            }
                        }
                        const h = this.compileCharset(e1.charset, e1.charStrings.count, e1.strings, e1.isCIDFont);
                        o.setEntryLocation("charset", [
                            t.length
                        ], t);
                        t.add(h);
                        const u = this.compileCharStrings(e1.charStrings);
                        o.setEntryLocation("CharStrings", [
                            t.length
                        ], t);
                        t.add(u);
                        if (e1.isCIDFont) {
                            o.setEntryLocation("FDSelect", [
                                t.length
                            ], t);
                            const a = this.compileFDSelect(e1.fdSelect);
                            t.add(a);
                            s = this.compileTopDicts(e1.fdArray, t.length, !0);
                            o.setEntryLocation("FDArray", [
                                t.length
                            ], t);
                            t.add(s.output);
                            const r = s.trackers;
                            this.compilePrivateDicts(e1.fdArray, r, t);
                        }
                        this.compilePrivateDicts([
                            e1.topDict
                        ], [
                            o
                        ], t);
                        t.add([
                            0
                        ]);
                        return t.data;
                    }
                    encodeNumber(e1) {
                        return Number.isInteger(e1) ? this.encodeInteger(e1) : this.encodeFloat(e1);
                    }
                    static get EncodeFloatRegExp() {
                        return (0, r.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
                    }
                    encodeFloat(e1) {
                        let t = e1.toString();
                        const a = CFFCompiler.EncodeFloatRegExp.exec(t);
                        if (a) {
                            const r = parseFloat("1e" + ((a[2] ? +a[2] : 0) + a[1].length));
                            t = (Math.round(e1 * r) / r).toString();
                        }
                        let r, n, i = "";
                        for(r = 0, n = t.length; r < n; ++r){
                            const e1 = t[r];
                            i += "e" === e1 ? "-" === t[++r] ? "c" : "b" : "." === e1 ? "a" : "-" === e1 ? "e" : e1;
                        }
                        i += 1 & i.length ? "f" : "ff";
                        const s = [
                            30
                        ];
                        for(r = 0, n = i.length; r < n; r += 2)s.push(parseInt(i.substring(r, r + 2), 16));
                        return s;
                    }
                    encodeInteger(e1) {
                        let t;
                        t = e1 >= -107 && e1 <= 107 ? [
                            e1 + 139
                        ] : e1 >= 108 && e1 <= 1131 ? [
                            247 + ((e1 -= 108) >> 8),
                            255 & e1
                        ] : e1 >= -1131 && e1 <= -108 ? [
                            251 + ((e1 = -e1 - 108) >> 8),
                            255 & e1
                        ] : e1 >= -32768 && e1 <= 32767 ? [
                            28,
                            e1 >> 8 & 255,
                            255 & e1
                        ] : [
                            29,
                            e1 >> 24 & 255,
                            e1 >> 16 & 255,
                            e1 >> 8 & 255,
                            255 & e1
                        ];
                        return t;
                    }
                    compileHeader(e1) {
                        return [
                            e1.major,
                            e1.minor,
                            4,
                            e1.offSize
                        ];
                    }
                    compileNameIndex(e1) {
                        const t = new CFFIndex;
                        for (const a of e1){
                            const e1 = Math.min(a.length, 127);
                            let n = new Array(e1);
                            for(let t = 0; t < e1; t++){
                                let e1 = a[t];
                                (e1 < "!" || e1 > "~" || "[" === e1 || "]" === e1 || "(" === e1 || ")" === e1 || "{" === e1 || "}" === e1 || "<" === e1 || ">" === e1 || "/" === e1 || "%" === e1) && (e1 = "_");
                                n[t] = e1;
                            }
                            n = n.join("");
                            "" === n && (n = "Bad_Font_Name");
                            t.add((0, r.stringToBytes)(n));
                        }
                        return this.compileIndex(t);
                    }
                    compileTopDicts(e1, t, a) {
                        const r = [];
                        let n = new CFFIndex;
                        for (const i of e1){
                            if (a) {
                                i.removeByName("CIDFontVersion");
                                i.removeByName("CIDFontRevision");
                                i.removeByName("CIDFontType");
                                i.removeByName("CIDCount");
                                i.removeByName("UIDBase");
                            }
                            const e1 = new CFFOffsetTracker, s = this.compileDict(i, e1);
                            r.push(e1);
                            n.add(s);
                            e1.offset(t);
                        }
                        n = this.compileIndex(n, r);
                        return {
                            trackers: r,
                            output: n
                        };
                    }
                    compilePrivateDicts(e1, t, a) {
                        for(let n = 0, i = e1.length; n < i; ++n){
                            const i = e1[n], s = i.privateDict;
                            if (!s || !i.hasName("Private")) throw new r.FormatError("There must be a private dictionary.");
                            const o = new CFFOffsetTracker, c = this.compileDict(s, o);
                            let l = a.length;
                            o.offset(l);
                            c.length || (l = 0);
                            t[n].setEntryLocation("Private", [
                                c.length,
                                l
                            ], a);
                            a.add(c);
                            if (s.subrsIndex && s.hasName("Subrs")) {
                                const e1 = this.compileIndex(s.subrsIndex);
                                o.setEntryLocation("Subrs", [
                                    c.length
                                ], a);
                                a.add(e1);
                            }
                        }
                    }
                    compileDict(e1, t) {
                        const a = [];
                        for (const n of e1.order){
                            if (!(n in e1.values)) continue;
                            let i = e1.values[n], s = e1.types[n];
                            Array.isArray(s) || (s = [
                                s
                            ]);
                            Array.isArray(i) || (i = [
                                i
                            ]);
                            if (0 !== i.length) {
                                for(let o = 0, c = s.length; o < c; ++o){
                                    const c = s[o], l = i[o];
                                    switch(c){
                                        case "num":
                                        case "sid":
                                            a.push(...this.encodeNumber(l));
                                            break;
                                        case "offset":
                                            const s1 = e1.keyToNameMap[n];
                                            t.isTracking(s1) || t.track(s1, a.length);
                                            a.push(29, 0, 0, 0, 0);
                                            break;
                                        case "array":
                                        case "delta":
                                            a.push(...this.encodeNumber(l));
                                            for(let e1 = 1, t = i.length; e1 < t; ++e1)a.push(...this.encodeNumber(i[e1]));
                                            break;
                                        default:
                                            throw new r.FormatError(`Unknown data type of ${c}`);
                                    }
                                }
                                a.push(...e1.opcodes[n]);
                            }
                        }
                        return a;
                    }
                    compileStringIndex(e1) {
                        const t = new CFFIndex;
                        for (const a of e1)t.add((0, r.stringToBytes)(a));
                        return this.compileIndex(t);
                    }
                    compileCharStrings(e1) {
                        const t = new CFFIndex;
                        for(let a = 0; a < e1.count; a++){
                            const r = e1.get(a);
                            0 !== r.length ? t.add(r) : t.add(new Uint8Array([
                                139,
                                14
                            ]));
                        }
                        return this.compileIndex(t);
                    }
                    compileCharset(e1, t, a, n) {
                        let i;
                        const s = t - 1;
                        if (n) i = new Uint8Array([
                            2,
                            0,
                            0,
                            s >> 8 & 255,
                            255 & s
                        ]);
                        else {
                            i = new Uint8Array(1 + 2 * s);
                            i[0] = 0;
                            let t = 0;
                            const n = e1.charset.length;
                            let o = !1;
                            for(let s = 1; s < i.length; s += 2){
                                let c = 0;
                                if (t < n) {
                                    const n = e1.charset[t++];
                                    c = a.getSID(n);
                                    if (-1 === c) {
                                        c = 0;
                                        if (!o) {
                                            o = !0;
                                            (0, r.warn)(`Couldn't find ${n} in CFF strings`);
                                        }
                                    }
                                }
                                i[s] = c >> 8 & 255;
                                i[s + 1] = 255 & c;
                            }
                        }
                        return this.compileTypedArray(i);
                    }
                    compileEncoding(e1) {
                        return this.compileTypedArray(e1.raw);
                    }
                    compileFDSelect(e1) {
                        const t = e1.format;
                        let a, r;
                        switch(t){
                            case 0:
                                a = new Uint8Array(1 + e1.fdSelect.length);
                                a[0] = t;
                                for(r = 0; r < e1.fdSelect.length; r++)a[r + 1] = e1.fdSelect[r];
                                break;
                            case 3:
                                const n = 0;
                                let i = e1.fdSelect[0];
                                const s = [
                                    t,
                                    0,
                                    0,
                                    n >> 8 & 255,
                                    255 & n,
                                    i
                                ];
                                for(r = 1; r < e1.fdSelect.length; r++){
                                    const t = e1.fdSelect[r];
                                    if (t !== i) {
                                        s.push(r >> 8 & 255, 255 & r, t);
                                        i = t;
                                    }
                                }
                                const o = (s.length - 3) / 3;
                                s[1] = o >> 8 & 255;
                                s[2] = 255 & o;
                                s.push(r >> 8 & 255, 255 & r);
                                a = new Uint8Array(s);
                        }
                        return this.compileTypedArray(a);
                    }
                    compileTypedArray(e1) {
                        return Array.from(e1);
                    }
                    compileIndex(e1, t = []) {
                        const a = e1.objects, r = a.length;
                        if (0 === r) return [
                            0,
                            0
                        ];
                        const n = [
                            r >> 8 & 255,
                            255 & r
                        ];
                        let i, s, o = 1;
                        for(i = 0; i < r; ++i)o += a[i].length;
                        s = o < 256 ? 1 : o < 65536 ? 2 : o < 16777216 ? 3 : 4;
                        n.push(s);
                        let c = 1;
                        for(i = 0; i < r + 1; i++){
                            1 === s ? n.push(255 & c) : 2 === s ? n.push(c >> 8 & 255, 255 & c) : 3 === s ? n.push(c >> 16 & 255, c >> 8 & 255, 255 & c) : n.push(c >>> 24 & 255, c >> 16 & 255, c >> 8 & 255, 255 & c);
                            a[i] && (c += a[i].length);
                        }
                        for(i = 0; i < r; i++){
                            t[i] && t[i].offset(n.length);
                            n.push(...a[i]);
                        }
                        return n;
                    }
                }
                t.CFFCompiler = CFFCompiler;
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ISOAdobeCharset = t.ExpertSubsetCharset = t.ExpertCharset = void 0;
                t.ISOAdobeCharset = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron"
                ];
                t.ExpertCharset = [
                    ".notdef",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                t.ExpertSubsetCharset = [
                    ".notdef",
                    "space",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "hyphensuperior",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "centoldstyle",
                    "figuredash",
                    "hypheninferior",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior"
                ];
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ZapfDingbatsEncoding = t.WinAnsiEncoding = t.SymbolSetEncoding = t.StandardEncoding = t.MacRomanEncoding = t.ExpertEncoding = void 0;
                t.getEncoding = function getEncoding(e1) {
                    switch(e1){
                        case "WinAnsiEncoding":
                            return s;
                        case "StandardEncoding":
                            return i;
                        case "MacRomanEncoding":
                            return n;
                        case "SymbolSetEncoding":
                            return o;
                        case "ZapfDingbatsEncoding":
                            return c;
                        case "ExpertEncoding":
                            return a;
                        case "MacExpertEncoding":
                            return r;
                        default:
                            return null;
                    }
                };
                const a = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "",
                    "",
                    "",
                    "isuperior",
                    "",
                    "",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "",
                    "",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "",
                    "",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "",
                    "Dotaccentsmall",
                    "",
                    "",
                    "Macronsmall",
                    "",
                    "",
                    "figuredash",
                    "hypheninferior",
                    "",
                    "",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                t.ExpertEncoding = a;
                const r = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "centoldstyle",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "",
                    "threequartersemdash",
                    "",
                    "questionsmall",
                    "",
                    "",
                    "",
                    "",
                    "Ethsmall",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hypheninferior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "asuperior",
                    "centsuperior",
                    "",
                    "",
                    "",
                    "",
                    "Aacutesmall",
                    "Agravesmall",
                    "Acircumflexsmall",
                    "Adieresissmall",
                    "Atildesmall",
                    "Aringsmall",
                    "Ccedillasmall",
                    "Eacutesmall",
                    "Egravesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Iacutesmall",
                    "Igravesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ntildesmall",
                    "Oacutesmall",
                    "Ogravesmall",
                    "Ocircumflexsmall",
                    "Odieresissmall",
                    "Otildesmall",
                    "Uacutesmall",
                    "Ugravesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "",
                    "eightsuperior",
                    "fourinferior",
                    "threeinferior",
                    "sixinferior",
                    "eightinferior",
                    "seveninferior",
                    "Scaronsmall",
                    "",
                    "centinferior",
                    "twoinferior",
                    "",
                    "Dieresissmall",
                    "",
                    "Caronsmall",
                    "osuperior",
                    "fiveinferior",
                    "",
                    "commainferior",
                    "periodinferior",
                    "Yacutesmall",
                    "",
                    "dollarinferior",
                    "",
                    "",
                    "Thornsmall",
                    "",
                    "nineinferior",
                    "zeroinferior",
                    "Zcaronsmall",
                    "AEsmall",
                    "Oslashsmall",
                    "questiondownsmall",
                    "oneinferior",
                    "Lslashsmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "OEsmall",
                    "figuredash",
                    "hyphensuperior",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "",
                    "Ydieresissmall",
                    "",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "ninesuperior",
                    "zerosuperior",
                    "",
                    "esuperior",
                    "rsuperior",
                    "tsuperior",
                    "",
                    "",
                    "isuperior",
                    "ssuperior",
                    "dsuperior",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "lsuperior",
                    "Ogoneksmall",
                    "Brevesmall",
                    "Macronsmall",
                    "bsuperior",
                    "nsuperior",
                    "msuperior",
                    "commasuperior",
                    "periodsuperior",
                    "Dotaccentsmall",
                    "Ringsmall",
                    "",
                    "",
                    "",
                    ""
                ], n = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "space",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron"
                ];
                t.MacRomanEncoding = n;
                const i = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "",
                    "questiondown",
                    "",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "",
                    "ring",
                    "cedilla",
                    "",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "AE",
                    "",
                    "ordfeminine",
                    "",
                    "",
                    "",
                    "",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ae",
                    "",
                    "",
                    "",
                    "dotlessi",
                    "",
                    "",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "",
                    "",
                    "",
                    ""
                ];
                t.StandardEncoding = i;
                const s = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "bullet",
                    "Euro",
                    "bullet",
                    "quotesinglbase",
                    "florin",
                    "quotedblbase",
                    "ellipsis",
                    "dagger",
                    "daggerdbl",
                    "circumflex",
                    "perthousand",
                    "Scaron",
                    "guilsinglleft",
                    "OE",
                    "bullet",
                    "Zcaron",
                    "bullet",
                    "bullet",
                    "quoteleft",
                    "quoteright",
                    "quotedblleft",
                    "quotedblright",
                    "bullet",
                    "endash",
                    "emdash",
                    "tilde",
                    "trademark",
                    "scaron",
                    "guilsinglright",
                    "oe",
                    "bullet",
                    "zcaron",
                    "Ydieresis",
                    "space",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "currency",
                    "yen",
                    "brokenbar",
                    "section",
                    "dieresis",
                    "copyright",
                    "ordfeminine",
                    "guillemotleft",
                    "logicalnot",
                    "hyphen",
                    "registered",
                    "macron",
                    "degree",
                    "plusminus",
                    "twosuperior",
                    "threesuperior",
                    "acute",
                    "mu",
                    "paragraph",
                    "periodcentered",
                    "cedilla",
                    "onesuperior",
                    "ordmasculine",
                    "guillemotright",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondown",
                    "Agrave",
                    "Aacute",
                    "Acircumflex",
                    "Atilde",
                    "Adieresis",
                    "Aring",
                    "AE",
                    "Ccedilla",
                    "Egrave",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Igrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Eth",
                    "Ntilde",
                    "Ograve",
                    "Oacute",
                    "Ocircumflex",
                    "Otilde",
                    "Odieresis",
                    "multiply",
                    "Oslash",
                    "Ugrave",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Yacute",
                    "Thorn",
                    "germandbls",
                    "agrave",
                    "aacute",
                    "acircumflex",
                    "atilde",
                    "adieresis",
                    "aring",
                    "ae",
                    "ccedilla",
                    "egrave",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "igrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "eth",
                    "ntilde",
                    "ograve",
                    "oacute",
                    "ocircumflex",
                    "otilde",
                    "odieresis",
                    "divide",
                    "oslash",
                    "ugrave",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "yacute",
                    "thorn",
                    "ydieresis"
                ];
                t.WinAnsiEncoding = s;
                const o = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "universal",
                    "numbersign",
                    "existential",
                    "percent",
                    "ampersand",
                    "suchthat",
                    "parenleft",
                    "parenright",
                    "asteriskmath",
                    "plus",
                    "comma",
                    "minus",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "congruent",
                    "Alpha",
                    "Beta",
                    "Chi",
                    "Delta",
                    "Epsilon",
                    "Phi",
                    "Gamma",
                    "Eta",
                    "Iota",
                    "theta1",
                    "Kappa",
                    "Lambda",
                    "Mu",
                    "Nu",
                    "Omicron",
                    "Pi",
                    "Theta",
                    "Rho",
                    "Sigma",
                    "Tau",
                    "Upsilon",
                    "sigma1",
                    "Omega",
                    "Xi",
                    "Psi",
                    "Zeta",
                    "bracketleft",
                    "therefore",
                    "bracketright",
                    "perpendicular",
                    "underscore",
                    "radicalex",
                    "alpha",
                    "beta",
                    "chi",
                    "delta",
                    "epsilon",
                    "phi",
                    "gamma",
                    "eta",
                    "iota",
                    "phi1",
                    "kappa",
                    "lambda",
                    "mu",
                    "nu",
                    "omicron",
                    "pi",
                    "theta",
                    "rho",
                    "sigma",
                    "tau",
                    "upsilon",
                    "omega1",
                    "omega",
                    "xi",
                    "psi",
                    "zeta",
                    "braceleft",
                    "bar",
                    "braceright",
                    "similar",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Euro",
                    "Upsilon1",
                    "minute",
                    "lessequal",
                    "fraction",
                    "infinity",
                    "florin",
                    "club",
                    "diamond",
                    "heart",
                    "spade",
                    "arrowboth",
                    "arrowleft",
                    "arrowup",
                    "arrowright",
                    "arrowdown",
                    "degree",
                    "plusminus",
                    "second",
                    "greaterequal",
                    "multiply",
                    "proportional",
                    "partialdiff",
                    "bullet",
                    "divide",
                    "notequal",
                    "equivalence",
                    "approxequal",
                    "ellipsis",
                    "arrowvertex",
                    "arrowhorizex",
                    "carriagereturn",
                    "aleph",
                    "Ifraktur",
                    "Rfraktur",
                    "weierstrass",
                    "circlemultiply",
                    "circleplus",
                    "emptyset",
                    "intersection",
                    "union",
                    "propersuperset",
                    "reflexsuperset",
                    "notsubset",
                    "propersubset",
                    "reflexsubset",
                    "element",
                    "notelement",
                    "angle",
                    "gradient",
                    "registerserif",
                    "copyrightserif",
                    "trademarkserif",
                    "product",
                    "radical",
                    "dotmath",
                    "logicalnot",
                    "logicaland",
                    "logicalor",
                    "arrowdblboth",
                    "arrowdblleft",
                    "arrowdblup",
                    "arrowdblright",
                    "arrowdbldown",
                    "lozenge",
                    "angleleft",
                    "registersans",
                    "copyrightsans",
                    "trademarksans",
                    "summation",
                    "parenlefttp",
                    "parenleftex",
                    "parenleftbt",
                    "bracketlefttp",
                    "bracketleftex",
                    "bracketleftbt",
                    "bracelefttp",
                    "braceleftmid",
                    "braceleftbt",
                    "braceex",
                    "",
                    "angleright",
                    "integral",
                    "integraltp",
                    "integralex",
                    "integralbt",
                    "parenrighttp",
                    "parenrightex",
                    "parenrightbt",
                    "bracketrighttp",
                    "bracketrightex",
                    "bracketrightbt",
                    "bracerighttp",
                    "bracerightmid",
                    "bracerightbt",
                    ""
                ];
                t.SymbolSetEncoding = o;
                const c = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "a1",
                    "a2",
                    "a202",
                    "a3",
                    "a4",
                    "a5",
                    "a119",
                    "a118",
                    "a117",
                    "a11",
                    "a12",
                    "a13",
                    "a14",
                    "a15",
                    "a16",
                    "a105",
                    "a17",
                    "a18",
                    "a19",
                    "a20",
                    "a21",
                    "a22",
                    "a23",
                    "a24",
                    "a25",
                    "a26",
                    "a27",
                    "a28",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "a10",
                    "a29",
                    "a30",
                    "a31",
                    "a32",
                    "a33",
                    "a34",
                    "a35",
                    "a36",
                    "a37",
                    "a38",
                    "a39",
                    "a40",
                    "a41",
                    "a42",
                    "a43",
                    "a44",
                    "a45",
                    "a46",
                    "a47",
                    "a48",
                    "a49",
                    "a50",
                    "a51",
                    "a52",
                    "a53",
                    "a54",
                    "a55",
                    "a56",
                    "a57",
                    "a58",
                    "a59",
                    "a60",
                    "a61",
                    "a62",
                    "a63",
                    "a64",
                    "a65",
                    "a66",
                    "a67",
                    "a68",
                    "a69",
                    "a70",
                    "a71",
                    "a72",
                    "a73",
                    "a74",
                    "a203",
                    "a75",
                    "a204",
                    "a76",
                    "a77",
                    "a78",
                    "a79",
                    "a81",
                    "a82",
                    "a83",
                    "a84",
                    "a97",
                    "a98",
                    "a99",
                    "a100",
                    "",
                    "a89",
                    "a90",
                    "a93",
                    "a94",
                    "a91",
                    "a92",
                    "a205",
                    "a85",
                    "a206",
                    "a86",
                    "a87",
                    "a88",
                    "a95",
                    "a96",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "a101",
                    "a102",
                    "a103",
                    "a104",
                    "a106",
                    "a107",
                    "a108",
                    "a112",
                    "a111",
                    "a110",
                    "a109",
                    "a120",
                    "a121",
                    "a122",
                    "a123",
                    "a124",
                    "a125",
                    "a126",
                    "a127",
                    "a128",
                    "a129",
                    "a130",
                    "a131",
                    "a132",
                    "a133",
                    "a134",
                    "a135",
                    "a136",
                    "a137",
                    "a138",
                    "a139",
                    "a140",
                    "a141",
                    "a142",
                    "a143",
                    "a144",
                    "a145",
                    "a146",
                    "a147",
                    "a148",
                    "a149",
                    "a150",
                    "a151",
                    "a152",
                    "a153",
                    "a154",
                    "a155",
                    "a156",
                    "a157",
                    "a158",
                    "a159",
                    "a160",
                    "a161",
                    "a163",
                    "a164",
                    "a196",
                    "a165",
                    "a192",
                    "a166",
                    "a167",
                    "a168",
                    "a169",
                    "a170",
                    "a171",
                    "a172",
                    "a173",
                    "a162",
                    "a174",
                    "a175",
                    "a176",
                    "a177",
                    "a178",
                    "a179",
                    "a193",
                    "a180",
                    "a199",
                    "a181",
                    "a200",
                    "a182",
                    "",
                    "a201",
                    "a183",
                    "a184",
                    "a197",
                    "a185",
                    "a194",
                    "a198",
                    "a186",
                    "a195",
                    "a187",
                    "a188",
                    "a189",
                    "a190",
                    "a191",
                    ""
                ];
                t.ZapfDingbatsEncoding = c;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.SEAC_ANALYSIS_ENABLED = t.MacStandardGlyphOrdering = t.FontFlags = void 0;
                t.normalizeFontName = function normalizeFontName(e1) {
                    return e1.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
                };
                t.recoverGlyphName = recoverGlyphName;
                t.type1FontGlyphMapping = function type1FontGlyphMapping(e1, t, a) {
                    const i = Object.create(null);
                    let s, c, l;
                    const h = !!(e1.flags & o.Symbolic);
                    if (e1.isInternalFont) {
                        l = t;
                        for(c = 0; c < l.length; c++){
                            s = a.indexOf(l[c]);
                            i[c] = s >= 0 ? s : 0;
                        }
                    } else if (e1.baseEncodingName) {
                        l = (0, r.getEncoding)(e1.baseEncodingName);
                        for(c = 0; c < l.length; c++){
                            s = a.indexOf(l[c]);
                            i[c] = s >= 0 ? s : 0;
                        }
                    } else if (h) for(c in t)i[c] = t[c];
                    else {
                        l = r.StandardEncoding;
                        for(c = 0; c < l.length; c++){
                            s = a.indexOf(l[c]);
                            i[c] = s >= 0 ? s : 0;
                        }
                    }
                    const u = e1.differences;
                    let d;
                    if (u) for(c in u){
                        const e1 = u[c];
                        s = a.indexOf(e1);
                        if (-1 === s) {
                            d || (d = (0, n.getGlyphsUnicode)());
                            const t = recoverGlyphName(e1, d);
                            t !== e1 && (s = a.indexOf(t));
                        }
                        i[c] = s >= 0 ? s : 0;
                    }
                    return i;
                };
                var r = a(37), n = a(39), i = a(40), s = a(2);
                t.SEAC_ANALYSIS_ENABLED = !0;
                const o = {
                    FixedPitch: 1,
                    Serif: 2,
                    Symbolic: 4,
                    Script: 8,
                    Nonsymbolic: 32,
                    Italic: 64,
                    AllCap: 65536,
                    SmallCap: 131072,
                    ForceBold: 262144
                };
                t.FontFlags = o;
                t.MacStandardGlyphOrdering = [
                    ".notdef",
                    ".null",
                    "nonmarkingreturn",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "nonbreakingspace",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "Lslash",
                    "lslash",
                    "Scaron",
                    "scaron",
                    "Zcaron",
                    "zcaron",
                    "brokenbar",
                    "Eth",
                    "eth",
                    "Yacute",
                    "yacute",
                    "Thorn",
                    "thorn",
                    "minus",
                    "multiply",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "onehalf",
                    "onequarter",
                    "threequarters",
                    "franc",
                    "Gbreve",
                    "gbreve",
                    "Idotaccent",
                    "Scedilla",
                    "scedilla",
                    "Cacute",
                    "cacute",
                    "Ccaron",
                    "ccaron",
                    "dcroat"
                ];
                function recoverGlyphName(e1, t) {
                    if (void 0 !== t[e1]) return e1;
                    const a = (0, i.getUnicodeForGlyph)(e1, t);
                    if (-1 !== a) {
                        for(const e1 in t)if (t[e1] === a) return e1;
                    }
                    (0, s.info)("Unable to recover a standard glyph name for: " + e1);
                    return e1;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.getGlyphsUnicode = t.getDingbatsGlyphsUnicode = void 0;
                var r = a(3);
                const n = (0, r.getLookupTableFactory)(function(e1) {
                    e1.A = 65;
                    e1.AE = 198;
                    e1.AEacute = 508;
                    e1.AEmacron = 482;
                    e1.AEsmall = 63462;
                    e1.Aacute = 193;
                    e1.Aacutesmall = 63457;
                    e1.Abreve = 258;
                    e1.Abreveacute = 7854;
                    e1.Abrevecyrillic = 1232;
                    e1.Abrevedotbelow = 7862;
                    e1.Abrevegrave = 7856;
                    e1.Abrevehookabove = 7858;
                    e1.Abrevetilde = 7860;
                    e1.Acaron = 461;
                    e1.Acircle = 9398;
                    e1.Acircumflex = 194;
                    e1.Acircumflexacute = 7844;
                    e1.Acircumflexdotbelow = 7852;
                    e1.Acircumflexgrave = 7846;
                    e1.Acircumflexhookabove = 7848;
                    e1.Acircumflexsmall = 63458;
                    e1.Acircumflextilde = 7850;
                    e1.Acute = 63177;
                    e1.Acutesmall = 63412;
                    e1.Acyrillic = 1040;
                    e1.Adblgrave = 512;
                    e1.Adieresis = 196;
                    e1.Adieresiscyrillic = 1234;
                    e1.Adieresismacron = 478;
                    e1.Adieresissmall = 63460;
                    e1.Adotbelow = 7840;
                    e1.Adotmacron = 480;
                    e1.Agrave = 192;
                    e1.Agravesmall = 63456;
                    e1.Ahookabove = 7842;
                    e1.Aiecyrillic = 1236;
                    e1.Ainvertedbreve = 514;
                    e1.Alpha = 913;
                    e1.Alphatonos = 902;
                    e1.Amacron = 256;
                    e1.Amonospace = 65313;
                    e1.Aogonek = 260;
                    e1.Aring = 197;
                    e1.Aringacute = 506;
                    e1.Aringbelow = 7680;
                    e1.Aringsmall = 63461;
                    e1.Asmall = 63329;
                    e1.Atilde = 195;
                    e1.Atildesmall = 63459;
                    e1.Aybarmenian = 1329;
                    e1.B = 66;
                    e1.Bcircle = 9399;
                    e1.Bdotaccent = 7682;
                    e1.Bdotbelow = 7684;
                    e1.Becyrillic = 1041;
                    e1.Benarmenian = 1330;
                    e1.Beta = 914;
                    e1.Bhook = 385;
                    e1.Blinebelow = 7686;
                    e1.Bmonospace = 65314;
                    e1.Brevesmall = 63220;
                    e1.Bsmall = 63330;
                    e1.Btopbar = 386;
                    e1.C = 67;
                    e1.Caarmenian = 1342;
                    e1.Cacute = 262;
                    e1.Caron = 63178;
                    e1.Caronsmall = 63221;
                    e1.Ccaron = 268;
                    e1.Ccedilla = 199;
                    e1.Ccedillaacute = 7688;
                    e1.Ccedillasmall = 63463;
                    e1.Ccircle = 9400;
                    e1.Ccircumflex = 264;
                    e1.Cdot = 266;
                    e1.Cdotaccent = 266;
                    e1.Cedillasmall = 63416;
                    e1.Chaarmenian = 1353;
                    e1.Cheabkhasiancyrillic = 1212;
                    e1.Checyrillic = 1063;
                    e1.Chedescenderabkhasiancyrillic = 1214;
                    e1.Chedescendercyrillic = 1206;
                    e1.Chedieresiscyrillic = 1268;
                    e1.Cheharmenian = 1347;
                    e1.Chekhakassiancyrillic = 1227;
                    e1.Cheverticalstrokecyrillic = 1208;
                    e1.Chi = 935;
                    e1.Chook = 391;
                    e1.Circumflexsmall = 63222;
                    e1.Cmonospace = 65315;
                    e1.Coarmenian = 1361;
                    e1.Csmall = 63331;
                    e1.D = 68;
                    e1.DZ = 497;
                    e1.DZcaron = 452;
                    e1.Daarmenian = 1332;
                    e1.Dafrican = 393;
                    e1.Dcaron = 270;
                    e1.Dcedilla = 7696;
                    e1.Dcircle = 9401;
                    e1.Dcircumflexbelow = 7698;
                    e1.Dcroat = 272;
                    e1.Ddotaccent = 7690;
                    e1.Ddotbelow = 7692;
                    e1.Decyrillic = 1044;
                    e1.Deicoptic = 1006;
                    e1.Delta = 8710;
                    e1.Deltagreek = 916;
                    e1.Dhook = 394;
                    e1.Dieresis = 63179;
                    e1.DieresisAcute = 63180;
                    e1.DieresisGrave = 63181;
                    e1.Dieresissmall = 63400;
                    e1.Digammagreek = 988;
                    e1.Djecyrillic = 1026;
                    e1.Dlinebelow = 7694;
                    e1.Dmonospace = 65316;
                    e1.Dotaccentsmall = 63223;
                    e1.Dslash = 272;
                    e1.Dsmall = 63332;
                    e1.Dtopbar = 395;
                    e1.Dz = 498;
                    e1.Dzcaron = 453;
                    e1.Dzeabkhasiancyrillic = 1248;
                    e1.Dzecyrillic = 1029;
                    e1.Dzhecyrillic = 1039;
                    e1.E = 69;
                    e1.Eacute = 201;
                    e1.Eacutesmall = 63465;
                    e1.Ebreve = 276;
                    e1.Ecaron = 282;
                    e1.Ecedillabreve = 7708;
                    e1.Echarmenian = 1333;
                    e1.Ecircle = 9402;
                    e1.Ecircumflex = 202;
                    e1.Ecircumflexacute = 7870;
                    e1.Ecircumflexbelow = 7704;
                    e1.Ecircumflexdotbelow = 7878;
                    e1.Ecircumflexgrave = 7872;
                    e1.Ecircumflexhookabove = 7874;
                    e1.Ecircumflexsmall = 63466;
                    e1.Ecircumflextilde = 7876;
                    e1.Ecyrillic = 1028;
                    e1.Edblgrave = 516;
                    e1.Edieresis = 203;
                    e1.Edieresissmall = 63467;
                    e1.Edot = 278;
                    e1.Edotaccent = 278;
                    e1.Edotbelow = 7864;
                    e1.Efcyrillic = 1060;
                    e1.Egrave = 200;
                    e1.Egravesmall = 63464;
                    e1.Eharmenian = 1335;
                    e1.Ehookabove = 7866;
                    e1.Eightroman = 8551;
                    e1.Einvertedbreve = 518;
                    e1.Eiotifiedcyrillic = 1124;
                    e1.Elcyrillic = 1051;
                    e1.Elevenroman = 8554;
                    e1.Emacron = 274;
                    e1.Emacronacute = 7702;
                    e1.Emacrongrave = 7700;
                    e1.Emcyrillic = 1052;
                    e1.Emonospace = 65317;
                    e1.Encyrillic = 1053;
                    e1.Endescendercyrillic = 1186;
                    e1.Eng = 330;
                    e1.Enghecyrillic = 1188;
                    e1.Enhookcyrillic = 1223;
                    e1.Eogonek = 280;
                    e1.Eopen = 400;
                    e1.Epsilon = 917;
                    e1.Epsilontonos = 904;
                    e1.Ercyrillic = 1056;
                    e1.Ereversed = 398;
                    e1.Ereversedcyrillic = 1069;
                    e1.Escyrillic = 1057;
                    e1.Esdescendercyrillic = 1194;
                    e1.Esh = 425;
                    e1.Esmall = 63333;
                    e1.Eta = 919;
                    e1.Etarmenian = 1336;
                    e1.Etatonos = 905;
                    e1.Eth = 208;
                    e1.Ethsmall = 63472;
                    e1.Etilde = 7868;
                    e1.Etildebelow = 7706;
                    e1.Euro = 8364;
                    e1.Ezh = 439;
                    e1.Ezhcaron = 494;
                    e1.Ezhreversed = 440;
                    e1.F = 70;
                    e1.Fcircle = 9403;
                    e1.Fdotaccent = 7710;
                    e1.Feharmenian = 1366;
                    e1.Feicoptic = 996;
                    e1.Fhook = 401;
                    e1.Fitacyrillic = 1138;
                    e1.Fiveroman = 8548;
                    e1.Fmonospace = 65318;
                    e1.Fourroman = 8547;
                    e1.Fsmall = 63334;
                    e1.G = 71;
                    e1.GBsquare = 13191;
                    e1.Gacute = 500;
                    e1.Gamma = 915;
                    e1.Gammaafrican = 404;
                    e1.Gangiacoptic = 1002;
                    e1.Gbreve = 286;
                    e1.Gcaron = 486;
                    e1.Gcedilla = 290;
                    e1.Gcircle = 9404;
                    e1.Gcircumflex = 284;
                    e1.Gcommaaccent = 290;
                    e1.Gdot = 288;
                    e1.Gdotaccent = 288;
                    e1.Gecyrillic = 1043;
                    e1.Ghadarmenian = 1346;
                    e1.Ghemiddlehookcyrillic = 1172;
                    e1.Ghestrokecyrillic = 1170;
                    e1.Gheupturncyrillic = 1168;
                    e1.Ghook = 403;
                    e1.Gimarmenian = 1331;
                    e1.Gjecyrillic = 1027;
                    e1.Gmacron = 7712;
                    e1.Gmonospace = 65319;
                    e1.Grave = 63182;
                    e1.Gravesmall = 63328;
                    e1.Gsmall = 63335;
                    e1.Gsmallhook = 667;
                    e1.Gstroke = 484;
                    e1.H = 72;
                    e1.H18533 = 9679;
                    e1.H18543 = 9642;
                    e1.H18551 = 9643;
                    e1.H22073 = 9633;
                    e1.HPsquare = 13259;
                    e1.Haabkhasiancyrillic = 1192;
                    e1.Hadescendercyrillic = 1202;
                    e1.Hardsigncyrillic = 1066;
                    e1.Hbar = 294;
                    e1.Hbrevebelow = 7722;
                    e1.Hcedilla = 7720;
                    e1.Hcircle = 9405;
                    e1.Hcircumflex = 292;
                    e1.Hdieresis = 7718;
                    e1.Hdotaccent = 7714;
                    e1.Hdotbelow = 7716;
                    e1.Hmonospace = 65320;
                    e1.Hoarmenian = 1344;
                    e1.Horicoptic = 1e3;
                    e1.Hsmall = 63336;
                    e1.Hungarumlaut = 63183;
                    e1.Hungarumlautsmall = 63224;
                    e1.Hzsquare = 13200;
                    e1.I = 73;
                    e1.IAcyrillic = 1071;
                    e1.IJ = 306;
                    e1.IUcyrillic = 1070;
                    e1.Iacute = 205;
                    e1.Iacutesmall = 63469;
                    e1.Ibreve = 300;
                    e1.Icaron = 463;
                    e1.Icircle = 9406;
                    e1.Icircumflex = 206;
                    e1.Icircumflexsmall = 63470;
                    e1.Icyrillic = 1030;
                    e1.Idblgrave = 520;
                    e1.Idieresis = 207;
                    e1.Idieresisacute = 7726;
                    e1.Idieresiscyrillic = 1252;
                    e1.Idieresissmall = 63471;
                    e1.Idot = 304;
                    e1.Idotaccent = 304;
                    e1.Idotbelow = 7882;
                    e1.Iebrevecyrillic = 1238;
                    e1.Iecyrillic = 1045;
                    e1.Ifraktur = 8465;
                    e1.Igrave = 204;
                    e1.Igravesmall = 63468;
                    e1.Ihookabove = 7880;
                    e1.Iicyrillic = 1048;
                    e1.Iinvertedbreve = 522;
                    e1.Iishortcyrillic = 1049;
                    e1.Imacron = 298;
                    e1.Imacroncyrillic = 1250;
                    e1.Imonospace = 65321;
                    e1.Iniarmenian = 1339;
                    e1.Iocyrillic = 1025;
                    e1.Iogonek = 302;
                    e1.Iota = 921;
                    e1.Iotaafrican = 406;
                    e1.Iotadieresis = 938;
                    e1.Iotatonos = 906;
                    e1.Ismall = 63337;
                    e1.Istroke = 407;
                    e1.Itilde = 296;
                    e1.Itildebelow = 7724;
                    e1.Izhitsacyrillic = 1140;
                    e1.Izhitsadblgravecyrillic = 1142;
                    e1.J = 74;
                    e1.Jaarmenian = 1345;
                    e1.Jcircle = 9407;
                    e1.Jcircumflex = 308;
                    e1.Jecyrillic = 1032;
                    e1.Jheharmenian = 1355;
                    e1.Jmonospace = 65322;
                    e1.Jsmall = 63338;
                    e1.K = 75;
                    e1.KBsquare = 13189;
                    e1.KKsquare = 13261;
                    e1.Kabashkircyrillic = 1184;
                    e1.Kacute = 7728;
                    e1.Kacyrillic = 1050;
                    e1.Kadescendercyrillic = 1178;
                    e1.Kahookcyrillic = 1219;
                    e1.Kappa = 922;
                    e1.Kastrokecyrillic = 1182;
                    e1.Kaverticalstrokecyrillic = 1180;
                    e1.Kcaron = 488;
                    e1.Kcedilla = 310;
                    e1.Kcircle = 9408;
                    e1.Kcommaaccent = 310;
                    e1.Kdotbelow = 7730;
                    e1.Keharmenian = 1364;
                    e1.Kenarmenian = 1343;
                    e1.Khacyrillic = 1061;
                    e1.Kheicoptic = 998;
                    e1.Khook = 408;
                    e1.Kjecyrillic = 1036;
                    e1.Klinebelow = 7732;
                    e1.Kmonospace = 65323;
                    e1.Koppacyrillic = 1152;
                    e1.Koppagreek = 990;
                    e1.Ksicyrillic = 1134;
                    e1.Ksmall = 63339;
                    e1.L = 76;
                    e1.LJ = 455;
                    e1.LL = 63167;
                    e1.Lacute = 313;
                    e1.Lambda = 923;
                    e1.Lcaron = 317;
                    e1.Lcedilla = 315;
                    e1.Lcircle = 9409;
                    e1.Lcircumflexbelow = 7740;
                    e1.Lcommaaccent = 315;
                    e1.Ldot = 319;
                    e1.Ldotaccent = 319;
                    e1.Ldotbelow = 7734;
                    e1.Ldotbelowmacron = 7736;
                    e1.Liwnarmenian = 1340;
                    e1.Lj = 456;
                    e1.Ljecyrillic = 1033;
                    e1.Llinebelow = 7738;
                    e1.Lmonospace = 65324;
                    e1.Lslash = 321;
                    e1.Lslashsmall = 63225;
                    e1.Lsmall = 63340;
                    e1.M = 77;
                    e1.MBsquare = 13190;
                    e1.Macron = 63184;
                    e1.Macronsmall = 63407;
                    e1.Macute = 7742;
                    e1.Mcircle = 9410;
                    e1.Mdotaccent = 7744;
                    e1.Mdotbelow = 7746;
                    e1.Menarmenian = 1348;
                    e1.Mmonospace = 65325;
                    e1.Msmall = 63341;
                    e1.Mturned = 412;
                    e1.Mu = 924;
                    e1.N = 78;
                    e1.NJ = 458;
                    e1.Nacute = 323;
                    e1.Ncaron = 327;
                    e1.Ncedilla = 325;
                    e1.Ncircle = 9411;
                    e1.Ncircumflexbelow = 7754;
                    e1.Ncommaaccent = 325;
                    e1.Ndotaccent = 7748;
                    e1.Ndotbelow = 7750;
                    e1.Nhookleft = 413;
                    e1.Nineroman = 8552;
                    e1.Nj = 459;
                    e1.Njecyrillic = 1034;
                    e1.Nlinebelow = 7752;
                    e1.Nmonospace = 65326;
                    e1.Nowarmenian = 1350;
                    e1.Nsmall = 63342;
                    e1.Ntilde = 209;
                    e1.Ntildesmall = 63473;
                    e1.Nu = 925;
                    e1.O = 79;
                    e1.OE = 338;
                    e1.OEsmall = 63226;
                    e1.Oacute = 211;
                    e1.Oacutesmall = 63475;
                    e1.Obarredcyrillic = 1256;
                    e1.Obarreddieresiscyrillic = 1258;
                    e1.Obreve = 334;
                    e1.Ocaron = 465;
                    e1.Ocenteredtilde = 415;
                    e1.Ocircle = 9412;
                    e1.Ocircumflex = 212;
                    e1.Ocircumflexacute = 7888;
                    e1.Ocircumflexdotbelow = 7896;
                    e1.Ocircumflexgrave = 7890;
                    e1.Ocircumflexhookabove = 7892;
                    e1.Ocircumflexsmall = 63476;
                    e1.Ocircumflextilde = 7894;
                    e1.Ocyrillic = 1054;
                    e1.Odblacute = 336;
                    e1.Odblgrave = 524;
                    e1.Odieresis = 214;
                    e1.Odieresiscyrillic = 1254;
                    e1.Odieresissmall = 63478;
                    e1.Odotbelow = 7884;
                    e1.Ogoneksmall = 63227;
                    e1.Ograve = 210;
                    e1.Ogravesmall = 63474;
                    e1.Oharmenian = 1365;
                    e1.Ohm = 8486;
                    e1.Ohookabove = 7886;
                    e1.Ohorn = 416;
                    e1.Ohornacute = 7898;
                    e1.Ohorndotbelow = 7906;
                    e1.Ohorngrave = 7900;
                    e1.Ohornhookabove = 7902;
                    e1.Ohorntilde = 7904;
                    e1.Ohungarumlaut = 336;
                    e1.Oi = 418;
                    e1.Oinvertedbreve = 526;
                    e1.Omacron = 332;
                    e1.Omacronacute = 7762;
                    e1.Omacrongrave = 7760;
                    e1.Omega = 8486;
                    e1.Omegacyrillic = 1120;
                    e1.Omegagreek = 937;
                    e1.Omegaroundcyrillic = 1146;
                    e1.Omegatitlocyrillic = 1148;
                    e1.Omegatonos = 911;
                    e1.Omicron = 927;
                    e1.Omicrontonos = 908;
                    e1.Omonospace = 65327;
                    e1.Oneroman = 8544;
                    e1.Oogonek = 490;
                    e1.Oogonekmacron = 492;
                    e1.Oopen = 390;
                    e1.Oslash = 216;
                    e1.Oslashacute = 510;
                    e1.Oslashsmall = 63480;
                    e1.Osmall = 63343;
                    e1.Ostrokeacute = 510;
                    e1.Otcyrillic = 1150;
                    e1.Otilde = 213;
                    e1.Otildeacute = 7756;
                    e1.Otildedieresis = 7758;
                    e1.Otildesmall = 63477;
                    e1.P = 80;
                    e1.Pacute = 7764;
                    e1.Pcircle = 9413;
                    e1.Pdotaccent = 7766;
                    e1.Pecyrillic = 1055;
                    e1.Peharmenian = 1354;
                    e1.Pemiddlehookcyrillic = 1190;
                    e1.Phi = 934;
                    e1.Phook = 420;
                    e1.Pi = 928;
                    e1.Piwrarmenian = 1363;
                    e1.Pmonospace = 65328;
                    e1.Psi = 936;
                    e1.Psicyrillic = 1136;
                    e1.Psmall = 63344;
                    e1.Q = 81;
                    e1.Qcircle = 9414;
                    e1.Qmonospace = 65329;
                    e1.Qsmall = 63345;
                    e1.R = 82;
                    e1.Raarmenian = 1356;
                    e1.Racute = 340;
                    e1.Rcaron = 344;
                    e1.Rcedilla = 342;
                    e1.Rcircle = 9415;
                    e1.Rcommaaccent = 342;
                    e1.Rdblgrave = 528;
                    e1.Rdotaccent = 7768;
                    e1.Rdotbelow = 7770;
                    e1.Rdotbelowmacron = 7772;
                    e1.Reharmenian = 1360;
                    e1.Rfraktur = 8476;
                    e1.Rho = 929;
                    e1.Ringsmall = 63228;
                    e1.Rinvertedbreve = 530;
                    e1.Rlinebelow = 7774;
                    e1.Rmonospace = 65330;
                    e1.Rsmall = 63346;
                    e1.Rsmallinverted = 641;
                    e1.Rsmallinvertedsuperior = 694;
                    e1.S = 83;
                    e1.SF010000 = 9484;
                    e1.SF020000 = 9492;
                    e1.SF030000 = 9488;
                    e1.SF040000 = 9496;
                    e1.SF050000 = 9532;
                    e1.SF060000 = 9516;
                    e1.SF070000 = 9524;
                    e1.SF080000 = 9500;
                    e1.SF090000 = 9508;
                    e1.SF100000 = 9472;
                    e1.SF110000 = 9474;
                    e1.SF190000 = 9569;
                    e1.SF200000 = 9570;
                    e1.SF210000 = 9558;
                    e1.SF220000 = 9557;
                    e1.SF230000 = 9571;
                    e1.SF240000 = 9553;
                    e1.SF250000 = 9559;
                    e1.SF260000 = 9565;
                    e1.SF270000 = 9564;
                    e1.SF280000 = 9563;
                    e1.SF360000 = 9566;
                    e1.SF370000 = 9567;
                    e1.SF380000 = 9562;
                    e1.SF390000 = 9556;
                    e1.SF400000 = 9577;
                    e1.SF410000 = 9574;
                    e1.SF420000 = 9568;
                    e1.SF430000 = 9552;
                    e1.SF440000 = 9580;
                    e1.SF450000 = 9575;
                    e1.SF460000 = 9576;
                    e1.SF470000 = 9572;
                    e1.SF480000 = 9573;
                    e1.SF490000 = 9561;
                    e1.SF500000 = 9560;
                    e1.SF510000 = 9554;
                    e1.SF520000 = 9555;
                    e1.SF530000 = 9579;
                    e1.SF540000 = 9578;
                    e1.Sacute = 346;
                    e1.Sacutedotaccent = 7780;
                    e1.Sampigreek = 992;
                    e1.Scaron = 352;
                    e1.Scarondotaccent = 7782;
                    e1.Scaronsmall = 63229;
                    e1.Scedilla = 350;
                    e1.Schwa = 399;
                    e1.Schwacyrillic = 1240;
                    e1.Schwadieresiscyrillic = 1242;
                    e1.Scircle = 9416;
                    e1.Scircumflex = 348;
                    e1.Scommaaccent = 536;
                    e1.Sdotaccent = 7776;
                    e1.Sdotbelow = 7778;
                    e1.Sdotbelowdotaccent = 7784;
                    e1.Seharmenian = 1357;
                    e1.Sevenroman = 8550;
                    e1.Shaarmenian = 1351;
                    e1.Shacyrillic = 1064;
                    e1.Shchacyrillic = 1065;
                    e1.Sheicoptic = 994;
                    e1.Shhacyrillic = 1210;
                    e1.Shimacoptic = 1004;
                    e1.Sigma = 931;
                    e1.Sixroman = 8549;
                    e1.Smonospace = 65331;
                    e1.Softsigncyrillic = 1068;
                    e1.Ssmall = 63347;
                    e1.Stigmagreek = 986;
                    e1.T = 84;
                    e1.Tau = 932;
                    e1.Tbar = 358;
                    e1.Tcaron = 356;
                    e1.Tcedilla = 354;
                    e1.Tcircle = 9417;
                    e1.Tcircumflexbelow = 7792;
                    e1.Tcommaaccent = 354;
                    e1.Tdotaccent = 7786;
                    e1.Tdotbelow = 7788;
                    e1.Tecyrillic = 1058;
                    e1.Tedescendercyrillic = 1196;
                    e1.Tenroman = 8553;
                    e1.Tetsecyrillic = 1204;
                    e1.Theta = 920;
                    e1.Thook = 428;
                    e1.Thorn = 222;
                    e1.Thornsmall = 63486;
                    e1.Threeroman = 8546;
                    e1.Tildesmall = 63230;
                    e1.Tiwnarmenian = 1359;
                    e1.Tlinebelow = 7790;
                    e1.Tmonospace = 65332;
                    e1.Toarmenian = 1337;
                    e1.Tonefive = 444;
                    e1.Tonesix = 388;
                    e1.Tonetwo = 423;
                    e1.Tretroflexhook = 430;
                    e1.Tsecyrillic = 1062;
                    e1.Tshecyrillic = 1035;
                    e1.Tsmall = 63348;
                    e1.Twelveroman = 8555;
                    e1.Tworoman = 8545;
                    e1.U = 85;
                    e1.Uacute = 218;
                    e1.Uacutesmall = 63482;
                    e1.Ubreve = 364;
                    e1.Ucaron = 467;
                    e1.Ucircle = 9418;
                    e1.Ucircumflex = 219;
                    e1.Ucircumflexbelow = 7798;
                    e1.Ucircumflexsmall = 63483;
                    e1.Ucyrillic = 1059;
                    e1.Udblacute = 368;
                    e1.Udblgrave = 532;
                    e1.Udieresis = 220;
                    e1.Udieresisacute = 471;
                    e1.Udieresisbelow = 7794;
                    e1.Udieresiscaron = 473;
                    e1.Udieresiscyrillic = 1264;
                    e1.Udieresisgrave = 475;
                    e1.Udieresismacron = 469;
                    e1.Udieresissmall = 63484;
                    e1.Udotbelow = 7908;
                    e1.Ugrave = 217;
                    e1.Ugravesmall = 63481;
                    e1.Uhookabove = 7910;
                    e1.Uhorn = 431;
                    e1.Uhornacute = 7912;
                    e1.Uhorndotbelow = 7920;
                    e1.Uhorngrave = 7914;
                    e1.Uhornhookabove = 7916;
                    e1.Uhorntilde = 7918;
                    e1.Uhungarumlaut = 368;
                    e1.Uhungarumlautcyrillic = 1266;
                    e1.Uinvertedbreve = 534;
                    e1.Ukcyrillic = 1144;
                    e1.Umacron = 362;
                    e1.Umacroncyrillic = 1262;
                    e1.Umacrondieresis = 7802;
                    e1.Umonospace = 65333;
                    e1.Uogonek = 370;
                    e1.Upsilon = 933;
                    e1.Upsilon1 = 978;
                    e1.Upsilonacutehooksymbolgreek = 979;
                    e1.Upsilonafrican = 433;
                    e1.Upsilondieresis = 939;
                    e1.Upsilondieresishooksymbolgreek = 980;
                    e1.Upsilonhooksymbol = 978;
                    e1.Upsilontonos = 910;
                    e1.Uring = 366;
                    e1.Ushortcyrillic = 1038;
                    e1.Usmall = 63349;
                    e1.Ustraightcyrillic = 1198;
                    e1.Ustraightstrokecyrillic = 1200;
                    e1.Utilde = 360;
                    e1.Utildeacute = 7800;
                    e1.Utildebelow = 7796;
                    e1.V = 86;
                    e1.Vcircle = 9419;
                    e1.Vdotbelow = 7806;
                    e1.Vecyrillic = 1042;
                    e1.Vewarmenian = 1358;
                    e1.Vhook = 434;
                    e1.Vmonospace = 65334;
                    e1.Voarmenian = 1352;
                    e1.Vsmall = 63350;
                    e1.Vtilde = 7804;
                    e1.W = 87;
                    e1.Wacute = 7810;
                    e1.Wcircle = 9420;
                    e1.Wcircumflex = 372;
                    e1.Wdieresis = 7812;
                    e1.Wdotaccent = 7814;
                    e1.Wdotbelow = 7816;
                    e1.Wgrave = 7808;
                    e1.Wmonospace = 65335;
                    e1.Wsmall = 63351;
                    e1.X = 88;
                    e1.Xcircle = 9421;
                    e1.Xdieresis = 7820;
                    e1.Xdotaccent = 7818;
                    e1.Xeharmenian = 1341;
                    e1.Xi = 926;
                    e1.Xmonospace = 65336;
                    e1.Xsmall = 63352;
                    e1.Y = 89;
                    e1.Yacute = 221;
                    e1.Yacutesmall = 63485;
                    e1.Yatcyrillic = 1122;
                    e1.Ycircle = 9422;
                    e1.Ycircumflex = 374;
                    e1.Ydieresis = 376;
                    e1.Ydieresissmall = 63487;
                    e1.Ydotaccent = 7822;
                    e1.Ydotbelow = 7924;
                    e1.Yericyrillic = 1067;
                    e1.Yerudieresiscyrillic = 1272;
                    e1.Ygrave = 7922;
                    e1.Yhook = 435;
                    e1.Yhookabove = 7926;
                    e1.Yiarmenian = 1349;
                    e1.Yicyrillic = 1031;
                    e1.Yiwnarmenian = 1362;
                    e1.Ymonospace = 65337;
                    e1.Ysmall = 63353;
                    e1.Ytilde = 7928;
                    e1.Yusbigcyrillic = 1130;
                    e1.Yusbigiotifiedcyrillic = 1132;
                    e1.Yuslittlecyrillic = 1126;
                    e1.Yuslittleiotifiedcyrillic = 1128;
                    e1.Z = 90;
                    e1.Zaarmenian = 1334;
                    e1.Zacute = 377;
                    e1.Zcaron = 381;
                    e1.Zcaronsmall = 63231;
                    e1.Zcircle = 9423;
                    e1.Zcircumflex = 7824;
                    e1.Zdot = 379;
                    e1.Zdotaccent = 379;
                    e1.Zdotbelow = 7826;
                    e1.Zecyrillic = 1047;
                    e1.Zedescendercyrillic = 1176;
                    e1.Zedieresiscyrillic = 1246;
                    e1.Zeta = 918;
                    e1.Zhearmenian = 1338;
                    e1.Zhebrevecyrillic = 1217;
                    e1.Zhecyrillic = 1046;
                    e1.Zhedescendercyrillic = 1174;
                    e1.Zhedieresiscyrillic = 1244;
                    e1.Zlinebelow = 7828;
                    e1.Zmonospace = 65338;
                    e1.Zsmall = 63354;
                    e1.Zstroke = 437;
                    e1.a = 97;
                    e1.aabengali = 2438;
                    e1.aacute = 225;
                    e1.aadeva = 2310;
                    e1.aagujarati = 2694;
                    e1.aagurmukhi = 2566;
                    e1.aamatragurmukhi = 2622;
                    e1.aarusquare = 13059;
                    e1.aavowelsignbengali = 2494;
                    e1.aavowelsigndeva = 2366;
                    e1.aavowelsigngujarati = 2750;
                    e1.abbreviationmarkarmenian = 1375;
                    e1.abbreviationsigndeva = 2416;
                    e1.abengali = 2437;
                    e1.abopomofo = 12570;
                    e1.abreve = 259;
                    e1.abreveacute = 7855;
                    e1.abrevecyrillic = 1233;
                    e1.abrevedotbelow = 7863;
                    e1.abrevegrave = 7857;
                    e1.abrevehookabove = 7859;
                    e1.abrevetilde = 7861;
                    e1.acaron = 462;
                    e1.acircle = 9424;
                    e1.acircumflex = 226;
                    e1.acircumflexacute = 7845;
                    e1.acircumflexdotbelow = 7853;
                    e1.acircumflexgrave = 7847;
                    e1.acircumflexhookabove = 7849;
                    e1.acircumflextilde = 7851;
                    e1.acute = 180;
                    e1.acutebelowcmb = 791;
                    e1.acutecmb = 769;
                    e1.acutecomb = 769;
                    e1.acutedeva = 2388;
                    e1.acutelowmod = 719;
                    e1.acutetonecmb = 833;
                    e1.acyrillic = 1072;
                    e1.adblgrave = 513;
                    e1.addakgurmukhi = 2673;
                    e1.adeva = 2309;
                    e1.adieresis = 228;
                    e1.adieresiscyrillic = 1235;
                    e1.adieresismacron = 479;
                    e1.adotbelow = 7841;
                    e1.adotmacron = 481;
                    e1.ae = 230;
                    e1.aeacute = 509;
                    e1.aekorean = 12624;
                    e1.aemacron = 483;
                    e1.afii00208 = 8213;
                    e1.afii08941 = 8356;
                    e1.afii10017 = 1040;
                    e1.afii10018 = 1041;
                    e1.afii10019 = 1042;
                    e1.afii10020 = 1043;
                    e1.afii10021 = 1044;
                    e1.afii10022 = 1045;
                    e1.afii10023 = 1025;
                    e1.afii10024 = 1046;
                    e1.afii10025 = 1047;
                    e1.afii10026 = 1048;
                    e1.afii10027 = 1049;
                    e1.afii10028 = 1050;
                    e1.afii10029 = 1051;
                    e1.afii10030 = 1052;
                    e1.afii10031 = 1053;
                    e1.afii10032 = 1054;
                    e1.afii10033 = 1055;
                    e1.afii10034 = 1056;
                    e1.afii10035 = 1057;
                    e1.afii10036 = 1058;
                    e1.afii10037 = 1059;
                    e1.afii10038 = 1060;
                    e1.afii10039 = 1061;
                    e1.afii10040 = 1062;
                    e1.afii10041 = 1063;
                    e1.afii10042 = 1064;
                    e1.afii10043 = 1065;
                    e1.afii10044 = 1066;
                    e1.afii10045 = 1067;
                    e1.afii10046 = 1068;
                    e1.afii10047 = 1069;
                    e1.afii10048 = 1070;
                    e1.afii10049 = 1071;
                    e1.afii10050 = 1168;
                    e1.afii10051 = 1026;
                    e1.afii10052 = 1027;
                    e1.afii10053 = 1028;
                    e1.afii10054 = 1029;
                    e1.afii10055 = 1030;
                    e1.afii10056 = 1031;
                    e1.afii10057 = 1032;
                    e1.afii10058 = 1033;
                    e1.afii10059 = 1034;
                    e1.afii10060 = 1035;
                    e1.afii10061 = 1036;
                    e1.afii10062 = 1038;
                    e1.afii10063 = 63172;
                    e1.afii10064 = 63173;
                    e1.afii10065 = 1072;
                    e1.afii10066 = 1073;
                    e1.afii10067 = 1074;
                    e1.afii10068 = 1075;
                    e1.afii10069 = 1076;
                    e1.afii10070 = 1077;
                    e1.afii10071 = 1105;
                    e1.afii10072 = 1078;
                    e1.afii10073 = 1079;
                    e1.afii10074 = 1080;
                    e1.afii10075 = 1081;
                    e1.afii10076 = 1082;
                    e1.afii10077 = 1083;
                    e1.afii10078 = 1084;
                    e1.afii10079 = 1085;
                    e1.afii10080 = 1086;
                    e1.afii10081 = 1087;
                    e1.afii10082 = 1088;
                    e1.afii10083 = 1089;
                    e1.afii10084 = 1090;
                    e1.afii10085 = 1091;
                    e1.afii10086 = 1092;
                    e1.afii10087 = 1093;
                    e1.afii10088 = 1094;
                    e1.afii10089 = 1095;
                    e1.afii10090 = 1096;
                    e1.afii10091 = 1097;
                    e1.afii10092 = 1098;
                    e1.afii10093 = 1099;
                    e1.afii10094 = 1100;
                    e1.afii10095 = 1101;
                    e1.afii10096 = 1102;
                    e1.afii10097 = 1103;
                    e1.afii10098 = 1169;
                    e1.afii10099 = 1106;
                    e1.afii10100 = 1107;
                    e1.afii10101 = 1108;
                    e1.afii10102 = 1109;
                    e1.afii10103 = 1110;
                    e1.afii10104 = 1111;
                    e1.afii10105 = 1112;
                    e1.afii10106 = 1113;
                    e1.afii10107 = 1114;
                    e1.afii10108 = 1115;
                    e1.afii10109 = 1116;
                    e1.afii10110 = 1118;
                    e1.afii10145 = 1039;
                    e1.afii10146 = 1122;
                    e1.afii10147 = 1138;
                    e1.afii10148 = 1140;
                    e1.afii10192 = 63174;
                    e1.afii10193 = 1119;
                    e1.afii10194 = 1123;
                    e1.afii10195 = 1139;
                    e1.afii10196 = 1141;
                    e1.afii10831 = 63175;
                    e1.afii10832 = 63176;
                    e1.afii10846 = 1241;
                    e1.afii299 = 8206;
                    e1.afii300 = 8207;
                    e1.afii301 = 8205;
                    e1.afii57381 = 1642;
                    e1.afii57388 = 1548;
                    e1.afii57392 = 1632;
                    e1.afii57393 = 1633;
                    e1.afii57394 = 1634;
                    e1.afii57395 = 1635;
                    e1.afii57396 = 1636;
                    e1.afii57397 = 1637;
                    e1.afii57398 = 1638;
                    e1.afii57399 = 1639;
                    e1.afii57400 = 1640;
                    e1.afii57401 = 1641;
                    e1.afii57403 = 1563;
                    e1.afii57407 = 1567;
                    e1.afii57409 = 1569;
                    e1.afii57410 = 1570;
                    e1.afii57411 = 1571;
                    e1.afii57412 = 1572;
                    e1.afii57413 = 1573;
                    e1.afii57414 = 1574;
                    e1.afii57415 = 1575;
                    e1.afii57416 = 1576;
                    e1.afii57417 = 1577;
                    e1.afii57418 = 1578;
                    e1.afii57419 = 1579;
                    e1.afii57420 = 1580;
                    e1.afii57421 = 1581;
                    e1.afii57422 = 1582;
                    e1.afii57423 = 1583;
                    e1.afii57424 = 1584;
                    e1.afii57425 = 1585;
                    e1.afii57426 = 1586;
                    e1.afii57427 = 1587;
                    e1.afii57428 = 1588;
                    e1.afii57429 = 1589;
                    e1.afii57430 = 1590;
                    e1.afii57431 = 1591;
                    e1.afii57432 = 1592;
                    e1.afii57433 = 1593;
                    e1.afii57434 = 1594;
                    e1.afii57440 = 1600;
                    e1.afii57441 = 1601;
                    e1.afii57442 = 1602;
                    e1.afii57443 = 1603;
                    e1.afii57444 = 1604;
                    e1.afii57445 = 1605;
                    e1.afii57446 = 1606;
                    e1.afii57448 = 1608;
                    e1.afii57449 = 1609;
                    e1.afii57450 = 1610;
                    e1.afii57451 = 1611;
                    e1.afii57452 = 1612;
                    e1.afii57453 = 1613;
                    e1.afii57454 = 1614;
                    e1.afii57455 = 1615;
                    e1.afii57456 = 1616;
                    e1.afii57457 = 1617;
                    e1.afii57458 = 1618;
                    e1.afii57470 = 1607;
                    e1.afii57505 = 1700;
                    e1.afii57506 = 1662;
                    e1.afii57507 = 1670;
                    e1.afii57508 = 1688;
                    e1.afii57509 = 1711;
                    e1.afii57511 = 1657;
                    e1.afii57512 = 1672;
                    e1.afii57513 = 1681;
                    e1.afii57514 = 1722;
                    e1.afii57519 = 1746;
                    e1.afii57534 = 1749;
                    e1.afii57636 = 8362;
                    e1.afii57645 = 1470;
                    e1.afii57658 = 1475;
                    e1.afii57664 = 1488;
                    e1.afii57665 = 1489;
                    e1.afii57666 = 1490;
                    e1.afii57667 = 1491;
                    e1.afii57668 = 1492;
                    e1.afii57669 = 1493;
                    e1.afii57670 = 1494;
                    e1.afii57671 = 1495;
                    e1.afii57672 = 1496;
                    e1.afii57673 = 1497;
                    e1.afii57674 = 1498;
                    e1.afii57675 = 1499;
                    e1.afii57676 = 1500;
                    e1.afii57677 = 1501;
                    e1.afii57678 = 1502;
                    e1.afii57679 = 1503;
                    e1.afii57680 = 1504;
                    e1.afii57681 = 1505;
                    e1.afii57682 = 1506;
                    e1.afii57683 = 1507;
                    e1.afii57684 = 1508;
                    e1.afii57685 = 1509;
                    e1.afii57686 = 1510;
                    e1.afii57687 = 1511;
                    e1.afii57688 = 1512;
                    e1.afii57689 = 1513;
                    e1.afii57690 = 1514;
                    e1.afii57694 = 64298;
                    e1.afii57695 = 64299;
                    e1.afii57700 = 64331;
                    e1.afii57705 = 64287;
                    e1.afii57716 = 1520;
                    e1.afii57717 = 1521;
                    e1.afii57718 = 1522;
                    e1.afii57723 = 64309;
                    e1.afii57793 = 1460;
                    e1.afii57794 = 1461;
                    e1.afii57795 = 1462;
                    e1.afii57796 = 1467;
                    e1.afii57797 = 1464;
                    e1.afii57798 = 1463;
                    e1.afii57799 = 1456;
                    e1.afii57800 = 1458;
                    e1.afii57801 = 1457;
                    e1.afii57802 = 1459;
                    e1.afii57803 = 1474;
                    e1.afii57804 = 1473;
                    e1.afii57806 = 1465;
                    e1.afii57807 = 1468;
                    e1.afii57839 = 1469;
                    e1.afii57841 = 1471;
                    e1.afii57842 = 1472;
                    e1.afii57929 = 700;
                    e1.afii61248 = 8453;
                    e1.afii61289 = 8467;
                    e1.afii61352 = 8470;
                    e1.afii61573 = 8236;
                    e1.afii61574 = 8237;
                    e1.afii61575 = 8238;
                    e1.afii61664 = 8204;
                    e1.afii63167 = 1645;
                    e1.afii64937 = 701;
                    e1.agrave = 224;
                    e1.agujarati = 2693;
                    e1.agurmukhi = 2565;
                    e1.ahiragana = 12354;
                    e1.ahookabove = 7843;
                    e1.aibengali = 2448;
                    e1.aibopomofo = 12574;
                    e1.aideva = 2320;
                    e1.aiecyrillic = 1237;
                    e1.aigujarati = 2704;
                    e1.aigurmukhi = 2576;
                    e1.aimatragurmukhi = 2632;
                    e1.ainarabic = 1593;
                    e1.ainfinalarabic = 65226;
                    e1.aininitialarabic = 65227;
                    e1.ainmedialarabic = 65228;
                    e1.ainvertedbreve = 515;
                    e1.aivowelsignbengali = 2504;
                    e1.aivowelsigndeva = 2376;
                    e1.aivowelsigngujarati = 2760;
                    e1.akatakana = 12450;
                    e1.akatakanahalfwidth = 65393;
                    e1.akorean = 12623;
                    e1.alef = 1488;
                    e1.alefarabic = 1575;
                    e1.alefdageshhebrew = 64304;
                    e1.aleffinalarabic = 65166;
                    e1.alefhamzaabovearabic = 1571;
                    e1.alefhamzaabovefinalarabic = 65156;
                    e1.alefhamzabelowarabic = 1573;
                    e1.alefhamzabelowfinalarabic = 65160;
                    e1.alefhebrew = 1488;
                    e1.aleflamedhebrew = 64335;
                    e1.alefmaddaabovearabic = 1570;
                    e1.alefmaddaabovefinalarabic = 65154;
                    e1.alefmaksuraarabic = 1609;
                    e1.alefmaksurafinalarabic = 65264;
                    e1.alefmaksurainitialarabic = 65267;
                    e1.alefmaksuramedialarabic = 65268;
                    e1.alefpatahhebrew = 64302;
                    e1.alefqamatshebrew = 64303;
                    e1.aleph = 8501;
                    e1.allequal = 8780;
                    e1.alpha = 945;
                    e1.alphatonos = 940;
                    e1.amacron = 257;
                    e1.amonospace = 65345;
                    e1.ampersand = 38;
                    e1.ampersandmonospace = 65286;
                    e1.ampersandsmall = 63270;
                    e1.amsquare = 13250;
                    e1.anbopomofo = 12578;
                    e1.angbopomofo = 12580;
                    e1.angbracketleft = 12296;
                    e1.angbracketright = 12297;
                    e1.angkhankhuthai = 3674;
                    e1.angle = 8736;
                    e1.anglebracketleft = 12296;
                    e1.anglebracketleftvertical = 65087;
                    e1.anglebracketright = 12297;
                    e1.anglebracketrightvertical = 65088;
                    e1.angleleft = 9001;
                    e1.angleright = 9002;
                    e1.angstrom = 8491;
                    e1.anoteleia = 903;
                    e1.anudattadeva = 2386;
                    e1.anusvarabengali = 2434;
                    e1.anusvaradeva = 2306;
                    e1.anusvaragujarati = 2690;
                    e1.aogonek = 261;
                    e1.apaatosquare = 13056;
                    e1.aparen = 9372;
                    e1.apostrophearmenian = 1370;
                    e1.apostrophemod = 700;
                    e1.apple = 63743;
                    e1.approaches = 8784;
                    e1.approxequal = 8776;
                    e1.approxequalorimage = 8786;
                    e1.approximatelyequal = 8773;
                    e1.araeaekorean = 12686;
                    e1.araeakorean = 12685;
                    e1.arc = 8978;
                    e1.arighthalfring = 7834;
                    e1.aring = 229;
                    e1.aringacute = 507;
                    e1.aringbelow = 7681;
                    e1.arrowboth = 8596;
                    e1.arrowdashdown = 8675;
                    e1.arrowdashleft = 8672;
                    e1.arrowdashright = 8674;
                    e1.arrowdashup = 8673;
                    e1.arrowdblboth = 8660;
                    e1.arrowdbldown = 8659;
                    e1.arrowdblleft = 8656;
                    e1.arrowdblright = 8658;
                    e1.arrowdblup = 8657;
                    e1.arrowdown = 8595;
                    e1.arrowdownleft = 8601;
                    e1.arrowdownright = 8600;
                    e1.arrowdownwhite = 8681;
                    e1.arrowheaddownmod = 709;
                    e1.arrowheadleftmod = 706;
                    e1.arrowheadrightmod = 707;
                    e1.arrowheadupmod = 708;
                    e1.arrowhorizex = 63719;
                    e1.arrowleft = 8592;
                    e1.arrowleftdbl = 8656;
                    e1.arrowleftdblstroke = 8653;
                    e1.arrowleftoverright = 8646;
                    e1.arrowleftwhite = 8678;
                    e1.arrowright = 8594;
                    e1.arrowrightdblstroke = 8655;
                    e1.arrowrightheavy = 10142;
                    e1.arrowrightoverleft = 8644;
                    e1.arrowrightwhite = 8680;
                    e1.arrowtableft = 8676;
                    e1.arrowtabright = 8677;
                    e1.arrowup = 8593;
                    e1.arrowupdn = 8597;
                    e1.arrowupdnbse = 8616;
                    e1.arrowupdownbase = 8616;
                    e1.arrowupleft = 8598;
                    e1.arrowupleftofdown = 8645;
                    e1.arrowupright = 8599;
                    e1.arrowupwhite = 8679;
                    e1.arrowvertex = 63718;
                    e1.asciicircum = 94;
                    e1.asciicircummonospace = 65342;
                    e1.asciitilde = 126;
                    e1.asciitildemonospace = 65374;
                    e1.ascript = 593;
                    e1.ascriptturned = 594;
                    e1.asmallhiragana = 12353;
                    e1.asmallkatakana = 12449;
                    e1.asmallkatakanahalfwidth = 65383;
                    e1.asterisk = 42;
                    e1.asteriskaltonearabic = 1645;
                    e1.asteriskarabic = 1645;
                    e1.asteriskmath = 8727;
                    e1.asteriskmonospace = 65290;
                    e1.asterisksmall = 65121;
                    e1.asterism = 8258;
                    e1.asuperior = 63209;
                    e1.asymptoticallyequal = 8771;
                    e1.at = 64;
                    e1.atilde = 227;
                    e1.atmonospace = 65312;
                    e1.atsmall = 65131;
                    e1.aturned = 592;
                    e1.aubengali = 2452;
                    e1.aubopomofo = 12576;
                    e1.audeva = 2324;
                    e1.augujarati = 2708;
                    e1.augurmukhi = 2580;
                    e1.aulengthmarkbengali = 2519;
                    e1.aumatragurmukhi = 2636;
                    e1.auvowelsignbengali = 2508;
                    e1.auvowelsigndeva = 2380;
                    e1.auvowelsigngujarati = 2764;
                    e1.avagrahadeva = 2365;
                    e1.aybarmenian = 1377;
                    e1.ayin = 1506;
                    e1.ayinaltonehebrew = 64288;
                    e1.ayinhebrew = 1506;
                    e1.b = 98;
                    e1.babengali = 2476;
                    e1.backslash = 92;
                    e1.backslashmonospace = 65340;
                    e1.badeva = 2348;
                    e1.bagujarati = 2732;
                    e1.bagurmukhi = 2604;
                    e1.bahiragana = 12400;
                    e1.bahtthai = 3647;
                    e1.bakatakana = 12496;
                    e1.bar = 124;
                    e1.barmonospace = 65372;
                    e1.bbopomofo = 12549;
                    e1.bcircle = 9425;
                    e1.bdotaccent = 7683;
                    e1.bdotbelow = 7685;
                    e1.beamedsixteenthnotes = 9836;
                    e1.because = 8757;
                    e1.becyrillic = 1073;
                    e1.beharabic = 1576;
                    e1.behfinalarabic = 65168;
                    e1.behinitialarabic = 65169;
                    e1.behiragana = 12409;
                    e1.behmedialarabic = 65170;
                    e1.behmeeminitialarabic = 64671;
                    e1.behmeemisolatedarabic = 64520;
                    e1.behnoonfinalarabic = 64621;
                    e1.bekatakana = 12505;
                    e1.benarmenian = 1378;
                    e1.bet = 1489;
                    e1.beta = 946;
                    e1.betasymbolgreek = 976;
                    e1.betdagesh = 64305;
                    e1.betdageshhebrew = 64305;
                    e1.bethebrew = 1489;
                    e1.betrafehebrew = 64332;
                    e1.bhabengali = 2477;
                    e1.bhadeva = 2349;
                    e1.bhagujarati = 2733;
                    e1.bhagurmukhi = 2605;
                    e1.bhook = 595;
                    e1.bihiragana = 12403;
                    e1.bikatakana = 12499;
                    e1.bilabialclick = 664;
                    e1.bindigurmukhi = 2562;
                    e1.birusquare = 13105;
                    e1.blackcircle = 9679;
                    e1.blackdiamond = 9670;
                    e1.blackdownpointingtriangle = 9660;
                    e1.blackleftpointingpointer = 9668;
                    e1.blackleftpointingtriangle = 9664;
                    e1.blacklenticularbracketleft = 12304;
                    e1.blacklenticularbracketleftvertical = 65083;
                    e1.blacklenticularbracketright = 12305;
                    e1.blacklenticularbracketrightvertical = 65084;
                    e1.blacklowerlefttriangle = 9699;
                    e1.blacklowerrighttriangle = 9698;
                    e1.blackrectangle = 9644;
                    e1.blackrightpointingpointer = 9658;
                    e1.blackrightpointingtriangle = 9654;
                    e1.blacksmallsquare = 9642;
                    e1.blacksmilingface = 9787;
                    e1.blacksquare = 9632;
                    e1.blackstar = 9733;
                    e1.blackupperlefttriangle = 9700;
                    e1.blackupperrighttriangle = 9701;
                    e1.blackuppointingsmalltriangle = 9652;
                    e1.blackuppointingtriangle = 9650;
                    e1.blank = 9251;
                    e1.blinebelow = 7687;
                    e1.block = 9608;
                    e1.bmonospace = 65346;
                    e1.bobaimaithai = 3610;
                    e1.bohiragana = 12412;
                    e1.bokatakana = 12508;
                    e1.bparen = 9373;
                    e1.bqsquare = 13251;
                    e1.braceex = 63732;
                    e1.braceleft = 123;
                    e1.braceleftbt = 63731;
                    e1.braceleftmid = 63730;
                    e1.braceleftmonospace = 65371;
                    e1.braceleftsmall = 65115;
                    e1.bracelefttp = 63729;
                    e1.braceleftvertical = 65079;
                    e1.braceright = 125;
                    e1.bracerightbt = 63742;
                    e1.bracerightmid = 63741;
                    e1.bracerightmonospace = 65373;
                    e1.bracerightsmall = 65116;
                    e1.bracerighttp = 63740;
                    e1.bracerightvertical = 65080;
                    e1.bracketleft = 91;
                    e1.bracketleftbt = 63728;
                    e1.bracketleftex = 63727;
                    e1.bracketleftmonospace = 65339;
                    e1.bracketlefttp = 63726;
                    e1.bracketright = 93;
                    e1.bracketrightbt = 63739;
                    e1.bracketrightex = 63738;
                    e1.bracketrightmonospace = 65341;
                    e1.bracketrighttp = 63737;
                    e1.breve = 728;
                    e1.brevebelowcmb = 814;
                    e1.brevecmb = 774;
                    e1.breveinvertedbelowcmb = 815;
                    e1.breveinvertedcmb = 785;
                    e1.breveinverteddoublecmb = 865;
                    e1.bridgebelowcmb = 810;
                    e1.bridgeinvertedbelowcmb = 826;
                    e1.brokenbar = 166;
                    e1.bstroke = 384;
                    e1.bsuperior = 63210;
                    e1.btopbar = 387;
                    e1.buhiragana = 12406;
                    e1.bukatakana = 12502;
                    e1.bullet = 8226;
                    e1.bulletinverse = 9688;
                    e1.bulletoperator = 8729;
                    e1.bullseye = 9678;
                    e1.c = 99;
                    e1.caarmenian = 1390;
                    e1.cabengali = 2458;
                    e1.cacute = 263;
                    e1.cadeva = 2330;
                    e1.cagujarati = 2714;
                    e1.cagurmukhi = 2586;
                    e1.calsquare = 13192;
                    e1.candrabindubengali = 2433;
                    e1.candrabinducmb = 784;
                    e1.candrabindudeva = 2305;
                    e1.candrabindugujarati = 2689;
                    e1.capslock = 8682;
                    e1.careof = 8453;
                    e1.caron = 711;
                    e1.caronbelowcmb = 812;
                    e1.caroncmb = 780;
                    e1.carriagereturn = 8629;
                    e1.cbopomofo = 12568;
                    e1.ccaron = 269;
                    e1.ccedilla = 231;
                    e1.ccedillaacute = 7689;
                    e1.ccircle = 9426;
                    e1.ccircumflex = 265;
                    e1.ccurl = 597;
                    e1.cdot = 267;
                    e1.cdotaccent = 267;
                    e1.cdsquare = 13253;
                    e1.cedilla = 184;
                    e1.cedillacmb = 807;
                    e1.cent = 162;
                    e1.centigrade = 8451;
                    e1.centinferior = 63199;
                    e1.centmonospace = 65504;
                    e1.centoldstyle = 63394;
                    e1.centsuperior = 63200;
                    e1.chaarmenian = 1401;
                    e1.chabengali = 2459;
                    e1.chadeva = 2331;
                    e1.chagujarati = 2715;
                    e1.chagurmukhi = 2587;
                    e1.chbopomofo = 12564;
                    e1.cheabkhasiancyrillic = 1213;
                    e1.checkmark = 10003;
                    e1.checyrillic = 1095;
                    e1.chedescenderabkhasiancyrillic = 1215;
                    e1.chedescendercyrillic = 1207;
                    e1.chedieresiscyrillic = 1269;
                    e1.cheharmenian = 1395;
                    e1.chekhakassiancyrillic = 1228;
                    e1.cheverticalstrokecyrillic = 1209;
                    e1.chi = 967;
                    e1.chieuchacirclekorean = 12919;
                    e1.chieuchaparenkorean = 12823;
                    e1.chieuchcirclekorean = 12905;
                    e1.chieuchkorean = 12618;
                    e1.chieuchparenkorean = 12809;
                    e1.chochangthai = 3594;
                    e1.chochanthai = 3592;
                    e1.chochingthai = 3593;
                    e1.chochoethai = 3596;
                    e1.chook = 392;
                    e1.cieucacirclekorean = 12918;
                    e1.cieucaparenkorean = 12822;
                    e1.cieuccirclekorean = 12904;
                    e1.cieuckorean = 12616;
                    e1.cieucparenkorean = 12808;
                    e1.cieucuparenkorean = 12828;
                    e1.circle = 9675;
                    e1.circlecopyrt = 169;
                    e1.circlemultiply = 8855;
                    e1.circleot = 8857;
                    e1.circleplus = 8853;
                    e1.circlepostalmark = 12342;
                    e1.circlewithlefthalfblack = 9680;
                    e1.circlewithrighthalfblack = 9681;
                    e1.circumflex = 710;
                    e1.circumflexbelowcmb = 813;
                    e1.circumflexcmb = 770;
                    e1.clear = 8999;
                    e1.clickalveolar = 450;
                    e1.clickdental = 448;
                    e1.clicklateral = 449;
                    e1.clickretroflex = 451;
                    e1.club = 9827;
                    e1.clubsuitblack = 9827;
                    e1.clubsuitwhite = 9831;
                    e1.cmcubedsquare = 13220;
                    e1.cmonospace = 65347;
                    e1.cmsquaredsquare = 13216;
                    e1.coarmenian = 1409;
                    e1.colon = 58;
                    e1.colonmonetary = 8353;
                    e1.colonmonospace = 65306;
                    e1.colonsign = 8353;
                    e1.colonsmall = 65109;
                    e1.colontriangularhalfmod = 721;
                    e1.colontriangularmod = 720;
                    e1.comma = 44;
                    e1.commaabovecmb = 787;
                    e1.commaaboverightcmb = 789;
                    e1.commaaccent = 63171;
                    e1.commaarabic = 1548;
                    e1.commaarmenian = 1373;
                    e1.commainferior = 63201;
                    e1.commamonospace = 65292;
                    e1.commareversedabovecmb = 788;
                    e1.commareversedmod = 701;
                    e1.commasmall = 65104;
                    e1.commasuperior = 63202;
                    e1.commaturnedabovecmb = 786;
                    e1.commaturnedmod = 699;
                    e1.compass = 9788;
                    e1.congruent = 8773;
                    e1.contourintegral = 8750;
                    e1.control = 8963;
                    e1.controlACK = 6;
                    e1.controlBEL = 7;
                    e1.controlBS = 8;
                    e1.controlCAN = 24;
                    e1.controlCR = 13;
                    e1.controlDC1 = 17;
                    e1.controlDC2 = 18;
                    e1.controlDC3 = 19;
                    e1.controlDC4 = 20;
                    e1.controlDEL = 127;
                    e1.controlDLE = 16;
                    e1.controlEM = 25;
                    e1.controlENQ = 5;
                    e1.controlEOT = 4;
                    e1.controlESC = 27;
                    e1.controlETB = 23;
                    e1.controlETX = 3;
                    e1.controlFF = 12;
                    e1.controlFS = 28;
                    e1.controlGS = 29;
                    e1.controlHT = 9;
                    e1.controlLF = 10;
                    e1.controlNAK = 21;
                    e1.controlNULL = 0;
                    e1.controlRS = 30;
                    e1.controlSI = 15;
                    e1.controlSO = 14;
                    e1.controlSOT = 2;
                    e1.controlSTX = 1;
                    e1.controlSUB = 26;
                    e1.controlSYN = 22;
                    e1.controlUS = 31;
                    e1.controlVT = 11;
                    e1.copyright = 169;
                    e1.copyrightsans = 63721;
                    e1.copyrightserif = 63193;
                    e1.cornerbracketleft = 12300;
                    e1.cornerbracketlefthalfwidth = 65378;
                    e1.cornerbracketleftvertical = 65089;
                    e1.cornerbracketright = 12301;
                    e1.cornerbracketrighthalfwidth = 65379;
                    e1.cornerbracketrightvertical = 65090;
                    e1.corporationsquare = 13183;
                    e1.cosquare = 13255;
                    e1.coverkgsquare = 13254;
                    e1.cparen = 9374;
                    e1.cruzeiro = 8354;
                    e1.cstretched = 663;
                    e1.curlyand = 8911;
                    e1.curlyor = 8910;
                    e1.currency = 164;
                    e1.cyrBreve = 63185;
                    e1.cyrFlex = 63186;
                    e1.cyrbreve = 63188;
                    e1.cyrflex = 63189;
                    e1.d = 100;
                    e1.daarmenian = 1380;
                    e1.dabengali = 2470;
                    e1.dadarabic = 1590;
                    e1.dadeva = 2342;
                    e1.dadfinalarabic = 65214;
                    e1.dadinitialarabic = 65215;
                    e1.dadmedialarabic = 65216;
                    e1.dagesh = 1468;
                    e1.dageshhebrew = 1468;
                    e1.dagger = 8224;
                    e1.daggerdbl = 8225;
                    e1.dagujarati = 2726;
                    e1.dagurmukhi = 2598;
                    e1.dahiragana = 12384;
                    e1.dakatakana = 12480;
                    e1.dalarabic = 1583;
                    e1.dalet = 1491;
                    e1.daletdagesh = 64307;
                    e1.daletdageshhebrew = 64307;
                    e1.dalethebrew = 1491;
                    e1.dalfinalarabic = 65194;
                    e1.dammaarabic = 1615;
                    e1.dammalowarabic = 1615;
                    e1.dammatanaltonearabic = 1612;
                    e1.dammatanarabic = 1612;
                    e1.danda = 2404;
                    e1.dargahebrew = 1447;
                    e1.dargalefthebrew = 1447;
                    e1.dasiapneumatacyrilliccmb = 1157;
                    e1.dblGrave = 63187;
                    e1.dblanglebracketleft = 12298;
                    e1.dblanglebracketleftvertical = 65085;
                    e1.dblanglebracketright = 12299;
                    e1.dblanglebracketrightvertical = 65086;
                    e1.dblarchinvertedbelowcmb = 811;
                    e1.dblarrowleft = 8660;
                    e1.dblarrowright = 8658;
                    e1.dbldanda = 2405;
                    e1.dblgrave = 63190;
                    e1.dblgravecmb = 783;
                    e1.dblintegral = 8748;
                    e1.dbllowline = 8215;
                    e1.dbllowlinecmb = 819;
                    e1.dbloverlinecmb = 831;
                    e1.dblprimemod = 698;
                    e1.dblverticalbar = 8214;
                    e1.dblverticallineabovecmb = 782;
                    e1.dbopomofo = 12553;
                    e1.dbsquare = 13256;
                    e1.dcaron = 271;
                    e1.dcedilla = 7697;
                    e1.dcircle = 9427;
                    e1.dcircumflexbelow = 7699;
                    e1.dcroat = 273;
                    e1.ddabengali = 2465;
                    e1.ddadeva = 2337;
                    e1.ddagujarati = 2721;
                    e1.ddagurmukhi = 2593;
                    e1.ddalarabic = 1672;
                    e1.ddalfinalarabic = 64393;
                    e1.dddhadeva = 2396;
                    e1.ddhabengali = 2466;
                    e1.ddhadeva = 2338;
                    e1.ddhagujarati = 2722;
                    e1.ddhagurmukhi = 2594;
                    e1.ddotaccent = 7691;
                    e1.ddotbelow = 7693;
                    e1.decimalseparatorarabic = 1643;
                    e1.decimalseparatorpersian = 1643;
                    e1.decyrillic = 1076;
                    e1.degree = 176;
                    e1.dehihebrew = 1453;
                    e1.dehiragana = 12391;
                    e1.deicoptic = 1007;
                    e1.dekatakana = 12487;
                    e1.deleteleft = 9003;
                    e1.deleteright = 8998;
                    e1.delta = 948;
                    e1.deltaturned = 397;
                    e1.denominatorminusonenumeratorbengali = 2552;
                    e1.dezh = 676;
                    e1.dhabengali = 2471;
                    e1.dhadeva = 2343;
                    e1.dhagujarati = 2727;
                    e1.dhagurmukhi = 2599;
                    e1.dhook = 599;
                    e1.dialytikatonos = 901;
                    e1.dialytikatonoscmb = 836;
                    e1.diamond = 9830;
                    e1.diamondsuitwhite = 9826;
                    e1.dieresis = 168;
                    e1.dieresisacute = 63191;
                    e1.dieresisbelowcmb = 804;
                    e1.dieresiscmb = 776;
                    e1.dieresisgrave = 63192;
                    e1.dieresistonos = 901;
                    e1.dihiragana = 12386;
                    e1.dikatakana = 12482;
                    e1.dittomark = 12291;
                    e1.divide = 247;
                    e1.divides = 8739;
                    e1.divisionslash = 8725;
                    e1.djecyrillic = 1106;
                    e1.dkshade = 9619;
                    e1.dlinebelow = 7695;
                    e1.dlsquare = 13207;
                    e1.dmacron = 273;
                    e1.dmonospace = 65348;
                    e1.dnblock = 9604;
                    e1.dochadathai = 3598;
                    e1.dodekthai = 3604;
                    e1.dohiragana = 12393;
                    e1.dokatakana = 12489;
                    e1.dollar = 36;
                    e1.dollarinferior = 63203;
                    e1.dollarmonospace = 65284;
                    e1.dollaroldstyle = 63268;
                    e1.dollarsmall = 65129;
                    e1.dollarsuperior = 63204;
                    e1.dong = 8363;
                    e1.dorusquare = 13094;
                    e1.dotaccent = 729;
                    e1.dotaccentcmb = 775;
                    e1.dotbelowcmb = 803;
                    e1.dotbelowcomb = 803;
                    e1.dotkatakana = 12539;
                    e1.dotlessi = 305;
                    e1.dotlessj = 63166;
                    e1.dotlessjstrokehook = 644;
                    e1.dotmath = 8901;
                    e1.dottedcircle = 9676;
                    e1.doubleyodpatah = 64287;
                    e1.doubleyodpatahhebrew = 64287;
                    e1.downtackbelowcmb = 798;
                    e1.downtackmod = 725;
                    e1.dparen = 9375;
                    e1.dsuperior = 63211;
                    e1.dtail = 598;
                    e1.dtopbar = 396;
                    e1.duhiragana = 12389;
                    e1.dukatakana = 12485;
                    e1.dz = 499;
                    e1.dzaltone = 675;
                    e1.dzcaron = 454;
                    e1.dzcurl = 677;
                    e1.dzeabkhasiancyrillic = 1249;
                    e1.dzecyrillic = 1109;
                    e1.dzhecyrillic = 1119;
                    e1.e = 101;
                    e1.eacute = 233;
                    e1.earth = 9793;
                    e1.ebengali = 2447;
                    e1.ebopomofo = 12572;
                    e1.ebreve = 277;
                    e1.ecandradeva = 2317;
                    e1.ecandragujarati = 2701;
                    e1.ecandravowelsigndeva = 2373;
                    e1.ecandravowelsigngujarati = 2757;
                    e1.ecaron = 283;
                    e1.ecedillabreve = 7709;
                    e1.echarmenian = 1381;
                    e1.echyiwnarmenian = 1415;
                    e1.ecircle = 9428;
                    e1.ecircumflex = 234;
                    e1.ecircumflexacute = 7871;
                    e1.ecircumflexbelow = 7705;
                    e1.ecircumflexdotbelow = 7879;
                    e1.ecircumflexgrave = 7873;
                    e1.ecircumflexhookabove = 7875;
                    e1.ecircumflextilde = 7877;
                    e1.ecyrillic = 1108;
                    e1.edblgrave = 517;
                    e1.edeva = 2319;
                    e1.edieresis = 235;
                    e1.edot = 279;
                    e1.edotaccent = 279;
                    e1.edotbelow = 7865;
                    e1.eegurmukhi = 2575;
                    e1.eematragurmukhi = 2631;
                    e1.efcyrillic = 1092;
                    e1.egrave = 232;
                    e1.egujarati = 2703;
                    e1.eharmenian = 1383;
                    e1.ehbopomofo = 12573;
                    e1.ehiragana = 12360;
                    e1.ehookabove = 7867;
                    e1.eibopomofo = 12575;
                    e1.eight = 56;
                    e1.eightarabic = 1640;
                    e1.eightbengali = 2542;
                    e1.eightcircle = 9319;
                    e1.eightcircleinversesansserif = 10129;
                    e1.eightdeva = 2414;
                    e1.eighteencircle = 9329;
                    e1.eighteenparen = 9349;
                    e1.eighteenperiod = 9369;
                    e1.eightgujarati = 2798;
                    e1.eightgurmukhi = 2670;
                    e1.eighthackarabic = 1640;
                    e1.eighthangzhou = 12328;
                    e1.eighthnotebeamed = 9835;
                    e1.eightideographicparen = 12839;
                    e1.eightinferior = 8328;
                    e1.eightmonospace = 65304;
                    e1.eightoldstyle = 63288;
                    e1.eightparen = 9339;
                    e1.eightperiod = 9359;
                    e1.eightpersian = 1784;
                    e1.eightroman = 8567;
                    e1.eightsuperior = 8312;
                    e1.eightthai = 3672;
                    e1.einvertedbreve = 519;
                    e1.eiotifiedcyrillic = 1125;
                    e1.ekatakana = 12456;
                    e1.ekatakanahalfwidth = 65396;
                    e1.ekonkargurmukhi = 2676;
                    e1.ekorean = 12628;
                    e1.elcyrillic = 1083;
                    e1.element = 8712;
                    e1.elevencircle = 9322;
                    e1.elevenparen = 9342;
                    e1.elevenperiod = 9362;
                    e1.elevenroman = 8570;
                    e1.ellipsis = 8230;
                    e1.ellipsisvertical = 8942;
                    e1.emacron = 275;
                    e1.emacronacute = 7703;
                    e1.emacrongrave = 7701;
                    e1.emcyrillic = 1084;
                    e1.emdash = 8212;
                    e1.emdashvertical = 65073;
                    e1.emonospace = 65349;
                    e1.emphasismarkarmenian = 1371;
                    e1.emptyset = 8709;
                    e1.enbopomofo = 12579;
                    e1.encyrillic = 1085;
                    e1.endash = 8211;
                    e1.endashvertical = 65074;
                    e1.endescendercyrillic = 1187;
                    e1.eng = 331;
                    e1.engbopomofo = 12581;
                    e1.enghecyrillic = 1189;
                    e1.enhookcyrillic = 1224;
                    e1.enspace = 8194;
                    e1.eogonek = 281;
                    e1.eokorean = 12627;
                    e1.eopen = 603;
                    e1.eopenclosed = 666;
                    e1.eopenreversed = 604;
                    e1.eopenreversedclosed = 606;
                    e1.eopenreversedhook = 605;
                    e1.eparen = 9376;
                    e1.epsilon = 949;
                    e1.epsilontonos = 941;
                    e1.equal = 61;
                    e1.equalmonospace = 65309;
                    e1.equalsmall = 65126;
                    e1.equalsuperior = 8316;
                    e1.equivalence = 8801;
                    e1.erbopomofo = 12582;
                    e1.ercyrillic = 1088;
                    e1.ereversed = 600;
                    e1.ereversedcyrillic = 1101;
                    e1.escyrillic = 1089;
                    e1.esdescendercyrillic = 1195;
                    e1.esh = 643;
                    e1.eshcurl = 646;
                    e1.eshortdeva = 2318;
                    e1.eshortvowelsigndeva = 2374;
                    e1.eshreversedloop = 426;
                    e1.eshsquatreversed = 645;
                    e1.esmallhiragana = 12359;
                    e1.esmallkatakana = 12455;
                    e1.esmallkatakanahalfwidth = 65386;
                    e1.estimated = 8494;
                    e1.esuperior = 63212;
                    e1.eta = 951;
                    e1.etarmenian = 1384;
                    e1.etatonos = 942;
                    e1.eth = 240;
                    e1.etilde = 7869;
                    e1.etildebelow = 7707;
                    e1.etnahtafoukhhebrew = 1425;
                    e1.etnahtafoukhlefthebrew = 1425;
                    e1.etnahtahebrew = 1425;
                    e1.etnahtalefthebrew = 1425;
                    e1.eturned = 477;
                    e1.eukorean = 12641;
                    e1.euro = 8364;
                    e1.evowelsignbengali = 2503;
                    e1.evowelsigndeva = 2375;
                    e1.evowelsigngujarati = 2759;
                    e1.exclam = 33;
                    e1.exclamarmenian = 1372;
                    e1.exclamdbl = 8252;
                    e1.exclamdown = 161;
                    e1.exclamdownsmall = 63393;
                    e1.exclammonospace = 65281;
                    e1.exclamsmall = 63265;
                    e1.existential = 8707;
                    e1.ezh = 658;
                    e1.ezhcaron = 495;
                    e1.ezhcurl = 659;
                    e1.ezhreversed = 441;
                    e1.ezhtail = 442;
                    e1.f = 102;
                    e1.fadeva = 2398;
                    e1.fagurmukhi = 2654;
                    e1.fahrenheit = 8457;
                    e1.fathaarabic = 1614;
                    e1.fathalowarabic = 1614;
                    e1.fathatanarabic = 1611;
                    e1.fbopomofo = 12552;
                    e1.fcircle = 9429;
                    e1.fdotaccent = 7711;
                    e1.feharabic = 1601;
                    e1.feharmenian = 1414;
                    e1.fehfinalarabic = 65234;
                    e1.fehinitialarabic = 65235;
                    e1.fehmedialarabic = 65236;
                    e1.feicoptic = 997;
                    e1.female = 9792;
                    e1.ff = 64256;
                    e1.f_f = 64256;
                    e1.ffi = 64259;
                    e1.f_f_i = 64259;
                    e1.ffl = 64260;
                    e1.f_f_l = 64260;
                    e1.fi = 64257;
                    e1.f_i = 64257;
                    e1.fifteencircle = 9326;
                    e1.fifteenparen = 9346;
                    e1.fifteenperiod = 9366;
                    e1.figuredash = 8210;
                    e1.filledbox = 9632;
                    e1.filledrect = 9644;
                    e1.finalkaf = 1498;
                    e1.finalkafdagesh = 64314;
                    e1.finalkafdageshhebrew = 64314;
                    e1.finalkafhebrew = 1498;
                    e1.finalmem = 1501;
                    e1.finalmemhebrew = 1501;
                    e1.finalnun = 1503;
                    e1.finalnunhebrew = 1503;
                    e1.finalpe = 1507;
                    e1.finalpehebrew = 1507;
                    e1.finaltsadi = 1509;
                    e1.finaltsadihebrew = 1509;
                    e1.firsttonechinese = 713;
                    e1.fisheye = 9673;
                    e1.fitacyrillic = 1139;
                    e1.five = 53;
                    e1.fivearabic = 1637;
                    e1.fivebengali = 2539;
                    e1.fivecircle = 9316;
                    e1.fivecircleinversesansserif = 10126;
                    e1.fivedeva = 2411;
                    e1.fiveeighths = 8541;
                    e1.fivegujarati = 2795;
                    e1.fivegurmukhi = 2667;
                    e1.fivehackarabic = 1637;
                    e1.fivehangzhou = 12325;
                    e1.fiveideographicparen = 12836;
                    e1.fiveinferior = 8325;
                    e1.fivemonospace = 65301;
                    e1.fiveoldstyle = 63285;
                    e1.fiveparen = 9336;
                    e1.fiveperiod = 9356;
                    e1.fivepersian = 1781;
                    e1.fiveroman = 8564;
                    e1.fivesuperior = 8309;
                    e1.fivethai = 3669;
                    e1.fl = 64258;
                    e1.f_l = 64258;
                    e1.florin = 402;
                    e1.fmonospace = 65350;
                    e1.fmsquare = 13209;
                    e1.fofanthai = 3615;
                    e1.fofathai = 3613;
                    e1.fongmanthai = 3663;
                    e1.forall = 8704;
                    e1.four = 52;
                    e1.fourarabic = 1636;
                    e1.fourbengali = 2538;
                    e1.fourcircle = 9315;
                    e1.fourcircleinversesansserif = 10125;
                    e1.fourdeva = 2410;
                    e1.fourgujarati = 2794;
                    e1.fourgurmukhi = 2666;
                    e1.fourhackarabic = 1636;
                    e1.fourhangzhou = 12324;
                    e1.fourideographicparen = 12835;
                    e1.fourinferior = 8324;
                    e1.fourmonospace = 65300;
                    e1.fournumeratorbengali = 2551;
                    e1.fouroldstyle = 63284;
                    e1.fourparen = 9335;
                    e1.fourperiod = 9355;
                    e1.fourpersian = 1780;
                    e1.fourroman = 8563;
                    e1.foursuperior = 8308;
                    e1.fourteencircle = 9325;
                    e1.fourteenparen = 9345;
                    e1.fourteenperiod = 9365;
                    e1.fourthai = 3668;
                    e1.fourthtonechinese = 715;
                    e1.fparen = 9377;
                    e1.fraction = 8260;
                    e1.franc = 8355;
                    e1.g = 103;
                    e1.gabengali = 2455;
                    e1.gacute = 501;
                    e1.gadeva = 2327;
                    e1.gafarabic = 1711;
                    e1.gaffinalarabic = 64403;
                    e1.gafinitialarabic = 64404;
                    e1.gafmedialarabic = 64405;
                    e1.gagujarati = 2711;
                    e1.gagurmukhi = 2583;
                    e1.gahiragana = 12364;
                    e1.gakatakana = 12460;
                    e1.gamma = 947;
                    e1.gammalatinsmall = 611;
                    e1.gammasuperior = 736;
                    e1.gangiacoptic = 1003;
                    e1.gbopomofo = 12557;
                    e1.gbreve = 287;
                    e1.gcaron = 487;
                    e1.gcedilla = 291;
                    e1.gcircle = 9430;
                    e1.gcircumflex = 285;
                    e1.gcommaaccent = 291;
                    e1.gdot = 289;
                    e1.gdotaccent = 289;
                    e1.gecyrillic = 1075;
                    e1.gehiragana = 12370;
                    e1.gekatakana = 12466;
                    e1.geometricallyequal = 8785;
                    e1.gereshaccenthebrew = 1436;
                    e1.gereshhebrew = 1523;
                    e1.gereshmuqdamhebrew = 1437;
                    e1.germandbls = 223;
                    e1.gershayimaccenthebrew = 1438;
                    e1.gershayimhebrew = 1524;
                    e1.getamark = 12307;
                    e1.ghabengali = 2456;
                    e1.ghadarmenian = 1394;
                    e1.ghadeva = 2328;
                    e1.ghagujarati = 2712;
                    e1.ghagurmukhi = 2584;
                    e1.ghainarabic = 1594;
                    e1.ghainfinalarabic = 65230;
                    e1.ghaininitialarabic = 65231;
                    e1.ghainmedialarabic = 65232;
                    e1.ghemiddlehookcyrillic = 1173;
                    e1.ghestrokecyrillic = 1171;
                    e1.gheupturncyrillic = 1169;
                    e1.ghhadeva = 2394;
                    e1.ghhagurmukhi = 2650;
                    e1.ghook = 608;
                    e1.ghzsquare = 13203;
                    e1.gihiragana = 12366;
                    e1.gikatakana = 12462;
                    e1.gimarmenian = 1379;
                    e1.gimel = 1490;
                    e1.gimeldagesh = 64306;
                    e1.gimeldageshhebrew = 64306;
                    e1.gimelhebrew = 1490;
                    e1.gjecyrillic = 1107;
                    e1.glottalinvertedstroke = 446;
                    e1.glottalstop = 660;
                    e1.glottalstopinverted = 662;
                    e1.glottalstopmod = 704;
                    e1.glottalstopreversed = 661;
                    e1.glottalstopreversedmod = 705;
                    e1.glottalstopreversedsuperior = 740;
                    e1.glottalstopstroke = 673;
                    e1.glottalstopstrokereversed = 674;
                    e1.gmacron = 7713;
                    e1.gmonospace = 65351;
                    e1.gohiragana = 12372;
                    e1.gokatakana = 12468;
                    e1.gparen = 9378;
                    e1.gpasquare = 13228;
                    e1.gradient = 8711;
                    e1.grave = 96;
                    e1.gravebelowcmb = 790;
                    e1.gravecmb = 768;
                    e1.gravecomb = 768;
                    e1.gravedeva = 2387;
                    e1.gravelowmod = 718;
                    e1.gravemonospace = 65344;
                    e1.gravetonecmb = 832;
                    e1.greater = 62;
                    e1.greaterequal = 8805;
                    e1.greaterequalorless = 8923;
                    e1.greatermonospace = 65310;
                    e1.greaterorequivalent = 8819;
                    e1.greaterorless = 8823;
                    e1.greateroverequal = 8807;
                    e1.greatersmall = 65125;
                    e1.gscript = 609;
                    e1.gstroke = 485;
                    e1.guhiragana = 12368;
                    e1.guillemotleft = 171;
                    e1.guillemotright = 187;
                    e1.guilsinglleft = 8249;
                    e1.guilsinglright = 8250;
                    e1.gukatakana = 12464;
                    e1.guramusquare = 13080;
                    e1.gysquare = 13257;
                    e1.h = 104;
                    e1.haabkhasiancyrillic = 1193;
                    e1.haaltonearabic = 1729;
                    e1.habengali = 2489;
                    e1.hadescendercyrillic = 1203;
                    e1.hadeva = 2361;
                    e1.hagujarati = 2745;
                    e1.hagurmukhi = 2617;
                    e1.haharabic = 1581;
                    e1.hahfinalarabic = 65186;
                    e1.hahinitialarabic = 65187;
                    e1.hahiragana = 12399;
                    e1.hahmedialarabic = 65188;
                    e1.haitusquare = 13098;
                    e1.hakatakana = 12495;
                    e1.hakatakanahalfwidth = 65418;
                    e1.halantgurmukhi = 2637;
                    e1.hamzaarabic = 1569;
                    e1.hamzalowarabic = 1569;
                    e1.hangulfiller = 12644;
                    e1.hardsigncyrillic = 1098;
                    e1.harpoonleftbarbup = 8636;
                    e1.harpoonrightbarbup = 8640;
                    e1.hasquare = 13258;
                    e1.hatafpatah = 1458;
                    e1.hatafpatah16 = 1458;
                    e1.hatafpatah23 = 1458;
                    e1.hatafpatah2f = 1458;
                    e1.hatafpatahhebrew = 1458;
                    e1.hatafpatahnarrowhebrew = 1458;
                    e1.hatafpatahquarterhebrew = 1458;
                    e1.hatafpatahwidehebrew = 1458;
                    e1.hatafqamats = 1459;
                    e1.hatafqamats1b = 1459;
                    e1.hatafqamats28 = 1459;
                    e1.hatafqamats34 = 1459;
                    e1.hatafqamatshebrew = 1459;
                    e1.hatafqamatsnarrowhebrew = 1459;
                    e1.hatafqamatsquarterhebrew = 1459;
                    e1.hatafqamatswidehebrew = 1459;
                    e1.hatafsegol = 1457;
                    e1.hatafsegol17 = 1457;
                    e1.hatafsegol24 = 1457;
                    e1.hatafsegol30 = 1457;
                    e1.hatafsegolhebrew = 1457;
                    e1.hatafsegolnarrowhebrew = 1457;
                    e1.hatafsegolquarterhebrew = 1457;
                    e1.hatafsegolwidehebrew = 1457;
                    e1.hbar = 295;
                    e1.hbopomofo = 12559;
                    e1.hbrevebelow = 7723;
                    e1.hcedilla = 7721;
                    e1.hcircle = 9431;
                    e1.hcircumflex = 293;
                    e1.hdieresis = 7719;
                    e1.hdotaccent = 7715;
                    e1.hdotbelow = 7717;
                    e1.he = 1492;
                    e1.heart = 9829;
                    e1.heartsuitblack = 9829;
                    e1.heartsuitwhite = 9825;
                    e1.hedagesh = 64308;
                    e1.hedageshhebrew = 64308;
                    e1.hehaltonearabic = 1729;
                    e1.heharabic = 1607;
                    e1.hehebrew = 1492;
                    e1.hehfinalaltonearabic = 64423;
                    e1.hehfinalalttwoarabic = 65258;
                    e1.hehfinalarabic = 65258;
                    e1.hehhamzaabovefinalarabic = 64421;
                    e1.hehhamzaaboveisolatedarabic = 64420;
                    e1.hehinitialaltonearabic = 64424;
                    e1.hehinitialarabic = 65259;
                    e1.hehiragana = 12408;
                    e1.hehmedialaltonearabic = 64425;
                    e1.hehmedialarabic = 65260;
                    e1.heiseierasquare = 13179;
                    e1.hekatakana = 12504;
                    e1.hekatakanahalfwidth = 65421;
                    e1.hekutaarusquare = 13110;
                    e1.henghook = 615;
                    e1.herutusquare = 13113;
                    e1.het = 1495;
                    e1.hethebrew = 1495;
                    e1.hhook = 614;
                    e1.hhooksuperior = 689;
                    e1.hieuhacirclekorean = 12923;
                    e1.hieuhaparenkorean = 12827;
                    e1.hieuhcirclekorean = 12909;
                    e1.hieuhkorean = 12622;
                    e1.hieuhparenkorean = 12813;
                    e1.hihiragana = 12402;
                    e1.hikatakana = 12498;
                    e1.hikatakanahalfwidth = 65419;
                    e1.hiriq = 1460;
                    e1.hiriq14 = 1460;
                    e1.hiriq21 = 1460;
                    e1.hiriq2d = 1460;
                    e1.hiriqhebrew = 1460;
                    e1.hiriqnarrowhebrew = 1460;
                    e1.hiriqquarterhebrew = 1460;
                    e1.hiriqwidehebrew = 1460;
                    e1.hlinebelow = 7830;
                    e1.hmonospace = 65352;
                    e1.hoarmenian = 1392;
                    e1.hohipthai = 3627;
                    e1.hohiragana = 12411;
                    e1.hokatakana = 12507;
                    e1.hokatakanahalfwidth = 65422;
                    e1.holam = 1465;
                    e1.holam19 = 1465;
                    e1.holam26 = 1465;
                    e1.holam32 = 1465;
                    e1.holamhebrew = 1465;
                    e1.holamnarrowhebrew = 1465;
                    e1.holamquarterhebrew = 1465;
                    e1.holamwidehebrew = 1465;
                    e1.honokhukthai = 3630;
                    e1.hookabovecomb = 777;
                    e1.hookcmb = 777;
                    e1.hookpalatalizedbelowcmb = 801;
                    e1.hookretroflexbelowcmb = 802;
                    e1.hoonsquare = 13122;
                    e1.horicoptic = 1001;
                    e1.horizontalbar = 8213;
                    e1.horncmb = 795;
                    e1.hotsprings = 9832;
                    e1.house = 8962;
                    e1.hparen = 9379;
                    e1.hsuperior = 688;
                    e1.hturned = 613;
                    e1.huhiragana = 12405;
                    e1.huiitosquare = 13107;
                    e1.hukatakana = 12501;
                    e1.hukatakanahalfwidth = 65420;
                    e1.hungarumlaut = 733;
                    e1.hungarumlautcmb = 779;
                    e1.hv = 405;
                    e1.hyphen = 45;
                    e1.hypheninferior = 63205;
                    e1.hyphenmonospace = 65293;
                    e1.hyphensmall = 65123;
                    e1.hyphensuperior = 63206;
                    e1.hyphentwo = 8208;
                    e1.i = 105;
                    e1.iacute = 237;
                    e1.iacyrillic = 1103;
                    e1.ibengali = 2439;
                    e1.ibopomofo = 12583;
                    e1.ibreve = 301;
                    e1.icaron = 464;
                    e1.icircle = 9432;
                    e1.icircumflex = 238;
                    e1.icyrillic = 1110;
                    e1.idblgrave = 521;
                    e1.ideographearthcircle = 12943;
                    e1.ideographfirecircle = 12939;
                    e1.ideographicallianceparen = 12863;
                    e1.ideographiccallparen = 12858;
                    e1.ideographiccentrecircle = 12965;
                    e1.ideographicclose = 12294;
                    e1.ideographiccomma = 12289;
                    e1.ideographiccommaleft = 65380;
                    e1.ideographiccongratulationparen = 12855;
                    e1.ideographiccorrectcircle = 12963;
                    e1.ideographicearthparen = 12847;
                    e1.ideographicenterpriseparen = 12861;
                    e1.ideographicexcellentcircle = 12957;
                    e1.ideographicfestivalparen = 12864;
                    e1.ideographicfinancialcircle = 12950;
                    e1.ideographicfinancialparen = 12854;
                    e1.ideographicfireparen = 12843;
                    e1.ideographichaveparen = 12850;
                    e1.ideographichighcircle = 12964;
                    e1.ideographiciterationmark = 12293;
                    e1.ideographiclaborcircle = 12952;
                    e1.ideographiclaborparen = 12856;
                    e1.ideographicleftcircle = 12967;
                    e1.ideographiclowcircle = 12966;
                    e1.ideographicmedicinecircle = 12969;
                    e1.ideographicmetalparen = 12846;
                    e1.ideographicmoonparen = 12842;
                    e1.ideographicnameparen = 12852;
                    e1.ideographicperiod = 12290;
                    e1.ideographicprintcircle = 12958;
                    e1.ideographicreachparen = 12867;
                    e1.ideographicrepresentparen = 12857;
                    e1.ideographicresourceparen = 12862;
                    e1.ideographicrightcircle = 12968;
                    e1.ideographicsecretcircle = 12953;
                    e1.ideographicselfparen = 12866;
                    e1.ideographicsocietyparen = 12851;
                    e1.ideographicspace = 12288;
                    e1.ideographicspecialparen = 12853;
                    e1.ideographicstockparen = 12849;
                    e1.ideographicstudyparen = 12859;
                    e1.ideographicsunparen = 12848;
                    e1.ideographicsuperviseparen = 12860;
                    e1.ideographicwaterparen = 12844;
                    e1.ideographicwoodparen = 12845;
                    e1.ideographiczero = 12295;
                    e1.ideographmetalcircle = 12942;
                    e1.ideographmooncircle = 12938;
                    e1.ideographnamecircle = 12948;
                    e1.ideographsuncircle = 12944;
                    e1.ideographwatercircle = 12940;
                    e1.ideographwoodcircle = 12941;
                    e1.ideva = 2311;
                    e1.idieresis = 239;
                    e1.idieresisacute = 7727;
                    e1.idieresiscyrillic = 1253;
                    e1.idotbelow = 7883;
                    e1.iebrevecyrillic = 1239;
                    e1.iecyrillic = 1077;
                    e1.ieungacirclekorean = 12917;
                    e1.ieungaparenkorean = 12821;
                    e1.ieungcirclekorean = 12903;
                    e1.ieungkorean = 12615;
                    e1.ieungparenkorean = 12807;
                    e1.igrave = 236;
                    e1.igujarati = 2695;
                    e1.igurmukhi = 2567;
                    e1.ihiragana = 12356;
                    e1.ihookabove = 7881;
                    e1.iibengali = 2440;
                    e1.iicyrillic = 1080;
                    e1.iideva = 2312;
                    e1.iigujarati = 2696;
                    e1.iigurmukhi = 2568;
                    e1.iimatragurmukhi = 2624;
                    e1.iinvertedbreve = 523;
                    e1.iishortcyrillic = 1081;
                    e1.iivowelsignbengali = 2496;
                    e1.iivowelsigndeva = 2368;
                    e1.iivowelsigngujarati = 2752;
                    e1.ij = 307;
                    e1.ikatakana = 12452;
                    e1.ikatakanahalfwidth = 65394;
                    e1.ikorean = 12643;
                    e1.ilde = 732;
                    e1.iluyhebrew = 1452;
                    e1.imacron = 299;
                    e1.imacroncyrillic = 1251;
                    e1.imageorapproximatelyequal = 8787;
                    e1.imatragurmukhi = 2623;
                    e1.imonospace = 65353;
                    e1.increment = 8710;
                    e1.infinity = 8734;
                    e1.iniarmenian = 1387;
                    e1.integral = 8747;
                    e1.integralbottom = 8993;
                    e1.integralbt = 8993;
                    e1.integralex = 63733;
                    e1.integraltop = 8992;
                    e1.integraltp = 8992;
                    e1.intersection = 8745;
                    e1.intisquare = 13061;
                    e1.invbullet = 9688;
                    e1.invcircle = 9689;
                    e1.invsmileface = 9787;
                    e1.iocyrillic = 1105;
                    e1.iogonek = 303;
                    e1.iota = 953;
                    e1.iotadieresis = 970;
                    e1.iotadieresistonos = 912;
                    e1.iotalatin = 617;
                    e1.iotatonos = 943;
                    e1.iparen = 9380;
                    e1.irigurmukhi = 2674;
                    e1.ismallhiragana = 12355;
                    e1.ismallkatakana = 12451;
                    e1.ismallkatakanahalfwidth = 65384;
                    e1.issharbengali = 2554;
                    e1.istroke = 616;
                    e1.isuperior = 63213;
                    e1.iterationhiragana = 12445;
                    e1.iterationkatakana = 12541;
                    e1.itilde = 297;
                    e1.itildebelow = 7725;
                    e1.iubopomofo = 12585;
                    e1.iucyrillic = 1102;
                    e1.ivowelsignbengali = 2495;
                    e1.ivowelsigndeva = 2367;
                    e1.ivowelsigngujarati = 2751;
                    e1.izhitsacyrillic = 1141;
                    e1.izhitsadblgravecyrillic = 1143;
                    e1.j = 106;
                    e1.jaarmenian = 1393;
                    e1.jabengali = 2460;
                    e1.jadeva = 2332;
                    e1.jagujarati = 2716;
                    e1.jagurmukhi = 2588;
                    e1.jbopomofo = 12560;
                    e1.jcaron = 496;
                    e1.jcircle = 9433;
                    e1.jcircumflex = 309;
                    e1.jcrossedtail = 669;
                    e1.jdotlessstroke = 607;
                    e1.jecyrillic = 1112;
                    e1.jeemarabic = 1580;
                    e1.jeemfinalarabic = 65182;
                    e1.jeeminitialarabic = 65183;
                    e1.jeemmedialarabic = 65184;
                    e1.jeharabic = 1688;
                    e1.jehfinalarabic = 64395;
                    e1.jhabengali = 2461;
                    e1.jhadeva = 2333;
                    e1.jhagujarati = 2717;
                    e1.jhagurmukhi = 2589;
                    e1.jheharmenian = 1403;
                    e1.jis = 12292;
                    e1.jmonospace = 65354;
                    e1.jparen = 9381;
                    e1.jsuperior = 690;
                    e1.k = 107;
                    e1.kabashkircyrillic = 1185;
                    e1.kabengali = 2453;
                    e1.kacute = 7729;
                    e1.kacyrillic = 1082;
                    e1.kadescendercyrillic = 1179;
                    e1.kadeva = 2325;
                    e1.kaf = 1499;
                    e1.kafarabic = 1603;
                    e1.kafdagesh = 64315;
                    e1.kafdageshhebrew = 64315;
                    e1.kaffinalarabic = 65242;
                    e1.kafhebrew = 1499;
                    e1.kafinitialarabic = 65243;
                    e1.kafmedialarabic = 65244;
                    e1.kafrafehebrew = 64333;
                    e1.kagujarati = 2709;
                    e1.kagurmukhi = 2581;
                    e1.kahiragana = 12363;
                    e1.kahookcyrillic = 1220;
                    e1.kakatakana = 12459;
                    e1.kakatakanahalfwidth = 65398;
                    e1.kappa = 954;
                    e1.kappasymbolgreek = 1008;
                    e1.kapyeounmieumkorean = 12657;
                    e1.kapyeounphieuphkorean = 12676;
                    e1.kapyeounpieupkorean = 12664;
                    e1.kapyeounssangpieupkorean = 12665;
                    e1.karoriisquare = 13069;
                    e1.kashidaautoarabic = 1600;
                    e1.kashidaautonosidebearingarabic = 1600;
                    e1.kasmallkatakana = 12533;
                    e1.kasquare = 13188;
                    e1.kasraarabic = 1616;
                    e1.kasratanarabic = 1613;
                    e1.kastrokecyrillic = 1183;
                    e1.katahiraprolongmarkhalfwidth = 65392;
                    e1.kaverticalstrokecyrillic = 1181;
                    e1.kbopomofo = 12558;
                    e1.kcalsquare = 13193;
                    e1.kcaron = 489;
                    e1.kcedilla = 311;
                    e1.kcircle = 9434;
                    e1.kcommaaccent = 311;
                    e1.kdotbelow = 7731;
                    e1.keharmenian = 1412;
                    e1.kehiragana = 12369;
                    e1.kekatakana = 12465;
                    e1.kekatakanahalfwidth = 65401;
                    e1.kenarmenian = 1391;
                    e1.kesmallkatakana = 12534;
                    e1.kgreenlandic = 312;
                    e1.khabengali = 2454;
                    e1.khacyrillic = 1093;
                    e1.khadeva = 2326;
                    e1.khagujarati = 2710;
                    e1.khagurmukhi = 2582;
                    e1.khaharabic = 1582;
                    e1.khahfinalarabic = 65190;
                    e1.khahinitialarabic = 65191;
                    e1.khahmedialarabic = 65192;
                    e1.kheicoptic = 999;
                    e1.khhadeva = 2393;
                    e1.khhagurmukhi = 2649;
                    e1.khieukhacirclekorean = 12920;
                    e1.khieukhaparenkorean = 12824;
                    e1.khieukhcirclekorean = 12906;
                    e1.khieukhkorean = 12619;
                    e1.khieukhparenkorean = 12810;
                    e1.khokhaithai = 3586;
                    e1.khokhonthai = 3589;
                    e1.khokhuatthai = 3587;
                    e1.khokhwaithai = 3588;
                    e1.khomutthai = 3675;
                    e1.khook = 409;
                    e1.khorakhangthai = 3590;
                    e1.khzsquare = 13201;
                    e1.kihiragana = 12365;
                    e1.kikatakana = 12461;
                    e1.kikatakanahalfwidth = 65399;
                    e1.kiroguramusquare = 13077;
                    e1.kiromeetorusquare = 13078;
                    e1.kirosquare = 13076;
                    e1.kiyeokacirclekorean = 12910;
                    e1.kiyeokaparenkorean = 12814;
                    e1.kiyeokcirclekorean = 12896;
                    e1.kiyeokkorean = 12593;
                    e1.kiyeokparenkorean = 12800;
                    e1.kiyeoksioskorean = 12595;
                    e1.kjecyrillic = 1116;
                    e1.klinebelow = 7733;
                    e1.klsquare = 13208;
                    e1.kmcubedsquare = 13222;
                    e1.kmonospace = 65355;
                    e1.kmsquaredsquare = 13218;
                    e1.kohiragana = 12371;
                    e1.kohmsquare = 13248;
                    e1.kokaithai = 3585;
                    e1.kokatakana = 12467;
                    e1.kokatakanahalfwidth = 65402;
                    e1.kooposquare = 13086;
                    e1.koppacyrillic = 1153;
                    e1.koreanstandardsymbol = 12927;
                    e1.koroniscmb = 835;
                    e1.kparen = 9382;
                    e1.kpasquare = 13226;
                    e1.ksicyrillic = 1135;
                    e1.ktsquare = 13263;
                    e1.kturned = 670;
                    e1.kuhiragana = 12367;
                    e1.kukatakana = 12463;
                    e1.kukatakanahalfwidth = 65400;
                    e1.kvsquare = 13240;
                    e1.kwsquare = 13246;
                    e1.l = 108;
                    e1.labengali = 2482;
                    e1.lacute = 314;
                    e1.ladeva = 2354;
                    e1.lagujarati = 2738;
                    e1.lagurmukhi = 2610;
                    e1.lakkhangyaothai = 3653;
                    e1.lamaleffinalarabic = 65276;
                    e1.lamalefhamzaabovefinalarabic = 65272;
                    e1.lamalefhamzaaboveisolatedarabic = 65271;
                    e1.lamalefhamzabelowfinalarabic = 65274;
                    e1.lamalefhamzabelowisolatedarabic = 65273;
                    e1.lamalefisolatedarabic = 65275;
                    e1.lamalefmaddaabovefinalarabic = 65270;
                    e1.lamalefmaddaaboveisolatedarabic = 65269;
                    e1.lamarabic = 1604;
                    e1.lambda = 955;
                    e1.lambdastroke = 411;
                    e1.lamed = 1500;
                    e1.lameddagesh = 64316;
                    e1.lameddageshhebrew = 64316;
                    e1.lamedhebrew = 1500;
                    e1.lamfinalarabic = 65246;
                    e1.lamhahinitialarabic = 64714;
                    e1.laminitialarabic = 65247;
                    e1.lamjeeminitialarabic = 64713;
                    e1.lamkhahinitialarabic = 64715;
                    e1.lamlamhehisolatedarabic = 65010;
                    e1.lammedialarabic = 65248;
                    e1.lammeemhahinitialarabic = 64904;
                    e1.lammeeminitialarabic = 64716;
                    e1.largecircle = 9711;
                    e1.lbar = 410;
                    e1.lbelt = 620;
                    e1.lbopomofo = 12556;
                    e1.lcaron = 318;
                    e1.lcedilla = 316;
                    e1.lcircle = 9435;
                    e1.lcircumflexbelow = 7741;
                    e1.lcommaaccent = 316;
                    e1.ldot = 320;
                    e1.ldotaccent = 320;
                    e1.ldotbelow = 7735;
                    e1.ldotbelowmacron = 7737;
                    e1.leftangleabovecmb = 794;
                    e1.lefttackbelowcmb = 792;
                    e1.less = 60;
                    e1.lessequal = 8804;
                    e1.lessequalorgreater = 8922;
                    e1.lessmonospace = 65308;
                    e1.lessorequivalent = 8818;
                    e1.lessorgreater = 8822;
                    e1.lessoverequal = 8806;
                    e1.lesssmall = 65124;
                    e1.lezh = 622;
                    e1.lfblock = 9612;
                    e1.lhookretroflex = 621;
                    e1.lira = 8356;
                    e1.liwnarmenian = 1388;
                    e1.lj = 457;
                    e1.ljecyrillic = 1113;
                    e1.ll = 63168;
                    e1.lladeva = 2355;
                    e1.llagujarati = 2739;
                    e1.llinebelow = 7739;
                    e1.llladeva = 2356;
                    e1.llvocalicbengali = 2529;
                    e1.llvocalicdeva = 2401;
                    e1.llvocalicvowelsignbengali = 2531;
                    e1.llvocalicvowelsigndeva = 2403;
                    e1.lmiddletilde = 619;
                    e1.lmonospace = 65356;
                    e1.lmsquare = 13264;
                    e1.lochulathai = 3628;
                    e1.logicaland = 8743;
                    e1.logicalnot = 172;
                    e1.logicalnotreversed = 8976;
                    e1.logicalor = 8744;
                    e1.lolingthai = 3621;
                    e1.longs = 383;
                    e1.lowlinecenterline = 65102;
                    e1.lowlinecmb = 818;
                    e1.lowlinedashed = 65101;
                    e1.lozenge = 9674;
                    e1.lparen = 9383;
                    e1.lslash = 322;
                    e1.lsquare = 8467;
                    e1.lsuperior = 63214;
                    e1.ltshade = 9617;
                    e1.luthai = 3622;
                    e1.lvocalicbengali = 2444;
                    e1.lvocalicdeva = 2316;
                    e1.lvocalicvowelsignbengali = 2530;
                    e1.lvocalicvowelsigndeva = 2402;
                    e1.lxsquare = 13267;
                    e1.m = 109;
                    e1.mabengali = 2478;
                    e1.macron = 175;
                    e1.macronbelowcmb = 817;
                    e1.macroncmb = 772;
                    e1.macronlowmod = 717;
                    e1.macronmonospace = 65507;
                    e1.macute = 7743;
                    e1.madeva = 2350;
                    e1.magujarati = 2734;
                    e1.magurmukhi = 2606;
                    e1.mahapakhhebrew = 1444;
                    e1.mahapakhlefthebrew = 1444;
                    e1.mahiragana = 12414;
                    e1.maichattawalowleftthai = 63637;
                    e1.maichattawalowrightthai = 63636;
                    e1.maichattawathai = 3659;
                    e1.maichattawaupperleftthai = 63635;
                    e1.maieklowleftthai = 63628;
                    e1.maieklowrightthai = 63627;
                    e1.maiekthai = 3656;
                    e1.maiekupperleftthai = 63626;
                    e1.maihanakatleftthai = 63620;
                    e1.maihanakatthai = 3633;
                    e1.maitaikhuleftthai = 63625;
                    e1.maitaikhuthai = 3655;
                    e1.maitholowleftthai = 63631;
                    e1.maitholowrightthai = 63630;
                    e1.maithothai = 3657;
                    e1.maithoupperleftthai = 63629;
                    e1.maitrilowleftthai = 63634;
                    e1.maitrilowrightthai = 63633;
                    e1.maitrithai = 3658;
                    e1.maitriupperleftthai = 63632;
                    e1.maiyamokthai = 3654;
                    e1.makatakana = 12510;
                    e1.makatakanahalfwidth = 65423;
                    e1.male = 9794;
                    e1.mansyonsquare = 13127;
                    e1.maqafhebrew = 1470;
                    e1.mars = 9794;
                    e1.masoracirclehebrew = 1455;
                    e1.masquare = 13187;
                    e1.mbopomofo = 12551;
                    e1.mbsquare = 13268;
                    e1.mcircle = 9436;
                    e1.mcubedsquare = 13221;
                    e1.mdotaccent = 7745;
                    e1.mdotbelow = 7747;
                    e1.meemarabic = 1605;
                    e1.meemfinalarabic = 65250;
                    e1.meeminitialarabic = 65251;
                    e1.meemmedialarabic = 65252;
                    e1.meemmeeminitialarabic = 64721;
                    e1.meemmeemisolatedarabic = 64584;
                    e1.meetorusquare = 13133;
                    e1.mehiragana = 12417;
                    e1.meizierasquare = 13182;
                    e1.mekatakana = 12513;
                    e1.mekatakanahalfwidth = 65426;
                    e1.mem = 1502;
                    e1.memdagesh = 64318;
                    e1.memdageshhebrew = 64318;
                    e1.memhebrew = 1502;
                    e1.menarmenian = 1396;
                    e1.merkhahebrew = 1445;
                    e1.merkhakefulahebrew = 1446;
                    e1.merkhakefulalefthebrew = 1446;
                    e1.merkhalefthebrew = 1445;
                    e1.mhook = 625;
                    e1.mhzsquare = 13202;
                    e1.middledotkatakanahalfwidth = 65381;
                    e1.middot = 183;
                    e1.mieumacirclekorean = 12914;
                    e1.mieumaparenkorean = 12818;
                    e1.mieumcirclekorean = 12900;
                    e1.mieumkorean = 12609;
                    e1.mieumpansioskorean = 12656;
                    e1.mieumparenkorean = 12804;
                    e1.mieumpieupkorean = 12654;
                    e1.mieumsioskorean = 12655;
                    e1.mihiragana = 12415;
                    e1.mikatakana = 12511;
                    e1.mikatakanahalfwidth = 65424;
                    e1.minus = 8722;
                    e1.minusbelowcmb = 800;
                    e1.minuscircle = 8854;
                    e1.minusmod = 727;
                    e1.minusplus = 8723;
                    e1.minute = 8242;
                    e1.miribaarusquare = 13130;
                    e1.mirisquare = 13129;
                    e1.mlonglegturned = 624;
                    e1.mlsquare = 13206;
                    e1.mmcubedsquare = 13219;
                    e1.mmonospace = 65357;
                    e1.mmsquaredsquare = 13215;
                    e1.mohiragana = 12418;
                    e1.mohmsquare = 13249;
                    e1.mokatakana = 12514;
                    e1.mokatakanahalfwidth = 65427;
                    e1.molsquare = 13270;
                    e1.momathai = 3617;
                    e1.moverssquare = 13223;
                    e1.moverssquaredsquare = 13224;
                    e1.mparen = 9384;
                    e1.mpasquare = 13227;
                    e1.mssquare = 13235;
                    e1.msuperior = 63215;
                    e1.mturned = 623;
                    e1.mu = 181;
                    e1.mu1 = 181;
                    e1.muasquare = 13186;
                    e1.muchgreater = 8811;
                    e1.muchless = 8810;
                    e1.mufsquare = 13196;
                    e1.mugreek = 956;
                    e1.mugsquare = 13197;
                    e1.muhiragana = 12416;
                    e1.mukatakana = 12512;
                    e1.mukatakanahalfwidth = 65425;
                    e1.mulsquare = 13205;
                    e1.multiply = 215;
                    e1.mumsquare = 13211;
                    e1.munahhebrew = 1443;
                    e1.munahlefthebrew = 1443;
                    e1.musicalnote = 9834;
                    e1.musicalnotedbl = 9835;
                    e1.musicflatsign = 9837;
                    e1.musicsharpsign = 9839;
                    e1.mussquare = 13234;
                    e1.muvsquare = 13238;
                    e1.muwsquare = 13244;
                    e1.mvmegasquare = 13241;
                    e1.mvsquare = 13239;
                    e1.mwmegasquare = 13247;
                    e1.mwsquare = 13245;
                    e1.n = 110;
                    e1.nabengali = 2472;
                    e1.nabla = 8711;
                    e1.nacute = 324;
                    e1.nadeva = 2344;
                    e1.nagujarati = 2728;
                    e1.nagurmukhi = 2600;
                    e1.nahiragana = 12394;
                    e1.nakatakana = 12490;
                    e1.nakatakanahalfwidth = 65413;
                    e1.napostrophe = 329;
                    e1.nasquare = 13185;
                    e1.nbopomofo = 12555;
                    e1.nbspace = 160;
                    e1.ncaron = 328;
                    e1.ncedilla = 326;
                    e1.ncircle = 9437;
                    e1.ncircumflexbelow = 7755;
                    e1.ncommaaccent = 326;
                    e1.ndotaccent = 7749;
                    e1.ndotbelow = 7751;
                    e1.nehiragana = 12397;
                    e1.nekatakana = 12493;
                    e1.nekatakanahalfwidth = 65416;
                    e1.newsheqelsign = 8362;
                    e1.nfsquare = 13195;
                    e1.ngabengali = 2457;
                    e1.ngadeva = 2329;
                    e1.ngagujarati = 2713;
                    e1.ngagurmukhi = 2585;
                    e1.ngonguthai = 3591;
                    e1.nhiragana = 12435;
                    e1.nhookleft = 626;
                    e1.nhookretroflex = 627;
                    e1.nieunacirclekorean = 12911;
                    e1.nieunaparenkorean = 12815;
                    e1.nieuncieuckorean = 12597;
                    e1.nieuncirclekorean = 12897;
                    e1.nieunhieuhkorean = 12598;
                    e1.nieunkorean = 12596;
                    e1.nieunpansioskorean = 12648;
                    e1.nieunparenkorean = 12801;
                    e1.nieunsioskorean = 12647;
                    e1.nieuntikeutkorean = 12646;
                    e1.nihiragana = 12395;
                    e1.nikatakana = 12491;
                    e1.nikatakanahalfwidth = 65414;
                    e1.nikhahitleftthai = 63641;
                    e1.nikhahitthai = 3661;
                    e1.nine = 57;
                    e1.ninearabic = 1641;
                    e1.ninebengali = 2543;
                    e1.ninecircle = 9320;
                    e1.ninecircleinversesansserif = 10130;
                    e1.ninedeva = 2415;
                    e1.ninegujarati = 2799;
                    e1.ninegurmukhi = 2671;
                    e1.ninehackarabic = 1641;
                    e1.ninehangzhou = 12329;
                    e1.nineideographicparen = 12840;
                    e1.nineinferior = 8329;
                    e1.ninemonospace = 65305;
                    e1.nineoldstyle = 63289;
                    e1.nineparen = 9340;
                    e1.nineperiod = 9360;
                    e1.ninepersian = 1785;
                    e1.nineroman = 8568;
                    e1.ninesuperior = 8313;
                    e1.nineteencircle = 9330;
                    e1.nineteenparen = 9350;
                    e1.nineteenperiod = 9370;
                    e1.ninethai = 3673;
                    e1.nj = 460;
                    e1.njecyrillic = 1114;
                    e1.nkatakana = 12531;
                    e1.nkatakanahalfwidth = 65437;
                    e1.nlegrightlong = 414;
                    e1.nlinebelow = 7753;
                    e1.nmonospace = 65358;
                    e1.nmsquare = 13210;
                    e1.nnabengali = 2467;
                    e1.nnadeva = 2339;
                    e1.nnagujarati = 2723;
                    e1.nnagurmukhi = 2595;
                    e1.nnnadeva = 2345;
                    e1.nohiragana = 12398;
                    e1.nokatakana = 12494;
                    e1.nokatakanahalfwidth = 65417;
                    e1.nonbreakingspace = 160;
                    e1.nonenthai = 3603;
                    e1.nonuthai = 3609;
                    e1.noonarabic = 1606;
                    e1.noonfinalarabic = 65254;
                    e1.noonghunnaarabic = 1722;
                    e1.noonghunnafinalarabic = 64415;
                    e1.nooninitialarabic = 65255;
                    e1.noonjeeminitialarabic = 64722;
                    e1.noonjeemisolatedarabic = 64587;
                    e1.noonmedialarabic = 65256;
                    e1.noonmeeminitialarabic = 64725;
                    e1.noonmeemisolatedarabic = 64590;
                    e1.noonnoonfinalarabic = 64653;
                    e1.notcontains = 8716;
                    e1.notelement = 8713;
                    e1.notelementof = 8713;
                    e1.notequal = 8800;
                    e1.notgreater = 8815;
                    e1.notgreaternorequal = 8817;
                    e1.notgreaternorless = 8825;
                    e1.notidentical = 8802;
                    e1.notless = 8814;
                    e1.notlessnorequal = 8816;
                    e1.notparallel = 8742;
                    e1.notprecedes = 8832;
                    e1.notsubset = 8836;
                    e1.notsucceeds = 8833;
                    e1.notsuperset = 8837;
                    e1.nowarmenian = 1398;
                    e1.nparen = 9385;
                    e1.nssquare = 13233;
                    e1.nsuperior = 8319;
                    e1.ntilde = 241;
                    e1.nu = 957;
                    e1.nuhiragana = 12396;
                    e1.nukatakana = 12492;
                    e1.nukatakanahalfwidth = 65415;
                    e1.nuktabengali = 2492;
                    e1.nuktadeva = 2364;
                    e1.nuktagujarati = 2748;
                    e1.nuktagurmukhi = 2620;
                    e1.numbersign = 35;
                    e1.numbersignmonospace = 65283;
                    e1.numbersignsmall = 65119;
                    e1.numeralsigngreek = 884;
                    e1.numeralsignlowergreek = 885;
                    e1.numero = 8470;
                    e1.nun = 1504;
                    e1.nundagesh = 64320;
                    e1.nundageshhebrew = 64320;
                    e1.nunhebrew = 1504;
                    e1.nvsquare = 13237;
                    e1.nwsquare = 13243;
                    e1.nyabengali = 2462;
                    e1.nyadeva = 2334;
                    e1.nyagujarati = 2718;
                    e1.nyagurmukhi = 2590;
                    e1.o = 111;
                    e1.oacute = 243;
                    e1.oangthai = 3629;
                    e1.obarred = 629;
                    e1.obarredcyrillic = 1257;
                    e1.obarreddieresiscyrillic = 1259;
                    e1.obengali = 2451;
                    e1.obopomofo = 12571;
                    e1.obreve = 335;
                    e1.ocandradeva = 2321;
                    e1.ocandragujarati = 2705;
                    e1.ocandravowelsigndeva = 2377;
                    e1.ocandravowelsigngujarati = 2761;
                    e1.ocaron = 466;
                    e1.ocircle = 9438;
                    e1.ocircumflex = 244;
                    e1.ocircumflexacute = 7889;
                    e1.ocircumflexdotbelow = 7897;
                    e1.ocircumflexgrave = 7891;
                    e1.ocircumflexhookabove = 7893;
                    e1.ocircumflextilde = 7895;
                    e1.ocyrillic = 1086;
                    e1.odblacute = 337;
                    e1.odblgrave = 525;
                    e1.odeva = 2323;
                    e1.odieresis = 246;
                    e1.odieresiscyrillic = 1255;
                    e1.odotbelow = 7885;
                    e1.oe = 339;
                    e1.oekorean = 12634;
                    e1.ogonek = 731;
                    e1.ogonekcmb = 808;
                    e1.ograve = 242;
                    e1.ogujarati = 2707;
                    e1.oharmenian = 1413;
                    e1.ohiragana = 12362;
                    e1.ohookabove = 7887;
                    e1.ohorn = 417;
                    e1.ohornacute = 7899;
                    e1.ohorndotbelow = 7907;
                    e1.ohorngrave = 7901;
                    e1.ohornhookabove = 7903;
                    e1.ohorntilde = 7905;
                    e1.ohungarumlaut = 337;
                    e1.oi = 419;
                    e1.oinvertedbreve = 527;
                    e1.okatakana = 12458;
                    e1.okatakanahalfwidth = 65397;
                    e1.okorean = 12631;
                    e1.olehebrew = 1451;
                    e1.omacron = 333;
                    e1.omacronacute = 7763;
                    e1.omacrongrave = 7761;
                    e1.omdeva = 2384;
                    e1.omega = 969;
                    e1.omega1 = 982;
                    e1.omegacyrillic = 1121;
                    e1.omegalatinclosed = 631;
                    e1.omegaroundcyrillic = 1147;
                    e1.omegatitlocyrillic = 1149;
                    e1.omegatonos = 974;
                    e1.omgujarati = 2768;
                    e1.omicron = 959;
                    e1.omicrontonos = 972;
                    e1.omonospace = 65359;
                    e1.one = 49;
                    e1.onearabic = 1633;
                    e1.onebengali = 2535;
                    e1.onecircle = 9312;
                    e1.onecircleinversesansserif = 10122;
                    e1.onedeva = 2407;
                    e1.onedotenleader = 8228;
                    e1.oneeighth = 8539;
                    e1.onefitted = 63196;
                    e1.onegujarati = 2791;
                    e1.onegurmukhi = 2663;
                    e1.onehackarabic = 1633;
                    e1.onehalf = 189;
                    e1.onehangzhou = 12321;
                    e1.oneideographicparen = 12832;
                    e1.oneinferior = 8321;
                    e1.onemonospace = 65297;
                    e1.onenumeratorbengali = 2548;
                    e1.oneoldstyle = 63281;
                    e1.oneparen = 9332;
                    e1.oneperiod = 9352;
                    e1.onepersian = 1777;
                    e1.onequarter = 188;
                    e1.oneroman = 8560;
                    e1.onesuperior = 185;
                    e1.onethai = 3665;
                    e1.onethird = 8531;
                    e1.oogonek = 491;
                    e1.oogonekmacron = 493;
                    e1.oogurmukhi = 2579;
                    e1.oomatragurmukhi = 2635;
                    e1.oopen = 596;
                    e1.oparen = 9386;
                    e1.openbullet = 9702;
                    e1.option = 8997;
                    e1.ordfeminine = 170;
                    e1.ordmasculine = 186;
                    e1.orthogonal = 8735;
                    e1.oshortdeva = 2322;
                    e1.oshortvowelsigndeva = 2378;
                    e1.oslash = 248;
                    e1.oslashacute = 511;
                    e1.osmallhiragana = 12361;
                    e1.osmallkatakana = 12457;
                    e1.osmallkatakanahalfwidth = 65387;
                    e1.ostrokeacute = 511;
                    e1.osuperior = 63216;
                    e1.otcyrillic = 1151;
                    e1.otilde = 245;
                    e1.otildeacute = 7757;
                    e1.otildedieresis = 7759;
                    e1.oubopomofo = 12577;
                    e1.overline = 8254;
                    e1.overlinecenterline = 65098;
                    e1.overlinecmb = 773;
                    e1.overlinedashed = 65097;
                    e1.overlinedblwavy = 65100;
                    e1.overlinewavy = 65099;
                    e1.overscore = 175;
                    e1.ovowelsignbengali = 2507;
                    e1.ovowelsigndeva = 2379;
                    e1.ovowelsigngujarati = 2763;
                    e1.p = 112;
                    e1.paampssquare = 13184;
                    e1.paasentosquare = 13099;
                    e1.pabengali = 2474;
                    e1.pacute = 7765;
                    e1.padeva = 2346;
                    e1.pagedown = 8671;
                    e1.pageup = 8670;
                    e1.pagujarati = 2730;
                    e1.pagurmukhi = 2602;
                    e1.pahiragana = 12401;
                    e1.paiyannoithai = 3631;
                    e1.pakatakana = 12497;
                    e1.palatalizationcyrilliccmb = 1156;
                    e1.palochkacyrillic = 1216;
                    e1.pansioskorean = 12671;
                    e1.paragraph = 182;
                    e1.parallel = 8741;
                    e1.parenleft = 40;
                    e1.parenleftaltonearabic = 64830;
                    e1.parenleftbt = 63725;
                    e1.parenleftex = 63724;
                    e1.parenleftinferior = 8333;
                    e1.parenleftmonospace = 65288;
                    e1.parenleftsmall = 65113;
                    e1.parenleftsuperior = 8317;
                    e1.parenlefttp = 63723;
                    e1.parenleftvertical = 65077;
                    e1.parenright = 41;
                    e1.parenrightaltonearabic = 64831;
                    e1.parenrightbt = 63736;
                    e1.parenrightex = 63735;
                    e1.parenrightinferior = 8334;
                    e1.parenrightmonospace = 65289;
                    e1.parenrightsmall = 65114;
                    e1.parenrightsuperior = 8318;
                    e1.parenrighttp = 63734;
                    e1.parenrightvertical = 65078;
                    e1.partialdiff = 8706;
                    e1.paseqhebrew = 1472;
                    e1.pashtahebrew = 1433;
                    e1.pasquare = 13225;
                    e1.patah = 1463;
                    e1.patah11 = 1463;
                    e1.patah1d = 1463;
                    e1.patah2a = 1463;
                    e1.patahhebrew = 1463;
                    e1.patahnarrowhebrew = 1463;
                    e1.patahquarterhebrew = 1463;
                    e1.patahwidehebrew = 1463;
                    e1.pazerhebrew = 1441;
                    e1.pbopomofo = 12550;
                    e1.pcircle = 9439;
                    e1.pdotaccent = 7767;
                    e1.pe = 1508;
                    e1.pecyrillic = 1087;
                    e1.pedagesh = 64324;
                    e1.pedageshhebrew = 64324;
                    e1.peezisquare = 13115;
                    e1.pefinaldageshhebrew = 64323;
                    e1.peharabic = 1662;
                    e1.peharmenian = 1402;
                    e1.pehebrew = 1508;
                    e1.pehfinalarabic = 64343;
                    e1.pehinitialarabic = 64344;
                    e1.pehiragana = 12410;
                    e1.pehmedialarabic = 64345;
                    e1.pekatakana = 12506;
                    e1.pemiddlehookcyrillic = 1191;
                    e1.perafehebrew = 64334;
                    e1.percent = 37;
                    e1.percentarabic = 1642;
                    e1.percentmonospace = 65285;
                    e1.percentsmall = 65130;
                    e1.period = 46;
                    e1.periodarmenian = 1417;
                    e1.periodcentered = 183;
                    e1.periodhalfwidth = 65377;
                    e1.periodinferior = 63207;
                    e1.periodmonospace = 65294;
                    e1.periodsmall = 65106;
                    e1.periodsuperior = 63208;
                    e1.perispomenigreekcmb = 834;
                    e1.perpendicular = 8869;
                    e1.perthousand = 8240;
                    e1.peseta = 8359;
                    e1.pfsquare = 13194;
                    e1.phabengali = 2475;
                    e1.phadeva = 2347;
                    e1.phagujarati = 2731;
                    e1.phagurmukhi = 2603;
                    e1.phi = 966;
                    e1.phi1 = 981;
                    e1.phieuphacirclekorean = 12922;
                    e1.phieuphaparenkorean = 12826;
                    e1.phieuphcirclekorean = 12908;
                    e1.phieuphkorean = 12621;
                    e1.phieuphparenkorean = 12812;
                    e1.philatin = 632;
                    e1.phinthuthai = 3642;
                    e1.phisymbolgreek = 981;
                    e1.phook = 421;
                    e1.phophanthai = 3614;
                    e1.phophungthai = 3612;
                    e1.phosamphaothai = 3616;
                    e1.pi = 960;
                    e1.pieupacirclekorean = 12915;
                    e1.pieupaparenkorean = 12819;
                    e1.pieupcieuckorean = 12662;
                    e1.pieupcirclekorean = 12901;
                    e1.pieupkiyeokkorean = 12658;
                    e1.pieupkorean = 12610;
                    e1.pieupparenkorean = 12805;
                    e1.pieupsioskiyeokkorean = 12660;
                    e1.pieupsioskorean = 12612;
                    e1.pieupsiostikeutkorean = 12661;
                    e1.pieupthieuthkorean = 12663;
                    e1.pieuptikeutkorean = 12659;
                    e1.pihiragana = 12404;
                    e1.pikatakana = 12500;
                    e1.pisymbolgreek = 982;
                    e1.piwrarmenian = 1411;
                    e1.planckover2pi = 8463;
                    e1.planckover2pi1 = 8463;
                    e1.plus = 43;
                    e1.plusbelowcmb = 799;
                    e1.pluscircle = 8853;
                    e1.plusminus = 177;
                    e1.plusmod = 726;
                    e1.plusmonospace = 65291;
                    e1.plussmall = 65122;
                    e1.plussuperior = 8314;
                    e1.pmonospace = 65360;
                    e1.pmsquare = 13272;
                    e1.pohiragana = 12413;
                    e1.pointingindexdownwhite = 9759;
                    e1.pointingindexleftwhite = 9756;
                    e1.pointingindexrightwhite = 9758;
                    e1.pointingindexupwhite = 9757;
                    e1.pokatakana = 12509;
                    e1.poplathai = 3611;
                    e1.postalmark = 12306;
                    e1.postalmarkface = 12320;
                    e1.pparen = 9387;
                    e1.precedes = 8826;
                    e1.prescription = 8478;
                    e1.primemod = 697;
                    e1.primereversed = 8245;
                    e1.product = 8719;
                    e1.projective = 8965;
                    e1.prolongedkana = 12540;
                    e1.propellor = 8984;
                    e1.propersubset = 8834;
                    e1.propersuperset = 8835;
                    e1.proportion = 8759;
                    e1.proportional = 8733;
                    e1.psi = 968;
                    e1.psicyrillic = 1137;
                    e1.psilipneumatacyrilliccmb = 1158;
                    e1.pssquare = 13232;
                    e1.puhiragana = 12407;
                    e1.pukatakana = 12503;
                    e1.pvsquare = 13236;
                    e1.pwsquare = 13242;
                    e1.q = 113;
                    e1.qadeva = 2392;
                    e1.qadmahebrew = 1448;
                    e1.qafarabic = 1602;
                    e1.qaffinalarabic = 65238;
                    e1.qafinitialarabic = 65239;
                    e1.qafmedialarabic = 65240;
                    e1.qamats = 1464;
                    e1.qamats10 = 1464;
                    e1.qamats1a = 1464;
                    e1.qamats1c = 1464;
                    e1.qamats27 = 1464;
                    e1.qamats29 = 1464;
                    e1.qamats33 = 1464;
                    e1.qamatsde = 1464;
                    e1.qamatshebrew = 1464;
                    e1.qamatsnarrowhebrew = 1464;
                    e1.qamatsqatanhebrew = 1464;
                    e1.qamatsqatannarrowhebrew = 1464;
                    e1.qamatsqatanquarterhebrew = 1464;
                    e1.qamatsqatanwidehebrew = 1464;
                    e1.qamatsquarterhebrew = 1464;
                    e1.qamatswidehebrew = 1464;
                    e1.qarneyparahebrew = 1439;
                    e1.qbopomofo = 12561;
                    e1.qcircle = 9440;
                    e1.qhook = 672;
                    e1.qmonospace = 65361;
                    e1.qof = 1511;
                    e1.qofdagesh = 64327;
                    e1.qofdageshhebrew = 64327;
                    e1.qofhebrew = 1511;
                    e1.qparen = 9388;
                    e1.quarternote = 9833;
                    e1.qubuts = 1467;
                    e1.qubuts18 = 1467;
                    e1.qubuts25 = 1467;
                    e1.qubuts31 = 1467;
                    e1.qubutshebrew = 1467;
                    e1.qubutsnarrowhebrew = 1467;
                    e1.qubutsquarterhebrew = 1467;
                    e1.qubutswidehebrew = 1467;
                    e1.question = 63;
                    e1.questionarabic = 1567;
                    e1.questionarmenian = 1374;
                    e1.questiondown = 191;
                    e1.questiondownsmall = 63423;
                    e1.questiongreek = 894;
                    e1.questionmonospace = 65311;
                    e1.questionsmall = 63295;
                    e1.quotedbl = 34;
                    e1.quotedblbase = 8222;
                    e1.quotedblleft = 8220;
                    e1.quotedblmonospace = 65282;
                    e1.quotedblprime = 12318;
                    e1.quotedblprimereversed = 12317;
                    e1.quotedblright = 8221;
                    e1.quoteleft = 8216;
                    e1.quoteleftreversed = 8219;
                    e1.quotereversed = 8219;
                    e1.quoteright = 8217;
                    e1.quoterightn = 329;
                    e1.quotesinglbase = 8218;
                    e1.quotesingle = 39;
                    e1.quotesinglemonospace = 65287;
                    e1.r = 114;
                    e1.raarmenian = 1404;
                    e1.rabengali = 2480;
                    e1.racute = 341;
                    e1.radeva = 2352;
                    e1.radical = 8730;
                    e1.radicalex = 63717;
                    e1.radoverssquare = 13230;
                    e1.radoverssquaredsquare = 13231;
                    e1.radsquare = 13229;
                    e1.rafe = 1471;
                    e1.rafehebrew = 1471;
                    e1.ragujarati = 2736;
                    e1.ragurmukhi = 2608;
                    e1.rahiragana = 12425;
                    e1.rakatakana = 12521;
                    e1.rakatakanahalfwidth = 65431;
                    e1.ralowerdiagonalbengali = 2545;
                    e1.ramiddlediagonalbengali = 2544;
                    e1.ramshorn = 612;
                    e1.ratio = 8758;
                    e1.rbopomofo = 12566;
                    e1.rcaron = 345;
                    e1.rcedilla = 343;
                    e1.rcircle = 9441;
                    e1.rcommaaccent = 343;
                    e1.rdblgrave = 529;
                    e1.rdotaccent = 7769;
                    e1.rdotbelow = 7771;
                    e1.rdotbelowmacron = 7773;
                    e1.referencemark = 8251;
                    e1.reflexsubset = 8838;
                    e1.reflexsuperset = 8839;
                    e1.registered = 174;
                    e1.registersans = 63720;
                    e1.registerserif = 63194;
                    e1.reharabic = 1585;
                    e1.reharmenian = 1408;
                    e1.rehfinalarabic = 65198;
                    e1.rehiragana = 12428;
                    e1.rekatakana = 12524;
                    e1.rekatakanahalfwidth = 65434;
                    e1.resh = 1512;
                    e1.reshdageshhebrew = 64328;
                    e1.reshhebrew = 1512;
                    e1.reversedtilde = 8765;
                    e1.reviahebrew = 1431;
                    e1.reviamugrashhebrew = 1431;
                    e1.revlogicalnot = 8976;
                    e1.rfishhook = 638;
                    e1.rfishhookreversed = 639;
                    e1.rhabengali = 2525;
                    e1.rhadeva = 2397;
                    e1.rho = 961;
                    e1.rhook = 637;
                    e1.rhookturned = 635;
                    e1.rhookturnedsuperior = 693;
                    e1.rhosymbolgreek = 1009;
                    e1.rhotichookmod = 734;
                    e1.rieulacirclekorean = 12913;
                    e1.rieulaparenkorean = 12817;
                    e1.rieulcirclekorean = 12899;
                    e1.rieulhieuhkorean = 12608;
                    e1.rieulkiyeokkorean = 12602;
                    e1.rieulkiyeoksioskorean = 12649;
                    e1.rieulkorean = 12601;
                    e1.rieulmieumkorean = 12603;
                    e1.rieulpansioskorean = 12652;
                    e1.rieulparenkorean = 12803;
                    e1.rieulphieuphkorean = 12607;
                    e1.rieulpieupkorean = 12604;
                    e1.rieulpieupsioskorean = 12651;
                    e1.rieulsioskorean = 12605;
                    e1.rieulthieuthkorean = 12606;
                    e1.rieultikeutkorean = 12650;
                    e1.rieulyeorinhieuhkorean = 12653;
                    e1.rightangle = 8735;
                    e1.righttackbelowcmb = 793;
                    e1.righttriangle = 8895;
                    e1.rihiragana = 12426;
                    e1.rikatakana = 12522;
                    e1.rikatakanahalfwidth = 65432;
                    e1.ring = 730;
                    e1.ringbelowcmb = 805;
                    e1.ringcmb = 778;
                    e1.ringhalfleft = 703;
                    e1.ringhalfleftarmenian = 1369;
                    e1.ringhalfleftbelowcmb = 796;
                    e1.ringhalfleftcentered = 723;
                    e1.ringhalfright = 702;
                    e1.ringhalfrightbelowcmb = 825;
                    e1.ringhalfrightcentered = 722;
                    e1.rinvertedbreve = 531;
                    e1.rittorusquare = 13137;
                    e1.rlinebelow = 7775;
                    e1.rlongleg = 636;
                    e1.rlonglegturned = 634;
                    e1.rmonospace = 65362;
                    e1.rohiragana = 12429;
                    e1.rokatakana = 12525;
                    e1.rokatakanahalfwidth = 65435;
                    e1.roruathai = 3619;
                    e1.rparen = 9389;
                    e1.rrabengali = 2524;
                    e1.rradeva = 2353;
                    e1.rragurmukhi = 2652;
                    e1.rreharabic = 1681;
                    e1.rrehfinalarabic = 64397;
                    e1.rrvocalicbengali = 2528;
                    e1.rrvocalicdeva = 2400;
                    e1.rrvocalicgujarati = 2784;
                    e1.rrvocalicvowelsignbengali = 2500;
                    e1.rrvocalicvowelsigndeva = 2372;
                    e1.rrvocalicvowelsigngujarati = 2756;
                    e1.rsuperior = 63217;
                    e1.rtblock = 9616;
                    e1.rturned = 633;
                    e1.rturnedsuperior = 692;
                    e1.ruhiragana = 12427;
                    e1.rukatakana = 12523;
                    e1.rukatakanahalfwidth = 65433;
                    e1.rupeemarkbengali = 2546;
                    e1.rupeesignbengali = 2547;
                    e1.rupiah = 63197;
                    e1.ruthai = 3620;
                    e1.rvocalicbengali = 2443;
                    e1.rvocalicdeva = 2315;
                    e1.rvocalicgujarati = 2699;
                    e1.rvocalicvowelsignbengali = 2499;
                    e1.rvocalicvowelsigndeva = 2371;
                    e1.rvocalicvowelsigngujarati = 2755;
                    e1.s = 115;
                    e1.sabengali = 2488;
                    e1.sacute = 347;
                    e1.sacutedotaccent = 7781;
                    e1.sadarabic = 1589;
                    e1.sadeva = 2360;
                    e1.sadfinalarabic = 65210;
                    e1.sadinitialarabic = 65211;
                    e1.sadmedialarabic = 65212;
                    e1.sagujarati = 2744;
                    e1.sagurmukhi = 2616;
                    e1.sahiragana = 12373;
                    e1.sakatakana = 12469;
                    e1.sakatakanahalfwidth = 65403;
                    e1.sallallahoualayhewasallamarabic = 65018;
                    e1.samekh = 1505;
                    e1.samekhdagesh = 64321;
                    e1.samekhdageshhebrew = 64321;
                    e1.samekhhebrew = 1505;
                    e1.saraaathai = 3634;
                    e1.saraaethai = 3649;
                    e1.saraaimaimalaithai = 3652;
                    e1.saraaimaimuanthai = 3651;
                    e1.saraamthai = 3635;
                    e1.saraathai = 3632;
                    e1.saraethai = 3648;
                    e1.saraiileftthai = 63622;
                    e1.saraiithai = 3637;
                    e1.saraileftthai = 63621;
                    e1.saraithai = 3636;
                    e1.saraothai = 3650;
                    e1.saraueeleftthai = 63624;
                    e1.saraueethai = 3639;
                    e1.saraueleftthai = 63623;
                    e1.sarauethai = 3638;
                    e1.sarauthai = 3640;
                    e1.sarauuthai = 3641;
                    e1.sbopomofo = 12569;
                    e1.scaron = 353;
                    e1.scarondotaccent = 7783;
                    e1.scedilla = 351;
                    e1.schwa = 601;
                    e1.schwacyrillic = 1241;
                    e1.schwadieresiscyrillic = 1243;
                    e1.schwahook = 602;
                    e1.scircle = 9442;
                    e1.scircumflex = 349;
                    e1.scommaaccent = 537;
                    e1.sdotaccent = 7777;
                    e1.sdotbelow = 7779;
                    e1.sdotbelowdotaccent = 7785;
                    e1.seagullbelowcmb = 828;
                    e1.second = 8243;
                    e1.secondtonechinese = 714;
                    e1.section = 167;
                    e1.seenarabic = 1587;
                    e1.seenfinalarabic = 65202;
                    e1.seeninitialarabic = 65203;
                    e1.seenmedialarabic = 65204;
                    e1.segol = 1462;
                    e1.segol13 = 1462;
                    e1.segol1f = 1462;
                    e1.segol2c = 1462;
                    e1.segolhebrew = 1462;
                    e1.segolnarrowhebrew = 1462;
                    e1.segolquarterhebrew = 1462;
                    e1.segoltahebrew = 1426;
                    e1.segolwidehebrew = 1462;
                    e1.seharmenian = 1405;
                    e1.sehiragana = 12379;
                    e1.sekatakana = 12475;
                    e1.sekatakanahalfwidth = 65406;
                    e1.semicolon = 59;
                    e1.semicolonarabic = 1563;
                    e1.semicolonmonospace = 65307;
                    e1.semicolonsmall = 65108;
                    e1.semivoicedmarkkana = 12444;
                    e1.semivoicedmarkkanahalfwidth = 65439;
                    e1.sentisquare = 13090;
                    e1.sentosquare = 13091;
                    e1.seven = 55;
                    e1.sevenarabic = 1639;
                    e1.sevenbengali = 2541;
                    e1.sevencircle = 9318;
                    e1.sevencircleinversesansserif = 10128;
                    e1.sevendeva = 2413;
                    e1.seveneighths = 8542;
                    e1.sevengujarati = 2797;
                    e1.sevengurmukhi = 2669;
                    e1.sevenhackarabic = 1639;
                    e1.sevenhangzhou = 12327;
                    e1.sevenideographicparen = 12838;
                    e1.seveninferior = 8327;
                    e1.sevenmonospace = 65303;
                    e1.sevenoldstyle = 63287;
                    e1.sevenparen = 9338;
                    e1.sevenperiod = 9358;
                    e1.sevenpersian = 1783;
                    e1.sevenroman = 8566;
                    e1.sevensuperior = 8311;
                    e1.seventeencircle = 9328;
                    e1.seventeenparen = 9348;
                    e1.seventeenperiod = 9368;
                    e1.seventhai = 3671;
                    e1.sfthyphen = 173;
                    e1.shaarmenian = 1399;
                    e1.shabengali = 2486;
                    e1.shacyrillic = 1096;
                    e1.shaddaarabic = 1617;
                    e1.shaddadammaarabic = 64609;
                    e1.shaddadammatanarabic = 64606;
                    e1.shaddafathaarabic = 64608;
                    e1.shaddakasraarabic = 64610;
                    e1.shaddakasratanarabic = 64607;
                    e1.shade = 9618;
                    e1.shadedark = 9619;
                    e1.shadelight = 9617;
                    e1.shademedium = 9618;
                    e1.shadeva = 2358;
                    e1.shagujarati = 2742;
                    e1.shagurmukhi = 2614;
                    e1.shalshelethebrew = 1427;
                    e1.shbopomofo = 12565;
                    e1.shchacyrillic = 1097;
                    e1.sheenarabic = 1588;
                    e1.sheenfinalarabic = 65206;
                    e1.sheeninitialarabic = 65207;
                    e1.sheenmedialarabic = 65208;
                    e1.sheicoptic = 995;
                    e1.sheqel = 8362;
                    e1.sheqelhebrew = 8362;
                    e1.sheva = 1456;
                    e1.sheva115 = 1456;
                    e1.sheva15 = 1456;
                    e1.sheva22 = 1456;
                    e1.sheva2e = 1456;
                    e1.shevahebrew = 1456;
                    e1.shevanarrowhebrew = 1456;
                    e1.shevaquarterhebrew = 1456;
                    e1.shevawidehebrew = 1456;
                    e1.shhacyrillic = 1211;
                    e1.shimacoptic = 1005;
                    e1.shin = 1513;
                    e1.shindagesh = 64329;
                    e1.shindageshhebrew = 64329;
                    e1.shindageshshindot = 64300;
                    e1.shindageshshindothebrew = 64300;
                    e1.shindageshsindot = 64301;
                    e1.shindageshsindothebrew = 64301;
                    e1.shindothebrew = 1473;
                    e1.shinhebrew = 1513;
                    e1.shinshindot = 64298;
                    e1.shinshindothebrew = 64298;
                    e1.shinsindot = 64299;
                    e1.shinsindothebrew = 64299;
                    e1.shook = 642;
                    e1.sigma = 963;
                    e1.sigma1 = 962;
                    e1.sigmafinal = 962;
                    e1.sigmalunatesymbolgreek = 1010;
                    e1.sihiragana = 12375;
                    e1.sikatakana = 12471;
                    e1.sikatakanahalfwidth = 65404;
                    e1.siluqhebrew = 1469;
                    e1.siluqlefthebrew = 1469;
                    e1.similar = 8764;
                    e1.sindothebrew = 1474;
                    e1.siosacirclekorean = 12916;
                    e1.siosaparenkorean = 12820;
                    e1.sioscieuckorean = 12670;
                    e1.sioscirclekorean = 12902;
                    e1.sioskiyeokkorean = 12666;
                    e1.sioskorean = 12613;
                    e1.siosnieunkorean = 12667;
                    e1.siosparenkorean = 12806;
                    e1.siospieupkorean = 12669;
                    e1.siostikeutkorean = 12668;
                    e1.six = 54;
                    e1.sixarabic = 1638;
                    e1.sixbengali = 2540;
                    e1.sixcircle = 9317;
                    e1.sixcircleinversesansserif = 10127;
                    e1.sixdeva = 2412;
                    e1.sixgujarati = 2796;
                    e1.sixgurmukhi = 2668;
                    e1.sixhackarabic = 1638;
                    e1.sixhangzhou = 12326;
                    e1.sixideographicparen = 12837;
                    e1.sixinferior = 8326;
                    e1.sixmonospace = 65302;
                    e1.sixoldstyle = 63286;
                    e1.sixparen = 9337;
                    e1.sixperiod = 9357;
                    e1.sixpersian = 1782;
                    e1.sixroman = 8565;
                    e1.sixsuperior = 8310;
                    e1.sixteencircle = 9327;
                    e1.sixteencurrencydenominatorbengali = 2553;
                    e1.sixteenparen = 9347;
                    e1.sixteenperiod = 9367;
                    e1.sixthai = 3670;
                    e1.slash = 47;
                    e1.slashmonospace = 65295;
                    e1.slong = 383;
                    e1.slongdotaccent = 7835;
                    e1.smileface = 9786;
                    e1.smonospace = 65363;
                    e1.sofpasuqhebrew = 1475;
                    e1.softhyphen = 173;
                    e1.softsigncyrillic = 1100;
                    e1.sohiragana = 12381;
                    e1.sokatakana = 12477;
                    e1.sokatakanahalfwidth = 65407;
                    e1.soliduslongoverlaycmb = 824;
                    e1.solidusshortoverlaycmb = 823;
                    e1.sorusithai = 3625;
                    e1.sosalathai = 3624;
                    e1.sosothai = 3595;
                    e1.sosuathai = 3626;
                    e1.space = 32;
                    e1.spacehackarabic = 32;
                    e1.spade = 9824;
                    e1.spadesuitblack = 9824;
                    e1.spadesuitwhite = 9828;
                    e1.sparen = 9390;
                    e1.squarebelowcmb = 827;
                    e1.squarecc = 13252;
                    e1.squarecm = 13213;
                    e1.squarediagonalcrosshatchfill = 9641;
                    e1.squarehorizontalfill = 9636;
                    e1.squarekg = 13199;
                    e1.squarekm = 13214;
                    e1.squarekmcapital = 13262;
                    e1.squareln = 13265;
                    e1.squarelog = 13266;
                    e1.squaremg = 13198;
                    e1.squaremil = 13269;
                    e1.squaremm = 13212;
                    e1.squaremsquared = 13217;
                    e1.squareorthogonalcrosshatchfill = 9638;
                    e1.squareupperlefttolowerrightfill = 9639;
                    e1.squareupperrighttolowerleftfill = 9640;
                    e1.squareverticalfill = 9637;
                    e1.squarewhitewithsmallblack = 9635;
                    e1.srsquare = 13275;
                    e1.ssabengali = 2487;
                    e1.ssadeva = 2359;
                    e1.ssagujarati = 2743;
                    e1.ssangcieuckorean = 12617;
                    e1.ssanghieuhkorean = 12677;
                    e1.ssangieungkorean = 12672;
                    e1.ssangkiyeokkorean = 12594;
                    e1.ssangnieunkorean = 12645;
                    e1.ssangpieupkorean = 12611;
                    e1.ssangsioskorean = 12614;
                    e1.ssangtikeutkorean = 12600;
                    e1.ssuperior = 63218;
                    e1.sterling = 163;
                    e1.sterlingmonospace = 65505;
                    e1.strokelongoverlaycmb = 822;
                    e1.strokeshortoverlaycmb = 821;
                    e1.subset = 8834;
                    e1.subsetnotequal = 8842;
                    e1.subsetorequal = 8838;
                    e1.succeeds = 8827;
                    e1.suchthat = 8715;
                    e1.suhiragana = 12377;
                    e1.sukatakana = 12473;
                    e1.sukatakanahalfwidth = 65405;
                    e1.sukunarabic = 1618;
                    e1.summation = 8721;
                    e1.sun = 9788;
                    e1.superset = 8835;
                    e1.supersetnotequal = 8843;
                    e1.supersetorequal = 8839;
                    e1.svsquare = 13276;
                    e1.syouwaerasquare = 13180;
                    e1.t = 116;
                    e1.tabengali = 2468;
                    e1.tackdown = 8868;
                    e1.tackleft = 8867;
                    e1.tadeva = 2340;
                    e1.tagujarati = 2724;
                    e1.tagurmukhi = 2596;
                    e1.taharabic = 1591;
                    e1.tahfinalarabic = 65218;
                    e1.tahinitialarabic = 65219;
                    e1.tahiragana = 12383;
                    e1.tahmedialarabic = 65220;
                    e1.taisyouerasquare = 13181;
                    e1.takatakana = 12479;
                    e1.takatakanahalfwidth = 65408;
                    e1.tatweelarabic = 1600;
                    e1.tau = 964;
                    e1.tav = 1514;
                    e1.tavdages = 64330;
                    e1.tavdagesh = 64330;
                    e1.tavdageshhebrew = 64330;
                    e1.tavhebrew = 1514;
                    e1.tbar = 359;
                    e1.tbopomofo = 12554;
                    e1.tcaron = 357;
                    e1.tccurl = 680;
                    e1.tcedilla = 355;
                    e1.tcheharabic = 1670;
                    e1.tchehfinalarabic = 64379;
                    e1.tchehinitialarabic = 64380;
                    e1.tchehmedialarabic = 64381;
                    e1.tcircle = 9443;
                    e1.tcircumflexbelow = 7793;
                    e1.tcommaaccent = 355;
                    e1.tdieresis = 7831;
                    e1.tdotaccent = 7787;
                    e1.tdotbelow = 7789;
                    e1.tecyrillic = 1090;
                    e1.tedescendercyrillic = 1197;
                    e1.teharabic = 1578;
                    e1.tehfinalarabic = 65174;
                    e1.tehhahinitialarabic = 64674;
                    e1.tehhahisolatedarabic = 64524;
                    e1.tehinitialarabic = 65175;
                    e1.tehiragana = 12390;
                    e1.tehjeeminitialarabic = 64673;
                    e1.tehjeemisolatedarabic = 64523;
                    e1.tehmarbutaarabic = 1577;
                    e1.tehmarbutafinalarabic = 65172;
                    e1.tehmedialarabic = 65176;
                    e1.tehmeeminitialarabic = 64676;
                    e1.tehmeemisolatedarabic = 64526;
                    e1.tehnoonfinalarabic = 64627;
                    e1.tekatakana = 12486;
                    e1.tekatakanahalfwidth = 65411;
                    e1.telephone = 8481;
                    e1.telephoneblack = 9742;
                    e1.telishagedolahebrew = 1440;
                    e1.telishaqetanahebrew = 1449;
                    e1.tencircle = 9321;
                    e1.tenideographicparen = 12841;
                    e1.tenparen = 9341;
                    e1.tenperiod = 9361;
                    e1.tenroman = 8569;
                    e1.tesh = 679;
                    e1.tet = 1496;
                    e1.tetdagesh = 64312;
                    e1.tetdageshhebrew = 64312;
                    e1.tethebrew = 1496;
                    e1.tetsecyrillic = 1205;
                    e1.tevirhebrew = 1435;
                    e1.tevirlefthebrew = 1435;
                    e1.thabengali = 2469;
                    e1.thadeva = 2341;
                    e1.thagujarati = 2725;
                    e1.thagurmukhi = 2597;
                    e1.thalarabic = 1584;
                    e1.thalfinalarabic = 65196;
                    e1.thanthakhatlowleftthai = 63640;
                    e1.thanthakhatlowrightthai = 63639;
                    e1.thanthakhatthai = 3660;
                    e1.thanthakhatupperleftthai = 63638;
                    e1.theharabic = 1579;
                    e1.thehfinalarabic = 65178;
                    e1.thehinitialarabic = 65179;
                    e1.thehmedialarabic = 65180;
                    e1.thereexists = 8707;
                    e1.therefore = 8756;
                    e1.theta = 952;
                    e1.theta1 = 977;
                    e1.thetasymbolgreek = 977;
                    e1.thieuthacirclekorean = 12921;
                    e1.thieuthaparenkorean = 12825;
                    e1.thieuthcirclekorean = 12907;
                    e1.thieuthkorean = 12620;
                    e1.thieuthparenkorean = 12811;
                    e1.thirteencircle = 9324;
                    e1.thirteenparen = 9344;
                    e1.thirteenperiod = 9364;
                    e1.thonangmonthothai = 3601;
                    e1.thook = 429;
                    e1.thophuthaothai = 3602;
                    e1.thorn = 254;
                    e1.thothahanthai = 3607;
                    e1.thothanthai = 3600;
                    e1.thothongthai = 3608;
                    e1.thothungthai = 3606;
                    e1.thousandcyrillic = 1154;
                    e1.thousandsseparatorarabic = 1644;
                    e1.thousandsseparatorpersian = 1644;
                    e1.three = 51;
                    e1.threearabic = 1635;
                    e1.threebengali = 2537;
                    e1.threecircle = 9314;
                    e1.threecircleinversesansserif = 10124;
                    e1.threedeva = 2409;
                    e1.threeeighths = 8540;
                    e1.threegujarati = 2793;
                    e1.threegurmukhi = 2665;
                    e1.threehackarabic = 1635;
                    e1.threehangzhou = 12323;
                    e1.threeideographicparen = 12834;
                    e1.threeinferior = 8323;
                    e1.threemonospace = 65299;
                    e1.threenumeratorbengali = 2550;
                    e1.threeoldstyle = 63283;
                    e1.threeparen = 9334;
                    e1.threeperiod = 9354;
                    e1.threepersian = 1779;
                    e1.threequarters = 190;
                    e1.threequartersemdash = 63198;
                    e1.threeroman = 8562;
                    e1.threesuperior = 179;
                    e1.threethai = 3667;
                    e1.thzsquare = 13204;
                    e1.tihiragana = 12385;
                    e1.tikatakana = 12481;
                    e1.tikatakanahalfwidth = 65409;
                    e1.tikeutacirclekorean = 12912;
                    e1.tikeutaparenkorean = 12816;
                    e1.tikeutcirclekorean = 12898;
                    e1.tikeutkorean = 12599;
                    e1.tikeutparenkorean = 12802;
                    e1.tilde = 732;
                    e1.tildebelowcmb = 816;
                    e1.tildecmb = 771;
                    e1.tildecomb = 771;
                    e1.tildedoublecmb = 864;
                    e1.tildeoperator = 8764;
                    e1.tildeoverlaycmb = 820;
                    e1.tildeverticalcmb = 830;
                    e1.timescircle = 8855;
                    e1.tipehahebrew = 1430;
                    e1.tipehalefthebrew = 1430;
                    e1.tippigurmukhi = 2672;
                    e1.titlocyrilliccmb = 1155;
                    e1.tiwnarmenian = 1407;
                    e1.tlinebelow = 7791;
                    e1.tmonospace = 65364;
                    e1.toarmenian = 1385;
                    e1.tohiragana = 12392;
                    e1.tokatakana = 12488;
                    e1.tokatakanahalfwidth = 65412;
                    e1.tonebarextrahighmod = 741;
                    e1.tonebarextralowmod = 745;
                    e1.tonebarhighmod = 742;
                    e1.tonebarlowmod = 744;
                    e1.tonebarmidmod = 743;
                    e1.tonefive = 445;
                    e1.tonesix = 389;
                    e1.tonetwo = 424;
                    e1.tonos = 900;
                    e1.tonsquare = 13095;
                    e1.topatakthai = 3599;
                    e1.tortoiseshellbracketleft = 12308;
                    e1.tortoiseshellbracketleftsmall = 65117;
                    e1.tortoiseshellbracketleftvertical = 65081;
                    e1.tortoiseshellbracketright = 12309;
                    e1.tortoiseshellbracketrightsmall = 65118;
                    e1.tortoiseshellbracketrightvertical = 65082;
                    e1.totaothai = 3605;
                    e1.tpalatalhook = 427;
                    e1.tparen = 9391;
                    e1.trademark = 8482;
                    e1.trademarksans = 63722;
                    e1.trademarkserif = 63195;
                    e1.tretroflexhook = 648;
                    e1.triagdn = 9660;
                    e1.triaglf = 9668;
                    e1.triagrt = 9658;
                    e1.triagup = 9650;
                    e1.ts = 678;
                    e1.tsadi = 1510;
                    e1.tsadidagesh = 64326;
                    e1.tsadidageshhebrew = 64326;
                    e1.tsadihebrew = 1510;
                    e1.tsecyrillic = 1094;
                    e1.tsere = 1461;
                    e1.tsere12 = 1461;
                    e1.tsere1e = 1461;
                    e1.tsere2b = 1461;
                    e1.tserehebrew = 1461;
                    e1.tserenarrowhebrew = 1461;
                    e1.tserequarterhebrew = 1461;
                    e1.tserewidehebrew = 1461;
                    e1.tshecyrillic = 1115;
                    e1.tsuperior = 63219;
                    e1.ttabengali = 2463;
                    e1.ttadeva = 2335;
                    e1.ttagujarati = 2719;
                    e1.ttagurmukhi = 2591;
                    e1.tteharabic = 1657;
                    e1.ttehfinalarabic = 64359;
                    e1.ttehinitialarabic = 64360;
                    e1.ttehmedialarabic = 64361;
                    e1.tthabengali = 2464;
                    e1.tthadeva = 2336;
                    e1.tthagujarati = 2720;
                    e1.tthagurmukhi = 2592;
                    e1.tturned = 647;
                    e1.tuhiragana = 12388;
                    e1.tukatakana = 12484;
                    e1.tukatakanahalfwidth = 65410;
                    e1.tusmallhiragana = 12387;
                    e1.tusmallkatakana = 12483;
                    e1.tusmallkatakanahalfwidth = 65391;
                    e1.twelvecircle = 9323;
                    e1.twelveparen = 9343;
                    e1.twelveperiod = 9363;
                    e1.twelveroman = 8571;
                    e1.twentycircle = 9331;
                    e1.twentyhangzhou = 21316;
                    e1.twentyparen = 9351;
                    e1.twentyperiod = 9371;
                    e1.two = 50;
                    e1.twoarabic = 1634;
                    e1.twobengali = 2536;
                    e1.twocircle = 9313;
                    e1.twocircleinversesansserif = 10123;
                    e1.twodeva = 2408;
                    e1.twodotenleader = 8229;
                    e1.twodotleader = 8229;
                    e1.twodotleadervertical = 65072;
                    e1.twogujarati = 2792;
                    e1.twogurmukhi = 2664;
                    e1.twohackarabic = 1634;
                    e1.twohangzhou = 12322;
                    e1.twoideographicparen = 12833;
                    e1.twoinferior = 8322;
                    e1.twomonospace = 65298;
                    e1.twonumeratorbengali = 2549;
                    e1.twooldstyle = 63282;
                    e1.twoparen = 9333;
                    e1.twoperiod = 9353;
                    e1.twopersian = 1778;
                    e1.tworoman = 8561;
                    e1.twostroke = 443;
                    e1.twosuperior = 178;
                    e1.twothai = 3666;
                    e1.twothirds = 8532;
                    e1.u = 117;
                    e1.uacute = 250;
                    e1.ubar = 649;
                    e1.ubengali = 2441;
                    e1.ubopomofo = 12584;
                    e1.ubreve = 365;
                    e1.ucaron = 468;
                    e1.ucircle = 9444;
                    e1.ucircumflex = 251;
                    e1.ucircumflexbelow = 7799;
                    e1.ucyrillic = 1091;
                    e1.udattadeva = 2385;
                    e1.udblacute = 369;
                    e1.udblgrave = 533;
                    e1.udeva = 2313;
                    e1.udieresis = 252;
                    e1.udieresisacute = 472;
                    e1.udieresisbelow = 7795;
                    e1.udieresiscaron = 474;
                    e1.udieresiscyrillic = 1265;
                    e1.udieresisgrave = 476;
                    e1.udieresismacron = 470;
                    e1.udotbelow = 7909;
                    e1.ugrave = 249;
                    e1.ugujarati = 2697;
                    e1.ugurmukhi = 2569;
                    e1.uhiragana = 12358;
                    e1.uhookabove = 7911;
                    e1.uhorn = 432;
                    e1.uhornacute = 7913;
                    e1.uhorndotbelow = 7921;
                    e1.uhorngrave = 7915;
                    e1.uhornhookabove = 7917;
                    e1.uhorntilde = 7919;
                    e1.uhungarumlaut = 369;
                    e1.uhungarumlautcyrillic = 1267;
                    e1.uinvertedbreve = 535;
                    e1.ukatakana = 12454;
                    e1.ukatakanahalfwidth = 65395;
                    e1.ukcyrillic = 1145;
                    e1.ukorean = 12636;
                    e1.umacron = 363;
                    e1.umacroncyrillic = 1263;
                    e1.umacrondieresis = 7803;
                    e1.umatragurmukhi = 2625;
                    e1.umonospace = 65365;
                    e1.underscore = 95;
                    e1.underscoredbl = 8215;
                    e1.underscoremonospace = 65343;
                    e1.underscorevertical = 65075;
                    e1.underscorewavy = 65103;
                    e1.union = 8746;
                    e1.universal = 8704;
                    e1.uogonek = 371;
                    e1.uparen = 9392;
                    e1.upblock = 9600;
                    e1.upperdothebrew = 1476;
                    e1.upsilon = 965;
                    e1.upsilondieresis = 971;
                    e1.upsilondieresistonos = 944;
                    e1.upsilonlatin = 650;
                    e1.upsilontonos = 973;
                    e1.uptackbelowcmb = 797;
                    e1.uptackmod = 724;
                    e1.uragurmukhi = 2675;
                    e1.uring = 367;
                    e1.ushortcyrillic = 1118;
                    e1.usmallhiragana = 12357;
                    e1.usmallkatakana = 12453;
                    e1.usmallkatakanahalfwidth = 65385;
                    e1.ustraightcyrillic = 1199;
                    e1.ustraightstrokecyrillic = 1201;
                    e1.utilde = 361;
                    e1.utildeacute = 7801;
                    e1.utildebelow = 7797;
                    e1.uubengali = 2442;
                    e1.uudeva = 2314;
                    e1.uugujarati = 2698;
                    e1.uugurmukhi = 2570;
                    e1.uumatragurmukhi = 2626;
                    e1.uuvowelsignbengali = 2498;
                    e1.uuvowelsigndeva = 2370;
                    e1.uuvowelsigngujarati = 2754;
                    e1.uvowelsignbengali = 2497;
                    e1.uvowelsigndeva = 2369;
                    e1.uvowelsigngujarati = 2753;
                    e1.v = 118;
                    e1.vadeva = 2357;
                    e1.vagujarati = 2741;
                    e1.vagurmukhi = 2613;
                    e1.vakatakana = 12535;
                    e1.vav = 1493;
                    e1.vavdagesh = 64309;
                    e1.vavdagesh65 = 64309;
                    e1.vavdageshhebrew = 64309;
                    e1.vavhebrew = 1493;
                    e1.vavholam = 64331;
                    e1.vavholamhebrew = 64331;
                    e1.vavvavhebrew = 1520;
                    e1.vavyodhebrew = 1521;
                    e1.vcircle = 9445;
                    e1.vdotbelow = 7807;
                    e1.vecyrillic = 1074;
                    e1.veharabic = 1700;
                    e1.vehfinalarabic = 64363;
                    e1.vehinitialarabic = 64364;
                    e1.vehmedialarabic = 64365;
                    e1.vekatakana = 12537;
                    e1.venus = 9792;
                    e1.verticalbar = 124;
                    e1.verticallineabovecmb = 781;
                    e1.verticallinebelowcmb = 809;
                    e1.verticallinelowmod = 716;
                    e1.verticallinemod = 712;
                    e1.vewarmenian = 1406;
                    e1.vhook = 651;
                    e1.vikatakana = 12536;
                    e1.viramabengali = 2509;
                    e1.viramadeva = 2381;
                    e1.viramagujarati = 2765;
                    e1.visargabengali = 2435;
                    e1.visargadeva = 2307;
                    e1.visargagujarati = 2691;
                    e1.vmonospace = 65366;
                    e1.voarmenian = 1400;
                    e1.voicediterationhiragana = 12446;
                    e1.voicediterationkatakana = 12542;
                    e1.voicedmarkkana = 12443;
                    e1.voicedmarkkanahalfwidth = 65438;
                    e1.vokatakana = 12538;
                    e1.vparen = 9393;
                    e1.vtilde = 7805;
                    e1.vturned = 652;
                    e1.vuhiragana = 12436;
                    e1.vukatakana = 12532;
                    e1.w = 119;
                    e1.wacute = 7811;
                    e1.waekorean = 12633;
                    e1.wahiragana = 12431;
                    e1.wakatakana = 12527;
                    e1.wakatakanahalfwidth = 65436;
                    e1.wakorean = 12632;
                    e1.wasmallhiragana = 12430;
                    e1.wasmallkatakana = 12526;
                    e1.wattosquare = 13143;
                    e1.wavedash = 12316;
                    e1.wavyunderscorevertical = 65076;
                    e1.wawarabic = 1608;
                    e1.wawfinalarabic = 65262;
                    e1.wawhamzaabovearabic = 1572;
                    e1.wawhamzaabovefinalarabic = 65158;
                    e1.wbsquare = 13277;
                    e1.wcircle = 9446;
                    e1.wcircumflex = 373;
                    e1.wdieresis = 7813;
                    e1.wdotaccent = 7815;
                    e1.wdotbelow = 7817;
                    e1.wehiragana = 12433;
                    e1.weierstrass = 8472;
                    e1.wekatakana = 12529;
                    e1.wekorean = 12638;
                    e1.weokorean = 12637;
                    e1.wgrave = 7809;
                    e1.whitebullet = 9702;
                    e1.whitecircle = 9675;
                    e1.whitecircleinverse = 9689;
                    e1.whitecornerbracketleft = 12302;
                    e1.whitecornerbracketleftvertical = 65091;
                    e1.whitecornerbracketright = 12303;
                    e1.whitecornerbracketrightvertical = 65092;
                    e1.whitediamond = 9671;
                    e1.whitediamondcontainingblacksmalldiamond = 9672;
                    e1.whitedownpointingsmalltriangle = 9663;
                    e1.whitedownpointingtriangle = 9661;
                    e1.whiteleftpointingsmalltriangle = 9667;
                    e1.whiteleftpointingtriangle = 9665;
                    e1.whitelenticularbracketleft = 12310;
                    e1.whitelenticularbracketright = 12311;
                    e1.whiterightpointingsmalltriangle = 9657;
                    e1.whiterightpointingtriangle = 9655;
                    e1.whitesmallsquare = 9643;
                    e1.whitesmilingface = 9786;
                    e1.whitesquare = 9633;
                    e1.whitestar = 9734;
                    e1.whitetelephone = 9743;
                    e1.whitetortoiseshellbracketleft = 12312;
                    e1.whitetortoiseshellbracketright = 12313;
                    e1.whiteuppointingsmalltriangle = 9653;
                    e1.whiteuppointingtriangle = 9651;
                    e1.wihiragana = 12432;
                    e1.wikatakana = 12528;
                    e1.wikorean = 12639;
                    e1.wmonospace = 65367;
                    e1.wohiragana = 12434;
                    e1.wokatakana = 12530;
                    e1.wokatakanahalfwidth = 65382;
                    e1.won = 8361;
                    e1.wonmonospace = 65510;
                    e1.wowaenthai = 3623;
                    e1.wparen = 9394;
                    e1.wring = 7832;
                    e1.wsuperior = 695;
                    e1.wturned = 653;
                    e1.wynn = 447;
                    e1.x = 120;
                    e1.xabovecmb = 829;
                    e1.xbopomofo = 12562;
                    e1.xcircle = 9447;
                    e1.xdieresis = 7821;
                    e1.xdotaccent = 7819;
                    e1.xeharmenian = 1389;
                    e1.xi = 958;
                    e1.xmonospace = 65368;
                    e1.xparen = 9395;
                    e1.xsuperior = 739;
                    e1.y = 121;
                    e1.yaadosquare = 13134;
                    e1.yabengali = 2479;
                    e1.yacute = 253;
                    e1.yadeva = 2351;
                    e1.yaekorean = 12626;
                    e1.yagujarati = 2735;
                    e1.yagurmukhi = 2607;
                    e1.yahiragana = 12420;
                    e1.yakatakana = 12516;
                    e1.yakatakanahalfwidth = 65428;
                    e1.yakorean = 12625;
                    e1.yamakkanthai = 3662;
                    e1.yasmallhiragana = 12419;
                    e1.yasmallkatakana = 12515;
                    e1.yasmallkatakanahalfwidth = 65388;
                    e1.yatcyrillic = 1123;
                    e1.ycircle = 9448;
                    e1.ycircumflex = 375;
                    e1.ydieresis = 255;
                    e1.ydotaccent = 7823;
                    e1.ydotbelow = 7925;
                    e1.yeharabic = 1610;
                    e1.yehbarreearabic = 1746;
                    e1.yehbarreefinalarabic = 64431;
                    e1.yehfinalarabic = 65266;
                    e1.yehhamzaabovearabic = 1574;
                    e1.yehhamzaabovefinalarabic = 65162;
                    e1.yehhamzaaboveinitialarabic = 65163;
                    e1.yehhamzaabovemedialarabic = 65164;
                    e1.yehinitialarabic = 65267;
                    e1.yehmedialarabic = 65268;
                    e1.yehmeeminitialarabic = 64733;
                    e1.yehmeemisolatedarabic = 64600;
                    e1.yehnoonfinalarabic = 64660;
                    e1.yehthreedotsbelowarabic = 1745;
                    e1.yekorean = 12630;
                    e1.yen = 165;
                    e1.yenmonospace = 65509;
                    e1.yeokorean = 12629;
                    e1.yeorinhieuhkorean = 12678;
                    e1.yerahbenyomohebrew = 1450;
                    e1.yerahbenyomolefthebrew = 1450;
                    e1.yericyrillic = 1099;
                    e1.yerudieresiscyrillic = 1273;
                    e1.yesieungkorean = 12673;
                    e1.yesieungpansioskorean = 12675;
                    e1.yesieungsioskorean = 12674;
                    e1.yetivhebrew = 1434;
                    e1.ygrave = 7923;
                    e1.yhook = 436;
                    e1.yhookabove = 7927;
                    e1.yiarmenian = 1397;
                    e1.yicyrillic = 1111;
                    e1.yikorean = 12642;
                    e1.yinyang = 9775;
                    e1.yiwnarmenian = 1410;
                    e1.ymonospace = 65369;
                    e1.yod = 1497;
                    e1.yoddagesh = 64313;
                    e1.yoddageshhebrew = 64313;
                    e1.yodhebrew = 1497;
                    e1.yodyodhebrew = 1522;
                    e1.yodyodpatahhebrew = 64287;
                    e1.yohiragana = 12424;
                    e1.yoikorean = 12681;
                    e1.yokatakana = 12520;
                    e1.yokatakanahalfwidth = 65430;
                    e1.yokorean = 12635;
                    e1.yosmallhiragana = 12423;
                    e1.yosmallkatakana = 12519;
                    e1.yosmallkatakanahalfwidth = 65390;
                    e1.yotgreek = 1011;
                    e1.yoyaekorean = 12680;
                    e1.yoyakorean = 12679;
                    e1.yoyakthai = 3618;
                    e1.yoyingthai = 3597;
                    e1.yparen = 9396;
                    e1.ypogegrammeni = 890;
                    e1.ypogegrammenigreekcmb = 837;
                    e1.yr = 422;
                    e1.yring = 7833;
                    e1.ysuperior = 696;
                    e1.ytilde = 7929;
                    e1.yturned = 654;
                    e1.yuhiragana = 12422;
                    e1.yuikorean = 12684;
                    e1.yukatakana = 12518;
                    e1.yukatakanahalfwidth = 65429;
                    e1.yukorean = 12640;
                    e1.yusbigcyrillic = 1131;
                    e1.yusbigiotifiedcyrillic = 1133;
                    e1.yuslittlecyrillic = 1127;
                    e1.yuslittleiotifiedcyrillic = 1129;
                    e1.yusmallhiragana = 12421;
                    e1.yusmallkatakana = 12517;
                    e1.yusmallkatakanahalfwidth = 65389;
                    e1.yuyekorean = 12683;
                    e1.yuyeokorean = 12682;
                    e1.yyabengali = 2527;
                    e1.yyadeva = 2399;
                    e1.z = 122;
                    e1.zaarmenian = 1382;
                    e1.zacute = 378;
                    e1.zadeva = 2395;
                    e1.zagurmukhi = 2651;
                    e1.zaharabic = 1592;
                    e1.zahfinalarabic = 65222;
                    e1.zahinitialarabic = 65223;
                    e1.zahiragana = 12374;
                    e1.zahmedialarabic = 65224;
                    e1.zainarabic = 1586;
                    e1.zainfinalarabic = 65200;
                    e1.zakatakana = 12470;
                    e1.zaqefgadolhebrew = 1429;
                    e1.zaqefqatanhebrew = 1428;
                    e1.zarqahebrew = 1432;
                    e1.zayin = 1494;
                    e1.zayindagesh = 64310;
                    e1.zayindageshhebrew = 64310;
                    e1.zayinhebrew = 1494;
                    e1.zbopomofo = 12567;
                    e1.zcaron = 382;
                    e1.zcircle = 9449;
                    e1.zcircumflex = 7825;
                    e1.zcurl = 657;
                    e1.zdot = 380;
                    e1.zdotaccent = 380;
                    e1.zdotbelow = 7827;
                    e1.zecyrillic = 1079;
                    e1.zedescendercyrillic = 1177;
                    e1.zedieresiscyrillic = 1247;
                    e1.zehiragana = 12380;
                    e1.zekatakana = 12476;
                    e1.zero = 48;
                    e1.zeroarabic = 1632;
                    e1.zerobengali = 2534;
                    e1.zerodeva = 2406;
                    e1.zerogujarati = 2790;
                    e1.zerogurmukhi = 2662;
                    e1.zerohackarabic = 1632;
                    e1.zeroinferior = 8320;
                    e1.zeromonospace = 65296;
                    e1.zerooldstyle = 63280;
                    e1.zeropersian = 1776;
                    e1.zerosuperior = 8304;
                    e1.zerothai = 3664;
                    e1.zerowidthjoiner = 65279;
                    e1.zerowidthnonjoiner = 8204;
                    e1.zerowidthspace = 8203;
                    e1.zeta = 950;
                    e1.zhbopomofo = 12563;
                    e1.zhearmenian = 1386;
                    e1.zhebrevecyrillic = 1218;
                    e1.zhecyrillic = 1078;
                    e1.zhedescendercyrillic = 1175;
                    e1.zhedieresiscyrillic = 1245;
                    e1.zihiragana = 12376;
                    e1.zikatakana = 12472;
                    e1.zinorhebrew = 1454;
                    e1.zlinebelow = 7829;
                    e1.zmonospace = 65370;
                    e1.zohiragana = 12382;
                    e1.zokatakana = 12478;
                    e1.zparen = 9397;
                    e1.zretroflexhook = 656;
                    e1.zstroke = 438;
                    e1.zuhiragana = 12378;
                    e1.zukatakana = 12474;
                    e1[".notdef"] = 0;
                    e1.angbracketleftbig = 9001;
                    e1.angbracketleftBig = 9001;
                    e1.angbracketleftbigg = 9001;
                    e1.angbracketleftBigg = 9001;
                    e1.angbracketrightBig = 9002;
                    e1.angbracketrightbig = 9002;
                    e1.angbracketrightBigg = 9002;
                    e1.angbracketrightbigg = 9002;
                    e1.arrowhookleft = 8618;
                    e1.arrowhookright = 8617;
                    e1.arrowlefttophalf = 8636;
                    e1.arrowleftbothalf = 8637;
                    e1.arrownortheast = 8599;
                    e1.arrownorthwest = 8598;
                    e1.arrowrighttophalf = 8640;
                    e1.arrowrightbothalf = 8641;
                    e1.arrowsoutheast = 8600;
                    e1.arrowsouthwest = 8601;
                    e1.backslashbig = 8726;
                    e1.backslashBig = 8726;
                    e1.backslashBigg = 8726;
                    e1.backslashbigg = 8726;
                    e1.bardbl = 8214;
                    e1.bracehtipdownleft = 65079;
                    e1.bracehtipdownright = 65079;
                    e1.bracehtipupleft = 65080;
                    e1.bracehtipupright = 65080;
                    e1.braceleftBig = 123;
                    e1.braceleftbig = 123;
                    e1.braceleftbigg = 123;
                    e1.braceleftBigg = 123;
                    e1.bracerightBig = 125;
                    e1.bracerightbig = 125;
                    e1.bracerightbigg = 125;
                    e1.bracerightBigg = 125;
                    e1.bracketleftbig = 91;
                    e1.bracketleftBig = 91;
                    e1.bracketleftbigg = 91;
                    e1.bracketleftBigg = 91;
                    e1.bracketrightBig = 93;
                    e1.bracketrightbig = 93;
                    e1.bracketrightbigg = 93;
                    e1.bracketrightBigg = 93;
                    e1.ceilingleftbig = 8968;
                    e1.ceilingleftBig = 8968;
                    e1.ceilingleftBigg = 8968;
                    e1.ceilingleftbigg = 8968;
                    e1.ceilingrightbig = 8969;
                    e1.ceilingrightBig = 8969;
                    e1.ceilingrightbigg = 8969;
                    e1.ceilingrightBigg = 8969;
                    e1.circledotdisplay = 8857;
                    e1.circledottext = 8857;
                    e1.circlemultiplydisplay = 8855;
                    e1.circlemultiplytext = 8855;
                    e1.circleplusdisplay = 8853;
                    e1.circleplustext = 8853;
                    e1.contintegraldisplay = 8750;
                    e1.contintegraltext = 8750;
                    e1.coproductdisplay = 8720;
                    e1.coproducttext = 8720;
                    e1.floorleftBig = 8970;
                    e1.floorleftbig = 8970;
                    e1.floorleftbigg = 8970;
                    e1.floorleftBigg = 8970;
                    e1.floorrightbig = 8971;
                    e1.floorrightBig = 8971;
                    e1.floorrightBigg = 8971;
                    e1.floorrightbigg = 8971;
                    e1.hatwide = 770;
                    e1.hatwider = 770;
                    e1.hatwidest = 770;
                    e1.intercal = 7488;
                    e1.integraldisplay = 8747;
                    e1.integraltext = 8747;
                    e1.intersectiondisplay = 8898;
                    e1.intersectiontext = 8898;
                    e1.logicalanddisplay = 8743;
                    e1.logicalandtext = 8743;
                    e1.logicalordisplay = 8744;
                    e1.logicalortext = 8744;
                    e1.parenleftBig = 40;
                    e1.parenleftbig = 40;
                    e1.parenleftBigg = 40;
                    e1.parenleftbigg = 40;
                    e1.parenrightBig = 41;
                    e1.parenrightbig = 41;
                    e1.parenrightBigg = 41;
                    e1.parenrightbigg = 41;
                    e1.prime = 8242;
                    e1.productdisplay = 8719;
                    e1.producttext = 8719;
                    e1.radicalbig = 8730;
                    e1.radicalBig = 8730;
                    e1.radicalBigg = 8730;
                    e1.radicalbigg = 8730;
                    e1.radicalbt = 8730;
                    e1.radicaltp = 8730;
                    e1.radicalvertex = 8730;
                    e1.slashbig = 47;
                    e1.slashBig = 47;
                    e1.slashBigg = 47;
                    e1.slashbigg = 47;
                    e1.summationdisplay = 8721;
                    e1.summationtext = 8721;
                    e1.tildewide = 732;
                    e1.tildewider = 732;
                    e1.tildewidest = 732;
                    e1.uniondisplay = 8899;
                    e1.unionmultidisplay = 8846;
                    e1.unionmultitext = 8846;
                    e1.unionsqdisplay = 8852;
                    e1.unionsqtext = 8852;
                    e1.uniontext = 8899;
                    e1.vextenddouble = 8741;
                    e1.vextendsingle = 8739;
                });
                t.getGlyphsUnicode = n;
                const i = (0, r.getLookupTableFactory)(function(e1) {
                    e1.space = 32;
                    e1.a1 = 9985;
                    e1.a2 = 9986;
                    e1.a202 = 9987;
                    e1.a3 = 9988;
                    e1.a4 = 9742;
                    e1.a5 = 9990;
                    e1.a119 = 9991;
                    e1.a118 = 9992;
                    e1.a117 = 9993;
                    e1.a11 = 9755;
                    e1.a12 = 9758;
                    e1.a13 = 9996;
                    e1.a14 = 9997;
                    e1.a15 = 9998;
                    e1.a16 = 9999;
                    e1.a105 = 1e4;
                    e1.a17 = 10001;
                    e1.a18 = 10002;
                    e1.a19 = 10003;
                    e1.a20 = 10004;
                    e1.a21 = 10005;
                    e1.a22 = 10006;
                    e1.a23 = 10007;
                    e1.a24 = 10008;
                    e1.a25 = 10009;
                    e1.a26 = 10010;
                    e1.a27 = 10011;
                    e1.a28 = 10012;
                    e1.a6 = 10013;
                    e1.a7 = 10014;
                    e1.a8 = 10015;
                    e1.a9 = 10016;
                    e1.a10 = 10017;
                    e1.a29 = 10018;
                    e1.a30 = 10019;
                    e1.a31 = 10020;
                    e1.a32 = 10021;
                    e1.a33 = 10022;
                    e1.a34 = 10023;
                    e1.a35 = 9733;
                    e1.a36 = 10025;
                    e1.a37 = 10026;
                    e1.a38 = 10027;
                    e1.a39 = 10028;
                    e1.a40 = 10029;
                    e1.a41 = 10030;
                    e1.a42 = 10031;
                    e1.a43 = 10032;
                    e1.a44 = 10033;
                    e1.a45 = 10034;
                    e1.a46 = 10035;
                    e1.a47 = 10036;
                    e1.a48 = 10037;
                    e1.a49 = 10038;
                    e1.a50 = 10039;
                    e1.a51 = 10040;
                    e1.a52 = 10041;
                    e1.a53 = 10042;
                    e1.a54 = 10043;
                    e1.a55 = 10044;
                    e1.a56 = 10045;
                    e1.a57 = 10046;
                    e1.a58 = 10047;
                    e1.a59 = 10048;
                    e1.a60 = 10049;
                    e1.a61 = 10050;
                    e1.a62 = 10051;
                    e1.a63 = 10052;
                    e1.a64 = 10053;
                    e1.a65 = 10054;
                    e1.a66 = 10055;
                    e1.a67 = 10056;
                    e1.a68 = 10057;
                    e1.a69 = 10058;
                    e1.a70 = 10059;
                    e1.a71 = 9679;
                    e1.a72 = 10061;
                    e1.a73 = 9632;
                    e1.a74 = 10063;
                    e1.a203 = 10064;
                    e1.a75 = 10065;
                    e1.a204 = 10066;
                    e1.a76 = 9650;
                    e1.a77 = 9660;
                    e1.a78 = 9670;
                    e1.a79 = 10070;
                    e1.a81 = 9687;
                    e1.a82 = 10072;
                    e1.a83 = 10073;
                    e1.a84 = 10074;
                    e1.a97 = 10075;
                    e1.a98 = 10076;
                    e1.a99 = 10077;
                    e1.a100 = 10078;
                    e1.a101 = 10081;
                    e1.a102 = 10082;
                    e1.a103 = 10083;
                    e1.a104 = 10084;
                    e1.a106 = 10085;
                    e1.a107 = 10086;
                    e1.a108 = 10087;
                    e1.a112 = 9827;
                    e1.a111 = 9830;
                    e1.a110 = 9829;
                    e1.a109 = 9824;
                    e1.a120 = 9312;
                    e1.a121 = 9313;
                    e1.a122 = 9314;
                    e1.a123 = 9315;
                    e1.a124 = 9316;
                    e1.a125 = 9317;
                    e1.a126 = 9318;
                    e1.a127 = 9319;
                    e1.a128 = 9320;
                    e1.a129 = 9321;
                    e1.a130 = 10102;
                    e1.a131 = 10103;
                    e1.a132 = 10104;
                    e1.a133 = 10105;
                    e1.a134 = 10106;
                    e1.a135 = 10107;
                    e1.a136 = 10108;
                    e1.a137 = 10109;
                    e1.a138 = 10110;
                    e1.a139 = 10111;
                    e1.a140 = 10112;
                    e1.a141 = 10113;
                    e1.a142 = 10114;
                    e1.a143 = 10115;
                    e1.a144 = 10116;
                    e1.a145 = 10117;
                    e1.a146 = 10118;
                    e1.a147 = 10119;
                    e1.a148 = 10120;
                    e1.a149 = 10121;
                    e1.a150 = 10122;
                    e1.a151 = 10123;
                    e1.a152 = 10124;
                    e1.a153 = 10125;
                    e1.a154 = 10126;
                    e1.a155 = 10127;
                    e1.a156 = 10128;
                    e1.a157 = 10129;
                    e1.a158 = 10130;
                    e1.a159 = 10131;
                    e1.a160 = 10132;
                    e1.a161 = 8594;
                    e1.a163 = 8596;
                    e1.a164 = 8597;
                    e1.a196 = 10136;
                    e1.a165 = 10137;
                    e1.a192 = 10138;
                    e1.a166 = 10139;
                    e1.a167 = 10140;
                    e1.a168 = 10141;
                    e1.a169 = 10142;
                    e1.a170 = 10143;
                    e1.a171 = 10144;
                    e1.a172 = 10145;
                    e1.a173 = 10146;
                    e1.a162 = 10147;
                    e1.a174 = 10148;
                    e1.a175 = 10149;
                    e1.a176 = 10150;
                    e1.a177 = 10151;
                    e1.a178 = 10152;
                    e1.a179 = 10153;
                    e1.a193 = 10154;
                    e1.a180 = 10155;
                    e1.a199 = 10156;
                    e1.a181 = 10157;
                    e1.a200 = 10158;
                    e1.a182 = 10159;
                    e1.a201 = 10161;
                    e1.a183 = 10162;
                    e1.a184 = 10163;
                    e1.a197 = 10164;
                    e1.a185 = 10165;
                    e1.a194 = 10166;
                    e1.a198 = 10167;
                    e1.a186 = 10168;
                    e1.a195 = 10169;
                    e1.a187 = 10170;
                    e1.a188 = 10171;
                    e1.a189 = 10172;
                    e1.a190 = 10173;
                    e1.a191 = 10174;
                    e1.a89 = 10088;
                    e1.a90 = 10089;
                    e1.a93 = 10090;
                    e1.a94 = 10091;
                    e1.a91 = 10092;
                    e1.a92 = 10093;
                    e1.a205 = 10094;
                    e1.a85 = 10095;
                    e1.a206 = 10096;
                    e1.a86 = 10097;
                    e1.a87 = 10098;
                    e1.a88 = 10099;
                    e1.a95 = 10100;
                    e1.a96 = 10101;
                    e1[".notdef"] = 0;
                });
                t.getDingbatsGlyphsUnicode = i;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.clearUnicodeCaches = function clearUnicodeCaches() {
                    s.clear();
                };
                t.getCharUnicodeCategory = function getCharUnicodeCategory(e1) {
                    const t = s.get(e1);
                    if (t) return t;
                    const a = e1.match(i), r = {
                        isWhitespace: !!a?.[1],
                        isZeroWidthDiacritic: !!a?.[2],
                        isInvisibleFormatMark: !!a?.[3]
                    };
                    s.set(e1, r);
                    return r;
                };
                t.getUnicodeForGlyph = function getUnicodeForGlyph(e1, t) {
                    let a = t[e1];
                    if (void 0 !== a) return a;
                    if (!e1) return -1;
                    if ("u" === e1[0]) {
                        const t = e1.length;
                        let r;
                        if (7 === t && "n" === e1[1] && "i" === e1[2]) r = e1.substring(3);
                        else {
                            if (!(t >= 5 && t <= 7)) return -1;
                            r = e1.substring(1);
                        }
                        if (r === r.toUpperCase()) {
                            a = parseInt(r, 16);
                            if (a >= 0) return a;
                        }
                    }
                    return -1;
                };
                t.getUnicodeRangeFor = function getUnicodeRangeFor(e1, t = -1) {
                    if (-1 !== t) {
                        const a = n[t];
                        for(let r = 0, n = a.length; r < n; r += 2)if (e1 >= a[r] && e1 <= a[r + 1]) return t;
                    }
                    for(let t = 0, a = n.length; t < a; t++){
                        const a = n[t];
                        for(let r = 0, n = a.length; r < n; r += 2)if (e1 >= a[r] && e1 <= a[r + 1]) return t;
                    }
                    return -1;
                };
                t.mapSpecialUnicodeValues = function mapSpecialUnicodeValues(e1) {
                    if (e1 >= 65520 && e1 <= 65535) return 0;
                    if (e1 >= 62976 && e1 <= 63743) return r()[e1] || e1;
                    if (173 === e1) return 45;
                    return e1;
                };
                const r = (0, a(3).getLookupTableFactory)(function(e1) {
                    e1[63721] = 169;
                    e1[63193] = 169;
                    e1[63720] = 174;
                    e1[63194] = 174;
                    e1[63722] = 8482;
                    e1[63195] = 8482;
                    e1[63729] = 9127;
                    e1[63730] = 9128;
                    e1[63731] = 9129;
                    e1[63740] = 9131;
                    e1[63741] = 9132;
                    e1[63742] = 9133;
                    e1[63726] = 9121;
                    e1[63727] = 9122;
                    e1[63728] = 9123;
                    e1[63737] = 9124;
                    e1[63738] = 9125;
                    e1[63739] = 9126;
                    e1[63723] = 9115;
                    e1[63724] = 9116;
                    e1[63725] = 9117;
                    e1[63734] = 9118;
                    e1[63735] = 9119;
                    e1[63736] = 9120;
                });
                const n = [
                    [
                        0,
                        127
                    ],
                    [
                        128,
                        255
                    ],
                    [
                        256,
                        383
                    ],
                    [
                        384,
                        591
                    ],
                    [
                        592,
                        687,
                        7424,
                        7551,
                        7552,
                        7615
                    ],
                    [
                        688,
                        767,
                        42752,
                        42783
                    ],
                    [
                        768,
                        879,
                        7616,
                        7679
                    ],
                    [
                        880,
                        1023
                    ],
                    [
                        11392,
                        11519
                    ],
                    [
                        1024,
                        1279,
                        1280,
                        1327,
                        11744,
                        11775,
                        42560,
                        42655
                    ],
                    [
                        1328,
                        1423
                    ],
                    [
                        1424,
                        1535
                    ],
                    [
                        42240,
                        42559
                    ],
                    [
                        1536,
                        1791,
                        1872,
                        1919
                    ],
                    [
                        1984,
                        2047
                    ],
                    [
                        2304,
                        2431
                    ],
                    [
                        2432,
                        2559
                    ],
                    [
                        2560,
                        2687
                    ],
                    [
                        2688,
                        2815
                    ],
                    [
                        2816,
                        2943
                    ],
                    [
                        2944,
                        3071
                    ],
                    [
                        3072,
                        3199
                    ],
                    [
                        3200,
                        3327
                    ],
                    [
                        3328,
                        3455
                    ],
                    [
                        3584,
                        3711
                    ],
                    [
                        3712,
                        3839
                    ],
                    [
                        4256,
                        4351,
                        11520,
                        11567
                    ],
                    [
                        6912,
                        7039
                    ],
                    [
                        4352,
                        4607
                    ],
                    [
                        7680,
                        7935,
                        11360,
                        11391,
                        42784,
                        43007
                    ],
                    [
                        7936,
                        8191
                    ],
                    [
                        8192,
                        8303,
                        11776,
                        11903
                    ],
                    [
                        8304,
                        8351
                    ],
                    [
                        8352,
                        8399
                    ],
                    [
                        8400,
                        8447
                    ],
                    [
                        8448,
                        8527
                    ],
                    [
                        8528,
                        8591
                    ],
                    [
                        8592,
                        8703,
                        10224,
                        10239,
                        10496,
                        10623,
                        11008,
                        11263
                    ],
                    [
                        8704,
                        8959,
                        10752,
                        11007,
                        10176,
                        10223,
                        10624,
                        10751
                    ],
                    [
                        8960,
                        9215
                    ],
                    [
                        9216,
                        9279
                    ],
                    [
                        9280,
                        9311
                    ],
                    [
                        9312,
                        9471
                    ],
                    [
                        9472,
                        9599
                    ],
                    [
                        9600,
                        9631
                    ],
                    [
                        9632,
                        9727
                    ],
                    [
                        9728,
                        9983
                    ],
                    [
                        9984,
                        10175
                    ],
                    [
                        12288,
                        12351
                    ],
                    [
                        12352,
                        12447
                    ],
                    [
                        12448,
                        12543,
                        12784,
                        12799
                    ],
                    [
                        12544,
                        12591,
                        12704,
                        12735
                    ],
                    [
                        12592,
                        12687
                    ],
                    [
                        43072,
                        43135
                    ],
                    [
                        12800,
                        13055
                    ],
                    [
                        13056,
                        13311
                    ],
                    [
                        44032,
                        55215
                    ],
                    [
                        55296,
                        57343
                    ],
                    [
                        67840,
                        67871
                    ],
                    [
                        19968,
                        40959,
                        11904,
                        12031,
                        12032,
                        12255,
                        12272,
                        12287,
                        13312,
                        19903,
                        131072,
                        173791,
                        12688,
                        12703
                    ],
                    [
                        57344,
                        63743
                    ],
                    [
                        12736,
                        12783,
                        63744,
                        64255,
                        194560,
                        195103
                    ],
                    [
                        64256,
                        64335
                    ],
                    [
                        64336,
                        65023
                    ],
                    [
                        65056,
                        65071
                    ],
                    [
                        65040,
                        65055
                    ],
                    [
                        65104,
                        65135
                    ],
                    [
                        65136,
                        65279
                    ],
                    [
                        65280,
                        65519
                    ],
                    [
                        65520,
                        65535
                    ],
                    [
                        3840,
                        4095
                    ],
                    [
                        1792,
                        1871
                    ],
                    [
                        1920,
                        1983
                    ],
                    [
                        3456,
                        3583
                    ],
                    [
                        4096,
                        4255
                    ],
                    [
                        4608,
                        4991,
                        4992,
                        5023,
                        11648,
                        11743
                    ],
                    [
                        5024,
                        5119
                    ],
                    [
                        5120,
                        5759
                    ],
                    [
                        5760,
                        5791
                    ],
                    [
                        5792,
                        5887
                    ],
                    [
                        6016,
                        6143
                    ],
                    [
                        6144,
                        6319
                    ],
                    [
                        10240,
                        10495
                    ],
                    [
                        40960,
                        42127
                    ],
                    [
                        5888,
                        5919,
                        5920,
                        5951,
                        5952,
                        5983,
                        5984,
                        6015
                    ],
                    [
                        66304,
                        66351
                    ],
                    [
                        66352,
                        66383
                    ],
                    [
                        66560,
                        66639
                    ],
                    [
                        118784,
                        119039,
                        119040,
                        119295,
                        119296,
                        119375
                    ],
                    [
                        119808,
                        120831
                    ],
                    [
                        1044480,
                        1048573
                    ],
                    [
                        65024,
                        65039,
                        917760,
                        917999
                    ],
                    [
                        917504,
                        917631
                    ],
                    [
                        6400,
                        6479
                    ],
                    [
                        6480,
                        6527
                    ],
                    [
                        6528,
                        6623
                    ],
                    [
                        6656,
                        6687
                    ],
                    [
                        11264,
                        11359
                    ],
                    [
                        11568,
                        11647
                    ],
                    [
                        19904,
                        19967
                    ],
                    [
                        43008,
                        43055
                    ],
                    [
                        65536,
                        65663,
                        65664,
                        65791,
                        65792,
                        65855
                    ],
                    [
                        65856,
                        65935
                    ],
                    [
                        66432,
                        66463
                    ],
                    [
                        66464,
                        66527
                    ],
                    [
                        66640,
                        66687
                    ],
                    [
                        66688,
                        66735
                    ],
                    [
                        67584,
                        67647
                    ],
                    [
                        68096,
                        68191
                    ],
                    [
                        119552,
                        119647
                    ],
                    [
                        73728,
                        74751,
                        74752,
                        74879
                    ],
                    [
                        119648,
                        119679
                    ],
                    [
                        7040,
                        7103
                    ],
                    [
                        7168,
                        7247
                    ],
                    [
                        7248,
                        7295
                    ],
                    [
                        43136,
                        43231
                    ],
                    [
                        43264,
                        43311
                    ],
                    [
                        43312,
                        43359
                    ],
                    [
                        43520,
                        43615
                    ],
                    [
                        65936,
                        65999
                    ],
                    [
                        66e3,
                        66047
                    ],
                    [
                        66208,
                        66271,
                        66176,
                        66207,
                        67872,
                        67903
                    ],
                    [
                        127024,
                        127135,
                        126976,
                        127023
                    ]
                ];
                const i = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), s = new Map;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.getSerifFonts = t.getNonStdFontMap = t.getGlyphMapForStandardFonts = t.getFontNameToFileMap = void 0;
                t.getStandardFontName = function getStandardFontName(e1) {
                    const t = (0, n.normalizeFontName)(e1);
                    return i()[t];
                };
                t.getSymbolsFonts = t.getSupplementalGlyphMapForCalibri = t.getSupplementalGlyphMapForArialBlack = t.getStdFontMap = void 0;
                t.isKnownFontName = function isKnownFontName(e1) {
                    const t = (0, n.normalizeFontName)(e1);
                    return !!(i()[t] || o()[t] || c()[t] || l()[t]);
                };
                var r = a(3), n = a(38);
                const i = (0, r.getLookupTableFactory)(function(e1) {
                    e1["Times-Roman"] = "Times-Roman";
                    e1.Helvetica = "Helvetica";
                    e1.Courier = "Courier";
                    e1.Symbol = "Symbol";
                    e1["Times-Bold"] = "Times-Bold";
                    e1["Helvetica-Bold"] = "Helvetica-Bold";
                    e1["Courier-Bold"] = "Courier-Bold";
                    e1.ZapfDingbats = "ZapfDingbats";
                    e1["Times-Italic"] = "Times-Italic";
                    e1["Helvetica-Oblique"] = "Helvetica-Oblique";
                    e1["Courier-Oblique"] = "Courier-Oblique";
                    e1["Times-BoldItalic"] = "Times-BoldItalic";
                    e1["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
                    e1["Courier-BoldOblique"] = "Courier-BoldOblique";
                    e1.ArialNarrow = "Helvetica";
                    e1["ArialNarrow-Bold"] = "Helvetica-Bold";
                    e1["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["ArialNarrow-Italic"] = "Helvetica-Oblique";
                    e1.ArialBlack = "Helvetica";
                    e1["ArialBlack-Bold"] = "Helvetica-Bold";
                    e1["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["ArialBlack-Italic"] = "Helvetica-Oblique";
                    e1["Arial-Black"] = "Helvetica";
                    e1["Arial-Black-Bold"] = "Helvetica-Bold";
                    e1["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["Arial-Black-Italic"] = "Helvetica-Oblique";
                    e1.Arial = "Helvetica";
                    e1["Arial-Bold"] = "Helvetica-Bold";
                    e1["Arial-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["Arial-Italic"] = "Helvetica-Oblique";
                    e1.ArialMT = "Helvetica";
                    e1["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
                    e1["Arial-BoldMT"] = "Helvetica-Bold";
                    e1["Arial-ItalicMT"] = "Helvetica-Oblique";
                    e1["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["Arial-BoldMT-Bold"] = "Helvetica-Bold";
                    e1["Arial-ItalicMT-Italic"] = "Helvetica-Oblique";
                    e1.ArialUnicodeMS = "Helvetica";
                    e1["ArialUnicodeMS-Bold"] = "Helvetica-Bold";
                    e1["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["ArialUnicodeMS-Italic"] = "Helvetica-Oblique";
                    e1["Courier-BoldItalic"] = "Courier-BoldOblique";
                    e1["Courier-Italic"] = "Courier-Oblique";
                    e1.CourierNew = "Courier";
                    e1["CourierNew-Bold"] = "Courier-Bold";
                    e1["CourierNew-BoldItalic"] = "Courier-BoldOblique";
                    e1["CourierNew-Italic"] = "Courier-Oblique";
                    e1["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
                    e1["CourierNewPS-BoldMT"] = "Courier-Bold";
                    e1["CourierNewPS-ItalicMT"] = "Courier-Oblique";
                    e1.CourierNewPSMT = "Courier";
                    e1["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["Helvetica-Italic"] = "Helvetica-Oblique";
                    e1["Symbol-Bold"] = "Symbol";
                    e1["Symbol-BoldItalic"] = "Symbol";
                    e1["Symbol-Italic"] = "Symbol";
                    e1.TimesNewRoman = "Times-Roman";
                    e1["TimesNewRoman-Bold"] = "Times-Bold";
                    e1["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
                    e1["TimesNewRoman-Italic"] = "Times-Italic";
                    e1.TimesNewRomanPS = "Times-Roman";
                    e1["TimesNewRomanPS-Bold"] = "Times-Bold";
                    e1["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
                    e1["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
                    e1["TimesNewRomanPS-BoldMT"] = "Times-Bold";
                    e1["TimesNewRomanPS-Italic"] = "Times-Italic";
                    e1["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
                    e1.TimesNewRomanPSMT = "Times-Roman";
                    e1["TimesNewRomanPSMT-Bold"] = "Times-Bold";
                    e1["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
                    e1["TimesNewRomanPSMT-Italic"] = "Times-Italic";
                });
                t.getStdFontMap = i;
                const s = (0, r.getLookupTableFactory)(function(e1) {
                    e1.Courier = "FoxitFixed.pfb";
                    e1["Courier-Bold"] = "FoxitFixedBold.pfb";
                    e1["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
                    e1["Courier-Oblique"] = "FoxitFixedItalic.pfb";
                    e1.Helvetica = "LiberationSans-Regular.ttf";
                    e1["Helvetica-Bold"] = "LiberationSans-Bold.ttf";
                    e1["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf";
                    e1["Helvetica-Oblique"] = "LiberationSans-Italic.ttf";
                    e1["Times-Roman"] = "FoxitSerif.pfb";
                    e1["Times-Bold"] = "FoxitSerifBold.pfb";
                    e1["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
                    e1["Times-Italic"] = "FoxitSerifItalic.pfb";
                    e1.Symbol = "FoxitSymbol.pfb";
                    e1.ZapfDingbats = "FoxitDingbats.pfb";
                    e1["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
                    e1["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
                    e1["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
                    e1["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
                });
                t.getFontNameToFileMap = s;
                const o = (0, r.getLookupTableFactory)(function(e1) {
                    e1.Calibri = "Helvetica";
                    e1["Calibri-Bold"] = "Helvetica-Bold";
                    e1["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["Calibri-Italic"] = "Helvetica-Oblique";
                    e1.CenturyGothic = "Helvetica";
                    e1["CenturyGothic-Bold"] = "Helvetica-Bold";
                    e1["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["CenturyGothic-Italic"] = "Helvetica-Oblique";
                    e1.ComicSansMS = "Comic Sans MS";
                    e1["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
                    e1["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
                    e1["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
                    e1.Impact = "Helvetica";
                    e1["ItcSymbol-Bold"] = "Helvetica-Bold";
                    e1["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique";
                    e1["ItcSymbol-Book"] = "Helvetica";
                    e1["ItcSymbol-BookItalic"] = "Helvetica-Oblique";
                    e1["ItcSymbol-Medium"] = "Helvetica";
                    e1["ItcSymbol-MediumItalic"] = "Helvetica-Oblique";
                    e1.LucidaConsole = "Courier";
                    e1["LucidaConsole-Bold"] = "Courier-Bold";
                    e1["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
                    e1["LucidaConsole-Italic"] = "Courier-Oblique";
                    e1["LucidaSans-Demi"] = "Helvetica-Bold";
                    e1["MS-Gothic"] = "MS Gothic";
                    e1["MS-Gothic-Bold"] = "MS Gothic-Bold";
                    e1["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
                    e1["MS-Gothic-Italic"] = "MS Gothic-Italic";
                    e1["MS-Mincho"] = "MS Mincho";
                    e1["MS-Mincho-Bold"] = "MS Mincho-Bold";
                    e1["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
                    e1["MS-Mincho-Italic"] = "MS Mincho-Italic";
                    e1["MS-PGothic"] = "MS PGothic";
                    e1["MS-PGothic-Bold"] = "MS PGothic-Bold";
                    e1["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
                    e1["MS-PGothic-Italic"] = "MS PGothic-Italic";
                    e1["MS-PMincho"] = "MS PMincho";
                    e1["MS-PMincho-Bold"] = "MS PMincho-Bold";
                    e1["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
                    e1["MS-PMincho-Italic"] = "MS PMincho-Italic";
                    e1.NuptialScript = "Times-Italic";
                    e1.SegoeUISymbol = "Helvetica";
                });
                t.getNonStdFontMap = o;
                const c = (0, r.getLookupTableFactory)(function(e1) {
                    e1["Adobe Jenson"] = !0;
                    e1["Adobe Text"] = !0;
                    e1.Albertus = !0;
                    e1.Aldus = !0;
                    e1.Alexandria = !0;
                    e1.Algerian = !0;
                    e1["American Typewriter"] = !0;
                    e1.Antiqua = !0;
                    e1.Apex = !0;
                    e1.Arno = !0;
                    e1.Aster = !0;
                    e1.Aurora = !0;
                    e1.Baskerville = !0;
                    e1.Bell = !0;
                    e1.Bembo = !0;
                    e1["Bembo Schoolbook"] = !0;
                    e1.Benguiat = !0;
                    e1["Berkeley Old Style"] = !0;
                    e1["Bernhard Modern"] = !0;
                    e1["Berthold City"] = !0;
                    e1.Bodoni = !0;
                    e1["Bauer Bodoni"] = !0;
                    e1["Book Antiqua"] = !0;
                    e1.Bookman = !0;
                    e1["Bordeaux Roman"] = !0;
                    e1["Californian FB"] = !0;
                    e1.Calisto = !0;
                    e1.Calvert = !0;
                    e1.Capitals = !0;
                    e1.Cambria = !0;
                    e1.Cartier = !0;
                    e1.Caslon = !0;
                    e1.Catull = !0;
                    e1.Centaur = !0;
                    e1["Century Old Style"] = !0;
                    e1["Century Schoolbook"] = !0;
                    e1.Chaparral = !0;
                    e1["Charis SIL"] = !0;
                    e1.Cheltenham = !0;
                    e1["Cholla Slab"] = !0;
                    e1.Clarendon = !0;
                    e1.Clearface = !0;
                    e1.Cochin = !0;
                    e1.Colonna = !0;
                    e1["Computer Modern"] = !0;
                    e1["Concrete Roman"] = !0;
                    e1.Constantia = !0;
                    e1["Cooper Black"] = !0;
                    e1.Corona = !0;
                    e1.Ecotype = !0;
                    e1.Egyptienne = !0;
                    e1.Elephant = !0;
                    e1.Excelsior = !0;
                    e1.Fairfield = !0;
                    e1["FF Scala"] = !0;
                    e1.Folkard = !0;
                    e1.Footlight = !0;
                    e1.FreeSerif = !0;
                    e1["Friz Quadrata"] = !0;
                    e1.Garamond = !0;
                    e1.Gentium = !0;
                    e1.Georgia = !0;
                    e1.Gloucester = !0;
                    e1["Goudy Old Style"] = !0;
                    e1["Goudy Schoolbook"] = !0;
                    e1["Goudy Pro Font"] = !0;
                    e1.Granjon = !0;
                    e1["Guardian Egyptian"] = !0;
                    e1.Heather = !0;
                    e1.Hercules = !0;
                    e1["High Tower Text"] = !0;
                    e1.Hiroshige = !0;
                    e1["Hoefler Text"] = !0;
                    e1["Humana Serif"] = !0;
                    e1.Imprint = !0;
                    e1["Ionic No. 5"] = !0;
                    e1.Janson = !0;
                    e1.Joanna = !0;
                    e1.Korinna = !0;
                    e1.Lexicon = !0;
                    e1.LiberationSerif = !0;
                    e1["Liberation Serif"] = !0;
                    e1["Linux Libertine"] = !0;
                    e1.Literaturnaya = !0;
                    e1.Lucida = !0;
                    e1["Lucida Bright"] = !0;
                    e1.Melior = !0;
                    e1.Memphis = !0;
                    e1.Miller = !0;
                    e1.Minion = !0;
                    e1.Modern = !0;
                    e1["Mona Lisa"] = !0;
                    e1["Mrs Eaves"] = !0;
                    e1["MS Serif"] = !0;
                    e1["Museo Slab"] = !0;
                    e1["New York"] = !0;
                    e1["Nimbus Roman"] = !0;
                    e1["NPS Rawlinson Roadway"] = !0;
                    e1.NuptialScript = !0;
                    e1.Palatino = !0;
                    e1.Perpetua = !0;
                    e1.Plantin = !0;
                    e1["Plantin Schoolbook"] = !0;
                    e1.Playbill = !0;
                    e1["Poor Richard"] = !0;
                    e1["Rawlinson Roadway"] = !0;
                    e1.Renault = !0;
                    e1.Requiem = !0;
                    e1.Rockwell = !0;
                    e1.Roman = !0;
                    e1["Rotis Serif"] = !0;
                    e1.Sabon = !0;
                    e1.Scala = !0;
                    e1.Seagull = !0;
                    e1.Sistina = !0;
                    e1.Souvenir = !0;
                    e1.STIX = !0;
                    e1["Stone Informal"] = !0;
                    e1["Stone Serif"] = !0;
                    e1.Sylfaen = !0;
                    e1.Times = !0;
                    e1.Trajan = !0;
                    e1["Trinit\xe9"] = !0;
                    e1["Trump Mediaeval"] = !0;
                    e1.Utopia = !0;
                    e1["Vale Type"] = !0;
                    e1["Bitstream Vera"] = !0;
                    e1["Vera Serif"] = !0;
                    e1.Versailles = !0;
                    e1.Wanted = !0;
                    e1.Weiss = !0;
                    e1["Wide Latin"] = !0;
                    e1.Windsor = !0;
                    e1.XITS = !0;
                });
                t.getSerifFonts = c;
                const l = (0, r.getLookupTableFactory)(function(e1) {
                    e1.Dingbats = !0;
                    e1.Symbol = !0;
                    e1.ZapfDingbats = !0;
                    e1.Wingdings = !0;
                    e1["Wingdings-Bold"] = !0;
                    e1["Wingdings-Regular"] = !0;
                });
                t.getSymbolsFonts = l;
                const h = (0, r.getLookupTableFactory)(function(e1) {
                    e1[2] = 10;
                    e1[3] = 32;
                    e1[4] = 33;
                    e1[5] = 34;
                    e1[6] = 35;
                    e1[7] = 36;
                    e1[8] = 37;
                    e1[9] = 38;
                    e1[10] = 39;
                    e1[11] = 40;
                    e1[12] = 41;
                    e1[13] = 42;
                    e1[14] = 43;
                    e1[15] = 44;
                    e1[16] = 45;
                    e1[17] = 46;
                    e1[18] = 47;
                    e1[19] = 48;
                    e1[20] = 49;
                    e1[21] = 50;
                    e1[22] = 51;
                    e1[23] = 52;
                    e1[24] = 53;
                    e1[25] = 54;
                    e1[26] = 55;
                    e1[27] = 56;
                    e1[28] = 57;
                    e1[29] = 58;
                    e1[30] = 894;
                    e1[31] = 60;
                    e1[32] = 61;
                    e1[33] = 62;
                    e1[34] = 63;
                    e1[35] = 64;
                    e1[36] = 65;
                    e1[37] = 66;
                    e1[38] = 67;
                    e1[39] = 68;
                    e1[40] = 69;
                    e1[41] = 70;
                    e1[42] = 71;
                    e1[43] = 72;
                    e1[44] = 73;
                    e1[45] = 74;
                    e1[46] = 75;
                    e1[47] = 76;
                    e1[48] = 77;
                    e1[49] = 78;
                    e1[50] = 79;
                    e1[51] = 80;
                    e1[52] = 81;
                    e1[53] = 82;
                    e1[54] = 83;
                    e1[55] = 84;
                    e1[56] = 85;
                    e1[57] = 86;
                    e1[58] = 87;
                    e1[59] = 88;
                    e1[60] = 89;
                    e1[61] = 90;
                    e1[62] = 91;
                    e1[63] = 92;
                    e1[64] = 93;
                    e1[65] = 94;
                    e1[66] = 95;
                    e1[67] = 96;
                    e1[68] = 97;
                    e1[69] = 98;
                    e1[70] = 99;
                    e1[71] = 100;
                    e1[72] = 101;
                    e1[73] = 102;
                    e1[74] = 103;
                    e1[75] = 104;
                    e1[76] = 105;
                    e1[77] = 106;
                    e1[78] = 107;
                    e1[79] = 108;
                    e1[80] = 109;
                    e1[81] = 110;
                    e1[82] = 111;
                    e1[83] = 112;
                    e1[84] = 113;
                    e1[85] = 114;
                    e1[86] = 115;
                    e1[87] = 116;
                    e1[88] = 117;
                    e1[89] = 118;
                    e1[90] = 119;
                    e1[91] = 120;
                    e1[92] = 121;
                    e1[93] = 122;
                    e1[94] = 123;
                    e1[95] = 124;
                    e1[96] = 125;
                    e1[97] = 126;
                    e1[98] = 196;
                    e1[99] = 197;
                    e1[100] = 199;
                    e1[101] = 201;
                    e1[102] = 209;
                    e1[103] = 214;
                    e1[104] = 220;
                    e1[105] = 225;
                    e1[106] = 224;
                    e1[107] = 226;
                    e1[108] = 228;
                    e1[109] = 227;
                    e1[110] = 229;
                    e1[111] = 231;
                    e1[112] = 233;
                    e1[113] = 232;
                    e1[114] = 234;
                    e1[115] = 235;
                    e1[116] = 237;
                    e1[117] = 236;
                    e1[118] = 238;
                    e1[119] = 239;
                    e1[120] = 241;
                    e1[121] = 243;
                    e1[122] = 242;
                    e1[123] = 244;
                    e1[124] = 246;
                    e1[125] = 245;
                    e1[126] = 250;
                    e1[127] = 249;
                    e1[128] = 251;
                    e1[129] = 252;
                    e1[130] = 8224;
                    e1[131] = 176;
                    e1[132] = 162;
                    e1[133] = 163;
                    e1[134] = 167;
                    e1[135] = 8226;
                    e1[136] = 182;
                    e1[137] = 223;
                    e1[138] = 174;
                    e1[139] = 169;
                    e1[140] = 8482;
                    e1[141] = 180;
                    e1[142] = 168;
                    e1[143] = 8800;
                    e1[144] = 198;
                    e1[145] = 216;
                    e1[146] = 8734;
                    e1[147] = 177;
                    e1[148] = 8804;
                    e1[149] = 8805;
                    e1[150] = 165;
                    e1[151] = 181;
                    e1[152] = 8706;
                    e1[153] = 8721;
                    e1[154] = 8719;
                    e1[156] = 8747;
                    e1[157] = 170;
                    e1[158] = 186;
                    e1[159] = 8486;
                    e1[160] = 230;
                    e1[161] = 248;
                    e1[162] = 191;
                    e1[163] = 161;
                    e1[164] = 172;
                    e1[165] = 8730;
                    e1[166] = 402;
                    e1[167] = 8776;
                    e1[168] = 8710;
                    e1[169] = 171;
                    e1[170] = 187;
                    e1[171] = 8230;
                    e1[179] = 8220;
                    e1[180] = 8221;
                    e1[181] = 8216;
                    e1[182] = 8217;
                    e1[200] = 193;
                    e1[203] = 205;
                    e1[207] = 211;
                    e1[210] = 218;
                    e1[223] = 711;
                    e1[224] = 321;
                    e1[225] = 322;
                    e1[226] = 352;
                    e1[227] = 353;
                    e1[228] = 381;
                    e1[229] = 382;
                    e1[233] = 221;
                    e1[234] = 253;
                    e1[252] = 263;
                    e1[253] = 268;
                    e1[254] = 269;
                    e1[258] = 258;
                    e1[260] = 260;
                    e1[261] = 261;
                    e1[265] = 280;
                    e1[266] = 281;
                    e1[267] = 282;
                    e1[268] = 283;
                    e1[269] = 313;
                    e1[275] = 323;
                    e1[276] = 324;
                    e1[278] = 328;
                    e1[283] = 344;
                    e1[284] = 345;
                    e1[285] = 346;
                    e1[286] = 347;
                    e1[292] = 367;
                    e1[295] = 377;
                    e1[296] = 378;
                    e1[298] = 380;
                    e1[305] = 963;
                    e1[306] = 964;
                    e1[307] = 966;
                    e1[308] = 8215;
                    e1[309] = 8252;
                    e1[310] = 8319;
                    e1[311] = 8359;
                    e1[312] = 8592;
                    e1[313] = 8593;
                    e1[337] = 9552;
                    e1[493] = 1039;
                    e1[494] = 1040;
                    e1[672] = 1488;
                    e1[673] = 1489;
                    e1[674] = 1490;
                    e1[675] = 1491;
                    e1[676] = 1492;
                    e1[677] = 1493;
                    e1[678] = 1494;
                    e1[679] = 1495;
                    e1[680] = 1496;
                    e1[681] = 1497;
                    e1[682] = 1498;
                    e1[683] = 1499;
                    e1[684] = 1500;
                    e1[685] = 1501;
                    e1[686] = 1502;
                    e1[687] = 1503;
                    e1[688] = 1504;
                    e1[689] = 1505;
                    e1[690] = 1506;
                    e1[691] = 1507;
                    e1[692] = 1508;
                    e1[693] = 1509;
                    e1[694] = 1510;
                    e1[695] = 1511;
                    e1[696] = 1512;
                    e1[697] = 1513;
                    e1[698] = 1514;
                    e1[705] = 1524;
                    e1[706] = 8362;
                    e1[710] = 64288;
                    e1[711] = 64298;
                    e1[759] = 1617;
                    e1[761] = 1776;
                    e1[763] = 1778;
                    e1[775] = 1652;
                    e1[777] = 1764;
                    e1[778] = 1780;
                    e1[779] = 1781;
                    e1[780] = 1782;
                    e1[782] = 771;
                    e1[783] = 64726;
                    e1[786] = 8363;
                    e1[788] = 8532;
                    e1[790] = 768;
                    e1[791] = 769;
                    e1[792] = 768;
                    e1[795] = 803;
                    e1[797] = 64336;
                    e1[798] = 64337;
                    e1[799] = 64342;
                    e1[800] = 64343;
                    e1[801] = 64344;
                    e1[802] = 64345;
                    e1[803] = 64362;
                    e1[804] = 64363;
                    e1[805] = 64364;
                    e1[2424] = 7821;
                    e1[2425] = 7822;
                    e1[2426] = 7823;
                    e1[2427] = 7824;
                    e1[2428] = 7825;
                    e1[2429] = 7826;
                    e1[2430] = 7827;
                    e1[2433] = 7682;
                    e1[2678] = 8045;
                    e1[2679] = 8046;
                    e1[2830] = 1552;
                    e1[2838] = 686;
                    e1[2840] = 751;
                    e1[2842] = 753;
                    e1[2843] = 754;
                    e1[2844] = 755;
                    e1[2846] = 757;
                    e1[2856] = 767;
                    e1[2857] = 848;
                    e1[2858] = 849;
                    e1[2862] = 853;
                    e1[2863] = 854;
                    e1[2864] = 855;
                    e1[2865] = 861;
                    e1[2866] = 862;
                    e1[2906] = 7460;
                    e1[2908] = 7462;
                    e1[2909] = 7463;
                    e1[2910] = 7464;
                    e1[2912] = 7466;
                    e1[2913] = 7467;
                    e1[2914] = 7468;
                    e1[2916] = 7470;
                    e1[2917] = 7471;
                    e1[2918] = 7472;
                    e1[2920] = 7474;
                    e1[2921] = 7475;
                    e1[2922] = 7476;
                    e1[2924] = 7478;
                    e1[2925] = 7479;
                    e1[2926] = 7480;
                    e1[2928] = 7482;
                    e1[2929] = 7483;
                    e1[2930] = 7484;
                    e1[2932] = 7486;
                    e1[2933] = 7487;
                    e1[2934] = 7488;
                    e1[2936] = 7490;
                    e1[2937] = 7491;
                    e1[2938] = 7492;
                    e1[2940] = 7494;
                    e1[2941] = 7495;
                    e1[2942] = 7496;
                    e1[2944] = 7498;
                    e1[2946] = 7500;
                    e1[2948] = 7502;
                    e1[2950] = 7504;
                    e1[2951] = 7505;
                    e1[2952] = 7506;
                    e1[2954] = 7508;
                    e1[2955] = 7509;
                    e1[2956] = 7510;
                    e1[2958] = 7512;
                    e1[2959] = 7513;
                    e1[2960] = 7514;
                    e1[2962] = 7516;
                    e1[2963] = 7517;
                    e1[2964] = 7518;
                    e1[2966] = 7520;
                    e1[2967] = 7521;
                    e1[2968] = 7522;
                    e1[2970] = 7524;
                    e1[2971] = 7525;
                    e1[2972] = 7526;
                    e1[2974] = 7528;
                    e1[2975] = 7529;
                    e1[2976] = 7530;
                    e1[2978] = 1537;
                    e1[2979] = 1538;
                    e1[2980] = 1539;
                    e1[2982] = 1549;
                    e1[2983] = 1551;
                    e1[2984] = 1552;
                    e1[2986] = 1554;
                    e1[2987] = 1555;
                    e1[2988] = 1556;
                    e1[2990] = 1623;
                    e1[2991] = 1624;
                    e1[2995] = 1775;
                    e1[2999] = 1791;
                    e1[3002] = 64290;
                    e1[3003] = 64291;
                    e1[3004] = 64292;
                    e1[3006] = 64294;
                    e1[3007] = 64295;
                    e1[3008] = 64296;
                    e1[3011] = 1900;
                    e1[3014] = 8223;
                    e1[3015] = 8244;
                    e1[3017] = 7532;
                    e1[3018] = 7533;
                    e1[3019] = 7534;
                    e1[3075] = 7590;
                    e1[3076] = 7591;
                    e1[3079] = 7594;
                    e1[3080] = 7595;
                    e1[3083] = 7598;
                    e1[3084] = 7599;
                    e1[3087] = 7602;
                    e1[3088] = 7603;
                    e1[3091] = 7606;
                    e1[3092] = 7607;
                    e1[3095] = 7610;
                    e1[3096] = 7611;
                    e1[3099] = 7614;
                    e1[3100] = 7615;
                    e1[3103] = 7618;
                    e1[3104] = 7619;
                    e1[3107] = 8337;
                    e1[3108] = 8338;
                    e1[3116] = 1884;
                    e1[3119] = 1885;
                    e1[3120] = 1885;
                    e1[3123] = 1886;
                    e1[3124] = 1886;
                    e1[3127] = 1887;
                    e1[3128] = 1887;
                    e1[3131] = 1888;
                    e1[3132] = 1888;
                    e1[3135] = 1889;
                    e1[3136] = 1889;
                    e1[3139] = 1890;
                    e1[3140] = 1890;
                    e1[3143] = 1891;
                    e1[3144] = 1891;
                    e1[3147] = 1892;
                    e1[3148] = 1892;
                    e1[3153] = 580;
                    e1[3154] = 581;
                    e1[3157] = 584;
                    e1[3158] = 585;
                    e1[3161] = 588;
                    e1[3162] = 589;
                    e1[3165] = 891;
                    e1[3166] = 892;
                    e1[3169] = 1274;
                    e1[3170] = 1275;
                    e1[3173] = 1278;
                    e1[3174] = 1279;
                    e1[3181] = 7622;
                    e1[3182] = 7623;
                    e1[3282] = 11799;
                    e1[3316] = 578;
                    e1[3379] = 42785;
                    e1[3393] = 1159;
                    e1[3416] = 8377;
                });
                t.getGlyphMapForStandardFonts = h;
                const u = (0, r.getLookupTableFactory)(function(e1) {
                    e1[227] = 322;
                    e1[264] = 261;
                    e1[291] = 346;
                });
                t.getSupplementalGlyphMapForArialBlack = u;
                const d = (0, r.getLookupTableFactory)(function(e1) {
                    e1[1] = 32;
                    e1[4] = 65;
                    e1[5] = 192;
                    e1[6] = 193;
                    e1[9] = 196;
                    e1[17] = 66;
                    e1[18] = 67;
                    e1[21] = 268;
                    e1[24] = 68;
                    e1[28] = 69;
                    e1[29] = 200;
                    e1[30] = 201;
                    e1[32] = 282;
                    e1[38] = 70;
                    e1[39] = 71;
                    e1[44] = 72;
                    e1[47] = 73;
                    e1[48] = 204;
                    e1[49] = 205;
                    e1[58] = 74;
                    e1[60] = 75;
                    e1[62] = 76;
                    e1[68] = 77;
                    e1[69] = 78;
                    e1[75] = 79;
                    e1[76] = 210;
                    e1[80] = 214;
                    e1[87] = 80;
                    e1[89] = 81;
                    e1[90] = 82;
                    e1[92] = 344;
                    e1[94] = 83;
                    e1[97] = 352;
                    e1[100] = 84;
                    e1[104] = 85;
                    e1[109] = 220;
                    e1[115] = 86;
                    e1[116] = 87;
                    e1[121] = 88;
                    e1[122] = 89;
                    e1[124] = 221;
                    e1[127] = 90;
                    e1[129] = 381;
                    e1[258] = 97;
                    e1[259] = 224;
                    e1[260] = 225;
                    e1[263] = 228;
                    e1[268] = 261;
                    e1[271] = 98;
                    e1[272] = 99;
                    e1[273] = 263;
                    e1[275] = 269;
                    e1[282] = 100;
                    e1[286] = 101;
                    e1[287] = 232;
                    e1[288] = 233;
                    e1[290] = 283;
                    e1[295] = 281;
                    e1[296] = 102;
                    e1[336] = 103;
                    e1[346] = 104;
                    e1[349] = 105;
                    e1[350] = 236;
                    e1[351] = 237;
                    e1[361] = 106;
                    e1[364] = 107;
                    e1[367] = 108;
                    e1[371] = 322;
                    e1[373] = 109;
                    e1[374] = 110;
                    e1[381] = 111;
                    e1[382] = 242;
                    e1[383] = 243;
                    e1[386] = 246;
                    e1[393] = 112;
                    e1[395] = 113;
                    e1[396] = 114;
                    e1[398] = 345;
                    e1[400] = 115;
                    e1[401] = 347;
                    e1[403] = 353;
                    e1[410] = 116;
                    e1[437] = 117;
                    e1[442] = 252;
                    e1[448] = 118;
                    e1[449] = 119;
                    e1[454] = 120;
                    e1[455] = 121;
                    e1[457] = 253;
                    e1[460] = 122;
                    e1[462] = 382;
                    e1[463] = 380;
                    e1[853] = 44;
                    e1[855] = 58;
                    e1[856] = 46;
                    e1[876] = 47;
                    e1[878] = 45;
                    e1[882] = 45;
                    e1[894] = 40;
                    e1[895] = 41;
                    e1[896] = 91;
                    e1[897] = 93;
                    e1[923] = 64;
                    e1[1004] = 48;
                    e1[1005] = 49;
                    e1[1006] = 50;
                    e1[1007] = 51;
                    e1[1008] = 52;
                    e1[1009] = 53;
                    e1[1010] = 54;
                    e1[1011] = 55;
                    e1[1012] = 56;
                    e1[1013] = 57;
                    e1[1081] = 37;
                    e1[1085] = 43;
                    e1[1086] = 45;
                });
                t.getSupplementalGlyphMapForCalibri = d;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ToUnicodeMap = t.IdentityToUnicodeMap = void 0;
                var r = a(2);
                t.ToUnicodeMap = class ToUnicodeMap {
                    constructor(e1 = []){
                        this._map = e1;
                    }
                    get length() {
                        return this._map.length;
                    }
                    forEach(e1) {
                        for(const t in this._map)e1(t, this._map[t].charCodeAt(0));
                    }
                    has(e1) {
                        return void 0 !== this._map[e1];
                    }
                    get(e1) {
                        return this._map[e1];
                    }
                    charCodeOf(e1) {
                        const t = this._map;
                        if (t.length <= 65536) return t.indexOf(e1);
                        for(const a in t)if (t[a] === e1) return 0 | a;
                        return -1;
                    }
                    amend(e1) {
                        for(const t in e1)this._map[t] = e1[t];
                    }
                };
                t.IdentityToUnicodeMap = class IdentityToUnicodeMap {
                    constructor(e1, t){
                        this.firstChar = e1;
                        this.lastChar = t;
                    }
                    get length() {
                        return this.lastChar + 1 - this.firstChar;
                    }
                    forEach(e1) {
                        for(let t = this.firstChar, a = this.lastChar; t <= a; t++)e1(t, t);
                    }
                    has(e1) {
                        return this.firstChar <= e1 && e1 <= this.lastChar;
                    }
                    get(e1) {
                        if (this.firstChar <= e1 && e1 <= this.lastChar) return String.fromCharCode(e1);
                    }
                    charCodeOf(e1) {
                        return Number.isInteger(e1) && e1 >= this.firstChar && e1 <= this.lastChar ? e1 : -1;
                    }
                    amend(e1) {
                        (0, r.unreachable)("Should not call amend()");
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.CFFFont = void 0;
                var r = a(35), n = a(38), i = a(2);
                t.CFFFont = class CFFFont {
                    constructor(e1, t){
                        this.properties = t;
                        const a = new r.CFFParser(e1, t, n.SEAC_ANALYSIS_ENABLED);
                        this.cff = a.parse();
                        this.cff.duplicateFirstGlyph();
                        const s = new r.CFFCompiler(this.cff);
                        this.seacs = this.cff.seacs;
                        try {
                            this.data = s.compile();
                        } catch  {
                            (0, i.warn)("Failed to compile font " + t.loadedName);
                            this.data = e1;
                        }
                        this._createBuiltInEncoding();
                    }
                    get numGlyphs() {
                        return this.cff.charStrings.count;
                    }
                    getCharset() {
                        return this.cff.charset.charset;
                    }
                    getGlyphMapping() {
                        const e1 = this.cff, t = this.properties, { cidToGidMap: a, cMap: r } = t, i = e1.charset.charset;
                        let s, o;
                        if (t.composite) {
                            let t, n;
                            if (a?.length > 0) {
                                t = Object.create(null);
                                for(let e1 = 0, r = a.length; e1 < r; e1++){
                                    const r = a[e1];
                                    void 0 !== r && (t[r] = e1);
                                }
                            }
                            s = Object.create(null);
                            if (e1.isCIDFont) for(o = 0; o < i.length; o++){
                                const e1 = i[o];
                                n = r.charCodeOf(e1);
                                void 0 !== t?.[n] && (n = t[n]);
                                s[n] = o;
                            }
                            else for(o = 0; o < e1.charStrings.count; o++){
                                n = r.charCodeOf(o);
                                s[n] = o;
                            }
                            return s;
                        }
                        let c = e1.encoding ? e1.encoding.encoding : null;
                        t.isInternalFont && (c = t.defaultEncoding);
                        s = (0, n.type1FontGlyphMapping)(t, c, i);
                        return s;
                    }
                    hasGlyphId(e1) {
                        return this.cff.hasGlyphId(e1);
                    }
                    _createBuiltInEncoding() {
                        const { charset: e1, encoding: t } = this.cff;
                        if (!e1 || !t) return;
                        const a = e1.charset, r = t.encoding, n = [];
                        for(const e1 in r){
                            const t = r[e1];
                            if (t >= 0) {
                                const r = a[t];
                                r && (n[e1] = r);
                            }
                        }
                        n.length > 0 && (this.properties.builtInEncoding = n);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.FontRendererFactory = void 0;
                var r = a(2), n = a(35), i = a(39), s = a(37), o = a(8);
                function getUint32(e1, t) {
                    return (e1[t] << 24 | e1[t + 1] << 16 | e1[t + 2] << 8 | e1[t + 3]) >>> 0;
                }
                function getUint16(e1, t) {
                    return e1[t] << 8 | e1[t + 1];
                }
                function getInt16(e1, t) {
                    return (e1[t] << 24 | e1[t + 1] << 16) >> 16;
                }
                function getInt8(e1, t) {
                    return e1[t] << 24 >> 24;
                }
                function getFloat214(e1, t) {
                    return getInt16(e1, t) / 16384;
                }
                function getSubroutineBias(e1) {
                    const t = e1.length;
                    let a = 32768;
                    t < 1240 ? a = 107 : t < 33900 && (a = 1131);
                    return a;
                }
                function parseCmap(e1, t, a) {
                    const n = 1 === getUint16(e1, t + 2) ? getUint32(e1, t + 8) : getUint32(e1, t + 16), i = getUint16(e1, t + n);
                    let s, o, c;
                    if (4 === i) {
                        getUint16(e1, t + n + 2);
                        const a = getUint16(e1, t + n + 6) >> 1;
                        o = t + n + 14;
                        s = [];
                        for(c = 0; c < a; c++, o += 2)s[c] = {
                            end: getUint16(e1, o)
                        };
                        o += 2;
                        for(c = 0; c < a; c++, o += 2)s[c].start = getUint16(e1, o);
                        for(c = 0; c < a; c++, o += 2)s[c].idDelta = getUint16(e1, o);
                        for(c = 0; c < a; c++, o += 2){
                            let t = getUint16(e1, o);
                            if (0 !== t) {
                                s[c].ids = [];
                                for(let a = 0, r = s[c].end - s[c].start + 1; a < r; a++){
                                    s[c].ids[a] = getUint16(e1, o + t);
                                    t += 2;
                                }
                            }
                        }
                        return s;
                    }
                    if (12 === i) {
                        const a = getUint32(e1, t + n + 12);
                        o = t + n + 16;
                        s = [];
                        for(c = 0; c < a; c++){
                            t = getUint32(e1, o);
                            s.push({
                                start: t,
                                end: getUint32(e1, o + 4),
                                idDelta: getUint32(e1, o + 8) - t
                            });
                            o += 12;
                        }
                        return s;
                    }
                    throw new r.FormatError(`unsupported cmap: ${i}`);
                }
                function parseCff(e1, t, a, r) {
                    const i = new n.CFFParser(new o.Stream(e1, t, a - t), {}, r).parse();
                    return {
                        glyphs: i.charStrings.objects,
                        subrs: i.topDict.privateDict?.subrsIndex?.objects,
                        gsubrs: i.globalSubrIndex?.objects,
                        isCFFCIDFont: i.isCIDFont,
                        fdSelect: i.fdSelect,
                        fdArray: i.fdArray
                    };
                }
                function lookupCmap(e1, t) {
                    const a = t.codePointAt(0);
                    let r = 0, n = 0, i = e1.length - 1;
                    for(; n < i;){
                        const t = n + i + 1 >> 1;
                        a < e1[t].start ? i = t - 1 : n = t;
                    }
                    e1[n].start <= a && a <= e1[n].end && (r = e1[n].idDelta + (e1[n].ids ? e1[n].ids[a - e1[n].start] : a) & 65535);
                    return {
                        charCode: a,
                        glyphId: r
                    };
                }
                function compileGlyf(e1, t, a) {
                    function moveTo(e1, a) {
                        t.push({
                            cmd: "moveTo",
                            args: [
                                e1,
                                a
                            ]
                        });
                    }
                    function lineTo(e1, a) {
                        t.push({
                            cmd: "lineTo",
                            args: [
                                e1,
                                a
                            ]
                        });
                    }
                    function quadraticCurveTo(e1, a, r, n) {
                        t.push({
                            cmd: "quadraticCurveTo",
                            args: [
                                e1,
                                a,
                                r,
                                n
                            ]
                        });
                    }
                    let r = 0;
                    const n = getInt16(e1, r);
                    let i, s = 0, o = 0;
                    r += 10;
                    if (n < 0) do {
                        i = getUint16(e1, r);
                        const n = getUint16(e1, r + 2);
                        r += 4;
                        let c, l;
                        if (1 & i) {
                            if (2 & i) {
                                c = getInt16(e1, r);
                                l = getInt16(e1, r + 2);
                            } else {
                                c = getUint16(e1, r);
                                l = getUint16(e1, r + 2);
                            }
                            r += 4;
                        } else if (2 & i) {
                            c = getInt8(e1, r++);
                            l = getInt8(e1, r++);
                        } else {
                            c = e1[r++];
                            l = e1[r++];
                        }
                        if (2 & i) {
                            s = c;
                            o = l;
                        } else {
                            s = 0;
                            o = 0;
                        }
                        let h = 1, u = 1, d = 0, f = 0;
                        if (8 & i) {
                            h = u = getFloat214(e1, r);
                            r += 2;
                        } else if (64 & i) {
                            h = getFloat214(e1, r);
                            u = getFloat214(e1, r + 2);
                            r += 4;
                        } else if (128 & i) {
                            h = getFloat214(e1, r);
                            d = getFloat214(e1, r + 2);
                            f = getFloat214(e1, r + 4);
                            u = getFloat214(e1, r + 6);
                            r += 8;
                        }
                        const g = a.glyphs[n];
                        if (g) {
                            t.push({
                                cmd: "save"
                            }, {
                                cmd: "transform",
                                args: [
                                    h,
                                    d,
                                    f,
                                    u,
                                    s,
                                    o
                                ]
                            });
                            compileGlyf(g, t, a);
                            t.push({
                                cmd: "restore"
                            });
                        }
                    }while (32 & i);
                    else {
                        const t = [];
                        let a, c;
                        for(a = 0; a < n; a++){
                            t.push(getUint16(e1, r));
                            r += 2;
                        }
                        r += 2 + getUint16(e1, r);
                        const l = t.at(-1) + 1, h = [];
                        for(; h.length < l;){
                            i = e1[r++];
                            let t = 1;
                            8 & i && (t += e1[r++]);
                            for(; t-- > 0;)h.push({
                                flags: i
                            });
                        }
                        for(a = 0; a < l; a++){
                            switch(18 & h[a].flags){
                                case 0:
                                    s += getInt16(e1, r);
                                    r += 2;
                                    break;
                                case 2:
                                    s -= e1[r++];
                                    break;
                                case 18:
                                    s += e1[r++];
                            }
                            h[a].x = s;
                        }
                        for(a = 0; a < l; a++){
                            switch(36 & h[a].flags){
                                case 0:
                                    o += getInt16(e1, r);
                                    r += 2;
                                    break;
                                case 4:
                                    o -= e1[r++];
                                    break;
                                case 36:
                                    o += e1[r++];
                            }
                            h[a].y = o;
                        }
                        let u = 0;
                        for(r = 0; r < n; r++){
                            const e1 = t[r], n = h.slice(u, e1 + 1);
                            if (1 & n[0].flags) n.push(n[0]);
                            else if (1 & n.at(-1).flags) n.unshift(n.at(-1));
                            else {
                                const e1 = {
                                    flags: 1,
                                    x: (n[0].x + n.at(-1).x) / 2,
                                    y: (n[0].y + n.at(-1).y) / 2
                                };
                                n.unshift(e1);
                                n.push(e1);
                            }
                            moveTo(n[0].x, n[0].y);
                            for(a = 1, c = n.length; a < c; a++)if (1 & n[a].flags) lineTo(n[a].x, n[a].y);
                            else if (1 & n[a + 1].flags) {
                                quadraticCurveTo(n[a].x, n[a].y, n[a + 1].x, n[a + 1].y);
                                a++;
                            } else quadraticCurveTo(n[a].x, n[a].y, (n[a].x + n[a + 1].x) / 2, (n[a].y + n[a + 1].y) / 2);
                            u = e1 + 1;
                        }
                    }
                }
                function compileCharString(e1, t, a, n) {
                    function moveTo(e1, a) {
                        t.push({
                            cmd: "moveTo",
                            args: [
                                e1,
                                a
                            ]
                        });
                    }
                    function lineTo(e1, a) {
                        t.push({
                            cmd: "lineTo",
                            args: [
                                e1,
                                a
                            ]
                        });
                    }
                    function bezierCurveTo(e1, a, r, n, i, s) {
                        t.push({
                            cmd: "bezierCurveTo",
                            args: [
                                e1,
                                a,
                                r,
                                n,
                                i,
                                s
                            ]
                        });
                    }
                    const i = [];
                    let o = 0, c = 0, l = 0;
                    !function parse(e1) {
                        let h = 0;
                        for(; h < e1.length;){
                            let u, d, f, g, p, m, b, y, w, S = !1, x = e1[h++];
                            switch(x){
                                case 1:
                                case 3:
                                case 18:
                                case 23:
                                    l += i.length >> 1;
                                    S = !0;
                                    break;
                                case 4:
                                    c += i.pop();
                                    moveTo(o, c);
                                    S = !0;
                                    break;
                                case 5:
                                    for(; i.length > 0;){
                                        o += i.shift();
                                        c += i.shift();
                                        lineTo(o, c);
                                    }
                                    break;
                                case 6:
                                    for(; i.length > 0;){
                                        o += i.shift();
                                        lineTo(o, c);
                                        if (0 === i.length) break;
                                        c += i.shift();
                                        lineTo(o, c);
                                    }
                                    break;
                                case 7:
                                    for(; i.length > 0;){
                                        c += i.shift();
                                        lineTo(o, c);
                                        if (0 === i.length) break;
                                        o += i.shift();
                                        lineTo(o, c);
                                    }
                                    break;
                                case 8:
                                    for(; i.length > 0;){
                                        u = o + i.shift();
                                        f = c + i.shift();
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d + i.shift();
                                        c = g + i.shift();
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    break;
                                case 10:
                                    y = i.pop();
                                    w = null;
                                    if (a.isCFFCIDFont) {
                                        const e1 = a.fdSelect.getFDIndex(n);
                                        if (e1 >= 0 && e1 < a.fdArray.length) {
                                            const t = a.fdArray[e1];
                                            let r;
                                            t.privateDict?.subrsIndex && (r = t.privateDict.subrsIndex.objects);
                                            if (r) {
                                                y += getSubroutineBias(r);
                                                w = r[y];
                                            }
                                        } else (0, r.warn)("Invalid fd index for glyph index.");
                                    } else w = a.subrs[y + a.subrsBias];
                                    w && parse(w);
                                    break;
                                case 11:
                                    return;
                                case 12:
                                    x = e1[h++];
                                    switch(x){
                                        case 34:
                                            u = o + i.shift();
                                            d = u + i.shift();
                                            p = c + i.shift();
                                            o = d + i.shift();
                                            bezierCurveTo(u, c, d, p, o, p);
                                            u = o + i.shift();
                                            d = u + i.shift();
                                            o = d + i.shift();
                                            bezierCurveTo(u, p, d, c, o, c);
                                            break;
                                        case 35:
                                            u = o + i.shift();
                                            f = c + i.shift();
                                            d = u + i.shift();
                                            g = f + i.shift();
                                            o = d + i.shift();
                                            c = g + i.shift();
                                            bezierCurveTo(u, f, d, g, o, c);
                                            u = o + i.shift();
                                            f = c + i.shift();
                                            d = u + i.shift();
                                            g = f + i.shift();
                                            o = d + i.shift();
                                            c = g + i.shift();
                                            bezierCurveTo(u, f, d, g, o, c);
                                            i.pop();
                                            break;
                                        case 36:
                                            u = o + i.shift();
                                            p = c + i.shift();
                                            d = u + i.shift();
                                            m = p + i.shift();
                                            o = d + i.shift();
                                            bezierCurveTo(u, p, d, m, o, m);
                                            u = o + i.shift();
                                            d = u + i.shift();
                                            b = m + i.shift();
                                            o = d + i.shift();
                                            bezierCurveTo(u, m, d, b, o, c);
                                            break;
                                        case 37:
                                            const e2 = o, t1 = c;
                                            u = o + i.shift();
                                            f = c + i.shift();
                                            d = u + i.shift();
                                            g = f + i.shift();
                                            o = d + i.shift();
                                            c = g + i.shift();
                                            bezierCurveTo(u, f, d, g, o, c);
                                            u = o + i.shift();
                                            f = c + i.shift();
                                            d = u + i.shift();
                                            g = f + i.shift();
                                            o = d;
                                            c = g;
                                            Math.abs(o - e2) > Math.abs(c - t1) ? o += i.shift() : c += i.shift();
                                            bezierCurveTo(u, f, d, g, o, c);
                                            break;
                                        default:
                                            throw new r.FormatError(`unknown operator: 12 ${x}`);
                                    }
                                    break;
                                case 14:
                                    if (i.length >= 4) {
                                        const e1 = i.pop(), r = i.pop();
                                        c = i.pop();
                                        o = i.pop();
                                        t.push({
                                            cmd: "save"
                                        }, {
                                            cmd: "translate",
                                            args: [
                                                o,
                                                c
                                            ]
                                        });
                                        let n = lookupCmap(a.cmap, String.fromCharCode(a.glyphNameMap[s.StandardEncoding[e1]]));
                                        compileCharString(a.glyphs[n.glyphId], t, a, n.glyphId);
                                        t.push({
                                            cmd: "restore"
                                        });
                                        n = lookupCmap(a.cmap, String.fromCharCode(a.glyphNameMap[s.StandardEncoding[r]]));
                                        compileCharString(a.glyphs[n.glyphId], t, a, n.glyphId);
                                    }
                                    return;
                                case 19:
                                case 20:
                                    l += i.length >> 1;
                                    h += l + 7 >> 3;
                                    S = !0;
                                    break;
                                case 21:
                                    c += i.pop();
                                    o += i.pop();
                                    moveTo(o, c);
                                    S = !0;
                                    break;
                                case 22:
                                    o += i.pop();
                                    moveTo(o, c);
                                    S = !0;
                                    break;
                                case 24:
                                    for(; i.length > 2;){
                                        u = o + i.shift();
                                        f = c + i.shift();
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d + i.shift();
                                        c = g + i.shift();
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    o += i.shift();
                                    c += i.shift();
                                    lineTo(o, c);
                                    break;
                                case 25:
                                    for(; i.length > 6;){
                                        o += i.shift();
                                        c += i.shift();
                                        lineTo(o, c);
                                    }
                                    u = o + i.shift();
                                    f = c + i.shift();
                                    d = u + i.shift();
                                    g = f + i.shift();
                                    o = d + i.shift();
                                    c = g + i.shift();
                                    bezierCurveTo(u, f, d, g, o, c);
                                    break;
                                case 26:
                                    i.length % 2 && (o += i.shift());
                                    for(; i.length > 0;){
                                        u = o;
                                        f = c + i.shift();
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d;
                                        c = g + i.shift();
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    break;
                                case 27:
                                    i.length % 2 && (c += i.shift());
                                    for(; i.length > 0;){
                                        u = o + i.shift();
                                        f = c;
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d + i.shift();
                                        c = g;
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    break;
                                case 28:
                                    i.push((e1[h] << 24 | e1[h + 1] << 16) >> 16);
                                    h += 2;
                                    break;
                                case 29:
                                    y = i.pop() + a.gsubrsBias;
                                    w = a.gsubrs[y];
                                    w && parse(w);
                                    break;
                                case 30:
                                    for(; i.length > 0;){
                                        u = o;
                                        f = c + i.shift();
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d + i.shift();
                                        c = g + (1 === i.length ? i.shift() : 0);
                                        bezierCurveTo(u, f, d, g, o, c);
                                        if (0 === i.length) break;
                                        u = o + i.shift();
                                        f = c;
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        c = g + i.shift();
                                        o = d + (1 === i.length ? i.shift() : 0);
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    break;
                                case 31:
                                    for(; i.length > 0;){
                                        u = o + i.shift();
                                        f = c;
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        c = g + i.shift();
                                        o = d + (1 === i.length ? i.shift() : 0);
                                        bezierCurveTo(u, f, d, g, o, c);
                                        if (0 === i.length) break;
                                        u = o;
                                        f = c + i.shift();
                                        d = u + i.shift();
                                        g = f + i.shift();
                                        o = d + i.shift();
                                        c = g + (1 === i.length ? i.shift() : 0);
                                        bezierCurveTo(u, f, d, g, o, c);
                                    }
                                    break;
                                default:
                                    if (x < 32) throw new r.FormatError(`unknown operator: ${x}`);
                                    if (x < 247) i.push(x - 139);
                                    else if (x < 251) i.push(256 * (x - 247) + e1[h++] + 108);
                                    else if (x < 255) i.push(256 * -(x - 251) - e1[h++] - 108);
                                    else {
                                        i.push((e1[h] << 24 | e1[h + 1] << 16 | e1[h + 2] << 8 | e1[h + 3]) / 65536);
                                        h += 4;
                                    }
                            }
                            S && (i.length = 0);
                        }
                    }(e1);
                }
                const c = [];
                class CompiledFont {
                    constructor(e1){
                        this.constructor === CompiledFont && (0, r.unreachable)("Cannot initialize CompiledFont.");
                        this.fontMatrix = e1;
                        this.compiledGlyphs = Object.create(null);
                        this.compiledCharCodeToGlyphId = Object.create(null);
                    }
                    getPathJs(e1) {
                        const { charCode: t, glyphId: a } = lookupCmap(this.cmap, e1);
                        let r = this.compiledGlyphs[a];
                        if (!r) try {
                            r = this.compileGlyph(this.glyphs[a], a);
                            this.compiledGlyphs[a] = r;
                        } catch (e1) {
                            this.compiledGlyphs[a] = c;
                            void 0 === this.compiledCharCodeToGlyphId[t] && (this.compiledCharCodeToGlyphId[t] = a);
                            throw e1;
                        }
                        void 0 === this.compiledCharCodeToGlyphId[t] && (this.compiledCharCodeToGlyphId[t] = a);
                        return r;
                    }
                    compileGlyph(e1, t) {
                        if (!e1 || 0 === e1.length || 14 === e1[0]) return c;
                        let a = this.fontMatrix;
                        if (this.isCFFCIDFont) {
                            const e1 = this.fdSelect.getFDIndex(t);
                            if (e1 >= 0 && e1 < this.fdArray.length) a = this.fdArray[e1].getByName("FontMatrix") || r.FONT_IDENTITY_MATRIX;
                            else (0, r.warn)("Invalid fd index for glyph index.");
                        }
                        const n = [
                            {
                                cmd: "save"
                            },
                            {
                                cmd: "transform",
                                args: a.slice()
                            },
                            {
                                cmd: "scale",
                                args: [
                                    "size",
                                    "-size"
                                ]
                            }
                        ];
                        this.compileGlyphImpl(e1, n, t);
                        n.push({
                            cmd: "restore"
                        });
                        return n;
                    }
                    compileGlyphImpl() {
                        (0, r.unreachable)("Children classes should implement this.");
                    }
                    hasBuiltPath(e1) {
                        const { charCode: t, glyphId: a } = lookupCmap(this.cmap, e1);
                        return void 0 !== this.compiledGlyphs[a] && void 0 !== this.compiledCharCodeToGlyphId[t];
                    }
                }
                class TrueTypeCompiled extends CompiledFont {
                    constructor(e1, t, a){
                        super(a || [
                            488e-6,
                            0,
                            0,
                            488e-6,
                            0,
                            0
                        ]);
                        this.glyphs = e1;
                        this.cmap = t;
                    }
                    compileGlyphImpl(e1, t) {
                        compileGlyf(e1, t, this);
                    }
                }
                class Type2Compiled extends CompiledFont {
                    constructor(e1, t, a, r){
                        super(a || [
                            .001,
                            0,
                            0,
                            .001,
                            0,
                            0
                        ]);
                        this.glyphs = e1.glyphs;
                        this.gsubrs = e1.gsubrs || [];
                        this.subrs = e1.subrs || [];
                        this.cmap = t;
                        this.glyphNameMap = r || (0, i.getGlyphsUnicode)();
                        this.gsubrsBias = getSubroutineBias(this.gsubrs);
                        this.subrsBias = getSubroutineBias(this.subrs);
                        this.isCFFCIDFont = e1.isCFFCIDFont;
                        this.fdSelect = e1.fdSelect;
                        this.fdArray = e1.fdArray;
                    }
                    compileGlyphImpl(e1, t, a) {
                        compileCharString(e1, t, this, a);
                    }
                }
                t.FontRendererFactory = class FontRendererFactory {
                    static create(e1, t) {
                        const a = new Uint8Array(e1.data);
                        let n, i, s, o, c, l;
                        const h = getUint16(a, 4);
                        for(let e1 = 0, u = 12; e1 < h; e1++, u += 16){
                            const e1 = (0, r.bytesToString)(a.subarray(u, u + 4)), h = getUint32(a, u + 8), d = getUint32(a, u + 12);
                            switch(e1){
                                case "cmap":
                                    n = parseCmap(a, h);
                                    break;
                                case "glyf":
                                    i = a.subarray(h, h + d);
                                    break;
                                case "loca":
                                    s = a.subarray(h, h + d);
                                    break;
                                case "head":
                                    l = getUint16(a, h + 18);
                                    c = getUint16(a, h + 50);
                                    break;
                                case "CFF ":
                                    o = parseCff(a, h, h + d, t);
                            }
                        }
                        if (i) {
                            const t = l ? [
                                1 / l,
                                0,
                                0,
                                1 / l,
                                0,
                                0
                            ] : e1.fontMatrix;
                            return new TrueTypeCompiled(function parseGlyfTable(e1, t, a) {
                                let r, n;
                                if (a) {
                                    r = 4;
                                    n = getUint32;
                                } else {
                                    r = 2;
                                    n = (e1, t)=>2 * getUint16(e1, t);
                                }
                                const i = [];
                                let s = n(t, 0);
                                for(let a = r; a < t.length; a += r){
                                    const r = n(t, a);
                                    i.push(e1.subarray(s, r));
                                    s = r;
                                }
                                return i;
                            }(i, s, c), n, t);
                        }
                        return new Type2Compiled(o, n, e1.fontMatrix, e1.glyphNameMap);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.getMetrics = t.getFontBasicMetrics = void 0;
                var r = a(3);
                const n = (0, r.getLookupTableFactory)(function(e1) {
                    e1.Courier = 600;
                    e1["Courier-Bold"] = 600;
                    e1["Courier-BoldOblique"] = 600;
                    e1["Courier-Oblique"] = 600;
                    e1.Helvetica = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 278;
                        e1.exclam = 278;
                        e1.quotedbl = 355;
                        e1.numbersign = 556;
                        e1.dollar = 556;
                        e1.percent = 889;
                        e1.ampersand = 667;
                        e1.quoteright = 222;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 389;
                        e1.plus = 584;
                        e1.comma = 278;
                        e1.hyphen = 333;
                        e1.period = 278;
                        e1.slash = 278;
                        e1.zero = 556;
                        e1.one = 556;
                        e1.two = 556;
                        e1.three = 556;
                        e1.four = 556;
                        e1.five = 556;
                        e1.six = 556;
                        e1.seven = 556;
                        e1.eight = 556;
                        e1.nine = 556;
                        e1.colon = 278;
                        e1.semicolon = 278;
                        e1.less = 584;
                        e1.equal = 584;
                        e1.greater = 584;
                        e1.question = 556;
                        e1.at = 1015;
                        e1.A = 667;
                        e1.B = 667;
                        e1.C = 722;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 611;
                        e1.G = 778;
                        e1.H = 722;
                        e1.I = 278;
                        e1.J = 500;
                        e1.K = 667;
                        e1.L = 556;
                        e1.M = 833;
                        e1.N = 722;
                        e1.O = 778;
                        e1.P = 667;
                        e1.Q = 778;
                        e1.R = 722;
                        e1.S = 667;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 667;
                        e1.W = 944;
                        e1.X = 667;
                        e1.Y = 667;
                        e1.Z = 611;
                        e1.bracketleft = 278;
                        e1.backslash = 278;
                        e1.bracketright = 278;
                        e1.asciicircum = 469;
                        e1.underscore = 556;
                        e1.quoteleft = 222;
                        e1.a = 556;
                        e1.b = 556;
                        e1.c = 500;
                        e1.d = 556;
                        e1.e = 556;
                        e1.f = 278;
                        e1.g = 556;
                        e1.h = 556;
                        e1.i = 222;
                        e1.j = 222;
                        e1.k = 500;
                        e1.l = 222;
                        e1.m = 833;
                        e1.n = 556;
                        e1.o = 556;
                        e1.p = 556;
                        e1.q = 556;
                        e1.r = 333;
                        e1.s = 500;
                        e1.t = 278;
                        e1.u = 556;
                        e1.v = 500;
                        e1.w = 722;
                        e1.x = 500;
                        e1.y = 500;
                        e1.z = 500;
                        e1.braceleft = 334;
                        e1.bar = 260;
                        e1.braceright = 334;
                        e1.asciitilde = 584;
                        e1.exclamdown = 333;
                        e1.cent = 556;
                        e1.sterling = 556;
                        e1.fraction = 167;
                        e1.yen = 556;
                        e1.florin = 556;
                        e1.section = 556;
                        e1.currency = 556;
                        e1.quotesingle = 191;
                        e1.quotedblleft = 333;
                        e1.guillemotleft = 556;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 500;
                        e1.fl = 500;
                        e1.endash = 556;
                        e1.dagger = 556;
                        e1.daggerdbl = 556;
                        e1.periodcentered = 278;
                        e1.paragraph = 537;
                        e1.bullet = 350;
                        e1.quotesinglbase = 222;
                        e1.quotedblbase = 333;
                        e1.quotedblright = 333;
                        e1.guillemotright = 556;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 611;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 1e3;
                        e1.ordfeminine = 370;
                        e1.Lslash = 556;
                        e1.Oslash = 778;
                        e1.OE = 1e3;
                        e1.ordmasculine = 365;
                        e1.ae = 889;
                        e1.dotlessi = 278;
                        e1.lslash = 222;
                        e1.oslash = 611;
                        e1.oe = 944;
                        e1.germandbls = 611;
                        e1.Idieresis = 278;
                        e1.eacute = 556;
                        e1.abreve = 556;
                        e1.uhungarumlaut = 556;
                        e1.ecaron = 556;
                        e1.Ydieresis = 667;
                        e1.divide = 584;
                        e1.Yacute = 667;
                        e1.Acircumflex = 667;
                        e1.aacute = 556;
                        e1.Ucircumflex = 722;
                        e1.yacute = 500;
                        e1.scommaaccent = 500;
                        e1.ecircumflex = 556;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 556;
                        e1.Uacute = 722;
                        e1.uogonek = 556;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 737;
                        e1.Emacron = 667;
                        e1.ccaron = 500;
                        e1.aring = 556;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 222;
                        e1.agrave = 556;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 722;
                        e1.atilde = 556;
                        e1.Edotaccent = 667;
                        e1.scaron = 500;
                        e1.scedilla = 500;
                        e1.iacute = 278;
                        e1.lozenge = 471;
                        e1.Rcaron = 722;
                        e1.Gcommaaccent = 778;
                        e1.ucircumflex = 556;
                        e1.acircumflex = 556;
                        e1.Amacron = 667;
                        e1.rcaron = 333;
                        e1.ccedilla = 500;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 667;
                        e1.Omacron = 778;
                        e1.Racute = 722;
                        e1.Sacute = 667;
                        e1.dcaron = 643;
                        e1.Umacron = 722;
                        e1.uring = 556;
                        e1.threesuperior = 333;
                        e1.Ograve = 778;
                        e1.Agrave = 667;
                        e1.Abreve = 667;
                        e1.multiply = 584;
                        e1.uacute = 556;
                        e1.Tcaron = 611;
                        e1.partialdiff = 476;
                        e1.ydieresis = 500;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 556;
                        e1.edieresis = 556;
                        e1.cacute = 500;
                        e1.nacute = 556;
                        e1.umacron = 556;
                        e1.Ncaron = 722;
                        e1.Iacute = 278;
                        e1.plusminus = 584;
                        e1.brokenbar = 260;
                        e1.registered = 737;
                        e1.Gbreve = 778;
                        e1.Idotaccent = 278;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 333;
                        e1.omacron = 556;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 722;
                        e1.lcommaaccent = 222;
                        e1.tcaron = 317;
                        e1.eogonek = 556;
                        e1.Uogonek = 722;
                        e1.Aacute = 667;
                        e1.Adieresis = 667;
                        e1.egrave = 556;
                        e1.zacute = 500;
                        e1.iogonek = 222;
                        e1.Oacute = 778;
                        e1.oacute = 556;
                        e1.amacron = 556;
                        e1.sacute = 500;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 778;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 556;
                        e1.twosuperior = 333;
                        e1.Odieresis = 778;
                        e1.mu = 556;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 556;
                        e1.Eogonek = 667;
                        e1.dcroat = 556;
                        e1.threequarters = 834;
                        e1.Scedilla = 667;
                        e1.lcaron = 299;
                        e1.Kcommaaccent = 667;
                        e1.Lacute = 556;
                        e1.trademark = 1e3;
                        e1.edotaccent = 556;
                        e1.Igrave = 278;
                        e1.Imacron = 278;
                        e1.Lcaron = 556;
                        e1.onehalf = 834;
                        e1.lessequal = 549;
                        e1.ocircumflex = 556;
                        e1.ntilde = 556;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 556;
                        e1.gbreve = 556;
                        e1.onequarter = 834;
                        e1.Scaron = 667;
                        e1.Scommaaccent = 667;
                        e1.Ohungarumlaut = 778;
                        e1.degree = 400;
                        e1.ograve = 556;
                        e1.Ccaron = 722;
                        e1.ugrave = 556;
                        e1.radical = 453;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 333;
                        e1.Ntilde = 722;
                        e1.otilde = 556;
                        e1.Rcommaaccent = 722;
                        e1.Lcommaaccent = 556;
                        e1.Atilde = 667;
                        e1.Aogonek = 667;
                        e1.Aring = 667;
                        e1.Otilde = 778;
                        e1.zdotaccent = 500;
                        e1.Ecaron = 667;
                        e1.Iogonek = 278;
                        e1.kcommaaccent = 500;
                        e1.minus = 584;
                        e1.Icircumflex = 278;
                        e1.ncaron = 556;
                        e1.tcommaaccent = 278;
                        e1.logicalnot = 584;
                        e1.odieresis = 556;
                        e1.udieresis = 556;
                        e1.notequal = 549;
                        e1.gcommaaccent = 556;
                        e1.eth = 556;
                        e1.zcaron = 500;
                        e1.ncommaaccent = 556;
                        e1.onesuperior = 333;
                        e1.imacron = 278;
                        e1.Euro = 556;
                    });
                    e1["Helvetica-Bold"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 278;
                        e1.exclam = 333;
                        e1.quotedbl = 474;
                        e1.numbersign = 556;
                        e1.dollar = 556;
                        e1.percent = 889;
                        e1.ampersand = 722;
                        e1.quoteright = 278;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 389;
                        e1.plus = 584;
                        e1.comma = 278;
                        e1.hyphen = 333;
                        e1.period = 278;
                        e1.slash = 278;
                        e1.zero = 556;
                        e1.one = 556;
                        e1.two = 556;
                        e1.three = 556;
                        e1.four = 556;
                        e1.five = 556;
                        e1.six = 556;
                        e1.seven = 556;
                        e1.eight = 556;
                        e1.nine = 556;
                        e1.colon = 333;
                        e1.semicolon = 333;
                        e1.less = 584;
                        e1.equal = 584;
                        e1.greater = 584;
                        e1.question = 611;
                        e1.at = 975;
                        e1.A = 722;
                        e1.B = 722;
                        e1.C = 722;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 611;
                        e1.G = 778;
                        e1.H = 722;
                        e1.I = 278;
                        e1.J = 556;
                        e1.K = 722;
                        e1.L = 611;
                        e1.M = 833;
                        e1.N = 722;
                        e1.O = 778;
                        e1.P = 667;
                        e1.Q = 778;
                        e1.R = 722;
                        e1.S = 667;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 667;
                        e1.W = 944;
                        e1.X = 667;
                        e1.Y = 667;
                        e1.Z = 611;
                        e1.bracketleft = 333;
                        e1.backslash = 278;
                        e1.bracketright = 333;
                        e1.asciicircum = 584;
                        e1.underscore = 556;
                        e1.quoteleft = 278;
                        e1.a = 556;
                        e1.b = 611;
                        e1.c = 556;
                        e1.d = 611;
                        e1.e = 556;
                        e1.f = 333;
                        e1.g = 611;
                        e1.h = 611;
                        e1.i = 278;
                        e1.j = 278;
                        e1.k = 556;
                        e1.l = 278;
                        e1.m = 889;
                        e1.n = 611;
                        e1.o = 611;
                        e1.p = 611;
                        e1.q = 611;
                        e1.r = 389;
                        e1.s = 556;
                        e1.t = 333;
                        e1.u = 611;
                        e1.v = 556;
                        e1.w = 778;
                        e1.x = 556;
                        e1.y = 556;
                        e1.z = 500;
                        e1.braceleft = 389;
                        e1.bar = 280;
                        e1.braceright = 389;
                        e1.asciitilde = 584;
                        e1.exclamdown = 333;
                        e1.cent = 556;
                        e1.sterling = 556;
                        e1.fraction = 167;
                        e1.yen = 556;
                        e1.florin = 556;
                        e1.section = 556;
                        e1.currency = 556;
                        e1.quotesingle = 238;
                        e1.quotedblleft = 500;
                        e1.guillemotleft = 556;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 611;
                        e1.fl = 611;
                        e1.endash = 556;
                        e1.dagger = 556;
                        e1.daggerdbl = 556;
                        e1.periodcentered = 278;
                        e1.paragraph = 556;
                        e1.bullet = 350;
                        e1.quotesinglbase = 278;
                        e1.quotedblbase = 500;
                        e1.quotedblright = 500;
                        e1.guillemotright = 556;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 611;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 1e3;
                        e1.ordfeminine = 370;
                        e1.Lslash = 611;
                        e1.Oslash = 778;
                        e1.OE = 1e3;
                        e1.ordmasculine = 365;
                        e1.ae = 889;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 611;
                        e1.oe = 944;
                        e1.germandbls = 611;
                        e1.Idieresis = 278;
                        e1.eacute = 556;
                        e1.abreve = 556;
                        e1.uhungarumlaut = 611;
                        e1.ecaron = 556;
                        e1.Ydieresis = 667;
                        e1.divide = 584;
                        e1.Yacute = 667;
                        e1.Acircumflex = 722;
                        e1.aacute = 556;
                        e1.Ucircumflex = 722;
                        e1.yacute = 556;
                        e1.scommaaccent = 556;
                        e1.ecircumflex = 556;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 556;
                        e1.Uacute = 722;
                        e1.uogonek = 611;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 737;
                        e1.Emacron = 667;
                        e1.ccaron = 556;
                        e1.aring = 556;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 278;
                        e1.agrave = 556;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 722;
                        e1.atilde = 556;
                        e1.Edotaccent = 667;
                        e1.scaron = 556;
                        e1.scedilla = 556;
                        e1.iacute = 278;
                        e1.lozenge = 494;
                        e1.Rcaron = 722;
                        e1.Gcommaaccent = 778;
                        e1.ucircumflex = 611;
                        e1.acircumflex = 556;
                        e1.Amacron = 722;
                        e1.rcaron = 389;
                        e1.ccedilla = 556;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 667;
                        e1.Omacron = 778;
                        e1.Racute = 722;
                        e1.Sacute = 667;
                        e1.dcaron = 743;
                        e1.Umacron = 722;
                        e1.uring = 611;
                        e1.threesuperior = 333;
                        e1.Ograve = 778;
                        e1.Agrave = 722;
                        e1.Abreve = 722;
                        e1.multiply = 584;
                        e1.uacute = 611;
                        e1.Tcaron = 611;
                        e1.partialdiff = 494;
                        e1.ydieresis = 556;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 556;
                        e1.edieresis = 556;
                        e1.cacute = 556;
                        e1.nacute = 611;
                        e1.umacron = 611;
                        e1.Ncaron = 722;
                        e1.Iacute = 278;
                        e1.plusminus = 584;
                        e1.brokenbar = 280;
                        e1.registered = 737;
                        e1.Gbreve = 778;
                        e1.Idotaccent = 278;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 389;
                        e1.omacron = 611;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 722;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 389;
                        e1.eogonek = 556;
                        e1.Uogonek = 722;
                        e1.Aacute = 722;
                        e1.Adieresis = 722;
                        e1.egrave = 556;
                        e1.zacute = 500;
                        e1.iogonek = 278;
                        e1.Oacute = 778;
                        e1.oacute = 611;
                        e1.amacron = 556;
                        e1.sacute = 556;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 778;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 611;
                        e1.twosuperior = 333;
                        e1.Odieresis = 778;
                        e1.mu = 611;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 611;
                        e1.Eogonek = 667;
                        e1.dcroat = 611;
                        e1.threequarters = 834;
                        e1.Scedilla = 667;
                        e1.lcaron = 400;
                        e1.Kcommaaccent = 722;
                        e1.Lacute = 611;
                        e1.trademark = 1e3;
                        e1.edotaccent = 556;
                        e1.Igrave = 278;
                        e1.Imacron = 278;
                        e1.Lcaron = 611;
                        e1.onehalf = 834;
                        e1.lessequal = 549;
                        e1.ocircumflex = 611;
                        e1.ntilde = 611;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 556;
                        e1.gbreve = 611;
                        e1.onequarter = 834;
                        e1.Scaron = 667;
                        e1.Scommaaccent = 667;
                        e1.Ohungarumlaut = 778;
                        e1.degree = 400;
                        e1.ograve = 611;
                        e1.Ccaron = 722;
                        e1.ugrave = 611;
                        e1.radical = 549;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 389;
                        e1.Ntilde = 722;
                        e1.otilde = 611;
                        e1.Rcommaaccent = 722;
                        e1.Lcommaaccent = 611;
                        e1.Atilde = 722;
                        e1.Aogonek = 722;
                        e1.Aring = 722;
                        e1.Otilde = 778;
                        e1.zdotaccent = 500;
                        e1.Ecaron = 667;
                        e1.Iogonek = 278;
                        e1.kcommaaccent = 556;
                        e1.minus = 584;
                        e1.Icircumflex = 278;
                        e1.ncaron = 611;
                        e1.tcommaaccent = 333;
                        e1.logicalnot = 584;
                        e1.odieresis = 611;
                        e1.udieresis = 611;
                        e1.notequal = 549;
                        e1.gcommaaccent = 611;
                        e1.eth = 611;
                        e1.zcaron = 500;
                        e1.ncommaaccent = 611;
                        e1.onesuperior = 333;
                        e1.imacron = 278;
                        e1.Euro = 556;
                    });
                    e1["Helvetica-BoldOblique"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 278;
                        e1.exclam = 333;
                        e1.quotedbl = 474;
                        e1.numbersign = 556;
                        e1.dollar = 556;
                        e1.percent = 889;
                        e1.ampersand = 722;
                        e1.quoteright = 278;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 389;
                        e1.plus = 584;
                        e1.comma = 278;
                        e1.hyphen = 333;
                        e1.period = 278;
                        e1.slash = 278;
                        e1.zero = 556;
                        e1.one = 556;
                        e1.two = 556;
                        e1.three = 556;
                        e1.four = 556;
                        e1.five = 556;
                        e1.six = 556;
                        e1.seven = 556;
                        e1.eight = 556;
                        e1.nine = 556;
                        e1.colon = 333;
                        e1.semicolon = 333;
                        e1.less = 584;
                        e1.equal = 584;
                        e1.greater = 584;
                        e1.question = 611;
                        e1.at = 975;
                        e1.A = 722;
                        e1.B = 722;
                        e1.C = 722;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 611;
                        e1.G = 778;
                        e1.H = 722;
                        e1.I = 278;
                        e1.J = 556;
                        e1.K = 722;
                        e1.L = 611;
                        e1.M = 833;
                        e1.N = 722;
                        e1.O = 778;
                        e1.P = 667;
                        e1.Q = 778;
                        e1.R = 722;
                        e1.S = 667;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 667;
                        e1.W = 944;
                        e1.X = 667;
                        e1.Y = 667;
                        e1.Z = 611;
                        e1.bracketleft = 333;
                        e1.backslash = 278;
                        e1.bracketright = 333;
                        e1.asciicircum = 584;
                        e1.underscore = 556;
                        e1.quoteleft = 278;
                        e1.a = 556;
                        e1.b = 611;
                        e1.c = 556;
                        e1.d = 611;
                        e1.e = 556;
                        e1.f = 333;
                        e1.g = 611;
                        e1.h = 611;
                        e1.i = 278;
                        e1.j = 278;
                        e1.k = 556;
                        e1.l = 278;
                        e1.m = 889;
                        e1.n = 611;
                        e1.o = 611;
                        e1.p = 611;
                        e1.q = 611;
                        e1.r = 389;
                        e1.s = 556;
                        e1.t = 333;
                        e1.u = 611;
                        e1.v = 556;
                        e1.w = 778;
                        e1.x = 556;
                        e1.y = 556;
                        e1.z = 500;
                        e1.braceleft = 389;
                        e1.bar = 280;
                        e1.braceright = 389;
                        e1.asciitilde = 584;
                        e1.exclamdown = 333;
                        e1.cent = 556;
                        e1.sterling = 556;
                        e1.fraction = 167;
                        e1.yen = 556;
                        e1.florin = 556;
                        e1.section = 556;
                        e1.currency = 556;
                        e1.quotesingle = 238;
                        e1.quotedblleft = 500;
                        e1.guillemotleft = 556;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 611;
                        e1.fl = 611;
                        e1.endash = 556;
                        e1.dagger = 556;
                        e1.daggerdbl = 556;
                        e1.periodcentered = 278;
                        e1.paragraph = 556;
                        e1.bullet = 350;
                        e1.quotesinglbase = 278;
                        e1.quotedblbase = 500;
                        e1.quotedblright = 500;
                        e1.guillemotright = 556;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 611;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 1e3;
                        e1.ordfeminine = 370;
                        e1.Lslash = 611;
                        e1.Oslash = 778;
                        e1.OE = 1e3;
                        e1.ordmasculine = 365;
                        e1.ae = 889;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 611;
                        e1.oe = 944;
                        e1.germandbls = 611;
                        e1.Idieresis = 278;
                        e1.eacute = 556;
                        e1.abreve = 556;
                        e1.uhungarumlaut = 611;
                        e1.ecaron = 556;
                        e1.Ydieresis = 667;
                        e1.divide = 584;
                        e1.Yacute = 667;
                        e1.Acircumflex = 722;
                        e1.aacute = 556;
                        e1.Ucircumflex = 722;
                        e1.yacute = 556;
                        e1.scommaaccent = 556;
                        e1.ecircumflex = 556;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 556;
                        e1.Uacute = 722;
                        e1.uogonek = 611;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 737;
                        e1.Emacron = 667;
                        e1.ccaron = 556;
                        e1.aring = 556;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 278;
                        e1.agrave = 556;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 722;
                        e1.atilde = 556;
                        e1.Edotaccent = 667;
                        e1.scaron = 556;
                        e1.scedilla = 556;
                        e1.iacute = 278;
                        e1.lozenge = 494;
                        e1.Rcaron = 722;
                        e1.Gcommaaccent = 778;
                        e1.ucircumflex = 611;
                        e1.acircumflex = 556;
                        e1.Amacron = 722;
                        e1.rcaron = 389;
                        e1.ccedilla = 556;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 667;
                        e1.Omacron = 778;
                        e1.Racute = 722;
                        e1.Sacute = 667;
                        e1.dcaron = 743;
                        e1.Umacron = 722;
                        e1.uring = 611;
                        e1.threesuperior = 333;
                        e1.Ograve = 778;
                        e1.Agrave = 722;
                        e1.Abreve = 722;
                        e1.multiply = 584;
                        e1.uacute = 611;
                        e1.Tcaron = 611;
                        e1.partialdiff = 494;
                        e1.ydieresis = 556;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 556;
                        e1.edieresis = 556;
                        e1.cacute = 556;
                        e1.nacute = 611;
                        e1.umacron = 611;
                        e1.Ncaron = 722;
                        e1.Iacute = 278;
                        e1.plusminus = 584;
                        e1.brokenbar = 280;
                        e1.registered = 737;
                        e1.Gbreve = 778;
                        e1.Idotaccent = 278;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 389;
                        e1.omacron = 611;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 722;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 389;
                        e1.eogonek = 556;
                        e1.Uogonek = 722;
                        e1.Aacute = 722;
                        e1.Adieresis = 722;
                        e1.egrave = 556;
                        e1.zacute = 500;
                        e1.iogonek = 278;
                        e1.Oacute = 778;
                        e1.oacute = 611;
                        e1.amacron = 556;
                        e1.sacute = 556;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 778;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 611;
                        e1.twosuperior = 333;
                        e1.Odieresis = 778;
                        e1.mu = 611;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 611;
                        e1.Eogonek = 667;
                        e1.dcroat = 611;
                        e1.threequarters = 834;
                        e1.Scedilla = 667;
                        e1.lcaron = 400;
                        e1.Kcommaaccent = 722;
                        e1.Lacute = 611;
                        e1.trademark = 1e3;
                        e1.edotaccent = 556;
                        e1.Igrave = 278;
                        e1.Imacron = 278;
                        e1.Lcaron = 611;
                        e1.onehalf = 834;
                        e1.lessequal = 549;
                        e1.ocircumflex = 611;
                        e1.ntilde = 611;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 556;
                        e1.gbreve = 611;
                        e1.onequarter = 834;
                        e1.Scaron = 667;
                        e1.Scommaaccent = 667;
                        e1.Ohungarumlaut = 778;
                        e1.degree = 400;
                        e1.ograve = 611;
                        e1.Ccaron = 722;
                        e1.ugrave = 611;
                        e1.radical = 549;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 389;
                        e1.Ntilde = 722;
                        e1.otilde = 611;
                        e1.Rcommaaccent = 722;
                        e1.Lcommaaccent = 611;
                        e1.Atilde = 722;
                        e1.Aogonek = 722;
                        e1.Aring = 722;
                        e1.Otilde = 778;
                        e1.zdotaccent = 500;
                        e1.Ecaron = 667;
                        e1.Iogonek = 278;
                        e1.kcommaaccent = 556;
                        e1.minus = 584;
                        e1.Icircumflex = 278;
                        e1.ncaron = 611;
                        e1.tcommaaccent = 333;
                        e1.logicalnot = 584;
                        e1.odieresis = 611;
                        e1.udieresis = 611;
                        e1.notequal = 549;
                        e1.gcommaaccent = 611;
                        e1.eth = 611;
                        e1.zcaron = 500;
                        e1.ncommaaccent = 611;
                        e1.onesuperior = 333;
                        e1.imacron = 278;
                        e1.Euro = 556;
                    });
                    e1["Helvetica-Oblique"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 278;
                        e1.exclam = 278;
                        e1.quotedbl = 355;
                        e1.numbersign = 556;
                        e1.dollar = 556;
                        e1.percent = 889;
                        e1.ampersand = 667;
                        e1.quoteright = 222;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 389;
                        e1.plus = 584;
                        e1.comma = 278;
                        e1.hyphen = 333;
                        e1.period = 278;
                        e1.slash = 278;
                        e1.zero = 556;
                        e1.one = 556;
                        e1.two = 556;
                        e1.three = 556;
                        e1.four = 556;
                        e1.five = 556;
                        e1.six = 556;
                        e1.seven = 556;
                        e1.eight = 556;
                        e1.nine = 556;
                        e1.colon = 278;
                        e1.semicolon = 278;
                        e1.less = 584;
                        e1.equal = 584;
                        e1.greater = 584;
                        e1.question = 556;
                        e1.at = 1015;
                        e1.A = 667;
                        e1.B = 667;
                        e1.C = 722;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 611;
                        e1.G = 778;
                        e1.H = 722;
                        e1.I = 278;
                        e1.J = 500;
                        e1.K = 667;
                        e1.L = 556;
                        e1.M = 833;
                        e1.N = 722;
                        e1.O = 778;
                        e1.P = 667;
                        e1.Q = 778;
                        e1.R = 722;
                        e1.S = 667;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 667;
                        e1.W = 944;
                        e1.X = 667;
                        e1.Y = 667;
                        e1.Z = 611;
                        e1.bracketleft = 278;
                        e1.backslash = 278;
                        e1.bracketright = 278;
                        e1.asciicircum = 469;
                        e1.underscore = 556;
                        e1.quoteleft = 222;
                        e1.a = 556;
                        e1.b = 556;
                        e1.c = 500;
                        e1.d = 556;
                        e1.e = 556;
                        e1.f = 278;
                        e1.g = 556;
                        e1.h = 556;
                        e1.i = 222;
                        e1.j = 222;
                        e1.k = 500;
                        e1.l = 222;
                        e1.m = 833;
                        e1.n = 556;
                        e1.o = 556;
                        e1.p = 556;
                        e1.q = 556;
                        e1.r = 333;
                        e1.s = 500;
                        e1.t = 278;
                        e1.u = 556;
                        e1.v = 500;
                        e1.w = 722;
                        e1.x = 500;
                        e1.y = 500;
                        e1.z = 500;
                        e1.braceleft = 334;
                        e1.bar = 260;
                        e1.braceright = 334;
                        e1.asciitilde = 584;
                        e1.exclamdown = 333;
                        e1.cent = 556;
                        e1.sterling = 556;
                        e1.fraction = 167;
                        e1.yen = 556;
                        e1.florin = 556;
                        e1.section = 556;
                        e1.currency = 556;
                        e1.quotesingle = 191;
                        e1.quotedblleft = 333;
                        e1.guillemotleft = 556;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 500;
                        e1.fl = 500;
                        e1.endash = 556;
                        e1.dagger = 556;
                        e1.daggerdbl = 556;
                        e1.periodcentered = 278;
                        e1.paragraph = 537;
                        e1.bullet = 350;
                        e1.quotesinglbase = 222;
                        e1.quotedblbase = 333;
                        e1.quotedblright = 333;
                        e1.guillemotright = 556;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 611;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 1e3;
                        e1.ordfeminine = 370;
                        e1.Lslash = 556;
                        e1.Oslash = 778;
                        e1.OE = 1e3;
                        e1.ordmasculine = 365;
                        e1.ae = 889;
                        e1.dotlessi = 278;
                        e1.lslash = 222;
                        e1.oslash = 611;
                        e1.oe = 944;
                        e1.germandbls = 611;
                        e1.Idieresis = 278;
                        e1.eacute = 556;
                        e1.abreve = 556;
                        e1.uhungarumlaut = 556;
                        e1.ecaron = 556;
                        e1.Ydieresis = 667;
                        e1.divide = 584;
                        e1.Yacute = 667;
                        e1.Acircumflex = 667;
                        e1.aacute = 556;
                        e1.Ucircumflex = 722;
                        e1.yacute = 500;
                        e1.scommaaccent = 500;
                        e1.ecircumflex = 556;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 556;
                        e1.Uacute = 722;
                        e1.uogonek = 556;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 737;
                        e1.Emacron = 667;
                        e1.ccaron = 500;
                        e1.aring = 556;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 222;
                        e1.agrave = 556;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 722;
                        e1.atilde = 556;
                        e1.Edotaccent = 667;
                        e1.scaron = 500;
                        e1.scedilla = 500;
                        e1.iacute = 278;
                        e1.lozenge = 471;
                        e1.Rcaron = 722;
                        e1.Gcommaaccent = 778;
                        e1.ucircumflex = 556;
                        e1.acircumflex = 556;
                        e1.Amacron = 667;
                        e1.rcaron = 333;
                        e1.ccedilla = 500;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 667;
                        e1.Omacron = 778;
                        e1.Racute = 722;
                        e1.Sacute = 667;
                        e1.dcaron = 643;
                        e1.Umacron = 722;
                        e1.uring = 556;
                        e1.threesuperior = 333;
                        e1.Ograve = 778;
                        e1.Agrave = 667;
                        e1.Abreve = 667;
                        e1.multiply = 584;
                        e1.uacute = 556;
                        e1.Tcaron = 611;
                        e1.partialdiff = 476;
                        e1.ydieresis = 500;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 556;
                        e1.edieresis = 556;
                        e1.cacute = 500;
                        e1.nacute = 556;
                        e1.umacron = 556;
                        e1.Ncaron = 722;
                        e1.Iacute = 278;
                        e1.plusminus = 584;
                        e1.brokenbar = 260;
                        e1.registered = 737;
                        e1.Gbreve = 778;
                        e1.Idotaccent = 278;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 333;
                        e1.omacron = 556;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 722;
                        e1.lcommaaccent = 222;
                        e1.tcaron = 317;
                        e1.eogonek = 556;
                        e1.Uogonek = 722;
                        e1.Aacute = 667;
                        e1.Adieresis = 667;
                        e1.egrave = 556;
                        e1.zacute = 500;
                        e1.iogonek = 222;
                        e1.Oacute = 778;
                        e1.oacute = 556;
                        e1.amacron = 556;
                        e1.sacute = 500;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 778;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 556;
                        e1.twosuperior = 333;
                        e1.Odieresis = 778;
                        e1.mu = 556;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 556;
                        e1.Eogonek = 667;
                        e1.dcroat = 556;
                        e1.threequarters = 834;
                        e1.Scedilla = 667;
                        e1.lcaron = 299;
                        e1.Kcommaaccent = 667;
                        e1.Lacute = 556;
                        e1.trademark = 1e3;
                        e1.edotaccent = 556;
                        e1.Igrave = 278;
                        e1.Imacron = 278;
                        e1.Lcaron = 556;
                        e1.onehalf = 834;
                        e1.lessequal = 549;
                        e1.ocircumflex = 556;
                        e1.ntilde = 556;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 556;
                        e1.gbreve = 556;
                        e1.onequarter = 834;
                        e1.Scaron = 667;
                        e1.Scommaaccent = 667;
                        e1.Ohungarumlaut = 778;
                        e1.degree = 400;
                        e1.ograve = 556;
                        e1.Ccaron = 722;
                        e1.ugrave = 556;
                        e1.radical = 453;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 333;
                        e1.Ntilde = 722;
                        e1.otilde = 556;
                        e1.Rcommaaccent = 722;
                        e1.Lcommaaccent = 556;
                        e1.Atilde = 667;
                        e1.Aogonek = 667;
                        e1.Aring = 667;
                        e1.Otilde = 778;
                        e1.zdotaccent = 500;
                        e1.Ecaron = 667;
                        e1.Iogonek = 278;
                        e1.kcommaaccent = 500;
                        e1.minus = 584;
                        e1.Icircumflex = 278;
                        e1.ncaron = 556;
                        e1.tcommaaccent = 278;
                        e1.logicalnot = 584;
                        e1.odieresis = 556;
                        e1.udieresis = 556;
                        e1.notequal = 549;
                        e1.gcommaaccent = 556;
                        e1.eth = 556;
                        e1.zcaron = 500;
                        e1.ncommaaccent = 556;
                        e1.onesuperior = 333;
                        e1.imacron = 278;
                        e1.Euro = 556;
                    });
                    e1.Symbol = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 250;
                        e1.exclam = 333;
                        e1.universal = 713;
                        e1.numbersign = 500;
                        e1.existential = 549;
                        e1.percent = 833;
                        e1.ampersand = 778;
                        e1.suchthat = 439;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asteriskmath = 500;
                        e1.plus = 549;
                        e1.comma = 250;
                        e1.minus = 549;
                        e1.period = 250;
                        e1.slash = 278;
                        e1.zero = 500;
                        e1.one = 500;
                        e1.two = 500;
                        e1.three = 500;
                        e1.four = 500;
                        e1.five = 500;
                        e1.six = 500;
                        e1.seven = 500;
                        e1.eight = 500;
                        e1.nine = 500;
                        e1.colon = 278;
                        e1.semicolon = 278;
                        e1.less = 549;
                        e1.equal = 549;
                        e1.greater = 549;
                        e1.question = 444;
                        e1.congruent = 549;
                        e1.Alpha = 722;
                        e1.Beta = 667;
                        e1.Chi = 722;
                        e1.Delta = 612;
                        e1.Epsilon = 611;
                        e1.Phi = 763;
                        e1.Gamma = 603;
                        e1.Eta = 722;
                        e1.Iota = 333;
                        e1.theta1 = 631;
                        e1.Kappa = 722;
                        e1.Lambda = 686;
                        e1.Mu = 889;
                        e1.Nu = 722;
                        e1.Omicron = 722;
                        e1.Pi = 768;
                        e1.Theta = 741;
                        e1.Rho = 556;
                        e1.Sigma = 592;
                        e1.Tau = 611;
                        e1.Upsilon = 690;
                        e1.sigma1 = 439;
                        e1.Omega = 768;
                        e1.Xi = 645;
                        e1.Psi = 795;
                        e1.Zeta = 611;
                        e1.bracketleft = 333;
                        e1.therefore = 863;
                        e1.bracketright = 333;
                        e1.perpendicular = 658;
                        e1.underscore = 500;
                        e1.radicalex = 500;
                        e1.alpha = 631;
                        e1.beta = 549;
                        e1.chi = 549;
                        e1.delta = 494;
                        e1.epsilon = 439;
                        e1.phi = 521;
                        e1.gamma = 411;
                        e1.eta = 603;
                        e1.iota = 329;
                        e1.phi1 = 603;
                        e1.kappa = 549;
                        e1.lambda = 549;
                        e1.mu = 576;
                        e1.nu = 521;
                        e1.omicron = 549;
                        e1.pi = 549;
                        e1.theta = 521;
                        e1.rho = 549;
                        e1.sigma = 603;
                        e1.tau = 439;
                        e1.upsilon = 576;
                        e1.omega1 = 713;
                        e1.omega = 686;
                        e1.xi = 493;
                        e1.psi = 686;
                        e1.zeta = 494;
                        e1.braceleft = 480;
                        e1.bar = 200;
                        e1.braceright = 480;
                        e1.similar = 549;
                        e1.Euro = 750;
                        e1.Upsilon1 = 620;
                        e1.minute = 247;
                        e1.lessequal = 549;
                        e1.fraction = 167;
                        e1.infinity = 713;
                        e1.florin = 500;
                        e1.club = 753;
                        e1.diamond = 753;
                        e1.heart = 753;
                        e1.spade = 753;
                        e1.arrowboth = 1042;
                        e1.arrowleft = 987;
                        e1.arrowup = 603;
                        e1.arrowright = 987;
                        e1.arrowdown = 603;
                        e1.degree = 400;
                        e1.plusminus = 549;
                        e1.second = 411;
                        e1.greaterequal = 549;
                        e1.multiply = 549;
                        e1.proportional = 713;
                        e1.partialdiff = 494;
                        e1.bullet = 460;
                        e1.divide = 549;
                        e1.notequal = 549;
                        e1.equivalence = 549;
                        e1.approxequal = 549;
                        e1.ellipsis = 1e3;
                        e1.arrowvertex = 603;
                        e1.arrowhorizex = 1e3;
                        e1.carriagereturn = 658;
                        e1.aleph = 823;
                        e1.Ifraktur = 686;
                        e1.Rfraktur = 795;
                        e1.weierstrass = 987;
                        e1.circlemultiply = 768;
                        e1.circleplus = 768;
                        e1.emptyset = 823;
                        e1.intersection = 768;
                        e1.union = 768;
                        e1.propersuperset = 713;
                        e1.reflexsuperset = 713;
                        e1.notsubset = 713;
                        e1.propersubset = 713;
                        e1.reflexsubset = 713;
                        e1.element = 713;
                        e1.notelement = 713;
                        e1.angle = 768;
                        e1.gradient = 713;
                        e1.registerserif = 790;
                        e1.copyrightserif = 790;
                        e1.trademarkserif = 890;
                        e1.product = 823;
                        e1.radical = 549;
                        e1.dotmath = 250;
                        e1.logicalnot = 713;
                        e1.logicaland = 603;
                        e1.logicalor = 603;
                        e1.arrowdblboth = 1042;
                        e1.arrowdblleft = 987;
                        e1.arrowdblup = 603;
                        e1.arrowdblright = 987;
                        e1.arrowdbldown = 603;
                        e1.lozenge = 494;
                        e1.angleleft = 329;
                        e1.registersans = 790;
                        e1.copyrightsans = 790;
                        e1.trademarksans = 786;
                        e1.summation = 713;
                        e1.parenlefttp = 384;
                        e1.parenleftex = 384;
                        e1.parenleftbt = 384;
                        e1.bracketlefttp = 384;
                        e1.bracketleftex = 384;
                        e1.bracketleftbt = 384;
                        e1.bracelefttp = 494;
                        e1.braceleftmid = 494;
                        e1.braceleftbt = 494;
                        e1.braceex = 494;
                        e1.angleright = 329;
                        e1.integral = 274;
                        e1.integraltp = 686;
                        e1.integralex = 686;
                        e1.integralbt = 686;
                        e1.parenrighttp = 384;
                        e1.parenrightex = 384;
                        e1.parenrightbt = 384;
                        e1.bracketrighttp = 384;
                        e1.bracketrightex = 384;
                        e1.bracketrightbt = 384;
                        e1.bracerighttp = 494;
                        e1.bracerightmid = 494;
                        e1.bracerightbt = 494;
                        e1.apple = 790;
                    });
                    e1["Times-Roman"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 250;
                        e1.exclam = 333;
                        e1.quotedbl = 408;
                        e1.numbersign = 500;
                        e1.dollar = 500;
                        e1.percent = 833;
                        e1.ampersand = 778;
                        e1.quoteright = 333;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 500;
                        e1.plus = 564;
                        e1.comma = 250;
                        e1.hyphen = 333;
                        e1.period = 250;
                        e1.slash = 278;
                        e1.zero = 500;
                        e1.one = 500;
                        e1.two = 500;
                        e1.three = 500;
                        e1.four = 500;
                        e1.five = 500;
                        e1.six = 500;
                        e1.seven = 500;
                        e1.eight = 500;
                        e1.nine = 500;
                        e1.colon = 278;
                        e1.semicolon = 278;
                        e1.less = 564;
                        e1.equal = 564;
                        e1.greater = 564;
                        e1.question = 444;
                        e1.at = 921;
                        e1.A = 722;
                        e1.B = 667;
                        e1.C = 667;
                        e1.D = 722;
                        e1.E = 611;
                        e1.F = 556;
                        e1.G = 722;
                        e1.H = 722;
                        e1.I = 333;
                        e1.J = 389;
                        e1.K = 722;
                        e1.L = 611;
                        e1.M = 889;
                        e1.N = 722;
                        e1.O = 722;
                        e1.P = 556;
                        e1.Q = 722;
                        e1.R = 667;
                        e1.S = 556;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 722;
                        e1.W = 944;
                        e1.X = 722;
                        e1.Y = 722;
                        e1.Z = 611;
                        e1.bracketleft = 333;
                        e1.backslash = 278;
                        e1.bracketright = 333;
                        e1.asciicircum = 469;
                        e1.underscore = 500;
                        e1.quoteleft = 333;
                        e1.a = 444;
                        e1.b = 500;
                        e1.c = 444;
                        e1.d = 500;
                        e1.e = 444;
                        e1.f = 333;
                        e1.g = 500;
                        e1.h = 500;
                        e1.i = 278;
                        e1.j = 278;
                        e1.k = 500;
                        e1.l = 278;
                        e1.m = 778;
                        e1.n = 500;
                        e1.o = 500;
                        e1.p = 500;
                        e1.q = 500;
                        e1.r = 333;
                        e1.s = 389;
                        e1.t = 278;
                        e1.u = 500;
                        e1.v = 500;
                        e1.w = 722;
                        e1.x = 500;
                        e1.y = 500;
                        e1.z = 444;
                        e1.braceleft = 480;
                        e1.bar = 200;
                        e1.braceright = 480;
                        e1.asciitilde = 541;
                        e1.exclamdown = 333;
                        e1.cent = 500;
                        e1.sterling = 500;
                        e1.fraction = 167;
                        e1.yen = 500;
                        e1.florin = 500;
                        e1.section = 500;
                        e1.currency = 500;
                        e1.quotesingle = 180;
                        e1.quotedblleft = 444;
                        e1.guillemotleft = 500;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 556;
                        e1.fl = 556;
                        e1.endash = 500;
                        e1.dagger = 500;
                        e1.daggerdbl = 500;
                        e1.periodcentered = 250;
                        e1.paragraph = 453;
                        e1.bullet = 350;
                        e1.quotesinglbase = 333;
                        e1.quotedblbase = 444;
                        e1.quotedblright = 444;
                        e1.guillemotright = 500;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 444;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 889;
                        e1.ordfeminine = 276;
                        e1.Lslash = 611;
                        e1.Oslash = 722;
                        e1.OE = 889;
                        e1.ordmasculine = 310;
                        e1.ae = 667;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 500;
                        e1.oe = 722;
                        e1.germandbls = 500;
                        e1.Idieresis = 333;
                        e1.eacute = 444;
                        e1.abreve = 444;
                        e1.uhungarumlaut = 500;
                        e1.ecaron = 444;
                        e1.Ydieresis = 722;
                        e1.divide = 564;
                        e1.Yacute = 722;
                        e1.Acircumflex = 722;
                        e1.aacute = 444;
                        e1.Ucircumflex = 722;
                        e1.yacute = 500;
                        e1.scommaaccent = 389;
                        e1.ecircumflex = 444;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 444;
                        e1.Uacute = 722;
                        e1.uogonek = 500;
                        e1.Edieresis = 611;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 760;
                        e1.Emacron = 611;
                        e1.ccaron = 444;
                        e1.aring = 444;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 278;
                        e1.agrave = 444;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 667;
                        e1.atilde = 444;
                        e1.Edotaccent = 611;
                        e1.scaron = 389;
                        e1.scedilla = 389;
                        e1.iacute = 278;
                        e1.lozenge = 471;
                        e1.Rcaron = 667;
                        e1.Gcommaaccent = 722;
                        e1.ucircumflex = 500;
                        e1.acircumflex = 444;
                        e1.Amacron = 722;
                        e1.rcaron = 333;
                        e1.ccedilla = 444;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 556;
                        e1.Omacron = 722;
                        e1.Racute = 667;
                        e1.Sacute = 556;
                        e1.dcaron = 588;
                        e1.Umacron = 722;
                        e1.uring = 500;
                        e1.threesuperior = 300;
                        e1.Ograve = 722;
                        e1.Agrave = 722;
                        e1.Abreve = 722;
                        e1.multiply = 564;
                        e1.uacute = 500;
                        e1.Tcaron = 611;
                        e1.partialdiff = 476;
                        e1.ydieresis = 500;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 611;
                        e1.adieresis = 444;
                        e1.edieresis = 444;
                        e1.cacute = 444;
                        e1.nacute = 500;
                        e1.umacron = 500;
                        e1.Ncaron = 722;
                        e1.Iacute = 333;
                        e1.plusminus = 564;
                        e1.brokenbar = 200;
                        e1.registered = 760;
                        e1.Gbreve = 722;
                        e1.Idotaccent = 333;
                        e1.summation = 600;
                        e1.Egrave = 611;
                        e1.racute = 333;
                        e1.omacron = 500;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 667;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 326;
                        e1.eogonek = 444;
                        e1.Uogonek = 722;
                        e1.Aacute = 722;
                        e1.Adieresis = 722;
                        e1.egrave = 444;
                        e1.zacute = 444;
                        e1.iogonek = 278;
                        e1.Oacute = 722;
                        e1.oacute = 500;
                        e1.amacron = 444;
                        e1.sacute = 389;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 722;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 500;
                        e1.twosuperior = 300;
                        e1.Odieresis = 722;
                        e1.mu = 500;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 500;
                        e1.Eogonek = 611;
                        e1.dcroat = 500;
                        e1.threequarters = 750;
                        e1.Scedilla = 556;
                        e1.lcaron = 344;
                        e1.Kcommaaccent = 722;
                        e1.Lacute = 611;
                        e1.trademark = 980;
                        e1.edotaccent = 444;
                        e1.Igrave = 333;
                        e1.Imacron = 333;
                        e1.Lcaron = 611;
                        e1.onehalf = 750;
                        e1.lessequal = 549;
                        e1.ocircumflex = 500;
                        e1.ntilde = 500;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 611;
                        e1.emacron = 444;
                        e1.gbreve = 500;
                        e1.onequarter = 750;
                        e1.Scaron = 556;
                        e1.Scommaaccent = 556;
                        e1.Ohungarumlaut = 722;
                        e1.degree = 400;
                        e1.ograve = 500;
                        e1.Ccaron = 667;
                        e1.ugrave = 500;
                        e1.radical = 453;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 333;
                        e1.Ntilde = 722;
                        e1.otilde = 500;
                        e1.Rcommaaccent = 667;
                        e1.Lcommaaccent = 611;
                        e1.Atilde = 722;
                        e1.Aogonek = 722;
                        e1.Aring = 722;
                        e1.Otilde = 722;
                        e1.zdotaccent = 444;
                        e1.Ecaron = 611;
                        e1.Iogonek = 333;
                        e1.kcommaaccent = 500;
                        e1.minus = 564;
                        e1.Icircumflex = 333;
                        e1.ncaron = 500;
                        e1.tcommaaccent = 278;
                        e1.logicalnot = 564;
                        e1.odieresis = 500;
                        e1.udieresis = 500;
                        e1.notequal = 549;
                        e1.gcommaaccent = 500;
                        e1.eth = 500;
                        e1.zcaron = 444;
                        e1.ncommaaccent = 500;
                        e1.onesuperior = 300;
                        e1.imacron = 278;
                        e1.Euro = 500;
                    });
                    e1["Times-Bold"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 250;
                        e1.exclam = 333;
                        e1.quotedbl = 555;
                        e1.numbersign = 500;
                        e1.dollar = 500;
                        e1.percent = 1e3;
                        e1.ampersand = 833;
                        e1.quoteright = 333;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 500;
                        e1.plus = 570;
                        e1.comma = 250;
                        e1.hyphen = 333;
                        e1.period = 250;
                        e1.slash = 278;
                        e1.zero = 500;
                        e1.one = 500;
                        e1.two = 500;
                        e1.three = 500;
                        e1.four = 500;
                        e1.five = 500;
                        e1.six = 500;
                        e1.seven = 500;
                        e1.eight = 500;
                        e1.nine = 500;
                        e1.colon = 333;
                        e1.semicolon = 333;
                        e1.less = 570;
                        e1.equal = 570;
                        e1.greater = 570;
                        e1.question = 500;
                        e1.at = 930;
                        e1.A = 722;
                        e1.B = 667;
                        e1.C = 722;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 611;
                        e1.G = 778;
                        e1.H = 778;
                        e1.I = 389;
                        e1.J = 500;
                        e1.K = 778;
                        e1.L = 667;
                        e1.M = 944;
                        e1.N = 722;
                        e1.O = 778;
                        e1.P = 611;
                        e1.Q = 778;
                        e1.R = 722;
                        e1.S = 556;
                        e1.T = 667;
                        e1.U = 722;
                        e1.V = 722;
                        e1.W = 1e3;
                        e1.X = 722;
                        e1.Y = 722;
                        e1.Z = 667;
                        e1.bracketleft = 333;
                        e1.backslash = 278;
                        e1.bracketright = 333;
                        e1.asciicircum = 581;
                        e1.underscore = 500;
                        e1.quoteleft = 333;
                        e1.a = 500;
                        e1.b = 556;
                        e1.c = 444;
                        e1.d = 556;
                        e1.e = 444;
                        e1.f = 333;
                        e1.g = 500;
                        e1.h = 556;
                        e1.i = 278;
                        e1.j = 333;
                        e1.k = 556;
                        e1.l = 278;
                        e1.m = 833;
                        e1.n = 556;
                        e1.o = 500;
                        e1.p = 556;
                        e1.q = 556;
                        e1.r = 444;
                        e1.s = 389;
                        e1.t = 333;
                        e1.u = 556;
                        e1.v = 500;
                        e1.w = 722;
                        e1.x = 500;
                        e1.y = 500;
                        e1.z = 444;
                        e1.braceleft = 394;
                        e1.bar = 220;
                        e1.braceright = 394;
                        e1.asciitilde = 520;
                        e1.exclamdown = 333;
                        e1.cent = 500;
                        e1.sterling = 500;
                        e1.fraction = 167;
                        e1.yen = 500;
                        e1.florin = 500;
                        e1.section = 500;
                        e1.currency = 500;
                        e1.quotesingle = 278;
                        e1.quotedblleft = 500;
                        e1.guillemotleft = 500;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 556;
                        e1.fl = 556;
                        e1.endash = 500;
                        e1.dagger = 500;
                        e1.daggerdbl = 500;
                        e1.periodcentered = 250;
                        e1.paragraph = 540;
                        e1.bullet = 350;
                        e1.quotesinglbase = 333;
                        e1.quotedblbase = 500;
                        e1.quotedblright = 500;
                        e1.guillemotright = 500;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 500;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 1e3;
                        e1.ordfeminine = 300;
                        e1.Lslash = 667;
                        e1.Oslash = 778;
                        e1.OE = 1e3;
                        e1.ordmasculine = 330;
                        e1.ae = 722;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 500;
                        e1.oe = 722;
                        e1.germandbls = 556;
                        e1.Idieresis = 389;
                        e1.eacute = 444;
                        e1.abreve = 500;
                        e1.uhungarumlaut = 556;
                        e1.ecaron = 444;
                        e1.Ydieresis = 722;
                        e1.divide = 570;
                        e1.Yacute = 722;
                        e1.Acircumflex = 722;
                        e1.aacute = 500;
                        e1.Ucircumflex = 722;
                        e1.yacute = 500;
                        e1.scommaaccent = 389;
                        e1.ecircumflex = 444;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 500;
                        e1.Uacute = 722;
                        e1.uogonek = 556;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 747;
                        e1.Emacron = 667;
                        e1.ccaron = 444;
                        e1.aring = 500;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 278;
                        e1.agrave = 500;
                        e1.Tcommaaccent = 667;
                        e1.Cacute = 722;
                        e1.atilde = 500;
                        e1.Edotaccent = 667;
                        e1.scaron = 389;
                        e1.scedilla = 389;
                        e1.iacute = 278;
                        e1.lozenge = 494;
                        e1.Rcaron = 722;
                        e1.Gcommaaccent = 778;
                        e1.ucircumflex = 556;
                        e1.acircumflex = 500;
                        e1.Amacron = 722;
                        e1.rcaron = 444;
                        e1.ccedilla = 444;
                        e1.Zdotaccent = 667;
                        e1.Thorn = 611;
                        e1.Omacron = 778;
                        e1.Racute = 722;
                        e1.Sacute = 556;
                        e1.dcaron = 672;
                        e1.Umacron = 722;
                        e1.uring = 556;
                        e1.threesuperior = 300;
                        e1.Ograve = 778;
                        e1.Agrave = 722;
                        e1.Abreve = 722;
                        e1.multiply = 570;
                        e1.uacute = 556;
                        e1.Tcaron = 667;
                        e1.partialdiff = 494;
                        e1.ydieresis = 500;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 500;
                        e1.edieresis = 444;
                        e1.cacute = 444;
                        e1.nacute = 556;
                        e1.umacron = 556;
                        e1.Ncaron = 722;
                        e1.Iacute = 389;
                        e1.plusminus = 570;
                        e1.brokenbar = 220;
                        e1.registered = 747;
                        e1.Gbreve = 778;
                        e1.Idotaccent = 389;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 444;
                        e1.omacron = 500;
                        e1.Zacute = 667;
                        e1.Zcaron = 667;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 722;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 416;
                        e1.eogonek = 444;
                        e1.Uogonek = 722;
                        e1.Aacute = 722;
                        e1.Adieresis = 722;
                        e1.egrave = 444;
                        e1.zacute = 444;
                        e1.iogonek = 278;
                        e1.Oacute = 778;
                        e1.oacute = 500;
                        e1.amacron = 500;
                        e1.sacute = 389;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 778;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 556;
                        e1.twosuperior = 300;
                        e1.Odieresis = 778;
                        e1.mu = 556;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 500;
                        e1.Eogonek = 667;
                        e1.dcroat = 556;
                        e1.threequarters = 750;
                        e1.Scedilla = 556;
                        e1.lcaron = 394;
                        e1.Kcommaaccent = 778;
                        e1.Lacute = 667;
                        e1.trademark = 1e3;
                        e1.edotaccent = 444;
                        e1.Igrave = 389;
                        e1.Imacron = 389;
                        e1.Lcaron = 667;
                        e1.onehalf = 750;
                        e1.lessequal = 549;
                        e1.ocircumflex = 500;
                        e1.ntilde = 556;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 444;
                        e1.gbreve = 500;
                        e1.onequarter = 750;
                        e1.Scaron = 556;
                        e1.Scommaaccent = 556;
                        e1.Ohungarumlaut = 778;
                        e1.degree = 400;
                        e1.ograve = 500;
                        e1.Ccaron = 722;
                        e1.ugrave = 556;
                        e1.radical = 549;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 444;
                        e1.Ntilde = 722;
                        e1.otilde = 500;
                        e1.Rcommaaccent = 722;
                        e1.Lcommaaccent = 667;
                        e1.Atilde = 722;
                        e1.Aogonek = 722;
                        e1.Aring = 722;
                        e1.Otilde = 778;
                        e1.zdotaccent = 444;
                        e1.Ecaron = 667;
                        e1.Iogonek = 389;
                        e1.kcommaaccent = 556;
                        e1.minus = 570;
                        e1.Icircumflex = 389;
                        e1.ncaron = 556;
                        e1.tcommaaccent = 333;
                        e1.logicalnot = 570;
                        e1.odieresis = 500;
                        e1.udieresis = 556;
                        e1.notequal = 549;
                        e1.gcommaaccent = 500;
                        e1.eth = 500;
                        e1.zcaron = 444;
                        e1.ncommaaccent = 556;
                        e1.onesuperior = 300;
                        e1.imacron = 278;
                        e1.Euro = 500;
                    });
                    e1["Times-BoldItalic"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 250;
                        e1.exclam = 389;
                        e1.quotedbl = 555;
                        e1.numbersign = 500;
                        e1.dollar = 500;
                        e1.percent = 833;
                        e1.ampersand = 778;
                        e1.quoteright = 333;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 500;
                        e1.plus = 570;
                        e1.comma = 250;
                        e1.hyphen = 333;
                        e1.period = 250;
                        e1.slash = 278;
                        e1.zero = 500;
                        e1.one = 500;
                        e1.two = 500;
                        e1.three = 500;
                        e1.four = 500;
                        e1.five = 500;
                        e1.six = 500;
                        e1.seven = 500;
                        e1.eight = 500;
                        e1.nine = 500;
                        e1.colon = 333;
                        e1.semicolon = 333;
                        e1.less = 570;
                        e1.equal = 570;
                        e1.greater = 570;
                        e1.question = 500;
                        e1.at = 832;
                        e1.A = 667;
                        e1.B = 667;
                        e1.C = 667;
                        e1.D = 722;
                        e1.E = 667;
                        e1.F = 667;
                        e1.G = 722;
                        e1.H = 778;
                        e1.I = 389;
                        e1.J = 500;
                        e1.K = 667;
                        e1.L = 611;
                        e1.M = 889;
                        e1.N = 722;
                        e1.O = 722;
                        e1.P = 611;
                        e1.Q = 722;
                        e1.R = 667;
                        e1.S = 556;
                        e1.T = 611;
                        e1.U = 722;
                        e1.V = 667;
                        e1.W = 889;
                        e1.X = 667;
                        e1.Y = 611;
                        e1.Z = 611;
                        e1.bracketleft = 333;
                        e1.backslash = 278;
                        e1.bracketright = 333;
                        e1.asciicircum = 570;
                        e1.underscore = 500;
                        e1.quoteleft = 333;
                        e1.a = 500;
                        e1.b = 500;
                        e1.c = 444;
                        e1.d = 500;
                        e1.e = 444;
                        e1.f = 333;
                        e1.g = 500;
                        e1.h = 556;
                        e1.i = 278;
                        e1.j = 278;
                        e1.k = 500;
                        e1.l = 278;
                        e1.m = 778;
                        e1.n = 556;
                        e1.o = 500;
                        e1.p = 500;
                        e1.q = 500;
                        e1.r = 389;
                        e1.s = 389;
                        e1.t = 278;
                        e1.u = 556;
                        e1.v = 444;
                        e1.w = 667;
                        e1.x = 500;
                        e1.y = 444;
                        e1.z = 389;
                        e1.braceleft = 348;
                        e1.bar = 220;
                        e1.braceright = 348;
                        e1.asciitilde = 570;
                        e1.exclamdown = 389;
                        e1.cent = 500;
                        e1.sterling = 500;
                        e1.fraction = 167;
                        e1.yen = 500;
                        e1.florin = 500;
                        e1.section = 500;
                        e1.currency = 500;
                        e1.quotesingle = 278;
                        e1.quotedblleft = 500;
                        e1.guillemotleft = 500;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 556;
                        e1.fl = 556;
                        e1.endash = 500;
                        e1.dagger = 500;
                        e1.daggerdbl = 500;
                        e1.periodcentered = 250;
                        e1.paragraph = 500;
                        e1.bullet = 350;
                        e1.quotesinglbase = 333;
                        e1.quotedblbase = 500;
                        e1.quotedblright = 500;
                        e1.guillemotright = 500;
                        e1.ellipsis = 1e3;
                        e1.perthousand = 1e3;
                        e1.questiondown = 500;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 1e3;
                        e1.AE = 944;
                        e1.ordfeminine = 266;
                        e1.Lslash = 611;
                        e1.Oslash = 722;
                        e1.OE = 944;
                        e1.ordmasculine = 300;
                        e1.ae = 722;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 500;
                        e1.oe = 722;
                        e1.germandbls = 500;
                        e1.Idieresis = 389;
                        e1.eacute = 444;
                        e1.abreve = 500;
                        e1.uhungarumlaut = 556;
                        e1.ecaron = 444;
                        e1.Ydieresis = 611;
                        e1.divide = 570;
                        e1.Yacute = 611;
                        e1.Acircumflex = 667;
                        e1.aacute = 500;
                        e1.Ucircumflex = 722;
                        e1.yacute = 444;
                        e1.scommaaccent = 389;
                        e1.ecircumflex = 444;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 500;
                        e1.Uacute = 722;
                        e1.uogonek = 556;
                        e1.Edieresis = 667;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 747;
                        e1.Emacron = 667;
                        e1.ccaron = 444;
                        e1.aring = 500;
                        e1.Ncommaaccent = 722;
                        e1.lacute = 278;
                        e1.agrave = 500;
                        e1.Tcommaaccent = 611;
                        e1.Cacute = 667;
                        e1.atilde = 500;
                        e1.Edotaccent = 667;
                        e1.scaron = 389;
                        e1.scedilla = 389;
                        e1.iacute = 278;
                        e1.lozenge = 494;
                        e1.Rcaron = 667;
                        e1.Gcommaaccent = 722;
                        e1.ucircumflex = 556;
                        e1.acircumflex = 500;
                        e1.Amacron = 667;
                        e1.rcaron = 389;
                        e1.ccedilla = 444;
                        e1.Zdotaccent = 611;
                        e1.Thorn = 611;
                        e1.Omacron = 722;
                        e1.Racute = 667;
                        e1.Sacute = 556;
                        e1.dcaron = 608;
                        e1.Umacron = 722;
                        e1.uring = 556;
                        e1.threesuperior = 300;
                        e1.Ograve = 722;
                        e1.Agrave = 667;
                        e1.Abreve = 667;
                        e1.multiply = 570;
                        e1.uacute = 556;
                        e1.Tcaron = 611;
                        e1.partialdiff = 494;
                        e1.ydieresis = 444;
                        e1.Nacute = 722;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 667;
                        e1.adieresis = 500;
                        e1.edieresis = 444;
                        e1.cacute = 444;
                        e1.nacute = 556;
                        e1.umacron = 556;
                        e1.Ncaron = 722;
                        e1.Iacute = 389;
                        e1.plusminus = 570;
                        e1.brokenbar = 220;
                        e1.registered = 747;
                        e1.Gbreve = 722;
                        e1.Idotaccent = 389;
                        e1.summation = 600;
                        e1.Egrave = 667;
                        e1.racute = 389;
                        e1.omacron = 500;
                        e1.Zacute = 611;
                        e1.Zcaron = 611;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 667;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 366;
                        e1.eogonek = 444;
                        e1.Uogonek = 722;
                        e1.Aacute = 667;
                        e1.Adieresis = 667;
                        e1.egrave = 444;
                        e1.zacute = 389;
                        e1.iogonek = 278;
                        e1.Oacute = 722;
                        e1.oacute = 500;
                        e1.amacron = 500;
                        e1.sacute = 389;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 722;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 500;
                        e1.twosuperior = 300;
                        e1.Odieresis = 722;
                        e1.mu = 576;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 500;
                        e1.Eogonek = 667;
                        e1.dcroat = 500;
                        e1.threequarters = 750;
                        e1.Scedilla = 556;
                        e1.lcaron = 382;
                        e1.Kcommaaccent = 667;
                        e1.Lacute = 611;
                        e1.trademark = 1e3;
                        e1.edotaccent = 444;
                        e1.Igrave = 389;
                        e1.Imacron = 389;
                        e1.Lcaron = 611;
                        e1.onehalf = 750;
                        e1.lessequal = 549;
                        e1.ocircumflex = 500;
                        e1.ntilde = 556;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 667;
                        e1.emacron = 444;
                        e1.gbreve = 500;
                        e1.onequarter = 750;
                        e1.Scaron = 556;
                        e1.Scommaaccent = 556;
                        e1.Ohungarumlaut = 722;
                        e1.degree = 400;
                        e1.ograve = 500;
                        e1.Ccaron = 667;
                        e1.ugrave = 556;
                        e1.radical = 549;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 389;
                        e1.Ntilde = 722;
                        e1.otilde = 500;
                        e1.Rcommaaccent = 667;
                        e1.Lcommaaccent = 611;
                        e1.Atilde = 667;
                        e1.Aogonek = 667;
                        e1.Aring = 667;
                        e1.Otilde = 722;
                        e1.zdotaccent = 389;
                        e1.Ecaron = 667;
                        e1.Iogonek = 389;
                        e1.kcommaaccent = 500;
                        e1.minus = 606;
                        e1.Icircumflex = 389;
                        e1.ncaron = 556;
                        e1.tcommaaccent = 278;
                        e1.logicalnot = 606;
                        e1.odieresis = 500;
                        e1.udieresis = 556;
                        e1.notequal = 549;
                        e1.gcommaaccent = 500;
                        e1.eth = 500;
                        e1.zcaron = 389;
                        e1.ncommaaccent = 556;
                        e1.onesuperior = 300;
                        e1.imacron = 278;
                        e1.Euro = 500;
                    });
                    e1["Times-Italic"] = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 250;
                        e1.exclam = 333;
                        e1.quotedbl = 420;
                        e1.numbersign = 500;
                        e1.dollar = 500;
                        e1.percent = 833;
                        e1.ampersand = 778;
                        e1.quoteright = 333;
                        e1.parenleft = 333;
                        e1.parenright = 333;
                        e1.asterisk = 500;
                        e1.plus = 675;
                        e1.comma = 250;
                        e1.hyphen = 333;
                        e1.period = 250;
                        e1.slash = 278;
                        e1.zero = 500;
                        e1.one = 500;
                        e1.two = 500;
                        e1.three = 500;
                        e1.four = 500;
                        e1.five = 500;
                        e1.six = 500;
                        e1.seven = 500;
                        e1.eight = 500;
                        e1.nine = 500;
                        e1.colon = 333;
                        e1.semicolon = 333;
                        e1.less = 675;
                        e1.equal = 675;
                        e1.greater = 675;
                        e1.question = 500;
                        e1.at = 920;
                        e1.A = 611;
                        e1.B = 611;
                        e1.C = 667;
                        e1.D = 722;
                        e1.E = 611;
                        e1.F = 611;
                        e1.G = 722;
                        e1.H = 722;
                        e1.I = 333;
                        e1.J = 444;
                        e1.K = 667;
                        e1.L = 556;
                        e1.M = 833;
                        e1.N = 667;
                        e1.O = 722;
                        e1.P = 611;
                        e1.Q = 722;
                        e1.R = 611;
                        e1.S = 500;
                        e1.T = 556;
                        e1.U = 722;
                        e1.V = 611;
                        e1.W = 833;
                        e1.X = 611;
                        e1.Y = 556;
                        e1.Z = 556;
                        e1.bracketleft = 389;
                        e1.backslash = 278;
                        e1.bracketright = 389;
                        e1.asciicircum = 422;
                        e1.underscore = 500;
                        e1.quoteleft = 333;
                        e1.a = 500;
                        e1.b = 500;
                        e1.c = 444;
                        e1.d = 500;
                        e1.e = 444;
                        e1.f = 278;
                        e1.g = 500;
                        e1.h = 500;
                        e1.i = 278;
                        e1.j = 278;
                        e1.k = 444;
                        e1.l = 278;
                        e1.m = 722;
                        e1.n = 500;
                        e1.o = 500;
                        e1.p = 500;
                        e1.q = 500;
                        e1.r = 389;
                        e1.s = 389;
                        e1.t = 278;
                        e1.u = 500;
                        e1.v = 444;
                        e1.w = 667;
                        e1.x = 444;
                        e1.y = 444;
                        e1.z = 389;
                        e1.braceleft = 400;
                        e1.bar = 275;
                        e1.braceright = 400;
                        e1.asciitilde = 541;
                        e1.exclamdown = 389;
                        e1.cent = 500;
                        e1.sterling = 500;
                        e1.fraction = 167;
                        e1.yen = 500;
                        e1.florin = 500;
                        e1.section = 500;
                        e1.currency = 500;
                        e1.quotesingle = 214;
                        e1.quotedblleft = 556;
                        e1.guillemotleft = 500;
                        e1.guilsinglleft = 333;
                        e1.guilsinglright = 333;
                        e1.fi = 500;
                        e1.fl = 500;
                        e1.endash = 500;
                        e1.dagger = 500;
                        e1.daggerdbl = 500;
                        e1.periodcentered = 250;
                        e1.paragraph = 523;
                        e1.bullet = 350;
                        e1.quotesinglbase = 333;
                        e1.quotedblbase = 556;
                        e1.quotedblright = 556;
                        e1.guillemotright = 500;
                        e1.ellipsis = 889;
                        e1.perthousand = 1e3;
                        e1.questiondown = 500;
                        e1.grave = 333;
                        e1.acute = 333;
                        e1.circumflex = 333;
                        e1.tilde = 333;
                        e1.macron = 333;
                        e1.breve = 333;
                        e1.dotaccent = 333;
                        e1.dieresis = 333;
                        e1.ring = 333;
                        e1.cedilla = 333;
                        e1.hungarumlaut = 333;
                        e1.ogonek = 333;
                        e1.caron = 333;
                        e1.emdash = 889;
                        e1.AE = 889;
                        e1.ordfeminine = 276;
                        e1.Lslash = 556;
                        e1.Oslash = 722;
                        e1.OE = 944;
                        e1.ordmasculine = 310;
                        e1.ae = 667;
                        e1.dotlessi = 278;
                        e1.lslash = 278;
                        e1.oslash = 500;
                        e1.oe = 667;
                        e1.germandbls = 500;
                        e1.Idieresis = 333;
                        e1.eacute = 444;
                        e1.abreve = 500;
                        e1.uhungarumlaut = 500;
                        e1.ecaron = 444;
                        e1.Ydieresis = 556;
                        e1.divide = 675;
                        e1.Yacute = 556;
                        e1.Acircumflex = 611;
                        e1.aacute = 500;
                        e1.Ucircumflex = 722;
                        e1.yacute = 444;
                        e1.scommaaccent = 389;
                        e1.ecircumflex = 444;
                        e1.Uring = 722;
                        e1.Udieresis = 722;
                        e1.aogonek = 500;
                        e1.Uacute = 722;
                        e1.uogonek = 500;
                        e1.Edieresis = 611;
                        e1.Dcroat = 722;
                        e1.commaaccent = 250;
                        e1.copyright = 760;
                        e1.Emacron = 611;
                        e1.ccaron = 444;
                        e1.aring = 500;
                        e1.Ncommaaccent = 667;
                        e1.lacute = 278;
                        e1.agrave = 500;
                        e1.Tcommaaccent = 556;
                        e1.Cacute = 667;
                        e1.atilde = 500;
                        e1.Edotaccent = 611;
                        e1.scaron = 389;
                        e1.scedilla = 389;
                        e1.iacute = 278;
                        e1.lozenge = 471;
                        e1.Rcaron = 611;
                        e1.Gcommaaccent = 722;
                        e1.ucircumflex = 500;
                        e1.acircumflex = 500;
                        e1.Amacron = 611;
                        e1.rcaron = 389;
                        e1.ccedilla = 444;
                        e1.Zdotaccent = 556;
                        e1.Thorn = 611;
                        e1.Omacron = 722;
                        e1.Racute = 611;
                        e1.Sacute = 500;
                        e1.dcaron = 544;
                        e1.Umacron = 722;
                        e1.uring = 500;
                        e1.threesuperior = 300;
                        e1.Ograve = 722;
                        e1.Agrave = 611;
                        e1.Abreve = 611;
                        e1.multiply = 675;
                        e1.uacute = 500;
                        e1.Tcaron = 556;
                        e1.partialdiff = 476;
                        e1.ydieresis = 444;
                        e1.Nacute = 667;
                        e1.icircumflex = 278;
                        e1.Ecircumflex = 611;
                        e1.adieresis = 500;
                        e1.edieresis = 444;
                        e1.cacute = 444;
                        e1.nacute = 500;
                        e1.umacron = 500;
                        e1.Ncaron = 667;
                        e1.Iacute = 333;
                        e1.plusminus = 675;
                        e1.brokenbar = 275;
                        e1.registered = 760;
                        e1.Gbreve = 722;
                        e1.Idotaccent = 333;
                        e1.summation = 600;
                        e1.Egrave = 611;
                        e1.racute = 389;
                        e1.omacron = 500;
                        e1.Zacute = 556;
                        e1.Zcaron = 556;
                        e1.greaterequal = 549;
                        e1.Eth = 722;
                        e1.Ccedilla = 667;
                        e1.lcommaaccent = 278;
                        e1.tcaron = 300;
                        e1.eogonek = 444;
                        e1.Uogonek = 722;
                        e1.Aacute = 611;
                        e1.Adieresis = 611;
                        e1.egrave = 444;
                        e1.zacute = 389;
                        e1.iogonek = 278;
                        e1.Oacute = 722;
                        e1.oacute = 500;
                        e1.amacron = 500;
                        e1.sacute = 389;
                        e1.idieresis = 278;
                        e1.Ocircumflex = 722;
                        e1.Ugrave = 722;
                        e1.Delta = 612;
                        e1.thorn = 500;
                        e1.twosuperior = 300;
                        e1.Odieresis = 722;
                        e1.mu = 500;
                        e1.igrave = 278;
                        e1.ohungarumlaut = 500;
                        e1.Eogonek = 611;
                        e1.dcroat = 500;
                        e1.threequarters = 750;
                        e1.Scedilla = 500;
                        e1.lcaron = 300;
                        e1.Kcommaaccent = 667;
                        e1.Lacute = 556;
                        e1.trademark = 980;
                        e1.edotaccent = 444;
                        e1.Igrave = 333;
                        e1.Imacron = 333;
                        e1.Lcaron = 611;
                        e1.onehalf = 750;
                        e1.lessequal = 549;
                        e1.ocircumflex = 500;
                        e1.ntilde = 500;
                        e1.Uhungarumlaut = 722;
                        e1.Eacute = 611;
                        e1.emacron = 444;
                        e1.gbreve = 500;
                        e1.onequarter = 750;
                        e1.Scaron = 500;
                        e1.Scommaaccent = 500;
                        e1.Ohungarumlaut = 722;
                        e1.degree = 400;
                        e1.ograve = 500;
                        e1.Ccaron = 667;
                        e1.ugrave = 500;
                        e1.radical = 453;
                        e1.Dcaron = 722;
                        e1.rcommaaccent = 389;
                        e1.Ntilde = 667;
                        e1.otilde = 500;
                        e1.Rcommaaccent = 611;
                        e1.Lcommaaccent = 556;
                        e1.Atilde = 611;
                        e1.Aogonek = 611;
                        e1.Aring = 611;
                        e1.Otilde = 722;
                        e1.zdotaccent = 389;
                        e1.Ecaron = 611;
                        e1.Iogonek = 333;
                        e1.kcommaaccent = 444;
                        e1.minus = 675;
                        e1.Icircumflex = 333;
                        e1.ncaron = 500;
                        e1.tcommaaccent = 278;
                        e1.logicalnot = 675;
                        e1.odieresis = 500;
                        e1.udieresis = 500;
                        e1.notequal = 549;
                        e1.gcommaaccent = 500;
                        e1.eth = 500;
                        e1.zcaron = 389;
                        e1.ncommaaccent = 500;
                        e1.onesuperior = 300;
                        e1.imacron = 278;
                        e1.Euro = 500;
                    });
                    e1.ZapfDingbats = (0, r.getLookupTableFactory)(function(e1) {
                        e1.space = 278;
                        e1.a1 = 974;
                        e1.a2 = 961;
                        e1.a202 = 974;
                        e1.a3 = 980;
                        e1.a4 = 719;
                        e1.a5 = 789;
                        e1.a119 = 790;
                        e1.a118 = 791;
                        e1.a117 = 690;
                        e1.a11 = 960;
                        e1.a12 = 939;
                        e1.a13 = 549;
                        e1.a14 = 855;
                        e1.a15 = 911;
                        e1.a16 = 933;
                        e1.a105 = 911;
                        e1.a17 = 945;
                        e1.a18 = 974;
                        e1.a19 = 755;
                        e1.a20 = 846;
                        e1.a21 = 762;
                        e1.a22 = 761;
                        e1.a23 = 571;
                        e1.a24 = 677;
                        e1.a25 = 763;
                        e1.a26 = 760;
                        e1.a27 = 759;
                        e1.a28 = 754;
                        e1.a6 = 494;
                        e1.a7 = 552;
                        e1.a8 = 537;
                        e1.a9 = 577;
                        e1.a10 = 692;
                        e1.a29 = 786;
                        e1.a30 = 788;
                        e1.a31 = 788;
                        e1.a32 = 790;
                        e1.a33 = 793;
                        e1.a34 = 794;
                        e1.a35 = 816;
                        e1.a36 = 823;
                        e1.a37 = 789;
                        e1.a38 = 841;
                        e1.a39 = 823;
                        e1.a40 = 833;
                        e1.a41 = 816;
                        e1.a42 = 831;
                        e1.a43 = 923;
                        e1.a44 = 744;
                        e1.a45 = 723;
                        e1.a46 = 749;
                        e1.a47 = 790;
                        e1.a48 = 792;
                        e1.a49 = 695;
                        e1.a50 = 776;
                        e1.a51 = 768;
                        e1.a52 = 792;
                        e1.a53 = 759;
                        e1.a54 = 707;
                        e1.a55 = 708;
                        e1.a56 = 682;
                        e1.a57 = 701;
                        e1.a58 = 826;
                        e1.a59 = 815;
                        e1.a60 = 789;
                        e1.a61 = 789;
                        e1.a62 = 707;
                        e1.a63 = 687;
                        e1.a64 = 696;
                        e1.a65 = 689;
                        e1.a66 = 786;
                        e1.a67 = 787;
                        e1.a68 = 713;
                        e1.a69 = 791;
                        e1.a70 = 785;
                        e1.a71 = 791;
                        e1.a72 = 873;
                        e1.a73 = 761;
                        e1.a74 = 762;
                        e1.a203 = 762;
                        e1.a75 = 759;
                        e1.a204 = 759;
                        e1.a76 = 892;
                        e1.a77 = 892;
                        e1.a78 = 788;
                        e1.a79 = 784;
                        e1.a81 = 438;
                        e1.a82 = 138;
                        e1.a83 = 277;
                        e1.a84 = 415;
                        e1.a97 = 392;
                        e1.a98 = 392;
                        e1.a99 = 668;
                        e1.a100 = 668;
                        e1.a89 = 390;
                        e1.a90 = 390;
                        e1.a93 = 317;
                        e1.a94 = 317;
                        e1.a91 = 276;
                        e1.a92 = 276;
                        e1.a205 = 509;
                        e1.a85 = 509;
                        e1.a206 = 410;
                        e1.a86 = 410;
                        e1.a87 = 234;
                        e1.a88 = 234;
                        e1.a95 = 334;
                        e1.a96 = 334;
                        e1.a101 = 732;
                        e1.a102 = 544;
                        e1.a103 = 544;
                        e1.a104 = 910;
                        e1.a106 = 667;
                        e1.a107 = 760;
                        e1.a108 = 760;
                        e1.a112 = 776;
                        e1.a111 = 595;
                        e1.a110 = 694;
                        e1.a109 = 626;
                        e1.a120 = 788;
                        e1.a121 = 788;
                        e1.a122 = 788;
                        e1.a123 = 788;
                        e1.a124 = 788;
                        e1.a125 = 788;
                        e1.a126 = 788;
                        e1.a127 = 788;
                        e1.a128 = 788;
                        e1.a129 = 788;
                        e1.a130 = 788;
                        e1.a131 = 788;
                        e1.a132 = 788;
                        e1.a133 = 788;
                        e1.a134 = 788;
                        e1.a135 = 788;
                        e1.a136 = 788;
                        e1.a137 = 788;
                        e1.a138 = 788;
                        e1.a139 = 788;
                        e1.a140 = 788;
                        e1.a141 = 788;
                        e1.a142 = 788;
                        e1.a143 = 788;
                        e1.a144 = 788;
                        e1.a145 = 788;
                        e1.a146 = 788;
                        e1.a147 = 788;
                        e1.a148 = 788;
                        e1.a149 = 788;
                        e1.a150 = 788;
                        e1.a151 = 788;
                        e1.a152 = 788;
                        e1.a153 = 788;
                        e1.a154 = 788;
                        e1.a155 = 788;
                        e1.a156 = 788;
                        e1.a157 = 788;
                        e1.a158 = 788;
                        e1.a159 = 788;
                        e1.a160 = 894;
                        e1.a161 = 838;
                        e1.a163 = 1016;
                        e1.a164 = 458;
                        e1.a196 = 748;
                        e1.a165 = 924;
                        e1.a192 = 748;
                        e1.a166 = 918;
                        e1.a167 = 927;
                        e1.a168 = 928;
                        e1.a169 = 928;
                        e1.a170 = 834;
                        e1.a171 = 873;
                        e1.a172 = 828;
                        e1.a173 = 924;
                        e1.a162 = 924;
                        e1.a174 = 917;
                        e1.a175 = 930;
                        e1.a176 = 931;
                        e1.a177 = 463;
                        e1.a178 = 883;
                        e1.a179 = 836;
                        e1.a193 = 836;
                        e1.a180 = 867;
                        e1.a199 = 867;
                        e1.a181 = 696;
                        e1.a200 = 696;
                        e1.a182 = 874;
                        e1.a201 = 874;
                        e1.a183 = 760;
                        e1.a184 = 946;
                        e1.a197 = 771;
                        e1.a185 = 865;
                        e1.a194 = 771;
                        e1.a198 = 888;
                        e1.a186 = 967;
                        e1.a195 = 888;
                        e1.a187 = 831;
                        e1.a188 = 873;
                        e1.a189 = 927;
                        e1.a190 = 970;
                        e1.a191 = 918;
                    });
                });
                t.getMetrics = n;
                const i = (0, r.getLookupTableFactory)(function(e1) {
                    e1.Courier = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: -426
                    };
                    e1["Courier-Bold"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 439
                    };
                    e1["Courier-Oblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    e1["Courier-BoldOblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    e1.Helvetica = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    e1["Helvetica-Bold"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    e1["Helvetica-Oblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    e1["Helvetica-BoldOblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    e1["Times-Roman"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 662,
                        xHeight: 450
                    };
                    e1["Times-Bold"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 676,
                        xHeight: 461
                    };
                    e1["Times-Italic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 653,
                        xHeight: 441
                    };
                    e1["Times-BoldItalic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 669,
                        xHeight: 462
                    };
                    e1.Symbol = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                    e1.ZapfDingbats = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                });
                t.getFontBasicMetrics = i;
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.GlyfTable = void 0;
                t.GlyfTable = class GlyfTable {
                    constructor({ glyfTable: e1, isGlyphLocationsLong: t, locaTable: a, numGlyphs: r }){
                        this.glyphs = [];
                        const n = new DataView(a.buffer, a.byteOffset, a.byteLength), i = new DataView(e1.buffer, e1.byteOffset, e1.byteLength), s = t ? 4 : 2;
                        let o = t ? n.getUint32(0) : 2 * n.getUint16(0), c = 0;
                        for(let e1 = 0; e1 < r; e1++){
                            c += s;
                            const e1 = t ? n.getUint32(c) : 2 * n.getUint16(c);
                            if (e1 === o) {
                                this.glyphs.push(new Glyph({}));
                                continue;
                            }
                            const a = Glyph.parse(o, i);
                            this.glyphs.push(a);
                            o = e1;
                        }
                    }
                    getSize() {
                        return this.glyphs.reduce((e1, t)=>e1 + (t.getSize() + 3 & -4), 0);
                    }
                    write() {
                        const e1 = this.getSize(), t = new DataView(new ArrayBuffer(e1)), a = e1 > 131070, r = a ? 4 : 2, n = new DataView(new ArrayBuffer((this.glyphs.length + 1) * r));
                        a ? n.setUint32(0, 0) : n.setUint16(0, 0);
                        let i = 0, s = 0;
                        for (const e1 of this.glyphs){
                            i += e1.write(i, t);
                            i = i + 3 & -4;
                            s += r;
                            a ? n.setUint32(s, i) : n.setUint16(s, i >> 1);
                        }
                        return {
                            isLocationLong: a,
                            loca: new Uint8Array(n.buffer),
                            glyf: new Uint8Array(t.buffer)
                        };
                    }
                    scale(e1) {
                        for(let t = 0, a = this.glyphs.length; t < a; t++)this.glyphs[t].scale(e1[t]);
                    }
                };
                class Glyph {
                    constructor({ header: e1 = null, simple: t = null, composites: a = null }){
                        this.header = e1;
                        this.simple = t;
                        this.composites = a;
                    }
                    static parse(e1, t) {
                        const [a, r] = GlyphHeader.parse(e1, t);
                        e1 += a;
                        if (r.numberOfContours < 0) {
                            const a = [];
                            for(;;){
                                const [r, n] = CompositeGlyph.parse(e1, t);
                                e1 += r;
                                a.push(n);
                                if (!(32 & n.flags)) break;
                            }
                            return new Glyph({
                                header: r,
                                composites: a
                            });
                        }
                        const n = SimpleGlyph.parse(e1, t, r.numberOfContours);
                        return new Glyph({
                            header: r,
                            simple: n
                        });
                    }
                    getSize() {
                        if (!this.header) return 0;
                        const e1 = this.simple ? this.simple.getSize() : this.composites.reduce((e1, t)=>e1 + t.getSize(), 0);
                        return this.header.getSize() + e1;
                    }
                    write(e1, t) {
                        if (!this.header) return 0;
                        const a = e1;
                        e1 += this.header.write(e1, t);
                        if (this.simple) e1 += this.simple.write(e1, t);
                        else for (const a of this.composites)e1 += a.write(e1, t);
                        return e1 - a;
                    }
                    scale(e1) {
                        if (!this.header) return;
                        const t = (this.header.xMin + this.header.xMax) / 2;
                        this.header.scale(t, e1);
                        if (this.simple) this.simple.scale(t, e1);
                        else for (const a of this.composites)a.scale(t, e1);
                    }
                }
                class GlyphHeader {
                    constructor({ numberOfContours: e1, xMin: t, yMin: a, xMax: r, yMax: n }){
                        this.numberOfContours = e1;
                        this.xMin = t;
                        this.yMin = a;
                        this.xMax = r;
                        this.yMax = n;
                    }
                    static parse(e1, t) {
                        return [
                            10,
                            new GlyphHeader({
                                numberOfContours: t.getInt16(e1),
                                xMin: t.getInt16(e1 + 2),
                                yMin: t.getInt16(e1 + 4),
                                xMax: t.getInt16(e1 + 6),
                                yMax: t.getInt16(e1 + 8)
                            })
                        ];
                    }
                    getSize() {
                        return 10;
                    }
                    write(e1, t) {
                        t.setInt16(e1, this.numberOfContours);
                        t.setInt16(e1 + 2, this.xMin);
                        t.setInt16(e1 + 4, this.yMin);
                        t.setInt16(e1 + 6, this.xMax);
                        t.setInt16(e1 + 8, this.yMax);
                        return 10;
                    }
                    scale(e1, t) {
                        this.xMin = Math.round(e1 + (this.xMin - e1) * t);
                        this.xMax = Math.round(e1 + (this.xMax - e1) * t);
                    }
                }
                class Contour {
                    constructor({ flags: e1, xCoordinates: t, yCoordinates: a }){
                        this.xCoordinates = t;
                        this.yCoordinates = a;
                        this.flags = e1;
                    }
                }
                class SimpleGlyph {
                    constructor({ contours: e1, instructions: t }){
                        this.contours = e1;
                        this.instructions = t;
                    }
                    static parse(e1, t, a) {
                        const r = [];
                        for(let n = 0; n < a; n++){
                            const a = t.getUint16(e1);
                            e1 += 2;
                            r.push(a);
                        }
                        const n = r[a - 1] + 1, i = t.getUint16(e1);
                        e1 += 2;
                        const s = new Uint8Array(t).slice(e1, e1 + i);
                        e1 += i;
                        const o = [];
                        for(let a = 0; a < n; e1++, a++){
                            let r = t.getUint8(e1);
                            o.push(r);
                            if (8 & r) {
                                const n = t.getUint8(++e1);
                                r ^= 8;
                                for(let e1 = 0; e1 < n; e1++)o.push(r);
                                a += n;
                            }
                        }
                        const c = [];
                        let l = [], h = [], u = [];
                        const d = [];
                        let f = 0, g = 0;
                        for(let a = 0; a < n; a++){
                            const n = o[a];
                            if (2 & n) {
                                const a = t.getUint8(e1++);
                                g += 16 & n ? a : -a;
                                l.push(g);
                            } else if (16 & n) l.push(g);
                            else {
                                g += t.getInt16(e1);
                                e1 += 2;
                                l.push(g);
                            }
                            if (r[f] === a) {
                                f++;
                                c.push(l);
                                l = [];
                            }
                        }
                        g = 0;
                        f = 0;
                        for(let a = 0; a < n; a++){
                            const n = o[a];
                            if (4 & n) {
                                const a = t.getUint8(e1++);
                                g += 32 & n ? a : -a;
                                h.push(g);
                            } else if (32 & n) h.push(g);
                            else {
                                g += t.getInt16(e1);
                                e1 += 2;
                                h.push(g);
                            }
                            u.push(1 & n | 64 & n);
                            if (r[f] === a) {
                                l = c[f];
                                f++;
                                d.push(new Contour({
                                    flags: u,
                                    xCoordinates: l,
                                    yCoordinates: h
                                }));
                                h = [];
                                u = [];
                            }
                        }
                        return new SimpleGlyph({
                            contours: d,
                            instructions: s
                        });
                    }
                    getSize() {
                        let e1 = 2 * this.contours.length + 2 + this.instructions.length, t = 0, a = 0;
                        for (const r of this.contours){
                            e1 += r.flags.length;
                            for(let n = 0, i = r.xCoordinates.length; n < i; n++){
                                const i = r.xCoordinates[n], s = r.yCoordinates[n];
                                let o = Math.abs(i - t);
                                o > 255 ? e1 += 2 : o > 0 && (e1 += 1);
                                t = i;
                                o = Math.abs(s - a);
                                o > 255 ? e1 += 2 : o > 0 && (e1 += 1);
                                a = s;
                            }
                        }
                        return e1;
                    }
                    write(e1, t) {
                        const a = e1, r = [], n = [], i = [];
                        let s = 0, o = 0;
                        for (const a of this.contours){
                            for(let e1 = 0, t = a.xCoordinates.length; e1 < t; e1++){
                                let t = a.flags[e1];
                                const c = a.xCoordinates[e1];
                                let l = c - s;
                                if (0 === l) {
                                    t |= 16;
                                    r.push(0);
                                } else {
                                    const e1 = Math.abs(l);
                                    if (e1 <= 255) {
                                        t |= l >= 0 ? 18 : 2;
                                        r.push(e1);
                                    } else r.push(l);
                                }
                                s = c;
                                const h = a.yCoordinates[e1];
                                l = h - o;
                                if (0 === l) {
                                    t |= 32;
                                    n.push(0);
                                } else {
                                    const e1 = Math.abs(l);
                                    if (e1 <= 255) {
                                        t |= l >= 0 ? 36 : 4;
                                        n.push(e1);
                                    } else n.push(l);
                                }
                                o = h;
                                i.push(t);
                            }
                            t.setUint16(e1, r.length - 1);
                            e1 += 2;
                        }
                        t.setUint16(e1, this.instructions.length);
                        e1 += 2;
                        if (this.instructions.length) {
                            new Uint8Array(t.buffer, 0, t.buffer.byteLength).set(this.instructions, e1);
                            e1 += this.instructions.length;
                        }
                        for (const a of i)t.setUint8(e1++, a);
                        for(let a = 0, n = r.length; a < n; a++){
                            const n = r[a], s = i[a];
                            if (2 & s) t.setUint8(e1++, n);
                            else if (!(16 & s)) {
                                t.setInt16(e1, n);
                                e1 += 2;
                            }
                        }
                        for(let a = 0, r = n.length; a < r; a++){
                            const r = n[a], s = i[a];
                            if (4 & s) t.setUint8(e1++, r);
                            else if (!(32 & s)) {
                                t.setInt16(e1, r);
                                e1 += 2;
                            }
                        }
                        return e1 - a;
                    }
                    scale(e1, t) {
                        for (const a of this.contours)if (0 !== a.xCoordinates.length) for(let r = 0, n = a.xCoordinates.length; r < n; r++)a.xCoordinates[r] = Math.round(e1 + (a.xCoordinates[r] - e1) * t);
                    }
                }
                class CompositeGlyph {
                    constructor({ flags: e1, glyphIndex: t, argument1: a, argument2: r, transf: n, instructions: i }){
                        this.flags = e1;
                        this.glyphIndex = t;
                        this.argument1 = a;
                        this.argument2 = r;
                        this.transf = n;
                        this.instructions = i;
                    }
                    static parse(e1, t) {
                        const a = e1, r = [];
                        let n = t.getUint16(e1);
                        const i = t.getUint16(e1 + 2);
                        e1 += 4;
                        let s, o;
                        if (1 & n) {
                            if (2 & n) {
                                s = t.getInt16(e1);
                                o = t.getInt16(e1 + 2);
                            } else {
                                s = t.getUint16(e1);
                                o = t.getUint16(e1 + 2);
                            }
                            e1 += 4;
                            n ^= 1;
                        } else {
                            if (2 & n) {
                                s = t.getInt8(e1);
                                o = t.getInt8(e1 + 1);
                            } else {
                                s = t.getUint8(e1);
                                o = t.getUint8(e1 + 1);
                            }
                            e1 += 2;
                        }
                        if (8 & n) {
                            r.push(t.getUint16(e1));
                            e1 += 2;
                        } else if (64 & n) {
                            r.push(t.getUint16(e1), t.getUint16(e1 + 2));
                            e1 += 4;
                        } else if (128 & n) {
                            r.push(t.getUint16(e1), t.getUint16(e1 + 2), t.getUint16(e1 + 4), t.getUint16(e1 + 6));
                            e1 += 8;
                        }
                        let c = null;
                        if (256 & n) {
                            const a = t.getUint16(e1);
                            e1 += 2;
                            c = new Uint8Array(t).slice(e1, e1 + a);
                            e1 += a;
                        }
                        return [
                            e1 - a,
                            new CompositeGlyph({
                                flags: n,
                                glyphIndex: i,
                                argument1: s,
                                argument2: o,
                                transf: r,
                                instructions: c
                            })
                        ];
                    }
                    getSize() {
                        let e1 = 4 + 2 * this.transf.length;
                        256 & this.flags && (e1 += 2 + this.instructions.length);
                        e1 += 2;
                        2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (e1 += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (e1 += 2);
                        return e1;
                    }
                    write(e1, t) {
                        const a = e1;
                        2 & this.flags ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= 1) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= 1);
                        t.setUint16(e1, this.flags);
                        t.setUint16(e1 + 2, this.glyphIndex);
                        e1 += 4;
                        if (1 & this.flags) {
                            if (2 & this.flags) {
                                t.setInt16(e1, this.argument1);
                                t.setInt16(e1 + 2, this.argument2);
                            } else {
                                t.setUint16(e1, this.argument1);
                                t.setUint16(e1 + 2, this.argument2);
                            }
                            e1 += 4;
                        } else {
                            t.setUint8(e1, this.argument1);
                            t.setUint8(e1 + 1, this.argument2);
                            e1 += 2;
                        }
                        if (256 & this.flags) {
                            t.setUint16(e1, this.instructions.length);
                            e1 += 2;
                            if (this.instructions.length) {
                                new Uint8Array(t.buffer, 0, t.buffer.byteLength).set(this.instructions, e1);
                                e1 += this.instructions.length;
                            }
                        }
                        return e1 - a;
                    }
                    scale(e1, t) {}
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.OpenTypeFileBuilder = void 0;
                var r = a(3), n = a(2);
                function writeInt16(e1, t, a) {
                    e1[t] = a >> 8 & 255;
                    e1[t + 1] = 255 & a;
                }
                function writeInt32(e1, t, a) {
                    e1[t] = a >> 24 & 255;
                    e1[t + 1] = a >> 16 & 255;
                    e1[t + 2] = a >> 8 & 255;
                    e1[t + 3] = 255 & a;
                }
                function writeData(e1, t, a) {
                    if (a instanceof Uint8Array) e1.set(a, t);
                    else if ("string" == typeof a) for(let r = 0, n = a.length; r < n; r++)e1[t++] = 255 & a.charCodeAt(r);
                    else for (const r of a)e1[t++] = 255 & r;
                }
                class OpenTypeFileBuilder {
                    constructor(e1){
                        this.sfnt = e1;
                        this.tables = Object.create(null);
                    }
                    static getSearchParams(e1, t) {
                        let a = 1, r = 0;
                        for(; (a ^ e1) > a;){
                            a <<= 1;
                            r++;
                        }
                        const n = a * t;
                        return {
                            range: n,
                            entry: r,
                            rangeShift: t * e1 - n
                        };
                    }
                    toArray() {
                        let e1 = this.sfnt;
                        const t = this.tables, a = Object.keys(t);
                        a.sort();
                        const i = a.length;
                        let s, o, c, l, h, u = 12 + 16 * i;
                        const d = [
                            u
                        ];
                        for(s = 0; s < i; s++){
                            l = t[a[s]];
                            u += (l.length + 3 & -4) >>> 0;
                            d.push(u);
                        }
                        const f = new Uint8Array(u);
                        for(s = 0; s < i; s++){
                            l = t[a[s]];
                            writeData(f, d[s], l);
                        }
                        "true" === e1 && (e1 = (0, n.string32)(65536));
                        f[0] = 255 & e1.charCodeAt(0);
                        f[1] = 255 & e1.charCodeAt(1);
                        f[2] = 255 & e1.charCodeAt(2);
                        f[3] = 255 & e1.charCodeAt(3);
                        writeInt16(f, 4, i);
                        const g = OpenTypeFileBuilder.getSearchParams(i, 16);
                        writeInt16(f, 6, g.range);
                        writeInt16(f, 8, g.entry);
                        writeInt16(f, 10, g.rangeShift);
                        u = 12;
                        for(s = 0; s < i; s++){
                            h = a[s];
                            f[u] = 255 & h.charCodeAt(0);
                            f[u + 1] = 255 & h.charCodeAt(1);
                            f[u + 2] = 255 & h.charCodeAt(2);
                            f[u + 3] = 255 & h.charCodeAt(3);
                            let e1 = 0;
                            for(o = d[s], c = d[s + 1]; o < c; o += 4)e1 = e1 + (0, r.readUint32)(f, o) >>> 0;
                            writeInt32(f, u + 4, e1);
                            writeInt32(f, u + 8, d[s]);
                            writeInt32(f, u + 12, t[h].length);
                            u += 16;
                        }
                        return f;
                    }
                    addTable(e1, t) {
                        if (e1 in this.tables) throw new Error("Table " + e1 + " already exists");
                        this.tables[e1] = t;
                    }
                }
                t.OpenTypeFileBuilder = OpenTypeFileBuilder;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Type1Font = void 0;
                var r = a(35), n = a(2), i = a(38), s = a(3), o = a(8), c = a(49);
                function findBlock(e1, t, a) {
                    const r = e1.length, n = t.length, i = r - n;
                    let o = a, c = !1;
                    for(; o < i;){
                        let a = 0;
                        for(; a < n && e1[o + a] === t[a];)a++;
                        if (a >= n) {
                            o += a;
                            for(; o < r && (0, s.isWhiteSpace)(e1[o]);)o++;
                            c = !0;
                            break;
                        }
                        o++;
                    }
                    return {
                        found: c,
                        length: o
                    };
                }
                t.Type1Font = class Type1Font {
                    constructor(e1, t, a){
                        let r = a.length1, s = a.length2, l = t.peekBytes(6);
                        const h = 128 === l[0] && 1 === l[1];
                        if (h) {
                            t.skip(6);
                            r = l[5] << 24 | l[4] << 16 | l[3] << 8 | l[2];
                        }
                        const u = function getHeaderBlock(e1, t) {
                            const a = [
                                101,
                                101,
                                120,
                                101,
                                99
                            ], r = e1.pos;
                            let i, s, c, l;
                            try {
                                i = e1.getBytes(t);
                                s = i.length;
                            } catch  {}
                            if (s === t) {
                                c = findBlock(i, a, t - 2 * a.length);
                                if (c.found && c.length === t) return {
                                    stream: new o.Stream(i),
                                    length: t
                                };
                            }
                            (0, n.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
                            e1.pos = r;
                            for(;;){
                                c = findBlock(e1.peekBytes(2048), a, 0);
                                if (0 === c.length) break;
                                e1.pos += c.length;
                                if (c.found) {
                                    l = e1.pos - r;
                                    break;
                                }
                            }
                            e1.pos = r;
                            if (l) return {
                                stream: new o.Stream(e1.getBytes(l)),
                                length: l
                            };
                            (0, n.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
                            return {
                                stream: new o.Stream(e1.getBytes(t)),
                                length: t
                            };
                        }(t, r);
                        new c.Type1Parser(u.stream, !1, i.SEAC_ANALYSIS_ENABLED).extractFontHeader(a);
                        if (h) {
                            l = t.getBytes(6);
                            s = l[5] << 24 | l[4] << 16 | l[3] << 8 | l[2];
                        }
                        const d = function getEexecBlock(e1, t) {
                            const a = e1.getBytes();
                            if (0 === a.length) throw new n.FormatError("getEexecBlock - no font program found.");
                            return {
                                stream: new o.Stream(a),
                                length: a.length
                            };
                        }(t), f = new c.Type1Parser(d.stream, !0, i.SEAC_ANALYSIS_ENABLED).extractFontProgram(a);
                        for(const e1 in f.properties)a[e1] = f.properties[e1];
                        const g = f.charstrings, p = this.getType2Charstrings(g), m = this.getType2Subrs(f.subrs);
                        this.charstrings = g;
                        this.data = this.wrap(e1, p, this.charstrings, m, a);
                        this.seacs = this.getSeacs(f.charstrings);
                    }
                    get numGlyphs() {
                        return this.charstrings.length + 1;
                    }
                    getCharset() {
                        const e1 = [
                            ".notdef"
                        ];
                        for (const { glyphName: t } of this.charstrings)e1.push(t);
                        return e1;
                    }
                    getGlyphMapping(e1) {
                        const t = this.charstrings;
                        if (e1.composite) {
                            const a = Object.create(null);
                            for(let r = 0, n = t.length; r < n; r++)a[e1.cMap.charCodeOf(r)] = r + 1;
                            return a;
                        }
                        const a = [
                            ".notdef"
                        ];
                        let r, n;
                        for(n = 0; n < t.length; n++)a.push(t[n].glyphName);
                        const s = e1.builtInEncoding;
                        if (s) {
                            r = Object.create(null);
                            for(const e1 in s){
                                n = a.indexOf(s[e1]);
                                n >= 0 && (r[e1] = n);
                            }
                        }
                        return (0, i.type1FontGlyphMapping)(e1, r, a);
                    }
                    hasGlyphId(e1) {
                        if (e1 < 0 || e1 >= this.numGlyphs) return !1;
                        if (0 === e1) return !0;
                        return this.charstrings[e1 - 1].charstring.length > 0;
                    }
                    getSeacs(e1) {
                        const t = [];
                        for(let a = 0, r = e1.length; a < r; a++){
                            const r = e1[a];
                            r.seac && (t[a + 1] = r.seac);
                        }
                        return t;
                    }
                    getType2Charstrings(e1) {
                        const t = [];
                        for (const a of e1)t.push(a.charstring);
                        return t;
                    }
                    getType2Subrs(e1) {
                        let t = 0;
                        const a = e1.length;
                        t = a < 1133 ? 107 : a < 33769 ? 1131 : 32768;
                        const r = [];
                        let n;
                        for(n = 0; n < t; n++)r.push([
                            11
                        ]);
                        for(n = 0; n < a; n++)r.push(e1[n]);
                        return r;
                    }
                    wrap(e1, t, a, n, i) {
                        const s = new r.CFF;
                        s.header = new r.CFFHeader(1, 0, 4, 4);
                        s.names = [
                            e1
                        ];
                        const o = new r.CFFTopDict;
                        o.setByName("version", 391);
                        o.setByName("Notice", 392);
                        o.setByName("FullName", 393);
                        o.setByName("FamilyName", 394);
                        o.setByName("Weight", 395);
                        o.setByName("Encoding", null);
                        o.setByName("FontMatrix", i.fontMatrix);
                        o.setByName("FontBBox", i.bbox);
                        o.setByName("charset", null);
                        o.setByName("CharStrings", null);
                        o.setByName("Private", null);
                        s.topDict = o;
                        const c = new r.CFFStrings;
                        c.add("Version 0.11");
                        c.add("See original notice");
                        c.add(e1);
                        c.add(e1);
                        c.add("Medium");
                        s.strings = c;
                        s.globalSubrIndex = new r.CFFIndex;
                        const l = t.length, h = [
                            ".notdef"
                        ];
                        let u, d;
                        for(u = 0; u < l; u++){
                            const e1 = a[u].glyphName;
                            -1 === r.CFFStandardStrings.indexOf(e1) && c.add(e1);
                            h.push(e1);
                        }
                        s.charset = new r.CFFCharset(!1, 0, h);
                        const f = new r.CFFIndex;
                        f.add([
                            139,
                            14
                        ]);
                        for(u = 0; u < l; u++)f.add(t[u]);
                        s.charStrings = f;
                        const g = new r.CFFPrivateDict;
                        g.setByName("Subrs", null);
                        const p = [
                            "BlueValues",
                            "OtherBlues",
                            "FamilyBlues",
                            "FamilyOtherBlues",
                            "StemSnapH",
                            "StemSnapV",
                            "BlueShift",
                            "BlueFuzz",
                            "BlueScale",
                            "LanguageGroup",
                            "ExpansionFactor",
                            "ForceBold",
                            "StdHW",
                            "StdVW"
                        ];
                        for(u = 0, d = p.length; u < d; u++){
                            const e1 = p[u];
                            if (!(e1 in i.privateData)) continue;
                            const t = i.privateData[e1];
                            if (Array.isArray(t)) for(let e1 = t.length - 1; e1 > 0; e1--)t[e1] -= t[e1 - 1];
                            g.setByName(e1, t);
                        }
                        s.topDict.privateDict = g;
                        const m = new r.CFFIndex;
                        for(u = 0, d = n.length; u < d; u++)m.add(n[u]);
                        g.subrsIndex = m;
                        return new r.CFFCompiler(s).compile();
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Type1Parser = void 0;
                var r = a(37), n = a(3), i = a(8), s = a(2);
                const o = [
                    4
                ], c = [
                    5
                ], l = [
                    6
                ], h = [
                    7
                ], u = [
                    8
                ], d = [
                    12,
                    35
                ], f = [
                    14
                ], g = [
                    21
                ], p = [
                    22
                ], m = [
                    30
                ], b = [
                    31
                ];
                class Type1CharString {
                    constructor(){
                        this.width = 0;
                        this.lsb = 0;
                        this.flexing = !1;
                        this.output = [];
                        this.stack = [];
                    }
                    convert(e1, t, a) {
                        const r = e1.length;
                        let n, i, y, w = !1;
                        for(let S = 0; S < r; S++){
                            let r = e1[S];
                            if (r < 32) {
                                12 === r && (r = (r << 8) + e1[++S]);
                                switch(r){
                                    case 1:
                                    case 3:
                                    case 9:
                                    case 3072:
                                    case 3073:
                                    case 3074:
                                    case 3105:
                                        this.stack = [];
                                        break;
                                    case 4:
                                        if (this.flexing) {
                                            if (this.stack.length < 1) {
                                                w = !0;
                                                break;
                                            }
                                            const e1 = this.stack.pop();
                                            this.stack.push(0, e1);
                                            break;
                                        }
                                        w = this.executeCommand(1, o);
                                        break;
                                    case 5:
                                        w = this.executeCommand(2, c);
                                        break;
                                    case 6:
                                        w = this.executeCommand(1, l);
                                        break;
                                    case 7:
                                        w = this.executeCommand(1, h);
                                        break;
                                    case 8:
                                        w = this.executeCommand(6, u);
                                        break;
                                    case 10:
                                        if (this.stack.length < 1) {
                                            w = !0;
                                            break;
                                        }
                                        y = this.stack.pop();
                                        if (!t[y]) {
                                            w = !0;
                                            break;
                                        }
                                        w = this.convert(t[y], t, a);
                                        break;
                                    case 11:
                                        return w;
                                    case 13:
                                        if (this.stack.length < 2) {
                                            w = !0;
                                            break;
                                        }
                                        n = this.stack.pop();
                                        i = this.stack.pop();
                                        this.lsb = i;
                                        this.width = n;
                                        this.stack.push(n, i);
                                        w = this.executeCommand(2, p);
                                        break;
                                    case 14:
                                        this.output.push(f[0]);
                                        break;
                                    case 21:
                                        if (this.flexing) break;
                                        w = this.executeCommand(2, g);
                                        break;
                                    case 22:
                                        if (this.flexing) {
                                            this.stack.push(0);
                                            break;
                                        }
                                        w = this.executeCommand(1, p);
                                        break;
                                    case 30:
                                        w = this.executeCommand(4, m);
                                        break;
                                    case 31:
                                        w = this.executeCommand(4, b);
                                        break;
                                    case 3078:
                                        if (a) {
                                            const e1 = this.stack.at(-5);
                                            this.seac = this.stack.splice(-4, 4);
                                            this.seac[0] += this.lsb - e1;
                                            w = this.executeCommand(0, f);
                                        } else w = this.executeCommand(4, f);
                                        break;
                                    case 3079:
                                        if (this.stack.length < 4) {
                                            w = !0;
                                            break;
                                        }
                                        this.stack.pop();
                                        n = this.stack.pop();
                                        const e2 = this.stack.pop();
                                        i = this.stack.pop();
                                        this.lsb = i;
                                        this.width = n;
                                        this.stack.push(n, i, e2);
                                        w = this.executeCommand(3, g);
                                        break;
                                    case 3084:
                                        if (this.stack.length < 2) {
                                            w = !0;
                                            break;
                                        }
                                        const S1 = this.stack.pop(), x = this.stack.pop();
                                        this.stack.push(x / S1);
                                        break;
                                    case 3088:
                                        if (this.stack.length < 2) {
                                            w = !0;
                                            break;
                                        }
                                        y = this.stack.pop();
                                        const C = this.stack.pop();
                                        if (0 === y && 3 === C) {
                                            const e1 = this.stack.splice(-17, 17);
                                            this.stack.push(e1[2] + e1[0], e1[3] + e1[1], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14]);
                                            w = this.executeCommand(13, d, !0);
                                            this.flexing = !1;
                                            this.stack.push(e1[15], e1[16]);
                                        } else 1 === y && 0 === C && (this.flexing = !0);
                                        break;
                                    case 3089:
                                        break;
                                    default:
                                        (0, s.warn)('Unknown type 1 charstring command of "' + r + '"');
                                }
                                if (w) break;
                            } else {
                                r <= 246 ? r -= 139 : r = r <= 250 ? 256 * (r - 247) + e1[++S] + 108 : r <= 254 ? -256 * (r - 251) - e1[++S] - 108 : (255 & e1[++S]) << 24 | (255 & e1[++S]) << 16 | (255 & e1[++S]) << 8 | (255 & e1[++S]) << 0;
                                this.stack.push(r);
                            }
                        }
                        return w;
                    }
                    executeCommand(e1, t, a) {
                        const r = this.stack.length;
                        if (e1 > r) return !0;
                        const n = r - e1;
                        for(let e1 = n; e1 < r; e1++){
                            let t = this.stack[e1];
                            if (Number.isInteger(t)) this.output.push(28, t >> 8 & 255, 255 & t);
                            else {
                                t = 65536 * t | 0;
                                this.output.push(255, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t);
                            }
                        }
                        this.output.push(...t);
                        a ? this.stack.splice(n, e1) : this.stack.length = 0;
                        return !1;
                    }
                }
                function isHexDigit(e1) {
                    return e1 >= 48 && e1 <= 57 || e1 >= 65 && e1 <= 70 || e1 >= 97 && e1 <= 102;
                }
                function decrypt(e1, t, a) {
                    if (a >= e1.length) return new Uint8Array(0);
                    let r, n, i = 0 | t;
                    for(r = 0; r < a; r++)i = 52845 * (e1[r] + i) + 22719 & 65535;
                    const s = e1.length - a, o = new Uint8Array(s);
                    for(r = a, n = 0; n < s; r++, n++){
                        const t = e1[r];
                        o[n] = t ^ i >> 8;
                        i = 52845 * (t + i) + 22719 & 65535;
                    }
                    return o;
                }
                function isSpecial(e1) {
                    return 47 === e1 || 91 === e1 || 93 === e1 || 123 === e1 || 125 === e1 || 40 === e1 || 41 === e1;
                }
                t.Type1Parser = class Type1Parser {
                    constructor(e1, t, a){
                        if (t) {
                            const t = e1.getBytes(), a = !((isHexDigit(t[0]) || (0, n.isWhiteSpace)(t[0])) && isHexDigit(t[1]) && isHexDigit(t[2]) && isHexDigit(t[3]) && isHexDigit(t[4]) && isHexDigit(t[5]) && isHexDigit(t[6]) && isHexDigit(t[7]));
                            e1 = new i.Stream(a ? decrypt(t, 55665, 4) : function decryptAscii(e1, t, a) {
                                let r = 0 | t;
                                const n = e1.length, i = new Uint8Array(n >>> 1);
                                let s, o;
                                for(s = 0, o = 0; s < n; s++){
                                    const t = e1[s];
                                    if (!isHexDigit(t)) continue;
                                    s++;
                                    let a;
                                    for(; s < n && !isHexDigit(a = e1[s]);)s++;
                                    if (s < n) {
                                        const e1 = parseInt(String.fromCharCode(t, a), 16);
                                        i[o++] = e1 ^ r >> 8;
                                        r = 52845 * (e1 + r) + 22719 & 65535;
                                    }
                                }
                                return i.slice(a, o);
                            }(t, 55665, 4));
                        }
                        this.seacAnalysisEnabled = !!a;
                        this.stream = e1;
                        this.nextChar();
                    }
                    readNumberArray() {
                        this.getToken();
                        const e1 = [];
                        for(;;){
                            const t = this.getToken();
                            if (null === t || "]" === t || "}" === t) break;
                            e1.push(parseFloat(t || 0));
                        }
                        return e1;
                    }
                    readNumber() {
                        const e1 = this.getToken();
                        return parseFloat(e1 || 0);
                    }
                    readInt() {
                        const e1 = this.getToken();
                        return 0 | parseInt(e1 || 0, 10);
                    }
                    readBoolean() {
                        return "true" === this.getToken() ? 1 : 0;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    prevChar() {
                        this.stream.skip(-2);
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let e1 = !1, t = this.currentChar;
                        for(;;){
                            if (-1 === t) return null;
                            if (e1) 10 !== t && 13 !== t || (e1 = !1);
                            else if (37 === t) e1 = !0;
                            else if (!(0, n.isWhiteSpace)(t)) break;
                            t = this.nextChar();
                        }
                        if (isSpecial(t)) {
                            this.nextChar();
                            return String.fromCharCode(t);
                        }
                        let a = "";
                        do {
                            a += String.fromCharCode(t);
                            t = this.nextChar();
                        }while (t >= 0 && !(0, n.isWhiteSpace)(t) && !isSpecial(t));
                        return a;
                    }
                    readCharStrings(e1, t) {
                        return -1 === t ? e1 : decrypt(e1, 4330, t);
                    }
                    extractFontProgram(e1) {
                        const t = this.stream, a = [], r = [], n = Object.create(null);
                        n.lenIV = 4;
                        const i = {
                            subrs: [],
                            charstrings: [],
                            properties: {
                                privateData: n
                            }
                        };
                        let s, o, c, l;
                        for(; null !== (s = this.getToken());)if ("/" === s) {
                            s = this.getToken();
                            switch(s){
                                case "CharStrings":
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    for(;;){
                                        s = this.getToken();
                                        if (null === s || "end" === s) break;
                                        if ("/" !== s) continue;
                                        const e1 = this.getToken();
                                        o = this.readInt();
                                        this.getToken();
                                        c = o > 0 ? t.getBytes(o) : new Uint8Array(0);
                                        l = i.properties.privateData.lenIV;
                                        const a = this.readCharStrings(c, l);
                                        this.nextChar();
                                        s = this.getToken();
                                        "noaccess" === s ? this.getToken() : "/" === s && this.prevChar();
                                        r.push({
                                            glyph: e1,
                                            encoded: a
                                        });
                                    }
                                    break;
                                case "Subrs":
                                    this.readInt();
                                    this.getToken();
                                    for(; "dup" === this.getToken();){
                                        const e1 = this.readInt();
                                        o = this.readInt();
                                        this.getToken();
                                        c = o > 0 ? t.getBytes(o) : new Uint8Array(0);
                                        l = i.properties.privateData.lenIV;
                                        const r = this.readCharStrings(c, l);
                                        this.nextChar();
                                        s = this.getToken();
                                        "noaccess" === s && this.getToken();
                                        a[e1] = r;
                                    }
                                    break;
                                case "BlueValues":
                                case "OtherBlues":
                                case "FamilyBlues":
                                case "FamilyOtherBlues":
                                    const e1 = this.readNumberArray();
                                    e1.length > 0 && e1.length;
                                    break;
                                case "StemSnapH":
                                case "StemSnapV":
                                    i.properties.privateData[s] = this.readNumberArray();
                                    break;
                                case "StdHW":
                                case "StdVW":
                                    i.properties.privateData[s] = this.readNumberArray()[0];
                                    break;
                                case "BlueShift":
                                case "lenIV":
                                case "BlueFuzz":
                                case "BlueScale":
                                case "LanguageGroup":
                                    i.properties.privateData[s] = this.readNumber();
                                    break;
                                case "ExpansionFactor":
                                    i.properties.privateData[s] = this.readNumber() || .06;
                                    break;
                                case "ForceBold":
                                    i.properties.privateData[s] = this.readBoolean();
                            }
                        }
                        for (const { encoded: t, glyph: n } of r){
                            const r = new Type1CharString, s = r.convert(t, a, this.seacAnalysisEnabled);
                            let o = r.output;
                            s && (o = [
                                14
                            ]);
                            const c = {
                                glyphName: n,
                                charstring: o,
                                width: r.width,
                                lsb: r.lsb,
                                seac: r.seac
                            };
                            ".notdef" === n ? i.charstrings.unshift(c) : i.charstrings.push(c);
                            if (e1.builtInEncoding) {
                                const t = e1.builtInEncoding.indexOf(n);
                                t > -1 && void 0 === e1.widths[t] && t >= e1.firstChar && t <= e1.lastChar && (e1.widths[t] = r.width);
                            }
                        }
                        return i;
                    }
                    extractFontHeader(e1) {
                        let t;
                        for(; null !== (t = this.getToken());)if ("/" === t) {
                            t = this.getToken();
                            switch(t){
                                case "FontMatrix":
                                    const a = this.readNumberArray();
                                    e1.fontMatrix = a;
                                    break;
                                case "Encoding":
                                    const n = this.getToken();
                                    let i;
                                    if (/^\d+$/.test(n)) {
                                        i = [];
                                        const e1 = 0 | parseInt(n, 10);
                                        this.getToken();
                                        for(let a = 0; a < e1; a++){
                                            t = this.getToken();
                                            for(; "dup" !== t && "def" !== t;){
                                                t = this.getToken();
                                                if (null === t) return;
                                            }
                                            if ("def" === t) break;
                                            const e1 = this.readInt();
                                            this.getToken();
                                            const a = this.getToken();
                                            i[e1] = a;
                                            this.getToken();
                                        }
                                    } else i = (0, r.getEncoding)(n);
                                    e1.builtInEncoding = i;
                                    break;
                                case "FontBBox":
                                    const s = this.readNumberArray();
                                    e1.ascent = Math.max(s[3], s[1]);
                                    e1.descent = Math.min(s[1], s[3]);
                                    e1.ascentScaled = !0;
                            }
                        }
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Pattern = void 0;
                t.clearPatternCaches = function clearPatternCaches() {
                    f = Object.create(null);
                };
                t.getTilingPatternIR = function getTilingPatternIR(e1, t, a) {
                    const n = t.getArray("Matrix"), i = r.Util.normalizeRect(t.getArray("BBox")), s = t.get("XStep"), o = t.get("YStep"), c = t.get("PaintType"), l = t.get("TilingType");
                    if (i[2] - i[0] == 0 || i[3] - i[1] == 0) throw new r.FormatError(`Invalid getTilingPatternIR /BBox array: [${i}].`);
                    return [
                        "TilingPattern",
                        a,
                        e1,
                        n,
                        i,
                        s,
                        o,
                        c,
                        l
                    ];
                };
                var r = a(2), n = a(5), i = a(12), s = a(3);
                const o = 2, c = 3, l = 4, h = 5, u = 6, d = 7;
                t.Pattern = class Pattern {
                    constructor(){
                        (0, r.unreachable)("Cannot initialize Pattern.");
                    }
                    static parseShading(e1, t, a, i, f) {
                        const g = e1 instanceof n.BaseStream ? e1.dict : e1, p = g.get("ShadingType");
                        try {
                            switch(p){
                                case o:
                                case c:
                                    return new RadialAxialShading(g, t, a, i, f);
                                case l:
                                case h:
                                case u:
                                case d:
                                    return new MeshShading(e1, t, a, i, f);
                                default:
                                    throw new r.FormatError("Unsupported ShadingType: " + p);
                            }
                        } catch (e1) {
                            if (e1 instanceof s.MissingDataException) throw e1;
                            (0, r.warn)(e1);
                            return new DummyShading;
                        }
                    }
                };
                class BaseShading {
                    static SMALL_NUMBER = 1e-6;
                    constructor(){
                        this.constructor === BaseShading && (0, r.unreachable)("Cannot initialize BaseShading.");
                    }
                    getIR() {
                        (0, r.unreachable)("Abstract method `getIR` called.");
                    }
                }
                class RadialAxialShading extends BaseShading {
                    constructor(e1, t, a, n, s){
                        super();
                        this.coordsArr = e1.getArray("Coords");
                        this.shadingType = e1.get("ShadingType");
                        const o = i.ColorSpace.parse({
                            cs: e1.getRaw("CS") || e1.getRaw("ColorSpace"),
                            xref: t,
                            resources: a,
                            pdfFunctionFactory: n,
                            localColorSpaceCache: s
                        }), l = e1.getArray("BBox");
                        this.bbox = Array.isArray(l) && 4 === l.length ? r.Util.normalizeRect(l) : null;
                        let h = 0, u = 1;
                        if (e1.has("Domain")) {
                            const t = e1.getArray("Domain");
                            h = t[0];
                            u = t[1];
                        }
                        let d = !1, f = !1;
                        if (e1.has("Extend")) {
                            const t = e1.getArray("Extend");
                            d = t[0];
                            f = t[1];
                        }
                        if (!(this.shadingType !== c || d && f)) {
                            const [e1, t, a, n, i, s] = this.coordsArr, o = Math.hypot(e1 - n, t - i);
                            a <= s + o && s <= a + o && (0, r.warn)("Unsupported radial gradient.");
                        }
                        this.extendStart = d;
                        this.extendEnd = f;
                        const g = e1.getRaw("Function"), p = n.createFromArray(g), m = (u - h) / 840, b = this.colorStops = [];
                        if (h >= u || m <= 0) {
                            (0, r.info)("Bad shading domain.");
                            return;
                        }
                        const y = new Float32Array(o.numComps), w = new Float32Array(1);
                        let S, x = 0;
                        w[0] = h;
                        p(w, 0, y, 0);
                        let C = o.getRgb(y, 0);
                        const k = r.Util.makeHexColor(C[0], C[1], C[2]);
                        b.push([
                            0,
                            k
                        ]);
                        let v = 1;
                        w[0] = h + m;
                        p(w, 0, y, 0);
                        let F = o.getRgb(y, 0), O = F[0] - C[0] + 1, T = F[1] - C[1] + 1, M = F[2] - C[2] + 1, D = F[0] - C[0] - 1, E = F[1] - C[1] - 1, N = F[2] - C[2] - 1;
                        for(let e1 = 2; e1 < 840; e1++){
                            w[0] = h + e1 * m;
                            p(w, 0, y, 0);
                            S = o.getRgb(y, 0);
                            const t = e1 - x;
                            O = Math.min(O, (S[0] - C[0] + 1) / t);
                            T = Math.min(T, (S[1] - C[1] + 1) / t);
                            M = Math.min(M, (S[2] - C[2] + 1) / t);
                            D = Math.max(D, (S[0] - C[0] - 1) / t);
                            E = Math.max(E, (S[1] - C[1] - 1) / t);
                            N = Math.max(N, (S[2] - C[2] - 1) / t);
                            if (!(D <= O && E <= T && N <= M)) {
                                const e1 = r.Util.makeHexColor(F[0], F[1], F[2]);
                                b.push([
                                    v / 840,
                                    e1
                                ]);
                                O = S[0] - F[0] + 1;
                                T = S[1] - F[1] + 1;
                                M = S[2] - F[2] + 1;
                                D = S[0] - F[0] - 1;
                                E = S[1] - F[1] - 1;
                                N = S[2] - F[2] - 1;
                                x = v;
                                C = F;
                            }
                            v = e1;
                            F = S;
                        }
                        const R = r.Util.makeHexColor(F[0], F[1], F[2]);
                        b.push([
                            1,
                            R
                        ]);
                        let L = "transparent";
                        if (e1.has("Background")) {
                            S = o.getRgb(e1.get("Background"), 0);
                            L = r.Util.makeHexColor(S[0], S[1], S[2]);
                        }
                        if (!d) {
                            b.unshift([
                                0,
                                L
                            ]);
                            b[1][0] += BaseShading.SMALL_NUMBER;
                        }
                        if (!f) {
                            b.at(-1)[0] -= BaseShading.SMALL_NUMBER;
                            b.push([
                                1,
                                L
                            ]);
                        }
                        this.colorStops = b;
                    }
                    getIR() {
                        const e1 = this.coordsArr, t = this.shadingType;
                        let a, n, i, s, l;
                        if (t === o) {
                            n = [
                                e1[0],
                                e1[1]
                            ];
                            i = [
                                e1[2],
                                e1[3]
                            ];
                            s = null;
                            l = null;
                            a = "axial";
                        } else if (t === c) {
                            n = [
                                e1[0],
                                e1[1]
                            ];
                            i = [
                                e1[3],
                                e1[4]
                            ];
                            s = e1[2];
                            l = e1[5];
                            a = "radial";
                        } else (0, r.unreachable)(`getPattern type unknown: ${t}`);
                        return [
                            "RadialAxial",
                            a,
                            this.bbox,
                            this.colorStops,
                            n,
                            i,
                            s,
                            l
                        ];
                    }
                }
                class MeshStreamReader {
                    constructor(e1, t){
                        this.stream = e1;
                        this.context = t;
                        this.buffer = 0;
                        this.bufferLength = 0;
                        const a = t.numComps;
                        this.tmpCompsBuf = new Float32Array(a);
                        const r = t.colorSpace.numComps;
                        this.tmpCsCompsBuf = t.colorFn ? new Float32Array(r) : this.tmpCompsBuf;
                    }
                    get hasData() {
                        if (this.stream.end) return this.stream.pos < this.stream.end;
                        if (this.bufferLength > 0) return !0;
                        const e1 = this.stream.getByte();
                        if (e1 < 0) return !1;
                        this.buffer = e1;
                        this.bufferLength = 8;
                        return !0;
                    }
                    readBits(e1) {
                        let t = this.buffer, a = this.bufferLength;
                        if (32 === e1) {
                            if (0 === a) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                            t = t << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                            const e1 = this.stream.getByte();
                            this.buffer = e1 & (1 << a) - 1;
                            return (t << 8 - a | (255 & e1) >> a) >>> 0;
                        }
                        if (8 === e1 && 0 === a) return this.stream.getByte();
                        for(; a < e1;){
                            t = t << 8 | this.stream.getByte();
                            a += 8;
                        }
                        a -= e1;
                        this.bufferLength = a;
                        this.buffer = t & (1 << a) - 1;
                        return t >> a;
                    }
                    align() {
                        this.buffer = 0;
                        this.bufferLength = 0;
                    }
                    readFlag() {
                        return this.readBits(this.context.bitsPerFlag);
                    }
                    readCoordinate() {
                        const e1 = this.context.bitsPerCoordinate, t = this.readBits(e1), a = this.readBits(e1), r = this.context.decode, n = e1 < 32 ? 1 / ((1 << e1) - 1) : 2.3283064365386963e-10;
                        return [
                            t * n * (r[1] - r[0]) + r[0],
                            a * n * (r[3] - r[2]) + r[2]
                        ];
                    }
                    readComponents() {
                        const e1 = this.context.numComps, t = this.context.bitsPerComponent, a = t < 32 ? 1 / ((1 << t) - 1) : 2.3283064365386963e-10, r = this.context.decode, n = this.tmpCompsBuf;
                        for(let i = 0, s = 4; i < e1; i++, s += 2){
                            const e1 = this.readBits(t);
                            n[i] = e1 * a * (r[s + 1] - r[s]) + r[s];
                        }
                        const i = this.tmpCsCompsBuf;
                        this.context.colorFn && this.context.colorFn(n, 0, i, 0);
                        return this.context.colorSpace.getRgb(i, 0);
                    }
                }
                let f = Object.create(null);
                function getB(e1) {
                    return f[e1] ||= function buildB(e1) {
                        const t = [];
                        for(let a = 0; a <= e1; a++){
                            const r = a / e1, n = 1 - r;
                            t.push(new Float32Array([
                                n ** 3,
                                3 * r * n ** 2,
                                3 * r ** 2 * n,
                                r ** 3
                            ]));
                        }
                        return t;
                    }(e1);
                }
                class MeshShading extends BaseShading {
                    static MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
                    static MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
                    static TRIANGLE_DENSITY = 20;
                    constructor(e1, t, a, s, o){
                        super();
                        if (!(e1 instanceof n.BaseStream)) throw new r.FormatError("Mesh data is not a stream");
                        const c = e1.dict;
                        this.shadingType = c.get("ShadingType");
                        const f = c.getArray("BBox");
                        this.bbox = Array.isArray(f) && 4 === f.length ? r.Util.normalizeRect(f) : null;
                        const g = i.ColorSpace.parse({
                            cs: c.getRaw("CS") || c.getRaw("ColorSpace"),
                            xref: t,
                            resources: a,
                            pdfFunctionFactory: s,
                            localColorSpaceCache: o
                        });
                        this.background = c.has("Background") ? g.getRgb(c.get("Background"), 0) : null;
                        const p = c.getRaw("Function"), m = p ? s.createFromArray(p) : null;
                        this.coords = [];
                        this.colors = [];
                        this.figures = [];
                        const b = {
                            bitsPerCoordinate: c.get("BitsPerCoordinate"),
                            bitsPerComponent: c.get("BitsPerComponent"),
                            bitsPerFlag: c.get("BitsPerFlag"),
                            decode: c.getArray("Decode"),
                            colorFn: m,
                            colorSpace: g,
                            numComps: m ? 1 : g.numComps
                        }, y = new MeshStreamReader(e1, b);
                        let w = !1;
                        switch(this.shadingType){
                            case l:
                                this._decodeType4Shading(y);
                                break;
                            case h:
                                const e2 = 0 | c.get("VerticesPerRow");
                                if (e2 < 2) throw new r.FormatError("Invalid VerticesPerRow");
                                this._decodeType5Shading(y, e2);
                                break;
                            case u:
                                this._decodeType6Shading(y);
                                w = !0;
                                break;
                            case d:
                                this._decodeType7Shading(y);
                                w = !0;
                                break;
                            default:
                                (0, r.unreachable)("Unsupported mesh type.");
                        }
                        if (w) {
                            this._updateBounds();
                            for(let e1 = 0, t = this.figures.length; e1 < t; e1++)this._buildFigureFromPatch(e1);
                        }
                        this._updateBounds();
                        this._packData();
                    }
                    _decodeType4Shading(e1) {
                        const t = this.coords, a = this.colors, n = [], i = [];
                        let s = 0;
                        for(; e1.hasData;){
                            const o = e1.readFlag(), c = e1.readCoordinate(), l = e1.readComponents();
                            if (0 === s) {
                                if (!(0 <= o && o <= 2)) throw new r.FormatError("Unknown type4 flag");
                                switch(o){
                                    case 0:
                                        s = 3;
                                        break;
                                    case 1:
                                        i.push(i.at(-2), i.at(-1));
                                        s = 1;
                                        break;
                                    case 2:
                                        i.push(i.at(-3), i.at(-1));
                                        s = 1;
                                }
                                n.push(o);
                            }
                            i.push(t.length);
                            t.push(c);
                            a.push(l);
                            s--;
                            e1.align();
                        }
                        this.figures.push({
                            type: "triangles",
                            coords: new Int32Array(i),
                            colors: new Int32Array(i)
                        });
                    }
                    _decodeType5Shading(e1, t) {
                        const a = this.coords, r = this.colors, n = [];
                        for(; e1.hasData;){
                            const t = e1.readCoordinate(), i = e1.readComponents();
                            n.push(a.length);
                            a.push(t);
                            r.push(i);
                        }
                        this.figures.push({
                            type: "lattice",
                            coords: new Int32Array(n),
                            colors: new Int32Array(n),
                            verticesPerRow: t
                        });
                    }
                    _decodeType6Shading(e1) {
                        const t = this.coords, a = this.colors, n = new Int32Array(16), i = new Int32Array(4);
                        for(; e1.hasData;){
                            const s = e1.readFlag();
                            if (!(0 <= s && s <= 3)) throw new r.FormatError("Unknown type6 flag");
                            const o = t.length;
                            for(let a = 0, r = 0 !== s ? 8 : 12; a < r; a++)t.push(e1.readCoordinate());
                            const c = a.length;
                            for(let t = 0, r = 0 !== s ? 2 : 4; t < r; t++)a.push(e1.readComponents());
                            let l, h, u, d;
                            switch(s){
                                case 0:
                                    n[12] = o + 3;
                                    n[13] = o + 4;
                                    n[14] = o + 5;
                                    n[15] = o + 6;
                                    n[8] = o + 2;
                                    n[11] = o + 7;
                                    n[4] = o + 1;
                                    n[7] = o + 8;
                                    n[0] = o;
                                    n[1] = o + 11;
                                    n[2] = o + 10;
                                    n[3] = o + 9;
                                    i[2] = c + 1;
                                    i[3] = c + 2;
                                    i[0] = c;
                                    i[1] = c + 3;
                                    break;
                                case 1:
                                    l = n[12];
                                    h = n[13];
                                    u = n[14];
                                    d = n[15];
                                    n[12] = d;
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = u;
                                    n[11] = o + 3;
                                    n[4] = h;
                                    n[7] = o + 4;
                                    n[0] = l;
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    l = i[2];
                                    h = i[3];
                                    i[2] = h;
                                    i[3] = c;
                                    i[0] = l;
                                    i[1] = c + 1;
                                    break;
                                case 2:
                                    l = n[15];
                                    h = n[11];
                                    n[12] = n[3];
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = n[7];
                                    n[11] = o + 3;
                                    n[4] = h;
                                    n[7] = o + 4;
                                    n[0] = l;
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    l = i[3];
                                    i[2] = i[1];
                                    i[3] = c;
                                    i[0] = l;
                                    i[1] = c + 1;
                                    break;
                                case 3:
                                    n[12] = n[0];
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = n[1];
                                    n[11] = o + 3;
                                    n[4] = n[2];
                                    n[7] = o + 4;
                                    n[0] = n[3];
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    i[2] = i[0];
                                    i[3] = c;
                                    i[0] = i[1];
                                    i[1] = c + 1;
                            }
                            n[5] = t.length;
                            t.push([
                                (-4 * t[n[0]][0] - t[n[15]][0] + 6 * (t[n[4]][0] + t[n[1]][0]) - 2 * (t[n[12]][0] + t[n[3]][0]) + 3 * (t[n[13]][0] + t[n[7]][0])) / 9,
                                (-4 * t[n[0]][1] - t[n[15]][1] + 6 * (t[n[4]][1] + t[n[1]][1]) - 2 * (t[n[12]][1] + t[n[3]][1]) + 3 * (t[n[13]][1] + t[n[7]][1])) / 9
                            ]);
                            n[6] = t.length;
                            t.push([
                                (-4 * t[n[3]][0] - t[n[12]][0] + 6 * (t[n[2]][0] + t[n[7]][0]) - 2 * (t[n[0]][0] + t[n[15]][0]) + 3 * (t[n[4]][0] + t[n[14]][0])) / 9,
                                (-4 * t[n[3]][1] - t[n[12]][1] + 6 * (t[n[2]][1] + t[n[7]][1]) - 2 * (t[n[0]][1] + t[n[15]][1]) + 3 * (t[n[4]][1] + t[n[14]][1])) / 9
                            ]);
                            n[9] = t.length;
                            t.push([
                                (-4 * t[n[12]][0] - t[n[3]][0] + 6 * (t[n[8]][0] + t[n[13]][0]) - 2 * (t[n[0]][0] + t[n[15]][0]) + 3 * (t[n[11]][0] + t[n[1]][0])) / 9,
                                (-4 * t[n[12]][1] - t[n[3]][1] + 6 * (t[n[8]][1] + t[n[13]][1]) - 2 * (t[n[0]][1] + t[n[15]][1]) + 3 * (t[n[11]][1] + t[n[1]][1])) / 9
                            ]);
                            n[10] = t.length;
                            t.push([
                                (-4 * t[n[15]][0] - t[n[0]][0] + 6 * (t[n[11]][0] + t[n[14]][0]) - 2 * (t[n[12]][0] + t[n[3]][0]) + 3 * (t[n[2]][0] + t[n[8]][0])) / 9,
                                (-4 * t[n[15]][1] - t[n[0]][1] + 6 * (t[n[11]][1] + t[n[14]][1]) - 2 * (t[n[12]][1] + t[n[3]][1]) + 3 * (t[n[2]][1] + t[n[8]][1])) / 9
                            ]);
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(n),
                                colors: new Int32Array(i)
                            });
                        }
                    }
                    _decodeType7Shading(e1) {
                        const t = this.coords, a = this.colors, n = new Int32Array(16), i = new Int32Array(4);
                        for(; e1.hasData;){
                            const s = e1.readFlag();
                            if (!(0 <= s && s <= 3)) throw new r.FormatError("Unknown type7 flag");
                            const o = t.length;
                            for(let a = 0, r = 0 !== s ? 12 : 16; a < r; a++)t.push(e1.readCoordinate());
                            const c = a.length;
                            for(let t = 0, r = 0 !== s ? 2 : 4; t < r; t++)a.push(e1.readComponents());
                            let l, h, u, d;
                            switch(s){
                                case 0:
                                    n[12] = o + 3;
                                    n[13] = o + 4;
                                    n[14] = o + 5;
                                    n[15] = o + 6;
                                    n[8] = o + 2;
                                    n[9] = o + 13;
                                    n[10] = o + 14;
                                    n[11] = o + 7;
                                    n[4] = o + 1;
                                    n[5] = o + 12;
                                    n[6] = o + 15;
                                    n[7] = o + 8;
                                    n[0] = o;
                                    n[1] = o + 11;
                                    n[2] = o + 10;
                                    n[3] = o + 9;
                                    i[2] = c + 1;
                                    i[3] = c + 2;
                                    i[0] = c;
                                    i[1] = c + 3;
                                    break;
                                case 1:
                                    l = n[12];
                                    h = n[13];
                                    u = n[14];
                                    d = n[15];
                                    n[12] = d;
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = u;
                                    n[9] = o + 9;
                                    n[10] = o + 10;
                                    n[11] = o + 3;
                                    n[4] = h;
                                    n[5] = o + 8;
                                    n[6] = o + 11;
                                    n[7] = o + 4;
                                    n[0] = l;
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    l = i[2];
                                    h = i[3];
                                    i[2] = h;
                                    i[3] = c;
                                    i[0] = l;
                                    i[1] = c + 1;
                                    break;
                                case 2:
                                    l = n[15];
                                    h = n[11];
                                    n[12] = n[3];
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = n[7];
                                    n[9] = o + 9;
                                    n[10] = o + 10;
                                    n[11] = o + 3;
                                    n[4] = h;
                                    n[5] = o + 8;
                                    n[6] = o + 11;
                                    n[7] = o + 4;
                                    n[0] = l;
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    l = i[3];
                                    i[2] = i[1];
                                    i[3] = c;
                                    i[0] = l;
                                    i[1] = c + 1;
                                    break;
                                case 3:
                                    n[12] = n[0];
                                    n[13] = o + 0;
                                    n[14] = o + 1;
                                    n[15] = o + 2;
                                    n[8] = n[1];
                                    n[9] = o + 9;
                                    n[10] = o + 10;
                                    n[11] = o + 3;
                                    n[4] = n[2];
                                    n[5] = o + 8;
                                    n[6] = o + 11;
                                    n[7] = o + 4;
                                    n[0] = n[3];
                                    n[1] = o + 7;
                                    n[2] = o + 6;
                                    n[3] = o + 5;
                                    i[2] = i[0];
                                    i[3] = c;
                                    i[0] = i[1];
                                    i[1] = c + 1;
                            }
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(n),
                                colors: new Int32Array(i)
                            });
                        }
                    }
                    _buildFigureFromPatch(e1) {
                        const t = this.figures[e1];
                        (0, r.assert)("patch" === t.type, "Unexpected patch mesh figure");
                        const a = this.coords, n = this.colors, i = t.coords, s = t.colors, o = Math.min(a[i[0]][0], a[i[3]][0], a[i[12]][0], a[i[15]][0]), c = Math.min(a[i[0]][1], a[i[3]][1], a[i[12]][1], a[i[15]][1]), l = Math.max(a[i[0]][0], a[i[3]][0], a[i[12]][0], a[i[15]][0]), h = Math.max(a[i[0]][1], a[i[3]][1], a[i[12]][1], a[i[15]][1]);
                        let u = Math.ceil((l - o) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                        u = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, u));
                        let d = Math.ceil((h - c) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                        d = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, d));
                        const f = u + 1, g = new Int32Array((d + 1) * f), p = new Int32Array((d + 1) * f);
                        let m = 0;
                        const b = new Uint8Array(3), y = new Uint8Array(3), w = n[s[0]], S = n[s[1]], x = n[s[2]], C = n[s[3]], k = getB(d), v = getB(u);
                        for(let e1 = 0; e1 <= d; e1++){
                            b[0] = (w[0] * (d - e1) + x[0] * e1) / d | 0;
                            b[1] = (w[1] * (d - e1) + x[1] * e1) / d | 0;
                            b[2] = (w[2] * (d - e1) + x[2] * e1) / d | 0;
                            y[0] = (S[0] * (d - e1) + C[0] * e1) / d | 0;
                            y[1] = (S[1] * (d - e1) + C[1] * e1) / d | 0;
                            y[2] = (S[2] * (d - e1) + C[2] * e1) / d | 0;
                            for(let t = 0; t <= u; t++, m++){
                                if (!(0 !== e1 && e1 !== d || 0 !== t && t !== u)) continue;
                                let r = 0, s = 0, o = 0;
                                for(let n = 0; n <= 3; n++)for(let c = 0; c <= 3; c++, o++){
                                    const l = k[e1][n] * v[t][c];
                                    r += a[i[o]][0] * l;
                                    s += a[i[o]][1] * l;
                                }
                                g[m] = a.length;
                                a.push([
                                    r,
                                    s
                                ]);
                                p[m] = n.length;
                                const c = new Uint8Array(3);
                                c[0] = (b[0] * (u - t) + y[0] * t) / u | 0;
                                c[1] = (b[1] * (u - t) + y[1] * t) / u | 0;
                                c[2] = (b[2] * (u - t) + y[2] * t) / u | 0;
                                n.push(c);
                            }
                        }
                        g[0] = i[0];
                        p[0] = s[0];
                        g[u] = i[3];
                        p[u] = s[1];
                        g[f * d] = i[12];
                        p[f * d] = s[2];
                        g[f * d + u] = i[15];
                        p[f * d + u] = s[3];
                        this.figures[e1] = {
                            type: "lattice",
                            coords: g,
                            colors: p,
                            verticesPerRow: f
                        };
                    }
                    _updateBounds() {
                        let e1 = this.coords[0][0], t = this.coords[0][1], a = e1, r = t;
                        for(let n = 1, i = this.coords.length; n < i; n++){
                            const i = this.coords[n][0], s = this.coords[n][1];
                            e1 = e1 > i ? i : e1;
                            t = t > s ? s : t;
                            a = a < i ? i : a;
                            r = r < s ? s : r;
                        }
                        this.bounds = [
                            e1,
                            t,
                            a,
                            r
                        ];
                    }
                    _packData() {
                        let e1, t, a, r;
                        const n = this.coords, i = new Float32Array(2 * n.length);
                        for(e1 = 0, a = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1];
                            i[a++] = t[0];
                            i[a++] = t[1];
                        }
                        this.coords = i;
                        const s = this.colors, o = new Uint8Array(3 * s.length);
                        for(e1 = 0, a = 0, t = s.length; e1 < t; e1++){
                            const t = s[e1];
                            o[a++] = t[0];
                            o[a++] = t[1];
                            o[a++] = t[2];
                        }
                        this.colors = o;
                        const c = this.figures;
                        for(e1 = 0, t = c.length; e1 < t; e1++){
                            const t = c[e1], n = t.coords, i = t.colors;
                            for(a = 0, r = n.length; a < r; a++){
                                n[a] *= 2;
                                i[a] *= 3;
                            }
                        }
                    }
                    getIR() {
                        return [
                            "Mesh",
                            this.shadingType,
                            this.coords,
                            this.colors,
                            this.figures,
                            this.bounds,
                            this.bbox,
                            this.background
                        ];
                    }
                }
                class DummyShading extends BaseShading {
                    getIR() {
                        return [
                            "Dummy"
                        ];
                    }
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.getXfaFontDict = function getXfaFontDict(e1) {
                    const t = function getXfaFontWidths(e1) {
                        const t = getXfaFontName(e1);
                        if (!t) return null;
                        const { baseWidths: a, baseMapping: r, factors: n } = t, i = n ? a.map((e1, t)=>e1 * n[t]) : a;
                        let s, o = -2;
                        const c = [];
                        for (const [e1, t] of r.map((e1, t)=>[
                                e1,
                                t
                            ]).sort(([e1], [t])=>e1 - t))if (-1 !== e1) {
                            if (e1 === o + 1) {
                                s.push(i[t]);
                                o += 1;
                            } else {
                                o = e1;
                                s = [
                                    i[t]
                                ];
                                c.push(e1, s);
                            }
                        }
                        return c;
                    }(e1), a = new n.Dict(null);
                    a.set("BaseFont", n.Name.get(e1));
                    a.set("Type", n.Name.get("Font"));
                    a.set("Subtype", n.Name.get("CIDFontType2"));
                    a.set("Encoding", n.Name.get("Identity-H"));
                    a.set("CIDToGIDMap", n.Name.get("Identity"));
                    a.set("W", t);
                    a.set("FirstChar", t[0]);
                    a.set("LastChar", t.at(-2) + t.at(-1).length - 1);
                    const r = new n.Dict(null);
                    a.set("FontDescriptor", r);
                    const i = new n.Dict(null);
                    i.set("Ordering", "Identity");
                    i.set("Registry", "Adobe");
                    i.set("Supplement", 0);
                    a.set("CIDSystemInfo", i);
                    return a;
                };
                t.getXfaFontName = getXfaFontName;
                var r = a(52), n = a(4), i = a(53), s = a(54), o = a(55), c = a(56), l = a(3), h = a(38);
                const u = (0, l.getLookupTableFactory)(function(e1) {
                    e1["MyriadPro-Regular"] = e1["PdfJS-Fallback-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: o.MyriadProRegularFactors,
                        baseWidths: s.LiberationSansRegularWidths,
                        baseMapping: s.LiberationSansRegularMapping,
                        metrics: o.MyriadProRegularMetrics
                    };
                    e1["MyriadPro-Bold"] = e1["PdfJS-Fallback-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: o.MyriadProBoldFactors,
                        baseWidths: s.LiberationSansBoldWidths,
                        baseMapping: s.LiberationSansBoldMapping,
                        metrics: o.MyriadProBoldMetrics
                    };
                    e1["MyriadPro-It"] = e1["MyriadPro-Italic"] = e1["PdfJS-Fallback-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: o.MyriadProItalicFactors,
                        baseWidths: s.LiberationSansItalicWidths,
                        baseMapping: s.LiberationSansItalicMapping,
                        metrics: o.MyriadProItalicMetrics
                    };
                    e1["MyriadPro-BoldIt"] = e1["MyriadPro-BoldItalic"] = e1["PdfJS-Fallback-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: o.MyriadProBoldItalicFactors,
                        baseWidths: s.LiberationSansBoldItalicWidths,
                        baseMapping: s.LiberationSansBoldItalicMapping,
                        metrics: o.MyriadProBoldItalicMetrics
                    };
                    e1.ArialMT = e1.Arial = e1["Arial-Regular"] = {
                        name: "LiberationSans-Regular",
                        baseWidths: s.LiberationSansRegularWidths,
                        baseMapping: s.LiberationSansRegularMapping
                    };
                    e1["Arial-BoldMT"] = e1["Arial-Bold"] = {
                        name: "LiberationSans-Bold",
                        baseWidths: s.LiberationSansBoldWidths,
                        baseMapping: s.LiberationSansBoldMapping
                    };
                    e1["Arial-ItalicMT"] = e1["Arial-Italic"] = {
                        name: "LiberationSans-Italic",
                        baseWidths: s.LiberationSansItalicWidths,
                        baseMapping: s.LiberationSansItalicMapping
                    };
                    e1["Arial-BoldItalicMT"] = e1["Arial-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        baseWidths: s.LiberationSansBoldItalicWidths,
                        baseMapping: s.LiberationSansBoldItalicMapping
                    };
                    e1["Calibri-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: r.CalibriRegularFactors,
                        baseWidths: s.LiberationSansRegularWidths,
                        baseMapping: s.LiberationSansRegularMapping,
                        metrics: r.CalibriRegularMetrics
                    };
                    e1["Calibri-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: r.CalibriBoldFactors,
                        baseWidths: s.LiberationSansBoldWidths,
                        baseMapping: s.LiberationSansBoldMapping,
                        metrics: r.CalibriBoldMetrics
                    };
                    e1["Calibri-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: r.CalibriItalicFactors,
                        baseWidths: s.LiberationSansItalicWidths,
                        baseMapping: s.LiberationSansItalicMapping,
                        metrics: r.CalibriItalicMetrics
                    };
                    e1["Calibri-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: r.CalibriBoldItalicFactors,
                        baseWidths: s.LiberationSansBoldItalicWidths,
                        baseMapping: s.LiberationSansBoldItalicMapping,
                        metrics: r.CalibriBoldItalicMetrics
                    };
                    e1["Segoeui-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: c.SegoeuiRegularFactors,
                        baseWidths: s.LiberationSansRegularWidths,
                        baseMapping: s.LiberationSansRegularMapping,
                        metrics: c.SegoeuiRegularMetrics
                    };
                    e1["Segoeui-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: c.SegoeuiBoldFactors,
                        baseWidths: s.LiberationSansBoldWidths,
                        baseMapping: s.LiberationSansBoldMapping,
                        metrics: c.SegoeuiBoldMetrics
                    };
                    e1["Segoeui-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: c.SegoeuiItalicFactors,
                        baseWidths: s.LiberationSansItalicWidths,
                        baseMapping: s.LiberationSansItalicMapping,
                        metrics: c.SegoeuiItalicMetrics
                    };
                    e1["Segoeui-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: c.SegoeuiBoldItalicFactors,
                        baseWidths: s.LiberationSansBoldItalicWidths,
                        baseMapping: s.LiberationSansBoldItalicMapping,
                        metrics: c.SegoeuiBoldItalicMetrics
                    };
                    e1["Helvetica-Regular"] = e1.Helvetica = {
                        name: "LiberationSans-Regular",
                        factors: i.HelveticaRegularFactors,
                        baseWidths: s.LiberationSansRegularWidths,
                        baseMapping: s.LiberationSansRegularMapping,
                        metrics: i.HelveticaRegularMetrics
                    };
                    e1["Helvetica-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: i.HelveticaBoldFactors,
                        baseWidths: s.LiberationSansBoldWidths,
                        baseMapping: s.LiberationSansBoldMapping,
                        metrics: i.HelveticaBoldMetrics
                    };
                    e1["Helvetica-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: i.HelveticaItalicFactors,
                        baseWidths: s.LiberationSansItalicWidths,
                        baseMapping: s.LiberationSansItalicMapping,
                        metrics: i.HelveticaItalicMetrics
                    };
                    e1["Helvetica-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: i.HelveticaBoldItalicFactors,
                        baseWidths: s.LiberationSansBoldItalicWidths,
                        baseMapping: s.LiberationSansBoldItalicMapping,
                        metrics: i.HelveticaBoldItalicMetrics
                    };
                });
                function getXfaFontName(e1) {
                    const t = (0, h.normalizeFontName)(e1);
                    return u()[t];
                }
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.CalibriRegularMetrics = t.CalibriRegularFactors = t.CalibriItalicMetrics = t.CalibriItalicFactors = t.CalibriBoldMetrics = t.CalibriBoldItalicMetrics = t.CalibriBoldItalicFactors = t.CalibriBoldFactors = void 0;
                t.CalibriBoldFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    .97801,
                    .92482,
                    .89552,
                    .91133,
                    .81988,
                    .97566,
                    .98152,
                    .93548,
                    .93548,
                    1.2798,
                    .85284,
                    .92794,
                    1,
                    .96134,
                    1.54657,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .82845,
                    .82845,
                    .85284,
                    .85284,
                    .85284,
                    .75859,
                    .92138,
                    .83908,
                    .7762,
                    .73293,
                    .87289,
                    .73133,
                    .7514,
                    .81921,
                    .87356,
                    .95958,
                    .59526,
                    .75727,
                    .69225,
                    1.04924,
                    .9121,
                    .86943,
                    .79795,
                    .88198,
                    .77958,
                    .70864,
                    .81055,
                    .90399,
                    .88653,
                    .96017,
                    .82577,
                    .77892,
                    .78257,
                    .97507,
                    1.54657,
                    .97507,
                    .85284,
                    .89552,
                    .90176,
                    .88762,
                    .8785,
                    .75241,
                    .8785,
                    .90518,
                    .95015,
                    .77618,
                    .8785,
                    .88401,
                    .91916,
                    .86304,
                    .88401,
                    .91488,
                    .8785,
                    .8801,
                    .8785,
                    .8785,
                    .91343,
                    .7173,
                    1.04106,
                    .8785,
                    .85075,
                    .95794,
                    .82616,
                    .85162,
                    .79492,
                    .88331,
                    1.69808,
                    .88331,
                    .85284,
                    .97801,
                    .89552,
                    .91133,
                    .89552,
                    .91133,
                    1.7801,
                    .89552,
                    1.24487,
                    1.13254,
                    1.12401,
                    .96839,
                    .85284,
                    .68787,
                    .70645,
                    .85592,
                    .90747,
                    1.01466,
                    1.0088,
                    .90323,
                    1,
                    1.07463,
                    1,
                    .91056,
                    .75806,
                    1.19118,
                    .96839,
                    .78864,
                    .82845,
                    .84133,
                    .75859,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .77539,
                    .73293,
                    .73133,
                    .73133,
                    .73133,
                    .73133,
                    .95958,
                    .95958,
                    .95958,
                    .95958,
                    .88506,
                    .9121,
                    .86943,
                    .86943,
                    .86943,
                    .86943,
                    .86943,
                    .85284,
                    .87508,
                    .90399,
                    .90399,
                    .90399,
                    .90399,
                    .77892,
                    .79795,
                    .90807,
                    .88762,
                    .88762,
                    .88762,
                    .88762,
                    .88762,
                    .88762,
                    .8715,
                    .75241,
                    .90518,
                    .90518,
                    .90518,
                    .90518,
                    .88401,
                    .88401,
                    .88401,
                    .88401,
                    .8785,
                    .8785,
                    .8801,
                    .8801,
                    .8801,
                    .8801,
                    .8801,
                    .90747,
                    .89049,
                    .8785,
                    .8785,
                    .8785,
                    .8785,
                    .85162,
                    .8785,
                    .85162,
                    .83908,
                    .88762,
                    .83908,
                    .88762,
                    .83908,
                    .88762,
                    .73293,
                    .75241,
                    .73293,
                    .75241,
                    .73293,
                    .75241,
                    .73293,
                    .75241,
                    .87289,
                    .83016,
                    .88506,
                    .93125,
                    .73133,
                    .90518,
                    .73133,
                    .90518,
                    .73133,
                    .90518,
                    .73133,
                    .90518,
                    .73133,
                    .90518,
                    .81921,
                    .77618,
                    .81921,
                    .77618,
                    .81921,
                    .77618,
                    1,
                    1,
                    .87356,
                    .8785,
                    .91075,
                    .89608,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .76229,
                    .90167,
                    .59526,
                    .91916,
                    1,
                    1,
                    .86304,
                    .69225,
                    .88401,
                    1,
                    1,
                    .70424,
                    .79468,
                    .91926,
                    .88175,
                    .70823,
                    .94903,
                    .9121,
                    .8785,
                    1,
                    1,
                    .9121,
                    .8785,
                    .87802,
                    .88656,
                    .8785,
                    .86943,
                    .8801,
                    .86943,
                    .8801,
                    .86943,
                    .8801,
                    .87402,
                    .89291,
                    .77958,
                    .91343,
                    1,
                    1,
                    .77958,
                    .91343,
                    .70864,
                    .7173,
                    .70864,
                    .7173,
                    .70864,
                    .7173,
                    .70864,
                    .7173,
                    1,
                    1,
                    .81055,
                    .75841,
                    .81055,
                    1.06452,
                    .90399,
                    .8785,
                    .90399,
                    .8785,
                    .90399,
                    .8785,
                    .90399,
                    .8785,
                    .90399,
                    .8785,
                    .90399,
                    .8785,
                    .96017,
                    .95794,
                    .77892,
                    .85162,
                    .77892,
                    .78257,
                    .79492,
                    .78257,
                    .79492,
                    .78257,
                    .79492,
                    .9297,
                    .56892,
                    .83908,
                    .88762,
                    .77539,
                    .8715,
                    .87508,
                    .89049,
                    1,
                    1,
                    .81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    .70674,
                    .98387,
                    .94721,
                    1.33431,
                    1.45894,
                    .95161,
                    1.06303,
                    .83908,
                    .80352,
                    .57184,
                    .6965,
                    .56289,
                    .82001,
                    .56029,
                    .81235,
                    1.02988,
                    .83908,
                    .7762,
                    .68156,
                    .80367,
                    .73133,
                    .78257,
                    .87356,
                    .86943,
                    .95958,
                    .75727,
                    .89019,
                    1.04924,
                    .9121,
                    .7648,
                    .86943,
                    .87356,
                    .79795,
                    .78275,
                    .81055,
                    .77892,
                    .9762,
                    .82577,
                    .99819,
                    .84896,
                    .95958,
                    .77892,
                    .96108,
                    1.01407,
                    .89049,
                    1.02988,
                    .94211,
                    .96108,
                    .8936,
                    .84021,
                    .87842,
                    .96399,
                    .79109,
                    .89049,
                    1.00813,
                    1.02988,
                    .86077,
                    .87445,
                    .92099,
                    .84723,
                    .86513,
                    .8801,
                    .75638,
                    .85714,
                    .78216,
                    .79586,
                    .87965,
                    .94211,
                    .97747,
                    .78287,
                    .97926,
                    .84971,
                    1.02988,
                    .94211,
                    .8801,
                    .94211,
                    .84971,
                    .73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90264,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90518,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90548,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .96017,
                    .95794,
                    .96017,
                    .95794,
                    .96017,
                    .95794,
                    .77892,
                    .85162,
                    1,
                    1,
                    .89552,
                    .90527,
                    1,
                    .90363,
                    .92794,
                    .92794,
                    .92794,
                    .92794,
                    .87012,
                    .87012,
                    .87012,
                    .89552,
                    .89552,
                    1.42259,
                    .71143,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    .97171,
                    1.4956,
                    2.2807,
                    .93835,
                    .83406,
                    .91133,
                    .84107,
                    .91133,
                    1,
                    1,
                    1,
                    .72021,
                    1,
                    1.23108,
                    .83489,
                    .88525,
                    .88525,
                    .81499,
                    .90527,
                    1.81055,
                    .90527,
                    1.81055,
                    1.31006,
                    1.53711,
                    .94434,
                    1.08696,
                    1,
                    .95018,
                    .77192,
                    .85284,
                    .90747,
                    1.17534,
                    .69825,
                    .9716,
                    1.37077,
                    .90747,
                    .90747,
                    .85356,
                    .90747,
                    .90747,
                    1.44947,
                    .85284,
                    .8941,
                    .8941,
                    .70572,
                    .8,
                    .70572,
                    .70572,
                    .70572,
                    .70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99862,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    .91027,
                    1,
                    1,
                    1,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90727,
                    .90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.CalibriBoldMetrics = {
                    lineHeight: 1.2207,
                    lineGap: .2207
                };
                t.CalibriBoldItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    .97801,
                    .92482,
                    .89552,
                    .91133,
                    .81988,
                    .97566,
                    .98152,
                    .93548,
                    .93548,
                    1.2798,
                    .85284,
                    .92794,
                    1,
                    .96134,
                    1.56239,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .82845,
                    .82845,
                    .85284,
                    .85284,
                    .85284,
                    .75859,
                    .92138,
                    .83908,
                    .7762,
                    .71805,
                    .87289,
                    .73133,
                    .7514,
                    .81921,
                    .87356,
                    .95958,
                    .59526,
                    .75727,
                    .69225,
                    1.04924,
                    .90872,
                    .85938,
                    .79795,
                    .87068,
                    .77958,
                    .69766,
                    .81055,
                    .90399,
                    .88653,
                    .96068,
                    .82577,
                    .77892,
                    .78257,
                    .97507,
                    1.529,
                    .97507,
                    .85284,
                    .89552,
                    .90176,
                    .94908,
                    .86411,
                    .74012,
                    .86411,
                    .88323,
                    .95015,
                    .86411,
                    .86331,
                    .88401,
                    .91916,
                    .86304,
                    .88401,
                    .9039,
                    .86331,
                    .86331,
                    .86411,
                    .86411,
                    .90464,
                    .70852,
                    1.04106,
                    .86331,
                    .84372,
                    .95794,
                    .82616,
                    .84548,
                    .79492,
                    .88331,
                    1.69808,
                    .88331,
                    .85284,
                    .97801,
                    .89552,
                    .91133,
                    .89552,
                    .91133,
                    1.7801,
                    .89552,
                    1.24487,
                    1.13254,
                    1.19129,
                    .96839,
                    .85284,
                    .68787,
                    .70645,
                    .85592,
                    .90747,
                    1.01466,
                    1.0088,
                    .90323,
                    1,
                    1.07463,
                    1,
                    .91056,
                    .75806,
                    1.19118,
                    .96839,
                    .78864,
                    .82845,
                    .84133,
                    .75859,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .83908,
                    .77539,
                    .71805,
                    .73133,
                    .73133,
                    .73133,
                    .73133,
                    .95958,
                    .95958,
                    .95958,
                    .95958,
                    .88506,
                    .90872,
                    .85938,
                    .85938,
                    .85938,
                    .85938,
                    .85938,
                    .85284,
                    .87068,
                    .90399,
                    .90399,
                    .90399,
                    .90399,
                    .77892,
                    .79795,
                    .90807,
                    .94908,
                    .94908,
                    .94908,
                    .94908,
                    .94908,
                    .94908,
                    .85887,
                    .74012,
                    .88323,
                    .88323,
                    .88323,
                    .88323,
                    .88401,
                    .88401,
                    .88401,
                    .88401,
                    .8785,
                    .86331,
                    .86331,
                    .86331,
                    .86331,
                    .86331,
                    .86331,
                    .90747,
                    .89049,
                    .86331,
                    .86331,
                    .86331,
                    .86331,
                    .84548,
                    .86411,
                    .84548,
                    .83908,
                    .94908,
                    .83908,
                    .94908,
                    .83908,
                    .94908,
                    .71805,
                    .74012,
                    .71805,
                    .74012,
                    .71805,
                    .74012,
                    .71805,
                    .74012,
                    .87289,
                    .79538,
                    .88506,
                    .92726,
                    .73133,
                    .88323,
                    .73133,
                    .88323,
                    .73133,
                    .88323,
                    .73133,
                    .88323,
                    .73133,
                    .88323,
                    .81921,
                    .86411,
                    .81921,
                    .86411,
                    .81921,
                    .86411,
                    1,
                    1,
                    .87356,
                    .86331,
                    .91075,
                    .8777,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .95958,
                    .88401,
                    .76467,
                    .90167,
                    .59526,
                    .91916,
                    1,
                    1,
                    .86304,
                    .69225,
                    .88401,
                    1,
                    1,
                    .70424,
                    .77312,
                    .91926,
                    .88175,
                    .70823,
                    .94903,
                    .90872,
                    .86331,
                    1,
                    1,
                    .90872,
                    .86331,
                    .86906,
                    .88116,
                    .86331,
                    .85938,
                    .86331,
                    .85938,
                    .86331,
                    .85938,
                    .86331,
                    .87402,
                    .86549,
                    .77958,
                    .90464,
                    1,
                    1,
                    .77958,
                    .90464,
                    .69766,
                    .70852,
                    .69766,
                    .70852,
                    .69766,
                    .70852,
                    .69766,
                    .70852,
                    1,
                    1,
                    .81055,
                    .75841,
                    .81055,
                    1.06452,
                    .90399,
                    .86331,
                    .90399,
                    .86331,
                    .90399,
                    .86331,
                    .90399,
                    .86331,
                    .90399,
                    .86331,
                    .90399,
                    .86331,
                    .96068,
                    .95794,
                    .77892,
                    .84548,
                    .77892,
                    .78257,
                    .79492,
                    .78257,
                    .79492,
                    .78257,
                    .79492,
                    .9297,
                    .56892,
                    .83908,
                    .94908,
                    .77539,
                    .85887,
                    .87068,
                    .89049,
                    1,
                    1,
                    .81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    .70088,
                    .98387,
                    .94721,
                    1.33431,
                    1.45894,
                    .95161,
                    1.48387,
                    .83908,
                    .80352,
                    .57118,
                    .6965,
                    .56347,
                    .79179,
                    .55853,
                    .80346,
                    1.02988,
                    .83908,
                    .7762,
                    .67174,
                    .86036,
                    .73133,
                    .78257,
                    .87356,
                    .86441,
                    .95958,
                    .75727,
                    .89019,
                    1.04924,
                    .90872,
                    .74889,
                    .85938,
                    .87891,
                    .79795,
                    .7957,
                    .81055,
                    .77892,
                    .97447,
                    .82577,
                    .97466,
                    .87179,
                    .95958,
                    .77892,
                    .94252,
                    .95612,
                    .8753,
                    1.02988,
                    .92733,
                    .94252,
                    .87411,
                    .84021,
                    .8728,
                    .95612,
                    .74081,
                    .8753,
                    1.02189,
                    1.02988,
                    .84814,
                    .87445,
                    .91822,
                    .84723,
                    .85668,
                    .86331,
                    .81344,
                    .87581,
                    .76422,
                    .82046,
                    .96057,
                    .92733,
                    .99375,
                    .78022,
                    .95452,
                    .86015,
                    1.02988,
                    .92733,
                    .86331,
                    .92733,
                    .86015,
                    .73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90631,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .88323,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .85174,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .96068,
                    .95794,
                    .96068,
                    .95794,
                    .96068,
                    .95794,
                    .77892,
                    .84548,
                    1,
                    1,
                    .89552,
                    .90527,
                    1,
                    .90363,
                    .92794,
                    .92794,
                    .92794,
                    .89807,
                    .87012,
                    .87012,
                    .87012,
                    .89552,
                    .89552,
                    1.42259,
                    .71094,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    .97171,
                    1.4956,
                    2.2807,
                    .92972,
                    .83406,
                    .91133,
                    .83326,
                    .91133,
                    1,
                    1,
                    1,
                    .72021,
                    1,
                    1.23108,
                    .83489,
                    .88525,
                    .88525,
                    .81499,
                    .90616,
                    1.81055,
                    .90527,
                    1.81055,
                    1.3107,
                    1.53711,
                    .94434,
                    1.08696,
                    1,
                    .95018,
                    .77192,
                    .85284,
                    .90747,
                    1.17534,
                    .69825,
                    .9716,
                    1.37077,
                    .90747,
                    .90747,
                    .85356,
                    .90747,
                    .90747,
                    1.44947,
                    .85284,
                    .8941,
                    .8941,
                    .70572,
                    .8,
                    .70572,
                    .70572,
                    .70572,
                    .70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99862,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    .91027,
                    1,
                    1,
                    1,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90727,
                    .90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.CalibriBoldItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: .2207
                };
                t.CalibriItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    .89552,
                    .91133,
                    .80395,
                    1.02269,
                    1.15601,
                    .91056,
                    .91056,
                    1.2798,
                    .85284,
                    .89807,
                    1,
                    .90861,
                    1.39543,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .96309,
                    .96309,
                    .85284,
                    .85284,
                    .85284,
                    .83319,
                    .88071,
                    .8675,
                    .81552,
                    .72346,
                    .85193,
                    .73206,
                    .7522,
                    .81105,
                    .86275,
                    .90685,
                    .6377,
                    .77892,
                    .75593,
                    1.02638,
                    .89249,
                    .84118,
                    .77452,
                    .85374,
                    .75186,
                    .67789,
                    .79776,
                    .88844,
                    .85066,
                    .94309,
                    .77818,
                    .7306,
                    .76659,
                    1.10369,
                    1.38313,
                    1.10369,
                    1.06139,
                    .89552,
                    .8739,
                    .9245,
                    .9245,
                    .83203,
                    .9245,
                    .85865,
                    1.09842,
                    .9245,
                    .9245,
                    1.03297,
                    1.07692,
                    .90918,
                    1.03297,
                    .94959,
                    .9245,
                    .92274,
                    .9245,
                    .9245,
                    1.02933,
                    .77832,
                    1.20562,
                    .9245,
                    .8916,
                    .98986,
                    .86621,
                    .89453,
                    .79004,
                    .94152,
                    1.77256,
                    .94152,
                    .85284,
                    .97801,
                    .89552,
                    .91133,
                    .89552,
                    .91133,
                    1.91729,
                    .89552,
                    1.17889,
                    1.13254,
                    1.16359,
                    .92098,
                    .85284,
                    .68787,
                    .71353,
                    .84737,
                    .90747,
                    1.0088,
                    1.0044,
                    .87683,
                    1,
                    1.09091,
                    1,
                    .92229,
                    .739,
                    1.15642,
                    .92098,
                    .76288,
                    .80504,
                    .80972,
                    .75859,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .76318,
                    .72346,
                    .73206,
                    .73206,
                    .73206,
                    .73206,
                    .90685,
                    .90685,
                    .90685,
                    .90685,
                    .86477,
                    .89249,
                    .84118,
                    .84118,
                    .84118,
                    .84118,
                    .84118,
                    .85284,
                    .84557,
                    .88844,
                    .88844,
                    .88844,
                    .88844,
                    .7306,
                    .77452,
                    .86331,
                    .9245,
                    .9245,
                    .9245,
                    .9245,
                    .9245,
                    .9245,
                    .84843,
                    .83203,
                    .85865,
                    .85865,
                    .85865,
                    .85865,
                    .82601,
                    .82601,
                    .82601,
                    .82601,
                    .94469,
                    .9245,
                    .92274,
                    .92274,
                    .92274,
                    .92274,
                    .92274,
                    .90747,
                    .86651,
                    .9245,
                    .9245,
                    .9245,
                    .9245,
                    .89453,
                    .9245,
                    .89453,
                    .8675,
                    .9245,
                    .8675,
                    .9245,
                    .8675,
                    .9245,
                    .72346,
                    .83203,
                    .72346,
                    .83203,
                    .72346,
                    .83203,
                    .72346,
                    .83203,
                    .85193,
                    .8875,
                    .86477,
                    .99034,
                    .73206,
                    .85865,
                    .73206,
                    .85865,
                    .73206,
                    .85865,
                    .73206,
                    .85865,
                    .73206,
                    .85865,
                    .81105,
                    .9245,
                    .81105,
                    .9245,
                    .81105,
                    .9245,
                    1,
                    1,
                    .86275,
                    .9245,
                    .90872,
                    .93591,
                    .90685,
                    .82601,
                    .90685,
                    .82601,
                    .90685,
                    .82601,
                    .90685,
                    1.03297,
                    .90685,
                    .82601,
                    .77896,
                    1.05611,
                    .6377,
                    1.07692,
                    1,
                    1,
                    .90918,
                    .75593,
                    1.03297,
                    1,
                    1,
                    .76032,
                    .9375,
                    .98156,
                    .93407,
                    .77261,
                    1.11429,
                    .89249,
                    .9245,
                    1,
                    1,
                    .89249,
                    .9245,
                    .92534,
                    .86698,
                    .9245,
                    .84118,
                    .92274,
                    .84118,
                    .92274,
                    .84118,
                    .92274,
                    .8667,
                    .86291,
                    .75186,
                    1.02933,
                    1,
                    1,
                    .75186,
                    1.02933,
                    .67789,
                    .77832,
                    .67789,
                    .77832,
                    .67789,
                    .77832,
                    .67789,
                    .77832,
                    1,
                    1,
                    .79776,
                    .97655,
                    .79776,
                    1.23023,
                    .88844,
                    .9245,
                    .88844,
                    .9245,
                    .88844,
                    .9245,
                    .88844,
                    .9245,
                    .88844,
                    .9245,
                    .88844,
                    .9245,
                    .94309,
                    .98986,
                    .7306,
                    .89453,
                    .7306,
                    .76659,
                    .79004,
                    .76659,
                    .79004,
                    .76659,
                    .79004,
                    1.09231,
                    .54873,
                    .8675,
                    .9245,
                    .76318,
                    .84843,
                    .84557,
                    .86651,
                    1,
                    1,
                    .79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    .67009,
                    .96334,
                    .93695,
                    1.35191,
                    1.40909,
                    .95161,
                    1.48387,
                    .8675,
                    .90861,
                    .6192,
                    .7363,
                    .64824,
                    .82411,
                    .56321,
                    .85696,
                    1.23516,
                    .8675,
                    .81552,
                    .7286,
                    .84134,
                    .73206,
                    .76659,
                    .86275,
                    .84369,
                    .90685,
                    .77892,
                    .85871,
                    1.02638,
                    .89249,
                    .75828,
                    .84118,
                    .85984,
                    .77452,
                    .76466,
                    .79776,
                    .7306,
                    .90782,
                    .77818,
                    .903,
                    .87291,
                    .90685,
                    .7306,
                    .99058,
                    1.03667,
                    .94635,
                    1.23516,
                    .9849,
                    .99058,
                    .92393,
                    .8916,
                    .942,
                    1.03667,
                    .75026,
                    .94635,
                    1.0297,
                    1.23516,
                    .90918,
                    .94048,
                    .98217,
                    .89746,
                    .84153,
                    .92274,
                    .82507,
                    .88832,
                    .84438,
                    .88178,
                    1.03525,
                    .9849,
                    1.00225,
                    .78086,
                    .97248,
                    .89404,
                    1.23516,
                    .9849,
                    .92274,
                    .9849,
                    .89404,
                    .73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .89693,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .85865,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .90933,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .94309,
                    .98986,
                    .94309,
                    .98986,
                    .94309,
                    .98986,
                    .7306,
                    .89453,
                    1,
                    1,
                    .89552,
                    .90527,
                    1,
                    .90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    .89552,
                    .89552,
                    1.42259,
                    .68994,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    .97858,
                    .82616,
                    .91133,
                    .83437,
                    .91133,
                    1,
                    1,
                    1,
                    .70508,
                    1,
                    1.23108,
                    .79801,
                    .84426,
                    .84426,
                    .774,
                    .90572,
                    1.81055,
                    .90749,
                    1.81055,
                    1.28809,
                    1.55469,
                    .94434,
                    1.07806,
                    1,
                    .97094,
                    .7589,
                    .85284,
                    .90747,
                    1.19658,
                    .69825,
                    .97622,
                    1.33512,
                    .90747,
                    .90747,
                    .85284,
                    .90747,
                    .90747,
                    1.44947,
                    .85284,
                    .8941,
                    .8941,
                    .70572,
                    .8,
                    .70572,
                    .70572,
                    .70572,
                    .70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99862,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    .91027,
                    1,
                    1,
                    1,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.CalibriItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: .2207
                };
                t.CalibriRegularFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    .89552,
                    .91133,
                    .80395,
                    1.02269,
                    1.15601,
                    .91056,
                    .91056,
                    1.2798,
                    .85284,
                    .89807,
                    1,
                    .90861,
                    1.39016,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .91133,
                    .96309,
                    .96309,
                    .85284,
                    .85284,
                    .85284,
                    .83319,
                    .88071,
                    .8675,
                    .81552,
                    .73834,
                    .85193,
                    .73206,
                    .7522,
                    .81105,
                    .86275,
                    .90685,
                    .6377,
                    .77892,
                    .75593,
                    1.02638,
                    .89385,
                    .85122,
                    .77452,
                    .86503,
                    .75186,
                    .68887,
                    .79776,
                    .88844,
                    .85066,
                    .94258,
                    .77818,
                    .7306,
                    .76659,
                    1.10369,
                    1.39016,
                    1.10369,
                    1.06139,
                    .89552,
                    .8739,
                    .86128,
                    .94469,
                    .8457,
                    .94469,
                    .89464,
                    1.09842,
                    .84636,
                    .94469,
                    1.03297,
                    1.07692,
                    .90918,
                    1.03297,
                    .95897,
                    .94469,
                    .9482,
                    .94469,
                    .94469,
                    1.04692,
                    .78223,
                    1.20562,
                    .94469,
                    .90332,
                    .98986,
                    .86621,
                    .90527,
                    .79004,
                    .94152,
                    1.77256,
                    .94152,
                    .85284,
                    .97801,
                    .89552,
                    .91133,
                    .89552,
                    .91133,
                    1.91729,
                    .89552,
                    1.17889,
                    1.13254,
                    1.08707,
                    .92098,
                    .85284,
                    .68787,
                    .71353,
                    .84737,
                    .90747,
                    1.0088,
                    1.0044,
                    .87683,
                    1,
                    1.09091,
                    1,
                    .92229,
                    .739,
                    1.15642,
                    .92098,
                    .76288,
                    .80504,
                    .80972,
                    .75859,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .8675,
                    .76318,
                    .73834,
                    .73206,
                    .73206,
                    .73206,
                    .73206,
                    .90685,
                    .90685,
                    .90685,
                    .90685,
                    .86477,
                    .89385,
                    .85122,
                    .85122,
                    .85122,
                    .85122,
                    .85122,
                    .85284,
                    .85311,
                    .88844,
                    .88844,
                    .88844,
                    .88844,
                    .7306,
                    .77452,
                    .86331,
                    .86128,
                    .86128,
                    .86128,
                    .86128,
                    .86128,
                    .86128,
                    .8693,
                    .8457,
                    .89464,
                    .89464,
                    .89464,
                    .89464,
                    .82601,
                    .82601,
                    .82601,
                    .82601,
                    .94469,
                    .94469,
                    .9482,
                    .9482,
                    .9482,
                    .9482,
                    .9482,
                    .90747,
                    .86651,
                    .94469,
                    .94469,
                    .94469,
                    .94469,
                    .90527,
                    .94469,
                    .90527,
                    .8675,
                    .86128,
                    .8675,
                    .86128,
                    .8675,
                    .86128,
                    .73834,
                    .8457,
                    .73834,
                    .8457,
                    .73834,
                    .8457,
                    .73834,
                    .8457,
                    .85193,
                    .92454,
                    .86477,
                    .9921,
                    .73206,
                    .89464,
                    .73206,
                    .89464,
                    .73206,
                    .89464,
                    .73206,
                    .89464,
                    .73206,
                    .89464,
                    .81105,
                    .84636,
                    .81105,
                    .84636,
                    .81105,
                    .84636,
                    1,
                    1,
                    .86275,
                    .94469,
                    .90872,
                    .95786,
                    .90685,
                    .82601,
                    .90685,
                    .82601,
                    .90685,
                    .82601,
                    .90685,
                    1.03297,
                    .90685,
                    .82601,
                    .77741,
                    1.05611,
                    .6377,
                    1.07692,
                    1,
                    1,
                    .90918,
                    .75593,
                    1.03297,
                    1,
                    1,
                    .76032,
                    .90452,
                    .98156,
                    1.11842,
                    .77261,
                    1.11429,
                    .89385,
                    .94469,
                    1,
                    1,
                    .89385,
                    .94469,
                    .95877,
                    .86901,
                    .94469,
                    .85122,
                    .9482,
                    .85122,
                    .9482,
                    .85122,
                    .9482,
                    .8667,
                    .90016,
                    .75186,
                    1.04692,
                    1,
                    1,
                    .75186,
                    1.04692,
                    .68887,
                    .78223,
                    .68887,
                    .78223,
                    .68887,
                    .78223,
                    .68887,
                    .78223,
                    1,
                    1,
                    .79776,
                    .92188,
                    .79776,
                    1.23023,
                    .88844,
                    .94469,
                    .88844,
                    .94469,
                    .88844,
                    .94469,
                    .88844,
                    .94469,
                    .88844,
                    .94469,
                    .88844,
                    .94469,
                    .94258,
                    .98986,
                    .7306,
                    .90527,
                    .7306,
                    .76659,
                    .79004,
                    .76659,
                    .79004,
                    .76659,
                    .79004,
                    1.09231,
                    .54873,
                    .8675,
                    .86128,
                    .76318,
                    .8693,
                    .85311,
                    .86651,
                    1,
                    1,
                    .79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    .67742,
                    .96334,
                    .93695,
                    1.35191,
                    1.40909,
                    .95161,
                    1.48387,
                    .86686,
                    .90861,
                    .62267,
                    .74359,
                    .65649,
                    .85498,
                    .56963,
                    .88254,
                    1.23516,
                    .8675,
                    .81552,
                    .75443,
                    .84503,
                    .73206,
                    .76659,
                    .86275,
                    .85122,
                    .90685,
                    .77892,
                    .85746,
                    1.02638,
                    .89385,
                    .75657,
                    .85122,
                    .86275,
                    .77452,
                    .74171,
                    .79776,
                    .7306,
                    .95165,
                    .77818,
                    .89772,
                    .88831,
                    .90685,
                    .7306,
                    .98142,
                    1.02191,
                    .96576,
                    1.23516,
                    .99018,
                    .98142,
                    .9236,
                    .89258,
                    .94035,
                    1.02191,
                    .78848,
                    .96576,
                    .9561,
                    1.23516,
                    .90918,
                    .92578,
                    .95424,
                    .89746,
                    .83969,
                    .9482,
                    .80113,
                    .89442,
                    .85208,
                    .86155,
                    .98022,
                    .99018,
                    1.00452,
                    .81209,
                    .99247,
                    .89181,
                    1.23516,
                    .99018,
                    .9482,
                    .99018,
                    .89181,
                    .73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .88844,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .89464,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .96766,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .94258,
                    .98986,
                    .94258,
                    .98986,
                    .94258,
                    .98986,
                    .7306,
                    .90527,
                    1,
                    1,
                    .89552,
                    .90527,
                    1,
                    .90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    .89552,
                    .89552,
                    1.42259,
                    .69043,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    .99331,
                    .82616,
                    .91133,
                    .84286,
                    .91133,
                    1,
                    1,
                    1,
                    .70508,
                    1,
                    1.23108,
                    .79801,
                    .84426,
                    .84426,
                    .774,
                    .90527,
                    1.81055,
                    .90527,
                    1.81055,
                    1.28809,
                    1.55469,
                    .94434,
                    1.07806,
                    1,
                    .97094,
                    .7589,
                    .85284,
                    .90747,
                    1.19658,
                    .69825,
                    .97622,
                    1.33512,
                    .90747,
                    .90747,
                    .85356,
                    .90747,
                    .90747,
                    1.44947,
                    .85284,
                    .8941,
                    .8941,
                    .70572,
                    .8,
                    .70572,
                    .70572,
                    .70572,
                    .70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99862,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    .91027,
                    1,
                    1,
                    1,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1.07185,
                    .99413,
                    .96334,
                    1.08065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.CalibriRegularMetrics = {
                    lineHeight: 1.2207,
                    lineGap: .2207
                };
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.HelveticaRegularMetrics = t.HelveticaRegularFactors = t.HelveticaItalicMetrics = t.HelveticaItalicFactors = t.HelveticaBoldMetrics = t.HelveticaBoldItalicMetrics = t.HelveticaBoldItalicFactors = t.HelveticaBoldFactors = void 0;
                t.HelveticaBoldFactors = [
                    .76116,
                    1,
                    1,
                    1.0006,
                    .99998,
                    .99974,
                    .99973,
                    .99973,
                    .99982,
                    .99977,
                    1.00087,
                    .99998,
                    .99998,
                    .99959,
                    1.00003,
                    1.0006,
                    .99998,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    .9999,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    .99977,
                    1.0006,
                    .99973,
                    .99977,
                    1.00026,
                    .99999,
                    .99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    .99977,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99998,
                    1.0006,
                    .99998,
                    1.00003,
                    .99973,
                    .99998,
                    .99973,
                    1.00026,
                    .99973,
                    1.00026,
                    .99973,
                    .99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    .99973,
                    1.0006,
                    .99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99959,
                    .99973,
                    .99998,
                    1.00026,
                    .99973,
                    1.00022,
                    .99973,
                    .99973,
                    1,
                    .99959,
                    1.00077,
                    .99959,
                    1.00003,
                    .99998,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.00077,
                    .99973,
                    .99998,
                    1.00025,
                    .99968,
                    .99973,
                    1.00003,
                    1.00025,
                    .60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    .99998,
                    1,
                    .99973,
                    1.0006,
                    .99998,
                    1,
                    .99936,
                    .99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99977,
                    .99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99982,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99973,
                    1.00026,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    1.03374,
                    .99977,
                    1.00026,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00042,
                    .99973,
                    .99973,
                    1.0006,
                    .99977,
                    .99973,
                    .99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.03828,
                    1.00026,
                    .99999,
                    1.00026,
                    1.0006,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .9993,
                    .9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    .99977,
                    .99959,
                    .99977,
                    .99959,
                    .99977,
                    .99959,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00026,
                    .99998,
                    1.00026,
                    .8121,
                    1.00026,
                    .99998,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    .99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    .99973,
                    .99977,
                    .99973,
                    1,
                    .99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    .99973,
                    1.00026,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    1.00034,
                    .99977,
                    1,
                    .99997,
                    1.00026,
                    1.00078,
                    1.00036,
                    .99973,
                    1.00013,
                    1.0006,
                    .99977,
                    .99977,
                    .99988,
                    .85148,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00022,
                    1.0006,
                    .99977,
                    1.00001,
                    .99999,
                    .99977,
                    1.00069,
                    1.00022,
                    .99977,
                    1.00001,
                    .99984,
                    1.00026,
                    1.00001,
                    1.00024,
                    1.00001,
                    .9999,
                    1,
                    1.0006,
                    1.00001,
                    1.00041,
                    .99962,
                    1.00026,
                    1.0006,
                    .99995,
                    1.00041,
                    .99942,
                    .99973,
                    .99927,
                    1.00082,
                    .99902,
                    1.00026,
                    1.00087,
                    1.0006,
                    1.00069,
                    .99973,
                    .99867,
                    .99973,
                    .9993,
                    1.00026,
                    1.00049,
                    1.00056,
                    1,
                    .99988,
                    .99935,
                    .99995,
                    .99954,
                    1.00055,
                    .99945,
                    1.00032,
                    1.0006,
                    .99995,
                    1.00026,
                    .99995,
                    1.00032,
                    1.00001,
                    1.00008,
                    .99971,
                    1.00019,
                    .9994,
                    1.00001,
                    1.0006,
                    1.00044,
                    .99973,
                    1.00023,
                    1.00047,
                    1,
                    .99942,
                    .99561,
                    .99989,
                    1.00035,
                    .99977,
                    1.00035,
                    .99977,
                    1.00019,
                    .99944,
                    1.00001,
                    1.00021,
                    .99926,
                    1.00035,
                    1.00035,
                    .99942,
                    1.00048,
                    .99999,
                    .99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    .99977,
                    1.00026,
                    .99989,
                    1.00057,
                    1.00001,
                    .99936,
                    1.00052,
                    1.00012,
                    .99996,
                    1.00043,
                    1,
                    1.00035,
                    .9994,
                    .99976,
                    1.00035,
                    .99973,
                    1.00052,
                    1.00041,
                    1.00119,
                    1.00037,
                    .99973,
                    1.00002,
                    .99986,
                    1.00041,
                    1.00041,
                    .99902,
                    .9996,
                    1.00034,
                    .99999,
                    1.00026,
                    .99999,
                    1.00026,
                    .99973,
                    1.00052,
                    .99973,
                    1,
                    .99973,
                    1.00041,
                    1.00075,
                    .9994,
                    1.0003,
                    .99999,
                    1,
                    1.00041,
                    .99955,
                    1,
                    .99915,
                    .99973,
                    .99973,
                    1.00026,
                    1.00119,
                    .99955,
                    .99973,
                    1.0006,
                    .99911,
                    1.0006,
                    1.00026,
                    .99972,
                    1.00026,
                    .99902,
                    1.00041,
                    .99973,
                    .99999,
                    1,
                    1,
                    1.00038,
                    1.0005,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    .99973,
                    1,
                    1,
                    .99973,
                    1,
                    1,
                    .99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    .99973,
                    .99973,
                    .99972,
                    1,
                    1,
                    1.00106,
                    .99999,
                    .99998,
                    .99998,
                    .99999,
                    .99998,
                    1.66475,
                    1,
                    .99973,
                    .99973,
                    1.00023,
                    .99973,
                    .99971,
                    1.00047,
                    1.00023,
                    1,
                    .99991,
                    .99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    .99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    .99915,
                    1.00031,
                    1.00031,
                    .99999,
                    1.00003,
                    .99999,
                    .99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    .99999,
                    1,
                    .99861,
                    .99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99972,
                    .99999,
                    .99999,
                    .99999,
                    .99999,
                    1.40483,
                    1,
                    .99977,
                    1.00054,
                    1,
                    1,
                    .99953,
                    .99962,
                    1.00042,
                    .9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.HelveticaBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
                t.HelveticaBoldItalicFactors = [
                    .76116,
                    1,
                    1,
                    1.0006,
                    .99998,
                    .99974,
                    .99973,
                    .99973,
                    .99982,
                    .99977,
                    1.00087,
                    .99998,
                    .99998,
                    .99959,
                    1.00003,
                    1.0006,
                    .99998,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    .9999,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    .99977,
                    1.0006,
                    .99973,
                    .99977,
                    1.00026,
                    .99999,
                    .99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    .99977,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99998,
                    1.0006,
                    .99998,
                    1.00003,
                    .99973,
                    .99998,
                    .99973,
                    1.00026,
                    .99973,
                    1.00026,
                    .99973,
                    .99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    .99973,
                    1.0006,
                    .99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99959,
                    .99973,
                    .99998,
                    1.00026,
                    .99973,
                    1.00022,
                    .99973,
                    .99973,
                    1,
                    .99959,
                    1.00077,
                    .99959,
                    1.00003,
                    .99998,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.00077,
                    .99973,
                    .99998,
                    1.00025,
                    .99968,
                    .99973,
                    1.00003,
                    1.00025,
                    .60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    .99998,
                    1,
                    .99973,
                    1.0006,
                    .99998,
                    1,
                    .99936,
                    .99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99977,
                    .99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99982,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99973,
                    1.00026,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    1.0044,
                    .99977,
                    1.00026,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99971,
                    .99973,
                    .99973,
                    1.0006,
                    .99977,
                    .99973,
                    .99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.01011,
                    1.00026,
                    .99999,
                    1.00026,
                    1.0006,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .9993,
                    .9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    .99977,
                    .99959,
                    .99977,
                    .99959,
                    .99977,
                    .99959,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00026,
                    .99998,
                    1.00026,
                    .8121,
                    1.00026,
                    .99998,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    .99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    .99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    .99973,
                    .99977,
                    .99973,
                    1,
                    .99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    .99973,
                    1.00026,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99977,
                    1,
                    1,
                    1.00026,
                    .99969,
                    .99972,
                    .99981,
                    .9998,
                    1.0006,
                    .99977,
                    .99977,
                    1.00022,
                    .91155,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00022,
                    1.0006,
                    .99977,
                    1.00001,
                    .99999,
                    .99977,
                    .99966,
                    1.00022,
                    1.00032,
                    1.00001,
                    .99944,
                    1.00026,
                    1.00001,
                    .99968,
                    1.00001,
                    1.00047,
                    1,
                    1.0006,
                    1.00001,
                    .99981,
                    1.00101,
                    1.00026,
                    1.0006,
                    .99948,
                    .99981,
                    1.00064,
                    .99973,
                    .99942,
                    1.00101,
                    1.00061,
                    1.00026,
                    1.00069,
                    1.0006,
                    1.00014,
                    .99973,
                    1.01322,
                    .99973,
                    1.00065,
                    1.00026,
                    1.00012,
                    .99923,
                    1,
                    1.00064,
                    1.00076,
                    .99948,
                    1.00055,
                    1.00063,
                    1.00007,
                    .99943,
                    1.0006,
                    .99948,
                    1.00026,
                    .99948,
                    .99943,
                    1.00001,
                    1.00001,
                    1.00029,
                    1.00038,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    .99973,
                    .99978,
                    1.00001,
                    1.00057,
                    .99989,
                    .99967,
                    .99964,
                    .99967,
                    .99977,
                    .99999,
                    .99977,
                    1.00038,
                    .99977,
                    1.00001,
                    .99973,
                    1.00066,
                    .99967,
                    .99967,
                    1.00041,
                    .99998,
                    .99999,
                    .99977,
                    1.00022,
                    .99967,
                    1.00001,
                    .99977,
                    1.00026,
                    .99964,
                    1.00031,
                    1.00001,
                    .99999,
                    .99999,
                    1,
                    1.00023,
                    1,
                    1,
                    .99999,
                    1.00035,
                    1.00001,
                    .99999,
                    .99973,
                    .99977,
                    .99999,
                    1.00058,
                    .99973,
                    .99973,
                    .99955,
                    .9995,
                    1.00026,
                    1.00026,
                    1.00032,
                    .99989,
                    1.00034,
                    .99999,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99973,
                    .45998,
                    .99973,
                    1.00026,
                    .99973,
                    1.00001,
                    .99999,
                    .99982,
                    .99994,
                    .99996,
                    1,
                    1.00042,
                    1.00044,
                    1.00029,
                    1.00023,
                    .99973,
                    .99973,
                    1.00026,
                    .99949,
                    1.00002,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99975,
                    1.00026,
                    1.00026,
                    1.00032,
                    .98685,
                    .99973,
                    1.00026,
                    1,
                    1,
                    .99966,
                    1.00044,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    .99973,
                    1,
                    1,
                    .99973,
                    1,
                    1,
                    .99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    .99973,
                    .99973,
                    .99972,
                    1,
                    1,
                    1.00106,
                    .99999,
                    .99998,
                    .99998,
                    .99999,
                    .99998,
                    1.66475,
                    1,
                    .99973,
                    .99973,
                    1,
                    .99973,
                    .99971,
                    .99978,
                    1,
                    1,
                    .99991,
                    .99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00098,
                    1,
                    1,
                    1,
                    1.00049,
                    1,
                    1,
                    .99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    .99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    .99915,
                    1.00031,
                    1.00031,
                    .99999,
                    1.00003,
                    .99999,
                    .99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    .99999,
                    1,
                    .99861,
                    .99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .99972,
                    .99999,
                    .99999,
                    .99999,
                    .99999,
                    1.40483,
                    1,
                    .99977,
                    1.00054,
                    1,
                    1,
                    .99953,
                    .99962,
                    1.00042,
                    .9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.HelveticaBoldItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: .2
                };
                t.HelveticaItalicFactors = [
                    .76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    .99973,
                    .99973,
                    .99982,
                    1.00001,
                    1.00043,
                    .99998,
                    .99998,
                    .99959,
                    1.00003,
                    1.0006,
                    .99998,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    .99973,
                    .99987,
                    1.00001,
                    1.00001,
                    .99977,
                    .99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    .99977,
                    1.0006,
                    1,
                    1.00001,
                    .99973,
                    .99999,
                    .99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    .99977,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99949,
                    .99973,
                    .99998,
                    .99973,
                    .99973,
                    1,
                    .99973,
                    .99973,
                    1.0006,
                    .99973,
                    .99973,
                    .99924,
                    .99924,
                    1,
                    .99924,
                    .99999,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99998,
                    1,
                    1.0006,
                    .99973,
                    1,
                    .99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    .99998,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0009,
                    .99973,
                    .99998,
                    1.00025,
                    .99968,
                    .99973,
                    1.00003,
                    1.00025,
                    .60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    .99998,
                    1,
                    .9998,
                    1.0006,
                    .99998,
                    1,
                    .99936,
                    .99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99977,
                    .99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99982,
                    1,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.06409,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1,
                    .99973,
                    1,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1.0288,
                    .99977,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99924,
                    1.0006,
                    1.0006,
                    .99946,
                    1.00034,
                    1,
                    .99924,
                    1.00001,
                    1,
                    1,
                    .99973,
                    .99924,
                    .99973,
                    .99924,
                    .99973,
                    1.06311,
                    .99973,
                    1.00024,
                    .99973,
                    .99924,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    1.00041,
                    .9998,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1,
                    1.00016,
                    .99977,
                    .99998,
                    .99977,
                    .99998,
                    .99977,
                    .99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    .89547,
                    1.00026,
                    1.0006,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    1.00016,
                    .99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    .99924,
                    .99973,
                    1.00001,
                    .99973,
                    1,
                    .99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    1.00001,
                    1,
                    1.00054,
                    .99977,
                    1.00084,
                    1.00007,
                    .99973,
                    1.00013,
                    .99924,
                    1.00001,
                    1.00001,
                    .99945,
                    .91221,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00001,
                    .99999,
                    .99977,
                    .99933,
                    1.00022,
                    1.00054,
                    1.00001,
                    1.00065,
                    1.00026,
                    1.00001,
                    1.0001,
                    1.00001,
                    1.00052,
                    1,
                    1.0006,
                    1.00001,
                    .99945,
                    .99897,
                    .99968,
                    .99924,
                    1.00036,
                    .99945,
                    .99949,
                    1,
                    1.0006,
                    .99897,
                    .99918,
                    .99968,
                    .99911,
                    .99924,
                    1,
                    .99962,
                    1.01487,
                    1,
                    1.0005,
                    .99973,
                    1.00012,
                    1.00043,
                    1,
                    .99995,
                    .99994,
                    1.00036,
                    .99947,
                    1.00019,
                    1.00063,
                    1.00025,
                    .99924,
                    1.00036,
                    .99973,
                    1.00036,
                    1.00025,
                    1.00001,
                    1.00001,
                    1.00027,
                    1.0001,
                    1.00068,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    1.00008,
                    .99957,
                    .99972,
                    .9994,
                    .99954,
                    .99975,
                    1.00051,
                    1.00001,
                    1.00019,
                    1.00001,
                    1.0001,
                    .99986,
                    1.00001,
                    1.00001,
                    1.00038,
                    .99954,
                    .99954,
                    .9994,
                    1.00066,
                    .99999,
                    .99977,
                    1.00022,
                    1.00054,
                    1.00001,
                    .99977,
                    1.00026,
                    .99975,
                    1.0001,
                    1.00001,
                    .99993,
                    .9995,
                    .99955,
                    1.00016,
                    .99978,
                    .99974,
                    1.00019,
                    1.00022,
                    .99955,
                    1.00053,
                    .99973,
                    1.00089,
                    1.00005,
                    .99967,
                    1.00048,
                    .99973,
                    1.00002,
                    1.00034,
                    .99973,
                    .99973,
                    .99964,
                    1.00006,
                    1.00066,
                    .99947,
                    .99973,
                    .98894,
                    .99973,
                    1,
                    .44898,
                    1,
                    .99946,
                    1,
                    1.00039,
                    1.00082,
                    .99991,
                    .99991,
                    .99985,
                    1.00022,
                    1.00023,
                    1.00061,
                    1.00006,
                    .99966,
                    .99973,
                    .99973,
                    .99973,
                    1.00019,
                    1.0008,
                    1,
                    .99924,
                    .99924,
                    .99924,
                    .99983,
                    1.00044,
                    .99973,
                    .99964,
                    .98332,
                    1,
                    .99973,
                    1,
                    1,
                    .99962,
                    .99895,
                    1.00016,
                    .99977,
                    1.00016,
                    .99977,
                    1.00016,
                    .99977,
                    1.00001,
                    1,
                    1,
                    1,
                    .99973,
                    1,
                    1,
                    .99955,
                    .99924,
                    .99924,
                    .99924,
                    .99924,
                    .99998,
                    .99998,
                    .99998,
                    .99973,
                    .99973,
                    .99972,
                    1,
                    1,
                    1.00267,
                    .99999,
                    .99998,
                    .99998,
                    1,
                    .99998,
                    1.66475,
                    1,
                    .99973,
                    .99973,
                    1.00023,
                    .99973,
                    1.00423,
                    .99925,
                    .99999,
                    1,
                    .99991,
                    .99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00049,
                    1,
                    1.00245,
                    1,
                    1,
                    1,
                    1,
                    .96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    .8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    1.00003,
                    1.00031,
                    1.00031,
                    .99999,
                    1.00003,
                    .99999,
                    .99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    .99999,
                    1,
                    .99861,
                    .99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .95317,
                    .99999,
                    .99999,
                    .99999,
                    .99999,
                    1.40483,
                    1,
                    .99977,
                    1.00054,
                    1,
                    1,
                    .99953,
                    .99962,
                    1.00042,
                    .9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.HelveticaItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: .2
                };
                t.HelveticaRegularFactors = [
                    .76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    .99973,
                    .99973,
                    .99982,
                    1.00001,
                    1.00043,
                    .99998,
                    .99998,
                    .99959,
                    1.00003,
                    1.0006,
                    .99998,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    .99973,
                    .99987,
                    1.00001,
                    1.00001,
                    .99977,
                    .99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    .99977,
                    1.0006,
                    1,
                    1.00001,
                    .99973,
                    .99999,
                    .99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    .99977,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99949,
                    .99973,
                    .99998,
                    .99973,
                    .99973,
                    1,
                    .99973,
                    .99973,
                    1.0006,
                    .99973,
                    .99973,
                    .99924,
                    .99924,
                    1,
                    .99924,
                    .99999,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99998,
                    1,
                    1.0006,
                    .99973,
                    1,
                    .99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    .99998,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0009,
                    .99973,
                    .99998,
                    1.00025,
                    .99968,
                    .99973,
                    1.00003,
                    1.00025,
                    .60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    .99998,
                    1,
                    .9998,
                    1.0006,
                    .99998,
                    1,
                    .99936,
                    .99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99977,
                    .99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    .99977,
                    .99977,
                    .99977,
                    .99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99982,
                    1,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1.06409,
                    1.00026,
                    .99973,
                    .99973,
                    .99973,
                    .99973,
                    1,
                    .99973,
                    1,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1,
                    .99977,
                    1.04596,
                    .99977,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00001,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    .99924,
                    1.0006,
                    1.0006,
                    1.00019,
                    1.00034,
                    1,
                    .99924,
                    1.00001,
                    1,
                    1,
                    .99973,
                    .99924,
                    .99973,
                    .99924,
                    .99973,
                    1.02572,
                    .99973,
                    1.00005,
                    .99973,
                    .99924,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99999,
                    .9998,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1.00022,
                    .99973,
                    1,
                    1.00016,
                    .99977,
                    .99998,
                    .99977,
                    .99998,
                    .99977,
                    .99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    .84533,
                    1.00026,
                    1.0006,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    .99977,
                    .99973,
                    1.00016,
                    .99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    .99924,
                    .99973,
                    1.00001,
                    .99973,
                    1,
                    .99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99998,
                    .99928,
                    1,
                    .99977,
                    1.00013,
                    1.00055,
                    .99947,
                    .99945,
                    .99941,
                    .99924,
                    1.00001,
                    1.00001,
                    1.0004,
                    .91621,
                    1.00001,
                    1.00026,
                    .99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00005,
                    .99999,
                    .99977,
                    1.00015,
                    1.00022,
                    .99977,
                    1.00001,
                    .99973,
                    1.00026,
                    1.00001,
                    1.00019,
                    1.00001,
                    .99946,
                    1,
                    1.0006,
                    1.00001,
                    .99978,
                    1.00045,
                    .99973,
                    .99924,
                    1.00023,
                    .99978,
                    .99966,
                    1,
                    1.00065,
                    1.00045,
                    1.00019,
                    .99973,
                    .99973,
                    .99924,
                    1,
                    1,
                    .96499,
                    1,
                    1.00055,
                    .99973,
                    1.00008,
                    1.00027,
                    1,
                    .9997,
                    .99995,
                    1.00023,
                    .99933,
                    1.00019,
                    1.00015,
                    1.00031,
                    .99924,
                    1.00023,
                    .99973,
                    1.00023,
                    1.00031,
                    1.00001,
                    .99928,
                    1.00029,
                    1.00092,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    .99988,
                    .99975,
                    1,
                    1.00082,
                    .99561,
                    .9996,
                    1.00035,
                    1.00001,
                    .99962,
                    1.00001,
                    1.00092,
                    .99964,
                    1.00001,
                    .99963,
                    .99999,
                    1.00035,
                    1.00035,
                    1.00082,
                    .99962,
                    .99999,
                    .99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    .99977,
                    1.00026,
                    .9996,
                    .99967,
                    1.00001,
                    1.00034,
                    1.00074,
                    1.00054,
                    1.00053,
                    1.00063,
                    .99971,
                    .99962,
                    1.00035,
                    .99975,
                    .99977,
                    .99973,
                    1.00043,
                    .99953,
                    1.0007,
                    .99915,
                    .99973,
                    1.00008,
                    .99892,
                    1.00073,
                    1.00073,
                    1.00114,
                    .99915,
                    1.00073,
                    .99955,
                    .99973,
                    1.00092,
                    .99973,
                    1,
                    .99998,
                    1,
                    1.0003,
                    1,
                    1.00043,
                    1.00001,
                    .99969,
                    1.0003,
                    1,
                    1.00035,
                    1.00001,
                    .9995,
                    1,
                    1.00092,
                    .99973,
                    .99973,
                    .99973,
                    1.0007,
                    .9995,
                    1,
                    .99924,
                    1.0006,
                    .99924,
                    .99972,
                    1.00062,
                    .99973,
                    1.00114,
                    1.00073,
                    1,
                    .99955,
                    1,
                    1,
                    1.00047,
                    .99968,
                    1.00016,
                    .99977,
                    1.00016,
                    .99977,
                    1.00016,
                    .99977,
                    1.00001,
                    1,
                    1,
                    1,
                    .99973,
                    1,
                    1,
                    .99955,
                    .99924,
                    .99924,
                    .99924,
                    .99924,
                    .99998,
                    .99998,
                    .99998,
                    .99973,
                    .99973,
                    .99972,
                    1,
                    1,
                    1.00267,
                    .99999,
                    .99998,
                    .99998,
                    1,
                    .99998,
                    1.66475,
                    1,
                    .99973,
                    .99973,
                    1.00023,
                    .99973,
                    .99971,
                    .99925,
                    1.00023,
                    1,
                    .99991,
                    .99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    .8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    .99915,
                    1.00031,
                    1.00031,
                    .99999,
                    1.00003,
                    .99999,
                    .99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    .99999,
                    1,
                    .99861,
                    .99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    .95317,
                    .99999,
                    .99999,
                    .99999,
                    .99999,
                    1.40483,
                    1,
                    .99977,
                    1.00054,
                    1,
                    1,
                    .99953,
                    .99962,
                    1.00042,
                    .9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.HelveticaRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.LiberationSansRegularWidths = t.LiberationSansRegularMapping = t.LiberationSansItalicWidths = t.LiberationSansItalicMapping = t.LiberationSansBoldWidths = t.LiberationSansBoldMapping = t.LiberationSansBoldItalicWidths = t.LiberationSansBoldItalicMapping = void 0;
                t.LiberationSansBoldWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1e3,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    719,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    785,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    385,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1e3,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1e3,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    465,
                    722,
                    333,
                    853,
                    906,
                    474,
                    825,
                    927,
                    838,
                    278,
                    722,
                    722,
                    601,
                    719,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    644,
                    778,
                    722,
                    667,
                    600,
                    611,
                    667,
                    821,
                    667,
                    809,
                    802,
                    278,
                    667,
                    615,
                    451,
                    611,
                    278,
                    582,
                    615,
                    610,
                    556,
                    606,
                    475,
                    460,
                    611,
                    541,
                    278,
                    558,
                    556,
                    612,
                    556,
                    445,
                    611,
                    766,
                    619,
                    520,
                    684,
                    446,
                    582,
                    715,
                    576,
                    753,
                    845,
                    278,
                    582,
                    611,
                    582,
                    845,
                    667,
                    669,
                    885,
                    567,
                    711,
                    667,
                    278,
                    276,
                    556,
                    1094,
                    1062,
                    875,
                    610,
                    722,
                    622,
                    719,
                    722,
                    719,
                    722,
                    567,
                    712,
                    667,
                    904,
                    626,
                    719,
                    719,
                    610,
                    702,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    622,
                    854,
                    667,
                    730,
                    703,
                    1005,
                    1019,
                    870,
                    979,
                    719,
                    711,
                    1031,
                    719,
                    556,
                    618,
                    615,
                    417,
                    635,
                    556,
                    709,
                    497,
                    615,
                    615,
                    500,
                    635,
                    740,
                    604,
                    611,
                    604,
                    611,
                    556,
                    490,
                    556,
                    875,
                    556,
                    615,
                    581,
                    833,
                    844,
                    729,
                    854,
                    615,
                    552,
                    854,
                    583,
                    556,
                    556,
                    611,
                    417,
                    552,
                    556,
                    278,
                    281,
                    278,
                    969,
                    906,
                    611,
                    500,
                    615,
                    556,
                    604,
                    778,
                    611,
                    487,
                    447,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1e3,
                    1e3,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1e3,
                    1e3,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    489,
                    1115,
                    1e3,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1e3,
                    500,
                    1e3,
                    500,
                    1e3,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1e3,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                t.LiberationSansBoldMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                t.LiberationSansBoldItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1e3,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    740,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    782,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    396,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1e3,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1e3,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    722,
                    333,
                    854,
                    906,
                    473,
                    844,
                    930,
                    847,
                    278,
                    722,
                    722,
                    610,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    657,
                    778,
                    718,
                    667,
                    590,
                    611,
                    667,
                    822,
                    667,
                    829,
                    781,
                    278,
                    667,
                    620,
                    479,
                    611,
                    278,
                    591,
                    620,
                    621,
                    556,
                    610,
                    479,
                    492,
                    611,
                    558,
                    278,
                    566,
                    556,
                    603,
                    556,
                    450,
                    611,
                    712,
                    605,
                    532,
                    664,
                    409,
                    591,
                    704,
                    578,
                    773,
                    834,
                    278,
                    591,
                    611,
                    591,
                    834,
                    667,
                    667,
                    886,
                    614,
                    719,
                    667,
                    278,
                    278,
                    556,
                    1094,
                    1042,
                    854,
                    622,
                    719,
                    677,
                    719,
                    722,
                    708,
                    722,
                    614,
                    722,
                    667,
                    927,
                    643,
                    719,
                    719,
                    615,
                    687,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    677,
                    781,
                    667,
                    729,
                    708,
                    979,
                    989,
                    854,
                    1e3,
                    708,
                    719,
                    1042,
                    729,
                    556,
                    619,
                    604,
                    534,
                    618,
                    556,
                    736,
                    510,
                    611,
                    611,
                    507,
                    622,
                    740,
                    604,
                    611,
                    611,
                    611,
                    556,
                    889,
                    556,
                    885,
                    556,
                    646,
                    583,
                    889,
                    935,
                    707,
                    854,
                    594,
                    552,
                    865,
                    589,
                    556,
                    556,
                    611,
                    469,
                    563,
                    556,
                    278,
                    278,
                    278,
                    969,
                    906,
                    611,
                    507,
                    619,
                    556,
                    611,
                    778,
                    611,
                    575,
                    467,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1e3,
                    1e3,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1e3,
                    1e3,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1104,
                    556,
                    885,
                    516,
                    1146,
                    1e3,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    999,
                    500,
                    1e3,
                    500,
                    1e3,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1e3,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                t.LiberationSansBoldItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                t.LiberationSansItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1e3,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    625,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    733,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    281,
                    556,
                    400,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    615,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1e3,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    354,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1e3,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    789,
                    846,
                    389,
                    794,
                    865,
                    775,
                    222,
                    667,
                    667,
                    570,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    667,
                    833,
                    722,
                    648,
                    778,
                    725,
                    667,
                    600,
                    611,
                    667,
                    837,
                    667,
                    831,
                    761,
                    278,
                    667,
                    570,
                    439,
                    555,
                    222,
                    550,
                    570,
                    571,
                    500,
                    556,
                    439,
                    463,
                    555,
                    542,
                    222,
                    500,
                    492,
                    548,
                    500,
                    447,
                    556,
                    670,
                    573,
                    486,
                    603,
                    374,
                    550,
                    652,
                    546,
                    728,
                    779,
                    222,
                    550,
                    556,
                    550,
                    779,
                    667,
                    667,
                    843,
                    544,
                    708,
                    667,
                    278,
                    278,
                    500,
                    1066,
                    982,
                    844,
                    589,
                    715,
                    639,
                    724,
                    667,
                    651,
                    667,
                    544,
                    704,
                    667,
                    917,
                    614,
                    715,
                    715,
                    589,
                    686,
                    833,
                    722,
                    778,
                    725,
                    667,
                    722,
                    611,
                    639,
                    795,
                    667,
                    727,
                    673,
                    920,
                    923,
                    805,
                    886,
                    651,
                    694,
                    1022,
                    682,
                    556,
                    562,
                    522,
                    493,
                    553,
                    556,
                    688,
                    465,
                    556,
                    556,
                    472,
                    564,
                    686,
                    550,
                    556,
                    556,
                    556,
                    500,
                    833,
                    500,
                    835,
                    500,
                    572,
                    518,
                    830,
                    851,
                    621,
                    736,
                    526,
                    492,
                    752,
                    534,
                    556,
                    556,
                    556,
                    378,
                    496,
                    500,
                    222,
                    222,
                    222,
                    910,
                    828,
                    556,
                    472,
                    565,
                    500,
                    556,
                    778,
                    556,
                    492,
                    339,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1e3,
                    1e3,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1e3,
                    1e3,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1083,
                    1e3,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1e3,
                    500,
                    998,
                    500,
                    1e3,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    584,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1e3,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                t.LiberationSansItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                t.LiberationSansRegularWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1e3,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    615,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    735,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    292,
                    556,
                    334,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    604,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1e3,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    375,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1e3,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    784,
                    838,
                    384,
                    774,
                    855,
                    752,
                    222,
                    667,
                    667,
                    551,
                    668,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    668,
                    833,
                    722,
                    650,
                    778,
                    722,
                    667,
                    618,
                    611,
                    667,
                    798,
                    667,
                    835,
                    748,
                    278,
                    667,
                    578,
                    446,
                    556,
                    222,
                    547,
                    578,
                    575,
                    500,
                    557,
                    446,
                    441,
                    556,
                    556,
                    222,
                    500,
                    500,
                    576,
                    500,
                    448,
                    556,
                    690,
                    569,
                    482,
                    617,
                    395,
                    547,
                    648,
                    525,
                    713,
                    781,
                    222,
                    547,
                    556,
                    547,
                    781,
                    667,
                    667,
                    865,
                    542,
                    719,
                    667,
                    278,
                    278,
                    500,
                    1057,
                    1010,
                    854,
                    583,
                    722,
                    635,
                    719,
                    667,
                    656,
                    667,
                    542,
                    677,
                    667,
                    923,
                    604,
                    719,
                    719,
                    583,
                    656,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    635,
                    760,
                    667,
                    740,
                    667,
                    917,
                    938,
                    792,
                    885,
                    656,
                    719,
                    1010,
                    722,
                    556,
                    573,
                    531,
                    365,
                    583,
                    556,
                    669,
                    458,
                    559,
                    559,
                    438,
                    583,
                    688,
                    552,
                    556,
                    542,
                    556,
                    500,
                    458,
                    500,
                    823,
                    500,
                    573,
                    521,
                    802,
                    823,
                    625,
                    719,
                    521,
                    510,
                    750,
                    542,
                    556,
                    556,
                    556,
                    365,
                    510,
                    500,
                    222,
                    278,
                    222,
                    906,
                    812,
                    556,
                    438,
                    559,
                    500,
                    552,
                    778,
                    556,
                    489,
                    411,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1e3,
                    1e3,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1e3,
                    1e3,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1073,
                    1e3,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1e3,
                    500,
                    1e3,
                    500,
                    1e3,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1e3,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                t.LiberationSansRegularMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.MyriadProRegularMetrics = t.MyriadProRegularFactors = t.MyriadProItalicMetrics = t.MyriadProItalicFactors = t.MyriadProBoldMetrics = t.MyriadProBoldItalicMetrics = t.MyriadProBoldItalicFactors = t.MyriadProBoldFactors = void 0;
                t.MyriadProBoldFactors = [
                    1.36898,
                    1,
                    1,
                    .72706,
                    .80479,
                    .83734,
                    .98894,
                    .99793,
                    .9897,
                    .93884,
                    .86209,
                    .94292,
                    .94292,
                    1.16661,
                    1.02058,
                    .93582,
                    .96694,
                    .93582,
                    1.19137,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    .78076,
                    .78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    .72851,
                    .78966,
                    .90838,
                    .83637,
                    .82391,
                    .96376,
                    .80061,
                    .86275,
                    .8768,
                    .95407,
                    1.0258,
                    .73901,
                    .85022,
                    .83655,
                    1.0156,
                    .95546,
                    .92179,
                    .87107,
                    .92179,
                    .82114,
                    .8096,
                    .89713,
                    .94438,
                    .95353,
                    .94083,
                    .91905,
                    .90406,
                    .9446,
                    .94292,
                    1.18777,
                    .94292,
                    1.02058,
                    .89903,
                    .90088,
                    .94938,
                    .97898,
                    .81093,
                    .97571,
                    .94938,
                    1.024,
                    .9577,
                    .95933,
                    .98621,
                    1.0474,
                    .97455,
                    .98981,
                    .9672,
                    .95933,
                    .9446,
                    .97898,
                    .97407,
                    .97646,
                    .78036,
                    1.10208,
                    .95442,
                    .95298,
                    .97579,
                    .9332,
                    .94039,
                    .938,
                    .80687,
                    1.01149,
                    .80687,
                    1.02058,
                    .80479,
                    .99793,
                    .99793,
                    .99793,
                    .99793,
                    1.01149,
                    1.00872,
                    .90088,
                    .91882,
                    1.0213,
                    .8361,
                    1.02058,
                    .62295,
                    .54324,
                    .89022,
                    1.08595,
                    1,
                    1,
                    .90088,
                    1,
                    .97455,
                    .93582,
                    .90088,
                    1,
                    1.05686,
                    .8361,
                    .99642,
                    .99642,
                    .99642,
                    .72851,
                    .90838,
                    .90838,
                    .90838,
                    .90838,
                    .90838,
                    .90838,
                    .868,
                    .82391,
                    .80061,
                    .80061,
                    .80061,
                    .80061,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    .97484,
                    .95546,
                    .92179,
                    .92179,
                    .92179,
                    .92179,
                    .92179,
                    1.02058,
                    .92179,
                    .94438,
                    .94438,
                    .94438,
                    .94438,
                    .90406,
                    .86958,
                    .98225,
                    .94938,
                    .94938,
                    .94938,
                    .94938,
                    .94938,
                    .94938,
                    .9031,
                    .81093,
                    .94938,
                    .94938,
                    .94938,
                    .94938,
                    .98621,
                    .98621,
                    .98621,
                    .98621,
                    .93969,
                    .95933,
                    .9446,
                    .9446,
                    .9446,
                    .9446,
                    .9446,
                    1.08595,
                    .9446,
                    .95442,
                    .95442,
                    .95442,
                    .95442,
                    .94039,
                    .97898,
                    .94039,
                    .90838,
                    .94938,
                    .90838,
                    .94938,
                    .90838,
                    .94938,
                    .82391,
                    .81093,
                    .82391,
                    .81093,
                    .82391,
                    .81093,
                    .82391,
                    .81093,
                    .96376,
                    .84313,
                    .97484,
                    .97571,
                    .80061,
                    .94938,
                    .80061,
                    .94938,
                    .80061,
                    .94938,
                    .80061,
                    .94938,
                    .80061,
                    .94938,
                    .8768,
                    .9577,
                    .8768,
                    .9577,
                    .8768,
                    .9577,
                    1,
                    1,
                    .95407,
                    .95933,
                    .97069,
                    .95933,
                    1.0258,
                    .98621,
                    1.0258,
                    .98621,
                    1.0258,
                    .98621,
                    1.0258,
                    .98621,
                    1.0258,
                    .98621,
                    .887,
                    1.01591,
                    .73901,
                    1.0474,
                    1,
                    1,
                    .97455,
                    .83655,
                    .98981,
                    1,
                    1,
                    .83655,
                    .73977,
                    .83655,
                    .73903,
                    .84638,
                    1.033,
                    .95546,
                    .95933,
                    1,
                    1,
                    .95546,
                    .95933,
                    .8271,
                    .95417,
                    .95933,
                    .92179,
                    .9446,
                    .92179,
                    .9446,
                    .92179,
                    .9446,
                    .936,
                    .91964,
                    .82114,
                    .97646,
                    1,
                    1,
                    .82114,
                    .97646,
                    .8096,
                    .78036,
                    .8096,
                    .78036,
                    1,
                    1,
                    .8096,
                    .78036,
                    1,
                    1,
                    .89713,
                    .77452,
                    .89713,
                    1.10208,
                    .94438,
                    .95442,
                    .94438,
                    .95442,
                    .94438,
                    .95442,
                    .94438,
                    .95442,
                    .94438,
                    .95442,
                    .94438,
                    .95442,
                    .94083,
                    .97579,
                    .90406,
                    .94039,
                    .90406,
                    .9446,
                    .938,
                    .9446,
                    .938,
                    .9446,
                    .938,
                    1,
                    .99793,
                    .90838,
                    .94938,
                    .868,
                    .9031,
                    .92179,
                    .9446,
                    1,
                    1,
                    .89713,
                    1.10208,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90989,
                    .9358,
                    .91945,
                    .83181,
                    .75261,
                    .87992,
                    .82976,
                    .96034,
                    .83689,
                    .97268,
                    1.0078,
                    .90838,
                    .83637,
                    .8019,
                    .90157,
                    .80061,
                    .9446,
                    .95407,
                    .92436,
                    1.0258,
                    .85022,
                    .97153,
                    1.0156,
                    .95546,
                    .89192,
                    .92179,
                    .92361,
                    .87107,
                    .96318,
                    .89713,
                    .93704,
                    .95638,
                    .91905,
                    .91709,
                    .92796,
                    1.0258,
                    .93704,
                    .94836,
                    1.0373,
                    .95933,
                    1.0078,
                    .95871,
                    .94836,
                    .96174,
                    .92601,
                    .9498,
                    .98607,
                    .95776,
                    .95933,
                    1.05453,
                    1.0078,
                    .98275,
                    .9314,
                    .95617,
                    .91701,
                    1.05993,
                    .9446,
                    .78367,
                    .9553,
                    1,
                    .86832,
                    1.0128,
                    .95871,
                    .99394,
                    .87548,
                    .96361,
                    .86774,
                    1.0078,
                    .95871,
                    .9446,
                    .95871,
                    .86774,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .94083,
                    .97579,
                    .94083,
                    .97579,
                    .94083,
                    .97579,
                    .90406,
                    .94039,
                    .96694,
                    1,
                    .89903,
                    1,
                    1,
                    1,
                    .93582,
                    .93582,
                    .93582,
                    1,
                    .908,
                    .908,
                    .918,
                    .94219,
                    .94219,
                    .96544,
                    1,
                    1.285,
                    1,
                    1,
                    .81079,
                    .81079,
                    1,
                    1,
                    .74854,
                    1,
                    1,
                    1,
                    1,
                    .99793,
                    1,
                    1,
                    1,
                    .65,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.17173,
                    1,
                    .80535,
                    .76169,
                    1.02058,
                    1.0732,
                    1.05486,
                    1,
                    1,
                    1.30692,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.16161,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.MyriadProBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
                t.MyriadProBoldItalicFactors = [
                    1.36898,
                    1,
                    1,
                    .66227,
                    .80779,
                    .81625,
                    .97276,
                    .97276,
                    .97733,
                    .92222,
                    .83266,
                    .94292,
                    .94292,
                    1.16148,
                    1.02058,
                    .93582,
                    .96694,
                    .93582,
                    1.17337,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .78076,
                    .78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    .71541,
                    .76813,
                    .85576,
                    .80591,
                    .80729,
                    .94299,
                    .77512,
                    .83655,
                    .86523,
                    .92222,
                    .98621,
                    .71743,
                    .81698,
                    .79726,
                    .98558,
                    .92222,
                    .90637,
                    .83809,
                    .90637,
                    .80729,
                    .76463,
                    .86275,
                    .90699,
                    .91605,
                    .9154,
                    .85308,
                    .85458,
                    .90531,
                    .94292,
                    1.21296,
                    .94292,
                    1.02058,
                    .89903,
                    1.18616,
                    .99613,
                    .91677,
                    .78216,
                    .91677,
                    .90083,
                    .98796,
                    .9135,
                    .92168,
                    .95381,
                    .98981,
                    .95298,
                    .95381,
                    .93459,
                    .92168,
                    .91513,
                    .92004,
                    .91677,
                    .95077,
                    .748,
                    1.04502,
                    .91677,
                    .92061,
                    .94236,
                    .89544,
                    .89364,
                    .9,
                    .80687,
                    .8578,
                    .80687,
                    1.02058,
                    .80779,
                    .97276,
                    .97276,
                    .97276,
                    .97276,
                    .8578,
                    .99973,
                    1.18616,
                    .91339,
                    1.08074,
                    .82891,
                    1.02058,
                    .55509,
                    .71526,
                    .89022,
                    1.08595,
                    1,
                    1,
                    1.18616,
                    1,
                    .96736,
                    .93582,
                    1.18616,
                    1,
                    1.04864,
                    .82711,
                    .99043,
                    .99043,
                    .99043,
                    .71541,
                    .85576,
                    .85576,
                    .85576,
                    .85576,
                    .85576,
                    .85576,
                    .845,
                    .80729,
                    .77512,
                    .77512,
                    .77512,
                    .77512,
                    .98621,
                    .98621,
                    .98621,
                    .98621,
                    .95961,
                    .92222,
                    .90637,
                    .90637,
                    .90637,
                    .90637,
                    .90637,
                    1.02058,
                    .90251,
                    .90699,
                    .90699,
                    .90699,
                    .90699,
                    .85458,
                    .83659,
                    .94951,
                    .99613,
                    .99613,
                    .99613,
                    .99613,
                    .99613,
                    .99613,
                    .85811,
                    .78216,
                    .90083,
                    .90083,
                    .90083,
                    .90083,
                    .95381,
                    .95381,
                    .95381,
                    .95381,
                    .9135,
                    .92168,
                    .91513,
                    .91513,
                    .91513,
                    .91513,
                    .91513,
                    1.08595,
                    .91677,
                    .91677,
                    .91677,
                    .91677,
                    .91677,
                    .89364,
                    .92332,
                    .89364,
                    .85576,
                    .99613,
                    .85576,
                    .99613,
                    .85576,
                    .99613,
                    .80729,
                    .78216,
                    .80729,
                    .78216,
                    .80729,
                    .78216,
                    .80729,
                    .78216,
                    .94299,
                    .76783,
                    .95961,
                    .91677,
                    .77512,
                    .90083,
                    .77512,
                    .90083,
                    .77512,
                    .90083,
                    .77512,
                    .90083,
                    .77512,
                    .90083,
                    .86523,
                    .9135,
                    .86523,
                    .9135,
                    .86523,
                    .9135,
                    1,
                    1,
                    .92222,
                    .92168,
                    .92222,
                    .92168,
                    .98621,
                    .95381,
                    .98621,
                    .95381,
                    .98621,
                    .95381,
                    .98621,
                    .95381,
                    .98621,
                    .95381,
                    .86036,
                    .97096,
                    .71743,
                    .98981,
                    1,
                    1,
                    .95298,
                    .79726,
                    .95381,
                    1,
                    1,
                    .79726,
                    .6894,
                    .79726,
                    .74321,
                    .81691,
                    1.0006,
                    .92222,
                    .92168,
                    1,
                    1,
                    .92222,
                    .92168,
                    .79464,
                    .92098,
                    .92168,
                    .90637,
                    .91513,
                    .90637,
                    .91513,
                    .90637,
                    .91513,
                    .909,
                    .87514,
                    .80729,
                    .95077,
                    1,
                    1,
                    .80729,
                    .95077,
                    .76463,
                    .748,
                    .76463,
                    .748,
                    1,
                    1,
                    .76463,
                    .748,
                    1,
                    1,
                    .86275,
                    .72651,
                    .86275,
                    1.04502,
                    .90699,
                    .91677,
                    .90699,
                    .91677,
                    .90699,
                    .91677,
                    .90699,
                    .91677,
                    .90699,
                    .91677,
                    .90699,
                    .91677,
                    .9154,
                    .94236,
                    .85458,
                    .89364,
                    .85458,
                    .90531,
                    .9,
                    .90531,
                    .9,
                    .90531,
                    .9,
                    1,
                    .97276,
                    .85576,
                    .99613,
                    .845,
                    .85811,
                    .90251,
                    .91677,
                    1,
                    1,
                    .86275,
                    1.04502,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.00899,
                    1.30628,
                    .85576,
                    .80178,
                    .66862,
                    .7927,
                    .69323,
                    .88127,
                    .72459,
                    .89711,
                    .95381,
                    .85576,
                    .80591,
                    .7805,
                    .94729,
                    .77512,
                    .90531,
                    .92222,
                    .90637,
                    .98621,
                    .81698,
                    .92655,
                    .98558,
                    .92222,
                    .85359,
                    .90637,
                    .90976,
                    .83809,
                    .94523,
                    .86275,
                    .83509,
                    .93157,
                    .85308,
                    .83392,
                    .92346,
                    .98621,
                    .83509,
                    .92886,
                    .91324,
                    .92168,
                    .95381,
                    .90646,
                    .92886,
                    .90557,
                    .86847,
                    .90276,
                    .91324,
                    .86842,
                    .92168,
                    .99531,
                    .95381,
                    .9224,
                    .85408,
                    .92699,
                    .86847,
                    1.0051,
                    .91513,
                    .80487,
                    .93481,
                    1,
                    .88159,
                    1.05214,
                    .90646,
                    .97355,
                    .81539,
                    .89398,
                    .85923,
                    .95381,
                    .90646,
                    .91513,
                    .90646,
                    .85923,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .9154,
                    .94236,
                    .9154,
                    .94236,
                    .9154,
                    .94236,
                    .85458,
                    .89364,
                    .96694,
                    1,
                    .89903,
                    1,
                    1,
                    1,
                    .91782,
                    .91782,
                    .91782,
                    1,
                    .896,
                    .896,
                    .896,
                    .9332,
                    .9332,
                    .95973,
                    1,
                    1.26,
                    1,
                    1,
                    .80479,
                    .80178,
                    1,
                    1,
                    .85633,
                    1,
                    1,
                    1,
                    1,
                    .97276,
                    1,
                    1,
                    1,
                    .698,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.14542,
                    1,
                    .79199,
                    .78694,
                    1.02058,
                    1.03493,
                    1.05486,
                    1,
                    1,
                    1.23026,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.20006,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.MyriadProBoldItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
                t.MyriadProItalicFactors = [
                    1.36898,
                    1,
                    1,
                    .65507,
                    .84943,
                    .85639,
                    .88465,
                    .88465,
                    .86936,
                    .88307,
                    .86948,
                    .85283,
                    .85283,
                    1.06383,
                    1.02058,
                    .75945,
                    .9219,
                    .75945,
                    1.17337,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .75945,
                    .75945,
                    1.02058,
                    1.02058,
                    1.02058,
                    .69046,
                    .70926,
                    .85158,
                    .77812,
                    .76852,
                    .89591,
                    .70466,
                    .76125,
                    .80094,
                    .86822,
                    .83864,
                    .728,
                    .77212,
                    .79475,
                    .93637,
                    .87514,
                    .8588,
                    .76013,
                    .8588,
                    .72421,
                    .69866,
                    .77598,
                    .85991,
                    .80811,
                    .87832,
                    .78112,
                    .77512,
                    .8562,
                    1.0222,
                    1.18417,
                    1.0222,
                    1.27014,
                    .89903,
                    1.15012,
                    .93859,
                    .94399,
                    .846,
                    .94399,
                    .81453,
                    1.0186,
                    .94219,
                    .96017,
                    1.03075,
                    1.02175,
                    .912,
                    1.03075,
                    .96998,
                    .96017,
                    .93859,
                    .94399,
                    .94399,
                    .95493,
                    .746,
                    1.12658,
                    .94578,
                    .91,
                    .979,
                    .882,
                    .882,
                    .83,
                    .85034,
                    .83537,
                    .85034,
                    1.02058,
                    .70869,
                    .88465,
                    .88465,
                    .88465,
                    .88465,
                    .83537,
                    .90083,
                    1.15012,
                    .9161,
                    .94565,
                    .73541,
                    1.02058,
                    .53609,
                    .69353,
                    .79519,
                    1.08595,
                    1,
                    1,
                    1.15012,
                    1,
                    .91974,
                    .75945,
                    1.15012,
                    1,
                    .9446,
                    .73361,
                    .9005,
                    .9005,
                    .9005,
                    .62864,
                    .85158,
                    .85158,
                    .85158,
                    .85158,
                    .85158,
                    .85158,
                    .773,
                    .76852,
                    .70466,
                    .70466,
                    .70466,
                    .70466,
                    .83864,
                    .83864,
                    .83864,
                    .83864,
                    .90561,
                    .87514,
                    .8588,
                    .8588,
                    .8588,
                    .8588,
                    .8588,
                    1.02058,
                    .85751,
                    .85991,
                    .85991,
                    .85991,
                    .85991,
                    .77512,
                    .76013,
                    .88075,
                    .93859,
                    .93859,
                    .93859,
                    .93859,
                    .93859,
                    .93859,
                    .8075,
                    .846,
                    .81453,
                    .81453,
                    .81453,
                    .81453,
                    .82424,
                    .82424,
                    .82424,
                    .82424,
                    .9278,
                    .96017,
                    .93859,
                    .93859,
                    .93859,
                    .93859,
                    .93859,
                    1.08595,
                    .8562,
                    .94578,
                    .94578,
                    .94578,
                    .94578,
                    .882,
                    .94578,
                    .882,
                    .85158,
                    .93859,
                    .85158,
                    .93859,
                    .85158,
                    .93859,
                    .76852,
                    .846,
                    .76852,
                    .846,
                    .76852,
                    .846,
                    .76852,
                    .846,
                    .89591,
                    .8544,
                    .90561,
                    .94399,
                    .70466,
                    .81453,
                    .70466,
                    .81453,
                    .70466,
                    .81453,
                    .70466,
                    .81453,
                    .70466,
                    .81453,
                    .80094,
                    .94219,
                    .80094,
                    .94219,
                    .80094,
                    .94219,
                    1,
                    1,
                    .86822,
                    .96017,
                    .86822,
                    .96017,
                    .83864,
                    .82424,
                    .83864,
                    .82424,
                    .83864,
                    .82424,
                    .83864,
                    1.03075,
                    .83864,
                    .82424,
                    .81402,
                    1.02738,
                    .728,
                    1.02175,
                    1,
                    1,
                    .912,
                    .79475,
                    1.03075,
                    1,
                    1,
                    .79475,
                    .83911,
                    .79475,
                    .66266,
                    .80553,
                    1.06676,
                    .87514,
                    .96017,
                    1,
                    1,
                    .87514,
                    .96017,
                    .86865,
                    .87396,
                    .96017,
                    .8588,
                    .93859,
                    .8588,
                    .93859,
                    .8588,
                    .93859,
                    .867,
                    .84759,
                    .72421,
                    .95493,
                    1,
                    1,
                    .72421,
                    .95493,
                    .69866,
                    .746,
                    .69866,
                    .746,
                    1,
                    1,
                    .69866,
                    .746,
                    1,
                    1,
                    .77598,
                    .88417,
                    .77598,
                    1.12658,
                    .85991,
                    .94578,
                    .85991,
                    .94578,
                    .85991,
                    .94578,
                    .85991,
                    .94578,
                    .85991,
                    .94578,
                    .85991,
                    .94578,
                    .87832,
                    .979,
                    .77512,
                    .882,
                    .77512,
                    .8562,
                    .83,
                    .8562,
                    .83,
                    .8562,
                    .83,
                    1,
                    .88465,
                    .85158,
                    .93859,
                    .773,
                    .8075,
                    .85751,
                    .8562,
                    1,
                    1,
                    .77598,
                    1.12658,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15313,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.08106,
                    1.03901,
                    .85158,
                    .77025,
                    .62264,
                    .7646,
                    .65351,
                    .86026,
                    .69461,
                    .89947,
                    1.03075,
                    .85158,
                    .77812,
                    .76449,
                    .88836,
                    .70466,
                    .8562,
                    .86822,
                    .8588,
                    .83864,
                    .77212,
                    .85308,
                    .93637,
                    .87514,
                    .82352,
                    .8588,
                    .85701,
                    .76013,
                    .89058,
                    .77598,
                    .8156,
                    .82565,
                    .78112,
                    .77899,
                    .89386,
                    .83864,
                    .8156,
                    .9486,
                    .92388,
                    .96186,
                    1.03075,
                    .91123,
                    .9486,
                    .93298,
                    .878,
                    .93942,
                    .92388,
                    .84596,
                    .96186,
                    .95119,
                    1.03075,
                    .922,
                    .88787,
                    .95829,
                    .88,
                    .93559,
                    .93859,
                    .78815,
                    .93758,
                    1,
                    .89217,
                    1.03737,
                    .91123,
                    .93969,
                    .77487,
                    .85769,
                    .86799,
                    1.03075,
                    .91123,
                    .93859,
                    .91123,
                    .86799,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .87832,
                    .979,
                    .87832,
                    .979,
                    .87832,
                    .979,
                    .77512,
                    .882,
                    .9219,
                    1,
                    .89903,
                    1,
                    1,
                    1,
                    .87321,
                    .87321,
                    .87321,
                    1,
                    1.027,
                    1.027,
                    1.027,
                    .86847,
                    .86847,
                    .79121,
                    1,
                    1.124,
                    1,
                    1,
                    .73572,
                    .73572,
                    1,
                    1,
                    .85034,
                    1,
                    1,
                    1,
                    1,
                    .88465,
                    1,
                    1,
                    1,
                    .669,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04828,
                    1,
                    .74948,
                    .75187,
                    1.02058,
                    .98391,
                    1.02119,
                    1,
                    1,
                    1.06233,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05233,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.MyriadProItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
                t.MyriadProRegularFactors = [
                    1.36898,
                    1,
                    1,
                    .76305,
                    .82784,
                    .94935,
                    .89364,
                    .92241,
                    .89073,
                    .90706,
                    .98472,
                    .85283,
                    .85283,
                    1.0664,
                    1.02058,
                    .74505,
                    .9219,
                    .74505,
                    1.23456,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .74505,
                    .74505,
                    1.02058,
                    1.02058,
                    1.02058,
                    .73002,
                    .72601,
                    .91755,
                    .8126,
                    .80314,
                    .92222,
                    .73764,
                    .79726,
                    .83051,
                    .90284,
                    .86023,
                    .74,
                    .8126,
                    .84869,
                    .96518,
                    .91115,
                    .8858,
                    .79761,
                    .8858,
                    .74498,
                    .73914,
                    .81363,
                    .89591,
                    .83659,
                    .89633,
                    .85608,
                    .8111,
                    .90531,
                    1.0222,
                    1.22736,
                    1.0222,
                    1.27014,
                    .89903,
                    .90088,
                    .86667,
                    1.0231,
                    .896,
                    1.01411,
                    .90083,
                    1.05099,
                    1.00512,
                    .99793,
                    1.05326,
                    1.09377,
                    .938,
                    1.06226,
                    1.00119,
                    .99793,
                    .98714,
                    1.0231,
                    1.01231,
                    .98196,
                    .792,
                    1.19137,
                    .99074,
                    .962,
                    1.01915,
                    .926,
                    .942,
                    .856,
                    .85034,
                    .92006,
                    .85034,
                    1.02058,
                    .69067,
                    .92241,
                    .92241,
                    .92241,
                    .92241,
                    .92006,
                    .9332,
                    .90088,
                    .91882,
                    .93484,
                    .75339,
                    1.02058,
                    .56866,
                    .54324,
                    .79519,
                    1.08595,
                    1,
                    1,
                    .90088,
                    1,
                    .95325,
                    .74505,
                    .90088,
                    1,
                    .97198,
                    .75339,
                    .91009,
                    .91009,
                    .91009,
                    .66466,
                    .91755,
                    .91755,
                    .91755,
                    .91755,
                    .91755,
                    .91755,
                    .788,
                    .80314,
                    .73764,
                    .73764,
                    .73764,
                    .73764,
                    .86023,
                    .86023,
                    .86023,
                    .86023,
                    .92915,
                    .91115,
                    .8858,
                    .8858,
                    .8858,
                    .8858,
                    .8858,
                    1.02058,
                    .8858,
                    .89591,
                    .89591,
                    .89591,
                    .89591,
                    .8111,
                    .79611,
                    .89713,
                    .86667,
                    .86667,
                    .86667,
                    .86667,
                    .86667,
                    .86667,
                    .86936,
                    .896,
                    .90083,
                    .90083,
                    .90083,
                    .90083,
                    .84224,
                    .84224,
                    .84224,
                    .84224,
                    .97276,
                    .99793,
                    .98714,
                    .98714,
                    .98714,
                    .98714,
                    .98714,
                    1.08595,
                    .89876,
                    .99074,
                    .99074,
                    .99074,
                    .99074,
                    .942,
                    1.0231,
                    .942,
                    .91755,
                    .86667,
                    .91755,
                    .86667,
                    .91755,
                    .86667,
                    .80314,
                    .896,
                    .80314,
                    .896,
                    .80314,
                    .896,
                    .80314,
                    .896,
                    .92222,
                    .93372,
                    .92915,
                    1.01411,
                    .73764,
                    .90083,
                    .73764,
                    .90083,
                    .73764,
                    .90083,
                    .73764,
                    .90083,
                    .73764,
                    .90083,
                    .83051,
                    1.00512,
                    .83051,
                    1.00512,
                    .83051,
                    1.00512,
                    1,
                    1,
                    .90284,
                    .99793,
                    .90976,
                    .99793,
                    .86023,
                    .84224,
                    .86023,
                    .84224,
                    .86023,
                    .84224,
                    .86023,
                    1.05326,
                    .86023,
                    .84224,
                    .82873,
                    1.07469,
                    .74,
                    1.09377,
                    1,
                    1,
                    .938,
                    .84869,
                    1.06226,
                    1,
                    1,
                    .84869,
                    .83704,
                    .84869,
                    .81441,
                    .85588,
                    1.08927,
                    .91115,
                    .99793,
                    1,
                    1,
                    .91115,
                    .99793,
                    .91887,
                    .90991,
                    .99793,
                    .8858,
                    .98714,
                    .8858,
                    .98714,
                    .8858,
                    .98714,
                    .894,
                    .91434,
                    .74498,
                    .98196,
                    1,
                    1,
                    .74498,
                    .98196,
                    .73914,
                    .792,
                    .73914,
                    .792,
                    1,
                    1,
                    .73914,
                    .792,
                    1,
                    1,
                    .81363,
                    .904,
                    .81363,
                    1.19137,
                    .89591,
                    .99074,
                    .89591,
                    .99074,
                    .89591,
                    .99074,
                    .89591,
                    .99074,
                    .89591,
                    .99074,
                    .89591,
                    .99074,
                    .89633,
                    1.01915,
                    .8111,
                    .942,
                    .8111,
                    .90531,
                    .856,
                    .90531,
                    .856,
                    .90531,
                    .856,
                    1,
                    .92241,
                    .91755,
                    .86667,
                    .788,
                    .86936,
                    .8858,
                    .89876,
                    1,
                    1,
                    .81363,
                    1.19137,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90088,
                    .90388,
                    1.03901,
                    .92138,
                    .78105,
                    .7154,
                    .86169,
                    .80513,
                    .94007,
                    .82528,
                    .98612,
                    1.06226,
                    .91755,
                    .8126,
                    .81884,
                    .92819,
                    .73764,
                    .90531,
                    .90284,
                    .8858,
                    .86023,
                    .8126,
                    .91172,
                    .96518,
                    .91115,
                    .83089,
                    .8858,
                    .87791,
                    .79761,
                    .89297,
                    .81363,
                    .88157,
                    .89992,
                    .85608,
                    .81992,
                    .94307,
                    .86023,
                    .88157,
                    .95308,
                    .98699,
                    .99793,
                    1.06226,
                    .95817,
                    .95308,
                    .97358,
                    .928,
                    .98088,
                    .98699,
                    .92761,
                    .99793,
                    .96017,
                    1.06226,
                    .986,
                    .944,
                    .95978,
                    .938,
                    .96705,
                    .98714,
                    .80442,
                    .98972,
                    1,
                    .89762,
                    1.04552,
                    .95817,
                    .99007,
                    .87064,
                    .91879,
                    .88888,
                    1.06226,
                    .95817,
                    .98714,
                    .95817,
                    .88888,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .89633,
                    1.01915,
                    .89633,
                    1.01915,
                    .89633,
                    1.01915,
                    .8111,
                    .942,
                    .9219,
                    1,
                    .89903,
                    1,
                    1,
                    1,
                    .93173,
                    .93173,
                    .93173,
                    1,
                    1.06304,
                    1.06304,
                    1.06904,
                    .89903,
                    .89903,
                    .80549,
                    1,
                    1.156,
                    1,
                    1,
                    .76575,
                    .76575,
                    1,
                    1,
                    .72458,
                    1,
                    1,
                    1,
                    1,
                    .92241,
                    1,
                    1,
                    1,
                    .619,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.07257,
                    1,
                    .74705,
                    .71119,
                    1.02058,
                    1.024,
                    1.02119,
                    1,
                    1,
                    1.1536,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05638,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.MyriadProRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: .2
                };
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.SegoeuiRegularMetrics = t.SegoeuiRegularFactors = t.SegoeuiItalicMetrics = t.SegoeuiItalicFactors = t.SegoeuiBoldMetrics = t.SegoeuiBoldItalicMetrics = t.SegoeuiBoldItalicFactors = t.SegoeuiBoldFactors = void 0;
                t.SegoeuiBoldFactors = [
                    1.76738,
                    1,
                    1,
                    .99297,
                    .9824,
                    1.04016,
                    1.06497,
                    1.03424,
                    .97529,
                    1.17647,
                    1.23203,
                    1.1085,
                    1.1085,
                    1.16939,
                    1.2107,
                    .9754,
                    1.21408,
                    .9754,
                    1.59578,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    .81378,
                    .81378,
                    1.2107,
                    1.2107,
                    1.2107,
                    .71703,
                    .97847,
                    .97363,
                    .88776,
                    .8641,
                    1.02096,
                    .79795,
                    .85132,
                    .914,
                    1.06085,
                    1.1406,
                    .8007,
                    .89858,
                    .83693,
                    1.14889,
                    1.09398,
                    .97489,
                    .92094,
                    .97489,
                    .90399,
                    .84041,
                    .95923,
                    1.00135,
                    1,
                    1.06467,
                    .98243,
                    .90996,
                    .99361,
                    1.1085,
                    1.56942,
                    1.1085,
                    1.2107,
                    .74627,
                    .94282,
                    .96752,
                    1.01519,
                    .86304,
                    1.01359,
                    .97278,
                    1.15103,
                    1.01359,
                    .98561,
                    1.02285,
                    1.02285,
                    1.00527,
                    1.02285,
                    1.0302,
                    .99041,
                    1.0008,
                    1.01519,
                    1.01359,
                    1.02258,
                    .79104,
                    1.16862,
                    .99041,
                    .97454,
                    1.02511,
                    .99298,
                    .96752,
                    .95801,
                    .94856,
                    1.16579,
                    .94856,
                    1.2107,
                    .9824,
                    1.03424,
                    1.03424,
                    1,
                    1.03424,
                    1.16579,
                    .8727,
                    1.3871,
                    1.18622,
                    1.10818,
                    1.04478,
                    1.2107,
                    1.18622,
                    .75155,
                    .94994,
                    1.28826,
                    1.21408,
                    1.21408,
                    .91056,
                    1,
                    .91572,
                    .9754,
                    .64663,
                    1.18328,
                    1.24866,
                    1.04478,
                    1.14169,
                    1.15749,
                    1.17389,
                    .71703,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .93506,
                    .8641,
                    .79795,
                    .79795,
                    .79795,
                    .79795,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.02096,
                    1.09398,
                    .97426,
                    .97426,
                    .97426,
                    .97426,
                    .97426,
                    1.2107,
                    .97489,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    .90996,
                    .92094,
                    1.02798,
                    .96752,
                    .96752,
                    .96752,
                    .96752,
                    .96752,
                    .96752,
                    .93136,
                    .86304,
                    .97278,
                    .97278,
                    .97278,
                    .97278,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    .97122,
                    .99041,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.28826,
                    1.0008,
                    .99041,
                    .99041,
                    .99041,
                    .99041,
                    .96752,
                    1.01519,
                    .96752,
                    .97363,
                    .96752,
                    .97363,
                    .96752,
                    .97363,
                    .96752,
                    .8641,
                    .86304,
                    .8641,
                    .86304,
                    .8641,
                    .86304,
                    .8641,
                    .86304,
                    1.02096,
                    1.03057,
                    1.02096,
                    1.03517,
                    .79795,
                    .97278,
                    .79795,
                    .97278,
                    .79795,
                    .97278,
                    .79795,
                    .97278,
                    .79795,
                    .97278,
                    .914,
                    1.01359,
                    .914,
                    1.01359,
                    .914,
                    1.01359,
                    1,
                    1,
                    1.06085,
                    .98561,
                    1.06085,
                    1.00879,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    .97138,
                    1.08692,
                    .8007,
                    1.02285,
                    1,
                    1,
                    1.00527,
                    .83693,
                    1.02285,
                    1,
                    1,
                    .83693,
                    .9455,
                    .83693,
                    .90418,
                    .83693,
                    1.13005,
                    1.09398,
                    .99041,
                    1,
                    1,
                    1.09398,
                    .99041,
                    .96692,
                    1.09251,
                    .99041,
                    .97489,
                    1.0008,
                    .97489,
                    1.0008,
                    .97489,
                    1.0008,
                    .93994,
                    .97931,
                    .90399,
                    1.02258,
                    1,
                    1,
                    .90399,
                    1.02258,
                    .84041,
                    .79104,
                    .84041,
                    .79104,
                    .84041,
                    .79104,
                    .84041,
                    .79104,
                    1,
                    1,
                    .95923,
                    1.07034,
                    .95923,
                    1.16862,
                    1.00135,
                    .99041,
                    1.00135,
                    .99041,
                    1.00135,
                    .99041,
                    1.00135,
                    .99041,
                    1.00135,
                    .99041,
                    1.00135,
                    .99041,
                    1.06467,
                    1.02511,
                    .90996,
                    .96752,
                    .90996,
                    .99361,
                    .95801,
                    .99361,
                    .95801,
                    .99361,
                    .95801,
                    1.07733,
                    1.03424,
                    .97363,
                    .96752,
                    .93506,
                    .93136,
                    .97489,
                    1.0008,
                    1,
                    1,
                    .95923,
                    1.16862,
                    1.15103,
                    1.15103,
                    1.01173,
                    1.03959,
                    .75953,
                    .81378,
                    .79912,
                    1.15103,
                    1.21994,
                    .95161,
                    .87815,
                    1.01149,
                    .81525,
                    .7676,
                    .98167,
                    1.01134,
                    1.02546,
                    .84097,
                    1.03089,
                    1.18102,
                    .97363,
                    .88776,
                    .85134,
                    .97826,
                    .79795,
                    .99361,
                    1.06085,
                    .97489,
                    1.1406,
                    .89858,
                    1.0388,
                    1.14889,
                    1.09398,
                    .86039,
                    .97489,
                    1.0595,
                    .92094,
                    .94793,
                    .95923,
                    .90996,
                    .99346,
                    .98243,
                    1.02112,
                    .95493,
                    1.1406,
                    .90996,
                    1.03574,
                    1.02597,
                    1.0008,
                    1.18102,
                    1.06628,
                    1.03574,
                    1.0192,
                    1.01932,
                    1.00886,
                    .97531,
                    1.0106,
                    1.0008,
                    1.13189,
                    1.18102,
                    1.02277,
                    .98683,
                    1.0016,
                    .99561,
                    1.07237,
                    1.0008,
                    .90434,
                    .99921,
                    .93803,
                    .8965,
                    1.23085,
                    1.06628,
                    1.04983,
                    .96268,
                    1.0499,
                    .98439,
                    1.18102,
                    1.06628,
                    1.0008,
                    1.06628,
                    .98439,
                    .79795,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09466,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .97278,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.02065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    .90996,
                    .96752,
                    1,
                    1.21408,
                    .89903,
                    1,
                    1,
                    .75155,
                    1.04394,
                    1.04394,
                    1.04394,
                    1.04394,
                    .98633,
                    .98633,
                    .98633,
                    .73047,
                    .73047,
                    1.20642,
                    .91211,
                    1.25635,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    .96039,
                    1.24633,
                    1,
                    1.12454,
                    .93503,
                    1.03424,
                    1.19687,
                    1.03424,
                    1,
                    1,
                    1,
                    .771,
                    1,
                    1,
                    1.15749,
                    1.15749,
                    1.15749,
                    1.10948,
                    .86279,
                    .94434,
                    .86279,
                    .94434,
                    .86182,
                    1,
                    1,
                    1.16897,
                    1,
                    .96085,
                    .90137,
                    1.2107,
                    1.18416,
                    1.13973,
                    .69825,
                    .9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21172,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    .99862,
                    .99862,
                    1,
                    .87025,
                    .87025,
                    .87025,
                    .87025,
                    1.18874,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.09193,
                    1.09193,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.SegoeuiBoldMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                t.SegoeuiBoldItalicFactors = [
                    1.76738,
                    1,
                    1,
                    .98946,
                    1.03959,
                    1.04016,
                    1.02809,
                    1.036,
                    .97639,
                    1.10953,
                    1.23203,
                    1.11144,
                    1.11144,
                    1.16939,
                    1.21237,
                    .9754,
                    1.21261,
                    .9754,
                    1.59754,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    .81378,
                    .81378,
                    1.21237,
                    1.21237,
                    1.21237,
                    .73541,
                    .97847,
                    .97363,
                    .89723,
                    .87897,
                    1.0426,
                    .79429,
                    .85292,
                    .91149,
                    1.05815,
                    1.1406,
                    .79631,
                    .90128,
                    .83853,
                    1.04396,
                    1.10615,
                    .97552,
                    .94436,
                    .97552,
                    .88641,
                    .80527,
                    .96083,
                    1.00135,
                    1,
                    1.06777,
                    .9817,
                    .91142,
                    .99361,
                    1.11144,
                    1.57293,
                    1.11144,
                    1.21237,
                    .74627,
                    1.31818,
                    1.06585,
                    .97042,
                    .83055,
                    .97042,
                    .93503,
                    1.1261,
                    .97042,
                    .97922,
                    1.14236,
                    .94552,
                    1.01054,
                    1.14236,
                    1.02471,
                    .97922,
                    .94165,
                    .97042,
                    .97042,
                    1.0276,
                    .78929,
                    1.1261,
                    .97922,
                    .95874,
                    1.02197,
                    .98507,
                    .96752,
                    .97168,
                    .95107,
                    1.16579,
                    .95107,
                    1.21237,
                    1.03959,
                    1.036,
                    1.036,
                    1,
                    1.036,
                    1.16579,
                    .87357,
                    1.31818,
                    1.18754,
                    1.26781,
                    1.05356,
                    1.21237,
                    1.18622,
                    .79487,
                    .94994,
                    1.29004,
                    1.24047,
                    1.24047,
                    1.31818,
                    1,
                    .91484,
                    .9754,
                    1.31818,
                    1.1349,
                    1.24866,
                    1.05356,
                    1.13934,
                    1.15574,
                    1.17389,
                    .73541,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .97363,
                    .94385,
                    .87897,
                    .79429,
                    .79429,
                    .79429,
                    .79429,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.0426,
                    1.10615,
                    .97552,
                    .97552,
                    .97552,
                    .97552,
                    .97552,
                    1.21237,
                    .97552,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    .91142,
                    .94436,
                    .98721,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    .96705,
                    .83055,
                    .93503,
                    .93503,
                    .93503,
                    .93503,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    .93125,
                    .97922,
                    .94165,
                    .94165,
                    .94165,
                    .94165,
                    .94165,
                    1.29004,
                    .94165,
                    .97922,
                    .97922,
                    .97922,
                    .97922,
                    .96752,
                    .97042,
                    .96752,
                    .97363,
                    1.06585,
                    .97363,
                    1.06585,
                    .97363,
                    1.06585,
                    .87897,
                    .83055,
                    .87897,
                    .83055,
                    .87897,
                    .83055,
                    .87897,
                    .83055,
                    1.0426,
                    1.0033,
                    1.0426,
                    .97042,
                    .79429,
                    .93503,
                    .79429,
                    .93503,
                    .79429,
                    .93503,
                    .79429,
                    .93503,
                    .79429,
                    .93503,
                    .91149,
                    .97042,
                    .91149,
                    .97042,
                    .91149,
                    .97042,
                    1,
                    1,
                    1.05815,
                    .97922,
                    1.05815,
                    .97922,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    .97441,
                    1.04302,
                    .79631,
                    1.01582,
                    1,
                    1,
                    1.01054,
                    .83853,
                    1.14236,
                    1,
                    1,
                    .83853,
                    1.09125,
                    .83853,
                    .90418,
                    .83853,
                    1.19508,
                    1.10615,
                    .97922,
                    1,
                    1,
                    1.10615,
                    .97922,
                    1.01034,
                    1.10466,
                    .97922,
                    .97552,
                    .94165,
                    .97552,
                    .94165,
                    .97552,
                    .94165,
                    .91602,
                    .91981,
                    .88641,
                    1.0276,
                    1,
                    1,
                    .88641,
                    1.0276,
                    .80527,
                    .78929,
                    .80527,
                    .78929,
                    .80527,
                    .78929,
                    .80527,
                    .78929,
                    1,
                    1,
                    .96083,
                    1.05403,
                    .95923,
                    1.16862,
                    1.00135,
                    .97922,
                    1.00135,
                    .97922,
                    1.00135,
                    .97922,
                    1.00135,
                    .97922,
                    1.00135,
                    .97922,
                    1.00135,
                    .97922,
                    1.06777,
                    1.02197,
                    .91142,
                    .96752,
                    .91142,
                    .99361,
                    .97168,
                    .99361,
                    .97168,
                    .99361,
                    .97168,
                    1.23199,
                    1.036,
                    .97363,
                    1.06585,
                    .94385,
                    .96705,
                    .97552,
                    .94165,
                    1,
                    1,
                    .96083,
                    1.1261,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    .95161,
                    1.27126,
                    1.00811,
                    .83284,
                    .77702,
                    .99137,
                    .95253,
                    1.0347,
                    .86142,
                    1.07205,
                    1.14236,
                    .97363,
                    .89723,
                    .86869,
                    1.09818,
                    .79429,
                    .99361,
                    1.05815,
                    .97552,
                    1.1406,
                    .90128,
                    1.06662,
                    1.04396,
                    1.10615,
                    .84918,
                    .97552,
                    1.04694,
                    .94436,
                    .98015,
                    .96083,
                    .91142,
                    1.00356,
                    .9817,
                    1.01945,
                    .98999,
                    1.1406,
                    .91142,
                    1.04961,
                    .9898,
                    1.00639,
                    1.14236,
                    1.07514,
                    1.04961,
                    .99607,
                    1.02897,
                    1.008,
                    .9898,
                    .95134,
                    1.00639,
                    1.11121,
                    1.14236,
                    1.00518,
                    .97981,
                    1.02186,
                    1,
                    1.08578,
                    .94165,
                    .99314,
                    .98387,
                    .93028,
                    .93377,
                    1.35125,
                    1.07514,
                    1.10687,
                    .93491,
                    1.04232,
                    1.00351,
                    1.14236,
                    1.07514,
                    .94165,
                    1.07514,
                    1.00351,
                    .79429,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09097,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .93503,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .96609,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    .91142,
                    .96752,
                    1,
                    1.21261,
                    .89903,
                    1,
                    1,
                    .75155,
                    1.04745,
                    1.04745,
                    1.04745,
                    1.04394,
                    .98633,
                    .98633,
                    .98633,
                    .72959,
                    .72959,
                    1.20502,
                    .91406,
                    1.26514,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    .96039,
                    1.24633,
                    1,
                    1.09125,
                    .93327,
                    1.03336,
                    1.16541,
                    1.036,
                    1,
                    1,
                    1,
                    .771,
                    1,
                    1,
                    1.15574,
                    1.15574,
                    1.15574,
                    1.15574,
                    .86364,
                    .94434,
                    .86279,
                    .94434,
                    .86224,
                    1,
                    1,
                    1.16798,
                    1,
                    .96085,
                    .90068,
                    1.21237,
                    1.18416,
                    1.13904,
                    .69825,
                    .9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21339,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    .99862,
                    .99862,
                    1,
                    .87025,
                    .87025,
                    .87025,
                    .87025,
                    1.18775,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.13269,
                    1.13269,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.SegoeuiBoldItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                t.SegoeuiItalicFactors = [
                    1.76738,
                    1,
                    1,
                    .98946,
                    1.14763,
                    1.05365,
                    1.06234,
                    .96927,
                    .92586,
                    1.15373,
                    1.18414,
                    .91349,
                    .91349,
                    1.07403,
                    1.17308,
                    .78383,
                    1.20088,
                    .78383,
                    1.42531,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .78383,
                    .78383,
                    1.17308,
                    1.17308,
                    1.17308,
                    .77349,
                    .94565,
                    .94729,
                    .85944,
                    .88506,
                    .9858,
                    .74817,
                    .80016,
                    .88449,
                    .98039,
                    .95782,
                    .69238,
                    .89898,
                    .83231,
                    .98183,
                    1.03989,
                    .96924,
                    .86237,
                    .96924,
                    .80595,
                    .74524,
                    .86091,
                    .95402,
                    .94143,
                    .98448,
                    .8858,
                    .83089,
                    .93285,
                    1.0949,
                    1.39016,
                    1.0949,
                    1.45994,
                    .74627,
                    1.04839,
                    .97454,
                    .97454,
                    .87207,
                    .97454,
                    .87533,
                    1.06151,
                    .97454,
                    1.00176,
                    1.16484,
                    1.08132,
                    .98047,
                    1.16484,
                    1.02989,
                    1.01054,
                    .96225,
                    .97454,
                    .97454,
                    1.06598,
                    .79004,
                    1.16344,
                    1.00351,
                    .94629,
                    .9973,
                    .91016,
                    .96777,
                    .9043,
                    .91082,
                    .92481,
                    .91082,
                    1.17308,
                    .95748,
                    .96927,
                    .96927,
                    1,
                    .96927,
                    .92481,
                    .80597,
                    1.04839,
                    1.23393,
                    1.1781,
                    .9245,
                    1.17308,
                    1.20808,
                    .63218,
                    .94261,
                    1.24822,
                    1.09971,
                    1.09971,
                    1.04839,
                    1,
                    .85273,
                    .78032,
                    1.04839,
                    1.09971,
                    1.22326,
                    .9245,
                    1.09836,
                    1.13525,
                    1.15222,
                    .70424,
                    .94729,
                    .94729,
                    .94729,
                    .94729,
                    .94729,
                    .94729,
                    .85498,
                    .88506,
                    .74817,
                    .74817,
                    .74817,
                    .74817,
                    .95782,
                    .95782,
                    .95782,
                    .95782,
                    .9858,
                    1.03989,
                    .96924,
                    .96924,
                    .96924,
                    .96924,
                    .96924,
                    1.17308,
                    .96924,
                    .95402,
                    .95402,
                    .95402,
                    .95402,
                    .83089,
                    .86237,
                    .88409,
                    .97454,
                    .97454,
                    .97454,
                    .97454,
                    .97454,
                    .97454,
                    .92916,
                    .87207,
                    .87533,
                    .87533,
                    .87533,
                    .87533,
                    .93146,
                    .93146,
                    .93146,
                    .93146,
                    .93854,
                    1.01054,
                    .96225,
                    .96225,
                    .96225,
                    .96225,
                    .96225,
                    1.24822,
                    .8761,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    .96777,
                    .97454,
                    .96777,
                    .94729,
                    .97454,
                    .94729,
                    .97454,
                    .94729,
                    .97454,
                    .88506,
                    .87207,
                    .88506,
                    .87207,
                    .88506,
                    .87207,
                    .88506,
                    .87207,
                    .9858,
                    .95391,
                    .9858,
                    .97454,
                    .74817,
                    .87533,
                    .74817,
                    .87533,
                    .74817,
                    .87533,
                    .74817,
                    .87533,
                    .74817,
                    .87533,
                    .88449,
                    .97454,
                    .88449,
                    .97454,
                    .88449,
                    .97454,
                    1,
                    1,
                    .98039,
                    1.00176,
                    .98039,
                    1.00176,
                    .95782,
                    .93146,
                    .95782,
                    .93146,
                    .95782,
                    .93146,
                    .95782,
                    1.16484,
                    .95782,
                    .93146,
                    .84421,
                    1.12761,
                    .69238,
                    1.08132,
                    1,
                    1,
                    .98047,
                    .83231,
                    1.16484,
                    1,
                    1,
                    .84723,
                    1.04861,
                    .84723,
                    .78755,
                    .83231,
                    1.23736,
                    1.03989,
                    1.01054,
                    1,
                    1,
                    1.03989,
                    1.01054,
                    .9857,
                    1.03849,
                    1.01054,
                    .96924,
                    .96225,
                    .96924,
                    .96225,
                    .96924,
                    .96225,
                    .92383,
                    .90171,
                    .80595,
                    1.06598,
                    1,
                    1,
                    .80595,
                    1.06598,
                    .74524,
                    .79004,
                    .74524,
                    .79004,
                    .74524,
                    .79004,
                    .74524,
                    .79004,
                    1,
                    1,
                    .86091,
                    1.02759,
                    .85771,
                    1.16344,
                    .95402,
                    1.00351,
                    .95402,
                    1.00351,
                    .95402,
                    1.00351,
                    .95402,
                    1.00351,
                    .95402,
                    1.00351,
                    .95402,
                    1.00351,
                    .98448,
                    .9973,
                    .83089,
                    .96777,
                    .83089,
                    .93285,
                    .9043,
                    .93285,
                    .9043,
                    .93285,
                    .9043,
                    1.31868,
                    .96927,
                    .94729,
                    .97454,
                    .85498,
                    .92916,
                    .96924,
                    .8761,
                    1,
                    1,
                    .86091,
                    1.16344,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    .81965,
                    .81965,
                    .94729,
                    .78032,
                    .71022,
                    .90883,
                    .84171,
                    .99877,
                    .77596,
                    1.05734,
                    1.2,
                    .94729,
                    .85944,
                    .82791,
                    .9607,
                    .74817,
                    .93285,
                    .98039,
                    .96924,
                    .95782,
                    .89898,
                    .98316,
                    .98183,
                    1.03989,
                    .78614,
                    .96924,
                    .97642,
                    .86237,
                    .86075,
                    .86091,
                    .83089,
                    .90082,
                    .8858,
                    .97296,
                    1.01284,
                    .95782,
                    .83089,
                    1.0976,
                    1.04,
                    1.03342,
                    1.2,
                    1.0675,
                    1.0976,
                    .98205,
                    1.03809,
                    1.05097,
                    1.04,
                    .95364,
                    1.03342,
                    1.05401,
                    1.2,
                    1.02148,
                    1.0119,
                    1.04724,
                    1.0127,
                    1.02732,
                    .96225,
                    .8965,
                    .97783,
                    .93574,
                    .94818,
                    1.30679,
                    1.0675,
                    1.11826,
                    .99821,
                    1.0557,
                    1.0326,
                    1.2,
                    1.0675,
                    .96225,
                    1.0675,
                    1.0326,
                    .74817,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03754,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .87533,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .98705,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .98448,
                    .9973,
                    .98448,
                    .9973,
                    .98448,
                    .9973,
                    .83089,
                    .96777,
                    1,
                    1.20088,
                    .89903,
                    1,
                    1,
                    .75155,
                    .94945,
                    .94945,
                    .94945,
                    .94945,
                    1.12317,
                    1.12317,
                    1.12317,
                    .67603,
                    .67603,
                    1.15621,
                    .73584,
                    1.21191,
                    1.22135,
                    1.06483,
                    .94868,
                    .94868,
                    .95996,
                    1.24633,
                    1,
                    1.07497,
                    .87709,
                    .96927,
                    1.01473,
                    .96927,
                    1,
                    1,
                    1,
                    .77295,
                    1,
                    1,
                    1.09836,
                    1.09836,
                    1.09836,
                    1.01522,
                    .86321,
                    .94434,
                    .8649,
                    .94434,
                    .86182,
                    1,
                    1,
                    1.083,
                    1,
                    .91578,
                    .86438,
                    1.17308,
                    1.18416,
                    1.14589,
                    .69825,
                    .97622,
                    1.96791,
                    1.24822,
                    1.24822,
                    1.17308,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    .99862,
                    .99862,
                    1,
                    .87025,
                    .87025,
                    .87025,
                    .87025,
                    1.17984,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10742,
                    1.10742,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.SegoeuiItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                t.SegoeuiRegularFactors = [
                    1.76738,
                    1,
                    1,
                    .98594,
                    1.02285,
                    1.10454,
                    1.06234,
                    .96927,
                    .92037,
                    1.19985,
                    1.2046,
                    .90616,
                    .90616,
                    1.07152,
                    1.1714,
                    .78032,
                    1.20088,
                    .78032,
                    1.40246,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .96927,
                    .78032,
                    .78032,
                    1.1714,
                    1.1714,
                    1.1714,
                    .80597,
                    .94084,
                    .96706,
                    .85944,
                    .85734,
                    .97093,
                    .75842,
                    .79936,
                    .88198,
                    .9831,
                    .95782,
                    .71387,
                    .86969,
                    .84636,
                    1.07796,
                    1.03584,
                    .96924,
                    .83968,
                    .96924,
                    .82826,
                    .79649,
                    .85771,
                    .95132,
                    .93119,
                    .98965,
                    .88433,
                    .8287,
                    .93365,
                    1.08612,
                    1.3638,
                    1.08612,
                    1.45786,
                    .74627,
                    .80499,
                    .91484,
                    1.05707,
                    .92383,
                    1.05882,
                    .9403,
                    1.12654,
                    1.05882,
                    1.01756,
                    1.09011,
                    1.09011,
                    .99414,
                    1.09011,
                    1.034,
                    1.01756,
                    1.05356,
                    1.05707,
                    1.05882,
                    1.04399,
                    .84863,
                    1.21968,
                    1.01756,
                    .95801,
                    1.00068,
                    .91797,
                    .96777,
                    .9043,
                    .90351,
                    .92105,
                    .90351,
                    1.1714,
                    .85337,
                    .96927,
                    .96927,
                    .99912,
                    .96927,
                    .92105,
                    .80597,
                    1.2434,
                    1.20808,
                    1.05937,
                    .90957,
                    1.1714,
                    1.20808,
                    .75155,
                    .94261,
                    1.24644,
                    1.09971,
                    1.09971,
                    .84751,
                    1,
                    .85273,
                    .78032,
                    .61584,
                    1.05425,
                    1.17914,
                    .90957,
                    1.08665,
                    1.11593,
                    1.14169,
                    .73381,
                    .96706,
                    .96706,
                    .96706,
                    .96706,
                    .96706,
                    .96706,
                    .86035,
                    .85734,
                    .75842,
                    .75842,
                    .75842,
                    .75842,
                    .95782,
                    .95782,
                    .95782,
                    .95782,
                    .97093,
                    1.03584,
                    .96924,
                    .96924,
                    .96924,
                    .96924,
                    .96924,
                    1.1714,
                    .96924,
                    .95132,
                    .95132,
                    .95132,
                    .95132,
                    .8287,
                    .83968,
                    .89049,
                    .91484,
                    .91484,
                    .91484,
                    .91484,
                    .91484,
                    .91484,
                    .93575,
                    .92383,
                    .9403,
                    .9403,
                    .9403,
                    .9403,
                    .8717,
                    .8717,
                    .8717,
                    .8717,
                    1.00527,
                    1.01756,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.24644,
                    .95923,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    .96777,
                    1.05707,
                    .96777,
                    .96706,
                    .91484,
                    .96706,
                    .91484,
                    .96706,
                    .91484,
                    .85734,
                    .92383,
                    .85734,
                    .92383,
                    .85734,
                    .92383,
                    .85734,
                    .92383,
                    .97093,
                    1.0969,
                    .97093,
                    1.05882,
                    .75842,
                    .9403,
                    .75842,
                    .9403,
                    .75842,
                    .9403,
                    .75842,
                    .9403,
                    .75842,
                    .9403,
                    .88198,
                    1.05882,
                    .88198,
                    1.05882,
                    .88198,
                    1.05882,
                    1,
                    1,
                    .9831,
                    1.01756,
                    .9831,
                    1.01756,
                    .95782,
                    .8717,
                    .95782,
                    .8717,
                    .95782,
                    .8717,
                    .95782,
                    1.09011,
                    .95782,
                    .8717,
                    .84784,
                    1.11551,
                    .71387,
                    1.09011,
                    1,
                    1,
                    .99414,
                    .84636,
                    1.09011,
                    1,
                    1,
                    .84636,
                    1.0536,
                    .84636,
                    .94298,
                    .84636,
                    1.23297,
                    1.03584,
                    1.01756,
                    1,
                    1,
                    1.03584,
                    1.01756,
                    1.00323,
                    1.03444,
                    1.01756,
                    .96924,
                    1.05356,
                    .96924,
                    1.05356,
                    .96924,
                    1.05356,
                    .93066,
                    .98293,
                    .82826,
                    1.04399,
                    1,
                    1,
                    .82826,
                    1.04399,
                    .79649,
                    .84863,
                    .79649,
                    .84863,
                    .79649,
                    .84863,
                    .79649,
                    .84863,
                    1,
                    1,
                    .85771,
                    1.17318,
                    .85771,
                    1.21968,
                    .95132,
                    1.01756,
                    .95132,
                    1.01756,
                    .95132,
                    1.01756,
                    .95132,
                    1.01756,
                    .95132,
                    1.01756,
                    .95132,
                    1.01756,
                    .98965,
                    1.00068,
                    .8287,
                    .96777,
                    .8287,
                    .93365,
                    .9043,
                    .93365,
                    .9043,
                    .93365,
                    .9043,
                    1.08571,
                    .96927,
                    .96706,
                    .91484,
                    .86035,
                    .93575,
                    .96924,
                    .95923,
                    1,
                    1,
                    .85771,
                    1.21968,
                    1.11437,
                    1.11437,
                    .93109,
                    .91202,
                    .60411,
                    .84164,
                    .55572,
                    1.01173,
                    .97361,
                    .81818,
                    .81818,
                    .96635,
                    .78032,
                    .72727,
                    .92366,
                    .98601,
                    1.03405,
                    .77968,
                    1.09799,
                    1.2,
                    .96706,
                    .85944,
                    .85638,
                    .96491,
                    .75842,
                    .93365,
                    .9831,
                    .96924,
                    .95782,
                    .86969,
                    .94152,
                    1.07796,
                    1.03584,
                    .78437,
                    .96924,
                    .98715,
                    .83968,
                    .83491,
                    .85771,
                    .8287,
                    .94492,
                    .88433,
                    .9287,
                    1.0098,
                    .95782,
                    .8287,
                    1.0625,
                    .98248,
                    1.03424,
                    1.2,
                    1.01071,
                    1.0625,
                    .95246,
                    1.03809,
                    1.04912,
                    .98248,
                    1.00221,
                    1.03424,
                    1.05443,
                    1.2,
                    1.04785,
                    .99609,
                    1.00169,
                    1.05176,
                    .99346,
                    1.05356,
                    .9087,
                    1.03004,
                    .95542,
                    .93117,
                    1.23362,
                    1.01071,
                    1.07831,
                    1.02512,
                    1.05205,
                    1.03502,
                    1.2,
                    1.01071,
                    1.05356,
                    1.01071,
                    1.03502,
                    .75842,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03719,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .9403,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04021,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    .98965,
                    1.00068,
                    .98965,
                    1.00068,
                    .98965,
                    1.00068,
                    .8287,
                    .96777,
                    1,
                    1.20088,
                    .89903,
                    1,
                    1,
                    .75155,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.13196,
                    1.13196,
                    1.13196,
                    .67428,
                    .67428,
                    1.16039,
                    .73291,
                    1.20996,
                    1.22135,
                    1.06483,
                    .94868,
                    .94868,
                    .95996,
                    1.24633,
                    1,
                    1.07497,
                    .87796,
                    .96927,
                    1.01518,
                    .96927,
                    1,
                    1,
                    1,
                    .77295,
                    1,
                    1,
                    1.10539,
                    1.10539,
                    1.11358,
                    1.06967,
                    .86279,
                    .94434,
                    .86279,
                    .94434,
                    .86182,
                    1,
                    1,
                    1.083,
                    1,
                    .91578,
                    .86507,
                    1.1714,
                    1.18416,
                    1.14589,
                    .69825,
                    .97622,
                    1.9697,
                    1.24822,
                    1.24822,
                    1.17238,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    .99862,
                    .99862,
                    1,
                    .87025,
                    .87025,
                    .87025,
                    .87025,
                    1.18083,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    .99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10938,
                    1.10938,
                    1,
                    1,
                    1,
                    1.05425,
                    1.09971,
                    1.09971,
                    1.09971,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                t.SegoeuiRegularMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PostScriptEvaluator = t.PostScriptCompiler = t.PDFFunctionFactory = void 0;
                t.isPDFFunction = function isPDFFunction(e1) {
                    let t;
                    if (e1 instanceof r.Dict) t = e1;
                    else {
                        if (!(e1 instanceof s.BaseStream)) return !1;
                        t = e1.dict;
                    }
                    return t.has("FunctionType");
                };
                var r = a(4), n = a(2), i = a(58), s = a(5), o = a(59);
                t.PDFFunctionFactory = class PDFFunctionFactory {
                    constructor({ xref: e1, isEvalSupported: t = !0 }){
                        this.xref = e1;
                        this.isEvalSupported = !1 !== t;
                    }
                    create(e1) {
                        const t = this.getCached(e1);
                        if (t) return t;
                        const a = PDFFunction.parse({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fn: e1 instanceof r.Ref ? this.xref.fetch(e1) : e1
                        });
                        this._cache(e1, a);
                        return a;
                    }
                    createFromArray(e1) {
                        const t = this.getCached(e1);
                        if (t) return t;
                        const a = PDFFunction.parseArray({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fnObj: e1 instanceof r.Ref ? this.xref.fetch(e1) : e1
                        });
                        this._cache(e1, a);
                        return a;
                    }
                    getCached(e1) {
                        let t;
                        e1 instanceof r.Ref ? t = e1 : e1 instanceof r.Dict ? t = e1.objId : e1 instanceof s.BaseStream && (t = e1.dict?.objId);
                        if (t) {
                            const e1 = this._localFunctionCache.getByRef(t);
                            if (e1) return e1;
                        }
                        return null;
                    }
                    _cache(e1, t) {
                        if (!t) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                        let a;
                        e1 instanceof r.Ref ? a = e1 : e1 instanceof r.Dict ? a = e1.objId : e1 instanceof s.BaseStream && (a = e1.dict?.objId);
                        a && this._localFunctionCache.set(null, a, t);
                    }
                    get _localFunctionCache() {
                        return (0, n.shadow)(this, "_localFunctionCache", new o.LocalFunctionCache);
                    }
                };
                function toNumberArray(e1) {
                    if (!Array.isArray(e1)) return null;
                    const t = e1.length;
                    for(let a = 0; a < t; a++)if ("number" != typeof e1[a]) {
                        const a = new Array(t);
                        for(let r = 0; r < t; r++)a[r] = +e1[r];
                        return a;
                    }
                    return e1;
                }
                class PDFFunction {
                    static getSampleArray(e1, t, a, r) {
                        let n, i, s = 1;
                        for(n = 0, i = e1.length; n < i; n++)s *= e1[n];
                        s *= t;
                        const o = new Array(s);
                        let c = 0, l = 0;
                        const h = 1 / (2 ** a - 1), u = r.getBytes((s * a + 7) / 8);
                        let d = 0;
                        for(n = 0; n < s; n++){
                            for(; c < a;){
                                l <<= 8;
                                l |= u[d++];
                                c += 8;
                            }
                            c -= a;
                            o[n] = (l >> c) * h;
                            l &= (1 << c) - 1;
                        }
                        return o;
                    }
                    static parse({ xref: e1, isEvalSupported: t, fn: a }) {
                        const r = a.dict || a;
                        switch(r.get("FunctionType")){
                            case 0:
                                return this.constructSampled({
                                    xref: e1,
                                    isEvalSupported: t,
                                    fn: a,
                                    dict: r
                                });
                            case 1:
                                break;
                            case 2:
                                return this.constructInterpolated({
                                    xref: e1,
                                    isEvalSupported: t,
                                    dict: r
                                });
                            case 3:
                                return this.constructStiched({
                                    xref: e1,
                                    isEvalSupported: t,
                                    dict: r
                                });
                            case 4:
                                return this.constructPostScript({
                                    xref: e1,
                                    isEvalSupported: t,
                                    fn: a,
                                    dict: r
                                });
                        }
                        throw new n.FormatError("Unknown type of function");
                    }
                    static parseArray({ xref: e1, isEvalSupported: t, fnObj: a }) {
                        if (!Array.isArray(a)) return this.parse({
                            xref: e1,
                            isEvalSupported: t,
                            fn: a
                        });
                        const r = [];
                        for (const n of a)r.push(this.parse({
                            xref: e1,
                            isEvalSupported: t,
                            fn: e1.fetchIfRef(n)
                        }));
                        return function(e1, t, a, n) {
                            for(let i = 0, s = r.length; i < s; i++)r[i](e1, t, a, n + i);
                        };
                    }
                    static constructSampled({ xref: e1, isEvalSupported: t, fn: a, dict: r }) {
                        function toMultiArray(e1) {
                            const t = e1.length, a = [];
                            let r = 0;
                            for(let n = 0; n < t; n += 2)a[r++] = [
                                e1[n],
                                e1[n + 1]
                            ];
                            return a;
                        }
                        function interpolate(e1, t, a, r, n) {
                            return r + (n - r) / (a - t) * (e1 - t);
                        }
                        let i = toNumberArray(r.getArray("Domain")), s = toNumberArray(r.getArray("Range"));
                        if (!i || !s) throw new n.FormatError("No domain or range");
                        const o = i.length / 2, c = s.length / 2;
                        i = toMultiArray(i);
                        s = toMultiArray(s);
                        const l = toNumberArray(r.getArray("Size")), h = r.get("BitsPerSample"), u = r.get("Order") || 1;
                        1 !== u && (0, n.info)("No support for cubic spline interpolation: " + u);
                        let d = toNumberArray(r.getArray("Encode"));
                        if (d) d = toMultiArray(d);
                        else {
                            d = [];
                            for(let e1 = 0; e1 < o; ++e1)d.push([
                                0,
                                l[e1] - 1
                            ]);
                        }
                        let f = toNumberArray(r.getArray("Decode"));
                        f = f ? toMultiArray(f) : s;
                        const g = this.getSampleArray(l, c, h, a);
                        return function constructSampledFn(e1, t, a, r) {
                            const n = 1 << o, h = new Float64Array(n), u = new Uint32Array(n);
                            let p, m;
                            for(m = 0; m < n; m++)h[m] = 1;
                            let b = c, y = 1;
                            for(p = 0; p < o; ++p){
                                const a = i[p][0], r = i[p][1];
                                let s = interpolate(Math.min(Math.max(e1[t + p], a), r), a, r, d[p][0], d[p][1]);
                                const o = l[p];
                                s = Math.min(Math.max(s, 0), o - 1);
                                const c = s < o - 1 ? Math.floor(s) : s - 1, f = c + 1 - s, g = s - c, w = c * b, S = w + b;
                                for(m = 0; m < n; m++)if (m & y) {
                                    h[m] *= g;
                                    u[m] += S;
                                } else {
                                    h[m] *= f;
                                    u[m] += w;
                                }
                                b *= o;
                                y <<= 1;
                            }
                            for(m = 0; m < c; ++m){
                                let e1 = 0;
                                for(p = 0; p < n; p++)e1 += g[u[p] + m] * h[p];
                                e1 = interpolate(e1, 0, 1, f[m][0], f[m][1]);
                                a[r + m] = Math.min(Math.max(e1, s[m][0]), s[m][1]);
                            }
                        };
                    }
                    static constructInterpolated({ xref: e1, isEvalSupported: t, dict: a }) {
                        const r = toNumberArray(a.getArray("C0")) || [
                            0
                        ], n = toNumberArray(a.getArray("C1")) || [
                            1
                        ], i = a.get("N"), s = [];
                        for(let e1 = 0, t = r.length; e1 < t; ++e1)s.push(n[e1] - r[e1]);
                        const o = s.length;
                        return function constructInterpolatedFn(e1, t, a, n) {
                            const c = 1 === i ? e1[t] : e1[t] ** i;
                            for(let e1 = 0; e1 < o; ++e1)a[n + e1] = r[e1] + c * s[e1];
                        };
                    }
                    static constructStiched({ xref: e1, isEvalSupported: t, dict: a }) {
                        const r = toNumberArray(a.getArray("Domain"));
                        if (!r) throw new n.FormatError("No domain");
                        if (1 !== r.length / 2) throw new n.FormatError("Bad domain for stiched function");
                        const i = [];
                        for (const r of a.get("Functions"))i.push(this.parse({
                            xref: e1,
                            isEvalSupported: t,
                            fn: e1.fetchIfRef(r)
                        }));
                        const s = toNumberArray(a.getArray("Bounds")), o = toNumberArray(a.getArray("Encode")), c = new Float32Array(1);
                        return function constructStichedFn(e1, t, a, n) {
                            const l = function constructStichedFromIRClip(e1, t, a) {
                                e1 > a ? e1 = a : e1 < t && (e1 = t);
                                return e1;
                            }(e1[t], r[0], r[1]), h = s.length;
                            let u;
                            for(u = 0; u < h && !(l < s[u]); ++u);
                            let d = r[0];
                            u > 0 && (d = s[u - 1]);
                            let f = r[1];
                            u < s.length && (f = s[u]);
                            const g = o[2 * u], p = o[2 * u + 1];
                            c[0] = d === f ? g : g + (l - d) * (p - g) / (f - d);
                            i[u](c, 0, a, n);
                        };
                    }
                    static constructPostScript({ xref: e1, isEvalSupported: t, fn: a, dict: r }) {
                        const s = toNumberArray(r.getArray("Domain")), o = toNumberArray(r.getArray("Range"));
                        if (!s) throw new n.FormatError("No domain.");
                        if (!o) throw new n.FormatError("No range.");
                        const c = new i.PostScriptLexer(a), l = new i.PostScriptParser(c).parse();
                        if (t && n.FeatureTest.isEvalSupported) {
                            const e1 = (new PostScriptCompiler).compile(l, s, o);
                            if (e1) return new Function("src", "srcOffset", "dest", "destOffset", e1);
                        }
                        (0, n.info)("Unable to compile PS function");
                        const h = o.length >> 1, u = s.length >> 1, d = new PostScriptEvaluator(l), f = Object.create(null);
                        let g = 8192;
                        const p = new Float32Array(u);
                        return function constructPostScriptFn(e1, t, a, r) {
                            let n, i, s = "";
                            const c = p;
                            for(n = 0; n < u; n++){
                                i = e1[t + n];
                                c[n] = i;
                                s += i + "_";
                            }
                            const l = f[s];
                            if (void 0 !== l) {
                                a.set(l, r);
                                return;
                            }
                            const m = new Float32Array(h), b = d.execute(c), y = b.length - h;
                            for(n = 0; n < h; n++){
                                i = b[y + n];
                                let e1 = o[2 * n];
                                if (i < e1) i = e1;
                                else {
                                    e1 = o[2 * n + 1];
                                    i > e1 && (i = e1);
                                }
                                m[n] = i;
                            }
                            if (g > 0) {
                                g--;
                                f[s] = m;
                            }
                            a.set(m, r);
                        };
                    }
                }
                class PostScriptStack {
                    static MAX_STACK_SIZE = 100;
                    constructor(e1){
                        this.stack = e1 ? Array.from(e1) : [];
                    }
                    push(e1) {
                        if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        this.stack.push(e1);
                    }
                    pop() {
                        if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
                        return this.stack.pop();
                    }
                    copy(e1) {
                        if (this.stack.length + e1 >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        const t = this.stack;
                        for(let a = t.length - e1, r = e1 - 1; r >= 0; r--, a++)t.push(t[a]);
                    }
                    index(e1) {
                        this.push(this.stack[this.stack.length - e1 - 1]);
                    }
                    roll(e1, t) {
                        const a = this.stack, r = a.length - e1, n = a.length - 1, i = r + (t - Math.floor(t / e1) * e1);
                        for(let e1 = r, t = n; e1 < t; e1++, t--){
                            const r = a[e1];
                            a[e1] = a[t];
                            a[t] = r;
                        }
                        for(let e1 = r, t = i - 1; e1 < t; e1++, t--){
                            const r = a[e1];
                            a[e1] = a[t];
                            a[t] = r;
                        }
                        for(let e1 = i, t = n; e1 < t; e1++, t--){
                            const r = a[e1];
                            a[e1] = a[t];
                            a[t] = r;
                        }
                    }
                }
                class PostScriptEvaluator {
                    constructor(e1){
                        this.operators = e1;
                    }
                    execute(e1) {
                        const t = new PostScriptStack(e1);
                        let a = 0;
                        const r = this.operators, i = r.length;
                        let s, o, c;
                        for(; a < i;){
                            s = r[a++];
                            if ("number" != typeof s) switch(s){
                                case "jz":
                                    c = t.pop();
                                    o = t.pop();
                                    o || (a = c);
                                    break;
                                case "j":
                                    o = t.pop();
                                    a = o;
                                    break;
                                case "abs":
                                    o = t.pop();
                                    t.push(Math.abs(o));
                                    break;
                                case "add":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o + c);
                                    break;
                                case "and":
                                    c = t.pop();
                                    o = t.pop();
                                    "boolean" == typeof o && "boolean" == typeof c ? t.push(o && c) : t.push(o & c);
                                    break;
                                case "atan":
                                    c = t.pop();
                                    o = t.pop();
                                    o = Math.atan2(o, c) / Math.PI * 180;
                                    o < 0 && (o += 360);
                                    t.push(o);
                                    break;
                                case "bitshift":
                                    c = t.pop();
                                    o = t.pop();
                                    o > 0 ? t.push(o << c) : t.push(o >> c);
                                    break;
                                case "ceiling":
                                    o = t.pop();
                                    t.push(Math.ceil(o));
                                    break;
                                case "copy":
                                    o = t.pop();
                                    t.copy(o);
                                    break;
                                case "cos":
                                    o = t.pop();
                                    t.push(Math.cos(o % 360 / 180 * Math.PI));
                                    break;
                                case "cvi":
                                    o = 0 | t.pop();
                                    t.push(o);
                                    break;
                                case "cvr":
                                    break;
                                case "div":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o / c);
                                    break;
                                case "dup":
                                    t.copy(1);
                                    break;
                                case "eq":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o === c);
                                    break;
                                case "exch":
                                    t.roll(2, 1);
                                    break;
                                case "exp":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o ** c);
                                    break;
                                case "false":
                                    t.push(!1);
                                    break;
                                case "floor":
                                    o = t.pop();
                                    t.push(Math.floor(o));
                                    break;
                                case "ge":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o >= c);
                                    break;
                                case "gt":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o > c);
                                    break;
                                case "idiv":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o / c | 0);
                                    break;
                                case "index":
                                    o = t.pop();
                                    t.index(o);
                                    break;
                                case "le":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o <= c);
                                    break;
                                case "ln":
                                    o = t.pop();
                                    t.push(Math.log(o));
                                    break;
                                case "log":
                                    o = t.pop();
                                    t.push(Math.log10(o));
                                    break;
                                case "lt":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o < c);
                                    break;
                                case "mod":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o % c);
                                    break;
                                case "mul":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o * c);
                                    break;
                                case "ne":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o !== c);
                                    break;
                                case "neg":
                                    o = t.pop();
                                    t.push(-o);
                                    break;
                                case "not":
                                    o = t.pop();
                                    "boolean" == typeof o ? t.push(!o) : t.push(~o);
                                    break;
                                case "or":
                                    c = t.pop();
                                    o = t.pop();
                                    "boolean" == typeof o && "boolean" == typeof c ? t.push(o || c) : t.push(o | c);
                                    break;
                                case "pop":
                                    t.pop();
                                    break;
                                case "roll":
                                    c = t.pop();
                                    o = t.pop();
                                    t.roll(o, c);
                                    break;
                                case "round":
                                    o = t.pop();
                                    t.push(Math.round(o));
                                    break;
                                case "sin":
                                    o = t.pop();
                                    t.push(Math.sin(o % 360 / 180 * Math.PI));
                                    break;
                                case "sqrt":
                                    o = t.pop();
                                    t.push(Math.sqrt(o));
                                    break;
                                case "sub":
                                    c = t.pop();
                                    o = t.pop();
                                    t.push(o - c);
                                    break;
                                case "true":
                                    t.push(!0);
                                    break;
                                case "truncate":
                                    o = t.pop();
                                    o = o < 0 ? Math.ceil(o) : Math.floor(o);
                                    t.push(o);
                                    break;
                                case "xor":
                                    c = t.pop();
                                    o = t.pop();
                                    "boolean" == typeof o && "boolean" == typeof c ? t.push(o !== c) : t.push(o ^ c);
                                    break;
                                default:
                                    throw new n.FormatError(`Unknown operator ${s}`);
                            }
                            else t.push(s);
                        }
                        return t.stack;
                    }
                }
                t.PostScriptEvaluator = PostScriptEvaluator;
                class AstNode {
                    constructor(e1){
                        this.type = e1;
                    }
                    visit(e1) {
                        (0, n.unreachable)("abstract method");
                    }
                }
                class AstArgument extends AstNode {
                    constructor(e1, t, a){
                        super("args");
                        this.index = e1;
                        this.min = t;
                        this.max = a;
                    }
                    visit(e1) {
                        e1.visitArgument(this);
                    }
                }
                class AstLiteral extends AstNode {
                    constructor(e1){
                        super("literal");
                        this.number = e1;
                        this.min = e1;
                        this.max = e1;
                    }
                    visit(e1) {
                        e1.visitLiteral(this);
                    }
                }
                class AstBinaryOperation extends AstNode {
                    constructor(e1, t, a, r, n){
                        super("binary");
                        this.op = e1;
                        this.arg1 = t;
                        this.arg2 = a;
                        this.min = r;
                        this.max = n;
                    }
                    visit(e1) {
                        e1.visitBinaryOperation(this);
                    }
                }
                class AstMin extends AstNode {
                    constructor(e1, t){
                        super("max");
                        this.arg = e1;
                        this.min = e1.min;
                        this.max = t;
                    }
                    visit(e1) {
                        e1.visitMin(this);
                    }
                }
                class AstVariable extends AstNode {
                    constructor(e1, t, a){
                        super("var");
                        this.index = e1;
                        this.min = t;
                        this.max = a;
                    }
                    visit(e1) {
                        e1.visitVariable(this);
                    }
                }
                class AstVariableDefinition extends AstNode {
                    constructor(e1, t){
                        super("definition");
                        this.variable = e1;
                        this.arg = t;
                    }
                    visit(e1) {
                        e1.visitVariableDefinition(this);
                    }
                }
                class ExpressionBuilderVisitor {
                    constructor(){
                        this.parts = [];
                    }
                    visitArgument(e1) {
                        this.parts.push("Math.max(", e1.min, ", Math.min(", e1.max, ", src[srcOffset + ", e1.index, "]))");
                    }
                    visitVariable(e1) {
                        this.parts.push("v", e1.index);
                    }
                    visitLiteral(e1) {
                        this.parts.push(e1.number);
                    }
                    visitBinaryOperation(e1) {
                        this.parts.push("(");
                        e1.arg1.visit(this);
                        this.parts.push(" ", e1.op, " ");
                        e1.arg2.visit(this);
                        this.parts.push(")");
                    }
                    visitVariableDefinition(e1) {
                        this.parts.push("var ");
                        e1.variable.visit(this);
                        this.parts.push(" = ");
                        e1.arg.visit(this);
                        this.parts.push(";");
                    }
                    visitMin(e1) {
                        this.parts.push("Math.min(");
                        e1.arg.visit(this);
                        this.parts.push(", ", e1.max, ")");
                    }
                    toString() {
                        return this.parts.join("");
                    }
                }
                function buildAddOperation(e1, t) {
                    return "literal" === t.type && 0 === t.number ? e1 : "literal" === e1.type && 0 === e1.number ? t : "literal" === t.type && "literal" === e1.type ? new AstLiteral(e1.number + t.number) : new AstBinaryOperation("+", e1, t, e1.min + t.min, e1.max + t.max);
                }
                function buildMulOperation(e1, t) {
                    if ("literal" === t.type) {
                        if (0 === t.number) return new AstLiteral(0);
                        if (1 === t.number) return e1;
                        if ("literal" === e1.type) return new AstLiteral(e1.number * t.number);
                    }
                    if ("literal" === e1.type) {
                        if (0 === e1.number) return new AstLiteral(0);
                        if (1 === e1.number) return t;
                    }
                    const a = Math.min(e1.min * t.min, e1.min * t.max, e1.max * t.min, e1.max * t.max), r = Math.max(e1.min * t.min, e1.min * t.max, e1.max * t.min, e1.max * t.max);
                    return new AstBinaryOperation("*", e1, t, a, r);
                }
                function buildSubOperation(e1, t) {
                    if ("literal" === t.type) {
                        if (0 === t.number) return e1;
                        if ("literal" === e1.type) return new AstLiteral(e1.number - t.number);
                    }
                    return "binary" === t.type && "-" === t.op && "literal" === e1.type && 1 === e1.number && "literal" === t.arg1.type && 1 === t.arg1.number ? t.arg2 : new AstBinaryOperation("-", e1, t, e1.min - t.max, e1.max - t.min);
                }
                function buildMinOperation(e1, t) {
                    return e1.min >= t ? new AstLiteral(t) : e1.max <= t ? e1 : new AstMin(e1, t);
                }
                class PostScriptCompiler {
                    compile(e1, t, a) {
                        const r = [], n = [], i = t.length >> 1, s = a.length >> 1;
                        let o, c, l, h, u, d, f, g, p = 0;
                        for(let e1 = 0; e1 < i; e1++)r.push(new AstArgument(e1, t[2 * e1], t[2 * e1 + 1]));
                        for(let t = 0, a = e1.length; t < a; t++){
                            g = e1[t];
                            if ("number" != typeof g) switch(g){
                                case "add":
                                    if (r.length < 2) return null;
                                    h = r.pop();
                                    l = r.pop();
                                    r.push(buildAddOperation(l, h));
                                    break;
                                case "cvr":
                                    if (r.length < 1) return null;
                                    break;
                                case "mul":
                                    if (r.length < 2) return null;
                                    h = r.pop();
                                    l = r.pop();
                                    r.push(buildMulOperation(l, h));
                                    break;
                                case "sub":
                                    if (r.length < 2) return null;
                                    h = r.pop();
                                    l = r.pop();
                                    r.push(buildSubOperation(l, h));
                                    break;
                                case "exch":
                                    if (r.length < 2) return null;
                                    u = r.pop();
                                    d = r.pop();
                                    r.push(u, d);
                                    break;
                                case "pop":
                                    if (r.length < 1) return null;
                                    r.pop();
                                    break;
                                case "index":
                                    if (r.length < 1) return null;
                                    l = r.pop();
                                    if ("literal" !== l.type) return null;
                                    o = l.number;
                                    if (o < 0 || !Number.isInteger(o) || r.length < o) return null;
                                    u = r[r.length - o - 1];
                                    if ("literal" === u.type || "var" === u.type) {
                                        r.push(u);
                                        break;
                                    }
                                    f = new AstVariable(p++, u.min, u.max);
                                    r[r.length - o - 1] = f;
                                    r.push(f);
                                    n.push(new AstVariableDefinition(f, u));
                                    break;
                                case "dup":
                                    if (r.length < 1) return null;
                                    if ("number" == typeof e1[t + 1] && "gt" === e1[t + 2] && e1[t + 3] === t + 7 && "jz" === e1[t + 4] && "pop" === e1[t + 5] && e1[t + 6] === e1[t + 1]) {
                                        l = r.pop();
                                        r.push(buildMinOperation(l, e1[t + 1]));
                                        t += 6;
                                        break;
                                    }
                                    u = r.at(-1);
                                    if ("literal" === u.type || "var" === u.type) {
                                        r.push(u);
                                        break;
                                    }
                                    f = new AstVariable(p++, u.min, u.max);
                                    r[r.length - 1] = f;
                                    r.push(f);
                                    n.push(new AstVariableDefinition(f, u));
                                    break;
                                case "roll":
                                    if (r.length < 2) return null;
                                    h = r.pop();
                                    l = r.pop();
                                    if ("literal" !== h.type || "literal" !== l.type) return null;
                                    c = h.number;
                                    o = l.number;
                                    if (o <= 0 || !Number.isInteger(o) || !Number.isInteger(c) || r.length < o) return null;
                                    c = (c % o + o) % o;
                                    if (0 === c) break;
                                    r.push(...r.splice(r.length - o, o - c));
                                    break;
                                default:
                                    return null;
                            }
                            else r.push(new AstLiteral(g));
                        }
                        if (r.length !== s) return null;
                        const m = [];
                        for (const e1 of n){
                            const t = new ExpressionBuilderVisitor;
                            e1.visit(t);
                            m.push(t.toString());
                        }
                        for(let e1 = 0, t = r.length; e1 < t; e1++){
                            const t = r[e1], n = new ExpressionBuilderVisitor;
                            t.visit(n);
                            const i = a[2 * e1], s = a[2 * e1 + 1], o = [
                                n.toString()
                            ];
                            if (i > t.min) {
                                o.unshift("Math.max(", i, ", ");
                                o.push(")");
                            }
                            if (s < t.max) {
                                o.unshift("Math.min(", s, ", ");
                                o.push(")");
                            }
                            o.unshift("dest[destOffset + ", e1, "] = ");
                            o.push(";");
                            m.push(o.join(""));
                        }
                        return m.join("\n");
                    }
                }
                t.PostScriptCompiler = PostScriptCompiler;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PostScriptParser = t.PostScriptLexer = void 0;
                var r = a(2), n = a(4), i = a(3);
                t.PostScriptParser = class PostScriptParser {
                    constructor(e1){
                        this.lexer = e1;
                        this.operators = [];
                        this.token = null;
                        this.prev = null;
                    }
                    nextToken() {
                        this.prev = this.token;
                        this.token = this.lexer.getToken();
                    }
                    accept(e1) {
                        if (this.token.type === e1) {
                            this.nextToken();
                            return !0;
                        }
                        return !1;
                    }
                    expect(e1) {
                        if (this.accept(e1)) return !0;
                        throw new r.FormatError(`Unexpected symbol: found ${this.token.type} expected ${e1}.`);
                    }
                    parse() {
                        this.nextToken();
                        this.expect(s.LBRACE);
                        this.parseBlock();
                        this.expect(s.RBRACE);
                        return this.operators;
                    }
                    parseBlock() {
                        for(;;)if (this.accept(s.NUMBER)) this.operators.push(this.prev.value);
                        else if (this.accept(s.OPERATOR)) this.operators.push(this.prev.value);
                        else {
                            if (!this.accept(s.LBRACE)) return;
                            this.parseCondition();
                        }
                    }
                    parseCondition() {
                        const e1 = this.operators.length;
                        this.operators.push(null, null);
                        this.parseBlock();
                        this.expect(s.RBRACE);
                        if (this.accept(s.IF)) {
                            this.operators[e1] = this.operators.length;
                            this.operators[e1 + 1] = "jz";
                        } else {
                            if (!this.accept(s.LBRACE)) throw new r.FormatError("PS Function: error parsing conditional.");
                            {
                                const t = this.operators.length;
                                this.operators.push(null, null);
                                const a = this.operators.length;
                                this.parseBlock();
                                this.expect(s.RBRACE);
                                this.expect(s.IFELSE);
                                this.operators[t] = this.operators.length;
                                this.operators[t + 1] = "j";
                                this.operators[e1] = a;
                                this.operators[e1 + 1] = "jz";
                            }
                        }
                    }
                };
                const s = {
                    LBRACE: 0,
                    RBRACE: 1,
                    NUMBER: 2,
                    OPERATOR: 3,
                    IF: 4,
                    IFELSE: 5
                };
                class PostScriptToken {
                    static get opCache() {
                        return (0, r.shadow)(this, "opCache", Object.create(null));
                    }
                    constructor(e1, t){
                        this.type = e1;
                        this.value = t;
                    }
                    static getOperator(e1) {
                        return PostScriptToken.opCache[e1] ||= new PostScriptToken(s.OPERATOR, e1);
                    }
                    static get LBRACE() {
                        return (0, r.shadow)(this, "LBRACE", new PostScriptToken(s.LBRACE, "{"));
                    }
                    static get RBRACE() {
                        return (0, r.shadow)(this, "RBRACE", new PostScriptToken(s.RBRACE, "}"));
                    }
                    static get IF() {
                        return (0, r.shadow)(this, "IF", new PostScriptToken(s.IF, "IF"));
                    }
                    static get IFELSE() {
                        return (0, r.shadow)(this, "IFELSE", new PostScriptToken(s.IFELSE, "IFELSE"));
                    }
                }
                t.PostScriptLexer = class PostScriptLexer {
                    constructor(e1){
                        this.stream = e1;
                        this.nextChar();
                        this.strBuf = [];
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let e1 = !1, t = this.currentChar;
                        for(;;){
                            if (t < 0) return n.EOF;
                            if (e1) 10 !== t && 13 !== t || (e1 = !1);
                            else if (37 === t) e1 = !0;
                            else if (!(0, i.isWhiteSpace)(t)) break;
                            t = this.nextChar();
                        }
                        switch(0 | t){
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 43:
                            case 45:
                            case 46:
                                return new PostScriptToken(s.NUMBER, this.getNumber());
                            case 123:
                                this.nextChar();
                                return PostScriptToken.LBRACE;
                            case 125:
                                this.nextChar();
                                return PostScriptToken.RBRACE;
                        }
                        const a = this.strBuf;
                        a.length = 0;
                        a[0] = String.fromCharCode(t);
                        for(; (t = this.nextChar()) >= 0 && (t >= 65 && t <= 90 || t >= 97 && t <= 122);)a.push(String.fromCharCode(t));
                        const r = a.join("");
                        switch(r.toLowerCase()){
                            case "if":
                                return PostScriptToken.IF;
                            case "ifelse":
                                return PostScriptToken.IFELSE;
                            default:
                                return PostScriptToken.getOperator(r);
                        }
                    }
                    getNumber() {
                        let e1 = this.currentChar;
                        const t = this.strBuf;
                        t.length = 0;
                        t[0] = String.fromCharCode(e1);
                        for(; (e1 = this.nextChar()) >= 0 && (e1 >= 48 && e1 <= 57 || 45 === e1 || 46 === e1);)t.push(String.fromCharCode(e1));
                        const a = parseFloat(t.join(""));
                        if (isNaN(a)) throw new r.FormatError(`Invalid floating point number: ${a}`);
                        return a;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.RegionalImageCache = t.LocalTilingPatternCache = t.LocalImageCache = t.LocalGStateCache = t.LocalFunctionCache = t.LocalColorSpaceCache = t.GlobalImageCache = void 0;
                var r = a(2), n = a(4);
                class BaseLocalCache {
                    constructor(e1){
                        this.constructor === BaseLocalCache && (0, r.unreachable)("Cannot initialize BaseLocalCache.");
                        this._onlyRefs = !0 === e1?.onlyRefs;
                        if (!this._onlyRefs) {
                            this._nameRefMap = new Map;
                            this._imageMap = new Map;
                        }
                        this._imageCache = new n.RefSetCache;
                    }
                    getByName(e1) {
                        this._onlyRefs && (0, r.unreachable)("Should not call `getByName` method.");
                        const t = this._nameRefMap.get(e1);
                        return t ? this.getByRef(t) : this._imageMap.get(e1) || null;
                    }
                    getByRef(e1) {
                        return this._imageCache.get(e1) || null;
                    }
                    set(e1, t, a) {
                        (0, r.unreachable)("Abstract method `set` called.");
                    }
                }
                t.LocalImageCache = class LocalImageCache extends BaseLocalCache {
                    set(e1, t = null, a) {
                        if ("string" != typeof e1) throw new Error('LocalImageCache.set - expected "name" argument.');
                        if (t) {
                            if (this._imageCache.has(t)) return;
                            this._nameRefMap.set(e1, t);
                            this._imageCache.put(t, a);
                        } else this._imageMap.has(e1) || this._imageMap.set(e1, a);
                    }
                };
                t.LocalColorSpaceCache = class LocalColorSpaceCache extends BaseLocalCache {
                    set(e1 = null, t = null, a) {
                        if ("string" != typeof e1 && !t) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                        if (t) {
                            if (this._imageCache.has(t)) return;
                            null !== e1 && this._nameRefMap.set(e1, t);
                            this._imageCache.put(t, a);
                        } else this._imageMap.has(e1) || this._imageMap.set(e1, a);
                    }
                };
                t.LocalFunctionCache = class LocalFunctionCache extends BaseLocalCache {
                    constructor(e1){
                        super({
                            onlyRefs: !0
                        });
                    }
                    set(e1 = null, t, a) {
                        if (!t) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                        this._imageCache.has(t) || this._imageCache.put(t, a);
                    }
                };
                t.LocalGStateCache = class LocalGStateCache extends BaseLocalCache {
                    set(e1, t = null, a) {
                        if ("string" != typeof e1) throw new Error('LocalGStateCache.set - expected "name" argument.');
                        if (t) {
                            if (this._imageCache.has(t)) return;
                            this._nameRefMap.set(e1, t);
                            this._imageCache.put(t, a);
                        } else this._imageMap.has(e1) || this._imageMap.set(e1, a);
                    }
                };
                t.LocalTilingPatternCache = class LocalTilingPatternCache extends BaseLocalCache {
                    constructor(e1){
                        super({
                            onlyRefs: !0
                        });
                    }
                    set(e1 = null, t, a) {
                        if (!t) throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
                        this._imageCache.has(t) || this._imageCache.put(t, a);
                    }
                };
                t.RegionalImageCache = class RegionalImageCache extends BaseLocalCache {
                    constructor(e1){
                        super({
                            onlyRefs: !0
                        });
                    }
                    set(e1 = null, t, a) {
                        if (!t) throw new Error('RegionalImageCache.set - expected "ref" argument.');
                        this._imageCache.has(t) || this._imageCache.put(t, a);
                    }
                };
                class GlobalImageCache {
                    static NUM_PAGES_THRESHOLD = 2;
                    static MIN_IMAGES_TO_CACHE = 10;
                    static MAX_BYTE_SIZE = 5 * r.MAX_IMAGE_SIZE_TO_CACHE;
                    constructor(){
                        this._refCache = new n.RefSetCache;
                        this._imageCache = new n.RefSetCache;
                    }
                    get _byteSize() {
                        let e1 = 0;
                        for (const t of this._imageCache)e1 += t.byteSize;
                        return e1;
                    }
                    get _cacheLimitReached() {
                        return !(this._imageCache.size < GlobalImageCache.MIN_IMAGES_TO_CACHE) && !(this._byteSize < GlobalImageCache.MAX_BYTE_SIZE);
                    }
                    shouldCache(e1, t) {
                        let a = this._refCache.get(e1);
                        if (!a) {
                            a = new Set;
                            this._refCache.put(e1, a);
                        }
                        a.add(t);
                        return !(a.size < GlobalImageCache.NUM_PAGES_THRESHOLD) && !(!this._imageCache.has(e1) && this._cacheLimitReached);
                    }
                    addByteSize(e1, t) {
                        const a = this._imageCache.get(e1);
                        a && (a.byteSize || (a.byteSize = t));
                    }
                    getData(e1, t) {
                        const a = this._refCache.get(e1);
                        if (!a) return null;
                        if (a.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return null;
                        const r = this._imageCache.get(e1);
                        if (!r) return null;
                        a.add(t);
                        return r;
                    }
                    setData(e1, t) {
                        if (!this._refCache.has(e1)) throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
                        this._imageCache.has(e1) || (this._cacheLimitReached ? (0, r.warn)("GlobalImageCache.setData - cache limit reached.") : this._imageCache.put(e1, t));
                    }
                    clear(e1 = !1) {
                        e1 || this._refCache.clear();
                        this._imageCache.clear();
                    }
                }
                t.GlobalImageCache = GlobalImageCache;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.bidi = function bidi(e1, t = -1, a = !1) {
                    let c = !0;
                    const l = e1.length;
                    if (0 === l || a) return createBidiText(e1, c, a);
                    s.length = l;
                    o.length = l;
                    let h, u, d = 0;
                    for(h = 0; h < l; ++h){
                        s[h] = e1.charAt(h);
                        const t = e1.charCodeAt(h);
                        let a = "L";
                        if (t <= 255) a = n[t];
                        else if (1424 <= t && t <= 1524) a = "R";
                        else if (1536 <= t && t <= 1791) {
                            a = i[255 & t];
                            a || (0, r.warn)("Bidi: invalid Unicode character " + t.toString(16));
                        } else (1792 <= t && t <= 2220 || 64336 <= t && t <= 65023 || 65136 <= t && t <= 65279) && (a = "AL");
                        "R" !== a && "AL" !== a && "AN" !== a || d++;
                        o[h] = a;
                    }
                    if (0 === d) {
                        c = !0;
                        return createBidiText(e1, c);
                    }
                    if (-1 === t) {
                        if (d / l < .3 && l > 4) {
                            c = !0;
                            t = 0;
                        } else {
                            c = !1;
                            t = 1;
                        }
                    }
                    const f = [];
                    for(h = 0; h < l; ++h)f[h] = t;
                    const g = isOdd(t) ? "R" : "L", p = g, m = p;
                    let b, y = p;
                    for(h = 0; h < l; ++h)"NSM" === o[h] ? o[h] = y : y = o[h];
                    y = p;
                    for(h = 0; h < l; ++h){
                        b = o[h];
                        "EN" === b ? o[h] = "AL" === y ? "AN" : "EN" : "R" !== b && "L" !== b && "AL" !== b || (y = b);
                    }
                    for(h = 0; h < l; ++h){
                        b = o[h];
                        "AL" === b && (o[h] = "R");
                    }
                    for(h = 1; h < l - 1; ++h){
                        "ES" === o[h] && "EN" === o[h - 1] && "EN" === o[h + 1] && (o[h] = "EN");
                        "CS" !== o[h] || "EN" !== o[h - 1] && "AN" !== o[h - 1] || o[h + 1] !== o[h - 1] || (o[h] = o[h - 1]);
                    }
                    for(h = 0; h < l; ++h)if ("EN" === o[h]) {
                        for(let e1 = h - 1; e1 >= 0 && "ET" === o[e1]; --e1)o[e1] = "EN";
                        for(let e1 = h + 1; e1 < l && "ET" === o[e1]; ++e1)o[e1] = "EN";
                    }
                    for(h = 0; h < l; ++h){
                        b = o[h];
                        "WS" !== b && "ES" !== b && "ET" !== b && "CS" !== b || (o[h] = "ON");
                    }
                    y = p;
                    for(h = 0; h < l; ++h){
                        b = o[h];
                        "EN" === b ? o[h] = "L" === y ? "L" : "EN" : "R" !== b && "L" !== b || (y = b);
                    }
                    for(h = 0; h < l; ++h)if ("ON" === o[h]) {
                        const e1 = findUnequal(o, h + 1, "ON");
                        let t = p;
                        h > 0 && (t = o[h - 1]);
                        let a = m;
                        e1 + 1 < l && (a = o[e1 + 1]);
                        "L" !== t && (t = "R");
                        "L" !== a && (a = "R");
                        t === a && setValues(o, h, e1, t);
                        h = e1 - 1;
                    }
                    for(h = 0; h < l; ++h)"ON" === o[h] && (o[h] = g);
                    for(h = 0; h < l; ++h){
                        b = o[h];
                        isEven(f[h]) ? "R" === b ? f[h] += 1 : "AN" !== b && "EN" !== b || (f[h] += 2) : "L" !== b && "AN" !== b && "EN" !== b || (f[h] += 1);
                    }
                    let w, S = -1, x = 99;
                    for(h = 0, u = f.length; h < u; ++h){
                        w = f[h];
                        S < w && (S = w);
                        x > w && isOdd(w) && (x = w);
                    }
                    for(w = S; w >= x; --w){
                        let e1 = -1;
                        for(h = 0, u = f.length; h < u; ++h)if (f[h] < w) {
                            if (e1 >= 0) {
                                reverseValues(s, e1, h);
                                e1 = -1;
                            }
                        } else e1 < 0 && (e1 = h);
                        e1 >= 0 && reverseValues(s, e1, f.length);
                    }
                    for(h = 0, u = s.length; h < u; ++h){
                        const e1 = s[h];
                        "<" !== e1 && ">" !== e1 || (s[h] = "");
                    }
                    return createBidiText(s.join(""), c);
                };
                var r = a(2);
                const n = [
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "S",
                    "B",
                    "S",
                    "WS",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "B",
                    "B",
                    "S",
                    "WS",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ES",
                    "CS",
                    "ES",
                    "CS",
                    "CS",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "CS",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "CS",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "BN",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "EN",
                    "EN",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "EN",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L"
                ], i = [
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ON",
                    "ON",
                    "AL",
                    "ET",
                    "ET",
                    "AL",
                    "CS",
                    "AL",
                    "ON",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ET",
                    "AN",
                    "AN",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL"
                ];
                function isOdd(e1) {
                    return 0 != (1 & e1);
                }
                function isEven(e1) {
                    return 0 == (1 & e1);
                }
                function findUnequal(e1, t, a) {
                    let r, n;
                    for(r = t, n = e1.length; r < n; ++r)if (e1[r] !== a) return r;
                    return r;
                }
                function setValues(e1, t, a, r) {
                    for(let n = t; n < a; ++n)e1[n] = r;
                }
                function reverseValues(e1, t, a) {
                    for(let r = t, n = a - 1; r < n; ++r, --n){
                        const t = e1[r];
                        e1[r] = e1[n];
                        e1[n] = t;
                    }
                }
                function createBidiText(e1, t, a = !1) {
                    let r = "ltr";
                    a ? r = "ttb" : t || (r = "rtl");
                    return {
                        str: e1,
                        dir: r
                    };
                }
                const s = [], o = [];
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.getFontSubstitution = function getFontSubstitution(e1, t, a, u, d) {
                    const f = u = (0, r.normalizeFontName)(u);
                    let g = e1.get(f);
                    if (g) return g;
                    let p = l.get(u);
                    if (!p) {
                        for (const [e1, t] of h)if (u.startsWith(e1)) {
                            u = `${t}${u.substring(e1.length)}`;
                            p = l.get(u);
                            break;
                        }
                    }
                    let m = !1;
                    if (!p) {
                        p = l.get(d);
                        m = !0;
                    }
                    const b = `${t.getDocId()}_s${t.createFontId()}`;
                    if (!p) {
                        if (!(0, n.validateFontName)(u)) {
                            e1.set(f, null);
                            return null;
                        }
                        const t = /bold/gi.test(u), a = /oblique|italic/gi.test(u);
                        g = {
                            css: b,
                            guessFallback: !0,
                            loadedName: b,
                            baseFontName: u,
                            src: `local(${u})`,
                            style: t && a && c || t && s || a && o || i
                        };
                        e1.set(f, g);
                        return g;
                    }
                    const y = [];
                    m && (0, n.validateFontName)(u) && y.push(`local(${u})`);
                    const { style: w, ultimate: S } = generateFont(p, y, a), x = null === S;
                    g = {
                        css: `${b}${x ? "" : `,${S}`}`,
                        guessFallback: x,
                        loadedName: b,
                        baseFontName: u,
                        src: y.join(","),
                        style: w
                    };
                    e1.set(f, g);
                    return g;
                };
                var r = a(38), n = a(3);
                const i = {
                    style: "normal",
                    weight: "normal"
                }, s = {
                    style: "normal",
                    weight: "bold"
                }, o = {
                    style: "italic",
                    weight: "normal"
                }, c = {
                    style: "italic",
                    weight: "bold"
                }, l = new Map([
                    [
                        "Times-Roman",
                        {
                            local: [
                                "Times New Roman",
                                "Times-Roman",
                                "Times",
                                "Liberation Serif",
                                "Nimbus Roman",
                                "Nimbus Roman L",
                                "Tinos",
                                "Thorndale",
                                "TeX Gyre Termes",
                                "FreeSerif",
                                "DejaVu Serif",
                                "Bitstream Vera Serif",
                                "Ubuntu"
                            ],
                            style: i,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Bold",
                        {
                            alias: "Times-Roman",
                            style: s,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Italic",
                        {
                            alias: "Times-Roman",
                            style: o,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-BoldItalic",
                        {
                            alias: "Times-Roman",
                            style: c,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Helvetica",
                        {
                            local: [
                                "Helvetica",
                                "Helvetica Neue",
                                "Arial",
                                "Arial Nova",
                                "Liberation Sans",
                                "Arimo",
                                "Nimbus Sans",
                                "Nimbus Sans L",
                                "A030",
                                "TeX Gyre Heros",
                                "FreeSans",
                                "DejaVu Sans",
                                "Albany",
                                "Bitstream Vera Sans",
                                "Arial Unicode MS",
                                "Microsoft Sans Serif",
                                "Apple Symbols",
                                "Cantarell"
                            ],
                            path: "LiberationSans-Regular.ttf",
                            style: i,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Bold",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Bold.ttf",
                            style: s,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Oblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Italic.ttf",
                            style: o,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-BoldOblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-BoldItalic.ttf",
                            style: c,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Courier",
                        {
                            local: [
                                "Courier",
                                "Courier New",
                                "Liberation Mono",
                                "Nimbus Mono",
                                "Nimbus Mono L",
                                "Cousine",
                                "Cumberland",
                                "TeX Gyre Cursor",
                                "FreeMono"
                            ],
                            style: i,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Bold",
                        {
                            alias: "Courier",
                            style: s,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Oblique",
                        {
                            alias: "Courier",
                            style: o,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-BoldOblique",
                        {
                            alias: "Courier",
                            style: c,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "ArialBlack",
                        {
                            local: [
                                "Arial Black"
                            ],
                            style: {
                                style: "normal",
                                weight: "900"
                            },
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialBlack-Bold",
                        {
                            alias: "ArialBlack"
                        }
                    ],
                    [
                        "ArialBlack-Italic",
                        {
                            alias: "ArialBlack",
                            style: {
                                style: "italic",
                                weight: "900"
                            },
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "ArialBlack-BoldItalic",
                        {
                            alias: "ArialBlack-Italic"
                        }
                    ],
                    [
                        "ArialNarrow",
                        {
                            local: [
                                "Arial Narrow",
                                "Liberation Sans Narrow",
                                "Helvetica Condensed",
                                "Nimbus Sans Narrow",
                                "TeX Gyre Heros Cn"
                            ],
                            style: i,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "ArialNarrow-Bold",
                        {
                            alias: "ArialNarrow",
                            style: s,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialNarrow-Italic",
                        {
                            alias: "ArialNarrow",
                            style: o,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "ArialNarrow-BoldItalic",
                        {
                            alias: "ArialNarrow",
                            style: c,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Calibri",
                        {
                            local: [
                                "Calibri",
                                "Carlito"
                            ],
                            style: i,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "Calibri-Bold",
                        {
                            alias: "Calibri",
                            style: s,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "Calibri-Italic",
                        {
                            alias: "Calibri",
                            style: o,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "Calibri-BoldItalic",
                        {
                            alias: "Calibri",
                            style: c,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Wingdings",
                        {
                            local: [
                                "Wingdings",
                                "URW Dingbats"
                            ],
                            style: i
                        }
                    ],
                    [
                        "Wingdings-Regular",
                        {
                            alias: "Wingdings"
                        }
                    ],
                    [
                        "Wingdings-Bold",
                        {
                            alias: "Wingdings"
                        }
                    ]
                ]), h = new Map([
                    [
                        "Arial-Black",
                        "ArialBlack"
                    ]
                ]);
                function generateFont({ alias: e1, local: t, path: a, fallback: r, style: n, ultimate: i }, h, u, d = !0, f = !0, g = "") {
                    const p = {
                        style: null,
                        ultimate: null
                    };
                    if (t) {
                        const e1 = g ? ` ${g}` : "";
                        for (const a of t)h.push(`local(${a}${e1})`);
                    }
                    if (e1) {
                        const t = l.get(e1), i = g || function getStyleToAppend(e1) {
                            switch(e1){
                                case s:
                                    return "Bold";
                                case o:
                                    return "Italic";
                                case c:
                                    return "Bold Italic";
                                default:
                                    if ("bold" === e1?.weight) return "Bold";
                                    if ("italic" === e1?.style) return "Italic";
                            }
                            return "";
                        }(n);
                        Object.assign(p, generateFont(t, h, u, d && !r, f && !a, i));
                    }
                    n && (p.style = n);
                    i && (p.ultimate = i);
                    if (d && r) {
                        const e1 = l.get(r), { ultimate: t } = generateFont(e1, h, u, d, f && !a, g);
                        p.ultimate ||= t;
                    }
                    f && a && u && h.push(`url(${u}${a})`);
                    return p;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ImageResizer = void 0;
                var r = a(2);
                class ImageResizer {
                    constructor(e1, t){
                        this._imgData = e1;
                        this._isMask = t;
                    }
                    static needsToBeResized(e1, t) {
                        if (e1 <= this._goodSquareLength && t <= this._goodSquareLength) return !1;
                        const { MAX_DIM: a } = this;
                        if (e1 > a || t > a) return !0;
                        const r = e1 * t;
                        if (this._hasMaxArea) return r > this.MAX_AREA;
                        if (r < this._goodSquareLength ** 2) return !1;
                        if (this._areGoodDims(e1, t)) {
                            this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(e1 * t)));
                            return !1;
                        }
                        this._goodSquareLength = this._guessMax(this._goodSquareLength, a, 128, 0);
                        return r > (this.MAX_AREA = this._goodSquareLength ** 2);
                    }
                    static get MAX_DIM() {
                        return (0, r.shadow)(this, "MAX_DIM", this._guessMax(2048, 65537, 0, 1));
                    }
                    static get MAX_AREA() {
                        this._hasMaxArea = !0;
                        return (0, r.shadow)(this, "MAX_AREA", this._guessMax(ImageResizer._goodSquareLength, this.MAX_DIM, 128, 0) ** 2);
                    }
                    static set MAX_AREA(e1) {
                        if (e1 >= 0) {
                            this._hasMaxArea = !0;
                            (0, r.shadow)(this, "MAX_AREA", e1);
                        }
                    }
                    static setMaxArea(e1) {
                        this._hasMaxArea || (this.MAX_AREA = e1 >> 2);
                    }
                    static _areGoodDims(e1, t) {
                        try {
                            const a = new OffscreenCanvas(e1, t), r = a.getContext("2d");
                            r.fillRect(0, 0, 1, 1);
                            const n = r.getImageData(0, 0, 1, 1).data[3];
                            a.width = a.height = 1;
                            return 0 !== n;
                        } catch  {
                            return !1;
                        }
                    }
                    static _guessMax(e1, t, a, r) {
                        for(; e1 + a + 1 < t;){
                            const a = Math.floor((e1 + t) / 2), n = r || a;
                            this._areGoodDims(a, n) ? e1 = a : t = a;
                        }
                        return e1;
                    }
                    static async createImage(e1, t = !1) {
                        return new ImageResizer(e1, t)._createImage();
                    }
                    async _createImage() {
                        const e1 = this._encodeBMP(), t = new Blob([
                            e1.buffer
                        ], {
                            type: "image/bmp"
                        }), a = createImageBitmap(t), { MAX_AREA: r, MAX_DIM: n } = ImageResizer, { _imgData: i } = this, { width: s, height: o } = i, c = Math.max(s / n, o / n, Math.sqrt(s * o / r)), l = Math.max(c, 2), h = Math.round(10 * (c + 1.25)) / 10 / l, u = Math.floor(Math.log2(h)), d = new Array(u + 2).fill(2);
                        d[0] = l;
                        d.splice(-1, 1, h / (1 << u));
                        let f = s, g = o, p = await a;
                        for (const e1 of d){
                            const t = f, a = g;
                            f = Math.floor(f / e1) - 1;
                            g = Math.floor(g / e1) - 1;
                            const r = new OffscreenCanvas(f, g);
                            r.getContext("2d").drawImage(p, 0, 0, t, a, 0, 0, f, g);
                            p = r.transferToImageBitmap();
                        }
                        i.data = null;
                        i.bitmap = p;
                        i.width = f;
                        i.height = g;
                        return i;
                    }
                    _encodeBMP() {
                        const { width: e1, height: t, kind: a } = this._imgData;
                        let n, i = this._imgData.data, s = new Uint8Array(0), o = s, c = 0;
                        switch(a){
                            case r.ImageKind.GRAYSCALE_1BPP:
                                {
                                    n = 1;
                                    s = new Uint8Array(this._isMask ? [
                                        255,
                                        255,
                                        255,
                                        255,
                                        0,
                                        0,
                                        0,
                                        0
                                    ] : [
                                        0,
                                        0,
                                        0,
                                        0,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]);
                                    const a = e1 + 7 >> 3, r = a + 3 & -4;
                                    if (a !== r) {
                                        const e1 = new Uint8Array(r * t);
                                        let n = 0;
                                        for(let s = 0, o = t * a; s < o; s += a, n += r)e1.set(i.subarray(s, s + a), n);
                                        i = e1;
                                    }
                                    break;
                                }
                            case r.ImageKind.RGB_24BPP:
                                n = 24;
                                if (3 & e1) {
                                    const a = 3 * e1, r = a + 3 & -4, n = r - a, s = new Uint8Array(r * t);
                                    let o = 0;
                                    for(let e1 = 0, r = t * a; e1 < r; e1 += a){
                                        const t = i.subarray(e1, e1 + a);
                                        for(let e1 = 0; e1 < a; e1 += 3){
                                            s[o++] = t[e1 + 2];
                                            s[o++] = t[e1 + 1];
                                            s[o++] = t[e1];
                                        }
                                        o += n;
                                    }
                                    i = s;
                                } else for(let e1 = 0, t = i.length; e1 < t; e1 += 3){
                                    const t = i[e1];
                                    i[e1] = i[e1 + 2];
                                    i[e1 + 2] = t;
                                }
                                break;
                            case r.ImageKind.RGBA_32BPP:
                                n = 32;
                                c = 3;
                                o = new Uint8Array(68);
                                const a1 = new DataView(o.buffer);
                                if (r.FeatureTest.isLittleEndian) {
                                    a1.setUint32(0, 255, !0);
                                    a1.setUint32(4, 65280, !0);
                                    a1.setUint32(8, 16711680, !0);
                                    a1.setUint32(12, 4278190080, !0);
                                } else {
                                    a1.setUint32(0, 4278190080, !0);
                                    a1.setUint32(4, 16711680, !0);
                                    a1.setUint32(8, 65280, !0);
                                    a1.setUint32(12, 255, !0);
                                }
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        let l = 0;
                        const h = 40 + o.length, u = 14 + h + s.length + i.length, d = new Uint8Array(u), f = new DataView(d.buffer);
                        f.setUint16(l, 19778, !0);
                        l += 2;
                        f.setUint32(l, u, !0);
                        l += 4;
                        f.setUint32(l, 0, !0);
                        l += 4;
                        f.setUint32(l, 14 + h + s.length, !0);
                        l += 4;
                        f.setUint32(l, h, !0);
                        l += 4;
                        f.setInt32(l, e1, !0);
                        l += 4;
                        f.setInt32(l, -t, !0);
                        l += 4;
                        f.setUint16(l, 1, !0);
                        l += 2;
                        f.setUint16(l, n, !0);
                        l += 2;
                        f.setUint32(l, c, !0);
                        l += 4;
                        f.setUint32(l, 0, !0);
                        l += 4;
                        f.setInt32(l, 0, !0);
                        l += 4;
                        f.setInt32(l, 0, !0);
                        l += 4;
                        f.setUint32(l, s.length / 4, !0);
                        l += 4;
                        f.setUint32(l, 0, !0);
                        l += 4;
                        d.set(o, l);
                        l += o.length;
                        d.set(s, l);
                        l += s.length;
                        d.set(i, l);
                        return d;
                    }
                }
                t.ImageResizer = ImageResizer;
                ImageResizer._goodSquareLength = 2048;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.MurmurHash3_64 = void 0;
                var r = a(2);
                const n = 3285377520, i = 4294901760, s = 65535;
                t.MurmurHash3_64 = class MurmurHash3_64 {
                    constructor(e1){
                        this.h1 = e1 ? 4294967295 & e1 : n;
                        this.h2 = e1 ? 4294967295 & e1 : n;
                    }
                    update(e1) {
                        let t, a;
                        if ("string" == typeof e1) {
                            t = new Uint8Array(2 * e1.length);
                            a = 0;
                            for(let r = 0, n = e1.length; r < n; r++){
                                const n = e1.charCodeAt(r);
                                if (n <= 255) t[a++] = n;
                                else {
                                    t[a++] = n >>> 8;
                                    t[a++] = 255 & n;
                                }
                            }
                        } else {
                            if (!(0, r.isArrayBuffer)(e1)) throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                            t = e1.slice();
                            a = t.byteLength;
                        }
                        const n = a >> 2, o = a - 4 * n, c = new Uint32Array(t.buffer, 0, n);
                        let l = 0, h = 0, u = this.h1, d = this.h2;
                        const f = 3432918353, g = 461845907, p = 11601, m = 13715;
                        for(let e1 = 0; e1 < n; e1++)if (1 & e1) {
                            l = c[e1];
                            l = l * f & i | l * p & s;
                            l = l << 15 | l >>> 17;
                            l = l * g & i | l * m & s;
                            u ^= l;
                            u = u << 13 | u >>> 19;
                            u = 5 * u + 3864292196;
                        } else {
                            h = c[e1];
                            h = h * f & i | h * p & s;
                            h = h << 15 | h >>> 17;
                            h = h * g & i | h * m & s;
                            d ^= h;
                            d = d << 13 | d >>> 19;
                            d = 5 * d + 3864292196;
                        }
                        l = 0;
                        switch(o){
                            case 3:
                                l ^= t[4 * n + 2] << 16;
                            case 2:
                                l ^= t[4 * n + 1] << 8;
                            case 1:
                                l ^= t[4 * n];
                                l = l * f & i | l * p & s;
                                l = l << 15 | l >>> 17;
                                l = l * g & i | l * m & s;
                                1 & n ? u ^= l : d ^= l;
                        }
                        this.h1 = u;
                        this.h2 = d;
                    }
                    hexdigest() {
                        let e1 = this.h1, t = this.h2;
                        e1 ^= t >>> 1;
                        e1 = 3981806797 * e1 & i | 36045 * e1 & s;
                        t = 4283543511 * t & i | (2950163797 * (t << 16 | e1 >>> 16) & i) >>> 16;
                        e1 ^= t >>> 1;
                        e1 = 444984403 * e1 & i | 60499 * e1 & s;
                        t = 3301882366 * t & i | (3120437893 * (t << 16 | e1 >>> 16) & i) >>> 16;
                        e1 ^= t >>> 1;
                        return (e1 >>> 0).toString(16).padStart(8, "0") + (t >>> 0).toString(16).padStart(8, "0");
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.OperatorList = void 0;
                var r = a(2);
                function addState(e1, t, a, r, n) {
                    let i = e1;
                    for(let e1 = 0, a = t.length - 1; e1 < a; e1++){
                        const a = t[e1];
                        i = i[a] ||= [];
                    }
                    i[t.at(-1)] = {
                        checkFn: a,
                        iterateFn: r,
                        processFn: n
                    };
                }
                const n = [];
                addState(n, [
                    r.OPS.save,
                    r.OPS.transform,
                    r.OPS.paintInlineImageXObject,
                    r.OPS.restore
                ], null, function iterateInlineImageGroup(e1, t) {
                    const a = e1.fnArray, n = (t - (e1.iCurr - 3)) % 4;
                    switch(n){
                        case 0:
                            return a[t] === r.OPS.save;
                        case 1:
                            return a[t] === r.OPS.transform;
                        case 2:
                            return a[t] === r.OPS.paintInlineImageXObject;
                        case 3:
                            return a[t] === r.OPS.restore;
                    }
                    throw new Error(`iterateInlineImageGroup - invalid pos: ${n}`);
                }, function foundInlineImageGroup(e1, t) {
                    const a = e1.fnArray, n = e1.argsArray, i = e1.iCurr, s = i - 3, o = i - 2, c = i - 1, l = Math.min(Math.floor((t - s) / 4), 200);
                    if (l < 10) return t - (t - s) % 4;
                    let h = 0;
                    const u = [];
                    let d = 0, f = 1, g = 1;
                    for(let e1 = 0; e1 < l; e1++){
                        const t = n[o + (e1 << 2)], a = n[c + (e1 << 2)][0];
                        if (f + a.width > 1e3) {
                            h = Math.max(h, f);
                            g += d + 2;
                            f = 0;
                            d = 0;
                        }
                        u.push({
                            transform: t,
                            x: f,
                            y: g,
                            w: a.width,
                            h: a.height
                        });
                        f += a.width + 2;
                        d = Math.max(d, a.height);
                    }
                    const p = Math.max(h, f) + 1, m = g + d + 1, b = new Uint8Array(p * m * 4), y = p << 2;
                    for(let e1 = 0; e1 < l; e1++){
                        const t = n[c + (e1 << 2)][0].data, a = u[e1].w << 2;
                        let r = 0, i = u[e1].x + u[e1].y * p << 2;
                        b.set(t.subarray(0, a), i - y);
                        for(let n = 0, s = u[e1].h; n < s; n++){
                            b.set(t.subarray(r, r + a), i);
                            r += a;
                            i += y;
                        }
                        b.set(t.subarray(r - a, r), i);
                        for(; i >= 0;){
                            t[i - 4] = t[i];
                            t[i - 3] = t[i + 1];
                            t[i - 2] = t[i + 2];
                            t[i - 1] = t[i + 3];
                            t[i + a] = t[i + a - 4];
                            t[i + a + 1] = t[i + a - 3];
                            t[i + a + 2] = t[i + a - 2];
                            t[i + a + 3] = t[i + a - 1];
                            i -= y;
                        }
                    }
                    const w = {
                        width: p,
                        height: m
                    };
                    if (e1.isOffscreenCanvasSupported) {
                        const e1 = new OffscreenCanvas(p, m);
                        e1.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(b.buffer), p, m), 0, 0);
                        w.bitmap = e1.transferToImageBitmap();
                        w.data = null;
                    } else {
                        w.kind = r.ImageKind.RGBA_32BPP;
                        w.data = b;
                    }
                    a.splice(s, 4 * l, r.OPS.paintInlineImageXObjectGroup);
                    n.splice(s, 4 * l, [
                        w,
                        u
                    ]);
                    return s + 1;
                });
                addState(n, [
                    r.OPS.save,
                    r.OPS.transform,
                    r.OPS.paintImageMaskXObject,
                    r.OPS.restore
                ], null, function iterateImageMaskGroup(e1, t) {
                    const a = e1.fnArray, n = (t - (e1.iCurr - 3)) % 4;
                    switch(n){
                        case 0:
                            return a[t] === r.OPS.save;
                        case 1:
                            return a[t] === r.OPS.transform;
                        case 2:
                            return a[t] === r.OPS.paintImageMaskXObject;
                        case 3:
                            return a[t] === r.OPS.restore;
                    }
                    throw new Error(`iterateImageMaskGroup - invalid pos: ${n}`);
                }, function foundImageMaskGroup(e1, t) {
                    const a = e1.fnArray, n = e1.argsArray, i = e1.iCurr, s = i - 3, o = i - 2, c = i - 1;
                    let l = Math.floor((t - s) / 4);
                    if (l < 10) return t - (t - s) % 4;
                    let h, u, d = !1;
                    const f = n[c][0], g = n[o][0], p = n[o][1], m = n[o][2], b = n[o][3];
                    if (p === m) {
                        d = !0;
                        h = o + 4;
                        let e1 = c + 4;
                        for(let t = 1; t < l; t++, h += 4, e1 += 4){
                            u = n[h];
                            if (n[e1][0] !== f || u[0] !== g || u[1] !== p || u[2] !== m || u[3] !== b) {
                                t < 10 ? d = !1 : l = t;
                                break;
                            }
                        }
                    }
                    if (d) {
                        l = Math.min(l, 1e3);
                        const e1 = new Float32Array(2 * l);
                        h = o;
                        for(let t = 0; t < l; t++, h += 4){
                            u = n[h];
                            e1[t << 1] = u[4];
                            e1[1 + (t << 1)] = u[5];
                        }
                        a.splice(s, 4 * l, r.OPS.paintImageMaskXObjectRepeat);
                        n.splice(s, 4 * l, [
                            f,
                            g,
                            p,
                            m,
                            b,
                            e1
                        ]);
                    } else {
                        l = Math.min(l, 100);
                        const e1 = [];
                        for(let t = 0; t < l; t++){
                            u = n[o + (t << 2)];
                            const a = n[c + (t << 2)][0];
                            e1.push({
                                data: a.data,
                                width: a.width,
                                height: a.height,
                                interpolate: a.interpolate,
                                count: a.count,
                                transform: u
                            });
                        }
                        a.splice(s, 4 * l, r.OPS.paintImageMaskXObjectGroup);
                        n.splice(s, 4 * l, [
                            e1
                        ]);
                    }
                    return s + 1;
                });
                addState(n, [
                    r.OPS.save,
                    r.OPS.transform,
                    r.OPS.paintImageXObject,
                    r.OPS.restore
                ], function(e1) {
                    const t = e1.argsArray, a = e1.iCurr - 2;
                    return 0 === t[a][1] && 0 === t[a][2];
                }, function iterateImageGroup(e1, t) {
                    const a = e1.fnArray, n = e1.argsArray, i = (t - (e1.iCurr - 3)) % 4;
                    switch(i){
                        case 0:
                            return a[t] === r.OPS.save;
                        case 1:
                            if (a[t] !== r.OPS.transform) return !1;
                            const i1 = e1.iCurr - 2, s = n[i1][0], o = n[i1][3];
                            return n[t][0] === s && 0 === n[t][1] && 0 === n[t][2] && n[t][3] === o;
                        case 2:
                            if (a[t] !== r.OPS.paintImageXObject) return !1;
                            const c = n[e1.iCurr - 1][0];
                            return n[t][0] === c;
                        case 3:
                            return a[t] === r.OPS.restore;
                    }
                    throw new Error(`iterateImageGroup - invalid pos: ${i}`);
                }, function(e1, t) {
                    const a = e1.fnArray, n = e1.argsArray, i = e1.iCurr, s = i - 3, o = i - 2, c = n[i - 1][0], l = n[o][0], h = n[o][3], u = Math.min(Math.floor((t - s) / 4), 1e3);
                    if (u < 3) return t - (t - s) % 4;
                    const d = new Float32Array(2 * u);
                    let f = o;
                    for(let e1 = 0; e1 < u; e1++, f += 4){
                        const t = n[f];
                        d[e1 << 1] = t[4];
                        d[1 + (e1 << 1)] = t[5];
                    }
                    const g = [
                        c,
                        l,
                        h,
                        d
                    ];
                    a.splice(s, 4 * u, r.OPS.paintImageXObjectRepeat);
                    n.splice(s, 4 * u, g);
                    return s + 1;
                });
                addState(n, [
                    r.OPS.beginText,
                    r.OPS.setFont,
                    r.OPS.setTextMatrix,
                    r.OPS.showText,
                    r.OPS.endText
                ], null, function iterateShowTextGroup(e1, t) {
                    const a = e1.fnArray, n = e1.argsArray, i = (t - (e1.iCurr - 4)) % 5;
                    switch(i){
                        case 0:
                            return a[t] === r.OPS.beginText;
                        case 1:
                            return a[t] === r.OPS.setFont;
                        case 2:
                            return a[t] === r.OPS.setTextMatrix;
                        case 3:
                            if (a[t] !== r.OPS.showText) return !1;
                            const i1 = e1.iCurr - 3, s = n[i1][0], o = n[i1][1];
                            return n[t][0] === s && n[t][1] === o;
                        case 4:
                            return a[t] === r.OPS.endText;
                    }
                    throw new Error(`iterateShowTextGroup - invalid pos: ${i}`);
                }, function(e1, t) {
                    const a = e1.fnArray, r = e1.argsArray, n = e1.iCurr, i = n - 4, s = n - 3, o = n - 2, c = n - 1, l = n, h = r[s][0], u = r[s][1];
                    let d = Math.min(Math.floor((t - i) / 5), 1e3);
                    if (d < 3) return t - (t - i) % 5;
                    let f = i;
                    if (i >= 4 && a[i - 4] === a[s] && a[i - 3] === a[o] && a[i - 2] === a[c] && a[i - 1] === a[l] && r[i - 4][0] === h && r[i - 4][1] === u) {
                        d++;
                        f -= 5;
                    }
                    let g = f + 4;
                    for(let e1 = 1; e1 < d; e1++){
                        a.splice(g, 3);
                        r.splice(g, 3);
                        g += 2;
                    }
                    return g + 1;
                });
                class NullOptimizer {
                    constructor(e1){
                        this.queue = e1;
                    }
                    _optimize() {}
                    push(e1, t) {
                        this.queue.fnArray.push(e1);
                        this.queue.argsArray.push(t);
                        this._optimize();
                    }
                    flush() {}
                    reset() {}
                }
                class QueueOptimizer extends NullOptimizer {
                    constructor(e1){
                        super(e1);
                        this.state = null;
                        this.context = {
                            iCurr: 0,
                            fnArray: e1.fnArray,
                            argsArray: e1.argsArray,
                            isOffscreenCanvasSupported: !1
                        };
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                    set isOffscreenCanvasSupported(e1) {
                        this.context.isOffscreenCanvasSupported = e1;
                    }
                    _optimize() {
                        const e1 = this.queue.fnArray;
                        let t = this.lastProcessed, a = e1.length, r = this.state, i = this.match;
                        if (!r && !i && t + 1 === a && !n[e1[t]]) {
                            this.lastProcessed = a;
                            return;
                        }
                        const s = this.context;
                        for(; t < a;){
                            if (i) {
                                if ((0, i.iterateFn)(s, t)) {
                                    t++;
                                    continue;
                                }
                                t = (0, i.processFn)(s, t + 1);
                                a = e1.length;
                                i = null;
                                r = null;
                                if (t >= a) break;
                            }
                            r = (r || n)[e1[t]];
                            if (r && !Array.isArray(r)) {
                                s.iCurr = t;
                                t++;
                                if (!r.checkFn || (0, r.checkFn)(s)) {
                                    i = r;
                                    r = null;
                                } else r = null;
                            } else t++;
                        }
                        this.state = r;
                        this.match = i;
                        this.lastProcessed = t;
                    }
                    flush() {
                        for(; this.match;){
                            const e1 = this.queue.fnArray.length;
                            this.lastProcessed = (0, this.match.processFn)(this.context, e1);
                            this.match = null;
                            this.state = null;
                            this._optimize();
                        }
                    }
                    reset() {
                        this.state = null;
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                }
                class OperatorList {
                    static CHUNK_SIZE = 1e3;
                    static CHUNK_SIZE_ABOUT = this.CHUNK_SIZE - 5;
                    constructor(e1 = 0, t){
                        this._streamSink = t;
                        this.fnArray = [];
                        this.argsArray = [];
                        this.optimizer = !t || e1 & r.RenderingIntentFlag.OPLIST ? new NullOptimizer(this) : new QueueOptimizer(this);
                        this.dependencies = new Set;
                        this._totalLength = 0;
                        this.weight = 0;
                        this._resolved = t ? null : Promise.resolve();
                    }
                    set isOffscreenCanvasSupported(e1) {
                        this.optimizer.isOffscreenCanvasSupported = e1;
                    }
                    get length() {
                        return this.argsArray.length;
                    }
                    get ready() {
                        return this._resolved || this._streamSink.ready;
                    }
                    get totalLength() {
                        return this._totalLength + this.length;
                    }
                    addOp(e1, t) {
                        this.optimizer.push(e1, t);
                        this.weight++;
                        this._streamSink && (this.weight >= OperatorList.CHUNK_SIZE || this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (e1 === r.OPS.restore || e1 === r.OPS.endText)) && this.flush();
                    }
                    addImageOps(e1, t, a) {
                        void 0 !== a && this.addOp(r.OPS.beginMarkedContentProps, [
                            "OC",
                            a
                        ]);
                        this.addOp(e1, t);
                        void 0 !== a && this.addOp(r.OPS.endMarkedContent, []);
                    }
                    addDependency(e1) {
                        if (!this.dependencies.has(e1)) {
                            this.dependencies.add(e1);
                            this.addOp(r.OPS.dependency, [
                                e1
                            ]);
                        }
                    }
                    addDependencies(e1) {
                        for (const t of e1)this.addDependency(t);
                    }
                    addOpList(e1) {
                        if (e1 instanceof OperatorList) {
                            for (const t of e1.dependencies)this.dependencies.add(t);
                            for(let t = 0, a = e1.length; t < a; t++)this.addOp(e1.fnArray[t], e1.argsArray[t]);
                        } else (0, r.warn)('addOpList - ignoring invalid "opList" parameter.');
                    }
                    getIR() {
                        return {
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            length: this.length
                        };
                    }
                    get _transfers() {
                        const e1 = [], { fnArray: t, argsArray: a, length: n } = this;
                        for(let i = 0; i < n; i++)switch(t[i]){
                            case r.OPS.paintInlineImageXObject:
                            case r.OPS.paintInlineImageXObjectGroup:
                            case r.OPS.paintImageMaskXObject:
                                const t1 = a[i][0];
                                !t1.cached && t1.data?.buffer instanceof ArrayBuffer && e1.push(t1.data.buffer);
                        }
                        return e1;
                    }
                    flush(e1 = !1, t = null) {
                        this.optimizer.flush();
                        const a = this.length;
                        this._totalLength += a;
                        this._streamSink.enqueue({
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            lastChunk: e1,
                            separateAnnots: t,
                            length: a
                        }, 1, this._transfers);
                        this.dependencies.clear();
                        this.fnArray.length = 0;
                        this.argsArray.length = 0;
                        this.weight = 0;
                        this.optimizer.reset();
                    }
                }
                t.OperatorList = OperatorList;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PDFImage = void 0;
                var r = a(2), n = a(28), i = a(5), s = a(12), o = a(18), c = a(62), l = a(26), h = a(30), u = a(4);
                function decodeAndClamp(e1, t, a, r) {
                    (e1 = t + e1 * a) < 0 ? e1 = 0 : e1 > r && (e1 = r);
                    return e1;
                }
                function resizeImageMask(e1, t, a, r, n, i) {
                    const s = n * i;
                    let o;
                    o = t <= 8 ? new Uint8Array(s) : t <= 16 ? new Uint16Array(s) : new Uint32Array(s);
                    const c = a / n, l = r / i;
                    let h, u, d, f, g = 0;
                    const p = new Uint16Array(n), m = a;
                    for(h = 0; h < n; h++)p[h] = Math.floor(h * c);
                    for(h = 0; h < i; h++){
                        d = Math.floor(h * l) * m;
                        for(u = 0; u < n; u++){
                            f = d + p[u];
                            o[g++] = e1[f];
                        }
                    }
                    return o;
                }
                class PDFImage {
                    constructor({ xref: e1, res: t, image: a, isInline: n = !1, smask: o = null, mask: c = null, isMask: l = !1, pdfFunctionFactory: d, localColorSpaceCache: f }){
                        this.image = a;
                        const g = a.dict, p = g.get("F", "Filter");
                        let m;
                        if (p instanceof u.Name) m = p.name;
                        else if (Array.isArray(p)) {
                            const t = e1.fetchIfRef(p[0]);
                            t instanceof u.Name && (m = t.name);
                        }
                        switch(m){
                            case "JPXDecode":
                                const e2 = new h.JpxImage;
                                e2.parseImageProperties(a.stream);
                                a.stream.reset();
                                a.width = e2.width;
                                a.height = e2.height;
                                a.bitsPerComponent = e2.bitsPerComponent;
                                a.numComps = e2.componentsCount;
                                break;
                            case "JBIG2Decode":
                                a.bitsPerComponent = 1;
                                a.numComps = 1;
                        }
                        let b = g.get("W", "Width"), y = g.get("H", "Height");
                        if (Number.isInteger(a.width) && a.width > 0 && Number.isInteger(a.height) && a.height > 0 && (a.width !== b || a.height !== y)) {
                            (0, r.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
                            b = a.width;
                            y = a.height;
                        }
                        if (b < 1 || y < 1) throw new r.FormatError(`Invalid image width: ${b} or height: ${y}`);
                        this.width = b;
                        this.height = y;
                        this.interpolate = g.get("I", "Interpolate");
                        this.imageMask = g.get("IM", "ImageMask") || !1;
                        this.matte = g.get("Matte") || !1;
                        let w = a.bitsPerComponent;
                        if (!w) {
                            w = g.get("BPC", "BitsPerComponent");
                            if (!w) {
                                if (!this.imageMask) throw new r.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                                w = 1;
                            }
                        }
                        this.bpc = w;
                        if (!this.imageMask) {
                            let i = g.getRaw("CS") || g.getRaw("ColorSpace");
                            if (!i) {
                                (0, r.info)("JPX images (which do not require color spaces)");
                                switch(a.numComps){
                                    case 1:
                                        i = u.Name.get("DeviceGray");
                                        break;
                                    case 3:
                                        i = u.Name.get("DeviceRGB");
                                        break;
                                    case 4:
                                        i = u.Name.get("DeviceCMYK");
                                        break;
                                    default:
                                        throw new Error(`JPX images with ${a.numComps} color components not supported.`);
                                }
                            }
                            this.colorSpace = s.ColorSpace.parse({
                                cs: i,
                                xref: e1,
                                resources: n ? t : null,
                                pdfFunctionFactory: d,
                                localColorSpaceCache: f
                            });
                            this.numComps = this.colorSpace.numComps;
                        }
                        this.decode = g.getArray("D", "Decode");
                        this.needsDecode = !1;
                        if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, w) || l && !s.ColorSpace.isDefaultDecode(this.decode, 1))) {
                            this.needsDecode = !0;
                            const e1 = (1 << w) - 1;
                            this.decodeCoefficients = [];
                            this.decodeAddends = [];
                            const t = "Indexed" === this.colorSpace?.name;
                            for(let a = 0, r = 0; a < this.decode.length; a += 2, ++r){
                                const n = this.decode[a], i = this.decode[a + 1];
                                this.decodeCoefficients[r] = t ? (i - n) / e1 : i - n;
                                this.decodeAddends[r] = t ? n : e1 * n;
                            }
                        }
                        if (o) this.smask = new PDFImage({
                            xref: e1,
                            res: t,
                            image: o,
                            isInline: n,
                            pdfFunctionFactory: d,
                            localColorSpaceCache: f
                        });
                        else if (c) {
                            if (c instanceof i.BaseStream) c.dict.get("IM", "ImageMask") ? this.mask = new PDFImage({
                                xref: e1,
                                res: t,
                                image: c,
                                isInline: n,
                                isMask: !0,
                                pdfFunctionFactory: d,
                                localColorSpaceCache: f
                            }) : (0, r.warn)("Ignoring /Mask in image without /ImageMask.");
                            else this.mask = c;
                        }
                    }
                    static async buildImage({ xref: e1, res: t, image: a, isInline: n = !1, pdfFunctionFactory: s, localColorSpaceCache: o }) {
                        const c = a;
                        let l = null, h = null;
                        const u = a.dict.get("SMask"), d = a.dict.get("Mask");
                        u ? u instanceof i.BaseStream ? l = u : (0, r.warn)("Unsupported /SMask format.") : d && (d instanceof i.BaseStream || Array.isArray(d) ? h = d : (0, r.warn)("Unsupported /Mask format."));
                        return new PDFImage({
                            xref: e1,
                            res: t,
                            image: c,
                            isInline: n,
                            smask: l,
                            mask: h,
                            pdfFunctionFactory: s,
                            localColorSpaceCache: o
                        });
                    }
                    static createRawMask({ imgArray: e1, width: t, height: a, imageIsFromDecodeStream: r, inverseDecode: n, interpolate: i }) {
                        const s = (t + 7 >> 3) * a, o = e1.byteLength;
                        let c, l;
                        if (!r || n && !(s === o)) {
                            if (n) {
                                c = new Uint8Array(s);
                                c.set(e1);
                                c.fill(255, o);
                            } else c = new Uint8Array(e1);
                        } else c = e1;
                        if (n) for(l = 0; l < o; l++)c[l] ^= 255;
                        return {
                            data: c,
                            width: t,
                            height: a,
                            interpolate: i
                        };
                    }
                    static async createMask({ imgArray: e1, width: t, height: a, imageIsFromDecodeStream: i, inverseDecode: s, interpolate: o, isOffscreenCanvasSupported: l = !1 }) {
                        const h = 1 === t && 1 === a && s === (0 === e1.length || !!(128 & e1[0]));
                        if (h) return {
                            isSingleOpaquePixel: h
                        };
                        if (l) {
                            if (c.ImageResizer.needsToBeResized(t, a)) {
                                const i = new Uint8ClampedArray(t * a * 4);
                                (0, n.convertBlackAndWhiteToRGBA)({
                                    src: e1,
                                    dest: i,
                                    width: t,
                                    height: a,
                                    nonBlackColor: 0,
                                    inverseDecode: s
                                });
                                return c.ImageResizer.createImage({
                                    kind: r.ImageKind.RGBA_32BPP,
                                    data: i,
                                    width: t,
                                    height: a,
                                    interpolate: o
                                });
                            }
                            const i = new OffscreenCanvas(t, a), l = i.getContext("2d"), h = l.createImageData(t, a);
                            (0, n.convertBlackAndWhiteToRGBA)({
                                src: e1,
                                dest: h.data,
                                width: t,
                                height: a,
                                nonBlackColor: 0,
                                inverseDecode: s
                            });
                            l.putImageData(h, 0, 0);
                            return {
                                data: null,
                                width: t,
                                height: a,
                                interpolate: o,
                                bitmap: i.transferToImageBitmap()
                            };
                        }
                        return this.createRawMask({
                            imgArray: e1,
                            width: t,
                            height: a,
                            inverseDecode: s,
                            imageIsFromDecodeStream: i,
                            interpolate: o
                        });
                    }
                    get drawWidth() {
                        return Math.max(this.width, this.smask?.width || 0, this.mask?.width || 0);
                    }
                    get drawHeight() {
                        return Math.max(this.height, this.smask?.height || 0, this.mask?.height || 0);
                    }
                    decodeBuffer(e1) {
                        const t = this.bpc, a = this.numComps, r = this.decodeAddends, n = this.decodeCoefficients, i = (1 << t) - 1;
                        let s, o;
                        if (1 === t) {
                            for(s = 0, o = e1.length; s < o; s++)e1[s] = +!e1[s];
                            return;
                        }
                        let c = 0;
                        for(s = 0, o = this.width * this.height; s < o; s++)for(let t = 0; t < a; t++){
                            e1[c] = decodeAndClamp(e1[c], r[t], n[t], i);
                            c++;
                        }
                    }
                    getComponents(e1) {
                        const t = this.bpc;
                        if (8 === t) return e1;
                        const a = this.width, r = this.height, n = this.numComps, i = a * r * n;
                        let s, o = 0;
                        s = t <= 8 ? new Uint8Array(i) : t <= 16 ? new Uint16Array(i) : new Uint32Array(i);
                        const c = a * n, l = (1 << t) - 1;
                        let h, u, d = 0;
                        if (1 === t) {
                            let t, a, n;
                            for(let i = 0; i < r; i++){
                                a = d + (-8 & c);
                                n = d + c;
                                for(; d < a;){
                                    u = e1[o++];
                                    s[d] = u >> 7 & 1;
                                    s[d + 1] = u >> 6 & 1;
                                    s[d + 2] = u >> 5 & 1;
                                    s[d + 3] = u >> 4 & 1;
                                    s[d + 4] = u >> 3 & 1;
                                    s[d + 5] = u >> 2 & 1;
                                    s[d + 6] = u >> 1 & 1;
                                    s[d + 7] = 1 & u;
                                    d += 8;
                                }
                                if (d < n) {
                                    u = e1[o++];
                                    t = 128;
                                    for(; d < n;){
                                        s[d++] = +!!(u & t);
                                        t >>= 1;
                                    }
                                }
                            }
                        } else {
                            let a = 0;
                            u = 0;
                            for(d = 0, h = i; d < h; ++d){
                                if (d % c == 0) {
                                    u = 0;
                                    a = 0;
                                }
                                for(; a < t;){
                                    u = u << 8 | e1[o++];
                                    a += 8;
                                }
                                const r = a - t;
                                let n = u >> r;
                                n < 0 ? n = 0 : n > l && (n = l);
                                s[d] = n;
                                u &= (1 << r) - 1;
                                a = r;
                            }
                        }
                        return s;
                    }
                    fillOpacity(e1, t, a, n, i) {
                        const s = this.smask, o = this.mask;
                        let c, l, h, u, d, f;
                        if (s) {
                            l = s.width;
                            h = s.height;
                            c = new Uint8ClampedArray(l * h);
                            s.fillGrayBuffer(c);
                            l === t && h === a || (c = resizeImageMask(c, s.bpc, l, h, t, a));
                        } else if (o) {
                            if (o instanceof PDFImage) {
                                l = o.width;
                                h = o.height;
                                c = new Uint8ClampedArray(l * h);
                                o.numComps = 1;
                                o.fillGrayBuffer(c);
                                for(u = 0, d = l * h; u < d; ++u)c[u] = 255 - c[u];
                                l === t && h === a || (c = resizeImageMask(c, o.bpc, l, h, t, a));
                            } else {
                                if (!Array.isArray(o)) throw new r.FormatError("Unknown mask format.");
                                {
                                    c = new Uint8ClampedArray(t * a);
                                    const e1 = this.numComps;
                                    for(u = 0, d = t * a; u < d; ++u){
                                        let t = 0;
                                        const a = u * e1;
                                        for(f = 0; f < e1; ++f){
                                            const e1 = i[a + f], r = 2 * f;
                                            if (e1 < o[r] || e1 > o[r + 1]) {
                                                t = 255;
                                                break;
                                            }
                                        }
                                        c[u] = t;
                                    }
                                }
                            }
                        }
                        if (c) for(u = 0, f = 3, d = t * n; u < d; ++u, f += 4)e1[f] = c[u];
                        else for(u = 0, f = 3, d = t * n; u < d; ++u, f += 4)e1[f] = 255;
                    }
                    undoPreblend(e1, t, a) {
                        const r = this.smask?.matte;
                        if (!r) return;
                        const n = this.colorSpace.getRgb(r, 0), i = n[0], s = n[1], o = n[2], c = t * a * 4;
                        for(let t = 0; t < c; t += 4){
                            const a = e1[t + 3];
                            if (0 === a) {
                                e1[t] = 255;
                                e1[t + 1] = 255;
                                e1[t + 2] = 255;
                                continue;
                            }
                            const r = 255 / a;
                            e1[t] = (e1[t] - i) * r + i;
                            e1[t + 1] = (e1[t + 1] - s) * r + s;
                            e1[t + 2] = (e1[t + 2] - o) * r + o;
                        }
                    }
                    async createImageData(e1 = !1, t = !1) {
                        const a = this.drawWidth, n = this.drawHeight, i = {
                            width: a,
                            height: n,
                            interpolate: this.interpolate,
                            kind: 0,
                            data: null
                        }, s = this.numComps, o = this.width, h = this.height, u = this.bpc, d = o * s * u + 7 >> 3, f = t && c.ImageResizer.needsToBeResized(a, n);
                        if (!e1) {
                            let e1;
                            "DeviceGray" === this.colorSpace.name && 1 === u ? e1 = r.ImageKind.GRAYSCALE_1BPP : "DeviceRGB" !== this.colorSpace.name || 8 !== u || this.needsDecode || (e1 = r.ImageKind.RGB_24BPP);
                            if (e1 && !this.smask && !this.mask && a === o && n === h) {
                                const s = this.getImageBytes(h * d, {});
                                if (t) return f ? c.ImageResizer.createImage({
                                    data: s,
                                    kind: e1,
                                    width: a,
                                    height: n,
                                    interpolate: this.interpolate
                                }, this.needsDecode) : this.createBitmap(e1, o, h, s);
                                i.kind = e1;
                                i.data = s;
                                if (this.needsDecode) {
                                    (0, r.assert)(e1 === r.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                                    const t = i.data;
                                    for(let e1 = 0, a = t.length; e1 < a; e1++)t[e1] ^= 255;
                                }
                                return i;
                            }
                            if (this.image instanceof l.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                                let e1 = h * d;
                                if (t && !f) {
                                    let t = !1;
                                    switch(this.colorSpace.name){
                                        case "DeviceGray":
                                            e1 *= 4;
                                            t = !0;
                                            break;
                                        case "DeviceRGB":
                                            e1 = e1 / 3 * 4;
                                            t = !0;
                                            break;
                                        case "DeviceCMYK":
                                            t = !0;
                                    }
                                    if (t) {
                                        const t = this.getImageBytes(e1, {
                                            drawWidth: a,
                                            drawHeight: n,
                                            forceRGBA: !0
                                        });
                                        return this.createBitmap(r.ImageKind.RGBA_32BPP, a, n, t);
                                    }
                                } else switch(this.colorSpace.name){
                                    case "DeviceGray":
                                        e1 *= 3;
                                    case "DeviceRGB":
                                    case "DeviceCMYK":
                                        i.kind = r.ImageKind.RGB_24BPP;
                                        i.data = this.getImageBytes(e1, {
                                            drawWidth: a,
                                            drawHeight: n,
                                            forceRGB: !0
                                        });
                                        return f ? c.ImageResizer.createImage(i) : i;
                                }
                            }
                        }
                        const g = this.getImageBytes(h * d, {
                            internal: !0
                        }), p = 0 | g.length / d * n / h, m = this.getComponents(g);
                        let b, y, w, S, x, C;
                        if (t && !f) {
                            w = new OffscreenCanvas(a, n);
                            S = w.getContext("2d");
                            x = S.createImageData(a, n);
                            C = x.data;
                        }
                        i.kind = r.ImageKind.RGBA_32BPP;
                        if (e1 || this.smask || this.mask) {
                            t && !f || (C = new Uint8ClampedArray(a * n * 4));
                            b = 1;
                            y = !0;
                            this.fillOpacity(C, a, n, p, m);
                        } else {
                            if (!t || f) {
                                i.kind = r.ImageKind.RGB_24BPP;
                                C = new Uint8ClampedArray(a * n * 3);
                                b = 0;
                            } else {
                                new Uint32Array(C.buffer).fill(r.FeatureTest.isLittleEndian ? 4278190080 : 255);
                                b = 1;
                            }
                            y = !1;
                        }
                        this.needsDecode && this.decodeBuffer(m);
                        this.colorSpace.fillRgb(C, o, h, a, n, p, u, m, b);
                        y && this.undoPreblend(C, a, p);
                        if (t && !f) {
                            S.putImageData(x, 0, 0);
                            return {
                                data: null,
                                width: a,
                                height: n,
                                bitmap: w.transferToImageBitmap(),
                                interpolate: this.interpolate
                            };
                        }
                        i.data = C;
                        return f ? c.ImageResizer.createImage(i) : i;
                    }
                    fillGrayBuffer(e1) {
                        const t = this.numComps;
                        if (1 !== t) throw new r.FormatError(`Reading gray scale from a color image: ${t}`);
                        const a = this.width, n = this.height, i = this.bpc, s = a * t * i + 7 >> 3, o = this.getImageBytes(n * s, {
                            internal: !0
                        }), c = this.getComponents(o);
                        let l, h;
                        if (1 === i) {
                            h = a * n;
                            if (this.needsDecode) for(l = 0; l < h; ++l)e1[l] = c[l] - 1 & 255;
                            else for(l = 0; l < h; ++l)e1[l] = 255 & -c[l];
                            return;
                        }
                        this.needsDecode && this.decodeBuffer(c);
                        h = a * n;
                        const u = 255 / ((1 << i) - 1);
                        for(l = 0; l < h; ++l)e1[l] = u * c[l];
                    }
                    createBitmap(e1, t, a, i) {
                        const s = new OffscreenCanvas(t, a), o = s.getContext("2d");
                        let c;
                        if (e1 === r.ImageKind.RGBA_32BPP) c = new ImageData(i, t, a);
                        else {
                            c = o.createImageData(t, a);
                            (0, n.convertToRGBA)({
                                kind: e1,
                                src: i,
                                dest: new Uint32Array(c.data.buffer),
                                width: t,
                                height: a,
                                inverseDecode: this.needsDecode
                            });
                        }
                        o.putImageData(c, 0, 0);
                        return {
                            data: null,
                            width: t,
                            height: a,
                            bitmap: s.transferToImageBitmap(),
                            interpolate: this.interpolate
                        };
                    }
                    getImageBytes(e1, { drawWidth: t, drawHeight: a, forceRGBA: n = !1, forceRGB: i = !1, internal: s = !1 }) {
                        this.image.reset();
                        this.image.drawWidth = t || this.width;
                        this.image.drawHeight = a || this.height;
                        this.image.forceRGBA = !!n;
                        this.image.forceRGB = !!i;
                        const c = this.image.getBytes(e1);
                        if (s || this.image instanceof o.DecodeStream) return c;
                        (0, r.assert)(c instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.');
                        return new Uint8Array(c);
                    }
                }
                t.PDFImage = PDFImage;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Catalog = void 0;
                var r = a(3), n = a(2), i = a(4), s = a(67), o = a(5), c = a(68), l = a(12), h = a(69), u = a(59), d = a(70), f = a(72);
                function fetchDestination(e1) {
                    e1 instanceof i.Dict && (e1 = e1.get("D"));
                    return Array.isArray(e1) ? e1 : null;
                }
                class Catalog {
                    constructor(e1, t){
                        this.pdfManager = e1;
                        this.xref = t;
                        this._catDict = t.getCatalogObj();
                        if (!(this._catDict instanceof i.Dict)) throw new n.FormatError("Catalog object is not a dictionary.");
                        this.toplevelPagesDict;
                        this._actualNumPages = null;
                        this.fontCache = new i.RefSetCache;
                        this.builtInCMapCache = new Map;
                        this.standardFontDataCache = new Map;
                        this.globalImageCache = new u.GlobalImageCache;
                        this.pageKidsCountCache = new i.RefSetCache;
                        this.pageIndexCache = new i.RefSetCache;
                        this.nonBlendModesSet = new i.RefSet;
                        this.systemFontCache = new Map;
                    }
                    cloneDict() {
                        return this._catDict.clone();
                    }
                    get version() {
                        const e1 = this._catDict.get("Version");
                        if (e1 instanceof i.Name) {
                            if (r.PDF_VERSION_REGEXP.test(e1.name)) return (0, n.shadow)(this, "version", e1.name);
                            (0, n.warn)(`Invalid PDF catalog version: ${e1.name}`);
                        }
                        return (0, n.shadow)(this, "version", null);
                    }
                    get lang() {
                        const e1 = this._catDict.get("Lang");
                        return (0, n.shadow)(this, "lang", "string" == typeof e1 ? (0, n.stringToPDFString)(e1) : null);
                    }
                    get needsRendering() {
                        const e1 = this._catDict.get("NeedsRendering");
                        return (0, n.shadow)(this, "needsRendering", "boolean" == typeof e1 && e1);
                    }
                    get collection() {
                        let e1 = null;
                        try {
                            const t = this._catDict.get("Collection");
                            t instanceof i.Dict && t.size > 0 && (e1 = t);
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.info)("Cannot fetch Collection entry; assuming no collection is present.");
                        }
                        return (0, n.shadow)(this, "collection", e1);
                    }
                    get acroForm() {
                        let e1 = null;
                        try {
                            const t = this._catDict.get("AcroForm");
                            t instanceof i.Dict && t.size > 0 && (e1 = t);
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                        }
                        return (0, n.shadow)(this, "acroForm", e1);
                    }
                    get acroFormRef() {
                        const e1 = this._catDict.getRaw("AcroForm");
                        return (0, n.shadow)(this, "acroFormRef", e1 instanceof i.Ref ? e1 : null);
                    }
                    get metadata() {
                        const e1 = this._catDict.getRaw("Metadata");
                        if (!(e1 instanceof i.Ref)) return (0, n.shadow)(this, "metadata", null);
                        let t = null;
                        try {
                            const a = this.xref.fetch(e1, !this.xref.encrypt?.encryptMetadata);
                            if (a instanceof o.BaseStream && a.dict instanceof i.Dict) {
                                const e1 = a.dict.get("Type"), r = a.dict.get("Subtype");
                                if ((0, i.isName)(e1, "Metadata") && (0, i.isName)(r, "XML")) {
                                    const e1 = (0, n.stringToUTF8String)(a.getString());
                                    e1 && (t = new d.MetadataParser(e1).serializable);
                                }
                            }
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.info)(`Skipping invalid Metadata: "${e1}".`);
                        }
                        return (0, n.shadow)(this, "metadata", t);
                    }
                    get markInfo() {
                        let e1 = null;
                        try {
                            e1 = this._readMarkInfo();
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)("Unable to read mark info.");
                        }
                        return (0, n.shadow)(this, "markInfo", e1);
                    }
                    _readMarkInfo() {
                        const e1 = this._catDict.get("MarkInfo");
                        if (!(e1 instanceof i.Dict)) return null;
                        const t = {
                            Marked: !1,
                            UserProperties: !1,
                            Suspects: !1
                        };
                        for(const a in t){
                            const r = e1.get(a);
                            "boolean" == typeof r && (t[a] = r);
                        }
                        return t;
                    }
                    get structTreeRoot() {
                        let e1 = null;
                        try {
                            e1 = this._readStructTreeRoot();
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)("Unable read to structTreeRoot info.");
                        }
                        return (0, n.shadow)(this, "structTreeRoot", e1);
                    }
                    _readStructTreeRoot() {
                        const e1 = this._catDict.getRaw("StructTreeRoot"), t = this.xref.fetchIfRef(e1);
                        if (!(t instanceof i.Dict)) return null;
                        const a = new f.StructTreeRoot(t, e1);
                        a.init();
                        return a;
                    }
                    get toplevelPagesDict() {
                        const e1 = this._catDict.get("Pages");
                        if (!(e1 instanceof i.Dict)) throw new n.FormatError("Invalid top-level pages dictionary.");
                        return (0, n.shadow)(this, "toplevelPagesDict", e1);
                    }
                    get documentOutline() {
                        let e1 = null;
                        try {
                            e1 = this._readDocumentOutline();
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)("Unable to read document outline.");
                        }
                        return (0, n.shadow)(this, "documentOutline", e1);
                    }
                    _readDocumentOutline() {
                        let e1 = this._catDict.get("Outlines");
                        if (!(e1 instanceof i.Dict)) return null;
                        e1 = e1.getRaw("First");
                        if (!(e1 instanceof i.Ref)) return null;
                        const t = {
                            items: []
                        }, a = [
                            {
                                obj: e1,
                                parent: t
                            }
                        ], r = new i.RefSet;
                        r.put(e1);
                        const s = this.xref, o = new Uint8ClampedArray(3);
                        for(; a.length > 0;){
                            const t = a.shift(), c = s.fetchIfRef(t.obj);
                            if (null === c) continue;
                            if (!c.has("Title")) throw new n.FormatError("Invalid outline item encountered.");
                            const h = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: c,
                                resultObj: h,
                                docBaseUrl: this.baseUrl,
                                docAttachments: this.attachments
                            });
                            const u = c.get("Title"), d = c.get("F") || 0, f = c.getArray("C"), g = c.get("Count");
                            let p = o;
                            !Array.isArray(f) || 3 !== f.length || 0 === f[0] && 0 === f[1] && 0 === f[2] || (p = l.ColorSpace.singletons.rgb.getRgb(f, 0));
                            const m = {
                                action: h.action,
                                attachment: h.attachment,
                                dest: h.dest,
                                url: h.url,
                                unsafeUrl: h.unsafeUrl,
                                newWindow: h.newWindow,
                                setOCGState: h.setOCGState,
                                title: (0, n.stringToPDFString)(u),
                                color: p,
                                count: Number.isInteger(g) ? g : void 0,
                                bold: !!(2 & d),
                                italic: !!(1 & d),
                                items: []
                            };
                            t.parent.items.push(m);
                            e1 = c.getRaw("First");
                            if (e1 instanceof i.Ref && !r.has(e1)) {
                                a.push({
                                    obj: e1,
                                    parent: m
                                });
                                r.put(e1);
                            }
                            e1 = c.getRaw("Next");
                            if (e1 instanceof i.Ref && !r.has(e1)) {
                                a.push({
                                    obj: e1,
                                    parent: t.parent
                                });
                                r.put(e1);
                            }
                        }
                        return t.items.length > 0 ? t.items : null;
                    }
                    get permissions() {
                        let e1 = null;
                        try {
                            e1 = this._readPermissions();
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)("Unable to read permissions.");
                        }
                        return (0, n.shadow)(this, "permissions", e1);
                    }
                    _readPermissions() {
                        const e1 = this.xref.trailer.get("Encrypt");
                        if (!(e1 instanceof i.Dict)) return null;
                        let t = e1.get("P");
                        if ("number" != typeof t) return null;
                        t += 2 ** 32;
                        const a = [];
                        for(const e1 in n.PermissionFlag){
                            const r = n.PermissionFlag[e1];
                            t & r && a.push(r);
                        }
                        return a;
                    }
                    get optionalContentConfig() {
                        let e1 = null;
                        try {
                            const t = this._catDict.get("OCProperties");
                            if (!t) return (0, n.shadow)(this, "optionalContentConfig", null);
                            const a = t.get("D");
                            if (!a) return (0, n.shadow)(this, "optionalContentConfig", null);
                            const r = t.get("OCGs");
                            if (!Array.isArray(r)) return (0, n.shadow)(this, "optionalContentConfig", null);
                            const s = [], o = [];
                            for (const e1 of r){
                                if (!(e1 instanceof i.Ref)) continue;
                                o.push(e1);
                                const t = this.xref.fetchIfRef(e1);
                                s.push({
                                    id: e1.toString(),
                                    name: "string" == typeof t.get("Name") ? (0, n.stringToPDFString)(t.get("Name")) : null,
                                    intent: "string" == typeof t.get("Intent") ? (0, n.stringToPDFString)(t.get("Intent")) : null
                                });
                            }
                            e1 = this._readOptionalContentConfig(a, o);
                            e1.groups = s;
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)(`Unable to read optional content config: ${e1}`);
                        }
                        return (0, n.shadow)(this, "optionalContentConfig", e1);
                    }
                    _readOptionalContentConfig(e1, t) {
                        function parseOnOff(e1) {
                            const a = [];
                            if (Array.isArray(e1)) for (const r of e1)r instanceof i.Ref && t.includes(r) && a.push(r.toString());
                            return a;
                        }
                        function parseOrder(e1, a = 0) {
                            if (!Array.isArray(e1)) return null;
                            const n = [];
                            for (const s of e1){
                                if (s instanceof i.Ref && t.includes(s)) {
                                    r.put(s);
                                    n.push(s.toString());
                                    continue;
                                }
                                const e1 = parseNestedOrder(s, a);
                                e1 && n.push(e1);
                            }
                            if (a > 0) return n;
                            const s = [];
                            for (const e1 of t)r.has(e1) || s.push(e1.toString());
                            s.length && n.push({
                                name: null,
                                order: s
                            });
                            return n;
                        }
                        function parseNestedOrder(e1, t) {
                            if (++t > s) {
                                (0, n.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS.");
                                return null;
                            }
                            const r = a.fetchIfRef(e1);
                            if (!Array.isArray(r)) return null;
                            const i = a.fetchIfRef(r[0]);
                            if ("string" != typeof i) return null;
                            const o = parseOrder(r.slice(1), t);
                            return o && o.length ? {
                                name: (0, n.stringToPDFString)(i),
                                order: o
                            } : null;
                        }
                        const a = this.xref, r = new i.RefSet, s = 10;
                        return {
                            name: "string" == typeof e1.get("Name") ? (0, n.stringToPDFString)(e1.get("Name")) : null,
                            creator: "string" == typeof e1.get("Creator") ? (0, n.stringToPDFString)(e1.get("Creator")) : null,
                            baseState: e1.get("BaseState") instanceof i.Name ? e1.get("BaseState").name : null,
                            on: parseOnOff(e1.get("ON")),
                            off: parseOnOff(e1.get("OFF")),
                            order: parseOrder(e1.get("Order")),
                            groups: null
                        };
                    }
                    setActualNumPages(e1 = null) {
                        this._actualNumPages = e1;
                    }
                    get hasActualNumPages() {
                        return null !== this._actualNumPages;
                    }
                    get _pagesCount() {
                        const e1 = this.toplevelPagesDict.get("Count");
                        if (!Number.isInteger(e1)) throw new n.FormatError("Page count in top-level pages dictionary is not an integer.");
                        return (0, n.shadow)(this, "_pagesCount", e1);
                    }
                    get numPages() {
                        return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
                    }
                    get destinations() {
                        const e1 = this._readDests(), t = Object.create(null);
                        if (e1 instanceof s.NameTree) for (const [a, r] of e1.getAll()){
                            const e1 = fetchDestination(r);
                            e1 && (t[(0, n.stringToPDFString)(a)] = e1);
                        }
                        else e1 instanceof i.Dict && e1.forEach(function(e1, a) {
                            const r = fetchDestination(a);
                            r && (t[e1] = r);
                        });
                        return (0, n.shadow)(this, "destinations", t);
                    }
                    getDestination(e1) {
                        const t = this._readDests();
                        if (t instanceof s.NameTree) {
                            const a = fetchDestination(t.get(e1));
                            if (a) return a;
                            const r = this.destinations[e1];
                            if (r) {
                                (0, n.warn)(`Found "${e1}" at an incorrect position in the NameTree.`);
                                return r;
                            }
                        } else if (t instanceof i.Dict) {
                            const a = fetchDestination(t.get(e1));
                            if (a) return a;
                        }
                        return null;
                    }
                    _readDests() {
                        const e1 = this._catDict.get("Names");
                        return e1?.has("Dests") ? new s.NameTree(e1.getRaw("Dests"), this.xref) : this._catDict.has("Dests") ? this._catDict.get("Dests") : void 0;
                    }
                    get pageLabels() {
                        let e1 = null;
                        try {
                            e1 = this._readPageLabels();
                        } catch (e1) {
                            if (e1 instanceof r.MissingDataException) throw e1;
                            (0, n.warn)("Unable to read page labels.");
                        }
                        return (0, n.shadow)(this, "pageLabels", e1);
                    }
                    _readPageLabels() {
                        const e1 = this._catDict.getRaw("PageLabels");
                        if (!e1) return null;
                        const t = new Array(this.numPages);
                        let a = null, o = "";
                        const c = new s.NumberTree(e1, this.xref).getAll();
                        let l = "", h = 1;
                        for(let e1 = 0, s = this.numPages; e1 < s; e1++){
                            const s = c.get(e1);
                            if (void 0 !== s) {
                                if (!(s instanceof i.Dict)) throw new n.FormatError("PageLabel is not a dictionary.");
                                if (s.has("Type") && !(0, i.isName)(s.get("Type"), "PageLabel")) throw new n.FormatError("Invalid type in PageLabel dictionary.");
                                if (s.has("S")) {
                                    const e1 = s.get("S");
                                    if (!(e1 instanceof i.Name)) throw new n.FormatError("Invalid style in PageLabel dictionary.");
                                    a = e1.name;
                                } else a = null;
                                if (s.has("P")) {
                                    const e1 = s.get("P");
                                    if ("string" != typeof e1) throw new n.FormatError("Invalid prefix in PageLabel dictionary.");
                                    o = (0, n.stringToPDFString)(e1);
                                } else o = "";
                                if (s.has("St")) {
                                    const e1 = s.get("St");
                                    if (!(Number.isInteger(e1) && e1 >= 1)) throw new n.FormatError("Invalid start in PageLabel dictionary.");
                                    h = e1;
                                } else h = 1;
                            }
                            switch(a){
                                case "D":
                                    l = h;
                                    break;
                                case "R":
                                case "r":
                                    l = (0, r.toRomanNumerals)(h, "r" === a);
                                    break;
                                case "A":
                                case "a":
                                    const e2 = 26, t1 = "a" === a ? 97 : 65, i1 = h - 1;
                                    l = String.fromCharCode(t1 + i1 % e2).repeat(Math.floor(i1 / e2) + 1);
                                    break;
                                default:
                                    if (a) throw new n.FormatError(`Invalid style "${a}" in PageLabel dictionary.`);
                                    l = "";
                            }
                            t[e1] = o + l;
                            h++;
                        }
                        return t;
                    }
                    get pageLayout() {
                        const e1 = this._catDict.get("PageLayout");
                        let t = "";
                        if (e1 instanceof i.Name) switch(e1.name){
                            case "SinglePage":
                            case "OneColumn":
                            case "TwoColumnLeft":
                            case "TwoColumnRight":
                            case "TwoPageLeft":
                            case "TwoPageRight":
                                t = e1.name;
                        }
                        return (0, n.shadow)(this, "pageLayout", t);
                    }
                    get pageMode() {
                        const e1 = this._catDict.get("PageMode");
                        let t = "UseNone";
                        if (e1 instanceof i.Name) switch(e1.name){
                            case "UseNone":
                            case "UseOutlines":
                            case "UseThumbs":
                            case "FullScreen":
                            case "UseOC":
                            case "UseAttachments":
                                t = e1.name;
                        }
                        return (0, n.shadow)(this, "pageMode", t);
                    }
                    get viewerPreferences() {
                        const e1 = this._catDict.get("ViewerPreferences");
                        if (!(e1 instanceof i.Dict)) return (0, n.shadow)(this, "viewerPreferences", null);
                        let t = null;
                        for (const a of e1.getKeys()){
                            const r = e1.get(a);
                            let s;
                            switch(a){
                                case "HideToolbar":
                                case "HideMenubar":
                                case "HideWindowUI":
                                case "FitWindow":
                                case "CenterWindow":
                                case "DisplayDocTitle":
                                case "PickTrayByPDFSize":
                                    "boolean" == typeof r && (s = r);
                                    break;
                                case "NonFullScreenPageMode":
                                    if (r instanceof i.Name) switch(r.name){
                                        case "UseNone":
                                        case "UseOutlines":
                                        case "UseThumbs":
                                        case "UseOC":
                                            s = r.name;
                                            break;
                                        default:
                                            s = "UseNone";
                                    }
                                    break;
                                case "Direction":
                                    if (r instanceof i.Name) switch(r.name){
                                        case "L2R":
                                        case "R2L":
                                            s = r.name;
                                            break;
                                        default:
                                            s = "L2R";
                                    }
                                    break;
                                case "ViewArea":
                                case "ViewClip":
                                case "PrintArea":
                                case "PrintClip":
                                    if (r instanceof i.Name) switch(r.name){
                                        case "MediaBox":
                                        case "CropBox":
                                        case "BleedBox":
                                        case "TrimBox":
                                        case "ArtBox":
                                            s = r.name;
                                            break;
                                        default:
                                            s = "CropBox";
                                    }
                                    break;
                                case "PrintScaling":
                                    if (r instanceof i.Name) switch(r.name){
                                        case "None":
                                        case "AppDefault":
                                            s = r.name;
                                            break;
                                        default:
                                            s = "AppDefault";
                                    }
                                    break;
                                case "Duplex":
                                    if (r instanceof i.Name) switch(r.name){
                                        case "Simplex":
                                        case "DuplexFlipShortEdge":
                                        case "DuplexFlipLongEdge":
                                            s = r.name;
                                            break;
                                        default:
                                            s = "None";
                                    }
                                    break;
                                case "PrintPageRange":
                                    if (Array.isArray(r) && r.length % 2 == 0) r.every((e1, t, a)=>Number.isInteger(e1) && e1 > 0 && (0 === t || e1 >= a[t - 1]) && e1 <= this.numPages) && (s = r);
                                    break;
                                case "NumCopies":
                                    Number.isInteger(r) && r > 0 && (s = r);
                                    break;
                                default:
                                    (0, n.warn)(`Ignoring non-standard key in ViewerPreferences: ${a}.`);
                                    continue;
                            }
                            if (void 0 !== s) {
                                t || (t = Object.create(null));
                                t[a] = s;
                            } else (0, n.warn)(`Bad value, for key "${a}", in ViewerPreferences: ${r}.`);
                        }
                        return (0, n.shadow)(this, "viewerPreferences", t);
                    }
                    get openAction() {
                        const e1 = this._catDict.get("OpenAction"), t = Object.create(null);
                        if (e1 instanceof i.Dict) {
                            const a = new i.Dict(this.xref);
                            a.set("A", e1);
                            const r = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: a,
                                resultObj: r
                            });
                            Array.isArray(r.dest) ? t.dest = r.dest : r.action && (t.action = r.action);
                        } else Array.isArray(e1) && (t.dest = e1);
                        return (0, n.shadow)(this, "openAction", (0, n.objectSize)(t) > 0 ? t : null);
                    }
                    get attachments() {
                        const e1 = this._catDict.get("Names");
                        let t = null;
                        if (e1 instanceof i.Dict && e1.has("EmbeddedFiles")) {
                            const a = new s.NameTree(e1.getRaw("EmbeddedFiles"), this.xref);
                            for (const [e1, r] of a.getAll()){
                                const a = new h.FileSpec(r, this.xref);
                                t || (t = Object.create(null));
                                t[(0, n.stringToPDFString)(e1)] = a.serializable;
                            }
                        }
                        return (0, n.shadow)(this, "attachments", t);
                    }
                    get xfaImages() {
                        const e1 = this._catDict.get("Names");
                        let t = null;
                        if (e1 instanceof i.Dict && e1.has("XFAImages")) {
                            const a = new s.NameTree(e1.getRaw("XFAImages"), this.xref);
                            for (const [e1, r] of a.getAll()){
                                t || (t = new i.Dict(this.xref));
                                t.set((0, n.stringToPDFString)(e1), r);
                            }
                        }
                        return (0, n.shadow)(this, "xfaImages", t);
                    }
                    _collectJavaScript() {
                        const e1 = this._catDict.get("Names");
                        let t = null;
                        function appendIfJavaScriptDict(e1, a) {
                            if (!(a instanceof i.Dict)) return;
                            if (!(0, i.isName)(a.get("S"), "JavaScript")) return;
                            let r = a.get("JS");
                            if (r instanceof o.BaseStream) r = r.getString();
                            else if ("string" != typeof r) return;
                            r = (0, n.stringToPDFString)(r).replaceAll("\0", "");
                            r && (t ||= new Map).set(e1, r);
                        }
                        if (e1 instanceof i.Dict && e1.has("JavaScript")) {
                            const t = new s.NameTree(e1.getRaw("JavaScript"), this.xref);
                            for (const [e1, a] of t.getAll())appendIfJavaScriptDict((0, n.stringToPDFString)(e1), a);
                        }
                        const a = this._catDict.get("OpenAction");
                        a && appendIfJavaScriptDict("OpenAction", a);
                        return t;
                    }
                    get jsActions() {
                        const e1 = this._collectJavaScript();
                        let t = (0, r.collectActions)(this.xref, this._catDict, n.DocumentActionEventType);
                        if (e1) {
                            t ||= Object.create(null);
                            for (const [a, r] of e1)a in t ? t[a].push(r) : t[a] = [
                                r
                            ];
                        }
                        return (0, n.shadow)(this, "jsActions", t);
                    }
                    async fontFallback(e1, t) {
                        const a = await Promise.all(this.fontCache);
                        for (const r of a)if (r.loadedName === e1) {
                            r.fallback(t);
                            return;
                        }
                    }
                    async cleanup(e1 = !1) {
                        (0, c.clearGlobalCaches)();
                        this.globalImageCache.clear(e1);
                        this.pageKidsCountCache.clear();
                        this.pageIndexCache.clear();
                        this.nonBlendModesSet.clear();
                        const t = await Promise.all(this.fontCache);
                        for (const { dict: e1 } of t)delete e1.cacheKey;
                        this.fontCache.clear();
                        this.builtInCMapCache.clear();
                        this.standardFontDataCache.clear();
                        this.systemFontCache.clear();
                    }
                    async getPageDict(e1) {
                        const t = [
                            this.toplevelPagesDict
                        ], a = new i.RefSet, r = this._catDict.getRaw("Pages");
                        r instanceof i.Ref && a.put(r);
                        const s = this.xref, o = this.pageKidsCountCache, c = this.pageIndexCache;
                        let l = 0;
                        for(; t.length;){
                            const r = t.pop();
                            if (r instanceof i.Ref) {
                                const h = o.get(r);
                                if (h >= 0 && l + h <= e1) {
                                    l += h;
                                    continue;
                                }
                                if (a.has(r)) throw new n.FormatError("Pages tree contains circular reference.");
                                a.put(r);
                                const u = await s.fetchAsync(r);
                                if (u instanceof i.Dict) {
                                    let t = u.getRaw("Type");
                                    t instanceof i.Ref && (t = await s.fetchAsync(t));
                                    if ((0, i.isName)(t, "Page") || !u.has("Kids")) {
                                        o.has(r) || o.put(r, 1);
                                        c.has(r) || c.put(r, l);
                                        if (l === e1) return [
                                            u,
                                            r
                                        ];
                                        l++;
                                        continue;
                                    }
                                }
                                t.push(u);
                                continue;
                            }
                            if (!(r instanceof i.Dict)) throw new n.FormatError("Page dictionary kid reference points to wrong type of object.");
                            const { objId: h } = r;
                            let u = r.getRaw("Count");
                            u instanceof i.Ref && (u = await s.fetchAsync(u));
                            if (Number.isInteger(u) && u >= 0) {
                                h && !o.has(h) && o.put(h, u);
                                if (l + u <= e1) {
                                    l += u;
                                    continue;
                                }
                            }
                            let d = r.getRaw("Kids");
                            d instanceof i.Ref && (d = await s.fetchAsync(d));
                            if (!Array.isArray(d)) {
                                let t = r.getRaw("Type");
                                t instanceof i.Ref && (t = await s.fetchAsync(t));
                                if ((0, i.isName)(t, "Page") || !r.has("Kids")) {
                                    if (l === e1) return [
                                        r,
                                        null
                                    ];
                                    l++;
                                    continue;
                                }
                                throw new n.FormatError("Page dictionary kids object is not an array.");
                            }
                            for(let e1 = d.length - 1; e1 >= 0; e1--)t.push(d[e1]);
                        }
                        throw new Error(`Page index ${e1} not found.`);
                    }
                    async getAllPageDicts(e1 = !1) {
                        const { ignoreErrors: t } = this.pdfManager.evaluatorOptions, a = [
                            {
                                currentNode: this.toplevelPagesDict,
                                posInKids: 0
                            }
                        ], s = new i.RefSet, o = this._catDict.getRaw("Pages");
                        o instanceof i.Ref && s.put(o);
                        const c = new Map, l = this.xref, h = this.pageIndexCache;
                        let u = 0;
                        function addPageDict(e1, t) {
                            t && !h.has(t) && h.put(t, u);
                            c.set(u++, [
                                e1,
                                t
                            ]);
                        }
                        function addPageError(a) {
                            if (a instanceof r.XRefEntryException && !e1) throw a;
                            if (e1 && t && 0 === u) {
                                (0, n.warn)(`getAllPageDicts - Skipping invalid first page: "${a}".`);
                                a = i.Dict.empty;
                            }
                            c.set(u++, [
                                a,
                                null
                            ]);
                        }
                        for(; a.length > 0;){
                            const e1 = a.at(-1), { currentNode: t, posInKids: r } = e1;
                            let o = t.getRaw("Kids");
                            if (o instanceof i.Ref) try {
                                o = await l.fetchAsync(o);
                            } catch (e1) {
                                addPageError(e1);
                                break;
                            }
                            if (!Array.isArray(o)) {
                                addPageError(new n.FormatError("Page dictionary kids object is not an array."));
                                break;
                            }
                            if (r >= o.length) {
                                a.pop();
                                continue;
                            }
                            const c = o[r];
                            let h;
                            if (c instanceof i.Ref) {
                                if (s.has(c)) {
                                    addPageError(new n.FormatError("Pages tree contains circular reference."));
                                    break;
                                }
                                s.put(c);
                                try {
                                    h = await l.fetchAsync(c);
                                } catch (e1) {
                                    addPageError(e1);
                                    break;
                                }
                            } else h = c;
                            if (!(h instanceof i.Dict)) {
                                addPageError(new n.FormatError("Page dictionary kid reference points to wrong type of object."));
                                break;
                            }
                            let u = h.getRaw("Type");
                            if (u instanceof i.Ref) try {
                                u = await l.fetchAsync(u);
                            } catch (e1) {
                                addPageError(e1);
                                break;
                            }
                            (0, i.isName)(u, "Page") || !h.has("Kids") ? addPageDict(h, c instanceof i.Ref ? c : null) : a.push({
                                currentNode: h,
                                posInKids: 0
                            });
                            e1.posInKids++;
                        }
                        return c;
                    }
                    getPageIndex(e1) {
                        const t = this.pageIndexCache.get(e1);
                        if (void 0 !== t) return Promise.resolve(t);
                        const a = this.xref;
                        let r = 0;
                        const next = (t)=>(function pagesBeforeRef(t) {
                                let r, s = 0;
                                return a.fetchAsync(t).then(function(a) {
                                    if ((0, i.isRefsEqual)(t, e1) && !(0, i.isDict)(a, "Page") && !(a instanceof i.Dict && !a.has("Type") && a.has("Contents"))) throw new n.FormatError("The reference does not point to a /Page dictionary.");
                                    if (!a) return null;
                                    if (!(a instanceof i.Dict)) throw new n.FormatError("Node must be a dictionary.");
                                    r = a.getRaw("Parent");
                                    return a.getAsync("Parent");
                                }).then(function(e1) {
                                    if (!e1) return null;
                                    if (!(e1 instanceof i.Dict)) throw new n.FormatError("Parent must be a dictionary.");
                                    return e1.getAsync("Kids");
                                }).then(function(e1) {
                                    if (!e1) return null;
                                    const o = [];
                                    let c = !1;
                                    for (const r of e1){
                                        if (!(r instanceof i.Ref)) throw new n.FormatError("Kid must be a reference.");
                                        if ((0, i.isRefsEqual)(r, t)) {
                                            c = !0;
                                            break;
                                        }
                                        o.push(a.fetchAsync(r).then(function(e1) {
                                            if (!(e1 instanceof i.Dict)) throw new n.FormatError("Kid node must be a dictionary.");
                                            e1.has("Count") ? s += e1.get("Count") : s++;
                                        }));
                                    }
                                    if (!c) throw new n.FormatError("Kid reference not found in parent's kids.");
                                    return Promise.all(o).then(function() {
                                        return [
                                            s,
                                            r
                                        ];
                                    });
                                });
                            })(t).then((t)=>{
                                if (!t) {
                                    this.pageIndexCache.put(e1, r);
                                    return r;
                                }
                                const [a, n] = t;
                                r += a;
                                return next(n);
                            });
                        return next(e1);
                    }
                    get baseUrl() {
                        const e1 = this._catDict.get("URI");
                        if (e1 instanceof i.Dict) {
                            const t = e1.get("Base");
                            if ("string" == typeof t) {
                                const e1 = (0, n.createValidAbsoluteUrl)(t, null, {
                                    tryConvertEncoding: !0
                                });
                                if (e1) return (0, n.shadow)(this, "baseUrl", e1.href);
                            }
                        }
                        return (0, n.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
                    }
                    static parseDestDictionary({ destDict: e1, resultObj: t, docBaseUrl: a = null, docAttachments: s = null }) {
                        if (!(e1 instanceof i.Dict)) {
                            (0, n.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                            return;
                        }
                        let c, l, h = e1.get("A");
                        if (!(h instanceof i.Dict)) {
                            if (e1.has("Dest")) h = e1.get("Dest");
                            else {
                                h = e1.get("AA");
                                h instanceof i.Dict && (h.has("D") ? h = h.get("D") : h.has("U") && (h = h.get("U")));
                            }
                        }
                        if (h instanceof i.Dict) {
                            const e1 = h.get("S");
                            if (!(e1 instanceof i.Name)) {
                                (0, n.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                                return;
                            }
                            const a = e1.name;
                            switch(a){
                                case "ResetForm":
                                    const e2 = h.get("Flags"), u = 0 == (1 & ("number" == typeof e2 ? e2 : 0)), d = [], f = [];
                                    for (const e1 of h.get("Fields") || [])e1 instanceof i.Ref ? f.push(e1.toString()) : "string" == typeof e1 && d.push((0, n.stringToPDFString)(e1));
                                    t.resetForm = {
                                        fields: d,
                                        refs: f,
                                        include: u
                                    };
                                    break;
                                case "URI":
                                    c = h.get("URI");
                                    c instanceof i.Name && (c = "/" + c.name);
                                    break;
                                case "GoTo":
                                    l = h.get("D");
                                    break;
                                case "Launch":
                                case "GoToR":
                                    const g = h.get("F");
                                    g instanceof i.Dict ? c = g.get("F") || null : "string" == typeof g && (c = g);
                                    let p = h.get("D");
                                    if (p) {
                                        p instanceof i.Name && (p = p.name);
                                        if ("string" == typeof c) {
                                            const e1 = c.split("#")[0];
                                            "string" == typeof p ? c = e1 + "#" + p : Array.isArray(p) && (c = e1 + "#" + JSON.stringify(p));
                                        }
                                    }
                                    const m = h.get("NewWindow");
                                    "boolean" == typeof m && (t.newWindow = m);
                                    break;
                                case "GoToE":
                                    const b = h.get("T");
                                    let y;
                                    if (s && b instanceof i.Dict) {
                                        const e1 = b.get("R"), t = b.get("N");
                                        (0, i.isName)(e1, "C") && "string" == typeof t && (y = s[(0, n.stringToPDFString)(t)]);
                                    }
                                    y ? t.attachment = y : (0, n.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                                    break;
                                case "Named":
                                    const w = h.get("N");
                                    w instanceof i.Name && (t.action = w.name);
                                    break;
                                case "SetOCGState":
                                    const S = h.get("State"), x = h.get("PreserveRB");
                                    if (!Array.isArray(S) || 0 === S.length) break;
                                    const C = [];
                                    for (const e1 of S)if (e1 instanceof i.Name) switch(e1.name){
                                        case "ON":
                                        case "OFF":
                                        case "Toggle":
                                            C.push(e1.name);
                                    }
                                    else e1 instanceof i.Ref && C.push(e1.toString());
                                    if (C.length !== S.length) break;
                                    t.setOCGState = {
                                        state: C,
                                        preserveRB: "boolean" != typeof x || x
                                    };
                                    break;
                                case "JavaScript":
                                    const k = h.get("JS");
                                    let v;
                                    k instanceof o.BaseStream ? v = k.getString() : "string" == typeof k && (v = k);
                                    const F = v && (0, r.recoverJsURL)((0, n.stringToPDFString)(v));
                                    if (F) {
                                        c = F.url;
                                        t.newWindow = F.newWindow;
                                        break;
                                    }
                                default:
                                    if ("JavaScript" === a || "SubmitForm" === a) break;
                                    (0, n.warn)(`parseDestDictionary - unsupported action: "${a}".`);
                            }
                        } else e1.has("Dest") && (l = e1.get("Dest"));
                        if ("string" == typeof c) {
                            const e1 = (0, n.createValidAbsoluteUrl)(c, a, {
                                addDefaultProtocol: !0,
                                tryConvertEncoding: !0
                            });
                            e1 && (t.url = e1.href);
                            t.unsafeUrl = c;
                        }
                        if (l) {
                            l instanceof i.Name && (l = l.name);
                            "string" == typeof l ? t.dest = (0, n.stringToPDFString)(l) : Array.isArray(l) && (t.dest = l);
                        }
                    }
                }
                t.Catalog = Catalog;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.NumberTree = t.NameTree = void 0;
                var r = a(4), n = a(2);
                class NameOrNumberTree {
                    constructor(e1, t, a){
                        this.constructor === NameOrNumberTree && (0, n.unreachable)("Cannot initialize NameOrNumberTree.");
                        this.root = e1;
                        this.xref = t;
                        this._type = a;
                    }
                    getAll() {
                        const e1 = new Map;
                        if (!this.root) return e1;
                        const t = this.xref, a = new r.RefSet;
                        a.put(this.root);
                        const i = [
                            this.root
                        ];
                        for(; i.length > 0;){
                            const s = t.fetchIfRef(i.shift());
                            if (!(s instanceof r.Dict)) continue;
                            if (s.has("Kids")) {
                                const e1 = s.get("Kids");
                                if (!Array.isArray(e1)) continue;
                                for (const t of e1){
                                    if (a.has(t)) throw new n.FormatError(`Duplicate entry in "${this._type}" tree.`);
                                    i.push(t);
                                    a.put(t);
                                }
                                continue;
                            }
                            const o = s.get(this._type);
                            if (Array.isArray(o)) for(let a = 0, r = o.length; a < r; a += 2)e1.set(t.fetchIfRef(o[a]), t.fetchIfRef(o[a + 1]));
                        }
                        return e1;
                    }
                    get(e1) {
                        if (!this.root) return null;
                        const t = this.xref;
                        let a = t.fetchIfRef(this.root), r = 0;
                        for(; a.has("Kids");){
                            if (++r > 10) {
                                (0, n.warn)(`Search depth limit reached for "${this._type}" tree.`);
                                return null;
                            }
                            const i = a.get("Kids");
                            if (!Array.isArray(i)) return null;
                            let s = 0, o = i.length - 1;
                            for(; s <= o;){
                                const r = s + o >> 1, n = t.fetchIfRef(i[r]), c = n.get("Limits");
                                if (e1 < t.fetchIfRef(c[0])) o = r - 1;
                                else {
                                    if (!(e1 > t.fetchIfRef(c[1]))) {
                                        a = n;
                                        break;
                                    }
                                    s = r + 1;
                                }
                            }
                            if (s > o) return null;
                        }
                        const i = a.get(this._type);
                        if (Array.isArray(i)) {
                            let a = 0, r = i.length - 2;
                            for(; a <= r;){
                                const n = a + r >> 1, s = n + (1 & n), o = t.fetchIfRef(i[s]);
                                if (e1 < o) r = s - 2;
                                else {
                                    if (!(e1 > o)) return t.fetchIfRef(i[s + 1]);
                                    a = s + 2;
                                }
                            }
                        }
                        return null;
                    }
                }
                t.NameTree = class NameTree extends NameOrNumberTree {
                    constructor(e1, t){
                        super(e1, t, "Names");
                    }
                };
                t.NumberTree = class NumberTree extends NameOrNumberTree {
                    constructor(e1, t){
                        super(e1, t, "Nums");
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.clearGlobalCaches = function clearGlobalCaches() {
                    (0, r.clearPatternCaches)();
                    (0, n.clearPrimitiveCaches)();
                    (0, i.clearUnicodeCaches)();
                };
                var r = a(50), n = a(4), i = a(40);
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.FileSpec = void 0;
                var r = a(2), n = a(5), i = a(4);
                function pickPlatformItem(e1) {
                    return e1.has("UF") ? e1.get("UF") : e1.has("F") ? e1.get("F") : e1.has("Unix") ? e1.get("Unix") : e1.has("Mac") ? e1.get("Mac") : e1.has("DOS") ? e1.get("DOS") : null;
                }
                t.FileSpec = class FileSpec {
                    constructor(e1, t){
                        if (e1 instanceof i.Dict) {
                            this.xref = t;
                            this.root = e1;
                            e1.has("FS") && (this.fs = e1.get("FS"));
                            this.description = e1.has("Desc") ? (0, r.stringToPDFString)(e1.get("Desc")) : "";
                            e1.has("RF") && (0, r.warn)("Related file specifications are not supported");
                            this.contentAvailable = !0;
                            if (!e1.has("EF")) {
                                this.contentAvailable = !1;
                                (0, r.warn)("Non-embedded file specifications are not supported");
                            }
                        }
                    }
                    get filename() {
                        if (!this._filename && this.root) {
                            const e1 = pickPlatformItem(this.root) || "unnamed";
                            this._filename = (0, r.stringToPDFString)(e1).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
                        }
                        return this._filename;
                    }
                    get content() {
                        if (!this.contentAvailable) return null;
                        !this.contentRef && this.root && (this.contentRef = pickPlatformItem(this.root.get("EF")));
                        let e1 = null;
                        if (this.contentRef) {
                            const t = this.xref.fetchIfRef(this.contentRef);
                            t instanceof n.BaseStream ? e1 = t.getBytes() : (0, r.warn)("Embedded file specification points to non-existing/invalid content");
                        } else (0, r.warn)("Embedded file specification does not have a content");
                        return e1;
                    }
                    get serializable() {
                        return {
                            filename: this.filename,
                            content: this.content
                        };
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.MetadataParser = void 0;
                var r = a(71);
                t.MetadataParser = class MetadataParser {
                    constructor(e1){
                        e1 = this._repair(e1);
                        const t = new r.SimpleXMLParser({
                            lowerCaseName: !0
                        }).parseFromString(e1);
                        this._metadataMap = new Map;
                        this._data = e1;
                        t && this._parse(t);
                    }
                    _repair(e1) {
                        return e1.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(e1, t) {
                            const a = t.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(e1, t, a, r) {
                                return String.fromCharCode(64 * t + 8 * a + 1 * r);
                            }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(e1, t) {
                                switch(t){
                                    case "amp":
                                        return "&";
                                    case "apos":
                                        return "'";
                                    case "gt":
                                        return ">";
                                    case "lt":
                                        return "<";
                                    case "quot":
                                        return '"';
                                }
                                throw new Error(`_repair: ${t} isn't defined.`);
                            }), r = [
                                ">"
                            ];
                            for(let e1 = 0, t = a.length; e1 < t; e1 += 2){
                                const t = 256 * a.charCodeAt(e1) + a.charCodeAt(e1 + 1);
                                t >= 32 && t < 127 && 60 !== t && 62 !== t && 38 !== t ? r.push(String.fromCharCode(t)) : r.push("&#x" + (65536 + t).toString(16).substring(1) + ";");
                            }
                            return r.join("");
                        });
                    }
                    _getSequence(e1) {
                        const t = e1.nodeName;
                        return "rdf:bag" !== t && "rdf:seq" !== t && "rdf:alt" !== t ? null : e1.childNodes.filter((e1)=>"rdf:li" === e1.nodeName);
                    }
                    _parseArray(e1) {
                        if (!e1.hasChildNodes()) return;
                        const [t] = e1.childNodes, a = this._getSequence(t) || [];
                        this._metadataMap.set(e1.nodeName, a.map((e1)=>e1.textContent.trim()));
                    }
                    _parse(e1) {
                        let t = e1.documentElement;
                        if ("rdf:rdf" !== t.nodeName) {
                            t = t.firstChild;
                            for(; t && "rdf:rdf" !== t.nodeName;)t = t.nextSibling;
                        }
                        if (t && "rdf:rdf" === t.nodeName && t.hasChildNodes()) {
                            for (const e1 of t.childNodes)if ("rdf:description" === e1.nodeName) for (const t of e1.childNodes){
                                const e1 = t.nodeName;
                                switch(e1){
                                    case "#text":
                                        continue;
                                    case "dc:creator":
                                    case "dc:subject":
                                        this._parseArray(t);
                                        continue;
                                }
                                this._metadataMap.set(e1, t.textContent.trim());
                            }
                        }
                    }
                    get serializable() {
                        return {
                            parsedData: this._metadataMap,
                            rawData: this._data
                        };
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XMLParserErrorCode = t.XMLParserBase = t.SimpleXMLParser = t.SimpleDOMNode = void 0;
                var r = a(3);
                const n = {
                    NoError: 0,
                    EndOfDocument: -1,
                    UnterminatedCdat: -2,
                    UnterminatedXmlDeclaration: -3,
                    UnterminatedDoctypeDeclaration: -4,
                    UnterminatedComment: -5,
                    MalformedElement: -6,
                    OutOfMemory: -7,
                    UnterminatedAttributeValue: -8,
                    UnterminatedElement: -9,
                    ElementNeverBegun: -10
                };
                t.XMLParserErrorCode = n;
                function isWhitespace(e1, t) {
                    const a = e1[t];
                    return " " === a || "\n" === a || "\r" === a || "\t" === a;
                }
                class XMLParserBase {
                    _resolveEntities(e1) {
                        return e1.replaceAll(/&([^;]+);/g, (e1, t)=>{
                            if ("#x" === t.substring(0, 2)) return String.fromCodePoint(parseInt(t.substring(2), 16));
                            if ("#" === t.substring(0, 1)) return String.fromCodePoint(parseInt(t.substring(1), 10));
                            switch(t){
                                case "lt":
                                    return "<";
                                case "gt":
                                    return ">";
                                case "amp":
                                    return "&";
                                case "quot":
                                    return '"';
                                case "apos":
                                    return "'";
                            }
                            return this.onResolveEntity(t);
                        });
                    }
                    _parseContent(e1, t) {
                        const a = [];
                        let r = t;
                        function skipWs() {
                            for(; r < e1.length && isWhitespace(e1, r);)++r;
                        }
                        for(; r < e1.length && !isWhitespace(e1, r) && ">" !== e1[r] && "/" !== e1[r];)++r;
                        const n = e1.substring(t, r);
                        skipWs();
                        for(; r < e1.length && ">" !== e1[r] && "/" !== e1[r] && "?" !== e1[r];){
                            skipWs();
                            let t = "", n = "";
                            for(; r < e1.length && !isWhitespace(e1, r) && "=" !== e1[r];){
                                t += e1[r];
                                ++r;
                            }
                            skipWs();
                            if ("=" !== e1[r]) return null;
                            ++r;
                            skipWs();
                            const i = e1[r];
                            if ('"' !== i && "'" !== i) return null;
                            const s = e1.indexOf(i, ++r);
                            if (s < 0) return null;
                            n = e1.substring(r, s);
                            a.push({
                                name: t,
                                value: this._resolveEntities(n)
                            });
                            r = s + 1;
                            skipWs();
                        }
                        return {
                            name: n,
                            attributes: a,
                            parsed: r - t
                        };
                    }
                    _parseProcessingInstruction(e1, t) {
                        let a = t;
                        for(; a < e1.length && !isWhitespace(e1, a) && ">" !== e1[a] && "?" !== e1[a] && "/" !== e1[a];)++a;
                        const r = e1.substring(t, a);
                        !function skipWs() {
                            for(; a < e1.length && isWhitespace(e1, a);)++a;
                        }();
                        const n = a;
                        for(; a < e1.length && ("?" !== e1[a] || ">" !== e1[a + 1]);)++a;
                        return {
                            name: r,
                            value: e1.substring(n, a),
                            parsed: a - t
                        };
                    }
                    parseXml(e1) {
                        let t = 0;
                        for(; t < e1.length;){
                            let a = t;
                            if ("<" === e1[t]) {
                                ++a;
                                let t;
                                switch(e1[a]){
                                    case "/":
                                        ++a;
                                        t = e1.indexOf(">", a);
                                        if (t < 0) {
                                            this.onError(n.UnterminatedElement);
                                            return;
                                        }
                                        this.onEndElement(e1.substring(a, t));
                                        a = t + 1;
                                        break;
                                    case "?":
                                        ++a;
                                        const r = this._parseProcessingInstruction(e1, a);
                                        if ("?>" !== e1.substring(a + r.parsed, a + r.parsed + 2)) {
                                            this.onError(n.UnterminatedXmlDeclaration);
                                            return;
                                        }
                                        this.onPi(r.name, r.value);
                                        a += r.parsed + 2;
                                        break;
                                    case "!":
                                        if ("--" === e1.substring(a + 1, a + 3)) {
                                            t = e1.indexOf("--\x3e", a + 3);
                                            if (t < 0) {
                                                this.onError(n.UnterminatedComment);
                                                return;
                                            }
                                            this.onComment(e1.substring(a + 3, t));
                                            a = t + 3;
                                        } else if ("[CDATA[" === e1.substring(a + 1, a + 8)) {
                                            t = e1.indexOf("]]>", a + 8);
                                            if (t < 0) {
                                                this.onError(n.UnterminatedCdat);
                                                return;
                                            }
                                            this.onCdata(e1.substring(a + 8, t));
                                            a = t + 3;
                                        } else {
                                            if ("DOCTYPE" !== e1.substring(a + 1, a + 8)) {
                                                this.onError(n.MalformedElement);
                                                return;
                                            }
                                            {
                                                const r = e1.indexOf("[", a + 8);
                                                let i = !1;
                                                t = e1.indexOf(">", a + 8);
                                                if (t < 0) {
                                                    this.onError(n.UnterminatedDoctypeDeclaration);
                                                    return;
                                                }
                                                if (r > 0 && t > r) {
                                                    t = e1.indexOf("]>", a + 8);
                                                    if (t < 0) {
                                                        this.onError(n.UnterminatedDoctypeDeclaration);
                                                        return;
                                                    }
                                                    i = !0;
                                                }
                                                const s = e1.substring(a + 8, t + (i ? 1 : 0));
                                                this.onDoctype(s);
                                                a = t + (i ? 2 : 1);
                                            }
                                        }
                                        break;
                                    default:
                                        const i = this._parseContent(e1, a);
                                        if (null === i) {
                                            this.onError(n.MalformedElement);
                                            return;
                                        }
                                        let s = !1;
                                        if ("/>" === e1.substring(a + i.parsed, a + i.parsed + 2)) s = !0;
                                        else if (">" !== e1.substring(a + i.parsed, a + i.parsed + 1)) {
                                            this.onError(n.UnterminatedElement);
                                            return;
                                        }
                                        this.onBeginElement(i.name, i.attributes, s);
                                        a += i.parsed + (s ? 2 : 1);
                                }
                            } else {
                                for(; a < e1.length && "<" !== e1[a];)a++;
                                const r = e1.substring(t, a);
                                this.onText(this._resolveEntities(r));
                            }
                            t = a;
                        }
                    }
                    onResolveEntity(e1) {
                        return `&${e1};`;
                    }
                    onPi(e1, t) {}
                    onComment(e1) {}
                    onCdata(e1) {}
                    onDoctype(e1) {}
                    onText(e1) {}
                    onBeginElement(e1, t, a) {}
                    onEndElement(e1) {}
                    onError(e1) {}
                }
                t.XMLParserBase = XMLParserBase;
                class SimpleDOMNode {
                    constructor(e1, t){
                        this.nodeName = e1;
                        this.nodeValue = t;
                        Object.defineProperty(this, "parentNode", {
                            value: null,
                            writable: !0
                        });
                    }
                    get firstChild() {
                        return this.childNodes?.[0];
                    }
                    get nextSibling() {
                        const e1 = this.parentNode.childNodes;
                        if (!e1) return;
                        const t = e1.indexOf(this);
                        return -1 !== t ? e1[t + 1] : void 0;
                    }
                    get textContent() {
                        return this.childNodes ? this.childNodes.map(function(e1) {
                            return e1.textContent;
                        }).join("") : this.nodeValue || "";
                    }
                    get children() {
                        return this.childNodes || [];
                    }
                    hasChildNodes() {
                        return this.childNodes?.length > 0;
                    }
                    searchNode(e1, t) {
                        if (t >= e1.length) return this;
                        const a = e1[t];
                        if (a.name.startsWith("#") && t < e1.length - 1) return this.searchNode(e1, t + 1);
                        const r = [];
                        let n = this;
                        for(;;){
                            if (a.name === n.nodeName) {
                                if (0 !== a.pos) {
                                    if (0 === r.length) return null;
                                    {
                                        const [i] = r.pop();
                                        let s = 0;
                                        for (const r of i.childNodes)if (a.name === r.nodeName) {
                                            if (s === a.pos) return r.searchNode(e1, t + 1);
                                            s++;
                                        }
                                        return n.searchNode(e1, t + 1);
                                    }
                                }
                                {
                                    const a = n.searchNode(e1, t + 1);
                                    if (null !== a) return a;
                                }
                            }
                            if (n.childNodes?.length > 0) {
                                r.push([
                                    n,
                                    0
                                ]);
                                n = n.childNodes[0];
                            } else {
                                if (0 === r.length) return null;
                                for(; 0 !== r.length;){
                                    const [e1, t] = r.pop(), a = t + 1;
                                    if (a < e1.childNodes.length) {
                                        r.push([
                                            e1,
                                            a
                                        ]);
                                        n = e1.childNodes[a];
                                        break;
                                    }
                                }
                                if (0 === r.length) return null;
                            }
                        }
                    }
                    dump(e1) {
                        if ("#text" !== this.nodeName) {
                            e1.push(`<${this.nodeName}`);
                            if (this.attributes) for (const t of this.attributes)e1.push(` ${t.name}="${(0, r.encodeToXmlString)(t.value)}"`);
                            if (this.hasChildNodes()) {
                                e1.push(">");
                                for (const t of this.childNodes)t.dump(e1);
                                e1.push(`</${this.nodeName}>`);
                            } else this.nodeValue ? e1.push(`>${(0, r.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : e1.push("/>");
                        } else e1.push((0, r.encodeToXmlString)(this.nodeValue));
                    }
                }
                t.SimpleDOMNode = SimpleDOMNode;
                t.SimpleXMLParser = class SimpleXMLParser extends XMLParserBase {
                    constructor({ hasAttributes: e1 = !1, lowerCaseName: t = !1 }){
                        super();
                        this._currentFragment = null;
                        this._stack = null;
                        this._errorCode = n.NoError;
                        this._hasAttributes = e1;
                        this._lowerCaseName = t;
                    }
                    parseFromString(e1) {
                        this._currentFragment = [];
                        this._stack = [];
                        this._errorCode = n.NoError;
                        this.parseXml(e1);
                        if (this._errorCode !== n.NoError) return;
                        const [t] = this._currentFragment;
                        return t ? {
                            documentElement: t
                        } : void 0;
                    }
                    onText(e1) {
                        if (function isWhitespaceString(e1) {
                            for(let t = 0, a = e1.length; t < a; t++)if (!isWhitespace(e1, t)) return !1;
                            return !0;
                        }(e1)) return;
                        const t = new SimpleDOMNode("#text", e1);
                        this._currentFragment.push(t);
                    }
                    onCdata(e1) {
                        const t = new SimpleDOMNode("#text", e1);
                        this._currentFragment.push(t);
                    }
                    onBeginElement(e1, t, a) {
                        this._lowerCaseName && (e1 = e1.toLowerCase());
                        const r = new SimpleDOMNode(e1);
                        r.childNodes = [];
                        this._hasAttributes && (r.attributes = t);
                        this._currentFragment.push(r);
                        if (!a) {
                            this._stack.push(this._currentFragment);
                            this._currentFragment = r.childNodes;
                        }
                    }
                    onEndElement(e1) {
                        this._currentFragment = this._stack.pop() || [];
                        const t = this._currentFragment.at(-1);
                        if (!t) return null;
                        for (const e1 of t.childNodes)e1.parentNode = t;
                        return t;
                    }
                    onError(e1) {
                        this._errorCode = e1;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.StructTreeRoot = t.StructTreePage = void 0;
                var r = a(2), n = a(4), i = a(67), s = a(73);
                const o = 1, c = 2, l = 3, h = 4, u = 5;
                class StructTreeRoot {
                    constructor(e1, t){
                        this.dict = e1;
                        this.ref = t instanceof n.Ref ? t : null;
                        this.roleMap = new Map;
                        this.structParentIds = null;
                    }
                    init() {
                        this.readRoleMap();
                    }
                    #C(e1, t, a) {
                        if (!(e1 instanceof n.Ref) || t < 0) return;
                        this.structParentIds ||= new n.RefSetCache;
                        let r = this.structParentIds.get(e1);
                        if (!r) {
                            r = [];
                            this.structParentIds.put(e1, r);
                        }
                        r.push([
                            t,
                            a
                        ]);
                    }
                    addAnnotationIdToPage(e1, t) {
                        this.#C(e1, t, h);
                    }
                    readRoleMap() {
                        const e1 = this.dict.get("RoleMap");
                        e1 instanceof n.Dict && e1.forEach((e1, t)=>{
                            t instanceof n.Name && this.roleMap.set(e1, t.name);
                        });
                    }
                    static async canCreateStructureTree({ catalogRef: e1, pdfManager: t, newAnnotationsByPage: a }) {
                        if (!(e1 instanceof n.Ref)) {
                            (0, r.warn)("Cannot save the struct tree: no catalog reference.");
                            return !1;
                        }
                        let i = 0, s = !0;
                        for (const [e1, o] of a){
                            const { ref: a } = await t.getPage(e1);
                            if (!(a instanceof n.Ref)) {
                                (0, r.warn)(`Cannot save the struct tree: page ${e1} has no ref.`);
                                s = !0;
                                break;
                            }
                            for (const e1 of o)if (e1.accessibilityData?.type) {
                                e1.parentTreeId = i++;
                                s = !1;
                            }
                        }
                        if (s) {
                            for (const e1 of a.values())for (const t of e1)delete t.parentTreeId;
                            return !1;
                        }
                        return !0;
                    }
                    static async createStructureTree({ newAnnotationsByPage: e1, xref: t, catalogRef: a, pdfManager: r, newRefs: i }) {
                        const o = r.catalog.cloneDict(), c = t.getNewTemporaryRef();
                        o.set("StructTreeRoot", c);
                        const l = [];
                        await (0, s.writeObject)(a, o, l, t);
                        i.push({
                            ref: a,
                            data: l.join("")
                        });
                        const h = new n.Dict(t);
                        h.set("Type", n.Name.get("StructTreeRoot"));
                        const u = t.getNewTemporaryRef();
                        h.set("ParentTree", u);
                        const d = [];
                        h.set("K", d);
                        const f = new n.Dict(t), g = [];
                        f.set("Nums", g);
                        const p = await this.#k({
                            newAnnotationsByPage: e1,
                            structTreeRootRef: c,
                            kids: d,
                            nums: g,
                            xref: t,
                            pdfManager: r,
                            newRefs: i,
                            buffer: l
                        });
                        h.set("ParentTreeNextKey", p);
                        l.length = 0;
                        await (0, s.writeObject)(u, f, l, t);
                        i.push({
                            ref: u,
                            data: l.join("")
                        });
                        l.length = 0;
                        await (0, s.writeObject)(c, h, l, t);
                        i.push({
                            ref: c,
                            data: l.join("")
                        });
                    }
                    async canUpdateStructTree({ pdfManager: e1, newAnnotationsByPage: t }) {
                        if (!this.ref) {
                            (0, r.warn)("Cannot update the struct tree: no root reference.");
                            return !1;
                        }
                        let a = this.dict.get("ParentTreeNextKey");
                        if (!Number.isInteger(a) || a < 0) {
                            (0, r.warn)("Cannot update the struct tree: invalid next key.");
                            return !1;
                        }
                        const i = this.dict.get("ParentTree");
                        if (!(i instanceof n.Dict)) {
                            (0, r.warn)("Cannot update the struct tree: ParentTree isn't a dict.");
                            return !1;
                        }
                        const s = i.get("Nums");
                        if (!Array.isArray(s)) {
                            (0, r.warn)("Cannot update the struct tree: nums isn't an array.");
                            return !1;
                        }
                        const { numPages: o } = e1.catalog;
                        for (const a of t.keys()){
                            const { pageDict: t, ref: i } = await e1.getPage(a);
                            if (!(i instanceof n.Ref)) {
                                (0, r.warn)(`Cannot save the struct tree: page ${a} has no ref.`);
                                return !1;
                            }
                            const s = t.get("StructParents");
                            if (!Number.isInteger(s) || s < 0 || s >= o) {
                                (0, r.warn)(`Cannot save the struct tree: page ${a} has no id.`);
                                return !1;
                            }
                        }
                        let c = !0;
                        for (const [r, n] of t){
                            const { pageDict: t } = await e1.getPage(r);
                            StructTreeRoot.#v({
                                elements: n,
                                xref: this.dict.xref,
                                pageDict: t,
                                parentTree: i
                            });
                            for (const e1 of n)if (e1.accessibilityData?.type) {
                                e1.parentTreeId = a++;
                                c = !1;
                            }
                        }
                        if (c) {
                            for (const e1 of t.values())for (const t of e1){
                                delete t.parentTreeId;
                                delete t.structTreeParent;
                            }
                            return !1;
                        }
                        return !0;
                    }
                    async updateStructureTree({ newAnnotationsByPage: e1, pdfManager: t, newRefs: a }) {
                        const r = this.dict.xref, i = this.dict.clone(), o = this.ref;
                        let c, l = i.getRaw("ParentTree");
                        if (l instanceof n.Ref) c = r.fetch(l);
                        else {
                            c = l;
                            l = r.getNewTemporaryRef();
                            i.set("ParentTree", l);
                        }
                        c = c.clone();
                        let h = c.getRaw("Nums"), u = null;
                        if (h instanceof n.Ref) {
                            u = h;
                            h = r.fetch(u);
                        }
                        h = h.slice();
                        u || c.set("Nums", h);
                        let d = i.getRaw("K"), f = null;
                        if (d instanceof n.Ref) {
                            f = d;
                            d = r.fetch(f);
                        } else {
                            f = r.getNewTemporaryRef();
                            i.set("K", f);
                        }
                        d = Array.isArray(d) ? d.slice() : [
                            d
                        ];
                        const g = [], p = await StructTreeRoot.#k({
                            newAnnotationsByPage: e1,
                            structTreeRootRef: o,
                            kids: d,
                            nums: h,
                            xref: r,
                            pdfManager: t,
                            newRefs: a,
                            buffer: g
                        });
                        i.set("ParentTreeNextKey", p);
                        g.length = 0;
                        await (0, s.writeObject)(f, d, g, r);
                        a.push({
                            ref: f,
                            data: g.join("")
                        });
                        if (u) {
                            g.length = 0;
                            await (0, s.writeObject)(u, h, g, r);
                            a.push({
                                ref: u,
                                data: g.join("")
                            });
                        }
                        g.length = 0;
                        await (0, s.writeObject)(l, c, g, r);
                        a.push({
                            ref: l,
                            data: g.join("")
                        });
                        g.length = 0;
                        await (0, s.writeObject)(o, i, g, r);
                        a.push({
                            ref: o,
                            data: g.join("")
                        });
                    }
                    static async #k({ newAnnotationsByPage: e1, structTreeRootRef: t, kids: a, nums: r, xref: i, pdfManager: o, newRefs: c, buffer: l }) {
                        const h = n.Name.get("OBJR");
                        let u = -1 / 0;
                        for (const [d, f] of e1){
                            const { ref: e1 } = await o.getPage(d);
                            for (const { accessibilityData: { type: o, title: d, lang: g, alt: p, expanded: m, actualText: b }, ref: y, parentTreeId: w, structTreeParent: S } of f){
                                u = Math.max(u, w);
                                const f = i.getNewTemporaryRef(), x = new n.Dict(i);
                                x.set("S", n.Name.get(o));
                                d && x.set("T", d);
                                g && x.set("Lang", g);
                                p && x.set("Alt", p);
                                m && x.set("E", m);
                                b && x.set("ActualText", b);
                                S ? await this.#F({
                                    structTreeParent: S,
                                    tagDict: x,
                                    newTagRef: f,
                                    fallbackRef: t,
                                    xref: i,
                                    newRefs: c,
                                    buffer: l
                                }) : x.set("P", t);
                                const C = new n.Dict(i);
                                x.set("K", C);
                                C.set("Type", h);
                                C.set("Pg", e1);
                                C.set("Obj", y);
                                l.length = 0;
                                await (0, s.writeObject)(f, x, l, i);
                                c.push({
                                    ref: f,
                                    data: l.join("")
                                });
                                r.push(w, f);
                                a.push(f);
                            }
                        }
                        return u + 1;
                    }
                    static #v({ elements: e1, xref: t, pageDict: a, parentTree: r }) {
                        const s = new Map;
                        for (const t of e1)if (t.structTreeParentId) {
                            const e1 = parseInt(t.structTreeParentId.split("_mc")[1], 10);
                            s.set(e1, t);
                        }
                        const o = a.get("StructParents"), c = new i.NumberTree(r, t).get(o);
                        if (!Array.isArray(c)) return;
                        const updateElement = (e1, a, r)=>{
                            const i = s.get(e1);
                            if (i) {
                                const e1 = a.getRaw("P"), s = t.fetchIfRef(e1);
                                e1 instanceof n.Ref && s instanceof n.Dict && (i.structTreeParent = {
                                    ref: r,
                                    dict: a
                                });
                                return !0;
                            }
                            return !1;
                        };
                        for (const e1 of c){
                            if (!(e1 instanceof n.Ref)) continue;
                            const a = t.fetch(e1), r = a.get("K");
                            if (Number.isInteger(r)) updateElement(r, a, e1);
                            else if (Array.isArray(r)) for (let n of r){
                                n = t.fetchIfRef(n);
                                if (Number.isInteger(n) && updateElement(n, a, e1)) break;
                            }
                        }
                    }
                    static async #F({ structTreeParent: { ref: e1, dict: t }, tagDict: a, newTagRef: i, fallbackRef: o, xref: c, newRefs: l, buffer: h }) {
                        const u = t.getRaw("P");
                        let d = c.fetchIfRef(u);
                        a.set("P", u);
                        let f, g = !1, p = d.getRaw("K");
                        if (p instanceof n.Ref) f = c.fetch(p);
                        else {
                            f = p;
                            p = c.getNewTemporaryRef();
                            d = d.clone();
                            d.set("K", p);
                            g = !0;
                        }
                        if (Array.isArray(f)) {
                            const t = f.indexOf(e1);
                            if (!(t >= 0)) {
                                (0, r.warn)("Cannot update the struct tree: parent kid not found.");
                                a.set("P", o);
                                return;
                            }
                            f = f.slice();
                            f.splice(t + 1, 0, i);
                        } else if (f instanceof n.Dict) {
                            f = [
                                p,
                                i
                            ];
                            p = c.getNewTemporaryRef();
                            d.set("K", p);
                            g = !0;
                        }
                        h.length = 0;
                        await (0, s.writeObject)(p, f, h, c);
                        l.push({
                            ref: p,
                            data: h.join("")
                        });
                        if (g) {
                            h.length = 0;
                            await (0, s.writeObject)(u, d, h, c);
                            l.push({
                                ref: u,
                                data: h.join("")
                            });
                        }
                    }
                }
                t.StructTreeRoot = StructTreeRoot;
                class StructElementNode {
                    constructor(e1, t){
                        this.tree = e1;
                        this.dict = t;
                        this.kids = [];
                        this.parseKids();
                    }
                    get role() {
                        const e1 = this.dict.get("S"), t = e1 instanceof n.Name ? e1.name : "", { root: a } = this.tree;
                        return a.roleMap.has(t) ? a.roleMap.get(t) : t;
                    }
                    parseKids() {
                        let e1 = null;
                        const t = this.dict.getRaw("Pg");
                        t instanceof n.Ref && (e1 = t.toString());
                        const a = this.dict.get("K");
                        if (Array.isArray(a)) for (const t of a){
                            const a = this.parseKid(e1, t);
                            a && this.kids.push(a);
                        }
                        else {
                            const t = this.parseKid(e1, a);
                            t && this.kids.push(t);
                        }
                    }
                    parseKid(e1, t) {
                        if (Number.isInteger(t)) return this.tree.pageDict.objId !== e1 ? null : new StructElement({
                            type: o,
                            mcid: t,
                            pageObjId: e1
                        });
                        let a = null;
                        t instanceof n.Ref ? a = this.dict.xref.fetch(t) : t instanceof n.Dict && (a = t);
                        if (!a) return null;
                        const r = a.getRaw("Pg");
                        r instanceof n.Ref && (e1 = r.toString());
                        const i = a.get("Type") instanceof n.Name ? a.get("Type").name : null;
                        if ("MCR" === i) {
                            if (this.tree.pageDict.objId !== e1) return null;
                            const t = a.getRaw("Stm");
                            return new StructElement({
                                type: c,
                                refObjId: t instanceof n.Ref ? t.toString() : null,
                                pageObjId: e1,
                                mcid: a.get("MCID")
                            });
                        }
                        if ("OBJR" === i) {
                            if (this.tree.pageDict.objId !== e1) return null;
                            const t = a.getRaw("Obj");
                            return new StructElement({
                                type: l,
                                refObjId: t instanceof n.Ref ? t.toString() : null,
                                pageObjId: e1
                            });
                        }
                        return new StructElement({
                            type: u,
                            dict: a
                        });
                    }
                }
                class StructElement {
                    constructor({ type: e1, dict: t = null, mcid: a = null, pageObjId: r = null, refObjId: n = null }){
                        this.type = e1;
                        this.dict = t;
                        this.mcid = a;
                        this.pageObjId = r;
                        this.refObjId = n;
                        this.parentNode = null;
                    }
                }
                t.StructTreePage = class StructTreePage {
                    constructor(e1, t){
                        this.root = e1;
                        this.rootDict = e1 ? e1.dict : null;
                        this.pageDict = t;
                        this.nodes = [];
                    }
                    parse(e1) {
                        if (!this.root || !this.rootDict) return;
                        const t = this.rootDict.get("ParentTree");
                        if (!t) return;
                        const a = this.pageDict.get("StructParents"), r = e1 instanceof n.Ref && this.root.structParentIds?.get(e1);
                        if (!Number.isInteger(a) && !r) return;
                        const s = new Map, o = new i.NumberTree(t, this.rootDict.xref);
                        if (Number.isInteger(a)) {
                            const e1 = o.get(a);
                            if (Array.isArray(e1)) for (const t of e1)t instanceof n.Ref && this.addNode(this.rootDict.xref.fetch(t), s);
                        }
                        if (r) for (const [e1, t] of r){
                            const a = o.get(e1);
                            if (a) {
                                const e1 = this.addNode(this.rootDict.xref.fetchIfRef(a), s);
                                1 === e1?.kids?.length && e1.kids[0].type === l && (e1.kids[0].type = t);
                            }
                        }
                    }
                    addNode(e1, t, a = 0) {
                        if (a > 40) {
                            (0, r.warn)("StructTree MAX_DEPTH reached.");
                            return null;
                        }
                        if (t.has(e1)) return t.get(e1);
                        const i = new StructElementNode(this, e1);
                        t.set(e1, i);
                        const s = e1.get("P");
                        if (!s || (0, n.isName)(s.get("Type"), "StructTreeRoot")) {
                            this.addTopLevelNode(e1, i) || t.delete(e1);
                            return i;
                        }
                        const o = this.addNode(s, t, a + 1);
                        if (!o) return i;
                        let c = !1;
                        for (const t of o.kids)if (t.type === u && t.dict === e1) {
                            t.parentNode = i;
                            c = !0;
                        }
                        c || t.delete(e1);
                        return i;
                    }
                    addTopLevelNode(e1, t) {
                        const a = this.rootDict.get("K");
                        if (!a) return !1;
                        if (a instanceof n.Dict) {
                            if (a.objId !== e1.objId) return !1;
                            this.nodes[0] = t;
                            return !0;
                        }
                        if (!Array.isArray(a)) return !0;
                        let r = !1;
                        for(let n = 0; n < a.length; n++){
                            const i = a[n];
                            if (i?.toString() === e1.objId) {
                                this.nodes[n] = t;
                                r = !0;
                            }
                        }
                        return r;
                    }
                    get serializable() {
                        function nodeToSerializable(e1, t, a = 0) {
                            if (a > 40) {
                                (0, r.warn)("StructTree too deep to be fully serialized.");
                                return;
                            }
                            const n = Object.create(null);
                            n.role = e1.role;
                            n.children = [];
                            t.children.push(n);
                            const i = e1.dict.get("Alt");
                            "string" == typeof i && (n.alt = (0, r.stringToPDFString)(i));
                            const s = e1.dict.get("Lang");
                            "string" == typeof s && (n.lang = (0, r.stringToPDFString)(s));
                            for (const t of e1.kids){
                                const e1 = t.type === u ? t.parentNode : null;
                                e1 ? nodeToSerializable(e1, n, a + 1) : t.type === o || t.type === c ? n.children.push({
                                    type: "content",
                                    id: `p${t.pageObjId}_mc${t.mcid}`
                                }) : t.type === l ? n.children.push({
                                    type: "object",
                                    id: t.refObjId
                                }) : t.type === h && n.children.push({
                                    type: "annotation",
                                    id: `${r.AnnotationPrefix}${t.refObjId}`
                                });
                            }
                        }
                        const e1 = Object.create(null);
                        e1.children = [];
                        e1.role = "Root";
                        for (const t of this.nodes)t && nodeToSerializable(t, e1);
                        return e1;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.incrementalUpdate = async function incrementalUpdate({ originalData: e1, xrefInfo: t, newRefs: a, xref: o = null, hasXfa: l = !1, xfaDatasetsRef: h = null, hasXfaDatasetsEntry: u = !1, needAppearances: d, acroFormRef: f = null, acroForm: g = null, xfaData: p = null }) {
                    await async function updateAcroform({ xref: e1, acroForm: t, acroFormRef: a, hasXfa: n, hasXfaDatasetsEntry: i, xfaDatasetsRef: s, needAppearances: o, newRefs: c }) {
                        !n || i || s || (0, r.warn)("XFA - Cannot save it");
                        if (!o && (!n || !s || i)) return;
                        const l = t.clone();
                        if (n && !i) {
                            const e1 = t.get("XFA").slice();
                            e1.splice(2, 0, "datasets");
                            e1.splice(3, 0, s);
                            l.set("XFA", e1);
                        }
                        o && l.set("NeedAppearances", !0);
                        const h = [];
                        await writeObject(a, l, h, e1);
                        c.push({
                            ref: a,
                            data: h.join("")
                        });
                    }({
                        xref: o,
                        acroForm: g,
                        acroFormRef: f,
                        hasXfa: l,
                        hasXfaDatasetsEntry: u,
                        xfaDatasetsRef: h,
                        needAppearances: d,
                        newRefs: a
                    });
                    l && function updateXFA({ xfaData: e1, xfaDatasetsRef: t, newRefs: a, xref: n }) {
                        if (null === e1) e1 = function writeXFADataForAcroform(e1, t) {
                            const a = new s.SimpleXMLParser({
                                hasAttributes: !0
                            }).parseFromString(e1);
                            for (const { xfa: e1 } of t){
                                if (!e1) continue;
                                const { path: t, value: n } = e1;
                                if (!t) continue;
                                const o = (0, i.parseXFAPath)(t);
                                let c = a.documentElement.searchNode(o, 0);
                                !c && o.length > 1 && (c = a.documentElement.searchNode([
                                    o.at(-1)
                                ], 0));
                                c ? c.childNodes = Array.isArray(n) ? n.map((e1)=>new s.SimpleDOMNode("value", e1)) : [
                                    new s.SimpleDOMNode("#text", n)
                                ] : (0, r.warn)(`Node not found for path: ${t}`);
                            }
                            const n = [];
                            a.documentElement.dump(n);
                            return n.join("");
                        }(n.fetchIfRef(t).getString(), a);
                        const o = n.encrypt;
                        if (o) e1 = o.createCipherTransform(t.num, t.gen).encryptString(e1);
                        const c = `${t.num} ${t.gen} obj\n<< /Type /EmbeddedFile /Length ${e1.length}>>\nstream\n` + e1 + "\nendstream\nendobj\n";
                        a.push({
                            ref: t,
                            data: c
                        });
                    }({
                        xfaData: p,
                        xfaDatasetsRef: h,
                        newRefs: a,
                        xref: o
                    });
                    const m = new n.Dict(null), b = t.newRef;
                    let y, w;
                    const S = e1.at(-1);
                    if (10 === S || 13 === S) {
                        y = [];
                        w = e1.length;
                    } else {
                        y = [
                            "\n"
                        ];
                        w = e1.length + 1;
                    }
                    m.set("Size", b.num + 1);
                    m.set("Prev", t.startXRef);
                    m.set("Type", n.Name.get("XRef"));
                    null !== t.rootRef && m.set("Root", t.rootRef);
                    null !== t.infoRef && m.set("Info", t.infoRef);
                    null !== t.encryptRef && m.set("Encrypt", t.encryptRef);
                    a.push({
                        ref: b,
                        data: ""
                    });
                    a = a.sort((e1, t)=>e1.ref.num - t.ref.num);
                    const x = [
                        [
                            0,
                            1,
                            65535
                        ]
                    ], C = [
                        0,
                        1
                    ];
                    let k = 0;
                    for (const { ref: e1, data: t } of a){
                        k = Math.max(k, w);
                        x.push([
                            1,
                            w,
                            Math.min(e1.gen, 65535)
                        ]);
                        w += t.length;
                        C.push(e1.num, 1);
                        y.push(t);
                    }
                    m.set("Index", C);
                    if (Array.isArray(t.fileIds) && t.fileIds.length > 0) {
                        const e1 = function computeMD5(e1, t) {
                            const a = Math.floor(Date.now() / 1e3), n = t.filename || "", i = [
                                a.toString(),
                                n,
                                e1.toString()
                            ];
                            let s = i.reduce((e1, t)=>e1 + t.length, 0);
                            for (const e1 of Object.values(t.info)){
                                i.push(e1);
                                s += e1.length;
                            }
                            const o = new Uint8Array(s);
                            let l = 0;
                            for (const e1 of i){
                                writeString(e1, l, o);
                                l += e1.length;
                            }
                            return (0, r.bytesToString)((0, c.calculateMD5)(o));
                        }(w, t);
                        m.set("ID", [
                            t.fileIds[0],
                            e1
                        ]);
                    }
                    const v = [
                        1,
                        Math.ceil(Math.log2(k) / 8),
                        2
                    ], F = (v[0] + v[1] + v[2]) * x.length;
                    m.set("W", v);
                    m.set("Length", F);
                    y.push(`${b.num} ${b.gen} obj\n`);
                    await writeDict(m, y, null);
                    y.push(" stream\n");
                    const O = y.reduce((e1, t)=>e1 + t.length, 0), T = `\nendstream\nendobj\nstartxref\n${w}\n%%EOF\n`, M = new Uint8Array(e1.length + O + F + T.length);
                    M.set(e1);
                    let D = e1.length;
                    for (const e1 of y){
                        writeString(e1, D, M);
                        D += e1.length;
                    }
                    for (const [e1, t, a] of x){
                        D = writeInt(e1, v[0], D, M);
                        D = writeInt(t, v[1], D, M);
                        D = writeInt(a, v[2], D, M);
                    }
                    writeString(T, D, M);
                    return M;
                };
                t.writeDict = writeDict;
                t.writeObject = writeObject;
                var r = a(2), n = a(4), i = a(3), s = a(71), o = a(5), c = a(74);
                async function writeObject(e1, t, a, { encrypt: r = null }) {
                    const i = r?.createCipherTransform(e1.num, e1.gen);
                    a.push(`${e1.num} ${e1.gen} obj\n`);
                    t instanceof n.Dict ? await writeDict(t, a, i) : t instanceof o.BaseStream ? await writeStream(t, a, i) : Array.isArray(t) && await writeArray(t, a, i);
                    a.push("\nendobj\n");
                }
                async function writeDict(e1, t, a) {
                    t.push("<<");
                    for (const r of e1.getKeys()){
                        t.push(` /${(0, i.escapePDFName)(r)} `);
                        await writeValue(e1.getRaw(r), t, a);
                    }
                    t.push(">>");
                }
                async function writeStream(e1, t, a) {
                    let i = e1.getString();
                    const { dict: s } = e1, [o, c] = await Promise.all([
                        s.getAsync("Filter"),
                        s.getAsync("DecodeParms")
                    ]), l = Array.isArray(o) ? await s.xref.fetchIfRefAsync(o[0]) : o, h = (0, n.isName)(l, "FlateDecode");
                    if ("undefined" != typeof CompressionStream && (i.length >= 256 || h)) try {
                        const e1 = (0, r.stringToBytes)(i), t = new CompressionStream("deflate"), a = t.writable.getWriter();
                        a.write(e1);
                        a.close();
                        const l = await new Response(t.readable).arrayBuffer();
                        i = (0, r.bytesToString)(new Uint8Array(l));
                        let u, d;
                        if (o) {
                            if (!h) {
                                u = Array.isArray(o) ? [
                                    n.Name.get("FlateDecode"),
                                    ...o
                                ] : [
                                    n.Name.get("FlateDecode"),
                                    o
                                ];
                                c && (d = Array.isArray(c) ? [
                                    null,
                                    ...c
                                ] : [
                                    null,
                                    c
                                ]);
                            }
                        } else u = n.Name.get("FlateDecode");
                        u && s.set("Filter", u);
                        d && s.set("DecodeParms", d);
                    } catch (e1) {
                        (0, r.info)(`writeStream - cannot compress data: "${e1}".`);
                    }
                    a && (i = a.encryptString(i));
                    s.set("Length", i.length);
                    await writeDict(s, t, a);
                    t.push(" stream\n", i, "\nendstream");
                }
                async function writeArray(e1, t, a) {
                    t.push("[");
                    let r = !0;
                    for (const n of e1){
                        r ? r = !1 : t.push(" ");
                        await writeValue(n, t, a);
                    }
                    t.push("]");
                }
                async function writeValue(e1, t, a) {
                    if (e1 instanceof n.Name) t.push(`/${(0, i.escapePDFName)(e1.name)}`);
                    else if (e1 instanceof n.Ref) t.push(`${e1.num} ${e1.gen} R`);
                    else if (Array.isArray(e1)) await writeArray(e1, t, a);
                    else if ("string" == typeof e1) {
                        a && (e1 = a.encryptString(e1));
                        t.push(`(${(0, i.escapeString)(e1)})`);
                    } else "number" == typeof e1 ? t.push((0, i.numberToString)(e1)) : "boolean" == typeof e1 ? t.push(e1.toString()) : e1 instanceof n.Dict ? await writeDict(e1, t, a) : e1 instanceof o.BaseStream ? await writeStream(e1, t, a) : null === e1 ? t.push("null") : (0, r.warn)(`Unhandled value in writer: ${typeof e1}, please file a bug.`);
                }
                function writeInt(e1, t, a, r) {
                    for(let n = t + a - 1; n > a - 1; n--){
                        r[n] = 255 & e1;
                        e1 >>= 8;
                    }
                    return a + t;
                }
                function writeString(e1, t, a) {
                    for(let r = 0, n = e1.length; r < n; r++)a[t + r] = 255 & e1.charCodeAt(r);
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.calculateSHA256 = t.calculateMD5 = t.PDF20 = t.PDF17 = t.CipherTransformFactory = t.ARCFourCipher = t.AES256Cipher = t.AES128Cipher = void 0;
                t.calculateSHA384 = calculateSHA384;
                t.calculateSHA512 = void 0;
                var r = a(2), n = a(4), i = a(75);
                class ARCFourCipher {
                    constructor(e1){
                        this.a = 0;
                        this.b = 0;
                        const t = new Uint8Array(256), a = e1.length;
                        for(let e1 = 0; e1 < 256; ++e1)t[e1] = e1;
                        for(let r = 0, n = 0; r < 256; ++r){
                            const i = t[r];
                            n = n + i + e1[r % a] & 255;
                            t[r] = t[n];
                            t[n] = i;
                        }
                        this.s = t;
                    }
                    encryptBlock(e1) {
                        let t = this.a, a = this.b;
                        const r = this.s, n = e1.length, i = new Uint8Array(n);
                        for(let s = 0; s < n; ++s){
                            t = t + 1 & 255;
                            const n = r[t];
                            a = a + n & 255;
                            const o = r[a];
                            r[t] = o;
                            r[a] = n;
                            i[s] = e1[s] ^ r[n + o & 255];
                        }
                        this.a = t;
                        this.b = a;
                        return i;
                    }
                    decryptBlock(e1) {
                        return this.encryptBlock(e1);
                    }
                    encrypt(e1) {
                        return this.encryptBlock(e1);
                    }
                }
                t.ARCFourCipher = ARCFourCipher;
                const s = function calculateMD5Closure() {
                    const e1 = new Uint8Array([
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21
                    ]), t = new Int32Array([
                        -680876936,
                        -389564586,
                        606105819,
                        -1044525330,
                        -176418897,
                        1200080426,
                        -1473231341,
                        -45705983,
                        1770035416,
                        -1958414417,
                        -42063,
                        -1990404162,
                        1804603682,
                        -40341101,
                        -1502002290,
                        1236535329,
                        -165796510,
                        -1069501632,
                        643717713,
                        -373897302,
                        -701558691,
                        38016083,
                        -660478335,
                        -405537848,
                        568446438,
                        -1019803690,
                        -187363961,
                        1163531501,
                        -1444681467,
                        -51403784,
                        1735328473,
                        -1926607734,
                        -378558,
                        -2022574463,
                        1839030562,
                        -35309556,
                        -1530992060,
                        1272893353,
                        -155497632,
                        -1094730640,
                        681279174,
                        -358537222,
                        -722521979,
                        76029189,
                        -640364487,
                        -421815835,
                        530742520,
                        -995338651,
                        -198630844,
                        1126891415,
                        -1416354905,
                        -57434055,
                        1700485571,
                        -1894986606,
                        -1051523,
                        -2054922799,
                        1873313359,
                        -30611744,
                        -1560198380,
                        1309151649,
                        -145523070,
                        -1120210379,
                        718787259,
                        -343485551
                    ]);
                    return function hash(a, r, n) {
                        let i = 1732584193, s = -271733879, o = -1732584194, c = 271733878;
                        const l = n + 72 & -64, h = new Uint8Array(l);
                        let u, d;
                        for(u = 0; u < n; ++u)h[u] = a[r++];
                        h[u++] = 128;
                        const f = l - 8;
                        for(; u < f;)h[u++] = 0;
                        h[u++] = n << 3 & 255;
                        h[u++] = n >> 5 & 255;
                        h[u++] = n >> 13 & 255;
                        h[u++] = n >> 21 & 255;
                        h[u++] = n >>> 29 & 255;
                        h[u++] = 0;
                        h[u++] = 0;
                        h[u++] = 0;
                        const g = new Int32Array(16);
                        for(u = 0; u < l;){
                            for(d = 0; d < 16; ++d, u += 4)g[d] = h[u] | h[u + 1] << 8 | h[u + 2] << 16 | h[u + 3] << 24;
                            let a, r, n = i, l = s, f = o, p = c;
                            for(d = 0; d < 64; ++d){
                                if (d < 16) {
                                    a = l & f | ~l & p;
                                    r = d;
                                } else if (d < 32) {
                                    a = p & l | ~p & f;
                                    r = 5 * d + 1 & 15;
                                } else if (d < 48) {
                                    a = l ^ f ^ p;
                                    r = 3 * d + 5 & 15;
                                } else {
                                    a = f ^ (l | ~p);
                                    r = 7 * d & 15;
                                }
                                const i = p, s = n + a + t[d] + g[r] | 0, o = e1[d];
                                p = f;
                                f = l;
                                l = l + (s << o | s >>> 32 - o) | 0;
                                n = i;
                            }
                            i = i + n | 0;
                            s = s + l | 0;
                            o = o + f | 0;
                            c = c + p | 0;
                        }
                        return new Uint8Array([
                            255 & i,
                            i >> 8 & 255,
                            i >> 16 & 255,
                            i >>> 24 & 255,
                            255 & s,
                            s >> 8 & 255,
                            s >> 16 & 255,
                            s >>> 24 & 255,
                            255 & o,
                            o >> 8 & 255,
                            o >> 16 & 255,
                            o >>> 24 & 255,
                            255 & c,
                            c >> 8 & 255,
                            c >> 16 & 255,
                            c >>> 24 & 255
                        ]);
                    };
                }();
                t.calculateMD5 = s;
                class Word64 {
                    constructor(e1, t){
                        this.high = 0 | e1;
                        this.low = 0 | t;
                    }
                    and(e1) {
                        this.high &= e1.high;
                        this.low &= e1.low;
                    }
                    xor(e1) {
                        this.high ^= e1.high;
                        this.low ^= e1.low;
                    }
                    or(e1) {
                        this.high |= e1.high;
                        this.low |= e1.low;
                    }
                    shiftRight(e1) {
                        if (e1 >= 32) {
                            this.low = this.high >>> e1 - 32 | 0;
                            this.high = 0;
                        } else {
                            this.low = this.low >>> e1 | this.high << 32 - e1;
                            this.high = this.high >>> e1 | 0;
                        }
                    }
                    shiftLeft(e1) {
                        if (e1 >= 32) {
                            this.high = this.low << e1 - 32;
                            this.low = 0;
                        } else {
                            this.high = this.high << e1 | this.low >>> 32 - e1;
                            this.low <<= e1;
                        }
                    }
                    rotateRight(e1) {
                        let t, a;
                        if (32 & e1) {
                            a = this.low;
                            t = this.high;
                        } else {
                            t = this.low;
                            a = this.high;
                        }
                        e1 &= 31;
                        this.low = t >>> e1 | a << 32 - e1;
                        this.high = a >>> e1 | t << 32 - e1;
                    }
                    not() {
                        this.high = ~this.high;
                        this.low = ~this.low;
                    }
                    add(e1) {
                        const t = (this.low >>> 0) + (e1.low >>> 0);
                        let a = (this.high >>> 0) + (e1.high >>> 0);
                        t > 4294967295 && (a += 1);
                        this.low = 0 | t;
                        this.high = 0 | a;
                    }
                    copyTo(e1, t) {
                        e1[t] = this.high >>> 24 & 255;
                        e1[t + 1] = this.high >> 16 & 255;
                        e1[t + 2] = this.high >> 8 & 255;
                        e1[t + 3] = 255 & this.high;
                        e1[t + 4] = this.low >>> 24 & 255;
                        e1[t + 5] = this.low >> 16 & 255;
                        e1[t + 6] = this.low >> 8 & 255;
                        e1[t + 7] = 255 & this.low;
                    }
                    assign(e1) {
                        this.high = e1.high;
                        this.low = e1.low;
                    }
                }
                const o = function calculateSHA256Closure() {
                    function rotr(e1, t) {
                        return e1 >>> t | e1 << 32 - t;
                    }
                    function ch(e1, t, a) {
                        return e1 & t ^ ~e1 & a;
                    }
                    function maj(e1, t, a) {
                        return e1 & t ^ e1 & a ^ t & a;
                    }
                    function sigma(e1) {
                        return rotr(e1, 2) ^ rotr(e1, 13) ^ rotr(e1, 22);
                    }
                    function sigmaPrime(e1) {
                        return rotr(e1, 6) ^ rotr(e1, 11) ^ rotr(e1, 25);
                    }
                    function littleSigma(e1) {
                        return rotr(e1, 7) ^ rotr(e1, 18) ^ e1 >>> 3;
                    }
                    const e1 = [
                        1116352408,
                        1899447441,
                        3049323471,
                        3921009573,
                        961987163,
                        1508970993,
                        2453635748,
                        2870763221,
                        3624381080,
                        310598401,
                        607225278,
                        1426881987,
                        1925078388,
                        2162078206,
                        2614888103,
                        3248222580,
                        3835390401,
                        4022224774,
                        264347078,
                        604807628,
                        770255983,
                        1249150122,
                        1555081692,
                        1996064986,
                        2554220882,
                        2821834349,
                        2952996808,
                        3210313671,
                        3336571891,
                        3584528711,
                        113926993,
                        338241895,
                        666307205,
                        773529912,
                        1294757372,
                        1396182291,
                        1695183700,
                        1986661051,
                        2177026350,
                        2456956037,
                        2730485921,
                        2820302411,
                        3259730800,
                        3345764771,
                        3516065817,
                        3600352804,
                        4094571909,
                        275423344,
                        430227734,
                        506948616,
                        659060556,
                        883997877,
                        958139571,
                        1322822218,
                        1537002063,
                        1747873779,
                        1955562222,
                        2024104815,
                        2227730452,
                        2361852424,
                        2428436474,
                        2756734187,
                        3204031479,
                        3329325298
                    ];
                    return function hash(t, a, r) {
                        let n = 1779033703, i = 3144134277, s = 1013904242, o = 2773480762, c = 1359893119, l = 2600822924, h = 528734635, u = 1541459225;
                        const d = 64 * Math.ceil((r + 9) / 64), f = new Uint8Array(d);
                        let g, p;
                        for(g = 0; g < r; ++g)f[g] = t[a++];
                        f[g++] = 128;
                        const m = d - 8;
                        for(; g < m;)f[g++] = 0;
                        f[g++] = 0;
                        f[g++] = 0;
                        f[g++] = 0;
                        f[g++] = r >>> 29 & 255;
                        f[g++] = r >> 21 & 255;
                        f[g++] = r >> 13 & 255;
                        f[g++] = r >> 5 & 255;
                        f[g++] = r << 3 & 255;
                        const b = new Uint32Array(64);
                        for(g = 0; g < d;){
                            for(p = 0; p < 16; ++p){
                                b[p] = f[g] << 24 | f[g + 1] << 16 | f[g + 2] << 8 | f[g + 3];
                                g += 4;
                            }
                            for(p = 16; p < 64; ++p)b[p] = (rotr(y = b[p - 2], 17) ^ rotr(y, 19) ^ y >>> 10) + b[p - 7] + littleSigma(b[p - 15]) + b[p - 16] | 0;
                            let t, a, r = n, d = i, m = s, w = o, S = c, x = l, C = h, k = u;
                            for(p = 0; p < 64; ++p){
                                t = k + sigmaPrime(S) + ch(S, x, C) + e1[p] + b[p];
                                a = sigma(r) + maj(r, d, m);
                                k = C;
                                C = x;
                                x = S;
                                S = w + t | 0;
                                w = m;
                                m = d;
                                d = r;
                                r = t + a | 0;
                            }
                            n = n + r | 0;
                            i = i + d | 0;
                            s = s + m | 0;
                            o = o + w | 0;
                            c = c + S | 0;
                            l = l + x | 0;
                            h = h + C | 0;
                            u = u + k | 0;
                        }
                        var y;
                        return new Uint8Array([
                            n >> 24 & 255,
                            n >> 16 & 255,
                            n >> 8 & 255,
                            255 & n,
                            i >> 24 & 255,
                            i >> 16 & 255,
                            i >> 8 & 255,
                            255 & i,
                            s >> 24 & 255,
                            s >> 16 & 255,
                            s >> 8 & 255,
                            255 & s,
                            o >> 24 & 255,
                            o >> 16 & 255,
                            o >> 8 & 255,
                            255 & o,
                            c >> 24 & 255,
                            c >> 16 & 255,
                            c >> 8 & 255,
                            255 & c,
                            l >> 24 & 255,
                            l >> 16 & 255,
                            l >> 8 & 255,
                            255 & l,
                            h >> 24 & 255,
                            h >> 16 & 255,
                            h >> 8 & 255,
                            255 & h,
                            u >> 24 & 255,
                            u >> 16 & 255,
                            u >> 8 & 255,
                            255 & u
                        ]);
                    };
                }();
                t.calculateSHA256 = o;
                const c = function calculateSHA512Closure() {
                    function ch(e1, t, a, r, n) {
                        e1.assign(t);
                        e1.and(a);
                        n.assign(t);
                        n.not();
                        n.and(r);
                        e1.xor(n);
                    }
                    function maj(e1, t, a, r, n) {
                        e1.assign(t);
                        e1.and(a);
                        n.assign(t);
                        n.and(r);
                        e1.xor(n);
                        n.assign(a);
                        n.and(r);
                        e1.xor(n);
                    }
                    function sigma(e1, t, a) {
                        e1.assign(t);
                        e1.rotateRight(28);
                        a.assign(t);
                        a.rotateRight(34);
                        e1.xor(a);
                        a.assign(t);
                        a.rotateRight(39);
                        e1.xor(a);
                    }
                    function sigmaPrime(e1, t, a) {
                        e1.assign(t);
                        e1.rotateRight(14);
                        a.assign(t);
                        a.rotateRight(18);
                        e1.xor(a);
                        a.assign(t);
                        a.rotateRight(41);
                        e1.xor(a);
                    }
                    function littleSigma(e1, t, a) {
                        e1.assign(t);
                        e1.rotateRight(1);
                        a.assign(t);
                        a.rotateRight(8);
                        e1.xor(a);
                        a.assign(t);
                        a.shiftRight(7);
                        e1.xor(a);
                    }
                    function littleSigmaPrime(e1, t, a) {
                        e1.assign(t);
                        e1.rotateRight(19);
                        a.assign(t);
                        a.rotateRight(61);
                        e1.xor(a);
                        a.assign(t);
                        a.shiftRight(6);
                        e1.xor(a);
                    }
                    const e1 = [
                        new Word64(1116352408, 3609767458),
                        new Word64(1899447441, 602891725),
                        new Word64(3049323471, 3964484399),
                        new Word64(3921009573, 2173295548),
                        new Word64(961987163, 4081628472),
                        new Word64(1508970993, 3053834265),
                        new Word64(2453635748, 2937671579),
                        new Word64(2870763221, 3664609560),
                        new Word64(3624381080, 2734883394),
                        new Word64(310598401, 1164996542),
                        new Word64(607225278, 1323610764),
                        new Word64(1426881987, 3590304994),
                        new Word64(1925078388, 4068182383),
                        new Word64(2162078206, 991336113),
                        new Word64(2614888103, 633803317),
                        new Word64(3248222580, 3479774868),
                        new Word64(3835390401, 2666613458),
                        new Word64(4022224774, 944711139),
                        new Word64(264347078, 2341262773),
                        new Word64(604807628, 2007800933),
                        new Word64(770255983, 1495990901),
                        new Word64(1249150122, 1856431235),
                        new Word64(1555081692, 3175218132),
                        new Word64(1996064986, 2198950837),
                        new Word64(2554220882, 3999719339),
                        new Word64(2821834349, 766784016),
                        new Word64(2952996808, 2566594879),
                        new Word64(3210313671, 3203337956),
                        new Word64(3336571891, 1034457026),
                        new Word64(3584528711, 2466948901),
                        new Word64(113926993, 3758326383),
                        new Word64(338241895, 168717936),
                        new Word64(666307205, 1188179964),
                        new Word64(773529912, 1546045734),
                        new Word64(1294757372, 1522805485),
                        new Word64(1396182291, 2643833823),
                        new Word64(1695183700, 2343527390),
                        new Word64(1986661051, 1014477480),
                        new Word64(2177026350, 1206759142),
                        new Word64(2456956037, 344077627),
                        new Word64(2730485921, 1290863460),
                        new Word64(2820302411, 3158454273),
                        new Word64(3259730800, 3505952657),
                        new Word64(3345764771, 106217008),
                        new Word64(3516065817, 3606008344),
                        new Word64(3600352804, 1432725776),
                        new Word64(4094571909, 1467031594),
                        new Word64(275423344, 851169720),
                        new Word64(430227734, 3100823752),
                        new Word64(506948616, 1363258195),
                        new Word64(659060556, 3750685593),
                        new Word64(883997877, 3785050280),
                        new Word64(958139571, 3318307427),
                        new Word64(1322822218, 3812723403),
                        new Word64(1537002063, 2003034995),
                        new Word64(1747873779, 3602036899),
                        new Word64(1955562222, 1575990012),
                        new Word64(2024104815, 1125592928),
                        new Word64(2227730452, 2716904306),
                        new Word64(2361852424, 442776044),
                        new Word64(2428436474, 593698344),
                        new Word64(2756734187, 3733110249),
                        new Word64(3204031479, 2999351573),
                        new Word64(3329325298, 3815920427),
                        new Word64(3391569614, 3928383900),
                        new Word64(3515267271, 566280711),
                        new Word64(3940187606, 3454069534),
                        new Word64(4118630271, 4000239992),
                        new Word64(116418474, 1914138554),
                        new Word64(174292421, 2731055270),
                        new Word64(289380356, 3203993006),
                        new Word64(460393269, 320620315),
                        new Word64(685471733, 587496836),
                        new Word64(852142971, 1086792851),
                        new Word64(1017036298, 365543100),
                        new Word64(1126000580, 2618297676),
                        new Word64(1288033470, 3409855158),
                        new Word64(1501505948, 4234509866),
                        new Word64(1607167915, 987167468),
                        new Word64(1816402316, 1246189591)
                    ];
                    return function hash(t, a, r, n = !1) {
                        let i, s, o, c, l, h, u, d;
                        if (n) {
                            i = new Word64(3418070365, 3238371032);
                            s = new Word64(1654270250, 914150663);
                            o = new Word64(2438529370, 812702999);
                            c = new Word64(355462360, 4144912697);
                            l = new Word64(1731405415, 4290775857);
                            h = new Word64(2394180231, 1750603025);
                            u = new Word64(3675008525, 1694076839);
                            d = new Word64(1203062813, 3204075428);
                        } else {
                            i = new Word64(1779033703, 4089235720);
                            s = new Word64(3144134277, 2227873595);
                            o = new Word64(1013904242, 4271175723);
                            c = new Word64(2773480762, 1595750129);
                            l = new Word64(1359893119, 2917565137);
                            h = new Word64(2600822924, 725511199);
                            u = new Word64(528734635, 4215389547);
                            d = new Word64(1541459225, 327033209);
                        }
                        const f = 128 * Math.ceil((r + 17) / 128), g = new Uint8Array(f);
                        let p, m;
                        for(p = 0; p < r; ++p)g[p] = t[a++];
                        g[p++] = 128;
                        const b = f - 16;
                        for(; p < b;)g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = 0;
                        g[p++] = r >>> 29 & 255;
                        g[p++] = r >> 21 & 255;
                        g[p++] = r >> 13 & 255;
                        g[p++] = r >> 5 & 255;
                        g[p++] = r << 3 & 255;
                        const y = new Array(80);
                        for(p = 0; p < 80; p++)y[p] = new Word64(0, 0);
                        let w = new Word64(0, 0), S = new Word64(0, 0), x = new Word64(0, 0), C = new Word64(0, 0), k = new Word64(0, 0), v = new Word64(0, 0), F = new Word64(0, 0), O = new Word64(0, 0);
                        const T = new Word64(0, 0), M = new Word64(0, 0), D = new Word64(0, 0), E = new Word64(0, 0);
                        let N, R;
                        for(p = 0; p < f;){
                            for(m = 0; m < 16; ++m){
                                y[m].high = g[p] << 24 | g[p + 1] << 16 | g[p + 2] << 8 | g[p + 3];
                                y[m].low = g[p + 4] << 24 | g[p + 5] << 16 | g[p + 6] << 8 | g[p + 7];
                                p += 8;
                            }
                            for(m = 16; m < 80; ++m){
                                N = y[m];
                                littleSigmaPrime(N, y[m - 2], E);
                                N.add(y[m - 7]);
                                littleSigma(D, y[m - 15], E);
                                N.add(D);
                                N.add(y[m - 16]);
                            }
                            w.assign(i);
                            S.assign(s);
                            x.assign(o);
                            C.assign(c);
                            k.assign(l);
                            v.assign(h);
                            F.assign(u);
                            O.assign(d);
                            for(m = 0; m < 80; ++m){
                                T.assign(O);
                                sigmaPrime(D, k, E);
                                T.add(D);
                                ch(D, k, v, F, E);
                                T.add(D);
                                T.add(e1[m]);
                                T.add(y[m]);
                                sigma(M, w, E);
                                maj(D, w, S, x, E);
                                M.add(D);
                                N = O;
                                O = F;
                                F = v;
                                v = k;
                                C.add(T);
                                k = C;
                                C = x;
                                x = S;
                                S = w;
                                N.assign(T);
                                N.add(M);
                                w = N;
                            }
                            i.add(w);
                            s.add(S);
                            o.add(x);
                            c.add(C);
                            l.add(k);
                            h.add(v);
                            u.add(F);
                            d.add(O);
                        }
                        if (n) {
                            R = new Uint8Array(48);
                            i.copyTo(R, 0);
                            s.copyTo(R, 8);
                            o.copyTo(R, 16);
                            c.copyTo(R, 24);
                            l.copyTo(R, 32);
                            h.copyTo(R, 40);
                        } else {
                            R = new Uint8Array(64);
                            i.copyTo(R, 0);
                            s.copyTo(R, 8);
                            o.copyTo(R, 16);
                            c.copyTo(R, 24);
                            l.copyTo(R, 32);
                            h.copyTo(R, 40);
                            u.copyTo(R, 48);
                            d.copyTo(R, 56);
                        }
                        return R;
                    };
                }();
                t.calculateSHA512 = c;
                function calculateSHA384(e1, t, a) {
                    return c(e1, t, a, !0);
                }
                class NullCipher {
                    decryptBlock(e1) {
                        return e1;
                    }
                    encrypt(e1) {
                        return e1;
                    }
                }
                class AESBaseCipher {
                    constructor(){
                        this.constructor === AESBaseCipher && (0, r.unreachable)("Cannot initialize AESBaseCipher.");
                        this._s = new Uint8Array([
                            99,
                            124,
                            119,
                            123,
                            242,
                            107,
                            111,
                            197,
                            48,
                            1,
                            103,
                            43,
                            254,
                            215,
                            171,
                            118,
                            202,
                            130,
                            201,
                            125,
                            250,
                            89,
                            71,
                            240,
                            173,
                            212,
                            162,
                            175,
                            156,
                            164,
                            114,
                            192,
                            183,
                            253,
                            147,
                            38,
                            54,
                            63,
                            247,
                            204,
                            52,
                            165,
                            229,
                            241,
                            113,
                            216,
                            49,
                            21,
                            4,
                            199,
                            35,
                            195,
                            24,
                            150,
                            5,
                            154,
                            7,
                            18,
                            128,
                            226,
                            235,
                            39,
                            178,
                            117,
                            9,
                            131,
                            44,
                            26,
                            27,
                            110,
                            90,
                            160,
                            82,
                            59,
                            214,
                            179,
                            41,
                            227,
                            47,
                            132,
                            83,
                            209,
                            0,
                            237,
                            32,
                            252,
                            177,
                            91,
                            106,
                            203,
                            190,
                            57,
                            74,
                            76,
                            88,
                            207,
                            208,
                            239,
                            170,
                            251,
                            67,
                            77,
                            51,
                            133,
                            69,
                            249,
                            2,
                            127,
                            80,
                            60,
                            159,
                            168,
                            81,
                            163,
                            64,
                            143,
                            146,
                            157,
                            56,
                            245,
                            188,
                            182,
                            218,
                            33,
                            16,
                            255,
                            243,
                            210,
                            205,
                            12,
                            19,
                            236,
                            95,
                            151,
                            68,
                            23,
                            196,
                            167,
                            126,
                            61,
                            100,
                            93,
                            25,
                            115,
                            96,
                            129,
                            79,
                            220,
                            34,
                            42,
                            144,
                            136,
                            70,
                            238,
                            184,
                            20,
                            222,
                            94,
                            11,
                            219,
                            224,
                            50,
                            58,
                            10,
                            73,
                            6,
                            36,
                            92,
                            194,
                            211,
                            172,
                            98,
                            145,
                            149,
                            228,
                            121,
                            231,
                            200,
                            55,
                            109,
                            141,
                            213,
                            78,
                            169,
                            108,
                            86,
                            244,
                            234,
                            101,
                            122,
                            174,
                            8,
                            186,
                            120,
                            37,
                            46,
                            28,
                            166,
                            180,
                            198,
                            232,
                            221,
                            116,
                            31,
                            75,
                            189,
                            139,
                            138,
                            112,
                            62,
                            181,
                            102,
                            72,
                            3,
                            246,
                            14,
                            97,
                            53,
                            87,
                            185,
                            134,
                            193,
                            29,
                            158,
                            225,
                            248,
                            152,
                            17,
                            105,
                            217,
                            142,
                            148,
                            155,
                            30,
                            135,
                            233,
                            206,
                            85,
                            40,
                            223,
                            140,
                            161,
                            137,
                            13,
                            191,
                            230,
                            66,
                            104,
                            65,
                            153,
                            45,
                            15,
                            176,
                            84,
                            187,
                            22
                        ]);
                        this._inv_s = new Uint8Array([
                            82,
                            9,
                            106,
                            213,
                            48,
                            54,
                            165,
                            56,
                            191,
                            64,
                            163,
                            158,
                            129,
                            243,
                            215,
                            251,
                            124,
                            227,
                            57,
                            130,
                            155,
                            47,
                            255,
                            135,
                            52,
                            142,
                            67,
                            68,
                            196,
                            222,
                            233,
                            203,
                            84,
                            123,
                            148,
                            50,
                            166,
                            194,
                            35,
                            61,
                            238,
                            76,
                            149,
                            11,
                            66,
                            250,
                            195,
                            78,
                            8,
                            46,
                            161,
                            102,
                            40,
                            217,
                            36,
                            178,
                            118,
                            91,
                            162,
                            73,
                            109,
                            139,
                            209,
                            37,
                            114,
                            248,
                            246,
                            100,
                            134,
                            104,
                            152,
                            22,
                            212,
                            164,
                            92,
                            204,
                            93,
                            101,
                            182,
                            146,
                            108,
                            112,
                            72,
                            80,
                            253,
                            237,
                            185,
                            218,
                            94,
                            21,
                            70,
                            87,
                            167,
                            141,
                            157,
                            132,
                            144,
                            216,
                            171,
                            0,
                            140,
                            188,
                            211,
                            10,
                            247,
                            228,
                            88,
                            5,
                            184,
                            179,
                            69,
                            6,
                            208,
                            44,
                            30,
                            143,
                            202,
                            63,
                            15,
                            2,
                            193,
                            175,
                            189,
                            3,
                            1,
                            19,
                            138,
                            107,
                            58,
                            145,
                            17,
                            65,
                            79,
                            103,
                            220,
                            234,
                            151,
                            242,
                            207,
                            206,
                            240,
                            180,
                            230,
                            115,
                            150,
                            172,
                            116,
                            34,
                            231,
                            173,
                            53,
                            133,
                            226,
                            249,
                            55,
                            232,
                            28,
                            117,
                            223,
                            110,
                            71,
                            241,
                            26,
                            113,
                            29,
                            41,
                            197,
                            137,
                            111,
                            183,
                            98,
                            14,
                            170,
                            24,
                            190,
                            27,
                            252,
                            86,
                            62,
                            75,
                            198,
                            210,
                            121,
                            32,
                            154,
                            219,
                            192,
                            254,
                            120,
                            205,
                            90,
                            244,
                            31,
                            221,
                            168,
                            51,
                            136,
                            7,
                            199,
                            49,
                            177,
                            18,
                            16,
                            89,
                            39,
                            128,
                            236,
                            95,
                            96,
                            81,
                            127,
                            169,
                            25,
                            181,
                            74,
                            13,
                            45,
                            229,
                            122,
                            159,
                            147,
                            201,
                            156,
                            239,
                            160,
                            224,
                            59,
                            77,
                            174,
                            42,
                            245,
                            176,
                            200,
                            235,
                            187,
                            60,
                            131,
                            83,
                            153,
                            97,
                            23,
                            43,
                            4,
                            126,
                            186,
                            119,
                            214,
                            38,
                            225,
                            105,
                            20,
                            99,
                            85,
                            33,
                            12,
                            125
                        ]);
                        this._mix = new Uint32Array([
                            0,
                            235474187,
                            470948374,
                            303765277,
                            941896748,
                            908933415,
                            607530554,
                            708780849,
                            1883793496,
                            2118214995,
                            1817866830,
                            1649639237,
                            1215061108,
                            1181045119,
                            1417561698,
                            1517767529,
                            3767586992,
                            4003061179,
                            4236429990,
                            4069246893,
                            3635733660,
                            3602770327,
                            3299278474,
                            3400528769,
                            2430122216,
                            2664543715,
                            2362090238,
                            2193862645,
                            2835123396,
                            2801107407,
                            3035535058,
                            3135740889,
                            3678124923,
                            3576870512,
                            3341394285,
                            3374361702,
                            3810496343,
                            3977675356,
                            4279080257,
                            4043610186,
                            2876494627,
                            2776292904,
                            3076639029,
                            3110650942,
                            2472011535,
                            2640243204,
                            2403728665,
                            2169303058,
                            1001089995,
                            899835584,
                            666464733,
                            699432150,
                            59727847,
                            226906860,
                            530400753,
                            294930682,
                            1273168787,
                            1172967064,
                            1475418501,
                            1509430414,
                            1942435775,
                            2110667444,
                            1876241833,
                            1641816226,
                            2910219766,
                            2743034109,
                            2976151520,
                            3211623147,
                            2505202138,
                            2606453969,
                            2302690252,
                            2269728455,
                            3711829422,
                            3543599269,
                            3240894392,
                            3475313331,
                            3843699074,
                            3943906441,
                            4178062228,
                            4144047775,
                            1306967366,
                            1139781709,
                            1374988112,
                            1610459739,
                            1975683434,
                            2076935265,
                            1775276924,
                            1742315127,
                            1034867998,
                            866637845,
                            566021896,
                            800440835,
                            92987698,
                            193195065,
                            429456164,
                            395441711,
                            1984812685,
                            2017778566,
                            1784663195,
                            1683407248,
                            1315562145,
                            1080094634,
                            1383856311,
                            1551037884,
                            101039829,
                            135050206,
                            437757123,
                            337553864,
                            1042385657,
                            807962610,
                            573804783,
                            742039012,
                            2531067453,
                            2564033334,
                            2328828971,
                            2227573024,
                            2935566865,
                            2700099354,
                            3001755655,
                            3168937228,
                            3868552805,
                            3902563182,
                            4203181171,
                            4102977912,
                            3736164937,
                            3501741890,
                            3265478751,
                            3433712980,
                            1106041591,
                            1340463100,
                            1576976609,
                            1408749034,
                            2043211483,
                            2009195472,
                            1708848333,
                            1809054150,
                            832877231,
                            1068351396,
                            766945465,
                            599762354,
                            159417987,
                            126454664,
                            361929877,
                            463180190,
                            2709260871,
                            2943682380,
                            3178106961,
                            3009879386,
                            2572697195,
                            2538681184,
                            2236228733,
                            2336434550,
                            3509871135,
                            3745345300,
                            3441850377,
                            3274667266,
                            3910161971,
                            3877198648,
                            4110568485,
                            4211818798,
                            2597806476,
                            2497604743,
                            2261089178,
                            2295101073,
                            2733856160,
                            2902087851,
                            3202437046,
                            2968011453,
                            3936291284,
                            3835036895,
                            4136440770,
                            4169408201,
                            3535486456,
                            3702665459,
                            3467192302,
                            3231722213,
                            2051518780,
                            1951317047,
                            1716890410,
                            1750902305,
                            1113818384,
                            1282050075,
                            1584504582,
                            1350078989,
                            168810852,
                            67556463,
                            371049330,
                            404016761,
                            841739592,
                            1008918595,
                            775550814,
                            540080725,
                            3969562369,
                            3801332234,
                            4035489047,
                            4269907996,
                            3569255213,
                            3669462566,
                            3366754619,
                            3332740144,
                            2631065433,
                            2463879762,
                            2160117071,
                            2395588676,
                            2767645557,
                            2868897406,
                            3102011747,
                            3069049960,
                            202008497,
                            33778362,
                            270040487,
                            504459436,
                            875451293,
                            975658646,
                            675039627,
                            641025152,
                            2084704233,
                            1917518562,
                            1615861247,
                            1851332852,
                            1147550661,
                            1248802510,
                            1484005843,
                            1451044056,
                            933301370,
                            967311729,
                            733156972,
                            632953703,
                            260388950,
                            25965917,
                            328671808,
                            496906059,
                            1206477858,
                            1239443753,
                            1543208500,
                            1441952575,
                            2144161806,
                            1908694277,
                            1675577880,
                            1842759443,
                            3610369226,
                            3644379585,
                            3408119516,
                            3307916247,
                            4011190502,
                            3776767469,
                            4077384432,
                            4245618683,
                            2809771154,
                            2842737049,
                            3144396420,
                            3043140495,
                            2673705150,
                            2438237621,
                            2203032232,
                            2370213795
                        ]);
                        this._mixCol = new Uint8Array(256);
                        for(let e1 = 0; e1 < 256; e1++)this._mixCol[e1] = e1 < 128 ? e1 << 1 : e1 << 1 ^ 27;
                        this.buffer = new Uint8Array(16);
                        this.bufferPosition = 0;
                    }
                    _expandKey(e1) {
                        (0, r.unreachable)("Cannot call `_expandKey` on the base class");
                    }
                    _decrypt(e1, t) {
                        let a, r, n;
                        const i = new Uint8Array(16);
                        i.set(e1);
                        for(let e1 = 0, a = this._keySize; e1 < 16; ++e1, ++a)i[e1] ^= t[a];
                        for(let e1 = this._cyclesOfRepetition - 1; e1 >= 1; --e1){
                            a = i[13];
                            i[13] = i[9];
                            i[9] = i[5];
                            i[5] = i[1];
                            i[1] = a;
                            a = i[14];
                            r = i[10];
                            i[14] = i[6];
                            i[10] = i[2];
                            i[6] = a;
                            i[2] = r;
                            a = i[15];
                            r = i[11];
                            n = i[7];
                            i[15] = i[3];
                            i[11] = a;
                            i[7] = r;
                            i[3] = n;
                            for(let e1 = 0; e1 < 16; ++e1)i[e1] = this._inv_s[i[e1]];
                            for(let a = 0, r = 16 * e1; a < 16; ++a, ++r)i[a] ^= t[r];
                            for(let e1 = 0; e1 < 16; e1 += 4){
                                const t = this._mix[i[e1]], r = this._mix[i[e1 + 1]], n = this._mix[i[e1 + 2]], s = this._mix[i[e1 + 3]];
                                a = t ^ r >>> 8 ^ r << 24 ^ n >>> 16 ^ n << 16 ^ s >>> 24 ^ s << 8;
                                i[e1] = a >>> 24 & 255;
                                i[e1 + 1] = a >> 16 & 255;
                                i[e1 + 2] = a >> 8 & 255;
                                i[e1 + 3] = 255 & a;
                            }
                        }
                        a = i[13];
                        i[13] = i[9];
                        i[9] = i[5];
                        i[5] = i[1];
                        i[1] = a;
                        a = i[14];
                        r = i[10];
                        i[14] = i[6];
                        i[10] = i[2];
                        i[6] = a;
                        i[2] = r;
                        a = i[15];
                        r = i[11];
                        n = i[7];
                        i[15] = i[3];
                        i[11] = a;
                        i[7] = r;
                        i[3] = n;
                        for(let e1 = 0; e1 < 16; ++e1){
                            i[e1] = this._inv_s[i[e1]];
                            i[e1] ^= t[e1];
                        }
                        return i;
                    }
                    _encrypt(e1, t) {
                        const a = this._s;
                        let r, n, i;
                        const s = new Uint8Array(16);
                        s.set(e1);
                        for(let e1 = 0; e1 < 16; ++e1)s[e1] ^= t[e1];
                        for(let e1 = 1; e1 < this._cyclesOfRepetition; e1++){
                            for(let e1 = 0; e1 < 16; ++e1)s[e1] = a[s[e1]];
                            i = s[1];
                            s[1] = s[5];
                            s[5] = s[9];
                            s[9] = s[13];
                            s[13] = i;
                            i = s[2];
                            n = s[6];
                            s[2] = s[10];
                            s[6] = s[14];
                            s[10] = i;
                            s[14] = n;
                            i = s[3];
                            n = s[7];
                            r = s[11];
                            s[3] = s[15];
                            s[7] = i;
                            s[11] = n;
                            s[15] = r;
                            for(let e1 = 0; e1 < 16; e1 += 4){
                                const t = s[e1 + 0], a = s[e1 + 1], n = s[e1 + 2], i = s[e1 + 3];
                                r = t ^ a ^ n ^ i;
                                s[e1 + 0] ^= r ^ this._mixCol[t ^ a];
                                s[e1 + 1] ^= r ^ this._mixCol[a ^ n];
                                s[e1 + 2] ^= r ^ this._mixCol[n ^ i];
                                s[e1 + 3] ^= r ^ this._mixCol[i ^ t];
                            }
                            for(let a = 0, r = 16 * e1; a < 16; ++a, ++r)s[a] ^= t[r];
                        }
                        for(let e1 = 0; e1 < 16; ++e1)s[e1] = a[s[e1]];
                        i = s[1];
                        s[1] = s[5];
                        s[5] = s[9];
                        s[9] = s[13];
                        s[13] = i;
                        i = s[2];
                        n = s[6];
                        s[2] = s[10];
                        s[6] = s[14];
                        s[10] = i;
                        s[14] = n;
                        i = s[3];
                        n = s[7];
                        r = s[11];
                        s[3] = s[15];
                        s[7] = i;
                        s[11] = n;
                        s[15] = r;
                        for(let e1 = 0, a = this._keySize; e1 < 16; ++e1, ++a)s[e1] ^= t[a];
                        return s;
                    }
                    _decryptBlock2(e1, t) {
                        const a = e1.length;
                        let r = this.buffer, n = this.bufferPosition;
                        const i = [];
                        let s = this.iv;
                        for(let t = 0; t < a; ++t){
                            r[n] = e1[t];
                            ++n;
                            if (n < 16) continue;
                            const a = this._decrypt(r, this._key);
                            for(let e1 = 0; e1 < 16; ++e1)a[e1] ^= s[e1];
                            s = r;
                            i.push(a);
                            r = new Uint8Array(16);
                            n = 0;
                        }
                        this.buffer = r;
                        this.bufferLength = n;
                        this.iv = s;
                        if (0 === i.length) return new Uint8Array(0);
                        let o = 16 * i.length;
                        if (t) {
                            const e1 = i.at(-1);
                            let t = e1[15];
                            if (t <= 16) {
                                for(let a = 15, r = 16 - t; a >= r; --a)if (e1[a] !== t) {
                                    t = 0;
                                    break;
                                }
                                o -= t;
                                i[i.length - 1] = e1.subarray(0, 16 - t);
                            }
                        }
                        const c = new Uint8Array(o);
                        for(let e1 = 0, t = 0, a = i.length; e1 < a; ++e1, t += 16)c.set(i[e1], t);
                        return c;
                    }
                    decryptBlock(e1, t, a = null) {
                        const r = e1.length, n = this.buffer;
                        let i = this.bufferPosition;
                        if (a) this.iv = a;
                        else {
                            for(let t = 0; i < 16 && t < r; ++t, ++i)n[i] = e1[t];
                            if (i < 16) {
                                this.bufferLength = i;
                                return new Uint8Array(0);
                            }
                            this.iv = n;
                            e1 = e1.subarray(16);
                        }
                        this.buffer = new Uint8Array(16);
                        this.bufferLength = 0;
                        this.decryptBlock = this._decryptBlock2;
                        return this.decryptBlock(e1, t);
                    }
                    encrypt(e1, t) {
                        const a = e1.length;
                        let r = this.buffer, n = this.bufferPosition;
                        const i = [];
                        t || (t = new Uint8Array(16));
                        for(let s = 0; s < a; ++s){
                            r[n] = e1[s];
                            ++n;
                            if (n < 16) continue;
                            for(let e1 = 0; e1 < 16; ++e1)r[e1] ^= t[e1];
                            const a = this._encrypt(r, this._key);
                            t = a;
                            i.push(a);
                            r = new Uint8Array(16);
                            n = 0;
                        }
                        this.buffer = r;
                        this.bufferLength = n;
                        this.iv = t;
                        if (0 === i.length) return new Uint8Array(0);
                        const s = 16 * i.length, o = new Uint8Array(s);
                        for(let e1 = 0, t = 0, a = i.length; e1 < a; ++e1, t += 16)o.set(i[e1], t);
                        return o;
                    }
                }
                class AES128Cipher extends AESBaseCipher {
                    constructor(e1){
                        super();
                        this._cyclesOfRepetition = 10;
                        this._keySize = 160;
                        this._rcon = new Uint8Array([
                            141,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54,
                            108,
                            216,
                            171,
                            77,
                            154,
                            47,
                            94,
                            188,
                            99,
                            198,
                            151,
                            53,
                            106,
                            212,
                            179,
                            125,
                            250,
                            239,
                            197,
                            145,
                            57,
                            114,
                            228,
                            211,
                            189,
                            97,
                            194,
                            159,
                            37,
                            74,
                            148,
                            51,
                            102,
                            204,
                            131,
                            29,
                            58,
                            116,
                            232,
                            203,
                            141,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54,
                            108,
                            216,
                            171,
                            77,
                            154,
                            47,
                            94,
                            188,
                            99,
                            198,
                            151,
                            53,
                            106,
                            212,
                            179,
                            125,
                            250,
                            239,
                            197,
                            145,
                            57,
                            114,
                            228,
                            211,
                            189,
                            97,
                            194,
                            159,
                            37,
                            74,
                            148,
                            51,
                            102,
                            204,
                            131,
                            29,
                            58,
                            116,
                            232,
                            203,
                            141,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54,
                            108,
                            216,
                            171,
                            77,
                            154,
                            47,
                            94,
                            188,
                            99,
                            198,
                            151,
                            53,
                            106,
                            212,
                            179,
                            125,
                            250,
                            239,
                            197,
                            145,
                            57,
                            114,
                            228,
                            211,
                            189,
                            97,
                            194,
                            159,
                            37,
                            74,
                            148,
                            51,
                            102,
                            204,
                            131,
                            29,
                            58,
                            116,
                            232,
                            203,
                            141,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54,
                            108,
                            216,
                            171,
                            77,
                            154,
                            47,
                            94,
                            188,
                            99,
                            198,
                            151,
                            53,
                            106,
                            212,
                            179,
                            125,
                            250,
                            239,
                            197,
                            145,
                            57,
                            114,
                            228,
                            211,
                            189,
                            97,
                            194,
                            159,
                            37,
                            74,
                            148,
                            51,
                            102,
                            204,
                            131,
                            29,
                            58,
                            116,
                            232,
                            203,
                            141,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54,
                            108,
                            216,
                            171,
                            77,
                            154,
                            47,
                            94,
                            188,
                            99,
                            198,
                            151,
                            53,
                            106,
                            212,
                            179,
                            125,
                            250,
                            239,
                            197,
                            145,
                            57,
                            114,
                            228,
                            211,
                            189,
                            97,
                            194,
                            159,
                            37,
                            74,
                            148,
                            51,
                            102,
                            204,
                            131,
                            29,
                            58,
                            116,
                            232,
                            203,
                            141
                        ]);
                        this._key = this._expandKey(e1);
                    }
                    _expandKey(e1) {
                        const t = this._s, a = this._rcon, r = new Uint8Array(176);
                        r.set(e1);
                        for(let e1 = 16, n = 1; e1 < 176; ++n){
                            let i = r[e1 - 3], s = r[e1 - 2], o = r[e1 - 1], c = r[e1 - 4];
                            i = t[i];
                            s = t[s];
                            o = t[o];
                            c = t[c];
                            i ^= a[n];
                            for(let t = 0; t < 4; ++t){
                                r[e1] = i ^= r[e1 - 16];
                                e1++;
                                r[e1] = s ^= r[e1 - 16];
                                e1++;
                                r[e1] = o ^= r[e1 - 16];
                                e1++;
                                r[e1] = c ^= r[e1 - 16];
                                e1++;
                            }
                        }
                        return r;
                    }
                }
                t.AES128Cipher = AES128Cipher;
                class AES256Cipher extends AESBaseCipher {
                    constructor(e1){
                        super();
                        this._cyclesOfRepetition = 14;
                        this._keySize = 224;
                        this._key = this._expandKey(e1);
                    }
                    _expandKey(e1) {
                        const t = this._s, a = new Uint8Array(240);
                        a.set(e1);
                        let r, n, i, s, o = 1;
                        for(let e1 = 32, c = 1; e1 < 240; ++c){
                            if (e1 % 32 == 16) {
                                r = t[r];
                                n = t[n];
                                i = t[i];
                                s = t[s];
                            } else if (e1 % 32 == 0) {
                                r = a[e1 - 3];
                                n = a[e1 - 2];
                                i = a[e1 - 1];
                                s = a[e1 - 4];
                                r = t[r];
                                n = t[n];
                                i = t[i];
                                s = t[s];
                                r ^= o;
                                (o <<= 1) >= 256 && (o = 255 & (27 ^ o));
                            }
                            for(let t = 0; t < 4; ++t){
                                a[e1] = r ^= a[e1 - 32];
                                e1++;
                                a[e1] = n ^= a[e1 - 32];
                                e1++;
                                a[e1] = i ^= a[e1 - 32];
                                e1++;
                                a[e1] = s ^= a[e1 - 32];
                                e1++;
                            }
                        }
                        return a;
                    }
                }
                t.AES256Cipher = AES256Cipher;
                class PDF17 {
                    checkOwnerPassword(e1, t, a, n) {
                        const i = new Uint8Array(e1.length + 56);
                        i.set(e1, 0);
                        i.set(t, e1.length);
                        i.set(a, e1.length + t.length);
                        const s = o(i, 0, i.length);
                        return (0, r.isArrayEqual)(s, n);
                    }
                    checkUserPassword(e1, t, a) {
                        const n = new Uint8Array(e1.length + 8);
                        n.set(e1, 0);
                        n.set(t, e1.length);
                        const i = o(n, 0, n.length);
                        return (0, r.isArrayEqual)(i, a);
                    }
                    getOwnerKey(e1, t, a, r) {
                        const n = new Uint8Array(e1.length + 56);
                        n.set(e1, 0);
                        n.set(t, e1.length);
                        n.set(a, e1.length + t.length);
                        const i = o(n, 0, n.length);
                        return new AES256Cipher(i).decryptBlock(r, !1, new Uint8Array(16));
                    }
                    getUserKey(e1, t, a) {
                        const r = new Uint8Array(e1.length + 8);
                        r.set(e1, 0);
                        r.set(t, e1.length);
                        const n = o(r, 0, r.length);
                        return new AES256Cipher(n).decryptBlock(a, !1, new Uint8Array(16));
                    }
                }
                t.PDF17 = PDF17;
                class PDF20 {
                    _hash(e1, t, a) {
                        let r = o(t, 0, t.length).subarray(0, 32), n = [
                            0
                        ], i = 0;
                        for(; i < 64 || n.at(-1) > i - 32;){
                            const t = e1.length + r.length + a.length, s = new Uint8Array(t);
                            let l = 0;
                            s.set(e1, l);
                            l += e1.length;
                            s.set(r, l);
                            l += r.length;
                            s.set(a, l);
                            const h = new Uint8Array(64 * t);
                            for(let e1 = 0, a = 0; e1 < 64; e1++, a += t)h.set(s, a);
                            n = new AES128Cipher(r.subarray(0, 16)).encrypt(h, r.subarray(16, 32));
                            const u = n.slice(0, 16).reduce((e1, t)=>e1 + t, 0) % 3;
                            0 === u ? r = o(n, 0, n.length) : 1 === u ? r = calculateSHA384(n, 0, n.length) : 2 === u && (r = c(n, 0, n.length));
                            i++;
                        }
                        return r.subarray(0, 32);
                    }
                    checkOwnerPassword(e1, t, a, n) {
                        const i = new Uint8Array(e1.length + 56);
                        i.set(e1, 0);
                        i.set(t, e1.length);
                        i.set(a, e1.length + t.length);
                        const s = this._hash(e1, i, a);
                        return (0, r.isArrayEqual)(s, n);
                    }
                    checkUserPassword(e1, t, a) {
                        const n = new Uint8Array(e1.length + 8);
                        n.set(e1, 0);
                        n.set(t, e1.length);
                        const i = this._hash(e1, n, []);
                        return (0, r.isArrayEqual)(i, a);
                    }
                    getOwnerKey(e1, t, a, r) {
                        const n = new Uint8Array(e1.length + 56);
                        n.set(e1, 0);
                        n.set(t, e1.length);
                        n.set(a, e1.length + t.length);
                        const i = this._hash(e1, n, a);
                        return new AES256Cipher(i).decryptBlock(r, !1, new Uint8Array(16));
                    }
                    getUserKey(e1, t, a) {
                        const r = new Uint8Array(e1.length + 8);
                        r.set(e1, 0);
                        r.set(t, e1.length);
                        const n = this._hash(e1, r, []);
                        return new AES256Cipher(n).decryptBlock(a, !1, new Uint8Array(16));
                    }
                }
                t.PDF20 = PDF20;
                class CipherTransform {
                    constructor(e1, t){
                        this.StringCipherConstructor = e1;
                        this.StreamCipherConstructor = t;
                    }
                    createStream(e1, t) {
                        const a = new this.StreamCipherConstructor;
                        return new i.DecryptStream(e1, t, function cipherTransformDecryptStream(e1, t) {
                            return a.decryptBlock(e1, t);
                        });
                    }
                    decryptString(e1) {
                        const t = new this.StringCipherConstructor;
                        let a = (0, r.stringToBytes)(e1);
                        a = t.decryptBlock(a, !0);
                        return (0, r.bytesToString)(a);
                    }
                    encryptString(e1) {
                        const t = new this.StringCipherConstructor;
                        if (t instanceof AESBaseCipher) {
                            const a = 16 - e1.length % 16;
                            e1 += String.fromCharCode(a).repeat(a);
                            const n = new Uint8Array(16);
                            if ("undefined" != typeof crypto) crypto.getRandomValues(n);
                            else for(let e1 = 0; e1 < 16; e1++)n[e1] = Math.floor(256 * Math.random());
                            let i = (0, r.stringToBytes)(e1);
                            i = t.encrypt(i, n);
                            const s = new Uint8Array(16 + i.length);
                            s.set(n);
                            s.set(i, 16);
                            return (0, r.bytesToString)(s);
                        }
                        let a = (0, r.stringToBytes)(e1);
                        a = t.encrypt(a);
                        return (0, r.bytesToString)(a);
                    }
                }
                class CipherTransformFactory {
                    static #O = new Uint8Array([
                        40,
                        191,
                        78,
                        94,
                        78,
                        117,
                        138,
                        65,
                        100,
                        0,
                        78,
                        86,
                        255,
                        250,
                        1,
                        8,
                        46,
                        46,
                        0,
                        182,
                        208,
                        104,
                        62,
                        128,
                        47,
                        12,
                        169,
                        254,
                        100,
                        83,
                        105,
                        122
                    ]);
                    #I(e1, t, a, r, n, i, s, o, c, l, h, u) {
                        if (t) {
                            const e1 = Math.min(127, t.length);
                            t = t.subarray(0, e1);
                        } else t = [];
                        const d = 6 === e1 ? new PDF20 : new PDF17;
                        return d.checkUserPassword(t, o, s) ? d.getUserKey(t, c, h) : t.length && d.checkOwnerPassword(t, r, i, a) ? d.getOwnerKey(t, n, i, l) : null;
                    }
                    #T(e1, t, a, r, n, i, o, c) {
                        const l = 40 + a.length + e1.length, h = new Uint8Array(l);
                        let u, d, f = 0;
                        if (t) {
                            d = Math.min(32, t.length);
                            for(; f < d; ++f)h[f] = t[f];
                        }
                        u = 0;
                        for(; f < 32;)h[f++] = CipherTransformFactory.#O[u++];
                        for(u = 0, d = a.length; u < d; ++u)h[f++] = a[u];
                        h[f++] = 255 & n;
                        h[f++] = n >> 8 & 255;
                        h[f++] = n >> 16 & 255;
                        h[f++] = n >>> 24 & 255;
                        for(u = 0, d = e1.length; u < d; ++u)h[f++] = e1[u];
                        if (i >= 4 && !c) {
                            h[f++] = 255;
                            h[f++] = 255;
                            h[f++] = 255;
                            h[f++] = 255;
                        }
                        let g = s(h, 0, f);
                        const p = o >> 3;
                        if (i >= 3) for(u = 0; u < 50; ++u)g = s(g, 0, p);
                        const m = g.subarray(0, p);
                        let b, y;
                        if (i >= 3) {
                            for(f = 0; f < 32; ++f)h[f] = CipherTransformFactory.#O[f];
                            for(u = 0, d = e1.length; u < d; ++u)h[f++] = e1[u];
                            b = new ARCFourCipher(m);
                            y = b.encryptBlock(s(h, 0, f));
                            d = m.length;
                            const t = new Uint8Array(d);
                            for(u = 1; u <= 19; ++u){
                                for(let e1 = 0; e1 < d; ++e1)t[e1] = m[e1] ^ u;
                                b = new ARCFourCipher(t);
                                y = b.encryptBlock(y);
                            }
                            for(u = 0, d = y.length; u < d; ++u)if (r[u] !== y[u]) return null;
                        } else {
                            b = new ARCFourCipher(m);
                            y = b.encryptBlock(CipherTransformFactory.#O);
                            for(u = 0, d = y.length; u < d; ++u)if (r[u] !== y[u]) return null;
                        }
                        return m;
                    }
                    #M(e1, t, a, r) {
                        const n = new Uint8Array(32);
                        let i = 0;
                        const o = Math.min(32, e1.length);
                        for(; i < o; ++i)n[i] = e1[i];
                        let c = 0;
                        for(; i < 32;)n[i++] = CipherTransformFactory.#O[c++];
                        let l = s(n, 0, i);
                        const h = r >> 3;
                        if (a >= 3) for(c = 0; c < 50; ++c)l = s(l, 0, l.length);
                        let u, d;
                        if (a >= 3) {
                            d = t;
                            const e1 = new Uint8Array(h);
                            for(c = 19; c >= 0; c--){
                                for(let t = 0; t < h; ++t)e1[t] = l[t] ^ c;
                                u = new ARCFourCipher(e1);
                                d = u.encryptBlock(d);
                            }
                        } else {
                            u = new ARCFourCipher(l.subarray(0, h));
                            d = u.encryptBlock(t);
                        }
                        return d;
                    }
                    #P(e1, t, a, r = !1) {
                        const n = new Uint8Array(a.length + 9), i = a.length;
                        let o;
                        for(o = 0; o < i; ++o)n[o] = a[o];
                        n[o++] = 255 & e1;
                        n[o++] = e1 >> 8 & 255;
                        n[o++] = e1 >> 16 & 255;
                        n[o++] = 255 & t;
                        n[o++] = t >> 8 & 255;
                        if (r) {
                            n[o++] = 115;
                            n[o++] = 65;
                            n[o++] = 108;
                            n[o++] = 84;
                        }
                        return s(n, 0, o).subarray(0, Math.min(a.length + 5, 16));
                    }
                    #D(e1, t, a, i, s) {
                        if (!(t instanceof n.Name)) throw new r.FormatError("Invalid crypt filter name.");
                        const o = this, c = e1.get(t.name), l = c?.get("CFM");
                        if (!l || "None" === l.name) return function() {
                            return new NullCipher;
                        };
                        if ("V2" === l.name) return function() {
                            return new ARCFourCipher(o.#P(a, i, s, !1));
                        };
                        if ("AESV2" === l.name) return function() {
                            return new AES128Cipher(o.#P(a, i, s, !0));
                        };
                        if ("AESV3" === l.name) return function() {
                            return new AES256Cipher(s);
                        };
                        throw new r.FormatError("Unknown crypto method");
                    }
                    constructor(e1, t, a){
                        const i = e1.get("Filter");
                        if (!(0, n.isName)(i, "Standard")) throw new r.FormatError("unknown encryption method");
                        this.filterName = i.name;
                        this.dict = e1;
                        const s = e1.get("V");
                        if (!Number.isInteger(s) || 1 !== s && 2 !== s && 4 !== s && 5 !== s) throw new r.FormatError("unsupported encryption algorithm");
                        this.algorithm = s;
                        let o = e1.get("Length");
                        if (!o) {
                            if (s <= 3) o = 40;
                            else {
                                const t = e1.get("CF"), a = e1.get("StmF");
                                if (t instanceof n.Dict && a instanceof n.Name) {
                                    t.suppressEncryption = !0;
                                    const e1 = t.get(a.name);
                                    o = e1?.get("Length") || 128;
                                    o < 40 && (o <<= 3);
                                }
                            }
                        }
                        if (!Number.isInteger(o) || o < 40 || o % 8 != 0) throw new r.FormatError("invalid key length");
                        const c = (0, r.stringToBytes)(e1.get("O")), l = (0, r.stringToBytes)(e1.get("U")), h = c.subarray(0, 32), u = l.subarray(0, 32), d = e1.get("P"), f = e1.get("R"), g = (4 === s || 5 === s) && !1 !== e1.get("EncryptMetadata");
                        this.encryptMetadata = g;
                        const p = (0, r.stringToBytes)(t);
                        let m, b;
                        if (a) {
                            if (6 === f) try {
                                a = (0, r.utf8StringToString)(a);
                            } catch  {
                                (0, r.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                            }
                            m = (0, r.stringToBytes)(a);
                        }
                        if (5 !== s) b = this.#T(p, m, h, u, d, f, o, g);
                        else {
                            const t = c.subarray(32, 40), a = c.subarray(40, 48), n = l.subarray(0, 48), i = l.subarray(32, 40), s = l.subarray(40, 48), o = (0, r.stringToBytes)(e1.get("OE")), d = (0, r.stringToBytes)(e1.get("UE")), g = (0, r.stringToBytes)(e1.get("Perms"));
                            b = this.#I(f, m, h, t, a, n, u, i, s, o, d, g);
                        }
                        if (!b && !a) throw new r.PasswordException("No password given", r.PasswordResponses.NEED_PASSWORD);
                        if (!b && a) {
                            const e1 = this.#M(m, h, f, o);
                            b = this.#T(p, e1, h, u, d, f, o, g);
                        }
                        if (!b) throw new r.PasswordException("Incorrect Password", r.PasswordResponses.INCORRECT_PASSWORD);
                        this.encryptionKey = b;
                        if (s >= 4) {
                            const t = e1.get("CF");
                            t instanceof n.Dict && (t.suppressEncryption = !0);
                            this.cf = t;
                            this.stmf = e1.get("StmF") || n.Name.get("Identity");
                            this.strf = e1.get("StrF") || n.Name.get("Identity");
                            this.eff = e1.get("EFF") || this.stmf;
                        }
                    }
                    createCipherTransform(e1, t) {
                        if (4 === this.algorithm || 5 === this.algorithm) return new CipherTransform(this.#D(this.cf, this.strf, e1, t, this.encryptionKey), this.#D(this.cf, this.stmf, e1, t, this.encryptionKey));
                        const a = this.#P(e1, t, this.encryptionKey, !1), cipherConstructor = function() {
                            return new ARCFourCipher(a);
                        };
                        return new CipherTransform(cipherConstructor, cipherConstructor);
                    }
                }
                t.CipherTransformFactory = CipherTransformFactory;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.DecryptStream = void 0;
                var r = a(18);
                class DecryptStream extends r.DecodeStream {
                    constructor(e1, t, a){
                        super(t);
                        this.str = e1;
                        this.dict = e1.dict;
                        this.decrypt = a;
                        this.nextChunk = null;
                        this.initialized = !1;
                    }
                    readBlock() {
                        let e1;
                        if (this.initialized) e1 = this.nextChunk;
                        else {
                            e1 = this.str.getBytes(512);
                            this.initialized = !0;
                        }
                        if (!e1 || 0 === e1.length) {
                            this.eof = !0;
                            return;
                        }
                        this.nextChunk = this.str.getBytes(512);
                        const t = this.nextChunk?.length > 0;
                        e1 = (0, this.decrypt)(e1, !t);
                        const a = this.bufferLength, r = a + e1.length;
                        this.ensureBuffer(r).set(e1, a);
                        this.bufferLength = r;
                    }
                }
                t.DecryptStream = DecryptStream;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ObjectLoader = void 0;
                var r = a(4), n = a(5), i = a(3), s = a(2);
                function addChildren(e1, t) {
                    if (e1 instanceof r.Dict) e1 = e1.getRawValues();
                    else if (e1 instanceof n.BaseStream) e1 = e1.dict.getRawValues();
                    else if (!Array.isArray(e1)) return;
                    for (const i of e1)((a = i) instanceof r.Ref || a instanceof r.Dict || a instanceof n.BaseStream || Array.isArray(a)) && t.push(i);
                    var a;
                }
                t.ObjectLoader = class ObjectLoader {
                    constructor(e1, t, a){
                        this.dict = e1;
                        this.keys = t;
                        this.xref = a;
                        this.refSet = null;
                    }
                    async load() {
                        if (this.xref.stream.isDataLoaded) return;
                        const { keys: e1, dict: t } = this;
                        this.refSet = new r.RefSet;
                        const a = [];
                        for (const r of e1){
                            const e1 = t.getRaw(r);
                            void 0 !== e1 && a.push(e1);
                        }
                        return this._walk(a);
                    }
                    async _walk(e1) {
                        const t = [], a = [];
                        for(; e1.length;){
                            let o = e1.pop();
                            if (o instanceof r.Ref) {
                                if (this.refSet.has(o)) continue;
                                try {
                                    this.refSet.put(o);
                                    o = this.xref.fetch(o);
                                } catch (e1) {
                                    if (!(e1 instanceof i.MissingDataException)) {
                                        (0, s.warn)(`ObjectLoader._walk - requesting all data: "${e1}".`);
                                        this.refSet = null;
                                        const { manager: t } = this.xref.stream;
                                        return t.requestAllChunks();
                                    }
                                    t.push(o);
                                    a.push({
                                        begin: e1.begin,
                                        end: e1.end
                                    });
                                }
                            }
                            if (o instanceof n.BaseStream) {
                                const e1 = o.getBaseStreams();
                                if (e1) {
                                    let r = !1;
                                    for (const t of e1)if (!t.isDataLoaded) {
                                        r = !0;
                                        a.push({
                                            begin: t.start,
                                            end: t.end
                                        });
                                    }
                                    r && t.push(o);
                                }
                            }
                            addChildren(o, e1);
                        }
                        if (a.length) {
                            await this.xref.stream.manager.requestRanges(a);
                            for (const e1 of t)e1 instanceof r.Ref && this.refSet.remove(e1);
                            return this._walk(t);
                        }
                        this.refSet = null;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XFAFactory = void 0;
                var r = a(78), n = a(79), i = a(89), s = a(85), o = a(84), c = a(2), l = a(90), h = a(100);
                class XFAFactory {
                    constructor(e1){
                        try {
                            this.root = (new l.XFAParser).parse(XFAFactory._createDocument(e1));
                            const t = new n.Binder(this.root);
                            this.form = t.bind();
                            this.dataHandler = new i.DataHandler(this.root, t.getData());
                            this.form[r.$globalData].template = this.form;
                        } catch (e1) {
                            (0, c.warn)(`XFA - an error occurred during parsing and binding: ${e1}`);
                        }
                    }
                    isValid() {
                        return this.root && this.form;
                    }
                    _createPagesHelper() {
                        const e1 = this.form[r.$toPages]();
                        return new Promise((t, a)=>{
                            const nextIteration = ()=>{
                                try {
                                    const a = e1.next();
                                    a.done ? t(a.value) : setTimeout(nextIteration, 0);
                                } catch (e1) {
                                    a(e1);
                                }
                            };
                            setTimeout(nextIteration, 0);
                        });
                    }
                    async _createPages() {
                        try {
                            this.pages = await this._createPagesHelper();
                            this.dims = this.pages.children.map((e1)=>{
                                const { width: t, height: a } = e1.attributes.style;
                                return [
                                    0,
                                    0,
                                    parseInt(t),
                                    parseInt(a)
                                ];
                            });
                        } catch (e1) {
                            (0, c.warn)(`XFA - an error occurred during layout: ${e1}`);
                        }
                    }
                    getBoundingBox(e1) {
                        return this.dims[e1];
                    }
                    async getNumPages() {
                        this.pages || await this._createPages();
                        return this.dims.length;
                    }
                    setImages(e1) {
                        this.form[r.$globalData].images = e1;
                    }
                    setFonts(e1) {
                        this.form[r.$globalData].fontFinder = new s.FontFinder(e1);
                        const t = [];
                        for (let e1 of this.form[r.$globalData].usedTypefaces){
                            e1 = (0, o.stripQuotes)(e1);
                            this.form[r.$globalData].fontFinder.find(e1) || t.push(e1);
                        }
                        return t.length > 0 ? t : null;
                    }
                    appendFonts(e1, t) {
                        this.form[r.$globalData].fontFinder.add(e1, t);
                    }
                    async getPages() {
                        this.pages || await this._createPages();
                        const e1 = this.pages;
                        this.pages = null;
                        return e1;
                    }
                    serializeData(e1) {
                        return this.dataHandler.serialize(e1);
                    }
                    static _createDocument(e1) {
                        return e1["/xdp:xdp"] ? Object.values(e1).join("") : e1["xdp:xdp"];
                    }
                    static getRichTextAsHtml(e1) {
                        if (!e1 || "string" != typeof e1) return null;
                        try {
                            let t = new l.XFAParser(h.XhtmlNamespace, !0).parse(e1);
                            if (![
                                "body",
                                "xhtml"
                            ].includes(t[r.$nodeName])) {
                                const e1 = h.XhtmlNamespace.body({});
                                e1[r.$appendChild](t);
                                t = e1;
                            }
                            const a = t[r.$toHTML]();
                            if (!a.success) return null;
                            const { html: n } = a, { attributes: i } = n;
                            if (i) {
                                i.class && (i.class = i.class.filter((e1)=>!e1.startsWith("xfa")));
                                i.dir = "auto";
                            }
                            return {
                                html: n,
                                str: t[r.$text]()
                            };
                        } catch (e1) {
                            (0, c.warn)(`XFA - an error occurred during parsing of rich text: ${e1}`);
                        }
                        return null;
                    }
                }
                t.XFAFactory = XFAFactory;
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.$uid = t.$toStyle = t.$toString = t.$toPages = t.$toHTML = t.$text = t.$tabIndex = t.$setValue = t.$setSetAttributes = t.$setId = t.$searchNode = t.$root = t.$resolvePrototypes = t.$removeChild = t.$pushPara = t.$pushGlyphs = t.$popPara = t.$onText = t.$onChildCheck = t.$onChild = t.$nsAttributes = t.$nodeName = t.$namespaceId = t.$lastAttribute = t.$isUsable = t.$isTransparent = t.$isThereMoreWidth = t.$isSplittable = t.$isNsAgnostic = t.$isDescendent = t.$isDataValue = t.$isCDATAXml = t.$isBindable = t.$insertAt = t.$indexOf = t.$ids = t.$hasSettableValue = t.$globalData = t.$getTemplateRoot = t.$getSubformParent = t.$getRealChildrenByNameIt = t.$getParent = t.$getNextPage = t.$getExtra = t.$getDataValue = t.$getContainedChildren = t.$getChildrenByNameIt = t.$getChildrenByName = t.$getChildrenByClass = t.$getChildren = t.$getAvailableSpace = t.$getAttributes = t.$getAttributeIt = t.$flushHTML = t.$finalize = t.$extra = t.$dump = t.$data = t.$content = t.$consumed = t.$clone = t.$cleanup = t.$cleanPage = t.$clean = t.$childrenToHTML = t.$appendChild = t.$addHTML = t.$acceptWhitespace = void 0;
                const a = Symbol();
                t.$acceptWhitespace = a;
                const r = Symbol();
                t.$addHTML = r;
                const n = Symbol();
                t.$appendChild = n;
                const i = Symbol();
                t.$childrenToHTML = i;
                const s = Symbol();
                t.$clean = s;
                const o = Symbol();
                t.$cleanPage = o;
                const c = Symbol();
                t.$cleanup = c;
                const l = Symbol();
                t.$clone = l;
                const h = Symbol();
                t.$consumed = h;
                const u = Symbol("content");
                t.$content = u;
                const d = Symbol("data");
                t.$data = d;
                const f = Symbol();
                t.$dump = f;
                const g = Symbol("extra");
                t.$extra = g;
                const p = Symbol();
                t.$finalize = p;
                const m = Symbol();
                t.$flushHTML = m;
                const b = Symbol();
                t.$getAttributeIt = b;
                const y = Symbol();
                t.$getAttributes = y;
                const w = Symbol();
                t.$getAvailableSpace = w;
                const S = Symbol();
                t.$getChildrenByClass = S;
                const x = Symbol();
                t.$getChildrenByName = x;
                const C = Symbol();
                t.$getChildrenByNameIt = C;
                const k = Symbol();
                t.$getDataValue = k;
                const v = Symbol();
                t.$getExtra = v;
                const F = Symbol();
                t.$getRealChildrenByNameIt = F;
                const O = Symbol();
                t.$getChildren = O;
                const T = Symbol();
                t.$getContainedChildren = T;
                const M = Symbol();
                t.$getNextPage = M;
                const D = Symbol();
                t.$getSubformParent = D;
                const E = Symbol();
                t.$getParent = E;
                const N = Symbol();
                t.$getTemplateRoot = N;
                const R = Symbol();
                t.$globalData = R;
                const L = Symbol();
                t.$hasSettableValue = L;
                const $ = Symbol();
                t.$ids = $;
                const _ = Symbol();
                t.$indexOf = _;
                const j = Symbol();
                t.$insertAt = j;
                const U = Symbol();
                t.$isCDATAXml = U;
                const X = Symbol();
                t.$isBindable = X;
                const H = Symbol();
                t.$isDataValue = H;
                const q = Symbol();
                t.$isDescendent = q;
                const z = Symbol();
                t.$isNsAgnostic = z;
                const W = Symbol();
                t.$isSplittable = W;
                const G = Symbol();
                t.$isThereMoreWidth = G;
                const V = Symbol();
                t.$isTransparent = V;
                const K = Symbol();
                t.$isUsable = K;
                const J = Symbol();
                t.$lastAttribute = J;
                const Y = Symbol("namespaceId");
                t.$namespaceId = Y;
                const Z = Symbol("nodeName");
                t.$nodeName = Z;
                const Q = Symbol();
                t.$nsAttributes = Q;
                const ee = Symbol();
                t.$onChild = ee;
                const te = Symbol();
                t.$onChildCheck = te;
                const ae = Symbol();
                t.$onText = ae;
                const re = Symbol();
                t.$pushGlyphs = re;
                const ne = Symbol();
                t.$popPara = ne;
                const ie = Symbol();
                t.$pushPara = ie;
                const se = Symbol();
                t.$removeChild = se;
                const oe = Symbol("root");
                t.$root = oe;
                const ce = Symbol();
                t.$resolvePrototypes = ce;
                const le = Symbol();
                t.$searchNode = le;
                const he = Symbol();
                t.$setId = he;
                const ue = Symbol();
                t.$setSetAttributes = ue;
                const de = Symbol();
                t.$setValue = de;
                const fe = Symbol();
                t.$tabIndex = fe;
                const ge = Symbol();
                t.$text = ge;
                const pe = Symbol();
                t.$toPages = pe;
                const me = Symbol();
                t.$toHTML = me;
                const be = Symbol();
                t.$toString = be;
                const ye = Symbol();
                t.$toStyle = ye;
                const we = Symbol("uid");
                t.$uid = we;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Binder = void 0;
                var r = a(78), n = a(80), i = a(88), s = a(87), o = a(81), c = a(2);
                const l = o.NamespaceIds.datasets.id;
                function createText(e1) {
                    const t = new n.Text({});
                    t[r.$content] = e1;
                    return t;
                }
                t.Binder = class Binder {
                    constructor(e1){
                        this.root = e1;
                        this.datasets = e1.datasets;
                        this.data = e1.datasets?.data || new s.XmlObject(o.NamespaceIds.datasets.id, "data");
                        this.emptyMerge = 0 === this.data[r.$getChildren]().length;
                        this.root.form = this.form = e1.template[r.$clone]();
                    }
                    _isConsumeData() {
                        return !this.emptyMerge && this._mergeMode;
                    }
                    _isMatchTemplate() {
                        return !this._isConsumeData();
                    }
                    bind() {
                        this._bindElement(this.form, this.data);
                        return this.form;
                    }
                    getData() {
                        return this.data;
                    }
                    _bindValue(e1, t, a) {
                        e1[r.$data] = t;
                        if (e1[r.$hasSettableValue]()) {
                            if (t[r.$isDataValue]()) {
                                const a = t[r.$getDataValue]();
                                e1[r.$setValue](createText(a));
                            } else if (e1 instanceof n.Field && "multiSelect" === e1.ui?.choiceList?.open) {
                                const a = t[r.$getChildren]().map((e1)=>e1[r.$content].trim()).join("\n");
                                e1[r.$setValue](createText(a));
                            } else this._isConsumeData() && (0, c.warn)("XFA - Nodes haven't the same type.");
                        } else !t[r.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(e1, t) : (0, c.warn)("XFA - Nodes haven't the same type.");
                    }
                    _findDataByNameToConsume(e1, t, a, n) {
                        if (!e1) return null;
                        let i, s;
                        for(let n = 0; n < 3; n++){
                            i = a[r.$getRealChildrenByNameIt](e1, !1, !0);
                            for(;;){
                                s = i.next().value;
                                if (!s) break;
                                if (t === s[r.$isDataValue]()) return s;
                            }
                            if (a[r.$namespaceId] === o.NamespaceIds.datasets.id && "data" === a[r.$nodeName]) break;
                            a = a[r.$getParent]();
                        }
                        if (!n) return null;
                        i = this.data[r.$getRealChildrenByNameIt](e1, !0, !1);
                        s = i.next().value;
                        if (s) return s;
                        i = this.data[r.$getAttributeIt](e1, !0);
                        s = i.next().value;
                        return s?.[r.$isDataValue]() ? s : null;
                    }
                    _setProperties(e1, t) {
                        if (e1.hasOwnProperty("setProperty")) for (const { ref: a, target: o, connection: l } of e1.setProperty.children){
                            if (l) continue;
                            if (!a) continue;
                            const h = (0, i.searchNode)(this.root, t, a, !1, !1);
                            if (!h) {
                                (0, c.warn)(`XFA - Invalid reference: ${a}.`);
                                continue;
                            }
                            const [u] = h;
                            if (!u[r.$isDescendent](this.data)) {
                                (0, c.warn)("XFA - Invalid node: must be a data node.");
                                continue;
                            }
                            const d = (0, i.searchNode)(this.root, e1, o, !1, !1);
                            if (!d) {
                                (0, c.warn)(`XFA - Invalid target: ${o}.`);
                                continue;
                            }
                            const [f] = d;
                            if (!f[r.$isDescendent](e1)) {
                                (0, c.warn)("XFA - Invalid target: must be a property or subproperty.");
                                continue;
                            }
                            const g = f[r.$getParent]();
                            if (f instanceof n.SetProperty || g instanceof n.SetProperty) {
                                (0, c.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                                continue;
                            }
                            if (f instanceof n.BindItems || g instanceof n.BindItems) {
                                (0, c.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                                continue;
                            }
                            const p = u[r.$text](), m = f[r.$nodeName];
                            if (f instanceof s.XFAAttribute) {
                                const e1 = Object.create(null);
                                e1[m] = p;
                                const t = Reflect.construct(Object.getPrototypeOf(g).constructor, [
                                    e1
                                ]);
                                g[m] = t[m];
                            } else if (f.hasOwnProperty(r.$content)) {
                                f[r.$data] = u;
                                f[r.$content] = p;
                                f[r.$finalize]();
                            } else (0, c.warn)("XFA - Invalid node to use in setProperty");
                        }
                    }
                    _bindItems(e1, t) {
                        if (!e1.hasOwnProperty("items") || !e1.hasOwnProperty("bindItems") || e1.bindItems.isEmpty()) return;
                        for (const t of e1.items.children)e1[r.$removeChild](t);
                        e1.items.clear();
                        const a = new n.Items({}), s = new n.Items({});
                        e1[r.$appendChild](a);
                        e1.items.push(a);
                        e1[r.$appendChild](s);
                        e1.items.push(s);
                        for (const { ref: n, labelRef: o, valueRef: l, connection: h } of e1.bindItems.children){
                            if (h) continue;
                            if (!n) continue;
                            const e1 = (0, i.searchNode)(this.root, t, n, !1, !1);
                            if (e1) for (const t of e1){
                                if (!t[r.$isDescendent](this.datasets)) {
                                    (0, c.warn)(`XFA - Invalid ref (${n}): must be a datasets child.`);
                                    continue;
                                }
                                const e1 = (0, i.searchNode)(this.root, t, o, !0, !1);
                                if (!e1) {
                                    (0, c.warn)(`XFA - Invalid label: ${o}.`);
                                    continue;
                                }
                                const [h] = e1;
                                if (!h[r.$isDescendent](this.datasets)) {
                                    (0, c.warn)("XFA - Invalid label: must be a datasets child.");
                                    continue;
                                }
                                const u = (0, i.searchNode)(this.root, t, l, !0, !1);
                                if (!u) {
                                    (0, c.warn)(`XFA - Invalid value: ${l}.`);
                                    continue;
                                }
                                const [d] = u;
                                if (!d[r.$isDescendent](this.datasets)) {
                                    (0, c.warn)("XFA - Invalid value: must be a datasets child.");
                                    continue;
                                }
                                const f = createText(h[r.$text]()), g = createText(d[r.$text]());
                                a[r.$appendChild](f);
                                a.text.push(f);
                                s[r.$appendChild](g);
                                s.text.push(g);
                            }
                            else (0, c.warn)(`XFA - Invalid reference: ${n}.`);
                        }
                    }
                    _bindOccurrences(e1, t, a) {
                        let n;
                        if (t.length > 1) {
                            n = e1[r.$clone]();
                            n[r.$removeChild](n.occur);
                            n.occur = null;
                        }
                        this._bindValue(e1, t[0], a);
                        this._setProperties(e1, t[0]);
                        this._bindItems(e1, t[0]);
                        if (1 === t.length) return;
                        const i = e1[r.$getParent](), s = e1[r.$nodeName], o = i[r.$indexOf](e1);
                        for(let e1 = 1, c = t.length; e1 < c; e1++){
                            const c = t[e1], l = n[r.$clone]();
                            i[s].push(l);
                            i[r.$insertAt](o + e1, l);
                            this._bindValue(l, c, a);
                            this._setProperties(l, c);
                            this._bindItems(l, c);
                        }
                    }
                    _createOccurrences(e1) {
                        if (!this.emptyMerge) return;
                        const { occur: t } = e1;
                        if (!t || t.initial <= 1) return;
                        const a = e1[r.$getParent](), n = e1[r.$nodeName];
                        if (!(a[n] instanceof s.XFAObjectArray)) return;
                        let i;
                        i = e1.name ? a[n].children.filter((t)=>t.name === e1.name).length : a[n].children.length;
                        const o = a[r.$indexOf](e1) + 1, c = t.initial - i;
                        if (c) {
                            const t = e1[r.$clone]();
                            t[r.$removeChild](t.occur);
                            t.occur = null;
                            a[n].push(t);
                            a[r.$insertAt](o, t);
                            for(let e1 = 1; e1 < c; e1++){
                                const i = t[r.$clone]();
                                a[n].push(i);
                                a[r.$insertAt](o + e1, i);
                            }
                        }
                    }
                    _getOccurInfo(e1) {
                        const { name: t, occur: a } = e1;
                        if (!a || !t) return [
                            1,
                            1
                        ];
                        const r = -1 === a.max ? 1 / 0 : a.max;
                        return [
                            a.min,
                            r
                        ];
                    }
                    _setAndBind(e1, t) {
                        this._setProperties(e1, t);
                        this._bindItems(e1, t);
                        this._bindElement(e1, t);
                    }
                    _bindElement(e1, t) {
                        const a = [];
                        this._createOccurrences(e1);
                        for (const n of e1[r.$getChildren]()){
                            if (n[r.$data]) continue;
                            if (void 0 === this._mergeMode && "subform" === n[r.$nodeName]) {
                                this._mergeMode = "consumeData" === n.mergeMode;
                                const e1 = t[r.$getChildren]();
                                if (e1.length > 0) this._bindOccurrences(n, [
                                    e1[0]
                                ], null);
                                else if (this.emptyMerge) {
                                    const e1 = t[r.$namespaceId] === l ? -1 : t[r.$namespaceId], a = n[r.$data] = new s.XmlObject(e1, n.name || "root");
                                    t[r.$appendChild](a);
                                    this._bindElement(n, a);
                                }
                                continue;
                            }
                            if (!n[r.$isBindable]()) continue;
                            let e1 = !1, o = null, h = null, u = null;
                            if (n.bind) {
                                switch(n.bind.match){
                                    case "none":
                                        this._setAndBind(n, t);
                                        continue;
                                    case "global":
                                        e1 = !0;
                                        break;
                                    case "dataRef":
                                        if (!n.bind.ref) {
                                            (0, c.warn)(`XFA - ref is empty in node ${n[r.$nodeName]}.`);
                                            this._setAndBind(n, t);
                                            continue;
                                        }
                                        h = n.bind.ref;
                                }
                                n.bind.picture && (o = n.bind.picture[r.$content]);
                            }
                            const [d, f] = this._getOccurInfo(n);
                            if (h) {
                                u = (0, i.searchNode)(this.root, t, h, !0, !1);
                                if (null === u) {
                                    u = (0, i.createDataNode)(this.data, t, h);
                                    if (!u) continue;
                                    this._isConsumeData() && (u[r.$consumed] = !0);
                                    this._setAndBind(n, u);
                                    continue;
                                }
                                this._isConsumeData() && (u = u.filter((e1)=>!e1[r.$consumed]));
                                u.length > f ? u = u.slice(0, f) : 0 === u.length && (u = null);
                                u && this._isConsumeData() && u.forEach((e1)=>{
                                    e1[r.$consumed] = !0;
                                });
                            } else {
                                if (!n.name) {
                                    this._setAndBind(n, t);
                                    continue;
                                }
                                if (this._isConsumeData()) {
                                    const a = [];
                                    for(; a.length < f;){
                                        const i = this._findDataByNameToConsume(n.name, n[r.$hasSettableValue](), t, e1);
                                        if (!i) break;
                                        i[r.$consumed] = !0;
                                        a.push(i);
                                    }
                                    u = a.length > 0 ? a : null;
                                } else {
                                    u = t[r.$getRealChildrenByNameIt](n.name, !1, this.emptyMerge).next().value;
                                    if (!u) {
                                        if (0 === d) {
                                            a.push(n);
                                            continue;
                                        }
                                        const e1 = t[r.$namespaceId] === l ? -1 : t[r.$namespaceId];
                                        u = n[r.$data] = new s.XmlObject(e1, n.name);
                                        this.emptyMerge && (u[r.$consumed] = !0);
                                        t[r.$appendChild](u);
                                        this._setAndBind(n, u);
                                        continue;
                                    }
                                    this.emptyMerge && (u[r.$consumed] = !0);
                                    u = [
                                        u
                                    ];
                                }
                            }
                            u ? this._bindOccurrences(n, u, o) : d > 0 ? this._setAndBind(n, t) : a.push(n);
                        }
                        a.forEach((e1)=>e1[r.$getParent]()[r.$removeChild](e1));
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Value = t.Text = t.TemplateNamespace = t.Template = t.SetProperty = t.Items = t.Field = t.BindItems = void 0;
                var r = a(78), n = a(81), i = a(82), s = a(83), o = a(87), c = a(84), l = a(2), h = a(85), u = a(3), d = a(88);
                const f = n.NamespaceIds.template.id, g = "http://www.w3.org/2000/svg", p = /^H(\d+)$/, m = new Set([
                    "image/gif",
                    "image/jpeg",
                    "image/jpg",
                    "image/pjpeg",
                    "image/png",
                    "image/apng",
                    "image/x-png",
                    "image/bmp",
                    "image/x-ms-bmp",
                    "image/tiff",
                    "image/tif",
                    "application/octet-stream"
                ]), b = [
                    [
                        [
                            66,
                            77
                        ],
                        "image/bmp"
                    ],
                    [
                        [
                            255,
                            216,
                            255
                        ],
                        "image/jpeg"
                    ],
                    [
                        [
                            73,
                            73,
                            42,
                            0
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            77,
                            77,
                            0,
                            42
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            71,
                            73,
                            70,
                            56,
                            57,
                            97
                        ],
                        "image/gif"
                    ],
                    [
                        [
                            137,
                            80,
                            78,
                            71,
                            13,
                            10,
                            26,
                            10
                        ],
                        "image/png"
                    ]
                ];
                function getBorderDims(e1) {
                    if (!e1 || !e1.border) return {
                        w: 0,
                        h: 0
                    };
                    const t = e1.border[r.$getExtra]();
                    return t ? {
                        w: t.widths[0] + t.widths[2] + t.insets[0] + t.insets[2],
                        h: t.widths[1] + t.widths[3] + t.insets[1] + t.insets[3]
                    } : {
                        w: 0,
                        h: 0
                    };
                }
                function hasMargin(e1) {
                    return e1.margin && (e1.margin.topInset || e1.margin.rightInset || e1.margin.bottomInset || e1.margin.leftInset);
                }
                function _setValue(e1, t) {
                    if (!e1.value) {
                        const t = new Value({});
                        e1[r.$appendChild](t);
                        e1.value = t;
                    }
                    e1.value[r.$setValue](t);
                }
                function* getContainedChildren(e1) {
                    for (const t of e1[r.$getChildren]())t instanceof SubformSet ? yield* t[r.$getContainedChildren]() : yield t;
                }
                function isRequired(e1) {
                    return "error" === e1.validate?.nullTest;
                }
                function setTabIndex(e1) {
                    for(; e1;){
                        if (!e1.traversal) {
                            e1[r.$tabIndex] = e1[r.$getParent]()[r.$tabIndex];
                            return;
                        }
                        if (e1[r.$tabIndex]) return;
                        let t = null;
                        for (const a of e1.traversal[r.$getChildren]())if ("next" === a.operation) {
                            t = a;
                            break;
                        }
                        if (!t || !t.ref) {
                            e1[r.$tabIndex] = e1[r.$getParent]()[r.$tabIndex];
                            return;
                        }
                        const a = e1[r.$getTemplateRoot]();
                        e1[r.$tabIndex] = ++a[r.$tabIndex];
                        const n = a[r.$searchNode](t.ref, e1);
                        if (!n) return;
                        e1 = n[0];
                    }
                }
                function applyAssist(e1, t) {
                    const a = e1.assist;
                    if (a) {
                        const e1 = a[r.$toHTML]();
                        e1 && (t.title = e1);
                        const n = a.role.match(p);
                        if (n) {
                            const e1 = "heading", a = n[1];
                            t.role = e1;
                            t["aria-level"] = a;
                        }
                    }
                    if ("table" === e1.layout) t.role = "table";
                    else if ("row" === e1.layout) t.role = "row";
                    else {
                        const a = e1[r.$getParent]();
                        "row" === a.layout && (t.role = "TH" === a.assist?.role ? "columnheader" : "cell");
                    }
                }
                function ariaLabel(e1) {
                    if (!e1.assist) return null;
                    const t = e1.assist;
                    return t.speak && "" !== t.speak[r.$content] ? t.speak[r.$content] : t.toolTip ? t.toolTip[r.$content] : null;
                }
                function valueToHtml(e1) {
                    return c.HTMLResult.success({
                        name: "div",
                        attributes: {
                            class: [
                                "xfaRich"
                            ],
                            style: Object.create(null)
                        },
                        children: [
                            {
                                name: "span",
                                attributes: {
                                    style: Object.create(null)
                                },
                                value: e1
                            }
                        ]
                    });
                }
                function setFirstUnsplittable(e1) {
                    const t = e1[r.$getTemplateRoot]();
                    if (null === t[r.$extra].firstUnsplittable) {
                        t[r.$extra].firstUnsplittable = e1;
                        t[r.$extra].noLayoutFailure = !0;
                    }
                }
                function unsetFirstUnsplittable(e1) {
                    const t = e1[r.$getTemplateRoot]();
                    t[r.$extra].firstUnsplittable === e1 && (t[r.$extra].noLayoutFailure = !1);
                }
                function handleBreak(e1) {
                    if (e1[r.$extra]) return !1;
                    e1[r.$extra] = Object.create(null);
                    if ("auto" === e1.targetType) return !1;
                    const t = e1[r.$getTemplateRoot]();
                    let a = null;
                    if (e1.target) {
                        a = t[r.$searchNode](e1.target, e1[r.$getParent]());
                        if (!a) return !1;
                        a = a[0];
                    }
                    const { currentPageArea: n, currentContentArea: i } = t[r.$extra];
                    if ("pageArea" === e1.targetType) {
                        a instanceof PageArea || (a = null);
                        if (e1.startNew) {
                            e1[r.$extra].target = a || n;
                            return !0;
                        }
                        if (a && a !== n) {
                            e1[r.$extra].target = a;
                            return !0;
                        }
                        return !1;
                    }
                    a instanceof ContentArea || (a = null);
                    const s = a && a[r.$getParent]();
                    let o, c = s;
                    if (e1.startNew) {
                        if (a) {
                            const e1 = s.contentArea.children, t = e1.indexOf(i), r = e1.indexOf(a);
                            -1 !== t && t < r && (c = null);
                            o = r - 1;
                        } else o = n.contentArea.children.indexOf(i);
                    } else {
                        if (!a || a === i) return !1;
                        o = s.contentArea.children.indexOf(a) - 1;
                        c = s === n ? null : s;
                    }
                    e1[r.$extra].target = c;
                    e1[r.$extra].index = o;
                    return !0;
                }
                function handleOverflow(e1, t, a) {
                    const n = e1[r.$getTemplateRoot](), i = n[r.$extra].noLayoutFailure, s = t[r.$getSubformParent];
                    t[r.$getSubformParent] = ()=>e1;
                    n[r.$extra].noLayoutFailure = !0;
                    const o = t[r.$toHTML](a);
                    e1[r.$addHTML](o.html, o.bbox);
                    n[r.$extra].noLayoutFailure = i;
                    t[r.$getSubformParent] = s;
                }
                class AppearanceFilter extends o.StringObject {
                    constructor(e1){
                        super(f, "appearanceFilter");
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Arc extends o.XFAObject {
                    constructor(e1){
                        super(f, "arc", !0);
                        this.circular = (0, c.getInteger)({
                            data: e1.circular,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.hand = (0, c.getStringOption)(e1.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.startAngle = (0, c.getFloat)({
                            data: e1.startAngle,
                            defaultValue: 0,
                            validate: (e1)=>!0
                        });
                        this.sweepAngle = (0, c.getFloat)({
                            data: e1.sweepAngle,
                            defaultValue: 360,
                            validate: (e1)=>!0
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.edge = null;
                        this.fill = null;
                    }
                    [r.$toHTML]() {
                        const e1 = this.edge || new Edge({}), t = e1[r.$toStyle](), a = Object.create(null);
                        "visible" === this.fill?.presence ? Object.assign(a, this.fill[r.$toStyle]()) : a.fill = "transparent";
                        a.strokeWidth = (0, s.measureToString)("visible" === e1.presence ? e1.thickness : 0);
                        a.stroke = t.color;
                        let n;
                        const i = {
                            xmlns: g,
                            style: {
                                width: "100%",
                                height: "100%",
                                overflow: "visible"
                            }
                        };
                        if (360 === this.sweepAngle) n = {
                            name: "ellipse",
                            attributes: {
                                xmlns: g,
                                cx: "50%",
                                cy: "50%",
                                rx: "50%",
                                ry: "50%",
                                style: a
                            }
                        };
                        else {
                            const e1 = this.startAngle * Math.PI / 180, t = this.sweepAngle * Math.PI / 180, r = this.sweepAngle > 180 ? 1 : 0, [s, o, c, l] = [
                                50 * (1 + Math.cos(e1)),
                                50 * (1 - Math.sin(e1)),
                                50 * (1 + Math.cos(e1 + t)),
                                50 * (1 - Math.sin(e1 + t))
                            ];
                            n = {
                                name: "path",
                                attributes: {
                                    xmlns: g,
                                    d: `M ${s} ${o} A 50 50 0 ${r} 0 ${c} ${l}`,
                                    vectorEffect: "non-scaling-stroke",
                                    style: a
                                }
                            };
                            Object.assign(i, {
                                viewBox: "0 0 100 100",
                                preserveAspectRatio: "none"
                            });
                        }
                        const o = {
                            name: "svg",
                            children: [
                                n
                            ],
                            attributes: i
                        };
                        if (hasMargin(this[r.$getParent]()[r.$getParent]())) return c.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                o
                            ]
                        });
                        o.attributes.style.position = "absolute";
                        return c.HTMLResult.success(o);
                    }
                }
                class Area extends o.XFAObject {
                    constructor(e1){
                        super(f, "area", !0);
                        this.colSpan = (0, c.getInteger)({
                            data: e1.colSpan,
                            defaultValue: 1,
                            validate: (e1)=>e1 >= 1 || -1 === e1
                        });
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                        this.area = new o.XFAObjectArray;
                        this.draw = new o.XFAObjectArray;
                        this.exObject = new o.XFAObjectArray;
                        this.exclGroup = new o.XFAObjectArray;
                        this.field = new o.XFAObjectArray;
                        this.subform = new o.XFAObjectArray;
                        this.subformSet = new o.XFAObjectArray;
                    }
                    *[r.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [r.$isTransparent]() {
                        return !0;
                    }
                    [r.$isBindable]() {
                        return !0;
                    }
                    [r.$addHTML](e1, t) {
                        const [a, n, i, s] = t;
                        this[r.$extra].width = Math.max(this[r.$extra].width, a + i);
                        this[r.$extra].height = Math.max(this[r.$extra].height, n + s);
                        this[r.$extra].children.push(e1);
                    }
                    [r.$getAvailableSpace]() {
                        return this[r.$extra].availableSpace;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)(this, "position"), a = {
                            style: t,
                            id: this[r.$uid],
                            class: [
                                "xfaArea"
                            ]
                        };
                        (0, s.isPrintOnly)(this) && a.class.push("xfaPrintOnly");
                        this.name && (a.xfaName = this.name);
                        const n = [];
                        this[r.$extra] = {
                            children: n,
                            width: 0,
                            height: 0,
                            availableSpace: e1
                        };
                        const i = this[r.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "exclGroup",
                                "subform",
                                "subformSet"
                            ]),
                            include: !0
                        });
                        if (!i.success) {
                            if (i.isBreak()) return i;
                            delete this[r.$extra];
                            return c.HTMLResult.FAILURE;
                        }
                        t.width = (0, s.measureToString)(this[r.$extra].width);
                        t.height = (0, s.measureToString)(this[r.$extra].height);
                        const o = {
                            name: "div",
                            attributes: a,
                            children: n
                        }, l = [
                            this.x,
                            this.y,
                            this[r.$extra].width,
                            this[r.$extra].height
                        ];
                        delete this[r.$extra];
                        return c.HTMLResult.success(o, l);
                    }
                }
                class Assist extends o.XFAObject {
                    constructor(e1){
                        super(f, "assist", !0);
                        this.id = e1.id || "";
                        this.role = e1.role || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.speak = null;
                        this.toolTip = null;
                    }
                    [r.$toHTML]() {
                        return this.toolTip?.[r.$content] || null;
                    }
                }
                class Barcode extends o.XFAObject {
                    constructor(e1){
                        super(f, "barcode", !0);
                        this.charEncoding = (0, c.getKeyword)({
                            data: e1.charEncoding ? e1.charEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (e1)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(e1) || e1.match(/iso-8859-\d{2}/)
                        });
                        this.checksum = (0, c.getStringOption)(e1.checksum, [
                            "none",
                            "1mod10",
                            "1mod10_1mod11",
                            "2mod10",
                            "auto"
                        ]);
                        this.dataColumnCount = (0, c.getInteger)({
                            data: e1.dataColumnCount,
                            defaultValue: -1,
                            validate: (e1)=>e1 >= 0
                        });
                        this.dataLength = (0, c.getInteger)({
                            data: e1.dataLength,
                            defaultValue: -1,
                            validate: (e1)=>e1 >= 0
                        });
                        this.dataPrep = (0, c.getStringOption)(e1.dataPrep, [
                            "none",
                            "flateCompress"
                        ]);
                        this.dataRowCount = (0, c.getInteger)({
                            data: e1.dataRowCount,
                            defaultValue: -1,
                            validate: (e1)=>e1 >= 0
                        });
                        this.endChar = e1.endChar || "";
                        this.errorCorrectionLevel = (0, c.getInteger)({
                            data: e1.errorCorrectionLevel,
                            defaultValue: -1,
                            validate: (e1)=>e1 >= 0 && e1 <= 8
                        });
                        this.id = e1.id || "";
                        this.moduleHeight = (0, c.getMeasurement)(e1.moduleHeight, "5mm");
                        this.moduleWidth = (0, c.getMeasurement)(e1.moduleWidth, "0.25mm");
                        this.printCheckDigit = (0, c.getInteger)({
                            data: e1.printCheckDigit,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.rowColumnRatio = (0, c.getRatio)(e1.rowColumnRatio);
                        this.startChar = e1.startChar || "";
                        this.textLocation = (0, c.getStringOption)(e1.textLocation, [
                            "below",
                            "above",
                            "aboveEmbedded",
                            "belowEmbedded",
                            "none"
                        ]);
                        this.truncate = (0, c.getInteger)({
                            data: e1.truncate,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.type = (0, c.getStringOption)(e1.type ? e1.type.toLowerCase() : "", [
                            "aztec",
                            "codabar",
                            "code2of5industrial",
                            "code2of5interleaved",
                            "code2of5matrix",
                            "code2of5standard",
                            "code3of9",
                            "code3of9extended",
                            "code11",
                            "code49",
                            "code93",
                            "code128",
                            "code128a",
                            "code128b",
                            "code128c",
                            "code128sscc",
                            "datamatrix",
                            "ean8",
                            "ean8add2",
                            "ean8add5",
                            "ean13",
                            "ean13add2",
                            "ean13add5",
                            "ean13pwcd",
                            "fim",
                            "logmars",
                            "maxicode",
                            "msi",
                            "pdf417",
                            "pdf417macro",
                            "plessey",
                            "postauscust2",
                            "postauscust3",
                            "postausreplypaid",
                            "postausstandard",
                            "postukrm4scc",
                            "postusdpbc",
                            "postusimb",
                            "postusstandard",
                            "postus5zip",
                            "qrcode",
                            "rfid",
                            "rss14",
                            "rss14expanded",
                            "rss14limited",
                            "rss14stacked",
                            "rss14stackedomni",
                            "rss14truncated",
                            "telepen",
                            "ucc128",
                            "ucc128random",
                            "ucc128sscc",
                            "upca",
                            "upcaadd2",
                            "upcaadd5",
                            "upcapwcd",
                            "upce",
                            "upceadd2",
                            "upceadd5",
                            "upcean2",
                            "upcean5",
                            "upsmaxicode"
                        ]);
                        this.upsMode = (0, c.getStringOption)(e1.upsMode, [
                            "usCarrier",
                            "internationalCarrier",
                            "secureSymbol",
                            "standardSymbol"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.wideNarrowRatio = (0, c.getRatio)(e1.wideNarrowRatio);
                        this.encrypt = null;
                        this.extras = null;
                    }
                }
                class Bind extends o.XFAObject {
                    constructor(e1){
                        super(f, "bind", !0);
                        this.match = (0, c.getStringOption)(e1.match, [
                            "once",
                            "dataRef",
                            "global",
                            "none"
                        ]);
                        this.ref = e1.ref || "";
                        this.picture = null;
                    }
                }
                class BindItems extends o.XFAObject {
                    constructor(e1){
                        super(f, "bindItems");
                        this.connection = e1.connection || "";
                        this.labelRef = e1.labelRef || "";
                        this.ref = e1.ref || "";
                        this.valueRef = e1.valueRef || "";
                    }
                }
                t.BindItems = BindItems;
                class Bookend extends o.XFAObject {
                    constructor(e1){
                        super(f, "bookend");
                        this.id = e1.id || "";
                        this.leader = e1.leader || "";
                        this.trailer = e1.trailer || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class BooleanElement extends o.Option01 {
                    constructor(e1){
                        super(f, "boolean");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(1 === this[r.$content] ? "1" : "0");
                    }
                }
                class Border extends o.XFAObject {
                    constructor(e1){
                        super(f, "border", !0);
                        this.break = (0, c.getStringOption)(e1.break, [
                            "close",
                            "open"
                        ]);
                        this.hand = (0, c.getStringOption)(e1.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.corner = new o.XFAObjectArray(4);
                        this.edge = new o.XFAObjectArray(4);
                        this.extras = null;
                        this.fill = null;
                        this.margin = null;
                    }
                    [r.$getExtra]() {
                        if (!this[r.$extra]) {
                            const e1 = this.edge.children.slice();
                            if (e1.length < 4) {
                                const t = e1.at(-1) || new Edge({});
                                for(let a = e1.length; a < 4; a++)e1.push(t);
                            }
                            const t = e1.map((e1)=>e1.thickness), a = [
                                0,
                                0,
                                0,
                                0
                            ];
                            if (this.margin) {
                                a[0] = this.margin.topInset;
                                a[1] = this.margin.rightInset;
                                a[2] = this.margin.bottomInset;
                                a[3] = this.margin.leftInset;
                            }
                            this[r.$extra] = {
                                widths: t,
                                insets: a,
                                edges: e1
                            };
                        }
                        return this[r.$extra];
                    }
                    [r.$toStyle]() {
                        const { edges: e1 } = this[r.$getExtra](), t = e1.map((e1)=>{
                            const t = e1[r.$toStyle]();
                            t.color ||= "#000000";
                            return t;
                        }), a = Object.create(null);
                        this.margin && Object.assign(a, this.margin[r.$toStyle]());
                        "visible" === this.fill?.presence && Object.assign(a, this.fill[r.$toStyle]());
                        if (this.corner.children.some((e1)=>0 !== e1.radius)) {
                            const e1 = this.corner.children.map((e1)=>e1[r.$toStyle]());
                            if (2 === e1.length || 3 === e1.length) {
                                const t = e1.at(-1);
                                for(let a = e1.length; a < 4; a++)e1.push(t);
                            }
                            a.borderRadius = e1.map((e1)=>e1.radius).join(" ");
                        }
                        switch(this.presence){
                            case "invisible":
                            case "hidden":
                                a.borderStyle = "";
                                break;
                            case "inactive":
                                a.borderStyle = "none";
                                break;
                            default:
                                a.borderStyle = t.map((e1)=>e1.style).join(" ");
                        }
                        a.borderWidth = t.map((e1)=>e1.width).join(" ");
                        a.borderColor = t.map((e1)=>e1.color).join(" ");
                        return a;
                    }
                }
                class Break extends o.XFAObject {
                    constructor(e1){
                        super(f, "break", !0);
                        this.after = (0, c.getStringOption)(e1.after, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.afterTarget = e1.afterTarget || "";
                        this.before = (0, c.getStringOption)(e1.before, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.beforeTarget = e1.beforeTarget || "";
                        this.bookendLeader = e1.bookendLeader || "";
                        this.bookendTrailer = e1.bookendTrailer || "";
                        this.id = e1.id || "";
                        this.overflowLeader = e1.overflowLeader || "";
                        this.overflowTarget = e1.overflowTarget || "";
                        this.overflowTrailer = e1.overflowTrailer || "";
                        this.startNew = (0, c.getInteger)({
                            data: e1.startNew,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                }
                class BreakAfter extends o.XFAObject {
                    constructor(e1){
                        super(f, "breakAfter", !0);
                        this.id = e1.id || "";
                        this.leader = e1.leader || "";
                        this.startNew = (0, c.getInteger)({
                            data: e1.startNew,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.target = e1.target || "";
                        this.targetType = (0, c.getStringOption)(e1.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = e1.trailer || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.script = null;
                    }
                }
                class BreakBefore extends o.XFAObject {
                    constructor(e1){
                        super(f, "breakBefore", !0);
                        this.id = e1.id || "";
                        this.leader = e1.leader || "";
                        this.startNew = (0, c.getInteger)({
                            data: e1.startNew,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.target = e1.target || "";
                        this.targetType = (0, c.getStringOption)(e1.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = e1.trailer || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.script = null;
                    }
                    [r.$toHTML](e1) {
                        this[r.$extra] = {};
                        return c.HTMLResult.FAILURE;
                    }
                }
                class Button extends o.XFAObject {
                    constructor(e1){
                        super(f, "button", !0);
                        this.highlight = (0, c.getStringOption)(e1.highlight, [
                            "inverted",
                            "none",
                            "outline",
                            "push"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                    [r.$toHTML](e1) {
                        const t = this[r.$getParent]()[r.$getParent](), a = {
                            name: "button",
                            attributes: {
                                id: this[r.$uid],
                                class: [
                                    "xfaButton"
                                ],
                                style: {}
                            },
                            children: []
                        };
                        for (const e1 of t.event.children){
                            if ("click" !== e1.activity || !e1.script) continue;
                            const t = (0, u.recoverJsURL)(e1.script[r.$content]);
                            if (!t) continue;
                            const n = (0, s.fixURL)(t.url);
                            n && a.children.push({
                                name: "a",
                                attributes: {
                                    id: "link" + this[r.$uid],
                                    href: n,
                                    newWindow: t.newWindow,
                                    class: [
                                        "xfaLink"
                                    ],
                                    style: {}
                                },
                                children: []
                            });
                        }
                        return c.HTMLResult.success(a);
                    }
                }
                class Calculate extends o.XFAObject {
                    constructor(e1){
                        super(f, "calculate", !0);
                        this.id = e1.id || "";
                        this.override = (0, c.getStringOption)(e1.override, [
                            "disabled",
                            "error",
                            "ignore",
                            "warning"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.script = null;
                    }
                }
                class Caption extends o.XFAObject {
                    constructor(e1){
                        super(f, "caption", !0);
                        this.id = e1.id || "";
                        this.placement = (0, c.getStringOption)(e1.placement, [
                            "left",
                            "bottom",
                            "inline",
                            "right",
                            "top"
                        ]);
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.reserve = Math.ceil((0, c.getMeasurement)(e1.reserve));
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.font = null;
                        this.margin = null;
                        this.para = null;
                        this.value = null;
                    }
                    [r.$setValue](e1) {
                        _setValue(this, e1);
                    }
                    [r.$getExtra](e1) {
                        if (!this[r.$extra]) {
                            let { width: t, height: a } = e1;
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    t = this.reserve <= 0 ? t : this.reserve;
                                    break;
                                case "top":
                                case "bottom":
                                    a = this.reserve <= 0 ? a : this.reserve;
                            }
                            this[r.$extra] = (0, s.layoutNode)(this, {
                                width: t,
                                height: a
                            });
                        }
                        return this[r.$extra];
                    }
                    [r.$toHTML](e1) {
                        if (!this.value) return c.HTMLResult.EMPTY;
                        this[r.$pushPara]();
                        const t = this.value[r.$toHTML](e1).html;
                        if (!t) {
                            this[r.$popPara]();
                            return c.HTMLResult.EMPTY;
                        }
                        const a = this.reserve;
                        if (this.reserve <= 0) {
                            const { w: t, h: a } = this[r.$getExtra](e1);
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    this.reserve = t;
                                    break;
                                case "top":
                                case "bottom":
                                    this.reserve = a;
                            }
                        }
                        const n = [];
                        "string" == typeof t ? n.push({
                            name: "#text",
                            value: t
                        }) : n.push(t);
                        const i = (0, s.toStyle)(this, "font", "margin", "visibility");
                        switch(this.placement){
                            case "left":
                            case "right":
                                this.reserve > 0 && (i.width = (0, s.measureToString)(this.reserve));
                                break;
                            case "top":
                            case "bottom":
                                this.reserve > 0 && (i.height = (0, s.measureToString)(this.reserve));
                        }
                        (0, s.setPara)(this, null, t);
                        this[r.$popPara]();
                        this.reserve = a;
                        return c.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: i,
                                class: [
                                    "xfaCaption"
                                ]
                            },
                            children: n
                        });
                    }
                }
                class Certificate extends o.StringObject {
                    constructor(e1){
                        super(f, "certificate");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Certificates extends o.XFAObject {
                    constructor(e1){
                        super(f, "certificates", !0);
                        this.credentialServerPolicy = (0, c.getStringOption)(e1.credentialServerPolicy, [
                            "optional",
                            "required"
                        ]);
                        this.id = e1.id || "";
                        this.url = e1.url || "";
                        this.urlPolicy = e1.urlPolicy || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.encryption = null;
                        this.issuers = null;
                        this.keyUsage = null;
                        this.oids = null;
                        this.signing = null;
                        this.subjectDNs = null;
                    }
                }
                class CheckButton extends o.XFAObject {
                    constructor(e1){
                        super(f, "checkButton", !0);
                        this.id = e1.id || "";
                        this.mark = (0, c.getStringOption)(e1.mark, [
                            "default",
                            "check",
                            "circle",
                            "cross",
                            "diamond",
                            "square",
                            "star"
                        ]);
                        this.shape = (0, c.getStringOption)(e1.shape, [
                            "square",
                            "round"
                        ]);
                        this.size = (0, c.getMeasurement)(e1.size, "10pt");
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)("margin"), a = (0, s.measureToString)(this.size);
                        t.width = t.height = a;
                        let n, i, o;
                        const l = this[r.$getParent]()[r.$getParent](), h = l.items.children.length && l.items.children[0][r.$toHTML]().html || [], u = {
                            on: (void 0 !== h[0] ? h[0] : "on").toString(),
                            off: (void 0 !== h[1] ? h[1] : "off").toString()
                        }, d = (l.value?.[r.$text]() || "off") === u.on || void 0, f = l[r.$getSubformParent](), g = l[r.$uid];
                        let p;
                        if (f instanceof ExclGroup) {
                            o = f[r.$uid];
                            n = "radio";
                            i = "xfaRadio";
                            p = f[r.$data]?.[r.$uid] || f[r.$uid];
                        } else {
                            n = "checkbox";
                            i = "xfaCheckbox";
                            p = l[r.$data]?.[r.$uid] || l[r.$uid];
                        }
                        const m = {
                            name: "input",
                            attributes: {
                                class: [
                                    i
                                ],
                                style: t,
                                fieldId: g,
                                dataId: p,
                                type: n,
                                checked: d,
                                xfaOn: u.on,
                                xfaOff: u.off,
                                "aria-label": ariaLabel(l),
                                "aria-required": !1
                            }
                        };
                        o && (m.attributes.name = o);
                        if (isRequired(l)) {
                            m.attributes["aria-required"] = !0;
                            m.attributes.required = !0;
                        }
                        return c.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                m
                            ]
                        });
                    }
                }
                class ChoiceList extends o.XFAObject {
                    constructor(e1){
                        super(f, "choiceList", !0);
                        this.commitOn = (0, c.getStringOption)(e1.commitOn, [
                            "select",
                            "exit"
                        ]);
                        this.id = e1.id || "";
                        this.open = (0, c.getStringOption)(e1.open, [
                            "userControl",
                            "always",
                            "multiSelect",
                            "onEntry"
                        ]);
                        this.textEntry = (0, c.getInteger)({
                            data: e1.textEntry,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)(this, "border", "margin"), a = this[r.$getParent]()[r.$getParent](), n = {
                            fontSize: `calc(${a.font?.size || 10}px * var(--scale-factor))`
                        }, i = [];
                        if (a.items.children.length > 0) {
                            const e1 = a.items;
                            let t = 0, s = 0;
                            if (2 === e1.children.length) {
                                t = e1.children[0].save;
                                s = 1 - t;
                            }
                            const o = e1.children[t][r.$toHTML]().html, c = e1.children[s][r.$toHTML]().html;
                            let l = !1;
                            const h = a.value?.[r.$text]() || "";
                            for(let e1 = 0, t = o.length; e1 < t; e1++){
                                const t = {
                                    name: "option",
                                    attributes: {
                                        value: c[e1] || o[e1],
                                        style: n
                                    },
                                    value: o[e1]
                                };
                                c[e1] === h && (t.attributes.selected = l = !0);
                                i.push(t);
                            }
                            l || i.splice(0, 0, {
                                name: "option",
                                attributes: {
                                    hidden: !0,
                                    selected: !0
                                },
                                value: " "
                            });
                        }
                        const o = {
                            class: [
                                "xfaSelect"
                            ],
                            fieldId: a[r.$uid],
                            dataId: a[r.$data]?.[r.$uid] || a[r.$uid],
                            style: t,
                            "aria-label": ariaLabel(a),
                            "aria-required": !1
                        };
                        if (isRequired(a)) {
                            o["aria-required"] = !0;
                            o.required = !0;
                        }
                        "multiSelect" === this.open && (o.multiple = !0);
                        return c.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                {
                                    name: "select",
                                    children: i,
                                    attributes: o
                                }
                            ]
                        });
                    }
                }
                class Color extends o.XFAObject {
                    constructor(e1){
                        super(f, "color", !0);
                        this.cSpace = (0, c.getStringOption)(e1.cSpace, [
                            "SRGB"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.value = e1.value ? (0, c.getColor)(e1.value) : "";
                        this.extras = null;
                    }
                    [r.$hasSettableValue]() {
                        return !1;
                    }
                    [r.$toStyle]() {
                        return this.value ? l.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
                    }
                }
                class Comb extends o.XFAObject {
                    constructor(e1){
                        super(f, "comb");
                        this.id = e1.id || "";
                        this.numberOfCells = (0, c.getInteger)({
                            data: e1.numberOfCells,
                            defaultValue: 0,
                            validate: (e1)=>e1 >= 0
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Connect extends o.XFAObject {
                    constructor(e1){
                        super(f, "connect", !0);
                        this.connection = e1.connection || "";
                        this.id = e1.id || "";
                        this.ref = e1.ref || "";
                        this.usage = (0, c.getStringOption)(e1.usage, [
                            "exportAndImport",
                            "exportOnly",
                            "importOnly"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.picture = null;
                    }
                }
                class ContentArea extends o.XFAObject {
                    constructor(e1){
                        super(f, "contentArea", !0);
                        this.h = (0, c.getMeasurement)(e1.h);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.w = (0, c.getMeasurement)(e1.w);
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                    }
                    [r.$toHTML](e1) {
                        const t = {
                            left: (0, s.measureToString)(this.x),
                            top: (0, s.measureToString)(this.y),
                            width: (0, s.measureToString)(this.w),
                            height: (0, s.measureToString)(this.h)
                        }, a = [
                            "xfaContentarea"
                        ];
                        (0, s.isPrintOnly)(this) && a.push("xfaPrintOnly");
                        return c.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {
                                style: t,
                                class: a,
                                id: this[r.$uid]
                            }
                        });
                    }
                }
                class Corner extends o.XFAObject {
                    constructor(e1){
                        super(f, "corner", !0);
                        this.id = e1.id || "";
                        this.inverted = (0, c.getInteger)({
                            data: e1.inverted,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.join = (0, c.getStringOption)(e1.join, [
                            "square",
                            "round"
                        ]);
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.radius = (0, c.getMeasurement)(e1.radius);
                        this.stroke = (0, c.getStringOption)(e1.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, c.getMeasurement)(e1.thickness, "0.5pt");
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle]() {
                        const e1 = (0, s.toStyle)(this, "visibility");
                        e1.radius = (0, s.measureToString)("square" === this.join ? 0 : this.radius);
                        return e1;
                    }
                }
                class DateElement extends o.ContentObject {
                    constructor(e1){
                        super(f, "date");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = this[r.$content].trim();
                        this[r.$content] = e1 ? new Date(e1) : null;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class DateTime extends o.ContentObject {
                    constructor(e1){
                        super(f, "dateTime");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = this[r.$content].trim();
                        this[r.$content] = e1 ? new Date(e1) : null;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class DateTimeEdit extends o.XFAObject {
                    constructor(e1){
                        super(f, "dateTimeEdit", !0);
                        this.hScrollPolicy = (0, c.getStringOption)(e1.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = e1.id || "";
                        this.picker = (0, c.getStringOption)(e1.picker, [
                            "host",
                            "none"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)(this, "border", "font", "margin"), a = this[r.$getParent]()[r.$getParent](), n = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: a[r.$uid],
                                dataId: a[r.$data]?.[r.$uid] || a[r.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: t,
                                "aria-label": ariaLabel(a),
                                "aria-required": !1
                            }
                        };
                        if (isRequired(a)) {
                            n.attributes["aria-required"] = !0;
                            n.attributes.required = !0;
                        }
                        return c.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                n
                            ]
                        });
                    }
                }
                class Decimal extends o.ContentObject {
                    constructor(e1){
                        super(f, "decimal");
                        this.fracDigits = (0, c.getInteger)({
                            data: e1.fracDigits,
                            defaultValue: 2,
                            validate: (e1)=>!0
                        });
                        this.id = e1.id || "";
                        this.leadDigits = (0, c.getInteger)({
                            data: e1.leadDigits,
                            defaultValue: -1,
                            validate: (e1)=>!0
                        });
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = parseFloat(this[r.$content].trim());
                        this[r.$content] = isNaN(e1) ? null : e1;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(null !== this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class DefaultUi extends o.XFAObject {
                    constructor(e1){
                        super(f, "defaultUi", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                }
                class Desc extends o.XFAObject {
                    constructor(e1){
                        super(f, "desc", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.boolean = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                    }
                }
                class DigestMethod extends o.OptionObject {
                    constructor(e1){
                        super(f, "digestMethod", [
                            "",
                            "SHA1",
                            "SHA256",
                            "SHA512",
                            "RIPEMD160"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class DigestMethods extends o.XFAObject {
                    constructor(e1){
                        super(f, "digestMethods", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.digestMethod = new o.XFAObjectArray;
                    }
                }
                class Draw extends o.XFAObject {
                    constructor(e1){
                        super(f, "draw", !0);
                        this.anchorType = (0, c.getStringOption)(e1.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, c.getInteger)({
                            data: e1.colSpan,
                            defaultValue: 1,
                            validate: (e1)=>e1 >= 1 || -1 === e1
                        });
                        this.h = e1.h ? (0, c.getMeasurement)(e1.h) : "";
                        this.hAlign = (0, c.getStringOption)(e1.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.locale = e1.locale || "";
                        this.maxH = (0, c.getMeasurement)(e1.maxH, "0pt");
                        this.maxW = (0, c.getMeasurement)(e1.maxW, "0pt");
                        this.minH = (0, c.getMeasurement)(e1.minH, "0pt");
                        this.minW = (0, c.getMeasurement)(e1.minW, "0pt");
                        this.name = e1.name || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.rotate = (0, c.getInteger)({
                            data: e1.rotate,
                            defaultValue: 0,
                            validate: (e1)=>e1 % 90 == 0
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.w = e1.w ? (0, c.getMeasurement)(e1.w) : "";
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.assist = null;
                        this.border = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.value = null;
                        this.setProperty = new o.XFAObjectArray;
                    }
                    [r.$setValue](e1) {
                        _setValue(this, e1);
                    }
                    [r.$toHTML](e1) {
                        setTabIndex(this);
                        if ("hidden" === this.presence || "inactive" === this.presence) return c.HTMLResult.EMPTY;
                        (0, s.fixDimensions)(this);
                        this[r.$pushPara]();
                        const t = this.w, a = this.h, { w: n, h: o, isBroken: l } = (0, s.layoutNode)(this, e1);
                        if (n && "" === this.w) {
                            if (l && this[r.$getSubformParent]()[r.$isThereMoreWidth]()) {
                                this[r.$popPara]();
                                return c.HTMLResult.FAILURE;
                            }
                            this.w = n;
                        }
                        o && "" === this.h && (this.h = o);
                        setFirstUnsplittable(this);
                        if (!(0, i.checkDimensions)(this, e1)) {
                            this.w = t;
                            this.h = a;
                            this[r.$popPara]();
                            return c.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const h = (0, s.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                        (0, s.setMinMaxDimensions)(this, h);
                        if (h.margin) {
                            h.padding = h.margin;
                            delete h.margin;
                        }
                        const u = [
                            "xfaDraw"
                        ];
                        this.font && u.push("xfaFont");
                        (0, s.isPrintOnly)(this) && u.push("xfaPrintOnly");
                        const d = {
                            style: h,
                            id: this[r.$uid],
                            class: u
                        };
                        this.name && (d.xfaName = this.name);
                        const f = {
                            name: "div",
                            attributes: d,
                            children: []
                        };
                        applyAssist(this, d);
                        const g = (0, s.computeBbox)(this, f, e1), p = this.value ? this.value[r.$toHTML](e1).html : null;
                        if (null === p) {
                            this.w = t;
                            this.h = a;
                            this[r.$popPara]();
                            return c.HTMLResult.success((0, s.createWrapper)(this, f), g);
                        }
                        f.children.push(p);
                        (0, s.setPara)(this, h, p);
                        this.w = t;
                        this.h = a;
                        this[r.$popPara]();
                        return c.HTMLResult.success((0, s.createWrapper)(this, f), g);
                    }
                }
                class Edge extends o.XFAObject {
                    constructor(e1){
                        super(f, "edge", !0);
                        this.cap = (0, c.getStringOption)(e1.cap, [
                            "square",
                            "butt",
                            "round"
                        ]);
                        this.id = e1.id || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.stroke = (0, c.getStringOption)(e1.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, c.getMeasurement)(e1.thickness, "0.5pt");
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle]() {
                        const e1 = (0, s.toStyle)(this, "visibility");
                        Object.assign(e1, {
                            linecap: this.cap,
                            width: (0, s.measureToString)(this.thickness),
                            color: this.color ? this.color[r.$toStyle]() : "#000000",
                            style: ""
                        });
                        if ("visible" !== this.presence) e1.style = "none";
                        else switch(this.stroke){
                            case "solid":
                                e1.style = "solid";
                                break;
                            case "dashDot":
                            case "dashDotDot":
                            case "dashed":
                                e1.style = "dashed";
                                break;
                            case "dotted":
                                e1.style = "dotted";
                                break;
                            case "embossed":
                                e1.style = "ridge";
                                break;
                            case "etched":
                                e1.style = "groove";
                                break;
                            case "lowered":
                                e1.style = "inset";
                                break;
                            case "raised":
                                e1.style = "outset";
                        }
                        return e1;
                    }
                }
                class Encoding extends o.OptionObject {
                    constructor(e1){
                        super(f, "encoding", [
                            "adbe.x509.rsa_sha1",
                            "adbe.pkcs7.detached",
                            "adbe.pkcs7.sha1"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Encodings extends o.XFAObject {
                    constructor(e1){
                        super(f, "encodings", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.encoding = new o.XFAObjectArray;
                    }
                }
                class Encrypt extends o.XFAObject {
                    constructor(e1){
                        super(f, "encrypt", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.certificate = null;
                    }
                }
                class EncryptData extends o.XFAObject {
                    constructor(e1){
                        super(f, "encryptData", !0);
                        this.id = e1.id || "";
                        this.operation = (0, c.getStringOption)(e1.operation, [
                            "encrypt",
                            "decrypt"
                        ]);
                        this.target = e1.target || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Encryption extends o.XFAObject {
                    constructor(e1){
                        super(f, "encryption", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.certificate = new o.XFAObjectArray;
                    }
                }
                class EncryptionMethod extends o.OptionObject {
                    constructor(e1){
                        super(f, "encryptionMethod", [
                            "",
                            "AES256-CBC",
                            "TRIPLEDES-CBC",
                            "AES128-CBC",
                            "AES192-CBC"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class EncryptionMethods extends o.XFAObject {
                    constructor(e1){
                        super(f, "encryptionMethods", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.encryptionMethod = new o.XFAObjectArray;
                    }
                }
                class Event extends o.XFAObject {
                    constructor(e1){
                        super(f, "event", !0);
                        this.activity = (0, c.getStringOption)(e1.activity, [
                            "click",
                            "change",
                            "docClose",
                            "docReady",
                            "enter",
                            "exit",
                            "full",
                            "indexChange",
                            "initialize",
                            "mouseDown",
                            "mouseEnter",
                            "mouseExit",
                            "mouseUp",
                            "postExecute",
                            "postOpen",
                            "postPrint",
                            "postSave",
                            "postSign",
                            "postSubmit",
                            "preExecute",
                            "preOpen",
                            "prePrint",
                            "preSave",
                            "preSign",
                            "preSubmit",
                            "ready",
                            "validationState"
                        ]);
                        this.id = e1.id || "";
                        this.listen = (0, c.getStringOption)(e1.listen, [
                            "refOnly",
                            "refAndDescendents"
                        ]);
                        this.name = e1.name || "";
                        this.ref = e1.ref || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.encryptData = null;
                        this.execute = null;
                        this.script = null;
                        this.signData = null;
                        this.submit = null;
                    }
                }
                class ExData extends o.ContentObject {
                    constructor(e1){
                        super(f, "exData");
                        this.contentType = e1.contentType || "";
                        this.href = e1.href || "";
                        this.id = e1.id || "";
                        this.maxLength = (0, c.getInteger)({
                            data: e1.maxLength,
                            defaultValue: -1,
                            validate: (e1)=>e1 >= -1
                        });
                        this.name = e1.name || "";
                        this.rid = e1.rid || "";
                        this.transferEncoding = (0, c.getStringOption)(e1.transferEncoding, [
                            "none",
                            "base64",
                            "package"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$isCDATAXml]() {
                        return "text/html" === this.contentType;
                    }
                    [r.$onChild](e1) {
                        if ("text/html" === this.contentType && e1[r.$namespaceId] === n.NamespaceIds.xhtml.id) {
                            this[r.$content] = e1;
                            return !0;
                        }
                        if ("text/xml" === this.contentType) {
                            this[r.$content] = e1;
                            return !0;
                        }
                        return !1;
                    }
                    [r.$toHTML](e1) {
                        return "text/html" === this.contentType && this[r.$content] ? this[r.$content][r.$toHTML](e1) : c.HTMLResult.EMPTY;
                    }
                }
                class ExObject extends o.XFAObject {
                    constructor(e1){
                        super(f, "exObject", !0);
                        this.archive = e1.archive || "";
                        this.classId = e1.classId || "";
                        this.codeBase = e1.codeBase || "";
                        this.codeType = e1.codeType || "";
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.boolean = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.exObject = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                    }
                }
                class ExclGroup extends o.XFAObject {
                    constructor(e1){
                        super(f, "exclGroup", !0);
                        this.access = (0, c.getStringOption)(e1.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = e1.accessKey || "";
                        this.anchorType = (0, c.getStringOption)(e1.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, c.getInteger)({
                            data: e1.colSpan,
                            defaultValue: 1,
                            validate: (e1)=>e1 >= 1 || -1 === e1
                        });
                        this.h = e1.h ? (0, c.getMeasurement)(e1.h) : "";
                        this.hAlign = (0, c.getStringOption)(e1.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.layout = (0, c.getStringOption)(e1.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.maxH = (0, c.getMeasurement)(e1.maxH, "0pt");
                        this.maxW = (0, c.getMeasurement)(e1.maxW, "0pt");
                        this.minH = (0, c.getMeasurement)(e1.minH, "0pt");
                        this.minW = (0, c.getMeasurement)(e1.minW, "0pt");
                        this.name = e1.name || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.w = e1.w ? (0, c.getMeasurement)(e1.w) : "";
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.connect = new o.XFAObjectArray;
                        this.event = new o.XFAObjectArray;
                        this.field = new o.XFAObjectArray;
                        this.setProperty = new o.XFAObjectArray;
                    }
                    [r.$isBindable]() {
                        return !0;
                    }
                    [r.$hasSettableValue]() {
                        return !0;
                    }
                    [r.$setValue](e1) {
                        for (const t of this.field.children){
                            if (!t.value) {
                                const e1 = new Value({});
                                t[r.$appendChild](e1);
                                t.value = e1;
                            }
                            t.value[r.$setValue](e1);
                        }
                    }
                    [r.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && 0 === this[r.$extra].attempt && this[r.$extra].numberInLine > 0 || this[r.$getParent]()[r.$isThereMoreWidth]();
                    }
                    [r.$isSplittable]() {
                        const e1 = this[r.$getSubformParent]();
                        if (!e1[r.$isSplittable]()) return !1;
                        if (void 0 !== this[r.$extra]._isSplittable) return this[r.$extra]._isSplittable;
                        if ("position" === this.layout || this.layout.includes("row")) {
                            this[r.$extra]._isSplittable = !1;
                            return !1;
                        }
                        if (e1.layout?.endsWith("-tb") && 0 !== e1[r.$extra].numberInLine) return !1;
                        this[r.$extra]._isSplittable = !0;
                        return !0;
                    }
                    [r.$flushHTML]() {
                        return (0, i.flushHTML)(this);
                    }
                    [r.$addHTML](e1, t) {
                        (0, i.addHTML)(this, e1, t);
                    }
                    [r.$getAvailableSpace]() {
                        return (0, i.getAvailableSpace)(this);
                    }
                    [r.$toHTML](e1) {
                        setTabIndex(this);
                        if ("hidden" === this.presence || "inactive" === this.presence || 0 === this.h || 0 === this.w) return c.HTMLResult.EMPTY;
                        (0, s.fixDimensions)(this);
                        const t = [], a = {
                            id: this[r.$uid],
                            class: []
                        };
                        (0, s.setAccess)(this, a.class);
                        this[r.$extra] || (this[r.$extra] = Object.create(null));
                        Object.assign(this[r.$extra], {
                            children: t,
                            attributes: a,
                            attempt: 0,
                            line: null,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || 1 / 0, e1.width),
                                height: Math.min(this.h || 1 / 0, e1.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const n = this[r.$isSplittable]();
                        n || setFirstUnsplittable(this);
                        if (!(0, i.checkDimensions)(this, e1)) return c.HTMLResult.FAILURE;
                        const o = new Set([
                            "field"
                        ]);
                        if (this.layout.includes("row")) {
                            const e1 = this[r.$getSubformParent]().columnWidths;
                            if (Array.isArray(e1) && e1.length > 0) {
                                this[r.$extra].columnWidths = e1;
                                this[r.$extra].currentColumn = 0;
                            }
                        }
                        const l = (0, s.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), h = [
                            "xfaExclgroup"
                        ], u = (0, s.layoutClass)(this);
                        u && h.push(u);
                        (0, s.isPrintOnly)(this) && h.push("xfaPrintOnly");
                        a.style = l;
                        a.class = h;
                        this.name && (a.xfaName = this.name);
                        this[r.$pushPara]();
                        const d = "lr-tb" === this.layout || "rl-tb" === this.layout, f = d ? 2 : 1;
                        for(; this[r.$extra].attempt < f; this[r.$extra].attempt++){
                            d && 1 === this[r.$extra].attempt && (this[r.$extra].numberInLine = 0);
                            const e1 = this[r.$childrenToHTML]({
                                filter: o,
                                include: !0
                            });
                            if (e1.success) break;
                            if (e1.isBreak()) {
                                this[r.$popPara]();
                                return e1;
                            }
                            if (d && 0 === this[r.$extra].attempt && 0 === this[r.$extra].numberInLine && !this[r.$getTemplateRoot]()[r.$extra].noLayoutFailure) {
                                this[r.$extra].attempt = f;
                                break;
                            }
                        }
                        this[r.$popPara]();
                        n || unsetFirstUnsplittable(this);
                        if (this[r.$extra].attempt === f) {
                            n || delete this[r.$extra];
                            return c.HTMLResult.FAILURE;
                        }
                        let g = 0, p = 0;
                        if (this.margin) {
                            g = this.margin.leftInset + this.margin.rightInset;
                            p = this.margin.topInset + this.margin.bottomInset;
                        }
                        const m = Math.max(this[r.$extra].width + g, this.w || 0), b = Math.max(this[r.$extra].height + p, this.h || 0), y = [
                            this.x,
                            this.y,
                            m,
                            b
                        ];
                        "" === this.w && (l.width = (0, s.measureToString)(m));
                        "" === this.h && (l.height = (0, s.measureToString)(b));
                        const w = {
                            name: "div",
                            attributes: a,
                            children: t
                        };
                        applyAssist(this, a);
                        delete this[r.$extra];
                        return c.HTMLResult.success((0, s.createWrapper)(this, w), y);
                    }
                }
                class Execute extends o.XFAObject {
                    constructor(e1){
                        super(f, "execute");
                        this.connection = e1.connection || "";
                        this.executeType = (0, c.getStringOption)(e1.executeType, [
                            "import",
                            "remerge"
                        ]);
                        this.id = e1.id || "";
                        this.runAt = (0, c.getStringOption)(e1.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Extras extends o.XFAObject {
                    constructor(e1){
                        super(f, "extras", !0);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.boolean = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.extras = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                    }
                }
                class Field extends o.XFAObject {
                    constructor(e1){
                        super(f, "field", !0);
                        this.access = (0, c.getStringOption)(e1.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = e1.accessKey || "";
                        this.anchorType = (0, c.getStringOption)(e1.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, c.getInteger)({
                            data: e1.colSpan,
                            defaultValue: 1,
                            validate: (e1)=>e1 >= 1 || -1 === e1
                        });
                        this.h = e1.h ? (0, c.getMeasurement)(e1.h) : "";
                        this.hAlign = (0, c.getStringOption)(e1.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.locale = e1.locale || "";
                        this.maxH = (0, c.getMeasurement)(e1.maxH, "0pt");
                        this.maxW = (0, c.getMeasurement)(e1.maxW, "0pt");
                        this.minH = (0, c.getMeasurement)(e1.minH, "0pt");
                        this.minW = (0, c.getMeasurement)(e1.minW, "0pt");
                        this.name = e1.name || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.rotate = (0, c.getInteger)({
                            data: e1.rotate,
                            defaultValue: 0,
                            validate: (e1)=>e1 % 90 == 0
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.w = e1.w ? (0, c.getMeasurement)(e1.w) : "";
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.format = null;
                        this.items = new o.XFAObjectArray(2);
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.validate = null;
                        this.value = null;
                        this.bindItems = new o.XFAObjectArray;
                        this.connect = new o.XFAObjectArray;
                        this.event = new o.XFAObjectArray;
                        this.setProperty = new o.XFAObjectArray;
                    }
                    [r.$isBindable]() {
                        return !0;
                    }
                    [r.$setValue](e1) {
                        _setValue(this, e1);
                    }
                    [r.$toHTML](e1) {
                        setTabIndex(this);
                        if (!this.ui) {
                            this.ui = new Ui({});
                            this.ui[r.$globalData] = this[r.$globalData];
                            this[r.$appendChild](this.ui);
                            let e1;
                            switch(this.items.children.length){
                                case 0:
                                    e1 = new TextEdit({});
                                    this.ui.textEdit = e1;
                                    break;
                                case 1:
                                    e1 = new CheckButton({});
                                    this.ui.checkButton = e1;
                                    break;
                                case 2:
                                    e1 = new ChoiceList({});
                                    this.ui.choiceList = e1;
                            }
                            this.ui[r.$appendChild](e1);
                        }
                        if (!this.ui || "hidden" === this.presence || "inactive" === this.presence || 0 === this.h || 0 === this.w) return c.HTMLResult.EMPTY;
                        this.caption && delete this.caption[r.$extra];
                        this[r.$pushPara]();
                        const t = this.caption ? this.caption[r.$toHTML](e1).html : null, a = this.w, n = this.h;
                        let o = 0, l = 0;
                        if (this.margin) {
                            o = this.margin.leftInset + this.margin.rightInset;
                            l = this.margin.topInset + this.margin.bottomInset;
                        }
                        let u = null;
                        if ("" === this.w || "" === this.h) {
                            let t = null, a = null, n = 0, i = 0;
                            if (this.ui.checkButton) n = i = this.ui.checkButton.size;
                            else {
                                const { w: t, h: a } = (0, s.layoutNode)(this, e1);
                                if (null !== t) {
                                    n = t;
                                    i = a;
                                } else i = (0, h.getMetrics)(this.font, !0).lineNoGap;
                            }
                            u = getBorderDims(this.ui[r.$getExtra]());
                            n += u.w;
                            i += u.h;
                            if (this.caption) {
                                const { w: s, h: o, isBroken: l } = this.caption[r.$getExtra](e1);
                                if (l && this[r.$getSubformParent]()[r.$isThereMoreWidth]()) {
                                    this[r.$popPara]();
                                    return c.HTMLResult.FAILURE;
                                }
                                t = s;
                                a = o;
                                switch(this.caption.placement){
                                    case "left":
                                    case "right":
                                    case "inline":
                                        t += n;
                                        break;
                                    case "top":
                                    case "bottom":
                                        a += i;
                                }
                            } else {
                                t = n;
                                a = i;
                            }
                            if (t && "" === this.w) {
                                t += o;
                                this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < t ? t : this.minW);
                            }
                            if (a && "" === this.h) {
                                a += l;
                                this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < a ? a : this.minH);
                            }
                        }
                        this[r.$popPara]();
                        (0, s.fixDimensions)(this);
                        setFirstUnsplittable(this);
                        if (!(0, i.checkDimensions)(this, e1)) {
                            this.w = a;
                            this.h = n;
                            this[r.$popPara]();
                            return c.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const d = (0, s.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                        (0, s.setMinMaxDimensions)(this, d);
                        const f = [
                            "xfaField"
                        ];
                        this.font && f.push("xfaFont");
                        (0, s.isPrintOnly)(this) && f.push("xfaPrintOnly");
                        const g = {
                            style: d,
                            id: this[r.$uid],
                            class: f
                        };
                        if (d.margin) {
                            d.padding = d.margin;
                            delete d.margin;
                        }
                        (0, s.setAccess)(this, f);
                        this.name && (g.xfaName = this.name);
                        const p = [], m = {
                            name: "div",
                            attributes: g,
                            children: p
                        };
                        applyAssist(this, g);
                        const b = this.border ? this.border[r.$toStyle]() : null, y = (0, s.computeBbox)(this, m, e1), w = this.ui[r.$toHTML]().html;
                        if (!w) {
                            Object.assign(d, b);
                            return c.HTMLResult.success((0, s.createWrapper)(this, m), y);
                        }
                        this[r.$tabIndex] && (w.children?.[0] ? w.children[0].attributes.tabindex = this[r.$tabIndex] : w.attributes.tabindex = this[r.$tabIndex]);
                        w.attributes.style || (w.attributes.style = Object.create(null));
                        let S = null;
                        if (this.ui.button) {
                            1 === w.children.length && ([S] = w.children.splice(0, 1));
                            Object.assign(w.attributes.style, b);
                        } else Object.assign(d, b);
                        p.push(w);
                        if (this.value) {
                            if (this.ui.imageEdit) w.children.push(this.value[r.$toHTML]().html);
                            else if (!this.ui.button) {
                                let e1 = "";
                                if (this.value.exData) e1 = this.value.exData[r.$text]();
                                else if (this.value.text) e1 = this.value.text[r.$getExtra]();
                                else {
                                    const t = this.value[r.$toHTML]().html;
                                    null !== t && (e1 = t.children[0].value);
                                }
                                this.ui.textEdit && this.value.text?.maxChars && (w.children[0].attributes.maxLength = this.value.text.maxChars);
                                if (e1) {
                                    if (this.ui.numericEdit) {
                                        e1 = parseFloat(e1);
                                        e1 = isNaN(e1) ? "" : e1.toString();
                                    }
                                    "textarea" === w.children[0].name ? w.children[0].attributes.textContent = e1 : w.children[0].attributes.value = e1;
                                }
                            }
                        }
                        if (!this.ui.imageEdit && w.children?.[0] && this.h) {
                            u = u || getBorderDims(this.ui[r.$getExtra]());
                            let t = 0;
                            if (this.caption && [
                                "top",
                                "bottom"
                            ].includes(this.caption.placement)) {
                                t = this.caption.reserve;
                                t <= 0 && (t = this.caption[r.$getExtra](e1).h);
                                const a = this.h - t - l - u.h;
                                w.children[0].attributes.style.height = (0, s.measureToString)(a);
                            } else w.children[0].attributes.style.height = "100%";
                        }
                        S && w.children.push(S);
                        if (!t) {
                            w.attributes.class && w.attributes.class.push("xfaLeft");
                            this.w = a;
                            this.h = n;
                            return c.HTMLResult.success((0, s.createWrapper)(this, m), y);
                        }
                        if (this.ui.button) {
                            d.padding && delete d.padding;
                            "div" === t.name && (t.name = "span");
                            w.children.push(t);
                            return c.HTMLResult.success(m, y);
                        }
                        this.ui.checkButton && (t.attributes.class[0] = "xfaCaptionForCheckButton");
                        w.attributes.class || (w.attributes.class = []);
                        w.children.splice(0, 0, t);
                        switch(this.caption.placement){
                            case "left":
                            case "inline":
                                w.attributes.class.push("xfaLeft");
                                break;
                            case "right":
                                w.attributes.class.push("xfaRight");
                                break;
                            case "top":
                                w.attributes.class.push("xfaTop");
                                break;
                            case "bottom":
                                w.attributes.class.push("xfaBottom");
                        }
                        this.w = a;
                        this.h = n;
                        return c.HTMLResult.success((0, s.createWrapper)(this, m), y);
                    }
                }
                t.Field = Field;
                class Fill extends o.XFAObject {
                    constructor(e1){
                        super(f, "fill", !0);
                        this.id = e1.id || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                        this.linear = null;
                        this.pattern = null;
                        this.radial = null;
                        this.solid = null;
                        this.stipple = null;
                    }
                    [r.$toStyle]() {
                        const e1 = this[r.$getParent](), t = e1[r.$getParent]()[r.$getParent](), a = Object.create(null);
                        let n = "color", i = n;
                        if (e1 instanceof Border) {
                            n = "background-color";
                            i = "background";
                            t instanceof Ui && (a.backgroundColor = "white");
                        }
                        if (e1 instanceof Rectangle || e1 instanceof Arc) {
                            n = i = "fill";
                            a.fill = "white";
                        }
                        for (const e1 of Object.getOwnPropertyNames(this)){
                            if ("extras" === e1 || "color" === e1) continue;
                            const t = this[e1];
                            if (!(t instanceof o.XFAObject)) continue;
                            const s = t[r.$toStyle](this.color);
                            s && (a[s.startsWith("#") ? n : i] = s);
                            return a;
                        }
                        if (this.color?.value) {
                            const e1 = this.color[r.$toStyle]();
                            a[e1.startsWith("#") ? n : i] = e1;
                        }
                        return a;
                    }
                }
                class Filter extends o.XFAObject {
                    constructor(e1){
                        super(f, "filter", !0);
                        this.addRevocationInfo = (0, c.getStringOption)(e1.addRevocationInfo, [
                            "",
                            "required",
                            "optional",
                            "none"
                        ]);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.version = (0, c.getInteger)({
                            data: this.version,
                            defaultValue: 5,
                            validate: (e1)=>e1 >= 1 && e1 <= 5
                        });
                        this.appearanceFilter = null;
                        this.certificates = null;
                        this.digestMethods = null;
                        this.encodings = null;
                        this.encryptionMethods = null;
                        this.handler = null;
                        this.lockDocument = null;
                        this.mdp = null;
                        this.reasons = null;
                        this.timeStamp = null;
                    }
                }
                class Float extends o.ContentObject {
                    constructor(e1){
                        super(f, "float");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = parseFloat(this[r.$content].trim());
                        this[r.$content] = isNaN(e1) ? null : e1;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(null !== this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class Font extends o.XFAObject {
                    constructor(e1){
                        super(f, "font", !0);
                        this.baselineShift = (0, c.getMeasurement)(e1.baselineShift);
                        this.fontHorizontalScale = (0, c.getFloat)({
                            data: e1.fontHorizontalScale,
                            defaultValue: 100,
                            validate: (e1)=>e1 >= 0
                        });
                        this.fontVerticalScale = (0, c.getFloat)({
                            data: e1.fontVerticalScale,
                            defaultValue: 100,
                            validate: (e1)=>e1 >= 0
                        });
                        this.id = e1.id || "";
                        this.kerningMode = (0, c.getStringOption)(e1.kerningMode, [
                            "none",
                            "pair"
                        ]);
                        this.letterSpacing = (0, c.getMeasurement)(e1.letterSpacing, "0");
                        this.lineThrough = (0, c.getInteger)({
                            data: e1.lineThrough,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1 || 2 === e1
                        });
                        this.lineThroughPeriod = (0, c.getStringOption)(e1.lineThroughPeriod, [
                            "all",
                            "word"
                        ]);
                        this.overline = (0, c.getInteger)({
                            data: e1.overline,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1 || 2 === e1
                        });
                        this.overlinePeriod = (0, c.getStringOption)(e1.overlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.posture = (0, c.getStringOption)(e1.posture, [
                            "normal",
                            "italic"
                        ]);
                        this.size = (0, c.getMeasurement)(e1.size, "10pt");
                        this.typeface = e1.typeface || "Courier";
                        this.underline = (0, c.getInteger)({
                            data: e1.underline,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1 || 2 === e1
                        });
                        this.underlinePeriod = (0, c.getStringOption)(e1.underlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.weight = (0, c.getStringOption)(e1.weight, [
                            "normal",
                            "bold"
                        ]);
                        this.extras = null;
                        this.fill = null;
                    }
                    [r.$clean](e1) {
                        super[r.$clean](e1);
                        this[r.$globalData].usedTypefaces.add(this.typeface);
                    }
                    [r.$toStyle]() {
                        const e1 = (0, s.toStyle)(this, "fill"), t = e1.color;
                        if (t) {
                            if ("#000000" === t) delete e1.color;
                            else if (!t.startsWith("#")) {
                                e1.background = t;
                                e1.backgroundClip = "text";
                                e1.color = "transparent";
                            }
                        }
                        this.baselineShift && (e1.verticalAlign = (0, s.measureToString)(this.baselineShift));
                        e1.fontKerning = "none" === this.kerningMode ? "none" : "normal";
                        e1.letterSpacing = (0, s.measureToString)(this.letterSpacing);
                        if (0 !== this.lineThrough) {
                            e1.textDecoration = "line-through";
                            2 === this.lineThrough && (e1.textDecorationStyle = "double");
                        }
                        if (0 !== this.overline) {
                            e1.textDecoration = "overline";
                            2 === this.overline && (e1.textDecorationStyle = "double");
                        }
                        e1.fontStyle = this.posture;
                        e1.fontSize = (0, s.measureToString)(.99 * this.size);
                        (0, s.setFontFamily)(this, this, this[r.$globalData].fontFinder, e1);
                        if (0 !== this.underline) {
                            e1.textDecoration = "underline";
                            2 === this.underline && (e1.textDecorationStyle = "double");
                        }
                        e1.fontWeight = this.weight;
                        return e1;
                    }
                }
                class Format extends o.XFAObject {
                    constructor(e1){
                        super(f, "format", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.picture = null;
                    }
                }
                class Handler extends o.StringObject {
                    constructor(e1){
                        super(f, "handler");
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Hyphenation extends o.XFAObject {
                    constructor(e1){
                        super(f, "hyphenation");
                        this.excludeAllCaps = (0, c.getInteger)({
                            data: e1.excludeAllCaps,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.excludeInitialCap = (0, c.getInteger)({
                            data: e1.excludeInitialCap,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.hyphenate = (0, c.getInteger)({
                            data: e1.hyphenate,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.id = e1.id || "";
                        this.pushCharacterCount = (0, c.getInteger)({
                            data: e1.pushCharacterCount,
                            defaultValue: 3,
                            validate: (e1)=>e1 >= 0
                        });
                        this.remainCharacterCount = (0, c.getInteger)({
                            data: e1.remainCharacterCount,
                            defaultValue: 3,
                            validate: (e1)=>e1 >= 0
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.wordCharacterCount = (0, c.getInteger)({
                            data: e1.wordCharacterCount,
                            defaultValue: 7,
                            validate: (e1)=>e1 >= 0
                        });
                    }
                }
                class Image extends o.StringObject {
                    constructor(e1){
                        super(f, "image");
                        this.aspect = (0, c.getStringOption)(e1.aspect, [
                            "fit",
                            "actual",
                            "height",
                            "none",
                            "width"
                        ]);
                        this.contentType = e1.contentType || "";
                        this.href = e1.href || "";
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.transferEncoding = (0, c.getStringOption)(e1.transferEncoding, [
                            "base64",
                            "none",
                            "package"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$toHTML]() {
                        if (this.contentType && !m.has(this.contentType.toLowerCase())) return c.HTMLResult.EMPTY;
                        let e1 = this[r.$globalData].images && this[r.$globalData].images.get(this.href);
                        if (!e1 && (this.href || !this[r.$content])) return c.HTMLResult.EMPTY;
                        e1 || "base64" !== this.transferEncoding || (e1 = (0, l.stringToBytes)(atob(this[r.$content])));
                        if (!e1) return c.HTMLResult.EMPTY;
                        if (!this.contentType) {
                            for (const [t, a] of b)if (e1.length > t.length && t.every((t, a)=>t === e1[a])) {
                                this.contentType = a;
                                break;
                            }
                            if (!this.contentType) return c.HTMLResult.EMPTY;
                        }
                        const t = new Blob([
                            e1
                        ], {
                            type: this.contentType
                        });
                        let a;
                        switch(this.aspect){
                            case "fit":
                            case "actual":
                                break;
                            case "height":
                                a = {
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "none":
                                a = {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "width":
                                a = {
                                    width: "100%",
                                    objectFit: "fill"
                                };
                        }
                        const n = this[r.$getParent]();
                        return c.HTMLResult.success({
                            name: "img",
                            attributes: {
                                class: [
                                    "xfaImage"
                                ],
                                style: a,
                                src: URL.createObjectURL(t),
                                alt: n ? ariaLabel(n[r.$getParent]()) : null
                            }
                        });
                    }
                }
                class ImageEdit extends o.XFAObject {
                    constructor(e1){
                        super(f, "imageEdit", !0);
                        this.data = (0, c.getStringOption)(e1.data, [
                            "link",
                            "embed"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        return "embed" === this.data ? c.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {}
                        }) : c.HTMLResult.EMPTY;
                    }
                }
                class Integer extends o.ContentObject {
                    constructor(e1){
                        super(f, "integer");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = parseInt(this[r.$content].trim(), 10);
                        this[r.$content] = isNaN(e1) ? null : e1;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(null !== this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class Issuers extends o.XFAObject {
                    constructor(e1){
                        super(f, "issuers", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.certificate = new o.XFAObjectArray;
                    }
                }
                class Items extends o.XFAObject {
                    constructor(e1){
                        super(f, "items", !0);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.ref = e1.ref || "";
                        this.save = (0, c.getInteger)({
                            data: e1.save,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.boolean = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                    }
                    [r.$toHTML]() {
                        const e1 = [];
                        for (const t of this[r.$getChildren]())e1.push(t[r.$text]());
                        return c.HTMLResult.success(e1);
                    }
                }
                t.Items = Items;
                class Keep extends o.XFAObject {
                    constructor(e1){
                        super(f, "keep", !0);
                        this.id = e1.id || "";
                        const t = [
                            "none",
                            "contentArea",
                            "pageArea"
                        ];
                        this.intact = (0, c.getStringOption)(e1.intact, t);
                        this.next = (0, c.getStringOption)(e1.next, t);
                        this.previous = (0, c.getStringOption)(e1.previous, t);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                }
                class KeyUsage extends o.XFAObject {
                    constructor(e1){
                        super(f, "keyUsage");
                        const t = [
                            "",
                            "yes",
                            "no"
                        ];
                        this.crlSign = (0, c.getStringOption)(e1.crlSign, t);
                        this.dataEncipherment = (0, c.getStringOption)(e1.dataEncipherment, t);
                        this.decipherOnly = (0, c.getStringOption)(e1.decipherOnly, t);
                        this.digitalSignature = (0, c.getStringOption)(e1.digitalSignature, t);
                        this.encipherOnly = (0, c.getStringOption)(e1.encipherOnly, t);
                        this.id = e1.id || "";
                        this.keyAgreement = (0, c.getStringOption)(e1.keyAgreement, t);
                        this.keyCertSign = (0, c.getStringOption)(e1.keyCertSign, t);
                        this.keyEncipherment = (0, c.getStringOption)(e1.keyEncipherment, t);
                        this.nonRepudiation = (0, c.getStringOption)(e1.nonRepudiation, t);
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Line extends o.XFAObject {
                    constructor(e1){
                        super(f, "line", !0);
                        this.hand = (0, c.getStringOption)(e1.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.slope = (0, c.getStringOption)(e1.slope, [
                            "\\",
                            "/"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.edge = null;
                    }
                    [r.$toHTML]() {
                        const e1 = this[r.$getParent]()[r.$getParent](), t = this.edge || new Edge({}), a = t[r.$toStyle](), n = Object.create(null), i = "visible" === t.presence ? t.thickness : 0;
                        n.strokeWidth = (0, s.measureToString)(i);
                        n.stroke = a.color;
                        let o, l, h, u, d = "100%", f = "100%";
                        if (e1.w <= i) {
                            [o, l, h, u] = [
                                "50%",
                                0,
                                "50%",
                                "100%"
                            ];
                            d = n.strokeWidth;
                        } else if (e1.h <= i) {
                            [o, l, h, u] = [
                                0,
                                "50%",
                                "100%",
                                "50%"
                            ];
                            f = n.strokeWidth;
                        } else "\\" === this.slope ? [o, l, h, u] = [
                            0,
                            0,
                            "100%",
                            "100%"
                        ] : [o, l, h, u] = [
                            0,
                            "100%",
                            "100%",
                            0
                        ];
                        const p = {
                            name: "svg",
                            children: [
                                {
                                    name: "line",
                                    attributes: {
                                        xmlns: g,
                                        x1: o,
                                        y1: l,
                                        x2: h,
                                        y2: u,
                                        style: n
                                    }
                                }
                            ],
                            attributes: {
                                xmlns: g,
                                width: d,
                                height: f,
                                style: {
                                    overflow: "visible"
                                }
                            }
                        };
                        if (hasMargin(e1)) return c.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                p
                            ]
                        });
                        p.attributes.style.position = "absolute";
                        return c.HTMLResult.success(p);
                    }
                }
                class Linear extends o.XFAObject {
                    constructor(e1){
                        super(f, "linear", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "toRight",
                            "toBottom",
                            "toLeft",
                            "toTop"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle](e1) {
                        e1 = e1 ? e1[r.$toStyle]() : "#FFFFFF";
                        return `linear-gradient(${this.type.replace(/([RBLT])/, " $1").toLowerCase()}, ${e1}, ${this.color ? this.color[r.$toStyle]() : "#000000"})`;
                    }
                }
                class LockDocument extends o.ContentObject {
                    constructor(e1){
                        super(f, "lockDocument");
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        this[r.$content] = (0, c.getStringOption)(this[r.$content], [
                            "auto",
                            "0",
                            "1"
                        ]);
                    }
                }
                class Manifest extends o.XFAObject {
                    constructor(e1){
                        super(f, "manifest", !0);
                        this.action = (0, c.getStringOption)(e1.action, [
                            "include",
                            "all",
                            "exclude"
                        ]);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.ref = new o.XFAObjectArray;
                    }
                }
                class Margin extends o.XFAObject {
                    constructor(e1){
                        super(f, "margin", !0);
                        this.bottomInset = (0, c.getMeasurement)(e1.bottomInset, "0");
                        this.id = e1.id || "";
                        this.leftInset = (0, c.getMeasurement)(e1.leftInset, "0");
                        this.rightInset = (0, c.getMeasurement)(e1.rightInset, "0");
                        this.topInset = (0, c.getMeasurement)(e1.topInset, "0");
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                    [r.$toStyle]() {
                        return {
                            margin: (0, s.measureToString)(this.topInset) + " " + (0, s.measureToString)(this.rightInset) + " " + (0, s.measureToString)(this.bottomInset) + " " + (0, s.measureToString)(this.leftInset)
                        };
                    }
                }
                class Mdp extends o.XFAObject {
                    constructor(e1){
                        super(f, "mdp");
                        this.id = e1.id || "";
                        this.permissions = (0, c.getInteger)({
                            data: e1.permissions,
                            defaultValue: 2,
                            validate: (e1)=>1 === e1 || 3 === e1
                        });
                        this.signatureType = (0, c.getStringOption)(e1.signatureType, [
                            "filler",
                            "author"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Medium extends o.XFAObject {
                    constructor(e1){
                        super(f, "medium");
                        this.id = e1.id || "";
                        this.imagingBBox = (0, c.getBBox)(e1.imagingBBox);
                        this.long = (0, c.getMeasurement)(e1.long);
                        this.orientation = (0, c.getStringOption)(e1.orientation, [
                            "portrait",
                            "landscape"
                        ]);
                        this.short = (0, c.getMeasurement)(e1.short);
                        this.stock = e1.stock || "";
                        this.trayIn = (0, c.getStringOption)(e1.trayIn, [
                            "auto",
                            "delegate",
                            "pageFront"
                        ]);
                        this.trayOut = (0, c.getStringOption)(e1.trayOut, [
                            "auto",
                            "delegate"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Message extends o.XFAObject {
                    constructor(e1){
                        super(f, "message", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.text = new o.XFAObjectArray;
                    }
                }
                class NumericEdit extends o.XFAObject {
                    constructor(e1){
                        super(f, "numericEdit", !0);
                        this.hScrollPolicy = (0, c.getStringOption)(e1.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)(this, "border", "font", "margin"), a = this[r.$getParent]()[r.$getParent](), n = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: a[r.$uid],
                                dataId: a[r.$data]?.[r.$uid] || a[r.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: t,
                                "aria-label": ariaLabel(a),
                                "aria-required": !1
                            }
                        };
                        if (isRequired(a)) {
                            n.attributes["aria-required"] = !0;
                            n.attributes.required = !0;
                        }
                        return c.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                n
                            ]
                        });
                    }
                }
                class Occur extends o.XFAObject {
                    constructor(e1){
                        super(f, "occur", !0);
                        this.id = e1.id || "";
                        this.initial = "" !== e1.initial ? (0, c.getInteger)({
                            data: e1.initial,
                            defaultValue: "",
                            validate: (e1)=>!0
                        }) : "";
                        this.max = "" !== e1.max ? (0, c.getInteger)({
                            data: e1.max,
                            defaultValue: 1,
                            validate: (e1)=>!0
                        }) : "";
                        this.min = "" !== e1.min ? (0, c.getInteger)({
                            data: e1.min,
                            defaultValue: 1,
                            validate: (e1)=>!0
                        }) : "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                    [r.$clean]() {
                        const e1 = this[r.$getParent](), t = this.min;
                        "" === this.min && (this.min = e1 instanceof PageArea || e1 instanceof PageSet ? 0 : 1);
                        "" === this.max && (this.max = "" === t ? e1 instanceof PageArea || e1 instanceof PageSet ? -1 : 1 : this.min);
                        -1 !== this.max && this.max < this.min && (this.max = this.min);
                        "" === this.initial && (this.initial = e1 instanceof Template ? 1 : this.min);
                    }
                }
                class Oid extends o.StringObject {
                    constructor(e1){
                        super(f, "oid");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Oids extends o.XFAObject {
                    constructor(e1){
                        super(f, "oids", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.oid = new o.XFAObjectArray;
                    }
                }
                class Overflow extends o.XFAObject {
                    constructor(e1){
                        super(f, "overflow");
                        this.id = e1.id || "";
                        this.leader = e1.leader || "";
                        this.target = e1.target || "";
                        this.trailer = e1.trailer || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$getExtra]() {
                        if (!this[r.$extra]) {
                            const e1 = this[r.$getParent](), t = this[r.$getTemplateRoot](), a = t[r.$searchNode](this.target, e1), n = t[r.$searchNode](this.leader, e1), i = t[r.$searchNode](this.trailer, e1);
                            this[r.$extra] = {
                                target: a?.[0] || null,
                                leader: n?.[0] || null,
                                trailer: i?.[0] || null,
                                addLeader: !1,
                                addTrailer: !1
                            };
                        }
                        return this[r.$extra];
                    }
                }
                class PageArea extends o.XFAObject {
                    constructor(e1){
                        super(f, "pageArea", !0);
                        this.blankOrNotBlank = (0, c.getStringOption)(e1.blankOrNotBlank, [
                            "any",
                            "blank",
                            "notBlank"
                        ]);
                        this.id = e1.id || "";
                        this.initialNumber = (0, c.getInteger)({
                            data: e1.initialNumber,
                            defaultValue: 1,
                            validate: (e1)=>!0
                        });
                        this.name = e1.name || "";
                        this.numbered = (0, c.getInteger)({
                            data: e1.numbered,
                            defaultValue: 1,
                            validate: (e1)=>!0
                        });
                        this.oddOrEven = (0, c.getStringOption)(e1.oddOrEven, [
                            "any",
                            "even",
                            "odd"
                        ]);
                        this.pagePosition = (0, c.getStringOption)(e1.pagePosition, [
                            "any",
                            "first",
                            "last",
                            "only",
                            "rest"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.desc = null;
                        this.extras = null;
                        this.medium = null;
                        this.occur = null;
                        this.area = new o.XFAObjectArray;
                        this.contentArea = new o.XFAObjectArray;
                        this.draw = new o.XFAObjectArray;
                        this.exclGroup = new o.XFAObjectArray;
                        this.field = new o.XFAObjectArray;
                        this.subform = new o.XFAObjectArray;
                    }
                    [r.$isUsable]() {
                        if (!this[r.$extra]) {
                            this[r.$extra] = {
                                numberOfUse: 0
                            };
                            return !0;
                        }
                        return !this.occur || -1 === this.occur.max || this[r.$extra].numberOfUse < this.occur.max;
                    }
                    [r.$cleanPage]() {
                        delete this[r.$extra];
                    }
                    [r.$getNextPage]() {
                        this[r.$extra] || (this[r.$extra] = {
                            numberOfUse: 0
                        });
                        const e1 = this[r.$getParent]();
                        if ("orderedOccurrence" === e1.relation && this[r.$isUsable]()) {
                            this[r.$extra].numberOfUse += 1;
                            return this;
                        }
                        return e1[r.$getNextPage]();
                    }
                    [r.$getAvailableSpace]() {
                        return this[r.$extra].space || {
                            width: 0,
                            height: 0
                        };
                    }
                    [r.$toHTML]() {
                        this[r.$extra] || (this[r.$extra] = {
                            numberOfUse: 1
                        });
                        const e1 = [];
                        this[r.$extra].children = e1;
                        const t = Object.create(null);
                        if (this.medium && this.medium.short && this.medium.long) {
                            t.width = (0, s.measureToString)(this.medium.short);
                            t.height = (0, s.measureToString)(this.medium.long);
                            this[r.$extra].space = {
                                width: this.medium.short,
                                height: this.medium.long
                            };
                            if ("landscape" === this.medium.orientation) {
                                const e1 = t.width;
                                t.width = t.height;
                                t.height = e1;
                                this[r.$extra].space = {
                                    width: this.medium.long,
                                    height: this.medium.short
                                };
                            }
                        } else (0, l.warn)("XFA - No medium specified in pageArea: please file a bug.");
                        this[r.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "subform"
                            ]),
                            include: !0
                        });
                        this[r.$childrenToHTML]({
                            filter: new Set([
                                "contentArea"
                            ]),
                            include: !0
                        });
                        return c.HTMLResult.success({
                            name: "div",
                            children: e1,
                            attributes: {
                                class: [
                                    "xfaPage"
                                ],
                                id: this[r.$uid],
                                style: t,
                                xfaName: this.name
                            }
                        });
                    }
                }
                class PageSet extends o.XFAObject {
                    constructor(e1){
                        super(f, "pageSet", !0);
                        this.duplexImposition = (0, c.getStringOption)(e1.duplexImposition, [
                            "longEdge",
                            "shortEdge"
                        ]);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.relation = (0, c.getStringOption)(e1.relation, [
                            "orderedOccurrence",
                            "duplexPaginated",
                            "simplexPaginated"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.occur = null;
                        this.pageArea = new o.XFAObjectArray;
                        this.pageSet = new o.XFAObjectArray;
                    }
                    [r.$cleanPage]() {
                        for (const e1 of this.pageArea.children)e1[r.$cleanPage]();
                        for (const e1 of this.pageSet.children)e1[r.$cleanPage]();
                    }
                    [r.$isUsable]() {
                        return !this.occur || -1 === this.occur.max || this[r.$extra].numberOfUse < this.occur.max;
                    }
                    [r.$getNextPage]() {
                        this[r.$extra] || (this[r.$extra] = {
                            numberOfUse: 1,
                            pageIndex: -1,
                            pageSetIndex: -1
                        });
                        if ("orderedOccurrence" === this.relation) {
                            if (this[r.$extra].pageIndex + 1 < this.pageArea.children.length) {
                                this[r.$extra].pageIndex += 1;
                                return this.pageArea.children[this[r.$extra].pageIndex][r.$getNextPage]();
                            }
                            if (this[r.$extra].pageSetIndex + 1 < this.pageSet.children.length) {
                                this[r.$extra].pageSetIndex += 1;
                                return this.pageSet.children[this[r.$extra].pageSetIndex][r.$getNextPage]();
                            }
                            if (this[r.$isUsable]()) {
                                this[r.$extra].numberOfUse += 1;
                                this[r.$extra].pageIndex = -1;
                                this[r.$extra].pageSetIndex = -1;
                                return this[r.$getNextPage]();
                            }
                            const e1 = this[r.$getParent]();
                            if (e1 instanceof PageSet) return e1[r.$getNextPage]();
                            this[r.$cleanPage]();
                            return this[r.$getNextPage]();
                        }
                        const e1 = this[r.$getTemplateRoot]()[r.$extra].pageNumber, t = e1 % 2 == 0 ? "even" : "odd", a = 0 === e1 ? "first" : "rest";
                        let n = this.pageArea.children.find((e1)=>e1.oddOrEven === t && e1.pagePosition === a);
                        if (n) return n;
                        n = this.pageArea.children.find((e1)=>"any" === e1.oddOrEven && e1.pagePosition === a);
                        if (n) return n;
                        n = this.pageArea.children.find((e1)=>"any" === e1.oddOrEven && "any" === e1.pagePosition);
                        return n || this.pageArea.children[0];
                    }
                }
                class Para extends o.XFAObject {
                    constructor(e1){
                        super(f, "para", !0);
                        this.hAlign = (0, c.getStringOption)(e1.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.lineHeight = e1.lineHeight ? (0, c.getMeasurement)(e1.lineHeight, "0pt") : "";
                        this.marginLeft = e1.marginLeft ? (0, c.getMeasurement)(e1.marginLeft, "0pt") : "";
                        this.marginRight = e1.marginRight ? (0, c.getMeasurement)(e1.marginRight, "0pt") : "";
                        this.orphans = (0, c.getInteger)({
                            data: e1.orphans,
                            defaultValue: 0,
                            validate: (e1)=>e1 >= 0
                        });
                        this.preserve = e1.preserve || "";
                        this.radixOffset = e1.radixOffset ? (0, c.getMeasurement)(e1.radixOffset, "0pt") : "";
                        this.spaceAbove = e1.spaceAbove ? (0, c.getMeasurement)(e1.spaceAbove, "0pt") : "";
                        this.spaceBelow = e1.spaceBelow ? (0, c.getMeasurement)(e1.spaceBelow, "0pt") : "";
                        this.tabDefault = e1.tabDefault ? (0, c.getMeasurement)(this.tabDefault) : "";
                        this.tabStops = (e1.tabStops || "").trim().split(/\s+/).map((e1, t)=>t % 2 == 1 ? (0, c.getMeasurement)(e1) : e1);
                        this.textIndent = e1.textIndent ? (0, c.getMeasurement)(e1.textIndent, "0pt") : "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.vAlign = (0, c.getStringOption)(e1.vAlign, [
                            "top",
                            "bottom",
                            "middle"
                        ]);
                        this.widows = (0, c.getInteger)({
                            data: e1.widows,
                            defaultValue: 0,
                            validate: (e1)=>e1 >= 0
                        });
                        this.hyphenation = null;
                    }
                    [r.$toStyle]() {
                        const e1 = (0, s.toStyle)(this, "hAlign");
                        "" !== this.marginLeft && (e1.paddingLeft = (0, s.measureToString)(this.marginLeft));
                        "" !== this.marginRight && (e1.paddingight = (0, s.measureToString)(this.marginRight));
                        "" !== this.spaceAbove && (e1.paddingTop = (0, s.measureToString)(this.spaceAbove));
                        "" !== this.spaceBelow && (e1.paddingBottom = (0, s.measureToString)(this.spaceBelow));
                        if ("" !== this.textIndent) {
                            e1.textIndent = (0, s.measureToString)(this.textIndent);
                            (0, s.fixTextIndent)(e1);
                        }
                        this.lineHeight > 0 && (e1.lineHeight = (0, s.measureToString)(this.lineHeight));
                        "" !== this.tabDefault && (e1.tabSize = (0, s.measureToString)(this.tabDefault));
                        this.tabStops.length;
                        this.hyphenatation && Object.assign(e1, this.hyphenatation[r.$toStyle]());
                        return e1;
                    }
                }
                class PasswordEdit extends o.XFAObject {
                    constructor(e1){
                        super(f, "passwordEdit", !0);
                        this.hScrollPolicy = (0, c.getStringOption)(e1.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = e1.id || "";
                        this.passwordChar = e1.passwordChar || "*";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                }
                class Pattern extends o.XFAObject {
                    constructor(e1){
                        super(f, "pattern", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "crossHatch",
                            "crossDiagonal",
                            "diagonalLeft",
                            "diagonalRight",
                            "horizontal",
                            "vertical"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle](e1) {
                        e1 = e1 ? e1[r.$toStyle]() : "#FFFFFF";
                        const t = this.color ? this.color[r.$toStyle]() : "#000000", a = "repeating-linear-gradient", n = `${e1},${e1} 5px,${t} 5px,${t} 10px`;
                        switch(this.type){
                            case "crossHatch":
                                return `${a}(to top,${n}) ${a}(to right,${n})`;
                            case "crossDiagonal":
                                return `${a}(45deg,${n}) ${a}(-45deg,${n})`;
                            case "diagonalLeft":
                                return `${a}(45deg,${n})`;
                            case "diagonalRight":
                                return `${a}(-45deg,${n})`;
                            case "horizontal":
                                return `${a}(to top,${n})`;
                            case "vertical":
                                return `${a}(to right,${n})`;
                        }
                        return "";
                    }
                }
                class Picture extends o.StringObject {
                    constructor(e1){
                        super(f, "picture");
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Proto extends o.XFAObject {
                    constructor(e1){
                        super(f, "proto", !0);
                        this.appearanceFilter = new o.XFAObjectArray;
                        this.arc = new o.XFAObjectArray;
                        this.area = new o.XFAObjectArray;
                        this.assist = new o.XFAObjectArray;
                        this.barcode = new o.XFAObjectArray;
                        this.bindItems = new o.XFAObjectArray;
                        this.bookend = new o.XFAObjectArray;
                        this.boolean = new o.XFAObjectArray;
                        this.border = new o.XFAObjectArray;
                        this.break = new o.XFAObjectArray;
                        this.breakAfter = new o.XFAObjectArray;
                        this.breakBefore = new o.XFAObjectArray;
                        this.button = new o.XFAObjectArray;
                        this.calculate = new o.XFAObjectArray;
                        this.caption = new o.XFAObjectArray;
                        this.certificate = new o.XFAObjectArray;
                        this.certificates = new o.XFAObjectArray;
                        this.checkButton = new o.XFAObjectArray;
                        this.choiceList = new o.XFAObjectArray;
                        this.color = new o.XFAObjectArray;
                        this.comb = new o.XFAObjectArray;
                        this.connect = new o.XFAObjectArray;
                        this.contentArea = new o.XFAObjectArray;
                        this.corner = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.dateTimeEdit = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.defaultUi = new o.XFAObjectArray;
                        this.desc = new o.XFAObjectArray;
                        this.digestMethod = new o.XFAObjectArray;
                        this.digestMethods = new o.XFAObjectArray;
                        this.draw = new o.XFAObjectArray;
                        this.edge = new o.XFAObjectArray;
                        this.encoding = new o.XFAObjectArray;
                        this.encodings = new o.XFAObjectArray;
                        this.encrypt = new o.XFAObjectArray;
                        this.encryptData = new o.XFAObjectArray;
                        this.encryption = new o.XFAObjectArray;
                        this.encryptionMethod = new o.XFAObjectArray;
                        this.encryptionMethods = new o.XFAObjectArray;
                        this.event = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.exObject = new o.XFAObjectArray;
                        this.exclGroup = new o.XFAObjectArray;
                        this.execute = new o.XFAObjectArray;
                        this.extras = new o.XFAObjectArray;
                        this.field = new o.XFAObjectArray;
                        this.fill = new o.XFAObjectArray;
                        this.filter = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.font = new o.XFAObjectArray;
                        this.format = new o.XFAObjectArray;
                        this.handler = new o.XFAObjectArray;
                        this.hyphenation = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.imageEdit = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.issuers = new o.XFAObjectArray;
                        this.items = new o.XFAObjectArray;
                        this.keep = new o.XFAObjectArray;
                        this.keyUsage = new o.XFAObjectArray;
                        this.line = new o.XFAObjectArray;
                        this.linear = new o.XFAObjectArray;
                        this.lockDocument = new o.XFAObjectArray;
                        this.manifest = new o.XFAObjectArray;
                        this.margin = new o.XFAObjectArray;
                        this.mdp = new o.XFAObjectArray;
                        this.medium = new o.XFAObjectArray;
                        this.message = new o.XFAObjectArray;
                        this.numericEdit = new o.XFAObjectArray;
                        this.occur = new o.XFAObjectArray;
                        this.oid = new o.XFAObjectArray;
                        this.oids = new o.XFAObjectArray;
                        this.overflow = new o.XFAObjectArray;
                        this.pageArea = new o.XFAObjectArray;
                        this.pageSet = new o.XFAObjectArray;
                        this.para = new o.XFAObjectArray;
                        this.passwordEdit = new o.XFAObjectArray;
                        this.pattern = new o.XFAObjectArray;
                        this.picture = new o.XFAObjectArray;
                        this.radial = new o.XFAObjectArray;
                        this.reason = new o.XFAObjectArray;
                        this.reasons = new o.XFAObjectArray;
                        this.rectangle = new o.XFAObjectArray;
                        this.ref = new o.XFAObjectArray;
                        this.script = new o.XFAObjectArray;
                        this.setProperty = new o.XFAObjectArray;
                        this.signData = new o.XFAObjectArray;
                        this.signature = new o.XFAObjectArray;
                        this.signing = new o.XFAObjectArray;
                        this.solid = new o.XFAObjectArray;
                        this.speak = new o.XFAObjectArray;
                        this.stipple = new o.XFAObjectArray;
                        this.subform = new o.XFAObjectArray;
                        this.subformSet = new o.XFAObjectArray;
                        this.subjectDN = new o.XFAObjectArray;
                        this.subjectDNs = new o.XFAObjectArray;
                        this.submit = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.textEdit = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                        this.timeStamp = new o.XFAObjectArray;
                        this.toolTip = new o.XFAObjectArray;
                        this.traversal = new o.XFAObjectArray;
                        this.traverse = new o.XFAObjectArray;
                        this.ui = new o.XFAObjectArray;
                        this.validate = new o.XFAObjectArray;
                        this.value = new o.XFAObjectArray;
                        this.variables = new o.XFAObjectArray;
                    }
                }
                class Radial extends o.XFAObject {
                    constructor(e1){
                        super(f, "radial", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "toEdge",
                            "toCenter"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle](e1) {
                        e1 = e1 ? e1[r.$toStyle]() : "#FFFFFF";
                        const t = this.color ? this.color[r.$toStyle]() : "#000000";
                        return `radial-gradient(circle at center, ${"toEdge" === this.type ? `${e1},${t}` : `${t},${e1}`})`;
                    }
                }
                class Reason extends o.StringObject {
                    constructor(e1){
                        super(f, "reason");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Reasons extends o.XFAObject {
                    constructor(e1){
                        super(f, "reasons", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.reason = new o.XFAObjectArray;
                    }
                }
                class Rectangle extends o.XFAObject {
                    constructor(e1){
                        super(f, "rectangle", !0);
                        this.hand = (0, c.getStringOption)(e1.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.corner = new o.XFAObjectArray(4);
                        this.edge = new o.XFAObjectArray(4);
                        this.fill = null;
                    }
                    [r.$toHTML]() {
                        const e1 = this.edge.children.length ? this.edge.children[0] : new Edge({}), t = e1[r.$toStyle](), a = Object.create(null);
                        "visible" === this.fill?.presence ? Object.assign(a, this.fill[r.$toStyle]()) : a.fill = "transparent";
                        a.strokeWidth = (0, s.measureToString)("visible" === e1.presence ? e1.thickness : 0);
                        a.stroke = t.color;
                        const n = (this.corner.children.length ? this.corner.children[0] : new Corner({}))[r.$toStyle](), i = {
                            name: "svg",
                            children: [
                                {
                                    name: "rect",
                                    attributes: {
                                        xmlns: g,
                                        width: "100%",
                                        height: "100%",
                                        x: 0,
                                        y: 0,
                                        rx: n.radius,
                                        ry: n.radius,
                                        style: a
                                    }
                                }
                            ],
                            attributes: {
                                xmlns: g,
                                style: {
                                    overflow: "visible"
                                },
                                width: "100%",
                                height: "100%"
                            }
                        };
                        if (hasMargin(this[r.$getParent]()[r.$getParent]())) return c.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                i
                            ]
                        });
                        i.attributes.style.position = "absolute";
                        return c.HTMLResult.success(i);
                    }
                }
                class RefElement extends o.StringObject {
                    constructor(e1){
                        super(f, "ref");
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Script extends o.StringObject {
                    constructor(e1){
                        super(f, "script");
                        this.binding = e1.binding || "";
                        this.contentType = e1.contentType || "";
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.runAt = (0, c.getStringOption)(e1.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class SetProperty extends o.XFAObject {
                    constructor(e1){
                        super(f, "setProperty");
                        this.connection = e1.connection || "";
                        this.ref = e1.ref || "";
                        this.target = e1.target || "";
                    }
                }
                t.SetProperty = SetProperty;
                class SignData extends o.XFAObject {
                    constructor(e1){
                        super(f, "signData", !0);
                        this.id = e1.id || "";
                        this.operation = (0, c.getStringOption)(e1.operation, [
                            "sign",
                            "clear",
                            "verify"
                        ]);
                        this.ref = e1.ref || "";
                        this.target = e1.target || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Signature extends o.XFAObject {
                    constructor(e1){
                        super(f, "signature", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "PDF1.3",
                            "PDF1.6"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.filter = null;
                        this.manifest = null;
                        this.margin = null;
                    }
                }
                class Signing extends o.XFAObject {
                    constructor(e1){
                        super(f, "signing", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.certificate = new o.XFAObjectArray;
                    }
                }
                class Solid extends o.XFAObject {
                    constructor(e1){
                        super(f, "solid", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                    }
                    [r.$toStyle](e1) {
                        return e1 ? e1[r.$toStyle]() : "#FFFFFF";
                    }
                }
                class Speak extends o.StringObject {
                    constructor(e1){
                        super(f, "speak");
                        this.disable = (0, c.getInteger)({
                            data: e1.disable,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.id = e1.id || "";
                        this.priority = (0, c.getStringOption)(e1.priority, [
                            "custom",
                            "caption",
                            "name",
                            "toolTip"
                        ]);
                        this.rid = e1.rid || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Stipple extends o.XFAObject {
                    constructor(e1){
                        super(f, "stipple", !0);
                        this.id = e1.id || "";
                        this.rate = (0, c.getInteger)({
                            data: e1.rate,
                            defaultValue: 50,
                            validate: (e1)=>e1 >= 0 && e1 <= 100
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [r.$toStyle](e1) {
                        const t = this.rate / 100;
                        return l.Util.makeHexColor(Math.round(e1.value.r * (1 - t) + this.value.r * t), Math.round(e1.value.g * (1 - t) + this.value.g * t), Math.round(e1.value.b * (1 - t) + this.value.b * t));
                    }
                }
                class Subform extends o.XFAObject {
                    constructor(e1){
                        super(f, "subform", !0);
                        this.access = (0, c.getStringOption)(e1.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.allowMacro = (0, c.getInteger)({
                            data: e1.allowMacro,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.anchorType = (0, c.getStringOption)(e1.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, c.getInteger)({
                            data: e1.colSpan,
                            defaultValue: 1,
                            validate: (e1)=>e1 >= 1 || -1 === e1
                        });
                        this.columnWidths = (e1.columnWidths || "").trim().split(/\s+/).map((e1)=>"-1" === e1 ? -1 : (0, c.getMeasurement)(e1));
                        this.h = e1.h ? (0, c.getMeasurement)(e1.h) : "";
                        this.hAlign = (0, c.getStringOption)(e1.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = e1.id || "";
                        this.layout = (0, c.getStringOption)(e1.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.locale = e1.locale || "";
                        this.maxH = (0, c.getMeasurement)(e1.maxH, "0pt");
                        this.maxW = (0, c.getMeasurement)(e1.maxW, "0pt");
                        this.mergeMode = (0, c.getStringOption)(e1.mergeMode, [
                            "consumeData",
                            "matchTemplate"
                        ]);
                        this.minH = (0, c.getMeasurement)(e1.minH, "0pt");
                        this.minW = (0, c.getMeasurement)(e1.minW, "0pt");
                        this.name = e1.name || "";
                        this.presence = (0, c.getStringOption)(e1.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.restoreState = (0, c.getStringOption)(e1.restoreState, [
                            "manual",
                            "auto"
                        ]);
                        this.scope = (0, c.getStringOption)(e1.scope, [
                            "name",
                            "none"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.w = e1.w ? (0, c.getMeasurement)(e1.w) : "";
                        this.x = (0, c.getMeasurement)(e1.x, "0pt");
                        this.y = (0, c.getMeasurement)(e1.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.bookend = null;
                        this.border = null;
                        this.break = null;
                        this.calculate = null;
                        this.desc = null;
                        this.extras = null;
                        this.keep = null;
                        this.margin = null;
                        this.occur = null;
                        this.overflow = null;
                        this.pageSet = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.variables = null;
                        this.area = new o.XFAObjectArray;
                        this.breakAfter = new o.XFAObjectArray;
                        this.breakBefore = new o.XFAObjectArray;
                        this.connect = new o.XFAObjectArray;
                        this.draw = new o.XFAObjectArray;
                        this.event = new o.XFAObjectArray;
                        this.exObject = new o.XFAObjectArray;
                        this.exclGroup = new o.XFAObjectArray;
                        this.field = new o.XFAObjectArray;
                        this.proto = new o.XFAObjectArray;
                        this.setProperty = new o.XFAObjectArray;
                        this.subform = new o.XFAObjectArray;
                        this.subformSet = new o.XFAObjectArray;
                    }
                    [r.$getSubformParent]() {
                        const e1 = this[r.$getParent]();
                        return e1 instanceof SubformSet ? e1[r.$getSubformParent]() : e1;
                    }
                    [r.$isBindable]() {
                        return !0;
                    }
                    [r.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && 0 === this[r.$extra].attempt && this[r.$extra].numberInLine > 0 || this[r.$getParent]()[r.$isThereMoreWidth]();
                    }
                    *[r.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [r.$flushHTML]() {
                        return (0, i.flushHTML)(this);
                    }
                    [r.$addHTML](e1, t) {
                        (0, i.addHTML)(this, e1, t);
                    }
                    [r.$getAvailableSpace]() {
                        return (0, i.getAvailableSpace)(this);
                    }
                    [r.$isSplittable]() {
                        const e1 = this[r.$getSubformParent]();
                        if (!e1[r.$isSplittable]()) return !1;
                        if (void 0 !== this[r.$extra]._isSplittable) return this[r.$extra]._isSplittable;
                        if ("position" === this.layout || this.layout.includes("row")) {
                            this[r.$extra]._isSplittable = !1;
                            return !1;
                        }
                        if (this.keep && "none" !== this.keep.intact) {
                            this[r.$extra]._isSplittable = !1;
                            return !1;
                        }
                        if (e1.layout?.endsWith("-tb") && 0 !== e1[r.$extra].numberInLine) return !1;
                        this[r.$extra]._isSplittable = !0;
                        return !0;
                    }
                    [r.$toHTML](e1) {
                        setTabIndex(this);
                        if (this.break) {
                            if ("auto" !== this.break.after || "" !== this.break.afterTarget) {
                                const e1 = new BreakAfter({
                                    targetType: this.break.after,
                                    target: this.break.afterTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                e1[r.$globalData] = this[r.$globalData];
                                this[r.$appendChild](e1);
                                this.breakAfter.push(e1);
                            }
                            if ("auto" !== this.break.before || "" !== this.break.beforeTarget) {
                                const e1 = new BreakBefore({
                                    targetType: this.break.before,
                                    target: this.break.beforeTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                e1[r.$globalData] = this[r.$globalData];
                                this[r.$appendChild](e1);
                                this.breakBefore.push(e1);
                            }
                            if ("" !== this.break.overflowTarget) {
                                const e1 = new Overflow({
                                    target: this.break.overflowTarget,
                                    leader: this.break.overflowLeader,
                                    trailer: this.break.overflowTrailer
                                });
                                e1[r.$globalData] = this[r.$globalData];
                                this[r.$appendChild](e1);
                                this.overflow.push(e1);
                            }
                            this[r.$removeChild](this.break);
                            this.break = null;
                        }
                        if ("hidden" === this.presence || "inactive" === this.presence) return c.HTMLResult.EMPTY;
                        (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, l.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
                        if (this.breakBefore.children.length >= 1) {
                            const e1 = this.breakBefore.children[0];
                            if (handleBreak(e1)) return c.HTMLResult.breakNode(e1);
                        }
                        if (this[r.$extra]?.afterBreakAfter) return c.HTMLResult.EMPTY;
                        (0, s.fixDimensions)(this);
                        const t = [], a = {
                            id: this[r.$uid],
                            class: []
                        };
                        (0, s.setAccess)(this, a.class);
                        this[r.$extra] || (this[r.$extra] = Object.create(null));
                        Object.assign(this[r.$extra], {
                            children: t,
                            line: null,
                            attributes: a,
                            attempt: 0,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || 1 / 0, e1.width),
                                height: Math.min(this.h || 1 / 0, e1.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const n = this[r.$getTemplateRoot](), o = n[r.$extra].noLayoutFailure, h = this[r.$isSplittable]();
                        h || setFirstUnsplittable(this);
                        if (!(0, i.checkDimensions)(this, e1)) return c.HTMLResult.FAILURE;
                        const u = new Set([
                            "area",
                            "draw",
                            "exclGroup",
                            "field",
                            "subform",
                            "subformSet"
                        ]);
                        if (this.layout.includes("row")) {
                            const e1 = this[r.$getSubformParent]().columnWidths;
                            if (Array.isArray(e1) && e1.length > 0) {
                                this[r.$extra].columnWidths = e1;
                                this[r.$extra].currentColumn = 0;
                            }
                        }
                        const d = (0, s.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), f = [
                            "xfaSubform"
                        ], g = (0, s.layoutClass)(this);
                        g && f.push(g);
                        a.style = d;
                        a.class = f;
                        this.name && (a.xfaName = this.name);
                        if (this.overflow) {
                            const t = this.overflow[r.$getExtra]();
                            if (t.addLeader) {
                                t.addLeader = !1;
                                handleOverflow(this, t.leader, e1);
                            }
                        }
                        this[r.$pushPara]();
                        const p = "lr-tb" === this.layout || "rl-tb" === this.layout, m = p ? 2 : 1;
                        for(; this[r.$extra].attempt < m; this[r.$extra].attempt++){
                            p && 1 === this[r.$extra].attempt && (this[r.$extra].numberInLine = 0);
                            const e1 = this[r.$childrenToHTML]({
                                filter: u,
                                include: !0
                            });
                            if (e1.success) break;
                            if (e1.isBreak()) {
                                this[r.$popPara]();
                                return e1;
                            }
                            if (p && 0 === this[r.$extra].attempt && 0 === this[r.$extra].numberInLine && !n[r.$extra].noLayoutFailure) {
                                this[r.$extra].attempt = m;
                                break;
                            }
                        }
                        this[r.$popPara]();
                        h || unsetFirstUnsplittable(this);
                        n[r.$extra].noLayoutFailure = o;
                        if (this[r.$extra].attempt === m) {
                            this.overflow && (this[r.$getTemplateRoot]()[r.$extra].overflowNode = this.overflow);
                            h || delete this[r.$extra];
                            return c.HTMLResult.FAILURE;
                        }
                        if (this.overflow) {
                            const t = this.overflow[r.$getExtra]();
                            if (t.addTrailer) {
                                t.addTrailer = !1;
                                handleOverflow(this, t.trailer, e1);
                            }
                        }
                        let b = 0, y = 0;
                        if (this.margin) {
                            b = this.margin.leftInset + this.margin.rightInset;
                            y = this.margin.topInset + this.margin.bottomInset;
                        }
                        const w = Math.max(this[r.$extra].width + b, this.w || 0), S = Math.max(this[r.$extra].height + y, this.h || 0), x = [
                            this.x,
                            this.y,
                            w,
                            S
                        ];
                        "" === this.w && (d.width = (0, s.measureToString)(w));
                        "" === this.h && (d.height = (0, s.measureToString)(S));
                        if (("0px" === d.width || "0px" === d.height) && 0 === t.length) return c.HTMLResult.EMPTY;
                        const C = {
                            name: "div",
                            attributes: a,
                            children: t
                        };
                        applyAssist(this, a);
                        const k = c.HTMLResult.success((0, s.createWrapper)(this, C), x);
                        if (this.breakAfter.children.length >= 1) {
                            const e1 = this.breakAfter.children[0];
                            if (handleBreak(e1)) {
                                this[r.$extra].afterBreakAfter = k;
                                return c.HTMLResult.breakNode(e1);
                            }
                        }
                        delete this[r.$extra];
                        return k;
                    }
                }
                class SubformSet extends o.XFAObject {
                    constructor(e1){
                        super(f, "subformSet", !0);
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.relation = (0, c.getStringOption)(e1.relation, [
                            "ordered",
                            "choice",
                            "unordered"
                        ]);
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.bookend = null;
                        this.break = null;
                        this.desc = null;
                        this.extras = null;
                        this.occur = null;
                        this.overflow = null;
                        this.breakAfter = new o.XFAObjectArray;
                        this.breakBefore = new o.XFAObjectArray;
                        this.subform = new o.XFAObjectArray;
                        this.subformSet = new o.XFAObjectArray;
                    }
                    *[r.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [r.$getSubformParent]() {
                        let e1 = this[r.$getParent]();
                        for(; !(e1 instanceof Subform);)e1 = e1[r.$getParent]();
                        return e1;
                    }
                    [r.$isBindable]() {
                        return !0;
                    }
                }
                class SubjectDN extends o.ContentObject {
                    constructor(e1){
                        super(f, "subjectDN");
                        this.delimiter = e1.delimiter || ",";
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        this[r.$content] = new Map(this[r.$content].split(this.delimiter).map((e1)=>{
                            (e1 = e1.split("=", 2))[0] = e1[0].trim();
                            return e1;
                        }));
                    }
                }
                class SubjectDNs extends o.XFAObject {
                    constructor(e1){
                        super(f, "subjectDNs", !0);
                        this.id = e1.id || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.subjectDN = new o.XFAObjectArray;
                    }
                }
                class Submit extends o.XFAObject {
                    constructor(e1){
                        super(f, "submit", !0);
                        this.embedPDF = (0, c.getInteger)({
                            data: e1.embedPDF,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.format = (0, c.getStringOption)(e1.format, [
                            "xdp",
                            "formdata",
                            "pdf",
                            "urlencoded",
                            "xfd",
                            "xml"
                        ]);
                        this.id = e1.id || "";
                        this.target = e1.target || "";
                        this.textEncoding = (0, c.getKeyword)({
                            data: e1.textEncoding ? e1.textEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (e1)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(e1) || e1.match(/iso-8859-\d{2}/)
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.xdpContent = e1.xdpContent || "";
                        this.encrypt = null;
                        this.encryptData = new o.XFAObjectArray;
                        this.signData = new o.XFAObjectArray;
                    }
                }
                class Template extends o.XFAObject {
                    constructor(e1){
                        super(f, "template", !0);
                        this.baseProfile = (0, c.getStringOption)(e1.baseProfile, [
                            "full",
                            "interactiveForms"
                        ]);
                        this.extras = null;
                        this.subform = new o.XFAObjectArray;
                    }
                    [r.$finalize]() {
                        0 === this.subform.children.length && (0, l.warn)("XFA - No subforms in template node.");
                        this.subform.children.length >= 2 && (0, l.warn)("XFA - Several subforms in template node: please file a bug.");
                        this[r.$tabIndex] = 5e3;
                    }
                    [r.$isSplittable]() {
                        return !0;
                    }
                    [r.$searchNode](e1, t) {
                        return e1.startsWith("#") ? [
                            this[r.$ids].get(e1.slice(1))
                        ] : (0, d.searchNode)(this, t, e1, !0, !0);
                    }
                    *[r.$toPages]() {
                        if (!this.subform.children.length) return c.HTMLResult.success({
                            name: "div",
                            children: []
                        });
                        this[r.$extra] = {
                            overflowNode: null,
                            firstUnsplittable: null,
                            currentContentArea: null,
                            currentPageArea: null,
                            noLayoutFailure: !1,
                            pageNumber: 1,
                            pagePosition: "first",
                            oddOrEven: "odd",
                            blankOrNotBlank: "nonBlank",
                            paraStack: []
                        };
                        const e1 = this.subform.children[0];
                        e1.pageSet[r.$cleanPage]();
                        const t = e1.pageSet.pageArea.children, a = {
                            name: "div",
                            children: []
                        };
                        let n = null, i = null, s = null;
                        if (e1.breakBefore.children.length >= 1) {
                            i = e1.breakBefore.children[0];
                            s = i.target;
                        } else if (e1.subform.children.length >= 1 && e1.subform.children[0].breakBefore.children.length >= 1) {
                            i = e1.subform.children[0].breakBefore.children[0];
                            s = i.target;
                        } else if (e1.break?.beforeTarget) {
                            i = e1.break;
                            s = i.beforeTarget;
                        } else if (e1.subform.children.length >= 1 && e1.subform.children[0].break?.beforeTarget) {
                            i = e1.subform.children[0].break;
                            s = i.beforeTarget;
                        }
                        if (i) {
                            const e1 = this[r.$searchNode](s, i[r.$getParent]());
                            if (e1 instanceof PageArea) {
                                n = e1;
                                i[r.$extra] = {};
                            }
                        }
                        n || (n = t[0]);
                        n[r.$extra] = {
                            numberOfUse: 1
                        };
                        const o = n[r.$getParent]();
                        o[r.$extra] = {
                            numberOfUse: 1,
                            pageIndex: o.pageArea.children.indexOf(n),
                            pageSetIndex: 0
                        };
                        let h, u = null, d = null, f = !0, g = 0, p = 0;
                        for(;;){
                            if (f) g = 0;
                            else {
                                a.children.pop();
                                if (3 == ++g) {
                                    (0, l.warn)("XFA - Something goes wrong: please file a bug.");
                                    return a;
                                }
                            }
                            h = null;
                            this[r.$extra].currentPageArea = n;
                            const t = n[r.$toHTML]().html;
                            a.children.push(t);
                            if (u) {
                                this[r.$extra].noLayoutFailure = !0;
                                t.children.push(u[r.$toHTML](n[r.$extra].space).html);
                                u = null;
                            }
                            if (d) {
                                this[r.$extra].noLayoutFailure = !0;
                                t.children.push(d[r.$toHTML](n[r.$extra].space).html);
                                d = null;
                            }
                            const i = n.contentArea.children, s = t.children.filter((e1)=>e1.attributes.class.includes("xfaContentarea"));
                            f = !1;
                            this[r.$extra].firstUnsplittable = null;
                            this[r.$extra].noLayoutFailure = !1;
                            const flush = (t)=>{
                                const a = e1[r.$flushHTML]();
                                if (a) {
                                    f ||= a.children?.length > 0;
                                    s[t].children.push(a);
                                }
                            };
                            for(let t = p, n = i.length; t < n; t++){
                                const n = this[r.$extra].currentContentArea = i[t], o = {
                                    width: n.w,
                                    height: n.h
                                };
                                p = 0;
                                if (u) {
                                    s[t].children.push(u[r.$toHTML](o).html);
                                    u = null;
                                }
                                if (d) {
                                    s[t].children.push(d[r.$toHTML](o).html);
                                    d = null;
                                }
                                const c = e1[r.$toHTML](o);
                                if (c.success) {
                                    if (c.html) {
                                        f ||= c.html.children?.length > 0;
                                        s[t].children.push(c.html);
                                    } else !f && a.children.length > 1 && a.children.pop();
                                    return a;
                                }
                                if (c.isBreak()) {
                                    const e1 = c.breakNode;
                                    flush(t);
                                    if ("auto" === e1.targetType) continue;
                                    if (e1.leader) {
                                        u = this[r.$searchNode](e1.leader, e1[r.$getParent]());
                                        u = u ? u[0] : null;
                                    }
                                    if (e1.trailer) {
                                        d = this[r.$searchNode](e1.trailer, e1[r.$getParent]());
                                        d = d ? d[0] : null;
                                    }
                                    if ("pageArea" === e1.targetType) {
                                        h = e1[r.$extra].target;
                                        t = 1 / 0;
                                    } else if (e1[r.$extra].target) {
                                        h = e1[r.$extra].target;
                                        p = e1[r.$extra].index + 1;
                                        t = 1 / 0;
                                    } else t = e1[r.$extra].index;
                                } else if (this[r.$extra].overflowNode) {
                                    const e1 = this[r.$extra].overflowNode;
                                    this[r.$extra].overflowNode = null;
                                    const a = e1[r.$getExtra](), n = a.target;
                                    a.addLeader = null !== a.leader;
                                    a.addTrailer = null !== a.trailer;
                                    flush(t);
                                    const s = t;
                                    t = 1 / 0;
                                    if (n instanceof PageArea) h = n;
                                    else if (n instanceof ContentArea) {
                                        const e1 = i.indexOf(n);
                                        if (-1 !== e1) e1 > s ? t = e1 - 1 : p = e1;
                                        else {
                                            h = n[r.$getParent]();
                                            p = h.contentArea.children.indexOf(n);
                                        }
                                    }
                                } else flush(t);
                            }
                            this[r.$extra].pageNumber += 1;
                            h && (h[r.$isUsable]() ? h[r.$extra].numberOfUse += 1 : h = null);
                            n = h || n[r.$getNextPage]();
                            yield null;
                        }
                    }
                }
                t.Template = Template;
                class Text extends o.ContentObject {
                    constructor(e1){
                        super(f, "text");
                        this.id = e1.id || "";
                        this.maxChars = (0, c.getInteger)({
                            data: e1.maxChars,
                            defaultValue: 0,
                            validate: (e1)=>e1 >= 0
                        });
                        this.name = e1.name || "";
                        this.rid = e1.rid || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$acceptWhitespace]() {
                        return !0;
                    }
                    [r.$onChild](e1) {
                        if (e1[r.$namespaceId] === n.NamespaceIds.xhtml.id) {
                            this[r.$content] = e1;
                            return !0;
                        }
                        (0, l.warn)(`XFA - Invalid content in Text: ${e1[r.$nodeName]}.`);
                        return !1;
                    }
                    [r.$onText](e1) {
                        this[r.$content] instanceof o.XFAObject || super[r.$onText](e1);
                    }
                    [r.$finalize]() {
                        "string" == typeof this[r.$content] && (this[r.$content] = this[r.$content].replaceAll("\r\n", "\n"));
                    }
                    [r.$getExtra]() {
                        return "string" == typeof this[r.$content] ? this[r.$content].split(/[\u2029\u2028\n]/).reduce((e1, t)=>{
                            t && e1.push(t);
                            return e1;
                        }, []).join("\n") : this[r.$content][r.$text]();
                    }
                    [r.$toHTML](e1) {
                        if ("string" == typeof this[r.$content]) {
                            const e1 = valueToHtml(this[r.$content]).html;
                            if (this[r.$content].includes("\u2029")) {
                                e1.name = "div";
                                e1.children = [];
                                this[r.$content].split("\u2029").map((e1)=>e1.split(/[\u2028\n]/).reduce((e1, t)=>{
                                        e1.push({
                                            name: "span",
                                            value: t
                                        }, {
                                            name: "br"
                                        });
                                        return e1;
                                    }, [])).forEach((t)=>{
                                    e1.children.push({
                                        name: "p",
                                        children: t
                                    });
                                });
                            } else if (/[\u2028\n]/.test(this[r.$content])) {
                                e1.name = "div";
                                e1.children = [];
                                this[r.$content].split(/[\u2028\n]/).forEach((t)=>{
                                    e1.children.push({
                                        name: "span",
                                        value: t
                                    }, {
                                        name: "br"
                                    });
                                });
                            }
                            return c.HTMLResult.success(e1);
                        }
                        return this[r.$content][r.$toHTML](e1);
                    }
                }
                t.Text = Text;
                class TextEdit extends o.XFAObject {
                    constructor(e1){
                        super(f, "textEdit", !0);
                        this.allowRichText = (0, c.getInteger)({
                            data: e1.allowRichText,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.hScrollPolicy = (0, c.getStringOption)(e1.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = e1.id || "";
                        this.multiLine = (0, c.getInteger)({
                            data: e1.multiLine,
                            defaultValue: "",
                            validate: (e1)=>0 === e1 || 1 === e1
                        });
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.vScrollPolicy = (0, c.getStringOption)(e1.vScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [r.$toHTML](e1) {
                        const t = (0, s.toStyle)(this, "border", "font", "margin");
                        let a;
                        const n = this[r.$getParent]()[r.$getParent]();
                        "" === this.multiLine && (this.multiLine = n instanceof Draw ? 1 : 0);
                        a = 1 === this.multiLine ? {
                            name: "textarea",
                            attributes: {
                                dataId: n[r.$data]?.[r.$uid] || n[r.$uid],
                                fieldId: n[r.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: t,
                                "aria-label": ariaLabel(n),
                                "aria-required": !1
                            }
                        } : {
                            name: "input",
                            attributes: {
                                type: "text",
                                dataId: n[r.$data]?.[r.$uid] || n[r.$uid],
                                fieldId: n[r.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: t,
                                "aria-label": ariaLabel(n),
                                "aria-required": !1
                            }
                        };
                        if (isRequired(n)) {
                            a.attributes["aria-required"] = !0;
                            a.attributes.required = !0;
                        }
                        return c.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                a
                            ]
                        });
                    }
                }
                class Time extends o.StringObject {
                    constructor(e1){
                        super(f, "time");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                    [r.$finalize]() {
                        const e1 = this[r.$content].trim();
                        this[r.$content] = e1 ? new Date(e1) : null;
                    }
                    [r.$toHTML](e1) {
                        return valueToHtml(this[r.$content] ? this[r.$content].toString() : "");
                    }
                }
                class TimeStamp extends o.XFAObject {
                    constructor(e1){
                        super(f, "timeStamp");
                        this.id = e1.id || "";
                        this.server = e1.server || "";
                        this.type = (0, c.getStringOption)(e1.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class ToolTip extends o.StringObject {
                    constructor(e1){
                        super(f, "toolTip");
                        this.id = e1.id || "";
                        this.rid = e1.rid || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Traversal extends o.XFAObject {
                    constructor(e1){
                        super(f, "traversal", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.traverse = new o.XFAObjectArray;
                    }
                }
                class Traverse extends o.XFAObject {
                    constructor(e1){
                        super(f, "traverse", !0);
                        this.id = e1.id || "";
                        this.operation = (0, c.getStringOption)(e1.operation, [
                            "next",
                            "back",
                            "down",
                            "first",
                            "left",
                            "right",
                            "up"
                        ]);
                        this.ref = e1.ref || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.script = null;
                    }
                    get name() {
                        return this.operation;
                    }
                    [r.$isTransparent]() {
                        return !1;
                    }
                }
                class Ui extends o.XFAObject {
                    constructor(e1){
                        super(f, "ui", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.picture = null;
                        this.barcode = null;
                        this.button = null;
                        this.checkButton = null;
                        this.choiceList = null;
                        this.dateTimeEdit = null;
                        this.defaultUi = null;
                        this.imageEdit = null;
                        this.numericEdit = null;
                        this.passwordEdit = null;
                        this.signature = null;
                        this.textEdit = null;
                    }
                    [r.$getExtra]() {
                        if (void 0 === this[r.$extra]) {
                            for (const e1 of Object.getOwnPropertyNames(this)){
                                if ("extras" === e1 || "picture" === e1) continue;
                                const t = this[e1];
                                if (t instanceof o.XFAObject) {
                                    this[r.$extra] = t;
                                    return t;
                                }
                            }
                            this[r.$extra] = null;
                        }
                        return this[r.$extra];
                    }
                    [r.$toHTML](e1) {
                        const t = this[r.$getExtra]();
                        return t ? t[r.$toHTML](e1) : c.HTMLResult.EMPTY;
                    }
                }
                class Validate extends o.XFAObject {
                    constructor(e1){
                        super(f, "validate", !0);
                        this.formatTest = (0, c.getStringOption)(e1.formatTest, [
                            "warning",
                            "disabled",
                            "error"
                        ]);
                        this.id = e1.id || "";
                        this.nullTest = (0, c.getStringOption)(e1.nullTest, [
                            "disabled",
                            "error",
                            "warning"
                        ]);
                        this.scriptTest = (0, c.getStringOption)(e1.scriptTest, [
                            "error",
                            "disabled",
                            "warning"
                        ]);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.picture = null;
                        this.script = null;
                    }
                }
                class Value extends o.XFAObject {
                    constructor(e1){
                        super(f, "value", !0);
                        this.id = e1.id || "";
                        this.override = (0, c.getInteger)({
                            data: e1.override,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.relevant = (0, c.getRelevant)(e1.relevant);
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.arc = null;
                        this.boolean = null;
                        this.date = null;
                        this.dateTime = null;
                        this.decimal = null;
                        this.exData = null;
                        this.float = null;
                        this.image = null;
                        this.integer = null;
                        this.line = null;
                        this.rectangle = null;
                        this.text = null;
                        this.time = null;
                    }
                    [r.$setValue](e1) {
                        const t = this[r.$getParent]();
                        if (t instanceof Field && t.ui?.imageEdit) {
                            if (!this.image) {
                                this.image = new Image({});
                                this[r.$appendChild](this.image);
                            }
                            this.image[r.$content] = e1[r.$content];
                            return;
                        }
                        const a = e1[r.$nodeName];
                        if (null === this[a]) {
                            for (const e1 of Object.getOwnPropertyNames(this)){
                                const t = this[e1];
                                if (t instanceof o.XFAObject) {
                                    this[e1] = null;
                                    this[r.$removeChild](t);
                                }
                            }
                            this[e1[r.$nodeName]] = e1;
                            this[r.$appendChild](e1);
                        } else this[a][r.$content] = e1[r.$content];
                    }
                    [r.$text]() {
                        if (this.exData) return "string" == typeof this.exData[r.$content] ? this.exData[r.$content].trim() : this.exData[r.$content][r.$text]().trim();
                        for (const e1 of Object.getOwnPropertyNames(this)){
                            if ("image" === e1) continue;
                            const t = this[e1];
                            if (t instanceof o.XFAObject) return (t[r.$content] || "").toString().trim();
                        }
                        return null;
                    }
                    [r.$toHTML](e1) {
                        for (const t of Object.getOwnPropertyNames(this)){
                            const a = this[t];
                            if (a instanceof o.XFAObject) return a[r.$toHTML](e1);
                        }
                        return c.HTMLResult.EMPTY;
                    }
                }
                t.Value = Value;
                class Variables extends o.XFAObject {
                    constructor(e1){
                        super(f, "variables", !0);
                        this.id = e1.id || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                        this.boolean = new o.XFAObjectArray;
                        this.date = new o.XFAObjectArray;
                        this.dateTime = new o.XFAObjectArray;
                        this.decimal = new o.XFAObjectArray;
                        this.exData = new o.XFAObjectArray;
                        this.float = new o.XFAObjectArray;
                        this.image = new o.XFAObjectArray;
                        this.integer = new o.XFAObjectArray;
                        this.manifest = new o.XFAObjectArray;
                        this.script = new o.XFAObjectArray;
                        this.text = new o.XFAObjectArray;
                        this.time = new o.XFAObjectArray;
                    }
                    [r.$isTransparent]() {
                        return !0;
                    }
                }
                class TemplateNamespace {
                    static [n.$buildXFAObject](e1, t) {
                        if (TemplateNamespace.hasOwnProperty(e1)) {
                            const a = TemplateNamespace[e1](t);
                            a[r.$setSetAttributes](t);
                            return a;
                        }
                    }
                    static appearanceFilter(e1) {
                        return new AppearanceFilter(e1);
                    }
                    static arc(e1) {
                        return new Arc(e1);
                    }
                    static area(e1) {
                        return new Area(e1);
                    }
                    static assist(e1) {
                        return new Assist(e1);
                    }
                    static barcode(e1) {
                        return new Barcode(e1);
                    }
                    static bind(e1) {
                        return new Bind(e1);
                    }
                    static bindItems(e1) {
                        return new BindItems(e1);
                    }
                    static bookend(e1) {
                        return new Bookend(e1);
                    }
                    static boolean(e1) {
                        return new BooleanElement(e1);
                    }
                    static border(e1) {
                        return new Border(e1);
                    }
                    static break(e1) {
                        return new Break(e1);
                    }
                    static breakAfter(e1) {
                        return new BreakAfter(e1);
                    }
                    static breakBefore(e1) {
                        return new BreakBefore(e1);
                    }
                    static button(e1) {
                        return new Button(e1);
                    }
                    static calculate(e1) {
                        return new Calculate(e1);
                    }
                    static caption(e1) {
                        return new Caption(e1);
                    }
                    static certificate(e1) {
                        return new Certificate(e1);
                    }
                    static certificates(e1) {
                        return new Certificates(e1);
                    }
                    static checkButton(e1) {
                        return new CheckButton(e1);
                    }
                    static choiceList(e1) {
                        return new ChoiceList(e1);
                    }
                    static color(e1) {
                        return new Color(e1);
                    }
                    static comb(e1) {
                        return new Comb(e1);
                    }
                    static connect(e1) {
                        return new Connect(e1);
                    }
                    static contentArea(e1) {
                        return new ContentArea(e1);
                    }
                    static corner(e1) {
                        return new Corner(e1);
                    }
                    static date(e1) {
                        return new DateElement(e1);
                    }
                    static dateTime(e1) {
                        return new DateTime(e1);
                    }
                    static dateTimeEdit(e1) {
                        return new DateTimeEdit(e1);
                    }
                    static decimal(e1) {
                        return new Decimal(e1);
                    }
                    static defaultUi(e1) {
                        return new DefaultUi(e1);
                    }
                    static desc(e1) {
                        return new Desc(e1);
                    }
                    static digestMethod(e1) {
                        return new DigestMethod(e1);
                    }
                    static digestMethods(e1) {
                        return new DigestMethods(e1);
                    }
                    static draw(e1) {
                        return new Draw(e1);
                    }
                    static edge(e1) {
                        return new Edge(e1);
                    }
                    static encoding(e1) {
                        return new Encoding(e1);
                    }
                    static encodings(e1) {
                        return new Encodings(e1);
                    }
                    static encrypt(e1) {
                        return new Encrypt(e1);
                    }
                    static encryptData(e1) {
                        return new EncryptData(e1);
                    }
                    static encryption(e1) {
                        return new Encryption(e1);
                    }
                    static encryptionMethod(e1) {
                        return new EncryptionMethod(e1);
                    }
                    static encryptionMethods(e1) {
                        return new EncryptionMethods(e1);
                    }
                    static event(e1) {
                        return new Event(e1);
                    }
                    static exData(e1) {
                        return new ExData(e1);
                    }
                    static exObject(e1) {
                        return new ExObject(e1);
                    }
                    static exclGroup(e1) {
                        return new ExclGroup(e1);
                    }
                    static execute(e1) {
                        return new Execute(e1);
                    }
                    static extras(e1) {
                        return new Extras(e1);
                    }
                    static field(e1) {
                        return new Field(e1);
                    }
                    static fill(e1) {
                        return new Fill(e1);
                    }
                    static filter(e1) {
                        return new Filter(e1);
                    }
                    static float(e1) {
                        return new Float(e1);
                    }
                    static font(e1) {
                        return new Font(e1);
                    }
                    static format(e1) {
                        return new Format(e1);
                    }
                    static handler(e1) {
                        return new Handler(e1);
                    }
                    static hyphenation(e1) {
                        return new Hyphenation(e1);
                    }
                    static image(e1) {
                        return new Image(e1);
                    }
                    static imageEdit(e1) {
                        return new ImageEdit(e1);
                    }
                    static integer(e1) {
                        return new Integer(e1);
                    }
                    static issuers(e1) {
                        return new Issuers(e1);
                    }
                    static items(e1) {
                        return new Items(e1);
                    }
                    static keep(e1) {
                        return new Keep(e1);
                    }
                    static keyUsage(e1) {
                        return new KeyUsage(e1);
                    }
                    static line(e1) {
                        return new Line(e1);
                    }
                    static linear(e1) {
                        return new Linear(e1);
                    }
                    static lockDocument(e1) {
                        return new LockDocument(e1);
                    }
                    static manifest(e1) {
                        return new Manifest(e1);
                    }
                    static margin(e1) {
                        return new Margin(e1);
                    }
                    static mdp(e1) {
                        return new Mdp(e1);
                    }
                    static medium(e1) {
                        return new Medium(e1);
                    }
                    static message(e1) {
                        return new Message(e1);
                    }
                    static numericEdit(e1) {
                        return new NumericEdit(e1);
                    }
                    static occur(e1) {
                        return new Occur(e1);
                    }
                    static oid(e1) {
                        return new Oid(e1);
                    }
                    static oids(e1) {
                        return new Oids(e1);
                    }
                    static overflow(e1) {
                        return new Overflow(e1);
                    }
                    static pageArea(e1) {
                        return new PageArea(e1);
                    }
                    static pageSet(e1) {
                        return new PageSet(e1);
                    }
                    static para(e1) {
                        return new Para(e1);
                    }
                    static passwordEdit(e1) {
                        return new PasswordEdit(e1);
                    }
                    static pattern(e1) {
                        return new Pattern(e1);
                    }
                    static picture(e1) {
                        return new Picture(e1);
                    }
                    static proto(e1) {
                        return new Proto(e1);
                    }
                    static radial(e1) {
                        return new Radial(e1);
                    }
                    static reason(e1) {
                        return new Reason(e1);
                    }
                    static reasons(e1) {
                        return new Reasons(e1);
                    }
                    static rectangle(e1) {
                        return new Rectangle(e1);
                    }
                    static ref(e1) {
                        return new RefElement(e1);
                    }
                    static script(e1) {
                        return new Script(e1);
                    }
                    static setProperty(e1) {
                        return new SetProperty(e1);
                    }
                    static signData(e1) {
                        return new SignData(e1);
                    }
                    static signature(e1) {
                        return new Signature(e1);
                    }
                    static signing(e1) {
                        return new Signing(e1);
                    }
                    static solid(e1) {
                        return new Solid(e1);
                    }
                    static speak(e1) {
                        return new Speak(e1);
                    }
                    static stipple(e1) {
                        return new Stipple(e1);
                    }
                    static subform(e1) {
                        return new Subform(e1);
                    }
                    static subformSet(e1) {
                        return new SubformSet(e1);
                    }
                    static subjectDN(e1) {
                        return new SubjectDN(e1);
                    }
                    static subjectDNs(e1) {
                        return new SubjectDNs(e1);
                    }
                    static submit(e1) {
                        return new Submit(e1);
                    }
                    static template(e1) {
                        return new Template(e1);
                    }
                    static text(e1) {
                        return new Text(e1);
                    }
                    static textEdit(e1) {
                        return new TextEdit(e1);
                    }
                    static time(e1) {
                        return new Time(e1);
                    }
                    static timeStamp(e1) {
                        return new TimeStamp(e1);
                    }
                    static toolTip(e1) {
                        return new ToolTip(e1);
                    }
                    static traversal(e1) {
                        return new Traversal(e1);
                    }
                    static traverse(e1) {
                        return new Traverse(e1);
                    }
                    static ui(e1) {
                        return new Ui(e1);
                    }
                    static validate(e1) {
                        return new Validate(e1);
                    }
                    static value(e1) {
                        return new Value(e1);
                    }
                    static variables(e1) {
                        return new Variables(e1);
                    }
                }
                t.TemplateNamespace = TemplateNamespace;
            },
            (e1, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.NamespaceIds = t.$buildXFAObject = void 0;
                const a = Symbol();
                t.$buildXFAObject = a;
                t.NamespaceIds = {
                    config: {
                        id: 0,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xci/")
                    },
                    connectionSet: {
                        id: 1,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
                    },
                    datasets: {
                        id: 2,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-data/")
                    },
                    form: {
                        id: 3,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-form/")
                    },
                    localeSet: {
                        id: 4,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
                    },
                    pdf: {
                        id: 5,
                        check: (e1)=>"http://ns.adobe.com/xdp/pdf/" === e1
                    },
                    signature: {
                        id: 6,
                        check: (e1)=>"http://www.w3.org/2000/09/xmldsig#" === e1
                    },
                    sourceSet: {
                        id: 7,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-source-set/")
                    },
                    stylesheet: {
                        id: 8,
                        check: (e1)=>"http://www.w3.org/1999/XSL/Transform" === e1
                    },
                    template: {
                        id: 9,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xfa-template/")
                    },
                    xdc: {
                        id: 10,
                        check: (e1)=>e1.startsWith("http://www.xfa.org/schema/xdc/")
                    },
                    xdp: {
                        id: 11,
                        check: (e1)=>"http://ns.adobe.com/xdp/" === e1
                    },
                    xfdf: {
                        id: 12,
                        check: (e1)=>"http://ns.adobe.com/xfdf/" === e1
                    },
                    xhtml: {
                        id: 13,
                        check: (e1)=>"http://www.w3.org/1999/xhtml" === e1
                    },
                    xmpmeta: {
                        id: 14,
                        check: (e1)=>"http://ns.adobe.com/xmpmeta/" === e1
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.addHTML = function addHTML(e1, t, a) {
                    const i = e1[r.$extra], s = i.availableSpace, [o, c, l, h] = a;
                    switch(e1.layout){
                        case "position":
                            i.width = Math.max(i.width, o + l);
                            i.height = Math.max(i.height, c + h);
                            i.children.push(t);
                            break;
                        case "lr-tb":
                        case "rl-tb":
                            if (!i.line || 1 === i.attempt) {
                                i.line = createLine(e1, []);
                                i.children.push(i.line);
                                i.numberInLine = 0;
                            }
                            i.numberInLine += 1;
                            i.line.children.push(t);
                            if (0 === i.attempt) {
                                i.currentWidth += l;
                                i.height = Math.max(i.height, i.prevHeight + h);
                            } else {
                                i.currentWidth = l;
                                i.prevHeight = i.height;
                                i.height += h;
                                i.attempt = 0;
                            }
                            i.width = Math.max(i.width, i.currentWidth);
                            break;
                        case "rl-row":
                        case "row":
                            {
                                i.children.push(t);
                                i.width += l;
                                i.height = Math.max(i.height, h);
                                const e1 = (0, n.measureToString)(i.height);
                                for (const t of i.children)t.attributes.style.height = e1;
                                break;
                            }
                        case "table":
                        case "tb":
                            i.width = Math.min(s.width, Math.max(i.width, l));
                            i.height += h;
                            i.children.push(t);
                    }
                };
                t.checkDimensions = function checkDimensions(e1, t) {
                    if (null === e1[r.$getTemplateRoot]()[r.$extra].firstUnsplittable) return !0;
                    if (0 === e1.w || 0 === e1.h) return !0;
                    const a = e1[r.$getSubformParent](), n = a[r.$extra]?.attempt || 0, [, i, s, o] = function getTransformedBBox(e1) {
                        let t, a, r = "" === e1.w ? NaN : e1.w, n = "" === e1.h ? NaN : e1.h, [i, s] = [
                            0,
                            0
                        ];
                        switch(e1.anchorType || ""){
                            case "bottomCenter":
                                [i, s] = [
                                    r / 2,
                                    n
                                ];
                                break;
                            case "bottomLeft":
                                [i, s] = [
                                    0,
                                    n
                                ];
                                break;
                            case "bottomRight":
                                [i, s] = [
                                    r,
                                    n
                                ];
                                break;
                            case "middleCenter":
                                [i, s] = [
                                    r / 2,
                                    n / 2
                                ];
                                break;
                            case "middleLeft":
                                [i, s] = [
                                    0,
                                    n / 2
                                ];
                                break;
                            case "middleRight":
                                [i, s] = [
                                    r,
                                    n / 2
                                ];
                                break;
                            case "topCenter":
                                [i, s] = [
                                    r / 2,
                                    0
                                ];
                                break;
                            case "topRight":
                                [i, s] = [
                                    r,
                                    0
                                ];
                        }
                        switch(e1.rotate || 0){
                            case 0:
                                [t, a] = [
                                    -i,
                                    -s
                                ];
                                break;
                            case 90:
                                [t, a] = [
                                    -s,
                                    i
                                ];
                                [r, n] = [
                                    n,
                                    -r
                                ];
                                break;
                            case 180:
                                [t, a] = [
                                    i,
                                    s
                                ];
                                [r, n] = [
                                    -r,
                                    -n
                                ];
                                break;
                            case 270:
                                [t, a] = [
                                    s,
                                    -i
                                ];
                                [r, n] = [
                                    -n,
                                    r
                                ];
                        }
                        return [
                            e1.x + t + Math.min(0, r),
                            e1.y + a + Math.min(0, n),
                            Math.abs(r),
                            Math.abs(n)
                        ];
                    }(e1);
                    switch(a.layout){
                        case "lr-tb":
                        case "rl-tb":
                            return 0 === n ? e1[r.$getTemplateRoot]()[r.$extra].noLayoutFailure ? "" !== e1.w ? Math.round(s - t.width) <= 2 : t.width > 2 : !("" !== e1.h && Math.round(o - t.height) > 2) && ("" !== e1.w ? Math.round(s - t.width) <= 2 || 0 === a[r.$extra].numberInLine && t.height > 2 : t.width > 2) : !!e1[r.$getTemplateRoot]()[r.$extra].noLayoutFailure || !("" !== e1.h && Math.round(o - t.height) > 2) && ("" === e1.w || Math.round(s - t.width) <= 2 || !a[r.$isThereMoreWidth]()) && t.height > 2;
                        case "table":
                        case "tb":
                            return !!e1[r.$getTemplateRoot]()[r.$extra].noLayoutFailure || ("" === e1.h || e1[r.$isSplittable]() ? ("" === e1.w || Math.round(s - t.width) <= 2 || !a[r.$isThereMoreWidth]()) && t.height > 2 : Math.round(o - t.height) <= 2);
                        case "position":
                            if (e1[r.$getTemplateRoot]()[r.$extra].noLayoutFailure) return !0;
                            if ("" === e1.h || Math.round(o + i - t.height) <= 2) return !0;
                            return o + i > e1[r.$getTemplateRoot]()[r.$extra].currentContentArea.h;
                        case "rl-row":
                        case "row":
                            return !!e1[r.$getTemplateRoot]()[r.$extra].noLayoutFailure || "" === e1.h || Math.round(o - t.height) <= 2;
                        default:
                            return !0;
                    }
                };
                t.flushHTML = function flushHTML(e1) {
                    if (!e1[r.$extra]) return null;
                    const t = {
                        name: "div",
                        attributes: e1[r.$extra].attributes,
                        children: e1[r.$extra].children
                    };
                    if (e1[r.$extra].failingNode) {
                        const a = e1[r.$extra].failingNode[r.$flushHTML]();
                        a && (e1.layout.endsWith("-tb") ? t.children.push(createLine(e1, [
                            a
                        ])) : t.children.push(a));
                    }
                    if (0 === t.children.length) return null;
                    return t;
                };
                t.getAvailableSpace = function getAvailableSpace(e1) {
                    const t = e1[r.$extra].availableSpace, a = e1.margin ? e1.margin.topInset + e1.margin.bottomInset : 0, n = e1.margin ? e1.margin.leftInset + e1.margin.rightInset : 0;
                    switch(e1.layout){
                        case "lr-tb":
                        case "rl-tb":
                            return 0 === e1[r.$extra].attempt ? {
                                width: t.width - n - e1[r.$extra].currentWidth,
                                height: t.height - a - e1[r.$extra].prevHeight
                            } : {
                                width: t.width - n,
                                height: t.height - a - e1[r.$extra].height
                            };
                        case "rl-row":
                        case "row":
                            return {
                                width: e1[r.$extra].columnWidths.slice(e1[r.$extra].currentColumn).reduce((e1, t)=>e1 + t),
                                height: t.height - n
                            };
                        case "table":
                        case "tb":
                            return {
                                width: t.width - n,
                                height: t.height - a - e1[r.$extra].height
                            };
                        default:
                            return t;
                    }
                };
                var r = a(78), n = a(83);
                function createLine(e1, t) {
                    return {
                        name: "div",
                        attributes: {
                            class: [
                                "lr-tb" === e1.layout ? "xfaLr" : "xfaRl"
                            ]
                        },
                        children: t
                    };
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.computeBbox = function computeBbox(e1, t, a) {
                    let n;
                    if ("" !== e1.w && "" !== e1.h) n = [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h
                    ];
                    else {
                        if (!a) return null;
                        let i = e1.w;
                        if ("" === i) {
                            if (0 === e1.maxW) {
                                const t = e1[r.$getSubformParent]();
                                i = "position" === t.layout && "" !== t.w ? 0 : e1.minW;
                            } else i = Math.min(e1.maxW, a.width);
                            t.attributes.style.width = measureToString(i);
                        }
                        let s = e1.h;
                        if ("" === s) {
                            if (0 === e1.maxH) {
                                const t = e1[r.$getSubformParent]();
                                s = "position" === t.layout && "" !== t.h ? 0 : e1.minH;
                            } else s = Math.min(e1.maxH, a.height);
                            t.attributes.style.height = measureToString(s);
                        }
                        n = [
                            e1.x,
                            e1.y,
                            i,
                            s
                        ];
                    }
                    return n;
                };
                t.createWrapper = function createWrapper(e1, t) {
                    const { attributes: a } = t, { style: n } = a, i = {
                        name: "div",
                        attributes: {
                            class: [
                                "xfaWrapper"
                            ],
                            style: Object.create(null)
                        },
                        children: []
                    };
                    a.class.push("xfaWrapped");
                    if (e1.border) {
                        const { widths: a, insets: s } = e1.border[r.$extra];
                        let o, c, l = s[0], h = s[3];
                        const u = s[0] + s[2], d = s[1] + s[3];
                        switch(e1.border.hand){
                            case "even":
                                l -= a[0] / 2;
                                h -= a[3] / 2;
                                o = `calc(100% + ${(a[1] + a[3]) / 2 - d}px)`;
                                c = `calc(100% + ${(a[0] + a[2]) / 2 - u}px)`;
                                break;
                            case "left":
                                l -= a[0];
                                h -= a[3];
                                o = `calc(100% + ${a[1] + a[3] - d}px)`;
                                c = `calc(100% + ${a[0] + a[2] - u}px)`;
                                break;
                            case "right":
                                o = d ? `calc(100% - ${d}px)` : "100%";
                                c = u ? `calc(100% - ${u}px)` : "100%";
                        }
                        const f = [
                            "xfaBorder"
                        ];
                        isPrintOnly(e1.border) && f.push("xfaPrintOnly");
                        const g = {
                            name: "div",
                            attributes: {
                                class: f,
                                style: {
                                    top: `${l}px`,
                                    left: `${h}px`,
                                    width: o,
                                    height: c
                                }
                            },
                            children: []
                        };
                        for (const e1 of [
                            "border",
                            "borderWidth",
                            "borderColor",
                            "borderRadius",
                            "borderStyle"
                        ])if (void 0 !== n[e1]) {
                            g.attributes.style[e1] = n[e1];
                            delete n[e1];
                        }
                        i.children.push(g, t);
                    } else i.children.push(t);
                    for (const e1 of [
                        "background",
                        "backgroundClip",
                        "top",
                        "left",
                        "width",
                        "height",
                        "minWidth",
                        "minHeight",
                        "maxWidth",
                        "maxHeight",
                        "transform",
                        "transformOrigin",
                        "visibility"
                    ])if (void 0 !== n[e1]) {
                        i.attributes.style[e1] = n[e1];
                        delete n[e1];
                    }
                    i.attributes.style.position = "absolute" === n.position ? "absolute" : "relative";
                    delete n.position;
                    if (n.alignSelf) {
                        i.attributes.style.alignSelf = n.alignSelf;
                        delete n.alignSelf;
                    }
                    return i;
                };
                t.fixDimensions = function fixDimensions(e1) {
                    const t = e1[r.$getSubformParent]();
                    if (t.layout?.includes("row")) {
                        const a = t[r.$extra], n = e1.colSpan;
                        let i;
                        i = -1 === n ? a.columnWidths.slice(a.currentColumn).reduce((e1, t)=>e1 + t, 0) : a.columnWidths.slice(a.currentColumn, a.currentColumn + n).reduce((e1, t)=>e1 + t, 0);
                        isNaN(i) || (e1.w = i);
                    }
                    t.layout && "position" !== t.layout && (e1.x = e1.y = 0);
                    "table" === e1.layout && "" === e1.w && Array.isArray(e1.columnWidths) && (e1.w = e1.columnWidths.reduce((e1, t)=>e1 + t, 0));
                };
                t.fixTextIndent = function fixTextIndent(e1) {
                    const t = (0, i.getMeasurement)(e1.textIndent, "0px");
                    if (t >= 0) return;
                    const a = "padding" + ("left" == ("right" === e1.textAlign ? "right" : "left") ? "Left" : "Right"), r = (0, i.getMeasurement)(e1[a], "0px");
                    e1[a] = r - t + "px";
                };
                t.fixURL = function fixURL(e1) {
                    const t = (0, n.createValidAbsoluteUrl)(e1, null, {
                        addDefaultProtocol: !0,
                        tryConvertEncoding: !0
                    });
                    return t ? t.href : null;
                };
                t.isPrintOnly = isPrintOnly;
                t.layoutClass = function layoutClass(e1) {
                    switch(e1.layout){
                        case "position":
                        default:
                            return "xfaPosition";
                        case "lr-tb":
                            return "xfaLrTb";
                        case "rl-row":
                            return "xfaRlRow";
                        case "rl-tb":
                            return "xfaRlTb";
                        case "row":
                            return "xfaRow";
                        case "table":
                            return "xfaTable";
                        case "tb":
                            return "xfaTb";
                    }
                };
                t.layoutNode = function layoutNode(e1, t) {
                    let a = null, n = null, i = !1;
                    if ((!e1.w || !e1.h) && e1.value) {
                        let s = 0, o = 0;
                        if (e1.margin) {
                            s = e1.margin.leftInset + e1.margin.rightInset;
                            o = e1.margin.topInset + e1.margin.bottomInset;
                        }
                        let c = null, l = null;
                        if (e1.para) {
                            l = Object.create(null);
                            c = "" === e1.para.lineHeight ? null : e1.para.lineHeight;
                            l.top = "" === e1.para.spaceAbove ? 0 : e1.para.spaceAbove;
                            l.bottom = "" === e1.para.spaceBelow ? 0 : e1.para.spaceBelow;
                            l.left = "" === e1.para.marginLeft ? 0 : e1.para.marginLeft;
                            l.right = "" === e1.para.marginRight ? 0 : e1.para.marginRight;
                        }
                        let h = e1.font;
                        if (!h) {
                            const t = e1[r.$getTemplateRoot]();
                            let a = e1[r.$getParent]();
                            for(; a && a !== t;){
                                if (a.font) {
                                    h = a.font;
                                    break;
                                }
                                a = a[r.$getParent]();
                            }
                        }
                        const u = (e1.w || t.width) - s, d = e1[r.$globalData].fontFinder;
                        if (e1.value.exData && e1.value.exData[r.$content] && "text/html" === e1.value.exData.contentType) {
                            const t = layoutText(e1.value.exData[r.$content], h, l, c, d, u);
                            n = t.width;
                            a = t.height;
                            i = t.isBroken;
                        } else {
                            const t = e1.value[r.$text]();
                            if (t) {
                                const e1 = layoutText(t, h, l, c, d, u);
                                n = e1.width;
                                a = e1.height;
                                i = e1.isBroken;
                            }
                        }
                        null === n || e1.w || (n += s);
                        null === a || e1.h || (a += o);
                    }
                    return {
                        w: n,
                        h: a,
                        isBroken: i
                    };
                };
                t.measureToString = measureToString;
                t.setAccess = function setAccess(e1, t) {
                    switch(e1.access){
                        case "nonInteractive":
                            t.push("xfaNonInteractive");
                            break;
                        case "readOnly":
                            t.push("xfaReadOnly");
                            break;
                        case "protected":
                            t.push("xfaDisabled");
                    }
                };
                t.setFontFamily = function setFontFamily(e1, t, a, r) {
                    if (!a) {
                        delete r.fontFamily;
                        return;
                    }
                    const n = (0, i.stripQuotes)(e1.typeface);
                    r.fontFamily = `"${n}"`;
                    const o = a.find(n);
                    if (o) {
                        const { fontFamily: a } = o.regular.cssFontInfo;
                        a !== n && (r.fontFamily = `"${a}"`);
                        const i = getCurrentPara(t);
                        if (i && "" !== i.lineHeight) return;
                        if (r.lineHeight) return;
                        const c = (0, s.selectFont)(e1, o);
                        c && (r.lineHeight = Math.max(1.2, c.lineHeight));
                    }
                };
                t.setMinMaxDimensions = function setMinMaxDimensions(e1, t) {
                    if ("position" === e1[r.$getSubformParent]().layout) {
                        e1.minW > 0 && (t.minWidth = measureToString(e1.minW));
                        e1.maxW > 0 && (t.maxWidth = measureToString(e1.maxW));
                        e1.minH > 0 && (t.minHeight = measureToString(e1.minH));
                        e1.maxH > 0 && (t.maxHeight = measureToString(e1.maxH));
                    }
                };
                t.setPara = function setPara(e1, t, a) {
                    if (a.attributes.class?.includes("xfaRich")) {
                        if (t) {
                            "" === e1.h && (t.height = "auto");
                            "" === e1.w && (t.width = "auto");
                        }
                        const n = getCurrentPara(e1);
                        if (n) {
                            const e1 = a.attributes.style;
                            e1.display = "flex";
                            e1.flexDirection = "column";
                            switch(n.vAlign){
                                case "top":
                                    e1.justifyContent = "start";
                                    break;
                                case "bottom":
                                    e1.justifyContent = "end";
                                    break;
                                case "middle":
                                    e1.justifyContent = "center";
                            }
                            const t = n[r.$toStyle]();
                            for (const [a, r] of Object.entries(t))a in e1 || (e1[a] = r);
                        }
                    }
                };
                t.toStyle = function toStyle(e1, ...t) {
                    const a = Object.create(null);
                    for (const i of t){
                        const t = e1[i];
                        if (null !== t) {
                            if (l.hasOwnProperty(i)) l[i](e1, a);
                            else if (t instanceof c.XFAObject) {
                                const e1 = t[r.$toStyle]();
                                e1 ? Object.assign(a, e1) : (0, n.warn)(`(DEBUG) - XFA - style for ${i} not implemented yet`);
                            }
                        }
                    }
                    return a;
                };
                var r = a(78), n = a(2), i = a(84), s = a(85), o = a(86), c = a(87);
                function measureToString(e1) {
                    return "string" == typeof e1 ? "0px" : Number.isInteger(e1) ? `${e1}px` : `${e1.toFixed(2)}px`;
                }
                const l = {
                    anchorType (e1, t) {
                        const a = e1[r.$getSubformParent]();
                        if (a && (!a.layout || "position" === a.layout)) {
                            "transform" in t || (t.transform = "");
                            switch(e1.anchorType){
                                case "bottomCenter":
                                    t.transform += "translate(-50%, -100%)";
                                    break;
                                case "bottomLeft":
                                    t.transform += "translate(0,-100%)";
                                    break;
                                case "bottomRight":
                                    t.transform += "translate(-100%,-100%)";
                                    break;
                                case "middleCenter":
                                    t.transform += "translate(-50%,-50%)";
                                    break;
                                case "middleLeft":
                                    t.transform += "translate(0,-50%)";
                                    break;
                                case "middleRight":
                                    t.transform += "translate(-100%,-50%)";
                                    break;
                                case "topCenter":
                                    t.transform += "translate(-50%,0)";
                                    break;
                                case "topRight":
                                    t.transform += "translate(-100%,0)";
                            }
                        }
                    },
                    dimensions (e1, t) {
                        const a = e1[r.$getSubformParent]();
                        let n = e1.w;
                        const i = e1.h;
                        if (a.layout?.includes("row")) {
                            const t = a[r.$extra], i = e1.colSpan;
                            let s;
                            if (-1 === i) {
                                s = t.columnWidths.slice(t.currentColumn).reduce((e1, t)=>e1 + t, 0);
                                t.currentColumn = 0;
                            } else {
                                s = t.columnWidths.slice(t.currentColumn, t.currentColumn + i).reduce((e1, t)=>e1 + t, 0);
                                t.currentColumn = (t.currentColumn + e1.colSpan) % t.columnWidths.length;
                            }
                            isNaN(s) || (n = e1.w = s);
                        }
                        t.width = "" !== n ? measureToString(n) : "auto";
                        t.height = "" !== i ? measureToString(i) : "auto";
                    },
                    position (e1, t) {
                        const a = e1[r.$getSubformParent]();
                        if (!a?.layout || "position" === a.layout) {
                            t.position = "absolute";
                            t.left = measureToString(e1.x);
                            t.top = measureToString(e1.y);
                        }
                    },
                    rotate (e1, t) {
                        if (e1.rotate) {
                            "transform" in t || (t.transform = "");
                            t.transform += `rotate(-${e1.rotate}deg)`;
                            t.transformOrigin = "top left";
                        }
                    },
                    presence (e1, t) {
                        switch(e1.presence){
                            case "invisible":
                                t.visibility = "hidden";
                                break;
                            case "hidden":
                            case "inactive":
                                t.display = "none";
                        }
                    },
                    hAlign (e1, t) {
                        if ("para" === e1[r.$nodeName]) switch(e1.hAlign){
                            case "justifyAll":
                                t.textAlign = "justify-all";
                                break;
                            case "radix":
                                t.textAlign = "left";
                                break;
                            default:
                                t.textAlign = e1.hAlign;
                        }
                        else switch(e1.hAlign){
                            case "left":
                                t.alignSelf = "start";
                                break;
                            case "center":
                                t.alignSelf = "center";
                                break;
                            case "right":
                                t.alignSelf = "end";
                        }
                    },
                    margin (e1, t) {
                        e1.margin && (t.margin = e1.margin[r.$toStyle]().margin);
                    }
                };
                function layoutText(e1, t, a, n, i, s) {
                    const c = new o.TextMeasure(t, a, n, i);
                    "string" == typeof e1 ? c.addString(e1) : e1[r.$pushGlyphs](c);
                    return c.compute(s);
                }
                function isPrintOnly(e1) {
                    return e1.relevant.length > 0 && !e1.relevant[0].excluded && "print" === e1.relevant[0].viewname;
                }
                function getCurrentPara(e1) {
                    const t = e1[r.$getTemplateRoot]()[r.$extra].paraStack;
                    return t.length ? t.at(-1) : null;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.HTMLResult = void 0;
                t.getBBox = function getBBox(e1) {
                    const t = -1;
                    if (!e1) return {
                        x: t,
                        y: t,
                        width: t,
                        height: t
                    };
                    const a = e1.trim().split(/\s*,\s*/).map((e1)=>getMeasurement(e1, "-1"));
                    if (a.length < 4 || a[2] < 0 || a[3] < 0) return {
                        x: t,
                        y: t,
                        width: t,
                        height: t
                    };
                    const [r, n, i, s] = a;
                    return {
                        x: r,
                        y: n,
                        width: i,
                        height: s
                    };
                };
                t.getColor = function getColor(e1, t = [
                    0,
                    0,
                    0
                ]) {
                    let [a, r, n] = t;
                    if (!e1) return {
                        r: a,
                        g: r,
                        b: n
                    };
                    const i = e1.trim().split(/\s*,\s*/).map((e1)=>Math.min(Math.max(0, parseInt(e1.trim(), 10)), 255)).map((e1)=>isNaN(e1) ? 0 : e1);
                    if (i.length < 3) return {
                        r: a,
                        g: r,
                        b: n
                    };
                    [a, r, n] = i;
                    return {
                        r: a,
                        g: r,
                        b: n
                    };
                };
                t.getFloat = function getFloat({ data: e1, defaultValue: t, validate: a }) {
                    if (!e1) return t;
                    e1 = e1.trim();
                    const r = parseFloat(e1);
                    if (!isNaN(r) && a(r)) return r;
                    return t;
                };
                t.getInteger = function getInteger({ data: e1, defaultValue: t, validate: a }) {
                    if (!e1) return t;
                    e1 = e1.trim();
                    const r = parseInt(e1, 10);
                    if (!isNaN(r) && a(r)) return r;
                    return t;
                };
                t.getKeyword = getKeyword;
                t.getMeasurement = getMeasurement;
                t.getRatio = function getRatio(e1) {
                    if (!e1) return {
                        num: 1,
                        den: 1
                    };
                    const t = e1.trim().split(/\s*:\s*/).map((e1)=>parseFloat(e1)).filter((e1)=>!isNaN(e1));
                    1 === t.length && t.push(1);
                    if (0 === t.length) return {
                        num: 1,
                        den: 1
                    };
                    const [a, r] = t;
                    return {
                        num: a,
                        den: r
                    };
                };
                t.getRelevant = function getRelevant(e1) {
                    if (!e1) return [];
                    return e1.trim().split(/\s+/).map((e1)=>({
                            excluded: "-" === e1[0],
                            viewname: e1.substring(1)
                        }));
                };
                t.getStringOption = function getStringOption(e1, t) {
                    return getKeyword({
                        data: e1,
                        defaultValue: t[0],
                        validate: (e1)=>t.includes(e1)
                    });
                };
                t.stripQuotes = function stripQuotes(e1) {
                    if (e1.startsWith("'") || e1.startsWith('"')) return e1.slice(1, -1);
                    return e1;
                };
                var r = a(2);
                const n = {
                    pt: (e1)=>e1,
                    cm: (e1)=>e1 / 2.54 * 72,
                    mm: (e1)=>e1 / 25.4 * 72,
                    in: (e1)=>72 * e1,
                    px: (e1)=>e1
                }, i = /([+-]?\d+\.?\d*)(.*)/;
                function getKeyword({ data: e1, defaultValue: t, validate: a }) {
                    return e1 && a(e1 = e1.trim()) ? e1 : t;
                }
                function getMeasurement(e1, t = "0") {
                    t ||= "0";
                    if (!e1) return getMeasurement(t);
                    const a = e1.trim().match(i);
                    if (!a) return getMeasurement(t);
                    const [, r, s] = a, o = parseFloat(r);
                    if (isNaN(o)) return getMeasurement(t);
                    if (0 === o) return 0;
                    const c = n[s];
                    return c ? c(o) : o;
                }
                class HTMLResult {
                    static get FAILURE() {
                        return (0, r.shadow)(this, "FAILURE", new HTMLResult(!1, null, null, null));
                    }
                    static get EMPTY() {
                        return (0, r.shadow)(this, "EMPTY", new HTMLResult(!0, null, null, null));
                    }
                    constructor(e1, t, a, r){
                        this.success = e1;
                        this.html = t;
                        this.bbox = a;
                        this.breakNode = r;
                    }
                    isBreak() {
                        return !!this.breakNode;
                    }
                    static breakNode(e1) {
                        return new HTMLResult(!1, null, null, e1);
                    }
                    static success(e1, t = null) {
                        return new HTMLResult(!0, e1, t, null);
                    }
                }
                t.HTMLResult = HTMLResult;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.FontFinder = void 0;
                t.getMetrics = function getMetrics(e1, t = !1) {
                    let a = null;
                    if (e1) {
                        const t = (0, n.stripQuotes)(e1.typeface), i = e1[r.$globalData].fontFinder.find(t);
                        a = selectFont(e1, i);
                    }
                    if (!a) return {
                        lineHeight: 12,
                        lineGap: 2,
                        lineNoGap: 10
                    };
                    const i = e1.size || 10, s = a.lineHeight ? Math.max(t ? 0 : 1.2, a.lineHeight) : 1.2, o = void 0 === a.lineGap ? .2 : a.lineGap;
                    return {
                        lineHeight: s * i,
                        lineGap: o * i,
                        lineNoGap: Math.max(1, s - o) * i
                    };
                };
                t.selectFont = selectFont;
                var r = a(78), n = a(84), i = a(2);
                t.FontFinder = class FontFinder {
                    constructor(e1){
                        this.fonts = new Map;
                        this.cache = new Map;
                        this.warned = new Set;
                        this.defaultFont = null;
                        this.add(e1);
                    }
                    add(e1, t = null) {
                        for (const t of e1)this.addPdfFont(t);
                        for (const e1 of this.fonts.values())e1.regular || (e1.regular = e1.italic || e1.bold || e1.bolditalic);
                        if (!t || 0 === t.size) return;
                        const a = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                        for (const e1 of t)this.fonts.set(e1, a);
                    }
                    addPdfFont(e1) {
                        const t = e1.cssFontInfo, a = t.fontFamily;
                        let r = this.fonts.get(a);
                        if (!r) {
                            r = Object.create(null);
                            this.fonts.set(a, r);
                            this.defaultFont || (this.defaultFont = r);
                        }
                        let n = "";
                        const i = parseFloat(t.fontWeight);
                        0 !== parseFloat(t.italicAngle) ? n = i >= 700 ? "bolditalic" : "italic" : i >= 700 && (n = "bold");
                        if (!n) {
                            (e1.name.includes("Bold") || e1.psName?.includes("Bold")) && (n = "bold");
                            (e1.name.includes("Italic") || e1.name.endsWith("It") || e1.psName?.includes("Italic") || e1.psName?.endsWith("It")) && (n += "italic");
                        }
                        n || (n = "regular");
                        r[n] = e1;
                    }
                    getDefault() {
                        return this.defaultFont;
                    }
                    find(e1, t = !0) {
                        let a = this.fonts.get(e1) || this.cache.get(e1);
                        if (a) return a;
                        const r = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                        let n = e1.replaceAll(r, "");
                        a = this.fonts.get(n);
                        if (a) {
                            this.cache.set(e1, a);
                            return a;
                        }
                        n = n.toLowerCase();
                        const s = [];
                        for (const [e1, t] of this.fonts.entries())e1.replaceAll(r, "").toLowerCase().startsWith(n) && s.push(t);
                        if (0 === s.length) for (const [, e1] of this.fonts.entries())e1.regular.name?.replaceAll(r, "").toLowerCase().startsWith(n) && s.push(e1);
                        if (0 === s.length) {
                            n = n.replaceAll(/psmt|mt/gi, "");
                            for (const [e1, t] of this.fonts.entries())e1.replaceAll(r, "").toLowerCase().startsWith(n) && s.push(t);
                        }
                        if (0 === s.length) for (const e1 of this.fonts.values())e1.regular.name?.replaceAll(r, "").toLowerCase().startsWith(n) && s.push(e1);
                        if (s.length >= 1) {
                            1 !== s.length && t && (0, i.warn)(`XFA - Too many choices to guess the correct font: ${e1}`);
                            this.cache.set(e1, s[0]);
                            return s[0];
                        }
                        if (t && !this.warned.has(e1)) {
                            this.warned.add(e1);
                            (0, i.warn)(`XFA - Cannot find the font: ${e1}`);
                        }
                        return null;
                    }
                };
                function selectFont(e1, t) {
                    return "italic" === e1.posture ? "bold" === e1.weight ? t.bolditalic : t.italic : "bold" === e1.weight ? t.bold : t.regular;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.TextMeasure = void 0;
                var r = a(85);
                class FontInfo {
                    constructor(e1, t, a, n){
                        this.lineHeight = a;
                        this.paraMargin = t || {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        };
                        if (!e1) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(n);
                            return;
                        }
                        this.xfaFont = {
                            typeface: e1.typeface,
                            posture: e1.posture,
                            weight: e1.weight,
                            size: e1.size,
                            letterSpacing: e1.letterSpacing
                        };
                        const i = n.find(e1.typeface);
                        if (i) {
                            this.pdfFont = (0, r.selectFont)(e1, i);
                            this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(n));
                        } else [this.pdfFont, this.xfaFont] = this.defaultFont(n);
                    }
                    defaultFont(e1) {
                        const t = e1.find("Helvetica", !1) || e1.find("Myriad Pro", !1) || e1.find("Arial", !1) || e1.getDefault();
                        if (t?.regular) {
                            const e1 = t.regular;
                            return [
                                e1,
                                {
                                    typeface: e1.cssFontInfo.fontFamily,
                                    posture: "normal",
                                    weight: "normal",
                                    size: 10,
                                    letterSpacing: 0
                                }
                            ];
                        }
                        return [
                            null,
                            {
                                typeface: "Courier",
                                posture: "normal",
                                weight: "normal",
                                size: 10,
                                letterSpacing: 0
                            }
                        ];
                    }
                }
                class FontSelector {
                    constructor(e1, t, a, r){
                        this.fontFinder = r;
                        this.stack = [
                            new FontInfo(e1, t, a, r)
                        ];
                    }
                    pushData(e1, t, a) {
                        const r = this.stack.at(-1);
                        for (const t of [
                            "typeface",
                            "posture",
                            "weight",
                            "size",
                            "letterSpacing"
                        ])e1[t] || (e1[t] = r.xfaFont[t]);
                        for (const e1 of [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ])isNaN(t[e1]) && (t[e1] = r.paraMargin[e1]);
                        const n = new FontInfo(e1, t, a || r.lineHeight, this.fontFinder);
                        n.pdfFont || (n.pdfFont = r.pdfFont);
                        this.stack.push(n);
                    }
                    popFont() {
                        this.stack.pop();
                    }
                    topFont() {
                        return this.stack.at(-1);
                    }
                }
                t.TextMeasure = class TextMeasure {
                    constructor(e1, t, a, r){
                        this.glyphs = [];
                        this.fontSelector = new FontSelector(e1, t, a, r);
                        this.extraHeight = 0;
                    }
                    pushData(e1, t, a) {
                        this.fontSelector.pushData(e1, t, a);
                    }
                    popFont(e1) {
                        return this.fontSelector.popFont();
                    }
                    addPara() {
                        const e1 = this.fontSelector.topFont();
                        this.extraHeight += e1.paraMargin.top + e1.paraMargin.bottom;
                    }
                    addString(e1) {
                        if (!e1) return;
                        const t = this.fontSelector.topFont(), a = t.xfaFont.size;
                        if (t.pdfFont) {
                            const r = t.xfaFont.letterSpacing, n = t.pdfFont, i = n.lineHeight || 1.2, s = t.lineHeight || Math.max(1.2, i) * a, o = i - (void 0 === n.lineGap ? .2 : n.lineGap), c = Math.max(1, o) * a, l = a / 1e3, h = n.defaultWidth || n.charsToGlyphs(" ")[0].width;
                            for (const t of e1.split(/[\u2029\n]/)){
                                const e1 = n.encodeString(t).join(""), a = n.charsToGlyphs(e1);
                                for (const e1 of a){
                                    const t = e1.width || h;
                                    this.glyphs.push([
                                        t * l + r,
                                        s,
                                        c,
                                        e1.unicode,
                                        !1
                                    ]);
                                }
                                this.glyphs.push([
                                    0,
                                    0,
                                    0,
                                    "\n",
                                    !0
                                ]);
                            }
                            this.glyphs.pop();
                        } else {
                            for (const t of e1.split(/[\u2029\n]/)){
                                for (const e1 of t.split(""))this.glyphs.push([
                                    a,
                                    1.2 * a,
                                    a,
                                    e1,
                                    !1
                                ]);
                                this.glyphs.push([
                                    0,
                                    0,
                                    0,
                                    "\n",
                                    !0
                                ]);
                            }
                            this.glyphs.pop();
                        }
                    }
                    compute(e1) {
                        let t = -1, a = 0, r = 0, n = 0, i = 0, s = 0, o = !1, c = !0;
                        for(let l = 0, h = this.glyphs.length; l < h; l++){
                            const [h, u, d, f, g] = this.glyphs[l], p = " " === f, m = c ? d : u;
                            if (g) {
                                r = Math.max(r, i);
                                i = 0;
                                n += s;
                                s = m;
                                t = -1;
                                a = 0;
                                c = !1;
                            } else if (p) {
                                if (i + h > e1) {
                                    r = Math.max(r, i);
                                    i = 0;
                                    n += s;
                                    s = m;
                                    t = -1;
                                    a = 0;
                                    o = !0;
                                    c = !1;
                                } else {
                                    s = Math.max(m, s);
                                    a = i;
                                    i += h;
                                    t = l;
                                }
                            } else if (i + h > e1) {
                                n += s;
                                s = m;
                                if (-1 !== t) {
                                    l = t;
                                    r = Math.max(r, a);
                                    i = 0;
                                    t = -1;
                                    a = 0;
                                } else {
                                    r = Math.max(r, i);
                                    i = h;
                                }
                                o = !0;
                                c = !1;
                            } else {
                                i += h;
                                s = Math.max(m, s);
                            }
                        }
                        r = Math.max(r, i);
                        n += s + this.extraHeight;
                        return {
                            width: 1.02 * r,
                            height: n,
                            isBroken: o
                        };
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XmlObject = t.XFAObjectArray = t.XFAObject = t.XFAAttribute = t.StringObject = t.OptionObject = t.Option10 = t.Option01 = t.IntegerObject = t.ContentObject = void 0;
                var r = a(78), n = a(84), i = a(2), s = a(3), o = a(81), c = a(88);
                const l = Symbol(), h = Symbol(), u = Symbol(), d = Symbol("_children"), f = Symbol(), g = Symbol(), p = Symbol(), m = Symbol(), b = Symbol(), y = Symbol(), w = Symbol(), S = Symbol(), x = Symbol(), C = Symbol("parent"), k = Symbol(), v = Symbol(), F = Symbol();
                let O = 0;
                const T = o.NamespaceIds.datasets.id;
                class XFAObject {
                    constructor(e1, t, a = !1){
                        this[r.$namespaceId] = e1;
                        this[r.$nodeName] = t;
                        this[w] = a;
                        this[C] = null;
                        this[d] = [];
                        this[r.$uid] = `${t}${O++}`;
                        this[r.$globalData] = null;
                    }
                    get isXFAObject() {
                        return !0;
                    }
                    get isXFAObjectArray() {
                        return !1;
                    }
                    createNodes(e1) {
                        let t = this, a = null;
                        for (const { name: n, index: i } of e1){
                            for(let e1 = 0, s = isFinite(i) ? i : 0; e1 <= s; e1++){
                                const e1 = t[r.$namespaceId] === T ? -1 : t[r.$namespaceId];
                                a = new XmlObject(e1, n);
                                t[r.$appendChild](a);
                            }
                            t = a;
                        }
                        return a;
                    }
                    [r.$onChild](e1) {
                        if (!this[w] || !this[r.$onChildCheck](e1)) return !1;
                        const t = e1[r.$nodeName], a = this[t];
                        if (!(a instanceof XFAObjectArray)) {
                            null !== a && this[r.$removeChild](a);
                            this[t] = e1;
                            this[r.$appendChild](e1);
                            return !0;
                        }
                        if (a.push(e1)) {
                            this[r.$appendChild](e1);
                            return !0;
                        }
                        let n = "";
                        this.id ? n = ` (id: ${this.id})` : this.name && (n = ` (name: ${this.name} ${this.h.value})`);
                        (0, i.warn)(`XFA - node "${this[r.$nodeName]}"${n} has already enough "${t}"!`);
                        return !1;
                    }
                    [r.$onChildCheck](e1) {
                        return this.hasOwnProperty(e1[r.$nodeName]) && e1[r.$namespaceId] === this[r.$namespaceId];
                    }
                    [r.$isNsAgnostic]() {
                        return !1;
                    }
                    [r.$acceptWhitespace]() {
                        return !1;
                    }
                    [r.$isCDATAXml]() {
                        return !1;
                    }
                    [r.$isBindable]() {
                        return !1;
                    }
                    [r.$popPara]() {
                        this.para && this[r.$getTemplateRoot]()[r.$extra].paraStack.pop();
                    }
                    [r.$pushPara]() {
                        this[r.$getTemplateRoot]()[r.$extra].paraStack.push(this.para);
                    }
                    [r.$setId](e1) {
                        this.id && this[r.$namespaceId] === o.NamespaceIds.template.id && e1.set(this.id, this);
                    }
                    [r.$getTemplateRoot]() {
                        return this[r.$globalData].template;
                    }
                    [r.$isSplittable]() {
                        return !1;
                    }
                    [r.$isThereMoreWidth]() {
                        return !1;
                    }
                    [r.$appendChild](e1) {
                        e1[C] = this;
                        this[d].push(e1);
                        !e1[r.$globalData] && this[r.$globalData] && (e1[r.$globalData] = this[r.$globalData]);
                    }
                    [r.$removeChild](e1) {
                        const t = this[d].indexOf(e1);
                        this[d].splice(t, 1);
                    }
                    [r.$hasSettableValue]() {
                        return this.hasOwnProperty("value");
                    }
                    [r.$setValue](e1) {}
                    [r.$onText](e1) {}
                    [r.$finalize]() {}
                    [r.$clean](e1) {
                        delete this[w];
                        if (this[r.$cleanup]) {
                            e1.clean(this[r.$cleanup]);
                            delete this[r.$cleanup];
                        }
                    }
                    [r.$indexOf](e1) {
                        return this[d].indexOf(e1);
                    }
                    [r.$insertAt](e1, t) {
                        t[C] = this;
                        this[d].splice(e1, 0, t);
                        !t[r.$globalData] && this[r.$globalData] && (t[r.$globalData] = this[r.$globalData]);
                    }
                    [r.$isTransparent]() {
                        return !this.name;
                    }
                    [r.$lastAttribute]() {
                        return "";
                    }
                    [r.$text]() {
                        return 0 === this[d].length ? this[r.$content] : this[d].map((e1)=>e1[r.$text]()).join("");
                    }
                    get [u]() {
                        const e1 = Object.getPrototypeOf(this);
                        if (!e1._attributes) {
                            const t = e1._attributes = new Set;
                            for (const e1 of Object.getOwnPropertyNames(this)){
                                if (null === this[e1] || this[e1] instanceof XFAObject || this[e1] instanceof XFAObjectArray) break;
                                t.add(e1);
                            }
                        }
                        return (0, i.shadow)(this, u, e1._attributes);
                    }
                    [r.$isDescendent](e1) {
                        let t = this;
                        for(; t;){
                            if (t === e1) return !0;
                            t = t[r.$getParent]();
                        }
                        return !1;
                    }
                    [r.$getParent]() {
                        return this[C];
                    }
                    [r.$getSubformParent]() {
                        return this[r.$getParent]();
                    }
                    [r.$getChildren](e1 = null) {
                        return e1 ? this[e1] : this[d];
                    }
                    [r.$dump]() {
                        const e1 = Object.create(null);
                        this[r.$content] && (e1.$content = this[r.$content]);
                        for (const t of Object.getOwnPropertyNames(this)){
                            const a = this[t];
                            null !== a && (a instanceof XFAObject ? e1[t] = a[r.$dump]() : a instanceof XFAObjectArray ? a.isEmpty() || (e1[t] = a.dump()) : e1[t] = a);
                        }
                        return e1;
                    }
                    [r.$toStyle]() {
                        return null;
                    }
                    [r.$toHTML]() {
                        return n.HTMLResult.EMPTY;
                    }
                    *[r.$getContainedChildren]() {
                        for (const e1 of this[r.$getChildren]())yield e1;
                    }
                    *[m](e1, t) {
                        for (const a of this[r.$getContainedChildren]())if (!e1 || t === e1.has(a[r.$nodeName])) {
                            const e1 = this[r.$getAvailableSpace](), t = a[r.$toHTML](e1);
                            t.success || (this[r.$extra].failingNode = a);
                            yield t;
                        }
                    }
                    [r.$flushHTML]() {
                        return null;
                    }
                    [r.$addHTML](e1, t) {
                        this[r.$extra].children.push(e1);
                    }
                    [r.$getAvailableSpace]() {}
                    [r.$childrenToHTML]({ filter: e1 = null, include: t = !0 }) {
                        if (this[r.$extra].generator) {
                            const e1 = this[r.$getAvailableSpace](), t = this[r.$extra].failingNode[r.$toHTML](e1);
                            if (!t.success) return t;
                            t.html && this[r.$addHTML](t.html, t.bbox);
                            delete this[r.$extra].failingNode;
                        } else this[r.$extra].generator = this[m](e1, t);
                        for(;;){
                            const e1 = this[r.$extra].generator.next();
                            if (e1.done) break;
                            const t = e1.value;
                            if (!t.success) return t;
                            t.html && this[r.$addHTML](t.html, t.bbox);
                        }
                        this[r.$extra].generator = null;
                        return n.HTMLResult.EMPTY;
                    }
                    [r.$setSetAttributes](e1) {
                        this[v] = new Set(Object.keys(e1));
                    }
                    [y](e1) {
                        const t = this[u], a = this[v];
                        return [
                            ...e1
                        ].filter((e1)=>t.has(e1) && !a.has(e1));
                    }
                    [r.$resolvePrototypes](e1, t = new Set) {
                        for (const a of this[d])a[k](e1, t);
                    }
                    [k](e1, t) {
                        const a = this[b](e1, t);
                        a ? this[l](a, e1, t) : this[r.$resolvePrototypes](e1, t);
                    }
                    [b](e1, t) {
                        const { use: a, usehref: n } = this;
                        if (!a && !n) return null;
                        let s = null, o = null, h = null, u = a;
                        if (n) {
                            u = n;
                            n.startsWith("#som(") && n.endsWith(")") ? o = n.slice(5, -1) : n.startsWith(".#som(") && n.endsWith(")") ? o = n.slice(6, -1) : n.startsWith("#") ? h = n.slice(1) : n.startsWith(".#") && (h = n.slice(2));
                        } else a.startsWith("#") ? h = a.slice(1) : o = a;
                        this.use = this.usehref = "";
                        if (h) s = e1.get(h);
                        else {
                            s = (0, c.searchNode)(e1.get(r.$root), this, o, !0, !1);
                            s && (s = s[0]);
                        }
                        if (!s) {
                            (0, i.warn)(`XFA - Invalid prototype reference: ${u}.`);
                            return null;
                        }
                        if (s[r.$nodeName] !== this[r.$nodeName]) {
                            (0, i.warn)(`XFA - Incompatible prototype: ${s[r.$nodeName]} !== ${this[r.$nodeName]}.`);
                            return null;
                        }
                        if (t.has(s)) {
                            (0, i.warn)("XFA - Cycle detected in prototypes use.");
                            return null;
                        }
                        t.add(s);
                        const d = s[b](e1, t);
                        d && s[l](d, e1, t);
                        s[r.$resolvePrototypes](e1, t);
                        t.delete(s);
                        return s;
                    }
                    [l](e1, t, a) {
                        if (a.has(e1)) {
                            (0, i.warn)("XFA - Cycle detected in prototypes use.");
                            return;
                        }
                        !this[r.$content] && e1[r.$content] && (this[r.$content] = e1[r.$content]);
                        new Set(a).add(e1);
                        for (const t of this[y](e1[v])){
                            this[t] = e1[t];
                            this[v] && this[v].add(t);
                        }
                        for (const n of Object.getOwnPropertyNames(this)){
                            if (this[u].has(n)) continue;
                            const i = this[n], s = e1[n];
                            if (i instanceof XFAObjectArray) {
                                for (const e1 of i[d])e1[k](t, a);
                                for(let n = i[d].length, o = s[d].length; n < o; n++){
                                    const s = e1[d][n][r.$clone]();
                                    if (!i.push(s)) break;
                                    s[C] = this;
                                    this[d].push(s);
                                    s[k](t, a);
                                }
                            } else if (null === i) {
                                if (null !== s) {
                                    const e1 = s[r.$clone]();
                                    e1[C] = this;
                                    this[n] = e1;
                                    this[d].push(e1);
                                    e1[k](t, a);
                                }
                            } else {
                                i[r.$resolvePrototypes](t, a);
                                s && i[l](s, t, a);
                            }
                        }
                    }
                    static [f](e1) {
                        return Array.isArray(e1) ? e1.map((e1)=>XFAObject[f](e1)) : "object" == typeof e1 && null !== e1 ? Object.assign({}, e1) : e1;
                    }
                    [r.$clone]() {
                        const e1 = Object.create(Object.getPrototypeOf(this));
                        for (const t of Object.getOwnPropertySymbols(this))try {
                            e1[t] = this[t];
                        } catch  {
                            (0, i.shadow)(e1, t, this[t]);
                        }
                        e1[r.$uid] = `${e1[r.$nodeName]}${O++}`;
                        e1[d] = [];
                        for (const t of Object.getOwnPropertyNames(this)){
                            if (this[u].has(t)) {
                                e1[t] = XFAObject[f](this[t]);
                                continue;
                            }
                            const a = this[t];
                            e1[t] = a instanceof XFAObjectArray ? new XFAObjectArray(a[S]) : null;
                        }
                        for (const t of this[d]){
                            const a = t[r.$nodeName], n = t[r.$clone]();
                            e1[d].push(n);
                            n[C] = e1;
                            null === e1[a] ? e1[a] = n : e1[a][d].push(n);
                        }
                        return e1;
                    }
                    [r.$getChildren](e1 = null) {
                        return e1 ? this[d].filter((t)=>t[r.$nodeName] === e1) : this[d];
                    }
                    [r.$getChildrenByClass](e1) {
                        return this[e1];
                    }
                    [r.$getChildrenByName](e1, t, a = !0) {
                        return Array.from(this[r.$getChildrenByNameIt](e1, t, a));
                    }
                    *[r.$getChildrenByNameIt](e1, t, a = !0) {
                        if ("parent" !== e1) {
                            for (const a of this[d]){
                                a[r.$nodeName] === e1 && (yield a);
                                a.name === e1 && (yield a);
                                (t || a[r.$isTransparent]()) && (yield* a[r.$getChildrenByNameIt](e1, t, !1));
                            }
                            a && this[u].has(e1) && (yield new XFAAttribute(this, e1, this[e1]));
                        } else yield this[C];
                    }
                }
                t.XFAObject = XFAObject;
                class XFAObjectArray {
                    constructor(e1 = 1 / 0){
                        this[S] = e1;
                        this[d] = [];
                    }
                    get isXFAObject() {
                        return !1;
                    }
                    get isXFAObjectArray() {
                        return !0;
                    }
                    push(e1) {
                        if (this[d].length <= this[S]) {
                            this[d].push(e1);
                            return !0;
                        }
                        (0, i.warn)(`XFA - node "${e1[r.$nodeName]}" accepts no more than ${this[S]} children`);
                        return !1;
                    }
                    isEmpty() {
                        return 0 === this[d].length;
                    }
                    dump() {
                        return 1 === this[d].length ? this[d][0][r.$dump]() : this[d].map((e1)=>e1[r.$dump]());
                    }
                    [r.$clone]() {
                        const e1 = new XFAObjectArray(this[S]);
                        e1[d] = this[d].map((e1)=>e1[r.$clone]());
                        return e1;
                    }
                    get children() {
                        return this[d];
                    }
                    clear() {
                        this[d].length = 0;
                    }
                }
                t.XFAObjectArray = XFAObjectArray;
                class XFAAttribute {
                    constructor(e1, t, a){
                        this[C] = e1;
                        this[r.$nodeName] = t;
                        this[r.$content] = a;
                        this[r.$consumed] = !1;
                        this[r.$uid] = "attribute" + O++;
                    }
                    [r.$getParent]() {
                        return this[C];
                    }
                    [r.$isDataValue]() {
                        return !0;
                    }
                    [r.$getDataValue]() {
                        return this[r.$content].trim();
                    }
                    [r.$setValue](e1) {
                        e1 = e1.value || "";
                        this[r.$content] = e1.toString();
                    }
                    [r.$text]() {
                        return this[r.$content];
                    }
                    [r.$isDescendent](e1) {
                        return this[C] === e1 || this[C][r.$isDescendent](e1);
                    }
                }
                t.XFAAttribute = XFAAttribute;
                class XmlObject extends XFAObject {
                    constructor(e1, t, a = {}){
                        super(e1, t);
                        this[r.$content] = "";
                        this[g] = null;
                        if ("#text" !== t) {
                            const e1 = new Map;
                            this[h] = e1;
                            for (const [t, r] of Object.entries(a))e1.set(t, new XFAAttribute(this, t, r));
                            if (a.hasOwnProperty(r.$nsAttributes)) {
                                const e1 = a[r.$nsAttributes].xfa.dataNode;
                                void 0 !== e1 && ("dataGroup" === e1 ? this[g] = !1 : "dataValue" === e1 && (this[g] = !0));
                            }
                        }
                        this[r.$consumed] = !1;
                    }
                    [r.$toString](e1) {
                        const t = this[r.$nodeName];
                        if ("#text" === t) {
                            e1.push((0, s.encodeToXmlString)(this[r.$content]));
                            return;
                        }
                        const a = (0, i.utf8StringToString)(t), n = this[r.$namespaceId] === T ? "xfa:" : "";
                        e1.push(`<${n}${a}`);
                        for (const [t, a] of this[h].entries()){
                            const n = (0, i.utf8StringToString)(t);
                            e1.push(` ${n}="${(0, s.encodeToXmlString)(a[r.$content])}"`);
                        }
                        null !== this[g] && (this[g] ? e1.push(' xfa:dataNode="dataValue"') : e1.push(' xfa:dataNode="dataGroup"'));
                        if (this[r.$content] || 0 !== this[d].length) {
                            e1.push(">");
                            if (this[r.$content]) "string" == typeof this[r.$content] ? e1.push((0, s.encodeToXmlString)(this[r.$content])) : this[r.$content][r.$toString](e1);
                            else for (const t of this[d])t[r.$toString](e1);
                            e1.push(`</${n}${a}>`);
                        } else e1.push("/>");
                    }
                    [r.$onChild](e1) {
                        if (this[r.$content]) {
                            const e1 = new XmlObject(this[r.$namespaceId], "#text");
                            this[r.$appendChild](e1);
                            e1[r.$content] = this[r.$content];
                            this[r.$content] = "";
                        }
                        this[r.$appendChild](e1);
                        return !0;
                    }
                    [r.$onText](e1) {
                        this[r.$content] += e1;
                    }
                    [r.$finalize]() {
                        if (this[r.$content] && this[d].length > 0) {
                            const e1 = new XmlObject(this[r.$namespaceId], "#text");
                            this[r.$appendChild](e1);
                            e1[r.$content] = this[r.$content];
                            delete this[r.$content];
                        }
                    }
                    [r.$toHTML]() {
                        return "#text" === this[r.$nodeName] ? n.HTMLResult.success({
                            name: "#text",
                            value: this[r.$content]
                        }) : n.HTMLResult.EMPTY;
                    }
                    [r.$getChildren](e1 = null) {
                        return e1 ? this[d].filter((t)=>t[r.$nodeName] === e1) : this[d];
                    }
                    [r.$getAttributes]() {
                        return this[h];
                    }
                    [r.$getChildrenByClass](e1) {
                        const t = this[h].get(e1);
                        return void 0 !== t ? t : this[r.$getChildren](e1);
                    }
                    *[r.$getChildrenByNameIt](e1, t) {
                        const a = this[h].get(e1);
                        a && (yield a);
                        for (const a of this[d]){
                            a[r.$nodeName] === e1 && (yield a);
                            t && (yield* a[r.$getChildrenByNameIt](e1, t));
                        }
                    }
                    *[r.$getAttributeIt](e1, t) {
                        const a = this[h].get(e1);
                        !a || t && a[r.$consumed] || (yield a);
                        for (const a of this[d])yield* a[r.$getAttributeIt](e1, t);
                    }
                    *[r.$getRealChildrenByNameIt](e1, t, a) {
                        for (const n of this[d]){
                            n[r.$nodeName] !== e1 || a && n[r.$consumed] || (yield n);
                            t && (yield* n[r.$getRealChildrenByNameIt](e1, t, a));
                        }
                    }
                    [r.$isDataValue]() {
                        return null === this[g] ? 0 === this[d].length || this[d][0][r.$namespaceId] === o.NamespaceIds.xhtml.id : this[g];
                    }
                    [r.$getDataValue]() {
                        return null === this[g] ? 0 === this[d].length ? this[r.$content].trim() : this[d][0][r.$namespaceId] === o.NamespaceIds.xhtml.id ? this[d][0][r.$text]().trim() : null : this[r.$content].trim();
                    }
                    [r.$setValue](e1) {
                        e1 = e1.value || "";
                        this[r.$content] = e1.toString();
                    }
                    [r.$dump](e1 = !1) {
                        const t = Object.create(null);
                        e1 && (t.$ns = this[r.$namespaceId]);
                        this[r.$content] && (t.$content = this[r.$content]);
                        t.$name = this[r.$nodeName];
                        t.children = [];
                        for (const a of this[d])t.children.push(a[r.$dump](e1));
                        t.attributes = Object.create(null);
                        for (const [e1, a] of this[h])t.attributes[e1] = a[r.$content];
                        return t;
                    }
                }
                t.XmlObject = XmlObject;
                class ContentObject extends XFAObject {
                    constructor(e1, t){
                        super(e1, t);
                        this[r.$content] = "";
                    }
                    [r.$onText](e1) {
                        this[r.$content] += e1;
                    }
                    [r.$finalize]() {}
                }
                t.ContentObject = ContentObject;
                class OptionObject extends ContentObject {
                    constructor(e1, t, a){
                        super(e1, t);
                        this[x] = a;
                    }
                    [r.$finalize]() {
                        this[r.$content] = (0, n.getKeyword)({
                            data: this[r.$content],
                            defaultValue: this[x][0],
                            validate: (e1)=>this[x].includes(e1)
                        });
                    }
                    [r.$clean](e1) {
                        super[r.$clean](e1);
                        delete this[x];
                    }
                }
                t.OptionObject = OptionObject;
                class StringObject extends ContentObject {
                    [r.$finalize]() {
                        this[r.$content] = this[r.$content].trim();
                    }
                }
                t.StringObject = StringObject;
                class IntegerObject extends ContentObject {
                    constructor(e1, t, a, r){
                        super(e1, t);
                        this[p] = a;
                        this[F] = r;
                    }
                    [r.$finalize]() {
                        this[r.$content] = (0, n.getInteger)({
                            data: this[r.$content],
                            defaultValue: this[p],
                            validate: this[F]
                        });
                    }
                    [r.$clean](e1) {
                        super[r.$clean](e1);
                        delete this[p];
                        delete this[F];
                    }
                }
                t.IntegerObject = IntegerObject;
                t.Option01 = class Option01 extends IntegerObject {
                    constructor(e1, t){
                        super(e1, t, 0, (e1)=>1 === e1);
                    }
                };
                t.Option10 = class Option10 extends IntegerObject {
                    constructor(e1, t){
                        super(e1, t, 1, (e1)=>0 === e1);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.createDataNode = function createDataNode(e1, t, a) {
                    const i = parseExpression(a);
                    if (!i) return null;
                    if (i.some((e1)=>e1.operator === o.dotDot)) return null;
                    const s = c.get(i[0].name);
                    let l = 0;
                    if (s) {
                        e1 = s(e1, t);
                        l = 1;
                    } else e1 = t || e1;
                    for(let t = i.length; l < t; l++){
                        const { name: t, operator: a, index: s } = i[l];
                        if (!isFinite(s)) {
                            i[l].index = 0;
                            return e1.createNodes(i.slice(l));
                        }
                        let c;
                        switch(a){
                            case o.dot:
                                c = e1[r.$getChildrenByName](t, !1);
                                break;
                            case o.dotDot:
                                c = e1[r.$getChildrenByName](t, !0);
                                break;
                            case o.dotHash:
                                c = e1[r.$getChildrenByClass](t);
                                c = c.isXFAObjectArray ? c.children : [
                                    c
                                ];
                        }
                        if (0 === c.length) return e1.createNodes(i.slice(l));
                        if (!(s < c.length)) {
                            i[l].index = s - c.length;
                            return e1.createNodes(i.slice(l));
                        }
                        {
                            const t = c[s];
                            if (!t.isXFAObject) {
                                (0, n.warn)("XFA - Cannot create a node.");
                                return null;
                            }
                            e1 = t;
                        }
                    }
                    return null;
                };
                t.searchNode = function searchNode(e1, t, a, n = !0, i = !0) {
                    const s = parseExpression(a, n);
                    if (!s) return null;
                    const h = c.get(s[0].name);
                    let u, d = 0;
                    if (h) {
                        u = !0;
                        e1 = [
                            h(e1, t)
                        ];
                        d = 1;
                    } else {
                        u = null === t;
                        e1 = [
                            t || e1
                        ];
                    }
                    for(let a = s.length; d < a; d++){
                        const { name: a, cacheName: n, operator: c, index: h } = s[d], f = [];
                        for (const t of e1){
                            if (!t.isXFAObject) continue;
                            let e1, s;
                            if (i) {
                                s = l.get(t);
                                if (!s) {
                                    s = new Map;
                                    l.set(t, s);
                                }
                                e1 = s.get(n);
                            }
                            if (!e1) {
                                switch(c){
                                    case o.dot:
                                        e1 = t[r.$getChildrenByName](a, !1);
                                        break;
                                    case o.dotDot:
                                        e1 = t[r.$getChildrenByName](a, !0);
                                        break;
                                    case o.dotHash:
                                        e1 = t[r.$getChildrenByClass](a);
                                        e1 = e1.isXFAObjectArray ? e1.children : [
                                            e1
                                        ];
                                }
                                i && s.set(n, e1);
                            }
                            e1.length > 0 && f.push(e1);
                        }
                        if (0 !== f.length || u || 0 !== d) e1 = isFinite(h) ? f.filter((e1)=>h < e1.length).map((e1)=>e1[h]) : f.flat();
                        else {
                            const a = t[r.$getParent]();
                            if (!(t = a)) return null;
                            d = -1;
                            e1 = [
                                t
                            ];
                        }
                    }
                    if (0 === e1.length) return null;
                    return e1;
                };
                var r = a(78), n = a(2);
                const i = /^[^.[]+/, s = /^[^\]]+/, o = {
                    dot: 0,
                    dotDot: 1,
                    dotHash: 2,
                    dotBracket: 3,
                    dotParen: 4
                }, c = new Map([
                    [
                        "$data",
                        (e1, t)=>e1.datasets ? e1.datasets.data : e1
                    ],
                    [
                        "$record",
                        (e1, t)=>(e1.datasets ? e1.datasets.data : e1)[r.$getChildren]()[0]
                    ],
                    [
                        "$template",
                        (e1, t)=>e1.template
                    ],
                    [
                        "$connectionSet",
                        (e1, t)=>e1.connectionSet
                    ],
                    [
                        "$form",
                        (e1, t)=>e1.form
                    ],
                    [
                        "$layout",
                        (e1, t)=>e1.layout
                    ],
                    [
                        "$host",
                        (e1, t)=>e1.host
                    ],
                    [
                        "$dataWindow",
                        (e1, t)=>e1.dataWindow
                    ],
                    [
                        "$event",
                        (e1, t)=>e1.event
                    ],
                    [
                        "!",
                        (e1, t)=>e1.datasets
                    ],
                    [
                        "$xfa",
                        (e1, t)=>e1
                    ],
                    [
                        "xfa",
                        (e1, t)=>e1
                    ],
                    [
                        "$",
                        (e1, t)=>t
                    ]
                ]), l = new WeakMap;
                function parseExpression(e1, t, a = !0) {
                    let r = e1.match(i);
                    if (!r) return null;
                    let [c] = r;
                    const l = [
                        {
                            name: c,
                            cacheName: "." + c,
                            index: 0,
                            js: null,
                            formCalc: null,
                            operator: o.dot
                        }
                    ];
                    let h = c.length;
                    for(; h < e1.length;){
                        const d = h;
                        if ("[" === e1.charAt(h++)) {
                            r = e1.slice(h).match(s);
                            if (!r) {
                                (0, n.warn)("XFA - Invalid index in SOM expression");
                                return null;
                            }
                            l.at(-1).index = "*" === (u = (u = r[0]).trim()) ? 1 / 0 : parseInt(u, 10) || 0;
                            h += r[0].length + 1;
                            continue;
                        }
                        let f;
                        switch(e1.charAt(h)){
                            case ".":
                                if (!t) return null;
                                h++;
                                f = o.dotDot;
                                break;
                            case "#":
                                h++;
                                f = o.dotHash;
                                break;
                            case "[":
                                if (a) {
                                    (0, n.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
                                    return null;
                                }
                                f = o.dotBracket;
                                break;
                            case "(":
                                if (a) {
                                    (0, n.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
                                    return null;
                                }
                                f = o.dotParen;
                                break;
                            default:
                                f = o.dot;
                        }
                        r = e1.slice(h).match(i);
                        if (!r) break;
                        [c] = r;
                        h += c.length;
                        l.push({
                            name: c,
                            cacheName: e1.slice(d, h),
                            operator: f,
                            index: 0,
                            js: null,
                            formCalc: null
                        });
                    }
                    var u;
                    return l;
                }
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.DataHandler = void 0;
                var r = a(78);
                t.DataHandler = class DataHandler {
                    constructor(e1, t){
                        this.data = t;
                        this.dataset = e1.datasets || null;
                    }
                    serialize(e1) {
                        const t = [
                            [
                                -1,
                                this.data[r.$getChildren]()
                            ]
                        ];
                        for(; t.length > 0;){
                            const a = t.at(-1), [n, i] = a;
                            if (n + 1 === i.length) {
                                t.pop();
                                continue;
                            }
                            const s = i[++a[0]], o = e1.get(s[r.$uid]);
                            if (o) s[r.$setValue](o);
                            else {
                                const t = s[r.$getAttributes]();
                                for (const a of t.values()){
                                    const t = e1.get(a[r.$uid]);
                                    if (t) {
                                        a[r.$setValue](t);
                                        break;
                                    }
                                }
                            }
                            const c = s[r.$getChildren]();
                            c.length > 0 && t.push([
                                -1,
                                c
                            ]);
                        }
                        const a = [
                            '<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'
                        ];
                        if (this.dataset) for (const e1 of this.dataset[r.$getChildren]())"data" !== e1[r.$nodeName] && e1[r.$toString](a);
                        this.data[r.$toString](a);
                        a.push("</xfa:datasets>");
                        return a.join("");
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XFAParser = void 0;
                var r = a(78), n = a(71), i = a(91), s = a(2);
                class XFAParser extends n.XMLParserBase {
                    constructor(e1 = null, t = !1){
                        super();
                        this._builder = new i.Builder(e1);
                        this._stack = [];
                        this._globalData = {
                            usedTypefaces: new Set
                        };
                        this._ids = new Map;
                        this._current = this._builder.buildRoot(this._ids);
                        this._errorCode = n.XMLParserErrorCode.NoError;
                        this._whiteRegex = /^\s+$/;
                        this._nbsps = /\xa0+/g;
                        this._richText = t;
                    }
                    parse(e1) {
                        this.parseXml(e1);
                        if (this._errorCode === n.XMLParserErrorCode.NoError) {
                            this._current[r.$finalize]();
                            return this._current.element;
                        }
                    }
                    onText(e1) {
                        e1 = e1.replace(this._nbsps, (e1)=>e1.slice(1) + " ");
                        this._richText || this._current[r.$acceptWhitespace]() ? this._current[r.$onText](e1, this._richText) : this._whiteRegex.test(e1) || this._current[r.$onText](e1.trim());
                    }
                    onCdata(e1) {
                        this._current[r.$onText](e1);
                    }
                    _mkAttributes(e1, t) {
                        let a = null, n = null;
                        const i = Object.create({});
                        for (const { name: o, value: c } of e1)if ("xmlns" === o) a ? (0, s.warn)(`XFA - multiple namespace definition in <${t}>`) : a = c;
                        else if (o.startsWith("xmlns:")) {
                            const e1 = o.substring(6);
                            n || (n = []);
                            n.push({
                                prefix: e1,
                                value: c
                            });
                        } else {
                            const e1 = o.indexOf(":");
                            if (-1 === e1) i[o] = c;
                            else {
                                let t = i[r.$nsAttributes];
                                t || (t = i[r.$nsAttributes] = Object.create(null));
                                const [a, n] = [
                                    o.slice(0, e1),
                                    o.slice(e1 + 1)
                                ];
                                (t[a] ||= Object.create(null))[n] = c;
                            }
                        }
                        return [
                            a,
                            n,
                            i
                        ];
                    }
                    _getNameAndPrefix(e1, t) {
                        const a = e1.indexOf(":");
                        return -1 === a ? [
                            e1,
                            null
                        ] : [
                            e1.substring(a + 1),
                            t ? "" : e1.substring(0, a)
                        ];
                    }
                    onBeginElement(e1, t, a) {
                        const [n, i, s] = this._mkAttributes(t, e1), [o, c] = this._getNameAndPrefix(e1, this._builder.isNsAgnostic()), l = this._builder.build({
                            nsPrefix: c,
                            name: o,
                            attributes: s,
                            namespace: n,
                            prefixes: i
                        });
                        l[r.$globalData] = this._globalData;
                        if (a) {
                            l[r.$finalize]();
                            this._current[r.$onChild](l) && l[r.$setId](this._ids);
                            l[r.$clean](this._builder);
                        } else {
                            this._stack.push(this._current);
                            this._current = l;
                        }
                    }
                    onEndElement(e1) {
                        const t = this._current;
                        if (t[r.$isCDATAXml]() && "string" == typeof t[r.$content]) {
                            const e1 = new XFAParser;
                            e1._globalData = this._globalData;
                            const a = e1.parse(t[r.$content]);
                            t[r.$content] = null;
                            t[r.$onChild](a);
                        }
                        t[r.$finalize]();
                        this._current = this._stack.pop();
                        this._current[r.$onChild](t) && t[r.$setId](this._ids);
                        t[r.$clean](this._builder);
                    }
                    onError(e1) {
                        this._errorCode = e1;
                    }
                }
                t.XFAParser = XFAParser;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.Builder = void 0;
                var r = a(81), n = a(78), i = a(92), s = a(80), o = a(101), c = a(2), l = a(87);
                class Root extends l.XFAObject {
                    constructor(e1){
                        super(-1, "root", Object.create(null));
                        this.element = null;
                        this[n.$ids] = e1;
                    }
                    [n.$onChild](e1) {
                        this.element = e1;
                        return !0;
                    }
                    [n.$finalize]() {
                        super[n.$finalize]();
                        if (this.element.template instanceof s.Template) {
                            this[n.$ids].set(n.$root, this.element);
                            this.element.template[n.$resolvePrototypes](this[n.$ids]);
                            this.element.template[n.$ids] = this[n.$ids];
                        }
                    }
                }
                class Empty extends l.XFAObject {
                    constructor(){
                        super(-1, "", Object.create(null));
                    }
                    [n.$onChild](e1) {
                        return !1;
                    }
                }
                t.Builder = class Builder {
                    constructor(e1 = null){
                        this._namespaceStack = [];
                        this._nsAgnosticLevel = 0;
                        this._namespacePrefixes = new Map;
                        this._namespaces = new Map;
                        this._nextNsId = Math.max(...Object.values(r.NamespaceIds).map(({ id: e1 })=>e1));
                        this._currentNamespace = e1 || new o.UnknownNamespace(++this._nextNsId);
                    }
                    buildRoot(e1) {
                        return new Root(e1);
                    }
                    build({ nsPrefix: e1, name: t, attributes: a, namespace: s, prefixes: o }) {
                        const c = null !== s;
                        if (c) {
                            this._namespaceStack.push(this._currentNamespace);
                            this._currentNamespace = this._searchNamespace(s);
                        }
                        o && this._addNamespacePrefix(o);
                        if (a.hasOwnProperty(n.$nsAttributes)) {
                            const e1 = i.NamespaceSetUp.datasets, t = a[n.$nsAttributes];
                            let r = null;
                            for (const [a, n] of Object.entries(t))if (this._getNamespaceToUse(a) === e1) {
                                r = {
                                    xfa: n
                                };
                                break;
                            }
                            r ? a[n.$nsAttributes] = r : delete a[n.$nsAttributes];
                        }
                        const l = this._getNamespaceToUse(e1), h = l?.[r.$buildXFAObject](t, a) || new Empty;
                        h[n.$isNsAgnostic]() && this._nsAgnosticLevel++;
                        (c || o || h[n.$isNsAgnostic]()) && (h[n.$cleanup] = {
                            hasNamespace: c,
                            prefixes: o,
                            nsAgnostic: h[n.$isNsAgnostic]()
                        });
                        return h;
                    }
                    isNsAgnostic() {
                        return this._nsAgnosticLevel > 0;
                    }
                    _searchNamespace(e1) {
                        let t = this._namespaces.get(e1);
                        if (t) return t;
                        for (const [a, { check: n }] of Object.entries(r.NamespaceIds))if (n(e1)) {
                            t = i.NamespaceSetUp[a];
                            if (t) {
                                this._namespaces.set(e1, t);
                                return t;
                            }
                            break;
                        }
                        t = new o.UnknownNamespace(++this._nextNsId);
                        this._namespaces.set(e1, t);
                        return t;
                    }
                    _addNamespacePrefix(e1) {
                        for (const { prefix: t, value: a } of e1){
                            const e1 = this._searchNamespace(a);
                            let r = this._namespacePrefixes.get(t);
                            if (!r) {
                                r = [];
                                this._namespacePrefixes.set(t, r);
                            }
                            r.push(e1);
                        }
                    }
                    _getNamespaceToUse(e1) {
                        if (!e1) return this._currentNamespace;
                        const t = this._namespacePrefixes.get(e1);
                        if (t?.length > 0) return t.at(-1);
                        (0, c.warn)(`Unknown namespace prefix: ${e1}.`);
                        return null;
                    }
                    clean(e1) {
                        const { hasNamespace: t, prefixes: a, nsAgnostic: r } = e1;
                        t && (this._currentNamespace = this._namespaceStack.pop());
                        a && a.forEach(({ prefix: e1 })=>{
                            this._namespacePrefixes.get(e1).pop();
                        });
                        r && this._nsAgnosticLevel--;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.NamespaceSetUp = void 0;
                var r = a(93), n = a(94), i = a(95), s = a(96), o = a(97), c = a(98), l = a(80), h = a(99), u = a(100);
                const d = {
                    config: r.ConfigNamespace,
                    connection: n.ConnectionSetNamespace,
                    datasets: i.DatasetsNamespace,
                    localeSet: s.LocaleSetNamespace,
                    signature: o.SignatureNamespace,
                    stylesheet: c.StylesheetNamespace,
                    template: l.TemplateNamespace,
                    xdp: h.XdpNamespace,
                    xhtml: u.XhtmlNamespace
                };
                t.NamespaceSetUp = d;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ConfigNamespace = void 0;
                var r = a(81), n = a(78), i = a(87), s = a(84), o = a(2);
                const c = r.NamespaceIds.config.id;
                class Acrobat extends i.XFAObject {
                    constructor(e1){
                        super(c, "acrobat", !0);
                        this.acrobat7 = null;
                        this.autoSave = null;
                        this.common = null;
                        this.validate = null;
                        this.validateApprovalSignatures = null;
                        this.submitUrl = new i.XFAObjectArray;
                    }
                }
                class Acrobat7 extends i.XFAObject {
                    constructor(e1){
                        super(c, "acrobat7", !0);
                        this.dynamicRender = null;
                    }
                }
                class ADBE_JSConsole extends i.OptionObject {
                    constructor(e1){
                        super(c, "ADBE_JSConsole", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class ADBE_JSDebugger extends i.OptionObject {
                    constructor(e1){
                        super(c, "ADBE_JSDebugger", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class AddSilentPrint extends i.Option01 {
                    constructor(e1){
                        super(c, "addSilentPrint");
                    }
                }
                class AddViewerPreferences extends i.Option01 {
                    constructor(e1){
                        super(c, "addViewerPreferences");
                    }
                }
                class AdjustData extends i.Option10 {
                    constructor(e1){
                        super(c, "adjustData");
                    }
                }
                class AdobeExtensionLevel extends i.IntegerObject {
                    constructor(e1){
                        super(c, "adobeExtensionLevel", 0, (e1)=>e1 >= 1 && e1 <= 8);
                    }
                }
                class Agent extends i.XFAObject {
                    constructor(e1){
                        super(c, "agent", !0);
                        this.name = e1.name ? e1.name.trim() : "";
                        this.common = new i.XFAObjectArray;
                    }
                }
                class AlwaysEmbed extends i.ContentObject {
                    constructor(e1){
                        super(c, "alwaysEmbed");
                    }
                }
                class Amd extends i.StringObject {
                    constructor(e1){
                        super(c, "amd");
                    }
                }
                class Area extends i.XFAObject {
                    constructor(e1){
                        super(c, "area");
                        this.level = (0, s.getInteger)({
                            data: e1.level,
                            defaultValue: 0,
                            validate: (e1)=>e1 >= 1 && e1 <= 3
                        });
                        this.name = (0, s.getStringOption)(e1.name, [
                            "",
                            "barcode",
                            "coreinit",
                            "deviceDriver",
                            "font",
                            "general",
                            "layout",
                            "merge",
                            "script",
                            "signature",
                            "sourceSet",
                            "templateCache"
                        ]);
                    }
                }
                class Attributes extends i.OptionObject {
                    constructor(e1){
                        super(c, "attributes", [
                            "preserve",
                            "delegate",
                            "ignore"
                        ]);
                    }
                }
                class AutoSave extends i.OptionObject {
                    constructor(e1){
                        super(c, "autoSave", [
                            "disabled",
                            "enabled"
                        ]);
                    }
                }
                class Base extends i.StringObject {
                    constructor(e1){
                        super(c, "base");
                    }
                }
                class BatchOutput extends i.XFAObject {
                    constructor(e1){
                        super(c, "batchOutput");
                        this.format = (0, s.getStringOption)(e1.format, [
                            "none",
                            "concat",
                            "zip",
                            "zipCompress"
                        ]);
                    }
                }
                class BehaviorOverride extends i.ContentObject {
                    constructor(e1){
                        super(c, "behaviorOverride");
                    }
                    [n.$finalize]() {
                        this[n.$content] = new Map(this[n.$content].trim().split(/\s+/).filter((e1)=>e1.includes(":")).map((e1)=>e1.split(":", 2)));
                    }
                }
                class Cache extends i.XFAObject {
                    constructor(e1){
                        super(c, "cache", !0);
                        this.templateCache = null;
                    }
                }
                class Change extends i.Option01 {
                    constructor(e1){
                        super(c, "change");
                    }
                }
                class Common extends i.XFAObject {
                    constructor(e1){
                        super(c, "common", !0);
                        this.data = null;
                        this.locale = null;
                        this.localeSet = null;
                        this.messaging = null;
                        this.suppressBanner = null;
                        this.template = null;
                        this.validationMessaging = null;
                        this.versionControl = null;
                        this.log = new i.XFAObjectArray;
                    }
                }
                class Compress extends i.XFAObject {
                    constructor(e1){
                        super(c, "compress");
                        this.scope = (0, s.getStringOption)(e1.scope, [
                            "imageOnly",
                            "document"
                        ]);
                    }
                }
                class CompressLogicalStructure extends i.Option01 {
                    constructor(e1){
                        super(c, "compressLogicalStructure");
                    }
                }
                class CompressObjectStream extends i.Option10 {
                    constructor(e1){
                        super(c, "compressObjectStream");
                    }
                }
                class Compression extends i.XFAObject {
                    constructor(e1){
                        super(c, "compression", !0);
                        this.compressLogicalStructure = null;
                        this.compressObjectStream = null;
                        this.level = null;
                        this.type = null;
                    }
                }
                class Config extends i.XFAObject {
                    constructor(e1){
                        super(c, "config", !0);
                        this.acrobat = null;
                        this.present = null;
                        this.trace = null;
                        this.agent = new i.XFAObjectArray;
                    }
                }
                class Conformance extends i.OptionObject {
                    constructor(e1){
                        super(c, "conformance", [
                            "A",
                            "B"
                        ]);
                    }
                }
                class ContentCopy extends i.Option01 {
                    constructor(e1){
                        super(c, "contentCopy");
                    }
                }
                class Copies extends i.IntegerObject {
                    constructor(e1){
                        super(c, "copies", 1, (e1)=>e1 >= 1);
                    }
                }
                class Creator extends i.StringObject {
                    constructor(e1){
                        super(c, "creator");
                    }
                }
                class CurrentPage extends i.IntegerObject {
                    constructor(e1){
                        super(c, "currentPage", 0, (e1)=>e1 >= 0);
                    }
                }
                class Data extends i.XFAObject {
                    constructor(e1){
                        super(c, "data", !0);
                        this.adjustData = null;
                        this.attributes = null;
                        this.incrementalLoad = null;
                        this.outputXSL = null;
                        this.range = null;
                        this.record = null;
                        this.startNode = null;
                        this.uri = null;
                        this.window = null;
                        this.xsl = null;
                        this.excludeNS = new i.XFAObjectArray;
                        this.transform = new i.XFAObjectArray;
                    }
                }
                class Debug extends i.XFAObject {
                    constructor(e1){
                        super(c, "debug", !0);
                        this.uri = null;
                    }
                }
                class DefaultTypeface extends i.ContentObject {
                    constructor(e1){
                        super(c, "defaultTypeface");
                        this.writingScript = (0, s.getStringOption)(e1.writingScript, [
                            "*",
                            "Arabic",
                            "Cyrillic",
                            "EastEuropeanRoman",
                            "Greek",
                            "Hebrew",
                            "Japanese",
                            "Korean",
                            "Roman",
                            "SimplifiedChinese",
                            "Thai",
                            "TraditionalChinese",
                            "Vietnamese"
                        ]);
                    }
                }
                class Destination extends i.OptionObject {
                    constructor(e1){
                        super(c, "destination", [
                            "pdf",
                            "pcl",
                            "ps",
                            "webClient",
                            "zpl"
                        ]);
                    }
                }
                class DocumentAssembly extends i.Option01 {
                    constructor(e1){
                        super(c, "documentAssembly");
                    }
                }
                class Driver extends i.XFAObject {
                    constructor(e1){
                        super(c, "driver", !0);
                        this.name = e1.name ? e1.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class DuplexOption extends i.OptionObject {
                    constructor(e1){
                        super(c, "duplexOption", [
                            "simplex",
                            "duplexFlipLongEdge",
                            "duplexFlipShortEdge"
                        ]);
                    }
                }
                class DynamicRender extends i.OptionObject {
                    constructor(e1){
                        super(c, "dynamicRender", [
                            "forbidden",
                            "required"
                        ]);
                    }
                }
                class Embed extends i.Option01 {
                    constructor(e1){
                        super(c, "embed");
                    }
                }
                class Encrypt extends i.Option01 {
                    constructor(e1){
                        super(c, "encrypt");
                    }
                }
                class Encryption extends i.XFAObject {
                    constructor(e1){
                        super(c, "encryption", !0);
                        this.encrypt = null;
                        this.encryptionLevel = null;
                        this.permissions = null;
                    }
                }
                class EncryptionLevel extends i.OptionObject {
                    constructor(e1){
                        super(c, "encryptionLevel", [
                            "40bit",
                            "128bit"
                        ]);
                    }
                }
                class Enforce extends i.StringObject {
                    constructor(e1){
                        super(c, "enforce");
                    }
                }
                class Equate extends i.XFAObject {
                    constructor(e1){
                        super(c, "equate");
                        this.force = (0, s.getInteger)({
                            data: e1.force,
                            defaultValue: 1,
                            validate: (e1)=>0 === e1
                        });
                        this.from = e1.from || "";
                        this.to = e1.to || "";
                    }
                }
                class EquateRange extends i.XFAObject {
                    constructor(e1){
                        super(c, "equateRange");
                        this.from = e1.from || "";
                        this.to = e1.to || "";
                        this._unicodeRange = e1.unicodeRange || "";
                    }
                    get unicodeRange() {
                        const e1 = [], t = /U\+([0-9a-fA-F]+)/, a = this._unicodeRange;
                        for (let r of a.split(",").map((e1)=>e1.trim()).filter((e1)=>!!e1)){
                            r = r.split("-", 2).map((e1)=>{
                                const a = e1.match(t);
                                return a ? parseInt(a[1], 16) : 0;
                            });
                            1 === r.length && r.push(r[0]);
                            e1.push(r);
                        }
                        return (0, o.shadow)(this, "unicodeRange", e1);
                    }
                }
                class Exclude extends i.ContentObject {
                    constructor(e1){
                        super(c, "exclude");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim().split(/\s+/).filter((e1)=>e1 && [
                                "calculate",
                                "close",
                                "enter",
                                "exit",
                                "initialize",
                                "ready",
                                "validate"
                            ].includes(e1));
                    }
                }
                class ExcludeNS extends i.StringObject {
                    constructor(e1){
                        super(c, "excludeNS");
                    }
                }
                class FlipLabel extends i.OptionObject {
                    constructor(e1){
                        super(c, "flipLabel", [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class FontInfo extends i.XFAObject {
                    constructor(e1){
                        super(c, "fontInfo", !0);
                        this.embed = null;
                        this.map = null;
                        this.subsetBelow = null;
                        this.alwaysEmbed = new i.XFAObjectArray;
                        this.defaultTypeface = new i.XFAObjectArray;
                        this.neverEmbed = new i.XFAObjectArray;
                    }
                }
                class FormFieldFilling extends i.Option01 {
                    constructor(e1){
                        super(c, "formFieldFilling");
                    }
                }
                class GroupParent extends i.StringObject {
                    constructor(e1){
                        super(c, "groupParent");
                    }
                }
                class IfEmpty extends i.OptionObject {
                    constructor(e1){
                        super(c, "ifEmpty", [
                            "dataValue",
                            "dataGroup",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class IncludeXDPContent extends i.StringObject {
                    constructor(e1){
                        super(c, "includeXDPContent");
                    }
                }
                class IncrementalLoad extends i.OptionObject {
                    constructor(e1){
                        super(c, "incrementalLoad", [
                            "none",
                            "forwardOnly"
                        ]);
                    }
                }
                class IncrementalMerge extends i.Option01 {
                    constructor(e1){
                        super(c, "incrementalMerge");
                    }
                }
                class Interactive extends i.Option01 {
                    constructor(e1){
                        super(c, "interactive");
                    }
                }
                class Jog extends i.OptionObject {
                    constructor(e1){
                        super(c, "jog", [
                            "usePrinterSetting",
                            "none",
                            "pageSet"
                        ]);
                    }
                }
                class LabelPrinter extends i.XFAObject {
                    constructor(e1){
                        super(c, "labelPrinter", !0);
                        this.name = (0, s.getStringOption)(e1.name, [
                            "zpl",
                            "dpl",
                            "ipl",
                            "tcpl"
                        ]);
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Layout extends i.OptionObject {
                    constructor(e1){
                        super(c, "layout", [
                            "paginate",
                            "panel"
                        ]);
                    }
                }
                class Level extends i.IntegerObject {
                    constructor(e1){
                        super(c, "level", 0, (e1)=>e1 > 0);
                    }
                }
                class Linearized extends i.Option01 {
                    constructor(e1){
                        super(c, "linearized");
                    }
                }
                class Locale extends i.StringObject {
                    constructor(e1){
                        super(c, "locale");
                    }
                }
                class LocaleSet extends i.StringObject {
                    constructor(e1){
                        super(c, "localeSet");
                    }
                }
                class Log extends i.XFAObject {
                    constructor(e1){
                        super(c, "log", !0);
                        this.mode = null;
                        this.threshold = null;
                        this.to = null;
                        this.uri = null;
                    }
                }
                class MapElement extends i.XFAObject {
                    constructor(e1){
                        super(c, "map", !0);
                        this.equate = new i.XFAObjectArray;
                        this.equateRange = new i.XFAObjectArray;
                    }
                }
                class MediumInfo extends i.XFAObject {
                    constructor(e1){
                        super(c, "mediumInfo", !0);
                        this.map = null;
                    }
                }
                class Message extends i.XFAObject {
                    constructor(e1){
                        super(c, "message", !0);
                        this.msgId = null;
                        this.severity = null;
                    }
                }
                class Messaging extends i.XFAObject {
                    constructor(e1){
                        super(c, "messaging", !0);
                        this.message = new i.XFAObjectArray;
                    }
                }
                class Mode extends i.OptionObject {
                    constructor(e1){
                        super(c, "mode", [
                            "append",
                            "overwrite"
                        ]);
                    }
                }
                class ModifyAnnots extends i.Option01 {
                    constructor(e1){
                        super(c, "modifyAnnots");
                    }
                }
                class MsgId extends i.IntegerObject {
                    constructor(e1){
                        super(c, "msgId", 1, (e1)=>e1 >= 1);
                    }
                }
                class NameAttr extends i.StringObject {
                    constructor(e1){
                        super(c, "nameAttr");
                    }
                }
                class NeverEmbed extends i.ContentObject {
                    constructor(e1){
                        super(c, "neverEmbed");
                    }
                }
                class NumberOfCopies extends i.IntegerObject {
                    constructor(e1){
                        super(c, "numberOfCopies", null, (e1)=>e1 >= 2 && e1 <= 5);
                    }
                }
                class OpenAction extends i.XFAObject {
                    constructor(e1){
                        super(c, "openAction", !0);
                        this.destination = null;
                    }
                }
                class Output extends i.XFAObject {
                    constructor(e1){
                        super(c, "output", !0);
                        this.to = null;
                        this.type = null;
                        this.uri = null;
                    }
                }
                class OutputBin extends i.StringObject {
                    constructor(e1){
                        super(c, "outputBin");
                    }
                }
                class OutputXSL extends i.XFAObject {
                    constructor(e1){
                        super(c, "outputXSL", !0);
                        this.uri = null;
                    }
                }
                class Overprint extends i.OptionObject {
                    constructor(e1){
                        super(c, "overprint", [
                            "none",
                            "both",
                            "draw",
                            "field"
                        ]);
                    }
                }
                class Packets extends i.StringObject {
                    constructor(e1){
                        super(c, "packets");
                    }
                    [n.$finalize]() {
                        "*" !== this[n.$content] && (this[n.$content] = this[n.$content].trim().split(/\s+/).filter((e1)=>[
                                "config",
                                "datasets",
                                "template",
                                "xfdf",
                                "xslt"
                            ].includes(e1)));
                    }
                }
                class PageOffset extends i.XFAObject {
                    constructor(e1){
                        super(c, "pageOffset");
                        this.x = (0, s.getInteger)({
                            data: e1.x,
                            defaultValue: "useXDCSetting",
                            validate: (e1)=>!0
                        });
                        this.y = (0, s.getInteger)({
                            data: e1.y,
                            defaultValue: "useXDCSetting",
                            validate: (e1)=>!0
                        });
                    }
                }
                class PageRange extends i.StringObject {
                    constructor(e1){
                        super(c, "pageRange");
                    }
                    [n.$finalize]() {
                        const e1 = this[n.$content].trim().split(/\s+/).map((e1)=>parseInt(e1, 10)), t = [];
                        for(let a = 0, r = e1.length; a < r; a += 2)t.push(e1.slice(a, a + 2));
                        this[n.$content] = t;
                    }
                }
                class Pagination extends i.OptionObject {
                    constructor(e1){
                        super(c, "pagination", [
                            "simplex",
                            "duplexShortEdge",
                            "duplexLongEdge"
                        ]);
                    }
                }
                class PaginationOverride extends i.OptionObject {
                    constructor(e1){
                        super(c, "paginationOverride", [
                            "none",
                            "forceDuplex",
                            "forceDuplexLongEdge",
                            "forceDuplexShortEdge",
                            "forceSimplex"
                        ]);
                    }
                }
                class Part extends i.IntegerObject {
                    constructor(e1){
                        super(c, "part", 1, (e1)=>!1);
                    }
                }
                class Pcl extends i.XFAObject {
                    constructor(e1){
                        super(c, "pcl", !0);
                        this.name = e1.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.pageOffset = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Pdf extends i.XFAObject {
                    constructor(e1){
                        super(c, "pdf", !0);
                        this.name = e1.name || "";
                        this.adobeExtensionLevel = null;
                        this.batchOutput = null;
                        this.compression = null;
                        this.creator = null;
                        this.encryption = null;
                        this.fontInfo = null;
                        this.interactive = null;
                        this.linearized = null;
                        this.openAction = null;
                        this.pdfa = null;
                        this.producer = null;
                        this.renderPolicy = null;
                        this.scriptModel = null;
                        this.silentPrint = null;
                        this.submitFormat = null;
                        this.tagged = null;
                        this.version = null;
                        this.viewerPreferences = null;
                        this.xdc = null;
                    }
                }
                class Pdfa extends i.XFAObject {
                    constructor(e1){
                        super(c, "pdfa", !0);
                        this.amd = null;
                        this.conformance = null;
                        this.includeXDPContent = null;
                        this.part = null;
                    }
                }
                class Permissions extends i.XFAObject {
                    constructor(e1){
                        super(c, "permissions", !0);
                        this.accessibleContent = null;
                        this.change = null;
                        this.contentCopy = null;
                        this.documentAssembly = null;
                        this.formFieldFilling = null;
                        this.modifyAnnots = null;
                        this.plaintextMetadata = null;
                        this.print = null;
                        this.printHighQuality = null;
                    }
                }
                class PickTrayByPDFSize extends i.Option01 {
                    constructor(e1){
                        super(c, "pickTrayByPDFSize");
                    }
                }
                class Picture extends i.StringObject {
                    constructor(e1){
                        super(c, "picture");
                    }
                }
                class PlaintextMetadata extends i.Option01 {
                    constructor(e1){
                        super(c, "plaintextMetadata");
                    }
                }
                class Presence extends i.OptionObject {
                    constructor(e1){
                        super(c, "presence", [
                            "preserve",
                            "dissolve",
                            "dissolveStructure",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class Present extends i.XFAObject {
                    constructor(e1){
                        super(c, "present", !0);
                        this.behaviorOverride = null;
                        this.cache = null;
                        this.common = null;
                        this.copies = null;
                        this.destination = null;
                        this.incrementalMerge = null;
                        this.layout = null;
                        this.output = null;
                        this.overprint = null;
                        this.pagination = null;
                        this.paginationOverride = null;
                        this.script = null;
                        this.validate = null;
                        this.xdp = null;
                        this.driver = new i.XFAObjectArray;
                        this.labelPrinter = new i.XFAObjectArray;
                        this.pcl = new i.XFAObjectArray;
                        this.pdf = new i.XFAObjectArray;
                        this.ps = new i.XFAObjectArray;
                        this.submitUrl = new i.XFAObjectArray;
                        this.webClient = new i.XFAObjectArray;
                        this.zpl = new i.XFAObjectArray;
                    }
                }
                class Print extends i.Option01 {
                    constructor(e1){
                        super(c, "print");
                    }
                }
                class PrintHighQuality extends i.Option01 {
                    constructor(e1){
                        super(c, "printHighQuality");
                    }
                }
                class PrintScaling extends i.OptionObject {
                    constructor(e1){
                        super(c, "printScaling", [
                            "appdefault",
                            "noScaling"
                        ]);
                    }
                }
                class PrinterName extends i.StringObject {
                    constructor(e1){
                        super(c, "printerName");
                    }
                }
                class Producer extends i.StringObject {
                    constructor(e1){
                        super(c, "producer");
                    }
                }
                class Ps extends i.XFAObject {
                    constructor(e1){
                        super(c, "ps", !0);
                        this.name = e1.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Range extends i.ContentObject {
                    constructor(e1){
                        super(c, "range");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim().split(/\s*,\s*/, 2).map((e1)=>e1.split("-").map((e1)=>parseInt(e1.trim(), 10))).filter((e1)=>e1.every((e1)=>!isNaN(e1))).map((e1)=>{
                            1 === e1.length && e1.push(e1[0]);
                            return e1;
                        });
                    }
                }
                class Record extends i.ContentObject {
                    constructor(e1){
                        super(c, "record");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim();
                        const e1 = parseInt(this[n.$content], 10);
                        !isNaN(e1) && e1 >= 0 && (this[n.$content] = e1);
                    }
                }
                class Relevant extends i.ContentObject {
                    constructor(e1){
                        super(c, "relevant");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim().split(/\s+/);
                    }
                }
                class Rename extends i.ContentObject {
                    constructor(e1){
                        super(c, "rename");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim();
                        (this[n.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[n.$content])) && (0, o.warn)("XFA - Rename: invalid XFA name");
                    }
                }
                class RenderPolicy extends i.OptionObject {
                    constructor(e1){
                        super(c, "renderPolicy", [
                            "server",
                            "client"
                        ]);
                    }
                }
                class RunScripts extends i.OptionObject {
                    constructor(e1){
                        super(c, "runScripts", [
                            "both",
                            "client",
                            "none",
                            "server"
                        ]);
                    }
                }
                class Script extends i.XFAObject {
                    constructor(e1){
                        super(c, "script", !0);
                        this.currentPage = null;
                        this.exclude = null;
                        this.runScripts = null;
                    }
                }
                class ScriptModel extends i.OptionObject {
                    constructor(e1){
                        super(c, "scriptModel", [
                            "XFA",
                            "none"
                        ]);
                    }
                }
                class Severity extends i.OptionObject {
                    constructor(e1){
                        super(c, "severity", [
                            "ignore",
                            "error",
                            "information",
                            "trace",
                            "warning"
                        ]);
                    }
                }
                class SilentPrint extends i.XFAObject {
                    constructor(e1){
                        super(c, "silentPrint", !0);
                        this.addSilentPrint = null;
                        this.printerName = null;
                    }
                }
                class Staple extends i.XFAObject {
                    constructor(e1){
                        super(c, "staple");
                        this.mode = (0, s.getStringOption)(e1.mode, [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class StartNode extends i.StringObject {
                    constructor(e1){
                        super(c, "startNode");
                    }
                }
                class StartPage extends i.IntegerObject {
                    constructor(e1){
                        super(c, "startPage", 0, (e1)=>!0);
                    }
                }
                class SubmitFormat extends i.OptionObject {
                    constructor(e1){
                        super(c, "submitFormat", [
                            "html",
                            "delegate",
                            "fdf",
                            "xml",
                            "pdf"
                        ]);
                    }
                }
                class SubmitUrl extends i.StringObject {
                    constructor(e1){
                        super(c, "submitUrl");
                    }
                }
                class SubsetBelow extends i.IntegerObject {
                    constructor(e1){
                        super(c, "subsetBelow", 100, (e1)=>e1 >= 0 && e1 <= 100);
                    }
                }
                class SuppressBanner extends i.Option01 {
                    constructor(e1){
                        super(c, "suppressBanner");
                    }
                }
                class Tagged extends i.Option01 {
                    constructor(e1){
                        super(c, "tagged");
                    }
                }
                class Template extends i.XFAObject {
                    constructor(e1){
                        super(c, "template", !0);
                        this.base = null;
                        this.relevant = null;
                        this.startPage = null;
                        this.uri = null;
                        this.xsl = null;
                    }
                }
                class Threshold extends i.OptionObject {
                    constructor(e1){
                        super(c, "threshold", [
                            "trace",
                            "error",
                            "information",
                            "warning"
                        ]);
                    }
                }
                class To extends i.OptionObject {
                    constructor(e1){
                        super(c, "to", [
                            "null",
                            "memory",
                            "stderr",
                            "stdout",
                            "system",
                            "uri"
                        ]);
                    }
                }
                class TemplateCache extends i.XFAObject {
                    constructor(e1){
                        super(c, "templateCache");
                        this.maxEntries = (0, s.getInteger)({
                            data: e1.maxEntries,
                            defaultValue: 5,
                            validate: (e1)=>e1 >= 0
                        });
                    }
                }
                class Trace extends i.XFAObject {
                    constructor(e1){
                        super(c, "trace", !0);
                        this.area = new i.XFAObjectArray;
                    }
                }
                class Transform extends i.XFAObject {
                    constructor(e1){
                        super(c, "transform", !0);
                        this.groupParent = null;
                        this.ifEmpty = null;
                        this.nameAttr = null;
                        this.picture = null;
                        this.presence = null;
                        this.rename = null;
                        this.whitespace = null;
                    }
                }
                class Type extends i.OptionObject {
                    constructor(e1){
                        super(c, "type", [
                            "none",
                            "ascii85",
                            "asciiHex",
                            "ccittfax",
                            "flate",
                            "lzw",
                            "runLength",
                            "native",
                            "xdp",
                            "mergedXDP"
                        ]);
                    }
                }
                class Uri extends i.StringObject {
                    constructor(e1){
                        super(c, "uri");
                    }
                }
                class Validate extends i.OptionObject {
                    constructor(e1){
                        super(c, "validate", [
                            "preSubmit",
                            "prePrint",
                            "preExecute",
                            "preSave"
                        ]);
                    }
                }
                class ValidateApprovalSignatures extends i.ContentObject {
                    constructor(e1){
                        super(c, "validateApprovalSignatures");
                    }
                    [n.$finalize]() {
                        this[n.$content] = this[n.$content].trim().split(/\s+/).filter((e1)=>[
                                "docReady",
                                "postSign"
                            ].includes(e1));
                    }
                }
                class ValidationMessaging extends i.OptionObject {
                    constructor(e1){
                        super(c, "validationMessaging", [
                            "allMessagesIndividually",
                            "allMessagesTogether",
                            "firstMessageOnly",
                            "noMessages"
                        ]);
                    }
                }
                class Version extends i.OptionObject {
                    constructor(e1){
                        super(c, "version", [
                            "1.7",
                            "1.6",
                            "1.5",
                            "1.4",
                            "1.3",
                            "1.2"
                        ]);
                    }
                }
                class VersionControl extends i.XFAObject {
                    constructor(e1){
                        super(c, "VersionControl");
                        this.outputBelow = (0, s.getStringOption)(e1.outputBelow, [
                            "warn",
                            "error",
                            "update"
                        ]);
                        this.sourceAbove = (0, s.getStringOption)(e1.sourceAbove, [
                            "warn",
                            "error"
                        ]);
                        this.sourceBelow = (0, s.getStringOption)(e1.sourceBelow, [
                            "update",
                            "maintain"
                        ]);
                    }
                }
                class ViewerPreferences extends i.XFAObject {
                    constructor(e1){
                        super(c, "viewerPreferences", !0);
                        this.ADBE_JSConsole = null;
                        this.ADBE_JSDebugger = null;
                        this.addViewerPreferences = null;
                        this.duplexOption = null;
                        this.enforce = null;
                        this.numberOfCopies = null;
                        this.pageRange = null;
                        this.pickTrayByPDFSize = null;
                        this.printScaling = null;
                    }
                }
                class WebClient extends i.XFAObject {
                    constructor(e1){
                        super(c, "webClient", !0);
                        this.name = e1.name ? e1.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Whitespace extends i.OptionObject {
                    constructor(e1){
                        super(c, "whitespace", [
                            "preserve",
                            "ltrim",
                            "normalize",
                            "rtrim",
                            "trim"
                        ]);
                    }
                }
                class Window extends i.ContentObject {
                    constructor(e1){
                        super(c, "window");
                    }
                    [n.$finalize]() {
                        const e1 = this[n.$content].trim().split(/\s*,\s*/, 2).map((e1)=>parseInt(e1, 10));
                        if (e1.some((e1)=>isNaN(e1))) this[n.$content] = [
                            0,
                            0
                        ];
                        else {
                            1 === e1.length && e1.push(e1[0]);
                            this[n.$content] = e1;
                        }
                    }
                }
                class Xdc extends i.XFAObject {
                    constructor(e1){
                        super(c, "xdc", !0);
                        this.uri = new i.XFAObjectArray;
                        this.xsl = new i.XFAObjectArray;
                    }
                }
                class Xdp extends i.XFAObject {
                    constructor(e1){
                        super(c, "xdp", !0);
                        this.packets = null;
                    }
                }
                class Xsl extends i.XFAObject {
                    constructor(e1){
                        super(c, "xsl", !0);
                        this.debug = null;
                        this.uri = null;
                    }
                }
                class Zpl extends i.XFAObject {
                    constructor(e1){
                        super(c, "zpl", !0);
                        this.name = e1.name ? e1.name.trim() : "";
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class ConfigNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (ConfigNamespace.hasOwnProperty(e1)) return ConfigNamespace[e1](t);
                    }
                    static acrobat(e1) {
                        return new Acrobat(e1);
                    }
                    static acrobat7(e1) {
                        return new Acrobat7(e1);
                    }
                    static ADBE_JSConsole(e1) {
                        return new ADBE_JSConsole(e1);
                    }
                    static ADBE_JSDebugger(e1) {
                        return new ADBE_JSDebugger(e1);
                    }
                    static addSilentPrint(e1) {
                        return new AddSilentPrint(e1);
                    }
                    static addViewerPreferences(e1) {
                        return new AddViewerPreferences(e1);
                    }
                    static adjustData(e1) {
                        return new AdjustData(e1);
                    }
                    static adobeExtensionLevel(e1) {
                        return new AdobeExtensionLevel(e1);
                    }
                    static agent(e1) {
                        return new Agent(e1);
                    }
                    static alwaysEmbed(e1) {
                        return new AlwaysEmbed(e1);
                    }
                    static amd(e1) {
                        return new Amd(e1);
                    }
                    static area(e1) {
                        return new Area(e1);
                    }
                    static attributes(e1) {
                        return new Attributes(e1);
                    }
                    static autoSave(e1) {
                        return new AutoSave(e1);
                    }
                    static base(e1) {
                        return new Base(e1);
                    }
                    static batchOutput(e1) {
                        return new BatchOutput(e1);
                    }
                    static behaviorOverride(e1) {
                        return new BehaviorOverride(e1);
                    }
                    static cache(e1) {
                        return new Cache(e1);
                    }
                    static change(e1) {
                        return new Change(e1);
                    }
                    static common(e1) {
                        return new Common(e1);
                    }
                    static compress(e1) {
                        return new Compress(e1);
                    }
                    static compressLogicalStructure(e1) {
                        return new CompressLogicalStructure(e1);
                    }
                    static compressObjectStream(e1) {
                        return new CompressObjectStream(e1);
                    }
                    static compression(e1) {
                        return new Compression(e1);
                    }
                    static config(e1) {
                        return new Config(e1);
                    }
                    static conformance(e1) {
                        return new Conformance(e1);
                    }
                    static contentCopy(e1) {
                        return new ContentCopy(e1);
                    }
                    static copies(e1) {
                        return new Copies(e1);
                    }
                    static creator(e1) {
                        return new Creator(e1);
                    }
                    static currentPage(e1) {
                        return new CurrentPage(e1);
                    }
                    static data(e1) {
                        return new Data(e1);
                    }
                    static debug(e1) {
                        return new Debug(e1);
                    }
                    static defaultTypeface(e1) {
                        return new DefaultTypeface(e1);
                    }
                    static destination(e1) {
                        return new Destination(e1);
                    }
                    static documentAssembly(e1) {
                        return new DocumentAssembly(e1);
                    }
                    static driver(e1) {
                        return new Driver(e1);
                    }
                    static duplexOption(e1) {
                        return new DuplexOption(e1);
                    }
                    static dynamicRender(e1) {
                        return new DynamicRender(e1);
                    }
                    static embed(e1) {
                        return new Embed(e1);
                    }
                    static encrypt(e1) {
                        return new Encrypt(e1);
                    }
                    static encryption(e1) {
                        return new Encryption(e1);
                    }
                    static encryptionLevel(e1) {
                        return new EncryptionLevel(e1);
                    }
                    static enforce(e1) {
                        return new Enforce(e1);
                    }
                    static equate(e1) {
                        return new Equate(e1);
                    }
                    static equateRange(e1) {
                        return new EquateRange(e1);
                    }
                    static exclude(e1) {
                        return new Exclude(e1);
                    }
                    static excludeNS(e1) {
                        return new ExcludeNS(e1);
                    }
                    static flipLabel(e1) {
                        return new FlipLabel(e1);
                    }
                    static fontInfo(e1) {
                        return new FontInfo(e1);
                    }
                    static formFieldFilling(e1) {
                        return new FormFieldFilling(e1);
                    }
                    static groupParent(e1) {
                        return new GroupParent(e1);
                    }
                    static ifEmpty(e1) {
                        return new IfEmpty(e1);
                    }
                    static includeXDPContent(e1) {
                        return new IncludeXDPContent(e1);
                    }
                    static incrementalLoad(e1) {
                        return new IncrementalLoad(e1);
                    }
                    static incrementalMerge(e1) {
                        return new IncrementalMerge(e1);
                    }
                    static interactive(e1) {
                        return new Interactive(e1);
                    }
                    static jog(e1) {
                        return new Jog(e1);
                    }
                    static labelPrinter(e1) {
                        return new LabelPrinter(e1);
                    }
                    static layout(e1) {
                        return new Layout(e1);
                    }
                    static level(e1) {
                        return new Level(e1);
                    }
                    static linearized(e1) {
                        return new Linearized(e1);
                    }
                    static locale(e1) {
                        return new Locale(e1);
                    }
                    static localeSet(e1) {
                        return new LocaleSet(e1);
                    }
                    static log(e1) {
                        return new Log(e1);
                    }
                    static map(e1) {
                        return new MapElement(e1);
                    }
                    static mediumInfo(e1) {
                        return new MediumInfo(e1);
                    }
                    static message(e1) {
                        return new Message(e1);
                    }
                    static messaging(e1) {
                        return new Messaging(e1);
                    }
                    static mode(e1) {
                        return new Mode(e1);
                    }
                    static modifyAnnots(e1) {
                        return new ModifyAnnots(e1);
                    }
                    static msgId(e1) {
                        return new MsgId(e1);
                    }
                    static nameAttr(e1) {
                        return new NameAttr(e1);
                    }
                    static neverEmbed(e1) {
                        return new NeverEmbed(e1);
                    }
                    static numberOfCopies(e1) {
                        return new NumberOfCopies(e1);
                    }
                    static openAction(e1) {
                        return new OpenAction(e1);
                    }
                    static output(e1) {
                        return new Output(e1);
                    }
                    static outputBin(e1) {
                        return new OutputBin(e1);
                    }
                    static outputXSL(e1) {
                        return new OutputXSL(e1);
                    }
                    static overprint(e1) {
                        return new Overprint(e1);
                    }
                    static packets(e1) {
                        return new Packets(e1);
                    }
                    static pageOffset(e1) {
                        return new PageOffset(e1);
                    }
                    static pageRange(e1) {
                        return new PageRange(e1);
                    }
                    static pagination(e1) {
                        return new Pagination(e1);
                    }
                    static paginationOverride(e1) {
                        return new PaginationOverride(e1);
                    }
                    static part(e1) {
                        return new Part(e1);
                    }
                    static pcl(e1) {
                        return new Pcl(e1);
                    }
                    static pdf(e1) {
                        return new Pdf(e1);
                    }
                    static pdfa(e1) {
                        return new Pdfa(e1);
                    }
                    static permissions(e1) {
                        return new Permissions(e1);
                    }
                    static pickTrayByPDFSize(e1) {
                        return new PickTrayByPDFSize(e1);
                    }
                    static picture(e1) {
                        return new Picture(e1);
                    }
                    static plaintextMetadata(e1) {
                        return new PlaintextMetadata(e1);
                    }
                    static presence(e1) {
                        return new Presence(e1);
                    }
                    static present(e1) {
                        return new Present(e1);
                    }
                    static print(e1) {
                        return new Print(e1);
                    }
                    static printHighQuality(e1) {
                        return new PrintHighQuality(e1);
                    }
                    static printScaling(e1) {
                        return new PrintScaling(e1);
                    }
                    static printerName(e1) {
                        return new PrinterName(e1);
                    }
                    static producer(e1) {
                        return new Producer(e1);
                    }
                    static ps(e1) {
                        return new Ps(e1);
                    }
                    static range(e1) {
                        return new Range(e1);
                    }
                    static record(e1) {
                        return new Record(e1);
                    }
                    static relevant(e1) {
                        return new Relevant(e1);
                    }
                    static rename(e1) {
                        return new Rename(e1);
                    }
                    static renderPolicy(e1) {
                        return new RenderPolicy(e1);
                    }
                    static runScripts(e1) {
                        return new RunScripts(e1);
                    }
                    static script(e1) {
                        return new Script(e1);
                    }
                    static scriptModel(e1) {
                        return new ScriptModel(e1);
                    }
                    static severity(e1) {
                        return new Severity(e1);
                    }
                    static silentPrint(e1) {
                        return new SilentPrint(e1);
                    }
                    static staple(e1) {
                        return new Staple(e1);
                    }
                    static startNode(e1) {
                        return new StartNode(e1);
                    }
                    static startPage(e1) {
                        return new StartPage(e1);
                    }
                    static submitFormat(e1) {
                        return new SubmitFormat(e1);
                    }
                    static submitUrl(e1) {
                        return new SubmitUrl(e1);
                    }
                    static subsetBelow(e1) {
                        return new SubsetBelow(e1);
                    }
                    static suppressBanner(e1) {
                        return new SuppressBanner(e1);
                    }
                    static tagged(e1) {
                        return new Tagged(e1);
                    }
                    static template(e1) {
                        return new Template(e1);
                    }
                    static templateCache(e1) {
                        return new TemplateCache(e1);
                    }
                    static threshold(e1) {
                        return new Threshold(e1);
                    }
                    static to(e1) {
                        return new To(e1);
                    }
                    static trace(e1) {
                        return new Trace(e1);
                    }
                    static transform(e1) {
                        return new Transform(e1);
                    }
                    static type(e1) {
                        return new Type(e1);
                    }
                    static uri(e1) {
                        return new Uri(e1);
                    }
                    static validate(e1) {
                        return new Validate(e1);
                    }
                    static validateApprovalSignatures(e1) {
                        return new ValidateApprovalSignatures(e1);
                    }
                    static validationMessaging(e1) {
                        return new ValidationMessaging(e1);
                    }
                    static version(e1) {
                        return new Version(e1);
                    }
                    static versionControl(e1) {
                        return new VersionControl(e1);
                    }
                    static viewerPreferences(e1) {
                        return new ViewerPreferences(e1);
                    }
                    static webClient(e1) {
                        return new WebClient(e1);
                    }
                    static whitespace(e1) {
                        return new Whitespace(e1);
                    }
                    static window(e1) {
                        return new Window(e1);
                    }
                    static xdc(e1) {
                        return new Xdc(e1);
                    }
                    static xdp(e1) {
                        return new Xdp(e1);
                    }
                    static xsl(e1) {
                        return new Xsl(e1);
                    }
                    static zpl(e1) {
                        return new Zpl(e1);
                    }
                }
                t.ConfigNamespace = ConfigNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.ConnectionSetNamespace = void 0;
                var r = a(81), n = a(87);
                const i = r.NamespaceIds.connectionSet.id;
                class ConnectionSet extends n.XFAObject {
                    constructor(e1){
                        super(i, "connectionSet", !0);
                        this.wsdlConnection = new n.XFAObjectArray;
                        this.xmlConnection = new n.XFAObjectArray;
                        this.xsdConnection = new n.XFAObjectArray;
                    }
                }
                class EffectiveInputPolicy extends n.XFAObject {
                    constructor(e1){
                        super(i, "effectiveInputPolicy");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class EffectiveOutputPolicy extends n.XFAObject {
                    constructor(e1){
                        super(i, "effectiveOutputPolicy");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Operation extends n.StringObject {
                    constructor(e1){
                        super(i, "operation");
                        this.id = e1.id || "";
                        this.input = e1.input || "";
                        this.name = e1.name || "";
                        this.output = e1.output || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class RootElement extends n.StringObject {
                    constructor(e1){
                        super(i, "rootElement");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class SoapAction extends n.StringObject {
                    constructor(e1){
                        super(i, "soapAction");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class SoapAddress extends n.StringObject {
                    constructor(e1){
                        super(i, "soapAddress");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class Uri extends n.StringObject {
                    constructor(e1){
                        super(i, "uri");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class WsdlAddress extends n.StringObject {
                    constructor(e1){
                        super(i, "wsdlAddress");
                        this.id = e1.id || "";
                        this.name = e1.name || "";
                        this.use = e1.use || "";
                        this.usehref = e1.usehref || "";
                    }
                }
                class WsdlConnection extends n.XFAObject {
                    constructor(e1){
                        super(i, "wsdlConnection", !0);
                        this.dataDescription = e1.dataDescription || "";
                        this.name = e1.name || "";
                        this.effectiveInputPolicy = null;
                        this.effectiveOutputPolicy = null;
                        this.operation = null;
                        this.soapAction = null;
                        this.soapAddress = null;
                        this.wsdlAddress = null;
                    }
                }
                class XmlConnection extends n.XFAObject {
                    constructor(e1){
                        super(i, "xmlConnection", !0);
                        this.dataDescription = e1.dataDescription || "";
                        this.name = e1.name || "";
                        this.uri = null;
                    }
                }
                class XsdConnection extends n.XFAObject {
                    constructor(e1){
                        super(i, "xsdConnection", !0);
                        this.dataDescription = e1.dataDescription || "";
                        this.name = e1.name || "";
                        this.rootElement = null;
                        this.uri = null;
                    }
                }
                class ConnectionSetNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (ConnectionSetNamespace.hasOwnProperty(e1)) return ConnectionSetNamespace[e1](t);
                    }
                    static connectionSet(e1) {
                        return new ConnectionSet(e1);
                    }
                    static effectiveInputPolicy(e1) {
                        return new EffectiveInputPolicy(e1);
                    }
                    static effectiveOutputPolicy(e1) {
                        return new EffectiveOutputPolicy(e1);
                    }
                    static operation(e1) {
                        return new Operation(e1);
                    }
                    static rootElement(e1) {
                        return new RootElement(e1);
                    }
                    static soapAction(e1) {
                        return new SoapAction(e1);
                    }
                    static soapAddress(e1) {
                        return new SoapAddress(e1);
                    }
                    static uri(e1) {
                        return new Uri(e1);
                    }
                    static wsdlAddress(e1) {
                        return new WsdlAddress(e1);
                    }
                    static wsdlConnection(e1) {
                        return new WsdlConnection(e1);
                    }
                    static xmlConnection(e1) {
                        return new XmlConnection(e1);
                    }
                    static xsdConnection(e1) {
                        return new XsdConnection(e1);
                    }
                }
                t.ConnectionSetNamespace = ConnectionSetNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.DatasetsNamespace = void 0;
                var r = a(78), n = a(81), i = a(87);
                const s = n.NamespaceIds.datasets.id;
                class Data extends i.XmlObject {
                    constructor(e1){
                        super(s, "data", e1);
                    }
                    [r.$isNsAgnostic]() {
                        return !0;
                    }
                }
                class Datasets extends i.XFAObject {
                    constructor(e1){
                        super(s, "datasets", !0);
                        this.data = null;
                        this.Signature = null;
                    }
                    [r.$onChild](e1) {
                        const t = e1[r.$nodeName];
                        ("data" === t && e1[r.$namespaceId] === s || "Signature" === t && e1[r.$namespaceId] === n.NamespaceIds.signature.id) && (this[t] = e1);
                        this[r.$appendChild](e1);
                    }
                }
                class DatasetsNamespace {
                    static [n.$buildXFAObject](e1, t) {
                        if (DatasetsNamespace.hasOwnProperty(e1)) return DatasetsNamespace[e1](t);
                    }
                    static datasets(e1) {
                        return new Datasets(e1);
                    }
                    static data(e1) {
                        return new Data(e1);
                    }
                }
                t.DatasetsNamespace = DatasetsNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.LocaleSetNamespace = void 0;
                var r = a(81), n = a(87), i = a(84);
                const s = r.NamespaceIds.localeSet.id;
                class CalendarSymbols extends n.XFAObject {
                    constructor(e1){
                        super(s, "calendarSymbols", !0);
                        this.name = "gregorian";
                        this.dayNames = new n.XFAObjectArray(2);
                        this.eraNames = null;
                        this.meridiemNames = null;
                        this.monthNames = new n.XFAObjectArray(2);
                    }
                }
                class CurrencySymbol extends n.StringObject {
                    constructor(e1){
                        super(s, "currencySymbol");
                        this.name = (0, i.getStringOption)(e1.name, [
                            "symbol",
                            "isoname",
                            "decimal"
                        ]);
                    }
                }
                class CurrencySymbols extends n.XFAObject {
                    constructor(e1){
                        super(s, "currencySymbols", !0);
                        this.currencySymbol = new n.XFAObjectArray(3);
                    }
                }
                class DatePattern extends n.StringObject {
                    constructor(e1){
                        super(s, "datePattern");
                        this.name = (0, i.getStringOption)(e1.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class DatePatterns extends n.XFAObject {
                    constructor(e1){
                        super(s, "datePatterns", !0);
                        this.datePattern = new n.XFAObjectArray(4);
                    }
                }
                class DateTimeSymbols extends n.ContentObject {
                    constructor(e1){
                        super(s, "dateTimeSymbols");
                    }
                }
                class Day extends n.StringObject {
                    constructor(e1){
                        super(s, "day");
                    }
                }
                class DayNames extends n.XFAObject {
                    constructor(e1){
                        super(s, "dayNames", !0);
                        this.abbr = (0, i.getInteger)({
                            data: e1.abbr,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.day = new n.XFAObjectArray(7);
                    }
                }
                class Era extends n.StringObject {
                    constructor(e1){
                        super(s, "era");
                    }
                }
                class EraNames extends n.XFAObject {
                    constructor(e1){
                        super(s, "eraNames", !0);
                        this.era = new n.XFAObjectArray(2);
                    }
                }
                class Locale extends n.XFAObject {
                    constructor(e1){
                        super(s, "locale", !0);
                        this.desc = e1.desc || "";
                        this.name = "isoname";
                        this.calendarSymbols = null;
                        this.currencySymbols = null;
                        this.datePatterns = null;
                        this.dateTimeSymbols = null;
                        this.numberPatterns = null;
                        this.numberSymbols = null;
                        this.timePatterns = null;
                        this.typeFaces = null;
                    }
                }
                class LocaleSet extends n.XFAObject {
                    constructor(e1){
                        super(s, "localeSet", !0);
                        this.locale = new n.XFAObjectArray;
                    }
                }
                class Meridiem extends n.StringObject {
                    constructor(e1){
                        super(s, "meridiem");
                    }
                }
                class MeridiemNames extends n.XFAObject {
                    constructor(e1){
                        super(s, "meridiemNames", !0);
                        this.meridiem = new n.XFAObjectArray(2);
                    }
                }
                class Month extends n.StringObject {
                    constructor(e1){
                        super(s, "month");
                    }
                }
                class MonthNames extends n.XFAObject {
                    constructor(e1){
                        super(s, "monthNames", !0);
                        this.abbr = (0, i.getInteger)({
                            data: e1.abbr,
                            defaultValue: 0,
                            validate: (e1)=>1 === e1
                        });
                        this.month = new n.XFAObjectArray(12);
                    }
                }
                class NumberPattern extends n.StringObject {
                    constructor(e1){
                        super(s, "numberPattern");
                        this.name = (0, i.getStringOption)(e1.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class NumberPatterns extends n.XFAObject {
                    constructor(e1){
                        super(s, "numberPatterns", !0);
                        this.numberPattern = new n.XFAObjectArray(4);
                    }
                }
                class NumberSymbol extends n.StringObject {
                    constructor(e1){
                        super(s, "numberSymbol");
                        this.name = (0, i.getStringOption)(e1.name, [
                            "decimal",
                            "grouping",
                            "percent",
                            "minus",
                            "zero"
                        ]);
                    }
                }
                class NumberSymbols extends n.XFAObject {
                    constructor(e1){
                        super(s, "numberSymbols", !0);
                        this.numberSymbol = new n.XFAObjectArray(5);
                    }
                }
                class TimePattern extends n.StringObject {
                    constructor(e1){
                        super(s, "timePattern");
                        this.name = (0, i.getStringOption)(e1.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class TimePatterns extends n.XFAObject {
                    constructor(e1){
                        super(s, "timePatterns", !0);
                        this.timePattern = new n.XFAObjectArray(4);
                    }
                }
                class TypeFace extends n.XFAObject {
                    constructor(e1){
                        super(s, "typeFace", !0);
                        this.name = "" | e1.name;
                    }
                }
                class TypeFaces extends n.XFAObject {
                    constructor(e1){
                        super(s, "typeFaces", !0);
                        this.typeFace = new n.XFAObjectArray;
                    }
                }
                class LocaleSetNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (LocaleSetNamespace.hasOwnProperty(e1)) return LocaleSetNamespace[e1](t);
                    }
                    static calendarSymbols(e1) {
                        return new CalendarSymbols(e1);
                    }
                    static currencySymbol(e1) {
                        return new CurrencySymbol(e1);
                    }
                    static currencySymbols(e1) {
                        return new CurrencySymbols(e1);
                    }
                    static datePattern(e1) {
                        return new DatePattern(e1);
                    }
                    static datePatterns(e1) {
                        return new DatePatterns(e1);
                    }
                    static dateTimeSymbols(e1) {
                        return new DateTimeSymbols(e1);
                    }
                    static day(e1) {
                        return new Day(e1);
                    }
                    static dayNames(e1) {
                        return new DayNames(e1);
                    }
                    static era(e1) {
                        return new Era(e1);
                    }
                    static eraNames(e1) {
                        return new EraNames(e1);
                    }
                    static locale(e1) {
                        return new Locale(e1);
                    }
                    static localeSet(e1) {
                        return new LocaleSet(e1);
                    }
                    static meridiem(e1) {
                        return new Meridiem(e1);
                    }
                    static meridiemNames(e1) {
                        return new MeridiemNames(e1);
                    }
                    static month(e1) {
                        return new Month(e1);
                    }
                    static monthNames(e1) {
                        return new MonthNames(e1);
                    }
                    static numberPattern(e1) {
                        return new NumberPattern(e1);
                    }
                    static numberPatterns(e1) {
                        return new NumberPatterns(e1);
                    }
                    static numberSymbol(e1) {
                        return new NumberSymbol(e1);
                    }
                    static numberSymbols(e1) {
                        return new NumberSymbols(e1);
                    }
                    static timePattern(e1) {
                        return new TimePattern(e1);
                    }
                    static timePatterns(e1) {
                        return new TimePatterns(e1);
                    }
                    static typeFace(e1) {
                        return new TypeFace(e1);
                    }
                    static typeFaces(e1) {
                        return new TypeFaces(e1);
                    }
                }
                t.LocaleSetNamespace = LocaleSetNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.SignatureNamespace = void 0;
                var r = a(81), n = a(87);
                const i = r.NamespaceIds.signature.id;
                class Signature extends n.XFAObject {
                    constructor(e1){
                        super(i, "signature", !0);
                    }
                }
                class SignatureNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (SignatureNamespace.hasOwnProperty(e1)) return SignatureNamespace[e1](t);
                    }
                    static signature(e1) {
                        return new Signature(e1);
                    }
                }
                t.SignatureNamespace = SignatureNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.StylesheetNamespace = void 0;
                var r = a(81), n = a(87);
                const i = r.NamespaceIds.stylesheet.id;
                class Stylesheet extends n.XFAObject {
                    constructor(e1){
                        super(i, "stylesheet", !0);
                    }
                }
                class StylesheetNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (StylesheetNamespace.hasOwnProperty(e1)) return StylesheetNamespace[e1](t);
                    }
                    static stylesheet(e1) {
                        return new Stylesheet(e1);
                    }
                }
                t.StylesheetNamespace = StylesheetNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XdpNamespace = void 0;
                var r = a(81), n = a(78), i = a(87);
                const s = r.NamespaceIds.xdp.id;
                class Xdp extends i.XFAObject {
                    constructor(e1){
                        super(s, "xdp", !0);
                        this.uuid = e1.uuid || "";
                        this.timeStamp = e1.timeStamp || "";
                        this.config = null;
                        this.connectionSet = null;
                        this.datasets = null;
                        this.localeSet = null;
                        this.stylesheet = new i.XFAObjectArray;
                        this.template = null;
                    }
                    [n.$onChildCheck](e1) {
                        const t = r.NamespaceIds[e1[n.$nodeName]];
                        return t && e1[n.$namespaceId] === t.id;
                    }
                }
                class XdpNamespace {
                    static [r.$buildXFAObject](e1, t) {
                        if (XdpNamespace.hasOwnProperty(e1)) return XdpNamespace[e1](t);
                    }
                    static xdp(e1) {
                        return new Xdp(e1);
                    }
                }
                t.XdpNamespace = XdpNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XhtmlNamespace = void 0;
                var r = a(78), n = a(81), i = a(83), s = a(84), o = a(87);
                const c = n.NamespaceIds.xhtml.id, l = Symbol(), h = new Set([
                    "color",
                    "font",
                    "font-family",
                    "font-size",
                    "font-stretch",
                    "font-style",
                    "font-weight",
                    "margin",
                    "margin-bottom",
                    "margin-left",
                    "margin-right",
                    "margin-top",
                    "letter-spacing",
                    "line-height",
                    "orphans",
                    "page-break-after",
                    "page-break-before",
                    "page-break-inside",
                    "tab-interval",
                    "tab-stop",
                    "text-align",
                    "text-decoration",
                    "text-indent",
                    "vertical-align",
                    "widows",
                    "kerning-mode",
                    "xfa-font-horizontal-scale",
                    "xfa-font-vertical-scale",
                    "xfa-spacerun",
                    "xfa-tab-stops"
                ]), u = new Map([
                    [
                        "page-break-after",
                        "breakAfter"
                    ],
                    [
                        "page-break-before",
                        "breakBefore"
                    ],
                    [
                        "page-break-inside",
                        "breakInside"
                    ],
                    [
                        "kerning-mode",
                        (e1)=>"none" === e1 ? "none" : "normal"
                    ],
                    [
                        "xfa-font-horizontal-scale",
                        (e1)=>`scaleX(${Math.max(0, Math.min(parseInt(e1) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-font-vertical-scale",
                        (e1)=>`scaleY(${Math.max(0, Math.min(parseInt(e1) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-spacerun",
                        ""
                    ],
                    [
                        "xfa-tab-stops",
                        ""
                    ],
                    [
                        "font-size",
                        (e1, t)=>{
                            e1 = t.fontSize = (0, s.getMeasurement)(e1);
                            return (0, i.measureToString)(.99 * e1);
                        }
                    ],
                    [
                        "letter-spacing",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "line-height",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "margin",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "margin-bottom",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "margin-left",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "margin-right",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "margin-top",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "text-indent",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ],
                    [
                        "font-family",
                        (e1)=>e1
                    ],
                    [
                        "vertical-align",
                        (e1)=>(0, i.measureToString)((0, s.getMeasurement)(e1))
                    ]
                ]), d = /\s+/g, f = /[\r\n]+/g, g = /\r\n?/g;
                function mapStyle(e1, t, a) {
                    const n = Object.create(null);
                    if (!e1) return n;
                    const o = Object.create(null);
                    for (const [t, a] of e1.split(";").map((e1)=>e1.split(":", 2))){
                        const e1 = u.get(t);
                        if ("" === e1) continue;
                        let r = a;
                        e1 && (r = "string" == typeof e1 ? e1 : e1(a, o));
                        t.endsWith("scale") ? n.transform = n.transform ? `${n[t]} ${r}` : r : n[t.replaceAll(/-([a-zA-Z])/g, (e1, t)=>t.toUpperCase())] = r;
                    }
                    n.fontFamily && (0, i.setFontFamily)({
                        typeface: n.fontFamily,
                        weight: n.fontWeight || "normal",
                        posture: n.fontStyle || "normal",
                        size: o.fontSize || 0
                    }, t, t[r.$globalData].fontFinder, n);
                    if (a && n.verticalAlign && "0px" !== n.verticalAlign && n.fontSize) {
                        const e1 = .583, t = .333, a = (0, s.getMeasurement)(n.fontSize);
                        n.fontSize = (0, i.measureToString)(a * e1);
                        n.verticalAlign = (0, i.measureToString)(Math.sign((0, s.getMeasurement)(n.verticalAlign)) * a * t);
                    }
                    a && n.fontSize && (n.fontSize = `calc(${n.fontSize} * var(--scale-factor))`);
                    (0, i.fixTextIndent)(n);
                    return n;
                }
                const p = new Set([
                    "body",
                    "html"
                ]);
                class XhtmlObject extends o.XmlObject {
                    constructor(e1, t){
                        super(c, t);
                        this[l] = !1;
                        this.style = e1.style || "";
                    }
                    [r.$clean](e1) {
                        super[r.$clean](e1);
                        this.style = function checkStyle(e1) {
                            return e1.style ? e1.style.trim().split(/\s*;\s*/).filter((e1)=>!!e1).map((e1)=>e1.split(/\s*:\s*/, 2)).filter(([t, a])=>{
                                "font-family" === t && e1[r.$globalData].usedTypefaces.add(a);
                                return h.has(t);
                            }).map((e1)=>e1.join(":")).join(";") : "";
                        }(this);
                    }
                    [r.$acceptWhitespace]() {
                        return !p.has(this[r.$nodeName]);
                    }
                    [r.$onText](e1, t = !1) {
                        if (t) this[l] = !0;
                        else {
                            e1 = e1.replaceAll(f, "");
                            this.style.includes("xfa-spacerun:yes") || (e1 = e1.replaceAll(d, " "));
                        }
                        e1 && (this[r.$content] += e1);
                    }
                    [r.$pushGlyphs](e1, t = !0) {
                        const a = Object.create(null), n = {
                            top: NaN,
                            bottom: NaN,
                            left: NaN,
                            right: NaN
                        };
                        let i = null;
                        for (const [e1, t] of this.style.split(";").map((e1)=>e1.split(":", 2)))switch(e1){
                            case "font-family":
                                a.typeface = (0, s.stripQuotes)(t);
                                break;
                            case "font-size":
                                a.size = (0, s.getMeasurement)(t);
                                break;
                            case "font-weight":
                                a.weight = t;
                                break;
                            case "font-style":
                                a.posture = t;
                                break;
                            case "letter-spacing":
                                a.letterSpacing = (0, s.getMeasurement)(t);
                                break;
                            case "margin":
                                const e2 = t.split(/ \t/).map((e1)=>(0, s.getMeasurement)(e1));
                                switch(e2.length){
                                    case 1:
                                        n.top = n.bottom = n.left = n.right = e2[0];
                                        break;
                                    case 2:
                                        n.top = n.bottom = e2[0];
                                        n.left = n.right = e2[1];
                                        break;
                                    case 3:
                                        n.top = e2[0];
                                        n.bottom = e2[2];
                                        n.left = n.right = e2[1];
                                        break;
                                    case 4:
                                        n.top = e2[0];
                                        n.left = e2[1];
                                        n.bottom = e2[2];
                                        n.right = e2[3];
                                }
                                break;
                            case "margin-top":
                                n.top = (0, s.getMeasurement)(t);
                                break;
                            case "margin-bottom":
                                n.bottom = (0, s.getMeasurement)(t);
                                break;
                            case "margin-left":
                                n.left = (0, s.getMeasurement)(t);
                                break;
                            case "margin-right":
                                n.right = (0, s.getMeasurement)(t);
                                break;
                            case "line-height":
                                i = (0, s.getMeasurement)(t);
                        }
                        e1.pushData(a, n, i);
                        if (this[r.$content]) e1.addString(this[r.$content]);
                        else for (const t of this[r.$getChildren]())"#text" !== t[r.$nodeName] ? t[r.$pushGlyphs](e1) : e1.addString(t[r.$content]);
                        t && e1.popFont();
                    }
                    [r.$toHTML](e1) {
                        const t = [];
                        this[r.$extra] = {
                            children: t
                        };
                        this[r.$childrenToHTML]({});
                        if (0 === t.length && !this[r.$content]) return s.HTMLResult.EMPTY;
                        let a;
                        a = this[l] ? this[r.$content] ? this[r.$content].replaceAll(g, "\n") : void 0 : this[r.$content] || void 0;
                        return s.HTMLResult.success({
                            name: this[r.$nodeName],
                            attributes: {
                                href: this.href,
                                style: mapStyle(this.style, this, this[l])
                            },
                            children: t,
                            value: a
                        });
                    }
                }
                class A extends XhtmlObject {
                    constructor(e1){
                        super(e1, "a");
                        this.href = (0, i.fixURL)(e1.href) || "";
                    }
                }
                class B extends XhtmlObject {
                    constructor(e1){
                        super(e1, "b");
                    }
                    [r.$pushGlyphs](e1) {
                        e1.pushFont({
                            weight: "bold"
                        });
                        super[r.$pushGlyphs](e1);
                        e1.popFont();
                    }
                }
                class Body extends XhtmlObject {
                    constructor(e1){
                        super(e1, "body");
                    }
                    [r.$toHTML](e1) {
                        const t = super[r.$toHTML](e1), { html: a } = t;
                        if (!a) return s.HTMLResult.EMPTY;
                        a.name = "div";
                        a.attributes.class = [
                            "xfaRich"
                        ];
                        return t;
                    }
                }
                class Br extends XhtmlObject {
                    constructor(e1){
                        super(e1, "br");
                    }
                    [r.$text]() {
                        return "\n";
                    }
                    [r.$pushGlyphs](e1) {
                        e1.addString("\n");
                    }
                    [r.$toHTML](e1) {
                        return s.HTMLResult.success({
                            name: "br"
                        });
                    }
                }
                class Html extends XhtmlObject {
                    constructor(e1){
                        super(e1, "html");
                    }
                    [r.$toHTML](e1) {
                        const t = [];
                        this[r.$extra] = {
                            children: t
                        };
                        this[r.$childrenToHTML]({});
                        if (0 === t.length) return s.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            value: this[r.$content] || ""
                        });
                        if (1 === t.length) {
                            const e1 = t[0];
                            if (e1.attributes?.class.includes("xfaRich")) return s.HTMLResult.success(e1);
                        }
                        return s.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            children: t
                        });
                    }
                }
                class I extends XhtmlObject {
                    constructor(e1){
                        super(e1, "i");
                    }
                    [r.$pushGlyphs](e1) {
                        e1.pushFont({
                            posture: "italic"
                        });
                        super[r.$pushGlyphs](e1);
                        e1.popFont();
                    }
                }
                class Li extends XhtmlObject {
                    constructor(e1){
                        super(e1, "li");
                    }
                }
                class Ol extends XhtmlObject {
                    constructor(e1){
                        super(e1, "ol");
                    }
                }
                class P extends XhtmlObject {
                    constructor(e1){
                        super(e1, "p");
                    }
                    [r.$pushGlyphs](e1) {
                        super[r.$pushGlyphs](e1, !1);
                        e1.addString("\n");
                        e1.addPara();
                        e1.popFont();
                    }
                    [r.$text]() {
                        return this[r.$getParent]()[r.$getChildren]().at(-1) === this ? super[r.$text]() : super[r.$text]() + "\n";
                    }
                }
                class Span extends XhtmlObject {
                    constructor(e1){
                        super(e1, "span");
                    }
                }
                class Sub extends XhtmlObject {
                    constructor(e1){
                        super(e1, "sub");
                    }
                }
                class Sup extends XhtmlObject {
                    constructor(e1){
                        super(e1, "sup");
                    }
                }
                class Ul extends XhtmlObject {
                    constructor(e1){
                        super(e1, "ul");
                    }
                }
                class XhtmlNamespace {
                    static [n.$buildXFAObject](e1, t) {
                        if (XhtmlNamespace.hasOwnProperty(e1)) return XhtmlNamespace[e1](t);
                    }
                    static a(e1) {
                        return new A(e1);
                    }
                    static b(e1) {
                        return new B(e1);
                    }
                    static body(e1) {
                        return new Body(e1);
                    }
                    static br(e1) {
                        return new Br(e1);
                    }
                    static html(e1) {
                        return new Html(e1);
                    }
                    static i(e1) {
                        return new I(e1);
                    }
                    static li(e1) {
                        return new Li(e1);
                    }
                    static ol(e1) {
                        return new Ol(e1);
                    }
                    static p(e1) {
                        return new P(e1);
                    }
                    static span(e1) {
                        return new Span(e1);
                    }
                    static sub(e1) {
                        return new Sub(e1);
                    }
                    static sup(e1) {
                        return new Sup(e1);
                    }
                    static ul(e1) {
                        return new Ul(e1);
                    }
                }
                t.XhtmlNamespace = XhtmlNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.UnknownNamespace = void 0;
                var r = a(81), n = a(87);
                class UnknownNamespace {
                    constructor(e1){
                        this.namespaceId = e1;
                    }
                    [r.$buildXFAObject](e1, t) {
                        return new n.XmlObject(this.namespaceId, e1, t);
                    }
                }
                t.UnknownNamespace = UnknownNamespace;
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.DatasetReader = void 0;
                var r = a(2), n = a(3), i = a(71);
                function decodeString(e1) {
                    try {
                        return (0, r.stringToUTF8String)(e1);
                    } catch (t) {
                        (0, r.warn)(`UTF-8 decoding failed: "${t}".`);
                        return e1;
                    }
                }
                class DatasetXMLParser extends i.SimpleXMLParser {
                    constructor(e1){
                        super(e1);
                        this.node = null;
                    }
                    onEndElement(e1) {
                        const t = super.onEndElement(e1);
                        if (t && "xfa:datasets" === e1) {
                            this.node = t;
                            throw new Error("Aborting DatasetXMLParser.");
                        }
                    }
                }
                t.DatasetReader = class DatasetReader {
                    constructor(e1){
                        if (e1.datasets) this.node = new i.SimpleXMLParser({
                            hasAttributes: !0
                        }).parseFromString(e1.datasets).documentElement;
                        else {
                            const t = new DatasetXMLParser({
                                hasAttributes: !0
                            });
                            try {
                                t.parseFromString(e1["xdp:xdp"]);
                            } catch  {}
                            this.node = t.node;
                        }
                    }
                    getValue(e1) {
                        if (!this.node || !e1) return "";
                        const t = this.node.searchNode((0, n.parseXFAPath)(e1), 0);
                        if (!t) return "";
                        const a = t.firstChild;
                        return "value" === a?.nodeName ? t.children.map((e1)=>decodeString(e1.textContent)) : decodeString(t.textContent);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.XRef = void 0;
                var r = a(2), n = a(4), i = a(16), s = a(3), o = a(5), c = a(74);
                t.XRef = class XRef {
                    #B = null;
                    constructor(e1, t){
                        this.stream = e1;
                        this.pdfManager = t;
                        this.entries = [];
                        this._xrefStms = new Set;
                        this._cacheMap = new Map;
                        this._pendingRefs = new n.RefSet;
                        this._newPersistentRefNum = null;
                        this._newTemporaryRefNum = null;
                    }
                    getNewPersistentRef(e1) {
                        null === this._newPersistentRefNum && (this._newPersistentRefNum = this.entries.length || 1);
                        const t = this._newPersistentRefNum++;
                        this._cacheMap.set(t, e1);
                        return n.Ref.get(t, 0);
                    }
                    getNewTemporaryRef() {
                        null === this._newTemporaryRefNum && (this._newTemporaryRefNum = this.entries.length || 1);
                        return n.Ref.get(this._newTemporaryRefNum++, 0);
                    }
                    resetNewTemporaryRef() {
                        this._newTemporaryRefNum = null;
                    }
                    setStartXRef(e1) {
                        this.startXRefQueue = [
                            e1
                        ];
                    }
                    parse(e1 = !1) {
                        let t, a, i;
                        if (e1) {
                            (0, r.warn)("Indexing all PDF objects");
                            t = this.indexObjects();
                        } else t = this.readXRef();
                        t.assignXref(this);
                        this.trailer = t;
                        try {
                            a = t.get("Encrypt");
                        } catch (e1) {
                            if (e1 instanceof s.MissingDataException) throw e1;
                            (0, r.warn)(`XRef.parse - Invalid "Encrypt" reference: "${e1}".`);
                        }
                        if (a instanceof n.Dict) {
                            const e1 = t.get("ID"), r = e1?.length ? e1[0] : "";
                            a.suppressEncryption = !0;
                            this.encrypt = new c.CipherTransformFactory(a, r, this.pdfManager.password);
                        }
                        try {
                            i = t.get("Root");
                        } catch (e1) {
                            if (e1 instanceof s.MissingDataException) throw e1;
                            (0, r.warn)(`XRef.parse - Invalid "Root" reference: "${e1}".`);
                        }
                        if (i instanceof n.Dict) try {
                            if (i.get("Pages") instanceof n.Dict) {
                                this.root = i;
                                return;
                            }
                        } catch (e1) {
                            if (e1 instanceof s.MissingDataException) throw e1;
                            (0, r.warn)(`XRef.parse - Invalid "Pages" reference: "${e1}".`);
                        }
                        if (!e1) throw new s.XRefParseException;
                        throw new r.InvalidPDFException("Invalid Root reference.");
                    }
                    processXRefTable(e1) {
                        "tableState" in this || (this.tableState = {
                            entryNum: 0,
                            streamPos: e1.lexer.stream.pos,
                            parserBuf1: e1.buf1,
                            parserBuf2: e1.buf2
                        });
                        const t = this.readXRefTable(e1);
                        if (!(0, n.isCmd)(t, "trailer")) throw new r.FormatError("Invalid XRef table: could not find trailer dictionary");
                        let a = e1.getObj();
                        a instanceof n.Dict || !a.dict || (a = a.dict);
                        if (!(a instanceof n.Dict)) throw new r.FormatError("Invalid XRef table: could not parse trailer dictionary");
                        delete this.tableState;
                        return a;
                    }
                    readXRefTable(e1) {
                        const t = e1.lexer.stream, a = this.tableState;
                        t.pos = a.streamPos;
                        e1.buf1 = a.parserBuf1;
                        e1.buf2 = a.parserBuf2;
                        let i;
                        for(;;){
                            if (!("firstEntryNum" in a) || !("entryCount" in a)) {
                                if ((0, n.isCmd)(i = e1.getObj(), "trailer")) break;
                                a.firstEntryNum = i;
                                a.entryCount = e1.getObj();
                            }
                            let s = a.firstEntryNum;
                            const o = a.entryCount;
                            if (!Number.isInteger(s) || !Number.isInteger(o)) throw new r.FormatError("Invalid XRef table: wrong types in subsection header");
                            for(let i = a.entryNum; i < o; i++){
                                a.streamPos = t.pos;
                                a.entryNum = i;
                                a.parserBuf1 = e1.buf1;
                                a.parserBuf2 = e1.buf2;
                                const c = {};
                                c.offset = e1.getObj();
                                c.gen = e1.getObj();
                                const l = e1.getObj();
                                if (l instanceof n.Cmd) switch(l.cmd){
                                    case "f":
                                        c.free = !0;
                                        break;
                                    case "n":
                                        c.uncompressed = !0;
                                }
                                if (!Number.isInteger(c.offset) || !Number.isInteger(c.gen) || !c.free && !c.uncompressed) throw new r.FormatError(`Invalid entry in XRef subsection: ${s}, ${o}`);
                                0 === i && c.free && 1 === s && (s = 0);
                                this.entries[i + s] || (this.entries[i + s] = c);
                            }
                            a.entryNum = 0;
                            a.streamPos = t.pos;
                            a.parserBuf1 = e1.buf1;
                            a.parserBuf2 = e1.buf2;
                            delete a.firstEntryNum;
                            delete a.entryCount;
                        }
                        if (this.entries[0] && !this.entries[0].free) throw new r.FormatError("Invalid XRef table: unexpected first object");
                        return i;
                    }
                    processXRefStream(e1) {
                        if (!("streamState" in this)) {
                            const t = e1.dict, a = t.get("W");
                            let r = t.get("Index");
                            r || (r = [
                                0,
                                t.get("Size")
                            ]);
                            this.streamState = {
                                entryRanges: r,
                                byteWidths: a,
                                entryNum: 0,
                                streamPos: e1.pos
                            };
                        }
                        this.readXRefStream(e1);
                        delete this.streamState;
                        return e1.dict;
                    }
                    readXRefStream(e1) {
                        const t = this.streamState;
                        e1.pos = t.streamPos;
                        const [a, n, i] = t.byteWidths, s = t.entryRanges;
                        for(; s.length > 0;){
                            const [o, c] = s;
                            if (!Number.isInteger(o) || !Number.isInteger(c)) throw new r.FormatError(`Invalid XRef range fields: ${o}, ${c}`);
                            if (!Number.isInteger(a) || !Number.isInteger(n) || !Number.isInteger(i)) throw new r.FormatError(`Invalid XRef entry fields length: ${o}, ${c}`);
                            for(let s = t.entryNum; s < c; ++s){
                                t.entryNum = s;
                                t.streamPos = e1.pos;
                                let c = 0, l = 0, h = 0;
                                for(let t = 0; t < a; ++t){
                                    const t = e1.getByte();
                                    if (-1 === t) throw new r.FormatError("Invalid XRef byteWidths 'type'.");
                                    c = c << 8 | t;
                                }
                                0 === a && (c = 1);
                                for(let t = 0; t < n; ++t){
                                    const t = e1.getByte();
                                    if (-1 === t) throw new r.FormatError("Invalid XRef byteWidths 'offset'.");
                                    l = l << 8 | t;
                                }
                                for(let t = 0; t < i; ++t){
                                    const t = e1.getByte();
                                    if (-1 === t) throw new r.FormatError("Invalid XRef byteWidths 'generation'.");
                                    h = h << 8 | t;
                                }
                                const u = {};
                                u.offset = l;
                                u.gen = h;
                                switch(c){
                                    case 0:
                                        u.free = !0;
                                        break;
                                    case 1:
                                        u.uncompressed = !0;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new r.FormatError(`Invalid XRef entry type: ${c}`);
                                }
                                this.entries[o + s] || (this.entries[o + s] = u);
                            }
                            t.entryNum = 0;
                            t.streamPos = e1.pos;
                            s.splice(0, 2);
                        }
                    }
                    indexObjects() {
                        function readToken(e1, t) {
                            let a = "", r = e1[t];
                            for(; 10 !== r && 13 !== r && 60 !== r && !(++t >= e1.length);){
                                a += String.fromCharCode(r);
                                r = e1[t];
                            }
                            return a;
                        }
                        function skipUntil(e1, t, a) {
                            const r = a.length, n = e1.length;
                            let i = 0;
                            for(; t < n;){
                                let n = 0;
                                for(; n < r && e1[t + n] === a[n];)++n;
                                if (n >= r) break;
                                t++;
                                i++;
                            }
                            return i;
                        }
                        const e1 = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g, t = /\b(startxref|\d+\s+\d+\s+obj)\b/g, a = /^(\d+)\s+(\d+)\s+obj\b/, o = new Uint8Array([
                            116,
                            114,
                            97,
                            105,
                            108,
                            101,
                            114
                        ]), c = new Uint8Array([
                            115,
                            116,
                            97,
                            114,
                            116,
                            120,
                            114,
                            101,
                            102
                        ]), l = new Uint8Array([
                            47,
                            88,
                            82,
                            101,
                            102
                        ]);
                        this.entries.length = 0;
                        this._cacheMap.clear();
                        const h = this.stream;
                        h.pos = 0;
                        const u = h.getBytes(), d = (0, r.bytesToString)(u), f = u.length;
                        let g = h.start;
                        const p = [], m = [];
                        for(; g < f;){
                            let n = u[g];
                            if (9 === n || 10 === n || 13 === n || 32 === n) {
                                ++g;
                                continue;
                            }
                            if (37 === n) {
                                do {
                                    ++g;
                                    if (g >= f) break;
                                    n = u[g];
                                }while (10 !== n && 13 !== n);
                                continue;
                            }
                            const b = readToken(u, g);
                            let y;
                            if (b.startsWith("xref") && (4 === b.length || /\s/.test(b[4]))) {
                                g += skipUntil(u, g, o);
                                p.push(g);
                                g += skipUntil(u, g, c);
                            } else if (y = a.exec(b)) {
                                const t = 0 | y[1], a = 0 | y[2], n = g + b.length;
                                let o, c = !1;
                                if (this.entries[t]) {
                                    if (this.entries[t].gen === a) try {
                                        new i.Parser({
                                            lexer: new i.Lexer(h.makeSubStream(n))
                                        }).getObj();
                                        c = !0;
                                    } catch (e1) {
                                        e1 instanceof s.ParserEOFException ? (0, r.warn)(`indexObjects -- checking object (${b}): "${e1}".`) : c = !0;
                                    }
                                } else c = !0;
                                c && (this.entries[t] = {
                                    offset: g - h.start,
                                    gen: a,
                                    uncompressed: !0
                                });
                                e1.lastIndex = n;
                                const p = e1.exec(d);
                                if (p) {
                                    o = e1.lastIndex + 1 - g;
                                    if ("endobj" !== p[1]) {
                                        (0, r.warn)(`indexObjects: Found "${p[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`);
                                        o -= p[1].length + 1;
                                    }
                                } else o = f - g;
                                const w = u.subarray(g, g + o), S = skipUntil(w, 0, l);
                                if (S < o && w[S + 5] < 64) {
                                    m.push(g - h.start);
                                    this._xrefStms.add(g - h.start);
                                }
                                g += o;
                            } else if (b.startsWith("trailer") && (7 === b.length || /\s/.test(b[7]))) {
                                p.push(g);
                                const e1 = g + b.length;
                                let a;
                                t.lastIndex = e1;
                                const n = t.exec(d);
                                if (n) {
                                    a = t.lastIndex + 1 - g;
                                    if ("startxref" !== n[1]) {
                                        (0, r.warn)(`indexObjects: Found "${n[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`);
                                        a -= n[1].length + 1;
                                    }
                                } else a = f - g;
                                g += a;
                            } else g += b.length + 1;
                        }
                        for (const e1 of m){
                            this.startXRefQueue.push(e1);
                            this.readXRef(!0);
                        }
                        const b = [];
                        let y, w, S = !1;
                        for (const e1 of p){
                            h.pos = e1;
                            const t = new i.Parser({
                                lexer: new i.Lexer(h),
                                xref: this,
                                allowStreams: !0,
                                recoveryMode: !0
                            }), a = t.getObj();
                            if (!(0, n.isCmd)(a, "trailer")) continue;
                            const r = t.getObj();
                            if (r instanceof n.Dict) {
                                b.push(r);
                                r.has("Encrypt") && (S = !0);
                            }
                        }
                        for (const e1 of [
                            ...b,
                            "genFallback",
                            ...b
                        ]){
                            if ("genFallback" === e1) {
                                if (!w) break;
                                this._generationFallback = !0;
                                continue;
                            }
                            let t = !1;
                            try {
                                const a = e1.get("Root");
                                if (!(a instanceof n.Dict)) continue;
                                const r = a.get("Pages");
                                if (!(r instanceof n.Dict)) continue;
                                const i = r.get("Count");
                                Number.isInteger(i) && (t = !0);
                            } catch (e1) {
                                w = e1;
                                continue;
                            }
                            if (t && (!S || e1.has("Encrypt")) && e1.has("ID")) return e1;
                            y = e1;
                        }
                        if (y) return y;
                        if (this.topDict) return this.topDict;
                        throw new r.InvalidPDFException("Invalid PDF structure.");
                    }
                    readXRef(e1 = !1) {
                        const t = this.stream, a = new Set;
                        for(; this.startXRefQueue.length;){
                            try {
                                const e1 = this.startXRefQueue[0];
                                if (a.has(e1)) {
                                    (0, r.warn)("readXRef - skipping XRef table since it was already parsed.");
                                    this.startXRefQueue.shift();
                                    continue;
                                }
                                a.add(e1);
                                t.pos = e1 + t.start;
                                const s = new i.Parser({
                                    lexer: new i.Lexer(t),
                                    xref: this,
                                    allowStreams: !0
                                });
                                let c, l = s.getObj();
                                if ((0, n.isCmd)(l, "xref")) {
                                    c = this.processXRefTable(s);
                                    this.topDict || (this.topDict = c);
                                    l = c.get("XRefStm");
                                    if (Number.isInteger(l) && !this._xrefStms.has(l)) {
                                        this._xrefStms.add(l);
                                        this.startXRefQueue.push(l);
                                        this.#B ??= l;
                                    }
                                } else {
                                    if (!Number.isInteger(l)) throw new r.FormatError("Invalid XRef stream header");
                                    if (!(Number.isInteger(s.getObj()) && (0, n.isCmd)(s.getObj(), "obj") && (l = s.getObj()) instanceof o.BaseStream)) throw new r.FormatError("Invalid XRef stream");
                                    c = this.processXRefStream(l);
                                    this.topDict || (this.topDict = c);
                                    if (!c) throw new r.FormatError("Failed to read XRef stream");
                                }
                                l = c.get("Prev");
                                Number.isInteger(l) ? this.startXRefQueue.push(l) : l instanceof n.Ref && this.startXRefQueue.push(l.num);
                            } catch (e1) {
                                if (e1 instanceof s.MissingDataException) throw e1;
                                (0, r.info)("(while reading XRef): " + e1);
                            }
                            this.startXRefQueue.shift();
                        }
                        if (this.topDict) return this.topDict;
                        if (!e1) throw new s.XRefParseException;
                    }
                    get lastXRefStreamPos() {
                        return this.#B ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
                    }
                    getEntry(e1) {
                        const t = this.entries[e1];
                        return t && !t.free && t.offset ? t : null;
                    }
                    fetchIfRef(e1, t = !1) {
                        return e1 instanceof n.Ref ? this.fetch(e1, t) : e1;
                    }
                    fetch(e1, t = !1) {
                        if (!(e1 instanceof n.Ref)) throw new Error("ref object is not a reference");
                        const a = e1.num, i = this._cacheMap.get(a);
                        if (void 0 !== i) {
                            i instanceof n.Dict && !i.objId && (i.objId = e1.toString());
                            return i;
                        }
                        let s = this.getEntry(a);
                        if (null === s) {
                            this._cacheMap.set(a, s);
                            return s;
                        }
                        if (this._pendingRefs.has(e1)) {
                            this._pendingRefs.remove(e1);
                            (0, r.warn)(`Ignoring circular reference: ${e1}.`);
                            return n.CIRCULAR_REF;
                        }
                        this._pendingRefs.put(e1);
                        try {
                            s = s.uncompressed ? this.fetchUncompressed(e1, s, t) : this.fetchCompressed(e1, s, t);
                            this._pendingRefs.remove(e1);
                        } catch (t) {
                            this._pendingRefs.remove(e1);
                            throw t;
                        }
                        s instanceof n.Dict ? s.objId = e1.toString() : s instanceof o.BaseStream && (s.dict.objId = e1.toString());
                        return s;
                    }
                    fetchUncompressed(e1, t, a = !1) {
                        const c = e1.gen;
                        let l = e1.num;
                        if (t.gen !== c) {
                            const i = `Inconsistent generation in XRef: ${e1}`;
                            if (this._generationFallback && t.gen < c) {
                                (0, r.warn)(i);
                                return this.fetchUncompressed(n.Ref.get(l, t.gen), t, a);
                            }
                            throw new s.XRefEntryException(i);
                        }
                        const h = this.stream.makeSubStream(t.offset + this.stream.start), u = new i.Parser({
                            lexer: new i.Lexer(h),
                            xref: this,
                            allowStreams: !0
                        }), d = u.getObj(), f = u.getObj(), g = u.getObj();
                        if (d !== l || f !== c || !(g instanceof n.Cmd)) throw new s.XRefEntryException(`Bad (uncompressed) XRef entry: ${e1}`);
                        if ("obj" !== g.cmd) {
                            if (g.cmd.startsWith("obj")) {
                                l = parseInt(g.cmd.substring(3), 10);
                                if (!Number.isNaN(l)) return l;
                            }
                            throw new s.XRefEntryException(`Bad (uncompressed) XRef entry: ${e1}`);
                        }
                        (t = this.encrypt && !a ? u.getObj(this.encrypt.createCipherTransform(l, c)) : u.getObj()) instanceof o.BaseStream || this._cacheMap.set(l, t);
                        return t;
                    }
                    fetchCompressed(e1, t, a = !1) {
                        const c = t.offset, l = this.fetch(n.Ref.get(c, 0));
                        if (!(l instanceof o.BaseStream)) throw new r.FormatError("bad ObjStm stream");
                        const h = l.dict.get("First"), u = l.dict.get("N");
                        if (!Number.isInteger(h) || !Number.isInteger(u)) throw new r.FormatError("invalid first and n parameters for ObjStm stream");
                        let d = new i.Parser({
                            lexer: new i.Lexer(l),
                            xref: this,
                            allowStreams: !0
                        });
                        const f = new Array(u), g = new Array(u);
                        for(let e1 = 0; e1 < u; ++e1){
                            const t = d.getObj();
                            if (!Number.isInteger(t)) throw new r.FormatError(`invalid object number in the ObjStm stream: ${t}`);
                            const a = d.getObj();
                            if (!Number.isInteger(a)) throw new r.FormatError(`invalid object offset in the ObjStm stream: ${a}`);
                            f[e1] = t;
                            g[e1] = a;
                        }
                        const p = (l.start || 0) + h, m = new Array(u);
                        for(let e1 = 0; e1 < u; ++e1){
                            const t = e1 < u - 1 ? g[e1 + 1] - g[e1] : void 0;
                            if (t < 0) throw new r.FormatError("Invalid offset in the ObjStm stream.");
                            d = new i.Parser({
                                lexer: new i.Lexer(l.makeSubStream(p + g[e1], t, l.dict)),
                                xref: this,
                                allowStreams: !0
                            });
                            const a = d.getObj();
                            m[e1] = a;
                            if (a instanceof o.BaseStream) continue;
                            const n = f[e1], s = this.entries[n];
                            s && s.offset === c && s.gen === e1 && this._cacheMap.set(n, a);
                        }
                        if (void 0 === (t = m[t.gen])) throw new s.XRefEntryException(`Bad (compressed) XRef entry: ${e1}`);
                        return t;
                    }
                    async fetchIfRefAsync(e1, t) {
                        return e1 instanceof n.Ref ? this.fetchAsync(e1, t) : e1;
                    }
                    async fetchAsync(e1, t) {
                        try {
                            return this.fetch(e1, t);
                        } catch (a) {
                            if (!(a instanceof s.MissingDataException)) throw a;
                            await this.pdfManager.requestRange(a.begin, a.end);
                            return this.fetchAsync(e1, t);
                        }
                    }
                    getCatalogObj() {
                        return this.root;
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.MessageHandler = void 0;
                var r = a(2);
                const n = 1, i = 2, s = 1, o = 2, c = 3, l = 4, h = 5, u = 6, d = 7, f = 8;
                function wrapReason(e1) {
                    e1 instanceof Error || "object" == typeof e1 && null !== e1 || (0, r.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(e1.name){
                        case "AbortException":
                            return new r.AbortException(e1.message);
                        case "MissingPDFException":
                            return new r.MissingPDFException(e1.message);
                        case "PasswordException":
                            return new r.PasswordException(e1.message, e1.code);
                        case "UnexpectedResponseException":
                            return new r.UnexpectedResponseException(e1.message, e1.status);
                        case "UnknownErrorException":
                            return new r.UnknownErrorException(e1.message, e1.details);
                        default:
                            return new r.UnknownErrorException(e1.message, e1.toString());
                    }
                }
                t.MessageHandler = class MessageHandler {
                    constructor(e1, t, a){
                        this.sourceName = e1;
                        this.targetName = t;
                        this.comObj = a;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (e1)=>{
                            const t = e1.data;
                            if (t.targetName !== this.sourceName) return;
                            if (t.stream) {
                                this.#E(t);
                                return;
                            }
                            if (t.callback) {
                                const e1 = t.callbackId, a = this.callbackCapabilities[e1];
                                if (!a) throw new Error(`Cannot resolve callback ${e1}`);
                                delete this.callbackCapabilities[e1];
                                if (t.callback === n) a.resolve(t.data);
                                else {
                                    if (t.callback !== i) throw new Error("Unexpected callback case");
                                    a.reject(wrapReason(t.reason));
                                }
                                return;
                            }
                            const r = this.actionHandler[t.action];
                            if (!r) throw new Error(`Unknown action from worker: ${t.action}`);
                            if (t.callbackId) {
                                const e1 = this.sourceName, s = t.sourceName;
                                new Promise(function(e1) {
                                    e1(r(t.data));
                                }).then(function(r) {
                                    a.postMessage({
                                        sourceName: e1,
                                        targetName: s,
                                        callback: n,
                                        callbackId: t.callbackId,
                                        data: r
                                    });
                                }, function(r) {
                                    a.postMessage({
                                        sourceName: e1,
                                        targetName: s,
                                        callback: i,
                                        callbackId: t.callbackId,
                                        reason: wrapReason(r)
                                    });
                                });
                            } else t.streamId ? this.#N(t) : r(t.data);
                        };
                        a.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(e1, t) {
                        const a = this.actionHandler;
                        if (a[e1]) throw new Error(`There is already an actionName called "${e1}"`);
                        a[e1] = t;
                    }
                    send(e1, t, a) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: e1,
                            data: t
                        }, a);
                    }
                    sendWithPromise(e1, t, a) {
                        const n = this.callbackId++, i = new r.PromiseCapability;
                        this.callbackCapabilities[n] = i;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: e1,
                                callbackId: n,
                                data: t
                            }, a);
                        } catch (e1) {
                            i.reject(e1);
                        }
                        return i.promise;
                    }
                    sendWithStream(e1, t, a, n) {
                        const i = this.streamId++, o = this.sourceName, c = this.targetName, l = this.comObj;
                        return new ReadableStream({
                            start: (a)=>{
                                const s = new r.PromiseCapability;
                                this.streamControllers[i] = {
                                    controller: a,
                                    startCall: s,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: !1
                                };
                                l.postMessage({
                                    sourceName: o,
                                    targetName: c,
                                    action: e1,
                                    streamId: i,
                                    data: t,
                                    desiredSize: a.desiredSize
                                }, n);
                                return s.promise;
                            },
                            pull: (e1)=>{
                                const t = new r.PromiseCapability;
                                this.streamControllers[i].pullCall = t;
                                l.postMessage({
                                    sourceName: o,
                                    targetName: c,
                                    stream: u,
                                    streamId: i,
                                    desiredSize: e1.desiredSize
                                });
                                return t.promise;
                            },
                            cancel: (e1)=>{
                                (0, r.assert)(e1 instanceof Error, "cancel must have a valid reason");
                                const t = new r.PromiseCapability;
                                this.streamControllers[i].cancelCall = t;
                                this.streamControllers[i].isClosed = !0;
                                l.postMessage({
                                    sourceName: o,
                                    targetName: c,
                                    stream: s,
                                    streamId: i,
                                    reason: wrapReason(e1)
                                });
                                return t.promise;
                            }
                        }, a);
                    }
                    #N(e1) {
                        const t = e1.streamId, a = this.sourceName, n = e1.sourceName, i = this.comObj, s = this, o = this.actionHandler[e1.action], u = {
                            enqueue (e1, s = 1, o) {
                                if (this.isCancelled) return;
                                const c = this.desiredSize;
                                this.desiredSize -= s;
                                if (c > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new r.PromiseCapability;
                                    this.ready = this.sinkCapability.promise;
                                }
                                i.postMessage({
                                    sourceName: a,
                                    targetName: n,
                                    stream: l,
                                    streamId: t,
                                    chunk: e1
                                }, o);
                            },
                            close () {
                                if (!this.isCancelled) {
                                    this.isCancelled = !0;
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: c,
                                        streamId: t
                                    });
                                    delete s.streamSinks[t];
                                }
                            },
                            error (e1) {
                                (0, r.assert)(e1 instanceof Error, "error must have a valid reason");
                                if (!this.isCancelled) {
                                    this.isCancelled = !0;
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: h,
                                        streamId: t,
                                        reason: wrapReason(e1)
                                    });
                                }
                            },
                            sinkCapability: new r.PromiseCapability,
                            onPull: null,
                            onCancel: null,
                            isCancelled: !1,
                            desiredSize: e1.desiredSize,
                            ready: null
                        };
                        u.sinkCapability.resolve();
                        u.ready = u.sinkCapability.promise;
                        this.streamSinks[t] = u;
                        new Promise(function(t) {
                            t(o(e1.data, u));
                        }).then(function() {
                            i.postMessage({
                                sourceName: a,
                                targetName: n,
                                stream: f,
                                streamId: t,
                                success: !0
                            });
                        }, function(e1) {
                            i.postMessage({
                                sourceName: a,
                                targetName: n,
                                stream: f,
                                streamId: t,
                                reason: wrapReason(e1)
                            });
                        });
                    }
                    #E(e1) {
                        const t = e1.streamId, a = this.sourceName, n = e1.sourceName, i = this.comObj, g = this.streamControllers[t], p = this.streamSinks[t];
                        switch(e1.stream){
                            case f:
                                e1.success ? g.startCall.resolve() : g.startCall.reject(wrapReason(e1.reason));
                                break;
                            case d:
                                e1.success ? g.pullCall.resolve() : g.pullCall.reject(wrapReason(e1.reason));
                                break;
                            case u:
                                if (!p) {
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: d,
                                        streamId: t,
                                        success: !0
                                    });
                                    break;
                                }
                                p.desiredSize <= 0 && e1.desiredSize > 0 && p.sinkCapability.resolve();
                                p.desiredSize = e1.desiredSize;
                                new Promise(function(e1) {
                                    e1(p.onPull?.());
                                }).then(function() {
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: d,
                                        streamId: t,
                                        success: !0
                                    });
                                }, function(e1) {
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: d,
                                        streamId: t,
                                        reason: wrapReason(e1)
                                    });
                                });
                                break;
                            case l:
                                (0, r.assert)(g, "enqueue should have stream controller");
                                if (g.isClosed) break;
                                g.controller.enqueue(e1.chunk);
                                break;
                            case c:
                                (0, r.assert)(g, "close should have stream controller");
                                if (g.isClosed) break;
                                g.isClosed = !0;
                                g.controller.close();
                                this.#R(g, t);
                                break;
                            case h:
                                (0, r.assert)(g, "error should have stream controller");
                                g.controller.error(wrapReason(e1.reason));
                                this.#R(g, t);
                                break;
                            case o:
                                e1.success ? g.cancelCall.resolve() : g.cancelCall.reject(wrapReason(e1.reason));
                                this.#R(g, t);
                                break;
                            case s:
                                if (!p) break;
                                new Promise(function(t) {
                                    t(p.onCancel?.(wrapReason(e1.reason)));
                                }).then(function() {
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: o,
                                        streamId: t,
                                        success: !0
                                    });
                                }, function(e1) {
                                    i.postMessage({
                                        sourceName: a,
                                        targetName: n,
                                        stream: o,
                                        streamId: t,
                                        reason: wrapReason(e1)
                                    });
                                });
                                p.sinkCapability.reject(wrapReason(e1.reason));
                                p.isCancelled = !0;
                                delete this.streamSinks[t];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #R(e1, t) {
                        await Promise.allSettled([
                            e1.startCall?.promise,
                            e1.pullCall?.promise,
                            e1.cancelCall?.promise
                        ]);
                        delete this.streamControllers[t];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                };
            },
            (e1, t, a)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.PDFWorkerStream = void 0;
                var r = a(2);
                t.PDFWorkerStream = class PDFWorkerStream {
                    constructor(e1){
                        this._msgHandler = e1;
                        this._contentLength = null;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    getFullReader() {
                        (0, r.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
                        return this._fullRequestReader;
                    }
                    getRangeReader(e1, t) {
                        const a = new PDFWorkerStreamRangeReader(e1, t, this._msgHandler);
                        this._rangeRequestReaders.push(a);
                        return a;
                    }
                    cancelAllRequests(e1) {
                        this._fullRequestReader?.cancel(e1);
                        for (const t of this._rangeRequestReaders.slice(0))t.cancel(e1);
                    }
                };
                class PDFWorkerStreamReader {
                    constructor(e1){
                        this._msgHandler = e1;
                        this.onProgress = null;
                        this._contentLength = null;
                        this._isRangeSupported = !1;
                        this._isStreamingSupported = !1;
                        const t = this._msgHandler.sendWithStream("GetReader");
                        this._reader = t.getReader();
                        this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((e1)=>{
                            this._isStreamingSupported = e1.isStreamingSupported;
                            this._isRangeSupported = e1.isRangeSupported;
                            this._contentLength = e1.contentLength;
                        });
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    async read() {
                        const { value: e1, done: t } = await this._reader.read();
                        return t ? {
                            value: void 0,
                            done: !0
                        } : {
                            value: e1.buffer,
                            done: !1
                        };
                    }
                    cancel(e1) {
                        this._reader.cancel(e1);
                    }
                }
                class PDFWorkerStreamRangeReader {
                    constructor(e1, t, a){
                        this._msgHandler = a;
                        this.onProgress = null;
                        const r = this._msgHandler.sendWithStream("GetRangeReader", {
                            begin: e1,
                            end: t
                        });
                        this._reader = r.getReader();
                    }
                    get isStreamingSupported() {
                        return !1;
                    }
                    async read() {
                        const { value: e1, done: t } = await this._reader.read();
                        return t ? {
                            value: void 0,
                            done: !0
                        } : {
                            value: e1.buffer,
                            done: !1
                        };
                    }
                    cancel(e1) {
                        this._reader.cancel(e1);
                    }
                }
            }
        ], t = {};
        function __w_pdfjs_require__(a) {
            var r = t[a];
            if (void 0 !== r) return r.exports;
            var n = t[a] = {
                exports: {}
            };
            e1[a](n, n.exports, __w_pdfjs_require__);
            return n.exports;
        }
        var a = {};
        (()=>{
            var e1 = a;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            Object.defineProperty(e1, "WorkerMessageHandler", {
                enumerable: !0,
                get: function() {
                    return t.WorkerMessageHandler;
                }
            });
            var t = __w_pdfjs_require__(1);
        })();
        return a;
    })());


const $4f64efc931dd8bad$export$8b92e12bd79dd0e2 = "transcribe";
const $4f64efc931dd8bad$export$af2ee85df7d23f58 = 40;
const $4f64efc931dd8bad$export$71c0c000641dcc6 = "ectd.scannedPageMode";
const $4f64efc931dd8bad$export$69cb6a4560bd4248 = "google/gemini-3.8-flash";
const $4f64efc931dd8bad$export$5e393f6caa70b25f = `Check if data provided in those files match requirements of parts specified in the specification document. Assume each file contains only part of the specification, try to match the input document to only this part of specification. Return output in a structured format with those sections (each heading as a h3): "Errors", "Missing Data", "Warnings", "Summary". Translate the Summary to English, Hungarian and Polish. Make the whole Error section use red font when errors are present. Use a very simple HTML formatting for the output. Ommit html, head, body tags, the output will be added to already existing HTML document.`;
const $4f64efc931dd8bad$export$6b93ff19e2337f2e = `The source document below is a set of PDF files that together form one eCTD section group (e.g. all subsections of 3.2.S.4 for one manufacturer). Each file is marked with "=== File:" and the eCTD subsection it was matched to. Check if the data provided in these files together match the requirements of the corresponding parts of the specification document. For each listed subsection, check the matching file(s) against only that part of the specification. Explicitly confirm which subsections are covered and point out subsections listed as missing. Return output in a structured format with those sections (each heading as a h3): "Errors", "Missing Data", "Warnings", "Summary". Translate the Summary to English, Hungarian and Polish. Make the whole Error section use red font when errors are present. Use a very simple HTML formatting for the output. Ommit html, head, body tags, the output will be added to already existing HTML document.`;
const $4f64efc931dd8bad$export$fc1aa2344d32ca66 = "You are a meticulous expert assistant. When answering, use only the information provided in the PDF excerpts unless the user clearly asks for general knowledge. If addresses and companies names are present in the document check them with the general knowledge.";
function $4f64efc931dd8bad$export$716ace1f00a73e4() {
    try {
        if (typeof localStorage === "undefined") return $4f64efc931dd8bad$export$8b92e12bd79dd0e2;
        const raw = localStorage.getItem($4f64efc931dd8bad$export$71c0c000641dcc6);
        if (raw === "attach-images" || raw === "transcribe") return raw;
    } catch (_) {
    // ignore storage errors (private mode, SSR)
    }
    return $4f64efc931dd8bad$export$8b92e12bd79dd0e2;
}
function $4f64efc931dd8bad$export$661ad4e3c111b5db(mode) {
    try {
        if (typeof localStorage === "undefined") return;
        localStorage.setItem($4f64efc931dd8bad$export$71c0c000641dcc6, mode);
    } catch (_) {
    // ignore
    }
}
function $4f64efc931dd8bad$export$a2f20583c0ab6bca(model) {
    if (!model) return true; // default analysis model is vision-capable
    const m = model.toLowerCase();
    return m.includes("gpt-4o") || m.includes("gpt-5") || m.includes("gemini") || m.includes("claude") || m.includes("grok") || m.includes("qwen") || m.includes("vision") || m.includes("vl-");
}
function $4f64efc931dd8bad$export$ff49557cb47721b9(basePrompt, sourceDocument, reference, maxChars) {
    const header = basePrompt.trim();
    const ectdParts = [];
    if (sourceDocument.ectdKey) ectdParts.push(`parent key: '${sourceDocument.ectdKey}'`);
    if (sourceDocument.ectdTitle) ectdParts.push(`title: '${sourceDocument.ectdTitle}'`);
    const leafInfoLine = ectdParts.length > 0 ? `\nSource document eCTD info: ${ectdParts.join(", ")}` : "";
    let combined = `${header}\n\nSource document PDF excerpts:\n\nSource document file name: '${sourceDocument.fileName}'${leafInfoLine}\n\nSource document text: '${sourceDocument.text}'\n\nReference document text: '${reference.text}' `;
    let truncated = !!sourceDocument.inputTruncated;
    if (combined.length > maxChars) {
        combined = `${combined.slice(0, maxChars)}\n\n[Truncated due to input length]`;
        truncated = true;
    }
    const { images: images } = sourceDocument;
    if (!images || images.length === 0) return {
        content: combined,
        truncated: truncated
    };
    const parts = [
        {
            type: "text",
            text: combined
        }
    ];
    images.forEach((img)=>{
        parts.push({
            type: "text",
            text: `\nAttached page image: ${img.label}`
        });
        parts.push({
            type: "image_url",
            image_url: {
                url: img.dataUrl
            }
        });
    });
    return {
        content: parts,
        truncated: truncated
    };
}


/**
 * Classify a PDF page as real digital text vs a scanned (image) page using
 * text-quality signals from getTextContent() and image-dominance signals from
 * getOperatorList(). No vision call is needed.
 */ /** pdf.js OPS names we care about (string form; numeric OPS also accepted). */ const $1ebb10e84a1dd185$var$IMAGE_OPS = new Set([
    "paintImageXObject",
    "paintInlineImageXObject",
    "paintJpegXObject",
    // Numeric OPS values from pdf.js (stable across recent versions)
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93
]);
const $1ebb10e84a1dd185$var$TEXT_OPS = new Set([
    "showText",
    "showSpacedText",
    "nextLineShowText",
    "nextLineSetSpacingShowText",
    // Numeric OPS
    44,
    45,
    46,
    47
]);
function $1ebb10e84a1dd185$export$f4959bb542efe05a(items) {
    const strs = items.map((item)=>typeof item.str === "string" ? item.str : "").filter((s)=>s.length > 0);
    const joined = strs.join("");
    const rawChars = joined.replace(/\s/g, "").length;
    const wordMatches = joined.match(/[A-Za-z]{3,}|[0-9]{2,}/g) || [];
    const wordCount = wordMatches.length;
    const itemCount = strs.length;
    const avgItemLen = itemCount === 0 ? 0 : strs.reduce((sum, s)=>sum + s.length, 0) / itemCount;
    return {
        rawChars: rawChars,
        wordCount: wordCount,
        avgItemLen: avgItemLen,
        itemCount: itemCount
    };
}
function $1ebb10e84a1dd185$export$f363750ff3158218(quality) {
    return quality.rawChars >= 80 && quality.wordCount >= 8 && quality.avgItemLen >= 3;
}
function $1ebb10e84a1dd185$export$da863b287780d33a(quality) {
    return quality.rawChars >= 250 && quality.wordCount >= 30 && quality.avgItemLen >= 3;
}
function $1ebb10e84a1dd185$export$c5ab3edd89ea78d0(operatorList) {
    const fnArray = operatorList?.fnArray || [];
    let imageOps = 0;
    let textOps = 0;
    fnArray.forEach((fn)=>{
        if ($1ebb10e84a1dd185$var$IMAGE_OPS.has(fn)) imageOps += 1;
        else if ($1ebb10e84a1dd185$var$TEXT_OPS.has(fn)) textOps += 1;
    });
    return {
        imageOps: imageOps,
        textOps: textOps,
        totalOps: fnArray.length
    };
}
function $1ebb10e84a1dd185$export$9d6ad6c0635af158(counts) {
    if (counts.imageOps < 1) return false;
    return counts.imageOps >= counts.textOps || counts.textOps === 0;
}
function $1ebb10e84a1dd185$export$c30d47578143443a(quality, counts) {
    return !$1ebb10e84a1dd185$export$f363750ff3158218(quality) && counts.imageOps === 0 && counts.totalOps < 8 && quality.rawChars < 20;
}
function $1ebb10e84a1dd185$export$2ebb97ff70d5ae3a(textItems, operatorList) {
    const quality = $1ebb10e84a1dd185$export$f4959bb542efe05a(textItems);
    if ($1ebb10e84a1dd185$export$da863b287780d33a(quality)) return "text";
    const counts = $1ebb10e84a1dd185$export$c5ab3edd89ea78d0(operatorList);
    if ($1ebb10e84a1dd185$export$f363750ff3158218(quality) && !$1ebb10e84a1dd185$export$9d6ad6c0635af158(counts)) return "text";
    return "scanned";
}


/**
 * Render a PDF page to a JPEG data URL and optionally transcribe it with a
 * vision LLM via OpenRouter.
 */ 


let $23a5f004ceaf672a$var$cachedOpenRouterApiKey = null;
let $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise = null;
let $23a5f004ceaf672a$var$cachedOpenRouterApiKeyFetchedAtMs = 0;
const $23a5f004ceaf672a$var$OPENROUTER_API_KEY_TTL_MS = 3300000; // backend issues ~1h keys; refresh a bit earlier
const $23a5f004ceaf672a$var$OPENROUTER_CHAT_URL = "https://openrouter.ai/api/v1/chat/completions";
const $23a5f004ceaf672a$var$OPENROUTER_MAX_ATTEMPTS = 5;
const $23a5f004ceaf672a$var$OPENROUTER_BACKOFF_CAP_MS = 15000;
const $23a5f004ceaf672a$var$RETRYABLE_HTTP_STATUSES = new Set([
    429,
    500,
    502,
    503,
    504
]);
const $23a5f004ceaf672a$var$RETRYABLE_AXIOS_CODES = new Set([
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK"
]);
function $23a5f004ceaf672a$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $23a5f004ceaf672a$var$asRecord(value) {
    if (value && typeof value === "object") return value;
    return null;
}
function $23a5f004ceaf672a$var$isAxiosLikeError(err) {
    if (!err || typeof err !== "object") return false;
    const record = err;
    return "response" in record || "config" in record || "request" in record || typeof record.code === "string";
}
function $23a5f004ceaf672a$var$readErrorCode(body) {
    const root = $23a5f004ceaf672a$var$asRecord(body);
    const error = $23a5f004ceaf672a$var$asRecord(root?.error);
    const code = error?.code;
    if (typeof code === "number" && Number.isFinite(code)) return code;
    if (typeof code === "string" && /^\d+$/.test(code)) return Number(code);
    return null;
}
function $23a5f004ceaf672a$var$isRetryableOpenRouterError(err) {
    if (!$23a5f004ceaf672a$var$isAxiosLikeError(err)) return false;
    if (err.code && $23a5f004ceaf672a$var$RETRYABLE_AXIOS_CODES.has(err.code)) return true;
    const status = err.response?.status;
    if (typeof status === "number" && $23a5f004ceaf672a$var$RETRYABLE_HTTP_STATUSES.has(status)) return true;
    const bodyCode = $23a5f004ceaf672a$var$readErrorCode(err.response?.data);
    if (bodyCode != null && $23a5f004ceaf672a$var$RETRYABLE_HTTP_STATUSES.has(bodyCode)) return true;
    return false;
}
function $23a5f004ceaf672a$var$getRetryDelayMs(err, attemptNum) {
    if ($23a5f004ceaf672a$var$isAxiosLikeError(err)) {
        const header = err.response?.headers?.["retry-after"];
        let raw;
        if (typeof header === "string") raw = header;
        else if (Array.isArray(header)) {
            const [first] = header;
            raw = first;
        }
        if (raw) {
            const asSeconds = Number(raw);
            if (Number.isFinite(asSeconds) && asSeconds >= 0) return Math.min(asSeconds * 1000, $23a5f004ceaf672a$var$OPENROUTER_BACKOFF_CAP_MS);
        }
    }
    const exponential = 1000 * 2 ** (attemptNum - 1);
    return Math.min(exponential, $23a5f004ceaf672a$var$OPENROUTER_BACKOFF_CAP_MS);
}
async function $23a5f004ceaf672a$var$withOpenRouterRetry(operation) {
    let lastError;
    for(let attempt = 1; attempt <= $23a5f004ceaf672a$var$OPENROUTER_MAX_ATTEMPTS; attempt += 1)try {
        // Sequential attempts are required for backoff-based retries.
        // eslint-disable-next-line no-await-in-loop
        return await operation();
    } catch (err) {
        lastError = err;
        const canRetry = attempt < $23a5f004ceaf672a$var$OPENROUTER_MAX_ATTEMPTS && $23a5f004ceaf672a$var$isRetryableOpenRouterError(err);
        if (!canRetry) throw err;
        const delayMs = $23a5f004ceaf672a$var$getRetryDelayMs(err, attempt);
        // eslint-disable-next-line no-console
        console.warn(`OpenRouter request failed (attempt ${attempt}/${$23a5f004ceaf672a$var$OPENROUTER_MAX_ATTEMPTS}), retrying in ${delayMs}ms\u{2026}`, err);
        // Wait before the next attempt so retries are spaced out.
        // eslint-disable-next-line no-await-in-loop
        await $23a5f004ceaf672a$var$sleep(delayMs);
    }
    throw lastError;
}
async function $23a5f004ceaf672a$var$getOpenRouterApiKeyFromBackend(authToken) {
    if ($23a5f004ceaf672a$var$cachedOpenRouterApiKey && Date.now() - $23a5f004ceaf672a$var$cachedOpenRouterApiKeyFetchedAtMs < $23a5f004ceaf672a$var$OPENROUTER_API_KEY_TTL_MS) return $23a5f004ceaf672a$var$cachedOpenRouterApiKey;
    if ($23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise) return $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise;
    $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise = (async ()=>{
        const host = "https://dev.leadernaplatform.com";
        if (!host) throw new Error("HOST env var is required to call backend GraphQL");
        const query = `
          query GetOpenRouterApiKey {
            GetOpenRouterApiKey
          }
        `;
        const { data: data } = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(`${host}/graphql`, {
            query: query
        }, {
            headers: {
                "Content-Type": "application/json",
                ...authToken ? {
                    Authorization: `Bearer ${authToken}`
                } : {}
            },
            timeout: 15000
        });
        const apiKey = data?.data?.GetOpenRouterApiKey;
        if (!apiKey || typeof apiKey !== "string") {
            const message = data?.errors?.[0]?.message || "Failed to obtain OpenRouter API key from backend";
            throw new Error(message);
        }
        $23a5f004ceaf672a$var$cachedOpenRouterApiKey = apiKey;
        $23a5f004ceaf672a$var$cachedOpenRouterApiKeyFetchedAtMs = Date.now();
        $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise = null;
        return apiKey;
    })().catch((err)=>{
        $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise = null;
        throw err;
    });
    return $23a5f004ceaf672a$var$cachedOpenRouterApiKeyPromise;
}
async function $23a5f004ceaf672a$export$5ef9f428f5bcf99d(sourceDocument, reference, options = {}) {
    const apiKey = await $23a5f004ceaf672a$var$getOpenRouterApiKeyFromBackend(options.authToken);
    // console.log("apiKey: ", apiKey);
    // const model = options.model || "openrouter/andromeda-alpha"; // słabo
    // const model = options.model || "openai/o3-deep-research"; // dobrze, ale drogo, 10USD za małą dokumentację testową
    // const model = options.model || "openai/gpt-5-mini"; // ok i tanio
    // const model = options.model || "openai/gpt-5"; // bardzo dobrze
    // const model = options.model || "openai/gpt-5.2"; //
    const model = options.model || "openai/gpt-5.6-sol"; //
    // const model = options.model || "mistralai/devstral-2512:free"; // słabo, źle formatuje HTML
    // const model = options.model || "allenai/olmo-3-32b-think:free"; //
    // const model = options.model || "openai/gpt-oss-120b:free"; //
    // const model = options.model || "google/gemma-3-27b-it:free"; // słabiutko
    // const model = options.model || "microsoft/phi-4"; // słabo
    // const model = options.model || "mistralai/mixtral-8x22b-instruct"; // tragedia
    // const model = options.model || "qwen/qwen3-235b-a22b-2507"; // jest potencjał
    // const model = options.model || "qwen/qwen3-vl-235b-a22b-instruct"; // jest potencjał, ale jeszcze średnio
    // const model = options.model || "google/gemini-2.5-pro"; // świetny
    // const model = options.model || "google/gemini-3.1-pro-preview";
    // const model = options.model || "google/gemini-2.5-flash"; // słabo, duzo bełkotu
    // const model = options.model || "z-ai/glm-4.6"; // bardzo spoko. krótkie i konkretne
    // const model = options.model || "x-ai/grok-4-fast"; // nieźle, ma problemy z formatowaniem HTML
    // const model = options.model || "x-ai/grok-4"; // dobrze, drogo, gorzej od gemini 2.5 pro i gpt-5
    // const model = options.model || "nvidia/nemotron-nano-9b-v2:free"; // zaskakująco dobry, do sprawdzenia
    // const model = options.model || "meta-llama/llama-4-maverick:free"; // słabo, nie radzi sobie z tworzeniem HTMLa
    // const model = options.model || "qwen/qwen3-max"; // całkiem nieźle
    // const model = options.model || "deepseek/deepseek-v3.1-terminus"; // nieźle, trochę się czepia
    const temperature = typeof options.temperature === "number" ? options.temperature : 1;
    const { maxTokens: maxTokens } = options;
    const systemMessage = options.system || (0, $4f64efc931dd8bad$export$fc1aa2344d32ca66);
    const basePrompt = options.basePrompt || (0, $4f64efc931dd8bad$export$5e393f6caa70b25f);
    const maxInputChars = options.maxInputChars || 160000; // soft guardrail (~160k chars)
    const { content: userContent, truncated: truncated } = (0, $4f64efc931dd8bad$export$ff49557cb47721b9)(basePrompt, sourceDocument, reference, maxInputChars);
    const payload = {
        model: model,
        temperature: temperature,
        max_tokens: maxTokens,
        messages: [
            {
                role: "system",
                content: systemMessage
            },
            {
                role: "user",
                content: userContent
            }
        ]
    };
    const headers = {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json"
    };
    // Optional but recommended by OpenRouter for better routing/quotas
    try {
        if (typeof window !== "undefined") {
            headers["HTTP-Referer"] = window.location.origin;
            headers["X-Title"] = "PrzemyslawGierski";
        }
    } catch (_) {
    // ignore if window is not available
    }
    const { data: data } = await $23a5f004ceaf672a$var$withOpenRouterRetry(()=>(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($23a5f004ceaf672a$var$OPENROUTER_CHAT_URL, payload, {
            headers: headers,
            timeout: 2880000
        }));
    const choice = data?.choices?.[0];
    const text = choice?.message?.content || "";
    return {
        text: text,
        fileName: sourceDocument.fileName,
        model: data?.model || model,
        usage: data?.usage,
        reference: reference,
        raw: data,
        ...truncated ? {
            inputTruncated: true
        } : {}
    };
}
async function $23a5f004ceaf672a$export$de1ecd1c5ea6eebe(messages, options = {}) {
    const apiKey = await $23a5f004ceaf672a$var$getOpenRouterApiKeyFromBackend(options.authToken);
    const model = options.model || "openai/gpt-5.2";
    const temperature = typeof options.temperature === "number" ? options.temperature : 1;
    const headers = {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json"
    };
    try {
        if (typeof window !== "undefined") {
            headers["HTTP-Referer"] = window.location.origin;
            headers["X-Title"] = "PrzemyslawGierski";
        }
    } catch (_) {
    // ignore if window is not available
    }
    const { data: data } = await $23a5f004ceaf672a$var$withOpenRouterRetry(()=>(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($23a5f004ceaf672a$var$OPENROUTER_CHAT_URL, {
            model: model,
            temperature: temperature,
            max_tokens: options.maxTokens,
            messages: messages
        }, {
            headers: headers,
            timeout: 720000
        }));
    return {
        text: data?.choices?.[0]?.message?.content || "",
        model: data?.model || model,
        usage: data?.usage,
        raw: data
    };
}
var $23a5f004ceaf672a$export$2e2bcd8739ae039 = $23a5f004ceaf672a$export$5ef9f428f5bcf99d;


const $9a5aef1fda50e141$var$RENDER_SCALE = 1.75;
const $9a5aef1fda50e141$var$JPEG_QUALITY = 0.72;
/** Longer edge target when attaching images to analysis prompts (~1600 px). */ const $9a5aef1fda50e141$var$ATTACH_MAX_EDGE = 1600;
const $9a5aef1fda50e141$export$a93ffe75517b9be3 = `Extract all visible text from this PDF page image. Preserve reading order. Turn any tables into GitHub-flavoured markdown tables. Do not invent values that are not visible. Return only the transcribed content \u{2014} no preamble.`;
function $9a5aef1fda50e141$var$blobToDataUrl(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(String(reader.result || ""));
        reader.onerror = ()=>reject(reader.error || new Error("Failed to read blob"));
        reader.readAsDataURL(blob);
    });
}
async function $9a5aef1fda50e141$export$9751f6c5629f4957(page, options = {}) {
    const scale = options.scale ?? $9a5aef1fda50e141$var$RENDER_SCALE;
    const quality = options.quality ?? $9a5aef1fda50e141$var$JPEG_QUALITY;
    const viewport = page.getViewport({
        scale: scale
    });
    let { width: width, height: height } = viewport;
    const { maxEdge: maxEdge } = options;
    if (maxEdge && Math.max(width, height) > maxEdge) {
        const factor = maxEdge / Math.max(width, height);
        width = Math.round(width * factor);
        height = Math.round(height * factor);
    }
    if (width < 16 || height < 16) return null;
    // Prefer OffscreenCanvas when available (workers / modern browsers);
    // fall back to a DOM canvas for older environments and Jest.
    const canvas = typeof OffscreenCanvas !== "undefined" ? new OffscreenCanvas(width, height) : (()=>{
        const el = document.createElement("canvas");
        el.width = width;
        el.height = height;
        return el;
    })();
    if ("width" in canvas) {
        canvas.width = width;
        canvas.height = height;
    }
    const context = canvas.getContext("2d");
    if (!context) return null;
    const renderViewport = width === viewport.width && height === viewport.height ? viewport : page.getViewport({
        scale: scale * (width / viewport.width)
    });
    await page.render({
        canvasContext: context,
        viewport: renderViewport
    }).promise;
    if ("convertToBlob" in canvas) {
        const blob = await canvas.convertToBlob({
            type: "image/jpeg",
            quality: quality
        });
        return $9a5aef1fda50e141$var$blobToDataUrl(blob);
    }
    return canvas.toDataURL("image/jpeg", quality);
}
async function $9a5aef1fda50e141$export$4b1919ce1b371d86(page) {
    return $9a5aef1fda50e141$export$9751f6c5629f4957(page, {
        scale: $9a5aef1fda50e141$var$RENDER_SCALE,
        maxEdge: $9a5aef1fda50e141$var$ATTACH_MAX_EDGE,
        quality: $9a5aef1fda50e141$var$JPEG_QUALITY
    });
}
async function $9a5aef1fda50e141$export$8179331f77214ab4(dataUrl, options = {}) {
    const content = [
        {
            type: "text",
            text: $9a5aef1fda50e141$export$a93ffe75517b9be3
        },
        {
            type: "image_url",
            image_url: {
                url: dataUrl
            }
        }
    ];
    const result = await (0, $23a5f004ceaf672a$export$de1ecd1c5ea6eebe)([
        {
            role: "system",
            content: "You are an accurate OCR assistant for regulatory PDF pages. Transcribe exactly what you see."
        },
        {
            role: "user",
            content: content
        }
    ], {
        ...options,
        model: options.model || (0, $4f64efc931dd8bad$export$69cb6a4560bd4248),
        temperature: typeof options.temperature === "number" ? options.temperature : 0.2
    });
    return (result.text || "").trim();
}
async function $9a5aef1fda50e141$export$10ad22ba27a653e9(page, options = {}) {
    const dataUrl = await $9a5aef1fda50e141$export$9751f6c5629f4957(page);
    if (!dataUrl) return "";
    return $9a5aef1fda50e141$export$8179331f77214ab4(dataUrl, options);
}


function $6d2e1af867362dad$export$5117db505c0e94be(path) {
    return path.replace(/\\/g, "/").replace(/^\.\/+/, "").toLowerCase();
}
function $6d2e1af867362dad$var$resolveRelativePath(basePath, relative) {
    const normalizedRelative = relative.replace(/\\/g, "/");
    // If already absolute (starts at root), return as-is
    if (normalizedRelative.startsWith("/")) return normalizedRelative.slice(1);
    const baseParts = basePath.replace(/\\/g, "/").split("/");
    // Remove the file name part to get the base directory
    baseParts.pop();
    const relParts = normalizedRelative.split("/");
    relParts.forEach((part)=>{
        if (!part || part === ".") return;
        if (part === "..") {
            if (baseParts.length > 0) baseParts.pop();
        } else baseParts.push(part);
    });
    return baseParts.join("/");
}
function $6d2e1af867362dad$var$bytesToString(bytes) {
    // Prefer proper UTF-8 decoding and strip any BOM if present.
    try {
        if (typeof TextDecoder !== "undefined") {
            const decoded = new TextDecoder("utf-8").decode(bytes);
            return decoded.replace(/^\uFEFF/, "");
        }
    } catch  {
    // Fallback to manual decoding below if TextDecoder is not available.
    }
    let result = "";
    for(let i = 0; i < bytes.length; i += 1)result += String.fromCharCode(bytes[i]);
    // Strip UTF-8 BOM that may appear as U+FEFF or as ï»¿ when mis-decoded.
    return result.replace(/^(?:\uFEFF|ï»¿)/, "");
}
function $6d2e1af867362dad$export$9e31f18171242572(entries) {
    const map = {};
    const xmlEntryNames = Object.keys(entries).filter((name)=>name.toLowerCase().endsWith("index.xml"));
    if (xmlEntryNames.length === 0) return map;
    const visitedXml = new Set();
    const parser = new DOMParser();
    const findEntryByNormalizedPath = (normalizedPath)=>Object.keys(entries).find((name)=>$6d2e1af867362dad$export$5117db505c0e94be(name) === normalizedPath);
    const traverseXml = (entryName)=>{
        const normalizedEntryName = $6d2e1af867362dad$export$5117db505c0e94be(entryName);
        // console.log("normalizedEntryName", normalizedEntryName);
        if (visitedXml.has(normalizedEntryName)) return;
        visitedXml.add(normalizedEntryName);
        const bytes = entries[entryName];
        if (!bytes) return;
        const xmlText = $6d2e1af867362dad$var$bytesToString(bytes);
        const doc = parser.parseFromString(xmlText, "text/xml");
        const leafElements = Array.from(doc.getElementsByTagName("leaf"));
        leafElements.forEach((leaf)=>{
            const href = leaf.getAttribute("xlink:href") || leaf.getAttribute("href");
            if (!href) return;
            const targetPath = $6d2e1af867362dad$var$resolveRelativePath(entryName, href);
            const normalizedTarget = $6d2e1af867362dad$export$5117db505c0e94be(targetPath);
            const parent = leaf.parentElement;
            const keyName = parent?.tagName;
            if (!keyName) return;
            const titleElement = leaf.getElementsByTagName("title")[0];
            const title = titleElement?.textContent?.trim() || undefined;
            const lowerHref = href.toLowerCase();
            if (lowerHref.endsWith(".xml")) {
                const xmlEntry = findEntryByNormalizedPath(normalizedTarget);
                if (xmlEntry) traverseXml(xmlEntry);
                return;
            }
            if (lowerHref.endsWith(".pdf")) {
                if (!map[normalizedTarget]) map[normalizedTarget] = {
                    parentName: keyName,
                    title: title
                };
            }
        });
    };
    xmlEntryNames.forEach(traverseXml);
    return map;
}


(0, $n3TJI.GlobalWorkerOptions).workerSrc = (0, (/*@__PURE__*/$parcel$interopDefault($028c0e1c138f1b37$exports))) || `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${0, $n3TJI.version}/pdf.worker.js`;
const $49233b2a320a7c4e$var$DEFAULT_OCR_CONCURRENCY = 6;
/**
 * Open a PDF from a copy of the bytes. pdf.js transfers `data.buffer` to the
 * worker when the Uint8Array owns its whole ArrayBuffer (as fflate returns),
 * which detaches the original. Callers that open the same entry twice must
 * slice so the unzipped bytes stay usable.
 */ function $49233b2a320a7c4e$var$openPdfDocument(pdfBytes) {
    return (0, $n3TJI.getDocument)({
        data: pdfBytes.slice()
    });
}
function $49233b2a320a7c4e$var$dataUrlToArrayBuffer(dataUrl) {
    const BASE64_MARKER = ";base64,";
    const base64Index = dataUrl.indexOf(BASE64_MARKER);
    if (base64Index === -1) {
        // Plain data URL (not base64-encoded)
        const parts = dataUrl.split(",");
        const raw = decodeURIComponent(parts[1] || "");
        const buf = new Uint8Array(raw.length);
        for(let i = 0; i < raw.length; i += 1)buf[i] = raw.charCodeAt(i);
        return buf.buffer;
    }
    const base64 = dataUrl.substring(base64Index + BASE64_MARKER.length);
    const raw = atob(base64);
    const buf = new Uint8Array(raw.length);
    for(let i = 0; i < raw.length; i += 1)buf[i] = raw.charCodeAt(i);
    return buf.buffer;
}
async function $49233b2a320a7c4e$var$classifyPages(pdf) {
    const pageNumbers = Array.from({
        length: pdf.numPages
    }, (_, i)=>i + 1);
    return Promise.all(pageNumbers.map(async (pageNum)=>{
        const page = await pdf.getPage(pageNum);
        const content = await page.getTextContent();
        const items = content.items || [];
        const textLayer = items.filter((item)=>item.str != null).map((item)=>(typeof item.str === "string" ? item.str : "") + (item.hasEOL ? "\n" : "")).join("");
        let operatorList = null;
        try {
            operatorList = await page.getOperatorList();
        } catch (_) {
            operatorList = null;
        }
        const pageClass = (0, $1ebb10e84a1dd185$export$2ebb97ff70d5ae3a)(items, operatorList);
        const quality = (0, $1ebb10e84a1dd185$export$f4959bb542efe05a)(items);
        const blank = (0, $1ebb10e84a1dd185$export$c30d47578143443a)(quality, (0, $1ebb10e84a1dd185$export$c5ab3edd89ea78d0)(operatorList));
        return {
            pageNumber: pageNum,
            pageClass: pageClass,
            blank: blank,
            usableText: (0, $1ebb10e84a1dd185$export$f363750ff3158218)(quality),
            textLayer: textLayer,
            page: page
        };
    }));
}
function $49233b2a320a7c4e$export$ccf311f6a3f60630(classified, mode, maxScannedPagesPerFile) {
    const scannedNonBlank = classified.filter((p)=>p.pageClass === "scanned" && !p.blank);
    const first = classified[0];
    const needFirstTranscribe = !!first && first.pageClass === "scanned" && !first.blank;
    let bodyScannedCount = scannedNonBlank.filter((p)=>p.pageNumber !== 1).length;
    if (mode === "transcribe" && typeof maxScannedPagesPerFile === "number" && Number.isFinite(maxScannedPagesPerFile)) {
        const remainingBudget = Math.max(0, maxScannedPagesPerFile - (needFirstTranscribe ? 1 : 0));
        bodyScannedCount = Math.min(bodyScannedCount, remainingBudget);
    }
    const transcribeCount = (needFirstTranscribe ? 1 : 0) + (mode === "transcribe" ? bodyScannedCount : 0);
    const attachCount = mode === "attach-images" ? scannedNonBlank.length : 0;
    return {
        filePageTotal: transcribeCount + attachCount,
        needFirstTranscribe: needFirstTranscribe,
        bodyScannedCount: bodyScannedCount,
        attachCount: attachCount
    };
}
function $49233b2a320a7c4e$var$emitClassifyProgress(onOcrProgress, partial) {
    if (typeof onOcrProgress !== "function") return;
    onOcrProgress({
        phase: "classify",
        overallCompleted: 0,
        overallTotal: 0,
        filesCompleted: partial.filesCompleted,
        fileCount: partial.fileCount,
        fileName: partial.fileName || "",
        fileIndex: partial.fileIndex ?? 0,
        filePageCompleted: 0,
        filePageTotal: 0,
        label: partial.label
    });
}
function $49233b2a320a7c4e$var$createConcurrencyLimiter(limit) {
    let active = 0;
    const waiting = [];
    const pump = ()=>{
        while(active < limit && waiting.length > 0){
            const next = waiting.shift();
            if (next) next();
        }
    };
    return {
        enqueue: (task)=>new Promise((resolve, reject)=>{
                const run = ()=>{
                    active += 1;
                    task().then(resolve, reject).finally(()=>{
                        active -= 1;
                        pump();
                    });
                };
                if (active < limit) run();
                else waiting.push(run);
            })
    };
}
function $49233b2a320a7c4e$var$createOcrProgressTracker(onOcrProgress, totals) {
    let overallCompleted = 0;
    const { overallTotal: overallTotal, fileCount: fileCount } = totals;
    const finishedFiles = new Set(totals.preCompletedFiles);
    let filesCompleted = finishedFiles.size;
    const filePageDone = new Map();
    const emit = (partial)=>{
        if (typeof onOcrProgress !== "function") return;
        onOcrProgress({
            phase: "extract",
            overallCompleted: overallCompleted,
            overallTotal: overallTotal,
            filesCompleted: filesCompleted,
            fileCount: fileCount,
            fileName: partial.fileName,
            fileIndex: partial.fileIndex,
            filePageCompleted: partial.filePageCompleted,
            filePageTotal: partial.filePageTotal,
            label: partial.label
        });
    };
    const markFileFinished = (fileName)=>{
        if (finishedFiles.has(fileName)) return;
        finishedFiles.add(fileName);
        filesCompleted += 1;
    };
    return {
        emitReady (label) {
            emit({
                fileName: "",
                fileIndex: 0,
                filePageCompleted: 0,
                filePageTotal: 0,
                label: label || "Counting pages\u2026"
            });
        },
        bumpPage ({ fileName: fileName, fileIndex: fileIndex, filePageTotal: filePageTotal, label: label }) {
            overallCompleted += 1;
            const done = (filePageDone.get(fileName) || 0) + 1;
            filePageDone.set(fileName, done);
            if (filePageTotal > 0 && done >= filePageTotal) markFileFinished(fileName);
            emit({
                fileName: fileName,
                fileIndex: fileIndex,
                filePageCompleted: done,
                filePageTotal: filePageTotal,
                label: label
            });
        },
        finishFile ({ fileName: fileName, fileIndex: fileIndex }) {
            markFileFinished(fileName);
            emit({
                fileName: fileName,
                fileIndex: fileIndex,
                filePageCompleted: 0,
                filePageTotal: 0,
                label: "Text only"
            });
        }
    };
}
/**
 * Open a PDF, classify pages, return the planned OCR unit count. Closes the
 * document so pass-2 OCR reopens fresh (avoids holding every page in memory).
 */ async function $49233b2a320a7c4e$var$planPdfOcrUnits(pdfBytes, options) {
    const mode = options.scannedPageMode || (0, $4f64efc931dd8bad$export$8b92e12bd79dd0e2);
    const maxScanned = options.maxScannedPagesPerFile;
    const loadingTask = $49233b2a320a7c4e$var$openPdfDocument(pdfBytes);
    const pdf = await loadingTask.promise;
    try {
        const classified = await $49233b2a320a7c4e$var$classifyPages(pdf);
        return $49233b2a320a7c4e$export$ccf311f6a3f60630(classified, mode, maxScanned).filePageTotal;
    } finally{
        try {
            if (typeof pdf.destroy === "function") await pdf.destroy();
        } catch (_) {
        // ignore cleanup errors
        }
    }
}
async function $49233b2a320a7c4e$var$extractPdfWithOcr(pdfBytes, fileName, options, queue, progress, ctx) {
    const mode = options.scannedPageMode || (0, $4f64efc931dd8bad$export$8b92e12bd79dd0e2);
    const maxScanned = options.maxScannedPagesPerFile;
    const visionOpts = {
        authToken: options.authToken,
        model: options.visionModel || (0, $4f64efc931dd8bad$export$69cb6a4560bd4248)
    };
    const { fileIndex: fileIndex } = ctx;
    const loadingTask = $49233b2a320a7c4e$var$openPdfDocument(pdfBytes);
    const pdf = await loadingTask.promise;
    {
        const classified = await $49233b2a320a7c4e$var$classifyPages(pdf);
        const pageStats = {
            totalPages: classified.length,
            scannedPages: classified.filter((p)=>p.pageClass === "scanned").length,
            textPages: classified.filter((p)=>p.pageClass === "text").length
        };
        const plan = $49233b2a320a7c4e$export$ccf311f6a3f60630(classified, mode, maxScanned);
        const { filePageTotal: filePageTotal } = plan;
        const scannedNonBlank = classified.filter((p)=>p.pageClass === "scanned" && !p.blank);
        const first = classified[0];
        const pagesToTranscribe = [];
        if (plan.needFirstTranscribe && first) pagesToTranscribe.push(first);
        if (mode === "transcribe") {
            const body = scannedNonBlank.filter((p)=>p.pageNumber !== 1).slice(0, plan.bodyScannedCount);
            pagesToTranscribe.push(...body);
        }
        const transcribeByNum = new Map();
        pagesToTranscribe.forEach((p)=>{
            transcribeByNum.set(p.pageNumber, p);
        });
        const pagesToAttach = mode === "attach-images" ? scannedNonBlank : [];
        if (filePageTotal === 0) progress.finishFile({
            fileName: fileName,
            fileIndex: fileIndex
        });
        const transcribed = new Map();
        await Promise.all(Array.from(transcribeByNum.values()).map((p)=>queue.enqueue(async ()=>{
                try {
                    const dataUrl = await (0, $9a5aef1fda50e141$export$9751f6c5629f4957)(p.page);
                    if (dataUrl) {
                        const text = await (0, $9a5aef1fda50e141$export$8179331f77214ab4)(dataUrl, visionOpts);
                        transcribed.set(p.pageNumber, text);
                    } else transcribed.set(p.pageNumber, "");
                } catch (_) {
                    transcribed.set(p.pageNumber, "");
                } finally{
                    progress.bumpPage({
                        fileName: fileName,
                        fileIndex: fileIndex,
                        filePageTotal: filePageTotal,
                        label: `OCR page ${p.pageNumber} of ${classified.length}`
                    });
                }
            })));
        const scannedPageImages = [];
        if (mode === "attach-images") {
            await Promise.all(pagesToAttach.map((p)=>queue.enqueue(async ()=>{
                    try {
                        const dataUrl = await (0, $9a5aef1fda50e141$export$4b1919ce1b371d86)(p.page);
                        if (dataUrl) scannedPageImages.push({
                            pageNumber: p.pageNumber,
                            dataUrl: dataUrl
                        });
                    } catch (_) {
                    // skip failed renders
                    } finally{
                        progress.bumpPage({
                            fileName: fileName,
                            fileIndex: fileIndex,
                            filePageTotal: filePageTotal,
                            label: `Render page ${p.pageNumber} of ${classified.length}`
                        });
                    }
                })));
            scannedPageImages.sort((a, b)=>a.pageNumber - b.pageNumber);
        }
        const pageTexts = classified.map((p)=>{
            if (p.pageClass === "text") return p.textLayer;
            if (p.blank) return "";
            if (transcribed.has(p.pageNumber)) return transcribed.get(p.pageNumber) || "";
            if (mode === "attach-images") return `[Page ${p.pageNumber}: see attached image "${fileName} p.${p.pageNumber}"]`;
            return `[further scanned pages omitted]`;
        });
        let sawOmitted = false;
        const cleaned = pageTexts.map((t)=>{
            if (t === "[further scanned pages omitted]") {
                if (sawOmitted) return "";
                sawOmitted = true;
                return t;
            }
            return t;
        });
        const text = cleaned.filter((t)=>t.length > 0).join("\n\n");
        // Header matching needs exact line structure (section codes at line
        // start). The embedded text layer is exact; a vision transcription is
        // approximate (markdown, merged lines), so prefer the text layer whenever
        // it is usable, even when the page was classified scanned.
        const firstPageText = first && (first.pageClass === "text" || first.usableText ? first.textLayer : transcribed.get(1) || first.textLayer) || "";
        return {
            fileName: fileName,
            text: text,
            ectdKey: "",
            ectdTitle: "",
            firstPageText: firstPageText,
            pageStats: pageStats,
            ...scannedPageImages.length > 0 ? {
                scannedPageImages: scannedPageImages
            } : {}
        };
    }
}
/** Lightweight text-only extraction (no OCR) — used as a fallback. */ async function $49233b2a320a7c4e$var$extractPdfPages(pdfBytes) {
    const loadingTask = $49233b2a320a7c4e$var$openPdfDocument(pdfBytes);
    const pdf = await loadingTask.promise;
    {
        const classified = await $49233b2a320a7c4e$var$classifyPages(pdf);
        return classified.map((p)=>p.textLayer);
    }
}
async function $49233b2a320a7c4e$export$f17f6c3c5b35ee78(zipData, options = {}) {
    const bytes = new Uint8Array(zipData);
    const entries = (0, $461bf5d8bd29e0d8$export$c757709326bb5901)(bytes); // Record<fileName, Uint8Array>
    const ectdLeafMap = (0, $6d2e1af867362dad$export$9e31f18171242572)(entries);
    const pdfEntries = Object.entries(entries).filter(([name])=>{
        const normalized = name.replace(/\\/g, "/");
        const baseName = normalized.split("/").pop() || "";
        return normalized.toLowerCase().endsWith(".pdf") && // Skip macOS ZIP artifacts (AppleDouble resource forks)
        !normalized.includes("__MACOSX") && !baseName.startsWith("._");
    });
    const fileCount = pdfEntries.length;
    $49233b2a320a7c4e$var$emitClassifyProgress(options.onOcrProgress, {
        filesCompleted: 0,
        fileCount: fileCount,
        label: fileCount > 0 ? "Classifying PDF files\u2026" : "No PDF files"
    });
    let classifiedCount = 0;
    // Pass 1: classify every PDF (no vision) so overallTotal is fixed up front.
    const plans = await Promise.all(pdfEntries.map(async ([name, content], index)=>{
        const fileIndex = index + 1;
        const baseName = name.replace(/\\/g, "/").split("/").pop() || name;
        let plan;
        try {
            const plannedUnits = await $49233b2a320a7c4e$var$planPdfOcrUnits(content, options);
            plan = {
                name: name,
                content: content,
                plannedUnits: plannedUnits,
                ok: true
            };
        } catch (_) {
            plan = {
                name: name,
                content: content,
                plannedUnits: 0,
                ok: false
            };
        }
        classifiedCount += 1;
        $49233b2a320a7c4e$var$emitClassifyProgress(options.onOcrProgress, {
            filesCompleted: classifiedCount,
            fileCount: fileCount,
            fileName: name,
            fileIndex: fileIndex,
            label: `Classifying ${baseName}`
        });
        return plan;
    }));
    const overallTotal = plans.reduce((sum, p)=>sum + p.plannedUnits, 0);
    const preCompletedFiles = plans.filter((p)=>p.plannedUnits === 0).map((p)=>p.name);
    const concurrency = options.ocrConcurrency ?? $49233b2a320a7c4e$var$DEFAULT_OCR_CONCURRENCY;
    const queue = $49233b2a320a7c4e$var$createConcurrencyLimiter(concurrency);
    const progress = $49233b2a320a7c4e$var$createOcrProgressTracker(options.onOcrProgress, {
        overallTotal: overallTotal,
        fileCount: fileCount,
        preCompletedFiles: preCompletedFiles
    });
    progress.emitReady(overallTotal > 0 ? `Ready: ${overallTotal} OCR pages across ${fileCount} files` : `Ready: ${fileCount} text-only files`);
    // Pass 2: OCR / extract with fixed progress denominators.
    const settled = await Promise.all(plans.map(async (plan, index)=>{
        const fileIndex = index + 1;
        try {
            const parsed = await $49233b2a320a7c4e$var$extractPdfWithOcr(plan.content, plan.name, options, queue, progress, {
                fileIndex: fileIndex,
                fileCount: fileCount,
                plannedUnits: plan.plannedUnits
            });
            const normalizedName = (0, $6d2e1af867362dad$export$5117db505c0e94be)(plan.name);
            const leafInfo = ectdLeafMap[normalizedName];
            return {
                status: "fulfilled",
                value: {
                    ...parsed,
                    fileName: plan.name,
                    ectdKey: leafInfo?.parentName || "",
                    ectdTitle: leafInfo?.title || ""
                }
            };
        } catch (reason) {
            try {
                progress.finishFile({
                    fileName: plan.name,
                    fileIndex: fileIndex
                });
                const pageTexts = await $49233b2a320a7c4e$var$extractPdfPages(plan.content);
                const normalizedName = (0, $6d2e1af867362dad$export$5117db505c0e94be)(plan.name);
                const leafInfo = ectdLeafMap[normalizedName];
                return {
                    status: "fulfilled",
                    value: {
                        fileName: plan.name,
                        text: pageTexts.join("\n\n"),
                        ectdKey: leafInfo?.parentName || "",
                        ectdTitle: leafInfo?.title || "",
                        firstPageText: pageTexts[0] || "",
                        pageStats: {
                            totalPages: pageTexts.length,
                            scannedPages: 0,
                            textPages: pageTexts.length
                        }
                    }
                };
            } catch (fallbackReason) {
                return {
                    status: "rejected",
                    reason: fallbackReason || reason
                };
            }
        }
    }));
    const fulfilled = settled.filter((s)=>s.status === "fulfilled");
    if (fileCount > 0 && fulfilled.length === 0) {
        const firstReject = settled.find((s)=>s.status === "rejected");
        const reason = firstReject?.reason;
        let message = "All PDF files failed to parse";
        if (reason instanceof Error) message = reason.message;
        else if (reason) message = String(reason);
        throw new Error(message);
    }
    return fulfilled.map((s)=>s.value);
}
async function $49233b2a320a7c4e$export$2ba0580d2c66d148(file, options = {}) {
    const arrayBuffer = await file.arrayBuffer();
    return $49233b2a320a7c4e$export$f17f6c3c5b35ee78(arrayBuffer, options);
}
async function $49233b2a320a7c4e$export$ce287739c756b4f4(dataUrl, options = {}) {
    const buffer = $49233b2a320a7c4e$var$dataUrlToArrayBuffer(dataUrl);
    return $49233b2a320a7c4e$export$f17f6c3c5b35ee78(buffer, options);
}
async function $49233b2a320a7c4e$export$ab112fbc46bc8862(dataUrl, fileName, options = {}) {
    const buffer = $49233b2a320a7c4e$var$dataUrlToArrayBuffer(dataUrl);
    const bytes = new Uint8Array(buffer);
    let plannedUnits = 0;
    try {
        plannedUnits = await $49233b2a320a7c4e$var$planPdfOcrUnits(bytes, options);
    } catch (_) {
        plannedUnits = 0;
    }
    const concurrency = options.ocrConcurrency ?? $49233b2a320a7c4e$var$DEFAULT_OCR_CONCURRENCY;
    const queue = $49233b2a320a7c4e$var$createConcurrencyLimiter(concurrency);
    const progress = $49233b2a320a7c4e$var$createOcrProgressTracker(options.onOcrProgress, {
        overallTotal: plannedUnits,
        fileCount: 1,
        preCompletedFiles: plannedUnits === 0 ? [
            fileName
        ] : []
    });
    progress.emitReady(plannedUnits > 0 ? `Ready: ${plannedUnits} OCR pages` : "Ready: text-only file");
    return $49233b2a320a7c4e$var$extractPdfWithOcr(bytes, fileName, options, queue, progress, {
        fileIndex: 1,
        fileCount: 1,
        plannedUnits: plannedUnits
    });
}


/** Set to true to enable console logs for literature reference validation. */ const $4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION = false;
function $4738859b0781c0f3$export$e310262789dd09b3(id) {
    return id.toLowerCase().replace(/\.pdf$/i, "").trim().replace(/\s+/g, "-");
}
/** "Literature References" or "References" - prefer the longer phrase to avoid TOC false hits */ const $4738859b0781c0f3$var$LITERATURE_HEADING_PATTERN = /literature\s+references|references/gi;
/**
 * True if the text immediately after the heading match looks like a TOC line:
 * only dots/spaces and a page number (e.g. " ......... 39" or " ................ 42").
 */ function $4738859b0781c0f3$var$looksLikeTocEntry(text, matchEndIndex) {
    const nextNewline = text.indexOf("\n", matchEndIndex);
    const restOfLine = text.slice(matchEndIndex, nextNewline === -1 ? text.length : nextNewline);
    return /^[\s.]*\d+\s*$/.test(restOfLine.trimStart());
}
/**
 * Find the first occurrence of the section heading that is NOT a Table of Contents entry.
 * TOC lines look like "Literature References ............... 39" (heading + dots + page number).
 */ function $4738859b0781c0f3$var$findSectionStart(text) {
    const re = new RegExp($4738859b0781c0f3$var$LITERATURE_HEADING_PATTERN.source, "gi");
    const matches = [];
    let m;
    while((m = re.exec(text)) !== null)matches.push({
        index: m.index,
        length: m[0].length,
        heading: m[0]
    });
    const found = matches.find((match)=>!$4738859b0781c0f3$var$looksLikeTocEntry(text, match.index + match.length));
    if (found) {
        if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] extractLiteratureReferencesSection: using non-TOC match at", found.index, "heading", found.heading);
        return found.index;
    }
    return -1;
}
/** Intro/header phrases that indicate a segment is not an actual reference entry */ const $4738859b0781c0f3$var$NOT_A_REFERENCE = /^(?:Literature\s+References|References)(?:\s|$)/i;
const $4738859b0781c0f3$var$INTRO_PATTERN = /references\s+are\s+included\s+in|the\s+following\s+references?|see\s+module\s+\d/i;
/** Footer line: document name + page X/Y (e.g. "Tigecycline 50 mg, powder for solution for infusion 39/42") */ const $4738859b0781c0f3$var$FOOTER_LINE = /\d+\/\d+\s*$/;
/**
 * Remove trailing lines that look like PDF footer (line ending with page X/Y, e.g. "39/42").
 */ function $4738859b0781c0f3$var$stripFooterLines(text) {
    const lines = text.split(/\r?\n/);
    let end = lines.length;
    while(end > 0 && $4738859b0781c0f3$var$FOOTER_LINE.test(lines[end - 1]?.trim() ?? ""))end -= 1;
    return lines.slice(0, end).join("\n").trim();
}
/** True if the whole string looks like a single footer line (document title + page X/Y). */ function $4738859b0781c0f3$var$isOnlyFooterLine(text) {
    const t = text.trim();
    return t.length > 0 && t.length < 200 && $4738859b0781c0f3$var$FOOTER_LINE.test(t);
}
function $4738859b0781c0f3$export$e409857b6797a596(sectionText) {
    if (!sectionText || !sectionText.trim()) return [];
    // Split only when "N. " is followed by uppercase (real list item), not e.g. "1002. doi"
    const segments = sectionText.split(/\n(?=\d{1,3}\.\s+[A-Z])/);
    return segments.reduce((entries, seg)=>{
        const trimmed = seg.trim();
        if (!trimmed) return entries;
        // Only process segments that start with "N. " (numbered list item); skip header/intro block
        if (!/^\d+\.\s/.test(trimmed)) return entries;
        // Strip leading "N. " from the segment to get the citation text
        let citation = trimmed.replace(/^\d+\.\s*/, "").trim();
        if (!citation) return entries;
        // Skip if citation is just the section header or short intro text
        const firstLine = citation.split(/\r?\n/)[0] ?? citation;
        if ($4738859b0781c0f3$var$NOT_A_REFERENCE.test(firstLine) && (citation.length < 120 || $4738859b0781c0f3$var$INTRO_PATTERN.test(citation))) return entries;
        // Skip if this is only a PDF footer line (document name + page X/Y)
        if ($4738859b0781c0f3$var$isOnlyFooterLine(citation)) return entries;
        // Remove trailing footer lines (e.g. "Tigecycline 50 mg, powder for solution for infusion 39/42")
        citation = $4738859b0781c0f3$var$stripFooterLines(citation);
        if (!citation) return entries;
        entries.push(citation);
        return entries;
    }, []);
}
function $4738859b0781c0f3$export$e8e1a14b9a0207f2(citation, maxLen = 400) {
    const trimmed = citation.trim();
    if (!trimmed) return "(no title)";
    if (trimmed.length <= maxLen) return trimmed;
    return `${trimmed.slice(0, maxLen).trim()}\u{2026}`;
}
/**
 * Try to match a citation string to an identifier in the valid set (e.g. barbour-2009).
 * Uses heuristics: valid id is like "author-year" or "keyword-keyword-year"; citation must
 * contain the name parts and the year.
 */ function $4738859b0781c0f3$var$matchCitationToValidId(citation, validSet) {
    const lower = citation.toLowerCase();
    const ids = Array.from(validSet);
    return ids.find((id)=>{
        const parts = id.split("-");
        const yearPart = parts.find((p)=>/^\d{4}$/.test(p));
        const nameParts = yearPart ? parts.filter((p)=>p !== yearPart) : parts;
        if (yearPart && !citation.includes(yearPart)) return false;
        return nameParts.every((part)=>lower.includes(part));
    }) ?? null;
}
function $4738859b0781c0f3$export$6572abb0ee37b964(text) {
    if (!text || !text.trim()) return "";
    const startIndex = $4738859b0781c0f3$var$findSectionStart(text);
    if (startIndex === -1) {
        if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] extractLiteratureReferencesSection: no heading found");
        return "";
    }
    // From start of section, look for next major heading (all caps line or numbered section like "2.3.4")
    const afterSection = text.slice(startIndex);
    const nextHeading = afterSection.match(/\n\s*(?:[A-Z][A-Z0-9\s]{10,}|\d+\.\d+(?:\.\d+)*\s+[A-Z])/);
    const endIndex = nextHeading && typeof nextHeading.index === "number" ? startIndex + nextHeading.index : text.length;
    const section = text.slice(startIndex, endIndex);
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) {
        console.log("[literature] extractLiteratureReferencesSection: section length", section.length);
        console.log("[literature] extractLiteratureReferencesSection: section", section);
    }
    return section;
}
function $4738859b0781c0f3$export$f09a27bc696091de(sectionText, validSet) {
    const citedCitations = $4738859b0781c0f3$export$e409857b6797a596(sectionText);
    const valid = [];
    const validItems = [];
    const missing = [];
    const missingItems = [];
    const matchedIds = new Set();
    citedCitations.forEach((citation)=>{
        const id = $4738859b0781c0f3$var$matchCitationToValidId(citation, validSet);
        if (id && !matchedIds.has(id)) {
            matchedIds.add(id);
            valid.push(id);
            validItems.push({
                refName: id,
                citation: citation
            });
        } else if (!id) {
            missing.push(citation);
            missingItems.push({
                refName: $4738859b0781c0f3$export$e8e1a14b9a0207f2(citation),
                citation: citation
            });
        }
    });
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] extractReferenceCandidates:", citedCitations.length, "citations,", valid.length, "valid,", missing.length, "missing");
    return {
        citedCitations: citedCitations,
        valid: valid,
        validItems: validItems,
        missing: missing,
        missingItems: missingItems
    };
}
function $4738859b0781c0f3$var$buildValidSet(parsed, ectdKeyFilter) {
    const refs = parsed.filter((p)=>p.ectdKey === ectdKeyFilter && p.ectdTitle).map((p)=>$4738859b0781c0f3$export$e310262789dd09b3(p.ectdTitle));
    const set = new Set(refs);
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] buildValidSet", ectdKeyFilter, ":", set.size, "refs", [
        ...set
    ].slice(0, 10), set.size > 10 ? "\u2026" : "");
    return set;
}
function $4738859b0781c0f3$var$validateOneOverview(overview, validSet) {
    const sectionText = $4738859b0781c0f3$export$6572abb0ee37b964(overview.text);
    const sectionFound = sectionText.length > 0;
    const { citedCitations: citedCitations, valid: valid, validItems: validItems, missing: missing, missingItems: missingItems } = sectionFound ? $4738859b0781c0f3$export$f09a27bc696091de(sectionText, validSet) : {
        citedCitations: [],
        valid: [],
        validItems: [],
        missing: [],
        missingItems: []
    };
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] validateOneOverview", overview.fileName, "| sectionFound:", sectionFound, "| citedCitations:", citedCitations.length, "| valid:", valid.length, "| missing:", missing.length);
    return {
        fileName: overview.fileName,
        ectdKey: overview.ectdKey,
        sectionFound: sectionFound,
        citedCitations: citedCitations,
        valid: valid,
        validItems: validItems,
        missing: missing,
        missingItems: missingItems
    };
}
function $4738859b0781c0f3$export$7f56789102a2032c(parsed) {
    const validM4 = $4738859b0781c0f3$var$buildValidSet(parsed, "m4-3-literature-references");
    const validM5 = $4738859b0781c0f3$var$buildValidSet(parsed, "m5-4-literature-references");
    const nonclinicalOverview = parsed.find((p)=>p.ectdKey === "m2-4-nonclinical-overview");
    const clinicalOverview = parsed.find((p)=>p.ectdKey === "m2-5-clinical-overview");
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) {
        console.log("[literature] validateLiteratureReferences: validM4 size", validM4.size, "validM5 size", validM5.size);
        console.log("[literature] overviews found: nonclinical", !!nonclinicalOverview, "clinical", !!clinicalOverview);
    }
    const result = {
        nonclinical: nonclinicalOverview ? $4738859b0781c0f3$var$validateOneOverview(nonclinicalOverview, validM4) : null,
        clinical: clinicalOverview ? $4738859b0781c0f3$var$validateOneOverview(clinicalOverview, validM5) : null
    };
    if ($4738859b0781c0f3$var$DEBUG_LITERATURE_VALIDATION) console.log("[literature] validateLiteratureReferences result:", result);
    return result;
}


/* eslint-disable import/no-named-as-default */ 

async function $4797f75c9bebdb42$export$9bf8f73ca1180e6d(sourceDocument, reference, options = {}) {
    const apiKey = undefined;
    if (!apiKey) throw new Error("OPENAI_API_KEY env var is required");
    // const model = options.model || "gpt-5-nano";
    // const model = options.model || "gpt-5-mini";
    const model = options.model || "gpt-5";
    const temperature = typeof options.temperature === "number" ? options.temperature : 1;
    const { maxTokens: maxTokens } = options;
    const systemMessage = options.system || (0, $4f64efc931dd8bad$export$fc1aa2344d32ca66);
    const basePrompt = (0, $4f64efc931dd8bad$export$5e393f6caa70b25f);
    const maxInputChars = options.maxInputChars || 160000; // soft guardrail (~160k chars)
    const { content: built, truncated: truncated } = (0, $4f64efc931dd8bad$export$ff49557cb47721b9)(basePrompt, sourceDocument, reference, maxInputChars);
    // OpenAI path stays text-only; ignore attached images if present.
    const userContent = typeof built === "string" ? built : built.filter((p)=>p.type === "text").map((p)=>p.text).join("\n");
    const payload = {
        model: model,
        temperature: temperature,
        max_tokens: maxTokens,
        messages: [
            {
                role: "system",
                content: systemMessage
            },
            {
                role: "user",
                content: userContent
            }
        ]
    };
    // console.log("payload for ", sourceDocument.fileName, payload);
    const { data: data } = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("https://api.openai.com/v1/chat/completions", payload, {
        headers: {
            Authorization: `Bearer ${apiKey}`,
            "Content-Type": "application/json"
        },
        timeout: 720000
    });
    const choice = data?.choices?.[0];
    const text = choice?.message?.content || "";
    // console.log("got response for ", sourceDocument.fileName);
    return {
        text: text,
        fileName: sourceDocument.fileName,
        model: data?.model || model,
        usage: data?.usage,
        raw: data,
        reference: reference,
        ...truncated ? {
            inputTruncated: true
        } : {}
    };
}
var $4797f75c9bebdb42$export$2e2bcd8739ae039 = $4797f75c9bebdb42$export$9bf8f73ca1180e6d;





async function $02748f80834eb7ce$export$cf147365556e35db(sourceDocument, reference, options = {}) {
    const baseUrl = "http://localhost:2000".replace(/\/$/, "");
    const endpoint = `${baseUrl}/v1/chat/completions`;
    const modelToUse = "deepseek/deepseek-r1-0528-qwen3-8b";
    // const modelToUse = "qwen/qwen3-vl-30b"
    const model = options.model || undefined || modelToUse;
    const temperature = typeof options.temperature === "number" ? options.temperature : 1;
    const { maxTokens: maxTokens } = options;
    const systemMessage = options.system || (0, $4f64efc931dd8bad$export$fc1aa2344d32ca66);
    const basePrompt = (0, $4f64efc931dd8bad$export$5e393f6caa70b25f);
    const maxInputChars = options.maxInputChars || 160000; // soft guardrail
    const { content: built, truncated: truncated } = (0, $4f64efc931dd8bad$export$ff49557cb47721b9)(basePrompt, sourceDocument, reference, maxInputChars);
    // LM Studio path stays text-only; ignore attached images if present.
    const userContent = typeof built === "string" ? built : built.filter((p)=>p.type === "text").map((p)=>p.text).join("\n");
    const payload = {
        model: model,
        temperature: temperature,
        max_tokens: maxTokens,
        messages: [
            {
                role: "system",
                content: systemMessage
            },
            {
                role: "user",
                content: userContent
            }
        ]
    };
    const { data: data } = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(endpoint, payload, {
        headers: {
            "Content-Type": "application/json"
        },
        timeout: 2880000
    });
    const choice = data?.choices?.[0];
    const text = choice?.message?.content || "";
    return {
        text: text,
        fileName: sourceDocument.fileName,
        model: data?.model || model,
        usage: data?.usage,
        raw: data,
        reference: reference,
        ...truncated ? {
            inputTruncated: true
        } : {}
    };
}
var $02748f80834eb7ce$export$2e2bcd8739ae039 = $02748f80834eb7ce$export$cf147365556e35db;


function $49cd54c429e356d8$var$resolveProvider(explicit) {
    if (explicit) return explicit;
    const fromEnv = "".toLowerCase();
    if (fromEnv === "openrouter") return "openrouter";
    if (fromEnv === "lmstudio") return "lmstudio";
    return "openai";
}
async function $49cd54c429e356d8$export$414397524d3f8144(sourceDocument, reference, options = {}) {
    const provider = $49cd54c429e356d8$var$resolveProvider(options.provider);
    const invoke = async ()=>{
        if (provider === "openrouter") return (0, $23a5f004ceaf672a$export$2e2bcd8739ae039)(sourceDocument, reference, options);
        if (provider === "lmstudio") return (0, $02748f80834eb7ce$export$2e2bcd8739ae039)(sourceDocument, reference, options);
        return (0, $4797f75c9bebdb42$export$2e2bcd8739ae039)(sourceDocument, reference, options);
    };
    const isEmptyLike = (text)=>{
        if (!text) return true;
        // Treat outputs that are only whitespace/newlines as empty
        return text.replace(/\s/g, "").length === 0;
    };
    const maxAttempts = 3; // initial try + 2 retries
    const attemptRun = async (attemptNum)=>{
        try {
            const result = await invoke();
            if (!isEmptyLike(result.text)) return result;
            if (attemptNum >= maxAttempts) return result;
            // eslint-disable-next-line no-console
            console.warn(`runPromptWithProvider: empty-like output received (attempt ${attemptNum}/${maxAttempts - 1}), retrying...`);
            await new Promise((r)=>setTimeout(r, 400 * attemptNum));
            return attemptRun(attemptNum + 1);
        } catch (err) {
            if (attemptNum >= maxAttempts) throw err;
            // eslint-disable-next-line no-console
            console.warn(`runPromptWithProvider: error on attempt ${attemptNum}/${maxAttempts - 1}, retrying...`, err);
            await new Promise((r)=>setTimeout(r, 400 * attemptNum));
            return attemptRun(attemptNum + 1);
        }
    };
    return attemptRun(1);
}
var $49cd54c429e356d8$export$2e2bcd8739ae039 = $49cd54c429e356d8$export$414397524d3f8144;




// Estimate cost in USD using a simple pricing table (per 1M tokens)
const $da17d1d9e567ae00$var$PRICING_USD_PER_MTOK = {
    "openrouter/andromeda-alpha": {
        input: 0,
        output: 0
    },
    "google/gemini-2.5-pro": {
        input: 1.25,
        output: 10
    },
    "google/gemini-2.5-flash": {
        input: 0.3,
        output: 2.5
    },
    "openai/o3-deep-research": {
        input: 10,
        output: 40
    },
    "openai/gpt-5-pro": {
        input: 15,
        output: 120
    },
    "gpt-5-nano": {
        input: 0.05,
        output: 0.4
    },
    "gpt-5-mini": {
        input: 0.25,
        output: 2
    },
    "openai/gpt-5-mini": {
        input: 0.25,
        output: 2
    },
    "gpt-5": {
        input: 1.25,
        output: 10
    },
    "openai/gpt-5.2": {
        input: 1.75,
        output: 14
    },
    "gpt-5.2": {
        input: 1.75,
        output: 14
    },
    "gpt-4o": {
        input: 5,
        output: 15
    },
    "gpt-4o-mini": {
        input: 0.15,
        output: 0.6
    },
    "gpt-4-turbo": {
        input: 10,
        output: 30
    },
    "gpt-3.5-turbo": {
        input: 0.5,
        output: 1.5
    }
};
// const SHOULD_RUN_PROMPTS = false;
const $da17d1d9e567ae00$var$SHOULD_RUN_PROMPTS = true;
const $da17d1d9e567ae00$var$DEBUG = false;
const $da17d1d9e567ae00$export$616a736cc06b2c14 = async (files, onProgress, options = {})=>{
    const targets = files.filter((file)=>file.ectdKey && (file.ectdKey.includes("m3-2-p") || file.ectdKey.includes("m3-2-r") || file.ectdKey.includes("m3-2-s") || file.ectdTitle.includes("common-spc") || file.ectdTitle.includes("common-pl") || file.ectdKey.includes("m1-8-1-pharmacovigilance-system") || file.ectdKey.includes("m2-2-introduction") || file.ectdKey.includes("m2-3-quality-overall-summary") || file.ectdKey.includes("m2-4-nonclinical-overview") || file.ectdKey.includes("m2-5-clinical-overview") || file.ectdKey.includes("m2-6-clinical-summary")));
    // .filter(
    //     (file) => file.fileName.includes('32p')
    // )
    // .filter(
    //     (file) => file.ectdTitle.includes('common-pl')
    // )
    // .slice(0, 1);
    const total = targets.length;
    let completed = 0;
    if (typeof onProgress === "function") onProgress(0, total);
    // console.log("targets: ", targets);
    const tasks = [];
    targets.forEach((file)=>{
        let reference;
        if (file.ectdKey === "pi-doc") {
            const foundReference = (0, $81b98fb9de868a7b$export$63b727d6e7a38867).find((r)=>r.ectdTitle === file.ectdTitle);
            if (foundReference) reference = foundReference;
        } else {
            const foundReference = (0, $81b98fb9de868a7b$export$63b727d6e7a38867).find((r)=>file.ectdKey.startsWith(r.ectdKey));
            if (foundReference) reference = foundReference;
        }
        // console.log("file: ", file);
        // console.log("reference, file: ", reference, file);
        if (reference) tasks.push((0, $49cd54c429e356d8$export$2e2bcd8739ae039)(file, reference, {
            provider: "openrouter",
            authToken: options.authToken
        }).then((res)=>{
            completed += 1;
            if (typeof onProgress === "function") onProgress(completed, total, file.fileName);
            return res;
        }));
    });
    const results = $da17d1d9e567ae00$var$SHOULD_RUN_PROMPTS ? await Promise.all(tasks) : [];
    // console.log(results);
    // Aggregate token usage across results
    const totals = results.reduce((acc, r)=>{
        const usage = r?.usage || {};
        const prompt = Number(usage.prompt_tokens) || 0;
        const completion = Number(usage.completion_tokens) || 0;
        const tokenTotal = Number(usage.total_tokens) || prompt + completion;
        acc.prompt_tokens += prompt;
        acc.completion_tokens += completion;
        acc.total_tokens += tokenTotal;
        return acc;
    }, {
        prompt_tokens: 0,
        completion_tokens: 0,
        total_tokens: 0
    });
    const resolvePricing = (model)=>{
        if (!model) return $da17d1d9e567ae00$var$PRICING_USD_PER_MTOK["gpt-5"];
        const entry = Object.entries($da17d1d9e567ae00$var$PRICING_USD_PER_MTOK).find(([key])=>model === key || model.startsWith(key));
        if (entry) return entry[1];
        console.warn("Unknown model in resolvePricing, returning pricing for gpt-5", model);
        return $da17d1d9e567ae00$var$PRICING_USD_PER_MTOK["gpt-5"]; // default fallback
    };
    const costTotals = results.reduce((acc, r)=>{
        const usage = r?.usage || {};
        const model = r?.model;
        const pricing = resolvePricing(model);
        const prompt = Number(usage.prompt_tokens) || 0;
        const completion = Number(usage.completion_tokens) || 0;
        const inputCost = prompt / 1000000 * pricing.input;
        const outputCost = completion / 1000000 * pricing.output;
        acc.input_usd += inputCost;
        acc.output_usd += outputCost;
        acc.total_usd += inputCost + outputCost;
        return acc;
    }, {
        input_usd: 0,
        output_usd: 0,
        total_usd: 0
    });
    if ($da17d1d9e567ae00$var$DEBUG) {
        console.log("Token usage totals:", totals);
        console.log("Estimated cost (USD):", {
            input_usd: Number(costTotals.input_usd.toFixed(6)),
            output_usd: Number(costTotals.output_usd.toFixed(6)),
            total_usd: Number(costTotals.total_usd.toFixed(6))
        });
    }
    return results;
};





const $2e711560b32d2ad8$var$formatBytes = (bytes)=>{
    if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
    const units = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB"
    ];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** i;
    return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};
function $2e711560b32d2ad8$var$summarizePageStats(parsed) {
    return parsed.reduce((acc, p)=>{
        const stats = p.pageStats;
        if (!stats) return acc;
        return {
            totalPages: acc.totalPages + stats.totalPages,
            textPages: acc.textPages + stats.textPages,
            scannedPages: acc.scannedPages + stats.scannedPages,
            fileCount: acc.fileCount + 1
        };
    }, {
        totalPages: 0,
        textPages: 0,
        scannedPages: 0,
        fileCount: 0
    });
}
function $2e711560b32d2ad8$var$OverviewValidationBlock({ label: label, overview: overview, validModuleLabel: validModuleLabel }) {
    const { fileName: fileName, sectionFound: sectionFound, citedCitations: citedCitations, validItems: validItems, missingItems: missingItems } = overview;
    let summary;
    if (!sectionFound) summary = "Literature References section not found.";
    else if (missingItems.length === 0) summary = "All references valid.";
    else summary = `${missingItems.length} reference(s) missing from ${validModuleLabel}.`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#555",
            marginBottom: 6
        }
    }, "File: ", fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 6
        }
    }, summary), missingItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#c00"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "Missing (", missingItems.length, ") \u2014 not matched to a file in", " ", validModuleLabel, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: "4px 0 0 16px",
            paddingLeft: 8
        }
    }, missingItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `missing-${item.refName}`,
            style: {
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, item.refName))))), sectionFound && citedCitations.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 8
        }
    }, validItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "Matched references (", validItems.length, ") \u2014 present in", " ", validModuleLabel, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: "4px 0 0 16px",
            paddingLeft: 8
        }
    }, validItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: item.refName,
            style: {
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, item.refName), item.citation && ` \u{2014} ${item.citation.length > 150 ? `${item.citation.slice(0, 150)}\u{2026}` : item.citation}`))))));
}
const $2e711560b32d2ad8$export$97ff6b38098aefc3 = ()=>{
    const { authResult: authResult } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [promptResults, setPromptResults] = (0, $acw62.useState)([]);
    const [promptsInFlight, setPromptsInFlight] = (0, $acw62.useState)(0);
    const [progressTotal, setProgressTotal] = (0, $acw62.useState)(0);
    const [progressCompleted, setProgressCompleted] = (0, $acw62.useState)(0);
    const [progressLastFile, setProgressLastFile] = (0, $acw62.useState)("");
    const [pageStatsSummary, setPageStatsSummary] = (0, $acw62.useState)(null);
    const [ocrProgress, setOcrProgress] = (0, $acw62.useState)(null);
    const [literatureValidation, setLiteratureValidation] = (0, $acw62.useState)(null);
    const [singlePdfFile, setSinglePdfFile] = (0, $acw62.useState)(null);
    const [selectedReferenceIndex, setSelectedReferenceIndex] = (0, $acw62.useState)(null);
    const [singlePdfAnalyzing, setSinglePdfAnalyzing] = (0, $acw62.useState)(false);
    const [isClearResultsModalOpen, setIsClearResultsModalOpen] = (0, $acw62.useState)(false);
    const referenceDropdownOptions = (0, $acw62.useMemo)(()=>(0, $81b98fb9de868a7b$export$63b727d6e7a38867).map((ref, i)=>({
                value: String(i),
                label: `${ref.ectdTitle} (${ref.ectdKey})`
            })), []);
    const latestFile = files.length ? files[files.length - 1] : undefined;
    const sortedResults = (0, $acw62.useMemo)(()=>[
            ...promptResults
        ].sort((a, b)=>(a.fileName || a.filename || "").localeCompare(b.fileName || b.filename || "")), [
        promptResults
    ]);
    const hasReportResults = !!(latestFile || promptResults.length > 0);
    const printRef = (0, $acw62.useRef)(null);
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    const processZip = (0, $acw62.useCallback)(async (file)=>{
        setFiles((prev)=>[
                ...prev,
                {
                    fileName: file.name,
                    fileSize: file.size
                }
            ]);
        setPromptsInFlight((c)=>c + 1);
        setOcrProgress(null);
        try {
            // Read the ZIP as an ArrayBuffer — no base64 data URL / JSON
            // round-trip, which overflows the browser string limit on large archives.
            const parsed = await (0, $49233b2a320a7c4e$export$2ba0580d2c66d148)(file, {
                authToken: authResult?.accessToken,
                scannedPageMode: (0, $4f64efc931dd8bad$export$716ace1f00a73e4)(),
                onOcrProgress: (event)=>{
                    setOcrProgress(event);
                }
            });
            setPageStatsSummary($2e711560b32d2ad8$var$summarizePageStats(parsed));
            setLiteratureValidation((0, $4738859b0781c0f3$export$7f56789102a2032c)(parsed));
            setProgressTotal(0);
            setProgressCompleted(0);
            setProgressLastFile("");
            setOcrProgress(null);
            const results = await (0, $da17d1d9e567ae00$export$616a736cc06b2c14)(parsed, (completed, total, fileName)=>{
                setProgressTotal(total);
                setProgressCompleted(completed);
                if (fileName) setProgressLastFile(fileName);
            }, {
                authToken: authResult?.accessToken
            });
            if (Array.isArray(results)) setPromptResults((prev)=>prev.concat(results));
        } catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(`eCTD package upload failed: ${message}`);
        } finally{
            setPromptsInFlight((c)=>Math.max(0, c - 1));
            setOcrProgress(null);
        }
    }, [
        authResult?.accessToken
    ]);
    const zipUploadDisabled = hasReportResults || singlePdfAnalyzing;
    const handleZipDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        const file = acceptedFiles[0];
        if (!file || zipUploadDisabled) return;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        processZip(file);
    }, [
        processZip,
        zipUploadDisabled
    ]);
    const { getRootProps: getZipRootProps, getInputProps: getZipInputProps, isDragAccept: isZipDragAccept, open: openZip } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        accept: "application/zip,.zip,application/x-zip-compressed",
        maxFiles: 1,
        disabled: zipUploadDisabled,
        onDrop: handleZipDrop,
        onDropRejected: (rejected)=>{
            if (rejected.length > 0) (0, $60f27fc97e29822a$export$b410431fab84fa58).error("Please upload a ZIP file only.");
        }
    });
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept, open: open } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        accept: "application/pdf,.pdf",
        maxFiles: 1,
        onDrop: (0, $acw62.useCallback)((acceptedFiles)=>{
            const file = acceptedFiles[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = ()=>{
                const dataUrl = typeof reader.result === "string" ? reader.result : "";
                if (dataUrl) setSinglePdfFile({
                    dataUrl: dataUrl,
                    fileName: file.name
                });
            };
            reader.readAsDataURL(file);
        }, [])
    });
    const handleAnalyzeSinglePdf = (0, $acw62.useCallback)(async ()=>{
        if (!singlePdfFile || selectedReferenceIndex === null || selectedReferenceIndex < 0 || selectedReferenceIndex >= (0, $81b98fb9de868a7b$export$63b727d6e7a38867).length) return;
        const reference = (0, $81b98fb9de868a7b$export$63b727d6e7a38867)[selectedReferenceIndex];
        setSinglePdfAnalyzing(true);
        try {
            const parsed = await (0, $49233b2a320a7c4e$export$ab112fbc46bc8862)(singlePdfFile.dataUrl, singlePdfFile.fileName, {
                authToken: authResult?.accessToken,
                scannedPageMode: (0, $4f64efc931dd8bad$export$716ace1f00a73e4)()
            });
            const parsedWithRef = {
                ...parsed,
                ectdKey: reference.ectdKey,
                ectdTitle: reference.ectdTitle
            };
            const result = await (0, $49cd54c429e356d8$export$414397524d3f8144)(parsedWithRef, reference, {
                provider: "openrouter",
                authToken: authResult?.accessToken
            });
            setPromptResults((prev)=>prev.concat({
                    reference: reference,
                    text: result.text,
                    fileName: result.fileName,
                    model: result.model,
                    ...result.inputTruncated ? {
                        inputTruncated: true
                    } : {}
                }));
        } catch (e) {
            console.warn(e);
        } finally{
            setSinglePdfAnalyzing(false);
        }
    }, [
        singlePdfFile,
        selectedReferenceIndex,
        authResult?.accessToken
    ]);
    const handleClearResults = (0, $acw62.useCallback)(()=>{
        setPromptResults([]);
        setLiteratureValidation(null);
        setFiles([]);
        setPageStatsSummary(null);
        setOcrProgress(null);
        setSinglePdfFile(null);
        setSelectedReferenceIndex(null);
        setProgressTotal(0);
        setProgressCompleted(0);
        setProgressLastFile("");
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "Regulatory"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: "Regulatory",
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 16
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Loose PDF set \u2192 eCTD mapping",
        onClick: ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $f125bbca2c654db8$export$ff7962acd6052c28)((0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            marginTop: 24,
            padding: 16,
            background: "#fafafa"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Upload the full eCTD package in a ZIP file"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e464d85de0bbd46d$export$6c8108ad15125580), {
        rootProps: getZipRootProps({
            isDragAccept: isZipDragAccept
        }),
        inputProps: getZipInputProps(),
        open: openZip,
        disabled: zipUploadDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            marginTop: 24,
            padding: 16,
            background: "#fafafa"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Upload summary"), latestFile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "140px 1fr",
            rowGap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "File name")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, latestFile.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "Size")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, $2e711560b32d2ad8$var$formatBytes(latestFile.fileSize)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "Total files")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, files.length), pageStatsSummary && pageStatsSummary.totalPages > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "PDF pages")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, pageStatsSummary.totalPages, " total \xb7", " ", pageStatsSummary.textPages, " text \xb7", " ", pageStatsSummary.scannedPages, " scanned"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666"
        }
    }, "No files uploaded yet."), ocrProgress && ocrProgress.phase === "classify" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            padding: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Classifying PDF files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.fileCount > 0 ? `${Math.floor(ocrProgress.filesCompleted / ocrProgress.fileCount * 100)}%` : "0%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "PDF classification progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.fileCount > 0 ? ocrProgress.filesCompleted / ocrProgress.fileCount * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, `${ocrProgress.filesCompleted} of ${ocrProgress.fileCount} files classified`, ocrProgress.label ? ` \xb7 ${ocrProgress.label}` : "")), ocrProgress && ocrProgress.phase === "extract" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            padding: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 16
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.overallTotal > 0 ? `${Math.floor(ocrProgress.overallCompleted / ocrProgress.overallTotal * 100)}%` : "Counting pages\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "OCR pages progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.overallTotal > 0 ? ocrProgress.overallCompleted / ocrProgress.overallTotal * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, ocrProgress.overallTotal > 0 ? `${ocrProgress.overallCompleted} of ${ocrProgress.overallTotal} pages processed` : "Counting pages\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.fileCount > 0 ? `${Math.floor(ocrProgress.filesCompleted / ocrProgress.fileCount * 100)}%` : "0%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "OCR files progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.fileCount > 0 ? ocrProgress.filesCompleted / ocrProgress.fileCount * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, `${ocrProgress.filesCompleted} of ${ocrProgress.fileCount} files processed`, ocrProgress.label ? ` \xb7 ${ocrProgress.label}` : ""))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            marginTop: 24,
            padding: 16,
            background: "#fafafa"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Or analyze a single PDF"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: "0 0 12px",
            color: "#555",
            fontSize: 14
        }
    }, "Upload one PDF file and select which reference document it should be compared against."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$SinglePdfRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e464d85de0bbd46d$export$6c8108ad15125580), {
        rootProps: getRootProps({
            isDragAccept: isDragAccept
        }),
        inputProps: getInputProps(),
        open: open,
        disabled: singlePdfAnalyzing || hasReportResults
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$SinglePdfControls, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
        options: referenceDropdownOptions,
        value: selectedReferenceIndex !== null ? referenceDropdownOptions[selectedReferenceIndex] : null,
        onChange: (option)=>{
            const idx = option && typeof option.value === "string" ? parseInt(option.value, 10) : NaN;
            setSelectedReferenceIndex(Number.isFinite(idx) && idx >= 0 && idx < (0, $81b98fb9de868a7b$export$63b727d6e7a38867).length ? idx : null);
        },
        placeholder: "Select reference document",
        isClearable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: singlePdfAnalyzing ? "Analyzing\u2026 PLEASE WAIT" : "Analyze single PDF",
        onClick: handleAnalyzeSinglePdf,
        disabled: !singlePdfFile || selectedReferenceIndex === null || singlePdfAnalyzing || hasReportResults
    }))), singlePdfFile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: 13,
            color: "#333"
        }
    }, "Selected file: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, singlePdfFile.fileName))), (latestFile || promptResults.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$PrintContainer, {
        style: {
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            marginTop: 24,
            padding: 16,
            background: "#fafafa",
            position: "relative",
            minHeight: 120
        },
        ref: printRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Document analysis results"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$NoPrint, {
        style: {
            display: "flex",
            gap: 8,
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Clear results",
        onClick: ()=>setIsClearResultsModalOpen(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Prepare printout",
        onClick: handlePrint,
        disabled: !sortedResults.length
    }))), promptsInFlight > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, progressTotal > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Running analysis"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, Math.floor(progressCompleted / progressTotal * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "Analysis progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${progressCompleted / progressTotal * 100}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, progressCompleted, " of ", progressTotal, " files processed", progressLastFile ? ` \u{2022} Last: ${progressLastFile}` : ""))), sortedResults.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, sortedResults.map((r)=>{
        const name = r.fileName || "Unknown file";
        const referenceUrl = r.reference.sourceUrl;
        const referenceName = r.reference.sourceName;
        const safeHtml = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(r.text || "", {
            USE_PROFILES: {
                html: true
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `${name}-${r.reference.ectdKey}-${r.reference.sourceName}`,
            style: {
                marginBottom: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, "File: ", name), r.inputTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: "#fff8e1",
                border: "1px solid #ffe082",
                borderRadius: 6,
                padding: "8px 12px",
                marginBottom: 8,
                color: "#7a5c00",
                fontSize: 14
            }
        }, "The prompt was shortened because it was too long, so this result may not cover the full document."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "This document was compared to the following reference:", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            href: referenceUrl,
            target: "_blank",
            rel: "noopener noreferrer"
        }, referenceName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: safeHtml
            }
        }));
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666"
        }
    }, "Waiting for document analysis...", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("br", null), "It usually takes about 2-3 minutes."), literatureValidation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, "Literature references check"), literatureValidation.nonclinical || literatureValidation.clinical ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 16
        }
    }, literatureValidation.nonclinical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$OverviewValidationBlock, {
        label: "Nonclinical overview (M2.4)",
        overview: literatureValidation.nonclinical,
        validModuleLabel: "M4.3 (literature references)"
    }), !literatureValidation.nonclinical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666",
            fontSize: 14
        }
    }, "Nonclinical overview (M2.4): overview not found in package."), literatureValidation.clinical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2e711560b32d2ad8$var$OverviewValidationBlock, {
        label: "Clinical overview (M2.5)",
        overview: literatureValidation.clinical,
        validModuleLabel: "M5.4 (literature references)"
    }), !literatureValidation.clinical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666",
            fontSize: 14
        }
    }, "Clinical overview (M2.5): overview not found in package.")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666",
            fontSize: 14
        }
    }, "No overview documents (M2.4 / M2.5) found in package."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isClearResultsModalOpen,
        title: "Clear results?",
        message: "This will clear all report results and re-enable file uploads. Do you want to continue?",
        closeModal: ()=>setIsClearResultsModalOpen(false),
        acceptModal: ()=>{
            handleClearResults();
            setIsClearResultsModalOpen(false);
        },
        yesButtonText: "Clear"
    }))));
};
var $2e711560b32d2ad8$export$2e2bcd8739ae039 = $2e711560b32d2ad8$export$97ff6b38098aefc3;
const $2e711560b32d2ad8$var$Container = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
const $2e711560b32d2ad8$var$NoPrint = (0, $lmFrL.default).div`
  @media print {
    display: none;
  }
`;
const $2e711560b32d2ad8$var$PrintContainer = (0, $lmFrL.default).div`
  @media print {
    display: block;

    @page {
      margin: 1cm;
    }
  }
`;
const $2e711560b32d2ad8$var$SinglePdfRow = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: flex-start;
  gap: 16px;
`;
const $2e711560b32d2ad8$var$SinglePdfControls = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;



var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");













/**
 * Matching of loose (non-eCTD-packaged) PDF files to canonical eCTD section
 * keys. Files are matched deterministically from section codes found anywhere
 * on the first PDF page (position-independent), combined with folder and
 * filename hints; files that stay unresolved can be classified with a single
 * batched LLM call (see classifyUnmatchedWithLlm).
 */ /**
 * Typed accessors over the canonical eCTD backbone sections generated from
 * the official EMA/ICH DTDs (see ./dtd/SOURCES.md and ectdSections.generated.ts).
 */ 
/* eslint-disable */ /**
 * AUTO-GENERATED by scripts/generateEctdSections.js - DO NOT EDIT.
 *
 * Canonical eCTD backbone sections parsed from the official DTDs in
 * ./dtd/ (ICH eCTD v3.2.2 for Modules 2-5, EU M1 eCTD for Module 1).
 * See ./dtd/SOURCES.md for provenance. Regenerate with: npm run generate:ectd
 */ const $48af5458de2399a4$export$5e8082a2a7905571 = [
    {
        "key": "m1-administrative-information-and-prescribing-information",
        "code": "1",
        "title": "Administrative Information And Prescribing Information",
        "module": 1,
        "parentKey": null,
        "childKeys": [],
        "depth": 0,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-common-technical-document-summaries",
        "code": "2",
        "title": "Common Technical Document Summaries",
        "module": 2,
        "parentKey": null,
        "childKeys": [
            "m2-2-introduction",
            "m2-3-quality-overall-summary",
            "m2-4-nonclinical-overview",
            "m2-5-clinical-overview",
            "m2-6-nonclinical-written-and-tabulated-summaries",
            "m2-7-clinical-summary"
        ],
        "depth": 0,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-2-introduction",
        "code": "2.2",
        "title": "Introduction",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-3-quality-overall-summary",
        "code": "2.3",
        "title": "Quality Overall Summary",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [
            "m2-3-introduction",
            "m2-3-s-drug-substance",
            "m2-3-p-drug-product",
            "m2-3-a-appendices",
            "m2-3-r-regional-information"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-3-introduction",
        "code": "2.3",
        "title": "Introduction",
        "module": 2,
        "parentKey": "m2-3-quality-overall-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-3-s-drug-substance",
        "code": "2.3.S",
        "title": "Drug Substance",
        "module": 2,
        "parentKey": "m2-3-quality-overall-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "substance",
            "manufacturer"
        ]
    },
    {
        "key": "m2-3-p-drug-product",
        "code": "2.3.P",
        "title": "Drug Product",
        "module": 2,
        "parentKey": "m2-3-quality-overall-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "product-name",
            "dosageform",
            "manufacturer"
        ]
    },
    {
        "key": "m2-3-a-appendices",
        "code": "2.3.A",
        "title": "Appendices",
        "module": 2,
        "parentKey": "m2-3-quality-overall-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-3-r-regional-information",
        "code": "2.3.R",
        "title": "Regional Information",
        "module": 2,
        "parentKey": "m2-3-quality-overall-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-4-nonclinical-overview",
        "code": "2.4",
        "title": "Nonclinical Overview",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-5-clinical-overview",
        "code": "2.5",
        "title": "Clinical Overview",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-nonclinical-written-and-tabulated-summaries",
        "code": "2.6",
        "title": "Nonclinical Written And Tabulated Summaries",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [
            "m2-6-1-introduction",
            "m2-6-2-pharmacology-written-summary",
            "m2-6-3-pharmacology-tabulated-summary",
            "m2-6-4-pharmacokinetics-written-summary",
            "m2-6-5-pharmacokinetics-tabulated-summary",
            "m2-6-6-toxicology-written-summary",
            "m2-6-7-toxicology-tabulated-summary"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-1-introduction",
        "code": "2.6.1",
        "title": "Introduction",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-2-pharmacology-written-summary",
        "code": "2.6.2",
        "title": "Pharmacology Written Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-3-pharmacology-tabulated-summary",
        "code": "2.6.3",
        "title": "Pharmacology Tabulated Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-4-pharmacokinetics-written-summary",
        "code": "2.6.4",
        "title": "Pharmacokinetics Written Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-5-pharmacokinetics-tabulated-summary",
        "code": "2.6.5",
        "title": "Pharmacokinetics Tabulated Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-6-toxicology-written-summary",
        "code": "2.6.6",
        "title": "Toxicology Written Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-6-7-toxicology-tabulated-summary",
        "code": "2.6.7",
        "title": "Toxicology Tabulated Summary",
        "module": 2,
        "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-clinical-summary",
        "code": "2.7",
        "title": "Clinical Summary",
        "module": 2,
        "parentKey": "m2-common-technical-document-summaries",
        "childKeys": [
            "m2-7-1-summary-of-biopharmaceutic-studies-and-associated-analytical-methods",
            "m2-7-2-summary-of-clinical-pharmacology-studies",
            "m2-7-3-summary-of-clinical-efficacy",
            "m2-7-4-summary-of-clinical-safety",
            "m2-7-5-literature-references",
            "m2-7-6-synopses-of-individual-studies"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-1-summary-of-biopharmaceutic-studies-and-associated-analytical-methods",
        "code": "2.7.1",
        "title": "Summary Of Biopharmaceutic Studies And Associated Analytical Methods",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-2-summary-of-clinical-pharmacology-studies",
        "code": "2.7.2",
        "title": "Summary Of Clinical Pharmacology Studies",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-3-summary-of-clinical-efficacy",
        "code": "2.7.3",
        "title": "Summary Of Clinical Efficacy",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "indication"
        ]
    },
    {
        "key": "m2-7-4-summary-of-clinical-safety",
        "code": "2.7.4",
        "title": "Summary Of Clinical Safety",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-5-literature-references",
        "code": "2.7.5",
        "title": "Literature References",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m2-7-6-synopses-of-individual-studies",
        "code": "2.7.6",
        "title": "Synopses Of Individual Studies",
        "module": 2,
        "parentKey": "m2-7-clinical-summary",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-quality",
        "code": "3",
        "title": "Quality",
        "module": 3,
        "parentKey": null,
        "childKeys": [
            "m3-2-body-of-data",
            "m3-3-literature-references"
        ],
        "depth": 0,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-body-of-data",
        "code": "3.2",
        "title": "Body Of Data",
        "module": 3,
        "parentKey": "m3-quality",
        "childKeys": [
            "m3-2-s-drug-substance",
            "m3-2-p-drug-product",
            "m3-2-a-appendices",
            "m3-2-r-regional-information"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-drug-substance",
        "code": "3.2.S",
        "title": "Drug Substance",
        "module": 3,
        "parentKey": "m3-2-body-of-data",
        "childKeys": [
            "m3-2-s-1-general-information",
            "m3-2-s-2-manufacture",
            "m3-2-s-3-characterisation",
            "m3-2-s-4-control-of-drug-substance",
            "m3-2-s-5-reference-standards-or-materials",
            "m3-2-s-6-container-closure-system",
            "m3-2-s-7-stability"
        ],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "substance",
            "manufacturer"
        ]
    },
    {
        "key": "m3-2-s-1-general-information",
        "code": "3.2.S.1",
        "title": "General Information",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [
            "m3-2-s-1-1-nomenclature",
            "m3-2-s-1-2-structure",
            "m3-2-s-1-3-general-properties"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-1-1-nomenclature",
        "code": "3.2.S.1.1",
        "title": "Nomenclature",
        "module": 3,
        "parentKey": "m3-2-s-1-general-information",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-1-2-structure",
        "code": "3.2.S.1.2",
        "title": "Structure",
        "module": 3,
        "parentKey": "m3-2-s-1-general-information",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-1-3-general-properties",
        "code": "3.2.S.1.3",
        "title": "General Properties",
        "module": 3,
        "parentKey": "m3-2-s-1-general-information",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-manufacture",
        "code": "3.2.S.2",
        "title": "Manufacture",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [
            "m3-2-s-2-1-manufacturer",
            "m3-2-s-2-2-description-of-manufacturing-process-and-process-controls",
            "m3-2-s-2-3-control-of-materials",
            "m3-2-s-2-4-controls-of-critical-steps-and-intermediates",
            "m3-2-s-2-5-process-validation-and-or-evaluation",
            "m3-2-s-2-6-manufacturing-process-development"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-1-manufacturer",
        "code": "3.2.S.2.1",
        "title": "Manufacturer",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-2-description-of-manufacturing-process-and-process-controls",
        "code": "3.2.S.2.2",
        "title": "Description Of Manufacturing Process And Process Controls",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-3-control-of-materials",
        "code": "3.2.S.2.3",
        "title": "Control Of Materials",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-4-controls-of-critical-steps-and-intermediates",
        "code": "3.2.S.2.4",
        "title": "Controls Of Critical Steps And Intermediates",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-5-process-validation-and-or-evaluation",
        "code": "3.2.S.2.5",
        "title": "Process Validation And/Or Evaluation",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-2-6-manufacturing-process-development",
        "code": "3.2.S.2.6",
        "title": "Manufacturing Process Development",
        "module": 3,
        "parentKey": "m3-2-s-2-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-3-characterisation",
        "code": "3.2.S.3",
        "title": "Characterisation",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [
            "m3-2-s-3-1-elucidation-of-structure-and-other-characteristics",
            "m3-2-s-3-2-impurities"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-3-1-elucidation-of-structure-and-other-characteristics",
        "code": "3.2.S.3.1",
        "title": "Elucidation Of Structure And Other Characteristics",
        "module": 3,
        "parentKey": "m3-2-s-3-characterisation",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-3-2-impurities",
        "code": "3.2.S.3.2",
        "title": "Impurities",
        "module": 3,
        "parentKey": "m3-2-s-3-characterisation",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-control-of-drug-substance",
        "code": "3.2.S.4",
        "title": "Control Of Drug Substance",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [
            "m3-2-s-4-1-specification",
            "m3-2-s-4-2-analytical-procedures",
            "m3-2-s-4-3-validation-of-analytical-procedures",
            "m3-2-s-4-4-batch-analyses",
            "m3-2-s-4-5-justification-of-specification"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-1-specification",
        "code": "3.2.S.4.1",
        "title": "Specification",
        "module": 3,
        "parentKey": "m3-2-s-4-control-of-drug-substance",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-2-analytical-procedures",
        "code": "3.2.S.4.2",
        "title": "Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-s-4-control-of-drug-substance",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-3-validation-of-analytical-procedures",
        "code": "3.2.S.4.3",
        "title": "Validation Of Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-s-4-control-of-drug-substance",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-4-batch-analyses",
        "code": "3.2.S.4.4",
        "title": "Batch Analyses",
        "module": 3,
        "parentKey": "m3-2-s-4-control-of-drug-substance",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-4-5-justification-of-specification",
        "code": "3.2.S.4.5",
        "title": "Justification Of Specification",
        "module": 3,
        "parentKey": "m3-2-s-4-control-of-drug-substance",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-5-reference-standards-or-materials",
        "code": "3.2.S.5",
        "title": "Reference Standards Or Materials",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-6-container-closure-system",
        "code": "3.2.S.6",
        "title": "Container Closure System",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-7-stability",
        "code": "3.2.S.7",
        "title": "Stability",
        "module": 3,
        "parentKey": "m3-2-s-drug-substance",
        "childKeys": [
            "m3-2-s-7-1-stability-summary-and-conclusions",
            "m3-2-s-7-2-post-approval-stability-protocol-and-stability-commitment",
            "m3-2-s-7-3-stability-data"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-7-1-stability-summary-and-conclusions",
        "code": "3.2.S.7.1",
        "title": "Stability Summary And Conclusions",
        "module": 3,
        "parentKey": "m3-2-s-7-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-7-2-post-approval-stability-protocol-and-stability-commitment",
        "code": "3.2.S.7.2",
        "title": "Post Approval Stability Protocol And Stability Commitment",
        "module": 3,
        "parentKey": "m3-2-s-7-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-s-7-3-stability-data",
        "code": "3.2.S.7.3",
        "title": "Stability Data",
        "module": 3,
        "parentKey": "m3-2-s-7-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-drug-product",
        "code": "3.2.P",
        "title": "Drug Product",
        "module": 3,
        "parentKey": "m3-2-body-of-data",
        "childKeys": [
            "m3-2-p-1-description-and-composition-of-the-drug-product",
            "m3-2-p-2-pharmaceutical-development",
            "m3-2-p-3-manufacture",
            "m3-2-p-4-control-of-excipients",
            "m3-2-p-5-control-of-drug-product",
            "m3-2-p-6-reference-standards-or-materials",
            "m3-2-p-7-container-closure-system",
            "m3-2-p-8-stability"
        ],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "product-name",
            "dosageform",
            "manufacturer"
        ]
    },
    {
        "key": "m3-2-p-1-description-and-composition-of-the-drug-product",
        "code": "3.2.P.1",
        "title": "Description And Composition Of The Drug Product",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-2-pharmaceutical-development",
        "code": "3.2.P.2",
        "title": "Pharmaceutical Development",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-manufacture",
        "code": "3.2.P.3",
        "title": "Manufacture",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [
            "m3-2-p-3-1-manufacturers",
            "m3-2-p-3-2-batch-formula",
            "m3-2-p-3-3-description-of-manufacturing-process-and-process-controls",
            "m3-2-p-3-4-controls-of-critical-steps-and-intermediates",
            "m3-2-p-3-5-process-validation-and-or-evaluation"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-1-manufacturers",
        "code": "3.2.P.3.1",
        "title": "Manufacturers",
        "module": 3,
        "parentKey": "m3-2-p-3-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-2-batch-formula",
        "code": "3.2.P.3.2",
        "title": "Batch Formula",
        "module": 3,
        "parentKey": "m3-2-p-3-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-3-description-of-manufacturing-process-and-process-controls",
        "code": "3.2.P.3.3",
        "title": "Description Of Manufacturing Process And Process Controls",
        "module": 3,
        "parentKey": "m3-2-p-3-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-4-controls-of-critical-steps-and-intermediates",
        "code": "3.2.P.3.4",
        "title": "Controls Of Critical Steps And Intermediates",
        "module": 3,
        "parentKey": "m3-2-p-3-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-3-5-process-validation-and-or-evaluation",
        "code": "3.2.P.3.5",
        "title": "Process Validation And/Or Evaluation",
        "module": 3,
        "parentKey": "m3-2-p-3-manufacture",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-control-of-excipients",
        "code": "3.2.P.4",
        "title": "Control Of Excipients",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [
            "m3-2-p-4-1-specifications",
            "m3-2-p-4-2-analytical-procedures",
            "m3-2-p-4-3-validation-of-analytical-procedures",
            "m3-2-p-4-4-justification-of-specifications",
            "m3-2-p-4-5-excipients-of-human-or-animal-origin",
            "m3-2-p-4-6-novel-excipients"
        ],
        "depth": 3,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "excipient"
        ]
    },
    {
        "key": "m3-2-p-4-1-specifications",
        "code": "3.2.P.4.1",
        "title": "Specifications",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-2-analytical-procedures",
        "code": "3.2.P.4.2",
        "title": "Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-3-validation-of-analytical-procedures",
        "code": "3.2.P.4.3",
        "title": "Validation Of Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-4-justification-of-specifications",
        "code": "3.2.P.4.4",
        "title": "Justification Of Specifications",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-5-excipients-of-human-or-animal-origin",
        "code": "3.2.P.4.5",
        "title": "Excipients Of Human Or Animal Origin",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-4-6-novel-excipients",
        "code": "3.2.P.4.6",
        "title": "Novel Excipients",
        "module": 3,
        "parentKey": "m3-2-p-4-control-of-excipients",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-control-of-drug-product",
        "code": "3.2.P.5",
        "title": "Control Of Drug Product",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [
            "m3-2-p-5-1-specifications",
            "m3-2-p-5-2-analytical-procedures",
            "m3-2-p-5-3-validation-of-analytical-procedures",
            "m3-2-p-5-4-batch-analyses",
            "m3-2-p-5-5-characterisation-of-impurities",
            "m3-2-p-5-6-justification-of-specifications"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-1-specifications",
        "code": "3.2.P.5.1",
        "title": "Specifications",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-2-analytical-procedures",
        "code": "3.2.P.5.2",
        "title": "Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-3-validation-of-analytical-procedures",
        "code": "3.2.P.5.3",
        "title": "Validation Of Analytical Procedures",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-4-batch-analyses",
        "code": "3.2.P.5.4",
        "title": "Batch Analyses",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-5-characterisation-of-impurities",
        "code": "3.2.P.5.5",
        "title": "Characterisation Of Impurities",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-5-6-justification-of-specifications",
        "code": "3.2.P.5.6",
        "title": "Justification Of Specifications",
        "module": 3,
        "parentKey": "m3-2-p-5-control-of-drug-product",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-6-reference-standards-or-materials",
        "code": "3.2.P.6",
        "title": "Reference Standards Or Materials",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-7-container-closure-system",
        "code": "3.2.P.7",
        "title": "Container Closure System",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-8-stability",
        "code": "3.2.P.8",
        "title": "Stability",
        "module": 3,
        "parentKey": "m3-2-p-drug-product",
        "childKeys": [
            "m3-2-p-8-1-stability-summary-and-conclusion",
            "m3-2-p-8-2-post-approval-stability-protocol-and-stability-commitment",
            "m3-2-p-8-3-stability-data"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-8-1-stability-summary-and-conclusion",
        "code": "3.2.P.8.1",
        "title": "Stability Summary And Conclusion",
        "module": 3,
        "parentKey": "m3-2-p-8-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-8-2-post-approval-stability-protocol-and-stability-commitment",
        "code": "3.2.P.8.2",
        "title": "Post Approval Stability Protocol And Stability Commitment",
        "module": 3,
        "parentKey": "m3-2-p-8-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-p-8-3-stability-data",
        "code": "3.2.P.8.3",
        "title": "Stability Data",
        "module": 3,
        "parentKey": "m3-2-p-8-stability",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-a-appendices",
        "code": "3.2.A",
        "title": "Appendices",
        "module": 3,
        "parentKey": "m3-2-body-of-data",
        "childKeys": [
            "m3-2-a-1-facilities-and-equipment",
            "m3-2-a-2-adventitious-agents-safety-evaluation",
            "m3-2-a-3-excipients"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-a-1-facilities-and-equipment",
        "code": "3.2.A.1",
        "title": "Facilities And Equipment",
        "module": 3,
        "parentKey": "m3-2-a-appendices",
        "childKeys": [],
        "depth": 3,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "manufacturer",
            "substance",
            "dosageform",
            "product-name"
        ]
    },
    {
        "key": "m3-2-a-2-adventitious-agents-safety-evaluation",
        "code": "3.2.A.2",
        "title": "Adventitious Agents Safety Evaluation",
        "module": 3,
        "parentKey": "m3-2-a-appendices",
        "childKeys": [],
        "depth": 3,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "manufacturer",
            "substance",
            "dosageform",
            "product-name"
        ]
    },
    {
        "key": "m3-2-a-3-excipients",
        "code": "3.2.A.3",
        "title": "Excipients",
        "module": 3,
        "parentKey": "m3-2-a-appendices",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-2-r-regional-information",
        "code": "3.2.R",
        "title": "Regional Information",
        "module": 3,
        "parentKey": "m3-2-body-of-data",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m3-3-literature-references",
        "code": "3.3",
        "title": "Literature References",
        "module": 3,
        "parentKey": "m3-quality",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-nonclinical-study-reports",
        "code": "4",
        "title": "Nonclinical Study Reports",
        "module": 4,
        "parentKey": null,
        "childKeys": [
            "m4-2-study-reports",
            "m4-3-literature-references"
        ],
        "depth": 0,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-study-reports",
        "code": "4.2",
        "title": "Study Reports",
        "module": 4,
        "parentKey": "m4-nonclinical-study-reports",
        "childKeys": [
            "m4-2-1-pharmacology",
            "m4-2-2-pharmacokinetics",
            "m4-2-3-toxicology"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-1-pharmacology",
        "code": "4.2.1",
        "title": "Pharmacology",
        "module": 4,
        "parentKey": "m4-2-study-reports",
        "childKeys": [
            "m4-2-1-1-primary-pharmacodynamics",
            "m4-2-1-2-secondary-pharmacodynamics",
            "m4-2-1-3-safety-pharmacology",
            "m4-2-1-4-pharmacodynamic-drug-interactions"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-1-1-primary-pharmacodynamics",
        "code": "4.2.1.1",
        "title": "Primary Pharmacodynamics",
        "module": 4,
        "parentKey": "m4-2-1-pharmacology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-1-2-secondary-pharmacodynamics",
        "code": "4.2.1.2",
        "title": "Secondary Pharmacodynamics",
        "module": 4,
        "parentKey": "m4-2-1-pharmacology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-1-3-safety-pharmacology",
        "code": "4.2.1.3",
        "title": "Safety Pharmacology",
        "module": 4,
        "parentKey": "m4-2-1-pharmacology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-1-4-pharmacodynamic-drug-interactions",
        "code": "4.2.1.4",
        "title": "Pharmacodynamic Drug Interactions",
        "module": 4,
        "parentKey": "m4-2-1-pharmacology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-pharmacokinetics",
        "code": "4.2.2",
        "title": "Pharmacokinetics",
        "module": 4,
        "parentKey": "m4-2-study-reports",
        "childKeys": [
            "m4-2-2-1-analytical-methods-and-validation-reports",
            "m4-2-2-2-absorption",
            "m4-2-2-3-distribution",
            "m4-2-2-4-metabolism",
            "m4-2-2-5-excretion",
            "m4-2-2-6-pharmacokinetic-drug-interactions",
            "m4-2-2-7-other-pharmacokinetic-studies"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-1-analytical-methods-and-validation-reports",
        "code": "4.2.2.1",
        "title": "Analytical Methods And Validation Reports",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-2-absorption",
        "code": "4.2.2.2",
        "title": "Absorption",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-3-distribution",
        "code": "4.2.2.3",
        "title": "Distribution",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-4-metabolism",
        "code": "4.2.2.4",
        "title": "Metabolism",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-5-excretion",
        "code": "4.2.2.5",
        "title": "Excretion",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-6-pharmacokinetic-drug-interactions",
        "code": "4.2.2.6",
        "title": "Pharmacokinetic Drug Interactions",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-2-7-other-pharmacokinetic-studies",
        "code": "4.2.2.7",
        "title": "Other Pharmacokinetic Studies",
        "module": 4,
        "parentKey": "m4-2-2-pharmacokinetics",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-toxicology",
        "code": "4.2.3",
        "title": "Toxicology",
        "module": 4,
        "parentKey": "m4-2-study-reports",
        "childKeys": [
            "m4-2-3-1-single-dose-toxicity",
            "m4-2-3-2-repeat-dose-toxicity",
            "m4-2-3-3-genotoxicity",
            "m4-2-3-4-carcinogenicity",
            "m4-2-3-5-reproductive-and-developmental-toxicity",
            "m4-2-3-6-local-tolerance",
            "m4-2-3-7-other-toxicity-studies"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-1-single-dose-toxicity",
        "code": "4.2.3.1",
        "title": "Single Dose Toxicity",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-2-repeat-dose-toxicity",
        "code": "4.2.3.2",
        "title": "Repeat Dose Toxicity",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-3-genotoxicity",
        "code": "4.2.3.3",
        "title": "Genotoxicity",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [
            "m4-2-3-3-1-in-vitro",
            "m4-2-3-3-2-in-vivo"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-3-1-in-vitro",
        "code": "4.2.3.3.1",
        "title": "In Vitro",
        "module": 4,
        "parentKey": "m4-2-3-3-genotoxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-3-2-in-vivo",
        "code": "4.2.3.3.2",
        "title": "In Vivo",
        "module": 4,
        "parentKey": "m4-2-3-3-genotoxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-4-carcinogenicity",
        "code": "4.2.3.4",
        "title": "Carcinogenicity",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [
            "m4-2-3-4-1-long-term-studies",
            "m4-2-3-4-2-short-or-medium-term-studies",
            "m4-2-3-4-3-other-studies"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-4-1-long-term-studies",
        "code": "4.2.3.4.1",
        "title": "Long Term Studies",
        "module": 4,
        "parentKey": "m4-2-3-4-carcinogenicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-4-2-short-or-medium-term-studies",
        "code": "4.2.3.4.2",
        "title": "Short Or Medium Term Studies",
        "module": 4,
        "parentKey": "m4-2-3-4-carcinogenicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-4-3-other-studies",
        "code": "4.2.3.4.3",
        "title": "Other Studies",
        "module": 4,
        "parentKey": "m4-2-3-4-carcinogenicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-5-reproductive-and-developmental-toxicity",
        "code": "4.2.3.5",
        "title": "Reproductive And Developmental Toxicity",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [
            "m4-2-3-5-1-fertility-and-early-embryonic-development",
            "m4-2-3-5-2-embryo-fetal-development",
            "m4-2-3-5-3-prenatal-and-postnatal-development-including-maternal-function",
            "m4-2-3-5-4-studies-in-which-the-offspring-juvenile-animals-are-dosed-and-or-further-evaluated"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-5-1-fertility-and-early-embryonic-development",
        "code": "4.2.3.5.1",
        "title": "Fertility And Early Embryonic Development",
        "module": 4,
        "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-5-2-embryo-fetal-development",
        "code": "4.2.3.5.2",
        "title": "Embryo Fetal Development",
        "module": 4,
        "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-5-3-prenatal-and-postnatal-development-including-maternal-function",
        "code": "4.2.3.5.3",
        "title": "Prenatal And Postnatal Development Including Maternal Function",
        "module": 4,
        "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-5-4-studies-in-which-the-offspring-juvenile-animals-are-dosed-and-or-further-evaluated",
        "code": "4.2.3.5.4",
        "title": "Studies In Which The Offspring Juvenile Animals Are Dosed And/Or Further Evaluated",
        "module": 4,
        "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-6-local-tolerance",
        "code": "4.2.3.6",
        "title": "Local Tolerance",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-other-toxicity-studies",
        "code": "4.2.3.7",
        "title": "Other Toxicity Studies",
        "module": 4,
        "parentKey": "m4-2-3-toxicology",
        "childKeys": [
            "m4-2-3-7-1-antigenicity",
            "m4-2-3-7-2-immunotoxicity",
            "m4-2-3-7-3-mechanistic-studies",
            "m4-2-3-7-4-dependence",
            "m4-2-3-7-5-metabolites",
            "m4-2-3-7-6-impurities",
            "m4-2-3-7-7-other"
        ],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-1-antigenicity",
        "code": "4.2.3.7.1",
        "title": "Antigenicity",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-2-immunotoxicity",
        "code": "4.2.3.7.2",
        "title": "Immunotoxicity",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-3-mechanistic-studies",
        "code": "4.2.3.7.3",
        "title": "Mechanistic Studies",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-4-dependence",
        "code": "4.2.3.7.4",
        "title": "Dependence",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-5-metabolites",
        "code": "4.2.3.7.5",
        "title": "Metabolites",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-6-impurities",
        "code": "4.2.3.7.6",
        "title": "Impurities",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-2-3-7-7-other",
        "code": "4.2.3.7.7",
        "title": "Other",
        "module": 4,
        "parentKey": "m4-2-3-7-other-toxicity-studies",
        "childKeys": [],
        "depth": 4,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m4-3-literature-references",
        "code": "4.3",
        "title": "Literature References",
        "module": 4,
        "parentKey": "m4-nonclinical-study-reports",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-clinical-study-reports",
        "code": "5",
        "title": "Clinical Study Reports",
        "module": 5,
        "parentKey": null,
        "childKeys": [
            "m5-2-tabular-listing-of-all-clinical-studies",
            "m5-3-clinical-study-reports",
            "m5-4-literature-references"
        ],
        "depth": 0,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-2-tabular-listing-of-all-clinical-studies",
        "code": "5.2",
        "title": "Tabular Listing Of All Clinical Studies",
        "module": 5,
        "parentKey": "m5-clinical-study-reports",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-clinical-study-reports",
        "code": "5.3",
        "title": "Clinical Study Reports",
        "module": 5,
        "parentKey": "m5-clinical-study-reports",
        "childKeys": [
            "m5-3-1-reports-of-biopharmaceutic-studies",
            "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
            "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
            "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
            "m5-3-5-reports-of-efficacy-and-safety-studies",
            "m5-3-6-reports-of-postmarketing-experience",
            "m5-3-7-case-report-forms-and-individual-patient-listings"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-1-reports-of-biopharmaceutic-studies",
        "code": "5.3.1",
        "title": "Reports Of Biopharmaceutic Studies",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [
            "m5-3-1-1-bioavailability-study-reports",
            "m5-3-1-2-comparative-ba-and-bioequivalence-study-reports",
            "m5-3-1-3-in-vitro-in-vivo-correlation-study-reports",
            "m5-3-1-4-reports-of-bioanalytical-and-analytical-methods-for-human-studies"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-1-1-bioavailability-study-reports",
        "code": "5.3.1.1",
        "title": "Bioavailability Study Reports",
        "module": 5,
        "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-1-2-comparative-ba-and-bioequivalence-study-reports",
        "code": "5.3.1.2",
        "title": "Comparative Ba And Bioequivalence Study Reports",
        "module": 5,
        "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-1-3-in-vitro-in-vivo-correlation-study-reports",
        "code": "5.3.1.3",
        "title": "In Vitro In Vivo Correlation Study Reports",
        "module": 5,
        "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-1-4-reports-of-bioanalytical-and-analytical-methods-for-human-studies",
        "code": "5.3.1.4",
        "title": "Reports Of Bioanalytical And Analytical Methods For Human Studies",
        "module": 5,
        "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
        "code": "5.3.2",
        "title": "Reports Of Studies Pertinent To Pharmacokinetics Using Human Biomaterials",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [
            "m5-3-2-1-plasma-protein-binding-study-reports",
            "m5-3-2-2-reports-of-hepatic-metabolism-and-drug-interaction-studies",
            "m5-3-2-3-reports-of-studies-using-other-human-biomaterials"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-2-1-plasma-protein-binding-study-reports",
        "code": "5.3.2.1",
        "title": "Plasma Protein Binding Study Reports",
        "module": 5,
        "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-2-2-reports-of-hepatic-metabolism-and-drug-interaction-studies",
        "code": "5.3.2.2",
        "title": "Reports Of Hepatic Metabolism And Drug Interaction Studies",
        "module": 5,
        "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-2-3-reports-of-studies-using-other-human-biomaterials",
        "code": "5.3.2.3",
        "title": "Reports Of Studies Using Other Human Biomaterials",
        "module": 5,
        "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "code": "5.3.3",
        "title": "Reports Of Human Pharmacokinetics Pk Studies",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [
            "m5-3-3-1-healthy-subject-pk-and-initial-tolerability-study-reports",
            "m5-3-3-2-patient-pk-and-initial-tolerability-study-reports",
            "m5-3-3-3-intrinsic-factor-pk-study-reports",
            "m5-3-3-4-extrinsic-factor-pk-study-reports",
            "m5-3-3-5-population-pk-study-reports"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-1-healthy-subject-pk-and-initial-tolerability-study-reports",
        "code": "5.3.3.1",
        "title": "Healthy Subject Pk And Initial Tolerability Study Reports",
        "module": 5,
        "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-2-patient-pk-and-initial-tolerability-study-reports",
        "code": "5.3.3.2",
        "title": "Patient Pk And Initial Tolerability Study Reports",
        "module": 5,
        "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-3-intrinsic-factor-pk-study-reports",
        "code": "5.3.3.3",
        "title": "Intrinsic Factor Pk Study Reports",
        "module": 5,
        "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-4-extrinsic-factor-pk-study-reports",
        "code": "5.3.3.4",
        "title": "Extrinsic Factor Pk Study Reports",
        "module": 5,
        "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-3-5-population-pk-study-reports",
        "code": "5.3.3.5",
        "title": "Population Pk Study Reports",
        "module": 5,
        "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
        "code": "5.3.4",
        "title": "Reports Of Human Pharmacodynamics Pd Studies",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [
            "m5-3-4-1-healthy-subject-pd-and-pk-pd-study-reports",
            "m5-3-4-2-patient-pd-and-pk-pd-study-reports"
        ],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-4-1-healthy-subject-pd-and-pk-pd-study-reports",
        "code": "5.3.4.1",
        "title": "Healthy Subject Pd And Pk Pd Study Reports",
        "module": 5,
        "parentKey": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-4-2-patient-pd-and-pk-pd-study-reports",
        "code": "5.3.4.2",
        "title": "Patient Pd And Pk Pd Study Reports",
        "module": 5,
        "parentKey": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-5-reports-of-efficacy-and-safety-studies",
        "code": "5.3.5",
        "title": "Reports Of Efficacy And Safety Studies",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [
            "m5-3-5-1-study-reports-of-controlled-clinical-studies-pertinent-to-the-claimed-indication",
            "m5-3-5-2-study-reports-of-uncontrolled-clinical-studies",
            "m5-3-5-3-reports-of-analyses-of-data-from-more-than-one-study",
            "m5-3-5-4-other-study-reports"
        ],
        "depth": 2,
        "repeatable": true,
        "optional": true,
        "contextAttributes": [
            "indication"
        ]
    },
    {
        "key": "m5-3-5-1-study-reports-of-controlled-clinical-studies-pertinent-to-the-claimed-indication",
        "code": "5.3.5.1",
        "title": "Study Reports Of Controlled Clinical Studies Pertinent To The Claimed Indication",
        "module": 5,
        "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-5-2-study-reports-of-uncontrolled-clinical-studies",
        "code": "5.3.5.2",
        "title": "Study Reports Of Uncontrolled Clinical Studies",
        "module": 5,
        "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-5-3-reports-of-analyses-of-data-from-more-than-one-study",
        "code": "5.3.5.3",
        "title": "Reports Of Analyses Of Data From More Than One Study",
        "module": 5,
        "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-5-4-other-study-reports",
        "code": "5.3.5.4",
        "title": "Other Study Reports",
        "module": 5,
        "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
        "childKeys": [],
        "depth": 3,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-6-reports-of-postmarketing-experience",
        "code": "5.3.6",
        "title": "Reports Of Postmarketing Experience",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-3-7-case-report-forms-and-individual-patient-listings",
        "code": "5.3.7",
        "title": "Case Report Forms And Individual Patient Listings",
        "module": 5,
        "parentKey": "m5-3-clinical-study-reports",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m5-4-literature-references",
        "code": "5.4",
        "title": "Literature References",
        "module": 5,
        "parentKey": "m5-clinical-study-reports",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-eu",
        "code": "1",
        "title": "Eu",
        "module": 1,
        "parentKey": null,
        "childKeys": [
            "m1-0-cover",
            "m1-2-form",
            "m1-3-pi",
            "m1-4-expert",
            "m1-5-specific",
            "m1-6-environrisk",
            "m1-7-orphan",
            "m1-8-pharmacovigilance",
            "m1-9-clinical-trials",
            "m1-10-paediatrics",
            "m1-responses",
            "m1-additional-data"
        ],
        "depth": 0,
        "repeatable": false,
        "optional": false,
        "contextAttributes": []
    },
    {
        "key": "m1-0-cover",
        "code": "1.0",
        "title": "Cover",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": false,
        "contextAttributes": []
    },
    {
        "key": "m1-2-form",
        "code": "1.2",
        "title": "Form",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-pi",
        "code": "1.3",
        "title": "Pi",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-3-1-spc-label-pl",
            "m1-3-2-mockup",
            "m1-3-3-specimen",
            "m1-3-4-consultation",
            "m1-3-5-approved",
            "m1-3-6-braille"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-1-spc-label-pl",
        "code": "1.3.1",
        "title": "Spc Label Pl",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-2-mockup",
        "code": "1.3.2",
        "title": "Mockup",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-3-specimen",
        "code": "1.3.3",
        "title": "Specimen",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-4-consultation",
        "code": "1.3.4",
        "title": "Consultation",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-5-approved",
        "code": "1.3.5",
        "title": "Approved",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-3-6-braille",
        "code": "1.3.6",
        "title": "Braille",
        "module": 1,
        "parentKey": "m1-3-pi",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-4-expert",
        "code": "1.4",
        "title": "Expert",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-4-1-quality",
            "m1-4-2-non-clinical",
            "m1-4-3-clinical"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-4-1-quality",
        "code": "1.4.1",
        "title": "Quality",
        "module": 1,
        "parentKey": "m1-4-expert",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-4-2-non-clinical",
        "code": "1.4.2",
        "title": "Non Clinical",
        "module": 1,
        "parentKey": "m1-4-expert",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-4-3-clinical",
        "code": "1.4.3",
        "title": "Clinical",
        "module": 1,
        "parentKey": "m1-4-expert",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-specific",
        "code": "1.5",
        "title": "Specific",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-5-1-bibliographic",
            "m1-5-2-generic-hybrid-bio-similar",
            "m1-5-3-data-market-exclusivity",
            "m1-5-4-exceptional-circumstances",
            "m1-5-5-conditional-ma"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-1-bibliographic",
        "code": "1.5.1",
        "title": "Bibliographic",
        "module": 1,
        "parentKey": "m1-5-specific",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-2-generic-hybrid-bio-similar",
        "code": "1.5.2",
        "title": "Generic Hybrid Bio Similar",
        "module": 1,
        "parentKey": "m1-5-specific",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-3-data-market-exclusivity",
        "code": "1.5.3",
        "title": "Data Market Exclusivity",
        "module": 1,
        "parentKey": "m1-5-specific",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-4-exceptional-circumstances",
        "code": "1.5.4",
        "title": "Exceptional Circumstances",
        "module": 1,
        "parentKey": "m1-5-specific",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-5-5-conditional-ma",
        "code": "1.5.5",
        "title": "Conditional Ma",
        "module": 1,
        "parentKey": "m1-5-specific",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-6-environrisk",
        "code": "1.6",
        "title": "Environrisk",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-6-1-non-gmo",
            "m1-6-2-gmo"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-6-1-non-gmo",
        "code": "1.6.1",
        "title": "Non Gmo",
        "module": 1,
        "parentKey": "m1-6-environrisk",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": false,
        "contextAttributes": []
    },
    {
        "key": "m1-6-2-gmo",
        "code": "1.6.2",
        "title": "Gmo",
        "module": 1,
        "parentKey": "m1-6-environrisk",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": false,
        "contextAttributes": []
    },
    {
        "key": "m1-7-orphan",
        "code": "1.7",
        "title": "Orphan",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-7-1-similarity",
            "m1-7-2-market-exclusivity"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-7-1-similarity",
        "code": "1.7.1",
        "title": "Similarity",
        "module": 1,
        "parentKey": "m1-7-orphan",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-7-2-market-exclusivity",
        "code": "1.7.2",
        "title": "Market Exclusivity",
        "module": 1,
        "parentKey": "m1-7-orphan",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-8-pharmacovigilance",
        "code": "1.8",
        "title": "Pharmacovigilance",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [
            "m1-8-1-pharmacovigilance-system",
            "m1-8-2-risk-management-system"
        ],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-8-1-pharmacovigilance-system",
        "code": "1.8.1",
        "title": "Pharmacovigilance System",
        "module": 1,
        "parentKey": "m1-8-pharmacovigilance",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-8-2-risk-management-system",
        "code": "1.8.2",
        "title": "Risk Management System",
        "module": 1,
        "parentKey": "m1-8-pharmacovigilance",
        "childKeys": [],
        "depth": 2,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-9-clinical-trials",
        "code": "1.9",
        "title": "Clinical Trials",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-10-paediatrics",
        "code": "1.10",
        "title": "Paediatrics",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-responses",
        "code": "1",
        "title": "Responses",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    },
    {
        "key": "m1-additional-data",
        "code": "1",
        "title": "Additional Data",
        "module": 1,
        "parentKey": "m1-eu",
        "childKeys": [],
        "depth": 1,
        "repeatable": false,
        "optional": true,
        "contextAttributes": []
    }
];


const $33272e5b46e0901c$var$referenceKeys = (0, $81b98fb9de868a7b$export$63b727d6e7a38867).map((r)=>r.ectdKey).filter((key)=>key && key !== "pi-doc");
function $33272e5b46e0901c$var$resolveReferenceKey(sectionKey) {
    let best;
    $33272e5b46e0901c$var$referenceKeys.forEach((refKey)=>{
        if ((sectionKey === refKey || sectionKey.startsWith(refKey)) && (!best || refKey.length > best.length)) best = refKey;
    });
    return best;
}
const $33272e5b46e0901c$export$3792a546d01e0f03 = (0, $48af5458de2399a4$export$5e8082a2a7905571).map((section)=>({
        ...section,
        referenceKey: $33272e5b46e0901c$var$resolveReferenceKey(section.key)
    }));
const $33272e5b46e0901c$var$sectionsByKey = new Map($33272e5b46e0901c$export$3792a546d01e0f03.map((s)=>[
        s.key,
        s
    ]));
// First occurrence wins (ICH document order first, then EU M1). Module 3+
// codes are unique; only shallow module-root codes can collide.
const $33272e5b46e0901c$var$sectionsByCode = new Map();
$33272e5b46e0901c$export$3792a546d01e0f03.forEach((s)=>{
    if (!$33272e5b46e0901c$var$sectionsByCode.has(s.code)) $33272e5b46e0901c$var$sectionsByCode.set(s.code, s);
});
function $33272e5b46e0901c$export$60c55e1260a3eae2(key) {
    return $33272e5b46e0901c$var$sectionsByKey.get(key);
}
function $33272e5b46e0901c$export$1a3246f47ed93fe8(code) {
    return $33272e5b46e0901c$var$sectionsByCode.get(code);
}
function $33272e5b46e0901c$export$aaca38c5bcd0c052(raw) {
    const cleaned = raw.toUpperCase().replace(/\s+/g, "").replace(/[.:;,]+$/g, "");
    if (!cleaned) return null;
    const segments = cleaned.split(".").filter((s)=>s.length > 0);
    while(segments.length > 0){
        const code = segments.join(".");
        if ($33272e5b46e0901c$var$sectionsByCode.has(code)) return code;
        segments.pop();
    }
    return null;
}
function $33272e5b46e0901c$export$221d7a240d8d8e51(section) {
    let outermost = null;
    let current = section;
    while(current){
        if (current.repeatable) outermost = current;
        current = current.parentKey ? $33272e5b46e0901c$var$sectionsByKey.get(current.parentKey) : undefined;
    }
    return outermost;
}
function $33272e5b46e0901c$export$c6fd3ab3f44300d0(section) {
    const ancestors = [];
    let current = section.parentKey ? $33272e5b46e0901c$var$sectionsByKey.get(section.parentKey) : undefined;
    while(current){
        ancestors.unshift(current);
        current = current.parentKey ? $33272e5b46e0901c$var$sectionsByKey.get(current.parentKey) : undefined;
    }
    return ancestors;
}
const $33272e5b46e0901c$var$KEYWORD_STOPWORDS = new Set([
    "of",
    "the",
    "and",
    "or",
    "a",
    "an",
    "for",
    "to",
    "in",
    "on",
    "its"
]);
function $33272e5b46e0901c$export$4af70f8b62218361(section) {
    return section.title.toLowerCase().split(/[^a-z]+/).filter((word)=>word.length > 1 && !$33272e5b46e0901c$var$KEYWORD_STOPWORDS.has(word));
}
function $33272e5b46e0901c$export$dce4845f2c63f6fe(moduleNumber) {
    return $33272e5b46e0901c$export$3792a546d01e0f03.filter((s)=>s.module === moduleNumber);
}
function $33272e5b46e0901c$export$9f650f49adb7472c(descendant, ancestor) {
    let current = descendant.parentKey ? $33272e5b46e0901c$var$sectionsByKey.get(descendant.parentKey) : undefined;
    while(current){
        if (current.key === ancestor.key) return true;
        current = current.parentKey ? $33272e5b46e0901c$var$sectionsByKey.get(current.parentKey) : undefined;
    }
    return false;
}



const $f065dde0569e0444$var$FIRST_PAGE_FALLBACK_CHARS = 3000;
/**
 * Leading markdown/decoration that vision transcriptions put in front of a
 * header ("**Section 3.2.P.8**", "## 3.2.P.8.1", "| 3.2.P.8.1 |", "- 3.2.P.8").
 */ const $f065dde0569e0444$var$LINE_DECORATION_RE = /^[*#_|>\-\s]+/;
function $f065dde0569e0444$var$getFirstPageText(file) {
    if (typeof file.firstPageText === "string" && file.firstPageText.length > 0) return file.firstPageText;
    return (file.text || "").slice(0, $f065dde0569e0444$var$FIRST_PAGE_FALLBACK_CHARS);
}
function $f065dde0569e0444$export$5357960d502b9db(pageText) {
    const occurrences = [];
    const record = (rawCode, offset)=>{
        // Guard against numeric contexts like "13.2..." or "0.3.3"
        const prev = offset > 0 ? pageText[offset - 1] : "";
        if (/[\d.]/.test(prev)) return;
        const code = (0, $33272e5b46e0901c$export$aaca38c5bcd0c052)(rawCode);
        if (!code || !code.startsWith("3")) return;
        const lineStart = pageText.lastIndexOf("\n", offset - 1) + 1;
        const prefix = pageText.slice(lineStart, offset).trim().replace($f065dde0569e0444$var$LINE_DECORATION_RE, "").replace(/[*_]+$/, "").trim();
        // "Section 3.2.S.4 ..." at the start of a line is a header; a mid-sentence
        // "... provided in section 3.2.P.3.5" is a cross-reference and stays weak.
        const afterSectionWord = /^section$/i.test(prefix);
        const atLineStart = prefix === "" || afterSectionWord;
        occurrences.push({
            code: code,
            offset: offset,
            atLineStart: atLineStart,
            afterSectionWord: afterSectionWord
        });
    };
    // Module 3 codes with a part letter: 3.2.S / 3.2.P / 3.2.A / 3.2.R (+ digits)
    const lettered = /3\s*\.\s*2\s*\.?\s*([SPAR])((?:\s*\.\s*\d+)*)/gi;
    let match = lettered.exec(pageText);
    while(match){
        record(`3.2.${match[1]}${match[2] || ""}`, match.index);
        match = lettered.exec(pageText);
    }
    // 3.3 Literature References
    const litRef = /3\s*\.\s*3(?!\s*\.?\s*[\dSPAR])/gi;
    match = litRef.exec(pageText);
    while(match){
        record("3.3", match.index);
        match = litRef.exec(pageText);
    }
    return occurrences.sort((a, b)=>a.offset - b.offset);
}
const $f065dde0569e0444$var$codeSegments = (code)=>code.split(".").length;
const $f065dde0569e0444$var$isCodeDescendant = (child, parent)=>child !== parent && child.startsWith(`${parent}.`);
const $f065dde0569e0444$var$codesRelated = (a, b)=>a === b || $f065dde0569e0444$var$isCodeDescendant(a, b) || $f065dde0569e0444$var$isCodeDescendant(b, a);
function $f065dde0569e0444$export$600073a7bee454a8(pageText) {
    const occurrences = $f065dde0569e0444$export$5357960d502b9db(pageText);
    if (occurrences.length === 0) return {
        group: null,
        leafCandidates: [],
        weakOnly: false,
        groupOffset: 0
    };
    const strong = occurrences.filter((o)=>o.atLineStart || o.afterSectionWord);
    const pool = strong.length > 0 ? strong : occurrences;
    const weakOnly = strong.length === 0;
    // Group: shallowest code; prefer occurrences following the word "Section".
    const sectionWorded = pool.filter((o)=>o.afterSectionWord);
    const groupPool = sectionWorded.length > 0 ? sectionWorded : pool;
    const group = groupPool.reduce((best, o)=>$f065dde0569e0444$var$codeSegments(o.code) < $f065dde0569e0444$var$codeSegments(best.code) ? o : best);
    const leafCandidates = [];
    strong.filter((o)=>o.offset >= group.offset && $f065dde0569e0444$var$isCodeDescendant(o.code, group.code)).forEach((o)=>{
        if (!leafCandidates.includes(o.code)) leafCandidates.push(o.code);
    });
    return {
        group: group.code,
        leafCandidates: leafCandidates,
        weakOnly: weakOnly,
        groupOffset: group.offset
    };
}
function $f065dde0569e0444$export$e76b56eedb8a5a19(segment) {
    const prefix = (segment.split("-")[0] || "").toLowerCase();
    const match = /^3(\d)?([spar])?(\d)?(\d)?$/.exec(prefix);
    if (!match) return null;
    const [, d1, letter, d2, d3] = match;
    let code = "3";
    if (d1) code += `.${d1}`;
    if (letter) code += `.${letter.toUpperCase()}`;
    if (d2) code += `.${d2}`;
    if (d3) code += `.${d3}`;
    return (0, $33272e5b46e0901c$export$aaca38c5bcd0c052)(code);
}
function $f065dde0569e0444$var$pathSegments(fileName) {
    return fileName.replace(/\\/g, "/").split("/").filter(Boolean);
}
function $f065dde0569e0444$export$e4f9f65afe654570(fileName) {
    const dirs = $f065dde0569e0444$var$pathSegments(fileName).slice(0, -1);
    let best = null;
    dirs.forEach((dir)=>{
        const code = $f065dde0569e0444$export$e76b56eedb8a5a19(dir);
        if (code && (!best || $f065dde0569e0444$var$codeSegments(code) > $f065dde0569e0444$var$codeSegments(best))) best = code;
    });
    return best;
}
const $f065dde0569e0444$var$tokenMatchesKeyword = (token, keyword)=>{
    if (token === keyword) return true;
    const len = Math.min(token.length, keyword.length);
    if (len < 3) return false;
    return token.slice(0, len) === keyword.slice(0, len);
};
const $f065dde0569e0444$var$FILENAME_STOPWORDS = new Set([
    "and",
    "the",
    "for",
    "with"
]);
function $f065dde0569e0444$var$filenameTokens(fileName) {
    const base = ($f065dde0569e0444$var$pathSegments(fileName).pop() || "").replace(/\.pdf$/i, "")// Drop manufacturer suffixes like "_Controlled by Orchid Pharma"
    .replace(/_?controlled by.*$/i, "");
    return base.toLowerCase().split(/[^a-z]+/).filter((t)=>t.length >= 3 && !$f065dde0569e0444$var$FILENAME_STOPWORDS.has(t));
}
/**
 * Similarity between filename tokens and a section title: harmonic mean of
 * title-keyword recall and filename-token precision. Recall alone would let a
 * one-word title ("Manufacturers") score 1.0 against
 * "manuf-process-and-controls" on a single prefix match.
 */ function $f065dde0569e0444$var$filenameTitleScore(tokens, keywords) {
    const matchedKeywords = keywords.filter((kw)=>tokens.some((token)=>$f065dde0569e0444$var$tokenMatchesKeyword(token, kw))).length;
    const matchedTokens = tokens.filter((token)=>keywords.some((kw)=>$f065dde0569e0444$var$tokenMatchesKeyword(token, kw))).length;
    if (matchedKeywords === 0 || matchedTokens === 0) return 0;
    const recall = matchedKeywords / keywords.length;
    const precision = matchedTokens / tokens.length;
    return 2 * precision * recall / (precision + recall);
}
function $f065dde0569e0444$export$782448a836fe5d1d(fileName, scope) {
    const tokens = $f065dde0569e0444$var$filenameTokens(fileName);
    if (tokens.length === 0 || scope.length === 0) return null;
    let bestScore = 0;
    let bestSections = [];
    scope.forEach((section)=>{
        const keywords = (0, $33272e5b46e0901c$export$4af70f8b62218361)(section);
        if (keywords.length === 0) return;
        const score = $f065dde0569e0444$var$filenameTitleScore(tokens, keywords);
        if (score > bestScore) {
            bestScore = score;
            bestSections = [
                section
            ];
        } else if (score === bestScore && score > 0) bestSections.push(section);
    });
    if (bestScore >= 0.5 && bestSections.length === 1) return bestSections[0].code;
    return null;
}
const $f065dde0569e0444$var$sectionAndDescendants = (root)=>(0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>s.key === root.key || (0, $33272e5b46e0901c$export$9f650f49adb7472c)(s, root));
/** Strict descendants of the section with the given code ([] if unknown). */ const $f065dde0569e0444$var$descendantsOfCode = (code)=>{
    const root = (0, $33272e5b46e0901c$export$1a3246f47ed93fe8)(code);
    if (!root) return [];
    return (0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>(0, $33272e5b46e0901c$export$9f650f49adb7472c)(s, root));
};
// ---------------------------------------------------------------------------
// Variant detection
// ---------------------------------------------------------------------------
function $f065dde0569e0444$var$variantFromPath(fileName, variantRoot) {
    const segments = $f065dde0569e0444$var$pathSegments(fileName);
    // Directories only (last segment is the file itself)
    for(let i = 0; i < segments.length - 1; i += 1){
        const code = $f065dde0569e0444$export$e76b56eedb8a5a19(segments[i]);
        if (code === variantRoot.code) {
            const next = segments[i + 1];
            const nextIsDirectory = i + 1 < segments.length - 1;
            // The next segment names the variant unless it is itself a section folder
            if (nextIsDirectory && $f065dde0569e0444$export$e76b56eedb8a5a19(next) === null) return next;
            return "";
        }
    }
    return null;
}
function $f065dde0569e0444$var$variantFromPage(pageText) {
    const match = /controlled\s+by\s*[:\-–]?\s*([^)\n]+)/i.exec(pageText);
    if (!match) return null;
    const name = match[1].trim().replace(/[.,;:]+$/, "");
    return name.length > 0 ? name : null;
}
function $f065dde0569e0444$var$detectVariant(file, section) {
    const variantRoot = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(section);
    if (!variantRoot) return undefined;
    const fromPath = $f065dde0569e0444$var$variantFromPath(file.fileName, variantRoot);
    if (fromPath !== null) return fromPath;
    const fromPage = $f065dde0569e0444$var$variantFromPage($f065dde0569e0444$var$getFirstPageText(file));
    if (fromPage) return fromPage;
    return "";
}
// ---------------------------------------------------------------------------
// Not-applicable detection
// ---------------------------------------------------------------------------
const $f065dde0569e0444$var$NOT_APPLICABLE_RE = /not\s+applicable/i;
function $f065dde0569e0444$var$detectNotApplicable(pageText, codeOffset) {
    // A genuine "whole section not applicable" page is essentially just the
    // header plus the declaration; longer pages that merely mention
    // "not applicable" for one sub-item must not be flagged.
    if (pageText.trim().length < 400 && $f065dde0569e0444$var$NOT_APPLICABLE_RE.test(pageText)) return true;
    return $f065dde0569e0444$var$NOT_APPLICABLE_RE.test(pageText.slice(codeOffset, codeOffset + 150));
}
// ---------------------------------------------------------------------------
// Main deterministic matcher
// ---------------------------------------------------------------------------
function $f065dde0569e0444$var$matchSingleFile(file) {
    const pageText = $f065dde0569e0444$var$getFirstPageText(file);
    const header = $f065dde0569e0444$export$600073a7bee454a8(pageText);
    const folderCode = $f065dde0569e0444$export$e4f9f65afe654570(file.fileName);
    const candidates = new Set();
    if (header.group) candidates.add(header.group);
    header.leafCandidates.forEach((c)=>candidates.add(c));
    if (folderCode) candidates.add(folderCode);
    let sectionCode = null;
    let matchedBy = "none";
    let confidence = "low";
    const groupSection = header.group ? (0, $33272e5b46e0901c$export$1a3246f47ed93fe8)(header.group) : undefined;
    if (header.leafCandidates.length === 1) {
        // Single unambiguous leaf code in the header
        [sectionCode] = header.leafCandidates;
        matchedBy = "header";
        confidence = !folderCode || $f065dde0569e0444$var$codesRelated(folderCode, sectionCode) ? "high" : "medium";
    } else if (header.leafCandidates.length > 1) {
        // TOC-style page listing several sibling sections
        const leafSections = header.leafCandidates.map((code)=>(0, $33272e5b46e0901c$export$1a3246f47ed93fe8)(code)).filter((s)=>!!s);
        const fromFilename = $f065dde0569e0444$export$782448a836fe5d1d(file.fileName, leafSections);
        if (fromFilename) {
            sectionCode = fromFilename;
            matchedBy = "filename";
            confidence = "high";
            candidates.add(fromFilename);
        } else if (folderCode && header.leafCandidates.includes(folderCode)) {
            sectionCode = folderCode;
            matchedBy = "folder";
            confidence = "high";
        } else {
            sectionCode = header.group;
            matchedBy = "header";
            confidence = "medium";
        }
    } else if (header.group && !header.weakOnly) {
        // Only a group-level code in the header; try refining with hints
        if (folderCode && $f065dde0569e0444$var$isCodeDescendant(folderCode, header.group)) {
            sectionCode = folderCode;
            matchedBy = "folder";
            confidence = "high";
        } else {
            const scope = groupSection ? $f065dde0569e0444$var$sectionAndDescendants(groupSection) : [];
            const fromFilename = $f065dde0569e0444$export$782448a836fe5d1d(file.fileName, scope.filter((s)=>s.code !== header.group));
            if (fromFilename) {
                sectionCode = fromFilename;
                matchedBy = "filename";
                confidence = "medium";
                candidates.add(fromFilename);
            } else {
                sectionCode = header.group;
                matchedBy = "header";
                // A childless group section (3.2.R, 3.3, 3.2.P.2, ...) is exact
                confidence = groupSection && groupSection.childKeys.length === 0 ? "high" : "medium";
            }
        }
    } else if (folderCode) {
        // No usable header (missing or cross-references only). The folder gives
        // the section; the filename can still pick a subsection within it.
        const fromFilename = $f065dde0569e0444$export$782448a836fe5d1d(file.fileName, $f065dde0569e0444$var$descendantsOfCode(folderCode));
        if (fromFilename) {
            sectionCode = fromFilename;
            matchedBy = "filename";
            candidates.add(fromFilename);
        } else {
            sectionCode = folderCode;
            matchedBy = "folder";
        }
        confidence = "medium";
    } else if (header.group && header.weakOnly) {
        const fromFilename = $f065dde0569e0444$export$782448a836fe5d1d(file.fileName, $f065dde0569e0444$var$descendantsOfCode(header.group));
        if (fromFilename) {
            sectionCode = fromFilename;
            matchedBy = "filename";
            candidates.add(fromFilename);
        } else {
            sectionCode = header.group;
            matchedBy = "header";
        }
        confidence = "low";
    } else {
        const fromFilename = $f065dde0569e0444$export$782448a836fe5d1d(file.fileName, (0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>s.module === 3));
        if (fromFilename) {
            sectionCode = fromFilename;
            matchedBy = "filename";
            confidence = "low";
            candidates.add(fromFilename);
        }
    }
    const section = sectionCode ? (0, $33272e5b46e0901c$export$1a3246f47ed93fe8)(sectionCode) : undefined;
    const declaredNotApplicable = sectionCode ? $f065dde0569e0444$var$detectNotApplicable(pageText, header.group ? header.groupOffset : 0) : false;
    return {
        file: file,
        sectionCode: sectionCode,
        section: section,
        variant: section ? $f065dde0569e0444$var$detectVariant(file, section) : undefined,
        confidence: confidence,
        matchedBy: matchedBy,
        candidates: Array.from(candidates),
        declaredNotApplicable: declaredNotApplicable
    };
}
function $f065dde0569e0444$export$4da2de81425059af(files) {
    return files.map($f065dde0569e0444$var$matchSingleFile);
}
function $f065dde0569e0444$export$1e433dec5cf29e4c(matches, fileName, sectionKey) {
    return matches.map((match)=>{
        if (match.file.fileName !== fileName) return match;
        const section = sectionKey ? (0, $33272e5b46e0901c$export$60c55e1260a3eae2)(sectionKey) : undefined;
        return {
            ...match,
            sectionCode: section ? section.code : null,
            section: section,
            variant: section ? $f065dde0569e0444$var$detectVariant(match.file, section) : undefined,
            matchedBy: "manual",
            confidence: section ? "high" : "low"
        };
    });
}
// ---------------------------------------------------------------------------
// LLM fallback classification (batched)
// ---------------------------------------------------------------------------
const $f065dde0569e0444$var$LLM_EXCERPT_CHARS = 3000;
function $f065dde0569e0444$var$extractJsonArray(text) {
    const start = text.indexOf("[");
    const end = text.lastIndexOf("]");
    if (start === -1 || end <= start) return null;
    try {
        const parsed = JSON.parse(text.slice(start, end + 1));
        return Array.isArray(parsed) ? parsed : null;
    } catch  {
        return null;
    }
}
function $f065dde0569e0444$export$a8551935c32a0765(match) {
    if (!match.sectionCode) return true;
    if (match.confidence === "low") return true;
    if (match.matchedBy === "manual") return false;
    return match.confidence !== "high" && !!match.section && match.section.childKeys.length > 0;
}
async function $f065dde0569e0444$export$e0732da4e7215f3f(matches, options = {}) {
    const unresolved = matches.filter($f065dde0569e0444$export$a8551935c32a0765);
    if (unresolved.length === 0) return matches;
    const sectionList = (0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>s.module === 3).map((s)=>`${s.code} \u{2014} ${s.title}`).join("\n");
    const fileBlocks = unresolved.map((m)=>{
        const excerpt = $f065dde0569e0444$var$getFirstPageText(m.file).slice(0, $f065dde0569e0444$var$LLM_EXCERPT_CHARS);
        return `--- fileName: "${m.file.fileName}"\nFirst page text:\n${excerpt}`;
    }).join("\n\n");
    const userContent = `You are given the first pages of PDF documents from a pharmaceutical dossier that follows the CTD Module 3 structure but is not packaged as eCTD. Assign each file to exactly one eCTD section code from the list below (or null if impossible). If the document names a manufacturer/controller (e.g. "Controlled by X"), report it as "variant".

Known section codes:
${sectionList}

Files:
${fileBlocks}

Respond with ONLY a JSON array, one item per file, in the same order:
[{"fileName": "...", "code": "3.2.S.4.2" | null, "variant": "..." | null}]`;
    try {
        const result = await (0, $23a5f004ceaf672a$export$de1ecd1c5ea6eebe)([
            {
                role: "system",
                content: "You are a precise assistant for regulatory (eCTD/CTD) document classification. Reply with strict JSON only."
            },
            {
                role: "user",
                content: userContent
            }
        ], options);
        const classifications = $f065dde0569e0444$var$extractJsonArray(result.text);
        if (!classifications) return matches;
        const byFileName = new Map();
        classifications.forEach((c)=>{
            if (c && typeof c.fileName === "string") byFileName.set(c.fileName, c);
        });
        return matches.map((match)=>{
            if (!$f065dde0569e0444$export$a8551935c32a0765(match)) return match;
            const classification = byFileName.get(match.file.fileName);
            const normalized = classification && classification.code ? (0, $33272e5b46e0901c$export$aaca38c5bcd0c052)(classification.code) : null;
            if (!normalized) return match;
            const section = (0, $33272e5b46e0901c$export$1a3246f47ed93fe8)(normalized);
            if (!section) return match;
            const variant = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(section) === null ? undefined : classification && classification.variant || $f065dde0569e0444$var$detectVariant(match.file, section) || "";
            return {
                ...match,
                sectionCode: normalized,
                section: section,
                variant: variant,
                matchedBy: "llm",
                confidence: "medium",
                candidates: Array.from(new Set([
                    ...match.candidates,
                    normalized
                ]))
            };
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("classifyUnmatchedWithLlm failed:", e);
        return matches;
    }
}
// ---------------------------------------------------------------------------
// Completeness report
// ---------------------------------------------------------------------------
const $f065dde0569e0444$var$variantIdentity = (rootKey, name)=>`${rootKey}::${name}`;
function $f065dde0569e0444$export$c877a6c4e166c3c6(root, name) {
    return `${root.title} \u{2014} ${name || "(default)"}`;
}
/**
 * Build a memoised, bottom-up status resolver for one completeness table.
 *
 * - A section with files of its own is "present", or "not-applicable" when
 *   every file declares the section not applicable.
 * - A container without files takes its status from its in-scope children:
 *   any present child -> present; all children not-applicable -> not-applicable.
 * - Otherwise it is "not-applicable" when an ancestor declared N/A (the
 *   declaration flows down to every subsection), else "missing".
 */ function $f065dde0569e0444$var$createStatusResolver({ filesBySectionKey: filesBySectionKey, inScope: inScope }) {
    const naDeclaredKeys = new Set();
    filesBySectionKey.forEach((files, key)=>{
        if (files.length > 0 && files.every((f)=>f.declaredNotApplicable)) naDeclaredKeys.add(key);
    });
    const memo = new Map();
    const ancestorNotApplicable = (section)=>naDeclaredKeys.size > 0 && (0, $33272e5b46e0901c$export$c6fd3ab3f44300d0)(section).some((ancestor)=>naDeclaredKeys.has(ancestor.key));
    const statusOf = (section)=>{
        const cached = memo.get(section.key);
        if (cached) return cached;
        let status;
        const files = filesBySectionKey.get(section.key) || [];
        if (files.length > 0) status = files.every((f)=>f.declaredNotApplicable) ? "not-applicable" : "present";
        else {
            const childStatuses = section.childKeys.map((key)=>(0, $33272e5b46e0901c$export$60c55e1260a3eae2)(key)).filter((child)=>!!child && inScope(child)).map(statusOf);
            if (childStatuses.some((s)=>s === "present")) status = "present";
            else if (childStatuses.length > 0 && childStatuses.every((s)=>s === "not-applicable")) status = "not-applicable";
            else status = ancestorNotApplicable(section) ? "not-applicable" : "missing";
        }
        memo.set(section.key, status);
        return status;
    };
    return statusOf;
}
function $f065dde0569e0444$export$54eb77b16425a840(matches) {
    const matched = matches.filter((m)=>!!m.section);
    const unmatched = matches.filter((m)=>!m.section);
    const detectedModules = Array.from(new Set(matched.map((m)=>m.section.module))).sort();
    const variants = [];
    // --- Variant columns (per repeatable root instance)
    const variantGroups = new Map();
    matched.forEach((m)=>{
        const root = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(m.section);
        if (!root) return;
        const name = m.variant || "";
        const id = $f065dde0569e0444$var$variantIdentity(root.key, name);
        const existing = variantGroups.get(id);
        if (existing) existing.files.push(m);
        else variantGroups.set(id, {
            root: root,
            name: name,
            files: [
                m
            ]
        });
    });
    Array.from(variantGroups.values()).sort((a, b)=>a.root.key.localeCompare(b.root.key) || a.name.localeCompare(b.name)).forEach(({ root: root, name: name, files: files })=>{
        // Sections whose variant root is this root. Nested repeatable subtrees
        // (3.2.P.4.x excipients) resolve to the enclosing drug product root, so
        // they are listed here alongside the other 3.2.P.x sections.
        const rowSections = (0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>s.key !== root.key && (0, $33272e5b46e0901c$export$9f650f49adb7472c)(s, root) && (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(s)?.key === root.key);
        const filesBySectionKey = new Map();
        files.forEach((m)=>{
            const list = filesBySectionKey.get(m.section.key) || [];
            list.push(m);
            filesBySectionKey.set(m.section.key, list);
        });
        const statusOf = $f065dde0569e0444$var$createStatusResolver({
            filesBySectionKey: filesBySectionKey,
            inScope: (s)=>(0, $33272e5b46e0901c$export$221d7a240d8d8e51)(s)?.key === root.key
        });
        const rows = [];
        // Row for the root itself only when files were matched directly to it.
        const rootFiles = filesBySectionKey.get(root.key) || [];
        if (rootFiles.length > 0) rows.push({
            section: root,
            files: rootFiles,
            status: statusOf(root)
        });
        rowSections.forEach((section)=>{
            rows.push({
                section: section,
                files: filesBySectionKey.get(section.key) || [],
                status: statusOf(section)
            });
        });
        variants.push({
            variantRootKey: root.key,
            name: $f065dde0569e0444$export$c877a6c4e166c3c6(root, name),
            rows: rows
        });
    });
    // --- Shared column: sections of detected modules without a variant root,
    // plus repeatable roots that have no matched instance at all (so completely
    // absent parts like an entirely missing 3.2.P are still reported).
    if (detectedModules.length > 0) {
        const rootsWithColumns = new Set(Array.from(variantGroups.values()).map((g)=>g.root.key));
        const sharedSections = (0, $33272e5b46e0901c$export$3792a546d01e0f03).filter((s)=>{
            if (!detectedModules.includes(s.module)) return false;
            if (s.parentKey === null) return false;
            if (s.depth <= 1 && s.childKeys.length > 0) return false;
            const root = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(s);
            if (root === null) return true;
            // Orphan repeatable root without any variant column
            return root.key === s.key && !rootsWithColumns.has(s.key);
        });
        const sharedFiles = matched.filter((m)=>(0, $33272e5b46e0901c$export$221d7a240d8d8e51)(m.section) === null);
        const filesBySectionKey = new Map();
        sharedFiles.forEach((m)=>{
            const list = filesBySectionKey.get(m.section.key) || [];
            list.push(m);
            filesBySectionKey.set(m.section.key, list);
        });
        const statusOf = $f065dde0569e0444$var$createStatusResolver({
            filesBySectionKey: filesBySectionKey,
            inScope: (s)=>(0, $33272e5b46e0901c$export$221d7a240d8d8e51)(s) === null
        });
        const rows = sharedSections.map((section)=>({
                section: section,
                files: filesBySectionKey.get(section.key) || [],
                status: statusOf(section)
            }));
        if (rows.length > 0) variants.push({
            variantRootKey: null,
            name: "Common (non-repeatable sections)",
            rows: rows
        });
    }
    return {
        variants: variants,
        unmatched: unmatched,
        detectedModules: detectedModules
    };
}



/**
 * Grouped LLM compliance analysis for loose PDF sets matched to eCTD sections.
 *
 * Matched files are grouped by (variant, section group) — e.g. all 3.2.S.4.x
 * files of one drug-substance manufacturer — and each group is analysed with
 * one prompt against the module-level reference text (m3-2-s / m3-2-p / m3-2-r).
 *
 * In `attach-images` mode, scanned page JPEGs travel with the prompt. Groups
 * whose image count exceeds ATTACH_IMAGES_PER_REQUEST are split into chunks
 * so every page is sent exactly once.
 */ 




const $52dcb047bf3a2f28$var$TOTAL_INPUT_BUDGET_CHARS = 140000;
const $52dcb047bf3a2f28$var$MIN_PER_FILE_CHARS = 8000;
function $52dcb047bf3a2f28$export$afc0abb4bbfd0b32(section) {
    const root = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(section);
    const ancestors = (0, $33272e5b46e0901c$export$c6fd3ab3f44300d0)(section);
    if (root) {
        if (section.key === root.key) return section;
        const rootIndex = ancestors.findIndex((a)=>a.key === root.key);
        // First ancestor below the root, or the section itself when directly under it
        return rootIndex >= 0 && rootIndex + 1 < ancestors.length ? ancestors[rootIndex + 1] : section;
    }
    // Shared sections: group under the ancestor with depth 2 (e.g. 3.2.A),
    // or the section itself when it is that shallow already (3.2.R, 3.3).
    const shallow = ancestors.find((a)=>a.depth >= 1 && a.childKeys.length > 0);
    if (section.depth <= 2) return section;
    return shallow && shallow.depth >= 1 ? shallow : section;
}
function $52dcb047bf3a2f28$export$71e8a967771bac6e(matches) {
    const groups = new Map();
    matches.forEach((match)=>{
        if (!match.section) return;
        const groupSection = $52dcb047bf3a2f28$export$afc0abb4bbfd0b32(match.section);
        const root = (0, $33272e5b46e0901c$export$221d7a240d8d8e51)(match.section);
        const variantName = root ? match.variant || "" : null;
        const id = `${root ? root.key : "shared"}::${variantName ?? ""}::${groupSection.key}`;
        const existing = groups.get(id);
        if (existing) {
            existing.files.push(match);
            return;
        }
        const reference = groupSection.referenceKey ? (0, $81b98fb9de868a7b$export$63b727d6e7a38867).find((r)=>r.ectdKey === groupSection.referenceKey) : undefined;
        const labelPrefix = root ? `${(0, $f065dde0569e0444$export$c877a6c4e166c3c6)(root, variantName || "")} / ` : "";
        groups.set(id, {
            id: id,
            label: `${labelPrefix}${groupSection.code} ${groupSection.title}`,
            groupSection: groupSection,
            variantName: variantName,
            files: [
                match
            ],
            reference: reference
        });
    });
    return Array.from(groups.values()).sort((a, b)=>a.label.localeCompare(b.label));
}
function $52dcb047bf3a2f28$var$buildGroupIntro(group) {
    const coveredCodes = Array.from(new Set(group.files.map((f)=>f.sectionCode).filter(Boolean)));
    const groupChildren = group.groupSection.childKeys.map((key)=>(0, $33272e5b46e0901c$export$60c55e1260a3eae2)(key)).filter((s)=>!!s);
    const missingCodes = groupChildren.map((s)=>s.code).filter((code)=>!coveredCodes.includes(code));
    return [
        `eCTD section group: ${group.groupSection.code} ${group.groupSection.title}`,
        group.variantName !== null ? `Variant (manufacturer/product): ${group.variantName || "(default)"}` : null,
        `Subsections covered by the provided files: ${coveredCodes.join(", ") || "(none)"}`,
        missingCodes.length > 0 ? `Subsections NOT provided in this file set (confirm they are missing): ${missingCodes.join(", ")}` : null
    ].filter(Boolean).join("\n");
}
function $52dcb047bf3a2f28$export$4b5fb66fa42f802b(files, limit = (0, $4f64efc931dd8bad$export$af2ee85df7d23f58)) {
    const perFile = files.map((match)=>({
            match: match,
            images: [
                ...match.file.scannedPageImages || []
            ].sort((a, b)=>a.pageNumber - b.pageNumber)
        }));
    const chunks = [];
    let current = [];
    let currentCount = 0;
    const flush = ()=>{
        if (current.length > 0) {
            chunks.push(current);
            current = [];
            currentCount = 0;
        }
    };
    perFile.forEach((slice)=>{
        if (slice.images.length === 0) return;
        if (slice.images.length > limit) {
            // Full chunks of `limit`, then leave the remainder in `current` so the
            // next file can pack into the leftover capacity.
            let offset = 0;
            while(slice.images.length - offset > limit){
                flush();
                chunks.push([
                    {
                        match: slice.match,
                        images: slice.images.slice(offset, offset + limit)
                    }
                ]);
                offset += limit;
            }
            const remainder = slice.images.slice(offset);
            if (remainder.length > 0) {
                flush();
                current.push({
                    match: slice.match,
                    images: remainder
                });
                currentCount = remainder.length;
            }
            return;
        }
        if (currentCount + slice.images.length > limit) flush();
        current.push(slice);
        currentCount += slice.images.length;
    });
    flush();
    // Ensure at least one chunk exists when there are text-only files
    if (chunks.length === 0 && files.length > 0) chunks.push([]);
    return chunks;
}
function $52dcb047bf3a2f28$var$textForFileInAttachMode(match, includedImages, perFileBudget, isFirstChunk) {
    // In attach-images mode the body already has placeholders; keep text-layer
    // content and first-page transcription, drop image placeholders for pages
    // not in this chunk.
    let text = match.file.text || "";
    const allImages = match.file.scannedPageImages || [];
    if (includedImages) {
        const includedNums = new Set(includedImages.map((i)=>i.pageNumber));
        allImages.forEach((img)=>{
            const placeholder = `[Page ${img.pageNumber}: see attached image "${match.file.fileName} p.${img.pageNumber}"]`;
            if (!includedNums.has(img.pageNumber)) text = text.split(placeholder).join(`[Page ${img.pageNumber}: see part covering this page]`);
        });
    } else if (!isFirstChunk) // Text-only files only appear in the first chunk
    return {
        text: "",
        truncated: false
    };
    if (!isFirstChunk && (!includedImages || includedImages.length === 0)) return {
        text: "",
        truncated: false
    };
    if (text.length > perFileBudget) return {
        text: `${text.slice(0, perFileBudget)}\n[File truncated due to length]`,
        truncated: true
    };
    return {
        text: text,
        truncated: false
    };
}
function $52dcb047bf3a2f28$export$a725b47bc0510f19(group, options = {}) {
    const mode = options.mode || (0, $4f64efc931dd8bad$export$8b92e12bd79dd0e2);
    const perFileBudget = Math.max($52dcb047bf3a2f28$var$MIN_PER_FILE_CHARS, Math.floor($52dcb047bf3a2f28$var$TOTAL_INPUT_BUDGET_CHARS / Math.max(1, group.files.length)));
    const intro = $52dcb047bf3a2f28$var$buildGroupIntro(group);
    const chunkHeader = options.chunkTotal && options.chunkTotal > 1 ? `\nPart ${options.chunkIndex} of ${options.chunkTotal} of group ${group.groupSection.code} \u{2014} images in this part only.` : "";
    const { imageChunk: imageChunk } = options;
    const imagesByFile = new Map();
    (imageChunk || []).forEach((slice)=>{
        imagesByFile.set(slice.match.file.fileName, slice.images);
    });
    let inputTruncated = false;
    const fileBlocks = group.files.map((match)=>{
        const sectionInfo = match.section ? `${match.section.code} ${match.section.title}` : "unknown section";
        if (mode === "attach-images") {
            const included = imagesByFile.get(match.file.fileName) || null;
            const isTextOnly = !(match.file.scannedPageImages || []).length;
            if (isTextOnly && !options.includeTextOnlyFiles) return null;
            if (!isTextOnly && !included) return null;
            const { text: text, truncated: truncated } = $52dcb047bf3a2f28$var$textForFileInAttachMode(match, included, perFileBudget, !!options.includeTextOnlyFiles || (options.chunkIndex || 1) === 1);
            if (truncated) inputTruncated = true;
            if (!text && !included?.length) return null;
            return `=== File: ${match.file.fileName} (matched to ${sectionInfo}) ===\n${text}`;
        }
        let text = match.file.text || "";
        if (text.length > perFileBudget) {
            text = `${text.slice(0, perFileBudget)}\n[File truncated due to length]`;
            inputTruncated = true;
        }
        return `=== File: ${match.file.fileName} (matched to ${sectionInfo}) ===\n${text}`;
    }).filter(Boolean);
    const excerptImages = [];
    if (mode === "attach-images" && imageChunk) imageChunk.forEach((slice)=>{
        slice.images.forEach((img)=>{
            excerptImages.push({
                label: `${slice.match.file.fileName} p.${img.pageNumber}`,
                dataUrl: img.dataUrl
            });
        });
    });
    return {
        fileName: group.label,
        text: `${intro}${chunkHeader}\n\n${fileBlocks.join("\n\n")}`,
        ectdKey: group.groupSection.key,
        ectdTitle: group.groupSection.title,
        ...excerptImages.length > 0 ? {
            images: excerptImages
        } : {},
        ...inputTruncated ? {
            inputTruncated: true
        } : {}
    };
}
async function $52dcb047bf3a2f28$export$52eb55930585163b(matches, onProgress, options = {}) {
    let mode = options.scannedPageMode || (0, $4f64efc931dd8bad$export$716ace1f00a73e4)() || (0, $4f64efc931dd8bad$export$8b92e12bd79dd0e2);
    // Fall back to transcription if the analysis model cannot see images.
    if (mode === "attach-images" && !(0, $4f64efc931dd8bad$export$a2f20583c0ab6bca)(options.model)) {
        // eslint-disable-next-line no-console
        console.warn("runGroupedEctdAnalysis: selected model is not vision-capable; falling back to transcribe mode");
        mode = "transcribe";
    }
    const groups = $52dcb047bf3a2f28$export$71e8a967771bac6e(matches).filter((g)=>g.reference);
    const work = [];
    groups.forEach((group)=>{
        if (mode !== "attach-images") {
            work.push({
                group: group,
                excerpt: $52dcb047bf3a2f28$export$a725b47bc0510f19(group, {
                    mode: mode
                }),
                label: group.label
            });
            return;
        }
        const chunks = $52dcb047bf3a2f28$export$4b5fb66fa42f802b(group.files, (0, $4f64efc931dd8bad$export$af2ee85df7d23f58));
        const chunkTotal = chunks.length;
        chunks.forEach((imageChunk, idx)=>{
            const chunkIndex = idx + 1;
            const pageCount = imageChunk.reduce((n, s)=>n + s.images.length, 0);
            const pageNums = [];
            imageChunk.forEach((s)=>{
                s.images.forEach((i)=>{
                    if (pageNums.indexOf(i.pageNumber) === -1) pageNums.push(i.pageNumber);
                });
            });
            const pageHint = pageCount > 0 ? ` (p.${pageNums.slice(0, 3).join(",")}${pageCount > 3 ? "\u2026" : ""})` : "";
            work.push({
                group: group,
                excerpt: $52dcb047bf3a2f28$export$a725b47bc0510f19(group, {
                    mode: mode,
                    imageChunk: imageChunk,
                    chunkIndex: chunkIndex,
                    chunkTotal: chunkTotal,
                    includeTextOnlyFiles: chunkIndex === 1
                }),
                chunkIndex: chunkTotal > 1 ? chunkIndex : undefined,
                chunkTotal: chunkTotal > 1 ? chunkTotal : undefined,
                label: chunkTotal > 1 ? `${group.label} \u{2014} part ${chunkIndex}/${chunkTotal}${pageHint}` : group.label
            });
        });
    });
    const total = work.length;
    let completed = 0;
    if (typeof onProgress === "function") onProgress(0, total);
    const tasks = work.map(async (item)=>{
        const result = await (0, $49cd54c429e356d8$export$2e2bcd8739ae039)(item.excerpt, item.group.reference, {
            provider: "openrouter",
            authToken: options.authToken,
            basePrompt: (0, $4f64efc931dd8bad$export$6b93ff19e2337f2e),
            scannedPageMode: mode,
            model: options.model
        });
        completed += 1;
        if (typeof onProgress === "function") onProgress(completed, total, item.label);
        return {
            group: item.group,
            result: result,
            chunkIndex: item.chunkIndex,
            chunkTotal: item.chunkTotal
        };
    });
    return Promise.all(tasks);
}




const $c16b1f2a46d9a82f$var$STATUS_LABEL = {
    present: "Present",
    missing: "Missing",
    "not-applicable": "N/A declared"
};
const $c16b1f2a46d9a82f$var$STATUS_COLOR = {
    present: "#1e7d32",
    missing: "#c62828",
    "not-applicable": "#757575"
};
const $c16b1f2a46d9a82f$var$CONFIDENCE_COLOR = {
    high: "#1e7d32",
    medium: "#e09b00",
    low: "#c62828"
};
const $c16b1f2a46d9a82f$var$baseName = (path)=>path.replace(/\\/g, "/").split("/").pop() || path;
const $c16b1f2a46d9a82f$export$a3b86265d6aa7c2e = ()=>{
    const { authResult: authResult } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const authToken = authResult?.accessToken;
    const [parsing, setParsing] = (0, $acw62.useState)(false);
    const [ocrProgress, setOcrProgress] = (0, $acw62.useState)(null);
    const [llmClassifying, setLlmClassifying] = (0, $acw62.useState)(false);
    const [uploadedName, setUploadedName] = (0, $acw62.useState)("");
    const [matches, setMatches] = (0, $acw62.useState)(null);
    const [showAllModules, setShowAllModules] = (0, $acw62.useState)(false);
    const [expandedCells, setExpandedCells] = (0, $acw62.useState)(new Set());
    const [scannedPageMode, setScannedPageMode] = (0, $acw62.useState)(()=>(0, $4f64efc931dd8bad$export$716ace1f00a73e4)());
    const [analysisRunning, setAnalysisRunning] = (0, $acw62.useState)(false);
    const [progressTotal, setProgressTotal] = (0, $acw62.useState)(0);
    const [progressCompleted, setProgressCompleted] = (0, $acw62.useState)(0);
    const [progressLastGroup, setProgressLastGroup] = (0, $acw62.useState)("");
    const [groupResults, setGroupResults] = (0, $acw62.useState)([]);
    const [isClearModalOpen, setIsClearModalOpen] = (0, $acw62.useState)(false);
    const [transcriptionMatch, setTranscriptionMatch] = (0, $acw62.useState)(null);
    const printRef = (0, $acw62.useRef)(null);
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    const report = (0, $acw62.useMemo)(()=>matches ? (0, $f065dde0569e0444$export$54eb77b16425a840)(matches) : null, [
        matches
    ]);
    const summary = (0, $acw62.useMemo)(()=>{
        if (!matches) return null;
        const by = (matchedBy)=>matches.filter((m)=>m.sectionCode && m.matchedBy === matchedBy).length;
        const pageTotals = matches.reduce((acc, m)=>{
            const stats = m.file.pageStats;
            if (!stats) return acc;
            return {
                totalPages: acc.totalPages + stats.totalPages,
                textPages: acc.textPages + stats.textPages,
                scannedPages: acc.scannedPages + stats.scannedPages
            };
        }, {
            totalPages: 0,
            textPages: 0,
            scannedPages: 0
        });
        return {
            total: matches.length,
            matched: matches.filter((m)=>m.sectionCode).length,
            unmatched: matches.filter((m)=>!m.sectionCode).length,
            header: by("header"),
            hints: by("folder") + by("filename"),
            llm: by("llm"),
            manual: by("manual"),
            ...pageTotals
        };
    }, [
        matches
    ]);
    const overrideOptions = (0, $acw62.useMemo)(()=>{
        const module3 = (0, $33272e5b46e0901c$export$dce4845f2c63f6fe)(3).filter((s)=>s.parentKey !== null).sort((a, b)=>a.code.localeCompare(b.code, undefined, {
                numeric: true
            }));
        return module3.map((s)=>({
                value: s.key,
                label: `${s.code} \u{2014} ${s.title}`
            }));
    }, []);
    const handleScannedPageModeChange = (0, $acw62.useCallback)((mode)=>{
        setScannedPageMode(mode);
        (0, $4f64efc931dd8bad$export$661ad4e3c111b5db)(mode);
    }, []);
    const processZip = (0, $acw62.useCallback)(async (file)=>{
        setParsing(true);
        setOcrProgress(null);
        try {
            // Read the ZIP directly as an ArrayBuffer. The previous data-URL +
            // JSON.stringify round-trip overflowed the browser string limit
            // ("allocation size overflow") on large archives.
            const parsed = await (0, $49233b2a320a7c4e$export$2ba0580d2c66d148)(file, {
                authToken: authToken,
                scannedPageMode: scannedPageMode,
                onOcrProgress: (event)=>{
                    setOcrProgress(event);
                }
            });
            if (parsed.length === 0) {
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error("No PDF files found in the ZIP archive.");
                return;
            }
            setUploadedName(file.name);
            const deterministic = (0, $f065dde0569e0444$export$4da2de81425059af)(parsed);
            setMatches(deterministic);
            const unresolved = deterministic.filter((0, $f065dde0569e0444$export$a8551935c32a0765));
            if (unresolved.length > 0) {
                setLlmClassifying(true);
                try {
                    const refined = await (0, $f065dde0569e0444$export$e0732da4e7215f3f)(deterministic, {
                        authToken: authToken
                    });
                    setMatches(refined);
                } finally{
                    setLlmClassifying(false);
                }
            }
        } catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(`ZIP processing failed: ${message}`);
        } finally{
            setParsing(false);
            setOcrProgress(null);
        }
    }, [
        authToken,
        scannedPageMode
    ]);
    const uploadDisabled = parsing || analysisRunning || !!matches;
    const handleDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        const file = acceptedFiles[0];
        if (!file || uploadDisabled) return;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        processZip(file);
    }, [
        processZip,
        uploadDisabled
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept, open: open } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        accept: "application/zip,.zip,application/x-zip-compressed",
        maxFiles: 1,
        onDrop: handleDrop,
        onDropRejected: (rejected)=>{
            if (rejected.length > 0) (0, $60f27fc97e29822a$export$b410431fab84fa58).error("Please upload a ZIP file only.");
        }
    });
    const handleOverride = (0, $acw62.useCallback)((fileName, sectionKey)=>{
        setMatches((prev)=>prev ? (0, $f065dde0569e0444$export$1e433dec5cf29e4c)(prev, fileName, sectionKey) : prev);
    }, []);
    const handleRunAnalysis = (0, $acw62.useCallback)(async ()=>{
        if (!matches) return;
        setAnalysisRunning(true);
        setProgressTotal(0);
        setProgressCompleted(0);
        setProgressLastGroup("");
        try {
            const results = await (0, $52dcb047bf3a2f28$export$52eb55930585163b)(matches, (completed, total, label)=>{
                setProgressTotal(total);
                setProgressCompleted(completed);
                if (label) setProgressLastGroup(label);
            }, {
                authToken: authToken,
                scannedPageMode: scannedPageMode
            });
            setGroupResults(results);
        } catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(`Grouped analysis failed: ${message}`);
        } finally{
            setAnalysisRunning(false);
        }
    }, [
        matches,
        authToken,
        scannedPageMode
    ]);
    const handleClear = (0, $acw62.useCallback)(()=>{
        setMatches(null);
        setGroupResults([]);
        setUploadedName("");
        setExpandedCells(new Set());
        setProgressTotal(0);
        setProgressCompleted(0);
        setProgressLastGroup("");
        setTranscriptionMatch(null);
    }, []);
    const toggleCell = (0, $acw62.useCallback)((cellKey)=>{
        setExpandedCells((prev)=>{
            const next = new Set(prev);
            if (next.has(cellKey)) next.delete(cellKey);
            else next.add(cellKey);
            return next;
        });
    }, []);
    const allModuleSections = (0, $acw62.useMemo)(()=>{
        if (!showAllModules || !matches) return [];
        const filesBySectionKey = new Map();
        matches.forEach((m)=>{
            if (!m.section) return;
            const list = filesBySectionKey.get(m.section.key) || [];
            list.push(m);
            filesBySectionKey.set(m.section.key, list);
        });
        const coveredCache = new Map();
        const isCovered = (section)=>{
            const cached = coveredCache.get(section.key);
            if (cached !== undefined) return cached;
            const hasFiles = (filesBySectionKey.get(section.key) || []).length > 0;
            let covered = hasFiles;
            if (!covered && section.childKeys.length > 0) covered = section.childKeys.every((key)=>{
                const child = (0, $33272e5b46e0901c$export$60c55e1260a3eae2)(key);
                return child ? isCovered(child) : false;
            });
            coveredCache.set(section.key, covered);
            return covered;
        };
        return (0, $33272e5b46e0901c$export$3792a546d01e0f03).map((s, index)=>({
                s: s,
                index: index
            })).filter(({ s: s })=>s.parentKey !== null).sort((a, b)=>a.s.module - b.s.module || a.index - b.index).map(({ s: s })=>({
                section: s,
                files: filesBySectionKey.get(s.key) || [],
                covered: isCovered(s)
            }));
    }, [
        showAllModules,
        matches
    ]);
    const transcriptionCloseButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Close",
        type: (0, $26e621062d296af4$export$d3d950cd69e1ac66).Secondary,
        onClick: ()=>setTranscriptionMatch(null)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a13939e608956ea$export$c14a569fae7175e4), {
        pageTitle: "eCTD mapping"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6703e6014d8edb3$export$51e90905745eccda), {
        title: "eCTD mapping \u2014 loose PDF set",
        stepNumber: 1,
        wrapCardsCallback: ()=>{},
        buttons: [],
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Upload a ZIP with loose Module 3 PDF files (no index.xml required)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: "0 0 12px",
            color: "#555",
            fontSize: 14
        }
    }, "Each PDF is matched to a canonical eCTD section key using the section codes found on its first page, plus folder and filename hints. Unresolved files are classified with an LLM. Scanned pages are detected automatically and either transcribed or attached as images for analysis."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ModeRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: "#333"
        }
    }, "Scanned pages:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ModeToggle, {
        type: "button",
        $active: scannedPageMode === "transcribe",
        disabled: uploadDisabled,
        onClick: ()=>handleScannedPageModeChange("transcribe")
    }, "Transcribe to text"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ModeToggle, {
        type: "button",
        $active: scannedPageMode === "attach-images",
        disabled: uploadDisabled,
        onClick: ()=>handleScannedPageModeChange("attach-images")
    }, "Attach page images")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e464d85de0bbd46d$export$6c8108ad15125580), {
        rootProps: getRootProps({
            isDragAccept: isDragAccept
        }),
        inputProps: getInputProps(),
        open: open,
        disabled: uploadDisabled
    }), uploadedName && !parsing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: 13,
            color: "#333"
        }
    }, "Processed file: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, uploadedName)), parsing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            padding: 12
        }
    }, !ocrProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Reading ZIP\u2026"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, "0%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "ZIP read progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: "0%",
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic
        }
    }))), ocrProgress && ocrProgress.phase === "classify" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Classifying PDF files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.fileCount > 0 ? `${Math.floor(ocrProgress.filesCompleted / ocrProgress.fileCount * 100)}%` : "0%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "PDF classification progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.fileCount > 0 ? ocrProgress.filesCompleted / ocrProgress.fileCount * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, `${ocrProgress.filesCompleted} of ${ocrProgress.fileCount} files classified`, ocrProgress.label ? ` \xb7 ${ocrProgress.label}` : "")), ocrProgress && ocrProgress.phase === "extract" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 16
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.overallTotal > 0 ? `${Math.floor(ocrProgress.overallCompleted / ocrProgress.overallTotal * 100)}%` : "Counting pages\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "OCR pages progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.overallTotal > 0 ? ocrProgress.overallCompleted / ocrProgress.overallTotal * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, ocrProgress.overallTotal > 0 ? `${ocrProgress.overallCompleted} of ${ocrProgress.overallTotal} pages processed` : "Counting pages\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, ocrProgress.fileCount > 0 ? `${Math.floor(ocrProgress.filesCompleted / ocrProgress.fileCount * 100)}%` : "0%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "OCR files progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${ocrProgress.fileCount > 0 ? ocrProgress.filesCompleted / ocrProgress.fileCount * 100 : 0}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, `${ocrProgress.filesCompleted} of ${ocrProgress.fileCount} files processed`, ocrProgress.label ? ` \xb7 ${ocrProgress.label}` : "")))), llmClassifying && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            color: "#555"
        }
    }, "Classifying unresolved files with LLM\u2026")), summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Matching summary", uploadedName ? ` \u{2014} ${uploadedName}` : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Clear and upload another set",
        onClick: ()=>setIsClearModalOpen(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ChipRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.total), "\xa0PDF files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, {
        style: {
            background: "#e8f5e9"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.matched), "\xa0matched"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, {
        style: {
            background: summary.unmatched ? "#ffebee" : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.unmatched), "\xa0unmatched"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.header), "\xa0by header"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.hints), "\xa0by folder/filename"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.llm), "\xa0by LLM"), summary.manual > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.manual), "\xa0manual")), summary.totalPages > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ChipRow, {
        style: {
            marginTop: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.totalPages), "\xa0pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.textPages), "\xa0text pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, {
        style: {
            background: summary.scannedPages > 0 ? "#fff8e1" : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, summary.scannedPages), "\xa0scanned pages")), report && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$ChipRow, {
        style: {
            marginTop: 8
        }
    }, report.variants.filter((v)=>v.variantRootKey !== null).map((v)=>{
        const relevant = v.rows.filter((r)=>r.status !== "not-applicable");
        const present = relevant.filter((r)=>r.status === "present").length;
        const pct = relevant.length ? Math.round(present / relevant.length * 100) : 100;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Chip, {
            key: v.name
        }, v.name, ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, pct, "%"), "\xa0coverage");
    }))), report && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "eCTD completeness", report.detectedModules.length > 0 ? ` \u{2014} Module ${report.detectedModules.join(", ")} detected` : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: showAllModules ? "Show detected modules only" : "Show all modules (M1\u2013M5)",
        onClick: ()=>setShowAllModules((v)=>!v)
    })), report.variants.map((variant)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: variant.name,
            style: {
                marginBottom: 16
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$VariantHeader, null, variant.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$MatrixTable, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            style: {
                width: 110
            }
        }, "Section"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", null, "Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            style: {
                width: 120
            }
        }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", null, "Files"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, variant.rows.map((row)=>{
            const cellKey = `${variant.name}::${row.section.key}`;
            const expanded = expandedCells.has(cellKey);
            const visibleFiles = expanded ? row.files : row.files.slice(0, 1);
            const isGroupHeader = row.section.childKeys.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
                key: row.section.key,
                className: isGroupHeader ? "section-header" : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, row.section.code, row.section.optional && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$OptionalMark, {
                title: "Optional in the DTD"
            }, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, row.section.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$StatusBadge, {
                style: {
                    background: $c16b1f2a46d9a82f$var$STATUS_COLOR[row.status]
                }
            }, row.status === "present" && row.files.length === 0 ? "Covered" : $c16b1f2a46d9a82f$var$STATUS_LABEL[row.status])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, visibleFiles.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: m.file.fileName,
                    title: m.file.fileName
                }, $c16b1f2a46d9a82f$var$baseName(m.file.fileName))), row.files.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$LinkButton, {
                type: "button",
                onClick: ()=>toggleCell(cellKey)
            }, expanded ? "Show less" : `Show all ${row.files.length} files`)));
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: "#777"
        }
    }, '* \u2014 section is optional in the eCTD DTD. "Covered" \u2014 no file matched directly, but all content is provided in subsections.'), showAllModules && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$VariantHeader, null, "Full eCTD backbone (M1\u2013M5)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$MatrixTable, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 110
        }
    }, "Section"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", null, "Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 120
        }
    }, "Matched files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 90
        }
    }, "Covered"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, allModuleSections.map(({ section: section, files: files, covered: covered })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: section.key,
            className: section.childKeys.length > 0 ? "section-header" : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                paddingLeft: 8 + section.depth * 12
            }
        }, section.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, section.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                color: files.length ? "#1e7d32" : "#999"
            }
        }, files.length || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                textAlign: "center"
            }
        }, covered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$CoveredTick, {
            title: files.length > 0 ? "Files present" : "All child sections present",
            "aria-label": "Covered"
        }, "\u2713") : ""))))))), matches && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "File-to-key mapping (", matches.length, " files)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$MatrixTable, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", null, "File"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 280
        }
    }, "eCTD section"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 140
        }
    }, "Variant"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 60
        }
    }, "Pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 50
        }
    }, "Text"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 70
        }
    }, "Scanned"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 80
        }
    }, "Matched by"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 80
        }
    }, "Confidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            width: 90
        }
    }, "Extracted"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, matches.map((match)=>{
        const selected = match.section ? {
            value: match.section.key,
            label: `${match.section.code} \u{2014} ${match.section.title}`
        } : null;
        const stats = match.file.pageStats;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: match.file.fileName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            title: match.file.fileName
        }, $c16b1f2a46d9a82f$var$baseName(match.file.fileName), match.declaredNotApplicable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: "#757575"
            }
        }, " ", "(declares N/A)")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce830298ea9125dd$export$931cbfb6bfb85fc), {
            options: overrideOptions,
            value: selected,
            onChange: (option)=>{
                handleOverride(match.file.fileName, option && typeof option.value === "string" ? option.value : null);
            },
            placeholder: "Unmatched \u2014 select section",
            isClearable: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, match.variant === undefined ? "\u2014" : match.variant || "(default)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, stats ? stats.totalPages : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, stats ? stats.textPages : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                color: stats && stats.scannedPages > 0 ? "#e09b00" : undefined,
                fontWeight: stats && stats.scannedPages > 0 ? 600 : undefined
            }
        }, stats ? stats.scannedPages : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, match.matchedBy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                color: $c16b1f2a46d9a82f$var$CONFIDENCE_COLOR[match.confidence] || "#333",
                fontWeight: 600
            }
        }, match.confidence), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$LinkButton, {
            type: "button",
            onClick: ()=>setTranscriptionMatch(match)
        }, "View text")));
    })))), matches && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$PrintCard, {
        ref: printRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            marginTop: 0,
            marginBottom: 8
        }
    }, "Grouped compliance analysis"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$NoPrint, {
        style: {
            display: "flex",
            gap: 8,
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: analysisRunning ? "Running\u2026 PLEASE WAIT" : "Run grouped analysis",
        onClick: handleRunAnalysis,
        disabled: analysisRunning || parsing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Prepare printout",
        onClick: handlePrint,
        disabled: !groupResults.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d16295188a465402$export$353f5b6fc5456de1), {
        label: "Clear results",
        onClick: ()=>setGroupResults([]),
        disabled: !groupResults.length || analysisRunning
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: "0 0 12px",
            color: "#555",
            fontSize: 14
        }
    }, "Matched files are grouped per section group and manufacturer/product variant (e.g. all 3.2.S.4.x files of one manufacturer) and each group is checked against the matching reference document in one prompt.", scannedPageMode === "attach-images" ? " Scanned pages are attached as images." : " Scanned pages were transcribed to text during upload."), analysisRunning && progressTotal > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600
        }
    }, "Running grouped analysis"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#333"
        }
    }, Math.floor(progressCompleted / progressTotal * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 10,
            background: "#eee",
            borderRadius: 6,
            overflow: "hidden"
        },
        "aria-label": "Analysis progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: "100%",
            width: `${progressCompleted / progressTotal * 100}%`,
            background: (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic,
            transition: "width 300ms ease"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6,
            fontSize: 12,
            color: "#555"
        }
    }, progressCompleted, " of ", progressTotal, " prompts processed", progressLastGroup ? ` \u{2022} Last: ${progressLastGroup}` : "")), groupResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, groupResults.map(({ group: group, result: result, chunkIndex: chunkIndex, chunkTotal: chunkTotal })=>{
        const safeHtml = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(result.text || "", {
            USE_PROFILES: {
                html: true
            }
        });
        const resultKey = chunkIndex && chunkTotal ? `${group.id}::part-${chunkIndex}` : group.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: resultKey,
            style: {
                marginBottom: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, "Group: ", group.label, chunkIndex && chunkTotal ? ` \u{2014} Part ${chunkIndex}/${chunkTotal}` : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginBottom: 4
            }
        }, "Files in this group:", " ", group.files.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                key: m.file.fileName
            }, i > 0 ? ", " : "", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                title: m.file.fileName
            }, $c16b1f2a46d9a82f$var$baseName(m.file.fileName))))), group.reference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Compared to the following reference:", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            href: group.reference.sourceUrl,
            target: "_blank",
            rel: "noopener noreferrer"
        }, group.reference.sourceName)), result.inputTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: "#fff8e1",
                border: "1px solid #ffe082",
                borderRadius: 6,
                padding: "8px 12px",
                margin: "8px 0",
                color: "#7a5c00",
                fontSize: 14
            }
        }, "The prompt was shortened because it was too long, so this result may not cover the full document."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: safeHtml
            }
        }));
    })) : !analysisRunning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666"
        }
    }, 'No analysis results yet. Click "Run grouped analysis" to start.')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4016d912c7091cca$export$1f33f980da756c46), {
        isOpen: isClearModalOpen,
        title: "Clear results?",
        message: "This will clear the mapping and all analysis results, and re-enable file uploads. Do you want to continue?",
        closeModal: ()=>setIsClearModalOpen(false),
        acceptModal: ()=>{
            handleClear();
            setIsClearModalOpen(false);
        },
        yesButtonText: "Clear"
    }), transcriptionMatch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$TranscriptionModal, {
        footerContent: transcriptionCloseButton,
        id: "TranscriptionPreviewModal",
        title: $c16b1f2a46d9a82f$var$baseName(transcriptionMatch.file.fileName),
        onClose: ()=>setTranscriptionMatch(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$TranscriptionBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: "#555",
            marginBottom: 8
        },
        title: transcriptionMatch.file.fileName
    }, transcriptionMatch.file.fileName), transcriptionMatch.file.pageStats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: "#555",
            marginBottom: 8
        }
    }, transcriptionMatch.file.pageStats.totalPages, " pages \xb7", " ", transcriptionMatch.file.pageStats.textPages, " text \xb7", " ", transcriptionMatch.file.pageStats.scannedPages, " scanned"), (transcriptionMatch.file.text || "").includes("see attached image") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: "#e09b00",
            marginBottom: 8
        }
    }, "Some pages were attached as images (not transcribed to text)."), transcriptionMatch.file.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c16b1f2a46d9a82f$var$TranscriptionPre, null, transcriptionMatch.file.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: "#666"
        }
    }, "No extracted text."))))));
};
var $c16b1f2a46d9a82f$export$2e2bcd8739ae039 = $c16b1f2a46d9a82f$export$a3b86265d6aa7c2e;
const $c16b1f2a46d9a82f$var$Container = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
const $c16b1f2a46d9a82f$var$Card = (0, $lmFrL.default).div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 24px;
  padding: 16px;
  background: #fafafa;
`;
const $c16b1f2a46d9a82f$var$ChipRow = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const $c16b1f2a46d9a82f$var$Chip = (0, $lmFrL.default).div`
  display: inline-flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  background: #fff;
  padding: 4px 12px;
  font-size: 13px;
`;
const $c16b1f2a46d9a82f$var$ModeRow = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;
const $c16b1f2a46d9a82f$var$ModeToggle = (0, $lmFrL.default).button`
  border: 1px solid
    ${(p)=>p.$active ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic : "#ccc"};
  background: ${(p)=>p.$active ? (0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic : "#fff"};
  color: ${(p)=>p.$active ? "#fff" : "#333"};
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
const $c16b1f2a46d9a82f$var$VariantHeader = (0, $lmFrL.default).h4`
  margin: 12px 0 0;
  padding: 8px 10px;
  background: #e0e0e0;
  border: 1px solid #e0e0e0;
  border-bottom: none;
  font-size: 14px;
  font-weight: 600;
`;
const $c16b1f2a46d9a82f$var$MatrixTable = (0, $lmFrL.default).table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: #fff;

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 6px 8px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #e8e8e8;
  }

  tr.section-header td {
    background: #f0f0f0;
    font-weight: 600;
  }
`;
const $c16b1f2a46d9a82f$var$StatusBadge = (0, $lmFrL.default).span`
  display: inline-block;
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
`;
const $c16b1f2a46d9a82f$var$CoveredTick = (0, $lmFrL.default).span`
  color: #1e7d32;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
`;
const $c16b1f2a46d9a82f$var$OptionalMark = (0, $lmFrL.default).span`
  color: #999;
  margin-left: 2px;
`;
const $c16b1f2a46d9a82f$var$LinkButton = (0, $lmFrL.default).button`
  background: none;
  border: none;
  color: ${()=>(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  text-decoration: underline;
`;
const $c16b1f2a46d9a82f$var$NoPrint = (0, $lmFrL.default).div`
  @media print {
    display: none;
  }
`;
const $c16b1f2a46d9a82f$var$PrintCard = (0, $lmFrL.default)($c16b1f2a46d9a82f$var$Card)`
  @media print {
    display: block;

    @page {
      margin: 1cm;
    }
  }
`;
const $c16b1f2a46d9a82f$var$TranscriptionModal = (0, $lmFrL.default)((0, $3139a814db547547$export$2b77a92f1a5ad772))`
  & > .modal-dialog {
    width: min(900px, 92vw);
  }

  & > .modal-dialog > .modal-content-footer > .modal-content-wrapper {
    padding: 1rem 1.5rem;
    max-height: 80vh;
  }

  &
    > .modal-dialog
    > .modal-content-footer
    > .modal-content-wrapper
    > .modal-content {
    min-width: 0;
    width: 100%;
    padding: 0;
  }
`;
const $c16b1f2a46d9a82f$var$TranscriptionBody = (0, $lmFrL.default).div`
  width: 100%;
`;
const $c16b1f2a46d9a82f$var$TranscriptionPre = (0, $lmFrL.default).pre`
  margin: 0;
  padding: 12px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  max-height: 70vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
`;


const $f48b0cbf012ebb22$export$37d3279522fbf5e2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66249767282b1118$export$55185c17a0fcbe46), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f96e1a178b2fcf1d$export$23191e4434a9e834), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).WELCOME,
        default: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $633b54f18e47cb87$export$7b09e4e56e72adf7), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2064c4fcddce0c2$export$1938c2a558dbd08), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_LIST_OF_RESULTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad026400ddaec87e$export$8fdcabde73f49165), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_RESULT
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b259a7a43a8a0e37$export$123d2caab55bdec5), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).LIST_OF_SAMPLES
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16007f7ec99c5da6$export$2e2bcd8739ae039), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).AUTH0_CALLBACK
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96fcde7450cfd307$export$21a94553ffa41578), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).LOGIN
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c84af5eefc2b2e4$export$26e5d19dbab98e56), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).AFTER_LOGIN
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $958581b144b6f867$export$ac07ca9bf4c6512c), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).WHAT_IS_LP
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff811c5df4acb19e$export$cc4d8724d022ebe5), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).INTRODUCTION
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $41f1419b296329a4$export$ca6fbb51b35e375c), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).GRID_OF_PROJECTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86c61f6c97c0a9f7$export$99bffacbdbcb5195), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).LIST_OF_PROJECTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fdecb748df15842d$export$882f8cd6537a0f14), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_TIMELINE_WILDCARD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2286f61233a3c57$export$fe82a520fc33e5f4), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).DASHBOARD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8374305fee1a9a36$export$974318e8ccdf0391), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).TASKS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e8c9061cb8c578d7$export$a95ea6b55a8407e0), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).TASKS_TABLE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66249767282b1118$export$2d8d895a0a0f636e), {
        noThrow: true,
        path: (0, $de08facaa603a546$export$cd891b82501bb412).SAMPLE,
        from: (0, $de08facaa603a546$export$cd891b82501bb412).SAMPLE,
        to: (0, $de08facaa603a546$export$cd891b82501bb412).SAMPLE_CONFIGURATOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $53645720d811f12d$export$4c9873d4255a2b02),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).PROJECT_CONFIGURATOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $85f61ab778fb9bcf$export$23ac95e499a8bbe),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).SAMPLE_CONFIGURATOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35b3f2cd735e2b62$export$2e2bcd8739ae039), {
        path: (0, $de08facaa603a546$export$cd891b82501bb412).HEALTHCHECK
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $da725c5c72257b1b$export$883262dc952d8f59),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).REPORTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $6b451827d670740b$export$8f769340aed2ad81),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).REPORT
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $64a8c7fab4187453$export$2e52b39ca0c7f0bb),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_TEAMS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $beeee90727a86437$export$eaacc8c92c2783a7),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_TEAM
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $a378f934e49c61cf$export$8be927c321cf81c8),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).USER_TASKS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $9cb4ff7362db7acf$export$d35e4a97650ed24e),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).GROUP_TASKS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $75bea24b7ba94747$export$7b8ace970730ea90),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_GROUPS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $19391a46fe0246aa$export$c3db4313253f3d7e),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_GROUP_MEMBERS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $e6556986845d7d1c$export$3caac47e16448199),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).MANAGE_USERS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $2e711560b32d2ad8$export$97ff6b38098aefc3),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d57ed483ff218c08$export$f01b3d7c7bbe3997), {
        route: (0, $c16b1f2a46d9a82f$export$a3b86265d6aa7c2e),
        path: (0, $de08facaa603a546$export$cd891b82501bb412).REGULATORY_ECTD_MAPPING
    }));
};






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");


const $fb97e187478333b4$export$52499e2c5ea4b095 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fb97e187478333b4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fb97e187478333b4$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fb97e187478333b4$var$LogoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a8ee0766077991c$export$8eea0721e4ba542), {
        height: "100%",
        width: "100%"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fb97e187478333b4$var$Main, null, children));
};
const $fb97e187478333b4$var$Container = (0, $lmFrL.default).div`
  width: 600px;
  background-color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.white};
  border: 1px solid ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  box-shadow: 0px 1px 0px ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.bordersOutside};
  border-radius: 8px;
  box-sizing: border-box;
`;
const $fb97e187478333b4$var$Header = (0, $lmFrL.default).header`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 96px;
  background: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.grayscale.primaryGray};
  border-radius: 8px 8px 0px 0px;
`;
const $fb97e187478333b4$var$LogoContainer = (0, $lmFrL.default).div`
  width: 164px;
  height: 32px;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;
const $fb97e187478333b4$var$Main = (0, $lmFrL.default).main`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 24px;
  font-size: 18px;
`;


const $fe6f1277295096ea$export$4eb66b48b0b0cc25 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fe6f1277295096ea$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fb97e187478333b4$export$52499e2c5ea4b095), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "You have not been assigned to an organization. Contact us at email", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fe6f1277295096ea$var$MailContainer, {
        "aria-hidden": true,
        onClick: ()=>{
            window.location.href = "mailto:info@leadernaplatform.com";
        }
    }, "info@leadernaplatform.com"), " ", "for assignment to an organization")));
const $fe6f1277295096ea$var$Container = (0, $lmFrL.default).div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $fe6f1277295096ea$var$MailContainer = (0, $lmFrL.default).span`
  color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.basic};
  text-decoration: none;
  cursor: pointer;
  transition: 200ms;

  &:hover {
    color: ${(0, $a9484fd40cfd560e$export$2fd68ac541630219).newColors.primary.hover};
    transition: 200ms;
    text-decoration: underline;
  }
`;


const $1b5686a5c10e33eb$export$c72ad249ce9e89b2 = ()=>{
    const { isAuthenticated: isAuthenticated, login: login, authResult: authResult, user: user } = (0, $cecde547f6c9ac49$export$1d39dc5b47e56ff0)();
    const runLoginAfter3s = ()=>{
        setTimeout(login, 3000);
    };
    const SimpleToastContainer = ()=>/*#__PURE__*/ $acw62.createElement((0, $60f27fc97e29822a$export$f2815235e76a62b9), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            newestOnTop: false,
            closeOnClick: true,
            rtl: false,
            pauseOnFocusLoss: false,
            draggable: false,
            pauseOnHover: false
        });
    const weAreOnTheAuth0Callback = window && window.location && (window.location.pathname === (0, $de08facaa603a546$export$cd891b82501bb412).AUTH0_CALLBACK || window.location.pathname === (0, $de08facaa603a546$export$cd891b82501bb412).HEALTHCHECK);
    if (isAuthenticated() || weAreOnTheAuth0Callback) {
        if (weAreOnTheAuth0Callback) return /*#__PURE__*/ $acw62.createElement((0, $dd3747b11ee1d6d4$export$c16b04c8a9956446), {
            client: (0, $edf0c7cc3f8c5588$export$1e6cfeaf8b88bd01)("")
        }, /*#__PURE__*/ $acw62.createElement((0, $lmFrL.ThemeProvider), {
            theme: (0, $a9484fd40cfd560e$export$2fd68ac541630219)
        }, /*#__PURE__*/ $acw62.createElement((0, $43f95f7f55a6f076$export$925437b8addebb63), null, /*#__PURE__*/ $acw62.createElement((0, $752f8ea6cb0f30bd$export$3a193063917ea516), null, /*#__PURE__*/ $acw62.createElement((0, $524aa20843ad8739$export$ede2be63923d531e), null, /*#__PURE__*/ $acw62.createElement(SimpleToastContainer, null), /*#__PURE__*/ $acw62.createElement((0, $f48b0cbf012ebb22$export$37d3279522fbf5e2), null))))));
        if (!authResult) return /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null);
        const organization = user["https://leaderneplatform.com/organization"];
        if (!organization) return /*#__PURE__*/ $acw62.createElement((0, $fe6f1277295096ea$export$4eb66b48b0b0cc25), null);
        return /*#__PURE__*/ $acw62.createElement((0, $dd3747b11ee1d6d4$export$c16b04c8a9956446), {
            client: (0, $edf0c7cc3f8c5588$export$1e6cfeaf8b88bd01)(authResult.accessToken)
        }, /*#__PURE__*/ $acw62.createElement((0, $lmFrL.ThemeProvider), {
            theme: (0, $a9484fd40cfd560e$export$2fd68ac541630219)
        }, /*#__PURE__*/ $acw62.createElement((0, $43f95f7f55a6f076$export$925437b8addebb63), null, /*#__PURE__*/ $acw62.createElement((0, $752f8ea6cb0f30bd$export$3a193063917ea516), null, /*#__PURE__*/ $acw62.createElement((0, $524aa20843ad8739$export$ede2be63923d531e), null, /*#__PURE__*/ $acw62.createElement(SimpleToastContainer, null), /*#__PURE__*/ $acw62.createElement((0, $f48b0cbf012ebb22$export$37d3279522fbf5e2), null))))));
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($1b5686a5c10e33eb$var$RedirectingMessage, null, "You are not logged in, redirecting to the login page...", runLoginAfter3s()), /*#__PURE__*/ $acw62.createElement((0, $a6474a3dbf48270d$export$7f7cbe89f1eacd2), null));
};
const $1b5686a5c10e33eb$var$RedirectingMessage = (0, $lmFrL.default).div`
  margin: 20px;
`;


const $1b39a2e2f0819fb1$var$MainApp = ()=>{
    const originalPath = window.location.pathname;
    if (originalPath !== "/auth0_callback") try {
        localStorage.setItem("gQ4QutxXcziDP3e2", originalPath);
    } catch (err) {
    // do nothing
    }
    return /*#__PURE__*/ $acw62.createElement((0, $cecde547f6c9ac49$export$87091915187a1a85), {
        navigate: (0, $f125bbca2c654db8$export$ff7962acd6052c28),
        auth0_domain: (0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_DOMAIN,
        auth0_client_id: (0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_CLIENT_ID,
        auth0_audience_domain: (0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_DOMAIN,
        auth0_params: {
            domain: (0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_DOMAIN,
            clientID: (0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_CLIENT_ID,
            redirectUri: `${window.location.origin}/auth0_callback`,
            audience: `https://${(0, $9d936a2aecb96285$export$2e2bcd8739ae039).AUTH0_DOMAIN}/api/v2/`,
            responseType: "token id_token",
            scope: "openid profile email"
        },
        customPropertyNamespace: ""
    }, /*#__PURE__*/ $acw62.createElement((0, $1b5686a5c10e33eb$export$c72ad249ce9e89b2), null));
};
var $1b39a2e2f0819fb1$export$2e2bcd8739ae039 = $1b39a2e2f0819fb1$var$MainApp;


(0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ $acw62.createElement($acw62.StrictMode, null, /*#__PURE__*/ $acw62.createElement((0, $1b39a2e2f0819fb1$export$2e2bcd8739ae039), null)), document.getElementById("root"));


//# sourceMappingURL=web.89dd85f2.js.map
